
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0320"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0320"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1YuiL", function(module, exports) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $1702e6525cc4e415$var$global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if (typeof __g == 'number') __g = $1702e6525cc4e415$var$global; // eslint-disable-line no-undef

});

parcelRegister("lRu3m", function(module, exports) {
var $fea5dc28d73fc098$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return $fea5dc28d73fc098$var$hasOwnProperty.call(it, key);
};

});

parcelRegister("gvOoh", function(module, exports) {
// Thank's IE8 for his funny defineProperty

module.exports = !(parcelRequire("bjnTD"))(function() {
    return Object.defineProperty({}, 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("bjnTD", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

});


parcelRegister("eqgBB", function(module, exports) {

var $1YuiL = parcelRequire("1YuiL");

var $ejAKF = parcelRequire("ejAKF");

var $5ujtn = parcelRequire("5ujtn");

var $2D2fi = parcelRequire("2D2fi");

var $8luNd = parcelRequire("8luNd");
var $a8005fe53c88f5f4$var$PROTOTYPE = 'prototype';
var $a8005fe53c88f5f4$var$$export = function(type, name, source) {
    var IS_FORCED = type & $a8005fe53c88f5f4$var$$export.F;
    var IS_GLOBAL = type & $a8005fe53c88f5f4$var$$export.G;
    var IS_STATIC = type & $a8005fe53c88f5f4$var$$export.S;
    var IS_PROTO = type & $a8005fe53c88f5f4$var$$export.P;
    var IS_BIND = type & $a8005fe53c88f5f4$var$$export.B;
    var target = IS_GLOBAL ? $1YuiL : IS_STATIC ? $1YuiL[name] || ($1YuiL[name] = {}) : ($1YuiL[name] || {})[$a8005fe53c88f5f4$var$PROTOTYPE];
    var exports = IS_GLOBAL ? $ejAKF : $ejAKF[name] || ($ejAKF[name] = {});
    var expProto = exports[$a8005fe53c88f5f4$var$PROTOTYPE] || (exports[$a8005fe53c88f5f4$var$PROTOTYPE] = {});
    var key, own, out, exp;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        // export native or passed
        out = (own ? target : source)[key];
        // bind timers to global for call from export context
        exp = IS_BIND && own ? $8luNd(out, $1YuiL) : IS_PROTO && typeof out == 'function' ? $8luNd(Function.call, out) : out;
        // extend global
        if (target) $2D2fi(target, key, out, type & $a8005fe53c88f5f4$var$$export.U);
        // export
        if (exports[key] != out) $5ujtn(exports, key, exp);
        if (IS_PROTO && expProto[key] != out) expProto[key] = out;
    }
};
$1YuiL.core = $ejAKF;
// type bitmap
$a8005fe53c88f5f4$var$$export.F = 1; // forced
$a8005fe53c88f5f4$var$$export.G = 2; // global
$a8005fe53c88f5f4$var$$export.S = 4; // static
$a8005fe53c88f5f4$var$$export.P = 8; // proto
$a8005fe53c88f5f4$var$$export.B = 16; // bind
$a8005fe53c88f5f4$var$$export.W = 32; // wrap
$a8005fe53c88f5f4$var$$export.U = 64; // safe
$a8005fe53c88f5f4$var$$export.R = 128; // real proto method for `library`
module.exports = $a8005fe53c88f5f4$var$$export;

});
parcelRegister("ejAKF", function(module, exports) {
var $a6bf5926e84ac445$var$core = module.exports = {
    version: '2.6.12'
};
if (typeof __e == 'number') __e = $a6bf5926e84ac445$var$core; // eslint-disable-line no-undef

});

parcelRegister("5ujtn", function(module, exports) {

var $lWhMZ = parcelRequire("lWhMZ");

var $8tLmk = parcelRequire("8tLmk");

module.exports = (parcelRequire("gvOoh")) ? function(object, key, value) {
    return $lWhMZ.f(object, key, $8tLmk(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("lWhMZ", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $ff8cd04e29fc2210$export$2d1720544b23b823; }, function (v) { return $ff8cd04e29fc2210$export$2d1720544b23b823 = v; });
var $ff8cd04e29fc2210$export$2d1720544b23b823;

var $6K5GG = parcelRequire("6K5GG");

var $3H8OJ = parcelRequire("3H8OJ");

var $9a73R = parcelRequire("9a73R");
var $ff8cd04e29fc2210$var$dP = Object.defineProperty;

$ff8cd04e29fc2210$export$2d1720544b23b823 = (parcelRequire("gvOoh")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    $6K5GG(O);
    P = $9a73R(P, true);
    $6K5GG(Attributes);
    if ($3H8OJ) try {
        return $ff8cd04e29fc2210$var$dP(O, P, Attributes);
    } catch (e) {}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("6K5GG", function(module, exports) {

var $h9IVq = parcelRequire("h9IVq");
module.exports = function(it) {
    if (!$h9IVq(it)) throw TypeError(it + ' is not an object!');
    return it;
};

});
parcelRegister("h9IVq", function(module, exports) {
module.exports = function(it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};

});


parcelRegister("3H8OJ", function(module, exports) {



module.exports = !(parcelRequire("gvOoh")) && !(parcelRequire("bjnTD"))(function() {
    return Object.defineProperty((parcelRequire("9Ut4j"))('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("9Ut4j", function(module, exports) {

var $h9IVq = parcelRequire("h9IVq");

var $1YuiL = parcelRequire("1YuiL");
var $736fe46e28d0aa36$require$document = $1YuiL.document;
// typeof document.createElement is 'object' in old IE
var $736fe46e28d0aa36$var$is = $h9IVq($736fe46e28d0aa36$require$document) && $h9IVq($736fe46e28d0aa36$require$document.createElement);
module.exports = function(it) {
    return $736fe46e28d0aa36$var$is ? $736fe46e28d0aa36$require$document.createElement(it) : {};
};

});


parcelRegister("9a73R", function(module, exports) {
// 7.1.1 ToPrimitive(input [, PreferredType])

var $h9IVq = parcelRequire("h9IVq");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!$h9IVq(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !$h9IVq(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !$h9IVq(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !$h9IVq(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});


parcelRegister("8tLmk", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});


parcelRegister("2D2fi", function(module, exports) {

var $1YuiL = parcelRequire("1YuiL");

var $5ujtn = parcelRequire("5ujtn");

var $lRu3m = parcelRequire("lRu3m");

var $1ea0f739ab2289b7$var$SRC = (parcelRequire("ln3yM"))('src');

var $bvbK6 = parcelRequire("bvbK6");
var $1ea0f739ab2289b7$var$TO_STRING = 'toString';
var $1ea0f739ab2289b7$var$TPL = ('' + $bvbK6).split($1ea0f739ab2289b7$var$TO_STRING);

(parcelRequire("ejAKF")).inspectSource = function(it) {
    return $bvbK6.call(it);
};
(module.exports = function(O, key, val, safe) {
    var isFunction = typeof val == 'function';
    if (isFunction) $lRu3m(val, 'name') || $5ujtn(val, 'name', key);
    if (O[key] === val) return;
    if (isFunction) $lRu3m(val, $1ea0f739ab2289b7$var$SRC) || $5ujtn(val, $1ea0f739ab2289b7$var$SRC, O[key] ? '' + O[key] : $1ea0f739ab2289b7$var$TPL.join(String(key)));
    if (O === $1YuiL) O[key] = val;
    else if (!safe) {
        delete O[key];
        $5ujtn(O, key, val);
    } else if (O[key]) O[key] = val;
    else $5ujtn(O, key, val);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, $1ea0f739ab2289b7$var$TO_STRING, function toString() {
    return typeof this == 'function' && this[$1ea0f739ab2289b7$var$SRC] || $bvbK6.call(this);
});

});
parcelRegister("ln3yM", function(module, exports) {
var $f8ee81e8eaae171b$var$id = 0;
var $f8ee81e8eaae171b$var$px = Math.random();
module.exports = function(key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++$f8ee81e8eaae171b$var$id + $f8ee81e8eaae171b$var$px).toString(36));
};

});

parcelRegister("bvbK6", function(module, exports) {

module.exports = (parcelRequire("6ODIt"))('native-function-to-string', Function.toString);

});
parcelRegister("6ODIt", function(module, exports) {

var $ejAKF = parcelRequire("ejAKF");

var $1YuiL = parcelRequire("1YuiL");
var $4f6638682b2b523b$var$SHARED = '__core-js_shared__';
var $4f6638682b2b523b$var$store = $1YuiL[$4f6638682b2b523b$var$SHARED] || ($1YuiL[$4f6638682b2b523b$var$SHARED] = {});

(module.exports = function(key, value) {
    return $4f6638682b2b523b$var$store[key] || ($4f6638682b2b523b$var$store[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: $ejAKF.version,
    mode: (parcelRequire("aNvO0")) ? 'pure' : 'global',
    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
});

});
parcelRegister("aNvO0", function(module, exports) {
module.exports = false;

});




parcelRegister("8luNd", function(module, exports) {
// optional / simple context binding

var $4VmiN = parcelRequire("4VmiN");
module.exports = function(fn, that, length) {
    $4VmiN(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("4VmiN", function(module, exports) {
module.exports = function(it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
};

});



parcelRegister("k40lc", function(module, exports) {

var $lWhMZ = parcelRequire("lWhMZ");
var $e9b47211eae6b122$require$def = $lWhMZ.f;

var $lRu3m = parcelRequire("lRu3m");

var $e9b47211eae6b122$var$TAG = (parcelRequire("buDDQ"))('toStringTag');
module.exports = function(it, tag, stat) {
    if (it && !$lRu3m(it = stat ? it : it.prototype, $e9b47211eae6b122$var$TAG)) $e9b47211eae6b122$require$def(it, $e9b47211eae6b122$var$TAG, {
        configurable: true,
        value: tag
    });
};

});
parcelRegister("buDDQ", function(module, exports) {

var $85e13f101266b1d3$var$store = (parcelRequire("6ODIt"))('wks');

var $ln3yM = parcelRequire("ln3yM");

var $1YuiL = parcelRequire("1YuiL");
var $85e13f101266b1d3$require$Symbol = $1YuiL.Symbol;
var $85e13f101266b1d3$var$USE_SYMBOL = typeof $85e13f101266b1d3$require$Symbol == 'function';
var $85e13f101266b1d3$var$$exports = module.exports = function(name) {
    return $85e13f101266b1d3$var$store[name] || ($85e13f101266b1d3$var$store[name] = $85e13f101266b1d3$var$USE_SYMBOL && $85e13f101266b1d3$require$Symbol[name] || ($85e13f101266b1d3$var$USE_SYMBOL ? $85e13f101266b1d3$require$Symbol : $ln3yM)('Symbol.' + name));
};
$85e13f101266b1d3$var$$exports.store = $85e13f101266b1d3$var$store;

});


parcelRegister("b5vfc", function(module, exports) {

var $1YuiL = parcelRequire("1YuiL");

var $ejAKF = parcelRequire("ejAKF");

var $aNvO0 = parcelRequire("aNvO0");

var $cTJIb = parcelRequire("cTJIb");

var $lWhMZ = parcelRequire("lWhMZ");
var $812865c7f307e00d$require$defineProperty = $lWhMZ.f;
module.exports = function(name) {
    var $Symbol = $ejAKF.Symbol || ($ejAKF.Symbol = $aNvO0 ? {} : $1YuiL.Symbol || {});
    if (name.charAt(0) != '_' && !(name in $Symbol)) $812865c7f307e00d$require$defineProperty($Symbol, name, {
        value: $cTJIb.f(name)
    });
};

});
parcelRegister("cTJIb", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $963e1478acd0f76f$export$2d1720544b23b823; }, function (v) { return $963e1478acd0f76f$export$2d1720544b23b823 = v; });
var $963e1478acd0f76f$export$2d1720544b23b823;

$963e1478acd0f76f$export$2d1720544b23b823 = (parcelRequire("buDDQ"));

});


parcelRegister("9DkTL", function(module, exports) {
// fallback for non-array-like ES3 and non-enumerable old V8 strings

var $P9d0u = parcelRequire("P9d0u");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it) {
    return $P9d0u(it) == 'String' ? it.split('') : Object(it);
};

});
parcelRegister("P9d0u", function(module, exports) {
var $099be83552bdba5f$var$toString = {}.toString;
module.exports = function(it) {
    return $099be83552bdba5f$var$toString.call(it).slice(8, -1);
};

});


parcelRegister("hKLZ1", function(module, exports) {
// false -> Array#indexOf
// true  -> Array#includes

var $15QDc = parcelRequire("15QDc");

var $jsF4z = parcelRequire("jsF4z");

var $aJr6a = parcelRequire("aJr6a");
module.exports = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $15QDc($this);
        var length = $jsF4z(O.length);
        var index = $aJr6a(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++)if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};

});
parcelRegister("15QDc", function(module, exports) {
// to indexed object, toObject with fallback for non-array-like ES3 strings

var $9DkTL = parcelRequire("9DkTL");

var $6g06V = parcelRequire("6g06V");
module.exports = function(it) {
    return $9DkTL($6g06V(it));
};

});
parcelRegister("6g06V", function(module, exports) {
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
};

});


parcelRegister("jsF4z", function(module, exports) {
// 7.1.15 ToLength

var $dAqin = parcelRequire("dAqin");
var $e2b07e0331a9ae4d$var$min = Math.min;
module.exports = function(it) {
    return it > 0 ? $e2b07e0331a9ae4d$var$min($dAqin(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

});
parcelRegister("dAqin", function(module, exports) {
// 7.1.4 ToInteger
var $9e4308dd687ce77b$var$ceil = Math.ceil;
var $9e4308dd687ce77b$var$floor = Math.floor;
module.exports = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? $9e4308dd687ce77b$var$floor : $9e4308dd687ce77b$var$ceil)(it);
};

});


parcelRegister("aJr6a", function(module, exports) {

var $dAqin = parcelRequire("dAqin");
var $7d0320888d05c202$var$max = Math.max;
var $7d0320888d05c202$var$min = Math.min;
module.exports = function(index, length) {
    index = $dAqin(index);
    return index < 0 ? $7d0320888d05c202$var$max(index + length, 0) : $7d0320888d05c202$var$min(index, length);
};

});


parcelRegister("fUAUM", function(module, exports) {

var $b958b87716583a41$var$shared = (parcelRequire("6ODIt"))('keys');

var $ln3yM = parcelRequire("ln3yM");
module.exports = function(key) {
    return $b958b87716583a41$var$shared[key] || ($b958b87716583a41$var$shared[key] = $ln3yM(key));
};

});

parcelRegister("bUdLW", function(module, exports) {
// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

});

parcelRegister("il6o7", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $d59f24b4b2e4791f$export$2d1720544b23b823; }, function (v) { return $d59f24b4b2e4791f$export$2d1720544b23b823 = v; });
var $d59f24b4b2e4791f$export$2d1720544b23b823;
$d59f24b4b2e4791f$export$2d1720544b23b823 = ({}).propertyIsEnumerable;

});

parcelRegister("6HMRV", function(module, exports) {
// 7.2.2 IsArray(argument)

var $P9d0u = parcelRequire("P9d0u");
module.exports = Array.isArray || function isArray(arg) {
    return $P9d0u(arg) == 'Array';
};

});

parcelRegister("j50QJ", function(module, exports) {
// 7.1.13 ToObject(argument)

var $6g06V = parcelRequire("6g06V");
module.exports = function(it) {
    return Object($6g06V(it));
};

});

parcelRegister("16E7l", function(module, exports) {
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])

var $6K5GG = parcelRequire("6K5GG");

var $4MNza = parcelRequire("4MNza");

var $bUdLW = parcelRequire("bUdLW");

var $0ce5787848e275b1$var$IE_PROTO = (parcelRequire("fUAUM"))('IE_PROTO');
var $0ce5787848e275b1$var$Empty = function() {};
var $0ce5787848e275b1$var$PROTOTYPE = 'prototype';


// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $0ce5787848e275b1$var$createDict = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = (parcelRequire("9Ut4j"))('iframe');
    var i = $bUdLW.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';
    (parcelRequire("ahTLX")).appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    $0ce5787848e275b1$var$createDict = iframeDocument.F;
    while(i--)delete $0ce5787848e275b1$var$createDict[$0ce5787848e275b1$var$PROTOTYPE][$bUdLW[i]];
    return $0ce5787848e275b1$var$createDict();
};
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $0ce5787848e275b1$var$Empty[$0ce5787848e275b1$var$PROTOTYPE] = $6K5GG(O);
        result = new $0ce5787848e275b1$var$Empty();
        $0ce5787848e275b1$var$Empty[$0ce5787848e275b1$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$0ce5787848e275b1$var$IE_PROTO] = O;
    } else result = $0ce5787848e275b1$var$createDict();
    return Properties === undefined ? result : $4MNza(result, Properties);
};

});
parcelRegister("4MNza", function(module, exports) {

var $lWhMZ = parcelRequire("lWhMZ");

var $6K5GG = parcelRequire("6K5GG");

var $eYXZv = parcelRequire("eYXZv");

module.exports = (parcelRequire("gvOoh")) ? Object.defineProperties : function defineProperties(O, Properties) {
    $6K5GG(O);
    var keys = $eYXZv(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while(length > i)$lWhMZ.f(O, P = keys[i++], Properties[P]);
    return O;
};

});
parcelRegister("eYXZv", function(module, exports) {
// 19.1.2.14 / 15.2.3.14 Object.keys(O)

var $8a1Ft = parcelRequire("8a1Ft");

var $bUdLW = parcelRequire("bUdLW");
module.exports = Object.keys || function keys(O) {
    return $8a1Ft(O, $bUdLW);
};

});
parcelRegister("8a1Ft", function(module, exports) {

var $lRu3m = parcelRequire("lRu3m");

var $15QDc = parcelRequire("15QDc");

var $5f108d1e070d7a95$var$arrayIndexOf = (parcelRequire("hKLZ1"))(false);

var $5f108d1e070d7a95$var$IE_PROTO = (parcelRequire("fUAUM"))('IE_PROTO');
module.exports = function(object, names) {
    var O = $15QDc(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)if (key != $5f108d1e070d7a95$var$IE_PROTO) $lRu3m(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($lRu3m(O, key = names[i++])) ~$5f108d1e070d7a95$var$arrayIndexOf(result, key) || result.push(key);
    return result;
};

});



parcelRegister("ahTLX", function(module, exports) {

var $1YuiL = parcelRequire("1YuiL");
var $77d6c1260d6643a6$require$document = $1YuiL.document;
module.exports = $77d6c1260d6643a6$require$document && $77d6c1260d6643a6$require$document.documentElement;

});


parcelRegister("1uBcr", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $116572e13767be68$export$2d1720544b23b823; }, function (v) { return $116572e13767be68$export$2d1720544b23b823 = v; });
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $116572e13767be68$export$2d1720544b23b823;

var $15QDc = parcelRequire("15QDc");

var $ivFzP = parcelRequire("ivFzP");
var $116572e13767be68$require$gOPN = $ivFzP.f;
var $116572e13767be68$var$toString = {}.toString;
var $116572e13767be68$var$windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $116572e13767be68$var$getWindowNames = function(it) {
    try {
        return $116572e13767be68$require$gOPN(it);
    } catch (e) {
        return $116572e13767be68$var$windowNames.slice();
    }
};
$116572e13767be68$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $116572e13767be68$var$windowNames && $116572e13767be68$var$toString.call(it) == '[object Window]' ? $116572e13767be68$var$getWindowNames(it) : $116572e13767be68$require$gOPN($15QDc(it));
};

});
parcelRegister("ivFzP", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $d79b5f918a5cd312$export$2d1720544b23b823; }, function (v) { return $d79b5f918a5cd312$export$2d1720544b23b823 = v; });
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $d79b5f918a5cd312$export$2d1720544b23b823;

var $8a1Ft = parcelRequire("8a1Ft");

var $d79b5f918a5cd312$var$hiddenKeys = (parcelRequire("bUdLW")).concat('length', 'prototype');
$d79b5f918a5cd312$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $8a1Ft(O, $d79b5f918a5cd312$var$hiddenKeys);
};

});


parcelRegister("5yOh2", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $40c72009c0aaac1c$export$2d1720544b23b823; }, function (v) { return $40c72009c0aaac1c$export$2d1720544b23b823 = v; });
var $40c72009c0aaac1c$export$2d1720544b23b823;

var $il6o7 = parcelRequire("il6o7");

var $8tLmk = parcelRequire("8tLmk");

var $15QDc = parcelRequire("15QDc");

var $9a73R = parcelRequire("9a73R");

var $lRu3m = parcelRequire("lRu3m");

var $3H8OJ = parcelRequire("3H8OJ");
var $40c72009c0aaac1c$var$gOPD = Object.getOwnPropertyDescriptor;

$40c72009c0aaac1c$export$2d1720544b23b823 = (parcelRequire("gvOoh")) ? $40c72009c0aaac1c$var$gOPD : function getOwnPropertyDescriptor(O, P) {
    O = $15QDc(O);
    P = $9a73R(P, true);
    if ($3H8OJ) try {
        return $40c72009c0aaac1c$var$gOPD(O, P);
    } catch (e) {}
    if ($lRu3m(O, P)) return $8tLmk(!$il6o7.f.call(O, P), O[P]);
};

});

parcelRegister("lTC2m", function(module, exports) {
// most Object methods by ES6 should accept primitives

var $eqgBB = parcelRequire("eqgBB");

var $ejAKF = parcelRequire("ejAKF");

var $bjnTD = parcelRequire("bjnTD");
module.exports = function(KEY, exec) {
    var fn = ($ejAKF.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    $eqgBB($eqgBB.S + $eqgBB.F * $bjnTD(function() {
        fn(1);
    }), 'Object', exp);
};

});

parcelRegister("9nGSz", function(module, exports) {
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)

var $lRu3m = parcelRequire("lRu3m");

var $j50QJ = parcelRequire("j50QJ");

var $6d4785ef744de780$var$IE_PROTO = (parcelRequire("fUAUM"))('IE_PROTO');
var $6d4785ef744de780$var$ObjectProto = Object.prototype;
module.exports = Object.getPrototypeOf || function(O) {
    O = $j50QJ(O);
    if ($lRu3m(O, $6d4785ef744de780$var$IE_PROTO)) return O[$6d4785ef744de780$var$IE_PROTO];
    if (typeof O.constructor == 'function' && O instanceof O.constructor) return O.constructor.prototype;
    return O instanceof Object ? $6d4785ef744de780$var$ObjectProto : null;
};

});

parcelRegister("5cuvo", function(module, exports) {
'use strict';

var $gvOoh = parcelRequire("gvOoh");

var $eYXZv = parcelRequire("eYXZv");

var $5S6VU = parcelRequire("5S6VU");

var $il6o7 = parcelRequire("il6o7");

var $j50QJ = parcelRequire("j50QJ");

var $9DkTL = parcelRequire("9DkTL");
var $3c95bc7c8f41afbe$var$$assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$3c95bc7c8f41afbe$var$$assign || (parcelRequire("bjnTD"))(function() {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function(k) {
        B[k] = k;
    });
    return $3c95bc7c8f41afbe$var$$assign({}, A)[S] != 7 || Object.keys($3c95bc7c8f41afbe$var$$assign({}, B)).join('') != K;
}) ? function assign(target, source) {
    var T = $j50QJ(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = $5S6VU.f;
    var isEnum = $il6o7.f;
    while(aLen > index){
        var S = $9DkTL(arguments[index++]);
        var keys = getSymbols ? $eYXZv(S).concat(getSymbols(S)) : $eYXZv(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$gvOoh || isEnum.call(S, key)) T[key] = S[key];
        }
    }
    return T;
} : $3c95bc7c8f41afbe$var$$assign;

});
parcelRegister("5S6VU", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $44675faabccaa5d2$export$2d1720544b23b823; }, function (v) { return $44675faabccaa5d2$export$2d1720544b23b823 = v; });
var $44675faabccaa5d2$export$2d1720544b23b823;
$44675faabccaa5d2$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});


parcelRegister("lnyGt", function(module, exports) {
// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
    // eslint-disable-next-line no-self-compare
    return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

});

parcelRegister("iTiy4", function(module, exports) {
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */ 
var $h9IVq = parcelRequire("h9IVq");

var $6K5GG = parcelRequire("6K5GG");
var $dc0bc065f22e3e92$var$check = function(O, proto) {
    $6K5GG(O);
    if (!$h9IVq(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};


module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? function(test, buggy, set) {
        try {
            set = (parcelRequire("8luNd"))(Function.call, (parcelRequire("5yOh2")).f(Object.prototype, '__proto__').set, 2);
            set(test, []);
            buggy = !(test instanceof Array);
        } catch (e) {
            buggy = true;
        }
        return function setPrototypeOf(O, proto) {
            $dc0bc065f22e3e92$var$check(O, proto);
            if (buggy) O.__proto__ = proto;
            else set(O, proto);
            return O;
        };
    }({}, false) : undefined),
    check: $dc0bc065f22e3e92$var$check
};

});

parcelRegister("47rfI", function(module, exports) {
// getting tag from 19.1.3.6 Object.prototype.toString()

var $P9d0u = parcelRequire("P9d0u");

var $2ffcf4a38fe385ed$var$TAG = (parcelRequire("buDDQ"))('toStringTag');
// ES3 wrong here
var $2ffcf4a38fe385ed$var$ARG = $P9d0u(function() {
    return arguments;
}()) == 'Arguments';
// fallback for IE11 Script Access Denied error
var $2ffcf4a38fe385ed$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (e) {}
};
module.exports = function(it) {
    var O, T, B;
    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (T = $2ffcf4a38fe385ed$var$tryGet(O = Object(it), $2ffcf4a38fe385ed$var$TAG)) == 'string' ? T : $2ffcf4a38fe385ed$var$ARG ? $P9d0u(O) : (B = $P9d0u(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

});

parcelRegister("d3CGC", function(module, exports) {
'use strict';

var $4VmiN = parcelRequire("4VmiN");

var $h9IVq = parcelRequire("h9IVq");

var $g66xb = parcelRequire("g66xb");
var $9819907dd4363f9b$var$arraySlice = [].slice;
var $9819907dd4363f9b$var$factories = {};
var $9819907dd4363f9b$var$construct = function(F, len, args) {
    if (!(len in $9819907dd4363f9b$var$factories)) {
        for(var n = [], i = 0; i < len; i++)n[i] = 'a[' + i + ']';
        // eslint-disable-next-line no-new-func
        $9819907dd4363f9b$var$factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
    }
    return $9819907dd4363f9b$var$factories[len](F, args);
};
module.exports = Function.bind || function bind(that /* , ...args */ ) {
    var fn = $4VmiN(this);
    var partArgs = $9819907dd4363f9b$var$arraySlice.call(arguments, 1);
    var bound = function() {
        var args = partArgs.concat($9819907dd4363f9b$var$arraySlice.call(arguments));
        return this instanceof bound ? $9819907dd4363f9b$var$construct(fn, args.length, args) : $g66xb(fn, args, that);
    };
    if ($h9IVq(fn.prototype)) bound.prototype = fn.prototype;
    return bound;
};

});
parcelRegister("g66xb", function(module, exports) {
// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that) {
    var un = that === undefined;
    switch(args.length){
        case 0:
            return un ? fn() : fn.call(that);
        case 1:
            return un ? fn(args[0]) : fn.call(that, args[0]);
        case 2:
            return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);
        case 3:
            return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);
        case 4:
            return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
    }
    return fn.apply(that, args);
};

});


parcelRegister("6vf7z", function(module, exports) {

var $eqgBB = parcelRequire("eqgBB");

var $6g06V = parcelRequire("6g06V");

var $bjnTD = parcelRequire("bjnTD");

var $7PMIg = parcelRequire("7PMIg");
var $4bc15e09d264f09b$var$space = '[' + $7PMIg + ']';
var $4bc15e09d264f09b$var$non = '\u200b\u0085';
var $4bc15e09d264f09b$var$ltrim = RegExp('^' + $4bc15e09d264f09b$var$space + $4bc15e09d264f09b$var$space + '*');
var $4bc15e09d264f09b$var$rtrim = RegExp($4bc15e09d264f09b$var$space + $4bc15e09d264f09b$var$space + '*$');
var $4bc15e09d264f09b$var$exporter = function(KEY, exec, ALIAS) {
    var exp = {};
    var FORCE = $bjnTD(function() {
        return !!$7PMIg[KEY]() || $4bc15e09d264f09b$var$non[KEY]() != $4bc15e09d264f09b$var$non;
    });
    var fn = exp[KEY] = FORCE ? exec($4bc15e09d264f09b$var$trim) : $7PMIg[KEY];
    if (ALIAS) exp[ALIAS] = fn;
    $eqgBB($eqgBB.P + $eqgBB.F * FORCE, 'String', exp);
};
// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var $4bc15e09d264f09b$var$trim = $4bc15e09d264f09b$var$exporter.trim = function(string, TYPE) {
    string = String($6g06V(string));
    if (TYPE & 1) string = string.replace($4bc15e09d264f09b$var$ltrim, '');
    if (TYPE & 2) string = string.replace($4bc15e09d264f09b$var$rtrim, '');
    return string;
};
module.exports = $4bc15e09d264f09b$var$exporter;

});
parcelRegister("7PMIg", function(module, exports) {
module.exports = "	\n\v\f\r \xa0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";

});


parcelRegister("lQVqT", function(module, exports) {
'use strict';

var $dAqin = parcelRequire("dAqin");

var $6g06V = parcelRequire("6g06V");
module.exports = function repeat(count) {
    var str = String($6g06V(this));
    var res = '';
    var n = $dAqin(count);
    if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
    for(; n > 0; (n >>>= 1) && (str += str))if (n & 1) res += str;
    return res;
};

});

parcelRegister("3DtrK", function(module, exports) {
// 20.1.2.3 Number.isInteger(number)

var $h9IVq = parcelRequire("h9IVq");
var $2a5bdb12188c4dee$var$floor = Math.floor;
module.exports = function isInteger(it) {
    return !$h9IVq(it) && isFinite(it) && $2a5bdb12188c4dee$var$floor(it) === it;
};

});

parcelRegister("7ZXns", function(module, exports) {
// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
    return (x = +x) > -0.00000001 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};

});

parcelRegister("36EjW", function(module, exports) {
// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
    // eslint-disable-next-line no-self-compare
    return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};

});

parcelRegister("6Jdp5", function(module, exports) {
// 20.2.2.16 Math.fround(x)

var $36EjW = parcelRequire("36EjW");
var $4e6157becd58ef2f$var$pow = Math.pow;
var $4e6157becd58ef2f$var$EPSILON = $4e6157becd58ef2f$var$pow(2, -52);
var $4e6157becd58ef2f$var$EPSILON32 = $4e6157becd58ef2f$var$pow(2, -23);
var $4e6157becd58ef2f$var$MAX32 = $4e6157becd58ef2f$var$pow(2, 127) * (2 - $4e6157becd58ef2f$var$EPSILON32);
var $4e6157becd58ef2f$var$MIN32 = $4e6157becd58ef2f$var$pow(2, -126);
var $4e6157becd58ef2f$var$roundTiesToEven = function(n) {
    return n + 1 / $4e6157becd58ef2f$var$EPSILON - 1 / $4e6157becd58ef2f$var$EPSILON;
};
module.exports = Math.fround || function fround(x) {
    var $abs = Math.abs(x);
    var $sign = $36EjW(x);
    var a, result;
    if ($abs < $4e6157becd58ef2f$var$MIN32) return $sign * $4e6157becd58ef2f$var$roundTiesToEven($abs / $4e6157becd58ef2f$var$MIN32 / $4e6157becd58ef2f$var$EPSILON32) * $4e6157becd58ef2f$var$MIN32 * $4e6157becd58ef2f$var$EPSILON32;
    a = (1 + $4e6157becd58ef2f$var$EPSILON32 / $4e6157becd58ef2f$var$EPSILON) * $abs;
    result = a - (a - $abs);
    // eslint-disable-next-line no-self-compare
    if (result > $4e6157becd58ef2f$var$MAX32 || result != result) return $sign * Infinity;
    return $sign * result;
};

});

parcelRegister("2B3HC", function(module, exports) {

var $dAqin = parcelRequire("dAqin");

var $6g06V = parcelRequire("6g06V");
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING) {
    return function(that, pos) {
        var s = String($6g06V(that));
        var i = $dAqin(pos);
        var l = s.length;
        var a, b;
        if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
        a = s.charCodeAt(i);
        return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
};

});

parcelRegister("eApyU", function(module, exports) {
'use strict';

var $aNvO0 = parcelRequire("aNvO0");

var $eqgBB = parcelRequire("eqgBB");

var $2D2fi = parcelRequire("2D2fi");

var $5ujtn = parcelRequire("5ujtn");

var $kfJlH = parcelRequire("kfJlH");

var $aleMf = parcelRequire("aleMf");

var $k40lc = parcelRequire("k40lc");

var $9nGSz = parcelRequire("9nGSz");

var $a9e8418f2963cdca$var$ITERATOR = (parcelRequire("buDDQ"))('iterator');
var $a9e8418f2963cdca$var$BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var $a9e8418f2963cdca$var$FF_ITERATOR = '@@iterator';
var $a9e8418f2963cdca$var$KEYS = 'keys';
var $a9e8418f2963cdca$var$VALUES = 'values';
var $a9e8418f2963cdca$var$returnThis = function() {
    return this;
};
module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
    $aleMf(Constructor, NAME, next);
    var getMethod = function(kind) {
        if (!$a9e8418f2963cdca$var$BUGGY && kind in proto) return proto[kind];
        switch(kind){
            case $a9e8418f2963cdca$var$KEYS:
                return function keys() {
                    return new Constructor(this, kind);
                };
            case $a9e8418f2963cdca$var$VALUES:
                return function values() {
                    return new Constructor(this, kind);
                };
        }
        return function entries() {
            return new Constructor(this, kind);
        };
    };
    var TAG = NAME + ' Iterator';
    var DEF_VALUES = DEFAULT == $a9e8418f2963cdca$var$VALUES;
    var VALUES_BUG = false;
    var proto = Base.prototype;
    var $native = proto[$a9e8418f2963cdca$var$ITERATOR] || proto[$a9e8418f2963cdca$var$FF_ITERATOR] || DEFAULT && proto[DEFAULT];
    var $default = $native || getMethod(DEFAULT);
    var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
    var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
    var methods, key, IteratorPrototype;
    // Fix native
    if ($anyNative) {
        IteratorPrototype = $9nGSz($anyNative.call(new Base()));
        if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
            // Set @@toStringTag to native iterators
            $k40lc(IteratorPrototype, TAG, true);
            // fix for some old engines
            if (!$aNvO0 && typeof IteratorPrototype[$a9e8418f2963cdca$var$ITERATOR] != 'function') $5ujtn(IteratorPrototype, $a9e8418f2963cdca$var$ITERATOR, $a9e8418f2963cdca$var$returnThis);
        }
    }
    // fix Array#{values, @@iterator}.name in V8 / FF
    if (DEF_VALUES && $native && $native.name !== $a9e8418f2963cdca$var$VALUES) {
        VALUES_BUG = true;
        $default = function values() {
            return $native.call(this);
        };
    }
    // Define iterator
    if ((!$aNvO0 || FORCED) && ($a9e8418f2963cdca$var$BUGGY || VALUES_BUG || !proto[$a9e8418f2963cdca$var$ITERATOR])) $5ujtn(proto, $a9e8418f2963cdca$var$ITERATOR, $default);
    // Plug for library
    $kfJlH[NAME] = $default;
    $kfJlH[TAG] = $a9e8418f2963cdca$var$returnThis;
    if (DEFAULT) {
        methods = {
            values: DEF_VALUES ? $default : getMethod($a9e8418f2963cdca$var$VALUES),
            keys: IS_SET ? $default : getMethod($a9e8418f2963cdca$var$KEYS),
            entries: $entries
        };
        if (FORCED) {
            for(key in methods)if (!(key in proto)) $2D2fi(proto, key, methods[key]);
        } else $eqgBB($eqgBB.P + $eqgBB.F * ($a9e8418f2963cdca$var$BUGGY || VALUES_BUG), NAME, methods);
    }
    return methods;
};

});
parcelRegister("kfJlH", function(module, exports) {
module.exports = {};

});

parcelRegister("aleMf", function(module, exports) {
'use strict';

var $16E7l = parcelRequire("16E7l");

var $8tLmk = parcelRequire("8tLmk");

var $k40lc = parcelRequire("k40lc");
var $78775402f9c01375$var$IteratorPrototype = {};


// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
(parcelRequire("5ujtn"))($78775402f9c01375$var$IteratorPrototype, (parcelRequire("buDDQ"))('iterator'), function() {
    return this;
});
module.exports = function(Constructor, NAME, next) {
    Constructor.prototype = $16E7l($78775402f9c01375$var$IteratorPrototype, {
        next: $8tLmk(1, next)
    });
    $k40lc(Constructor, NAME + ' Iterator');
};

});


parcelRegister("caRQI", function(module, exports) {

var $8dd0308fab59130b$var$MATCH = (parcelRequire("buDDQ"))('match');
module.exports = function(KEY) {
    var re = /./;
    try {
        '/./'[KEY](re);
    } catch (e) {
        try {
            re[$8dd0308fab59130b$var$MATCH] = false;
            return !'/./'[KEY](re);
        } catch (f) {}
    }
    return true;
};

});

parcelRegister("9Zqh5", function(module, exports) {

var $eqgBB = parcelRequire("eqgBB");

var $bjnTD = parcelRequire("bjnTD");

var $6g06V = parcelRequire("6g06V");
var $745e3125cc560cfe$var$quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var $745e3125cc560cfe$var$createHTML = function(string, tag, attribute, value) {
    var S = String($6g06V(string));
    var p1 = '<' + tag;
    if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace($745e3125cc560cfe$var$quot, '&quot;') + '"';
    return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function(NAME, exec) {
    var O = {};
    O[NAME] = exec($745e3125cc560cfe$var$createHTML);
    $eqgBB($eqgBB.P + $eqgBB.F * $bjnTD(function() {
        var test = ''[NAME]('"');
        return test !== test.toLowerCase() || test.split('"').length > 3;
    }), 'String', O);
};

});

parcelRegister("l8WEI", function(module, exports) {
'use strict';

var $6K5GG = parcelRequire("6K5GG");

var $9a73R = parcelRequire("9a73R");
var $f647d82166637e47$var$NUMBER = 'number';
module.exports = function(hint) {
    if (hint !== 'string' && hint !== $f647d82166637e47$var$NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
    return $9a73R($6K5GG(this), hint != $f647d82166637e47$var$NUMBER);
};

});

parcelRegister("awT0Y", function(module, exports) {
// check on default Array iterator

var $kfJlH = parcelRequire("kfJlH");

var $7aa7915387bb1a7e$var$ITERATOR = (parcelRequire("buDDQ"))('iterator');
var $7aa7915387bb1a7e$var$ArrayProto = Array.prototype;
module.exports = function(it) {
    return it !== undefined && ($kfJlH.Array === it || $7aa7915387bb1a7e$var$ArrayProto[$7aa7915387bb1a7e$var$ITERATOR] === it);
};

});

parcelRegister("fUVYF", function(module, exports) {

var $47rfI = parcelRequire("47rfI");

var $b9690f181429a63e$var$ITERATOR = (parcelRequire("buDDQ"))('iterator');

var $kfJlH = parcelRequire("kfJlH");

module.exports = (parcelRequire("ejAKF")).getIteratorMethod = function(it) {
    if (it != undefined) return it[$b9690f181429a63e$var$ITERATOR] || it['@@iterator'] || $kfJlH[$47rfI(it)];
};

});

parcelRegister("5QSWt", function(module, exports) {

var $442c6d775904fb5d$var$ITERATOR = (parcelRequire("buDDQ"))('iterator');
var $442c6d775904fb5d$var$SAFE_CLOSING = false;
try {
    var $442c6d775904fb5d$var$riter = [
        7
    ][$442c6d775904fb5d$var$ITERATOR]();
    $442c6d775904fb5d$var$riter['return'] = function() {
        $442c6d775904fb5d$var$SAFE_CLOSING = true;
    };
    // eslint-disable-next-line no-throw-literal
    Array.from($442c6d775904fb5d$var$riter, function() {
        throw 2;
    });
} catch (e) {}
module.exports = function(exec, skipClosing) {
    if (!skipClosing && !$442c6d775904fb5d$var$SAFE_CLOSING) return false;
    var safe = false;
    try {
        var arr = [
            7
        ];
        var iter = arr[$442c6d775904fb5d$var$ITERATOR]();
        iter.next = function() {
            return {
                done: safe = true
            };
        };
        arr[$442c6d775904fb5d$var$ITERATOR] = function() {
            return iter;
        };
        exec(arr);
    } catch (e) {}
    return safe;
};

});

parcelRegister("QCNTE", function(module, exports) {
'use strict';

var $bjnTD = parcelRequire("bjnTD");
module.exports = function(method, arg) {
    return !!method && $bjnTD(function() {
        // eslint-disable-next-line no-useless-call
        arg ? method.call(null, function() {}, 1) : method.call(null);
    });
};

});

parcelRegister("2ikiy", function(module, exports) {
// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex

var $8luNd = parcelRequire("8luNd");

var $9DkTL = parcelRequire("9DkTL");

var $j50QJ = parcelRequire("j50QJ");

var $jsF4z = parcelRequire("jsF4z");

var $8z5mb = parcelRequire("8z5mb");
module.exports = function(TYPE, $create) {
    var IS_MAP = TYPE == 1;
    var IS_FILTER = TYPE == 2;
    var IS_SOME = TYPE == 3;
    var IS_EVERY = TYPE == 4;
    var IS_FIND_INDEX = TYPE == 6;
    var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
    var create = $create || $8z5mb;
    return function($this, callbackfn, that) {
        var O = $j50QJ($this);
        var self = $9DkTL(O);
        var f = $8luNd(callbackfn, that, 3);
        var length = $jsF4z(self.length);
        var index = 0;
        var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
        var val, res;
        for(; length > index; index++)if (NO_HOLES || index in self) {
            val = self[index];
            res = f(val, index, O);
            if (TYPE) {
                if (IS_MAP) result[index] = res; // map
                else if (res) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return val; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        result.push(val); // filter
                }
                else if (IS_EVERY) return false; // every
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
    };
};

});
parcelRegister("8z5mb", function(module, exports) {
// 9.4.2.3 ArraySpeciesCreate(originalArray, length)

var $lFAQH = parcelRequire("lFAQH");
module.exports = function(original, length) {
    return new ($lFAQH(original))(length);
};

});
parcelRegister("lFAQH", function(module, exports) {

var $h9IVq = parcelRequire("h9IVq");

var $6HMRV = parcelRequire("6HMRV");

var $fc6a02c016d4b9ca$var$SPECIES = (parcelRequire("buDDQ"))('species');
module.exports = function(original) {
    var C;
    if ($6HMRV(original)) {
        C = original.constructor;
        // cross-realm fallback
        if (typeof C == 'function' && (C === Array || $6HMRV(C.prototype))) C = undefined;
        if ($h9IVq(C)) {
            C = C[$fc6a02c016d4b9ca$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? Array : C;
};

});



parcelRegister("1sqkh", function(module, exports) {
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
'use strict';

var $j50QJ = parcelRequire("j50QJ");

var $aJr6a = parcelRequire("aJr6a");

var $jsF4z = parcelRequire("jsF4z");
module.exports = [].copyWithin || function copyWithin(target /* = 0 */ , start /* = 0, end = @length */ ) {
    var O = $j50QJ(this);
    var len = $jsF4z(O.length);
    var to = $aJr6a(target, len);
    var from = $aJr6a(start, len);
    var end = arguments.length > 2 ? arguments[2] : undefined;
    var count = Math.min((end === undefined ? len : $aJr6a(end, len)) - from, len - to);
    var inc = 1;
    if (from < to && to < from + count) {
        inc = -1;
        from += count - 1;
        to += count - 1;
    }
    while(count-- > 0){
        if (from in O) O[to] = O[from];
        else delete O[to];
        to += inc;
        from += inc;
    }
    return O;
};

});

parcelRegister("e0GHn", function(module, exports) {
// 22.1.3.31 Array.prototype[@@unscopables]

var $a3322fd1fb607aeb$var$UNSCOPABLES = (parcelRequire("buDDQ"))('unscopables');
var $a3322fd1fb607aeb$var$ArrayProto = Array.prototype;

if ($a3322fd1fb607aeb$var$ArrayProto[$a3322fd1fb607aeb$var$UNSCOPABLES] == undefined) (parcelRequire("5ujtn"))($a3322fd1fb607aeb$var$ArrayProto, $a3322fd1fb607aeb$var$UNSCOPABLES, {});
module.exports = function(key) {
    $a3322fd1fb607aeb$var$ArrayProto[$a3322fd1fb607aeb$var$UNSCOPABLES][key] = true;
};

});

parcelRegister("7iF8D", function(module, exports) {
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
'use strict';

var $j50QJ = parcelRequire("j50QJ");

var $aJr6a = parcelRequire("aJr6a");

var $jsF4z = parcelRequire("jsF4z");
module.exports = function fill(value /* , start = 0, end = @length */ ) {
    var O = $j50QJ(this);
    var length = $jsF4z(O.length);
    var aLen = arguments.length;
    var index = $aJr6a(aLen > 1 ? arguments[1] : undefined, length);
    var end = aLen > 2 ? arguments[2] : undefined;
    var endPos = end === undefined ? length : $aJr6a(end, length);
    while(endPos > index)O[index++] = value;
    return O;
};

});

parcelRegister("4kzAJ", function(module, exports) {
'use strict';

var $1YuiL = parcelRequire("1YuiL");

var $lWhMZ = parcelRequire("lWhMZ");

var $gvOoh = parcelRequire("gvOoh");

var $3274a3683ff72432$var$SPECIES = (parcelRequire("buDDQ"))('species');
module.exports = function(KEY) {
    var C = $1YuiL[KEY];
    if ($gvOoh && C && !C[$3274a3683ff72432$var$SPECIES]) $lWhMZ.f(C, $3274a3683ff72432$var$SPECIES, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};

});

parcelRegister("5Mf7C", function(module, exports) {
'use strict';

var $e0GHn = parcelRequire("e0GHn");

var $1OttB = parcelRequire("1OttB");

var $kfJlH = parcelRequire("kfJlH");

var $15QDc = parcelRequire("15QDc");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = (parcelRequire("eApyU"))(Array, 'Array', function(iterated, kind) {
    this._t = $15QDc(iterated); // target
    this._i = 0; // next index
    this._k = kind; // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var kind = this._k;
    var index = this._i++;
    if (!O || index >= O.length) {
        this._t = undefined;
        return $1OttB(1);
    }
    if (kind == 'keys') return $1OttB(0, index);
    if (kind == 'values') return $1OttB(0, O[index]);
    return $1OttB(0, [
        index,
        O[index]
    ]);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
$kfJlH.Arguments = $kfJlH.Array;
$e0GHn('keys');
$e0GHn('values');
$e0GHn('entries');

});
parcelRegister("1OttB", function(module, exports) {
module.exports = function(done, value) {
    return {
        value: value,
        done: !!done
    };
};

});


parcelRegister("gL7EQ", function(module, exports) {
'use strict';

var $6K5GG = parcelRequire("6K5GG");
module.exports = function() {
    var that = $6K5GG(this);
    var result = '';
    if (that.global) result += 'g';
    if (that.ignoreCase) result += 'i';
    if (that.multiline) result += 'm';
    if (that.unicode) result += 'u';
    if (that.sticky) result += 'y';
    return result;
};

});

parcelRegister("ioyf6", function(module, exports) {
'use strict';
parcelRequire("j7wg2");

var $2D2fi = parcelRequire("2D2fi");

var $5ujtn = parcelRequire("5ujtn");

var $bjnTD = parcelRequire("bjnTD");

var $6g06V = parcelRequire("6g06V");

var $buDDQ = parcelRequire("buDDQ");

var $krJ8T = parcelRequire("krJ8T");
var $d64507bf41eeb152$var$SPECIES = $buDDQ('species');
var $d64507bf41eeb152$var$REPLACE_SUPPORTS_NAMED_GROUPS = !$bjnTD(function() {
    // #replace needs built-in support for named groups.
    // #match works fine because it just return the exec results, even if it has
    // a "grops" property.
    var re = /./;
    re.exec = function() {
        var result = [];
        result.groups = {
            a: '7'
        };
        return result;
    };
    return ''.replace(re, '$<a>') !== '7';
});
var $d64507bf41eeb152$var$SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = function() {
    // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
    var re = /(?:)/;
    var originalExec = re.exec;
    re.exec = function() {
        return originalExec.apply(this, arguments);
    };
    var result = 'ab'.split(re);
    return result.length === 2 && result[0] === 'a' && result[1] === 'b';
}();
module.exports = function(KEY, length, exec) {
    var SYMBOL = $buDDQ(KEY);
    var DELEGATES_TO_SYMBOL = !$bjnTD(function() {
        // String methods call symbol-named RegEp methods
        var O = {};
        O[SYMBOL] = function() {
            return 7;
        };
        return ''[KEY](O) != 7;
    });
    var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !$bjnTD(function() {
        // Symbol-named RegExp methods call .exec
        var execCalled = false;
        var re = /a/;
        re.exec = function() {
            execCalled = true;
            return null;
        };
        if (KEY === 'split') {
            // RegExp[@@split] doesn't call the regex's exec method, but first creates
            // a new one. We need to return the patched regex when creating the new one.
            re.constructor = {};
            re.constructor[$d64507bf41eeb152$var$SPECIES] = function() {
                return re;
            };
        }
        re[SYMBOL]('');
        return !execCalled;
    }) : undefined;
    if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || KEY === 'replace' && !$d64507bf41eeb152$var$REPLACE_SUPPORTS_NAMED_GROUPS || KEY === 'split' && !$d64507bf41eeb152$var$SPLIT_WORKS_WITH_OVERWRITTEN_EXEC) {
        var nativeRegExpMethod = /./[SYMBOL];
        var fns = exec($6g06V, SYMBOL, ''[KEY], function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
            if (regexp.exec === $krJ8T) {
                if (DELEGATES_TO_SYMBOL && !forceStringMethod) // The native String method already delegates to @@method (this
                // polyfilled function), leasing to infinite recursion.
                // We avoid it by directly calling the native @@method method.
                return {
                    done: true,
                    value: nativeRegExpMethod.call(regexp, str, arg2)
                };
                return {
                    done: true,
                    value: nativeMethod.call(str, regexp, arg2)
                };
            }
            return {
                done: false
            };
        });
        var strfn = fns[0];
        var rxfn = fns[1];
        $2D2fi(String.prototype, KEY, strfn);
        $5ujtn(RegExp.prototype, SYMBOL, length == 2 ? function(string, arg) {
            return rxfn.call(string, this, arg);
        } : function(string) {
            return rxfn.call(string, this);
        });
    }
};

});
parcelRegister("j7wg2", function(module, exports) {
'use strict';

var $krJ8T = parcelRequire("krJ8T");

(parcelRequire("eqgBB"))({
    target: 'RegExp',
    proto: true,
    forced: $krJ8T !== /./.exec
}, {
    exec: $krJ8T
});

});
parcelRegister("krJ8T", function(module, exports) {
'use strict';

var $gL7EQ = parcelRequire("gL7EQ");
var $ee29589fe10075e8$var$nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var $ee29589fe10075e8$var$nativeReplace = String.prototype.replace;
var $ee29589fe10075e8$var$patchedExec = $ee29589fe10075e8$var$nativeExec;
var $ee29589fe10075e8$var$LAST_INDEX = 'lastIndex';
var $ee29589fe10075e8$var$UPDATES_LAST_INDEX_WRONG = function() {
    var re1 = /a/, re2 = /b*/g;
    $ee29589fe10075e8$var$nativeExec.call(re1, 'a');
    $ee29589fe10075e8$var$nativeExec.call(re2, 'a');
    return re1[$ee29589fe10075e8$var$LAST_INDEX] !== 0 || re2[$ee29589fe10075e8$var$LAST_INDEX] !== 0;
}();
// nonparticipating capturing group, copied from es5-shim's String#split patch.
var $ee29589fe10075e8$var$NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
var $ee29589fe10075e8$var$PATCH = $ee29589fe10075e8$var$UPDATES_LAST_INDEX_WRONG || $ee29589fe10075e8$var$NPCG_INCLUDED;
if ($ee29589fe10075e8$var$PATCH) $ee29589fe10075e8$var$patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;
    if ($ee29589fe10075e8$var$NPCG_INCLUDED) reCopy = new RegExp('^' + re.source + '$(?!\\s)', $gL7EQ.call(re));
    if ($ee29589fe10075e8$var$UPDATES_LAST_INDEX_WRONG) lastIndex = re[$ee29589fe10075e8$var$LAST_INDEX];
    match = $ee29589fe10075e8$var$nativeExec.call(re, str);
    if ($ee29589fe10075e8$var$UPDATES_LAST_INDEX_WRONG && match) re[$ee29589fe10075e8$var$LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    if ($ee29589fe10075e8$var$NPCG_INCLUDED && match && match.length > 1) // Fix browsers whose `exec` methods don't consistently return `undefined`
    // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
    // eslint-disable-next-line no-loop-func
    $ee29589fe10075e8$var$nativeReplace.call(match[0], reCopy, function() {
        for(i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
    });
    return match;
};
module.exports = $ee29589fe10075e8$var$patchedExec;

});



parcelRegister("hHXyM", function(module, exports) {
// 7.3.20 SpeciesConstructor(O, defaultConstructor)

var $6K5GG = parcelRequire("6K5GG");

var $4VmiN = parcelRequire("4VmiN");

var $ce44a73291f6138b$var$SPECIES = (parcelRequire("buDDQ"))('species');
module.exports = function(O, D) {
    var C = $6K5GG(O).constructor;
    var S;
    return C === undefined || (S = $6K5GG(C)[$ce44a73291f6138b$var$SPECIES]) == undefined ? D : $4VmiN(S);
};

});

parcelRegister("gVepx", function(module, exports) {
module.exports = function(it, Constructor, name, forbiddenField) {
    if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) throw TypeError(name + ': incorrect invocation!');
    return it;
};

});

parcelRegister("hIctV", function(module, exports) {

var $1YuiL = parcelRequire("1YuiL");

var $7L6vC = parcelRequire("7L6vC");
var $ce503a58f556567b$require$macrotask = $7L6vC.set;
var $ce503a58f556567b$var$Observer = $1YuiL.MutationObserver || $1YuiL.WebKitMutationObserver;
var $ce503a58f556567b$var$process = $1YuiL.process;
var $ce503a58f556567b$var$Promise = $1YuiL.Promise;

var $ce503a58f556567b$var$isNode = (parcelRequire("P9d0u"))($ce503a58f556567b$var$process) == 'process';
module.exports = function() {
    var head, last, notify;
    var flush = function() {
        var parent, fn;
        if ($ce503a58f556567b$var$isNode && (parent = $ce503a58f556567b$var$process.domain)) parent.exit();
        while(head){
            fn = head.fn;
            head = head.next;
            try {
                fn();
            } catch (e) {
                if (head) notify();
                else last = undefined;
                throw e;
            }
        }
        last = undefined;
        if (parent) parent.enter();
    };
    // Node.js
    if ($ce503a58f556567b$var$isNode) notify = function() {
        $ce503a58f556567b$var$process.nextTick(flush);
    };
    else if ($ce503a58f556567b$var$Observer && !($1YuiL.navigator && $1YuiL.navigator.standalone)) {
        var toggle = true;
        var node = document.createTextNode('');
        new $ce503a58f556567b$var$Observer(flush).observe(node, {
            characterData: true
        }); // eslint-disable-line no-new
        notify = function() {
            node.data = toggle = !toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if ($ce503a58f556567b$var$Promise && $ce503a58f556567b$var$Promise.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        var promise = $ce503a58f556567b$var$Promise.resolve(undefined);
        notify = function() {
            promise.then(flush);
        };
    // for other environments - macrotask based on:
    // - setImmediate
    // - MessageChannel
    // - window.postMessag
    // - onreadystatechange
    // - setTimeout
    } else notify = function() {
        // strange IE + webpack dev server bug - use .call(global)
        $ce503a58f556567b$require$macrotask.call($1YuiL, flush);
    };
    return function(fn) {
        var task = {
            fn: fn,
            next: undefined
        };
        if (last) last.next = task;
        if (!head) {
            head = task;
            notify();
        }
        last = task;
    };
};

});
parcelRegister("7L6vC", function(module, exports) {

var $8luNd = parcelRequire("8luNd");

var $g66xb = parcelRequire("g66xb");

var $ahTLX = parcelRequire("ahTLX");

var $9Ut4j = parcelRequire("9Ut4j");

var $1YuiL = parcelRequire("1YuiL");
var $5a61f8c20f6a68cd$var$process = $1YuiL.process;
var $5a61f8c20f6a68cd$var$setTask = $1YuiL.setImmediate;
var $5a61f8c20f6a68cd$var$clearTask = $1YuiL.clearImmediate;
var $5a61f8c20f6a68cd$var$MessageChannel = $1YuiL.MessageChannel;
var $5a61f8c20f6a68cd$var$Dispatch = $1YuiL.Dispatch;
var $5a61f8c20f6a68cd$var$counter = 0;
var $5a61f8c20f6a68cd$var$queue = {};
var $5a61f8c20f6a68cd$var$ONREADYSTATECHANGE = 'onreadystatechange';
var $5a61f8c20f6a68cd$var$defer, $5a61f8c20f6a68cd$var$channel, $5a61f8c20f6a68cd$var$port;
var $5a61f8c20f6a68cd$var$run = function() {
    var id = +this;
    // eslint-disable-next-line no-prototype-builtins
    if ($5a61f8c20f6a68cd$var$queue.hasOwnProperty(id)) {
        var fn = $5a61f8c20f6a68cd$var$queue[id];
        delete $5a61f8c20f6a68cd$var$queue[id];
        fn();
    }
};
var $5a61f8c20f6a68cd$var$listener = function(event) {
    $5a61f8c20f6a68cd$var$run.call(event.data);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$5a61f8c20f6a68cd$var$setTask || !$5a61f8c20f6a68cd$var$clearTask) {
    $5a61f8c20f6a68cd$var$setTask = function setImmediate(fn) {
        var args = [];
        var i = 1;
        while(arguments.length > i)args.push(arguments[i++]);
        $5a61f8c20f6a68cd$var$queue[++$5a61f8c20f6a68cd$var$counter] = function() {
            // eslint-disable-next-line no-new-func
            $g66xb(typeof fn == 'function' ? fn : Function(fn), args);
        };
        $5a61f8c20f6a68cd$var$defer($5a61f8c20f6a68cd$var$counter);
        return $5a61f8c20f6a68cd$var$counter;
    };
    $5a61f8c20f6a68cd$var$clearTask = function clearImmediate(id) {
        delete $5a61f8c20f6a68cd$var$queue[id];
    };
    // Node.js 0.8-
    if ((parcelRequire("P9d0u"))($5a61f8c20f6a68cd$var$process) == 'process') $5a61f8c20f6a68cd$var$defer = function(id) {
        $5a61f8c20f6a68cd$var$process.nextTick($8luNd($5a61f8c20f6a68cd$var$run, id, 1));
    };
    else if ($5a61f8c20f6a68cd$var$Dispatch && $5a61f8c20f6a68cd$var$Dispatch.now) $5a61f8c20f6a68cd$var$defer = function(id) {
        $5a61f8c20f6a68cd$var$Dispatch.now($8luNd($5a61f8c20f6a68cd$var$run, id, 1));
    };
    else if ($5a61f8c20f6a68cd$var$MessageChannel) {
        $5a61f8c20f6a68cd$var$channel = new $5a61f8c20f6a68cd$var$MessageChannel();
        $5a61f8c20f6a68cd$var$port = $5a61f8c20f6a68cd$var$channel.port2;
        $5a61f8c20f6a68cd$var$channel.port1.onmessage = $5a61f8c20f6a68cd$var$listener;
        $5a61f8c20f6a68cd$var$defer = $8luNd($5a61f8c20f6a68cd$var$port.postMessage, $5a61f8c20f6a68cd$var$port, 1);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($1YuiL.addEventListener && typeof postMessage == 'function' && !$1YuiL.importScripts) {
        $5a61f8c20f6a68cd$var$defer = function(id) {
            $1YuiL.postMessage(id + '', '*');
        };
        $1YuiL.addEventListener('message', $5a61f8c20f6a68cd$var$listener, false);
    // IE8-
    } else if ($5a61f8c20f6a68cd$var$ONREADYSTATECHANGE in $9Ut4j('script')) $5a61f8c20f6a68cd$var$defer = function(id) {
        $ahTLX.appendChild($9Ut4j('script'))[$5a61f8c20f6a68cd$var$ONREADYSTATECHANGE] = function() {
            $ahTLX.removeChild(this);
            $5a61f8c20f6a68cd$var$run.call(id);
        };
    };
    else $5a61f8c20f6a68cd$var$defer = function(id) {
        setTimeout($8luNd($5a61f8c20f6a68cd$var$run, id, 1), 0);
    };
}
module.exports = {
    set: $5a61f8c20f6a68cd$var$setTask,
    clear: $5a61f8c20f6a68cd$var$clearTask
};

});


parcelRegister("1YB50", function(module, exports) {

var $2D2fi = parcelRequire("2D2fi");
module.exports = function(target, src, safe) {
    for(var key in src)$2D2fi(target, key, src[key], safe);
    return target;
};

});

parcelRegister("chbv3", function(module, exports) {
'use strict';

var $1YuiL = parcelRequire("1YuiL");

var $eqgBB = parcelRequire("eqgBB");

var $2D2fi = parcelRequire("2D2fi");

var $1YB50 = parcelRequire("1YB50");

var $86Fx8 = parcelRequire("86Fx8");

var $gTqEb = parcelRequire("gTqEb");

var $gVepx = parcelRequire("gVepx");

var $h9IVq = parcelRequire("h9IVq");

var $bjnTD = parcelRequire("bjnTD");

var $5QSWt = parcelRequire("5QSWt");

var $k40lc = parcelRequire("k40lc");

var $gozGd = parcelRequire("gozGd");
module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
    var Base = $1YuiL[NAME];
    var C = Base;
    var ADDER = IS_MAP ? 'set' : 'add';
    var proto = C && C.prototype;
    var O = {};
    var fixMethod = function(KEY) {
        var fn = proto[KEY];
        $2D2fi(proto, KEY, KEY == 'delete' ? function(a) {
            return IS_WEAK && !$h9IVq(a) ? false : fn.call(this, a === 0 ? 0 : a);
        } : KEY == 'has' ? function has(a) {
            return IS_WEAK && !$h9IVq(a) ? false : fn.call(this, a === 0 ? 0 : a);
        } : KEY == 'get' ? function get(a) {
            return IS_WEAK && !$h9IVq(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
        } : KEY == 'add' ? function add(a) {
            fn.call(this, a === 0 ? 0 : a);
            return this;
        } : function set(a, b) {
            fn.call(this, a === 0 ? 0 : a, b);
            return this;
        });
    };
    if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !$bjnTD(function() {
        new C().entries().next();
    }))) {
        // create collection constructor
        C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
        $1YB50(C.prototype, methods);
        $86Fx8.NEED = true;
    } else {
        var instance = new C();
        // early implementations not supports chaining
        var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
        // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
        var THROWS_ON_PRIMITIVES = $bjnTD(function() {
            instance.has(1);
        });
        // most early implementations doesn't supports iterables, most modern - not close it correctly
        var ACCEPT_ITERABLES = $5QSWt(function(iter) {
            new C(iter);
        }); // eslint-disable-line no-new
        // for early implementations -0 and +0 not the same
        var BUGGY_ZERO = !IS_WEAK && $bjnTD(function() {
            // V8 ~ Chromium 42- fails only with 5+ elements
            var $instance = new C();
            var index = 5;
            while(index--)$instance[ADDER](index, index);
            return !$instance.has(-0);
        });
        if (!ACCEPT_ITERABLES) {
            C = wrapper(function(target, iterable) {
                $gVepx(target, C, NAME);
                var that = $gozGd(new Base(), target, C);
                if (iterable != undefined) $gTqEb(iterable, IS_MAP, that[ADDER], that);
                return that;
            });
            C.prototype = proto;
            proto.constructor = C;
        }
        if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
            fixMethod('delete');
            fixMethod('has');
            IS_MAP && fixMethod('get');
        }
        if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
        // weak collections should not contains .clear method
        if (IS_WEAK && proto.clear) delete proto.clear;
    }
    $k40lc(C, NAME);
    O[NAME] = C;
    $eqgBB($eqgBB.G + $eqgBB.W + $eqgBB.F * (C != Base), O);
    if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
    return C;
};

});
parcelRegister("86Fx8", function(module, exports) {

var $5e6f19f0561b6cb9$var$META = (parcelRequire("ln3yM"))('meta');

var $h9IVq = parcelRequire("h9IVq");

var $lRu3m = parcelRequire("lRu3m");

var $lWhMZ = parcelRequire("lWhMZ");
var $5e6f19f0561b6cb9$require$setDesc = $lWhMZ.f;
var $5e6f19f0561b6cb9$var$id = 0;
var $5e6f19f0561b6cb9$var$isExtensible = Object.isExtensible || function() {
    return true;
};

var $5e6f19f0561b6cb9$var$FREEZE = !(parcelRequire("bjnTD"))(function() {
    return $5e6f19f0561b6cb9$var$isExtensible(Object.preventExtensions({}));
});
var $5e6f19f0561b6cb9$var$setMeta = function(it) {
    $5e6f19f0561b6cb9$require$setDesc(it, $5e6f19f0561b6cb9$var$META, {
        value: {
            i: 'O' + ++$5e6f19f0561b6cb9$var$id,
            w: {} // weak collections IDs
        }
    });
};
var $5e6f19f0561b6cb9$var$fastKey = function(it, create) {
    // return primitive with prefix
    if (!$h9IVq(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!$lRu3m(it, $5e6f19f0561b6cb9$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$5e6f19f0561b6cb9$var$isExtensible(it)) return 'F';
        // not necessary to add metadata
        if (!create) return 'E';
        // add missing metadata
        $5e6f19f0561b6cb9$var$setMeta(it);
    // return object ID
    }
    return it[$5e6f19f0561b6cb9$var$META].i;
};
var $5e6f19f0561b6cb9$var$getWeak = function(it, create) {
    if (!$lRu3m(it, $5e6f19f0561b6cb9$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$5e6f19f0561b6cb9$var$isExtensible(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $5e6f19f0561b6cb9$var$setMeta(it);
    // return hash weak collections IDs
    }
    return it[$5e6f19f0561b6cb9$var$META].w;
};
// add metadata on freeze-family methods calling
var $5e6f19f0561b6cb9$var$onFreeze = function(it) {
    if ($5e6f19f0561b6cb9$var$FREEZE && $5e6f19f0561b6cb9$var$meta.NEED && $5e6f19f0561b6cb9$var$isExtensible(it) && !$lRu3m(it, $5e6f19f0561b6cb9$var$META)) $5e6f19f0561b6cb9$var$setMeta(it);
    return it;
};
var $5e6f19f0561b6cb9$var$meta = module.exports = {
    KEY: $5e6f19f0561b6cb9$var$META,
    NEED: false,
    fastKey: $5e6f19f0561b6cb9$var$fastKey,
    getWeak: $5e6f19f0561b6cb9$var$getWeak,
    onFreeze: $5e6f19f0561b6cb9$var$onFreeze
};

});

parcelRegister("gTqEb", function(module, exports) {

var $8luNd = parcelRequire("8luNd");

var $a1YsG = parcelRequire("a1YsG");

var $awT0Y = parcelRequire("awT0Y");

var $6K5GG = parcelRequire("6K5GG");

var $jsF4z = parcelRequire("jsF4z");

var $fUVYF = parcelRequire("fUVYF");
var $c4c673f85e923891$var$BREAK = {};
var $c4c673f85e923891$var$RETURN = {};
var $c4c673f85e923891$var$exports = module.exports = function(iterable, entries, fn, that, ITERATOR) {
    var iterFn = ITERATOR ? function() {
        return iterable;
    } : $fUVYF(iterable);
    var f = $8luNd(fn, that, entries ? 2 : 1);
    var index = 0;
    var length, step, iterator, result;
    if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
    // fast case for arrays with default iterator
    if ($awT0Y(iterFn)) for(length = $jsF4z(iterable.length); length > index; index++){
        result = entries ? f($6K5GG(step = iterable[index])[0], step[1]) : f(iterable[index]);
        if (result === $c4c673f85e923891$var$BREAK || result === $c4c673f85e923891$var$RETURN) return result;
    }
    else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done;){
        result = $a1YsG(iterator, f, step.value, entries);
        if (result === $c4c673f85e923891$var$BREAK || result === $c4c673f85e923891$var$RETURN) return result;
    }
};
$c4c673f85e923891$var$exports.BREAK = $c4c673f85e923891$var$BREAK;
$c4c673f85e923891$var$exports.RETURN = $c4c673f85e923891$var$RETURN;

});
parcelRegister("a1YsG", function(module, exports) {
// call something on iterator step with safe closing on error

var $6K5GG = parcelRequire("6K5GG");
module.exports = function(iterator, fn, value, entries) {
    try {
        return entries ? fn($6K5GG(value)[0], value[1]) : fn(value);
    // 7.4.6 IteratorClose(iterator, completion)
    } catch (e) {
        var ret = iterator['return'];
        if (ret !== undefined) $6K5GG(ret.call(iterator));
        throw e;
    }
};

});


parcelRegister("gozGd", function(module, exports) {

var $h9IVq = parcelRequire("h9IVq");

var $iTiy4 = parcelRequire("iTiy4");
var $befa9084421bf431$require$setPrototypeOf = $iTiy4.set;
module.exports = function(that, target, C) {
    var S = target.constructor;
    var P;
    if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && $h9IVq(P) && $befa9084421bf431$require$setPrototypeOf) $befa9084421bf431$require$setPrototypeOf(that, P);
    return that;
};

});


parcelRegister("9dDAH", function(module, exports) {
'use strict';

var $1YuiL = parcelRequire("1YuiL");

var $6b6409e6196663ef$var$each = (parcelRequire("2ikiy"))(0);

var $2D2fi = parcelRequire("2D2fi");

var $86Fx8 = parcelRequire("86Fx8");

var $5cuvo = parcelRequire("5cuvo");

var $5cDUT = parcelRequire("5cDUT");

var $h9IVq = parcelRequire("h9IVq");

var $6PJwo = parcelRequire("6PJwo");

var $6PJwo = parcelRequire("6PJwo");
var $6b6409e6196663ef$var$IS_IE11 = !$1YuiL.ActiveXObject && 'ActiveXObject' in $1YuiL;
var $6b6409e6196663ef$var$WEAK_MAP = 'WeakMap';
var $6b6409e6196663ef$var$getWeak = $86Fx8.getWeak;
var $6b6409e6196663ef$var$isExtensible = Object.isExtensible;
var $6b6409e6196663ef$var$uncaughtFrozenStore = $5cDUT.ufstore;
var $6b6409e6196663ef$var$InternalMap;
var $6b6409e6196663ef$var$wrapper = function(get) {
    return function WeakMap() {
        return get(this, arguments.length > 0 ? arguments[0] : undefined);
    };
};
var $6b6409e6196663ef$var$methods = {
    // 23.3.3.3 WeakMap.prototype.get(key)
    get: function get(key) {
        if ($h9IVq(key)) {
            var data = $6b6409e6196663ef$var$getWeak(key);
            if (data === true) return $6b6409e6196663ef$var$uncaughtFrozenStore($6PJwo(this, $6b6409e6196663ef$var$WEAK_MAP)).get(key);
            return data ? data[this._i] : undefined;
        }
    },
    // 23.3.3.5 WeakMap.prototype.set(key, value)
    set: function set(key, value) {
        return $5cDUT.def($6PJwo(this, $6b6409e6196663ef$var$WEAK_MAP), key, value);
    }
};

// 23.3 WeakMap Objects
var $6b6409e6196663ef$var$$WeakMap = module.exports = (parcelRequire("chbv3"))($6b6409e6196663ef$var$WEAK_MAP, $6b6409e6196663ef$var$wrapper, $6b6409e6196663ef$var$methods, $5cDUT, true, true);
// IE11 WeakMap frozen keys fix
if ($6PJwo && $6b6409e6196663ef$var$IS_IE11) {
    $6b6409e6196663ef$var$InternalMap = $5cDUT.getConstructor($6b6409e6196663ef$var$wrapper, $6b6409e6196663ef$var$WEAK_MAP);
    $5cuvo($6b6409e6196663ef$var$InternalMap.prototype, $6b6409e6196663ef$var$methods);
    $86Fx8.NEED = true;
    $6b6409e6196663ef$var$each([
        'delete',
        'has',
        'get',
        'set'
    ], function(key) {
        var proto = $6b6409e6196663ef$var$$WeakMap.prototype;
        var method = proto[key];
        $2D2fi(proto, key, function(a, b) {
            // store frozen objects on internal weakmap shim
            if ($h9IVq(a) && !$6b6409e6196663ef$var$isExtensible(a)) {
                if (!this._f) this._f = new $6b6409e6196663ef$var$InternalMap();
                var result = this._f[key](a, b);
                return key == 'set' ? this : result;
            // store all the rest on native weakmap
            }
            return method.call(this, a, b);
        });
    });
}

});
parcelRegister("5cDUT", function(module, exports) {
'use strict';

var $1YB50 = parcelRequire("1YB50");

var $86Fx8 = parcelRequire("86Fx8");
var $3c9d095b4fd57395$require$getWeak = $86Fx8.getWeak;

var $6K5GG = parcelRequire("6K5GG");

var $h9IVq = parcelRequire("h9IVq");

var $gVepx = parcelRequire("gVepx");

var $gTqEb = parcelRequire("gTqEb");

var $2ikiy = parcelRequire("2ikiy");

var $lRu3m = parcelRequire("lRu3m");

var $6PJwo = parcelRequire("6PJwo");
var $3c9d095b4fd57395$var$arrayFind = $2ikiy(5);
var $3c9d095b4fd57395$var$arrayFindIndex = $2ikiy(6);
var $3c9d095b4fd57395$var$id = 0;
// fallback for uncaught frozen keys
var $3c9d095b4fd57395$var$uncaughtFrozenStore = function(that) {
    return that._l || (that._l = new $3c9d095b4fd57395$var$UncaughtFrozenStore());
};
var $3c9d095b4fd57395$var$UncaughtFrozenStore = function() {
    this.a = [];
};
var $3c9d095b4fd57395$var$findUncaughtFrozen = function(store, key) {
    return $3c9d095b4fd57395$var$arrayFind(store.a, function(it) {
        return it[0] === key;
    });
};
$3c9d095b4fd57395$var$UncaughtFrozenStore.prototype = {
    get: function(key) {
        var entry = $3c9d095b4fd57395$var$findUncaughtFrozen(this, key);
        if (entry) return entry[1];
    },
    has: function(key) {
        return !!$3c9d095b4fd57395$var$findUncaughtFrozen(this, key);
    },
    set: function(key, value) {
        var entry = $3c9d095b4fd57395$var$findUncaughtFrozen(this, key);
        if (entry) entry[1] = value;
        else this.a.push([
            key,
            value
        ]);
    },
    'delete': function(key) {
        var index = $3c9d095b4fd57395$var$arrayFindIndex(this.a, function(it) {
            return it[0] === key;
        });
        if (~index) this.a.splice(index, 1);
        return !!~index;
    }
};
module.exports = {
    getConstructor: function(wrapper, NAME, IS_MAP, ADDER) {
        var C = wrapper(function(that, iterable) {
            $gVepx(that, C, NAME, '_i');
            that._t = NAME; // collection type
            that._i = $3c9d095b4fd57395$var$id++; // collection id
            that._l = undefined; // leak store for uncaught frozen objects
            if (iterable != undefined) $gTqEb(iterable, IS_MAP, that[ADDER], that);
        });
        $1YB50(C.prototype, {
            // 23.3.3.2 WeakMap.prototype.delete(key)
            // 23.4.3.3 WeakSet.prototype.delete(value)
            'delete': function(key) {
                if (!$h9IVq(key)) return false;
                var data = $3c9d095b4fd57395$require$getWeak(key);
                if (data === true) return $3c9d095b4fd57395$var$uncaughtFrozenStore($6PJwo(this, NAME))['delete'](key);
                return data && $lRu3m(data, this._i) && delete data[this._i];
            },
            // 23.3.3.4 WeakMap.prototype.has(key)
            // 23.4.3.4 WeakSet.prototype.has(value)
            has: function has(key) {
                if (!$h9IVq(key)) return false;
                var data = $3c9d095b4fd57395$require$getWeak(key);
                if (data === true) return $3c9d095b4fd57395$var$uncaughtFrozenStore($6PJwo(this, NAME)).has(key);
                return data && $lRu3m(data, this._i);
            }
        });
        return C;
    },
    def: function(that, key, value) {
        var data = $3c9d095b4fd57395$require$getWeak($6K5GG(key), true);
        if (data === true) $3c9d095b4fd57395$var$uncaughtFrozenStore(that).set(key, value);
        else data[that._i] = value;
        return that;
    },
    ufstore: $3c9d095b4fd57395$var$uncaughtFrozenStore
};

});
parcelRegister("6PJwo", function(module, exports) {

var $h9IVq = parcelRequire("h9IVq");
module.exports = function(it, TYPE) {
    if (!$h9IVq(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
    return it;
};

});



parcelRegister("hI4KF", function(module, exports) {

var $1YuiL = parcelRequire("1YuiL");

var $5ujtn = parcelRequire("5ujtn");

var $ln3yM = parcelRequire("ln3yM");
var $ce4a3b5710b412f0$var$TYPED = $ln3yM('typed_array');
var $ce4a3b5710b412f0$var$VIEW = $ln3yM('view');
var $ce4a3b5710b412f0$var$ABV = !!($1YuiL.ArrayBuffer && $1YuiL.DataView);
var $ce4a3b5710b412f0$var$CONSTR = $ce4a3b5710b412f0$var$ABV;
var $ce4a3b5710b412f0$var$i = 0;
var $ce4a3b5710b412f0$var$l = 9;
var $ce4a3b5710b412f0$var$Typed;
var $ce4a3b5710b412f0$var$TypedArrayConstructors = 'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'.split(',');
while($ce4a3b5710b412f0$var$i < $ce4a3b5710b412f0$var$l)if ($ce4a3b5710b412f0$var$Typed = $1YuiL[$ce4a3b5710b412f0$var$TypedArrayConstructors[$ce4a3b5710b412f0$var$i++]]) {
    $5ujtn($ce4a3b5710b412f0$var$Typed.prototype, $ce4a3b5710b412f0$var$TYPED, true);
    $5ujtn($ce4a3b5710b412f0$var$Typed.prototype, $ce4a3b5710b412f0$var$VIEW, true);
} else $ce4a3b5710b412f0$var$CONSTR = false;
module.exports = {
    ABV: $ce4a3b5710b412f0$var$ABV,
    CONSTR: $ce4a3b5710b412f0$var$CONSTR,
    TYPED: $ce4a3b5710b412f0$var$TYPED,
    VIEW: $ce4a3b5710b412f0$var$VIEW
};

});

parcelRegister("3LpdK", function(module, exports) {
'use strict';

var $1YuiL = parcelRequire("1YuiL");

var $gvOoh = parcelRequire("gvOoh");

var $aNvO0 = parcelRequire("aNvO0");

var $hI4KF = parcelRequire("hI4KF");

var $5ujtn = parcelRequire("5ujtn");

var $1YB50 = parcelRequire("1YB50");

var $bjnTD = parcelRequire("bjnTD");

var $gVepx = parcelRequire("gVepx");

var $dAqin = parcelRequire("dAqin");

var $jsF4z = parcelRequire("jsF4z");

var $9UZy5 = parcelRequire("9UZy5");

var $ivFzP = parcelRequire("ivFzP");
var $2bd953308969d884$require$gOPN = $ivFzP.f;

var $lWhMZ = parcelRequire("lWhMZ");
var $2bd953308969d884$require$dP = $lWhMZ.f;

var $7iF8D = parcelRequire("7iF8D");

var $k40lc = parcelRequire("k40lc");
var $2bd953308969d884$var$ARRAY_BUFFER = 'ArrayBuffer';
var $2bd953308969d884$var$DATA_VIEW = 'DataView';
var $2bd953308969d884$var$PROTOTYPE = 'prototype';
var $2bd953308969d884$var$WRONG_LENGTH = 'Wrong length!';
var $2bd953308969d884$var$WRONG_INDEX = 'Wrong index!';
var $2bd953308969d884$var$$ArrayBuffer = $1YuiL[$2bd953308969d884$var$ARRAY_BUFFER];
var $2bd953308969d884$var$$DataView = $1YuiL[$2bd953308969d884$var$DATA_VIEW];
var $2bd953308969d884$var$Math = $1YuiL.Math;
var $2bd953308969d884$var$RangeError = $1YuiL.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var $2bd953308969d884$var$Infinity1 = $1YuiL.Infinity;
var $2bd953308969d884$var$BaseBuffer = $2bd953308969d884$var$$ArrayBuffer;
var $2bd953308969d884$var$abs = $2bd953308969d884$var$Math.abs;
var $2bd953308969d884$var$pow = $2bd953308969d884$var$Math.pow;
var $2bd953308969d884$var$floor = $2bd953308969d884$var$Math.floor;
var $2bd953308969d884$var$log = $2bd953308969d884$var$Math.log;
var $2bd953308969d884$var$LN2 = $2bd953308969d884$var$Math.LN2;
var $2bd953308969d884$var$BUFFER = 'buffer';
var $2bd953308969d884$var$BYTE_LENGTH = 'byteLength';
var $2bd953308969d884$var$BYTE_OFFSET = 'byteOffset';
var $2bd953308969d884$var$$BUFFER = $gvOoh ? '_b' : $2bd953308969d884$var$BUFFER;
var $2bd953308969d884$var$$LENGTH = $gvOoh ? '_l' : $2bd953308969d884$var$BYTE_LENGTH;
var $2bd953308969d884$var$$OFFSET = $gvOoh ? '_o' : $2bd953308969d884$var$BYTE_OFFSET;
// IEEE754 conversions based on https://github.com/feross/ieee754
function $2bd953308969d884$var$packIEEE754(value, mLen, nBytes) {
    var buffer = new Array(nBytes);
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? $2bd953308969d884$var$pow(2, -24) - $2bd953308969d884$var$pow(2, -77) : 0;
    var i = 0;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    var e, m, c;
    value = $2bd953308969d884$var$abs(value);
    // eslint-disable-next-line no-self-compare
    if (value != value || value === Infinity) {
        // eslint-disable-next-line no-self-compare
        m = value != value ? 1 : 0;
        e = eMax;
    } else {
        e = $2bd953308969d884$var$floor($2bd953308969d884$var$log(value) / $2bd953308969d884$var$LN2);
        if (value * (c = $2bd953308969d884$var$pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * $2bd953308969d884$var$pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * $2bd953308969d884$var$pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * $2bd953308969d884$var$pow(2, eBias - 1) * $2bd953308969d884$var$pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
    buffer[--i] |= s * 128;
    return buffer;
}
function $2bd953308969d884$var$unpackIEEE754(buffer, mLen, nBytes) {
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = eLen - 7;
    var i = nBytes - 1;
    var s = buffer[i--];
    var e = s & 127;
    var m;
    s >>= 7;
    for(; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : s ? -Infinity : Infinity;
    else {
        m = m + $2bd953308969d884$var$pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * $2bd953308969d884$var$pow(2, e - mLen);
}
function $2bd953308969d884$var$unpackI32(bytes) {
    return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function $2bd953308969d884$var$packI8(it) {
    return [
        it & 0xff
    ];
}
function $2bd953308969d884$var$packI16(it) {
    return [
        it & 0xff,
        it >> 8 & 0xff
    ];
}
function $2bd953308969d884$var$packI32(it) {
    return [
        it & 0xff,
        it >> 8 & 0xff,
        it >> 16 & 0xff,
        it >> 24 & 0xff
    ];
}
function $2bd953308969d884$var$packF64(it) {
    return $2bd953308969d884$var$packIEEE754(it, 52, 8);
}
function $2bd953308969d884$var$packF32(it) {
    return $2bd953308969d884$var$packIEEE754(it, 23, 4);
}
function $2bd953308969d884$var$addGetter(C, key, internal) {
    $2bd953308969d884$require$dP(C[$2bd953308969d884$var$PROTOTYPE], key, {
        get: function() {
            return this[internal];
        }
    });
}
function $2bd953308969d884$var$get(view, bytes, index, isLittleEndian) {
    var numIndex = +index;
    var intIndex = $9UZy5(numIndex);
    if (intIndex + bytes > view[$2bd953308969d884$var$$LENGTH]) throw $2bd953308969d884$var$RangeError($2bd953308969d884$var$WRONG_INDEX);
    var store = view[$2bd953308969d884$var$$BUFFER]._b;
    var start = intIndex + view[$2bd953308969d884$var$$OFFSET];
    var pack = store.slice(start, start + bytes);
    return isLittleEndian ? pack : pack.reverse();
}
function $2bd953308969d884$var$set(view, bytes, index, conversion, value, isLittleEndian) {
    var numIndex = +index;
    var intIndex = $9UZy5(numIndex);
    if (intIndex + bytes > view[$2bd953308969d884$var$$LENGTH]) throw $2bd953308969d884$var$RangeError($2bd953308969d884$var$WRONG_INDEX);
    var store = view[$2bd953308969d884$var$$BUFFER]._b;
    var start = intIndex + view[$2bd953308969d884$var$$OFFSET];
    var pack = conversion(+value);
    for(var i = 0; i < bytes; i++)store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}
if (!$hI4KF.ABV) {
    $2bd953308969d884$var$$ArrayBuffer = function ArrayBuffer(length) {
        $gVepx(this, $2bd953308969d884$var$$ArrayBuffer, $2bd953308969d884$var$ARRAY_BUFFER);
        var byteLength = $9UZy5(length);
        this._b = $7iF8D.call(new Array(byteLength), 0);
        this[$2bd953308969d884$var$$LENGTH] = byteLength;
    };
    $2bd953308969d884$var$$DataView = function DataView(buffer, byteOffset, byteLength) {
        $gVepx(this, $2bd953308969d884$var$$DataView, $2bd953308969d884$var$DATA_VIEW);
        $gVepx(buffer, $2bd953308969d884$var$$ArrayBuffer, $2bd953308969d884$var$DATA_VIEW);
        var bufferLength = buffer[$2bd953308969d884$var$$LENGTH];
        var offset = $dAqin(byteOffset);
        if (offset < 0 || offset > bufferLength) throw $2bd953308969d884$var$RangeError('Wrong offset!');
        byteLength = byteLength === undefined ? bufferLength - offset : $jsF4z(byteLength);
        if (offset + byteLength > bufferLength) throw $2bd953308969d884$var$RangeError($2bd953308969d884$var$WRONG_LENGTH);
        this[$2bd953308969d884$var$$BUFFER] = buffer;
        this[$2bd953308969d884$var$$OFFSET] = offset;
        this[$2bd953308969d884$var$$LENGTH] = byteLength;
    };
    if ($gvOoh) {
        $2bd953308969d884$var$addGetter($2bd953308969d884$var$$ArrayBuffer, $2bd953308969d884$var$BYTE_LENGTH, '_l');
        $2bd953308969d884$var$addGetter($2bd953308969d884$var$$DataView, $2bd953308969d884$var$BUFFER, '_b');
        $2bd953308969d884$var$addGetter($2bd953308969d884$var$$DataView, $2bd953308969d884$var$BYTE_LENGTH, '_l');
        $2bd953308969d884$var$addGetter($2bd953308969d884$var$$DataView, $2bd953308969d884$var$BYTE_OFFSET, '_o');
    }
    $1YB50($2bd953308969d884$var$$DataView[$2bd953308969d884$var$PROTOTYPE], {
        getInt8: function getInt8(byteOffset) {
            return $2bd953308969d884$var$get(this, 1, byteOffset)[0] << 24 >> 24;
        },
        getUint8: function getUint8(byteOffset) {
            return $2bd953308969d884$var$get(this, 1, byteOffset)[0];
        },
        getInt16: function getInt16(byteOffset /* , littleEndian */ ) {
            var bytes = $2bd953308969d884$var$get(this, 2, byteOffset, arguments[1]);
            return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
        },
        getUint16: function getUint16(byteOffset /* , littleEndian */ ) {
            var bytes = $2bd953308969d884$var$get(this, 2, byteOffset, arguments[1]);
            return bytes[1] << 8 | bytes[0];
        },
        getInt32: function getInt32(byteOffset /* , littleEndian */ ) {
            return $2bd953308969d884$var$unpackI32($2bd953308969d884$var$get(this, 4, byteOffset, arguments[1]));
        },
        getUint32: function getUint32(byteOffset /* , littleEndian */ ) {
            return $2bd953308969d884$var$unpackI32($2bd953308969d884$var$get(this, 4, byteOffset, arguments[1])) >>> 0;
        },
        getFloat32: function getFloat32(byteOffset /* , littleEndian */ ) {
            return $2bd953308969d884$var$unpackIEEE754($2bd953308969d884$var$get(this, 4, byteOffset, arguments[1]), 23, 4);
        },
        getFloat64: function getFloat64(byteOffset /* , littleEndian */ ) {
            return $2bd953308969d884$var$unpackIEEE754($2bd953308969d884$var$get(this, 8, byteOffset, arguments[1]), 52, 8);
        },
        setInt8: function setInt8(byteOffset, value) {
            $2bd953308969d884$var$set(this, 1, byteOffset, $2bd953308969d884$var$packI8, value);
        },
        setUint8: function setUint8(byteOffset, value) {
            $2bd953308969d884$var$set(this, 1, byteOffset, $2bd953308969d884$var$packI8, value);
        },
        setInt16: function setInt16(byteOffset, value /* , littleEndian */ ) {
            $2bd953308969d884$var$set(this, 2, byteOffset, $2bd953308969d884$var$packI16, value, arguments[2]);
        },
        setUint16: function setUint16(byteOffset, value /* , littleEndian */ ) {
            $2bd953308969d884$var$set(this, 2, byteOffset, $2bd953308969d884$var$packI16, value, arguments[2]);
        },
        setInt32: function setInt32(byteOffset, value /* , littleEndian */ ) {
            $2bd953308969d884$var$set(this, 4, byteOffset, $2bd953308969d884$var$packI32, value, arguments[2]);
        },
        setUint32: function setUint32(byteOffset, value /* , littleEndian */ ) {
            $2bd953308969d884$var$set(this, 4, byteOffset, $2bd953308969d884$var$packI32, value, arguments[2]);
        },
        setFloat32: function setFloat32(byteOffset, value /* , littleEndian */ ) {
            $2bd953308969d884$var$set(this, 4, byteOffset, $2bd953308969d884$var$packF32, value, arguments[2]);
        },
        setFloat64: function setFloat64(byteOffset, value /* , littleEndian */ ) {
            $2bd953308969d884$var$set(this, 8, byteOffset, $2bd953308969d884$var$packF64, value, arguments[2]);
        }
    });
} else {
    if (!$bjnTD(function() {
        $2bd953308969d884$var$$ArrayBuffer(1);
    }) || !$bjnTD(function() {
        new $2bd953308969d884$var$$ArrayBuffer(-1); // eslint-disable-line no-new
    }) || $bjnTD(function() {
        new $2bd953308969d884$var$$ArrayBuffer(); // eslint-disable-line no-new
        new $2bd953308969d884$var$$ArrayBuffer(1.5); // eslint-disable-line no-new
        new $2bd953308969d884$var$$ArrayBuffer(NaN); // eslint-disable-line no-new
        return $2bd953308969d884$var$$ArrayBuffer.name != $2bd953308969d884$var$ARRAY_BUFFER;
    })) {
        $2bd953308969d884$var$$ArrayBuffer = function ArrayBuffer(length) {
            $gVepx(this, $2bd953308969d884$var$$ArrayBuffer);
            return new $2bd953308969d884$var$BaseBuffer($9UZy5(length));
        };
        var $2bd953308969d884$var$ArrayBufferProto = $2bd953308969d884$var$$ArrayBuffer[$2bd953308969d884$var$PROTOTYPE] = $2bd953308969d884$var$BaseBuffer[$2bd953308969d884$var$PROTOTYPE];
        for(var $2bd953308969d884$var$keys = $2bd953308969d884$require$gOPN($2bd953308969d884$var$BaseBuffer), $2bd953308969d884$var$j = 0, $2bd953308969d884$var$key; $2bd953308969d884$var$keys.length > $2bd953308969d884$var$j;)if (!(($2bd953308969d884$var$key = $2bd953308969d884$var$keys[$2bd953308969d884$var$j++]) in $2bd953308969d884$var$$ArrayBuffer)) $5ujtn($2bd953308969d884$var$$ArrayBuffer, $2bd953308969d884$var$key, $2bd953308969d884$var$BaseBuffer[$2bd953308969d884$var$key]);
        if (!$aNvO0) $2bd953308969d884$var$ArrayBufferProto.constructor = $2bd953308969d884$var$$ArrayBuffer;
    }
    // iOS Safari 7.x bug
    var $2bd953308969d884$var$view = new $2bd953308969d884$var$$DataView(new $2bd953308969d884$var$$ArrayBuffer(2));
    var $2bd953308969d884$var$$setInt8 = $2bd953308969d884$var$$DataView[$2bd953308969d884$var$PROTOTYPE].setInt8;
    $2bd953308969d884$var$view.setInt8(0, 2147483648);
    $2bd953308969d884$var$view.setInt8(1, 2147483649);
    if ($2bd953308969d884$var$view.getInt8(0) || !$2bd953308969d884$var$view.getInt8(1)) $1YB50($2bd953308969d884$var$$DataView[$2bd953308969d884$var$PROTOTYPE], {
        setInt8: function setInt8(byteOffset, value) {
            $2bd953308969d884$var$$setInt8.call(this, byteOffset, value << 24 >> 24);
        },
        setUint8: function setUint8(byteOffset, value) {
            $2bd953308969d884$var$$setInt8.call(this, byteOffset, value << 24 >> 24);
        }
    }, true);
}
$k40lc($2bd953308969d884$var$$ArrayBuffer, $2bd953308969d884$var$ARRAY_BUFFER);
$k40lc($2bd953308969d884$var$$DataView, $2bd953308969d884$var$DATA_VIEW);
$5ujtn($2bd953308969d884$var$$DataView[$2bd953308969d884$var$PROTOTYPE], $hI4KF.VIEW, true);
module.exports[$2bd953308969d884$var$ARRAY_BUFFER] = $2bd953308969d884$var$$ArrayBuffer;
module.exports[$2bd953308969d884$var$DATA_VIEW] = $2bd953308969d884$var$$DataView;

});
parcelRegister("9UZy5", function(module, exports) {
// https://tc39.github.io/ecma262/#sec-toindex

var $dAqin = parcelRequire("dAqin");

var $jsF4z = parcelRequire("jsF4z");
module.exports = function(it) {
    if (it === undefined) return 0;
    var number = $dAqin(it);
    var length = $jsF4z(number);
    if (number !== length) throw RangeError('Wrong length!');
    return length;
};

});


parcelRegister("6JNHC", function(module, exports) {
'use strict';







































if ((parcelRequire("gvOoh"))) {
    var $4e7d7febd98d159a$var$LIBRARY = (parcelRequire("aNvO0"));
    var $4e7d7febd98d159a$var$global = (parcelRequire("1YuiL"));
    var $4e7d7febd98d159a$var$fails = (parcelRequire("bjnTD"));
    var $4e7d7febd98d159a$var$$export = (parcelRequire("eqgBB"));
    var $4e7d7febd98d159a$var$$typed = (parcelRequire("hI4KF"));
    var $4e7d7febd98d159a$var$$buffer = (parcelRequire("3LpdK"));
    var $4e7d7febd98d159a$var$ctx = (parcelRequire("8luNd"));
    var $4e7d7febd98d159a$var$anInstance = (parcelRequire("gVepx"));
    var $4e7d7febd98d159a$var$propertyDesc = (parcelRequire("8tLmk"));
    var $4e7d7febd98d159a$var$hide = (parcelRequire("5ujtn"));
    var $4e7d7febd98d159a$var$redefineAll = (parcelRequire("1YB50"));
    var $4e7d7febd98d159a$var$toInteger = (parcelRequire("dAqin"));
    var $4e7d7febd98d159a$var$toLength = (parcelRequire("jsF4z"));
    var $4e7d7febd98d159a$var$toIndex = (parcelRequire("9UZy5"));
    var $4e7d7febd98d159a$var$toAbsoluteIndex = (parcelRequire("aJr6a"));
    var $4e7d7febd98d159a$var$toPrimitive = (parcelRequire("9a73R"));
    var $4e7d7febd98d159a$var$has = (parcelRequire("lRu3m"));
    var $4e7d7febd98d159a$var$classof = (parcelRequire("47rfI"));
    var $4e7d7febd98d159a$var$isObject = (parcelRequire("h9IVq"));
    var $4e7d7febd98d159a$var$toObject = (parcelRequire("j50QJ"));
    var $4e7d7febd98d159a$var$isArrayIter = (parcelRequire("awT0Y"));
    var $4e7d7febd98d159a$var$create = (parcelRequire("16E7l"));
    var $4e7d7febd98d159a$var$getPrototypeOf = (parcelRequire("9nGSz"));
    var $4e7d7febd98d159a$var$gOPN = (parcelRequire("ivFzP")).f;
    var $4e7d7febd98d159a$var$getIterFn = (parcelRequire("fUVYF"));
    var $4e7d7febd98d159a$var$uid = (parcelRequire("ln3yM"));
    var $4e7d7febd98d159a$var$wks = (parcelRequire("buDDQ"));
    var $4e7d7febd98d159a$var$createArrayMethod = (parcelRequire("2ikiy"));
    var $4e7d7febd98d159a$var$createArrayIncludes = (parcelRequire("hKLZ1"));
    var $4e7d7febd98d159a$var$speciesConstructor = (parcelRequire("hHXyM"));
    var $4e7d7febd98d159a$var$ArrayIterators = (parcelRequire("5Mf7C"));
    var $4e7d7febd98d159a$var$Iterators = (parcelRequire("kfJlH"));
    var $4e7d7febd98d159a$var$$iterDetect = (parcelRequire("5QSWt"));
    var $4e7d7febd98d159a$var$setSpecies = (parcelRequire("4kzAJ"));
    var $4e7d7febd98d159a$var$arrayFill = (parcelRequire("7iF8D"));
    var $4e7d7febd98d159a$var$arrayCopyWithin = (parcelRequire("1sqkh"));
    var $4e7d7febd98d159a$var$$DP = (parcelRequire("lWhMZ"));
    var $4e7d7febd98d159a$var$$GOPD = (parcelRequire("5yOh2"));
    var $4e7d7febd98d159a$var$dP = $4e7d7febd98d159a$var$$DP.f;
    var $4e7d7febd98d159a$var$gOPD = $4e7d7febd98d159a$var$$GOPD.f;
    var $4e7d7febd98d159a$var$RangeError = $4e7d7febd98d159a$var$global.RangeError;
    var $4e7d7febd98d159a$var$TypeError = $4e7d7febd98d159a$var$global.TypeError;
    var $4e7d7febd98d159a$var$Uint8Array = $4e7d7febd98d159a$var$global.Uint8Array;
    var $4e7d7febd98d159a$var$ARRAY_BUFFER = 'ArrayBuffer';
    var $4e7d7febd98d159a$var$SHARED_BUFFER = 'Shared' + $4e7d7febd98d159a$var$ARRAY_BUFFER;
    var $4e7d7febd98d159a$var$BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
    var $4e7d7febd98d159a$var$PROTOTYPE = 'prototype';
    var $4e7d7febd98d159a$var$ArrayProto = Array[$4e7d7febd98d159a$var$PROTOTYPE];
    var $4e7d7febd98d159a$var$$ArrayBuffer = $4e7d7febd98d159a$var$$buffer.ArrayBuffer;
    var $4e7d7febd98d159a$var$$DataView = $4e7d7febd98d159a$var$$buffer.DataView;
    var $4e7d7febd98d159a$var$arrayForEach = $4e7d7febd98d159a$var$createArrayMethod(0);
    var $4e7d7febd98d159a$var$arrayFilter = $4e7d7febd98d159a$var$createArrayMethod(2);
    var $4e7d7febd98d159a$var$arraySome = $4e7d7febd98d159a$var$createArrayMethod(3);
    var $4e7d7febd98d159a$var$arrayEvery = $4e7d7febd98d159a$var$createArrayMethod(4);
    var $4e7d7febd98d159a$var$arrayFind = $4e7d7febd98d159a$var$createArrayMethod(5);
    var $4e7d7febd98d159a$var$arrayFindIndex = $4e7d7febd98d159a$var$createArrayMethod(6);
    var $4e7d7febd98d159a$var$arrayIncludes = $4e7d7febd98d159a$var$createArrayIncludes(true);
    var $4e7d7febd98d159a$var$arrayIndexOf = $4e7d7febd98d159a$var$createArrayIncludes(false);
    var $4e7d7febd98d159a$var$arrayValues = $4e7d7febd98d159a$var$ArrayIterators.values;
    var $4e7d7febd98d159a$var$arrayKeys = $4e7d7febd98d159a$var$ArrayIterators.keys;
    var $4e7d7febd98d159a$var$arrayEntries = $4e7d7febd98d159a$var$ArrayIterators.entries;
    var $4e7d7febd98d159a$var$arrayLastIndexOf = $4e7d7febd98d159a$var$ArrayProto.lastIndexOf;
    var $4e7d7febd98d159a$var$arrayReduce = $4e7d7febd98d159a$var$ArrayProto.reduce;
    var $4e7d7febd98d159a$var$arrayReduceRight = $4e7d7febd98d159a$var$ArrayProto.reduceRight;
    var $4e7d7febd98d159a$var$arrayJoin = $4e7d7febd98d159a$var$ArrayProto.join;
    var $4e7d7febd98d159a$var$arraySort = $4e7d7febd98d159a$var$ArrayProto.sort;
    var $4e7d7febd98d159a$var$arraySlice = $4e7d7febd98d159a$var$ArrayProto.slice;
    var $4e7d7febd98d159a$var$arrayToString = $4e7d7febd98d159a$var$ArrayProto.toString;
    var $4e7d7febd98d159a$var$arrayToLocaleString = $4e7d7febd98d159a$var$ArrayProto.toLocaleString;
    var $4e7d7febd98d159a$var$ITERATOR = $4e7d7febd98d159a$var$wks('iterator');
    var $4e7d7febd98d159a$var$TAG = $4e7d7febd98d159a$var$wks('toStringTag');
    var $4e7d7febd98d159a$var$TYPED_CONSTRUCTOR = $4e7d7febd98d159a$var$uid('typed_constructor');
    var $4e7d7febd98d159a$var$DEF_CONSTRUCTOR = $4e7d7febd98d159a$var$uid('def_constructor');
    var $4e7d7febd98d159a$var$ALL_CONSTRUCTORS = $4e7d7febd98d159a$var$$typed.CONSTR;
    var $4e7d7febd98d159a$var$TYPED_ARRAY = $4e7d7febd98d159a$var$$typed.TYPED;
    var $4e7d7febd98d159a$var$VIEW = $4e7d7febd98d159a$var$$typed.VIEW;
    var $4e7d7febd98d159a$var$WRONG_LENGTH = 'Wrong length!';
    var $4e7d7febd98d159a$var$$map = $4e7d7febd98d159a$var$createArrayMethod(1, function(O, length) {
        return $4e7d7febd98d159a$var$allocate($4e7d7febd98d159a$var$speciesConstructor(O, O[$4e7d7febd98d159a$var$DEF_CONSTRUCTOR]), length);
    });
    var $4e7d7febd98d159a$var$LITTLE_ENDIAN = $4e7d7febd98d159a$var$fails(function() {
        // eslint-disable-next-line no-undef
        return new $4e7d7febd98d159a$var$Uint8Array(new Uint16Array([
            1
        ]).buffer)[0] === 1;
    });
    var $4e7d7febd98d159a$var$FORCED_SET = !!$4e7d7febd98d159a$var$Uint8Array && !!$4e7d7febd98d159a$var$Uint8Array[$4e7d7febd98d159a$var$PROTOTYPE].set && $4e7d7febd98d159a$var$fails(function() {
        new $4e7d7febd98d159a$var$Uint8Array(1).set({});
    });
    var $4e7d7febd98d159a$var$toOffset = function(it, BYTES) {
        var offset = $4e7d7febd98d159a$var$toInteger(it);
        if (offset < 0 || offset % BYTES) throw $4e7d7febd98d159a$var$RangeError('Wrong offset!');
        return offset;
    };
    var $4e7d7febd98d159a$var$validate = function(it) {
        if ($4e7d7febd98d159a$var$isObject(it) && $4e7d7febd98d159a$var$TYPED_ARRAY in it) return it;
        throw $4e7d7febd98d159a$var$TypeError(it + ' is not a typed array!');
    };
    var $4e7d7febd98d159a$var$allocate = function(C, length) {
        if (!($4e7d7febd98d159a$var$isObject(C) && $4e7d7febd98d159a$var$TYPED_CONSTRUCTOR in C)) throw $4e7d7febd98d159a$var$TypeError('It is not a typed array constructor!');
        return new C(length);
    };
    var $4e7d7febd98d159a$var$speciesFromList = function(O, list) {
        return $4e7d7febd98d159a$var$fromList($4e7d7febd98d159a$var$speciesConstructor(O, O[$4e7d7febd98d159a$var$DEF_CONSTRUCTOR]), list);
    };
    var $4e7d7febd98d159a$var$fromList = function(C, list) {
        var index = 0;
        var length = list.length;
        var result = $4e7d7febd98d159a$var$allocate(C, length);
        while(length > index)result[index] = list[index++];
        return result;
    };
    var $4e7d7febd98d159a$var$addGetter = function(it, key, internal) {
        $4e7d7febd98d159a$var$dP(it, key, {
            get: function() {
                return this._d[internal];
            }
        });
    };
    var $4e7d7febd98d159a$var$$from = function from(source /* , mapfn, thisArg */ ) {
        var O = $4e7d7febd98d159a$var$toObject(source);
        var aLen = arguments.length;
        var mapfn = aLen > 1 ? arguments[1] : undefined;
        var mapping = mapfn !== undefined;
        var iterFn = $4e7d7febd98d159a$var$getIterFn(O);
        var i, length, values, result, step, iterator;
        if (iterFn != undefined && !$4e7d7febd98d159a$var$isArrayIter(iterFn)) {
            for(iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++)values.push(step.value);
            O = values;
        }
        if (mapping && aLen > 2) mapfn = $4e7d7febd98d159a$var$ctx(mapfn, arguments[2], 2);
        for(i = 0, length = $4e7d7febd98d159a$var$toLength(O.length), result = $4e7d7febd98d159a$var$allocate(this, length); length > i; i++)result[i] = mapping ? mapfn(O[i], i) : O[i];
        return result;
    };
    var $4e7d7febd98d159a$var$$of = function of() {
        var index = 0;
        var length = arguments.length;
        var result = $4e7d7febd98d159a$var$allocate(this, length);
        while(length > index)result[index] = arguments[index++];
        return result;
    };
    // iOS Safari 6.x fails here
    var $4e7d7febd98d159a$var$TO_LOCALE_BUG = !!$4e7d7febd98d159a$var$Uint8Array && $4e7d7febd98d159a$var$fails(function() {
        $4e7d7febd98d159a$var$arrayToLocaleString.call(new $4e7d7febd98d159a$var$Uint8Array(1));
    });
    var $4e7d7febd98d159a$var$$toLocaleString = function toLocaleString() {
        return $4e7d7febd98d159a$var$arrayToLocaleString.apply($4e7d7febd98d159a$var$TO_LOCALE_BUG ? $4e7d7febd98d159a$var$arraySlice.call($4e7d7febd98d159a$var$validate(this)) : $4e7d7febd98d159a$var$validate(this), arguments);
    };
    var $4e7d7febd98d159a$var$proto = {
        copyWithin: function copyWithin(target, start /* , end */ ) {
            return $4e7d7febd98d159a$var$arrayCopyWithin.call($4e7d7febd98d159a$var$validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
        },
        every: function every(callbackfn /* , thisArg */ ) {
            return $4e7d7febd98d159a$var$arrayEvery($4e7d7febd98d159a$var$validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        },
        fill: function fill(value /* , start, end */ ) {
            return $4e7d7febd98d159a$var$arrayFill.apply($4e7d7febd98d159a$var$validate(this), arguments);
        },
        filter: function filter(callbackfn /* , thisArg */ ) {
            return $4e7d7febd98d159a$var$speciesFromList(this, $4e7d7febd98d159a$var$arrayFilter($4e7d7febd98d159a$var$validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined));
        },
        find: function find(predicate /* , thisArg */ ) {
            return $4e7d7febd98d159a$var$arrayFind($4e7d7febd98d159a$var$validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
        },
        findIndex: function findIndex(predicate /* , thisArg */ ) {
            return $4e7d7febd98d159a$var$arrayFindIndex($4e7d7febd98d159a$var$validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
        },
        forEach: function forEach(callbackfn /* , thisArg */ ) {
            $4e7d7febd98d159a$var$arrayForEach($4e7d7febd98d159a$var$validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        },
        indexOf: function indexOf(searchElement /* , fromIndex */ ) {
            return $4e7d7febd98d159a$var$arrayIndexOf($4e7d7febd98d159a$var$validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
        },
        includes: function includes(searchElement /* , fromIndex */ ) {
            return $4e7d7febd98d159a$var$arrayIncludes($4e7d7febd98d159a$var$validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
        },
        join: function join(separator) {
            return $4e7d7febd98d159a$var$arrayJoin.apply($4e7d7febd98d159a$var$validate(this), arguments);
        },
        lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */ ) {
            return $4e7d7febd98d159a$var$arrayLastIndexOf.apply($4e7d7febd98d159a$var$validate(this), arguments);
        },
        map: function map(mapfn /* , thisArg */ ) {
            return $4e7d7febd98d159a$var$$map($4e7d7febd98d159a$var$validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
        },
        reduce: function reduce(callbackfn /* , initialValue */ ) {
            return $4e7d7febd98d159a$var$arrayReduce.apply($4e7d7febd98d159a$var$validate(this), arguments);
        },
        reduceRight: function reduceRight(callbackfn /* , initialValue */ ) {
            return $4e7d7febd98d159a$var$arrayReduceRight.apply($4e7d7febd98d159a$var$validate(this), arguments);
        },
        reverse: function reverse() {
            var that = this;
            var length = $4e7d7febd98d159a$var$validate(that).length;
            var middle = Math.floor(length / 2);
            var index = 0;
            var value;
            while(index < middle){
                value = that[index];
                that[index++] = that[--length];
                that[length] = value;
            }
            return that;
        },
        some: function some(callbackfn /* , thisArg */ ) {
            return $4e7d7febd98d159a$var$arraySome($4e7d7febd98d159a$var$validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        },
        sort: function sort(comparefn) {
            return $4e7d7febd98d159a$var$arraySort.call($4e7d7febd98d159a$var$validate(this), comparefn);
        },
        subarray: function subarray(begin, end) {
            var O = $4e7d7febd98d159a$var$validate(this);
            var length = O.length;
            var $begin = $4e7d7febd98d159a$var$toAbsoluteIndex(begin, length);
            return new ($4e7d7febd98d159a$var$speciesConstructor(O, O[$4e7d7febd98d159a$var$DEF_CONSTRUCTOR]))(O.buffer, O.byteOffset + $begin * O.BYTES_PER_ELEMENT, $4e7d7febd98d159a$var$toLength((end === undefined ? length : $4e7d7febd98d159a$var$toAbsoluteIndex(end, length)) - $begin));
        }
    };
    var $4e7d7febd98d159a$var$$slice = function slice(start, end) {
        return $4e7d7febd98d159a$var$speciesFromList(this, $4e7d7febd98d159a$var$arraySlice.call($4e7d7febd98d159a$var$validate(this), start, end));
    };
    var $4e7d7febd98d159a$var$$set = function set(arrayLike /* , offset */ ) {
        $4e7d7febd98d159a$var$validate(this);
        var offset = $4e7d7febd98d159a$var$toOffset(arguments[1], 1);
        var length = this.length;
        var src = $4e7d7febd98d159a$var$toObject(arrayLike);
        var len = $4e7d7febd98d159a$var$toLength(src.length);
        var index = 0;
        if (len + offset > length) throw $4e7d7febd98d159a$var$RangeError($4e7d7febd98d159a$var$WRONG_LENGTH);
        while(index < len)this[offset + index] = src[index++];
    };
    var $4e7d7febd98d159a$var$$iterators = {
        entries: function entries() {
            return $4e7d7febd98d159a$var$arrayEntries.call($4e7d7febd98d159a$var$validate(this));
        },
        keys: function keys() {
            return $4e7d7febd98d159a$var$arrayKeys.call($4e7d7febd98d159a$var$validate(this));
        },
        values: function values() {
            return $4e7d7febd98d159a$var$arrayValues.call($4e7d7febd98d159a$var$validate(this));
        }
    };
    var $4e7d7febd98d159a$var$isTAIndex = function(target, key) {
        return $4e7d7febd98d159a$var$isObject(target) && target[$4e7d7febd98d159a$var$TYPED_ARRAY] && typeof key != 'symbol' && key in target && String(+key) == String(key);
    };
    var $4e7d7febd98d159a$var$$getDesc = function getOwnPropertyDescriptor(target, key) {
        return $4e7d7febd98d159a$var$isTAIndex(target, key = $4e7d7febd98d159a$var$toPrimitive(key, true)) ? $4e7d7febd98d159a$var$propertyDesc(2, target[key]) : $4e7d7febd98d159a$var$gOPD(target, key);
    };
    var $4e7d7febd98d159a$var$$setDesc = function defineProperty(target, key, desc) {
        if ($4e7d7febd98d159a$var$isTAIndex(target, key = $4e7d7febd98d159a$var$toPrimitive(key, true)) && $4e7d7febd98d159a$var$isObject(desc) && $4e7d7febd98d159a$var$has(desc, 'value') && !$4e7d7febd98d159a$var$has(desc, 'get') && !$4e7d7febd98d159a$var$has(desc, 'set') && !desc.configurable && (!$4e7d7febd98d159a$var$has(desc, 'writable') || desc.writable) && (!$4e7d7febd98d159a$var$has(desc, 'enumerable') || desc.enumerable)) {
            target[key] = desc.value;
            return target;
        }
        return $4e7d7febd98d159a$var$dP(target, key, desc);
    };
    if (!$4e7d7febd98d159a$var$ALL_CONSTRUCTORS) {
        $4e7d7febd98d159a$var$$GOPD.f = $4e7d7febd98d159a$var$$getDesc;
        $4e7d7febd98d159a$var$$DP.f = $4e7d7febd98d159a$var$$setDesc;
    }
    $4e7d7febd98d159a$var$$export($4e7d7febd98d159a$var$$export.S + $4e7d7febd98d159a$var$$export.F * !$4e7d7febd98d159a$var$ALL_CONSTRUCTORS, 'Object', {
        getOwnPropertyDescriptor: $4e7d7febd98d159a$var$$getDesc,
        defineProperty: $4e7d7febd98d159a$var$$setDesc
    });
    if ($4e7d7febd98d159a$var$fails(function() {
        $4e7d7febd98d159a$var$arrayToString.call({});
    })) $4e7d7febd98d159a$var$arrayToString = $4e7d7febd98d159a$var$arrayToLocaleString = function toString() {
        return $4e7d7febd98d159a$var$arrayJoin.call(this);
    };
    var $4e7d7febd98d159a$var$$TypedArrayPrototype$ = $4e7d7febd98d159a$var$redefineAll({}, $4e7d7febd98d159a$var$proto);
    $4e7d7febd98d159a$var$redefineAll($4e7d7febd98d159a$var$$TypedArrayPrototype$, $4e7d7febd98d159a$var$$iterators);
    $4e7d7febd98d159a$var$hide($4e7d7febd98d159a$var$$TypedArrayPrototype$, $4e7d7febd98d159a$var$ITERATOR, $4e7d7febd98d159a$var$$iterators.values);
    $4e7d7febd98d159a$var$redefineAll($4e7d7febd98d159a$var$$TypedArrayPrototype$, {
        slice: $4e7d7febd98d159a$var$$slice,
        set: $4e7d7febd98d159a$var$$set,
        constructor: function() {},
        toString: $4e7d7febd98d159a$var$arrayToString,
        toLocaleString: $4e7d7febd98d159a$var$$toLocaleString
    });
    $4e7d7febd98d159a$var$addGetter($4e7d7febd98d159a$var$$TypedArrayPrototype$, 'buffer', 'b');
    $4e7d7febd98d159a$var$addGetter($4e7d7febd98d159a$var$$TypedArrayPrototype$, 'byteOffset', 'o');
    $4e7d7febd98d159a$var$addGetter($4e7d7febd98d159a$var$$TypedArrayPrototype$, 'byteLength', 'l');
    $4e7d7febd98d159a$var$addGetter($4e7d7febd98d159a$var$$TypedArrayPrototype$, 'length', 'e');
    $4e7d7febd98d159a$var$dP($4e7d7febd98d159a$var$$TypedArrayPrototype$, $4e7d7febd98d159a$var$TAG, {
        get: function() {
            return this[$4e7d7febd98d159a$var$TYPED_ARRAY];
        }
    });
    // eslint-disable-next-line max-statements
    module.exports = function(KEY, BYTES, wrapper, CLAMPED) {
        CLAMPED = !!CLAMPED;
        var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
        var GETTER = 'get' + KEY;
        var SETTER = 'set' + KEY;
        var TypedArray = $4e7d7febd98d159a$var$global[NAME];
        var Base = TypedArray || {};
        var TAC = TypedArray && $4e7d7febd98d159a$var$getPrototypeOf(TypedArray);
        var FORCED = !TypedArray || !$4e7d7febd98d159a$var$$typed.ABV;
        var O = {};
        var TypedArrayPrototype = TypedArray && TypedArray[$4e7d7febd98d159a$var$PROTOTYPE];
        var getter = function(that, index) {
            var data = that._d;
            return data.v[GETTER](index * BYTES + data.o, $4e7d7febd98d159a$var$LITTLE_ENDIAN);
        };
        var setter = function(that, index, value) {
            var data = that._d;
            if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
            data.v[SETTER](index * BYTES + data.o, value, $4e7d7febd98d159a$var$LITTLE_ENDIAN);
        };
        var addElement = function(that, index) {
            $4e7d7febd98d159a$var$dP(that, index, {
                get: function() {
                    return getter(this, index);
                },
                set: function(value) {
                    return setter(this, index, value);
                },
                enumerable: true
            });
        };
        if (FORCED) {
            TypedArray = wrapper(function(that, data, $offset, $length) {
                $4e7d7febd98d159a$var$anInstance(that, TypedArray, NAME, '_d');
                var index = 0;
                var offset = 0;
                var buffer, byteLength, length, klass;
                if (!$4e7d7febd98d159a$var$isObject(data)) {
                    length = $4e7d7febd98d159a$var$toIndex(data);
                    byteLength = length * BYTES;
                    buffer = new $4e7d7febd98d159a$var$$ArrayBuffer(byteLength);
                } else if (data instanceof $4e7d7febd98d159a$var$$ArrayBuffer || (klass = $4e7d7febd98d159a$var$classof(data)) == $4e7d7febd98d159a$var$ARRAY_BUFFER || klass == $4e7d7febd98d159a$var$SHARED_BUFFER) {
                    buffer = data;
                    offset = $4e7d7febd98d159a$var$toOffset($offset, BYTES);
                    var $len = data.byteLength;
                    if ($length === undefined) {
                        if ($len % BYTES) throw $4e7d7febd98d159a$var$RangeError($4e7d7febd98d159a$var$WRONG_LENGTH);
                        byteLength = $len - offset;
                        if (byteLength < 0) throw $4e7d7febd98d159a$var$RangeError($4e7d7febd98d159a$var$WRONG_LENGTH);
                    } else {
                        byteLength = $4e7d7febd98d159a$var$toLength($length) * BYTES;
                        if (byteLength + offset > $len) throw $4e7d7febd98d159a$var$RangeError($4e7d7febd98d159a$var$WRONG_LENGTH);
                    }
                    length = byteLength / BYTES;
                } else if ($4e7d7febd98d159a$var$TYPED_ARRAY in data) return $4e7d7febd98d159a$var$fromList(TypedArray, data);
                else return $4e7d7febd98d159a$var$$from.call(TypedArray, data);
                $4e7d7febd98d159a$var$hide(that, '_d', {
                    b: buffer,
                    o: offset,
                    l: byteLength,
                    e: length,
                    v: new $4e7d7febd98d159a$var$$DataView(buffer)
                });
                while(index < length)addElement(that, index++);
            });
            TypedArrayPrototype = TypedArray[$4e7d7febd98d159a$var$PROTOTYPE] = $4e7d7febd98d159a$var$create($4e7d7febd98d159a$var$$TypedArrayPrototype$);
            $4e7d7febd98d159a$var$hide(TypedArrayPrototype, 'constructor', TypedArray);
        } else if (!$4e7d7febd98d159a$var$fails(function() {
            TypedArray(1);
        }) || !$4e7d7febd98d159a$var$fails(function() {
            new TypedArray(-1); // eslint-disable-line no-new
        }) || !$4e7d7febd98d159a$var$$iterDetect(function(iter) {
            new TypedArray(); // eslint-disable-line no-new
            new TypedArray(null); // eslint-disable-line no-new
            new TypedArray(1.5); // eslint-disable-line no-new
            new TypedArray(iter); // eslint-disable-line no-new
        }, true)) {
            TypedArray = wrapper(function(that, data, $offset, $length) {
                $4e7d7febd98d159a$var$anInstance(that, TypedArray, NAME);
                var klass;
                // `ws` module bug, temporarily remove validation length for Uint8Array
                // https://github.com/websockets/ws/pull/645
                if (!$4e7d7febd98d159a$var$isObject(data)) return new Base($4e7d7febd98d159a$var$toIndex(data));
                if (data instanceof $4e7d7febd98d159a$var$$ArrayBuffer || (klass = $4e7d7febd98d159a$var$classof(data)) == $4e7d7febd98d159a$var$ARRAY_BUFFER || klass == $4e7d7febd98d159a$var$SHARED_BUFFER) return $length !== undefined ? new Base(data, $4e7d7febd98d159a$var$toOffset($offset, BYTES), $length) : $offset !== undefined ? new Base(data, $4e7d7febd98d159a$var$toOffset($offset, BYTES)) : new Base(data);
                if ($4e7d7febd98d159a$var$TYPED_ARRAY in data) return $4e7d7febd98d159a$var$fromList(TypedArray, data);
                return $4e7d7febd98d159a$var$$from.call(TypedArray, data);
            });
            $4e7d7febd98d159a$var$arrayForEach(TAC !== Function.prototype ? $4e7d7febd98d159a$var$gOPN(Base).concat($4e7d7febd98d159a$var$gOPN(TAC)) : $4e7d7febd98d159a$var$gOPN(Base), function(key) {
                if (!(key in TypedArray)) $4e7d7febd98d159a$var$hide(TypedArray, key, Base[key]);
            });
            TypedArray[$4e7d7febd98d159a$var$PROTOTYPE] = TypedArrayPrototype;
            if (!$4e7d7febd98d159a$var$LIBRARY) TypedArrayPrototype.constructor = TypedArray;
        }
        var $nativeIterator = TypedArrayPrototype[$4e7d7febd98d159a$var$ITERATOR];
        var CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
        var $iterator = $4e7d7febd98d159a$var$$iterators.values;
        $4e7d7febd98d159a$var$hide(TypedArray, $4e7d7febd98d159a$var$TYPED_CONSTRUCTOR, true);
        $4e7d7febd98d159a$var$hide(TypedArrayPrototype, $4e7d7febd98d159a$var$TYPED_ARRAY, NAME);
        $4e7d7febd98d159a$var$hide(TypedArrayPrototype, $4e7d7febd98d159a$var$VIEW, true);
        $4e7d7febd98d159a$var$hide(TypedArrayPrototype, $4e7d7febd98d159a$var$DEF_CONSTRUCTOR, TypedArray);
        if (CLAMPED ? new TypedArray(1)[$4e7d7febd98d159a$var$TAG] != NAME : !($4e7d7febd98d159a$var$TAG in TypedArrayPrototype)) $4e7d7febd98d159a$var$dP(TypedArrayPrototype, $4e7d7febd98d159a$var$TAG, {
            get: function() {
                return NAME;
            }
        });
        O[NAME] = TypedArray;
        $4e7d7febd98d159a$var$$export($4e7d7febd98d159a$var$$export.G + $4e7d7febd98d159a$var$$export.W + $4e7d7febd98d159a$var$$export.F * (TypedArray != Base), O);
        $4e7d7febd98d159a$var$$export($4e7d7febd98d159a$var$$export.S, NAME, {
            BYTES_PER_ELEMENT: BYTES
        });
        $4e7d7febd98d159a$var$$export($4e7d7febd98d159a$var$$export.S + $4e7d7febd98d159a$var$$export.F * $4e7d7febd98d159a$var$fails(function() {
            Base.of.call(TypedArray, 1);
        }), NAME, {
            from: $4e7d7febd98d159a$var$$from,
            of: $4e7d7febd98d159a$var$$of
        });
        if (!($4e7d7febd98d159a$var$BYTES_PER_ELEMENT in TypedArrayPrototype)) $4e7d7febd98d159a$var$hide(TypedArrayPrototype, $4e7d7febd98d159a$var$BYTES_PER_ELEMENT, BYTES);
        $4e7d7febd98d159a$var$$export($4e7d7febd98d159a$var$$export.P, NAME, $4e7d7febd98d159a$var$proto);
        $4e7d7febd98d159a$var$setSpecies(NAME);
        $4e7d7febd98d159a$var$$export($4e7d7febd98d159a$var$$export.P + $4e7d7febd98d159a$var$$export.F * $4e7d7febd98d159a$var$FORCED_SET, NAME, {
            set: $4e7d7febd98d159a$var$$set
        });
        $4e7d7febd98d159a$var$$export($4e7d7febd98d159a$var$$export.P + $4e7d7febd98d159a$var$$export.F * !CORRECT_ITER_NAME, NAME, $4e7d7febd98d159a$var$$iterators);
        if (!$4e7d7febd98d159a$var$LIBRARY && TypedArrayPrototype.toString != $4e7d7febd98d159a$var$arrayToString) TypedArrayPrototype.toString = $4e7d7febd98d159a$var$arrayToString;
        $4e7d7febd98d159a$var$$export($4e7d7febd98d159a$var$$export.P + $4e7d7febd98d159a$var$$export.F * $4e7d7febd98d159a$var$fails(function() {
            new TypedArray(1).slice();
        }), NAME, {
            slice: $4e7d7febd98d159a$var$$slice
        });
        $4e7d7febd98d159a$var$$export($4e7d7febd98d159a$var$$export.P + $4e7d7febd98d159a$var$$export.F * ($4e7d7febd98d159a$var$fails(function() {
            return [
                1,
                2
            ].toLocaleString() != new TypedArray([
                1,
                2
            ]).toLocaleString();
        }) || !$4e7d7febd98d159a$var$fails(function() {
            TypedArrayPrototype.toLocaleString.call([
                1,
                2
            ]);
        })), NAME, {
            toLocaleString: $4e7d7febd98d159a$var$$toLocaleString
        });
        $4e7d7febd98d159a$var$Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
        if (!$4e7d7febd98d159a$var$LIBRARY && !CORRECT_ITER_NAME) $4e7d7febd98d159a$var$hide(TypedArrayPrototype, $4e7d7febd98d159a$var$ITERATOR, $iterator);
    };
} else module.exports = function() {};

});

parcelRegister("755Pi", function(module, exports) {
// all object keys, includes non-enumerable and symbols

var $ivFzP = parcelRequire("ivFzP");

var $5S6VU = parcelRequire("5S6VU");

var $6K5GG = parcelRequire("6K5GG");

var $1YuiL = parcelRequire("1YuiL");
var $527d850818f6f4aa$require$Reflect = $1YuiL.Reflect;
module.exports = $527d850818f6f4aa$require$Reflect && $527d850818f6f4aa$require$Reflect.ownKeys || function ownKeys(it) {
    var keys = $ivFzP.f($6K5GG(it));
    var getSymbols = $5S6VU.f;
    return getSymbols ? keys.concat(getSymbols(it)) : keys;
};

});

parcelRegister("4AEZp", function(module, exports) {

var $gvOoh = parcelRequire("gvOoh");

var $eYXZv = parcelRequire("eYXZv");

var $15QDc = parcelRequire("15QDc");

var $il6o7 = parcelRequire("il6o7");
var $357a51da85402f1a$require$isEnum = $il6o7.f;
module.exports = function(isEntries) {
    return function(it) {
        var O = $15QDc(it);
        var keys = $eYXZv(O);
        var length = keys.length;
        var i = 0;
        var result = [];
        var key;
        while(length > i){
            key = keys[i++];
            if (!$gvOoh || $357a51da85402f1a$require$isEnum.call(O, key)) result.push(isEntries ? [
                key,
                O[key]
            ] : O[key]);
        }
        return result;
    };
};

});

parcelRegister("19Rte", function(module, exports) {
'use strict';



// Forced replacement prototype accessors methods
module.exports = (parcelRequire("aNvO0")) || !(parcelRequire("bjnTD"))(function() {
    var K = Math.random();
    // In FF throws only define methods
    // eslint-disable-next-line no-undef, no-useless-call
    __defineSetter__.call(null, K, function() {});
    delete (parcelRequire("1YuiL"))[K];
});

});

parcelRegister("a5gb2", function(module, exports) {
// https://github.com/DavidBruant/Map-Set.prototype.toJSON

var $47rfI = parcelRequire("47rfI");

var $7wV2F = parcelRequire("7wV2F");
module.exports = function(NAME) {
    return function toJSON() {
        if ($47rfI(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
        return $7wV2F(this);
    };
};

});
parcelRegister("7wV2F", function(module, exports) {

var $gTqEb = parcelRequire("gTqEb");
module.exports = function(iter, ITERATOR) {
    var result = [];
    $gTqEb(iter, false, result.push, result, ITERATOR);
    return result;
};

});


parcelRegister("gmEKb", function(module, exports) {
'use strict';

var $eqgBB = parcelRequire("eqgBB");
module.exports = function(COLLECTION) {
    $eqgBB($eqgBB.S, COLLECTION, {
        of: function of() {
            var length = arguments.length;
            var A = new Array(length);
            while(length--)A[length] = arguments[length];
            return new this(A);
        }
    });
};

});

parcelRegister("i2Pmb", function(module, exports) {
'use strict';

var $eqgBB = parcelRequire("eqgBB");

var $4VmiN = parcelRequire("4VmiN");

var $8luNd = parcelRequire("8luNd");

var $gTqEb = parcelRequire("gTqEb");
module.exports = function(COLLECTION) {
    $eqgBB($eqgBB.S, COLLECTION, {
        from: function from(source /* , mapFn, thisArg */ ) {
            var mapFn = arguments[1];
            var mapping, A, n, cb;
            $4VmiN(this);
            mapping = mapFn !== undefined;
            if (mapping) $4VmiN(mapFn);
            if (source == undefined) return new this();
            A = [];
            if (mapping) {
                n = 0;
                cb = $8luNd(mapFn, arguments[2], 2);
                $gTqEb(source, false, function(nextItem) {
                    A.push(cb(nextItem, n++));
                });
            } else $gTqEb(source, false, A.push, A);
            return new this(A);
        }
    });
};

});

parcelRegister("fxKVl", function(module, exports) {
// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
    if (arguments.length === 0 || x != x || inLow != inLow || inHigh != inHigh || outLow != outLow || outHigh != outHigh) return NaN;
    if (x === Infinity || x === -Infinity) return x;
    return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};

});

parcelRegister("cWchu", function(module, exports) {
module.exports = function(regExp, replace) {
    var replacer = replace === Object(replace) ? function(part) {
        return replace[part];
    } : replace;
    return function(it) {
        return String(it).replace(regExp, replacer);
    };
};

});

parcelRegister("NdCUR", function(module, exports) {
'use strict';

module.exports = (parcelRequire("eFe2B"));

});
parcelRegister("eFe2B", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $aacfc94514c3d2a5$export$dca3b0875bd9a954; }, function (v) { return $aacfc94514c3d2a5$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $aacfc94514c3d2a5$export$16fa2f45be04daa8; }, function (v) { return $aacfc94514c3d2a5$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $aacfc94514c3d2a5$export$ffb0004e005737fa; }, function (v) { return $aacfc94514c3d2a5$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $aacfc94514c3d2a5$export$e2c29f18771995cb; }, function (v) { return $aacfc94514c3d2a5$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $aacfc94514c3d2a5$export$221d75b3f55bb0bd; }, function (v) { return $aacfc94514c3d2a5$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $aacfc94514c3d2a5$export$5f8d39834fd61797; }, function (v) { return $aacfc94514c3d2a5$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $aacfc94514c3d2a5$export$74bf444e3cd11ea5; }, function (v) { return $aacfc94514c3d2a5$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $aacfc94514c3d2a5$export$ae55be85d98224ed; }, function (v) { return $aacfc94514c3d2a5$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $aacfc94514c3d2a5$export$e530037191fcd5d7; }, function (v) { return $aacfc94514c3d2a5$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $aacfc94514c3d2a5$export$fd42f52fd3ae1109; }, function (v) { return $aacfc94514c3d2a5$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $aacfc94514c3d2a5$export$c8a8987d4410bf2d; }, function (v) { return $aacfc94514c3d2a5$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $aacfc94514c3d2a5$export$d38cd72104c1f0e9; }, function (v) { return $aacfc94514c3d2a5$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $aacfc94514c3d2a5$export$7d1e3a5e95ceca43; }, function (v) { return $aacfc94514c3d2a5$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $aacfc94514c3d2a5$export$257a8862b851cb5b; }, function (v) { return $aacfc94514c3d2a5$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $aacfc94514c3d2a5$export$a8257692ac88316c; }, function (v) { return $aacfc94514c3d2a5$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $aacfc94514c3d2a5$export$488013bae63b21da; }, function (v) { return $aacfc94514c3d2a5$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $aacfc94514c3d2a5$export$7c73462e0d25e514; }, function (v) { return $aacfc94514c3d2a5$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $aacfc94514c3d2a5$export$35808ee640e87ca7; }, function (v) { return $aacfc94514c3d2a5$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $aacfc94514c3d2a5$export$fae74005e78b1a27; }, function (v) { return $aacfc94514c3d2a5$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $aacfc94514c3d2a5$export$dc8fbce3eb94dc1e; }, function (v) { return $aacfc94514c3d2a5$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $aacfc94514c3d2a5$export$6d9c69b0de29b591; }, function (v) { return $aacfc94514c3d2a5$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $aacfc94514c3d2a5$export$d5a552a76deda3c2; }, function (v) { return $aacfc94514c3d2a5$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $aacfc94514c3d2a5$export$e5c5a5f917a5871c; }, function (v) { return $aacfc94514c3d2a5$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $aacfc94514c3d2a5$export$1538c33de8887b59; }, function (v) { return $aacfc94514c3d2a5$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $aacfc94514c3d2a5$export$13e3392192263954; }, function (v) { return $aacfc94514c3d2a5$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $aacfc94514c3d2a5$export$b8f5890fc79d6aca; }, function (v) { return $aacfc94514c3d2a5$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $aacfc94514c3d2a5$export$60241385465d0a34; }, function (v) { return $aacfc94514c3d2a5$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $aacfc94514c3d2a5$export$83d89fbfd8236492; }, function (v) { return $aacfc94514c3d2a5$export$83d89fbfd8236492 = v; });
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $aacfc94514c3d2a5$export$dca3b0875bd9a954;
var $aacfc94514c3d2a5$export$16fa2f45be04daa8;
var $aacfc94514c3d2a5$export$ffb0004e005737fa;
var $aacfc94514c3d2a5$export$e2c29f18771995cb;
var $aacfc94514c3d2a5$export$221d75b3f55bb0bd;
var $aacfc94514c3d2a5$export$5f8d39834fd61797;
var $aacfc94514c3d2a5$export$74bf444e3cd11ea5;
var $aacfc94514c3d2a5$export$ae55be85d98224ed;
var $aacfc94514c3d2a5$export$e530037191fcd5d7;
var $aacfc94514c3d2a5$export$fd42f52fd3ae1109;
var $aacfc94514c3d2a5$export$c8a8987d4410bf2d;
var $aacfc94514c3d2a5$export$d38cd72104c1f0e9;
var $aacfc94514c3d2a5$export$7d1e3a5e95ceca43;
var $aacfc94514c3d2a5$export$257a8862b851cb5b;
var $aacfc94514c3d2a5$export$a8257692ac88316c;
var $aacfc94514c3d2a5$export$488013bae63b21da;
var $aacfc94514c3d2a5$export$7c73462e0d25e514;
var $aacfc94514c3d2a5$export$35808ee640e87ca7;
var $aacfc94514c3d2a5$export$fae74005e78b1a27;
var $aacfc94514c3d2a5$export$dc8fbce3eb94dc1e;
var $aacfc94514c3d2a5$export$6d9c69b0de29b591;
var $aacfc94514c3d2a5$export$d5a552a76deda3c2;
var $aacfc94514c3d2a5$export$e5c5a5f917a5871c;
var $aacfc94514c3d2a5$export$1538c33de8887b59;
var $aacfc94514c3d2a5$export$13e3392192263954;
var $aacfc94514c3d2a5$export$b8f5890fc79d6aca;
var $aacfc94514c3d2a5$export$60241385465d0a34;
var $aacfc94514c3d2a5$export$83d89fbfd8236492;
'use strict';

var $haJ2X = parcelRequire("haJ2X");
var $aacfc94514c3d2a5$var$n = "function" === typeof Symbol && Symbol.for, $aacfc94514c3d2a5$var$p = $aacfc94514c3d2a5$var$n ? Symbol.for("react.element") : 60103, $aacfc94514c3d2a5$var$q = $aacfc94514c3d2a5$var$n ? Symbol.for("react.portal") : 60106, $aacfc94514c3d2a5$var$r = $aacfc94514c3d2a5$var$n ? Symbol.for("react.fragment") : 60107, $aacfc94514c3d2a5$var$t = $aacfc94514c3d2a5$var$n ? Symbol.for("react.strict_mode") : 60108, $aacfc94514c3d2a5$var$u = $aacfc94514c3d2a5$var$n ? Symbol.for("react.profiler") : 60114, $aacfc94514c3d2a5$var$v = $aacfc94514c3d2a5$var$n ? Symbol.for("react.provider") : 60109, $aacfc94514c3d2a5$var$w = $aacfc94514c3d2a5$var$n ? Symbol.for("react.context") : 60110, $aacfc94514c3d2a5$var$x = $aacfc94514c3d2a5$var$n ? Symbol.for("react.forward_ref") : 60112, $aacfc94514c3d2a5$var$y = $aacfc94514c3d2a5$var$n ? Symbol.for("react.suspense") : 60113, $aacfc94514c3d2a5$var$z = $aacfc94514c3d2a5$var$n ? Symbol.for("react.memo") : 60115, $aacfc94514c3d2a5$var$A = $aacfc94514c3d2a5$var$n ? Symbol.for("react.lazy") : 60116, $aacfc94514c3d2a5$var$B = "function" === typeof Symbol && Symbol.iterator;
function $aacfc94514c3d2a5$var$C(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $aacfc94514c3d2a5$var$D = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $aacfc94514c3d2a5$var$E = {};
function $aacfc94514c3d2a5$var$F(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $aacfc94514c3d2a5$var$E;
    this.updater = c || $aacfc94514c3d2a5$var$D;
}
$aacfc94514c3d2a5$var$F.prototype.isReactComponent = {};
$aacfc94514c3d2a5$var$F.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($aacfc94514c3d2a5$var$C(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$aacfc94514c3d2a5$var$F.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $aacfc94514c3d2a5$var$G() {}
$aacfc94514c3d2a5$var$G.prototype = $aacfc94514c3d2a5$var$F.prototype;
function $aacfc94514c3d2a5$var$H(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $aacfc94514c3d2a5$var$E;
    this.updater = c || $aacfc94514c3d2a5$var$D;
}
var $aacfc94514c3d2a5$var$I = $aacfc94514c3d2a5$var$H.prototype = new $aacfc94514c3d2a5$var$G;
$aacfc94514c3d2a5$var$I.constructor = $aacfc94514c3d2a5$var$H;
$haJ2X($aacfc94514c3d2a5$var$I, $aacfc94514c3d2a5$var$F.prototype);
$aacfc94514c3d2a5$var$I.isPureReactComponent = !0;
var $aacfc94514c3d2a5$var$J = {
    current: null
}, $aacfc94514c3d2a5$var$K = Object.prototype.hasOwnProperty, $aacfc94514c3d2a5$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $aacfc94514c3d2a5$var$M(a, b, c) {
    var e, d = {}, g = null, k = null;
    if (null != b) for(e in void 0 !== b.ref && (k = b.ref), void 0 !== b.key && (g = "" + b.key), b)$aacfc94514c3d2a5$var$K.call(b, e) && !$aacfc94514c3d2a5$var$L.hasOwnProperty(e) && (d[e] = b[e]);
    var f = arguments.length - 2;
    if (1 === f) d.children = c;
    else if (1 < f) {
        for(var h = Array(f), m = 0; m < f; m++)h[m] = arguments[m + 2];
        d.children = h;
    }
    if (a && a.defaultProps) for(e in f = a.defaultProps, f)void 0 === d[e] && (d[e] = f[e]);
    return {
        $$typeof: $aacfc94514c3d2a5$var$p,
        type: a,
        key: g,
        ref: k,
        props: d,
        _owner: $aacfc94514c3d2a5$var$J.current
    };
}
function $aacfc94514c3d2a5$var$N(a, b) {
    return {
        $$typeof: $aacfc94514c3d2a5$var$p,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $aacfc94514c3d2a5$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $aacfc94514c3d2a5$var$p;
}
function $aacfc94514c3d2a5$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + ("" + a).replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $aacfc94514c3d2a5$var$P = /\/+/g, $aacfc94514c3d2a5$var$Q = [];
function $aacfc94514c3d2a5$var$R(a, b, c, e) {
    if ($aacfc94514c3d2a5$var$Q.length) {
        var d = $aacfc94514c3d2a5$var$Q.pop();
        d.result = a;
        d.keyPrefix = b;
        d.func = c;
        d.context = e;
        d.count = 0;
        return d;
    }
    return {
        result: a,
        keyPrefix: b,
        func: c,
        context: e,
        count: 0
    };
}
function $aacfc94514c3d2a5$var$S(a) {
    a.result = null;
    a.keyPrefix = null;
    a.func = null;
    a.context = null;
    a.count = 0;
    10 > $aacfc94514c3d2a5$var$Q.length && $aacfc94514c3d2a5$var$Q.push(a);
}
function $aacfc94514c3d2a5$var$T(a, b, c, e) {
    var d = typeof a;
    if ("undefined" === d || "boolean" === d) a = null;
    var g = !1;
    if (null === a) g = !0;
    else switch(d){
        case "string":
        case "number":
            g = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $aacfc94514c3d2a5$var$p:
                case $aacfc94514c3d2a5$var$q:
                    g = !0;
            }
    }
    if (g) return c(e, a, "" === b ? "." + $aacfc94514c3d2a5$var$U(a, 0) : b), 1;
    g = 0;
    b = "" === b ? "." : b + ":";
    if (Array.isArray(a)) for(var k = 0; k < a.length; k++){
        d = a[k];
        var f = b + $aacfc94514c3d2a5$var$U(d, k);
        g += $aacfc94514c3d2a5$var$T(d, f, c, e);
    }
    else if (null === a || "object" !== typeof a ? f = null : (f = $aacfc94514c3d2a5$var$B && a[$aacfc94514c3d2a5$var$B] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for(a = f.call(a), k = 0; !(d = a.next()).done;)d = d.value, f = b + $aacfc94514c3d2a5$var$U(d, k++), g += $aacfc94514c3d2a5$var$T(d, f, c, e);
    else if ("object" === d) throw c = "" + a, Error($aacfc94514c3d2a5$var$C(31, "[object Object]" === c ? "object with keys {" + Object.keys(a).join(", ") + "}" : c, ""));
    return g;
}
function $aacfc94514c3d2a5$var$V(a, b, c) {
    return null == a ? 0 : $aacfc94514c3d2a5$var$T(a, "", b, c);
}
function $aacfc94514c3d2a5$var$U(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $aacfc94514c3d2a5$var$escape(a.key) : b.toString(36);
}
function $aacfc94514c3d2a5$var$W(a, b) {
    a.func.call(a.context, b, a.count++);
}
function $aacfc94514c3d2a5$var$aa(a, b, c) {
    var e = a.result, d = a.keyPrefix;
    a = a.func.call(a.context, b, a.count++);
    Array.isArray(a) ? $aacfc94514c3d2a5$var$X(a, e, c, function(a) {
        return a;
    }) : null != a && ($aacfc94514c3d2a5$var$O(a) && (a = $aacfc94514c3d2a5$var$N(a, d + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace($aacfc94514c3d2a5$var$P, "$&/") + "/") + c)), e.push(a));
}
function $aacfc94514c3d2a5$var$X(a, b, c, e, d) {
    var g = "";
    null != c && (g = ("" + c).replace($aacfc94514c3d2a5$var$P, "$&/") + "/");
    b = $aacfc94514c3d2a5$var$R(b, g, e, d);
    $aacfc94514c3d2a5$var$V(a, $aacfc94514c3d2a5$var$aa, b);
    $aacfc94514c3d2a5$var$S(b);
}
var $aacfc94514c3d2a5$var$Y = {
    current: null
};
function $aacfc94514c3d2a5$var$Z() {
    var a = $aacfc94514c3d2a5$var$Y.current;
    if (null === a) throw Error($aacfc94514c3d2a5$var$C(321));
    return a;
}
var $aacfc94514c3d2a5$var$ba = {
    ReactCurrentDispatcher: $aacfc94514c3d2a5$var$Y,
    ReactCurrentBatchConfig: {
        suspense: null
    },
    ReactCurrentOwner: $aacfc94514c3d2a5$var$J,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $haJ2X
};
$aacfc94514c3d2a5$export$dca3b0875bd9a954 = {
    map: function(a, b, c) {
        if (null == a) return a;
        var e = [];
        $aacfc94514c3d2a5$var$X(a, e, null, b, c);
        return e;
    },
    forEach: function(a, b, c) {
        if (null == a) return a;
        b = $aacfc94514c3d2a5$var$R(null, null, b, c);
        $aacfc94514c3d2a5$var$V(a, $aacfc94514c3d2a5$var$W, b);
        $aacfc94514c3d2a5$var$S(b);
    },
    count: function(a) {
        return $aacfc94514c3d2a5$var$V(a, function() {
            return null;
        }, null);
    },
    toArray: function(a) {
        var b = [];
        $aacfc94514c3d2a5$var$X(a, b, null, function(a) {
            return a;
        });
        return b;
    },
    only: function(a) {
        if (!$aacfc94514c3d2a5$var$O(a)) throw Error($aacfc94514c3d2a5$var$C(143));
        return a;
    }
};
$aacfc94514c3d2a5$export$16fa2f45be04daa8 = $aacfc94514c3d2a5$var$F;
$aacfc94514c3d2a5$export$ffb0004e005737fa = $aacfc94514c3d2a5$var$r;
$aacfc94514c3d2a5$export$e2c29f18771995cb = $aacfc94514c3d2a5$var$u;
$aacfc94514c3d2a5$export$221d75b3f55bb0bd = $aacfc94514c3d2a5$var$H;
$aacfc94514c3d2a5$export$5f8d39834fd61797 = $aacfc94514c3d2a5$var$t;
$aacfc94514c3d2a5$export$74bf444e3cd11ea5 = $aacfc94514c3d2a5$var$y;
$aacfc94514c3d2a5$export$ae55be85d98224ed = $aacfc94514c3d2a5$var$ba;
$aacfc94514c3d2a5$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($aacfc94514c3d2a5$var$C(267, a));
    var e = $haJ2X({}, a.props), d = a.key, g = a.ref, k = a._owner;
    if (null != b) {
        void 0 !== b.ref && (g = b.ref, k = $aacfc94514c3d2a5$var$J.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var f = a.type.defaultProps;
        for(h in b)$aacfc94514c3d2a5$var$K.call(b, h) && !$aacfc94514c3d2a5$var$L.hasOwnProperty(h) && (e[h] = void 0 === b[h] && void 0 !== f ? f[h] : b[h]);
    }
    var h = arguments.length - 2;
    if (1 === h) e.children = c;
    else if (1 < h) {
        f = Array(h);
        for(var m = 0; m < h; m++)f[m] = arguments[m + 2];
        e.children = f;
    }
    return {
        $$typeof: $aacfc94514c3d2a5$var$p,
        type: a.type,
        key: d,
        ref: g,
        props: e,
        _owner: k
    };
};
$aacfc94514c3d2a5$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $aacfc94514c3d2a5$var$w,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $aacfc94514c3d2a5$var$v,
        _context: a
    };
    return a.Consumer = a;
};
$aacfc94514c3d2a5$export$c8a8987d4410bf2d = $aacfc94514c3d2a5$var$M;
$aacfc94514c3d2a5$export$d38cd72104c1f0e9 = function(a) {
    var b = $aacfc94514c3d2a5$var$M.bind(null, a);
    b.type = a;
    return b;
};
$aacfc94514c3d2a5$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$aacfc94514c3d2a5$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $aacfc94514c3d2a5$var$x,
        render: a
    };
};
$aacfc94514c3d2a5$export$a8257692ac88316c = $aacfc94514c3d2a5$var$O;
$aacfc94514c3d2a5$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $aacfc94514c3d2a5$var$A,
        _ctor: a,
        _status: -1,
        _result: null
    };
};
$aacfc94514c3d2a5$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $aacfc94514c3d2a5$var$z,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$aacfc94514c3d2a5$export$35808ee640e87ca7 = function(a, b) {
    return $aacfc94514c3d2a5$var$Z().useCallback(a, b);
};
$aacfc94514c3d2a5$export$fae74005e78b1a27 = function(a, b) {
    return $aacfc94514c3d2a5$var$Z().useContext(a, b);
};
$aacfc94514c3d2a5$export$dc8fbce3eb94dc1e = function() {};
$aacfc94514c3d2a5$export$6d9c69b0de29b591 = function(a, b) {
    return $aacfc94514c3d2a5$var$Z().useEffect(a, b);
};
$aacfc94514c3d2a5$export$d5a552a76deda3c2 = function(a, b, c) {
    return $aacfc94514c3d2a5$var$Z().useImperativeHandle(a, b, c);
};
$aacfc94514c3d2a5$export$e5c5a5f917a5871c = function(a, b) {
    return $aacfc94514c3d2a5$var$Z().useLayoutEffect(a, b);
};
$aacfc94514c3d2a5$export$1538c33de8887b59 = function(a, b) {
    return $aacfc94514c3d2a5$var$Z().useMemo(a, b);
};
$aacfc94514c3d2a5$export$13e3392192263954 = function(a, b, c) {
    return $aacfc94514c3d2a5$var$Z().useReducer(a, b, c);
};
$aacfc94514c3d2a5$export$b8f5890fc79d6aca = function(a) {
    return $aacfc94514c3d2a5$var$Z().useRef(a);
};
$aacfc94514c3d2a5$export$60241385465d0a34 = function(a) {
    return $aacfc94514c3d2a5$var$Z().useState(a);
};
$aacfc94514c3d2a5$export$83d89fbfd8236492 = "16.14.0";

});
parcelRegister("haJ2X", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $c8065027ccc663d8$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $c8065027ccc663d8$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $c8065027ccc663d8$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $c8065027ccc663d8$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $c8065027ccc663d8$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $c8065027ccc663d8$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $c8065027ccc663d8$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($c8065027ccc663d8$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($c8065027ccc663d8$var$getOwnPropertySymbols) {
            symbols = $c8065027ccc663d8$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($c8065027ccc663d8$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});



parcelRegister("g2wso", function(module, exports) {
'use strict';
function $bad602861d266056$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($bad602861d266056$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$bad602861d266056$var$checkDCE();

module.exports = (parcelRequire("2Bwej"));

});
parcelRegister("2Bwej", function(module, exports) {
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $NdCUR = parcelRequire("NdCUR");

var $haJ2X = parcelRequire("haJ2X");

var $lOLwO = parcelRequire("lOLwO");
function u(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$NdCUR) throw Error(u(227));
function ba(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var da = !1, ea = null, fa = !1, ha = null, ia = {
    onError: function(a) {
        da = !0;
        ea = a;
    }
};
function ja(a, b, c, d, e, f, g, h, k) {
    da = !1;
    ea = null;
    ba.apply(ia, arguments);
}
function ka(a, b, c, d, e, f, g, h, k) {
    ja.apply(this, arguments);
    if (da) {
        if (da) {
            var l = ea;
            da = !1;
            ea = null;
        } else throw Error(u(198));
        fa || (fa = !0, ha = l);
    }
}
var la = null, ma = null, na = null;
function oa(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = na(c);
    ka(d, b, void 0, a);
    a.currentTarget = null;
}
var pa = null, qa = {};
function ra() {
    if (pa) for(var a in qa){
        var b = qa[a], c = pa.indexOf(a);
        if (!(-1 < c)) throw Error(u(96, a));
        if (!sa[c]) {
            if (!b.extractEvents) throw Error(u(97, a));
            sa[c] = b;
            c = b.eventTypes;
            for(var d in c){
                var e = void 0;
                var f = c[d], g = b, h = d;
                if (ta.hasOwnProperty(h)) throw Error(u(99, h));
                ta[h] = f;
                var k = f.phasedRegistrationNames;
                if (k) {
                    for(e in k)k.hasOwnProperty(e) && ua(k[e], g, h);
                    e = !0;
                } else f.registrationName ? (ua(f.registrationName, g, h), e = !0) : e = !1;
                if (!e) throw Error(u(98, d, a));
            }
        }
    }
}
function ua(a, b, c) {
    if (va[a]) throw Error(u(100, a));
    va[a] = b;
    wa[a] = b.eventTypes[c].dependencies;
}
var sa = [], ta = {}, va = {}, wa = {};
function xa(a) {
    var b = !1, c;
    for(c in a)if (a.hasOwnProperty(c)) {
        var d = a[c];
        if (!qa.hasOwnProperty(c) || qa[c] !== d) {
            if (qa[c]) throw Error(u(102, c));
            qa[c] = d;
            b = !0;
        }
    }
    b && ra();
}
var ya = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), za = null, Aa = null, Ba = null;
function Ca(a) {
    if (a = ma(a)) {
        if ("function" !== typeof za) throw Error(u(280));
        var b = a.stateNode;
        b && (b = la(b), za(a.stateNode, a.type, b));
    }
}
function Da(a) {
    Aa ? Ba ? Ba.push(a) : Ba = [
        a
    ] : Aa = a;
}
function Ea() {
    if (Aa) {
        var a = Aa, b = Ba;
        Ba = Aa = null;
        Ca(a);
        if (b) for(a = 0; a < b.length; a++)Ca(b[a]);
    }
}
function Fa(a, b) {
    return a(b);
}
function Ga(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ha() {}
var Ia = Fa, Ja = !1, Ka = !1;
function La() {
    if (null !== Aa || null !== Ba) Ha(), Ea();
}
function Ma(a, b, c) {
    if (Ka) return a(b, c);
    Ka = !0;
    try {
        return Ia(a, b, c);
    } finally{
        Ka = !1, La();
    }
}
var Na = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, Oa = Object.prototype.hasOwnProperty, Pa = {}, Qa = {};
function Ra(a) {
    if (Oa.call(Qa, a)) return !0;
    if (Oa.call(Pa, a)) return !1;
    if (Na.test(a)) return Qa[a] = !0;
    Pa[a] = !0;
    return !1;
}
function Sa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function Ta(a, b, c, d) {
    if (null === b || "undefined" === typeof b || Sa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
}
var C = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    C[a] = new v(a, 0, !1, a, null, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    C[b] = new v(b, 1, !1, a[1], null, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    C[a] = new v(a, 2, !1, a.toLowerCase(), null, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    C[a] = new v(a, 2, !1, a, null, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    C[a] = new v(a, 3, !1, a.toLowerCase(), null, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    C[a] = new v(a, 3, !0, a, null, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    C[a] = new v(a, 4, !1, a, null, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    C[a] = new v(a, 6, !1, a, null, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    C[a] = new v(a, 5, !1, a.toLowerCase(), null, !1);
});
var Ua = /[\-:]([a-z])/g;
function Va(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, null, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    C[a] = new v(a, 1, !1, a.toLowerCase(), null, !1);
});
C.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    C[a] = new v(a, 1, !1, a.toLowerCase(), null, !0);
});
var Wa = $NdCUR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
Wa.hasOwnProperty("ReactCurrentDispatcher") || (Wa.ReactCurrentDispatcher = {
    current: null
});
Wa.hasOwnProperty("ReactCurrentBatchConfig") || (Wa.ReactCurrentBatchConfig = {
    suspense: null
});
function Xa(a, b, c, d) {
    var e = C.hasOwnProperty(b) ? C[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (Ta(b, c, e, d) && (c = null), d || null === e ? Ra(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var Ya = /^(.*)[\\\/]/, E = "function" === typeof Symbol && Symbol.for, Za = E ? Symbol.for("react.element") : 60103, $a = E ? Symbol.for("react.portal") : 60106, ab = E ? Symbol.for("react.fragment") : 60107, bb = E ? Symbol.for("react.strict_mode") : 60108, cb = E ? Symbol.for("react.profiler") : 60114, db = E ? Symbol.for("react.provider") : 60109, eb = E ? Symbol.for("react.context") : 60110, fb = E ? Symbol.for("react.concurrent_mode") : 60111, gb = E ? Symbol.for("react.forward_ref") : 60112, hb = E ? Symbol.for("react.suspense") : 60113, ib = E ? Symbol.for("react.suspense_list") : 60120, jb = E ? Symbol.for("react.memo") : 60115, kb = E ? Symbol.for("react.lazy") : 60116, lb = E ? Symbol.for("react.block") : 60121, mb = "function" === typeof Symbol && Symbol.iterator;
function nb(a) {
    if (null === a || "object" !== typeof a) return null;
    a = mb && a[mb] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function ob(a) {
    if (-1 === a._status) {
        a._status = 0;
        var b = a._ctor;
        b = b();
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
}
function pb(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ab:
            return "Fragment";
        case $a:
            return "Portal";
        case cb:
            return "Profiler";
        case bb:
            return "StrictMode";
        case hb:
            return "Suspense";
        case ib:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case eb:
            return "Context.Consumer";
        case db:
            return "Context.Provider";
        case gb:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case jb:
            return pb(a.type);
        case lb:
            return pb(a.render);
        case kb:
            if (a = 1 === a._status ? a._result : null) return pb(a);
    }
    return null;
}
function qb(a) {
    var b = "";
    do {
        a: switch(a.tag){
            case 3:
            case 4:
            case 6:
            case 7:
            case 10:
            case 9:
                var c = "";
                break a;
            default:
                var d = a._debugOwner, e = a._debugSource, f = pb(a.type);
                c = null;
                d && (c = pb(d.type));
                d = f;
                f = "";
                e ? f = " (at " + e.fileName.replace(Ya, "") + ":" + e.lineNumber + ")" : c && (f = " (created by " + c + ")");
                c = "\n    in " + (d || "Unknown") + f;
        }
        b += c;
        a = a.return;
    }while (a);
    return b;
}
function rb(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function sb(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function tb(a) {
    var b = sb(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function xb(a) {
    a._valueTracker || (a._valueTracker = tb(a));
}
function yb(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = sb(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function zb(a, b) {
    var c = b.checked;
    return $haJ2X({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Ab(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = rb(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function Bb(a, b) {
    b = b.checked;
    null != b && Xa(a, "checked", b, !1);
}
function Cb(a, b) {
    Bb(a, b);
    var c = rb(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? Db(a, b.type, c) : b.hasOwnProperty("defaultValue") && Db(a, b.type, rb(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function Eb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function Db(a, b, c) {
    if ("number" !== b || a.ownerDocument.activeElement !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function Fb(a) {
    var b = "";
    $NdCUR.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function Gb(a, b) {
    a = $haJ2X({
        children: void 0
    }, b);
    if (b = Fb(b.children)) a.children = b;
    return a;
}
function Hb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + rb(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function Ib(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(u(91));
    return $haJ2X({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function Jb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(u(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(u(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: rb(c)
    };
}
function Kb(a, b) {
    var c = rb(b.value), d = rb(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function Lb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var Mb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function Nb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function Ob(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? Nb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var Pb, Qb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== Mb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        Pb = Pb || document.createElement("div");
        Pb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = Pb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function Rb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
function Sb(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Tb = {
    animationend: Sb("Animation", "AnimationEnd"),
    animationiteration: Sb("Animation", "AnimationIteration"),
    animationstart: Sb("Animation", "AnimationStart"),
    transitionend: Sb("Transition", "TransitionEnd")
}, Ub = {}, Vb = {};
ya && (Vb = document.createElement("div").style, "AnimationEvent" in window || (delete Tb.animationend.animation, delete Tb.animationiteration.animation, delete Tb.animationstart.animation), "TransitionEvent" in window || delete Tb.transitionend.transition);
function Wb(a) {
    if (Ub[a]) return Ub[a];
    if (!Tb[a]) return a;
    var b = Tb[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Vb) return Ub[a] = b[c];
    return a;
}
var Xb = Wb("animationend"), Yb = Wb("animationiteration"), Zb = Wb("animationstart"), $b = Wb("transitionend"), ac = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), bc = new ("function" === typeof WeakMap ? WeakMap : Map);
function cc(a) {
    var b = bc.get(a);
    void 0 === b && (b = new Map, bc.set(a, b));
    return b;
}
function dc(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.effectTag & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function ec(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function fc(a) {
    if (dc(a) !== a) throw Error(u(188));
}
function gc(a) {
    var b = a.alternate;
    if (!b) {
        b = dc(a);
        if (null === b) throw Error(u(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return fc(e), a;
                if (f === d) return fc(e), b;
                f = f.sibling;
            }
            throw Error(u(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(u(189));
            }
        }
        if (c.alternate !== d) throw Error(u(190));
    }
    if (3 !== c.tag) throw Error(u(188));
    return c.stateNode.current === c ? a : b;
}
function hc(a) {
    a = gc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function ic(a, b) {
    if (null == b) throw Error(u(30));
    if (null == a) return b;
    if (Array.isArray(a)) {
        if (Array.isArray(b)) return a.push.apply(a, b), a;
        a.push(b);
        return a;
    }
    return Array.isArray(b) ? [
        a
    ].concat(b) : [
        a,
        b
    ];
}
function jc(a, b, c) {
    Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
}
var kc = null;
function lc(a) {
    if (a) {
        var b = a._dispatchListeners, c = a._dispatchInstances;
        if (Array.isArray(b)) for(var d = 0; d < b.length && !a.isPropagationStopped(); d++)oa(a, b[d], c[d]);
        else b && oa(a, b, c);
        a._dispatchListeners = null;
        a._dispatchInstances = null;
        a.isPersistent() || a.constructor.release(a);
    }
}
function mc(a) {
    null !== a && (kc = ic(kc, a));
    a = kc;
    kc = null;
    if (a) {
        jc(a, lc);
        if (kc) throw Error(u(95));
        if (fa) throw a = ha, fa = !1, ha = null, a;
    }
}
function nc(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
function oc(a) {
    if (!ya) return !1;
    a = "on" + a;
    var b = a in document;
    b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = "function" === typeof b[a]);
    return b;
}
var pc = [];
function qc(a) {
    a.topLevelType = null;
    a.nativeEvent = null;
    a.targetInst = null;
    a.ancestors.length = 0;
    10 > pc.length && pc.push(a);
}
function rc(a, b, c, d) {
    if (pc.length) {
        var e = pc.pop();
        e.topLevelType = a;
        e.eventSystemFlags = d;
        e.nativeEvent = b;
        e.targetInst = c;
        return e;
    }
    return {
        topLevelType: a,
        eventSystemFlags: d,
        nativeEvent: b,
        targetInst: c,
        ancestors: []
    };
}
function sc(a) {
    var b = a.targetInst, c = b;
    do {
        if (!c) {
            a.ancestors.push(c);
            break;
        }
        var d = c;
        if (3 === d.tag) d = d.stateNode.containerInfo;
        else {
            for(; d.return;)d = d.return;
            d = 3 !== d.tag ? null : d.stateNode.containerInfo;
        }
        if (!d) break;
        b = c.tag;
        5 !== b && 6 !== b || a.ancestors.push(c);
        c = tc(d);
    }while (c);
    for(c = 0; c < a.ancestors.length; c++){
        b = a.ancestors[c];
        var e = nc(a.nativeEvent);
        d = a.topLevelType;
        var f = a.nativeEvent, g = a.eventSystemFlags;
        0 === c && (g |= 64);
        for(var h = null, k = 0; k < sa.length; k++){
            var l = sa[k];
            l && (l = l.extractEvents(d, b, f, e, g)) && (h = ic(h, l));
        }
        mc(h);
    }
}
function uc(a, b, c) {
    if (!c.has(a)) {
        switch(a){
            case "scroll":
                vc(b, "scroll", !0);
                break;
            case "focus":
            case "blur":
                vc(b, "focus", !0);
                vc(b, "blur", !0);
                c.set("blur", null);
                c.set("focus", null);
                break;
            case "cancel":
            case "close":
                oc(a) && vc(b, a, !0);
                break;
            case "invalid":
            case "submit":
            case "reset":
                break;
            default:
                -1 === ac.indexOf(a) && F(a, b);
        }
        c.set(a, null);
    }
}
var wc, xc, yc, zc = !1, Ac = [], Bc = null, Cc = null, Dc = null, Ec = new Map, Fc = new Map, Gc = [], Hc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "), Ic = "focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a, b) {
    var c = cc(b);
    Hc.forEach(function(a) {
        uc(a, b, c);
    });
    Ic.forEach(function(a) {
        uc(a, b, c);
    });
}
function Kc(a, b, c, d, e) {
    return {
        blockedOn: a,
        topLevelType: b,
        eventSystemFlags: c | 32,
        nativeEvent: e,
        container: d
    };
}
function Lc(a, b) {
    switch(a){
        case "focus":
        case "blur":
            Bc = null;
            break;
        case "dragenter":
        case "dragleave":
            Cc = null;
            break;
        case "mouseover":
        case "mouseout":
            Dc = null;
            break;
        case "pointerover":
        case "pointerout":
            Ec.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Fc.delete(b.pointerId);
    }
}
function Mc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = Kc(b, c, d, e, f), null !== b && (b = Nc(b), null !== b && xc(b)), a;
    a.eventSystemFlags |= d;
    return a;
}
function Oc(a, b, c, d, e) {
    switch(b){
        case "focus":
            return Bc = Mc(Bc, a, b, c, d, e), !0;
        case "dragenter":
            return Cc = Mc(Cc, a, b, c, d, e), !0;
        case "mouseover":
            return Dc = Mc(Dc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Ec.set(f, Mc(Ec.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Fc.set(f, Mc(Fc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Pc(a) {
    var b = tc(a.target);
    if (null !== b) {
        var c = dc(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = ec(c), null !== b) {
                    a.blockedOn = b;
                    $lOLwO.unstable_runWithPriority(a.priority, function() {
                        yc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Qc(a) {
    if (null !== a.blockedOn) return !1;
    var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
    if (null !== b) {
        var c = Nc(b);
        null !== c && xc(c);
        a.blockedOn = b;
        return !1;
    }
    return !0;
}
function Sc(a, b, c) {
    Qc(a) && c.delete(b);
}
function Tc() {
    for(zc = !1; 0 < Ac.length;){
        var a = Ac[0];
        if (null !== a.blockedOn) {
            a = Nc(a.blockedOn);
            null !== a && wc(a);
            break;
        }
        var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
        null !== b ? a.blockedOn = b : Ac.shift();
    }
    null !== Bc && Qc(Bc) && (Bc = null);
    null !== Cc && Qc(Cc) && (Cc = null);
    null !== Dc && Qc(Dc) && (Dc = null);
    Ec.forEach(Sc);
    Fc.forEach(Sc);
}
function Uc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, zc || (zc = !0, $lOLwO.unstable_scheduleCallback($lOLwO.unstable_NormalPriority, Tc)));
}
function Vc(a) {
    function b(b) {
        return Uc(b, a);
    }
    if (0 < Ac.length) {
        Uc(Ac[0], a);
        for(var c = 1; c < Ac.length; c++){
            var d = Ac[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Bc && Uc(Bc, a);
    null !== Cc && Uc(Cc, a);
    null !== Dc && Uc(Dc, a);
    Ec.forEach(b);
    Fc.forEach(b);
    for(c = 0; c < Gc.length; c++)d = Gc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Gc.length && (c = Gc[0], null === c.blockedOn);)Pc(c), null === c.blockedOn && Gc.shift();
}
var Wc = {}, Yc = new Map, Zc = new Map, $c = [
    "abort",
    "abort",
    Xb,
    "animationEnd",
    Yb,
    "animationIteration",
    Zb,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    $b,
    "transitionEnd",
    "waiting",
    "waiting"
];
function ad(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1], f = "on" + (e[0].toUpperCase() + e.slice(1));
        f = {
            phasedRegistrationNames: {
                bubbled: f,
                captured: f + "Capture"
            },
            dependencies: [
                d
            ],
            eventPriority: b
        };
        Zc.set(d, b);
        Yc.set(d, f);
        Wc[e] = f;
    }
}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
ad($c, 2);
for(var bd = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), cd = 0; cd < bd.length; cd++)Zc.set(bd[cd], 0);
var dd = $lOLwO.unstable_UserBlockingPriority, ed = $lOLwO.unstable_runWithPriority, fd = !0;
function F(a, b) {
    vc(b, a, !1);
}
function vc(a, b, c) {
    var d = Zc.get(b);
    switch(void 0 === d ? 2 : d){
        case 0:
            d = gd.bind(null, b, 1, a);
            break;
        case 1:
            d = hd.bind(null, b, 1, a);
            break;
        default:
            d = id.bind(null, b, 1, a);
    }
    c ? a.addEventListener(b, d, !0) : a.addEventListener(b, d, !1);
}
function gd(a, b, c, d) {
    Ja || Ha();
    var e = id, f = Ja;
    Ja = !0;
    try {
        Ga(e, a, b, c, d);
    } finally{
        (Ja = f) || La();
    }
}
function hd(a, b, c, d) {
    ed(dd, id.bind(null, a, b, c, d));
}
function id(a, b, c, d) {
    if (fd) {
        if (0 < Ac.length && -1 < Hc.indexOf(a)) a = Kc(null, a, b, c, d), Ac.push(a);
        else {
            var e = Rc(a, b, c, d);
            if (null === e) Lc(a, d);
            else if (-1 < Hc.indexOf(a)) a = Kc(e, a, b, c, d), Ac.push(a);
            else if (!Oc(e, a, b, c, d)) {
                Lc(a, d);
                a = rc(a, d, null, b);
                try {
                    Ma(sc, a);
                } finally{
                    qc(a);
                }
            }
        }
    }
}
function Rc(a, b, c, d) {
    c = nc(d);
    c = tc(c);
    if (null !== c) {
        var e = dc(c);
        if (null === e) c = null;
        else {
            var f = e.tag;
            if (13 === f) {
                c = ec(e);
                if (null !== c) return c;
                c = null;
            } else if (3 === f) {
                if (e.stateNode.hydrate) return 3 === e.tag ? e.stateNode.containerInfo : null;
                c = null;
            } else e !== c && (c = null);
        }
    }
    a = rc(a, d, c, b);
    try {
        Ma(sc, a);
    } finally{
        qc(a);
    }
    return null;
}
var jd = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, kd = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(jd).forEach(function(a) {
    kd.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        jd[b] = jd[a];
    });
});
function ld(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || jd.hasOwnProperty(a) && jd[a] ? ("" + b).trim() : b + "px";
}
function md(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = ld(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var nd = $haJ2X({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function od(a, b) {
    if (b) {
        if (nd[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(u(137, a, ""));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(u(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(u(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(u(62, ""));
    }
}
function pd(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var qd = Mb.html;
function rd(a, b) {
    a = 9 === a.nodeType || 11 === a.nodeType ? a : a.ownerDocument;
    var c = cc(a);
    b = wa[b];
    for(var d = 0; d < b.length; d++)uc(b[d], a, c);
}
function sd() {}
function td(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function ud(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function vd(a, b) {
    var c = ud(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = ud(c);
    }
}
function wd(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? wd(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function xd() {
    for(var a = window, b = td(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = td(a.document);
    }
    return b;
}
function yd(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var zd = "$", Ad = "/$", Bd = "$?", Cd = "$!", Dd = null, Ed = null;
function Fd(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function Gd(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Hd = "function" === typeof setTimeout ? setTimeout : void 0, Id = "function" === typeof clearTimeout ? clearTimeout : void 0;
function Jd(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function Kd(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if (c === zd || c === Cd || c === Bd) {
                if (0 === b) return a;
                b--;
            } else c === Ad && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Ld = Math.random().toString(36).slice(2), Md = "__reactInternalInstance$" + Ld, Nd = "__reactEventHandlers$" + Ld, Od = "__reactContainere$" + Ld;
function tc(a) {
    var b = a[Md];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[Od] || c[Md]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Kd(a); null !== a;){
                if (c = a[Md]) return c;
                a = Kd(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Nc(a) {
    a = a[Md] || a[Od];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function Pd(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(u(33));
}
function Qd(a) {
    return a[Nd] || null;
}
function Rd(a) {
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function Sd(a, b) {
    var c = a.stateNode;
    if (!c) return null;
    var d = la(c);
    if (!d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(u(231, b, typeof c));
    return c;
}
function Td(a, b, c) {
    if (b = Sd(a, c.dispatchConfig.phasedRegistrationNames[b])) c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a);
}
function Ud(a) {
    if (a && a.dispatchConfig.phasedRegistrationNames) {
        for(var b = a._targetInst, c = []; b;)c.push(b), b = Rd(b);
        for(b = c.length; 0 < b--;)Td(c[b], "captured", a);
        for(b = 0; b < c.length; b++)Td(c[b], "bubbled", a);
    }
}
function Vd(a, b, c) {
    a && c && c.dispatchConfig.registrationName && (b = Sd(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a));
}
function Wd(a) {
    a && a.dispatchConfig.registrationName && Vd(a._targetInst, null, a);
}
function Xd(a) {
    jc(a, Ud);
}
var Yd = null, Zd = null, $d = null;
function ae() {
    if ($d) return $d;
    var a, b = Zd, c = b.length, d, e = "value" in Yd ? Yd.value : Yd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $d = e.slice(a, 1 < d ? 1 - d : void 0);
}
function be() {
    return !0;
}
function ce() {
    return !1;
}
function G(a, b, c, d) {
    this.dispatchConfig = a;
    this._targetInst = b;
    this.nativeEvent = c;
    a = this.constructor.Interface;
    for(var e in a)a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : "target" === e ? this.target = d : this[e] = c[e]);
    this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? be : ce;
    this.isPropagationStopped = ce;
    return this;
}
$haJ2X(G.prototype, {
    preventDefault: function() {
        this.defaultPrevented = !0;
        var a = this.nativeEvent;
        a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = be);
    },
    stopPropagation: function() {
        var a = this.nativeEvent;
        a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = be);
    },
    persist: function() {
        this.isPersistent = be;
    },
    isPersistent: ce,
    destructor: function() {
        var a = this.constructor.Interface, b;
        for(b in a)this[b] = null;
        this.nativeEvent = this._targetInst = this.dispatchConfig = null;
        this.isPropagationStopped = this.isDefaultPrevented = ce;
        this._dispatchInstances = this._dispatchListeners = null;
    }
});
G.Interface = {
    type: null,
    target: null,
    currentTarget: function() {
        return null;
    },
    eventPhase: null,
    bubbles: null,
    cancelable: null,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: null,
    isTrusted: null
};
G.extend = function(a) {
    function b() {}
    function c() {
        return d.apply(this, arguments);
    }
    var d = this;
    b.prototype = d.prototype;
    var e = new b;
    $haJ2X(e, c.prototype);
    c.prototype = e;
    c.prototype.constructor = c;
    c.Interface = $haJ2X({}, d.Interface, a);
    c.extend = d.extend;
    de(c);
    return c;
};
de(G);
function ee(a, b, c, d) {
    if (this.eventPool.length) {
        var e = this.eventPool.pop();
        this.call(e, a, b, c, d);
        return e;
    }
    return new this(a, b, c, d);
}
function fe(a) {
    if (!(a instanceof this)) throw Error(u(279));
    a.destructor();
    10 > this.eventPool.length && this.eventPool.push(a);
}
function de(a) {
    a.eventPool = [];
    a.getPooled = ee;
    a.release = fe;
}
var ge = G.extend({
    data: null
}), he = G.extend({
    data: null
}), ie = [
    9,
    13,
    27,
    32
], je = ya && "CompositionEvent" in window, ke = null;
ya && "documentMode" in document && (ke = document.documentMode);
var le = ya && "TextEvent" in window && !ke, me = ya && (!je || ke && 8 < ke && 11 >= ke), ne = String.fromCharCode(32), oe = {
    beforeInput: {
        phasedRegistrationNames: {
            bubbled: "onBeforeInput",
            captured: "onBeforeInputCapture"
        },
        dependencies: [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]
    },
    compositionEnd: {
        phasedRegistrationNames: {
            bubbled: "onCompositionEnd",
            captured: "onCompositionEndCapture"
        },
        dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ")
    },
    compositionStart: {
        phasedRegistrationNames: {
            bubbled: "onCompositionStart",
            captured: "onCompositionStartCapture"
        },
        dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ")
    },
    compositionUpdate: {
        phasedRegistrationNames: {
            bubbled: "onCompositionUpdate",
            captured: "onCompositionUpdateCapture"
        },
        dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ")
    }
}, pe = !1;
function qe(a, b) {
    switch(a){
        case "keyup":
            return -1 !== ie.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "blur":
            return !0;
        default:
            return !1;
    }
}
function re(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var se = !1;
function te(a, b) {
    switch(a){
        case "compositionend":
            return re(b);
        case "keypress":
            if (32 !== b.which) return null;
            pe = !0;
            return ne;
        case "textInput":
            return a = b.data, a === ne && pe ? null : a;
        default:
            return null;
    }
}
function ue(a, b) {
    if (se) return "compositionend" === a || !je && qe(a, b) ? (a = ae(), $d = Zd = Yd = null, se = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return me && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var ve = {
    eventTypes: oe,
    extractEvents: function(a, b, c, d) {
        var e;
        if (je) b: {
            switch(a){
                case "compositionstart":
                    var f = oe.compositionStart;
                    break b;
                case "compositionend":
                    f = oe.compositionEnd;
                    break b;
                case "compositionupdate":
                    f = oe.compositionUpdate;
                    break b;
            }
            f = void 0;
        }
        else se ? qe(a, c) && (f = oe.compositionEnd) : "keydown" === a && 229 === c.keyCode && (f = oe.compositionStart);
        f ? (me && "ko" !== c.locale && (se || f !== oe.compositionStart ? f === oe.compositionEnd && se && (e = ae()) : (Yd = d, Zd = "value" in Yd ? Yd.value : Yd.textContent, se = !0)), f = ge.getPooled(f, b, c, d), e ? f.data = e : (e = re(c), null !== e && (f.data = e)), Xd(f), e = f) : e = null;
        (a = le ? te(a, c) : ue(a, c)) ? (b = he.getPooled(oe.beforeInput, b, c, d), b.data = a, Xd(b)) : b = null;
        return null === e ? b : null === b ? e : [
            e,
            b
        ];
    }
}, we = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function xe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!we[a.type] : "textarea" === b ? !0 : !1;
}
var ye = {
    change: {
        phasedRegistrationNames: {
            bubbled: "onChange",
            captured: "onChangeCapture"
        },
        dependencies: "blur change click focus input keydown keyup selectionchange".split(" ")
    }
};
function ze(a, b, c) {
    a = G.getPooled(ye.change, a, b, c);
    a.type = "change";
    Da(c);
    Xd(a);
    return a;
}
var Ae = null, Be = null;
function Ce(a) {
    mc(a);
}
function De(a) {
    var b = Pd(a);
    if (yb(b)) return a;
}
function Ee(a, b) {
    if ("change" === a) return b;
}
var Fe = !1;
ya && (Fe = oc("input") && (!document.documentMode || 9 < document.documentMode));
function Ge() {
    Ae && (Ae.detachEvent("onpropertychange", He), Be = Ae = null);
}
function He(a) {
    if ("value" === a.propertyName && De(Be)) {
        if (a = ze(Be, a, nc(a)), Ja) mc(a);
        else {
            Ja = !0;
            try {
                Fa(Ce, a);
            } finally{
                Ja = !1, La();
            }
        }
    }
}
function Ie(a, b, c) {
    "focus" === a ? (Ge(), Ae = b, Be = c, Ae.attachEvent("onpropertychange", He)) : "blur" === a && Ge();
}
function Je(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return De(Be);
}
function Ke(a, b) {
    if ("click" === a) return De(b);
}
function Le(a, b) {
    if ("input" === a || "change" === a) return De(b);
}
var Me = {
    eventTypes: ye,
    _isInputEventSupported: Fe,
    extractEvents: function(a, b, c, d) {
        var e = b ? Pd(b) : window, f = e.nodeName && e.nodeName.toLowerCase();
        if ("select" === f || "input" === f && "file" === e.type) var g = Ee;
        else if (xe(e)) {
            if (Fe) g = Le;
            else {
                g = Je;
                var h = Ie;
            }
        } else (f = e.nodeName) && "input" === f.toLowerCase() && ("checkbox" === e.type || "radio" === e.type) && (g = Ke);
        if (g && (g = g(a, b))) return ze(g, c, d);
        h && h(a, e, b);
        "blur" === a && (a = e._wrapperState) && a.controlled && "number" === e.type && Db(e, "number", e.value);
    }
}, Ne = G.extend({
    view: null,
    detail: null
}), Oe = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pe(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Oe[a]) ? !!b[a] : !1;
}
function Qe() {
    return Pe;
}
var Re = 0, Se = 0, Te = !1, Ue = !1, Ve = Ne.extend({
    screenX: null,
    screenY: null,
    clientX: null,
    clientY: null,
    pageX: null,
    pageY: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    getModifierState: Qe,
    button: null,
    buttons: null,
    relatedTarget: function(a) {
        return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        var b = Re;
        Re = a.screenX;
        return Te ? "mousemove" === a.type ? a.screenX - b : 0 : (Te = !0, 0);
    },
    movementY: function(a) {
        if ("movementY" in a) return a.movementY;
        var b = Se;
        Se = a.screenY;
        return Ue ? "mousemove" === a.type ? a.screenY - b : 0 : (Ue = !0, 0);
    }
}), We = Ve.extend({
    pointerId: null,
    width: null,
    height: null,
    pressure: null,
    tangentialPressure: null,
    tiltX: null,
    tiltY: null,
    twist: null,
    pointerType: null,
    isPrimary: null
}), Xe = {
    mouseEnter: {
        registrationName: "onMouseEnter",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    mouseLeave: {
        registrationName: "onMouseLeave",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    pointerEnter: {
        registrationName: "onPointerEnter",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    },
    pointerLeave: {
        registrationName: "onPointerLeave",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    }
}, Ye = {
    eventTypes: Xe,
    extractEvents: function(a, b, c, d, e) {
        var f = "mouseover" === a || "pointerover" === a, g = "mouseout" === a || "pointerout" === a;
        if (f && 0 === (e & 32) && (c.relatedTarget || c.fromElement) || !g && !f) return null;
        f = d.window === d ? d : (f = d.ownerDocument) ? f.defaultView || f.parentWindow : window;
        if (g) {
            if (g = b, b = (b = c.relatedTarget || c.toElement) ? tc(b) : null, null !== b) {
                var h = dc(b);
                if (b !== h || 5 !== b.tag && 6 !== b.tag) b = null;
            }
        } else g = null;
        if (g === b) return null;
        if ("mouseout" === a || "mouseover" === a) {
            var k = Ve;
            var l = Xe.mouseLeave;
            var m = Xe.mouseEnter;
            var p = "mouse";
        } else if ("pointerout" === a || "pointerover" === a) k = We, l = Xe.pointerLeave, m = Xe.pointerEnter, p = "pointer";
        a = null == g ? f : Pd(g);
        f = null == b ? f : Pd(b);
        l = k.getPooled(l, g, c, d);
        l.type = p + "leave";
        l.target = a;
        l.relatedTarget = f;
        c = k.getPooled(m, b, c, d);
        c.type = p + "enter";
        c.target = f;
        c.relatedTarget = a;
        d = g;
        p = b;
        if (d && p) a: {
            k = d;
            m = p;
            g = 0;
            for(a = k; a; a = Rd(a))g++;
            a = 0;
            for(b = m; b; b = Rd(b))a++;
            for(; 0 < g - a;)k = Rd(k), g--;
            for(; 0 < a - g;)m = Rd(m), a--;
            for(; g--;){
                if (k === m || k === m.alternate) break a;
                k = Rd(k);
                m = Rd(m);
            }
            k = null;
        }
        else k = null;
        m = k;
        for(k = []; d && d !== m;){
            g = d.alternate;
            if (null !== g && g === m) break;
            k.push(d);
            d = Rd(d);
        }
        for(d = []; p && p !== m;){
            g = p.alternate;
            if (null !== g && g === m) break;
            d.push(p);
            p = Rd(p);
        }
        for(p = 0; p < k.length; p++)Vd(k[p], "bubbled", l);
        for(p = d.length; 0 < p--;)Vd(d[p], "captured", c);
        return 0 === (e & 64) ? [
            l
        ] : [
            l,
            c
        ];
    }
};
function Ze(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e = "function" === typeof Object.is ? Object.is : Ze, af = Object.prototype.hasOwnProperty;
function bf(a, b) {
    if ($e(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!af.call(b, c[d]) || !$e(a[c[d]], b[c[d]])) return !1;
    return !0;
}
var cf = ya && "documentMode" in document && 11 >= document.documentMode, df = {
    select: {
        phasedRegistrationNames: {
            bubbled: "onSelect",
            captured: "onSelectCapture"
        },
        dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")
    }
}, ef = null, ff = null, gf = null, hf = !1;
function jf(a, b) {
    var c = b.window === b ? b.document : 9 === b.nodeType ? b : b.ownerDocument;
    if (hf || null == ef || ef !== td(c)) return null;
    c = ef;
    "selectionStart" in c && yd(c) ? c = {
        start: c.selectionStart,
        end: c.selectionEnd
    } : (c = (c.ownerDocument && c.ownerDocument.defaultView || window).getSelection(), c = {
        anchorNode: c.anchorNode,
        anchorOffset: c.anchorOffset,
        focusNode: c.focusNode,
        focusOffset: c.focusOffset
    });
    return gf && bf(gf, c) ? null : (gf = c, a = G.getPooled(df.select, ff, a, b), a.type = "select", a.target = ef, Xd(a), a);
}
var kf = {
    eventTypes: df,
    extractEvents: function(a, b, c, d, e, f) {
        e = f || (d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument);
        if (!(f = !e)) {
            a: {
                e = cc(e);
                f = wa.onSelect;
                for(var g = 0; g < f.length; g++)if (!e.has(f[g])) {
                    e = !1;
                    break a;
                }
                e = !0;
            }
            f = !e;
        }
        if (f) return null;
        e = b ? Pd(b) : window;
        switch(a){
            case "focus":
                if (xe(e) || "true" === e.contentEditable) ef = e, ff = b, gf = null;
                break;
            case "blur":
                gf = ff = ef = null;
                break;
            case "mousedown":
                hf = !0;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                return hf = !1, jf(c, d);
            case "selectionchange":
                if (cf) break;
            case "keydown":
            case "keyup":
                return jf(c, d);
        }
        return null;
    }
}, lf = G.extend({
    animationName: null,
    elapsedTime: null,
    pseudoElement: null
}), mf = G.extend({
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), nf = Ne.extend({
    relatedTarget: null
});
function of(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
var pf = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, qf = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, rf = Ne.extend({
    key: function(a) {
        if (a.key) {
            var b = pf[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = of(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? qf[a.keyCode] || "Unidentified" : "";
    },
    location: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    repeat: null,
    locale: null,
    getModifierState: Qe,
    charCode: function(a) {
        return "keypress" === a.type ? of(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? of(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), sf = Ve.extend({
    dataTransfer: null
}), tf = Ne.extend({
    touches: null,
    targetTouches: null,
    changedTouches: null,
    altKey: null,
    metaKey: null,
    ctrlKey: null,
    shiftKey: null,
    getModifierState: Qe
}), uf = G.extend({
    propertyName: null,
    elapsedTime: null,
    pseudoElement: null
}), vf = Ve.extend({
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: null,
    deltaMode: null
}), wf = {
    eventTypes: Wc,
    extractEvents: function(a, b, c, d) {
        var e = Yc.get(a);
        if (!e) return null;
        switch(a){
            case "keypress":
                if (0 === of(c)) return null;
            case "keydown":
            case "keyup":
                a = rf;
                break;
            case "blur":
            case "focus":
                a = nf;
                break;
            case "click":
                if (2 === c.button) return null;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
                a = Ve;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                a = sf;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                a = tf;
                break;
            case Xb:
            case Yb:
            case Zb:
                a = lf;
                break;
            case $b:
                a = uf;
                break;
            case "scroll":
                a = Ne;
                break;
            case "wheel":
                a = vf;
                break;
            case "copy":
            case "cut":
            case "paste":
                a = mf;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                a = We;
                break;
            default:
                a = G;
        }
        b = a.getPooled(e, b, c, d);
        Xd(b);
        return b;
    }
};
if (pa) throw Error(u(101));
pa = Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
ra();
var xf = Nc;
la = Qd;
ma = xf;
na = Pd;
xa({
    SimpleEventPlugin: wf,
    EnterLeaveEventPlugin: Ye,
    ChangeEventPlugin: Me,
    SelectEventPlugin: kf,
    BeforeInputEventPlugin: ve
});
var yf = [], zf = -1;
function H(a) {
    0 > zf || (a.current = yf[zf], yf[zf] = null, zf--);
}
function I(a, b) {
    zf++;
    yf[zf] = a.current;
    a.current = b;
}
var Af = {}, J = {
    current: Af
}, K = {
    current: !1
}, Bf = Af;
function Cf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Af;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function L(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Df() {
    H(K);
    H(J);
}
function Ef(a, b, c) {
    if (J.current !== Af) throw Error(u(168));
    I(J, b);
    I(K, c);
}
function Ff(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(u(108, pb(b) || "Unknown", e));
    return $haJ2X({}, c, {}, d);
}
function Gf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Af;
    Bf = J.current;
    I(J, a);
    I(K, K.current);
    return !0;
}
function Hf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(u(169));
    c ? (a = Ff(a, b, Bf), d.__reactInternalMemoizedMergedChildContext = a, H(K), H(J), I(J, a)) : H(K);
    I(K, c);
}
var If = $lOLwO.unstable_runWithPriority, Jf = $lOLwO.unstable_scheduleCallback, Kf = $lOLwO.unstable_cancelCallback, Lf = $lOLwO.unstable_requestPaint, Mf = $lOLwO.unstable_now, Nf = $lOLwO.unstable_getCurrentPriorityLevel, Of = $lOLwO.unstable_ImmediatePriority, Pf = $lOLwO.unstable_UserBlockingPriority, Qf = $lOLwO.unstable_NormalPriority, Rf = $lOLwO.unstable_LowPriority, Sf = $lOLwO.unstable_IdlePriority, Tf = {}, Uf = $lOLwO.unstable_shouldYield, Vf = void 0 !== Lf ? Lf : function() {}, Wf = null, Xf = null, Yf = !1, Zf = Mf(), $f = 1E4 > Zf ? Mf : function() {
    return Mf() - Zf;
};
function ag() {
    switch(Nf()){
        case Of:
            return 99;
        case Pf:
            return 98;
        case Qf:
            return 97;
        case Rf:
            return 96;
        case Sf:
            return 95;
        default:
            throw Error(u(332));
    }
}
function bg(a) {
    switch(a){
        case 99:
            return Of;
        case 98:
            return Pf;
        case 97:
            return Qf;
        case 96:
            return Rf;
        case 95:
            return Sf;
        default:
            throw Error(u(332));
    }
}
function cg(a, b) {
    a = bg(a);
    return If(a, b);
}
function dg(a, b, c) {
    a = bg(a);
    return Jf(a, b, c);
}
function eg(a) {
    null === Wf ? (Wf = [
        a
    ], Xf = Jf(Of, fg)) : Wf.push(a);
    return Tf;
}
function gg() {
    if (null !== Xf) {
        var a = Xf;
        Xf = null;
        Kf(a);
    }
    fg();
}
function fg() {
    if (!Yf && null !== Wf) {
        Yf = !0;
        var a = 0;
        try {
            var b = Wf;
            cg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            Wf = null;
        } catch (c) {
            throw null !== Wf && (Wf = Wf.slice(a + 1)), Jf(Of, gg), c;
        } finally{
            Yf = !1;
        }
    }
}
function hg(a, b, c) {
    c /= 10;
    return 1073741821 - (((1073741821 - a + b / 10) / c | 0) + 1) * c;
}
function ig(a, b) {
    if (a && a.defaultProps) {
        b = $haJ2X({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
    }
    return b;
}
var jg = {
    current: null
}, kg = null, lg = null, mg = null;
function ng() {
    mg = lg = kg = null;
}
function og(a) {
    var b = jg.current;
    H(jg);
    a.type._context._currentValue = b;
}
function pg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if (a.childExpirationTime < b) a.childExpirationTime = b, null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        else if (null !== c && c.childExpirationTime < b) c.childExpirationTime = b;
        else break;
        a = a.return;
    }
}
function qg(a, b) {
    kg = a;
    mg = lg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (a.expirationTime >= b && (rg = !0), a.firstContext = null);
}
function sg(a, b) {
    if (mg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) mg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === lg) {
            if (null === kg) throw Error(u(308));
            lg = b;
            kg.dependencies = {
                expirationTime: 0,
                firstContext: b,
                responders: null
            };
        } else lg = lg.next = b;
    }
    return a._currentValue;
}
var tg = !1;
function ug(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        baseQueue: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function vg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        baseQueue: a.baseQueue,
        shared: a.shared,
        effects: a.effects
    });
}
function wg(a, b) {
    a = {
        expirationTime: a,
        suspenseConfig: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
    return a.next = a;
}
function xg(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function yg(a, b) {
    var c = a.alternate;
    null !== c && vg(c, a);
    a = a.updateQueue;
    c = a.baseQueue;
    null === c ? (a.baseQueue = b.next = b, b.next = b) : (b.next = c.next, c.next = b);
}
function zg(a, b, c, d) {
    var e = a.updateQueue;
    tg = !1;
    var f = e.baseQueue, g = e.shared.pending;
    if (null !== g) {
        if (null !== f) {
            var h = f.next;
            f.next = g.next;
            g.next = h;
        }
        f = g;
        e.shared.pending = null;
        h = a.alternate;
        null !== h && (h = h.updateQueue, null !== h && (h.baseQueue = g));
    }
    if (null !== f) {
        h = f.next;
        var k = e.baseState, l = 0, m = null, p = null, x = null;
        if (null !== h) {
            var z = h;
            do {
                g = z.expirationTime;
                if (g < d) {
                    var ca = {
                        expirationTime: z.expirationTime,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    };
                    null === x ? (p = x = ca, m = k) : x = x.next = ca;
                    g > l && (l = g);
                } else {
                    null !== x && (x = x.next = {
                        expirationTime: 1073741823,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    });
                    Ag(g, z.suspenseConfig);
                    a: {
                        var D = a, t = z;
                        g = b;
                        ca = c;
                        switch(t.tag){
                            case 1:
                                D = t.payload;
                                if ("function" === typeof D) {
                                    k = D.call(ca, k, g);
                                    break a;
                                }
                                k = D;
                                break a;
                            case 3:
                                D.effectTag = D.effectTag & -4097 | 64;
                            case 0:
                                D = t.payload;
                                g = "function" === typeof D ? D.call(ca, k, g) : D;
                                if (null === g || void 0 === g) break a;
                                k = $haJ2X({}, k, g);
                                break a;
                            case 2:
                                tg = !0;
                        }
                    }
                    null !== z.callback && (a.effectTag |= 32, g = e.effects, null === g ? e.effects = [
                        z
                    ] : g.push(z));
                }
                z = z.next;
                if (null === z || z === h) {
                    if (g = e.shared.pending, null === g) break;
                    else z = f.next = g.next, g.next = h, e.baseQueue = f = g, e.shared.pending = null;
                }
            }while (1);
        }
        null === x ? m = k : x.next = p;
        e.baseState = m;
        e.baseQueue = x;
        Bg(l);
        a.expirationTime = l;
        a.memoizedState = k;
    }
}
function Cg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = e;
            e = c;
            if ("function" !== typeof d) throw Error(u(191, d));
            d.call(e);
        }
    }
}
var Dg = Wa.ReactCurrentBatchConfig, Eg = (new $NdCUR.Component).refs;
function Fg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $haJ2X({}, b, c);
    a.memoizedState = c;
    0 === a.expirationTime && (a.updateQueue.baseState = c);
}
var Jg = {
    isMounted: function(a) {
        return (a = a._reactInternalFiber) ? dc(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = Gg(), e = Dg.suspense;
        d = Hg(d, a, e);
        e = wg(d, e);
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        xg(a, e);
        Ig(a, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = Gg(), e = Dg.suspense;
        d = Hg(d, a, e);
        e = wg(d, e);
        e.tag = 1;
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        xg(a, e);
        Ig(a, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternalFiber;
        var c = Gg(), d = Dg.suspense;
        c = Hg(c, a, d);
        d = wg(c, d);
        d.tag = 2;
        void 0 !== b && null !== b && (d.callback = b);
        xg(a, d);
        Ig(a, c);
    }
};
function Kg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !bf(c, d) || !bf(e, f) : !0;
}
function Lg(a, b, c) {
    var d = !1, e = Af;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = sg(f) : (e = L(b) ? Bf : J.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Cf(a, e) : Af);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Jg;
    a.stateNode = b;
    b._reactInternalFiber = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Mg(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Jg.enqueueReplaceState(b, b.state, null);
}
function Ng(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Eg;
    ug(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = sg(f) : (f = L(b) ? Bf : J.current, e.context = Cf(a, f));
    zg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Fg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Jg.enqueueReplaceState(e, e.state, null), zg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.effectTag |= 4);
}
var Og = Array.isArray;
function Pg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(u(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(u(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Eg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(u(284));
        if (!c._owner) throw Error(u(290, a));
    }
    return a;
}
function Qg(a, b) {
    if ("textarea" !== a.type) throw Error(u(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, ""));
}
function Rg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.effectTag = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Sg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;
        b.effectTag = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.effectTag = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Tg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Pg(a, b, c), d.return = a, d;
        d = Ug(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Pg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Vg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Wg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function p(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Tg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case Za:
                    return c = Ug(b.type, b.key, b.props, null, a.mode, c), c.ref = Pg(a, null, b), c.return = a, c;
                case $a:
                    return b = Vg(b, a.mode, c), b.return = a, b;
            }
            if (Og(b) || nb(b)) return b = Wg(b, a.mode, c, null), b.return = a, b;
            Qg(a, b);
        }
        return null;
    }
    function x(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case Za:
                    return c.key === e ? c.type === ab ? m(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case $a:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Og(c) || nb(c)) return null !== e ? null : m(a, b, c, d, null);
            Qg(a, c);
        }
        return null;
    }
    function z(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case Za:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ab ? m(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case $a:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Og(d) || nb(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            Qg(b, d);
        }
        return null;
    }
    function ca(e, g, h, k) {
        for(var l = null, t = null, m = g, y = g = 0, A = null; null !== m && y < h.length; y++){
            m.index > y ? (A = m, m = null) : A = m.sibling;
            var q = x(e, m, h[y], k);
            if (null === q) {
                null === m && (m = A);
                break;
            }
            a && m && null === q.alternate && b(e, m);
            g = f(q, g, y);
            null === t ? l = q : t.sibling = q;
            t = q;
            m = A;
        }
        if (y === h.length) return c(e, m), l;
        if (null === m) {
            for(; y < h.length; y++)m = p(e, h[y], k), null !== m && (g = f(m, g, y), null === t ? l = m : t.sibling = m, t = m);
            return l;
        }
        for(m = d(e, m); y < h.length; y++)A = z(m, e, y, h[y], k), null !== A && (a && null !== A.alternate && m.delete(null === A.key ? y : A.key), g = f(A, g, y), null === t ? l = A : t.sibling = A, t = A);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function D(e, g, h, l) {
        var k = nb(h);
        if ("function" !== typeof k) throw Error(u(150));
        h = k.call(h);
        if (null == h) throw Error(u(151));
        for(var m = k = null, t = g, y = g = 0, A = null, q = h.next(); null !== t && !q.done; y++, q = h.next()){
            t.index > y ? (A = t, t = null) : A = t.sibling;
            var D = x(e, t, q.value, l);
            if (null === D) {
                null === t && (t = A);
                break;
            }
            a && t && null === D.alternate && b(e, t);
            g = f(D, g, y);
            null === m ? k = D : m.sibling = D;
            m = D;
            t = A;
        }
        if (q.done) return c(e, t), k;
        if (null === t) {
            for(; !q.done; y++, q = h.next())q = p(e, q.value, l), null !== q && (g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
            return k;
        }
        for(t = d(e, t); !q.done; y++, q = h.next())q = z(t, e, y, q.value, l), null !== q && (a && null !== q.alternate && t.delete(null === q.key ? y : q.key), g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
        a && t.forEach(function(a) {
            return b(e, a);
        });
        return k;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ab && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case Za:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ab) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Pg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ab ? (d = Wg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Ug(f.type, f.key, f.props, null, a.mode, h), h.ref = Pg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case $a:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Vg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Tg(f, a.mode, h), d.return = a, a = d), g(a);
        if (Og(f)) return ca(a, d, f, h);
        if (nb(f)) return D(a, d, f, h);
        l && Qg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 0:
                throw a = a.type, Error(u(152, a.displayName || a.name || "Component"));
        }
        return c(a, d);
    };
}
var Xg = Rg(!0), Yg = Rg(!1), Zg = {}, $g = {
    current: Zg
}, ah = {
    current: Zg
}, bh = {
    current: Zg
};
function ch(a) {
    if (a === Zg) throw Error(u(174));
    return a;
}
function dh(a, b) {
    I(bh, b);
    I(ah, a);
    I($g, Zg);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : Ob(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = Ob(b, a);
    }
    H($g);
    I($g, b);
}
function eh() {
    H($g);
    H(ah);
    H(bh);
}
function fh(a) {
    ch(bh.current);
    var b = ch($g.current);
    var c = Ob(b, a.type);
    b !== c && (I(ah, a), I($g, c));
}
function gh(a) {
    ah.current === a && (H($g), H(ah));
}
var M = {
    current: 0
};
function hh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || c.data === Bd || c.data === Cd)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.effectTag & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
function ih(a, b) {
    return {
        responder: a,
        props: b
    };
}
var jh = Wa.ReactCurrentDispatcher, kh = Wa.ReactCurrentBatchConfig, lh = 0, N = null, O = null, P = null, mh = !1;
function Q() {
    throw Error(u(321));
}
function nh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$e(a[c], b[c])) return !1;
    return !0;
}
function oh(a, b, c, d, e, f) {
    lh = f;
    N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.expirationTime = 0;
    jh.current = null === a || null === a.memoizedState ? ph : qh;
    a = c(d, e);
    if (b.expirationTime === lh) {
        f = 0;
        do {
            b.expirationTime = 0;
            if (!(25 > f)) throw Error(u(301));
            f += 1;
            P = O = null;
            b.updateQueue = null;
            jh.current = rh;
            a = c(d, e);
        }while (b.expirationTime === lh);
    }
    jh.current = sh;
    b = null !== O && null !== O.next;
    lh = 0;
    P = O = N = null;
    mh = !1;
    if (b) throw Error(u(300));
    return a;
}
function th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === P ? N.memoizedState = P = a : P = P.next = a;
    return P;
}
function uh() {
    if (null === O) {
        var a = N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = O.next;
    var b = null === P ? N.memoizedState : P.next;
    if (null !== b) P = b, O = a;
    else {
        if (null === a) throw Error(u(310));
        O = a;
        a = {
            memoizedState: O.memoizedState,
            baseState: O.baseState,
            baseQueue: O.baseQueue,
            queue: O.queue,
            next: null
        };
        null === P ? N.memoizedState = P = a : P = P.next = a;
    }
    return P;
}
function vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function wh(a) {
    var b = uh(), c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.expirationTime;
            if (l < lh) {
                var m = {
                    expirationTime: k.expirationTime,
                    suspenseConfig: k.suspenseConfig,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = m, f = d) : h = h.next = m;
                l > N.expirationTime && (N.expirationTime = l, Bg(l));
            } else null !== h && (h = h.next = {
                expirationTime: 1073741823,
                suspenseConfig: k.suspenseConfig,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), Ag(l, k.suspenseConfig), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        $e(d, b.memoizedState) || (rg = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function xh(a) {
    var b = uh(), c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $e(f, b.memoizedState) || (rg = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function yh(a) {
    var b = th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: vh,
        lastRenderedState: a
    };
    a = a.dispatch = zh.bind(null, N, a);
    return [
        b.memoizedState,
        a
    ];
}
function Ah(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = N.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Bh() {
    return uh().memoizedState;
}
function Ch(a, b, c, d) {
    var e = th();
    N.effectTag |= a;
    e.memoizedState = Ah(1 | b, c, void 0, void 0 === d ? null : d);
}
function Dh(a, b, c, d) {
    var e = uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== O) {
        var g = O.memoizedState;
        f = g.destroy;
        if (null !== d && nh(d, g.deps)) {
            Ah(b, c, f, d);
            return;
        }
    }
    N.effectTag |= a;
    e.memoizedState = Ah(1 | b, c, f, d);
}
function Eh(a, b) {
    return Ch(516, 4, a, b);
}
function Fh(a, b) {
    return Dh(516, 4, a, b);
}
function Gh(a, b) {
    return Dh(4, 2, a, b);
}
function Hh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function Ih(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Dh(4, 2, Hh.bind(null, b, a), c);
}
function Jh() {}
function Kh(a, b) {
    th().memoizedState = [
        a,
        void 0 === b ? null : b
    ];
    return a;
}
function Lh(a, b) {
    var c = uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && nh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Mh(a, b) {
    var c = uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && nh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Nh(a, b, c) {
    var d = ag();
    cg(98 > d ? 98 : d, function() {
        a(!0);
    });
    cg(97 < d ? 97 : d, function() {
        var d = kh.suspense;
        kh.suspense = void 0 === b ? null : b;
        try {
            a(!1), c();
        } finally{
            kh.suspense = d;
        }
    });
}
function zh(a, b, c) {
    var d = Gg(), e = Dg.suspense;
    d = Hg(d, a, e);
    e = {
        expirationTime: d,
        suspenseConfig: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    };
    var f = b.pending;
    null === f ? e.next = e : (e.next = f.next, f.next = e);
    b.pending = e;
    f = a.alternate;
    if (a === N || null !== f && f === N) mh = !0, e.expirationTime = lh, N.expirationTime = lh;
    else {
        if (0 === a.expirationTime && (null === f || 0 === f.expirationTime) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.eagerReducer = f;
            e.eagerState = h;
            if ($e(h, g)) return;
        } catch (k) {} finally{}
        Ig(a, d);
    }
}
var sh = {
    readContext: sg,
    useCallback: Q,
    useContext: Q,
    useEffect: Q,
    useImperativeHandle: Q,
    useLayoutEffect: Q,
    useMemo: Q,
    useReducer: Q,
    useRef: Q,
    useState: Q,
    useDebugValue: Q,
    useResponder: Q,
    useDeferredValue: Q,
    useTransition: Q
}, ph = {
    readContext: sg,
    useCallback: Kh,
    useContext: sg,
    useEffect: Eh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Ch(4, 2, Hh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Ch(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = zh.bind(null, N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: yh,
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = yh(a), d = c[0], e = c[1];
        Eh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = yh(!1), c = b[0];
        b = b[1];
        return [
            Kh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, qh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: wh,
    useRef: Bh,
    useState: function() {
        return wh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = wh(vh), d = c[0], e = c[1];
        Fh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = wh(vh), c = b[0];
        b = b[1];
        return [
            Lh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, rh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: xh,
    useRef: Bh,
    useState: function() {
        return xh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = xh(vh), d = c[0], e = c[1];
        Fh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = xh(vh), c = b[0];
        b = b[1];
        return [
            Lh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, Oh = null, Ph = null, Qh = !1;
function Rh(a, b) {
    var c = Sh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.effectTag = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function Th(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function Uh(a) {
    if (Qh) {
        var b = Ph;
        if (b) {
            var c = b;
            if (!Th(a, b)) {
                b = Jd(c.nextSibling);
                if (!b || !Th(a, b)) {
                    a.effectTag = a.effectTag & -1025 | 2;
                    Qh = !1;
                    Oh = a;
                    return;
                }
                Rh(Oh, c);
            }
            Oh = a;
            Ph = Jd(b.firstChild);
        } else a.effectTag = a.effectTag & -1025 | 2, Qh = !1, Oh = a;
    }
}
function Vh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    Oh = a;
}
function Wh(a) {
    if (a !== Oh) return !1;
    if (!Qh) return Vh(a), Qh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !Gd(b, a.memoizedProps)) for(b = Ph; b;)Rh(a, b), b = Jd(b.nextSibling);
    Vh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(u(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if (c === Ad) {
                        if (0 === b) {
                            Ph = Jd(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else c !== zd && c !== Cd && c !== Bd || b++;
                }
                a = a.nextSibling;
            }
            Ph = null;
        }
    } else Ph = Oh ? Jd(a.stateNode.nextSibling) : null;
    return !0;
}
function Xh() {
    Ph = Oh = null;
    Qh = !1;
}
var Yh = Wa.ReactCurrentOwner, rg = !1;
function R(a, b, c, d) {
    b.child = null === a ? Yg(b, null, c, d) : Xg(b, a.child, c, d);
}
function Zh(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    qg(b, e);
    d = oh(a, b, c, d, f, e);
    if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
    b.effectTag |= 1;
    R(a, b, d, e);
    return b.child;
}
function ai(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !bi(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ci(a, b, g, d, e, f);
        a = Ug(c.type, null, d, null, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (e < f && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : bf, c(e, d) && a.ref === b.ref)) return $h(a, b, f);
    b.effectTag |= 1;
    a = Sg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ci(a, b, c, d, e, f) {
    return null !== a && bf(a.memoizedProps, d) && a.ref === b.ref && (rg = !1, e < f) ? (b.expirationTime = a.expirationTime, $h(a, b, f)) : di(a, b, c, d, f);
}
function ei(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
}
function di(a, b, c, d, e) {
    var f = L(c) ? Bf : J.current;
    f = Cf(b, f);
    qg(b, e);
    c = oh(a, b, c, d, f, e);
    if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
    b.effectTag |= 1;
    R(a, b, c, e);
    return b.child;
}
function fi(a, b, c, d, e) {
    if (L(c)) {
        var f = !0;
        Gf(b);
    } else f = !1;
    qg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), Lg(b, c, d), Ng(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l));
        var m = c.getDerivedStateFromProps, p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        p || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l);
        tg = !1;
        var x = b.memoizedState;
        g.state = x;
        zg(b, d, g, e);
        k = b.memoizedState;
        h !== d || x !== k || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), k = b.memoizedState), (h = tg || Kg(b, c, h, d, x, k, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), d = !1);
    } else g = b.stateNode, vg(a, b), h = b.memoizedProps, g.props = b.type === b.elementType ? h : ig(b.type, h), k = g.context, l = c.contextType, "object" === typeof l && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l)), m = c.getDerivedStateFromProps, (p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l), tg = !1, k = b.memoizedState, g.state = k, zg(b, d, g, e), x = b.memoizedState, h !== d || k !== x || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), x = b.memoizedState), (m = tg || Kg(b, c, h, d, k, x, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, l), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, l)), "function" === typeof g.componentDidUpdate && (b.effectTag |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = l, d = m) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), d = !1);
    return gi(a, b, c, d, f, e);
}
function gi(a, b, c, d, e, f) {
    ei(a, b);
    var g = 0 !== (b.effectTag & 64);
    if (!d && !g) return e && Hf(b, c, !1), $h(a, b, f);
    d = b.stateNode;
    Yh.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.effectTag |= 1;
    null !== a && g ? (b.child = Xg(b, a.child, null, f), b.child = Xg(b, null, h, f)) : R(a, b, h, f);
    b.memoizedState = d.state;
    e && Hf(b, c, !0);
    return b.child;
}
function hi(a) {
    var b = a.stateNode;
    b.pendingContext ? Ef(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Ef(a, b.context, !1);
    dh(a, b.containerInfo);
}
var ii = {
    dehydrated: null,
    retryTime: 0
};
function ji(a, b, c) {
    var d = b.mode, e = b.pendingProps, f = M.current, g = !1, h;
    (h = 0 !== (b.effectTag & 64)) || (h = 0 !== (f & 2) && (null === a || null !== a.memoizedState));
    h ? (g = !0, b.effectTag &= -65) : null !== a && null === a.memoizedState || void 0 === e.fallback || !0 === e.unstable_avoidThisFallback || (f |= 1);
    I(M, f & 1);
    if (null === a) {
        void 0 !== e.fallback && Uh(b);
        if (g) {
            g = e.fallback;
            e = Wg(null, d, 0, null);
            e.return = b;
            if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
            c = Wg(g, d, c, null);
            c.return = b;
            e.sibling = c;
            b.memoizedState = ii;
            b.child = e;
            return c;
        }
        d = e.children;
        b.memoizedState = null;
        return b.child = Yg(b, null, d, c);
    }
    if (null !== a.memoizedState) {
        a = a.child;
        d = a.sibling;
        if (g) {
            e = e.fallback;
            c = Sg(a, a.pendingProps);
            c.return = b;
            if (0 === (b.mode & 2) && (g = null !== b.memoizedState ? b.child.child : b.child, g !== a.child)) for(c.child = g; null !== g;)g.return = c, g = g.sibling;
            d = Sg(d, e);
            d.return = b;
            c.sibling = d;
            c.childExpirationTime = 0;
            b.memoizedState = ii;
            b.child = c;
            return d;
        }
        c = Xg(b, a.child, e.children, c);
        b.memoizedState = null;
        return b.child = c;
    }
    a = a.child;
    if (g) {
        g = e.fallback;
        e = Wg(null, d, 0, null);
        e.return = b;
        e.child = a;
        null !== a && (a.return = e);
        if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
        c = Wg(g, d, c, null);
        c.return = b;
        e.sibling = c;
        c.effectTag |= 2;
        e.childExpirationTime = 0;
        b.memoizedState = ii;
        b.child = e;
        return c;
    }
    b.memoizedState = null;
    return b.child = Xg(b, a, e.children, c);
}
function ki(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    pg(a.return, b);
}
function li(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailExpiration: 0,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailExpiration = 0, g.tailMode = e, g.lastEffect = f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    R(a, b, d.children, c);
    d = M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.effectTag |= 64;
    else {
        if (null !== a && 0 !== (a.effectTag & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && ki(a, c);
            else if (19 === a.tag) ki(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(M, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === hh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            li(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === hh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            li(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            li(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $h(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    var d = b.expirationTime;
    0 !== d && Bg(d);
    if (b.childExpirationTime < c) return null;
    if (null !== a && b.child !== a.child) throw Error(u(153));
    if (null !== b.child) {
        a = b.child;
        c = Sg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Sg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
var ni, oi, pi, qi;
ni = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
oi = function() {};
pi = function(a, b, c, d, e) {
    var f = a.memoizedProps;
    if (f !== d) {
        var g = b.stateNode;
        ch($g.current);
        a = null;
        switch(c){
            case "input":
                f = zb(g, f);
                d = zb(g, d);
                a = [];
                break;
            case "option":
                f = Gb(g, f);
                d = Gb(g, d);
                a = [];
                break;
            case "select":
                f = $haJ2X({}, f, {
                    value: void 0
                });
                d = $haJ2X({}, d, {
                    value: void 0
                });
                a = [];
                break;
            case "textarea":
                f = Ib(g, f);
                d = Ib(g, d);
                a = [];
                break;
            default:
                "function" !== typeof f.onClick && "function" === typeof d.onClick && (g.onclick = sd);
        }
        od(c, d);
        var h, k;
        c = null;
        for(h in f)if (!d.hasOwnProperty(h) && f.hasOwnProperty(h) && null != f[h]) {
            if ("style" === h) for(k in g = f[h], g)g.hasOwnProperty(k) && (c || (c = {}), c[k] = "");
            else "dangerouslySetInnerHTML" !== h && "children" !== h && "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && "autoFocus" !== h && (va.hasOwnProperty(h) ? a || (a = []) : (a = a || []).push(h, null));
        }
        for(h in d){
            var l = d[h];
            g = null != f ? f[h] : void 0;
            if (d.hasOwnProperty(h) && l !== g && (null != l || null != g)) {
                if ("style" === h) {
                    if (g) {
                        for(k in g)!g.hasOwnProperty(k) || l && l.hasOwnProperty(k) || (c || (c = {}), c[k] = "");
                        for(k in l)l.hasOwnProperty(k) && g[k] !== l[k] && (c || (c = {}), c[k] = l[k]);
                    } else c || (a || (a = []), a.push(h, c)), c = l;
                } else "dangerouslySetInnerHTML" === h ? (l = l ? l.__html : void 0, g = g ? g.__html : void 0, null != l && g !== l && (a = a || []).push(h, l)) : "children" === h ? g === l || "string" !== typeof l && "number" !== typeof l || (a = a || []).push(h, "" + l) : "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && (va.hasOwnProperty(h) ? (null != l && rd(e, h), a || g === l || (a = [])) : (a = a || []).push(h, l));
            }
        }
        c && (a = a || []).push("style", c);
        e = a;
        if (b.updateQueue = e) b.effectTag |= 4;
    }
};
qi = function(a, b, c, d) {
    c !== d && (b.effectTag |= 4);
};
function ri(a, b) {
    switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function si(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return L(b.type) && Df(), null;
        case 3:
            return eh(), H(K), H(J), c = b.stateNode, c.pendingContext && (c.context = c.pendingContext, c.pendingContext = null), null !== a && null !== a.child || !Wh(b) || (b.effectTag |= 4), oi(b), null;
        case 5:
            gh(b);
            c = ch(bh.current);
            var e = b.type;
            if (null !== a && null != b.stateNode) pi(a, b, e, d, c), a.ref !== b.ref && (b.effectTag |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(u(166));
                    return null;
                }
                a = ch($g.current);
                if (Wh(b)) {
                    d = b.stateNode;
                    e = b.type;
                    var f = b.memoizedProps;
                    d[Md] = b;
                    d[Nd] = f;
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < ac.length; a++)F(ac[a], d);
                            break;
                        case "source":
                            F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            F("error", d);
                            F("load", d);
                            break;
                        case "form":
                            F("reset", d);
                            F("submit", d);
                            break;
                        case "details":
                            F("toggle", d);
                            break;
                        case "input":
                            Ab(d, f);
                            F("invalid", d);
                            rd(c, "onChange");
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            F("invalid", d);
                            rd(c, "onChange");
                            break;
                        case "textarea":
                            Jb(d, f), F("invalid", d), rd(c, "onChange");
                    }
                    od(e, f);
                    a = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (a = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (a = [
                            "children",
                            "" + h
                        ]) : va.hasOwnProperty(g) && null != h && rd(c, g);
                    }
                    switch(e){
                        case "input":
                            xb(d);
                            Eb(d, f, !0);
                            break;
                        case "textarea":
                            xb(d);
                            Lb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = sd);
                    }
                    c = a;
                    b.updateQueue = c;
                    null !== c && (b.effectTag |= 4);
                } else {
                    g = 9 === c.nodeType ? c : c.ownerDocument;
                    a === qd && (a = Nb(e));
                    a === qd ? "script" === e ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(e, {
                        is: d.is
                    }) : (a = g.createElement(e), "select" === e && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, e);
                    a[Md] = b;
                    a[Nd] = d;
                    ni(a, b, !1, !1);
                    b.stateNode = a;
                    g = pd(e, d);
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            F("load", a);
                            h = d;
                            break;
                        case "video":
                        case "audio":
                            for(h = 0; h < ac.length; h++)F(ac[h], a);
                            h = d;
                            break;
                        case "source":
                            F("error", a);
                            h = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            F("error", a);
                            F("load", a);
                            h = d;
                            break;
                        case "form":
                            F("reset", a);
                            F("submit", a);
                            h = d;
                            break;
                        case "details":
                            F("toggle", a);
                            h = d;
                            break;
                        case "input":
                            Ab(a, d);
                            h = zb(a, d);
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        case "option":
                            h = Gb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            h = $haJ2X({}, d, {
                                value: void 0
                            });
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        case "textarea":
                            Jb(a, d);
                            h = Ib(a, d);
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        default:
                            h = d;
                    }
                    od(e, h);
                    var k = h;
                    for(f in k)if (k.hasOwnProperty(f)) {
                        var l = k[f];
                        "style" === f ? md(a, l) : "dangerouslySetInnerHTML" === f ? (l = l ? l.__html : void 0, null != l && Qb(a, l)) : "children" === f ? "string" === typeof l ? ("textarea" !== e || "" !== l) && Rb(a, l) : "number" === typeof l && Rb(a, "" + l) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (va.hasOwnProperty(f) ? null != l && rd(c, f) : null != l && Xa(a, f, l, g));
                    }
                    switch(e){
                        case "input":
                            xb(a);
                            Eb(a, d, !1);
                            break;
                        case "textarea":
                            xb(a);
                            Lb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + rb(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            c = d.value;
                            null != c ? Hb(a, !!d.multiple, c, !1) : null != d.defaultValue && Hb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof h.onClick && (a.onclick = sd);
                    }
                    Fd(e, d) && (b.effectTag |= 4);
                }
                null !== b.ref && (b.effectTag |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) qi(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(u(166));
                c = ch(bh.current);
                ch($g.current);
                Wh(b) ? (c = b.stateNode, d = b.memoizedProps, c[Md] = b, c.nodeValue !== d && (b.effectTag |= 4)) : (c = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), c[Md] = b, b.stateNode = c);
            }
            return null;
        case 13:
            H(M);
            d = b.memoizedState;
            if (0 !== (b.effectTag & 64)) return b.expirationTime = c, b;
            c = null !== d;
            d = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && Wh(b) : (e = a.memoizedState, d = null !== e, c || null === e || (e = a.child.sibling, null !== e && (f = b.firstEffect, null !== f ? (b.firstEffect = e, e.nextEffect = f) : (b.firstEffect = b.lastEffect = e, e.nextEffect = null), e.effectTag = 8)));
            if (c && !d && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (M.current & 1)) S === ti && (S = ui);
                else {
                    if (S === ti || S === ui) S = vi;
                    0 !== wi && null !== T && (xi(T, U), yi(T, wi));
                }
            }
            if (c || d) b.effectTag |= 4;
            return null;
        case 4:
            return eh(), oi(b), null;
        case 10:
            return og(b), null;
        case 17:
            return L(b.type) && Df(), null;
        case 19:
            H(M);
            d = b.memoizedState;
            if (null === d) return null;
            e = 0 !== (b.effectTag & 64);
            f = d.rendering;
            if (null === f) {
                if (e) ri(d, !1);
                else {
                    if (S !== ti || null !== a && 0 !== (a.effectTag & 64)) for(f = b.child; null !== f;){
                        a = hh(f);
                        if (null !== a) {
                            b.effectTag |= 64;
                            ri(d, !1);
                            e = a.updateQueue;
                            null !== e && (b.updateQueue = e, b.effectTag |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            for(d = b.child; null !== d;)e = d, f = c, e.effectTag &= 2, e.nextEffect = null, e.firstEffect = null, e.lastEffect = null, a = e.alternate, null === a ? (e.childExpirationTime = 0, e.expirationTime = f, e.child = null, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null) : (e.childExpirationTime = a.childExpirationTime, e.expirationTime = a.expirationTime, e.child = a.child, e.memoizedProps = a.memoizedProps, e.memoizedState = a.memoizedState, e.updateQueue = a.updateQueue, f = a.dependencies, e.dependencies = null === f ? null : {
                                expirationTime: f.expirationTime,
                                firstContext: f.firstContext,
                                responders: f.responders
                            }), d = d.sibling;
                            I(M, M.current & 1 | 2);
                            return b.child;
                        }
                        f = f.sibling;
                    }
                }
            } else {
                if (!e) {
                    if (a = hh(f), null !== a) {
                        if (b.effectTag |= 64, e = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.effectTag |= 4), ri(d, !0), null === d.tail && "hidden" === d.tailMode && !f.alternate) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * $f() - d.renderingStartTime > d.tailExpiration && 1 < c && (b.effectTag |= 64, e = !0, ri(d, !1), b.expirationTime = b.childExpirationTime = c - 1);
                }
                d.isBackwards ? (f.sibling = b.child, b.child = f) : (c = d.last, null !== c ? c.sibling = f : b.child = f, d.last = f);
            }
            return null !== d.tail ? (0 === d.tailExpiration && (d.tailExpiration = $f() + 500), c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = $f(), c.sibling = null, b = M.current, I(M, e ? b & 1 | 2 : b & 1), c) : null;
    }
    throw Error(u(156, b.tag));
}
function zi(a) {
    switch(a.tag){
        case 1:
            L(a.type) && Df();
            var b = a.effectTag;
            return b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 3:
            eh();
            H(K);
            H(J);
            b = a.effectTag;
            if (0 !== (b & 64)) throw Error(u(285));
            a.effectTag = b & -4097 | 64;
            return a;
        case 5:
            return gh(a), null;
        case 13:
            return H(M), b = a.effectTag, b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 19:
            return H(M), null;
        case 4:
            return eh(), null;
        case 10:
            return og(a), null;
        default:
            return null;
    }
}
function Ai(a, b) {
    return {
        value: a,
        source: b,
        stack: qb(b)
    };
}
var Bi = "function" === typeof WeakSet ? WeakSet : Set;
function Ci(a, b) {
    var c = b.source, d = b.stack;
    null === d && null !== c && (d = qb(c));
    null !== c && pb(c.type);
    b = b.value;
    null !== a && 1 === a.tag && pb(a.type);
    try {
        console.error(b);
    } catch (e) {
        setTimeout(function() {
            throw e;
        });
    }
}
function Di(a, b) {
    try {
        b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
    } catch (c) {
        Ei(a, c);
    }
}
function Fi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Ei(a, c);
        }
        else b.current = null;
    }
}
function Gi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.effectTag & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : ig(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(u(163));
}
function Hi(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.destroy;
                c.destroy = void 0;
                void 0 !== d && d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Ii(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Ji(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            Ii(3, c);
            return;
        case 1:
            a = c.stateNode;
            if (c.effectTag & 4) {
                if (null === b) a.componentDidMount();
                else {
                    var d = c.elementType === c.type ? b.memoizedProps : ig(c.type, b.memoizedProps);
                    a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate);
                }
            }
            b = c.updateQueue;
            null !== b && Cg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Cg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.effectTag & 4 && Fd(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Vc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
            return;
    }
    throw Error(u(163));
}
function Ki(a, b, c) {
    "function" === typeof Li && Li(b);
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var d = a.next;
                cg(97 < c ? 97 : c, function() {
                    var a = d;
                    do {
                        var c = a.destroy;
                        if (void 0 !== c) {
                            var g = b;
                            try {
                                c();
                            } catch (h) {
                                Ei(g, h);
                            }
                        }
                        a = a.next;
                    }while (a !== d);
                });
            }
            break;
        case 1:
            Fi(b);
            c = b.stateNode;
            "function" === typeof c.componentWillUnmount && Di(b, c);
            break;
        case 5:
            Fi(b);
            break;
        case 4:
            Mi(a, b, c);
    }
}
function Ni(a) {
    var b = a.alternate;
    a.return = null;
    a.child = null;
    a.memoizedState = null;
    a.updateQueue = null;
    a.dependencies = null;
    a.alternate = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.pendingProps = null;
    a.memoizedProps = null;
    a.stateNode = null;
    null !== b && Ni(b);
}
function Oi(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Pi(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (Oi(b)) {
                var c = b;
                break a;
            }
            b = b.return;
        }
        throw Error(u(160));
    }
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(u(161));
    }
    c.effectTag & 16 && (Rb(b, ""), c.effectTag &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || Oi(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.effectTag & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.effectTag & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? Qi(a, c, b) : Ri(a, c, b);
}
function Qi(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = sd));
    else if (4 !== d && (a = a.child, null !== a)) for(Qi(a, b, c), a = a.sibling; null !== a;)Qi(a, b, c), a = a.sibling;
}
function Ri(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Ri(a, b, c), a = a.sibling; null !== a;)Ri(a, b, c), a = a.sibling;
}
function Mi(a, b, c) {
    for(var d = b, e = !1, f, g;;){
        if (!e) {
            e = d.return;
            a: for(;;){
                if (null === e) throw Error(u(160));
                f = e.stateNode;
                switch(e.tag){
                    case 5:
                        g = !1;
                        break a;
                    case 3:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                    case 4:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                }
                e = e.return;
            }
            e = !0;
        }
        if (5 === d.tag || 6 === d.tag) {
            a: for(var h = a, k = d, l = c, m = k;;)if (Ki(h, m, l), null !== m.child && 4 !== m.tag) m.child.return = m, m = m.child;
            else {
                if (m === k) break a;
                for(; null === m.sibling;){
                    if (null === m.return || m.return === k) break a;
                    m = m.return;
                }
                m.sibling.return = m.return;
                m = m.sibling;
            }
            g ? (h = f, k = d.stateNode, 8 === h.nodeType ? h.parentNode.removeChild(k) : h.removeChild(k)) : f.removeChild(d.stateNode);
        } else if (4 === d.tag) {
            if (null !== d.child) {
                f = d.stateNode.containerInfo;
                g = !0;
                d.child.return = d;
                d = d.child;
                continue;
            }
        } else if (Ki(a, d, c), null !== d.child) {
            d.child.return = d;
            d = d.child;
            continue;
        }
        if (d === b) break;
        for(; null === d.sibling;){
            if (null === d.return || d.return === b) return;
            d = d.return;
            4 === d.tag && (e = !1);
        }
        d.sibling.return = d.return;
        d = d.sibling;
    }
}
function Si(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            Hi(3, b);
            return;
        case 1:
            return;
        case 5:
            var c = b.stateNode;
            if (null != c) {
                var d = b.memoizedProps, e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[Nd] = d;
                    "input" === a && "radio" === d.type && null != d.name && Bb(c, d);
                    pd(a, e);
                    b = pd(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? md(c, h) : "dangerouslySetInnerHTML" === g ? Qb(c, h) : "children" === g ? Rb(c, h) : Xa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            Cb(c, d);
                            break;
                        case "textarea":
                            Kb(c, d);
                            break;
                        case "select":
                            b = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, a = d.value, null != a ? Hb(c, !!d.multiple, a, !1) : b !== !!d.multiple && (null != d.defaultValue ? Hb(c, !!d.multiple, d.defaultValue, !0) : Hb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(u(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            b = b.stateNode;
            b.hydrate && (b.hydrate = !1, Vc(b.containerInfo));
            return;
        case 12:
            return;
        case 13:
            c = b;
            null === b.memoizedState ? d = !1 : (d = !0, c = b.child, Ti = $f());
            if (null !== c) a: for(a = c;;){
                if (5 === a.tag) f = a.stateNode, d ? (f = f.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (f = a.stateNode, e = a.memoizedProps.style, e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null, f.style.display = ld("display", e));
                else if (6 === a.tag) a.stateNode.nodeValue = d ? "" : a.memoizedProps;
                else if (13 === a.tag && null !== a.memoizedState && null === a.memoizedState.dehydrated) {
                    f = a.child.sibling;
                    f.return = a;
                    a = f;
                    continue;
                } else if (null !== a.child) {
                    a.child.return = a;
                    a = a.child;
                    continue;
                }
                if (a === c) break;
                for(; null === a.sibling;){
                    if (null === a.return || a.return === c) break a;
                    a = a.return;
                }
                a.sibling.return = a.return;
                a = a.sibling;
            }
            Ui(b);
            return;
        case 19:
            Ui(b);
            return;
        case 17:
            return;
    }
    throw Error(u(163));
}
function Ui(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Bi);
        b.forEach(function(b) {
            var d = Vi.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
var Wi = "function" === typeof WeakMap ? WeakMap : Map;
function Xi(a, b, c) {
    c = wg(c, null);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Yi || (Yi = !0, Zi = d);
        Ci(a, b);
    };
    return c;
}
function $i(a, b, c) {
    c = wg(c, null);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ci(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === aj ? aj = new Set([
            this
        ]) : aj.add(this), Ci(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var bj = Math.ceil, cj = Wa.ReactCurrentDispatcher, dj = Wa.ReactCurrentOwner, V = 0, ej = 8, fj = 16, gj = 32, ti = 0, hj = 1, ij = 2, ui = 3, vi = 4, jj = 5, W = V, T = null, X = null, U = 0, S = ti, kj = null, lj = 1073741823, mj = 1073741823, nj = null, wi = 0, oj = !1, Ti = 0, pj = 500, Y = null, Yi = !1, Zi = null, aj = null, qj = !1, rj = null, sj = 90, tj = null, uj = 0, vj = null, wj = 0;
function Gg() {
    return (W & (fj | gj)) !== V ? 1073741821 - ($f() / 10 | 0) : 0 !== wj ? wj : wj = 1073741821 - ($f() / 10 | 0);
}
function Hg(a, b, c) {
    b = b.mode;
    if (0 === (b & 2)) return 1073741823;
    var d = ag();
    if (0 === (b & 4)) return 99 === d ? 1073741823 : 1073741822;
    if ((W & fj) !== V) return U;
    if (null !== c) a = hg(a, c.timeoutMs | 0 || 5E3, 250);
    else switch(d){
        case 99:
            a = 1073741823;
            break;
        case 98:
            a = hg(a, 150, 100);
            break;
        case 97:
        case 96:
            a = hg(a, 5E3, 250);
            break;
        case 95:
            a = 2;
            break;
        default:
            throw Error(u(326));
    }
    null !== T && a === U && --a;
    return a;
}
function Ig(a, b) {
    if (50 < uj) throw uj = 0, vj = null, Error(u(185));
    a = xj(a, b);
    if (null !== a) {
        var c = ag();
        1073741823 === b ? (W & ej) !== V && (W & (fj | gj)) === V ? yj(a) : (Z(a), W === V && gg()) : Z(a);
        (W & 4) === V || 98 !== c && 99 !== c || (null === tj ? tj = new Map([
            [
                a,
                b
            ]
        ]) : (c = tj.get(a), (void 0 === c || c > b) && tj.set(a, b)));
    }
}
function xj(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    var d = a.return, e = null;
    if (null === d && 3 === a.tag) e = a.stateNode;
    else for(; null !== d;){
        c = d.alternate;
        d.childExpirationTime < b && (d.childExpirationTime = b);
        null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        if (null === d.return && 3 === d.tag) {
            e = d.stateNode;
            break;
        }
        d = d.return;
    }
    null !== e && (T === e && (Bg(b), S === vi && xi(e, U)), yi(e, b));
    return e;
}
function zj(a) {
    var b = a.lastExpiredTime;
    if (0 !== b) return b;
    b = a.firstPendingTime;
    if (!Aj(a, b)) return b;
    var c = a.lastPingedTime;
    a = a.nextKnownPendingLevel;
    a = c > a ? c : a;
    return 2 >= a && b !== a ? 0 : a;
}
function Z(a) {
    if (0 !== a.lastExpiredTime) a.callbackExpirationTime = 1073741823, a.callbackPriority = 99, a.callbackNode = eg(yj.bind(null, a));
    else {
        var b = zj(a), c = a.callbackNode;
        if (0 === b) null !== c && (a.callbackNode = null, a.callbackExpirationTime = 0, a.callbackPriority = 90);
        else {
            var d = Gg();
            1073741823 === b ? d = 99 : 1 === b || 2 === b ? d = 95 : (d = 10 * (1073741821 - b) - 10 * (1073741821 - d), d = 0 >= d ? 99 : 250 >= d ? 98 : 5250 >= d ? 97 : 95);
            if (null !== c) {
                var e = a.callbackPriority;
                if (a.callbackExpirationTime === b && e >= d) return;
                c !== Tf && Kf(c);
            }
            a.callbackExpirationTime = b;
            a.callbackPriority = d;
            b = 1073741823 === b ? eg(yj.bind(null, a)) : dg(d, Bj.bind(null, a), {
                timeout: 10 * (1073741821 - b) - $f()
            });
            a.callbackNode = b;
        }
    }
}
function Bj(a, b) {
    wj = 0;
    if (b) return b = Gg(), Cj(a, b), Z(a), null;
    var c = zj(a);
    if (0 !== c) {
        b = a.callbackNode;
        if ((W & (fj | gj)) !== V) throw Error(u(327));
        Dj();
        a === T && c === U || Ej(a, c);
        if (null !== X) {
            var d = W;
            W |= fj;
            var e = Fj();
            for(;;)try {
                Gj();
                break;
            } catch (h) {
                Hj(a, h);
            }
            ng();
            W = d;
            cj.current = e;
            if (S === hj) throw b = kj, Ej(a, c), xi(a, c), Z(a), b;
            if (null === X) switch(e = a.finishedWork = a.current.alternate, a.finishedExpirationTime = c, d = S, T = null, d){
                case ti:
                case hj:
                    throw Error(u(345));
                case ij:
                    Cj(a, 2 < c ? 2 : c);
                    break;
                case ui:
                    xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = Ij(e));
                    if (1073741823 === lj && (e = Ti + pj - $f(), 10 < e)) {
                        if (oj) {
                            var f = a.lastPingedTime;
                            if (0 === f || f >= c) {
                                a.lastPingedTime = c;
                                Ej(a, c);
                                break;
                            }
                        }
                        f = zj(a);
                        if (0 !== f && f !== c) break;
                        if (0 !== d && d !== c) {
                            a.lastPingedTime = d;
                            break;
                        }
                        a.timeoutHandle = Hd(Jj.bind(null, a), e);
                        break;
                    }
                    Jj(a);
                    break;
                case vi:
                    xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = Ij(e));
                    if (oj && (e = a.lastPingedTime, 0 === e || e >= c)) {
                        a.lastPingedTime = c;
                        Ej(a, c);
                        break;
                    }
                    e = zj(a);
                    if (0 !== e && e !== c) break;
                    if (0 !== d && d !== c) {
                        a.lastPingedTime = d;
                        break;
                    }
                    1073741823 !== mj ? d = 10 * (1073741821 - mj) - $f() : 1073741823 === lj ? d = 0 : (d = 10 * (1073741821 - lj) - 5E3, e = $f(), c = 10 * (1073741821 - c) - e, d = e - d, 0 > d && (d = 0), d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * bj(d / 1960)) - d, c < d && (d = c));
                    if (10 < d) {
                        a.timeoutHandle = Hd(Jj.bind(null, a), d);
                        break;
                    }
                    Jj(a);
                    break;
                case jj:
                    if (1073741823 !== lj && null !== nj) {
                        f = lj;
                        var g = nj;
                        d = g.busyMinDurationMs | 0;
                        0 >= d ? d = 0 : (e = g.busyDelayMs | 0, f = $f() - (10 * (1073741821 - f) - (g.timeoutMs | 0 || 5E3)), d = f <= e ? 0 : e + d - f);
                        if (10 < d) {
                            xi(a, c);
                            a.timeoutHandle = Hd(Jj.bind(null, a), d);
                            break;
                        }
                    }
                    Jj(a);
                    break;
                default:
                    throw Error(u(329));
            }
            Z(a);
            if (a.callbackNode === b) return Bj.bind(null, a);
        }
    }
    return null;
}
function yj(a) {
    var b = a.lastExpiredTime;
    b = 0 !== b ? b : 1073741823;
    if ((W & (fj | gj)) !== V) throw Error(u(327));
    Dj();
    a === T && b === U || Ej(a, b);
    if (null !== X) {
        var c = W;
        W |= fj;
        var d = Fj();
        for(;;)try {
            Kj();
            break;
        } catch (e) {
            Hj(a, e);
        }
        ng();
        W = c;
        cj.current = d;
        if (S === hj) throw c = kj, Ej(a, b), xi(a, b), Z(a), c;
        if (null !== X) throw Error(u(261));
        a.finishedWork = a.current.alternate;
        a.finishedExpirationTime = b;
        T = null;
        Jj(a);
        Z(a);
    }
    return null;
}
function Lj() {
    if (null !== tj) {
        var a = tj;
        tj = null;
        a.forEach(function(a, c) {
            Cj(c, a);
            Z(c);
        });
        gg();
    }
}
function Mj(a, b) {
    var c = W;
    W |= 1;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
}
function Nj(a, b) {
    var c = W;
    W &= -2;
    W |= ej;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
}
function Ej(a, b) {
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Id(c));
    if (null !== X) for(c = X.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Df();
                break;
            case 3:
                eh();
                H(K);
                H(J);
                break;
            case 5:
                gh(d);
                break;
            case 4:
                eh();
                break;
            case 13:
                H(M);
                break;
            case 19:
                H(M);
                break;
            case 10:
                og(d);
        }
        c = c.return;
    }
    T = a;
    X = Sg(a.current, null);
    U = b;
    S = ti;
    kj = null;
    mj = lj = 1073741823;
    nj = null;
    wi = 0;
    oj = !1;
}
function Hj(a, b) {
    do {
        try {
            ng();
            jh.current = sh;
            if (mh) for(var c = N.memoizedState; null !== c;){
                var d = c.queue;
                null !== d && (d.pending = null);
                c = c.next;
            }
            lh = 0;
            P = O = N = null;
            mh = !1;
            if (null === X || null === X.return) return S = hj, kj = b, X = null;
            a: {
                var e = a, f = X.return, g = X, h = b;
                b = U;
                g.effectTag |= 2048;
                g.firstEffect = g.lastEffect = null;
                if (null !== h && "object" === typeof h && "function" === typeof h.then) {
                    var k = h;
                    if (0 === (g.mode & 2)) {
                        var l = g.alternate;
                        l ? (g.updateQueue = l.updateQueue, g.memoizedState = l.memoizedState, g.expirationTime = l.expirationTime) : (g.updateQueue = null, g.memoizedState = null);
                    }
                    var m = 0 !== (M.current & 1), p = f;
                    do {
                        var x;
                        if (x = 13 === p.tag) {
                            var z = p.memoizedState;
                            if (null !== z) x = null !== z.dehydrated ? !0 : !1;
                            else {
                                var ca = p.memoizedProps;
                                x = void 0 === ca.fallback ? !1 : !0 !== ca.unstable_avoidThisFallback ? !0 : m ? !1 : !0;
                            }
                        }
                        if (x) {
                            var D = p.updateQueue;
                            if (null === D) {
                                var t = new Set;
                                t.add(k);
                                p.updateQueue = t;
                            } else D.add(k);
                            if (0 === (p.mode & 2)) {
                                p.effectTag |= 64;
                                g.effectTag &= -2981;
                                if (1 === g.tag) {
                                    if (null === g.alternate) g.tag = 17;
                                    else {
                                        var y = wg(1073741823, null);
                                        y.tag = 2;
                                        xg(g, y);
                                    }
                                }
                                g.expirationTime = 1073741823;
                                break a;
                            }
                            h = void 0;
                            g = b;
                            var A = e.pingCache;
                            null === A ? (A = e.pingCache = new Wi, h = new Set, A.set(k, h)) : (h = A.get(k), void 0 === h && (h = new Set, A.set(k, h)));
                            if (!h.has(g)) {
                                h.add(g);
                                var q = Oj.bind(null, e, k, g);
                                k.then(q, q);
                            }
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    h = Error((pb(g.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + qb(g));
                }
                S !== jj && (S = ij);
                h = Ai(h, g);
                p = f;
                do {
                    switch(p.tag){
                        case 3:
                            k = h;
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            var B = Xi(p, k, b);
                            yg(p, B);
                            break a;
                        case 1:
                            k = h;
                            var w = p.type, ub = p.stateNode;
                            if (0 === (p.effectTag & 64) && ("function" === typeof w.getDerivedStateFromError || null !== ub && "function" === typeof ub.componentDidCatch && (null === aj || !aj.has(ub)))) {
                                p.effectTag |= 4096;
                                p.expirationTime = b;
                                var vb = $i(p, k, b);
                                yg(p, vb);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            X = Pj(X);
        } catch (Xc) {
            b = Xc;
            continue;
        }
        break;
    }while (1);
}
function Fj() {
    var a = cj.current;
    cj.current = sh;
    return null === a ? sh : a;
}
function Ag(a, b) {
    a < lj && 2 < a && (lj = a);
    null !== b && a < mj && 2 < a && (mj = a, nj = b);
}
function Bg(a) {
    a > wi && (wi = a);
}
function Kj() {
    for(; null !== X;)X = Qj(X);
}
function Gj() {
    for(; null !== X && !Uf();)X = Qj(X);
}
function Qj(a) {
    var b = Rj(a.alternate, a, U);
    a.memoizedProps = a.pendingProps;
    null === b && (b = Pj(a));
    dj.current = null;
    return b;
}
function Pj(a) {
    X = a;
    do {
        var b = X.alternate;
        a = X.return;
        if (0 === (X.effectTag & 2048)) {
            b = si(b, X, U);
            if (1 === U || 1 !== X.childExpirationTime) {
                for(var c = 0, d = X.child; null !== d;){
                    var e = d.expirationTime, f = d.childExpirationTime;
                    e > c && (c = e);
                    f > c && (c = f);
                    d = d.sibling;
                }
                X.childExpirationTime = c;
            }
            if (null !== b) return b;
            null !== a && 0 === (a.effectTag & 2048) && (null === a.firstEffect && (a.firstEffect = X.firstEffect), null !== X.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = X.firstEffect), a.lastEffect = X.lastEffect), 1 < X.effectTag && (null !== a.lastEffect ? a.lastEffect.nextEffect = X : a.firstEffect = X, a.lastEffect = X));
        } else {
            b = zi(X);
            if (null !== b) return b.effectTag &= 2047, b;
            null !== a && (a.firstEffect = a.lastEffect = null, a.effectTag |= 2048);
        }
        b = X.sibling;
        if (null !== b) return b;
        X = a;
    }while (null !== X);
    S === ti && (S = jj);
    return null;
}
function Ij(a) {
    var b = a.expirationTime;
    a = a.childExpirationTime;
    return b > a ? b : a;
}
function Jj(a) {
    var b = ag();
    cg(99, Sj.bind(null, a, b));
    return null;
}
function Sj(a, b) {
    do Dj();
    while (null !== rj);
    if ((W & (fj | gj)) !== V) throw Error(u(327));
    var c = a.finishedWork, d = a.finishedExpirationTime;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    if (c === a.current) throw Error(u(177));
    a.callbackNode = null;
    a.callbackExpirationTime = 0;
    a.callbackPriority = 90;
    a.nextKnownPendingLevel = 0;
    var e = Ij(c);
    a.firstPendingTime = e;
    d <= a.lastSuspendedTime ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : d <= a.firstSuspendedTime && (a.firstSuspendedTime = d - 1);
    d <= a.lastPingedTime && (a.lastPingedTime = 0);
    d <= a.lastExpiredTime && (a.lastExpiredTime = 0);
    a === T && (X = T = null, U = 0);
    1 < c.effectTag ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, e = c.firstEffect) : e = c : e = c.firstEffect;
    if (null !== e) {
        var f = W;
        W |= gj;
        dj.current = null;
        Dd = fd;
        var g = xd();
        if (yd(g)) {
            if ("selectionStart" in g) var h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: {
                h = (h = g.ownerDocument) && h.defaultView || window;
                var k = h.getSelection && h.getSelection();
                if (k && 0 !== k.rangeCount) {
                    h = k.anchorNode;
                    var l = k.anchorOffset, m = k.focusNode;
                    k = k.focusOffset;
                    try {
                        h.nodeType, m.nodeType;
                    } catch (wb) {
                        h = null;
                        break a;
                    }
                    var p = 0, x = -1, z = -1, ca = 0, D = 0, t = g, y = null;
                    b: for(;;){
                        for(var A;;){
                            t !== h || 0 !== l && 3 !== t.nodeType || (x = p + l);
                            t !== m || 0 !== k && 3 !== t.nodeType || (z = p + k);
                            3 === t.nodeType && (p += t.nodeValue.length);
                            if (null === (A = t.firstChild)) break;
                            y = t;
                            t = A;
                        }
                        for(;;){
                            if (t === g) break b;
                            y === h && ++ca === l && (x = p);
                            y === m && ++D === k && (z = p);
                            if (null !== (A = t.nextSibling)) break;
                            t = y;
                            y = t.parentNode;
                        }
                        t = A;
                    }
                    h = -1 === x || -1 === z ? null : {
                        start: x,
                        end: z
                    };
                } else h = null;
            }
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        Ed = {
            activeElementDetached: null,
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Y = e;
        do try {
            Tj();
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        Y = e;
        do try {
            for(g = a, h = b; null !== Y;){
                var q = Y.effectTag;
                q & 16 && Rb(Y.stateNode, "");
                if (q & 128) {
                    var B = Y.alternate;
                    if (null !== B) {
                        var w = B.ref;
                        null !== w && ("function" === typeof w ? w(null) : w.current = null);
                    }
                }
                switch(q & 1038){
                    case 2:
                        Pi(Y);
                        Y.effectTag &= -3;
                        break;
                    case 6:
                        Pi(Y);
                        Y.effectTag &= -3;
                        Si(Y.alternate, Y);
                        break;
                    case 1024:
                        Y.effectTag &= -1025;
                        break;
                    case 1028:
                        Y.effectTag &= -1025;
                        Si(Y.alternate, Y);
                        break;
                    case 4:
                        Si(Y.alternate, Y);
                        break;
                    case 8:
                        l = Y, Mi(g, l, h), Ni(l);
                }
                Y = Y.nextEffect;
            }
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        w = Ed;
        B = xd();
        q = w.focusedElem;
        h = w.selectionRange;
        if (B !== q && q && q.ownerDocument && wd(q.ownerDocument.documentElement, q)) {
            null !== h && yd(q) && (B = h.start, w = h.end, void 0 === w && (w = B), "selectionStart" in q ? (q.selectionStart = B, q.selectionEnd = Math.min(w, q.value.length)) : (w = (B = q.ownerDocument || document) && B.defaultView || window, w.getSelection && (w = w.getSelection(), l = q.textContent.length, g = Math.min(h.start, l), h = void 0 === h.end ? g : Math.min(h.end, l), !w.extend && g > h && (l = h, h = g, g = l), l = vd(q, g), m = vd(q, h), l && m && (1 !== w.rangeCount || w.anchorNode !== l.node || w.anchorOffset !== l.offset || w.focusNode !== m.node || w.focusOffset !== m.offset) && (B = B.createRange(), B.setStart(l.node, l.offset), w.removeAllRanges(), g > h ? (w.addRange(B), w.extend(m.node, m.offset)) : (B.setEnd(m.node, m.offset), w.addRange(B))))));
            B = [];
            for(w = q; w = w.parentNode;)1 === w.nodeType && B.push({
                element: w,
                left: w.scrollLeft,
                top: w.scrollTop
            });
            "function" === typeof q.focus && q.focus();
            for(q = 0; q < B.length; q++)w = B[q], w.element.scrollLeft = w.left, w.element.scrollTop = w.top;
        }
        fd = !!Dd;
        Ed = Dd = null;
        a.current = c;
        Y = e;
        do try {
            for(q = a; null !== Y;){
                var ub = Y.effectTag;
                ub & 36 && Ji(q, Y.alternate, Y);
                if (ub & 128) {
                    B = void 0;
                    var vb = Y.ref;
                    if (null !== vb) {
                        var Xc = Y.stateNode;
                        switch(Y.tag){
                            case 5:
                                B = Xc;
                                break;
                            default:
                                B = Xc;
                        }
                        "function" === typeof vb ? vb(B) : vb.current = B;
                    }
                }
                Y = Y.nextEffect;
            }
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        Y = null;
        Vf();
        W = f;
    } else a.current = c;
    if (qj) qj = !1, rj = a, sj = b;
    else for(Y = e; null !== Y;)b = Y.nextEffect, Y.nextEffect = null, Y = b;
    b = a.firstPendingTime;
    0 === b && (aj = null);
    1073741823 === b ? a === vj ? uj++ : (uj = 0, vj = a) : uj = 0;
    "function" === typeof Uj && Uj(c.stateNode, d);
    Z(a);
    if (Yi) throw Yi = !1, a = Zi, Zi = null, a;
    if ((W & ej) !== V) return null;
    gg();
    return null;
}
function Tj() {
    for(; null !== Y;){
        var a = Y.effectTag;
        0 !== (a & 256) && Gi(Y.alternate, Y);
        0 === (a & 512) || qj || (qj = !0, dg(97, function() {
            Dj();
            return null;
        }));
        Y = Y.nextEffect;
    }
}
function Dj() {
    if (90 !== sj) {
        var a = 97 < sj ? 97 : sj;
        sj = 90;
        return cg(a, Vj);
    }
}
function Vj() {
    if (null === rj) return !1;
    var a = rj;
    rj = null;
    if ((W & (fj | gj)) !== V) throw Error(u(331));
    var b = W;
    W |= gj;
    for(a = a.current.firstEffect; null !== a;){
        try {
            var c = a;
            if (0 !== (c.effectTag & 512)) switch(c.tag){
                case 0:
                case 11:
                case 15:
                case 22:
                    Hi(5, c), Ii(5, c);
            }
        } catch (d) {
            if (null === a) throw Error(u(330));
            Ei(a, d);
        }
        c = a.nextEffect;
        a.nextEffect = null;
        a = c;
    }
    W = b;
    gg();
    return !0;
}
function Wj(a, b, c) {
    b = Ai(c, b);
    b = Xi(a, b, 1073741823);
    xg(a, b);
    a = xj(a, 1073741823);
    null !== a && Z(a);
}
function Ei(a, b) {
    if (3 === a.tag) Wj(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            Wj(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === aj || !aj.has(d))) {
                a = Ai(b, a);
                a = $i(c, a, 1073741823);
                xg(c, a);
                c = xj(c, 1073741823);
                null !== c && Z(c);
                break;
            }
        }
        c = c.return;
    }
}
function Oj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    T === a && U === c ? S === vi || S === ui && 1073741823 === lj && $f() - Ti < pj ? Ej(a, U) : oj = !0 : Aj(a, c) && (b = a.lastPingedTime, 0 !== b && b < c || (a.lastPingedTime = c, Z(a)));
}
function Vi(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = Gg(), b = Hg(b, a, null));
    a = xj(a, b);
    null !== a && Z(a);
}
var Rj;
Rj = function(a, b, c) {
    var d = b.expirationTime;
    if (null !== a) {
        var e = b.pendingProps;
        if (a.memoizedProps !== e || K.current) rg = !0;
        else {
            if (d < c) {
                rg = !1;
                switch(b.tag){
                    case 3:
                        hi(b);
                        Xh();
                        break;
                    case 5:
                        fh(b);
                        if (b.mode & 4 && 1 !== c && e.hidden) return b.expirationTime = b.childExpirationTime = 1, null;
                        break;
                    case 1:
                        L(b.type) && Gf(b);
                        break;
                    case 4:
                        dh(b, b.stateNode.containerInfo);
                        break;
                    case 10:
                        d = b.memoizedProps.value;
                        e = b.type._context;
                        I(jg, e._currentValue);
                        e._currentValue = d;
                        break;
                    case 13:
                        if (null !== b.memoizedState) {
                            d = b.child.childExpirationTime;
                            if (0 !== d && d >= c) return ji(a, b, c);
                            I(M, M.current & 1);
                            b = $h(a, b, c);
                            return null !== b ? b.sibling : null;
                        }
                        I(M, M.current & 1);
                        break;
                    case 19:
                        d = b.childExpirationTime >= c;
                        if (0 !== (a.effectTag & 64)) {
                            if (d) return mi(a, b, c);
                            b.effectTag |= 64;
                        }
                        e = b.memoizedState;
                        null !== e && (e.rendering = null, e.tail = null);
                        I(M, M.current);
                        if (!d) return null;
                }
                return $h(a, b, c);
            }
            rg = !1;
        }
    } else rg = !1;
    b.expirationTime = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
            a = b.pendingProps;
            e = Cf(b, J.current);
            qg(b, c);
            e = oh(null, b, d, a, e, c);
            b.effectTag |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (L(d)) {
                    var f = !0;
                    Gf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                ug(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Fg(b, d, g, a);
                e.updater = Jg;
                b.stateNode = e;
                e._reactInternalFiber = b;
                Ng(b, d, a, c);
                b = gi(null, b, d, !0, f, c);
            } else b.tag = 0, R(null, b, e, c), b = b.child;
            return b;
        case 16:
            a: {
                e = b.elementType;
                null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
                a = b.pendingProps;
                ob(e);
                if (1 !== e._status) throw e._result;
                e = e._result;
                b.type = e;
                f = b.tag = Xj(e);
                a = ig(e, a);
                switch(f){
                    case 0:
                        b = di(null, b, e, a, c);
                        break a;
                    case 1:
                        b = fi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = Zh(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ai(null, b, e, ig(e.type, a), d, c);
                        break a;
                }
                throw Error(u(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), di(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), fi(a, b, d, e, c);
        case 3:
            hi(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(u(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            vg(a, b);
            zg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) Xh(), b = $h(a, b, c);
            else {
                if (e = b.stateNode.hydrate) Ph = Jd(b.stateNode.containerInfo.firstChild), Oh = b, e = Qh = !0;
                if (e) for(c = Yg(b, null, d, c), b.child = c; c;)c.effectTag = c.effectTag & -3 | 1024, c = c.sibling;
                else R(a, b, d, c), Xh();
                b = b.child;
            }
            return b;
        case 5:
            return fh(b), null === a && Uh(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Gd(d, e) ? g = null : null !== f && Gd(d, f) && (b.effectTag |= 16), ei(a, b), b.mode & 4 && 1 !== c && e.hidden ? (b.expirationTime = b.childExpirationTime = 1, b = null) : (R(a, b, g, c), b = b.child), b;
        case 6:
            return null === a && Uh(b), null;
        case 13:
            return ji(a, b, c);
        case 4:
            return dh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Xg(b, null, d, c) : R(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), Zh(a, b, d, e, c);
        case 7:
            return R(a, b, b.pendingProps, c), b.child;
        case 8:
            return R(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return R(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(jg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = $e(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !K.current) {
                            b = $h(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = wg(c, null), l.tag = 2, xg(h, l));
                                    h.expirationTime < c && (h.expirationTime = c);
                                    l = h.alternate;
                                    null !== l && l.expirationTime < c && (l.expirationTime = c);
                                    pg(h.return, c);
                                    k.expirationTime < c && (k.expirationTime = c);
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                R(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, qg(b, c), e = sg(e, f.unstable_observedBits), d = d(e), b.effectTag |= 1, R(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = ig(e, b.pendingProps), f = ig(e.type, f), ai(a, b, e, f, d, c);
        case 15:
            return ci(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, L(d) ? (a = !0, Gf(b)) : a = !1, qg(b, c), Lg(b, d, e), Ng(b, d, e, c), gi(null, b, d, !0, a, c);
        case 19:
            return mi(a, b, c);
    }
    throw Error(u(156, b.tag));
};
var Uj = null, Li = null;
function Yj(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        var c = b.inject(a);
        Uj = function(a) {
            try {
                b.onCommitFiberRoot(c, a, void 0, 64 === (a.current.effectTag & 64));
            } catch (e) {}
        };
        Li = function(a) {
            try {
                b.onCommitFiberUnmount(c, a);
            } catch (e) {}
        };
    } catch (d) {}
    return !0;
}
function Zj(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.effectTag = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childExpirationTime = this.expirationTime = 0;
    this.alternate = null;
}
function Sh(a, b, c, d) {
    return new Zj(a, b, c, d);
}
function bi(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function Xj(a) {
    if ("function" === typeof a) return bi(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === gb) return 11;
        if (a === jb) return 14;
    }
    return 2;
}
function Sg(a, b) {
    var c = a.alternate;
    null === c ? (c = Sh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childExpirationTime = a.childExpirationTime;
    c.expirationTime = a.expirationTime;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        expirationTime: b.expirationTime,
        firstContext: b.firstContext,
        responders: b.responders
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Ug(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) bi(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ab:
            return Wg(c.children, e, f, b);
        case fb:
            g = 8;
            e |= 7;
            break;
        case bb:
            g = 8;
            e |= 1;
            break;
        case cb:
            return a = Sh(12, c, b, e | 8), a.elementType = cb, a.type = cb, a.expirationTime = f, a;
        case hb:
            return a = Sh(13, c, b, e), a.type = hb, a.elementType = hb, a.expirationTime = f, a;
        case ib:
            return a = Sh(19, c, b, e), a.elementType = ib, a.expirationTime = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case db:
                    g = 10;
                    break a;
                case eb:
                    g = 9;
                    break a;
                case gb:
                    g = 11;
                    break a;
                case jb:
                    g = 14;
                    break a;
                case kb:
                    g = 16;
                    d = null;
                    break a;
                case lb:
                    g = 22;
                    break a;
            }
            throw Error(u(130, null == a ? a : typeof a, ""));
    }
    b = Sh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.expirationTime = f;
    return b;
}
function Wg(a, b, c, d) {
    a = Sh(7, a, d, b);
    a.expirationTime = c;
    return a;
}
function Tg(a, b, c) {
    a = Sh(6, a, null, b);
    a.expirationTime = c;
    return a;
}
function Vg(a, b, c) {
    b = Sh(4, null !== a.children ? a.children : [], a.key, b);
    b.expirationTime = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function ak(a, b, c) {
    this.tag = b;
    this.current = null;
    this.containerInfo = a;
    this.pingCache = this.pendingChildren = null;
    this.finishedExpirationTime = 0;
    this.finishedWork = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 90;
    this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
}
function Aj(a, b) {
    var c = a.firstSuspendedTime;
    a = a.lastSuspendedTime;
    return 0 !== c && c >= b && a <= b;
}
function xi(a, b) {
    var c = a.firstSuspendedTime, d = a.lastSuspendedTime;
    c < b && (a.firstSuspendedTime = b);
    if (d > b || 0 === c) a.lastSuspendedTime = b;
    b <= a.lastPingedTime && (a.lastPingedTime = 0);
    b <= a.lastExpiredTime && (a.lastExpiredTime = 0);
}
function yi(a, b) {
    b > a.firstPendingTime && (a.firstPendingTime = b);
    var c = a.firstSuspendedTime;
    0 !== c && (b >= c ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : b >= a.lastSuspendedTime && (a.lastSuspendedTime = b + 1), b > a.nextKnownPendingLevel && (a.nextKnownPendingLevel = b));
}
function Cj(a, b) {
    var c = a.lastExpiredTime;
    if (0 === c || c > b) a.lastExpiredTime = b;
}
function bk(a, b, c, d) {
    var e = b.current, f = Gg(), g = Dg.suspense;
    f = Hg(f, e, g);
    a: if (c) {
        c = c._reactInternalFiber;
        b: {
            if (dc(c) !== c || 1 !== c.tag) throw Error(u(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (L(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(u(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (L(k)) {
                c = Ff(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Af;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = wg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    xg(e, b);
    Ig(e, f);
    return f;
}
function ck(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function dk(a, b) {
    a = a.memoizedState;
    null !== a && null !== a.dehydrated && a.retryTime < b && (a.retryTime = b);
}
function ek(a, b) {
    dk(a, b);
    (a = a.alternate) && dk(a, b);
}
function fk(a, b, c) {
    c = null != c && !0 === c.hydrate;
    var d = new ak(a, b, c), e = Sh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    d.current = e;
    e.stateNode = d;
    ug(e);
    a[Od] = d.current;
    c && 0 !== b && Jc(a, 9 === a.nodeType ? a : a.ownerDocument);
    this._internalRoot = d;
}
fk.prototype.render = function(a) {
    bk(a, this._internalRoot, null, null);
};
fk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    bk(null, a, null, function() {
        b[Od] = null;
    });
};
function gk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function hk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new fk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function ik(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = ck(g);
                h.call(a);
            };
        }
        bk(b, g, a, e);
    } else {
        f = c._reactRootContainer = hk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = ck(g);
                k.call(a);
            };
        }
        Nj(function() {
            bk(b, g, a, e);
        });
    }
    return ck(g);
}
function jk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $a,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
wc = function(a) {
    if (13 === a.tag) {
        var b = hg(Gg(), 150, 100);
        Ig(a, b);
        ek(a, b);
    }
};
xc = function(a) {
    13 === a.tag && (Ig(a, 3), ek(a, 3));
};
yc = function(a) {
    if (13 === a.tag) {
        var b = Gg();
        b = Hg(b, a, null);
        Ig(a, b);
        ek(a, b);
    }
};
za = function(a, b, c) {
    switch(b){
        case "input":
            Cb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Qd(d);
                        if (!e) throw Error(u(90));
                        yb(d);
                        Cb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            Kb(a, c);
            break;
        case "select":
            b = c.value, null != b && Hb(a, !!c.multiple, b, !1);
    }
};
Fa = Mj;
Ga = function(a, b, c, d, e) {
    var f = W;
    W |= 4;
    try {
        return cg(98, a.bind(null, b, c, d, e));
    } finally{
        W = f, W === V && gg();
    }
};
Ha = function() {
    (W & (1 | fj | gj)) === V && (Lj(), Dj());
};
Ia = function(a, b) {
    var c = W;
    W |= 2;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
};
function kk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!gk(b)) throw Error(u(200));
    return jk(a, b, null, c);
}
var lk = {
    Events: [
        Nc,
        Pd,
        Qd,
        xa,
        ta,
        Xd,
        function(a) {
            jc(a, Wd);
        },
        Da,
        Ea,
        id,
        mc,
        Dj,
        {
            current: !1
        }
    ]
};
(function(a) {
    var b = a.findFiberByHostInstance;
    return Yj($haJ2X({}, a, {
        overrideHookState: null,
        overrideProps: null,
        setSuspenseHandler: null,
        scheduleUpdate: null,
        currentDispatcherRef: Wa.ReactCurrentDispatcher,
        findHostInstanceByFiber: function(a) {
            a = hc(a);
            return null === a ? null : a.stateNode;
        },
        findFiberByHostInstance: function(a) {
            return b ? b(a) : null;
        },
        findHostInstancesForRefresh: null,
        scheduleRefresh: null,
        scheduleRoot: null,
        setRefreshHandler: null,
        getCurrentFiber: null
    }));
})({
    findFiberByHostInstance: tc,
    bundleType: 0,
    version: "16.14.0",
    rendererPackageName: "react-dom"
});
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = lk;
exports.createPortal = kk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternalFiber;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(u(188));
        throw Error(u(268, Object.keys(a)));
    }
    a = hc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    if ((W & (fj | gj)) !== V) throw Error(u(187));
    var c = W;
    W |= 1;
    try {
        return cg(99, a.bind(null, b));
    } finally{
        W = c, gg();
    }
};
exports.hydrate = function(a, b, c) {
    if (!gk(b)) throw Error(u(200));
    return ik(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!gk(b)) throw Error(u(200));
    return ik(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!gk(a)) throw Error(u(40));
    return a._reactRootContainer ? (Nj(function() {
        ik(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[Od] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Mj;
exports.unstable_createPortal = function(a, b) {
    return kk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!gk(c)) throw Error(u(200));
    if (null == a || void 0 === a._reactInternalFiber) throw Error(u(38));
    return ik(a, b, c, !1, d);
};
exports.version = "16.14.0";

});
parcelRegister("lOLwO", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gckuW"));

});
parcelRegister("gckuW", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $bcadaad21e196717$export$c4744153514ff05d; }, function (v) { return $bcadaad21e196717$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $bcadaad21e196717$export$d66a1c1c77bd778b; }, function (v) { return $bcadaad21e196717$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $bcadaad21e196717$export$3e506c1ccc9cc1a7; }, function (v) { return $bcadaad21e196717$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $bcadaad21e196717$export$e26fe2ed2fa76875; }, function (v) { return $bcadaad21e196717$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $bcadaad21e196717$export$502329bbf4b505b1; }, function (v) { return $bcadaad21e196717$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $bcadaad21e196717$export$6e3807111c4874c4; }, function (v) { return $bcadaad21e196717$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $bcadaad21e196717$export$c27134553091fb3a; }, function (v) { return $bcadaad21e196717$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $bcadaad21e196717$export$33ee1acdc04fd2a2; }, function (v) { return $bcadaad21e196717$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $bcadaad21e196717$export$b00a404bbd5edef2; }, function (v) { return $bcadaad21e196717$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $bcadaad21e196717$export$8352ce38b91d0c62; }, function (v) { return $bcadaad21e196717$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $bcadaad21e196717$export$d3dfb8e4810cb555; }, function (v) { return $bcadaad21e196717$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $bcadaad21e196717$export$839f9183b0465a69; }, function (v) { return $bcadaad21e196717$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $bcadaad21e196717$export$72fdf0e06517287b; }, function (v) { return $bcadaad21e196717$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $bcadaad21e196717$export$4b844e58a3e414b4; }, function (v) { return $bcadaad21e196717$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $bcadaad21e196717$export$816d2913ae6b83b1; }, function (v) { return $bcadaad21e196717$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $bcadaad21e196717$export$61bcfe829111a1d0; }, function (v) { return $bcadaad21e196717$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $bcadaad21e196717$export$7ee8c9beb337bc3f; }, function (v) { return $bcadaad21e196717$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $bcadaad21e196717$export$b5836b71941fa3ed; }, function (v) { return $bcadaad21e196717$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $bcadaad21e196717$export$cf845f2c119da08a; }, function (v) { return $bcadaad21e196717$export$cf845f2c119da08a = v; });
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcadaad21e196717$export$c4744153514ff05d;
var $bcadaad21e196717$export$d66a1c1c77bd778b;
var $bcadaad21e196717$export$3e506c1ccc9cc1a7;
var $bcadaad21e196717$export$e26fe2ed2fa76875;
var $bcadaad21e196717$export$502329bbf4b505b1;
var $bcadaad21e196717$export$6e3807111c4874c4;
var $bcadaad21e196717$export$c27134553091fb3a;
var $bcadaad21e196717$export$33ee1acdc04fd2a2;
var $bcadaad21e196717$export$b00a404bbd5edef2;
var $bcadaad21e196717$export$8352ce38b91d0c62;
var $bcadaad21e196717$export$d3dfb8e4810cb555;
var $bcadaad21e196717$export$839f9183b0465a69;
var $bcadaad21e196717$export$72fdf0e06517287b;
var $bcadaad21e196717$export$4b844e58a3e414b4;
var $bcadaad21e196717$export$816d2913ae6b83b1;
var $bcadaad21e196717$export$61bcfe829111a1d0;
var $bcadaad21e196717$export$7ee8c9beb337bc3f;
var $bcadaad21e196717$export$b5836b71941fa3ed;
var $bcadaad21e196717$export$cf845f2c119da08a;
'use strict';
var $bcadaad21e196717$var$f, $bcadaad21e196717$var$g, $bcadaad21e196717$var$h, $bcadaad21e196717$var$k, $bcadaad21e196717$var$l;
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $bcadaad21e196717$var$p = null, $bcadaad21e196717$var$q = null, $bcadaad21e196717$var$t = function() {
        if (null !== $bcadaad21e196717$var$p) try {
            var a = $bcadaad21e196717$export$c4744153514ff05d();
            $bcadaad21e196717$var$p(!0, a);
            $bcadaad21e196717$var$p = null;
        } catch (b) {
            throw setTimeout($bcadaad21e196717$var$t, 0), b;
        }
    }, $bcadaad21e196717$var$u = Date.now();
    $bcadaad21e196717$export$c4744153514ff05d = function() {
        return Date.now() - $bcadaad21e196717$var$u;
    };
    $bcadaad21e196717$var$f = function(a) {
        null !== $bcadaad21e196717$var$p ? setTimeout($bcadaad21e196717$var$f, 0, a) : ($bcadaad21e196717$var$p = a, setTimeout($bcadaad21e196717$var$t, 0));
    };
    $bcadaad21e196717$var$g = function(a, b) {
        $bcadaad21e196717$var$q = setTimeout(a, b);
    };
    $bcadaad21e196717$var$h = function() {
        clearTimeout($bcadaad21e196717$var$q);
    };
    $bcadaad21e196717$var$k = function() {
        return !1;
    };
    $bcadaad21e196717$var$l = $bcadaad21e196717$export$d66a1c1c77bd778b = function() {};
} else {
    var $bcadaad21e196717$var$w = window.performance, $bcadaad21e196717$var$x = window.Date, $bcadaad21e196717$var$y = window.setTimeout, $bcadaad21e196717$var$z = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $bcadaad21e196717$var$A = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
        "function" !== typeof $bcadaad21e196717$var$A && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
    }
    if ("object" === typeof $bcadaad21e196717$var$w && "function" === typeof $bcadaad21e196717$var$w.now) $bcadaad21e196717$export$c4744153514ff05d = function() {
        return $bcadaad21e196717$var$w.now();
    };
    else {
        var $bcadaad21e196717$var$B = $bcadaad21e196717$var$x.now();
        $bcadaad21e196717$export$c4744153514ff05d = function() {
            return $bcadaad21e196717$var$x.now() - $bcadaad21e196717$var$B;
        };
    }
    var $bcadaad21e196717$var$C = !1, $bcadaad21e196717$var$D = null, $bcadaad21e196717$var$E = -1, $bcadaad21e196717$var$F = 5, $bcadaad21e196717$var$G = 0;
    $bcadaad21e196717$var$k = function() {
        return $bcadaad21e196717$export$c4744153514ff05d() >= $bcadaad21e196717$var$G;
    };
    $bcadaad21e196717$var$l = function() {};
    $bcadaad21e196717$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : $bcadaad21e196717$var$F = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $bcadaad21e196717$var$H = new MessageChannel, $bcadaad21e196717$var$I = $bcadaad21e196717$var$H.port2;
    $bcadaad21e196717$var$H.port1.onmessage = function() {
        if (null !== $bcadaad21e196717$var$D) {
            var a = $bcadaad21e196717$export$c4744153514ff05d();
            $bcadaad21e196717$var$G = a + $bcadaad21e196717$var$F;
            try {
                $bcadaad21e196717$var$D(!0, a) ? $bcadaad21e196717$var$I.postMessage(null) : ($bcadaad21e196717$var$C = !1, $bcadaad21e196717$var$D = null);
            } catch (b) {
                throw $bcadaad21e196717$var$I.postMessage(null), b;
            }
        } else $bcadaad21e196717$var$C = !1;
    };
    $bcadaad21e196717$var$f = function(a) {
        $bcadaad21e196717$var$D = a;
        $bcadaad21e196717$var$C || ($bcadaad21e196717$var$C = !0, $bcadaad21e196717$var$I.postMessage(null));
    };
    $bcadaad21e196717$var$g = function(a, b) {
        $bcadaad21e196717$var$E = $bcadaad21e196717$var$y(function() {
            a($bcadaad21e196717$export$c4744153514ff05d());
        }, b);
    };
    $bcadaad21e196717$var$h = function() {
        $bcadaad21e196717$var$z($bcadaad21e196717$var$E);
        $bcadaad21e196717$var$E = -1;
    };
}
function $bcadaad21e196717$var$J(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $bcadaad21e196717$var$K(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcadaad21e196717$var$L(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $bcadaad21e196717$var$M(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $bcadaad21e196717$var$K(n, c)) void 0 !== r && 0 > $bcadaad21e196717$var$K(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $bcadaad21e196717$var$K(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $bcadaad21e196717$var$K(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $bcadaad21e196717$var$N = [], $bcadaad21e196717$var$O = [], $bcadaad21e196717$var$P = 1, $bcadaad21e196717$var$Q = null, $bcadaad21e196717$var$R = 3, $bcadaad21e196717$var$S = !1, $bcadaad21e196717$var$T = !1, $bcadaad21e196717$var$U = !1;
function $bcadaad21e196717$var$V(a) {
    for(var b = $bcadaad21e196717$var$L($bcadaad21e196717$var$O); null !== b;){
        if (null === b.callback) $bcadaad21e196717$var$M($bcadaad21e196717$var$O);
        else if (b.startTime <= a) $bcadaad21e196717$var$M($bcadaad21e196717$var$O), b.sortIndex = b.expirationTime, $bcadaad21e196717$var$J($bcadaad21e196717$var$N, b);
        else break;
        b = $bcadaad21e196717$var$L($bcadaad21e196717$var$O);
    }
}
function $bcadaad21e196717$var$W(a) {
    $bcadaad21e196717$var$U = !1;
    $bcadaad21e196717$var$V(a);
    if (!$bcadaad21e196717$var$T) {
        if (null !== $bcadaad21e196717$var$L($bcadaad21e196717$var$N)) $bcadaad21e196717$var$T = !0, $bcadaad21e196717$var$f($bcadaad21e196717$var$X);
        else {
            var b = $bcadaad21e196717$var$L($bcadaad21e196717$var$O);
            null !== b && $bcadaad21e196717$var$g($bcadaad21e196717$var$W, b.startTime - a);
        }
    }
}
function $bcadaad21e196717$var$X(a, b) {
    $bcadaad21e196717$var$T = !1;
    $bcadaad21e196717$var$U && ($bcadaad21e196717$var$U = !1, $bcadaad21e196717$var$h());
    $bcadaad21e196717$var$S = !0;
    var c = $bcadaad21e196717$var$R;
    try {
        $bcadaad21e196717$var$V(b);
        for($bcadaad21e196717$var$Q = $bcadaad21e196717$var$L($bcadaad21e196717$var$N); null !== $bcadaad21e196717$var$Q && (!($bcadaad21e196717$var$Q.expirationTime > b) || a && !$bcadaad21e196717$var$k());){
            var d = $bcadaad21e196717$var$Q.callback;
            if (null !== d) {
                $bcadaad21e196717$var$Q.callback = null;
                $bcadaad21e196717$var$R = $bcadaad21e196717$var$Q.priorityLevel;
                var e = d($bcadaad21e196717$var$Q.expirationTime <= b);
                b = $bcadaad21e196717$export$c4744153514ff05d();
                "function" === typeof e ? $bcadaad21e196717$var$Q.callback = e : $bcadaad21e196717$var$Q === $bcadaad21e196717$var$L($bcadaad21e196717$var$N) && $bcadaad21e196717$var$M($bcadaad21e196717$var$N);
                $bcadaad21e196717$var$V(b);
            } else $bcadaad21e196717$var$M($bcadaad21e196717$var$N);
            $bcadaad21e196717$var$Q = $bcadaad21e196717$var$L($bcadaad21e196717$var$N);
        }
        if (null !== $bcadaad21e196717$var$Q) var m = !0;
        else {
            var n = $bcadaad21e196717$var$L($bcadaad21e196717$var$O);
            null !== n && $bcadaad21e196717$var$g($bcadaad21e196717$var$W, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $bcadaad21e196717$var$Q = null, $bcadaad21e196717$var$R = c, $bcadaad21e196717$var$S = !1;
    }
}
function $bcadaad21e196717$var$Y(a) {
    switch(a){
        case 1:
            return -1;
        case 2:
            return 250;
        case 5:
            return 1073741823;
        case 4:
            return 1E4;
        default:
            return 5E3;
    }
}
var $bcadaad21e196717$var$Z = $bcadaad21e196717$var$l;
$bcadaad21e196717$export$3e506c1ccc9cc1a7 = 5;
$bcadaad21e196717$export$e26fe2ed2fa76875 = 1;
$bcadaad21e196717$export$502329bbf4b505b1 = 4;
$bcadaad21e196717$export$6e3807111c4874c4 = 3;
$bcadaad21e196717$export$c27134553091fb3a = null;
$bcadaad21e196717$export$33ee1acdc04fd2a2 = 2;
$bcadaad21e196717$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcadaad21e196717$export$8352ce38b91d0c62 = function() {
    $bcadaad21e196717$var$T || $bcadaad21e196717$var$S || ($bcadaad21e196717$var$T = !0, $bcadaad21e196717$var$f($bcadaad21e196717$var$X));
};
$bcadaad21e196717$export$d3dfb8e4810cb555 = function() {
    return $bcadaad21e196717$var$R;
};
$bcadaad21e196717$export$839f9183b0465a69 = function() {
    return $bcadaad21e196717$var$L($bcadaad21e196717$var$N);
};
$bcadaad21e196717$export$72fdf0e06517287b = function(a) {
    switch($bcadaad21e196717$var$R){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcadaad21e196717$var$R;
    }
    var c = $bcadaad21e196717$var$R;
    $bcadaad21e196717$var$R = b;
    try {
        return a();
    } finally{
        $bcadaad21e196717$var$R = c;
    }
};
$bcadaad21e196717$export$4b844e58a3e414b4 = function() {};
$bcadaad21e196717$export$816d2913ae6b83b1 = $bcadaad21e196717$var$Z;
$bcadaad21e196717$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcadaad21e196717$var$R;
    $bcadaad21e196717$var$R = a;
    try {
        return b();
    } finally{
        $bcadaad21e196717$var$R = c;
    }
};
$bcadaad21e196717$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcadaad21e196717$export$c4744153514ff05d();
    if ("object" === typeof c && null !== c) {
        var e = c.delay;
        e = "number" === typeof e && 0 < e ? d + e : d;
        c = "number" === typeof c.timeout ? c.timeout : $bcadaad21e196717$var$Y(a);
    } else c = $bcadaad21e196717$var$Y(a), e = d;
    c = e + c;
    a = {
        id: $bcadaad21e196717$var$P++,
        callback: b,
        priorityLevel: a,
        startTime: e,
        expirationTime: c,
        sortIndex: -1
    };
    e > d ? (a.sortIndex = e, $bcadaad21e196717$var$J($bcadaad21e196717$var$O, a), null === $bcadaad21e196717$var$L($bcadaad21e196717$var$N) && a === $bcadaad21e196717$var$L($bcadaad21e196717$var$O) && ($bcadaad21e196717$var$U ? $bcadaad21e196717$var$h() : $bcadaad21e196717$var$U = !0, $bcadaad21e196717$var$g($bcadaad21e196717$var$W, e - d))) : (a.sortIndex = c, $bcadaad21e196717$var$J($bcadaad21e196717$var$N, a), $bcadaad21e196717$var$T || $bcadaad21e196717$var$S || ($bcadaad21e196717$var$T = !0, $bcadaad21e196717$var$f($bcadaad21e196717$var$X)));
    return a;
};
$bcadaad21e196717$export$b5836b71941fa3ed = function() {
    var a = $bcadaad21e196717$export$c4744153514ff05d();
    $bcadaad21e196717$var$V(a);
    var b = $bcadaad21e196717$var$L($bcadaad21e196717$var$N);
    return b !== $bcadaad21e196717$var$Q && null !== $bcadaad21e196717$var$Q && null !== b && null !== b.callback && b.startTime <= a && b.expirationTime < $bcadaad21e196717$var$Q.expirationTime || $bcadaad21e196717$var$k();
};
$bcadaad21e196717$export$cf845f2c119da08a = function(a) {
    var b = $bcadaad21e196717$var$R;
    return function() {
        var c = $bcadaad21e196717$var$R;
        $bcadaad21e196717$var$R = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcadaad21e196717$var$R = c;
        }
    };
};

});




parcelRegister("fGw9V", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b6b3b966eeb692e6$var$ReactIs, $b6b3b966eeb692e6$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("6z0ek"))();

});
parcelRegister("6z0ek", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $bXgaF = parcelRequire("bXgaF");
function $4c7630a2b92b8133$var$emptyFunction() {}
function $4c7630a2b92b8133$var$emptyFunctionWithReset() {}
$4c7630a2b92b8133$var$emptyFunctionWithReset.resetWarningCache = $4c7630a2b92b8133$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $bXgaF) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $4c7630a2b92b8133$var$emptyFunctionWithReset,
        resetWarningCache: $4c7630a2b92b8133$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("bXgaF", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $8b41bfa2045923f4$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $8b41bfa2045923f4$var$ReactPropTypesSecret;

});



parcelRegister("bVGZs", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $8af65d8d09c24ffe$export$2b8d127b894957b9; }, function (v) { return $8af65d8d09c24ffe$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $8af65d8d09c24ffe$export$cea3a54a6425200c; }, function (v) { return $8af65d8d09c24ffe$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $8af65d8d09c24ffe$export$a7c73072b1a182ae; }, function (v) { return $8af65d8d09c24ffe$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $8af65d8d09c24ffe$export$9f27bc3417b4524d; }, function (v) { return $8af65d8d09c24ffe$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $8af65d8d09c24ffe$export$db77ccec0bb4ccac; }, function (v) { return $8af65d8d09c24ffe$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $8af65d8d09c24ffe$export$8392c0c9d3dcbd35; }, function (v) { return $8af65d8d09c24ffe$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $8af65d8d09c24ffe$export$ffb0004e005737fa; }, function (v) { return $8af65d8d09c24ffe$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $8af65d8d09c24ffe$export$b624eff549462981; }, function (v) { return $8af65d8d09c24ffe$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $8af65d8d09c24ffe$export$7897aa7841a5380c; }, function (v) { return $8af65d8d09c24ffe$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $8af65d8d09c24ffe$export$602eac185826482c; }, function (v) { return $8af65d8d09c24ffe$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $8af65d8d09c24ffe$export$e2c29f18771995cb; }, function (v) { return $8af65d8d09c24ffe$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $8af65d8d09c24ffe$export$5f8d39834fd61797; }, function (v) { return $8af65d8d09c24ffe$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $8af65d8d09c24ffe$export$74bf444e3cd11ea5; }, function (v) { return $8af65d8d09c24ffe$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $8af65d8d09c24ffe$export$92387174baf9b227; }, function (v) { return $8af65d8d09c24ffe$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $8af65d8d09c24ffe$export$ec112efeb987d9c6; }, function (v) { return $8af65d8d09c24ffe$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $8af65d8d09c24ffe$export$b706b080d889d2c9; }, function (v) { return $8af65d8d09c24ffe$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $8af65d8d09c24ffe$export$5be5a87408f70ddc; }, function (v) { return $8af65d8d09c24ffe$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $8af65d8d09c24ffe$export$45a5e7f76e0caa8d; }, function (v) { return $8af65d8d09c24ffe$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $8af65d8d09c24ffe$export$455c2e768291efa6; }, function (v) { return $8af65d8d09c24ffe$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $8af65d8d09c24ffe$export$9522e17588c12572; }, function (v) { return $8af65d8d09c24ffe$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $8af65d8d09c24ffe$export$2110ac352bb060b9; }, function (v) { return $8af65d8d09c24ffe$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $8af65d8d09c24ffe$export$56885ab8b9c456ab; }, function (v) { return $8af65d8d09c24ffe$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $8af65d8d09c24ffe$export$d927fcb6adf8f9de; }, function (v) { return $8af65d8d09c24ffe$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $8af65d8d09c24ffe$export$b82d16f27459e05a; }, function (v) { return $8af65d8d09c24ffe$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $8af65d8d09c24ffe$export$522c17b4f5e123e8; }, function (v) { return $8af65d8d09c24ffe$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $8af65d8d09c24ffe$export$1aabd8a0274ecfd6; }, function (v) { return $8af65d8d09c24ffe$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $8af65d8d09c24ffe$export$9b621391a187a31a; }, function (v) { return $8af65d8d09c24ffe$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $8af65d8d09c24ffe$export$f5bbd400c2f4426f; }, function (v) { return $8af65d8d09c24ffe$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8af65d8d09c24ffe$export$2b8d127b894957b9;
var $8af65d8d09c24ffe$export$cea3a54a6425200c;
var $8af65d8d09c24ffe$export$a7c73072b1a182ae;
var $8af65d8d09c24ffe$export$9f27bc3417b4524d;
var $8af65d8d09c24ffe$export$db77ccec0bb4ccac;
var $8af65d8d09c24ffe$export$8392c0c9d3dcbd35;
var $8af65d8d09c24ffe$export$ffb0004e005737fa;
var $8af65d8d09c24ffe$export$b624eff549462981;
var $8af65d8d09c24ffe$export$7897aa7841a5380c;
var $8af65d8d09c24ffe$export$602eac185826482c;
var $8af65d8d09c24ffe$export$e2c29f18771995cb;
var $8af65d8d09c24ffe$export$5f8d39834fd61797;
var $8af65d8d09c24ffe$export$74bf444e3cd11ea5;
var $8af65d8d09c24ffe$export$92387174baf9b227;
var $8af65d8d09c24ffe$export$ec112efeb987d9c6;
var $8af65d8d09c24ffe$export$b706b080d889d2c9;
var $8af65d8d09c24ffe$export$5be5a87408f70ddc;
var $8af65d8d09c24ffe$export$45a5e7f76e0caa8d;
var $8af65d8d09c24ffe$export$455c2e768291efa6;
var $8af65d8d09c24ffe$export$9522e17588c12572;
var $8af65d8d09c24ffe$export$2110ac352bb060b9;
var $8af65d8d09c24ffe$export$56885ab8b9c456ab;
var $8af65d8d09c24ffe$export$d927fcb6adf8f9de;
var $8af65d8d09c24ffe$export$b82d16f27459e05a;
var $8af65d8d09c24ffe$export$522c17b4f5e123e8;
var $8af65d8d09c24ffe$export$1aabd8a0274ecfd6;
var $8af65d8d09c24ffe$export$9b621391a187a31a;
var $8af65d8d09c24ffe$export$f5bbd400c2f4426f;
'use strict';
var $8af65d8d09c24ffe$var$b = "function" === typeof Symbol && Symbol.for, $8af65d8d09c24ffe$var$c = $8af65d8d09c24ffe$var$b ? Symbol.for("react.element") : 60103, $8af65d8d09c24ffe$var$d = $8af65d8d09c24ffe$var$b ? Symbol.for("react.portal") : 60106, $8af65d8d09c24ffe$var$e = $8af65d8d09c24ffe$var$b ? Symbol.for("react.fragment") : 60107, $8af65d8d09c24ffe$var$f = $8af65d8d09c24ffe$var$b ? Symbol.for("react.strict_mode") : 60108, $8af65d8d09c24ffe$var$g = $8af65d8d09c24ffe$var$b ? Symbol.for("react.profiler") : 60114, $8af65d8d09c24ffe$var$h = $8af65d8d09c24ffe$var$b ? Symbol.for("react.provider") : 60109, $8af65d8d09c24ffe$var$k = $8af65d8d09c24ffe$var$b ? Symbol.for("react.context") : 60110, $8af65d8d09c24ffe$var$l = $8af65d8d09c24ffe$var$b ? Symbol.for("react.async_mode") : 60111, $8af65d8d09c24ffe$var$m = $8af65d8d09c24ffe$var$b ? Symbol.for("react.concurrent_mode") : 60111, $8af65d8d09c24ffe$var$n = $8af65d8d09c24ffe$var$b ? Symbol.for("react.forward_ref") : 60112, $8af65d8d09c24ffe$var$p = $8af65d8d09c24ffe$var$b ? Symbol.for("react.suspense") : 60113, $8af65d8d09c24ffe$var$q = $8af65d8d09c24ffe$var$b ? Symbol.for("react.suspense_list") : 60120, $8af65d8d09c24ffe$var$r = $8af65d8d09c24ffe$var$b ? Symbol.for("react.memo") : 60115, $8af65d8d09c24ffe$var$t = $8af65d8d09c24ffe$var$b ? Symbol.for("react.lazy") : 60116, $8af65d8d09c24ffe$var$v = $8af65d8d09c24ffe$var$b ? Symbol.for("react.block") : 60121, $8af65d8d09c24ffe$var$w = $8af65d8d09c24ffe$var$b ? Symbol.for("react.fundamental") : 60117, $8af65d8d09c24ffe$var$x = $8af65d8d09c24ffe$var$b ? Symbol.for("react.responder") : 60118, $8af65d8d09c24ffe$var$y = $8af65d8d09c24ffe$var$b ? Symbol.for("react.scope") : 60119;
function $8af65d8d09c24ffe$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $8af65d8d09c24ffe$var$c:
                switch(a = a.type, a){
                    case $8af65d8d09c24ffe$var$l:
                    case $8af65d8d09c24ffe$var$m:
                    case $8af65d8d09c24ffe$var$e:
                    case $8af65d8d09c24ffe$var$g:
                    case $8af65d8d09c24ffe$var$f:
                    case $8af65d8d09c24ffe$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $8af65d8d09c24ffe$var$k:
                            case $8af65d8d09c24ffe$var$n:
                            case $8af65d8d09c24ffe$var$t:
                            case $8af65d8d09c24ffe$var$r:
                            case $8af65d8d09c24ffe$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $8af65d8d09c24ffe$var$d:
                return u;
        }
    }
}
function $8af65d8d09c24ffe$var$A(a) {
    return $8af65d8d09c24ffe$var$z(a) === $8af65d8d09c24ffe$var$m;
}
$8af65d8d09c24ffe$export$2b8d127b894957b9 = $8af65d8d09c24ffe$var$l;
$8af65d8d09c24ffe$export$cea3a54a6425200c = $8af65d8d09c24ffe$var$m;
$8af65d8d09c24ffe$export$a7c73072b1a182ae = $8af65d8d09c24ffe$var$k;
$8af65d8d09c24ffe$export$9f27bc3417b4524d = $8af65d8d09c24ffe$var$h;
$8af65d8d09c24ffe$export$db77ccec0bb4ccac = $8af65d8d09c24ffe$var$c;
$8af65d8d09c24ffe$export$8392c0c9d3dcbd35 = $8af65d8d09c24ffe$var$n;
$8af65d8d09c24ffe$export$ffb0004e005737fa = $8af65d8d09c24ffe$var$e;
$8af65d8d09c24ffe$export$b624eff549462981 = $8af65d8d09c24ffe$var$t;
$8af65d8d09c24ffe$export$7897aa7841a5380c = $8af65d8d09c24ffe$var$r;
$8af65d8d09c24ffe$export$602eac185826482c = $8af65d8d09c24ffe$var$d;
$8af65d8d09c24ffe$export$e2c29f18771995cb = $8af65d8d09c24ffe$var$g;
$8af65d8d09c24ffe$export$5f8d39834fd61797 = $8af65d8d09c24ffe$var$f;
$8af65d8d09c24ffe$export$74bf444e3cd11ea5 = $8af65d8d09c24ffe$var$p;
$8af65d8d09c24ffe$export$92387174baf9b227 = function(a) {
    return $8af65d8d09c24ffe$var$A(a) || $8af65d8d09c24ffe$var$z(a) === $8af65d8d09c24ffe$var$l;
};
$8af65d8d09c24ffe$export$ec112efeb987d9c6 = $8af65d8d09c24ffe$var$A;
$8af65d8d09c24ffe$export$b706b080d889d2c9 = function(a) {
    return $8af65d8d09c24ffe$var$z(a) === $8af65d8d09c24ffe$var$k;
};
$8af65d8d09c24ffe$export$5be5a87408f70ddc = function(a) {
    return $8af65d8d09c24ffe$var$z(a) === $8af65d8d09c24ffe$var$h;
};
$8af65d8d09c24ffe$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $8af65d8d09c24ffe$var$c;
};
$8af65d8d09c24ffe$export$455c2e768291efa6 = function(a) {
    return $8af65d8d09c24ffe$var$z(a) === $8af65d8d09c24ffe$var$n;
};
$8af65d8d09c24ffe$export$9522e17588c12572 = function(a) {
    return $8af65d8d09c24ffe$var$z(a) === $8af65d8d09c24ffe$var$e;
};
$8af65d8d09c24ffe$export$2110ac352bb060b9 = function(a) {
    return $8af65d8d09c24ffe$var$z(a) === $8af65d8d09c24ffe$var$t;
};
$8af65d8d09c24ffe$export$56885ab8b9c456ab = function(a) {
    return $8af65d8d09c24ffe$var$z(a) === $8af65d8d09c24ffe$var$r;
};
$8af65d8d09c24ffe$export$d927fcb6adf8f9de = function(a) {
    return $8af65d8d09c24ffe$var$z(a) === $8af65d8d09c24ffe$var$d;
};
$8af65d8d09c24ffe$export$b82d16f27459e05a = function(a) {
    return $8af65d8d09c24ffe$var$z(a) === $8af65d8d09c24ffe$var$g;
};
$8af65d8d09c24ffe$export$522c17b4f5e123e8 = function(a) {
    return $8af65d8d09c24ffe$var$z(a) === $8af65d8d09c24ffe$var$f;
};
$8af65d8d09c24ffe$export$1aabd8a0274ecfd6 = function(a) {
    return $8af65d8d09c24ffe$var$z(a) === $8af65d8d09c24ffe$var$p;
};
$8af65d8d09c24ffe$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $8af65d8d09c24ffe$var$e || a === $8af65d8d09c24ffe$var$m || a === $8af65d8d09c24ffe$var$g || a === $8af65d8d09c24ffe$var$f || a === $8af65d8d09c24ffe$var$p || a === $8af65d8d09c24ffe$var$q || "object" === typeof a && null !== a && (a.$$typeof === $8af65d8d09c24ffe$var$t || a.$$typeof === $8af65d8d09c24ffe$var$r || a.$$typeof === $8af65d8d09c24ffe$var$h || a.$$typeof === $8af65d8d09c24ffe$var$k || a.$$typeof === $8af65d8d09c24ffe$var$n || a.$$typeof === $8af65d8d09c24ffe$var$w || a.$$typeof === $8af65d8d09c24ffe$var$x || a.$$typeof === $8af65d8d09c24ffe$var$y || a.$$typeof === $8af65d8d09c24ffe$var$v);
};
$8af65d8d09c24ffe$export$f5bbd400c2f4426f = $8af65d8d09c24ffe$var$z;

});

parcelRegister("cgbez", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $8ecfb17bbb423e23$export$a7c73072b1a182ae; }, function (v) { return $8ecfb17bbb423e23$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $8ecfb17bbb423e23$export$9f27bc3417b4524d; }, function (v) { return $8ecfb17bbb423e23$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $8ecfb17bbb423e23$export$db77ccec0bb4ccac; }, function (v) { return $8ecfb17bbb423e23$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $8ecfb17bbb423e23$export$8392c0c9d3dcbd35; }, function (v) { return $8ecfb17bbb423e23$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $8ecfb17bbb423e23$export$ffb0004e005737fa; }, function (v) { return $8ecfb17bbb423e23$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $8ecfb17bbb423e23$export$b624eff549462981; }, function (v) { return $8ecfb17bbb423e23$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $8ecfb17bbb423e23$export$7897aa7841a5380c; }, function (v) { return $8ecfb17bbb423e23$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $8ecfb17bbb423e23$export$602eac185826482c; }, function (v) { return $8ecfb17bbb423e23$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $8ecfb17bbb423e23$export$e2c29f18771995cb; }, function (v) { return $8ecfb17bbb423e23$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $8ecfb17bbb423e23$export$5f8d39834fd61797; }, function (v) { return $8ecfb17bbb423e23$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $8ecfb17bbb423e23$export$74bf444e3cd11ea5; }, function (v) { return $8ecfb17bbb423e23$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $8ecfb17bbb423e23$export$92387174baf9b227; }, function (v) { return $8ecfb17bbb423e23$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $8ecfb17bbb423e23$export$ec112efeb987d9c6; }, function (v) { return $8ecfb17bbb423e23$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $8ecfb17bbb423e23$export$b706b080d889d2c9; }, function (v) { return $8ecfb17bbb423e23$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $8ecfb17bbb423e23$export$5be5a87408f70ddc; }, function (v) { return $8ecfb17bbb423e23$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $8ecfb17bbb423e23$export$45a5e7f76e0caa8d; }, function (v) { return $8ecfb17bbb423e23$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $8ecfb17bbb423e23$export$455c2e768291efa6; }, function (v) { return $8ecfb17bbb423e23$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $8ecfb17bbb423e23$export$9522e17588c12572; }, function (v) { return $8ecfb17bbb423e23$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $8ecfb17bbb423e23$export$2110ac352bb060b9; }, function (v) { return $8ecfb17bbb423e23$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $8ecfb17bbb423e23$export$56885ab8b9c456ab; }, function (v) { return $8ecfb17bbb423e23$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $8ecfb17bbb423e23$export$d927fcb6adf8f9de; }, function (v) { return $8ecfb17bbb423e23$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $8ecfb17bbb423e23$export$b82d16f27459e05a; }, function (v) { return $8ecfb17bbb423e23$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $8ecfb17bbb423e23$export$522c17b4f5e123e8; }, function (v) { return $8ecfb17bbb423e23$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $8ecfb17bbb423e23$export$1aabd8a0274ecfd6; }, function (v) { return $8ecfb17bbb423e23$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $8ecfb17bbb423e23$export$9b621391a187a31a; }, function (v) { return $8ecfb17bbb423e23$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $8ecfb17bbb423e23$export$f5bbd400c2f4426f; }, function (v) { return $8ecfb17bbb423e23$export$f5bbd400c2f4426f = v; });
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8ecfb17bbb423e23$export$a7c73072b1a182ae;
var $8ecfb17bbb423e23$export$9f27bc3417b4524d;
var $8ecfb17bbb423e23$export$db77ccec0bb4ccac;
var $8ecfb17bbb423e23$export$8392c0c9d3dcbd35;
var $8ecfb17bbb423e23$export$ffb0004e005737fa;
var $8ecfb17bbb423e23$export$b624eff549462981;
var $8ecfb17bbb423e23$export$7897aa7841a5380c;
var $8ecfb17bbb423e23$export$602eac185826482c;
var $8ecfb17bbb423e23$export$e2c29f18771995cb;
var $8ecfb17bbb423e23$export$5f8d39834fd61797;
var $8ecfb17bbb423e23$export$74bf444e3cd11ea5;
var $8ecfb17bbb423e23$export$92387174baf9b227;
var $8ecfb17bbb423e23$export$ec112efeb987d9c6;
var $8ecfb17bbb423e23$export$b706b080d889d2c9;
var $8ecfb17bbb423e23$export$5be5a87408f70ddc;
var $8ecfb17bbb423e23$export$45a5e7f76e0caa8d;
var $8ecfb17bbb423e23$export$455c2e768291efa6;
var $8ecfb17bbb423e23$export$9522e17588c12572;
var $8ecfb17bbb423e23$export$2110ac352bb060b9;
var $8ecfb17bbb423e23$export$56885ab8b9c456ab;
var $8ecfb17bbb423e23$export$d927fcb6adf8f9de;
var $8ecfb17bbb423e23$export$b82d16f27459e05a;
var $8ecfb17bbb423e23$export$522c17b4f5e123e8;
var $8ecfb17bbb423e23$export$1aabd8a0274ecfd6;
var $8ecfb17bbb423e23$export$9b621391a187a31a;
var $8ecfb17bbb423e23$export$f5bbd400c2f4426f;
'use strict';
var $8ecfb17bbb423e23$var$b = 60103, $8ecfb17bbb423e23$var$c = 60106, $8ecfb17bbb423e23$var$d = 60107, $8ecfb17bbb423e23$var$e = 60108, $8ecfb17bbb423e23$var$f = 60114, $8ecfb17bbb423e23$var$g = 60109, $8ecfb17bbb423e23$var$h = 60110, $8ecfb17bbb423e23$var$k = 60112, $8ecfb17bbb423e23$var$l = 60113, $8ecfb17bbb423e23$var$m = 60120, $8ecfb17bbb423e23$var$n = 60115, $8ecfb17bbb423e23$var$p = 60116, $8ecfb17bbb423e23$var$q = 60121, $8ecfb17bbb423e23$var$r = 60122, $8ecfb17bbb423e23$var$u = 60117, $8ecfb17bbb423e23$var$v = 60129, $8ecfb17bbb423e23$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $8ecfb17bbb423e23$var$x = Symbol.for;
    $8ecfb17bbb423e23$var$b = $8ecfb17bbb423e23$var$x("react.element");
    $8ecfb17bbb423e23$var$c = $8ecfb17bbb423e23$var$x("react.portal");
    $8ecfb17bbb423e23$var$d = $8ecfb17bbb423e23$var$x("react.fragment");
    $8ecfb17bbb423e23$var$e = $8ecfb17bbb423e23$var$x("react.strict_mode");
    $8ecfb17bbb423e23$var$f = $8ecfb17bbb423e23$var$x("react.profiler");
    $8ecfb17bbb423e23$var$g = $8ecfb17bbb423e23$var$x("react.provider");
    $8ecfb17bbb423e23$var$h = $8ecfb17bbb423e23$var$x("react.context");
    $8ecfb17bbb423e23$var$k = $8ecfb17bbb423e23$var$x("react.forward_ref");
    $8ecfb17bbb423e23$var$l = $8ecfb17bbb423e23$var$x("react.suspense");
    $8ecfb17bbb423e23$var$m = $8ecfb17bbb423e23$var$x("react.suspense_list");
    $8ecfb17bbb423e23$var$n = $8ecfb17bbb423e23$var$x("react.memo");
    $8ecfb17bbb423e23$var$p = $8ecfb17bbb423e23$var$x("react.lazy");
    $8ecfb17bbb423e23$var$q = $8ecfb17bbb423e23$var$x("react.block");
    $8ecfb17bbb423e23$var$r = $8ecfb17bbb423e23$var$x("react.server.block");
    $8ecfb17bbb423e23$var$u = $8ecfb17bbb423e23$var$x("react.fundamental");
    $8ecfb17bbb423e23$var$v = $8ecfb17bbb423e23$var$x("react.debug_trace_mode");
    $8ecfb17bbb423e23$var$w = $8ecfb17bbb423e23$var$x("react.legacy_hidden");
}
function $8ecfb17bbb423e23$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $8ecfb17bbb423e23$var$b:
                switch(a = a.type, a){
                    case $8ecfb17bbb423e23$var$d:
                    case $8ecfb17bbb423e23$var$f:
                    case $8ecfb17bbb423e23$var$e:
                    case $8ecfb17bbb423e23$var$l:
                    case $8ecfb17bbb423e23$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $8ecfb17bbb423e23$var$h:
                            case $8ecfb17bbb423e23$var$k:
                            case $8ecfb17bbb423e23$var$p:
                            case $8ecfb17bbb423e23$var$n:
                            case $8ecfb17bbb423e23$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $8ecfb17bbb423e23$var$c:
                return t;
        }
    }
}
var $8ecfb17bbb423e23$var$z = $8ecfb17bbb423e23$var$g, $8ecfb17bbb423e23$var$A = $8ecfb17bbb423e23$var$b, $8ecfb17bbb423e23$var$B = $8ecfb17bbb423e23$var$k, $8ecfb17bbb423e23$var$C = $8ecfb17bbb423e23$var$d, $8ecfb17bbb423e23$var$D = $8ecfb17bbb423e23$var$p, $8ecfb17bbb423e23$var$E = $8ecfb17bbb423e23$var$n, $8ecfb17bbb423e23$var$F = $8ecfb17bbb423e23$var$c, $8ecfb17bbb423e23$var$G = $8ecfb17bbb423e23$var$f, $8ecfb17bbb423e23$var$H = $8ecfb17bbb423e23$var$e, $8ecfb17bbb423e23$var$I = $8ecfb17bbb423e23$var$l;
$8ecfb17bbb423e23$export$a7c73072b1a182ae = $8ecfb17bbb423e23$var$h;
$8ecfb17bbb423e23$export$9f27bc3417b4524d = $8ecfb17bbb423e23$var$z;
$8ecfb17bbb423e23$export$db77ccec0bb4ccac = $8ecfb17bbb423e23$var$A;
$8ecfb17bbb423e23$export$8392c0c9d3dcbd35 = $8ecfb17bbb423e23$var$B;
$8ecfb17bbb423e23$export$ffb0004e005737fa = $8ecfb17bbb423e23$var$C;
$8ecfb17bbb423e23$export$b624eff549462981 = $8ecfb17bbb423e23$var$D;
$8ecfb17bbb423e23$export$7897aa7841a5380c = $8ecfb17bbb423e23$var$E;
$8ecfb17bbb423e23$export$602eac185826482c = $8ecfb17bbb423e23$var$F;
$8ecfb17bbb423e23$export$e2c29f18771995cb = $8ecfb17bbb423e23$var$G;
$8ecfb17bbb423e23$export$5f8d39834fd61797 = $8ecfb17bbb423e23$var$H;
$8ecfb17bbb423e23$export$74bf444e3cd11ea5 = $8ecfb17bbb423e23$var$I;
$8ecfb17bbb423e23$export$92387174baf9b227 = function() {
    return !1;
};
$8ecfb17bbb423e23$export$ec112efeb987d9c6 = function() {
    return !1;
};
$8ecfb17bbb423e23$export$b706b080d889d2c9 = function(a) {
    return $8ecfb17bbb423e23$var$y(a) === $8ecfb17bbb423e23$var$h;
};
$8ecfb17bbb423e23$export$5be5a87408f70ddc = function(a) {
    return $8ecfb17bbb423e23$var$y(a) === $8ecfb17bbb423e23$var$g;
};
$8ecfb17bbb423e23$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $8ecfb17bbb423e23$var$b;
};
$8ecfb17bbb423e23$export$455c2e768291efa6 = function(a) {
    return $8ecfb17bbb423e23$var$y(a) === $8ecfb17bbb423e23$var$k;
};
$8ecfb17bbb423e23$export$9522e17588c12572 = function(a) {
    return $8ecfb17bbb423e23$var$y(a) === $8ecfb17bbb423e23$var$d;
};
$8ecfb17bbb423e23$export$2110ac352bb060b9 = function(a) {
    return $8ecfb17bbb423e23$var$y(a) === $8ecfb17bbb423e23$var$p;
};
$8ecfb17bbb423e23$export$56885ab8b9c456ab = function(a) {
    return $8ecfb17bbb423e23$var$y(a) === $8ecfb17bbb423e23$var$n;
};
$8ecfb17bbb423e23$export$d927fcb6adf8f9de = function(a) {
    return $8ecfb17bbb423e23$var$y(a) === $8ecfb17bbb423e23$var$c;
};
$8ecfb17bbb423e23$export$b82d16f27459e05a = function(a) {
    return $8ecfb17bbb423e23$var$y(a) === $8ecfb17bbb423e23$var$f;
};
$8ecfb17bbb423e23$export$522c17b4f5e123e8 = function(a) {
    return $8ecfb17bbb423e23$var$y(a) === $8ecfb17bbb423e23$var$e;
};
$8ecfb17bbb423e23$export$1aabd8a0274ecfd6 = function(a) {
    return $8ecfb17bbb423e23$var$y(a) === $8ecfb17bbb423e23$var$l;
};
$8ecfb17bbb423e23$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $8ecfb17bbb423e23$var$d || a === $8ecfb17bbb423e23$var$f || a === $8ecfb17bbb423e23$var$v || a === $8ecfb17bbb423e23$var$e || a === $8ecfb17bbb423e23$var$l || a === $8ecfb17bbb423e23$var$m || a === $8ecfb17bbb423e23$var$w || "object" === typeof a && null !== a && (a.$$typeof === $8ecfb17bbb423e23$var$p || a.$$typeof === $8ecfb17bbb423e23$var$n || a.$$typeof === $8ecfb17bbb423e23$var$g || a.$$typeof === $8ecfb17bbb423e23$var$h || a.$$typeof === $8ecfb17bbb423e23$var$k || a.$$typeof === $8ecfb17bbb423e23$var$u || a.$$typeof === $8ecfb17bbb423e23$var$q || a[0] === $8ecfb17bbb423e23$var$r) ? !0 : !1;
};
$8ecfb17bbb423e23$export$f5bbd400c2f4426f = $8ecfb17bbb423e23$var$y;

});

parcelRegister("8gcse", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $60397a8d640665b4$export$2e2bcd8739ae039; });
/* global window */ 
var $hyiJ6 = parcelRequire("hyiJ6");
var root;
if (typeof self !== 'undefined') root = self;
else if (typeof window !== 'undefined') root = window;
else if (typeof $parcel$global !== 'undefined') root = $parcel$global;
else root = module;
var result = (0, $hyiJ6.default)(root);
var $60397a8d640665b4$export$2e2bcd8739ae039 = result;

});
parcelRegister("hyiJ6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc74235599754fd7$export$2e2bcd8739ae039; });
function $cc74235599754fd7$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) result = Symbol.observable;
        else {
            result = Symbol('observable');
            Symbol.observable = result;
        }
    } else result = '@@observable';
    return result;
}

});


parcelRegister("hBdgJ", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.18.1';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`', INVALID_TEMPL_IMPORTS_ERROR_TEXT = 'Invalid `imports` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * **Security:** See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md)
     * — `_.template` is insecure and will be removed in v5.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            // Prevent prototype pollution:
            // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
            // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
            var index = -1, length = path.length;
            if (!length) return true;
            while(++index < length){
                var key = toKey(path[index]);
                // Always block "__proto__" anywhere in the path if it's not expected
                if (key === '__proto__' && !hasOwnProperty.call(object, '__proto__')) return false;
                // Block constructor/prototype as non-terminal traversal keys to prevent
                // escaping the object graph into built-in constructors and prototypes.
                if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
            }
            var obj = parent(object, path);
            return obj == null || delete obj[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `-0`, `0n`, `""`, `undefined`, and `NaN` are falsy.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                baseAssignValue(result, pair[0], pair[1]);
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * **Note:** If `lower` is greater than `upper`, the values are swapped.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * // when lower is greater than upper the values are swapped
     * _.random(5, 0);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(-5);
     * // => an integer between -5 and 0
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Security:** `_.template` is insecure and should not be used. It will be
     * removed in Lodash v5. Avoid untrusted input. See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md).
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            arrayEach(importsKeys, function(key) {
                if (reForbiddenIdentifierChars.test(key)) throw new Error(INVALID_TEMPL_IMPORTS_ERROR_TEXT);
            });
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("kfUr0", function(module, exports) {
'use strict';
var $ebf0fc17bb9efdef$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $fVVXq = parcelRequire("fVVXq");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $ebf0fc17bb9efdef$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $ebf0fc17bb9efdef$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $fVVXq();
};

});
parcelRegister("fVVXq", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("h4twM", function(module, exports) {
/*! https://mths.be/he v1.2.0 by @mathias | MIT license */ (function(root) {
    // Detect free variables `exports`.
    var freeExports = exports;
    // Detect free variable `module`.
    var freeModule = module && module.exports == freeExports && module;
    // Detect free variable `global`, from Node.js or Browserified code,
    // and use it as `root`.
    var freeGlobal = typeof $parcel$global == 'object' && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) root = freeGlobal;
    /*--------------------------------------------------------------------------*/ // All astral symbols.
    var regexAstralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
    // All ASCII symbols (not just printable ASCII) except those listed in the
    // first column of the overrides table.
    // https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides
    var regexAsciiWhitelist = /[\x01-\x7F]/g;
    // All BMP symbols that are not ASCII newlines, printable ASCII symbols, or
    // code points listed in the first column of the overrides table on
    // https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides.
    var regexBmpWhitelist = /[\x01-\t\x0B\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g;
    var regexEncodeNonAscii = /<\u20D2|=\u20E5|>\u20D2|\u205F\u200A|\u219D\u0338|\u2202\u0338|\u2220\u20D2|\u2229\uFE00|\u222A\uFE00|\u223C\u20D2|\u223D\u0331|\u223E\u0333|\u2242\u0338|\u224B\u0338|\u224D\u20D2|\u224E\u0338|\u224F\u0338|\u2250\u0338|\u2261\u20E5|\u2264\u20D2|\u2265\u20D2|\u2266\u0338|\u2267\u0338|\u2268\uFE00|\u2269\uFE00|\u226A\u0338|\u226A\u20D2|\u226B\u0338|\u226B\u20D2|\u227F\u0338|\u2282\u20D2|\u2283\u20D2|\u228A\uFE00|\u228B\uFE00|\u228F\u0338|\u2290\u0338|\u2293\uFE00|\u2294\uFE00|\u22B4\u20D2|\u22B5\u20D2|\u22D8\u0338|\u22D9\u0338|\u22DA\uFE00|\u22DB\uFE00|\u22F5\u0338|\u22F9\u0338|\u2933\u0338|\u29CF\u0338|\u29D0\u0338|\u2A6D\u0338|\u2A70\u0338|\u2A7D\u0338|\u2A7E\u0338|\u2AA1\u0338|\u2AA2\u0338|\u2AAC\uFE00|\u2AAD\uFE00|\u2AAF\u0338|\u2AB0\u0338|\u2AC5\u0338|\u2AC6\u0338|\u2ACB\uFE00|\u2ACC\uFE00|\u2AFD\u20E5|[\xA0-\u0113\u0116-\u0122\u0124-\u012B\u012E-\u014D\u0150-\u017E\u0192\u01B5\u01F5\u0237\u02C6\u02C7\u02D8-\u02DD\u0311\u0391-\u03A1\u03A3-\u03A9\u03B1-\u03C9\u03D1\u03D2\u03D5\u03D6\u03DC\u03DD\u03F0\u03F1\u03F5\u03F6\u0401-\u040C\u040E-\u044F\u0451-\u045C\u045E\u045F\u2002-\u2005\u2007-\u2010\u2013-\u2016\u2018-\u201A\u201C-\u201E\u2020-\u2022\u2025\u2026\u2030-\u2035\u2039\u203A\u203E\u2041\u2043\u2044\u204F\u2057\u205F-\u2063\u20AC\u20DB\u20DC\u2102\u2105\u210A-\u2113\u2115-\u211E\u2122\u2124\u2127-\u2129\u212C\u212D\u212F-\u2131\u2133-\u2138\u2145-\u2148\u2153-\u215E\u2190-\u219B\u219D-\u21A7\u21A9-\u21AE\u21B0-\u21B3\u21B5-\u21B7\u21BA-\u21DB\u21DD\u21E4\u21E5\u21F5\u21FD-\u2205\u2207-\u2209\u220B\u220C\u220F-\u2214\u2216-\u2218\u221A\u221D-\u2238\u223A-\u2257\u2259\u225A\u225C\u225F-\u2262\u2264-\u228B\u228D-\u229B\u229D-\u22A5\u22A7-\u22B0\u22B2-\u22BB\u22BD-\u22DB\u22DE-\u22E3\u22E6-\u22F7\u22F9-\u22FE\u2305\u2306\u2308-\u2310\u2312\u2313\u2315\u2316\u231C-\u231F\u2322\u2323\u232D\u232E\u2336\u233D\u233F\u237C\u23B0\u23B1\u23B4-\u23B6\u23DC-\u23DF\u23E2\u23E7\u2423\u24C8\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2550-\u256C\u2580\u2584\u2588\u2591-\u2593\u25A1\u25AA\u25AB\u25AD\u25AE\u25B1\u25B3-\u25B5\u25B8\u25B9\u25BD-\u25BF\u25C2\u25C3\u25CA\u25CB\u25EC\u25EF\u25F8-\u25FC\u2605\u2606\u260E\u2640\u2642\u2660\u2663\u2665\u2666\u266A\u266D-\u266F\u2713\u2717\u2720\u2736\u2758\u2772\u2773\u27C8\u27C9\u27E6-\u27ED\u27F5-\u27FA\u27FC\u27FF\u2902-\u2905\u290C-\u2913\u2916\u2919-\u2920\u2923-\u292A\u2933\u2935-\u2939\u293C\u293D\u2945\u2948-\u294B\u294E-\u2976\u2978\u2979\u297B-\u297F\u2985\u2986\u298B-\u2996\u299A\u299C\u299D\u29A4-\u29B7\u29B9\u29BB\u29BC\u29BE-\u29C5\u29C9\u29CD-\u29D0\u29DC-\u29DE\u29E3-\u29E5\u29EB\u29F4\u29F6\u2A00-\u2A02\u2A04\u2A06\u2A0C\u2A0D\u2A10-\u2A17\u2A22-\u2A27\u2A29\u2A2A\u2A2D-\u2A31\u2A33-\u2A3C\u2A3F\u2A40\u2A42-\u2A4D\u2A50\u2A53-\u2A58\u2A5A-\u2A5D\u2A5F\u2A66\u2A6A\u2A6D-\u2A75\u2A77-\u2A9A\u2A9D-\u2AA2\u2AA4-\u2AB0\u2AB3-\u2AC8\u2ACB\u2ACC\u2ACF-\u2ADB\u2AE4\u2AE6-\u2AE9\u2AEB-\u2AF3\u2AFD\uFB00-\uFB04]|\uD835[\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDD6B]/g;
    var encodeMap = {
        '\xAD': 'shy',
        '\u200C': 'zwnj',
        '\u200D': 'zwj',
        '\u200E': 'lrm',
        '\u2063': 'ic',
        '\u2062': 'it',
        '\u2061': 'af',
        '\u200F': 'rlm',
        '\u200B': 'ZeroWidthSpace',
        '\u2060': 'NoBreak',
        '\u0311': 'DownBreve',
        '\u20DB': 'tdot',
        '\u20DC': 'DotDot',
        '\t': 'Tab',
        '\n': 'NewLine',
        '\u2008': 'puncsp',
        '\u205F': 'MediumSpace',
        '\u2009': 'thinsp',
        '\u200A': 'hairsp',
        '\u2004': 'emsp13',
        '\u2002': 'ensp',
        '\u2005': 'emsp14',
        '\u2003': 'emsp',
        '\u2007': 'numsp',
        '\xA0': 'nbsp',
        '\u205F\u200A': 'ThickSpace',
        '\u203E': 'oline',
        '_': 'lowbar',
        '\u2010': 'dash',
        '\u2013': 'ndash',
        '\u2014': 'mdash',
        '\u2015': 'horbar',
        ',': 'comma',
        ';': 'semi',
        '\u204F': 'bsemi',
        ':': 'colon',
        '\u2A74': 'Colone',
        '!': 'excl',
        '\xA1': 'iexcl',
        '?': 'quest',
        '\xBF': 'iquest',
        '.': 'period',
        '\u2025': 'nldr',
        '\u2026': 'mldr',
        '\xB7': 'middot',
        '\'': 'apos',
        '\u2018': 'lsquo',
        '\u2019': 'rsquo',
        '\u201A': 'sbquo',
        '\u2039': 'lsaquo',
        '\u203A': 'rsaquo',
        '"': 'quot',
        '\u201C': 'ldquo',
        '\u201D': 'rdquo',
        '\u201E': 'bdquo',
        '\xAB': 'laquo',
        '\xBB': 'raquo',
        '(': 'lpar',
        ')': 'rpar',
        '[': 'lsqb',
        ']': 'rsqb',
        '{': 'lcub',
        '}': 'rcub',
        '\u2308': 'lceil',
        '\u2309': 'rceil',
        '\u230A': 'lfloor',
        '\u230B': 'rfloor',
        '\u2985': 'lopar',
        '\u2986': 'ropar',
        '\u298B': 'lbrke',
        '\u298C': 'rbrke',
        '\u298D': 'lbrkslu',
        '\u298E': 'rbrksld',
        '\u298F': 'lbrksld',
        '\u2990': 'rbrkslu',
        '\u2991': 'langd',
        '\u2992': 'rangd',
        '\u2993': 'lparlt',
        '\u2994': 'rpargt',
        '\u2995': 'gtlPar',
        '\u2996': 'ltrPar',
        '\u27E6': 'lobrk',
        '\u27E7': 'robrk',
        '\u27E8': 'lang',
        '\u27E9': 'rang',
        '\u27EA': 'Lang',
        '\u27EB': 'Rang',
        '\u27EC': 'loang',
        '\u27ED': 'roang',
        '\u2772': 'lbbrk',
        '\u2773': 'rbbrk',
        '\u2016': 'Vert',
        '\xA7': 'sect',
        '\xB6': 'para',
        '@': 'commat',
        '*': 'ast',
        '/': 'sol',
        'undefined': null,
        '&': 'amp',
        '#': 'num',
        '%': 'percnt',
        '\u2030': 'permil',
        '\u2031': 'pertenk',
        '\u2020': 'dagger',
        '\u2021': 'Dagger',
        '\u2022': 'bull',
        '\u2043': 'hybull',
        '\u2032': 'prime',
        '\u2033': 'Prime',
        '\u2034': 'tprime',
        '\u2057': 'qprime',
        '\u2035': 'bprime',
        '\u2041': 'caret',
        '`': 'grave',
        '\xB4': 'acute',
        '\u02DC': 'tilde',
        '^': 'Hat',
        '\xAF': 'macr',
        '\u02D8': 'breve',
        '\u02D9': 'dot',
        '\xA8': 'die',
        '\u02DA': 'ring',
        '\u02DD': 'dblac',
        '\xB8': 'cedil',
        '\u02DB': 'ogon',
        '\u02C6': 'circ',
        '\u02C7': 'caron',
        '\xB0': 'deg',
        '\xA9': 'copy',
        '\xAE': 'reg',
        '\u2117': 'copysr',
        '\u2118': 'wp',
        '\u211E': 'rx',
        '\u2127': 'mho',
        '\u2129': 'iiota',
        '\u2190': 'larr',
        '\u219A': 'nlarr',
        '\u2192': 'rarr',
        '\u219B': 'nrarr',
        '\u2191': 'uarr',
        '\u2193': 'darr',
        '\u2194': 'harr',
        '\u21AE': 'nharr',
        '\u2195': 'varr',
        '\u2196': 'nwarr',
        '\u2197': 'nearr',
        '\u2198': 'searr',
        '\u2199': 'swarr',
        '\u219D': 'rarrw',
        '\u219D\u0338': 'nrarrw',
        '\u219E': 'Larr',
        '\u219F': 'Uarr',
        '\u21A0': 'Rarr',
        '\u21A1': 'Darr',
        '\u21A2': 'larrtl',
        '\u21A3': 'rarrtl',
        '\u21A4': 'mapstoleft',
        '\u21A5': 'mapstoup',
        '\u21A6': 'map',
        '\u21A7': 'mapstodown',
        '\u21A9': 'larrhk',
        '\u21AA': 'rarrhk',
        '\u21AB': 'larrlp',
        '\u21AC': 'rarrlp',
        '\u21AD': 'harrw',
        '\u21B0': 'lsh',
        '\u21B1': 'rsh',
        '\u21B2': 'ldsh',
        '\u21B3': 'rdsh',
        '\u21B5': 'crarr',
        '\u21B6': 'cularr',
        '\u21B7': 'curarr',
        '\u21BA': 'olarr',
        '\u21BB': 'orarr',
        '\u21BC': 'lharu',
        '\u21BD': 'lhard',
        '\u21BE': 'uharr',
        '\u21BF': 'uharl',
        '\u21C0': 'rharu',
        '\u21C1': 'rhard',
        '\u21C2': 'dharr',
        '\u21C3': 'dharl',
        '\u21C4': 'rlarr',
        '\u21C5': 'udarr',
        '\u21C6': 'lrarr',
        '\u21C7': 'llarr',
        '\u21C8': 'uuarr',
        '\u21C9': 'rrarr',
        '\u21CA': 'ddarr',
        '\u21CB': 'lrhar',
        '\u21CC': 'rlhar',
        '\u21D0': 'lArr',
        '\u21CD': 'nlArr',
        '\u21D1': 'uArr',
        '\u21D2': 'rArr',
        '\u21CF': 'nrArr',
        '\u21D3': 'dArr',
        '\u21D4': 'iff',
        '\u21CE': 'nhArr',
        '\u21D5': 'vArr',
        '\u21D6': 'nwArr',
        '\u21D7': 'neArr',
        '\u21D8': 'seArr',
        '\u21D9': 'swArr',
        '\u21DA': 'lAarr',
        '\u21DB': 'rAarr',
        '\u21DD': 'zigrarr',
        '\u21E4': 'larrb',
        '\u21E5': 'rarrb',
        '\u21F5': 'duarr',
        '\u21FD': 'loarr',
        '\u21FE': 'roarr',
        '\u21FF': 'hoarr',
        '\u2200': 'forall',
        '\u2201': 'comp',
        '\u2202': 'part',
        '\u2202\u0338': 'npart',
        '\u2203': 'exist',
        '\u2204': 'nexist',
        '\u2205': 'empty',
        '\u2207': 'Del',
        '\u2208': 'in',
        '\u2209': 'notin',
        '\u220B': 'ni',
        '\u220C': 'notni',
        '\u03F6': 'bepsi',
        '\u220F': 'prod',
        '\u2210': 'coprod',
        '\u2211': 'sum',
        '+': 'plus',
        '\xB1': 'pm',
        '\xF7': 'div',
        '\xD7': 'times',
        '<': 'lt',
        '\u226E': 'nlt',
        '<\u20D2': 'nvlt',
        '=': 'equals',
        '\u2260': 'ne',
        '=\u20E5': 'bne',
        '\u2A75': 'Equal',
        '>': 'gt',
        '\u226F': 'ngt',
        '>\u20D2': 'nvgt',
        '\xAC': 'not',
        '|': 'vert',
        '\xA6': 'brvbar',
        '\u2212': 'minus',
        '\u2213': 'mp',
        '\u2214': 'plusdo',
        '\u2044': 'frasl',
        '\u2216': 'setmn',
        '\u2217': 'lowast',
        '\u2218': 'compfn',
        '\u221A': 'Sqrt',
        '\u221D': 'prop',
        '\u221E': 'infin',
        '\u221F': 'angrt',
        '\u2220': 'ang',
        '\u2220\u20D2': 'nang',
        '\u2221': 'angmsd',
        '\u2222': 'angsph',
        '\u2223': 'mid',
        '\u2224': 'nmid',
        '\u2225': 'par',
        '\u2226': 'npar',
        '\u2227': 'and',
        '\u2228': 'or',
        '\u2229': 'cap',
        '\u2229\uFE00': 'caps',
        '\u222A': 'cup',
        '\u222A\uFE00': 'cups',
        '\u222B': 'int',
        '\u222C': 'Int',
        '\u222D': 'tint',
        '\u2A0C': 'qint',
        '\u222E': 'oint',
        '\u222F': 'Conint',
        '\u2230': 'Cconint',
        '\u2231': 'cwint',
        '\u2232': 'cwconint',
        '\u2233': 'awconint',
        '\u2234': 'there4',
        '\u2235': 'becaus',
        '\u2236': 'ratio',
        '\u2237': 'Colon',
        '\u2238': 'minusd',
        '\u223A': 'mDDot',
        '\u223B': 'homtht',
        '\u223C': 'sim',
        '\u2241': 'nsim',
        '\u223C\u20D2': 'nvsim',
        '\u223D': 'bsim',
        '\u223D\u0331': 'race',
        '\u223E': 'ac',
        '\u223E\u0333': 'acE',
        '\u223F': 'acd',
        '\u2240': 'wr',
        '\u2242': 'esim',
        '\u2242\u0338': 'nesim',
        '\u2243': 'sime',
        '\u2244': 'nsime',
        '\u2245': 'cong',
        '\u2247': 'ncong',
        '\u2246': 'simne',
        '\u2248': 'ap',
        '\u2249': 'nap',
        '\u224A': 'ape',
        '\u224B': 'apid',
        '\u224B\u0338': 'napid',
        '\u224C': 'bcong',
        '\u224D': 'CupCap',
        '\u226D': 'NotCupCap',
        '\u224D\u20D2': 'nvap',
        '\u224E': 'bump',
        '\u224E\u0338': 'nbump',
        '\u224F': 'bumpe',
        '\u224F\u0338': 'nbumpe',
        '\u2250': 'doteq',
        '\u2250\u0338': 'nedot',
        '\u2251': 'eDot',
        '\u2252': 'efDot',
        '\u2253': 'erDot',
        '\u2254': 'colone',
        '\u2255': 'ecolon',
        '\u2256': 'ecir',
        '\u2257': 'cire',
        '\u2259': 'wedgeq',
        '\u225A': 'veeeq',
        '\u225C': 'trie',
        '\u225F': 'equest',
        '\u2261': 'equiv',
        '\u2262': 'nequiv',
        '\u2261\u20E5': 'bnequiv',
        '\u2264': 'le',
        '\u2270': 'nle',
        '\u2264\u20D2': 'nvle',
        '\u2265': 'ge',
        '\u2271': 'nge',
        '\u2265\u20D2': 'nvge',
        '\u2266': 'lE',
        '\u2266\u0338': 'nlE',
        '\u2267': 'gE',
        '\u2267\u0338': 'ngE',
        '\u2268\uFE00': 'lvnE',
        '\u2268': 'lnE',
        '\u2269': 'gnE',
        '\u2269\uFE00': 'gvnE',
        '\u226A': 'll',
        '\u226A\u0338': 'nLtv',
        '\u226A\u20D2': 'nLt',
        '\u226B': 'gg',
        '\u226B\u0338': 'nGtv',
        '\u226B\u20D2': 'nGt',
        '\u226C': 'twixt',
        '\u2272': 'lsim',
        '\u2274': 'nlsim',
        '\u2273': 'gsim',
        '\u2275': 'ngsim',
        '\u2276': 'lg',
        '\u2278': 'ntlg',
        '\u2277': 'gl',
        '\u2279': 'ntgl',
        '\u227A': 'pr',
        '\u2280': 'npr',
        '\u227B': 'sc',
        '\u2281': 'nsc',
        '\u227C': 'prcue',
        '\u22E0': 'nprcue',
        '\u227D': 'sccue',
        '\u22E1': 'nsccue',
        '\u227E': 'prsim',
        '\u227F': 'scsim',
        '\u227F\u0338': 'NotSucceedsTilde',
        '\u2282': 'sub',
        '\u2284': 'nsub',
        '\u2282\u20D2': 'vnsub',
        '\u2283': 'sup',
        '\u2285': 'nsup',
        '\u2283\u20D2': 'vnsup',
        '\u2286': 'sube',
        '\u2288': 'nsube',
        '\u2287': 'supe',
        '\u2289': 'nsupe',
        '\u228A\uFE00': 'vsubne',
        '\u228A': 'subne',
        '\u228B\uFE00': 'vsupne',
        '\u228B': 'supne',
        '\u228D': 'cupdot',
        '\u228E': 'uplus',
        '\u228F': 'sqsub',
        '\u228F\u0338': 'NotSquareSubset',
        '\u2290': 'sqsup',
        '\u2290\u0338': 'NotSquareSuperset',
        '\u2291': 'sqsube',
        '\u22E2': 'nsqsube',
        '\u2292': 'sqsupe',
        '\u22E3': 'nsqsupe',
        '\u2293': 'sqcap',
        '\u2293\uFE00': 'sqcaps',
        '\u2294': 'sqcup',
        '\u2294\uFE00': 'sqcups',
        '\u2295': 'oplus',
        '\u2296': 'ominus',
        '\u2297': 'otimes',
        '\u2298': 'osol',
        '\u2299': 'odot',
        '\u229A': 'ocir',
        '\u229B': 'oast',
        '\u229D': 'odash',
        '\u229E': 'plusb',
        '\u229F': 'minusb',
        '\u22A0': 'timesb',
        '\u22A1': 'sdotb',
        '\u22A2': 'vdash',
        '\u22AC': 'nvdash',
        '\u22A3': 'dashv',
        '\u22A4': 'top',
        '\u22A5': 'bot',
        '\u22A7': 'models',
        '\u22A8': 'vDash',
        '\u22AD': 'nvDash',
        '\u22A9': 'Vdash',
        '\u22AE': 'nVdash',
        '\u22AA': 'Vvdash',
        '\u22AB': 'VDash',
        '\u22AF': 'nVDash',
        '\u22B0': 'prurel',
        '\u22B2': 'vltri',
        '\u22EA': 'nltri',
        '\u22B3': 'vrtri',
        '\u22EB': 'nrtri',
        '\u22B4': 'ltrie',
        '\u22EC': 'nltrie',
        '\u22B4\u20D2': 'nvltrie',
        '\u22B5': 'rtrie',
        '\u22ED': 'nrtrie',
        '\u22B5\u20D2': 'nvrtrie',
        '\u22B6': 'origof',
        '\u22B7': 'imof',
        '\u22B8': 'mumap',
        '\u22B9': 'hercon',
        '\u22BA': 'intcal',
        '\u22BB': 'veebar',
        '\u22BD': 'barvee',
        '\u22BE': 'angrtvb',
        '\u22BF': 'lrtri',
        '\u22C0': 'Wedge',
        '\u22C1': 'Vee',
        '\u22C2': 'xcap',
        '\u22C3': 'xcup',
        '\u22C4': 'diam',
        '\u22C5': 'sdot',
        '\u22C6': 'Star',
        '\u22C7': 'divonx',
        '\u22C8': 'bowtie',
        '\u22C9': 'ltimes',
        '\u22CA': 'rtimes',
        '\u22CB': 'lthree',
        '\u22CC': 'rthree',
        '\u22CD': 'bsime',
        '\u22CE': 'cuvee',
        '\u22CF': 'cuwed',
        '\u22D0': 'Sub',
        '\u22D1': 'Sup',
        '\u22D2': 'Cap',
        '\u22D3': 'Cup',
        '\u22D4': 'fork',
        '\u22D5': 'epar',
        '\u22D6': 'ltdot',
        '\u22D7': 'gtdot',
        '\u22D8': 'Ll',
        '\u22D8\u0338': 'nLl',
        '\u22D9': 'Gg',
        '\u22D9\u0338': 'nGg',
        '\u22DA\uFE00': 'lesg',
        '\u22DA': 'leg',
        '\u22DB': 'gel',
        '\u22DB\uFE00': 'gesl',
        '\u22DE': 'cuepr',
        '\u22DF': 'cuesc',
        '\u22E6': 'lnsim',
        '\u22E7': 'gnsim',
        '\u22E8': 'prnsim',
        '\u22E9': 'scnsim',
        '\u22EE': 'vellip',
        '\u22EF': 'ctdot',
        '\u22F0': 'utdot',
        '\u22F1': 'dtdot',
        '\u22F2': 'disin',
        '\u22F3': 'isinsv',
        '\u22F4': 'isins',
        '\u22F5': 'isindot',
        '\u22F5\u0338': 'notindot',
        '\u22F6': 'notinvc',
        '\u22F7': 'notinvb',
        '\u22F9': 'isinE',
        '\u22F9\u0338': 'notinE',
        '\u22FA': 'nisd',
        '\u22FB': 'xnis',
        '\u22FC': 'nis',
        '\u22FD': 'notnivc',
        '\u22FE': 'notnivb',
        '\u2305': 'barwed',
        '\u2306': 'Barwed',
        '\u230C': 'drcrop',
        '\u230D': 'dlcrop',
        '\u230E': 'urcrop',
        '\u230F': 'ulcrop',
        '\u2310': 'bnot',
        '\u2312': 'profline',
        '\u2313': 'profsurf',
        '\u2315': 'telrec',
        '\u2316': 'target',
        '\u231C': 'ulcorn',
        '\u231D': 'urcorn',
        '\u231E': 'dlcorn',
        '\u231F': 'drcorn',
        '\u2322': 'frown',
        '\u2323': 'smile',
        '\u232D': 'cylcty',
        '\u232E': 'profalar',
        '\u2336': 'topbot',
        '\u233D': 'ovbar',
        '\u233F': 'solbar',
        '\u237C': 'angzarr',
        '\u23B0': 'lmoust',
        '\u23B1': 'rmoust',
        '\u23B4': 'tbrk',
        '\u23B5': 'bbrk',
        '\u23B6': 'bbrktbrk',
        '\u23DC': 'OverParenthesis',
        '\u23DD': 'UnderParenthesis',
        '\u23DE': 'OverBrace',
        '\u23DF': 'UnderBrace',
        '\u23E2': 'trpezium',
        '\u23E7': 'elinters',
        '\u2423': 'blank',
        '\u2500': 'boxh',
        '\u2502': 'boxv',
        '\u250C': 'boxdr',
        '\u2510': 'boxdl',
        '\u2514': 'boxur',
        '\u2518': 'boxul',
        '\u251C': 'boxvr',
        '\u2524': 'boxvl',
        '\u252C': 'boxhd',
        '\u2534': 'boxhu',
        '\u253C': 'boxvh',
        '\u2550': 'boxH',
        '\u2551': 'boxV',
        '\u2552': 'boxdR',
        '\u2553': 'boxDr',
        '\u2554': 'boxDR',
        '\u2555': 'boxdL',
        '\u2556': 'boxDl',
        '\u2557': 'boxDL',
        '\u2558': 'boxuR',
        '\u2559': 'boxUr',
        '\u255A': 'boxUR',
        '\u255B': 'boxuL',
        '\u255C': 'boxUl',
        '\u255D': 'boxUL',
        '\u255E': 'boxvR',
        '\u255F': 'boxVr',
        '\u2560': 'boxVR',
        '\u2561': 'boxvL',
        '\u2562': 'boxVl',
        '\u2563': 'boxVL',
        '\u2564': 'boxHd',
        '\u2565': 'boxhD',
        '\u2566': 'boxHD',
        '\u2567': 'boxHu',
        '\u2568': 'boxhU',
        '\u2569': 'boxHU',
        '\u256A': 'boxvH',
        '\u256B': 'boxVh',
        '\u256C': 'boxVH',
        '\u2580': 'uhblk',
        '\u2584': 'lhblk',
        '\u2588': 'block',
        '\u2591': 'blk14',
        '\u2592': 'blk12',
        '\u2593': 'blk34',
        '\u25A1': 'squ',
        '\u25AA': 'squf',
        '\u25AB': 'EmptyVerySmallSquare',
        '\u25AD': 'rect',
        '\u25AE': 'marker',
        '\u25B1': 'fltns',
        '\u25B3': 'xutri',
        '\u25B4': 'utrif',
        '\u25B5': 'utri',
        '\u25B8': 'rtrif',
        '\u25B9': 'rtri',
        '\u25BD': 'xdtri',
        '\u25BE': 'dtrif',
        '\u25BF': 'dtri',
        '\u25C2': 'ltrif',
        '\u25C3': 'ltri',
        '\u25CA': 'loz',
        '\u25CB': 'cir',
        '\u25EC': 'tridot',
        '\u25EF': 'xcirc',
        '\u25F8': 'ultri',
        '\u25F9': 'urtri',
        '\u25FA': 'lltri',
        '\u25FB': 'EmptySmallSquare',
        '\u25FC': 'FilledSmallSquare',
        '\u2605': 'starf',
        '\u2606': 'star',
        '\u260E': 'phone',
        '\u2640': 'female',
        '\u2642': 'male',
        '\u2660': 'spades',
        '\u2663': 'clubs',
        '\u2665': 'hearts',
        '\u2666': 'diams',
        '\u266A': 'sung',
        '\u2713': 'check',
        '\u2717': 'cross',
        '\u2720': 'malt',
        '\u2736': 'sext',
        '\u2758': 'VerticalSeparator',
        '\u27C8': 'bsolhsub',
        '\u27C9': 'suphsol',
        '\u27F5': 'xlarr',
        '\u27F6': 'xrarr',
        '\u27F7': 'xharr',
        '\u27F8': 'xlArr',
        '\u27F9': 'xrArr',
        '\u27FA': 'xhArr',
        '\u27FC': 'xmap',
        '\u27FF': 'dzigrarr',
        '\u2902': 'nvlArr',
        '\u2903': 'nvrArr',
        '\u2904': 'nvHarr',
        '\u2905': 'Map',
        '\u290C': 'lbarr',
        '\u290D': 'rbarr',
        '\u290E': 'lBarr',
        '\u290F': 'rBarr',
        '\u2910': 'RBarr',
        '\u2911': 'DDotrahd',
        '\u2912': 'UpArrowBar',
        '\u2913': 'DownArrowBar',
        '\u2916': 'Rarrtl',
        '\u2919': 'latail',
        '\u291A': 'ratail',
        '\u291B': 'lAtail',
        '\u291C': 'rAtail',
        '\u291D': 'larrfs',
        '\u291E': 'rarrfs',
        '\u291F': 'larrbfs',
        '\u2920': 'rarrbfs',
        '\u2923': 'nwarhk',
        '\u2924': 'nearhk',
        '\u2925': 'searhk',
        '\u2926': 'swarhk',
        '\u2927': 'nwnear',
        '\u2928': 'toea',
        '\u2929': 'tosa',
        '\u292A': 'swnwar',
        '\u2933': 'rarrc',
        '\u2933\u0338': 'nrarrc',
        '\u2935': 'cudarrr',
        '\u2936': 'ldca',
        '\u2937': 'rdca',
        '\u2938': 'cudarrl',
        '\u2939': 'larrpl',
        '\u293C': 'curarrm',
        '\u293D': 'cularrp',
        '\u2945': 'rarrpl',
        '\u2948': 'harrcir',
        '\u2949': 'Uarrocir',
        '\u294A': 'lurdshar',
        '\u294B': 'ldrushar',
        '\u294E': 'LeftRightVector',
        '\u294F': 'RightUpDownVector',
        '\u2950': 'DownLeftRightVector',
        '\u2951': 'LeftUpDownVector',
        '\u2952': 'LeftVectorBar',
        '\u2953': 'RightVectorBar',
        '\u2954': 'RightUpVectorBar',
        '\u2955': 'RightDownVectorBar',
        '\u2956': 'DownLeftVectorBar',
        '\u2957': 'DownRightVectorBar',
        '\u2958': 'LeftUpVectorBar',
        '\u2959': 'LeftDownVectorBar',
        '\u295A': 'LeftTeeVector',
        '\u295B': 'RightTeeVector',
        '\u295C': 'RightUpTeeVector',
        '\u295D': 'RightDownTeeVector',
        '\u295E': 'DownLeftTeeVector',
        '\u295F': 'DownRightTeeVector',
        '\u2960': 'LeftUpTeeVector',
        '\u2961': 'LeftDownTeeVector',
        '\u2962': 'lHar',
        '\u2963': 'uHar',
        '\u2964': 'rHar',
        '\u2965': 'dHar',
        '\u2966': 'luruhar',
        '\u2967': 'ldrdhar',
        '\u2968': 'ruluhar',
        '\u2969': 'rdldhar',
        '\u296A': 'lharul',
        '\u296B': 'llhard',
        '\u296C': 'rharul',
        '\u296D': 'lrhard',
        '\u296E': 'udhar',
        '\u296F': 'duhar',
        '\u2970': 'RoundImplies',
        '\u2971': 'erarr',
        '\u2972': 'simrarr',
        '\u2973': 'larrsim',
        '\u2974': 'rarrsim',
        '\u2975': 'rarrap',
        '\u2976': 'ltlarr',
        '\u2978': 'gtrarr',
        '\u2979': 'subrarr',
        '\u297B': 'suplarr',
        '\u297C': 'lfisht',
        '\u297D': 'rfisht',
        '\u297E': 'ufisht',
        '\u297F': 'dfisht',
        '\u299A': 'vzigzag',
        '\u299C': 'vangrt',
        '\u299D': 'angrtvbd',
        '\u29A4': 'ange',
        '\u29A5': 'range',
        '\u29A6': 'dwangle',
        '\u29A7': 'uwangle',
        '\u29A8': 'angmsdaa',
        '\u29A9': 'angmsdab',
        '\u29AA': 'angmsdac',
        '\u29AB': 'angmsdad',
        '\u29AC': 'angmsdae',
        '\u29AD': 'angmsdaf',
        '\u29AE': 'angmsdag',
        '\u29AF': 'angmsdah',
        '\u29B0': 'bemptyv',
        '\u29B1': 'demptyv',
        '\u29B2': 'cemptyv',
        '\u29B3': 'raemptyv',
        '\u29B4': 'laemptyv',
        '\u29B5': 'ohbar',
        '\u29B6': 'omid',
        '\u29B7': 'opar',
        '\u29B9': 'operp',
        '\u29BB': 'olcross',
        '\u29BC': 'odsold',
        '\u29BE': 'olcir',
        '\u29BF': 'ofcir',
        '\u29C0': 'olt',
        '\u29C1': 'ogt',
        '\u29C2': 'cirscir',
        '\u29C3': 'cirE',
        '\u29C4': 'solb',
        '\u29C5': 'bsolb',
        '\u29C9': 'boxbox',
        '\u29CD': 'trisb',
        '\u29CE': 'rtriltri',
        '\u29CF': 'LeftTriangleBar',
        '\u29CF\u0338': 'NotLeftTriangleBar',
        '\u29D0': 'RightTriangleBar',
        '\u29D0\u0338': 'NotRightTriangleBar',
        '\u29DC': 'iinfin',
        '\u29DD': 'infintie',
        '\u29DE': 'nvinfin',
        '\u29E3': 'eparsl',
        '\u29E4': 'smeparsl',
        '\u29E5': 'eqvparsl',
        '\u29EB': 'lozf',
        '\u29F4': 'RuleDelayed',
        '\u29F6': 'dsol',
        '\u2A00': 'xodot',
        '\u2A01': 'xoplus',
        '\u2A02': 'xotime',
        '\u2A04': 'xuplus',
        '\u2A06': 'xsqcup',
        '\u2A0D': 'fpartint',
        '\u2A10': 'cirfnint',
        '\u2A11': 'awint',
        '\u2A12': 'rppolint',
        '\u2A13': 'scpolint',
        '\u2A14': 'npolint',
        '\u2A15': 'pointint',
        '\u2A16': 'quatint',
        '\u2A17': 'intlarhk',
        '\u2A22': 'pluscir',
        '\u2A23': 'plusacir',
        '\u2A24': 'simplus',
        '\u2A25': 'plusdu',
        '\u2A26': 'plussim',
        '\u2A27': 'plustwo',
        '\u2A29': 'mcomma',
        '\u2A2A': 'minusdu',
        '\u2A2D': 'loplus',
        '\u2A2E': 'roplus',
        '\u2A2F': 'Cross',
        '\u2A30': 'timesd',
        '\u2A31': 'timesbar',
        '\u2A33': 'smashp',
        '\u2A34': 'lotimes',
        '\u2A35': 'rotimes',
        '\u2A36': 'otimesas',
        '\u2A37': 'Otimes',
        '\u2A38': 'odiv',
        '\u2A39': 'triplus',
        '\u2A3A': 'triminus',
        '\u2A3B': 'tritime',
        '\u2A3C': 'iprod',
        '\u2A3F': 'amalg',
        '\u2A40': 'capdot',
        '\u2A42': 'ncup',
        '\u2A43': 'ncap',
        '\u2A44': 'capand',
        '\u2A45': 'cupor',
        '\u2A46': 'cupcap',
        '\u2A47': 'capcup',
        '\u2A48': 'cupbrcap',
        '\u2A49': 'capbrcup',
        '\u2A4A': 'cupcup',
        '\u2A4B': 'capcap',
        '\u2A4C': 'ccups',
        '\u2A4D': 'ccaps',
        '\u2A50': 'ccupssm',
        '\u2A53': 'And',
        '\u2A54': 'Or',
        '\u2A55': 'andand',
        '\u2A56': 'oror',
        '\u2A57': 'orslope',
        '\u2A58': 'andslope',
        '\u2A5A': 'andv',
        '\u2A5B': 'orv',
        '\u2A5C': 'andd',
        '\u2A5D': 'ord',
        '\u2A5F': 'wedbar',
        '\u2A66': 'sdote',
        '\u2A6A': 'simdot',
        '\u2A6D': 'congdot',
        '\u2A6D\u0338': 'ncongdot',
        '\u2A6E': 'easter',
        '\u2A6F': 'apacir',
        '\u2A70': 'apE',
        '\u2A70\u0338': 'napE',
        '\u2A71': 'eplus',
        '\u2A72': 'pluse',
        '\u2A73': 'Esim',
        '\u2A77': 'eDDot',
        '\u2A78': 'equivDD',
        '\u2A79': 'ltcir',
        '\u2A7A': 'gtcir',
        '\u2A7B': 'ltquest',
        '\u2A7C': 'gtquest',
        '\u2A7D': 'les',
        '\u2A7D\u0338': 'nles',
        '\u2A7E': 'ges',
        '\u2A7E\u0338': 'nges',
        '\u2A7F': 'lesdot',
        '\u2A80': 'gesdot',
        '\u2A81': 'lesdoto',
        '\u2A82': 'gesdoto',
        '\u2A83': 'lesdotor',
        '\u2A84': 'gesdotol',
        '\u2A85': 'lap',
        '\u2A86': 'gap',
        '\u2A87': 'lne',
        '\u2A88': 'gne',
        '\u2A89': 'lnap',
        '\u2A8A': 'gnap',
        '\u2A8B': 'lEg',
        '\u2A8C': 'gEl',
        '\u2A8D': 'lsime',
        '\u2A8E': 'gsime',
        '\u2A8F': 'lsimg',
        '\u2A90': 'gsiml',
        '\u2A91': 'lgE',
        '\u2A92': 'glE',
        '\u2A93': 'lesges',
        '\u2A94': 'gesles',
        '\u2A95': 'els',
        '\u2A96': 'egs',
        '\u2A97': 'elsdot',
        '\u2A98': 'egsdot',
        '\u2A99': 'el',
        '\u2A9A': 'eg',
        '\u2A9D': 'siml',
        '\u2A9E': 'simg',
        '\u2A9F': 'simlE',
        '\u2AA0': 'simgE',
        '\u2AA1': 'LessLess',
        '\u2AA1\u0338': 'NotNestedLessLess',
        '\u2AA2': 'GreaterGreater',
        '\u2AA2\u0338': 'NotNestedGreaterGreater',
        '\u2AA4': 'glj',
        '\u2AA5': 'gla',
        '\u2AA6': 'ltcc',
        '\u2AA7': 'gtcc',
        '\u2AA8': 'lescc',
        '\u2AA9': 'gescc',
        '\u2AAA': 'smt',
        '\u2AAB': 'lat',
        '\u2AAC': 'smte',
        '\u2AAC\uFE00': 'smtes',
        '\u2AAD': 'late',
        '\u2AAD\uFE00': 'lates',
        '\u2AAE': 'bumpE',
        '\u2AAF': 'pre',
        '\u2AAF\u0338': 'npre',
        '\u2AB0': 'sce',
        '\u2AB0\u0338': 'nsce',
        '\u2AB3': 'prE',
        '\u2AB4': 'scE',
        '\u2AB5': 'prnE',
        '\u2AB6': 'scnE',
        '\u2AB7': 'prap',
        '\u2AB8': 'scap',
        '\u2AB9': 'prnap',
        '\u2ABA': 'scnap',
        '\u2ABB': 'Pr',
        '\u2ABC': 'Sc',
        '\u2ABD': 'subdot',
        '\u2ABE': 'supdot',
        '\u2ABF': 'subplus',
        '\u2AC0': 'supplus',
        '\u2AC1': 'submult',
        '\u2AC2': 'supmult',
        '\u2AC3': 'subedot',
        '\u2AC4': 'supedot',
        '\u2AC5': 'subE',
        '\u2AC5\u0338': 'nsubE',
        '\u2AC6': 'supE',
        '\u2AC6\u0338': 'nsupE',
        '\u2AC7': 'subsim',
        '\u2AC8': 'supsim',
        '\u2ACB\uFE00': 'vsubnE',
        '\u2ACB': 'subnE',
        '\u2ACC\uFE00': 'vsupnE',
        '\u2ACC': 'supnE',
        '\u2ACF': 'csub',
        '\u2AD0': 'csup',
        '\u2AD1': 'csube',
        '\u2AD2': 'csupe',
        '\u2AD3': 'subsup',
        '\u2AD4': 'supsub',
        '\u2AD5': 'subsub',
        '\u2AD6': 'supsup',
        '\u2AD7': 'suphsub',
        '\u2AD8': 'supdsub',
        '\u2AD9': 'forkv',
        '\u2ADA': 'topfork',
        '\u2ADB': 'mlcp',
        '\u2AE4': 'Dashv',
        '\u2AE6': 'Vdashl',
        '\u2AE7': 'Barv',
        '\u2AE8': 'vBar',
        '\u2AE9': 'vBarv',
        '\u2AEB': 'Vbar',
        '\u2AEC': 'Not',
        '\u2AED': 'bNot',
        '\u2AEE': 'rnmid',
        '\u2AEF': 'cirmid',
        '\u2AF0': 'midcir',
        '\u2AF1': 'topcir',
        '\u2AF2': 'nhpar',
        '\u2AF3': 'parsim',
        '\u2AFD': 'parsl',
        '\u2AFD\u20E5': 'nparsl',
        '\u266D': 'flat',
        '\u266E': 'natur',
        '\u266F': 'sharp',
        '\xA4': 'curren',
        '\xA2': 'cent',
        '$': 'dollar',
        '\xA3': 'pound',
        '\xA5': 'yen',
        '\u20AC': 'euro',
        '\xB9': 'sup1',
        '\xBD': 'half',
        '\u2153': 'frac13',
        '\xBC': 'frac14',
        '\u2155': 'frac15',
        '\u2159': 'frac16',
        '\u215B': 'frac18',
        '\xB2': 'sup2',
        '\u2154': 'frac23',
        '\u2156': 'frac25',
        '\xB3': 'sup3',
        '\xBE': 'frac34',
        '\u2157': 'frac35',
        '\u215C': 'frac38',
        '\u2158': 'frac45',
        '\u215A': 'frac56',
        '\u215D': 'frac58',
        '\u215E': 'frac78',
        '\uD835\uDCB6': 'ascr',
        '\uD835\uDD52': 'aopf',
        '\uD835\uDD1E': 'afr',
        '\uD835\uDD38': 'Aopf',
        '\uD835\uDD04': 'Afr',
        '\uD835\uDC9C': 'Ascr',
        '\xAA': 'ordf',
        '\xE1': 'aacute',
        '\xC1': 'Aacute',
        '\xE0': 'agrave',
        '\xC0': 'Agrave',
        '\u0103': 'abreve',
        '\u0102': 'Abreve',
        '\xE2': 'acirc',
        '\xC2': 'Acirc',
        '\xE5': 'aring',
        '\xC5': 'angst',
        '\xE4': 'auml',
        '\xC4': 'Auml',
        '\xE3': 'atilde',
        '\xC3': 'Atilde',
        '\u0105': 'aogon',
        '\u0104': 'Aogon',
        '\u0101': 'amacr',
        '\u0100': 'Amacr',
        '\xE6': 'aelig',
        '\xC6': 'AElig',
        '\uD835\uDCB7': 'bscr',
        '\uD835\uDD53': 'bopf',
        '\uD835\uDD1F': 'bfr',
        '\uD835\uDD39': 'Bopf',
        '\u212C': 'Bscr',
        '\uD835\uDD05': 'Bfr',
        '\uD835\uDD20': 'cfr',
        '\uD835\uDCB8': 'cscr',
        '\uD835\uDD54': 'copf',
        '\u212D': 'Cfr',
        '\uD835\uDC9E': 'Cscr',
        '\u2102': 'Copf',
        '\u0107': 'cacute',
        '\u0106': 'Cacute',
        '\u0109': 'ccirc',
        '\u0108': 'Ccirc',
        '\u010D': 'ccaron',
        '\u010C': 'Ccaron',
        '\u010B': 'cdot',
        '\u010A': 'Cdot',
        '\xE7': 'ccedil',
        '\xC7': 'Ccedil',
        '\u2105': 'incare',
        '\uD835\uDD21': 'dfr',
        '\u2146': 'dd',
        '\uD835\uDD55': 'dopf',
        '\uD835\uDCB9': 'dscr',
        '\uD835\uDC9F': 'Dscr',
        '\uD835\uDD07': 'Dfr',
        '\u2145': 'DD',
        '\uD835\uDD3B': 'Dopf',
        '\u010F': 'dcaron',
        '\u010E': 'Dcaron',
        '\u0111': 'dstrok',
        '\u0110': 'Dstrok',
        '\xF0': 'eth',
        '\xD0': 'ETH',
        '\u2147': 'ee',
        '\u212F': 'escr',
        '\uD835\uDD22': 'efr',
        '\uD835\uDD56': 'eopf',
        '\u2130': 'Escr',
        '\uD835\uDD08': 'Efr',
        '\uD835\uDD3C': 'Eopf',
        '\xE9': 'eacute',
        '\xC9': 'Eacute',
        '\xE8': 'egrave',
        '\xC8': 'Egrave',
        '\xEA': 'ecirc',
        '\xCA': 'Ecirc',
        '\u011B': 'ecaron',
        '\u011A': 'Ecaron',
        '\xEB': 'euml',
        '\xCB': 'Euml',
        '\u0117': 'edot',
        '\u0116': 'Edot',
        '\u0119': 'eogon',
        '\u0118': 'Eogon',
        '\u0113': 'emacr',
        '\u0112': 'Emacr',
        '\uD835\uDD23': 'ffr',
        '\uD835\uDD57': 'fopf',
        '\uD835\uDCBB': 'fscr',
        '\uD835\uDD09': 'Ffr',
        '\uD835\uDD3D': 'Fopf',
        '\u2131': 'Fscr',
        '\uFB00': 'fflig',
        '\uFB03': 'ffilig',
        '\uFB04': 'ffllig',
        '\uFB01': 'filig',
        'fj': 'fjlig',
        '\uFB02': 'fllig',
        '\u0192': 'fnof',
        '\u210A': 'gscr',
        '\uD835\uDD58': 'gopf',
        '\uD835\uDD24': 'gfr',
        '\uD835\uDCA2': 'Gscr',
        '\uD835\uDD3E': 'Gopf',
        '\uD835\uDD0A': 'Gfr',
        '\u01F5': 'gacute',
        '\u011F': 'gbreve',
        '\u011E': 'Gbreve',
        '\u011D': 'gcirc',
        '\u011C': 'Gcirc',
        '\u0121': 'gdot',
        '\u0120': 'Gdot',
        '\u0122': 'Gcedil',
        '\uD835\uDD25': 'hfr',
        '\u210E': 'planckh',
        '\uD835\uDCBD': 'hscr',
        '\uD835\uDD59': 'hopf',
        '\u210B': 'Hscr',
        '\u210C': 'Hfr',
        '\u210D': 'Hopf',
        '\u0125': 'hcirc',
        '\u0124': 'Hcirc',
        '\u210F': 'hbar',
        '\u0127': 'hstrok',
        '\u0126': 'Hstrok',
        '\uD835\uDD5A': 'iopf',
        '\uD835\uDD26': 'ifr',
        '\uD835\uDCBE': 'iscr',
        '\u2148': 'ii',
        '\uD835\uDD40': 'Iopf',
        '\u2110': 'Iscr',
        '\u2111': 'Im',
        '\xED': 'iacute',
        '\xCD': 'Iacute',
        '\xEC': 'igrave',
        '\xCC': 'Igrave',
        '\xEE': 'icirc',
        '\xCE': 'Icirc',
        '\xEF': 'iuml',
        '\xCF': 'Iuml',
        '\u0129': 'itilde',
        '\u0128': 'Itilde',
        '\u0130': 'Idot',
        '\u012F': 'iogon',
        '\u012E': 'Iogon',
        '\u012B': 'imacr',
        '\u012A': 'Imacr',
        '\u0133': 'ijlig',
        '\u0132': 'IJlig',
        '\u0131': 'imath',
        '\uD835\uDCBF': 'jscr',
        '\uD835\uDD5B': 'jopf',
        '\uD835\uDD27': 'jfr',
        '\uD835\uDCA5': 'Jscr',
        '\uD835\uDD0D': 'Jfr',
        '\uD835\uDD41': 'Jopf',
        '\u0135': 'jcirc',
        '\u0134': 'Jcirc',
        '\u0237': 'jmath',
        '\uD835\uDD5C': 'kopf',
        '\uD835\uDCC0': 'kscr',
        '\uD835\uDD28': 'kfr',
        '\uD835\uDCA6': 'Kscr',
        '\uD835\uDD42': 'Kopf',
        '\uD835\uDD0E': 'Kfr',
        '\u0137': 'kcedil',
        '\u0136': 'Kcedil',
        '\uD835\uDD29': 'lfr',
        '\uD835\uDCC1': 'lscr',
        '\u2113': 'ell',
        '\uD835\uDD5D': 'lopf',
        '\u2112': 'Lscr',
        '\uD835\uDD0F': 'Lfr',
        '\uD835\uDD43': 'Lopf',
        '\u013A': 'lacute',
        '\u0139': 'Lacute',
        '\u013E': 'lcaron',
        '\u013D': 'Lcaron',
        '\u013C': 'lcedil',
        '\u013B': 'Lcedil',
        '\u0142': 'lstrok',
        '\u0141': 'Lstrok',
        '\u0140': 'lmidot',
        '\u013F': 'Lmidot',
        '\uD835\uDD2A': 'mfr',
        '\uD835\uDD5E': 'mopf',
        '\uD835\uDCC2': 'mscr',
        '\uD835\uDD10': 'Mfr',
        '\uD835\uDD44': 'Mopf',
        '\u2133': 'Mscr',
        '\uD835\uDD2B': 'nfr',
        '\uD835\uDD5F': 'nopf',
        '\uD835\uDCC3': 'nscr',
        '\u2115': 'Nopf',
        '\uD835\uDCA9': 'Nscr',
        '\uD835\uDD11': 'Nfr',
        '\u0144': 'nacute',
        '\u0143': 'Nacute',
        '\u0148': 'ncaron',
        '\u0147': 'Ncaron',
        '\xF1': 'ntilde',
        '\xD1': 'Ntilde',
        '\u0146': 'ncedil',
        '\u0145': 'Ncedil',
        '\u2116': 'numero',
        '\u014B': 'eng',
        '\u014A': 'ENG',
        '\uD835\uDD60': 'oopf',
        '\uD835\uDD2C': 'ofr',
        '\u2134': 'oscr',
        '\uD835\uDCAA': 'Oscr',
        '\uD835\uDD12': 'Ofr',
        '\uD835\uDD46': 'Oopf',
        '\xBA': 'ordm',
        '\xF3': 'oacute',
        '\xD3': 'Oacute',
        '\xF2': 'ograve',
        '\xD2': 'Ograve',
        '\xF4': 'ocirc',
        '\xD4': 'Ocirc',
        '\xF6': 'ouml',
        '\xD6': 'Ouml',
        '\u0151': 'odblac',
        '\u0150': 'Odblac',
        '\xF5': 'otilde',
        '\xD5': 'Otilde',
        '\xF8': 'oslash',
        '\xD8': 'Oslash',
        '\u014D': 'omacr',
        '\u014C': 'Omacr',
        '\u0153': 'oelig',
        '\u0152': 'OElig',
        '\uD835\uDD2D': 'pfr',
        '\uD835\uDCC5': 'pscr',
        '\uD835\uDD61': 'popf',
        '\u2119': 'Popf',
        '\uD835\uDD13': 'Pfr',
        '\uD835\uDCAB': 'Pscr',
        '\uD835\uDD62': 'qopf',
        '\uD835\uDD2E': 'qfr',
        '\uD835\uDCC6': 'qscr',
        '\uD835\uDCAC': 'Qscr',
        '\uD835\uDD14': 'Qfr',
        '\u211A': 'Qopf',
        '\u0138': 'kgreen',
        '\uD835\uDD2F': 'rfr',
        '\uD835\uDD63': 'ropf',
        '\uD835\uDCC7': 'rscr',
        '\u211B': 'Rscr',
        '\u211C': 'Re',
        '\u211D': 'Ropf',
        '\u0155': 'racute',
        '\u0154': 'Racute',
        '\u0159': 'rcaron',
        '\u0158': 'Rcaron',
        '\u0157': 'rcedil',
        '\u0156': 'Rcedil',
        '\uD835\uDD64': 'sopf',
        '\uD835\uDCC8': 'sscr',
        '\uD835\uDD30': 'sfr',
        '\uD835\uDD4A': 'Sopf',
        '\uD835\uDD16': 'Sfr',
        '\uD835\uDCAE': 'Sscr',
        '\u24C8': 'oS',
        '\u015B': 'sacute',
        '\u015A': 'Sacute',
        '\u015D': 'scirc',
        '\u015C': 'Scirc',
        '\u0161': 'scaron',
        '\u0160': 'Scaron',
        '\u015F': 'scedil',
        '\u015E': 'Scedil',
        '\xDF': 'szlig',
        '\uD835\uDD31': 'tfr',
        '\uD835\uDCC9': 'tscr',
        '\uD835\uDD65': 'topf',
        '\uD835\uDCAF': 'Tscr',
        '\uD835\uDD17': 'Tfr',
        '\uD835\uDD4B': 'Topf',
        '\u0165': 'tcaron',
        '\u0164': 'Tcaron',
        '\u0163': 'tcedil',
        '\u0162': 'Tcedil',
        '\u2122': 'trade',
        '\u0167': 'tstrok',
        '\u0166': 'Tstrok',
        '\uD835\uDCCA': 'uscr',
        '\uD835\uDD66': 'uopf',
        '\uD835\uDD32': 'ufr',
        '\uD835\uDD4C': 'Uopf',
        '\uD835\uDD18': 'Ufr',
        '\uD835\uDCB0': 'Uscr',
        '\xFA': 'uacute',
        '\xDA': 'Uacute',
        '\xF9': 'ugrave',
        '\xD9': 'Ugrave',
        '\u016D': 'ubreve',
        '\u016C': 'Ubreve',
        '\xFB': 'ucirc',
        '\xDB': 'Ucirc',
        '\u016F': 'uring',
        '\u016E': 'Uring',
        '\xFC': 'uuml',
        '\xDC': 'Uuml',
        '\u0171': 'udblac',
        '\u0170': 'Udblac',
        '\u0169': 'utilde',
        '\u0168': 'Utilde',
        '\u0173': 'uogon',
        '\u0172': 'Uogon',
        '\u016B': 'umacr',
        '\u016A': 'Umacr',
        '\uD835\uDD33': 'vfr',
        '\uD835\uDD67': 'vopf',
        '\uD835\uDCCB': 'vscr',
        '\uD835\uDD19': 'Vfr',
        '\uD835\uDD4D': 'Vopf',
        '\uD835\uDCB1': 'Vscr',
        '\uD835\uDD68': 'wopf',
        '\uD835\uDCCC': 'wscr',
        '\uD835\uDD34': 'wfr',
        '\uD835\uDCB2': 'Wscr',
        '\uD835\uDD4E': 'Wopf',
        '\uD835\uDD1A': 'Wfr',
        '\u0175': 'wcirc',
        '\u0174': 'Wcirc',
        '\uD835\uDD35': 'xfr',
        '\uD835\uDCCD': 'xscr',
        '\uD835\uDD69': 'xopf',
        '\uD835\uDD4F': 'Xopf',
        '\uD835\uDD1B': 'Xfr',
        '\uD835\uDCB3': 'Xscr',
        '\uD835\uDD36': 'yfr',
        '\uD835\uDCCE': 'yscr',
        '\uD835\uDD6A': 'yopf',
        '\uD835\uDCB4': 'Yscr',
        '\uD835\uDD1C': 'Yfr',
        '\uD835\uDD50': 'Yopf',
        '\xFD': 'yacute',
        '\xDD': 'Yacute',
        '\u0177': 'ycirc',
        '\u0176': 'Ycirc',
        '\xFF': 'yuml',
        '\u0178': 'Yuml',
        '\uD835\uDCCF': 'zscr',
        '\uD835\uDD37': 'zfr',
        '\uD835\uDD6B': 'zopf',
        '\u2128': 'Zfr',
        '\u2124': 'Zopf',
        '\uD835\uDCB5': 'Zscr',
        '\u017A': 'zacute',
        '\u0179': 'Zacute',
        '\u017E': 'zcaron',
        '\u017D': 'Zcaron',
        '\u017C': 'zdot',
        '\u017B': 'Zdot',
        '\u01B5': 'imped',
        '\xFE': 'thorn',
        '\xDE': 'THORN',
        '\u0149': 'napos',
        '\u03B1': 'alpha',
        '\u0391': 'Alpha',
        '\u03B2': 'beta',
        '\u0392': 'Beta',
        '\u03B3': 'gamma',
        '\u0393': 'Gamma',
        '\u03B4': 'delta',
        '\u0394': 'Delta',
        '\u03B5': 'epsi',
        '\u03F5': 'epsiv',
        '\u0395': 'Epsilon',
        '\u03DD': 'gammad',
        '\u03DC': 'Gammad',
        '\u03B6': 'zeta',
        '\u0396': 'Zeta',
        '\u03B7': 'eta',
        '\u0397': 'Eta',
        '\u03B8': 'theta',
        '\u03D1': 'thetav',
        '\u0398': 'Theta',
        '\u03B9': 'iota',
        '\u0399': 'Iota',
        '\u03BA': 'kappa',
        '\u03F0': 'kappav',
        '\u039A': 'Kappa',
        '\u03BB': 'lambda',
        '\u039B': 'Lambda',
        '\u03BC': 'mu',
        '\xB5': 'micro',
        '\u039C': 'Mu',
        '\u03BD': 'nu',
        '\u039D': 'Nu',
        '\u03BE': 'xi',
        '\u039E': 'Xi',
        '\u03BF': 'omicron',
        '\u039F': 'Omicron',
        '\u03C0': 'pi',
        '\u03D6': 'piv',
        '\u03A0': 'Pi',
        '\u03C1': 'rho',
        '\u03F1': 'rhov',
        '\u03A1': 'Rho',
        '\u03C3': 'sigma',
        '\u03A3': 'Sigma',
        '\u03C2': 'sigmaf',
        '\u03C4': 'tau',
        '\u03A4': 'Tau',
        '\u03C5': 'upsi',
        '\u03A5': 'Upsilon',
        '\u03D2': 'Upsi',
        '\u03C6': 'phi',
        '\u03D5': 'phiv',
        '\u03A6': 'Phi',
        '\u03C7': 'chi',
        '\u03A7': 'Chi',
        '\u03C8': 'psi',
        '\u03A8': 'Psi',
        '\u03C9': 'omega',
        '\u03A9': 'ohm',
        '\u0430': 'acy',
        '\u0410': 'Acy',
        '\u0431': 'bcy',
        '\u0411': 'Bcy',
        '\u0432': 'vcy',
        '\u0412': 'Vcy',
        '\u0433': 'gcy',
        '\u0413': 'Gcy',
        '\u0453': 'gjcy',
        '\u0403': 'GJcy',
        '\u0434': 'dcy',
        '\u0414': 'Dcy',
        '\u0452': 'djcy',
        '\u0402': 'DJcy',
        '\u0435': 'iecy',
        '\u0415': 'IEcy',
        '\u0451': 'iocy',
        '\u0401': 'IOcy',
        '\u0454': 'jukcy',
        '\u0404': 'Jukcy',
        '\u0436': 'zhcy',
        '\u0416': 'ZHcy',
        '\u0437': 'zcy',
        '\u0417': 'Zcy',
        '\u0455': 'dscy',
        '\u0405': 'DScy',
        '\u0438': 'icy',
        '\u0418': 'Icy',
        '\u0456': 'iukcy',
        '\u0406': 'Iukcy',
        '\u0457': 'yicy',
        '\u0407': 'YIcy',
        '\u0439': 'jcy',
        '\u0419': 'Jcy',
        '\u0458': 'jsercy',
        '\u0408': 'Jsercy',
        '\u043A': 'kcy',
        '\u041A': 'Kcy',
        '\u045C': 'kjcy',
        '\u040C': 'KJcy',
        '\u043B': 'lcy',
        '\u041B': 'Lcy',
        '\u0459': 'ljcy',
        '\u0409': 'LJcy',
        '\u043C': 'mcy',
        '\u041C': 'Mcy',
        '\u043D': 'ncy',
        '\u041D': 'Ncy',
        '\u045A': 'njcy',
        '\u040A': 'NJcy',
        '\u043E': 'ocy',
        '\u041E': 'Ocy',
        '\u043F': 'pcy',
        '\u041F': 'Pcy',
        '\u0440': 'rcy',
        '\u0420': 'Rcy',
        '\u0441': 'scy',
        '\u0421': 'Scy',
        '\u0442': 'tcy',
        '\u0422': 'Tcy',
        '\u045B': 'tshcy',
        '\u040B': 'TSHcy',
        '\u0443': 'ucy',
        '\u0423': 'Ucy',
        '\u045E': 'ubrcy',
        '\u040E': 'Ubrcy',
        '\u0444': 'fcy',
        '\u0424': 'Fcy',
        '\u0445': 'khcy',
        '\u0425': 'KHcy',
        '\u0446': 'tscy',
        '\u0426': 'TScy',
        '\u0447': 'chcy',
        '\u0427': 'CHcy',
        '\u045F': 'dzcy',
        '\u040F': 'DZcy',
        '\u0448': 'shcy',
        '\u0428': 'SHcy',
        '\u0449': 'shchcy',
        '\u0429': 'SHCHcy',
        '\u044A': 'hardcy',
        '\u042A': 'HARDcy',
        '\u044B': 'ycy',
        '\u042B': 'Ycy',
        '\u044C': 'softcy',
        '\u042C': 'SOFTcy',
        '\u044D': 'ecy',
        '\u042D': 'Ecy',
        '\u044E': 'yucy',
        '\u042E': 'YUcy',
        '\u044F': 'yacy',
        '\u042F': 'YAcy',
        '\u2135': 'aleph',
        '\u2136': 'beth',
        '\u2137': 'gimel',
        '\u2138': 'daleth'
    };
    var regexEscape = /["&'<>`]/g;
    var escapeMap = {
        '"': '&quot;',
        '&': '&amp;',
        '\'': '&#x27;',
        '<': '&lt;',
        // See https://mathiasbynens.be/notes/ambiguous-ampersands: in HTML, the
        // following is not strictly necessary unless it’s part of a tag or an
        // unquoted attribute value. We’re only escaping it to support those
        // situations, and for XML support.
        '>': '&gt;',
        // In Internet Explorer ≤ 8, the backtick character can be used
        // to break out of (un)quoted attribute values or HTML comments.
        // See http://html5sec.org/#102, http://html5sec.org/#108, and
        // http://html5sec.org/#133.
        '`': '&#x60;'
    };
    var regexInvalidEntity = /&#(?:[xX][^a-fA-F0-9]|[^0-9xX])/;
    var regexInvalidRawCodePoint = /[\0-\x08\x0B\x0E-\x1F\x7F-\x9F\uFDD0-\uFDEF\uFFFE\uFFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
    var regexDecode = /&(CounterClockwiseContourIntegral|DoubleLongLeftRightArrow|ClockwiseContourIntegral|NotNestedGreaterGreater|NotSquareSupersetEqual|DiacriticalDoubleAcute|NotRightTriangleEqual|NotSucceedsSlantEqual|NotPrecedesSlantEqual|CloseCurlyDoubleQuote|NegativeVeryThinSpace|DoubleContourIntegral|FilledVerySmallSquare|CapitalDifferentialD|OpenCurlyDoubleQuote|EmptyVerySmallSquare|NestedGreaterGreater|DoubleLongRightArrow|NotLeftTriangleEqual|NotGreaterSlantEqual|ReverseUpEquilibrium|DoubleLeftRightArrow|NotSquareSubsetEqual|NotDoubleVerticalBar|RightArrowLeftArrow|NotGreaterFullEqual|NotRightTriangleBar|SquareSupersetEqual|DownLeftRightVector|DoubleLongLeftArrow|leftrightsquigarrow|LeftArrowRightArrow|NegativeMediumSpace|blacktriangleright|RightDownVectorBar|PrecedesSlantEqual|RightDoubleBracket|SucceedsSlantEqual|NotLeftTriangleBar|RightTriangleEqual|SquareIntersection|RightDownTeeVector|ReverseEquilibrium|NegativeThickSpace|longleftrightarrow|Longleftrightarrow|LongLeftRightArrow|DownRightTeeVector|DownRightVectorBar|GreaterSlantEqual|SquareSubsetEqual|LeftDownVectorBar|LeftDoubleBracket|VerticalSeparator|rightleftharpoons|NotGreaterGreater|NotSquareSuperset|blacktriangleleft|blacktriangledown|NegativeThinSpace|LeftDownTeeVector|NotLessSlantEqual|leftrightharpoons|DoubleUpDownArrow|DoubleVerticalBar|LeftTriangleEqual|FilledSmallSquare|twoheadrightarrow|NotNestedLessLess|DownLeftTeeVector|DownLeftVectorBar|RightAngleBracket|NotTildeFullEqual|NotReverseElement|RightUpDownVector|DiacriticalTilde|NotSucceedsTilde|circlearrowright|NotPrecedesEqual|rightharpoondown|DoubleRightArrow|NotSucceedsEqual|NonBreakingSpace|NotRightTriangle|LessEqualGreater|RightUpTeeVector|LeftAngleBracket|GreaterFullEqual|DownArrowUpArrow|RightUpVectorBar|twoheadleftarrow|GreaterEqualLess|downharpoonright|RightTriangleBar|ntrianglerighteq|NotSupersetEqual|LeftUpDownVector|DiacriticalAcute|rightrightarrows|vartriangleright|UpArrowDownArrow|DiacriticalGrave|UnderParenthesis|EmptySmallSquare|LeftUpVectorBar|leftrightarrows|DownRightVector|downharpoonleft|trianglerighteq|ShortRightArrow|OverParenthesis|DoubleLeftArrow|DoubleDownArrow|NotSquareSubset|bigtriangledown|ntrianglelefteq|UpperRightArrow|curvearrowright|vartriangleleft|NotLeftTriangle|nleftrightarrow|LowerRightArrow|NotHumpDownHump|NotGreaterTilde|rightthreetimes|LeftUpTeeVector|NotGreaterEqual|straightepsilon|LeftTriangleBar|rightsquigarrow|ContourIntegral|rightleftarrows|CloseCurlyQuote|RightDownVector|LeftRightVector|nLeftrightarrow|leftharpoondown|circlearrowleft|SquareSuperset|OpenCurlyQuote|hookrightarrow|HorizontalLine|DiacriticalDot|NotLessGreater|ntriangleright|DoubleRightTee|InvisibleComma|InvisibleTimes|LowerLeftArrow|DownLeftVector|NotSubsetEqual|curvearrowleft|trianglelefteq|NotVerticalBar|TildeFullEqual|downdownarrows|NotGreaterLess|RightTeeVector|ZeroWidthSpace|looparrowright|LongRightArrow|doublebarwedge|ShortLeftArrow|ShortDownArrow|RightVectorBar|GreaterGreater|ReverseElement|rightharpoonup|LessSlantEqual|leftthreetimes|upharpoonright|rightarrowtail|LeftDownVector|Longrightarrow|NestedLessLess|UpperLeftArrow|nshortparallel|leftleftarrows|leftrightarrow|Leftrightarrow|LeftRightArrow|longrightarrow|upharpoonleft|RightArrowBar|ApplyFunction|LeftTeeVector|leftarrowtail|NotEqualTilde|varsubsetneqq|varsupsetneqq|RightTeeArrow|SucceedsEqual|SucceedsTilde|LeftVectorBar|SupersetEqual|hookleftarrow|DifferentialD|VerticalTilde|VeryThinSpace|blacktriangle|bigtriangleup|LessFullEqual|divideontimes|leftharpoonup|UpEquilibrium|ntriangleleft|RightTriangle|measuredangle|shortparallel|longleftarrow|Longleftarrow|LongLeftArrow|DoubleLeftTee|Poincareplane|PrecedesEqual|triangleright|DoubleUpArrow|RightUpVector|fallingdotseq|looparrowleft|PrecedesTilde|NotTildeEqual|NotTildeTilde|smallsetminus|Proportional|triangleleft|triangledown|UnderBracket|NotHumpEqual|exponentiale|ExponentialE|NotLessTilde|HilbertSpace|RightCeiling|blacklozenge|varsupsetneq|HumpDownHump|GreaterEqual|VerticalLine|LeftTeeArrow|NotLessEqual|DownTeeArrow|LeftTriangle|varsubsetneq|Intersection|NotCongruent|DownArrowBar|LeftUpVector|LeftArrowBar|risingdotseq|GreaterTilde|RoundImplies|SquareSubset|ShortUpArrow|NotSuperset|quaternions|precnapprox|backepsilon|preccurlyeq|OverBracket|blacksquare|MediumSpace|VerticalBar|circledcirc|circleddash|CircleMinus|CircleTimes|LessGreater|curlyeqprec|curlyeqsucc|diamondsuit|UpDownArrow|Updownarrow|RuleDelayed|Rrightarrow|updownarrow|RightVector|nRightarrow|nrightarrow|eqslantless|LeftCeiling|Equilibrium|SmallCircle|expectation|NotSucceeds|thickapprox|GreaterLess|SquareUnion|NotPrecedes|NotLessLess|straightphi|succnapprox|succcurlyeq|SubsetEqual|sqsupseteq|Proportion|Laplacetrf|ImaginaryI|supsetneqq|NotGreater|gtreqqless|NotElement|ThickSpace|TildeEqual|TildeTilde|Fouriertrf|rmoustache|EqualTilde|eqslantgtr|UnderBrace|LeftVector|UpArrowBar|nLeftarrow|nsubseteqq|subsetneqq|nsupseteqq|nleftarrow|succapprox|lessapprox|UpTeeArrow|upuparrows|curlywedge|lesseqqgtr|varepsilon|varnothing|RightFloor|complement|CirclePlus|sqsubseteq|Lleftarrow|circledast|RightArrow|Rightarrow|rightarrow|lmoustache|Bernoullis|precapprox|mapstoleft|mapstodown|longmapsto|dotsquare|downarrow|DoubleDot|nsubseteq|supsetneq|leftarrow|nsupseteq|subsetneq|ThinSpace|ngeqslant|subseteqq|HumpEqual|NotSubset|triangleq|NotCupCap|lesseqgtr|heartsuit|TripleDot|Leftarrow|Coproduct|Congruent|varpropto|complexes|gvertneqq|LeftArrow|LessTilde|supseteqq|MinusPlus|CircleDot|nleqslant|NotExists|gtreqless|nparallel|UnionPlus|LeftFloor|checkmark|CenterDot|centerdot|Mellintrf|gtrapprox|bigotimes|OverBrace|spadesuit|therefore|pitchfork|rationals|PlusMinus|Backslash|Therefore|DownBreve|backsimeq|backprime|DownArrow|nshortmid|Downarrow|lvertneqq|eqvparsl|imagline|imagpart|infintie|integers|Integral|intercal|LessLess|Uarrocir|intlarhk|sqsupset|angmsdaf|sqsubset|llcorner|vartheta|cupbrcap|lnapprox|Superset|SuchThat|succnsim|succneqq|angmsdag|biguplus|curlyvee|trpezium|Succeeds|NotTilde|bigwedge|angmsdah|angrtvbd|triminus|cwconint|fpartint|lrcorner|smeparsl|subseteq|urcorner|lurdshar|laemptyv|DDotrahd|approxeq|ldrushar|awconint|mapstoup|backcong|shortmid|triangle|geqslant|gesdotol|timesbar|circledR|circledS|setminus|multimap|naturals|scpolint|ncongdot|RightTee|boxminus|gnapprox|boxtimes|andslope|thicksim|angmsdaa|varsigma|cirfnint|rtriltri|angmsdab|rppolint|angmsdac|barwedge|drbkarow|clubsuit|thetasym|bsolhsub|capbrcup|dzigrarr|doteqdot|DotEqual|dotminus|UnderBar|NotEqual|realpart|otimesas|ulcorner|hksearow|hkswarow|parallel|PartialD|elinters|emptyset|plusacir|bbrktbrk|angmsdad|pointint|bigoplus|angmsdae|Precedes|bigsqcup|varkappa|notindot|supseteq|precneqq|precnsim|profalar|profline|profsurf|leqslant|lesdotor|raemptyv|subplus|notnivb|notnivc|subrarr|zigrarr|vzigzag|submult|subedot|Element|between|cirscir|larrbfs|larrsim|lotimes|lbrksld|lbrkslu|lozenge|ldrdhar|dbkarow|bigcirc|epsilon|simrarr|simplus|ltquest|Epsilon|luruhar|gtquest|maltese|npolint|eqcolon|npreceq|bigodot|ddagger|gtrless|bnequiv|harrcir|ddotseq|equivDD|backsim|demptyv|nsqsube|nsqsupe|Upsilon|nsubset|upsilon|minusdu|nsucceq|swarrow|nsupset|coloneq|searrow|boxplus|napprox|natural|asympeq|alefsym|congdot|nearrow|bigstar|diamond|supplus|tritime|LeftTee|nvinfin|triplus|NewLine|nvltrie|nvrtrie|nwarrow|nexists|Diamond|ruluhar|Implies|supmult|angzarr|suplarr|suphsub|questeq|because|digamma|Because|olcross|bemptyv|omicron|Omicron|rotimes|NoBreak|intprod|angrtvb|orderof|uwangle|suphsol|lesdoto|orslope|DownTee|realine|cudarrl|rdldhar|OverBar|supedot|lessdot|supdsub|topfork|succsim|rbrkslu|rbrksld|pertenk|cudarrr|isindot|planckh|lessgtr|pluscir|gesdoto|plussim|plustwo|lesssim|cularrp|rarrsim|Cayleys|notinva|notinvb|notinvc|UpArrow|Uparrow|uparrow|NotLess|dwangle|precsim|Product|curarrm|Cconint|dotplus|rarrbfs|ccupssm|Cedilla|cemptyv|notniva|quatint|frac35|frac38|frac45|frac56|frac58|frac78|tridot|xoplus|gacute|gammad|Gammad|lfisht|lfloor|bigcup|sqsupe|gbreve|Gbreve|lharul|sqsube|sqcups|Gcedil|apacir|llhard|lmidot|Lmidot|lmoust|andand|sqcaps|approx|Abreve|spades|circeq|tprime|divide|topcir|Assign|topbot|gesdot|divonx|xuplus|timesd|gesles|atilde|solbar|SOFTcy|loplus|timesb|lowast|lowbar|dlcorn|dlcrop|softcy|dollar|lparlt|thksim|lrhard|Atilde|lsaquo|smashp|bigvee|thinsp|wreath|bkarow|lsquor|lstrok|Lstrok|lthree|ltimes|ltlarr|DotDot|simdot|ltrPar|weierp|xsqcup|angmsd|sigmav|sigmaf|zeetrf|Zcaron|zcaron|mapsto|vsupne|thetav|cirmid|marker|mcomma|Zacute|vsubnE|there4|gtlPar|vsubne|bottom|gtrarr|SHCHcy|shchcy|midast|midcir|middot|minusb|minusd|gtrdot|bowtie|sfrown|mnplus|models|colone|seswar|Colone|mstpos|searhk|gtrsim|nacute|Nacute|boxbox|telrec|hairsp|Tcedil|nbumpe|scnsim|ncaron|Ncaron|ncedil|Ncedil|hamilt|Scedil|nearhk|hardcy|HARDcy|tcedil|Tcaron|commat|nequiv|nesear|tcaron|target|hearts|nexist|varrho|scedil|Scaron|scaron|hellip|Sacute|sacute|hercon|swnwar|compfn|rtimes|rthree|rsquor|rsaquo|zacute|wedgeq|homtht|barvee|barwed|Barwed|rpargt|horbar|conint|swarhk|roplus|nltrie|hslash|hstrok|Hstrok|rmoust|Conint|bprime|hybull|hyphen|iacute|Iacute|supsup|supsub|supsim|varphi|coprod|brvbar|agrave|Supset|supset|igrave|Igrave|notinE|Agrave|iiiint|iinfin|copysr|wedbar|Verbar|vangrt|becaus|incare|verbar|inodot|bullet|drcorn|intcal|drcrop|cularr|vellip|Utilde|bumpeq|cupcap|dstrok|Dstrok|CupCap|cupcup|cupdot|eacute|Eacute|supdot|iquest|easter|ecaron|Ecaron|ecolon|isinsv|utilde|itilde|Itilde|curarr|succeq|Bumpeq|cacute|ulcrop|nparsl|Cacute|nprcue|egrave|Egrave|nrarrc|nrarrw|subsup|subsub|nrtrie|jsercy|nsccue|Jsercy|kappav|kcedil|Kcedil|subsim|ulcorn|nsimeq|egsdot|veebar|kgreen|capand|elsdot|Subset|subset|curren|aacute|lacute|Lacute|emptyv|ntilde|Ntilde|lagran|lambda|Lambda|capcap|Ugrave|langle|subdot|emsp13|numero|emsp14|nvdash|nvDash|nVdash|nVDash|ugrave|ufisht|nvHarr|larrfs|nvlArr|larrhk|larrlp|larrpl|nvrArr|Udblac|nwarhk|larrtl|nwnear|oacute|Oacute|latail|lAtail|sstarf|lbrace|odblac|Odblac|lbrack|udblac|odsold|eparsl|lcaron|Lcaron|ograve|Ograve|lcedil|Lcedil|Aacute|ssmile|ssetmn|squarf|ldquor|capcup|ominus|cylcty|rharul|eqcirc|dagger|rfloor|rfisht|Dagger|daleth|equals|origof|capdot|equest|dcaron|Dcaron|rdquor|oslash|Oslash|otilde|Otilde|otimes|Otimes|urcrop|Ubreve|ubreve|Yacute|Uacute|uacute|Rcedil|rcedil|urcorn|parsim|Rcaron|Vdashl|rcaron|Tstrok|percnt|period|permil|Exists|yacute|rbrack|rbrace|phmmat|ccaron|Ccaron|planck|ccedil|plankv|tstrok|female|plusdo|plusdu|ffilig|plusmn|ffllig|Ccedil|rAtail|dfisht|bernou|ratail|Rarrtl|rarrtl|angsph|rarrpl|rarrlp|rarrhk|xwedge|xotime|forall|ForAll|Vvdash|vsupnE|preceq|bigcap|frac12|frac13|frac14|primes|rarrfs|prnsim|frac15|Square|frac16|square|lesdot|frac18|frac23|propto|prurel|rarrap|rangle|puncsp|frac25|Racute|qprime|racute|lesges|frac34|abreve|AElig|eqsim|utdot|setmn|urtri|Equal|Uring|seArr|uring|searr|dashv|Dashv|mumap|nabla|iogon|Iogon|sdote|sdotb|scsim|napid|napos|equiv|natur|Acirc|dblac|erarr|nbump|iprod|erDot|ucirc|awint|esdot|angrt|ncong|isinE|scnap|Scirc|scirc|ndash|isins|Ubrcy|nearr|neArr|isinv|nedot|ubrcy|acute|Ycirc|iukcy|Iukcy|xutri|nesim|caret|jcirc|Jcirc|caron|twixt|ddarr|sccue|exist|jmath|sbquo|ngeqq|angst|ccaps|lceil|ngsim|UpTee|delta|Delta|rtrif|nharr|nhArr|nhpar|rtrie|jukcy|Jukcy|kappa|rsquo|Kappa|nlarr|nlArr|TSHcy|rrarr|aogon|Aogon|fflig|xrarr|tshcy|ccirc|nleqq|filig|upsih|nless|dharl|nlsim|fjlig|ropar|nltri|dharr|robrk|roarr|fllig|fltns|roang|rnmid|subnE|subne|lAarr|trisb|Ccirc|acirc|ccups|blank|VDash|forkv|Vdash|langd|cedil|blk12|blk14|laquo|strns|diams|notin|vDash|larrb|blk34|block|disin|uplus|vdash|vBarv|aelig|starf|Wedge|check|xrArr|lates|lbarr|lBarr|notni|lbbrk|bcong|frasl|lbrke|frown|vrtri|vprop|vnsup|gamma|Gamma|wedge|xodot|bdquo|srarr|doteq|ldquo|boxdl|boxdL|gcirc|Gcirc|boxDl|boxDL|boxdr|boxdR|boxDr|TRADE|trade|rlhar|boxDR|vnsub|npart|vltri|rlarr|boxhd|boxhD|nprec|gescc|nrarr|nrArr|boxHd|boxHD|boxhu|boxhU|nrtri|boxHu|clubs|boxHU|times|colon|Colon|gimel|xlArr|Tilde|nsime|tilde|nsmid|nspar|THORN|thorn|xlarr|nsube|nsubE|thkap|xhArr|comma|nsucc|boxul|boxuL|nsupe|nsupE|gneqq|gnsim|boxUl|boxUL|grave|boxur|boxuR|boxUr|boxUR|lescc|angle|bepsi|boxvh|varpi|boxvH|numsp|Theta|gsime|gsiml|theta|boxVh|boxVH|boxvl|gtcir|gtdot|boxvL|boxVl|boxVL|crarr|cross|Cross|nvsim|boxvr|nwarr|nwArr|sqsup|dtdot|Uogon|lhard|lharu|dtrif|ocirc|Ocirc|lhblk|duarr|odash|sqsub|Hacek|sqcup|llarr|duhar|oelig|OElig|ofcir|boxvR|uogon|lltri|boxVr|csube|uuarr|ohbar|csupe|ctdot|olarr|olcir|harrw|oline|sqcap|omacr|Omacr|omega|Omega|boxVR|aleph|lneqq|lnsim|loang|loarr|rharu|lobrk|hcirc|operp|oplus|rhard|Hcirc|orarr|Union|order|ecirc|Ecirc|cuepr|szlig|cuesc|breve|reals|eDDot|Breve|hoarr|lopar|utrif|rdquo|Umacr|umacr|efDot|swArr|ultri|alpha|rceil|ovbar|swarr|Wcirc|wcirc|smtes|smile|bsemi|lrarr|aring|parsl|lrhar|bsime|uhblk|lrtri|cupor|Aring|uharr|uharl|slarr|rbrke|bsolb|lsime|rbbrk|RBarr|lsimg|phone|rBarr|rbarr|icirc|lsquo|Icirc|emacr|Emacr|ratio|simne|plusb|simlE|simgE|simeq|pluse|ltcir|ltdot|empty|xharr|xdtri|iexcl|Alpha|ltrie|rarrw|pound|ltrif|xcirc|bumpe|prcue|bumpE|asymp|amacr|cuvee|Sigma|sigma|iiint|udhar|iiota|ijlig|IJlig|supnE|imacr|Imacr|prime|Prime|image|prnap|eogon|Eogon|rarrc|mdash|mDDot|cuwed|imath|supne|imped|Amacr|udarr|prsim|micro|rarrb|cwint|raquo|infin|eplus|range|rangd|Ucirc|radic|minus|amalg|veeeq|rAarr|epsiv|ycirc|quest|sharp|quot|zwnj|Qscr|race|qscr|Qopf|qopf|qint|rang|Rang|Zscr|zscr|Zopf|zopf|rarr|rArr|Rarr|Pscr|pscr|prop|prod|prnE|prec|ZHcy|zhcy|prap|Zeta|zeta|Popf|popf|Zdot|plus|zdot|Yuml|yuml|phiv|YUcy|yucy|Yscr|yscr|perp|Yopf|yopf|part|para|YIcy|Ouml|rcub|yicy|YAcy|rdca|ouml|osol|Oscr|rdsh|yacy|real|oscr|xvee|andd|rect|andv|Xscr|oror|ordm|ordf|xscr|ange|aopf|Aopf|rHar|Xopf|opar|Oopf|xopf|xnis|rhov|oopf|omid|xmap|oint|apid|apos|ogon|ascr|Ascr|odot|odiv|xcup|xcap|ocir|oast|nvlt|nvle|nvgt|nvge|nvap|Wscr|wscr|auml|ntlg|ntgl|nsup|nsub|nsim|Nscr|nscr|nsce|Wopf|ring|npre|wopf|npar|Auml|Barv|bbrk|Nopf|nopf|nmid|nLtv|beta|ropf|Ropf|Beta|beth|nles|rpar|nleq|bnot|bNot|nldr|NJcy|rscr|Rscr|Vscr|vscr|rsqb|njcy|bopf|nisd|Bopf|rtri|Vopf|nGtv|ngtr|vopf|boxh|boxH|boxv|nges|ngeq|boxV|bscr|scap|Bscr|bsim|Vert|vert|bsol|bull|bump|caps|cdot|ncup|scnE|ncap|nbsp|napE|Cdot|cent|sdot|Vbar|nang|vBar|chcy|Mscr|mscr|sect|semi|CHcy|Mopf|mopf|sext|circ|cire|mldr|mlcp|cirE|comp|shcy|SHcy|vArr|varr|cong|copf|Copf|copy|COPY|malt|male|macr|lvnE|cscr|ltri|sime|ltcc|simg|Cscr|siml|csub|Uuml|lsqb|lsim|uuml|csup|Lscr|lscr|utri|smid|lpar|cups|smte|lozf|darr|Lopf|Uscr|solb|lopf|sopf|Sopf|lneq|uscr|spar|dArr|lnap|Darr|dash|Sqrt|LJcy|ljcy|lHar|dHar|Upsi|upsi|diam|lesg|djcy|DJcy|leqq|dopf|Dopf|dscr|Dscr|dscy|ldsh|ldca|squf|DScy|sscr|Sscr|dsol|lcub|late|star|Star|Uopf|Larr|lArr|larr|uopf|dtri|dzcy|sube|subE|Lang|lang|Kscr|kscr|Kopf|kopf|KJcy|kjcy|KHcy|khcy|DZcy|ecir|edot|eDot|Jscr|jscr|succ|Jopf|jopf|Edot|uHar|emsp|ensp|Iuml|iuml|eopf|isin|Iscr|iscr|Eopf|epar|sung|epsi|escr|sup1|sup2|sup3|Iota|iota|supe|supE|Iopf|iopf|IOcy|iocy|Escr|esim|Esim|imof|Uarr|QUOT|uArr|uarr|euml|IEcy|iecy|Idot|Euml|euro|excl|Hscr|hscr|Hopf|hopf|TScy|tscy|Tscr|hbar|tscr|flat|tbrk|fnof|hArr|harr|half|fopf|Fopf|tdot|gvnE|fork|trie|gtcc|fscr|Fscr|gdot|gsim|Gscr|gscr|Gopf|gopf|gneq|Gdot|tosa|gnap|Topf|topf|geqq|toea|GJcy|gjcy|tint|gesl|mid|Sfr|ggg|top|ges|gla|glE|glj|geq|gne|gEl|gel|gnE|Gcy|gcy|gap|Tfr|tfr|Tcy|tcy|Hat|Tau|Ffr|tau|Tab|hfr|Hfr|ffr|Fcy|fcy|icy|Icy|iff|ETH|eth|ifr|Ifr|Eta|eta|int|Int|Sup|sup|ucy|Ucy|Sum|sum|jcy|ENG|ufr|Ufr|eng|Jcy|jfr|els|ell|egs|Efr|efr|Jfr|uml|kcy|Kcy|Ecy|ecy|kfr|Kfr|lap|Sub|sub|lat|lcy|Lcy|leg|Dot|dot|lEg|leq|les|squ|div|die|lfr|Lfr|lgE|Dfr|dfr|Del|deg|Dcy|dcy|lne|lnE|sol|loz|smt|Cup|lrm|cup|lsh|Lsh|sim|shy|map|Map|mcy|Mcy|mfr|Mfr|mho|gfr|Gfr|sfr|cir|Chi|chi|nap|Cfr|vcy|Vcy|cfr|Scy|scy|ncy|Ncy|vee|Vee|Cap|cap|nfr|scE|sce|Nfr|nge|ngE|nGg|vfr|Vfr|ngt|bot|nGt|nis|niv|Rsh|rsh|nle|nlE|bne|Bfr|bfr|nLl|nlt|nLt|Bcy|bcy|not|Not|rlm|wfr|Wfr|npr|nsc|num|ocy|ast|Ocy|ofr|xfr|Xfr|Ofr|ogt|ohm|apE|olt|Rho|ape|rho|Rfr|rfr|ord|REG|ang|reg|orv|And|and|AMP|Rcy|amp|Afr|ycy|Ycy|yen|yfr|Yfr|rcy|par|pcy|Pcy|pfr|Pfr|phi|Phi|afr|Acy|acy|zcy|Zcy|piv|acE|acd|zfr|Zfr|pre|prE|psi|Psi|qfr|Qfr|zwj|Or|ge|Gg|gt|gg|el|oS|lt|Lt|LT|Re|lg|gl|eg|ne|Im|it|le|DD|wp|wr|nu|Nu|dd|lE|Sc|sc|pi|Pi|ee|af|ll|Ll|rx|gE|xi|pm|Xi|ic|pr|Pr|in|ni|mp|mu|ac|Mu|or|ap|Gt|GT|ii);|&(Aacute|Agrave|Atilde|Ccedil|Eacute|Egrave|Iacute|Igrave|Ntilde|Oacute|Ograve|Oslash|Otilde|Uacute|Ugrave|Yacute|aacute|agrave|atilde|brvbar|ccedil|curren|divide|eacute|egrave|frac12|frac14|frac34|iacute|igrave|iquest|middot|ntilde|oacute|ograve|oslash|otilde|plusmn|uacute|ugrave|yacute|AElig|Acirc|Aring|Ecirc|Icirc|Ocirc|THORN|Ucirc|acirc|acute|aelig|aring|cedil|ecirc|icirc|iexcl|laquo|micro|ocirc|pound|raquo|szlig|thorn|times|ucirc|Auml|COPY|Euml|Iuml|Ouml|QUOT|Uuml|auml|cent|copy|euml|iuml|macr|nbsp|ordf|ordm|ouml|para|quot|sect|sup1|sup2|sup3|uuml|yuml|AMP|ETH|REG|amp|deg|eth|not|reg|shy|uml|yen|GT|LT|gt|lt)(?!;)([=a-zA-Z0-9]?)|&#([0-9]+)(;?)|&#[xX]([a-fA-F0-9]+)(;?)|&([0-9a-zA-Z]+)/g;
    var decodeMap = {
        'aacute': '\xE1',
        'Aacute': '\xC1',
        'abreve': '\u0103',
        'Abreve': '\u0102',
        'ac': '\u223E',
        'acd': '\u223F',
        'acE': '\u223E\u0333',
        'acirc': '\xE2',
        'Acirc': '\xC2',
        'acute': '\xB4',
        'acy': '\u0430',
        'Acy': '\u0410',
        'aelig': '\xE6',
        'AElig': '\xC6',
        'af': '\u2061',
        'afr': '\uD835\uDD1E',
        'Afr': '\uD835\uDD04',
        'agrave': '\xE0',
        'Agrave': '\xC0',
        'alefsym': '\u2135',
        'aleph': '\u2135',
        'alpha': '\u03B1',
        'Alpha': '\u0391',
        'amacr': '\u0101',
        'Amacr': '\u0100',
        'amalg': '\u2A3F',
        'amp': '&',
        'AMP': '&',
        'and': '\u2227',
        'And': '\u2A53',
        'andand': '\u2A55',
        'andd': '\u2A5C',
        'andslope': '\u2A58',
        'andv': '\u2A5A',
        'ang': '\u2220',
        'ange': '\u29A4',
        'angle': '\u2220',
        'angmsd': '\u2221',
        'angmsdaa': '\u29A8',
        'angmsdab': '\u29A9',
        'angmsdac': '\u29AA',
        'angmsdad': '\u29AB',
        'angmsdae': '\u29AC',
        'angmsdaf': '\u29AD',
        'angmsdag': '\u29AE',
        'angmsdah': '\u29AF',
        'angrt': '\u221F',
        'angrtvb': '\u22BE',
        'angrtvbd': '\u299D',
        'angsph': '\u2222',
        'angst': '\xC5',
        'angzarr': '\u237C',
        'aogon': '\u0105',
        'Aogon': '\u0104',
        'aopf': '\uD835\uDD52',
        'Aopf': '\uD835\uDD38',
        'ap': '\u2248',
        'apacir': '\u2A6F',
        'ape': '\u224A',
        'apE': '\u2A70',
        'apid': '\u224B',
        'apos': '\'',
        'ApplyFunction': '\u2061',
        'approx': '\u2248',
        'approxeq': '\u224A',
        'aring': '\xE5',
        'Aring': '\xC5',
        'ascr': '\uD835\uDCB6',
        'Ascr': '\uD835\uDC9C',
        'Assign': '\u2254',
        'ast': '*',
        'asymp': '\u2248',
        'asympeq': '\u224D',
        'atilde': '\xE3',
        'Atilde': '\xC3',
        'auml': '\xE4',
        'Auml': '\xC4',
        'awconint': '\u2233',
        'awint': '\u2A11',
        'backcong': '\u224C',
        'backepsilon': '\u03F6',
        'backprime': '\u2035',
        'backsim': '\u223D',
        'backsimeq': '\u22CD',
        'Backslash': '\u2216',
        'Barv': '\u2AE7',
        'barvee': '\u22BD',
        'barwed': '\u2305',
        'Barwed': '\u2306',
        'barwedge': '\u2305',
        'bbrk': '\u23B5',
        'bbrktbrk': '\u23B6',
        'bcong': '\u224C',
        'bcy': '\u0431',
        'Bcy': '\u0411',
        'bdquo': '\u201E',
        'becaus': '\u2235',
        'because': '\u2235',
        'Because': '\u2235',
        'bemptyv': '\u29B0',
        'bepsi': '\u03F6',
        'bernou': '\u212C',
        'Bernoullis': '\u212C',
        'beta': '\u03B2',
        'Beta': '\u0392',
        'beth': '\u2136',
        'between': '\u226C',
        'bfr': '\uD835\uDD1F',
        'Bfr': '\uD835\uDD05',
        'bigcap': '\u22C2',
        'bigcirc': '\u25EF',
        'bigcup': '\u22C3',
        'bigodot': '\u2A00',
        'bigoplus': '\u2A01',
        'bigotimes': '\u2A02',
        'bigsqcup': '\u2A06',
        'bigstar': '\u2605',
        'bigtriangledown': '\u25BD',
        'bigtriangleup': '\u25B3',
        'biguplus': '\u2A04',
        'bigvee': '\u22C1',
        'bigwedge': '\u22C0',
        'bkarow': '\u290D',
        'blacklozenge': '\u29EB',
        'blacksquare': '\u25AA',
        'blacktriangle': '\u25B4',
        'blacktriangledown': '\u25BE',
        'blacktriangleleft': '\u25C2',
        'blacktriangleright': '\u25B8',
        'blank': '\u2423',
        'blk12': '\u2592',
        'blk14': '\u2591',
        'blk34': '\u2593',
        'block': '\u2588',
        'bne': '=\u20E5',
        'bnequiv': '\u2261\u20E5',
        'bnot': '\u2310',
        'bNot': '\u2AED',
        'bopf': '\uD835\uDD53',
        'Bopf': '\uD835\uDD39',
        'bot': '\u22A5',
        'bottom': '\u22A5',
        'bowtie': '\u22C8',
        'boxbox': '\u29C9',
        'boxdl': '\u2510',
        'boxdL': '\u2555',
        'boxDl': '\u2556',
        'boxDL': '\u2557',
        'boxdr': '\u250C',
        'boxdR': '\u2552',
        'boxDr': '\u2553',
        'boxDR': '\u2554',
        'boxh': '\u2500',
        'boxH': '\u2550',
        'boxhd': '\u252C',
        'boxhD': '\u2565',
        'boxHd': '\u2564',
        'boxHD': '\u2566',
        'boxhu': '\u2534',
        'boxhU': '\u2568',
        'boxHu': '\u2567',
        'boxHU': '\u2569',
        'boxminus': '\u229F',
        'boxplus': '\u229E',
        'boxtimes': '\u22A0',
        'boxul': '\u2518',
        'boxuL': '\u255B',
        'boxUl': '\u255C',
        'boxUL': '\u255D',
        'boxur': '\u2514',
        'boxuR': '\u2558',
        'boxUr': '\u2559',
        'boxUR': '\u255A',
        'boxv': '\u2502',
        'boxV': '\u2551',
        'boxvh': '\u253C',
        'boxvH': '\u256A',
        'boxVh': '\u256B',
        'boxVH': '\u256C',
        'boxvl': '\u2524',
        'boxvL': '\u2561',
        'boxVl': '\u2562',
        'boxVL': '\u2563',
        'boxvr': '\u251C',
        'boxvR': '\u255E',
        'boxVr': '\u255F',
        'boxVR': '\u2560',
        'bprime': '\u2035',
        'breve': '\u02D8',
        'Breve': '\u02D8',
        'brvbar': '\xA6',
        'bscr': '\uD835\uDCB7',
        'Bscr': '\u212C',
        'bsemi': '\u204F',
        'bsim': '\u223D',
        'bsime': '\u22CD',
        'bsol': '\\',
        'bsolb': '\u29C5',
        'bsolhsub': '\u27C8',
        'bull': '\u2022',
        'bullet': '\u2022',
        'bump': '\u224E',
        'bumpe': '\u224F',
        'bumpE': '\u2AAE',
        'bumpeq': '\u224F',
        'Bumpeq': '\u224E',
        'cacute': '\u0107',
        'Cacute': '\u0106',
        'cap': '\u2229',
        'Cap': '\u22D2',
        'capand': '\u2A44',
        'capbrcup': '\u2A49',
        'capcap': '\u2A4B',
        'capcup': '\u2A47',
        'capdot': '\u2A40',
        'CapitalDifferentialD': '\u2145',
        'caps': '\u2229\uFE00',
        'caret': '\u2041',
        'caron': '\u02C7',
        'Cayleys': '\u212D',
        'ccaps': '\u2A4D',
        'ccaron': '\u010D',
        'Ccaron': '\u010C',
        'ccedil': '\xE7',
        'Ccedil': '\xC7',
        'ccirc': '\u0109',
        'Ccirc': '\u0108',
        'Cconint': '\u2230',
        'ccups': '\u2A4C',
        'ccupssm': '\u2A50',
        'cdot': '\u010B',
        'Cdot': '\u010A',
        'cedil': '\xB8',
        'Cedilla': '\xB8',
        'cemptyv': '\u29B2',
        'cent': '\xA2',
        'centerdot': '\xB7',
        'CenterDot': '\xB7',
        'cfr': '\uD835\uDD20',
        'Cfr': '\u212D',
        'chcy': '\u0447',
        'CHcy': '\u0427',
        'check': '\u2713',
        'checkmark': '\u2713',
        'chi': '\u03C7',
        'Chi': '\u03A7',
        'cir': '\u25CB',
        'circ': '\u02C6',
        'circeq': '\u2257',
        'circlearrowleft': '\u21BA',
        'circlearrowright': '\u21BB',
        'circledast': '\u229B',
        'circledcirc': '\u229A',
        'circleddash': '\u229D',
        'CircleDot': '\u2299',
        'circledR': '\xAE',
        'circledS': '\u24C8',
        'CircleMinus': '\u2296',
        'CirclePlus': '\u2295',
        'CircleTimes': '\u2297',
        'cire': '\u2257',
        'cirE': '\u29C3',
        'cirfnint': '\u2A10',
        'cirmid': '\u2AEF',
        'cirscir': '\u29C2',
        'ClockwiseContourIntegral': '\u2232',
        'CloseCurlyDoubleQuote': '\u201D',
        'CloseCurlyQuote': '\u2019',
        'clubs': '\u2663',
        'clubsuit': '\u2663',
        'colon': ':',
        'Colon': '\u2237',
        'colone': '\u2254',
        'Colone': '\u2A74',
        'coloneq': '\u2254',
        'comma': ',',
        'commat': '@',
        'comp': '\u2201',
        'compfn': '\u2218',
        'complement': '\u2201',
        'complexes': '\u2102',
        'cong': '\u2245',
        'congdot': '\u2A6D',
        'Congruent': '\u2261',
        'conint': '\u222E',
        'Conint': '\u222F',
        'ContourIntegral': '\u222E',
        'copf': '\uD835\uDD54',
        'Copf': '\u2102',
        'coprod': '\u2210',
        'Coproduct': '\u2210',
        'copy': '\xA9',
        'COPY': '\xA9',
        'copysr': '\u2117',
        'CounterClockwiseContourIntegral': '\u2233',
        'crarr': '\u21B5',
        'cross': '\u2717',
        'Cross': '\u2A2F',
        'cscr': '\uD835\uDCB8',
        'Cscr': '\uD835\uDC9E',
        'csub': '\u2ACF',
        'csube': '\u2AD1',
        'csup': '\u2AD0',
        'csupe': '\u2AD2',
        'ctdot': '\u22EF',
        'cudarrl': '\u2938',
        'cudarrr': '\u2935',
        'cuepr': '\u22DE',
        'cuesc': '\u22DF',
        'cularr': '\u21B6',
        'cularrp': '\u293D',
        'cup': '\u222A',
        'Cup': '\u22D3',
        'cupbrcap': '\u2A48',
        'cupcap': '\u2A46',
        'CupCap': '\u224D',
        'cupcup': '\u2A4A',
        'cupdot': '\u228D',
        'cupor': '\u2A45',
        'cups': '\u222A\uFE00',
        'curarr': '\u21B7',
        'curarrm': '\u293C',
        'curlyeqprec': '\u22DE',
        'curlyeqsucc': '\u22DF',
        'curlyvee': '\u22CE',
        'curlywedge': '\u22CF',
        'curren': '\xA4',
        'curvearrowleft': '\u21B6',
        'curvearrowright': '\u21B7',
        'cuvee': '\u22CE',
        'cuwed': '\u22CF',
        'cwconint': '\u2232',
        'cwint': '\u2231',
        'cylcty': '\u232D',
        'dagger': '\u2020',
        'Dagger': '\u2021',
        'daleth': '\u2138',
        'darr': '\u2193',
        'dArr': '\u21D3',
        'Darr': '\u21A1',
        'dash': '\u2010',
        'dashv': '\u22A3',
        'Dashv': '\u2AE4',
        'dbkarow': '\u290F',
        'dblac': '\u02DD',
        'dcaron': '\u010F',
        'Dcaron': '\u010E',
        'dcy': '\u0434',
        'Dcy': '\u0414',
        'dd': '\u2146',
        'DD': '\u2145',
        'ddagger': '\u2021',
        'ddarr': '\u21CA',
        'DDotrahd': '\u2911',
        'ddotseq': '\u2A77',
        'deg': '\xB0',
        'Del': '\u2207',
        'delta': '\u03B4',
        'Delta': '\u0394',
        'demptyv': '\u29B1',
        'dfisht': '\u297F',
        'dfr': '\uD835\uDD21',
        'Dfr': '\uD835\uDD07',
        'dHar': '\u2965',
        'dharl': '\u21C3',
        'dharr': '\u21C2',
        'DiacriticalAcute': '\xB4',
        'DiacriticalDot': '\u02D9',
        'DiacriticalDoubleAcute': '\u02DD',
        'DiacriticalGrave': '`',
        'DiacriticalTilde': '\u02DC',
        'diam': '\u22C4',
        'diamond': '\u22C4',
        'Diamond': '\u22C4',
        'diamondsuit': '\u2666',
        'diams': '\u2666',
        'die': '\xA8',
        'DifferentialD': '\u2146',
        'digamma': '\u03DD',
        'disin': '\u22F2',
        'div': '\xF7',
        'divide': '\xF7',
        'divideontimes': '\u22C7',
        'divonx': '\u22C7',
        'djcy': '\u0452',
        'DJcy': '\u0402',
        'dlcorn': '\u231E',
        'dlcrop': '\u230D',
        'dollar': '$',
        'dopf': '\uD835\uDD55',
        'Dopf': '\uD835\uDD3B',
        'dot': '\u02D9',
        'Dot': '\xA8',
        'DotDot': '\u20DC',
        'doteq': '\u2250',
        'doteqdot': '\u2251',
        'DotEqual': '\u2250',
        'dotminus': '\u2238',
        'dotplus': '\u2214',
        'dotsquare': '\u22A1',
        'doublebarwedge': '\u2306',
        'DoubleContourIntegral': '\u222F',
        'DoubleDot': '\xA8',
        'DoubleDownArrow': '\u21D3',
        'DoubleLeftArrow': '\u21D0',
        'DoubleLeftRightArrow': '\u21D4',
        'DoubleLeftTee': '\u2AE4',
        'DoubleLongLeftArrow': '\u27F8',
        'DoubleLongLeftRightArrow': '\u27FA',
        'DoubleLongRightArrow': '\u27F9',
        'DoubleRightArrow': '\u21D2',
        'DoubleRightTee': '\u22A8',
        'DoubleUpArrow': '\u21D1',
        'DoubleUpDownArrow': '\u21D5',
        'DoubleVerticalBar': '\u2225',
        'downarrow': '\u2193',
        'Downarrow': '\u21D3',
        'DownArrow': '\u2193',
        'DownArrowBar': '\u2913',
        'DownArrowUpArrow': '\u21F5',
        'DownBreve': '\u0311',
        'downdownarrows': '\u21CA',
        'downharpoonleft': '\u21C3',
        'downharpoonright': '\u21C2',
        'DownLeftRightVector': '\u2950',
        'DownLeftTeeVector': '\u295E',
        'DownLeftVector': '\u21BD',
        'DownLeftVectorBar': '\u2956',
        'DownRightTeeVector': '\u295F',
        'DownRightVector': '\u21C1',
        'DownRightVectorBar': '\u2957',
        'DownTee': '\u22A4',
        'DownTeeArrow': '\u21A7',
        'drbkarow': '\u2910',
        'drcorn': '\u231F',
        'drcrop': '\u230C',
        'dscr': '\uD835\uDCB9',
        'Dscr': '\uD835\uDC9F',
        'dscy': '\u0455',
        'DScy': '\u0405',
        'dsol': '\u29F6',
        'dstrok': '\u0111',
        'Dstrok': '\u0110',
        'dtdot': '\u22F1',
        'dtri': '\u25BF',
        'dtrif': '\u25BE',
        'duarr': '\u21F5',
        'duhar': '\u296F',
        'dwangle': '\u29A6',
        'dzcy': '\u045F',
        'DZcy': '\u040F',
        'dzigrarr': '\u27FF',
        'eacute': '\xE9',
        'Eacute': '\xC9',
        'easter': '\u2A6E',
        'ecaron': '\u011B',
        'Ecaron': '\u011A',
        'ecir': '\u2256',
        'ecirc': '\xEA',
        'Ecirc': '\xCA',
        'ecolon': '\u2255',
        'ecy': '\u044D',
        'Ecy': '\u042D',
        'eDDot': '\u2A77',
        'edot': '\u0117',
        'eDot': '\u2251',
        'Edot': '\u0116',
        'ee': '\u2147',
        'efDot': '\u2252',
        'efr': '\uD835\uDD22',
        'Efr': '\uD835\uDD08',
        'eg': '\u2A9A',
        'egrave': '\xE8',
        'Egrave': '\xC8',
        'egs': '\u2A96',
        'egsdot': '\u2A98',
        'el': '\u2A99',
        'Element': '\u2208',
        'elinters': '\u23E7',
        'ell': '\u2113',
        'els': '\u2A95',
        'elsdot': '\u2A97',
        'emacr': '\u0113',
        'Emacr': '\u0112',
        'empty': '\u2205',
        'emptyset': '\u2205',
        'EmptySmallSquare': '\u25FB',
        'emptyv': '\u2205',
        'EmptyVerySmallSquare': '\u25AB',
        'emsp': '\u2003',
        'emsp13': '\u2004',
        'emsp14': '\u2005',
        'eng': '\u014B',
        'ENG': '\u014A',
        'ensp': '\u2002',
        'eogon': '\u0119',
        'Eogon': '\u0118',
        'eopf': '\uD835\uDD56',
        'Eopf': '\uD835\uDD3C',
        'epar': '\u22D5',
        'eparsl': '\u29E3',
        'eplus': '\u2A71',
        'epsi': '\u03B5',
        'epsilon': '\u03B5',
        'Epsilon': '\u0395',
        'epsiv': '\u03F5',
        'eqcirc': '\u2256',
        'eqcolon': '\u2255',
        'eqsim': '\u2242',
        'eqslantgtr': '\u2A96',
        'eqslantless': '\u2A95',
        'Equal': '\u2A75',
        'equals': '=',
        'EqualTilde': '\u2242',
        'equest': '\u225F',
        'Equilibrium': '\u21CC',
        'equiv': '\u2261',
        'equivDD': '\u2A78',
        'eqvparsl': '\u29E5',
        'erarr': '\u2971',
        'erDot': '\u2253',
        'escr': '\u212F',
        'Escr': '\u2130',
        'esdot': '\u2250',
        'esim': '\u2242',
        'Esim': '\u2A73',
        'eta': '\u03B7',
        'Eta': '\u0397',
        'eth': '\xF0',
        'ETH': '\xD0',
        'euml': '\xEB',
        'Euml': '\xCB',
        'euro': '\u20AC',
        'excl': '!',
        'exist': '\u2203',
        'Exists': '\u2203',
        'expectation': '\u2130',
        'exponentiale': '\u2147',
        'ExponentialE': '\u2147',
        'fallingdotseq': '\u2252',
        'fcy': '\u0444',
        'Fcy': '\u0424',
        'female': '\u2640',
        'ffilig': '\uFB03',
        'fflig': '\uFB00',
        'ffllig': '\uFB04',
        'ffr': '\uD835\uDD23',
        'Ffr': '\uD835\uDD09',
        'filig': '\uFB01',
        'FilledSmallSquare': '\u25FC',
        'FilledVerySmallSquare': '\u25AA',
        'fjlig': 'fj',
        'flat': '\u266D',
        'fllig': '\uFB02',
        'fltns': '\u25B1',
        'fnof': '\u0192',
        'fopf': '\uD835\uDD57',
        'Fopf': '\uD835\uDD3D',
        'forall': '\u2200',
        'ForAll': '\u2200',
        'fork': '\u22D4',
        'forkv': '\u2AD9',
        'Fouriertrf': '\u2131',
        'fpartint': '\u2A0D',
        'frac12': '\xBD',
        'frac13': '\u2153',
        'frac14': '\xBC',
        'frac15': '\u2155',
        'frac16': '\u2159',
        'frac18': '\u215B',
        'frac23': '\u2154',
        'frac25': '\u2156',
        'frac34': '\xBE',
        'frac35': '\u2157',
        'frac38': '\u215C',
        'frac45': '\u2158',
        'frac56': '\u215A',
        'frac58': '\u215D',
        'frac78': '\u215E',
        'frasl': '\u2044',
        'frown': '\u2322',
        'fscr': '\uD835\uDCBB',
        'Fscr': '\u2131',
        'gacute': '\u01F5',
        'gamma': '\u03B3',
        'Gamma': '\u0393',
        'gammad': '\u03DD',
        'Gammad': '\u03DC',
        'gap': '\u2A86',
        'gbreve': '\u011F',
        'Gbreve': '\u011E',
        'Gcedil': '\u0122',
        'gcirc': '\u011D',
        'Gcirc': '\u011C',
        'gcy': '\u0433',
        'Gcy': '\u0413',
        'gdot': '\u0121',
        'Gdot': '\u0120',
        'ge': '\u2265',
        'gE': '\u2267',
        'gel': '\u22DB',
        'gEl': '\u2A8C',
        'geq': '\u2265',
        'geqq': '\u2267',
        'geqslant': '\u2A7E',
        'ges': '\u2A7E',
        'gescc': '\u2AA9',
        'gesdot': '\u2A80',
        'gesdoto': '\u2A82',
        'gesdotol': '\u2A84',
        'gesl': '\u22DB\uFE00',
        'gesles': '\u2A94',
        'gfr': '\uD835\uDD24',
        'Gfr': '\uD835\uDD0A',
        'gg': '\u226B',
        'Gg': '\u22D9',
        'ggg': '\u22D9',
        'gimel': '\u2137',
        'gjcy': '\u0453',
        'GJcy': '\u0403',
        'gl': '\u2277',
        'gla': '\u2AA5',
        'glE': '\u2A92',
        'glj': '\u2AA4',
        'gnap': '\u2A8A',
        'gnapprox': '\u2A8A',
        'gne': '\u2A88',
        'gnE': '\u2269',
        'gneq': '\u2A88',
        'gneqq': '\u2269',
        'gnsim': '\u22E7',
        'gopf': '\uD835\uDD58',
        'Gopf': '\uD835\uDD3E',
        'grave': '`',
        'GreaterEqual': '\u2265',
        'GreaterEqualLess': '\u22DB',
        'GreaterFullEqual': '\u2267',
        'GreaterGreater': '\u2AA2',
        'GreaterLess': '\u2277',
        'GreaterSlantEqual': '\u2A7E',
        'GreaterTilde': '\u2273',
        'gscr': '\u210A',
        'Gscr': '\uD835\uDCA2',
        'gsim': '\u2273',
        'gsime': '\u2A8E',
        'gsiml': '\u2A90',
        'gt': '>',
        'Gt': '\u226B',
        'GT': '>',
        'gtcc': '\u2AA7',
        'gtcir': '\u2A7A',
        'gtdot': '\u22D7',
        'gtlPar': '\u2995',
        'gtquest': '\u2A7C',
        'gtrapprox': '\u2A86',
        'gtrarr': '\u2978',
        'gtrdot': '\u22D7',
        'gtreqless': '\u22DB',
        'gtreqqless': '\u2A8C',
        'gtrless': '\u2277',
        'gtrsim': '\u2273',
        'gvertneqq': '\u2269\uFE00',
        'gvnE': '\u2269\uFE00',
        'Hacek': '\u02C7',
        'hairsp': '\u200A',
        'half': '\xBD',
        'hamilt': '\u210B',
        'hardcy': '\u044A',
        'HARDcy': '\u042A',
        'harr': '\u2194',
        'hArr': '\u21D4',
        'harrcir': '\u2948',
        'harrw': '\u21AD',
        'Hat': '^',
        'hbar': '\u210F',
        'hcirc': '\u0125',
        'Hcirc': '\u0124',
        'hearts': '\u2665',
        'heartsuit': '\u2665',
        'hellip': '\u2026',
        'hercon': '\u22B9',
        'hfr': '\uD835\uDD25',
        'Hfr': '\u210C',
        'HilbertSpace': '\u210B',
        'hksearow': '\u2925',
        'hkswarow': '\u2926',
        'hoarr': '\u21FF',
        'homtht': '\u223B',
        'hookleftarrow': '\u21A9',
        'hookrightarrow': '\u21AA',
        'hopf': '\uD835\uDD59',
        'Hopf': '\u210D',
        'horbar': '\u2015',
        'HorizontalLine': '\u2500',
        'hscr': '\uD835\uDCBD',
        'Hscr': '\u210B',
        'hslash': '\u210F',
        'hstrok': '\u0127',
        'Hstrok': '\u0126',
        'HumpDownHump': '\u224E',
        'HumpEqual': '\u224F',
        'hybull': '\u2043',
        'hyphen': '\u2010',
        'iacute': '\xED',
        'Iacute': '\xCD',
        'ic': '\u2063',
        'icirc': '\xEE',
        'Icirc': '\xCE',
        'icy': '\u0438',
        'Icy': '\u0418',
        'Idot': '\u0130',
        'iecy': '\u0435',
        'IEcy': '\u0415',
        'iexcl': '\xA1',
        'iff': '\u21D4',
        'ifr': '\uD835\uDD26',
        'Ifr': '\u2111',
        'igrave': '\xEC',
        'Igrave': '\xCC',
        'ii': '\u2148',
        'iiiint': '\u2A0C',
        'iiint': '\u222D',
        'iinfin': '\u29DC',
        'iiota': '\u2129',
        'ijlig': '\u0133',
        'IJlig': '\u0132',
        'Im': '\u2111',
        'imacr': '\u012B',
        'Imacr': '\u012A',
        'image': '\u2111',
        'ImaginaryI': '\u2148',
        'imagline': '\u2110',
        'imagpart': '\u2111',
        'imath': '\u0131',
        'imof': '\u22B7',
        'imped': '\u01B5',
        'Implies': '\u21D2',
        'in': '\u2208',
        'incare': '\u2105',
        'infin': '\u221E',
        'infintie': '\u29DD',
        'inodot': '\u0131',
        'int': '\u222B',
        'Int': '\u222C',
        'intcal': '\u22BA',
        'integers': '\u2124',
        'Integral': '\u222B',
        'intercal': '\u22BA',
        'Intersection': '\u22C2',
        'intlarhk': '\u2A17',
        'intprod': '\u2A3C',
        'InvisibleComma': '\u2063',
        'InvisibleTimes': '\u2062',
        'iocy': '\u0451',
        'IOcy': '\u0401',
        'iogon': '\u012F',
        'Iogon': '\u012E',
        'iopf': '\uD835\uDD5A',
        'Iopf': '\uD835\uDD40',
        'iota': '\u03B9',
        'Iota': '\u0399',
        'iprod': '\u2A3C',
        'iquest': '\xBF',
        'iscr': '\uD835\uDCBE',
        'Iscr': '\u2110',
        'isin': '\u2208',
        'isindot': '\u22F5',
        'isinE': '\u22F9',
        'isins': '\u22F4',
        'isinsv': '\u22F3',
        'isinv': '\u2208',
        'it': '\u2062',
        'itilde': '\u0129',
        'Itilde': '\u0128',
        'iukcy': '\u0456',
        'Iukcy': '\u0406',
        'iuml': '\xEF',
        'Iuml': '\xCF',
        'jcirc': '\u0135',
        'Jcirc': '\u0134',
        'jcy': '\u0439',
        'Jcy': '\u0419',
        'jfr': '\uD835\uDD27',
        'Jfr': '\uD835\uDD0D',
        'jmath': '\u0237',
        'jopf': '\uD835\uDD5B',
        'Jopf': '\uD835\uDD41',
        'jscr': '\uD835\uDCBF',
        'Jscr': '\uD835\uDCA5',
        'jsercy': '\u0458',
        'Jsercy': '\u0408',
        'jukcy': '\u0454',
        'Jukcy': '\u0404',
        'kappa': '\u03BA',
        'Kappa': '\u039A',
        'kappav': '\u03F0',
        'kcedil': '\u0137',
        'Kcedil': '\u0136',
        'kcy': '\u043A',
        'Kcy': '\u041A',
        'kfr': '\uD835\uDD28',
        'Kfr': '\uD835\uDD0E',
        'kgreen': '\u0138',
        'khcy': '\u0445',
        'KHcy': '\u0425',
        'kjcy': '\u045C',
        'KJcy': '\u040C',
        'kopf': '\uD835\uDD5C',
        'Kopf': '\uD835\uDD42',
        'kscr': '\uD835\uDCC0',
        'Kscr': '\uD835\uDCA6',
        'lAarr': '\u21DA',
        'lacute': '\u013A',
        'Lacute': '\u0139',
        'laemptyv': '\u29B4',
        'lagran': '\u2112',
        'lambda': '\u03BB',
        'Lambda': '\u039B',
        'lang': '\u27E8',
        'Lang': '\u27EA',
        'langd': '\u2991',
        'langle': '\u27E8',
        'lap': '\u2A85',
        'Laplacetrf': '\u2112',
        'laquo': '\xAB',
        'larr': '\u2190',
        'lArr': '\u21D0',
        'Larr': '\u219E',
        'larrb': '\u21E4',
        'larrbfs': '\u291F',
        'larrfs': '\u291D',
        'larrhk': '\u21A9',
        'larrlp': '\u21AB',
        'larrpl': '\u2939',
        'larrsim': '\u2973',
        'larrtl': '\u21A2',
        'lat': '\u2AAB',
        'latail': '\u2919',
        'lAtail': '\u291B',
        'late': '\u2AAD',
        'lates': '\u2AAD\uFE00',
        'lbarr': '\u290C',
        'lBarr': '\u290E',
        'lbbrk': '\u2772',
        'lbrace': '{',
        'lbrack': '[',
        'lbrke': '\u298B',
        'lbrksld': '\u298F',
        'lbrkslu': '\u298D',
        'lcaron': '\u013E',
        'Lcaron': '\u013D',
        'lcedil': '\u013C',
        'Lcedil': '\u013B',
        'lceil': '\u2308',
        'lcub': '{',
        'lcy': '\u043B',
        'Lcy': '\u041B',
        'ldca': '\u2936',
        'ldquo': '\u201C',
        'ldquor': '\u201E',
        'ldrdhar': '\u2967',
        'ldrushar': '\u294B',
        'ldsh': '\u21B2',
        'le': '\u2264',
        'lE': '\u2266',
        'LeftAngleBracket': '\u27E8',
        'leftarrow': '\u2190',
        'Leftarrow': '\u21D0',
        'LeftArrow': '\u2190',
        'LeftArrowBar': '\u21E4',
        'LeftArrowRightArrow': '\u21C6',
        'leftarrowtail': '\u21A2',
        'LeftCeiling': '\u2308',
        'LeftDoubleBracket': '\u27E6',
        'LeftDownTeeVector': '\u2961',
        'LeftDownVector': '\u21C3',
        'LeftDownVectorBar': '\u2959',
        'LeftFloor': '\u230A',
        'leftharpoondown': '\u21BD',
        'leftharpoonup': '\u21BC',
        'leftleftarrows': '\u21C7',
        'leftrightarrow': '\u2194',
        'Leftrightarrow': '\u21D4',
        'LeftRightArrow': '\u2194',
        'leftrightarrows': '\u21C6',
        'leftrightharpoons': '\u21CB',
        'leftrightsquigarrow': '\u21AD',
        'LeftRightVector': '\u294E',
        'LeftTee': '\u22A3',
        'LeftTeeArrow': '\u21A4',
        'LeftTeeVector': '\u295A',
        'leftthreetimes': '\u22CB',
        'LeftTriangle': '\u22B2',
        'LeftTriangleBar': '\u29CF',
        'LeftTriangleEqual': '\u22B4',
        'LeftUpDownVector': '\u2951',
        'LeftUpTeeVector': '\u2960',
        'LeftUpVector': '\u21BF',
        'LeftUpVectorBar': '\u2958',
        'LeftVector': '\u21BC',
        'LeftVectorBar': '\u2952',
        'leg': '\u22DA',
        'lEg': '\u2A8B',
        'leq': '\u2264',
        'leqq': '\u2266',
        'leqslant': '\u2A7D',
        'les': '\u2A7D',
        'lescc': '\u2AA8',
        'lesdot': '\u2A7F',
        'lesdoto': '\u2A81',
        'lesdotor': '\u2A83',
        'lesg': '\u22DA\uFE00',
        'lesges': '\u2A93',
        'lessapprox': '\u2A85',
        'lessdot': '\u22D6',
        'lesseqgtr': '\u22DA',
        'lesseqqgtr': '\u2A8B',
        'LessEqualGreater': '\u22DA',
        'LessFullEqual': '\u2266',
        'LessGreater': '\u2276',
        'lessgtr': '\u2276',
        'LessLess': '\u2AA1',
        'lesssim': '\u2272',
        'LessSlantEqual': '\u2A7D',
        'LessTilde': '\u2272',
        'lfisht': '\u297C',
        'lfloor': '\u230A',
        'lfr': '\uD835\uDD29',
        'Lfr': '\uD835\uDD0F',
        'lg': '\u2276',
        'lgE': '\u2A91',
        'lHar': '\u2962',
        'lhard': '\u21BD',
        'lharu': '\u21BC',
        'lharul': '\u296A',
        'lhblk': '\u2584',
        'ljcy': '\u0459',
        'LJcy': '\u0409',
        'll': '\u226A',
        'Ll': '\u22D8',
        'llarr': '\u21C7',
        'llcorner': '\u231E',
        'Lleftarrow': '\u21DA',
        'llhard': '\u296B',
        'lltri': '\u25FA',
        'lmidot': '\u0140',
        'Lmidot': '\u013F',
        'lmoust': '\u23B0',
        'lmoustache': '\u23B0',
        'lnap': '\u2A89',
        'lnapprox': '\u2A89',
        'lne': '\u2A87',
        'lnE': '\u2268',
        'lneq': '\u2A87',
        'lneqq': '\u2268',
        'lnsim': '\u22E6',
        'loang': '\u27EC',
        'loarr': '\u21FD',
        'lobrk': '\u27E6',
        'longleftarrow': '\u27F5',
        'Longleftarrow': '\u27F8',
        'LongLeftArrow': '\u27F5',
        'longleftrightarrow': '\u27F7',
        'Longleftrightarrow': '\u27FA',
        'LongLeftRightArrow': '\u27F7',
        'longmapsto': '\u27FC',
        'longrightarrow': '\u27F6',
        'Longrightarrow': '\u27F9',
        'LongRightArrow': '\u27F6',
        'looparrowleft': '\u21AB',
        'looparrowright': '\u21AC',
        'lopar': '\u2985',
        'lopf': '\uD835\uDD5D',
        'Lopf': '\uD835\uDD43',
        'loplus': '\u2A2D',
        'lotimes': '\u2A34',
        'lowast': '\u2217',
        'lowbar': '_',
        'LowerLeftArrow': '\u2199',
        'LowerRightArrow': '\u2198',
        'loz': '\u25CA',
        'lozenge': '\u25CA',
        'lozf': '\u29EB',
        'lpar': '(',
        'lparlt': '\u2993',
        'lrarr': '\u21C6',
        'lrcorner': '\u231F',
        'lrhar': '\u21CB',
        'lrhard': '\u296D',
        'lrm': '\u200E',
        'lrtri': '\u22BF',
        'lsaquo': '\u2039',
        'lscr': '\uD835\uDCC1',
        'Lscr': '\u2112',
        'lsh': '\u21B0',
        'Lsh': '\u21B0',
        'lsim': '\u2272',
        'lsime': '\u2A8D',
        'lsimg': '\u2A8F',
        'lsqb': '[',
        'lsquo': '\u2018',
        'lsquor': '\u201A',
        'lstrok': '\u0142',
        'Lstrok': '\u0141',
        'lt': '<',
        'Lt': '\u226A',
        'LT': '<',
        'ltcc': '\u2AA6',
        'ltcir': '\u2A79',
        'ltdot': '\u22D6',
        'lthree': '\u22CB',
        'ltimes': '\u22C9',
        'ltlarr': '\u2976',
        'ltquest': '\u2A7B',
        'ltri': '\u25C3',
        'ltrie': '\u22B4',
        'ltrif': '\u25C2',
        'ltrPar': '\u2996',
        'lurdshar': '\u294A',
        'luruhar': '\u2966',
        'lvertneqq': '\u2268\uFE00',
        'lvnE': '\u2268\uFE00',
        'macr': '\xAF',
        'male': '\u2642',
        'malt': '\u2720',
        'maltese': '\u2720',
        'map': '\u21A6',
        'Map': '\u2905',
        'mapsto': '\u21A6',
        'mapstodown': '\u21A7',
        'mapstoleft': '\u21A4',
        'mapstoup': '\u21A5',
        'marker': '\u25AE',
        'mcomma': '\u2A29',
        'mcy': '\u043C',
        'Mcy': '\u041C',
        'mdash': '\u2014',
        'mDDot': '\u223A',
        'measuredangle': '\u2221',
        'MediumSpace': '\u205F',
        'Mellintrf': '\u2133',
        'mfr': '\uD835\uDD2A',
        'Mfr': '\uD835\uDD10',
        'mho': '\u2127',
        'micro': '\xB5',
        'mid': '\u2223',
        'midast': '*',
        'midcir': '\u2AF0',
        'middot': '\xB7',
        'minus': '\u2212',
        'minusb': '\u229F',
        'minusd': '\u2238',
        'minusdu': '\u2A2A',
        'MinusPlus': '\u2213',
        'mlcp': '\u2ADB',
        'mldr': '\u2026',
        'mnplus': '\u2213',
        'models': '\u22A7',
        'mopf': '\uD835\uDD5E',
        'Mopf': '\uD835\uDD44',
        'mp': '\u2213',
        'mscr': '\uD835\uDCC2',
        'Mscr': '\u2133',
        'mstpos': '\u223E',
        'mu': '\u03BC',
        'Mu': '\u039C',
        'multimap': '\u22B8',
        'mumap': '\u22B8',
        'nabla': '\u2207',
        'nacute': '\u0144',
        'Nacute': '\u0143',
        'nang': '\u2220\u20D2',
        'nap': '\u2249',
        'napE': '\u2A70\u0338',
        'napid': '\u224B\u0338',
        'napos': '\u0149',
        'napprox': '\u2249',
        'natur': '\u266E',
        'natural': '\u266E',
        'naturals': '\u2115',
        'nbsp': '\xA0',
        'nbump': '\u224E\u0338',
        'nbumpe': '\u224F\u0338',
        'ncap': '\u2A43',
        'ncaron': '\u0148',
        'Ncaron': '\u0147',
        'ncedil': '\u0146',
        'Ncedil': '\u0145',
        'ncong': '\u2247',
        'ncongdot': '\u2A6D\u0338',
        'ncup': '\u2A42',
        'ncy': '\u043D',
        'Ncy': '\u041D',
        'ndash': '\u2013',
        'ne': '\u2260',
        'nearhk': '\u2924',
        'nearr': '\u2197',
        'neArr': '\u21D7',
        'nearrow': '\u2197',
        'nedot': '\u2250\u0338',
        'NegativeMediumSpace': '\u200B',
        'NegativeThickSpace': '\u200B',
        'NegativeThinSpace': '\u200B',
        'NegativeVeryThinSpace': '\u200B',
        'nequiv': '\u2262',
        'nesear': '\u2928',
        'nesim': '\u2242\u0338',
        'NestedGreaterGreater': '\u226B',
        'NestedLessLess': '\u226A',
        'NewLine': '\n',
        'nexist': '\u2204',
        'nexists': '\u2204',
        'nfr': '\uD835\uDD2B',
        'Nfr': '\uD835\uDD11',
        'nge': '\u2271',
        'ngE': '\u2267\u0338',
        'ngeq': '\u2271',
        'ngeqq': '\u2267\u0338',
        'ngeqslant': '\u2A7E\u0338',
        'nges': '\u2A7E\u0338',
        'nGg': '\u22D9\u0338',
        'ngsim': '\u2275',
        'ngt': '\u226F',
        'nGt': '\u226B\u20D2',
        'ngtr': '\u226F',
        'nGtv': '\u226B\u0338',
        'nharr': '\u21AE',
        'nhArr': '\u21CE',
        'nhpar': '\u2AF2',
        'ni': '\u220B',
        'nis': '\u22FC',
        'nisd': '\u22FA',
        'niv': '\u220B',
        'njcy': '\u045A',
        'NJcy': '\u040A',
        'nlarr': '\u219A',
        'nlArr': '\u21CD',
        'nldr': '\u2025',
        'nle': '\u2270',
        'nlE': '\u2266\u0338',
        'nleftarrow': '\u219A',
        'nLeftarrow': '\u21CD',
        'nleftrightarrow': '\u21AE',
        'nLeftrightarrow': '\u21CE',
        'nleq': '\u2270',
        'nleqq': '\u2266\u0338',
        'nleqslant': '\u2A7D\u0338',
        'nles': '\u2A7D\u0338',
        'nless': '\u226E',
        'nLl': '\u22D8\u0338',
        'nlsim': '\u2274',
        'nlt': '\u226E',
        'nLt': '\u226A\u20D2',
        'nltri': '\u22EA',
        'nltrie': '\u22EC',
        'nLtv': '\u226A\u0338',
        'nmid': '\u2224',
        'NoBreak': '\u2060',
        'NonBreakingSpace': '\xA0',
        'nopf': '\uD835\uDD5F',
        'Nopf': '\u2115',
        'not': '\xAC',
        'Not': '\u2AEC',
        'NotCongruent': '\u2262',
        'NotCupCap': '\u226D',
        'NotDoubleVerticalBar': '\u2226',
        'NotElement': '\u2209',
        'NotEqual': '\u2260',
        'NotEqualTilde': '\u2242\u0338',
        'NotExists': '\u2204',
        'NotGreater': '\u226F',
        'NotGreaterEqual': '\u2271',
        'NotGreaterFullEqual': '\u2267\u0338',
        'NotGreaterGreater': '\u226B\u0338',
        'NotGreaterLess': '\u2279',
        'NotGreaterSlantEqual': '\u2A7E\u0338',
        'NotGreaterTilde': '\u2275',
        'NotHumpDownHump': '\u224E\u0338',
        'NotHumpEqual': '\u224F\u0338',
        'notin': '\u2209',
        'notindot': '\u22F5\u0338',
        'notinE': '\u22F9\u0338',
        'notinva': '\u2209',
        'notinvb': '\u22F7',
        'notinvc': '\u22F6',
        'NotLeftTriangle': '\u22EA',
        'NotLeftTriangleBar': '\u29CF\u0338',
        'NotLeftTriangleEqual': '\u22EC',
        'NotLess': '\u226E',
        'NotLessEqual': '\u2270',
        'NotLessGreater': '\u2278',
        'NotLessLess': '\u226A\u0338',
        'NotLessSlantEqual': '\u2A7D\u0338',
        'NotLessTilde': '\u2274',
        'NotNestedGreaterGreater': '\u2AA2\u0338',
        'NotNestedLessLess': '\u2AA1\u0338',
        'notni': '\u220C',
        'notniva': '\u220C',
        'notnivb': '\u22FE',
        'notnivc': '\u22FD',
        'NotPrecedes': '\u2280',
        'NotPrecedesEqual': '\u2AAF\u0338',
        'NotPrecedesSlantEqual': '\u22E0',
        'NotReverseElement': '\u220C',
        'NotRightTriangle': '\u22EB',
        'NotRightTriangleBar': '\u29D0\u0338',
        'NotRightTriangleEqual': '\u22ED',
        'NotSquareSubset': '\u228F\u0338',
        'NotSquareSubsetEqual': '\u22E2',
        'NotSquareSuperset': '\u2290\u0338',
        'NotSquareSupersetEqual': '\u22E3',
        'NotSubset': '\u2282\u20D2',
        'NotSubsetEqual': '\u2288',
        'NotSucceeds': '\u2281',
        'NotSucceedsEqual': '\u2AB0\u0338',
        'NotSucceedsSlantEqual': '\u22E1',
        'NotSucceedsTilde': '\u227F\u0338',
        'NotSuperset': '\u2283\u20D2',
        'NotSupersetEqual': '\u2289',
        'NotTilde': '\u2241',
        'NotTildeEqual': '\u2244',
        'NotTildeFullEqual': '\u2247',
        'NotTildeTilde': '\u2249',
        'NotVerticalBar': '\u2224',
        'npar': '\u2226',
        'nparallel': '\u2226',
        'nparsl': '\u2AFD\u20E5',
        'npart': '\u2202\u0338',
        'npolint': '\u2A14',
        'npr': '\u2280',
        'nprcue': '\u22E0',
        'npre': '\u2AAF\u0338',
        'nprec': '\u2280',
        'npreceq': '\u2AAF\u0338',
        'nrarr': '\u219B',
        'nrArr': '\u21CF',
        'nrarrc': '\u2933\u0338',
        'nrarrw': '\u219D\u0338',
        'nrightarrow': '\u219B',
        'nRightarrow': '\u21CF',
        'nrtri': '\u22EB',
        'nrtrie': '\u22ED',
        'nsc': '\u2281',
        'nsccue': '\u22E1',
        'nsce': '\u2AB0\u0338',
        'nscr': '\uD835\uDCC3',
        'Nscr': '\uD835\uDCA9',
        'nshortmid': '\u2224',
        'nshortparallel': '\u2226',
        'nsim': '\u2241',
        'nsime': '\u2244',
        'nsimeq': '\u2244',
        'nsmid': '\u2224',
        'nspar': '\u2226',
        'nsqsube': '\u22E2',
        'nsqsupe': '\u22E3',
        'nsub': '\u2284',
        'nsube': '\u2288',
        'nsubE': '\u2AC5\u0338',
        'nsubset': '\u2282\u20D2',
        'nsubseteq': '\u2288',
        'nsubseteqq': '\u2AC5\u0338',
        'nsucc': '\u2281',
        'nsucceq': '\u2AB0\u0338',
        'nsup': '\u2285',
        'nsupe': '\u2289',
        'nsupE': '\u2AC6\u0338',
        'nsupset': '\u2283\u20D2',
        'nsupseteq': '\u2289',
        'nsupseteqq': '\u2AC6\u0338',
        'ntgl': '\u2279',
        'ntilde': '\xF1',
        'Ntilde': '\xD1',
        'ntlg': '\u2278',
        'ntriangleleft': '\u22EA',
        'ntrianglelefteq': '\u22EC',
        'ntriangleright': '\u22EB',
        'ntrianglerighteq': '\u22ED',
        'nu': '\u03BD',
        'Nu': '\u039D',
        'num': '#',
        'numero': '\u2116',
        'numsp': '\u2007',
        'nvap': '\u224D\u20D2',
        'nvdash': '\u22AC',
        'nvDash': '\u22AD',
        'nVdash': '\u22AE',
        'nVDash': '\u22AF',
        'nvge': '\u2265\u20D2',
        'nvgt': '>\u20D2',
        'nvHarr': '\u2904',
        'nvinfin': '\u29DE',
        'nvlArr': '\u2902',
        'nvle': '\u2264\u20D2',
        'nvlt': '<\u20D2',
        'nvltrie': '\u22B4\u20D2',
        'nvrArr': '\u2903',
        'nvrtrie': '\u22B5\u20D2',
        'nvsim': '\u223C\u20D2',
        'nwarhk': '\u2923',
        'nwarr': '\u2196',
        'nwArr': '\u21D6',
        'nwarrow': '\u2196',
        'nwnear': '\u2927',
        'oacute': '\xF3',
        'Oacute': '\xD3',
        'oast': '\u229B',
        'ocir': '\u229A',
        'ocirc': '\xF4',
        'Ocirc': '\xD4',
        'ocy': '\u043E',
        'Ocy': '\u041E',
        'odash': '\u229D',
        'odblac': '\u0151',
        'Odblac': '\u0150',
        'odiv': '\u2A38',
        'odot': '\u2299',
        'odsold': '\u29BC',
        'oelig': '\u0153',
        'OElig': '\u0152',
        'ofcir': '\u29BF',
        'ofr': '\uD835\uDD2C',
        'Ofr': '\uD835\uDD12',
        'ogon': '\u02DB',
        'ograve': '\xF2',
        'Ograve': '\xD2',
        'ogt': '\u29C1',
        'ohbar': '\u29B5',
        'ohm': '\u03A9',
        'oint': '\u222E',
        'olarr': '\u21BA',
        'olcir': '\u29BE',
        'olcross': '\u29BB',
        'oline': '\u203E',
        'olt': '\u29C0',
        'omacr': '\u014D',
        'Omacr': '\u014C',
        'omega': '\u03C9',
        'Omega': '\u03A9',
        'omicron': '\u03BF',
        'Omicron': '\u039F',
        'omid': '\u29B6',
        'ominus': '\u2296',
        'oopf': '\uD835\uDD60',
        'Oopf': '\uD835\uDD46',
        'opar': '\u29B7',
        'OpenCurlyDoubleQuote': '\u201C',
        'OpenCurlyQuote': '\u2018',
        'operp': '\u29B9',
        'oplus': '\u2295',
        'or': '\u2228',
        'Or': '\u2A54',
        'orarr': '\u21BB',
        'ord': '\u2A5D',
        'order': '\u2134',
        'orderof': '\u2134',
        'ordf': '\xAA',
        'ordm': '\xBA',
        'origof': '\u22B6',
        'oror': '\u2A56',
        'orslope': '\u2A57',
        'orv': '\u2A5B',
        'oS': '\u24C8',
        'oscr': '\u2134',
        'Oscr': '\uD835\uDCAA',
        'oslash': '\xF8',
        'Oslash': '\xD8',
        'osol': '\u2298',
        'otilde': '\xF5',
        'Otilde': '\xD5',
        'otimes': '\u2297',
        'Otimes': '\u2A37',
        'otimesas': '\u2A36',
        'ouml': '\xF6',
        'Ouml': '\xD6',
        'ovbar': '\u233D',
        'OverBar': '\u203E',
        'OverBrace': '\u23DE',
        'OverBracket': '\u23B4',
        'OverParenthesis': '\u23DC',
        'par': '\u2225',
        'para': '\xB6',
        'parallel': '\u2225',
        'parsim': '\u2AF3',
        'parsl': '\u2AFD',
        'part': '\u2202',
        'PartialD': '\u2202',
        'pcy': '\u043F',
        'Pcy': '\u041F',
        'percnt': '%',
        'period': '.',
        'permil': '\u2030',
        'perp': '\u22A5',
        'pertenk': '\u2031',
        'pfr': '\uD835\uDD2D',
        'Pfr': '\uD835\uDD13',
        'phi': '\u03C6',
        'Phi': '\u03A6',
        'phiv': '\u03D5',
        'phmmat': '\u2133',
        'phone': '\u260E',
        'pi': '\u03C0',
        'Pi': '\u03A0',
        'pitchfork': '\u22D4',
        'piv': '\u03D6',
        'planck': '\u210F',
        'planckh': '\u210E',
        'plankv': '\u210F',
        'plus': '+',
        'plusacir': '\u2A23',
        'plusb': '\u229E',
        'pluscir': '\u2A22',
        'plusdo': '\u2214',
        'plusdu': '\u2A25',
        'pluse': '\u2A72',
        'PlusMinus': '\xB1',
        'plusmn': '\xB1',
        'plussim': '\u2A26',
        'plustwo': '\u2A27',
        'pm': '\xB1',
        'Poincareplane': '\u210C',
        'pointint': '\u2A15',
        'popf': '\uD835\uDD61',
        'Popf': '\u2119',
        'pound': '\xA3',
        'pr': '\u227A',
        'Pr': '\u2ABB',
        'prap': '\u2AB7',
        'prcue': '\u227C',
        'pre': '\u2AAF',
        'prE': '\u2AB3',
        'prec': '\u227A',
        'precapprox': '\u2AB7',
        'preccurlyeq': '\u227C',
        'Precedes': '\u227A',
        'PrecedesEqual': '\u2AAF',
        'PrecedesSlantEqual': '\u227C',
        'PrecedesTilde': '\u227E',
        'preceq': '\u2AAF',
        'precnapprox': '\u2AB9',
        'precneqq': '\u2AB5',
        'precnsim': '\u22E8',
        'precsim': '\u227E',
        'prime': '\u2032',
        'Prime': '\u2033',
        'primes': '\u2119',
        'prnap': '\u2AB9',
        'prnE': '\u2AB5',
        'prnsim': '\u22E8',
        'prod': '\u220F',
        'Product': '\u220F',
        'profalar': '\u232E',
        'profline': '\u2312',
        'profsurf': '\u2313',
        'prop': '\u221D',
        'Proportion': '\u2237',
        'Proportional': '\u221D',
        'propto': '\u221D',
        'prsim': '\u227E',
        'prurel': '\u22B0',
        'pscr': '\uD835\uDCC5',
        'Pscr': '\uD835\uDCAB',
        'psi': '\u03C8',
        'Psi': '\u03A8',
        'puncsp': '\u2008',
        'qfr': '\uD835\uDD2E',
        'Qfr': '\uD835\uDD14',
        'qint': '\u2A0C',
        'qopf': '\uD835\uDD62',
        'Qopf': '\u211A',
        'qprime': '\u2057',
        'qscr': '\uD835\uDCC6',
        'Qscr': '\uD835\uDCAC',
        'quaternions': '\u210D',
        'quatint': '\u2A16',
        'quest': '?',
        'questeq': '\u225F',
        'quot': '"',
        'QUOT': '"',
        'rAarr': '\u21DB',
        'race': '\u223D\u0331',
        'racute': '\u0155',
        'Racute': '\u0154',
        'radic': '\u221A',
        'raemptyv': '\u29B3',
        'rang': '\u27E9',
        'Rang': '\u27EB',
        'rangd': '\u2992',
        'range': '\u29A5',
        'rangle': '\u27E9',
        'raquo': '\xBB',
        'rarr': '\u2192',
        'rArr': '\u21D2',
        'Rarr': '\u21A0',
        'rarrap': '\u2975',
        'rarrb': '\u21E5',
        'rarrbfs': '\u2920',
        'rarrc': '\u2933',
        'rarrfs': '\u291E',
        'rarrhk': '\u21AA',
        'rarrlp': '\u21AC',
        'rarrpl': '\u2945',
        'rarrsim': '\u2974',
        'rarrtl': '\u21A3',
        'Rarrtl': '\u2916',
        'rarrw': '\u219D',
        'ratail': '\u291A',
        'rAtail': '\u291C',
        'ratio': '\u2236',
        'rationals': '\u211A',
        'rbarr': '\u290D',
        'rBarr': '\u290F',
        'RBarr': '\u2910',
        'rbbrk': '\u2773',
        'rbrace': '}',
        'rbrack': ']',
        'rbrke': '\u298C',
        'rbrksld': '\u298E',
        'rbrkslu': '\u2990',
        'rcaron': '\u0159',
        'Rcaron': '\u0158',
        'rcedil': '\u0157',
        'Rcedil': '\u0156',
        'rceil': '\u2309',
        'rcub': '}',
        'rcy': '\u0440',
        'Rcy': '\u0420',
        'rdca': '\u2937',
        'rdldhar': '\u2969',
        'rdquo': '\u201D',
        'rdquor': '\u201D',
        'rdsh': '\u21B3',
        'Re': '\u211C',
        'real': '\u211C',
        'realine': '\u211B',
        'realpart': '\u211C',
        'reals': '\u211D',
        'rect': '\u25AD',
        'reg': '\xAE',
        'REG': '\xAE',
        'ReverseElement': '\u220B',
        'ReverseEquilibrium': '\u21CB',
        'ReverseUpEquilibrium': '\u296F',
        'rfisht': '\u297D',
        'rfloor': '\u230B',
        'rfr': '\uD835\uDD2F',
        'Rfr': '\u211C',
        'rHar': '\u2964',
        'rhard': '\u21C1',
        'rharu': '\u21C0',
        'rharul': '\u296C',
        'rho': '\u03C1',
        'Rho': '\u03A1',
        'rhov': '\u03F1',
        'RightAngleBracket': '\u27E9',
        'rightarrow': '\u2192',
        'Rightarrow': '\u21D2',
        'RightArrow': '\u2192',
        'RightArrowBar': '\u21E5',
        'RightArrowLeftArrow': '\u21C4',
        'rightarrowtail': '\u21A3',
        'RightCeiling': '\u2309',
        'RightDoubleBracket': '\u27E7',
        'RightDownTeeVector': '\u295D',
        'RightDownVector': '\u21C2',
        'RightDownVectorBar': '\u2955',
        'RightFloor': '\u230B',
        'rightharpoondown': '\u21C1',
        'rightharpoonup': '\u21C0',
        'rightleftarrows': '\u21C4',
        'rightleftharpoons': '\u21CC',
        'rightrightarrows': '\u21C9',
        'rightsquigarrow': '\u219D',
        'RightTee': '\u22A2',
        'RightTeeArrow': '\u21A6',
        'RightTeeVector': '\u295B',
        'rightthreetimes': '\u22CC',
        'RightTriangle': '\u22B3',
        'RightTriangleBar': '\u29D0',
        'RightTriangleEqual': '\u22B5',
        'RightUpDownVector': '\u294F',
        'RightUpTeeVector': '\u295C',
        'RightUpVector': '\u21BE',
        'RightUpVectorBar': '\u2954',
        'RightVector': '\u21C0',
        'RightVectorBar': '\u2953',
        'ring': '\u02DA',
        'risingdotseq': '\u2253',
        'rlarr': '\u21C4',
        'rlhar': '\u21CC',
        'rlm': '\u200F',
        'rmoust': '\u23B1',
        'rmoustache': '\u23B1',
        'rnmid': '\u2AEE',
        'roang': '\u27ED',
        'roarr': '\u21FE',
        'robrk': '\u27E7',
        'ropar': '\u2986',
        'ropf': '\uD835\uDD63',
        'Ropf': '\u211D',
        'roplus': '\u2A2E',
        'rotimes': '\u2A35',
        'RoundImplies': '\u2970',
        'rpar': ')',
        'rpargt': '\u2994',
        'rppolint': '\u2A12',
        'rrarr': '\u21C9',
        'Rrightarrow': '\u21DB',
        'rsaquo': '\u203A',
        'rscr': '\uD835\uDCC7',
        'Rscr': '\u211B',
        'rsh': '\u21B1',
        'Rsh': '\u21B1',
        'rsqb': ']',
        'rsquo': '\u2019',
        'rsquor': '\u2019',
        'rthree': '\u22CC',
        'rtimes': '\u22CA',
        'rtri': '\u25B9',
        'rtrie': '\u22B5',
        'rtrif': '\u25B8',
        'rtriltri': '\u29CE',
        'RuleDelayed': '\u29F4',
        'ruluhar': '\u2968',
        'rx': '\u211E',
        'sacute': '\u015B',
        'Sacute': '\u015A',
        'sbquo': '\u201A',
        'sc': '\u227B',
        'Sc': '\u2ABC',
        'scap': '\u2AB8',
        'scaron': '\u0161',
        'Scaron': '\u0160',
        'sccue': '\u227D',
        'sce': '\u2AB0',
        'scE': '\u2AB4',
        'scedil': '\u015F',
        'Scedil': '\u015E',
        'scirc': '\u015D',
        'Scirc': '\u015C',
        'scnap': '\u2ABA',
        'scnE': '\u2AB6',
        'scnsim': '\u22E9',
        'scpolint': '\u2A13',
        'scsim': '\u227F',
        'scy': '\u0441',
        'Scy': '\u0421',
        'sdot': '\u22C5',
        'sdotb': '\u22A1',
        'sdote': '\u2A66',
        'searhk': '\u2925',
        'searr': '\u2198',
        'seArr': '\u21D8',
        'searrow': '\u2198',
        'sect': '\xA7',
        'semi': ';',
        'seswar': '\u2929',
        'setminus': '\u2216',
        'setmn': '\u2216',
        'sext': '\u2736',
        'sfr': '\uD835\uDD30',
        'Sfr': '\uD835\uDD16',
        'sfrown': '\u2322',
        'sharp': '\u266F',
        'shchcy': '\u0449',
        'SHCHcy': '\u0429',
        'shcy': '\u0448',
        'SHcy': '\u0428',
        'ShortDownArrow': '\u2193',
        'ShortLeftArrow': '\u2190',
        'shortmid': '\u2223',
        'shortparallel': '\u2225',
        'ShortRightArrow': '\u2192',
        'ShortUpArrow': '\u2191',
        'shy': '\xAD',
        'sigma': '\u03C3',
        'Sigma': '\u03A3',
        'sigmaf': '\u03C2',
        'sigmav': '\u03C2',
        'sim': '\u223C',
        'simdot': '\u2A6A',
        'sime': '\u2243',
        'simeq': '\u2243',
        'simg': '\u2A9E',
        'simgE': '\u2AA0',
        'siml': '\u2A9D',
        'simlE': '\u2A9F',
        'simne': '\u2246',
        'simplus': '\u2A24',
        'simrarr': '\u2972',
        'slarr': '\u2190',
        'SmallCircle': '\u2218',
        'smallsetminus': '\u2216',
        'smashp': '\u2A33',
        'smeparsl': '\u29E4',
        'smid': '\u2223',
        'smile': '\u2323',
        'smt': '\u2AAA',
        'smte': '\u2AAC',
        'smtes': '\u2AAC\uFE00',
        'softcy': '\u044C',
        'SOFTcy': '\u042C',
        'sol': '/',
        'solb': '\u29C4',
        'solbar': '\u233F',
        'sopf': '\uD835\uDD64',
        'Sopf': '\uD835\uDD4A',
        'spades': '\u2660',
        'spadesuit': '\u2660',
        'spar': '\u2225',
        'sqcap': '\u2293',
        'sqcaps': '\u2293\uFE00',
        'sqcup': '\u2294',
        'sqcups': '\u2294\uFE00',
        'Sqrt': '\u221A',
        'sqsub': '\u228F',
        'sqsube': '\u2291',
        'sqsubset': '\u228F',
        'sqsubseteq': '\u2291',
        'sqsup': '\u2290',
        'sqsupe': '\u2292',
        'sqsupset': '\u2290',
        'sqsupseteq': '\u2292',
        'squ': '\u25A1',
        'square': '\u25A1',
        'Square': '\u25A1',
        'SquareIntersection': '\u2293',
        'SquareSubset': '\u228F',
        'SquareSubsetEqual': '\u2291',
        'SquareSuperset': '\u2290',
        'SquareSupersetEqual': '\u2292',
        'SquareUnion': '\u2294',
        'squarf': '\u25AA',
        'squf': '\u25AA',
        'srarr': '\u2192',
        'sscr': '\uD835\uDCC8',
        'Sscr': '\uD835\uDCAE',
        'ssetmn': '\u2216',
        'ssmile': '\u2323',
        'sstarf': '\u22C6',
        'star': '\u2606',
        'Star': '\u22C6',
        'starf': '\u2605',
        'straightepsilon': '\u03F5',
        'straightphi': '\u03D5',
        'strns': '\xAF',
        'sub': '\u2282',
        'Sub': '\u22D0',
        'subdot': '\u2ABD',
        'sube': '\u2286',
        'subE': '\u2AC5',
        'subedot': '\u2AC3',
        'submult': '\u2AC1',
        'subne': '\u228A',
        'subnE': '\u2ACB',
        'subplus': '\u2ABF',
        'subrarr': '\u2979',
        'subset': '\u2282',
        'Subset': '\u22D0',
        'subseteq': '\u2286',
        'subseteqq': '\u2AC5',
        'SubsetEqual': '\u2286',
        'subsetneq': '\u228A',
        'subsetneqq': '\u2ACB',
        'subsim': '\u2AC7',
        'subsub': '\u2AD5',
        'subsup': '\u2AD3',
        'succ': '\u227B',
        'succapprox': '\u2AB8',
        'succcurlyeq': '\u227D',
        'Succeeds': '\u227B',
        'SucceedsEqual': '\u2AB0',
        'SucceedsSlantEqual': '\u227D',
        'SucceedsTilde': '\u227F',
        'succeq': '\u2AB0',
        'succnapprox': '\u2ABA',
        'succneqq': '\u2AB6',
        'succnsim': '\u22E9',
        'succsim': '\u227F',
        'SuchThat': '\u220B',
        'sum': '\u2211',
        'Sum': '\u2211',
        'sung': '\u266A',
        'sup': '\u2283',
        'Sup': '\u22D1',
        'sup1': '\xB9',
        'sup2': '\xB2',
        'sup3': '\xB3',
        'supdot': '\u2ABE',
        'supdsub': '\u2AD8',
        'supe': '\u2287',
        'supE': '\u2AC6',
        'supedot': '\u2AC4',
        'Superset': '\u2283',
        'SupersetEqual': '\u2287',
        'suphsol': '\u27C9',
        'suphsub': '\u2AD7',
        'suplarr': '\u297B',
        'supmult': '\u2AC2',
        'supne': '\u228B',
        'supnE': '\u2ACC',
        'supplus': '\u2AC0',
        'supset': '\u2283',
        'Supset': '\u22D1',
        'supseteq': '\u2287',
        'supseteqq': '\u2AC6',
        'supsetneq': '\u228B',
        'supsetneqq': '\u2ACC',
        'supsim': '\u2AC8',
        'supsub': '\u2AD4',
        'supsup': '\u2AD6',
        'swarhk': '\u2926',
        'swarr': '\u2199',
        'swArr': '\u21D9',
        'swarrow': '\u2199',
        'swnwar': '\u292A',
        'szlig': '\xDF',
        'Tab': '\t',
        'target': '\u2316',
        'tau': '\u03C4',
        'Tau': '\u03A4',
        'tbrk': '\u23B4',
        'tcaron': '\u0165',
        'Tcaron': '\u0164',
        'tcedil': '\u0163',
        'Tcedil': '\u0162',
        'tcy': '\u0442',
        'Tcy': '\u0422',
        'tdot': '\u20DB',
        'telrec': '\u2315',
        'tfr': '\uD835\uDD31',
        'Tfr': '\uD835\uDD17',
        'there4': '\u2234',
        'therefore': '\u2234',
        'Therefore': '\u2234',
        'theta': '\u03B8',
        'Theta': '\u0398',
        'thetasym': '\u03D1',
        'thetav': '\u03D1',
        'thickapprox': '\u2248',
        'thicksim': '\u223C',
        'ThickSpace': '\u205F\u200A',
        'thinsp': '\u2009',
        'ThinSpace': '\u2009',
        'thkap': '\u2248',
        'thksim': '\u223C',
        'thorn': '\xFE',
        'THORN': '\xDE',
        'tilde': '\u02DC',
        'Tilde': '\u223C',
        'TildeEqual': '\u2243',
        'TildeFullEqual': '\u2245',
        'TildeTilde': '\u2248',
        'times': '\xD7',
        'timesb': '\u22A0',
        'timesbar': '\u2A31',
        'timesd': '\u2A30',
        'tint': '\u222D',
        'toea': '\u2928',
        'top': '\u22A4',
        'topbot': '\u2336',
        'topcir': '\u2AF1',
        'topf': '\uD835\uDD65',
        'Topf': '\uD835\uDD4B',
        'topfork': '\u2ADA',
        'tosa': '\u2929',
        'tprime': '\u2034',
        'trade': '\u2122',
        'TRADE': '\u2122',
        'triangle': '\u25B5',
        'triangledown': '\u25BF',
        'triangleleft': '\u25C3',
        'trianglelefteq': '\u22B4',
        'triangleq': '\u225C',
        'triangleright': '\u25B9',
        'trianglerighteq': '\u22B5',
        'tridot': '\u25EC',
        'trie': '\u225C',
        'triminus': '\u2A3A',
        'TripleDot': '\u20DB',
        'triplus': '\u2A39',
        'trisb': '\u29CD',
        'tritime': '\u2A3B',
        'trpezium': '\u23E2',
        'tscr': '\uD835\uDCC9',
        'Tscr': '\uD835\uDCAF',
        'tscy': '\u0446',
        'TScy': '\u0426',
        'tshcy': '\u045B',
        'TSHcy': '\u040B',
        'tstrok': '\u0167',
        'Tstrok': '\u0166',
        'twixt': '\u226C',
        'twoheadleftarrow': '\u219E',
        'twoheadrightarrow': '\u21A0',
        'uacute': '\xFA',
        'Uacute': '\xDA',
        'uarr': '\u2191',
        'uArr': '\u21D1',
        'Uarr': '\u219F',
        'Uarrocir': '\u2949',
        'ubrcy': '\u045E',
        'Ubrcy': '\u040E',
        'ubreve': '\u016D',
        'Ubreve': '\u016C',
        'ucirc': '\xFB',
        'Ucirc': '\xDB',
        'ucy': '\u0443',
        'Ucy': '\u0423',
        'udarr': '\u21C5',
        'udblac': '\u0171',
        'Udblac': '\u0170',
        'udhar': '\u296E',
        'ufisht': '\u297E',
        'ufr': '\uD835\uDD32',
        'Ufr': '\uD835\uDD18',
        'ugrave': '\xF9',
        'Ugrave': '\xD9',
        'uHar': '\u2963',
        'uharl': '\u21BF',
        'uharr': '\u21BE',
        'uhblk': '\u2580',
        'ulcorn': '\u231C',
        'ulcorner': '\u231C',
        'ulcrop': '\u230F',
        'ultri': '\u25F8',
        'umacr': '\u016B',
        'Umacr': '\u016A',
        'uml': '\xA8',
        'UnderBar': '_',
        'UnderBrace': '\u23DF',
        'UnderBracket': '\u23B5',
        'UnderParenthesis': '\u23DD',
        'Union': '\u22C3',
        'UnionPlus': '\u228E',
        'uogon': '\u0173',
        'Uogon': '\u0172',
        'uopf': '\uD835\uDD66',
        'Uopf': '\uD835\uDD4C',
        'uparrow': '\u2191',
        'Uparrow': '\u21D1',
        'UpArrow': '\u2191',
        'UpArrowBar': '\u2912',
        'UpArrowDownArrow': '\u21C5',
        'updownarrow': '\u2195',
        'Updownarrow': '\u21D5',
        'UpDownArrow': '\u2195',
        'UpEquilibrium': '\u296E',
        'upharpoonleft': '\u21BF',
        'upharpoonright': '\u21BE',
        'uplus': '\u228E',
        'UpperLeftArrow': '\u2196',
        'UpperRightArrow': '\u2197',
        'upsi': '\u03C5',
        'Upsi': '\u03D2',
        'upsih': '\u03D2',
        'upsilon': '\u03C5',
        'Upsilon': '\u03A5',
        'UpTee': '\u22A5',
        'UpTeeArrow': '\u21A5',
        'upuparrows': '\u21C8',
        'urcorn': '\u231D',
        'urcorner': '\u231D',
        'urcrop': '\u230E',
        'uring': '\u016F',
        'Uring': '\u016E',
        'urtri': '\u25F9',
        'uscr': '\uD835\uDCCA',
        'Uscr': '\uD835\uDCB0',
        'utdot': '\u22F0',
        'utilde': '\u0169',
        'Utilde': '\u0168',
        'utri': '\u25B5',
        'utrif': '\u25B4',
        'uuarr': '\u21C8',
        'uuml': '\xFC',
        'Uuml': '\xDC',
        'uwangle': '\u29A7',
        'vangrt': '\u299C',
        'varepsilon': '\u03F5',
        'varkappa': '\u03F0',
        'varnothing': '\u2205',
        'varphi': '\u03D5',
        'varpi': '\u03D6',
        'varpropto': '\u221D',
        'varr': '\u2195',
        'vArr': '\u21D5',
        'varrho': '\u03F1',
        'varsigma': '\u03C2',
        'varsubsetneq': '\u228A\uFE00',
        'varsubsetneqq': '\u2ACB\uFE00',
        'varsupsetneq': '\u228B\uFE00',
        'varsupsetneqq': '\u2ACC\uFE00',
        'vartheta': '\u03D1',
        'vartriangleleft': '\u22B2',
        'vartriangleright': '\u22B3',
        'vBar': '\u2AE8',
        'Vbar': '\u2AEB',
        'vBarv': '\u2AE9',
        'vcy': '\u0432',
        'Vcy': '\u0412',
        'vdash': '\u22A2',
        'vDash': '\u22A8',
        'Vdash': '\u22A9',
        'VDash': '\u22AB',
        'Vdashl': '\u2AE6',
        'vee': '\u2228',
        'Vee': '\u22C1',
        'veebar': '\u22BB',
        'veeeq': '\u225A',
        'vellip': '\u22EE',
        'verbar': '|',
        'Verbar': '\u2016',
        'vert': '|',
        'Vert': '\u2016',
        'VerticalBar': '\u2223',
        'VerticalLine': '|',
        'VerticalSeparator': '\u2758',
        'VerticalTilde': '\u2240',
        'VeryThinSpace': '\u200A',
        'vfr': '\uD835\uDD33',
        'Vfr': '\uD835\uDD19',
        'vltri': '\u22B2',
        'vnsub': '\u2282\u20D2',
        'vnsup': '\u2283\u20D2',
        'vopf': '\uD835\uDD67',
        'Vopf': '\uD835\uDD4D',
        'vprop': '\u221D',
        'vrtri': '\u22B3',
        'vscr': '\uD835\uDCCB',
        'Vscr': '\uD835\uDCB1',
        'vsubne': '\u228A\uFE00',
        'vsubnE': '\u2ACB\uFE00',
        'vsupne': '\u228B\uFE00',
        'vsupnE': '\u2ACC\uFE00',
        'Vvdash': '\u22AA',
        'vzigzag': '\u299A',
        'wcirc': '\u0175',
        'Wcirc': '\u0174',
        'wedbar': '\u2A5F',
        'wedge': '\u2227',
        'Wedge': '\u22C0',
        'wedgeq': '\u2259',
        'weierp': '\u2118',
        'wfr': '\uD835\uDD34',
        'Wfr': '\uD835\uDD1A',
        'wopf': '\uD835\uDD68',
        'Wopf': '\uD835\uDD4E',
        'wp': '\u2118',
        'wr': '\u2240',
        'wreath': '\u2240',
        'wscr': '\uD835\uDCCC',
        'Wscr': '\uD835\uDCB2',
        'xcap': '\u22C2',
        'xcirc': '\u25EF',
        'xcup': '\u22C3',
        'xdtri': '\u25BD',
        'xfr': '\uD835\uDD35',
        'Xfr': '\uD835\uDD1B',
        'xharr': '\u27F7',
        'xhArr': '\u27FA',
        'xi': '\u03BE',
        'Xi': '\u039E',
        'xlarr': '\u27F5',
        'xlArr': '\u27F8',
        'xmap': '\u27FC',
        'xnis': '\u22FB',
        'xodot': '\u2A00',
        'xopf': '\uD835\uDD69',
        'Xopf': '\uD835\uDD4F',
        'xoplus': '\u2A01',
        'xotime': '\u2A02',
        'xrarr': '\u27F6',
        'xrArr': '\u27F9',
        'xscr': '\uD835\uDCCD',
        'Xscr': '\uD835\uDCB3',
        'xsqcup': '\u2A06',
        'xuplus': '\u2A04',
        'xutri': '\u25B3',
        'xvee': '\u22C1',
        'xwedge': '\u22C0',
        'yacute': '\xFD',
        'Yacute': '\xDD',
        'yacy': '\u044F',
        'YAcy': '\u042F',
        'ycirc': '\u0177',
        'Ycirc': '\u0176',
        'ycy': '\u044B',
        'Ycy': '\u042B',
        'yen': '\xA5',
        'yfr': '\uD835\uDD36',
        'Yfr': '\uD835\uDD1C',
        'yicy': '\u0457',
        'YIcy': '\u0407',
        'yopf': '\uD835\uDD6A',
        'Yopf': '\uD835\uDD50',
        'yscr': '\uD835\uDCCE',
        'Yscr': '\uD835\uDCB4',
        'yucy': '\u044E',
        'YUcy': '\u042E',
        'yuml': '\xFF',
        'Yuml': '\u0178',
        'zacute': '\u017A',
        'Zacute': '\u0179',
        'zcaron': '\u017E',
        'Zcaron': '\u017D',
        'zcy': '\u0437',
        'Zcy': '\u0417',
        'zdot': '\u017C',
        'Zdot': '\u017B',
        'zeetrf': '\u2128',
        'ZeroWidthSpace': '\u200B',
        'zeta': '\u03B6',
        'Zeta': '\u0396',
        'zfr': '\uD835\uDD37',
        'Zfr': '\u2128',
        'zhcy': '\u0436',
        'ZHcy': '\u0416',
        'zigrarr': '\u21DD',
        'zopf': '\uD835\uDD6B',
        'Zopf': '\u2124',
        'zscr': '\uD835\uDCCF',
        'Zscr': '\uD835\uDCB5',
        'zwj': '\u200D',
        'zwnj': '\u200C'
    };
    var decodeMapLegacy = {
        'aacute': '\xE1',
        'Aacute': '\xC1',
        'acirc': '\xE2',
        'Acirc': '\xC2',
        'acute': '\xB4',
        'aelig': '\xE6',
        'AElig': '\xC6',
        'agrave': '\xE0',
        'Agrave': '\xC0',
        'amp': '&',
        'AMP': '&',
        'aring': '\xE5',
        'Aring': '\xC5',
        'atilde': '\xE3',
        'Atilde': '\xC3',
        'auml': '\xE4',
        'Auml': '\xC4',
        'brvbar': '\xA6',
        'ccedil': '\xE7',
        'Ccedil': '\xC7',
        'cedil': '\xB8',
        'cent': '\xA2',
        'copy': '\xA9',
        'COPY': '\xA9',
        'curren': '\xA4',
        'deg': '\xB0',
        'divide': '\xF7',
        'eacute': '\xE9',
        'Eacute': '\xC9',
        'ecirc': '\xEA',
        'Ecirc': '\xCA',
        'egrave': '\xE8',
        'Egrave': '\xC8',
        'eth': '\xF0',
        'ETH': '\xD0',
        'euml': '\xEB',
        'Euml': '\xCB',
        'frac12': '\xBD',
        'frac14': '\xBC',
        'frac34': '\xBE',
        'gt': '>',
        'GT': '>',
        'iacute': '\xED',
        'Iacute': '\xCD',
        'icirc': '\xEE',
        'Icirc': '\xCE',
        'iexcl': '\xA1',
        'igrave': '\xEC',
        'Igrave': '\xCC',
        'iquest': '\xBF',
        'iuml': '\xEF',
        'Iuml': '\xCF',
        'laquo': '\xAB',
        'lt': '<',
        'LT': '<',
        'macr': '\xAF',
        'micro': '\xB5',
        'middot': '\xB7',
        'nbsp': '\xA0',
        'not': '\xAC',
        'ntilde': '\xF1',
        'Ntilde': '\xD1',
        'oacute': '\xF3',
        'Oacute': '\xD3',
        'ocirc': '\xF4',
        'Ocirc': '\xD4',
        'ograve': '\xF2',
        'Ograve': '\xD2',
        'ordf': '\xAA',
        'ordm': '\xBA',
        'oslash': '\xF8',
        'Oslash': '\xD8',
        'otilde': '\xF5',
        'Otilde': '\xD5',
        'ouml': '\xF6',
        'Ouml': '\xD6',
        'para': '\xB6',
        'plusmn': '\xB1',
        'pound': '\xA3',
        'quot': '"',
        'QUOT': '"',
        'raquo': '\xBB',
        'reg': '\xAE',
        'REG': '\xAE',
        'sect': '\xA7',
        'shy': '\xAD',
        'sup1': '\xB9',
        'sup2': '\xB2',
        'sup3': '\xB3',
        'szlig': '\xDF',
        'thorn': '\xFE',
        'THORN': '\xDE',
        'times': '\xD7',
        'uacute': '\xFA',
        'Uacute': '\xDA',
        'ucirc': '\xFB',
        'Ucirc': '\xDB',
        'ugrave': '\xF9',
        'Ugrave': '\xD9',
        'uml': '\xA8',
        'uuml': '\xFC',
        'Uuml': '\xDC',
        'yacute': '\xFD',
        'Yacute': '\xDD',
        'yen': '\xA5',
        'yuml': '\xFF'
    };
    var decodeMapNumeric = {
        '0': '\uFFFD',
        '128': '\u20AC',
        '130': '\u201A',
        '131': '\u0192',
        '132': '\u201E',
        '133': '\u2026',
        '134': '\u2020',
        '135': '\u2021',
        '136': '\u02C6',
        '137': '\u2030',
        '138': '\u0160',
        '139': '\u2039',
        '140': '\u0152',
        '142': '\u017D',
        '145': '\u2018',
        '146': '\u2019',
        '147': '\u201C',
        '148': '\u201D',
        '149': '\u2022',
        '150': '\u2013',
        '151': '\u2014',
        '152': '\u02DC',
        '153': '\u2122',
        '154': '\u0161',
        '155': '\u203A',
        '156': '\u0153',
        '158': '\u017E',
        '159': '\u0178'
    };
    var invalidReferenceCodePoints = [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        11,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        127,
        128,
        129,
        130,
        131,
        132,
        133,
        134,
        135,
        136,
        137,
        138,
        139,
        140,
        141,
        142,
        143,
        144,
        145,
        146,
        147,
        148,
        149,
        150,
        151,
        152,
        153,
        154,
        155,
        156,
        157,
        158,
        159,
        64976,
        64977,
        64978,
        64979,
        64980,
        64981,
        64982,
        64983,
        64984,
        64985,
        64986,
        64987,
        64988,
        64989,
        64990,
        64991,
        64992,
        64993,
        64994,
        64995,
        64996,
        64997,
        64998,
        64999,
        65000,
        65001,
        65002,
        65003,
        65004,
        65005,
        65006,
        65007,
        65534,
        65535,
        131070,
        131071,
        196606,
        196607,
        262142,
        262143,
        327678,
        327679,
        393214,
        393215,
        458750,
        458751,
        524286,
        524287,
        589822,
        589823,
        655358,
        655359,
        720894,
        720895,
        786430,
        786431,
        851966,
        851967,
        917502,
        917503,
        983038,
        983039,
        1048574,
        1048575,
        1114110,
        1114111
    ];
    /*--------------------------------------------------------------------------*/ var stringFromCharCode = String.fromCharCode;
    var object = {};
    var hasOwnProperty = object.hasOwnProperty;
    var has = function(object, propertyName) {
        return hasOwnProperty.call(object, propertyName);
    };
    var contains = function(array, value) {
        var index = -1;
        var length = array.length;
        while(++index < length){
            if (array[index] == value) return true;
        }
        return false;
    };
    var merge = function(options, defaults) {
        if (!options) return defaults;
        var result = {};
        var key;
        for(key in defaults)// A `hasOwnProperty` check is not needed here, since only recognized
        // option names are used anyway. Any others are ignored.
        result[key] = has(options, key) ? options[key] : defaults[key];
        return result;
    };
    // Modified version of `ucs2encode`; see https://mths.be/punycode.
    var codePointToSymbol = function(codePoint, strict) {
        var output = '';
        if (codePoint >= 0xD800 && codePoint <= 0xDFFF || codePoint > 0x10FFFF) {
            // See issue #4:
            // “Otherwise, if the number is in the range 0xD800 to 0xDFFF or is
            // greater than 0x10FFFF, then this is a parse error. Return a U+FFFD
            // REPLACEMENT CHARACTER.”
            if (strict) parseError('character reference outside the permissible Unicode range');
            return '\uFFFD';
        }
        if (has(decodeMapNumeric, codePoint)) {
            if (strict) parseError('disallowed character reference');
            return decodeMapNumeric[codePoint];
        }
        if (strict && contains(invalidReferenceCodePoints, codePoint)) parseError('disallowed character reference');
        if (codePoint > 0xFFFF) {
            codePoint -= 0x10000;
            output += stringFromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        output += stringFromCharCode(codePoint);
        return output;
    };
    var hexEscape = function(codePoint) {
        return '&#x' + codePoint.toString(16).toUpperCase() + ';';
    };
    var decEscape = function(codePoint) {
        return '&#' + codePoint + ';';
    };
    var parseError = function(message) {
        throw Error('Parse error: ' + message);
    };
    /*--------------------------------------------------------------------------*/ var encode = function(string, options) {
        options = merge(options, encode.options);
        var strict = options.strict;
        if (strict && regexInvalidRawCodePoint.test(string)) parseError('forbidden code point');
        var encodeEverything = options.encodeEverything;
        var useNamedReferences = options.useNamedReferences;
        var allowUnsafeSymbols = options.allowUnsafeSymbols;
        var escapeCodePoint = options.decimal ? decEscape : hexEscape;
        var escapeBmpSymbol = function(symbol) {
            return escapeCodePoint(symbol.charCodeAt(0));
        };
        if (encodeEverything) {
            // Encode ASCII symbols.
            string = string.replace(regexAsciiWhitelist, function(symbol) {
                // Use named references if requested & possible.
                if (useNamedReferences && has(encodeMap, symbol)) return '&' + encodeMap[symbol] + ';';
                return escapeBmpSymbol(symbol);
            });
            // Shorten a few escapes that represent two symbols, of which at least one
            // is within the ASCII range.
            if (useNamedReferences) string = string.replace(/&gt;\u20D2/g, '&nvgt;').replace(/&lt;\u20D2/g, '&nvlt;').replace(/&#x66;&#x6A;/g, '&fjlig;');
            // Encode non-ASCII symbols.
            if (useNamedReferences) // Encode non-ASCII symbols that can be replaced with a named reference.
            string = string.replace(regexEncodeNonAscii, function(string) {
                // Note: there is no need to check `has(encodeMap, string)` here.
                return '&' + encodeMap[string] + ';';
            });
        // Note: any remaining non-ASCII symbols are handled outside of the `if`.
        } else if (useNamedReferences) {
            // Apply named character references.
            // Encode `<>"'&` using named character references.
            if (!allowUnsafeSymbols) string = string.replace(regexEscape, function(string) {
                return '&' + encodeMap[string] + ';'; // no need to check `has()` here
            });
            // Shorten escapes that represent two symbols, of which at least one is
            // `<>"'&`.
            string = string.replace(/&gt;\u20D2/g, '&nvgt;').replace(/&lt;\u20D2/g, '&nvlt;');
            // Encode non-ASCII symbols that can be replaced with a named reference.
            string = string.replace(regexEncodeNonAscii, function(string) {
                // Note: there is no need to check `has(encodeMap, string)` here.
                return '&' + encodeMap[string] + ';';
            });
        } else if (!allowUnsafeSymbols) // Encode `<>"'&` using hexadecimal escapes, now that they’re not handled
        // using named character references.
        string = string.replace(regexEscape, escapeBmpSymbol);
        return string// Encode astral symbols.
        .replace(regexAstralSymbols, function($0) {
            // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
            var high = $0.charCodeAt(0);
            var low = $0.charCodeAt(1);
            var codePoint = (high - 0xD800) * 0x400 + low - 0xDC00 + 0x10000;
            return escapeCodePoint(codePoint);
        })// Encode any remaining BMP symbols that are not printable ASCII symbols
        // using a hexadecimal escape.
        .replace(regexBmpWhitelist, escapeBmpSymbol);
    };
    // Expose default options (so they can be overridden globally).
    encode.options = {
        'allowUnsafeSymbols': false,
        'encodeEverything': false,
        'strict': false,
        'useNamedReferences': false,
        'decimal': false
    };
    var decode = function(html, options) {
        options = merge(options, decode.options);
        var strict = options.strict;
        if (strict && regexInvalidEntity.test(html)) parseError('malformed character reference');
        return html.replace(regexDecode, function($0, $1, $2, $3, $4, $5, $6, $7, $8) {
            var codePoint;
            var semicolon;
            var decDigits;
            var hexDigits;
            var reference;
            var next;
            if ($1) {
                reference = $1;
                // Note: there is no need to check `has(decodeMap, reference)`.
                return decodeMap[reference];
            }
            if ($2) {
                // Decode named character references without trailing `;`, e.g. `&amp`.
                // This is only a parse error if it gets converted to `&`, or if it is
                // followed by `=` in an attribute context.
                reference = $2;
                next = $3;
                if (next && options.isAttributeValue) {
                    if (strict && next == '=') parseError('`&` did not start a character reference');
                    return $0;
                } else {
                    if (strict) parseError('named character reference was not terminated by a semicolon');
                    // Note: there is no need to check `has(decodeMapLegacy, reference)`.
                    return decodeMapLegacy[reference] + (next || '');
                }
            }
            if ($4) {
                // Decode decimal escapes, e.g. `&#119558;`.
                decDigits = $4;
                semicolon = $5;
                if (strict && !semicolon) parseError('character reference was not terminated by a semicolon');
                codePoint = parseInt(decDigits, 10);
                return codePointToSymbol(codePoint, strict);
            }
            if ($6) {
                // Decode hexadecimal escapes, e.g. `&#x1D306;`.
                hexDigits = $6;
                semicolon = $7;
                if (strict && !semicolon) parseError('character reference was not terminated by a semicolon');
                codePoint = parseInt(hexDigits, 16);
                return codePointToSymbol(codePoint, strict);
            }
            // If we’re still here, `if ($7)` is implied; it’s an ambiguous
            // ampersand for sure. https://mths.be/notes/ambiguous-ampersands
            if (strict) parseError('named character reference was not terminated by a semicolon');
            return $0;
        });
    };
    // Expose default options (so they can be overridden globally).
    decode.options = {
        'isAttributeValue': false,
        'strict': false
    };
    var escape = function(string) {
        return string.replace(regexEscape, function($0) {
            // Note: there is no need to check `has(escapeMap, $0)` here.
            return escapeMap[$0];
        });
    };
    /*--------------------------------------------------------------------------*/ var he = {
        'version': '1.2.0',
        'encode': encode,
        'decode': decode,
        'escape': escape,
        'unescape': decode
    };
    // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) define(function() {
        return he;
    });
    else if (freeExports && !freeExports.nodeType) {
        if (freeModule) freeModule.exports = he;
        else for(var key in he)has(he, key) && (freeExports[key] = he[key]);
    } else root.he = he;
})(this);

});

parcelRegister("hlFxx", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $ca149ec9d20b8505$var$R = typeof Reflect === 'object' ? Reflect : null;
var $ca149ec9d20b8505$var$ReflectApply = $ca149ec9d20b8505$var$R && typeof $ca149ec9d20b8505$var$R.apply === 'function' ? $ca149ec9d20b8505$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $ca149ec9d20b8505$var$ReflectOwnKeys;
if ($ca149ec9d20b8505$var$R && typeof $ca149ec9d20b8505$var$R.ownKeys === 'function') $ca149ec9d20b8505$var$ReflectOwnKeys = $ca149ec9d20b8505$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $ca149ec9d20b8505$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $ca149ec9d20b8505$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $ca149ec9d20b8505$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $ca149ec9d20b8505$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $ca149ec9d20b8505$var$EventEmitter() {
    $ca149ec9d20b8505$var$EventEmitter.init.call(this);
}
module.exports = $ca149ec9d20b8505$var$EventEmitter;
module.exports.once = $ca149ec9d20b8505$var$once;
// Backwards-compat with node 0.10.x
$ca149ec9d20b8505$var$EventEmitter.EventEmitter = $ca149ec9d20b8505$var$EventEmitter;
$ca149ec9d20b8505$var$EventEmitter.prototype._events = undefined;
$ca149ec9d20b8505$var$EventEmitter.prototype._eventsCount = 0;
$ca149ec9d20b8505$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $ca149ec9d20b8505$var$defaultMaxListeners = 10;
function $ca149ec9d20b8505$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($ca149ec9d20b8505$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $ca149ec9d20b8505$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $ca149ec9d20b8505$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $ca149ec9d20b8505$var$defaultMaxListeners = arg;
    }
});
$ca149ec9d20b8505$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$ca149ec9d20b8505$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $ca149ec9d20b8505$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $ca149ec9d20b8505$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $ca149ec9d20b8505$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$ca149ec9d20b8505$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $ca149ec9d20b8505$var$_getMaxListeners(this);
};
$ca149ec9d20b8505$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $ca149ec9d20b8505$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $ca149ec9d20b8505$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$ca149ec9d20b8505$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $ca149ec9d20b8505$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $ca149ec9d20b8505$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $ca149ec9d20b8505$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $ca149ec9d20b8505$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$ca149ec9d20b8505$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $ca149ec9d20b8505$var$_addListener(this, type, listener, false);
};
$ca149ec9d20b8505$var$EventEmitter.prototype.on = $ca149ec9d20b8505$var$EventEmitter.prototype.addListener;
$ca149ec9d20b8505$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $ca149ec9d20b8505$var$_addListener(this, type, listener, true);
};
function $ca149ec9d20b8505$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $ca149ec9d20b8505$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $ca149ec9d20b8505$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$ca149ec9d20b8505$var$EventEmitter.prototype.once = function once(type, listener) {
    $ca149ec9d20b8505$var$checkListener(listener);
    this.on(type, $ca149ec9d20b8505$var$_onceWrap(this, type, listener));
    return this;
};
$ca149ec9d20b8505$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $ca149ec9d20b8505$var$checkListener(listener);
    this.prependListener(type, $ca149ec9d20b8505$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$ca149ec9d20b8505$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $ca149ec9d20b8505$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $ca149ec9d20b8505$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$ca149ec9d20b8505$var$EventEmitter.prototype.off = $ca149ec9d20b8505$var$EventEmitter.prototype.removeListener;
$ca149ec9d20b8505$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $ca149ec9d20b8505$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $ca149ec9d20b8505$var$unwrapListeners(evlistener) : $ca149ec9d20b8505$var$arrayClone(evlistener, evlistener.length);
}
$ca149ec9d20b8505$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $ca149ec9d20b8505$var$_listeners(this, type, true);
};
$ca149ec9d20b8505$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $ca149ec9d20b8505$var$_listeners(this, type, false);
};
$ca149ec9d20b8505$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $ca149ec9d20b8505$var$listenerCount.call(emitter, type);
};
$ca149ec9d20b8505$var$EventEmitter.prototype.listenerCount = $ca149ec9d20b8505$var$listenerCount;
function $ca149ec9d20b8505$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$ca149ec9d20b8505$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $ca149ec9d20b8505$var$ReflectOwnKeys(this._events) : [];
};
function $ca149ec9d20b8505$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $ca149ec9d20b8505$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $ca149ec9d20b8505$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $ca149ec9d20b8505$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $ca149ec9d20b8505$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $ca149ec9d20b8505$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $ca149ec9d20b8505$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $ca149ec9d20b8505$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $ca149ec9d20b8505$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("9rz1O", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $bebu9 = parcelRequire("bebu9");

var $h0MTa = parcelRequire("h0MTa");

var $jXzrP = parcelRequire("jXzrP");

var $4sKxE = parcelRequire("4sKxE");
function $6e01ce8f452e8cf9$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $6e01ce8f452e8cf9$var$BigIntSupported = typeof BigInt !== 'undefined';
var $6e01ce8f452e8cf9$var$SymbolSupported = typeof Symbol !== 'undefined';
var $6e01ce8f452e8cf9$var$ObjectToString = $6e01ce8f452e8cf9$var$uncurryThis(Object.prototype.toString);
var $6e01ce8f452e8cf9$var$numberValue = $6e01ce8f452e8cf9$var$uncurryThis(Number.prototype.valueOf);
var $6e01ce8f452e8cf9$var$stringValue = $6e01ce8f452e8cf9$var$uncurryThis(String.prototype.valueOf);
var $6e01ce8f452e8cf9$var$booleanValue = $6e01ce8f452e8cf9$var$uncurryThis(Boolean.prototype.valueOf);
if ($6e01ce8f452e8cf9$var$BigIntSupported) var $6e01ce8f452e8cf9$var$bigIntValue = $6e01ce8f452e8cf9$var$uncurryThis(BigInt.prototype.valueOf);
if ($6e01ce8f452e8cf9$var$SymbolSupported) var $6e01ce8f452e8cf9$var$symbolValue = $6e01ce8f452e8cf9$var$uncurryThis(Symbol.prototype.valueOf);
function $6e01ce8f452e8cf9$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $bebu9;
module.exports.isGeneratorFunction = $h0MTa;
module.exports.isTypedArray = $4sKxE;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $6e01ce8f452e8cf9$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $6e01ce8f452e8cf9$var$isPromise;
function $6e01ce8f452e8cf9$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $4sKxE(value) || $6e01ce8f452e8cf9$var$isDataView(value);
}
module.exports.isArrayBufferView = $6e01ce8f452e8cf9$var$isArrayBufferView;
function $6e01ce8f452e8cf9$var$isUint8Array(value) {
    return $jXzrP(value) === 'Uint8Array';
}
module.exports.isUint8Array = $6e01ce8f452e8cf9$var$isUint8Array;
function $6e01ce8f452e8cf9$var$isUint8ClampedArray(value) {
    return $jXzrP(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $6e01ce8f452e8cf9$var$isUint8ClampedArray;
function $6e01ce8f452e8cf9$var$isUint16Array(value) {
    return $jXzrP(value) === 'Uint16Array';
}
module.exports.isUint16Array = $6e01ce8f452e8cf9$var$isUint16Array;
function $6e01ce8f452e8cf9$var$isUint32Array(value) {
    return $jXzrP(value) === 'Uint32Array';
}
module.exports.isUint32Array = $6e01ce8f452e8cf9$var$isUint32Array;
function $6e01ce8f452e8cf9$var$isInt8Array(value) {
    return $jXzrP(value) === 'Int8Array';
}
module.exports.isInt8Array = $6e01ce8f452e8cf9$var$isInt8Array;
function $6e01ce8f452e8cf9$var$isInt16Array(value) {
    return $jXzrP(value) === 'Int16Array';
}
module.exports.isInt16Array = $6e01ce8f452e8cf9$var$isInt16Array;
function $6e01ce8f452e8cf9$var$isInt32Array(value) {
    return $jXzrP(value) === 'Int32Array';
}
module.exports.isInt32Array = $6e01ce8f452e8cf9$var$isInt32Array;
function $6e01ce8f452e8cf9$var$isFloat32Array(value) {
    return $jXzrP(value) === 'Float32Array';
}
module.exports.isFloat32Array = $6e01ce8f452e8cf9$var$isFloat32Array;
function $6e01ce8f452e8cf9$var$isFloat64Array(value) {
    return $jXzrP(value) === 'Float64Array';
}
module.exports.isFloat64Array = $6e01ce8f452e8cf9$var$isFloat64Array;
function $6e01ce8f452e8cf9$var$isBigInt64Array(value) {
    return $jXzrP(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $6e01ce8f452e8cf9$var$isBigInt64Array;
function $6e01ce8f452e8cf9$var$isBigUint64Array(value) {
    return $jXzrP(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $6e01ce8f452e8cf9$var$isBigUint64Array;
function $6e01ce8f452e8cf9$var$isMapToString(value) {
    return $6e01ce8f452e8cf9$var$ObjectToString(value) === '[object Map]';
}
$6e01ce8f452e8cf9$var$isMapToString.working = typeof Map !== 'undefined' && $6e01ce8f452e8cf9$var$isMapToString(new Map());
function $6e01ce8f452e8cf9$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $6e01ce8f452e8cf9$var$isMapToString.working ? $6e01ce8f452e8cf9$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $6e01ce8f452e8cf9$var$isMap;
function $6e01ce8f452e8cf9$var$isSetToString(value) {
    return $6e01ce8f452e8cf9$var$ObjectToString(value) === '[object Set]';
}
$6e01ce8f452e8cf9$var$isSetToString.working = typeof Set !== 'undefined' && $6e01ce8f452e8cf9$var$isSetToString(new Set());
function $6e01ce8f452e8cf9$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $6e01ce8f452e8cf9$var$isSetToString.working ? $6e01ce8f452e8cf9$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $6e01ce8f452e8cf9$var$isSet;
function $6e01ce8f452e8cf9$var$isWeakMapToString(value) {
    return $6e01ce8f452e8cf9$var$ObjectToString(value) === '[object WeakMap]';
}
$6e01ce8f452e8cf9$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $6e01ce8f452e8cf9$var$isWeakMapToString(new WeakMap());
function $6e01ce8f452e8cf9$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $6e01ce8f452e8cf9$var$isWeakMapToString.working ? $6e01ce8f452e8cf9$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $6e01ce8f452e8cf9$var$isWeakMap;
function $6e01ce8f452e8cf9$var$isWeakSetToString(value) {
    return $6e01ce8f452e8cf9$var$ObjectToString(value) === '[object WeakSet]';
}
$6e01ce8f452e8cf9$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $6e01ce8f452e8cf9$var$isWeakSetToString(new WeakSet());
function $6e01ce8f452e8cf9$var$isWeakSet(value) {
    return $6e01ce8f452e8cf9$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $6e01ce8f452e8cf9$var$isWeakSet;
function $6e01ce8f452e8cf9$var$isArrayBufferToString(value) {
    return $6e01ce8f452e8cf9$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$6e01ce8f452e8cf9$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $6e01ce8f452e8cf9$var$isArrayBufferToString(new ArrayBuffer());
function $6e01ce8f452e8cf9$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $6e01ce8f452e8cf9$var$isArrayBufferToString.working ? $6e01ce8f452e8cf9$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $6e01ce8f452e8cf9$var$isArrayBuffer;
function $6e01ce8f452e8cf9$var$isDataViewToString(value) {
    return $6e01ce8f452e8cf9$var$ObjectToString(value) === '[object DataView]';
}
$6e01ce8f452e8cf9$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $6e01ce8f452e8cf9$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $6e01ce8f452e8cf9$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $6e01ce8f452e8cf9$var$isDataViewToString.working ? $6e01ce8f452e8cf9$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $6e01ce8f452e8cf9$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $6e01ce8f452e8cf9$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $6e01ce8f452e8cf9$var$isSharedArrayBufferToString(value) {
    return $6e01ce8f452e8cf9$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $6e01ce8f452e8cf9$var$isSharedArrayBuffer(value) {
    if (typeof $6e01ce8f452e8cf9$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $6e01ce8f452e8cf9$var$isSharedArrayBufferToString.working === 'undefined') $6e01ce8f452e8cf9$var$isSharedArrayBufferToString.working = $6e01ce8f452e8cf9$var$isSharedArrayBufferToString(new $6e01ce8f452e8cf9$var$SharedArrayBufferCopy());
    return $6e01ce8f452e8cf9$var$isSharedArrayBufferToString.working ? $6e01ce8f452e8cf9$var$isSharedArrayBufferToString(value) : value instanceof $6e01ce8f452e8cf9$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $6e01ce8f452e8cf9$var$isSharedArrayBuffer;
function $6e01ce8f452e8cf9$var$isAsyncFunction(value) {
    return $6e01ce8f452e8cf9$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $6e01ce8f452e8cf9$var$isAsyncFunction;
function $6e01ce8f452e8cf9$var$isMapIterator(value) {
    return $6e01ce8f452e8cf9$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $6e01ce8f452e8cf9$var$isMapIterator;
function $6e01ce8f452e8cf9$var$isSetIterator(value) {
    return $6e01ce8f452e8cf9$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $6e01ce8f452e8cf9$var$isSetIterator;
function $6e01ce8f452e8cf9$var$isGeneratorObject(value) {
    return $6e01ce8f452e8cf9$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $6e01ce8f452e8cf9$var$isGeneratorObject;
function $6e01ce8f452e8cf9$var$isWebAssemblyCompiledModule(value) {
    return $6e01ce8f452e8cf9$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $6e01ce8f452e8cf9$var$isWebAssemblyCompiledModule;
function $6e01ce8f452e8cf9$var$isNumberObject(value) {
    return $6e01ce8f452e8cf9$var$checkBoxedPrimitive(value, $6e01ce8f452e8cf9$var$numberValue);
}
module.exports.isNumberObject = $6e01ce8f452e8cf9$var$isNumberObject;
function $6e01ce8f452e8cf9$var$isStringObject(value) {
    return $6e01ce8f452e8cf9$var$checkBoxedPrimitive(value, $6e01ce8f452e8cf9$var$stringValue);
}
module.exports.isStringObject = $6e01ce8f452e8cf9$var$isStringObject;
function $6e01ce8f452e8cf9$var$isBooleanObject(value) {
    return $6e01ce8f452e8cf9$var$checkBoxedPrimitive(value, $6e01ce8f452e8cf9$var$booleanValue);
}
module.exports.isBooleanObject = $6e01ce8f452e8cf9$var$isBooleanObject;
function $6e01ce8f452e8cf9$var$isBigIntObject(value) {
    return $6e01ce8f452e8cf9$var$BigIntSupported && $6e01ce8f452e8cf9$var$checkBoxedPrimitive(value, $6e01ce8f452e8cf9$var$bigIntValue);
}
module.exports.isBigIntObject = $6e01ce8f452e8cf9$var$isBigIntObject;
function $6e01ce8f452e8cf9$var$isSymbolObject(value) {
    return $6e01ce8f452e8cf9$var$SymbolSupported && $6e01ce8f452e8cf9$var$checkBoxedPrimitive(value, $6e01ce8f452e8cf9$var$symbolValue);
}
module.exports.isSymbolObject = $6e01ce8f452e8cf9$var$isSymbolObject;
function $6e01ce8f452e8cf9$var$isBoxedPrimitive(value) {
    return $6e01ce8f452e8cf9$var$isNumberObject(value) || $6e01ce8f452e8cf9$var$isStringObject(value) || $6e01ce8f452e8cf9$var$isBooleanObject(value) || $6e01ce8f452e8cf9$var$isBigIntObject(value) || $6e01ce8f452e8cf9$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $6e01ce8f452e8cf9$var$isBoxedPrimitive;
function $6e01ce8f452e8cf9$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($6e01ce8f452e8cf9$var$isArrayBuffer(value) || $6e01ce8f452e8cf9$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $6e01ce8f452e8cf9$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});
parcelRegister("bebu9", function(module, exports) {
'use strict';

var $82c9e93ea99944e3$var$hasToStringTag = (parcelRequire("bnrBt"))();

var $f5egT = parcelRequire("f5egT");
var $82c9e93ea99944e3$var$$toString = $f5egT('Object.prototype.toString');
var $82c9e93ea99944e3$var$isStandardArguments = function isArguments(value) {
    if ($82c9e93ea99944e3$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $82c9e93ea99944e3$var$$toString(value) === '[object Arguments]';
};
var $82c9e93ea99944e3$var$isLegacyArguments = function isArguments(value) {
    if ($82c9e93ea99944e3$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $82c9e93ea99944e3$var$$toString(value) !== '[object Array]' && $82c9e93ea99944e3$var$$toString(value.callee) === '[object Function]';
};
var $82c9e93ea99944e3$var$supportsStandardArguments = function() {
    return $82c9e93ea99944e3$var$isStandardArguments(arguments);
}();
$82c9e93ea99944e3$var$isStandardArguments.isLegacyArguments = $82c9e93ea99944e3$var$isLegacyArguments; // for tests
module.exports = $82c9e93ea99944e3$var$supportsStandardArguments ? $82c9e93ea99944e3$var$isStandardArguments : $82c9e93ea99944e3$var$isLegacyArguments;

});
parcelRegister("bnrBt", function(module, exports) {
'use strict';

var $2m7yB = parcelRequire("2m7yB");
module.exports = function hasToStringTagShams() {
    return $2m7yB() && !!Symbol.toStringTag;
};

});
parcelRegister("2m7yB", function(module, exports) {
'use strict';
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("f5egT", function(module, exports) {
'use strict';

var $eUYVQ = parcelRequire("eUYVQ");

var $gbBT6 = parcelRequire("gbBT6");
var $afb264ad80347196$var$$indexOf = $gbBT6($eUYVQ('String.prototype.indexOf'));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $eUYVQ(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $afb264ad80347196$var$$indexOf(name, '.prototype.') > -1) return $gbBT6(intrinsic);
    return intrinsic;
};

});
parcelRegister("eUYVQ", function(module, exports) {
'use strict';
var $adc58f789b6dd6e0$var$undefined1;
var $adc58f789b6dd6e0$var$$SyntaxError = SyntaxError;
var $adc58f789b6dd6e0$var$$Function = Function;
var $adc58f789b6dd6e0$var$$TypeError = TypeError;
// eslint-disable-next-line consistent-return
var $adc58f789b6dd6e0$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $adc58f789b6dd6e0$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};
var $adc58f789b6dd6e0$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($adc58f789b6dd6e0$var$$gOPD) try {
    $adc58f789b6dd6e0$var$$gOPD({}, '');
} catch (e) {
    $adc58f789b6dd6e0$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $adc58f789b6dd6e0$var$throwTypeError = function() {
    throw new $adc58f789b6dd6e0$var$$TypeError();
};
var $adc58f789b6dd6e0$var$ThrowTypeError = $adc58f789b6dd6e0$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $adc58f789b6dd6e0$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $adc58f789b6dd6e0$var$$gOPD(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $adc58f789b6dd6e0$var$throwTypeError;
        }
    }
}() : $adc58f789b6dd6e0$var$throwTypeError;

var $adc58f789b6dd6e0$var$hasSymbols = (parcelRequire("hLfix"))();
var $adc58f789b6dd6e0$var$getProto = Object.getPrototypeOf || function(x) {
    return x.__proto__;
}; // eslint-disable-line no-proto
var $adc58f789b6dd6e0$var$needsEval = {};
var $adc58f789b6dd6e0$var$TypedArray = typeof Uint8Array === 'undefined' ? undefined : $adc58f789b6dd6e0$var$getProto(Uint8Array);
var $adc58f789b6dd6e0$var$INTRINSICS = {
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $adc58f789b6dd6e0$var$hasSymbols ? $adc58f789b6dd6e0$var$getProto([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $adc58f789b6dd6e0$var$needsEval,
    '%AsyncGenerator%': $adc58f789b6dd6e0$var$needsEval,
    '%AsyncGeneratorFunction%': $adc58f789b6dd6e0$var$needsEval,
    '%AsyncIteratorPrototype%': $adc58f789b6dd6e0$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': Error,
    '%eval%': eval,
    '%EvalError%': EvalError,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $adc58f789b6dd6e0$var$$Function,
    '%GeneratorFunction%': $adc58f789b6dd6e0$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $adc58f789b6dd6e0$var$hasSymbols ? $adc58f789b6dd6e0$var$getProto($adc58f789b6dd6e0$var$getProto([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$adc58f789b6dd6e0$var$hasSymbols ? undefined : $adc58f789b6dd6e0$var$getProto(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': Object,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': RangeError,
    '%ReferenceError%': ReferenceError,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$adc58f789b6dd6e0$var$hasSymbols ? undefined : $adc58f789b6dd6e0$var$getProto(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $adc58f789b6dd6e0$var$hasSymbols ? $adc58f789b6dd6e0$var$getProto(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $adc58f789b6dd6e0$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $adc58f789b6dd6e0$var$$SyntaxError,
    '%ThrowTypeError%': $adc58f789b6dd6e0$var$ThrowTypeError,
    '%TypedArray%': $adc58f789b6dd6e0$var$TypedArray,
    '%TypeError%': $adc58f789b6dd6e0$var$$TypeError,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': URIError,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};
var $adc58f789b6dd6e0$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $adc58f789b6dd6e0$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $adc58f789b6dd6e0$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $adc58f789b6dd6e0$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen) value = $adc58f789b6dd6e0$var$getProto(gen.prototype);
    }
    $adc58f789b6dd6e0$var$INTRINSICS[name] = value;
    return value;
};
var $adc58f789b6dd6e0$var$LEGACY_ALIASES = {
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $1tVKm = parcelRequire("1tVKm");

var $7HQeL = parcelRequire("7HQeL");
var $adc58f789b6dd6e0$var$$concat = $1tVKm.call(Function.call, Array.prototype.concat);
var $adc58f789b6dd6e0$var$$spliceApply = $1tVKm.call(Function.apply, Array.prototype.splice);
var $adc58f789b6dd6e0$var$$replace = $1tVKm.call(Function.call, String.prototype.replace);
var $adc58f789b6dd6e0$var$$strSlice = $1tVKm.call(Function.call, String.prototype.slice);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $adc58f789b6dd6e0$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $adc58f789b6dd6e0$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $adc58f789b6dd6e0$var$stringToPath = function stringToPath(string) {
    var first = $adc58f789b6dd6e0$var$$strSlice(string, 0, 1);
    var last = $adc58f789b6dd6e0$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $adc58f789b6dd6e0$var$$SyntaxError('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $adc58f789b6dd6e0$var$$SyntaxError('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $adc58f789b6dd6e0$var$$replace(string, $adc58f789b6dd6e0$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $adc58f789b6dd6e0$var$$replace(subString, $adc58f789b6dd6e0$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $adc58f789b6dd6e0$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($7HQeL($adc58f789b6dd6e0$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $adc58f789b6dd6e0$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($7HQeL($adc58f789b6dd6e0$var$INTRINSICS, intrinsicName)) {
        var value = $adc58f789b6dd6e0$var$INTRINSICS[intrinsicName];
        if (value === $adc58f789b6dd6e0$var$needsEval) value = $adc58f789b6dd6e0$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $adc58f789b6dd6e0$var$$TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $adc58f789b6dd6e0$var$$SyntaxError('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $adc58f789b6dd6e0$var$$TypeError('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $adc58f789b6dd6e0$var$$TypeError('"allowMissing" argument must be a boolean');
    var parts = $adc58f789b6dd6e0$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $adc58f789b6dd6e0$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $adc58f789b6dd6e0$var$$spliceApply(parts, $adc58f789b6dd6e0$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $adc58f789b6dd6e0$var$$strSlice(part, 0, 1);
        var last = $adc58f789b6dd6e0$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $adc58f789b6dd6e0$var$$SyntaxError('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($7HQeL($adc58f789b6dd6e0$var$INTRINSICS, intrinsicRealName)) value = $adc58f789b6dd6e0$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $adc58f789b6dd6e0$var$$TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($adc58f789b6dd6e0$var$$gOPD && i + 1 >= parts.length) {
                var desc = $adc58f789b6dd6e0$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $7HQeL(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $adc58f789b6dd6e0$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("hLfix", function(module, exports) {
'use strict';
var $03563caa89040fce$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $2m7yB = parcelRequire("2m7yB");
module.exports = function hasNativeSymbols() {
    if (typeof $03563caa89040fce$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $03563caa89040fce$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $2m7yB();
};

});

parcelRegister("1tVKm", function(module, exports) {
'use strict';

var $dCtDG = parcelRequire("dCtDG");
module.exports = Function.prototype.bind || $dCtDG;

});
parcelRegister("dCtDG", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $9ea5d0a77e71f766$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $9ea5d0a77e71f766$var$slice = Array.prototype.slice;
var $9ea5d0a77e71f766$var$toStr = Object.prototype.toString;
var $9ea5d0a77e71f766$var$funcType = '[object Function]';
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $9ea5d0a77e71f766$var$toStr.call(target) !== $9ea5d0a77e71f766$var$funcType) throw new TypeError($9ea5d0a77e71f766$var$ERROR_MESSAGE + target);
    var args = $9ea5d0a77e71f766$var$slice.call(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, args.concat($9ea5d0a77e71f766$var$slice.call(arguments)));
            if (Object(result) === result) return result;
            return this;
        } else return target.apply(that, args.concat($9ea5d0a77e71f766$var$slice.call(arguments)));
    };
    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs.push('$' + i);
    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("7HQeL", function(module, exports) {
'use strict';

var $1tVKm = parcelRequire("1tVKm");
module.exports = $1tVKm.call(Function.call, Object.prototype.hasOwnProperty);

});


parcelRegister("gbBT6", function(module, exports) {
'use strict';

var $1tVKm = parcelRequire("1tVKm");

var $eUYVQ = parcelRequire("eUYVQ");
var $bc8b10212d5e8167$var$$apply = $eUYVQ('%Function.prototype.apply%');
var $bc8b10212d5e8167$var$$call = $eUYVQ('%Function.prototype.call%');
var $bc8b10212d5e8167$var$$reflectApply = $eUYVQ('%Reflect.apply%', true) || $1tVKm.call($bc8b10212d5e8167$var$$call, $bc8b10212d5e8167$var$$apply);
var $bc8b10212d5e8167$var$$gOPD = $eUYVQ('%Object.getOwnPropertyDescriptor%', true);
var $bc8b10212d5e8167$var$$defineProperty = $eUYVQ('%Object.defineProperty%', true);
var $bc8b10212d5e8167$var$$max = $eUYVQ('%Math.max%');
if ($bc8b10212d5e8167$var$$defineProperty) try {
    $bc8b10212d5e8167$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $bc8b10212d5e8167$var$$defineProperty = null;
}
module.exports = function callBind(originalFunction) {
    var func = $bc8b10212d5e8167$var$$reflectApply($1tVKm, $bc8b10212d5e8167$var$$call, arguments);
    if ($bc8b10212d5e8167$var$$gOPD && $bc8b10212d5e8167$var$$defineProperty) {
        var desc = $bc8b10212d5e8167$var$$gOPD(func, 'length');
        if (desc.configurable) // original length, plus the receiver, minus any additional arguments (after the receiver)
        $bc8b10212d5e8167$var$$defineProperty(func, 'length', {
            value: 1 + $bc8b10212d5e8167$var$$max(0, originalFunction.length - (arguments.length - 1))
        });
    }
    return func;
};
var $bc8b10212d5e8167$var$applyBind = function applyBind() {
    return $bc8b10212d5e8167$var$$reflectApply($1tVKm, $bc8b10212d5e8167$var$$apply, arguments);
};
if ($bc8b10212d5e8167$var$$defineProperty) $bc8b10212d5e8167$var$$defineProperty(module.exports, 'apply', {
    value: $bc8b10212d5e8167$var$applyBind
});
else module.exports.apply = $bc8b10212d5e8167$var$applyBind;

});



parcelRegister("h0MTa", function(module, exports) {
'use strict';
var $c6285c08346a3979$var$toStr = Object.prototype.toString;
var $c6285c08346a3979$var$fnToStr = Function.prototype.toString;
var $c6285c08346a3979$var$isFnRegex = /^\s*(?:function)?\*/;

var $c6285c08346a3979$var$hasToStringTag = (parcelRequire("47r5i"))();
var $c6285c08346a3979$var$getProto = Object.getPrototypeOf;
var $c6285c08346a3979$var$getGeneratorFunc = function() {
    if (!$c6285c08346a3979$var$hasToStringTag) return false;
    try {
        return Function('return function*() {}')();
    } catch (e) {}
};
var $c6285c08346a3979$var$GeneratorFunction;
module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($c6285c08346a3979$var$isFnRegex.test($c6285c08346a3979$var$fnToStr.call(fn))) return true;
    if (!$c6285c08346a3979$var$hasToStringTag) {
        var str = $c6285c08346a3979$var$toStr.call(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$c6285c08346a3979$var$getProto) return false;
    if (typeof $c6285c08346a3979$var$GeneratorFunction === 'undefined') {
        var generatorFunc = $c6285c08346a3979$var$getGeneratorFunc();
        $c6285c08346a3979$var$GeneratorFunction = generatorFunc ? $c6285c08346a3979$var$getProto(generatorFunc) : false;
    }
    return $c6285c08346a3979$var$getProto(fn) === $c6285c08346a3979$var$GeneratorFunction;
};

});
parcelRegister("47r5i", function(module, exports) {
'use strict';

var $2m7yB = parcelRequire("2m7yB");
module.exports = function hasToStringTagShams() {
    return $2m7yB() && !!Symbol.toStringTag;
};

});


parcelRegister("jXzrP", function(module, exports) {
'use strict';

var $9ikBS = parcelRequire("9ikBS");

var $9WfvB = parcelRequire("9WfvB");

var $f5egT = parcelRequire("f5egT");
var $e87f0636baf7e9d6$var$$toString = $f5egT('Object.prototype.toString');

var $e87f0636baf7e9d6$var$hasToStringTag = (parcelRequire("4u81E"))();
var $e87f0636baf7e9d6$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $e87f0636baf7e9d6$var$typedArrays = $9WfvB();
var $e87f0636baf7e9d6$var$$slice = $f5egT('String.prototype.slice');
var $e87f0636baf7e9d6$var$toStrTags = {};

var $lliYw = parcelRequire("lliYw");
var $e87f0636baf7e9d6$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
if ($e87f0636baf7e9d6$var$hasToStringTag && $lliYw && $e87f0636baf7e9d6$var$getPrototypeOf) $9ikBS($e87f0636baf7e9d6$var$typedArrays, function(typedArray) {
    if (typeof $e87f0636baf7e9d6$var$g[typedArray] === 'function') {
        var arr = new $e87f0636baf7e9d6$var$g[typedArray]();
        if (Symbol.toStringTag in arr) {
            var proto = $e87f0636baf7e9d6$var$getPrototypeOf(arr);
            var descriptor = $lliYw(proto, Symbol.toStringTag);
            if (!descriptor) {
                var superProto = $e87f0636baf7e9d6$var$getPrototypeOf(proto);
                descriptor = $lliYw(superProto, Symbol.toStringTag);
            }
            $e87f0636baf7e9d6$var$toStrTags[typedArray] = descriptor.get;
        }
    }
});
var $e87f0636baf7e9d6$var$tryTypedArrays = function tryAllTypedArrays(value) {
    var foundName = false;
    $9ikBS($e87f0636baf7e9d6$var$toStrTags, function(getter, typedArray) {
        if (!foundName) try {
            var name = getter.call(value);
            if (name === typedArray) foundName = name;
        } catch (e) {}
    });
    return foundName;
};

var $4sKxE = parcelRequire("4sKxE");
module.exports = function whichTypedArray(value) {
    if (!$4sKxE(value)) return false;
    if (!$e87f0636baf7e9d6$var$hasToStringTag || !(Symbol.toStringTag in value)) return $e87f0636baf7e9d6$var$$slice($e87f0636baf7e9d6$var$$toString(value), 8, -1);
    return $e87f0636baf7e9d6$var$tryTypedArrays(value);
};

});
parcelRegister("9ikBS", function(module, exports) {
'use strict';

var $b0wEC = parcelRequire("b0wEC");
var $6c45c82f0c4046ab$var$toStr = Object.prototype.toString;
var $6c45c82f0c4046ab$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $6c45c82f0c4046ab$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($6c45c82f0c4046ab$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
var $6c45c82f0c4046ab$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
var $6c45c82f0c4046ab$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($6c45c82f0c4046ab$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
var $6c45c82f0c4046ab$var$forEach = function forEach(list, iterator, thisArg) {
    if (!$b0wEC(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($6c45c82f0c4046ab$var$toStr.call(list) === '[object Array]') $6c45c82f0c4046ab$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $6c45c82f0c4046ab$var$forEachString(list, iterator, receiver);
    else $6c45c82f0c4046ab$var$forEachObject(list, iterator, receiver);
};
module.exports = $6c45c82f0c4046ab$var$forEach;

});
parcelRegister("b0wEC", function(module, exports) {
'use strict';
var $8039063f92a8f457$var$fnToStr = Function.prototype.toString;
var $8039063f92a8f457$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $8039063f92a8f457$var$badArrayLike;
var $8039063f92a8f457$var$isCallableMarker;
if (typeof $8039063f92a8f457$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $8039063f92a8f457$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $8039063f92a8f457$var$isCallableMarker;
        }
    });
    $8039063f92a8f457$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $8039063f92a8f457$var$reflectApply(function() {
        throw 42;
    }, null, $8039063f92a8f457$var$badArrayLike);
} catch (_) {
    if (_ !== $8039063f92a8f457$var$isCallableMarker) $8039063f92a8f457$var$reflectApply = null;
}
else $8039063f92a8f457$var$reflectApply = null;
var $8039063f92a8f457$var$constructorRegex = /^\s*class\b/;
var $8039063f92a8f457$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $8039063f92a8f457$var$fnToStr.call(value);
        return $8039063f92a8f457$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $8039063f92a8f457$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($8039063f92a8f457$var$isES6ClassFn(value)) return false;
        $8039063f92a8f457$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $8039063f92a8f457$var$toStr = Object.prototype.toString;
var $8039063f92a8f457$var$fnClass = '[object Function]';
var $8039063f92a8f457$var$genClass = '[object GeneratorFunction]';
var $8039063f92a8f457$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
/* globals document: false */ var $8039063f92a8f457$var$documentDotAll = typeof document === 'object' && typeof document.all === 'undefined' && document.all !== undefined ? document.all : {};
module.exports = $8039063f92a8f457$var$reflectApply ? function isCallable(value) {
    if (value === $8039063f92a8f457$var$documentDotAll) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if (typeof value === 'function' && !value.prototype) return true;
    try {
        $8039063f92a8f457$var$reflectApply(value, null, $8039063f92a8f457$var$badArrayLike);
    } catch (e) {
        if (e !== $8039063f92a8f457$var$isCallableMarker) return false;
    }
    return !$8039063f92a8f457$var$isES6ClassFn(value);
} : function isCallable(value) {
    if (value === $8039063f92a8f457$var$documentDotAll) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if (typeof value === 'function' && !value.prototype) return true;
    if ($8039063f92a8f457$var$hasToStringTag) return $8039063f92a8f457$var$tryFunctionObject(value);
    if ($8039063f92a8f457$var$isES6ClassFn(value)) return false;
    var strClass = $8039063f92a8f457$var$toStr.call(value);
    return strClass === $8039063f92a8f457$var$fnClass || strClass === $8039063f92a8f457$var$genClass;
};

});


parcelRegister("9WfvB", function(module, exports) {
'use strict';
var $73c58f8839d3975c$var$possibleNames = [
    'BigInt64Array',
    'BigUint64Array',
    'Float32Array',
    'Float64Array',
    'Int16Array',
    'Int32Array',
    'Int8Array',
    'Uint16Array',
    'Uint32Array',
    'Uint8Array',
    'Uint8ClampedArray'
];
var $73c58f8839d3975c$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
module.exports = function availableTypedArrays() {
    var out = [];
    for(var i = 0; i < $73c58f8839d3975c$var$possibleNames.length; i++)if (typeof $73c58f8839d3975c$var$g[$73c58f8839d3975c$var$possibleNames[i]] === 'function') out[out.length] = $73c58f8839d3975c$var$possibleNames[i];
    return out;
};

});

parcelRegister("4u81E", function(module, exports) {
'use strict';

var $2m7yB = parcelRequire("2m7yB");
module.exports = function hasToStringTagShams() {
    return $2m7yB() && !!Symbol.toStringTag;
};

});

parcelRegister("lliYw", function(module, exports) {
'use strict';

var $lSfLG = parcelRequire("lSfLG");
var $f89a473c8961c801$var$$gOPD = $lSfLG('%Object.getOwnPropertyDescriptor%', true);
if ($f89a473c8961c801$var$$gOPD) try {
    $f89a473c8961c801$var$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $f89a473c8961c801$var$$gOPD = null;
}
module.exports = $f89a473c8961c801$var$$gOPD;

});
parcelRegister("lSfLG", function(module, exports) {
'use strict';
var $fecadf57dec29445$var$undefined1;
var $fecadf57dec29445$var$$SyntaxError = SyntaxError;
var $fecadf57dec29445$var$$Function = Function;
var $fecadf57dec29445$var$$TypeError = TypeError;
// eslint-disable-next-line consistent-return
var $fecadf57dec29445$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $fecadf57dec29445$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};
var $fecadf57dec29445$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($fecadf57dec29445$var$$gOPD) try {
    $fecadf57dec29445$var$$gOPD({}, '');
} catch (e) {
    $fecadf57dec29445$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $fecadf57dec29445$var$throwTypeError = function() {
    throw new $fecadf57dec29445$var$$TypeError();
};
var $fecadf57dec29445$var$ThrowTypeError = $fecadf57dec29445$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $fecadf57dec29445$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $fecadf57dec29445$var$$gOPD(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $fecadf57dec29445$var$throwTypeError;
        }
    }
}() : $fecadf57dec29445$var$throwTypeError;

var $fecadf57dec29445$var$hasSymbols = (parcelRequire("hLfix"))();
var $fecadf57dec29445$var$getProto = Object.getPrototypeOf || function(x) {
    return x.__proto__;
}; // eslint-disable-line no-proto
var $fecadf57dec29445$var$needsEval = {};
var $fecadf57dec29445$var$TypedArray = typeof Uint8Array === 'undefined' ? undefined : $fecadf57dec29445$var$getProto(Uint8Array);
var $fecadf57dec29445$var$INTRINSICS = {
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $fecadf57dec29445$var$hasSymbols ? $fecadf57dec29445$var$getProto([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $fecadf57dec29445$var$needsEval,
    '%AsyncGenerator%': $fecadf57dec29445$var$needsEval,
    '%AsyncGeneratorFunction%': $fecadf57dec29445$var$needsEval,
    '%AsyncIteratorPrototype%': $fecadf57dec29445$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': Error,
    '%eval%': eval,
    '%EvalError%': EvalError,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $fecadf57dec29445$var$$Function,
    '%GeneratorFunction%': $fecadf57dec29445$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $fecadf57dec29445$var$hasSymbols ? $fecadf57dec29445$var$getProto($fecadf57dec29445$var$getProto([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$fecadf57dec29445$var$hasSymbols ? undefined : $fecadf57dec29445$var$getProto(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': Object,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': RangeError,
    '%ReferenceError%': ReferenceError,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$fecadf57dec29445$var$hasSymbols ? undefined : $fecadf57dec29445$var$getProto(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $fecadf57dec29445$var$hasSymbols ? $fecadf57dec29445$var$getProto(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $fecadf57dec29445$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $fecadf57dec29445$var$$SyntaxError,
    '%ThrowTypeError%': $fecadf57dec29445$var$ThrowTypeError,
    '%TypedArray%': $fecadf57dec29445$var$TypedArray,
    '%TypeError%': $fecadf57dec29445$var$$TypeError,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': URIError,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};
var $fecadf57dec29445$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $fecadf57dec29445$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $fecadf57dec29445$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $fecadf57dec29445$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen) value = $fecadf57dec29445$var$getProto(gen.prototype);
    }
    $fecadf57dec29445$var$INTRINSICS[name] = value;
    return value;
};
var $fecadf57dec29445$var$LEGACY_ALIASES = {
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $1tVKm = parcelRequire("1tVKm");

var $7HQeL = parcelRequire("7HQeL");
var $fecadf57dec29445$var$$concat = $1tVKm.call(Function.call, Array.prototype.concat);
var $fecadf57dec29445$var$$spliceApply = $1tVKm.call(Function.apply, Array.prototype.splice);
var $fecadf57dec29445$var$$replace = $1tVKm.call(Function.call, String.prototype.replace);
var $fecadf57dec29445$var$$strSlice = $1tVKm.call(Function.call, String.prototype.slice);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $fecadf57dec29445$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $fecadf57dec29445$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $fecadf57dec29445$var$stringToPath = function stringToPath(string) {
    var first = $fecadf57dec29445$var$$strSlice(string, 0, 1);
    var last = $fecadf57dec29445$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $fecadf57dec29445$var$$SyntaxError('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $fecadf57dec29445$var$$SyntaxError('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $fecadf57dec29445$var$$replace(string, $fecadf57dec29445$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $fecadf57dec29445$var$$replace(subString, $fecadf57dec29445$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $fecadf57dec29445$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($7HQeL($fecadf57dec29445$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $fecadf57dec29445$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($7HQeL($fecadf57dec29445$var$INTRINSICS, intrinsicName)) {
        var value = $fecadf57dec29445$var$INTRINSICS[intrinsicName];
        if (value === $fecadf57dec29445$var$needsEval) value = $fecadf57dec29445$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $fecadf57dec29445$var$$TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $fecadf57dec29445$var$$SyntaxError('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $fecadf57dec29445$var$$TypeError('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $fecadf57dec29445$var$$TypeError('"allowMissing" argument must be a boolean');
    var parts = $fecadf57dec29445$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $fecadf57dec29445$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $fecadf57dec29445$var$$spliceApply(parts, $fecadf57dec29445$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $fecadf57dec29445$var$$strSlice(part, 0, 1);
        var last = $fecadf57dec29445$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $fecadf57dec29445$var$$SyntaxError('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($7HQeL($fecadf57dec29445$var$INTRINSICS, intrinsicRealName)) value = $fecadf57dec29445$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $fecadf57dec29445$var$$TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($fecadf57dec29445$var$$gOPD && i + 1 >= parts.length) {
                var desc = $fecadf57dec29445$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $7HQeL(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $fecadf57dec29445$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});


parcelRegister("4sKxE", function(module, exports) {
'use strict';

var $9ikBS = parcelRequire("9ikBS");

var $9WfvB = parcelRequire("9WfvB");

var $f5egT = parcelRequire("f5egT");
var $33fde12b9c095c24$var$$toString = $f5egT('Object.prototype.toString');

var $33fde12b9c095c24$var$hasToStringTag = (parcelRequire("4u81E"))();
var $33fde12b9c095c24$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $33fde12b9c095c24$var$typedArrays = $9WfvB();
var $33fde12b9c095c24$var$$indexOf = $f5egT('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
var $33fde12b9c095c24$var$$slice = $f5egT('String.prototype.slice');
var $33fde12b9c095c24$var$toStrTags = {};

var $lliYw = parcelRequire("lliYw");
var $33fde12b9c095c24$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
if ($33fde12b9c095c24$var$hasToStringTag && $lliYw && $33fde12b9c095c24$var$getPrototypeOf) $9ikBS($33fde12b9c095c24$var$typedArrays, function(typedArray) {
    var arr = new $33fde12b9c095c24$var$g[typedArray]();
    if (Symbol.toStringTag in arr) {
        var proto = $33fde12b9c095c24$var$getPrototypeOf(arr);
        var descriptor = $lliYw(proto, Symbol.toStringTag);
        if (!descriptor) {
            var superProto = $33fde12b9c095c24$var$getPrototypeOf(proto);
            descriptor = $lliYw(superProto, Symbol.toStringTag);
        }
        $33fde12b9c095c24$var$toStrTags[typedArray] = descriptor.get;
    }
});
var $33fde12b9c095c24$var$tryTypedArrays = function tryAllTypedArrays(value) {
    var anyTrue = false;
    $9ikBS($33fde12b9c095c24$var$toStrTags, function(getter, typedArray) {
        if (!anyTrue) try {
            anyTrue = getter.call(value) === typedArray;
        } catch (e) {}
    });
    return anyTrue;
};
module.exports = function isTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$33fde12b9c095c24$var$hasToStringTag || !(Symbol.toStringTag in value)) {
        var tag = $33fde12b9c095c24$var$$slice($33fde12b9c095c24$var$$toString(value), 8, -1);
        return $33fde12b9c095c24$var$$indexOf($33fde12b9c095c24$var$typedArrays, tag) > -1;
    }
    if (!$lliYw) return false;
    return $33fde12b9c095c24$var$tryTypedArrays(value);
};

});



parcelRegister("lw0MU", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});

parcelRegister("e10SE", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("6acZf", function(module, exports) {
/* Copyright (c) 2017 Rod Vagg, MIT License */ 
var $kavLi = parcelRequire("kavLi");

var $js3Ea = parcelRequire("js3Ea");
var $47cdc02f43ebafe7$require$Buffer = $js3Ea.Buffer;

var $br7jT = parcelRequire("br7jT");

var $a1zeg = parcelRequire("a1zeg");

var $jV4kG = parcelRequire("jV4kG");
var $47cdc02f43ebafe7$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $47cdc02f43ebafe7$var$rangeOptions = 'start end gt gte lt lte'.split(' ');
function $47cdc02f43ebafe7$var$AbstractLevelDOWN(location) {
    if (!arguments.length || location === undefined) throw new Error('constructor requires at least a location argument');
    if (typeof location !== 'string') throw new Error('constructor requires a location string argument');
    this.location = location;
    this.status = 'new';
}
$47cdc02f43ebafe7$var$AbstractLevelDOWN.prototype.open = function(options, callback) {
    var self = this;
    var oldStatus = this.status;
    if (typeof options === 'function') callback = options;
    if (typeof callback !== 'function') throw new Error('open() requires a callback argument');
    if (typeof options !== 'object') options = {};
    options.createIfMissing = options.createIfMissing !== false;
    options.errorIfExists = !!options.errorIfExists;
    this.status = 'opening';
    this._open(options, function(err) {
        if (err) {
            self.status = oldStatus;
            return callback(err);
        }
        self.status = 'open';
        callback();
    });
};
$47cdc02f43ebafe7$var$AbstractLevelDOWN.prototype._open = function(options, callback) {
    $kavLi.nextTick(callback);
};
$47cdc02f43ebafe7$var$AbstractLevelDOWN.prototype.close = function(callback) {
    var self = this;
    var oldStatus = this.status;
    if (typeof callback !== 'function') throw new Error('close() requires a callback argument');
    this.status = 'closing';
    this._close(function(err) {
        if (err) {
            self.status = oldStatus;
            return callback(err);
        }
        self.status = 'closed';
        callback();
    });
};
$47cdc02f43ebafe7$var$AbstractLevelDOWN.prototype._close = function(callback) {
    $kavLi.nextTick(callback);
};
$47cdc02f43ebafe7$var$AbstractLevelDOWN.prototype.get = function(key, options, callback) {
    if (typeof options === 'function') callback = options;
    if (typeof callback !== 'function') throw new Error('get() requires a callback argument');
    var err = this._checkKey(key, 'key');
    if (err) return $kavLi.nextTick(callback, err);
    key = this._serializeKey(key);
    if (typeof options !== 'object') options = {};
    options.asBuffer = options.asBuffer !== false;
    this._get(key, options, callback);
};
$47cdc02f43ebafe7$var$AbstractLevelDOWN.prototype._get = function(key, options, callback) {
    $kavLi.nextTick(function() {
        callback(new Error('NotFound'));
    });
};
$47cdc02f43ebafe7$var$AbstractLevelDOWN.prototype.put = function(key, value, options, callback) {
    if (typeof options === 'function') callback = options;
    if (typeof callback !== 'function') throw new Error('put() requires a callback argument');
    var err = this._checkKey(key, 'key');
    if (err) return $kavLi.nextTick(callback, err);
    key = this._serializeKey(key);
    value = this._serializeValue(value);
    if (typeof options !== 'object') options = {};
    this._put(key, value, options, callback);
};
$47cdc02f43ebafe7$var$AbstractLevelDOWN.prototype._put = function(key, value, options, callback) {
    $kavLi.nextTick(callback);
};
$47cdc02f43ebafe7$var$AbstractLevelDOWN.prototype.del = function(key, options, callback) {
    if (typeof options === 'function') callback = options;
    if (typeof callback !== 'function') throw new Error('del() requires a callback argument');
    var err = this._checkKey(key, 'key');
    if (err) return $kavLi.nextTick(callback, err);
    key = this._serializeKey(key);
    if (typeof options !== 'object') options = {};
    this._del(key, options, callback);
};
$47cdc02f43ebafe7$var$AbstractLevelDOWN.prototype._del = function(key, options, callback) {
    $kavLi.nextTick(callback);
};
$47cdc02f43ebafe7$var$AbstractLevelDOWN.prototype.batch = function(array, options, callback) {
    if (!arguments.length) return this._chainedBatch();
    if (typeof options === 'function') callback = options;
    if (typeof array === 'function') callback = array;
    if (typeof callback !== 'function') throw new Error('batch(array) requires a callback argument');
    if (!Array.isArray(array)) return $kavLi.nextTick(callback, new Error('batch(array) requires an array argument'));
    if (!options || typeof options !== 'object') options = {};
    var serialized = new Array(array.length);
    for(var i = 0; i < array.length; i++){
        if (typeof array[i] !== 'object' || array[i] === null) return $kavLi.nextTick(callback, new Error('batch(array) element must be an object and not `null`'));
        var e = $br7jT(array[i]);
        if (e.type !== 'put' && e.type !== 'del') return $kavLi.nextTick(callback, new Error("`type` must be 'put' or 'del'"));
        var err = this._checkKey(e.key, 'key');
        if (err) return $kavLi.nextTick(callback, err);
        e.key = this._serializeKey(e.key);
        if (e.type === 'put') e.value = this._serializeValue(e.value);
        serialized[i] = e;
    }
    this._batch(serialized, options, callback);
};
$47cdc02f43ebafe7$var$AbstractLevelDOWN.prototype._batch = function(array, options, callback) {
    $kavLi.nextTick(callback);
};
$47cdc02f43ebafe7$var$AbstractLevelDOWN.prototype._setupIteratorOptions = function(options) {
    options = $47cdc02f43ebafe7$var$cleanRangeOptions(options);
    options.reverse = !!options.reverse;
    options.keys = options.keys !== false;
    options.values = options.values !== false;
    options.limit = 'limit' in options ? options.limit : -1;
    options.keyAsBuffer = options.keyAsBuffer !== false;
    options.valueAsBuffer = options.valueAsBuffer !== false;
    return options;
};
function $47cdc02f43ebafe7$var$cleanRangeOptions(options) {
    var result = {};
    for(var k in options){
        if (!$47cdc02f43ebafe7$var$hasOwnProperty.call(options, k)) continue;
        if ($47cdc02f43ebafe7$var$isRangeOption(k) && $47cdc02f43ebafe7$var$isEmptyRangeOption(options[k])) continue;
        result[k] = options[k];
    }
    return result;
}
function $47cdc02f43ebafe7$var$isRangeOption(k) {
    return $47cdc02f43ebafe7$var$rangeOptions.indexOf(k) !== -1;
}
function $47cdc02f43ebafe7$var$isEmptyRangeOption(v) {
    return v === '' || v == null || $47cdc02f43ebafe7$var$isEmptyBuffer(v);
}
function $47cdc02f43ebafe7$var$isEmptyBuffer(v) {
    return $47cdc02f43ebafe7$require$Buffer.isBuffer(v) && v.length === 0;
}
$47cdc02f43ebafe7$var$AbstractLevelDOWN.prototype.iterator = function(options) {
    if (typeof options !== 'object') options = {};
    options = this._setupIteratorOptions(options);
    return this._iterator(options);
};
$47cdc02f43ebafe7$var$AbstractLevelDOWN.prototype._iterator = function(options) {
    return new $a1zeg(this);
};
$47cdc02f43ebafe7$var$AbstractLevelDOWN.prototype._chainedBatch = function() {
    return new $jV4kG(this);
};
$47cdc02f43ebafe7$var$AbstractLevelDOWN.prototype._serializeKey = function(key) {
    return $47cdc02f43ebafe7$require$Buffer.isBuffer(key) ? key : String(key);
};
$47cdc02f43ebafe7$var$AbstractLevelDOWN.prototype._serializeValue = function(value) {
    if (value == null) return '';
    return $47cdc02f43ebafe7$require$Buffer.isBuffer(value), value;
};
$47cdc02f43ebafe7$var$AbstractLevelDOWN.prototype._checkKey = function(obj, type) {
    if (obj === null || obj === undefined) return new Error(type + ' cannot be `null` or `undefined`');
    if ($47cdc02f43ebafe7$require$Buffer.isBuffer(obj) && obj.length === 0) return new Error(type + ' cannot be an empty Buffer');
    if (String(obj) === '') return new Error(type + ' cannot be an empty String');
};
module.exports = $47cdc02f43ebafe7$var$AbstractLevelDOWN;

});
parcelRegister("kavLi", function(module, exports) {
// shim for using process in browser
var $eaed610ce933a8fc$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $eaed610ce933a8fc$var$cachedSetTimeout;
var $eaed610ce933a8fc$var$cachedClearTimeout;
function $eaed610ce933a8fc$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $eaed610ce933a8fc$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $eaed610ce933a8fc$var$cachedSetTimeout = setTimeout;
        else $eaed610ce933a8fc$var$cachedSetTimeout = $eaed610ce933a8fc$var$defaultSetTimout;
    } catch (e) {
        $eaed610ce933a8fc$var$cachedSetTimeout = $eaed610ce933a8fc$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $eaed610ce933a8fc$var$cachedClearTimeout = clearTimeout;
        else $eaed610ce933a8fc$var$cachedClearTimeout = $eaed610ce933a8fc$var$defaultClearTimeout;
    } catch (e) {
        $eaed610ce933a8fc$var$cachedClearTimeout = $eaed610ce933a8fc$var$defaultClearTimeout;
    }
})();
function $eaed610ce933a8fc$var$runTimeout(fun) {
    if ($eaed610ce933a8fc$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($eaed610ce933a8fc$var$cachedSetTimeout === $eaed610ce933a8fc$var$defaultSetTimout || !$eaed610ce933a8fc$var$cachedSetTimeout) && setTimeout) {
        $eaed610ce933a8fc$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $eaed610ce933a8fc$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $eaed610ce933a8fc$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $eaed610ce933a8fc$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $eaed610ce933a8fc$var$runClearTimeout(marker) {
    if ($eaed610ce933a8fc$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($eaed610ce933a8fc$var$cachedClearTimeout === $eaed610ce933a8fc$var$defaultClearTimeout || !$eaed610ce933a8fc$var$cachedClearTimeout) && clearTimeout) {
        $eaed610ce933a8fc$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $eaed610ce933a8fc$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $eaed610ce933a8fc$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $eaed610ce933a8fc$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $eaed610ce933a8fc$var$queue = [];
var $eaed610ce933a8fc$var$draining = false;
var $eaed610ce933a8fc$var$currentQueue;
var $eaed610ce933a8fc$var$queueIndex = -1;
function $eaed610ce933a8fc$var$cleanUpNextTick() {
    if (!$eaed610ce933a8fc$var$draining || !$eaed610ce933a8fc$var$currentQueue) return;
    $eaed610ce933a8fc$var$draining = false;
    if ($eaed610ce933a8fc$var$currentQueue.length) $eaed610ce933a8fc$var$queue = $eaed610ce933a8fc$var$currentQueue.concat($eaed610ce933a8fc$var$queue);
    else $eaed610ce933a8fc$var$queueIndex = -1;
    if ($eaed610ce933a8fc$var$queue.length) $eaed610ce933a8fc$var$drainQueue();
}
function $eaed610ce933a8fc$var$drainQueue() {
    if ($eaed610ce933a8fc$var$draining) return;
    var timeout = $eaed610ce933a8fc$var$runTimeout($eaed610ce933a8fc$var$cleanUpNextTick);
    $eaed610ce933a8fc$var$draining = true;
    var len = $eaed610ce933a8fc$var$queue.length;
    while(len){
        $eaed610ce933a8fc$var$currentQueue = $eaed610ce933a8fc$var$queue;
        $eaed610ce933a8fc$var$queue = [];
        while(++$eaed610ce933a8fc$var$queueIndex < len)if ($eaed610ce933a8fc$var$currentQueue) $eaed610ce933a8fc$var$currentQueue[$eaed610ce933a8fc$var$queueIndex].run();
        $eaed610ce933a8fc$var$queueIndex = -1;
        len = $eaed610ce933a8fc$var$queue.length;
    }
    $eaed610ce933a8fc$var$currentQueue = null;
    $eaed610ce933a8fc$var$draining = false;
    $eaed610ce933a8fc$var$runClearTimeout(timeout);
}
$eaed610ce933a8fc$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $eaed610ce933a8fc$var$queue.push(new $eaed610ce933a8fc$var$Item(fun, args));
    if ($eaed610ce933a8fc$var$queue.length === 1 && !$eaed610ce933a8fc$var$draining) $eaed610ce933a8fc$var$runTimeout($eaed610ce933a8fc$var$drainQueue);
};
// v8 likes predictible objects
function $eaed610ce933a8fc$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$eaed610ce933a8fc$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$eaed610ce933a8fc$var$process.title = 'browser';
$eaed610ce933a8fc$var$process.browser = true;
$eaed610ce933a8fc$var$process.env = {};
$eaed610ce933a8fc$var$process.argv = [];
$eaed610ce933a8fc$var$process.version = ''; // empty string to avoid regexp issues
$eaed610ce933a8fc$var$process.versions = {};
function $eaed610ce933a8fc$var$noop() {}
$eaed610ce933a8fc$var$process.on = $eaed610ce933a8fc$var$noop;
$eaed610ce933a8fc$var$process.addListener = $eaed610ce933a8fc$var$noop;
$eaed610ce933a8fc$var$process.once = $eaed610ce933a8fc$var$noop;
$eaed610ce933a8fc$var$process.off = $eaed610ce933a8fc$var$noop;
$eaed610ce933a8fc$var$process.removeListener = $eaed610ce933a8fc$var$noop;
$eaed610ce933a8fc$var$process.removeAllListeners = $eaed610ce933a8fc$var$noop;
$eaed610ce933a8fc$var$process.emit = $eaed610ce933a8fc$var$noop;
$eaed610ce933a8fc$var$process.prependListener = $eaed610ce933a8fc$var$noop;
$eaed610ce933a8fc$var$process.prependOnceListener = $eaed610ce933a8fc$var$noop;
$eaed610ce933a8fc$var$process.listeners = function(name) {
    return [];
};
$eaed610ce933a8fc$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$eaed610ce933a8fc$var$process.cwd = function() {
    return '/';
};
$eaed610ce933a8fc$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$eaed610ce933a8fc$var$process.umask = function() {
    return 0;
};

});

parcelRegister("js3Ea", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $e293760f7905ce48$export$a143d493d941bafc; }, function (v) { return $e293760f7905ce48$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "SlowBuffer", function () { return $e293760f7905ce48$export$e4cf37d7f6fb9e0a; }, function (v) { return $e293760f7905ce48$export$e4cf37d7f6fb9e0a = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $e293760f7905ce48$export$f99ded8fe4b79145; }, function (v) { return $e293760f7905ce48$export$f99ded8fe4b79145 = v; });
$parcel$export(module.exports, "kMaxLength", function () { return $e293760f7905ce48$export$599f31c3813fae4d; }, function (v) { return $e293760f7905ce48$export$599f31c3813fae4d = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $e293760f7905ce48$export$a143d493d941bafc;
var $e293760f7905ce48$export$e4cf37d7f6fb9e0a;
var $e293760f7905ce48$export$f99ded8fe4b79145;
var $e293760f7905ce48$export$599f31c3813fae4d;
'use strict';

var $fJ2s2 = parcelRequire("fJ2s2");

var $79ztV = parcelRequire("79ztV");
var $e293760f7905ce48$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$e293760f7905ce48$export$a143d493d941bafc = $e293760f7905ce48$var$Buffer;
$e293760f7905ce48$export$e4cf37d7f6fb9e0a = $e293760f7905ce48$var$SlowBuffer;
$e293760f7905ce48$export$f99ded8fe4b79145 = 50;
var $e293760f7905ce48$var$K_MAX_LENGTH = 0x7fffffff;
$e293760f7905ce48$export$599f31c3813fae4d = $e293760f7905ce48$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $e293760f7905ce48$var$Buffer.TYPED_ARRAY_SUPPORT = $e293760f7905ce48$var$typedArraySupport();
if (!$e293760f7905ce48$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $e293760f7905ce48$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($e293760f7905ce48$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$e293760f7905ce48$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($e293760f7905ce48$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$e293760f7905ce48$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $e293760f7905ce48$var$createBuffer(length) {
    if (length > $e293760f7905ce48$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $e293760f7905ce48$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $e293760f7905ce48$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $e293760f7905ce48$var$allocUnsafe(arg);
    }
    return $e293760f7905ce48$var$from(arg, encodingOrOffset, length);
}
$e293760f7905ce48$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $e293760f7905ce48$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $e293760f7905ce48$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $e293760f7905ce48$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($e293760f7905ce48$var$isInstance(value, ArrayBuffer) || value && $e293760f7905ce48$var$isInstance(value.buffer, ArrayBuffer)) return $e293760f7905ce48$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($e293760f7905ce48$var$isInstance(value, SharedArrayBuffer) || value && $e293760f7905ce48$var$isInstance(value.buffer, SharedArrayBuffer))) return $e293760f7905ce48$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $e293760f7905ce48$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $e293760f7905ce48$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $e293760f7905ce48$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $e293760f7905ce48$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $e293760f7905ce48$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($e293760f7905ce48$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($e293760f7905ce48$var$Buffer, Uint8Array);
function $e293760f7905ce48$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $e293760f7905ce48$var$alloc(size, fill, encoding) {
    $e293760f7905ce48$var$assertSize(size);
    if (size <= 0) return $e293760f7905ce48$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $e293760f7905ce48$var$createBuffer(size).fill(fill, encoding) : $e293760f7905ce48$var$createBuffer(size).fill(fill);
    return $e293760f7905ce48$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $e293760f7905ce48$var$Buffer.alloc = function(size, fill, encoding) {
    return $e293760f7905ce48$var$alloc(size, fill, encoding);
};
function $e293760f7905ce48$var$allocUnsafe(size) {
    $e293760f7905ce48$var$assertSize(size);
    return $e293760f7905ce48$var$createBuffer(size < 0 ? 0 : $e293760f7905ce48$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $e293760f7905ce48$var$Buffer.allocUnsafe = function(size) {
    return $e293760f7905ce48$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $e293760f7905ce48$var$Buffer.allocUnsafeSlow = function(size) {
    return $e293760f7905ce48$var$allocUnsafe(size);
};
function $e293760f7905ce48$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$e293760f7905ce48$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $e293760f7905ce48$var$byteLength(string, encoding) | 0;
    var buf = $e293760f7905ce48$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $e293760f7905ce48$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $e293760f7905ce48$var$checked(array.length) | 0;
    var buf = $e293760f7905ce48$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $e293760f7905ce48$var$fromArrayView(arrayView) {
    if ($e293760f7905ce48$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $e293760f7905ce48$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $e293760f7905ce48$var$fromArrayLike(arrayView);
}
function $e293760f7905ce48$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $e293760f7905ce48$var$Buffer.prototype);
    return buf;
}
function $e293760f7905ce48$var$fromObject(obj) {
    if ($e293760f7905ce48$var$Buffer.isBuffer(obj)) {
        var len = $e293760f7905ce48$var$checked(obj.length) | 0;
        var buf = $e293760f7905ce48$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $e293760f7905ce48$var$numberIsNaN(obj.length)) return $e293760f7905ce48$var$createBuffer(0);
        return $e293760f7905ce48$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $e293760f7905ce48$var$fromArrayLike(obj.data);
}
function $e293760f7905ce48$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $e293760f7905ce48$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $e293760f7905ce48$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $e293760f7905ce48$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $e293760f7905ce48$var$Buffer.alloc(+length);
}
$e293760f7905ce48$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $e293760f7905ce48$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$e293760f7905ce48$var$Buffer.compare = function compare(a, b) {
    if ($e293760f7905ce48$var$isInstance(a, Uint8Array)) a = $e293760f7905ce48$var$Buffer.from(a, a.offset, a.byteLength);
    if ($e293760f7905ce48$var$isInstance(b, Uint8Array)) b = $e293760f7905ce48$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$e293760f7905ce48$var$Buffer.isBuffer(a) || !$e293760f7905ce48$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$e293760f7905ce48$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$e293760f7905ce48$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $e293760f7905ce48$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $e293760f7905ce48$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($e293760f7905ce48$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $e293760f7905ce48$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$e293760f7905ce48$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $e293760f7905ce48$var$byteLength(string, encoding) {
    if ($e293760f7905ce48$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $e293760f7905ce48$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $e293760f7905ce48$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $e293760f7905ce48$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $e293760f7905ce48$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$e293760f7905ce48$var$Buffer.byteLength = $e293760f7905ce48$var$byteLength;
function $e293760f7905ce48$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $e293760f7905ce48$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $e293760f7905ce48$var$utf8Slice(this, start, end);
        case 'ascii':
            return $e293760f7905ce48$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $e293760f7905ce48$var$latin1Slice(this, start, end);
        case 'base64':
            return $e293760f7905ce48$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $e293760f7905ce48$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$e293760f7905ce48$var$Buffer.prototype._isBuffer = true;
function $e293760f7905ce48$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$e293760f7905ce48$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$e293760f7905ce48$var$swap(this, i, i + 1);
    return this;
};
$e293760f7905ce48$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $e293760f7905ce48$var$swap(this, i, i + 3);
        $e293760f7905ce48$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$e293760f7905ce48$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $e293760f7905ce48$var$swap(this, i, i + 7);
        $e293760f7905ce48$var$swap(this, i + 1, i + 6);
        $e293760f7905ce48$var$swap(this, i + 2, i + 5);
        $e293760f7905ce48$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$e293760f7905ce48$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $e293760f7905ce48$var$utf8Slice(this, 0, length);
    return $e293760f7905ce48$var$slowToString.apply(this, arguments);
};
$e293760f7905ce48$var$Buffer.prototype.toLocaleString = $e293760f7905ce48$var$Buffer.prototype.toString;
$e293760f7905ce48$var$Buffer.prototype.equals = function equals(b) {
    if (!$e293760f7905ce48$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $e293760f7905ce48$var$Buffer.compare(this, b) === 0;
};
$e293760f7905ce48$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $e293760f7905ce48$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($e293760f7905ce48$var$customInspectSymbol) $e293760f7905ce48$var$Buffer.prototype[$e293760f7905ce48$var$customInspectSymbol] = $e293760f7905ce48$var$Buffer.prototype.inspect;
$e293760f7905ce48$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($e293760f7905ce48$var$isInstance(target, Uint8Array)) target = $e293760f7905ce48$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$e293760f7905ce48$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $e293760f7905ce48$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($e293760f7905ce48$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $e293760f7905ce48$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($e293760f7905ce48$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $e293760f7905ce48$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $e293760f7905ce48$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $e293760f7905ce48$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$e293760f7905ce48$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$e293760f7905ce48$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $e293760f7905ce48$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$e293760f7905ce48$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $e293760f7905ce48$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $e293760f7905ce48$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($e293760f7905ce48$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $e293760f7905ce48$var$utf8Write(buf, string, offset, length) {
    return $e293760f7905ce48$var$blitBuffer($e293760f7905ce48$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $e293760f7905ce48$var$asciiWrite(buf, string, offset, length) {
    return $e293760f7905ce48$var$blitBuffer($e293760f7905ce48$var$asciiToBytes(string), buf, offset, length);
}
function $e293760f7905ce48$var$base64Write(buf, string, offset, length) {
    return $e293760f7905ce48$var$blitBuffer($e293760f7905ce48$var$base64ToBytes(string), buf, offset, length);
}
function $e293760f7905ce48$var$ucs2Write(buf, string, offset, length) {
    return $e293760f7905ce48$var$blitBuffer($e293760f7905ce48$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$e293760f7905ce48$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $e293760f7905ce48$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $e293760f7905ce48$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $e293760f7905ce48$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $e293760f7905ce48$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $e293760f7905ce48$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$e293760f7905ce48$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $e293760f7905ce48$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $fJ2s2.fromByteArray(buf);
    else return $fJ2s2.fromByteArray(buf.slice(start, end));
}
function $e293760f7905ce48$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $e293760f7905ce48$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $e293760f7905ce48$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $e293760f7905ce48$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $e293760f7905ce48$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $e293760f7905ce48$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $e293760f7905ce48$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $e293760f7905ce48$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $e293760f7905ce48$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $e293760f7905ce48$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $e293760f7905ce48$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$e293760f7905ce48$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $e293760f7905ce48$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $e293760f7905ce48$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$e293760f7905ce48$var$Buffer.prototype.readUintLE = $e293760f7905ce48$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e293760f7905ce48$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$e293760f7905ce48$var$Buffer.prototype.readUintBE = $e293760f7905ce48$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e293760f7905ce48$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$e293760f7905ce48$var$Buffer.prototype.readUint8 = $e293760f7905ce48$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e293760f7905ce48$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$e293760f7905ce48$var$Buffer.prototype.readUint16LE = $e293760f7905ce48$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e293760f7905ce48$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$e293760f7905ce48$var$Buffer.prototype.readUint16BE = $e293760f7905ce48$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e293760f7905ce48$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$e293760f7905ce48$var$Buffer.prototype.readUint32LE = $e293760f7905ce48$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e293760f7905ce48$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$e293760f7905ce48$var$Buffer.prototype.readUint32BE = $e293760f7905ce48$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e293760f7905ce48$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$e293760f7905ce48$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e293760f7905ce48$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$e293760f7905ce48$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e293760f7905ce48$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$e293760f7905ce48$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e293760f7905ce48$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$e293760f7905ce48$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e293760f7905ce48$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$e293760f7905ce48$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e293760f7905ce48$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$e293760f7905ce48$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e293760f7905ce48$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$e293760f7905ce48$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e293760f7905ce48$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$e293760f7905ce48$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e293760f7905ce48$var$checkOffset(offset, 4, this.length);
    return $79ztV.read(this, offset, true, 23, 4);
};
$e293760f7905ce48$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e293760f7905ce48$var$checkOffset(offset, 4, this.length);
    return $79ztV.read(this, offset, false, 23, 4);
};
$e293760f7905ce48$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e293760f7905ce48$var$checkOffset(offset, 8, this.length);
    return $79ztV.read(this, offset, true, 52, 8);
};
$e293760f7905ce48$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e293760f7905ce48$var$checkOffset(offset, 8, this.length);
    return $79ztV.read(this, offset, false, 52, 8);
};
function $e293760f7905ce48$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$e293760f7905ce48$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$e293760f7905ce48$var$Buffer.prototype.writeUintLE = $e293760f7905ce48$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $e293760f7905ce48$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$e293760f7905ce48$var$Buffer.prototype.writeUintBE = $e293760f7905ce48$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $e293760f7905ce48$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$e293760f7905ce48$var$Buffer.prototype.writeUint8 = $e293760f7905ce48$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e293760f7905ce48$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$e293760f7905ce48$var$Buffer.prototype.writeUint16LE = $e293760f7905ce48$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e293760f7905ce48$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$e293760f7905ce48$var$Buffer.prototype.writeUint16BE = $e293760f7905ce48$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e293760f7905ce48$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$e293760f7905ce48$var$Buffer.prototype.writeUint32LE = $e293760f7905ce48$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e293760f7905ce48$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$e293760f7905ce48$var$Buffer.prototype.writeUint32BE = $e293760f7905ce48$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e293760f7905ce48$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$e293760f7905ce48$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $e293760f7905ce48$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$e293760f7905ce48$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $e293760f7905ce48$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$e293760f7905ce48$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e293760f7905ce48$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$e293760f7905ce48$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e293760f7905ce48$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$e293760f7905ce48$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e293760f7905ce48$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$e293760f7905ce48$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e293760f7905ce48$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$e293760f7905ce48$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e293760f7905ce48$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $e293760f7905ce48$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $e293760f7905ce48$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e293760f7905ce48$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $79ztV.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$e293760f7905ce48$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $e293760f7905ce48$var$writeFloat(this, value, offset, true, noAssert);
};
$e293760f7905ce48$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $e293760f7905ce48$var$writeFloat(this, value, offset, false, noAssert);
};
function $e293760f7905ce48$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e293760f7905ce48$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $79ztV.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$e293760f7905ce48$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $e293760f7905ce48$var$writeDouble(this, value, offset, true, noAssert);
};
$e293760f7905ce48$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $e293760f7905ce48$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$e293760f7905ce48$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$e293760f7905ce48$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$e293760f7905ce48$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$e293760f7905ce48$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $e293760f7905ce48$var$Buffer.isBuffer(val) ? val : $e293760f7905ce48$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $e293760f7905ce48$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $e293760f7905ce48$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($e293760f7905ce48$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $e293760f7905ce48$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $e293760f7905ce48$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $e293760f7905ce48$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $e293760f7905ce48$var$base64ToBytes(str) {
    return $fJ2s2.toByteArray($e293760f7905ce48$var$base64clean(str));
}
function $e293760f7905ce48$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $e293760f7905ce48$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $e293760f7905ce48$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $e293760f7905ce48$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("fJ2s2", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $b72cf5c2d60bb26f$export$d622b2ad8d90c771; }, function (v) { return $b72cf5c2d60bb26f$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $b72cf5c2d60bb26f$export$6100ba28696e12de; }, function (v) { return $b72cf5c2d60bb26f$export$6100ba28696e12de = v; });
var $b72cf5c2d60bb26f$export$a48f0734ac7c2329;
var $b72cf5c2d60bb26f$export$d622b2ad8d90c771;
var $b72cf5c2d60bb26f$export$6100ba28696e12de;
'use strict';
$b72cf5c2d60bb26f$export$a48f0734ac7c2329 = $b72cf5c2d60bb26f$var$byteLength;
$b72cf5c2d60bb26f$export$d622b2ad8d90c771 = $b72cf5c2d60bb26f$var$toByteArray;
$b72cf5c2d60bb26f$export$6100ba28696e12de = $b72cf5c2d60bb26f$var$fromByteArray;
var $b72cf5c2d60bb26f$var$lookup = [];
var $b72cf5c2d60bb26f$var$revLookup = [];
var $b72cf5c2d60bb26f$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $b72cf5c2d60bb26f$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $b72cf5c2d60bb26f$var$i = 0, $b72cf5c2d60bb26f$var$len = $b72cf5c2d60bb26f$var$code.length; $b72cf5c2d60bb26f$var$i < $b72cf5c2d60bb26f$var$len; ++$b72cf5c2d60bb26f$var$i){
    $b72cf5c2d60bb26f$var$lookup[$b72cf5c2d60bb26f$var$i] = $b72cf5c2d60bb26f$var$code[$b72cf5c2d60bb26f$var$i];
    $b72cf5c2d60bb26f$var$revLookup[$b72cf5c2d60bb26f$var$code.charCodeAt($b72cf5c2d60bb26f$var$i)] = $b72cf5c2d60bb26f$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$b72cf5c2d60bb26f$var$revLookup['-'.charCodeAt(0)] = 62;
$b72cf5c2d60bb26f$var$revLookup['_'.charCodeAt(0)] = 63;
function $b72cf5c2d60bb26f$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $b72cf5c2d60bb26f$var$byteLength(b64) {
    var lens = $b72cf5c2d60bb26f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $b72cf5c2d60bb26f$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $b72cf5c2d60bb26f$var$toByteArray(b64) {
    var tmp;
    var lens = $b72cf5c2d60bb26f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $b72cf5c2d60bb26f$var$Arr($b72cf5c2d60bb26f$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $b72cf5c2d60bb26f$var$revLookup[b64.charCodeAt(i)] << 18 | $b72cf5c2d60bb26f$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $b72cf5c2d60bb26f$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $b72cf5c2d60bb26f$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $b72cf5c2d60bb26f$var$revLookup[b64.charCodeAt(i)] << 2 | $b72cf5c2d60bb26f$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $b72cf5c2d60bb26f$var$revLookup[b64.charCodeAt(i)] << 10 | $b72cf5c2d60bb26f$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $b72cf5c2d60bb26f$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $b72cf5c2d60bb26f$var$tripletToBase64(num) {
    return $b72cf5c2d60bb26f$var$lookup[num >> 18 & 0x3F] + $b72cf5c2d60bb26f$var$lookup[num >> 12 & 0x3F] + $b72cf5c2d60bb26f$var$lookup[num >> 6 & 0x3F] + $b72cf5c2d60bb26f$var$lookup[num & 0x3F];
}
function $b72cf5c2d60bb26f$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($b72cf5c2d60bb26f$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $b72cf5c2d60bb26f$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($b72cf5c2d60bb26f$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($b72cf5c2d60bb26f$var$lookup[tmp >> 2] + $b72cf5c2d60bb26f$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($b72cf5c2d60bb26f$var$lookup[tmp >> 10] + $b72cf5c2d60bb26f$var$lookup[tmp >> 4 & 0x3F] + $b72cf5c2d60bb26f$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("79ztV", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $5354e596a7f4ffe8$export$aafa59e2e03f2942; }, function (v) { return $5354e596a7f4ffe8$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $5354e596a7f4ffe8$export$68d8715fc104d294; }, function (v) { return $5354e596a7f4ffe8$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $5354e596a7f4ffe8$export$aafa59e2e03f2942;
var $5354e596a7f4ffe8$export$68d8715fc104d294;
$5354e596a7f4ffe8$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$5354e596a7f4ffe8$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("br7jT", function(module, exports) {
module.exports = $8537e4e689ad664f$var$extend;
var $8537e4e689ad664f$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $8537e4e689ad664f$var$extend() {
    var target = {};
    for(var i = 0; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if ($8537e4e689ad664f$var$hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
}

});

parcelRegister("a1zeg", function(module, exports) {
/* Copyright (c) 2017 Rod Vagg, MIT License */ 
var $kavLi = parcelRequire("kavLi");
function $74c55324e9d54e86$var$AbstractIterator(db) {
    this.db = db;
    this._ended = false;
    this._nexting = false;
}
$74c55324e9d54e86$var$AbstractIterator.prototype.next = function(callback) {
    var self = this;
    if (typeof callback !== 'function') throw new Error('next() requires a callback argument');
    if (self._ended) {
        $kavLi.nextTick(callback, new Error('cannot call next() after end()'));
        return self;
    }
    if (self._nexting) {
        $kavLi.nextTick(callback, new Error('cannot call next() before previous next() has completed'));
        return self;
    }
    self._nexting = true;
    self._next(function() {
        self._nexting = false;
        callback.apply(null, arguments);
    });
    return self;
};
$74c55324e9d54e86$var$AbstractIterator.prototype._next = function(callback) {
    $kavLi.nextTick(callback);
};
$74c55324e9d54e86$var$AbstractIterator.prototype.end = function(callback) {
    if (typeof callback !== 'function') throw new Error('end() requires a callback argument');
    if (this._ended) return $kavLi.nextTick(callback, new Error('end() already called on iterator'));
    this._ended = true;
    this._end(callback);
};
$74c55324e9d54e86$var$AbstractIterator.prototype._end = function(callback) {
    $kavLi.nextTick(callback);
};
module.exports = $74c55324e9d54e86$var$AbstractIterator;

});

parcelRegister("jV4kG", function(module, exports) {
/* Copyright (c) 2017 Rod Vagg, MIT License */ 
var $kavLi = parcelRequire("kavLi");
function $e806b3887048abf7$var$AbstractChainedBatch(db) {
    this._db = db;
    this._operations = [];
    this._written = false;
}
$e806b3887048abf7$var$AbstractChainedBatch.prototype._serializeKey = function(key) {
    return this._db._serializeKey(key);
};
$e806b3887048abf7$var$AbstractChainedBatch.prototype._serializeValue = function(value) {
    return this._db._serializeValue(value);
};
$e806b3887048abf7$var$AbstractChainedBatch.prototype._checkWritten = function() {
    if (this._written) throw new Error('write() already called on this batch');
};
$e806b3887048abf7$var$AbstractChainedBatch.prototype.put = function(key, value) {
    this._checkWritten();
    var err = this._db._checkKey(key, 'key');
    if (err) throw err;
    key = this._serializeKey(key);
    value = this._serializeValue(value);
    this._put(key, value);
    return this;
};
$e806b3887048abf7$var$AbstractChainedBatch.prototype._put = function(key, value) {
    this._operations.push({
        type: 'put',
        key: key,
        value: value
    });
};
$e806b3887048abf7$var$AbstractChainedBatch.prototype.del = function(key) {
    this._checkWritten();
    var err = this._db._checkKey(key, 'key');
    if (err) throw err;
    key = this._serializeKey(key);
    this._del(key);
    return this;
};
$e806b3887048abf7$var$AbstractChainedBatch.prototype._del = function(key) {
    this._operations.push({
        type: 'del',
        key: key
    });
};
$e806b3887048abf7$var$AbstractChainedBatch.prototype.clear = function() {
    this._checkWritten();
    this._operations = [];
    this._clear();
    return this;
};
$e806b3887048abf7$var$AbstractChainedBatch.prototype._clear = function noop() {};
$e806b3887048abf7$var$AbstractChainedBatch.prototype.write = function(options, callback) {
    this._checkWritten();
    if (typeof options === 'function') callback = options;
    if (typeof callback !== 'function') throw new Error('write() requires a callback argument');
    if (typeof options !== 'object') options = {};
    this._written = true;
    // @ts-ignore
    if (typeof this._write === 'function') return this._write(callback);
    if (typeof this._db._batch === 'function') return this._db._batch(this._operations, options, callback);
    $kavLi.nextTick(callback);
};
module.exports = $e806b3887048abf7$var$AbstractChainedBatch;

});


parcelRegister("cyzRy", function(module, exports) {

exports = module.exports = (parcelRequire("1Jys3"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("dUROj"));

exports.Duplex = (parcelRequire("28d42"));

exports.Transform = (parcelRequire("3ntPP"));

exports.PassThrough = (parcelRequire("6gSno"));

});
parcelRegister("1Jys3", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $kavLi = parcelRequire("kavLi");
'use strict';

var $aDtvX = parcelRequire("aDtvX");
/*</replacement>*/ module.exports = $1434b7c4593d9290$var$Readable;

var $dW5pC = parcelRequire("dW5pC");
/*</replacement>*/ /*<replacement>*/ var $1434b7c4593d9290$var$Duplex;
/*</replacement>*/ $1434b7c4593d9290$var$Readable.ReadableState = $1434b7c4593d9290$var$ReadableState;

var $hlFxx = parcelRequire("hlFxx");
var $1434b7c4593d9290$require$EE = $hlFxx.EventEmitter;
var $1434b7c4593d9290$var$EElistenerCount = function(emitter, type) {
    return emitter.listeners(type).length;
};

var $2Y3tr = parcelRequire("2Y3tr");

var $lHf3B = parcelRequire("lHf3B");
var $1434b7c4593d9290$require$Buffer = $lHf3B.Buffer;
var $1434b7c4593d9290$var$OurUint8Array = $parcel$global.Uint8Array || function() {};
function $1434b7c4593d9290$var$_uint8ArrayToBuffer(chunk) {
    return $1434b7c4593d9290$require$Buffer.from(chunk);
}
function $1434b7c4593d9290$var$_isUint8Array(obj) {
    return $1434b7c4593d9290$require$Buffer.isBuffer(obj) || obj instanceof $1434b7c4593d9290$var$OurUint8Array;
}

/*</replacement>*/ /*<replacement>*/ var $1434b7c4593d9290$var$util = Object.create((parcelRequire("uJslv")));

$1434b7c4593d9290$var$util.inherits = (parcelRequire("e10SE"));

var $7U0Mk = parcelRequire("7U0Mk");
var $1434b7c4593d9290$var$debug = void 0;
if ($7U0Mk && $7U0Mk.debuglog) $1434b7c4593d9290$var$debug = $7U0Mk.debuglog('stream');
else $1434b7c4593d9290$var$debug = function() {};

var $1oAuj = parcelRequire("1oAuj");

var $1PfvD = parcelRequire("1PfvD");
var $1434b7c4593d9290$var$StringDecoder;
$1434b7c4593d9290$var$util.inherits($1434b7c4593d9290$var$Readable, $2Y3tr);
var $1434b7c4593d9290$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $1434b7c4593d9290$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($dW5pC(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $1434b7c4593d9290$var$ReadableState(options, stream) {
    $1434b7c4593d9290$var$Duplex = $1434b7c4593d9290$var$Duplex || (parcelRequire("28d42"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $1434b7c4593d9290$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var readableHwm = options.readableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $1oAuj();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$1434b7c4593d9290$var$StringDecoder) $1434b7c4593d9290$var$StringDecoder = (parcelRequire("9INlf")).StringDecoder;
        this.decoder = new $1434b7c4593d9290$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $1434b7c4593d9290$var$Readable(options) {
    $1434b7c4593d9290$var$Duplex = $1434b7c4593d9290$var$Duplex || (parcelRequire("28d42"));
    if (!(this instanceof $1434b7c4593d9290$var$Readable)) return new $1434b7c4593d9290$var$Readable(options);
    this._readableState = new $1434b7c4593d9290$var$ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $2Y3tr.call(this);
}
Object.defineProperty($1434b7c4593d9290$var$Readable.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$1434b7c4593d9290$var$Readable.prototype.destroy = $1PfvD.destroy;
$1434b7c4593d9290$var$Readable.prototype._undestroy = $1PfvD.undestroy;
$1434b7c4593d9290$var$Readable.prototype._destroy = function(err, cb) {
    this.push(null);
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$1434b7c4593d9290$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $1434b7c4593d9290$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $1434b7c4593d9290$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$1434b7c4593d9290$var$Readable.prototype.unshift = function(chunk) {
    return $1434b7c4593d9290$var$readableAddChunk(this, chunk, null, true, false);
};
function $1434b7c4593d9290$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $1434b7c4593d9290$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $1434b7c4593d9290$var$chunkInvalid(state, chunk);
        if (er) stream.emit('error', er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $1434b7c4593d9290$require$Buffer.prototype) chunk = $1434b7c4593d9290$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));
                else $1434b7c4593d9290$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) stream.emit('error', new Error('stream.push() after EOF'));
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $1434b7c4593d9290$var$addChunk(stream, state, chunk, false);
                    else $1434b7c4593d9290$var$maybeReadMore(stream, state);
                } else $1434b7c4593d9290$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) state.reading = false;
    }
    return $1434b7c4593d9290$var$needMoreData(state);
}
function $1434b7c4593d9290$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit('data', chunk);
        stream.read(0);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $1434b7c4593d9290$var$emitReadable(stream);
    }
    $1434b7c4593d9290$var$maybeReadMore(stream, state);
}
function $1434b7c4593d9290$var$chunkInvalid(state, chunk) {
    var er;
    if (!$1434b7c4593d9290$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    return er;
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function $1434b7c4593d9290$var$needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
$1434b7c4593d9290$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$1434b7c4593d9290$var$Readable.prototype.setEncoding = function(enc) {
    if (!$1434b7c4593d9290$var$StringDecoder) $1434b7c4593d9290$var$StringDecoder = (parcelRequire("9INlf")).StringDecoder;
    this._readableState.decoder = new $1434b7c4593d9290$var$StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var $1434b7c4593d9290$var$MAX_HWM = 0x800000;
function $1434b7c4593d9290$var$computeNewHighWaterMark(n) {
    if (n >= $1434b7c4593d9290$var$MAX_HWM) n = $1434b7c4593d9290$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $1434b7c4593d9290$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $1434b7c4593d9290$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$1434b7c4593d9290$var$Readable.prototype.read = function(n) {
    $1434b7c4593d9290$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        $1434b7c4593d9290$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $1434b7c4593d9290$var$endReadable(this);
        else $1434b7c4593d9290$var$emitReadable(this);
        return null;
    }
    n = $1434b7c4593d9290$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $1434b7c4593d9290$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $1434b7c4593d9290$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $1434b7c4593d9290$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $1434b7c4593d9290$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $1434b7c4593d9290$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $1434b7c4593d9290$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $1434b7c4593d9290$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $1434b7c4593d9290$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $1434b7c4593d9290$var$onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    $1434b7c4593d9290$var$emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $1434b7c4593d9290$var$emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        $1434b7c4593d9290$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        if (state.sync) $aDtvX.nextTick($1434b7c4593d9290$var$emitReadable_, stream);
        else $1434b7c4593d9290$var$emitReadable_(stream);
    }
}
function $1434b7c4593d9290$var$emitReadable_(stream) {
    $1434b7c4593d9290$var$debug('emit readable');
    stream.emit('readable');
    $1434b7c4593d9290$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $1434b7c4593d9290$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $aDtvX.nextTick($1434b7c4593d9290$var$maybeReadMore_, stream, state);
    }
}
function $1434b7c4593d9290$var$maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        $1434b7c4593d9290$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$1434b7c4593d9290$var$Readable.prototype._read = function(n) {
    this.emit('error', new Error('_read() is not implemented'));
};
$1434b7c4593d9290$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $1434b7c4593d9290$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $kavLi.stdout && dest !== $kavLi.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $aDtvX.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $1434b7c4593d9290$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $1434b7c4593d9290$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $1434b7c4593d9290$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $1434b7c4593d9290$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on('data', ondata);
    function ondata(chunk) {
        $1434b7c4593d9290$var$debug('ondata');
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $1434b7c4593d9290$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $1434b7c4593d9290$var$debug('false write response, pause', src._readableState.awaitDrain);
                src._readableState.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $1434b7c4593d9290$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($1434b7c4593d9290$var$EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
    }
    // Make sure our error handler is attached before userland ones.
    $1434b7c4593d9290$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $1434b7c4593d9290$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $1434b7c4593d9290$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $1434b7c4593d9290$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $1434b7c4593d9290$var$pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        $1434b7c4593d9290$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $1434b7c4593d9290$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $1434b7c4593d9290$var$flow(src);
        }
    };
}
$1434b7c4593d9290$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, unpipeInfo);
        return this;
    }
    // try to find the right one.
    var index = $1434b7c4593d9290$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$1434b7c4593d9290$var$Readable.prototype.on = function(ev, fn) {
    var res = $2Y3tr.prototype.on.call(this, ev, fn);
    if (ev === 'data') // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) $aDtvX.nextTick($1434b7c4593d9290$var$nReadingNextTick, this);
            else if (state.length) $1434b7c4593d9290$var$emitReadable(this);
        }
    }
    return res;
};
$1434b7c4593d9290$var$Readable.prototype.addListener = $1434b7c4593d9290$var$Readable.prototype.on;
function $1434b7c4593d9290$var$nReadingNextTick(self) {
    $1434b7c4593d9290$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$1434b7c4593d9290$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $1434b7c4593d9290$var$debug('resume');
        state.flowing = true;
        $1434b7c4593d9290$var$resume(this, state);
    }
    return this;
};
function $1434b7c4593d9290$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $aDtvX.nextTick($1434b7c4593d9290$var$resume_, stream, state);
    }
}
function $1434b7c4593d9290$var$resume_(stream, state) {
    if (!state.reading) {
        $1434b7c4593d9290$var$debug('resume read 0');
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit('resume');
    $1434b7c4593d9290$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$1434b7c4593d9290$var$Readable.prototype.pause = function() {
    $1434b7c4593d9290$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        $1434b7c4593d9290$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    return this;
};
function $1434b7c4593d9290$var$flow(stream) {
    var state = stream._readableState;
    $1434b7c4593d9290$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$1434b7c4593d9290$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $1434b7c4593d9290$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $1434b7c4593d9290$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $1434b7c4593d9290$var$kProxyEvents.length; n++)stream.on($1434b7c4593d9290$var$kProxyEvents[n], this.emit.bind(this, $1434b7c4593d9290$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $1434b7c4593d9290$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
Object.defineProperty($1434b7c4593d9290$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._readableState.highWaterMark;
    }
});
// exposed for testing purposes only.
$1434b7c4593d9290$var$Readable._fromList = $1434b7c4593d9290$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $1434b7c4593d9290$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = $1434b7c4593d9290$var$fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $1434b7c4593d9290$var$fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? $1434b7c4593d9290$var$copyFromBufferString(n, list) : $1434b7c4593d9290$var$copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $1434b7c4593d9290$var$copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $1434b7c4593d9290$var$copyFromBuffer(n, list) {
    var ret = $1434b7c4593d9290$require$Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function $1434b7c4593d9290$var$endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        $aDtvX.nextTick($1434b7c4593d9290$var$endReadableNT, state, stream);
    }
}
function $1434b7c4593d9290$var$endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
    }
}
function $1434b7c4593d9290$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("aDtvX", function(module, exports) {

var $kavLi = parcelRequire("kavLi");
'use strict';
module.exports = {
    nextTick: $7be470d4af19e391$var$nextTick
};
function $7be470d4af19e391$var$nextTick(fn, arg1, arg2, arg3) {
    if (typeof fn !== 'function') throw new TypeError('"callback" argument must be a function');
    var len = arguments.length;
    var args, i;
    switch(len){
        case 0:
        case 1:
            return $kavLi.nextTick(fn);
        case 2:
            return $kavLi.nextTick(function afterTickOne() {
                fn.call(null, arg1);
            });
        case 3:
            return $kavLi.nextTick(function afterTickTwo() {
                fn.call(null, arg1, arg2);
            });
        case 4:
            return $kavLi.nextTick(function afterTickThree() {
                fn.call(null, arg1, arg2, arg3);
            });
        default:
            args = new Array(len - 1);
            i = 0;
            while(i < args.length)args[i++] = arguments[i];
            return $kavLi.nextTick(function afterTick() {
                fn.apply(null, args);
            });
    }
}

});

parcelRegister("dW5pC", function(module, exports) {
var $a254e3e49e93268e$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $a254e3e49e93268e$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("2Y3tr", function(module, exports) {

module.exports = (parcelRequire("hlFxx")).EventEmitter;

});

parcelRegister("lHf3B", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $js3Ea = parcelRequire("js3Ea");
var $fcb94b2884ed620d$var$Buffer = $js3Ea.Buffer;
// alternative to using Object.keys for old browsers
function $fcb94b2884ed620d$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($fcb94b2884ed620d$var$Buffer.from && $fcb94b2884ed620d$var$Buffer.alloc && $fcb94b2884ed620d$var$Buffer.allocUnsafe && $fcb94b2884ed620d$var$Buffer.allocUnsafeSlow) module.exports = $js3Ea;
else {
    // Copy properties from require('buffer')
    $fcb94b2884ed620d$var$copyProps($js3Ea, module.exports);
    module.exports.Buffer = $fcb94b2884ed620d$var$SafeBuffer;
}
function $fcb94b2884ed620d$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $fcb94b2884ed620d$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$fcb94b2884ed620d$var$copyProps($fcb94b2884ed620d$var$Buffer, $fcb94b2884ed620d$var$SafeBuffer);
$fcb94b2884ed620d$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $fcb94b2884ed620d$var$Buffer(arg, encodingOrOffset, length);
};
$fcb94b2884ed620d$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $fcb94b2884ed620d$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$fcb94b2884ed620d$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $fcb94b2884ed620d$var$Buffer(size);
};
$fcb94b2884ed620d$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $js3Ea.SlowBuffer(size);
};

});

parcelRegister("uJslv", function(module, exports) {

$parcel$export(module.exports, "isArray", function () { return $05c6101bf4713740$export$43bee75e5e14138e; }, function (v) { return $05c6101bf4713740$export$43bee75e5e14138e = v; });
$parcel$export(module.exports, "isBoolean", function () { return $05c6101bf4713740$export$f9ce7b637dfbe238; }, function (v) { return $05c6101bf4713740$export$f9ce7b637dfbe238 = v; });
$parcel$export(module.exports, "isNull", function () { return $05c6101bf4713740$export$630801d484da15df; }, function (v) { return $05c6101bf4713740$export$630801d484da15df = v; });
$parcel$export(module.exports, "isNullOrUndefined", function () { return $05c6101bf4713740$export$bedb7023a7733221; }, function (v) { return $05c6101bf4713740$export$bedb7023a7733221 = v; });
$parcel$export(module.exports, "isNumber", function () { return $05c6101bf4713740$export$7e4aa119212bc614; }, function (v) { return $05c6101bf4713740$export$7e4aa119212bc614 = v; });
$parcel$export(module.exports, "isString", function () { return $05c6101bf4713740$export$844ec244b1367d54; }, function (v) { return $05c6101bf4713740$export$844ec244b1367d54 = v; });
$parcel$export(module.exports, "isSymbol", function () { return $05c6101bf4713740$export$a244864fd9645c7f; }, function (v) { return $05c6101bf4713740$export$a244864fd9645c7f = v; });
$parcel$export(module.exports, "isUndefined", function () { return $05c6101bf4713740$export$fce6876652108ab; }, function (v) { return $05c6101bf4713740$export$fce6876652108ab = v; });
$parcel$export(module.exports, "isRegExp", function () { return $05c6101bf4713740$export$49841c62b9eff15; }, function (v) { return $05c6101bf4713740$export$49841c62b9eff15 = v; });
$parcel$export(module.exports, "isObject", function () { return $05c6101bf4713740$export$a6cdc56e425d0d0a; }, function (v) { return $05c6101bf4713740$export$a6cdc56e425d0d0a = v; });
$parcel$export(module.exports, "isDate", function () { return $05c6101bf4713740$export$871608497c498473; }, function (v) { return $05c6101bf4713740$export$871608497c498473 = v; });
$parcel$export(module.exports, "isError", function () { return $05c6101bf4713740$export$e6127cc7fe7395c3; }, function (v) { return $05c6101bf4713740$export$e6127cc7fe7395c3 = v; });
$parcel$export(module.exports, "isFunction", function () { return $05c6101bf4713740$export$f6e2535fb5126e54; }, function (v) { return $05c6101bf4713740$export$f6e2535fb5126e54 = v; });
$parcel$export(module.exports, "isPrimitive", function () { return $05c6101bf4713740$export$c3825b437cbdea5c; }, function (v) { return $05c6101bf4713740$export$c3825b437cbdea5c = v; });
$parcel$export(module.exports, "isBuffer", function () { return $05c6101bf4713740$export$a7884ebc965f8f54; }, function (v) { return $05c6101bf4713740$export$a7884ebc965f8f54 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
var $05c6101bf4713740$export$43bee75e5e14138e;
var $05c6101bf4713740$export$f9ce7b637dfbe238;
var $05c6101bf4713740$export$630801d484da15df;
var $05c6101bf4713740$export$bedb7023a7733221;
var $05c6101bf4713740$export$7e4aa119212bc614;
var $05c6101bf4713740$export$844ec244b1367d54;
var $05c6101bf4713740$export$a244864fd9645c7f;
var $05c6101bf4713740$export$fce6876652108ab;
var $05c6101bf4713740$export$49841c62b9eff15;
var $05c6101bf4713740$export$a6cdc56e425d0d0a;
var $05c6101bf4713740$export$871608497c498473;
var $05c6101bf4713740$export$e6127cc7fe7395c3;
var $05c6101bf4713740$export$f6e2535fb5126e54;
var $05c6101bf4713740$export$c3825b437cbdea5c;
var $05c6101bf4713740$export$a7884ebc965f8f54;
function $05c6101bf4713740$var$isArray(arg) {
    if (Array.isArray) return Array.isArray(arg);
    return $05c6101bf4713740$var$objectToString(arg) === '[object Array]';
}
$05c6101bf4713740$export$43bee75e5e14138e = $05c6101bf4713740$var$isArray;
function $05c6101bf4713740$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
$05c6101bf4713740$export$f9ce7b637dfbe238 = $05c6101bf4713740$var$isBoolean;
function $05c6101bf4713740$var$isNull(arg) {
    return arg === null;
}
$05c6101bf4713740$export$630801d484da15df = $05c6101bf4713740$var$isNull;
function $05c6101bf4713740$var$isNullOrUndefined(arg) {
    return arg == null;
}
$05c6101bf4713740$export$bedb7023a7733221 = $05c6101bf4713740$var$isNullOrUndefined;
function $05c6101bf4713740$var$isNumber(arg) {
    return typeof arg === 'number';
}
$05c6101bf4713740$export$7e4aa119212bc614 = $05c6101bf4713740$var$isNumber;
function $05c6101bf4713740$var$isString(arg) {
    return typeof arg === 'string';
}
$05c6101bf4713740$export$844ec244b1367d54 = $05c6101bf4713740$var$isString;
function $05c6101bf4713740$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
$05c6101bf4713740$export$a244864fd9645c7f = $05c6101bf4713740$var$isSymbol;
function $05c6101bf4713740$var$isUndefined(arg) {
    return arg === void 0;
}
$05c6101bf4713740$export$fce6876652108ab = $05c6101bf4713740$var$isUndefined;
function $05c6101bf4713740$var$isRegExp(re) {
    return $05c6101bf4713740$var$objectToString(re) === '[object RegExp]';
}
$05c6101bf4713740$export$49841c62b9eff15 = $05c6101bf4713740$var$isRegExp;
function $05c6101bf4713740$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
$05c6101bf4713740$export$a6cdc56e425d0d0a = $05c6101bf4713740$var$isObject;
function $05c6101bf4713740$var$isDate(d) {
    return $05c6101bf4713740$var$objectToString(d) === '[object Date]';
}
$05c6101bf4713740$export$871608497c498473 = $05c6101bf4713740$var$isDate;
function $05c6101bf4713740$var$isError(e) {
    return $05c6101bf4713740$var$objectToString(e) === '[object Error]' || e instanceof Error;
}
$05c6101bf4713740$export$e6127cc7fe7395c3 = $05c6101bf4713740$var$isError;
function $05c6101bf4713740$var$isFunction(arg) {
    return typeof arg === 'function';
}
$05c6101bf4713740$export$f6e2535fb5126e54 = $05c6101bf4713740$var$isFunction;
function $05c6101bf4713740$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
$05c6101bf4713740$export$c3825b437cbdea5c = $05c6101bf4713740$var$isPrimitive;

$05c6101bf4713740$export$a7884ebc965f8f54 = (parcelRequire("js3Ea")).Buffer.isBuffer;
function $05c6101bf4713740$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}

});

parcelRegister("7U0Mk", function(module, exports) {
"use strict";

});

parcelRegister("1oAuj", function(module, exports) {
'use strict';
function $10445611f130ba0d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $lHf3B = parcelRequire("lHf3B");
var $10445611f130ba0d$require$Buffer = $lHf3B.Buffer;

var $7U0Mk = parcelRequire("7U0Mk");
function $10445611f130ba0d$var$copyBuffer(src, target, offset) {
    src.copy(target, offset);
}
module.exports = function() {
    function BufferList() {
        $10445611f130ba0d$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    BufferList.prototype.push = function push(v) {
        var entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    };
    BufferList.prototype.unshift = function unshift(v) {
        var entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    };
    BufferList.prototype.shift = function shift() {
        if (this.length === 0) return;
        var ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    };
    BufferList.prototype.clear = function clear() {
        this.head = this.tail = null;
        this.length = 0;
    };
    BufferList.prototype.join = function join(s) {
        if (this.length === 0) return '';
        var p = this.head;
        var ret = '' + p.data;
        while(p = p.next)ret += s + p.data;
        return ret;
    };
    BufferList.prototype.concat = function concat(n) {
        if (this.length === 0) return $10445611f130ba0d$require$Buffer.alloc(0);
        if (this.length === 1) return this.head.data;
        var ret = $10445611f130ba0d$require$Buffer.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;
        while(p){
            $10445611f130ba0d$var$copyBuffer(p.data, ret, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    };
    return BufferList;
}();
if ($7U0Mk && $7U0Mk.inspect && $7U0Mk.inspect.custom) module.exports.prototype[$7U0Mk.inspect.custom] = function() {
    var obj = $7U0Mk.inspect({
        length: this.length
    });
    return this.constructor.name + ' ' + obj;
};

});

parcelRegister("1PfvD", function(module, exports) {
'use strict';

var $aDtvX = parcelRequire("aDtvX");
/*</replacement>*/ // undocumented cb() API, needed for core, not for public API
function $154695aa24a00b77$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err && (!this._writableState || !this._writableState.errorEmitted)) $aDtvX.nextTick($154695aa24a00b77$var$emitErrorNT, this, err);
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            $aDtvX.nextTick($154695aa24a00b77$var$emitErrorNT, _this, err);
            if (_this._writableState) _this._writableState.errorEmitted = true;
        } else if (cb) cb(err);
    });
    return this;
}
function $154695aa24a00b77$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $154695aa24a00b77$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
module.exports = {
    destroy: $154695aa24a00b77$var$destroy,
    undestroy: $154695aa24a00b77$var$undestroy
};

});

parcelRegister("28d42", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
'use strict';

var $aDtvX = parcelRequire("aDtvX");
/*</replacement>*/ /*<replacement>*/ var $18d676677d4ff5d9$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $18d676677d4ff5d9$var$Duplex;

/*<replacement>*/ var $18d676677d4ff5d9$var$util = Object.create((parcelRequire("uJslv")));

$18d676677d4ff5d9$var$util.inherits = (parcelRequire("e10SE"));

var $1Jys3 = parcelRequire("1Jys3");

var $dUROj = parcelRequire("dUROj");
$18d676677d4ff5d9$var$util.inherits($18d676677d4ff5d9$var$Duplex, $1Jys3);
// avoid scope creep, the keys array can then be collected
var $18d676677d4ff5d9$var$keys = $18d676677d4ff5d9$var$objectKeys($dUROj.prototype);
for(var $18d676677d4ff5d9$var$v = 0; $18d676677d4ff5d9$var$v < $18d676677d4ff5d9$var$keys.length; $18d676677d4ff5d9$var$v++){
    var $18d676677d4ff5d9$var$method = $18d676677d4ff5d9$var$keys[$18d676677d4ff5d9$var$v];
    if (!$18d676677d4ff5d9$var$Duplex.prototype[$18d676677d4ff5d9$var$method]) $18d676677d4ff5d9$var$Duplex.prototype[$18d676677d4ff5d9$var$method] = $dUROj.prototype[$18d676677d4ff5d9$var$method];
}
function $18d676677d4ff5d9$var$Duplex(options) {
    if (!(this instanceof $18d676677d4ff5d9$var$Duplex)) return new $18d676677d4ff5d9$var$Duplex(options);
    $1Jys3.call(this, options);
    $dUROj.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once('end', $18d676677d4ff5d9$var$onend);
}
Object.defineProperty($18d676677d4ff5d9$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// the no-half-open enforcer
function $18d676677d4ff5d9$var$onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $aDtvX.nextTick($18d676677d4ff5d9$var$onEndNT, this);
}
function $18d676677d4ff5d9$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($18d676677d4ff5d9$var$Duplex.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});
$18d676677d4ff5d9$var$Duplex.prototype._destroy = function(err, cb) {
    this.push(null);
    this.end();
    $aDtvX.nextTick(cb, err);
};

});
parcelRegister("dUROj", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $aDtvX = parcelRequire("aDtvX");
/*</replacement>*/ module.exports = $a21a3ef31a2202b2$var$Writable;
/* <replacement> */ function $a21a3ef31a2202b2$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $a21a3ef31a2202b2$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $a21a3ef31a2202b2$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $a21a3ef31a2202b2$var$asyncWrite = (0, $aDtvX.nextTick);
/*</replacement>*/ /*<replacement>*/ var $a21a3ef31a2202b2$var$Duplex;
/*</replacement>*/ $a21a3ef31a2202b2$var$Writable.WritableState = $a21a3ef31a2202b2$var$WritableState;

/*<replacement>*/ var $a21a3ef31a2202b2$var$util = Object.create((parcelRequire("uJslv")));

$a21a3ef31a2202b2$var$util.inherits = (parcelRequire("e10SE"));

/*</replacement>*/ /*<replacement>*/ var $a21a3ef31a2202b2$var$internalUtil = {
    deprecate: (parcelRequire("8bjay"))
};

var $2Y3tr = parcelRequire("2Y3tr");

var $lHf3B = parcelRequire("lHf3B");
var $a21a3ef31a2202b2$require$Buffer = $lHf3B.Buffer;
var $a21a3ef31a2202b2$var$OurUint8Array = $parcel$global.Uint8Array || function() {};
function $a21a3ef31a2202b2$var$_uint8ArrayToBuffer(chunk) {
    return $a21a3ef31a2202b2$require$Buffer.from(chunk);
}
function $a21a3ef31a2202b2$var$_isUint8Array(obj) {
    return $a21a3ef31a2202b2$require$Buffer.isBuffer(obj) || obj instanceof $a21a3ef31a2202b2$var$OurUint8Array;
}

var $1PfvD = parcelRequire("1PfvD");
$a21a3ef31a2202b2$var$util.inherits($a21a3ef31a2202b2$var$Writable, $2Y3tr);
function $a21a3ef31a2202b2$var$nop() {}

function $a21a3ef31a2202b2$var$WritableState(options, stream) {
    $a21a3ef31a2202b2$var$Duplex = $a21a3ef31a2202b2$var$Duplex || (parcelRequire("28d42"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $a21a3ef31a2202b2$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var writableHwm = options.writableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $a21a3ef31a2202b2$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $a21a3ef31a2202b2$var$CorkedRequest(this);
}
$a21a3ef31a2202b2$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($a21a3ef31a2202b2$var$WritableState.prototype, 'buffer', {
            get: $a21a3ef31a2202b2$var$internalUtil.deprecate(function() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $a21a3ef31a2202b2$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $a21a3ef31a2202b2$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($a21a3ef31a2202b2$var$Writable, Symbol.hasInstance, {
        value: function(object) {
            if ($a21a3ef31a2202b2$var$realHasInstance.call(this, object)) return true;
            if (this !== $a21a3ef31a2202b2$var$Writable) return false;
            return object && object._writableState instanceof $a21a3ef31a2202b2$var$WritableState;
        }
    });
} else $a21a3ef31a2202b2$var$realHasInstance = function(object) {
    return object instanceof this;
};

function $a21a3ef31a2202b2$var$Writable(options) {
    $a21a3ef31a2202b2$var$Duplex = $a21a3ef31a2202b2$var$Duplex || (parcelRequire("28d42"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    if (!$a21a3ef31a2202b2$var$realHasInstance.call($a21a3ef31a2202b2$var$Writable, this) && !(this instanceof $a21a3ef31a2202b2$var$Duplex)) return new $a21a3ef31a2202b2$var$Writable(options);
    this._writableState = new $a21a3ef31a2202b2$var$WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $2Y3tr.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$a21a3ef31a2202b2$var$Writable.prototype.pipe = function() {
    this.emit('error', new Error('Cannot pipe, not readable'));
};
function $a21a3ef31a2202b2$var$writeAfterEnd(stream, cb) {
    var er = new Error('write after end');
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit('error', er);
    $aDtvX.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $a21a3ef31a2202b2$var$validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    if (chunk === null) er = new TypeError('May not write null values to stream');
    else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    if (er) {
        stream.emit('error', er);
        $aDtvX.nextTick(cb, er);
        valid = false;
    }
    return valid;
}
$a21a3ef31a2202b2$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $a21a3ef31a2202b2$var$_isUint8Array(chunk);
    if (isBuf && !$a21a3ef31a2202b2$require$Buffer.isBuffer(chunk)) chunk = $a21a3ef31a2202b2$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $a21a3ef31a2202b2$var$nop;
    if (state.ended) $a21a3ef31a2202b2$var$writeAfterEnd(this, cb);
    else if (isBuf || $a21a3ef31a2202b2$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $a21a3ef31a2202b2$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$a21a3ef31a2202b2$var$Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
$a21a3ef31a2202b2$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) $a21a3ef31a2202b2$var$clearBuffer(this, state);
    }
};
$a21a3ef31a2202b2$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function $a21a3ef31a2202b2$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $a21a3ef31a2202b2$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($a21a3ef31a2202b2$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $a21a3ef31a2202b2$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $a21a3ef31a2202b2$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $a21a3ef31a2202b2$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $a21a3ef31a2202b2$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $a21a3ef31a2202b2$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $aDtvX.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $aDtvX.nextTick($a21a3ef31a2202b2$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
        // this can emit finish, but finish must
        // always follow error
        $a21a3ef31a2202b2$var$finishMaybe(stream, state);
    }
}
function $a21a3ef31a2202b2$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $a21a3ef31a2202b2$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    $a21a3ef31a2202b2$var$onwriteStateUpdate(state);
    if (er) $a21a3ef31a2202b2$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $a21a3ef31a2202b2$var$needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $a21a3ef31a2202b2$var$clearBuffer(stream, state);
        if (sync) /*<replacement>*/ $a21a3ef31a2202b2$var$asyncWrite($a21a3ef31a2202b2$var$afterWrite, stream, state, finished, cb);
        else $a21a3ef31a2202b2$var$afterWrite(stream, state, finished, cb);
    }
}
function $a21a3ef31a2202b2$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $a21a3ef31a2202b2$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $a21a3ef31a2202b2$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $a21a3ef31a2202b2$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $a21a3ef31a2202b2$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $a21a3ef31a2202b2$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $a21a3ef31a2202b2$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $a21a3ef31a2202b2$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$a21a3ef31a2202b2$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error('_write() is not implemented'));
};
$a21a3ef31a2202b2$var$Writable.prototype._writev = null;
$a21a3ef31a2202b2$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending && !state.finished) $a21a3ef31a2202b2$var$endWritable(this, state, cb);
};
function $a21a3ef31a2202b2$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $a21a3ef31a2202b2$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) stream.emit('error', err);
        state.prefinished = true;
        stream.emit('prefinish');
        $a21a3ef31a2202b2$var$finishMaybe(stream, state);
    });
}
function $a21a3ef31a2202b2$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function') {
            state.pendingcb++;
            state.finalCalled = true;
            $aDtvX.nextTick($a21a3ef31a2202b2$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $a21a3ef31a2202b2$var$finishMaybe(stream, state) {
    var need = $a21a3ef31a2202b2$var$needFinish(state);
    if (need) {
        $a21a3ef31a2202b2$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
        }
    }
    return need;
}
function $a21a3ef31a2202b2$var$endWritable(stream, state, cb) {
    state.ending = true;
    $a21a3ef31a2202b2$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $aDtvX.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $a21a3ef31a2202b2$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    if (state.corkedRequestsFree) state.corkedRequestsFree.next = corkReq;
    else state.corkedRequestsFree = corkReq;
}
Object.defineProperty($a21a3ef31a2202b2$var$Writable.prototype, 'destroyed', {
    get: function() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$a21a3ef31a2202b2$var$Writable.prototype.destroy = $1PfvD.destroy;
$a21a3ef31a2202b2$var$Writable.prototype._undestroy = $1PfvD.undestroy;
$a21a3ef31a2202b2$var$Writable.prototype._destroy = function(err, cb) {
    this.end();
    cb(err);
};

});
parcelRegister("8bjay", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $5f4e386ef792e378$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $5f4e386ef792e378$var$deprecate(fn, msg) {
    if ($5f4e386ef792e378$var$config('noDeprecation')) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($5f4e386ef792e378$var$config('throwDeprecation')) throw new Error(msg);
            else if ($5f4e386ef792e378$var$config('traceDeprecation')) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $5f4e386ef792e378$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === 'true';
}

});



parcelRegister("9INlf", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $713e7f59ba6dc098$export$63a7aa211a91ed69; }, function (v) { return $713e7f59ba6dc098$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $713e7f59ba6dc098$export$63a7aa211a91ed69;
'use strict';

var $8Rspq = parcelRequire("8Rspq");
var $713e7f59ba6dc098$require$Buffer = $8Rspq.Buffer;
/*</replacement>*/ var $713e7f59ba6dc098$var$isEncoding = $713e7f59ba6dc098$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $713e7f59ba6dc098$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $713e7f59ba6dc098$var$normalizeEncoding(enc) {
    var nenc = $713e7f59ba6dc098$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($713e7f59ba6dc098$require$Buffer.isEncoding === $713e7f59ba6dc098$var$isEncoding || !$713e7f59ba6dc098$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$713e7f59ba6dc098$export$63a7aa211a91ed69 = $713e7f59ba6dc098$var$StringDecoder;
function $713e7f59ba6dc098$var$StringDecoder(encoding) {
    this.encoding = $713e7f59ba6dc098$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $713e7f59ba6dc098$var$utf16Text;
            this.end = $713e7f59ba6dc098$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $713e7f59ba6dc098$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $713e7f59ba6dc098$var$base64Text;
            this.end = $713e7f59ba6dc098$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $713e7f59ba6dc098$var$simpleWrite;
            this.end = $713e7f59ba6dc098$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $713e7f59ba6dc098$require$Buffer.allocUnsafe(nb);
}
$713e7f59ba6dc098$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$713e7f59ba6dc098$var$StringDecoder.prototype.end = $713e7f59ba6dc098$var$utf8End;
// Returns only complete characters in a Buffer
$713e7f59ba6dc098$var$StringDecoder.prototype.text = $713e7f59ba6dc098$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$713e7f59ba6dc098$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $713e7f59ba6dc098$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $713e7f59ba6dc098$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $713e7f59ba6dc098$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $713e7f59ba6dc098$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $713e7f59ba6dc098$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $713e7f59ba6dc098$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $713e7f59ba6dc098$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $713e7f59ba6dc098$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $713e7f59ba6dc098$var$utf8Text(buf, i) {
    var total = $713e7f59ba6dc098$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $713e7f59ba6dc098$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $713e7f59ba6dc098$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $713e7f59ba6dc098$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $713e7f59ba6dc098$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $713e7f59ba6dc098$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $713e7f59ba6dc098$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $713e7f59ba6dc098$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});
parcelRegister("8Rspq", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $js3Ea = parcelRequire("js3Ea");
var $67394f6e15527b55$var$Buffer = $js3Ea.Buffer;
// alternative to using Object.keys for old browsers
function $67394f6e15527b55$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($67394f6e15527b55$var$Buffer.from && $67394f6e15527b55$var$Buffer.alloc && $67394f6e15527b55$var$Buffer.allocUnsafe && $67394f6e15527b55$var$Buffer.allocUnsafeSlow) module.exports = $js3Ea;
else {
    // Copy properties from require('buffer')
    $67394f6e15527b55$var$copyProps($js3Ea, module.exports);
    module.exports.Buffer = $67394f6e15527b55$var$SafeBuffer;
}
function $67394f6e15527b55$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $67394f6e15527b55$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$67394f6e15527b55$var$copyProps($67394f6e15527b55$var$Buffer, $67394f6e15527b55$var$SafeBuffer);
$67394f6e15527b55$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $67394f6e15527b55$var$Buffer(arg, encodingOrOffset, length);
};
$67394f6e15527b55$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $67394f6e15527b55$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$67394f6e15527b55$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $67394f6e15527b55$var$Buffer(size);
};
$67394f6e15527b55$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $js3Ea.SlowBuffer(size);
};

});



parcelRegister("3ntPP", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $275aa9ae6f5f7a48$var$Transform;

var $28d42 = parcelRequire("28d42");

/*<replacement>*/ var $275aa9ae6f5f7a48$var$util = Object.create((parcelRequire("uJslv")));

$275aa9ae6f5f7a48$var$util.inherits = (parcelRequire("e10SE"));
/*</replacement>*/ $275aa9ae6f5f7a48$var$util.inherits($275aa9ae6f5f7a48$var$Transform, $28d42);
function $275aa9ae6f5f7a48$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return this.emit('error', new Error('write callback called multiple times'));
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $275aa9ae6f5f7a48$var$Transform(options) {
    if (!(this instanceof $275aa9ae6f5f7a48$var$Transform)) return new $275aa9ae6f5f7a48$var$Transform(options);
    $28d42.call(this, options);
    this._transformState = {
        afterTransform: $275aa9ae6f5f7a48$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $275aa9ae6f5f7a48$var$prefinish);
}
function $275aa9ae6f5f7a48$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function') this._flush(function(er, data) {
        $275aa9ae6f5f7a48$var$done(_this, er, data);
    });
    else $275aa9ae6f5f7a48$var$done(this, null, null);
}
$275aa9ae6f5f7a48$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $28d42.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$275aa9ae6f5f7a48$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error('_transform() is not implemented');
};
$275aa9ae6f5f7a48$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$275aa9ae6f5f7a48$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$275aa9ae6f5f7a48$var$Transform.prototype._destroy = function(err, cb) {
    var _this2 = this;
    $28d42.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
        _this2.emit('close');
    });
};
function $275aa9ae6f5f7a48$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) stream.push(data);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
    if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
    return stream.push(null);
}

});

parcelRegister("6gSno", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $490e6ab302710948$var$PassThrough;

var $3ntPP = parcelRequire("3ntPP");

/*<replacement>*/ var $490e6ab302710948$var$util = Object.create((parcelRequire("uJslv")));

$490e6ab302710948$var$util.inherits = (parcelRequire("e10SE"));
/*</replacement>*/ $490e6ab302710948$var$util.inherits($490e6ab302710948$var$PassThrough, $3ntPP);
function $490e6ab302710948$var$PassThrough(options) {
    if (!(this instanceof $490e6ab302710948$var$PassThrough)) return new $490e6ab302710948$var$PassThrough(options);
    $3ntPP.call(this, options);
}
$490e6ab302710948$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});


parcelRegister("iUF7U", function(module, exports) {

var $2nNvs = parcelRequire("2nNvs");
function $dc4d5bd59d344ecd$var$init(type, message, cause) {
    if (!!message && typeof message != 'string') message = message.message || message.name;
    $2nNvs(this, {
        type: type,
        name: type,
        cause: typeof message != 'string' ? message : cause,
        message: message
    }, 'ewr');
}
// generic prototype, not intended to be actually used - helpful for `instanceof`
function $dc4d5bd59d344ecd$var$CustomError(message, cause) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    $dc4d5bd59d344ecd$var$init.call(this, 'CustomError', message, cause);
}
$dc4d5bd59d344ecd$var$CustomError.prototype = new Error();
function $dc4d5bd59d344ecd$var$createError(errno, type, proto) {
    var err = function(message, cause) {
        $dc4d5bd59d344ecd$var$init.call(this, type, message, cause);
        //TODO: the specificity here is stupid, errno should be available everywhere
        if (type == 'FilesystemError') {
            this.code = this.cause.code;
            this.path = this.cause.path;
            this.errno = this.cause.errno;
            this.message = (errno.errno[this.cause.errno] ? errno.errno[this.cause.errno].description : this.cause.message) + (this.cause.path ? ' [' + this.cause.path + ']' : '');
        }
        Error.call(this);
        if (Error.captureStackTrace) Error.captureStackTrace(this, err);
    };
    err.prototype = !!proto ? new proto() : new $dc4d5bd59d344ecd$var$CustomError();
    return err;
}
module.exports = function(errno) {
    var ce = function(type, proto) {
        return $dc4d5bd59d344ecd$var$createError(errno, type, proto);
    };
    return {
        CustomError: $dc4d5bd59d344ecd$var$CustomError,
        FilesystemError: ce('FilesystemError'),
        createError: ce
    };
};

});
parcelRegister("2nNvs", function(module, exports) {
/*!
  * prr
  * (c) 2013 Rod Vagg <rod@vagg.org>
  * https://github.com/rvagg/prr
  * License: MIT
  */ (function(name, context, definition) {
    if (module.exports) module.exports = definition();
    else context[name] = definition();
})('prr', module.exports, function() {
    var setProperty = typeof Object.defineProperty == 'function' ? function(obj, key, options) {
        Object.defineProperty(obj, key, options);
        return obj;
    } : function(obj, key, options) {
        obj[key] = options.value;
        return obj;
    }, makeOptions = function(value, options) {
        var oo = typeof options == 'object', os = !oo && typeof options == 'string', op = function(p) {
            return oo ? !!options[p] : os ? options.indexOf(p[0]) > -1 : false;
        };
        return {
            enumerable: op('enumerable'),
            configurable: op('configurable'),
            writable: op('writable'),
            value: value
        };
    }, prr = function(obj, key, value, options) {
        var k;
        options = makeOptions(value, options);
        if (typeof key == 'object') {
            for(k in key)if (Object.hasOwnProperty.call(key, k)) {
                options.value = key[k];
                setProperty(obj, k, options);
            }
            return obj;
        }
        return setProperty(obj, key, options);
    };
    return prr;
});

});


parcelRegister("iUbla", function(module, exports) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var $kavLi = parcelRequire("kavLi");
'use strict';
function $dc3640eb2b3c2774$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $dc3640eb2b3c2774$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $dc3640eb2b3c2774$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $dc3640eb2b3c2774$var$_typeof(obj);
}
function $dc3640eb2b3c2774$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $aPz4L = parcelRequire("aPz4L");
var $dc3640eb2b3c2774$var$_require$codes = $aPz4L.codes, $dc3640eb2b3c2774$var$ERR_AMBIGUOUS_ARGUMENT = $dc3640eb2b3c2774$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $dc3640eb2b3c2774$var$ERR_INVALID_ARG_TYPE = $dc3640eb2b3c2774$var$_require$codes.ERR_INVALID_ARG_TYPE, $dc3640eb2b3c2774$var$ERR_INVALID_ARG_VALUE = $dc3640eb2b3c2774$var$_require$codes.ERR_INVALID_ARG_VALUE, $dc3640eb2b3c2774$var$ERR_INVALID_RETURN_VALUE = $dc3640eb2b3c2774$var$_require$codes.ERR_INVALID_RETURN_VALUE, $dc3640eb2b3c2774$var$ERR_MISSING_ARGS = $dc3640eb2b3c2774$var$_require$codes.ERR_MISSING_ARGS;

var $5uJGS = parcelRequire("5uJGS");

var $lmEzn = parcelRequire("lmEzn");
var $dc3640eb2b3c2774$var$inspect = $lmEzn.inspect;

var $lmEzn = parcelRequire("lmEzn");
var $dc3640eb2b3c2774$require$_require$types = $lmEzn.types;
var $dc3640eb2b3c2774$var$isPromise = $dc3640eb2b3c2774$require$_require$types.isPromise, $dc3640eb2b3c2774$var$isRegExp = $dc3640eb2b3c2774$require$_require$types.isRegExp;

var $dc3640eb2b3c2774$var$objectAssign = Object.assign ? Object.assign : (parcelRequire("2YhbW")).assign;

var $dc3640eb2b3c2774$var$objectIs = Object.is ? Object.is : (parcelRequire("9JZPb"));
var $dc3640eb2b3c2774$var$errorCache = new Map();
var $dc3640eb2b3c2774$var$isDeepEqual;
var $dc3640eb2b3c2774$var$isDeepStrictEqual;
var $dc3640eb2b3c2774$var$parseExpressionAt;
var $dc3640eb2b3c2774$var$findNodeAround;
var $dc3640eb2b3c2774$var$decoder;

function $dc3640eb2b3c2774$var$lazyLoadComparison() {
    var comparison = (parcelRequire("ghIoK"));
    $dc3640eb2b3c2774$var$isDeepEqual = comparison.isDeepEqual;
    $dc3640eb2b3c2774$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
} // Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var $dc3640eb2b3c2774$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var $dc3640eb2b3c2774$var$meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    '\\b',
    '',
    '',
    "\\u000b",
    '\\f',
    '',
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var $dc3640eb2b3c2774$var$escapeFn = function escapeFn(str) {
    return $dc3640eb2b3c2774$var$meta[str.charCodeAt(0)];
};
var $dc3640eb2b3c2774$var$warned = false; // The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var $dc3640eb2b3c2774$var$assert = module.exports = $dc3640eb2b3c2774$var$ok;
var $dc3640eb2b3c2774$var$NO_EXCEPTION_SENTINEL = {}; // All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function $dc3640eb2b3c2774$var$innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new $5uJGS(obj);
}
function $dc3640eb2b3c2774$var$fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = 'Failed';
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if ($dc3640eb2b3c2774$var$warned === false) {
            $dc3640eb2b3c2774$var$warned = true;
            var warn = $kavLi.emitWarning ? $kavLi.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", 'DeprecationWarning', 'DEP0094');
        }
        if (argsLen === 2) operator = '!=';
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? 'fail' : operator,
        stackStartFn: stackStartFn || $dc3640eb2b3c2774$var$fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new $5uJGS(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
$dc3640eb2b3c2774$var$assert.fail = $dc3640eb2b3c2774$var$fail; // The AssertionError is defined in internal/error.
$dc3640eb2b3c2774$var$assert.AssertionError = $5uJGS;
function $dc3640eb2b3c2774$var$innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = 'No value argument passed to `assert.ok()`';
        } else if (message instanceof Error) throw message;
        var err = new $5uJGS({
            actual: value,
            expected: true,
            message: message,
            operator: '==',
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
} // Pure assertion tests whether a value is truthy, as determined
// by !!value.
function $dc3640eb2b3c2774$var$ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $dc3640eb2b3c2774$var$innerOk.apply(void 0, [
        $dc3640eb2b3c2774$var$ok,
        args.length
    ].concat(args));
}
$dc3640eb2b3c2774$var$assert.ok = $dc3640eb2b3c2774$var$ok; // The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ $dc3640eb2b3c2774$var$assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new $dc3640eb2b3c2774$var$ERR_MISSING_ARGS('actual', 'expected');
     // eslint-disable-next-line eqeqeq
    if (actual != expected) $dc3640eb2b3c2774$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '==',
        stackStartFn: equal
    });
}; // The non-equality assertion tests for whether two objects are not
// equal with !=.
$dc3640eb2b3c2774$var$assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $dc3640eb2b3c2774$var$ERR_MISSING_ARGS('actual', 'expected');
     // eslint-disable-next-line eqeqeq
    if (actual == expected) $dc3640eb2b3c2774$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '!=',
        stackStartFn: notEqual
    });
}; // The equivalence assertion tests a deep equality relation.
$dc3640eb2b3c2774$var$assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $dc3640eb2b3c2774$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($dc3640eb2b3c2774$var$isDeepEqual === undefined) $dc3640eb2b3c2774$var$lazyLoadComparison();
    if (!$dc3640eb2b3c2774$var$isDeepEqual(actual, expected)) $dc3640eb2b3c2774$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepEqual',
        stackStartFn: deepEqual
    });
}; // The non-equivalence assertion tests for any deep inequality.
$dc3640eb2b3c2774$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $dc3640eb2b3c2774$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($dc3640eb2b3c2774$var$isDeepEqual === undefined) $dc3640eb2b3c2774$var$lazyLoadComparison();
    if ($dc3640eb2b3c2774$var$isDeepEqual(actual, expected)) $dc3640eb2b3c2774$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepEqual',
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ $dc3640eb2b3c2774$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $dc3640eb2b3c2774$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($dc3640eb2b3c2774$var$isDeepEqual === undefined) $dc3640eb2b3c2774$var$lazyLoadComparison();
    if (!$dc3640eb2b3c2774$var$isDeepStrictEqual(actual, expected)) $dc3640eb2b3c2774$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepStrictEqual',
        stackStartFn: deepStrictEqual
    });
};
$dc3640eb2b3c2774$var$assert.notDeepStrictEqual = $dc3640eb2b3c2774$var$notDeepStrictEqual;
function $dc3640eb2b3c2774$var$notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $dc3640eb2b3c2774$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($dc3640eb2b3c2774$var$isDeepEqual === undefined) $dc3640eb2b3c2774$var$lazyLoadComparison();
    if ($dc3640eb2b3c2774$var$isDeepStrictEqual(actual, expected)) $dc3640eb2b3c2774$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepStrictEqual',
        stackStartFn: $dc3640eb2b3c2774$var$notDeepStrictEqual
    });
}
$dc3640eb2b3c2774$var$assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $dc3640eb2b3c2774$var$ERR_MISSING_ARGS('actual', 'expected');
    if (!$dc3640eb2b3c2774$var$objectIs(actual, expected)) $dc3640eb2b3c2774$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'strictEqual',
        stackStartFn: strictEqual
    });
};
$dc3640eb2b3c2774$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $dc3640eb2b3c2774$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($dc3640eb2b3c2774$var$objectIs(actual, expected)) $dc3640eb2b3c2774$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notStrictEqual',
        stackStartFn: notStrictEqual
    });
};
var $dc3640eb2b3c2774$var$Comparison = function Comparison(obj, keys, actual) {
    var _this = this;
    $dc3640eb2b3c2774$var$_classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === 'string' && $dc3640eb2b3c2774$var$isRegExp(obj[key]) && obj[key].test(actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
};
function $dc3640eb2b3c2774$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !$dc3640eb2b3c2774$var$isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new $dc3640eb2b3c2774$var$Comparison(actual, keys);
            var b = new $dc3640eb2b3c2774$var$Comparison(expected, keys, actual);
            var err = new $5uJGS({
                actual: a,
                expected: b,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        $dc3640eb2b3c2774$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function $dc3640eb2b3c2774$var$expectedException(actual, expected, msg, fn) {
    if (typeof expected !== 'function') {
        if ($dc3640eb2b3c2774$var$isRegExp(expected)) return expected.test(actual); // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new $dc3640eb2b3c2774$var$ERR_INVALID_ARG_TYPE('expected', [
            'Function',
            'RegExp'
        ], expected);
         // Handle primitives properly.
        if ($dc3640eb2b3c2774$var$_typeof(actual) !== 'object' || actual === null) {
            var err = new $5uJGS({
                actual: actual,
                expected: expected,
                message: msg,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected); // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push('name', 'message');
        else if (keys.length === 0) throw new $dc3640eb2b3c2774$var$ERR_INVALID_ARG_VALUE('error', expected, 'may not be an empty object');
        if ($dc3640eb2b3c2774$var$isDeepEqual === undefined) $dc3640eb2b3c2774$var$lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === 'string' && $dc3640eb2b3c2774$var$isRegExp(expected[key]) && expected[key].test(actual[key])) return;
            $dc3640eb2b3c2774$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    } // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function $dc3640eb2b3c2774$var$getActual(fn) {
    if (typeof fn !== 'function') throw new $dc3640eb2b3c2774$var$ERR_INVALID_ARG_TYPE('fn', 'Function', fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return $dc3640eb2b3c2774$var$NO_EXCEPTION_SENTINEL;
}
function $dc3640eb2b3c2774$var$checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return $dc3640eb2b3c2774$var$isPromise(obj) || obj !== null && $dc3640eb2b3c2774$var$_typeof(obj) === 'object' && typeof obj.then === 'function' && typeof obj.catch === 'function';
}
function $dc3640eb2b3c2774$var$waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === 'function') {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn(); // Fail in case no promise is returned.
            if (!$dc3640eb2b3c2774$var$checkIsPromise(resultPromise)) throw new $dc3640eb2b3c2774$var$ERR_INVALID_RETURN_VALUE('instance of Promise', 'promiseFn', resultPromise);
        } else if ($dc3640eb2b3c2774$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new $dc3640eb2b3c2774$var$ERR_INVALID_ARG_TYPE('promiseFn', [
            'Function',
            'Promise'
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return $dc3640eb2b3c2774$var$NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function $dc3640eb2b3c2774$var$expectsError(stackStartFn, actual, error, message) {
    if (typeof error === 'string') {
        if (arguments.length === 4) throw new $dc3640eb2b3c2774$var$ERR_INVALID_ARG_TYPE('error', [
            'Object',
            'Error',
            'Function',
            'RegExp'
        ], error);
        if ($dc3640eb2b3c2774$var$_typeof(actual) === 'object' && actual !== null) {
            if (actual.message === error) throw new $dc3640eb2b3c2774$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error message \"".concat(actual.message, "\" is identical to the message."));
        } else if (actual === error) throw new $dc3640eb2b3c2774$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error \"".concat(actual, "\" is identical to the message."));
        message = error;
        error = undefined;
    } else if (error != null && $dc3640eb2b3c2774$var$_typeof(error) !== 'object' && typeof error !== 'function') throw new $dc3640eb2b3c2774$var$ERR_INVALID_ARG_TYPE('error', [
        'Object',
        'Error',
        'Function',
        'RegExp'
    ], error);
    if (actual === $dc3640eb2b3c2774$var$NO_EXCEPTION_SENTINEL) {
        var details = '';
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'rejects' ? 'rejection' : 'exception';
        $dc3640eb2b3c2774$var$innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !$dc3640eb2b3c2774$var$expectedException(actual, error, message, stackStartFn)) throw actual;
}
function $dc3640eb2b3c2774$var$expectsNoError(stackStartFn, actual, error, message) {
    if (actual === $dc3640eb2b3c2774$var$NO_EXCEPTION_SENTINEL) return;
    if (typeof error === 'string') {
        message = error;
        error = undefined;
    }
    if (!error || $dc3640eb2b3c2774$var$expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'doesNotReject' ? 'rejection' : 'exception';
        $dc3640eb2b3c2774$var$innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + "Actual message: \"".concat(actual && actual.message, "\""),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
$dc3640eb2b3c2774$var$assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    $dc3640eb2b3c2774$var$expectsError.apply(void 0, [
        throws,
        $dc3640eb2b3c2774$var$getActual(promiseFn)
    ].concat(args));
};
$dc3640eb2b3c2774$var$assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $dc3640eb2b3c2774$var$waitForActual(promiseFn).then(function(result) {
        return $dc3640eb2b3c2774$var$expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
$dc3640eb2b3c2774$var$assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    $dc3640eb2b3c2774$var$expectsNoError.apply(void 0, [
        doesNotThrow,
        $dc3640eb2b3c2774$var$getActual(fn)
    ].concat(args));
};
$dc3640eb2b3c2774$var$assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $dc3640eb2b3c2774$var$waitForActual(fn).then(function(result) {
        return $dc3640eb2b3c2774$var$expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
$dc3640eb2b3c2774$var$assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = 'ifError got unwanted exception: ';
        if ($dc3640eb2b3c2774$var$_typeof(err) === 'object' && typeof err.message === 'string') {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += $dc3640eb2b3c2774$var$inspect(err);
        var newErr = new $5uJGS({
            actual: err,
            expected: null,
            operator: 'ifError',
            message: message,
            stackStartFn: ifError
        }); // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === 'string') {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split('\n');
            tmp2.shift(); // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split('\n');
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join('\n'), "\n").concat(tmp2.join('\n'));
        }
        throw newErr;
    }
}; // Expose a strict only variant of assert
function $dc3640eb2b3c2774$var$strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    $dc3640eb2b3c2774$var$innerOk.apply(void 0, [
        $dc3640eb2b3c2774$var$strict,
        args.length
    ].concat(args));
}
$dc3640eb2b3c2774$var$assert.strict = $dc3640eb2b3c2774$var$objectAssign($dc3640eb2b3c2774$var$strict, $dc3640eb2b3c2774$var$assert, {
    equal: $dc3640eb2b3c2774$var$assert.strictEqual,
    deepEqual: $dc3640eb2b3c2774$var$assert.deepStrictEqual,
    notEqual: $dc3640eb2b3c2774$var$assert.notStrictEqual,
    notDeepEqual: $dc3640eb2b3c2774$var$assert.notDeepStrictEqual
});
$dc3640eb2b3c2774$var$assert.strict.strict = $dc3640eb2b3c2774$var$assert.strict;

});
parcelRegister("aPz4L", function(module, exports) {

$parcel$export(module.exports, "codes", function () { return $7e29e022413f1595$export$e45cb6485273080e; }, function (v) { return $7e29e022413f1595$export$e45cb6485273080e = v; });
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ var $7e29e022413f1595$export$e45cb6485273080e;
'use strict'; // The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function $7e29e022413f1595$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $7e29e022413f1595$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $7e29e022413f1595$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $7e29e022413f1595$var$_typeof(obj);
}
function $7e29e022413f1595$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7e29e022413f1595$var$_possibleConstructorReturn(self, call) {
    if (call && ($7e29e022413f1595$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $7e29e022413f1595$var$_assertThisInitialized(self);
}
function $7e29e022413f1595$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $7e29e022413f1595$var$_getPrototypeOf(o) {
    $7e29e022413f1595$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $7e29e022413f1595$var$_getPrototypeOf(o);
}
function $7e29e022413f1595$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $7e29e022413f1595$var$_setPrototypeOf(subClass, superClass);
}
function $7e29e022413f1595$var$_setPrototypeOf(o, p) {
    $7e29e022413f1595$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7e29e022413f1595$var$_setPrototypeOf(o, p);
}
var $7e29e022413f1595$var$codes = {}; // Lazy loaded
var $7e29e022413f1595$var$assert;
var $7e29e022413f1595$var$util;
function $7e29e022413f1595$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $7e29e022413f1595$var$_inherits(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            $7e29e022413f1595$var$_classCallCheck(this, NodeError);
            _this = $7e29e022413f1595$var$_possibleConstructorReturn(this, $7e29e022413f1595$var$_getPrototypeOf(NodeError).call(this, getMessage(arg1, arg2, arg3)));
            _this.code = code;
            return _this;
        }
        return NodeError;
    }(Base);
    $7e29e022413f1595$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $7e29e022413f1595$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $7e29e022413f1595$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $7e29e022413f1595$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $7e29e022413f1595$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$7e29e022413f1595$var$createErrorType('ERR_AMBIGUOUS_ARGUMENT', 'The "%s" argument is ambiguous. %s', TypeError);

$7e29e022413f1595$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    if ($7e29e022413f1595$var$assert === undefined) $7e29e022413f1595$var$assert = (parcelRequire("iUbla"));
    $7e29e022413f1595$var$assert(typeof name === 'string', "'name' must be a string"); // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $7e29e022413f1595$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($7e29e022413f1595$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($7e29e022413f1595$var$oneOf(expected, 'type'));
    else {
        var type = $7e29e022413f1595$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($7e29e022413f1595$var$oneOf(expected, 'type'));
    } // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat($7e29e022413f1595$var$_typeof(actual));
    return msg;
}, TypeError);

$7e29e022413f1595$var$createErrorType('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'is invalid';
    if ($7e29e022413f1595$var$util === undefined) $7e29e022413f1595$var$util = (parcelRequire("lmEzn"));
    var inspected = $7e29e022413f1595$var$util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
$7e29e022413f1595$var$createErrorType('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat($7e29e022413f1595$var$_typeof(value));
    return "Expected ".concat(input, " to be returned from the \"").concat(name, "\"") + " function but got ".concat(type, ".");
}, TypeError);

$7e29e022413f1595$var$createErrorType('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if ($7e29e022413f1595$var$assert === undefined) $7e29e022413f1595$var$assert = (parcelRequire("iUbla"));
    $7e29e022413f1595$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg = 'The ';
    var len = args.length;
    args = args.map(function(a) {
        return "\"".concat(a, "\"");
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(', ');
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$7e29e022413f1595$export$e45cb6485273080e = $7e29e022413f1595$var$codes;

});
parcelRegister("lmEzn", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $kavLi = parcelRequire("kavLi");
var $f8db1f54c966a8ef$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $f8db1f54c966a8ef$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$f8db1f54c966a8ef$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($f8db1f54c966a8ef$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($f8db1f54c966a8ef$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($f8db1f54c966a8ef$var$isNull(x) || !$f8db1f54c966a8ef$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $f8db1f54c966a8ef$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    var warned;
    return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    function deprecated() {
        if (!warned) {
            if ($kavLi.throwDeprecation) throw new Error(msg);
            else if ($kavLi.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
};
var $f8db1f54c966a8ef$var$debugs = {};
var $f8db1f54c966a8ef$var$debugEnvRegex = /^$/;
var $f8db1f54c966a8ef$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$f8db1f54c966a8ef$var$debugs[set]) {
        if ($f8db1f54c966a8ef$var$debugEnvRegex.test(set)) {
            var pid = $kavLi.pid;
            $f8db1f54c966a8ef$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $f8db1f54c966a8ef$var$debugs[set] = function() {};
    }
    return $f8db1f54c966a8ef$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $f8db1f54c966a8ef$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $f8db1f54c966a8ef$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($f8db1f54c966a8ef$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($f8db1f54c966a8ef$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($f8db1f54c966a8ef$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($f8db1f54c966a8ef$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($f8db1f54c966a8ef$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $f8db1f54c966a8ef$var$stylizeWithColor;
    return $f8db1f54c966a8ef$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $f8db1f54c966a8ef$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$f8db1f54c966a8ef$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$f8db1f54c966a8ef$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $f8db1f54c966a8ef$var$stylizeWithColor(str, styleType) {
    var style = $f8db1f54c966a8ef$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $f8db1f54c966a8ef$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $f8db1f54c966a8ef$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $f8db1f54c966a8ef$var$stylizeNoColor(str, styleType) {
    return str;
}
function $f8db1f54c966a8ef$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $f8db1f54c966a8ef$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $f8db1f54c966a8ef$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$f8db1f54c966a8ef$var$isString(ret)) ret = $f8db1f54c966a8ef$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $f8db1f54c966a8ef$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $f8db1f54c966a8ef$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($f8db1f54c966a8ef$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $f8db1f54c966a8ef$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($f8db1f54c966a8ef$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($f8db1f54c966a8ef$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($f8db1f54c966a8ef$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($f8db1f54c966a8ef$var$isError(value)) return $f8db1f54c966a8ef$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($f8db1f54c966a8ef$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($f8db1f54c966a8ef$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($f8db1f54c966a8ef$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($f8db1f54c966a8ef$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($f8db1f54c966a8ef$var$isError(value)) base = ' ' + $f8db1f54c966a8ef$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($f8db1f54c966a8ef$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $f8db1f54c966a8ef$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $f8db1f54c966a8ef$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $f8db1f54c966a8ef$var$reduceToSingleString(output, base, braces);
}
function $f8db1f54c966a8ef$var$formatPrimitive(ctx, value) {
    if ($f8db1f54c966a8ef$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($f8db1f54c966a8ef$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($f8db1f54c966a8ef$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($f8db1f54c966a8ef$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($f8db1f54c966a8ef$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $f8db1f54c966a8ef$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $f8db1f54c966a8ef$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($f8db1f54c966a8ef$var$hasOwnProperty(value, String(i))) output.push($f8db1f54c966a8ef$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($f8db1f54c966a8ef$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $f8db1f54c966a8ef$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$f8db1f54c966a8ef$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($f8db1f54c966a8ef$var$isNull(recurseTimes)) str = $f8db1f54c966a8ef$var$formatValue(ctx, desc.value, null);
            else str = $f8db1f54c966a8ef$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').substr(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($f8db1f54c966a8ef$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.substr(1, name.length - 2);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $f8db1f54c966a8ef$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("6gnjp"));
function $f8db1f54c966a8ef$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $f8db1f54c966a8ef$var$isArray;
function $f8db1f54c966a8ef$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $f8db1f54c966a8ef$var$isBoolean;
function $f8db1f54c966a8ef$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $f8db1f54c966a8ef$var$isNull;
function $f8db1f54c966a8ef$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $f8db1f54c966a8ef$var$isNullOrUndefined;
function $f8db1f54c966a8ef$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $f8db1f54c966a8ef$var$isNumber;
function $f8db1f54c966a8ef$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $f8db1f54c966a8ef$var$isString;
function $f8db1f54c966a8ef$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
module.exports.isSymbol = $f8db1f54c966a8ef$var$isSymbol;
function $f8db1f54c966a8ef$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $f8db1f54c966a8ef$var$isUndefined;
function $f8db1f54c966a8ef$var$isRegExp(re) {
    return $f8db1f54c966a8ef$var$isObject(re) && $f8db1f54c966a8ef$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $f8db1f54c966a8ef$var$isRegExp;
module.exports.types.isRegExp = $f8db1f54c966a8ef$var$isRegExp;
function $f8db1f54c966a8ef$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
module.exports.isObject = $f8db1f54c966a8ef$var$isObject;
function $f8db1f54c966a8ef$var$isDate(d) {
    return $f8db1f54c966a8ef$var$isObject(d) && $f8db1f54c966a8ef$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $f8db1f54c966a8ef$var$isDate;
module.exports.types.isDate = $f8db1f54c966a8ef$var$isDate;
function $f8db1f54c966a8ef$var$isError(e) {
    return $f8db1f54c966a8ef$var$isObject(e) && ($f8db1f54c966a8ef$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $f8db1f54c966a8ef$var$isError;
module.exports.types.isNativeError = $f8db1f54c966a8ef$var$isError;
function $f8db1f54c966a8ef$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $f8db1f54c966a8ef$var$isFunction;
function $f8db1f54c966a8ef$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $f8db1f54c966a8ef$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("mdj9S"));
function $f8db1f54c966a8ef$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $f8db1f54c966a8ef$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $f8db1f54c966a8ef$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $f8db1f54c966a8ef$var$timestamp() {
    var d = new Date();
    var time = [
        $f8db1f54c966a8ef$var$pad(d.getHours()),
        $f8db1f54c966a8ef$var$pad(d.getMinutes()),
        $f8db1f54c966a8ef$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $f8db1f54c966a8ef$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $f8db1f54c966a8ef$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("e10SE"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$f8db1f54c966a8ef$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $f8db1f54c966a8ef$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $f8db1f54c966a8ef$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($f8db1f54c966a8ef$var$kCustomPromisifiedSymbol && original[$f8db1f54c966a8ef$var$kCustomPromisifiedSymbol]) {
        var fn = original[$f8db1f54c966a8ef$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $f8db1f54c966a8ef$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($f8db1f54c966a8ef$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $f8db1f54c966a8ef$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $f8db1f54c966a8ef$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $f8db1f54c966a8ef$var$kCustomPromisifiedSymbol;
function $f8db1f54c966a8ef$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $f8db1f54c966a8ef$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $kavLi.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $kavLi.nextTick($f8db1f54c966a8ef$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $f8db1f54c966a8ef$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $f8db1f54c966a8ef$var$callbackify;

});
parcelRegister("6gnjp", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $bebu9 = parcelRequire("bebu9");

var $h0MTa = parcelRequire("h0MTa");

var $6yzZE = parcelRequire("6yzZE");

var $4sYF9 = parcelRequire("4sYF9");
function $48f652035112774e$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $48f652035112774e$var$BigIntSupported = typeof BigInt !== 'undefined';
var $48f652035112774e$var$SymbolSupported = typeof Symbol !== 'undefined';
var $48f652035112774e$var$ObjectToString = $48f652035112774e$var$uncurryThis(Object.prototype.toString);
var $48f652035112774e$var$numberValue = $48f652035112774e$var$uncurryThis(Number.prototype.valueOf);
var $48f652035112774e$var$stringValue = $48f652035112774e$var$uncurryThis(String.prototype.valueOf);
var $48f652035112774e$var$booleanValue = $48f652035112774e$var$uncurryThis(Boolean.prototype.valueOf);
if ($48f652035112774e$var$BigIntSupported) var $48f652035112774e$var$bigIntValue = $48f652035112774e$var$uncurryThis(BigInt.prototype.valueOf);
if ($48f652035112774e$var$SymbolSupported) var $48f652035112774e$var$symbolValue = $48f652035112774e$var$uncurryThis(Symbol.prototype.valueOf);
function $48f652035112774e$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $bebu9;
module.exports.isGeneratorFunction = $h0MTa;
module.exports.isTypedArray = $4sYF9;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $48f652035112774e$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $48f652035112774e$var$isPromise;
function $48f652035112774e$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $4sYF9(value) || $48f652035112774e$var$isDataView(value);
}
module.exports.isArrayBufferView = $48f652035112774e$var$isArrayBufferView;
function $48f652035112774e$var$isUint8Array(value) {
    return $6yzZE(value) === 'Uint8Array';
}
module.exports.isUint8Array = $48f652035112774e$var$isUint8Array;
function $48f652035112774e$var$isUint8ClampedArray(value) {
    return $6yzZE(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $48f652035112774e$var$isUint8ClampedArray;
function $48f652035112774e$var$isUint16Array(value) {
    return $6yzZE(value) === 'Uint16Array';
}
module.exports.isUint16Array = $48f652035112774e$var$isUint16Array;
function $48f652035112774e$var$isUint32Array(value) {
    return $6yzZE(value) === 'Uint32Array';
}
module.exports.isUint32Array = $48f652035112774e$var$isUint32Array;
function $48f652035112774e$var$isInt8Array(value) {
    return $6yzZE(value) === 'Int8Array';
}
module.exports.isInt8Array = $48f652035112774e$var$isInt8Array;
function $48f652035112774e$var$isInt16Array(value) {
    return $6yzZE(value) === 'Int16Array';
}
module.exports.isInt16Array = $48f652035112774e$var$isInt16Array;
function $48f652035112774e$var$isInt32Array(value) {
    return $6yzZE(value) === 'Int32Array';
}
module.exports.isInt32Array = $48f652035112774e$var$isInt32Array;
function $48f652035112774e$var$isFloat32Array(value) {
    return $6yzZE(value) === 'Float32Array';
}
module.exports.isFloat32Array = $48f652035112774e$var$isFloat32Array;
function $48f652035112774e$var$isFloat64Array(value) {
    return $6yzZE(value) === 'Float64Array';
}
module.exports.isFloat64Array = $48f652035112774e$var$isFloat64Array;
function $48f652035112774e$var$isBigInt64Array(value) {
    return $6yzZE(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $48f652035112774e$var$isBigInt64Array;
function $48f652035112774e$var$isBigUint64Array(value) {
    return $6yzZE(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $48f652035112774e$var$isBigUint64Array;
function $48f652035112774e$var$isMapToString(value) {
    return $48f652035112774e$var$ObjectToString(value) === '[object Map]';
}
$48f652035112774e$var$isMapToString.working = typeof Map !== 'undefined' && $48f652035112774e$var$isMapToString(new Map());
function $48f652035112774e$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $48f652035112774e$var$isMapToString.working ? $48f652035112774e$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $48f652035112774e$var$isMap;
function $48f652035112774e$var$isSetToString(value) {
    return $48f652035112774e$var$ObjectToString(value) === '[object Set]';
}
$48f652035112774e$var$isSetToString.working = typeof Set !== 'undefined' && $48f652035112774e$var$isSetToString(new Set());
function $48f652035112774e$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $48f652035112774e$var$isSetToString.working ? $48f652035112774e$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $48f652035112774e$var$isSet;
function $48f652035112774e$var$isWeakMapToString(value) {
    return $48f652035112774e$var$ObjectToString(value) === '[object WeakMap]';
}
$48f652035112774e$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $48f652035112774e$var$isWeakMapToString(new WeakMap());
function $48f652035112774e$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $48f652035112774e$var$isWeakMapToString.working ? $48f652035112774e$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $48f652035112774e$var$isWeakMap;
function $48f652035112774e$var$isWeakSetToString(value) {
    return $48f652035112774e$var$ObjectToString(value) === '[object WeakSet]';
}
$48f652035112774e$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $48f652035112774e$var$isWeakSetToString(new WeakSet());
function $48f652035112774e$var$isWeakSet(value) {
    return $48f652035112774e$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $48f652035112774e$var$isWeakSet;
function $48f652035112774e$var$isArrayBufferToString(value) {
    return $48f652035112774e$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$48f652035112774e$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $48f652035112774e$var$isArrayBufferToString(new ArrayBuffer());
function $48f652035112774e$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $48f652035112774e$var$isArrayBufferToString.working ? $48f652035112774e$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $48f652035112774e$var$isArrayBuffer;
function $48f652035112774e$var$isDataViewToString(value) {
    return $48f652035112774e$var$ObjectToString(value) === '[object DataView]';
}
$48f652035112774e$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $48f652035112774e$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $48f652035112774e$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $48f652035112774e$var$isDataViewToString.working ? $48f652035112774e$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $48f652035112774e$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $48f652035112774e$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $48f652035112774e$var$isSharedArrayBufferToString(value) {
    return $48f652035112774e$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $48f652035112774e$var$isSharedArrayBuffer(value) {
    if (typeof $48f652035112774e$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $48f652035112774e$var$isSharedArrayBufferToString.working === 'undefined') $48f652035112774e$var$isSharedArrayBufferToString.working = $48f652035112774e$var$isSharedArrayBufferToString(new $48f652035112774e$var$SharedArrayBufferCopy());
    return $48f652035112774e$var$isSharedArrayBufferToString.working ? $48f652035112774e$var$isSharedArrayBufferToString(value) : value instanceof $48f652035112774e$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $48f652035112774e$var$isSharedArrayBuffer;
function $48f652035112774e$var$isAsyncFunction(value) {
    return $48f652035112774e$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $48f652035112774e$var$isAsyncFunction;
function $48f652035112774e$var$isMapIterator(value) {
    return $48f652035112774e$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $48f652035112774e$var$isMapIterator;
function $48f652035112774e$var$isSetIterator(value) {
    return $48f652035112774e$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $48f652035112774e$var$isSetIterator;
function $48f652035112774e$var$isGeneratorObject(value) {
    return $48f652035112774e$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $48f652035112774e$var$isGeneratorObject;
function $48f652035112774e$var$isWebAssemblyCompiledModule(value) {
    return $48f652035112774e$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $48f652035112774e$var$isWebAssemblyCompiledModule;
function $48f652035112774e$var$isNumberObject(value) {
    return $48f652035112774e$var$checkBoxedPrimitive(value, $48f652035112774e$var$numberValue);
}
module.exports.isNumberObject = $48f652035112774e$var$isNumberObject;
function $48f652035112774e$var$isStringObject(value) {
    return $48f652035112774e$var$checkBoxedPrimitive(value, $48f652035112774e$var$stringValue);
}
module.exports.isStringObject = $48f652035112774e$var$isStringObject;
function $48f652035112774e$var$isBooleanObject(value) {
    return $48f652035112774e$var$checkBoxedPrimitive(value, $48f652035112774e$var$booleanValue);
}
module.exports.isBooleanObject = $48f652035112774e$var$isBooleanObject;
function $48f652035112774e$var$isBigIntObject(value) {
    return $48f652035112774e$var$BigIntSupported && $48f652035112774e$var$checkBoxedPrimitive(value, $48f652035112774e$var$bigIntValue);
}
module.exports.isBigIntObject = $48f652035112774e$var$isBigIntObject;
function $48f652035112774e$var$isSymbolObject(value) {
    return $48f652035112774e$var$SymbolSupported && $48f652035112774e$var$checkBoxedPrimitive(value, $48f652035112774e$var$symbolValue);
}
module.exports.isSymbolObject = $48f652035112774e$var$isSymbolObject;
function $48f652035112774e$var$isBoxedPrimitive(value) {
    return $48f652035112774e$var$isNumberObject(value) || $48f652035112774e$var$isStringObject(value) || $48f652035112774e$var$isBooleanObject(value) || $48f652035112774e$var$isBigIntObject(value) || $48f652035112774e$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $48f652035112774e$var$isBoxedPrimitive;
function $48f652035112774e$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($48f652035112774e$var$isArrayBuffer(value) || $48f652035112774e$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $48f652035112774e$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});
parcelRegister("6yzZE", function(module, exports) {
'use strict';

var $9ikBS = parcelRequire("9ikBS");

var $8O01H = parcelRequire("8O01H");

var $f5egT = parcelRequire("f5egT");
var $4c61d6963d464c83$var$$toString = $f5egT('Object.prototype.toString');

var $4c61d6963d464c83$var$hasToStringTag = (parcelRequire("45DaP"))();
var $4c61d6963d464c83$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $4c61d6963d464c83$var$typedArrays = $8O01H();
var $4c61d6963d464c83$var$$slice = $f5egT('String.prototype.slice');
var $4c61d6963d464c83$var$toStrTags = {};

var $5aB0C = parcelRequire("5aB0C");
var $4c61d6963d464c83$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
if ($4c61d6963d464c83$var$hasToStringTag && $5aB0C && $4c61d6963d464c83$var$getPrototypeOf) $9ikBS($4c61d6963d464c83$var$typedArrays, function(typedArray) {
    if (typeof $4c61d6963d464c83$var$g[typedArray] === 'function') {
        var arr = new $4c61d6963d464c83$var$g[typedArray]();
        if (Symbol.toStringTag in arr) {
            var proto = $4c61d6963d464c83$var$getPrototypeOf(arr);
            var descriptor = $5aB0C(proto, Symbol.toStringTag);
            if (!descriptor) {
                var superProto = $4c61d6963d464c83$var$getPrototypeOf(proto);
                descriptor = $5aB0C(superProto, Symbol.toStringTag);
            }
            $4c61d6963d464c83$var$toStrTags[typedArray] = descriptor.get;
        }
    }
});
var $4c61d6963d464c83$var$tryTypedArrays = function tryAllTypedArrays(value) {
    var foundName = false;
    $9ikBS($4c61d6963d464c83$var$toStrTags, function(getter, typedArray) {
        if (!foundName) try {
            var name = getter.call(value);
            if (name === typedArray) foundName = name;
        } catch (e) {}
    });
    return foundName;
};

var $4sYF9 = parcelRequire("4sYF9");
module.exports = function whichTypedArray(value) {
    if (!$4sYF9(value)) return false;
    if (!$4c61d6963d464c83$var$hasToStringTag || !(Symbol.toStringTag in value)) return $4c61d6963d464c83$var$$slice($4c61d6963d464c83$var$$toString(value), 8, -1);
    return $4c61d6963d464c83$var$tryTypedArrays(value);
};

});
parcelRegister("8O01H", function(module, exports) {
'use strict';
var $6693037cdb4fdc47$var$possibleNames = [
    'BigInt64Array',
    'BigUint64Array',
    'Float32Array',
    'Float64Array',
    'Int16Array',
    'Int32Array',
    'Int8Array',
    'Uint16Array',
    'Uint32Array',
    'Uint8Array',
    'Uint8ClampedArray'
];
var $6693037cdb4fdc47$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
module.exports = function availableTypedArrays() {
    var out = [];
    for(var i = 0; i < $6693037cdb4fdc47$var$possibleNames.length; i++)if (typeof $6693037cdb4fdc47$var$g[$6693037cdb4fdc47$var$possibleNames[i]] === 'function') out[out.length] = $6693037cdb4fdc47$var$possibleNames[i];
    return out;
};

});

parcelRegister("45DaP", function(module, exports) {
'use strict';

var $2m7yB = parcelRequire("2m7yB");
module.exports = function hasToStringTagShams() {
    return $2m7yB() && !!Symbol.toStringTag;
};

});

parcelRegister("5aB0C", function(module, exports) {
'use strict';

var $6qVPC = parcelRequire("6qVPC");
var $3c3a982353c5602a$var$$gOPD = $6qVPC('%Object.getOwnPropertyDescriptor%', true);
if ($3c3a982353c5602a$var$$gOPD) try {
    $3c3a982353c5602a$var$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $3c3a982353c5602a$var$$gOPD = null;
}
module.exports = $3c3a982353c5602a$var$$gOPD;

});
parcelRegister("6qVPC", function(module, exports) {
'use strict';
var $4af207f187f7a256$var$undefined1;
var $4af207f187f7a256$var$$SyntaxError = SyntaxError;
var $4af207f187f7a256$var$$Function = Function;
var $4af207f187f7a256$var$$TypeError = TypeError;
// eslint-disable-next-line consistent-return
var $4af207f187f7a256$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $4af207f187f7a256$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};
var $4af207f187f7a256$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($4af207f187f7a256$var$$gOPD) try {
    $4af207f187f7a256$var$$gOPD({}, '');
} catch (e) {
    $4af207f187f7a256$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $4af207f187f7a256$var$throwTypeError = function() {
    throw new $4af207f187f7a256$var$$TypeError();
};
var $4af207f187f7a256$var$ThrowTypeError = $4af207f187f7a256$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $4af207f187f7a256$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $4af207f187f7a256$var$$gOPD(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $4af207f187f7a256$var$throwTypeError;
        }
    }
}() : $4af207f187f7a256$var$throwTypeError;

var $4af207f187f7a256$var$hasSymbols = (parcelRequire("hLfix"))();
var $4af207f187f7a256$var$getProto = Object.getPrototypeOf || function(x) {
    return x.__proto__;
}; // eslint-disable-line no-proto
var $4af207f187f7a256$var$needsEval = {};
var $4af207f187f7a256$var$TypedArray = typeof Uint8Array === 'undefined' ? undefined : $4af207f187f7a256$var$getProto(Uint8Array);
var $4af207f187f7a256$var$INTRINSICS = {
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $4af207f187f7a256$var$hasSymbols ? $4af207f187f7a256$var$getProto([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $4af207f187f7a256$var$needsEval,
    '%AsyncGenerator%': $4af207f187f7a256$var$needsEval,
    '%AsyncGeneratorFunction%': $4af207f187f7a256$var$needsEval,
    '%AsyncIteratorPrototype%': $4af207f187f7a256$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': Error,
    '%eval%': eval,
    '%EvalError%': EvalError,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $4af207f187f7a256$var$$Function,
    '%GeneratorFunction%': $4af207f187f7a256$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $4af207f187f7a256$var$hasSymbols ? $4af207f187f7a256$var$getProto($4af207f187f7a256$var$getProto([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$4af207f187f7a256$var$hasSymbols ? undefined : $4af207f187f7a256$var$getProto(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': Object,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': RangeError,
    '%ReferenceError%': ReferenceError,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$4af207f187f7a256$var$hasSymbols ? undefined : $4af207f187f7a256$var$getProto(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $4af207f187f7a256$var$hasSymbols ? $4af207f187f7a256$var$getProto(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $4af207f187f7a256$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $4af207f187f7a256$var$$SyntaxError,
    '%ThrowTypeError%': $4af207f187f7a256$var$ThrowTypeError,
    '%TypedArray%': $4af207f187f7a256$var$TypedArray,
    '%TypeError%': $4af207f187f7a256$var$$TypeError,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': URIError,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};
var $4af207f187f7a256$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $4af207f187f7a256$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $4af207f187f7a256$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $4af207f187f7a256$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen) value = $4af207f187f7a256$var$getProto(gen.prototype);
    }
    $4af207f187f7a256$var$INTRINSICS[name] = value;
    return value;
};
var $4af207f187f7a256$var$LEGACY_ALIASES = {
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $1tVKm = parcelRequire("1tVKm");

var $7HQeL = parcelRequire("7HQeL");
var $4af207f187f7a256$var$$concat = $1tVKm.call(Function.call, Array.prototype.concat);
var $4af207f187f7a256$var$$spliceApply = $1tVKm.call(Function.apply, Array.prototype.splice);
var $4af207f187f7a256$var$$replace = $1tVKm.call(Function.call, String.prototype.replace);
var $4af207f187f7a256$var$$strSlice = $1tVKm.call(Function.call, String.prototype.slice);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $4af207f187f7a256$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $4af207f187f7a256$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $4af207f187f7a256$var$stringToPath = function stringToPath(string) {
    var first = $4af207f187f7a256$var$$strSlice(string, 0, 1);
    var last = $4af207f187f7a256$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $4af207f187f7a256$var$$SyntaxError('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $4af207f187f7a256$var$$SyntaxError('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $4af207f187f7a256$var$$replace(string, $4af207f187f7a256$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $4af207f187f7a256$var$$replace(subString, $4af207f187f7a256$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $4af207f187f7a256$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($7HQeL($4af207f187f7a256$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $4af207f187f7a256$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($7HQeL($4af207f187f7a256$var$INTRINSICS, intrinsicName)) {
        var value = $4af207f187f7a256$var$INTRINSICS[intrinsicName];
        if (value === $4af207f187f7a256$var$needsEval) value = $4af207f187f7a256$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $4af207f187f7a256$var$$TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $4af207f187f7a256$var$$SyntaxError('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $4af207f187f7a256$var$$TypeError('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $4af207f187f7a256$var$$TypeError('"allowMissing" argument must be a boolean');
    var parts = $4af207f187f7a256$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $4af207f187f7a256$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $4af207f187f7a256$var$$spliceApply(parts, $4af207f187f7a256$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $4af207f187f7a256$var$$strSlice(part, 0, 1);
        var last = $4af207f187f7a256$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $4af207f187f7a256$var$$SyntaxError('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($7HQeL($4af207f187f7a256$var$INTRINSICS, intrinsicRealName)) value = $4af207f187f7a256$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $4af207f187f7a256$var$$TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($4af207f187f7a256$var$$gOPD && i + 1 >= parts.length) {
                var desc = $4af207f187f7a256$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $7HQeL(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $4af207f187f7a256$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});


parcelRegister("4sYF9", function(module, exports) {
'use strict';

var $9ikBS = parcelRequire("9ikBS");

var $8O01H = parcelRequire("8O01H");

var $f5egT = parcelRequire("f5egT");
var $3408d547978a7100$var$$toString = $f5egT('Object.prototype.toString');

var $3408d547978a7100$var$hasToStringTag = (parcelRequire("45DaP"))();
var $3408d547978a7100$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $3408d547978a7100$var$typedArrays = $8O01H();
var $3408d547978a7100$var$$indexOf = $f5egT('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
var $3408d547978a7100$var$$slice = $f5egT('String.prototype.slice');
var $3408d547978a7100$var$toStrTags = {};

var $5aB0C = parcelRequire("5aB0C");
var $3408d547978a7100$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
if ($3408d547978a7100$var$hasToStringTag && $5aB0C && $3408d547978a7100$var$getPrototypeOf) $9ikBS($3408d547978a7100$var$typedArrays, function(typedArray) {
    var arr = new $3408d547978a7100$var$g[typedArray]();
    if (Symbol.toStringTag in arr) {
        var proto = $3408d547978a7100$var$getPrototypeOf(arr);
        var descriptor = $5aB0C(proto, Symbol.toStringTag);
        if (!descriptor) {
            var superProto = $3408d547978a7100$var$getPrototypeOf(proto);
            descriptor = $5aB0C(superProto, Symbol.toStringTag);
        }
        $3408d547978a7100$var$toStrTags[typedArray] = descriptor.get;
    }
});
var $3408d547978a7100$var$tryTypedArrays = function tryAllTypedArrays(value) {
    var anyTrue = false;
    $9ikBS($3408d547978a7100$var$toStrTags, function(getter, typedArray) {
        if (!anyTrue) try {
            anyTrue = getter.call(value) === typedArray;
        } catch (e) {}
    });
    return anyTrue;
};
module.exports = function isTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$3408d547978a7100$var$hasToStringTag || !(Symbol.toStringTag in value)) {
        var tag = $3408d547978a7100$var$$slice($3408d547978a7100$var$$toString(value), 8, -1);
        return $3408d547978a7100$var$$indexOf($3408d547978a7100$var$typedArrays, tag) > -1;
    }
    if (!$5aB0C) return false;
    return $3408d547978a7100$var$tryTypedArrays(value);
};

});



parcelRegister("mdj9S", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});



parcelRegister("5uJGS", function(module, exports) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c

var $kavLi = parcelRequire("kavLi");
'use strict';
function $40033248b1d1ceca$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $40033248b1d1ceca$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $40033248b1d1ceca$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $40033248b1d1ceca$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $40033248b1d1ceca$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $40033248b1d1ceca$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $40033248b1d1ceca$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $40033248b1d1ceca$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $40033248b1d1ceca$var$_possibleConstructorReturn(self, call) {
    if (call && ($40033248b1d1ceca$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $40033248b1d1ceca$var$_assertThisInitialized(self);
}
function $40033248b1d1ceca$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $40033248b1d1ceca$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $40033248b1d1ceca$var$_setPrototypeOf(subClass, superClass);
}
function $40033248b1d1ceca$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $40033248b1d1ceca$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$40033248b1d1ceca$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $40033248b1d1ceca$var$_construct(Class, arguments, $40033248b1d1ceca$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $40033248b1d1ceca$var$_setPrototypeOf(Wrapper, Class);
    };
    return $40033248b1d1ceca$var$_wrapNativeSuper(Class);
}
function $40033248b1d1ceca$var$isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $40033248b1d1ceca$var$_construct(Parent, args, Class) {
    if ($40033248b1d1ceca$var$isNativeReflectConstruct()) $40033248b1d1ceca$var$_construct = Reflect.construct;
    else $40033248b1d1ceca$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $40033248b1d1ceca$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $40033248b1d1ceca$var$_construct.apply(null, arguments);
}
function $40033248b1d1ceca$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $40033248b1d1ceca$var$_setPrototypeOf(o, p) {
    $40033248b1d1ceca$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $40033248b1d1ceca$var$_setPrototypeOf(o, p);
}
function $40033248b1d1ceca$var$_getPrototypeOf(o) {
    $40033248b1d1ceca$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $40033248b1d1ceca$var$_getPrototypeOf(o);
}
function $40033248b1d1ceca$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $40033248b1d1ceca$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $40033248b1d1ceca$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $40033248b1d1ceca$var$_typeof(obj);
}

var $lmEzn = parcelRequire("lmEzn");
var $40033248b1d1ceca$var$inspect = $lmEzn.inspect;

var $aPz4L = parcelRequire("aPz4L");
var $40033248b1d1ceca$var$ERR_INVALID_ARG_TYPE = $aPz4L.codes.ERR_INVALID_ARG_TYPE; // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $40033248b1d1ceca$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function $40033248b1d1ceca$var$repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return '';
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var $40033248b1d1ceca$var$blue = '';
var $40033248b1d1ceca$var$green = '';
var $40033248b1d1ceca$var$red = '';
var $40033248b1d1ceca$var$white = '';
var $40033248b1d1ceca$var$kReadableOperator = {
    deepStrictEqual: 'Expected values to be strictly deep-equal:',
    strictEqual: 'Expected values to be strictly equal:',
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: 'Expected values to be loosely deep-equal:',
    equal: 'Expected values to be loosely equal:',
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: 'Values identical but not reference-equal:'
}; // Comparing short primitives should just show === / !== instead of using the
// diff.
var $40033248b1d1ceca$var$kMaxShortLength = 10;
function $40033248b1d1ceca$var$copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, 'message', {
        value: source.message
    });
    return target;
}
function $40033248b1d1ceca$var$inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return $40033248b1d1ceca$var$inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function $40033248b1d1ceca$var$createErrDiff(actual, expected, operator) {
    var other = '';
    var res = '';
    var lastPos = 0;
    var end = '';
    var skipped = false;
    var actualInspected = $40033248b1d1ceca$var$inspectValue(actual);
    var actualLines = actualInspected.split('\n');
    var expectedLines = $40033248b1d1ceca$var$inspectValue(expected).split('\n');
    var i = 0;
    var indicator = ''; // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === 'strictEqual' && $40033248b1d1ceca$var$_typeof(actual) === 'object' && $40033248b1d1ceca$var$_typeof(expected) === 'object' && actual !== null && expected !== null) operator = 'strictEqualObject';
     // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length; // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= $40033248b1d1ceca$var$kMaxShortLength) {
            if (($40033248b1d1ceca$var$_typeof(actual) !== 'object' || actual === null) && ($40033248b1d1ceca$var$_typeof(expected) !== 'object' || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat($40033248b1d1ceca$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== 'strictEqualObject') {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = $kavLi.stderr && $kavLi.stderr.isTTY ? $kavLi.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                 // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat($40033248b1d1ceca$var$repeat(' ', i), "^");
                    i = 0;
                }
            }
        }
    } // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length); // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split('\n'); // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat($40033248b1d1ceca$var$blue, "...").concat($40033248b1d1ceca$var$white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat($40033248b1d1ceca$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join('\n'), "\n");
    }
    if (i > 3) {
        end = "\n".concat($40033248b1d1ceca$var$blue, "...").concat($40033248b1d1ceca$var$white).concat(end);
        skipped = true;
    }
    if (other !== '') {
        end = "\n  ".concat(other).concat(end);
        other = '';
    }
    var printedLines = 0;
    var msg = $40033248b1d1ceca$var$kReadableOperator[operator] + "\n".concat($40033248b1d1ceca$var$green, "+ actual").concat($40033248b1d1ceca$var$white, " ").concat($40033248b1d1ceca$var$red, "- expected").concat($40033248b1d1ceca$var$white);
    var skippedMsg = " ".concat($40033248b1d1ceca$var$blue, "...").concat($40033248b1d1ceca$var$white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($40033248b1d1ceca$var$blue, "...").concat($40033248b1d1ceca$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            } // Mark the current line as the last diverging one.
            lastPos = i; // Add the expected line to the cache.
            other += "\n".concat($40033248b1d1ceca$var$red, "-").concat($40033248b1d1ceca$var$white, " ").concat(expectedLines[i]);
            printedLines++; // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($40033248b1d1ceca$var$blue, "...").concat($40033248b1d1ceca$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            } // Mark the current line as the last diverging one.
            lastPos = i; // Add the actual line to the result.
            res += "\n".concat($40033248b1d1ceca$var$green, "+").concat($40033248b1d1ceca$var$white, " ").concat(actualLines[i]);
            printedLines++; // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i]; // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!$40033248b1d1ceca$var$endsWith(actualLine, ',') || actualLine.slice(0, -1) !== expectedLine); // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && $40033248b1d1ceca$var$endsWith(expectedLine, ',') && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ',';
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($40033248b1d1ceca$var$blue, "...").concat($40033248b1d1ceca$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                } // Mark the current line as the last diverging one.
                lastPos = i; // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat($40033248b1d1ceca$var$green, "+").concat($40033248b1d1ceca$var$white, " ").concat(actualLine);
                other += "\n".concat($40033248b1d1ceca$var$red, "-").concat($40033248b1d1ceca$var$white, " ").concat(expectedLine);
                printedLines += 2; // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = ''; // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        } // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($40033248b1d1ceca$var$blue, "...").concat($40033248b1d1ceca$var$white).concat(other, "\n") + "".concat($40033248b1d1ceca$var$blue, "...").concat($40033248b1d1ceca$var$white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : '', "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var $40033248b1d1ceca$var$AssertionError = /*#__PURE__*/ function(_Error) {
    $40033248b1d1ceca$var$_inherits(AssertionError, _Error);
    function AssertionError(options) {
        var _this;
        $40033248b1d1ceca$var$_classCallCheck(this, AssertionError);
        if ($40033248b1d1ceca$var$_typeof(options) !== 'object' || options === null) throw new $40033248b1d1ceca$var$ERR_INVALID_ARG_TYPE('options', 'Object', options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = $40033248b1d1ceca$var$_possibleConstructorReturn(this, $40033248b1d1ceca$var$_getPrototypeOf(AssertionError).call(this, String(message)));
        else {
            if ($kavLi.stderr && $kavLi.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if ($kavLi.stderr && $kavLi.stderr.getColorDepth && $kavLi.stderr.getColorDepth() !== 1) {
                    $40033248b1d1ceca$var$blue = "\x1B[34m";
                    $40033248b1d1ceca$var$green = "\x1B[32m";
                    $40033248b1d1ceca$var$white = "\x1B[39m";
                    $40033248b1d1ceca$var$red = "\x1B[31m";
                } else {
                    $40033248b1d1ceca$var$blue = '';
                    $40033248b1d1ceca$var$green = '';
                    $40033248b1d1ceca$var$white = '';
                    $40033248b1d1ceca$var$red = '';
                }
            } // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if ($40033248b1d1ceca$var$_typeof(actual) === 'object' && actual !== null && $40033248b1d1ceca$var$_typeof(expected) === 'object' && expected !== null && 'stack' in actual && actual instanceof Error && 'stack' in expected && expected instanceof Error) {
                actual = $40033248b1d1ceca$var$copyError(actual);
                expected = $40033248b1d1ceca$var$copyError(expected);
            }
            if (operator === 'deepStrictEqual' || operator === 'strictEqual') _this = $40033248b1d1ceca$var$_possibleConstructorReturn(this, $40033248b1d1ceca$var$_getPrototypeOf(AssertionError).call(this, $40033248b1d1ceca$var$createErrDiff(actual, expected, operator)));
            else if (operator === 'notDeepStrictEqual' || operator === 'notStrictEqual') {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = $40033248b1d1ceca$var$kReadableOperator[operator];
                var res = $40033248b1d1ceca$var$inspectValue(actual).split('\n'); // In case "actual" is an object, it should not be reference equal.
                if (operator === 'notStrictEqual' && $40033248b1d1ceca$var$_typeof(actual) === 'object' && actual !== null) base = $40033248b1d1ceca$var$kReadableOperator.notStrictEqualObject;
                 // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat($40033248b1d1ceca$var$blue, "...").concat($40033248b1d1ceca$var$white);
                    while(res.length > 27)res.pop();
                } // Only print a single input.
                if (res.length === 1) _this = $40033248b1d1ceca$var$_possibleConstructorReturn(this, $40033248b1d1ceca$var$_getPrototypeOf(AssertionError).call(this, "".concat(base, " ").concat(res[0])));
                else _this = $40033248b1d1ceca$var$_possibleConstructorReturn(this, $40033248b1d1ceca$var$_getPrototypeOf(AssertionError).call(this, "".concat(base, "\n\n").concat(res.join('\n'), "\n")));
            } else {
                var _res = $40033248b1d1ceca$var$inspectValue(actual);
                var other = '';
                var knownOperators = $40033248b1d1ceca$var$kReadableOperator[operator];
                if (operator === 'notDeepEqual' || operator === 'notEqual') {
                    _res = "".concat($40033248b1d1ceca$var$kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat($40033248b1d1ceca$var$inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === 'deepEqual' || operator === 'equal') _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = $40033248b1d1ceca$var$_possibleConstructorReturn(this, $40033248b1d1ceca$var$_getPrototypeOf(AssertionError).call(this, "".concat(_res).concat(other)));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty($40033248b1d1ceca$var$_assertThisInitialized(_this), 'name', {
            value: 'AssertionError [ERR_ASSERTION]',
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = 'ERR_ASSERTION';
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace($40033248b1d1ceca$var$_assertThisInitialized(_this), stackStartFn);
         // Create error message including the error code in the name.
        _this.stack; // Reset the name.
        _this.name = 'AssertionError';
        return $40033248b1d1ceca$var$_possibleConstructorReturn(_this);
    }
    $40033248b1d1ceca$var$_createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: $40033248b1d1ceca$var$inspect.custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return $40033248b1d1ceca$var$inspect(this, $40033248b1d1ceca$var$_objectSpread({}, ctx, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}($40033248b1d1ceca$var$_wrapNativeSuper(Error));
module.exports = $40033248b1d1ceca$var$AssertionError;

});

parcelRegister("2YhbW", function(module, exports) {
/**
 * Code refactored from Mozilla Developer Network:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 */ 'use strict';
function $229e853e7611c8f9$var$assign(target, firstSource) {
    if (target === undefined || target === null) throw new TypeError('Cannot convert first argument to object');
    var to = Object(target);
    for(var i = 1; i < arguments.length; i++){
        var nextSource = arguments[i];
        if (nextSource === undefined || nextSource === null) continue;
        var keysArray = Object.keys(Object(nextSource));
        for(var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++){
            var nextKey = keysArray[nextIndex];
            var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
            if (desc !== undefined && desc.enumerable) to[nextKey] = nextSource[nextKey];
        }
    }
    return to;
}
function $229e853e7611c8f9$var$polyfill() {
    if (!Object.assign) Object.defineProperty(Object, 'assign', {
        enumerable: false,
        configurable: true,
        writable: true,
        value: $229e853e7611c8f9$var$assign
    });
}
module.exports = {
    assign: $229e853e7611c8f9$var$assign,
    polyfill: $229e853e7611c8f9$var$polyfill
};

});

parcelRegister("9JZPb", function(module, exports) {
'use strict';

var $bnyrj = parcelRequire("bnyrj");

var $gbBT6 = parcelRequire("gbBT6");

var $j6fBo = parcelRequire("j6fBo");

var $j6DGV = parcelRequire("j6DGV");

var $3dEtR = parcelRequire("3dEtR");
var $7178461b62322732$var$polyfill = $gbBT6($j6DGV(), Object);
$bnyrj($7178461b62322732$var$polyfill, {
    getPolyfill: $j6DGV,
    implementation: $j6fBo,
    shim: $3dEtR
});
module.exports = $7178461b62322732$var$polyfill;

});
parcelRegister("bnyrj", function(module, exports) {
'use strict';

var $axhYK = parcelRequire("axhYK");
var $848c8eadae63fc48$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var $848c8eadae63fc48$var$toStr = Object.prototype.toString;
var $848c8eadae63fc48$var$concat = Array.prototype.concat;
var $848c8eadae63fc48$var$origDefineProperty = Object.defineProperty;
var $848c8eadae63fc48$var$isFunction = function(fn) {
    return typeof fn === 'function' && $848c8eadae63fc48$var$toStr.call(fn) === '[object Function]';
};
var $848c8eadae63fc48$var$arePropertyDescriptorsSupported = function() {
    var obj = {};
    try {
        $848c8eadae63fc48$var$origDefineProperty(obj, 'x', {
            enumerable: false,
            value: obj
        });
        // eslint-disable-next-line no-unused-vars, no-restricted-syntax
        for(var _ in obj)return false;
        return obj.x === obj;
    } catch (e) {
        return false;
    }
};
var $848c8eadae63fc48$var$supportsDescriptors = $848c8eadae63fc48$var$origDefineProperty && $848c8eadae63fc48$var$arePropertyDescriptorsSupported();
var $848c8eadae63fc48$var$defineProperty = function(object, name, value, predicate) {
    if (name in object && (!$848c8eadae63fc48$var$isFunction(predicate) || !predicate())) return;
    if ($848c8eadae63fc48$var$supportsDescriptors) $848c8eadae63fc48$var$origDefineProperty(object, name, {
        configurable: true,
        enumerable: false,
        value: value,
        writable: true
    });
    else object[name] = value;
};
var $848c8eadae63fc48$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $axhYK(map);
    if ($848c8eadae63fc48$var$hasSymbols) props = $848c8eadae63fc48$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$848c8eadae63fc48$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$848c8eadae63fc48$var$defineProperties.supportsDescriptors = !!$848c8eadae63fc48$var$supportsDescriptors;
module.exports = $848c8eadae63fc48$var$defineProperties;

});
parcelRegister("axhYK", function(module, exports) {
'use strict';
var $7abaeeae24b9ca0f$var$slice = Array.prototype.slice;

var $bFy5S = parcelRequire("bFy5S");
var $7abaeeae24b9ca0f$var$origKeys = Object.keys;

var $7abaeeae24b9ca0f$var$keysShim = $7abaeeae24b9ca0f$var$origKeys ? function keys(o) {
    return $7abaeeae24b9ca0f$var$origKeys(o);
} : (parcelRequire("5e15H"));
var $7abaeeae24b9ca0f$var$originalKeys = Object.keys;
$7abaeeae24b9ca0f$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($bFy5S(object)) return $7abaeeae24b9ca0f$var$originalKeys($7abaeeae24b9ca0f$var$slice.call(object));
            return $7abaeeae24b9ca0f$var$originalKeys(object);
        };
    } else Object.keys = $7abaeeae24b9ca0f$var$keysShim;
    return Object.keys || $7abaeeae24b9ca0f$var$keysShim;
};
module.exports = $7abaeeae24b9ca0f$var$keysShim;

});
parcelRegister("bFy5S", function(module, exports) {
'use strict';
var $87edf85af0bddaaf$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $87edf85af0bddaaf$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $87edf85af0bddaaf$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

});

parcelRegister("5e15H", function(module, exports) {
'use strict';
var $3cdf1b36769cb25c$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $3cdf1b36769cb25c$var$has = Object.prototype.hasOwnProperty;
    var $3cdf1b36769cb25c$var$toStr = Object.prototype.toString;
    var $3cdf1b36769cb25c$var$isArgs = (parcelRequire("bFy5S")); // eslint-disable-line global-require
    var $3cdf1b36769cb25c$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $3cdf1b36769cb25c$var$hasDontEnumBug = !$3cdf1b36769cb25c$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $3cdf1b36769cb25c$var$hasProtoEnumBug = $3cdf1b36769cb25c$var$isEnumerable.call(function() {}, 'prototype');
    var $3cdf1b36769cb25c$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $3cdf1b36769cb25c$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $3cdf1b36769cb25c$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $3cdf1b36769cb25c$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$3cdf1b36769cb25c$var$excludedKeys['$' + k] && $3cdf1b36769cb25c$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $3cdf1b36769cb25c$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $3cdf1b36769cb25c$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !$3cdf1b36769cb25c$var$hasAutomationEqualityBug) return $3cdf1b36769cb25c$var$equalsConstructorPrototype(o);
        try {
            return $3cdf1b36769cb25c$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $3cdf1b36769cb25c$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $3cdf1b36769cb25c$var$toStr.call(object) === '[object Function]';
        var isArguments = $3cdf1b36769cb25c$var$isArgs(object);
        var isString = isObject && $3cdf1b36769cb25c$var$toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $3cdf1b36769cb25c$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$3cdf1b36769cb25c$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $3cdf1b36769cb25c$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($3cdf1b36769cb25c$var$hasDontEnumBug) {
            var skipConstructor = $3cdf1b36769cb25c$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $3cdf1b36769cb25c$var$dontEnums.length; ++k)if (!(skipConstructor && $3cdf1b36769cb25c$var$dontEnums[k] === 'constructor') && $3cdf1b36769cb25c$var$has.call(object, $3cdf1b36769cb25c$var$dontEnums[k])) theKeys.push($3cdf1b36769cb25c$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $3cdf1b36769cb25c$var$keysShim;

});



parcelRegister("j6fBo", function(module, exports) {
'use strict';
var $de7aae1e11d7713e$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($de7aae1e11d7713e$var$numberIsNaN(a) && $de7aae1e11d7713e$var$numberIsNaN(b)) return true;
    return false;
};

});

parcelRegister("j6DGV", function(module, exports) {
'use strict';

var $j6fBo = parcelRequire("j6fBo");
module.exports = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : $j6fBo;
};

});

parcelRegister("3dEtR", function(module, exports) {
'use strict';

var $j6DGV = parcelRequire("j6DGV");

var $bnyrj = parcelRequire("bnyrj");
module.exports = function shimObjectIs() {
    var polyfill = $j6DGV();
    $bnyrj(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRegister("ghIoK", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';
function $bdb0ac6a4c1b2b09$var$_slicedToArray(arr, i) {
    return $bdb0ac6a4c1b2b09$var$_arrayWithHoles(arr) || $bdb0ac6a4c1b2b09$var$_iterableToArrayLimit(arr, i) || $bdb0ac6a4c1b2b09$var$_nonIterableRest();
}
function $bdb0ac6a4c1b2b09$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function $bdb0ac6a4c1b2b09$var$_iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $bdb0ac6a4c1b2b09$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $bdb0ac6a4c1b2b09$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $bdb0ac6a4c1b2b09$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $bdb0ac6a4c1b2b09$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $bdb0ac6a4c1b2b09$var$_typeof(obj);
}
var $bdb0ac6a4c1b2b09$var$regexFlagsSupported = /a/g.flags !== undefined;
var $bdb0ac6a4c1b2b09$var$arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var $bdb0ac6a4c1b2b09$var$arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};

var $bdb0ac6a4c1b2b09$var$objectIs = Object.is ? Object.is : (parcelRequire("9JZPb"));
var $bdb0ac6a4c1b2b09$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};

var $bdb0ac6a4c1b2b09$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("epoPu"));
function $bdb0ac6a4c1b2b09$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $bdb0ac6a4c1b2b09$var$hasOwnProperty = $bdb0ac6a4c1b2b09$var$uncurryThis(Object.prototype.hasOwnProperty);
var $bdb0ac6a4c1b2b09$var$propertyIsEnumerable = $bdb0ac6a4c1b2b09$var$uncurryThis(Object.prototype.propertyIsEnumerable);
var $bdb0ac6a4c1b2b09$var$objectToString = $bdb0ac6a4c1b2b09$var$uncurryThis(Object.prototype.toString);

var $lmEzn = parcelRequire("lmEzn");
var $bdb0ac6a4c1b2b09$require$_require$types = $lmEzn.types;
var $bdb0ac6a4c1b2b09$var$isAnyArrayBuffer = $bdb0ac6a4c1b2b09$require$_require$types.isAnyArrayBuffer, $bdb0ac6a4c1b2b09$var$isArrayBufferView = $bdb0ac6a4c1b2b09$require$_require$types.isArrayBufferView, $bdb0ac6a4c1b2b09$var$isDate = $bdb0ac6a4c1b2b09$require$_require$types.isDate, $bdb0ac6a4c1b2b09$var$isMap = $bdb0ac6a4c1b2b09$require$_require$types.isMap, $bdb0ac6a4c1b2b09$var$isRegExp = $bdb0ac6a4c1b2b09$require$_require$types.isRegExp, $bdb0ac6a4c1b2b09$var$isSet = $bdb0ac6a4c1b2b09$require$_require$types.isSet, $bdb0ac6a4c1b2b09$var$isNativeError = $bdb0ac6a4c1b2b09$require$_require$types.isNativeError, $bdb0ac6a4c1b2b09$var$isBoxedPrimitive = $bdb0ac6a4c1b2b09$require$_require$types.isBoxedPrimitive, $bdb0ac6a4c1b2b09$var$isNumberObject = $bdb0ac6a4c1b2b09$require$_require$types.isNumberObject, $bdb0ac6a4c1b2b09$var$isStringObject = $bdb0ac6a4c1b2b09$require$_require$types.isStringObject, $bdb0ac6a4c1b2b09$var$isBooleanObject = $bdb0ac6a4c1b2b09$require$_require$types.isBooleanObject, $bdb0ac6a4c1b2b09$var$isBigIntObject = $bdb0ac6a4c1b2b09$require$_require$types.isBigIntObject, $bdb0ac6a4c1b2b09$var$isSymbolObject = $bdb0ac6a4c1b2b09$require$_require$types.isSymbolObject, $bdb0ac6a4c1b2b09$var$isFloat32Array = $bdb0ac6a4c1b2b09$require$_require$types.isFloat32Array, $bdb0ac6a4c1b2b09$var$isFloat64Array = $bdb0ac6a4c1b2b09$require$_require$types.isFloat64Array;
function $bdb0ac6a4c1b2b09$var$isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    } // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function $bdb0ac6a4c1b2b09$var$getOwnNonIndexProperties(value) {
    return Object.keys(value).filter($bdb0ac6a4c1b2b09$var$isNonIndex).concat($bdb0ac6a4c1b2b09$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
} // Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function $bdb0ac6a4c1b2b09$var$compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var $bdb0ac6a4c1b2b09$var$ONLY_ENUMERABLE = undefined;
var $bdb0ac6a4c1b2b09$var$kStrict = true;
var $bdb0ac6a4c1b2b09$var$kLoose = false;
var $bdb0ac6a4c1b2b09$var$kNoIterator = 0;
var $bdb0ac6a4c1b2b09$var$kIsArray = 1;
var $bdb0ac6a4c1b2b09$var$kIsSet = 2;
var $bdb0ac6a4c1b2b09$var$kIsMap = 3; // Check if they have the same source and flags
function $bdb0ac6a4c1b2b09$var$areSimilarRegExps(a, b) {
    return $bdb0ac6a4c1b2b09$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function $bdb0ac6a4c1b2b09$var$areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function $bdb0ac6a4c1b2b09$var$areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $bdb0ac6a4c1b2b09$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function $bdb0ac6a4c1b2b09$var$areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && $bdb0ac6a4c1b2b09$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function $bdb0ac6a4c1b2b09$var$isEqualBoxedPrimitive(val1, val2) {
    if ($bdb0ac6a4c1b2b09$var$isNumberObject(val1)) return $bdb0ac6a4c1b2b09$var$isNumberObject(val2) && $bdb0ac6a4c1b2b09$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if ($bdb0ac6a4c1b2b09$var$isStringObject(val1)) return $bdb0ac6a4c1b2b09$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if ($bdb0ac6a4c1b2b09$var$isBooleanObject(val1)) return $bdb0ac6a4c1b2b09$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if ($bdb0ac6a4c1b2b09$var$isBigIntObject(val1)) return $bdb0ac6a4c1b2b09$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return $bdb0ac6a4c1b2b09$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
} // Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function $bdb0ac6a4c1b2b09$var$innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? $bdb0ac6a4c1b2b09$var$objectIs(val1, val2) : true;
    } // Check more closely if val1 and val2 are equal.
    if (strict) {
        if ($bdb0ac6a4c1b2b09$var$_typeof(val1) !== 'object') return typeof val1 === 'number' && $bdb0ac6a4c1b2b09$var$numberIsNaN(val1) && $bdb0ac6a4c1b2b09$var$numberIsNaN(val2);
        if ($bdb0ac6a4c1b2b09$var$_typeof(val2) !== 'object' || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || $bdb0ac6a4c1b2b09$var$_typeof(val1) !== 'object') {
            if (val2 === null || $bdb0ac6a4c1b2b09$var$_typeof(val2) !== 'object') // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || $bdb0ac6a4c1b2b09$var$_typeof(val2) !== 'object') return false;
    }
    var val1Tag = $bdb0ac6a4c1b2b09$var$objectToString(val1);
    var val2Tag = $bdb0ac6a4c1b2b09$var$objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = $bdb0ac6a4c1b2b09$var$getOwnNonIndexProperties(val1, $bdb0ac6a4c1b2b09$var$ONLY_ENUMERABLE);
        var keys2 = $bdb0ac6a4c1b2b09$var$getOwnNonIndexProperties(val2, $bdb0ac6a4c1b2b09$var$ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return $bdb0ac6a4c1b2b09$var$keyCheck(val1, val2, strict, memos, $bdb0ac6a4c1b2b09$var$kIsArray, keys1);
    } // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === '[object Object]') {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!$bdb0ac6a4c1b2b09$var$isMap(val1) && $bdb0ac6a4c1b2b09$var$isMap(val2) || !$bdb0ac6a4c1b2b09$var$isSet(val1) && $bdb0ac6a4c1b2b09$var$isSet(val2)) return false;
    }
    if ($bdb0ac6a4c1b2b09$var$isDate(val1)) {
        if (!$bdb0ac6a4c1b2b09$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if ($bdb0ac6a4c1b2b09$var$isRegExp(val1)) {
        if (!$bdb0ac6a4c1b2b09$var$isRegExp(val2) || !$bdb0ac6a4c1b2b09$var$areSimilarRegExps(val1, val2)) return false;
    } else if ($bdb0ac6a4c1b2b09$var$isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if ($bdb0ac6a4c1b2b09$var$isArrayBufferView(val1)) {
        if (!strict && ($bdb0ac6a4c1b2b09$var$isFloat32Array(val1) || $bdb0ac6a4c1b2b09$var$isFloat64Array(val1))) {
            if (!$bdb0ac6a4c1b2b09$var$areSimilarFloatArrays(val1, val2)) return false;
        } else if (!$bdb0ac6a4c1b2b09$var$areSimilarTypedArrays(val1, val2)) return false;
         // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = $bdb0ac6a4c1b2b09$var$getOwnNonIndexProperties(val1, $bdb0ac6a4c1b2b09$var$ONLY_ENUMERABLE);
        var _keys2 = $bdb0ac6a4c1b2b09$var$getOwnNonIndexProperties(val2, $bdb0ac6a4c1b2b09$var$ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return $bdb0ac6a4c1b2b09$var$keyCheck(val1, val2, strict, memos, $bdb0ac6a4c1b2b09$var$kNoIterator, _keys);
    } else if ($bdb0ac6a4c1b2b09$var$isSet(val1)) {
        if (!$bdb0ac6a4c1b2b09$var$isSet(val2) || val1.size !== val2.size) return false;
        return $bdb0ac6a4c1b2b09$var$keyCheck(val1, val2, strict, memos, $bdb0ac6a4c1b2b09$var$kIsSet);
    } else if ($bdb0ac6a4c1b2b09$var$isMap(val1)) {
        if (!$bdb0ac6a4c1b2b09$var$isMap(val2) || val1.size !== val2.size) return false;
        return $bdb0ac6a4c1b2b09$var$keyCheck(val1, val2, strict, memos, $bdb0ac6a4c1b2b09$var$kIsMap);
    } else if ($bdb0ac6a4c1b2b09$var$isAnyArrayBuffer(val1)) {
        if (!$bdb0ac6a4c1b2b09$var$areEqualArrayBuffers(val1, val2)) return false;
    } else if ($bdb0ac6a4c1b2b09$var$isBoxedPrimitive(val1) && !$bdb0ac6a4c1b2b09$var$isEqualBoxedPrimitive(val1, val2)) return false;
    return $bdb0ac6a4c1b2b09$var$keyCheck(val1, val2, strict, memos, $bdb0ac6a4c1b2b09$var$kNoIterator);
}
function $bdb0ac6a4c1b2b09$var$getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return $bdb0ac6a4c1b2b09$var$propertyIsEnumerable(val, k);
    });
}
function $bdb0ac6a4c1b2b09$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2); // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    } // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!$bdb0ac6a4c1b2b09$var$hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = $bdb0ac6a4c1b2b09$var$objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if ($bdb0ac6a4c1b2b09$var$propertyIsEnumerable(val1, key)) {
                    if (!$bdb0ac6a4c1b2b09$var$propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if ($bdb0ac6a4c1b2b09$var$propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = $bdb0ac6a4c1b2b09$var$objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && $bdb0ac6a4c1b2b09$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = $bdb0ac6a4c1b2b09$var$objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && $bdb0ac6a4c1b2b09$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === $bdb0ac6a4c1b2b09$var$kNoIterator || iterationType === $bdb0ac6a4c1b2b09$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
     // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = $bdb0ac6a4c1b2b09$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function $bdb0ac6a4c1b2b09$var$setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = $bdb0ac6a4c1b2b09$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if ($bdb0ac6a4c1b2b09$var$innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
} // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function $bdb0ac6a4c1b2b09$var$findLooseMatchingPrimitives(prim) {
    switch($bdb0ac6a4c1b2b09$var$_typeof(prim)){
        case 'undefined':
            return null;
        case 'object':
            // Only pass in null as object!
            return undefined;
        case 'symbol':
            return false;
        case 'string':
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case 'number':
            if ($bdb0ac6a4c1b2b09$var$numberIsNaN(prim)) return false;
    }
    return true;
}
function $bdb0ac6a4c1b2b09$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $bdb0ac6a4c1b2b09$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function $bdb0ac6a4c1b2b09$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = $bdb0ac6a4c1b2b09$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !$bdb0ac6a4c1b2b09$var$innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && $bdb0ac6a4c1b2b09$var$innerDeepEqual(item, curB, false, memo);
}
function $bdb0ac6a4c1b2b09$var$setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = $bdb0ac6a4c1b2b09$var$arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i]; // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if ($bdb0ac6a4c1b2b09$var$_typeof(val) === 'object' && val !== null) {
            if (set === null) set = new Set();
             // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false; // Fast path to detect missing string, symbol, undefined and null values.
            if (!$bdb0ac6a4c1b2b09$var$setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = $bdb0ac6a4c1b2b09$var$arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i]; // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if ($bdb0ac6a4c1b2b09$var$_typeof(_val) === 'object' && _val !== null) {
                if (!$bdb0ac6a4c1b2b09$var$setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !$bdb0ac6a4c1b2b09$var$setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $bdb0ac6a4c1b2b09$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = $bdb0ac6a4c1b2b09$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if ($bdb0ac6a4c1b2b09$var$innerDeepEqual(key1, key2, strict, memo) && $bdb0ac6a4c1b2b09$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function $bdb0ac6a4c1b2b09$var$mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = $bdb0ac6a4c1b2b09$var$arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = $bdb0ac6a4c1b2b09$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if ($bdb0ac6a4c1b2b09$var$_typeof(key) === 'object' && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !$bdb0ac6a4c1b2b09$var$innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false; // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!$bdb0ac6a4c1b2b09$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = $bdb0ac6a4c1b2b09$var$arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = $bdb0ac6a4c1b2b09$var$_slicedToArray(bEntries[_i2], 2), key = _bEntries$_i[0], item = _bEntries$_i[1];
            if ($bdb0ac6a4c1b2b09$var$_typeof(key) === 'object' && key !== null) {
                if (!$bdb0ac6a4c1b2b09$var$mapHasEqualEntry(set, a, key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(key) || !$bdb0ac6a4c1b2b09$var$innerDeepEqual(a.get(key), item, false, memo)) && !$bdb0ac6a4c1b2b09$var$mapHasEqualEntry(set, a, key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $bdb0ac6a4c1b2b09$var$objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === $bdb0ac6a4c1b2b09$var$kIsSet) {
        if (!$bdb0ac6a4c1b2b09$var$setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $bdb0ac6a4c1b2b09$var$kIsMap) {
        if (!$bdb0ac6a4c1b2b09$var$mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $bdb0ac6a4c1b2b09$var$kIsArray) for(; i < a.length; i++){
        if ($bdb0ac6a4c1b2b09$var$hasOwnProperty(a, i)) {
            if (!$bdb0ac6a4c1b2b09$var$hasOwnProperty(b, i) || !$bdb0ac6a4c1b2b09$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if ($bdb0ac6a4c1b2b09$var$hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!$bdb0ac6a4c1b2b09$var$hasOwnProperty(b, key) || !$bdb0ac6a4c1b2b09$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
     // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key = keys[i];
        if (!$bdb0ac6a4c1b2b09$var$innerDeepEqual(a[_key], b[_key], strict, memos)) return false;
    }
    return true;
}
function $bdb0ac6a4c1b2b09$var$isDeepEqual(val1, val2) {
    return $bdb0ac6a4c1b2b09$var$innerDeepEqual(val1, val2, $bdb0ac6a4c1b2b09$var$kLoose);
}
function $bdb0ac6a4c1b2b09$var$isDeepStrictEqual(val1, val2) {
    return $bdb0ac6a4c1b2b09$var$innerDeepEqual(val1, val2, $bdb0ac6a4c1b2b09$var$kStrict);
}
module.exports = {
    isDeepEqual: $bdb0ac6a4c1b2b09$var$isDeepEqual,
    isDeepStrictEqual: $bdb0ac6a4c1b2b09$var$isDeepStrictEqual
};

});
parcelRegister("epoPu", function(module, exports) {
'use strict';

var $gbBT6 = parcelRequire("gbBT6");

var $2jgcO = parcelRequire("2jgcO");

var $2LTQv = parcelRequire("2LTQv");

var $aMzeW = parcelRequire("aMzeW");

var $2Gc8e = parcelRequire("2Gc8e");
var $a7d6a918cdc5200f$var$polyfill = $gbBT6($aMzeW(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ $2jgcO($a7d6a918cdc5200f$var$polyfill, {
    getPolyfill: $aMzeW,
    implementation: $2LTQv,
    shim: $2Gc8e
});
module.exports = $a7d6a918cdc5200f$var$polyfill;

});
parcelRegister("2jgcO", function(module, exports) {
'use strict';

var $axhYK = parcelRequire("axhYK");
var $1ae9ed3e6d471a31$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var $1ae9ed3e6d471a31$var$toStr = Object.prototype.toString;
var $1ae9ed3e6d471a31$var$concat = Array.prototype.concat;
var $1ae9ed3e6d471a31$var$origDefineProperty = Object.defineProperty;
var $1ae9ed3e6d471a31$var$isFunction = function(fn) {
    return typeof fn === 'function' && $1ae9ed3e6d471a31$var$toStr.call(fn) === '[object Function]';
};
var $1ae9ed3e6d471a31$var$arePropertyDescriptorsSupported = function() {
    var obj = {};
    try {
        $1ae9ed3e6d471a31$var$origDefineProperty(obj, 'x', {
            enumerable: false,
            value: obj
        });
        // eslint-disable-next-line no-unused-vars, no-restricted-syntax
        for(var _ in obj)return false;
        return obj.x === obj;
    } catch (e) {
        return false;
    }
};
var $1ae9ed3e6d471a31$var$supportsDescriptors = $1ae9ed3e6d471a31$var$origDefineProperty && $1ae9ed3e6d471a31$var$arePropertyDescriptorsSupported();
var $1ae9ed3e6d471a31$var$defineProperty = function(object, name, value, predicate) {
    if (name in object && (!$1ae9ed3e6d471a31$var$isFunction(predicate) || !predicate())) return;
    if ($1ae9ed3e6d471a31$var$supportsDescriptors) $1ae9ed3e6d471a31$var$origDefineProperty(object, name, {
        configurable: true,
        enumerable: false,
        value: value,
        writable: true
    });
    else object[name] = value;
};
var $1ae9ed3e6d471a31$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $axhYK(map);
    if ($1ae9ed3e6d471a31$var$hasSymbols) props = $1ae9ed3e6d471a31$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$1ae9ed3e6d471a31$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$1ae9ed3e6d471a31$var$defineProperties.supportsDescriptors = !!$1ae9ed3e6d471a31$var$supportsDescriptors;
module.exports = $1ae9ed3e6d471a31$var$defineProperties;

});

parcelRegister("2LTQv", function(module, exports) {
'use strict';
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

});

parcelRegister("aMzeW", function(module, exports) {
'use strict';

var $2LTQv = parcelRequire("2LTQv");
module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) return Number.isNaN;
    return $2LTQv;
};

});

parcelRegister("2Gc8e", function(module, exports) {
'use strict';

var $2jgcO = parcelRequire("2jgcO");

var $aMzeW = parcelRequire("aMzeW");
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = $aMzeW();
    $2jgcO(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

});




parcelRegister("2gIsH", function(module, exports) {
'use strict';





var $1a6f909541fbb8a9$var$types = [
    (parcelRequire("lCSiz")),
    (parcelRequire("jYxW9")),
    (parcelRequire("cRtwx")),
    (parcelRequire("fzl3X")),
    (parcelRequire("2zzIg"))
];
var $1a6f909541fbb8a9$var$draining;
var $1a6f909541fbb8a9$var$currentQueue;
var $1a6f909541fbb8a9$var$queueIndex = -1;
var $1a6f909541fbb8a9$var$queue = [];
var $1a6f909541fbb8a9$var$scheduled = false;
function $1a6f909541fbb8a9$var$cleanUpNextTick() {
    if (!$1a6f909541fbb8a9$var$draining || !$1a6f909541fbb8a9$var$currentQueue) return;
    $1a6f909541fbb8a9$var$draining = false;
    if ($1a6f909541fbb8a9$var$currentQueue.length) $1a6f909541fbb8a9$var$queue = $1a6f909541fbb8a9$var$currentQueue.concat($1a6f909541fbb8a9$var$queue);
    else $1a6f909541fbb8a9$var$queueIndex = -1;
    if ($1a6f909541fbb8a9$var$queue.length) $1a6f909541fbb8a9$var$nextTick();
}
//named nextTick for less confusing stack traces
function $1a6f909541fbb8a9$var$nextTick() {
    if ($1a6f909541fbb8a9$var$draining) return;
    $1a6f909541fbb8a9$var$scheduled = false;
    $1a6f909541fbb8a9$var$draining = true;
    var len = $1a6f909541fbb8a9$var$queue.length;
    var timeout = setTimeout($1a6f909541fbb8a9$var$cleanUpNextTick);
    while(len){
        $1a6f909541fbb8a9$var$currentQueue = $1a6f909541fbb8a9$var$queue;
        $1a6f909541fbb8a9$var$queue = [];
        while($1a6f909541fbb8a9$var$currentQueue && ++$1a6f909541fbb8a9$var$queueIndex < len)$1a6f909541fbb8a9$var$currentQueue[$1a6f909541fbb8a9$var$queueIndex].run();
        $1a6f909541fbb8a9$var$queueIndex = -1;
        len = $1a6f909541fbb8a9$var$queue.length;
    }
    $1a6f909541fbb8a9$var$currentQueue = null;
    $1a6f909541fbb8a9$var$queueIndex = -1;
    $1a6f909541fbb8a9$var$draining = false;
    clearTimeout(timeout);
}
var $1a6f909541fbb8a9$var$scheduleDrain;
var $1a6f909541fbb8a9$var$i = -1;
var $1a6f909541fbb8a9$var$len = $1a6f909541fbb8a9$var$types.length;
while(++$1a6f909541fbb8a9$var$i < $1a6f909541fbb8a9$var$len)if ($1a6f909541fbb8a9$var$types[$1a6f909541fbb8a9$var$i] && $1a6f909541fbb8a9$var$types[$1a6f909541fbb8a9$var$i].test && $1a6f909541fbb8a9$var$types[$1a6f909541fbb8a9$var$i].test()) {
    $1a6f909541fbb8a9$var$scheduleDrain = $1a6f909541fbb8a9$var$types[$1a6f909541fbb8a9$var$i].install($1a6f909541fbb8a9$var$nextTick);
    break;
}
// v8 likes predictible objects
function $1a6f909541fbb8a9$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$1a6f909541fbb8a9$var$Item.prototype.run = function() {
    var fun = this.fun;
    var array = this.array;
    switch(array.length){
        case 0:
            return fun();
        case 1:
            return fun(array[0]);
        case 2:
            return fun(array[0], array[1]);
        case 3:
            return fun(array[0], array[1], array[2]);
        default:
            return fun.apply(null, array);
    }
};
module.exports = $1a6f909541fbb8a9$var$immediate;
function $1a6f909541fbb8a9$var$immediate(task) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $1a6f909541fbb8a9$var$queue.push(new $1a6f909541fbb8a9$var$Item(task, args));
    if (!$1a6f909541fbb8a9$var$scheduled && !$1a6f909541fbb8a9$var$draining) {
        $1a6f909541fbb8a9$var$scheduled = true;
        $1a6f909541fbb8a9$var$scheduleDrain();
    }
}

});
parcelRegister("lCSiz", function(module, exports) {

$parcel$export(module.exports, "test", function () { return $fbe744242be1e7c9$export$e0969da9b8fb378d; }, function (v) { return $fbe744242be1e7c9$export$e0969da9b8fb378d = v; });
$parcel$export(module.exports, "install", function () { return $fbe744242be1e7c9$export$4b3e715f166fdd78; }, function (v) { return $fbe744242be1e7c9$export$4b3e715f166fdd78 = v; });
var $fbe744242be1e7c9$export$e0969da9b8fb378d;
var $fbe744242be1e7c9$export$4b3e715f166fdd78;

var $kavLi = parcelRequire("kavLi");
'use strict';
$fbe744242be1e7c9$export$e0969da9b8fb378d = function() {
    // Don't get fooled by e.g. browserify environments.
    return false;
};
$fbe744242be1e7c9$export$4b3e715f166fdd78 = function(func) {
    return function() {
        $kavLi.nextTick(func);
    };
};

});

parcelRegister("jYxW9", function(module, exports) {

$parcel$export(module.exports, "test", function () { return $e8adf21a6ed2ab98$export$e0969da9b8fb378d; }, function (v) { return $e8adf21a6ed2ab98$export$e0969da9b8fb378d = v; });
$parcel$export(module.exports, "install", function () { return $e8adf21a6ed2ab98$export$4b3e715f166fdd78; }, function (v) { return $e8adf21a6ed2ab98$export$4b3e715f166fdd78 = v; });
var $e8adf21a6ed2ab98$export$e0969da9b8fb378d;
var $e8adf21a6ed2ab98$export$4b3e715f166fdd78;
'use strict';
//based off rsvp https://github.com/tildeio/rsvp.js
//license https://github.com/tildeio/rsvp.js/blob/master/LICENSE
//https://github.com/tildeio/rsvp.js/blob/master/lib/rsvp/asap.js
var $e8adf21a6ed2ab98$var$Mutation = $parcel$global.MutationObserver || $parcel$global.WebKitMutationObserver;
$e8adf21a6ed2ab98$export$e0969da9b8fb378d = function() {
    return $e8adf21a6ed2ab98$var$Mutation;
};
$e8adf21a6ed2ab98$export$4b3e715f166fdd78 = function(handle) {
    var called = 0;
    var observer = new $e8adf21a6ed2ab98$var$Mutation(handle);
    var element = $parcel$global.document.createTextNode('');
    observer.observe(element, {
        characterData: true
    });
    return function() {
        element.data = called = ++called % 2;
    };
};

});

parcelRegister("cRtwx", function(module, exports) {

$parcel$export(module.exports, "test", function () { return $95d156141dfcc1bb$export$e0969da9b8fb378d; }, function (v) { return $95d156141dfcc1bb$export$e0969da9b8fb378d = v; });
$parcel$export(module.exports, "install", function () { return $95d156141dfcc1bb$export$4b3e715f166fdd78; }, function (v) { return $95d156141dfcc1bb$export$4b3e715f166fdd78 = v; });
var $95d156141dfcc1bb$export$e0969da9b8fb378d;
var $95d156141dfcc1bb$export$4b3e715f166fdd78;
'use strict';
$95d156141dfcc1bb$export$e0969da9b8fb378d = function() {
    if ($parcel$global.setImmediate) // we can only get here in IE10
    // which doesn't handel postMessage well
    return false;
    return typeof $parcel$global.MessageChannel !== 'undefined';
};
$95d156141dfcc1bb$export$4b3e715f166fdd78 = function(func) {
    var channel = new $parcel$global.MessageChannel();
    channel.port1.onmessage = func;
    return function() {
        channel.port2.postMessage(0);
    };
};

});

parcelRegister("fzl3X", function(module, exports) {

$parcel$export(module.exports, "test", function () { return $b55a768eb828b1ba$export$e0969da9b8fb378d; }, function (v) { return $b55a768eb828b1ba$export$e0969da9b8fb378d = v; });
$parcel$export(module.exports, "install", function () { return $b55a768eb828b1ba$export$4b3e715f166fdd78; }, function (v) { return $b55a768eb828b1ba$export$4b3e715f166fdd78 = v; });
var $b55a768eb828b1ba$export$e0969da9b8fb378d;
var $b55a768eb828b1ba$export$4b3e715f166fdd78;
'use strict';
$b55a768eb828b1ba$export$e0969da9b8fb378d = function() {
    return 'document' in $parcel$global && 'onreadystatechange' in $parcel$global.document.createElement('script');
};
$b55a768eb828b1ba$export$4b3e715f166fdd78 = function(handle) {
    return function() {
        // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
        // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
        var scriptEl = $parcel$global.document.createElement('script');
        scriptEl.onreadystatechange = function() {
            handle();
            scriptEl.onreadystatechange = null;
            scriptEl.parentNode.removeChild(scriptEl);
            scriptEl = null;
        };
        $parcel$global.document.documentElement.appendChild(scriptEl);
        return handle;
    };
};

});

parcelRegister("2zzIg", function(module, exports) {

$parcel$export(module.exports, "test", function () { return $1dfa8d84823312a1$export$e0969da9b8fb378d; }, function (v) { return $1dfa8d84823312a1$export$e0969da9b8fb378d = v; });
$parcel$export(module.exports, "install", function () { return $1dfa8d84823312a1$export$4b3e715f166fdd78; }, function (v) { return $1dfa8d84823312a1$export$4b3e715f166fdd78 = v; });
var $1dfa8d84823312a1$export$e0969da9b8fb378d;
var $1dfa8d84823312a1$export$4b3e715f166fdd78;
'use strict';
$1dfa8d84823312a1$export$e0969da9b8fb378d = function() {
    return true;
};
$1dfa8d84823312a1$export$4b3e715f166fdd78 = function(t) {
    return function() {
        setTimeout(t, 0);
    };
};

});


parcelRegister("axd2S", function(module, exports) {
//! moment.js
//! version : 2.31.0
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidOffset: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid$2(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidOffset && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid$1(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg + '\n' + new Error().stack);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\e)|(\\)?(eHHmm|[Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        var cacheKey = '$' + format;
        if (!hasOwnProp(formatFunctions, cacheKey)) formatFunctions[cacheKey] = makeFormatFunction(format);
        return formatFunctions[cacheKey](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get$2(this, unit);
        };
    }
    function get$2(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod$1(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod$1(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord, monthsParseProperties = [
        'monthsParse',
        'longMonthsParse',
        'shortMonthsParse',
        'monthsRegex',
        'monthsShortRegex',
        'monthsStrictRegex',
        'monthsShortStrictRegex'
    ];
    function clearMonthsParseCache(locale, config) {
        var i, prop;
        for(i = 0; i < monthsParseProperties.length; i++){
            prop = monthsParseProperties[i];
            if (!hasOwnProp(config, prop)) delete locale['_' + prop];
        }
    }
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse$1(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse$1.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get$2(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    addFormatToken('eHHmm', 0, 0, function() {
        return '' + this.weekday() + zeroFill(this.hours(), 2) + zeroFill(this.minutes(), 2);
    });
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('eHHmm', match5to6);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    addWeekParseToken('eHHmm', function(input, week, config) {
        var weekdayEnd = input.length - 4;
        week.e = toInt(input.substr(0, weekdayEnd));
        config._a[HOUR] = toInt(input.substr(weekdayEnd, 2));
        config._a[MINUTE] = toInt(input.substr(weekdayEnd + 2));
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord, weekdaysParseProperties = [
        'weekdaysParse',
        'fullWeekdaysParse',
        'shortWeekdaysParse',
        'minWeekdaysParse',
        'weekdaysRegex',
        'weekdaysShortRegex',
        'weekdaysMinRegex',
        'weekdaysStrictRegex',
        'weekdaysShortStrictRegex',
        'weekdaysMinStrictRegex'
    ];
    function clearWeekdaysParseCache(locale, config) {
        var i, prop;
        for(i = 0; i < weekdaysParseProperties.length; i++){
            prop = weekdaysParseProperties[i];
            if (!hasOwnProp(config, prop)) delete locale['_' + prop];
        }
    }
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get$2(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    function set(config) {
        var prop, i;
        clearMonthsParseCache(this, config);
        clearWeekdaysParseCache(this, config);
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar$1(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()], formatCache = this._longDateFormatCache;
        if (format || !formatUpper) return format;
        if (formatCache && formatCache[key] && formatCache[key].formatUpper === formatUpper) return formatCache[key].format;
        format = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        if (!formatCache) formatCache = this._longDateFormatCache = {};
        formatCache[key] = {
            formatUpper: formatUpper,
            format: format
        };
        return format;
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTimeWithoutPostformat(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function relativeTime$1(number, withoutSuffix, string, isFuture) {
        return this.postformat(relativeTimeWithoutPostformat.call(this, number, withoutSuffix, string, isFuture));
    }
    function pastFutureWithoutPostformat(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    function pastFuture(diff, output) {
        return this.postformat(pastFutureWithoutPostformat.call(this, diff, output));
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYearFromDayOfYear(year, dayOfYear, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), week = Math.floor((dayOfYear - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = year - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(year, dow, doy)) {
            resWeek = week - weeksInYear(year, dow, doy);
            resYear = year + 1;
        } else {
            resYear = year;
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        return weekOfYearFromDayOfYear(mom.year(), mom.dayOfYear(), dow, doy);
    }
    function weekOfYearFromDate(year, month, date, dow, doy) {
        var dayOfYear = Math.round((createUTCDate(year, month, date) - createUTCDate(year, 0, 1)) / 864e5) + 1;
        return weekOfYearFromDayOfYear(year, dayOfYear, dow, doy);
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Only canonical locale module names are safe to append to the require path.
        return typeof name === 'string' && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(name);
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire, normalizedName;
        // Preserve exact custom locale names before trying the canonical built-in name.
        // Use hasOwnProp rather than a plain lookup so that names like "__proto__",
        // "constructor", or "prototype" can't resolve to an inherited Object.prototype
        // property instead of a real (or missing) locale entry.
        if (hasOwnProp(locales, name)) return locales[name];
        normalizedName = normalizeLocale(name);
        if (hasOwnProp(locales, normalizedName)) return locales[normalizedName];
        // TODO: Find a better way to register and load all the locales in Node
        if (module && module.exports && isLocaleNameSane(normalizedName)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + normalizedName);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[normalizedName] = null; // null means not found
        }
        if (hasOwnProp(locales, normalizedName)) return locales[normalizedName];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        var locale, tmpLocale = loadLocale(name), parentConfig = baseConfig;
        if (tmpLocale != null) name = tmpLocale._abbr;
        if (config != null) {
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config, now, forWeek) {
        var hadWeekContext = Object.prototype.hasOwnProperty.call(config, '_isDefaultDatePartsForWeek'), weekContext = config._isDefaultDatePartsForWeek;
        // hooks is actually the exported moment object
        config._isDefaultDatePartsForWeek = !!forWeek;
        try {
            return hooks._getDefaultDateParts(config, now, forWeek);
        } finally{
            if (hadWeekContext) config._isDefaultDatePartsForWeek = weekContext;
            else delete config._isDefaultDatePartsForWeek;
        }
    }
    function currentDateNow(config) {
        var now = config._defaultDatePartsNow;
        if (!now) return hooks.now();
        if (!now.hasValue) {
            now.value = hooks.now();
            now.hasValue = true;
        }
        return now.value;
    }
    // Internal hook for extensions that supply omitted calendar fields.
    function getDefaultDateParts(config, now, forWeek) {
        var useWeekDefaults = forWeek || config._isDefaultDatePartsForWeek, nowValue = useWeekDefaults ? createLocal(now) : new Date(now);
        if (useWeekDefaults) return [
            nowValue.year(),
            nowValue.month(),
            nowValue.date()
        ];
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    hooks._getDefaultDateParts = getDefaultDateParts;
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], now, currentDate, expectedWeekday, yearToUse, dateIsDefaulted;
        if (config._d) return;
        if (config._a[YEAR] == null || config._a[MONTH] == null || config._a[DATE] == null) {
            now = currentDateNow(config);
            currentDate = currentDateArray(config, now);
        }
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config, currentDateArray(config, now, true));
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = config._a[YEAR] != null ? config._a[YEAR] : currentDate[YEAR];
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        dateIsDefaulted = config._a[YEAR] == null || config._a[MONTH] == null || config._a[DATE] == null;
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && !dateIsDefaulted && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config, currentDate) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYearFromDate(currentDate[YEAR], currentDate[MONTH], currentDate[DATE], 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYearFromDate(currentDate[YEAR], currentDate[MONTH], currentDate[DATE], dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, defaultDatePartsNow = {}, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._defaultDatePartsNow = defaultDatePartsNow;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid$2(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid$1({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid$2(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid$1();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid$1();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        for(i = 0; i < moments.length; ++i)if (isMoment(moments[i])) {
            res = moments[i];
            break;
        }
        if (!res) return createInvalid$1();
        for(++i; i < moments.length; ++i)if (isMoment(moments[i]) && (!moments[i].isValid() || moments[i][fn](res))) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        var offset = offsetFromString(matchShortOffset, input);
        config._useUTC = true;
        config._tzm = offset;
        if (offset === null) getParsingFlags(config).invalidOffset = input;
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        if (toInt(parts[2]) > 59 || (parts[0] === '+' ? minutes > 840 : minutes > 720)) return null;
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract$1(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract$1(this, dur, direction);
            return this;
        };
    }
    function addSubtract$1(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get$2(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get$2(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add$1 = createAdder(1, 'add'), subtract$1 = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone$1() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString$1(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf$1() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid() {
        return isValid$2(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto$2 = Moment.prototype;
    proto$2.add = add$1;
    proto$2.calendar = calendar;
    proto$2.clone = clone$1;
    proto$2.diff = diff;
    proto$2.endOf = endOf;
    proto$2.format = format;
    proto$2.from = from;
    proto$2.fromNow = fromNow;
    proto$2.to = to;
    proto$2.toNow = toNow;
    proto$2.get = stringGet;
    proto$2.invalidAt = invalidAt;
    proto$2.isAfter = isAfter;
    proto$2.isBefore = isBefore;
    proto$2.isBetween = isBetween;
    proto$2.isSame = isSame;
    proto$2.isSameOrAfter = isSameOrAfter;
    proto$2.isSameOrBefore = isSameOrBefore;
    proto$2.isValid = isValid;
    proto$2.lang = lang;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.max = prototypeMax;
    proto$2.min = prototypeMin;
    proto$2.parsingFlags = parsingFlags;
    proto$2.set = stringSet;
    proto$2.startOf = startOf;
    proto$2.subtract = subtract$1;
    proto$2.toArray = toArray;
    proto$2.toObject = toObject;
    proto$2.toDate = toDate;
    proto$2.toISOString = toISOString$1;
    proto$2.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto$2[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto$2.toJSON = toJSON;
    proto$2.toString = toString;
    proto$2.unix = unix;
    proto$2.valueOf = valueOf$1;
    proto$2.creationData = creationData;
    proto$2.eraName = getEraName;
    proto$2.eraNarrow = getEraNarrow;
    proto$2.eraAbbr = getEraAbbr;
    proto$2.eraYear = getEraYear;
    proto$2.year = getSetYear;
    proto$2.isLeapYear = getIsLeapYear;
    proto$2.weekYear = getSetWeekYear;
    proto$2.isoWeekYear = getSetISOWeekYear;
    proto$2.quarter = proto$2.quarters = getSetQuarter;
    proto$2.month = getSetMonth;
    proto$2.daysInMonth = getDaysInMonth;
    proto$2.week = proto$2.weeks = getSetWeek;
    proto$2.isoWeek = proto$2.isoWeeks = getSetISOWeek;
    proto$2.weeksInYear = getWeeksInYear;
    proto$2.weeksInWeekYear = getWeeksInWeekYear;
    proto$2.isoWeeksInYear = getISOWeeksInYear;
    proto$2.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto$2.date = getSetDayOfMonth;
    proto$2.day = proto$2.days = getSetDayOfWeek;
    proto$2.weekday = getSetLocaleDayOfWeek;
    proto$2.isoWeekday = getSetISODayOfWeek;
    proto$2.dayOfYear = getSetDayOfYear;
    proto$2.hour = proto$2.hours = getSetHour;
    proto$2.minute = proto$2.minutes = getSetMinute;
    proto$2.second = proto$2.seconds = getSetSecond;
    proto$2.millisecond = proto$2.milliseconds = getSetMillisecond;
    proto$2.utcOffset = getSetOffset;
    proto$2.utc = setOffsetToUTC;
    proto$2.local = setOffsetToLocal;
    proto$2.parseZone = setOffsetToParsedOffset;
    proto$2.hasAlignedHourOffset = hasAlignedHourOffset;
    proto$2.isDST = isDaylightSavingTime;
    proto$2.isLocal = isLocal;
    proto$2.isUtcOffset = isUtcOffset;
    proto$2.isUtc = isUtc;
    proto$2.isUTC = isUtc;
    proto$2.zoneAbbr = getZoneAbbr;
    proto$2.zoneName = getZoneName;
    proto$2.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto$2.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto$2.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto$2.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto$2.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar$1;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime$1;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs$1() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add(input, value) {
        return addSubtract(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract(input, value) {
        return addSubtract(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf = asMilliseconds;
    function clone() {
        return createDuration(this);
    }
    function get(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return relativeTimeWithoutPostformat.call(locale, number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = extend(extend({}, thresholds), argThresholds || {});
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime(this, !withSuffix, th, locale);
        if (withSuffix) output = pastFutureWithoutPostformat.call(locale, +this, output);
        return locale.postformat(output);
    }
    var abs = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs(this._milliseconds) / 1000, days = abs(this._days), months = abs(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto = Duration.prototype;
    proto.isValid = isValid$1;
    proto.abs = abs$1;
    proto.add = add;
    proto.subtract = subtract;
    proto.as = as;
    proto.asMilliseconds = asMilliseconds;
    proto.asSeconds = asSeconds;
    proto.asMinutes = asMinutes;
    proto.asHours = asHours;
    proto.asDays = asDays;
    proto.asWeeks = asWeeks;
    proto.asMonths = asMonths;
    proto.asQuarters = asQuarters;
    proto.asYears = asYears;
    proto.valueOf = valueOf;
    proto._bubble = bubble;
    proto.clone = clone;
    proto.get = get;
    proto.milliseconds = milliseconds;
    proto.seconds = seconds;
    proto.minutes = minutes;
    proto.hours = hours;
    proto.days = days;
    proto.weeks = weeks;
    proto.months = months;
    proto.years = years;
    proto.humanize = humanize;
    proto.toISOString = toISOString;
    proto.toString = toISOString;
    proto.toJSON = toISOString;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString);
    proto.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.31.0';
    setHookCallback(createLocal);
    hooks.fn = proto$2;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid$1;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto$2;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});

parcelRegister("lEd8H", function(module, exports) {

var $6MeXQ = parcelRequire("6MeXQ");

var $6metg = parcelRequire("6metg");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $6MeXQ.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $6metg;
module.exports = isBuffer;

});
parcelRegister("6MeXQ", function(module, exports) {

var $4utoq = parcelRequire("4utoq");
/** Detect free variable `self`. */ var $4ef2d561f5af7fec$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $4ef2d561f5af7fec$var$root = $4utoq || $4ef2d561f5af7fec$var$freeSelf || Function('return this')();
module.exports = $4ef2d561f5af7fec$var$root;

});
parcelRegister("4utoq", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $3450c39200a173bb$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $3450c39200a173bb$var$freeGlobal;

});


parcelRegister("6metg", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $4a1005c88c229fa7$var$stubFalse() {
    return false;
}
module.exports = $4a1005c88c229fa7$var$stubFalse;

});


parcelRegister("38lOQ", function(module, exports) {

var $4utoq = parcelRequire("4utoq");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $4utoq.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("1v7mg", function(module, exports) {
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === 'string' || argType === 'number') classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === 'object') {
                if (arg.toString === Object.prototype.toString) {
                    for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
                } else classes.push(arg.toString());
            }
        }
        return classes.join(' ');
    }
    if (module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("1pxUG", function(module, exports) {
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ 'use strict';

var $1xz7G = parcelRequire("1xz7G");
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */ var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */ delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    '\''
].concat(unwise), /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */ nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat(autoEscape), hostEndingChars = [
    '/',
    '?',
    '#'
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    javascript: true,
    'javascript:': true
}, // protocols that never have a hostname.
hostlessProtocol = {
    javascript: true,
    'javascript:': true
}, // protocols that always contain a // bit.
slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
};

var $1l8zS = parcelRequire("1l8zS");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && typeof url === 'object' && url instanceof Url) return url;
    var u = new Url();
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (typeof url !== 'string') throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */ var queryIndex = url.indexOf('?'), splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#', uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, '/');
    url = uSplit.join(splitter);
    var rest = url;
    /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */ rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $1l8zS.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = '';
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
        var slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */ /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */ // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */ var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */ atSign = rest.lastIndexOf('@', hostEnd);
        /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */ if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */ this.hostname = this.hostname || '';
        /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */ var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = '';
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */ newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = '/' + notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = '';
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */ this.hostname = $1xz7G.toASCII(this.hostname);
        var p = this.port ? ':' + this.port : '';
        var h = this.hostname || '';
        this.host = h + p;
        this.href += this.host;
        /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */ if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== '/') rest = '/' + rest;
        }
    }
    /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */ if (!unsafeProtocol[lowerProto]) /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */ for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $1l8zS.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = '';
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '/';
    // to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || '';
        var s = this.search || '';
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */ if (typeof obj === 'string') obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || '';
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ':');
        auth += '@';
    }
    var protocol = this.protocol || '', pathname = this.pathname || '', hash = this.hash || '', host = false, query = '';
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
        if (this.port) host += ':' + this.port;
    }
    if (this.query && typeof this.query === 'object' && Object.keys(this.query).length) query = $1l8zS.stringify(this.query, {
        arrayFormat: 'repeat',
        addQueryPrefix: false
    });
    var search = this.search || query && '?' + query || '';
    if (protocol && protocol.substr(-1) !== ':') protocol += ':';
    /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */ if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = '//' + (host || '');
        if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
    } else if (!host) host = '';
    if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
    if (search && search.charAt(0) !== '?') search = '?' + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace('#', '%23');
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if (typeof relative === 'string') {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */ result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === '') {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== 'protocol') result[rkey] = relative[rkey];
        }
        // urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
            result.pathname = '/';
            result.path = result.pathname;
        }
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */ if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || '').split('/');
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = '';
            if (!relative.hostname) relative.hostname = '';
            if (relPath[0] !== '') relPath.unshift('');
            if (relPath.length < 2) relPath.unshift('');
            result.pathname = relPath.join('/');
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || '';
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || '';
            var s = result.search || '';
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/', isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/', mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split('/') || [], relPath = relative.pathname && relative.pathname.split('/') || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */ if (psychotic) {
        result.hostname = '';
        result.port = null;
        if (result.host) {
            if (srcPath[0] === '') srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = '';
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === '') relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === '' ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */ if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (relative.search != null) {
        /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */ if (psychotic) {
            result.host = srcPath.shift();
            result.hostname = result.host;
            /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */ var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.hostname = authInHost.shift();
                result.host = result.hostname;
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        // to support http.request
        if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */ result.pathname = null;
        // to support http.request
        if (result.search) result.path = '/' + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */ var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';
    /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */ var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === '.') srcPath.splice(i, 1);
        else if (last === '..') {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift('..');
    if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) srcPath.unshift('');
    if (hasTrailingSlash && srcPath.join('/').substr(-1) !== '/') srcPath.push('');
    var isAbsolute = srcPath[0] === '' || srcPath[0] && srcPath[0].charAt(0) === '/';
    // put the host back
    if (psychotic) {
        result.hostname = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
        result.host = result.hostname;
        /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */ var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.hostname = authInHost.shift();
            result.host = result.hostname;
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift('');
    if (srcPath.length > 0) result.pathname = srcPath.join('/');
    else {
        result.pathname = null;
        result.path = null;
    }
    // to support request.http
    if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;

});
parcelRegister("1xz7G", function(module, exports) {
/*! https://mths.be/punycode v1.4.1 by @mathias */ (function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == 'object' && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = '-', /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        'overflow': 'Overflow: input needs wider integers to process',
        'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
        'invalid-input': 'Invalid input'
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split('@');
        var result = '';
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + '@';
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, '\x2E');
        var labels = string.split('.');
        var encoded = map(labels, fn).join('.');
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = '';
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join('');
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error('not-basic');
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error('invalid-input');
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error('overflow');
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error('overflow');
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error('overflow');
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error('overflow');
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error('overflow');
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join('');
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ 'version': '1.4.1',
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ 'ucs2': {
            'decode': ucs2decode,
            'encode': ucs2encode
        },
        'decode': decode,
        'encode': encode,
        'toASCII': toASCII,
        'toUnicode': toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) define('punycode', function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

});

parcelRegister("1l8zS", function(module, exports) {
'use strict';

var $cFzLl = parcelRequire("cFzLl");

var $bSZbC = parcelRequire("bSZbC");

var $4qNLb = parcelRequire("4qNLb");
module.exports = {
    formats: $4qNLb,
    parse: $bSZbC,
    stringify: $cFzLl
};

});
parcelRegister("cFzLl", function(module, exports) {
'use strict';

var $fnMB2 = parcelRequire("fnMB2");

var $04yIU = parcelRequire("04yIU");

var $4qNLb = parcelRequire("4qNLb");
var $93950e1158342634$var$has = Object.prototype.hasOwnProperty;
var $93950e1158342634$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $93950e1158342634$var$isArray = Array.isArray;
var $93950e1158342634$var$push = Array.prototype.push;
var $93950e1158342634$var$pushToArray = function(arr, valueOrArray) {
    $93950e1158342634$var$push.apply(arr, $93950e1158342634$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $93950e1158342634$var$toISO = Date.prototype.toISOString;
var $93950e1158342634$var$defaultFormat = $4qNLb.default;
var $93950e1158342634$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    depth: Infinity,
    encode: true,
    encodeDotInKeys: false,
    encoder: $04yIU.encode,
    encodeValuesOnly: false,
    filter: void 0,
    format: $93950e1158342634$var$defaultFormat,
    formatter: $4qNLb.formatters[$93950e1158342634$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $93950e1158342634$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $93950e1158342634$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
};
var $93950e1158342634$var$sentinel = {};
var $93950e1158342634$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel, depth, currentDepth) {
    var obj = object;
    if (currentDepth > depth) throw new RangeError('Input depth exceeded depth option of ' + depth);
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($93950e1158342634$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) throw new RangeError('Cyclic object value');
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($93950e1158342634$var$sentinel) === 'undefined') step = 0;
    }
    obj = typeof filter === 'function' ? filter(prefix, obj) : obj;
    if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === 'comma' && $93950e1158342634$var$isArray(obj)) obj = $04yIU.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return formatter(encoder && !encodeValuesOnly ? encoder(prefix, $93950e1158342634$var$defaults.encoder, charset, 'key', format) : prefix);
        obj = '';
    }
    if ($93950e1158342634$var$isNonNullishPrimitive(obj) || $04yIU.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $93950e1158342634$var$defaults.encoder, charset, 'key', format);
            return [
                formatter(keyValue) + '=' + formatter(encoder(obj, $93950e1158342634$var$defaults.encoder, charset, 'value', format))
            ];
        }
        return [
            formatter(prefix) + '=' + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === 'undefined') return values;
    var objKeys;
    if (generateArrayPrefix === 'comma' && $93950e1158342634$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $04yIU.maybeMap(obj, function(v) {
            return v == null ? v : encoder(v, $93950e1158342634$var$defaults.encoder, charset, 'value', format);
        });
        objKeys = [
            {
                value: obj.length > 0 ? $04yIU.toCoercible(obj).join(',') || null : void 0
            }
        ];
    } else if ($93950e1158342634$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = String(prefix);
    var adjustedPrefix = commaRoundTrip && $93950e1158342634$var$isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;
    if (allowEmptyArrays && $93950e1158342634$var$isArray(obj) && obj.length === 0 && Object.keys(obj).length === 0) return adjustedPrefix + '[]';
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined' ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = $93950e1158342634$var$isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');
        sideChannel.set(object, step);
        var valueSideChannel = $fnMB2();
        valueSideChannel.set($93950e1158342634$var$sentinel, sideChannel);
        $93950e1158342634$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === 'comma' && encodeValuesOnly && $93950e1158342634$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel, depth, currentDepth + 1));
    }
    return values;
};
var $93950e1158342634$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $93950e1158342634$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') throw new TypeError('Encoder has to be a function.');
    var charset = opts.charset || $93950e1158342634$var$defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var format = $4qNLb.default;
    if (typeof opts.format !== 'undefined') {
        if (!$93950e1158342634$var$has.call($4qNLb.formatters, opts.format)) throw new TypeError('Unknown format option provided.');
        format = opts.format;
    }
    var formatter = $4qNLb.formatters[format];
    var filter = $93950e1158342634$var$defaults.filter;
    if (typeof opts.filter === 'function' || $93950e1158342634$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if ($93950e1158342634$var$has.call($93950e1158342634$var$arrayPrefixGenerators, opts.arrayFormat)) arrayFormat = opts.arrayFormat;
    else if ('indices' in opts) arrayFormat = opts.indices ? 'indices' : 'repeat';
    else arrayFormat = $93950e1158342634$var$defaults.arrayFormat;
    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : $93950e1158342634$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : $93950e1158342634$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $93950e1158342634$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $93950e1158342634$var$defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? $93950e1158342634$var$defaults.delimiter : opts.delimiter,
        depth: typeof opts.depth === 'number' ? opts.depth : $93950e1158342634$var$defaults.depth,
        encode: typeof opts.encode === 'boolean' ? opts.encode : $93950e1158342634$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : $93950e1158342634$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : $93950e1158342634$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : $93950e1158342634$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : $93950e1158342634$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : $93950e1158342634$var$defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $93950e1158342634$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $93950e1158342634$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if ($93950e1158342634$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== 'object' || obj === null) return '';
    var generateArrayPrefix = $93950e1158342634$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $fnMB2();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (typeof key === 'undefined' || key === null) continue;
        var value = obj[key];
        if (options.skipNulls && value === null) continue;
        var encodedKey = options.encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        $93950e1158342634$var$pushToArray(keys, $93950e1158342634$var$stringify(value, encodedKey, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel, options.depth, 0));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';
    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += 'utf8=%26%2310003%3B' + options.delimiter;
        else // encodeURIComponent('✓')
        prefix += 'utf8=%E2%9C%93' + options.delimiter;
    }
    return joined.length > 0 ? prefix + joined : '';
};

});
parcelRegister("fnMB2", function(module, exports) {
'use strict';

var $7YkL5 = parcelRequire("7YkL5");

var $9m1oK = parcelRequire("9m1oK");

var $bfm54 = parcelRequire("bfm54");

var $fq3xL = parcelRequire("fq3xL");

var $7R17S = parcelRequire("7R17S");
var $b32eb33dca38d853$var$makeChannel = $7R17S || $fq3xL || $bfm54;
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @typedef {ReturnType<typeof getSideChannel>} Channel */ /** @type {Channel | undefined} */ var $channelData;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) {
                var keyDesc = key && Object(key) === key ? 'the given object key' : $9m1oK(key);
                throw new $7YkL5('Side channel does not contain ' + keyDesc);
            }
        },
        'delete': function(key) {
            return !!$channelData && $channelData['delete'](key);
        },
        get: function(key) {
            return $channelData && $channelData.get(key);
        },
        has: function(key) {
            return !!$channelData && $channelData.has(key);
        },
        set: function(key, value) {
            if (!$channelData) $channelData = $b32eb33dca38d853$var$makeChannel();
            $channelData.set(key, value);
        }
    };
    return channel;
};

});
parcelRegister("7YkL5", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("9m1oK", function(module, exports) {
var $6cf740cbc1e9dd0a$var$hasMap = typeof Map === 'function' && Map.prototype;
var $6cf740cbc1e9dd0a$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $6cf740cbc1e9dd0a$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var $6cf740cbc1e9dd0a$var$mapSize = $6cf740cbc1e9dd0a$var$hasMap && $6cf740cbc1e9dd0a$var$mapSizeDescriptor && typeof $6cf740cbc1e9dd0a$var$mapSizeDescriptor.get === 'function' ? $6cf740cbc1e9dd0a$var$mapSizeDescriptor.get : null;
var $6cf740cbc1e9dd0a$var$mapForEach = $6cf740cbc1e9dd0a$var$hasMap && Map.prototype.forEach;
var $6cf740cbc1e9dd0a$var$hasSet = typeof Set === 'function' && Set.prototype;
var $6cf740cbc1e9dd0a$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $6cf740cbc1e9dd0a$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var $6cf740cbc1e9dd0a$var$setSize = $6cf740cbc1e9dd0a$var$hasSet && $6cf740cbc1e9dd0a$var$setSizeDescriptor && typeof $6cf740cbc1e9dd0a$var$setSizeDescriptor.get === 'function' ? $6cf740cbc1e9dd0a$var$setSizeDescriptor.get : null;
var $6cf740cbc1e9dd0a$var$setForEach = $6cf740cbc1e9dd0a$var$hasSet && Set.prototype.forEach;
var $6cf740cbc1e9dd0a$var$hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var $6cf740cbc1e9dd0a$var$weakMapHas = $6cf740cbc1e9dd0a$var$hasWeakMap ? WeakMap.prototype.has : null;
var $6cf740cbc1e9dd0a$var$hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var $6cf740cbc1e9dd0a$var$weakSetHas = $6cf740cbc1e9dd0a$var$hasWeakSet ? WeakSet.prototype.has : null;
var $6cf740cbc1e9dd0a$var$hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var $6cf740cbc1e9dd0a$var$weakRefDeref = $6cf740cbc1e9dd0a$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $6cf740cbc1e9dd0a$var$booleanValueOf = Boolean.prototype.valueOf;
var $6cf740cbc1e9dd0a$var$objectToString = Object.prototype.toString;
var $6cf740cbc1e9dd0a$var$functionToString = Function.prototype.toString;
var $6cf740cbc1e9dd0a$var$$match = String.prototype.match;
var $6cf740cbc1e9dd0a$var$$slice = String.prototype.slice;
var $6cf740cbc1e9dd0a$var$$replace = String.prototype.replace;
var $6cf740cbc1e9dd0a$var$$toUpperCase = String.prototype.toUpperCase;
var $6cf740cbc1e9dd0a$var$$toLowerCase = String.prototype.toLowerCase;
var $6cf740cbc1e9dd0a$var$$test = RegExp.prototype.test;
var $6cf740cbc1e9dd0a$var$$concat = Array.prototype.concat;
var $6cf740cbc1e9dd0a$var$$join = Array.prototype.join;
var $6cf740cbc1e9dd0a$var$$arrSlice = Array.prototype.slice;
var $6cf740cbc1e9dd0a$var$$floor = Math.floor;
var $6cf740cbc1e9dd0a$var$bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var $6cf740cbc1e9dd0a$var$gOPS = Object.getOwnPropertySymbols;
var $6cf740cbc1e9dd0a$var$symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var $6cf740cbc1e9dd0a$var$hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var $6cf740cbc1e9dd0a$var$toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === $6cf740cbc1e9dd0a$var$hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var $6cf740cbc1e9dd0a$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $6cf740cbc1e9dd0a$var$gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $6cf740cbc1e9dd0a$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $6cf740cbc1e9dd0a$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$6cf740cbc1e9dd0a$var$$floor(-num) : $6cf740cbc1e9dd0a$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $6cf740cbc1e9dd0a$var$$slice.call(str, intStr.length + 1);
            return $6cf740cbc1e9dd0a$var$$replace.call(intStr, sepRegex, '$&_') + '.' + $6cf740cbc1e9dd0a$var$$replace.call($6cf740cbc1e9dd0a$var$$replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $6cf740cbc1e9dd0a$var$$replace.call(str, sepRegex, '$&_');
}

var $7U0Mk = parcelRequire("7U0Mk");
var $6cf740cbc1e9dd0a$var$inspectCustom = $7U0Mk.custom;
var $6cf740cbc1e9dd0a$var$inspectSymbol = $6cf740cbc1e9dd0a$var$isSymbol($6cf740cbc1e9dd0a$var$inspectCustom) ? $6cf740cbc1e9dd0a$var$inspectCustom : null;
var $6cf740cbc1e9dd0a$var$quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var $6cf740cbc1e9dd0a$var$quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($6cf740cbc1e9dd0a$var$has(opts, 'quoteStyle') && !$6cf740cbc1e9dd0a$var$has($6cf740cbc1e9dd0a$var$quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($6cf740cbc1e9dd0a$var$has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $6cf740cbc1e9dd0a$var$has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    if ($6cf740cbc1e9dd0a$var$has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($6cf740cbc1e9dd0a$var$has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === 'undefined') return 'undefined';
    if (obj === null) return 'null';
    if (typeof obj === 'boolean') return obj ? 'true' : 'false';
    if (typeof obj === 'string') return $6cf740cbc1e9dd0a$var$inspectString(obj, opts);
    if (typeof obj === 'number') {
        if (obj === 0) return Infinity / obj > 0 ? '0' : '-0';
        var str = String(obj);
        return numericSeparator ? $6cf740cbc1e9dd0a$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? $6cf740cbc1e9dd0a$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') return $6cf740cbc1e9dd0a$var$isArray(obj) ? '[Array]' : '[Object]';
    var indent = $6cf740cbc1e9dd0a$var$getIndent(opts, depth);
    if (typeof seen === 'undefined') seen = [];
    else if ($6cf740cbc1e9dd0a$var$indexOf(seen, obj) >= 0) return '[Circular]';
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $6cf740cbc1e9dd0a$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($6cf740cbc1e9dd0a$var$has(opts, 'quoteStyle')) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === 'function' && !$6cf740cbc1e9dd0a$var$isRegExp(obj)) {
        var name = $6cf740cbc1e9dd0a$var$nameOf(obj);
        var keys = $6cf740cbc1e9dd0a$var$arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $6cf740cbc1e9dd0a$var$$join.call(keys, ', ') + ' }' : '');
    }
    if ($6cf740cbc1e9dd0a$var$isSymbol(obj)) {
        var symString = $6cf740cbc1e9dd0a$var$hasShammedSymbols ? $6cf740cbc1e9dd0a$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : $6cf740cbc1e9dd0a$var$symToString.call(obj);
        return typeof obj === 'object' && !$6cf740cbc1e9dd0a$var$hasShammedSymbols ? $6cf740cbc1e9dd0a$var$markBoxed(symString) : symString;
    }
    if ($6cf740cbc1e9dd0a$var$isElement(obj)) {
        var s = '<' + $6cf740cbc1e9dd0a$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += ' ' + attrs[i].name + '=' + $6cf740cbc1e9dd0a$var$wrapQuotes($6cf740cbc1e9dd0a$var$quote(attrs[i].value), 'double', opts);
        s += '>';
        if (obj.childNodes && obj.childNodes.length) s += '...';
        s += '</' + $6cf740cbc1e9dd0a$var$$toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if ($6cf740cbc1e9dd0a$var$isArray(obj)) {
        if (obj.length === 0) return '[]';
        var xs = $6cf740cbc1e9dd0a$var$arrObjKeys(obj, inspect);
        if (indent && !$6cf740cbc1e9dd0a$var$singleLineValues(xs)) return '[' + $6cf740cbc1e9dd0a$var$indentedJoin(xs, indent) + ']';
        return '[ ' + $6cf740cbc1e9dd0a$var$$join.call(xs, ', ') + ' ]';
    }
    if ($6cf740cbc1e9dd0a$var$isError(obj)) {
        var parts = $6cf740cbc1e9dd0a$var$arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !$6cf740cbc1e9dd0a$var$isEnumerable.call(obj, 'cause')) return '{ [' + String(obj) + '] ' + $6cf740cbc1e9dd0a$var$$join.call($6cf740cbc1e9dd0a$var$$concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        if (parts.length === 0) return '[' + String(obj) + ']';
        return '{ [' + String(obj) + '] ' + $6cf740cbc1e9dd0a$var$$join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if ($6cf740cbc1e9dd0a$var$inspectSymbol && typeof obj[$6cf740cbc1e9dd0a$var$inspectSymbol] === 'function' && $7U0Mk) return $7U0Mk(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') return obj.inspect();
    }
    if ($6cf740cbc1e9dd0a$var$isMap(obj)) {
        var mapParts = [];
        if ($6cf740cbc1e9dd0a$var$mapForEach) $6cf740cbc1e9dd0a$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return $6cf740cbc1e9dd0a$var$collectionOf('Map', $6cf740cbc1e9dd0a$var$mapSize.call(obj), mapParts, indent);
    }
    if ($6cf740cbc1e9dd0a$var$isSet(obj)) {
        var setParts = [];
        if ($6cf740cbc1e9dd0a$var$setForEach) $6cf740cbc1e9dd0a$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $6cf740cbc1e9dd0a$var$collectionOf('Set', $6cf740cbc1e9dd0a$var$setSize.call(obj), setParts, indent);
    }
    if ($6cf740cbc1e9dd0a$var$isWeakMap(obj)) return $6cf740cbc1e9dd0a$var$weakCollectionOf('WeakMap');
    if ($6cf740cbc1e9dd0a$var$isWeakSet(obj)) return $6cf740cbc1e9dd0a$var$weakCollectionOf('WeakSet');
    if ($6cf740cbc1e9dd0a$var$isWeakRef(obj)) return $6cf740cbc1e9dd0a$var$weakCollectionOf('WeakRef');
    if ($6cf740cbc1e9dd0a$var$isNumber(obj)) return $6cf740cbc1e9dd0a$var$markBoxed(inspect(Number(obj)));
    if ($6cf740cbc1e9dd0a$var$isBigInt(obj)) return $6cf740cbc1e9dd0a$var$markBoxed(inspect($6cf740cbc1e9dd0a$var$bigIntValueOf.call(obj)));
    if ($6cf740cbc1e9dd0a$var$isBoolean(obj)) return $6cf740cbc1e9dd0a$var$markBoxed($6cf740cbc1e9dd0a$var$booleanValueOf.call(obj));
    if ($6cf740cbc1e9dd0a$var$isString(obj)) return $6cf740cbc1e9dd0a$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== 'undefined' && obj === window) return '{ [object Window] }';
    if (typeof globalThis !== 'undefined' && obj === globalThis || typeof $parcel$global !== 'undefined' && obj === $parcel$global) return '{ [object globalThis] }';
    if (!$6cf740cbc1e9dd0a$var$isDate(obj) && !$6cf740cbc1e9dd0a$var$isRegExp(obj)) {
        var ys = $6cf740cbc1e9dd0a$var$arrObjKeys(obj, inspect);
        var isPlainObject = $6cf740cbc1e9dd0a$var$gPO ? $6cf740cbc1e9dd0a$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && $6cf740cbc1e9dd0a$var$toStringTag && Object(obj) === obj && $6cf740cbc1e9dd0a$var$toStringTag in obj ? $6cf740cbc1e9dd0a$var$$slice.call($6cf740cbc1e9dd0a$var$toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $6cf740cbc1e9dd0a$var$$join.call($6cf740cbc1e9dd0a$var$$concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) return tag + '{}';
        if (indent) return tag + '{' + $6cf740cbc1e9dd0a$var$indentedJoin(ys, indent) + '}';
        return tag + '{ ' + $6cf740cbc1e9dd0a$var$$join.call(ys, ', ') + ' }';
    }
    return String(obj);
};
function $6cf740cbc1e9dd0a$var$wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = $6cf740cbc1e9dd0a$var$quotes[style];
    return quoteChar + s + quoteChar;
}
function $6cf740cbc1e9dd0a$var$quote(s) {
    return $6cf740cbc1e9dd0a$var$$replace.call(String(s), /"/g, '&quot;');
}
function $6cf740cbc1e9dd0a$var$canTrustToString(obj) {
    return !$6cf740cbc1e9dd0a$var$toStringTag || !(typeof obj === 'object' && ($6cf740cbc1e9dd0a$var$toStringTag in obj || typeof obj[$6cf740cbc1e9dd0a$var$toStringTag] !== 'undefined'));
}
function $6cf740cbc1e9dd0a$var$isArray(obj) {
    return $6cf740cbc1e9dd0a$var$toStr(obj) === '[object Array]' && $6cf740cbc1e9dd0a$var$canTrustToString(obj);
}
function $6cf740cbc1e9dd0a$var$isDate(obj) {
    return $6cf740cbc1e9dd0a$var$toStr(obj) === '[object Date]' && $6cf740cbc1e9dd0a$var$canTrustToString(obj);
}
function $6cf740cbc1e9dd0a$var$isRegExp(obj) {
    return $6cf740cbc1e9dd0a$var$toStr(obj) === '[object RegExp]' && $6cf740cbc1e9dd0a$var$canTrustToString(obj);
}
function $6cf740cbc1e9dd0a$var$isError(obj) {
    return $6cf740cbc1e9dd0a$var$toStr(obj) === '[object Error]' && $6cf740cbc1e9dd0a$var$canTrustToString(obj);
}
function $6cf740cbc1e9dd0a$var$isString(obj) {
    return $6cf740cbc1e9dd0a$var$toStr(obj) === '[object String]' && $6cf740cbc1e9dd0a$var$canTrustToString(obj);
}
function $6cf740cbc1e9dd0a$var$isNumber(obj) {
    return $6cf740cbc1e9dd0a$var$toStr(obj) === '[object Number]' && $6cf740cbc1e9dd0a$var$canTrustToString(obj);
}
function $6cf740cbc1e9dd0a$var$isBoolean(obj) {
    return $6cf740cbc1e9dd0a$var$toStr(obj) === '[object Boolean]' && $6cf740cbc1e9dd0a$var$canTrustToString(obj);
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $6cf740cbc1e9dd0a$var$isSymbol(obj) {
    if ($6cf740cbc1e9dd0a$var$hasShammedSymbols) return obj && typeof obj === 'object' && obj instanceof Symbol;
    if (typeof obj === 'symbol') return true;
    if (!obj || typeof obj !== 'object' || !$6cf740cbc1e9dd0a$var$symToString) return false;
    try {
        $6cf740cbc1e9dd0a$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $6cf740cbc1e9dd0a$var$isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !$6cf740cbc1e9dd0a$var$bigIntValueOf) return false;
    try {
        $6cf740cbc1e9dd0a$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $6cf740cbc1e9dd0a$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $6cf740cbc1e9dd0a$var$has(obj, key) {
    return $6cf740cbc1e9dd0a$var$hasOwn.call(obj, key);
}
function $6cf740cbc1e9dd0a$var$toStr(obj) {
    return $6cf740cbc1e9dd0a$var$objectToString.call(obj);
}
function $6cf740cbc1e9dd0a$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $6cf740cbc1e9dd0a$var$$match.call($6cf740cbc1e9dd0a$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $6cf740cbc1e9dd0a$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $6cf740cbc1e9dd0a$var$isMap(x) {
    if (!$6cf740cbc1e9dd0a$var$mapSize || !x || typeof x !== 'object') return false;
    try {
        $6cf740cbc1e9dd0a$var$mapSize.call(x);
        try {
            $6cf740cbc1e9dd0a$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $6cf740cbc1e9dd0a$var$isWeakMap(x) {
    if (!$6cf740cbc1e9dd0a$var$weakMapHas || !x || typeof x !== 'object') return false;
    try {
        $6cf740cbc1e9dd0a$var$weakMapHas.call(x, $6cf740cbc1e9dd0a$var$weakMapHas);
        try {
            $6cf740cbc1e9dd0a$var$weakSetHas.call(x, $6cf740cbc1e9dd0a$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $6cf740cbc1e9dd0a$var$isWeakRef(x) {
    if (!$6cf740cbc1e9dd0a$var$weakRefDeref || !x || typeof x !== 'object') return false;
    try {
        $6cf740cbc1e9dd0a$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $6cf740cbc1e9dd0a$var$isSet(x) {
    if (!$6cf740cbc1e9dd0a$var$setSize || !x || typeof x !== 'object') return false;
    try {
        $6cf740cbc1e9dd0a$var$setSize.call(x);
        try {
            $6cf740cbc1e9dd0a$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $6cf740cbc1e9dd0a$var$isWeakSet(x) {
    if (!$6cf740cbc1e9dd0a$var$weakSetHas || !x || typeof x !== 'object') return false;
    try {
        $6cf740cbc1e9dd0a$var$weakSetHas.call(x, $6cf740cbc1e9dd0a$var$weakSetHas);
        try {
            $6cf740cbc1e9dd0a$var$weakMapHas.call(x, $6cf740cbc1e9dd0a$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $6cf740cbc1e9dd0a$var$isElement(x) {
    if (!x || typeof x !== 'object') return false;
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) return true;
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function $6cf740cbc1e9dd0a$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return $6cf740cbc1e9dd0a$var$inspectString($6cf740cbc1e9dd0a$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = $6cf740cbc1e9dd0a$var$quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $6cf740cbc1e9dd0a$var$$replace.call($6cf740cbc1e9dd0a$var$$replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, $6cf740cbc1e9dd0a$var$lowbyte);
    return $6cf740cbc1e9dd0a$var$wrapQuotes(s, 'single', opts);
}
function $6cf740cbc1e9dd0a$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) return '\\' + x;
    return '\\x' + (n < 0x10 ? '0' : '') + $6cf740cbc1e9dd0a$var$$toUpperCase.call(n.toString(16));
}
function $6cf740cbc1e9dd0a$var$markBoxed(str) {
    return 'Object(' + str + ')';
}
function $6cf740cbc1e9dd0a$var$weakCollectionOf(type) {
    return type + ' { ? }';
}
function $6cf740cbc1e9dd0a$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $6cf740cbc1e9dd0a$var$indentedJoin(entries, indent) : $6cf740cbc1e9dd0a$var$$join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}
function $6cf740cbc1e9dd0a$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($6cf740cbc1e9dd0a$var$indexOf(xs[i], '\n') >= 0) return false;
    }
    return true;
}
function $6cf740cbc1e9dd0a$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') baseIndent = '\t';
    else if (typeof opts.indent === 'number' && opts.indent > 0) baseIndent = $6cf740cbc1e9dd0a$var$$join.call(Array(opts.indent + 1), ' ');
    else return null;
    return {
        base: baseIndent,
        prev: $6cf740cbc1e9dd0a$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $6cf740cbc1e9dd0a$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return '';
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $6cf740cbc1e9dd0a$var$$join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function $6cf740cbc1e9dd0a$var$arrObjKeys(obj, inspect) {
    var isArr = $6cf740cbc1e9dd0a$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $6cf740cbc1e9dd0a$var$has(obj, i) ? inspect(obj[i], obj) : '';
    }
    var syms = typeof $6cf740cbc1e9dd0a$var$gOPS === 'function' ? $6cf740cbc1e9dd0a$var$gOPS(obj) : [];
    var symMap;
    if ($6cf740cbc1e9dd0a$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap['$' + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$6cf740cbc1e9dd0a$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($6cf740cbc1e9dd0a$var$hasShammedSymbols && symMap['$' + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($6cf740cbc1e9dd0a$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        else xs.push(key + ': ' + inspect(obj[key], obj));
    }
    if (typeof $6cf740cbc1e9dd0a$var$gOPS === 'function') {
        for(var j = 0; j < syms.length; j++)if ($6cf740cbc1e9dd0a$var$isEnumerable.call(obj, syms[j])) xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});

parcelRegister("bfm54", function(module, exports) {
'use strict';

var $9m1oK = parcelRequire("9m1oK");

var $7YkL5 = parcelRequire("7YkL5");
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('./list.d.ts').listGetNode} */ // eslint-disable-next-line consistent-return
var $83023938c97438a1$var$listGetNode = function(list, key, isDelete) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    // eslint-disable-next-line eqeqeq
    for(; (curr = prev.next) != null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        if (!isDelete) {
            // eslint-disable-next-line no-extra-parens
            curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
            list.next = curr; // eslint-disable-line no-param-reassign
        }
        return curr;
    }
};
/** @type {import('./list.d.ts').listGet} */ var $83023938c97438a1$var$listGet = function(objects, key) {
    if (!objects) return void 0;
    var node = $83023938c97438a1$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */ var $83023938c97438a1$var$listSet = function(objects, key, value) {
    var node = $83023938c97438a1$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('./list.d.ts').listHas} */ var $83023938c97438a1$var$listHas = function(objects, key) {
    if (!objects) return false;
    return !!$83023938c97438a1$var$listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */ // eslint-disable-next-line consistent-return
var $83023938c97438a1$var$listDelete = function(objects, key) {
    if (objects) return $83023938c97438a1$var$listGetNode(objects, key, true);
};
/** @type {import('.')} */ module.exports = function getSideChannelList() {
    /** @typedef {ReturnType<typeof getSideChannelList>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $7YkL5('Side channel does not contain ' + $9m1oK(key));
        },
        'delete': function(key) {
            var deletedNode = $83023938c97438a1$var$listDelete($o, key);
            if (deletedNode && $o && !$o.next) $o = void 0;
            return !!deletedNode;
        },
        get: function(key) {
            return $83023938c97438a1$var$listGet($o, key);
        },
        has: function(key) {
            return $83023938c97438a1$var$listHas($o, key);
        },
        set: function(key, value) {
            if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
            $o = {
                next: void 0
            };
            // eslint-disable-next-line no-extra-parens
            $83023938c97438a1$var$listSet(/** @type {NonNullable<typeof $o>} */ $o, key, value);
        }
    };
    return channel;
};

});

parcelRegister("fq3xL", function(module, exports) {
'use strict';

var $7uWfV = parcelRequire("7uWfV");

var $2ToJh = parcelRequire("2ToJh");

var $9m1oK = parcelRequire("9m1oK");

var $7YkL5 = parcelRequire("7YkL5");
var $b39c086177e9c6a8$var$$Map = $7uWfV('%Map%', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */ var $b39c086177e9c6a8$var$$mapGet = $2ToJh('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */ var $b39c086177e9c6a8$var$$mapSet = $2ToJh('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $b39c086177e9c6a8$var$$mapHas = $2ToJh('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $b39c086177e9c6a8$var$$mapDelete = $2ToJh('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */ var $b39c086177e9c6a8$var$$mapSize = $2ToJh('Map.prototype.size', true);
/** @type {import('.')} */ module.exports = !!$b39c086177e9c6a8$var$$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
    /** @typedef {ReturnType<typeof getSideChannelMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {Map<K, V> | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $7YkL5('Side channel does not contain ' + $9m1oK(key));
        },
        'delete': function(key) {
            if ($m) {
                var result = $b39c086177e9c6a8$var$$mapDelete($m, key);
                if ($b39c086177e9c6a8$var$$mapSize($m) === 0) $m = void 0;
                return result;
            }
            return false;
        },
        get: function(key) {
            if ($m) return $b39c086177e9c6a8$var$$mapGet($m, key);
        },
        has: function(key) {
            if ($m) return $b39c086177e9c6a8$var$$mapHas($m, key);
            return false;
        },
        set: function(key, value) {
            if (!$m) // @ts-expect-error TS can't handle narrowing a variable inside a closure
            $m = new $b39c086177e9c6a8$var$$Map();
            $b39c086177e9c6a8$var$$mapSet($m, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why TS is erroring here
    return channel;
};

});
parcelRegister("7uWfV", function(module, exports) {
'use strict';
var $57588624034e2d46$var$undefined1;

var $b1f9x = parcelRequire("b1f9x");

var $6lZZZ = parcelRequire("6lZZZ");

var $9amJ3 = parcelRequire("9amJ3");

var $bFjYa = parcelRequire("bFjYa");

var $cJnFv = parcelRequire("cJnFv");

var $bAtI6 = parcelRequire("bAtI6");

var $7YkL5 = parcelRequire("7YkL5");

var $4f3Qm = parcelRequire("4f3Qm");

var $gR96v = parcelRequire("gR96v");

var $iKNav = parcelRequire("iKNav");

var $2OvbK = parcelRequire("2OvbK");

var $dpPwC = parcelRequire("dpPwC");

var $3yiFN = parcelRequire("3yiFN");

var $grHmy = parcelRequire("grHmy");

var $dbx5V = parcelRequire("dbx5V");
var $57588624034e2d46$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $57588624034e2d46$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $57588624034e2d46$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $2f2Cz = parcelRequire("2f2Cz");

var $73g4T = parcelRequire("73g4T");
var $57588624034e2d46$var$throwTypeError = function() {
    throw new $7YkL5();
};
var $57588624034e2d46$var$ThrowTypeError = $2f2Cz ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $57588624034e2d46$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $2f2Cz(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $57588624034e2d46$var$throwTypeError;
        }
    }
}() : $57588624034e2d46$var$throwTypeError;

var $57588624034e2d46$var$hasSymbols = (parcelRequire("kfUr0"))();

var $2jtw2 = parcelRequire("2jtw2");

var $hTo8i = parcelRequire("hTo8i");

var $cH1WN = parcelRequire("cH1WN");

var $9AD7g = parcelRequire("9AD7g");

var $3nrRj = parcelRequire("3nrRj");
var $57588624034e2d46$var$needsEval = {};
var $57588624034e2d46$var$TypedArray = typeof Uint8Array === 'undefined' || !$2jtw2 ? undefined : $2jtw2(Uint8Array);
var $57588624034e2d46$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $57588624034e2d46$var$hasSymbols && $2jtw2 ? $2jtw2([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $57588624034e2d46$var$needsEval,
    '%AsyncGenerator%': $57588624034e2d46$var$needsEval,
    '%AsyncGeneratorFunction%': $57588624034e2d46$var$needsEval,
    '%AsyncIteratorPrototype%': $57588624034e2d46$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $6lZZZ,
    '%eval%': eval,
    '%EvalError%': $9amJ3,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $57588624034e2d46$var$$Function,
    '%GeneratorFunction%': $57588624034e2d46$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $57588624034e2d46$var$hasSymbols && $2jtw2 ? $2jtw2($2jtw2([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$57588624034e2d46$var$hasSymbols || !$2jtw2 ? undefined : $2jtw2(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $b1f9x,
    '%Object.getOwnPropertyDescriptor%': $2f2Cz,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $bFjYa,
    '%ReferenceError%': $cJnFv,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$57588624034e2d46$var$hasSymbols || !$2jtw2 ? undefined : $2jtw2(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $57588624034e2d46$var$hasSymbols && $2jtw2 ? $2jtw2(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $57588624034e2d46$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $bAtI6,
    '%ThrowTypeError%': $57588624034e2d46$var$ThrowTypeError,
    '%TypedArray%': $57588624034e2d46$var$TypedArray,
    '%TypeError%': $7YkL5,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $4f3Qm,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $3nrRj,
    '%Function.prototype.apply%': $9AD7g,
    '%Object.defineProperty%': $73g4T,
    '%Object.getPrototypeOf%': $hTo8i,
    '%Math.abs%': $gR96v,
    '%Math.floor%': $iKNav,
    '%Math.max%': $2OvbK,
    '%Math.min%': $dpPwC,
    '%Math.pow%': $3yiFN,
    '%Math.round%': $grHmy,
    '%Math.sign%': $dbx5V,
    '%Reflect.getPrototypeOf%': $cH1WN
};
if ($2jtw2) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $57588624034e2d46$var$errorProto = $2jtw2($2jtw2(e));
    $57588624034e2d46$var$INTRINSICS['%Error.prototype%'] = $57588624034e2d46$var$errorProto;
}
var $57588624034e2d46$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $57588624034e2d46$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $57588624034e2d46$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $57588624034e2d46$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $2jtw2) value = $2jtw2(gen.prototype);
    }
    $57588624034e2d46$var$INTRINSICS[name] = value;
    return value;
};
var $57588624034e2d46$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $5ciuu = parcelRequire("5ciuu");

var $bbrZs = parcelRequire("bbrZs");
var $57588624034e2d46$var$$concat = $5ciuu.call($3nrRj, Array.prototype.concat);
var $57588624034e2d46$var$$spliceApply = $5ciuu.call($9AD7g, Array.prototype.splice);
var $57588624034e2d46$var$$replace = $5ciuu.call($3nrRj, String.prototype.replace);
var $57588624034e2d46$var$$strSlice = $5ciuu.call($3nrRj, String.prototype.slice);
var $57588624034e2d46$var$$exec = $5ciuu.call($3nrRj, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $57588624034e2d46$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $57588624034e2d46$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $57588624034e2d46$var$stringToPath = function stringToPath(string) {
    var first = $57588624034e2d46$var$$strSlice(string, 0, 1);
    var last = $57588624034e2d46$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $bAtI6('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $bAtI6('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $57588624034e2d46$var$$replace(string, $57588624034e2d46$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $57588624034e2d46$var$$replace(subString, $57588624034e2d46$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $57588624034e2d46$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($bbrZs($57588624034e2d46$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $57588624034e2d46$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($bbrZs($57588624034e2d46$var$INTRINSICS, intrinsicName)) {
        var value = $57588624034e2d46$var$INTRINSICS[intrinsicName];
        if (value === $57588624034e2d46$var$needsEval) value = $57588624034e2d46$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $7YkL5('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $bAtI6('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $7YkL5('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $7YkL5('"allowMissing" argument must be a boolean');
    if ($57588624034e2d46$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $bAtI6('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $57588624034e2d46$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $57588624034e2d46$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $57588624034e2d46$var$$spliceApply(parts, $57588624034e2d46$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $57588624034e2d46$var$$strSlice(part, 0, 1);
        var last = $57588624034e2d46$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $bAtI6('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($bbrZs($57588624034e2d46$var$INTRINSICS, intrinsicRealName)) value = $57588624034e2d46$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $7YkL5('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($2f2Cz && i + 1 >= parts.length) {
                var desc = $2f2Cz(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $bbrZs(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $57588624034e2d46$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("b1f9x", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("6lZZZ", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("9amJ3", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("bFjYa", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("cJnFv", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("bAtI6", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("4f3Qm", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("gR96v", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("iKNav", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("2OvbK", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("dpPwC", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("3yiFN", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("grHmy", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("dbx5V", function(module, exports) {
'use strict';

var $bSpLh = parcelRequire("bSpLh");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($bSpLh(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("bSpLh", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("2f2Cz", function(module, exports) {
'use strict';

var $fN961 = parcelRequire("fN961");
var $1a1f03f51e7d97eb$require$$gOPD = $fN961;
if ($1a1f03f51e7d97eb$require$$gOPD) try {
    $1a1f03f51e7d97eb$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $1a1f03f51e7d97eb$require$$gOPD = null;
}
module.exports = $1a1f03f51e7d97eb$require$$gOPD;

});
parcelRegister("fN961", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("73g4T", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $522548f70a012fed$var$$defineProperty = Object.defineProperty || false;
if ($522548f70a012fed$var$$defineProperty) try {
    $522548f70a012fed$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $522548f70a012fed$var$$defineProperty = false;
}
module.exports = $522548f70a012fed$var$$defineProperty;

});

parcelRegister("2jtw2", function(module, exports) {
'use strict';

var $cH1WN = parcelRequire("cH1WN");

var $hTo8i = parcelRequire("hTo8i");

var $4b3aA = parcelRequire("4b3aA");
/** @type {import('.')} */ module.exports = $cH1WN ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $cH1WN(O);
} : $hTo8i ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $hTo8i(O);
} : $4b3aA ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $4b3aA(O);
} : null;

});
parcelRegister("cH1WN", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("hTo8i", function(module, exports) {
'use strict';

var $b1f9x = parcelRequire("b1f9x");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $b1f9x.getPrototypeOf || null;

});

parcelRegister("4b3aA", function(module, exports) {
'use strict';

var $3xCIr = parcelRequire("3xCIr");

var $2f2Cz = parcelRequire("2f2Cz");
var $30aaa5f637596e25$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $30aaa5f637596e25$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $30aaa5f637596e25$var$desc = !!$30aaa5f637596e25$var$hasProtoAccessor && $2f2Cz && $2f2Cz(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $30aaa5f637596e25$var$$Object = Object;
var $30aaa5f637596e25$var$$getPrototypeOf = $30aaa5f637596e25$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $30aaa5f637596e25$var$desc && typeof $30aaa5f637596e25$var$desc.get === 'function' ? $3xCIr([
    $30aaa5f637596e25$var$desc.get
]) : typeof $30aaa5f637596e25$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $30aaa5f637596e25$var$$getPrototypeOf(value == null ? value : $30aaa5f637596e25$var$$Object(value));
} : false;

});
parcelRegister("3xCIr", function(module, exports) {
'use strict';

var $bnZe2 = parcelRequire("bnZe2");

var $7YkL5 = parcelRequire("7YkL5");

var $3nrRj = parcelRequire("3nrRj");

var $fipYV = parcelRequire("fipYV");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $7YkL5('a function is required');
    return $fipYV($bnZe2, $3nrRj, args);
};

});
parcelRegister("bnZe2", function(module, exports) {
'use strict';

var $3JedN = parcelRequire("3JedN");
module.exports = Function.prototype.bind || $3JedN;

});
parcelRegister("3JedN", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $2b709b2e7f906f79$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $2b709b2e7f906f79$var$toStr = Object.prototype.toString;
var $2b709b2e7f906f79$var$max = Math.max;
var $2b709b2e7f906f79$var$funcType = '[object Function]';
var $2b709b2e7f906f79$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $2b709b2e7f906f79$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $2b709b2e7f906f79$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $2b709b2e7f906f79$var$toStr.apply(target) !== $2b709b2e7f906f79$var$funcType) throw new TypeError($2b709b2e7f906f79$var$ERROR_MESSAGE + target);
    var args = $2b709b2e7f906f79$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $2b709b2e7f906f79$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $2b709b2e7f906f79$var$concatty(args, arguments));
    };
    var boundLength = $2b709b2e7f906f79$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $2b709b2e7f906f79$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("3nrRj", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("fipYV", function(module, exports) {
'use strict';

var $bnZe2 = parcelRequire("bnZe2");

var $9AD7g = parcelRequire("9AD7g");

var $3nrRj = parcelRequire("3nrRj");

var $4ReFE = parcelRequire("4ReFE");
/** @type {import('./actualApply')} */ module.exports = $4ReFE || $bnZe2.call($3nrRj, $9AD7g);

});
parcelRegister("9AD7g", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("4ReFE", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("5ciuu", function(module, exports) {
'use strict';

var $V2wyF = parcelRequire("V2wyF");
module.exports = Function.prototype.bind || $V2wyF;

});
parcelRegister("V2wyF", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $0ab74839b7138040$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $0ab74839b7138040$var$toStr = Object.prototype.toString;
var $0ab74839b7138040$var$max = Math.max;
var $0ab74839b7138040$var$funcType = '[object Function]';
var $0ab74839b7138040$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $0ab74839b7138040$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $0ab74839b7138040$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $0ab74839b7138040$var$toStr.apply(target) !== $0ab74839b7138040$var$funcType) throw new TypeError($0ab74839b7138040$var$ERROR_MESSAGE + target);
    var args = $0ab74839b7138040$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $0ab74839b7138040$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $0ab74839b7138040$var$concatty(args, arguments));
    };
    var boundLength = $0ab74839b7138040$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $0ab74839b7138040$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("bbrZs", function(module, exports) {
'use strict';
var $82466f1234ea4841$var$call = Function.prototype.call;
var $82466f1234ea4841$var$$hasOwn = Object.prototype.hasOwnProperty;

var $8HhPX = parcelRequire("8HhPX");
/** @type {import('.')} */ module.exports = $8HhPX.call($82466f1234ea4841$var$call, $82466f1234ea4841$var$$hasOwn);

});
parcelRegister("8HhPX", function(module, exports) {
'use strict';

var $lsZhT = parcelRequire("lsZhT");
module.exports = Function.prototype.bind || $lsZhT;

});
parcelRegister("lsZhT", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $fa0bc0f6d09bc8cf$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $fa0bc0f6d09bc8cf$var$toStr = Object.prototype.toString;
var $fa0bc0f6d09bc8cf$var$max = Math.max;
var $fa0bc0f6d09bc8cf$var$funcType = '[object Function]';
var $fa0bc0f6d09bc8cf$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $fa0bc0f6d09bc8cf$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $fa0bc0f6d09bc8cf$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $fa0bc0f6d09bc8cf$var$toStr.apply(target) !== $fa0bc0f6d09bc8cf$var$funcType) throw new TypeError($fa0bc0f6d09bc8cf$var$ERROR_MESSAGE + target);
    var args = $fa0bc0f6d09bc8cf$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $fa0bc0f6d09bc8cf$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $fa0bc0f6d09bc8cf$var$concatty(args, arguments));
    };
    var boundLength = $fa0bc0f6d09bc8cf$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $fa0bc0f6d09bc8cf$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});




parcelRegister("2ToJh", function(module, exports) {
'use strict';

var $7uWfV = parcelRequire("7uWfV");

var $3xCIr = parcelRequire("3xCIr");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $21b3e693ece4af73$var$$indexOf = $3xCIr([
    $7uWfV('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $7uWfV(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $21b3e693ece4af73$var$$indexOf(name, '.prototype.') > -1) return $3xCIr(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});


parcelRegister("7R17S", function(module, exports) {
'use strict';

var $7uWfV = parcelRequire("7uWfV");

var $2ToJh = parcelRequire("2ToJh");

var $9m1oK = parcelRequire("9m1oK");

var $fq3xL = parcelRequire("fq3xL");

var $7YkL5 = parcelRequire("7YkL5");
var $5b7e5b3f1592ffe9$var$$WeakMap = $7uWfV('%WeakMap%', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */ var $5b7e5b3f1592ffe9$var$$weakMapGet = $2ToJh('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */ var $5b7e5b3f1592ffe9$var$$weakMapSet = $2ToJh('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $5b7e5b3f1592ffe9$var$$weakMapHas = $2ToJh('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $5b7e5b3f1592ffe9$var$$weakMapDelete = $2ToJh('WeakMap.prototype.delete', true);
/** @type {import('.')} */ module.exports = $5b7e5b3f1592ffe9$var$$WeakMap ? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
    /** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {WeakMap<K & object, V> | undefined} */ var $wm;
    /** @type {Channel | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $7YkL5('Side channel does not contain ' + $9m1oK(key));
        },
        'delete': function(key) {
            if ($5b7e5b3f1592ffe9$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $5b7e5b3f1592ffe9$var$$weakMapDelete($wm, key);
            } else if ($fq3xL) {
                if ($m) return $m['delete'](key);
            }
            return false;
        },
        get: function(key) {
            if ($5b7e5b3f1592ffe9$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $5b7e5b3f1592ffe9$var$$weakMapGet($wm, key);
            }
            return $m && $m.get(key);
        },
        has: function(key) {
            if ($5b7e5b3f1592ffe9$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $5b7e5b3f1592ffe9$var$$weakMapHas($wm, key);
            }
            return !!$m && $m.has(key);
        },
        set: function(key, value) {
            if ($5b7e5b3f1592ffe9$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if (!$wm) $wm = new $5b7e5b3f1592ffe9$var$$WeakMap();
                $5b7e5b3f1592ffe9$var$$weakMapSet($wm, key, value);
            } else if ($fq3xL) {
                if (!$m) $m = $fq3xL();
                // eslint-disable-next-line no-extra-parens
                /** @type {NonNullable<typeof $m>} */ $m.set(key, value);
            }
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
} : $fq3xL;

});


parcelRegister("04yIU", function(module, exports) {
'use strict';

var $4qNLb = parcelRequire("4qNLb");

var $fnMB2 = parcelRequire("fnMB2");

var $73g4T = parcelRequire("73g4T");
var $00db4f28354840f4$var$has = Object.prototype.hasOwnProperty;
var $00db4f28354840f4$var$isArray = Array.isArray;
// Track objects created from arrayLimit overflow using side-channel
// Stores the current max numeric index for O(1) lookup
var $00db4f28354840f4$var$overflowChannel = $fnMB2();
var $00db4f28354840f4$var$markOverflow = function markOverflow(obj, maxIndex) {
    $00db4f28354840f4$var$overflowChannel.set(obj, maxIndex);
    return obj;
};
var $00db4f28354840f4$var$isOverflow = function isOverflow(obj) {
    return $00db4f28354840f4$var$overflowChannel.has(obj);
};
var $00db4f28354840f4$var$getMaxIndex = function getMaxIndex(obj) {
    return $00db4f28354840f4$var$overflowChannel.get(obj);
};
var $00db4f28354840f4$var$setMaxIndex = function setMaxIndex(obj, maxIndex) {
    $00db4f28354840f4$var$overflowChannel.set(obj, maxIndex);
};
// Track containers produced by a `strictMerge` conflict wrap, and their current max numeric index,
// so repeated conflicts on one path append instead of nesting a new wrapper each time
var $00db4f28354840f4$var$conflictChannel = $fnMB2();
var $00db4f28354840f4$var$markConflict = function markConflict(obj, maxIndex) {
    $00db4f28354840f4$var$conflictChannel.set(obj, maxIndex);
    return obj;
};
var $00db4f28354840f4$var$isConflict = function isConflict(obj) {
    return $00db4f28354840f4$var$conflictChannel.has(obj);
};
var $00db4f28354840f4$var$getConflictIndex = function getConflictIndex(obj) {
    return $00db4f28354840f4$var$conflictChannel.get(obj);
};
var $00db4f28354840f4$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array[array.length] = '%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase();
    return array;
}();
var $00db4f28354840f4$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($00db4f28354840f4$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== 'undefined') compacted[compacted.length] = obj[j];
            item.obj[item.prop] = compacted;
        }
    }
};
var $00db4f28354840f4$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? {
        __proto__: null
    } : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== 'undefined') obj[i] = source[i];
    return obj;
};
var $00db4f28354840f4$var$setProperty = function setProperty(obj, key, value) {
    if (key === '__proto__' && $73g4T) $73g4T(obj, key, {
        configurable: true,
        enumerable: true,
        value: value,
        writable: true
    });
    else obj[key] = value;
};
var $00db4f28354840f4$var$maxNumericIndex = function maxNumericIndex(obj, min) {
    var max = min;
    var keys = Object.keys(obj);
    for(var i = 0; i < keys.length; ++i){
        var num = parseInt(keys[i], 10);
        if (String(num) === keys[i] && num > max) max = num;
    }
    return max;
};
var $00db4f28354840f4$var$limitedPair = function limitedPair(first, second, options) {
    var pair = [
        first,
        second
    ];
    if (options && typeof options.arrayLimit === 'number' && pair.length > options.arrayLimit) {
        if (options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
        return $00db4f28354840f4$var$markOverflow($00db4f28354840f4$var$arrayToObject(pair, options), 1);
    }
    return pair;
};
var $00db4f28354840f4$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== 'object' && typeof source !== 'function') {
        if ($00db4f28354840f4$var$isArray(target)) {
            var nextIndex = target.length;
            if (options && typeof options.arrayLimit === 'number' && nextIndex >= options.arrayLimit) {
                if (options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
                return $00db4f28354840f4$var$markOverflow($00db4f28354840f4$var$arrayToObject(target.concat(source), options), nextIndex);
            }
            target[nextIndex] = source;
        } else if (target && typeof target === 'object') {
            if ($00db4f28354840f4$var$isOverflow(target)) {
                // Add at next numeric index for overflow objects
                var newIndex = $00db4f28354840f4$var$getMaxIndex(target) + 1;
                target[newIndex] = source;
                $00db4f28354840f4$var$setMaxIndex(target, newIndex);
            } else if (options && options.strictMerge && $00db4f28354840f4$var$isConflict(target)) {
                var nextConflict = $00db4f28354840f4$var$getConflictIndex(target) + 1;
                if (options.throwOnLimitExceeded && typeof options.arrayLimit === 'number' && nextConflict >= options.arrayLimit) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
                target[nextConflict] = source;
                $00db4f28354840f4$var$markConflict(target, nextConflict);
            } else if (options && options.strictMerge) {
                var conflict = $00db4f28354840f4$var$limitedPair(target, source, options);
                return $00db4f28354840f4$var$isArray(conflict) ? $00db4f28354840f4$var$markConflict(conflict, 1) : conflict;
            } else if (options && (options.plainObjects || options.allowPrototypes) || !$00db4f28354840f4$var$has.call(Object.prototype, source)) target[source] = true;
        } else return $00db4f28354840f4$var$limitedPair(target, source, options);
        return target;
    }
    if (!target || typeof target !== 'object') {
        if ($00db4f28354840f4$var$isOverflow(source)) {
            // Create new object with target at 0, source values shifted by 1
            var sourceKeys = Object.keys(source);
            var result = options && options.plainObjects ? {
                __proto__: null,
                0: target
            } : {
                0: target
            };
            for(var m = 0; m < sourceKeys.length; m++){
                var oldKey = parseInt(sourceKeys[m], 10);
                result[oldKey + 1] = source[sourceKeys[m]];
            }
            return $00db4f28354840f4$var$markOverflow(result, $00db4f28354840f4$var$getMaxIndex(source) + 1);
        }
        var combined = [
            target
        ].concat(source);
        if (options && typeof options.arrayLimit === 'number' && combined.length > options.arrayLimit) {
            if (options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            return $00db4f28354840f4$var$markOverflow($00db4f28354840f4$var$arrayToObject(combined, options), combined.length - 1);
        }
        return combined;
    }
    var mergeTarget = target;
    if ($00db4f28354840f4$var$isArray(target) && !$00db4f28354840f4$var$isArray(source)) {
        mergeTarget = $00db4f28354840f4$var$arrayToObject(target, options);
        if ($00db4f28354840f4$var$isConflict(target)) // the array may have grown past its last conflict, so continue after its last index
        $00db4f28354840f4$var$markConflict(mergeTarget, target.length - 1);
    }
    if ($00db4f28354840f4$var$isArray(target) && $00db4f28354840f4$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($00db4f28354840f4$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') target[i] = merge(targetItem, item, options);
                else target[target.length] = item;
            } else target[i] = item;
        });
        if (options && typeof options.arrayLimit === 'number' && target.length > options.arrayLimit) {
            if (options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            return $00db4f28354840f4$var$markOverflow($00db4f28354840f4$var$arrayToObject(target, options), target.length - 1);
        }
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($00db4f28354840f4$var$has.call(acc, key)) $00db4f28354840f4$var$setProperty(acc, key, merge(acc[key], value, options));
        else $00db4f28354840f4$var$setProperty(acc, key, value);
        if ($00db4f28354840f4$var$isOverflow(source) && !$00db4f28354840f4$var$isOverflow(acc)) $00db4f28354840f4$var$markOverflow(acc, $00db4f28354840f4$var$maxNumericIndex(acc, $00db4f28354840f4$var$getMaxIndex(source)));
        if ($00db4f28354840f4$var$isOverflow(acc)) {
            var keyNum = parseInt(key, 10);
            if (String(keyNum) === key && keyNum >= 0 && keyNum > $00db4f28354840f4$var$getMaxIndex(acc)) $00db4f28354840f4$var$setMaxIndex(acc, keyNum);
        }
        if ($00db4f28354840f4$var$isConflict(acc)) {
            var conflictKey = parseInt(key, 10);
            if (String(conflictKey) === key && conflictKey > $00db4f28354840f4$var$getConflictIndex(acc)) $00db4f28354840f4$var$markConflict(acc, conflictKey);
        }
        return acc;
    }, mergeTarget);
};
var $00db4f28354840f4$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        $00db4f28354840f4$var$setProperty(acc, key, source[key]);
        return acc;
    }, target);
};
var $00db4f28354840f4$var$decode = function(str, defaultDecoder, charset) {
    // With no `%` there is no escape to expand, in either charset: `unescape` has
    // nothing to match, and `decodeURIComponent` is the identity on such a string
    // (and cannot throw). So only `+` -> ' ' remains, and often not even that.
    if (typeof str === 'string' && str.indexOf('%') === -1) return str.indexOf('+') === -1 ? str : str.replace(/\+/g, ' ');
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $00db4f28354840f4$var$hasToPrimitive = typeof Symbol === 'function' && typeof Symbol.toPrimitive === 'symbol';
var $00db4f28354840f4$var$arrayJoin = Array.prototype.join;
var $00db4f28354840f4$var$arrayToString = Array.prototype.toString;
var $00db4f28354840f4$var$objectToString = Object.prototype.toString;
// an object with no callable toString (eg, from JSON, or null-prototype) would make String() or join() throw,
// so it becomes its primitive valueOf or else Object.prototype.toString; arrays are walked like join walks them,
// copied only once an element changes, with an array already being joined becoming '' as engines do for cycles
var $00db4f28354840f4$var$toCoercible = function toCoercible(value, joining) {
    if (!value || typeof value !== 'object' && typeof value !== 'function') return value;
    if ($00db4f28354840f4$var$hasToPrimitive && value[Symbol.toPrimitive] != null) return value;
    if ($00db4f28354840f4$var$isArray(value) && value.toString === $00db4f28354840f4$var$arrayToString && value.join === $00db4f28354840f4$var$arrayJoin) {
        var ancestors = joining || $fnMB2();
        if (ancestors.has(value)) return '';
        ancestors.set(value, true);
        var copy;
        for(var i = 0; i < value.length; i += 1){
            var item = value[i];
            var coerced = toCoercible(item, ancestors);
            if (!copy && coerced !== item) {
                copy = [];
                for(var j = 0; j < i; j += 1)copy[j] = value[j];
            }
            if (copy) copy[i] = coerced;
        }
        ancestors['delete'](value);
        return copy || value;
    }
    if (typeof value.toString === 'function') return value;
    var valueOf = value.valueOf;
    if (typeof valueOf === 'function') {
        var primitive = valueOf.call(value);
        if (!primitive || typeof primitive !== 'object' && typeof primitive !== 'function') return String(primitive);
    }
    return $00db4f28354840f4$var$objectToString.call(value);
};
var $00db4f28354840f4$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $00db4f28354840f4$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === 'symbol') string = Symbol.prototype.toString.call(str);
    else if (typeof str !== 'string') string = String($00db4f28354840f4$var$toCoercible(str));
    if (charset === 'iso-8859-1') // `escape` leaves `+` untouched, but a literal `+` is decoded back to a space,
    // so it must be percent-encoded to round-trip (the utf-8 path already does this).
    return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    }).replace(/\+/g, '%2B');
    var out = '';
    for(var j = 0; j < string.length; j += $00db4f28354840f4$var$limit){
        var segment = string.length >= $00db4f28354840f4$var$limit ? string.slice(j, j + $00db4f28354840f4$var$limit) : string;
        if (j + $00db4f28354840f4$var$limit < string.length) {
            var last = segment.charCodeAt(segment.length - 1);
            if (last >= 0xD800 && last <= 0xDBFF) {
                segment = segment.slice(0, -1);
                j -= 1;
            }
        }
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $4qNLb.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $00db4f28354840f4$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $00db4f28354840f4$var$hexTable[0xC0 | c >> 6] + $00db4f28354840f4$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $00db4f28354840f4$var$hexTable[0xE0 | c >> 12] + $00db4f28354840f4$var$hexTable[0x80 | c >> 6 & 0x3F] + $00db4f28354840f4$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $00db4f28354840f4$var$hexTable[0xF0 | c >> 18] + $00db4f28354840f4$var$hexTable[0x80 | c >> 12 & 0x3F] + $00db4f28354840f4$var$hexTable[0x80 | c >> 6 & 0x3F] + $00db4f28354840f4$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join('');
    }
    return out;
};
var $00db4f28354840f4$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: 'o'
        }
    ];
    var refs = $fnMB2();
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && !refs.has(val)) {
                queue[queue.length] = {
                    obj: obj,
                    prop: key
                };
                refs.set(val, true);
            }
        }
    }
    $00db4f28354840f4$var$compactQueue(queue);
    return value;
};
var $00db4f28354840f4$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};
var $00db4f28354840f4$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') return false;
    return !!(obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj));
};
var $00db4f28354840f4$var$combine = function combine(a, b, arrayLimit, plainObjects, throwOnLimitExceeded) {
    // If 'a' is already an overflow object, add to it
    if ($00db4f28354840f4$var$isOverflow(a)) {
        if (throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + arrayLimit + ' element' + (arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
        // spread `b` one level, matching the `[].concat(a, b)` used below, so a
        // collection appended to an already-overflowed object is flattened
        // rather than nested under a single index
        var bValues = $00db4f28354840f4$var$isArray(b) ? b : [
            b
        ];
        var newIndex = $00db4f28354840f4$var$getMaxIndex(a);
        for(var i = 0; i < bValues.length; ++i){
            newIndex += 1;
            a[newIndex] = bValues[i];
        }
        $00db4f28354840f4$var$setMaxIndex(a, newIndex);
        return a;
    }
    var result = [].concat(a, b);
    if (result.length > arrayLimit) {
        if (throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + arrayLimit + ' element' + (arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
        return $00db4f28354840f4$var$markOverflow($00db4f28354840f4$var$arrayToObject(result, {
            plainObjects: plainObjects
        }), result.length - 1);
    }
    return result;
};
var $00db4f28354840f4$var$maybeMap = function maybeMap(val, fn) {
    if ($00db4f28354840f4$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped[mapped.length] = fn(val[i]);
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $00db4f28354840f4$var$arrayToObject,
    assign: $00db4f28354840f4$var$assign,
    combine: $00db4f28354840f4$var$combine,
    compact: $00db4f28354840f4$var$compact,
    decode: $00db4f28354840f4$var$decode,
    encode: $00db4f28354840f4$var$encode,
    isBuffer: $00db4f28354840f4$var$isBuffer,
    isOverflow: $00db4f28354840f4$var$isOverflow,
    isRegExp: $00db4f28354840f4$var$isRegExp,
    markOverflow: $00db4f28354840f4$var$markOverflow,
    maybeMap: $00db4f28354840f4$var$maybeMap,
    merge: $00db4f28354840f4$var$merge,
    toCoercible: $00db4f28354840f4$var$toCoercible
};

});
parcelRegister("4qNLb", function(module, exports) {
'use strict';
var $33a0306def7f136a$var$replace = String.prototype.replace;
var $33a0306def7f136a$var$percentTwenties = /%20/g;
var $33a0306def7f136a$var$Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};
module.exports = {
    'default': $33a0306def7f136a$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $33a0306def7f136a$var$replace.call(value, $33a0306def7f136a$var$percentTwenties, '+');
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $33a0306def7f136a$var$Format.RFC1738,
    RFC3986: $33a0306def7f136a$var$Format.RFC3986
};

});



parcelRegister("bSZbC", function(module, exports) {
'use strict';

var $fnMB2 = parcelRequire("fnMB2");

var $04yIU = parcelRequire("04yIU");
var $8a7433323e0f8a21$var$has = Object.prototype.hasOwnProperty;
var $8a7433323e0f8a21$var$isArray = Array.isArray;
var $8a7433323e0f8a21$var$getPrototypeOf = Object.getPrototypeOf;
var $8a7433323e0f8a21$var$isPlainContainer = function isPlainContainer(value) {
    if (!value || typeof value !== 'object') return false;
    if ($8a7433323e0f8a21$var$isArray(value)) return true;
    var proto = $8a7433323e0f8a21$var$getPrototypeOf(value);
    return proto === Object.prototype || proto === null;
};
var $8a7433323e0f8a21$var$emptyCopyOf = function emptyCopyOf(value) {
    if ($8a7433323e0f8a21$var$isArray(value)) {
        var arr = [];
        arr.length = value.length;
        return arr;
    }
    return $8a7433323e0f8a21$var$getPrototypeOf(value) === null ? {
        __proto__: null
    } : {};
};
// `merge` and `compact` modify the containers they are given, so copy the caller's arrays and plain objects first
var $8a7433323e0f8a21$var$copyInput = function copyInput(input) {
    var copies = $fnMB2();
    var result = {};
    var queue = [
        {
            source: input,
            target: result
        }
    ];
    for(var i = 0; i < queue.length; ++i){
        var source = queue[i].source;
        var target = queue[i].target;
        var keys = Object.keys(source);
        for(var j = 0; j < keys.length; ++j){
            var value = source[keys[j]];
            if ($8a7433323e0f8a21$var$isPlainContainer(value)) {
                if (!copies.has(value)) {
                    var copy = $8a7433323e0f8a21$var$emptyCopyOf(value);
                    copies.set(value, copy);
                    queue[queue.length] = {
                        source: value,
                        target: copy
                    };
                }
                target[keys[j]] = copies.get(value);
            } else target[keys[j]] = value;
        }
    }
    return result;
};
var $8a7433323e0f8a21$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $04yIU.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictMerge: true,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};
var $8a7433323e0f8a21$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $8a7433323e0f8a21$var$parseArrayValue = function(val, options, currentArrayLength) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        if (options.throwOnLimitExceeded) {
            var commaCount = 0;
            var commaIndex = val.indexOf(',');
            while(commaIndex > -1){
                commaCount += 1;
                if (commaCount >= options.arrayLimit) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
                commaIndex = val.indexOf(',', commaIndex + 1);
            }
        }
        return val.split(',');
    }
    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $8a7433323e0f8a21$var$isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $8a7433323e0f8a21$var$charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
var $8a7433323e0f8a21$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    var limit = options.parameterLimit === Infinity ? void 0 : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, options.throwOnLimitExceeded && typeof limit !== 'undefined' ? limit + 1 : limit);
    if (options.throwOnLimitExceeded && typeof limit !== 'undefined' && parts.length > limit) throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf('utf8=') === 0) {
            if (parts[i] === $8a7433323e0f8a21$var$charsetSentinel) charset = 'utf-8';
            else if (parts[i] === $8a7433323e0f8a21$var$isoSentinel) charset = 'iso-8859-1';
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
        // `[]` belongs to the key, so look for it at the split point, not anywhere in the part
        var isEmptyBracketKey = pos > 1 && part.slice(pos - 2, pos) === '[]';
        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, $8a7433323e0f8a21$var$defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), $8a7433323e0f8a21$var$defaults.decoder, charset, 'key');
            if (key !== null) val = $04yIU.maybeMap($8a7433323e0f8a21$var$parseArrayValue(part.slice(pos + 1), options, $8a7433323e0f8a21$var$isArray(obj[key]) ? obj[key].length : 0), function(encodedVal) {
                return options.decoder(encodedVal, $8a7433323e0f8a21$var$defaults.decoder, charset, 'value');
            });
        }
        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') val = $8a7433323e0f8a21$var$interpretNumericEntities(String(val));
        if (isEmptyBracketKey) val = $8a7433323e0f8a21$var$isArray(val) ? [
            val
        ] : val;
        if (options.comma && $8a7433323e0f8a21$var$isArray(val) && val.length > options.arrayLimit) val = $04yIU.combine([], val, options.arrayLimit, options.plainObjects, options.throwOnLimitExceeded);
        if (key !== null) {
            var existing = $8a7433323e0f8a21$var$has.call(obj, key);
            if (existing && (options.duplicates === 'combine' || isEmptyBracketKey)) obj[key] = $04yIU.combine(obj[key], val, options.arrayLimit, options.plainObjects, options.throwOnLimitExceeded);
            else if (!existing || options.duplicates === 'last') obj[key] = val;
        }
    }
    return obj;
};
var $8a7433323e0f8a21$var$parseObject = function(chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }
    var leaf = valuesParsed ? val : $8a7433323e0f8a21$var$parseArrayValue(val, options, currentArrayLength);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === '[]' && options.parseArrays) {
            if ($04yIU.isOverflow(leaf)) // leaf is already an overflow object, preserve it
            obj = leaf;
            else obj = options.allowEmptyArrays && (leaf === '' || options.strictNullHandling && leaf === null) ? [] : $04yIU.combine([], leaf, options.arrayLimit, options.plainObjects, options.throwOnLimitExceeded);
        } else {
            obj = options.plainObjects ? {
                __proto__: null
            } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            var isValidArrayIndex = !isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays;
            if (!options.parseArrays && decodedRoot === '') obj = {
                0: leaf
            };
            else if (isValidArrayIndex && index < options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (isValidArrayIndex && options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            else if (isValidArrayIndex) {
                obj[index] = leaf;
                $04yIU.markOverflow(obj, index);
            } else if (decodedRoot !== '__proto__') obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
// Behaves like `key.replace(/\.([^.[]+)/g, '[$1]')`, but only rewrites a dot
// that sits at bracket depth 0. A literal dot already inside a `[...]` segment
// is left untouched instead of corrupting the key (e.g. "outer[a.b]"). (#617)
var $8a7433323e0f8a21$var$topLevelDotsToBrackets = function topLevelDotsToBrackets(key) {
    var result = '';
    var depth = 0;
    for(var i = 0; i < key.length; i += 1){
        var cu = key.charCodeAt(i);
        if (cu === 0x5B) {
            depth += 1;
            result += '[';
        } else if (cu === 0x5D) {
            if (depth > 0) depth -= 1;
            result += ']';
        } else if (cu === 0x2E // '.'
         && depth === 0 && i + 1 < key.length && key.charCodeAt(i + 1) !== 0x2E // not another '.'
         && key.charCodeAt(i + 1) !== 0x5B // not '['
        ) {
            var start = i + 1;
            var j = start;
            while(j < key.length && key.charCodeAt(j) !== 0x2E && key.charCodeAt(j) !== 0x5B)j += 1;
            result += '[' + key.slice(start, j) + ']';
            i = j - 1;
        } else result += key.charAt(i);
    }
    return result;
};
// Split a key like "a[b][c[]]" into ['a', '[b]', '[c[]]'] while preserving
// qs parse semantics for depth/prototype guards.
var $8a7433323e0f8a21$var$splitKeyIntoSegments = function splitKeyIntoSegments(originalKey, options) {
    var key = options.allowDots ? $8a7433323e0f8a21$var$topLevelDotsToBrackets(originalKey) : originalKey;
    // depth <= 0 keeps the whole key as one segment
    if (options.depth <= 0) {
        if (!options.plainObjects && $8a7433323e0f8a21$var$has.call(Object.prototype, key)) {
            if (!options.allowPrototypes) return;
        }
        return [
            key
        ];
    }
    var segments = [];
    // parent before the first '[' (may be empty if key starts with '[')
    var first = key.indexOf('[');
    var parent = first >= 0 ? key.slice(0, first) : key;
    if (parent) {
        if (!options.plainObjects && $8a7433323e0f8a21$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        segments[segments.length] = parent;
    }
    var n = key.length;
    var open = first;
    var collected = 0;
    while(open >= 0 && collected < options.depth){
        var level = 1;
        var i = open + 1;
        var close = -1;
        // balance nested '[' and ']' inside this bracket group using a nesting level counter
        while(i < n && close < 0){
            var cu = key.charCodeAt(i);
            if (cu === 0x5B) level += 1;
            else if (cu === 0x5D) {
                level -= 1;
                if (level === 0) close = i; // found matching close; loop will exit by condition
            }
            i += 1;
        }
        if (close < 0) {
            // Unterminated group: wrap the raw remainder in one bracket pair so it stays
            // a single literal segment (e.g. "[[]b" -> "[[]b]"); we do not infer missing ']'.
            segments[segments.length] = '[' + key.slice(open) + ']';
            return segments;
        }
        var seg = key.slice(open, close + 1);
        // prototype guard for the content of this group
        var content = seg.slice(1, -1);
        if (!options.plainObjects && $8a7433323e0f8a21$var$has.call(Object.prototype, content) && !options.allowPrototypes) return;
        segments[segments.length] = seg;
        collected += 1;
        // find the next '[' after this balanced group
        open = key.indexOf('[', close + 1);
    }
    if (open >= 0) {
        if (options.strictDepth === true) throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        segments[segments.length] = '[' + key.slice(open) + ']';
    }
    return segments;
};
var $8a7433323e0f8a21$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    var keys = $8a7433323e0f8a21$var$splitKeyIntoSegments(givenKey, options);
    if (!keys) return;
    return $8a7433323e0f8a21$var$parseObject(keys, val, options, valuesParsed);
};
var $8a7433323e0f8a21$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $8a7433323e0f8a21$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') throw new TypeError('Decoder has to be a function.');
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    var charset = typeof opts.charset === 'undefined' ? $8a7433323e0f8a21$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === 'undefined' ? $8a7433323e0f8a21$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') throw new TypeError('The duplicates option must be either combine, first, or last');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : $8a7433323e0f8a21$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $8a7433323e0f8a21$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : $8a7433323e0f8a21$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : $8a7433323e0f8a21$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : $8a7433323e0f8a21$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $8a7433323e0f8a21$var$defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : $8a7433323e0f8a21$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : $8a7433323e0f8a21$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : $8a7433323e0f8a21$var$defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || $04yIU.isRegExp(opts.delimiter) ? opts.delimiter : $8a7433323e0f8a21$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : $8a7433323e0f8a21$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : $8a7433323e0f8a21$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : $8a7433323e0f8a21$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : $8a7433323e0f8a21$var$defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : $8a7433323e0f8a21$var$defaults.strictDepth,
        strictMerge: typeof opts.strictMerge === 'boolean' ? !!opts.strictMerge : $8a7433323e0f8a21$var$defaults.strictMerge,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $8a7433323e0f8a21$var$defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};
module.exports = function(str, opts) {
    var options = $8a7433323e0f8a21$var$normalizeParseOptions(opts);
    if (str === '' || str === null || typeof str === 'undefined') return options.plainObjects ? {
        __proto__: null
    } : {};
    var tempObj = typeof str === 'string' ? $8a7433323e0f8a21$var$parseValues(str, options) : $8a7433323e0f8a21$var$copyInput(str);
    var obj = options.plainObjects ? {
        __proto__: null
    } : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $8a7433323e0f8a21$var$parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = $04yIU.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $04yIU.compact(obj);
};

});



parcelRegister("2qxpy", function(module, exports) {
"use strict";
function $1c47ed37ea81ba93$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $1c47ed37ea81ba93$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $1c47ed37ea81ba93$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $1c47ed37ea81ba93$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1c47ed37ea81ba93$var$React = $1c47ed37ea81ba93$var$_interopRequireWildcard((parcelRequire("NdCUR")));

var $1c47ed37ea81ba93$var$_lodash = $1c47ed37ea81ba93$var$_interopRequireDefault((parcelRequire("cc5cI")));

var $1c47ed37ea81ba93$var$_classnames = $1c47ed37ea81ba93$var$_interopRequireDefault((parcelRequire("1v7mg")));

var $1VByH = parcelRequire("1VByH");

var $2WZMH = parcelRequire("2WZMH");

var $1c47ed37ea81ba93$var$_GridItem = $1c47ed37ea81ba93$var$_interopRequireDefault((parcelRequire("eCToD")));

var $1c47ed37ea81ba93$var$_ReactGridLayoutPropTypes = $1c47ed37ea81ba93$var$_interopRequireDefault((parcelRequire("jGk5X")));
function $1c47ed37ea81ba93$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1c47ed37ea81ba93$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $1c47ed37ea81ba93$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $1c47ed37ea81ba93$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || $1c47ed37ea81ba93$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $1c47ed37ea81ba93$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $1c47ed37ea81ba93$var$_slicedToArray(arr, i) {
    return $1c47ed37ea81ba93$var$_arrayWithHoles(arr) || $1c47ed37ea81ba93$var$_iterableToArrayLimit(arr, i) || $1c47ed37ea81ba93$var$_unsupportedIterableToArray(arr, i) || $1c47ed37ea81ba93$var$_nonIterableRest();
}
function $1c47ed37ea81ba93$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1c47ed37ea81ba93$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $1c47ed37ea81ba93$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $1c47ed37ea81ba93$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1c47ed37ea81ba93$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $1c47ed37ea81ba93$var$ownKeys(Object(source), true).forEach(function(key) {
            $1c47ed37ea81ba93$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $1c47ed37ea81ba93$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1c47ed37ea81ba93$var$_toConsumableArray(arr) {
    return $1c47ed37ea81ba93$var$_arrayWithoutHoles(arr) || $1c47ed37ea81ba93$var$_iterableToArray(arr) || $1c47ed37ea81ba93$var$_unsupportedIterableToArray(arr) || $1c47ed37ea81ba93$var$_nonIterableSpread();
}
function $1c47ed37ea81ba93$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1c47ed37ea81ba93$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1c47ed37ea81ba93$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1c47ed37ea81ba93$var$_arrayLikeToArray(o, minLen);
}
function $1c47ed37ea81ba93$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $1c47ed37ea81ba93$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $1c47ed37ea81ba93$var$_arrayLikeToArray(arr);
}
function $1c47ed37ea81ba93$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1c47ed37ea81ba93$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1c47ed37ea81ba93$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1c47ed37ea81ba93$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1c47ed37ea81ba93$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1c47ed37ea81ba93$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $1c47ed37ea81ba93$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $1c47ed37ea81ba93$var$_setPrototypeOf(subClass, superClass);
}
function $1c47ed37ea81ba93$var$_setPrototypeOf(o, p) {
    $1c47ed37ea81ba93$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1c47ed37ea81ba93$var$_setPrototypeOf(o, p);
}
function $1c47ed37ea81ba93$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $1c47ed37ea81ba93$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $1c47ed37ea81ba93$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $1c47ed37ea81ba93$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $1c47ed37ea81ba93$var$_possibleConstructorReturn(this, result);
    };
}
function $1c47ed37ea81ba93$var$_possibleConstructorReturn(self, call) {
    if (call && ($1c47ed37ea81ba93$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $1c47ed37ea81ba93$var$_assertThisInitialized(self);
}
function $1c47ed37ea81ba93$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $1c47ed37ea81ba93$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $1c47ed37ea81ba93$var$_getPrototypeOf(o) {
    $1c47ed37ea81ba93$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1c47ed37ea81ba93$var$_getPrototypeOf(o);
}
function $1c47ed37ea81ba93$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
// End Types
var $1c47ed37ea81ba93$var$layoutClassName = "react-grid-layout";
var $1c47ed37ea81ba93$var$isFirefox = false; // Try...catch will protect from navigator not existing (e.g. node) or a bad implementation of navigator
try {
    $1c47ed37ea81ba93$var$isFirefox = /firefox/i.test(navigator.userAgent);
} catch (e) {
/* Ignore */ }
/**
 * A reactive, fluid grid layout with draggable, resizable components.
 */ var $1c47ed37ea81ba93$var$ReactGridLayout = /*#__PURE__*/ function(_React$Component) {
    $1c47ed37ea81ba93$var$_inherits(ReactGridLayout, _React$Component);
    var _super = $1c47ed37ea81ba93$var$_createSuper(ReactGridLayout);
    // TODO publish internal ReactClass displayName transform
    // Refactored to another module to make way for preval
    function ReactGridLayout(props, context) /*: void*/ {
        var _this;
        $1c47ed37ea81ba93$var$_classCallCheck(this, ReactGridLayout);
        _this = _super.call(this, props, context);
        $1c47ed37ea81ba93$var$_defineProperty($1c47ed37ea81ba93$var$_assertThisInitialized(_this), "state", {
            activeDrag: null,
            layout: (0, $1VByH.synchronizeLayoutWithChildren)(_this.props.layout, _this.props.children, _this.props.cols, (0, $1VByH.compactType)(_this.props)),
            mounted: false,
            oldDragItem: null,
            oldLayout: null,
            oldResizeItem: null,
            droppingDOMNode: null,
            children: []
        });
        $1c47ed37ea81ba93$var$_defineProperty($1c47ed37ea81ba93$var$_assertThisInitialized(_this), "dragEnterCounter", 0);
        $1c47ed37ea81ba93$var$_defineProperty($1c47ed37ea81ba93$var$_assertThisInitialized(_this), "onDragOver", function(e) {
            var _e$nativeEvent$target;
            // we should ignore events from layout's children in Firefox
            // to avoid unpredictable jumping of a dropping placeholder
            // FIXME remove this hack
            if ($1c47ed37ea81ba93$var$isFirefox && // $FlowIgnore can't figure this out
            !((_e$nativeEvent$target = e.nativeEvent.target) !== null && _e$nativeEvent$target !== void 0 && _e$nativeEvent$target.classList.contains($1c47ed37ea81ba93$var$layoutClassName))) {
                // without this Firefox will not allow drop if currently over droppingItem
                e.preventDefault();
                return false;
            }
            var _this$props = _this.props, droppingItem = _this$props.droppingItem, margin = _this$props.margin, cols = _this$props.cols, rowHeight = _this$props.rowHeight, maxRows = _this$props.maxRows, width = _this$props.width, containerPadding = _this$props.containerPadding;
            var layout = _this.state.layout; // This is relative to the DOM element that this event fired for.
            var _e$nativeEvent = e.nativeEvent, layerX = _e$nativeEvent.layerX, layerY = _e$nativeEvent.layerY;
            var droppingPosition = {
                left: layerX,
                top: layerY,
                e: e
            };
            if (!_this.state.droppingDOMNode) {
                var positionParams = {
                    cols: cols,
                    margin: margin,
                    maxRows: maxRows,
                    rowHeight: rowHeight,
                    containerWidth: width,
                    containerPadding: containerPadding || margin
                };
                var calculatedPosition = (0, $2WZMH.calcXY)(positionParams, layerY, layerX, droppingItem.w, droppingItem.h);
                _this.setState({
                    droppingDOMNode: /*#__PURE__*/ $1c47ed37ea81ba93$var$React.createElement("div", {
                        key: droppingItem.i
                    }),
                    droppingPosition: droppingPosition,
                    layout: [].concat($1c47ed37ea81ba93$var$_toConsumableArray(layout), [
                        $1c47ed37ea81ba93$var$_objectSpread($1c47ed37ea81ba93$var$_objectSpread({}, droppingItem), {}, {
                            x: calculatedPosition.x,
                            y: calculatedPosition.y,
                            static: false,
                            isDraggable: true
                        })
                    ])
                });
            } else if (_this.state.droppingPosition) {
                var _this$state$droppingP = _this.state.droppingPosition, left = _this$state$droppingP.left, top = _this$state$droppingP.top;
                var shouldUpdatePosition = left != layerX || top != layerY;
                if (shouldUpdatePosition) _this.setState({
                    droppingPosition: droppingPosition
                });
            }
            e.stopPropagation();
            e.preventDefault();
        });
        $1c47ed37ea81ba93$var$_defineProperty($1c47ed37ea81ba93$var$_assertThisInitialized(_this), "removeDroppingPlaceholder", function() {
            var _this$props2 = _this.props, droppingItem = _this$props2.droppingItem, cols = _this$props2.cols;
            var layout = _this.state.layout;
            var newLayout = (0, $1VByH.compact)(layout.filter(function(l) {
                return l.i !== droppingItem.i;
            }), (0, $1VByH.compactType)(_this.props), cols);
            _this.setState({
                layout: newLayout,
                droppingDOMNode: null,
                activeDrag: null,
                droppingPosition: undefined
            });
        });
        $1c47ed37ea81ba93$var$_defineProperty($1c47ed37ea81ba93$var$_assertThisInitialized(_this), "onDragLeave", function() {
            _this.dragEnterCounter--; // onDragLeave can be triggered on each layout's child.
            // But we know that count of dragEnter and dragLeave events
            // will be balanced after leaving the layout's container
            // so we can increase and decrease count of dragEnter and
            // when it'll be equal to 0 we'll remove the placeholder
            if (_this.dragEnterCounter === 0) _this.removeDroppingPlaceholder();
        });
        $1c47ed37ea81ba93$var$_defineProperty($1c47ed37ea81ba93$var$_assertThisInitialized(_this), "onDragEnter", function() {
            _this.dragEnterCounter++;
        });
        $1c47ed37ea81ba93$var$_defineProperty($1c47ed37ea81ba93$var$_assertThisInitialized(_this), "onDrop", function(e) {
            var droppingItem = _this.props.droppingItem;
            var layout = _this.state.layout;
            var item = layout.find(function(l) {
                return l.i === droppingItem.i;
            }); // reset dragEnter counter on drop
            _this.dragEnterCounter = 0;
            _this.removeDroppingPlaceholder();
            _this.props.onDrop(layout, item, e);
        });
        (0, $1VByH.autoBindHandlers)($1c47ed37ea81ba93$var$_assertThisInitialized(_this), [
            "onDragStart",
            "onDrag",
            "onDragStop",
            "onResizeStart",
            "onResize",
            "onResizeStop"
        ]);
        return _this;
    }
    $1c47ed37ea81ba93$var$_createClass(ReactGridLayout, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.setState({
                    mounted: true
                }); // Possibly call back with layout on mount. This should be done after correcting the layout width
                // to ensure we don't rerender with the wrong width.
                this.onLayoutMaybeChanged(this.state.layout, this.props.layout);
            }
        },
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps, nextState) /*: boolean*/ {
                return(// from SCU is if the user intentionally memoizes children. If they do, and they can
                // handle changes properly, performance will increase.
                this.props.children !== nextProps.children || !(0, $1VByH.fastRGLPropsEqual)(this.props, nextProps, $1c47ed37ea81ba93$var$_lodash.default) || this.state.activeDrag !== nextState.activeDrag || this.state.mounted !== nextState.mounted || this.state.droppingPosition !== nextState.droppingPosition);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (!this.state.activeDrag) {
                    var newLayout = this.state.layout;
                    var oldLayout = prevState.layout;
                    this.onLayoutMaybeChanged(newLayout, oldLayout);
                }
            }
        },
        {
            key: "containerHeight",
            value: function containerHeight() /*: ?string*/ {
                if (!this.props.autoSize) return;
                var nbRow = (0, $1VByH.bottom)(this.state.layout);
                var containerPaddingY = this.props.containerPadding ? this.props.containerPadding[1] : this.props.margin[1];
                return nbRow * this.props.rowHeight + (nbRow - 1) * this.props.margin[1] + containerPaddingY * 2 + "px";
            }
        },
        {
            key: "onDragStart",
            value: function onDragStart(i, x, y, _ref) /*: void*/ {
                var e = _ref.e, node = _ref.node;
                var layout = this.state.layout;
                var l = (0, $1VByH.getLayoutItem)(layout, i);
                if (!l) return;
                this.setState({
                    oldDragItem: (0, $1VByH.cloneLayoutItem)(l),
                    oldLayout: this.state.layout
                });
                return this.props.onDragStart(layout, l, l, null, e, node);
            }
        },
        {
            key: "onDrag",
            value: function onDrag(i, x, y, _ref2) /*: void*/ {
                var e = _ref2.e, node = _ref2.node;
                var oldDragItem = this.state.oldDragItem;
                var layout = this.state.layout;
                var cols = this.props.cols;
                var l = (0, $1VByH.getLayoutItem)(layout, i);
                if (!l) return; // Create placeholder (display only)
                var placeholder = {
                    w: l.w,
                    h: l.h,
                    x: l.x,
                    y: l.y,
                    placeholder: true,
                    i: i
                }; // Move the element to the dragged location.
                var isUserAction = true;
                layout = (0, $1VByH.moveElement)(layout, l, x, y, isUserAction, this.props.preventCollision, (0, $1VByH.compactType)(this.props), cols);
                this.props.onDrag(layout, oldDragItem, l, placeholder, e, node);
                this.setState({
                    layout: (0, $1VByH.compact)(layout, (0, $1VByH.compactType)(this.props), cols),
                    activeDrag: placeholder
                });
            }
        },
        {
            key: "onDragStop",
            value: function onDragStop(i, x, y, _ref3) /*: void*/ {
                var e = _ref3.e, node = _ref3.node;
                if (!this.state.activeDrag) return;
                var oldDragItem = this.state.oldDragItem;
                var layout = this.state.layout;
                var _this$props3 = this.props, cols = _this$props3.cols, preventCollision = _this$props3.preventCollision;
                var l = (0, $1VByH.getLayoutItem)(layout, i);
                if (!l) return; // Move the element here
                var isUserAction = true;
                layout = (0, $1VByH.moveElement)(layout, l, x, y, isUserAction, preventCollision, (0, $1VByH.compactType)(this.props), cols);
                this.props.onDragStop(layout, oldDragItem, l, null, e, node); // Set state
                var newLayout = (0, $1VByH.compact)(layout, (0, $1VByH.compactType)(this.props), cols);
                var oldLayout = this.state.oldLayout;
                this.setState({
                    activeDrag: null,
                    layout: newLayout,
                    oldDragItem: null,
                    oldLayout: null
                });
                this.onLayoutMaybeChanged(newLayout, oldLayout);
            }
        },
        {
            key: "onLayoutMaybeChanged",
            value: function onLayoutMaybeChanged(newLayout, oldLayout) {
                if (!oldLayout) oldLayout = this.state.layout;
                if (!(0, $1c47ed37ea81ba93$var$_lodash.default)(oldLayout, newLayout)) this.props.onLayoutChange(newLayout);
            }
        },
        {
            key: "onResizeStart",
            value: function onResizeStart(i, w, h, _ref4) {
                var e = _ref4.e, node = _ref4.node;
                var layout = this.state.layout;
                var l = (0, $1VByH.getLayoutItem)(layout, i);
                if (!l) return;
                this.setState({
                    oldResizeItem: (0, $1VByH.cloneLayoutItem)(l),
                    oldLayout: this.state.layout
                });
                this.props.onResizeStart(layout, l, l, null, e, node);
            }
        },
        {
            key: "onResize",
            value: function onResize(i, w, h, _ref5) {
                var e = _ref5.e, node = _ref5.node;
                var _this$state = this.state, layout = _this$state.layout, oldResizeItem = _this$state.oldResizeItem;
                var _this$props4 = this.props, cols = _this$props4.cols, preventCollision = _this$props4.preventCollision;
                var _withLayoutItem = (0, $1VByH.withLayoutItem)(layout, i, function(l) {
                    // Something like quad tree should be used
                    // to find collisions faster
                    var hasCollisions;
                    if (preventCollision) {
                        var collisions = (0, $1VByH.getAllCollisions)(layout, $1c47ed37ea81ba93$var$_objectSpread($1c47ed37ea81ba93$var$_objectSpread({}, l), {}, {
                            w: w,
                            h: h
                        })).filter(function(layoutItem) {
                            return layoutItem.i !== l.i;
                        });
                        hasCollisions = collisions.length > 0; // If we're colliding, we need adjust the placeholder.
                        if (hasCollisions) {
                            // adjust w && h to maximum allowed space
                            var leastX = Infinity, leastY = Infinity;
                            collisions.forEach(function(layoutItem) {
                                if (layoutItem.x > l.x) leastX = Math.min(leastX, layoutItem.x);
                                if (layoutItem.y > l.y) leastY = Math.min(leastY, layoutItem.y);
                            });
                            if (Number.isFinite(leastX)) l.w = leastX - l.x;
                            if (Number.isFinite(leastY)) l.h = leastY - l.y;
                        }
                    }
                    if (!hasCollisions) {
                        // Set new width and height.
                        l.w = w;
                        l.h = h;
                    }
                    return l;
                }), _withLayoutItem2 = $1c47ed37ea81ba93$var$_slicedToArray(_withLayoutItem, 2), newLayout = _withLayoutItem2[0], l = _withLayoutItem2[1]; // Shouldn't ever happen, but typechecking makes it necessary
                if (!l) return; // Create placeholder element (display only)
                var placeholder = {
                    w: l.w,
                    h: l.h,
                    x: l.x,
                    y: l.y,
                    static: true,
                    i: i
                };
                this.props.onResize(newLayout, oldResizeItem, l, placeholder, e, node); // Re-compact the newLayout and set the drag placeholder.
                this.setState({
                    layout: (0, $1VByH.compact)(newLayout, (0, $1VByH.compactType)(this.props), cols),
                    activeDrag: placeholder
                });
            }
        },
        {
            key: "onResizeStop",
            value: function onResizeStop(i, w, h, _ref6) {
                var e = _ref6.e, node = _ref6.node;
                var _this$state2 = this.state, layout = _this$state2.layout, oldResizeItem = _this$state2.oldResizeItem;
                var cols = this.props.cols;
                var l = (0, $1VByH.getLayoutItem)(layout, i);
                this.props.onResizeStop(layout, oldResizeItem, l, null, e, node); // Set state
                var newLayout = (0, $1VByH.compact)(layout, (0, $1VByH.compactType)(this.props), cols);
                var oldLayout = this.state.oldLayout;
                this.setState({
                    activeDrag: null,
                    layout: newLayout,
                    oldResizeItem: null,
                    oldLayout: null
                });
                this.onLayoutMaybeChanged(newLayout, oldLayout);
            }
        },
        {
            key: "placeholder",
            value: function placeholder() /*: ?ReactElement<any>*/ {
                var activeDrag = this.state.activeDrag;
                if (!activeDrag) return null;
                var _this$props5 = this.props, width = _this$props5.width, cols = _this$props5.cols, margin = _this$props5.margin, containerPadding = _this$props5.containerPadding, rowHeight = _this$props5.rowHeight, maxRows = _this$props5.maxRows, useCSSTransforms = _this$props5.useCSSTransforms, transformScale = _this$props5.transformScale; // {...this.state.activeDrag} is pretty slow, actually
                return /*#__PURE__*/ $1c47ed37ea81ba93$var$React.createElement($1c47ed37ea81ba93$var$_GridItem.default, {
                    w: activeDrag.w,
                    h: activeDrag.h,
                    x: activeDrag.x,
                    y: activeDrag.y,
                    i: activeDrag.i,
                    className: "react-grid-placeholder",
                    containerWidth: width,
                    cols: cols,
                    margin: margin,
                    containerPadding: containerPadding || margin,
                    maxRows: maxRows,
                    rowHeight: rowHeight,
                    isDraggable: false,
                    isResizable: false,
                    isBounded: false,
                    useCSSTransforms: useCSSTransforms,
                    transformScale: transformScale
                }, /*#__PURE__*/ $1c47ed37ea81ba93$var$React.createElement("div", null));
            }
        },
        {
            key: "processGridItem",
            value: function processGridItem(child, isDroppingItem) /*: ?ReactElement<any>*/ {
                if (!child || !child.key) return;
                var l = (0, $1VByH.getLayoutItem)(this.state.layout, String(child.key));
                if (!l) return null;
                var _this$props6 = this.props, width = _this$props6.width, cols = _this$props6.cols, margin = _this$props6.margin, containerPadding = _this$props6.containerPadding, rowHeight = _this$props6.rowHeight, maxRows = _this$props6.maxRows, isDraggable = _this$props6.isDraggable, isResizable = _this$props6.isResizable, isBounded = _this$props6.isBounded, useCSSTransforms = _this$props6.useCSSTransforms, transformScale = _this$props6.transformScale, draggableCancel = _this$props6.draggableCancel, draggableHandle = _this$props6.draggableHandle, resizeHandles = _this$props6.resizeHandles, resizeHandle = _this$props6.resizeHandle;
                var _this$state3 = this.state, mounted = _this$state3.mounted, droppingPosition = _this$state3.droppingPosition; // Determine user manipulations possible.
                // If an item is static, it can't be manipulated by default.
                // Any properties defined directly on the grid item will take precedence.
                var draggable = typeof l.isDraggable === "boolean" ? l.isDraggable : !l.static && isDraggable;
                var resizable = typeof l.isResizable === "boolean" ? l.isResizable : !l.static && isResizable;
                var resizeHandlesOptions = l.resizeHandles || resizeHandles; // isBounded set on child if set on parent, and child is not explicitly false
                var bounded = draggable && isBounded && l.isBounded !== false;
                return /*#__PURE__*/ $1c47ed37ea81ba93$var$React.createElement($1c47ed37ea81ba93$var$_GridItem.default, {
                    containerWidth: width,
                    cols: cols,
                    margin: margin,
                    containerPadding: containerPadding || margin,
                    maxRows: maxRows,
                    rowHeight: rowHeight,
                    cancel: draggableCancel,
                    handle: draggableHandle,
                    onDragStop: this.onDragStop,
                    onDragStart: this.onDragStart,
                    onDrag: this.onDrag,
                    onResizeStart: this.onResizeStart,
                    onResize: this.onResize,
                    onResizeStop: this.onResizeStop,
                    isDraggable: draggable,
                    isResizable: resizable,
                    isBounded: bounded,
                    useCSSTransforms: useCSSTransforms && mounted,
                    usePercentages: !mounted,
                    transformScale: transformScale,
                    w: l.w,
                    h: l.h,
                    x: l.x,
                    y: l.y,
                    i: l.i,
                    minH: l.minH,
                    minW: l.minW,
                    maxH: l.maxH,
                    maxW: l.maxW,
                    static: l.static,
                    droppingPosition: isDroppingItem ? droppingPosition : undefined,
                    resizeHandles: resizeHandlesOptions,
                    resizeHandle: resizeHandle
                }, child);
            } // Called while dragging an element. Part of browser native drag/drop API.
        },
        {
            key: "render",
            value: function render() /*: React.Element<"div">*/ {
                var _this2 = this;
                var _this$props7 = this.props, className = _this$props7.className, style = _this$props7.style, isDroppable = _this$props7.isDroppable, innerRef = _this$props7.innerRef;
                var mergedClassName = (0, $1c47ed37ea81ba93$var$_classnames.default)($1c47ed37ea81ba93$var$layoutClassName, className);
                var mergedStyle = $1c47ed37ea81ba93$var$_objectSpread({
                    height: this.containerHeight()
                }, style);
                return /*#__PURE__*/ $1c47ed37ea81ba93$var$React.createElement("div", {
                    ref: innerRef,
                    className: mergedClassName,
                    style: mergedStyle,
                    onDrop: isDroppable ? this.onDrop : $1VByH.noop,
                    onDragLeave: isDroppable ? this.onDragLeave : $1VByH.noop,
                    onDragEnter: isDroppable ? this.onDragEnter : $1VByH.noop,
                    onDragOver: isDroppable ? this.onDragOver : $1VByH.noop
                }, $1c47ed37ea81ba93$var$React.Children.map(this.props.children, function(child) {
                    return _this2.processGridItem(child);
                }), isDroppable && this.state.droppingDOMNode && this.processGridItem(this.state.droppingDOMNode, true), this.placeholder());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) /*: $Shape<State> | null*/ {
                var newLayoutBase;
                if (prevState.activeDrag) return null;
                 // Legacy support for compactType
                // Allow parent to set layout directly.
                if (!(0, $1c47ed37ea81ba93$var$_lodash.default)(nextProps.layout, prevState.propsLayout) || nextProps.compactType !== prevState.compactType) newLayoutBase = nextProps.layout;
                else if (!(0, $1VByH.childrenEqual)(nextProps.children, prevState.children)) // If children change, also regenerate the layout. Use our state
                // as the base in case because it may be more up to date than
                // what is in props.
                newLayoutBase = prevState.layout;
                 // We need to regenerate the layout.
                if (newLayoutBase) {
                    var newLayout = (0, $1VByH.synchronizeLayoutWithChildren)(newLayoutBase, nextProps.children, nextProps.cols, (0, $1VByH.compactType)(nextProps));
                    return {
                        layout: newLayout,
                        // We need to save these props to state for using
                        // getDerivedStateFromProps instead of componentDidMount (in which we would get extra rerender)
                        compactType: nextProps.compactType,
                        children: nextProps.children,
                        propsLayout: nextProps.layout
                    };
                }
                return null;
            }
        }
    ]);
    return ReactGridLayout;
}($1c47ed37ea81ba93$var$React.Component);
module.exports.default = $1c47ed37ea81ba93$var$ReactGridLayout;
$1c47ed37ea81ba93$var$_defineProperty($1c47ed37ea81ba93$var$ReactGridLayout, "displayName", "ReactGridLayout");
$1c47ed37ea81ba93$var$_defineProperty($1c47ed37ea81ba93$var$ReactGridLayout, "propTypes", $1c47ed37ea81ba93$var$_ReactGridLayoutPropTypes.default);
$1c47ed37ea81ba93$var$_defineProperty($1c47ed37ea81ba93$var$ReactGridLayout, "defaultProps", {
    autoSize: true,
    cols: 12,
    className: "",
    style: {},
    draggableHandle: "",
    draggableCancel: "",
    containerPadding: null,
    rowHeight: 150,
    maxRows: Infinity,
    // infinite vertical growth
    layout: [],
    margin: [
        10,
        10
    ],
    isBounded: false,
    isDraggable: true,
    isResizable: true,
    isDroppable: false,
    useCSSTransforms: true,
    transformScale: 1,
    verticalCompact: true,
    compactType: "vertical",
    preventCollision: false,
    droppingItem: {
        i: "__dropping-elem__",
        h: 1,
        w: 1
    },
    resizeHandles: [
        "se"
    ],
    onLayoutChange: $1VByH.noop,
    onDragStart: $1VByH.noop,
    onDrag: $1VByH.noop,
    onDragStop: $1VByH.noop,
    onResizeStart: $1VByH.noop,
    onResize: $1VByH.noop,
    onResizeStop: $1VByH.noop,
    onDrop: $1VByH.noop
});

});
parcelRegister("cc5cI", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = isEqual;

});

parcelRegister("1VByH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bottom = $16783fa9589b1bdb$var$bottom;
module.exports.cloneLayout = $16783fa9589b1bdb$var$cloneLayout;
module.exports.modifyLayout = $16783fa9589b1bdb$var$modifyLayout;
module.exports.withLayoutItem = $16783fa9589b1bdb$var$withLayoutItem;
module.exports.cloneLayoutItem = $16783fa9589b1bdb$var$cloneLayoutItem;
module.exports.childrenEqual = $16783fa9589b1bdb$var$childrenEqual;
module.exports.fastPositionEqual = $16783fa9589b1bdb$var$fastPositionEqual;
module.exports.collides = $16783fa9589b1bdb$var$collides;
module.exports.compact = $16783fa9589b1bdb$var$compact;
module.exports.compactItem = $16783fa9589b1bdb$var$compactItem;
module.exports.correctBounds = $16783fa9589b1bdb$var$correctBounds;
module.exports.getLayoutItem = $16783fa9589b1bdb$var$getLayoutItem;
module.exports.getFirstCollision = $16783fa9589b1bdb$var$getFirstCollision;
module.exports.getAllCollisions = $16783fa9589b1bdb$var$getAllCollisions;
module.exports.getStatics = $16783fa9589b1bdb$var$getStatics;
module.exports.moveElement = $16783fa9589b1bdb$var$moveElement;
module.exports.moveElementAwayFromCollision = $16783fa9589b1bdb$var$moveElementAwayFromCollision;
module.exports.perc = $16783fa9589b1bdb$var$perc;
module.exports.setTransform = $16783fa9589b1bdb$var$setTransform;
module.exports.setTopLeft = $16783fa9589b1bdb$var$setTopLeft;
module.exports.sortLayoutItems = $16783fa9589b1bdb$var$sortLayoutItems;
module.exports.sortLayoutItemsByRowCol = $16783fa9589b1bdb$var$sortLayoutItemsByRowCol;
module.exports.sortLayoutItemsByColRow = $16783fa9589b1bdb$var$sortLayoutItemsByColRow;
module.exports.synchronizeLayoutWithChildren = $16783fa9589b1bdb$var$synchronizeLayoutWithChildren;
module.exports.validateLayout = $16783fa9589b1bdb$var$validateLayout;
module.exports.compactType = $16783fa9589b1bdb$var$compactType;
module.exports.autoBindHandlers = $16783fa9589b1bdb$var$autoBindHandlers;
module.exports.noop = module.exports.fastRGLPropsEqual = void 0;

var $16783fa9589b1bdb$var$_lodash = $16783fa9589b1bdb$var$_interopRequireDefault((parcelRequire("cc5cI")));

var $16783fa9589b1bdb$var$_react = $16783fa9589b1bdb$var$_interopRequireDefault((parcelRequire("NdCUR")));
function $16783fa9589b1bdb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $16783fa9589b1bdb$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $16783fa9589b1bdb$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $16783fa9589b1bdb$var$ownKeys(Object(source), true).forEach(function(key) {
            $16783fa9589b1bdb$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $16783fa9589b1bdb$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $16783fa9589b1bdb$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $16783fa9589b1bdb$var$isProduction = true;
var $16783fa9589b1bdb$var$DEBUG = false;
/**
 * Return the bottom coordinate of the layout.
 *
 * @param  {Array} layout Layout array.
 * @return {Number}       Bottom coordinate.
 */ function $16783fa9589b1bdb$var$bottom(layout) /*: number*/ {
    var max = 0, bottomY;
    for(var i = 0, len = layout.length; i < len; i++){
        bottomY = layout[i].y + layout[i].h;
        if (bottomY > max) max = bottomY;
    }
    return max;
}
function $16783fa9589b1bdb$var$cloneLayout(layout) /*: Layout*/ {
    var newLayout = Array(layout.length);
    for(var i = 0, len = layout.length; i < len; i++)newLayout[i] = $16783fa9589b1bdb$var$cloneLayoutItem(layout[i]);
    return newLayout;
} // Modify a layoutItem inside a layout. Returns a new Layout,
// does not mutate. Carries over all other LayoutItems unmodified.
function $16783fa9589b1bdb$var$modifyLayout(layout, layoutItem) /*: Layout*/ {
    var newLayout = Array(layout.length);
    for(var i = 0, len = layout.length; i < len; i++)if (layoutItem.i === layout[i].i) newLayout[i] = layoutItem;
    else newLayout[i] = layout[i];
    return newLayout;
} // Function to be called to modify a layout item.
// Does defensive clones to ensure the layout is not modified.
function $16783fa9589b1bdb$var$withLayoutItem(layout, itemKey, cb) /*: [Layout, ?LayoutItem]*/ {
    var item = $16783fa9589b1bdb$var$getLayoutItem(layout, itemKey);
    if (!item) return [
        layout,
        null
    ];
    item = cb($16783fa9589b1bdb$var$cloneLayoutItem(item)); // defensive clone then modify
    // FIXME could do this faster if we already knew the index
    layout = $16783fa9589b1bdb$var$modifyLayout(layout, item);
    return [
        layout,
        item
    ];
} // Fast path to cloning, since this is monomorphic
function $16783fa9589b1bdb$var$cloneLayoutItem(layoutItem) /*: LayoutItem*/ {
    return {
        w: layoutItem.w,
        h: layoutItem.h,
        x: layoutItem.x,
        y: layoutItem.y,
        i: layoutItem.i,
        minW: layoutItem.minW,
        maxW: layoutItem.maxW,
        minH: layoutItem.minH,
        maxH: layoutItem.maxH,
        moved: Boolean(layoutItem.moved),
        static: Boolean(layoutItem.static),
        // These can be null/undefined
        isDraggable: layoutItem.isDraggable,
        isResizable: layoutItem.isResizable,
        resizeHandles: layoutItem.resizeHandles,
        isBounded: layoutItem.isBounded
    };
}
/**
 * Comparing React `children` is a bit difficult. This is a good way to compare them.
 * This will catch differences in keys, order, and length.
 */ function $16783fa9589b1bdb$var$childrenEqual(a, b) /*: boolean*/ {
    return (0, $16783fa9589b1bdb$var$_lodash.default)($16783fa9589b1bdb$var$_react.default.Children.map(a, function(c) {
        return c.key;
    }), $16783fa9589b1bdb$var$_react.default.Children.map(b, function(c) {
        return c.key;
    }));
}

var $kXeQz = parcelRequire("kXeQz");
module.exports.fastRGLPropsEqual = $kXeQz;
function $16783fa9589b1bdb$var$fastPositionEqual(a, b) /*: boolean*/ {
    return a.left === b.left && a.top === b.top && a.width === b.width && a.height === b.height;
}
/**
 * Given two layoutitems, check if they collide.
 */ function $16783fa9589b1bdb$var$collides(l1, l2) /*: boolean*/ {
    if (l1.i === l2.i) return false; // same element
    if (l1.x + l1.w <= l2.x) return false; // l1 is left of l2
    if (l1.x >= l2.x + l2.w) return false; // l1 is right of l2
    if (l1.y + l1.h <= l2.y) return false; // l1 is above l2
    if (l1.y >= l2.y + l2.h) return false; // l1 is below l2
    return true; // boxes overlap
}
/**
 * Given a layout, compact it. This involves going down each y coordinate and removing gaps
 * between items.
 *
 * Does not modify layout items (clones). Creates a new layout array.
 *
 * @param  {Array} layout Layout.
 * @param  {Boolean} verticalCompact Whether or not to compact the layout
 *   vertically.
 * @return {Array}       Compacted Layout.
 */ function $16783fa9589b1bdb$var$compact(layout, compactType, cols) /*: Layout*/ {
    // Statics go in the compareWith array right away so items flow around them.
    var compareWith = $16783fa9589b1bdb$var$getStatics(layout); // We go through the items by row and column.
    var sorted = $16783fa9589b1bdb$var$sortLayoutItems(layout, compactType); // Holding for new items.
    var out = Array(layout.length);
    for(var i = 0, len = sorted.length; i < len; i++){
        var l = $16783fa9589b1bdb$var$cloneLayoutItem(sorted[i]); // Don't move static elements
        if (!l.static) {
            l = $16783fa9589b1bdb$var$compactItem(compareWith, l, compactType, cols, sorted); // Add to comparison array. We only collide with items before this one.
            // Statics are already in this array.
            compareWith.push(l);
        } // Add to output array to make sure they still come out in the right order.
        out[layout.indexOf(sorted[i])] = l; // Clear moved flag, if it exists.
        l.moved = false;
    }
    return out;
}
var $16783fa9589b1bdb$var$heightWidth = {
    x: "w",
    y: "h"
};
/**
 * Before moving item down, it will check if the movement will cause collisions and move those items down before.
 */ function $16783fa9589b1bdb$var$resolveCompactionCollision(layout, item, moveToCoord, axis) {
    var sizeProp = $16783fa9589b1bdb$var$heightWidth[axis];
    item[axis] += 1;
    var itemIndex = layout.map(function(layoutItem) {
        return layoutItem.i;
    }).indexOf(item.i); // Go through each item we collide with.
    for(var i = itemIndex + 1; i < layout.length; i++){
        var otherItem = layout[i]; // Ignore static items
        if (otherItem.static) continue; // Optimization: we can break early if we know we're past this el
        // We can do this b/c it's a sorted layout
        if (otherItem.y > item.y + item.h) break;
        if ($16783fa9589b1bdb$var$collides(item, otherItem)) $16783fa9589b1bdb$var$resolveCompactionCollision(layout, otherItem, moveToCoord + item[sizeProp], axis);
    }
    item[axis] = moveToCoord;
}
/**
 * Compact an item in the layout.
 *
 * Modifies item.
 *
 */ function $16783fa9589b1bdb$var$compactItem(compareWith, l, compactType, cols, fullLayout) /*: LayoutItem*/ {
    var compactV = compactType === "vertical";
    var compactH = compactType === "horizontal";
    if (compactV) {
        // Bottom 'y' possible is the bottom of the layout.
        // This allows you to do nice stuff like specify {y: Infinity}
        // This is here because the layout must be sorted in order to get the correct bottom `y`.
        l.y = Math.min($16783fa9589b1bdb$var$bottom(compareWith), l.y); // Move the element up as far as it can go without colliding.
        while(l.y > 0 && !$16783fa9589b1bdb$var$getFirstCollision(compareWith, l))l.y--;
    } else if (compactH) // Move the element left as far as it can go without colliding.
    while(l.x > 0 && !$16783fa9589b1bdb$var$getFirstCollision(compareWith, l))l.x--;
     // Move it down, and keep moving it down if it's colliding.
    var collides;
    while(collides = $16783fa9589b1bdb$var$getFirstCollision(compareWith, l)){
        if (compactH) $16783fa9589b1bdb$var$resolveCompactionCollision(fullLayout, l, collides.x + collides.w, "x");
        else $16783fa9589b1bdb$var$resolveCompactionCollision(fullLayout, l, collides.y + collides.h, "y");
         // Since we can't grow without bounds horizontally, if we've overflown, let's move it down and try again.
        if (compactH && l.x + l.w > cols) {
            l.x = cols - l.w;
            l.y++;
        }
    }
    return l;
}
/**
 * Given a layout, make sure all elements fit within its bounds.
 *
 * Modifies layout items.
 *
 * @param  {Array} layout Layout array.
 * @param  {Number} bounds Number of columns.
 */ function $16783fa9589b1bdb$var$correctBounds(layout, bounds) /*: Layout*/ {
    var collidesWith = $16783fa9589b1bdb$var$getStatics(layout);
    for(var i = 0, len = layout.length; i < len; i++){
        var l = layout[i]; // Overflows right
        if (l.x + l.w > bounds.cols) l.x = bounds.cols - l.w; // Overflows left
        if (l.x < 0) {
            l.x = 0;
            l.w = bounds.cols;
        }
        if (!l.static) collidesWith.push(l);
        else // If this is static and collides with other statics, we must move it down.
        // We have to do something nicer than just letting them overlap.
        while($16783fa9589b1bdb$var$getFirstCollision(collidesWith, l))l.y++;
    }
    return layout;
}
/**
 * Get a layout item by ID. Used so we can override later on if necessary.
 *
 * @param  {Array}  layout Layout array.
 * @param  {String} id     ID
 * @return {LayoutItem}    Item at ID.
 */ function $16783fa9589b1bdb$var$getLayoutItem(layout, id) /*: ?LayoutItem*/ {
    for(var i = 0, len = layout.length; i < len; i++){
        if (layout[i].i === id) return layout[i];
    }
}
/**
 * Returns the first item this layout collides with.
 * It doesn't appear to matter which order we approach this from, although
 * perhaps that is the wrong thing to do.
 *
 * @param  {Object} layoutItem Layout item.
 * @return {Object|undefined}  A colliding layout item, or undefined.
 */ function $16783fa9589b1bdb$var$getFirstCollision(layout, layoutItem) /*: ?LayoutItem*/ {
    for(var i = 0, len = layout.length; i < len; i++){
        if ($16783fa9589b1bdb$var$collides(layout[i], layoutItem)) return layout[i];
    }
}
function $16783fa9589b1bdb$var$getAllCollisions(layout, layoutItem) /*: Array<LayoutItem>*/ {
    return layout.filter(function(l) {
        return $16783fa9589b1bdb$var$collides(l, layoutItem);
    });
}
/**
 * Get all static elements.
 * @param  {Array} layout Array of layout objects.
 * @return {Array}        Array of static layout items..
 */ function $16783fa9589b1bdb$var$getStatics(layout) /*: Array<LayoutItem>*/ {
    return layout.filter(function(l) {
        return l.static;
    });
}
/**
 * Move an element. Responsible for doing cascading movements of other elements.
 *
 * Modifies layout items.
 *
 * @param  {Array}      layout            Full layout to modify.
 * @param  {LayoutItem} l                 element to move.
 * @param  {Number}     [x]               X position in grid units.
 * @param  {Number}     [y]               Y position in grid units.
 */ function $16783fa9589b1bdb$var$moveElement(layout, l, x, y, isUserAction, preventCollision, compactType, cols) /*: Layout*/ {
    // If this is static and not explicitly enabled as draggable,
    // no move is possible, so we can short-circuit this immediately.
    if (l.static && l.isDraggable !== true) return layout; // Short-circuit if nothing to do.
    if (l.y === y && l.x === x) return layout;
    $16783fa9589b1bdb$var$log("Moving element ".concat(l.i, " to [").concat(String(x), ",").concat(String(y), "] from [").concat(l.x, ",").concat(l.y, "]"));
    var oldX = l.x;
    var oldY = l.y; // This is quite a bit faster than extending the object
    if (typeof x === "number") l.x = x;
    if (typeof y === "number") l.y = y;
    l.moved = true; // If this collides with anything, move it.
    // When doing this comparison, we have to sort the items we compare with
    // to ensure, in the case of multiple collisions, that we're getting the
    // nearest collision.
    var sorted = $16783fa9589b1bdb$var$sortLayoutItems(layout, compactType);
    var movingUp = compactType === "vertical" && typeof y === "number" ? oldY >= y : compactType === "horizontal" && typeof x === "number" ? oldX >= x : false; // $FlowIgnore acceptable modification of read-only array as it was recently cloned
    if (movingUp) sorted = sorted.reverse();
    var collisions = $16783fa9589b1bdb$var$getAllCollisions(sorted, l); // There was a collision; abort
    if (preventCollision && collisions.length) {
        $16783fa9589b1bdb$var$log("Collision prevented on ".concat(l.i, ", reverting."));
        l.x = oldX;
        l.y = oldY;
        l.moved = false;
        return layout;
    } // Move each item that collides away from this element.
    for(var i = 0, len = collisions.length; i < len; i++){
        var collision = collisions[i];
        $16783fa9589b1bdb$var$log("Resolving collision between ".concat(l.i, " at [").concat(l.x, ",").concat(l.y, "] and ").concat(collision.i, " at [").concat(collision.x, ",").concat(collision.y, "]")); // Short circuit so we can't infinite loop
        if (collision.moved) continue; // Don't move static items - we have to move *this* element away
        if (collision.static) layout = $16783fa9589b1bdb$var$moveElementAwayFromCollision(layout, collision, l, isUserAction, compactType, cols);
        else layout = $16783fa9589b1bdb$var$moveElementAwayFromCollision(layout, l, collision, isUserAction, compactType, cols);
    }
    return layout;
}
/**
 * This is where the magic needs to happen - given a collision, move an element away from the collision.
 * We attempt to move it up if there's room, otherwise it goes below.
 *
 * @param  {Array} layout            Full layout to modify.
 * @param  {LayoutItem} collidesWith Layout item we're colliding with.
 * @param  {LayoutItem} itemToMove   Layout item we're moving.
 */ function $16783fa9589b1bdb$var$moveElementAwayFromCollision(layout, collidesWith, itemToMove, isUserAction, compactType, cols) /*: Layout*/ {
    var compactH = compactType === "horizontal"; // Compact vertically if not set to horizontal
    var compactV = compactType !== "horizontal";
    var preventCollision = collidesWith.static; // we're already colliding (not for static items)
    // If there is enough space above the collision to put this element, move it there.
    // We only do this on the main collision as this can get funky in cascades and cause
    // unwanted swapping behavior.
    if (isUserAction) {
        // Reset isUserAction flag because we're not in the main collision anymore.
        isUserAction = false; // Make a mock item so we don't modify the item here, only modify in moveElement.
        var fakeItem = {
            x: compactH ? Math.max(collidesWith.x - itemToMove.w, 0) : itemToMove.x,
            y: compactV ? Math.max(collidesWith.y - itemToMove.h, 0) : itemToMove.y,
            w: itemToMove.w,
            h: itemToMove.h,
            i: "-1"
        }; // No collision? If so, we can go up there; otherwise, we'll end up moving down as normal
        if (!$16783fa9589b1bdb$var$getFirstCollision(layout, fakeItem)) {
            $16783fa9589b1bdb$var$log("Doing reverse collision on ".concat(itemToMove.i, " up to [").concat(fakeItem.x, ",").concat(fakeItem.y, "]."));
            return $16783fa9589b1bdb$var$moveElement(layout, itemToMove, compactH ? fakeItem.x : undefined, compactV ? fakeItem.y : undefined, isUserAction, preventCollision, compactType, cols);
        }
    }
    return $16783fa9589b1bdb$var$moveElement(layout, itemToMove, compactH ? itemToMove.x + 1 : undefined, compactV ? itemToMove.y + 1 : undefined, isUserAction, preventCollision, compactType, cols);
}
/**
 * Helper to convert a number to a percentage string.
 *
 * @param  {Number} num Any number
 * @return {String}     That number as a percentage.
 */ function $16783fa9589b1bdb$var$perc(num) /*: string*/ {
    return num * 100 + "%";
}
function $16783fa9589b1bdb$var$setTransform(_ref) /*: Object*/ {
    var top = _ref.top, left = _ref.left, width = _ref.width, height = _ref.height;
    // Replace unitless items with px
    var translate = "translate(".concat(left, "px,").concat(top, "px)");
    return {
        transform: translate,
        WebkitTransform: translate,
        MozTransform: translate,
        msTransform: translate,
        OTransform: translate,
        width: "".concat(width, "px"),
        height: "".concat(height, "px"),
        position: "absolute"
    };
}
function $16783fa9589b1bdb$var$setTopLeft(_ref2) /*: Object*/ {
    var top = _ref2.top, left = _ref2.left, width = _ref2.width, height = _ref2.height;
    return {
        top: "".concat(top, "px"),
        left: "".concat(left, "px"),
        width: "".concat(width, "px"),
        height: "".concat(height, "px"),
        position: "absolute"
    };
}
/**
 * Get layout items sorted from top left to right and down.
 *
 * @return {Array} Array of layout objects.
 * @return {Array}        Layout, sorted static items first.
 */ function $16783fa9589b1bdb$var$sortLayoutItems(layout, compactType) /*: Layout*/ {
    if (compactType === "horizontal") return $16783fa9589b1bdb$var$sortLayoutItemsByColRow(layout);
    else return $16783fa9589b1bdb$var$sortLayoutItemsByRowCol(layout);
}
/**
 * Sort layout items by row ascending and column ascending.
 *
 * Does not modify Layout.
 */ function $16783fa9589b1bdb$var$sortLayoutItemsByRowCol(layout) /*: Layout*/ {
    // Slice to clone array as sort modifies
    return layout.slice(0).sort(function(a, b) {
        if (a.y > b.y || a.y === b.y && a.x > b.x) return 1;
        else if (a.y === b.y && a.x === b.x) // Without this, we can get different sort results in IE vs. Chrome/FF
        return 0;
        return -1;
    });
}
/**
 * Sort layout items by column ascending then row ascending.
 *
 * Does not modify Layout.
 */ function $16783fa9589b1bdb$var$sortLayoutItemsByColRow(layout) /*: Layout*/ {
    return layout.slice(0).sort(function(a, b) {
        if (a.x > b.x || a.x === b.x && a.y > b.y) return 1;
        return -1;
    });
}
/**
 * Generate a layout using the initialLayout and children as a template.
 * Missing entries will be added, extraneous ones will be truncated.
 *
 * Does not modify initialLayout.
 *
 * @param  {Array}  initialLayout Layout passed in through props.
 * @param  {String} breakpoint    Current responsive breakpoint.
 * @param  {?String} compact      Compaction option.
 * @return {Array}                Working layout.
 */ function $16783fa9589b1bdb$var$synchronizeLayoutWithChildren(initialLayout, children, cols, compactType) /*: Layout*/ {
    initialLayout = initialLayout || []; // Generate one layout item per child.
    var layout = [];
    $16783fa9589b1bdb$var$_react.default.Children.forEach(children, function(child, i) {
        // Don't overwrite if it already exists.
        var exists = $16783fa9589b1bdb$var$getLayoutItem(initialLayout, String(child.key));
        if (exists) layout[i] = $16783fa9589b1bdb$var$cloneLayoutItem(exists);
        else {
            if (!$16783fa9589b1bdb$var$isProduction && child.props._grid) console.warn("`_grid` properties on children have been deprecated as of React 15.2. Please use `data-grid` or add your properties directly to the `layout`.");
            var g = child.props["data-grid"] || child.props._grid; // Hey, this item has a data-grid property, use it.
            if (g) {
                if (!$16783fa9589b1bdb$var$isProduction) $16783fa9589b1bdb$var$validateLayout([
                    g
                ], "ReactGridLayout.children");
                 // FIXME clone not really necessary here
                layout[i] = $16783fa9589b1bdb$var$cloneLayoutItem($16783fa9589b1bdb$var$_objectSpread($16783fa9589b1bdb$var$_objectSpread({}, g), {}, {
                    i: child.key
                }));
            } else // Nothing provided: ensure this is added to the bottom
            // FIXME clone not really necessary here
            layout[i] = $16783fa9589b1bdb$var$cloneLayoutItem({
                w: 1,
                h: 1,
                x: 0,
                y: $16783fa9589b1bdb$var$bottom(layout),
                i: String(child.key)
            });
        }
    }); // Correct the layout.
    var correctedLayout = $16783fa9589b1bdb$var$correctBounds(layout, {
        cols: cols
    });
    return $16783fa9589b1bdb$var$compact(correctedLayout, compactType, cols);
}
/**
 * Validate a layout. Throws errors.
 *
 * @param  {Array}  layout        Array of layout items.
 * @param  {String} [contextName] Context name for errors.
 * @throw  {Error}                Validation error.
 */ function $16783fa9589b1bdb$var$validateLayout(layout) /*: void*/ {
    var contextName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Layout";
    var subProps = [
        "x",
        "y",
        "w",
        "h"
    ];
    if (!Array.isArray(layout)) throw new Error(contextName + " must be an array!");
    for(var i = 0, len = layout.length; i < len; i++){
        var item = layout[i];
        for(var j = 0; j < subProps.length; j++){
            if (typeof item[subProps[j]] !== "number") throw new Error("ReactGridLayout: " + contextName + "[" + i + "]." + subProps[j] + " must be a number!");
        }
        if (item.i && typeof item.i !== "string") throw new Error("ReactGridLayout: " + contextName + "[" + i + "].i must be a string!");
        if (item.static !== undefined && typeof item.static !== "boolean") throw new Error("ReactGridLayout: " + contextName + "[" + i + "].static must be a boolean!");
    }
} // Legacy support for verticalCompact: false
function $16783fa9589b1bdb$var$compactType(props) /*: CompactType*/ {
    var _ref3 = props || {}, verticalCompact = _ref3.verticalCompact, compactType = _ref3.compactType;
    return verticalCompact === false ? null : compactType;
} // Flow can't really figure this out, so we just use Object
function $16783fa9589b1bdb$var$autoBindHandlers(el, fns) /*: void*/ {
    fns.forEach(function(key) {
        return el[key] = el[key].bind(el);
    });
}
function $16783fa9589b1bdb$var$log() {
    var _console;
    if (!$16783fa9589b1bdb$var$DEBUG) return; // eslint-disable-next-line no-console
    (_console = console).log.apply(_console, arguments);
}
var $16783fa9589b1bdb$var$noop = function noop() {};
module.exports.noop = $16783fa9589b1bdb$var$noop;

});
parcelRegister("kXeQz", function(module, exports) {
// this file was prevaled
module.exports = function fastRGLPropsEqual(a, b, isEqualImpl) {
    if (a === b) return true;
    return a.className === b.className && isEqualImpl(a.style, b.style) && a.width === b.width && a.autoSize === b.autoSize && a.cols === b.cols && a.draggableCancel === b.draggableCancel && a.draggableHandle === b.draggableHandle && isEqualImpl(a.verticalCompact, b.verticalCompact) && isEqualImpl(a.compactType, b.compactType) && isEqualImpl(a.layout, b.layout) && isEqualImpl(a.margin, b.margin) && isEqualImpl(a.containerPadding, b.containerPadding) && a.rowHeight === b.rowHeight && a.maxRows === b.maxRows && a.isBounded === b.isBounded && a.isDraggable === b.isDraggable && a.isResizable === b.isResizable && a.preventCollision === b.preventCollision && a.useCSSTransforms === b.useCSSTransforms && a.transformScale === b.transformScale && a.isDroppable === b.isDroppable && isEqualImpl(a.resizeHandles, b.resizeHandles) && isEqualImpl(a.resizeHandle, b.resizeHandle) && a.onLayoutChange === b.onLayoutChange && a.onDragStart === b.onDragStart && a.onDrag === b.onDrag && a.onDragStop === b.onDragStop && a.onResizeStart === b.onResizeStart && a.onResize === b.onResize && a.onResizeStop === b.onResizeStop && a.onDrop === b.onDrop && isEqualImpl(a.droppingItem, b.droppingItem) && isEqualImpl(a.innerRef, b.innerRef);
};

});


parcelRegister("2WZMH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calcGridColWidth = $2260ecad5dcfee3c$var$calcGridColWidth;
module.exports.calcGridItemWHPx = $2260ecad5dcfee3c$var$calcGridItemWHPx;
module.exports.calcGridItemPosition = $2260ecad5dcfee3c$var$calcGridItemPosition;
module.exports.calcXY = $2260ecad5dcfee3c$var$calcXY;
module.exports.calcWH = $2260ecad5dcfee3c$var$calcWH;
module.exports.clamp = $2260ecad5dcfee3c$var$clamp;
/*:: import type { Position } from "./utils";*/ /*:: export type PositionParams = {
  margin: [number, number],
  containerPadding: [number, number],
  containerWidth: number,
  cols: number,
  rowHeight: number,
  maxRows: number
};*/ // Helper for generating column width
function $2260ecad5dcfee3c$var$calcGridColWidth(positionParams) /*: number*/ {
    var margin = positionParams.margin, containerPadding = positionParams.containerPadding, containerWidth = positionParams.containerWidth, cols = positionParams.cols;
    return (containerWidth - margin[0] * (cols - 1) - containerPadding[0] * 2) / cols;
} // This can either be called:
// calcGridItemWHPx(w, colWidth, margin[0])
// or
// calcGridItemWHPx(h, rowHeight, margin[1])
function $2260ecad5dcfee3c$var$calcGridItemWHPx(gridUnits, colOrRowSize, marginPx) /*: number*/ {
    // 0 * Infinity === NaN, which causes problems with resize contraints
    if (!Number.isFinite(gridUnits)) return gridUnits;
    return Math.round(colOrRowSize * gridUnits + Math.max(0, gridUnits - 1) * marginPx);
}
/**
 * Return position on the page given an x, y, w, h.
 * left, top, width, height are all in pixels.
 * @param  {PositionParams} positionParams  Parameters of grid needed for coordinates calculations.
 * @param  {Number}  x                      X coordinate in grid units.
 * @param  {Number}  y                      Y coordinate in grid units.
 * @param  {Number}  w                      W coordinate in grid units.
 * @param  {Number}  h                      H coordinate in grid units.
 * @return {Position}                       Object containing coords.
 */ function $2260ecad5dcfee3c$var$calcGridItemPosition(positionParams, x, y, w, h, state) /*: Position*/ {
    var margin = positionParams.margin, containerPadding = positionParams.containerPadding, rowHeight = positionParams.rowHeight;
    var colWidth = $2260ecad5dcfee3c$var$calcGridColWidth(positionParams);
    var out = {}; // If resizing, use the exact width and height as returned from resizing callbacks.
    if (state && state.resizing) {
        out.width = Math.round(state.resizing.width);
        out.height = Math.round(state.resizing.height);
    } else {
        out.width = $2260ecad5dcfee3c$var$calcGridItemWHPx(w, colWidth, margin[0]);
        out.height = $2260ecad5dcfee3c$var$calcGridItemWHPx(h, rowHeight, margin[1]);
    } // If dragging, use the exact width and height as returned from dragging callbacks.
    if (state && state.dragging) {
        out.top = Math.round(state.dragging.top);
        out.left = Math.round(state.dragging.left);
    } else {
        out.top = Math.round((rowHeight + margin[1]) * y + containerPadding[1]);
        out.left = Math.round((colWidth + margin[0]) * x + containerPadding[0]);
    }
    return out;
}
/**
 * Translate x and y coordinates from pixels to grid units.
 * @param  {PositionParams} positionParams  Parameters of grid needed for coordinates calculations.
 * @param  {Number} top                     Top position (relative to parent) in pixels.
 * @param  {Number} left                    Left position (relative to parent) in pixels.
 * @param  {Number} w                       W coordinate in grid units.
 * @param  {Number} h                       H coordinate in grid units.
 * @return {Object}                         x and y in grid units.
 */ function $2260ecad5dcfee3c$var$calcXY(positionParams, top, left, w, h) /*: { x: number, y: number }*/ {
    var margin = positionParams.margin, cols = positionParams.cols, rowHeight = positionParams.rowHeight, maxRows = positionParams.maxRows;
    var colWidth = $2260ecad5dcfee3c$var$calcGridColWidth(positionParams); // left = colWidth * x + margin * (x + 1)
    // l = cx + m(x+1)
    // l = cx + mx + m
    // l - m = cx + mx
    // l - m = x(c + m)
    // (l - m) / (c + m) = x
    // x = (left - margin) / (coldWidth + margin)
    var x = Math.round((left - margin[0]) / (colWidth + margin[0]));
    var y = Math.round((top - margin[1]) / (rowHeight + margin[1])); // Capping
    x = $2260ecad5dcfee3c$var$clamp(x, 0, cols - w);
    y = $2260ecad5dcfee3c$var$clamp(y, 0, maxRows - h);
    return {
        x: x,
        y: y
    };
}
/**
 * Given a height and width in pixel values, calculate grid units.
 * @param  {PositionParams} positionParams  Parameters of grid needed for coordinates calcluations.
 * @param  {Number} height                  Height in pixels.
 * @param  {Number} width                   Width in pixels.
 * @param  {Number} x                       X coordinate in grid units.
 * @param  {Number} y                       Y coordinate in grid units.
 * @return {Object}                         w, h as grid units.
 */ function $2260ecad5dcfee3c$var$calcWH(positionParams, width, height, x, y) /*: { w: number, h: number }*/ {
    var margin = positionParams.margin, maxRows = positionParams.maxRows, cols = positionParams.cols, rowHeight = positionParams.rowHeight;
    var colWidth = $2260ecad5dcfee3c$var$calcGridColWidth(positionParams); // width = colWidth * w - (margin * (w - 1))
    // ...
    // w = (width + margin) / (colWidth + margin)
    var w = Math.round((width + margin[0]) / (colWidth + margin[0]));
    var h = Math.round((height + margin[1]) / (rowHeight + margin[1])); // Capping
    w = $2260ecad5dcfee3c$var$clamp(w, 0, cols - x);
    h = $2260ecad5dcfee3c$var$clamp(h, 0, maxRows - y);
    return {
        w: w,
        h: h
    };
} // Similar to _.clamp
function $2260ecad5dcfee3c$var$clamp(num, lowerBound, upperBound) /*: number*/ {
    return Math.max(Math.min(num, upperBound), lowerBound);
}

});

parcelRegister("eCToD", function(module, exports) {
"use strict";
function $aa5f95d793842953$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $aa5f95d793842953$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $aa5f95d793842953$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $aa5f95d793842953$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aa5f95d793842953$var$_react = $aa5f95d793842953$var$_interopRequireDefault((parcelRequire("NdCUR")));

var $aa5f95d793842953$var$_reactDom = $aa5f95d793842953$var$_interopRequireDefault((parcelRequire("g2wso")));

var $aa5f95d793842953$var$_propTypes = $aa5f95d793842953$var$_interopRequireDefault((parcelRequire("fGw9V")));

var $aqFpf = parcelRequire("aqFpf");

var $fzrCT = parcelRequire("fzrCT");

var $1VByH = parcelRequire("1VByH");

var $2WZMH = parcelRequire("2WZMH");

var $jGk5X = parcelRequire("jGk5X");

var $aa5f95d793842953$var$_classnames = $aa5f95d793842953$var$_interopRequireDefault((parcelRequire("1v7mg")));
function $aa5f95d793842953$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $aa5f95d793842953$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $aa5f95d793842953$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $aa5f95d793842953$var$ownKeys(Object(source), true).forEach(function(key) {
            $aa5f95d793842953$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $aa5f95d793842953$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $aa5f95d793842953$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $aa5f95d793842953$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $aa5f95d793842953$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $aa5f95d793842953$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $aa5f95d793842953$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $aa5f95d793842953$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $aa5f95d793842953$var$_setPrototypeOf(subClass, superClass);
}
function $aa5f95d793842953$var$_setPrototypeOf(o, p) {
    $aa5f95d793842953$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $aa5f95d793842953$var$_setPrototypeOf(o, p);
}
function $aa5f95d793842953$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $aa5f95d793842953$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $aa5f95d793842953$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $aa5f95d793842953$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $aa5f95d793842953$var$_possibleConstructorReturn(this, result);
    };
}
function $aa5f95d793842953$var$_possibleConstructorReturn(self, call) {
    if (call && ($aa5f95d793842953$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $aa5f95d793842953$var$_assertThisInitialized(self);
}
function $aa5f95d793842953$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $aa5f95d793842953$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $aa5f95d793842953$var$_getPrototypeOf(o) {
    $aa5f95d793842953$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $aa5f95d793842953$var$_getPrototypeOf(o);
}
function $aa5f95d793842953$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/**
 * An individual item within a ReactGridLayout.
 */ var $aa5f95d793842953$var$GridItem = /*#__PURE__*/ function(_React$Component) {
    $aa5f95d793842953$var$_inherits(GridItem, _React$Component);
    var _super = $aa5f95d793842953$var$_createSuper(GridItem);
    function GridItem() {
        var _this;
        $aa5f95d793842953$var$_classCallCheck(this, GridItem);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $aa5f95d793842953$var$_defineProperty($aa5f95d793842953$var$_assertThisInitialized(_this), "state", {
            resizing: null,
            dragging: null,
            className: ""
        });
        $aa5f95d793842953$var$_defineProperty($aa5f95d793842953$var$_assertThisInitialized(_this), "currentNode", void 0);
        $aa5f95d793842953$var$_defineProperty($aa5f95d793842953$var$_assertThisInitialized(_this), "onDragStart", function(e, _ref) {
            var node = _ref.node;
            var _this$props = _this.props, onDragStart = _this$props.onDragStart, transformScale = _this$props.transformScale;
            if (!onDragStart) return;
            var newPosition = {
                top: 0,
                left: 0
            }; // TODO: this wont work on nested parents
            var offsetParent = node.offsetParent;
            if (!offsetParent) return;
            var parentRect = offsetParent.getBoundingClientRect();
            var clientRect = node.getBoundingClientRect();
            var cLeft = clientRect.left / transformScale;
            var pLeft = parentRect.left / transformScale;
            var cTop = clientRect.top / transformScale;
            var pTop = parentRect.top / transformScale;
            newPosition.left = cLeft - pLeft + offsetParent.scrollLeft;
            newPosition.top = cTop - pTop + offsetParent.scrollTop;
            _this.setState({
                dragging: newPosition
            }); // Call callback with this data
            var _calcXY = (0, $2WZMH.calcXY)(_this.getPositionParams(), newPosition.top, newPosition.left, _this.props.w, _this.props.h), x = _calcXY.x, y = _calcXY.y;
            return onDragStart.call($aa5f95d793842953$var$_assertThisInitialized(_this), _this.props.i, x, y, {
                e: e,
                node: node,
                newPosition: newPosition
            });
        });
        $aa5f95d793842953$var$_defineProperty($aa5f95d793842953$var$_assertThisInitialized(_this), "onDrag", function(e, _ref2) {
            var node = _ref2.node, deltaX = _ref2.deltaX, deltaY = _ref2.deltaY;
            var onDrag = _this.props.onDrag;
            if (!onDrag) return;
            if (!_this.state.dragging) throw new Error("onDrag called before onDragStart.");
            var top = _this.state.dragging.top + deltaY;
            var left = _this.state.dragging.left + deltaX;
            var _this$props2 = _this.props, isBounded = _this$props2.isBounded, i = _this$props2.i, w = _this$props2.w, h = _this$props2.h, containerWidth = _this$props2.containerWidth;
            var positionParams = _this.getPositionParams(); // Boundary calculations; keeps items within the grid
            if (isBounded) {
                var offsetParent = node.offsetParent;
                if (offsetParent) {
                    var _this$props3 = _this.props, margin = _this$props3.margin, rowHeight = _this$props3.rowHeight;
                    var bottomBoundary = offsetParent.clientHeight - (0, $2WZMH.calcGridItemWHPx)(h, rowHeight, margin[1]);
                    top = (0, $2WZMH.clamp)(top, 0, bottomBoundary);
                    var colWidth = (0, $2WZMH.calcGridColWidth)(positionParams);
                    var rightBoundary = containerWidth - (0, $2WZMH.calcGridItemWHPx)(w, colWidth, margin[0]);
                    left = (0, $2WZMH.clamp)(left, 0, rightBoundary);
                }
            }
            var newPosition = {
                top: top,
                left: left
            };
            _this.setState({
                dragging: newPosition
            }); // Call callback with this data
            var _calcXY2 = (0, $2WZMH.calcXY)(positionParams, top, left, w, h), x = _calcXY2.x, y = _calcXY2.y;
            return onDrag.call($aa5f95d793842953$var$_assertThisInitialized(_this), i, x, y, {
                e: e,
                node: node,
                newPosition: newPosition
            });
        });
        $aa5f95d793842953$var$_defineProperty($aa5f95d793842953$var$_assertThisInitialized(_this), "onDragStop", function(e, _ref3) {
            var node = _ref3.node;
            var onDragStop = _this.props.onDragStop;
            if (!onDragStop) return;
            if (!_this.state.dragging) throw new Error("onDragEnd called before onDragStart.");
            var _this$props4 = _this.props, w = _this$props4.w, h = _this$props4.h, i = _this$props4.i;
            var _this$state$dragging = _this.state.dragging, left = _this$state$dragging.left, top = _this$state$dragging.top;
            var newPosition = {
                top: top,
                left: left
            };
            _this.setState({
                dragging: null
            });
            var _calcXY3 = (0, $2WZMH.calcXY)(_this.getPositionParams(), top, left, w, h), x = _calcXY3.x, y = _calcXY3.y;
            return onDragStop.call($aa5f95d793842953$var$_assertThisInitialized(_this), i, x, y, {
                e: e,
                node: node,
                newPosition: newPosition
            });
        });
        $aa5f95d793842953$var$_defineProperty($aa5f95d793842953$var$_assertThisInitialized(_this), "onResizeStop", function(e, callbackData) {
            _this.onResizeHandler(e, callbackData, "onResizeStop");
        });
        $aa5f95d793842953$var$_defineProperty($aa5f95d793842953$var$_assertThisInitialized(_this), "onResizeStart", function(e, callbackData) {
            _this.onResizeHandler(e, callbackData, "onResizeStart");
        });
        $aa5f95d793842953$var$_defineProperty($aa5f95d793842953$var$_assertThisInitialized(_this), "onResize", function(e, callbackData) {
            _this.onResizeHandler(e, callbackData, "onResize");
        });
        return _this;
    }
    $aa5f95d793842953$var$_createClass(GridItem, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps, nextState) /*: boolean*/ {
                // We can't deeply compare children. If the developer memoizes them, we can
                // use this optimization.
                if (this.props.children !== nextProps.children) return true;
                if (this.props.droppingPosition !== nextProps.droppingPosition) return true; // TODO memoize these calculations so they don't take so long?
                var oldPosition = (0, $2WZMH.calcGridItemPosition)(this.getPositionParams(this.props), this.props.x, this.props.y, this.props.w, this.props.h, this.state);
                var newPosition = (0, $2WZMH.calcGridItemPosition)(this.getPositionParams(nextProps), nextProps.x, nextProps.y, nextProps.w, nextProps.h, nextState);
                return !(0, $1VByH.fastPositionEqual)(oldPosition, newPosition) || this.props.useCSSTransforms !== nextProps.useCSSTransforms;
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.moveDroppingItem({});
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                this.moveDroppingItem(prevProps);
            } // When a droppingPosition is present, this means we should fire a move event, as if we had moved
        },
        {
            key: "moveDroppingItem",
            value: function moveDroppingItem(prevProps) {
                var droppingPosition = this.props.droppingPosition;
                if (!droppingPosition) return;
                var prevDroppingPosition = prevProps.droppingPosition || {
                    left: 0,
                    top: 0
                };
                var dragging = this.state.dragging;
                if (!this.currentNode) // eslint-disable-next-line react/no-find-dom-node
                this.currentNode = $aa5f95d793842953$var$_reactDom.default.findDOMNode(this);
                var shouldDrag = dragging && droppingPosition.left !== prevDroppingPosition.left || droppingPosition.top !== prevDroppingPosition.top;
                if (!dragging) this.onDragStart(droppingPosition.e, {
                    node: this.currentNode,
                    deltaX: droppingPosition.left,
                    deltaY: droppingPosition.top
                });
                else if (shouldDrag) {
                    var deltaX = droppingPosition.left - dragging.left;
                    var deltaY = droppingPosition.top - dragging.top;
                    this.onDrag(droppingPosition.e, {
                        node: this.currentNode,
                        deltaX: deltaX,
                        deltaY: deltaY
                    });
                }
            }
        },
        {
            key: "getPositionParams",
            value: function getPositionParams() /*: PositionParams*/ {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                return {
                    cols: props.cols,
                    containerPadding: props.containerPadding,
                    containerWidth: props.containerWidth,
                    margin: props.margin,
                    maxRows: props.maxRows,
                    rowHeight: props.rowHeight
                };
            }
        },
        {
            key: "createStyle",
            value: function createStyle(pos) /*: { [key: string]: ?string }*/ {
                var _this$props5 = this.props, usePercentages = _this$props5.usePercentages, containerWidth = _this$props5.containerWidth, useCSSTransforms = _this$props5.useCSSTransforms;
                var style; // CSS Transforms support (default)
                if (useCSSTransforms) style = (0, $1VByH.setTransform)(pos);
                else {
                    // top,left (slow)
                    style = (0, $1VByH.setTopLeft)(pos); // This is used for server rendering.
                    if (usePercentages) {
                        style.left = (0, $1VByH.perc)(pos.left / containerWidth);
                        style.width = (0, $1VByH.perc)(pos.width / containerWidth);
                    }
                }
                return style;
            }
        },
        {
            key: "mixinDraggable",
            value: function mixinDraggable(child, isDraggable) /*: ReactElement<any>*/ {
                return /*#__PURE__*/ $aa5f95d793842953$var$_react.default.createElement($aqFpf.DraggableCore, {
                    disabled: !isDraggable,
                    onStart: this.onDragStart,
                    onDrag: this.onDrag,
                    onStop: this.onDragStop,
                    handle: this.props.handle,
                    cancel: ".react-resizable-handle" + (this.props.cancel ? "," + this.props.cancel : ""),
                    scale: this.props.transformScale
                }, child);
            }
        },
        {
            key: "mixinResizable",
            value: function mixinResizable(child, position, isResizable) /*: ReactElement<any>*/ {
                var _this$props6 = this.props, cols = _this$props6.cols, x = _this$props6.x, minW = _this$props6.minW, minH = _this$props6.minH, maxW = _this$props6.maxW, maxH = _this$props6.maxH, transformScale = _this$props6.transformScale, resizeHandles = _this$props6.resizeHandles, resizeHandle = _this$props6.resizeHandle;
                var positionParams = this.getPositionParams(); // This is the max possible width - doesn't go to infinity because of the width of the window
                var maxWidth = (0, $2WZMH.calcGridItemPosition)(positionParams, 0, 0, cols - x, 0).width; // Calculate min/max constraints using our min & maxes
                var mins = (0, $2WZMH.calcGridItemPosition)(positionParams, 0, 0, minW, minH);
                var maxes = (0, $2WZMH.calcGridItemPosition)(positionParams, 0, 0, maxW, maxH);
                var minConstraints = [
                    mins.width,
                    mins.height
                ];
                var maxConstraints = [
                    Math.min(maxes.width, maxWidth),
                    Math.min(maxes.height, Infinity)
                ];
                return /*#__PURE__*/ $aa5f95d793842953$var$_react.default.createElement($fzrCT.Resizable, {
                    draggableOpts: {
                        disabled: !isResizable
                    },
                    className: isResizable ? undefined : "react-resizable-hide",
                    width: position.width,
                    height: position.height,
                    minConstraints: minConstraints,
                    maxConstraints: maxConstraints,
                    onResizeStop: this.onResizeStop,
                    onResizeStart: this.onResizeStart,
                    onResize: this.onResize,
                    transformScale: transformScale,
                    resizeHandles: resizeHandles,
                    handle: resizeHandle
                }, child);
            }
        },
        {
            key: "onResizeHandler",
            value: /**
     * Wrapper around drag events to provide more useful data.
     * All drag events call the function with the given handler name,
     * with the signature (index, x, y).
     *
     * @param  {String} handlerName Handler name to wrap.
     * @return {Function}           Handler function.
     */ function onResizeHandler(e, _ref4, handlerName) /*: void*/ {
                var node = _ref4.node, size = _ref4.size;
                var handler = this.props[handlerName];
                if (!handler) return;
                var _this$props7 = this.props, cols = _this$props7.cols, x = _this$props7.x, y = _this$props7.y, i = _this$props7.i, maxH = _this$props7.maxH, minH = _this$props7.minH;
                var _this$props8 = this.props, minW = _this$props8.minW, maxW = _this$props8.maxW; // Get new XY
                var _calcWH = (0, $2WZMH.calcWH)(this.getPositionParams(), size.width, size.height, x, y), w = _calcWH.w, h = _calcWH.h; // minW should be at least 1 (TODO propTypes validation?)
                minW = Math.max(minW, 1); // maxW should be at most (cols - x)
                maxW = Math.min(maxW, cols - x); // Min/max capping
                w = (0, $2WZMH.clamp)(w, minW, maxW);
                h = (0, $2WZMH.clamp)(h, minH, maxH);
                this.setState({
                    resizing: handlerName === "onResizeStop" ? null : size
                });
                handler.call(this, i, w, h, {
                    e: e,
                    node: node,
                    size: size
                });
            }
        },
        {
            key: "render",
            value: function render() /*: ReactNode*/ {
                var _this$props9 = this.props, x = _this$props9.x, y = _this$props9.y, w = _this$props9.w, h = _this$props9.h, isDraggable = _this$props9.isDraggable, isResizable = _this$props9.isResizable, droppingPosition = _this$props9.droppingPosition, useCSSTransforms = _this$props9.useCSSTransforms;
                var pos = (0, $2WZMH.calcGridItemPosition)(this.getPositionParams(), x, y, w, h, this.state);
                var child = $aa5f95d793842953$var$_react.default.Children.only(this.props.children); // Create the child element. We clone the existing element but modify its className and style.
                var newChild = /*#__PURE__*/ $aa5f95d793842953$var$_react.default.cloneElement(child, {
                    className: (0, $aa5f95d793842953$var$_classnames.default)("react-grid-item", child.props.className, this.props.className, {
                        static: this.props.static,
                        resizing: Boolean(this.state.resizing),
                        "react-draggable": isDraggable,
                        "react-draggable-dragging": Boolean(this.state.dragging),
                        dropping: Boolean(droppingPosition),
                        cssTransforms: useCSSTransforms
                    }),
                    // We can set the width and height on the child, but unfortunately we can't set the position.
                    style: $aa5f95d793842953$var$_objectSpread($aa5f95d793842953$var$_objectSpread($aa5f95d793842953$var$_objectSpread({}, this.props.style), child.props.style), this.createStyle(pos))
                }); // Resizable support. This is usually on but the user can toggle it off.
                newChild = this.mixinResizable(newChild, pos, isResizable); // Draggable support. This is always on, except for with placeholders.
                newChild = this.mixinDraggable(newChild, isDraggable);
                return newChild;
            }
        }
    ]);
    return GridItem;
}($aa5f95d793842953$var$_react.default.Component);
module.exports.default = $aa5f95d793842953$var$GridItem;
$aa5f95d793842953$var$_defineProperty($aa5f95d793842953$var$GridItem, "propTypes", {
    // Children must be only a single element
    children: $aa5f95d793842953$var$_propTypes.default.element,
    // General grid attributes
    cols: $aa5f95d793842953$var$_propTypes.default.number.isRequired,
    containerWidth: $aa5f95d793842953$var$_propTypes.default.number.isRequired,
    rowHeight: $aa5f95d793842953$var$_propTypes.default.number.isRequired,
    margin: $aa5f95d793842953$var$_propTypes.default.array.isRequired,
    maxRows: $aa5f95d793842953$var$_propTypes.default.number.isRequired,
    containerPadding: $aa5f95d793842953$var$_propTypes.default.array.isRequired,
    // These are all in grid units
    x: $aa5f95d793842953$var$_propTypes.default.number.isRequired,
    y: $aa5f95d793842953$var$_propTypes.default.number.isRequired,
    w: $aa5f95d793842953$var$_propTypes.default.number.isRequired,
    h: $aa5f95d793842953$var$_propTypes.default.number.isRequired,
    // All optional
    minW: function minW(props, propName) {
        var value = props[propName];
        if (typeof value !== "number") return new Error("minWidth not Number");
        if (value > props.w || value > props.maxW) return new Error("minWidth larger than item width/maxWidth");
    },
    maxW: function maxW(props, propName) {
        var value = props[propName];
        if (typeof value !== "number") return new Error("maxWidth not Number");
        if (value < props.w || value < props.minW) return new Error("maxWidth smaller than item width/minWidth");
    },
    minH: function minH(props, propName) {
        var value = props[propName];
        if (typeof value !== "number") return new Error("minHeight not Number");
        if (value > props.h || value > props.maxH) return new Error("minHeight larger than item height/maxHeight");
    },
    maxH: function maxH(props, propName) {
        var value = props[propName];
        if (typeof value !== "number") return new Error("maxHeight not Number");
        if (value < props.h || value < props.minH) return new Error("maxHeight smaller than item height/minHeight");
    },
    // ID is nice to have for callbacks
    i: $aa5f95d793842953$var$_propTypes.default.string.isRequired,
    // Resize handle options
    resizeHandles: $jGk5X.resizeHandlesType,
    resizeHandle: $jGk5X.resizeHandleType,
    // Functions
    onDragStop: $aa5f95d793842953$var$_propTypes.default.func,
    onDragStart: $aa5f95d793842953$var$_propTypes.default.func,
    onDrag: $aa5f95d793842953$var$_propTypes.default.func,
    onResizeStop: $aa5f95d793842953$var$_propTypes.default.func,
    onResizeStart: $aa5f95d793842953$var$_propTypes.default.func,
    onResize: $aa5f95d793842953$var$_propTypes.default.func,
    // Flags
    isDraggable: $aa5f95d793842953$var$_propTypes.default.bool.isRequired,
    isResizable: $aa5f95d793842953$var$_propTypes.default.bool.isRequired,
    isBounded: $aa5f95d793842953$var$_propTypes.default.bool.isRequired,
    static: $aa5f95d793842953$var$_propTypes.default.bool,
    // Use CSS transforms instead of top/left
    useCSSTransforms: $aa5f95d793842953$var$_propTypes.default.bool.isRequired,
    transformScale: $aa5f95d793842953$var$_propTypes.default.number,
    // Others
    className: $aa5f95d793842953$var$_propTypes.default.string,
    // Selector for draggable handle
    handle: $aa5f95d793842953$var$_propTypes.default.string,
    // Selector for draggable cancel (see react-draggable)
    cancel: $aa5f95d793842953$var$_propTypes.default.string,
    // Current position of a dropping element
    droppingPosition: $aa5f95d793842953$var$_propTypes.default.shape({
        e: $aa5f95d793842953$var$_propTypes.default.object.isRequired,
        left: $aa5f95d793842953$var$_propTypes.default.number.isRequired,
        top: $aa5f95d793842953$var$_propTypes.default.number.isRequired
    })
});
$aa5f95d793842953$var$_defineProperty($aa5f95d793842953$var$GridItem, "defaultProps", {
    className: "",
    cancel: "",
    handle: "",
    minH: 1,
    minW: 1,
    maxH: Infinity,
    maxW: Infinity,
    transformScale: 1
});

});
parcelRegister("aqFpf", function(module, exports) {
"use strict";

var $7DFIl = parcelRequire("7DFIl");
var $797c73818734b3a8$var$Draggable = $7DFIl.default, $797c73818734b3a8$var$DraggableCore = $7DFIl.DraggableCore; // Previous versions of this lib exported <Draggable> as the root export. As to no-// them, or TypeScript, we export *both* as the root and as 'default'.
// See https://github.com/mzabriskie/react-draggable/pull/254
// and https://github.com/mzabriskie/react-draggable/issues/266
module.exports = $797c73818734b3a8$var$Draggable;
module.exports.default = $797c73818734b3a8$var$Draggable;
module.exports.DraggableCore = $797c73818734b3a8$var$DraggableCore;

});
parcelRegister("7DFIl", function(module, exports) {
"use strict";
function $58fc887fb1797a01$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $58fc887fb1797a01$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $58fc887fb1797a01$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $58fc887fb1797a01$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "DraggableCore", {
    enumerable: true,
    get: function get() {
        return $58fc887fb1797a01$var$_DraggableCore.default;
    }
});
module.exports.default = void 0;

var $58fc887fb1797a01$var$React = $58fc887fb1797a01$var$_interopRequireWildcard((parcelRequire("NdCUR")));

var $58fc887fb1797a01$var$_propTypes = $58fc887fb1797a01$var$_interopRequireDefault((parcelRequire("fGw9V")));

var $58fc887fb1797a01$var$_reactDom = $58fc887fb1797a01$var$_interopRequireDefault((parcelRequire("g2wso")));

var $58fc887fb1797a01$var$_clsx2 = $58fc887fb1797a01$var$_interopRequireDefault((parcelRequire("lbxdO")));

var $3qhhR = parcelRequire("3qhhR");

var $jKNSJ = parcelRequire("jKNSJ");

var $ghOl8 = parcelRequire("ghOl8");

var $58fc887fb1797a01$var$_DraggableCore = $58fc887fb1797a01$var$_interopRequireDefault((parcelRequire("5k5bv")));

var $58fc887fb1797a01$var$_log = $58fc887fb1797a01$var$_interopRequireDefault((parcelRequire("djv9A")));
var $58fc887fb1797a01$var$_excluded = [
    "axis",
    "bounds",
    "children",
    "defaultPosition",
    "defaultClassName",
    "defaultClassNameDragging",
    "defaultClassNameDragged",
    "position",
    "positionOffset",
    "scale"
];
function $58fc887fb1797a01$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $58fc887fb1797a01$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($58fc887fb1797a01$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $58fc887fb1797a01$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $58fc887fb1797a01$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $58fc887fb1797a01$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $58fc887fb1797a01$var$_extends() {
    $58fc887fb1797a01$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $58fc887fb1797a01$var$_extends.apply(this, arguments);
}
function $58fc887fb1797a01$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $58fc887fb1797a01$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $58fc887fb1797a01$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $58fc887fb1797a01$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $58fc887fb1797a01$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $58fc887fb1797a01$var$ownKeys(Object(source), true).forEach(function(key) {
            $58fc887fb1797a01$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $58fc887fb1797a01$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $58fc887fb1797a01$var$_slicedToArray(arr, i) {
    return $58fc887fb1797a01$var$_arrayWithHoles(arr) || $58fc887fb1797a01$var$_iterableToArrayLimit(arr, i) || $58fc887fb1797a01$var$_unsupportedIterableToArray(arr, i) || $58fc887fb1797a01$var$_nonIterableRest();
}
function $58fc887fb1797a01$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $58fc887fb1797a01$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $58fc887fb1797a01$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $58fc887fb1797a01$var$_arrayLikeToArray(o, minLen);
}
function $58fc887fb1797a01$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $58fc887fb1797a01$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $58fc887fb1797a01$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $58fc887fb1797a01$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $58fc887fb1797a01$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $58fc887fb1797a01$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $58fc887fb1797a01$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $58fc887fb1797a01$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $58fc887fb1797a01$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $58fc887fb1797a01$var$_setPrototypeOf(subClass, superClass);
}
function $58fc887fb1797a01$var$_setPrototypeOf(o, p) {
    $58fc887fb1797a01$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $58fc887fb1797a01$var$_setPrototypeOf(o, p);
}
function $58fc887fb1797a01$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $58fc887fb1797a01$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $58fc887fb1797a01$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $58fc887fb1797a01$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $58fc887fb1797a01$var$_possibleConstructorReturn(this, result);
    };
}
function $58fc887fb1797a01$var$_possibleConstructorReturn(self, call) {
    if (call && ($58fc887fb1797a01$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $58fc887fb1797a01$var$_assertThisInitialized(self);
}
function $58fc887fb1797a01$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $58fc887fb1797a01$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $58fc887fb1797a01$var$_getPrototypeOf(o) {
    $58fc887fb1797a01$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $58fc887fb1797a01$var$_getPrototypeOf(o);
}
function $58fc887fb1797a01$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
//
// Define <Draggable>
//
var $58fc887fb1797a01$var$Draggable = /*#__PURE__*/ function(_React$Component) {
    $58fc887fb1797a01$var$_inherits(Draggable, _React$Component);
    var _super = $58fc887fb1797a01$var$_createSuper(Draggable);
    function Draggable(props) {
        var _this;
        $58fc887fb1797a01$var$_classCallCheck(this, Draggable);
        _this = _super.call(this, props);
        $58fc887fb1797a01$var$_defineProperty($58fc887fb1797a01$var$_assertThisInitialized(_this), "onDragStart", function(e, coreData) {
            (0, $58fc887fb1797a01$var$_log.default)('Draggable: onDragStart: %j', coreData); // Short-circuit if user's callback killed it.
            var shouldStart = _this.props.onStart(e, (0, $jKNSJ.createDraggableData)($58fc887fb1797a01$var$_assertThisInitialized(_this), coreData)); // Kills start event on core as well, so move handlers are never bound.
            if (shouldStart === false) return false;
            _this.setState({
                dragging: true,
                dragged: true
            });
        });
        $58fc887fb1797a01$var$_defineProperty($58fc887fb1797a01$var$_assertThisInitialized(_this), "onDrag", function(e, coreData) {
            if (!_this.state.dragging) return false;
            (0, $58fc887fb1797a01$var$_log.default)('Draggable: onDrag: %j', coreData);
            var uiData = (0, $jKNSJ.createDraggableData)($58fc887fb1797a01$var$_assertThisInitialized(_this), coreData);
            var newState = {
                x: uiData.x,
                y: uiData.y
            }; // Keep within bounds.
            if (_this.props.bounds) {
                // Save original x and y.
                var x = newState.x, y = newState.y; // Add slack to the values used to calculate bound position. This will ensure that if
                // we start removing slack, the element won't react to it right away until it's been
                // completely removed.
                newState.x += _this.state.slackX;
                newState.y += _this.state.slackY; // Get bound position. This will ceil/floor the x and y within the boundaries.
                var _getBoundPosition = (0, $jKNSJ.getBoundPosition)($58fc887fb1797a01$var$_assertThisInitialized(_this), newState.x, newState.y), _getBoundPosition2 = $58fc887fb1797a01$var$_slicedToArray(_getBoundPosition, 2), newStateX = _getBoundPosition2[0], newStateY = _getBoundPosition2[1];
                newState.x = newStateX;
                newState.y = newStateY; // Recalculate slack by noting how much was shaved by the boundPosition handler.
                newState.slackX = _this.state.slackX + (x - newState.x);
                newState.slackY = _this.state.slackY + (y - newState.y); // Update the event we fire to reflect what really happened after bounds took effect.
                uiData.x = newState.x;
                uiData.y = newState.y;
                uiData.deltaX = newState.x - _this.state.x;
                uiData.deltaY = newState.y - _this.state.y;
            } // Short-circuit if user's callback killed it.
            var shouldUpdate = _this.props.onDrag(e, uiData);
            if (shouldUpdate === false) return false;
            _this.setState(newState);
        });
        $58fc887fb1797a01$var$_defineProperty($58fc887fb1797a01$var$_assertThisInitialized(_this), "onDragStop", function(e, coreData) {
            if (!_this.state.dragging) return false; // Short-circuit if user's callback killed it.
            var shouldContinue = _this.props.onStop(e, (0, $jKNSJ.createDraggableData)($58fc887fb1797a01$var$_assertThisInitialized(_this), coreData));
            if (shouldContinue === false) return false;
            (0, $58fc887fb1797a01$var$_log.default)('Draggable: onDragStop: %j', coreData);
            var newState = {
                dragging: false,
                slackX: 0,
                slackY: 0
            }; // If this is a controlled component, the result of this operation will be to
            // revert back to the old position. We expect a handler on `onDragStop`, at the least.
            var controlled = Boolean(_this.props.position);
            if (controlled) {
                var _this$props$position = _this.props.position, x = _this$props$position.x, y = _this$props$position.y;
                newState.x = x;
                newState.y = y;
            }
            _this.setState(newState);
        });
        _this.state = {
            // Whether or not we are currently dragging.
            dragging: false,
            // Whether or not we have been dragged before.
            dragged: false,
            // Current transform x and y.
            x: props.position ? props.position.x : props.defaultPosition.x,
            y: props.position ? props.position.y : props.defaultPosition.y,
            prevPropsPosition: $58fc887fb1797a01$var$_objectSpread({}, props.position),
            // Used for compensating for out-of-bounds drags
            slackX: 0,
            slackY: 0,
            // Can only determine if SVG after mounting
            isElementSVG: false
        };
        if (props.position && !(props.onDrag || props.onStop)) // eslint-disable-next-line no-console
        console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element.");
        return _this;
    }
    $58fc887fb1797a01$var$_createClass(Draggable, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                // Check to see if the element passed is an instanceof SVGElement
                if (typeof window.SVGElement !== 'undefined' && this.findDOMNode() instanceof window.SVGElement) this.setState({
                    isElementSVG: true
                });
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.setState({
                    dragging: false
                }); // prevents invariant if unmounted while dragging
            } // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
        },
        {
            key: "findDOMNode",
            value: function findDOMNode() /*: ?HTMLElement*/ {
                var _this$props$nodeRef$c, _this$props, _this$props$nodeRef;
                return (_this$props$nodeRef$c = (_this$props = this.props) === null || _this$props === void 0 ? void 0 : (_this$props$nodeRef = _this$props.nodeRef) === null || _this$props$nodeRef === void 0 ? void 0 : _this$props$nodeRef.current) !== null && _this$props$nodeRef$c !== void 0 ? _this$props$nodeRef$c : $58fc887fb1797a01$var$_reactDom.default.findDOMNode(this);
            }
        },
        {
            key: "render",
            value: function render() /*: ReactElement<any>*/ {
                var _clsx;
                var _this$props2 = this.props, axis = _this$props2.axis, bounds = _this$props2.bounds, children = _this$props2.children, defaultPosition = _this$props2.defaultPosition, defaultClassName = _this$props2.defaultClassName, defaultClassNameDragging = _this$props2.defaultClassNameDragging, defaultClassNameDragged = _this$props2.defaultClassNameDragged, position = _this$props2.position, positionOffset = _this$props2.positionOffset, scale = _this$props2.scale, draggableCoreProps = $58fc887fb1797a01$var$_objectWithoutProperties(_this$props2, $58fc887fb1797a01$var$_excluded);
                var style = {};
                var svgTransform = null; // If this is controlled, we don't want to move it - unless it's dragging.
                var controlled = Boolean(position);
                var draggable = !controlled || this.state.dragging;
                var validPosition = position || defaultPosition;
                var transformOpts = {
                    // Set left if horizontal drag is enabled
                    x: (0, $jKNSJ.canDragX)(this) && draggable ? this.state.x : validPosition.x,
                    // Set top if vertical drag is enabled
                    y: (0, $jKNSJ.canDragY)(this) && draggable ? this.state.y : validPosition.y
                }; // If this element was SVG, we use the `transform` attribute.
                if (this.state.isElementSVG) svgTransform = (0, $3qhhR.createSVGTransform)(transformOpts, positionOffset);
                else // Add a CSS transform to move the element around. This allows us to move the element around
                // without worrying about whether or not it is relatively or absolutely positioned.
                // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
                // has a clean slate.
                style = (0, $3qhhR.createCSSTransform)(transformOpts, positionOffset);
                 // Mark with class while dragging
                var className = (0, $58fc887fb1797a01$var$_clsx2.default)(children.props.className || '', defaultClassName, (_clsx = {}, $58fc887fb1797a01$var$_defineProperty(_clsx, defaultClassNameDragging, this.state.dragging), $58fc887fb1797a01$var$_defineProperty(_clsx, defaultClassNameDragged, this.state.dragged), _clsx)); // Reuse the child provided
                // This makes it flexible to use whatever element is wanted (div, ul, etc)
                return /*#__PURE__*/ $58fc887fb1797a01$var$React.createElement($58fc887fb1797a01$var$_DraggableCore.default, $58fc887fb1797a01$var$_extends({}, draggableCoreProps, {
                    onStart: this.onDragStart,
                    onDrag: this.onDrag,
                    onStop: this.onDragStop
                }), /*#__PURE__*/ $58fc887fb1797a01$var$React.cloneElement($58fc887fb1797a01$var$React.Children.only(children), {
                    className: className,
                    style: $58fc887fb1797a01$var$_objectSpread($58fc887fb1797a01$var$_objectSpread({}, children.props.style), style),
                    transform: svgTransform
                }));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: // Arity (props, state)
            function getDerivedStateFromProps(_ref, _ref2) /*: ?$Shape<DraggableState>*/ {
                var position = _ref.position;
                var prevPropsPosition = _ref2.prevPropsPosition;
                // Set x/y if a new position is provided in props that is different than the previous.
                if (position && (!prevPropsPosition || position.x !== prevPropsPosition.x || position.y !== prevPropsPosition.y)) {
                    (0, $58fc887fb1797a01$var$_log.default)('Draggable: getDerivedStateFromProps %j', {
                        position: position,
                        prevPropsPosition: prevPropsPosition
                    });
                    return {
                        x: position.x,
                        y: position.y,
                        prevPropsPosition: $58fc887fb1797a01$var$_objectSpread({}, position)
                    };
                }
                return null;
            }
        }
    ]);
    return Draggable;
}($58fc887fb1797a01$var$React.Component);
module.exports.default = $58fc887fb1797a01$var$Draggable;
$58fc887fb1797a01$var$_defineProperty($58fc887fb1797a01$var$Draggable, "displayName", 'Draggable');
$58fc887fb1797a01$var$_defineProperty($58fc887fb1797a01$var$Draggable, "propTypes", $58fc887fb1797a01$var$_objectSpread($58fc887fb1797a01$var$_objectSpread({}, $58fc887fb1797a01$var$_DraggableCore.default.propTypes), {}, {
    /**
   * `axis` determines which axis the draggable can move.
   *
   *  Note that all callbacks will still return data as normal. This only
   *  controls flushing to the DOM.
   *
   * 'both' allows movement horizontally and vertically.
   * 'x' limits movement to horizontal axis.
   * 'y' limits movement to vertical axis.
   * 'none' limits all movement.
   *
   * Defaults to 'both'.
   */ axis: $58fc887fb1797a01$var$_propTypes.default.oneOf([
        'both',
        'x',
        'y',
        'none'
    ]),
    /**
   * `bounds` determines the range of movement available to the element.
   * Available values are:
   *
   * 'parent' restricts movement within the Draggable's parent node.
   *
   * Alternatively, pass an object with the following properties, all of which are optional:
   *
   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
   *
   * All values are in px.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable bounds={{right: 300, bottom: 300}}>
   *              <div>Content</div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ bounds: $58fc887fb1797a01$var$_propTypes.default.oneOfType([
        $58fc887fb1797a01$var$_propTypes.default.shape({
            left: $58fc887fb1797a01$var$_propTypes.default.number,
            right: $58fc887fb1797a01$var$_propTypes.default.number,
            top: $58fc887fb1797a01$var$_propTypes.default.number,
            bottom: $58fc887fb1797a01$var$_propTypes.default.number
        }),
        $58fc887fb1797a01$var$_propTypes.default.string,
        $58fc887fb1797a01$var$_propTypes.default.oneOf([
            false
        ])
    ]),
    defaultClassName: $58fc887fb1797a01$var$_propTypes.default.string,
    defaultClassNameDragging: $58fc887fb1797a01$var$_propTypes.default.string,
    defaultClassNameDragged: $58fc887fb1797a01$var$_propTypes.default.string,
    /**
   * `defaultPosition` specifies the x and y that the dragged item should start at
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ defaultPosition: $58fc887fb1797a01$var$_propTypes.default.shape({
        x: $58fc887fb1797a01$var$_propTypes.default.number,
        y: $58fc887fb1797a01$var$_propTypes.default.number
    }),
    positionOffset: $58fc887fb1797a01$var$_propTypes.default.shape({
        x: $58fc887fb1797a01$var$_propTypes.default.oneOfType([
            $58fc887fb1797a01$var$_propTypes.default.number,
            $58fc887fb1797a01$var$_propTypes.default.string
        ]),
        y: $58fc887fb1797a01$var$_propTypes.default.oneOfType([
            $58fc887fb1797a01$var$_propTypes.default.number,
            $58fc887fb1797a01$var$_propTypes.default.string
        ])
    }),
    /**
   * `position`, if present, defines the current position of the element.
   *
   *  This is similar to how form elements in React work - if no `position` is supplied, the component
   *  is uncontrolled.
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable position={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ position: $58fc887fb1797a01$var$_propTypes.default.shape({
        x: $58fc887fb1797a01$var$_propTypes.default.number,
        y: $58fc887fb1797a01$var$_propTypes.default.number
    }),
    /**
   * These properties should be defined on the child, not here.
   */ className: $ghOl8.dontSetMe,
    style: $ghOl8.dontSetMe,
    transform: $ghOl8.dontSetMe
}));
$58fc887fb1797a01$var$_defineProperty($58fc887fb1797a01$var$Draggable, "defaultProps", $58fc887fb1797a01$var$_objectSpread($58fc887fb1797a01$var$_objectSpread({}, $58fc887fb1797a01$var$_DraggableCore.default.defaultProps), {}, {
    axis: 'both',
    bounds: false,
    defaultClassName: 'react-draggable',
    defaultClassNameDragging: 'react-draggable-dragging',
    defaultClassNameDragged: 'react-draggable-dragged',
    defaultPosition: {
        x: 0,
        y: 0
    },
    scale: 1
}));

});
parcelRegister("lbxdO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $f6c4653a369dd092$export$2e2bcd8739ae039; });
function $f6c4653a369dd092$var$toVal(mix) {
    var k, y, str = '';
    if (typeof mix === 'string' || typeof mix === 'number') str += mix;
    else if (typeof mix === 'object') {
        if (Array.isArray(mix)) for(k = 0; k < mix.length; k++){
            if (mix[k]) {
                if (y = $f6c4653a369dd092$var$toVal(mix[k])) {
                    str && (str += ' ');
                    str += y;
                }
            }
        }
        else {
            for(k in mix)if (mix[k]) {
                str && (str += ' ');
                str += k;
            }
        }
    }
    return str;
}
function $f6c4653a369dd092$export$2e2bcd8739ae039() {
    var i = 0, tmp, x, str = '';
    while(i < arguments.length){
        if (tmp = arguments[i++]) {
            if (x = $f6c4653a369dd092$var$toVal(tmp)) {
                str && (str += ' ');
                str += x;
            }
        }
    }
    return str;
}

});

parcelRegister("3qhhR", function(module, exports) {
"use strict";
function $27e135aab8a7d352$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $27e135aab8a7d352$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $27e135aab8a7d352$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $27e135aab8a7d352$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.matchesSelector = $27e135aab8a7d352$var$matchesSelector;
module.exports.matchesSelectorAndParentsTo = $27e135aab8a7d352$var$matchesSelectorAndParentsTo;
module.exports.addEvent = $27e135aab8a7d352$var$addEvent;
module.exports.removeEvent = $27e135aab8a7d352$var$removeEvent;
module.exports.outerHeight = $27e135aab8a7d352$var$outerHeight;
module.exports.outerWidth = $27e135aab8a7d352$var$outerWidth;
module.exports.innerHeight = $27e135aab8a7d352$var$innerHeight;
module.exports.innerWidth = $27e135aab8a7d352$var$innerWidth;
module.exports.offsetXYFromParent = $27e135aab8a7d352$var$offsetXYFromParent;
module.exports.createCSSTransform = $27e135aab8a7d352$var$createCSSTransform;
module.exports.createSVGTransform = $27e135aab8a7d352$var$createSVGTransform;
module.exports.getTranslation = $27e135aab8a7d352$var$getTranslation;
module.exports.getTouch = $27e135aab8a7d352$var$getTouch;
module.exports.getTouchIdentifier = $27e135aab8a7d352$var$getTouchIdentifier;
module.exports.addUserSelectStyles = $27e135aab8a7d352$var$addUserSelectStyles;
module.exports.removeUserSelectStyles = $27e135aab8a7d352$var$removeUserSelectStyles;
module.exports.addClassName = $27e135aab8a7d352$var$addClassName;
module.exports.removeClassName = $27e135aab8a7d352$var$removeClassName;

var $ghOl8 = parcelRequire("ghOl8");

var $27e135aab8a7d352$var$_getPrefix = $27e135aab8a7d352$var$_interopRequireWildcard((parcelRequire("bCzdy")));
function $27e135aab8a7d352$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($27e135aab8a7d352$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $27e135aab8a7d352$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $27e135aab8a7d352$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $27e135aab8a7d352$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $27e135aab8a7d352$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $27e135aab8a7d352$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $27e135aab8a7d352$var$ownKeys(Object(source), true).forEach(function(key) {
            $27e135aab8a7d352$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $27e135aab8a7d352$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $27e135aab8a7d352$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $27e135aab8a7d352$var$matchesSelectorFunc = '';
function $27e135aab8a7d352$var$matchesSelector(el, selector) /*: boolean*/ {
    if (!$27e135aab8a7d352$var$matchesSelectorFunc) $27e135aab8a7d352$var$matchesSelectorFunc = (0, $ghOl8.findInArray)([
        'matches',
        'webkitMatchesSelector',
        'mozMatchesSelector',
        'msMatchesSelector',
        'oMatchesSelector'
    ], function(method) {
        // $FlowIgnore: Doesn't think elements are indexable
        return (0, $ghOl8.isFunction)(el[method]);
    });
     // Might not be found entirely (not an Element?) - in that case, bail
    // $FlowIgnore: Doesn't think elements are indexable
    if (!(0, $ghOl8.isFunction)(el[$27e135aab8a7d352$var$matchesSelectorFunc])) return false; // $FlowIgnore: Doesn't think elements are indexable
    return el[$27e135aab8a7d352$var$matchesSelectorFunc](selector);
} // Works up the tree to the draggable itself attempting to match selector.
function $27e135aab8a7d352$var$matchesSelectorAndParentsTo(el, selector, baseNode) /*: boolean*/ {
    var node = el;
    do {
        if ($27e135aab8a7d352$var$matchesSelector(node, selector)) return true;
        if (node === baseNode) return false;
        node = node.parentNode;
    }while (node);
    return false;
}
function $27e135aab8a7d352$var$addEvent(el, event, handler, inputOptions) /*: void*/ {
    if (!el) return;
    var options = $27e135aab8a7d352$var$_objectSpread({
        capture: true
    }, inputOptions); // $FlowIgnore[method-unbinding]
    if (el.addEventListener) el.addEventListener(event, handler, options);
    else if (el.attachEvent) el.attachEvent('on' + event, handler);
    else // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = handler;
}
function $27e135aab8a7d352$var$removeEvent(el, event, handler, inputOptions) /*: void*/ {
    if (!el) return;
    var options = $27e135aab8a7d352$var$_objectSpread({
        capture: true
    }, inputOptions); // $FlowIgnore[method-unbinding]
    if (el.removeEventListener) el.removeEventListener(event, handler, options);
    else if (el.detachEvent) el.detachEvent('on' + event, handler);
    else // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = null;
}
function $27e135aab8a7d352$var$outerHeight(node) /*: number*/ {
    // This is deliberately excluding margin for our calculations, since we are using
    // offsetTop which is including margin. See getBoundPosition
    var height = node.clientHeight;
    var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height += (0, $ghOl8.int)(computedStyle.borderTopWidth);
    height += (0, $ghOl8.int)(computedStyle.borderBottomWidth);
    return height;
}
function $27e135aab8a7d352$var$outerWidth(node) /*: number*/ {
    // This is deliberately excluding margin for our calculations, since we are using
    // offsetLeft which is including margin. See getBoundPosition
    var width = node.clientWidth;
    var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width += (0, $ghOl8.int)(computedStyle.borderLeftWidth);
    width += (0, $ghOl8.int)(computedStyle.borderRightWidth);
    return width;
}
function $27e135aab8a7d352$var$innerHeight(node) /*: number*/ {
    var height = node.clientHeight;
    var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height -= (0, $ghOl8.int)(computedStyle.paddingTop);
    height -= (0, $ghOl8.int)(computedStyle.paddingBottom);
    return height;
}
function $27e135aab8a7d352$var$innerWidth(node) /*: number*/ {
    var width = node.clientWidth;
    var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width -= (0, $ghOl8.int)(computedStyle.paddingLeft);
    width -= (0, $ghOl8.int)(computedStyle.paddingRight);
    return width;
}
/*:: interface EventWithOffset {
  clientX: number, clientY: number
}*/ // Get from offsetParent
function $27e135aab8a7d352$var$offsetXYFromParent(evt, offsetParent, scale) /*: ControlPosition*/ {
    var isBody = offsetParent === offsetParent.ownerDocument.body;
    var offsetParentRect = isBody ? {
        left: 0,
        top: 0
    } : offsetParent.getBoundingClientRect();
    var x = (evt.clientX + offsetParent.scrollLeft - offsetParentRect.left) / scale;
    var y = (evt.clientY + offsetParent.scrollTop - offsetParentRect.top) / scale;
    return {
        x: x,
        y: y
    };
}
function $27e135aab8a7d352$var$createCSSTransform(controlPos, positionOffset) /*: Object*/ {
    var translation = $27e135aab8a7d352$var$getTranslation(controlPos, positionOffset, 'px');
    return $27e135aab8a7d352$var$_defineProperty({}, (0, $27e135aab8a7d352$var$_getPrefix.browserPrefixToKey)('transform', $27e135aab8a7d352$var$_getPrefix.default), translation);
}
function $27e135aab8a7d352$var$createSVGTransform(controlPos, positionOffset) /*: string*/ {
    var translation = $27e135aab8a7d352$var$getTranslation(controlPos, positionOffset, '');
    return translation;
}
function $27e135aab8a7d352$var$getTranslation(_ref2, positionOffset, unitSuffix) /*: string*/ {
    var x = _ref2.x, y = _ref2.y;
    var translation = "translate(".concat(x).concat(unitSuffix, ",").concat(y).concat(unitSuffix, ")");
    if (positionOffset) {
        var defaultX = "".concat(typeof positionOffset.x === 'string' ? positionOffset.x : positionOffset.x + unitSuffix);
        var defaultY = "".concat(typeof positionOffset.y === 'string' ? positionOffset.y : positionOffset.y + unitSuffix);
        translation = "translate(".concat(defaultX, ", ").concat(defaultY, ")") + translation;
    }
    return translation;
}
function $27e135aab8a7d352$var$getTouch(e, identifier) /*: ?{clientX: number, clientY: number}*/ {
    return e.targetTouches && (0, $ghOl8.findInArray)(e.targetTouches, function(t) {
        return identifier === t.identifier;
    }) || e.changedTouches && (0, $ghOl8.findInArray)(e.changedTouches, function(t) {
        return identifier === t.identifier;
    });
}
function $27e135aab8a7d352$var$getTouchIdentifier(e) /*: ?number*/ {
    if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
    if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
} // User-select Hacks:
//
// Useful for preventing blue highlights all over everything when dragging.
// Note we're passing `document` b/c we could be iframed
function $27e135aab8a7d352$var$addUserSelectStyles(doc) {
    if (!doc) return;
    var styleEl = doc.getElementById('react-draggable-style-el');
    if (!styleEl) {
        styleEl = doc.createElement('style');
        styleEl.type = 'text/css';
        styleEl.id = 'react-draggable-style-el';
        styleEl.innerHTML = '.react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n';
        styleEl.innerHTML += '.react-draggable-transparent-selection *::selection {all: inherit;}\n';
        doc.getElementsByTagName('head')[0].appendChild(styleEl);
    }
    if (doc.body) $27e135aab8a7d352$var$addClassName(doc.body, 'react-draggable-transparent-selection');
}
function $27e135aab8a7d352$var$removeUserSelectStyles(doc) {
    if (!doc) return;
    try {
        if (doc.body) $27e135aab8a7d352$var$removeClassName(doc.body, 'react-draggable-transparent-selection'); // $FlowIgnore: IE
        if (doc.selection) // $FlowIgnore: IE
        doc.selection.empty();
        else {
            // Remove selection caused by scroll, unless it's a focused input
            // (we use doc.defaultView in case we're in an iframe)
            var selection = (doc.defaultView || window).getSelection();
            if (selection && selection.type !== 'Caret') selection.removeAllRanges();
        }
    } catch (e) {}
}
function $27e135aab8a7d352$var$addClassName(el, className) {
    if (el.classList) el.classList.add(className);
    else if (!el.className.match(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)")))) el.className += " ".concat(className);
}
function $27e135aab8a7d352$var$removeClassName(el, className) {
    if (el.classList) el.classList.remove(className);
    else el.className = el.className.replace(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)"), 'g'), '');
}

});
parcelRegister("ghOl8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findInArray = $bdb548542e852710$var$findInArray;
module.exports.isFunction = $bdb548542e852710$var$isFunction;
module.exports.isNum = $bdb548542e852710$var$isNum;
module.exports.int = $bdb548542e852710$var$int;
module.exports.dontSetMe = $bdb548542e852710$var$dontSetMe;
// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
function $bdb548542e852710$var$findInArray(array, callback) /*: any*/ {
    for(var i = 0, length = array.length; i < length; i++){
        if (callback.apply(callback, [
            array[i],
            i,
            array
        ])) return array[i];
    }
}
function $bdb548542e852710$var$isFunction(func) /*: boolean %checks*/ {
    // $FlowIgnore[method-unbinding]
    return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]';
}
function $bdb548542e852710$var$isNum(num) /*: boolean %checks*/ {
    return typeof num === 'number' && !isNaN(num);
}
function $bdb548542e852710$var$int(a) /*: number*/ {
    return parseInt(a, 10);
}
function $bdb548542e852710$var$dontSetMe(props, propName, componentName) /*: ?Error*/ {
    if (props[propName]) return new Error("Invalid prop ".concat(propName, " passed to ").concat(componentName, " - do not set this, set it on the child."));
}

});

parcelRegister("bCzdy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPrefix = $875e8fd0ab714433$var$getPrefix;
module.exports.browserPrefixToKey = $875e8fd0ab714433$var$browserPrefixToKey;
module.exports.browserPrefixToStyle = $875e8fd0ab714433$var$browserPrefixToStyle;
module.exports.default = void 0;
var $875e8fd0ab714433$var$prefixes = [
    'Moz',
    'Webkit',
    'O',
    'ms'
];
function $875e8fd0ab714433$var$getPrefix() /*: string*/ {
    var _window$document, _window$document$docu;
    var prop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';
    // Ensure we're running in an environment where there is actually a global
    // `window` obj
    if (typeof window === 'undefined') return ''; // If we're in a pseudo-browser server-side environment, this access
    // path may not exist, so bail out if it doesn't.
    var style = (_window$document = window.document) === null || _window$document === void 0 ? void 0 : (_window$document$docu = _window$document.documentElement) === null || _window$document$docu === void 0 ? void 0 : _window$document$docu.style;
    if (!style) return '';
    if (prop in style) return '';
    for(var i = 0; i < $875e8fd0ab714433$var$prefixes.length; i++){
        if ($875e8fd0ab714433$var$browserPrefixToKey(prop, $875e8fd0ab714433$var$prefixes[i]) in style) return $875e8fd0ab714433$var$prefixes[i];
    }
    return '';
}
function $875e8fd0ab714433$var$browserPrefixToKey(prop, prefix) /*: string*/ {
    return prefix ? "".concat(prefix).concat($875e8fd0ab714433$var$kebabToTitleCase(prop)) : prop;
}
function $875e8fd0ab714433$var$browserPrefixToStyle(prop, prefix) /*: string*/ {
    return prefix ? "-".concat(prefix.toLowerCase(), "-").concat(prop) : prop;
}
function $875e8fd0ab714433$var$kebabToTitleCase(str) /*: string*/ {
    var out = '';
    var shouldCapitalize = true;
    for(var i = 0; i < str.length; i++){
        if (shouldCapitalize) {
            out += str[i].toUpperCase();
            shouldCapitalize = false;
        } else if (str[i] === '-') shouldCapitalize = true;
        else out += str[i];
    }
    return out;
} // Default export is the prefix itself, like 'Moz', 'Webkit', etc
// Note that you may have to re-test for certain things; for instance, Chrome 50
// can handle unprefixed `transform`, but not unprefixed `user-select`
var $875e8fd0ab714433$var$_default = $875e8fd0ab714433$var$getPrefix();
module.exports.default = $875e8fd0ab714433$var$_default;

});


parcelRegister("jKNSJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getBoundPosition = $e61901a7d91eee95$var$getBoundPosition;
module.exports.snapToGrid = $e61901a7d91eee95$var$snapToGrid;
module.exports.canDragX = $e61901a7d91eee95$var$canDragX;
module.exports.canDragY = $e61901a7d91eee95$var$canDragY;
module.exports.getControlPosition = $e61901a7d91eee95$var$getControlPosition;
module.exports.createCoreData = $e61901a7d91eee95$var$createCoreData;
module.exports.createDraggableData = $e61901a7d91eee95$var$createDraggableData;

var $ghOl8 = parcelRequire("ghOl8");

var $3qhhR = parcelRequire("3qhhR");
function $e61901a7d91eee95$var$getBoundPosition(draggable, x, y) /*: [number, number]*/ {
    // If no bounds, short-circuit and move on
    if (!draggable.props.bounds) return [
        x,
        y
    ]; // Clone new bounds
    var bounds = draggable.props.bounds;
    bounds = typeof bounds === 'string' ? bounds : $e61901a7d91eee95$var$cloneBounds(bounds);
    var node = $e61901a7d91eee95$var$findDOMNode(draggable);
    if (typeof bounds === 'string') {
        var ownerDocument = node.ownerDocument;
        var ownerWindow = ownerDocument.defaultView;
        var boundNode;
        if (bounds === 'parent') boundNode = node.parentNode;
        else boundNode = ownerDocument.querySelector(bounds);
        if (!(boundNode instanceof ownerWindow.HTMLElement)) throw new Error('Bounds selector "' + bounds + '" could not find an element.');
        var boundNodeEl = boundNode; // for Flow, can't seem to refine correctly
        var nodeStyle = ownerWindow.getComputedStyle(node);
        var boundNodeStyle = ownerWindow.getComputedStyle(boundNodeEl); // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.
        bounds = {
            left: -node.offsetLeft + (0, $ghOl8.int)(boundNodeStyle.paddingLeft) + (0, $ghOl8.int)(nodeStyle.marginLeft),
            top: -node.offsetTop + (0, $ghOl8.int)(boundNodeStyle.paddingTop) + (0, $ghOl8.int)(nodeStyle.marginTop),
            right: (0, $3qhhR.innerWidth)(boundNodeEl) - (0, $3qhhR.outerWidth)(node) - node.offsetLeft + (0, $ghOl8.int)(boundNodeStyle.paddingRight) - (0, $ghOl8.int)(nodeStyle.marginRight),
            bottom: (0, $3qhhR.innerHeight)(boundNodeEl) - (0, $3qhhR.outerHeight)(node) - node.offsetTop + (0, $ghOl8.int)(boundNodeStyle.paddingBottom) - (0, $ghOl8.int)(nodeStyle.marginBottom)
        };
    } // Keep x and y below right and bottom limits...
    if ((0, $ghOl8.isNum)(bounds.right)) x = Math.min(x, bounds.right);
    if ((0, $ghOl8.isNum)(bounds.bottom)) y = Math.min(y, bounds.bottom); // But above left and top limits.
    if ((0, $ghOl8.isNum)(bounds.left)) x = Math.max(x, bounds.left);
    if ((0, $ghOl8.isNum)(bounds.top)) y = Math.max(y, bounds.top);
    return [
        x,
        y
    ];
}
function $e61901a7d91eee95$var$snapToGrid(grid, pendingX, pendingY) /*: [number, number]*/ {
    var x = Math.round(pendingX / grid[0]) * grid[0];
    var y = Math.round(pendingY / grid[1]) * grid[1];
    return [
        x,
        y
    ];
}
function $e61901a7d91eee95$var$canDragX(draggable) /*: boolean*/ {
    return draggable.props.axis === 'both' || draggable.props.axis === 'x';
}
function $e61901a7d91eee95$var$canDragY(draggable) /*: boolean*/ {
    return draggable.props.axis === 'both' || draggable.props.axis === 'y';
} // Get {x, y} positions from event.
function $e61901a7d91eee95$var$getControlPosition(e, touchIdentifier, draggableCore) /*: ?ControlPosition*/ {
    var touchObj = typeof touchIdentifier === 'number' ? (0, $3qhhR.getTouch)(e, touchIdentifier) : null;
    if (typeof touchIdentifier === 'number' && !touchObj) return null; // not the right touch
    var node = $e61901a7d91eee95$var$findDOMNode(draggableCore); // User can provide an offsetParent if desired.
    var offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
    return (0, $3qhhR.offsetXYFromParent)(touchObj || e, offsetParent, draggableCore.props.scale);
} // Create an data object exposed by <DraggableCore>'s events
function $e61901a7d91eee95$var$createCoreData(draggable, x, y) /*: DraggableData*/ {
    var state = draggable.state;
    var isStart = !(0, $ghOl8.isNum)(state.lastX);
    var node = $e61901a7d91eee95$var$findDOMNode(draggable);
    if (isStart) // If this is our first move, use the x and y as last coords.
    return {
        node: node,
        deltaX: 0,
        deltaY: 0,
        lastX: x,
        lastY: y,
        x: x,
        y: y
    };
    else // Otherwise calculate proper values.
    return {
        node: node,
        deltaX: x - state.lastX,
        deltaY: y - state.lastY,
        lastX: state.lastX,
        lastY: state.lastY,
        x: x,
        y: y
    };
} // Create an data exposed by <Draggable>'s events
function $e61901a7d91eee95$var$createDraggableData(draggable, coreData) /*: DraggableData*/ {
    var scale = draggable.props.scale;
    return {
        node: coreData.node,
        x: draggable.state.x + coreData.deltaX / scale,
        y: draggable.state.y + coreData.deltaY / scale,
        deltaX: coreData.deltaX / scale,
        deltaY: coreData.deltaY / scale,
        lastX: draggable.state.x,
        lastY: draggable.state.y
    };
} // A lot faster than stringify/parse
function $e61901a7d91eee95$var$cloneBounds(bounds) /*: Bounds*/ {
    return {
        left: bounds.left,
        top: bounds.top,
        right: bounds.right,
        bottom: bounds.bottom
    };
}
function $e61901a7d91eee95$var$findDOMNode(draggable) /*: HTMLElement*/ {
    var node = draggable.findDOMNode();
    if (!node) throw new Error('<DraggableCore>: Unmounted during event!');
     // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME
    return node;
}

});

parcelRegister("5k5bv", function(module, exports) {
"use strict";
function $3e02d78f2f421b00$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $3e02d78f2f421b00$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $3e02d78f2f421b00$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $3e02d78f2f421b00$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e02d78f2f421b00$var$React = $3e02d78f2f421b00$var$_interopRequireWildcard((parcelRequire("NdCUR")));

var $3e02d78f2f421b00$var$_propTypes = $3e02d78f2f421b00$var$_interopRequireDefault((parcelRequire("fGw9V")));

var $3e02d78f2f421b00$var$_reactDom = $3e02d78f2f421b00$var$_interopRequireDefault((parcelRequire("g2wso")));

var $3qhhR = parcelRequire("3qhhR");

var $jKNSJ = parcelRequire("jKNSJ");

var $ghOl8 = parcelRequire("ghOl8");

var $3e02d78f2f421b00$var$_log = $3e02d78f2f421b00$var$_interopRequireDefault((parcelRequire("djv9A")));
function $3e02d78f2f421b00$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3e02d78f2f421b00$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($3e02d78f2f421b00$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $3e02d78f2f421b00$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $3e02d78f2f421b00$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $3e02d78f2f421b00$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $3e02d78f2f421b00$var$_slicedToArray(arr, i) {
    return $3e02d78f2f421b00$var$_arrayWithHoles(arr) || $3e02d78f2f421b00$var$_iterableToArrayLimit(arr, i) || $3e02d78f2f421b00$var$_unsupportedIterableToArray(arr, i) || $3e02d78f2f421b00$var$_nonIterableRest();
}
function $3e02d78f2f421b00$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3e02d78f2f421b00$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3e02d78f2f421b00$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3e02d78f2f421b00$var$_arrayLikeToArray(o, minLen);
}
function $3e02d78f2f421b00$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3e02d78f2f421b00$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $3e02d78f2f421b00$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $3e02d78f2f421b00$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3e02d78f2f421b00$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3e02d78f2f421b00$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3e02d78f2f421b00$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3e02d78f2f421b00$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $3e02d78f2f421b00$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $3e02d78f2f421b00$var$_setPrototypeOf(subClass, superClass);
}
function $3e02d78f2f421b00$var$_setPrototypeOf(o, p) {
    $3e02d78f2f421b00$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3e02d78f2f421b00$var$_setPrototypeOf(o, p);
}
function $3e02d78f2f421b00$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $3e02d78f2f421b00$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $3e02d78f2f421b00$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $3e02d78f2f421b00$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $3e02d78f2f421b00$var$_possibleConstructorReturn(this, result);
    };
}
function $3e02d78f2f421b00$var$_possibleConstructorReturn(self, call) {
    if (call && ($3e02d78f2f421b00$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $3e02d78f2f421b00$var$_assertThisInitialized(self);
}
function $3e02d78f2f421b00$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $3e02d78f2f421b00$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $3e02d78f2f421b00$var$_getPrototypeOf(o) {
    $3e02d78f2f421b00$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $3e02d78f2f421b00$var$_getPrototypeOf(o);
}
function $3e02d78f2f421b00$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
// Simple abstraction for dragging events names.
var $3e02d78f2f421b00$var$eventsFor = {
    touch: {
        start: 'touchstart',
        move: 'touchmove',
        stop: 'touchend'
    },
    mouse: {
        start: 'mousedown',
        move: 'mousemove',
        stop: 'mouseup'
    }
}; // Default to mouse events.
var $3e02d78f2f421b00$var$dragEventFor = $3e02d78f2f421b00$var$eventsFor.mouse;
/*:: type DraggableCoreState = {
  dragging: boolean,
  lastX: number,
  lastY: number,
  touchIdentifier: ?number
};*/ /*:: export type DraggableData = {
  node: HTMLElement,
  x: number, y: number,
  deltaX: number, deltaY: number,
  lastX: number, lastY: number,
};*/ /*:: export type DraggableEventHandler = (e: MouseEvent, data: DraggableData) => void | false;*/ /*:: export type ControlPosition = {x: number, y: number};*/ /*:: export type PositionOffsetControlPosition = {x: number|string, y: number|string};*/ /*:: export type DraggableCoreDefaultProps = {
  allowAnyClick: boolean,
  disabled: boolean,
  enableUserSelectHack: boolean,
  onStart: DraggableEventHandler,
  onDrag: DraggableEventHandler,
  onStop: DraggableEventHandler,
  onMouseDown: (e: MouseEvent) => void,
  scale: number,
};*/ /*:: export type DraggableCoreProps = {
  ...DraggableCoreDefaultProps,
  cancel: string,
  children: ReactElement<any>,
  offsetParent: HTMLElement,
  grid: [number, number],
  handle: string,
  nodeRef?: ?React.ElementRef<any>,
};*/ //
// Define <DraggableCore>.
//
// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
// work well with libraries that require more control over the element.
//
var $3e02d78f2f421b00$var$DraggableCore = /*#__PURE__*/ function(_React$Component) {
    $3e02d78f2f421b00$var$_inherits(DraggableCore, _React$Component);
    var _super = $3e02d78f2f421b00$var$_createSuper(DraggableCore);
    function DraggableCore() {
        var _this;
        $3e02d78f2f421b00$var$_classCallCheck(this, DraggableCore);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $3e02d78f2f421b00$var$_defineProperty($3e02d78f2f421b00$var$_assertThisInitialized(_this), "state", {
            dragging: false,
            // Used while dragging to determine deltas.
            lastX: NaN,
            lastY: NaN,
            touchIdentifier: null
        });
        $3e02d78f2f421b00$var$_defineProperty($3e02d78f2f421b00$var$_assertThisInitialized(_this), "mounted", false);
        $3e02d78f2f421b00$var$_defineProperty($3e02d78f2f421b00$var$_assertThisInitialized(_this), "handleDragStart", function(e) {
            // Make it possible to attach event handlers on top of this one.
            _this.props.onMouseDown(e); // Only accept left-clicks.
            if (!_this.props.allowAnyClick && typeof e.button === 'number' && e.button !== 0) return false; // Get nodes. Be sure to grab relative document (could be iframed)
            var thisNode = _this.findDOMNode();
            if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) throw new Error('<DraggableCore> not mounted on DragStart!');
            var ownerDocument = thisNode.ownerDocument; // Short circuit if handle or cancel prop was provided and selector doesn't match.
            if (_this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || _this.props.handle && !(0, $3qhhR.matchesSelectorAndParentsTo)(e.target, _this.props.handle, thisNode) || _this.props.cancel && (0, $3qhhR.matchesSelectorAndParentsTo)(e.target, _this.props.cancel, thisNode)) return;
             // Prevent scrolling on mobile devices, like ipad/iphone.
            // Important that this is after handle/cancel.
            if (e.type === 'touchstart') e.preventDefault(); // Set touch identifier in component state if this is a touch event. This allows us to
            // distinguish between individual touches on multitouch screens by identifying which
            // touchpoint was set to this element.
            var touchIdentifier = (0, $3qhhR.getTouchIdentifier)(e);
            _this.setState({
                touchIdentifier: touchIdentifier
            }); // Get the current drag point from the event. This is used as the offset.
            var position = (0, $jKNSJ.getControlPosition)(e, touchIdentifier, $3e02d78f2f421b00$var$_assertThisInitialized(_this));
            if (position == null) return; // not possible but satisfies flow
            var x = position.x, y = position.y; // Create an event object with all the data parents need to make a decision here.
            var coreEvent = (0, $jKNSJ.createCoreData)($3e02d78f2f421b00$var$_assertThisInitialized(_this), x, y);
            (0, $3e02d78f2f421b00$var$_log.default)('DraggableCore: handleDragStart: %j', coreEvent); // Call event handler. If it returns explicit false, cancel.
            (0, $3e02d78f2f421b00$var$_log.default)('calling', _this.props.onStart);
            var shouldUpdate = _this.props.onStart(e, coreEvent);
            if (shouldUpdate === false || _this.mounted === false) return; // Add a style to the body to disable user-select. This prevents text from
            // being selected all over the page.
            if (_this.props.enableUserSelectHack) (0, $3qhhR.addUserSelectStyles)(ownerDocument); // Initiate dragging. Set the current x and y as offsets
            // so we know how much we've moved during the drag. This allows us
            // to drag elements around even if they have been moved, without issue.
            _this.setState({
                dragging: true,
                lastX: x,
                lastY: y
            }); // Add events to the document directly so we catch when the user's mouse/touch moves outside of
            // this element. We use different events depending on whether or not we have detected that this
            // is a touch-capable device.
            (0, $3qhhR.addEvent)(ownerDocument, $3e02d78f2f421b00$var$dragEventFor.move, _this.handleDrag);
            (0, $3qhhR.addEvent)(ownerDocument, $3e02d78f2f421b00$var$dragEventFor.stop, _this.handleDragStop);
        });
        $3e02d78f2f421b00$var$_defineProperty($3e02d78f2f421b00$var$_assertThisInitialized(_this), "handleDrag", function(e) {
            // Get the current drag point from the event. This is used as the offset.
            var position = (0, $jKNSJ.getControlPosition)(e, _this.state.touchIdentifier, $3e02d78f2f421b00$var$_assertThisInitialized(_this));
            if (position == null) return;
            var x = position.x, y = position.y; // Snap to grid if prop has been provided
            if (Array.isArray(_this.props.grid)) {
                var deltaX = x - _this.state.lastX, deltaY = y - _this.state.lastY;
                var _snapToGrid = (0, $jKNSJ.snapToGrid)(_this.props.grid, deltaX, deltaY);
                var _snapToGrid2 = $3e02d78f2f421b00$var$_slicedToArray(_snapToGrid, 2);
                deltaX = _snapToGrid2[0];
                deltaY = _snapToGrid2[1];
                if (!deltaX && !deltaY) return; // skip useless drag
                x = _this.state.lastX + deltaX, y = _this.state.lastY + deltaY;
            }
            var coreEvent = (0, $jKNSJ.createCoreData)($3e02d78f2f421b00$var$_assertThisInitialized(_this), x, y);
            (0, $3e02d78f2f421b00$var$_log.default)('DraggableCore: handleDrag: %j', coreEvent); // Call event handler. If it returns explicit false, trigger end.
            var shouldUpdate = _this.props.onDrag(e, coreEvent);
            if (shouldUpdate === false || _this.mounted === false) {
                try {
                    // $FlowIgnore
                    _this.handleDragStop(new MouseEvent('mouseup'));
                } catch (err) {
                    // Old browsers
                    var event = document.createEvent('MouseEvents'); // I see why this insanity was deprecated
                    // $FlowIgnore
                    event.initMouseEvent('mouseup', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                    _this.handleDragStop(event);
                }
                return;
            }
            _this.setState({
                lastX: x,
                lastY: y
            });
        });
        $3e02d78f2f421b00$var$_defineProperty($3e02d78f2f421b00$var$_assertThisInitialized(_this), "handleDragStop", function(e) {
            if (!_this.state.dragging) return;
            var position = (0, $jKNSJ.getControlPosition)(e, _this.state.touchIdentifier, $3e02d78f2f421b00$var$_assertThisInitialized(_this));
            if (position == null) return;
            var x = position.x, y = position.y;
            var coreEvent = (0, $jKNSJ.createCoreData)($3e02d78f2f421b00$var$_assertThisInitialized(_this), x, y); // Call event handler
            var shouldContinue = _this.props.onStop(e, coreEvent);
            if (shouldContinue === false || _this.mounted === false) return false;
            var thisNode = _this.findDOMNode();
            if (thisNode) // Remove user-select hack
            {
                if (_this.props.enableUserSelectHack) (0, $3qhhR.removeUserSelectStyles)(thisNode.ownerDocument);
            }
            (0, $3e02d78f2f421b00$var$_log.default)('DraggableCore: handleDragStop: %j', coreEvent); // Reset the el.
            _this.setState({
                dragging: false,
                lastX: NaN,
                lastY: NaN
            });
            if (thisNode) {
                // Remove event handlers
                (0, $3e02d78f2f421b00$var$_log.default)('DraggableCore: Removing handlers');
                (0, $3qhhR.removeEvent)(thisNode.ownerDocument, $3e02d78f2f421b00$var$dragEventFor.move, _this.handleDrag);
                (0, $3qhhR.removeEvent)(thisNode.ownerDocument, $3e02d78f2f421b00$var$dragEventFor.stop, _this.handleDragStop);
            }
        });
        $3e02d78f2f421b00$var$_defineProperty($3e02d78f2f421b00$var$_assertThisInitialized(_this), "onMouseDown", function(e) {
            $3e02d78f2f421b00$var$dragEventFor = $3e02d78f2f421b00$var$eventsFor.mouse; // on touchscreen laptops we could switch back to mouse
            return _this.handleDragStart(e);
        });
        $3e02d78f2f421b00$var$_defineProperty($3e02d78f2f421b00$var$_assertThisInitialized(_this), "onMouseUp", function(e) {
            $3e02d78f2f421b00$var$dragEventFor = $3e02d78f2f421b00$var$eventsFor.mouse;
            return _this.handleDragStop(e);
        });
        $3e02d78f2f421b00$var$_defineProperty($3e02d78f2f421b00$var$_assertThisInitialized(_this), "onTouchStart", function(e) {
            // We're on a touch device now, so change the event handlers
            $3e02d78f2f421b00$var$dragEventFor = $3e02d78f2f421b00$var$eventsFor.touch;
            return _this.handleDragStart(e);
        });
        $3e02d78f2f421b00$var$_defineProperty($3e02d78f2f421b00$var$_assertThisInitialized(_this), "onTouchEnd", function(e) {
            // We're on a touch device now, so change the event handlers
            $3e02d78f2f421b00$var$dragEventFor = $3e02d78f2f421b00$var$eventsFor.touch;
            return _this.handleDragStop(e);
        });
        return _this;
    }
    $3e02d78f2f421b00$var$_createClass(DraggableCore, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.mounted = true; // Touch handlers must be added with {passive: false} to be cancelable.
                // https://developers.google.com/web/updates/2017/01/scrolling-intervention
                var thisNode = this.findDOMNode();
                if (thisNode) (0, $3qhhR.addEvent)(thisNode, $3e02d78f2f421b00$var$eventsFor.touch.start, this.onTouchStart, {
                    passive: false
                });
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mounted = false; // Remove any leftover event handlers. Remove both touch and mouse handlers in case
                // some browser quirk caused a touch event to fire during a mouse move, or vice versa.
                var thisNode = this.findDOMNode();
                if (thisNode) {
                    var ownerDocument = thisNode.ownerDocument;
                    (0, $3qhhR.removeEvent)(ownerDocument, $3e02d78f2f421b00$var$eventsFor.mouse.move, this.handleDrag);
                    (0, $3qhhR.removeEvent)(ownerDocument, $3e02d78f2f421b00$var$eventsFor.touch.move, this.handleDrag);
                    (0, $3qhhR.removeEvent)(ownerDocument, $3e02d78f2f421b00$var$eventsFor.mouse.stop, this.handleDragStop);
                    (0, $3qhhR.removeEvent)(ownerDocument, $3e02d78f2f421b00$var$eventsFor.touch.stop, this.handleDragStop);
                    (0, $3qhhR.removeEvent)(thisNode, $3e02d78f2f421b00$var$eventsFor.touch.start, this.onTouchStart, {
                        passive: false
                    });
                    if (this.props.enableUserSelectHack) (0, $3qhhR.removeUserSelectStyles)(ownerDocument);
                }
            } // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
        },
        {
            key: "findDOMNode",
            value: function findDOMNode() /*: ?HTMLElement*/ {
                var _this$props$nodeRef$c, _this$props, _this$props$nodeRef;
                return (_this$props$nodeRef$c = (_this$props = this.props) === null || _this$props === void 0 ? void 0 : (_this$props$nodeRef = _this$props.nodeRef) === null || _this$props$nodeRef === void 0 ? void 0 : _this$props$nodeRef.current) !== null && _this$props$nodeRef$c !== void 0 ? _this$props$nodeRef$c : $3e02d78f2f421b00$var$_reactDom.default.findDOMNode(this);
            }
        },
        {
            key: "render",
            value: function render() /*: React.Element<any>*/ {
                // Reuse the child provided
                // This makes it flexible to use whatever element is wanted (div, ul, etc)
                return /*#__PURE__*/ $3e02d78f2f421b00$var$React.cloneElement($3e02d78f2f421b00$var$React.Children.only(this.props.children), {
                    // Note: mouseMove handler is attached to document so it will still function
                    // when the user drags quickly and leaves the bounds of the element.
                    onMouseDown: this.onMouseDown,
                    onMouseUp: this.onMouseUp,
                    // onTouchStart is added on `componentDidMount` so they can be added with
                    // {passive: false}, which allows it to cancel. See
                    // https://developers.google.com/web/updates/2017/01/scrolling-intervention
                    onTouchEnd: this.onTouchEnd
                });
            }
        }
    ]);
    return DraggableCore;
}($3e02d78f2f421b00$var$React.Component);
module.exports.default = $3e02d78f2f421b00$var$DraggableCore;
$3e02d78f2f421b00$var$_defineProperty($3e02d78f2f421b00$var$DraggableCore, "displayName", 'DraggableCore');
$3e02d78f2f421b00$var$_defineProperty($3e02d78f2f421b00$var$DraggableCore, "propTypes", {
    /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */ allowAnyClick: $3e02d78f2f421b00$var$_propTypes.default.bool,
    /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */ disabled: $3e02d78f2f421b00$var$_propTypes.default.bool,
    /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */ enableUserSelectHack: $3e02d78f2f421b00$var$_propTypes.default.bool,
    /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */ offsetParent: function offsetParent(props, propName) {
        if (props[propName] && props[propName].nodeType !== 1) throw new Error('Draggable\'s offsetParent must be a DOM Node.');
    },
    /**
   * `grid` specifies the x and y that dragging should snap to.
   */ grid: $3e02d78f2f421b00$var$_propTypes.default.arrayOf($3e02d78f2f421b00$var$_propTypes.default.number),
    /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ handle: $3e02d78f2f421b00$var$_propTypes.default.string,
    /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */ cancel: $3e02d78f2f421b00$var$_propTypes.default.string,
    /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */ nodeRef: $3e02d78f2f421b00$var$_propTypes.default.object,
    /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */ onStart: $3e02d78f2f421b00$var$_propTypes.default.func,
    /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */ onDrag: $3e02d78f2f421b00$var$_propTypes.default.func,
    /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */ onStop: $3e02d78f2f421b00$var$_propTypes.default.func,
    /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */ onMouseDown: $3e02d78f2f421b00$var$_propTypes.default.func,
    /**
   * `scale`, if set, applies scaling while dragging an element
   */ scale: $3e02d78f2f421b00$var$_propTypes.default.number,
    /**
   * These properties should be defined on the child, not here.
   */ className: $ghOl8.dontSetMe,
    style: $ghOl8.dontSetMe,
    transform: $ghOl8.dontSetMe
});
$3e02d78f2f421b00$var$_defineProperty($3e02d78f2f421b00$var$DraggableCore, "defaultProps", {
    allowAnyClick: false,
    // by default only accept left click
    disabled: false,
    enableUserSelectHack: true,
    onStart: function onStart() {},
    onDrag: function onDrag() {},
    onStop: function onStop() {},
    onMouseDown: function onMouseDown() {},
    scale: 1
});

});
parcelRegister("djv9A", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9b15372d8250980b$var$log;
/*eslint no-console:0*/ function $9b15372d8250980b$var$log() {
    var _console;
}

});




parcelRegister("fzrCT", function(module, exports) {
'use strict';
module.exports = function() {
    throw new Error("Don't instantiate Resizable directly! Use require('react-resizable').Resizable");
};

module.exports.Resizable = (parcelRequire("fKu1V")).default;

module.exports.ResizableBox = (parcelRequire("5jyqk")).default;

});
parcelRegister("fKu1V", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $b772723ffc717f33$export$1e511d4a378977f5; }, function (v) { return $b772723ffc717f33$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $b772723ffc717f33$export$2e2bcd8739ae039; }, function (v) { return $b772723ffc717f33$export$2e2bcd8739ae039 = v; });
var $b772723ffc717f33$export$1e511d4a378977f5;
var $b772723ffc717f33$export$2e2bcd8739ae039;
"use strict";
$b772723ffc717f33$export$1e511d4a378977f5 = true;
$b772723ffc717f33$export$2e2bcd8739ae039 = void 0;

var $b772723ffc717f33$var$_react = $b772723ffc717f33$var$_interopRequireDefault((parcelRequire("NdCUR")));

var $aqFpf = parcelRequire("aqFpf");

var $kzgvq = parcelRequire("kzgvq");

var $01aMo = parcelRequire("01aMo");
function $b772723ffc717f33$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b772723ffc717f33$var$_extends() {
    $b772723ffc717f33$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b772723ffc717f33$var$_extends.apply(this, arguments);
}
function $b772723ffc717f33$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b772723ffc717f33$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $b772723ffc717f33$var$ownKeys(Object(source), true).forEach(function(key) {
            $b772723ffc717f33$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $b772723ffc717f33$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b772723ffc717f33$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $b772723ffc717f33$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $b772723ffc717f33$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $b772723ffc717f33$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $b772723ffc717f33$var$Resizable = /*#__PURE__*/ function(_React$Component) {
    $b772723ffc717f33$var$_inheritsLoose(Resizable, _React$Component);
    function Resizable() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        $b772723ffc717f33$var$_defineProperty($b772723ffc717f33$var$_assertThisInitialized(_this), "state", undefined);
        $b772723ffc717f33$var$_defineProperty($b772723ffc717f33$var$_assertThisInitialized(_this), "lastHandleRect", null);
        $b772723ffc717f33$var$_defineProperty($b772723ffc717f33$var$_assertThisInitialized(_this), "slack", null);
        return _this;
    }
    var _proto = Resizable.prototype;
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.resetData();
    };
    _proto.lockAspectRatio = function lockAspectRatio(width, height, aspectRatio) {
        height = width / aspectRatio;
        width = height * aspectRatio;
        return [
            width,
            height
        ];
    };
    _proto.resetData = function resetData() {
        this.lastHandleRect = this.slack = null;
    } // Clamp width and height within provided constraints
    ;
    _proto.runConstraints = function runConstraints(width, height) {
        var _ref = [
            this.props.minConstraints,
            this.props.maxConstraints
        ], min = _ref[0], max = _ref[1];
        if (!min && !max) return [
            width,
            height
        ]; // If constraining to min and max, we need to also fit width and height to aspect ratio.
        if (this.props.lockAspectRatio) {
            var resizingHorizontally = height === this.props.height;
            if (resizingHorizontally) {
                var ratio = this.props.width / this.props.height;
                height = width / ratio;
                width = height * ratio;
            } else {
                // Take into account vertical resize with N/S handles on locked aspect
                // ratio. Calculate the change height-first, instead of width-first
                var _ratio = this.props.height / this.props.width;
                width = height / _ratio;
                height = width * _ratio;
            }
        }
        var oldW = width, oldH = height; // Add slack to the values used to calculate bound position. This will ensure that if
        // we start removing slack, the element won't react to it right away until it's been
        // completely removed.
        var _ref2 = this.slack || [
            0,
            0
        ], slackW = _ref2[0], slackH = _ref2[1];
        width += slackW;
        height += slackH;
        if (min) {
            width = Math.max(min[0], width);
            height = Math.max(min[1], height);
        }
        if (max) {
            width = Math.min(max[0], width);
            height = Math.min(max[1], height);
        } // If the width or height changed, we must have introduced some slack. Record it for the next iteration.
        this.slack = [
            slackW + (oldW - width),
            slackH + (oldH - height)
        ];
        return [
            width,
            height
        ];
    };
    _proto.resizeHandler = function resizeHandler(handlerName, axis) {
        var _this2 = this;
        return function(e, _ref3) {
            var node = _ref3.node, deltaX = _ref3.deltaX, deltaY = _ref3.deltaY;
            // Reset data in case it was left over somehow (should not be possible)
            if (handlerName === 'onResizeStart') _this2.resetData(); // Axis restrictions
            var canDragX = (_this2.props.axis === 'both' || _this2.props.axis === 'x') && axis !== 'n' && axis !== 's';
            var canDragY = (_this2.props.axis === 'both' || _this2.props.axis === 'y') && axis !== 'e' && axis !== 'w'; // No dragging possible.
            if (!canDragX && !canDragY) return; // Decompose axis for later use
            var axisV = axis[0];
            var axisH = axis[axis.length - 1]; // intentionally not axis[1], so that this catches axis === 'w' for example
            // Track the element being dragged to account for changes in position.
            // If a handle's position is changed between callbacks, we need to factor this in to the next callback.
            // Failure to do so will cause the element to "skip" when resized upwards or leftwards.
            var handleRect = node.getBoundingClientRect();
            if (_this2.lastHandleRect != null) {
                // If the handle has repositioned on either axis since last render,
                // we need to increase our callback values by this much.
                // Only checking 'n', 'w' since resizing by 's', 'w' won't affect the overall position on page,
                if (axisH === 'w') {
                    var deltaLeftSinceLast = handleRect.left - _this2.lastHandleRect.left;
                    deltaX += deltaLeftSinceLast;
                }
                if (axisV === 'n') {
                    var deltaTopSinceLast = handleRect.top - _this2.lastHandleRect.top;
                    deltaY += deltaTopSinceLast;
                }
            } // Storage of last rect so we know how much it has really moved.
            _this2.lastHandleRect = handleRect; // Reverse delta if using top or left drag handles.
            if (axisH === 'w') deltaX = -deltaX;
            if (axisV === 'n') deltaY = -deltaY; // Update w/h by the deltas. Also factor in transformScale.
            var width = _this2.props.width + (canDragX ? deltaX / _this2.props.transformScale : 0);
            var height = _this2.props.height + (canDragY ? deltaY / _this2.props.transformScale : 0); // Run user-provided constraints.
            var _this2$runConstraints = _this2.runConstraints(width, height);
            width = _this2$runConstraints[0];
            height = _this2$runConstraints[1];
            var dimensionsChanged = width !== _this2.props.width || height !== _this2.props.height; // Call user-supplied callback if present.
            var cb = typeof _this2.props[handlerName] === 'function' ? _this2.props[handlerName] : null; // Don't call 'onResize' if dimensions haven't changed.
            var shouldSkipCb = handlerName === 'onResize' && !dimensionsChanged;
            if (cb && !shouldSkipCb) {
                if (typeof e.persist === 'function') e.persist();
                cb(e, {
                    node: node,
                    size: {
                        width: width,
                        height: height
                    },
                    handle: axis
                });
            } // Reset internal data
            if (handlerName === 'onResizeStop') _this2.resetData();
        };
    };
    _proto.renderResizeHandle = function renderResizeHandle(resizeHandleAxis) {
        var handle = this.props.handle;
        if (handle) {
            if (typeof handle === 'function') return handle(resizeHandleAxis);
            return handle;
        }
        return /*#__PURE__*/ $b772723ffc717f33$var$_react.default.createElement("span", {
            className: "react-resizable-handle react-resizable-handle-" + resizeHandleAxis
        });
    };
    _proto.render = function render() {
        var _this3 = this;
        // Pass along only props not meant for the `<Resizable>`.`
        // eslint-disable-next-line no-unused-vars
        var _this$props = this.props, children = _this$props.children, className = _this$props.className, draggableOpts = _this$props.draggableOpts, width = _this$props.width, height = _this$props.height, handle = _this$props.handle, handleSize = _this$props.handleSize, lockAspectRatio = _this$props.lockAspectRatio, axis = _this$props.axis, minConstraints = _this$props.minConstraints, maxConstraints = _this$props.maxConstraints, onResize = _this$props.onResize, onResizeStop = _this$props.onResizeStop, onResizeStart = _this$props.onResizeStart, resizeHandles = _this$props.resizeHandles, transformScale = _this$props.transformScale, p = $b772723ffc717f33$var$_objectWithoutPropertiesLoose(_this$props, [
            "children",
            "className",
            "draggableOpts",
            "width",
            "height",
            "handle",
            "handleSize",
            "lockAspectRatio",
            "axis",
            "minConstraints",
            "maxConstraints",
            "onResize",
            "onResizeStop",
            "onResizeStart",
            "resizeHandles",
            "transformScale"
        ]); // What we're doing here is getting the child of this element, and cloning it with this element's props.
        // We are then defining its children as:
        // Its original children (resizable's child's children), and
        // One or more draggable handles.
        return (0, $kzgvq.cloneElement)(children, $b772723ffc717f33$var$_objectSpread($b772723ffc717f33$var$_objectSpread({}, p), {}, {
            className: (className ? className + " " : '') + "react-resizable",
            children: [].concat(children.props.children, resizeHandles.map(function(handleAxis) {
                return /*#__PURE__*/ $b772723ffc717f33$var$_react.default.createElement($aqFpf.DraggableCore, $b772723ffc717f33$var$_extends({}, draggableOpts, {
                    key: "resizableHandle-" + handleAxis,
                    onStop: _this3.resizeHandler('onResizeStop', handleAxis),
                    onStart: _this3.resizeHandler('onResizeStart', handleAxis),
                    onDrag: _this3.resizeHandler('onResize', handleAxis)
                }), _this3.renderResizeHandle(handleAxis));
            }))
        }));
    };
    return Resizable;
}($b772723ffc717f33$var$_react.default.Component);
$b772723ffc717f33$export$2e2bcd8739ae039 = $b772723ffc717f33$var$Resizable;
$b772723ffc717f33$var$_defineProperty($b772723ffc717f33$var$Resizable, "propTypes", $01aMo.resizableProps);
$b772723ffc717f33$var$_defineProperty($b772723ffc717f33$var$Resizable, "defaultProps", {
    handleSize: [
        20,
        20
    ],
    lockAspectRatio: false,
    axis: 'both',
    minConstraints: [
        20,
        20
    ],
    maxConstraints: [
        Infinity,
        Infinity
    ],
    resizeHandles: [
        'se'
    ],
    transformScale: 1
});

});
parcelRegister("kzgvq", function(module, exports) {

$parcel$export(module.exports, "cloneElement", function () { return $ef93e1438ad92db1$export$e530037191fcd5d7; }, function (v) { return $ef93e1438ad92db1$export$e530037191fcd5d7 = v; });
var $ef93e1438ad92db1$export$1e511d4a378977f5;
var $ef93e1438ad92db1$export$e530037191fcd5d7;
"use strict";
$ef93e1438ad92db1$export$1e511d4a378977f5 = true;
$ef93e1438ad92db1$export$e530037191fcd5d7 = $ef93e1438ad92db1$var$cloneElement;

var $ef93e1438ad92db1$var$_react = $ef93e1438ad92db1$var$_interopRequireDefault((parcelRequire("NdCUR")));
function $ef93e1438ad92db1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ef93e1438ad92db1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ef93e1438ad92db1$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $ef93e1438ad92db1$var$ownKeys(Object(source), true).forEach(function(key) {
            $ef93e1438ad92db1$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $ef93e1438ad92db1$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ef93e1438ad92db1$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
// React.addons.cloneWithProps look-alike that merges style & className.
function $ef93e1438ad92db1$var$cloneElement(element, props) {
    if (props.style && element.props.style) props.style = $ef93e1438ad92db1$var$_objectSpread($ef93e1438ad92db1$var$_objectSpread({}, element.props.style), props.style);
    if (props.className && element.props.className) props.className = element.props.className + " " + props.className;
    return /*#__PURE__*/ $ef93e1438ad92db1$var$_react.default.cloneElement(element, props);
}

});

parcelRegister("01aMo", function(module, exports) {

$parcel$export(module.exports, "resizableProps", function () { return $003874b761a80407$export$32a002ec6a601762; }, function (v) { return $003874b761a80407$export$32a002ec6a601762 = v; });
var $003874b761a80407$export$1e511d4a378977f5;
var $003874b761a80407$export$32a002ec6a601762;
"use strict";
$003874b761a80407$export$1e511d4a378977f5 = true;
$003874b761a80407$export$32a002ec6a601762 = void 0;

var $003874b761a80407$var$_propTypes = $003874b761a80407$var$_interopRequireDefault((parcelRequire("fGw9V")));
parcelRequire("aqFpf");
function $003874b761a80407$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $003874b761a80407$var$resizableProps = {
    /*
  * Restricts resizing to a particular axis (default: 'both')
  * 'both' - allows resizing by width or height
  * 'x' - only allows the width to be changed
  * 'y' - only allows the height to be changed
  * 'none' - disables resizing altogether
  * */ axis: $003874b761a80407$var$_propTypes.default.oneOf([
        'both',
        'x',
        'y',
        'none'
    ]),
    className: $003874b761a80407$var$_propTypes.default.string,
    /*
  * Require that one and only one child be present.
  * */ children: $003874b761a80407$var$_propTypes.default.element.isRequired,
    /*
  * These will be passed wholesale to react-draggable's DraggableCore
  * */ draggableOpts: $003874b761a80407$var$_propTypes.default.shape({
        allowAnyClick: $003874b761a80407$var$_propTypes.default.bool,
        cancel: $003874b761a80407$var$_propTypes.default.string,
        children: $003874b761a80407$var$_propTypes.default.node,
        disabled: $003874b761a80407$var$_propTypes.default.bool,
        enableUserSelectHack: $003874b761a80407$var$_propTypes.default.bool,
        offsetParent: $003874b761a80407$var$_propTypes.default.node,
        grid: $003874b761a80407$var$_propTypes.default.arrayOf($003874b761a80407$var$_propTypes.default.number),
        handle: $003874b761a80407$var$_propTypes.default.string,
        nodeRef: $003874b761a80407$var$_propTypes.default.object,
        onStart: $003874b761a80407$var$_propTypes.default.func,
        onDrag: $003874b761a80407$var$_propTypes.default.func,
        onStop: $003874b761a80407$var$_propTypes.default.func,
        onMouseDown: $003874b761a80407$var$_propTypes.default.func,
        scale: $003874b761a80407$var$_propTypes.default.number
    }),
    /*
  * Initial height
  * */ height: $003874b761a80407$var$_propTypes.default.number.isRequired,
    /*
  * Customize cursor resize handle
  * */ handle: $003874b761a80407$var$_propTypes.default.oneOfType([
        $003874b761a80407$var$_propTypes.default.node,
        $003874b761a80407$var$_propTypes.default.func
    ]),
    /*
  * If you change this, be sure to update your css
  * */ handleSize: $003874b761a80407$var$_propTypes.default.arrayOf($003874b761a80407$var$_propTypes.default.number),
    lockAspectRatio: $003874b761a80407$var$_propTypes.default.bool,
    /*
  * Max X & Y measure
  * */ maxConstraints: $003874b761a80407$var$_propTypes.default.arrayOf($003874b761a80407$var$_propTypes.default.number),
    /*
  * Min X & Y measure
  * */ minConstraints: $003874b761a80407$var$_propTypes.default.arrayOf($003874b761a80407$var$_propTypes.default.number),
    /*
  * Called on stop resize event
  * */ onResizeStop: $003874b761a80407$var$_propTypes.default.func,
    /*
  * Called on start resize event
  * */ onResizeStart: $003874b761a80407$var$_propTypes.default.func,
    /*
  * Called on resize event
  * */ onResize: $003874b761a80407$var$_propTypes.default.func,
    /*
  * Defines which resize handles should be rendered (default: 'se')
  * 's' - South handle (bottom-center)
  * 'w' - West handle (left-center)
  * 'e' - East handle (right-center)
  * 'n' - North handle (top-center)
  * 'sw' - Southwest handle (bottom-left)
  * 'nw' - Northwest handle (top-left)
  * 'se' - Southeast handle (bottom-right)
  * 'ne' - Northeast handle (top-center)
  * */ resizeHandles: $003874b761a80407$var$_propTypes.default.arrayOf($003874b761a80407$var$_propTypes.default.oneOf([
        's',
        'w',
        'e',
        'n',
        'sw',
        'nw',
        'se',
        'ne'
    ])),
    /*
  * If `transform: scale(n)` is set on the parent, this should be set to `n`.
  * */ transformScale: $003874b761a80407$var$_propTypes.default.number,
    /*
   * Initial width
   */ width: $003874b761a80407$var$_propTypes.default.number.isRequired
};
$003874b761a80407$export$32a002ec6a601762 = $003874b761a80407$var$resizableProps;

});


parcelRegister("5jyqk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3de96de5bedd4cba$export$2e2bcd8739ae039; }, function (v) { return $3de96de5bedd4cba$export$2e2bcd8739ae039 = v; });
var $3de96de5bedd4cba$export$1e511d4a378977f5;
var $3de96de5bedd4cba$export$2e2bcd8739ae039;
"use strict";
$3de96de5bedd4cba$export$1e511d4a378977f5 = true;
$3de96de5bedd4cba$export$2e2bcd8739ae039 = void 0;

var $3de96de5bedd4cba$var$React = $3de96de5bedd4cba$var$_interopRequireWildcard((parcelRequire("NdCUR")));

var $3de96de5bedd4cba$var$_propTypes = $3de96de5bedd4cba$var$_interopRequireDefault((parcelRequire("fGw9V")));

var $3de96de5bedd4cba$var$_Resizable = $3de96de5bedd4cba$var$_interopRequireDefault((parcelRequire("fKu1V")));

var $01aMo = parcelRequire("01aMo");
function $3de96de5bedd4cba$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3de96de5bedd4cba$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $3de96de5bedd4cba$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $3de96de5bedd4cba$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $3de96de5bedd4cba$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $3de96de5bedd4cba$var$_extends() {
    $3de96de5bedd4cba$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3de96de5bedd4cba$var$_extends.apply(this, arguments);
}
function $3de96de5bedd4cba$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3de96de5bedd4cba$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $3de96de5bedd4cba$var$ownKeys(Object(source), true).forEach(function(key) {
            $3de96de5bedd4cba$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $3de96de5bedd4cba$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3de96de5bedd4cba$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $3de96de5bedd4cba$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $3de96de5bedd4cba$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $3de96de5bedd4cba$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $3de96de5bedd4cba$var$ResizableBox = /*#__PURE__*/ function(_React$Component) {
    $3de96de5bedd4cba$var$_inheritsLoose(ResizableBox, _React$Component);
    function ResizableBox() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        $3de96de5bedd4cba$var$_defineProperty($3de96de5bedd4cba$var$_assertThisInitialized(_this), "state", {
            width: _this.props.width,
            height: _this.props.height,
            propsWidth: _this.props.width,
            propsHeight: _this.props.height
        });
        $3de96de5bedd4cba$var$_defineProperty($3de96de5bedd4cba$var$_assertThisInitialized(_this), "onResize", function(e, data) {
            var size = data.size;
            if (_this.props.onResize) {
                e.persist && e.persist();
                _this.setState(size, function() {
                    return _this.props.onResize && _this.props.onResize(e, data);
                });
            } else _this.setState(size);
        });
        return _this;
    }
    ResizableBox.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        // If parent changes height/width, set that in our state.
        if (state.propsWidth !== props.width || state.propsHeight !== props.height) return {
            width: props.width,
            height: props.height,
            propsWidth: props.width,
            propsHeight: props.height
        };
        return null;
    };
    var _proto = ResizableBox.prototype;
    _proto.render = function render() {
        // Basic wrapper around a Resizable instance.
        // If you use Resizable directly, you are responsible for updating the child component
        // with a new width and height.
        var _this$props = this.props, handle = _this$props.handle, handleSize = _this$props.handleSize, onResize = _this$props.onResize, onResizeStart = _this$props.onResizeStart, onResizeStop = _this$props.onResizeStop, draggableOpts = _this$props.draggableOpts, minConstraints = _this$props.minConstraints, maxConstraints = _this$props.maxConstraints, lockAspectRatio = _this$props.lockAspectRatio, axis = _this$props.axis, width = _this$props.width, height = _this$props.height, resizeHandles = _this$props.resizeHandles, style = _this$props.style, transformScale = _this$props.transformScale, props = $3de96de5bedd4cba$var$_objectWithoutPropertiesLoose(_this$props, [
            "handle",
            "handleSize",
            "onResize",
            "onResizeStart",
            "onResizeStop",
            "draggableOpts",
            "minConstraints",
            "maxConstraints",
            "lockAspectRatio",
            "axis",
            "width",
            "height",
            "resizeHandles",
            "style",
            "transformScale"
        ]);
        return /*#__PURE__*/ $3de96de5bedd4cba$var$React.createElement($3de96de5bedd4cba$var$_Resizable.default, {
            axis: axis,
            draggableOpts: draggableOpts,
            handle: handle,
            handleSize: handleSize,
            height: this.state.height,
            lockAspectRatio: lockAspectRatio,
            maxConstraints: maxConstraints,
            minConstraints: minConstraints,
            onResizeStart: onResizeStart,
            onResize: this.onResize,
            onResizeStop: onResizeStop,
            resizeHandles: resizeHandles,
            transformScale: transformScale,
            width: this.state.width
        }, /*#__PURE__*/ $3de96de5bedd4cba$var$React.createElement("div", $3de96de5bedd4cba$var$_extends({}, props, {
            style: $3de96de5bedd4cba$var$_objectSpread($3de96de5bedd4cba$var$_objectSpread({}, style), {}, {
                width: this.state.width + 'px',
                height: this.state.height + 'px'
            })
        })));
    };
    return ResizableBox;
}($3de96de5bedd4cba$var$React.Component);
$3de96de5bedd4cba$export$2e2bcd8739ae039 = $3de96de5bedd4cba$var$ResizableBox;
$3de96de5bedd4cba$var$_defineProperty($3de96de5bedd4cba$var$ResizableBox, "propTypes", $3de96de5bedd4cba$var$_objectSpread($3de96de5bedd4cba$var$_objectSpread({}, $01aMo.resizableProps), {}, {
    children: $3de96de5bedd4cba$var$_propTypes.default.element
}));

});


parcelRegister("jGk5X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.resizeHandleType = module.exports.resizeHandlesType = void 0;

var $e541870b76c6b591$var$_propTypes = $e541870b76c6b591$var$_interopRequireDefault((parcelRequire("fGw9V")));

var $e541870b76c6b591$var$_react = $e541870b76c6b591$var$_interopRequireDefault((parcelRequire("NdCUR")));
function $e541870b76c6b591$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// Defines which resize handles should be rendered (default: 'se')
// Allows for any combination of:
// 's' - South handle (bottom-center)
// 'w' - West handle (left-center)
// 'e' - East handle (right-center)
// 'n' - North handle (top-center)
// 'sw' - Southwest handle (bottom-left)
// 'nw' - Northwest handle (top-left)
// 'se' - Southeast handle (bottom-right)
// 'ne' - Northeast handle (top-right)
var $e541870b76c6b591$var$resizeHandlesType = $e541870b76c6b591$var$_propTypes.default.arrayOf($e541870b76c6b591$var$_propTypes.default.oneOf([
    "s",
    "w",
    "e",
    "n",
    "sw",
    "nw",
    "se",
    "ne"
])); // Custom component for resize handles
module.exports.resizeHandlesType = $e541870b76c6b591$var$resizeHandlesType;
var $e541870b76c6b591$var$resizeHandleType = $e541870b76c6b591$var$_propTypes.default.oneOfType([
    $e541870b76c6b591$var$_propTypes.default.node,
    $e541870b76c6b591$var$_propTypes.default.func
]);
/*:: export type Props = {|
  className: string,
  style: Object,
  width: number,
  autoSize: boolean,
  cols: number,
  draggableCancel: string,
  draggableHandle: string,
  verticalCompact: boolean,
  compactType: CompactType,
  layout: Layout,
  margin: [number, number],
  containerPadding: ?[number, number],
  rowHeight: number,
  maxRows: number,
  isBounded: boolean,
  isDraggable: boolean,
  isResizable: boolean,
  isDroppable: boolean,
  preventCollision: boolean,
  useCSSTransforms: boolean,
  transformScale: number,
  droppingItem: $Shape<LayoutItem>,
  resizeHandles: ResizeHandles,
  resizeHandle?: ResizeHandle,

  // Callbacks
  onLayoutChange: Layout => void,
  onDrag: EventCallback,
  onDragStart: EventCallback,
  onDragStop: EventCallback,
  onResize: EventCallback,
  onResizeStart: EventCallback,
  onResizeStop: EventCallback,
  onDrop: (layout: Layout, item: ?LayoutItem, e: Event) => void,
  children: ReactChildrenArray<ReactElement<any>>,
  innerRef?: Ref<"div">
|};*/ /*:: export type DefaultProps = $Diff<
  Props,
  {
    children: ReactChildrenArray<ReactElement<any>>,
    width: number
  }
>;*/ module.exports.resizeHandleType = $e541870b76c6b591$var$resizeHandleType;

var $e541870b76c6b591$var$_default = {
    //
    // Basic props
    //
    className: $e541870b76c6b591$var$_propTypes.default.string,
    style: $e541870b76c6b591$var$_propTypes.default.object,
    // This can be set explicitly. If it is not set, it will automatically
    // be set to the container width. Note that resizes will *not* cause this to adjust.
    // If you need that behavior, use WidthProvider.
    width: $e541870b76c6b591$var$_propTypes.default.number,
    // If true, the container height swells and contracts to fit contents
    autoSize: $e541870b76c6b591$var$_propTypes.default.bool,
    // # of cols.
    cols: $e541870b76c6b591$var$_propTypes.default.number,
    // A selector that will not be draggable.
    draggableCancel: $e541870b76c6b591$var$_propTypes.default.string,
    // A selector for the draggable handler
    draggableHandle: $e541870b76c6b591$var$_propTypes.default.string,
    // Deprecated
    verticalCompact: function verticalCompact(props) {
        props.verticalCompact;
    },
    // Choose vertical or hotizontal compaction
    compactType: $e541870b76c6b591$var$_propTypes.default.oneOf([
        "vertical",
        "horizontal"
    ]),
    // layout is an array of object with the format:
    // {x: Number, y: Number, w: Number, h: Number, i: String}
    layout: function layout(props) {
        var layout = props.layout; // I hope you're setting the data-grid property on the grid items
        if (layout === undefined) return;
        (parcelRequire("1VByH")).validateLayout(layout, "layout");
    },
    //
    // Grid Dimensions
    //
    // Margin between items [x, y] in px
    margin: $e541870b76c6b591$var$_propTypes.default.arrayOf($e541870b76c6b591$var$_propTypes.default.number),
    // Padding inside the container [x, y] in px
    containerPadding: $e541870b76c6b591$var$_propTypes.default.arrayOf($e541870b76c6b591$var$_propTypes.default.number),
    // Rows have a static height, but you can change this based on breakpoints if you like
    rowHeight: $e541870b76c6b591$var$_propTypes.default.number,
    // Default Infinity, but you can specify a max here if you like.
    // Note that this isn't fully fleshed out and won't error if you specify a layout that
    // extends beyond the row capacity. It will, however, not allow users to drag/resize
    // an item past the barrier. They can push items beyond the barrier, though.
    // Intentionally not documented for this reason.
    maxRows: $e541870b76c6b591$var$_propTypes.default.number,
    //
    // Flags
    //
    isBounded: $e541870b76c6b591$var$_propTypes.default.bool,
    isDraggable: $e541870b76c6b591$var$_propTypes.default.bool,
    isResizable: $e541870b76c6b591$var$_propTypes.default.bool,
    // If true, grid items won't change position when being dragged over.
    preventCollision: $e541870b76c6b591$var$_propTypes.default.bool,
    // Use CSS transforms instead of top/left
    useCSSTransforms: $e541870b76c6b591$var$_propTypes.default.bool,
    // parent layout transform scale
    transformScale: $e541870b76c6b591$var$_propTypes.default.number,
    // If true, an external element can trigger onDrop callback with a specific grid position as a parameter
    isDroppable: $e541870b76c6b591$var$_propTypes.default.bool,
    // Resize handle options
    resizeHandles: $e541870b76c6b591$var$resizeHandlesType,
    resizeHandle: $e541870b76c6b591$var$resizeHandleType,
    //
    // Callbacks
    //
    // Callback so you can save the layout. Calls after each drag & resize stops.
    onLayoutChange: $e541870b76c6b591$var$_propTypes.default.func,
    // Calls when drag starts. Callback is of the signature (layout, oldItem, newItem, placeholder, e, ?node).
    // All callbacks below have the same signature. 'start' and 'stop' callbacks omit the 'placeholder'.
    onDragStart: $e541870b76c6b591$var$_propTypes.default.func,
    // Calls on each drag movement.
    onDrag: $e541870b76c6b591$var$_propTypes.default.func,
    // Calls when drag is complete.
    onDragStop: $e541870b76c6b591$var$_propTypes.default.func,
    //Calls when resize starts.
    onResizeStart: $e541870b76c6b591$var$_propTypes.default.func,
    // Calls when resize movement happens.
    onResize: $e541870b76c6b591$var$_propTypes.default.func,
    // Calls when resize is complete.
    onResizeStop: $e541870b76c6b591$var$_propTypes.default.func,
    // Calls when some element is dropped.
    onDrop: $e541870b76c6b591$var$_propTypes.default.func,
    //
    // Other validations
    //
    droppingItem: $e541870b76c6b591$var$_propTypes.default.shape({
        i: $e541870b76c6b591$var$_propTypes.default.string.isRequired,
        w: $e541870b76c6b591$var$_propTypes.default.number.isRequired,
        h: $e541870b76c6b591$var$_propTypes.default.number.isRequired
    }),
    // Children must not have duplicate keys.
    children: function children(props, propName) {
        var children = props[propName]; // Check children keys for duplicates. Throw if found.
        var keys = {};
        $e541870b76c6b591$var$_react.default.Children.forEach(children, function(child) {
            if (keys[child.key]) throw new Error('Duplicate child key "' + child.key + '" found! This will cause problems in ReactGridLayout.');
            keys[child.key] = true;
        });
    },
    // Optional ref for getting a reference for the wrapping div.
    innerRef: $e541870b76c6b591$var$_propTypes.default.any
};
module.exports.default = $e541870b76c6b591$var$_default;

});



parcelRegister("8bVNH", function(module, exports) {
"use strict";
function $5f6c2fccd14eae7f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $5f6c2fccd14eae7f$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $5f6c2fccd14eae7f$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $5f6c2fccd14eae7f$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5f6c2fccd14eae7f$var$React = $5f6c2fccd14eae7f$var$_interopRequireWildcard((parcelRequire("NdCUR")));

var $5f6c2fccd14eae7f$var$_propTypes = $5f6c2fccd14eae7f$var$_interopRequireDefault((parcelRequire("fGw9V")));

var $5f6c2fccd14eae7f$var$_lodash = $5f6c2fccd14eae7f$var$_interopRequireDefault((parcelRequire("cc5cI")));

var $1VByH = parcelRequire("1VByH");

var $9OLJg = parcelRequire("9OLJg");

var $5f6c2fccd14eae7f$var$_ReactGridLayout = $5f6c2fccd14eae7f$var$_interopRequireDefault((parcelRequire("2qxpy")));
function $5f6c2fccd14eae7f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5f6c2fccd14eae7f$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $5f6c2fccd14eae7f$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $5f6c2fccd14eae7f$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || $5f6c2fccd14eae7f$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $5f6c2fccd14eae7f$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $5f6c2fccd14eae7f$var$_extends() {
    $5f6c2fccd14eae7f$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5f6c2fccd14eae7f$var$_extends.apply(this, arguments);
}
function $5f6c2fccd14eae7f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $5f6c2fccd14eae7f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $5f6c2fccd14eae7f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $5f6c2fccd14eae7f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5f6c2fccd14eae7f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $5f6c2fccd14eae7f$var$ownKeys(Object(source), true).forEach(function(key) {
            $5f6c2fccd14eae7f$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $5f6c2fccd14eae7f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5f6c2fccd14eae7f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5f6c2fccd14eae7f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $5f6c2fccd14eae7f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5f6c2fccd14eae7f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5f6c2fccd14eae7f$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $5f6c2fccd14eae7f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $5f6c2fccd14eae7f$var$_setPrototypeOf(subClass, superClass);
}
function $5f6c2fccd14eae7f$var$_setPrototypeOf(o, p) {
    $5f6c2fccd14eae7f$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $5f6c2fccd14eae7f$var$_setPrototypeOf(o, p);
}
function $5f6c2fccd14eae7f$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5f6c2fccd14eae7f$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $5f6c2fccd14eae7f$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $5f6c2fccd14eae7f$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $5f6c2fccd14eae7f$var$_possibleConstructorReturn(this, result);
    };
}
function $5f6c2fccd14eae7f$var$_possibleConstructorReturn(self, call) {
    if (call && ($5f6c2fccd14eae7f$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $5f6c2fccd14eae7f$var$_assertThisInitialized(self);
}
function $5f6c2fccd14eae7f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $5f6c2fccd14eae7f$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $5f6c2fccd14eae7f$var$_getPrototypeOf(o) {
    $5f6c2fccd14eae7f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $5f6c2fccd14eae7f$var$_getPrototypeOf(o);
}
function $5f6c2fccd14eae7f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $5f6c2fccd14eae7f$var$type = function type(obj) {
    return Object.prototype.toString.call(obj);
};
/**
 * Get a value of margin or containerPadding.
 *
 * @param  {Array | Object} param Margin | containerPadding, e.g. [10, 10] | {lg: [10, 10], ...}.
 * @param  {String} breakpoint   Breakpoint: lg, md, sm, xs and etc.
 * @return {Array}
 */ function $5f6c2fccd14eae7f$var$getIndentationValue(param, breakpoint) /*: T*/ {
    // $FlowIgnore TODO fix this typedef
    if (param == null) return null; // $FlowIgnore TODO fix this typedef
    return Array.isArray(param) ? param : param[breakpoint];
}
/*:: type State = {
  layout: Layout,
  breakpoint: string,
  cols: number,
  layouts?: ResponsiveLayout<string>
};*/ /*:: type Props<Breakpoint: string = string> = {|
  ...React.ElementConfig<typeof ReactGridLayout>,

  // Responsive config
  breakpoint?: ?Breakpoint,
  breakpoints: Breakpoints<Breakpoint>,
  cols: { [key: Breakpoint]: number },
  layouts: ResponsiveLayout<Breakpoint>,
  width: number,
  margin: { [key: Breakpoint]: [number, number] } | [number, number],
  /* prettier-ignore *-/
  containerPadding: { [key: Breakpoint]: ?[number, number] } | ?[number, number],

  // Callbacks
  onBreakpointChange: (Breakpoint, cols: number) => void,
  onLayoutChange: OnLayoutChangeCallback,
  onWidthChange: (
    containerWidth: number,
    margin: [number, number],
    cols: number,
    containerPadding: ?[number, number]
  ) => void
|};*/ /*:: type DefaultProps = Pick<
  Props<>,
  {|
    breakpoints: 0,
    cols: 0,
    containerPadding: 0,
    layouts: 0,
    margin: 0,
    onBreakpointChange: 0,
    onLayoutChange: 0,
    onWidthChange: 0
  |}
>;*/ var $5f6c2fccd14eae7f$var$ResponsiveReactGridLayout = /*#__PURE__*/ function(_React$Component) {
    $5f6c2fccd14eae7f$var$_inherits(ResponsiveReactGridLayout, _React$Component);
    var _super = $5f6c2fccd14eae7f$var$_createSuper(ResponsiveReactGridLayout);
    function ResponsiveReactGridLayout() {
        var _this;
        $5f6c2fccd14eae7f$var$_classCallCheck(this, ResponsiveReactGridLayout);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $5f6c2fccd14eae7f$var$_defineProperty($5f6c2fccd14eae7f$var$_assertThisInitialized(_this), "state", _this.generateInitialState());
        $5f6c2fccd14eae7f$var$_defineProperty($5f6c2fccd14eae7f$var$_assertThisInitialized(_this), "onLayoutChange", function(layout) {
            _this.props.onLayoutChange(layout, $5f6c2fccd14eae7f$var$_objectSpread($5f6c2fccd14eae7f$var$_objectSpread({}, _this.props.layouts), {}, $5f6c2fccd14eae7f$var$_defineProperty({}, _this.state.breakpoint, layout)));
        });
        return _this;
    }
    $5f6c2fccd14eae7f$var$_createClass(ResponsiveReactGridLayout, [
        {
            key: "generateInitialState",
            value: function generateInitialState() /*: State*/ {
                var _this$props = this.props, width = _this$props.width, breakpoints = _this$props.breakpoints, layouts = _this$props.layouts, cols = _this$props.cols;
                var breakpoint = (0, $9OLJg.getBreakpointFromWidth)(breakpoints, width);
                var colNo = (0, $9OLJg.getColsFromBreakpoint)(breakpoint, cols); // verticalCompact compatibility, now deprecated
                var compactType = this.props.verticalCompact === false ? null : this.props.compactType; // Get the initial layout. This can tricky; we try to generate one however possible if one doesn't exist
                // for this layout.
                var initialLayout = (0, $9OLJg.findOrGenerateResponsiveLayout)(layouts, breakpoints, breakpoint, breakpoint, colNo, compactType);
                return {
                    layout: initialLayout,
                    breakpoint: breakpoint,
                    cols: colNo
                };
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                // Allow parent to set width or breakpoint directly.
                if (this.props.width != prevProps.width || this.props.breakpoint !== prevProps.breakpoint || !(0, $5f6c2fccd14eae7f$var$_lodash.default)(this.props.breakpoints, prevProps.breakpoints) || !(0, $5f6c2fccd14eae7f$var$_lodash.default)(this.props.cols, prevProps.cols)) this.onWidthChange(prevProps);
            } // wrap layouts so we do not need to pass layouts to child
        },
        {
            key: "onWidthChange",
            value: /**
     * When the width changes work through breakpoints and reset state with the new width & breakpoint.
     * Width changes are necessary to figure out the widget widths.
     */ function onWidthChange(prevProps) {
                var _this$props2 = this.props, breakpoints = _this$props2.breakpoints, cols = _this$props2.cols, layouts = _this$props2.layouts, compactType = _this$props2.compactType;
                var newBreakpoint = this.props.breakpoint || (0, $9OLJg.getBreakpointFromWidth)(this.props.breakpoints, this.props.width);
                var lastBreakpoint = this.state.breakpoint;
                var newCols = (0, $9OLJg.getColsFromBreakpoint)(newBreakpoint, cols);
                var newLayouts = $5f6c2fccd14eae7f$var$_objectSpread({}, layouts); // Breakpoint change
                if (lastBreakpoint !== newBreakpoint || prevProps.breakpoints !== breakpoints || prevProps.cols !== cols) {
                    // Preserve the current layout if the current breakpoint is not present in the next layouts.
                    if (!(lastBreakpoint in newLayouts)) newLayouts[lastBreakpoint] = (0, $1VByH.cloneLayout)(this.state.layout); // Find or generate a new layout.
                    var layout = (0, $9OLJg.findOrGenerateResponsiveLayout)(newLayouts, breakpoints, newBreakpoint, lastBreakpoint, newCols, compactType); // This adds missing items.
                    layout = (0, $1VByH.synchronizeLayoutWithChildren)(layout, this.props.children, newCols, compactType); // Store the new layout.
                    newLayouts[newBreakpoint] = layout; // callbacks
                    this.props.onLayoutChange(layout, newLayouts);
                    this.props.onBreakpointChange(newBreakpoint, newCols);
                    this.setState({
                        breakpoint: newBreakpoint,
                        layout: layout,
                        cols: newCols
                    });
                }
                var margin = $5f6c2fccd14eae7f$var$getIndentationValue(this.props.margin, newBreakpoint);
                var containerPadding = $5f6c2fccd14eae7f$var$getIndentationValue(this.props.containerPadding, newBreakpoint); //call onWidthChange on every change of width, not only on breakpoint changes
                this.props.onWidthChange(this.props.width, margin, newCols, containerPadding);
            }
        },
        {
            key: "render",
            value: function render() /*: React.Element<typeof ReactGridLayout>*/ {
                /* eslint-disable no-unused-vars */ var _this$props3 = this.props, breakpoint = _this$props3.breakpoint, breakpoints = _this$props3.breakpoints, cols = _this$props3.cols, layouts = _this$props3.layouts, margin = _this$props3.margin, containerPadding = _this$props3.containerPadding, onBreakpointChange = _this$props3.onBreakpointChange, onLayoutChange = _this$props3.onLayoutChange, onWidthChange = _this$props3.onWidthChange, other = $5f6c2fccd14eae7f$var$_objectWithoutProperties(_this$props3, [
                    "breakpoint",
                    "breakpoints",
                    "cols",
                    "layouts",
                    "margin",
                    "containerPadding",
                    "onBreakpointChange",
                    "onLayoutChange",
                    "onWidthChange"
                ]);
                /* eslint-enable no-unused-vars */ return /*#__PURE__*/ $5f6c2fccd14eae7f$var$React.createElement($5f6c2fccd14eae7f$var$_ReactGridLayout.default, $5f6c2fccd14eae7f$var$_extends({}, other, {
                    // $FlowIgnore should allow nullable here due to DefaultProps
                    margin: $5f6c2fccd14eae7f$var$getIndentationValue(margin, this.state.breakpoint),
                    containerPadding: $5f6c2fccd14eae7f$var$getIndentationValue(containerPadding, this.state.breakpoint),
                    onLayoutChange: this.onLayoutChange,
                    layout: this.state.layout,
                    cols: this.state.cols
                }));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) /*: ?$Shape<State>*/ {
                if (!(0, $5f6c2fccd14eae7f$var$_lodash.default)(nextProps.layouts, prevState.layouts)) {
                    // Allow parent to set layouts directly.
                    var breakpoint = prevState.breakpoint, _cols = prevState.cols; // Since we're setting an entirely new layout object, we must generate a new responsive layout
                    // if one does not exist.
                    var newLayout = (0, $9OLJg.findOrGenerateResponsiveLayout)(nextProps.layouts, nextProps.breakpoints, breakpoint, breakpoint, _cols, nextProps.compactType);
                    return {
                        layout: newLayout,
                        layouts: nextProps.layouts
                    };
                }
                return null;
            }
        }
    ]);
    return ResponsiveReactGridLayout;
}($5f6c2fccd14eae7f$var$React.Component);
module.exports.default = $5f6c2fccd14eae7f$var$ResponsiveReactGridLayout;
$5f6c2fccd14eae7f$var$_defineProperty($5f6c2fccd14eae7f$var$ResponsiveReactGridLayout, "propTypes", {
    //
    // Basic props
    //
    // Optional, but if you are managing width yourself you may want to set the breakpoint
    // yourself as well.
    breakpoint: $5f6c2fccd14eae7f$var$_propTypes.default.string,
    // {name: pxVal}, e.g. {lg: 1200, md: 996, sm: 768, xs: 480}
    breakpoints: $5f6c2fccd14eae7f$var$_propTypes.default.object,
    // # of cols. This is a breakpoint -> cols map
    cols: $5f6c2fccd14eae7f$var$_propTypes.default.object,
    // # of margin. This is a breakpoint -> margin map
    // e.g. { lg: [5, 5], md: [10, 10], sm: [15, 15] }
    // Margin between items [x, y] in px
    // e.g. [10, 10]
    margin: $5f6c2fccd14eae7f$var$_propTypes.default.oneOfType([
        $5f6c2fccd14eae7f$var$_propTypes.default.array,
        $5f6c2fccd14eae7f$var$_propTypes.default.object
    ]),
    // # of containerPadding. This is a breakpoint -> containerPadding map
    // e.g. { lg: [5, 5], md: [10, 10], sm: [15, 15] }
    // Padding inside the container [x, y] in px
    // e.g. [10, 10]
    containerPadding: $5f6c2fccd14eae7f$var$_propTypes.default.oneOfType([
        $5f6c2fccd14eae7f$var$_propTypes.default.array,
        $5f6c2fccd14eae7f$var$_propTypes.default.object
    ]),
    // layouts is an object mapping breakpoints to layouts.
    // e.g. {lg: Layout, md: Layout, ...}
    layouts: function layouts(props, propName) {
        if ($5f6c2fccd14eae7f$var$type(props[propName]) !== "[object Object]") throw new Error("Layout property must be an object. Received: " + $5f6c2fccd14eae7f$var$type(props[propName]));
        Object.keys(props[propName]).forEach(function(key) {
            if (!(key in props.breakpoints)) throw new Error("Each key in layouts must align with a key in breakpoints.");
            (0, $1VByH.validateLayout)(props.layouts[key], "layouts." + key);
        });
    },
    // The width of this component.
    // Required in this propTypes stanza because generateInitialState() will fail without it.
    width: $5f6c2fccd14eae7f$var$_propTypes.default.number.isRequired,
    //
    // Callbacks
    //
    // Calls back with breakpoint and new # cols
    onBreakpointChange: $5f6c2fccd14eae7f$var$_propTypes.default.func,
    // Callback so you can save the layout.
    // Calls back with (currentLayout, allLayouts). allLayouts are keyed by breakpoint.
    onLayoutChange: $5f6c2fccd14eae7f$var$_propTypes.default.func,
    // Calls back with (containerWidth, margin, cols, containerPadding)
    onWidthChange: $5f6c2fccd14eae7f$var$_propTypes.default.func
});
$5f6c2fccd14eae7f$var$_defineProperty($5f6c2fccd14eae7f$var$ResponsiveReactGridLayout, "defaultProps", {
    breakpoints: {
        lg: 1200,
        md: 996,
        sm: 768,
        xs: 480,
        xxs: 0
    },
    cols: {
        lg: 12,
        md: 10,
        sm: 6,
        xs: 4,
        xxs: 2
    },
    containerPadding: {
        lg: null,
        md: null,
        sm: null,
        xs: null,
        xxs: null
    },
    layouts: {},
    margin: [
        10,
        10
    ],
    onBreakpointChange: $1VByH.noop,
    onLayoutChange: $1VByH.noop,
    onWidthChange: $1VByH.noop
});

});
parcelRegister("9OLJg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getBreakpointFromWidth = $725dce906abd91d7$var$getBreakpointFromWidth;
module.exports.getColsFromBreakpoint = $725dce906abd91d7$var$getColsFromBreakpoint;
module.exports.findOrGenerateResponsiveLayout = $725dce906abd91d7$var$findOrGenerateResponsiveLayout;
module.exports.sortBreakpoints = $725dce906abd91d7$var$sortBreakpoints;

var $1VByH = parcelRequire("1VByH");
/**
 * Given a width, find the highest breakpoint that matches is valid for it (width > breakpoint).
 *
 * @param  {Object} breakpoints Breakpoints object (e.g. {lg: 1200, md: 960, ...})
 * @param  {Number} width Screen width.
 * @return {String}       Highest breakpoint that is less than width.
 */ function $725dce906abd91d7$var$getBreakpointFromWidth(breakpoints, width) /*: Breakpoint*/ {
    var sorted = $725dce906abd91d7$var$sortBreakpoints(breakpoints);
    var matching = sorted[0];
    for(var i = 1, len = sorted.length; i < len; i++){
        var breakpointName = sorted[i];
        if (width > breakpoints[breakpointName]) matching = breakpointName;
    }
    return matching;
}
/**
 * Given a breakpoint, get the # of cols set for it.
 * @param  {String} breakpoint Breakpoint name.
 * @param  {Object} cols       Map of breakpoints to cols.
 * @return {Number}            Number of cols.
 */ function $725dce906abd91d7$var$getColsFromBreakpoint(breakpoint, cols) /*: number*/ {
    if (!cols[breakpoint]) throw new Error("ResponsiveReactGridLayout: `cols` entry for breakpoint " + breakpoint + " is missing!");
    return cols[breakpoint];
}
/**
 * Given existing layouts and a new breakpoint, find or generate a new layout.
 *
 * This finds the layout above the new one and generates from it, if it exists.
 *
 * @param  {Object} layouts     Existing layouts.
 * @param  {Array} breakpoints All breakpoints.
 * @param  {String} breakpoint New breakpoint.
 * @param  {String} breakpoint Last breakpoint (for fallback).
 * @param  {Number} cols       Column count at new breakpoint.
 * @param  {Boolean} verticalCompact Whether or not to compact the layout
 *   vertically.
 * @return {Array}             New layout.
 */ function $725dce906abd91d7$var$findOrGenerateResponsiveLayout(layouts, breakpoints, breakpoint, lastBreakpoint, cols, compactType) /*: Layout*/ {
    // If it already exists, just return it.
    if (layouts[breakpoint]) return (0, $1VByH.cloneLayout)(layouts[breakpoint]); // Find or generate the next layout
    var layout = layouts[lastBreakpoint];
    var breakpointsSorted = $725dce906abd91d7$var$sortBreakpoints(breakpoints);
    var breakpointsAbove = breakpointsSorted.slice(breakpointsSorted.indexOf(breakpoint));
    for(var i = 0, len = breakpointsAbove.length; i < len; i++){
        var b = breakpointsAbove[i];
        if (layouts[b]) {
            layout = layouts[b];
            break;
        }
    }
    layout = (0, $1VByH.cloneLayout)(layout || []); // clone layout so we don't modify existing items
    return (0, $1VByH.compact)((0, $1VByH.correctBounds)(layout, {
        cols: cols
    }), compactType, cols);
}
/**
 * Given breakpoints, return an array of breakpoints sorted by width. This is usually
 * e.g. ['xxs', 'xs', 'sm', ...]
 *
 * @param  {Object} breakpoints Key/value pair of breakpoint names to widths.
 * @return {Array}              Sorted breakpoints.
 */ function $725dce906abd91d7$var$sortBreakpoints(breakpoints) /*: Array<Breakpoint>*/ {
    var keys = Object.keys(breakpoints);
    return keys.sort(function(a, b) {
        return breakpoints[a] - breakpoints[b];
    });
}

});


parcelRegister("lj1I1", function(module, exports) {
"use strict";
function $f82cb2aef7369f6a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $f82cb2aef7369f6a$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $f82cb2aef7369f6a$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $f82cb2aef7369f6a$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f82cb2aef7369f6a$var$WidthProvider;

var $f82cb2aef7369f6a$var$React = $f82cb2aef7369f6a$var$_interopRequireWildcard((parcelRequire("NdCUR")));

var $f82cb2aef7369f6a$var$_propTypes = $f82cb2aef7369f6a$var$_interopRequireDefault((parcelRequire("fGw9V")));

var $f82cb2aef7369f6a$var$_reactDom = $f82cb2aef7369f6a$var$_interopRequireDefault((parcelRequire("g2wso")));
function $f82cb2aef7369f6a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f82cb2aef7369f6a$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $f82cb2aef7369f6a$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $f82cb2aef7369f6a$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || $f82cb2aef7369f6a$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $f82cb2aef7369f6a$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $f82cb2aef7369f6a$var$_extends() {
    $f82cb2aef7369f6a$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f82cb2aef7369f6a$var$_extends.apply(this, arguments);
}
function $f82cb2aef7369f6a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $f82cb2aef7369f6a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $f82cb2aef7369f6a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $f82cb2aef7369f6a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f82cb2aef7369f6a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f82cb2aef7369f6a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f82cb2aef7369f6a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f82cb2aef7369f6a$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $f82cb2aef7369f6a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $f82cb2aef7369f6a$var$_setPrototypeOf(subClass, superClass);
}
function $f82cb2aef7369f6a$var$_setPrototypeOf(o, p) {
    $f82cb2aef7369f6a$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f82cb2aef7369f6a$var$_setPrototypeOf(o, p);
}
function $f82cb2aef7369f6a$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $f82cb2aef7369f6a$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $f82cb2aef7369f6a$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $f82cb2aef7369f6a$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $f82cb2aef7369f6a$var$_possibleConstructorReturn(this, result);
    };
}
function $f82cb2aef7369f6a$var$_possibleConstructorReturn(self, call) {
    if (call && ($f82cb2aef7369f6a$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $f82cb2aef7369f6a$var$_assertThisInitialized(self);
}
function $f82cb2aef7369f6a$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $f82cb2aef7369f6a$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $f82cb2aef7369f6a$var$_getPrototypeOf(o) {
    $f82cb2aef7369f6a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f82cb2aef7369f6a$var$_getPrototypeOf(o);
}
function $f82cb2aef7369f6a$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/*
 * A simple HOC that provides facility for listening to container resizes.
 *
 * The Flow type is pretty janky here. I can't just spread `WPProps` into this returned object - I wish I could - but it triggers
 * a flow bug of some sort that causes it to stop typechecking.
 */ function $f82cb2aef7369f6a$var$WidthProvider(ComposedComponent) /*: React.AbstractComponent<{|
  ...Config,
  measureBeforeMount?: boolean,
  className?: string,
  style?: Object,
  width?: number
|}>*/ {
    var _class, _temp;
    return _temp = _class = /*#__PURE__*/ function(_React$Component) {
        $f82cb2aef7369f6a$var$_inherits(WidthProvider, _React$Component);
        var _super = $f82cb2aef7369f6a$var$_createSuper(WidthProvider);
        function WidthProvider() {
            var _this;
            $f82cb2aef7369f6a$var$_classCallCheck(this, WidthProvider);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _super.call.apply(_super, [
                this
            ].concat(args));
            $f82cb2aef7369f6a$var$_defineProperty($f82cb2aef7369f6a$var$_assertThisInitialized(_this), "state", {
                width: 1280
            });
            $f82cb2aef7369f6a$var$_defineProperty($f82cb2aef7369f6a$var$_assertThisInitialized(_this), "mounted", false);
            $f82cb2aef7369f6a$var$_defineProperty($f82cb2aef7369f6a$var$_assertThisInitialized(_this), "onWindowResize", function() {
                if (!_this.mounted) return; // eslint-disable-next-line react/no-find-dom-node
                var node = $f82cb2aef7369f6a$var$_reactDom.default.findDOMNode($f82cb2aef7369f6a$var$_assertThisInitialized(_this)); // Flow casts this to Text | Element
                if (node instanceof HTMLElement) _this.setState({
                    width: node.offsetWidth
                });
            });
            return _this;
        }
        $f82cb2aef7369f6a$var$_createClass(WidthProvider, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.mounted = true;
                    window.addEventListener("resize", this.onWindowResize); // Call to properly set the breakpoint and resize the elements.
                    // Note that if you're doing a full-width element, this can get a little wonky if a scrollbar
                    // appears because of the grid. In that case, fire your own resize event, or set `overflow: scroll` on your body.
                    this.onWindowResize();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.mounted = false;
                    window.removeEventListener("resize", this.onWindowResize);
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this$props = this.props, measureBeforeMount = _this$props.measureBeforeMount, rest = $f82cb2aef7369f6a$var$_objectWithoutProperties(_this$props, [
                        "measureBeforeMount"
                    ]);
                    if (measureBeforeMount && !this.mounted) return /*#__PURE__*/ $f82cb2aef7369f6a$var$React.createElement("div", {
                        className: this.props.className,
                        style: this.props.style
                    });
                    return /*#__PURE__*/ $f82cb2aef7369f6a$var$React.createElement(ComposedComponent, $f82cb2aef7369f6a$var$_extends({}, rest, this.state));
                }
            }
        ]);
        return WidthProvider;
    }($f82cb2aef7369f6a$var$React.Component), $f82cb2aef7369f6a$var$_defineProperty(_class, "defaultProps", {
        measureBeforeMount: false
    }), $f82cb2aef7369f6a$var$_defineProperty(_class, "propTypes", {
        // If true, will not render children until mounted. Useful for getting the exact width before
        // rendering, to prevent any unsightly resizing.
        measureBeforeMount: $f82cb2aef7369f6a$var$_propTypes.default.bool
    }), _temp;
}

});

parcelRegister("lyPqm", function(module, exports) {
'use strict';

var $fMgII = parcelRequire("fMgII");

var $9FL18 = parcelRequire("9FL18");

var $eWYrq = parcelRequire("eWYrq");
function $fb24a9b925c4165a$var$compareBuilder(compare) {
    return function factory(value) {
        var fixed = $9FL18(value);
        return function validate(date) {
            var cal = $fMgII.find(value);
            var left = $9FL18(date);
            var right = fixed || cal && cal.getMoment();
            if (!right) return true;
            if (cal) $eWYrq.add(this, cal);
            return compare(left, right);
        };
    };
}
function $fb24a9b925c4165a$var$rangeBuilder(how, compare) {
    return function factory(start, end) {
        var dates;
        var len = arguments.length;
        if (Array.isArray(start)) dates = start;
        else {
            if (len === 1) dates = [
                start
            ];
            else if (len === 2) dates = [
                [
                    start,
                    end
                ]
            ];
        }
        return function validate(date) {
            return dates.map(expand.bind(this))[how](compare.bind(this, date));
        };
        function expand(value) {
            var start, end;
            var cal = $fMgII.find(value);
            if (cal) start = end = cal.getMoment();
            else if (Array.isArray(value)) {
                start = value[0];
                end = value[1];
            } else start = end = value;
            if (cal) $eWYrq.add(cal, this);
            return {
                start: $9FL18(start).startOf('day').toDate(),
                end: $9FL18(end).endOf('day').toDate()
            };
        }
    };
}
var $fb24a9b925c4165a$var$afterEq = $fb24a9b925c4165a$var$compareBuilder(function(left, right) {
    return left >= right;
});
var $fb24a9b925c4165a$var$after = $fb24a9b925c4165a$var$compareBuilder(function(left, right) {
    return left > right;
});
var $fb24a9b925c4165a$var$beforeEq = $fb24a9b925c4165a$var$compareBuilder(function(left, right) {
    return left <= right;
});
var $fb24a9b925c4165a$var$before = $fb24a9b925c4165a$var$compareBuilder(function(left, right) {
    return left < right;
});
var $fb24a9b925c4165a$var$except = $fb24a9b925c4165a$var$rangeBuilder('every', function(left, right) {
    return right.start > left || right.end < left;
});
var $fb24a9b925c4165a$var$only = $fb24a9b925c4165a$var$rangeBuilder('some', function(left, right) {
    return right.start <= left && right.end >= left;
});
module.exports = {
    afterEq: $fb24a9b925c4165a$var$afterEq,
    after: $fb24a9b925c4165a$var$after,
    beforeEq: $fb24a9b925c4165a$var$beforeEq,
    before: $fb24a9b925c4165a$var$before,
    except: $fb24a9b925c4165a$var$except,
    only: $fb24a9b925c4165a$var$only
};

});
parcelRegister("fMgII", function(module, exports) {
'use strict';
var $b7c84efe381817c3$var$no;
var $b7c84efe381817c3$var$ikey = 'data-rome-id';
var $b7c84efe381817c3$var$index = [];
function $b7c84efe381817c3$var$find(thing) {
    if (typeof thing !== 'number' && thing && thing.getAttribute) return $b7c84efe381817c3$var$find(thing.getAttribute($b7c84efe381817c3$var$ikey));
    var existing = $b7c84efe381817c3$var$index[thing];
    if (existing !== $b7c84efe381817c3$var$no) return existing;
    return null;
}
function $b7c84efe381817c3$var$assign(elem, instance) {
    elem.setAttribute($b7c84efe381817c3$var$ikey, instance.id = $b7c84efe381817c3$var$index.push(instance) - 1);
}
module.exports = {
    find: $b7c84efe381817c3$var$find,
    assign: $b7c84efe381817c3$var$assign
};

});

parcelRegister("9FL18", function(module, exports) {
'use strict';

var $k0LC7 = parcelRequire("k0LC7");
function $70ac6a0c52f7e92d$var$raw(date, format) {
    if (typeof date === 'string') return $k0LC7.moment(date, format);
    if (Object.prototype.toString.call(date) === '[object Date]') return $k0LC7.moment(date);
    if ($k0LC7.isMoment(date)) return date.clone();
}
function $70ac6a0c52f7e92d$var$parse(date, format) {
    var m = $70ac6a0c52f7e92d$var$raw(date, typeof format === 'string' ? format : null);
    return m && m.isValid() ? m : null;
}
module.exports = $70ac6a0c52f7e92d$var$parse;

});
parcelRegister("k0LC7", function(module, exports) {
'use strict';
function $e918bddc64932362$var$isMoment(value) {
    return value && Object.prototype.hasOwnProperty.call(value, '_isAMomentObject');
}
var $e918bddc64932362$var$api = {
    moment: null,
    isMoment: $e918bddc64932362$var$isMoment
};
module.exports = $e918bddc64932362$var$api;

});


parcelRegister("eWYrq", function(module, exports) {
'use strict';

var $gBEl8 = parcelRequire("gBEl8");
var $ae255dd65c17de7c$var$bindings = {};
function $ae255dd65c17de7c$var$has(source, target) {
    var binding = $ae255dd65c17de7c$var$bindings[source.id];
    return binding && binding[target.id];
}
function $ae255dd65c17de7c$var$insert(source, target) {
    var binding = $ae255dd65c17de7c$var$bindings[source.id];
    if (!binding) binding = $ae255dd65c17de7c$var$bindings[source.id] = {};
    var invalidate = $ae255dd65c17de7c$var$invalidator(target);
    binding[target.id] = invalidate;
    source.on('data', invalidate);
    source.on('destroyed', $ae255dd65c17de7c$var$remove.bind(null, source, target));
}
function $ae255dd65c17de7c$var$remove(source, target) {
    var binding = $ae255dd65c17de7c$var$bindings[source.id];
    if (!binding) return;
    var invalidate = binding[target.id];
    source.off('data', invalidate);
    delete binding[target.id];
}
function $ae255dd65c17de7c$var$invalidator(target) {
    return function invalidate() {
        target.refresh();
    };
}
function $ae255dd65c17de7c$var$add(source, target) {
    if ($gBEl8(target.associated) || $ae255dd65c17de7c$var$has(source, target)) return;
    $ae255dd65c17de7c$var$insert(source, target);
}
module.exports = {
    add: $ae255dd65c17de7c$var$add,
    remove: $ae255dd65c17de7c$var$remove
};

});
parcelRegister("gBEl8", function(module, exports) {
'use strict';
function $c16f64b605e19874$var$isInput(elem) {
    return elem && elem.nodeName && elem.nodeName.toLowerCase() === 'input';
}
module.exports = $c16f64b605e19874$var$isInput;

});



parcelRegister("gmCTX", function(module, exports) {
/**
 * @license
 *
 * chroma.js - JavaScript library for color conversions
 * 
 * Copyright (c) 2011-2017, Gregor Aisch
 * All rights reserved.
 * 
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 * 
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 * 
 * 3. The name Gregor Aisch may not be used to endorse or promote products
 *    derived from this software without specific prior written permission.
 * 
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL GREGOR AISCH OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 * INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
 * OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 * EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 */ (function() {
    var Color, DEG2RAD, LAB_CONSTANTS, PI, PITHIRD, RAD2DEG, TWOPI, _average_lrgb, _guess_formats, _guess_formats_sorted, _input, _interpolators, abs, atan2, bezier, blend, blend_f, brewer, burn, chroma, clip_rgb, cmyk2rgb, colors, cos, css2rgb, darken, dodge, each, floor, hcg2rgb, hex2rgb, hsi2rgb, hsl2css, hsl2rgb, hsv2rgb, interpolate, interpolate_hsx, interpolate_lab, interpolate_lrgb, interpolate_num, interpolate_rgb, lab2lch, lab2rgb, lab_xyz, lch2lab, lch2rgb, lighten, limit, log, luminance_x, m, max, multiply, normal, num2rgb, overlay, pow, rgb2cmyk, rgb2css, rgb2hcg, rgb2hex, rgb2hsi, rgb2hsl, rgb2hsv, rgb2lab, rgb2lch, rgb2luminance, rgb2num, rgb2temperature, rgb2xyz, rgb_xyz, rnd, root, round, screen, sin, sqrt, temperature2rgb, type, unpack, w3cx11, xyz_lab, xyz_rgb, slice = [].slice;
    type = function() {
        /*
    for browser-safe type checking+
    ported from jQuery's $.type
     */ var classToType, len, name, o, ref;
        classToType = {};
        ref = "Boolean Number String Function Array Date RegExp Undefined Null".split(" ");
        for(o = 0, len = ref.length; o < len; o++){
            name = ref[o];
            classToType["[object " + name + "]"] = name.toLowerCase();
        }
        return function(obj) {
            var strType;
            strType = Object.prototype.toString.call(obj);
            return classToType[strType] || "object";
        };
    }();
    limit = function(x, min, max) {
        if (min == null) min = 0;
        if (max == null) max = 1;
        if (x < min) x = min;
        if (x > max) x = max;
        return x;
    };
    unpack = function(args) {
        if (args.length >= 3) return Array.prototype.slice.call(args);
        else return args[0];
    };
    clip_rgb = function(rgb) {
        var i, o;
        rgb._clipped = false;
        rgb._unclipped = rgb.slice(0);
        for(i = o = 0; o < 3; i = ++o){
            if (i < 3) {
                if (rgb[i] < 0 || rgb[i] > 255) rgb._clipped = true;
                if (rgb[i] < 0) rgb[i] = 0;
                if (rgb[i] > 255) rgb[i] = 255;
            } else if (i === 3) {
                if (rgb[i] < 0) rgb[i] = 0;
                if (rgb[i] > 1) rgb[i] = 1;
            }
        }
        if (!rgb._clipped) delete rgb._unclipped;
        return rgb;
    };
    PI = Math.PI, round = Math.round, cos = Math.cos, floor = Math.floor, pow = Math.pow, log = Math.log, sin = Math.sin, sqrt = Math.sqrt, atan2 = Math.atan2, max = Math.max, abs = Math.abs;
    TWOPI = PI * 2;
    PITHIRD = PI / 3;
    DEG2RAD = PI / 180;
    RAD2DEG = 180 / PI;
    chroma = function() {
        if (arguments[0] instanceof Color) return arguments[0];
        return function(func, args, ctor) {
            ctor.prototype = func.prototype;
            var child = new ctor, result = func.apply(child, args);
            return Object(result) === result ? result : child;
        }(Color, arguments, function() {});
    };
    chroma["default"] = chroma;
    _interpolators = [];
    if (module !== null && module.exports != null) module.exports = chroma;
    if (typeof define === 'function' && define.amd) define([], function() {
        return chroma;
    });
    else {
        root = exports !== null ? exports : this;
        root.chroma = chroma;
    }
    chroma.version = '1.4.1';
    _input = {};
    _guess_formats = [];
    _guess_formats_sorted = false;
    Color = function() {
        function Color() {
            var arg, args, chk, len, len1, me, mode, o, w;
            me = this;
            args = [];
            for(o = 0, len = arguments.length; o < len; o++){
                arg = arguments[o];
                if (arg != null) args.push(arg);
            }
            if (args.length > 1) mode = args[args.length - 1];
            if (_input[mode] != null) me._rgb = clip_rgb(_input[mode](unpack(args.slice(0, -1))));
            else {
                if (!_guess_formats_sorted) {
                    _guess_formats = _guess_formats.sort(function(a, b) {
                        return b.p - a.p;
                    });
                    _guess_formats_sorted = true;
                }
                for(w = 0, len1 = _guess_formats.length; w < len1; w++){
                    chk = _guess_formats[w];
                    mode = chk.test.apply(chk, args);
                    if (mode) break;
                }
                if (mode) me._rgb = clip_rgb(_input[mode].apply(_input, args));
            }
            if (me._rgb == null) console.warn('unknown format: ' + args);
            if (me._rgb == null) me._rgb = [
                0,
                0,
                0
            ];
            if (me._rgb.length === 3) me._rgb.push(1);
        }
        Color.prototype.toString = function() {
            return this.hex();
        };
        return Color;
    }();
    chroma._input = _input;
    /**
  	ColorBrewer colors for chroma.js
  
  	Copyright (c) 2002 Cynthia Brewer, Mark Harrower, and The 
  	Pennsylvania State University.
  
  	Licensed under the Apache License, Version 2.0 (the "License"); 
  	you may not use this file except in compliance with the License.
  	You may obtain a copy of the License at	
  	http://www.apache.org/licenses/LICENSE-2.0
  
  	Unless required by applicable law or agreed to in writing, software distributed
  	under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
  	CONDITIONS OF ANY KIND, either express or implied. See the License for the
  	specific language governing permissions and limitations under the License.
  
      @preserve
   */ chroma.brewer = brewer = {
        OrRd: [
            '#fff7ec',
            '#fee8c8',
            '#fdd49e',
            '#fdbb84',
            '#fc8d59',
            '#ef6548',
            '#d7301f',
            '#b30000',
            '#7f0000'
        ],
        PuBu: [
            '#fff7fb',
            '#ece7f2',
            '#d0d1e6',
            '#a6bddb',
            '#74a9cf',
            '#3690c0',
            '#0570b0',
            '#045a8d',
            '#023858'
        ],
        BuPu: [
            '#f7fcfd',
            '#e0ecf4',
            '#bfd3e6',
            '#9ebcda',
            '#8c96c6',
            '#8c6bb1',
            '#88419d',
            '#810f7c',
            '#4d004b'
        ],
        Oranges: [
            '#fff5eb',
            '#fee6ce',
            '#fdd0a2',
            '#fdae6b',
            '#fd8d3c',
            '#f16913',
            '#d94801',
            '#a63603',
            '#7f2704'
        ],
        BuGn: [
            '#f7fcfd',
            '#e5f5f9',
            '#ccece6',
            '#99d8c9',
            '#66c2a4',
            '#41ae76',
            '#238b45',
            '#006d2c',
            '#00441b'
        ],
        YlOrBr: [
            '#ffffe5',
            '#fff7bc',
            '#fee391',
            '#fec44f',
            '#fe9929',
            '#ec7014',
            '#cc4c02',
            '#993404',
            '#662506'
        ],
        YlGn: [
            '#ffffe5',
            '#f7fcb9',
            '#d9f0a3',
            '#addd8e',
            '#78c679',
            '#41ab5d',
            '#238443',
            '#006837',
            '#004529'
        ],
        Reds: [
            '#fff5f0',
            '#fee0d2',
            '#fcbba1',
            '#fc9272',
            '#fb6a4a',
            '#ef3b2c',
            '#cb181d',
            '#a50f15',
            '#67000d'
        ],
        RdPu: [
            '#fff7f3',
            '#fde0dd',
            '#fcc5c0',
            '#fa9fb5',
            '#f768a1',
            '#dd3497',
            '#ae017e',
            '#7a0177',
            '#49006a'
        ],
        Greens: [
            '#f7fcf5',
            '#e5f5e0',
            '#c7e9c0',
            '#a1d99b',
            '#74c476',
            '#41ab5d',
            '#238b45',
            '#006d2c',
            '#00441b'
        ],
        YlGnBu: [
            '#ffffd9',
            '#edf8b1',
            '#c7e9b4',
            '#7fcdbb',
            '#41b6c4',
            '#1d91c0',
            '#225ea8',
            '#253494',
            '#081d58'
        ],
        Purples: [
            '#fcfbfd',
            '#efedf5',
            '#dadaeb',
            '#bcbddc',
            '#9e9ac8',
            '#807dba',
            '#6a51a3',
            '#54278f',
            '#3f007d'
        ],
        GnBu: [
            '#f7fcf0',
            '#e0f3db',
            '#ccebc5',
            '#a8ddb5',
            '#7bccc4',
            '#4eb3d3',
            '#2b8cbe',
            '#0868ac',
            '#084081'
        ],
        Greys: [
            '#ffffff',
            '#f0f0f0',
            '#d9d9d9',
            '#bdbdbd',
            '#969696',
            '#737373',
            '#525252',
            '#252525',
            '#000000'
        ],
        YlOrRd: [
            '#ffffcc',
            '#ffeda0',
            '#fed976',
            '#feb24c',
            '#fd8d3c',
            '#fc4e2a',
            '#e31a1c',
            '#bd0026',
            '#800026'
        ],
        PuRd: [
            '#f7f4f9',
            '#e7e1ef',
            '#d4b9da',
            '#c994c7',
            '#df65b0',
            '#e7298a',
            '#ce1256',
            '#980043',
            '#67001f'
        ],
        Blues: [
            '#f7fbff',
            '#deebf7',
            '#c6dbef',
            '#9ecae1',
            '#6baed6',
            '#4292c6',
            '#2171b5',
            '#08519c',
            '#08306b'
        ],
        PuBuGn: [
            '#fff7fb',
            '#ece2f0',
            '#d0d1e6',
            '#a6bddb',
            '#67a9cf',
            '#3690c0',
            '#02818a',
            '#016c59',
            '#014636'
        ],
        Viridis: [
            '#440154',
            '#482777',
            '#3f4a8a',
            '#31678e',
            '#26838f',
            '#1f9d8a',
            '#6cce5a',
            '#b6de2b',
            '#fee825'
        ],
        Spectral: [
            '#9e0142',
            '#d53e4f',
            '#f46d43',
            '#fdae61',
            '#fee08b',
            '#ffffbf',
            '#e6f598',
            '#abdda4',
            '#66c2a5',
            '#3288bd',
            '#5e4fa2'
        ],
        RdYlGn: [
            '#a50026',
            '#d73027',
            '#f46d43',
            '#fdae61',
            '#fee08b',
            '#ffffbf',
            '#d9ef8b',
            '#a6d96a',
            '#66bd63',
            '#1a9850',
            '#006837'
        ],
        RdBu: [
            '#67001f',
            '#b2182b',
            '#d6604d',
            '#f4a582',
            '#fddbc7',
            '#f7f7f7',
            '#d1e5f0',
            '#92c5de',
            '#4393c3',
            '#2166ac',
            '#053061'
        ],
        PiYG: [
            '#8e0152',
            '#c51b7d',
            '#de77ae',
            '#f1b6da',
            '#fde0ef',
            '#f7f7f7',
            '#e6f5d0',
            '#b8e186',
            '#7fbc41',
            '#4d9221',
            '#276419'
        ],
        PRGn: [
            '#40004b',
            '#762a83',
            '#9970ab',
            '#c2a5cf',
            '#e7d4e8',
            '#f7f7f7',
            '#d9f0d3',
            '#a6dba0',
            '#5aae61',
            '#1b7837',
            '#00441b'
        ],
        RdYlBu: [
            '#a50026',
            '#d73027',
            '#f46d43',
            '#fdae61',
            '#fee090',
            '#ffffbf',
            '#e0f3f8',
            '#abd9e9',
            '#74add1',
            '#4575b4',
            '#313695'
        ],
        BrBG: [
            '#543005',
            '#8c510a',
            '#bf812d',
            '#dfc27d',
            '#f6e8c3',
            '#f5f5f5',
            '#c7eae5',
            '#80cdc1',
            '#35978f',
            '#01665e',
            '#003c30'
        ],
        RdGy: [
            '#67001f',
            '#b2182b',
            '#d6604d',
            '#f4a582',
            '#fddbc7',
            '#ffffff',
            '#e0e0e0',
            '#bababa',
            '#878787',
            '#4d4d4d',
            '#1a1a1a'
        ],
        PuOr: [
            '#7f3b08',
            '#b35806',
            '#e08214',
            '#fdb863',
            '#fee0b6',
            '#f7f7f7',
            '#d8daeb',
            '#b2abd2',
            '#8073ac',
            '#542788',
            '#2d004b'
        ],
        Set2: [
            '#66c2a5',
            '#fc8d62',
            '#8da0cb',
            '#e78ac3',
            '#a6d854',
            '#ffd92f',
            '#e5c494',
            '#b3b3b3'
        ],
        Accent: [
            '#7fc97f',
            '#beaed4',
            '#fdc086',
            '#ffff99',
            '#386cb0',
            '#f0027f',
            '#bf5b17',
            '#666666'
        ],
        Set1: [
            '#e41a1c',
            '#377eb8',
            '#4daf4a',
            '#984ea3',
            '#ff7f00',
            '#ffff33',
            '#a65628',
            '#f781bf',
            '#999999'
        ],
        Set3: [
            '#8dd3c7',
            '#ffffb3',
            '#bebada',
            '#fb8072',
            '#80b1d3',
            '#fdb462',
            '#b3de69',
            '#fccde5',
            '#d9d9d9',
            '#bc80bd',
            '#ccebc5',
            '#ffed6f'
        ],
        Dark2: [
            '#1b9e77',
            '#d95f02',
            '#7570b3',
            '#e7298a',
            '#66a61e',
            '#e6ab02',
            '#a6761d',
            '#666666'
        ],
        Paired: [
            '#a6cee3',
            '#1f78b4',
            '#b2df8a',
            '#33a02c',
            '#fb9a99',
            '#e31a1c',
            '#fdbf6f',
            '#ff7f00',
            '#cab2d6',
            '#6a3d9a',
            '#ffff99',
            '#b15928'
        ],
        Pastel2: [
            '#b3e2cd',
            '#fdcdac',
            '#cbd5e8',
            '#f4cae4',
            '#e6f5c9',
            '#fff2ae',
            '#f1e2cc',
            '#cccccc'
        ],
        Pastel1: [
            '#fbb4ae',
            '#b3cde3',
            '#ccebc5',
            '#decbe4',
            '#fed9a6',
            '#ffffcc',
            '#e5d8bd',
            '#fddaec',
            '#f2f2f2'
        ]
    };
    (function() {
        var key, results;
        results = [];
        for(key in brewer)results.push(brewer[key.toLowerCase()] = brewer[key]);
        return results;
    })();
    /**
  	X11 color names
  
  	http://www.w3.org/TR/css3-color/#svg-color
   */ w3cx11 = {
        aliceblue: '#f0f8ff',
        antiquewhite: '#faebd7',
        aqua: '#00ffff',
        aquamarine: '#7fffd4',
        azure: '#f0ffff',
        beige: '#f5f5dc',
        bisque: '#ffe4c4',
        black: '#000000',
        blanchedalmond: '#ffebcd',
        blue: '#0000ff',
        blueviolet: '#8a2be2',
        brown: '#a52a2a',
        burlywood: '#deb887',
        cadetblue: '#5f9ea0',
        chartreuse: '#7fff00',
        chocolate: '#d2691e',
        coral: '#ff7f50',
        cornflower: '#6495ed',
        cornflowerblue: '#6495ed',
        cornsilk: '#fff8dc',
        crimson: '#dc143c',
        cyan: '#00ffff',
        darkblue: '#00008b',
        darkcyan: '#008b8b',
        darkgoldenrod: '#b8860b',
        darkgray: '#a9a9a9',
        darkgreen: '#006400',
        darkgrey: '#a9a9a9',
        darkkhaki: '#bdb76b',
        darkmagenta: '#8b008b',
        darkolivegreen: '#556b2f',
        darkorange: '#ff8c00',
        darkorchid: '#9932cc',
        darkred: '#8b0000',
        darksalmon: '#e9967a',
        darkseagreen: '#8fbc8f',
        darkslateblue: '#483d8b',
        darkslategray: '#2f4f4f',
        darkslategrey: '#2f4f4f',
        darkturquoise: '#00ced1',
        darkviolet: '#9400d3',
        deeppink: '#ff1493',
        deepskyblue: '#00bfff',
        dimgray: '#696969',
        dimgrey: '#696969',
        dodgerblue: '#1e90ff',
        firebrick: '#b22222',
        floralwhite: '#fffaf0',
        forestgreen: '#228b22',
        fuchsia: '#ff00ff',
        gainsboro: '#dcdcdc',
        ghostwhite: '#f8f8ff',
        gold: '#ffd700',
        goldenrod: '#daa520',
        gray: '#808080',
        green: '#008000',
        greenyellow: '#adff2f',
        grey: '#808080',
        honeydew: '#f0fff0',
        hotpink: '#ff69b4',
        indianred: '#cd5c5c',
        indigo: '#4b0082',
        ivory: '#fffff0',
        khaki: '#f0e68c',
        laserlemon: '#ffff54',
        lavender: '#e6e6fa',
        lavenderblush: '#fff0f5',
        lawngreen: '#7cfc00',
        lemonchiffon: '#fffacd',
        lightblue: '#add8e6',
        lightcoral: '#f08080',
        lightcyan: '#e0ffff',
        lightgoldenrod: '#fafad2',
        lightgoldenrodyellow: '#fafad2',
        lightgray: '#d3d3d3',
        lightgreen: '#90ee90',
        lightgrey: '#d3d3d3',
        lightpink: '#ffb6c1',
        lightsalmon: '#ffa07a',
        lightseagreen: '#20b2aa',
        lightskyblue: '#87cefa',
        lightslategray: '#778899',
        lightslategrey: '#778899',
        lightsteelblue: '#b0c4de',
        lightyellow: '#ffffe0',
        lime: '#00ff00',
        limegreen: '#32cd32',
        linen: '#faf0e6',
        magenta: '#ff00ff',
        maroon: '#800000',
        maroon2: '#7f0000',
        maroon3: '#b03060',
        mediumaquamarine: '#66cdaa',
        mediumblue: '#0000cd',
        mediumorchid: '#ba55d3',
        mediumpurple: '#9370db',
        mediumseagreen: '#3cb371',
        mediumslateblue: '#7b68ee',
        mediumspringgreen: '#00fa9a',
        mediumturquoise: '#48d1cc',
        mediumvioletred: '#c71585',
        midnightblue: '#191970',
        mintcream: '#f5fffa',
        mistyrose: '#ffe4e1',
        moccasin: '#ffe4b5',
        navajowhite: '#ffdead',
        navy: '#000080',
        oldlace: '#fdf5e6',
        olive: '#808000',
        olivedrab: '#6b8e23',
        orange: '#ffa500',
        orangered: '#ff4500',
        orchid: '#da70d6',
        palegoldenrod: '#eee8aa',
        palegreen: '#98fb98',
        paleturquoise: '#afeeee',
        palevioletred: '#db7093',
        papayawhip: '#ffefd5',
        peachpuff: '#ffdab9',
        peru: '#cd853f',
        pink: '#ffc0cb',
        plum: '#dda0dd',
        powderblue: '#b0e0e6',
        purple: '#800080',
        purple2: '#7f007f',
        purple3: '#a020f0',
        rebeccapurple: '#663399',
        red: '#ff0000',
        rosybrown: '#bc8f8f',
        royalblue: '#4169e1',
        saddlebrown: '#8b4513',
        salmon: '#fa8072',
        sandybrown: '#f4a460',
        seagreen: '#2e8b57',
        seashell: '#fff5ee',
        sienna: '#a0522d',
        silver: '#c0c0c0',
        skyblue: '#87ceeb',
        slateblue: '#6a5acd',
        slategray: '#708090',
        slategrey: '#708090',
        snow: '#fffafa',
        springgreen: '#00ff7f',
        steelblue: '#4682b4',
        tan: '#d2b48c',
        teal: '#008080',
        thistle: '#d8bfd8',
        tomato: '#ff6347',
        turquoise: '#40e0d0',
        violet: '#ee82ee',
        wheat: '#f5deb3',
        white: '#ffffff',
        whitesmoke: '#f5f5f5',
        yellow: '#ffff00',
        yellowgreen: '#9acd32'
    };
    chroma.colors = colors = w3cx11;
    lab2rgb = function() {
        var a, args, b, g, l, r, x, y, z;
        args = unpack(arguments);
        l = args[0], a = args[1], b = args[2];
        y = (l + 16) / 116;
        x = isNaN(a) ? y : y + a / 500;
        z = isNaN(b) ? y : y - b / 200;
        y = LAB_CONSTANTS.Yn * lab_xyz(y);
        x = LAB_CONSTANTS.Xn * lab_xyz(x);
        z = LAB_CONSTANTS.Zn * lab_xyz(z);
        r = xyz_rgb(3.2404542 * x - 1.5371385 * y - 0.4985314 * z);
        g = xyz_rgb(-0.969266 * x + 1.8760108 * y + 0.0415560 * z);
        b = xyz_rgb(0.0556434 * x - 0.2040259 * y + 1.0572252 * z);
        return [
            r,
            g,
            b,
            args.length > 3 ? args[3] : 1
        ];
    };
    xyz_rgb = function(r) {
        return 255 * (r <= 0.00304 ? 12.92 * r : 1.055 * pow(r, 1 / 2.4) - 0.055);
    };
    lab_xyz = function(t) {
        if (t > LAB_CONSTANTS.t1) return t * t * t;
        else return LAB_CONSTANTS.t2 * (t - LAB_CONSTANTS.t0);
    };
    LAB_CONSTANTS = {
        Kn: 18,
        Xn: 0.950470,
        Yn: 1,
        Zn: 1.088830,
        t0: 0.137931034,
        t1: 0.206896552,
        t2: 0.12841855,
        t3: 0.008856452
    };
    rgb2lab = function() {
        var b, g, r, ref, ref1, x, y, z;
        ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
        ref1 = rgb2xyz(r, g, b), x = ref1[0], y = ref1[1], z = ref1[2];
        return [
            116 * y - 16,
            500 * (x - y),
            200 * (y - z)
        ];
    };
    rgb_xyz = function(r) {
        if ((r /= 255) <= 0.04045) return r / 12.92;
        else return pow((r + 0.055) / 1.055, 2.4);
    };
    xyz_lab = function(t) {
        if (t > LAB_CONSTANTS.t3) return pow(t, 1 / 3);
        else return t / LAB_CONSTANTS.t2 + LAB_CONSTANTS.t0;
    };
    rgb2xyz = function() {
        var b, g, r, ref, x, y, z;
        ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
        r = rgb_xyz(r);
        g = rgb_xyz(g);
        b = rgb_xyz(b);
        x = xyz_lab((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / LAB_CONSTANTS.Xn);
        y = xyz_lab((0.2126729 * r + 0.7151522 * g + 0.0721750 * b) / LAB_CONSTANTS.Yn);
        z = xyz_lab((0.0193339 * r + 0.1191920 * g + 0.9503041 * b) / LAB_CONSTANTS.Zn);
        return [
            x,
            y,
            z
        ];
    };
    chroma.lab = function() {
        return function(func, args, ctor) {
            ctor.prototype = func.prototype;
            var child = new ctor, result = func.apply(child, args);
            return Object(result) === result ? result : child;
        }(Color, slice.call(arguments).concat([
            'lab'
        ]), function() {});
    };
    _input.lab = lab2rgb;
    Color.prototype.lab = function() {
        return rgb2lab(this._rgb);
    };
    bezier = function(colors) {
        var I, I0, I1, c, lab0, lab1, lab2, lab3, ref, ref1, ref2;
        colors = function() {
            var len, o, results;
            results = [];
            for(o = 0, len = colors.length; o < len; o++){
                c = colors[o];
                results.push(chroma(c));
            }
            return results;
        }();
        if (colors.length === 2) {
            ref = function() {
                var len, o, results;
                results = [];
                for(o = 0, len = colors.length; o < len; o++){
                    c = colors[o];
                    results.push(c.lab());
                }
                return results;
            }(), lab0 = ref[0], lab1 = ref[1];
            I = function(t) {
                var i, lab;
                lab = function() {
                    var o, results;
                    results = [];
                    for(i = o = 0; o <= 2; i = ++o)results.push(lab0[i] + t * (lab1[i] - lab0[i]));
                    return results;
                }();
                return chroma.lab.apply(chroma, lab);
            };
        } else if (colors.length === 3) {
            ref1 = function() {
                var len, o, results;
                results = [];
                for(o = 0, len = colors.length; o < len; o++){
                    c = colors[o];
                    results.push(c.lab());
                }
                return results;
            }(), lab0 = ref1[0], lab1 = ref1[1], lab2 = ref1[2];
            I = function(t) {
                var i, lab;
                lab = function() {
                    var o, results;
                    results = [];
                    for(i = o = 0; o <= 2; i = ++o)results.push((1 - t) * (1 - t) * lab0[i] + 2 * (1 - t) * t * lab1[i] + t * t * lab2[i]);
                    return results;
                }();
                return chroma.lab.apply(chroma, lab);
            };
        } else if (colors.length === 4) {
            ref2 = function() {
                var len, o, results;
                results = [];
                for(o = 0, len = colors.length; o < len; o++){
                    c = colors[o];
                    results.push(c.lab());
                }
                return results;
            }(), lab0 = ref2[0], lab1 = ref2[1], lab2 = ref2[2], lab3 = ref2[3];
            I = function(t) {
                var i, lab;
                lab = function() {
                    var o, results;
                    results = [];
                    for(i = o = 0; o <= 2; i = ++o)results.push((1 - t) * (1 - t) * (1 - t) * lab0[i] + 3 * (1 - t) * (1 - t) * t * lab1[i] + 3 * (1 - t) * t * t * lab2[i] + t * t * t * lab3[i]);
                    return results;
                }();
                return chroma.lab.apply(chroma, lab);
            };
        } else if (colors.length === 5) {
            I0 = bezier(colors.slice(0, 3));
            I1 = bezier(colors.slice(2, 5));
            I = function(t) {
                if (t < 0.5) return I0(t * 2);
                else return I1((t - 0.5) * 2);
            };
        }
        return I;
    };
    chroma.bezier = function(colors) {
        var f;
        f = bezier(colors);
        f.scale = function() {
            return chroma.scale(f);
        };
        return f;
    };
    chroma.cubehelix = function(start, rotations, hue, gamma, lightness) {
        var dh, dl, f;
        if (start == null) start = 300;
        if (rotations == null) rotations = -1.5;
        if (hue == null) hue = 1;
        if (gamma == null) gamma = 1;
        if (lightness == null) lightness = [
            0,
            1
        ];
        dh = 0;
        if (type(lightness) === 'array') dl = lightness[1] - lightness[0];
        else {
            dl = 0;
            lightness = [
                lightness,
                lightness
            ];
        }
        f = function(fract) {
            var a, amp, b, cos_a, g, h, l, r, sin_a;
            a = TWOPI * ((start + 120) / 360 + rotations * fract);
            l = pow(lightness[0] + dl * fract, gamma);
            h = dh !== 0 ? hue[0] + fract * dh : hue;
            amp = h * l * (1 - l) / 2;
            cos_a = cos(a);
            sin_a = sin(a);
            r = l + amp * (-0.14861 * cos_a + 1.78277 * sin_a);
            g = l + amp * (-0.29227 * cos_a - 0.90649 * sin_a);
            b = l + amp * (1.97294 * cos_a);
            return chroma(clip_rgb([
                r * 255,
                g * 255,
                b * 255,
                1
            ]));
        };
        f.start = function(s) {
            if (s == null) return start;
            start = s;
            return f;
        };
        f.rotations = function(r) {
            if (r == null) return rotations;
            rotations = r;
            return f;
        };
        f.gamma = function(g) {
            if (g == null) return gamma;
            gamma = g;
            return f;
        };
        f.hue = function(h) {
            if (h == null) return hue;
            hue = h;
            if (type(hue) === 'array') {
                dh = hue[1] - hue[0];
                if (dh === 0) hue = hue[1];
            } else dh = 0;
            return f;
        };
        f.lightness = function(h) {
            if (h == null) return lightness;
            if (type(h) === 'array') {
                lightness = h;
                dl = h[1] - h[0];
            } else {
                lightness = [
                    h,
                    h
                ];
                dl = 0;
            }
            return f;
        };
        f.scale = function() {
            return chroma.scale(f);
        };
        f.hue(hue);
        return f;
    };
    chroma.random = function() {
        var code, digits, i, o;
        digits = '0123456789abcdef';
        code = '#';
        for(i = o = 0; o < 6; i = ++o)code += digits.charAt(floor(Math.random() * 16));
        return new Color(code);
    };
    _interpolators = [];
    interpolate = function(col1, col2, f, m) {
        var interpol, len, o, res;
        if (f == null) f = 0.5;
        if (m == null) m = 'rgb';
        /*
    interpolates between colors
    f = 0 --> me
    f = 1 --> col
     */ if (type(col1) !== 'object') col1 = chroma(col1);
        if (type(col2) !== 'object') col2 = chroma(col2);
        for(o = 0, len = _interpolators.length; o < len; o++){
            interpol = _interpolators[o];
            if (m === interpol[0]) {
                res = interpol[1](col1, col2, f, m);
                break;
            }
        }
        if (res == null) throw "color mode " + m + " is not supported";
        return res.alpha(col1.alpha() + f * (col2.alpha() - col1.alpha()));
    };
    chroma.interpolate = interpolate;
    Color.prototype.interpolate = function(col2, f, m) {
        return interpolate(this, col2, f, m);
    };
    chroma.mix = interpolate;
    Color.prototype.mix = Color.prototype.interpolate;
    _input.rgb = function() {
        var k, ref, results, v;
        ref = unpack(arguments);
        results = [];
        for(k in ref){
            v = ref[k];
            results.push(v);
        }
        return results;
    };
    chroma.rgb = function() {
        return function(func, args, ctor) {
            ctor.prototype = func.prototype;
            var child = new ctor, result = func.apply(child, args);
            return Object(result) === result ? result : child;
        }(Color, slice.call(arguments).concat([
            'rgb'
        ]), function() {});
    };
    Color.prototype.rgb = function(round) {
        if (round == null) round = true;
        if (round) return this._rgb.map(Math.round).slice(0, 3);
        else return this._rgb.slice(0, 3);
    };
    Color.prototype.rgba = function(round) {
        if (round == null) round = true;
        if (!round) return this._rgb.slice(0);
        return [
            Math.round(this._rgb[0]),
            Math.round(this._rgb[1]),
            Math.round(this._rgb[2]),
            this._rgb[3]
        ];
    };
    _guess_formats.push({
        p: 3,
        test: function(n) {
            var a;
            a = unpack(arguments);
            if (type(a) === 'array' && a.length === 3) return 'rgb';
            if (a.length === 4 && type(a[3]) === "number" && a[3] >= 0 && a[3] <= 1) return 'rgb';
        }
    });
    _input.lrgb = _input.rgb;
    interpolate_lrgb = function(col1, col2, f, m) {
        var xyz0, xyz1;
        xyz0 = col1._rgb;
        xyz1 = col2._rgb;
        return new Color(sqrt(pow(xyz0[0], 2) * (1 - f) + pow(xyz1[0], 2) * f), sqrt(pow(xyz0[1], 2) * (1 - f) + pow(xyz1[1], 2) * f), sqrt(pow(xyz0[2], 2) * (1 - f) + pow(xyz1[2], 2) * f), m);
    };
    _average_lrgb = function(colors) {
        var col, f, len, o, rgb, xyz;
        f = 1 / colors.length;
        xyz = [
            0,
            0,
            0,
            0
        ];
        for(o = 0, len = colors.length; o < len; o++){
            col = colors[o];
            rgb = col._rgb;
            xyz[0] += pow(rgb[0], 2) * f;
            xyz[1] += pow(rgb[1], 2) * f;
            xyz[2] += pow(rgb[2], 2) * f;
            xyz[3] += rgb[3] * f;
        }
        xyz[0] = sqrt(xyz[0]);
        xyz[1] = sqrt(xyz[1]);
        xyz[2] = sqrt(xyz[2]);
        if (xyz[3] > 1) xyz[3] = 1;
        return new Color(clip_rgb(xyz));
    };
    _interpolators.push([
        'lrgb',
        interpolate_lrgb
    ]);
    chroma.average = function(colors, mode) {
        var A, alpha, c, cnt, dx, dy, first, i, l, len, o, xyz, xyz2;
        if (mode == null) mode = 'rgb';
        l = colors.length;
        colors = colors.map(function(c) {
            return chroma(c);
        });
        first = colors.splice(0, 1)[0];
        if (mode === 'lrgb') return _average_lrgb(colors);
        xyz = first.get(mode);
        cnt = [];
        dx = 0;
        dy = 0;
        for(i in xyz){
            xyz[i] = xyz[i] || 0;
            cnt.push(isNaN(xyz[i]) ? 0 : 1);
            if (mode.charAt(i) === 'h' && !isNaN(xyz[i])) {
                A = xyz[i] / 180 * PI;
                dx += cos(A);
                dy += sin(A);
            }
        }
        alpha = first.alpha();
        for(o = 0, len = colors.length; o < len; o++){
            c = colors[o];
            xyz2 = c.get(mode);
            alpha += c.alpha();
            for(i in xyz)if (!isNaN(xyz2[i])) {
                cnt[i] += 1;
                if (mode.charAt(i) === 'h') {
                    A = xyz2[i] / 180 * PI;
                    dx += cos(A);
                    dy += sin(A);
                } else xyz[i] += xyz2[i];
            }
        }
        for(i in xyz)if (mode.charAt(i) === 'h') {
            A = atan2(dy / cnt[i], dx / cnt[i]) / PI * 180;
            while(A < 0)A += 360;
            while(A >= 360)A -= 360;
            xyz[i] = A;
        } else xyz[i] = xyz[i] / cnt[i];
        return chroma(xyz, mode).alpha(alpha / l);
    };
    hex2rgb = function(hex) {
        var a, b, g, r, rgb, u;
        if (hex.match(/^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/)) {
            if (hex.length === 4 || hex.length === 7) hex = hex.substr(1);
            if (hex.length === 3) {
                hex = hex.split("");
                hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
            }
            u = parseInt(hex, 16);
            r = u >> 16;
            g = u >> 8 & 0xFF;
            b = u & 0xFF;
            return [
                r,
                g,
                b,
                1
            ];
        }
        if (hex.match(/^#?([A-Fa-f0-9]{8})$/)) {
            if (hex.length === 9) hex = hex.substr(1);
            u = parseInt(hex, 16);
            r = u >> 24 & 0xFF;
            g = u >> 16 & 0xFF;
            b = u >> 8 & 0xFF;
            a = round((u & 0xFF) / 0xFF * 100) / 100;
            return [
                r,
                g,
                b,
                a
            ];
        }
        if (_input.css != null && (rgb = _input.css(hex))) return rgb;
        throw "unknown color: " + hex;
    };
    rgb2hex = function(channels, mode) {
        var a, b, g, hxa, r, str, u;
        if (mode == null) mode = 'auto';
        r = channels[0], g = channels[1], b = channels[2], a = channels[3];
        if (mode === 'auto') mode = a < 1 ? 'rgba' : 'rgb';
        r = Math.round(r);
        g = Math.round(g);
        b = Math.round(b);
        u = r << 16 | g << 8 | b;
        str = "000000" + u.toString(16);
        str = str.substr(str.length - 6);
        hxa = '0' + round(a * 255).toString(16);
        hxa = hxa.substr(hxa.length - 2);
        return "#" + function() {
            switch(mode.toLowerCase()){
                case 'rgba':
                    return str + hxa;
                case 'argb':
                    return hxa + str;
                default:
                    return str;
            }
        }();
    };
    _input.hex = function(h) {
        return hex2rgb(h);
    };
    chroma.hex = function() {
        return function(func, args, ctor) {
            ctor.prototype = func.prototype;
            var child = new ctor, result = func.apply(child, args);
            return Object(result) === result ? result : child;
        }(Color, slice.call(arguments).concat([
            'hex'
        ]), function() {});
    };
    Color.prototype.hex = function(mode) {
        if (mode == null) mode = 'auto';
        return rgb2hex(this._rgb, mode);
    };
    _guess_formats.push({
        p: 4,
        test: function(n) {
            if (arguments.length === 1 && type(n) === "string") return 'hex';
        }
    });
    hsl2rgb = function() {
        var args, b, c, g, h, i, l, o, r, ref, s, t1, t2, t3;
        args = unpack(arguments);
        h = args[0], s = args[1], l = args[2];
        if (s === 0) r = g = b = l * 255;
        else {
            t3 = [
                0,
                0,
                0
            ];
            c = [
                0,
                0,
                0
            ];
            t2 = l < 0.5 ? l * (1 + s) : l + s - l * s;
            t1 = 2 * l - t2;
            h /= 360;
            t3[0] = h + 1 / 3;
            t3[1] = h;
            t3[2] = h - 1 / 3;
            for(i = o = 0; o <= 2; i = ++o){
                if (t3[i] < 0) t3[i] += 1;
                if (t3[i] > 1) t3[i] -= 1;
                if (6 * t3[i] < 1) c[i] = t1 + (t2 - t1) * 6 * t3[i];
                else if (2 * t3[i] < 1) c[i] = t2;
                else if (3 * t3[i] < 2) c[i] = t1 + (t2 - t1) * (2 / 3 - t3[i]) * 6;
                else c[i] = t1;
            }
            ref = [
                round(c[0] * 255),
                round(c[1] * 255),
                round(c[2] * 255)
            ], r = ref[0], g = ref[1], b = ref[2];
        }
        if (args.length > 3) return [
            r,
            g,
            b,
            args[3]
        ];
        else return [
            r,
            g,
            b
        ];
    };
    rgb2hsl = function(r, g, b) {
        var h, l, min, ref, s;
        if (r !== void 0 && r.length >= 3) ref = r, r = ref[0], g = ref[1], b = ref[2];
        r /= 255;
        g /= 255;
        b /= 255;
        min = Math.min(r, g, b);
        max = Math.max(r, g, b);
        l = (max + min) / 2;
        if (max === min) {
            s = 0;
            h = Number.NaN;
        } else s = l < 0.5 ? (max - min) / (max + min) : (max - min) / (2 - max - min);
        if (r === max) h = (g - b) / (max - min);
        else if (g === max) h = 2 + (b - r) / (max - min);
        else if (b === max) h = 4 + (r - g) / (max - min);
        h *= 60;
        if (h < 0) h += 360;
        return [
            h,
            s,
            l
        ];
    };
    chroma.hsl = function() {
        return function(func, args, ctor) {
            ctor.prototype = func.prototype;
            var child = new ctor, result = func.apply(child, args);
            return Object(result) === result ? result : child;
        }(Color, slice.call(arguments).concat([
            'hsl'
        ]), function() {});
    };
    _input.hsl = hsl2rgb;
    Color.prototype.hsl = function() {
        return rgb2hsl(this._rgb);
    };
    hsv2rgb = function() {
        var args, b, f, g, h, i, p, q, r, ref, ref1, ref2, ref3, ref4, ref5, s, t, v;
        args = unpack(arguments);
        h = args[0], s = args[1], v = args[2];
        v *= 255;
        if (s === 0) r = g = b = v;
        else {
            if (h === 360) h = 0;
            if (h > 360) h -= 360;
            if (h < 0) h += 360;
            h /= 60;
            i = floor(h);
            f = h - i;
            p = v * (1 - s);
            q = v * (1 - s * f);
            t = v * (1 - s * (1 - f));
            switch(i){
                case 0:
                    ref = [
                        v,
                        t,
                        p
                    ], r = ref[0], g = ref[1], b = ref[2];
                    break;
                case 1:
                    ref1 = [
                        q,
                        v,
                        p
                    ], r = ref1[0], g = ref1[1], b = ref1[2];
                    break;
                case 2:
                    ref2 = [
                        p,
                        v,
                        t
                    ], r = ref2[0], g = ref2[1], b = ref2[2];
                    break;
                case 3:
                    ref3 = [
                        p,
                        q,
                        v
                    ], r = ref3[0], g = ref3[1], b = ref3[2];
                    break;
                case 4:
                    ref4 = [
                        t,
                        p,
                        v
                    ], r = ref4[0], g = ref4[1], b = ref4[2];
                    break;
                case 5:
                    ref5 = [
                        v,
                        p,
                        q
                    ], r = ref5[0], g = ref5[1], b = ref5[2];
            }
        }
        return [
            r,
            g,
            b,
            args.length > 3 ? args[3] : 1
        ];
    };
    rgb2hsv = function() {
        var b, delta, g, h, min, r, ref, s, v;
        ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
        min = Math.min(r, g, b);
        max = Math.max(r, g, b);
        delta = max - min;
        v = max / 255.0;
        if (max === 0) {
            h = Number.NaN;
            s = 0;
        } else {
            s = delta / max;
            if (r === max) h = (g - b) / delta;
            if (g === max) h = 2 + (b - r) / delta;
            if (b === max) h = 4 + (r - g) / delta;
            h *= 60;
            if (h < 0) h += 360;
        }
        return [
            h,
            s,
            v
        ];
    };
    chroma.hsv = function() {
        return function(func, args, ctor) {
            ctor.prototype = func.prototype;
            var child = new ctor, result = func.apply(child, args);
            return Object(result) === result ? result : child;
        }(Color, slice.call(arguments).concat([
            'hsv'
        ]), function() {});
    };
    _input.hsv = hsv2rgb;
    Color.prototype.hsv = function() {
        return rgb2hsv(this._rgb);
    };
    num2rgb = function(num) {
        var b, g, r;
        if (type(num) === "number" && num >= 0 && num <= 0xFFFFFF) {
            r = num >> 16;
            g = num >> 8 & 0xFF;
            b = num & 0xFF;
            return [
                r,
                g,
                b,
                1
            ];
        }
        console.warn("unknown num color: " + num);
        return [
            0,
            0,
            0,
            1
        ];
    };
    rgb2num = function() {
        var b, g, r, ref;
        ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
        return (r << 16) + (g << 8) + b;
    };
    chroma.num = function(num) {
        return new Color(num, 'num');
    };
    Color.prototype.num = function(mode) {
        if (mode == null) mode = 'rgb';
        return rgb2num(this._rgb, mode);
    };
    _input.num = num2rgb;
    _guess_formats.push({
        p: 1,
        test: function(n) {
            if (arguments.length === 1 && type(n) === "number" && n >= 0 && n <= 0xFFFFFF) return 'num';
        }
    });
    hcg2rgb = function() {
        var _c, _g, args, b, c, f, g, h, i, p, q, r, ref, ref1, ref2, ref3, ref4, ref5, t, v;
        args = unpack(arguments);
        h = args[0], c = args[1], _g = args[2];
        c = c / 100;
        g = g / 100 * 255;
        _c = c * 255;
        if (c === 0) r = g = b = _g;
        else {
            if (h === 360) h = 0;
            if (h > 360) h -= 360;
            if (h < 0) h += 360;
            h /= 60;
            i = floor(h);
            f = h - i;
            p = _g * (1 - c);
            q = p + _c * (1 - f);
            t = p + _c * f;
            v = p + _c;
            switch(i){
                case 0:
                    ref = [
                        v,
                        t,
                        p
                    ], r = ref[0], g = ref[1], b = ref[2];
                    break;
                case 1:
                    ref1 = [
                        q,
                        v,
                        p
                    ], r = ref1[0], g = ref1[1], b = ref1[2];
                    break;
                case 2:
                    ref2 = [
                        p,
                        v,
                        t
                    ], r = ref2[0], g = ref2[1], b = ref2[2];
                    break;
                case 3:
                    ref3 = [
                        p,
                        q,
                        v
                    ], r = ref3[0], g = ref3[1], b = ref3[2];
                    break;
                case 4:
                    ref4 = [
                        t,
                        p,
                        v
                    ], r = ref4[0], g = ref4[1], b = ref4[2];
                    break;
                case 5:
                    ref5 = [
                        v,
                        p,
                        q
                    ], r = ref5[0], g = ref5[1], b = ref5[2];
            }
        }
        return [
            r,
            g,
            b,
            args.length > 3 ? args[3] : 1
        ];
    };
    rgb2hcg = function() {
        var _g, b, c, delta, g, h, min, r, ref;
        ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
        min = Math.min(r, g, b);
        max = Math.max(r, g, b);
        delta = max - min;
        c = delta * 100 / 255;
        _g = min / (255 - delta) * 100;
        if (delta === 0) h = Number.NaN;
        else {
            if (r === max) h = (g - b) / delta;
            if (g === max) h = 2 + (b - r) / delta;
            if (b === max) h = 4 + (r - g) / delta;
            h *= 60;
            if (h < 0) h += 360;
        }
        return [
            h,
            c,
            _g
        ];
    };
    chroma.hcg = function() {
        return function(func, args, ctor) {
            ctor.prototype = func.prototype;
            var child = new ctor, result = func.apply(child, args);
            return Object(result) === result ? result : child;
        }(Color, slice.call(arguments).concat([
            'hcg'
        ]), function() {});
    };
    _input.hcg = hcg2rgb;
    Color.prototype.hcg = function() {
        return rgb2hcg(this._rgb);
    };
    css2rgb = function(css) {
        var aa, ab, hsl, i, m, o, rgb, w;
        css = css.toLowerCase();
        if (chroma.colors != null && chroma.colors[css]) return hex2rgb(chroma.colors[css]);
        if (m = css.match(/rgb\(\s*(\-?\d+),\s*(\-?\d+)\s*,\s*(\-?\d+)\s*\)/)) {
            rgb = m.slice(1, 4);
            for(i = o = 0; o <= 2; i = ++o)rgb[i] = +rgb[i];
            rgb[3] = 1;
        } else if (m = css.match(/rgba\(\s*(\-?\d+),\s*(\-?\d+)\s*,\s*(\-?\d+)\s*,\s*([01]|[01]?\.\d+)\)/)) {
            rgb = m.slice(1, 5);
            for(i = w = 0; w <= 3; i = ++w)rgb[i] = +rgb[i];
        } else if (m = css.match(/rgb\(\s*(\-?\d+(?:\.\d+)?)%,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*\)/)) {
            rgb = m.slice(1, 4);
            for(i = aa = 0; aa <= 2; i = ++aa)rgb[i] = round(rgb[i] * 2.55);
            rgb[3] = 1;
        } else if (m = css.match(/rgba\(\s*(\-?\d+(?:\.\d+)?)%,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)/)) {
            rgb = m.slice(1, 5);
            for(i = ab = 0; ab <= 2; i = ++ab)rgb[i] = round(rgb[i] * 2.55);
            rgb[3] = +rgb[3];
        } else if (m = css.match(/hsl\(\s*(\-?\d+(?:\.\d+)?),\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*\)/)) {
            hsl = m.slice(1, 4);
            hsl[1] *= 0.01;
            hsl[2] *= 0.01;
            rgb = hsl2rgb(hsl);
            rgb[3] = 1;
        } else if (m = css.match(/hsla\(\s*(\-?\d+(?:\.\d+)?),\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)/)) {
            hsl = m.slice(1, 4);
            hsl[1] *= 0.01;
            hsl[2] *= 0.01;
            rgb = hsl2rgb(hsl);
            rgb[3] = +m[4];
        }
        return rgb;
    };
    rgb2css = function(rgba) {
        var mode;
        mode = rgba[3] < 1 ? 'rgba' : 'rgb';
        if (mode === 'rgb') return mode + '(' + rgba.slice(0, 3).map(round).join(',') + ')';
        else if (mode === 'rgba') return mode + '(' + rgba.slice(0, 3).map(round).join(',') + ',' + rgba[3] + ')';
    };
    rnd = function(a) {
        return round(a * 100) / 100;
    };
    hsl2css = function(hsl, alpha) {
        var mode;
        mode = alpha < 1 ? 'hsla' : 'hsl';
        hsl[0] = rnd(hsl[0] || 0);
        hsl[1] = rnd(hsl[1] * 100) + '%';
        hsl[2] = rnd(hsl[2] * 100) + '%';
        if (mode === 'hsla') hsl[3] = alpha;
        return mode + '(' + hsl.join(',') + ')';
    };
    _input.css = function(h) {
        return css2rgb(h);
    };
    chroma.css = function() {
        return function(func, args, ctor) {
            ctor.prototype = func.prototype;
            var child = new ctor, result = func.apply(child, args);
            return Object(result) === result ? result : child;
        }(Color, slice.call(arguments).concat([
            'css'
        ]), function() {});
    };
    Color.prototype.css = function(mode) {
        if (mode == null) mode = 'rgb';
        if (mode.slice(0, 3) === 'rgb') return rgb2css(this._rgb);
        else if (mode.slice(0, 3) === 'hsl') return hsl2css(this.hsl(), this.alpha());
    };
    _input.named = function(name) {
        return hex2rgb(w3cx11[name]);
    };
    _guess_formats.push({
        p: 5,
        test: function(n) {
            if (arguments.length === 1 && w3cx11[n] != null) return 'named';
        }
    });
    Color.prototype.name = function(n) {
        var h, k;
        if (arguments.length) {
            if (w3cx11[n]) this._rgb = hex2rgb(w3cx11[n]);
            this._rgb[3] = 1;
            this;
        }
        h = this.hex('rgb');
        for(k in w3cx11){
            if (h === w3cx11[k]) return k;
        }
        return h;
    };
    lch2lab = function() {
        /*
    Convert from a qualitative parameter h and a quantitative parameter l to a 24-bit pixel.
    These formulas were invented by David Dalrymple to obtain maximum contrast without going
    out of gamut if the parameters are in the range 0-1.
    
    A saturation multiplier was added by Gregor Aisch
     */ var c, h, l, ref;
        ref = unpack(arguments), l = ref[0], c = ref[1], h = ref[2];
        h = h * DEG2RAD;
        return [
            l,
            cos(h) * c,
            sin(h) * c
        ];
    };
    lch2rgb = function() {
        var L, a, args, b, c, g, h, l, r, ref, ref1;
        args = unpack(arguments);
        l = args[0], c = args[1], h = args[2];
        ref = lch2lab(l, c, h), L = ref[0], a = ref[1], b = ref[2];
        ref1 = lab2rgb(L, a, b), r = ref1[0], g = ref1[1], b = ref1[2];
        return [
            r,
            g,
            b,
            args.length > 3 ? args[3] : 1
        ];
    };
    lab2lch = function() {
        var a, b, c, h, l, ref;
        ref = unpack(arguments), l = ref[0], a = ref[1], b = ref[2];
        c = sqrt(a * a + b * b);
        h = (atan2(b, a) * RAD2DEG + 360) % 360;
        if (round(c * 10000) === 0) h = Number.NaN;
        return [
            l,
            c,
            h
        ];
    };
    rgb2lch = function() {
        var a, b, g, l, r, ref, ref1;
        ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
        ref1 = rgb2lab(r, g, b), l = ref1[0], a = ref1[1], b = ref1[2];
        return lab2lch(l, a, b);
    };
    chroma.lch = function() {
        var args;
        args = unpack(arguments);
        return new Color(args, 'lch');
    };
    chroma.hcl = function() {
        var args;
        args = unpack(arguments);
        return new Color(args, 'hcl');
    };
    _input.lch = lch2rgb;
    _input.hcl = function() {
        var c, h, l, ref;
        ref = unpack(arguments), h = ref[0], c = ref[1], l = ref[2];
        return lch2rgb([
            l,
            c,
            h
        ]);
    };
    Color.prototype.lch = function() {
        return rgb2lch(this._rgb);
    };
    Color.prototype.hcl = function() {
        return rgb2lch(this._rgb).reverse();
    };
    rgb2cmyk = function(mode) {
        var b, c, f, g, k, m, r, ref, y;
        if (mode == null) mode = 'rgb';
        ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
        r = r / 255;
        g = g / 255;
        b = b / 255;
        k = 1 - Math.max(r, Math.max(g, b));
        f = k < 1 ? 1 / (1 - k) : 0;
        c = (1 - r - k) * f;
        m = (1 - g - k) * f;
        y = (1 - b - k) * f;
        return [
            c,
            m,
            y,
            k
        ];
    };
    cmyk2rgb = function() {
        var alpha, args, b, c, g, k, m, r, y;
        args = unpack(arguments);
        c = args[0], m = args[1], y = args[2], k = args[3];
        alpha = args.length > 4 ? args[4] : 1;
        if (k === 1) return [
            0,
            0,
            0,
            alpha
        ];
        r = c >= 1 ? 0 : 255 * (1 - c) * (1 - k);
        g = m >= 1 ? 0 : 255 * (1 - m) * (1 - k);
        b = y >= 1 ? 0 : 255 * (1 - y) * (1 - k);
        return [
            r,
            g,
            b,
            alpha
        ];
    };
    _input.cmyk = function() {
        return cmyk2rgb(unpack(arguments));
    };
    chroma.cmyk = function() {
        return function(func, args, ctor) {
            ctor.prototype = func.prototype;
            var child = new ctor, result = func.apply(child, args);
            return Object(result) === result ? result : child;
        }(Color, slice.call(arguments).concat([
            'cmyk'
        ]), function() {});
    };
    Color.prototype.cmyk = function() {
        return rgb2cmyk(this._rgb);
    };
    _input.gl = function() {
        var i, k, o, rgb, v;
        rgb = (function() {
            var ref, results;
            ref = unpack(arguments);
            results = [];
            for(k in ref){
                v = ref[k];
                results.push(v);
            }
            return results;
        }).apply(this, arguments);
        for(i = o = 0; o <= 2; i = ++o)rgb[i] *= 255;
        return rgb;
    };
    chroma.gl = function() {
        return function(func, args, ctor) {
            ctor.prototype = func.prototype;
            var child = new ctor, result = func.apply(child, args);
            return Object(result) === result ? result : child;
        }(Color, slice.call(arguments).concat([
            'gl'
        ]), function() {});
    };
    Color.prototype.gl = function() {
        var rgb;
        rgb = this._rgb;
        return [
            rgb[0] / 255,
            rgb[1] / 255,
            rgb[2] / 255,
            rgb[3]
        ];
    };
    rgb2luminance = function(r, g, b) {
        var ref;
        ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
        r = luminance_x(r);
        g = luminance_x(g);
        b = luminance_x(b);
        return 0.2126 * r + 0.7152 * g + 0.0722 * b;
    };
    luminance_x = function(x) {
        x /= 255;
        if (x <= 0.03928) return x / 12.92;
        else return pow((x + 0.055) / 1.055, 2.4);
    };
    interpolate_rgb = function(col1, col2, f, m) {
        var xyz0, xyz1;
        xyz0 = col1._rgb;
        xyz1 = col2._rgb;
        return new Color(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), m);
    };
    _interpolators.push([
        'rgb',
        interpolate_rgb
    ]);
    Color.prototype.luminance = function(lum, mode) {
        var cur_lum, eps, max_iter, rgba, test;
        if (mode == null) mode = 'rgb';
        if (!arguments.length) return rgb2luminance(this._rgb);
        rgba = this._rgb;
        if (lum === 0) rgba = [
            0,
            0,
            0,
            this._rgb[3]
        ];
        else if (lum === 1) rgba = [
            255,
            255,
            255,
            this[3]
        ];
        else {
            cur_lum = rgb2luminance(this._rgb);
            eps = 1e-7;
            max_iter = 20;
            test = function(l, h) {
                var lm, m;
                m = l.interpolate(h, 0.5, mode);
                lm = m.luminance();
                if (Math.abs(lum - lm) < eps || !max_iter--) return m;
                if (lm > lum) return test(l, m);
                return test(m, h);
            };
            if (cur_lum > lum) rgba = test(chroma('black'), this).rgba();
            else rgba = test(this, chroma('white')).rgba();
        }
        return chroma(rgba).alpha(this.alpha());
    };
    temperature2rgb = function(kelvin) {
        var b, g, r, temp;
        temp = kelvin / 100;
        if (temp < 66) {
            r = 255;
            g = -155.25485562709179 - 0.44596950469579133 * (g = temp - 2) + 104.49216199393888 * log(g);
            b = temp < 20 ? 0 : -254.76935184120902 + 0.8274096064007395 * (b = temp - 10) + 115.67994401066147 * log(b);
        } else {
            r = 351.97690566805693 + 0.114206453784165 * (r = temp - 55) - 40.25366309332127 * log(r);
            g = 325.4494125711974 + 0.07943456536662342 * (g = temp - 50) - 28.0852963507957 * log(g);
            b = 255;
        }
        return [
            r,
            g,
            b
        ];
    };
    rgb2temperature = function() {
        var b, eps, g, maxTemp, minTemp, r, ref, rgb, temp;
        ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
        minTemp = 1000;
        maxTemp = 40000;
        eps = 0.4;
        while(maxTemp - minTemp > eps){
            temp = (maxTemp + minTemp) * 0.5;
            rgb = temperature2rgb(temp);
            if (rgb[2] / rgb[0] >= b / r) maxTemp = temp;
            else minTemp = temp;
        }
        return round(temp);
    };
    chroma.temperature = chroma.kelvin = function() {
        return function(func, args, ctor) {
            ctor.prototype = func.prototype;
            var child = new ctor, result = func.apply(child, args);
            return Object(result) === result ? result : child;
        }(Color, slice.call(arguments).concat([
            'temperature'
        ]), function() {});
    };
    _input.temperature = _input.kelvin = _input.K = temperature2rgb;
    Color.prototype.temperature = function() {
        return rgb2temperature(this._rgb);
    };
    Color.prototype.kelvin = Color.prototype.temperature;
    chroma.contrast = function(a, b) {
        var l1, l2, ref, ref1;
        if ((ref = type(a)) === 'string' || ref === 'number') a = new Color(a);
        if ((ref1 = type(b)) === 'string' || ref1 === 'number') b = new Color(b);
        l1 = a.luminance();
        l2 = b.luminance();
        if (l1 > l2) return (l1 + 0.05) / (l2 + 0.05);
        else return (l2 + 0.05) / (l1 + 0.05);
    };
    chroma.distance = function(a, b, mode) {
        var d, i, l1, l2, ref, ref1, sum_sq;
        if (mode == null) mode = 'lab';
        if ((ref = type(a)) === 'string' || ref === 'number') a = new Color(a);
        if ((ref1 = type(b)) === 'string' || ref1 === 'number') b = new Color(b);
        l1 = a.get(mode);
        l2 = b.get(mode);
        sum_sq = 0;
        for(i in l1){
            d = (l1[i] || 0) - (l2[i] || 0);
            sum_sq += d * d;
        }
        return Math.sqrt(sum_sq);
    };
    chroma.deltaE = function(a, b, L, C) {
        var L1, L2, a1, a2, b1, b2, c1, c2, c4, dH2, delA, delB, delC, delL, f, h1, ref, ref1, ref2, ref3, sc, sh, sl, t, v1, v2, v3;
        if (L == null) L = 1;
        if (C == null) C = 1;
        if ((ref = type(a)) === 'string' || ref === 'number') a = new Color(a);
        if ((ref1 = type(b)) === 'string' || ref1 === 'number') b = new Color(b);
        ref2 = a.lab(), L1 = ref2[0], a1 = ref2[1], b1 = ref2[2];
        ref3 = b.lab(), L2 = ref3[0], a2 = ref3[1], b2 = ref3[2];
        c1 = sqrt(a1 * a1 + b1 * b1);
        c2 = sqrt(a2 * a2 + b2 * b2);
        sl = L1 < 16.0 ? 0.511 : 0.040975 * L1 / (1.0 + 0.01765 * L1);
        sc = 0.0638 * c1 / (1.0 + 0.0131 * c1) + 0.638;
        h1 = c1 < 0.000001 ? 0.0 : atan2(b1, a1) * 180.0 / PI;
        while(h1 < 0)h1 += 360;
        while(h1 >= 360)h1 -= 360;
        t = h1 >= 164.0 && h1 <= 345.0 ? 0.56 + abs(0.2 * cos(PI * (h1 + 168.0) / 180.0)) : 0.36 + abs(0.4 * cos(PI * (h1 + 35.0) / 180.0));
        c4 = c1 * c1 * c1 * c1;
        f = sqrt(c4 / (c4 + 1900.0));
        sh = sc * (f * t + 1.0 - f);
        delL = L1 - L2;
        delC = c1 - c2;
        delA = a1 - a2;
        delB = b1 - b2;
        dH2 = delA * delA + delB * delB - delC * delC;
        v1 = delL / (L * sl);
        v2 = delC / (C * sc);
        v3 = sh;
        return sqrt(v1 * v1 + v2 * v2 + dH2 / (v3 * v3));
    };
    Color.prototype.get = function(modechan) {
        var channel, i, me, mode, ref, src;
        me = this;
        ref = modechan.split('.'), mode = ref[0], channel = ref[1];
        src = me[mode]();
        if (channel) {
            i = mode.indexOf(channel);
            if (i > -1) return src[i];
            else return console.warn('unknown channel ' + channel + ' in mode ' + mode);
        } else return src;
    };
    Color.prototype.set = function(modechan, value) {
        var channel, i, me, mode, ref, src;
        me = this;
        ref = modechan.split('.'), mode = ref[0], channel = ref[1];
        if (channel) {
            src = me[mode]();
            i = mode.indexOf(channel);
            if (i > -1) {
                if (type(value) === 'string') switch(value.charAt(0)){
                    case '+':
                        src[i] += +value;
                        break;
                    case '-':
                        src[i] += +value;
                        break;
                    case '*':
                        src[i] *= +value.substr(1);
                        break;
                    case '/':
                        src[i] /= +value.substr(1);
                        break;
                    default:
                        src[i] = +value;
                }
                else src[i] = value;
            } else console.warn('unknown channel ' + channel + ' in mode ' + mode);
        } else src = value;
        return chroma(src, mode).alpha(me.alpha());
    };
    Color.prototype.clipped = function() {
        return this._rgb._clipped || false;
    };
    Color.prototype.alpha = function(a) {
        if (arguments.length) return chroma.rgb([
            this._rgb[0],
            this._rgb[1],
            this._rgb[2],
            a
        ]);
        return this._rgb[3];
    };
    Color.prototype.darken = function(amount) {
        var lab, me;
        if (amount == null) amount = 1;
        me = this;
        lab = me.lab();
        lab[0] -= LAB_CONSTANTS.Kn * amount;
        return chroma.lab(lab).alpha(me.alpha());
    };
    Color.prototype.brighten = function(amount) {
        if (amount == null) amount = 1;
        return this.darken(-amount);
    };
    Color.prototype.darker = Color.prototype.darken;
    Color.prototype.brighter = Color.prototype.brighten;
    Color.prototype.saturate = function(amount) {
        var lch, me;
        if (amount == null) amount = 1;
        me = this;
        lch = me.lch();
        lch[1] += amount * LAB_CONSTANTS.Kn;
        if (lch[1] < 0) lch[1] = 0;
        return chroma.lch(lch).alpha(me.alpha());
    };
    Color.prototype.desaturate = function(amount) {
        if (amount == null) amount = 1;
        return this.saturate(-amount);
    };
    Color.prototype.premultiply = function() {
        var a, rgb;
        rgb = this.rgb();
        a = this.alpha();
        return chroma(rgb[0] * a, rgb[1] * a, rgb[2] * a, a);
    };
    blend = function(bottom, top, mode) {
        if (!blend[mode]) throw 'unknown blend mode ' + mode;
        return blend[mode](bottom, top);
    };
    blend_f = function(f) {
        return function(bottom, top) {
            var c0, c1;
            c0 = chroma(top).rgb();
            c1 = chroma(bottom).rgb();
            return chroma(f(c0, c1), 'rgb');
        };
    };
    each = function(f) {
        return function(c0, c1) {
            var i, o, out;
            out = [];
            for(i = o = 0; o <= 3; i = ++o)out[i] = f(c0[i], c1[i]);
            return out;
        };
    };
    normal = function(a, b) {
        return a;
    };
    multiply = function(a, b) {
        return a * b / 255;
    };
    darken = function(a, b) {
        if (a > b) return b;
        else return a;
    };
    lighten = function(a, b) {
        if (a > b) return a;
        else return b;
    };
    screen = function(a, b) {
        return 255 * (1 - (1 - a / 255) * (1 - b / 255));
    };
    overlay = function(a, b) {
        if (b < 128) return 2 * a * b / 255;
        else return 255 * (1 - 2 * (1 - a / 255) * (1 - b / 255));
    };
    burn = function(a, b) {
        return 255 * (1 - (1 - b / 255) / (a / 255));
    };
    dodge = function(a, b) {
        if (a === 255) return 255;
        a = 255 * (b / 255) / (1 - a / 255);
        if (a > 255) return 255;
        else return a;
    };
    blend.normal = blend_f(each(normal));
    blend.multiply = blend_f(each(multiply));
    blend.screen = blend_f(each(screen));
    blend.overlay = blend_f(each(overlay));
    blend.darken = blend_f(each(darken));
    blend.lighten = blend_f(each(lighten));
    blend.dodge = blend_f(each(dodge));
    blend.burn = blend_f(each(burn));
    chroma.blend = blend;
    chroma.analyze = function(data) {
        var len, o, r, val;
        r = {
            min: Number.MAX_VALUE,
            max: Number.MAX_VALUE * -1,
            sum: 0,
            values: [],
            count: 0
        };
        for(o = 0, len = data.length; o < len; o++){
            val = data[o];
            if (val != null && !isNaN(val)) {
                r.values.push(val);
                r.sum += val;
                if (val < r.min) r.min = val;
                if (val > r.max) r.max = val;
                r.count += 1;
            }
        }
        r.domain = [
            r.min,
            r.max
        ];
        r.limits = function(mode, num) {
            return chroma.limits(r, mode, num);
        };
        return r;
    };
    chroma.scale = function(colors, positions) {
        var _classes, _colorCache, _colors, _correctLightness, _domain, _fixed, _gamma, _max, _min, _mode, _nacol, _out, _padding, _pos, _spread, _useCache, classifyValue, f, getClass, getColor, resetCache, setColors, tmap;
        _mode = 'rgb';
        _nacol = chroma('#ccc');
        _spread = 0;
        _fixed = false;
        _domain = [
            0,
            1
        ];
        _pos = [];
        _padding = [
            0,
            0
        ];
        _classes = false;
        _colors = [];
        _out = false;
        _min = 0;
        _max = 1;
        _correctLightness = false;
        _colorCache = {};
        _useCache = true;
        _gamma = 1;
        setColors = function(colors) {
            var c, col, o, ref, ref1, w;
            if (colors == null) colors = [
                '#fff',
                '#000'
            ];
            if (colors != null && type(colors) === 'string' && chroma.brewer != null) colors = chroma.brewer[colors] || chroma.brewer[colors.toLowerCase()] || colors;
            if (type(colors) === 'array') {
                if (colors.length === 1) colors = [
                    colors[0],
                    colors[0]
                ];
                colors = colors.slice(0);
                for(c = o = 0, ref = colors.length - 1; 0 <= ref ? o <= ref : o >= ref; c = 0 <= ref ? ++o : --o){
                    col = colors[c];
                    if (type(col) === "string") colors[c] = chroma(col);
                }
                _pos.length = 0;
                for(c = w = 0, ref1 = colors.length - 1; 0 <= ref1 ? w <= ref1 : w >= ref1; c = 0 <= ref1 ? ++w : --w)_pos.push(c / (colors.length - 1));
            }
            resetCache();
            return _colors = colors;
        };
        getClass = function(value) {
            var i, n;
            if (_classes != null) {
                n = _classes.length - 1;
                i = 0;
                while(i < n && value >= _classes[i])i++;
                return i - 1;
            }
            return 0;
        };
        tmap = function(t) {
            return t;
        };
        classifyValue = function(value) {
            var i, maxc, minc, n, val;
            val = value;
            if (_classes.length > 2) {
                n = _classes.length - 1;
                i = getClass(value);
                minc = _classes[0] + (_classes[1] - _classes[0]) * (0 + _spread * 0.5);
                maxc = _classes[n - 1] + (_classes[n] - _classes[n - 1]) * (1 - _spread * 0.5);
                val = _min + (_classes[i] + (_classes[i + 1] - _classes[i]) * 0.5 - minc) / (maxc - minc) * (_max - _min);
            }
            return val;
        };
        getColor = function(val, bypassMap) {
            var c, col, i, k, o, p, ref, t;
            if (bypassMap == null) bypassMap = false;
            if (isNaN(val) || val === null) return _nacol;
            if (!bypassMap) {
                if (_classes && _classes.length > 2) {
                    c = getClass(val);
                    t = c / (_classes.length - 2);
                } else if (_max !== _min) t = (val - _min) / (_max - _min);
                else t = 1;
            } else t = val;
            if (!bypassMap) t = tmap(t);
            if (_gamma !== 1) t = pow(t, _gamma);
            t = _padding[0] + t * (1 - _padding[0] - _padding[1]);
            t = Math.min(1, Math.max(0, t));
            k = Math.floor(t * 10000);
            if (_useCache && _colorCache[k]) col = _colorCache[k];
            else {
                if (type(_colors) === 'array') for(i = o = 0, ref = _pos.length - 1; 0 <= ref ? o <= ref : o >= ref; i = 0 <= ref ? ++o : --o){
                    p = _pos[i];
                    if (t <= p) {
                        col = _colors[i];
                        break;
                    }
                    if (t >= p && i === _pos.length - 1) {
                        col = _colors[i];
                        break;
                    }
                    if (t > p && t < _pos[i + 1]) {
                        t = (t - p) / (_pos[i + 1] - p);
                        col = chroma.interpolate(_colors[i], _colors[i + 1], t, _mode);
                        break;
                    }
                }
                else if (type(_colors) === 'function') col = _colors(t);
                if (_useCache) _colorCache[k] = col;
            }
            return col;
        };
        resetCache = function() {
            return _colorCache = {};
        };
        setColors(colors);
        f = function(v) {
            var c;
            c = chroma(getColor(v));
            if (_out && c[_out]) return c[_out]();
            else return c;
        };
        f.classes = function(classes) {
            var d;
            if (classes != null) {
                if (type(classes) === 'array') {
                    _classes = classes;
                    _domain = [
                        classes[0],
                        classes[classes.length - 1]
                    ];
                } else {
                    d = chroma.analyze(_domain);
                    if (classes === 0) _classes = [
                        d.min,
                        d.max
                    ];
                    else _classes = chroma.limits(d, 'e', classes);
                }
                return f;
            }
            return _classes;
        };
        f.domain = function(domain) {
            var c, d, k, len, o, ref, w;
            if (!arguments.length) return _domain;
            _min = domain[0];
            _max = domain[domain.length - 1];
            _pos = [];
            k = _colors.length;
            if (domain.length === k && _min !== _max) for(o = 0, len = domain.length; o < len; o++){
                d = domain[o];
                _pos.push((d - _min) / (_max - _min));
            }
            else for(c = w = 0, ref = k - 1; 0 <= ref ? w <= ref : w >= ref; c = 0 <= ref ? ++w : --w)_pos.push(c / (k - 1));
            _domain = [
                _min,
                _max
            ];
            return f;
        };
        f.mode = function(_m) {
            if (!arguments.length) return _mode;
            _mode = _m;
            resetCache();
            return f;
        };
        f.range = function(colors, _pos) {
            setColors(colors, _pos);
            return f;
        };
        f.out = function(_o) {
            _out = _o;
            return f;
        };
        f.spread = function(val) {
            if (!arguments.length) return _spread;
            _spread = val;
            return f;
        };
        f.correctLightness = function(v) {
            if (v == null) v = true;
            _correctLightness = v;
            resetCache();
            if (_correctLightness) tmap = function(t) {
                var L0, L1, L_actual, L_diff, L_ideal, max_iter, pol, t0, t1;
                L0 = getColor(0, true).lab()[0];
                L1 = getColor(1, true).lab()[0];
                pol = L0 > L1;
                L_actual = getColor(t, true).lab()[0];
                L_ideal = L0 + (L1 - L0) * t;
                L_diff = L_actual - L_ideal;
                t0 = 0;
                t1 = 1;
                max_iter = 20;
                while(Math.abs(L_diff) > 1e-2 && max_iter-- > 0)(function() {
                    if (pol) L_diff *= -1;
                    if (L_diff < 0) {
                        t0 = t;
                        t += (t1 - t) * 0.5;
                    } else {
                        t1 = t;
                        t += (t0 - t) * 0.5;
                    }
                    L_actual = getColor(t, true).lab()[0];
                    return L_diff = L_actual - L_ideal;
                })();
                return t;
            };
            else tmap = function(t) {
                return t;
            };
            return f;
        };
        f.padding = function(p) {
            if (p != null) {
                if (type(p) === 'number') p = [
                    p,
                    p
                ];
                _padding = p;
                return f;
            } else return _padding;
        };
        f.colors = function(numColors, out) {
            var dd, dm, i, o, ref, result, results, samples, w;
            if (arguments.length < 2) out = 'hex';
            result = [];
            if (arguments.length === 0) result = _colors.slice(0);
            else if (numColors === 1) result = [
                f(0.5)
            ];
            else if (numColors > 1) {
                dm = _domain[0];
                dd = _domain[1] - dm;
                result = (function() {
                    results = [];
                    for(var o = 0; 0 <= numColors ? o < numColors : o > numColors; 0 <= numColors ? o++ : o--)results.push(o);
                    return results;
                }).apply(this).map(function(i) {
                    return f(dm + i / (numColors - 1) * dd);
                });
            } else {
                colors = [];
                samples = [];
                if (_classes && _classes.length > 2) for(i = w = 1, ref = _classes.length; 1 <= ref ? w < ref : w > ref; i = 1 <= ref ? ++w : --w)samples.push((_classes[i - 1] + _classes[i]) * 0.5);
                else samples = _domain;
                result = samples.map(function(v) {
                    return f(v);
                });
            }
            if (chroma[out]) result = result.map(function(c) {
                return c[out]();
            });
            return result;
        };
        f.cache = function(c) {
            if (c != null) {
                _useCache = c;
                return f;
            } else return _useCache;
        };
        f.gamma = function(g) {
            if (g != null) {
                _gamma = g;
                return f;
            } else return _gamma;
        };
        f.nodata = function(d) {
            if (d != null) {
                _nacol = chroma(d);
                return f;
            } else return _nacol;
        };
        return f;
    };
    if (chroma.scales == null) chroma.scales = {};
    chroma.scales.cool = function() {
        return chroma.scale([
            chroma.hsl(180, 1, .9),
            chroma.hsl(250, .7, .4)
        ]);
    };
    chroma.scales.hot = function() {
        return chroma.scale([
            '#000',
            '#f00',
            '#ff0',
            '#fff'
        ], [
            0,
            .25,
            .75,
            1
        ]).mode('rgb');
    };
    chroma.analyze = function(data, key, filter) {
        var add, k, len, o, r, val, visit;
        r = {
            min: Number.MAX_VALUE,
            max: Number.MAX_VALUE * -1,
            sum: 0,
            values: [],
            count: 0
        };
        if (filter == null) filter = function() {
            return true;
        };
        add = function(val) {
            if (val != null && !isNaN(val)) {
                r.values.push(val);
                r.sum += val;
                if (val < r.min) r.min = val;
                if (val > r.max) r.max = val;
                r.count += 1;
            }
        };
        visit = function(val, k) {
            if (filter(val, k)) {
                if (key != null && type(key) === 'function') return add(key(val));
                else if (key != null && type(key) === 'string' || type(key) === 'number') return add(val[key]);
                else return add(val);
            }
        };
        if (type(data) === 'array') for(o = 0, len = data.length; o < len; o++){
            val = data[o];
            visit(val);
        }
        else for(k in data){
            val = data[k];
            visit(val, k);
        }
        r.domain = [
            r.min,
            r.max
        ];
        r.limits = function(mode, num) {
            return chroma.limits(r, mode, num);
        };
        return r;
    };
    chroma.limits = function(data, mode, num) {
        var aa, ab, ac, ad, ae, af, ag, ah, ai, aj, ak, al, am, assignments, best, centroids, cluster, clusterSizes, dist, i, j, kClusters, limits, max_log, min, min_log, mindist, n, nb_iters, newCentroids, o, p, pb, pr, ref, ref1, ref10, ref11, ref12, ref13, ref14, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, repeat, sum, tmpKMeansBreaks, v, value, values, w;
        if (mode == null) mode = 'equal';
        if (num == null) num = 7;
        if (type(data) === 'array') data = chroma.analyze(data);
        min = data.min;
        max = data.max;
        sum = data.sum;
        values = data.values.sort(function(a, b) {
            return a - b;
        });
        if (num === 1) return [
            min,
            max
        ];
        limits = [];
        if (mode.substr(0, 1) === 'c') {
            limits.push(min);
            limits.push(max);
        }
        if (mode.substr(0, 1) === 'e') {
            limits.push(min);
            for(i = o = 1, ref = num - 1; 1 <= ref ? o <= ref : o >= ref; i = 1 <= ref ? ++o : --o)limits.push(min + i / num * (max - min));
            limits.push(max);
        } else if (mode.substr(0, 1) === 'l') {
            if (min <= 0) throw 'Logarithmic scales are only possible for values > 0';
            min_log = Math.LOG10E * log(min);
            max_log = Math.LOG10E * log(max);
            limits.push(min);
            for(i = w = 1, ref1 = num - 1; 1 <= ref1 ? w <= ref1 : w >= ref1; i = 1 <= ref1 ? ++w : --w)limits.push(pow(10, min_log + i / num * (max_log - min_log)));
            limits.push(max);
        } else if (mode.substr(0, 1) === 'q') {
            limits.push(min);
            for(i = aa = 1, ref2 = num - 1; 1 <= ref2 ? aa <= ref2 : aa >= ref2; i = 1 <= ref2 ? ++aa : --aa){
                p = (values.length - 1) * i / num;
                pb = floor(p);
                if (pb === p) limits.push(values[pb]);
                else {
                    pr = p - pb;
                    limits.push(values[pb] * (1 - pr) + values[pb + 1] * pr);
                }
            }
            limits.push(max);
        } else if (mode.substr(0, 1) === 'k') {
            /*
      implementation based on
      http://code.google.com/p/figue/source/browse/trunk/figue.js#336
      simplified for 1-d input values
       */ n = values.length;
            assignments = new Array(n);
            clusterSizes = new Array(num);
            repeat = true;
            nb_iters = 0;
            centroids = null;
            centroids = [];
            centroids.push(min);
            for(i = ab = 1, ref3 = num - 1; 1 <= ref3 ? ab <= ref3 : ab >= ref3; i = 1 <= ref3 ? ++ab : --ab)centroids.push(min + i / num * (max - min));
            centroids.push(max);
            while(repeat){
                for(j = ac = 0, ref4 = num - 1; 0 <= ref4 ? ac <= ref4 : ac >= ref4; j = 0 <= ref4 ? ++ac : --ac)clusterSizes[j] = 0;
                for(i = ad = 0, ref5 = n - 1; 0 <= ref5 ? ad <= ref5 : ad >= ref5; i = 0 <= ref5 ? ++ad : --ad){
                    value = values[i];
                    mindist = Number.MAX_VALUE;
                    for(j = ae = 0, ref6 = num - 1; 0 <= ref6 ? ae <= ref6 : ae >= ref6; j = 0 <= ref6 ? ++ae : --ae){
                        dist = abs(centroids[j] - value);
                        if (dist < mindist) {
                            mindist = dist;
                            best = j;
                        }
                    }
                    clusterSizes[best]++;
                    assignments[i] = best;
                }
                newCentroids = new Array(num);
                for(j = af = 0, ref7 = num - 1; 0 <= ref7 ? af <= ref7 : af >= ref7; j = 0 <= ref7 ? ++af : --af)newCentroids[j] = null;
                for(i = ag = 0, ref8 = n - 1; 0 <= ref8 ? ag <= ref8 : ag >= ref8; i = 0 <= ref8 ? ++ag : --ag){
                    cluster = assignments[i];
                    if (newCentroids[cluster] === null) newCentroids[cluster] = values[i];
                    else newCentroids[cluster] += values[i];
                }
                for(j = ah = 0, ref9 = num - 1; 0 <= ref9 ? ah <= ref9 : ah >= ref9; j = 0 <= ref9 ? ++ah : --ah)newCentroids[j] *= 1 / clusterSizes[j];
                repeat = false;
                for(j = ai = 0, ref10 = num - 1; 0 <= ref10 ? ai <= ref10 : ai >= ref10; j = 0 <= ref10 ? ++ai : --ai)if (newCentroids[j] !== centroids[i]) {
                    repeat = true;
                    break;
                }
                centroids = newCentroids;
                nb_iters++;
                if (nb_iters > 200) repeat = false;
            }
            kClusters = {};
            for(j = aj = 0, ref11 = num - 1; 0 <= ref11 ? aj <= ref11 : aj >= ref11; j = 0 <= ref11 ? ++aj : --aj)kClusters[j] = [];
            for(i = ak = 0, ref12 = n - 1; 0 <= ref12 ? ak <= ref12 : ak >= ref12; i = 0 <= ref12 ? ++ak : --ak){
                cluster = assignments[i];
                kClusters[cluster].push(values[i]);
            }
            tmpKMeansBreaks = [];
            for(j = al = 0, ref13 = num - 1; 0 <= ref13 ? al <= ref13 : al >= ref13; j = 0 <= ref13 ? ++al : --al){
                tmpKMeansBreaks.push(kClusters[j][0]);
                tmpKMeansBreaks.push(kClusters[j][kClusters[j].length - 1]);
            }
            tmpKMeansBreaks = tmpKMeansBreaks.sort(function(a, b) {
                return a - b;
            });
            limits.push(tmpKMeansBreaks[0]);
            for(i = am = 1, ref14 = tmpKMeansBreaks.length - 1; am <= ref14; i = am += 2){
                v = tmpKMeansBreaks[i];
                if (!isNaN(v) && limits.indexOf(v) === -1) limits.push(v);
            }
        }
        return limits;
    };
    hsi2rgb = function(h, s, i) {
        /*
    borrowed from here:
    http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/hsi2rgb.cpp
     */ var args, b, g, r;
        args = unpack(arguments);
        h = args[0], s = args[1], i = args[2];
        if (isNaN(h)) h = 0;
        h /= 360;
        if (h < 1 / 3) {
            b = (1 - s) / 3;
            r = (1 + s * cos(TWOPI * h) / cos(PITHIRD - TWOPI * h)) / 3;
            g = 1 - (b + r);
        } else if (h < 2 / 3) {
            h -= 1 / 3;
            r = (1 - s) / 3;
            g = (1 + s * cos(TWOPI * h) / cos(PITHIRD - TWOPI * h)) / 3;
            b = 1 - (r + g);
        } else {
            h -= 2 / 3;
            g = (1 - s) / 3;
            b = (1 + s * cos(TWOPI * h) / cos(PITHIRD - TWOPI * h)) / 3;
            r = 1 - (g + b);
        }
        r = limit(i * r * 3);
        g = limit(i * g * 3);
        b = limit(i * b * 3);
        return [
            r * 255,
            g * 255,
            b * 255,
            args.length > 3 ? args[3] : 1
        ];
    };
    rgb2hsi = function() {
        /*
    borrowed from here:
    http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/rgb2hsi.cpp
     */ var b, g, h, i, min, r, ref, s;
        ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
        TWOPI = Math.PI * 2;
        r /= 255;
        g /= 255;
        b /= 255;
        min = Math.min(r, g, b);
        i = (r + g + b) / 3;
        s = 1 - min / i;
        if (s === 0) h = 0;
        else {
            h = (r - g + (r - b)) / 2;
            h /= Math.sqrt((r - g) * (r - g) + (r - b) * (g - b));
            h = Math.acos(h);
            if (b > g) h = TWOPI - h;
            h /= TWOPI;
        }
        return [
            h * 360,
            s,
            i
        ];
    };
    chroma.hsi = function() {
        return function(func, args, ctor) {
            ctor.prototype = func.prototype;
            var child = new ctor, result = func.apply(child, args);
            return Object(result) === result ? result : child;
        }(Color, slice.call(arguments).concat([
            'hsi'
        ]), function() {});
    };
    _input.hsi = hsi2rgb;
    Color.prototype.hsi = function() {
        return rgb2hsi(this._rgb);
    };
    interpolate_hsx = function(col1, col2, f, m) {
        var dh, hue, hue0, hue1, lbv, lbv0, lbv1, res, sat, sat0, sat1, xyz0, xyz1;
        if (m === 'hsl') {
            xyz0 = col1.hsl();
            xyz1 = col2.hsl();
        } else if (m === 'hsv') {
            xyz0 = col1.hsv();
            xyz1 = col2.hsv();
        } else if (m === 'hcg') {
            xyz0 = col1.hcg();
            xyz1 = col2.hcg();
        } else if (m === 'hsi') {
            xyz0 = col1.hsi();
            xyz1 = col2.hsi();
        } else if (m === 'lch' || m === 'hcl') {
            m = 'hcl';
            xyz0 = col1.hcl();
            xyz1 = col2.hcl();
        }
        if (m.substr(0, 1) === 'h') {
            hue0 = xyz0[0], sat0 = xyz0[1], lbv0 = xyz0[2];
            hue1 = xyz1[0], sat1 = xyz1[1], lbv1 = xyz1[2];
        }
        if (!isNaN(hue0) && !isNaN(hue1)) {
            if (hue1 > hue0 && hue1 - hue0 > 180) dh = hue1 - (hue0 + 360);
            else if (hue1 < hue0 && hue0 - hue1 > 180) dh = hue1 + 360 - hue0;
            else dh = hue1 - hue0;
            hue = hue0 + f * dh;
        } else if (!isNaN(hue0)) {
            hue = hue0;
            if ((lbv1 === 1 || lbv1 === 0) && m !== 'hsv') sat = sat0;
        } else if (!isNaN(hue1)) {
            hue = hue1;
            if ((lbv0 === 1 || lbv0 === 0) && m !== 'hsv') sat = sat1;
        } else hue = Number.NaN;
        if (sat == null) sat = sat0 + f * (sat1 - sat0);
        lbv = lbv0 + f * (lbv1 - lbv0);
        return res = chroma[m](hue, sat, lbv);
    };
    _interpolators = _interpolators.concat(function() {
        var len, o, ref, results;
        ref = [
            'hsv',
            'hsl',
            'hsi',
            'hcl',
            'lch',
            'hcg'
        ];
        results = [];
        for(o = 0, len = ref.length; o < len; o++){
            m = ref[o];
            results.push([
                m,
                interpolate_hsx
            ]);
        }
        return results;
    }());
    interpolate_num = function(col1, col2, f, m) {
        var n1, n2;
        n1 = col1.num();
        n2 = col2.num();
        return chroma.num(n1 + (n2 - n1) * f, 'num');
    };
    _interpolators.push([
        'num',
        interpolate_num
    ]);
    interpolate_lab = function(col1, col2, f, m) {
        var res, xyz0, xyz1;
        xyz0 = col1.lab();
        xyz1 = col2.lab();
        return res = new Color(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), m);
    };
    _interpolators.push([
        'lab',
        interpolate_lab
    ]);
}).call(this);

});

parcelRegister("eocIy", function(module, exports) {
'use strict';

var $gFsLW = parcelRequire("gFsLW");

var $1a8gC = parcelRequire("1a8gC");
module.exports = $1a8gC;
$1a8gC.prototype.message = $a79d2c05348001ef$var$message;
$1a8gC.prototype.info = $a79d2c05348001ef$var$info;
$1a8gC.prototype.fail = $a79d2c05348001ef$var$fail;
// Create a message with `reason` at `position`.
// When an error is passed in as `reason`, copies the stack.
function $a79d2c05348001ef$var$message(reason, position, origin) {
    var message = new $gFsLW(reason, position, origin);
    if (this.path) {
        message.name = this.path + ':' + message.name;
        message.file = this.path;
    }
    message.fatal = false;
    this.messages.push(message);
    return message;
}
// Fail: creates a vmessage, associates it with the file, and throws it.
function $a79d2c05348001ef$var$fail() {
    var message = this.message.apply(this, arguments);
    message.fatal = true;
    throw message;
}
// Info: creates a vmessage, associates it with the file, and marks the fatality
// as null.
function $a79d2c05348001ef$var$info() {
    var message = this.message.apply(this, arguments);
    message.fatal = null;
    return message;
}

});
parcelRegister("gFsLW", function(module, exports) {
'use strict';

var $7HEO6 = parcelRequire("7HEO6");
module.exports = $c226cb3d81a610a4$var$VMessage;
// Inherit from `Error#`.
function $c226cb3d81a610a4$var$VMessagePrototype() {}
$c226cb3d81a610a4$var$VMessagePrototype.prototype = Error.prototype;
$c226cb3d81a610a4$var$VMessage.prototype = new $c226cb3d81a610a4$var$VMessagePrototype();
// Message properties.
var $c226cb3d81a610a4$var$proto = $c226cb3d81a610a4$var$VMessage.prototype;
$c226cb3d81a610a4$var$proto.file = '';
$c226cb3d81a610a4$var$proto.name = '';
$c226cb3d81a610a4$var$proto.reason = '';
$c226cb3d81a610a4$var$proto.message = '';
$c226cb3d81a610a4$var$proto.stack = '';
$c226cb3d81a610a4$var$proto.fatal = null;
$c226cb3d81a610a4$var$proto.column = null;
$c226cb3d81a610a4$var$proto.line = null;
// Construct a new VMessage.
//
// Note: We cannot invoke `Error` on the created context, as that adds readonly
// `line` and `column` attributes on Safari 9, thus throwing and failing the
// data.
function $c226cb3d81a610a4$var$VMessage(reason, position, origin) {
    var parts;
    var range;
    var location;
    if (typeof position === 'string') {
        origin = position;
        position = null;
    }
    parts = $c226cb3d81a610a4$var$parseOrigin(origin);
    range = $7HEO6(position) || '1:1';
    location = {
        start: {
            line: null,
            column: null
        },
        end: {
            line: null,
            column: null
        }
    };
    // Node.
    if (position && position.position) position = position.position;
    if (position) {
        // Position.
        if (position.start) {
            location = position;
            position = position.start;
        } else // Point.
        location.start = position;
    }
    if (reason.stack) {
        this.stack = reason.stack;
        reason = reason.message;
    }
    this.message = reason;
    this.name = range;
    this.reason = reason;
    this.line = position ? position.line : null;
    this.column = position ? position.column : null;
    this.location = location;
    this.source = parts[0];
    this.ruleId = parts[1];
}
function $c226cb3d81a610a4$var$parseOrigin(origin) {
    var result = [
        null,
        null
    ];
    var index;
    if (typeof origin === 'string') {
        index = origin.indexOf(':');
        if (index === -1) result[1] = origin;
        else {
            result[0] = origin.slice(0, index);
            result[1] = origin.slice(index + 1);
        }
    }
    return result;
}

});
parcelRegister("7HEO6", function(module, exports) {
'use strict';
var $59bc33f93fdd2c5d$var$own = {}.hasOwnProperty;
module.exports = $59bc33f93fdd2c5d$var$stringify;
function $59bc33f93fdd2c5d$var$stringify(value) {
    // Nothing.
    if (!value || typeof value !== 'object') return '';
    // Node.
    if ($59bc33f93fdd2c5d$var$own.call(value, 'position') || $59bc33f93fdd2c5d$var$own.call(value, 'type')) return $59bc33f93fdd2c5d$var$position(value.position);
    // Position.
    if ($59bc33f93fdd2c5d$var$own.call(value, 'start') || $59bc33f93fdd2c5d$var$own.call(value, 'end')) return $59bc33f93fdd2c5d$var$position(value);
    // Point.
    if ($59bc33f93fdd2c5d$var$own.call(value, 'line') || $59bc33f93fdd2c5d$var$own.call(value, 'column')) return $59bc33f93fdd2c5d$var$point(value);
    // ?
    return '';
}
function $59bc33f93fdd2c5d$var$point(point) {
    if (!point || typeof point !== 'object') point = {};
    return $59bc33f93fdd2c5d$var$index(point.line) + ':' + $59bc33f93fdd2c5d$var$index(point.column);
}
function $59bc33f93fdd2c5d$var$position(pos) {
    if (!pos || typeof pos !== 'object') pos = {};
    return $59bc33f93fdd2c5d$var$point(pos.start) + '-' + $59bc33f93fdd2c5d$var$point(pos.end);
}
function $59bc33f93fdd2c5d$var$index(value) {
    return value && typeof value === 'number' ? value : 1;
}

});


parcelRegister("1a8gC", function(module, exports) {
'use strict';

var $eHwUl = parcelRequire("eHwUl");

var $da1MY = parcelRequire("da1MY");

var $cQ3eS = parcelRequire("cQ3eS");
module.exports = $0d8d2348dabdbe81$var$VFile;
var $0d8d2348dabdbe81$var$own = {}.hasOwnProperty;
// Order of setting (least specific to most), we need this because otherwise
// `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
// stem can be set.
var $0d8d2348dabdbe81$var$order = [
    'history',
    'path',
    'basename',
    'stem',
    'extname',
    'dirname'
];
$0d8d2348dabdbe81$var$VFile.prototype.toString = $0d8d2348dabdbe81$var$toString;
// Access full path (`~/index.min.js`).
Object.defineProperty($0d8d2348dabdbe81$var$VFile.prototype, 'path', {
    get: $0d8d2348dabdbe81$var$getPath,
    set: $0d8d2348dabdbe81$var$setPath
});
// Access parent path (`~`).
Object.defineProperty($0d8d2348dabdbe81$var$VFile.prototype, 'dirname', {
    get: $0d8d2348dabdbe81$var$getDirname,
    set: $0d8d2348dabdbe81$var$setDirname
});
// Access basename (`index.min.js`).
Object.defineProperty($0d8d2348dabdbe81$var$VFile.prototype, 'basename', {
    get: $0d8d2348dabdbe81$var$getBasename,
    set: $0d8d2348dabdbe81$var$setBasename
});
// Access extname (`.js`).
Object.defineProperty($0d8d2348dabdbe81$var$VFile.prototype, 'extname', {
    get: $0d8d2348dabdbe81$var$getExtname,
    set: $0d8d2348dabdbe81$var$setExtname
});
// Access stem (`index.min`).
Object.defineProperty($0d8d2348dabdbe81$var$VFile.prototype, 'stem', {
    get: $0d8d2348dabdbe81$var$getStem,
    set: $0d8d2348dabdbe81$var$setStem
});
// Construct a new file.
function $0d8d2348dabdbe81$var$VFile(options) {
    var prop;
    var index;
    if (!options) options = {};
    else if (typeof options === 'string' || $cQ3eS(options)) options = {
        contents: options
    };
    else if ('message' in options && 'messages' in options) return options;
    if (!(this instanceof $0d8d2348dabdbe81$var$VFile)) return new $0d8d2348dabdbe81$var$VFile(options);
    this.data = {};
    this.messages = [];
    this.history = [];
    this.cwd = $da1MY.cwd();
    // Set path related properties in the correct order.
    index = -1;
    while(++index < $0d8d2348dabdbe81$var$order.length){
        prop = $0d8d2348dabdbe81$var$order[index];
        if ($0d8d2348dabdbe81$var$own.call(options, prop)) this[prop] = options[prop];
    }
    // Set non-path related properties.
    for(prop in options)if ($0d8d2348dabdbe81$var$order.indexOf(prop) < 0) this[prop] = options[prop];
}
function $0d8d2348dabdbe81$var$getPath() {
    return this.history[this.history.length - 1];
}
function $0d8d2348dabdbe81$var$setPath(path) {
    $0d8d2348dabdbe81$var$assertNonEmpty(path, 'path');
    if (this.path !== path) this.history.push(path);
}
function $0d8d2348dabdbe81$var$getDirname() {
    return typeof this.path === 'string' ? $eHwUl.dirname(this.path) : undefined;
}
function $0d8d2348dabdbe81$var$setDirname(dirname) {
    $0d8d2348dabdbe81$var$assertPath(this.path, 'dirname');
    this.path = $eHwUl.join(dirname || '', this.basename);
}
function $0d8d2348dabdbe81$var$getBasename() {
    return typeof this.path === 'string' ? $eHwUl.basename(this.path) : undefined;
}
function $0d8d2348dabdbe81$var$setBasename(basename) {
    $0d8d2348dabdbe81$var$assertNonEmpty(basename, 'basename');
    $0d8d2348dabdbe81$var$assertPart(basename, 'basename');
    this.path = $eHwUl.join(this.dirname || '', basename);
}
function $0d8d2348dabdbe81$var$getExtname() {
    return typeof this.path === 'string' ? $eHwUl.extname(this.path) : undefined;
}
function $0d8d2348dabdbe81$var$setExtname(extname) {
    $0d8d2348dabdbe81$var$assertPart(extname, 'extname');
    $0d8d2348dabdbe81$var$assertPath(this.path, 'extname');
    if (extname) {
        if (extname.charCodeAt(0) !== 46 /* `.` */ ) throw new Error('`extname` must start with `.`');
        if (extname.indexOf('.', 1) > -1) throw new Error('`extname` cannot contain multiple dots');
    }
    this.path = $eHwUl.join(this.dirname, this.stem + (extname || ''));
}
function $0d8d2348dabdbe81$var$getStem() {
    return typeof this.path === 'string' ? $eHwUl.basename(this.path, this.extname) : undefined;
}
function $0d8d2348dabdbe81$var$setStem(stem) {
    $0d8d2348dabdbe81$var$assertNonEmpty(stem, 'stem');
    $0d8d2348dabdbe81$var$assertPart(stem, 'stem');
    this.path = $eHwUl.join(this.dirname || '', stem + (this.extname || ''));
}
// Get the value of the file.
function $0d8d2348dabdbe81$var$toString(encoding) {
    return (this.contents || '').toString(encoding);
}
// Assert that `part` is not a path (i.e., does not contain `p.sep`).
function $0d8d2348dabdbe81$var$assertPart(part, name) {
    if (part && part.indexOf($eHwUl.sep) > -1) throw new Error('`' + name + '` cannot be a path: did not expect `' + $eHwUl.sep + '`');
}
// Assert that `part` is not empty.
function $0d8d2348dabdbe81$var$assertNonEmpty(part, name) {
    if (!part) throw new Error('`' + name + '` cannot be empty');
}
// Assert `path` exists.
function $0d8d2348dabdbe81$var$assertPath(path, name) {
    if (!path) throw new Error('Setting `' + name + '` requires `path` to be set too');
}

});
parcelRegister("eHwUl", function(module, exports) {

$parcel$export(module.exports, "basename", function () { return $ab3e9baaa2ba32b2$export$9bf319d8f74f51d1; }, function (v) { return $ab3e9baaa2ba32b2$export$9bf319d8f74f51d1 = v; });
$parcel$export(module.exports, "dirname", function () { return $ab3e9baaa2ba32b2$export$7f7b8152cc673abe; }, function (v) { return $ab3e9baaa2ba32b2$export$7f7b8152cc673abe = v; });
$parcel$export(module.exports, "extname", function () { return $ab3e9baaa2ba32b2$export$d0e86f3a75393fa3; }, function (v) { return $ab3e9baaa2ba32b2$export$d0e86f3a75393fa3 = v; });
$parcel$export(module.exports, "join", function () { return $ab3e9baaa2ba32b2$export$f7e2c8231c57a8bd; }, function (v) { return $ab3e9baaa2ba32b2$export$f7e2c8231c57a8bd = v; });
$parcel$export(module.exports, "sep", function () { return $ab3e9baaa2ba32b2$export$5aee1a5bd9743d8f; }, function (v) { return $ab3e9baaa2ba32b2$export$5aee1a5bd9743d8f = v; });
// A derivative work based on:
// <https://github.com/browserify/path-browserify>.
// Which is licensed:
//
// MIT License
//
// Copyright (c) 2013 James Halliday
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// A derivative work based on:
//
// Parts of that are extracted from Node’s internal `path` module:
// <https://github.com/nodejs/node/blob/master/lib/path.js>.
// Which is licensed:
//
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var $ab3e9baaa2ba32b2$export$9bf319d8f74f51d1;
var $ab3e9baaa2ba32b2$export$7f7b8152cc673abe;
var $ab3e9baaa2ba32b2$export$d0e86f3a75393fa3;
var $ab3e9baaa2ba32b2$export$f7e2c8231c57a8bd;
var $ab3e9baaa2ba32b2$export$5aee1a5bd9743d8f;
'use strict';
$ab3e9baaa2ba32b2$export$9bf319d8f74f51d1 = $ab3e9baaa2ba32b2$var$basename;
$ab3e9baaa2ba32b2$export$7f7b8152cc673abe = $ab3e9baaa2ba32b2$var$dirname;
$ab3e9baaa2ba32b2$export$d0e86f3a75393fa3 = $ab3e9baaa2ba32b2$var$extname;
$ab3e9baaa2ba32b2$export$f7e2c8231c57a8bd = $ab3e9baaa2ba32b2$var$join;
$ab3e9baaa2ba32b2$export$5aee1a5bd9743d8f = '/';
function $ab3e9baaa2ba32b2$var$basename(path, ext) {
    var start = 0;
    var end = -1;
    var index;
    var firstNonSlashEnd;
    var seenNonSlash;
    var extIndex;
    if (ext !== undefined && typeof ext !== 'string') throw new TypeError('"ext" argument must be a string');
    $ab3e9baaa2ba32b2$var$assertPath(path);
    index = path.length;
    if (ext === undefined || !ext.length || ext.length > path.length) {
        while(index--){
            if (path.charCodeAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            {
                if (seenNonSlash) {
                    start = index + 1;
                    break;
                }
            } else if (end < 0) {
                // We saw the first non-path separator, mark this as the end of our
                // path component.
                seenNonSlash = true;
                end = index + 1;
            }
        }
        return end < 0 ? '' : path.slice(start, end);
    }
    if (ext === path) return '';
    firstNonSlashEnd = -1;
    extIndex = ext.length - 1;
    while(index--){
        if (path.charCodeAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now.
        {
            if (seenNonSlash) {
                start = index + 1;
                break;
            }
        } else {
            if (firstNonSlashEnd < 0) {
                // We saw the first non-path separator, remember this index in case
                // we need it if the extension ends up not matching.
                seenNonSlash = true;
                firstNonSlashEnd = index + 1;
            }
            if (extIndex > -1) {
                // Try to match the explicit extension.
                if (path.charCodeAt(index) === ext.charCodeAt(extIndex--)) {
                    if (extIndex < 0) // We matched the extension, so mark this as the end of our path
                    // component
                    end = index;
                } else {
                    // Extension does not match, so our result is the entire path
                    // component
                    extIndex = -1;
                    end = firstNonSlashEnd;
                }
            }
        }
    }
    if (start === end) end = firstNonSlashEnd;
    else if (end < 0) end = path.length;
    return path.slice(start, end);
}
function $ab3e9baaa2ba32b2$var$dirname(path) {
    var end;
    var unmatchedSlash;
    var index;
    $ab3e9baaa2ba32b2$var$assertPath(path);
    if (!path.length) return '.';
    end = -1;
    index = path.length;
    // Prefix `--` is important to not run on `0`.
    while(--index){
        if (path.charCodeAt(index) === 47 /* `/` */ ) {
            if (unmatchedSlash) {
                end = index;
                break;
            }
        } else if (!unmatchedSlash) // We saw the first non-path separator
        unmatchedSlash = true;
    }
    return end < 0 ? path.charCodeAt(0) === 47 /* `/` */  ? '/' : '.' : end === 1 && path.charCodeAt(0) === 47 /* `/` */  ? '//' : path.slice(0, end);
}
function $ab3e9baaa2ba32b2$var$extname(path) {
    var startDot = -1;
    var startPart = 0;
    var end = -1;
    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find.
    var preDotState = 0;
    var unmatchedSlash;
    var code;
    var index;
    $ab3e9baaa2ba32b2$var$assertPath(path);
    index = path.length;
    while(index--){
        code = path.charCodeAt(index);
        if (code === 47 /* `/` */ ) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            if (unmatchedSlash) {
                startPart = index + 1;
                break;
            }
            continue;
        }
        if (end < 0) {
            // We saw the first non-path separator, mark this as the end of our
            // extension.
            unmatchedSlash = true;
            end = index + 1;
        }
        if (code === 46 /* `.` */ ) {
            // If this is our first dot, mark it as the start of our extension.
            if (startDot < 0) startDot = index;
            else if (preDotState !== 1) preDotState = 1;
        } else if (startDot > -1) // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension.
        preDotState = -1;
    }
    if (startDot < 0 || end < 0 || // We saw a non-dot character immediately before the dot.
    preDotState === 0 || // The (right-most) trimmed path component is exactly `..`.
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return '';
    return path.slice(startDot, end);
}
function $ab3e9baaa2ba32b2$var$join() {
    var index = -1;
    var joined;
    while(++index < arguments.length){
        $ab3e9baaa2ba32b2$var$assertPath(arguments[index]);
        if (arguments[index]) joined = joined === undefined ? arguments[index] : joined + '/' + arguments[index];
    }
    return joined === undefined ? '.' : $ab3e9baaa2ba32b2$var$normalize(joined);
}
// Note: `normalize` is not exposed as `path.normalize`, so some code is
// manually removed from it.
function $ab3e9baaa2ba32b2$var$normalize(path) {
    var absolute;
    var value;
    $ab3e9baaa2ba32b2$var$assertPath(path);
    absolute = path.charCodeAt(0) === 47 /* `/` */ ;
    // Normalize the path according to POSIX rules.
    value = $ab3e9baaa2ba32b2$var$normalizeString(path, !absolute);
    if (!value.length && !absolute) value = '.';
    if (value.length && path.charCodeAt(path.length - 1) === 47 /* / */ ) value += '/';
    return absolute ? '/' + value : value;
}
// Resolve `.` and `..` elements in a path with directory names.
function $ab3e9baaa2ba32b2$var$normalizeString(path, allowAboveRoot) {
    var result = '';
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var index = -1;
    var code;
    var lastSlashIndex;
    while(++index <= path.length){
        if (index < path.length) code = path.charCodeAt(index);
        else if (code === 47 /* `/` */ ) break;
        else code = 47 /* `/` */ ;
        if (code === 47 /* `/` */ ) {
            if (lastSlash === index - 1 || dots === 1) ;
            else if (lastSlash !== index - 1 && dots === 2) {
                if (result.length < 2 || lastSegmentLength !== 2 || result.charCodeAt(result.length - 1) !== 46 /* `.` */  || result.charCodeAt(result.length - 2) !== 46 /* `.` */ ) {
                    if (result.length > 2) {
                        lastSlashIndex = result.lastIndexOf('/');
                        /* istanbul ignore else - No clue how to cover it. */ if (lastSlashIndex !== result.length - 1) {
                            if (lastSlashIndex < 0) {
                                result = '';
                                lastSegmentLength = 0;
                            } else {
                                result = result.slice(0, lastSlashIndex);
                                lastSegmentLength = result.length - 1 - result.lastIndexOf('/');
                            }
                            lastSlash = index;
                            dots = 0;
                            continue;
                        }
                    } else if (result.length) {
                        result = '';
                        lastSegmentLength = 0;
                        lastSlash = index;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    result = result.length ? result + '/..' : '..';
                    lastSegmentLength = 2;
                }
            } else {
                if (result.length) result += '/' + path.slice(lastSlash + 1, index);
                else result = path.slice(lastSlash + 1, index);
                lastSegmentLength = index - lastSlash - 1;
            }
            lastSlash = index;
            dots = 0;
        } else if (code === 46 /* `.` */  && dots > -1) dots++;
        else dots = -1;
    }
    return result;
}
function $ab3e9baaa2ba32b2$var$assertPath(path) {
    if (typeof path !== 'string') throw new TypeError('Path must be a string. Received ' + JSON.stringify(path));
}

});

parcelRegister("da1MY", function(module, exports) {

$parcel$export(module.exports, "cwd", function () { return $994d98cb7a6c491d$export$5f7bb87daeae59c1; }, function (v) { return $994d98cb7a6c491d$export$5f7bb87daeae59c1 = v; });
// Somewhat based on:
// <https://github.com/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
var $994d98cb7a6c491d$export$5f7bb87daeae59c1;
'use strict';
$994d98cb7a6c491d$export$5f7bb87daeae59c1 = $994d98cb7a6c491d$var$cwd;
function $994d98cb7a6c491d$var$cwd() {
    return '/';
}

});

parcelRegister("cQ3eS", function(module, exports) {
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ module.exports = function isBuffer(obj) {
    return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
};

});



parcelRegister("5BMBa", function(module, exports) {
'use strict';
module.exports = $41561b18110b93d1$var$fromMarkdown;

var $eE6pL = parcelRequire("eE6pL");

var $jhqC9 = parcelRequire("jhqC9");

var $2ZIIm = parcelRequire("2ZIIm");

var $b6oju = parcelRequire("b6oju");

var $crP4t = parcelRequire("crP4t");

var $5DrGG = parcelRequire("5DrGG");

var $eFans = parcelRequire("eFans");

var $5HegO = parcelRequire("5HegO");

var $gpZto = parcelRequire("gpZto");

var $7HEO6 = parcelRequire("7HEO6");
function $41561b18110b93d1$var$fromMarkdown(value, encoding, options) {
    if (typeof encoding !== 'string') {
        options = encoding;
        encoding = undefined;
    }
    return $41561b18110b93d1$var$compiler(options)($5HegO($5DrGG(options).document().write($eFans()(value, encoding, true))));
}
// Note this compiler only understand complete buffering, not streaming.
function $41561b18110b93d1$var$compiler(options) {
    var settings = options || {};
    var config = $41561b18110b93d1$var$configure({
        transforms: [],
        canContainEols: [
            'emphasis',
            'fragment',
            'heading',
            'paragraph',
            'strong'
        ],
        enter: {
            autolink: opener(link),
            autolinkProtocol: onenterdata,
            autolinkEmail: onenterdata,
            atxHeading: opener(heading),
            blockQuote: opener(blockQuote),
            characterEscape: onenterdata,
            characterReference: onenterdata,
            codeFenced: opener(codeFlow),
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: opener(codeFlow, buffer),
            codeText: opener(codeText, buffer),
            codeTextData: onenterdata,
            data: onenterdata,
            codeFlowValue: onenterdata,
            definition: opener(definition),
            definitionDestinationString: buffer,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: opener(emphasis),
            hardBreakEscape: opener(hardBreak),
            hardBreakTrailing: opener(hardBreak),
            htmlFlow: opener(html, buffer),
            htmlFlowData: onenterdata,
            htmlText: opener(html, buffer),
            htmlTextData: onenterdata,
            image: opener(image),
            label: buffer,
            link: opener(link),
            listItem: opener(listItem),
            listItemValue: onenterlistitemvalue,
            listOrdered: opener(list, onenterlistordered),
            listUnordered: opener(list),
            paragraph: opener(paragraph),
            reference: onenterreference,
            referenceString: buffer,
            resourceDestinationString: buffer,
            resourceTitleString: buffer,
            setextHeading: opener(heading),
            strong: opener(strong),
            thematicBreak: opener(thematicBreak)
        },
        exit: {
            atxHeading: closer(),
            atxHeadingSequence: onexitatxheadingsequence,
            autolink: closer(),
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: closer(),
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            codeFenced: closer(onexitcodefenced),
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onexitcodefencedfencemeta,
            codeFlowValue: onexitdata,
            codeIndented: closer(onexitcodeindented),
            codeText: closer(onexitcodetext),
            codeTextData: onexitdata,
            data: onexitdata,
            definition: closer(),
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: closer(),
            hardBreakEscape: closer(onexithardbreak),
            hardBreakTrailing: closer(onexithardbreak),
            htmlFlow: closer(onexithtmlflow),
            htmlFlowData: onexitdata,
            htmlText: closer(onexithtmltext),
            htmlTextData: onexitdata,
            image: closer(onexitimage),
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: closer(onexitlink),
            listItem: closer(),
            listOrdered: closer(),
            listUnordered: closer(),
            paragraph: closer(),
            referenceString: onexitreferencestring,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            resource: onexitresource,
            setextHeading: closer(onexitsetextheading),
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: closer(),
            thematicBreak: closer()
        }
    }, settings.mdastExtensions || []);
    var data = {};
    return compile;
    function compile(events) {
        var tree = {
            type: 'root',
            children: []
        };
        var stack = [
            tree
        ];
        var tokenStack = [];
        var listStack = [];
        var index = -1;
        var handler;
        var listStart;
        var context = {
            stack: stack,
            tokenStack: tokenStack,
            config: config,
            enter: enter,
            exit: exit,
            buffer: buffer,
            resume: resume,
            setData: setData,
            getData: getData
        };
        while(++index < events.length)// We preprocess lists to add `listItem` tokens, and to infer whether
        // items the list itself are spread out.
        if (events[index][1].type === 'listOrdered' || events[index][1].type === 'listUnordered') {
            if (events[index][0] === 'enter') listStack.push(index);
            else {
                listStart = listStack.pop(index);
                index = prepareList(events, listStart, index);
            }
        }
        index = -1;
        while(++index < events.length){
            handler = config[events[index][0]];
            if ($2ZIIm.call(handler, events[index][1].type)) handler[events[index][1].type].call($jhqC9({
                sliceSerialize: events[index][2].sliceSerialize
            }, context), events[index][1]);
        }
        if (tokenStack.length) throw new Error('Cannot close document, a token (`' + tokenStack[tokenStack.length - 1].type + '`, ' + $7HEO6({
            start: tokenStack[tokenStack.length - 1].start,
            end: tokenStack[tokenStack.length - 1].end
        }) + ') is still open');
        // Figure out `root` position.
        tree.position = {
            start: point(events.length ? events[0][1].start : {
                line: 1,
                column: 1,
                offset: 0
            }),
            end: point(events.length ? events[events.length - 2][1].end : {
                line: 1,
                column: 1,
                offset: 0
            })
        };
        index = -1;
        while(++index < config.transforms.length)tree = config.transforms[index](tree) || tree;
        return tree;
    }
    function prepareList(events, start, length) {
        var index = start - 1;
        var containerBalance = -1;
        var listSpread = false;
        var listItem;
        var tailIndex;
        var lineIndex;
        var tailEvent;
        var event;
        var firstBlankLineIndex;
        var atMarker;
        while(++index <= length){
            event = events[index];
            if (event[1].type === 'listUnordered' || event[1].type === 'listOrdered' || event[1].type === 'blockQuote') {
                if (event[0] === 'enter') containerBalance++;
                else containerBalance--;
                atMarker = undefined;
            } else if (event[1].type === 'lineEndingBlank') {
                if (event[0] === 'enter') {
                    if (listItem && !atMarker && !containerBalance && !firstBlankLineIndex) firstBlankLineIndex = index;
                    atMarker = undefined;
                }
            } else if (event[1].type === 'linePrefix' || event[1].type === 'listItemValue' || event[1].type === 'listItemMarker' || event[1].type === 'listItemPrefix' || event[1].type === 'listItemPrefixWhitespace') ;
            else atMarker = undefined;
            if (!containerBalance && event[0] === 'enter' && event[1].type === 'listItemPrefix' || containerBalance === -1 && event[0] === 'exit' && (event[1].type === 'listUnordered' || event[1].type === 'listOrdered')) {
                if (listItem) {
                    tailIndex = index;
                    lineIndex = undefined;
                    while(tailIndex--){
                        tailEvent = events[tailIndex];
                        if (tailEvent[1].type === 'lineEnding' || tailEvent[1].type === 'lineEndingBlank') {
                            if (tailEvent[0] === 'exit') continue;
                            if (lineIndex) {
                                events[lineIndex][1].type = 'lineEndingBlank';
                                listSpread = true;
                            }
                            tailEvent[1].type = 'lineEnding';
                            lineIndex = tailIndex;
                        } else if (tailEvent[1].type === 'linePrefix' || tailEvent[1].type === 'blockQuotePrefix' || tailEvent[1].type === 'blockQuotePrefixWhitespace' || tailEvent[1].type === 'blockQuoteMarker' || tailEvent[1].type === 'listItemIndent') ;
                        else break;
                    }
                    if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) listItem._spread = true;
                    // Fix position.
                    listItem.end = point(lineIndex ? events[lineIndex][1].start : event[1].end);
                    events.splice(lineIndex || index, 0, [
                        'exit',
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                }
                // Create a new list item.
                if (event[1].type === 'listItemPrefix') {
                    listItem = {
                        type: 'listItem',
                        _spread: false,
                        start: point(event[1].start)
                    };
                    events.splice(index, 0, [
                        'enter',
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                    firstBlankLineIndex = undefined;
                    atMarker = true;
                }
            }
        }
        events[start][1]._spread = listSpread;
        return length;
    }
    function setData(key, value) {
        data[key] = value;
    }
    function getData(key) {
        return data[key];
    }
    function point(d) {
        return {
            line: d.line,
            column: d.column,
            offset: d.offset
        };
    }
    function opener(create, and) {
        return open;
        function open(token) {
            enter.call(this, create(token), token);
            if (and) and.call(this, token);
        }
    }
    function buffer() {
        this.stack.push({
            type: 'fragment',
            children: []
        });
    }
    function enter(node, token) {
        this.stack[this.stack.length - 1].children.push(node);
        this.stack.push(node);
        this.tokenStack.push(token);
        node.position = {
            start: point(token.start)
        };
        return node;
    }
    function closer(and) {
        return close;
        function close(token) {
            if (and) and.call(this, token);
            exit.call(this, token);
        }
    }
    function exit(token) {
        var node = this.stack.pop();
        var open = this.tokenStack.pop();
        if (!open) throw new Error('Cannot close `' + token.type + '` (' + $7HEO6({
            start: token.start,
            end: token.end
        }) + "): it\u2019s not open");
        else if (open.type !== token.type) throw new Error('Cannot close `' + token.type + '` (' + $7HEO6({
            start: token.start,
            end: token.end
        }) + '): a different token (`' + open.type + '`, ' + $7HEO6({
            start: open.start,
            end: open.end
        }) + ') is open');
        node.position.end = point(token.end);
        return node;
    }
    function resume() {
        return $eE6pL(this.stack.pop());
    }
    //
    // Handlers.
    //
    function onenterlistordered() {
        setData('expectingFirstListItemValue', true);
    }
    function onenterlistitemvalue(token) {
        if (getData('expectingFirstListItemValue')) {
            this.stack[this.stack.length - 2].start = parseInt(this.sliceSerialize(token), 10);
            setData('expectingFirstListItemValue');
        }
    }
    function onexitcodefencedfenceinfo() {
        var data = this.resume();
        this.stack[this.stack.length - 1].lang = data;
    }
    function onexitcodefencedfencemeta() {
        var data = this.resume();
        this.stack[this.stack.length - 1].meta = data;
    }
    function onexitcodefencedfence() {
        // Exit if this is the closing fence.
        if (getData('flowCodeInside')) return;
        this.buffer();
        setData('flowCodeInside', true);
    }
    function onexitcodefenced() {
        var data = this.resume();
        this.stack[this.stack.length - 1].value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, '');
        setData('flowCodeInside');
    }
    function onexitcodeindented() {
        var data = this.resume();
        this.stack[this.stack.length - 1].value = data;
    }
    function onexitdefinitionlabelstring(token) {
        // Discard label, use the source content instead.
        var label = this.resume();
        this.stack[this.stack.length - 1].label = label;
        this.stack[this.stack.length - 1].identifier = $b6oju(this.sliceSerialize(token)).toLowerCase();
    }
    function onexitdefinitiontitlestring() {
        var data = this.resume();
        this.stack[this.stack.length - 1].title = data;
    }
    function onexitdefinitiondestinationstring() {
        var data = this.resume();
        this.stack[this.stack.length - 1].url = data;
    }
    function onexitatxheadingsequence(token) {
        if (!this.stack[this.stack.length - 1].depth) this.stack[this.stack.length - 1].depth = this.sliceSerialize(token).length;
    }
    function onexitsetextheadingtext() {
        setData('setextHeadingSlurpLineEnding', true);
    }
    function onexitsetextheadinglinesequence(token) {
        this.stack[this.stack.length - 1].depth = this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2;
    }
    function onexitsetextheading() {
        setData('setextHeadingSlurpLineEnding');
    }
    function onenterdata(token) {
        var siblings = this.stack[this.stack.length - 1].children;
        var tail = siblings[siblings.length - 1];
        if (!tail || tail.type !== 'text') {
            // Add a new text node.
            tail = text();
            tail.position = {
                start: point(token.start)
            };
            this.stack[this.stack.length - 1].children.push(tail);
        }
        this.stack.push(tail);
    }
    function onexitdata(token) {
        var tail = this.stack.pop();
        tail.value += this.sliceSerialize(token);
        tail.position.end = point(token.end);
    }
    function onexitlineending(token) {
        var context = this.stack[this.stack.length - 1];
        // If we’re at a hard break, include the line ending in there.
        if (getData('atHardBreak')) {
            context.children[context.children.length - 1].position.end = point(token.end);
            setData('atHardBreak');
            return;
        }
        if (!getData('setextHeadingSlurpLineEnding') && config.canContainEols.indexOf(context.type) > -1) {
            onenterdata.call(this, token);
            onexitdata.call(this, token);
        }
    }
    function onexithardbreak() {
        setData('atHardBreak', true);
    }
    function onexithtmlflow() {
        var data = this.resume();
        this.stack[this.stack.length - 1].value = data;
    }
    function onexithtmltext() {
        var data = this.resume();
        this.stack[this.stack.length - 1].value = data;
    }
    function onexitcodetext() {
        var data = this.resume();
        this.stack[this.stack.length - 1].value = data;
    }
    function onexitlink() {
        var context = this.stack[this.stack.length - 1];
        // To do: clean.
        if (getData('inReference')) {
            context.type += 'Reference';
            context.referenceType = getData('referenceType') || 'shortcut';
            delete context.url;
            delete context.title;
        } else {
            delete context.identifier;
            delete context.label;
            delete context.referenceType;
        }
        setData('referenceType');
    }
    function onexitimage() {
        var context = this.stack[this.stack.length - 1];
        // To do: clean.
        if (getData('inReference')) {
            context.type += 'Reference';
            context.referenceType = getData('referenceType') || 'shortcut';
            delete context.url;
            delete context.title;
        } else {
            delete context.identifier;
            delete context.label;
            delete context.referenceType;
        }
        setData('referenceType');
    }
    function onexitlabeltext(token) {
        this.stack[this.stack.length - 2].identifier = $b6oju(this.sliceSerialize(token)).toLowerCase();
    }
    function onexitlabel() {
        var fragment = this.stack[this.stack.length - 1];
        var value = this.resume();
        this.stack[this.stack.length - 1].label = value;
        // Assume a reference.
        setData('inReference', true);
        if (this.stack[this.stack.length - 1].type === 'link') this.stack[this.stack.length - 1].children = fragment.children;
        else this.stack[this.stack.length - 1].alt = value;
    }
    function onexitresourcedestinationstring() {
        var data = this.resume();
        this.stack[this.stack.length - 1].url = data;
    }
    function onexitresourcetitlestring() {
        var data = this.resume();
        this.stack[this.stack.length - 1].title = data;
    }
    function onexitresource() {
        setData('inReference');
    }
    function onenterreference() {
        setData('referenceType', 'collapsed');
    }
    function onexitreferencestring(token) {
        var label = this.resume();
        this.stack[this.stack.length - 1].label = label;
        this.stack[this.stack.length - 1].identifier = $b6oju(this.sliceSerialize(token)).toLowerCase();
        setData('referenceType', 'full');
    }
    function onexitcharacterreferencemarker(token) {
        setData('characterReferenceType', token.type);
    }
    function onexitcharacterreferencevalue(token) {
        var data = this.sliceSerialize(token);
        var type = getData('characterReferenceType');
        var value;
        var tail;
        if (type) {
            value = $crP4t(data, type === 'characterReferenceMarkerNumeric' ? 10 : 16);
            setData('characterReferenceType');
        } else value = $gpZto(data);
        tail = this.stack.pop();
        tail.value += value;
        tail.position.end = point(token.end);
    }
    function onexitautolinkprotocol(token) {
        onexitdata.call(this, token);
        this.stack[this.stack.length - 1].url = this.sliceSerialize(token);
    }
    function onexitautolinkemail(token) {
        onexitdata.call(this, token);
        this.stack[this.stack.length - 1].url = 'mailto:' + this.sliceSerialize(token);
    }
    //
    // Creaters.
    //
    function blockQuote() {
        return {
            type: 'blockquote',
            children: []
        };
    }
    function codeFlow() {
        return {
            type: 'code',
            lang: null,
            meta: null,
            value: ''
        };
    }
    function codeText() {
        return {
            type: 'inlineCode',
            value: ''
        };
    }
    function definition() {
        return {
            type: 'definition',
            identifier: '',
            label: null,
            title: null,
            url: ''
        };
    }
    function emphasis() {
        return {
            type: 'emphasis',
            children: []
        };
    }
    function heading() {
        return {
            type: 'heading',
            depth: undefined,
            children: []
        };
    }
    function hardBreak() {
        return {
            type: 'break'
        };
    }
    function html() {
        return {
            type: 'html',
            value: ''
        };
    }
    function image() {
        return {
            type: 'image',
            title: null,
            url: '',
            alt: null
        };
    }
    function link() {
        return {
            type: 'link',
            title: null,
            url: '',
            children: []
        };
    }
    function list(token) {
        return {
            type: 'list',
            ordered: token.type === 'listOrdered',
            start: null,
            spread: token._spread,
            children: []
        };
    }
    function listItem(token) {
        return {
            type: 'listItem',
            spread: token._spread,
            checked: null,
            children: []
        };
    }
    function paragraph() {
        return {
            type: 'paragraph',
            children: []
        };
    }
    function strong() {
        return {
            type: 'strong',
            children: []
        };
    }
    function text() {
        return {
            type: 'text',
            value: ''
        };
    }
    function thematicBreak() {
        return {
            type: 'thematicBreak'
        };
    }
}
function $41561b18110b93d1$var$configure(config, extensions) {
    var index = -1;
    while(++index < extensions.length)$41561b18110b93d1$var$extension(config, extensions[index]);
    return config;
}
function $41561b18110b93d1$var$extension(config, extension) {
    var key;
    var left;
    for(key in extension){
        left = $2ZIIm.call(config, key) ? config[key] : config[key] = {};
        if (key === 'canContainEols' || key === 'transforms') config[key] = [].concat(left, extension[key]);
        else Object.assign(left, extension[key]);
    }
}

});
parcelRegister("eE6pL", function(module, exports) {
'use strict';
module.exports = $aa99c6e856eacae2$var$toString;
// Get the text content of a node.
// Prefer the node’s plain-text fields, otherwise serialize its children,
// and if the given value is an array, serialize the nodes in it.
function $aa99c6e856eacae2$var$toString(node) {
    return node && (node.value || node.alt || node.title || 'children' in node && $aa99c6e856eacae2$var$all(node.children) || 'length' in node && $aa99c6e856eacae2$var$all(node)) || '';
}
function $aa99c6e856eacae2$var$all(values) {
    var result = [];
    var index = -1;
    while(++index < values.length)result[index] = $aa99c6e856eacae2$var$toString(values[index]);
    return result.join('');
}

});

parcelRegister("jhqC9", function(module, exports) {
'use strict';
var $e0943fe46f6abd99$var$assign = Object.assign;
module.exports = $e0943fe46f6abd99$var$assign;

});

parcelRegister("2ZIIm", function(module, exports) {
'use strict';
var $22e3f6a34240038b$var$own = {}.hasOwnProperty;
module.exports = $22e3f6a34240038b$var$own;

});

parcelRegister("b6oju", function(module, exports) {
'use strict';
function $81531d627f3ffacf$var$normalizeIdentifier(value) {
    return value // Collapse Markdown whitespace.
    .replace(/[\t\n\r ]+/g, ' ') // Trim.
    .replace(/^ | $/g, '') // Some characters are considered “uppercase”, but if their lowercase
    // counterpart is uppercased will result in a different uppercase
    // character.
    // Hence, to get that form, we perform both lower- and uppercase.
    // Upper case makes sure keys will not interact with default prototypal
    // methods: no object method is uppercase.
    .toLowerCase().toUpperCase();
}
module.exports = $81531d627f3ffacf$var$normalizeIdentifier;

});

parcelRegister("crP4t", function(module, exports) {
'use strict';

var $dBi5Y = parcelRequire("dBi5Y");
function $90ff9f5600484a8e$var$safeFromInt(value, base) {
    var code = parseInt(value, base);
    if (// C0 except for HT, LF, FF, CR, space
    code < 9 || code === 11 || code > 13 && code < 32 || // Control character (DEL) of the basic block and C1 controls.
    code > 126 && code < 160 || // Lone high surrogates and low surrogates.
    code > 55295 && code < 57344 || // Noncharacters.
    code > 64975 && code < 65008 || (code & 65535) === 65535 || (code & 65535) === 65534 || // Out of range
    code > 1114111) return '\uFFFD';
    return $dBi5Y(code);
}
module.exports = $90ff9f5600484a8e$var$safeFromInt;

});
parcelRegister("dBi5Y", function(module, exports) {
'use strict';
var $9e6cc4671de24537$var$fromCharCode = String.fromCharCode;
module.exports = $9e6cc4671de24537$var$fromCharCode;

});


parcelRegister("5DrGG", function(module, exports) {
'use strict';

var $2gi1m = parcelRequire("2gi1m");

var $cIcCQ = parcelRequire("cIcCQ");

var $76pvH = parcelRequire("76pvH");

var $h7bJy = parcelRequire("h7bJy");

var $9bmBd = parcelRequire("9bmBd");

var $hyL4W = parcelRequire("hyL4W");

var $iHnGQ = parcelRequire("iHnGQ");

var $4Vr4H = parcelRequire("4Vr4H");
function $41a6126fad5dea8e$var$parse(options) {
    var settings = options || {};
    var parser = {
        defined: [],
        constructs: $9bmBd([
            $4Vr4H
        ].concat($iHnGQ(settings.extensions))),
        content: create($2gi1m),
        document: create($cIcCQ),
        flow: create($76pvH),
        string: create($h7bJy.string),
        text: create($h7bJy.text)
    };
    return parser;
    function create(initializer) {
        return creator;
        function creator(from) {
            return $hyL4W(parser, initializer, from);
        }
    }
}
module.exports = $41a6126fad5dea8e$var$parse;

});
parcelRegister("2gi1m", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $52d6Z = parcelRequire("52d6Z");

var $12DO2 = parcelRequire("12DO2");
var $1a5b0df47fa6b734$var$tokenize = $1a5b0df47fa6b734$var$initializeContent;
function $1a5b0df47fa6b734$var$initializeContent(effects) {
    var contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
    var previous;
    return contentStart;
    function afterContentStartConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        return $12DO2(effects, contentStart, 'linePrefix');
    }
    function paragraphInitial(code) {
        effects.enter('paragraph');
        return lineStart(code);
    }
    function lineStart(code) {
        var token = effects.enter('chunkText', {
            contentType: 'text',
            previous: previous
        });
        if (previous) previous.next = token;
        previous = token;
        return data(code);
    }
    function data(code) {
        if (code === null) {
            effects.exit('chunkText');
            effects.exit('paragraph');
            effects.consume(code);
            return;
        }
        if ($52d6Z(code)) {
            effects.consume(code);
            effects.exit('chunkText');
            return lineStart;
        } // Data.
        effects.consume(code);
        return data;
    }
}
module.exports.tokenize = $1a5b0df47fa6b734$var$tokenize;

});
parcelRegister("52d6Z", function(module, exports) {
'use strict';
function $3aa74f5c0ab362fe$var$markdownLineEnding(code) {
    return code < -2;
}
module.exports = $3aa74f5c0ab362fe$var$markdownLineEnding;

});

parcelRegister("12DO2", function(module, exports) {
'use strict';

var $ddAr7 = parcelRequire("ddAr7");
function $0c24db06dcd412c6$var$spaceFactory(effects, ok, type, max) {
    var limit = max ? max - 1 : Infinity;
    var size = 0;
    return start;
    function start(code) {
        if ($ddAr7(code)) {
            effects.enter(type);
            return prefix(code);
        }
        return ok(code);
    }
    function prefix(code) {
        if ($ddAr7(code) && size++ < limit) {
            effects.consume(code);
            return prefix;
        }
        effects.exit(type);
        return ok(code);
    }
}
module.exports = $0c24db06dcd412c6$var$spaceFactory;

});
parcelRegister("ddAr7", function(module, exports) {
'use strict';
function $99f8c0c31f59b52d$var$markdownSpace(code) {
    return code === -2 || code === -1 || code === 32;
}
module.exports = $99f8c0c31f59b52d$var$markdownSpace;

});



parcelRegister("cIcCQ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $52d6Z = parcelRequire("52d6Z");

var $12DO2 = parcelRequire("12DO2");

var $89OcD = parcelRequire("89OcD");
var $9413634889793547$var$tokenize = $9413634889793547$var$initializeDocument;
var $9413634889793547$var$containerConstruct = {
    tokenize: $9413634889793547$var$tokenizeContainer
};
var $9413634889793547$var$lazyFlowConstruct = {
    tokenize: $9413634889793547$var$tokenizeLazyFlow
};
function $9413634889793547$var$initializeDocument(effects) {
    var self = this;
    var stack = [];
    var continued = 0;
    var inspectConstruct = {
        tokenize: tokenizeInspect,
        partial: true
    };
    var inspectResult;
    var childFlow;
    var childToken;
    return start;
    function start(code) {
        if (continued < stack.length) {
            self.containerState = stack[continued][1];
            return effects.attempt(stack[continued][0].continuation, documentContinue, documentContinued)(code);
        }
        return documentContinued(code);
    }
    function documentContinue(code) {
        continued++;
        return start(code);
    }
    function documentContinued(code) {
        // If we’re in a concrete construct (such as when expecting another line of
        // HTML, or we resulted in lazy content), we can immediately start flow.
        if (inspectResult && inspectResult.flowContinue) return flowStart(code);
        self.interrupt = childFlow && childFlow.currentConstruct && childFlow.currentConstruct.interruptible;
        self.containerState = {};
        return effects.attempt($9413634889793547$var$containerConstruct, containerContinue, flowStart)(code);
    }
    function containerContinue(code) {
        stack.push([
            self.currentConstruct,
            self.containerState
        ]);
        self.containerState = undefined;
        return documentContinued(code);
    }
    function flowStart(code) {
        if (code === null) {
            exitContainers(0, true);
            effects.consume(code);
            return;
        }
        childFlow = childFlow || self.parser.flow(self.now());
        effects.enter('chunkFlow', {
            contentType: 'flow',
            previous: childToken,
            _tokenizer: childFlow
        });
        return flowContinue(code);
    }
    function flowContinue(code) {
        if (code === null) {
            continueFlow(effects.exit('chunkFlow'));
            return flowStart(code);
        }
        if ($52d6Z(code)) {
            effects.consume(code);
            continueFlow(effects.exit('chunkFlow'));
            return effects.check(inspectConstruct, documentAfterPeek);
        }
        effects.consume(code);
        return flowContinue;
    }
    function documentAfterPeek(code) {
        exitContainers(inspectResult.continued, inspectResult && inspectResult.flowEnd);
        continued = 0;
        return start(code);
    }
    function continueFlow(token) {
        if (childToken) childToken.next = token;
        childToken = token;
        childFlow.lazy = inspectResult && inspectResult.lazy;
        childFlow.defineSkip(token.start);
        childFlow.write(self.sliceStream(token));
    }
    function exitContainers(size, end) {
        var index = stack.length // Close the flow.
        ;
        if (childFlow && end) {
            childFlow.write([
                null
            ]);
            childToken = childFlow = undefined;
        } // Exit open containers.
        while(index-- > size){
            self.containerState = stack[index][1];
            stack[index][0].exit.call(self, effects);
        }
        stack.length = size;
    }
    function tokenizeInspect(effects, ok) {
        var subcontinued = 0;
        inspectResult = {};
        return inspectStart;
        function inspectStart(code) {
            if (subcontinued < stack.length) {
                self.containerState = stack[subcontinued][1];
                return effects.attempt(stack[subcontinued][0].continuation, inspectContinue, inspectLess)(code);
            } // If we’re continued but in a concrete flow, we can’t have more
            // containers.
            if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) {
                inspectResult.flowContinue = true;
                return inspectDone(code);
            }
            self.interrupt = childFlow.currentConstruct && childFlow.currentConstruct.interruptible;
            self.containerState = {};
            return effects.attempt($9413634889793547$var$containerConstruct, inspectFlowEnd, inspectDone)(code);
        }
        function inspectContinue(code) {
            subcontinued++;
            return self.containerState._closeFlow ? inspectFlowEnd(code) : inspectStart(code);
        }
        function inspectLess(code) {
            if (childFlow.currentConstruct && childFlow.currentConstruct.lazy) {
                // Maybe another container?
                self.containerState = {};
                return effects.attempt($9413634889793547$var$containerConstruct, inspectFlowEnd, effects.attempt($9413634889793547$var$lazyFlowConstruct, inspectFlowEnd, effects.check($89OcD, inspectFlowEnd, inspectLazy)))(code);
            } // Otherwise we’re interrupting.
            return inspectFlowEnd(code);
        }
        function inspectLazy(code) {
            // Act as if all containers are continued.
            subcontinued = stack.length;
            inspectResult.lazy = true;
            inspectResult.flowContinue = true;
            return inspectDone(code);
        } // We’re done with flow if we have more containers, or an interruption.
        function inspectFlowEnd(code) {
            inspectResult.flowEnd = true;
            return inspectDone(code);
        }
        function inspectDone(code) {
            inspectResult.continued = subcontinued;
            self.interrupt = self.containerState = undefined;
            return ok(code);
        }
    }
}
function $9413634889793547$var$tokenizeContainer(effects, ok, nok) {
    return $12DO2(effects, effects.attempt(this.parser.constructs.document, ok, nok), 'linePrefix', this.parser.constructs.disable.null.indexOf('codeIndented') > -1 ? undefined : 4);
}
function $9413634889793547$var$tokenizeLazyFlow(effects, ok, nok) {
    return $12DO2(effects, effects.lazy(this.parser.constructs.flow, ok, nok), 'linePrefix', this.parser.constructs.disable.null.indexOf('codeIndented') > -1 ? undefined : 4);
}
module.exports.tokenize = $9413634889793547$var$tokenize;

});
parcelRegister("89OcD", function(module, exports) {
'use strict';

var $52d6Z = parcelRequire("52d6Z");

var $12DO2 = parcelRequire("12DO2");
var $5f061b33a3187a2f$var$partialBlankLine = {
    tokenize: $5f061b33a3187a2f$var$tokenizePartialBlankLine,
    partial: true
};
function $5f061b33a3187a2f$var$tokenizePartialBlankLine(effects, ok, nok) {
    return $12DO2(effects, afterWhitespace, 'linePrefix');
    function afterWhitespace(code) {
        return code === null || $52d6Z(code) ? ok(code) : nok(code);
    }
}
module.exports = $5f061b33a3187a2f$var$partialBlankLine;

});


parcelRegister("76pvH", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $a6ehJ = parcelRequire("a6ehJ");

var $12DO2 = parcelRequire("12DO2");

var $89OcD = parcelRequire("89OcD");
var $52bce1c441507602$var$tokenize = $52bce1c441507602$var$initializeFlow;
function $52bce1c441507602$var$initializeFlow(effects) {
    var self = this;
    var initial = effects.attempt(// Try to parse a blank line.
    $89OcD, atBlankEnding, effects.attempt(this.parser.constructs.flowInitial, afterConstruct, $12DO2(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt($a6ehJ, afterConstruct)), 'linePrefix')));
    return initial;
    function atBlankEnding(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter('lineEndingBlank');
        effects.consume(code);
        effects.exit('lineEndingBlank');
        self.currentConstruct = undefined;
        return initial;
    }
    function afterConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        self.currentConstruct = undefined;
        return initial;
    }
}
module.exports.tokenize = $52bce1c441507602$var$tokenize;

});
parcelRegister("a6ehJ", function(module, exports) {
'use strict';

var $52d6Z = parcelRequire("52d6Z");

var $9gPhT = parcelRequire("9gPhT");

var $hJSf6 = parcelRequire("hJSf6");

var $12DO2 = parcelRequire("12DO2");
// No name because it must not be turned off.
var $75a58b9a2355426e$var$content = {
    tokenize: $75a58b9a2355426e$var$tokenizeContent,
    resolve: $75a58b9a2355426e$var$resolveContent,
    interruptible: true,
    lazy: true
};
var $75a58b9a2355426e$var$continuationConstruct = {
    tokenize: $75a58b9a2355426e$var$tokenizeContinuation,
    partial: true
} // Content is transparent: it’s parsed right now. That way, definitions are also
;
// parsed right now: before text in paragraphs (specifically, media) are parsed.
function $75a58b9a2355426e$var$resolveContent(events) {
    $hJSf6(events);
    return events;
}
function $75a58b9a2355426e$var$tokenizeContent(effects, ok) {
    var previous;
    return start;
    function start(code) {
        effects.enter('content');
        previous = effects.enter('chunkContent', {
            contentType: 'content'
        });
        return data(code);
    }
    function data(code) {
        if (code === null) return contentEnd(code);
        if ($52d6Z(code)) return effects.check($75a58b9a2355426e$var$continuationConstruct, contentContinue, contentEnd)(code);
         // Data.
        effects.consume(code);
        return data;
    }
    function contentEnd(code) {
        effects.exit('chunkContent');
        effects.exit('content');
        return ok(code);
    }
    function contentContinue(code) {
        effects.consume(code);
        effects.exit('chunkContent');
        previous = previous.next = effects.enter('chunkContent', {
            contentType: 'content',
            previous: previous
        });
        return data;
    }
}
function $75a58b9a2355426e$var$tokenizeContinuation(effects, ok, nok) {
    var self = this;
    return startLookahead;
    function startLookahead(code) {
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        return $12DO2(effects, prefixed, 'linePrefix');
    }
    function prefixed(code) {
        if (code === null || $52d6Z(code)) return nok(code);
        if (self.parser.constructs.disable.null.indexOf('codeIndented') > -1 || $9gPhT(self.events, 'linePrefix') < 4) return effects.interrupt(self.parser.constructs.flow, nok, ok)(code);
        return ok(code);
    }
}
module.exports = $75a58b9a2355426e$var$content;

});
parcelRegister("9gPhT", function(module, exports) {
'use strict';

var $i9qol = parcelRequire("i9qol");
function $6bfd644e33792e99$var$prefixSize(events, type) {
    var tail = events[events.length - 1];
    if (!tail || tail[1].type !== type) return 0;
    return $i9qol(tail[2].sliceStream(tail[1]));
}
module.exports = $6bfd644e33792e99$var$prefixSize;

});
parcelRegister("i9qol", function(module, exports) {
'use strict';
// Counts tabs based on their expanded size, and CR+LF as one character.
function $d36d8a1593dc4050$var$sizeChunks(chunks) {
    var index = -1;
    var size = 0;
    while(++index < chunks.length)size += typeof chunks[index] === 'string' ? chunks[index].length : 1;
    return size;
}
module.exports = $d36d8a1593dc4050$var$sizeChunks;

});


parcelRegister("hJSf6", function(module, exports) {
'use strict';

var $jhqC9 = parcelRequire("jhqC9");

var $jqdTZ = parcelRequire("jqdTZ");

var $dmdD5 = parcelRequire("dmdD5");
function $cea0b71624886722$var$subtokenize(events) {
    var jumps = {};
    var index = -1;
    var event;
    var lineIndex;
    var otherIndex;
    var otherEvent;
    var parameters;
    var subevents;
    var more;
    while(++index < events.length){
        while(index in jumps)index = jumps[index];
        event = events[index] // Add a hook for the GFM tasklist extension, which needs to know if text
        ;
        // is in the first content of a list item.
        if (index && event[1].type === 'chunkFlow' && events[index - 1][1].type === 'listItemPrefix') {
            subevents = event[1]._tokenizer.events;
            otherIndex = 0;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === 'lineEndingBlank') otherIndex += 2;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === 'content') while(++otherIndex < subevents.length){
                if (subevents[otherIndex][1].type === 'content') break;
                if (subevents[otherIndex][1].type === 'chunkText') {
                    subevents[otherIndex][1].isInFirstContentOfListItem = true;
                    otherIndex++;
                }
            }
        } // Enter.
        if (event[0] === 'enter') {
            if (event[1].contentType) {
                $jhqC9(jumps, $cea0b71624886722$var$subcontent(events, index));
                index = jumps[index];
                more = true;
            }
        } else if (event[1]._container || event[1]._movePreviousLineEndings) {
            otherIndex = index;
            lineIndex = undefined;
            while(otherIndex--){
                otherEvent = events[otherIndex];
                if (otherEvent[1].type === 'lineEnding' || otherEvent[1].type === 'lineEndingBlank') {
                    if (otherEvent[0] === 'enter') {
                        if (lineIndex) events[lineIndex][1].type = 'lineEndingBlank';
                        otherEvent[1].type = 'lineEnding';
                        lineIndex = otherIndex;
                    }
                } else break;
            }
            if (lineIndex) {
                // Fix position.
                event[1].end = $dmdD5(events[lineIndex][1].start) // Switch container exit w/ line endings.
                ;
                parameters = events.slice(lineIndex, index);
                parameters.unshift(event);
                $jqdTZ(events, lineIndex, index - lineIndex + 1, parameters);
            }
        }
    }
    return !more;
}
function $cea0b71624886722$var$subcontent(events, eventIndex) {
    var token = events[eventIndex][1];
    var context = events[eventIndex][2];
    var startPosition = eventIndex - 1;
    var startPositions = [];
    var tokenizer = token._tokenizer || context.parser[token.contentType](token.start);
    var childEvents = tokenizer.events;
    var jumps = [];
    var gaps = {};
    var stream;
    var previous;
    var index;
    var entered;
    var end;
    var adjust // Loop forward through the linked tokens to pass them in order to the
    ;
    // subtokenizer.
    while(token){
        // Find the position of the event for this token.
        while(events[++startPosition][1] !== token);
        startPositions.push(startPosition);
        if (!token._tokenizer) {
            stream = context.sliceStream(token);
            if (!token.next) stream.push(null);
            if (previous) tokenizer.defineSkip(token.start);
            if (token.isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = true;
            tokenizer.write(stream);
            if (token.isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = undefined;
        } // Unravel the next token.
        previous = token;
        token = token.next;
    } // Now, loop back through all events (and linked tokens), to figure out which
    // parts belong where.
    token = previous;
    index = childEvents.length;
    while(index--){
        // Make sure we’ve at least seen something (final eol is part of the last
        // token).
        if (childEvents[index][0] === 'enter') entered = true;
        else if (// Find a void token that includes a break.
        entered && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
            add(childEvents.slice(index + 1, end));
            // Help GC.
            token._tokenizer = token.next = undefined;
            token = token.previous;
            end = index + 1;
        }
    }
    // Help GC.
    tokenizer.events = token._tokenizer = token.next = undefined // Do head:
    ;
    add(childEvents.slice(0, end));
    index = -1;
    adjust = 0;
    while(++index < jumps.length){
        gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
        adjust += jumps[index][1] - jumps[index][0] - 1;
    }
    return gaps;
    function add(slice) {
        var start = startPositions.pop();
        jumps.unshift([
            start,
            start + slice.length - 1
        ]);
        $jqdTZ(events, start, 2, slice);
    }
}
module.exports = $cea0b71624886722$var$subtokenize;

});
parcelRegister("jqdTZ", function(module, exports) {
'use strict';

var $jDGhN = parcelRequire("jDGhN");
// causes a stack overflow in V8 when trying to insert 100k items for instance.
function $e23b3aaa189e1dcd$var$chunkedSplice(list, start, remove, items) {
    var end = list.length;
    var chunkStart = 0;
    var parameters // Make start between zero and `end` (included).
    ;
    if (start < 0) start = -start > end ? 0 : end + start;
    else start = start > end ? end : start;
    remove = remove > 0 ? remove : 0 // No need to chunk the items if there’s only a couple (10k) items.
    ;
    if (items.length < 10000) {
        parameters = Array.from(items);
        parameters.unshift(start, remove);
        $jDGhN.apply(list, parameters);
    } else {
        // Delete `remove` items starting from `start`
        if (remove) $jDGhN.apply(list, [
            start,
            remove
        ]) // Insert the items in chunks to not cause stack overflows.
        ;
        while(chunkStart < items.length){
            parameters = items.slice(chunkStart, chunkStart + 10000);
            parameters.unshift(start, 0);
            $jDGhN.apply(list, parameters);
            chunkStart += 10000;
            start += 10000;
        }
    }
}
module.exports = $e23b3aaa189e1dcd$var$chunkedSplice;

});
parcelRegister("jDGhN", function(module, exports) {
'use strict';
var $e4c275f12f78e5ac$var$splice = [].splice;
module.exports = $e4c275f12f78e5ac$var$splice;

});


parcelRegister("dmdD5", function(module, exports) {
'use strict';

var $jhqC9 = parcelRequire("jhqC9");
function $9b97e6f96fc62728$var$shallow(object) {
    return $jhqC9({}, object);
}
module.exports = $9b97e6f96fc62728$var$shallow;

});




parcelRegister("h7bJy", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $jhqC9 = parcelRequire("jhqC9");

var $dmdD5 = parcelRequire("dmdD5");
var $c75c313671d6980e$var$text = $c75c313671d6980e$var$initializeFactory('text');
var $c75c313671d6980e$var$string = $c75c313671d6980e$var$initializeFactory('string');
var $c75c313671d6980e$var$resolver = {
    resolveAll: $c75c313671d6980e$var$createResolver()
};
function $c75c313671d6980e$var$initializeFactory(field) {
    return {
        tokenize: initializeText,
        resolveAll: $c75c313671d6980e$var$createResolver(field === 'text' ? $c75c313671d6980e$var$resolveAllLineSuffixes : undefined)
    };
    function initializeText(effects) {
        var self = this;
        var constructs = this.parser.constructs[field];
        var text = effects.attempt(constructs, start, notText);
        return start;
        function start(code) {
            return atBreak(code) ? text(code) : notText(code);
        }
        function notText(code) {
            if (code === null) {
                effects.consume(code);
                return;
            }
            effects.enter('data');
            effects.consume(code);
            return data;
        }
        function data(code) {
            if (atBreak(code)) {
                effects.exit('data');
                return text(code);
            } // Data.
            effects.consume(code);
            return data;
        }
        function atBreak(code) {
            var list = constructs[code];
            var index = -1;
            if (code === null) return true;
            if (list) while(++index < list.length){
                if (!list[index].previous || list[index].previous.call(self, self.previous)) return true;
            }
        }
    }
}
function $c75c313671d6980e$var$createResolver(extraResolver) {
    return resolveAllText;
    function resolveAllText(events, context) {
        var index = -1;
        var enter // A rather boring computation (to merge adjacent `data` events) which
        ;
        // improves mm performance by 29%.
        while(++index <= events.length){
            if (enter === undefined) {
                if (events[index] && events[index][1].type === 'data') {
                    enter = index;
                    index++;
                }
            } else if (!events[index] || events[index][1].type !== 'data') {
                // Don’t do anything if there is one data token.
                if (index !== enter + 2) {
                    events[enter][1].end = events[index - 1][1].end;
                    events.splice(enter + 2, index - enter - 2);
                    index = enter + 2;
                }
                enter = undefined;
            }
        }
        return extraResolver ? extraResolver(events, context) : events;
    }
} // A rather ugly set of instructions which again looks at chunks in the input
// stream.
// The reason to do this here is that it is *much* faster to parse in reverse.
// And that we can’t hook into `null` to split the line suffix before an EOF.
// To do: figure out if we can make this into a clean utility, or even in core.
// As it will be useful for GFMs literal autolink extension (and maybe even
// tables?)
function $c75c313671d6980e$var$resolveAllLineSuffixes(events, context) {
    var eventIndex = -1;
    var chunks;
    var data;
    var chunk;
    var index;
    var bufferIndex;
    var size;
    var tabs;
    var token;
    while(++eventIndex <= events.length)if ((eventIndex === events.length || events[eventIndex][1].type === 'lineEnding') && events[eventIndex - 1][1].type === 'data') {
        data = events[eventIndex - 1][1];
        chunks = context.sliceStream(data);
        index = chunks.length;
        bufferIndex = -1;
        size = 0;
        tabs = undefined;
        while(index--){
            chunk = chunks[index];
            if (typeof chunk === 'string') {
                bufferIndex = chunk.length;
                while(chunk.charCodeAt(bufferIndex - 1) === 32){
                    size++;
                    bufferIndex--;
                }
                if (bufferIndex) break;
                bufferIndex = -1;
            } else if (chunk === -2) {
                tabs = true;
                size++;
            } else if (chunk === -1) ;
            else {
                // Replacement character, exit.
                index++;
                break;
            }
        }
        if (size) {
            token = {
                type: eventIndex === events.length || tabs || size < 2 ? 'lineSuffix' : 'hardBreakTrailing',
                start: {
                    line: data.end.line,
                    column: data.end.column - size,
                    offset: data.end.offset - size,
                    _index: data.start._index + index,
                    _bufferIndex: index ? bufferIndex : data.start._bufferIndex + bufferIndex
                },
                end: $dmdD5(data.end)
            };
            data.end = $dmdD5(token.start);
            if (data.start.offset === data.end.offset) $jhqC9(data, token);
            else {
                events.splice(eventIndex, 0, [
                    'enter',
                    token,
                    context
                ], [
                    'exit',
                    token,
                    context
                ]);
                eventIndex += 2;
            }
        }
        eventIndex++;
    }
    return events;
}
module.exports.resolver = $c75c313671d6980e$var$resolver;
module.exports.string = $c75c313671d6980e$var$string;
module.exports.text = $c75c313671d6980e$var$text;

});

parcelRegister("9bmBd", function(module, exports) {
'use strict';

var $2ZIIm = parcelRequire("2ZIIm");

var $jqdTZ = parcelRequire("jqdTZ");

var $iHnGQ = parcelRequire("iHnGQ");
function $6af6abdf6a332826$var$combineExtensions(extensions) {
    var all = {};
    var index = -1;
    while(++index < extensions.length)$6af6abdf6a332826$var$extension(all, extensions[index]);
    return all;
}
function $6af6abdf6a332826$var$extension(all, extension) {
    var hook;
    var left;
    var right;
    var code;
    for(hook in extension){
        left = $2ZIIm.call(all, hook) ? all[hook] : all[hook] = {};
        right = extension[hook];
        for(code in right)left[code] = $6af6abdf6a332826$var$constructs($iHnGQ(right[code]), $2ZIIm.call(left, code) ? left[code] : []);
    }
}
function $6af6abdf6a332826$var$constructs(list, existing) {
    var index = -1;
    var before = [];
    while(++index < list.length)(list[index].add === 'after' ? existing : before).push(list[index]);
    $jqdTZ(existing, 0, 0, before);
    return existing;
}
module.exports = $6af6abdf6a332826$var$combineExtensions;

});
parcelRegister("iHnGQ", function(module, exports) {
'use strict';
function $d9ce9e81aa5aef0b$var$miniflat(value) {
    return value === null || value === undefined ? [] : 'length' in value ? value : [
        value
    ];
}
module.exports = $d9ce9e81aa5aef0b$var$miniflat;

});


parcelRegister("hyL4W", function(module, exports) {
'use strict';

var $jhqC9 = parcelRequire("jhqC9");

var $52d6Z = parcelRequire("52d6Z");

var $ilKDT = parcelRequire("ilKDT");

var $jqdTZ = parcelRequire("jqdTZ");

var $iHnGQ = parcelRequire("iHnGQ");

var $uWhOk = parcelRequire("uWhOk");

var $1AQgp = parcelRequire("1AQgp");

var $dmdD5 = parcelRequire("dmdD5");

var $7gBuo = parcelRequire("7gBuo");
// Create a tokenizer.
// Tokenizers deal with one type of data (e.g., containers, flow, text).
// The parser is the object dealing with it all.
// `initialize` works like other constructs, except that only its `tokenize`
// function is used, in which case it doesn’t receive an `ok` or `nok`.
// `from` can be given to set the point before the first character, although
// when further lines are indented, they must be set with `defineSkip`.
function $cc8a217e089b5cd2$var$createTokenizer(parser, initialize, from) {
    var point = from ? $dmdD5(from) : {
        line: 1,
        column: 1,
        offset: 0
    };
    var columnStart = {};
    var resolveAllConstructs = [];
    var chunks = [];
    var stack = [];
    var effects = {
        consume: consume,
        enter: enter,
        exit: exit,
        attempt: constructFactory(onsuccessfulconstruct),
        check: constructFactory(onsuccessfulcheck),
        interrupt: constructFactory(onsuccessfulcheck, {
            interrupt: true
        }),
        lazy: constructFactory(onsuccessfulcheck, {
            lazy: true
        })
    } // State and tools for resolving and serializing.
    ;
    var context = {
        previous: null,
        events: [],
        parser: parser,
        sliceStream: sliceStream,
        sliceSerialize: sliceSerialize,
        now: now,
        defineSkip: skip,
        write: write
    } // The state function.
    ;
    var state = initialize.tokenize.call(context, effects) // Track which character we expect to be consumed, to catch bugs.
    ;
    if (initialize.resolveAll) resolveAllConstructs.push(initialize);
     // Store where we are in the input stream.
    point._index = 0;
    point._bufferIndex = -1;
    return context;
    function write(slice) {
        chunks = $ilKDT(chunks, slice);
        main() // Exit if we’re not done, resolve might change stuff.
        ;
        if (chunks[chunks.length - 1] !== null) return [];
        addResult(initialize, 0) // Otherwise, resolve, and exit.
        ;
        context.events = $uWhOk(resolveAllConstructs, context.events, context);
        return context.events;
    } //
    // Tools.
    //
    function sliceSerialize(token) {
        return $1AQgp(sliceStream(token));
    }
    function sliceStream(token) {
        return $7gBuo(chunks, token);
    }
    function now() {
        return $dmdD5(point);
    }
    function skip(value) {
        columnStart[value.line] = value.column;
        accountForPotentialSkip();
    } //
    // State management.
    //
    // Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
    // `consume`).
    // Here is where we walk through the chunks, which either include strings of
    // several characters, or numerical character codes.
    // The reason to do this in a loop instead of a call is so the stack can
    // drain.
    function main() {
        var chunkIndex;
        var chunk;
        while(point._index < chunks.length){
            chunk = chunks[point._index] // If we’re in a buffer chunk, loop through it.
            ;
            if (typeof chunk === 'string') {
                chunkIndex = point._index;
                if (point._bufferIndex < 0) point._bufferIndex = 0;
                while(point._index === chunkIndex && point._bufferIndex < chunk.length)go(chunk.charCodeAt(point._bufferIndex));
            } else go(chunk);
        }
    } // Deal with one code.
    function go(code) {
        state = state(code);
    } // Move a character forward.
    function consume(code) {
        if ($52d6Z(code)) {
            point.line++;
            point.column = 1;
            point.offset += code === -3 ? 2 : 1;
            accountForPotentialSkip();
        } else if (code !== -1) {
            point.column++;
            point.offset++;
        } // Not in a string chunk.
        if (point._bufferIndex < 0) point._index++;
        else {
            point._bufferIndex++ // At end of string chunk.
            ;
            if (point._bufferIndex === chunks[point._index].length) {
                point._bufferIndex = -1;
                point._index++;
            }
        } // Expose the previous character.
        context.previous = code // Mark as consumed.
        ;
    } // Start a token.
    function enter(type, fields) {
        var token = fields || {};
        token.type = type;
        token.start = now();
        context.events.push([
            'enter',
            token,
            context
        ]);
        stack.push(token);
        return token;
    } // Stop a token.
    function exit(type) {
        var token = stack.pop();
        token.end = now();
        context.events.push([
            'exit',
            token,
            context
        ]);
        return token;
    } // Use results.
    function onsuccessfulconstruct(construct, info) {
        addResult(construct, info.from);
    } // Discard results.
    function onsuccessfulcheck(construct, info) {
        info.restore();
    } // Factory to attempt/check/interrupt.
    function constructFactory(onreturn, fields) {
        return hook // Handle either an object mapping codes to constructs, a list of
        ;
        // constructs, or a single construct.
        function hook(constructs, returnState, bogusState) {
            var listOfConstructs;
            var constructIndex;
            var currentConstruct;
            var info;
            return constructs.tokenize || 'length' in constructs ? handleListOfConstructs($iHnGQ(constructs)) : handleMapOfConstructs;
            function handleMapOfConstructs(code) {
                if (code in constructs || null in constructs) return handleListOfConstructs(constructs.null ? /* c8 ignore next */ $iHnGQ(constructs[code]).concat($iHnGQ(constructs.null)) : constructs[code])(code);
                return bogusState(code);
            }
            function handleListOfConstructs(list) {
                listOfConstructs = list;
                constructIndex = 0;
                return handleConstruct(list[constructIndex]);
            }
            function handleConstruct(construct) {
                return start;
                function start(code) {
                    // To do: not nede to store if there is no bogus state, probably?
                    // Currently doesn’t work because `inspect` in document does a check
                    // w/o a bogus, which doesn’t make sense. But it does seem to help perf
                    // by not storing.
                    info = store();
                    currentConstruct = construct;
                    if (!construct.partial) context.currentConstruct = construct;
                    if (construct.name && context.parser.constructs.disable.null.indexOf(construct.name) > -1) return nok();
                    return construct.tokenize.call(fields ? $jhqC9({}, context, fields) : context, effects, ok, nok)(code);
                }
            }
            function ok(code) {
                onreturn(currentConstruct, info);
                return returnState;
            }
            function nok(code) {
                info.restore();
                if (++constructIndex < listOfConstructs.length) return handleConstruct(listOfConstructs[constructIndex]);
                return bogusState;
            }
        }
    }
    function addResult(construct, from) {
        if (construct.resolveAll && resolveAllConstructs.indexOf(construct) < 0) resolveAllConstructs.push(construct);
        if (construct.resolve) $jqdTZ(context.events, from, context.events.length - from, construct.resolve(context.events.slice(from), context));
        if (construct.resolveTo) context.events = construct.resolveTo(context.events, context);
    }
    function store() {
        var startPoint = now();
        var startPrevious = context.previous;
        var startCurrentConstruct = context.currentConstruct;
        var startEventsIndex = context.events.length;
        var startStack = Array.from(stack);
        return {
            restore: restore,
            from: startEventsIndex
        };
        function restore() {
            point = startPoint;
            context.previous = startPrevious;
            context.currentConstruct = startCurrentConstruct;
            context.events.length = startEventsIndex;
            stack = startStack;
            accountForPotentialSkip();
        }
    }
    function accountForPotentialSkip() {
        if (point.line in columnStart && point.column < 2) {
            point.column = columnStart[point.line];
            point.offset += columnStart[point.line] - 1;
        }
    }
}
module.exports = $cc8a217e089b5cd2$var$createTokenizer;

});
parcelRegister("ilKDT", function(module, exports) {
'use strict';

var $jqdTZ = parcelRequire("jqdTZ");
function $d5be5e5d79d79abb$var$chunkedPush(list, items) {
    if (list.length) {
        $jqdTZ(list, list.length, 0, items);
        return list;
    }
    return items;
}
module.exports = $d5be5e5d79d79abb$var$chunkedPush;

});

parcelRegister("uWhOk", function(module, exports) {
'use strict';
function $05d003e55d346c9b$var$resolveAll(constructs, events, context) {
    var called = [];
    var index = -1;
    var resolve;
    while(++index < constructs.length){
        resolve = constructs[index].resolveAll;
        if (resolve && called.indexOf(resolve) < 0) {
            events = resolve(events, context);
            called.push(resolve);
        }
    }
    return events;
}
module.exports = $05d003e55d346c9b$var$resolveAll;

});

parcelRegister("1AQgp", function(module, exports) {
'use strict';

var $dBi5Y = parcelRequire("dBi5Y");
function $1291b1b483b740e3$var$serializeChunks(chunks) {
    var index = -1;
    var result = [];
    var chunk;
    var value;
    var atTab;
    while(++index < chunks.length){
        chunk = chunks[index];
        if (typeof chunk === 'string') value = chunk;
        else if (chunk === -5) value = '\r';
        else if (chunk === -4) value = '\n';
        else if (chunk === -3) value = "\r\n";
        else if (chunk === -2) value = '\t';
        else if (chunk === -1) {
            if (atTab) continue;
            value = ' ';
        } else // Currently only replacement character.
        value = $dBi5Y(chunk);
        atTab = chunk === -2;
        result.push(value);
    }
    return result.join('');
}
module.exports = $1291b1b483b740e3$var$serializeChunks;

});

parcelRegister("7gBuo", function(module, exports) {
'use strict';
function $54a71b94768fe2a0$var$sliceChunks(chunks, token) {
    var startIndex = token.start._index;
    var startBufferIndex = token.start._bufferIndex;
    var endIndex = token.end._index;
    var endBufferIndex = token.end._bufferIndex;
    var view;
    if (startIndex === endIndex) view = [
        chunks[startIndex].slice(startBufferIndex, endBufferIndex)
    ];
    else {
        view = chunks.slice(startIndex, endIndex);
        if (startBufferIndex > -1) view[0] = view[0].slice(startBufferIndex);
        if (endBufferIndex > 0) view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
    return view;
}
module.exports = $54a71b94768fe2a0$var$sliceChunks;

});


parcelRegister("4Vr4H", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $h7bJy = parcelRequire("h7bJy");

var $gNvDy = parcelRequire("gNvDy");

var $10el5 = parcelRequire("10el5");

var $8TSNS = parcelRequire("8TSNS");

var $goe1x = parcelRequire("goe1x");

var $4OSIW = parcelRequire("4OSIW");

var $USwiJ = parcelRequire("USwiJ");

var $fknb8 = parcelRequire("fknb8");

var $eCKPC = parcelRequire("eCKPC");

var $f4fso = parcelRequire("f4fso");

var $1L22T = parcelRequire("1L22T");

var $hNEBZ = parcelRequire("hNEBZ");

var $7k59L = parcelRequire("7k59L");

var $kspPu = parcelRequire("kspPu");

var $7CZcz = parcelRequire("7CZcz");

var $c9UQ2 = parcelRequire("c9UQ2");

var $6z2zH = parcelRequire("6z2zH");

var $gRGFa = parcelRequire("gRGFa");

var $484wK = parcelRequire("484wK");

var $cp9zf = parcelRequire("cp9zf");

var $3Hn2y = parcelRequire("3Hn2y");
var $39617ccc98429dcd$var$document = {
    42: $484wK,
    // Asterisk
    43: $484wK,
    // Plus sign
    45: $484wK,
    // Dash
    48: $484wK,
    // 0
    49: $484wK,
    // 1
    50: $484wK,
    // 2
    51: $484wK,
    // 3
    52: $484wK,
    // 4
    53: $484wK,
    // 5
    54: $484wK,
    // 6
    55: $484wK,
    // 7
    56: $484wK,
    // 8
    57: $484wK,
    // 9
    62: $8TSNS // Greater than
};
var $39617ccc98429dcd$var$contentInitial = {
    91: $f4fso // Left square bracket
};
var $39617ccc98429dcd$var$flowInitial = {
    '-2': $fknb8,
    // Horizontal tab
    '-1': $fknb8,
    // Virtual space
    32: $fknb8 // Space
};
var $39617ccc98429dcd$var$flow = {
    35: $hNEBZ,
    // Number sign
    42: $3Hn2y,
    // Asterisk
    45: [
        $cp9zf,
        $3Hn2y
    ],
    // Dash
    60: $7k59L,
    // Less than
    61: $cp9zf,
    // Equals to
    95: $3Hn2y,
    // Underscore
    96: $USwiJ,
    // Grave accent
    126: $USwiJ // Tilde
};
var $39617ccc98429dcd$var$string = {
    38: $4OSIW,
    // Ampersand
    92: $goe1x // Backslash
};
var $39617ccc98429dcd$var$text = {
    '-5': $gRGFa,
    // Carriage return
    '-4': $gRGFa,
    // Line feed
    '-3': $gRGFa,
    // Carriage return + line feed
    33: $c9UQ2,
    // Exclamation mark
    38: $4OSIW,
    // Ampersand
    42: $gNvDy,
    // Asterisk
    60: [
        $10el5,
        $kspPu
    ],
    // Less than
    91: $6z2zH,
    // Left square bracket
    92: [
        $1L22T,
        $goe1x
    ],
    // Backslash
    93: $7CZcz,
    // Right square bracket
    95: $gNvDy,
    // Underscore
    96: $eCKPC // Grave accent
};
var $39617ccc98429dcd$var$insideSpan = {
    null: [
        $gNvDy,
        $h7bJy.resolver
    ]
};
var $39617ccc98429dcd$var$disable = {
    null: []
};
module.exports.contentInitial = $39617ccc98429dcd$var$contentInitial;
module.exports.disable = $39617ccc98429dcd$var$disable;
module.exports.document = $39617ccc98429dcd$var$document;
module.exports.flow = $39617ccc98429dcd$var$flow;
module.exports.flowInitial = $39617ccc98429dcd$var$flowInitial;
module.exports.insideSpan = $39617ccc98429dcd$var$insideSpan;
module.exports.string = $39617ccc98429dcd$var$string;
module.exports.text = $39617ccc98429dcd$var$text;

});
parcelRegister("gNvDy", function(module, exports) {
'use strict';

var $ilKDT = parcelRequire("ilKDT");

var $jqdTZ = parcelRequire("jqdTZ");

var $iTgpu = parcelRequire("iTgpu");

var $4OukW = parcelRequire("4OukW");

var $uWhOk = parcelRequire("uWhOk");

var $dmdD5 = parcelRequire("dmdD5");
var $c3a9c3688638f493$var$attention = {
    name: 'attention',
    tokenize: $c3a9c3688638f493$var$tokenizeAttention,
    resolveAll: $c3a9c3688638f493$var$resolveAllAttention
};
function $c3a9c3688638f493$var$resolveAllAttention(events, context) {
    var index = -1;
    var open;
    var group;
    var text;
    var openingSequence;
    var closingSequence;
    var use;
    var nextEvents;
    var offset // Walk through all events.
    ;
    //
    // Note: performance of this is fine on an mb of normal markdown, but it’s
    // a bottleneck for malicious stuff.
    while(++index < events.length)// Find a token that can close.
    if (events[index][0] === 'enter' && events[index][1].type === 'attentionSequence' && events[index][1]._close) {
        open = index // Now walk back to find an opener.
        ;
        while(open--)// Find a token that can open the closer.
        if (events[open][0] === 'exit' && events[open][1].type === 'attentionSequence' && events[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
            // If the opening can close or the closing can open,
            // and the close size *is not* a multiple of three,
            // but the sum of the opening and closing size *is* multiple of three,
            // then don’t match.
            if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) continue;
             // Number of markers to use from the sequence.
            use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
            openingSequence = {
                type: use > 1 ? 'strongSequence' : 'emphasisSequence',
                start: $4OukW($dmdD5(events[open][1].end), -use),
                end: $dmdD5(events[open][1].end)
            };
            closingSequence = {
                type: use > 1 ? 'strongSequence' : 'emphasisSequence',
                start: $dmdD5(events[index][1].start),
                end: $4OukW($dmdD5(events[index][1].start), use)
            };
            text = {
                type: use > 1 ? 'strongText' : 'emphasisText',
                start: $dmdD5(events[open][1].end),
                end: $dmdD5(events[index][1].start)
            };
            group = {
                type: use > 1 ? 'strong' : 'emphasis',
                start: $dmdD5(openingSequence.start),
                end: $dmdD5(closingSequence.end)
            };
            events[open][1].end = $dmdD5(openingSequence.start);
            events[index][1].start = $dmdD5(closingSequence.end);
            nextEvents = [] // If there are more markers in the opening, add them before.
            ;
            if (events[open][1].end.offset - events[open][1].start.offset) nextEvents = $ilKDT(nextEvents, [
                [
                    'enter',
                    events[open][1],
                    context
                ],
                [
                    'exit',
                    events[open][1],
                    context
                ]
            ]);
             // Opening.
            nextEvents = $ilKDT(nextEvents, [
                [
                    'enter',
                    group,
                    context
                ],
                [
                    'enter',
                    openingSequence,
                    context
                ],
                [
                    'exit',
                    openingSequence,
                    context
                ],
                [
                    'enter',
                    text,
                    context
                ]
            ]) // Between.
            ;
            nextEvents = $ilKDT(nextEvents, $uWhOk(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context)) // Closing.
            ;
            nextEvents = $ilKDT(nextEvents, [
                [
                    'exit',
                    text,
                    context
                ],
                [
                    'enter',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    group,
                    context
                ]
            ]) // If there are more markers in the closing, add them after.
            ;
            if (events[index][1].end.offset - events[index][1].start.offset) {
                offset = 2;
                nextEvents = $ilKDT(nextEvents, [
                    [
                        'enter',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        events[index][1],
                        context
                    ]
                ]);
            } else offset = 0;
            $jqdTZ(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - offset - 2;
            break;
        }
    }
     // Remove remaining sequences.
    index = -1;
    while(++index < events.length)if (events[index][1].type === 'attentionSequence') events[index][1].type = 'data';
    return events;
}
function $c3a9c3688638f493$var$tokenizeAttention(effects, ok) {
    var before = $iTgpu(this.previous);
    var marker;
    return start;
    function start(code) {
        effects.enter('attentionSequence');
        marker = code;
        return sequence(code);
    }
    function sequence(code) {
        var token;
        var after;
        var open;
        var close;
        if (code === marker) {
            effects.consume(code);
            return sequence;
        }
        token = effects.exit('attentionSequence');
        after = $iTgpu(code);
        open = !after || after === 2 && before;
        close = !before || before === 2 && after;
        token._open = marker === 42 ? open : open && (before || !close);
        token._close = marker === 42 ? close : close && (after || !open);
        return ok(code);
    }
}
module.exports = $c3a9c3688638f493$var$attention;

});
parcelRegister("iTgpu", function(module, exports) {
'use strict';

var $2NUjQ = parcelRequire("2NUjQ");

var $9guyx = parcelRequire("9guyx");

var $kcp7G = parcelRequire("kcp7G");
// Classify whether a character is unicode whitespace, unicode punctuation, or
// anything else.
// Used for attention (emphasis, strong), whose sequences can open or close
// based on the class of surrounding characters.
function $dc0a17c6ade30f4b$var$classifyCharacter(code) {
    if (code === null || $2NUjQ(code) || $kcp7G(code)) return 1;
    if ($9guyx(code)) return 2;
}
module.exports = $dc0a17c6ade30f4b$var$classifyCharacter;

});
parcelRegister("2NUjQ", function(module, exports) {
'use strict';
function $20abd831a37b0cec$var$markdownLineEndingOrSpace(code) {
    return code < 0 || code === 32;
}
module.exports = $20abd831a37b0cec$var$markdownLineEndingOrSpace;

});

parcelRegister("9guyx", function(module, exports) {
'use strict';

var $3S2rj = parcelRequire("3S2rj");

var $erzLB = parcelRequire("erzLB");
// In fact adds to the bundle size.
var $6bed4f7ddfab6d4d$var$unicodePunctuation = $erzLB($3S2rj);
module.exports = $6bed4f7ddfab6d4d$var$unicodePunctuation;

});
parcelRegister("3S2rj", function(module, exports) {
'use strict';
// This module is generated by `script/`.
//
// CommonMark handles attention (emphasis, strong) markers based on what comes
// before or after them.
// One such difference is if those characters are Unicode punctuation.
// This script is generated from the Unicode data.
var $2d184ea90b7df837$var$unicodePunctuation = /[!-\/:-@\[-`\{-~\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/;
module.exports = $2d184ea90b7df837$var$unicodePunctuation;

});

parcelRegister("erzLB", function(module, exports) {
'use strict';

var $dBi5Y = parcelRequire("dBi5Y");
function $a83f54da662f7e55$var$regexCheck(regex) {
    return check;
    function check(code) {
        return regex.test($dBi5Y(code));
    }
}
module.exports = $a83f54da662f7e55$var$regexCheck;

});


parcelRegister("kcp7G", function(module, exports) {
'use strict';

var $erzLB = parcelRequire("erzLB");
var $eb486a83385fcca5$var$unicodeWhitespace = $erzLB(/\s/);
module.exports = $eb486a83385fcca5$var$unicodeWhitespace;

});


parcelRegister("4OukW", function(module, exports) {
'use strict';
// chunks (replacement characters, tabs, or line endings).
function $38135d3094cc6ba4$var$movePoint(point, offset) {
    point.column += offset;
    point.offset += offset;
    point._bufferIndex += offset;
    return point;
}
module.exports = $38135d3094cc6ba4$var$movePoint;

});


parcelRegister("10el5", function(module, exports) {
'use strict';

var $a3Tr7 = parcelRequire("a3Tr7");

var $dWPhi = parcelRequire("dWPhi");

var $gaf5l = parcelRequire("gaf5l");

var $gvE9z = parcelRequire("gvE9z");
var $0bb0e9ff6308abb0$var$autolink = {
    name: 'autolink',
    tokenize: $0bb0e9ff6308abb0$var$tokenizeAutolink
};
function $0bb0e9ff6308abb0$var$tokenizeAutolink(effects, ok, nok) {
    var size = 1;
    return start;
    function start(code) {
        effects.enter('autolink');
        effects.enter('autolinkMarker');
        effects.consume(code);
        effects.exit('autolinkMarker');
        effects.enter('autolinkProtocol');
        return open;
    }
    function open(code) {
        if ($a3Tr7(code)) {
            effects.consume(code);
            return schemeOrEmailAtext;
        }
        return $gaf5l(code) ? emailAtext(code) : nok(code);
    }
    function schemeOrEmailAtext(code) {
        return code === 43 || code === 45 || code === 46 || $dWPhi(code) ? schemeInsideOrEmailAtext(code) : emailAtext(code);
    }
    function schemeInsideOrEmailAtext(code) {
        if (code === 58) {
            effects.consume(code);
            return urlInside;
        }
        if ((code === 43 || code === 45 || code === 46 || $dWPhi(code)) && size++ < 32) {
            effects.consume(code);
            return schemeInsideOrEmailAtext;
        }
        return emailAtext(code);
    }
    function urlInside(code) {
        if (code === 62) {
            effects.exit('autolinkProtocol');
            return end(code);
        }
        if (code === 32 || code === 60 || $gvE9z(code)) return nok(code);
        effects.consume(code);
        return urlInside;
    }
    function emailAtext(code) {
        if (code === 64) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if ($gaf5l(code)) {
            effects.consume(code);
            return emailAtext;
        }
        return nok(code);
    }
    function emailAtSignOrDot(code) {
        return $dWPhi(code) ? emailLabel(code) : nok(code);
    }
    function emailLabel(code) {
        if (code === 46) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if (code === 62) {
            // Exit, then change the type.
            effects.exit('autolinkProtocol').type = 'autolinkEmail';
            return end(code);
        }
        return emailValue(code);
    }
    function emailValue(code) {
        if ((code === 45 || $dWPhi(code)) && size++ < 63) {
            effects.consume(code);
            return code === 45 ? emailValue : emailLabel;
        }
        return nok(code);
    }
    function end(code) {
        effects.enter('autolinkMarker');
        effects.consume(code);
        effects.exit('autolinkMarker');
        effects.exit('autolink');
        return ok;
    }
}
module.exports = $0bb0e9ff6308abb0$var$autolink;

});
parcelRegister("a3Tr7", function(module, exports) {
'use strict';

var $erzLB = parcelRequire("erzLB");
var $75352fb79c2da5a0$var$asciiAlpha = $erzLB(/[A-Za-z]/);
module.exports = $75352fb79c2da5a0$var$asciiAlpha;

});

parcelRegister("dWPhi", function(module, exports) {
'use strict';

var $erzLB = parcelRequire("erzLB");
var $a27877dc2100350f$var$asciiAlphanumeric = $erzLB(/[\dA-Za-z]/);
module.exports = $a27877dc2100350f$var$asciiAlphanumeric;

});

parcelRegister("gaf5l", function(module, exports) {
'use strict';

var $erzLB = parcelRequire("erzLB");
var $bc4948242f942c13$var$asciiAtext = $erzLB(/[#-'*+\--9=?A-Z^-~]/);
module.exports = $bc4948242f942c13$var$asciiAtext;

});

parcelRegister("gvE9z", function(module, exports) {
'use strict';
// Note: EOF is seen as ASCII control here, because `null < 32 == true`.
function $c04eb03b63f60a96$var$asciiControl(code) {
    return(// Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code < 32 || code === 127);
}
module.exports = $c04eb03b63f60a96$var$asciiControl;

});


parcelRegister("8TSNS", function(module, exports) {
'use strict';

var $ddAr7 = parcelRequire("ddAr7");

var $12DO2 = parcelRequire("12DO2");
var $67adf89911a460cd$var$blockQuote = {
    name: 'blockQuote',
    tokenize: $67adf89911a460cd$var$tokenizeBlockQuoteStart,
    continuation: {
        tokenize: $67adf89911a460cd$var$tokenizeBlockQuoteContinuation
    },
    exit: $67adf89911a460cd$var$exit
};
function $67adf89911a460cd$var$tokenizeBlockQuoteStart(effects, ok, nok) {
    var self = this;
    return start;
    function start(code) {
        if (code === 62) {
            if (!self.containerState.open) {
                effects.enter('blockQuote', {
                    _container: true
                });
                self.containerState.open = true;
            }
            effects.enter('blockQuotePrefix');
            effects.enter('blockQuoteMarker');
            effects.consume(code);
            effects.exit('blockQuoteMarker');
            return after;
        }
        return nok(code);
    }
    function after(code) {
        if ($ddAr7(code)) {
            effects.enter('blockQuotePrefixWhitespace');
            effects.consume(code);
            effects.exit('blockQuotePrefixWhitespace');
            effects.exit('blockQuotePrefix');
            return ok;
        }
        effects.exit('blockQuotePrefix');
        return ok(code);
    }
}
function $67adf89911a460cd$var$tokenizeBlockQuoteContinuation(effects, ok, nok) {
    return $12DO2(effects, effects.attempt($67adf89911a460cd$var$blockQuote, ok, nok), 'linePrefix', this.parser.constructs.disable.null.indexOf('codeIndented') > -1 ? undefined : 4);
}
function $67adf89911a460cd$var$exit(effects) {
    effects.exit('blockQuote');
}
module.exports = $67adf89911a460cd$var$blockQuote;

});

parcelRegister("goe1x", function(module, exports) {
'use strict';

var $l9c1F = parcelRequire("l9c1F");
var $bee9c40ffbd9fd96$var$characterEscape = {
    name: 'characterEscape',
    tokenize: $bee9c40ffbd9fd96$var$tokenizeCharacterEscape
};
function $bee9c40ffbd9fd96$var$tokenizeCharacterEscape(effects, ok, nok) {
    return start;
    function start(code) {
        effects.enter('characterEscape');
        effects.enter('escapeMarker');
        effects.consume(code);
        effects.exit('escapeMarker');
        return open;
    }
    function open(code) {
        if ($l9c1F(code)) {
            effects.enter('characterEscapeValue');
            effects.consume(code);
            effects.exit('characterEscapeValue');
            effects.exit('characterEscape');
            return ok;
        }
        return nok(code);
    }
}
module.exports = $bee9c40ffbd9fd96$var$characterEscape;

});
parcelRegister("l9c1F", function(module, exports) {
'use strict';

var $erzLB = parcelRequire("erzLB");
var $f653c456e3fa641b$var$asciiPunctuation = $erzLB(/[!-/:-@[-`{-~]/);
module.exports = $f653c456e3fa641b$var$asciiPunctuation;

});


parcelRegister("4OSIW", function(module, exports) {
'use strict';

var $gpZto = parcelRequire("gpZto");

var $dWPhi = parcelRequire("dWPhi");

var $6UWEV = parcelRequire("6UWEV");

var $cV7K0 = parcelRequire("cV7K0");
function $382647ef1a0e9550$var$_interopDefaultLegacy(e) {
    return e && typeof e === 'object' && 'default' in e ? e : {
        default: e
    };
}
var $382647ef1a0e9550$var$decodeEntity__default = /*#__PURE__*/ $382647ef1a0e9550$var$_interopDefaultLegacy($gpZto);
var $382647ef1a0e9550$var$characterReference = {
    name: 'characterReference',
    tokenize: $382647ef1a0e9550$var$tokenizeCharacterReference
};
function $382647ef1a0e9550$var$tokenizeCharacterReference(effects, ok, nok) {
    var self = this;
    var size = 0;
    var max;
    var test;
    return start;
    function start(code) {
        effects.enter('characterReference');
        effects.enter('characterReferenceMarker');
        effects.consume(code);
        effects.exit('characterReferenceMarker');
        return open;
    }
    function open(code) {
        if (code === 35) {
            effects.enter('characterReferenceMarkerNumeric');
            effects.consume(code);
            effects.exit('characterReferenceMarkerNumeric');
            return numeric;
        }
        effects.enter('characterReferenceValue');
        max = 31;
        test = $dWPhi;
        return value(code);
    }
    function numeric(code) {
        if (code === 88 || code === 120) {
            effects.enter('characterReferenceMarkerHexadecimal');
            effects.consume(code);
            effects.exit('characterReferenceMarkerHexadecimal');
            effects.enter('characterReferenceValue');
            max = 6;
            test = $cV7K0;
            return value;
        }
        effects.enter('characterReferenceValue');
        max = 7;
        test = $6UWEV;
        return value(code);
    }
    function value(code) {
        var token;
        if (code === 59 && size) {
            token = effects.exit('characterReferenceValue');
            if (test === $dWPhi && !$382647ef1a0e9550$var$decodeEntity__default['default'](self.sliceSerialize(token))) return nok(code);
            effects.enter('characterReferenceMarker');
            effects.consume(code);
            effects.exit('characterReferenceMarker');
            effects.exit('characterReference');
            return ok;
        }
        if (test(code) && size++ < max) {
            effects.consume(code);
            return value;
        }
        return nok(code);
    }
}
module.exports = $382647ef1a0e9550$var$characterReference;

});
parcelRegister("gpZto", function(module, exports) {
'use strict';
/* eslint-env browser */ var $bf3eaa695bdae56b$var$el;
var $bf3eaa695bdae56b$var$semicolon = 59 //  ';'
;
module.exports = $bf3eaa695bdae56b$var$decodeEntity;
function $bf3eaa695bdae56b$var$decodeEntity(characters) {
    var entity = '&' + characters + ';';
    var char;
    $bf3eaa695bdae56b$var$el = $bf3eaa695bdae56b$var$el || document.createElement('i');
    $bf3eaa695bdae56b$var$el.innerHTML = entity;
    char = $bf3eaa695bdae56b$var$el.textContent;
    // Some entities do not require the closing semicolon (`&not` - for instance),
    // which leads to situations where parsing the assumed entity of &notit; will
    // result in the string `¬it;`.  When we encounter a trailing semicolon after
    // parsing and the entity to decode was not a semicolon (`&semi;`), we can
    // assume that the matching was incomplete
    if (char.charCodeAt(char.length - 1) === $bf3eaa695bdae56b$var$semicolon && characters !== 'semi') return false;
    // If the decoded string is equal to the input, the entity was not valid
    return char === entity ? false : char;
}

});

parcelRegister("6UWEV", function(module, exports) {
'use strict';

var $erzLB = parcelRequire("erzLB");
var $5095797ecaf3f6bc$var$asciiDigit = $erzLB(/\d/);
module.exports = $5095797ecaf3f6bc$var$asciiDigit;

});

parcelRegister("cV7K0", function(module, exports) {
'use strict';

var $erzLB = parcelRequire("erzLB");
var $9680d020e893d19e$var$asciiHexDigit = $erzLB(/[\dA-Fa-f]/);
module.exports = $9680d020e893d19e$var$asciiHexDigit;

});


parcelRegister("USwiJ", function(module, exports) {
'use strict';

var $52d6Z = parcelRequire("52d6Z");

var $2NUjQ = parcelRequire("2NUjQ");

var $9gPhT = parcelRequire("9gPhT");

var $12DO2 = parcelRequire("12DO2");
var $0aaf859c7b6bc4ef$var$codeFenced = {
    name: 'codeFenced',
    tokenize: $0aaf859c7b6bc4ef$var$tokenizeCodeFenced,
    concrete: true
};
function $0aaf859c7b6bc4ef$var$tokenizeCodeFenced(effects, ok, nok) {
    var self = this;
    var closingFenceConstruct = {
        tokenize: tokenizeClosingFence,
        partial: true
    };
    var initialPrefix = $9gPhT(this.events, 'linePrefix');
    var sizeOpen = 0;
    var marker;
    return start;
    function start(code) {
        effects.enter('codeFenced');
        effects.enter('codeFencedFence');
        effects.enter('codeFencedFenceSequence');
        marker = code;
        return sequenceOpen(code);
    }
    function sequenceOpen(code) {
        if (code === marker) {
            effects.consume(code);
            sizeOpen++;
            return sequenceOpen;
        }
        effects.exit('codeFencedFenceSequence');
        return sizeOpen < 3 ? nok(code) : $12DO2(effects, infoOpen, 'whitespace')(code);
    }
    function infoOpen(code) {
        if (code === null || $52d6Z(code)) return openAfter(code);
        effects.enter('codeFencedFenceInfo');
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return info(code);
    }
    function info(code) {
        if (code === null || $2NUjQ(code)) {
            effects.exit('chunkString');
            effects.exit('codeFencedFenceInfo');
            return $12DO2(effects, infoAfter, 'whitespace')(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return info;
    }
    function infoAfter(code) {
        if (code === null || $52d6Z(code)) return openAfter(code);
        effects.enter('codeFencedFenceMeta');
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return meta(code);
    }
    function meta(code) {
        if (code === null || $52d6Z(code)) {
            effects.exit('chunkString');
            effects.exit('codeFencedFenceMeta');
            return openAfter(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return meta;
    }
    function openAfter(code) {
        effects.exit('codeFencedFence');
        return self.interrupt ? ok(code) : content(code);
    }
    function content(code) {
        if (code === null) return after(code);
        if ($52d6Z(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return effects.attempt(closingFenceConstruct, after, initialPrefix ? $12DO2(effects, content, 'linePrefix', initialPrefix + 1) : content);
        }
        effects.enter('codeFlowValue');
        return contentContinue(code);
    }
    function contentContinue(code) {
        if (code === null || $52d6Z(code)) {
            effects.exit('codeFlowValue');
            return content(code);
        }
        effects.consume(code);
        return contentContinue;
    }
    function after(code) {
        effects.exit('codeFenced');
        return ok(code);
    }
    function tokenizeClosingFence(effects, ok, nok) {
        var size = 0;
        return $12DO2(effects, closingSequenceStart, 'linePrefix', this.parser.constructs.disable.null.indexOf('codeIndented') > -1 ? undefined : 4);
        function closingSequenceStart(code) {
            effects.enter('codeFencedFence');
            effects.enter('codeFencedFenceSequence');
            return closingSequence(code);
        }
        function closingSequence(code) {
            if (code === marker) {
                effects.consume(code);
                size++;
                return closingSequence;
            }
            if (size < sizeOpen) return nok(code);
            effects.exit('codeFencedFenceSequence');
            return $12DO2(effects, closingSequenceEnd, 'whitespace')(code);
        }
        function closingSequenceEnd(code) {
            if (code === null || $52d6Z(code)) {
                effects.exit('codeFencedFence');
                return ok(code);
            }
            return nok(code);
        }
    }
}
module.exports = $0aaf859c7b6bc4ef$var$codeFenced;

});

parcelRegister("fknb8", function(module, exports) {
'use strict';

var $52d6Z = parcelRequire("52d6Z");

var $jqdTZ = parcelRequire("jqdTZ");

var $9gPhT = parcelRequire("9gPhT");

var $12DO2 = parcelRequire("12DO2");
var $b28ab414470797f6$var$codeIndented = {
    name: 'codeIndented',
    tokenize: $b28ab414470797f6$var$tokenizeCodeIndented,
    resolve: $b28ab414470797f6$var$resolveCodeIndented
};
var $b28ab414470797f6$var$indentedContentConstruct = {
    tokenize: $b28ab414470797f6$var$tokenizeIndentedContent,
    partial: true
};
function $b28ab414470797f6$var$resolveCodeIndented(events, context) {
    var code = {
        type: 'codeIndented',
        start: events[0][1].start,
        end: events[events.length - 1][1].end
    };
    $jqdTZ(events, 0, 0, [
        [
            'enter',
            code,
            context
        ]
    ]);
    $jqdTZ(events, events.length, 0, [
        [
            'exit',
            code,
            context
        ]
    ]);
    return events;
}
function $b28ab414470797f6$var$tokenizeCodeIndented(effects, ok, nok) {
    return effects.attempt($b28ab414470797f6$var$indentedContentConstruct, afterPrefix, nok);
    function afterPrefix(code) {
        if (code === null) return ok(code);
        if ($52d6Z(code)) return effects.attempt($b28ab414470797f6$var$indentedContentConstruct, afterPrefix, ok)(code);
        effects.enter('codeFlowValue');
        return content(code);
    }
    function content(code) {
        if (code === null || $52d6Z(code)) {
            effects.exit('codeFlowValue');
            return afterPrefix(code);
        }
        effects.consume(code);
        return content;
    }
}
function $b28ab414470797f6$var$tokenizeIndentedContent(effects, ok, nok) {
    var self = this;
    return $12DO2(effects, afterPrefix, 'linePrefix', 5);
    function afterPrefix(code) {
        if ($52d6Z(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return $12DO2(effects, afterPrefix, 'linePrefix', 5);
        }
        return $9gPhT(self.events, 'linePrefix') < 4 ? nok(code) : ok(code);
    }
}
module.exports = $b28ab414470797f6$var$codeIndented;

});

parcelRegister("eCKPC", function(module, exports) {
'use strict';

var $52d6Z = parcelRequire("52d6Z");
var $aa58f10c5d21de8b$var$codeText = {
    name: 'codeText',
    tokenize: $aa58f10c5d21de8b$var$tokenizeCodeText,
    resolve: $aa58f10c5d21de8b$var$resolveCodeText,
    previous: $aa58f10c5d21de8b$var$previous
};
function $aa58f10c5d21de8b$var$resolveCodeText(events) {
    var tailExitIndex = events.length - 4;
    var headEnterIndex = 3;
    var index;
    var enter // If we start and end with an EOL or a space.
    ;
    if ((events[headEnterIndex][1].type === 'lineEnding' || events[headEnterIndex][1].type === 'space') && (events[tailExitIndex][1].type === 'lineEnding' || events[tailExitIndex][1].type === 'space')) {
        index = headEnterIndex // And we have data.
        ;
        while(++index < tailExitIndex)if (events[index][1].type === 'codeTextData') {
            // Then we have padding.
            events[tailExitIndex][1].type = events[headEnterIndex][1].type = 'codeTextPadding';
            headEnterIndex += 2;
            tailExitIndex -= 2;
            break;
        }
    } // Merge adjacent spaces and data.
    index = headEnterIndex - 1;
    tailExitIndex++;
    while(++index <= tailExitIndex){
        if (enter === undefined) {
            if (index !== tailExitIndex && events[index][1].type !== 'lineEnding') enter = index;
        } else if (index === tailExitIndex || events[index][1].type === 'lineEnding') {
            events[enter][1].type = 'codeTextData';
            if (index !== enter + 2) {
                events[enter][1].end = events[index - 1][1].end;
                events.splice(enter + 2, index - enter - 2);
                tailExitIndex -= index - enter - 2;
                index = enter + 2;
            }
            enter = undefined;
        }
    }
    return events;
}
function $aa58f10c5d21de8b$var$previous(code) {
    // If there is a previous code, there will always be a tail.
    return code !== 96 || this.events[this.events.length - 1][1].type === 'characterEscape';
}
function $aa58f10c5d21de8b$var$tokenizeCodeText(effects, ok, nok) {
    var sizeOpen = 0;
    var size;
    var token;
    return start;
    function start(code) {
        effects.enter('codeText');
        effects.enter('codeTextSequence');
        return openingSequence(code);
    }
    function openingSequence(code) {
        if (code === 96) {
            effects.consume(code);
            sizeOpen++;
            return openingSequence;
        }
        effects.exit('codeTextSequence');
        return gap(code);
    }
    function gap(code) {
        // EOF.
        if (code === null) return nok(code);
         // Closing fence?
        // Could also be data.
        if (code === 96) {
            token = effects.enter('codeTextSequence');
            size = 0;
            return closingSequence(code);
        } // Tabs don’t work, and virtual spaces don’t make sense.
        if (code === 32) {
            effects.enter('space');
            effects.consume(code);
            effects.exit('space');
            return gap;
        }
        if ($52d6Z(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return gap;
        } // Data.
        effects.enter('codeTextData');
        return data(code);
    } // In code.
    function data(code) {
        if (code === null || code === 32 || code === 96 || $52d6Z(code)) {
            effects.exit('codeTextData');
            return gap(code);
        }
        effects.consume(code);
        return data;
    } // Closing fence.
    function closingSequence(code) {
        // More.
        if (code === 96) {
            effects.consume(code);
            size++;
            return closingSequence;
        } // Done!
        if (size === sizeOpen) {
            effects.exit('codeTextSequence');
            effects.exit('codeText');
            return ok(code);
        } // More or less accents: mark as data.
        token.type = 'codeTextData';
        return data(code);
    }
}
module.exports = $aa58f10c5d21de8b$var$codeText;

});

parcelRegister("f4fso", function(module, exports) {
'use strict';

var $52d6Z = parcelRequire("52d6Z");

var $2NUjQ = parcelRequire("2NUjQ");

var $b6oju = parcelRequire("b6oju");

var $f820y = parcelRequire("f820y");

var $4HIQH = parcelRequire("4HIQH");

var $12DO2 = parcelRequire("12DO2");

var $QRTi2 = parcelRequire("QRTi2");

var $eHYrg = parcelRequire("eHYrg");
var $af83382e91bd7c56$var$definition = {
    name: 'definition',
    tokenize: $af83382e91bd7c56$var$tokenizeDefinition
};
var $af83382e91bd7c56$var$titleConstruct = {
    tokenize: $af83382e91bd7c56$var$tokenizeTitle,
    partial: true
};
function $af83382e91bd7c56$var$tokenizeDefinition(effects, ok, nok) {
    var self = this;
    var identifier;
    return start;
    function start(code) {
        effects.enter('definition');
        return $4HIQH.call(self, effects, labelAfter, nok, 'definitionLabel', 'definitionLabelMarker', 'definitionLabelString')(code);
    }
    function labelAfter(code) {
        identifier = $b6oju(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1));
        if (code === 58) {
            effects.enter('definitionMarker');
            effects.consume(code);
            effects.exit('definitionMarker') // Note: blank lines can’t exist in content.
            ;
            return $QRTi2(effects, $f820y(effects, effects.attempt($af83382e91bd7c56$var$titleConstruct, $12DO2(effects, after, 'whitespace'), $12DO2(effects, after, 'whitespace')), nok, 'definitionDestination', 'definitionDestinationLiteral', 'definitionDestinationLiteralMarker', 'definitionDestinationRaw', 'definitionDestinationString'));
        }
        return nok(code);
    }
    function after(code) {
        if (code === null || $52d6Z(code)) {
            effects.exit('definition');
            if (self.parser.defined.indexOf(identifier) < 0) self.parser.defined.push(identifier);
            return ok(code);
        }
        return nok(code);
    }
}
function $af83382e91bd7c56$var$tokenizeTitle(effects, ok, nok) {
    return start;
    function start(code) {
        return $2NUjQ(code) ? $QRTi2(effects, before)(code) : nok(code);
    }
    function before(code) {
        if (code === 34 || code === 39 || code === 40) return $eHYrg(effects, $12DO2(effects, after, 'whitespace'), nok, 'definitionTitle', 'definitionTitleMarker', 'definitionTitleString')(code);
        return nok(code);
    }
    function after(code) {
        return code === null || $52d6Z(code) ? ok(code) : nok(code);
    }
}
module.exports = $af83382e91bd7c56$var$definition;

});
parcelRegister("f820y", function(module, exports) {
'use strict';

var $gvE9z = parcelRequire("gvE9z");

var $2NUjQ = parcelRequire("2NUjQ");

var $52d6Z = parcelRequire("52d6Z");
// eslint-disable-next-line max-params
function $b03929214be69f84$var$destinationFactory(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max) {
    var limit = max || Infinity;
    var balance = 0;
    return start;
    function start(code) {
        if (code === 60) {
            effects.enter(type);
            effects.enter(literalType);
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            return destinationEnclosedBefore;
        }
        if ($gvE9z(code) || code === 41) return nok(code);
        effects.enter(type);
        effects.enter(rawType);
        effects.enter(stringType);
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return destinationRaw(code);
    }
    function destinationEnclosedBefore(code) {
        if (code === 62) {
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            effects.exit(literalType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return destinationEnclosed(code);
    }
    function destinationEnclosed(code) {
        if (code === 62) {
            effects.exit('chunkString');
            effects.exit(stringType);
            return destinationEnclosedBefore(code);
        }
        if (code === null || code === 60 || $52d6Z(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? destinationEnclosedEscape : destinationEnclosed;
    }
    function destinationEnclosedEscape(code) {
        if (code === 60 || code === 62 || code === 92) {
            effects.consume(code);
            return destinationEnclosed;
        }
        return destinationEnclosed(code);
    }
    function destinationRaw(code) {
        if (code === 40) {
            if (++balance > limit) return nok(code);
            effects.consume(code);
            return destinationRaw;
        }
        if (code === 41) {
            if (!balance--) {
                effects.exit('chunkString');
                effects.exit(stringType);
                effects.exit(rawType);
                effects.exit(type);
                return ok(code);
            }
            effects.consume(code);
            return destinationRaw;
        }
        if (code === null || $2NUjQ(code)) {
            if (balance) return nok(code);
            effects.exit('chunkString');
            effects.exit(stringType);
            effects.exit(rawType);
            effects.exit(type);
            return ok(code);
        }
        if ($gvE9z(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? destinationRawEscape : destinationRaw;
    }
    function destinationRawEscape(code) {
        if (code === 40 || code === 41 || code === 92) {
            effects.consume(code);
            return destinationRaw;
        }
        return destinationRaw(code);
    }
}
module.exports = $b03929214be69f84$var$destinationFactory;

});

parcelRegister("4HIQH", function(module, exports) {
'use strict';

var $52d6Z = parcelRequire("52d6Z");

var $ddAr7 = parcelRequire("ddAr7");
// eslint-disable-next-line max-params
function $36cdf7a69c813e22$var$labelFactory(effects, ok, nok, type, markerType, stringType) {
    var self = this;
    var size = 0;
    var data;
    return start;
    function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        effects.enter(stringType);
        return atBreak;
    }
    function atBreak(code) {
        if (code === null || code === 91 || code === 93 && !data || /* c8 ignore next */ code === 94 && /* c8 ignore next */ !size && /* c8 ignore next */ '_hiddenFootnoteSupport' in self.parser.constructs || size > 999) return nok(code);
        if (code === 93) {
            effects.exit(stringType);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        if ($52d6Z(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return atBreak;
        }
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return label(code);
    }
    function label(code) {
        if (code === null || code === 91 || code === 93 || $52d6Z(code) || size++ > 999) {
            effects.exit('chunkString');
            return atBreak(code);
        }
        effects.consume(code);
        data = data || !$ddAr7(code);
        return code === 92 ? labelEscape : label;
    }
    function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return label;
        }
        return label(code);
    }
}
module.exports = $36cdf7a69c813e22$var$labelFactory;

});

parcelRegister("QRTi2", function(module, exports) {
'use strict';

var $52d6Z = parcelRequire("52d6Z");

var $ddAr7 = parcelRequire("ddAr7");

var $12DO2 = parcelRequire("12DO2");
function $09eea9072c055d2e$var$whitespaceFactory(effects, ok) {
    var seen;
    return start;
    function start(code) {
        if ($52d6Z(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            seen = true;
            return start;
        }
        if ($ddAr7(code)) return $12DO2(effects, start, seen ? 'linePrefix' : 'lineSuffix')(code);
        return ok(code);
    }
}
module.exports = $09eea9072c055d2e$var$whitespaceFactory;

});

parcelRegister("eHYrg", function(module, exports) {
'use strict';

var $52d6Z = parcelRequire("52d6Z");

var $12DO2 = parcelRequire("12DO2");
function $ab53f6b4da8c37f6$var$titleFactory(effects, ok, nok, type, markerType, stringType) {
    var marker;
    return start;
    function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        marker = code === 40 ? 41 : code;
        return atFirstTitleBreak;
    }
    function atFirstTitleBreak(code) {
        if (code === marker) {
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        return atTitleBreak(code);
    }
    function atTitleBreak(code) {
        if (code === marker) {
            effects.exit(stringType);
            return atFirstTitleBreak(marker);
        }
        if (code === null) return nok(code);
         // Note: blank lines can’t exist in content.
        if ($52d6Z(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return $12DO2(effects, atTitleBreak, 'linePrefix');
        }
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return title(code);
    }
    function title(code) {
        if (code === marker || code === null || $52d6Z(code)) {
            effects.exit('chunkString');
            return atTitleBreak(code);
        }
        effects.consume(code);
        return code === 92 ? titleEscape : title;
    }
    function titleEscape(code) {
        if (code === marker || code === 92) {
            effects.consume(code);
            return title;
        }
        return title(code);
    }
}
module.exports = $ab53f6b4da8c37f6$var$titleFactory;

});


parcelRegister("1L22T", function(module, exports) {
'use strict';

var $52d6Z = parcelRequire("52d6Z");
var $147bc47b41bdd070$var$hardBreakEscape = {
    name: 'hardBreakEscape',
    tokenize: $147bc47b41bdd070$var$tokenizeHardBreakEscape
};
function $147bc47b41bdd070$var$tokenizeHardBreakEscape(effects, ok, nok) {
    return start;
    function start(code) {
        effects.enter('hardBreakEscape');
        effects.enter('escapeMarker');
        effects.consume(code);
        return open;
    }
    function open(code) {
        if ($52d6Z(code)) {
            effects.exit('escapeMarker');
            effects.exit('hardBreakEscape');
            return ok(code);
        }
        return nok(code);
    }
}
module.exports = $147bc47b41bdd070$var$hardBreakEscape;

});

parcelRegister("hNEBZ", function(module, exports) {
'use strict';

var $52d6Z = parcelRequire("52d6Z");

var $2NUjQ = parcelRequire("2NUjQ");

var $ddAr7 = parcelRequire("ddAr7");

var $jqdTZ = parcelRequire("jqdTZ");

var $12DO2 = parcelRequire("12DO2");
var $cf5683e834a08103$var$headingAtx = {
    name: 'headingAtx',
    tokenize: $cf5683e834a08103$var$tokenizeHeadingAtx,
    resolve: $cf5683e834a08103$var$resolveHeadingAtx
};
function $cf5683e834a08103$var$resolveHeadingAtx(events, context) {
    var contentEnd = events.length - 2;
    var contentStart = 3;
    var content;
    var text // Prefix whitespace, part of the opening.
    ;
    if (events[contentStart][1].type === 'whitespace') contentStart += 2;
     // Suffix whitespace, part of the closing.
    if (contentEnd - 2 > contentStart && events[contentEnd][1].type === 'whitespace') contentEnd -= 2;
    if (events[contentEnd][1].type === 'atxHeadingSequence' && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === 'whitespace')) contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
    if (contentEnd > contentStart) {
        content = {
            type: 'atxHeadingText',
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end
        };
        text = {
            type: 'chunkText',
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end,
            contentType: 'text'
        };
        $jqdTZ(events, contentStart, contentEnd - contentStart + 1, [
            [
                'enter',
                content,
                context
            ],
            [
                'enter',
                text,
                context
            ],
            [
                'exit',
                text,
                context
            ],
            [
                'exit',
                content,
                context
            ]
        ]);
    }
    return events;
}
function $cf5683e834a08103$var$tokenizeHeadingAtx(effects, ok, nok) {
    var self = this;
    var size = 0;
    return start;
    function start(code) {
        effects.enter('atxHeading');
        effects.enter('atxHeadingSequence');
        return fenceOpenInside(code);
    }
    function fenceOpenInside(code) {
        if (code === 35 && size++ < 6) {
            effects.consume(code);
            return fenceOpenInside;
        }
        if (code === null || $2NUjQ(code)) {
            effects.exit('atxHeadingSequence');
            return self.interrupt ? ok(code) : headingBreak(code);
        }
        return nok(code);
    }
    function headingBreak(code) {
        if (code === 35) {
            effects.enter('atxHeadingSequence');
            return sequence(code);
        }
        if (code === null || $52d6Z(code)) {
            effects.exit('atxHeading');
            return ok(code);
        }
        if ($ddAr7(code)) return $12DO2(effects, headingBreak, 'whitespace')(code);
        effects.enter('atxHeadingText');
        return data(code);
    }
    function sequence(code) {
        if (code === 35) {
            effects.consume(code);
            return sequence;
        }
        effects.exit('atxHeadingSequence');
        return headingBreak(code);
    }
    function data(code) {
        if (code === null || code === 35 || $2NUjQ(code)) {
            effects.exit('atxHeadingText');
            return headingBreak(code);
        }
        effects.consume(code);
        return data;
    }
}
module.exports = $cf5683e834a08103$var$headingAtx;

});

parcelRegister("7k59L", function(module, exports) {
'use strict';

var $a3Tr7 = parcelRequire("a3Tr7");

var $dWPhi = parcelRequire("dWPhi");

var $52d6Z = parcelRequire("52d6Z");

var $2NUjQ = parcelRequire("2NUjQ");

var $ddAr7 = parcelRequire("ddAr7");

var $dBi5Y = parcelRequire("dBi5Y");

var $hhDbj = parcelRequire("hhDbj");

var $jozOX = parcelRequire("jozOX");

var $89OcD = parcelRequire("89OcD");
var $554e66a1083f9889$var$htmlFlow = {
    name: 'htmlFlow',
    tokenize: $554e66a1083f9889$var$tokenizeHtmlFlow,
    resolveTo: $554e66a1083f9889$var$resolveToHtmlFlow,
    concrete: true
};
var $554e66a1083f9889$var$nextBlankConstruct = {
    tokenize: $554e66a1083f9889$var$tokenizeNextBlank,
    partial: true
};
function $554e66a1083f9889$var$resolveToHtmlFlow(events) {
    var index = events.length;
    while(index--){
        if (events[index][0] === 'enter' && events[index][1].type === 'htmlFlow') break;
    }
    if (index > 1 && events[index - 2][1].type === 'linePrefix') {
        // Add the prefix start to the HTML token.
        events[index][1].start = events[index - 2][1].start // Add the prefix start to the HTML line token.
        ;
        events[index + 1][1].start = events[index - 2][1].start // Remove the line prefix.
        ;
        events.splice(index - 2, 2);
    }
    return events;
}
function $554e66a1083f9889$var$tokenizeHtmlFlow(effects, ok, nok) {
    var self = this;
    var kind;
    var startTag;
    var buffer;
    var index;
    var marker;
    return start;
    function start(code) {
        effects.enter('htmlFlow');
        effects.enter('htmlFlowData');
        effects.consume(code);
        return open;
    }
    function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationStart;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            kind = 3 // While we’re in an instruction instead of a declaration, we’re on a `?`
            ;
            // right now, so we do need to search for `>`, similar to declarations.
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        if ($a3Tr7(code)) {
            effects.consume(code);
            buffer = $dBi5Y(code);
            startTag = true;
            return tagName;
        }
        return nok(code);
    }
    function declarationStart(code) {
        if (code === 45) {
            effects.consume(code);
            kind = 2;
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            kind = 5;
            buffer = 'CDATA[';
            index = 0;
            return cdataOpenInside;
        }
        if ($a3Tr7(code)) {
            effects.consume(code);
            kind = 4;
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    function cdataOpenInside(code) {
        if (code === buffer.charCodeAt(index++)) {
            effects.consume(code);
            return index === buffer.length ? self.interrupt ? ok : continuation : cdataOpenInside;
        }
        return nok(code);
    }
    function tagCloseStart(code) {
        if ($a3Tr7(code)) {
            effects.consume(code);
            buffer = $dBi5Y(code);
            return tagName;
        }
        return nok(code);
    }
    function tagName(code) {
        if (code === null || code === 47 || code === 62 || $2NUjQ(code)) {
            if (code !== 47 && startTag && $jozOX.indexOf(buffer.toLowerCase()) > -1) {
                kind = 1;
                return self.interrupt ? ok(code) : continuation(code);
            }
            if ($hhDbj.indexOf(buffer.toLowerCase()) > -1) {
                kind = 6;
                if (code === 47) {
                    effects.consume(code);
                    return basicSelfClosing;
                }
                return self.interrupt ? ok(code) : continuation(code);
            }
            kind = 7 // Do not support complete HTML when interrupting.
            ;
            return self.interrupt ? nok(code) : startTag ? completeAttributeNameBefore(code) : completeClosingTagAfter(code);
        }
        if (code === 45 || $dWPhi(code)) {
            effects.consume(code);
            buffer += $dBi5Y(code);
            return tagName;
        }
        return nok(code);
    }
    function basicSelfClosing(code) {
        if (code === 62) {
            effects.consume(code);
            return self.interrupt ? ok : continuation;
        }
        return nok(code);
    }
    function completeClosingTagAfter(code) {
        if ($ddAr7(code)) {
            effects.consume(code);
            return completeClosingTagAfter;
        }
        return completeEnd(code);
    }
    function completeAttributeNameBefore(code) {
        if (code === 47) {
            effects.consume(code);
            return completeEnd;
        }
        if (code === 58 || code === 95 || $a3Tr7(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        if ($ddAr7(code)) {
            effects.consume(code);
            return completeAttributeNameBefore;
        }
        return completeEnd(code);
    }
    function completeAttributeName(code) {
        if (code === 45 || code === 46 || code === 58 || code === 95 || $dWPhi(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        return completeAttributeNameAfter(code);
    }
    function completeAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        if ($ddAr7(code)) {
            effects.consume(code);
            return completeAttributeNameAfter;
        }
        return completeAttributeNameBefore(code);
    }
    function completeAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return completeAttributeValueQuoted;
        }
        if ($ddAr7(code)) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        marker = undefined;
        return completeAttributeValueUnquoted(code);
    }
    function completeAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            return completeAttributeValueQuotedAfter;
        }
        if (code === null || $52d6Z(code)) return nok(code);
        effects.consume(code);
        return completeAttributeValueQuoted;
    }
    function completeAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 62 || code === 96 || $2NUjQ(code)) return completeAttributeNameAfter(code);
        effects.consume(code);
        return completeAttributeValueUnquoted;
    }
    function completeAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || $ddAr7(code)) return completeAttributeNameBefore(code);
        return nok(code);
    }
    function completeEnd(code) {
        if (code === 62) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    function completeAfter(code) {
        if ($ddAr7(code)) {
            effects.consume(code);
            return completeAfter;
        }
        return code === null || $52d6Z(code) ? continuation(code) : nok(code);
    }
    function continuation(code) {
        if (code === 45 && kind === 2) {
            effects.consume(code);
            return continuationCommentInside;
        }
        if (code === 60 && kind === 1) {
            effects.consume(code);
            return continuationRawTagOpen;
        }
        if (code === 62 && kind === 4) {
            effects.consume(code);
            return continuationClose;
        }
        if (code === 63 && kind === 3) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        if (code === 93 && kind === 5) {
            effects.consume(code);
            return continuationCharacterDataInside;
        }
        if ($52d6Z(code) && (kind === 6 || kind === 7)) return effects.check($554e66a1083f9889$var$nextBlankConstruct, continuationClose, continuationAtLineEnding)(code);
        if (code === null || $52d6Z(code)) return continuationAtLineEnding(code);
        effects.consume(code);
        return continuation;
    }
    function continuationAtLineEnding(code) {
        effects.exit('htmlFlowData');
        return htmlContinueStart(code);
    }
    function htmlContinueStart(code) {
        if (code === null) return done(code);
        if ($52d6Z(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return htmlContinueStart;
        }
        effects.enter('htmlFlowData');
        return continuation(code);
    }
    function continuationCommentInside(code) {
        if (code === 45) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    function continuationRawTagOpen(code) {
        if (code === 47) {
            effects.consume(code);
            buffer = '';
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    function continuationRawEndTag(code) {
        if (code === 62 && $jozOX.indexOf(buffer.toLowerCase()) > -1) {
            effects.consume(code);
            return continuationClose;
        }
        if ($a3Tr7(code) && buffer.length < 8) {
            effects.consume(code);
            buffer += $dBi5Y(code);
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    function continuationCharacterDataInside(code) {
        if (code === 93) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    function continuationDeclarationInside(code) {
        if (code === 62) {
            effects.consume(code);
            return continuationClose;
        }
        return continuation(code);
    }
    function continuationClose(code) {
        if (code === null || $52d6Z(code)) {
            effects.exit('htmlFlowData');
            return done(code);
        }
        effects.consume(code);
        return continuationClose;
    }
    function done(code) {
        effects.exit('htmlFlow');
        return ok(code);
    }
}
function $554e66a1083f9889$var$tokenizeNextBlank(effects, ok, nok) {
    return start;
    function start(code) {
        effects.exit('htmlFlowData');
        effects.enter('lineEndingBlank');
        effects.consume(code);
        effects.exit('lineEndingBlank');
        return effects.attempt($89OcD, ok, nok);
    }
}
module.exports = $554e66a1083f9889$var$htmlFlow;

});
parcelRegister("hhDbj", function(module, exports) {
'use strict';
// This module is copied from <https://spec.commonmark.org/0.29/#html-blocks>.
var $c9526ad2f44f7039$var$basics = [
    'address',
    'article',
    'aside',
    'base',
    'basefont',
    'blockquote',
    'body',
    'caption',
    'center',
    'col',
    'colgroup',
    'dd',
    'details',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'iframe',
    'legend',
    'li',
    'link',
    'main',
    'menu',
    'menuitem',
    'nav',
    'noframes',
    'ol',
    'optgroup',
    'option',
    'p',
    'param',
    'section',
    'source',
    'summary',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'title',
    'tr',
    'track',
    'ul'
];
module.exports = $c9526ad2f44f7039$var$basics;

});

parcelRegister("jozOX", function(module, exports) {
'use strict';
// This module is copied from <https://spec.commonmark.org/0.29/#html-blocks>.
var $e1ec0b7f8d1f6840$var$raws = [
    'pre',
    'script',
    'style',
    'textarea'
];
module.exports = $e1ec0b7f8d1f6840$var$raws;

});


parcelRegister("kspPu", function(module, exports) {
'use strict';

var $a3Tr7 = parcelRequire("a3Tr7");

var $dWPhi = parcelRequire("dWPhi");

var $52d6Z = parcelRequire("52d6Z");

var $2NUjQ = parcelRequire("2NUjQ");

var $ddAr7 = parcelRequire("ddAr7");

var $12DO2 = parcelRequire("12DO2");
var $ee4a755da4bacd69$var$htmlText = {
    name: 'htmlText',
    tokenize: $ee4a755da4bacd69$var$tokenizeHtmlText
};
function $ee4a755da4bacd69$var$tokenizeHtmlText(effects, ok, nok) {
    var self = this;
    var marker;
    var buffer;
    var index;
    var returnState;
    return start;
    function start(code) {
        effects.enter('htmlText');
        effects.enter('htmlTextData');
        effects.consume(code);
        return open;
    }
    function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            return instruction;
        }
        if ($a3Tr7(code)) {
            effects.consume(code);
            return tagOpen;
        }
        return nok(code);
    }
    function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentOpen;
        }
        if (code === 91) {
            effects.consume(code);
            buffer = 'CDATA[';
            index = 0;
            return cdataOpen;
        }
        if ($a3Tr7(code)) {
            effects.consume(code);
            return declaration;
        }
        return nok(code);
    }
    function commentOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentStart;
        }
        return nok(code);
    }
    function commentStart(code) {
        if (code === null || code === 62) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentStartDash;
        }
        return comment(code);
    }
    function commentStartDash(code) {
        if (code === null || code === 62) return nok(code);
        return comment(code);
    }
    function comment(code) {
        if (code === null) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentClose;
        }
        if ($52d6Z(code)) {
            returnState = comment;
            return atLineEnding(code);
        }
        effects.consume(code);
        return comment;
    }
    function commentClose(code) {
        if (code === 45) {
            effects.consume(code);
            return end;
        }
        return comment(code);
    }
    function cdataOpen(code) {
        if (code === buffer.charCodeAt(index++)) {
            effects.consume(code);
            return index === buffer.length ? cdata : cdataOpen;
        }
        return nok(code);
    }
    function cdata(code) {
        if (code === null) return nok(code);
        if (code === 93) {
            effects.consume(code);
            return cdataClose;
        }
        if ($52d6Z(code)) {
            returnState = cdata;
            return atLineEnding(code);
        }
        effects.consume(code);
        return cdata;
    }
    function cdataClose(code) {
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    function cdataEnd(code) {
        if (code === 62) return end(code);
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    function declaration(code) {
        if (code === null || code === 62) return end(code);
        if ($52d6Z(code)) {
            returnState = declaration;
            return atLineEnding(code);
        }
        effects.consume(code);
        return declaration;
    }
    function instruction(code) {
        if (code === null) return nok(code);
        if (code === 63) {
            effects.consume(code);
            return instructionClose;
        }
        if ($52d6Z(code)) {
            returnState = instruction;
            return atLineEnding(code);
        }
        effects.consume(code);
        return instruction;
    }
    function instructionClose(code) {
        return code === 62 ? end(code) : instruction(code);
    }
    function tagCloseStart(code) {
        if ($a3Tr7(code)) {
            effects.consume(code);
            return tagClose;
        }
        return nok(code);
    }
    function tagClose(code) {
        if (code === 45 || $dWPhi(code)) {
            effects.consume(code);
            return tagClose;
        }
        return tagCloseBetween(code);
    }
    function tagCloseBetween(code) {
        if ($52d6Z(code)) {
            returnState = tagCloseBetween;
            return atLineEnding(code);
        }
        if ($ddAr7(code)) {
            effects.consume(code);
            return tagCloseBetween;
        }
        return end(code);
    }
    function tagOpen(code) {
        if (code === 45 || $dWPhi(code)) {
            effects.consume(code);
            return tagOpen;
        }
        if (code === 47 || code === 62 || $2NUjQ(code)) return tagOpenBetween(code);
        return nok(code);
    }
    function tagOpenBetween(code) {
        if (code === 47) {
            effects.consume(code);
            return end;
        }
        if (code === 58 || code === 95 || $a3Tr7(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        if ($52d6Z(code)) {
            returnState = tagOpenBetween;
            return atLineEnding(code);
        }
        if ($ddAr7(code)) {
            effects.consume(code);
            return tagOpenBetween;
        }
        return end(code);
    }
    function tagOpenAttributeName(code) {
        if (code === 45 || code === 46 || code === 58 || code === 95 || $dWPhi(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        return tagOpenAttributeNameAfter(code);
    }
    function tagOpenAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        if ($52d6Z(code)) {
            returnState = tagOpenAttributeNameAfter;
            return atLineEnding(code);
        }
        if ($ddAr7(code)) {
            effects.consume(code);
            return tagOpenAttributeNameAfter;
        }
        return tagOpenBetween(code);
    }
    function tagOpenAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return tagOpenAttributeValueQuoted;
        }
        if ($52d6Z(code)) {
            returnState = tagOpenAttributeValueBefore;
            return atLineEnding(code);
        }
        if ($ddAr7(code)) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        effects.consume(code);
        marker = undefined;
        return tagOpenAttributeValueUnquoted;
    }
    function tagOpenAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            return tagOpenAttributeValueQuotedAfter;
        }
        if (code === null) return nok(code);
        if ($52d6Z(code)) {
            returnState = tagOpenAttributeValueQuoted;
            return atLineEnding(code);
        }
        effects.consume(code);
        return tagOpenAttributeValueQuoted;
    }
    function tagOpenAttributeValueQuotedAfter(code) {
        if (code === 62 || code === 47 || $2NUjQ(code)) return tagOpenBetween(code);
        return nok(code);
    }
    function tagOpenAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 96) return nok(code);
        if (code === 62 || $2NUjQ(code)) return tagOpenBetween(code);
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    } // We can’t have blank lines in content, so no need to worry about empty
    // tokens.
    function atLineEnding(code) {
        effects.exit('htmlTextData');
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        return $12DO2(effects, afterPrefix, 'linePrefix', self.parser.constructs.disable.null.indexOf('codeIndented') > -1 ? undefined : 4);
    }
    function afterPrefix(code) {
        effects.enter('htmlTextData');
        return returnState(code);
    }
    function end(code) {
        if (code === 62) {
            effects.consume(code);
            effects.exit('htmlTextData');
            effects.exit('htmlText');
            return ok;
        }
        return nok(code);
    }
}
module.exports = $ee4a755da4bacd69$var$htmlText;

});

parcelRegister("7CZcz", function(module, exports) {
'use strict';

var $2NUjQ = parcelRequire("2NUjQ");

var $ilKDT = parcelRequire("ilKDT");

var $jqdTZ = parcelRequire("jqdTZ");

var $b6oju = parcelRequire("b6oju");

var $uWhOk = parcelRequire("uWhOk");

var $dmdD5 = parcelRequire("dmdD5");

var $f820y = parcelRequire("f820y");

var $4HIQH = parcelRequire("4HIQH");

var $eHYrg = parcelRequire("eHYrg");

var $QRTi2 = parcelRequire("QRTi2");
var $58db8e67a2c50c32$var$labelEnd = {
    name: 'labelEnd',
    tokenize: $58db8e67a2c50c32$var$tokenizeLabelEnd,
    resolveTo: $58db8e67a2c50c32$var$resolveToLabelEnd,
    resolveAll: $58db8e67a2c50c32$var$resolveAllLabelEnd
};
var $58db8e67a2c50c32$var$resourceConstruct = {
    tokenize: $58db8e67a2c50c32$var$tokenizeResource
};
var $58db8e67a2c50c32$var$fullReferenceConstruct = {
    tokenize: $58db8e67a2c50c32$var$tokenizeFullReference
};
var $58db8e67a2c50c32$var$collapsedReferenceConstruct = {
    tokenize: $58db8e67a2c50c32$var$tokenizeCollapsedReference
};
function $58db8e67a2c50c32$var$resolveAllLabelEnd(events) {
    var index = -1;
    var token;
    while(++index < events.length){
        token = events[index][1];
        if (!token._used && (token.type === 'labelImage' || token.type === 'labelLink' || token.type === 'labelEnd')) {
            // Remove the marker.
            events.splice(index + 1, token.type === 'labelImage' ? 4 : 2);
            token.type = 'data';
            index++;
        }
    }
    return events;
}
function $58db8e67a2c50c32$var$resolveToLabelEnd(events, context) {
    var index = events.length;
    var offset = 0;
    var group;
    var label;
    var text;
    var token;
    var open;
    var close;
    var media // Find an opening.
    ;
    while(index--){
        token = events[index][1];
        if (open) {
            // If we see another link, or inactive link label, we’ve been here before.
            if (token.type === 'link' || token.type === 'labelLink' && token._inactive) break;
             // Mark other link openings as inactive, as we can’t have links in
            // links.
            if (events[index][0] === 'enter' && token.type === 'labelLink') token._inactive = true;
        } else if (close) {
            if (events[index][0] === 'enter' && (token.type === 'labelImage' || token.type === 'labelLink') && !token._balanced) {
                open = index;
                if (token.type !== 'labelLink') {
                    offset = 2;
                    break;
                }
            }
        } else if (token.type === 'labelEnd') close = index;
    }
    group = {
        type: events[open][1].type === 'labelLink' ? 'link' : 'image',
        start: $dmdD5(events[open][1].start),
        end: $dmdD5(events[events.length - 1][1].end)
    };
    label = {
        type: 'label',
        start: $dmdD5(events[open][1].start),
        end: $dmdD5(events[close][1].end)
    };
    text = {
        type: 'labelText',
        start: $dmdD5(events[open + offset + 2][1].end),
        end: $dmdD5(events[close - 2][1].start)
    };
    media = [
        [
            'enter',
            group,
            context
        ],
        [
            'enter',
            label,
            context
        ]
    ] // Opening marker.
    ;
    media = $ilKDT(media, events.slice(open + 1, open + offset + 3)) // Text open.
    ;
    media = $ilKDT(media, [
        [
            'enter',
            text,
            context
        ]
    ]) // Between.
    ;
    media = $ilKDT(media, $uWhOk(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close - 3), context)) // Text close, marker close, label close.
    ;
    media = $ilKDT(media, [
        [
            'exit',
            text,
            context
        ],
        events[close - 2],
        events[close - 1],
        [
            'exit',
            label,
            context
        ]
    ]) // Reference, resource, or so.
    ;
    media = $ilKDT(media, events.slice(close + 1)) // Media close.
    ;
    media = $ilKDT(media, [
        [
            'exit',
            group,
            context
        ]
    ]);
    $jqdTZ(events, open, events.length, media);
    return events;
}
function $58db8e67a2c50c32$var$tokenizeLabelEnd(effects, ok, nok) {
    var self = this;
    var index = self.events.length;
    var labelStart;
    var defined // Find an opening.
    ;
    while(index--)if ((self.events[index][1].type === 'labelImage' || self.events[index][1].type === 'labelLink') && !self.events[index][1]._balanced) {
        labelStart = self.events[index][1];
        break;
    }
    return start;
    function start(code) {
        if (!labelStart) return nok(code);
         // It’s a balanced bracket, but contains a link.
        if (labelStart._inactive) return balanced(code);
        defined = self.parser.defined.indexOf($b6oju(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        }))) > -1;
        effects.enter('labelEnd');
        effects.enter('labelMarker');
        effects.consume(code);
        effects.exit('labelMarker');
        effects.exit('labelEnd');
        return afterLabelEnd;
    }
    function afterLabelEnd(code) {
        // Resource: `[asd](fgh)`.
        if (code === 40) return effects.attempt($58db8e67a2c50c32$var$resourceConstruct, ok, defined ? ok : balanced)(code);
         // Collapsed (`[asd][]`) or full (`[asd][fgh]`) reference?
        if (code === 91) return effects.attempt($58db8e67a2c50c32$var$fullReferenceConstruct, ok, defined ? effects.attempt($58db8e67a2c50c32$var$collapsedReferenceConstruct, ok, balanced) : balanced)(code);
         // Shortcut reference: `[asd]`?
        return defined ? ok(code) : balanced(code);
    }
    function balanced(code) {
        labelStart._balanced = true;
        return nok(code);
    }
}
function $58db8e67a2c50c32$var$tokenizeResource(effects, ok, nok) {
    return start;
    function start(code) {
        effects.enter('resource');
        effects.enter('resourceMarker');
        effects.consume(code);
        effects.exit('resourceMarker');
        return $QRTi2(effects, open);
    }
    function open(code) {
        if (code === 41) return end(code);
        return $f820y(effects, destinationAfter, nok, 'resourceDestination', 'resourceDestinationLiteral', 'resourceDestinationLiteralMarker', 'resourceDestinationRaw', 'resourceDestinationString', 3)(code);
    }
    function destinationAfter(code) {
        return $2NUjQ(code) ? $QRTi2(effects, between)(code) : end(code);
    }
    function between(code) {
        if (code === 34 || code === 39 || code === 40) return $eHYrg(effects, $QRTi2(effects, end), nok, 'resourceTitle', 'resourceTitleMarker', 'resourceTitleString')(code);
        return end(code);
    }
    function end(code) {
        if (code === 41) {
            effects.enter('resourceMarker');
            effects.consume(code);
            effects.exit('resourceMarker');
            effects.exit('resource');
            return ok;
        }
        return nok(code);
    }
}
function $58db8e67a2c50c32$var$tokenizeFullReference(effects, ok, nok) {
    var self = this;
    return start;
    function start(code) {
        return $4HIQH.call(self, effects, afterLabel, nok, 'reference', 'referenceMarker', 'referenceString')(code);
    }
    function afterLabel(code) {
        return self.parser.defined.indexOf($b6oju(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1))) < 0 ? nok(code) : ok(code);
    }
}
function $58db8e67a2c50c32$var$tokenizeCollapsedReference(effects, ok, nok) {
    return start;
    function start(code) {
        effects.enter('reference');
        effects.enter('referenceMarker');
        effects.consume(code);
        effects.exit('referenceMarker');
        return open;
    }
    function open(code) {
        if (code === 93) {
            effects.enter('referenceMarker');
            effects.consume(code);
            effects.exit('referenceMarker');
            effects.exit('reference');
            return ok;
        }
        return nok(code);
    }
}
module.exports = $58db8e67a2c50c32$var$labelEnd;

});

parcelRegister("c9UQ2", function(module, exports) {
'use strict';

var $7CZcz = parcelRequire("7CZcz");
var $0248d02a301f8c7f$var$labelStartImage = {
    name: 'labelStartImage',
    tokenize: $0248d02a301f8c7f$var$tokenizeLabelStartImage,
    resolveAll: $7CZcz.resolveAll
};
function $0248d02a301f8c7f$var$tokenizeLabelStartImage(effects, ok, nok) {
    var self = this;
    return start;
    function start(code) {
        effects.enter('labelImage');
        effects.enter('labelImageMarker');
        effects.consume(code);
        effects.exit('labelImageMarker');
        return open;
    }
    function open(code) {
        if (code === 91) {
            effects.enter('labelMarker');
            effects.consume(code);
            effects.exit('labelMarker');
            effects.exit('labelImage');
            return after;
        }
        return nok(code);
    }
    function after(code) {
        /* c8 ignore next */ return code === 94 && /* c8 ignore next */ '_hiddenFootnoteSupport' in self.parser.constructs ? /* c8 ignore next */ nok(code) : ok(code);
    }
}
module.exports = $0248d02a301f8c7f$var$labelStartImage;

});

parcelRegister("6z2zH", function(module, exports) {
'use strict';

var $7CZcz = parcelRequire("7CZcz");
var $4c780240e43c457d$var$labelStartLink = {
    name: 'labelStartLink',
    tokenize: $4c780240e43c457d$var$tokenizeLabelStartLink,
    resolveAll: $7CZcz.resolveAll
};
function $4c780240e43c457d$var$tokenizeLabelStartLink(effects, ok, nok) {
    var self = this;
    return start;
    function start(code) {
        effects.enter('labelLink');
        effects.enter('labelMarker');
        effects.consume(code);
        effects.exit('labelMarker');
        effects.exit('labelLink');
        return after;
    }
    function after(code) {
        /* c8 ignore next */ return code === 94 && /* c8 ignore next */ '_hiddenFootnoteSupport' in self.parser.constructs ? /* c8 ignore next */ nok(code) : ok(code);
    }
}
module.exports = $4c780240e43c457d$var$labelStartLink;

});

parcelRegister("gRGFa", function(module, exports) {
'use strict';

var $12DO2 = parcelRequire("12DO2");
var $c472b08d68bb852b$var$lineEnding = {
    name: 'lineEnding',
    tokenize: $c472b08d68bb852b$var$tokenizeLineEnding
};
function $c472b08d68bb852b$var$tokenizeLineEnding(effects, ok) {
    return start;
    function start(code) {
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        return $12DO2(effects, ok, 'linePrefix');
    }
}
module.exports = $c472b08d68bb852b$var$lineEnding;

});

parcelRegister("484wK", function(module, exports) {
'use strict';

var $6UWEV = parcelRequire("6UWEV");

var $ddAr7 = parcelRequire("ddAr7");

var $9gPhT = parcelRequire("9gPhT");

var $i9qol = parcelRequire("i9qol");

var $12DO2 = parcelRequire("12DO2");

var $89OcD = parcelRequire("89OcD");

var $3Hn2y = parcelRequire("3Hn2y");
var $301b6bc4c5f91e3a$var$list = {
    name: 'list',
    tokenize: $301b6bc4c5f91e3a$var$tokenizeListStart,
    continuation: {
        tokenize: $301b6bc4c5f91e3a$var$tokenizeListContinuation
    },
    exit: $301b6bc4c5f91e3a$var$tokenizeListEnd
};
var $301b6bc4c5f91e3a$var$listItemPrefixWhitespaceConstruct = {
    tokenize: $301b6bc4c5f91e3a$var$tokenizeListItemPrefixWhitespace,
    partial: true
};
var $301b6bc4c5f91e3a$var$indentConstruct = {
    tokenize: $301b6bc4c5f91e3a$var$tokenizeIndent,
    partial: true
};
function $301b6bc4c5f91e3a$var$tokenizeListStart(effects, ok, nok) {
    var self = this;
    var initialSize = $9gPhT(self.events, 'linePrefix');
    var size = 0;
    return start;
    function start(code) {
        var kind = self.containerState.type || (code === 42 || code === 43 || code === 45 ? 'listUnordered' : 'listOrdered');
        if (kind === 'listUnordered' ? !self.containerState.marker || code === self.containerState.marker : $6UWEV(code)) {
            if (!self.containerState.type) {
                self.containerState.type = kind;
                effects.enter(kind, {
                    _container: true
                });
            }
            if (kind === 'listUnordered') {
                effects.enter('listItemPrefix');
                return code === 42 || code === 45 ? effects.check($3Hn2y, nok, atMarker)(code) : atMarker(code);
            }
            if (!self.interrupt || code === 49) {
                effects.enter('listItemPrefix');
                effects.enter('listItemValue');
                return inside(code);
            }
        }
        return nok(code);
    }
    function inside(code) {
        if ($6UWEV(code) && ++size < 10) {
            effects.consume(code);
            return inside;
        }
        if ((!self.interrupt || size < 2) && (self.containerState.marker ? code === self.containerState.marker : code === 41 || code === 46)) {
            effects.exit('listItemValue');
            return atMarker(code);
        }
        return nok(code);
    }
    function atMarker(code) {
        effects.enter('listItemMarker');
        effects.consume(code);
        effects.exit('listItemMarker');
        self.containerState.marker = self.containerState.marker || code;
        return effects.check($89OcD, self.interrupt ? nok : onBlank, effects.attempt($301b6bc4c5f91e3a$var$listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix));
    }
    function onBlank(code) {
        self.containerState.initialBlankLine = true;
        initialSize++;
        return endOfPrefix(code);
    }
    function otherPrefix(code) {
        if ($ddAr7(code)) {
            effects.enter('listItemPrefixWhitespace');
            effects.consume(code);
            effects.exit('listItemPrefixWhitespace');
            return endOfPrefix;
        }
        return nok(code);
    }
    function endOfPrefix(code) {
        self.containerState.size = initialSize + $i9qol(self.sliceStream(effects.exit('listItemPrefix')));
        return ok(code);
    }
}
function $301b6bc4c5f91e3a$var$tokenizeListContinuation(effects, ok, nok) {
    var self = this;
    self.containerState._closeFlow = undefined;
    return effects.check($89OcD, onBlank, notBlank);
    function onBlank(code) {
        self.containerState.furtherBlankLines = self.containerState.furtherBlankLines || self.containerState.initialBlankLine // We have a blank line.
        ;
        // Still, try to consume at most the items size.
        return $12DO2(effects, ok, 'listItemIndent', self.containerState.size + 1)(code);
    }
    function notBlank(code) {
        if (self.containerState.furtherBlankLines || !$ddAr7(code)) {
            self.containerState.furtherBlankLines = self.containerState.initialBlankLine = undefined;
            return notInCurrentItem(code);
        }
        self.containerState.furtherBlankLines = self.containerState.initialBlankLine = undefined;
        return effects.attempt($301b6bc4c5f91e3a$var$indentConstruct, ok, notInCurrentItem)(code);
    }
    function notInCurrentItem(code) {
        // While we do continue, we signal that the flow should be closed.
        self.containerState._closeFlow = true // As we’re closing flow, we’re no longer interrupting.
        ;
        self.interrupt = undefined;
        return $12DO2(effects, effects.attempt($301b6bc4c5f91e3a$var$list, ok, nok), 'linePrefix', self.parser.constructs.disable.null.indexOf('codeIndented') > -1 ? undefined : 4)(code);
    }
}
function $301b6bc4c5f91e3a$var$tokenizeIndent(effects, ok, nok) {
    var self = this;
    return $12DO2(effects, afterPrefix, 'listItemIndent', self.containerState.size + 1);
    function afterPrefix(code) {
        return $9gPhT(self.events, 'listItemIndent') === self.containerState.size ? ok(code) : nok(code);
    }
}
function $301b6bc4c5f91e3a$var$tokenizeListEnd(effects) {
    effects.exit(this.containerState.type);
}
function $301b6bc4c5f91e3a$var$tokenizeListItemPrefixWhitespace(effects, ok, nok) {
    var self = this;
    return $12DO2(effects, afterPrefix, 'listItemPrefixWhitespace', self.parser.constructs.disable.null.indexOf('codeIndented') > -1 ? undefined : 5);
    function afterPrefix(code) {
        return $ddAr7(code) || !$9gPhT(self.events, 'listItemPrefixWhitespace') ? nok(code) : ok(code);
    }
}
module.exports = $301b6bc4c5f91e3a$var$list;

});
parcelRegister("3Hn2y", function(module, exports) {
'use strict';

var $52d6Z = parcelRequire("52d6Z");

var $ddAr7 = parcelRequire("ddAr7");

var $12DO2 = parcelRequire("12DO2");
var $2b17428a26de58ec$var$thematicBreak = {
    name: 'thematicBreak',
    tokenize: $2b17428a26de58ec$var$tokenizeThematicBreak
};
function $2b17428a26de58ec$var$tokenizeThematicBreak(effects, ok, nok) {
    var size = 0;
    var marker;
    return start;
    function start(code) {
        effects.enter('thematicBreak');
        marker = code;
        return atBreak(code);
    }
    function atBreak(code) {
        if (code === marker) {
            effects.enter('thematicBreakSequence');
            return sequence(code);
        }
        if ($ddAr7(code)) return $12DO2(effects, atBreak, 'whitespace')(code);
        if (size < 3 || code !== null && !$52d6Z(code)) return nok(code);
        effects.exit('thematicBreak');
        return ok(code);
    }
    function sequence(code) {
        if (code === marker) {
            effects.consume(code);
            size++;
            return sequence;
        }
        effects.exit('thematicBreakSequence');
        return atBreak(code);
    }
}
module.exports = $2b17428a26de58ec$var$thematicBreak;

});


parcelRegister("cp9zf", function(module, exports) {
'use strict';

var $52d6Z = parcelRequire("52d6Z");

var $dmdD5 = parcelRequire("dmdD5");

var $12DO2 = parcelRequire("12DO2");
var $907f3dc3460836fc$var$setextUnderline = {
    name: 'setextUnderline',
    tokenize: $907f3dc3460836fc$var$tokenizeSetextUnderline,
    resolveTo: $907f3dc3460836fc$var$resolveToSetextUnderline
};
function $907f3dc3460836fc$var$resolveToSetextUnderline(events, context) {
    var index = events.length;
    var content;
    var text;
    var definition;
    var heading // Find the opening of the content.
    ;
    // It’ll always exist: we don’t tokenize if it isn’t there.
    while(index--)if (events[index][0] === 'enter') {
        if (events[index][1].type === 'content') {
            content = index;
            break;
        }
        if (events[index][1].type === 'paragraph') text = index;
    } else {
        if (events[index][1].type === 'content') // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1);
        if (!definition && events[index][1].type === 'definition') definition = index;
    }
    heading = {
        type: 'setextHeading',
        start: $dmdD5(events[text][1].start),
        end: $dmdD5(events[events.length - 1][1].end)
    } // Change the paragraph to setext heading text.
    ;
    events[text][1].type = 'setextHeadingText' // If we have definitions in the content, we’ll keep on having content,
    ;
    // but we need move it.
    if (definition) {
        events.splice(text, 0, [
            'enter',
            heading,
            context
        ]);
        events.splice(definition + 1, 0, [
            'exit',
            events[content][1],
            context
        ]);
        events[content][1].end = $dmdD5(events[definition][1].end);
    } else events[content][1] = heading;
     // Add the heading exit at the end.
    events.push([
        'exit',
        heading,
        context
    ]);
    return events;
}
function $907f3dc3460836fc$var$tokenizeSetextUnderline(effects, ok, nok) {
    var self = this;
    var index = self.events.length;
    var marker;
    var paragraph // Find an opening.
    ;
    while(index--)// Skip enter/exit of line ending, line prefix, and content.
    // We can now either have a definition or a paragraph.
    if (self.events[index][1].type !== 'lineEnding' && self.events[index][1].type !== 'linePrefix' && self.events[index][1].type !== 'content') {
        paragraph = self.events[index][1].type === 'paragraph';
        break;
    }
    return start;
    function start(code) {
        if (!self.lazy && (self.interrupt || paragraph)) {
            effects.enter('setextHeadingLine');
            effects.enter('setextHeadingLineSequence');
            marker = code;
            return closingSequence(code);
        }
        return nok(code);
    }
    function closingSequence(code) {
        if (code === marker) {
            effects.consume(code);
            return closingSequence;
        }
        effects.exit('setextHeadingLineSequence');
        return $12DO2(effects, closingSequenceEnd, 'lineSuffix')(code);
    }
    function closingSequenceEnd(code) {
        if (code === null || $52d6Z(code)) {
            effects.exit('setextHeadingLine');
            return ok(code);
        }
        return nok(code);
    }
}
module.exports = $907f3dc3460836fc$var$setextUnderline;

});



parcelRegister("eFans", function(module, exports) {
'use strict';
var $aaccf1be4d62feb4$var$search = /[\0\t\n\r]/g;
function $aaccf1be4d62feb4$var$preprocess() {
    var start = true;
    var column = 1;
    var buffer = '';
    var atCarriageReturn;
    return preprocessor;
    function preprocessor(value, encoding, end) {
        var chunks = [];
        var match;
        var next;
        var startPosition;
        var endPosition;
        var code;
        value = buffer + value.toString(encoding);
        startPosition = 0;
        buffer = '';
        if (start) {
            if (value.charCodeAt(0) === 65279) startPosition++;
            start = undefined;
        }
        while(startPosition < value.length){
            $aaccf1be4d62feb4$var$search.lastIndex = startPosition;
            match = $aaccf1be4d62feb4$var$search.exec(value);
            endPosition = match ? match.index : value.length;
            code = value.charCodeAt(endPosition);
            if (!match) {
                buffer = value.slice(startPosition);
                break;
            }
            if (code === 10 && startPosition === endPosition && atCarriageReturn) {
                chunks.push(-3);
                atCarriageReturn = undefined;
            } else {
                if (atCarriageReturn) {
                    chunks.push(-5);
                    atCarriageReturn = undefined;
                }
                if (startPosition < endPosition) {
                    chunks.push(value.slice(startPosition, endPosition));
                    column += endPosition - startPosition;
                }
                if (code === 0) {
                    chunks.push(65533);
                    column++;
                } else if (code === 9) {
                    next = Math.ceil(column / 4) * 4;
                    chunks.push(-2);
                    while(column++ < next)chunks.push(-1);
                } else if (code === 10) {
                    chunks.push(-4);
                    column = 1;
                } else {
                    atCarriageReturn = true;
                    column = 1;
                }
            }
            startPosition = endPosition + 1;
        }
        if (end) {
            if (atCarriageReturn) chunks.push(-5);
            if (buffer) chunks.push(buffer);
            chunks.push(null);
        }
        return chunks;
    }
}
module.exports = $aaccf1be4d62feb4$var$preprocess;

});

parcelRegister("5HegO", function(module, exports) {
'use strict';

var $hJSf6 = parcelRequire("hJSf6");
function $425c09a4c4d1e7e8$var$postprocess(events) {
    while(!$hJSf6(events));
    return events;
}
module.exports = $425c09a4c4d1e7e8$var$postprocess;

});


parcelRegister("6xjLC", function(module, exports) {
'use strict';
module.exports = $4c25287351a2f07a$var$toHast;

var $k5hlo = parcelRequire("k5hlo");

var $lxQxI = parcelRequire("lxQxI");

var $l5vcs = parcelRequire("l5vcs");

var $878M9 = parcelRequire("878M9");

var $iYmo0 = parcelRequire("iYmo0");

var $ewvob = parcelRequire("ewvob");

var $85uZB = parcelRequire("85uZB");

var $4IEHE = parcelRequire("4IEHE");
var $4c25287351a2f07a$var$own = {}.hasOwnProperty;
var $4c25287351a2f07a$var$deprecationWarningIssued = false;
// Factory to transform.
function $4c25287351a2f07a$var$factory(tree, options) {
    var settings = options || {};
    // Issue a warning if the deprecated tag 'allowDangerousHTML' is used
    if (settings.allowDangerousHTML !== undefined && !$4c25287351a2f07a$var$deprecationWarningIssued) {
        $4c25287351a2f07a$var$deprecationWarningIssued = true;
        console.warn('mdast-util-to-hast: deprecation: `allowDangerousHTML` is nonstandard, use `allowDangerousHtml` instead');
    }
    var dangerous = settings.allowDangerousHtml || settings.allowDangerousHTML;
    var footnoteById = {};
    h.dangerous = dangerous;
    h.definition = $iYmo0(tree);
    h.footnoteById = footnoteById;
    h.footnoteOrder = [];
    h.augment = augment;
    h.handlers = Object.assign({}, $4IEHE, settings.handlers);
    h.unknownHandler = settings.unknownHandler;
    h.passThrough = settings.passThrough;
    $lxQxI(tree, 'footnoteDefinition', onfootnotedefinition);
    return h;
    // Finalise the created `right`, a hast node, from `left`, an mdast node.
    function augment(left, right) {
        var data;
        var ctx;
        // Handle `data.hName`, `data.hProperties, `data.hChildren`.
        if (left && left.data) {
            data = left.data;
            if (data.hName) {
                if (right.type !== 'element') right = {
                    type: 'element',
                    tagName: '',
                    properties: {},
                    children: []
                };
                right.tagName = data.hName;
            }
            if (right.type === 'element' && data.hProperties) right.properties = Object.assign({}, right.properties, data.hProperties);
            if (right.children && data.hChildren) right.children = data.hChildren;
        }
        ctx = left && left.position ? left : {
            position: left
        };
        if (!$878M9(ctx)) right.position = {
            start: $l5vcs.start(ctx),
            end: $l5vcs.end(ctx)
        };
        return right;
    }
    // Create an element for `node`.
    function h(node, tagName, props, children) {
        if ((children === undefined || children === null) && typeof props === 'object' && 'length' in props) {
            children = props;
            props = {};
        }
        return augment(node, {
            type: 'element',
            tagName: tagName,
            properties: props || {},
            children: children || []
        });
    }
    function onfootnotedefinition(definition) {
        var id = String(definition.identifier).toUpperCase();
        // Mimick CM behavior of link definitions.
        // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/8290999/index.js#L26>.
        if (!$4c25287351a2f07a$var$own.call(footnoteById, id)) footnoteById[id] = definition;
    }
}
// Transform `tree`, which is an mdast node, to a hast node.
function $4c25287351a2f07a$var$toHast(tree, options) {
    var h = $4c25287351a2f07a$var$factory(tree, options);
    var node = $ewvob(h, tree);
    var foot = $85uZB(h);
    if (foot) node.children = node.children.concat($k5hlo('text', '\n'), foot);
    return node;
}

});
parcelRegister("k5hlo", function(module, exports) {
'use strict';
module.exports = $e9f1ba77749fa945$var$u;
function $e9f1ba77749fa945$var$u(type, props, value) {
    var node;
    if ((value === null || value === undefined) && (typeof props !== 'object' || Array.isArray(props))) {
        value = props;
        props = {};
    }
    node = Object.assign({
        type: String(type)
    }, props);
    if (Array.isArray(value)) node.children = value;
    else if (value !== null && value !== undefined) node.value = String(value);
    return node;
}

});

parcelRegister("lxQxI", function(module, exports) {
'use strict';
module.exports = $faf56fec5b55bd4a$var$visit;

var $bjUst = parcelRequire("bjUst");
var $faf56fec5b55bd4a$var$CONTINUE = $bjUst.CONTINUE;
var $faf56fec5b55bd4a$var$SKIP = $bjUst.SKIP;
var $faf56fec5b55bd4a$var$EXIT = $bjUst.EXIT;
$faf56fec5b55bd4a$var$visit.CONTINUE = $faf56fec5b55bd4a$var$CONTINUE;
$faf56fec5b55bd4a$var$visit.SKIP = $faf56fec5b55bd4a$var$SKIP;
$faf56fec5b55bd4a$var$visit.EXIT = $faf56fec5b55bd4a$var$EXIT;
function $faf56fec5b55bd4a$var$visit(tree, test, visitor, reverse) {
    if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    $bjUst(tree, test, overload, reverse);
    function overload(node, parents) {
        var parent = parents[parents.length - 1];
        var index = parent ? parent.children.indexOf(node) : null;
        return visitor(node, index, parent);
    }
}

});
parcelRegister("bjUst", function(module, exports) {
'use strict';
module.exports = $83dd437d28ecde82$var$visitParents;

var $jz4Ok = parcelRequire("jz4Ok");

var $KTYXW = parcelRequire("KTYXW");
var $83dd437d28ecde82$var$CONTINUE = true;
var $83dd437d28ecde82$var$SKIP = 'skip';
var $83dd437d28ecde82$var$EXIT = false;
$83dd437d28ecde82$var$visitParents.CONTINUE = $83dd437d28ecde82$var$CONTINUE;
$83dd437d28ecde82$var$visitParents.SKIP = $83dd437d28ecde82$var$SKIP;
$83dd437d28ecde82$var$visitParents.EXIT = $83dd437d28ecde82$var$EXIT;
function $83dd437d28ecde82$var$visitParents(tree, test, visitor, reverse) {
    var step;
    var is;
    if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    is = $jz4Ok(test);
    step = reverse ? -1 : 1;
    factory(tree, null, [])();
    function factory(node, index, parents) {
        var value = typeof node === 'object' && node !== null ? node : {};
        var name;
        if (typeof value.type === 'string') {
            name = typeof value.tagName === 'string' ? value.tagName : typeof value.name === 'string' ? value.name : undefined;
            visit.displayName = 'node (' + $KTYXW(value.type + (name ? '<' + name + '>' : '')) + ')';
        }
        return visit;
        function visit() {
            var grandparents = parents.concat(node);
            var result = [];
            var subresult;
            var offset;
            if (!test || is(node, index, parents[parents.length - 1] || null)) {
                result = $83dd437d28ecde82$var$toResult(visitor(node, parents));
                if (result[0] === $83dd437d28ecde82$var$EXIT) return result;
            }
            if (node.children && result[0] !== $83dd437d28ecde82$var$SKIP) {
                offset = (reverse ? node.children.length : -1) + step;
                while(offset > -1 && offset < node.children.length){
                    subresult = factory(node.children[offset], offset, grandparents)();
                    if (subresult[0] === $83dd437d28ecde82$var$EXIT) return subresult;
                    offset = typeof subresult[1] === 'number' ? subresult[1] : offset + step;
                }
            }
            return result;
        }
    }
}
function $83dd437d28ecde82$var$toResult(value) {
    if (value !== null && typeof value === 'object' && 'length' in value) return value;
    if (typeof value === 'number') return [
        $83dd437d28ecde82$var$CONTINUE,
        value
    ];
    return [
        value
    ];
}

});
parcelRegister("jz4Ok", function(module, exports) {
'use strict';
module.exports = $03acfbf1a01fbc5c$var$convert;
function $03acfbf1a01fbc5c$var$convert(test) {
    if (test == null) return $03acfbf1a01fbc5c$var$ok;
    if (typeof test === 'string') return $03acfbf1a01fbc5c$var$typeFactory(test);
    if (typeof test === 'object') return 'length' in test ? $03acfbf1a01fbc5c$var$anyFactory(test) : $03acfbf1a01fbc5c$var$allFactory(test);
    if (typeof test === 'function') return test;
    throw new Error('Expected function, string, or object as test');
}
// Utility assert each property in `test` is represented in `node`, and each
// values are strictly equal.
function $03acfbf1a01fbc5c$var$allFactory(test) {
    return all;
    function all(node) {
        var key;
        for(key in test){
            if (node[key] !== test[key]) return false;
        }
        return true;
    }
}
function $03acfbf1a01fbc5c$var$anyFactory(tests) {
    var checks = [];
    var index = -1;
    while(++index < tests.length)checks[index] = $03acfbf1a01fbc5c$var$convert(tests[index]);
    return any;
    function any() {
        var index = -1;
        while(++index < checks.length){
            if (checks[index].apply(this, arguments)) return true;
        }
        return false;
    }
}
// Utility to convert a string into a function which checks a given node’s type
// for said string.
function $03acfbf1a01fbc5c$var$typeFactory(test) {
    return type;
    function type(node) {
        return Boolean(node && node.type === test);
    }
}
// Utility to return true.
function $03acfbf1a01fbc5c$var$ok() {
    return true;
}

});

parcelRegister("KTYXW", function(module, exports) {
module.exports = $08cfb8ea417447ab$var$identity;
function $08cfb8ea417447ab$var$identity(d) {
    return d;
}

});



parcelRegister("l5vcs", function(module, exports) {
'use strict';
var $f5a2443cba62757d$var$start = $f5a2443cba62757d$var$factory('start');
var $f5a2443cba62757d$var$end = $f5a2443cba62757d$var$factory('end');
module.exports = $f5a2443cba62757d$var$position;
$f5a2443cba62757d$var$position.start = $f5a2443cba62757d$var$start;
$f5a2443cba62757d$var$position.end = $f5a2443cba62757d$var$end;
function $f5a2443cba62757d$var$position(node) {
    return {
        start: $f5a2443cba62757d$var$start(node),
        end: $f5a2443cba62757d$var$end(node)
    };
}
function $f5a2443cba62757d$var$factory(type) {
    point.displayName = type;
    return point;
    function point(node) {
        var point = node && node.position && node.position[type] || {};
        return {
            line: point.line || null,
            column: point.column || null,
            offset: isNaN(point.offset) ? null : point.offset
        };
    }
}

});

parcelRegister("878M9", function(module, exports) {
'use strict';
module.exports = $5e85c8da216ed04b$var$generated;
function $5e85c8da216ed04b$var$generated(node) {
    return !node || !node.position || !node.position.start || !node.position.start.line || !node.position.start.column || !node.position.end || !node.position.end.line || !node.position.end.column;
}

});

parcelRegister("iYmo0", function(module, exports) {
'use strict';

var $lxQxI = parcelRequire("lxQxI");
module.exports = $dcff3202e7e8ae6f$var$getDefinitionFactory;
var $dcff3202e7e8ae6f$var$own = {}.hasOwnProperty;
// Get a definition in `node` by `identifier`.
function $dcff3202e7e8ae6f$var$getDefinitionFactory(node, options) {
    return $dcff3202e7e8ae6f$var$getterFactory($dcff3202e7e8ae6f$var$gather(node, options));
}
// Gather all definitions in `node`
function $dcff3202e7e8ae6f$var$gather(node) {
    var cache = {};
    if (!node || !node.type) throw new Error('mdast-util-definitions expected node');
    $lxQxI(node, 'definition', ondefinition);
    return cache;
    function ondefinition(definition) {
        var id = $dcff3202e7e8ae6f$var$normalise(definition.identifier);
        if (!$dcff3202e7e8ae6f$var$own.call(cache, id)) cache[id] = definition;
    }
}
// Factory to get a node from the given definition-cache.
function $dcff3202e7e8ae6f$var$getterFactory(cache) {
    return getter;
    // Get a node from the bound definition-cache.
    function getter(identifier) {
        var id = identifier && $dcff3202e7e8ae6f$var$normalise(identifier);
        return id && $dcff3202e7e8ae6f$var$own.call(cache, id) ? cache[id] : null;
    }
}
function $dcff3202e7e8ae6f$var$normalise(identifier) {
    return identifier.toUpperCase();
}

});

parcelRegister("ewvob", function(module, exports) {
'use strict';
module.exports = $a92c670cee933364$var$one;

var $k5hlo = parcelRequire("k5hlo");

var $1d9zq = parcelRequire("1d9zq");
var $a92c670cee933364$var$own = {}.hasOwnProperty;
// Transform an unknown node.
function $a92c670cee933364$var$unknown(h, node) {
    if ($a92c670cee933364$var$text(node)) return h.augment(node, $k5hlo('text', node.value));
    return h(node, 'div', $1d9zq(h, node));
}
// Visit a node.
function $a92c670cee933364$var$one(h, node, parent) {
    var type = node && node.type;
    var fn;
    // Fail on non-nodes.
    if (!type) throw new Error('Expected node, got `' + node + '`');
    if ($a92c670cee933364$var$own.call(h.handlers, type)) fn = h.handlers[type];
    else if (h.passThrough && h.passThrough.indexOf(type) > -1) fn = $a92c670cee933364$var$returnNode;
    else fn = h.unknownHandler;
    return (typeof fn === 'function' ? fn : $a92c670cee933364$var$unknown)(h, node, parent);
}
// Check if the node should be renderered as a text node.
function $a92c670cee933364$var$text(node) {
    var data = node.data || {};
    if ($a92c670cee933364$var$own.call(data, 'hName') || $a92c670cee933364$var$own.call(data, 'hProperties') || $a92c670cee933364$var$own.call(data, 'hChildren')) return false;
    return 'value' in node;
}
function $a92c670cee933364$var$returnNode(h, node) {
    var clone;
    if (node.children) {
        clone = Object.assign({}, node);
        clone.children = $1d9zq(h, node);
        return clone;
    }
    return node;
}

});
parcelRegister("1d9zq", function(module, exports) {
'use strict';
module.exports = $0e1e6dcbddebf7f9$var$all;

var $ewvob = parcelRequire("ewvob");
function $0e1e6dcbddebf7f9$var$all(h, parent) {
    var nodes = parent.children || [];
    var length = nodes.length;
    var values = [];
    var index = -1;
    var result;
    var head;
    while(++index < length){
        result = $ewvob(h, nodes[index], parent);
        if (result) {
            if (index && nodes[index - 1].type === 'break') {
                if (result.value) result.value = result.value.replace(/^\s+/, '');
                head = result.children && result.children[0];
                if (head && head.value) head.value = head.value.replace(/^\s+/, '');
            }
            values = values.concat(result);
        }
    }
    return values;
}

});


parcelRegister("85uZB", function(module, exports) {
'use strict';
module.exports = $5e36d4d3e0f3c5b4$var$generateFootnotes;

var $3gMWL = parcelRequire("3gMWL");

var $hILp2 = parcelRequire("hILp2");

var $hJJj8 = parcelRequire("hJJj8");
function $5e36d4d3e0f3c5b4$var$generateFootnotes(h) {
    var footnoteById = h.footnoteById;
    var footnoteOrder = h.footnoteOrder;
    var length = footnoteOrder.length;
    var index = -1;
    var listItems = [];
    var def;
    var backReference;
    var content;
    var tail;
    while(++index < length){
        def = footnoteById[footnoteOrder[index].toUpperCase()];
        if (!def) continue;
        content = def.children.concat();
        tail = content[content.length - 1];
        backReference = {
            type: 'link',
            url: '#fnref-' + def.identifier,
            data: {
                hProperties: {
                    className: [
                        'footnote-backref'
                    ]
                }
            },
            children: [
                {
                    type: 'text',
                    value: "\u21A9"
                }
            ]
        };
        if (!tail || tail.type !== 'paragraph') {
            tail = {
                type: 'paragraph',
                children: []
            };
            content.push(tail);
        }
        tail.children.push(backReference);
        listItems.push({
            type: 'listItem',
            data: {
                hProperties: {
                    id: 'fn-' + def.identifier
                }
            },
            children: content,
            position: def.position
        });
    }
    if (listItems.length === 0) return null;
    return h(null, 'div', {
        className: [
            'footnotes'
        ]
    }, $hJJj8([
        $3gMWL(h),
        $hILp2(h, {
            type: 'list',
            ordered: true,
            children: listItems
        })
    ], true));
}

});
parcelRegister("3gMWL", function(module, exports) {
'use strict';
module.exports = $2618d589c36ca247$var$thematicBreak;
function $2618d589c36ca247$var$thematicBreak(h, node) {
    return h(node, 'hr');
}

});

parcelRegister("hILp2", function(module, exports) {
'use strict';
module.exports = $ce6b50f31948337e$var$list;

var $hJJj8 = parcelRequire("hJJj8");

var $1d9zq = parcelRequire("1d9zq");
function $ce6b50f31948337e$var$list(h, node) {
    var props = {};
    var name = node.ordered ? 'ol' : 'ul';
    var items;
    var index = -1;
    var length;
    if (typeof node.start === 'number' && node.start !== 1) props.start = node.start;
    items = $1d9zq(h, node);
    length = items.length;
    // Like GitHub, add a class for custom styling.
    while(++index < length)if (items[index].properties.className && items[index].properties.className.indexOf('task-list-item') !== -1) {
        props.className = [
            'contains-task-list'
        ];
        break;
    }
    return h(node, name, props, $hJJj8(items, true));
}

});
parcelRegister("hJJj8", function(module, exports) {
'use strict';
module.exports = $ce99c8c8ca5ce520$var$wrap;

var $k5hlo = parcelRequire("k5hlo");
// Wrap `nodes` with line feeds between each entry.
// Optionally adds line feeds at the start and end.
function $ce99c8c8ca5ce520$var$wrap(nodes, loose) {
    var result = [];
    var index = -1;
    var length = nodes.length;
    if (loose) result.push($k5hlo('text', '\n'));
    while(++index < length){
        if (index) result.push($k5hlo('text', '\n'));
        result.push(nodes[index]);
    }
    if (loose && nodes.length > 0) result.push($k5hlo('text', '\n'));
    return result;
}

});



parcelRegister("4IEHE", function(module, exports) {
'use strict';






















module.exports = {
    blockquote: (parcelRequire("ihpkq")),
    break: (parcelRequire("6AcYA")),
    code: (parcelRequire("gQNWa")),
    delete: (parcelRequire("alS89")),
    emphasis: (parcelRequire("ig9Uq")),
    footnoteReference: (parcelRequire("1JUS1")),
    footnote: (parcelRequire("8DnGu")),
    heading: (parcelRequire("gtsPF")),
    html: (parcelRequire("f94vv")),
    imageReference: (parcelRequire("bN0CK")),
    image: (parcelRequire("9WFEt")),
    inlineCode: (parcelRequire("1tz46")),
    linkReference: (parcelRequire("qkrDT")),
    link: (parcelRequire("kh9L7")),
    listItem: (parcelRequire("4FQhD")),
    list: (parcelRequire("hILp2")),
    paragraph: (parcelRequire("ajhAC")),
    root: (parcelRequire("4lSC1")),
    strong: (parcelRequire("3HEXD")),
    table: (parcelRequire("4XJSP")),
    text: (parcelRequire("5aRfd")),
    thematicBreak: (parcelRequire("3gMWL")),
    toml: $36fad847f2d28c48$var$ignore,
    yaml: $36fad847f2d28c48$var$ignore,
    definition: $36fad847f2d28c48$var$ignore,
    footnoteDefinition: $36fad847f2d28c48$var$ignore
};
// Return nothing for nodes that are ignored.
function $36fad847f2d28c48$var$ignore() {
    return null;
}

});
parcelRegister("ihpkq", function(module, exports) {
'use strict';
module.exports = $d4ed7636a382c075$var$blockquote;

var $hJJj8 = parcelRequire("hJJj8");

var $1d9zq = parcelRequire("1d9zq");
function $d4ed7636a382c075$var$blockquote(h, node) {
    return h(node, 'blockquote', $hJJj8($1d9zq(h, node), true));
}

});

parcelRegister("6AcYA", function(module, exports) {
'use strict';
module.exports = $4cb02baeed0935fd$var$hardBreak;

var $k5hlo = parcelRequire("k5hlo");
function $4cb02baeed0935fd$var$hardBreak(h, node) {
    return [
        h(node, 'br'),
        $k5hlo('text', '\n')
    ];
}

});

parcelRegister("gQNWa", function(module, exports) {
'use strict';
module.exports = $c4483d2374a093a3$var$code;

var $k5hlo = parcelRequire("k5hlo");
function $c4483d2374a093a3$var$code(h, node) {
    var value = node.value ? node.value + '\n' : '';
    // To do: next major, use `node.lang` w/o regex, the splitting’s been going
    // on for years in remark now.
    var lang = node.lang && node.lang.match(/^[^ \t]+(?=[ \t]|$)/);
    var props = {};
    var code;
    if (lang) props.className = [
        'language-' + lang
    ];
    code = h(node, 'code', props, [
        $k5hlo('text', value)
    ]);
    if (node.meta) code.data = {
        meta: node.meta
    };
    return h(node.position, 'pre', [
        code
    ]);
}

});

parcelRegister("alS89", function(module, exports) {
'use strict';
module.exports = $7895dac1309d4d35$var$strikethrough;

var $1d9zq = parcelRequire("1d9zq");
function $7895dac1309d4d35$var$strikethrough(h, node) {
    return h(node, 'del', $1d9zq(h, node));
}

});

parcelRegister("ig9Uq", function(module, exports) {
'use strict';
module.exports = $d4b1685ed25a1c79$var$emphasis;

var $1d9zq = parcelRequire("1d9zq");
function $d4b1685ed25a1c79$var$emphasis(h, node) {
    return h(node, 'em', $1d9zq(h, node));
}

});

parcelRegister("1JUS1", function(module, exports) {
'use strict';
module.exports = $14461baf285c043c$var$footnoteReference;

var $k5hlo = parcelRequire("k5hlo");
function $14461baf285c043c$var$footnoteReference(h, node) {
    var footnoteOrder = h.footnoteOrder;
    var identifier = String(node.identifier);
    if (footnoteOrder.indexOf(identifier) === -1) footnoteOrder.push(identifier);
    return h(node.position, 'sup', {
        id: 'fnref-' + identifier
    }, [
        h(node, 'a', {
            href: '#fn-' + identifier,
            className: [
                'footnote-ref'
            ]
        }, [
            $k5hlo('text', node.label || identifier)
        ])
    ]);
}

});

parcelRegister("8DnGu", function(module, exports) {
'use strict';
module.exports = $649456778c88f757$var$footnote;

var $1JUS1 = parcelRequire("1JUS1");
function $649456778c88f757$var$footnote(h, node) {
    var footnoteById = h.footnoteById;
    var footnoteOrder = h.footnoteOrder;
    var identifier = 1;
    while(identifier in footnoteById)identifier++;
    identifier = String(identifier);
    // No need to check if `identifier` exists in `footnoteOrder`, it’s guaranteed
    // to not exist because we just generated it.
    footnoteOrder.push(identifier);
    footnoteById[identifier] = {
        type: 'footnoteDefinition',
        identifier: identifier,
        children: [
            {
                type: 'paragraph',
                children: node.children
            }
        ],
        position: node.position
    };
    return $1JUS1(h, {
        type: 'footnoteReference',
        identifier: identifier,
        position: node.position
    });
}

});

parcelRegister("gtsPF", function(module, exports) {
'use strict';
module.exports = $bfe5b84175351cb5$var$heading;

var $1d9zq = parcelRequire("1d9zq");
function $bfe5b84175351cb5$var$heading(h, node) {
    return h(node, 'h' + node.depth, $1d9zq(h, node));
}

});

parcelRegister("f94vv", function(module, exports) {
'use strict';
module.exports = $b06b314d7b6e1d74$var$html;

var $k5hlo = parcelRequire("k5hlo");
// Return either a `raw` node in dangerous mode, otherwise nothing.
function $b06b314d7b6e1d74$var$html(h, node) {
    return h.dangerous ? h.augment(node, $k5hlo('raw', node.value)) : null;
}

});

parcelRegister("bN0CK", function(module, exports) {
'use strict';
module.exports = $8954c134ad1c4aad$var$imageReference;

var $eRV99 = parcelRequire("eRV99");

var $jFvpE = parcelRequire("jFvpE");
function $8954c134ad1c4aad$var$imageReference(h, node) {
    var def = h.definition(node.identifier);
    var props;
    if (!def) return $jFvpE(h, node);
    props = {
        src: $eRV99(def.url || ''),
        alt: node.alt
    };
    if (def.title !== null && def.title !== undefined) props.title = def.title;
    return h(node, 'img', props);
}

});
parcelRegister("eRV99", function(module, exports) {
'use strict';
var $ad32580f48d2518a$var$encodeCache = {};
// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function $ad32580f48d2518a$var$getEncodeCache(exclude) {
    var i, ch, cache = $ad32580f48d2518a$var$encodeCache[exclude];
    if (cache) return cache;
    cache = $ad32580f48d2518a$var$encodeCache[exclude] = [];
    for(i = 0; i < 128; i++){
        ch = String.fromCharCode(i);
        if (/^[0-9a-z]$/i.test(ch)) // always allow unencoded alphanumeric characters
        cache.push(ch);
        else cache.push('%' + ('0' + i.toString(16).toUpperCase()).slice(-2));
    }
    for(i = 0; i < exclude.length; i++)cache[exclude.charCodeAt(i)] = exclude[i];
    return cache;
}
// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function $ad32580f48d2518a$var$encode(string, exclude, keepEscaped) {
    var i, l, code, nextCode, cache, result = '';
    if (typeof exclude !== 'string') {
        // encode(string, keepEscaped)
        keepEscaped = exclude;
        exclude = $ad32580f48d2518a$var$encode.defaultChars;
    }
    if (typeof keepEscaped === 'undefined') keepEscaped = true;
    cache = $ad32580f48d2518a$var$getEncodeCache(exclude);
    for(i = 0, l = string.length; i < l; i++){
        code = string.charCodeAt(i);
        if (keepEscaped && code === 0x25 /* % */  && i + 2 < l) {
            if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
                result += string.slice(i, i + 3);
                i += 2;
                continue;
            }
        }
        if (code < 128) {
            result += cache[code];
            continue;
        }
        if (code >= 0xD800 && code <= 0xDFFF) {
            if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
                nextCode = string.charCodeAt(i + 1);
                if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
                    result += encodeURIComponent(string[i] + string[i + 1]);
                    i++;
                    continue;
                }
            }
            result += '%EF%BF%BD';
            continue;
        }
        result += encodeURIComponent(string[i]);
    }
    return result;
}
$ad32580f48d2518a$var$encode.defaultChars = ";/?:@&=+$,-_.!~*'()#";
$ad32580f48d2518a$var$encode.componentChars = "-_.!~*'()";
module.exports = $ad32580f48d2518a$var$encode;

});

parcelRegister("jFvpE", function(module, exports) {
'use strict';
module.exports = $e51a368d0d07d891$var$revert;

var $k5hlo = parcelRequire("k5hlo");

var $1d9zq = parcelRequire("1d9zq");
// Return the content of a reference without definition as Markdown.
function $e51a368d0d07d891$var$revert(h, node) {
    var subtype = node.referenceType;
    var suffix = ']';
    var contents;
    var head;
    var tail;
    if (subtype === 'collapsed') suffix += '[]';
    else if (subtype === 'full') suffix += '[' + (node.label || node.identifier) + ']';
    if (node.type === 'imageReference') return $k5hlo('text', '![' + node.alt + suffix);
    contents = $1d9zq(h, node);
    head = contents[0];
    if (head && head.type === 'text') head.value = '[' + head.value;
    else contents.unshift($k5hlo('text', '['));
    tail = contents[contents.length - 1];
    if (tail && tail.type === 'text') tail.value += suffix;
    else contents.push($k5hlo('text', suffix));
    return contents;
}

});


parcelRegister("9WFEt", function(module, exports) {
'use strict';

var $eRV99 = parcelRequire("eRV99");
module.exports = $73d9d70778b23bfb$var$image;
function $73d9d70778b23bfb$var$image(h, node) {
    var props = {
        src: $eRV99(node.url),
        alt: node.alt
    };
    if (node.title !== null && node.title !== undefined) props.title = node.title;
    return h(node, 'img', props);
}

});

parcelRegister("1tz46", function(module, exports) {
'use strict';
module.exports = $1133b317a790a08e$var$inlineCode;

var $k5hlo = parcelRequire("k5hlo");
function $1133b317a790a08e$var$inlineCode(h, node) {
    var value = node.value.replace(/\r?\n|\r/g, ' ');
    return h(node, 'code', [
        $k5hlo('text', value)
    ]);
}

});

parcelRegister("qkrDT", function(module, exports) {
'use strict';
module.exports = $04f249be2d43e397$var$linkReference;

var $eRV99 = parcelRequire("eRV99");

var $jFvpE = parcelRequire("jFvpE");

var $1d9zq = parcelRequire("1d9zq");
function $04f249be2d43e397$var$linkReference(h, node) {
    var def = h.definition(node.identifier);
    var props;
    if (!def) return $jFvpE(h, node);
    props = {
        href: $eRV99(def.url || '')
    };
    if (def.title !== null && def.title !== undefined) props.title = def.title;
    return h(node, 'a', props, $1d9zq(h, node));
}

});

parcelRegister("kh9L7", function(module, exports) {
'use strict';

var $eRV99 = parcelRequire("eRV99");

var $1d9zq = parcelRequire("1d9zq");
module.exports = $ec2cf719b832e1a8$var$link;
function $ec2cf719b832e1a8$var$link(h, node) {
    var props = {
        href: $eRV99(node.url)
    };
    if (node.title !== null && node.title !== undefined) props.title = node.title;
    return h(node, 'a', props, $1d9zq(h, node));
}

});

parcelRegister("4FQhD", function(module, exports) {
'use strict';
module.exports = $36738c2cb0fbe5fc$var$listItem;

var $k5hlo = parcelRequire("k5hlo");

var $1d9zq = parcelRequire("1d9zq");
function $36738c2cb0fbe5fc$var$listItem(h, node, parent) {
    var result = $1d9zq(h, node);
    var head = result[0];
    var loose = parent ? $36738c2cb0fbe5fc$var$listLoose(parent) : $36738c2cb0fbe5fc$var$listItemLoose(node);
    var props = {};
    var wrapped = [];
    var length;
    var index;
    var child;
    if (typeof node.checked === 'boolean') {
        if (!head || head.tagName !== 'p') {
            head = h(null, 'p', []);
            result.unshift(head);
        }
        if (head.children.length > 0) head.children.unshift($k5hlo('text', ' '));
        head.children.unshift(h(null, 'input', {
            type: 'checkbox',
            checked: node.checked,
            disabled: true
        }));
        // According to github-markdown-css, this class hides bullet.
        // See: <https://github.com/sindresorhus/github-markdown-css>.
        props.className = [
            'task-list-item'
        ];
    }
    length = result.length;
    index = -1;
    while(++index < length){
        child = result[index];
        // Add eols before nodes, except if this is a loose, first paragraph.
        if (loose || index !== 0 || child.tagName !== 'p') wrapped.push($k5hlo('text', '\n'));
        if (child.tagName === 'p' && !loose) wrapped = wrapped.concat(child.children);
        else wrapped.push(child);
    }
    // Add a final eol.
    if (length && (loose || child.tagName !== 'p')) wrapped.push($k5hlo('text', '\n'));
    return h(node, 'li', props, wrapped);
}
function $36738c2cb0fbe5fc$var$listLoose(node) {
    var loose = node.spread;
    var children = node.children;
    var length = children.length;
    var index = -1;
    while(!loose && ++index < length)loose = $36738c2cb0fbe5fc$var$listItemLoose(children[index]);
    return loose;
}
function $36738c2cb0fbe5fc$var$listItemLoose(node) {
    var spread = node.spread;
    return spread === undefined || spread === null ? node.children.length > 1 : spread;
}

});

parcelRegister("ajhAC", function(module, exports) {
'use strict';
module.exports = $781952af94f9f06e$var$paragraph;

var $1d9zq = parcelRequire("1d9zq");
function $781952af94f9f06e$var$paragraph(h, node) {
    return h(node, 'p', $1d9zq(h, node));
}

});

parcelRegister("4lSC1", function(module, exports) {
'use strict';
module.exports = $32b37c766f9fff9b$var$root;

var $k5hlo = parcelRequire("k5hlo");

var $hJJj8 = parcelRequire("hJJj8");

var $1d9zq = parcelRequire("1d9zq");
function $32b37c766f9fff9b$var$root(h, node) {
    return h.augment(node, $k5hlo('root', $hJJj8($1d9zq(h, node))));
}

});

parcelRegister("3HEXD", function(module, exports) {
'use strict';
module.exports = $2b25293dda882d5f$var$strong;

var $1d9zq = parcelRequire("1d9zq");
function $2b25293dda882d5f$var$strong(h, node) {
    return h(node, 'strong', $1d9zq(h, node));
}

});

parcelRegister("4XJSP", function(module, exports) {
'use strict';
module.exports = $39d043926e26bb79$var$table;

var $l5vcs = parcelRequire("l5vcs");

var $hJJj8 = parcelRequire("hJJj8");

var $1d9zq = parcelRequire("1d9zq");
function $39d043926e26bb79$var$table(h, node) {
    var rows = node.children;
    var index = rows.length;
    var align = node.align || [];
    var alignLength = align.length;
    var result = [];
    var pos;
    var row;
    var out;
    var name;
    var cell;
    while(index--){
        row = rows[index].children;
        name = index === 0 ? 'th' : 'td';
        pos = alignLength || row.length;
        out = [];
        while(pos--){
            cell = row[pos];
            out[pos] = h(cell, name, {
                align: align[pos]
            }, cell ? $1d9zq(h, cell) : []);
        }
        result[index] = h(rows[index], 'tr', $hJJj8(out, true));
    }
    return h(node, 'table', $hJJj8([
        h(result[0].position, 'thead', $hJJj8([
            result[0]
        ], true))
    ].concat(result[1] ? h({
        start: $l5vcs.start(result[1]),
        end: $l5vcs.end(result[result.length - 1])
    }, 'tbody', $hJJj8(result.slice(1), true)) : []), true));
}

});

parcelRegister("5aRfd", function(module, exports) {
'use strict';
module.exports = $3c4730247b89d735$var$text;

var $k5hlo = parcelRequire("k5hlo");
function $3c4730247b89d735$var$text(h, node) {
    return h.augment(node, $k5hlo('text', String(node.value).replace(/[ \t]*(\r?\n|\r)[ \t]*/g, '$1')));
}

});



parcelRegister("diARD", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $9ae98d410e18ca67$export$a7c73072b1a182ae; }, function (v) { return $9ae98d410e18ca67$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $9ae98d410e18ca67$export$9f27bc3417b4524d; }, function (v) { return $9ae98d410e18ca67$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $9ae98d410e18ca67$export$db77ccec0bb4ccac; }, function (v) { return $9ae98d410e18ca67$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $9ae98d410e18ca67$export$8392c0c9d3dcbd35; }, function (v) { return $9ae98d410e18ca67$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $9ae98d410e18ca67$export$ffb0004e005737fa; }, function (v) { return $9ae98d410e18ca67$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $9ae98d410e18ca67$export$b624eff549462981; }, function (v) { return $9ae98d410e18ca67$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $9ae98d410e18ca67$export$7897aa7841a5380c; }, function (v) { return $9ae98d410e18ca67$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $9ae98d410e18ca67$export$602eac185826482c; }, function (v) { return $9ae98d410e18ca67$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $9ae98d410e18ca67$export$e2c29f18771995cb; }, function (v) { return $9ae98d410e18ca67$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $9ae98d410e18ca67$export$5f8d39834fd61797; }, function (v) { return $9ae98d410e18ca67$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $9ae98d410e18ca67$export$74bf444e3cd11ea5; }, function (v) { return $9ae98d410e18ca67$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $9ae98d410e18ca67$export$92387174baf9b227; }, function (v) { return $9ae98d410e18ca67$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $9ae98d410e18ca67$export$ec112efeb987d9c6; }, function (v) { return $9ae98d410e18ca67$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $9ae98d410e18ca67$export$b706b080d889d2c9; }, function (v) { return $9ae98d410e18ca67$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $9ae98d410e18ca67$export$5be5a87408f70ddc; }, function (v) { return $9ae98d410e18ca67$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $9ae98d410e18ca67$export$45a5e7f76e0caa8d; }, function (v) { return $9ae98d410e18ca67$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $9ae98d410e18ca67$export$455c2e768291efa6; }, function (v) { return $9ae98d410e18ca67$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $9ae98d410e18ca67$export$9522e17588c12572; }, function (v) { return $9ae98d410e18ca67$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $9ae98d410e18ca67$export$2110ac352bb060b9; }, function (v) { return $9ae98d410e18ca67$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $9ae98d410e18ca67$export$56885ab8b9c456ab; }, function (v) { return $9ae98d410e18ca67$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $9ae98d410e18ca67$export$d927fcb6adf8f9de; }, function (v) { return $9ae98d410e18ca67$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $9ae98d410e18ca67$export$b82d16f27459e05a; }, function (v) { return $9ae98d410e18ca67$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $9ae98d410e18ca67$export$522c17b4f5e123e8; }, function (v) { return $9ae98d410e18ca67$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $9ae98d410e18ca67$export$1aabd8a0274ecfd6; }, function (v) { return $9ae98d410e18ca67$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $9ae98d410e18ca67$export$9b621391a187a31a; }, function (v) { return $9ae98d410e18ca67$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $9ae98d410e18ca67$export$f5bbd400c2f4426f; }, function (v) { return $9ae98d410e18ca67$export$f5bbd400c2f4426f = v; });
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9ae98d410e18ca67$export$a7c73072b1a182ae;
var $9ae98d410e18ca67$export$9f27bc3417b4524d;
var $9ae98d410e18ca67$export$db77ccec0bb4ccac;
var $9ae98d410e18ca67$export$8392c0c9d3dcbd35;
var $9ae98d410e18ca67$export$ffb0004e005737fa;
var $9ae98d410e18ca67$export$b624eff549462981;
var $9ae98d410e18ca67$export$7897aa7841a5380c;
var $9ae98d410e18ca67$export$602eac185826482c;
var $9ae98d410e18ca67$export$e2c29f18771995cb;
var $9ae98d410e18ca67$export$5f8d39834fd61797;
var $9ae98d410e18ca67$export$74bf444e3cd11ea5;
var $9ae98d410e18ca67$export$92387174baf9b227;
var $9ae98d410e18ca67$export$ec112efeb987d9c6;
var $9ae98d410e18ca67$export$b706b080d889d2c9;
var $9ae98d410e18ca67$export$5be5a87408f70ddc;
var $9ae98d410e18ca67$export$45a5e7f76e0caa8d;
var $9ae98d410e18ca67$export$455c2e768291efa6;
var $9ae98d410e18ca67$export$9522e17588c12572;
var $9ae98d410e18ca67$export$2110ac352bb060b9;
var $9ae98d410e18ca67$export$56885ab8b9c456ab;
var $9ae98d410e18ca67$export$d927fcb6adf8f9de;
var $9ae98d410e18ca67$export$b82d16f27459e05a;
var $9ae98d410e18ca67$export$522c17b4f5e123e8;
var $9ae98d410e18ca67$export$1aabd8a0274ecfd6;
var $9ae98d410e18ca67$export$9b621391a187a31a;
var $9ae98d410e18ca67$export$f5bbd400c2f4426f;
'use strict';
var $9ae98d410e18ca67$var$b = 60103, $9ae98d410e18ca67$var$c = 60106, $9ae98d410e18ca67$var$d = 60107, $9ae98d410e18ca67$var$e = 60108, $9ae98d410e18ca67$var$f = 60114, $9ae98d410e18ca67$var$g = 60109, $9ae98d410e18ca67$var$h = 60110, $9ae98d410e18ca67$var$k = 60112, $9ae98d410e18ca67$var$l = 60113, $9ae98d410e18ca67$var$m = 60120, $9ae98d410e18ca67$var$n = 60115, $9ae98d410e18ca67$var$p = 60116, $9ae98d410e18ca67$var$q = 60121, $9ae98d410e18ca67$var$r = 60122, $9ae98d410e18ca67$var$u = 60117, $9ae98d410e18ca67$var$v = 60129, $9ae98d410e18ca67$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $9ae98d410e18ca67$var$x = Symbol.for;
    $9ae98d410e18ca67$var$b = $9ae98d410e18ca67$var$x("react.element");
    $9ae98d410e18ca67$var$c = $9ae98d410e18ca67$var$x("react.portal");
    $9ae98d410e18ca67$var$d = $9ae98d410e18ca67$var$x("react.fragment");
    $9ae98d410e18ca67$var$e = $9ae98d410e18ca67$var$x("react.strict_mode");
    $9ae98d410e18ca67$var$f = $9ae98d410e18ca67$var$x("react.profiler");
    $9ae98d410e18ca67$var$g = $9ae98d410e18ca67$var$x("react.provider");
    $9ae98d410e18ca67$var$h = $9ae98d410e18ca67$var$x("react.context");
    $9ae98d410e18ca67$var$k = $9ae98d410e18ca67$var$x("react.forward_ref");
    $9ae98d410e18ca67$var$l = $9ae98d410e18ca67$var$x("react.suspense");
    $9ae98d410e18ca67$var$m = $9ae98d410e18ca67$var$x("react.suspense_list");
    $9ae98d410e18ca67$var$n = $9ae98d410e18ca67$var$x("react.memo");
    $9ae98d410e18ca67$var$p = $9ae98d410e18ca67$var$x("react.lazy");
    $9ae98d410e18ca67$var$q = $9ae98d410e18ca67$var$x("react.block");
    $9ae98d410e18ca67$var$r = $9ae98d410e18ca67$var$x("react.server.block");
    $9ae98d410e18ca67$var$u = $9ae98d410e18ca67$var$x("react.fundamental");
    $9ae98d410e18ca67$var$v = $9ae98d410e18ca67$var$x("react.debug_trace_mode");
    $9ae98d410e18ca67$var$w = $9ae98d410e18ca67$var$x("react.legacy_hidden");
}
function $9ae98d410e18ca67$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $9ae98d410e18ca67$var$b:
                switch(a = a.type, a){
                    case $9ae98d410e18ca67$var$d:
                    case $9ae98d410e18ca67$var$f:
                    case $9ae98d410e18ca67$var$e:
                    case $9ae98d410e18ca67$var$l:
                    case $9ae98d410e18ca67$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $9ae98d410e18ca67$var$h:
                            case $9ae98d410e18ca67$var$k:
                            case $9ae98d410e18ca67$var$p:
                            case $9ae98d410e18ca67$var$n:
                            case $9ae98d410e18ca67$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $9ae98d410e18ca67$var$c:
                return t;
        }
    }
}
var $9ae98d410e18ca67$var$z = $9ae98d410e18ca67$var$g, $9ae98d410e18ca67$var$A = $9ae98d410e18ca67$var$b, $9ae98d410e18ca67$var$B = $9ae98d410e18ca67$var$k, $9ae98d410e18ca67$var$C = $9ae98d410e18ca67$var$d, $9ae98d410e18ca67$var$D = $9ae98d410e18ca67$var$p, $9ae98d410e18ca67$var$E = $9ae98d410e18ca67$var$n, $9ae98d410e18ca67$var$F = $9ae98d410e18ca67$var$c, $9ae98d410e18ca67$var$G = $9ae98d410e18ca67$var$f, $9ae98d410e18ca67$var$H = $9ae98d410e18ca67$var$e, $9ae98d410e18ca67$var$I = $9ae98d410e18ca67$var$l;
$9ae98d410e18ca67$export$a7c73072b1a182ae = $9ae98d410e18ca67$var$h;
$9ae98d410e18ca67$export$9f27bc3417b4524d = $9ae98d410e18ca67$var$z;
$9ae98d410e18ca67$export$db77ccec0bb4ccac = $9ae98d410e18ca67$var$A;
$9ae98d410e18ca67$export$8392c0c9d3dcbd35 = $9ae98d410e18ca67$var$B;
$9ae98d410e18ca67$export$ffb0004e005737fa = $9ae98d410e18ca67$var$C;
$9ae98d410e18ca67$export$b624eff549462981 = $9ae98d410e18ca67$var$D;
$9ae98d410e18ca67$export$7897aa7841a5380c = $9ae98d410e18ca67$var$E;
$9ae98d410e18ca67$export$602eac185826482c = $9ae98d410e18ca67$var$F;
$9ae98d410e18ca67$export$e2c29f18771995cb = $9ae98d410e18ca67$var$G;
$9ae98d410e18ca67$export$5f8d39834fd61797 = $9ae98d410e18ca67$var$H;
$9ae98d410e18ca67$export$74bf444e3cd11ea5 = $9ae98d410e18ca67$var$I;
$9ae98d410e18ca67$export$92387174baf9b227 = function() {
    return !1;
};
$9ae98d410e18ca67$export$ec112efeb987d9c6 = function() {
    return !1;
};
$9ae98d410e18ca67$export$b706b080d889d2c9 = function(a) {
    return $9ae98d410e18ca67$var$y(a) === $9ae98d410e18ca67$var$h;
};
$9ae98d410e18ca67$export$5be5a87408f70ddc = function(a) {
    return $9ae98d410e18ca67$var$y(a) === $9ae98d410e18ca67$var$g;
};
$9ae98d410e18ca67$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $9ae98d410e18ca67$var$b;
};
$9ae98d410e18ca67$export$455c2e768291efa6 = function(a) {
    return $9ae98d410e18ca67$var$y(a) === $9ae98d410e18ca67$var$k;
};
$9ae98d410e18ca67$export$9522e17588c12572 = function(a) {
    return $9ae98d410e18ca67$var$y(a) === $9ae98d410e18ca67$var$d;
};
$9ae98d410e18ca67$export$2110ac352bb060b9 = function(a) {
    return $9ae98d410e18ca67$var$y(a) === $9ae98d410e18ca67$var$p;
};
$9ae98d410e18ca67$export$56885ab8b9c456ab = function(a) {
    return $9ae98d410e18ca67$var$y(a) === $9ae98d410e18ca67$var$n;
};
$9ae98d410e18ca67$export$d927fcb6adf8f9de = function(a) {
    return $9ae98d410e18ca67$var$y(a) === $9ae98d410e18ca67$var$c;
};
$9ae98d410e18ca67$export$b82d16f27459e05a = function(a) {
    return $9ae98d410e18ca67$var$y(a) === $9ae98d410e18ca67$var$f;
};
$9ae98d410e18ca67$export$522c17b4f5e123e8 = function(a) {
    return $9ae98d410e18ca67$var$y(a) === $9ae98d410e18ca67$var$e;
};
$9ae98d410e18ca67$export$1aabd8a0274ecfd6 = function(a) {
    return $9ae98d410e18ca67$var$y(a) === $9ae98d410e18ca67$var$l;
};
$9ae98d410e18ca67$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $9ae98d410e18ca67$var$d || a === $9ae98d410e18ca67$var$f || a === $9ae98d410e18ca67$var$v || a === $9ae98d410e18ca67$var$e || a === $9ae98d410e18ca67$var$l || a === $9ae98d410e18ca67$var$m || a === $9ae98d410e18ca67$var$w || "object" === typeof a && null !== a && (a.$$typeof === $9ae98d410e18ca67$var$p || a.$$typeof === $9ae98d410e18ca67$var$n || a.$$typeof === $9ae98d410e18ca67$var$g || a.$$typeof === $9ae98d410e18ca67$var$h || a.$$typeof === $9ae98d410e18ca67$var$k || a.$$typeof === $9ae98d410e18ca67$var$u || a.$$typeof === $9ae98d410e18ca67$var$q || a[0] === $9ae98d410e18ca67$var$r) ? !0 : !1;
};
$9ae98d410e18ca67$export$f5bbd400c2f4426f = $9ae98d410e18ca67$var$y;

});

parcelRegister("b0uZf", function(module, exports) {
'use strict';
/**
 * # Constructor
 *
 * Provided as a convenient wrapper around Fast functions.
 *
 * ```js
 * var arr = fast([1,2,3,4,5,6]);
 *
 * var result = arr.filter(function (item) {
 *   return item % 2 === 0;
 * });
 *
 * result instanceof Fast; // true
 * result.length; // 3
 * ```
 *
 *
 * @param {Array} value The value to wrap.
 */ function Fast(value) {
    if (!(this instanceof Fast)) return new Fast(value);
    this.value = value || [];
}
module.exports = exports = Fast;

Fast.array = (parcelRequire("ko2xd"));

Fast['function'] = Fast.fn = (parcelRequire("fL17Y"));

Fast.object = (parcelRequire("b47bx"));

Fast.string = (parcelRequire("5hjIi"));
Fast.apply = Fast['function'].apply;
Fast.bind = Fast['function'].bind;
Fast.partial = Fast['function'].partial;
Fast.partialConstructor = Fast['function'].partialConstructor;
Fast['try'] = Fast.attempt = Fast['function']['try'];
Fast.assign = Fast.object.assign;
Fast.cloneObject = Fast.object.clone; // @deprecated use fast.object.clone()
Fast.keys = Fast.object.keys;
Fast.values = Fast.object.values;

Fast.clone = (parcelRequire("RAfgy"));

Fast.map = (parcelRequire("lAv3U"));

Fast.filter = (parcelRequire("2kxQm"));

Fast.forEach = (parcelRequire("aWRjO"));

Fast.reduce = (parcelRequire("2q5xW"));

Fast.reduceRight = (parcelRequire("MPvsw"));
Fast.cloneArray = Fast.array.clone; // @deprecated use fast.array.clone()
Fast.concat = Fast.array.concat;
Fast.some = Fast.array.some;
Fast.every = Fast.array.every;
Fast.indexOf = Fast.array.indexOf;
Fast.lastIndexOf = Fast.array.lastIndexOf;
Fast.pluck = Fast.array.pluck;
Fast.fill = Fast.array.fill;
Fast.intern = Fast.string.intern;
/**
 * # Concat
 *
 * Concatenate multiple arrays.
 *
 * @param  {Array|mixed} item, ... The item(s) to concatenate.
 * @return {Fast}                  A new Fast object, containing the results.
 */ Fast.prototype.concat = function Fast$concat() {
    var length = this.value.length, arr = new Array(length), i, item, childLength, j;
    for(i = 0; i < length; i++)arr[i] = this.value[i];
    length = arguments.length;
    for(i = 0; i < length; i++){
        item = arguments[i];
        if (Array.isArray(item)) {
            childLength = item.length;
            for(j = 0; j < childLength; j++)arr.push(item[j]);
        } else arr.push(item);
    }
    return new Fast(arr);
};
/**
 * Fast Map
 *
 * @param  {Function} fn          The visitor function.
 * @param  {Object}   thisContext The context for the visitor, if any.
 * @return {Fast}                 A new Fast object, containing the results.
 */ Fast.prototype.map = function Fast$map(fn, thisContext) {
    return new Fast(Fast.map(this.value, fn, thisContext));
};
/**
 * Fast Filter
 *
 * @param  {Function} fn          The filter function.
 * @param  {Object}   thisContext The context for the filter function, if any.
 * @return {Fast}                 A new Fast object, containing the results.
 */ Fast.prototype.filter = function Fast$filter(fn, thisContext) {
    return new Fast(Fast.filter(this.value, fn, thisContext));
};
/**
 * Fast Reduce
 *
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value, if any.
 * @param  {Object}   thisContext  The context for the reducer, if any.
 * @return {mixed}                 The final result.
 */ Fast.prototype.reduce = function Fast$reduce(fn, initialValue, thisContext) {
    return Fast.reduce(this.value, fn, initialValue, thisContext);
};
/**
 * Fast Reduce Right
 *
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value, if any.
 * @param  {Object}   thisContext  The context for the reducer, if any.
 * @return {mixed}                 The final result.
 */ Fast.prototype.reduceRight = function Fast$reduceRight(fn, initialValue, thisContext) {
    return Fast.reduceRight(this.value, fn, initialValue, thisContext);
};
/**
 * Fast For Each
 *
 * @param  {Function} fn          The visitor function.
 * @param  {Object}   thisContext The context for the visitor, if any.
 * @return {Fast}                 The Fast instance.
 */ Fast.prototype.forEach = function Fast$forEach(fn, thisContext) {
    Fast.forEach(this.value, fn, thisContext);
    return this;
};
/**
 * Fast Some
 *
 * @param  {Function} fn          The matcher predicate.
 * @param  {Object}   thisContext The context for the matcher, if any.
 * @return {Boolean}              True if at least one element matches.
 */ Fast.prototype.some = function Fast$some(fn, thisContext) {
    return Fast.some(this.value, fn, thisContext);
};
/**
 * Fast Every
 *
 * @param  {Function} fn          The matcher predicate.
 * @param  {Object}   thisContext The context for the matcher, if any.
 * @return {Boolean}              True if at all elements match.
 */ Fast.prototype.every = function Fast$every(fn, thisContext) {
    return Fast.some(this.value, fn, thisContext);
};
/**
 * Fast Index Of
 *
 * @param  {mixed}  target    The target to lookup.
 * @param  {Number} fromIndex The index to start searching from, if known.
 * @return {Number}           The index of the item, or -1 if no match found.
 */ Fast.prototype.indexOf = function Fast$indexOf(target, fromIndex) {
    return Fast.indexOf(this.value, target, fromIndex);
};
/**
 * Fast Last Index Of
 *
 * @param  {mixed}  target    The target to lookup.
 * @param  {Number} fromIndex The index to start searching from, if known.
 * @return {Number}           The last index of the item, or -1 if no match found.
 */ Fast.prototype.lastIndexOf = function Fast$lastIndexOf(target, fromIndex) {
    return Fast.lastIndexOf(this.value, target, fromIndex);
};
/**
 * Reverse
 *
 * @return {Fast} A new Fast instance, with the contents reversed.
 */ Fast.prototype.reverse = function Fast$reverse() {
    return new Fast(this.value.reverse());
};
/**
 * Value Of
 *
 * @return {Array} The wrapped value.
 */ Fast.prototype.valueOf = function Fast$valueOf() {
    return this.value;
};
/**
 * To JSON
 *
 * @return {Array} The wrapped value.
 */ Fast.prototype.toJSON = function Fast$toJSON() {
    return this.value;
};
/**
 * Item Length
 */ Object.defineProperty(Fast.prototype, 'length', {
    get: function() {
        return this.value.length;
    }
});

});
parcelRegister("ko2xd", function(module, exports) {

$parcel$export(module.exports, "clone", function () { return $ed7803e7c397b842$export$9cd59f9826255e47; }, function (v) { return $ed7803e7c397b842$export$9cd59f9826255e47 = v; });
$parcel$export(module.exports, "concat", function () { return $ed7803e7c397b842$export$ee1b3e54f0441b22; }, function (v) { return $ed7803e7c397b842$export$ee1b3e54f0441b22 = v; });
$parcel$export(module.exports, "every", function () { return $ed7803e7c397b842$export$7ecc1a3b11b57dab; }, function (v) { return $ed7803e7c397b842$export$7ecc1a3b11b57dab = v; });
$parcel$export(module.exports, "filter", function () { return $ed7803e7c397b842$export$3dea766d36a8935f; }, function (v) { return $ed7803e7c397b842$export$3dea766d36a8935f = v; });
$parcel$export(module.exports, "forEach", function () { return $ed7803e7c397b842$export$4b80e395e36b5a56; }, function (v) { return $ed7803e7c397b842$export$4b80e395e36b5a56 = v; });
$parcel$export(module.exports, "indexOf", function () { return $ed7803e7c397b842$export$305f7d4e9d4624f2; }, function (v) { return $ed7803e7c397b842$export$305f7d4e9d4624f2 = v; });
$parcel$export(module.exports, "lastIndexOf", function () { return $ed7803e7c397b842$export$557cfb7ed375eeb7; }, function (v) { return $ed7803e7c397b842$export$557cfb7ed375eeb7 = v; });
$parcel$export(module.exports, "map", function () { return $ed7803e7c397b842$export$871de8747c9eaa88; }, function (v) { return $ed7803e7c397b842$export$871de8747c9eaa88 = v; });
$parcel$export(module.exports, "pluck", function () { return $ed7803e7c397b842$export$c44985b87d605eff; }, function (v) { return $ed7803e7c397b842$export$c44985b87d605eff = v; });
$parcel$export(module.exports, "reduce", function () { return $ed7803e7c397b842$export$533b26079ad0b4b; }, function (v) { return $ed7803e7c397b842$export$533b26079ad0b4b = v; });
$parcel$export(module.exports, "reduceRight", function () { return $ed7803e7c397b842$export$7fef8bcdbb34f435; }, function (v) { return $ed7803e7c397b842$export$7fef8bcdbb34f435 = v; });
$parcel$export(module.exports, "some", function () { return $ed7803e7c397b842$export$ad14ef4001db2bcd; }, function (v) { return $ed7803e7c397b842$export$ad14ef4001db2bcd = v; });
$parcel$export(module.exports, "fill", function () { return $ed7803e7c397b842$export$9563e054e6f787fb; }, function (v) { return $ed7803e7c397b842$export$9563e054e6f787fb = v; });
var $ed7803e7c397b842$export$9cd59f9826255e47;
var $ed7803e7c397b842$export$ee1b3e54f0441b22;
var $ed7803e7c397b842$export$7ecc1a3b11b57dab;
var $ed7803e7c397b842$export$3dea766d36a8935f;
var $ed7803e7c397b842$export$4b80e395e36b5a56;
var $ed7803e7c397b842$export$305f7d4e9d4624f2;
var $ed7803e7c397b842$export$557cfb7ed375eeb7;
var $ed7803e7c397b842$export$871de8747c9eaa88;
var $ed7803e7c397b842$export$c44985b87d605eff;
var $ed7803e7c397b842$export$533b26079ad0b4b;
var $ed7803e7c397b842$export$7fef8bcdbb34f435;
var $ed7803e7c397b842$export$ad14ef4001db2bcd;
var $ed7803e7c397b842$export$9563e054e6f787fb;
'use strict';

$ed7803e7c397b842$export$9cd59f9826255e47 = (parcelRequire("82ZEX"));

$ed7803e7c397b842$export$ee1b3e54f0441b22 = (parcelRequire("5sQ9X"));

$ed7803e7c397b842$export$7ecc1a3b11b57dab = (parcelRequire("cODa6"));

$ed7803e7c397b842$export$3dea766d36a8935f = (parcelRequire("lTbrG"));

$ed7803e7c397b842$export$4b80e395e36b5a56 = (parcelRequire("azdyr"));

$ed7803e7c397b842$export$305f7d4e9d4624f2 = (parcelRequire("fj51d"));

$ed7803e7c397b842$export$557cfb7ed375eeb7 = (parcelRequire("7abNV"));

$ed7803e7c397b842$export$871de8747c9eaa88 = (parcelRequire("ckctc"));

$ed7803e7c397b842$export$c44985b87d605eff = (parcelRequire("k0h73"));

$ed7803e7c397b842$export$533b26079ad0b4b = (parcelRequire("9ZFGa"));

$ed7803e7c397b842$export$7fef8bcdbb34f435 = (parcelRequire("a2oet"));

$ed7803e7c397b842$export$ad14ef4001db2bcd = (parcelRequire("lPGrY"));

$ed7803e7c397b842$export$9563e054e6f787fb = (parcelRequire("jLrkz"));

});
parcelRegister("82ZEX", function(module, exports) {
'use strict';
/**
 * # Clone Array
 *
 * Clone an array or array like object (e.g. `arguments`).
 * This is the equivalent of calling `Array.prototype.slice.call(arguments)`, but
 * significantly faster.
 *
 * @param  {Array} input The array or array-like object to clone.
 * @return {Array}       The cloned array.
 */ module.exports = function fastCloneArray(input) {
    var length = input.length, sliced = new Array(length), i;
    for(i = 0; i < length; i++)sliced[i] = input[i];
    return sliced;
};

});

parcelRegister("5sQ9X", function(module, exports) {
'use strict';
/**
 * # Concat
 *
 * Concatenate multiple arrays.
 *
 * > Note: This function is effectively identical to `Array.prototype.concat()`.
 *
 *
 * @param  {Array|mixed} item, ... The item(s) to concatenate.
 * @return {Array}                 The array containing the concatenated items.
 */ module.exports = function fastConcat() {
    var length = arguments.length, arr = [], i, item, childLength, j;
    for(i = 0; i < length; i++){
        item = arguments[i];
        if (Array.isArray(item)) {
            childLength = item.length;
            for(j = 0; j < childLength; j++)arr.push(item[j]);
        } else arr.push(item);
    }
    return arr;
};

});

parcelRegister("cODa6", function(module, exports) {
'use strict';

var $cPAnc = parcelRequire("cPAnc");
/**
 * # Every
 *
 * A fast `.every()` implementation.
 *
 * @param  {Array}    subject     The array (or array-like) to iterate over.
 * @param  {Function} fn          The visitor function.
 * @param  {Object}   thisContext The context for the visitor.
 * @return {Boolean}              true if all items in the array passes the truth test.
 */ module.exports = function fastEvery(subject, fn, thisContext) {
    var length = subject.length, iterator = thisContext !== undefined ? $cPAnc(fn, thisContext) : fn, i;
    for(i = 0; i < length; i++){
        if (!iterator(subject[i], i, subject)) return false;
    }
    return true;
};

});
parcelRegister("cPAnc", function(module, exports) {
'use strict';
/**
 * Internal helper to bind a function known to have 3 arguments
 * to a given context.
 */ module.exports = function bindInternal3(func, thisContext) {
    return function(a, b, c) {
        return func.call(thisContext, a, b, c);
    };
};

});


parcelRegister("lTbrG", function(module, exports) {
'use strict';

var $cPAnc = parcelRequire("cPAnc");
/**
 * # Filter
 *
 * A fast `.filter()` implementation.
 *
 * @param  {Array}    subject     The array (or array-like) to filter.
 * @param  {Function} fn          The filter function.
 * @param  {Object}   thisContext The context for the filter.
 * @return {Array}                The array containing the results.
 */ module.exports = function fastFilter(subject, fn, thisContext) {
    var length = subject.length, result = [], iterator = thisContext !== undefined ? $cPAnc(fn, thisContext) : fn, i;
    for(i = 0; i < length; i++)if (iterator(subject[i], i, subject)) result.push(subject[i]);
    return result;
};

});

parcelRegister("azdyr", function(module, exports) {
'use strict';

var $cPAnc = parcelRequire("cPAnc");
/**
 * # For Each
 *
 * A fast `.forEach()` implementation.
 *
 * @param  {Array}    subject     The array (or array-like) to iterate over.
 * @param  {Function} fn          The visitor function.
 * @param  {Object}   thisContext The context for the visitor.
 */ module.exports = function fastForEach(subject, fn, thisContext) {
    var length = subject.length, iterator = thisContext !== undefined ? $cPAnc(fn, thisContext) : fn, i;
    for(i = 0; i < length; i++)iterator(subject[i], i, subject);
};

});

parcelRegister("fj51d", function(module, exports) {
'use strict';
/**
 * # Index Of
 *
 * A faster `Array.prototype.indexOf()` implementation.
 *
 * @param  {Array}  subject   The array (or array-like) to search within.
 * @param  {mixed}  target    The target item to search for.
 * @param  {Number} fromIndex The position to start searching from, if known.
 * @return {Number}           The position of the target in the subject, or -1 if it does not exist.
 */ module.exports = function fastIndexOf(subject, target, fromIndex) {
    var length = subject.length, i = 0;
    if (typeof fromIndex === 'number') {
        i = fromIndex;
        if (i < 0) {
            i += length;
            if (i < 0) i = 0;
        }
    }
    for(; i < length; i++){
        if (subject[i] === target) return i;
    }
    return -1;
};

});

parcelRegister("7abNV", function(module, exports) {
'use strict';
/**
 * # Last Index Of
 *
 * A faster `Array.prototype.lastIndexOf()` implementation.
 *
 * @param  {Array}  subject The array (or array-like) to search within.
 * @param  {mixed}  target  The target item to search for.
 * @param  {Number} fromIndex The position to start searching backwards from, if known.
 * @return {Number}         The last position of the target in the subject, or -1 if it does not exist.
 */ module.exports = function fastLastIndexOf(subject, target, fromIndex) {
    var length = subject.length, i = length - 1;
    if (typeof fromIndex === 'number') {
        i = fromIndex;
        if (i < 0) i += length;
    }
    for(; i >= 0; i--){
        if (subject[i] === target) return i;
    }
    return -1;
};

});

parcelRegister("ckctc", function(module, exports) {
'use strict';

var $cPAnc = parcelRequire("cPAnc");
/**
 * # Map
 *
 * A fast `.map()` implementation.
 *
 * @param  {Array}    subject     The array (or array-like) to map over.
 * @param  {Function} fn          The mapper function.
 * @param  {Object}   thisContext The context for the mapper.
 * @return {Array}                The array containing the results.
 */ module.exports = function fastMap(subject, fn, thisContext) {
    var length = subject.length, result = new Array(length), iterator = thisContext !== undefined ? $cPAnc(fn, thisContext) : fn, i;
    for(i = 0; i < length; i++)result[i] = iterator(subject[i], i, subject);
    return result;
};

});

parcelRegister("k0h73", function(module, exports) {
'use strict';
/**
 * # Pluck
 * Pluck the property with the given name from an array of objects.
 *
 * @param  {Array}  input The values to pluck from.
 * @param  {String} field The name of the field to pluck.
 * @return {Array}        The plucked array of values.
 */ module.exports = function fastPluck(input, field) {
    var length = input.length, plucked = [], count = 0, value, i;
    for(i = 0; i < length; i++){
        value = input[i];
        if (value != null && value[field] !== undefined) plucked[count++] = value[field];
    }
    return plucked;
};

});

parcelRegister("9ZFGa", function(module, exports) {
'use strict';

var $kGuwb = parcelRequire("kGuwb");
/**
 * # Reduce
 *
 * A fast `.reduce()` implementation.
 *
 * @param  {Array}    subject      The array (or array-like) to reduce.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */ module.exports = function fastReduce(subject, fn, initialValue, thisContext) {
    var length = subject.length, iterator = thisContext !== undefined ? $kGuwb(fn, thisContext) : fn, i, result;
    if (initialValue === undefined) {
        i = 1;
        result = subject[0];
    } else {
        i = 0;
        result = initialValue;
    }
    for(; i < length; i++)result = iterator(result, subject[i], i, subject);
    return result;
};

});
parcelRegister("kGuwb", function(module, exports) {
'use strict';
/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */ module.exports = function bindInternal4(func, thisContext) {
    return function(a, b, c, d) {
        return func.call(thisContext, a, b, c, d);
    };
};

});


parcelRegister("a2oet", function(module, exports) {
'use strict';

var $kGuwb = parcelRequire("kGuwb");
/**
 * # Reduce Right
 *
 * A fast `.reduceRight()` implementation.
 *
 * @param  {Array}    subject      The array (or array-like) to reduce.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */ module.exports = function fastReduce(subject, fn, initialValue, thisContext) {
    var length = subject.length, iterator = thisContext !== undefined ? $kGuwb(fn, thisContext) : fn, i, result;
    if (initialValue === undefined) {
        i = length - 2;
        result = subject[length - 1];
    } else {
        i = length - 1;
        result = initialValue;
    }
    for(; i >= 0; i--)result = iterator(result, subject[i], i, subject);
    return result;
};

});

parcelRegister("lPGrY", function(module, exports) {
'use strict';

var $cPAnc = parcelRequire("cPAnc");
/**
 * # Some
 *
 * A fast `.some()` implementation.
 *
 * @param  {Array}    subject     The array (or array-like) to iterate over.
 * @param  {Function} fn          The visitor function.
 * @param  {Object}   thisContext The context for the visitor.
 * @return {Boolean}              true if at least one item in the array passes the truth test.
 */ module.exports = function fastSome(subject, fn, thisContext) {
    var length = subject.length, iterator = thisContext !== undefined ? $cPAnc(fn, thisContext) : fn, i;
    for(i = 0; i < length; i++){
        if (iterator(subject[i], i, subject)) return true;
    }
    return false;
};

});

parcelRegister("jLrkz", function(module, exports) {
'use strict';
/**
 * # Fill
 * Fill an array with values, optionally starting and stopping at a given index.
 *
 * > Note: unlike the specced Array.prototype.fill(), this version does not support
 * > negative start / end arguments.
 *
 * @param  {Array}   subject The array to fill.
 * @param  {mixed}   value   The value to insert.
 * @param  {Integer} start   The start position, defaults to 0.
 * @param  {Integer} end     The end position, defaults to subject.length
 * @return {Array}           The now filled subject.
 */ module.exports = function fastFill(subject, value, start, end) {
    var length = subject.length, i;
    if (start === undefined) start = 0;
    if (end === undefined) end = length;
    for(i = start; i < end; i++)subject[i] = value;
    return subject;
};

});


parcelRegister("fL17Y", function(module, exports) {

$parcel$export(module.exports, "apply", function () { return $b78c1ebb5840707d$export$5635d7ef4b8fee1c; }, function (v) { return $b78c1ebb5840707d$export$5635d7ef4b8fee1c = v; });
$parcel$export(module.exports, "bind", function () { return $b78c1ebb5840707d$export$2385a24977818dd0; }, function (v) { return $b78c1ebb5840707d$export$2385a24977818dd0 = v; });
$parcel$export(module.exports, "partial", function () { return $b78c1ebb5840707d$export$e45945969df8035a; }, function (v) { return $b78c1ebb5840707d$export$e45945969df8035a = v; });
$parcel$export(module.exports, "partialConstructor", function () { return $b78c1ebb5840707d$export$420aec02de1cba77; }, function (v) { return $b78c1ebb5840707d$export$420aec02de1cba77 = v; });
$parcel$export(module.exports, "try", function () { return $b78c1ebb5840707d$export$410a452afcd48948; }, function (v) { return $b78c1ebb5840707d$export$410a452afcd48948 = v; });
var $b78c1ebb5840707d$export$5635d7ef4b8fee1c;
var $b78c1ebb5840707d$export$2385a24977818dd0;
var $b78c1ebb5840707d$export$e45945969df8035a;
var $b78c1ebb5840707d$export$420aec02de1cba77;
var $b78c1ebb5840707d$export$410a452afcd48948;
'use strict';

$b78c1ebb5840707d$export$5635d7ef4b8fee1c = (parcelRequire("6cBGD"));

$b78c1ebb5840707d$export$2385a24977818dd0 = (parcelRequire("bwUhn"));

$b78c1ebb5840707d$export$e45945969df8035a = (parcelRequire("hsyTz"));

$b78c1ebb5840707d$export$420aec02de1cba77 = (parcelRequire("jUgYq"));

$b78c1ebb5840707d$export$410a452afcd48948 = (parcelRequire("4ujTU"));

});
parcelRegister("6cBGD", function(module, exports) {
'use strict';

var $izNYf = parcelRequire("izNYf");

var $aomPz = parcelRequire("aomPz");
/**
 * # Apply
 *
 * Faster version of `Function::apply()`, optimised for 8 arguments or fewer.
 *
 *
 * @param  {Function} subject   The function to apply.
 * @param  {Object} thisContext The context for the function, set to undefined or null if no context is required.
 * @param  {Array} args         The arguments for the function.
 * @return {mixed}              The result of the function invocation.
 */ module.exports = function fastApply(subject, thisContext, args) {
    return thisContext !== undefined ? $izNYf(subject, thisContext, args) : $aomPz(subject, args);
};

});
parcelRegister("izNYf", function(module, exports) {
'use strict';
/**
 * Internal helper for applying a function with a context.
 */ module.exports = function applyWithContext(subject, thisContext, args) {
    switch(args.length){
        case 0:
            return subject.call(thisContext);
        case 1:
            return subject.call(thisContext, args[0]);
        case 2:
            return subject.call(thisContext, args[0], args[1]);
        case 3:
            return subject.call(thisContext, args[0], args[1], args[2]);
        case 4:
            return subject.call(thisContext, args[0], args[1], args[2], args[3]);
        case 5:
            return subject.call(thisContext, args[0], args[1], args[2], args[3], args[4]);
        case 6:
            return subject.call(thisContext, args[0], args[1], args[2], args[3], args[4], args[5]);
        case 7:
            return subject.call(thisContext, args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        case 8:
            return subject.call(thisContext, args[0], args[1], args[2], args[3], args[4], args[5], args[6], args[7]);
        default:
            return subject.apply(thisContext, args);
    }
};

});

parcelRegister("aomPz", function(module, exports) {
'use strict';
/**
 * Internal helper for applying a function without a context.
 */ module.exports = function applyNoContext(subject, args) {
    switch(args.length){
        case 0:
            return subject();
        case 1:
            return subject(args[0]);
        case 2:
            return subject(args[0], args[1]);
        case 3:
            return subject(args[0], args[1], args[2]);
        case 4:
            return subject(args[0], args[1], args[2], args[3]);
        case 5:
            return subject(args[0], args[1], args[2], args[3], args[4]);
        case 6:
            return subject(args[0], args[1], args[2], args[3], args[4], args[5]);
        case 7:
            return subject(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        case 8:
            return subject(args[0], args[1], args[2], args[3], args[4], args[5], args[6], args[7]);
        default:
            return subject.apply(undefined, args);
    }
};

});


parcelRegister("bwUhn", function(module, exports) {
'use strict';

var $izNYf = parcelRequire("izNYf");

var $aomPz = parcelRequire("aomPz");
/**
 * # Bind
 * Analogue of `Function::bind()`.
 *
 * ```js
 * var bind = require('fast.js').bind;
 * var bound = bind(myfunc, this, 1, 2, 3);
 *
 * bound(4);
 * ```
 *
 *
 * @param  {Function} fn          The function which should be bound.
 * @param  {Object}   thisContext The context to bind the function to.
 * @param  {mixed}    args, ...   Additional arguments to pre-bind.
 * @return {Function}             The bound function.
 */ module.exports = function fastBind(fn, thisContext) {
    var boundLength = arguments.length - 2, boundArgs;
    if (boundLength > 0) {
        boundArgs = new Array(boundLength);
        for(var i = 0; i < boundLength; i++)boundArgs[i] = arguments[i + 2];
        if (thisContext !== undefined) return function() {
            var length = arguments.length, args = new Array(boundLength + length), i;
            for(i = 0; i < boundLength; i++)args[i] = boundArgs[i];
            for(i = 0; i < length; i++)args[boundLength + i] = arguments[i];
            return $izNYf(fn, thisContext, args);
        };
        else return function() {
            var length = arguments.length, args = new Array(boundLength + length), i;
            for(i = 0; i < boundLength; i++)args[i] = boundArgs[i];
            for(i = 0; i < length; i++)args[boundLength + i] = arguments[i];
            return $aomPz(fn, args);
        };
    }
    if (thisContext !== undefined) return function() {
        return $izNYf(fn, thisContext, arguments);
    };
    else return function() {
        return $aomPz(fn, arguments);
    };
};

});

parcelRegister("hsyTz", function(module, exports) {
'use strict';

var $izNYf = parcelRequire("izNYf");
/**
 * # Partial Application
 *
 * Partially apply a function. This is similar to `.bind()`,
 * but with one important difference - the returned function is not bound
 * to a particular context. This makes it easy to add partially
 * applied methods to objects. If you need to bind to a context,
 * use `.bind()` instead.
 *
 * > Note: This function does not support partial application for
 * constructors, for that see `partialConstructor()`
 *
 *
 * @param  {Function} fn          The function to partially apply.
 * @param  {mixed}    args, ...   Arguments to pre-bind.
 * @return {Function}             The partially applied function.
 */ module.exports = function fastPartial(fn) {
    var boundLength = arguments.length - 1, boundArgs;
    boundArgs = new Array(boundLength);
    for(var i = 0; i < boundLength; i++)boundArgs[i] = arguments[i + 1];
    return function() {
        var length = arguments.length, args = new Array(boundLength + length), i;
        for(i = 0; i < boundLength; i++)args[i] = boundArgs[i];
        for(i = 0; i < length; i++)args[boundLength + i] = arguments[i];
        return $izNYf(fn, this, args);
    };
};

});

parcelRegister("jUgYq", function(module, exports) {
'use strict';

var $izNYf = parcelRequire("izNYf");
/**
 * # Partial Constructor
 *
 * Partially apply a constructor function. The returned function
 * will work with or without the `new` keyword.
 *
 *
 * @param  {Function} fn          The constructor function to partially apply.
 * @param  {mixed}    args, ...   Arguments to pre-bind.
 * @return {Function}             The partially applied constructor.
 */ module.exports = function fastPartialConstructor(fn) {
    var boundLength = arguments.length - 1, boundArgs;
    boundArgs = new Array(boundLength);
    for(var i = 0; i < boundLength; i++)boundArgs[i] = arguments[i + 1];
    return function partialed() {
        var length = arguments.length, args = new Array(boundLength + length), i;
        for(i = 0; i < boundLength; i++)args[i] = boundArgs[i];
        for(i = 0; i < length; i++)args[boundLength + i] = arguments[i];
        var thisContext = Object.create(fn.prototype), result = $izNYf(fn, thisContext, args);
        if (result != null && (typeof result === 'object' || typeof result === 'function')) return result;
        else return thisContext;
    };
};

});

parcelRegister("4ujTU", function(module, exports) {
'use strict';
/**
 * # Try
 *
 * Allows functions to be optimised by isolating `try {} catch (e) {}` blocks
 * outside the function declaration. Returns either the result of the function or an Error
 * object if one was thrown. The caller should then check for `result instanceof Error`.
 *
 * ```js
 * var result = fast.try(myFunction);
 * if (result instanceof Error) {
 *    console.log('something went wrong');
 * }
 * else {
 *   console.log('result:', result);
 * }
 * ```
 *
 * @param  {Function} fn The function to invoke.
 * @return {mixed}       The result of the function, or an `Error` object.
 */ module.exports = function fastTry(fn) {
    try {
        return fn();
    } catch (e) {
        if (!(e instanceof Error)) return new Error(e);
        else return e;
    }
};

});


parcelRegister("b47bx", function(module, exports) {

$parcel$export(module.exports, "assign", function () { return $80e5a438e00d8464$export$e6e34fd1f2686227; }, function (v) { return $80e5a438e00d8464$export$e6e34fd1f2686227 = v; });
$parcel$export(module.exports, "clone", function () { return $80e5a438e00d8464$export$9cd59f9826255e47; }, function (v) { return $80e5a438e00d8464$export$9cd59f9826255e47 = v; });
$parcel$export(module.exports, "filter", function () { return $80e5a438e00d8464$export$3dea766d36a8935f; }, function (v) { return $80e5a438e00d8464$export$3dea766d36a8935f = v; });
$parcel$export(module.exports, "forEach", function () { return $80e5a438e00d8464$export$4b80e395e36b5a56; }, function (v) { return $80e5a438e00d8464$export$4b80e395e36b5a56 = v; });
$parcel$export(module.exports, "map", function () { return $80e5a438e00d8464$export$871de8747c9eaa88; }, function (v) { return $80e5a438e00d8464$export$871de8747c9eaa88 = v; });
$parcel$export(module.exports, "reduce", function () { return $80e5a438e00d8464$export$533b26079ad0b4b; }, function (v) { return $80e5a438e00d8464$export$533b26079ad0b4b = v; });
$parcel$export(module.exports, "reduceRight", function () { return $80e5a438e00d8464$export$7fef8bcdbb34f435; }, function (v) { return $80e5a438e00d8464$export$7fef8bcdbb34f435 = v; });
$parcel$export(module.exports, "keys", function () { return $80e5a438e00d8464$export$ed97f33186d4b816; }, function (v) { return $80e5a438e00d8464$export$ed97f33186d4b816 = v; });
$parcel$export(module.exports, "values", function () { return $80e5a438e00d8464$export$68c286be0e7e55b7; }, function (v) { return $80e5a438e00d8464$export$68c286be0e7e55b7 = v; });
var $80e5a438e00d8464$export$e6e34fd1f2686227;
var $80e5a438e00d8464$export$9cd59f9826255e47;
var $80e5a438e00d8464$export$3dea766d36a8935f;
var $80e5a438e00d8464$export$4b80e395e36b5a56;
var $80e5a438e00d8464$export$871de8747c9eaa88;
var $80e5a438e00d8464$export$533b26079ad0b4b;
var $80e5a438e00d8464$export$7fef8bcdbb34f435;
var $80e5a438e00d8464$export$ed97f33186d4b816;
var $80e5a438e00d8464$export$68c286be0e7e55b7;
'use strict';

$80e5a438e00d8464$export$e6e34fd1f2686227 = (parcelRequire("9qTfd"));

$80e5a438e00d8464$export$9cd59f9826255e47 = (parcelRequire("8YU6G"));

$80e5a438e00d8464$export$3dea766d36a8935f = (parcelRequire("8uetW"));

$80e5a438e00d8464$export$4b80e395e36b5a56 = (parcelRequire("k0YmB"));

$80e5a438e00d8464$export$871de8747c9eaa88 = (parcelRequire("4Pw2S"));

$80e5a438e00d8464$export$533b26079ad0b4b = (parcelRequire("3rpDs"));

$80e5a438e00d8464$export$7fef8bcdbb34f435 = (parcelRequire("2Z9tq"));

$80e5a438e00d8464$export$ed97f33186d4b816 = (parcelRequire("35o5q"));

$80e5a438e00d8464$export$68c286be0e7e55b7 = (parcelRequire("8ecPL"));

});
parcelRegister("9qTfd", function(module, exports) {
'use strict';
/**
 * Analogue of Object.assign().
 * Copies properties from one or more source objects to
 * a target object. Existing keys on the target object will be overwritten.
 *
 * > Note: This differs from spec in some important ways:
 * > 1. Will throw if passed non-objects, including `undefined` or `null` values.
 * > 2. Does not support the curious Exception handling behavior, exceptions are thrown immediately.
 * > For more details, see:
 * > https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 *
 *
 *
 * @param  {Object} target      The target object to copy properties to.
 * @param  {Object} source, ... The source(s) to copy properties from.
 * @return {Object}             The updated target object.
 */ module.exports = function fastAssign(target) {
    var totalArgs = arguments.length, source, i, totalKeys, keys, key, j;
    for(i = 1; i < totalArgs; i++){
        source = arguments[i];
        keys = Object.keys(source);
        totalKeys = keys.length;
        for(j = 0; j < totalKeys; j++){
            key = keys[j];
            target[key] = source[key];
        }
    }
    return target;
};

});

parcelRegister("8YU6G", function(module, exports) {
'use strict';
/**
 * # Clone Object
 *
 * Shallow clone a simple object.
 *
 * > Note: Prototypes and non-enumerable properties will not be copied!
 *
 * @param  {Object} input The object to clone.
 * @return {Object}       The cloned object.
 */ module.exports = function fastCloneObject(input) {
    var keys = Object.keys(input), total = keys.length, cloned = {}, i, key;
    for(i = 0; i < total; i++){
        key = keys[i];
        cloned[key] = input[key];
    }
    return cloned;
};

});

parcelRegister("8uetW", function(module, exports) {
'use strict';

var $cPAnc = parcelRequire("cPAnc");
/**
 * # Filter
 *
 * A fast object `.filter()` implementation.
 *
 * @param  {Object}   subject     The object to filter.
 * @param  {Function} fn          The filter function.
 * @param  {Object}   thisContext The context for the filter.
 * @return {Object}               The new object containing the filtered results.
 */ module.exports = function fastFilterObject(subject, fn, thisContext) {
    var keys = Object.keys(subject), length = keys.length, result = {}, iterator = thisContext !== undefined ? $cPAnc(fn, thisContext) : fn, i, key;
    for(i = 0; i < length; i++){
        key = keys[i];
        if (iterator(subject[key], key, subject)) result[key] = subject[key];
    }
    return result;
};

});

parcelRegister("k0YmB", function(module, exports) {
'use strict';

var $cPAnc = parcelRequire("cPAnc");
/**
 * # For Each
 *
 * A fast object `.forEach()` implementation.
 *
 * @param  {Object}   subject     The object to iterate over.
 * @param  {Function} fn          The visitor function.
 * @param  {Object}   thisContext The context for the visitor.
 */ module.exports = function fastForEachObject(subject, fn, thisContext) {
    var keys = Object.keys(subject), length = keys.length, iterator = thisContext !== undefined ? $cPAnc(fn, thisContext) : fn, key, i;
    for(i = 0; i < length; i++){
        key = keys[i];
        iterator(subject[key], key, subject);
    }
};

});

parcelRegister("4Pw2S", function(module, exports) {
'use strict';

var $cPAnc = parcelRequire("cPAnc");
/**
 * # Map
 *
 * A fast object `.map()` implementation.
 *
 * @param  {Object}   subject     The object to map over.
 * @param  {Function} fn          The mapper function.
 * @param  {Object}   thisContext The context for the mapper.
 * @return {Object}               The new object containing the results.
 */ module.exports = function fastMapObject(subject, fn, thisContext) {
    var keys = Object.keys(subject), length = keys.length, result = {}, iterator = thisContext !== undefined ? $cPAnc(fn, thisContext) : fn, i, key;
    for(i = 0; i < length; i++){
        key = keys[i];
        result[key] = iterator(subject[key], key, subject);
    }
    return result;
};

});

parcelRegister("3rpDs", function(module, exports) {
'use strict';

var $kGuwb = parcelRequire("kGuwb");
/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */ module.exports = function fastReduceObject(subject, fn, initialValue, thisContext) {
    var keys = Object.keys(subject), length = keys.length, iterator = thisContext !== undefined ? $kGuwb(fn, thisContext) : fn, i, key, result;
    if (initialValue === undefined) {
        i = 1;
        result = subject[keys[0]];
    } else {
        i = 0;
        result = initialValue;
    }
    for(; i < length; i++){
        key = keys[i];
        result = iterator(result, subject[key], key, subject);
    }
    return result;
};

});

parcelRegister("2Z9tq", function(module, exports) {
'use strict';

var $kGuwb = parcelRequire("kGuwb");
/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */ module.exports = function fastReduceRightObject(subject, fn, initialValue, thisContext) {
    var keys = Object.keys(subject), length = keys.length, iterator = thisContext !== undefined ? $kGuwb(fn, thisContext) : fn, i, key, result;
    if (initialValue === undefined) {
        i = length - 2;
        result = subject[keys[length - 1]];
    } else {
        i = length - 1;
        result = initialValue;
    }
    for(; i >= 0; i--){
        key = keys[i];
        result = iterator(result, subject[key], key, subject);
    }
    return result;
};

});

parcelRegister("35o5q", function(module, exports) {
'use strict';
/**
 * Object.keys() shim for ES3 environments.
 *
 * @param  {Object} obj The object to get keys for.
 * @return {Array}      The array of keys.
 */ module.exports = typeof Object.keys === "function" ? Object.keys : /* istanbul ignore next */ function fastKeys(obj) {
    var keys = [];
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) keys.push(key);
    return keys;
};

});

parcelRegister("8ecPL", function(module, exports) {
'use strict';
/**
 * # Values
 * Return all the (enumerable) property values for an object.
 * Like Object.keys() but for values.
 *
 * @param  {Object} obj The object to retrieve values from.
 * @return {Array}      An array containing property values.
 */ module.exports = function fastValues(obj) {
    var keys = Object.keys(obj), length = keys.length, values = new Array(length);
    for(var i = 0; i < length; i++)values[i] = obj[keys[i]];
    return values;
};

});


parcelRegister("5hjIi", function(module, exports) {

$parcel$export(module.exports, "intern", function () { return $3d7dd4f464ea3c4a$export$a84e3dcfe8ceeb7f; }, function (v) { return $3d7dd4f464ea3c4a$export$a84e3dcfe8ceeb7f = v; });
var $3d7dd4f464ea3c4a$export$a84e3dcfe8ceeb7f;
'use strict';

$3d7dd4f464ea3c4a$export$a84e3dcfe8ceeb7f = (parcelRequire("bliqM"));

});
parcelRegister("bliqM", function(module, exports) {
'use strict';
// Compilers such as V8 use string interning to make string comparison very fast and efficient,
// as efficient as comparing two references to the same object.
//
//
// V8 does its best to intern strings automatically where it can, for instance:
// ```js
//   var greeting = "hello world";
// ```
// With this, comparison will be very fast:
// ```js
//   if (greeting === "hello world") {}
// ```
// However, there are several cases where V8 cannot intern the string, and instead
// must resort to byte-wise comparison. This can be signficantly slower for long strings.
// The most common example is string concatenation:
// ```js
//   function subject () { return "world"; };
//   var greeting = "hello " + subject();
// ```
// In this case, V8 cannot intern the string. So this comparison is *much* slower:
// ```js
//  if (greeting === "hello world") {}
// ```
// At the moment, the fastest, safe way of interning a string is to
// use it as a key in an object, and then use that key.
//
// Note: This technique comes courtesy of Petka Antonov - http://jsperf.com/istrn/11
//
// We create a container object in hash mode.
// Most strings being interned will not be valid fast property names,
// so we ensure hash mode now to avoid transitioning the object mode at runtime.
var $841ff3e52cc5a5b3$var$container = {
    '- ': true
};
delete $841ff3e52cc5a5b3$var$container['- '];
/**
 * Intern a string to make comparisons faster.
 *
 * > Note: This is a relatively expensive operation, you
 * shouldn't usually do the actual interning at runtime, instead
 * use this at compile time to make future work faster.
 *
 * @param  {String} string The string to intern.
 * @return {String}        The interned string.
 */ module.exports = function fastIntern(string) {
    $841ff3e52cc5a5b3$var$container[string] = true;
    var interned = Object.keys($841ff3e52cc5a5b3$var$container)[0];
    delete $841ff3e52cc5a5b3$var$container[interned];
    return interned;
};

});


parcelRegister("RAfgy", function(module, exports) {
'use strict';

var $82ZEX = parcelRequire("82ZEX");

var $8YU6G = parcelRequire("8YU6G");
/**
 * # Clone
 *
 * Clone an item. Primitive values will be returned directly,
 * arrays and objects will be shallow cloned. If you know the
 * type of input you're dealing with, call `.cloneArray()` or `.cloneObject()`
 * instead.
 *
 * @param  {mixed} input The input to clone.
 * @return {mixed}       The cloned input.
 */ module.exports = function clone(input) {
    if (!input || typeof input !== 'object') return input;
    else if (Array.isArray(input)) return $82ZEX(input);
    else return $8YU6G(input);
};

});

parcelRegister("lAv3U", function(module, exports) {
'use strict';

var $ckctc = parcelRequire("ckctc");

var $4Pw2S = parcelRequire("4Pw2S");
/**
 * # Map
 *
 * A fast `.map()` implementation.
 *
 * @param  {Array|Object} subject     The array or object to map over.
 * @param  {Function}     fn          The mapper function.
 * @param  {Object}       thisContext The context for the mapper.
 * @return {Array|Object}             The array or object containing the results.
 */ module.exports = function fastMap(subject, fn, thisContext) {
    if (subject instanceof Array) return $ckctc(subject, fn, thisContext);
    else return $4Pw2S(subject, fn, thisContext);
};

});

parcelRegister("2kxQm", function(module, exports) {
'use strict';

var $lTbrG = parcelRequire("lTbrG");

var $8uetW = parcelRequire("8uetW");
/**
 * # Filter
 *
 * A fast `.filter()` implementation.
 *
 * @param  {Array|Object} subject     The array or object to filter.
 * @param  {Function}     fn          The filter function.
 * @param  {Object}       thisContext The context for the filter.
 * @return {Array|Object}             The array or object containing the filtered results.
 */ module.exports = function fastFilter(subject, fn, thisContext) {
    if (subject instanceof Array) return $lTbrG(subject, fn, thisContext);
    else return $8uetW(subject, fn, thisContext);
};

});

parcelRegister("aWRjO", function(module, exports) {
'use strict';

var $azdyr = parcelRequire("azdyr");

var $k0YmB = parcelRequire("k0YmB");
/**
 * # ForEach
 *
 * A fast `.forEach()` implementation.
 *
 * @param  {Array|Object} subject     The array or object to iterate over.
 * @param  {Function}     fn          The visitor function.
 * @param  {Object}       thisContext The context for the visitor.
 */ module.exports = function fastForEach(subject, fn, thisContext) {
    if (subject instanceof Array) return $azdyr(subject, fn, thisContext);
    else return $k0YmB(subject, fn, thisContext);
};

});

parcelRegister("2q5xW", function(module, exports) {
'use strict';

var $9ZFGa = parcelRequire("9ZFGa");

var $3rpDs = parcelRequire("3rpDs");
/**
 * # Reduce
 *
 * A fast `.reduce()` implementation.
 *
 * @param  {Array|Object} subject      The array or object to reduce over.
 * @param  {Function}     fn           The reducer function.
 * @param  {mixed}        initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}       thisContext  The context for the reducer.
 * @return {Array|Object}              The array or object containing the results.
 */ module.exports = function fastReduce(subject, fn, initialValue, thisContext) {
    if (subject instanceof Array) return $9ZFGa(subject, fn, initialValue, thisContext);
    else return $3rpDs(subject, fn, initialValue, thisContext);
};

});

parcelRegister("MPvsw", function(module, exports) {
'use strict';

var $a2oet = parcelRequire("a2oet");

var $2Z9tq = parcelRequire("2Z9tq");
/**
 * # Reduce Right
 *
 * A fast `.reduceRight()` implementation.
 *
 * @param  {Array|Object} subject      The array or object to reduce over.
 * @param  {Function}     fn           The reducer function.
 * @param  {mixed}        initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}       thisContext  The context for the reducer.
 * @return {Array|Object}              The array or object containing the results.
 */ module.exports = function fastReduceRight(subject, fn, initialValue, thisContext) {
    if (subject instanceof Array) return $a2oet(subject, fn, initialValue, thisContext);
    else return $2Z9tq(subject, fn, initialValue, thisContext);
};

});


parcelRegister("gO4UB", function(module, exports) {
/*! bignumber.js v4.1.0 https://github.com/MikeMcl/bignumber.js/LICENCE */ (function(globalObj) {
    'use strict';
    /*
      bignumber.js v4.1.0
      A JavaScript library for arbitrary-precision arithmetic.
      https://github.com/MikeMcl/bignumber.js
      Copyright (c) 2017 Michael Mclaughlin <M8ch88l@gmail.com>
      MIT Expat Licence
    */ var BigNumber, isNumeric = /^-?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, mathceil = Math.ceil, mathfloor = Math.floor, notBool = ' not a boolean or binary digit', roundingMode = 'rounding mode', tooManyDigits = 'number type has more than 15 significant digits', ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_', BASE = 1e14, LOG_BASE = 14, MAX_SAFE_INTEGER = 0x1fffffffffffff, // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
    POWS_TEN = [
        1,
        10,
        100,
        1e3,
        1e4,
        1e5,
        1e6,
        1e7,
        1e8,
        1e9,
        1e10,
        1e11,
        1e12,
        1e13
    ], SQRT_BASE = 1e7, /*
         * The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
         * the arguments to toExponential, toFixed, toFormat, and toPrecision, beyond which an
         * exception is thrown (if ERRORS is true).
         */ MAX = 1E9; // 0 to MAX_INT32
    /*
     * Create and return a BigNumber constructor.
     */ function constructorFactory(config) {
        var div, parseNumeric, // id tracks the caller function, so its name can be included in error messages.
        id = 0, P = BigNumber.prototype, ONE = new BigNumber(1), /********************************* EDITABLE DEFAULTS **********************************/ /*
             * The default values below must be integers within the inclusive ranges stated.
             * The values can also be changed at run-time using BigNumber.config.
             */ // The maximum number of decimal places for operations involving division.
        DECIMAL_PLACES = 20, /*
             * The rounding mode used when rounding to the above decimal places, and when using
             * toExponential, toFixed, toFormat and toPrecision, and round (default value).
             * UP         0 Away from zero.
             * DOWN       1 Towards zero.
             * CEIL       2 Towards +Infinity.
             * FLOOR      3 Towards -Infinity.
             * HALF_UP    4 Towards nearest neighbour. If equidistant, up.
             * HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
             * HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
             * HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
             * HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
             */ ROUNDING_MODE = 4, // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]
        // The exponent value at and beneath which toString returns exponential notation.
        // Number type: -7
        TO_EXP_NEG = -7, // The exponent value at and above which toString returns exponential notation.
        // Number type: 21
        TO_EXP_POS = 21, // RANGE : [MIN_EXP, MAX_EXP]
        // The minimum exponent value, beneath which underflow to zero occurs.
        // Number type: -324  (5e-324)
        MIN_EXP = -10000000, // The maximum exponent value, above which overflow to Infinity occurs.
        // Number type:  308  (1.7976931348623157e+308)
        // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
        MAX_EXP = 1e7, // Whether BigNumber Errors are ever thrown.
        ERRORS = true, // Change to intValidatorNoErrors if ERRORS is false.
        isValidInt = intValidatorWithErrors, // Whether to use cryptographically-secure random number generation, if available.
        CRYPTO = false, /*
             * The modulo mode used when calculating the modulus: a mod n.
             * The quotient (q = a / n) is calculated according to the corresponding rounding mode.
             * The remainder (r) is calculated as: r = a - n * q.
             *
             * UP        0 The remainder is positive if the dividend is negative, else is negative.
             * DOWN      1 The remainder has the same sign as the dividend.
             *             This modulo mode is commonly known as 'truncated division' and is
             *             equivalent to (a % n) in JavaScript.
             * FLOOR     3 The remainder has the same sign as the divisor (Python %).
             * HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
             * EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
             *             The remainder is always positive.
             *
             * The truncated division, floored division, Euclidian division and IEEE 754 remainder
             * modes are commonly used for the modulus operation.
             * Although the other rounding modes can also be used, they may not give useful results.
             */ MODULO_MODE = 1, // The maximum number of significant digits of the result of the toPower operation.
        // If POW_PRECISION is 0, there will be unlimited significant digits.
        POW_PRECISION = 0, // The format specification used by the BigNumber.prototype.toFormat method.
        FORMAT = {
            decimalSeparator: '.',
            groupSeparator: ',',
            groupSize: 3,
            secondaryGroupSize: 0,
            fractionGroupSeparator: '\xA0',
            fractionGroupSize: 0
        };
        /******************************************************************************************/ // CONSTRUCTOR
        /*
         * The BigNumber constructor and exported function.
         * Create and return a new instance of a BigNumber object.
         *
         * n {number|string|BigNumber} A numeric value.
         * [b] {number} The base of n. Integer, 2 to 64 inclusive.
         */ function BigNumber(n, b) {
            var c, e, i, num, len, str, x = this;
            // Enable constructor usage without new.
            if (!(x instanceof BigNumber)) {
                // 'BigNumber() constructor call without new: {n}'
                if (ERRORS) raise(26, 'constructor call without new', n);
                return new BigNumber(n, b);
            }
            // 'new BigNumber() base not an integer: {b}'
            // 'new BigNumber() base out of range: {b}'
            if (b == null || !isValidInt(b, 2, 64, id, 'base')) {
                // Duplicate.
                if (n instanceof BigNumber) {
                    x.s = n.s;
                    x.e = n.e;
                    x.c = (n = n.c) ? n.slice() : n;
                    id = 0;
                    return;
                }
                if ((num = typeof n == 'number') && n * 0 == 0) {
                    x.s = 1 / n < 0 ? (n = -n, -1) : 1;
                    // Fast path for integers.
                    if (n === ~~n) {
                        for(e = 0, i = n; i >= 10; i /= 10, e++);
                        x.e = e;
                        x.c = [
                            n
                        ];
                        id = 0;
                        return;
                    }
                    str = n + '';
                } else {
                    if (!isNumeric.test(str = n + '')) return parseNumeric(x, str, num);
                    x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
                }
            } else {
                b = b | 0;
                str = n + '';
                // Ensure return value is rounded to DECIMAL_PLACES as with other bases.
                // Allow exponential notation to be used with base 10 argument.
                if (b == 10) {
                    x = new BigNumber(n instanceof BigNumber ? n : str);
                    return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
                }
                // Avoid potential interpretation of Infinity and NaN as base 44+ values.
                // Any number in exponential form will fail due to the [Ee][+-].
                if ((num = typeof n == 'number') && n * 0 != 0 || !new RegExp('^-?' + (c = '[' + ALPHABET.slice(0, b) + ']+') + '(?:\\.' + c + ')?$', b < 37 ? 'i' : '').test(str)) return parseNumeric(x, str, num, b);
                if (num) {
                    x.s = 1 / n < 0 ? (str = str.slice(1), -1) : 1;
                    if (ERRORS && str.replace(/^0\.0*|\./, '').length > 15) // 'new BigNumber() number type has more than 15 significant digits: {n}'
                    raise(id, tooManyDigits, n);
                    // Prevent later check for length on converted number.
                    num = false;
                } else x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
                str = convertBase(str, 10, b, x.s);
            }
            // Decimal point?
            if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
            // Exponential form?
            if ((i = str.search(/e/i)) > 0) {
                // Determine exponent.
                if (e < 0) e = i;
                e += +str.slice(i + 1);
                str = str.substring(0, i);
            } else if (e < 0) // Integer.
            e = str.length;
            // Determine leading zeros.
            for(i = 0; str.charCodeAt(i) === 48; i++);
            // Determine trailing zeros.
            for(len = str.length; str.charCodeAt(--len) === 48;);
            str = str.slice(i, len + 1);
            if (str) {
                len = str.length;
                // Disallow numbers with over 15 significant digits if number type.
                // 'new BigNumber() number type has more than 15 significant digits: {n}'
                if (num && ERRORS && len > 15 && (n > MAX_SAFE_INTEGER || n !== mathfloor(n))) raise(id, tooManyDigits, x.s * n);
                e = e - i - 1;
                // Overflow?
                if (e > MAX_EXP) // Infinity.
                x.c = x.e = null;
                else if (e < MIN_EXP) // Zero.
                x.c = [
                    x.e = 0
                ];
                else {
                    x.e = e;
                    x.c = [];
                    // Transform base
                    // e is the base 10 exponent.
                    // i is where to slice str to get the first element of the coefficient array.
                    i = (e + 1) % LOG_BASE;
                    if (e < 0) i += LOG_BASE;
                    if (i < len) {
                        if (i) x.c.push(+str.slice(0, i));
                        for(len -= LOG_BASE; i < len;)x.c.push(+str.slice(i, i += LOG_BASE));
                        str = str.slice(i);
                        i = LOG_BASE - str.length;
                    } else i -= len;
                    for(; i--; str += '0');
                    x.c.push(+str);
                }
            } else // Zero.
            x.c = [
                x.e = 0
            ];
            id = 0;
        }
        // CONSTRUCTOR PROPERTIES
        BigNumber.another = constructorFactory;
        BigNumber.ROUND_UP = 0;
        BigNumber.ROUND_DOWN = 1;
        BigNumber.ROUND_CEIL = 2;
        BigNumber.ROUND_FLOOR = 3;
        BigNumber.ROUND_HALF_UP = 4;
        BigNumber.ROUND_HALF_DOWN = 5;
        BigNumber.ROUND_HALF_EVEN = 6;
        BigNumber.ROUND_HALF_CEIL = 7;
        BigNumber.ROUND_HALF_FLOOR = 8;
        BigNumber.EUCLID = 9;
        /*
         * Configure infrequently-changing library-wide settings.
         *
         * Accept an object or an argument list, with one or many of the following properties or
         * parameters respectively:
         *
         *   DECIMAL_PLACES  {number}  Integer, 0 to MAX inclusive
         *   ROUNDING_MODE   {number}  Integer, 0 to 8 inclusive
         *   EXPONENTIAL_AT  {number|number[]}  Integer, -MAX to MAX inclusive or
         *                                      [integer -MAX to 0 incl., 0 to MAX incl.]
         *   RANGE           {number|number[]}  Non-zero integer, -MAX to MAX inclusive or
         *                                      [integer -MAX to -1 incl., integer 1 to MAX incl.]
         *   ERRORS          {boolean|number}   true, false, 1 or 0
         *   CRYPTO          {boolean|number}   true, false, 1 or 0
         *   MODULO_MODE     {number}           0 to 9 inclusive
         *   POW_PRECISION   {number}           0 to MAX inclusive
         *   FORMAT          {object}           See BigNumber.prototype.toFormat
         *      decimalSeparator       {string}
         *      groupSeparator         {string}
         *      groupSize              {number}
         *      secondaryGroupSize     {number}
         *      fractionGroupSeparator {string}
         *      fractionGroupSize      {number}
         *
         * (The values assigned to the above FORMAT object properties are not checked for validity.)
         *
         * E.g.
         * BigNumber.config(20, 4) is equivalent to
         * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
         *
         * Ignore properties/parameters set to null or undefined.
         * Return an object with the properties current values.
         */ BigNumber.config = BigNumber.set = function() {
            var v, p, i = 0, r = {}, a = arguments, o = a[0], has = o && typeof o == 'object' ? function() {
                if (o.hasOwnProperty(p)) return (v = o[p]) != null;
            } : function() {
                if (a.length > i) return (v = a[i++]) != null;
            };
            // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
            // 'config() DECIMAL_PLACES not an integer: {v}'
            // 'config() DECIMAL_PLACES out of range: {v}'
            if (has(p = 'DECIMAL_PLACES') && isValidInt(v, 0, MAX, 2, p)) DECIMAL_PLACES = v | 0;
            r[p] = DECIMAL_PLACES;
            // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
            // 'config() ROUNDING_MODE not an integer: {v}'
            // 'config() ROUNDING_MODE out of range: {v}'
            if (has(p = 'ROUNDING_MODE') && isValidInt(v, 0, 8, 2, p)) ROUNDING_MODE = v | 0;
            r[p] = ROUNDING_MODE;
            // EXPONENTIAL_AT {number|number[]}
            // Integer, -MAX to MAX inclusive or [integer -MAX to 0 inclusive, 0 to MAX inclusive].
            // 'config() EXPONENTIAL_AT not an integer: {v}'
            // 'config() EXPONENTIAL_AT out of range: {v}'
            if (has(p = 'EXPONENTIAL_AT')) {
                if (isArray(v)) {
                    if (isValidInt(v[0], -MAX, 0, 2, p) && isValidInt(v[1], 0, MAX, 2, p)) {
                        TO_EXP_NEG = v[0] | 0;
                        TO_EXP_POS = v[1] | 0;
                    }
                } else if (isValidInt(v, -MAX, MAX, 2, p)) TO_EXP_NEG = -(TO_EXP_POS = (v < 0 ? -v : v) | 0);
            }
            r[p] = [
                TO_EXP_NEG,
                TO_EXP_POS
            ];
            // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
            // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
            // 'config() RANGE not an integer: {v}'
            // 'config() RANGE cannot be zero: {v}'
            // 'config() RANGE out of range: {v}'
            if (has(p = 'RANGE')) {
                if (isArray(v)) {
                    if (isValidInt(v[0], -MAX, -1, 2, p) && isValidInt(v[1], 1, MAX, 2, p)) {
                        MIN_EXP = v[0] | 0;
                        MAX_EXP = v[1] | 0;
                    }
                } else if (isValidInt(v, -MAX, MAX, 2, p)) {
                    if (v | 0) MIN_EXP = -(MAX_EXP = (v < 0 ? -v : v) | 0);
                    else if (ERRORS) raise(2, p + ' cannot be zero', v);
                }
            }
            r[p] = [
                MIN_EXP,
                MAX_EXP
            ];
            // ERRORS {boolean|number} true, false, 1 or 0.
            // 'config() ERRORS not a boolean or binary digit: {v}'
            if (has(p = 'ERRORS')) {
                if (v === !!v || v === 1 || v === 0) {
                    id = 0;
                    isValidInt = (ERRORS = !!v) ? intValidatorWithErrors : intValidatorNoErrors;
                } else if (ERRORS) raise(2, p + notBool, v);
            }
            r[p] = ERRORS;
            // CRYPTO {boolean|number} true, false, 1 or 0.
            // 'config() CRYPTO not a boolean or binary digit: {v}'
            // 'config() crypto unavailable: {crypto}'
            if (has(p = 'CRYPTO')) {
                if (v === true || v === false || v === 1 || v === 0) {
                    if (v) {
                        v = typeof crypto == 'undefined';
                        if (!v && crypto && (crypto.getRandomValues || crypto.randomBytes)) CRYPTO = true;
                        else if (ERRORS) raise(2, 'crypto unavailable', v ? void 0 : crypto);
                        else CRYPTO = false;
                    } else CRYPTO = false;
                } else if (ERRORS) raise(2, p + notBool, v);
            }
            r[p] = CRYPTO;
            // MODULO_MODE {number} Integer, 0 to 9 inclusive.
            // 'config() MODULO_MODE not an integer: {v}'
            // 'config() MODULO_MODE out of range: {v}'
            if (has(p = 'MODULO_MODE') && isValidInt(v, 0, 9, 2, p)) MODULO_MODE = v | 0;
            r[p] = MODULO_MODE;
            // POW_PRECISION {number} Integer, 0 to MAX inclusive.
            // 'config() POW_PRECISION not an integer: {v}'
            // 'config() POW_PRECISION out of range: {v}'
            if (has(p = 'POW_PRECISION') && isValidInt(v, 0, MAX, 2, p)) POW_PRECISION = v | 0;
            r[p] = POW_PRECISION;
            // FORMAT {object}
            // 'config() FORMAT not an object: {v}'
            if (has(p = 'FORMAT')) {
                if (typeof v == 'object') FORMAT = v;
                else if (ERRORS) raise(2, p + ' not an object', v);
            }
            r[p] = FORMAT;
            return r;
        };
        /*
         * Return a new BigNumber whose value is the maximum of the arguments.
         *
         * arguments {number|string|BigNumber}
         */ BigNumber.max = function() {
            return maxOrMin(arguments, P.lt);
        };
        /*
         * Return a new BigNumber whose value is the minimum of the arguments.
         *
         * arguments {number|string|BigNumber}
         */ BigNumber.min = function() {
            return maxOrMin(arguments, P.gt);
        };
        /*
         * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
         * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
         * zeros are produced).
         *
         * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
         *
         * 'random() decimal places not an integer: {dp}'
         * 'random() decimal places out of range: {dp}'
         * 'random() crypto unavailable: {crypto}'
         */ BigNumber.random = function() {
            var pow2_53 = 0x20000000000000;
            // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
            // Check if Math.random() produces more than 32 bits of randomness.
            // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
            // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
            var random53bitInt = Math.random() * pow2_53 & 0x1fffff ? function() {
                return mathfloor(Math.random() * pow2_53);
            } : function() {
                return (Math.random() * 0x40000000 | 0) * 0x800000 + (Math.random() * 0x800000 | 0);
            };
            return function(dp) {
                var a, b, e, k, v, i = 0, c = [], rand = new BigNumber(ONE);
                dp = dp == null || !isValidInt(dp, 0, MAX, 14) ? DECIMAL_PLACES : dp | 0;
                k = mathceil(dp / LOG_BASE);
                if (CRYPTO) {
                    // Browsers supporting crypto.getRandomValues.
                    if (crypto.getRandomValues) {
                        a = crypto.getRandomValues(new Uint32Array(k *= 2));
                        for(; i < k;){
                            // 53 bits:
                            // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
                            // 11111 11111111 11111111 11111111 11100000 00000000 00000000
                            // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
                            //                                     11111 11111111 11111111
                            // 0x20000 is 2^21.
                            v = a[i] * 0x20000 + (a[i + 1] >>> 11);
                            // Rejection sampling:
                            // 0 <= v < 9007199254740992
                            // Probability that v >= 9e15, is
                            // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
                            if (v >= 9e15) {
                                b = crypto.getRandomValues(new Uint32Array(2));
                                a[i] = b[0];
                                a[i + 1] = b[1];
                            } else {
                                // 0 <= v <= 8999999999999999
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 2;
                            }
                        }
                        i = k / 2;
                    // Node.js supporting crypto.randomBytes.
                    } else if (crypto.randomBytes) {
                        // buffer
                        a = crypto.randomBytes(k *= 7);
                        for(; i < k;){
                            // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
                            // 0x100000000 is 2^32, 0x1000000 is 2^24
                            // 11111 11111111 11111111 11111111 11111111 11111111 11111111
                            // 0 <= v < 9007199254740992
                            v = (a[i] & 31) * 0x1000000000000 + a[i + 1] * 0x10000000000 + a[i + 2] * 0x100000000 + a[i + 3] * 0x1000000 + (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];
                            if (v >= 9e15) crypto.randomBytes(7).copy(a, i);
                            else {
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 7;
                            }
                        }
                        i = k / 7;
                    } else {
                        CRYPTO = false;
                        if (ERRORS) raise(14, 'crypto unavailable', crypto);
                    }
                }
                // Use Math.random.
                if (!CRYPTO) for(; i < k;){
                    v = random53bitInt();
                    if (v < 9e15) c[i++] = v % 1e14;
                }
                k = c[--i];
                dp %= LOG_BASE;
                // Convert trailing digits to zeros according to dp.
                if (k && dp) {
                    v = POWS_TEN[LOG_BASE - dp];
                    c[i] = mathfloor(k / v) * v;
                }
                // Remove trailing elements which are zero.
                for(; c[i] === 0; c.pop(), i--);
                // Zero?
                if (i < 0) c = [
                    e = 0
                ];
                else {
                    // Remove leading elements which are zero and adjust exponent accordingly.
                    for(e = -1; c[0] === 0; c.splice(0, 1), e -= LOG_BASE);
                    // Count the digits of the first element of c to determine leading zeros, and...
                    for(i = 1, v = c[0]; v >= 10; v /= 10, i++);
                    // adjust the exponent accordingly.
                    if (i < LOG_BASE) e -= LOG_BASE - i;
                }
                rand.e = e;
                rand.c = c;
                return rand;
            };
        }();
        // PRIVATE FUNCTIONS
        // Convert a numeric string of baseIn to a numeric string of baseOut.
        function convertBase(str, baseOut, baseIn, sign) {
            var d, e, k, r, x, xc, y, i = str.indexOf('.'), dp = DECIMAL_PLACES, rm = ROUNDING_MODE;
            if (baseIn < 37) str = str.toLowerCase();
            // Non-integer.
            if (i >= 0) {
                k = POW_PRECISION;
                // Unlimited precision.
                POW_PRECISION = 0;
                str = str.replace('.', '');
                y = new BigNumber(baseIn);
                x = y.pow(str.length - i);
                POW_PRECISION = k;
                // Convert str as if an integer, then restore the fraction part by dividing the
                // result by its base raised to a power.
                y.c = toBaseOut(toFixedPoint(coeffToString(x.c), x.e), 10, baseOut);
                y.e = y.c.length;
            }
            // Convert the number as integer.
            xc = toBaseOut(str, baseIn, baseOut);
            e = k = xc.length;
            // Remove trailing zeros.
            for(; xc[--k] == 0; xc.pop());
            if (!xc[0]) return '0';
            if (i < 0) --e;
            else {
                x.c = xc;
                x.e = e;
                // sign is needed for correct rounding.
                x.s = sign;
                x = div(x, y, dp, rm, baseOut);
                xc = x.c;
                r = x.r;
                e = x.e;
            }
            d = e + dp + 1;
            // The rounding digit, i.e. the digit to the right of the digit that may be rounded up.
            i = xc[d];
            k = baseOut / 2;
            r = r || d < 0 || xc[d + 1] != null;
            r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : i > k || i == k && (rm == 4 || r || rm == 6 && xc[d - 1] & 1 || rm == (x.s < 0 ? 8 : 7));
            if (d < 1 || !xc[0]) // 1^-dp or 0.
            str = r ? toFixedPoint('1', -dp) : '0';
            else {
                xc.length = d;
                if (r) // Rounding up may mean the previous digit has to be rounded up and so on.
                for(--baseOut; ++xc[--d] > baseOut;){
                    xc[d] = 0;
                    if (!d) {
                        ++e;
                        xc = [
                            1
                        ].concat(xc);
                    }
                }
                // Determine trailing zeros.
                for(k = xc.length; !xc[--k];);
                // E.g. [4, 11, 15] becomes 4bf.
                for(i = 0, str = ''; i <= k; str += ALPHABET.charAt(xc[i++]));
                str = toFixedPoint(str, e);
            }
            // The caller will add the sign.
            return str;
        }
        // Perform division in the specified base. Called by div and convertBase.
        div = function() {
            // Assume non-zero x and k.
            function multiply(x, k, base) {
                var m, temp, xlo, xhi, carry = 0, i = x.length, klo = k % SQRT_BASE, khi = k / SQRT_BASE | 0;
                for(x = x.slice(); i--;){
                    xlo = x[i] % SQRT_BASE;
                    xhi = x[i] / SQRT_BASE | 0;
                    m = khi * xlo + xhi * klo;
                    temp = klo * xlo + m % SQRT_BASE * SQRT_BASE + carry;
                    carry = (temp / base | 0) + (m / SQRT_BASE | 0) + khi * xhi;
                    x[i] = temp % base;
                }
                if (carry) x = [
                    carry
                ].concat(x);
                return x;
            }
            function compare(a, b, aL, bL) {
                var i, cmp;
                if (aL != bL) cmp = aL > bL ? 1 : -1;
                else {
                    for(i = cmp = 0; i < aL; i++)if (a[i] != b[i]) {
                        cmp = a[i] > b[i] ? 1 : -1;
                        break;
                    }
                }
                return cmp;
            }
            function subtract(a, b, aL, base) {
                var i = 0;
                // Subtract b from a.
                for(; aL--;){
                    a[aL] -= i;
                    i = a[aL] < b[aL] ? 1 : 0;
                    a[aL] = i * base + a[aL] - b[aL];
                }
                // Remove leading zeros.
                for(; !a[0] && a.length > 1; a.splice(0, 1));
            }
            // x: dividend, y: divisor.
            return function(x, y, dp, rm, base) {
                var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0, yL, yz, s = x.s == y.s ? 1 : -1, xc = x.c, yc = y.c;
                // Either NaN, Infinity or 0?
                if (!xc || !xc[0] || !yc || !yc[0]) return new BigNumber(// Return NaN if either NaN, or both Infinity or 0.
                !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN : // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
                xc && xc[0] == 0 || !yc ? s * 0 : s / 0);
                q = new BigNumber(s);
                qc = q.c = [];
                e = x.e - y.e;
                s = dp + e + 1;
                if (!base) {
                    base = BASE;
                    e = bitFloor(x.e / LOG_BASE) - bitFloor(y.e / LOG_BASE);
                    s = s / LOG_BASE | 0;
                }
                // Result exponent may be one less then the current value of e.
                // The coefficients of the BigNumbers from convertBase may have trailing zeros.
                for(i = 0; yc[i] == (xc[i] || 0); i++);
                if (yc[i] > (xc[i] || 0)) e--;
                if (s < 0) {
                    qc.push(1);
                    more = true;
                } else {
                    xL = xc.length;
                    yL = yc.length;
                    i = 0;
                    s += 2;
                    // Normalise xc and yc so highest order digit of yc is >= base / 2.
                    n = mathfloor(base / (yc[0] + 1));
                    // Not necessary, but to handle odd bases where yc[0] == ( base / 2 ) - 1.
                    // if ( n > 1 || n++ == 1 && yc[0] < base / 2 ) {
                    if (n > 1) {
                        yc = multiply(yc, n, base);
                        xc = multiply(xc, n, base);
                        yL = yc.length;
                        xL = xc.length;
                    }
                    xi = yL;
                    rem = xc.slice(0, yL);
                    remL = rem.length;
                    // Add zeros to make remainder as long as divisor.
                    for(; remL < yL; rem[remL++] = 0);
                    yz = yc.slice();
                    yz = [
                        0
                    ].concat(yz);
                    yc0 = yc[0];
                    if (yc[1] >= base / 2) yc0++;
                    // Not necessary, but to prevent trial digit n > base, when using base 3.
                    // else if ( base == 3 && yc0 == 1 ) yc0 = 1 + 1e-15;
                    do {
                        n = 0;
                        // Compare divisor and remainder.
                        cmp = compare(yc, rem, yL, remL);
                        // If divisor < remainder.
                        if (cmp < 0) {
                            // Calculate trial digit, n.
                            rem0 = rem[0];
                            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                            // n is how many times the divisor goes into the current remainder.
                            n = mathfloor(rem0 / yc0);
                            //  Algorithm:
                            //  1. product = divisor * trial digit (n)
                            //  2. if product > remainder: product -= divisor, n--
                            //  3. remainder -= product
                            //  4. if product was < remainder at 2:
                            //    5. compare new remainder and divisor
                            //    6. If remainder > divisor: remainder -= divisor, n++
                            if (n > 1) {
                                // n may be > base only when base is 3.
                                if (n >= base) n = base - 1;
                                // product = divisor * trial digit.
                                prod = multiply(yc, n, base);
                                prodL = prod.length;
                                remL = rem.length;
                                // Compare product and remainder.
                                // If product > remainder.
                                // Trial digit n too high.
                                // n is 1 too high about 5% of the time, and is not known to have
                                // ever been more than 1 too high.
                                while(compare(prod, rem, prodL, remL) == 1){
                                    n--;
                                    // Subtract divisor from product.
                                    subtract(prod, yL < prodL ? yz : yc, prodL, base);
                                    prodL = prod.length;
                                    cmp = 1;
                                }
                            } else {
                                // n is 0 or 1, cmp is -1.
                                // If n is 0, there is no need to compare yc and rem again below,
                                // so change cmp to 1 to avoid it.
                                // If n is 1, leave cmp as -1, so yc and rem are compared again.
                                if (n == 0) // divisor < remainder, so n must be at least 1.
                                cmp = n = 1;
                                // product = divisor
                                prod = yc.slice();
                                prodL = prod.length;
                            }
                            if (prodL < remL) prod = [
                                0
                            ].concat(prod);
                            // Subtract product from remainder.
                            subtract(rem, prod, remL, base);
                            remL = rem.length;
                            // If product was < remainder.
                            if (cmp == -1) // Compare divisor and new remainder.
                            // If divisor < new remainder, subtract divisor from remainder.
                            // Trial digit n too low.
                            // n is 1 too low about 5% of the time, and very rarely 2 too low.
                            while(compare(yc, rem, yL, remL) < 1){
                                n++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yc, remL, base);
                                remL = rem.length;
                            }
                        } else if (cmp === 0) {
                            n++;
                            rem = [
                                0
                            ];
                        } // else cmp === 1 and n will be 0
                        // Add the next digit, n, to the result array.
                        qc[i++] = n;
                        // Update the remainder.
                        if (rem[0]) rem[remL++] = xc[xi] || 0;
                        else {
                            rem = [
                                xc[xi]
                            ];
                            remL = 1;
                        }
                    }while ((xi++ < xL || rem[0] != null) && s--);
                    more = rem[0] != null;
                    // Leading zero?
                    if (!qc[0]) qc.splice(0, 1);
                }
                if (base == BASE) {
                    // To calculate q.e, first get the number of digits of qc[0].
                    for(i = 1, s = qc[0]; s >= 10; s /= 10, i++);
                    round(q, dp + (q.e = i + e * LOG_BASE - 1) + 1, rm, more);
                // Caller is convertBase.
                } else {
                    q.e = e;
                    q.r = +more;
                }
                return q;
            };
        }();
        /*
         * Return a string representing the value of BigNumber n in fixed-point or exponential
         * notation rounded to the specified decimal places or significant digits.
         *
         * n is a BigNumber.
         * i is the index of the last digit required (i.e. the digit that may be rounded up).
         * rm is the rounding mode.
         * caller is caller id: toExponential 19, toFixed 20, toFormat 21, toPrecision 24.
         */ function format(n, i, rm, caller) {
            var c0, e, ne, len, str;
            rm = rm != null && isValidInt(rm, 0, 8, caller, roundingMode) ? rm | 0 : ROUNDING_MODE;
            if (!n.c) return n.toString();
            c0 = n.c[0];
            ne = n.e;
            if (i == null) {
                str = coeffToString(n.c);
                str = caller == 19 || caller == 24 && ne <= TO_EXP_NEG ? toExponential(str, ne) : toFixedPoint(str, ne);
            } else {
                n = round(new BigNumber(n), i, rm);
                // n.e may have changed if the value was rounded up.
                e = n.e;
                str = coeffToString(n.c);
                len = str.length;
                // toPrecision returns exponential notation if the number of significant digits
                // specified is less than the number of digits necessary to represent the integer
                // part of the value in fixed-point notation.
                // Exponential notation.
                if (caller == 19 || caller == 24 && (i <= e || e <= TO_EXP_NEG)) {
                    // Append zeros?
                    for(; len < i; str += '0', len++);
                    str = toExponential(str, e);
                // Fixed-point notation.
                } else {
                    i -= ne;
                    str = toFixedPoint(str, e);
                    // Append zeros?
                    if (e + 1 > len) {
                        if (--i > 0) for(str += '.'; i--; str += '0');
                    } else {
                        i += e - len;
                        if (i > 0) {
                            if (e + 1 == len) str += '.';
                            for(; i--; str += '0');
                        }
                    }
                }
            }
            return n.s < 0 && c0 ? '-' + str : str;
        }
        // Handle BigNumber.max and BigNumber.min.
        function maxOrMin(args, method) {
            var m, n, i = 0;
            if (isArray(args[0])) args = args[0];
            m = new BigNumber(args[0]);
            for(; ++i < args.length;){
                n = new BigNumber(args[i]);
                // If any number is NaN, return NaN.
                if (!n.s) {
                    m = n;
                    break;
                } else if (method.call(m, n)) m = n;
            }
            return m;
        }
        /*
         * Return true if n is an integer in range, otherwise throw.
         * Use for argument validation when ERRORS is true.
         */ function intValidatorWithErrors(n, min, max, caller, name) {
            if (n < min || n > max || n != truncate(n)) raise(caller, (name || 'decimal places') + (n < min || n > max ? ' out of range' : ' not an integer'), n);
            return true;
        }
        /*
         * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
         * Called by minus, plus and times.
         */ function normalise(n, c, e) {
            var i = 1, j = c.length;
            // Remove trailing zeros.
            for(; !c[--j]; c.pop());
            // Calculate the base 10 exponent. First get the number of digits of c[0].
            for(j = c[0]; j >= 10; j /= 10, i++);
            // Overflow?
            if ((e = i + e * LOG_BASE - 1) > MAX_EXP) // Infinity.
            n.c = n.e = null;
            else if (e < MIN_EXP) // Zero.
            n.c = [
                n.e = 0
            ];
            else {
                n.e = e;
                n.c = c;
            }
            return n;
        }
        // Handle values that fail the validity test in BigNumber.
        parseNumeric = function() {
            var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i, dotAfter = /^([^.]+)\.$/, dotBefore = /^\.([^.]+)$/, isInfinityOrNaN = /^-?(Infinity|NaN)$/, whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
            return function(x, str, num, b) {
                var base, s = num ? str : str.replace(whitespaceOrPlus, '');
                // No exception on ±Infinity or NaN.
                if (isInfinityOrNaN.test(s)) x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
                else {
                    if (!num) {
                        // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
                        s = s.replace(basePrefix, function(m, p1, p2) {
                            base = (p2 = p2.toLowerCase()) == 'x' ? 16 : p2 == 'b' ? 2 : 8;
                            return !b || b == base ? p1 : m;
                        });
                        if (b) {
                            base = b;
                            // E.g. '1.' to '1', '.1' to '0.1'
                            s = s.replace(dotAfter, '$1').replace(dotBefore, '0.$1');
                        }
                        if (str != s) return new BigNumber(s, base);
                    }
                    // 'new BigNumber() not a number: {n}'
                    // 'new BigNumber() not a base {b} number: {n}'
                    if (ERRORS) raise(id, 'not a' + (b ? ' base ' + b : '') + ' number', str);
                    x.s = null;
                }
                x.c = x.e = null;
                id = 0;
            };
        }();
        // Throw a BigNumber Error.
        function raise(caller, msg, val) {
            var error = new Error([
                'new BigNumber',
                'cmp',
                'config',
                'div',
                'divToInt',
                'eq',
                'gt',
                'gte',
                'lt',
                'lte',
                'minus',
                'mod',
                'plus',
                'precision',
                'random',
                'round',
                'shift',
                'times',
                'toDigits',
                'toExponential',
                'toFixed',
                'toFormat',
                'toFraction',
                'pow',
                'toPrecision',
                'toString',
                'BigNumber' // 26
            ][caller] + '() ' + msg + ': ' + val);
            error.name = 'BigNumber Error';
            id = 0;
            throw error;
        }
        /*
         * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
         * If r is truthy, it is known that there are more digits after the rounding digit.
         */ function round(x, sd, rm, r) {
            var d, i, j, k, n, ni, rd, xc = x.c, pows10 = POWS_TEN;
            // if x is not Infinity or NaN...
            if (xc) {
                // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
                // n is a base 1e14 number, the value of the element of array x.c containing rd.
                // ni is the index of n within x.c.
                // d is the number of digits of n.
                // i is the index of rd within n including leading zeros.
                // j is the actual index of rd within n (if < 0, rd is a leading zero).
                out: {
                    // Get the number of digits of the first element of xc.
                    for(d = 1, k = xc[0]; k >= 10; k /= 10, d++);
                    i = sd - d;
                    // If the rounding digit is in the first element of xc...
                    if (i < 0) {
                        i += LOG_BASE;
                        j = sd;
                        n = xc[ni = 0];
                        // Get the rounding digit at index j of n.
                        rd = n / pows10[d - j - 1] % 10 | 0;
                    } else {
                        ni = mathceil((i + 1) / LOG_BASE);
                        if (ni >= xc.length) {
                            if (r) {
                                // Needed by sqrt.
                                for(; xc.length <= ni; xc.push(0));
                                n = rd = 0;
                                d = 1;
                                i %= LOG_BASE;
                                j = i - LOG_BASE + 1;
                            } else break out;
                        } else {
                            n = k = xc[ni];
                            // Get the number of digits of n.
                            for(d = 1; k >= 10; k /= 10, d++);
                            // Get the index of rd within n.
                            i %= LOG_BASE;
                            // Get the index of rd within n, adjusted for leading zeros.
                            // The number of leading zeros of n is given by LOG_BASE - d.
                            j = i - LOG_BASE + d;
                            // Get the rounding digit at index j of n.
                            rd = j < 0 ? 0 : n / pows10[d - j - 1] % 10 | 0;
                        }
                    }
                    r = r || sd < 0 || // Are there any non-zero digits after the rounding digit?
                    // The expression  n % pows10[ d - j - 1 ]  returns all digits of n to the right
                    // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
                    xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);
                    r = rm < 4 ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 && (i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
                    if (sd < 1 || !xc[0]) {
                        xc.length = 0;
                        if (r) {
                            // Convert sd to decimal places.
                            sd -= x.e + 1;
                            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                            xc[0] = pows10[(LOG_BASE - sd % LOG_BASE) % LOG_BASE];
                            x.e = -sd || 0;
                        } else // Zero.
                        xc[0] = x.e = 0;
                        return x;
                    }
                    // Remove excess digits.
                    if (i == 0) {
                        xc.length = ni;
                        k = 1;
                        ni--;
                    } else {
                        xc.length = ni + 1;
                        k = pows10[LOG_BASE - i];
                        // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                        // j > 0 means i > number of leading zeros of n.
                        xc[ni] = j > 0 ? mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
                    }
                    // Round up?
                    if (r) {
                        for(;;)// If the digit to be rounded up is in the first element of xc...
                        if (ni == 0) {
                            // i will be the length of xc[0] before k is added.
                            for(i = 1, j = xc[0]; j >= 10; j /= 10, i++);
                            j = xc[0] += k;
                            for(k = 1; j >= 10; j /= 10, k++);
                            // if i != k the length has increased.
                            if (i != k) {
                                x.e++;
                                if (xc[0] == BASE) xc[0] = 1;
                            }
                            break;
                        } else {
                            xc[ni] += k;
                            if (xc[ni] != BASE) break;
                            xc[ni--] = 0;
                            k = 1;
                        }
                    }
                    // Remove trailing zeros.
                    for(i = xc.length; xc[--i] === 0; xc.pop());
                }
                // Overflow? Infinity.
                if (x.e > MAX_EXP) x.c = x.e = null;
                else if (x.e < MIN_EXP) x.c = [
                    x.e = 0
                ];
            }
            return x;
        }
        // PROTOTYPE/INSTANCE METHODS
        /*
         * Return a new BigNumber whose value is the absolute value of this BigNumber.
         */ P.absoluteValue = P.abs = function() {
            var x = new BigNumber(this);
            if (x.s < 0) x.s = 1;
            return x;
        };
        /*
         * Return a new BigNumber whose value is the value of this BigNumber rounded to a whole
         * number in the direction of Infinity.
         */ P.ceil = function() {
            return round(new BigNumber(this), this.e + 1, 2);
        };
        /*
         * Return
         * 1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
         * -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
         * 0 if they have the same value,
         * or null if the value of either is NaN.
         */ P.comparedTo = P.cmp = function(y, b) {
            id = 1;
            return compare(this, new BigNumber(y, b));
        };
        /*
         * Return the number of decimal places of the value of this BigNumber, or null if the value
         * of this BigNumber is ±Infinity or NaN.
         */ P.decimalPlaces = P.dp = function() {
            var n, v, c = this.c;
            if (!c) return null;
            n = ((v = c.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE;
            // Subtract the number of trailing zeros of the last number.
            if (v = c[v]) for(; v % 10 == 0; v /= 10, n--);
            if (n < 0) n = 0;
            return n;
        };
        /*
         *  n / 0 = I
         *  n / N = N
         *  n / I = 0
         *  0 / n = 0
         *  0 / 0 = N
         *  0 / N = N
         *  0 / I = 0
         *  N / n = N
         *  N / 0 = N
         *  N / N = N
         *  N / I = N
         *  I / n = I
         *  I / 0 = I
         *  I / N = N
         *  I / I = N
         *
         * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
         * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
         */ P.dividedBy = P.div = function(y, b) {
            id = 3;
            return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
        };
        /*
         * Return a new BigNumber whose value is the integer part of dividing the value of this
         * BigNumber by the value of BigNumber(y, b).
         */ P.dividedToIntegerBy = P.divToInt = function(y, b) {
            id = 4;
            return div(this, new BigNumber(y, b), 0, 1);
        };
        /*
         * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
         * otherwise returns false.
         */ P.equals = P.eq = function(y, b) {
            id = 5;
            return compare(this, new BigNumber(y, b)) === 0;
        };
        /*
         * Return a new BigNumber whose value is the value of this BigNumber rounded to a whole
         * number in the direction of -Infinity.
         */ P.floor = function() {
            return round(new BigNumber(this), this.e + 1, 3);
        };
        /*
         * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
         * otherwise returns false.
         */ P.greaterThan = P.gt = function(y, b) {
            id = 6;
            return compare(this, new BigNumber(y, b)) > 0;
        };
        /*
         * Return true if the value of this BigNumber is greater than or equal to the value of
         * BigNumber(y, b), otherwise returns false.
         */ P.greaterThanOrEqualTo = P.gte = function(y, b) {
            id = 7;
            return (b = compare(this, new BigNumber(y, b))) === 1 || b === 0;
        };
        /*
         * Return true if the value of this BigNumber is a finite number, otherwise returns false.
         */ P.isFinite = function() {
            return !!this.c;
        };
        /*
         * Return true if the value of this BigNumber is an integer, otherwise return false.
         */ P.isInteger = P.isInt = function() {
            return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
        };
        /*
         * Return true if the value of this BigNumber is NaN, otherwise returns false.
         */ P.isNaN = function() {
            return !this.s;
        };
        /*
         * Return true if the value of this BigNumber is negative, otherwise returns false.
         */ P.isNegative = P.isNeg = function() {
            return this.s < 0;
        };
        /*
         * Return true if the value of this BigNumber is 0 or -0, otherwise returns false.
         */ P.isZero = function() {
            return !!this.c && this.c[0] == 0;
        };
        /*
         * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
         * otherwise returns false.
         */ P.lessThan = P.lt = function(y, b) {
            id = 8;
            return compare(this, new BigNumber(y, b)) < 0;
        };
        /*
         * Return true if the value of this BigNumber is less than or equal to the value of
         * BigNumber(y, b), otherwise returns false.
         */ P.lessThanOrEqualTo = P.lte = function(y, b) {
            id = 9;
            return (b = compare(this, new BigNumber(y, b))) === -1 || b === 0;
        };
        /*
         *  n - 0 = n
         *  n - N = N
         *  n - I = -I
         *  0 - n = -n
         *  0 - 0 = 0
         *  0 - N = N
         *  0 - I = -I
         *  N - n = N
         *  N - 0 = N
         *  N - N = N
         *  N - I = N
         *  I - n = I
         *  I - 0 = I
         *  I - N = N
         *  I - I = N
         *
         * Return a new BigNumber whose value is the value of this BigNumber minus the value of
         * BigNumber(y, b).
         */ P.minus = P.sub = function(y, b) {
            var i, j, t, xLTy, x = this, a = x.s;
            id = 10;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.plus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Either Infinity?
                if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);
                // Either zero?
                if (!xc[0] || !yc[0]) // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x : // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
                ROUNDING_MODE == 3 ? -0 : 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Determine which is the bigger number.
            if (a = xe - ye) {
                if (xLTy = a < 0) {
                    a = -a;
                    t = xc;
                } else {
                    ye = xe;
                    t = yc;
                }
                t.reverse();
                // Prepend zeros to equalise exponents.
                for(b = a; b--; t.push(0));
                t.reverse();
            } else {
                // Exponents equal. Check digit by digit.
                j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;
                for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                    xLTy = xc[b] < yc[b];
                    break;
                }
            }
            // x < y? Point xc to the array of the bigger number.
            if (xLTy) t = xc, xc = yc, yc = t, y.s = -y.s;
            b = (j = yc.length) - (i = xc.length);
            // Append zeros to xc if shorter.
            // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
            if (b > 0) for(; b--; xc[i++] = 0);
            b = BASE - 1;
            // Subtract yc from xc.
            for(; j > a;){
                if (xc[--j] < yc[j]) {
                    for(i = j; i && !xc[--i]; xc[i] = b);
                    --xc[i];
                    xc[j] += BASE;
                }
                xc[j] -= yc[j];
            }
            // Remove leading zeros and adjust exponent accordingly.
            for(; xc[0] == 0; xc.splice(0, 1), --ye);
            // Zero?
            if (!xc[0]) {
                // Following IEEE 754 (2008) 6.3,
                // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
                y.s = ROUNDING_MODE == 3 ? -1 : 1;
                y.c = [
                    y.e = 0
                ];
                return y;
            }
            // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
            // for finite x and y.
            return normalise(y, xc, ye);
        };
        /*
         *   n % 0 =  N
         *   n % N =  N
         *   n % I =  n
         *   0 % n =  0
         *  -0 % n = -0
         *   0 % 0 =  N
         *   0 % N =  N
         *   0 % I =  0
         *   N % n =  N
         *   N % 0 =  N
         *   N % N =  N
         *   N % I =  N
         *   I % n =  N
         *   I % 0 =  N
         *   I % N =  N
         *   I % I =  N
         *
         * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
         * BigNumber(y, b). The result depends on the value of MODULO_MODE.
         */ P.modulo = P.mod = function(y, b) {
            var q, s, x = this;
            id = 11;
            y = new BigNumber(y, b);
            // Return NaN if x is Infinity or NaN, or y is NaN or zero.
            if (!x.c || !y.s || y.c && !y.c[0]) return new BigNumber(NaN);
            else if (!y.c || x.c && !x.c[0]) return new BigNumber(x);
            if (MODULO_MODE == 9) {
                // Euclidian division: q = sign(y) * floor(x / abs(y))
                // r = x - qy    where  0 <= r < abs(y)
                s = y.s;
                y.s = 1;
                q = div(x, y, 0, 3);
                y.s = s;
                q.s *= s;
            } else q = div(x, y, 0, MODULO_MODE);
            return x.minus(q.times(y));
        };
        /*
         * Return a new BigNumber whose value is the value of this BigNumber negated,
         * i.e. multiplied by -1.
         */ P.negated = P.neg = function() {
            var x = new BigNumber(this);
            x.s = -x.s || null;
            return x;
        };
        /*
         *  n + 0 = n
         *  n + N = N
         *  n + I = I
         *  0 + n = n
         *  0 + 0 = 0
         *  0 + N = N
         *  0 + I = I
         *  N + n = N
         *  N + 0 = N
         *  N + N = N
         *  N + I = N
         *  I + n = I
         *  I + 0 = I
         *  I + N = N
         *  I + I = I
         *
         * Return a new BigNumber whose value is the value of this BigNumber plus the value of
         * BigNumber(y, b).
         */ P.plus = P.add = function(y, b) {
            var t, x = this, a = x.s;
            id = 12;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.minus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Return ±Infinity if either ±Infinity.
                if (!xc || !yc) return new BigNumber(a / 0);
                // Either zero?
                // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
            if (a = xe - ye) {
                if (a > 0) {
                    ye = xe;
                    t = yc;
                } else {
                    a = -a;
                    t = xc;
                }
                t.reverse();
                for(; a--; t.push(0));
                t.reverse();
            }
            a = xc.length;
            b = yc.length;
            // Point xc to the longer array, and b to the shorter length.
            if (a - b < 0) t = yc, yc = xc, xc = t, b = a;
            // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
            for(a = 0; b;){
                a = (xc[--b] = xc[b] + yc[b] + a) / BASE | 0;
                xc[b] = BASE === xc[b] ? 0 : xc[b] % BASE;
            }
            if (a) {
                xc = [
                    a
                ].concat(xc);
                ++ye;
            }
            // No need to check for zero, as +x + +y != 0 && -x + -y != 0
            // ye = MAX_EXP + 1 possible
            return normalise(y, xc, ye);
        };
        /*
         * Return the number of significant digits of the value of this BigNumber.
         *
         * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
         */ P.precision = P.sd = function(z) {
            var n, v, x = this, c = x.c;
            // 'precision() argument not a boolean or binary digit: {z}'
            if (z != null && z !== !!z && z !== 1 && z !== 0) {
                if (ERRORS) raise(13, 'argument' + notBool, z);
                if (z != !!z) z = null;
            }
            if (!c) return null;
            v = c.length - 1;
            n = v * LOG_BASE + 1;
            if (v = c[v]) {
                // Subtract the number of trailing zeros of the last element.
                for(; v % 10 == 0; v /= 10, n--);
                // Add the number of digits of the first element.
                for(v = c[0]; v >= 10; v /= 10, n++);
            }
            if (z && x.e + 1 > n) n = x.e + 1;
            return n;
        };
        /*
         * Return a new BigNumber whose value is the value of this BigNumber rounded to a maximum of
         * dp decimal places using rounding mode rm, or to 0 and ROUNDING_MODE respectively if
         * omitted.
         *
         * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
         * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
         *
         * 'round() decimal places out of range: {dp}'
         * 'round() decimal places not an integer: {dp}'
         * 'round() rounding mode not an integer: {rm}'
         * 'round() rounding mode out of range: {rm}'
         */ P.round = function(dp, rm) {
            var n = new BigNumber(this);
            if (dp == null || isValidInt(dp, 0, MAX, 15)) round(n, ~~dp + this.e + 1, rm == null || !isValidInt(rm, 0, 8, 15, roundingMode) ? ROUNDING_MODE : rm | 0);
            return n;
        };
        /*
         * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
         * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
         *
         * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
         *
         * If k is out of range and ERRORS is false, the result will be ±0 if k < 0, or ±Infinity
         * otherwise.
         *
         * 'shift() argument not an integer: {k}'
         * 'shift() argument out of range: {k}'
         */ P.shift = function(k) {
            var n = this;
            return isValidInt(k, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER, 16, 'argument') ? n.times('1e' + truncate(k)) : new BigNumber(n.c && n.c[0] && (k < -MAX_SAFE_INTEGER || k > MAX_SAFE_INTEGER) ? n.s * (k < 0 ? 0 : 1 / 0) : n);
        };
        /*
         *  sqrt(-n) =  N
         *  sqrt( N) =  N
         *  sqrt(-I) =  N
         *  sqrt( I) =  I
         *  sqrt( 0) =  0
         *  sqrt(-0) = -0
         *
         * Return a new BigNumber whose value is the square root of the value of this BigNumber,
         * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
         */ P.squareRoot = P.sqrt = function() {
            var m, n, r, rep, t, x = this, c = x.c, s = x.s, e = x.e, dp = DECIMAL_PLACES + 4, half = new BigNumber('0.5');
            // Negative/NaN/Infinity/zero?
            if (s !== 1 || !c || !c[0]) return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
            // Initial estimate.
            s = Math.sqrt(+x);
            // Math.sqrt underflow/overflow?
            // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
            if (s == 0 || s == 1 / 0) {
                n = coeffToString(c);
                if ((n.length + e) % 2 == 0) n += '0';
                s = Math.sqrt(n);
                e = bitFloor((e + 1) / 2) - (e < 0 || e % 2);
                if (s == 1 / 0) n = '1e' + e;
                else {
                    n = s.toExponential();
                    n = n.slice(0, n.indexOf('e') + 1) + e;
                }
                r = new BigNumber(n);
            } else r = new BigNumber(s + '');
            // Check for zero.
            // r could be zero if MIN_EXP is changed after the this value was created.
            // This would cause a division by zero (x/t) and hence Infinity below, which would cause
            // coeffToString to throw.
            if (r.c[0]) {
                e = r.e;
                s = e + dp;
                if (s < 3) s = 0;
                // Newton-Raphson iteration.
                for(;;){
                    t = r;
                    r = half.times(t.plus(div(x, t, dp, 1)));
                    if (coeffToString(t.c).slice(0, s) === (n = coeffToString(r.c)).slice(0, s)) {
                        // The exponent of r may here be one less than the final result exponent,
                        // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
                        // are indexed correctly.
                        if (r.e < e) --s;
                        n = n.slice(s - 3, s + 1);
                        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
                        // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
                        // iteration.
                        if (n == '9999' || !rep && n == '4999') {
                            // On the first iteration only, check to see if rounding up gives the
                            // exact result as the nines may infinitely repeat.
                            if (!rep) {
                                round(t, t.e + DECIMAL_PLACES + 2, 0);
                                if (t.times(t).eq(x)) {
                                    r = t;
                                    break;
                                }
                            }
                            dp += 4;
                            s += 4;
                            rep = 1;
                        } else {
                            // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
                            // result. If not, then there are further digits and m will be truthy.
                            if (!+n || !+n.slice(1) && n.charAt(0) == '5') {
                                // Truncate to the first rounding digit.
                                round(r, r.e + DECIMAL_PLACES + 2, 1);
                                m = !r.times(r).eq(x);
                            }
                            break;
                        }
                    }
                }
            }
            return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
        };
        /*
         *  n * 0 = 0
         *  n * N = N
         *  n * I = I
         *  0 * n = 0
         *  0 * 0 = 0
         *  0 * N = N
         *  0 * I = N
         *  N * n = N
         *  N * 0 = N
         *  N * N = N
         *  N * I = N
         *  I * n = I
         *  I * 0 = N
         *  I * N = N
         *  I * I = I
         *
         * Return a new BigNumber whose value is the value of this BigNumber times the value of
         * BigNumber(y, b).
         */ P.times = P.mul = function(y, b) {
            var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc, base, sqrtBase, x = this, xc = x.c, yc = (id = 17, y = new BigNumber(y, b)).c;
            // Either NaN, ±Infinity or ±0?
            if (!xc || !yc || !xc[0] || !yc[0]) {
                // Return NaN if either is NaN, or one is 0 and the other is Infinity.
                if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) y.c = y.e = y.s = null;
                else {
                    y.s *= x.s;
                    // Return ±Infinity if either is ±Infinity.
                    if (!xc || !yc) y.c = y.e = null;
                    else {
                        y.c = [
                            0
                        ];
                        y.e = 0;
                    }
                }
                return y;
            }
            e = bitFloor(x.e / LOG_BASE) + bitFloor(y.e / LOG_BASE);
            y.s *= x.s;
            xcL = xc.length;
            ycL = yc.length;
            // Ensure xc points to longer array and xcL to its length.
            if (xcL < ycL) zc = xc, xc = yc, yc = zc, i = xcL, xcL = ycL, ycL = i;
            // Initialise the result array with zeros.
            for(i = xcL + ycL, zc = []; i--; zc.push(0));
            base = BASE;
            sqrtBase = SQRT_BASE;
            for(i = ycL; --i >= 0;){
                c = 0;
                ylo = yc[i] % sqrtBase;
                yhi = yc[i] / sqrtBase | 0;
                for(k = xcL, j = i + k; j > i;){
                    xlo = xc[--k] % sqrtBase;
                    xhi = xc[k] / sqrtBase | 0;
                    m = yhi * xlo + xhi * ylo;
                    xlo = ylo * xlo + m % sqrtBase * sqrtBase + zc[j] + c;
                    c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
                    zc[j--] = xlo % base;
                }
                zc[j] = c;
            }
            if (c) ++e;
            else zc.splice(0, 1);
            return normalise(y, zc, e);
        };
        /*
         * Return a new BigNumber whose value is the value of this BigNumber rounded to a maximum of
         * sd significant digits using rounding mode rm, or ROUNDING_MODE if rm is omitted.
         *
         * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
         * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
         *
         * 'toDigits() precision out of range: {sd}'
         * 'toDigits() precision not an integer: {sd}'
         * 'toDigits() rounding mode not an integer: {rm}'
         * 'toDigits() rounding mode out of range: {rm}'
         */ P.toDigits = function(sd, rm) {
            var n = new BigNumber(this);
            sd = sd == null || !isValidInt(sd, 1, MAX, 18, 'precision') ? null : sd | 0;
            rm = rm == null || !isValidInt(rm, 0, 8, 18, roundingMode) ? ROUNDING_MODE : rm | 0;
            return sd ? round(n, sd, rm) : n;
        };
        /*
         * Return a string representing the value of this BigNumber in exponential notation and
         * rounded using ROUNDING_MODE to dp fixed decimal places.
         *
         * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
         * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
         *
         * 'toExponential() decimal places not an integer: {dp}'
         * 'toExponential() decimal places out of range: {dp}'
         * 'toExponential() rounding mode not an integer: {rm}'
         * 'toExponential() rounding mode out of range: {rm}'
         */ P.toExponential = function(dp, rm) {
            return format(this, dp != null && isValidInt(dp, 0, MAX, 19) ? ~~dp + 1 : null, rm, 19);
        };
        /*
         * Return a string representing the value of this BigNumber in fixed-point notation rounding
         * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
         *
         * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
         * but e.g. (-0.00001).toFixed(0) is '-0'.
         *
         * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
         * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
         *
         * 'toFixed() decimal places not an integer: {dp}'
         * 'toFixed() decimal places out of range: {dp}'
         * 'toFixed() rounding mode not an integer: {rm}'
         * 'toFixed() rounding mode out of range: {rm}'
         */ P.toFixed = function(dp, rm) {
            return format(this, dp != null && isValidInt(dp, 0, MAX, 20) ? ~~dp + this.e + 1 : null, rm, 20);
        };
        /*
         * Return a string representing the value of this BigNumber in fixed-point notation rounded
         * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
         * of the FORMAT object (see BigNumber.config).
         *
         * FORMAT = {
         *      decimalSeparator : '.',
         *      groupSeparator : ',',
         *      groupSize : 3,
         *      secondaryGroupSize : 0,
         *      fractionGroupSeparator : '\xA0',    // non-breaking space
         *      fractionGroupSize : 0
         * };
         *
         * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
         * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
         *
         * 'toFormat() decimal places not an integer: {dp}'
         * 'toFormat() decimal places out of range: {dp}'
         * 'toFormat() rounding mode not an integer: {rm}'
         * 'toFormat() rounding mode out of range: {rm}'
         */ P.toFormat = function(dp, rm) {
            var str = format(this, dp != null && isValidInt(dp, 0, MAX, 21) ? ~~dp + this.e + 1 : null, rm, 21);
            if (this.c) {
                var i, arr = str.split('.'), g1 = +FORMAT.groupSize, g2 = +FORMAT.secondaryGroupSize, groupSeparator = FORMAT.groupSeparator, intPart = arr[0], fractionPart = arr[1], isNeg = this.s < 0, intDigits = isNeg ? intPart.slice(1) : intPart, len = intDigits.length;
                if (g2) i = g1, g1 = g2, g2 = i, len -= i;
                if (g1 > 0 && len > 0) {
                    i = len % g1 || g1;
                    intPart = intDigits.substr(0, i);
                    for(; i < len; i += g1)intPart += groupSeparator + intDigits.substr(i, g1);
                    if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
                    if (isNeg) intPart = '-' + intPart;
                }
                str = fractionPart ? intPart + FORMAT.decimalSeparator + ((g2 = +FORMAT.fractionGroupSize) ? fractionPart.replace(new RegExp('\\d{' + g2 + '}\\B', 'g'), '$&' + FORMAT.fractionGroupSeparator) : fractionPart) : intPart;
            }
            return str;
        };
        /*
         * Return a string array representing the value of this BigNumber as a simple fraction with
         * an integer numerator and an integer denominator. The denominator will be a positive
         * non-zero value less than or equal to the specified maximum denominator. If a maximum
         * denominator is not specified, the denominator will be the lowest value necessary to
         * represent the number exactly.
         *
         * [md] {number|string|BigNumber} Integer >= 1 and < Infinity. The maximum denominator.
         *
         * 'toFraction() max denominator not an integer: {md}'
         * 'toFraction() max denominator out of range: {md}'
         */ P.toFraction = function(md) {
            var arr, d0, d2, e, exp, n, n0, q, s, k = ERRORS, x = this, xc = x.c, d = new BigNumber(ONE), n1 = d0 = new BigNumber(ONE), d1 = n0 = new BigNumber(ONE);
            if (md != null) {
                ERRORS = false;
                n = new BigNumber(md);
                ERRORS = k;
                if (!(k = n.isInt()) || n.lt(ONE)) {
                    if (ERRORS) raise(22, 'max denominator ' + (k ? 'out of range' : 'not an integer'), md);
                    // ERRORS is false:
                    // If md is a finite non-integer >= 1, round it to an integer and use it.
                    md = !k && n.c && round(n, n.e + 1, 1).gte(ONE) ? n : null;
                }
            }
            if (!xc) return x.toString();
            s = coeffToString(xc);
            // Determine initial denominator.
            // d is a power of 10 and the minimum max denominator that specifies the value exactly.
            e = d.e = s.length - x.e - 1;
            d.c[0] = POWS_TEN[(exp = e % LOG_BASE) < 0 ? LOG_BASE + exp : exp];
            md = !md || n.cmp(d) > 0 ? e > 0 ? d : n1 : n;
            exp = MAX_EXP;
            MAX_EXP = 1 / 0;
            n = new BigNumber(s);
            // n0 = d1 = 0
            n0.c[0] = 0;
            for(;;){
                q = div(n, d, 0, 1);
                d2 = d0.plus(q.times(d1));
                if (d2.cmp(md) == 1) break;
                d0 = d1;
                d1 = d2;
                n1 = n0.plus(q.times(d2 = n1));
                n0 = d2;
                d = n.minus(q.times(d2 = d));
                n = d2;
            }
            d2 = div(md.minus(d0), d1, 0, 1);
            n0 = n0.plus(d2.times(n1));
            d0 = d0.plus(d2.times(d1));
            n0.s = n1.s = x.s;
            e *= 2;
            // Determine which fraction is closer to x, n0/d0 or n1/d1
            arr = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().cmp(div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [
                n1.toString(),
                d1.toString()
            ] : [
                n0.toString(),
                d0.toString()
            ];
            MAX_EXP = exp;
            return arr;
        };
        /*
         * Return the value of this BigNumber converted to a number primitive.
         */ P.toNumber = function() {
            return +this;
        };
        /*
         * Return a BigNumber whose value is the value of this BigNumber raised to the power n.
         * If m is present, return the result modulo m.
         * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
         * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using
         * ROUNDING_MODE.
         *
         * The modular power operation works efficiently when x, n, and m are positive integers,
         * otherwise it is equivalent to calculating x.toPower(n).modulo(m) (with POW_PRECISION 0).
         *
         * n {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
         * [m] {number|string|BigNumber} The modulus.
         *
         * 'pow() exponent not an integer: {n}'
         * 'pow() exponent out of range: {n}'
         *
         * Performs 54 loop iterations for n of 9007199254740991.
         */ P.toPower = P.pow = function(n, m) {
            var k, y, z, i = mathfloor(n < 0 ? -n : +n), x = this;
            if (m != null) {
                id = 23;
                m = new BigNumber(m);
            }
            // Pass ±Infinity to Math.pow if exponent is out of range.
            if (!isValidInt(n, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER, 23, 'exponent') && (!isFinite(n) || i > MAX_SAFE_INTEGER && (n /= 0) || parseFloat(n) != n && (n = NaN, true)) || n == 0) {
                k = Math.pow(+x, n);
                return new BigNumber(m ? k % m : k);
            }
            if (m) {
                if (n > 1 && x.gt(ONE) && x.isInt() && m.gt(ONE) && m.isInt()) x = x.mod(m);
                else {
                    z = m;
                    // Nullify m so only a single mod operation is performed at the end.
                    m = null;
                }
            } else if (POW_PRECISION) // Truncating each coefficient array to a length of k after each multiplication
            // equates to truncating significant digits to POW_PRECISION + [28, 41],
            // i.e. there will be a minimum of 28 guard digits retained.
            // (Using + 1.5 would give [9, 21] guard digits.)
            k = mathceil(POW_PRECISION / LOG_BASE + 2);
            y = new BigNumber(ONE);
            for(;;){
                if (i % 2) {
                    y = y.times(x);
                    if (!y.c) break;
                    if (k) {
                        if (y.c.length > k) y.c.length = k;
                    } else if (m) y = y.mod(m);
                }
                i = mathfloor(i / 2);
                if (!i) break;
                x = x.times(x);
                if (k) {
                    if (x.c && x.c.length > k) x.c.length = k;
                } else if (m) x = x.mod(m);
            }
            if (m) return y;
            if (n < 0) y = ONE.div(y);
            return z ? y.mod(z) : k ? round(y, POW_PRECISION, ROUNDING_MODE) : y;
        };
        /*
         * Return a string representing the value of this BigNumber rounded to sd significant digits
         * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
         * necessary to represent the integer part of the value in fixed-point notation, then use
         * exponential notation.
         *
         * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
         * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
         *
         * 'toPrecision() precision not an integer: {sd}'
         * 'toPrecision() precision out of range: {sd}'
         * 'toPrecision() rounding mode not an integer: {rm}'
         * 'toPrecision() rounding mode out of range: {rm}'
         */ P.toPrecision = function(sd, rm) {
            return format(this, sd != null && isValidInt(sd, 1, MAX, 24, 'precision') ? sd | 0 : null, rm, 24);
        };
        /*
         * Return a string representing the value of this BigNumber in base b, or base 10 if b is
         * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
         * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
         * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
         * TO_EXP_NEG, return exponential notation.
         *
         * [b] {number} Integer, 2 to 64 inclusive.
         *
         * 'toString() base not an integer: {b}'
         * 'toString() base out of range: {b}'
         */ P.toString = function(b) {
            var str, n = this, s = n.s, e = n.e;
            // Infinity or NaN?
            if (e === null) {
                if (s) {
                    str = 'Infinity';
                    if (s < 0) str = '-' + str;
                } else str = 'NaN';
            } else {
                str = coeffToString(n.c);
                if (b == null || !isValidInt(b, 2, 64, 25, 'base')) str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(str, e) : toFixedPoint(str, e);
                else str = convertBase(toFixedPoint(str, e), b | 0, 10, s);
                if (s < 0 && n.c[0]) str = '-' + str;
            }
            return str;
        };
        /*
         * Return a new BigNumber whose value is the value of this BigNumber truncated to a whole
         * number.
         */ P.truncated = P.trunc = function() {
            return round(new BigNumber(this), this.e + 1, 1);
        };
        /*
         * Return as toString, but do not accept a base argument, and include the minus sign for
         * negative zero.
         */ P.valueOf = P.toJSON = function() {
            var str, n = this, e = n.e;
            if (e === null) return n.toString();
            str = coeffToString(n.c);
            str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(str, e) : toFixedPoint(str, e);
            return n.s < 0 ? '-' + str : str;
        };
        P.isBigNumber = true;
        if (config != null) BigNumber.config(config);
        return BigNumber;
    }
    // PRIVATE HELPER FUNCTIONS
    function bitFloor(n) {
        var i = n | 0;
        return n > 0 || n === i ? i : i - 1;
    }
    // Return a coefficient array as a string of base 10 digits.
    function coeffToString(a) {
        var s, z, i = 1, j = a.length, r = a[0] + '';
        for(; i < j;){
            s = a[i++] + '';
            z = LOG_BASE - s.length;
            for(; z--; s = '0' + s);
            r += s;
        }
        // Determine trailing zeros.
        for(j = r.length; r.charCodeAt(--j) === 48;);
        return r.slice(0, j + 1 || 1);
    }
    // Compare the value of BigNumbers x and y.
    function compare(x, y) {
        var a, b, xc = x.c, yc = y.c, i = x.s, j = y.s, k = x.e, l = y.e;
        // Either NaN?
        if (!i || !j) return null;
        a = xc && !xc[0];
        b = yc && !yc[0];
        // Either zero?
        if (a || b) return a ? b ? 0 : -j : i;
        // Signs differ?
        if (i != j) return i;
        a = i < 0;
        b = k == l;
        // Either Infinity?
        if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;
        // Compare exponents.
        if (!b) return k > l ^ a ? 1 : -1;
        j = (k = xc.length) < (l = yc.length) ? k : l;
        // Compare digit by digit.
        for(i = 0; i < j; i++)if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;
        // Compare lengths.
        return k == l ? 0 : k > l ^ a ? 1 : -1;
    }
    /*
     * Return true if n is a valid number in range, otherwise false.
     * Use for argument validation when ERRORS is false.
     * Note: parseInt('1e+1') == 1 but parseFloat('1e+1') == 10.
     */ function intValidatorNoErrors(n, min, max) {
        return (n = truncate(n)) >= min && n <= max;
    }
    function isArray(obj) {
        return Object.prototype.toString.call(obj) == '[object Array]';
    }
    /*
     * Convert string of baseIn to an array of numbers of baseOut.
     * Eg. convertBase('255', 10, 16) returns [15, 15].
     * Eg. convertBase('ff', 16, 10) returns [2, 5, 5].
     */ function toBaseOut(str, baseIn, baseOut) {
        var j, arr = [
            0
        ], arrL, i = 0, len = str.length;
        for(; i < len;){
            for(arrL = arr.length; arrL--; arr[arrL] *= baseIn);
            arr[j = 0] += ALPHABET.indexOf(str.charAt(i++));
            for(; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                if (arr[j + 1] == null) arr[j + 1] = 0;
                arr[j + 1] += arr[j] / baseOut | 0;
                arr[j] %= baseOut;
            }
        }
        return arr.reverse();
    }
    function toExponential(str, e) {
        return (str.length > 1 ? str.charAt(0) + '.' + str.slice(1) : str) + (e < 0 ? 'e' : 'e+') + e;
    }
    function toFixedPoint(str, e) {
        var len, z;
        // Negative exponent?
        if (e < 0) {
            // Prepend zeros.
            for(z = '0.'; ++e; z += '0');
            str = z + str;
        // Positive exponent
        } else {
            len = str.length;
            // Append zeros.
            if (++e > len) {
                for(z = '0', e -= len; --e; z += '0');
                str += z;
            } else if (e < len) str = str.slice(0, e) + '.' + str.slice(e);
        }
        return str;
    }
    function truncate(n) {
        n = parseFloat(n);
        return n < 0 ? mathceil(n) : mathfloor(n);
    }
    // EXPORT
    BigNumber = constructorFactory();
    BigNumber['default'] = BigNumber.BigNumber = BigNumber;
    // AMD.
    if (typeof define == 'function' && define.amd) define(function() {
        return BigNumber;
    });
    else if (module.exports) module.exports = BigNumber;
    else {
        if (!globalObj) globalObj = typeof self != 'undefined' ? self : Function('return this')();
        globalObj.BigNumber = BigNumber;
    }
})(module.exports);

});

parcelRegister("7LIhW", function(module, exports) {

$parcel$export(module.exports, "override", function () { return (parcelRequire("02k2L")).default; });
$parcel$export(module.exports, "deprecate", function () { return (parcelRequire("dBtor")).default; });
$parcel$export(module.exports, "deprecated", function () { return (parcelRequire("dBtor")).default; });
$parcel$export(module.exports, "suppressWarnings", function () { return (parcelRequire("79jIH")).default; });
$parcel$export(module.exports, "memoize", function () { return (parcelRequire("8XHaK")).default; });
$parcel$export(module.exports, "autobind", function () { return (parcelRequire("bQguj")).default; });
$parcel$export(module.exports, "readonly", function () { return (parcelRequire("a0oRn")).default; });
$parcel$export(module.exports, "enumerable", function () { return (parcelRequire("5Ztx3")).default; });
$parcel$export(module.exports, "nonenumerable", function () { return (parcelRequire("f7ua8")).default; });
$parcel$export(module.exports, "nonconfigurable", function () { return (parcelRequire("4ORVA")).default; });
$parcel$export(module.exports, "debounce", function () { return (parcelRequire("hT4iv")).default; });
$parcel$export(module.exports, "throttle", function () { return (parcelRequire("fJBHf")).default; });
$parcel$export(module.exports, "decorate", function () { return (parcelRequire("c2p24")).default; });
$parcel$export(module.exports, "mixin", function () { return (parcelRequire("cOmNC")).default; });
$parcel$export(module.exports, "mixins", function () { return (parcelRequire("cOmNC")).default; });
$parcel$export(module.exports, "lazyInitialize", function () { return (parcelRequire("aLcoM")).default; });
$parcel$export(module.exports, "time", function () { return (parcelRequire("fZGAn")).default; });
$parcel$export(module.exports, "extendDescriptor", function () { return (parcelRequire("kYbIs")).default; });
$parcel$export(module.exports, "profile", function () { return (parcelRequire("eddlU")).default; });
$parcel$export(module.exports, "applyDecorators", function () { return (parcelRequire("gv1bL")).default; });
/**
 * core-decorators.js
 * (c) 2017 Jay Phelps and contributors
 * MIT Licensed
 * https://github.com/jayphelps/core-decorators.js
 * @license
 */ 
var $02k2L = parcelRequire("02k2L");

var $dBtor = parcelRequire("dBtor");

var $79jIH = parcelRequire("79jIH");

var $8XHaK = parcelRequire("8XHaK");

var $bQguj = parcelRequire("bQguj");

var $a0oRn = parcelRequire("a0oRn");

var $5Ztx3 = parcelRequire("5Ztx3");

var $f7ua8 = parcelRequire("f7ua8");

var $4ORVA = parcelRequire("4ORVA");

var $hT4iv = parcelRequire("hT4iv");

var $fJBHf = parcelRequire("fJBHf");

var $c2p24 = parcelRequire("c2p24");

var $cOmNC = parcelRequire("cOmNC");

var $aLcoM = parcelRequire("aLcoM");

var $fZGAn = parcelRequire("fZGAn");

var $kYbIs = parcelRequire("kYbIs");

var $eddlU = parcelRequire("eddlU");

var $gv1bL = parcelRequire("gv1bL");

});
parcelRegister("02k2L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $006fbc4802f2b530$export$2e2bcd8739ae039; });

var $12cFS = parcelRequire("12cFS");
var $006fbc4802f2b530$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $006fbc4802f2b530$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $006fbc4802f2b530$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $006fbc4802f2b530$var$GENERIC_FUNCTION_ERROR = '{child} does not properly override {parent}';
var $006fbc4802f2b530$var$FUNCTION_REGEXP = /^function ([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?(\([^\)]*\))[\s\S]+$/;
var $006fbc4802f2b530$var$SyntaxErrorReporter = function() {
    $006fbc4802f2b530$var$_createClass(SyntaxErrorReporter, [
        {
            key: '_getTopic',
            value: function _getTopic(descriptor) {
                if (descriptor === undefined) return null;
                if ('value' in descriptor) return descriptor.value;
                if ('get' in descriptor) return descriptor.get;
                if ('set' in descriptor) return descriptor.set;
            }
        },
        {
            key: '_extractTopicSignature',
            value: function _extractTopicSignature(topic) {
                switch(typeof topic === 'undefined' ? 'undefined' : $006fbc4802f2b530$var$_typeof(topic)){
                    case 'function':
                        return this._extractFunctionSignature(topic);
                    default:
                        return this.key;
                }
            }
        },
        {
            key: '_extractFunctionSignature',
            value: function _extractFunctionSignature(fn) {
                var _this = this;
                return fn.toString().replace($006fbc4802f2b530$var$FUNCTION_REGEXP, function(match) {
                    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.key;
                    var params = arguments[2];
                    return name + params;
                });
            }
        },
        {
            key: 'key',
            get: function get() {
                return this.childDescriptor.key;
            }
        },
        {
            key: 'parentNotation',
            get: function get() {
                return this.parentKlass.constructor.name + '#' + this.parentPropertySignature;
            }
        },
        {
            key: 'childNotation',
            get: function get() {
                return this.childKlass.constructor.name + '#' + this.childPropertySignature;
            }
        },
        {
            key: 'parentTopic',
            get: function get() {
                return this._getTopic(this.parentDescriptor);
            }
        },
        {
            key: 'childTopic',
            get: function get() {
                return this._getTopic(this.childDescriptor);
            }
        },
        {
            key: 'parentPropertySignature',
            get: function get() {
                return this._extractTopicSignature(this.parentTopic);
            }
        },
        {
            key: 'childPropertySignature',
            get: function get() {
                return this._extractTopicSignature(this.childTopic);
            }
        }
    ]);
    function SyntaxErrorReporter(parentKlass, childKlass, parentDescriptor, childDescriptor) {
        $006fbc4802f2b530$var$_classCallCheck(this, SyntaxErrorReporter);
        this.parentKlass = parentKlass;
        this.childKlass = childKlass;
        this.parentDescriptor = parentDescriptor;
        this.childDescriptor = childDescriptor;
    }
    $006fbc4802f2b530$var$_createClass(SyntaxErrorReporter, [
        {
            key: 'assert',
            value: function assert(condition) {
                var msg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
                if (condition !== true) this.error($006fbc4802f2b530$var$GENERIC_FUNCTION_ERROR + msg);
            }
        },
        {
            key: 'error',
            value: function error(msg) {
                var _this2 = this;
                msg = msg// Replace lazily, because they actually might not
                // be available in all cases
                .replace('{parent}', function(m) {
                    return _this2.parentNotation;
                }).replace('{child}', function(m) {
                    return _this2.childNotation;
                });
                throw new SyntaxError(msg);
            }
        }
    ]);
    return SyntaxErrorReporter;
}();
function $006fbc4802f2b530$var$getDescriptorType(descriptor) {
    if (descriptor.hasOwnProperty('value')) return 'data';
    if (descriptor.hasOwnProperty('get') || descriptor.hasOwnProperty('set')) return 'accessor';
    // If none of them exist, browsers treat it as
    // a data descriptor with a value of `undefined`
    return 'data';
}
function $006fbc4802f2b530$var$checkFunctionSignatures(parent, child, reporter) {
    reporter.assert(parent.length === child.length);
}
function $006fbc4802f2b530$var$checkDataDescriptors(parent, child, reporter) {
    var parentValueType = $006fbc4802f2b530$var$_typeof(parent.value);
    var childValueType = $006fbc4802f2b530$var$_typeof(child.value);
    if (parentValueType === 'undefined' && childValueType === 'undefined') // class properties can be any expression, which isn't ran until the
    // the instance is created, so we can't reliably get type information
    // for them yet (per spec). Perhaps when Babel includes flow-type info
    // in runtime? Tried regex solutions, but super hacky and only feasible
    // on primitives, which is confusing for usage...
    reporter.error('descriptor values are both undefined. (class properties are are not currently supported)\'');
    if (parentValueType !== childValueType) {
        var isFunctionOverUndefined = childValueType === 'function' && parentValueType === undefined;
        // Even though we don't support class properties, this
        // will still handle more than just functions, just in case.
        // Shadowing an undefined value is an error if the inherited
        // value was undefined (usually a class property, not a method)
        if (isFunctionOverUndefined || parentValueType !== undefined) reporter.error('value types do not match. {parent} is "' + parentValueType + '", {child} is "' + childValueType + '"');
    }
    // Switch, in preparation for supporting more types
    switch(childValueType){
        case 'function':
            $006fbc4802f2b530$var$checkFunctionSignatures(parent.value, child.value, reporter);
            break;
        default:
            reporter.error('Unexpected error. Please file a bug with: {parent} is "' + parentValueType + '", {child} is "' + childValueType + '"');
            break;
    }
}
function $006fbc4802f2b530$var$checkAccessorDescriptors(parent, child, reporter) {
    var parentHasGetter = typeof parent.get === 'function';
    var childHasGetter = typeof child.get === 'function';
    var parentHasSetter = typeof parent.set === 'function';
    var childHasSetter = typeof child.set === 'function';
    if (parentHasGetter || childHasGetter) {
        if (!parentHasGetter && parentHasSetter) reporter.error('{parent} is setter but {child} is getter');
        if (!childHasGetter && childHasSetter) reporter.error('{parent} is getter but {child} is setter');
        $006fbc4802f2b530$var$checkFunctionSignatures(parent.get, child.get, reporter);
    }
    if (parentHasSetter || childHasSetter) {
        if (!parentHasSetter && parentHasGetter) reporter.error('{parent} is getter but {child} is setter');
        if (!childHasSetter && childHasGetter) reporter.error('{parent} is setter but {child} is getter');
        $006fbc4802f2b530$var$checkFunctionSignatures(parent.set, child.set, reporter);
    }
}
function $006fbc4802f2b530$var$checkDescriptors(parent, child, reporter) {
    var parentType = $006fbc4802f2b530$var$getDescriptorType(parent);
    var childType = $006fbc4802f2b530$var$getDescriptorType(child);
    if (parentType !== childType) reporter.error('descriptor types do not match. {parent} is "' + parentType + '", {child} is "' + childType + '"');
    switch(childType){
        case 'data':
            $006fbc4802f2b530$var$checkDataDescriptors(parent, child, reporter);
            break;
        case 'accessor':
            $006fbc4802f2b530$var$checkAccessorDescriptors(parent, child, reporter);
            break;
    }
}
var $006fbc4802f2b530$var$suggestionTransforms = [
    function(key) {
        return key.toLowerCase();
    },
    function(key) {
        return key.toUpperCase();
    },
    function(key) {
        return key + 's';
    },
    function(key) {
        return key.slice(0, -1);
    },
    function(key) {
        return key.slice(1, key.length);
    }
];
function $006fbc4802f2b530$var$findPossibleAlternatives(superKlass, key) {
    for(var i = 0, l = $006fbc4802f2b530$var$suggestionTransforms.length; i < l; i++){
        var fn = $006fbc4802f2b530$var$suggestionTransforms[i];
        var suggestion = fn(key);
        if (suggestion in superKlass) return suggestion;
    }
    return null;
}
function $006fbc4802f2b530$var$handleDescriptor(target, key, descriptor) {
    descriptor.key = key;
    var superKlass = Object.getPrototypeOf(target);
    var superDescriptor = Object.getOwnPropertyDescriptor(superKlass, key);
    var reporter = new $006fbc4802f2b530$var$SyntaxErrorReporter(superKlass, target, superDescriptor, descriptor);
    if (superDescriptor === undefined) {
        var suggestedKey = $006fbc4802f2b530$var$findPossibleAlternatives(superKlass, key);
        var suggestion = suggestedKey ? '\n\n  Did you mean "' + suggestedKey + '"?' : '';
        reporter.error('No descriptor matching {child} was found on the prototype chain.' + suggestion);
    }
    $006fbc4802f2b530$var$checkDescriptors(superDescriptor, descriptor, reporter);
    return descriptor;
}
function $006fbc4802f2b530$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $12cFS.decorate)($006fbc4802f2b530$var$handleDescriptor, args);
}

});
parcelRegister("12cFS", function(module, exports) {

$parcel$export(module.exports, "decorate", function () { return $0c0fcf3ee96d0033$export$c80826d3392ea781; });
$parcel$export(module.exports, "metaFor", function () { return $0c0fcf3ee96d0033$export$80cb9ae906a6980a; });
$parcel$export(module.exports, "getOwnKeys", function () { return $0c0fcf3ee96d0033$export$d4d350286644e474; });
$parcel$export(module.exports, "getOwnPropertyDescriptors", function () { return $0c0fcf3ee96d0033$export$cea84f72459ece05; });
$parcel$export(module.exports, "createDefaultSetter", function () { return $0c0fcf3ee96d0033$export$91fd6b508048524d; });
$parcel$export(module.exports, "bind", function () { return $0c0fcf3ee96d0033$export$2385a24977818dd0; });
$parcel$export(module.exports, "warn", function () { return $0c0fcf3ee96d0033$export$c106dd0671a0fc2d; });
$parcel$export(module.exports, "internalDeprecation", function () { return $0c0fcf3ee96d0033$export$9777dce9403baef9; });

var $aLcoM = parcelRequire("aLcoM");
var $0c0fcf3ee96d0033$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $0c0fcf3ee96d0033$var$_desc, $0c0fcf3ee96d0033$var$_value, $0c0fcf3ee96d0033$var$_class, $0c0fcf3ee96d0033$var$_descriptor, $0c0fcf3ee96d0033$var$_descriptor2, $0c0fcf3ee96d0033$var$_descriptor3, $0c0fcf3ee96d0033$var$_descriptor4, $0c0fcf3ee96d0033$var$_descriptor5;
function $0c0fcf3ee96d0033$var$_initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;
    Object.defineProperty(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}
function $0c0fcf3ee96d0033$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0c0fcf3ee96d0033$var$_applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object["keys"](descriptor).forEach(function(key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) desc.writable = true;
    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object["defineProperty"](target, property, desc);
        desc = null;
    }
    return desc;
}
function $0c0fcf3ee96d0033$var$_initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}
function $0c0fcf3ee96d0033$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
var $0c0fcf3ee96d0033$var$defineProperty = Object.defineProperty, $0c0fcf3ee96d0033$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, $0c0fcf3ee96d0033$var$getOwnPropertyNames = Object.getOwnPropertyNames, $0c0fcf3ee96d0033$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
function $0c0fcf3ee96d0033$export$bbeba8ee9bc10f0d(desc) {
    if (!desc || !desc.hasOwnProperty) return false;
    var keys = [
        'value',
        'initializer',
        'get',
        'set'
    ];
    for(var i = 0, l = keys.length; i < l; i++){
        if (desc.hasOwnProperty(keys[i])) return true;
    }
    return false;
}
function $0c0fcf3ee96d0033$export$c80826d3392ea781(handleDescriptor, entryArgs) {
    if ($0c0fcf3ee96d0033$export$bbeba8ee9bc10f0d(entryArgs[entryArgs.length - 1])) return handleDescriptor.apply(undefined, $0c0fcf3ee96d0033$var$_toConsumableArray(entryArgs).concat([
        []
    ]));
    else return function() {
        return handleDescriptor.apply(undefined, $0c0fcf3ee96d0033$var$_toConsumableArray(Array.prototype.slice.call(arguments)).concat([
            entryArgs
        ]));
    };
}
var $0c0fcf3ee96d0033$var$Meta = ($0c0fcf3ee96d0033$var$_class = function Meta() {
    $0c0fcf3ee96d0033$var$_classCallCheck(this, Meta);
    $0c0fcf3ee96d0033$var$_initDefineProp(this, 'debounceTimeoutIds', $0c0fcf3ee96d0033$var$_descriptor, this);
    $0c0fcf3ee96d0033$var$_initDefineProp(this, 'throttleTimeoutIds', $0c0fcf3ee96d0033$var$_descriptor2, this);
    $0c0fcf3ee96d0033$var$_initDefineProp(this, 'throttlePreviousTimestamps', $0c0fcf3ee96d0033$var$_descriptor3, this);
    $0c0fcf3ee96d0033$var$_initDefineProp(this, 'throttleTrailingArgs', $0c0fcf3ee96d0033$var$_descriptor4, this);
    $0c0fcf3ee96d0033$var$_initDefineProp(this, 'profileLastRan', $0c0fcf3ee96d0033$var$_descriptor5, this);
}, $0c0fcf3ee96d0033$var$_descriptor = $0c0fcf3ee96d0033$var$_applyDecoratedDescriptor($0c0fcf3ee96d0033$var$_class.prototype, 'debounceTimeoutIds', [
    (0, $aLcoM.default)
], {
    enumerable: true,
    initializer: function initializer() {
        return {};
    }
}), $0c0fcf3ee96d0033$var$_descriptor2 = $0c0fcf3ee96d0033$var$_applyDecoratedDescriptor($0c0fcf3ee96d0033$var$_class.prototype, 'throttleTimeoutIds', [
    (0, $aLcoM.default)
], {
    enumerable: true,
    initializer: function initializer() {
        return {};
    }
}), $0c0fcf3ee96d0033$var$_descriptor3 = $0c0fcf3ee96d0033$var$_applyDecoratedDescriptor($0c0fcf3ee96d0033$var$_class.prototype, 'throttlePreviousTimestamps', [
    (0, $aLcoM.default)
], {
    enumerable: true,
    initializer: function initializer() {
        return {};
    }
}), $0c0fcf3ee96d0033$var$_descriptor4 = $0c0fcf3ee96d0033$var$_applyDecoratedDescriptor($0c0fcf3ee96d0033$var$_class.prototype, 'throttleTrailingArgs', [
    (0, $aLcoM.default)
], {
    enumerable: true,
    initializer: function initializer() {
        return null;
    }
}), $0c0fcf3ee96d0033$var$_descriptor5 = $0c0fcf3ee96d0033$var$_applyDecoratedDescriptor($0c0fcf3ee96d0033$var$_class.prototype, 'profileLastRan', [
    (0, $aLcoM.default)
], {
    enumerable: true,
    initializer: function initializer() {
        return null;
    }
}), $0c0fcf3ee96d0033$var$_class);
var $0c0fcf3ee96d0033$var$META_KEY = typeof Symbol === 'function' ? Symbol('__core_decorators__') : '__core_decorators__';
function $0c0fcf3ee96d0033$export$80cb9ae906a6980a(obj) {
    if (obj.hasOwnProperty($0c0fcf3ee96d0033$var$META_KEY) === false) $0c0fcf3ee96d0033$var$defineProperty(obj, $0c0fcf3ee96d0033$var$META_KEY, {
        // Defaults: NOT enumerable, configurable, or writable
        value: new $0c0fcf3ee96d0033$var$Meta()
    });
    return obj[$0c0fcf3ee96d0033$var$META_KEY];
}
var $0c0fcf3ee96d0033$export$d4d350286644e474 = $0c0fcf3ee96d0033$var$getOwnPropertySymbols ? function(object) {
    return $0c0fcf3ee96d0033$var$getOwnPropertyNames(object).concat($0c0fcf3ee96d0033$var$getOwnPropertySymbols(object));
} : $0c0fcf3ee96d0033$var$getOwnPropertyNames;
function $0c0fcf3ee96d0033$export$cea84f72459ece05(obj) {
    var descs = {};
    $0c0fcf3ee96d0033$export$d4d350286644e474(obj).forEach(function(key) {
        return descs[key] = $0c0fcf3ee96d0033$var$getOwnPropertyDescriptor(obj, key);
    });
    return descs;
}
function $0c0fcf3ee96d0033$export$91fd6b508048524d(key) {
    return function set(newValue) {
        Object.defineProperty(this, key, {
            configurable: true,
            writable: true,
            // IS enumerable when reassigned by the outside word
            enumerable: true,
            value: newValue
        });
        return newValue;
    };
}
function $0c0fcf3ee96d0033$export$2385a24977818dd0(fn, context) {
    if (fn.bind) return fn.bind(context);
    else return function __autobind__() {
        return fn.apply(context, arguments);
    };
}
var $0c0fcf3ee96d0033$export$c106dd0671a0fc2d = function() {
    if ((typeof console === 'undefined' ? 'undefined' : $0c0fcf3ee96d0033$var$_typeof(console)) !== 'object' || !console || typeof console.warn !== 'function') return function() {};
    else return $0c0fcf3ee96d0033$export$2385a24977818dd0(console.warn, console);
}();
var $0c0fcf3ee96d0033$var$seenDeprecations = {};
function $0c0fcf3ee96d0033$export$9777dce9403baef9(msg) {
    if ($0c0fcf3ee96d0033$var$seenDeprecations[msg] !== true) {
        $0c0fcf3ee96d0033$var$seenDeprecations[msg] = true;
        $0c0fcf3ee96d0033$export$c106dd0671a0fc2d('DEPRECATION: ' + msg);
    }
}

});
parcelRegister("aLcoM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d57e94802ec511d$export$2e2bcd8739ae039; });

var $12cFS = parcelRequire("12cFS");
var $7d57e94802ec511d$var$defineProperty = Object.defineProperty;
function $7d57e94802ec511d$var$handleDescriptor(target, key, descriptor) {
    var configurable = descriptor.configurable, enumerable = descriptor.enumerable, initializer = descriptor.initializer, value = descriptor.value;
    return {
        configurable: configurable,
        enumerable: enumerable,
        get: function get() {
            // This happens if someone accesses the
            // property directly on the prototype
            if (this === target) return;
            var ret = initializer ? initializer.call(this) : value;
            $7d57e94802ec511d$var$defineProperty(this, key, {
                configurable: configurable,
                enumerable: enumerable,
                writable: true,
                value: ret
            });
            return ret;
        },
        set: (0, $12cFS.createDefaultSetter)(key)
    };
}
function $7d57e94802ec511d$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $12cFS.decorate)($7d57e94802ec511d$var$handleDescriptor, args);
}

});



parcelRegister("dBtor", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e7587f58599021a$export$2e2bcd8739ae039; });

var $12cFS = parcelRequire("12cFS");
var $9e7587f58599021a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $9e7587f58599021a$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();
var $9e7587f58599021a$var$DEFAULT_MSG = 'This function will be removed in future versions.';
function $9e7587f58599021a$var$handleDescriptor(target, key, descriptor, _ref) {
    var _ref2 = $9e7587f58599021a$var$_slicedToArray(_ref, 2), _ref2$ = _ref2[0], msg = _ref2$ === undefined ? $9e7587f58599021a$var$DEFAULT_MSG : _ref2$, _ref2$2 = _ref2[1], options = _ref2$2 === undefined ? {} : _ref2$2;
    if (typeof descriptor.value !== 'function') throw new SyntaxError('Only functions can be marked as deprecated');
    var methodSignature = target.constructor.name + '#' + key;
    if (options.url) msg += '\n\n    See ' + options.url + ' for more details.\n\n';
    return $9e7587f58599021a$var$_extends({}, descriptor, {
        value: function deprecationWrapper() {
            (0, $12cFS.warn)('DEPRECATION ' + methodSignature + ': ' + msg);
            return descriptor.value.apply(this, arguments);
        }
    });
}
function $9e7587f58599021a$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $12cFS.decorate)($9e7587f58599021a$var$handleDescriptor, args);
}

});

parcelRegister("79jIH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5348ab9fdd7920bf$export$2e2bcd8739ae039; });

var $12cFS = parcelRequire("12cFS");
var $5348ab9fdd7920bf$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $5348ab9fdd7920bf$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $5348ab9fdd7920bf$var$suppressedWarningNoop() {
// Warnings are currently suppressed via @suppressWarnings
}
function $5348ab9fdd7920bf$var$applyWithoutWarnings(context, fn, args) {
    if ((typeof console === 'undefined' ? 'undefined' : $5348ab9fdd7920bf$var$_typeof(console)) === 'object') {
        var nativeWarn = console.warn;
        console.warn = $5348ab9fdd7920bf$var$suppressedWarningNoop;
        var ret = fn.apply(context, args);
        console.warn = nativeWarn;
        return ret;
    } else return fn.apply(context, args);
}
function $5348ab9fdd7920bf$var$handleDescriptor(target, key, descriptor) {
    return $5348ab9fdd7920bf$var$_extends({}, descriptor, {
        value: function suppressWarningsWrapper() {
            return $5348ab9fdd7920bf$var$applyWithoutWarnings(this, descriptor.value, arguments);
        }
    });
}
function $5348ab9fdd7920bf$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $12cFS.decorate)($5348ab9fdd7920bf$var$handleDescriptor, args);
}

});

parcelRegister("8XHaK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68655286849297bf$export$2e2bcd8739ae039; });

var $12cFS = parcelRequire("12cFS");
var $68655286849297bf$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $68655286849297bf$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $68655286849297bf$var$toObject(cache, value) {
    if (value === Object(value)) return value;
    return cache[value] || (cache[value] = {});
}
function $68655286849297bf$var$applyAndCache(context, fn, args, cache, signature) {
    var ret = fn.apply(context, args);
    cache[signature] = ret;
    return ret;
}
function $68655286849297bf$var$metaForDescriptor(descriptor) {
    var fn = void 0, wrapKey = void 0;
    // This is ugly code, but way faster than other
    // ways I tried that *looked* pretty
    if (descriptor.value) {
        fn = descriptor.value;
        wrapKey = 'value';
    } else if (descriptor.get) {
        fn = descriptor.get;
        wrapKey = 'get';
    } else if (descriptor.set) {
        fn = descriptor.set;
        wrapKey = 'set';
    }
    return {
        fn: fn,
        wrapKey: wrapKey
    };
}
function $68655286849297bf$var$handleDescriptor(target, key, descriptor) {
    var _metaForDescriptor = $68655286849297bf$var$metaForDescriptor(descriptor), fn = _metaForDescriptor.fn, wrapKey = _metaForDescriptor.wrapKey;
    var argumentCache = new WeakMap();
    var signatureCache = Object.create(null);
    var primativeRefCache = Object.create(null);
    var argumentIdCounter = 0;
    return $68655286849297bf$var$_extends({}, descriptor, $68655286849297bf$var$_defineProperty({}, wrapKey, function memoizeWrapper() {
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var signature = '0';
        for(var i = 0, l = args.length; i < l; i++){
            var arg = args[i];
            var argRef = $68655286849297bf$var$toObject(primativeRefCache, arg);
            var argKey = argumentCache.get(argRef);
            if (argKey === undefined) {
                argKey = ++argumentIdCounter;
                argumentCache.set(argRef, argKey);
            }
            signature += argKey;
        }
        return signatureCache[signature] || $68655286849297bf$var$applyAndCache(this, fn, arguments, signatureCache, signature);
    }));
}
function $68655286849297bf$export$2e2bcd8739ae039() {
    (0, $12cFS.internalDeprecation)('@memoize is deprecated and will be removed shortly. Use @memoize from lodash-decorators.\n\n  https://www.npmjs.com/package/lodash-decorators');
    for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    return (0, $12cFS.decorate)($68655286849297bf$var$handleDescriptor, args);
}

});

parcelRegister("bQguj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89f1573704d05356$export$2e2bcd8739ae039; });

var $12cFS = parcelRequire("12cFS");
function $89f1573704d05356$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
var $89f1573704d05356$var$defineProperty = Object.defineProperty, $89f1573704d05356$var$getPrototypeOf = Object.getPrototypeOf;
var $89f1573704d05356$var$mapStore = void 0;
function $89f1573704d05356$var$getBoundSuper(obj, fn) {
    if (typeof WeakMap === 'undefined') throw new Error('Using @autobind on ' + fn.name + '() requires WeakMap support due to its use of super.' + fn.name + '()\n      See https://github.com/jayphelps/core-decorators.js/issues/20');
    if (!$89f1573704d05356$var$mapStore) $89f1573704d05356$var$mapStore = new WeakMap();
    if ($89f1573704d05356$var$mapStore.has(obj) === false) $89f1573704d05356$var$mapStore.set(obj, new WeakMap());
    var superStore = $89f1573704d05356$var$mapStore.get(obj);
    if (superStore.has(fn) === false) superStore.set(fn, (0, $12cFS.bind)(fn, obj));
    return superStore.get(fn);
}
function $89f1573704d05356$var$autobindClass(klass) {
    var descs = (0, $12cFS.getOwnPropertyDescriptors)(klass.prototype);
    var keys = (0, $12cFS.getOwnKeys)(descs);
    for(var i = 0, l = keys.length; i < l; i++){
        var key = keys[i];
        var desc = descs[key];
        if (typeof desc.value !== 'function' || key === 'constructor') continue;
        $89f1573704d05356$var$defineProperty(klass.prototype, key, $89f1573704d05356$var$autobindMethod(klass.prototype, key, desc));
    }
}
function $89f1573704d05356$var$autobindMethod(target, key, _ref) {
    var fn = _ref.value, configurable = _ref.configurable, enumerable = _ref.enumerable;
    if (typeof fn !== 'function') throw new SyntaxError('@autobind can only be used on functions, not: ' + fn);
    var constructor = target.constructor;
    return {
        configurable: configurable,
        enumerable: enumerable,
        get: function get() {
            // Class.prototype.key lookup
            // Someone accesses the property directly on the prototype on which it is
            // actually defined on, i.e. Class.prototype.hasOwnProperty(key)
            if (this === target) return fn;
            // Class.prototype.key lookup
            // Someone accesses the property directly on a prototype but it was found
            // up the chain, not defined directly on it
            // i.e. Class.prototype.hasOwnProperty(key) == false && key in Class.prototype
            if (this.constructor !== constructor && $89f1573704d05356$var$getPrototypeOf(this).constructor === constructor) return fn;
            // Autobound method calling super.sameMethod() which is also autobound and so on.
            if (this.constructor !== constructor && key in this.constructor.prototype) return $89f1573704d05356$var$getBoundSuper(this, fn);
            var boundFn = (0, $12cFS.bind)(fn, this);
            $89f1573704d05356$var$defineProperty(this, key, {
                configurable: true,
                writable: true,
                // NOT enumerable when it's a bound method
                enumerable: false,
                value: boundFn
            });
            return boundFn;
        },
        set: (0, $12cFS.createDefaultSetter)(key)
    };
}
function $89f1573704d05356$var$handle(args) {
    if (args.length === 1) return $89f1573704d05356$var$autobindClass.apply(undefined, $89f1573704d05356$var$_toConsumableArray(args));
    else return $89f1573704d05356$var$autobindMethod.apply(undefined, $89f1573704d05356$var$_toConsumableArray(args));
}
function $89f1573704d05356$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if (args.length === 0) return function() {
        return $89f1573704d05356$var$handle(arguments);
    };
    else return $89f1573704d05356$var$handle(args);
}

});

parcelRegister("a0oRn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $748d30210aec0f10$export$2e2bcd8739ae039; });

var $12cFS = parcelRequire("12cFS");
function $748d30210aec0f10$var$handleDescriptor(target, key, descriptor) {
    descriptor.writable = false;
    return descriptor;
}
function $748d30210aec0f10$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $12cFS.decorate)($748d30210aec0f10$var$handleDescriptor, args);
}

});

parcelRegister("5Ztx3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45c98eb7a4bb8442$export$2e2bcd8739ae039; });

var $12cFS = parcelRequire("12cFS");
function $45c98eb7a4bb8442$var$handleDescriptor(target, key, descriptor) {
    descriptor.enumerable = true;
    return descriptor;
}
function $45c98eb7a4bb8442$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $12cFS.decorate)($45c98eb7a4bb8442$var$handleDescriptor, args);
}

});

parcelRegister("f7ua8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b01ee814825a7741$export$2e2bcd8739ae039; });

var $12cFS = parcelRequire("12cFS");
function $b01ee814825a7741$var$handleDescriptor(target, key, descriptor) {
    descriptor.enumerable = false;
    return descriptor;
}
function $b01ee814825a7741$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $12cFS.decorate)($b01ee814825a7741$var$handleDescriptor, args);
}

});

parcelRegister("4ORVA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3825a9e43466d17b$export$2e2bcd8739ae039; });

var $12cFS = parcelRequire("12cFS");
function $3825a9e43466d17b$var$handleDescriptor(target, key, descriptor) {
    descriptor.configurable = false;
    return descriptor;
}
function $3825a9e43466d17b$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $12cFS.decorate)($3825a9e43466d17b$var$handleDescriptor, args);
}

});

parcelRegister("hT4iv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d05ae81e8e98b2fa$export$2e2bcd8739ae039; });

var $12cFS = parcelRequire("12cFS");
var $d05ae81e8e98b2fa$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $d05ae81e8e98b2fa$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();
var $d05ae81e8e98b2fa$var$DEFAULT_TIMEOUT = 300;
function $d05ae81e8e98b2fa$var$handleDescriptor(target, key, descriptor, _ref) {
    var _ref2 = $d05ae81e8e98b2fa$var$_slicedToArray(_ref, 2), _ref2$ = _ref2[0], wait = _ref2$ === undefined ? $d05ae81e8e98b2fa$var$DEFAULT_TIMEOUT : _ref2$, _ref2$2 = _ref2[1], immediate = _ref2$2 === undefined ? false : _ref2$2;
    var callback = descriptor.value;
    if (typeof callback !== 'function') throw new SyntaxError('Only functions can be debounced');
    return $d05ae81e8e98b2fa$var$_extends({}, descriptor, {
        value: function value() {
            var _this = this;
            var _metaFor = (0, $12cFS.metaFor)(this), debounceTimeoutIds = _metaFor.debounceTimeoutIds;
            var timeout = debounceTimeoutIds[key];
            var callNow = immediate && !timeout;
            var args = arguments;
            clearTimeout(timeout);
            debounceTimeoutIds[key] = setTimeout(function() {
                delete debounceTimeoutIds[key];
                if (!immediate) callback.apply(_this, args);
            }, wait);
            if (callNow) callback.apply(this, args);
        }
    });
}
function $d05ae81e8e98b2fa$export$2e2bcd8739ae039() {
    (0, $12cFS.internalDeprecation)('@debounce is deprecated and will be removed shortly. Use @debounce from lodash-decorators.\n\n  https://www.npmjs.com/package/lodash-decorators');
    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $12cFS.decorate)($d05ae81e8e98b2fa$var$handleDescriptor, args);
}

});

parcelRegister("fJBHf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7484cb8cd3fdcad$export$2e2bcd8739ae039; });

var $12cFS = parcelRequire("12cFS");
var $b7484cb8cd3fdcad$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $b7484cb8cd3fdcad$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();
var $b7484cb8cd3fdcad$var$DEFAULT_TIMEOUT = 300;
function $b7484cb8cd3fdcad$var$handleDescriptor(target, key, descriptor, _ref) {
    var _ref2 = $b7484cb8cd3fdcad$var$_slicedToArray(_ref, 2), _ref2$ = _ref2[0], wait = _ref2$ === undefined ? $b7484cb8cd3fdcad$var$DEFAULT_TIMEOUT : _ref2$, _ref2$2 = _ref2[1], options = _ref2$2 === undefined ? {} : _ref2$2;
    var callback = descriptor.value;
    if (typeof callback !== 'function') throw new SyntaxError('Only functions can be throttled');
    if (options.leading !== false) options.leading = true;
    if (options.trailing !== false) options.trailing = true;
    return $b7484cb8cd3fdcad$var$_extends({}, descriptor, {
        value: function value() {
            var _this = this;
            var meta = (0, $12cFS.metaFor)(this);
            var throttleTimeoutIds = meta.throttleTimeoutIds, throttlePreviousTimestamps = meta.throttlePreviousTimestamps;
            var timeout = throttleTimeoutIds[key];
            // last execute timestamp
            var previous = throttlePreviousTimestamps[key] || 0;
            var now = Date.now();
            if (options.trailing) meta.throttleTrailingArgs = arguments;
            // if first be called and disable the execution on the leading edge
            // set last execute timestamp to now
            if (!previous && options.leading === false) previous = now;
            var remaining = wait - (now - previous);
            if (remaining <= 0) {
                clearTimeout(timeout);
                delete throttleTimeoutIds[key];
                throttlePreviousTimestamps[key] = now;
                callback.apply(this, arguments);
            } else if (!timeout && options.trailing) throttleTimeoutIds[key] = setTimeout(function() {
                throttlePreviousTimestamps[key] = options.leading === false ? 0 : Date.now();
                delete throttleTimeoutIds[key];
                callback.apply(_this, meta.throttleTrailingArgs);
                // don't leak memory!
                meta.throttleTrailingArgs = null;
            }, remaining);
        }
    });
}
function $b7484cb8cd3fdcad$export$2e2bcd8739ae039() {
    (0, $12cFS.internalDeprecation)('@throttle is deprecated and will be removed shortly. Use @throttle from lodash-decorators.\n\n  https://www.npmjs.com/package/lodash-decorators');
    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $12cFS.decorate)($b7484cb8cd3fdcad$var$handleDescriptor, args);
}

});

parcelRegister("c2p24", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c3916d68411c33a$export$2e2bcd8739ae039; });

var $12cFS = parcelRequire("12cFS");
function $8c3916d68411c33a$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
function $8c3916d68411c33a$var$_toArray(arr) {
    return Array.isArray(arr) ? arr : Array.from(arr);
}
var $8c3916d68411c33a$var$defineProperty = Object.defineProperty;
function $8c3916d68411c33a$var$handleDescriptor(target, key, descriptor, _ref) {
    var _ref2 = $8c3916d68411c33a$var$_toArray(_ref), decorator = _ref2[0], args = _ref2.slice(1);
    var configurable = descriptor.configurable, enumerable = descriptor.enumerable, writable = descriptor.writable;
    var originalGet = descriptor.get;
    var originalSet = descriptor.set;
    var originalValue = descriptor.value;
    var isGetter = !!originalGet;
    return {
        configurable: configurable,
        enumerable: enumerable,
        get: function get() {
            var fn = isGetter ? originalGet.call(this) : originalValue;
            var value = decorator.call.apply(decorator, [
                this,
                fn
            ].concat($8c3916d68411c33a$var$_toConsumableArray(args)));
            if (isGetter) return value;
            else {
                var desc = {
                    configurable: configurable,
                    enumerable: enumerable
                };
                desc.value = value;
                desc.writable = writable;
                $8c3916d68411c33a$var$defineProperty(this, key, desc);
                return value;
            }
        },
        set: isGetter ? originalSet : (0, $12cFS.createDefaultSetter)()
    };
}
function $8c3916d68411c33a$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $12cFS.decorate)($8c3916d68411c33a$var$handleDescriptor, args);
}

});

parcelRegister("cOmNC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $953bd6ff96435836$export$2e2bcd8739ae039; });

var $12cFS = parcelRequire("12cFS");
var $953bd6ff96435836$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $953bd6ff96435836$var$defineProperty = Object.defineProperty, $953bd6ff96435836$var$getPrototypeOf = Object.getPrototypeOf;
function $953bd6ff96435836$var$buggySymbol(symbol) {
    return Object.prototype.toString.call(symbol) === '[object Symbol]' && (typeof symbol === 'undefined' ? 'undefined' : $953bd6ff96435836$var$_typeof(symbol)) === 'object';
}
function $953bd6ff96435836$var$hasProperty(prop, obj) {
    // We have to traverse manually prototypes' chain for polyfilled ES6 Symbols
    // like "in" operator does.
    // I.e.: Babel 5 Symbol polyfill stores every created symbol in Object.prototype.
    // That's why we cannot use construction like "prop in obj" to check, if needed
    // prop actually exists in given object/prototypes' chain.
    if ($953bd6ff96435836$var$buggySymbol(prop)) {
        do {
            if (obj === Object.prototype) // Polyfill assigns undefined as value for stored symbol key.
            // We can assume in this special case if there is nothing assigned it doesn't exist.
            return typeof obj[prop] !== 'undefined';
            if (obj.hasOwnProperty(prop)) return true;
        }while (obj = $953bd6ff96435836$var$getPrototypeOf(obj));
        return false;
    } else return prop in obj;
}
function $953bd6ff96435836$var$handleClass(target, mixins) {
    if (!mixins.length) throw new SyntaxError('@mixin() class ' + target.name + ' requires at least one mixin as an argument');
    for(var i = 0, l = mixins.length; i < l; i++){
        var descs = (0, $12cFS.getOwnPropertyDescriptors)(mixins[i]);
        var keys = (0, $12cFS.getOwnKeys)(descs);
        for(var j = 0, k = keys.length; j < k; j++){
            var key = keys[j];
            if (!$953bd6ff96435836$var$hasProperty(key, target.prototype)) $953bd6ff96435836$var$defineProperty(target.prototype, key, descs[key]);
        }
    }
}
function $953bd6ff96435836$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, mixins = Array(_len), _key = 0; _key < _len; _key++)mixins[_key] = arguments[_key];
    (0, $12cFS.internalDeprecation)('@mixin is deprecated and will be removed shortly. Use @mixin from lodash-decorators.\n\n  https://www.npmjs.com/package/lodash-decorators');
    if (typeof mixins[0] === 'function') return $953bd6ff96435836$var$handleClass(mixins[0], []);
    else return function(target) {
        return $953bd6ff96435836$var$handleClass(target, mixins);
    };
}

});

parcelRegister("fZGAn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba4d962ef168a47d$export$2e2bcd8739ae039; });

var $12cFS = parcelRequire("12cFS");
var $ba4d962ef168a47d$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $ba4d962ef168a47d$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();
var $ba4d962ef168a47d$var$labels = {};
var $ba4d962ef168a47d$export$600a7be3e8bb1b70 = {
    time: console.time ? console.time.bind(console) : function(label) {
        $ba4d962ef168a47d$var$labels[label] = new Date();
    },
    timeEnd: console.timeEnd ? console.timeEnd.bind(console) : function(label) {
        var timeNow = new Date();
        var timeTaken = timeNow - $ba4d962ef168a47d$var$labels[label];
        delete $ba4d962ef168a47d$var$labels[label];
        console.log(label + ': ' + timeTaken + 'ms');
    }
};
var $ba4d962ef168a47d$var$count = 0;
function $ba4d962ef168a47d$var$handleDescriptor(target, key, descriptor, _ref) {
    var _ref2 = $ba4d962ef168a47d$var$_slicedToArray(_ref, 2), _ref2$ = _ref2[0], prefix = _ref2$ === undefined ? null : _ref2$, _ref2$2 = _ref2[1], console1 = _ref2$2 === undefined ? $ba4d962ef168a47d$export$600a7be3e8bb1b70 : _ref2$2;
    var fn = descriptor.value;
    if (prefix === null) prefix = target.constructor.name + '.' + key;
    if (typeof fn !== 'function') throw new SyntaxError('@time can only be used on functions, not: ' + fn);
    return $ba4d962ef168a47d$var$_extends({}, descriptor, {
        value: function value() {
            var label = prefix + '-' + $ba4d962ef168a47d$var$count;
            $ba4d962ef168a47d$var$count++;
            console1.time(label);
            try {
                return fn.apply(this, arguments);
            } finally{
                console1.timeEnd(label);
            }
        }
    });
}
function $ba4d962ef168a47d$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $12cFS.decorate)($ba4d962ef168a47d$var$handleDescriptor, args);
}

});

parcelRegister("kYbIs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4427fc914221045$export$2e2bcd8739ae039; });

var $12cFS = parcelRequire("12cFS");
var $f4427fc914221045$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $f4427fc914221045$var$getPrototypeOf = Object.getPrototypeOf, $f4427fc914221045$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
function $f4427fc914221045$var$handleDescriptor(target, key, descriptor) {
    var superKlass = $f4427fc914221045$var$getPrototypeOf(target);
    var superDesc = $f4427fc914221045$var$getOwnPropertyDescriptor(superKlass, key);
    return $f4427fc914221045$var$_extends({}, superDesc, {
        value: descriptor.value,
        initializer: descriptor.initializer,
        get: descriptor.get || superDesc.get,
        set: descriptor.set || superDesc.set
    });
}
function $f4427fc914221045$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $12cFS.decorate)($f4427fc914221045$var$handleDescriptor, args);
}

});

parcelRegister("eddlU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a58ca312dff4a689$export$2e2bcd8739ae039; });

var $12cFS = parcelRequire("12cFS");
var $a58ca312dff4a689$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $a58ca312dff4a689$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();
var $a58ca312dff4a689$var$oc = console;
var $a58ca312dff4a689$export$600a7be3e8bb1b70 = {
    profile: console.profile ? (0, $12cFS.bind)(console.profile, console) : function() {},
    profileEnd: console.profileEnd ? (0, $12cFS.bind)(console.profileEnd, console) : function() {},
    warn: (0, $12cFS.warn)
};
function $a58ca312dff4a689$var$handleDescriptor(target, key, descriptor, _ref) {
    var _ref2 = $a58ca312dff4a689$var$_slicedToArray(_ref, 3), _ref2$ = _ref2[0], prefix = _ref2$ === undefined ? null : _ref2$, _ref2$2 = _ref2[1], onceThrottleOrFunction = _ref2$2 === undefined ? false : _ref2$2, _ref2$3 = _ref2[2], console1 = _ref2$3 === undefined ? $a58ca312dff4a689$export$600a7be3e8bb1b70 : _ref2$3;
    if (!$a58ca312dff4a689$export$2e2bcd8739ae039.__enabled) {
        if (!$a58ca312dff4a689$export$2e2bcd8739ae039.__warned) {
            console1.warn('console.profile is not supported. All @profile decorators are disabled.');
            $a58ca312dff4a689$export$2e2bcd8739ae039.__warned = true;
        }
        return descriptor;
    }
    var fn = descriptor.value;
    if (prefix === null) prefix = target.constructor.name + '.' + key;
    if (typeof fn !== 'function') throw new SyntaxError('@profile can only be used on functions, not: ' + fn);
    return $a58ca312dff4a689$var$_extends({}, descriptor, {
        value: function value() {
            var now = Date.now();
            var meta = (0, $12cFS.metaFor)(this);
            if (onceThrottleOrFunction === true && !meta.profileLastRan || onceThrottleOrFunction === false || typeof onceThrottleOrFunction === 'number' && now - meta.profileLastRan > onceThrottleOrFunction || typeof onceThrottleOrFunction === 'function' && onceThrottleOrFunction.apply(this, arguments)) {
                console1.profile(prefix);
                meta.profileLastRan = now;
            }
            try {
                return fn.apply(this, arguments);
            } finally{
                console1.profileEnd(prefix);
            }
        }
    });
}
function $a58ca312dff4a689$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $12cFS.decorate)($a58ca312dff4a689$var$handleDescriptor, args);
}
// Only Chrome, Firefox, and Edge support profile.
// Exposing properties for testing.
$a58ca312dff4a689$export$2e2bcd8739ae039.__enabled = !!console.profile;
$a58ca312dff4a689$export$2e2bcd8739ae039.__warned = false;

});

parcelRegister("gv1bL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c03076ab2021f638$export$2e2bcd8739ae039; });
var $c03076ab2021f638$var$defineProperty = Object.defineProperty, $c03076ab2021f638$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
function $c03076ab2021f638$export$2e2bcd8739ae039(Class, props) {
    var prototype = Class.prototype;
    for(var key in props){
        var decorators = props[key];
        for(var i = 0, l = decorators.length; i < l; i++){
            var decorator = decorators[i];
            $c03076ab2021f638$var$defineProperty(prototype, key, decorator(prototype, key, $c03076ab2021f638$var$getOwnPropertyDescriptor(prototype, key)));
        }
    }
    return Class;
}

});


parcelRegister("k76Eu", function(module, exports) {
(function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = undefined;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(e) {
                    var n = t[o][1][e];
                    return s(n ? n : e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = undefined;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(_dereq_, module1, exports) {
                module1.exports = function(forceSimilar) {
                    if (typeof Map !== 'function' || forceSimilar) {
                        var Similar = _dereq_('./similar');
                        return new Similar();
                    } else return new Map();
                };
            },
            {
                "./similar": 2
            }
        ],
        2: [
            function(_dereq_, module1, exports) {
                function Similar() {
                    this.list = [];
                    this.lastItem = undefined;
                    this.size = 0;
                    return this;
                }
                Similar.prototype.get = function(key) {
                    var index;
                    if (this.lastItem && this.isEqual(this.lastItem.key, key)) return this.lastItem.val;
                    index = this.indexOf(key);
                    if (index >= 0) {
                        this.lastItem = this.list[index];
                        return this.list[index].val;
                    }
                    return undefined;
                };
                Similar.prototype.set = function(key, val) {
                    var index;
                    if (this.lastItem && this.isEqual(this.lastItem.key, key)) {
                        this.lastItem.val = val;
                        return this;
                    }
                    index = this.indexOf(key);
                    if (index >= 0) {
                        this.lastItem = this.list[index];
                        this.list[index].val = val;
                        return this;
                    }
                    this.lastItem = {
                        key: key,
                        val: val
                    };
                    this.list.push(this.lastItem);
                    this.size++;
                    return this;
                };
                Similar.prototype.delete = function(key) {
                    var index;
                    if (this.lastItem && this.isEqual(this.lastItem.key, key)) this.lastItem = undefined;
                    index = this.indexOf(key);
                    if (index >= 0) {
                        this.size--;
                        return this.list.splice(index, 1)[0];
                    }
                    return undefined;
                };
                // important that has() doesn't use get() in case an existing key has a falsy value, in which case has() would return false
                Similar.prototype.has = function(key) {
                    var index;
                    if (this.lastItem && this.isEqual(this.lastItem.key, key)) return true;
                    index = this.indexOf(key);
                    if (index >= 0) {
                        this.lastItem = this.list[index];
                        return true;
                    }
                    return false;
                };
                Similar.prototype.forEach = function(callback, thisArg) {
                    var i;
                    for(i = 0; i < this.size; i++)callback.call(thisArg || this, this.list[i].val, this.list[i].key, this);
                };
                Similar.prototype.indexOf = function(key) {
                    var i;
                    for(i = 0; i < this.size; i++){
                        if (this.isEqual(this.list[i].key, key)) return i;
                    }
                    return -1;
                };
                // check if the numbers are equal, or whether they are both precisely NaN (isNaN returns true for all non-numbers)
                Similar.prototype.isEqual = function(val1, val2) {
                    return val1 === val2 || val1 !== val1 && val2 !== val2;
                };
                module1.exports = Similar;
            },
            {}
        ],
        3: [
            function(_dereq_, module1, exports) {
                var MapOrSimilar = _dereq_('map-or-similar');
                module1.exports = function(limit) {
                    var cache = new MapOrSimilar(false), lru = [];
                    return function(fn) {
                        var memoizerific = function() {
                            var currentCache = cache, newMap, fnResult, argsLengthMinusOne = arguments.length - 1, lruPath = Array(argsLengthMinusOne + 1), isMemoized = true, i;
                            if ((memoizerific.numArgs || memoizerific.numArgs === 0) && memoizerific.numArgs !== argsLengthMinusOne + 1) throw new Error('Memoizerific functions should always be called with the same number of arguments');
                            // loop through each argument to traverse the map tree
                            for(i = 0; i < argsLengthMinusOne; i++){
                                lruPath[i] = {
                                    cacheItem: currentCache,
                                    arg: arguments[i]
                                };
                                // climb through the hierarchical map tree until the second-last argument has been found, or an argument is missing.
                                // if all arguments up to the second-last have been found, this will potentially be a cache hit (determined later)
                                if (currentCache.has(arguments[i])) {
                                    currentCache = currentCache.get(arguments[i]);
                                    continue;
                                }
                                isMemoized = false;
                                // make maps until last value
                                newMap = new MapOrSimilar(false);
                                currentCache.set(arguments[i], newMap);
                                currentCache = newMap;
                            }
                            // we are at the last arg, check if it is really memoized
                            if (isMemoized) {
                                if (currentCache.has(arguments[argsLengthMinusOne])) fnResult = currentCache.get(arguments[argsLengthMinusOne]);
                                else isMemoized = false;
                            }
                            if (!isMemoized) {
                                fnResult = fn.apply(null, arguments);
                                currentCache.set(arguments[argsLengthMinusOne], fnResult);
                            }
                            if (limit > 0) {
                                lruPath[argsLengthMinusOne] = {
                                    cacheItem: currentCache,
                                    arg: arguments[argsLengthMinusOne]
                                };
                                if (isMemoized) moveToMostRecentLru(lru, lruPath);
                                else lru.push(lruPath);
                                if (lru.length > limit) removeCachedResult(lru.shift());
                            }
                            memoizerific.wasMemoized = isMemoized;
                            memoizerific.numArgs = argsLengthMinusOne + 1;
                            return fnResult;
                        };
                        memoizerific.limit = limit;
                        memoizerific.wasMemoized = false;
                        memoizerific.cache = cache;
                        memoizerific.lru = lru;
                        return memoizerific;
                    };
                };
                // move current args to most recent position
                function moveToMostRecentLru(lru, lruPath) {
                    var lruLen = lru.length, lruPathLen = lruPath.length, isMatch, i, ii;
                    for(i = 0; i < lruLen; i++){
                        isMatch = true;
                        for(ii = 0; ii < lruPathLen; ii++)if (!isEqual(lru[i][ii].arg, lruPath[ii].arg)) {
                            isMatch = false;
                            break;
                        }
                        if (isMatch) break;
                    }
                    lru.push(lru.splice(i, 1)[0]);
                }
                // remove least recently used cache item and all dead branches
                function removeCachedResult(removedLru) {
                    var removedLruLen = removedLru.length, currentLru = removedLru[removedLruLen - 1], tmp, i;
                    currentLru.cacheItem.delete(currentLru.arg);
                    // walk down the tree removing dead branches (size 0) along the way
                    for(i = removedLruLen - 2; i >= 0; i--){
                        currentLru = removedLru[i];
                        tmp = currentLru.cacheItem.get(currentLru.arg);
                        if (!tmp || !tmp.size) currentLru.cacheItem.delete(currentLru.arg);
                        else break;
                    }
                }
                // check if the numbers are equal, or whether they are both precisely NaN (isNaN returns true for all non-numbers)
                function isEqual(val1, val2) {
                    return val1 === val2 || val1 !== val1 && val2 !== val2;
                }
            },
            {
                "map-or-similar": 1
            }
        ]
    }, {}, [
        3
    ])(3);
});

});

parcelRegister("4csXa", function(module, exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
// This is CodeMirror (https://codemirror.net), a code editor
// implemented in JavaScript on top of the browser's DOM.
//
// You can find some technical background for some of the code below
// at http://marijnhaverbeke.nl/blog/#cm-internals .
(function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    // Kludges for bugs and behavior differences that can't be feature
    // detected are enabled based on userAgent etc sniffing.
    var userAgent = navigator.userAgent;
    var platform = navigator.platform;
    var gecko = /gecko\/\d/i.test(userAgent);
    var ie_upto10 = /MSIE \d/.test(userAgent);
    var ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(userAgent);
    var edge = /Edge\/(\d+)/.exec(userAgent);
    var ie = ie_upto10 || ie_11up || edge;
    var ie_version = ie && (ie_upto10 ? document.documentMode || 6 : +(edge || ie_11up)[1]);
    var webkit = !edge && /WebKit\//.test(userAgent);
    var qtwebkit = webkit && /Qt\/\d+\.\d+/.test(userAgent);
    var chrome = !edge && /Chrome\//.test(userAgent);
    var presto = /Opera\//.test(userAgent);
    var safari = /Apple Computer/.test(navigator.vendor);
    var mac_geMountainLion = /Mac OS X 1\d\D([8-9]|\d\d)\D/.test(userAgent);
    var phantom = /PhantomJS/.test(userAgent);
    var ios = safari && (/Mobile\/\w+/.test(userAgent) || navigator.maxTouchPoints > 2);
    var android = /Android/.test(userAgent);
    // This is woefully incomplete. Suggestions for alternative methods welcome.
    var mobile = ios || android || /webOS|BlackBerry|Opera Mini|Opera Mobi|IEMobile/i.test(userAgent);
    var mac = ios || /Mac/.test(platform);
    var chromeOS = /\bCrOS\b/.test(userAgent);
    var windows = /win/i.test(platform);
    var presto_version = presto && userAgent.match(/Version\/(\d*\.\d*)/);
    if (presto_version) presto_version = Number(presto_version[1]);
    if (presto_version && presto_version >= 15) {
        presto = false;
        webkit = true;
    }
    // Some browsers use the wrong event properties to signal cmd/ctrl on OS X
    var flipCtrlCmd = mac && (qtwebkit || presto && (presto_version == null || presto_version < 12.11));
    var captureRightClick = gecko || ie && ie_version >= 9;
    function classTest(cls) {
        return new RegExp("(^|\\s)" + cls + "(?:$|\\s)\\s*");
    }
    var rmClass = function(node, cls) {
        var current = node.className;
        var match = classTest(cls).exec(current);
        if (match) {
            var after = current.slice(match.index + match[0].length);
            node.className = current.slice(0, match.index) + (after ? match[1] + after : "");
        }
    };
    function removeChildren(e) {
        for(var count = e.childNodes.length; count > 0; --count)e.removeChild(e.firstChild);
        return e;
    }
    function removeChildrenAndAdd(parent, e) {
        return removeChildren(parent).appendChild(e);
    }
    function elt(tag, content, className, style) {
        var e = document.createElement(tag);
        if (className) e.className = className;
        if (style) e.style.cssText = style;
        if (typeof content == "string") e.appendChild(document.createTextNode(content));
        else if (content) for(var i = 0; i < content.length; ++i)e.appendChild(content[i]);
        return e;
    }
    // wrapper for elt, which removes the elt from the accessibility tree
    function eltP(tag, content, className, style) {
        var e = elt(tag, content, className, style);
        e.setAttribute("role", "presentation");
        return e;
    }
    var range;
    if (document.createRange) range = function(node, start, end, endNode) {
        var r = document.createRange();
        r.setEnd(endNode || node, end);
        r.setStart(node, start);
        return r;
    };
    else range = function(node, start, end) {
        var r = document.body.createTextRange();
        try {
            r.moveToElementText(node.parentNode);
        } catch (e) {
            return r;
        }
        r.collapse(true);
        r.moveEnd("character", end);
        r.moveStart("character", start);
        return r;
    };
    function contains(parent, child) {
        if (child.nodeType == 3) child = child.parentNode;
        if (parent.contains) return parent.contains(child);
        do {
            if (child.nodeType == 11) child = child.host;
            if (child == parent) return true;
        }while (child = child.parentNode);
    }
    function activeElt() {
        // IE and Edge may throw an "Unspecified Error" when accessing document.activeElement.
        // IE < 10 will throw when accessed while the page is loading or in an iframe.
        // IE > 9 and Edge will throw when accessed in an iframe if document.body is unavailable.
        var activeElement;
        try {
            activeElement = document.activeElement;
        } catch (e) {
            activeElement = document.body || null;
        }
        while(activeElement && activeElement.shadowRoot && activeElement.shadowRoot.activeElement)activeElement = activeElement.shadowRoot.activeElement;
        return activeElement;
    }
    function addClass(node, cls) {
        var current = node.className;
        if (!classTest(cls).test(current)) node.className += (current ? " " : "") + cls;
    }
    function joinClasses(a, b) {
        var as = a.split(" ");
        for(var i = 0; i < as.length; i++)if (as[i] && !classTest(as[i]).test(b)) b += " " + as[i];
        return b;
    }
    var selectInput = function(node) {
        node.select();
    };
    if (ios) selectInput = function(node) {
        node.selectionStart = 0;
        node.selectionEnd = node.value.length;
    };
    else if (ie) selectInput = function(node) {
        try {
            node.select();
        } catch (_e) {}
    };
    function bind(f) {
        var args = Array.prototype.slice.call(arguments, 1);
        return function() {
            return f.apply(null, args);
        };
    }
    function copyObj(obj, target, overwrite) {
        if (!target) target = {};
        for(var prop in obj)if (obj.hasOwnProperty(prop) && (overwrite !== false || !target.hasOwnProperty(prop))) target[prop] = obj[prop];
        return target;
    }
    // Counts the column offset in a string, taking tabs into account.
    // Used mostly to find indentation.
    function countColumn(string, end, tabSize, startIndex, startValue) {
        if (end == null) {
            end = string.search(/[^\s\u00a0]/);
            if (end == -1) end = string.length;
        }
        for(var i = startIndex || 0, n = startValue || 0;;){
            var nextTab = string.indexOf("\t", i);
            if (nextTab < 0 || nextTab >= end) return n + (end - i);
            n += nextTab - i;
            n += tabSize - n % tabSize;
            i = nextTab + 1;
        }
    }
    var Delayed = function() {
        this.id = null;
        this.f = null;
        this.time = 0;
        this.handler = bind(this.onTimeout, this);
    };
    Delayed.prototype.onTimeout = function(self) {
        self.id = 0;
        if (self.time <= +new Date) self.f();
        else setTimeout(self.handler, self.time - +new Date);
    };
    Delayed.prototype.set = function(ms, f) {
        this.f = f;
        var time = +new Date + ms;
        if (!this.id || time < this.time) {
            clearTimeout(this.id);
            this.id = setTimeout(this.handler, ms);
            this.time = time;
        }
    };
    function indexOf(array, elt) {
        for(var i = 0; i < array.length; ++i){
            if (array[i] == elt) return i;
        }
        return -1;
    }
    // Number of pixels added to scroller and sizer to hide scrollbar
    var scrollerGap = 50;
    // Returned or thrown by various protocols to signal 'I'm not
    // handling this'.
    var Pass = {
        toString: function() {
            return "CodeMirror.Pass";
        }
    };
    // Reused option objects for setSelection & friends
    var sel_dontScroll = {
        scroll: false
    }, sel_mouse = {
        origin: "*mouse"
    }, sel_move = {
        origin: "+move"
    };
    // The inverse of countColumn -- find the offset that corresponds to
    // a particular column.
    function findColumn(string, goal, tabSize) {
        for(var pos = 0, col = 0;;){
            var nextTab = string.indexOf("\t", pos);
            if (nextTab == -1) nextTab = string.length;
            var skipped = nextTab - pos;
            if (nextTab == string.length || col + skipped >= goal) return pos + Math.min(skipped, goal - col);
            col += nextTab - pos;
            col += tabSize - col % tabSize;
            pos = nextTab + 1;
            if (col >= goal) return pos;
        }
    }
    var spaceStrs = [
        ""
    ];
    function spaceStr(n) {
        while(spaceStrs.length <= n)spaceStrs.push(lst(spaceStrs) + " ");
        return spaceStrs[n];
    }
    function lst(arr) {
        return arr[arr.length - 1];
    }
    function map(array, f) {
        var out = [];
        for(var i = 0; i < array.length; i++)out[i] = f(array[i], i);
        return out;
    }
    function insertSorted(array, value, score) {
        var pos = 0, priority = score(value);
        while(pos < array.length && score(array[pos]) <= priority)pos++;
        array.splice(pos, 0, value);
    }
    function nothing() {}
    function createObj(base, props) {
        var inst;
        if (Object.create) inst = Object.create(base);
        else {
            nothing.prototype = base;
            inst = new nothing();
        }
        if (props) copyObj(props, inst);
        return inst;
    }
    var nonASCIISingleCaseWordChar = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
    function isWordCharBasic(ch) {
        return /\w/.test(ch) || ch > "\x80" && (ch.toUpperCase() != ch.toLowerCase() || nonASCIISingleCaseWordChar.test(ch));
    }
    function isWordChar(ch, helper) {
        if (!helper) return isWordCharBasic(ch);
        if (helper.source.indexOf("\\w") > -1 && isWordCharBasic(ch)) return true;
        return helper.test(ch);
    }
    function isEmpty(obj) {
        for(var n in obj){
            if (obj.hasOwnProperty(n) && obj[n]) return false;
        }
        return true;
    }
    // Extending unicode characters. A series of a non-extending char +
    // any number of extending chars is treated as a single unit as far
    // as editing and measuring is concerned. This is not fully correct,
    // since some scripts/fonts/browsers also treat other configurations
    // of code points as a group.
    var extendingChars = /[\u0300-\u036f\u0483-\u0489\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u065e\u0670\u06d6-\u06dc\u06de-\u06e4\u06e7\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0900-\u0902\u093c\u0941-\u0948\u094d\u0951-\u0955\u0962\u0963\u0981\u09bc\u09be\u09c1-\u09c4\u09cd\u09d7\u09e2\u09e3\u0a01\u0a02\u0a3c\u0a41\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a70\u0a71\u0a75\u0a81\u0a82\u0abc\u0ac1-\u0ac5\u0ac7\u0ac8\u0acd\u0ae2\u0ae3\u0b01\u0b3c\u0b3e\u0b3f\u0b41-\u0b44\u0b4d\u0b56\u0b57\u0b62\u0b63\u0b82\u0bbe\u0bc0\u0bcd\u0bd7\u0c3e-\u0c40\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0cbc\u0cbf\u0cc2\u0cc6\u0ccc\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0d3e\u0d41-\u0d44\u0d4d\u0d57\u0d62\u0d63\u0dca\u0dcf\u0dd2-\u0dd4\u0dd6\u0ddf\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9\u0ebb\u0ebc\u0ec8-\u0ecd\u0f18\u0f19\u0f35\u0f37\u0f39\u0f71-\u0f7e\u0f80-\u0f84\u0f86\u0f87\u0f90-\u0f97\u0f99-\u0fbc\u0fc6\u102d-\u1030\u1032-\u1037\u1039\u103a\u103d\u103e\u1058\u1059\u105e-\u1060\u1071-\u1074\u1082\u1085\u1086\u108d\u109d\u135f\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17b7-\u17bd\u17c6\u17c9-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193b\u1a17\u1a18\u1a56\u1a58-\u1a5e\u1a60\u1a62\u1a65-\u1a6c\u1a73-\u1a7c\u1a7f\u1b00-\u1b03\u1b34\u1b36-\u1b3a\u1b3c\u1b42\u1b6b-\u1b73\u1b80\u1b81\u1ba2-\u1ba5\u1ba8\u1ba9\u1c2c-\u1c33\u1c36\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce0\u1ce2-\u1ce8\u1ced\u1dc0-\u1de6\u1dfd-\u1dff\u200c\u200d\u20d0-\u20f0\u2cef-\u2cf1\u2de0-\u2dff\u302a-\u302f\u3099\u309a\ua66f-\ua672\ua67c\ua67d\ua6f0\ua6f1\ua802\ua806\ua80b\ua825\ua826\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua951\ua980-\ua982\ua9b3\ua9b6-\ua9b9\ua9bc\uaa29-\uaa2e\uaa31\uaa32\uaa35\uaa36\uaa43\uaa4c\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uabe5\uabe8\uabed\udc00-\udfff\ufb1e\ufe00-\ufe0f\ufe20-\ufe26\uff9e\uff9f]/;
    function isExtendingChar(ch) {
        return ch.charCodeAt(0) >= 768 && extendingChars.test(ch);
    }
    // Returns a number from the range [`0`; `str.length`] unless `pos` is outside that range.
    function skipExtendingChars(str, pos, dir) {
        while((dir < 0 ? pos > 0 : pos < str.length) && isExtendingChar(str.charAt(pos)))pos += dir;
        return pos;
    }
    // Returns the value from the range [`from`; `to`] that satisfies
    // `pred` and is closest to `from`. Assumes that at least `to`
    // satisfies `pred`. Supports `from` being greater than `to`.
    function findFirst(pred, from, to) {
        // At any point we are certain `to` satisfies `pred`, don't know
        // whether `from` does.
        var dir = from > to ? -1 : 1;
        for(;;){
            if (from == to) return from;
            var midF = (from + to) / 2, mid = dir < 0 ? Math.ceil(midF) : Math.floor(midF);
            if (mid == from) return pred(mid) ? from : to;
            if (pred(mid)) to = mid;
            else from = mid + dir;
        }
    }
    // BIDI HELPERS
    function iterateBidiSections(order, from, to, f) {
        if (!order) return f(from, to, "ltr", 0);
        var found = false;
        for(var i = 0; i < order.length; ++i){
            var part = order[i];
            if (part.from < to && part.to > from || from == to && part.to == from) {
                f(Math.max(part.from, from), Math.min(part.to, to), part.level == 1 ? "rtl" : "ltr", i);
                found = true;
            }
        }
        if (!found) f(from, to, "ltr");
    }
    var bidiOther = null;
    function getBidiPartAt(order, ch, sticky) {
        var found;
        bidiOther = null;
        for(var i = 0; i < order.length; ++i){
            var cur = order[i];
            if (cur.from < ch && cur.to > ch) return i;
            if (cur.to == ch) {
                if (cur.from != cur.to && sticky == "before") found = i;
                else bidiOther = i;
            }
            if (cur.from == ch) {
                if (cur.from != cur.to && sticky != "before") found = i;
                else bidiOther = i;
            }
        }
        return found != null ? found : bidiOther;
    }
    // Bidirectional ordering algorithm
    // See http://unicode.org/reports/tr9/tr9-13.html for the algorithm
    // that this (partially) implements.
    // One-char codes used for character types:
    // L (L):   Left-to-Right
    // R (R):   Right-to-Left
    // r (AL):  Right-to-Left Arabic
    // 1 (EN):  European Number
    // + (ES):  European Number Separator
    // % (ET):  European Number Terminator
    // n (AN):  Arabic Number
    // , (CS):  Common Number Separator
    // m (NSM): Non-Spacing Mark
    // b (BN):  Boundary Neutral
    // s (B):   Paragraph Separator
    // t (S):   Segment Separator
    // w (WS):  Whitespace
    // N (ON):  Other Neutrals
    // Returns null if characters are ordered as they appear
    // (left-to-right), or an array of sections ({from, to, level}
    // objects) in the order in which they occur visually.
    var bidiOrdering = function() {
        // Character types for codepoints 0 to 0xff
        var lowTypes = "bbbbbbbbbtstwsbbbbbbbbbbbbbbssstwNN%%%NNNNNN,N,N1111111111NNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNbbbbbbsbbbbbbbbbbbbbbbbbbbbbbbbbb,N%%%%NNNNLNNNNN%%11NLNNN1LNNNNNLLLLLLLLLLLLLLLLLLLLLLLNLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLN";
        // Character types for codepoints 0x600 to 0x6f9
        var arabicTypes = "nnnnnnNNr%%r,rNNmmmmmmmmmmmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmmmmmmmmmmmmmmmnnnnnnnnnn%nnrrrmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmnNmmmmmmrrmmNmmmmrr1111111111";
        function charType(code) {
            if (code <= 0xf7) return lowTypes.charAt(code);
            else if (0x590 <= code && code <= 0x5f4) return "R";
            else if (0x600 <= code && code <= 0x6f9) return arabicTypes.charAt(code - 0x600);
            else if (0x6ee <= code && code <= 0x8ac) return "r";
            else if (0x2000 <= code && code <= 0x200b) return "w";
            else if (code == 0x200c) return "b";
            else return "L";
        }
        var bidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
        var isNeutral = /[stwN]/, isStrong = /[LRr]/, countsAsLeft = /[Lb1n]/, countsAsNum = /[1n]/;
        function BidiSpan(level, from, to) {
            this.level = level;
            this.from = from;
            this.to = to;
        }
        return function(str, direction) {
            var outerType = direction == "ltr" ? "L" : "R";
            if (str.length == 0 || direction == "ltr" && !bidiRE.test(str)) return false;
            var len = str.length, types = [];
            for(var i = 0; i < len; ++i)types.push(charType(str.charCodeAt(i)));
            // W1. Examine each non-spacing mark (NSM) in the level run, and
            // change the type of the NSM to the type of the previous
            // character. If the NSM is at the start of the level run, it will
            // get the type of sor.
            for(var i$1 = 0, prev = outerType; i$1 < len; ++i$1){
                var type = types[i$1];
                if (type == "m") types[i$1] = prev;
                else prev = type;
            }
            // W2. Search backwards from each instance of a European number
            // until the first strong type (R, L, AL, or sor) is found. If an
            // AL is found, change the type of the European number to Arabic
            // number.
            // W3. Change all ALs to R.
            for(var i$2 = 0, cur = outerType; i$2 < len; ++i$2){
                var type$1 = types[i$2];
                if (type$1 == "1" && cur == "r") types[i$2] = "n";
                else if (isStrong.test(type$1)) {
                    cur = type$1;
                    if (type$1 == "r") types[i$2] = "R";
                }
            }
            // W4. A single European separator between two European numbers
            // changes to a European number. A single common separator between
            // two numbers of the same type changes to that type.
            for(var i$3 = 1, prev$1 = types[0]; i$3 < len - 1; ++i$3){
                var type$2 = types[i$3];
                if (type$2 == "+" && prev$1 == "1" && types[i$3 + 1] == "1") types[i$3] = "1";
                else if (type$2 == "," && prev$1 == types[i$3 + 1] && (prev$1 == "1" || prev$1 == "n")) types[i$3] = prev$1;
                prev$1 = type$2;
            }
            // W5. A sequence of European terminators adjacent to European
            // numbers changes to all European numbers.
            // W6. Otherwise, separators and terminators change to Other
            // Neutral.
            for(var i$4 = 0; i$4 < len; ++i$4){
                var type$3 = types[i$4];
                if (type$3 == ",") types[i$4] = "N";
                else if (type$3 == "%") {
                    var end = void 0;
                    for(end = i$4 + 1; end < len && types[end] == "%"; ++end);
                    var replace = i$4 && types[i$4 - 1] == "!" || end < len && types[end] == "1" ? "1" : "N";
                    for(var j = i$4; j < end; ++j)types[j] = replace;
                    i$4 = end - 1;
                }
            }
            // W7. Search backwards from each instance of a European number
            // until the first strong type (R, L, or sor) is found. If an L is
            // found, then change the type of the European number to L.
            for(var i$5 = 0, cur$1 = outerType; i$5 < len; ++i$5){
                var type$4 = types[i$5];
                if (cur$1 == "L" && type$4 == "1") types[i$5] = "L";
                else if (isStrong.test(type$4)) cur$1 = type$4;
            }
            // N1. A sequence of neutrals takes the direction of the
            // surrounding strong text if the text on both sides has the same
            // direction. European and Arabic numbers act as if they were R in
            // terms of their influence on neutrals. Start-of-level-run (sor)
            // and end-of-level-run (eor) are used at level run boundaries.
            // N2. Any remaining neutrals take the embedding direction.
            for(var i$6 = 0; i$6 < len; ++i$6)if (isNeutral.test(types[i$6])) {
                var end$1 = void 0;
                for(end$1 = i$6 + 1; end$1 < len && isNeutral.test(types[end$1]); ++end$1);
                var before = (i$6 ? types[i$6 - 1] : outerType) == "L";
                var after = (end$1 < len ? types[end$1] : outerType) == "L";
                var replace$1 = before == after ? before ? "L" : "R" : outerType;
                for(var j$1 = i$6; j$1 < end$1; ++j$1)types[j$1] = replace$1;
                i$6 = end$1 - 1;
            }
            // Here we depart from the documented algorithm, in order to avoid
            // building up an actual levels array. Since there are only three
            // levels (0, 1, 2) in an implementation that doesn't take
            // explicit embedding into account, we can build up the order on
            // the fly, without following the level-based algorithm.
            var order = [], m;
            for(var i$7 = 0; i$7 < len;)if (countsAsLeft.test(types[i$7])) {
                var start = i$7;
                for(++i$7; i$7 < len && countsAsLeft.test(types[i$7]); ++i$7);
                order.push(new BidiSpan(0, start, i$7));
            } else {
                var pos = i$7, at = order.length, isRTL = direction == "rtl" ? 1 : 0;
                for(++i$7; i$7 < len && types[i$7] != "L"; ++i$7);
                for(var j$2 = pos; j$2 < i$7;)if (countsAsNum.test(types[j$2])) {
                    if (pos < j$2) {
                        order.splice(at, 0, new BidiSpan(1, pos, j$2));
                        at += isRTL;
                    }
                    var nstart = j$2;
                    for(++j$2; j$2 < i$7 && countsAsNum.test(types[j$2]); ++j$2);
                    order.splice(at, 0, new BidiSpan(2, nstart, j$2));
                    at += isRTL;
                    pos = j$2;
                } else ++j$2;
                if (pos < i$7) order.splice(at, 0, new BidiSpan(1, pos, i$7));
            }
            if (direction == "ltr") {
                if (order[0].level == 1 && (m = str.match(/^\s+/))) {
                    order[0].from = m[0].length;
                    order.unshift(new BidiSpan(0, 0, m[0].length));
                }
                if (lst(order).level == 1 && (m = str.match(/\s+$/))) {
                    lst(order).to -= m[0].length;
                    order.push(new BidiSpan(0, len - m[0].length, len));
                }
            }
            return direction == "rtl" ? order.reverse() : order;
        };
    }();
    // Get the bidi ordering for the given line (and cache it). Returns
    // false for lines that are fully left-to-right, and an array of
    // BidiSpan objects otherwise.
    function getOrder(line, direction) {
        var order = line.order;
        if (order == null) order = line.order = bidiOrdering(line.text, direction);
        return order;
    }
    // EVENT HANDLING
    // Lightweight event framework. on/off also work on DOM nodes,
    // registering native DOM handlers.
    var noHandlers = [];
    var on = function(emitter, type, f) {
        if (emitter.addEventListener) emitter.addEventListener(type, f, false);
        else if (emitter.attachEvent) emitter.attachEvent("on" + type, f);
        else {
            var map = emitter._handlers || (emitter._handlers = {});
            map[type] = (map[type] || noHandlers).concat(f);
        }
    };
    function getHandlers(emitter, type) {
        return emitter._handlers && emitter._handlers[type] || noHandlers;
    }
    function off(emitter, type, f) {
        if (emitter.removeEventListener) emitter.removeEventListener(type, f, false);
        else if (emitter.detachEvent) emitter.detachEvent("on" + type, f);
        else {
            var map = emitter._handlers, arr = map && map[type];
            if (arr) {
                var index = indexOf(arr, f);
                if (index > -1) map[type] = arr.slice(0, index).concat(arr.slice(index + 1));
            }
        }
    }
    function signal(emitter, type /*, values...*/ ) {
        var handlers = getHandlers(emitter, type);
        if (!handlers.length) return;
        var args = Array.prototype.slice.call(arguments, 2);
        for(var i = 0; i < handlers.length; ++i)handlers[i].apply(null, args);
    }
    // The DOM events that CodeMirror handles can be overridden by
    // registering a (non-DOM) handler on the editor for the event name,
    // and preventDefault-ing the event in that handler.
    function signalDOMEvent(cm, e, override) {
        if (typeof e == "string") e = {
            type: e,
            preventDefault: function() {
                this.defaultPrevented = true;
            }
        };
        signal(cm, override || e.type, cm, e);
        return e_defaultPrevented(e) || e.codemirrorIgnore;
    }
    function signalCursorActivity(cm) {
        var arr = cm._handlers && cm._handlers.cursorActivity;
        if (!arr) return;
        var set = cm.curOp.cursorActivityHandlers || (cm.curOp.cursorActivityHandlers = []);
        for(var i = 0; i < arr.length; ++i)if (indexOf(set, arr[i]) == -1) set.push(arr[i]);
    }
    function hasHandler(emitter, type) {
        return getHandlers(emitter, type).length > 0;
    }
    // Add on and off methods to a constructor's prototype, to make
    // registering events on such objects more convenient.
    function eventMixin(ctor) {
        ctor.prototype.on = function(type, f) {
            on(this, type, f);
        };
        ctor.prototype.off = function(type, f) {
            off(this, type, f);
        };
    }
    // Due to the fact that we still support jurassic IE versions, some
    // compatibility wrappers are needed.
    function e_preventDefault(e) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
    }
    function e_stopPropagation(e) {
        if (e.stopPropagation) e.stopPropagation();
        else e.cancelBubble = true;
    }
    function e_defaultPrevented(e) {
        return e.defaultPrevented != null ? e.defaultPrevented : e.returnValue == false;
    }
    function e_stop(e) {
        e_preventDefault(e);
        e_stopPropagation(e);
    }
    function e_target(e) {
        return e.target || e.srcElement;
    }
    function e_button(e) {
        var b = e.which;
        if (b == null) {
            if (e.button & 1) b = 1;
            else if (e.button & 2) b = 3;
            else if (e.button & 4) b = 2;
        }
        if (mac && e.ctrlKey && b == 1) b = 3;
        return b;
    }
    // Detect drag-and-drop
    var dragAndDrop = function() {
        // There is *some* kind of drag-and-drop support in IE6-8, but I
        // couldn't get it to work yet.
        if (ie && ie_version < 9) return false;
        var div = elt('div');
        return "draggable" in div || "dragDrop" in div;
    }();
    var zwspSupported;
    function zeroWidthElement(measure) {
        if (zwspSupported == null) {
            var test = elt("span", "\u200b");
            removeChildrenAndAdd(measure, elt("span", [
                test,
                document.createTextNode("x")
            ]));
            if (measure.firstChild.offsetHeight != 0) zwspSupported = test.offsetWidth <= 1 && test.offsetHeight > 2 && !(ie && ie_version < 8);
        }
        var node = zwspSupported ? elt("span", "\u200b") : elt("span", "\u00a0", null, "display: inline-block; width: 1px; margin-right: -1px");
        node.setAttribute("cm-text", "");
        return node;
    }
    // Feature-detect IE's crummy client rect reporting for bidi text
    var badBidiRects;
    function hasBadBidiRects(measure) {
        if (badBidiRects != null) return badBidiRects;
        var txt = removeChildrenAndAdd(measure, document.createTextNode("A\u062eA"));
        var r0 = range(txt, 0, 1).getBoundingClientRect();
        var r1 = range(txt, 1, 2).getBoundingClientRect();
        removeChildren(measure);
        if (!r0 || r0.left == r0.right) return false;
         // Safari returns null in some cases (#2780)
        return badBidiRects = r1.right - r0.right < 3;
    }
    // See if "".split is the broken IE version, if so, provide an
    // alternative way to split lines.
    var splitLinesAuto = "\n\nb".split(/\n/).length != 3 ? function(string) {
        var pos = 0, result = [], l = string.length;
        while(pos <= l){
            var nl = string.indexOf("\n", pos);
            if (nl == -1) nl = string.length;
            var line = string.slice(pos, string.charAt(nl - 1) == "\r" ? nl - 1 : nl);
            var rt = line.indexOf("\r");
            if (rt != -1) {
                result.push(line.slice(0, rt));
                pos += rt + 1;
            } else {
                result.push(line);
                pos = nl + 1;
            }
        }
        return result;
    } : function(string) {
        return string.split(/\r\n?|\n/);
    };
    var hasSelection = window.getSelection ? function(te) {
        try {
            return te.selectionStart != te.selectionEnd;
        } catch (e) {
            return false;
        }
    } : function(te) {
        var range;
        try {
            range = te.ownerDocument.selection.createRange();
        } catch (e) {}
        if (!range || range.parentElement() != te) return false;
        return range.compareEndPoints("StartToEnd", range) != 0;
    };
    var hasCopyEvent = function() {
        var e = elt("div");
        if ("oncopy" in e) return true;
        e.setAttribute("oncopy", "return;");
        return typeof e.oncopy == "function";
    }();
    var badZoomedRects = null;
    function hasBadZoomedRects(measure) {
        if (badZoomedRects != null) return badZoomedRects;
        var node = removeChildrenAndAdd(measure, elt("span", "x"));
        var normal = node.getBoundingClientRect();
        var fromRange = range(node, 0, 1).getBoundingClientRect();
        return badZoomedRects = Math.abs(normal.left - fromRange.left) > 1;
    }
    // Known modes, by name and by MIME
    var modes = {}, mimeModes = {};
    // Extra arguments are stored as the mode's dependencies, which is
    // used by (legacy) mechanisms like loadmode.js to automatically
    // load a mode. (Preferred mechanism is the require/define calls.)
    function defineMode(name, mode) {
        if (arguments.length > 2) mode.dependencies = Array.prototype.slice.call(arguments, 2);
        modes[name] = mode;
    }
    function defineMIME(mime, spec) {
        mimeModes[mime] = spec;
    }
    // Given a MIME type, a {name, ...options} config object, or a name
    // string, return a mode config object.
    function resolveMode(spec) {
        if (typeof spec == "string" && mimeModes.hasOwnProperty(spec)) spec = mimeModes[spec];
        else if (spec && typeof spec.name == "string" && mimeModes.hasOwnProperty(spec.name)) {
            var found = mimeModes[spec.name];
            if (typeof found == "string") found = {
                name: found
            };
            spec = createObj(found, spec);
            spec.name = found.name;
        } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+xml$/.test(spec)) return resolveMode("application/xml");
        else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+json$/.test(spec)) return resolveMode("application/json");
        if (typeof spec == "string") return {
            name: spec
        };
        else return spec || {
            name: "null"
        };
    }
    // Given a mode spec (anything that resolveMode accepts), find and
    // initialize an actual mode object.
    function getMode(options, spec) {
        spec = resolveMode(spec);
        var mfactory = modes[spec.name];
        if (!mfactory) return getMode(options, "text/plain");
        var modeObj = mfactory(options, spec);
        if (modeExtensions.hasOwnProperty(spec.name)) {
            var exts = modeExtensions[spec.name];
            for(var prop in exts){
                if (!exts.hasOwnProperty(prop)) continue;
                if (modeObj.hasOwnProperty(prop)) modeObj["_" + prop] = modeObj[prop];
                modeObj[prop] = exts[prop];
            }
        }
        modeObj.name = spec.name;
        if (spec.helperType) modeObj.helperType = spec.helperType;
        if (spec.modeProps) for(var prop$1 in spec.modeProps)modeObj[prop$1] = spec.modeProps[prop$1];
        return modeObj;
    }
    // This can be used to attach properties to mode objects from
    // outside the actual mode definition.
    var modeExtensions = {};
    function extendMode(mode, properties) {
        var exts = modeExtensions.hasOwnProperty(mode) ? modeExtensions[mode] : modeExtensions[mode] = {};
        copyObj(properties, exts);
    }
    function copyState(mode, state) {
        if (state === true) return state;
        if (mode.copyState) return mode.copyState(state);
        var nstate = {};
        for(var n in state){
            var val = state[n];
            if (val instanceof Array) val = val.concat([]);
            nstate[n] = val;
        }
        return nstate;
    }
    // Given a mode and a state (for that mode), find the inner mode and
    // state at the position that the state refers to.
    function innerMode(mode, state) {
        var info;
        while(mode.innerMode){
            info = mode.innerMode(state);
            if (!info || info.mode == mode) break;
            state = info.state;
            mode = info.mode;
        }
        return info || {
            mode: mode,
            state: state
        };
    }
    function startState(mode, a1, a2) {
        return mode.startState ? mode.startState(a1, a2) : true;
    }
    // STRING STREAM
    // Fed to the mode parsers, provides helper functions to make
    // parsers more succinct.
    var StringStream = function(string, tabSize, lineOracle) {
        this.pos = this.start = 0;
        this.string = string;
        this.tabSize = tabSize || 8;
        this.lastColumnPos = this.lastColumnValue = 0;
        this.lineStart = 0;
        this.lineOracle = lineOracle;
    };
    StringStream.prototype.eol = function() {
        return this.pos >= this.string.length;
    };
    StringStream.prototype.sol = function() {
        return this.pos == this.lineStart;
    };
    StringStream.prototype.peek = function() {
        return this.string.charAt(this.pos) || undefined;
    };
    StringStream.prototype.next = function() {
        if (this.pos < this.string.length) return this.string.charAt(this.pos++);
    };
    StringStream.prototype.eat = function(match) {
        var ch = this.string.charAt(this.pos);
        var ok;
        if (typeof match == "string") ok = ch == match;
        else ok = ch && (match.test ? match.test(ch) : match(ch));
        if (ok) {
            ++this.pos;
            return ch;
        }
    };
    StringStream.prototype.eatWhile = function(match) {
        var start = this.pos;
        while(this.eat(match));
        return this.pos > start;
    };
    StringStream.prototype.eatSpace = function() {
        var start = this.pos;
        while(/[\s\u00a0]/.test(this.string.charAt(this.pos)))++this.pos;
        return this.pos > start;
    };
    StringStream.prototype.skipToEnd = function() {
        this.pos = this.string.length;
    };
    StringStream.prototype.skipTo = function(ch) {
        var found = this.string.indexOf(ch, this.pos);
        if (found > -1) {
            this.pos = found;
            return true;
        }
    };
    StringStream.prototype.backUp = function(n) {
        this.pos -= n;
    };
    StringStream.prototype.column = function() {
        if (this.lastColumnPos < this.start) {
            this.lastColumnValue = countColumn(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue);
            this.lastColumnPos = this.start;
        }
        return this.lastColumnValue - (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0);
    };
    StringStream.prototype.indentation = function() {
        return countColumn(this.string, null, this.tabSize) - (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0);
    };
    StringStream.prototype.match = function(pattern, consume, caseInsensitive) {
        if (typeof pattern == "string") {
            var cased = function(str) {
                return caseInsensitive ? str.toLowerCase() : str;
            };
            var substr = this.string.substr(this.pos, pattern.length);
            if (cased(substr) == cased(pattern)) {
                if (consume !== false) this.pos += pattern.length;
                return true;
            }
        } else {
            var match = this.string.slice(this.pos).match(pattern);
            if (match && match.index > 0) return null;
            if (match && consume !== false) this.pos += match[0].length;
            return match;
        }
    };
    StringStream.prototype.current = function() {
        return this.string.slice(this.start, this.pos);
    };
    StringStream.prototype.hideFirstChars = function(n, inner) {
        this.lineStart += n;
        try {
            return inner();
        } finally{
            this.lineStart -= n;
        }
    };
    StringStream.prototype.lookAhead = function(n) {
        var oracle = this.lineOracle;
        return oracle && oracle.lookAhead(n);
    };
    StringStream.prototype.baseToken = function() {
        var oracle = this.lineOracle;
        return oracle && oracle.baseToken(this.pos);
    };
    // Find the line object corresponding to the given line number.
    function getLine(doc, n) {
        n -= doc.first;
        if (n < 0 || n >= doc.size) throw new Error("There is no line " + (n + doc.first) + " in the document.");
        var chunk = doc;
        while(!chunk.lines)for(var i = 0;; ++i){
            var child = chunk.children[i], sz = child.chunkSize();
            if (n < sz) {
                chunk = child;
                break;
            }
            n -= sz;
        }
        return chunk.lines[n];
    }
    // Get the part of a document between two positions, as an array of
    // strings.
    function getBetween(doc, start, end) {
        var out = [], n = start.line;
        doc.iter(start.line, end.line + 1, function(line) {
            var text = line.text;
            if (n == end.line) text = text.slice(0, end.ch);
            if (n == start.line) text = text.slice(start.ch);
            out.push(text);
            ++n;
        });
        return out;
    }
    // Get the lines between from and to, as array of strings.
    function getLines(doc, from, to) {
        var out = [];
        doc.iter(from, to, function(line) {
            out.push(line.text);
        }); // iter aborts when callback returns truthy value
        return out;
    }
    // Update the height of a line, propagating the height change
    // upwards to parent nodes.
    function updateLineHeight(line, height) {
        var diff = height - line.height;
        if (diff) for(var n = line; n; n = n.parent)n.height += diff;
    }
    // Given a line object, find its line number by walking up through
    // its parent links.
    function lineNo(line) {
        if (line.parent == null) return null;
        var cur = line.parent, no = indexOf(cur.lines, line);
        for(var chunk = cur.parent; chunk; cur = chunk, chunk = chunk.parent)for(var i = 0;; ++i){
            if (chunk.children[i] == cur) break;
            no += chunk.children[i].chunkSize();
        }
        return no + cur.first;
    }
    // Find the line at the given vertical position, using the height
    // information in the document tree.
    function lineAtHeight(chunk, h) {
        var n = chunk.first;
        outer: do {
            for(var i$1 = 0; i$1 < chunk.children.length; ++i$1){
                var child = chunk.children[i$1], ch = child.height;
                if (h < ch) {
                    chunk = child;
                    continue outer;
                }
                h -= ch;
                n += child.chunkSize();
            }
            return n;
        }while (!chunk.lines);
        var i = 0;
        for(; i < chunk.lines.length; ++i){
            var line = chunk.lines[i], lh = line.height;
            if (h < lh) break;
            h -= lh;
        }
        return n + i;
    }
    function isLine(doc, l) {
        return l >= doc.first && l < doc.first + doc.size;
    }
    function lineNumberFor(options, i) {
        return String(options.lineNumberFormatter(i + options.firstLineNumber));
    }
    // A Pos instance represents a position within the text.
    function Pos(line, ch, sticky) {
        if (sticky === void 0) sticky = null;
        if (!(this instanceof Pos)) return new Pos(line, ch, sticky);
        this.line = line;
        this.ch = ch;
        this.sticky = sticky;
    }
    // Compare two positions, return 0 if they are the same, a negative
    // number when a is less, and a positive number otherwise.
    function cmp(a, b) {
        return a.line - b.line || a.ch - b.ch;
    }
    function equalCursorPos(a, b) {
        return a.sticky == b.sticky && cmp(a, b) == 0;
    }
    function copyPos(x) {
        return Pos(x.line, x.ch);
    }
    function maxPos(a, b) {
        return cmp(a, b) < 0 ? b : a;
    }
    function minPos(a, b) {
        return cmp(a, b) < 0 ? a : b;
    }
    // Most of the external API clips given positions to make sure they
    // actually exist within the document.
    function clipLine(doc, n) {
        return Math.max(doc.first, Math.min(n, doc.first + doc.size - 1));
    }
    function clipPos(doc, pos) {
        if (pos.line < doc.first) return Pos(doc.first, 0);
        var last = doc.first + doc.size - 1;
        if (pos.line > last) return Pos(last, getLine(doc, last).text.length);
        return clipToLen(pos, getLine(doc, pos.line).text.length);
    }
    function clipToLen(pos, linelen) {
        var ch = pos.ch;
        if (ch == null || ch > linelen) return Pos(pos.line, linelen);
        else if (ch < 0) return Pos(pos.line, 0);
        else return pos;
    }
    function clipPosArray(doc, array) {
        var out = [];
        for(var i = 0; i < array.length; i++)out[i] = clipPos(doc, array[i]);
        return out;
    }
    var SavedContext = function(state, lookAhead) {
        this.state = state;
        this.lookAhead = lookAhead;
    };
    var Context = function(doc, state, line, lookAhead) {
        this.state = state;
        this.doc = doc;
        this.line = line;
        this.maxLookAhead = lookAhead || 0;
        this.baseTokens = null;
        this.baseTokenPos = 1;
    };
    Context.prototype.lookAhead = function(n) {
        var line = this.doc.getLine(this.line + n);
        if (line != null && n > this.maxLookAhead) this.maxLookAhead = n;
        return line;
    };
    Context.prototype.baseToken = function(n) {
        if (!this.baseTokens) return null;
        while(this.baseTokens[this.baseTokenPos] <= n)this.baseTokenPos += 2;
        var type = this.baseTokens[this.baseTokenPos + 1];
        return {
            type: type && type.replace(/( |^)overlay .*/, ""),
            size: this.baseTokens[this.baseTokenPos] - n
        };
    };
    Context.prototype.nextLine = function() {
        this.line++;
        if (this.maxLookAhead > 0) this.maxLookAhead--;
    };
    Context.fromSaved = function(doc, saved, line) {
        if (saved instanceof SavedContext) return new Context(doc, copyState(doc.mode, saved.state), line, saved.lookAhead);
        else return new Context(doc, copyState(doc.mode, saved), line);
    };
    Context.prototype.save = function(copy) {
        var state = copy !== false ? copyState(this.doc.mode, this.state) : this.state;
        return this.maxLookAhead > 0 ? new SavedContext(state, this.maxLookAhead) : state;
    };
    // Compute a style array (an array starting with a mode generation
    // -- for invalidation -- followed by pairs of end positions and
    // style strings), which is used to highlight the tokens on the
    // line.
    function highlightLine(cm, line, context, forceToEnd) {
        // A styles array always starts with a number identifying the
        // mode/overlays that it is based on (for easy invalidation).
        var st = [
            cm.state.modeGen
        ], lineClasses = {};
        // Compute the base array of styles
        runMode(cm, line.text, cm.doc.mode, context, function(end, style) {
            return st.push(end, style);
        }, lineClasses, forceToEnd);
        var state = context.state;
        // Run overlays, adjust style array.
        var loop = function(o) {
            context.baseTokens = st;
            var overlay = cm.state.overlays[o], i = 1, at = 0;
            context.state = true;
            runMode(cm, line.text, overlay.mode, context, function(end, style) {
                var start = i;
                // Ensure there's a token end at the current position, and that i points at it
                while(at < end){
                    var i_end = st[i];
                    if (i_end > end) st.splice(i, 1, end, st[i + 1], i_end);
                    i += 2;
                    at = Math.min(end, i_end);
                }
                if (!style) return;
                if (overlay.opaque) {
                    st.splice(start, i - start, end, "overlay " + style);
                    i = start + 2;
                } else for(; start < i; start += 2){
                    var cur = st[start + 1];
                    st[start + 1] = (cur ? cur + " " : "") + "overlay " + style;
                }
            }, lineClasses);
            context.state = state;
            context.baseTokens = null;
            context.baseTokenPos = 1;
        };
        for(var o = 0; o < cm.state.overlays.length; ++o)loop(o);
        return {
            styles: st,
            classes: lineClasses.bgClass || lineClasses.textClass ? lineClasses : null
        };
    }
    function getLineStyles(cm, line, updateFrontier) {
        if (!line.styles || line.styles[0] != cm.state.modeGen) {
            var context = getContextBefore(cm, lineNo(line));
            var resetState = line.text.length > cm.options.maxHighlightLength && copyState(cm.doc.mode, context.state);
            var result = highlightLine(cm, line, context);
            if (resetState) context.state = resetState;
            line.stateAfter = context.save(!resetState);
            line.styles = result.styles;
            if (result.classes) line.styleClasses = result.classes;
            else if (line.styleClasses) line.styleClasses = null;
            if (updateFrontier === cm.doc.highlightFrontier) cm.doc.modeFrontier = Math.max(cm.doc.modeFrontier, ++cm.doc.highlightFrontier);
        }
        return line.styles;
    }
    function getContextBefore(cm, n, precise) {
        var doc = cm.doc, display = cm.display;
        if (!doc.mode.startState) return new Context(doc, true, n);
        var start = findStartLine(cm, n, precise);
        var saved = start > doc.first && getLine(doc, start - 1).stateAfter;
        var context = saved ? Context.fromSaved(doc, saved, start) : new Context(doc, startState(doc.mode), start);
        doc.iter(start, n, function(line) {
            processLine(cm, line.text, context);
            var pos = context.line;
            line.stateAfter = pos == n - 1 || pos % 5 == 0 || pos >= display.viewFrom && pos < display.viewTo ? context.save() : null;
            context.nextLine();
        });
        if (precise) doc.modeFrontier = context.line;
        return context;
    }
    // Lightweight form of highlight -- proceed over this line and
    // update state, but don't save a style array. Used for lines that
    // aren't currently visible.
    function processLine(cm, text, context, startAt) {
        var mode = cm.doc.mode;
        var stream = new StringStream(text, cm.options.tabSize, context);
        stream.start = stream.pos = startAt || 0;
        if (text == "") callBlankLine(mode, context.state);
        while(!stream.eol()){
            readToken(mode, stream, context.state);
            stream.start = stream.pos;
        }
    }
    function callBlankLine(mode, state) {
        if (mode.blankLine) return mode.blankLine(state);
        if (!mode.innerMode) return;
        var inner = innerMode(mode, state);
        if (inner.mode.blankLine) return inner.mode.blankLine(inner.state);
    }
    function readToken(mode, stream, state, inner) {
        for(var i = 0; i < 10; i++){
            if (inner) inner[0] = innerMode(mode, state).mode;
            var style = mode.token(stream, state);
            if (stream.pos > stream.start) return style;
        }
        throw new Error("Mode " + mode.name + " failed to advance stream.");
    }
    var Token = function(stream, type, state) {
        this.start = stream.start;
        this.end = stream.pos;
        this.string = stream.current();
        this.type = type || null;
        this.state = state;
    };
    // Utility for getTokenAt and getLineTokens
    function takeToken(cm, pos, precise, asArray) {
        var doc = cm.doc, mode = doc.mode, style;
        pos = clipPos(doc, pos);
        var line = getLine(doc, pos.line), context = getContextBefore(cm, pos.line, precise);
        var stream = new StringStream(line.text, cm.options.tabSize, context), tokens;
        if (asArray) tokens = [];
        while((asArray || stream.pos < pos.ch) && !stream.eol()){
            stream.start = stream.pos;
            style = readToken(mode, stream, context.state);
            if (asArray) tokens.push(new Token(stream, style, copyState(doc.mode, context.state)));
        }
        return asArray ? tokens : new Token(stream, style, context.state);
    }
    function extractLineClasses(type, output) {
        if (type) for(;;){
            var lineClass = type.match(/(?:^|\s+)line-(background-)?(\S+)/);
            if (!lineClass) break;
            type = type.slice(0, lineClass.index) + type.slice(lineClass.index + lineClass[0].length);
            var prop = lineClass[1] ? "bgClass" : "textClass";
            if (output[prop] == null) output[prop] = lineClass[2];
            else if (!new RegExp("(?:^|\\s)" + lineClass[2] + "(?:$|\\s)").test(output[prop])) output[prop] += " " + lineClass[2];
        }
        return type;
    }
    // Run the given mode's parser over a line, calling f for each token.
    function runMode(cm, text, mode, context, f, lineClasses, forceToEnd) {
        var flattenSpans = mode.flattenSpans;
        if (flattenSpans == null) flattenSpans = cm.options.flattenSpans;
        var curStart = 0, curStyle = null;
        var stream = new StringStream(text, cm.options.tabSize, context), style;
        var inner = cm.options.addModeClass && [
            null
        ];
        if (text == "") extractLineClasses(callBlankLine(mode, context.state), lineClasses);
        while(!stream.eol()){
            if (stream.pos > cm.options.maxHighlightLength) {
                flattenSpans = false;
                if (forceToEnd) processLine(cm, text, context, stream.pos);
                stream.pos = text.length;
                style = null;
            } else style = extractLineClasses(readToken(mode, stream, context.state, inner), lineClasses);
            if (inner) {
                var mName = inner[0].name;
                if (mName) style = "m-" + (style ? mName + " " + style : mName);
            }
            if (!flattenSpans || curStyle != style) {
                while(curStart < stream.start){
                    curStart = Math.min(stream.start, curStart + 5000);
                    f(curStart, curStyle);
                }
                curStyle = style;
            }
            stream.start = stream.pos;
        }
        while(curStart < stream.pos){
            // Webkit seems to refuse to render text nodes longer than 57444
            // characters, and returns inaccurate measurements in nodes
            // starting around 5000 chars.
            var pos = Math.min(stream.pos, curStart + 5000);
            f(pos, curStyle);
            curStart = pos;
        }
    }
    // Finds the line to start with when starting a parse. Tries to
    // find a line with a stateAfter, so that it can start with a
    // valid state. If that fails, it returns the line with the
    // smallest indentation, which tends to need the least context to
    // parse correctly.
    function findStartLine(cm, n, precise) {
        var minindent, minline, doc = cm.doc;
        var lim = precise ? -1 : n - (cm.doc.mode.innerMode ? 1000 : 100);
        for(var search = n; search > lim; --search){
            if (search <= doc.first) return doc.first;
            var line = getLine(doc, search - 1), after = line.stateAfter;
            if (after && (!precise || search + (after instanceof SavedContext ? after.lookAhead : 0) <= doc.modeFrontier)) return search;
            var indented = countColumn(line.text, null, cm.options.tabSize);
            if (minline == null || minindent > indented) {
                minline = search - 1;
                minindent = indented;
            }
        }
        return minline;
    }
    function retreatFrontier(doc, n) {
        doc.modeFrontier = Math.min(doc.modeFrontier, n);
        if (doc.highlightFrontier < n - 10) return;
        var start = doc.first;
        for(var line = n - 1; line > start; line--){
            var saved = getLine(doc, line).stateAfter;
            // change is on 3
            // state on line 1 looked ahead 2 -- so saw 3
            // test 1 + 2 < 3 should cover this
            if (saved && (!(saved instanceof SavedContext) || line + saved.lookAhead < n)) {
                start = line + 1;
                break;
            }
        }
        doc.highlightFrontier = Math.min(doc.highlightFrontier, start);
    }
    // Optimize some code when these features are not used.
    var sawReadOnlySpans = false, sawCollapsedSpans = false;
    function seeReadOnlySpans() {
        sawReadOnlySpans = true;
    }
    function seeCollapsedSpans() {
        sawCollapsedSpans = true;
    }
    // TEXTMARKER SPANS
    function MarkedSpan(marker, from, to) {
        this.marker = marker;
        this.from = from;
        this.to = to;
    }
    // Search an array of spans for a span matching the given marker.
    function getMarkedSpanFor(spans, marker) {
        if (spans) for(var i = 0; i < spans.length; ++i){
            var span = spans[i];
            if (span.marker == marker) return span;
        }
    }
    // Remove a span from an array, returning undefined if no spans are
    // left (we don't store arrays for lines without spans).
    function removeMarkedSpan(spans, span) {
        var r;
        for(var i = 0; i < spans.length; ++i)if (spans[i] != span) (r || (r = [])).push(spans[i]);
        return r;
    }
    // Add a span to a line.
    function addMarkedSpan(line, span, op) {
        var inThisOp = op && window.WeakSet && (op.markedSpans || (op.markedSpans = new WeakSet));
        if (inThisOp && inThisOp.has(line.markedSpans)) line.markedSpans.push(span);
        else {
            line.markedSpans = line.markedSpans ? line.markedSpans.concat([
                span
            ]) : [
                span
            ];
            if (inThisOp) inThisOp.add(line.markedSpans);
        }
        span.marker.attachLine(line);
    }
    // Used for the algorithm that adjusts markers for a change in the
    // document. These functions cut an array of spans at a given
    // character position, returning an array of remaining chunks (or
    // undefined if nothing remains).
    function markedSpansBefore(old, startCh, isInsert) {
        var nw;
        if (old) for(var i = 0; i < old.length; ++i){
            var span = old[i], marker = span.marker;
            var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= startCh : span.from < startCh);
            if (startsBefore || span.from == startCh && marker.type == "bookmark" && (!isInsert || !span.marker.insertLeft)) {
                var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= startCh : span.to > startCh);
                (nw || (nw = [])).push(new MarkedSpan(marker, span.from, endsAfter ? null : span.to));
            }
        }
        return nw;
    }
    function markedSpansAfter(old, endCh, isInsert) {
        var nw;
        if (old) for(var i = 0; i < old.length; ++i){
            var span = old[i], marker = span.marker;
            var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= endCh : span.to > endCh);
            if (endsAfter || span.from == endCh && marker.type == "bookmark" && (!isInsert || span.marker.insertLeft)) {
                var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= endCh : span.from < endCh);
                (nw || (nw = [])).push(new MarkedSpan(marker, startsBefore ? null : span.from - endCh, span.to == null ? null : span.to - endCh));
            }
        }
        return nw;
    }
    // Given a change object, compute the new set of marker spans that
    // cover the line in which the change took place. Removes spans
    // entirely within the change, reconnects spans belonging to the
    // same marker that appear on both sides of the change, and cuts off
    // spans partially within the change. Returns an array of span
    // arrays with one element for each line in (after) the change.
    function stretchSpansOverChange(doc, change) {
        if (change.full) return null;
        var oldFirst = isLine(doc, change.from.line) && getLine(doc, change.from.line).markedSpans;
        var oldLast = isLine(doc, change.to.line) && getLine(doc, change.to.line).markedSpans;
        if (!oldFirst && !oldLast) return null;
        var startCh = change.from.ch, endCh = change.to.ch, isInsert = cmp(change.from, change.to) == 0;
        // Get the spans that 'stick out' on both sides
        var first = markedSpansBefore(oldFirst, startCh, isInsert);
        var last = markedSpansAfter(oldLast, endCh, isInsert);
        // Next, merge those two ends
        var sameLine = change.text.length == 1, offset = lst(change.text).length + (sameLine ? startCh : 0);
        if (first) // Fix up .to properties of first
        for(var i = 0; i < first.length; ++i){
            var span = first[i];
            if (span.to == null) {
                var found = getMarkedSpanFor(last, span.marker);
                if (!found) span.to = startCh;
                else if (sameLine) span.to = found.to == null ? null : found.to + offset;
            }
        }
        if (last) // Fix up .from in last (or move them into first in case of sameLine)
        for(var i$1 = 0; i$1 < last.length; ++i$1){
            var span$1 = last[i$1];
            if (span$1.to != null) span$1.to += offset;
            if (span$1.from == null) {
                var found$1 = getMarkedSpanFor(first, span$1.marker);
                if (!found$1) {
                    span$1.from = offset;
                    if (sameLine) (first || (first = [])).push(span$1);
                }
            } else {
                span$1.from += offset;
                if (sameLine) (first || (first = [])).push(span$1);
            }
        }
        // Make sure we didn't create any zero-length spans
        if (first) first = clearEmptySpans(first);
        if (last && last != first) last = clearEmptySpans(last);
        var newMarkers = [
            first
        ];
        if (!sameLine) {
            // Fill gap with whole-line-spans
            var gap = change.text.length - 2, gapMarkers;
            if (gap > 0 && first) {
                for(var i$2 = 0; i$2 < first.length; ++i$2)if (first[i$2].to == null) (gapMarkers || (gapMarkers = [])).push(new MarkedSpan(first[i$2].marker, null, null));
            }
            for(var i$3 = 0; i$3 < gap; ++i$3)newMarkers.push(gapMarkers);
            newMarkers.push(last);
        }
        return newMarkers;
    }
    // Remove spans that are empty and don't have a clearWhenEmpty
    // option of false.
    function clearEmptySpans(spans) {
        for(var i = 0; i < spans.length; ++i){
            var span = spans[i];
            if (span.from != null && span.from == span.to && span.marker.clearWhenEmpty !== false) spans.splice(i--, 1);
        }
        if (!spans.length) return null;
        return spans;
    }
    // Used to 'clip' out readOnly ranges when making a change.
    function removeReadOnlyRanges(doc, from, to) {
        var markers = null;
        doc.iter(from.line, to.line + 1, function(line) {
            if (line.markedSpans) for(var i = 0; i < line.markedSpans.length; ++i){
                var mark = line.markedSpans[i].marker;
                if (mark.readOnly && (!markers || indexOf(markers, mark) == -1)) (markers || (markers = [])).push(mark);
            }
        });
        if (!markers) return null;
        var parts = [
            {
                from: from,
                to: to
            }
        ];
        for(var i = 0; i < markers.length; ++i){
            var mk = markers[i], m = mk.find(0);
            for(var j = 0; j < parts.length; ++j){
                var p = parts[j];
                if (cmp(p.to, m.from) < 0 || cmp(p.from, m.to) > 0) continue;
                var newParts = [
                    j,
                    1
                ], dfrom = cmp(p.from, m.from), dto = cmp(p.to, m.to);
                if (dfrom < 0 || !mk.inclusiveLeft && !dfrom) newParts.push({
                    from: p.from,
                    to: m.from
                });
                if (dto > 0 || !mk.inclusiveRight && !dto) newParts.push({
                    from: m.to,
                    to: p.to
                });
                parts.splice.apply(parts, newParts);
                j += newParts.length - 3;
            }
        }
        return parts;
    }
    // Connect or disconnect spans from a line.
    function detachMarkedSpans(line) {
        var spans = line.markedSpans;
        if (!spans) return;
        for(var i = 0; i < spans.length; ++i)spans[i].marker.detachLine(line);
        line.markedSpans = null;
    }
    function attachMarkedSpans(line, spans) {
        if (!spans) return;
        for(var i = 0; i < spans.length; ++i)spans[i].marker.attachLine(line);
        line.markedSpans = spans;
    }
    // Helpers used when computing which overlapping collapsed span
    // counts as the larger one.
    function extraLeft(marker) {
        return marker.inclusiveLeft ? -1 : 0;
    }
    function extraRight(marker) {
        return marker.inclusiveRight ? 1 : 0;
    }
    // Returns a number indicating which of two overlapping collapsed
    // spans is larger (and thus includes the other). Falls back to
    // comparing ids when the spans cover exactly the same range.
    function compareCollapsedMarkers(a, b) {
        var lenDiff = a.lines.length - b.lines.length;
        if (lenDiff != 0) return lenDiff;
        var aPos = a.find(), bPos = b.find();
        var fromCmp = cmp(aPos.from, bPos.from) || extraLeft(a) - extraLeft(b);
        if (fromCmp) return -fromCmp;
        var toCmp = cmp(aPos.to, bPos.to) || extraRight(a) - extraRight(b);
        if (toCmp) return toCmp;
        return b.id - a.id;
    }
    // Find out whether a line ends or starts in a collapsed span. If
    // so, return the marker for that span.
    function collapsedSpanAtSide(line, start) {
        var sps = sawCollapsedSpans && line.markedSpans, found;
        if (sps) for(var sp = void 0, i = 0; i < sps.length; ++i){
            sp = sps[i];
            if (sp.marker.collapsed && (start ? sp.from : sp.to) == null && (!found || compareCollapsedMarkers(found, sp.marker) < 0)) found = sp.marker;
        }
        return found;
    }
    function collapsedSpanAtStart(line) {
        return collapsedSpanAtSide(line, true);
    }
    function collapsedSpanAtEnd(line) {
        return collapsedSpanAtSide(line, false);
    }
    function collapsedSpanAround(line, ch) {
        var sps = sawCollapsedSpans && line.markedSpans, found;
        if (sps) for(var i = 0; i < sps.length; ++i){
            var sp = sps[i];
            if (sp.marker.collapsed && (sp.from == null || sp.from < ch) && (sp.to == null || sp.to > ch) && (!found || compareCollapsedMarkers(found, sp.marker) < 0)) found = sp.marker;
        }
        return found;
    }
    // Test whether there exists a collapsed span that partially
    // overlaps (covers the start or end, but not both) of a new span.
    // Such overlap is not allowed.
    function conflictingCollapsedRange(doc, lineNo, from, to, marker) {
        var line = getLine(doc, lineNo);
        var sps = sawCollapsedSpans && line.markedSpans;
        if (sps) for(var i = 0; i < sps.length; ++i){
            var sp = sps[i];
            if (!sp.marker.collapsed) continue;
            var found = sp.marker.find(0);
            var fromCmp = cmp(found.from, from) || extraLeft(sp.marker) - extraLeft(marker);
            var toCmp = cmp(found.to, to) || extraRight(sp.marker) - extraRight(marker);
            if (fromCmp >= 0 && toCmp <= 0 || fromCmp <= 0 && toCmp >= 0) continue;
            if (fromCmp <= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.to, from) >= 0 : cmp(found.to, from) > 0) || fromCmp >= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.from, to) <= 0 : cmp(found.from, to) < 0)) return true;
        }
    }
    // A visual line is a line as drawn on the screen. Folding, for
    // example, can cause multiple logical lines to appear on the same
    // visual line. This finds the start of the visual line that the
    // given line is part of (usually that is the line itself).
    function visualLine(line) {
        var merged;
        while(merged = collapsedSpanAtStart(line))line = merged.find(-1, true).line;
        return line;
    }
    function visualLineEnd(line) {
        var merged;
        while(merged = collapsedSpanAtEnd(line))line = merged.find(1, true).line;
        return line;
    }
    // Returns an array of logical lines that continue the visual line
    // started by the argument, or undefined if there are no such lines.
    function visualLineContinued(line) {
        var merged, lines;
        while(merged = collapsedSpanAtEnd(line)){
            line = merged.find(1, true).line;
            (lines || (lines = [])).push(line);
        }
        return lines;
    }
    // Get the line number of the start of the visual line that the
    // given line number is part of.
    function visualLineNo(doc, lineN) {
        var line = getLine(doc, lineN), vis = visualLine(line);
        if (line == vis) return lineN;
        return lineNo(vis);
    }
    // Get the line number of the start of the next visual line after
    // the given line.
    function visualLineEndNo(doc, lineN) {
        if (lineN > doc.lastLine()) return lineN;
        var line = getLine(doc, lineN), merged;
        if (!lineIsHidden(doc, line)) return lineN;
        while(merged = collapsedSpanAtEnd(line))line = merged.find(1, true).line;
        return lineNo(line) + 1;
    }
    // Compute whether a line is hidden. Lines count as hidden when they
    // are part of a visual line that starts with another line, or when
    // they are entirely covered by collapsed, non-widget span.
    function lineIsHidden(doc, line) {
        var sps = sawCollapsedSpans && line.markedSpans;
        if (sps) for(var sp = void 0, i = 0; i < sps.length; ++i){
            sp = sps[i];
            if (!sp.marker.collapsed) continue;
            if (sp.from == null) return true;
            if (sp.marker.widgetNode) continue;
            if (sp.from == 0 && sp.marker.inclusiveLeft && lineIsHiddenInner(doc, line, sp)) return true;
        }
    }
    function lineIsHiddenInner(doc, line, span) {
        if (span.to == null) {
            var end = span.marker.find(1, true);
            return lineIsHiddenInner(doc, end.line, getMarkedSpanFor(end.line.markedSpans, span.marker));
        }
        if (span.marker.inclusiveRight && span.to == line.text.length) return true;
        for(var sp = void 0, i = 0; i < line.markedSpans.length; ++i){
            sp = line.markedSpans[i];
            if (sp.marker.collapsed && !sp.marker.widgetNode && sp.from == span.to && (sp.to == null || sp.to != span.from) && (sp.marker.inclusiveLeft || span.marker.inclusiveRight) && lineIsHiddenInner(doc, line, sp)) return true;
        }
    }
    // Find the height above the given line.
    function heightAtLine(lineObj) {
        lineObj = visualLine(lineObj);
        var h = 0, chunk = lineObj.parent;
        for(var i = 0; i < chunk.lines.length; ++i){
            var line = chunk.lines[i];
            if (line == lineObj) break;
            else h += line.height;
        }
        for(var p = chunk.parent; p; chunk = p, p = chunk.parent)for(var i$1 = 0; i$1 < p.children.length; ++i$1){
            var cur = p.children[i$1];
            if (cur == chunk) break;
            else h += cur.height;
        }
        return h;
    }
    // Compute the character length of a line, taking into account
    // collapsed ranges (see markText) that might hide parts, and join
    // other lines onto it.
    function lineLength(line) {
        if (line.height == 0) return 0;
        var len = line.text.length, merged, cur = line;
        while(merged = collapsedSpanAtStart(cur)){
            var found = merged.find(0, true);
            cur = found.from.line;
            len += found.from.ch - found.to.ch;
        }
        cur = line;
        while(merged = collapsedSpanAtEnd(cur)){
            var found$1 = merged.find(0, true);
            len -= cur.text.length - found$1.from.ch;
            cur = found$1.to.line;
            len += cur.text.length - found$1.to.ch;
        }
        return len;
    }
    // Find the longest line in the document.
    function findMaxLine(cm) {
        var d = cm.display, doc = cm.doc;
        d.maxLine = getLine(doc, doc.first);
        d.maxLineLength = lineLength(d.maxLine);
        d.maxLineChanged = true;
        doc.iter(function(line) {
            var len = lineLength(line);
            if (len > d.maxLineLength) {
                d.maxLineLength = len;
                d.maxLine = line;
            }
        });
    }
    // LINE DATA STRUCTURE
    // Line objects. These hold state related to a line, including
    // highlighting info (the styles array).
    var Line = function(text, markedSpans, estimateHeight) {
        this.text = text;
        attachMarkedSpans(this, markedSpans);
        this.height = estimateHeight ? estimateHeight(this) : 1;
    };
    Line.prototype.lineNo = function() {
        return lineNo(this);
    };
    eventMixin(Line);
    // Change the content (text, markers) of a line. Automatically
    // invalidates cached information and tries to re-estimate the
    // line's height.
    function updateLine(line, text, markedSpans, estimateHeight) {
        line.text = text;
        if (line.stateAfter) line.stateAfter = null;
        if (line.styles) line.styles = null;
        if (line.order != null) line.order = null;
        detachMarkedSpans(line);
        attachMarkedSpans(line, markedSpans);
        var estHeight = estimateHeight ? estimateHeight(line) : 1;
        if (estHeight != line.height) updateLineHeight(line, estHeight);
    }
    // Detach a line from the document tree and its markers.
    function cleanUpLine(line) {
        line.parent = null;
        detachMarkedSpans(line);
    }
    // Convert a style as returned by a mode (either null, or a string
    // containing one or more styles) to a CSS style. This is cached,
    // and also looks for line-wide styles.
    var styleToClassCache = {}, styleToClassCacheWithMode = {};
    function interpretTokenStyle(style, options) {
        if (!style || /^\s*$/.test(style)) return null;
        var cache = options.addModeClass ? styleToClassCacheWithMode : styleToClassCache;
        return cache[style] || (cache[style] = style.replace(/\S+/g, "cm-$&"));
    }
    // Render the DOM representation of the text of a line. Also builds
    // up a 'line map', which points at the DOM nodes that represent
    // specific stretches of text, and is used by the measuring code.
    // The returned object contains the DOM node, this map, and
    // information about line-wide styles that were set by the mode.
    function buildLineContent(cm, lineView) {
        // The padding-right forces the element to have a 'border', which
        // is needed on Webkit to be able to get line-level bounding
        // rectangles for it (in measureChar).
        var content = eltP("span", null, null, webkit ? "padding-right: .1px" : null);
        var builder = {
            pre: eltP("pre", [
                content
            ], "CodeMirror-line"),
            content: content,
            col: 0,
            pos: 0,
            cm: cm,
            trailingSpace: false,
            splitSpaces: cm.getOption("lineWrapping")
        };
        lineView.measure = {};
        // Iterate over the logical lines that make up this visual line.
        for(var i = 0; i <= (lineView.rest ? lineView.rest.length : 0); i++){
            var line = i ? lineView.rest[i - 1] : lineView.line, order = void 0;
            builder.pos = 0;
            builder.addToken = buildToken;
            // Optionally wire in some hacks into the token-rendering
            // algorithm, to deal with browser quirks.
            if (hasBadBidiRects(cm.display.measure) && (order = getOrder(line, cm.doc.direction))) builder.addToken = buildTokenBadBidi(builder.addToken, order);
            builder.map = [];
            var allowFrontierUpdate = lineView != cm.display.externalMeasured && lineNo(line);
            insertLineContent(line, builder, getLineStyles(cm, line, allowFrontierUpdate));
            if (line.styleClasses) {
                if (line.styleClasses.bgClass) builder.bgClass = joinClasses(line.styleClasses.bgClass, builder.bgClass || "");
                if (line.styleClasses.textClass) builder.textClass = joinClasses(line.styleClasses.textClass, builder.textClass || "");
            }
            // Ensure at least a single node is present, for measuring.
            if (builder.map.length == 0) builder.map.push(0, 0, builder.content.appendChild(zeroWidthElement(cm.display.measure)));
            // Store the map and a cache object for the current logical line
            if (i == 0) {
                lineView.measure.map = builder.map;
                lineView.measure.cache = {};
            } else {
                (lineView.measure.maps || (lineView.measure.maps = [])).push(builder.map);
                (lineView.measure.caches || (lineView.measure.caches = [])).push({});
            }
        }
        // See issue #2901
        if (webkit) {
            var last = builder.content.lastChild;
            if (/\bcm-tab\b/.test(last.className) || last.querySelector && last.querySelector(".cm-tab")) builder.content.className = "cm-tab-wrap-hack";
        }
        signal(cm, "renderLine", cm, lineView.line, builder.pre);
        if (builder.pre.className) builder.textClass = joinClasses(builder.pre.className, builder.textClass || "");
        return builder;
    }
    function defaultSpecialCharPlaceholder(ch) {
        var token = elt("span", "\u2022", "cm-invalidchar");
        token.title = "\\u" + ch.charCodeAt(0).toString(16);
        token.setAttribute("aria-label", token.title);
        return token;
    }
    // Build up the DOM representation for a single token, and add it to
    // the line map. Takes care to render special characters separately.
    function buildToken(builder, text, style, startStyle, endStyle, css, attributes) {
        if (!text) return;
        var displayText = builder.splitSpaces ? splitSpaces(text, builder.trailingSpace) : text;
        var special = builder.cm.state.specialChars, mustWrap = false;
        var content;
        if (!special.test(text)) {
            builder.col += text.length;
            content = document.createTextNode(displayText);
            builder.map.push(builder.pos, builder.pos + text.length, content);
            if (ie && ie_version < 9) mustWrap = true;
            builder.pos += text.length;
        } else {
            content = document.createDocumentFragment();
            var pos = 0;
            while(true){
                special.lastIndex = pos;
                var m = special.exec(text);
                var skipped = m ? m.index - pos : text.length - pos;
                if (skipped) {
                    var txt = document.createTextNode(displayText.slice(pos, pos + skipped));
                    if (ie && ie_version < 9) content.appendChild(elt("span", [
                        txt
                    ]));
                    else content.appendChild(txt);
                    builder.map.push(builder.pos, builder.pos + skipped, txt);
                    builder.col += skipped;
                    builder.pos += skipped;
                }
                if (!m) break;
                pos += skipped + 1;
                var txt$1 = void 0;
                if (m[0] == "\t") {
                    var tabSize = builder.cm.options.tabSize, tabWidth = tabSize - builder.col % tabSize;
                    txt$1 = content.appendChild(elt("span", spaceStr(tabWidth), "cm-tab"));
                    txt$1.setAttribute("role", "presentation");
                    txt$1.setAttribute("cm-text", "\t");
                    builder.col += tabWidth;
                } else if (m[0] == "\r" || m[0] == "\n") {
                    txt$1 = content.appendChild(elt("span", m[0] == "\r" ? "\u240d" : "\u2424", "cm-invalidchar"));
                    txt$1.setAttribute("cm-text", m[0]);
                    builder.col += 1;
                } else {
                    txt$1 = builder.cm.options.specialCharPlaceholder(m[0]);
                    txt$1.setAttribute("cm-text", m[0]);
                    if (ie && ie_version < 9) content.appendChild(elt("span", [
                        txt$1
                    ]));
                    else content.appendChild(txt$1);
                    builder.col += 1;
                }
                builder.map.push(builder.pos, builder.pos + 1, txt$1);
                builder.pos++;
            }
        }
        builder.trailingSpace = displayText.charCodeAt(text.length - 1) == 32;
        if (style || startStyle || endStyle || mustWrap || css || attributes) {
            var fullStyle = style || "";
            if (startStyle) fullStyle += startStyle;
            if (endStyle) fullStyle += endStyle;
            var token = elt("span", [
                content
            ], fullStyle, css);
            if (attributes) {
                for(var attr in attributes)if (attributes.hasOwnProperty(attr) && attr != "style" && attr != "class") token.setAttribute(attr, attributes[attr]);
            }
            return builder.content.appendChild(token);
        }
        builder.content.appendChild(content);
    }
    // Change some spaces to NBSP to prevent the browser from collapsing
    // trailing spaces at the end of a line when rendering text (issue #1362).
    function splitSpaces(text, trailingBefore) {
        if (text.length > 1 && !/  /.test(text)) return text;
        var spaceBefore = trailingBefore, result = "";
        for(var i = 0; i < text.length; i++){
            var ch = text.charAt(i);
            if (ch == " " && spaceBefore && (i == text.length - 1 || text.charCodeAt(i + 1) == 32)) ch = "\u00a0";
            result += ch;
            spaceBefore = ch == " ";
        }
        return result;
    }
    // Work around nonsense dimensions being reported for stretches of
    // right-to-left text.
    function buildTokenBadBidi(inner, order) {
        return function(builder, text, style, startStyle, endStyle, css, attributes) {
            style = style ? style + " cm-force-border" : "cm-force-border";
            var start = builder.pos, end = start + text.length;
            for(;;){
                // Find the part that overlaps with the start of this text
                var part = void 0;
                for(var i = 0; i < order.length; i++){
                    part = order[i];
                    if (part.to > start && part.from <= start) break;
                }
                if (part.to >= end) return inner(builder, text, style, startStyle, endStyle, css, attributes);
                inner(builder, text.slice(0, part.to - start), style, startStyle, null, css, attributes);
                startStyle = null;
                text = text.slice(part.to - start);
                start = part.to;
            }
        };
    }
    function buildCollapsedSpan(builder, size, marker, ignoreWidget) {
        var widget = !ignoreWidget && marker.widgetNode;
        if (widget) builder.map.push(builder.pos, builder.pos + size, widget);
        if (!ignoreWidget && builder.cm.display.input.needsContentAttribute) {
            if (!widget) widget = builder.content.appendChild(document.createElement("span"));
            widget.setAttribute("cm-marker", marker.id);
        }
        if (widget) {
            builder.cm.display.input.setUneditable(widget);
            builder.content.appendChild(widget);
        }
        builder.pos += size;
        builder.trailingSpace = false;
    }
    // Outputs a number of spans to make up a line, taking highlighting
    // and marked text into account.
    function insertLineContent(line, builder, styles) {
        var spans = line.markedSpans, allText = line.text, at = 0;
        if (!spans) {
            for(var i$1 = 1; i$1 < styles.length; i$1 += 2)builder.addToken(builder, allText.slice(at, at = styles[i$1]), interpretTokenStyle(styles[i$1 + 1], builder.cm.options));
            return;
        }
        var len = allText.length, pos = 0, i = 1, text = "", style, css;
        var nextChange = 0, spanStyle, spanEndStyle, spanStartStyle, collapsed, attributes;
        for(;;){
            if (nextChange == pos) {
                spanStyle = spanEndStyle = spanStartStyle = css = "";
                attributes = null;
                collapsed = null;
                nextChange = Infinity;
                var foundBookmarks = [], endStyles = void 0;
                for(var j = 0; j < spans.length; ++j){
                    var sp = spans[j], m = sp.marker;
                    if (m.type == "bookmark" && sp.from == pos && m.widgetNode) foundBookmarks.push(m);
                    else if (sp.from <= pos && (sp.to == null || sp.to > pos || m.collapsed && sp.to == pos && sp.from == pos)) {
                        if (sp.to != null && sp.to != pos && nextChange > sp.to) {
                            nextChange = sp.to;
                            spanEndStyle = "";
                        }
                        if (m.className) spanStyle += " " + m.className;
                        if (m.css) css = (css ? css + ";" : "") + m.css;
                        if (m.startStyle && sp.from == pos) spanStartStyle += " " + m.startStyle;
                        if (m.endStyle && sp.to == nextChange) (endStyles || (endStyles = [])).push(m.endStyle, sp.to);
                        // support for the old title property
                        // https://github.com/codemirror/CodeMirror/pull/5673
                        if (m.title) (attributes || (attributes = {})).title = m.title;
                        if (m.attributes) for(var attr in m.attributes)(attributes || (attributes = {}))[attr] = m.attributes[attr];
                        if (m.collapsed && (!collapsed || compareCollapsedMarkers(collapsed.marker, m) < 0)) collapsed = sp;
                    } else if (sp.from > pos && nextChange > sp.from) nextChange = sp.from;
                }
                if (endStyles) {
                    for(var j$1 = 0; j$1 < endStyles.length; j$1 += 2)if (endStyles[j$1 + 1] == nextChange) spanEndStyle += " " + endStyles[j$1];
                }
                if (!collapsed || collapsed.from == pos) for(var j$2 = 0; j$2 < foundBookmarks.length; ++j$2)buildCollapsedSpan(builder, 0, foundBookmarks[j$2]);
                if (collapsed && (collapsed.from || 0) == pos) {
                    buildCollapsedSpan(builder, (collapsed.to == null ? len + 1 : collapsed.to) - pos, collapsed.marker, collapsed.from == null);
                    if (collapsed.to == null) return;
                    if (collapsed.to == pos) collapsed = false;
                }
            }
            if (pos >= len) break;
            var upto = Math.min(len, nextChange);
            while(true){
                if (text) {
                    var end = pos + text.length;
                    if (!collapsed) {
                        var tokenText = end > upto ? text.slice(0, upto - pos) : text;
                        builder.addToken(builder, tokenText, style ? style + spanStyle : spanStyle, spanStartStyle, pos + tokenText.length == nextChange ? spanEndStyle : "", css, attributes);
                    }
                    if (end >= upto) {
                        text = text.slice(upto - pos);
                        pos = upto;
                        break;
                    }
                    pos = end;
                    spanStartStyle = "";
                }
                text = allText.slice(at, at = styles[i++]);
                style = interpretTokenStyle(styles[i++], builder.cm.options);
            }
        }
    }
    // These objects are used to represent the visible (currently drawn)
    // part of the document. A LineView may correspond to multiple
    // logical lines, if those are connected by collapsed ranges.
    function LineView(doc, line, lineN) {
        // The starting line
        this.line = line;
        // Continuing lines, if any
        this.rest = visualLineContinued(line);
        // Number of logical lines in this visual line
        this.size = this.rest ? lineNo(lst(this.rest)) - lineN + 1 : 1;
        this.node = this.text = null;
        this.hidden = lineIsHidden(doc, line);
    }
    // Create a range of LineView objects for the given lines.
    function buildViewArray(cm, from, to) {
        var array = [], nextPos;
        for(var pos = from; pos < to; pos = nextPos){
            var view = new LineView(cm.doc, getLine(cm.doc, pos), pos);
            nextPos = pos + view.size;
            array.push(view);
        }
        return array;
    }
    var operationGroup = null;
    function pushOperation(op) {
        if (operationGroup) operationGroup.ops.push(op);
        else op.ownsGroup = operationGroup = {
            ops: [
                op
            ],
            delayedCallbacks: []
        };
    }
    function fireCallbacksForOps(group) {
        // Calls delayed callbacks and cursorActivity handlers until no
        // new ones appear
        var callbacks = group.delayedCallbacks, i = 0;
        do {
            for(; i < callbacks.length; i++)callbacks[i].call(null);
            for(var j = 0; j < group.ops.length; j++){
                var op = group.ops[j];
                if (op.cursorActivityHandlers) while(op.cursorActivityCalled < op.cursorActivityHandlers.length)op.cursorActivityHandlers[op.cursorActivityCalled++].call(null, op.cm);
            }
        }while (i < callbacks.length);
    }
    function finishOperation(op, endCb) {
        var group = op.ownsGroup;
        if (!group) return;
        try {
            fireCallbacksForOps(group);
        } finally{
            operationGroup = null;
            endCb(group);
        }
    }
    var orphanDelayedCallbacks = null;
    // Often, we want to signal events at a point where we are in the
    // middle of some work, but don't want the handler to start calling
    // other methods on the editor, which might be in an inconsistent
    // state or simply not expect any other events to happen.
    // signalLater looks whether there are any handlers, and schedules
    // them to be executed when the last operation ends, or, if no
    // operation is active, when a timeout fires.
    function signalLater(emitter, type /*, values...*/ ) {
        var arr = getHandlers(emitter, type);
        if (!arr.length) return;
        var args = Array.prototype.slice.call(arguments, 2), list;
        if (operationGroup) list = operationGroup.delayedCallbacks;
        else if (orphanDelayedCallbacks) list = orphanDelayedCallbacks;
        else {
            list = orphanDelayedCallbacks = [];
            setTimeout(fireOrphanDelayed, 0);
        }
        var loop = function(i) {
            list.push(function() {
                return arr[i].apply(null, args);
            });
        };
        for(var i = 0; i < arr.length; ++i)loop(i);
    }
    function fireOrphanDelayed() {
        var delayed = orphanDelayedCallbacks;
        orphanDelayedCallbacks = null;
        for(var i = 0; i < delayed.length; ++i)delayed[i]();
    }
    // When an aspect of a line changes, a string is added to
    // lineView.changes. This updates the relevant part of the line's
    // DOM structure.
    function updateLineForChanges(cm, lineView, lineN, dims) {
        for(var j = 0; j < lineView.changes.length; j++){
            var type = lineView.changes[j];
            if (type == "text") updateLineText(cm, lineView);
            else if (type == "gutter") updateLineGutter(cm, lineView, lineN, dims);
            else if (type == "class") updateLineClasses(cm, lineView);
            else if (type == "widget") updateLineWidgets(cm, lineView, dims);
        }
        lineView.changes = null;
    }
    // Lines with gutter elements, widgets or a background class need to
    // be wrapped, and have the extra elements added to the wrapper div
    function ensureLineWrapped(lineView) {
        if (lineView.node == lineView.text) {
            lineView.node = elt("div", null, null, "position: relative");
            if (lineView.text.parentNode) lineView.text.parentNode.replaceChild(lineView.node, lineView.text);
            lineView.node.appendChild(lineView.text);
            if (ie && ie_version < 8) lineView.node.style.zIndex = 2;
        }
        return lineView.node;
    }
    function updateLineBackground(cm, lineView) {
        var cls = lineView.bgClass ? lineView.bgClass + " " + (lineView.line.bgClass || "") : lineView.line.bgClass;
        if (cls) cls += " CodeMirror-linebackground";
        if (lineView.background) {
            if (cls) lineView.background.className = cls;
            else {
                lineView.background.parentNode.removeChild(lineView.background);
                lineView.background = null;
            }
        } else if (cls) {
            var wrap = ensureLineWrapped(lineView);
            lineView.background = wrap.insertBefore(elt("div", null, cls), wrap.firstChild);
            cm.display.input.setUneditable(lineView.background);
        }
    }
    // Wrapper around buildLineContent which will reuse the structure
    // in display.externalMeasured when possible.
    function getLineContent(cm, lineView) {
        var ext = cm.display.externalMeasured;
        if (ext && ext.line == lineView.line) {
            cm.display.externalMeasured = null;
            lineView.measure = ext.measure;
            return ext.built;
        }
        return buildLineContent(cm, lineView);
    }
    // Redraw the line's text. Interacts with the background and text
    // classes because the mode may output tokens that influence these
    // classes.
    function updateLineText(cm, lineView) {
        var cls = lineView.text.className;
        var built = getLineContent(cm, lineView);
        if (lineView.text == lineView.node) lineView.node = built.pre;
        lineView.text.parentNode.replaceChild(built.pre, lineView.text);
        lineView.text = built.pre;
        if (built.bgClass != lineView.bgClass || built.textClass != lineView.textClass) {
            lineView.bgClass = built.bgClass;
            lineView.textClass = built.textClass;
            updateLineClasses(cm, lineView);
        } else if (cls) lineView.text.className = cls;
    }
    function updateLineClasses(cm, lineView) {
        updateLineBackground(cm, lineView);
        if (lineView.line.wrapClass) ensureLineWrapped(lineView).className = lineView.line.wrapClass;
        else if (lineView.node != lineView.text) lineView.node.className = "";
        var textClass = lineView.textClass ? lineView.textClass + " " + (lineView.line.textClass || "") : lineView.line.textClass;
        lineView.text.className = textClass || "";
    }
    function updateLineGutter(cm, lineView, lineN, dims) {
        if (lineView.gutter) {
            lineView.node.removeChild(lineView.gutter);
            lineView.gutter = null;
        }
        if (lineView.gutterBackground) {
            lineView.node.removeChild(lineView.gutterBackground);
            lineView.gutterBackground = null;
        }
        if (lineView.line.gutterClass) {
            var wrap = ensureLineWrapped(lineView);
            lineView.gutterBackground = elt("div", null, "CodeMirror-gutter-background " + lineView.line.gutterClass, "left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px; width: " + dims.gutterTotalWidth + "px");
            cm.display.input.setUneditable(lineView.gutterBackground);
            wrap.insertBefore(lineView.gutterBackground, lineView.text);
        }
        var markers = lineView.line.gutterMarkers;
        if (cm.options.lineNumbers || markers) {
            var wrap$1 = ensureLineWrapped(lineView);
            var gutterWrap = lineView.gutter = elt("div", null, "CodeMirror-gutter-wrapper", "left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px");
            gutterWrap.setAttribute("aria-hidden", "true");
            cm.display.input.setUneditable(gutterWrap);
            wrap$1.insertBefore(gutterWrap, lineView.text);
            if (lineView.line.gutterClass) gutterWrap.className += " " + lineView.line.gutterClass;
            if (cm.options.lineNumbers && (!markers || !markers["CodeMirror-linenumbers"])) lineView.lineNumber = gutterWrap.appendChild(elt("div", lineNumberFor(cm.options, lineN), "CodeMirror-linenumber CodeMirror-gutter-elt", "left: " + dims.gutterLeft["CodeMirror-linenumbers"] + "px; width: " + cm.display.lineNumInnerWidth + "px"));
            if (markers) for(var k = 0; k < cm.display.gutterSpecs.length; ++k){
                var id = cm.display.gutterSpecs[k].className, found = markers.hasOwnProperty(id) && markers[id];
                if (found) gutterWrap.appendChild(elt("div", [
                    found
                ], "CodeMirror-gutter-elt", "left: " + dims.gutterLeft[id] + "px; width: " + dims.gutterWidth[id] + "px"));
            }
        }
    }
    function updateLineWidgets(cm, lineView, dims) {
        if (lineView.alignable) lineView.alignable = null;
        var isWidget = classTest("CodeMirror-linewidget");
        for(var node = lineView.node.firstChild, next = void 0; node; node = next){
            next = node.nextSibling;
            if (isWidget.test(node.className)) lineView.node.removeChild(node);
        }
        insertLineWidgets(cm, lineView, dims);
    }
    // Build a line's DOM representation from scratch
    function buildLineElement(cm, lineView, lineN, dims) {
        var built = getLineContent(cm, lineView);
        lineView.text = lineView.node = built.pre;
        if (built.bgClass) lineView.bgClass = built.bgClass;
        if (built.textClass) lineView.textClass = built.textClass;
        updateLineClasses(cm, lineView);
        updateLineGutter(cm, lineView, lineN, dims);
        insertLineWidgets(cm, lineView, dims);
        return lineView.node;
    }
    // A lineView may contain multiple logical lines (when merged by
    // collapsed spans). The widgets for all of them need to be drawn.
    function insertLineWidgets(cm, lineView, dims) {
        insertLineWidgetsFor(cm, lineView.line, lineView, dims, true);
        if (lineView.rest) for(var i = 0; i < lineView.rest.length; i++)insertLineWidgetsFor(cm, lineView.rest[i], lineView, dims, false);
    }
    function insertLineWidgetsFor(cm, line, lineView, dims, allowAbove) {
        if (!line.widgets) return;
        var wrap = ensureLineWrapped(lineView);
        for(var i = 0, ws = line.widgets; i < ws.length; ++i){
            var widget = ws[i], node = elt("div", [
                widget.node
            ], "CodeMirror-linewidget" + (widget.className ? " " + widget.className : ""));
            if (!widget.handleMouseEvents) node.setAttribute("cm-ignore-events", "true");
            positionLineWidget(widget, node, lineView, dims);
            cm.display.input.setUneditable(node);
            if (allowAbove && widget.above) wrap.insertBefore(node, lineView.gutter || lineView.text);
            else wrap.appendChild(node);
            signalLater(widget, "redraw");
        }
    }
    function positionLineWidget(widget, node, lineView, dims) {
        if (widget.noHScroll) {
            (lineView.alignable || (lineView.alignable = [])).push(node);
            var width = dims.wrapperWidth;
            node.style.left = dims.fixedPos + "px";
            if (!widget.coverGutter) {
                width -= dims.gutterTotalWidth;
                node.style.paddingLeft = dims.gutterTotalWidth + "px";
            }
            node.style.width = width + "px";
        }
        if (widget.coverGutter) {
            node.style.zIndex = 5;
            node.style.position = "relative";
            if (!widget.noHScroll) node.style.marginLeft = -dims.gutterTotalWidth + "px";
        }
    }
    function widgetHeight(widget) {
        if (widget.height != null) return widget.height;
        var cm = widget.doc.cm;
        if (!cm) return 0;
        if (!contains(document.body, widget.node)) {
            var parentStyle = "position: relative;";
            if (widget.coverGutter) parentStyle += "margin-left: -" + cm.display.gutters.offsetWidth + "px;";
            if (widget.noHScroll) parentStyle += "width: " + cm.display.wrapper.clientWidth + "px;";
            removeChildrenAndAdd(cm.display.measure, elt("div", [
                widget.node
            ], null, parentStyle));
        }
        return widget.height = widget.node.parentNode.offsetHeight;
    }
    // Return true when the given mouse event happened in a widget
    function eventInWidget(display, e) {
        for(var n = e_target(e); n != display.wrapper; n = n.parentNode){
            if (!n || n.nodeType == 1 && n.getAttribute("cm-ignore-events") == "true" || n.parentNode == display.sizer && n != display.mover) return true;
        }
    }
    // POSITION MEASUREMENT
    function paddingTop(display) {
        return display.lineSpace.offsetTop;
    }
    function paddingVert(display) {
        return display.mover.offsetHeight - display.lineSpace.offsetHeight;
    }
    function paddingH(display) {
        if (display.cachedPaddingH) return display.cachedPaddingH;
        var e = removeChildrenAndAdd(display.measure, elt("pre", "x", "CodeMirror-line-like"));
        var style = window.getComputedStyle ? window.getComputedStyle(e) : e.currentStyle;
        var data = {
            left: parseInt(style.paddingLeft),
            right: parseInt(style.paddingRight)
        };
        if (!isNaN(data.left) && !isNaN(data.right)) display.cachedPaddingH = data;
        return data;
    }
    function scrollGap(cm) {
        return scrollerGap - cm.display.nativeBarWidth;
    }
    function displayWidth(cm) {
        return cm.display.scroller.clientWidth - scrollGap(cm) - cm.display.barWidth;
    }
    function displayHeight(cm) {
        return cm.display.scroller.clientHeight - scrollGap(cm) - cm.display.barHeight;
    }
    // Ensure the lineView.wrapping.heights array is populated. This is
    // an array of bottom offsets for the lines that make up a drawn
    // line. When lineWrapping is on, there might be more than one
    // height.
    function ensureLineHeights(cm, lineView, rect) {
        var wrapping = cm.options.lineWrapping;
        var curWidth = wrapping && displayWidth(cm);
        if (!lineView.measure.heights || wrapping && lineView.measure.width != curWidth) {
            var heights = lineView.measure.heights = [];
            if (wrapping) {
                lineView.measure.width = curWidth;
                var rects = lineView.text.firstChild.getClientRects();
                for(var i = 0; i < rects.length - 1; i++){
                    var cur = rects[i], next = rects[i + 1];
                    if (Math.abs(cur.bottom - next.bottom) > 2) heights.push((cur.bottom + next.top) / 2 - rect.top);
                }
            }
            heights.push(rect.bottom - rect.top);
        }
    }
    // Find a line map (mapping character offsets to text nodes) and a
    // measurement cache for the given line number. (A line view might
    // contain multiple lines when collapsed ranges are present.)
    function mapFromLineView(lineView, line, lineN) {
        if (lineView.line == line) return {
            map: lineView.measure.map,
            cache: lineView.measure.cache
        };
        if (lineView.rest) {
            for(var i = 0; i < lineView.rest.length; i++){
                if (lineView.rest[i] == line) return {
                    map: lineView.measure.maps[i],
                    cache: lineView.measure.caches[i]
                };
            }
            for(var i$1 = 0; i$1 < lineView.rest.length; i$1++){
                if (lineNo(lineView.rest[i$1]) > lineN) return {
                    map: lineView.measure.maps[i$1],
                    cache: lineView.measure.caches[i$1],
                    before: true
                };
            }
        }
    }
    // Render a line into the hidden node display.externalMeasured. Used
    // when measurement is needed for a line that's not in the viewport.
    function updateExternalMeasurement(cm, line) {
        line = visualLine(line);
        var lineN = lineNo(line);
        var view = cm.display.externalMeasured = new LineView(cm.doc, line, lineN);
        view.lineN = lineN;
        var built = view.built = buildLineContent(cm, view);
        view.text = built.pre;
        removeChildrenAndAdd(cm.display.lineMeasure, built.pre);
        return view;
    }
    // Get a {top, bottom, left, right} box (in line-local coordinates)
    // for a given character.
    function measureChar(cm, line, ch, bias) {
        return measureCharPrepared(cm, prepareMeasureForLine(cm, line), ch, bias);
    }
    // Find a line view that corresponds to the given line number.
    function findViewForLine(cm, lineN) {
        if (lineN >= cm.display.viewFrom && lineN < cm.display.viewTo) return cm.display.view[findViewIndex(cm, lineN)];
        var ext = cm.display.externalMeasured;
        if (ext && lineN >= ext.lineN && lineN < ext.lineN + ext.size) return ext;
    }
    // Measurement can be split in two steps, the set-up work that
    // applies to the whole line, and the measurement of the actual
    // character. Functions like coordsChar, that need to do a lot of
    // measurements in a row, can thus ensure that the set-up work is
    // only done once.
    function prepareMeasureForLine(cm, line) {
        var lineN = lineNo(line);
        var view = findViewForLine(cm, lineN);
        if (view && !view.text) view = null;
        else if (view && view.changes) {
            updateLineForChanges(cm, view, lineN, getDimensions(cm));
            cm.curOp.forceUpdate = true;
        }
        if (!view) view = updateExternalMeasurement(cm, line);
        var info = mapFromLineView(view, line, lineN);
        return {
            line: line,
            view: view,
            rect: null,
            map: info.map,
            cache: info.cache,
            before: info.before,
            hasHeights: false
        };
    }
    // Given a prepared measurement object, measures the position of an
    // actual character (or fetches it from the cache).
    function measureCharPrepared(cm, prepared, ch, bias, varHeight) {
        if (prepared.before) ch = -1;
        var key = ch + (bias || ""), found;
        if (prepared.cache.hasOwnProperty(key)) found = prepared.cache[key];
        else {
            if (!prepared.rect) prepared.rect = prepared.view.text.getBoundingClientRect();
            if (!prepared.hasHeights) {
                ensureLineHeights(cm, prepared.view, prepared.rect);
                prepared.hasHeights = true;
            }
            found = measureCharInner(cm, prepared, ch, bias);
            if (!found.bogus) prepared.cache[key] = found;
        }
        return {
            left: found.left,
            right: found.right,
            top: varHeight ? found.rtop : found.top,
            bottom: varHeight ? found.rbottom : found.bottom
        };
    }
    var nullRect = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
    };
    function nodeAndOffsetInLineMap(map, ch, bias) {
        var node, start, end, collapse, mStart, mEnd;
        // First, search the line map for the text node corresponding to,
        // or closest to, the target character.
        for(var i = 0; i < map.length; i += 3){
            mStart = map[i];
            mEnd = map[i + 1];
            if (ch < mStart) {
                start = 0;
                end = 1;
                collapse = "left";
            } else if (ch < mEnd) {
                start = ch - mStart;
                end = start + 1;
            } else if (i == map.length - 3 || ch == mEnd && map[i + 3] > ch) {
                end = mEnd - mStart;
                start = end - 1;
                if (ch >= mEnd) collapse = "right";
            }
            if (start != null) {
                node = map[i + 2];
                if (mStart == mEnd && bias == (node.insertLeft ? "left" : "right")) collapse = bias;
                if (bias == "left" && start == 0) while(i && map[i - 2] == map[i - 3] && map[i - 1].insertLeft){
                    node = map[(i -= 3) + 2];
                    collapse = "left";
                }
                if (bias == "right" && start == mEnd - mStart) while(i < map.length - 3 && map[i + 3] == map[i + 4] && !map[i + 5].insertLeft){
                    node = map[(i += 3) + 2];
                    collapse = "right";
                }
                break;
            }
        }
        return {
            node: node,
            start: start,
            end: end,
            collapse: collapse,
            coverStart: mStart,
            coverEnd: mEnd
        };
    }
    function getUsefulRect(rects, bias) {
        var rect = nullRect;
        if (bias == "left") for(var i = 0; i < rects.length; i++){
            if ((rect = rects[i]).left != rect.right) break;
        }
        else for(var i$1 = rects.length - 1; i$1 >= 0; i$1--){
            if ((rect = rects[i$1]).left != rect.right) break;
        }
        return rect;
    }
    function measureCharInner(cm, prepared, ch, bias) {
        var place = nodeAndOffsetInLineMap(prepared.map, ch, bias);
        var node = place.node, start = place.start, end = place.end, collapse = place.collapse;
        var rect;
        if (node.nodeType == 3) {
            for(var i$1 = 0; i$1 < 4; i$1++){
                while(start && isExtendingChar(prepared.line.text.charAt(place.coverStart + start)))--start;
                while(place.coverStart + end < place.coverEnd && isExtendingChar(prepared.line.text.charAt(place.coverStart + end)))++end;
                if (ie && ie_version < 9 && start == 0 && end == place.coverEnd - place.coverStart) rect = node.parentNode.getBoundingClientRect();
                else rect = getUsefulRect(range(node, start, end).getClientRects(), bias);
                if (rect.left || rect.right || start == 0) break;
                end = start;
                start = start - 1;
                collapse = "right";
            }
            if (ie && ie_version < 11) rect = maybeUpdateRectForZooming(cm.display.measure, rect);
        } else {
            if (start > 0) collapse = bias = "right";
            var rects;
            if (cm.options.lineWrapping && (rects = node.getClientRects()).length > 1) rect = rects[bias == "right" ? rects.length - 1 : 0];
            else rect = node.getBoundingClientRect();
        }
        if (ie && ie_version < 9 && !start && (!rect || !rect.left && !rect.right)) {
            var rSpan = node.parentNode.getClientRects()[0];
            if (rSpan) rect = {
                left: rSpan.left,
                right: rSpan.left + charWidth(cm.display),
                top: rSpan.top,
                bottom: rSpan.bottom
            };
            else rect = nullRect;
        }
        var rtop = rect.top - prepared.rect.top, rbot = rect.bottom - prepared.rect.top;
        var mid = (rtop + rbot) / 2;
        var heights = prepared.view.measure.heights;
        var i = 0;
        for(; i < heights.length - 1; i++){
            if (mid < heights[i]) break;
        }
        var top = i ? heights[i - 1] : 0, bot = heights[i];
        var result = {
            left: (collapse == "right" ? rect.right : rect.left) - prepared.rect.left,
            right: (collapse == "left" ? rect.left : rect.right) - prepared.rect.left,
            top: top,
            bottom: bot
        };
        if (!rect.left && !rect.right) result.bogus = true;
        if (!cm.options.singleCursorHeightPerLine) {
            result.rtop = rtop;
            result.rbottom = rbot;
        }
        return result;
    }
    // Work around problem with bounding client rects on ranges being
    // returned incorrectly when zoomed on IE10 and below.
    function maybeUpdateRectForZooming(measure, rect) {
        if (!window.screen || screen.logicalXDPI == null || screen.logicalXDPI == screen.deviceXDPI || !hasBadZoomedRects(measure)) return rect;
        var scaleX = screen.logicalXDPI / screen.deviceXDPI;
        var scaleY = screen.logicalYDPI / screen.deviceYDPI;
        return {
            left: rect.left * scaleX,
            right: rect.right * scaleX,
            top: rect.top * scaleY,
            bottom: rect.bottom * scaleY
        };
    }
    function clearLineMeasurementCacheFor(lineView) {
        if (lineView.measure) {
            lineView.measure.cache = {};
            lineView.measure.heights = null;
            if (lineView.rest) for(var i = 0; i < lineView.rest.length; i++)lineView.measure.caches[i] = {};
        }
    }
    function clearLineMeasurementCache(cm) {
        cm.display.externalMeasure = null;
        removeChildren(cm.display.lineMeasure);
        for(var i = 0; i < cm.display.view.length; i++)clearLineMeasurementCacheFor(cm.display.view[i]);
    }
    function clearCaches(cm) {
        clearLineMeasurementCache(cm);
        cm.display.cachedCharWidth = cm.display.cachedTextHeight = cm.display.cachedPaddingH = null;
        if (!cm.options.lineWrapping) cm.display.maxLineChanged = true;
        cm.display.lineNumChars = null;
    }
    function pageScrollX() {
        // Work around https://bugs.chromium.org/p/chromium/issues/detail?id=489206
        // which causes page_Offset and bounding client rects to use
        // different reference viewports and invalidate our calculations.
        if (chrome && android) return -(document.body.getBoundingClientRect().left - parseInt(getComputedStyle(document.body).marginLeft));
        return window.pageXOffset || (document.documentElement || document.body).scrollLeft;
    }
    function pageScrollY() {
        if (chrome && android) return -(document.body.getBoundingClientRect().top - parseInt(getComputedStyle(document.body).marginTop));
        return window.pageYOffset || (document.documentElement || document.body).scrollTop;
    }
    function widgetTopHeight(lineObj) {
        var ref = visualLine(lineObj);
        var widgets = ref.widgets;
        var height = 0;
        if (widgets) {
            for(var i = 0; i < widgets.length; ++i)if (widgets[i].above) height += widgetHeight(widgets[i]);
        }
        return height;
    }
    // Converts a {top, bottom, left, right} box from line-local
    // coordinates into another coordinate system. Context may be one of
    // "line", "div" (display.lineDiv), "local"./null (editor), "window",
    // or "page".
    function intoCoordSystem(cm, lineObj, rect, context, includeWidgets) {
        if (!includeWidgets) {
            var height = widgetTopHeight(lineObj);
            rect.top += height;
            rect.bottom += height;
        }
        if (context == "line") return rect;
        if (!context) context = "local";
        var yOff = heightAtLine(lineObj);
        if (context == "local") yOff += paddingTop(cm.display);
        else yOff -= cm.display.viewOffset;
        if (context == "page" || context == "window") {
            var lOff = cm.display.lineSpace.getBoundingClientRect();
            yOff += lOff.top + (context == "window" ? 0 : pageScrollY());
            var xOff = lOff.left + (context == "window" ? 0 : pageScrollX());
            rect.left += xOff;
            rect.right += xOff;
        }
        rect.top += yOff;
        rect.bottom += yOff;
        return rect;
    }
    // Coverts a box from "div" coords to another coordinate system.
    // Context may be "window", "page", "div", or "local"./null.
    function fromCoordSystem(cm, coords, context) {
        if (context == "div") return coords;
        var left = coords.left, top = coords.top;
        // First move into "page" coordinate system
        if (context == "page") {
            left -= pageScrollX();
            top -= pageScrollY();
        } else if (context == "local" || !context) {
            var localBox = cm.display.sizer.getBoundingClientRect();
            left += localBox.left;
            top += localBox.top;
        }
        var lineSpaceBox = cm.display.lineSpace.getBoundingClientRect();
        return {
            left: left - lineSpaceBox.left,
            top: top - lineSpaceBox.top
        };
    }
    function charCoords(cm, pos, context, lineObj, bias) {
        if (!lineObj) lineObj = getLine(cm.doc, pos.line);
        return intoCoordSystem(cm, lineObj, measureChar(cm, lineObj, pos.ch, bias), context);
    }
    // Returns a box for a given cursor position, which may have an
    // 'other' property containing the position of the secondary cursor
    // on a bidi boundary.
    // A cursor Pos(line, char, "before") is on the same visual line as `char - 1`
    // and after `char - 1` in writing order of `char - 1`
    // A cursor Pos(line, char, "after") is on the same visual line as `char`
    // and before `char` in writing order of `char`
    // Examples (upper-case letters are RTL, lower-case are LTR):
    //     Pos(0, 1, ...)
    //     before   after
    // ab     a|b     a|b
    // aB     a|B     aB|
    // Ab     |Ab     A|b
    // AB     B|A     B|A
    // Every position after the last character on a line is considered to stick
    // to the last character on the line.
    function cursorCoords(cm, pos, context, lineObj, preparedMeasure, varHeight) {
        lineObj = lineObj || getLine(cm.doc, pos.line);
        if (!preparedMeasure) preparedMeasure = prepareMeasureForLine(cm, lineObj);
        function get(ch, right) {
            var m = measureCharPrepared(cm, preparedMeasure, ch, right ? "right" : "left", varHeight);
            if (right) m.left = m.right;
            else m.right = m.left;
            return intoCoordSystem(cm, lineObj, m, context);
        }
        var order = getOrder(lineObj, cm.doc.direction), ch = pos.ch, sticky = pos.sticky;
        if (ch >= lineObj.text.length) {
            ch = lineObj.text.length;
            sticky = "before";
        } else if (ch <= 0) {
            ch = 0;
            sticky = "after";
        }
        if (!order) return get(sticky == "before" ? ch - 1 : ch, sticky == "before");
        function getBidi(ch, partPos, invert) {
            var part = order[partPos], right = part.level == 1;
            return get(invert ? ch - 1 : ch, right != invert);
        }
        var partPos = getBidiPartAt(order, ch, sticky);
        var other = bidiOther;
        var val = getBidi(ch, partPos, sticky == "before");
        if (other != null) val.other = getBidi(ch, other, sticky != "before");
        return val;
    }
    // Used to cheaply estimate the coordinates for a position. Used for
    // intermediate scroll updates.
    function estimateCoords(cm, pos) {
        var left = 0;
        pos = clipPos(cm.doc, pos);
        if (!cm.options.lineWrapping) left = charWidth(cm.display) * pos.ch;
        var lineObj = getLine(cm.doc, pos.line);
        var top = heightAtLine(lineObj) + paddingTop(cm.display);
        return {
            left: left,
            right: left,
            top: top,
            bottom: top + lineObj.height
        };
    }
    // Positions returned by coordsChar contain some extra information.
    // xRel is the relative x position of the input coordinates compared
    // to the found position (so xRel > 0 means the coordinates are to
    // the right of the character position, for example). When outside
    // is true, that means the coordinates lie outside the line's
    // vertical range.
    function PosWithInfo(line, ch, sticky, outside, xRel) {
        var pos = Pos(line, ch, sticky);
        pos.xRel = xRel;
        if (outside) pos.outside = outside;
        return pos;
    }
    // Compute the character position closest to the given coordinates.
    // Input must be lineSpace-local ("div" coordinate system).
    function coordsChar(cm, x, y) {
        var doc = cm.doc;
        y += cm.display.viewOffset;
        if (y < 0) return PosWithInfo(doc.first, 0, null, -1, -1);
        var lineN = lineAtHeight(doc, y), last = doc.first + doc.size - 1;
        if (lineN > last) return PosWithInfo(doc.first + doc.size - 1, getLine(doc, last).text.length, null, 1, 1);
        if (x < 0) x = 0;
        var lineObj = getLine(doc, lineN);
        for(;;){
            var found = coordsCharInner(cm, lineObj, lineN, x, y);
            var collapsed = collapsedSpanAround(lineObj, found.ch + (found.xRel > 0 || found.outside > 0 ? 1 : 0));
            if (!collapsed) return found;
            var rangeEnd = collapsed.find(1);
            if (rangeEnd.line == lineN) return rangeEnd;
            lineObj = getLine(doc, lineN = rangeEnd.line);
        }
    }
    function wrappedLineExtent(cm, lineObj, preparedMeasure, y) {
        y -= widgetTopHeight(lineObj);
        var end = lineObj.text.length;
        var begin = findFirst(function(ch) {
            return measureCharPrepared(cm, preparedMeasure, ch - 1).bottom <= y;
        }, end, 0);
        end = findFirst(function(ch) {
            return measureCharPrepared(cm, preparedMeasure, ch).top > y;
        }, begin, end);
        return {
            begin: begin,
            end: end
        };
    }
    function wrappedLineExtentChar(cm, lineObj, preparedMeasure, target) {
        if (!preparedMeasure) preparedMeasure = prepareMeasureForLine(cm, lineObj);
        var targetTop = intoCoordSystem(cm, lineObj, measureCharPrepared(cm, preparedMeasure, target), "line").top;
        return wrappedLineExtent(cm, lineObj, preparedMeasure, targetTop);
    }
    // Returns true if the given side of a box is after the given
    // coordinates, in top-to-bottom, left-to-right order.
    function boxIsAfter(box, x, y, left) {
        return box.bottom <= y ? false : box.top > y ? true : (left ? box.left : box.right) > x;
    }
    function coordsCharInner(cm, lineObj, lineNo, x, y) {
        // Move y into line-local coordinate space
        y -= heightAtLine(lineObj);
        var preparedMeasure = prepareMeasureForLine(cm, lineObj);
        // When directly calling `measureCharPrepared`, we have to adjust
        // for the widgets at this line.
        var widgetHeight = widgetTopHeight(lineObj);
        var begin = 0, end = lineObj.text.length, ltr = true;
        var order = getOrder(lineObj, cm.doc.direction);
        // If the line isn't plain left-to-right text, first figure out
        // which bidi section the coordinates fall into.
        if (order) {
            var part = (cm.options.lineWrapping ? coordsBidiPartWrapped : coordsBidiPart)(cm, lineObj, lineNo, preparedMeasure, order, x, y);
            ltr = part.level != 1;
            // The awkward -1 offsets are needed because findFirst (called
            // on these below) will treat its first bound as inclusive,
            // second as exclusive, but we want to actually address the
            // characters in the part's range
            begin = ltr ? part.from : part.to - 1;
            end = ltr ? part.to : part.from - 1;
        }
        // A binary search to find the first character whose bounding box
        // starts after the coordinates. If we run across any whose box wrap
        // the coordinates, store that.
        var chAround = null, boxAround = null;
        var ch = findFirst(function(ch) {
            var box = measureCharPrepared(cm, preparedMeasure, ch);
            box.top += widgetHeight;
            box.bottom += widgetHeight;
            if (!boxIsAfter(box, x, y, false)) return false;
            if (box.top <= y && box.left <= x) {
                chAround = ch;
                boxAround = box;
            }
            return true;
        }, begin, end);
        var baseX, sticky, outside = false;
        // If a box around the coordinates was found, use that
        if (boxAround) {
            // Distinguish coordinates nearer to the left or right side of the box
            var atLeft = x - boxAround.left < boxAround.right - x, atStart = atLeft == ltr;
            ch = chAround + (atStart ? 0 : 1);
            sticky = atStart ? "after" : "before";
            baseX = atLeft ? boxAround.left : boxAround.right;
        } else {
            // (Adjust for extended bound, if necessary.)
            if (!ltr && (ch == end || ch == begin)) ch++;
            // To determine which side to associate with, get the box to the
            // left of the character and compare it's vertical position to the
            // coordinates
            sticky = ch == 0 ? "after" : ch == lineObj.text.length ? "before" : measureCharPrepared(cm, preparedMeasure, ch - (ltr ? 1 : 0)).bottom + widgetHeight <= y == ltr ? "after" : "before";
            // Now get accurate coordinates for this place, in order to get a
            // base X position
            var coords = cursorCoords(cm, Pos(lineNo, ch, sticky), "line", lineObj, preparedMeasure);
            baseX = coords.left;
            outside = y < coords.top ? -1 : y >= coords.bottom ? 1 : 0;
        }
        ch = skipExtendingChars(lineObj.text, ch, 1);
        return PosWithInfo(lineNo, ch, sticky, outside, x - baseX);
    }
    function coordsBidiPart(cm, lineObj, lineNo, preparedMeasure, order, x, y) {
        // Bidi parts are sorted left-to-right, and in a non-line-wrapping
        // situation, we can take this ordering to correspond to the visual
        // ordering. This finds the first part whose end is after the given
        // coordinates.
        var index = findFirst(function(i) {
            var part = order[i], ltr = part.level != 1;
            return boxIsAfter(cursorCoords(cm, Pos(lineNo, ltr ? part.to : part.from, ltr ? "before" : "after"), "line", lineObj, preparedMeasure), x, y, true);
        }, 0, order.length - 1);
        var part = order[index];
        // If this isn't the first part, the part's start is also after
        // the coordinates, and the coordinates aren't on the same line as
        // that start, move one part back.
        if (index > 0) {
            var ltr = part.level != 1;
            var start = cursorCoords(cm, Pos(lineNo, ltr ? part.from : part.to, ltr ? "after" : "before"), "line", lineObj, preparedMeasure);
            if (boxIsAfter(start, x, y, true) && start.top > y) part = order[index - 1];
        }
        return part;
    }
    function coordsBidiPartWrapped(cm, lineObj, _lineNo, preparedMeasure, order, x, y) {
        // In a wrapped line, rtl text on wrapping boundaries can do things
        // that don't correspond to the ordering in our `order` array at
        // all, so a binary search doesn't work, and we want to return a
        // part that only spans one line so that the binary search in
        // coordsCharInner is safe. As such, we first find the extent of the
        // wrapped line, and then do a flat search in which we discard any
        // spans that aren't on the line.
        var ref = wrappedLineExtent(cm, lineObj, preparedMeasure, y);
        var begin = ref.begin;
        var end = ref.end;
        if (/\s/.test(lineObj.text.charAt(end - 1))) end--;
        var part = null, closestDist = null;
        for(var i = 0; i < order.length; i++){
            var p = order[i];
            if (p.from >= end || p.to <= begin) continue;
            var ltr = p.level != 1;
            var endX = measureCharPrepared(cm, preparedMeasure, ltr ? Math.min(end, p.to) - 1 : Math.max(begin, p.from)).right;
            // Weigh against spans ending before this, so that they are only
            // picked if nothing ends after
            var dist = endX < x ? x - endX + 1e9 : endX - x;
            if (!part || closestDist > dist) {
                part = p;
                closestDist = dist;
            }
        }
        if (!part) part = order[order.length - 1];
        // Clip the part to the wrapped line.
        if (part.from < begin) part = {
            from: begin,
            to: part.to,
            level: part.level
        };
        if (part.to > end) part = {
            from: part.from,
            to: end,
            level: part.level
        };
        return part;
    }
    var measureText;
    // Compute the default text height.
    function textHeight(display) {
        if (display.cachedTextHeight != null) return display.cachedTextHeight;
        if (measureText == null) {
            measureText = elt("pre", null, "CodeMirror-line-like");
            // Measure a bunch of lines, for browsers that compute
            // fractional heights.
            for(var i = 0; i < 49; ++i){
                measureText.appendChild(document.createTextNode("x"));
                measureText.appendChild(elt("br"));
            }
            measureText.appendChild(document.createTextNode("x"));
        }
        removeChildrenAndAdd(display.measure, measureText);
        var height = measureText.offsetHeight / 50;
        if (height > 3) display.cachedTextHeight = height;
        removeChildren(display.measure);
        return height || 1;
    }
    // Compute the default character width.
    function charWidth(display) {
        if (display.cachedCharWidth != null) return display.cachedCharWidth;
        var anchor = elt("span", "xxxxxxxxxx");
        var pre = elt("pre", [
            anchor
        ], "CodeMirror-line-like");
        removeChildrenAndAdd(display.measure, pre);
        var rect = anchor.getBoundingClientRect(), width = (rect.right - rect.left) / 10;
        if (width > 2) display.cachedCharWidth = width;
        return width || 10;
    }
    // Do a bulk-read of the DOM positions and sizes needed to draw the
    // view, so that we don't interleave reading and writing to the DOM.
    function getDimensions(cm) {
        var d = cm.display, left = {}, width = {};
        var gutterLeft = d.gutters.clientLeft;
        for(var n = d.gutters.firstChild, i = 0; n; n = n.nextSibling, ++i){
            var id = cm.display.gutterSpecs[i].className;
            left[id] = n.offsetLeft + n.clientLeft + gutterLeft;
            width[id] = n.clientWidth;
        }
        return {
            fixedPos: compensateForHScroll(d),
            gutterTotalWidth: d.gutters.offsetWidth,
            gutterLeft: left,
            gutterWidth: width,
            wrapperWidth: d.wrapper.clientWidth
        };
    }
    // Computes display.scroller.scrollLeft + display.gutters.offsetWidth,
    // but using getBoundingClientRect to get a sub-pixel-accurate
    // result.
    function compensateForHScroll(display) {
        return display.scroller.getBoundingClientRect().left - display.sizer.getBoundingClientRect().left;
    }
    // Returns a function that estimates the height of a line, to use as
    // first approximation until the line becomes visible (and is thus
    // properly measurable).
    function estimateHeight(cm) {
        var th = textHeight(cm.display), wrapping = cm.options.lineWrapping;
        var perLine = wrapping && Math.max(5, cm.display.scroller.clientWidth / charWidth(cm.display) - 3);
        return function(line) {
            if (lineIsHidden(cm.doc, line)) return 0;
            var widgetsHeight = 0;
            if (line.widgets) {
                for(var i = 0; i < line.widgets.length; i++)if (line.widgets[i].height) widgetsHeight += line.widgets[i].height;
            }
            if (wrapping) return widgetsHeight + (Math.ceil(line.text.length / perLine) || 1) * th;
            else return widgetsHeight + th;
        };
    }
    function estimateLineHeights(cm) {
        var doc = cm.doc, est = estimateHeight(cm);
        doc.iter(function(line) {
            var estHeight = est(line);
            if (estHeight != line.height) updateLineHeight(line, estHeight);
        });
    }
    // Given a mouse event, find the corresponding position. If liberal
    // is false, it checks whether a gutter or scrollbar was clicked,
    // and returns null if it was. forRect is used by rectangular
    // selections, and tries to estimate a character position even for
    // coordinates beyond the right of the text.
    function posFromMouse(cm, e, liberal, forRect) {
        var display = cm.display;
        if (!liberal && e_target(e).getAttribute("cm-not-content") == "true") return null;
        var x, y, space = display.lineSpace.getBoundingClientRect();
        // Fails unpredictably on IE[67] when mouse is dragged around quickly.
        try {
            x = e.clientX - space.left;
            y = e.clientY - space.top;
        } catch (e$1) {
            return null;
        }
        var coords = coordsChar(cm, x, y), line;
        if (forRect && coords.xRel > 0 && (line = getLine(cm.doc, coords.line).text).length == coords.ch) {
            var colDiff = countColumn(line, line.length, cm.options.tabSize) - line.length;
            coords = Pos(coords.line, Math.max(0, Math.round((x - paddingH(cm.display).left) / charWidth(cm.display)) - colDiff));
        }
        return coords;
    }
    // Find the view element corresponding to a given line. Return null
    // when the line isn't visible.
    function findViewIndex(cm, n) {
        if (n >= cm.display.viewTo) return null;
        n -= cm.display.viewFrom;
        if (n < 0) return null;
        var view = cm.display.view;
        for(var i = 0; i < view.length; i++){
            n -= view[i].size;
            if (n < 0) return i;
        }
    }
    // Updates the display.view data structure for a given change to the
    // document. From and to are in pre-change coordinates. Lendiff is
    // the amount of lines added or subtracted by the change. This is
    // used for changes that span multiple lines, or change the way
    // lines are divided into visual lines. regLineChange (below)
    // registers single-line changes.
    function regChange(cm, from, to, lendiff) {
        if (from == null) from = cm.doc.first;
        if (to == null) to = cm.doc.first + cm.doc.size;
        if (!lendiff) lendiff = 0;
        var display = cm.display;
        if (lendiff && to < display.viewTo && (display.updateLineNumbers == null || display.updateLineNumbers > from)) display.updateLineNumbers = from;
        cm.curOp.viewChanged = true;
        if (from >= display.viewTo) {
            if (sawCollapsedSpans && visualLineNo(cm.doc, from) < display.viewTo) resetView(cm);
        } else if (to <= display.viewFrom) {
            if (sawCollapsedSpans && visualLineEndNo(cm.doc, to + lendiff) > display.viewFrom) resetView(cm);
            else {
                display.viewFrom += lendiff;
                display.viewTo += lendiff;
            }
        } else if (from <= display.viewFrom && to >= display.viewTo) resetView(cm);
        else if (from <= display.viewFrom) {
            var cut = viewCuttingPoint(cm, to, to + lendiff, 1);
            if (cut) {
                display.view = display.view.slice(cut.index);
                display.viewFrom = cut.lineN;
                display.viewTo += lendiff;
            } else resetView(cm);
        } else if (to >= display.viewTo) {
            var cut$1 = viewCuttingPoint(cm, from, from, -1);
            if (cut$1) {
                display.view = display.view.slice(0, cut$1.index);
                display.viewTo = cut$1.lineN;
            } else resetView(cm);
        } else {
            var cutTop = viewCuttingPoint(cm, from, from, -1);
            var cutBot = viewCuttingPoint(cm, to, to + lendiff, 1);
            if (cutTop && cutBot) {
                display.view = display.view.slice(0, cutTop.index).concat(buildViewArray(cm, cutTop.lineN, cutBot.lineN)).concat(display.view.slice(cutBot.index));
                display.viewTo += lendiff;
            } else resetView(cm);
        }
        var ext = display.externalMeasured;
        if (ext) {
            if (to < ext.lineN) ext.lineN += lendiff;
            else if (from < ext.lineN + ext.size) display.externalMeasured = null;
        }
    }
    // Register a change to a single line. Type must be one of "text",
    // "gutter", "class", "widget"
    function regLineChange(cm, line, type) {
        cm.curOp.viewChanged = true;
        var display = cm.display, ext = cm.display.externalMeasured;
        if (ext && line >= ext.lineN && line < ext.lineN + ext.size) display.externalMeasured = null;
        if (line < display.viewFrom || line >= display.viewTo) return;
        var lineView = display.view[findViewIndex(cm, line)];
        if (lineView.node == null) return;
        var arr = lineView.changes || (lineView.changes = []);
        if (indexOf(arr, type) == -1) arr.push(type);
    }
    // Clear the view.
    function resetView(cm) {
        cm.display.viewFrom = cm.display.viewTo = cm.doc.first;
        cm.display.view = [];
        cm.display.viewOffset = 0;
    }
    function viewCuttingPoint(cm, oldN, newN, dir) {
        var index = findViewIndex(cm, oldN), diff, view = cm.display.view;
        if (!sawCollapsedSpans || newN == cm.doc.first + cm.doc.size) return {
            index: index,
            lineN: newN
        };
        var n = cm.display.viewFrom;
        for(var i = 0; i < index; i++)n += view[i].size;
        if (n != oldN) {
            if (dir > 0) {
                if (index == view.length - 1) return null;
                diff = n + view[index].size - oldN;
                index++;
            } else diff = n - oldN;
            oldN += diff;
            newN += diff;
        }
        while(visualLineNo(cm.doc, newN) != newN){
            if (index == (dir < 0 ? 0 : view.length - 1)) return null;
            newN += dir * view[index - (dir < 0 ? 1 : 0)].size;
            index += dir;
        }
        return {
            index: index,
            lineN: newN
        };
    }
    // Force the view to cover a given range, adding empty view element
    // or clipping off existing ones as needed.
    function adjustView(cm, from, to) {
        var display = cm.display, view = display.view;
        if (view.length == 0 || from >= display.viewTo || to <= display.viewFrom) {
            display.view = buildViewArray(cm, from, to);
            display.viewFrom = from;
        } else {
            if (display.viewFrom > from) display.view = buildViewArray(cm, from, display.viewFrom).concat(display.view);
            else if (display.viewFrom < from) display.view = display.view.slice(findViewIndex(cm, from));
            display.viewFrom = from;
            if (display.viewTo < to) display.view = display.view.concat(buildViewArray(cm, display.viewTo, to));
            else if (display.viewTo > to) display.view = display.view.slice(0, findViewIndex(cm, to));
        }
        display.viewTo = to;
    }
    // Count the number of lines in the view whose DOM representation is
    // out of date (or nonexistent).
    function countDirtyView(cm) {
        var view = cm.display.view, dirty = 0;
        for(var i = 0; i < view.length; i++){
            var lineView = view[i];
            if (!lineView.hidden && (!lineView.node || lineView.changes)) ++dirty;
        }
        return dirty;
    }
    function updateSelection(cm) {
        cm.display.input.showSelection(cm.display.input.prepareSelection());
    }
    function prepareSelection(cm, primary) {
        if (primary === void 0) primary = true;
        var doc = cm.doc, result = {};
        var curFragment = result.cursors = document.createDocumentFragment();
        var selFragment = result.selection = document.createDocumentFragment();
        var customCursor = cm.options.$customCursor;
        if (customCursor) primary = true;
        for(var i = 0; i < doc.sel.ranges.length; i++){
            if (!primary && i == doc.sel.primIndex) continue;
            var range = doc.sel.ranges[i];
            if (range.from().line >= cm.display.viewTo || range.to().line < cm.display.viewFrom) continue;
            var collapsed = range.empty();
            if (customCursor) {
                var head = customCursor(cm, range);
                if (head) drawSelectionCursor(cm, head, curFragment);
            } else if (collapsed || cm.options.showCursorWhenSelecting) drawSelectionCursor(cm, range.head, curFragment);
            if (!collapsed) drawSelectionRange(cm, range, selFragment);
        }
        return result;
    }
    // Draws a cursor for the given range
    function drawSelectionCursor(cm, head, output) {
        var pos = cursorCoords(cm, head, "div", null, null, !cm.options.singleCursorHeightPerLine);
        var cursor = output.appendChild(elt("div", "\u00a0", "CodeMirror-cursor"));
        cursor.style.left = pos.left + "px";
        cursor.style.top = pos.top + "px";
        cursor.style.height = Math.max(0, pos.bottom - pos.top) * cm.options.cursorHeight + "px";
        if (/\bcm-fat-cursor\b/.test(cm.getWrapperElement().className)) {
            var charPos = charCoords(cm, head, "div", null, null);
            var width = charPos.right - charPos.left;
            cursor.style.width = (width > 0 ? width : cm.defaultCharWidth()) + "px";
        }
        if (pos.other) {
            // Secondary cursor, shown when on a 'jump' in bi-directional text
            var otherCursor = output.appendChild(elt("div", "\u00a0", "CodeMirror-cursor CodeMirror-secondarycursor"));
            otherCursor.style.display = "";
            otherCursor.style.left = pos.other.left + "px";
            otherCursor.style.top = pos.other.top + "px";
            otherCursor.style.height = (pos.other.bottom - pos.other.top) * .85 + "px";
        }
    }
    function cmpCoords(a, b) {
        return a.top - b.top || a.left - b.left;
    }
    // Draws the given range as a highlighted selection
    function drawSelectionRange(cm, range, output) {
        var display = cm.display, doc = cm.doc;
        var fragment = document.createDocumentFragment();
        var padding = paddingH(cm.display), leftSide = padding.left;
        var rightSide = Math.max(display.sizerWidth, displayWidth(cm) - display.sizer.offsetLeft) - padding.right;
        var docLTR = doc.direction == "ltr";
        function add(left, top, width, bottom) {
            if (top < 0) top = 0;
            top = Math.round(top);
            bottom = Math.round(bottom);
            fragment.appendChild(elt("div", null, "CodeMirror-selected", "position: absolute; left: " + left + "px;\n                             top: " + top + "px; width: " + (width == null ? rightSide - left : width) + "px;\n                             height: " + (bottom - top) + "px"));
        }
        function drawForLine(line, fromArg, toArg) {
            var lineObj = getLine(doc, line);
            var lineLen = lineObj.text.length;
            var start, end;
            function coords(ch, bias) {
                return charCoords(cm, Pos(line, ch), "div", lineObj, bias);
            }
            function wrapX(pos, dir, side) {
                var extent = wrappedLineExtentChar(cm, lineObj, null, pos);
                var prop = dir == "ltr" == (side == "after") ? "left" : "right";
                var ch = side == "after" ? extent.begin : extent.end - (/\s/.test(lineObj.text.charAt(extent.end - 1)) ? 2 : 1);
                return coords(ch, prop)[prop];
            }
            var order = getOrder(lineObj, doc.direction);
            iterateBidiSections(order, fromArg || 0, toArg == null ? lineLen : toArg, function(from, to, dir, i) {
                var ltr = dir == "ltr";
                var fromPos = coords(from, ltr ? "left" : "right");
                var toPos = coords(to - 1, ltr ? "right" : "left");
                var openStart = fromArg == null && from == 0, openEnd = toArg == null && to == lineLen;
                var first = i == 0, last = !order || i == order.length - 1;
                if (toPos.top - fromPos.top <= 3) {
                    var openLeft = (docLTR ? openStart : openEnd) && first;
                    var openRight = (docLTR ? openEnd : openStart) && last;
                    var left = openLeft ? leftSide : (ltr ? fromPos : toPos).left;
                    var right = openRight ? rightSide : (ltr ? toPos : fromPos).right;
                    add(left, fromPos.top, right - left, fromPos.bottom);
                } else {
                    var topLeft, topRight, botLeft, botRight;
                    if (ltr) {
                        topLeft = docLTR && openStart && first ? leftSide : fromPos.left;
                        topRight = docLTR ? rightSide : wrapX(from, dir, "before");
                        botLeft = docLTR ? leftSide : wrapX(to, dir, "after");
                        botRight = docLTR && openEnd && last ? rightSide : toPos.right;
                    } else {
                        topLeft = !docLTR ? leftSide : wrapX(from, dir, "before");
                        topRight = !docLTR && openStart && first ? rightSide : fromPos.right;
                        botLeft = !docLTR && openEnd && last ? leftSide : toPos.left;
                        botRight = !docLTR ? rightSide : wrapX(to, dir, "after");
                    }
                    add(topLeft, fromPos.top, topRight - topLeft, fromPos.bottom);
                    if (fromPos.bottom < toPos.top) add(leftSide, fromPos.bottom, null, toPos.top);
                    add(botLeft, toPos.top, botRight - botLeft, toPos.bottom);
                }
                if (!start || cmpCoords(fromPos, start) < 0) start = fromPos;
                if (cmpCoords(toPos, start) < 0) start = toPos;
                if (!end || cmpCoords(fromPos, end) < 0) end = fromPos;
                if (cmpCoords(toPos, end) < 0) end = toPos;
            });
            return {
                start: start,
                end: end
            };
        }
        var sFrom = range.from(), sTo = range.to();
        if (sFrom.line == sTo.line) drawForLine(sFrom.line, sFrom.ch, sTo.ch);
        else {
            var fromLine = getLine(doc, sFrom.line), toLine = getLine(doc, sTo.line);
            var singleVLine = visualLine(fromLine) == visualLine(toLine);
            var leftEnd = drawForLine(sFrom.line, sFrom.ch, singleVLine ? fromLine.text.length + 1 : null).end;
            var rightStart = drawForLine(sTo.line, singleVLine ? 0 : null, sTo.ch).start;
            if (singleVLine) {
                if (leftEnd.top < rightStart.top - 2) {
                    add(leftEnd.right, leftEnd.top, null, leftEnd.bottom);
                    add(leftSide, rightStart.top, rightStart.left, rightStart.bottom);
                } else add(leftEnd.right, leftEnd.top, rightStart.left - leftEnd.right, leftEnd.bottom);
            }
            if (leftEnd.bottom < rightStart.top) add(leftSide, leftEnd.bottom, null, rightStart.top);
        }
        output.appendChild(fragment);
    }
    // Cursor-blinking
    function restartBlink(cm) {
        if (!cm.state.focused) return;
        var display = cm.display;
        clearInterval(display.blinker);
        var on = true;
        display.cursorDiv.style.visibility = "";
        if (cm.options.cursorBlinkRate > 0) display.blinker = setInterval(function() {
            if (!cm.hasFocus()) onBlur(cm);
            display.cursorDiv.style.visibility = (on = !on) ? "" : "hidden";
        }, cm.options.cursorBlinkRate);
        else if (cm.options.cursorBlinkRate < 0) display.cursorDiv.style.visibility = "hidden";
    }
    function ensureFocus(cm) {
        if (!cm.hasFocus()) {
            cm.display.input.focus();
            if (!cm.state.focused) onFocus(cm);
        }
    }
    function delayBlurEvent(cm) {
        cm.state.delayingBlurEvent = true;
        setTimeout(function() {
            if (cm.state.delayingBlurEvent) {
                cm.state.delayingBlurEvent = false;
                if (cm.state.focused) onBlur(cm);
            }
        }, 100);
    }
    function onFocus(cm, e) {
        if (cm.state.delayingBlurEvent && !cm.state.draggingText) cm.state.delayingBlurEvent = false;
        if (cm.options.readOnly == "nocursor") return;
        if (!cm.state.focused) {
            signal(cm, "focus", cm, e);
            cm.state.focused = true;
            addClass(cm.display.wrapper, "CodeMirror-focused");
            // This test prevents this from firing when a context
            // menu is closed (since the input reset would kill the
            // select-all detection hack)
            if (!cm.curOp && cm.display.selForContextMenu != cm.doc.sel) {
                cm.display.input.reset();
                if (webkit) setTimeout(function() {
                    return cm.display.input.reset(true);
                }, 20);
                 // Issue #1730
            }
            cm.display.input.receivedFocus();
        }
        restartBlink(cm);
    }
    function onBlur(cm, e) {
        if (cm.state.delayingBlurEvent) return;
        if (cm.state.focused) {
            signal(cm, "blur", cm, e);
            cm.state.focused = false;
            rmClass(cm.display.wrapper, "CodeMirror-focused");
        }
        clearInterval(cm.display.blinker);
        setTimeout(function() {
            if (!cm.state.focused) cm.display.shift = false;
        }, 150);
    }
    // Read the actual heights of the rendered lines, and update their
    // stored heights to match.
    function updateHeightsInViewport(cm) {
        var display = cm.display;
        var prevBottom = display.lineDiv.offsetTop;
        var viewTop = Math.max(0, display.scroller.getBoundingClientRect().top);
        var oldHeight = display.lineDiv.getBoundingClientRect().top;
        var mustScroll = 0;
        for(var i = 0; i < display.view.length; i++){
            var cur = display.view[i], wrapping = cm.options.lineWrapping;
            var height = void 0, width = 0;
            if (cur.hidden) continue;
            oldHeight += cur.line.height;
            if (ie && ie_version < 8) {
                var bot = cur.node.offsetTop + cur.node.offsetHeight;
                height = bot - prevBottom;
                prevBottom = bot;
            } else {
                var box = cur.node.getBoundingClientRect();
                height = box.bottom - box.top;
                // Check that lines don't extend past the right of the current
                // editor width
                if (!wrapping && cur.text.firstChild) width = cur.text.firstChild.getBoundingClientRect().right - box.left - 1;
            }
            var diff = cur.line.height - height;
            if (diff > .005 || diff < -0.005) {
                if (oldHeight < viewTop) mustScroll -= diff;
                updateLineHeight(cur.line, height);
                updateWidgetHeight(cur.line);
                if (cur.rest) for(var j = 0; j < cur.rest.length; j++)updateWidgetHeight(cur.rest[j]);
            }
            if (width > cm.display.sizerWidth) {
                var chWidth = Math.ceil(width / charWidth(cm.display));
                if (chWidth > cm.display.maxLineLength) {
                    cm.display.maxLineLength = chWidth;
                    cm.display.maxLine = cur.line;
                    cm.display.maxLineChanged = true;
                }
            }
        }
        if (Math.abs(mustScroll) > 2) display.scroller.scrollTop += mustScroll;
    }
    // Read and store the height of line widgets associated with the
    // given line.
    function updateWidgetHeight(line) {
        if (line.widgets) for(var i = 0; i < line.widgets.length; ++i){
            var w = line.widgets[i], parent = w.node.parentNode;
            if (parent) w.height = parent.offsetHeight;
        }
    }
    // Compute the lines that are visible in a given viewport (defaults
    // the the current scroll position). viewport may contain top,
    // height, and ensure (see op.scrollToPos) properties.
    function visibleLines(display, doc, viewport) {
        var top = viewport && viewport.top != null ? Math.max(0, viewport.top) : display.scroller.scrollTop;
        top = Math.floor(top - paddingTop(display));
        var bottom = viewport && viewport.bottom != null ? viewport.bottom : top + display.wrapper.clientHeight;
        var from = lineAtHeight(doc, top), to = lineAtHeight(doc, bottom);
        // Ensure is a {from: {line, ch}, to: {line, ch}} object, and
        // forces those lines into the viewport (if possible).
        if (viewport && viewport.ensure) {
            var ensureFrom = viewport.ensure.from.line, ensureTo = viewport.ensure.to.line;
            if (ensureFrom < from) {
                from = ensureFrom;
                to = lineAtHeight(doc, heightAtLine(getLine(doc, ensureFrom)) + display.wrapper.clientHeight);
            } else if (Math.min(ensureTo, doc.lastLine()) >= to) {
                from = lineAtHeight(doc, heightAtLine(getLine(doc, ensureTo)) - display.wrapper.clientHeight);
                to = ensureTo;
            }
        }
        return {
            from: from,
            to: Math.max(to, from + 1)
        };
    }
    // SCROLLING THINGS INTO VIEW
    // If an editor sits on the top or bottom of the window, partially
    // scrolled out of view, this ensures that the cursor is visible.
    function maybeScrollWindow(cm, rect) {
        if (signalDOMEvent(cm, "scrollCursorIntoView")) return;
        var display = cm.display, box = display.sizer.getBoundingClientRect(), doScroll = null;
        if (rect.top + box.top < 0) doScroll = true;
        else if (rect.bottom + box.top > (window.innerHeight || document.documentElement.clientHeight)) doScroll = false;
        if (doScroll != null && !phantom) {
            var scrollNode = elt("div", "\u200b", null, "position: absolute;\n                         top: " + (rect.top - display.viewOffset - paddingTop(cm.display)) + "px;\n                         height: " + (rect.bottom - rect.top + scrollGap(cm) + display.barHeight) + "px;\n                         left: " + rect.left + "px; width: " + Math.max(2, rect.right - rect.left) + "px;");
            cm.display.lineSpace.appendChild(scrollNode);
            scrollNode.scrollIntoView(doScroll);
            cm.display.lineSpace.removeChild(scrollNode);
        }
    }
    // Scroll a given position into view (immediately), verifying that
    // it actually became visible (as line heights are accurately
    // measured, the position of something may 'drift' during drawing).
    function scrollPosIntoView(cm, pos, end, margin) {
        if (margin == null) margin = 0;
        var rect;
        if (!cm.options.lineWrapping && pos == end) {
            // Set pos and end to the cursor positions around the character pos sticks to
            // If pos.sticky == "before", that is around pos.ch - 1, otherwise around pos.ch
            // If pos == Pos(_, 0, "before"), pos and end are unchanged
            end = pos.sticky == "before" ? Pos(pos.line, pos.ch + 1, "before") : pos;
            pos = pos.ch ? Pos(pos.line, pos.sticky == "before" ? pos.ch - 1 : pos.ch, "after") : pos;
        }
        for(var limit = 0; limit < 5; limit++){
            var changed = false;
            var coords = cursorCoords(cm, pos);
            var endCoords = !end || end == pos ? coords : cursorCoords(cm, end);
            rect = {
                left: Math.min(coords.left, endCoords.left),
                top: Math.min(coords.top, endCoords.top) - margin,
                right: Math.max(coords.left, endCoords.left),
                bottom: Math.max(coords.bottom, endCoords.bottom) + margin
            };
            var scrollPos = calculateScrollPos(cm, rect);
            var startTop = cm.doc.scrollTop, startLeft = cm.doc.scrollLeft;
            if (scrollPos.scrollTop != null) {
                updateScrollTop(cm, scrollPos.scrollTop);
                if (Math.abs(cm.doc.scrollTop - startTop) > 1) changed = true;
            }
            if (scrollPos.scrollLeft != null) {
                setScrollLeft(cm, scrollPos.scrollLeft);
                if (Math.abs(cm.doc.scrollLeft - startLeft) > 1) changed = true;
            }
            if (!changed) break;
        }
        return rect;
    }
    // Scroll a given set of coordinates into view (immediately).
    function scrollIntoView(cm, rect) {
        var scrollPos = calculateScrollPos(cm, rect);
        if (scrollPos.scrollTop != null) updateScrollTop(cm, scrollPos.scrollTop);
        if (scrollPos.scrollLeft != null) setScrollLeft(cm, scrollPos.scrollLeft);
    }
    // Calculate a new scroll position needed to scroll the given
    // rectangle into view. Returns an object with scrollTop and
    // scrollLeft properties. When these are undefined, the
    // vertical/horizontal position does not need to be adjusted.
    function calculateScrollPos(cm, rect) {
        var display = cm.display, snapMargin = textHeight(cm.display);
        if (rect.top < 0) rect.top = 0;
        var screentop = cm.curOp && cm.curOp.scrollTop != null ? cm.curOp.scrollTop : display.scroller.scrollTop;
        var screen1 = displayHeight(cm), result = {};
        if (rect.bottom - rect.top > screen1) rect.bottom = rect.top + screen1;
        var docBottom = cm.doc.height + paddingVert(display);
        var atTop = rect.top < snapMargin, atBottom = rect.bottom > docBottom - snapMargin;
        if (rect.top < screentop) result.scrollTop = atTop ? 0 : rect.top;
        else if (rect.bottom > screentop + screen1) {
            var newTop = Math.min(rect.top, (atBottom ? docBottom : rect.bottom) - screen1);
            if (newTop != screentop) result.scrollTop = newTop;
        }
        var gutterSpace = cm.options.fixedGutter ? 0 : display.gutters.offsetWidth;
        var screenleft = cm.curOp && cm.curOp.scrollLeft != null ? cm.curOp.scrollLeft : display.scroller.scrollLeft - gutterSpace;
        var screenw = displayWidth(cm) - display.gutters.offsetWidth;
        var tooWide = rect.right - rect.left > screenw;
        if (tooWide) rect.right = rect.left + screenw;
        if (rect.left < 10) result.scrollLeft = 0;
        else if (rect.left < screenleft) result.scrollLeft = Math.max(0, rect.left + gutterSpace - (tooWide ? 0 : 10));
        else if (rect.right > screenw + screenleft - 3) result.scrollLeft = rect.right + (tooWide ? 0 : 10) - screenw;
        return result;
    }
    // Store a relative adjustment to the scroll position in the current
    // operation (to be applied when the operation finishes).
    function addToScrollTop(cm, top) {
        if (top == null) return;
        resolveScrollToPos(cm);
        cm.curOp.scrollTop = (cm.curOp.scrollTop == null ? cm.doc.scrollTop : cm.curOp.scrollTop) + top;
    }
    // Make sure that at the end of the operation the current cursor is
    // shown.
    function ensureCursorVisible(cm) {
        resolveScrollToPos(cm);
        var cur = cm.getCursor();
        cm.curOp.scrollToPos = {
            from: cur,
            to: cur,
            margin: cm.options.cursorScrollMargin
        };
    }
    function scrollToCoords(cm, x, y) {
        if (x != null || y != null) resolveScrollToPos(cm);
        if (x != null) cm.curOp.scrollLeft = x;
        if (y != null) cm.curOp.scrollTop = y;
    }
    function scrollToRange(cm, range) {
        resolveScrollToPos(cm);
        cm.curOp.scrollToPos = range;
    }
    // When an operation has its scrollToPos property set, and another
    // scroll action is applied before the end of the operation, this
    // 'simulates' scrolling that position into view in a cheap way, so
    // that the effect of intermediate scroll commands is not ignored.
    function resolveScrollToPos(cm) {
        var range = cm.curOp.scrollToPos;
        if (range) {
            cm.curOp.scrollToPos = null;
            var from = estimateCoords(cm, range.from), to = estimateCoords(cm, range.to);
            scrollToCoordsRange(cm, from, to, range.margin);
        }
    }
    function scrollToCoordsRange(cm, from, to, margin) {
        var sPos = calculateScrollPos(cm, {
            left: Math.min(from.left, to.left),
            top: Math.min(from.top, to.top) - margin,
            right: Math.max(from.right, to.right),
            bottom: Math.max(from.bottom, to.bottom) + margin
        });
        scrollToCoords(cm, sPos.scrollLeft, sPos.scrollTop);
    }
    // Sync the scrollable area and scrollbars, ensure the viewport
    // covers the visible area.
    function updateScrollTop(cm, val) {
        if (Math.abs(cm.doc.scrollTop - val) < 2) return;
        if (!gecko) updateDisplaySimple(cm, {
            top: val
        });
        setScrollTop(cm, val, true);
        if (gecko) updateDisplaySimple(cm);
        startWorker(cm, 100);
    }
    function setScrollTop(cm, val, forceScroll) {
        val = Math.max(0, Math.min(cm.display.scroller.scrollHeight - cm.display.scroller.clientHeight, val));
        if (cm.display.scroller.scrollTop == val && !forceScroll) return;
        cm.doc.scrollTop = val;
        cm.display.scrollbars.setScrollTop(val);
        if (cm.display.scroller.scrollTop != val) cm.display.scroller.scrollTop = val;
    }
    // Sync scroller and scrollbar, ensure the gutter elements are
    // aligned.
    function setScrollLeft(cm, val, isScroller, forceScroll) {
        val = Math.max(0, Math.min(val, cm.display.scroller.scrollWidth - cm.display.scroller.clientWidth));
        if ((isScroller ? val == cm.doc.scrollLeft : Math.abs(cm.doc.scrollLeft - val) < 2) && !forceScroll) return;
        cm.doc.scrollLeft = val;
        alignHorizontally(cm);
        if (cm.display.scroller.scrollLeft != val) cm.display.scroller.scrollLeft = val;
        cm.display.scrollbars.setScrollLeft(val);
    }
    // SCROLLBARS
    // Prepare DOM reads needed to update the scrollbars. Done in one
    // shot to minimize update/measure roundtrips.
    function measureForScrollbars(cm) {
        var d = cm.display, gutterW = d.gutters.offsetWidth;
        var docH = Math.round(cm.doc.height + paddingVert(cm.display));
        return {
            clientHeight: d.scroller.clientHeight,
            viewHeight: d.wrapper.clientHeight,
            scrollWidth: d.scroller.scrollWidth,
            clientWidth: d.scroller.clientWidth,
            viewWidth: d.wrapper.clientWidth,
            barLeft: cm.options.fixedGutter ? gutterW : 0,
            docHeight: docH,
            scrollHeight: docH + scrollGap(cm) + d.barHeight,
            nativeBarWidth: d.nativeBarWidth,
            gutterWidth: gutterW
        };
    }
    var NativeScrollbars = function(place, scroll, cm) {
        this.cm = cm;
        var vert = this.vert = elt("div", [
            elt("div", null, null, "min-width: 1px")
        ], "CodeMirror-vscrollbar");
        var horiz = this.horiz = elt("div", [
            elt("div", null, null, "height: 100%; min-height: 1px")
        ], "CodeMirror-hscrollbar");
        vert.tabIndex = horiz.tabIndex = -1;
        place(vert);
        place(horiz);
        on(vert, "scroll", function() {
            if (vert.clientHeight) scroll(vert.scrollTop, "vertical");
        });
        on(horiz, "scroll", function() {
            if (horiz.clientWidth) scroll(horiz.scrollLeft, "horizontal");
        });
        this.checkedZeroWidth = false;
        // Need to set a minimum width to see the scrollbar on IE7 (but must not set it on IE8).
        if (ie && ie_version < 8) this.horiz.style.minHeight = this.vert.style.minWidth = "18px";
    };
    NativeScrollbars.prototype.update = function(measure) {
        var needsH = measure.scrollWidth > measure.clientWidth + 1;
        var needsV = measure.scrollHeight > measure.clientHeight + 1;
        var sWidth = measure.nativeBarWidth;
        if (needsV) {
            this.vert.style.display = "block";
            this.vert.style.bottom = needsH ? sWidth + "px" : "0";
            var totalHeight = measure.viewHeight - (needsH ? sWidth : 0);
            // A bug in IE8 can cause this value to be negative, so guard it.
            this.vert.firstChild.style.height = Math.max(0, measure.scrollHeight - measure.clientHeight + totalHeight) + "px";
        } else {
            this.vert.scrollTop = 0;
            this.vert.style.display = "";
            this.vert.firstChild.style.height = "0";
        }
        if (needsH) {
            this.horiz.style.display = "block";
            this.horiz.style.right = needsV ? sWidth + "px" : "0";
            this.horiz.style.left = measure.barLeft + "px";
            var totalWidth = measure.viewWidth - measure.barLeft - (needsV ? sWidth : 0);
            this.horiz.firstChild.style.width = Math.max(0, measure.scrollWidth - measure.clientWidth + totalWidth) + "px";
        } else {
            this.horiz.style.display = "";
            this.horiz.firstChild.style.width = "0";
        }
        if (!this.checkedZeroWidth && measure.clientHeight > 0) {
            if (sWidth == 0) this.zeroWidthHack();
            this.checkedZeroWidth = true;
        }
        return {
            right: needsV ? sWidth : 0,
            bottom: needsH ? sWidth : 0
        };
    };
    NativeScrollbars.prototype.setScrollLeft = function(pos) {
        if (this.horiz.scrollLeft != pos) this.horiz.scrollLeft = pos;
        if (this.disableHoriz) this.enableZeroWidthBar(this.horiz, this.disableHoriz, "horiz");
    };
    NativeScrollbars.prototype.setScrollTop = function(pos) {
        if (this.vert.scrollTop != pos) this.vert.scrollTop = pos;
        if (this.disableVert) this.enableZeroWidthBar(this.vert, this.disableVert, "vert");
    };
    NativeScrollbars.prototype.zeroWidthHack = function() {
        var w = mac && !mac_geMountainLion ? "12px" : "18px";
        this.horiz.style.height = this.vert.style.width = w;
        this.horiz.style.pointerEvents = this.vert.style.pointerEvents = "none";
        this.disableHoriz = new Delayed;
        this.disableVert = new Delayed;
    };
    NativeScrollbars.prototype.enableZeroWidthBar = function(bar, delay, type) {
        bar.style.pointerEvents = "auto";
        function maybeDisable() {
            // To find out whether the scrollbar is still visible, we
            // check whether the element under the pixel in the bottom
            // right corner of the scrollbar box is the scrollbar box
            // itself (when the bar is still visible) or its filler child
            // (when the bar is hidden). If it is still visible, we keep
            // it enabled, if it's hidden, we disable pointer events.
            var box = bar.getBoundingClientRect();
            var elt = type == "vert" ? document.elementFromPoint(box.right - 1, (box.top + box.bottom) / 2) : document.elementFromPoint((box.right + box.left) / 2, box.bottom - 1);
            if (elt != bar) bar.style.pointerEvents = "none";
            else delay.set(1000, maybeDisable);
        }
        delay.set(1000, maybeDisable);
    };
    NativeScrollbars.prototype.clear = function() {
        var parent = this.horiz.parentNode;
        parent.removeChild(this.horiz);
        parent.removeChild(this.vert);
    };
    var NullScrollbars = function() {};
    NullScrollbars.prototype.update = function() {
        return {
            bottom: 0,
            right: 0
        };
    };
    NullScrollbars.prototype.setScrollLeft = function() {};
    NullScrollbars.prototype.setScrollTop = function() {};
    NullScrollbars.prototype.clear = function() {};
    function updateScrollbars(cm, measure) {
        if (!measure) measure = measureForScrollbars(cm);
        var startWidth = cm.display.barWidth, startHeight = cm.display.barHeight;
        updateScrollbarsInner(cm, measure);
        for(var i = 0; i < 4 && startWidth != cm.display.barWidth || startHeight != cm.display.barHeight; i++){
            if (startWidth != cm.display.barWidth && cm.options.lineWrapping) updateHeightsInViewport(cm);
            updateScrollbarsInner(cm, measureForScrollbars(cm));
            startWidth = cm.display.barWidth;
            startHeight = cm.display.barHeight;
        }
    }
    // Re-synchronize the fake scrollbars with the actual size of the
    // content.
    function updateScrollbarsInner(cm, measure) {
        var d = cm.display;
        var sizes = d.scrollbars.update(measure);
        d.sizer.style.paddingRight = (d.barWidth = sizes.right) + "px";
        d.sizer.style.paddingBottom = (d.barHeight = sizes.bottom) + "px";
        d.heightForcer.style.borderBottom = sizes.bottom + "px solid transparent";
        if (sizes.right && sizes.bottom) {
            d.scrollbarFiller.style.display = "block";
            d.scrollbarFiller.style.height = sizes.bottom + "px";
            d.scrollbarFiller.style.width = sizes.right + "px";
        } else d.scrollbarFiller.style.display = "";
        if (sizes.bottom && cm.options.coverGutterNextToScrollbar && cm.options.fixedGutter) {
            d.gutterFiller.style.display = "block";
            d.gutterFiller.style.height = sizes.bottom + "px";
            d.gutterFiller.style.width = measure.gutterWidth + "px";
        } else d.gutterFiller.style.display = "";
    }
    var scrollbarModel = {
        "native": NativeScrollbars,
        "null": NullScrollbars
    };
    function initScrollbars(cm) {
        if (cm.display.scrollbars) {
            cm.display.scrollbars.clear();
            if (cm.display.scrollbars.addClass) rmClass(cm.display.wrapper, cm.display.scrollbars.addClass);
        }
        cm.display.scrollbars = new scrollbarModel[cm.options.scrollbarStyle](function(node) {
            cm.display.wrapper.insertBefore(node, cm.display.scrollbarFiller);
            // Prevent clicks in the scrollbars from killing focus
            on(node, "mousedown", function() {
                if (cm.state.focused) setTimeout(function() {
                    return cm.display.input.focus();
                }, 0);
            });
            node.setAttribute("cm-not-content", "true");
        }, function(pos, axis) {
            if (axis == "horizontal") setScrollLeft(cm, pos);
            else updateScrollTop(cm, pos);
        }, cm);
        if (cm.display.scrollbars.addClass) addClass(cm.display.wrapper, cm.display.scrollbars.addClass);
    }
    // Operations are used to wrap a series of changes to the editor
    // state in such a way that each change won't have to update the
    // cursor and display (which would be awkward, slow, and
    // error-prone). Instead, display updates are batched and then all
    // combined and executed at once.
    var nextOpId = 0;
    // Start a new operation.
    function startOperation(cm) {
        cm.curOp = {
            cm: cm,
            viewChanged: false,
            startHeight: cm.doc.height,
            forceUpdate: false,
            updateInput: 0,
            typing: false,
            changeObjs: null,
            cursorActivityHandlers: null,
            cursorActivityCalled: 0,
            selectionChanged: false,
            updateMaxLine: false,
            scrollLeft: null,
            scrollTop: null,
            scrollToPos: null,
            focus: false,
            id: ++nextOpId,
            markArrays: null // Used by addMarkedSpan
        };
        pushOperation(cm.curOp);
    }
    // Finish an operation, updating the display and signalling delayed events
    function endOperation(cm) {
        var op = cm.curOp;
        if (op) finishOperation(op, function(group) {
            for(var i = 0; i < group.ops.length; i++)group.ops[i].cm.curOp = null;
            endOperations(group);
        });
    }
    // The DOM updates done when an operation finishes are batched so
    // that the minimum number of relayouts are required.
    function endOperations(group) {
        var ops = group.ops;
        for(var i = 0; i < ops.length; i++)endOperation_R1(ops[i]);
        for(var i$1 = 0; i$1 < ops.length; i$1++)endOperation_W1(ops[i$1]);
        for(var i$2 = 0; i$2 < ops.length; i$2++)endOperation_R2(ops[i$2]);
        for(var i$3 = 0; i$3 < ops.length; i$3++)endOperation_W2(ops[i$3]);
        for(var i$4 = 0; i$4 < ops.length; i$4++)endOperation_finish(ops[i$4]);
    }
    function endOperation_R1(op) {
        var cm = op.cm, display = cm.display;
        maybeClipScrollbars(cm);
        if (op.updateMaxLine) findMaxLine(cm);
        op.mustUpdate = op.viewChanged || op.forceUpdate || op.scrollTop != null || op.scrollToPos && (op.scrollToPos.from.line < display.viewFrom || op.scrollToPos.to.line >= display.viewTo) || display.maxLineChanged && cm.options.lineWrapping;
        op.update = op.mustUpdate && new DisplayUpdate(cm, op.mustUpdate && {
            top: op.scrollTop,
            ensure: op.scrollToPos
        }, op.forceUpdate);
    }
    function endOperation_W1(op) {
        op.updatedDisplay = op.mustUpdate && updateDisplayIfNeeded(op.cm, op.update);
    }
    function endOperation_R2(op) {
        var cm = op.cm, display = cm.display;
        if (op.updatedDisplay) updateHeightsInViewport(cm);
        op.barMeasure = measureForScrollbars(cm);
        // If the max line changed since it was last measured, measure it,
        // and ensure the document's width matches it.
        // updateDisplay_W2 will use these properties to do the actual resizing
        if (display.maxLineChanged && !cm.options.lineWrapping) {
            op.adjustWidthTo = measureChar(cm, display.maxLine, display.maxLine.text.length).left + 3;
            cm.display.sizerWidth = op.adjustWidthTo;
            op.barMeasure.scrollWidth = Math.max(display.scroller.clientWidth, display.sizer.offsetLeft + op.adjustWidthTo + scrollGap(cm) + cm.display.barWidth);
            op.maxScrollLeft = Math.max(0, display.sizer.offsetLeft + op.adjustWidthTo - displayWidth(cm));
        }
        if (op.updatedDisplay || op.selectionChanged) op.preparedSelection = display.input.prepareSelection();
    }
    function endOperation_W2(op) {
        var cm = op.cm;
        if (op.adjustWidthTo != null) {
            cm.display.sizer.style.minWidth = op.adjustWidthTo + "px";
            if (op.maxScrollLeft < cm.doc.scrollLeft) setScrollLeft(cm, Math.min(cm.display.scroller.scrollLeft, op.maxScrollLeft), true);
            cm.display.maxLineChanged = false;
        }
        var takeFocus = op.focus && op.focus == activeElt();
        if (op.preparedSelection) cm.display.input.showSelection(op.preparedSelection, takeFocus);
        if (op.updatedDisplay || op.startHeight != cm.doc.height) updateScrollbars(cm, op.barMeasure);
        if (op.updatedDisplay) setDocumentHeight(cm, op.barMeasure);
        if (op.selectionChanged) restartBlink(cm);
        if (cm.state.focused && op.updateInput) cm.display.input.reset(op.typing);
        if (takeFocus) ensureFocus(op.cm);
    }
    function endOperation_finish(op) {
        var cm = op.cm, display = cm.display, doc = cm.doc;
        if (op.updatedDisplay) postUpdateDisplay(cm, op.update);
        // Abort mouse wheel delta measurement, when scrolling explicitly
        if (display.wheelStartX != null && (op.scrollTop != null || op.scrollLeft != null || op.scrollToPos)) display.wheelStartX = display.wheelStartY = null;
        // Propagate the scroll position to the actual DOM scroller
        if (op.scrollTop != null) setScrollTop(cm, op.scrollTop, op.forceScroll);
        if (op.scrollLeft != null) setScrollLeft(cm, op.scrollLeft, true, true);
        // If we need to scroll a specific position into view, do so.
        if (op.scrollToPos) {
            var rect = scrollPosIntoView(cm, clipPos(doc, op.scrollToPos.from), clipPos(doc, op.scrollToPos.to), op.scrollToPos.margin);
            maybeScrollWindow(cm, rect);
        }
        // Fire events for markers that are hidden/unidden by editing or
        // undoing
        var hidden = op.maybeHiddenMarkers, unhidden = op.maybeUnhiddenMarkers;
        if (hidden) {
            for(var i = 0; i < hidden.length; ++i)if (!hidden[i].lines.length) signal(hidden[i], "hide");
        }
        if (unhidden) {
            for(var i$1 = 0; i$1 < unhidden.length; ++i$1)if (unhidden[i$1].lines.length) signal(unhidden[i$1], "unhide");
        }
        if (display.wrapper.offsetHeight) doc.scrollTop = cm.display.scroller.scrollTop;
        // Fire change events, and delayed event handlers
        if (op.changeObjs) signal(cm, "changes", cm, op.changeObjs);
        if (op.update) op.update.finish();
    }
    // Run the given function in an operation
    function runInOp(cm, f) {
        if (cm.curOp) return f();
        startOperation(cm);
        try {
            return f();
        } finally{
            endOperation(cm);
        }
    }
    // Wraps a function in an operation. Returns the wrapped function.
    function operation(cm, f) {
        return function() {
            if (cm.curOp) return f.apply(cm, arguments);
            startOperation(cm);
            try {
                return f.apply(cm, arguments);
            } finally{
                endOperation(cm);
            }
        };
    }
    // Used to add methods to editor and doc instances, wrapping them in
    // operations.
    function methodOp(f) {
        return function() {
            if (this.curOp) return f.apply(this, arguments);
            startOperation(this);
            try {
                return f.apply(this, arguments);
            } finally{
                endOperation(this);
            }
        };
    }
    function docMethodOp(f) {
        return function() {
            var cm = this.cm;
            if (!cm || cm.curOp) return f.apply(this, arguments);
            startOperation(cm);
            try {
                return f.apply(this, arguments);
            } finally{
                endOperation(cm);
            }
        };
    }
    // HIGHLIGHT WORKER
    function startWorker(cm, time) {
        if (cm.doc.highlightFrontier < cm.display.viewTo) cm.state.highlight.set(time, bind(highlightWorker, cm));
    }
    function highlightWorker(cm) {
        var doc = cm.doc;
        if (doc.highlightFrontier >= cm.display.viewTo) return;
        var end = +new Date + cm.options.workTime;
        var context = getContextBefore(cm, doc.highlightFrontier);
        var changedLines = [];
        doc.iter(context.line, Math.min(doc.first + doc.size, cm.display.viewTo + 500), function(line) {
            if (context.line >= cm.display.viewFrom) {
                var oldStyles = line.styles;
                var resetState = line.text.length > cm.options.maxHighlightLength ? copyState(doc.mode, context.state) : null;
                var highlighted = highlightLine(cm, line, context, true);
                if (resetState) context.state = resetState;
                line.styles = highlighted.styles;
                var oldCls = line.styleClasses, newCls = highlighted.classes;
                if (newCls) line.styleClasses = newCls;
                else if (oldCls) line.styleClasses = null;
                var ischange = !oldStyles || oldStyles.length != line.styles.length || oldCls != newCls && (!oldCls || !newCls || oldCls.bgClass != newCls.bgClass || oldCls.textClass != newCls.textClass);
                for(var i = 0; !ischange && i < oldStyles.length; ++i)ischange = oldStyles[i] != line.styles[i];
                if (ischange) changedLines.push(context.line);
                line.stateAfter = context.save();
                context.nextLine();
            } else {
                if (line.text.length <= cm.options.maxHighlightLength) processLine(cm, line.text, context);
                line.stateAfter = context.line % 5 == 0 ? context.save() : null;
                context.nextLine();
            }
            if (+new Date > end) {
                startWorker(cm, cm.options.workDelay);
                return true;
            }
        });
        doc.highlightFrontier = context.line;
        doc.modeFrontier = Math.max(doc.modeFrontier, context.line);
        if (changedLines.length) runInOp(cm, function() {
            for(var i = 0; i < changedLines.length; i++)regLineChange(cm, changedLines[i], "text");
        });
    }
    // DISPLAY DRAWING
    var DisplayUpdate = function(cm, viewport, force) {
        var display = cm.display;
        this.viewport = viewport;
        // Store some values that we'll need later (but don't want to force a relayout for)
        this.visible = visibleLines(display, cm.doc, viewport);
        this.editorIsHidden = !display.wrapper.offsetWidth;
        this.wrapperHeight = display.wrapper.clientHeight;
        this.wrapperWidth = display.wrapper.clientWidth;
        this.oldDisplayWidth = displayWidth(cm);
        this.force = force;
        this.dims = getDimensions(cm);
        this.events = [];
    };
    DisplayUpdate.prototype.signal = function(emitter, type) {
        if (hasHandler(emitter, type)) this.events.push(arguments);
    };
    DisplayUpdate.prototype.finish = function() {
        for(var i = 0; i < this.events.length; i++)signal.apply(null, this.events[i]);
    };
    function maybeClipScrollbars(cm) {
        var display = cm.display;
        if (!display.scrollbarsClipped && display.scroller.offsetWidth) {
            display.nativeBarWidth = display.scroller.offsetWidth - display.scroller.clientWidth;
            display.heightForcer.style.height = scrollGap(cm) + "px";
            display.sizer.style.marginBottom = -display.nativeBarWidth + "px";
            display.sizer.style.borderRightWidth = scrollGap(cm) + "px";
            display.scrollbarsClipped = true;
        }
    }
    function selectionSnapshot(cm) {
        if (cm.hasFocus()) return null;
        var active = activeElt();
        if (!active || !contains(cm.display.lineDiv, active)) return null;
        var result = {
            activeElt: active
        };
        if (window.getSelection) {
            var sel = window.getSelection();
            if (sel.anchorNode && sel.extend && contains(cm.display.lineDiv, sel.anchorNode)) {
                result.anchorNode = sel.anchorNode;
                result.anchorOffset = sel.anchorOffset;
                result.focusNode = sel.focusNode;
                result.focusOffset = sel.focusOffset;
            }
        }
        return result;
    }
    function restoreSelection(snapshot) {
        if (!snapshot || !snapshot.activeElt || snapshot.activeElt == activeElt()) return;
        snapshot.activeElt.focus();
        if (!/^(INPUT|TEXTAREA)$/.test(snapshot.activeElt.nodeName) && snapshot.anchorNode && contains(document.body, snapshot.anchorNode) && contains(document.body, snapshot.focusNode)) {
            var sel = window.getSelection(), range = document.createRange();
            range.setEnd(snapshot.anchorNode, snapshot.anchorOffset);
            range.collapse(false);
            sel.removeAllRanges();
            sel.addRange(range);
            sel.extend(snapshot.focusNode, snapshot.focusOffset);
        }
    }
    // Does the actual updating of the line display. Bails out
    // (returning false) when there is nothing to be done and forced is
    // false.
    function updateDisplayIfNeeded(cm, update) {
        var display = cm.display, doc = cm.doc;
        if (update.editorIsHidden) {
            resetView(cm);
            return false;
        }
        // Bail out if the visible area is already rendered and nothing changed.
        if (!update.force && update.visible.from >= display.viewFrom && update.visible.to <= display.viewTo && (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo) && display.renderedView == display.view && countDirtyView(cm) == 0) return false;
        if (maybeUpdateLineNumberWidth(cm)) {
            resetView(cm);
            update.dims = getDimensions(cm);
        }
        // Compute a suitable new viewport (from & to)
        var end = doc.first + doc.size;
        var from = Math.max(update.visible.from - cm.options.viewportMargin, doc.first);
        var to = Math.min(end, update.visible.to + cm.options.viewportMargin);
        if (display.viewFrom < from && from - display.viewFrom < 20) from = Math.max(doc.first, display.viewFrom);
        if (display.viewTo > to && display.viewTo - to < 20) to = Math.min(end, display.viewTo);
        if (sawCollapsedSpans) {
            from = visualLineNo(cm.doc, from);
            to = visualLineEndNo(cm.doc, to);
        }
        var different = from != display.viewFrom || to != display.viewTo || display.lastWrapHeight != update.wrapperHeight || display.lastWrapWidth != update.wrapperWidth;
        adjustView(cm, from, to);
        display.viewOffset = heightAtLine(getLine(cm.doc, display.viewFrom));
        // Position the mover div to align with the current scroll position
        cm.display.mover.style.top = display.viewOffset + "px";
        var toUpdate = countDirtyView(cm);
        if (!different && toUpdate == 0 && !update.force && display.renderedView == display.view && (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo)) return false;
        // For big changes, we hide the enclosing element during the
        // update, since that speeds up the operations on most browsers.
        var selSnapshot = selectionSnapshot(cm);
        if (toUpdate > 4) display.lineDiv.style.display = "none";
        patchDisplay(cm, display.updateLineNumbers, update.dims);
        if (toUpdate > 4) display.lineDiv.style.display = "";
        display.renderedView = display.view;
        // There might have been a widget with a focused element that got
        // hidden or updated, if so re-focus it.
        restoreSelection(selSnapshot);
        // Prevent selection and cursors from interfering with the scroll
        // width and height.
        removeChildren(display.cursorDiv);
        removeChildren(display.selectionDiv);
        display.gutters.style.height = display.sizer.style.minHeight = 0;
        if (different) {
            display.lastWrapHeight = update.wrapperHeight;
            display.lastWrapWidth = update.wrapperWidth;
            startWorker(cm, 400);
        }
        display.updateLineNumbers = null;
        return true;
    }
    function postUpdateDisplay(cm, update) {
        var viewport = update.viewport;
        for(var first = true;; first = false){
            if (!first || !cm.options.lineWrapping || update.oldDisplayWidth == displayWidth(cm)) {
                // Clip forced viewport to actual scrollable area.
                if (viewport && viewport.top != null) viewport = {
                    top: Math.min(cm.doc.height + paddingVert(cm.display) - displayHeight(cm), viewport.top)
                };
                // Updated line heights might result in the drawn area not
                // actually covering the viewport. Keep looping until it does.
                update.visible = visibleLines(cm.display, cm.doc, viewport);
                if (update.visible.from >= cm.display.viewFrom && update.visible.to <= cm.display.viewTo) break;
            } else if (first) update.visible = visibleLines(cm.display, cm.doc, viewport);
            if (!updateDisplayIfNeeded(cm, update)) break;
            updateHeightsInViewport(cm);
            var barMeasure = measureForScrollbars(cm);
            updateSelection(cm);
            updateScrollbars(cm, barMeasure);
            setDocumentHeight(cm, barMeasure);
            update.force = false;
        }
        update.signal(cm, "update", cm);
        if (cm.display.viewFrom != cm.display.reportedViewFrom || cm.display.viewTo != cm.display.reportedViewTo) {
            update.signal(cm, "viewportChange", cm, cm.display.viewFrom, cm.display.viewTo);
            cm.display.reportedViewFrom = cm.display.viewFrom;
            cm.display.reportedViewTo = cm.display.viewTo;
        }
    }
    function updateDisplaySimple(cm, viewport) {
        var update = new DisplayUpdate(cm, viewport);
        if (updateDisplayIfNeeded(cm, update)) {
            updateHeightsInViewport(cm);
            postUpdateDisplay(cm, update);
            var barMeasure = measureForScrollbars(cm);
            updateSelection(cm);
            updateScrollbars(cm, barMeasure);
            setDocumentHeight(cm, barMeasure);
            update.finish();
        }
    }
    // Sync the actual display DOM structure with display.view, removing
    // nodes for lines that are no longer in view, and creating the ones
    // that are not there yet, and updating the ones that are out of
    // date.
    function patchDisplay(cm, updateNumbersFrom, dims) {
        var display = cm.display, lineNumbers = cm.options.lineNumbers;
        var container = display.lineDiv, cur = container.firstChild;
        function rm(node) {
            var next = node.nextSibling;
            // Works around a throw-scroll bug in OS X Webkit
            if (webkit && mac && cm.display.currentWheelTarget == node) node.style.display = "none";
            else node.parentNode.removeChild(node);
            return next;
        }
        var view = display.view, lineN = display.viewFrom;
        // Loop over the elements in the view, syncing cur (the DOM nodes
        // in display.lineDiv) with the view as we go.
        for(var i = 0; i < view.length; i++){
            var lineView = view[i];
            if (lineView.hidden) ;
            else if (!lineView.node || lineView.node.parentNode != container) {
                var node = buildLineElement(cm, lineView, lineN, dims);
                container.insertBefore(node, cur);
            } else {
                while(cur != lineView.node)cur = rm(cur);
                var updateNumber = lineNumbers && updateNumbersFrom != null && updateNumbersFrom <= lineN && lineView.lineNumber;
                if (lineView.changes) {
                    if (indexOf(lineView.changes, "gutter") > -1) updateNumber = false;
                    updateLineForChanges(cm, lineView, lineN, dims);
                }
                if (updateNumber) {
                    removeChildren(lineView.lineNumber);
                    lineView.lineNumber.appendChild(document.createTextNode(lineNumberFor(cm.options, lineN)));
                }
                cur = lineView.node.nextSibling;
            }
            lineN += lineView.size;
        }
        while(cur)cur = rm(cur);
    }
    function updateGutterSpace(display) {
        var width = display.gutters.offsetWidth;
        display.sizer.style.marginLeft = width + "px";
        // Send an event to consumers responding to changes in gutter width.
        signalLater(display, "gutterChanged", display);
    }
    function setDocumentHeight(cm, measure) {
        cm.display.sizer.style.minHeight = measure.docHeight + "px";
        cm.display.heightForcer.style.top = measure.docHeight + "px";
        cm.display.gutters.style.height = measure.docHeight + cm.display.barHeight + scrollGap(cm) + "px";
    }
    // Re-align line numbers and gutter marks to compensate for
    // horizontal scrolling.
    function alignHorizontally(cm) {
        var display = cm.display, view = display.view;
        if (!display.alignWidgets && (!display.gutters.firstChild || !cm.options.fixedGutter)) return;
        var comp = compensateForHScroll(display) - display.scroller.scrollLeft + cm.doc.scrollLeft;
        var gutterW = display.gutters.offsetWidth, left = comp + "px";
        for(var i = 0; i < view.length; i++)if (!view[i].hidden) {
            if (cm.options.fixedGutter) {
                if (view[i].gutter) view[i].gutter.style.left = left;
                if (view[i].gutterBackground) view[i].gutterBackground.style.left = left;
            }
            var align = view[i].alignable;
            if (align) for(var j = 0; j < align.length; j++)align[j].style.left = left;
        }
        if (cm.options.fixedGutter) display.gutters.style.left = comp + gutterW + "px";
    }
    // Used to ensure that the line number gutter is still the right
    // size for the current document size. Returns true when an update
    // is needed.
    function maybeUpdateLineNumberWidth(cm) {
        if (!cm.options.lineNumbers) return false;
        var doc = cm.doc, last = lineNumberFor(cm.options, doc.first + doc.size - 1), display = cm.display;
        if (last.length != display.lineNumChars) {
            var test = display.measure.appendChild(elt("div", [
                elt("div", last)
            ], "CodeMirror-linenumber CodeMirror-gutter-elt"));
            var innerW = test.firstChild.offsetWidth, padding = test.offsetWidth - innerW;
            display.lineGutter.style.width = "";
            display.lineNumInnerWidth = Math.max(innerW, display.lineGutter.offsetWidth - padding) + 1;
            display.lineNumWidth = display.lineNumInnerWidth + padding;
            display.lineNumChars = display.lineNumInnerWidth ? last.length : -1;
            display.lineGutter.style.width = display.lineNumWidth + "px";
            updateGutterSpace(cm.display);
            return true;
        }
        return false;
    }
    function getGutters(gutters, lineNumbers) {
        var result = [], sawLineNumbers = false;
        for(var i = 0; i < gutters.length; i++){
            var name = gutters[i], style = null;
            if (typeof name != "string") {
                style = name.style;
                name = name.className;
            }
            if (name == "CodeMirror-linenumbers") {
                if (!lineNumbers) continue;
                else sawLineNumbers = true;
            }
            result.push({
                className: name,
                style: style
            });
        }
        if (lineNumbers && !sawLineNumbers) result.push({
            className: "CodeMirror-linenumbers",
            style: null
        });
        return result;
    }
    // Rebuild the gutter elements, ensure the margin to the left of the
    // code matches their width.
    function renderGutters(display) {
        var gutters = display.gutters, specs = display.gutterSpecs;
        removeChildren(gutters);
        display.lineGutter = null;
        for(var i = 0; i < specs.length; ++i){
            var ref = specs[i];
            var className = ref.className;
            var style = ref.style;
            var gElt = gutters.appendChild(elt("div", null, "CodeMirror-gutter " + className));
            if (style) gElt.style.cssText = style;
            if (className == "CodeMirror-linenumbers") {
                display.lineGutter = gElt;
                gElt.style.width = (display.lineNumWidth || 1) + "px";
            }
        }
        gutters.style.display = specs.length ? "" : "none";
        updateGutterSpace(display);
    }
    function updateGutters(cm) {
        renderGutters(cm.display);
        regChange(cm);
        alignHorizontally(cm);
    }
    // The display handles the DOM integration, both for input reading
    // and content drawing. It holds references to DOM nodes and
    // display-related state.
    function Display(place, doc, input, options) {
        var d = this;
        this.input = input;
        // Covers bottom-right square when both scrollbars are present.
        d.scrollbarFiller = elt("div", null, "CodeMirror-scrollbar-filler");
        d.scrollbarFiller.setAttribute("cm-not-content", "true");
        // Covers bottom of gutter when coverGutterNextToScrollbar is on
        // and h scrollbar is present.
        d.gutterFiller = elt("div", null, "CodeMirror-gutter-filler");
        d.gutterFiller.setAttribute("cm-not-content", "true");
        // Will contain the actual code, positioned to cover the viewport.
        d.lineDiv = eltP("div", null, "CodeMirror-code");
        // Elements are added to these to represent selection and cursors.
        d.selectionDiv = elt("div", null, null, "position: relative; z-index: 1");
        d.cursorDiv = elt("div", null, "CodeMirror-cursors");
        // A visibility: hidden element used to find the size of things.
        d.measure = elt("div", null, "CodeMirror-measure");
        // When lines outside of the viewport are measured, they are drawn in this.
        d.lineMeasure = elt("div", null, "CodeMirror-measure");
        // Wraps everything that needs to exist inside the vertically-padded coordinate system
        d.lineSpace = eltP("div", [
            d.measure,
            d.lineMeasure,
            d.selectionDiv,
            d.cursorDiv,
            d.lineDiv
        ], null, "position: relative; outline: none");
        var lines = eltP("div", [
            d.lineSpace
        ], "CodeMirror-lines");
        // Moved around its parent to cover visible view.
        d.mover = elt("div", [
            lines
        ], null, "position: relative");
        // Set to the height of the document, allowing scrolling.
        d.sizer = elt("div", [
            d.mover
        ], "CodeMirror-sizer");
        d.sizerWidth = null;
        // Behavior of elts with overflow: auto and padding is
        // inconsistent across browsers. This is used to ensure the
        // scrollable area is big enough.
        d.heightForcer = elt("div", null, null, "position: absolute; height: " + scrollerGap + "px; width: 1px;");
        // Will contain the gutters, if any.
        d.gutters = elt("div", null, "CodeMirror-gutters");
        d.lineGutter = null;
        // Actual scrollable element.
        d.scroller = elt("div", [
            d.sizer,
            d.heightForcer,
            d.gutters
        ], "CodeMirror-scroll");
        d.scroller.setAttribute("tabIndex", "-1");
        // The element in which the editor lives.
        d.wrapper = elt("div", [
            d.scrollbarFiller,
            d.gutterFiller,
            d.scroller
        ], "CodeMirror");
        // This attribute is respected by automatic translation systems such as Google Translate,
        // and may also be respected by tools used by human translators.
        d.wrapper.setAttribute('translate', 'no');
        // Work around IE7 z-index bug (not perfect, hence IE7 not really being supported)
        if (ie && ie_version < 8) {
            d.gutters.style.zIndex = -1;
            d.scroller.style.paddingRight = 0;
        }
        if (!webkit && !(gecko && mobile)) d.scroller.draggable = true;
        if (place) {
            if (place.appendChild) place.appendChild(d.wrapper);
            else place(d.wrapper);
        }
        // Current rendered range (may be bigger than the view window).
        d.viewFrom = d.viewTo = doc.first;
        d.reportedViewFrom = d.reportedViewTo = doc.first;
        // Information about the rendered lines.
        d.view = [];
        d.renderedView = null;
        // Holds info about a single rendered line when it was rendered
        // for measurement, while not in view.
        d.externalMeasured = null;
        // Empty space (in pixels) above the view
        d.viewOffset = 0;
        d.lastWrapHeight = d.lastWrapWidth = 0;
        d.updateLineNumbers = null;
        d.nativeBarWidth = d.barHeight = d.barWidth = 0;
        d.scrollbarsClipped = false;
        // Used to only resize the line number gutter when necessary (when
        // the amount of lines crosses a boundary that makes its width change)
        d.lineNumWidth = d.lineNumInnerWidth = d.lineNumChars = null;
        // Set to true when a non-horizontal-scrolling line widget is
        // added. As an optimization, line widget aligning is skipped when
        // this is false.
        d.alignWidgets = false;
        d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;
        // Tracks the maximum line length so that the horizontal scrollbar
        // can be kept static when scrolling.
        d.maxLine = null;
        d.maxLineLength = 0;
        d.maxLineChanged = false;
        // Used for measuring wheel scrolling granularity
        d.wheelDX = d.wheelDY = d.wheelStartX = d.wheelStartY = null;
        // True when shift is held down.
        d.shift = false;
        // Used to track whether anything happened since the context menu
        // was opened.
        d.selForContextMenu = null;
        d.activeTouch = null;
        d.gutterSpecs = getGutters(options.gutters, options.lineNumbers);
        renderGutters(d);
        input.init(d);
    }
    // Since the delta values reported on mouse wheel events are
    // unstandardized between browsers and even browser versions, and
    // generally horribly unpredictable, this code starts by measuring
    // the scroll effect that the first few mouse wheel events have,
    // and, from that, detects the way it can convert deltas to pixel
    // offsets afterwards.
    //
    // The reason we want to know the amount a wheel event will scroll
    // is that it gives us a chance to update the display before the
    // actual scrolling happens, reducing flickering.
    var wheelSamples = 0, wheelPixelsPerUnit = null;
    // Fill in a browser-detected starting value on browsers where we
    // know one. These don't have to be accurate -- the result of them
    // being wrong would just be a slight flicker on the first wheel
    // scroll (if it is large enough).
    if (ie) wheelPixelsPerUnit = -0.53;
    else if (gecko) wheelPixelsPerUnit = 15;
    else if (chrome) wheelPixelsPerUnit = -0.7;
    else if (safari) wheelPixelsPerUnit = -1 / 3;
    function wheelEventDelta(e) {
        var dx = e.wheelDeltaX, dy = e.wheelDeltaY;
        if (dx == null && e.detail && e.axis == e.HORIZONTAL_AXIS) dx = e.detail;
        if (dy == null && e.detail && e.axis == e.VERTICAL_AXIS) dy = e.detail;
        else if (dy == null) dy = e.wheelDelta;
        return {
            x: dx,
            y: dy
        };
    }
    function wheelEventPixels(e) {
        var delta = wheelEventDelta(e);
        delta.x *= wheelPixelsPerUnit;
        delta.y *= wheelPixelsPerUnit;
        return delta;
    }
    function onScrollWheel(cm, e) {
        var delta = wheelEventDelta(e), dx = delta.x, dy = delta.y;
        var pixelsPerUnit = wheelPixelsPerUnit;
        if (e.deltaMode === 0) {
            dx = e.deltaX;
            dy = e.deltaY;
            pixelsPerUnit = 1;
        }
        var display = cm.display, scroll = display.scroller;
        // Quit if there's nothing to scroll here
        var canScrollX = scroll.scrollWidth > scroll.clientWidth;
        var canScrollY = scroll.scrollHeight > scroll.clientHeight;
        if (!(dx && canScrollX || dy && canScrollY)) return;
        // Webkit browsers on OS X abort momentum scrolls when the target
        // of the scroll event is removed from the scrollable element.
        // This hack (see related code in patchDisplay) makes sure the
        // element is kept around.
        if (dy && mac && webkit) outer: for(var cur = e.target, view = display.view; cur != scroll; cur = cur.parentNode){
            for(var i = 0; i < view.length; i++)if (view[i].node == cur) {
                cm.display.currentWheelTarget = cur;
                break outer;
            }
        }
        // On some browsers, horizontal scrolling will cause redraws to
        // happen before the gutter has been realigned, causing it to
        // wriggle around in a most unseemly way. When we have an
        // estimated pixels/delta value, we just handle horizontal
        // scrolling entirely here. It'll be slightly off from native, but
        // better than glitching out.
        if (dx && !gecko && !presto && pixelsPerUnit != null) {
            if (dy && canScrollY) updateScrollTop(cm, Math.max(0, scroll.scrollTop + dy * pixelsPerUnit));
            setScrollLeft(cm, Math.max(0, scroll.scrollLeft + dx * pixelsPerUnit));
            // Only prevent default scrolling if vertical scrolling is
            // actually possible. Otherwise, it causes vertical scroll
            // jitter on OSX trackpads when deltaX is small and deltaY
            // is large (issue #3579)
            if (!dy || dy && canScrollY) e_preventDefault(e);
            display.wheelStartX = null; // Abort measurement, if in progress
            return;
        }
        // 'Project' the visible viewport to cover the area that is being
        // scrolled into view (if we know enough to estimate it).
        if (dy && pixelsPerUnit != null) {
            var pixels = dy * pixelsPerUnit;
            var top = cm.doc.scrollTop, bot = top + display.wrapper.clientHeight;
            if (pixels < 0) top = Math.max(0, top + pixels - 50);
            else bot = Math.min(cm.doc.height, bot + pixels + 50);
            updateDisplaySimple(cm, {
                top: top,
                bottom: bot
            });
        }
        if (wheelSamples < 20 && e.deltaMode !== 0) {
            if (display.wheelStartX == null) {
                display.wheelStartX = scroll.scrollLeft;
                display.wheelStartY = scroll.scrollTop;
                display.wheelDX = dx;
                display.wheelDY = dy;
                setTimeout(function() {
                    if (display.wheelStartX == null) return;
                    var movedX = scroll.scrollLeft - display.wheelStartX;
                    var movedY = scroll.scrollTop - display.wheelStartY;
                    var sample = movedY && display.wheelDY && movedY / display.wheelDY || movedX && display.wheelDX && movedX / display.wheelDX;
                    display.wheelStartX = display.wheelStartY = null;
                    if (!sample) return;
                    wheelPixelsPerUnit = (wheelPixelsPerUnit * wheelSamples + sample) / (wheelSamples + 1);
                    ++wheelSamples;
                }, 200);
            } else {
                display.wheelDX += dx;
                display.wheelDY += dy;
            }
        }
    }
    // Selection objects are immutable. A new one is created every time
    // the selection changes. A selection is one or more non-overlapping
    // (and non-touching) ranges, sorted, and an integer that indicates
    // which one is the primary selection (the one that's scrolled into
    // view, that getCursor returns, etc).
    var Selection = function(ranges, primIndex) {
        this.ranges = ranges;
        this.primIndex = primIndex;
    };
    Selection.prototype.primary = function() {
        return this.ranges[this.primIndex];
    };
    Selection.prototype.equals = function(other) {
        if (other == this) return true;
        if (other.primIndex != this.primIndex || other.ranges.length != this.ranges.length) return false;
        for(var i = 0; i < this.ranges.length; i++){
            var here = this.ranges[i], there = other.ranges[i];
            if (!equalCursorPos(here.anchor, there.anchor) || !equalCursorPos(here.head, there.head)) return false;
        }
        return true;
    };
    Selection.prototype.deepCopy = function() {
        var out = [];
        for(var i = 0; i < this.ranges.length; i++)out[i] = new Range(copyPos(this.ranges[i].anchor), copyPos(this.ranges[i].head));
        return new Selection(out, this.primIndex);
    };
    Selection.prototype.somethingSelected = function() {
        for(var i = 0; i < this.ranges.length; i++){
            if (!this.ranges[i].empty()) return true;
        }
        return false;
    };
    Selection.prototype.contains = function(pos, end) {
        if (!end) end = pos;
        for(var i = 0; i < this.ranges.length; i++){
            var range = this.ranges[i];
            if (cmp(end, range.from()) >= 0 && cmp(pos, range.to()) <= 0) return i;
        }
        return -1;
    };
    var Range = function(anchor, head) {
        this.anchor = anchor;
        this.head = head;
    };
    Range.prototype.from = function() {
        return minPos(this.anchor, this.head);
    };
    Range.prototype.to = function() {
        return maxPos(this.anchor, this.head);
    };
    Range.prototype.empty = function() {
        return this.head.line == this.anchor.line && this.head.ch == this.anchor.ch;
    };
    // Take an unsorted, potentially overlapping set of ranges, and
    // build a selection out of it. 'Consumes' ranges array (modifying
    // it).
    function normalizeSelection(cm, ranges, primIndex) {
        var mayTouch = cm && cm.options.selectionsMayTouch;
        var prim = ranges[primIndex];
        ranges.sort(function(a, b) {
            return cmp(a.from(), b.from());
        });
        primIndex = indexOf(ranges, prim);
        for(var i = 1; i < ranges.length; i++){
            var cur = ranges[i], prev = ranges[i - 1];
            var diff = cmp(prev.to(), cur.from());
            if (mayTouch && !cur.empty() ? diff > 0 : diff >= 0) {
                var from = minPos(prev.from(), cur.from()), to = maxPos(prev.to(), cur.to());
                var inv = prev.empty() ? cur.from() == cur.head : prev.from() == prev.head;
                if (i <= primIndex) --primIndex;
                ranges.splice(--i, 2, new Range(inv ? to : from, inv ? from : to));
            }
        }
        return new Selection(ranges, primIndex);
    }
    function simpleSelection(anchor, head) {
        return new Selection([
            new Range(anchor, head || anchor)
        ], 0);
    }
    // Compute the position of the end of a change (its 'to' property
    // refers to the pre-change end).
    function changeEnd(change) {
        if (!change.text) return change.to;
        return Pos(change.from.line + change.text.length - 1, lst(change.text).length + (change.text.length == 1 ? change.from.ch : 0));
    }
    // Adjust a position to refer to the post-change position of the
    // same text, or the end of the change if the change covers it.
    function adjustForChange(pos, change) {
        if (cmp(pos, change.from) < 0) return pos;
        if (cmp(pos, change.to) <= 0) return changeEnd(change);
        var line = pos.line + change.text.length - (change.to.line - change.from.line) - 1, ch = pos.ch;
        if (pos.line == change.to.line) ch += changeEnd(change).ch - change.to.ch;
        return Pos(line, ch);
    }
    function computeSelAfterChange(doc, change) {
        var out = [];
        for(var i = 0; i < doc.sel.ranges.length; i++){
            var range = doc.sel.ranges[i];
            out.push(new Range(adjustForChange(range.anchor, change), adjustForChange(range.head, change)));
        }
        return normalizeSelection(doc.cm, out, doc.sel.primIndex);
    }
    function offsetPos(pos, old, nw) {
        if (pos.line == old.line) return Pos(nw.line, pos.ch - old.ch + nw.ch);
        else return Pos(nw.line + (pos.line - old.line), pos.ch);
    }
    // Used by replaceSelections to allow moving the selection to the
    // start or around the replaced test. Hint may be "start" or "around".
    function computeReplacedSel(doc, changes, hint) {
        var out = [];
        var oldPrev = Pos(doc.first, 0), newPrev = oldPrev;
        for(var i = 0; i < changes.length; i++){
            var change = changes[i];
            var from = offsetPos(change.from, oldPrev, newPrev);
            var to = offsetPos(changeEnd(change), oldPrev, newPrev);
            oldPrev = change.to;
            newPrev = to;
            if (hint == "around") {
                var range = doc.sel.ranges[i], inv = cmp(range.head, range.anchor) < 0;
                out[i] = new Range(inv ? to : from, inv ? from : to);
            } else out[i] = new Range(from, from);
        }
        return new Selection(out, doc.sel.primIndex);
    }
    // Used to get the editor into a consistent state again when options change.
    function loadMode(cm) {
        cm.doc.mode = getMode(cm.options, cm.doc.modeOption);
        resetModeState(cm);
    }
    function resetModeState(cm) {
        cm.doc.iter(function(line) {
            if (line.stateAfter) line.stateAfter = null;
            if (line.styles) line.styles = null;
        });
        cm.doc.modeFrontier = cm.doc.highlightFrontier = cm.doc.first;
        startWorker(cm, 100);
        cm.state.modeGen++;
        if (cm.curOp) regChange(cm);
    }
    // DOCUMENT DATA STRUCTURE
    // By default, updates that start and end at the beginning of a line
    // are treated specially, in order to make the association of line
    // widgets and marker elements with the text behave more intuitive.
    function isWholeLineUpdate(doc, change) {
        return change.from.ch == 0 && change.to.ch == 0 && lst(change.text) == "" && (!doc.cm || doc.cm.options.wholeLineUpdateBefore);
    }
    // Perform a change on the document data structure.
    function updateDoc(doc, change, markedSpans, estimateHeight) {
        function spansFor(n) {
            return markedSpans ? markedSpans[n] : null;
        }
        function update(line, text, spans) {
            updateLine(line, text, spans, estimateHeight);
            signalLater(line, "change", line, change);
        }
        function linesFor(start, end) {
            var result = [];
            for(var i = start; i < end; ++i)result.push(new Line(text[i], spansFor(i), estimateHeight));
            return result;
        }
        var from = change.from, to = change.to, text = change.text;
        var firstLine = getLine(doc, from.line), lastLine = getLine(doc, to.line);
        var lastText = lst(text), lastSpans = spansFor(text.length - 1), nlines = to.line - from.line;
        // Adjust the line structure
        if (change.full) {
            doc.insert(0, linesFor(0, text.length));
            doc.remove(text.length, doc.size - text.length);
        } else if (isWholeLineUpdate(doc, change)) {
            // This is a whole-line replace. Treated specially to make
            // sure line objects move the way they are supposed to.
            var added = linesFor(0, text.length - 1);
            update(lastLine, lastLine.text, lastSpans);
            if (nlines) doc.remove(from.line, nlines);
            if (added.length) doc.insert(from.line, added);
        } else if (firstLine == lastLine) {
            if (text.length == 1) update(firstLine, firstLine.text.slice(0, from.ch) + lastText + firstLine.text.slice(to.ch), lastSpans);
            else {
                var added$1 = linesFor(1, text.length - 1);
                added$1.push(new Line(lastText + firstLine.text.slice(to.ch), lastSpans, estimateHeight));
                update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
                doc.insert(from.line + 1, added$1);
            }
        } else if (text.length == 1) {
            update(firstLine, firstLine.text.slice(0, from.ch) + text[0] + lastLine.text.slice(to.ch), spansFor(0));
            doc.remove(from.line + 1, nlines);
        } else {
            update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
            update(lastLine, lastText + lastLine.text.slice(to.ch), lastSpans);
            var added$2 = linesFor(1, text.length - 1);
            if (nlines > 1) doc.remove(from.line + 1, nlines - 1);
            doc.insert(from.line + 1, added$2);
        }
        signalLater(doc, "change", doc, change);
    }
    // Call f for all linked documents.
    function linkedDocs(doc, f, sharedHistOnly) {
        function propagate(doc, skip, sharedHist) {
            if (doc.linked) for(var i = 0; i < doc.linked.length; ++i){
                var rel = doc.linked[i];
                if (rel.doc == skip) continue;
                var shared = sharedHist && rel.sharedHist;
                if (sharedHistOnly && !shared) continue;
                f(rel.doc, shared);
                propagate(rel.doc, doc, shared);
            }
        }
        propagate(doc, null, true);
    }
    // Attach a document to an editor.
    function attachDoc(cm, doc) {
        if (doc.cm) throw new Error("This document is already in use.");
        cm.doc = doc;
        doc.cm = cm;
        estimateLineHeights(cm);
        loadMode(cm);
        setDirectionClass(cm);
        cm.options.direction = doc.direction;
        if (!cm.options.lineWrapping) findMaxLine(cm);
        cm.options.mode = doc.modeOption;
        regChange(cm);
    }
    function setDirectionClass(cm) {
        (cm.doc.direction == "rtl" ? addClass : rmClass)(cm.display.lineDiv, "CodeMirror-rtl");
    }
    function directionChanged(cm) {
        runInOp(cm, function() {
            setDirectionClass(cm);
            regChange(cm);
        });
    }
    function History(prev) {
        // Arrays of change events and selections. Doing something adds an
        // event to done and clears undo. Undoing moves events from done
        // to undone, redoing moves them in the other direction.
        this.done = [];
        this.undone = [];
        this.undoDepth = prev ? prev.undoDepth : Infinity;
        // Used to track when changes can be merged into a single undo
        // event
        this.lastModTime = this.lastSelTime = 0;
        this.lastOp = this.lastSelOp = null;
        this.lastOrigin = this.lastSelOrigin = null;
        // Used by the isClean() method
        this.generation = this.maxGeneration = prev ? prev.maxGeneration : 1;
    }
    // Create a history change event from an updateDoc-style change
    // object.
    function historyChangeFromChange(doc, change) {
        var histChange = {
            from: copyPos(change.from),
            to: changeEnd(change),
            text: getBetween(doc, change.from, change.to)
        };
        attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1);
        linkedDocs(doc, function(doc) {
            return attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1);
        }, true);
        return histChange;
    }
    // Pop all selection events off the end of a history array. Stop at
    // a change event.
    function clearSelectionEvents(array) {
        while(array.length){
            var last = lst(array);
            if (last.ranges) array.pop();
            else break;
        }
    }
    // Find the top change event in the history. Pop off selection
    // events that are in the way.
    function lastChangeEvent(hist, force) {
        if (force) {
            clearSelectionEvents(hist.done);
            return lst(hist.done);
        } else if (hist.done.length && !lst(hist.done).ranges) return lst(hist.done);
        else if (hist.done.length > 1 && !hist.done[hist.done.length - 2].ranges) {
            hist.done.pop();
            return lst(hist.done);
        }
    }
    // Register a change in the history. Merges changes that are within
    // a single operation, or are close together with an origin that
    // allows merging (starting with "+") into a single event.
    function addChangeToHistory(doc, change, selAfter, opId) {
        var hist = doc.history;
        hist.undone.length = 0;
        var time = +new Date, cur;
        var last;
        if ((hist.lastOp == opId || hist.lastOrigin == change.origin && change.origin && (change.origin.charAt(0) == "+" && hist.lastModTime > time - (doc.cm ? doc.cm.options.historyEventDelay : 500) || change.origin.charAt(0) == "*")) && (cur = lastChangeEvent(hist, hist.lastOp == opId))) {
            // Merge this change into the last event
            last = lst(cur.changes);
            if (cmp(change.from, change.to) == 0 && cmp(change.from, last.to) == 0) // Optimized case for simple insertion -- don't want to add
            // new changesets for every character typed
            last.to = changeEnd(change);
            else // Add new sub-event
            cur.changes.push(historyChangeFromChange(doc, change));
        } else {
            // Can not be merged, start a new event.
            var before = lst(hist.done);
            if (!before || !before.ranges) pushSelectionToHistory(doc.sel, hist.done);
            cur = {
                changes: [
                    historyChangeFromChange(doc, change)
                ],
                generation: hist.generation
            };
            hist.done.push(cur);
            while(hist.done.length > hist.undoDepth){
                hist.done.shift();
                if (!hist.done[0].ranges) hist.done.shift();
            }
        }
        hist.done.push(selAfter);
        hist.generation = ++hist.maxGeneration;
        hist.lastModTime = hist.lastSelTime = time;
        hist.lastOp = hist.lastSelOp = opId;
        hist.lastOrigin = hist.lastSelOrigin = change.origin;
        if (!last) signal(doc, "historyAdded");
    }
    function selectionEventCanBeMerged(doc, origin, prev, sel) {
        var ch = origin.charAt(0);
        return ch == "*" || ch == "+" && prev.ranges.length == sel.ranges.length && prev.somethingSelected() == sel.somethingSelected() && new Date - doc.history.lastSelTime <= (doc.cm ? doc.cm.options.historyEventDelay : 500);
    }
    // Called whenever the selection changes, sets the new selection as
    // the pending selection in the history, and pushes the old pending
    // selection into the 'done' array when it was significantly
    // different (in number of selected ranges, emptiness, or time).
    function addSelectionToHistory(doc, sel, opId, options) {
        var hist = doc.history, origin = options && options.origin;
        // A new event is started when the previous origin does not match
        // the current, or the origins don't allow matching. Origins
        // starting with * are always merged, those starting with + are
        // merged when similar and close together in time.
        if (opId == hist.lastSelOp || origin && hist.lastSelOrigin == origin && (hist.lastModTime == hist.lastSelTime && hist.lastOrigin == origin || selectionEventCanBeMerged(doc, origin, lst(hist.done), sel))) hist.done[hist.done.length - 1] = sel;
        else pushSelectionToHistory(sel, hist.done);
        hist.lastSelTime = +new Date;
        hist.lastSelOrigin = origin;
        hist.lastSelOp = opId;
        if (options && options.clearRedo !== false) clearSelectionEvents(hist.undone);
    }
    function pushSelectionToHistory(sel, dest) {
        var top = lst(dest);
        if (!(top && top.ranges && top.equals(sel))) dest.push(sel);
    }
    // Used to store marked span information in the history.
    function attachLocalSpans(doc, change, from, to) {
        var existing = change["spans_" + doc.id], n = 0;
        doc.iter(Math.max(doc.first, from), Math.min(doc.first + doc.size, to), function(line) {
            if (line.markedSpans) (existing || (existing = change["spans_" + doc.id] = {}))[n] = line.markedSpans;
            ++n;
        });
    }
    // When un/re-doing restores text containing marked spans, those
    // that have been explicitly cleared should not be restored.
    function removeClearedSpans(spans) {
        if (!spans) return null;
        var out;
        for(var i = 0; i < spans.length; ++i){
            if (spans[i].marker.explicitlyCleared) {
                if (!out) out = spans.slice(0, i);
            } else if (out) out.push(spans[i]);
        }
        return !out ? spans : out.length ? out : null;
    }
    // Retrieve and filter the old marked spans stored in a change event.
    function getOldSpans(doc, change) {
        var found = change["spans_" + doc.id];
        if (!found) return null;
        var nw = [];
        for(var i = 0; i < change.text.length; ++i)nw.push(removeClearedSpans(found[i]));
        return nw;
    }
    // Used for un/re-doing changes from the history. Combines the
    // result of computing the existing spans with the set of spans that
    // existed in the history (so that deleting around a span and then
    // undoing brings back the span).
    function mergeOldSpans(doc, change) {
        var old = getOldSpans(doc, change);
        var stretched = stretchSpansOverChange(doc, change);
        if (!old) return stretched;
        if (!stretched) return old;
        for(var i = 0; i < old.length; ++i){
            var oldCur = old[i], stretchCur = stretched[i];
            if (oldCur && stretchCur) spans: for(var j = 0; j < stretchCur.length; ++j){
                var span = stretchCur[j];
                for(var k = 0; k < oldCur.length; ++k){
                    if (oldCur[k].marker == span.marker) continue spans;
                }
                oldCur.push(span);
            }
            else if (stretchCur) old[i] = stretchCur;
        }
        return old;
    }
    // Used both to provide a JSON-safe object in .getHistory, and, when
    // detaching a document, to split the history in two
    function copyHistoryArray(events, newGroup, instantiateSel) {
        var copy = [];
        for(var i = 0; i < events.length; ++i){
            var event = events[i];
            if (event.ranges) {
                copy.push(instantiateSel ? Selection.prototype.deepCopy.call(event) : event);
                continue;
            }
            var changes = event.changes, newChanges = [];
            copy.push({
                changes: newChanges
            });
            for(var j = 0; j < changes.length; ++j){
                var change = changes[j], m = void 0;
                newChanges.push({
                    from: change.from,
                    to: change.to,
                    text: change.text
                });
                if (newGroup) for(var prop in change){
                    if (m = prop.match(/^spans_(\d+)$/)) {
                        if (indexOf(newGroup, Number(m[1])) > -1) {
                            lst(newChanges)[prop] = change[prop];
                            delete change[prop];
                        }
                    }
                }
            }
        }
        return copy;
    }
    // The 'scroll' parameter given to many of these indicated whether
    // the new cursor position should be scrolled into view after
    // modifying the selection.
    // If shift is held or the extend flag is set, extends a range to
    // include a given position (and optionally a second position).
    // Otherwise, simply returns the range between the given positions.
    // Used for cursor motion and such.
    function extendRange(range, head, other, extend) {
        if (extend) {
            var anchor = range.anchor;
            if (other) {
                var posBefore = cmp(head, anchor) < 0;
                if (posBefore != cmp(other, anchor) < 0) {
                    anchor = head;
                    head = other;
                } else if (posBefore != cmp(head, other) < 0) head = other;
            }
            return new Range(anchor, head);
        } else return new Range(other || head, head);
    }
    // Extend the primary selection range, discard the rest.
    function extendSelection(doc, head, other, options, extend) {
        if (extend == null) extend = doc.cm && (doc.cm.display.shift || doc.extend);
        setSelection(doc, new Selection([
            extendRange(doc.sel.primary(), head, other, extend)
        ], 0), options);
    }
    // Extend all selections (pos is an array of selections with length
    // equal the number of selections)
    function extendSelections(doc, heads, options) {
        var out = [];
        var extend = doc.cm && (doc.cm.display.shift || doc.extend);
        for(var i = 0; i < doc.sel.ranges.length; i++)out[i] = extendRange(doc.sel.ranges[i], heads[i], null, extend);
        var newSel = normalizeSelection(doc.cm, out, doc.sel.primIndex);
        setSelection(doc, newSel, options);
    }
    // Updates a single range in the selection.
    function replaceOneSelection(doc, i, range, options) {
        var ranges = doc.sel.ranges.slice(0);
        ranges[i] = range;
        setSelection(doc, normalizeSelection(doc.cm, ranges, doc.sel.primIndex), options);
    }
    // Reset the selection to a single range.
    function setSimpleSelection(doc, anchor, head, options) {
        setSelection(doc, simpleSelection(anchor, head), options);
    }
    // Give beforeSelectionChange handlers a change to influence a
    // selection update.
    function filterSelectionChange(doc, sel, options) {
        var obj = {
            ranges: sel.ranges,
            update: function(ranges) {
                this.ranges = [];
                for(var i = 0; i < ranges.length; i++)this.ranges[i] = new Range(clipPos(doc, ranges[i].anchor), clipPos(doc, ranges[i].head));
            },
            origin: options && options.origin
        };
        signal(doc, "beforeSelectionChange", doc, obj);
        if (doc.cm) signal(doc.cm, "beforeSelectionChange", doc.cm, obj);
        if (obj.ranges != sel.ranges) return normalizeSelection(doc.cm, obj.ranges, obj.ranges.length - 1);
        else return sel;
    }
    function setSelectionReplaceHistory(doc, sel, options) {
        var done = doc.history.done, last = lst(done);
        if (last && last.ranges) {
            done[done.length - 1] = sel;
            setSelectionNoUndo(doc, sel, options);
        } else setSelection(doc, sel, options);
    }
    // Set a new selection.
    function setSelection(doc, sel, options) {
        setSelectionNoUndo(doc, sel, options);
        addSelectionToHistory(doc, doc.sel, doc.cm ? doc.cm.curOp.id : NaN, options);
    }
    function setSelectionNoUndo(doc, sel, options) {
        if (hasHandler(doc, "beforeSelectionChange") || doc.cm && hasHandler(doc.cm, "beforeSelectionChange")) sel = filterSelectionChange(doc, sel, options);
        var bias = options && options.bias || (cmp(sel.primary().head, doc.sel.primary().head) < 0 ? -1 : 1);
        setSelectionInner(doc, skipAtomicInSelection(doc, sel, bias, true));
        if (!(options && options.scroll === false) && doc.cm && doc.cm.getOption("readOnly") != "nocursor") ensureCursorVisible(doc.cm);
    }
    function setSelectionInner(doc, sel) {
        if (sel.equals(doc.sel)) return;
        doc.sel = sel;
        if (doc.cm) {
            doc.cm.curOp.updateInput = 1;
            doc.cm.curOp.selectionChanged = true;
            signalCursorActivity(doc.cm);
        }
        signalLater(doc, "cursorActivity", doc);
    }
    // Verify that the selection does not partially select any atomic
    // marked ranges.
    function reCheckSelection(doc) {
        setSelectionInner(doc, skipAtomicInSelection(doc, doc.sel, null, false));
    }
    // Return a selection that does not partially select any atomic
    // ranges.
    function skipAtomicInSelection(doc, sel, bias, mayClear) {
        var out;
        for(var i = 0; i < sel.ranges.length; i++){
            var range = sel.ranges[i];
            var old = sel.ranges.length == doc.sel.ranges.length && doc.sel.ranges[i];
            var newAnchor = skipAtomic(doc, range.anchor, old && old.anchor, bias, mayClear);
            var newHead = skipAtomic(doc, range.head, old && old.head, bias, mayClear);
            if (out || newAnchor != range.anchor || newHead != range.head) {
                if (!out) out = sel.ranges.slice(0, i);
                out[i] = new Range(newAnchor, newHead);
            }
        }
        return out ? normalizeSelection(doc.cm, out, sel.primIndex) : sel;
    }
    function skipAtomicInner(doc, pos, oldPos, dir, mayClear) {
        var line = getLine(doc, pos.line);
        if (line.markedSpans) for(var i = 0; i < line.markedSpans.length; ++i){
            var sp = line.markedSpans[i], m = sp.marker;
            // Determine if we should prevent the cursor being placed to the left/right of an atomic marker
            // Historically this was determined using the inclusiveLeft/Right option, but the new way to control it
            // is with selectLeft/Right
            var preventCursorLeft = "selectLeft" in m ? !m.selectLeft : m.inclusiveLeft;
            var preventCursorRight = "selectRight" in m ? !m.selectRight : m.inclusiveRight;
            if ((sp.from == null || (preventCursorLeft ? sp.from <= pos.ch : sp.from < pos.ch)) && (sp.to == null || (preventCursorRight ? sp.to >= pos.ch : sp.to > pos.ch))) {
                if (mayClear) {
                    signal(m, "beforeCursorEnter");
                    if (m.explicitlyCleared) {
                        if (!line.markedSpans) break;
                        else {
                            --i;
                            continue;
                        }
                    }
                }
                if (!m.atomic) continue;
                if (oldPos) {
                    var near = m.find(dir < 0 ? 1 : -1), diff = void 0;
                    if (dir < 0 ? preventCursorRight : preventCursorLeft) near = movePos(doc, near, -dir, near && near.line == pos.line ? line : null);
                    if (near && near.line == pos.line && (diff = cmp(near, oldPos)) && (dir < 0 ? diff < 0 : diff > 0)) return skipAtomicInner(doc, near, pos, dir, mayClear);
                }
                var far = m.find(dir < 0 ? -1 : 1);
                if (dir < 0 ? preventCursorLeft : preventCursorRight) far = movePos(doc, far, dir, far.line == pos.line ? line : null);
                return far ? skipAtomicInner(doc, far, pos, dir, mayClear) : null;
            }
        }
        return pos;
    }
    // Ensure a given position is not inside an atomic range.
    function skipAtomic(doc, pos, oldPos, bias, mayClear) {
        var dir = bias || 1;
        var found = skipAtomicInner(doc, pos, oldPos, dir, mayClear) || !mayClear && skipAtomicInner(doc, pos, oldPos, dir, true) || skipAtomicInner(doc, pos, oldPos, -dir, mayClear) || !mayClear && skipAtomicInner(doc, pos, oldPos, -dir, true);
        if (!found) {
            doc.cantEdit = true;
            return Pos(doc.first, 0);
        }
        return found;
    }
    function movePos(doc, pos, dir, line) {
        if (dir < 0 && pos.ch == 0) {
            if (pos.line > doc.first) return clipPos(doc, Pos(pos.line - 1));
            else return null;
        } else if (dir > 0 && pos.ch == (line || getLine(doc, pos.line)).text.length) {
            if (pos.line < doc.first + doc.size - 1) return Pos(pos.line + 1, 0);
            else return null;
        } else return new Pos(pos.line, pos.ch + dir);
    }
    function selectAll(cm) {
        cm.setSelection(Pos(cm.firstLine(), 0), Pos(cm.lastLine()), sel_dontScroll);
    }
    // UPDATING
    // Allow "beforeChange" event handlers to influence a change
    function filterChange(doc, change, update) {
        var obj = {
            canceled: false,
            from: change.from,
            to: change.to,
            text: change.text,
            origin: change.origin,
            cancel: function() {
                return obj.canceled = true;
            }
        };
        if (update) obj.update = function(from, to, text, origin) {
            if (from) obj.from = clipPos(doc, from);
            if (to) obj.to = clipPos(doc, to);
            if (text) obj.text = text;
            if (origin !== undefined) obj.origin = origin;
        };
        signal(doc, "beforeChange", doc, obj);
        if (doc.cm) signal(doc.cm, "beforeChange", doc.cm, obj);
        if (obj.canceled) {
            if (doc.cm) doc.cm.curOp.updateInput = 2;
            return null;
        }
        return {
            from: obj.from,
            to: obj.to,
            text: obj.text,
            origin: obj.origin
        };
    }
    // Apply a change to a document, and add it to the document's
    // history, and propagating it to all linked documents.
    function makeChange(doc, change, ignoreReadOnly) {
        if (doc.cm) {
            if (!doc.cm.curOp) return operation(doc.cm, makeChange)(doc, change, ignoreReadOnly);
            if (doc.cm.state.suppressEdits) return;
        }
        if (hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange")) {
            change = filterChange(doc, change, true);
            if (!change) return;
        }
        // Possibly split or suppress the update based on the presence
        // of read-only spans in its range.
        var split = sawReadOnlySpans && !ignoreReadOnly && removeReadOnlyRanges(doc, change.from, change.to);
        if (split) for(var i = split.length - 1; i >= 0; --i)makeChangeInner(doc, {
            from: split[i].from,
            to: split[i].to,
            text: i ? [
                ""
            ] : change.text,
            origin: change.origin
        });
        else makeChangeInner(doc, change);
    }
    function makeChangeInner(doc, change) {
        if (change.text.length == 1 && change.text[0] == "" && cmp(change.from, change.to) == 0) return;
        var selAfter = computeSelAfterChange(doc, change);
        addChangeToHistory(doc, change, selAfter, doc.cm ? doc.cm.curOp.id : NaN);
        makeChangeSingleDoc(doc, change, selAfter, stretchSpansOverChange(doc, change));
        var rebased = [];
        linkedDocs(doc, function(doc, sharedHist) {
            if (!sharedHist && indexOf(rebased, doc.history) == -1) {
                rebaseHist(doc.history, change);
                rebased.push(doc.history);
            }
            makeChangeSingleDoc(doc, change, null, stretchSpansOverChange(doc, change));
        });
    }
    // Revert a change stored in a document's history.
    function makeChangeFromHistory(doc, type, allowSelectionOnly) {
        var suppress = doc.cm && doc.cm.state.suppressEdits;
        if (suppress && !allowSelectionOnly) return;
        var hist = doc.history, event, selAfter = doc.sel;
        var source = type == "undo" ? hist.done : hist.undone, dest = type == "undo" ? hist.undone : hist.done;
        // Verify that there is a useable event (so that ctrl-z won't
        // needlessly clear selection events)
        var i = 0;
        for(; i < source.length; i++){
            event = source[i];
            if (allowSelectionOnly ? event.ranges && !event.equals(doc.sel) : !event.ranges) break;
        }
        if (i == source.length) return;
        hist.lastOrigin = hist.lastSelOrigin = null;
        for(;;){
            event = source.pop();
            if (event.ranges) {
                pushSelectionToHistory(event, dest);
                if (allowSelectionOnly && !event.equals(doc.sel)) {
                    setSelection(doc, event, {
                        clearRedo: false
                    });
                    return;
                }
                selAfter = event;
            } else if (suppress) {
                source.push(event);
                return;
            } else break;
        }
        // Build up a reverse change object to add to the opposite history
        // stack (redo when undoing, and vice versa).
        var antiChanges = [];
        pushSelectionToHistory(selAfter, dest);
        dest.push({
            changes: antiChanges,
            generation: hist.generation
        });
        hist.generation = event.generation || ++hist.maxGeneration;
        var filter = hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange");
        var loop = function(i) {
            var change = event.changes[i];
            change.origin = type;
            if (filter && !filterChange(doc, change, false)) {
                source.length = 0;
                return {};
            }
            antiChanges.push(historyChangeFromChange(doc, change));
            var after = i ? computeSelAfterChange(doc, change) : lst(source);
            makeChangeSingleDoc(doc, change, after, mergeOldSpans(doc, change));
            if (!i && doc.cm) doc.cm.scrollIntoView({
                from: change.from,
                to: changeEnd(change)
            });
            var rebased = [];
            // Propagate to the linked documents
            linkedDocs(doc, function(doc, sharedHist) {
                if (!sharedHist && indexOf(rebased, doc.history) == -1) {
                    rebaseHist(doc.history, change);
                    rebased.push(doc.history);
                }
                makeChangeSingleDoc(doc, change, null, mergeOldSpans(doc, change));
            });
        };
        for(var i$1 = event.changes.length - 1; i$1 >= 0; --i$1){
            var returned = loop(i$1);
            if (returned) return returned.v;
        }
    }
    // Sub-views need their line numbers shifted when text is added
    // above or below them in the parent document.
    function shiftDoc(doc, distance) {
        if (distance == 0) return;
        doc.first += distance;
        doc.sel = new Selection(map(doc.sel.ranges, function(range) {
            return new Range(Pos(range.anchor.line + distance, range.anchor.ch), Pos(range.head.line + distance, range.head.ch));
        }), doc.sel.primIndex);
        if (doc.cm) {
            regChange(doc.cm, doc.first, doc.first - distance, distance);
            for(var d = doc.cm.display, l = d.viewFrom; l < d.viewTo; l++)regLineChange(doc.cm, l, "gutter");
        }
    }
    // More lower-level change function, handling only a single document
    // (not linked ones).
    function makeChangeSingleDoc(doc, change, selAfter, spans) {
        if (doc.cm && !doc.cm.curOp) return operation(doc.cm, makeChangeSingleDoc)(doc, change, selAfter, spans);
        if (change.to.line < doc.first) {
            shiftDoc(doc, change.text.length - 1 - (change.to.line - change.from.line));
            return;
        }
        if (change.from.line > doc.lastLine()) return;
        // Clip the change to the size of this doc
        if (change.from.line < doc.first) {
            var shift = change.text.length - 1 - (doc.first - change.from.line);
            shiftDoc(doc, shift);
            change = {
                from: Pos(doc.first, 0),
                to: Pos(change.to.line + shift, change.to.ch),
                text: [
                    lst(change.text)
                ],
                origin: change.origin
            };
        }
        var last = doc.lastLine();
        if (change.to.line > last) change = {
            from: change.from,
            to: Pos(last, getLine(doc, last).text.length),
            text: [
                change.text[0]
            ],
            origin: change.origin
        };
        change.removed = getBetween(doc, change.from, change.to);
        if (!selAfter) selAfter = computeSelAfterChange(doc, change);
        if (doc.cm) makeChangeSingleDocInEditor(doc.cm, change, spans);
        else updateDoc(doc, change, spans);
        setSelectionNoUndo(doc, selAfter, sel_dontScroll);
        if (doc.cantEdit && skipAtomic(doc, Pos(doc.firstLine(), 0))) doc.cantEdit = false;
    }
    // Handle the interaction of a change to a document with the editor
    // that this document is part of.
    function makeChangeSingleDocInEditor(cm, change, spans) {
        var doc = cm.doc, display = cm.display, from = change.from, to = change.to;
        var recomputeMaxLength = false, checkWidthStart = from.line;
        if (!cm.options.lineWrapping) {
            checkWidthStart = lineNo(visualLine(getLine(doc, from.line)));
            doc.iter(checkWidthStart, to.line + 1, function(line) {
                if (line == display.maxLine) {
                    recomputeMaxLength = true;
                    return true;
                }
            });
        }
        if (doc.sel.contains(change.from, change.to) > -1) signalCursorActivity(cm);
        updateDoc(doc, change, spans, estimateHeight(cm));
        if (!cm.options.lineWrapping) {
            doc.iter(checkWidthStart, from.line + change.text.length, function(line) {
                var len = lineLength(line);
                if (len > display.maxLineLength) {
                    display.maxLine = line;
                    display.maxLineLength = len;
                    display.maxLineChanged = true;
                    recomputeMaxLength = false;
                }
            });
            if (recomputeMaxLength) cm.curOp.updateMaxLine = true;
        }
        retreatFrontier(doc, from.line);
        startWorker(cm, 400);
        var lendiff = change.text.length - (to.line - from.line) - 1;
        // Remember that these lines changed, for updating the display
        if (change.full) regChange(cm);
        else if (from.line == to.line && change.text.length == 1 && !isWholeLineUpdate(cm.doc, change)) regLineChange(cm, from.line, "text");
        else regChange(cm, from.line, to.line + 1, lendiff);
        var changesHandler = hasHandler(cm, "changes"), changeHandler = hasHandler(cm, "change");
        if (changeHandler || changesHandler) {
            var obj = {
                from: from,
                to: to,
                text: change.text,
                removed: change.removed,
                origin: change.origin
            };
            if (changeHandler) signalLater(cm, "change", cm, obj);
            if (changesHandler) (cm.curOp.changeObjs || (cm.curOp.changeObjs = [])).push(obj);
        }
        cm.display.selForContextMenu = null;
    }
    function replaceRange(doc, code, from, to, origin) {
        var assign;
        if (!to) to = from;
        if (cmp(to, from) < 0) assign = [
            to,
            from
        ], from = assign[0], to = assign[1];
        if (typeof code == "string") code = doc.splitLines(code);
        makeChange(doc, {
            from: from,
            to: to,
            text: code,
            origin: origin
        });
    }
    // Rebasing/resetting history to deal with externally-sourced changes
    function rebaseHistSelSingle(pos, from, to, diff) {
        if (to < pos.line) pos.line += diff;
        else if (from < pos.line) {
            pos.line = from;
            pos.ch = 0;
        }
    }
    // Tries to rebase an array of history events given a change in the
    // document. If the change touches the same lines as the event, the
    // event, and everything 'behind' it, is discarded. If the change is
    // before the event, the event's positions are updated. Uses a
    // copy-on-write scheme for the positions, to avoid having to
    // reallocate them all on every rebase, but also avoid problems with
    // shared position objects being unsafely updated.
    function rebaseHistArray(array, from, to, diff) {
        for(var i = 0; i < array.length; ++i){
            var sub = array[i], ok = true;
            if (sub.ranges) {
                if (!sub.copied) {
                    sub = array[i] = sub.deepCopy();
                    sub.copied = true;
                }
                for(var j = 0; j < sub.ranges.length; j++){
                    rebaseHistSelSingle(sub.ranges[j].anchor, from, to, diff);
                    rebaseHistSelSingle(sub.ranges[j].head, from, to, diff);
                }
                continue;
            }
            for(var j$1 = 0; j$1 < sub.changes.length; ++j$1){
                var cur = sub.changes[j$1];
                if (to < cur.from.line) {
                    cur.from = Pos(cur.from.line + diff, cur.from.ch);
                    cur.to = Pos(cur.to.line + diff, cur.to.ch);
                } else if (from <= cur.to.line) {
                    ok = false;
                    break;
                }
            }
            if (!ok) {
                array.splice(0, i + 1);
                i = 0;
            }
        }
    }
    function rebaseHist(hist, change) {
        var from = change.from.line, to = change.to.line, diff = change.text.length - (to - from) - 1;
        rebaseHistArray(hist.done, from, to, diff);
        rebaseHistArray(hist.undone, from, to, diff);
    }
    // Utility for applying a change to a line by handle or number,
    // returning the number and optionally registering the line as
    // changed.
    function changeLine(doc, handle, changeType, op) {
        var no = handle, line = handle;
        if (typeof handle == "number") line = getLine(doc, clipLine(doc, handle));
        else no = lineNo(handle);
        if (no == null) return null;
        if (op(line, no) && doc.cm) regLineChange(doc.cm, no, changeType);
        return line;
    }
    // The document is represented as a BTree consisting of leaves, with
    // chunk of lines in them, and branches, with up to ten leaves or
    // other branch nodes below them. The top node is always a branch
    // node, and is the document object itself (meaning it has
    // additional methods and properties).
    //
    // All nodes have parent links. The tree is used both to go from
    // line numbers to line objects, and to go from objects to numbers.
    // It also indexes by height, and is used to convert between height
    // and line object, and to find the total height of the document.
    //
    // See also http://marijnhaverbeke.nl/blog/codemirror-line-tree.html
    function LeafChunk(lines) {
        this.lines = lines;
        this.parent = null;
        var height = 0;
        for(var i = 0; i < lines.length; ++i){
            lines[i].parent = this;
            height += lines[i].height;
        }
        this.height = height;
    }
    LeafChunk.prototype = {
        chunkSize: function() {
            return this.lines.length;
        },
        // Remove the n lines at offset 'at'.
        removeInner: function(at, n) {
            for(var i = at, e = at + n; i < e; ++i){
                var line = this.lines[i];
                this.height -= line.height;
                cleanUpLine(line);
                signalLater(line, "delete");
            }
            this.lines.splice(at, n);
        },
        // Helper used to collapse a small branch into a single leaf.
        collapse: function(lines) {
            lines.push.apply(lines, this.lines);
        },
        // Insert the given array of lines at offset 'at', count them as
        // having the given height.
        insertInner: function(at, lines, height) {
            this.height += height;
            this.lines = this.lines.slice(0, at).concat(lines).concat(this.lines.slice(at));
            for(var i = 0; i < lines.length; ++i)lines[i].parent = this;
        },
        // Used to iterate over a part of the tree.
        iterN: function(at, n, op) {
            for(var e = at + n; at < e; ++at){
                if (op(this.lines[at])) return true;
            }
        }
    };
    function BranchChunk(children) {
        this.children = children;
        var size = 0, height = 0;
        for(var i = 0; i < children.length; ++i){
            var ch = children[i];
            size += ch.chunkSize();
            height += ch.height;
            ch.parent = this;
        }
        this.size = size;
        this.height = height;
        this.parent = null;
    }
    BranchChunk.prototype = {
        chunkSize: function() {
            return this.size;
        },
        removeInner: function(at, n) {
            this.size -= n;
            for(var i = 0; i < this.children.length; ++i){
                var child = this.children[i], sz = child.chunkSize();
                if (at < sz) {
                    var rm = Math.min(n, sz - at), oldHeight = child.height;
                    child.removeInner(at, rm);
                    this.height -= oldHeight - child.height;
                    if (sz == rm) {
                        this.children.splice(i--, 1);
                        child.parent = null;
                    }
                    if ((n -= rm) == 0) break;
                    at = 0;
                } else at -= sz;
            }
            // If the result is smaller than 25 lines, ensure that it is a
            // single leaf node.
            if (this.size - n < 25 && (this.children.length > 1 || !(this.children[0] instanceof LeafChunk))) {
                var lines = [];
                this.collapse(lines);
                this.children = [
                    new LeafChunk(lines)
                ];
                this.children[0].parent = this;
            }
        },
        collapse: function(lines) {
            for(var i = 0; i < this.children.length; ++i)this.children[i].collapse(lines);
        },
        insertInner: function(at, lines, height) {
            this.size += lines.length;
            this.height += height;
            for(var i = 0; i < this.children.length; ++i){
                var child = this.children[i], sz = child.chunkSize();
                if (at <= sz) {
                    child.insertInner(at, lines, height);
                    if (child.lines && child.lines.length > 50) {
                        // To avoid memory thrashing when child.lines is huge (e.g. first view of a large file), it's never spliced.
                        // Instead, small slices are taken. They're taken in order because sequential memory accesses are fastest.
                        var remaining = child.lines.length % 25 + 25;
                        for(var pos = remaining; pos < child.lines.length;){
                            var leaf = new LeafChunk(child.lines.slice(pos, pos += 25));
                            child.height -= leaf.height;
                            this.children.splice(++i, 0, leaf);
                            leaf.parent = this;
                        }
                        child.lines = child.lines.slice(0, remaining);
                        this.maybeSpill();
                    }
                    break;
                }
                at -= sz;
            }
        },
        // When a node has grown, check whether it should be split.
        maybeSpill: function() {
            if (this.children.length <= 10) return;
            var me = this;
            do {
                var spilled = me.children.splice(me.children.length - 5, 5);
                var sibling = new BranchChunk(spilled);
                if (!me.parent) {
                    var copy = new BranchChunk(me.children);
                    copy.parent = me;
                    me.children = [
                        copy,
                        sibling
                    ];
                    me = copy;
                } else {
                    me.size -= sibling.size;
                    me.height -= sibling.height;
                    var myIndex = indexOf(me.parent.children, me);
                    me.parent.children.splice(myIndex + 1, 0, sibling);
                }
                sibling.parent = me.parent;
            }while (me.children.length > 10);
            me.parent.maybeSpill();
        },
        iterN: function(at, n, op) {
            for(var i = 0; i < this.children.length; ++i){
                var child = this.children[i], sz = child.chunkSize();
                if (at < sz) {
                    var used = Math.min(n, sz - at);
                    if (child.iterN(at, used, op)) return true;
                    if ((n -= used) == 0) break;
                    at = 0;
                } else at -= sz;
            }
        }
    };
    // Line widgets are block elements displayed above or below a line.
    var LineWidget = function(doc, node, options) {
        if (options) {
            for(var opt in options)if (options.hasOwnProperty(opt)) this[opt] = options[opt];
        }
        this.doc = doc;
        this.node = node;
    };
    LineWidget.prototype.clear = function() {
        var cm = this.doc.cm, ws = this.line.widgets, line = this.line, no = lineNo(line);
        if (no == null || !ws) return;
        for(var i = 0; i < ws.length; ++i)if (ws[i] == this) ws.splice(i--, 1);
        if (!ws.length) line.widgets = null;
        var height = widgetHeight(this);
        updateLineHeight(line, Math.max(0, line.height - height));
        if (cm) {
            runInOp(cm, function() {
                adjustScrollWhenAboveVisible(cm, line, -height);
                regLineChange(cm, no, "widget");
            });
            signalLater(cm, "lineWidgetCleared", cm, this, no);
        }
    };
    LineWidget.prototype.changed = function() {
        var this$1 = this;
        var oldH = this.height, cm = this.doc.cm, line = this.line;
        this.height = null;
        var diff = widgetHeight(this) - oldH;
        if (!diff) return;
        if (!lineIsHidden(this.doc, line)) updateLineHeight(line, line.height + diff);
        if (cm) runInOp(cm, function() {
            cm.curOp.forceUpdate = true;
            adjustScrollWhenAboveVisible(cm, line, diff);
            signalLater(cm, "lineWidgetChanged", cm, this$1, lineNo(line));
        });
    };
    eventMixin(LineWidget);
    function adjustScrollWhenAboveVisible(cm, line, diff) {
        if (heightAtLine(line) < (cm.curOp && cm.curOp.scrollTop || cm.doc.scrollTop)) addToScrollTop(cm, diff);
    }
    function addLineWidget(doc, handle, node, options) {
        var widget = new LineWidget(doc, node, options);
        var cm = doc.cm;
        if (cm && widget.noHScroll) cm.display.alignWidgets = true;
        changeLine(doc, handle, "widget", function(line) {
            var widgets = line.widgets || (line.widgets = []);
            if (widget.insertAt == null) widgets.push(widget);
            else widgets.splice(Math.min(widgets.length, Math.max(0, widget.insertAt)), 0, widget);
            widget.line = line;
            if (cm && !lineIsHidden(doc, line)) {
                var aboveVisible = heightAtLine(line) < doc.scrollTop;
                updateLineHeight(line, line.height + widgetHeight(widget));
                if (aboveVisible) addToScrollTop(cm, widget.height);
                cm.curOp.forceUpdate = true;
            }
            return true;
        });
        if (cm) signalLater(cm, "lineWidgetAdded", cm, widget, typeof handle == "number" ? handle : lineNo(handle));
        return widget;
    }
    // TEXTMARKERS
    // Created with markText and setBookmark methods. A TextMarker is a
    // handle that can be used to clear or find a marked position in the
    // document. Line objects hold arrays (markedSpans) containing
    // {from, to, marker} object pointing to such marker objects, and
    // indicating that such a marker is present on that line. Multiple
    // lines may point to the same marker when it spans across lines.
    // The spans will have null for their from/to properties when the
    // marker continues beyond the start/end of the line. Markers have
    // links back to the lines they currently touch.
    // Collapsed markers have unique ids, in order to be able to order
    // them, which is needed for uniquely determining an outer marker
    // when they overlap (they may nest, but not partially overlap).
    var nextMarkerId = 0;
    var TextMarker = function(doc, type) {
        this.lines = [];
        this.type = type;
        this.doc = doc;
        this.id = ++nextMarkerId;
    };
    // Clear the marker.
    TextMarker.prototype.clear = function() {
        if (this.explicitlyCleared) return;
        var cm = this.doc.cm, withOp = cm && !cm.curOp;
        if (withOp) startOperation(cm);
        if (hasHandler(this, "clear")) {
            var found = this.find();
            if (found) signalLater(this, "clear", found.from, found.to);
        }
        var min = null, max = null;
        for(var i = 0; i < this.lines.length; ++i){
            var line = this.lines[i];
            var span = getMarkedSpanFor(line.markedSpans, this);
            if (cm && !this.collapsed) regLineChange(cm, lineNo(line), "text");
            else if (cm) {
                if (span.to != null) max = lineNo(line);
                if (span.from != null) min = lineNo(line);
            }
            line.markedSpans = removeMarkedSpan(line.markedSpans, span);
            if (span.from == null && this.collapsed && !lineIsHidden(this.doc, line) && cm) updateLineHeight(line, textHeight(cm.display));
        }
        if (cm && this.collapsed && !cm.options.lineWrapping) for(var i$1 = 0; i$1 < this.lines.length; ++i$1){
            var visual = visualLine(this.lines[i$1]), len = lineLength(visual);
            if (len > cm.display.maxLineLength) {
                cm.display.maxLine = visual;
                cm.display.maxLineLength = len;
                cm.display.maxLineChanged = true;
            }
        }
        if (min != null && cm && this.collapsed) regChange(cm, min, max + 1);
        this.lines.length = 0;
        this.explicitlyCleared = true;
        if (this.atomic && this.doc.cantEdit) {
            this.doc.cantEdit = false;
            if (cm) reCheckSelection(cm.doc);
        }
        if (cm) signalLater(cm, "markerCleared", cm, this, min, max);
        if (withOp) endOperation(cm);
        if (this.parent) this.parent.clear();
    };
    // Find the position of the marker in the document. Returns a {from,
    // to} object by default. Side can be passed to get a specific side
    // -- 0 (both), -1 (left), or 1 (right). When lineObj is true, the
    // Pos objects returned contain a line object, rather than a line
    // number (used to prevent looking up the same line twice).
    TextMarker.prototype.find = function(side, lineObj) {
        if (side == null && this.type == "bookmark") side = 1;
        var from, to;
        for(var i = 0; i < this.lines.length; ++i){
            var line = this.lines[i];
            var span = getMarkedSpanFor(line.markedSpans, this);
            if (span.from != null) {
                from = Pos(lineObj ? line : lineNo(line), span.from);
                if (side == -1) return from;
            }
            if (span.to != null) {
                to = Pos(lineObj ? line : lineNo(line), span.to);
                if (side == 1) return to;
            }
        }
        return from && {
            from: from,
            to: to
        };
    };
    // Signals that the marker's widget changed, and surrounding layout
    // should be recomputed.
    TextMarker.prototype.changed = function() {
        var this$1 = this;
        var pos = this.find(-1, true), widget = this, cm = this.doc.cm;
        if (!pos || !cm) return;
        runInOp(cm, function() {
            var line = pos.line, lineN = lineNo(pos.line);
            var view = findViewForLine(cm, lineN);
            if (view) {
                clearLineMeasurementCacheFor(view);
                cm.curOp.selectionChanged = cm.curOp.forceUpdate = true;
            }
            cm.curOp.updateMaxLine = true;
            if (!lineIsHidden(widget.doc, line) && widget.height != null) {
                var oldHeight = widget.height;
                widget.height = null;
                var dHeight = widgetHeight(widget) - oldHeight;
                if (dHeight) updateLineHeight(line, line.height + dHeight);
            }
            signalLater(cm, "markerChanged", cm, this$1);
        });
    };
    TextMarker.prototype.attachLine = function(line) {
        if (!this.lines.length && this.doc.cm) {
            var op = this.doc.cm.curOp;
            if (!op.maybeHiddenMarkers || indexOf(op.maybeHiddenMarkers, this) == -1) (op.maybeUnhiddenMarkers || (op.maybeUnhiddenMarkers = [])).push(this);
        }
        this.lines.push(line);
    };
    TextMarker.prototype.detachLine = function(line) {
        this.lines.splice(indexOf(this.lines, line), 1);
        if (!this.lines.length && this.doc.cm) {
            var op = this.doc.cm.curOp;
            (op.maybeHiddenMarkers || (op.maybeHiddenMarkers = [])).push(this);
        }
    };
    eventMixin(TextMarker);
    // Create a marker, wire it up to the right lines, and
    function markText(doc, from, to, options, type) {
        // Shared markers (across linked documents) are handled separately
        // (markTextShared will call out to this again, once per
        // document).
        if (options && options.shared) return markTextShared(doc, from, to, options, type);
        // Ensure we are in an operation.
        if (doc.cm && !doc.cm.curOp) return operation(doc.cm, markText)(doc, from, to, options, type);
        var marker = new TextMarker(doc, type), diff = cmp(from, to);
        if (options) copyObj(options, marker, false);
        // Don't connect empty markers unless clearWhenEmpty is false
        if (diff > 0 || diff == 0 && marker.clearWhenEmpty !== false) return marker;
        if (marker.replacedWith) {
            // Showing up as a widget implies collapsed (widget replaces text)
            marker.collapsed = true;
            marker.widgetNode = eltP("span", [
                marker.replacedWith
            ], "CodeMirror-widget");
            if (!options.handleMouseEvents) marker.widgetNode.setAttribute("cm-ignore-events", "true");
            if (options.insertLeft) marker.widgetNode.insertLeft = true;
        }
        if (marker.collapsed) {
            if (conflictingCollapsedRange(doc, from.line, from, to, marker) || from.line != to.line && conflictingCollapsedRange(doc, to.line, from, to, marker)) throw new Error("Inserting collapsed marker partially overlapping an existing one");
            seeCollapsedSpans();
        }
        if (marker.addToHistory) addChangeToHistory(doc, {
            from: from,
            to: to,
            origin: "markText"
        }, doc.sel, NaN);
        var curLine = from.line, cm = doc.cm, updateMaxLine;
        doc.iter(curLine, to.line + 1, function(line) {
            if (cm && marker.collapsed && !cm.options.lineWrapping && visualLine(line) == cm.display.maxLine) updateMaxLine = true;
            if (marker.collapsed && curLine != from.line) updateLineHeight(line, 0);
            addMarkedSpan(line, new MarkedSpan(marker, curLine == from.line ? from.ch : null, curLine == to.line ? to.ch : null), doc.cm && doc.cm.curOp);
            ++curLine;
        });
        // lineIsHidden depends on the presence of the spans, so needs a second pass
        if (marker.collapsed) doc.iter(from.line, to.line + 1, function(line) {
            if (lineIsHidden(doc, line)) updateLineHeight(line, 0);
        });
        if (marker.clearOnEnter) on(marker, "beforeCursorEnter", function() {
            return marker.clear();
        });
        if (marker.readOnly) {
            seeReadOnlySpans();
            if (doc.history.done.length || doc.history.undone.length) doc.clearHistory();
        }
        if (marker.collapsed) {
            marker.id = ++nextMarkerId;
            marker.atomic = true;
        }
        if (cm) {
            // Sync editor state
            if (updateMaxLine) cm.curOp.updateMaxLine = true;
            if (marker.collapsed) regChange(cm, from.line, to.line + 1);
            else if (marker.className || marker.startStyle || marker.endStyle || marker.css || marker.attributes || marker.title) for(var i = from.line; i <= to.line; i++)regLineChange(cm, i, "text");
            if (marker.atomic) reCheckSelection(cm.doc);
            signalLater(cm, "markerAdded", cm, marker);
        }
        return marker;
    }
    // SHARED TEXTMARKERS
    // A shared marker spans multiple linked documents. It is
    // implemented as a meta-marker-object controlling multiple normal
    // markers.
    var SharedTextMarker = function(markers, primary) {
        this.markers = markers;
        this.primary = primary;
        for(var i = 0; i < markers.length; ++i)markers[i].parent = this;
    };
    SharedTextMarker.prototype.clear = function() {
        if (this.explicitlyCleared) return;
        this.explicitlyCleared = true;
        for(var i = 0; i < this.markers.length; ++i)this.markers[i].clear();
        signalLater(this, "clear");
    };
    SharedTextMarker.prototype.find = function(side, lineObj) {
        return this.primary.find(side, lineObj);
    };
    eventMixin(SharedTextMarker);
    function markTextShared(doc, from, to, options, type) {
        options = copyObj(options);
        options.shared = false;
        var markers = [
            markText(doc, from, to, options, type)
        ], primary = markers[0];
        var widget = options.widgetNode;
        linkedDocs(doc, function(doc) {
            if (widget) options.widgetNode = widget.cloneNode(true);
            markers.push(markText(doc, clipPos(doc, from), clipPos(doc, to), options, type));
            for(var i = 0; i < doc.linked.length; ++i){
                if (doc.linked[i].isParent) return;
            }
            primary = lst(markers);
        });
        return new SharedTextMarker(markers, primary);
    }
    function findSharedMarkers(doc) {
        return doc.findMarks(Pos(doc.first, 0), doc.clipPos(Pos(doc.lastLine())), function(m) {
            return m.parent;
        });
    }
    function copySharedMarkers(doc, markers) {
        for(var i = 0; i < markers.length; i++){
            var marker = markers[i], pos = marker.find();
            var mFrom = doc.clipPos(pos.from), mTo = doc.clipPos(pos.to);
            if (cmp(mFrom, mTo)) {
                var subMark = markText(doc, mFrom, mTo, marker.primary, marker.primary.type);
                marker.markers.push(subMark);
                subMark.parent = marker;
            }
        }
    }
    function detachSharedMarkers(markers) {
        var loop = function(i) {
            var marker = markers[i], linked = [
                marker.primary.doc
            ];
            linkedDocs(marker.primary.doc, function(d) {
                return linked.push(d);
            });
            for(var j = 0; j < marker.markers.length; j++){
                var subMarker = marker.markers[j];
                if (indexOf(linked, subMarker.doc) == -1) {
                    subMarker.parent = null;
                    marker.markers.splice(j--, 1);
                }
            }
        };
        for(var i = 0; i < markers.length; i++)loop(i);
    }
    var nextDocId = 0;
    var Doc = function(text, mode, firstLine, lineSep, direction) {
        if (!(this instanceof Doc)) return new Doc(text, mode, firstLine, lineSep, direction);
        if (firstLine == null) firstLine = 0;
        BranchChunk.call(this, [
            new LeafChunk([
                new Line("", null)
            ])
        ]);
        this.first = firstLine;
        this.scrollTop = this.scrollLeft = 0;
        this.cantEdit = false;
        this.cleanGeneration = 1;
        this.modeFrontier = this.highlightFrontier = firstLine;
        var start = Pos(firstLine, 0);
        this.sel = simpleSelection(start);
        this.history = new History(null);
        this.id = ++nextDocId;
        this.modeOption = mode;
        this.lineSep = lineSep;
        this.direction = direction == "rtl" ? "rtl" : "ltr";
        this.extend = false;
        if (typeof text == "string") text = this.splitLines(text);
        updateDoc(this, {
            from: start,
            to: start,
            text: text
        });
        setSelection(this, simpleSelection(start), sel_dontScroll);
    };
    Doc.prototype = createObj(BranchChunk.prototype, {
        constructor: Doc,
        // Iterate over the document. Supports two forms -- with only one
        // argument, it calls that for each line in the document. With
        // three, it iterates over the range given by the first two (with
        // the second being non-inclusive).
        iter: function(from, to, op) {
            if (op) this.iterN(from - this.first, to - from, op);
            else this.iterN(this.first, this.first + this.size, from);
        },
        // Non-public interface for adding and removing lines.
        insert: function(at, lines) {
            var height = 0;
            for(var i = 0; i < lines.length; ++i)height += lines[i].height;
            this.insertInner(at - this.first, lines, height);
        },
        remove: function(at, n) {
            this.removeInner(at - this.first, n);
        },
        // From here, the methods are part of the public interface. Most
        // are also available from CodeMirror (editor) instances.
        getValue: function(lineSep) {
            var lines = getLines(this, this.first, this.first + this.size);
            if (lineSep === false) return lines;
            return lines.join(lineSep || this.lineSeparator());
        },
        setValue: docMethodOp(function(code) {
            var top = Pos(this.first, 0), last = this.first + this.size - 1;
            makeChange(this, {
                from: top,
                to: Pos(last, getLine(this, last).text.length),
                text: this.splitLines(code),
                origin: "setValue",
                full: true
            }, true);
            if (this.cm) scrollToCoords(this.cm, 0, 0);
            setSelection(this, simpleSelection(top), sel_dontScroll);
        }),
        replaceRange: function(code, from, to, origin) {
            from = clipPos(this, from);
            to = to ? clipPos(this, to) : from;
            replaceRange(this, code, from, to, origin);
        },
        getRange: function(from, to, lineSep) {
            var lines = getBetween(this, clipPos(this, from), clipPos(this, to));
            if (lineSep === false) return lines;
            if (lineSep === '') return lines.join('');
            return lines.join(lineSep || this.lineSeparator());
        },
        getLine: function(line) {
            var l = this.getLineHandle(line);
            return l && l.text;
        },
        getLineHandle: function(line) {
            if (isLine(this, line)) return getLine(this, line);
        },
        getLineNumber: function(line) {
            return lineNo(line);
        },
        getLineHandleVisualStart: function(line) {
            if (typeof line == "number") line = getLine(this, line);
            return visualLine(line);
        },
        lineCount: function() {
            return this.size;
        },
        firstLine: function() {
            return this.first;
        },
        lastLine: function() {
            return this.first + this.size - 1;
        },
        clipPos: function(pos) {
            return clipPos(this, pos);
        },
        getCursor: function(start) {
            var range = this.sel.primary(), pos;
            if (start == null || start == "head") pos = range.head;
            else if (start == "anchor") pos = range.anchor;
            else if (start == "end" || start == "to" || start === false) pos = range.to();
            else pos = range.from();
            return pos;
        },
        listSelections: function() {
            return this.sel.ranges;
        },
        somethingSelected: function() {
            return this.sel.somethingSelected();
        },
        setCursor: docMethodOp(function(line, ch, options) {
            setSimpleSelection(this, clipPos(this, typeof line == "number" ? Pos(line, ch || 0) : line), null, options);
        }),
        setSelection: docMethodOp(function(anchor, head, options) {
            setSimpleSelection(this, clipPos(this, anchor), clipPos(this, head || anchor), options);
        }),
        extendSelection: docMethodOp(function(head, other, options) {
            extendSelection(this, clipPos(this, head), other && clipPos(this, other), options);
        }),
        extendSelections: docMethodOp(function(heads, options) {
            extendSelections(this, clipPosArray(this, heads), options);
        }),
        extendSelectionsBy: docMethodOp(function(f, options) {
            var heads = map(this.sel.ranges, f);
            extendSelections(this, clipPosArray(this, heads), options);
        }),
        setSelections: docMethodOp(function(ranges, primary, options) {
            if (!ranges.length) return;
            var out = [];
            for(var i = 0; i < ranges.length; i++)out[i] = new Range(clipPos(this, ranges[i].anchor), clipPos(this, ranges[i].head || ranges[i].anchor));
            if (primary == null) primary = Math.min(ranges.length - 1, this.sel.primIndex);
            setSelection(this, normalizeSelection(this.cm, out, primary), options);
        }),
        addSelection: docMethodOp(function(anchor, head, options) {
            var ranges = this.sel.ranges.slice(0);
            ranges.push(new Range(clipPos(this, anchor), clipPos(this, head || anchor)));
            setSelection(this, normalizeSelection(this.cm, ranges, ranges.length - 1), options);
        }),
        getSelection: function(lineSep) {
            var ranges = this.sel.ranges, lines;
            for(var i = 0; i < ranges.length; i++){
                var sel = getBetween(this, ranges[i].from(), ranges[i].to());
                lines = lines ? lines.concat(sel) : sel;
            }
            if (lineSep === false) return lines;
            else return lines.join(lineSep || this.lineSeparator());
        },
        getSelections: function(lineSep) {
            var parts = [], ranges = this.sel.ranges;
            for(var i = 0; i < ranges.length; i++){
                var sel = getBetween(this, ranges[i].from(), ranges[i].to());
                if (lineSep !== false) sel = sel.join(lineSep || this.lineSeparator());
                parts[i] = sel;
            }
            return parts;
        },
        replaceSelection: function(code, collapse, origin) {
            var dup = [];
            for(var i = 0; i < this.sel.ranges.length; i++)dup[i] = code;
            this.replaceSelections(dup, collapse, origin || "+input");
        },
        replaceSelections: docMethodOp(function(code, collapse, origin) {
            var changes = [], sel = this.sel;
            for(var i = 0; i < sel.ranges.length; i++){
                var range = sel.ranges[i];
                changes[i] = {
                    from: range.from(),
                    to: range.to(),
                    text: this.splitLines(code[i]),
                    origin: origin
                };
            }
            var newSel = collapse && collapse != "end" && computeReplacedSel(this, changes, collapse);
            for(var i$1 = changes.length - 1; i$1 >= 0; i$1--)makeChange(this, changes[i$1]);
            if (newSel) setSelectionReplaceHistory(this, newSel);
            else if (this.cm) ensureCursorVisible(this.cm);
        }),
        undo: docMethodOp(function() {
            makeChangeFromHistory(this, "undo");
        }),
        redo: docMethodOp(function() {
            makeChangeFromHistory(this, "redo");
        }),
        undoSelection: docMethodOp(function() {
            makeChangeFromHistory(this, "undo", true);
        }),
        redoSelection: docMethodOp(function() {
            makeChangeFromHistory(this, "redo", true);
        }),
        setExtending: function(val) {
            this.extend = val;
        },
        getExtending: function() {
            return this.extend;
        },
        historySize: function() {
            var hist = this.history, done = 0, undone = 0;
            for(var i = 0; i < hist.done.length; i++)if (!hist.done[i].ranges) ++done;
            for(var i$1 = 0; i$1 < hist.undone.length; i$1++)if (!hist.undone[i$1].ranges) ++undone;
            return {
                undo: done,
                redo: undone
            };
        },
        clearHistory: function() {
            var this$1 = this;
            this.history = new History(this.history);
            linkedDocs(this, function(doc) {
                return doc.history = this$1.history;
            }, true);
        },
        markClean: function() {
            this.cleanGeneration = this.changeGeneration(true);
        },
        changeGeneration: function(forceSplit) {
            if (forceSplit) this.history.lastOp = this.history.lastSelOp = this.history.lastOrigin = null;
            return this.history.generation;
        },
        isClean: function(gen) {
            return this.history.generation == (gen || this.cleanGeneration);
        },
        getHistory: function() {
            return {
                done: copyHistoryArray(this.history.done),
                undone: copyHistoryArray(this.history.undone)
            };
        },
        setHistory: function(histData) {
            var hist = this.history = new History(this.history);
            hist.done = copyHistoryArray(histData.done.slice(0), null, true);
            hist.undone = copyHistoryArray(histData.undone.slice(0), null, true);
        },
        setGutterMarker: docMethodOp(function(line, gutterID, value) {
            return changeLine(this, line, "gutter", function(line) {
                var markers = line.gutterMarkers || (line.gutterMarkers = {});
                markers[gutterID] = value;
                if (!value && isEmpty(markers)) line.gutterMarkers = null;
                return true;
            });
        }),
        clearGutter: docMethodOp(function(gutterID) {
            var this$1 = this;
            this.iter(function(line) {
                if (line.gutterMarkers && line.gutterMarkers[gutterID]) changeLine(this$1, line, "gutter", function() {
                    line.gutterMarkers[gutterID] = null;
                    if (isEmpty(line.gutterMarkers)) line.gutterMarkers = null;
                    return true;
                });
            });
        }),
        lineInfo: function(line) {
            var n;
            if (typeof line == "number") {
                if (!isLine(this, line)) return null;
                n = line;
                line = getLine(this, line);
                if (!line) return null;
            } else {
                n = lineNo(line);
                if (n == null) return null;
            }
            return {
                line: n,
                handle: line,
                text: line.text,
                gutterMarkers: line.gutterMarkers,
                textClass: line.textClass,
                bgClass: line.bgClass,
                wrapClass: line.wrapClass,
                widgets: line.widgets
            };
        },
        addLineClass: docMethodOp(function(handle, where, cls) {
            return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function(line) {
                var prop = where == "text" ? "textClass" : where == "background" ? "bgClass" : where == "gutter" ? "gutterClass" : "wrapClass";
                if (!line[prop]) line[prop] = cls;
                else if (classTest(cls).test(line[prop])) return false;
                else line[prop] += " " + cls;
                return true;
            });
        }),
        removeLineClass: docMethodOp(function(handle, where, cls) {
            return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function(line) {
                var prop = where == "text" ? "textClass" : where == "background" ? "bgClass" : where == "gutter" ? "gutterClass" : "wrapClass";
                var cur = line[prop];
                if (!cur) return false;
                else if (cls == null) line[prop] = null;
                else {
                    var found = cur.match(classTest(cls));
                    if (!found) return false;
                    var end = found.index + found[0].length;
                    line[prop] = cur.slice(0, found.index) + (!found.index || end == cur.length ? "" : " ") + cur.slice(end) || null;
                }
                return true;
            });
        }),
        addLineWidget: docMethodOp(function(handle, node, options) {
            return addLineWidget(this, handle, node, options);
        }),
        removeLineWidget: function(widget) {
            widget.clear();
        },
        markText: function(from, to, options) {
            return markText(this, clipPos(this, from), clipPos(this, to), options, options && options.type || "range");
        },
        setBookmark: function(pos, options) {
            var realOpts = {
                replacedWith: options && (options.nodeType == null ? options.widget : options),
                insertLeft: options && options.insertLeft,
                clearWhenEmpty: false,
                shared: options && options.shared,
                handleMouseEvents: options && options.handleMouseEvents
            };
            pos = clipPos(this, pos);
            return markText(this, pos, pos, realOpts, "bookmark");
        },
        findMarksAt: function(pos) {
            pos = clipPos(this, pos);
            var markers = [], spans = getLine(this, pos.line).markedSpans;
            if (spans) for(var i = 0; i < spans.length; ++i){
                var span = spans[i];
                if ((span.from == null || span.from <= pos.ch) && (span.to == null || span.to >= pos.ch)) markers.push(span.marker.parent || span.marker);
            }
            return markers;
        },
        findMarks: function(from, to, filter) {
            from = clipPos(this, from);
            to = clipPos(this, to);
            var found = [], lineNo = from.line;
            this.iter(from.line, to.line + 1, function(line) {
                var spans = line.markedSpans;
                if (spans) for(var i = 0; i < spans.length; i++){
                    var span = spans[i];
                    if (!(span.to != null && lineNo == from.line && from.ch >= span.to || span.from == null && lineNo != from.line || span.from != null && lineNo == to.line && span.from >= to.ch) && (!filter || filter(span.marker))) found.push(span.marker.parent || span.marker);
                }
                ++lineNo;
            });
            return found;
        },
        getAllMarks: function() {
            var markers = [];
            this.iter(function(line) {
                var sps = line.markedSpans;
                if (sps) {
                    for(var i = 0; i < sps.length; ++i)if (sps[i].from != null) markers.push(sps[i].marker);
                }
            });
            return markers;
        },
        posFromIndex: function(off) {
            var ch, lineNo = this.first, sepSize = this.lineSeparator().length;
            this.iter(function(line) {
                var sz = line.text.length + sepSize;
                if (sz > off) {
                    ch = off;
                    return true;
                }
                off -= sz;
                ++lineNo;
            });
            return clipPos(this, Pos(lineNo, ch));
        },
        indexFromPos: function(coords) {
            coords = clipPos(this, coords);
            var index = coords.ch;
            if (coords.line < this.first || coords.ch < 0) return 0;
            var sepSize = this.lineSeparator().length;
            this.iter(this.first, coords.line, function(line) {
                index += line.text.length + sepSize;
            });
            return index;
        },
        copy: function(copyHistory) {
            var doc = new Doc(getLines(this, this.first, this.first + this.size), this.modeOption, this.first, this.lineSep, this.direction);
            doc.scrollTop = this.scrollTop;
            doc.scrollLeft = this.scrollLeft;
            doc.sel = this.sel;
            doc.extend = false;
            if (copyHistory) {
                doc.history.undoDepth = this.history.undoDepth;
                doc.setHistory(this.getHistory());
            }
            return doc;
        },
        linkedDoc: function(options) {
            if (!options) options = {};
            var from = this.first, to = this.first + this.size;
            if (options.from != null && options.from > from) from = options.from;
            if (options.to != null && options.to < to) to = options.to;
            var copy = new Doc(getLines(this, from, to), options.mode || this.modeOption, from, this.lineSep, this.direction);
            if (options.sharedHist) copy.history = this.history;
            (this.linked || (this.linked = [])).push({
                doc: copy,
                sharedHist: options.sharedHist
            });
            copy.linked = [
                {
                    doc: this,
                    isParent: true,
                    sharedHist: options.sharedHist
                }
            ];
            copySharedMarkers(copy, findSharedMarkers(this));
            return copy;
        },
        unlinkDoc: function(other) {
            if (other instanceof CodeMirror) other = other.doc;
            if (this.linked) for(var i = 0; i < this.linked.length; ++i){
                var link = this.linked[i];
                if (link.doc != other) continue;
                this.linked.splice(i, 1);
                other.unlinkDoc(this);
                detachSharedMarkers(findSharedMarkers(this));
                break;
            }
            // If the histories were shared, split them again
            if (other.history == this.history) {
                var splitIds = [
                    other.id
                ];
                linkedDocs(other, function(doc) {
                    return splitIds.push(doc.id);
                }, true);
                other.history = new History(null);
                other.history.done = copyHistoryArray(this.history.done, splitIds);
                other.history.undone = copyHistoryArray(this.history.undone, splitIds);
            }
        },
        iterLinkedDocs: function(f) {
            linkedDocs(this, f);
        },
        getMode: function() {
            return this.mode;
        },
        getEditor: function() {
            return this.cm;
        },
        splitLines: function(str) {
            if (this.lineSep) return str.split(this.lineSep);
            return splitLinesAuto(str);
        },
        lineSeparator: function() {
            return this.lineSep || "\n";
        },
        setDirection: docMethodOp(function(dir) {
            if (dir != "rtl") dir = "ltr";
            if (dir == this.direction) return;
            this.direction = dir;
            this.iter(function(line) {
                return line.order = null;
            });
            if (this.cm) directionChanged(this.cm);
        })
    });
    // Public alias.
    Doc.prototype.eachLine = Doc.prototype.iter;
    // Kludge to work around strange IE behavior where it'll sometimes
    // re-fire a series of drag-related events right after the drop (#1551)
    var lastDrop = 0;
    function onDrop(e) {
        var cm = this;
        clearDragCursor(cm);
        if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e)) return;
        e_preventDefault(e);
        if (ie) lastDrop = +new Date;
        var pos = posFromMouse(cm, e, true), files = e.dataTransfer.files;
        if (!pos || cm.isReadOnly()) return;
        // Might be a file drop, in which case we simply extract the text
        // and insert it.
        if (files && files.length && window.FileReader && window.File) {
            var n = files.length, text = Array(n), read = 0;
            var markAsReadAndPasteIfAllFilesAreRead = function() {
                if (++read == n) operation(cm, function() {
                    pos = clipPos(cm.doc, pos);
                    var change = {
                        from: pos,
                        to: pos,
                        text: cm.doc.splitLines(text.filter(function(t) {
                            return t != null;
                        }).join(cm.doc.lineSeparator())),
                        origin: "paste"
                    };
                    makeChange(cm.doc, change);
                    setSelectionReplaceHistory(cm.doc, simpleSelection(clipPos(cm.doc, pos), clipPos(cm.doc, changeEnd(change))));
                })();
            };
            var readTextFromFile = function(file, i) {
                if (cm.options.allowDropFileTypes && indexOf(cm.options.allowDropFileTypes, file.type) == -1) {
                    markAsReadAndPasteIfAllFilesAreRead();
                    return;
                }
                var reader = new FileReader;
                reader.onerror = function() {
                    return markAsReadAndPasteIfAllFilesAreRead();
                };
                reader.onload = function() {
                    var content = reader.result;
                    if (/[\x00-\x08\x0e-\x1f]{2}/.test(content)) {
                        markAsReadAndPasteIfAllFilesAreRead();
                        return;
                    }
                    text[i] = content;
                    markAsReadAndPasteIfAllFilesAreRead();
                };
                reader.readAsText(file);
            };
            for(var i = 0; i < files.length; i++)readTextFromFile(files[i], i);
        } else {
            // Don't do a replace if the drop happened inside of the selected text.
            if (cm.state.draggingText && cm.doc.sel.contains(pos) > -1) {
                cm.state.draggingText(e);
                // Ensure the editor is re-focused
                setTimeout(function() {
                    return cm.display.input.focus();
                }, 20);
                return;
            }
            try {
                var text$1 = e.dataTransfer.getData("Text");
                if (text$1) {
                    var selected;
                    if (cm.state.draggingText && !cm.state.draggingText.copy) selected = cm.listSelections();
                    setSelectionNoUndo(cm.doc, simpleSelection(pos, pos));
                    if (selected) for(var i$1 = 0; i$1 < selected.length; ++i$1)replaceRange(cm.doc, "", selected[i$1].anchor, selected[i$1].head, "drag");
                    cm.replaceSelection(text$1, "around", "paste");
                    cm.display.input.focus();
                }
            } catch (e$1) {}
        }
    }
    function onDragStart(cm, e) {
        if (ie && (!cm.state.draggingText || +new Date - lastDrop < 100)) {
            e_stop(e);
            return;
        }
        if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e)) return;
        e.dataTransfer.setData("Text", cm.getSelection());
        e.dataTransfer.effectAllowed = "copyMove";
        // Use dummy image instead of default browsers image.
        // Recent Safari (~6.0.2) have a tendency to segfault when this happens, so we don't do it there.
        if (e.dataTransfer.setDragImage && !safari) {
            var img = elt("img", null, null, "position: fixed; left: 0; top: 0;");
            img.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
            if (presto) {
                img.width = img.height = 1;
                cm.display.wrapper.appendChild(img);
                // Force a relayout, or Opera won't use our image for some obscure reason
                img._top = img.offsetTop;
            }
            e.dataTransfer.setDragImage(img, 0, 0);
            if (presto) img.parentNode.removeChild(img);
        }
    }
    function onDragOver(cm, e) {
        var pos = posFromMouse(cm, e);
        if (!pos) return;
        var frag = document.createDocumentFragment();
        drawSelectionCursor(cm, pos, frag);
        if (!cm.display.dragCursor) {
            cm.display.dragCursor = elt("div", null, "CodeMirror-cursors CodeMirror-dragcursors");
            cm.display.lineSpace.insertBefore(cm.display.dragCursor, cm.display.cursorDiv);
        }
        removeChildrenAndAdd(cm.display.dragCursor, frag);
    }
    function clearDragCursor(cm) {
        if (cm.display.dragCursor) {
            cm.display.lineSpace.removeChild(cm.display.dragCursor);
            cm.display.dragCursor = null;
        }
    }
    // These must be handled carefully, because naively registering a
    // handler for each editor will cause the editors to never be
    // garbage collected.
    function forEachCodeMirror(f) {
        if (!document.getElementsByClassName) return;
        var byClass = document.getElementsByClassName("CodeMirror"), editors = [];
        for(var i = 0; i < byClass.length; i++){
            var cm = byClass[i].CodeMirror;
            if (cm) editors.push(cm);
        }
        if (editors.length) editors[0].operation(function() {
            for(var i = 0; i < editors.length; i++)f(editors[i]);
        });
    }
    var globalsRegistered = false;
    function ensureGlobalHandlers() {
        if (globalsRegistered) return;
        registerGlobalHandlers();
        globalsRegistered = true;
    }
    function registerGlobalHandlers() {
        // When the window resizes, we need to refresh active editors.
        var resizeTimer;
        on(window, "resize", function() {
            if (resizeTimer == null) resizeTimer = setTimeout(function() {
                resizeTimer = null;
                forEachCodeMirror(onResize);
            }, 100);
        });
        // When the window loses focus, we want to show the editor as blurred
        on(window, "blur", function() {
            return forEachCodeMirror(onBlur);
        });
    }
    // Called when the window resizes
    function onResize(cm) {
        var d = cm.display;
        // Might be a text scaling operation, clear size caches.
        d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;
        d.scrollbarsClipped = false;
        cm.setSize();
    }
    var keyNames = {
        3: "Pause",
        8: "Backspace",
        9: "Tab",
        13: "Enter",
        16: "Shift",
        17: "Ctrl",
        18: "Alt",
        19: "Pause",
        20: "CapsLock",
        27: "Esc",
        32: "Space",
        33: "PageUp",
        34: "PageDown",
        35: "End",
        36: "Home",
        37: "Left",
        38: "Up",
        39: "Right",
        40: "Down",
        44: "PrintScrn",
        45: "Insert",
        46: "Delete",
        59: ";",
        61: "=",
        91: "Mod",
        92: "Mod",
        93: "Mod",
        106: "*",
        107: "=",
        109: "-",
        110: ".",
        111: "/",
        145: "ScrollLock",
        173: "-",
        186: ";",
        187: "=",
        188: ",",
        189: "-",
        190: ".",
        191: "/",
        192: "`",
        219: "[",
        220: "\\",
        221: "]",
        222: "'",
        224: "Mod",
        63232: "Up",
        63233: "Down",
        63234: "Left",
        63235: "Right",
        63272: "Delete",
        63273: "Home",
        63275: "End",
        63276: "PageUp",
        63277: "PageDown",
        63302: "Insert"
    };
    // Number keys
    for(var i = 0; i < 10; i++)keyNames[i + 48] = keyNames[i + 96] = String(i);
    // Alphabetic keys
    for(var i$1 = 65; i$1 <= 90; i$1++)keyNames[i$1] = String.fromCharCode(i$1);
    // Function keys
    for(var i$2 = 1; i$2 <= 12; i$2++)keyNames[i$2 + 111] = keyNames[i$2 + 63235] = "F" + i$2;
    var keyMap = {};
    keyMap.basic = {
        "Left": "goCharLeft",
        "Right": "goCharRight",
        "Up": "goLineUp",
        "Down": "goLineDown",
        "End": "goLineEnd",
        "Home": "goLineStartSmart",
        "PageUp": "goPageUp",
        "PageDown": "goPageDown",
        "Delete": "delCharAfter",
        "Backspace": "delCharBefore",
        "Shift-Backspace": "delCharBefore",
        "Tab": "defaultTab",
        "Shift-Tab": "indentAuto",
        "Enter": "newlineAndIndent",
        "Insert": "toggleOverwrite",
        "Esc": "singleSelection"
    };
    // Note that the save and find-related commands aren't defined by
    // default. User code or addons can define them. Unknown commands
    // are simply ignored.
    keyMap.pcDefault = {
        "Ctrl-A": "selectAll",
        "Ctrl-D": "deleteLine",
        "Ctrl-Z": "undo",
        "Shift-Ctrl-Z": "redo",
        "Ctrl-Y": "redo",
        "Ctrl-Home": "goDocStart",
        "Ctrl-End": "goDocEnd",
        "Ctrl-Up": "goLineUp",
        "Ctrl-Down": "goLineDown",
        "Ctrl-Left": "goGroupLeft",
        "Ctrl-Right": "goGroupRight",
        "Alt-Left": "goLineStart",
        "Alt-Right": "goLineEnd",
        "Ctrl-Backspace": "delGroupBefore",
        "Ctrl-Delete": "delGroupAfter",
        "Ctrl-S": "save",
        "Ctrl-F": "find",
        "Ctrl-G": "findNext",
        "Shift-Ctrl-G": "findPrev",
        "Shift-Ctrl-F": "replace",
        "Shift-Ctrl-R": "replaceAll",
        "Ctrl-[": "indentLess",
        "Ctrl-]": "indentMore",
        "Ctrl-U": "undoSelection",
        "Shift-Ctrl-U": "redoSelection",
        "Alt-U": "redoSelection",
        "fallthrough": "basic"
    };
    // Very basic readline/emacs-style bindings, which are standard on Mac.
    keyMap.emacsy = {
        "Ctrl-F": "goCharRight",
        "Ctrl-B": "goCharLeft",
        "Ctrl-P": "goLineUp",
        "Ctrl-N": "goLineDown",
        "Ctrl-A": "goLineStart",
        "Ctrl-E": "goLineEnd",
        "Ctrl-V": "goPageDown",
        "Shift-Ctrl-V": "goPageUp",
        "Ctrl-D": "delCharAfter",
        "Ctrl-H": "delCharBefore",
        "Alt-Backspace": "delWordBefore",
        "Ctrl-K": "killLine",
        "Ctrl-T": "transposeChars",
        "Ctrl-O": "openLine"
    };
    keyMap.macDefault = {
        "Cmd-A": "selectAll",
        "Cmd-D": "deleteLine",
        "Cmd-Z": "undo",
        "Shift-Cmd-Z": "redo",
        "Cmd-Y": "redo",
        "Cmd-Home": "goDocStart",
        "Cmd-Up": "goDocStart",
        "Cmd-End": "goDocEnd",
        "Cmd-Down": "goDocEnd",
        "Alt-Left": "goGroupLeft",
        "Alt-Right": "goGroupRight",
        "Cmd-Left": "goLineLeft",
        "Cmd-Right": "goLineRight",
        "Alt-Backspace": "delGroupBefore",
        "Ctrl-Alt-Backspace": "delGroupAfter",
        "Alt-Delete": "delGroupAfter",
        "Cmd-S": "save",
        "Cmd-F": "find",
        "Cmd-G": "findNext",
        "Shift-Cmd-G": "findPrev",
        "Cmd-Alt-F": "replace",
        "Shift-Cmd-Alt-F": "replaceAll",
        "Cmd-[": "indentLess",
        "Cmd-]": "indentMore",
        "Cmd-Backspace": "delWrappedLineLeft",
        "Cmd-Delete": "delWrappedLineRight",
        "Cmd-U": "undoSelection",
        "Shift-Cmd-U": "redoSelection",
        "Ctrl-Up": "goDocStart",
        "Ctrl-Down": "goDocEnd",
        "fallthrough": [
            "basic",
            "emacsy"
        ]
    };
    keyMap["default"] = mac ? keyMap.macDefault : keyMap.pcDefault;
    // KEYMAP DISPATCH
    function normalizeKeyName(name) {
        var parts = name.split(/-(?!$)/);
        name = parts[parts.length - 1];
        var alt, ctrl, shift, cmd;
        for(var i = 0; i < parts.length - 1; i++){
            var mod = parts[i];
            if (/^(cmd|meta|m)$/i.test(mod)) cmd = true;
            else if (/^a(lt)?$/i.test(mod)) alt = true;
            else if (/^(c|ctrl|control)$/i.test(mod)) ctrl = true;
            else if (/^s(hift)?$/i.test(mod)) shift = true;
            else throw new Error("Unrecognized modifier name: " + mod);
        }
        if (alt) name = "Alt-" + name;
        if (ctrl) name = "Ctrl-" + name;
        if (cmd) name = "Cmd-" + name;
        if (shift) name = "Shift-" + name;
        return name;
    }
    // This is a kludge to keep keymaps mostly working as raw objects
    // (backwards compatibility) while at the same time support features
    // like normalization and multi-stroke key bindings. It compiles a
    // new normalized keymap, and then updates the old object to reflect
    // this.
    function normalizeKeyMap(keymap) {
        var copy = {};
        for(var keyname in keymap)if (keymap.hasOwnProperty(keyname)) {
            var value = keymap[keyname];
            if (/^(name|fallthrough|(de|at)tach)$/.test(keyname)) continue;
            if (value == "...") {
                delete keymap[keyname];
                continue;
            }
            var keys = map(keyname.split(" "), normalizeKeyName);
            for(var i = 0; i < keys.length; i++){
                var val = void 0, name = void 0;
                if (i == keys.length - 1) {
                    name = keys.join(" ");
                    val = value;
                } else {
                    name = keys.slice(0, i + 1).join(" ");
                    val = "...";
                }
                var prev = copy[name];
                if (!prev) copy[name] = val;
                else if (prev != val) throw new Error("Inconsistent bindings for " + name);
            }
            delete keymap[keyname];
        }
        for(var prop in copy)keymap[prop] = copy[prop];
        return keymap;
    }
    function lookupKey(key, map, handle, context) {
        map = getKeyMap(map);
        var found = map.call ? map.call(key, context) : map[key];
        if (found === false) return "nothing";
        if (found === "...") return "multi";
        if (found != null && handle(found)) return "handled";
        if (map.fallthrough) {
            if (Object.prototype.toString.call(map.fallthrough) != "[object Array]") return lookupKey(key, map.fallthrough, handle, context);
            for(var i = 0; i < map.fallthrough.length; i++){
                var result = lookupKey(key, map.fallthrough[i], handle, context);
                if (result) return result;
            }
        }
    }
    // Modifier key presses don't count as 'real' key presses for the
    // purpose of keymap fallthrough.
    function isModifierKey(value) {
        var name = typeof value == "string" ? value : keyNames[value.keyCode];
        return name == "Ctrl" || name == "Alt" || name == "Shift" || name == "Mod";
    }
    function addModifierNames(name, event, noShift) {
        var base = name;
        if (event.altKey && base != "Alt") name = "Alt-" + name;
        if ((flipCtrlCmd ? event.metaKey : event.ctrlKey) && base != "Ctrl") name = "Ctrl-" + name;
        if ((flipCtrlCmd ? event.ctrlKey : event.metaKey) && base != "Mod") name = "Cmd-" + name;
        if (!noShift && event.shiftKey && base != "Shift") name = "Shift-" + name;
        return name;
    }
    // Look up the name of a key as indicated by an event object.
    function keyName(event, noShift) {
        if (presto && event.keyCode == 34 && event["char"]) return false;
        var name = keyNames[event.keyCode];
        if (name == null || event.altGraphKey) return false;
        // Ctrl-ScrollLock has keyCode 3, same as Ctrl-Pause,
        // so we'll use event.code when available (Chrome 48+, FF 38+, Safari 10.1+)
        if (event.keyCode == 3 && event.code) name = event.code;
        return addModifierNames(name, event, noShift);
    }
    function getKeyMap(val) {
        return typeof val == "string" ? keyMap[val] : val;
    }
    // Helper for deleting text near the selection(s), used to implement
    // backspace, delete, and similar functionality.
    function deleteNearSelection(cm, compute) {
        var ranges = cm.doc.sel.ranges, kill = [];
        // Build up a set of ranges to kill first, merging overlapping
        // ranges.
        for(var i = 0; i < ranges.length; i++){
            var toKill = compute(ranges[i]);
            while(kill.length && cmp(toKill.from, lst(kill).to) <= 0){
                var replaced = kill.pop();
                if (cmp(replaced.from, toKill.from) < 0) {
                    toKill.from = replaced.from;
                    break;
                }
            }
            kill.push(toKill);
        }
        // Next, remove those actual ranges.
        runInOp(cm, function() {
            for(var i = kill.length - 1; i >= 0; i--)replaceRange(cm.doc, "", kill[i].from, kill[i].to, "+delete");
            ensureCursorVisible(cm);
        });
    }
    function moveCharLogically(line, ch, dir) {
        var target = skipExtendingChars(line.text, ch + dir, dir);
        return target < 0 || target > line.text.length ? null : target;
    }
    function moveLogically(line, start, dir) {
        var ch = moveCharLogically(line, start.ch, dir);
        return ch == null ? null : new Pos(start.line, ch, dir < 0 ? "after" : "before");
    }
    function endOfLine(visually, cm, lineObj, lineNo, dir) {
        if (visually) {
            if (cm.doc.direction == "rtl") dir = -dir;
            var order = getOrder(lineObj, cm.doc.direction);
            if (order) {
                var part = dir < 0 ? lst(order) : order[0];
                var moveInStorageOrder = dir < 0 == (part.level == 1);
                var sticky = moveInStorageOrder ? "after" : "before";
                var ch;
                // With a wrapped rtl chunk (possibly spanning multiple bidi parts),
                // it could be that the last bidi part is not on the last visual line,
                // since visual lines contain content order-consecutive chunks.
                // Thus, in rtl, we are looking for the first (content-order) character
                // in the rtl chunk that is on the last line (that is, the same line
                // as the last (content-order) character).
                if (part.level > 0 || cm.doc.direction == "rtl") {
                    var prep = prepareMeasureForLine(cm, lineObj);
                    ch = dir < 0 ? lineObj.text.length - 1 : 0;
                    var targetTop = measureCharPrepared(cm, prep, ch).top;
                    ch = findFirst(function(ch) {
                        return measureCharPrepared(cm, prep, ch).top == targetTop;
                    }, dir < 0 == (part.level == 1) ? part.from : part.to - 1, ch);
                    if (sticky == "before") ch = moveCharLogically(lineObj, ch, 1);
                } else ch = dir < 0 ? part.to : part.from;
                return new Pos(lineNo, ch, sticky);
            }
        }
        return new Pos(lineNo, dir < 0 ? lineObj.text.length : 0, dir < 0 ? "before" : "after");
    }
    function moveVisually(cm, line, start, dir) {
        var bidi = getOrder(line, cm.doc.direction);
        if (!bidi) return moveLogically(line, start, dir);
        if (start.ch >= line.text.length) {
            start.ch = line.text.length;
            start.sticky = "before";
        } else if (start.ch <= 0) {
            start.ch = 0;
            start.sticky = "after";
        }
        var partPos = getBidiPartAt(bidi, start.ch, start.sticky), part = bidi[partPos];
        if (cm.doc.direction == "ltr" && part.level % 2 == 0 && (dir > 0 ? part.to > start.ch : part.from < start.ch)) // Case 1: We move within an ltr part in an ltr editor. Even with wrapped lines,
        // nothing interesting happens.
        return moveLogically(line, start, dir);
        var mv = function(pos, dir) {
            return moveCharLogically(line, pos instanceof Pos ? pos.ch : pos, dir);
        };
        var prep;
        var getWrappedLineExtent = function(ch) {
            if (!cm.options.lineWrapping) return {
                begin: 0,
                end: line.text.length
            };
            prep = prep || prepareMeasureForLine(cm, line);
            return wrappedLineExtentChar(cm, line, prep, ch);
        };
        var wrappedLineExtent = getWrappedLineExtent(start.sticky == "before" ? mv(start, -1) : start.ch);
        if (cm.doc.direction == "rtl" || part.level == 1) {
            var moveInStorageOrder = part.level == 1 == dir < 0;
            var ch = mv(start, moveInStorageOrder ? 1 : -1);
            if (ch != null && (!moveInStorageOrder ? ch >= part.from && ch >= wrappedLineExtent.begin : ch <= part.to && ch <= wrappedLineExtent.end)) {
                // Case 2: We move within an rtl part or in an rtl editor on the same visual line
                var sticky = moveInStorageOrder ? "before" : "after";
                return new Pos(start.line, ch, sticky);
            }
        }
        // Case 3: Could not move within this bidi part in this visual line, so leave
        // the current bidi part
        var searchInVisualLine = function(partPos, dir, wrappedLineExtent) {
            var getRes = function(ch, moveInStorageOrder) {
                return moveInStorageOrder ? new Pos(start.line, mv(ch, 1), "before") : new Pos(start.line, ch, "after");
            };
            for(; partPos >= 0 && partPos < bidi.length; partPos += dir){
                var part = bidi[partPos];
                var moveInStorageOrder = dir > 0 == (part.level != 1);
                var ch = moveInStorageOrder ? wrappedLineExtent.begin : mv(wrappedLineExtent.end, -1);
                if (part.from <= ch && ch < part.to) return getRes(ch, moveInStorageOrder);
                ch = moveInStorageOrder ? part.from : mv(part.to, -1);
                if (wrappedLineExtent.begin <= ch && ch < wrappedLineExtent.end) return getRes(ch, moveInStorageOrder);
            }
        };
        // Case 3a: Look for other bidi parts on the same visual line
        var res = searchInVisualLine(partPos + dir, dir, wrappedLineExtent);
        if (res) return res;
        // Case 3b: Look for other bidi parts on the next visual line
        var nextCh = dir > 0 ? wrappedLineExtent.end : mv(wrappedLineExtent.begin, -1);
        if (nextCh != null && !(dir > 0 && nextCh == line.text.length)) {
            res = searchInVisualLine(dir > 0 ? 0 : bidi.length - 1, dir, getWrappedLineExtent(nextCh));
            if (res) return res;
        }
        // Case 4: Nowhere to move
        return null;
    }
    // Commands are parameter-less actions that can be performed on an
    // editor, mostly used for keybindings.
    var commands = {
        selectAll: selectAll,
        singleSelection: function(cm) {
            return cm.setSelection(cm.getCursor("anchor"), cm.getCursor("head"), sel_dontScroll);
        },
        killLine: function(cm) {
            return deleteNearSelection(cm, function(range) {
                if (range.empty()) {
                    var len = getLine(cm.doc, range.head.line).text.length;
                    if (range.head.ch == len && range.head.line < cm.lastLine()) return {
                        from: range.head,
                        to: Pos(range.head.line + 1, 0)
                    };
                    else return {
                        from: range.head,
                        to: Pos(range.head.line, len)
                    };
                } else return {
                    from: range.from(),
                    to: range.to()
                };
            });
        },
        deleteLine: function(cm) {
            return deleteNearSelection(cm, function(range) {
                return {
                    from: Pos(range.from().line, 0),
                    to: clipPos(cm.doc, Pos(range.to().line + 1, 0))
                };
            });
        },
        delLineLeft: function(cm) {
            return deleteNearSelection(cm, function(range) {
                return {
                    from: Pos(range.from().line, 0),
                    to: range.from()
                };
            });
        },
        delWrappedLineLeft: function(cm) {
            return deleteNearSelection(cm, function(range) {
                var top = cm.charCoords(range.head, "div").top + 5;
                var leftPos = cm.coordsChar({
                    left: 0,
                    top: top
                }, "div");
                return {
                    from: leftPos,
                    to: range.from()
                };
            });
        },
        delWrappedLineRight: function(cm) {
            return deleteNearSelection(cm, function(range) {
                var top = cm.charCoords(range.head, "div").top + 5;
                var rightPos = cm.coordsChar({
                    left: cm.display.lineDiv.offsetWidth + 100,
                    top: top
                }, "div");
                return {
                    from: range.from(),
                    to: rightPos
                };
            });
        },
        undo: function(cm) {
            return cm.undo();
        },
        redo: function(cm) {
            return cm.redo();
        },
        undoSelection: function(cm) {
            return cm.undoSelection();
        },
        redoSelection: function(cm) {
            return cm.redoSelection();
        },
        goDocStart: function(cm) {
            return cm.extendSelection(Pos(cm.firstLine(), 0));
        },
        goDocEnd: function(cm) {
            return cm.extendSelection(Pos(cm.lastLine()));
        },
        goLineStart: function(cm) {
            return cm.extendSelectionsBy(function(range) {
                return lineStart(cm, range.head.line);
            }, {
                origin: "+move",
                bias: 1
            });
        },
        goLineStartSmart: function(cm) {
            return cm.extendSelectionsBy(function(range) {
                return lineStartSmart(cm, range.head);
            }, {
                origin: "+move",
                bias: 1
            });
        },
        goLineEnd: function(cm) {
            return cm.extendSelectionsBy(function(range) {
                return lineEnd(cm, range.head.line);
            }, {
                origin: "+move",
                bias: -1
            });
        },
        goLineRight: function(cm) {
            return cm.extendSelectionsBy(function(range) {
                var top = cm.cursorCoords(range.head, "div").top + 5;
                return cm.coordsChar({
                    left: cm.display.lineDiv.offsetWidth + 100,
                    top: top
                }, "div");
            }, sel_move);
        },
        goLineLeft: function(cm) {
            return cm.extendSelectionsBy(function(range) {
                var top = cm.cursorCoords(range.head, "div").top + 5;
                return cm.coordsChar({
                    left: 0,
                    top: top
                }, "div");
            }, sel_move);
        },
        goLineLeftSmart: function(cm) {
            return cm.extendSelectionsBy(function(range) {
                var top = cm.cursorCoords(range.head, "div").top + 5;
                var pos = cm.coordsChar({
                    left: 0,
                    top: top
                }, "div");
                if (pos.ch < cm.getLine(pos.line).search(/\S/)) return lineStartSmart(cm, range.head);
                return pos;
            }, sel_move);
        },
        goLineUp: function(cm) {
            return cm.moveV(-1, "line");
        },
        goLineDown: function(cm) {
            return cm.moveV(1, "line");
        },
        goPageUp: function(cm) {
            return cm.moveV(-1, "page");
        },
        goPageDown: function(cm) {
            return cm.moveV(1, "page");
        },
        goCharLeft: function(cm) {
            return cm.moveH(-1, "char");
        },
        goCharRight: function(cm) {
            return cm.moveH(1, "char");
        },
        goColumnLeft: function(cm) {
            return cm.moveH(-1, "column");
        },
        goColumnRight: function(cm) {
            return cm.moveH(1, "column");
        },
        goWordLeft: function(cm) {
            return cm.moveH(-1, "word");
        },
        goGroupRight: function(cm) {
            return cm.moveH(1, "group");
        },
        goGroupLeft: function(cm) {
            return cm.moveH(-1, "group");
        },
        goWordRight: function(cm) {
            return cm.moveH(1, "word");
        },
        delCharBefore: function(cm) {
            return cm.deleteH(-1, "codepoint");
        },
        delCharAfter: function(cm) {
            return cm.deleteH(1, "char");
        },
        delWordBefore: function(cm) {
            return cm.deleteH(-1, "word");
        },
        delWordAfter: function(cm) {
            return cm.deleteH(1, "word");
        },
        delGroupBefore: function(cm) {
            return cm.deleteH(-1, "group");
        },
        delGroupAfter: function(cm) {
            return cm.deleteH(1, "group");
        },
        indentAuto: function(cm) {
            return cm.indentSelection("smart");
        },
        indentMore: function(cm) {
            return cm.indentSelection("add");
        },
        indentLess: function(cm) {
            return cm.indentSelection("subtract");
        },
        insertTab: function(cm) {
            return cm.replaceSelection("\t");
        },
        insertSoftTab: function(cm) {
            var spaces = [], ranges = cm.listSelections(), tabSize = cm.options.tabSize;
            for(var i = 0; i < ranges.length; i++){
                var pos = ranges[i].from();
                var col = countColumn(cm.getLine(pos.line), pos.ch, tabSize);
                spaces.push(spaceStr(tabSize - col % tabSize));
            }
            cm.replaceSelections(spaces);
        },
        defaultTab: function(cm) {
            if (cm.somethingSelected()) cm.indentSelection("add");
            else cm.execCommand("insertTab");
        },
        // Swap the two chars left and right of each selection's head.
        // Move cursor behind the two swapped characters afterwards.
        //
        // Doesn't consider line feeds a character.
        // Doesn't scan more than one line above to find a character.
        // Doesn't do anything on an empty line.
        // Doesn't do anything with non-empty selections.
        transposeChars: function(cm) {
            return runInOp(cm, function() {
                var ranges = cm.listSelections(), newSel = [];
                for(var i = 0; i < ranges.length; i++){
                    if (!ranges[i].empty()) continue;
                    var cur = ranges[i].head, line = getLine(cm.doc, cur.line).text;
                    if (line) {
                        if (cur.ch == line.length) cur = new Pos(cur.line, cur.ch - 1);
                        if (cur.ch > 0) {
                            cur = new Pos(cur.line, cur.ch + 1);
                            cm.replaceRange(line.charAt(cur.ch - 1) + line.charAt(cur.ch - 2), Pos(cur.line, cur.ch - 2), cur, "+transpose");
                        } else if (cur.line > cm.doc.first) {
                            var prev = getLine(cm.doc, cur.line - 1).text;
                            if (prev) {
                                cur = new Pos(cur.line, 1);
                                cm.replaceRange(line.charAt(0) + cm.doc.lineSeparator() + prev.charAt(prev.length - 1), Pos(cur.line - 1, prev.length - 1), cur, "+transpose");
                            }
                        }
                    }
                    newSel.push(new Range(cur, cur));
                }
                cm.setSelections(newSel);
            });
        },
        newlineAndIndent: function(cm) {
            return runInOp(cm, function() {
                var sels = cm.listSelections();
                for(var i = sels.length - 1; i >= 0; i--)cm.replaceRange(cm.doc.lineSeparator(), sels[i].anchor, sels[i].head, "+input");
                sels = cm.listSelections();
                for(var i$1 = 0; i$1 < sels.length; i$1++)cm.indentLine(sels[i$1].from().line, null, true);
                ensureCursorVisible(cm);
            });
        },
        openLine: function(cm) {
            return cm.replaceSelection("\n", "start");
        },
        toggleOverwrite: function(cm) {
            return cm.toggleOverwrite();
        }
    };
    function lineStart(cm, lineN) {
        var line = getLine(cm.doc, lineN);
        var visual = visualLine(line);
        if (visual != line) lineN = lineNo(visual);
        return endOfLine(true, cm, visual, lineN, 1);
    }
    function lineEnd(cm, lineN) {
        var line = getLine(cm.doc, lineN);
        var visual = visualLineEnd(line);
        if (visual != line) lineN = lineNo(visual);
        return endOfLine(true, cm, line, lineN, -1);
    }
    function lineStartSmart(cm, pos) {
        var start = lineStart(cm, pos.line);
        var line = getLine(cm.doc, start.line);
        var order = getOrder(line, cm.doc.direction);
        if (!order || order[0].level == 0) {
            var firstNonWS = Math.max(start.ch, line.text.search(/\S/));
            var inWS = pos.line == start.line && pos.ch <= firstNonWS && pos.ch;
            return Pos(start.line, inWS ? 0 : firstNonWS, start.sticky);
        }
        return start;
    }
    // Run a handler that was bound to a key.
    function doHandleBinding(cm, bound, dropShift) {
        if (typeof bound == "string") {
            bound = commands[bound];
            if (!bound) return false;
        }
        // Ensure previous input has been read, so that the handler sees a
        // consistent view of the document
        cm.display.input.ensurePolled();
        var prevShift = cm.display.shift, done = false;
        try {
            if (cm.isReadOnly()) cm.state.suppressEdits = true;
            if (dropShift) cm.display.shift = false;
            done = bound(cm) != Pass;
        } finally{
            cm.display.shift = prevShift;
            cm.state.suppressEdits = false;
        }
        return done;
    }
    function lookupKeyForEditor(cm, name, handle) {
        for(var i = 0; i < cm.state.keyMaps.length; i++){
            var result = lookupKey(name, cm.state.keyMaps[i], handle, cm);
            if (result) return result;
        }
        return cm.options.extraKeys && lookupKey(name, cm.options.extraKeys, handle, cm) || lookupKey(name, cm.options.keyMap, handle, cm);
    }
    // Note that, despite the name, this function is also used to check
    // for bound mouse clicks.
    var stopSeq = new Delayed;
    function dispatchKey(cm, name, e, handle) {
        var seq = cm.state.keySeq;
        if (seq) {
            if (isModifierKey(name)) return "handled";
            if (/\'$/.test(name)) cm.state.keySeq = null;
            else stopSeq.set(50, function() {
                if (cm.state.keySeq == seq) {
                    cm.state.keySeq = null;
                    cm.display.input.reset();
                }
            });
            if (dispatchKeyInner(cm, seq + " " + name, e, handle)) return true;
        }
        return dispatchKeyInner(cm, name, e, handle);
    }
    function dispatchKeyInner(cm, name, e, handle) {
        var result = lookupKeyForEditor(cm, name, handle);
        if (result == "multi") cm.state.keySeq = name;
        if (result == "handled") signalLater(cm, "keyHandled", cm, name, e);
        if (result == "handled" || result == "multi") {
            e_preventDefault(e);
            restartBlink(cm);
        }
        return !!result;
    }
    // Handle a key from the keydown event.
    function handleKeyBinding(cm, e) {
        var name = keyName(e, true);
        if (!name) return false;
        if (e.shiftKey && !cm.state.keySeq) // First try to resolve full name (including 'Shift-'). Failing
        // that, see if there is a cursor-motion command (starting with
        // 'go') bound to the keyname without 'Shift-'.
        return dispatchKey(cm, "Shift-" + name, e, function(b) {
            return doHandleBinding(cm, b, true);
        }) || dispatchKey(cm, name, e, function(b) {
            if (typeof b == "string" ? /^go[A-Z]/.test(b) : b.motion) return doHandleBinding(cm, b);
        });
        else return dispatchKey(cm, name, e, function(b) {
            return doHandleBinding(cm, b);
        });
    }
    // Handle a key from the keypress event
    function handleCharBinding(cm, e, ch) {
        return dispatchKey(cm, "'" + ch + "'", e, function(b) {
            return doHandleBinding(cm, b, true);
        });
    }
    var lastStoppedKey = null;
    function onKeyDown(e) {
        var cm = this;
        if (e.target && e.target != cm.display.input.getField()) return;
        cm.curOp.focus = activeElt();
        if (signalDOMEvent(cm, e)) return;
        // IE does strange things with escape.
        if (ie && ie_version < 11 && e.keyCode == 27) e.returnValue = false;
        var code = e.keyCode;
        cm.display.shift = code == 16 || e.shiftKey;
        var handled = handleKeyBinding(cm, e);
        if (presto) {
            lastStoppedKey = handled ? code : null;
            // Opera has no cut event... we try to at least catch the key combo
            if (!handled && code == 88 && !hasCopyEvent && (mac ? e.metaKey : e.ctrlKey)) cm.replaceSelection("", null, "cut");
        }
        if (gecko && !mac && !handled && code == 46 && e.shiftKey && !e.ctrlKey && document.execCommand) document.execCommand("cut");
        // Turn mouse into crosshair when Alt is held on Mac.
        if (code == 18 && !/\bCodeMirror-crosshair\b/.test(cm.display.lineDiv.className)) showCrossHair(cm);
    }
    function showCrossHair(cm) {
        var lineDiv = cm.display.lineDiv;
        addClass(lineDiv, "CodeMirror-crosshair");
        function up(e) {
            if (e.keyCode == 18 || !e.altKey) {
                rmClass(lineDiv, "CodeMirror-crosshair");
                off(document, "keyup", up);
                off(document, "mouseover", up);
            }
        }
        on(document, "keyup", up);
        on(document, "mouseover", up);
    }
    function onKeyUp(e) {
        if (e.keyCode == 16) this.doc.sel.shift = false;
        signalDOMEvent(this, e);
    }
    function onKeyPress(e) {
        var cm = this;
        if (e.target && e.target != cm.display.input.getField()) return;
        if (eventInWidget(cm.display, e) || signalDOMEvent(cm, e) || e.ctrlKey && !e.altKey || mac && e.metaKey) return;
        var keyCode = e.keyCode, charCode = e.charCode;
        if (presto && keyCode == lastStoppedKey) {
            lastStoppedKey = null;
            e_preventDefault(e);
            return;
        }
        if (presto && (!e.which || e.which < 10) && handleKeyBinding(cm, e)) return;
        var ch = String.fromCharCode(charCode == null ? keyCode : charCode);
        // Some browsers fire keypress events for backspace
        if (ch == "\x08") return;
        if (handleCharBinding(cm, e, ch)) return;
        cm.display.input.onKeyPress(e);
    }
    var DOUBLECLICK_DELAY = 400;
    var PastClick = function(time, pos, button) {
        this.time = time;
        this.pos = pos;
        this.button = button;
    };
    PastClick.prototype.compare = function(time, pos, button) {
        return this.time + DOUBLECLICK_DELAY > time && cmp(pos, this.pos) == 0 && button == this.button;
    };
    var lastClick, lastDoubleClick;
    function clickRepeat(pos, button) {
        var now = +new Date;
        if (lastDoubleClick && lastDoubleClick.compare(now, pos, button)) {
            lastClick = lastDoubleClick = null;
            return "triple";
        } else if (lastClick && lastClick.compare(now, pos, button)) {
            lastDoubleClick = new PastClick(now, pos, button);
            lastClick = null;
            return "double";
        } else {
            lastClick = new PastClick(now, pos, button);
            lastDoubleClick = null;
            return "single";
        }
    }
    // A mouse down can be a single click, double click, triple click,
    // start of selection drag, start of text drag, new cursor
    // (ctrl-click), rectangle drag (alt-drag), or xwin
    // middle-click-paste. Or it might be a click on something we should
    // not interfere with, such as a scrollbar or widget.
    function onMouseDown(e) {
        var cm = this, display = cm.display;
        if (signalDOMEvent(cm, e) || display.activeTouch && display.input.supportsTouch()) return;
        display.input.ensurePolled();
        display.shift = e.shiftKey;
        if (eventInWidget(display, e)) {
            if (!webkit) {
                // Briefly turn off draggability, to allow widgets to do
                // normal dragging things.
                display.scroller.draggable = false;
                setTimeout(function() {
                    return display.scroller.draggable = true;
                }, 100);
            }
            return;
        }
        if (clickInGutter(cm, e)) return;
        var pos = posFromMouse(cm, e), button = e_button(e), repeat = pos ? clickRepeat(pos, button) : "single";
        window.focus();
        // #3261: make sure, that we're not starting a second selection
        if (button == 1 && cm.state.selectingText) cm.state.selectingText(e);
        if (pos && handleMappedButton(cm, button, pos, repeat, e)) return;
        if (button == 1) {
            if (pos) leftButtonDown(cm, pos, repeat, e);
            else if (e_target(e) == display.scroller) e_preventDefault(e);
        } else if (button == 2) {
            if (pos) extendSelection(cm.doc, pos);
            setTimeout(function() {
                return display.input.focus();
            }, 20);
        } else if (button == 3) {
            if (captureRightClick) cm.display.input.onContextMenu(e);
            else delayBlurEvent(cm);
        }
    }
    function handleMappedButton(cm, button, pos, repeat, event) {
        var name = "Click";
        if (repeat == "double") name = "Double" + name;
        else if (repeat == "triple") name = "Triple" + name;
        name = (button == 1 ? "Left" : button == 2 ? "Middle" : "Right") + name;
        return dispatchKey(cm, addModifierNames(name, event), event, function(bound) {
            if (typeof bound == "string") bound = commands[bound];
            if (!bound) return false;
            var done = false;
            try {
                if (cm.isReadOnly()) cm.state.suppressEdits = true;
                done = bound(cm, pos) != Pass;
            } finally{
                cm.state.suppressEdits = false;
            }
            return done;
        });
    }
    function configureMouse(cm, repeat, event) {
        var option = cm.getOption("configureMouse");
        var value = option ? option(cm, repeat, event) : {};
        if (value.unit == null) {
            var rect = chromeOS ? event.shiftKey && event.metaKey : event.altKey;
            value.unit = rect ? "rectangle" : repeat == "single" ? "char" : repeat == "double" ? "word" : "line";
        }
        if (value.extend == null || cm.doc.extend) value.extend = cm.doc.extend || event.shiftKey;
        if (value.addNew == null) value.addNew = mac ? event.metaKey : event.ctrlKey;
        if (value.moveOnDrag == null) value.moveOnDrag = !(mac ? event.altKey : event.ctrlKey);
        return value;
    }
    function leftButtonDown(cm, pos, repeat, event) {
        if (ie) setTimeout(bind(ensureFocus, cm), 0);
        else cm.curOp.focus = activeElt();
        var behavior = configureMouse(cm, repeat, event);
        var sel = cm.doc.sel, contained;
        if (cm.options.dragDrop && dragAndDrop && !cm.isReadOnly() && repeat == "single" && (contained = sel.contains(pos)) > -1 && (cmp((contained = sel.ranges[contained]).from(), pos) < 0 || pos.xRel > 0) && (cmp(contained.to(), pos) > 0 || pos.xRel < 0)) leftButtonStartDrag(cm, event, pos, behavior);
        else leftButtonSelect(cm, event, pos, behavior);
    }
    // Start a text drag. When it ends, see if any dragging actually
    // happen, and treat as a click if it didn't.
    function leftButtonStartDrag(cm, event, pos, behavior) {
        var display = cm.display, moved = false;
        var dragEnd = operation(cm, function(e) {
            if (webkit) display.scroller.draggable = false;
            cm.state.draggingText = false;
            if (cm.state.delayingBlurEvent) {
                if (cm.hasFocus()) cm.state.delayingBlurEvent = false;
                else delayBlurEvent(cm);
            }
            off(display.wrapper.ownerDocument, "mouseup", dragEnd);
            off(display.wrapper.ownerDocument, "mousemove", mouseMove);
            off(display.scroller, "dragstart", dragStart);
            off(display.scroller, "drop", dragEnd);
            if (!moved) {
                e_preventDefault(e);
                if (!behavior.addNew) extendSelection(cm.doc, pos, null, null, behavior.extend);
                // Work around unexplainable focus problem in IE9 (#2127) and Chrome (#3081)
                if (webkit && !safari || ie && ie_version == 9) setTimeout(function() {
                    display.wrapper.ownerDocument.body.focus({
                        preventScroll: true
                    });
                    display.input.focus();
                }, 20);
                else display.input.focus();
            }
        });
        var mouseMove = function(e2) {
            moved = moved || Math.abs(event.clientX - e2.clientX) + Math.abs(event.clientY - e2.clientY) >= 10;
        };
        var dragStart = function() {
            return moved = true;
        };
        // Let the drag handler handle this.
        if (webkit) display.scroller.draggable = true;
        cm.state.draggingText = dragEnd;
        dragEnd.copy = !behavior.moveOnDrag;
        on(display.wrapper.ownerDocument, "mouseup", dragEnd);
        on(display.wrapper.ownerDocument, "mousemove", mouseMove);
        on(display.scroller, "dragstart", dragStart);
        on(display.scroller, "drop", dragEnd);
        cm.state.delayingBlurEvent = true;
        setTimeout(function() {
            return display.input.focus();
        }, 20);
        // IE's approach to draggable
        if (display.scroller.dragDrop) display.scroller.dragDrop();
    }
    function rangeForUnit(cm, pos, unit) {
        if (unit == "char") return new Range(pos, pos);
        if (unit == "word") return cm.findWordAt(pos);
        if (unit == "line") return new Range(Pos(pos.line, 0), clipPos(cm.doc, Pos(pos.line + 1, 0)));
        var result = unit(cm, pos);
        return new Range(result.from, result.to);
    }
    // Normal selection, as opposed to text dragging.
    function leftButtonSelect(cm, event, start, behavior) {
        if (ie) delayBlurEvent(cm);
        var display = cm.display, doc = cm.doc;
        e_preventDefault(event);
        var ourRange, ourIndex, startSel = doc.sel, ranges = startSel.ranges;
        if (behavior.addNew && !behavior.extend) {
            ourIndex = doc.sel.contains(start);
            if (ourIndex > -1) ourRange = ranges[ourIndex];
            else ourRange = new Range(start, start);
        } else {
            ourRange = doc.sel.primary();
            ourIndex = doc.sel.primIndex;
        }
        if (behavior.unit == "rectangle") {
            if (!behavior.addNew) ourRange = new Range(start, start);
            start = posFromMouse(cm, event, true, true);
            ourIndex = -1;
        } else {
            var range = rangeForUnit(cm, start, behavior.unit);
            if (behavior.extend) ourRange = extendRange(ourRange, range.anchor, range.head, behavior.extend);
            else ourRange = range;
        }
        if (!behavior.addNew) {
            ourIndex = 0;
            setSelection(doc, new Selection([
                ourRange
            ], 0), sel_mouse);
            startSel = doc.sel;
        } else if (ourIndex == -1) {
            ourIndex = ranges.length;
            setSelection(doc, normalizeSelection(cm, ranges.concat([
                ourRange
            ]), ourIndex), {
                scroll: false,
                origin: "*mouse"
            });
        } else if (ranges.length > 1 && ranges[ourIndex].empty() && behavior.unit == "char" && !behavior.extend) {
            setSelection(doc, normalizeSelection(cm, ranges.slice(0, ourIndex).concat(ranges.slice(ourIndex + 1)), 0), {
                scroll: false,
                origin: "*mouse"
            });
            startSel = doc.sel;
        } else replaceOneSelection(doc, ourIndex, ourRange, sel_mouse);
        var lastPos = start;
        function extendTo(pos) {
            if (cmp(lastPos, pos) == 0) return;
            lastPos = pos;
            if (behavior.unit == "rectangle") {
                var ranges = [], tabSize = cm.options.tabSize;
                var startCol = countColumn(getLine(doc, start.line).text, start.ch, tabSize);
                var posCol = countColumn(getLine(doc, pos.line).text, pos.ch, tabSize);
                var left = Math.min(startCol, posCol), right = Math.max(startCol, posCol);
                for(var line = Math.min(start.line, pos.line), end = Math.min(cm.lastLine(), Math.max(start.line, pos.line)); line <= end; line++){
                    var text = getLine(doc, line).text, leftPos = findColumn(text, left, tabSize);
                    if (left == right) ranges.push(new Range(Pos(line, leftPos), Pos(line, leftPos)));
                    else if (text.length > leftPos) ranges.push(new Range(Pos(line, leftPos), Pos(line, findColumn(text, right, tabSize))));
                }
                if (!ranges.length) ranges.push(new Range(start, start));
                setSelection(doc, normalizeSelection(cm, startSel.ranges.slice(0, ourIndex).concat(ranges), ourIndex), {
                    origin: "*mouse",
                    scroll: false
                });
                cm.scrollIntoView(pos);
            } else {
                var oldRange = ourRange;
                var range = rangeForUnit(cm, pos, behavior.unit);
                var anchor = oldRange.anchor, head;
                if (cmp(range.anchor, anchor) > 0) {
                    head = range.head;
                    anchor = minPos(oldRange.from(), range.anchor);
                } else {
                    head = range.anchor;
                    anchor = maxPos(oldRange.to(), range.head);
                }
                var ranges$1 = startSel.ranges.slice(0);
                ranges$1[ourIndex] = bidiSimplify(cm, new Range(clipPos(doc, anchor), head));
                setSelection(doc, normalizeSelection(cm, ranges$1, ourIndex), sel_mouse);
            }
        }
        var editorSize = display.wrapper.getBoundingClientRect();
        // Used to ensure timeout re-tries don't fire when another extend
        // happened in the meantime (clearTimeout isn't reliable -- at
        // least on Chrome, the timeouts still happen even when cleared,
        // if the clear happens after their scheduled firing time).
        var counter = 0;
        function extend(e) {
            var curCount = ++counter;
            var cur = posFromMouse(cm, e, true, behavior.unit == "rectangle");
            if (!cur) return;
            if (cmp(cur, lastPos) != 0) {
                cm.curOp.focus = activeElt();
                extendTo(cur);
                var visible = visibleLines(display, doc);
                if (cur.line >= visible.to || cur.line < visible.from) setTimeout(operation(cm, function() {
                    if (counter == curCount) extend(e);
                }), 150);
            } else {
                var outside = e.clientY < editorSize.top ? -20 : e.clientY > editorSize.bottom ? 20 : 0;
                if (outside) setTimeout(operation(cm, function() {
                    if (counter != curCount) return;
                    display.scroller.scrollTop += outside;
                    extend(e);
                }), 50);
            }
        }
        function done(e) {
            cm.state.selectingText = false;
            counter = Infinity;
            // If e is null or undefined we interpret this as someone trying
            // to explicitly cancel the selection rather than the user
            // letting go of the mouse button.
            if (e) {
                e_preventDefault(e);
                display.input.focus();
            }
            off(display.wrapper.ownerDocument, "mousemove", move);
            off(display.wrapper.ownerDocument, "mouseup", up);
            doc.history.lastSelOrigin = null;
        }
        var move = operation(cm, function(e) {
            if (e.buttons === 0 || !e_button(e)) done(e);
            else extend(e);
        });
        var up = operation(cm, done);
        cm.state.selectingText = up;
        on(display.wrapper.ownerDocument, "mousemove", move);
        on(display.wrapper.ownerDocument, "mouseup", up);
    }
    // Used when mouse-selecting to adjust the anchor to the proper side
    // of a bidi jump depending on the visual position of the head.
    function bidiSimplify(cm, range) {
        var anchor = range.anchor;
        var head = range.head;
        var anchorLine = getLine(cm.doc, anchor.line);
        if (cmp(anchor, head) == 0 && anchor.sticky == head.sticky) return range;
        var order = getOrder(anchorLine);
        if (!order) return range;
        var index = getBidiPartAt(order, anchor.ch, anchor.sticky), part = order[index];
        if (part.from != anchor.ch && part.to != anchor.ch) return range;
        var boundary = index + (part.from == anchor.ch == (part.level != 1) ? 0 : 1);
        if (boundary == 0 || boundary == order.length) return range;
        // Compute the relative visual position of the head compared to the
        // anchor (<0 is to the left, >0 to the right)
        var leftSide;
        if (head.line != anchor.line) leftSide = (head.line - anchor.line) * (cm.doc.direction == "ltr" ? 1 : -1) > 0;
        else {
            var headIndex = getBidiPartAt(order, head.ch, head.sticky);
            var dir = headIndex - index || (head.ch - anchor.ch) * (part.level == 1 ? -1 : 1);
            if (headIndex == boundary - 1 || headIndex == boundary) leftSide = dir < 0;
            else leftSide = dir > 0;
        }
        var usePart = order[boundary + (leftSide ? -1 : 0)];
        var from = leftSide == (usePart.level == 1);
        var ch = from ? usePart.from : usePart.to, sticky = from ? "after" : "before";
        return anchor.ch == ch && anchor.sticky == sticky ? range : new Range(new Pos(anchor.line, ch, sticky), head);
    }
    // Determines whether an event happened in the gutter, and fires the
    // handlers for the corresponding event.
    function gutterEvent(cm, e, type, prevent) {
        var mX, mY;
        if (e.touches) {
            mX = e.touches[0].clientX;
            mY = e.touches[0].clientY;
        } else try {
            mX = e.clientX;
            mY = e.clientY;
        } catch (e$1) {
            return false;
        }
        if (mX >= Math.floor(cm.display.gutters.getBoundingClientRect().right)) return false;
        if (prevent) e_preventDefault(e);
        var display = cm.display;
        var lineBox = display.lineDiv.getBoundingClientRect();
        if (mY > lineBox.bottom || !hasHandler(cm, type)) return e_defaultPrevented(e);
        mY -= lineBox.top - display.viewOffset;
        for(var i = 0; i < cm.display.gutterSpecs.length; ++i){
            var g = display.gutters.childNodes[i];
            if (g && g.getBoundingClientRect().right >= mX) {
                var line = lineAtHeight(cm.doc, mY);
                var gutter = cm.display.gutterSpecs[i];
                signal(cm, type, cm, line, gutter.className, e);
                return e_defaultPrevented(e);
            }
        }
    }
    function clickInGutter(cm, e) {
        return gutterEvent(cm, e, "gutterClick", true);
    }
    // CONTEXT MENU HANDLING
    // To make the context menu work, we need to briefly unhide the
    // textarea (making it as unobtrusive as possible) to let the
    // right-click take effect on it.
    function onContextMenu(cm, e) {
        if (eventInWidget(cm.display, e) || contextMenuInGutter(cm, e)) return;
        if (signalDOMEvent(cm, e, "contextmenu")) return;
        if (!captureRightClick) cm.display.input.onContextMenu(e);
    }
    function contextMenuInGutter(cm, e) {
        if (!hasHandler(cm, "gutterContextMenu")) return false;
        return gutterEvent(cm, e, "gutterContextMenu", false);
    }
    function themeChanged(cm) {
        cm.display.wrapper.className = cm.display.wrapper.className.replace(/\s*cm-s-\S+/g, "") + cm.options.theme.replace(/(^|\s)\s*/g, " cm-s-");
        clearCaches(cm);
    }
    var Init = {
        toString: function() {
            return "CodeMirror.Init";
        }
    };
    var defaults = {};
    var optionHandlers = {};
    function defineOptions(CodeMirror) {
        var optionHandlers = CodeMirror.optionHandlers;
        function option(name, deflt, handle, notOnInit) {
            CodeMirror.defaults[name] = deflt;
            if (handle) optionHandlers[name] = notOnInit ? function(cm, val, old) {
                if (old != Init) handle(cm, val, old);
            } : handle;
        }
        CodeMirror.defineOption = option;
        // Passed to option handlers when there is no old value.
        CodeMirror.Init = Init;
        // These two are, on init, called from the constructor because they
        // have to be initialized before the editor can start at all.
        option("value", "", function(cm, val) {
            return cm.setValue(val);
        }, true);
        option("mode", null, function(cm, val) {
            cm.doc.modeOption = val;
            loadMode(cm);
        }, true);
        option("indentUnit", 2, loadMode, true);
        option("indentWithTabs", false);
        option("smartIndent", true);
        option("tabSize", 4, function(cm) {
            resetModeState(cm);
            clearCaches(cm);
            regChange(cm);
        }, true);
        option("lineSeparator", null, function(cm, val) {
            cm.doc.lineSep = val;
            if (!val) return;
            var newBreaks = [], lineNo = cm.doc.first;
            cm.doc.iter(function(line) {
                for(var pos = 0;;){
                    var found = line.text.indexOf(val, pos);
                    if (found == -1) break;
                    pos = found + val.length;
                    newBreaks.push(Pos(lineNo, found));
                }
                lineNo++;
            });
            for(var i = newBreaks.length - 1; i >= 0; i--)replaceRange(cm.doc, val, newBreaks[i], Pos(newBreaks[i].line, newBreaks[i].ch + val.length));
        });
        option("specialChars", /[\u0000-\u001f\u007f-\u009f\u00ad\u061c\u200b\u200e\u200f\u2028\u2029\ufeff\ufff9-\ufffc]/g, function(cm, val, old) {
            cm.state.specialChars = new RegExp(val.source + (val.test("\t") ? "" : "|\t"), "g");
            if (old != Init) cm.refresh();
        });
        option("specialCharPlaceholder", defaultSpecialCharPlaceholder, function(cm) {
            return cm.refresh();
        }, true);
        option("electricChars", true);
        option("inputStyle", mobile ? "contenteditable" : "textarea", function() {
            throw new Error("inputStyle can not (yet) be changed in a running editor") // FIXME
            ;
        }, true);
        option("spellcheck", false, function(cm, val) {
            return cm.getInputField().spellcheck = val;
        }, true);
        option("autocorrect", false, function(cm, val) {
            return cm.getInputField().autocorrect = val;
        }, true);
        option("autocapitalize", false, function(cm, val) {
            return cm.getInputField().autocapitalize = val;
        }, true);
        option("rtlMoveVisually", !windows);
        option("wholeLineUpdateBefore", true);
        option("theme", "default", function(cm) {
            themeChanged(cm);
            updateGutters(cm);
        }, true);
        option("keyMap", "default", function(cm, val, old) {
            var next = getKeyMap(val);
            var prev = old != Init && getKeyMap(old);
            if (prev && prev.detach) prev.detach(cm, next);
            if (next.attach) next.attach(cm, prev || null);
        });
        option("extraKeys", null);
        option("configureMouse", null);
        option("lineWrapping", false, wrappingChanged, true);
        option("gutters", [], function(cm, val) {
            cm.display.gutterSpecs = getGutters(val, cm.options.lineNumbers);
            updateGutters(cm);
        }, true);
        option("fixedGutter", true, function(cm, val) {
            cm.display.gutters.style.left = val ? compensateForHScroll(cm.display) + "px" : "0";
            cm.refresh();
        }, true);
        option("coverGutterNextToScrollbar", false, function(cm) {
            return updateScrollbars(cm);
        }, true);
        option("scrollbarStyle", "native", function(cm) {
            initScrollbars(cm);
            updateScrollbars(cm);
            cm.display.scrollbars.setScrollTop(cm.doc.scrollTop);
            cm.display.scrollbars.setScrollLeft(cm.doc.scrollLeft);
        }, true);
        option("lineNumbers", false, function(cm, val) {
            cm.display.gutterSpecs = getGutters(cm.options.gutters, val);
            updateGutters(cm);
        }, true);
        option("firstLineNumber", 1, updateGutters, true);
        option("lineNumberFormatter", function(integer) {
            return integer;
        }, updateGutters, true);
        option("showCursorWhenSelecting", false, updateSelection, true);
        option("resetSelectionOnContextMenu", true);
        option("lineWiseCopyCut", true);
        option("pasteLinesPerSelection", true);
        option("selectionsMayTouch", false);
        option("readOnly", false, function(cm, val) {
            if (val == "nocursor") {
                onBlur(cm);
                cm.display.input.blur();
            }
            cm.display.input.readOnlyChanged(val);
        });
        option("screenReaderLabel", null, function(cm, val) {
            val = val === '' ? null : val;
            cm.display.input.screenReaderLabelChanged(val);
        });
        option("disableInput", false, function(cm, val) {
            if (!val) cm.display.input.reset();
        }, true);
        option("dragDrop", true, dragDropChanged);
        option("allowDropFileTypes", null);
        option("cursorBlinkRate", 530);
        option("cursorScrollMargin", 0);
        option("cursorHeight", 1, updateSelection, true);
        option("singleCursorHeightPerLine", true, updateSelection, true);
        option("workTime", 100);
        option("workDelay", 100);
        option("flattenSpans", true, resetModeState, true);
        option("addModeClass", false, resetModeState, true);
        option("pollInterval", 100);
        option("undoDepth", 200, function(cm, val) {
            return cm.doc.history.undoDepth = val;
        });
        option("historyEventDelay", 1250);
        option("viewportMargin", 10, function(cm) {
            return cm.refresh();
        }, true);
        option("maxHighlightLength", 10000, resetModeState, true);
        option("moveInputWithCursor", true, function(cm, val) {
            if (!val) cm.display.input.resetPosition();
        });
        option("tabindex", null, function(cm, val) {
            return cm.display.input.getField().tabIndex = val || "";
        });
        option("autofocus", null);
        option("direction", "ltr", function(cm, val) {
            return cm.doc.setDirection(val);
        }, true);
        option("phrases", null);
    }
    function dragDropChanged(cm, value, old) {
        var wasOn = old && old != Init;
        if (!value != !wasOn) {
            var funcs = cm.display.dragFunctions;
            var toggle = value ? on : off;
            toggle(cm.display.scroller, "dragstart", funcs.start);
            toggle(cm.display.scroller, "dragenter", funcs.enter);
            toggle(cm.display.scroller, "dragover", funcs.over);
            toggle(cm.display.scroller, "dragleave", funcs.leave);
            toggle(cm.display.scroller, "drop", funcs.drop);
        }
    }
    function wrappingChanged(cm) {
        if (cm.options.lineWrapping) {
            addClass(cm.display.wrapper, "CodeMirror-wrap");
            cm.display.sizer.style.minWidth = "";
            cm.display.sizerWidth = null;
        } else {
            rmClass(cm.display.wrapper, "CodeMirror-wrap");
            findMaxLine(cm);
        }
        estimateLineHeights(cm);
        regChange(cm);
        clearCaches(cm);
        setTimeout(function() {
            return updateScrollbars(cm);
        }, 100);
    }
    // A CodeMirror instance represents an editor. This is the object
    // that user code is usually dealing with.
    function CodeMirror(place, options) {
        var this$1 = this;
        if (!(this instanceof CodeMirror)) return new CodeMirror(place, options);
        this.options = options = options ? copyObj(options) : {};
        // Determine effective options based on given values and defaults.
        copyObj(defaults, options, false);
        var doc = options.value;
        if (typeof doc == "string") doc = new Doc(doc, options.mode, null, options.lineSeparator, options.direction);
        else if (options.mode) doc.modeOption = options.mode;
        this.doc = doc;
        var input = new CodeMirror.inputStyles[options.inputStyle](this);
        var display = this.display = new Display(place, doc, input, options);
        display.wrapper.CodeMirror = this;
        themeChanged(this);
        if (options.lineWrapping) this.display.wrapper.className += " CodeMirror-wrap";
        initScrollbars(this);
        this.state = {
            keyMaps: [],
            overlays: [],
            modeGen: 0,
            overwrite: false,
            delayingBlurEvent: false,
            focused: false,
            suppressEdits: false,
            pasteIncoming: -1,
            cutIncoming: -1,
            selectingText: false,
            draggingText: false,
            highlight: new Delayed(),
            keySeq: null,
            specialChars: null
        };
        if (options.autofocus && !mobile) display.input.focus();
        // Override magic textarea content restore that IE sometimes does
        // on our hidden textarea on reload
        if (ie && ie_version < 11) setTimeout(function() {
            return this$1.display.input.reset(true);
        }, 20);
        registerEventHandlers(this);
        ensureGlobalHandlers();
        startOperation(this);
        this.curOp.forceUpdate = true;
        attachDoc(this, doc);
        if (options.autofocus && !mobile || this.hasFocus()) setTimeout(function() {
            if (this$1.hasFocus() && !this$1.state.focused) onFocus(this$1);
        }, 20);
        else onBlur(this);
        for(var opt in optionHandlers)if (optionHandlers.hasOwnProperty(opt)) optionHandlers[opt](this, options[opt], Init);
        maybeUpdateLineNumberWidth(this);
        if (options.finishInit) options.finishInit(this);
        for(var i = 0; i < initHooks.length; ++i)initHooks[i](this);
        endOperation(this);
        // Suppress optimizelegibility in Webkit, since it breaks text
        // measuring on line wrapping boundaries.
        if (webkit && options.lineWrapping && getComputedStyle(display.lineDiv).textRendering == "optimizelegibility") display.lineDiv.style.textRendering = "auto";
    }
    // The default configuration options.
    CodeMirror.defaults = defaults;
    // Functions to run when options are changed.
    CodeMirror.optionHandlers = optionHandlers;
    // Attach the necessary event handlers when initializing the editor
    function registerEventHandlers(cm) {
        var d = cm.display;
        on(d.scroller, "mousedown", operation(cm, onMouseDown));
        // Older IE's will not fire a second mousedown for a double click
        if (ie && ie_version < 11) on(d.scroller, "dblclick", operation(cm, function(e) {
            if (signalDOMEvent(cm, e)) return;
            var pos = posFromMouse(cm, e);
            if (!pos || clickInGutter(cm, e) || eventInWidget(cm.display, e)) return;
            e_preventDefault(e);
            var word = cm.findWordAt(pos);
            extendSelection(cm.doc, word.anchor, word.head);
        }));
        else on(d.scroller, "dblclick", function(e) {
            return signalDOMEvent(cm, e) || e_preventDefault(e);
        });
        // Some browsers fire contextmenu *after* opening the menu, at
        // which point we can't mess with it anymore. Context menu is
        // handled in onMouseDown for these browsers.
        on(d.scroller, "contextmenu", function(e) {
            return onContextMenu(cm, e);
        });
        on(d.input.getField(), "contextmenu", function(e) {
            if (!d.scroller.contains(e.target)) onContextMenu(cm, e);
        });
        // Used to suppress mouse event handling when a touch happens
        var touchFinished, prevTouch = {
            end: 0
        };
        function finishTouch() {
            if (d.activeTouch) {
                touchFinished = setTimeout(function() {
                    return d.activeTouch = null;
                }, 1000);
                prevTouch = d.activeTouch;
                prevTouch.end = +new Date;
            }
        }
        function isMouseLikeTouchEvent(e) {
            if (e.touches.length != 1) return false;
            var touch = e.touches[0];
            return touch.radiusX <= 1 && touch.radiusY <= 1;
        }
        function farAway(touch, other) {
            if (other.left == null) return true;
            var dx = other.left - touch.left, dy = other.top - touch.top;
            return dx * dx + dy * dy > 400;
        }
        on(d.scroller, "touchstart", function(e) {
            if (!signalDOMEvent(cm, e) && !isMouseLikeTouchEvent(e) && !clickInGutter(cm, e)) {
                d.input.ensurePolled();
                clearTimeout(touchFinished);
                var now = +new Date;
                d.activeTouch = {
                    start: now,
                    moved: false,
                    prev: now - prevTouch.end <= 300 ? prevTouch : null
                };
                if (e.touches.length == 1) {
                    d.activeTouch.left = e.touches[0].pageX;
                    d.activeTouch.top = e.touches[0].pageY;
                }
            }
        });
        on(d.scroller, "touchmove", function() {
            if (d.activeTouch) d.activeTouch.moved = true;
        });
        on(d.scroller, "touchend", function(e) {
            var touch = d.activeTouch;
            if (touch && !eventInWidget(d, e) && touch.left != null && !touch.moved && new Date - touch.start < 300) {
                var pos = cm.coordsChar(d.activeTouch, "page"), range;
                if (!touch.prev || farAway(touch, touch.prev)) range = new Range(pos, pos);
                else if (!touch.prev.prev || farAway(touch, touch.prev.prev)) range = cm.findWordAt(pos);
                else range = new Range(Pos(pos.line, 0), clipPos(cm.doc, Pos(pos.line + 1, 0)));
                cm.setSelection(range.anchor, range.head);
                cm.focus();
                e_preventDefault(e);
            }
            finishTouch();
        });
        on(d.scroller, "touchcancel", finishTouch);
        // Sync scrolling between fake scrollbars and real scrollable
        // area, ensure viewport is updated when scrolling.
        on(d.scroller, "scroll", function() {
            if (d.scroller.clientHeight) {
                updateScrollTop(cm, d.scroller.scrollTop);
                setScrollLeft(cm, d.scroller.scrollLeft, true);
                signal(cm, "scroll", cm);
            }
        });
        // Listen to wheel events in order to try and update the viewport on time.
        on(d.scroller, "mousewheel", function(e) {
            return onScrollWheel(cm, e);
        });
        on(d.scroller, "DOMMouseScroll", function(e) {
            return onScrollWheel(cm, e);
        });
        // Prevent wrapper from ever scrolling
        on(d.wrapper, "scroll", function() {
            return d.wrapper.scrollTop = d.wrapper.scrollLeft = 0;
        });
        d.dragFunctions = {
            enter: function(e) {
                if (!signalDOMEvent(cm, e)) e_stop(e);
            },
            over: function(e) {
                if (!signalDOMEvent(cm, e)) {
                    onDragOver(cm, e);
                    e_stop(e);
                }
            },
            start: function(e) {
                return onDragStart(cm, e);
            },
            drop: operation(cm, onDrop),
            leave: function(e) {
                if (!signalDOMEvent(cm, e)) clearDragCursor(cm);
            }
        };
        var inp = d.input.getField();
        on(inp, "keyup", function(e) {
            return onKeyUp.call(cm, e);
        });
        on(inp, "keydown", operation(cm, onKeyDown));
        on(inp, "keypress", operation(cm, onKeyPress));
        on(inp, "focus", function(e) {
            return onFocus(cm, e);
        });
        on(inp, "blur", function(e) {
            return onBlur(cm, e);
        });
    }
    var initHooks = [];
    CodeMirror.defineInitHook = function(f) {
        return initHooks.push(f);
    };
    // Indent the given line. The how parameter can be "smart",
    // "add"/null, "subtract", or "prev". When aggressive is false
    // (typically set to true for forced single-line indents), empty
    // lines are not indented, and places where the mode returns Pass
    // are left alone.
    function indentLine(cm, n, how, aggressive) {
        var doc = cm.doc, state;
        if (how == null) how = "add";
        if (how == "smart") {
            // Fall back to "prev" when the mode doesn't have an indentation
            // method.
            if (!doc.mode.indent) how = "prev";
            else state = getContextBefore(cm, n).state;
        }
        var tabSize = cm.options.tabSize;
        var line = getLine(doc, n), curSpace = countColumn(line.text, null, tabSize);
        if (line.stateAfter) line.stateAfter = null;
        var curSpaceString = line.text.match(/^\s*/)[0], indentation;
        if (!aggressive && !/\S/.test(line.text)) {
            indentation = 0;
            how = "not";
        } else if (how == "smart") {
            indentation = doc.mode.indent(state, line.text.slice(curSpaceString.length), line.text);
            if (indentation == Pass || indentation > 150) {
                if (!aggressive) return;
                how = "prev";
            }
        }
        if (how == "prev") {
            if (n > doc.first) indentation = countColumn(getLine(doc, n - 1).text, null, tabSize);
            else indentation = 0;
        } else if (how == "add") indentation = curSpace + cm.options.indentUnit;
        else if (how == "subtract") indentation = curSpace - cm.options.indentUnit;
        else if (typeof how == "number") indentation = curSpace + how;
        indentation = Math.max(0, indentation);
        var indentString = "", pos = 0;
        if (cm.options.indentWithTabs) for(var i = Math.floor(indentation / tabSize); i; --i){
            pos += tabSize;
            indentString += "\t";
        }
        if (pos < indentation) indentString += spaceStr(indentation - pos);
        if (indentString != curSpaceString) {
            replaceRange(doc, indentString, Pos(n, 0), Pos(n, curSpaceString.length), "+input");
            line.stateAfter = null;
            return true;
        } else // Ensure that, if the cursor was in the whitespace at the start
        // of the line, it is moved to the end of that space.
        for(var i$1 = 0; i$1 < doc.sel.ranges.length; i$1++){
            var range = doc.sel.ranges[i$1];
            if (range.head.line == n && range.head.ch < curSpaceString.length) {
                var pos$1 = Pos(n, curSpaceString.length);
                replaceOneSelection(doc, i$1, new Range(pos$1, pos$1));
                break;
            }
        }
    }
    // This will be set to a {lineWise: bool, text: [string]} object, so
    // that, when pasting, we know what kind of selections the copied
    // text was made out of.
    var lastCopied = null;
    function setLastCopied(newLastCopied) {
        lastCopied = newLastCopied;
    }
    function applyTextInput(cm, inserted, deleted, sel, origin) {
        var doc = cm.doc;
        cm.display.shift = false;
        if (!sel) sel = doc.sel;
        var recent = +new Date - 200;
        var paste = origin == "paste" || cm.state.pasteIncoming > recent;
        var textLines = splitLinesAuto(inserted), multiPaste = null;
        // When pasting N lines into N selections, insert one line per selection
        if (paste && sel.ranges.length > 1) {
            if (lastCopied && lastCopied.text.join("\n") == inserted) {
                if (sel.ranges.length % lastCopied.text.length == 0) {
                    multiPaste = [];
                    for(var i = 0; i < lastCopied.text.length; i++)multiPaste.push(doc.splitLines(lastCopied.text[i]));
                }
            } else if (textLines.length == sel.ranges.length && cm.options.pasteLinesPerSelection) multiPaste = map(textLines, function(l) {
                return [
                    l
                ];
            });
        }
        var updateInput = cm.curOp.updateInput;
        // Normal behavior is to insert the new text into every selection
        for(var i$1 = sel.ranges.length - 1; i$1 >= 0; i$1--){
            var range = sel.ranges[i$1];
            var from = range.from(), to = range.to();
            if (range.empty()) {
                if (deleted && deleted > 0) from = Pos(from.line, from.ch - deleted);
                else if (cm.state.overwrite && !paste) to = Pos(to.line, Math.min(getLine(doc, to.line).text.length, to.ch + lst(textLines).length));
                else if (paste && lastCopied && lastCopied.lineWise && lastCopied.text.join("\n") == textLines.join("\n")) from = to = Pos(from.line, 0);
            }
            var changeEvent = {
                from: from,
                to: to,
                text: multiPaste ? multiPaste[i$1 % multiPaste.length] : textLines,
                origin: origin || (paste ? "paste" : cm.state.cutIncoming > recent ? "cut" : "+input")
            };
            makeChange(cm.doc, changeEvent);
            signalLater(cm, "inputRead", cm, changeEvent);
        }
        if (inserted && !paste) triggerElectric(cm, inserted);
        ensureCursorVisible(cm);
        if (cm.curOp.updateInput < 2) cm.curOp.updateInput = updateInput;
        cm.curOp.typing = true;
        cm.state.pasteIncoming = cm.state.cutIncoming = -1;
    }
    function handlePaste(e, cm) {
        var pasted = e.clipboardData && e.clipboardData.getData("Text");
        if (pasted) {
            e.preventDefault();
            if (!cm.isReadOnly() && !cm.options.disableInput) runInOp(cm, function() {
                return applyTextInput(cm, pasted, 0, null, "paste");
            });
            return true;
        }
    }
    function triggerElectric(cm, inserted) {
        // When an 'electric' character is inserted, immediately trigger a reindent
        if (!cm.options.electricChars || !cm.options.smartIndent) return;
        var sel = cm.doc.sel;
        for(var i = sel.ranges.length - 1; i >= 0; i--){
            var range = sel.ranges[i];
            if (range.head.ch > 100 || i && sel.ranges[i - 1].head.line == range.head.line) continue;
            var mode = cm.getModeAt(range.head);
            var indented = false;
            if (mode.electricChars) {
                for(var j = 0; j < mode.electricChars.length; j++)if (inserted.indexOf(mode.electricChars.charAt(j)) > -1) {
                    indented = indentLine(cm, range.head.line, "smart");
                    break;
                }
            } else if (mode.electricInput) {
                if (mode.electricInput.test(getLine(cm.doc, range.head.line).text.slice(0, range.head.ch))) indented = indentLine(cm, range.head.line, "smart");
            }
            if (indented) signalLater(cm, "electricInput", cm, range.head.line);
        }
    }
    function copyableRanges(cm) {
        var text = [], ranges = [];
        for(var i = 0; i < cm.doc.sel.ranges.length; i++){
            var line = cm.doc.sel.ranges[i].head.line;
            var lineRange = {
                anchor: Pos(line, 0),
                head: Pos(line + 1, 0)
            };
            ranges.push(lineRange);
            text.push(cm.getRange(lineRange.anchor, lineRange.head));
        }
        return {
            text: text,
            ranges: ranges
        };
    }
    function disableBrowserMagic(field, spellcheck, autocorrect, autocapitalize) {
        field.setAttribute("autocorrect", autocorrect ? "" : "off");
        field.setAttribute("autocapitalize", autocapitalize ? "" : "off");
        field.setAttribute("spellcheck", !!spellcheck);
    }
    function hiddenTextarea() {
        var te = elt("textarea", null, null, "position: absolute; bottom: -1em; padding: 0; width: 1px; height: 1em; min-height: 1em; outline: none");
        var div = elt("div", [
            te
        ], null, "overflow: hidden; position: relative; width: 3px; height: 0px;");
        // The textarea is kept positioned near the cursor to prevent the
        // fact that it'll be scrolled into view on input from scrolling
        // our fake cursor out of view. On webkit, when wrap=off, paste is
        // very slow. So make the area wide instead.
        if (webkit) te.style.width = "1000px";
        else te.setAttribute("wrap", "off");
        // If border: 0; -- iOS fails to open keyboard (issue #1287)
        if (ios) te.style.border = "1px solid black";
        disableBrowserMagic(te);
        return div;
    }
    // The publicly visible API. Note that methodOp(f) means
    // 'wrap f in an operation, performed on its `this` parameter'.
    // This is not the complete set of editor methods. Most of the
    // methods defined on the Doc type are also injected into
    // CodeMirror.prototype, for backwards compatibility and
    // convenience.
    function addEditorMethods(CodeMirror) {
        var optionHandlers = CodeMirror.optionHandlers;
        var helpers = CodeMirror.helpers = {};
        CodeMirror.prototype = {
            constructor: CodeMirror,
            focus: function() {
                window.focus();
                this.display.input.focus();
            },
            setOption: function(option, value) {
                var options = this.options, old = options[option];
                if (options[option] == value && option != "mode") return;
                options[option] = value;
                if (optionHandlers.hasOwnProperty(option)) operation(this, optionHandlers[option])(this, value, old);
                signal(this, "optionChange", this, option);
            },
            getOption: function(option) {
                return this.options[option];
            },
            getDoc: function() {
                return this.doc;
            },
            addKeyMap: function(map, bottom) {
                this.state.keyMaps[bottom ? "push" : "unshift"](getKeyMap(map));
            },
            removeKeyMap: function(map) {
                var maps = this.state.keyMaps;
                for(var i = 0; i < maps.length; ++i)if (maps[i] == map || maps[i].name == map) {
                    maps.splice(i, 1);
                    return true;
                }
            },
            addOverlay: methodOp(function(spec, options) {
                var mode = spec.token ? spec : CodeMirror.getMode(this.options, spec);
                if (mode.startState) throw new Error("Overlays may not be stateful.");
                insertSorted(this.state.overlays, {
                    mode: mode,
                    modeSpec: spec,
                    opaque: options && options.opaque,
                    priority: options && options.priority || 0
                }, function(overlay) {
                    return overlay.priority;
                });
                this.state.modeGen++;
                regChange(this);
            }),
            removeOverlay: methodOp(function(spec) {
                var overlays = this.state.overlays;
                for(var i = 0; i < overlays.length; ++i){
                    var cur = overlays[i].modeSpec;
                    if (cur == spec || typeof spec == "string" && cur.name == spec) {
                        overlays.splice(i, 1);
                        this.state.modeGen++;
                        regChange(this);
                        return;
                    }
                }
            }),
            indentLine: methodOp(function(n, dir, aggressive) {
                if (typeof dir != "string" && typeof dir != "number") {
                    if (dir == null) dir = this.options.smartIndent ? "smart" : "prev";
                    else dir = dir ? "add" : "subtract";
                }
                if (isLine(this.doc, n)) indentLine(this, n, dir, aggressive);
            }),
            indentSelection: methodOp(function(how) {
                var ranges = this.doc.sel.ranges, end = -1;
                for(var i = 0; i < ranges.length; i++){
                    var range = ranges[i];
                    if (!range.empty()) {
                        var from = range.from(), to = range.to();
                        var start = Math.max(end, from.line);
                        end = Math.min(this.lastLine(), to.line - (to.ch ? 0 : 1)) + 1;
                        for(var j = start; j < end; ++j)indentLine(this, j, how);
                        var newRanges = this.doc.sel.ranges;
                        if (from.ch == 0 && ranges.length == newRanges.length && newRanges[i].from().ch > 0) replaceOneSelection(this.doc, i, new Range(from, newRanges[i].to()), sel_dontScroll);
                    } else if (range.head.line > end) {
                        indentLine(this, range.head.line, how, true);
                        end = range.head.line;
                        if (i == this.doc.sel.primIndex) ensureCursorVisible(this);
                    }
                }
            }),
            // Fetch the parser token for a given character. Useful for hacks
            // that want to inspect the mode state (say, for completion).
            getTokenAt: function(pos, precise) {
                return takeToken(this, pos, precise);
            },
            getLineTokens: function(line, precise) {
                return takeToken(this, Pos(line), precise, true);
            },
            getTokenTypeAt: function(pos) {
                pos = clipPos(this.doc, pos);
                var styles = getLineStyles(this, getLine(this.doc, pos.line));
                var before = 0, after = (styles.length - 1) / 2, ch = pos.ch;
                var type;
                if (ch == 0) type = styles[2];
                else for(;;){
                    var mid = before + after >> 1;
                    if ((mid ? styles[mid * 2 - 1] : 0) >= ch) after = mid;
                    else if (styles[mid * 2 + 1] < ch) before = mid + 1;
                    else {
                        type = styles[mid * 2 + 2];
                        break;
                    }
                }
                var cut = type ? type.indexOf("overlay ") : -1;
                return cut < 0 ? type : cut == 0 ? null : type.slice(0, cut - 1);
            },
            getModeAt: function(pos) {
                var mode = this.doc.mode;
                if (!mode.innerMode) return mode;
                return CodeMirror.innerMode(mode, this.getTokenAt(pos).state).mode;
            },
            getHelper: function(pos, type) {
                return this.getHelpers(pos, type)[0];
            },
            getHelpers: function(pos, type) {
                var found = [];
                if (!helpers.hasOwnProperty(type)) return found;
                var help = helpers[type], mode = this.getModeAt(pos);
                if (typeof mode[type] == "string") {
                    if (help[mode[type]]) found.push(help[mode[type]]);
                } else if (mode[type]) for(var i = 0; i < mode[type].length; i++){
                    var val = help[mode[type][i]];
                    if (val) found.push(val);
                }
                else if (mode.helperType && help[mode.helperType]) found.push(help[mode.helperType]);
                else if (help[mode.name]) found.push(help[mode.name]);
                for(var i$1 = 0; i$1 < help._global.length; i$1++){
                    var cur = help._global[i$1];
                    if (cur.pred(mode, this) && indexOf(found, cur.val) == -1) found.push(cur.val);
                }
                return found;
            },
            getStateAfter: function(line, precise) {
                var doc = this.doc;
                line = clipLine(doc, line == null ? doc.first + doc.size - 1 : line);
                return getContextBefore(this, line + 1, precise).state;
            },
            cursorCoords: function(start, mode) {
                var pos, range = this.doc.sel.primary();
                if (start == null) pos = range.head;
                else if (typeof start == "object") pos = clipPos(this.doc, start);
                else pos = start ? range.from() : range.to();
                return cursorCoords(this, pos, mode || "page");
            },
            charCoords: function(pos, mode) {
                return charCoords(this, clipPos(this.doc, pos), mode || "page");
            },
            coordsChar: function(coords, mode) {
                coords = fromCoordSystem(this, coords, mode || "page");
                return coordsChar(this, coords.left, coords.top);
            },
            lineAtHeight: function(height, mode) {
                height = fromCoordSystem(this, {
                    top: height,
                    left: 0
                }, mode || "page").top;
                return lineAtHeight(this.doc, height + this.display.viewOffset);
            },
            heightAtLine: function(line, mode, includeWidgets) {
                var end = false, lineObj;
                if (typeof line == "number") {
                    var last = this.doc.first + this.doc.size - 1;
                    if (line < this.doc.first) line = this.doc.first;
                    else if (line > last) {
                        line = last;
                        end = true;
                    }
                    lineObj = getLine(this.doc, line);
                } else lineObj = line;
                return intoCoordSystem(this, lineObj, {
                    top: 0,
                    left: 0
                }, mode || "page", includeWidgets || end).top + (end ? this.doc.height - heightAtLine(lineObj) : 0);
            },
            defaultTextHeight: function() {
                return textHeight(this.display);
            },
            defaultCharWidth: function() {
                return charWidth(this.display);
            },
            getViewport: function() {
                return {
                    from: this.display.viewFrom,
                    to: this.display.viewTo
                };
            },
            addWidget: function(pos, node, scroll, vert, horiz) {
                var display = this.display;
                pos = cursorCoords(this, clipPos(this.doc, pos));
                var top = pos.bottom, left = pos.left;
                node.style.position = "absolute";
                node.setAttribute("cm-ignore-events", "true");
                this.display.input.setUneditable(node);
                display.sizer.appendChild(node);
                if (vert == "over") top = pos.top;
                else if (vert == "above" || vert == "near") {
                    var vspace = Math.max(display.wrapper.clientHeight, this.doc.height), hspace = Math.max(display.sizer.clientWidth, display.lineSpace.clientWidth);
                    // Default to positioning above (if specified and possible); otherwise default to positioning below
                    if ((vert == 'above' || pos.bottom + node.offsetHeight > vspace) && pos.top > node.offsetHeight) top = pos.top - node.offsetHeight;
                    else if (pos.bottom + node.offsetHeight <= vspace) top = pos.bottom;
                    if (left + node.offsetWidth > hspace) left = hspace - node.offsetWidth;
                }
                node.style.top = top + "px";
                node.style.left = node.style.right = "";
                if (horiz == "right") {
                    left = display.sizer.clientWidth - node.offsetWidth;
                    node.style.right = "0px";
                } else {
                    if (horiz == "left") left = 0;
                    else if (horiz == "middle") left = (display.sizer.clientWidth - node.offsetWidth) / 2;
                    node.style.left = left + "px";
                }
                if (scroll) scrollIntoView(this, {
                    left: left,
                    top: top,
                    right: left + node.offsetWidth,
                    bottom: top + node.offsetHeight
                });
            },
            triggerOnKeyDown: methodOp(onKeyDown),
            triggerOnKeyPress: methodOp(onKeyPress),
            triggerOnKeyUp: onKeyUp,
            triggerOnMouseDown: methodOp(onMouseDown),
            execCommand: function(cmd) {
                if (commands.hasOwnProperty(cmd)) return commands[cmd].call(null, this);
            },
            triggerElectric: methodOp(function(text) {
                triggerElectric(this, text);
            }),
            findPosH: function(from, amount, unit, visually) {
                var dir = 1;
                if (amount < 0) {
                    dir = -1;
                    amount = -amount;
                }
                var cur = clipPos(this.doc, from);
                for(var i = 0; i < amount; ++i){
                    cur = findPosH(this.doc, cur, dir, unit, visually);
                    if (cur.hitSide) break;
                }
                return cur;
            },
            moveH: methodOp(function(dir, unit) {
                var this$1 = this;
                this.extendSelectionsBy(function(range) {
                    if (this$1.display.shift || this$1.doc.extend || range.empty()) return findPosH(this$1.doc, range.head, dir, unit, this$1.options.rtlMoveVisually);
                    else return dir < 0 ? range.from() : range.to();
                }, sel_move);
            }),
            deleteH: methodOp(function(dir, unit) {
                var sel = this.doc.sel, doc = this.doc;
                if (sel.somethingSelected()) doc.replaceSelection("", null, "+delete");
                else deleteNearSelection(this, function(range) {
                    var other = findPosH(doc, range.head, dir, unit, false);
                    return dir < 0 ? {
                        from: other,
                        to: range.head
                    } : {
                        from: range.head,
                        to: other
                    };
                });
            }),
            findPosV: function(from, amount, unit, goalColumn) {
                var dir = 1, x = goalColumn;
                if (amount < 0) {
                    dir = -1;
                    amount = -amount;
                }
                var cur = clipPos(this.doc, from);
                for(var i = 0; i < amount; ++i){
                    var coords = cursorCoords(this, cur, "div");
                    if (x == null) x = coords.left;
                    else coords.left = x;
                    cur = findPosV(this, coords, dir, unit);
                    if (cur.hitSide) break;
                }
                return cur;
            },
            moveV: methodOp(function(dir, unit) {
                var this$1 = this;
                var doc = this.doc, goals = [];
                var collapse = !this.display.shift && !doc.extend && doc.sel.somethingSelected();
                doc.extendSelectionsBy(function(range) {
                    if (collapse) return dir < 0 ? range.from() : range.to();
                    var headPos = cursorCoords(this$1, range.head, "div");
                    if (range.goalColumn != null) headPos.left = range.goalColumn;
                    goals.push(headPos.left);
                    var pos = findPosV(this$1, headPos, dir, unit);
                    if (unit == "page" && range == doc.sel.primary()) addToScrollTop(this$1, charCoords(this$1, pos, "div").top - headPos.top);
                    return pos;
                }, sel_move);
                if (goals.length) for(var i = 0; i < doc.sel.ranges.length; i++)doc.sel.ranges[i].goalColumn = goals[i];
            }),
            // Find the word at the given position (as returned by coordsChar).
            findWordAt: function(pos) {
                var doc = this.doc, line = getLine(doc, pos.line).text;
                var start = pos.ch, end = pos.ch;
                if (line) {
                    var helper = this.getHelper(pos, "wordChars");
                    if ((pos.sticky == "before" || end == line.length) && start) --start;
                    else ++end;
                    var startChar = line.charAt(start);
                    var check = isWordChar(startChar, helper) ? function(ch) {
                        return isWordChar(ch, helper);
                    } : /\s/.test(startChar) ? function(ch) {
                        return /\s/.test(ch);
                    } : function(ch) {
                        return !/\s/.test(ch) && !isWordChar(ch);
                    };
                    while(start > 0 && check(line.charAt(start - 1)))--start;
                    while(end < line.length && check(line.charAt(end)))++end;
                }
                return new Range(Pos(pos.line, start), Pos(pos.line, end));
            },
            toggleOverwrite: function(value) {
                if (value != null && value == this.state.overwrite) return;
                if (this.state.overwrite = !this.state.overwrite) addClass(this.display.cursorDiv, "CodeMirror-overwrite");
                else rmClass(this.display.cursorDiv, "CodeMirror-overwrite");
                signal(this, "overwriteToggle", this, this.state.overwrite);
            },
            hasFocus: function() {
                return this.display.input.getField() == activeElt();
            },
            isReadOnly: function() {
                return !!(this.options.readOnly || this.doc.cantEdit);
            },
            scrollTo: methodOp(function(x, y) {
                scrollToCoords(this, x, y);
            }),
            getScrollInfo: function() {
                var scroller = this.display.scroller;
                return {
                    left: scroller.scrollLeft,
                    top: scroller.scrollTop,
                    height: scroller.scrollHeight - scrollGap(this) - this.display.barHeight,
                    width: scroller.scrollWidth - scrollGap(this) - this.display.barWidth,
                    clientHeight: displayHeight(this),
                    clientWidth: displayWidth(this)
                };
            },
            scrollIntoView: methodOp(function(range, margin) {
                if (range == null) {
                    range = {
                        from: this.doc.sel.primary().head,
                        to: null
                    };
                    if (margin == null) margin = this.options.cursorScrollMargin;
                } else if (typeof range == "number") range = {
                    from: Pos(range, 0),
                    to: null
                };
                else if (range.from == null) range = {
                    from: range,
                    to: null
                };
                if (!range.to) range.to = range.from;
                range.margin = margin || 0;
                if (range.from.line != null) scrollToRange(this, range);
                else scrollToCoordsRange(this, range.from, range.to, range.margin);
            }),
            setSize: methodOp(function(width, height) {
                var this$1 = this;
                var interpret = function(val) {
                    return typeof val == "number" || /^\d+$/.test(String(val)) ? val + "px" : val;
                };
                if (width != null) this.display.wrapper.style.width = interpret(width);
                if (height != null) this.display.wrapper.style.height = interpret(height);
                if (this.options.lineWrapping) clearLineMeasurementCache(this);
                var lineNo = this.display.viewFrom;
                this.doc.iter(lineNo, this.display.viewTo, function(line) {
                    if (line.widgets) {
                        for(var i = 0; i < line.widgets.length; i++)if (line.widgets[i].noHScroll) {
                            regLineChange(this$1, lineNo, "widget");
                            break;
                        }
                    }
                    ++lineNo;
                });
                this.curOp.forceUpdate = true;
                signal(this, "refresh", this);
            }),
            operation: function(f) {
                return runInOp(this, f);
            },
            startOperation: function() {
                return startOperation(this);
            },
            endOperation: function() {
                return endOperation(this);
            },
            refresh: methodOp(function() {
                var oldHeight = this.display.cachedTextHeight;
                regChange(this);
                this.curOp.forceUpdate = true;
                clearCaches(this);
                scrollToCoords(this, this.doc.scrollLeft, this.doc.scrollTop);
                updateGutterSpace(this.display);
                if (oldHeight == null || Math.abs(oldHeight - textHeight(this.display)) > .5 || this.options.lineWrapping) estimateLineHeights(this);
                signal(this, "refresh", this);
            }),
            swapDoc: methodOp(function(doc) {
                var old = this.doc;
                old.cm = null;
                // Cancel the current text selection if any (#5821)
                if (this.state.selectingText) this.state.selectingText();
                attachDoc(this, doc);
                clearCaches(this);
                this.display.input.reset();
                scrollToCoords(this, doc.scrollLeft, doc.scrollTop);
                this.curOp.forceScroll = true;
                signalLater(this, "swapDoc", this, old);
                return old;
            }),
            phrase: function(phraseText) {
                var phrases = this.options.phrases;
                return phrases && Object.prototype.hasOwnProperty.call(phrases, phraseText) ? phrases[phraseText] : phraseText;
            },
            getInputField: function() {
                return this.display.input.getField();
            },
            getWrapperElement: function() {
                return this.display.wrapper;
            },
            getScrollerElement: function() {
                return this.display.scroller;
            },
            getGutterElement: function() {
                return this.display.gutters;
            }
        };
        eventMixin(CodeMirror);
        CodeMirror.registerHelper = function(type, name, value) {
            if (!helpers.hasOwnProperty(type)) helpers[type] = CodeMirror[type] = {
                _global: []
            };
            helpers[type][name] = value;
        };
        CodeMirror.registerGlobalHelper = function(type, name, predicate, value) {
            CodeMirror.registerHelper(type, name, value);
            helpers[type]._global.push({
                pred: predicate,
                val: value
            });
        };
    }
    // Used for horizontal relative motion. Dir is -1 or 1 (left or
    // right), unit can be "codepoint", "char", "column" (like char, but
    // doesn't cross line boundaries), "word" (across next word), or
    // "group" (to the start of next group of word or
    // non-word-non-whitespace chars). The visually param controls
    // whether, in right-to-left text, direction 1 means to move towards
    // the next index in the string, or towards the character to the right
    // of the current position. The resulting position will have a
    // hitSide=true property if it reached the end of the document.
    function findPosH(doc, pos, dir, unit, visually) {
        var oldPos = pos;
        var origDir = dir;
        var lineObj = getLine(doc, pos.line);
        var lineDir = visually && doc.direction == "rtl" ? -dir : dir;
        function findNextLine() {
            var l = pos.line + lineDir;
            if (l < doc.first || l >= doc.first + doc.size) return false;
            pos = new Pos(l, pos.ch, pos.sticky);
            return lineObj = getLine(doc, l);
        }
        function moveOnce(boundToLine) {
            var next;
            if (unit == "codepoint") {
                var ch = lineObj.text.charCodeAt(pos.ch + (dir > 0 ? 0 : -1));
                if (isNaN(ch)) next = null;
                else {
                    var astral = dir > 0 ? ch >= 0xD800 && ch < 0xDC00 : ch >= 0xDC00 && ch < 0xDFFF;
                    next = new Pos(pos.line, Math.max(0, Math.min(lineObj.text.length, pos.ch + dir * (astral ? 2 : 1))), -dir);
                }
            } else if (visually) next = moveVisually(doc.cm, lineObj, pos, dir);
            else next = moveLogically(lineObj, pos, dir);
            if (next == null) {
                if (!boundToLine && findNextLine()) pos = endOfLine(visually, doc.cm, lineObj, pos.line, lineDir);
                else return false;
            } else pos = next;
            return true;
        }
        if (unit == "char" || unit == "codepoint") moveOnce();
        else if (unit == "column") moveOnce(true);
        else if (unit == "word" || unit == "group") {
            var sawType = null, group = unit == "group";
            var helper = doc.cm && doc.cm.getHelper(pos, "wordChars");
            for(var first = true;; first = false){
                if (dir < 0 && !moveOnce(!first)) break;
                var cur = lineObj.text.charAt(pos.ch) || "\n";
                var type = isWordChar(cur, helper) ? "w" : group && cur == "\n" ? "n" : !group || /\s/.test(cur) ? null : "p";
                if (group && !first && !type) type = "s";
                if (sawType && sawType != type) {
                    if (dir < 0) {
                        dir = 1;
                        moveOnce();
                        pos.sticky = "after";
                    }
                    break;
                }
                if (type) sawType = type;
                if (dir > 0 && !moveOnce(!first)) break;
            }
        }
        var result = skipAtomic(doc, pos, oldPos, origDir, true);
        if (equalCursorPos(oldPos, result)) result.hitSide = true;
        return result;
    }
    // For relative vertical movement. Dir may be -1 or 1. Unit can be
    // "page" or "line". The resulting position will have a hitSide=true
    // property if it reached the end of the document.
    function findPosV(cm, pos, dir, unit) {
        var doc = cm.doc, x = pos.left, y;
        if (unit == "page") {
            var pageSize = Math.min(cm.display.wrapper.clientHeight, window.innerHeight || document.documentElement.clientHeight);
            var moveAmount = Math.max(pageSize - .5 * textHeight(cm.display), 3);
            y = (dir > 0 ? pos.bottom : pos.top) + dir * moveAmount;
        } else if (unit == "line") y = dir > 0 ? pos.bottom + 3 : pos.top - 3;
        var target;
        for(;;){
            target = coordsChar(cm, x, y);
            if (!target.outside) break;
            if (dir < 0 ? y <= 0 : y >= doc.height) {
                target.hitSide = true;
                break;
            }
            y += dir * 5;
        }
        return target;
    }
    // CONTENTEDITABLE INPUT STYLE
    var ContentEditableInput = function(cm) {
        this.cm = cm;
        this.lastAnchorNode = this.lastAnchorOffset = this.lastFocusNode = this.lastFocusOffset = null;
        this.polling = new Delayed();
        this.composing = null;
        this.gracePeriod = false;
        this.readDOMTimeout = null;
    };
    ContentEditableInput.prototype.init = function(display) {
        var this$1 = this;
        var input = this, cm = input.cm;
        var div = input.div = display.lineDiv;
        div.contentEditable = true;
        disableBrowserMagic(div, cm.options.spellcheck, cm.options.autocorrect, cm.options.autocapitalize);
        function belongsToInput(e) {
            for(var t = e.target; t; t = t.parentNode){
                if (t == div) return true;
                if (/\bCodeMirror-(?:line)?widget\b/.test(t.className)) break;
            }
            return false;
        }
        on(div, "paste", function(e) {
            if (!belongsToInput(e) || signalDOMEvent(cm, e) || handlePaste(e, cm)) return;
            // IE doesn't fire input events, so we schedule a read for the pasted content in this way
            if (ie_version <= 11) setTimeout(operation(cm, function() {
                return this$1.updateFromDOM();
            }), 20);
        });
        on(div, "compositionstart", function(e) {
            this$1.composing = {
                data: e.data,
                done: false
            };
        });
        on(div, "compositionupdate", function(e) {
            if (!this$1.composing) this$1.composing = {
                data: e.data,
                done: false
            };
        });
        on(div, "compositionend", function(e) {
            if (this$1.composing) {
                if (e.data != this$1.composing.data) this$1.readFromDOMSoon();
                this$1.composing.done = true;
            }
        });
        on(div, "touchstart", function() {
            return input.forceCompositionEnd();
        });
        on(div, "input", function() {
            if (!this$1.composing) this$1.readFromDOMSoon();
        });
        function onCopyCut(e) {
            if (!belongsToInput(e) || signalDOMEvent(cm, e)) return;
            if (cm.somethingSelected()) {
                setLastCopied({
                    lineWise: false,
                    text: cm.getSelections()
                });
                if (e.type == "cut") cm.replaceSelection("", null, "cut");
            } else if (!cm.options.lineWiseCopyCut) return;
            else {
                var ranges = copyableRanges(cm);
                setLastCopied({
                    lineWise: true,
                    text: ranges.text
                });
                if (e.type == "cut") cm.operation(function() {
                    cm.setSelections(ranges.ranges, 0, sel_dontScroll);
                    cm.replaceSelection("", null, "cut");
                });
            }
            if (e.clipboardData) {
                e.clipboardData.clearData();
                var content = lastCopied.text.join("\n");
                // iOS exposes the clipboard API, but seems to discard content inserted into it
                e.clipboardData.setData("Text", content);
                if (e.clipboardData.getData("Text") == content) {
                    e.preventDefault();
                    return;
                }
            }
            // Old-fashioned briefly-focus-a-textarea hack
            var kludge = hiddenTextarea(), te = kludge.firstChild;
            cm.display.lineSpace.insertBefore(kludge, cm.display.lineSpace.firstChild);
            te.value = lastCopied.text.join("\n");
            var hadFocus = activeElt();
            selectInput(te);
            setTimeout(function() {
                cm.display.lineSpace.removeChild(kludge);
                hadFocus.focus();
                if (hadFocus == div) input.showPrimarySelection();
            }, 50);
        }
        on(div, "copy", onCopyCut);
        on(div, "cut", onCopyCut);
    };
    ContentEditableInput.prototype.screenReaderLabelChanged = function(label) {
        // Label for screenreaders, accessibility
        if (label) this.div.setAttribute('aria-label', label);
        else this.div.removeAttribute('aria-label');
    };
    ContentEditableInput.prototype.prepareSelection = function() {
        var result = prepareSelection(this.cm, false);
        result.focus = activeElt() == this.div;
        return result;
    };
    ContentEditableInput.prototype.showSelection = function(info, takeFocus) {
        if (!info || !this.cm.display.view.length) return;
        if (info.focus || takeFocus) this.showPrimarySelection();
        this.showMultipleSelections(info);
    };
    ContentEditableInput.prototype.getSelection = function() {
        return this.cm.display.wrapper.ownerDocument.getSelection();
    };
    ContentEditableInput.prototype.showPrimarySelection = function() {
        var sel = this.getSelection(), cm = this.cm, prim = cm.doc.sel.primary();
        var from = prim.from(), to = prim.to();
        if (cm.display.viewTo == cm.display.viewFrom || from.line >= cm.display.viewTo || to.line < cm.display.viewFrom) {
            sel.removeAllRanges();
            return;
        }
        var curAnchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
        var curFocus = domToPos(cm, sel.focusNode, sel.focusOffset);
        if (curAnchor && !curAnchor.bad && curFocus && !curFocus.bad && cmp(minPos(curAnchor, curFocus), from) == 0 && cmp(maxPos(curAnchor, curFocus), to) == 0) return;
        var view = cm.display.view;
        var start = from.line >= cm.display.viewFrom && posToDOM(cm, from) || {
            node: view[0].measure.map[2],
            offset: 0
        };
        var end = to.line < cm.display.viewTo && posToDOM(cm, to);
        if (!end) {
            var measure = view[view.length - 1].measure;
            var map = measure.maps ? measure.maps[measure.maps.length - 1] : measure.map;
            end = {
                node: map[map.length - 1],
                offset: map[map.length - 2] - map[map.length - 3]
            };
        }
        if (!start || !end) {
            sel.removeAllRanges();
            return;
        }
        var old = sel.rangeCount && sel.getRangeAt(0), rng;
        try {
            rng = range(start.node, start.offset, end.offset, end.node);
        } catch (e) {} // Our model of the DOM might be outdated, in which case the range we try to set can be impossible
        if (rng) {
            if (!gecko && cm.state.focused) {
                sel.collapse(start.node, start.offset);
                if (!rng.collapsed) {
                    sel.removeAllRanges();
                    sel.addRange(rng);
                }
            } else {
                sel.removeAllRanges();
                sel.addRange(rng);
            }
            if (old && sel.anchorNode == null) sel.addRange(old);
            else if (gecko) this.startGracePeriod();
        }
        this.rememberSelection();
    };
    ContentEditableInput.prototype.startGracePeriod = function() {
        var this$1 = this;
        clearTimeout(this.gracePeriod);
        this.gracePeriod = setTimeout(function() {
            this$1.gracePeriod = false;
            if (this$1.selectionChanged()) this$1.cm.operation(function() {
                return this$1.cm.curOp.selectionChanged = true;
            });
        }, 20);
    };
    ContentEditableInput.prototype.showMultipleSelections = function(info) {
        removeChildrenAndAdd(this.cm.display.cursorDiv, info.cursors);
        removeChildrenAndAdd(this.cm.display.selectionDiv, info.selection);
    };
    ContentEditableInput.prototype.rememberSelection = function() {
        var sel = this.getSelection();
        this.lastAnchorNode = sel.anchorNode;
        this.lastAnchorOffset = sel.anchorOffset;
        this.lastFocusNode = sel.focusNode;
        this.lastFocusOffset = sel.focusOffset;
    };
    ContentEditableInput.prototype.selectionInEditor = function() {
        var sel = this.getSelection();
        if (!sel.rangeCount) return false;
        var node = sel.getRangeAt(0).commonAncestorContainer;
        return contains(this.div, node);
    };
    ContentEditableInput.prototype.focus = function() {
        if (this.cm.options.readOnly != "nocursor") {
            if (!this.selectionInEditor() || activeElt() != this.div) this.showSelection(this.prepareSelection(), true);
            this.div.focus();
        }
    };
    ContentEditableInput.prototype.blur = function() {
        this.div.blur();
    };
    ContentEditableInput.prototype.getField = function() {
        return this.div;
    };
    ContentEditableInput.prototype.supportsTouch = function() {
        return true;
    };
    ContentEditableInput.prototype.receivedFocus = function() {
        var this$1 = this;
        var input = this;
        if (this.selectionInEditor()) setTimeout(function() {
            return this$1.pollSelection();
        }, 20);
        else runInOp(this.cm, function() {
            return input.cm.curOp.selectionChanged = true;
        });
        function poll() {
            if (input.cm.state.focused) {
                input.pollSelection();
                input.polling.set(input.cm.options.pollInterval, poll);
            }
        }
        this.polling.set(this.cm.options.pollInterval, poll);
    };
    ContentEditableInput.prototype.selectionChanged = function() {
        var sel = this.getSelection();
        return sel.anchorNode != this.lastAnchorNode || sel.anchorOffset != this.lastAnchorOffset || sel.focusNode != this.lastFocusNode || sel.focusOffset != this.lastFocusOffset;
    };
    ContentEditableInput.prototype.pollSelection = function() {
        if (this.readDOMTimeout != null || this.gracePeriod || !this.selectionChanged()) return;
        var sel = this.getSelection(), cm = this.cm;
        // On Android Chrome (version 56, at least), backspacing into an
        // uneditable block element will put the cursor in that element,
        // and then, because it's not editable, hide the virtual keyboard.
        // Because Android doesn't allow us to actually detect backspace
        // presses in a sane way, this code checks for when that happens
        // and simulates a backspace press in this case.
        if (android && chrome && this.cm.display.gutterSpecs.length && isInGutter(sel.anchorNode)) {
            this.cm.triggerOnKeyDown({
                type: "keydown",
                keyCode: 8,
                preventDefault: Math.abs
            });
            this.blur();
            this.focus();
            return;
        }
        if (this.composing) return;
        this.rememberSelection();
        var anchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
        var head = domToPos(cm, sel.focusNode, sel.focusOffset);
        if (anchor && head) runInOp(cm, function() {
            setSelection(cm.doc, simpleSelection(anchor, head), sel_dontScroll);
            if (anchor.bad || head.bad) cm.curOp.selectionChanged = true;
        });
    };
    ContentEditableInput.prototype.pollContent = function() {
        if (this.readDOMTimeout != null) {
            clearTimeout(this.readDOMTimeout);
            this.readDOMTimeout = null;
        }
        var cm = this.cm, display = cm.display, sel = cm.doc.sel.primary();
        var from = sel.from(), to = sel.to();
        if (from.ch == 0 && from.line > cm.firstLine()) from = Pos(from.line - 1, getLine(cm.doc, from.line - 1).length);
        if (to.ch == getLine(cm.doc, to.line).text.length && to.line < cm.lastLine()) to = Pos(to.line + 1, 0);
        if (from.line < display.viewFrom || to.line > display.viewTo - 1) return false;
        var fromIndex, fromLine, fromNode;
        if (from.line == display.viewFrom || (fromIndex = findViewIndex(cm, from.line)) == 0) {
            fromLine = lineNo(display.view[0].line);
            fromNode = display.view[0].node;
        } else {
            fromLine = lineNo(display.view[fromIndex].line);
            fromNode = display.view[fromIndex - 1].node.nextSibling;
        }
        var toIndex = findViewIndex(cm, to.line);
        var toLine, toNode;
        if (toIndex == display.view.length - 1) {
            toLine = display.viewTo - 1;
            toNode = display.lineDiv.lastChild;
        } else {
            toLine = lineNo(display.view[toIndex + 1].line) - 1;
            toNode = display.view[toIndex + 1].node.previousSibling;
        }
        if (!fromNode) return false;
        var newText = cm.doc.splitLines(domTextBetween(cm, fromNode, toNode, fromLine, toLine));
        var oldText = getBetween(cm.doc, Pos(fromLine, 0), Pos(toLine, getLine(cm.doc, toLine).text.length));
        while(newText.length > 1 && oldText.length > 1){
            if (lst(newText) == lst(oldText)) {
                newText.pop();
                oldText.pop();
                toLine--;
            } else if (newText[0] == oldText[0]) {
                newText.shift();
                oldText.shift();
                fromLine++;
            } else break;
        }
        var cutFront = 0, cutEnd = 0;
        var newTop = newText[0], oldTop = oldText[0], maxCutFront = Math.min(newTop.length, oldTop.length);
        while(cutFront < maxCutFront && newTop.charCodeAt(cutFront) == oldTop.charCodeAt(cutFront))++cutFront;
        var newBot = lst(newText), oldBot = lst(oldText);
        var maxCutEnd = Math.min(newBot.length - (newText.length == 1 ? cutFront : 0), oldBot.length - (oldText.length == 1 ? cutFront : 0));
        while(cutEnd < maxCutEnd && newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1))++cutEnd;
        // Try to move start of change to start of selection if ambiguous
        if (newText.length == 1 && oldText.length == 1 && fromLine == from.line) while(cutFront && cutFront > from.ch && newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1)){
            cutFront--;
            cutEnd++;
        }
        newText[newText.length - 1] = newBot.slice(0, newBot.length - cutEnd).replace(/^\u200b+/, "");
        newText[0] = newText[0].slice(cutFront).replace(/\u200b+$/, "");
        var chFrom = Pos(fromLine, cutFront);
        var chTo = Pos(toLine, oldText.length ? lst(oldText).length - cutEnd : 0);
        if (newText.length > 1 || newText[0] || cmp(chFrom, chTo)) {
            replaceRange(cm.doc, newText, chFrom, chTo, "+input");
            return true;
        }
    };
    ContentEditableInput.prototype.ensurePolled = function() {
        this.forceCompositionEnd();
    };
    ContentEditableInput.prototype.reset = function() {
        this.forceCompositionEnd();
    };
    ContentEditableInput.prototype.forceCompositionEnd = function() {
        if (!this.composing) return;
        clearTimeout(this.readDOMTimeout);
        this.composing = null;
        this.updateFromDOM();
        this.div.blur();
        this.div.focus();
    };
    ContentEditableInput.prototype.readFromDOMSoon = function() {
        var this$1 = this;
        if (this.readDOMTimeout != null) return;
        this.readDOMTimeout = setTimeout(function() {
            this$1.readDOMTimeout = null;
            if (this$1.composing) {
                if (this$1.composing.done) this$1.composing = null;
                else return;
            }
            this$1.updateFromDOM();
        }, 80);
    };
    ContentEditableInput.prototype.updateFromDOM = function() {
        var this$1 = this;
        if (this.cm.isReadOnly() || !this.pollContent()) runInOp(this.cm, function() {
            return regChange(this$1.cm);
        });
    };
    ContentEditableInput.prototype.setUneditable = function(node) {
        node.contentEditable = "false";
    };
    ContentEditableInput.prototype.onKeyPress = function(e) {
        if (e.charCode == 0 || this.composing) return;
        e.preventDefault();
        if (!this.cm.isReadOnly()) operation(this.cm, applyTextInput)(this.cm, String.fromCharCode(e.charCode == null ? e.keyCode : e.charCode), 0);
    };
    ContentEditableInput.prototype.readOnlyChanged = function(val) {
        this.div.contentEditable = String(val != "nocursor");
    };
    ContentEditableInput.prototype.onContextMenu = function() {};
    ContentEditableInput.prototype.resetPosition = function() {};
    ContentEditableInput.prototype.needsContentAttribute = true;
    function posToDOM(cm, pos) {
        var view = findViewForLine(cm, pos.line);
        if (!view || view.hidden) return null;
        var line = getLine(cm.doc, pos.line);
        var info = mapFromLineView(view, line, pos.line);
        var order = getOrder(line, cm.doc.direction), side = "left";
        if (order) {
            var partPos = getBidiPartAt(order, pos.ch);
            side = partPos % 2 ? "right" : "left";
        }
        var result = nodeAndOffsetInLineMap(info.map, pos.ch, side);
        result.offset = result.collapse == "right" ? result.end : result.start;
        return result;
    }
    function isInGutter(node) {
        for(var scan = node; scan; scan = scan.parentNode){
            if (/CodeMirror-gutter-wrapper/.test(scan.className)) return true;
        }
        return false;
    }
    function badPos(pos, bad) {
        if (bad) pos.bad = true;
        return pos;
    }
    function domTextBetween(cm, from, to, fromLine, toLine) {
        var text = "", closing = false, lineSep = cm.doc.lineSeparator(), extraLinebreak = false;
        function recognizeMarker(id) {
            return function(marker) {
                return marker.id == id;
            };
        }
        function close() {
            if (closing) {
                text += lineSep;
                if (extraLinebreak) text += lineSep;
                closing = extraLinebreak = false;
            }
        }
        function addText(str) {
            if (str) {
                close();
                text += str;
            }
        }
        function walk(node) {
            if (node.nodeType == 1) {
                var cmText = node.getAttribute("cm-text");
                if (cmText) {
                    addText(cmText);
                    return;
                }
                var markerID = node.getAttribute("cm-marker"), range;
                if (markerID) {
                    var found = cm.findMarks(Pos(fromLine, 0), Pos(toLine + 1, 0), recognizeMarker(+markerID));
                    if (found.length && (range = found[0].find(0))) addText(getBetween(cm.doc, range.from, range.to).join(lineSep));
                    return;
                }
                if (node.getAttribute("contenteditable") == "false") return;
                var isBlock = /^(pre|div|p|li|table|br)$/i.test(node.nodeName);
                if (!/^br$/i.test(node.nodeName) && node.textContent.length == 0) return;
                if (isBlock) close();
                for(var i = 0; i < node.childNodes.length; i++)walk(node.childNodes[i]);
                if (/^(pre|p)$/i.test(node.nodeName)) extraLinebreak = true;
                if (isBlock) closing = true;
            } else if (node.nodeType == 3) addText(node.nodeValue.replace(/\u200b/g, "").replace(/\u00a0/g, " "));
        }
        for(;;){
            walk(from);
            if (from == to) break;
            from = from.nextSibling;
            extraLinebreak = false;
        }
        return text;
    }
    function domToPos(cm, node, offset) {
        var lineNode;
        if (node == cm.display.lineDiv) {
            lineNode = cm.display.lineDiv.childNodes[offset];
            if (!lineNode) return badPos(cm.clipPos(Pos(cm.display.viewTo - 1)), true);
            node = null;
            offset = 0;
        } else for(lineNode = node;; lineNode = lineNode.parentNode){
            if (!lineNode || lineNode == cm.display.lineDiv) return null;
            if (lineNode.parentNode && lineNode.parentNode == cm.display.lineDiv) break;
        }
        for(var i = 0; i < cm.display.view.length; i++){
            var lineView = cm.display.view[i];
            if (lineView.node == lineNode) return locateNodeInLineView(lineView, node, offset);
        }
    }
    function locateNodeInLineView(lineView, node, offset) {
        var wrapper = lineView.text.firstChild, bad = false;
        if (!node || !contains(wrapper, node)) return badPos(Pos(lineNo(lineView.line), 0), true);
        if (node == wrapper) {
            bad = true;
            node = wrapper.childNodes[offset];
            offset = 0;
            if (!node) {
                var line = lineView.rest ? lst(lineView.rest) : lineView.line;
                return badPos(Pos(lineNo(line), line.text.length), bad);
            }
        }
        var textNode = node.nodeType == 3 ? node : null, topNode = node;
        if (!textNode && node.childNodes.length == 1 && node.firstChild.nodeType == 3) {
            textNode = node.firstChild;
            if (offset) offset = textNode.nodeValue.length;
        }
        while(topNode.parentNode != wrapper)topNode = topNode.parentNode;
        var measure = lineView.measure, maps = measure.maps;
        function find(textNode, topNode, offset) {
            for(var i = -1; i < (maps ? maps.length : 0); i++){
                var map = i < 0 ? measure.map : maps[i];
                for(var j = 0; j < map.length; j += 3){
                    var curNode = map[j + 2];
                    if (curNode == textNode || curNode == topNode) {
                        var line = lineNo(i < 0 ? lineView.line : lineView.rest[i]);
                        var ch = map[j] + offset;
                        if (offset < 0 || curNode != textNode) ch = map[j + (offset ? 1 : 0)];
                        return Pos(line, ch);
                    }
                }
            }
        }
        var found = find(textNode, topNode, offset);
        if (found) return badPos(found, bad);
        // FIXME this is all really shaky. might handle the few cases it needs to handle, but likely to cause problems
        for(var after = topNode.nextSibling, dist = textNode ? textNode.nodeValue.length - offset : 0; after; after = after.nextSibling){
            found = find(after, after.firstChild, 0);
            if (found) return badPos(Pos(found.line, found.ch - dist), bad);
            else dist += after.textContent.length;
        }
        for(var before = topNode.previousSibling, dist$1 = offset; before; before = before.previousSibling){
            found = find(before, before.firstChild, -1);
            if (found) return badPos(Pos(found.line, found.ch + dist$1), bad);
            else dist$1 += before.textContent.length;
        }
    }
    // TEXTAREA INPUT STYLE
    var TextareaInput = function(cm) {
        this.cm = cm;
        // See input.poll and input.reset
        this.prevInput = "";
        // Flag that indicates whether we expect input to appear real soon
        // now (after some event like 'keypress' or 'input') and are
        // polling intensively.
        this.pollingFast = false;
        // Self-resetting timeout for the poller
        this.polling = new Delayed();
        // Used to work around IE issue with selection being forgotten when focus moves away from textarea
        this.hasSelection = false;
        this.composing = null;
    };
    TextareaInput.prototype.init = function(display) {
        var this$1 = this;
        var input = this, cm = this.cm;
        this.createField(display);
        var te = this.textarea;
        display.wrapper.insertBefore(this.wrapper, display.wrapper.firstChild);
        // Needed to hide big blue blinking cursor on Mobile Safari (doesn't seem to work in iOS 8 anymore)
        if (ios) te.style.width = "0px";
        on(te, "input", function() {
            if (ie && ie_version >= 9 && this$1.hasSelection) this$1.hasSelection = null;
            input.poll();
        });
        on(te, "paste", function(e) {
            if (signalDOMEvent(cm, e) || handlePaste(e, cm)) return;
            cm.state.pasteIncoming = +new Date;
            input.fastPoll();
        });
        function prepareCopyCut(e) {
            if (signalDOMEvent(cm, e)) return;
            if (cm.somethingSelected()) setLastCopied({
                lineWise: false,
                text: cm.getSelections()
            });
            else if (!cm.options.lineWiseCopyCut) return;
            else {
                var ranges = copyableRanges(cm);
                setLastCopied({
                    lineWise: true,
                    text: ranges.text
                });
                if (e.type == "cut") cm.setSelections(ranges.ranges, null, sel_dontScroll);
                else {
                    input.prevInput = "";
                    te.value = ranges.text.join("\n");
                    selectInput(te);
                }
            }
            if (e.type == "cut") cm.state.cutIncoming = +new Date;
        }
        on(te, "cut", prepareCopyCut);
        on(te, "copy", prepareCopyCut);
        on(display.scroller, "paste", function(e) {
            if (eventInWidget(display, e) || signalDOMEvent(cm, e)) return;
            if (!te.dispatchEvent) {
                cm.state.pasteIncoming = +new Date;
                input.focus();
                return;
            }
            // Pass the `paste` event to the textarea so it's handled by its event listener.
            var event = new Event("paste");
            event.clipboardData = e.clipboardData;
            te.dispatchEvent(event);
        });
        // Prevent normal selection in the editor (we handle our own)
        on(display.lineSpace, "selectstart", function(e) {
            if (!eventInWidget(display, e)) e_preventDefault(e);
        });
        on(te, "compositionstart", function() {
            var start = cm.getCursor("from");
            if (input.composing) input.composing.range.clear();
            input.composing = {
                start: start,
                range: cm.markText(start, cm.getCursor("to"), {
                    className: "CodeMirror-composing"
                })
            };
        });
        on(te, "compositionend", function() {
            if (input.composing) {
                input.poll();
                input.composing.range.clear();
                input.composing = null;
            }
        });
    };
    TextareaInput.prototype.createField = function(_display) {
        // Wraps and hides input textarea
        this.wrapper = hiddenTextarea();
        // The semihidden textarea that is focused when the editor is
        // focused, and receives input.
        this.textarea = this.wrapper.firstChild;
    };
    TextareaInput.prototype.screenReaderLabelChanged = function(label) {
        // Label for screenreaders, accessibility
        if (label) this.textarea.setAttribute('aria-label', label);
        else this.textarea.removeAttribute('aria-label');
    };
    TextareaInput.prototype.prepareSelection = function() {
        // Redraw the selection and/or cursor
        var cm = this.cm, display = cm.display, doc = cm.doc;
        var result = prepareSelection(cm);
        // Move the hidden textarea near the cursor to prevent scrolling artifacts
        if (cm.options.moveInputWithCursor) {
            var headPos = cursorCoords(cm, doc.sel.primary().head, "div");
            var wrapOff = display.wrapper.getBoundingClientRect(), lineOff = display.lineDiv.getBoundingClientRect();
            result.teTop = Math.max(0, Math.min(display.wrapper.clientHeight - 10, headPos.top + lineOff.top - wrapOff.top));
            result.teLeft = Math.max(0, Math.min(display.wrapper.clientWidth - 10, headPos.left + lineOff.left - wrapOff.left));
        }
        return result;
    };
    TextareaInput.prototype.showSelection = function(drawn) {
        var cm = this.cm, display = cm.display;
        removeChildrenAndAdd(display.cursorDiv, drawn.cursors);
        removeChildrenAndAdd(display.selectionDiv, drawn.selection);
        if (drawn.teTop != null) {
            this.wrapper.style.top = drawn.teTop + "px";
            this.wrapper.style.left = drawn.teLeft + "px";
        }
    };
    // Reset the input to correspond to the selection (or to be empty,
    // when not typing and nothing is selected)
    TextareaInput.prototype.reset = function(typing) {
        if (this.contextMenuPending || this.composing) return;
        var cm = this.cm;
        if (cm.somethingSelected()) {
            this.prevInput = "";
            var content = cm.getSelection();
            this.textarea.value = content;
            if (cm.state.focused) selectInput(this.textarea);
            if (ie && ie_version >= 9) this.hasSelection = content;
        } else if (!typing) {
            this.prevInput = this.textarea.value = "";
            if (ie && ie_version >= 9) this.hasSelection = null;
        }
    };
    TextareaInput.prototype.getField = function() {
        return this.textarea;
    };
    TextareaInput.prototype.supportsTouch = function() {
        return false;
    };
    TextareaInput.prototype.focus = function() {
        if (this.cm.options.readOnly != "nocursor" && (!mobile || activeElt() != this.textarea)) try {
            this.textarea.focus();
        } catch (e) {} // IE8 will throw if the textarea is display: none or not in DOM
    };
    TextareaInput.prototype.blur = function() {
        this.textarea.blur();
    };
    TextareaInput.prototype.resetPosition = function() {
        this.wrapper.style.top = this.wrapper.style.left = 0;
    };
    TextareaInput.prototype.receivedFocus = function() {
        this.slowPoll();
    };
    // Poll for input changes, using the normal rate of polling. This
    // runs as long as the editor is focused.
    TextareaInput.prototype.slowPoll = function() {
        var this$1 = this;
        if (this.pollingFast) return;
        this.polling.set(this.cm.options.pollInterval, function() {
            this$1.poll();
            if (this$1.cm.state.focused) this$1.slowPoll();
        });
    };
    // When an event has just come in that is likely to add or change
    // something in the input textarea, we poll faster, to ensure that
    // the change appears on the screen quickly.
    TextareaInput.prototype.fastPoll = function() {
        var missed = false, input = this;
        input.pollingFast = true;
        function p() {
            var changed = input.poll();
            if (!changed && !missed) {
                missed = true;
                input.polling.set(60, p);
            } else {
                input.pollingFast = false;
                input.slowPoll();
            }
        }
        input.polling.set(20, p);
    };
    // Read input from the textarea, and update the document to match.
    // When something is selected, it is present in the textarea, and
    // selected (unless it is huge, in which case a placeholder is
    // used). When nothing is selected, the cursor sits after previously
    // seen text (can be empty), which is stored in prevInput (we must
    // not reset the textarea when typing, because that breaks IME).
    TextareaInput.prototype.poll = function() {
        var this$1 = this;
        var cm = this.cm, input = this.textarea, prevInput = this.prevInput;
        // Since this is called a *lot*, try to bail out as cheaply as
        // possible when it is clear that nothing happened. hasSelection
        // will be the case when there is a lot of text in the textarea,
        // in which case reading its value would be expensive.
        if (this.contextMenuPending || !cm.state.focused || hasSelection(input) && !prevInput && !this.composing || cm.isReadOnly() || cm.options.disableInput || cm.state.keySeq) return false;
        var text = input.value;
        // If nothing changed, bail.
        if (text == prevInput && !cm.somethingSelected()) return false;
        // Work around nonsensical selection resetting in IE9/10, and
        // inexplicable appearance of private area unicode characters on
        // some key combos in Mac (#2689).
        if (ie && ie_version >= 9 && this.hasSelection === text || mac && /[\uf700-\uf7ff]/.test(text)) {
            cm.display.input.reset();
            return false;
        }
        if (cm.doc.sel == cm.display.selForContextMenu) {
            var first = text.charCodeAt(0);
            if (first == 0x200b && !prevInput) prevInput = "\u200b";
            if (first == 0x21da) {
                this.reset();
                return this.cm.execCommand("undo");
            }
        }
        // Find the part of the input that is actually new
        var same = 0, l = Math.min(prevInput.length, text.length);
        while(same < l && prevInput.charCodeAt(same) == text.charCodeAt(same))++same;
        runInOp(cm, function() {
            applyTextInput(cm, text.slice(same), prevInput.length - same, null, this$1.composing ? "*compose" : null);
            // Don't leave long text in the textarea, since it makes further polling slow
            if (text.length > 1000 || text.indexOf("\n") > -1) input.value = this$1.prevInput = "";
            else this$1.prevInput = text;
            if (this$1.composing) {
                this$1.composing.range.clear();
                this$1.composing.range = cm.markText(this$1.composing.start, cm.getCursor("to"), {
                    className: "CodeMirror-composing"
                });
            }
        });
        return true;
    };
    TextareaInput.prototype.ensurePolled = function() {
        if (this.pollingFast && this.poll()) this.pollingFast = false;
    };
    TextareaInput.prototype.onKeyPress = function() {
        if (ie && ie_version >= 9) this.hasSelection = null;
        this.fastPoll();
    };
    TextareaInput.prototype.onContextMenu = function(e) {
        var input = this, cm = input.cm, display = cm.display, te = input.textarea;
        if (input.contextMenuPending) input.contextMenuPending();
        var pos = posFromMouse(cm, e), scrollPos = display.scroller.scrollTop;
        if (!pos || presto) return;
         // Opera is difficult.
        // Reset the current text selection only if the click is done outside of the selection
        // and 'resetSelectionOnContextMenu' option is true.
        var reset = cm.options.resetSelectionOnContextMenu;
        if (reset && cm.doc.sel.contains(pos) == -1) operation(cm, setSelection)(cm.doc, simpleSelection(pos), sel_dontScroll);
        var oldCSS = te.style.cssText, oldWrapperCSS = input.wrapper.style.cssText;
        var wrapperBox = input.wrapper.offsetParent.getBoundingClientRect();
        input.wrapper.style.cssText = "position: static";
        te.style.cssText = "position: absolute; width: 30px; height: 30px;\n      top: " + (e.clientY - wrapperBox.top - 5) + "px; left: " + (e.clientX - wrapperBox.left - 5) + "px;\n      z-index: 1000; background: " + (ie ? "rgba(255, 255, 255, .05)" : "transparent") + ";\n      outline: none; border-width: 0; outline: none; overflow: hidden; opacity: .05; filter: alpha(opacity=5);";
        var oldScrollY;
        if (webkit) oldScrollY = window.scrollY;
         // Work around Chrome issue (#2712)
        display.input.focus();
        if (webkit) window.scrollTo(null, oldScrollY);
        display.input.reset();
        // Adds "Select all" to context menu in FF
        if (!cm.somethingSelected()) te.value = input.prevInput = " ";
        input.contextMenuPending = rehide;
        display.selForContextMenu = cm.doc.sel;
        clearTimeout(display.detectingSelectAll);
        // Select-all will be greyed out if there's nothing to select, so
        // this adds a zero-width space so that we can later check whether
        // it got selected.
        function prepareSelectAllHack() {
            if (te.selectionStart != null) {
                var selected = cm.somethingSelected();
                var extval = "\u200b" + (selected ? te.value : "");
                te.value = "\u21da"; // Used to catch context-menu undo
                te.value = extval;
                input.prevInput = selected ? "" : "\u200b";
                te.selectionStart = 1;
                te.selectionEnd = extval.length;
                // Re-set this, in case some other handler touched the
                // selection in the meantime.
                display.selForContextMenu = cm.doc.sel;
            }
        }
        function rehide() {
            if (input.contextMenuPending != rehide) return;
            input.contextMenuPending = false;
            input.wrapper.style.cssText = oldWrapperCSS;
            te.style.cssText = oldCSS;
            if (ie && ie_version < 9) display.scrollbars.setScrollTop(display.scroller.scrollTop = scrollPos);
            // Try to detect the user choosing select-all
            if (te.selectionStart != null) {
                if (!ie || ie && ie_version < 9) prepareSelectAllHack();
                var i = 0, poll = function() {
                    if (display.selForContextMenu == cm.doc.sel && te.selectionStart == 0 && te.selectionEnd > 0 && input.prevInput == "\u200b") operation(cm, selectAll)(cm);
                    else if (i++ < 10) display.detectingSelectAll = setTimeout(poll, 500);
                    else {
                        display.selForContextMenu = null;
                        display.input.reset();
                    }
                };
                display.detectingSelectAll = setTimeout(poll, 200);
            }
        }
        if (ie && ie_version >= 9) prepareSelectAllHack();
        if (captureRightClick) {
            e_stop(e);
            var mouseup = function() {
                off(window, "mouseup", mouseup);
                setTimeout(rehide, 20);
            };
            on(window, "mouseup", mouseup);
        } else setTimeout(rehide, 50);
    };
    TextareaInput.prototype.readOnlyChanged = function(val) {
        if (!val) this.reset();
        this.textarea.disabled = val == "nocursor";
        this.textarea.readOnly = !!val;
    };
    TextareaInput.prototype.setUneditable = function() {};
    TextareaInput.prototype.needsContentAttribute = false;
    function fromTextArea(textarea, options) {
        options = options ? copyObj(options) : {};
        options.value = textarea.value;
        if (!options.tabindex && textarea.tabIndex) options.tabindex = textarea.tabIndex;
        if (!options.placeholder && textarea.placeholder) options.placeholder = textarea.placeholder;
        // Set autofocus to true if this textarea is focused, or if it has
        // autofocus and no other element is focused.
        if (options.autofocus == null) {
            var hasFocus = activeElt();
            options.autofocus = hasFocus == textarea || textarea.getAttribute("autofocus") != null && hasFocus == document.body;
        }
        function save() {
            textarea.value = cm.getValue();
        }
        var realSubmit;
        if (textarea.form) {
            on(textarea.form, "submit", save);
            // Deplorable hack to make the submit method do the right thing.
            if (!options.leaveSubmitMethodAlone) {
                var form = textarea.form;
                realSubmit = form.submit;
                try {
                    var wrappedSubmit = form.submit = function() {
                        save();
                        form.submit = realSubmit;
                        form.submit();
                        form.submit = wrappedSubmit;
                    };
                } catch (e) {}
            }
        }
        options.finishInit = function(cm) {
            cm.save = save;
            cm.getTextArea = function() {
                return textarea;
            };
            cm.toTextArea = function() {
                cm.toTextArea = isNaN; // Prevent this from being ran twice
                save();
                textarea.parentNode.removeChild(cm.getWrapperElement());
                textarea.style.display = "";
                if (textarea.form) {
                    off(textarea.form, "submit", save);
                    if (!options.leaveSubmitMethodAlone && typeof textarea.form.submit == "function") textarea.form.submit = realSubmit;
                }
            };
        };
        textarea.style.display = "none";
        var cm = CodeMirror(function(node) {
            return textarea.parentNode.insertBefore(node, textarea.nextSibling);
        }, options);
        return cm;
    }
    function addLegacyProps(CodeMirror) {
        CodeMirror.off = off;
        CodeMirror.on = on;
        CodeMirror.wheelEventPixels = wheelEventPixels;
        CodeMirror.Doc = Doc;
        CodeMirror.splitLines = splitLinesAuto;
        CodeMirror.countColumn = countColumn;
        CodeMirror.findColumn = findColumn;
        CodeMirror.isWordChar = isWordCharBasic;
        CodeMirror.Pass = Pass;
        CodeMirror.signal = signal;
        CodeMirror.Line = Line;
        CodeMirror.changeEnd = changeEnd;
        CodeMirror.scrollbarModel = scrollbarModel;
        CodeMirror.Pos = Pos;
        CodeMirror.cmpPos = cmp;
        CodeMirror.modes = modes;
        CodeMirror.mimeModes = mimeModes;
        CodeMirror.resolveMode = resolveMode;
        CodeMirror.getMode = getMode;
        CodeMirror.modeExtensions = modeExtensions;
        CodeMirror.extendMode = extendMode;
        CodeMirror.copyState = copyState;
        CodeMirror.startState = startState;
        CodeMirror.innerMode = innerMode;
        CodeMirror.commands = commands;
        CodeMirror.keyMap = keyMap;
        CodeMirror.keyName = keyName;
        CodeMirror.isModifierKey = isModifierKey;
        CodeMirror.lookupKey = lookupKey;
        CodeMirror.normalizeKeyMap = normalizeKeyMap;
        CodeMirror.StringStream = StringStream;
        CodeMirror.SharedTextMarker = SharedTextMarker;
        CodeMirror.TextMarker = TextMarker;
        CodeMirror.LineWidget = LineWidget;
        CodeMirror.e_preventDefault = e_preventDefault;
        CodeMirror.e_stopPropagation = e_stopPropagation;
        CodeMirror.e_stop = e_stop;
        CodeMirror.addClass = addClass;
        CodeMirror.contains = contains;
        CodeMirror.rmClass = rmClass;
        CodeMirror.keyNames = keyNames;
    }
    // EDITOR CONSTRUCTOR
    defineOptions(CodeMirror);
    addEditorMethods(CodeMirror);
    // Set up methods on CodeMirror's prototype to redirect to the editor's document.
    var dontDelegate = "iter insert remove copy getEditor constructor".split(" ");
    for(var prop in Doc.prototype)if (Doc.prototype.hasOwnProperty(prop) && indexOf(dontDelegate, prop) < 0) CodeMirror.prototype[prop] = function(method) {
        return function() {
            return method.apply(this.doc, arguments);
        };
    }(Doc.prototype[prop]);
    eventMixin(Doc);
    CodeMirror.inputStyles = {
        "textarea": TextareaInput,
        "contenteditable": ContentEditableInput
    };
    // Extra arguments are stored as the mode's dependencies, which is
    // used by (legacy) mechanisms like loadmode.js to automatically
    // load a mode. (Preferred mechanism is the require/define calls.)
    CodeMirror.defineMode = function(name /*, mode, …*/ ) {
        if (!CodeMirror.defaults.mode && name != "null") CodeMirror.defaults.mode = name;
        defineMode.apply(this, arguments);
    };
    CodeMirror.defineMIME = defineMIME;
    // Minimal default mode.
    CodeMirror.defineMode("null", function() {
        return {
            token: function(stream) {
                return stream.skipToEnd();
            }
        };
    });
    CodeMirror.defineMIME("text/plain", "null");
    // EXTENSIONS
    CodeMirror.defineExtension = function(name, func) {
        CodeMirror.prototype[name] = func;
    };
    CodeMirror.defineDocExtension = function(name, func) {
        Doc.prototype[name] = func;
    };
    CodeMirror.fromTextArea = fromTextArea;
    addLegacyProps(CodeMirror);
    CodeMirror.version = "5.65.2";
    return CodeMirror;
});

});

parcelRegister("8G5JO", function(module, exports) {
"use strict";

var $9HcUm = parcelRequire("9HcUm");
var $6516b26dad4ca52e$var$clipboardToIE11Formatting = {
    "text/plain": "Text",
    "text/html": "Url",
    "default": "Text"
};
var $6516b26dad4ca52e$var$defaultMessage = "Copy to clipboard: #{key}, Enter";
function $6516b26dad4ca52e$var$format(message) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? "\u2318" : "Ctrl") + "+C";
    return message.replace(/#{\s*key\s*}/g, copyKey);
}
function $6516b26dad4ca52e$var$copy(text, options) {
    var debug, message, reselectPrevious, range, selection, mark, success = false;
    if (!options) options = {};
    debug = options.debug || false;
    try {
        reselectPrevious = $9HcUm();
        range = document.createRange();
        selection = document.getSelection();
        mark = document.createElement("span");
        mark.textContent = text;
        // reset user styles for span element
        mark.style.all = "unset";
        // prevents scrolling to the end of the page
        mark.style.position = "fixed";
        mark.style.top = 0;
        mark.style.clip = "rect(0, 0, 0, 0)";
        // used to preserve spaces and line breaks
        mark.style.whiteSpace = "pre";
        // do not inherit user-select (it may be `none`)
        mark.style.webkitUserSelect = "text";
        mark.style.MozUserSelect = "text";
        mark.style.msUserSelect = "text";
        mark.style.userSelect = "text";
        mark.addEventListener("copy", function(e) {
            e.stopPropagation();
            if (options.format) {
                e.preventDefault();
                if (typeof e.clipboardData === "undefined") {
                    debug && console.warn("unable to use e.clipboardData");
                    debug && console.warn("trying IE specific stuff");
                    window.clipboardData.clearData();
                    var format = $6516b26dad4ca52e$var$clipboardToIE11Formatting[options.format] || $6516b26dad4ca52e$var$clipboardToIE11Formatting["default"];
                    window.clipboardData.setData(format, text);
                } else {
                    e.clipboardData.clearData();
                    e.clipboardData.setData(options.format, text);
                }
            }
            if (options.onCopy) {
                e.preventDefault();
                options.onCopy(e.clipboardData);
            }
        });
        document.body.appendChild(mark);
        range.selectNodeContents(mark);
        selection.addRange(range);
        var successful = document.execCommand("copy");
        if (!successful) throw new Error("copy command was unsuccessful");
        success = true;
    } catch (err) {
        debug && console.error("unable to copy using execCommand: ", err);
        debug && console.warn("trying IE specific stuff");
        try {
            window.clipboardData.setData(options.format || "text", text);
            options.onCopy && options.onCopy(window.clipboardData);
            success = true;
        } catch (err) {
            debug && console.error("unable to copy using clipboardData: ", err);
            debug && console.error("falling back to prompt");
            message = $6516b26dad4ca52e$var$format("message" in options ? options.message : $6516b26dad4ca52e$var$defaultMessage);
            window.prompt(message, text);
        }
    } finally{
        if (selection) {
            if (typeof selection.removeRange == "function") selection.removeRange(range);
            else selection.removeAllRanges();
        }
        if (mark) document.body.removeChild(mark);
        reselectPrevious();
    }
    return success;
}
module.exports = $6516b26dad4ca52e$var$copy;

});
parcelRegister("9HcUm", function(module, exports) {
module.exports = function() {
    var selection = document.getSelection();
    if (!selection.rangeCount) return function() {};
    var active = document.activeElement;
    var ranges = [];
    for(var i = 0; i < selection.rangeCount; i++)ranges.push(selection.getRangeAt(i));
    switch(active.tagName.toUpperCase()){
        case 'INPUT':
        case 'TEXTAREA':
            active.blur();
            break;
        default:
            active = null;
            break;
    }
    selection.removeAllRanges();
    return function() {
        selection.type === 'Caret' && selection.removeAllRanges();
        if (!selection.rangeCount) ranges.forEach(function(range) {
            selection.addRange(range);
        });
        active && active.focus();
    };
};

});


parcelRegister("dPK2y", function(module, exports) {

$parcel$export(module.exports, "Color", function () { return Color; });
$parcel$export(module.exports, "darker", function () { return darker; });
$parcel$export(module.exports, "brighter", function () { return brighter; });
$parcel$export(module.exports, "default", function () { return color; });
$parcel$export(module.exports, "hslConvert", function () { return hslConvert; });
$parcel$export(module.exports, "Rgb", function () { return Rgb; });
$parcel$export(module.exports, "rgbConvert", function () { return rgbConvert; });
$parcel$export(module.exports, "rgb", function () { return rgb; });
$parcel$export(module.exports, "hsl", function () { return hsl; });

var $4RiRw = parcelRequire("4RiRw");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $4RiRw.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $4RiRw.default)(Rgb, rgb, (0, $4RiRw.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $4RiRw.default)(Hsl, hsl, (0, $4RiRw.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("4RiRw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $389abe4a3628f470$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "extend", function () { return $389abe4a3628f470$export$8b58be045bf06082; });
function $389abe4a3628f470$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $389abe4a3628f470$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


var $b1985252e6c9e225$exports = {};
$parcel$extendImportMap({
    "9OtVK": "worker.0959f341.js"
});

"use strict";
var $fc815ff806253b78$exports = {};
'use strict';

var $1YuiL = parcelRequire("1YuiL");

var $lRu3m = parcelRequire("lRu3m");

var $gvOoh = parcelRequire("gvOoh");

var $eqgBB = parcelRequire("eqgBB");

var $2D2fi = parcelRequire("2D2fi");

var $86Fx8 = parcelRequire("86Fx8");
var $3cfbeed0b06b5bdc$require$META = $86Fx8.KEY;

var $bjnTD = parcelRequire("bjnTD");

var $6ODIt = parcelRequire("6ODIt");

var $k40lc = parcelRequire("k40lc");

var $ln3yM = parcelRequire("ln3yM");

var $buDDQ = parcelRequire("buDDQ");

var $cTJIb = parcelRequire("cTJIb");

var $b5vfc = parcelRequire("b5vfc");
var $66d8875a9a00fc0f$exports = {};
// all enumerable object keys, includes symbols

var $eYXZv = parcelRequire("eYXZv");

var $5S6VU = parcelRequire("5S6VU");

var $il6o7 = parcelRequire("il6o7");
$66d8875a9a00fc0f$exports = function(it) {
    var result = $eYXZv(it);
    var getSymbols = $5S6VU.f;
    if (getSymbols) {
        var symbols = getSymbols(it);
        var isEnum = $il6o7.f;
        var i = 0;
        var key;
        while(symbols.length > i)if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
    return result;
};



var $6HMRV = parcelRequire("6HMRV");

var $6K5GG = parcelRequire("6K5GG");

var $h9IVq = parcelRequire("h9IVq");

var $j50QJ = parcelRequire("j50QJ");

var $15QDc = parcelRequire("15QDc");

var $9a73R = parcelRequire("9a73R");

var $8tLmk = parcelRequire("8tLmk");

var $16E7l = parcelRequire("16E7l");

var $1uBcr = parcelRequire("1uBcr");

var $5yOh2 = parcelRequire("5yOh2");

var $5S6VU = parcelRequire("5S6VU");

var $lWhMZ = parcelRequire("lWhMZ");

var $eYXZv = parcelRequire("eYXZv");
var $3cfbeed0b06b5bdc$var$gOPD = $5yOh2.f;
var $3cfbeed0b06b5bdc$var$dP = $lWhMZ.f;
var $3cfbeed0b06b5bdc$var$gOPN = $1uBcr.f;
var $3cfbeed0b06b5bdc$var$$Symbol = $1YuiL.Symbol;
var $3cfbeed0b06b5bdc$var$$JSON = $1YuiL.JSON;
var $3cfbeed0b06b5bdc$var$_stringify = $3cfbeed0b06b5bdc$var$$JSON && $3cfbeed0b06b5bdc$var$$JSON.stringify;
var $3cfbeed0b06b5bdc$var$PROTOTYPE = 'prototype';
var $3cfbeed0b06b5bdc$var$HIDDEN = $buDDQ('_hidden');
var $3cfbeed0b06b5bdc$var$TO_PRIMITIVE = $buDDQ('toPrimitive');
var $3cfbeed0b06b5bdc$var$isEnum = {}.propertyIsEnumerable;
var $3cfbeed0b06b5bdc$var$SymbolRegistry = $6ODIt('symbol-registry');
var $3cfbeed0b06b5bdc$var$AllSymbols = $6ODIt('symbols');
var $3cfbeed0b06b5bdc$var$OPSymbols = $6ODIt('op-symbols');
var $3cfbeed0b06b5bdc$var$ObjectProto = Object[$3cfbeed0b06b5bdc$var$PROTOTYPE];
var $3cfbeed0b06b5bdc$var$USE_NATIVE = typeof $3cfbeed0b06b5bdc$var$$Symbol == 'function' && !!$5S6VU.f;
var $3cfbeed0b06b5bdc$var$QObject = $1YuiL.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var $3cfbeed0b06b5bdc$var$setter = !$3cfbeed0b06b5bdc$var$QObject || !$3cfbeed0b06b5bdc$var$QObject[$3cfbeed0b06b5bdc$var$PROTOTYPE] || !$3cfbeed0b06b5bdc$var$QObject[$3cfbeed0b06b5bdc$var$PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var $3cfbeed0b06b5bdc$var$setSymbolDesc = $gvOoh && $bjnTD(function() {
    return $16E7l($3cfbeed0b06b5bdc$var$dP({}, 'a', {
        get: function() {
            return $3cfbeed0b06b5bdc$var$dP(this, 'a', {
                value: 7
            }).a;
        }
    })).a != 7;
}) ? function(it, key, D) {
    var protoDesc = $3cfbeed0b06b5bdc$var$gOPD($3cfbeed0b06b5bdc$var$ObjectProto, key);
    if (protoDesc) delete $3cfbeed0b06b5bdc$var$ObjectProto[key];
    $3cfbeed0b06b5bdc$var$dP(it, key, D);
    if (protoDesc && it !== $3cfbeed0b06b5bdc$var$ObjectProto) $3cfbeed0b06b5bdc$var$dP($3cfbeed0b06b5bdc$var$ObjectProto, key, protoDesc);
} : $3cfbeed0b06b5bdc$var$dP;
var $3cfbeed0b06b5bdc$var$wrap = function(tag) {
    var sym = $3cfbeed0b06b5bdc$var$AllSymbols[tag] = $16E7l($3cfbeed0b06b5bdc$var$$Symbol[$3cfbeed0b06b5bdc$var$PROTOTYPE]);
    sym._k = tag;
    return sym;
};
var $3cfbeed0b06b5bdc$var$isSymbol = $3cfbeed0b06b5bdc$var$USE_NATIVE && typeof $3cfbeed0b06b5bdc$var$$Symbol.iterator == 'symbol' ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    return it instanceof $3cfbeed0b06b5bdc$var$$Symbol;
};
var $3cfbeed0b06b5bdc$var$$defineProperty = function defineProperty(it, key, D) {
    if (it === $3cfbeed0b06b5bdc$var$ObjectProto) $3cfbeed0b06b5bdc$var$$defineProperty($3cfbeed0b06b5bdc$var$OPSymbols, key, D);
    $6K5GG(it);
    key = $9a73R(key, true);
    $6K5GG(D);
    if ($lRu3m($3cfbeed0b06b5bdc$var$AllSymbols, key)) {
        if (!D.enumerable) {
            if (!$lRu3m(it, $3cfbeed0b06b5bdc$var$HIDDEN)) $3cfbeed0b06b5bdc$var$dP(it, $3cfbeed0b06b5bdc$var$HIDDEN, $8tLmk(1, {}));
            it[$3cfbeed0b06b5bdc$var$HIDDEN][key] = true;
        } else {
            if ($lRu3m(it, $3cfbeed0b06b5bdc$var$HIDDEN) && it[$3cfbeed0b06b5bdc$var$HIDDEN][key]) it[$3cfbeed0b06b5bdc$var$HIDDEN][key] = false;
            D = $16E7l(D, {
                enumerable: $8tLmk(0, false)
            });
        }
        return $3cfbeed0b06b5bdc$var$setSymbolDesc(it, key, D);
    }
    return $3cfbeed0b06b5bdc$var$dP(it, key, D);
};
var $3cfbeed0b06b5bdc$var$$defineProperties = function defineProperties(it, P) {
    $6K5GG(it);
    var keys = $66d8875a9a00fc0f$exports(P = $15QDc(P));
    var i = 0;
    var l = keys.length;
    var key;
    while(l > i)$3cfbeed0b06b5bdc$var$$defineProperty(it, key = keys[i++], P[key]);
    return it;
};
var $3cfbeed0b06b5bdc$var$$create = function create(it, P) {
    return P === undefined ? $16E7l(it) : $3cfbeed0b06b5bdc$var$$defineProperties($16E7l(it), P);
};
var $3cfbeed0b06b5bdc$var$$propertyIsEnumerable = function propertyIsEnumerable(key) {
    var E = $3cfbeed0b06b5bdc$var$isEnum.call(this, key = $9a73R(key, true));
    if (this === $3cfbeed0b06b5bdc$var$ObjectProto && $lRu3m($3cfbeed0b06b5bdc$var$AllSymbols, key) && !$lRu3m($3cfbeed0b06b5bdc$var$OPSymbols, key)) return false;
    return E || !$lRu3m(this, key) || !$lRu3m($3cfbeed0b06b5bdc$var$AllSymbols, key) || $lRu3m(this, $3cfbeed0b06b5bdc$var$HIDDEN) && this[$3cfbeed0b06b5bdc$var$HIDDEN][key] ? E : true;
};
var $3cfbeed0b06b5bdc$var$$getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
    it = $15QDc(it);
    key = $9a73R(key, true);
    if (it === $3cfbeed0b06b5bdc$var$ObjectProto && $lRu3m($3cfbeed0b06b5bdc$var$AllSymbols, key) && !$lRu3m($3cfbeed0b06b5bdc$var$OPSymbols, key)) return;
    var D = $3cfbeed0b06b5bdc$var$gOPD(it, key);
    if (D && $lRu3m($3cfbeed0b06b5bdc$var$AllSymbols, key) && !($lRu3m(it, $3cfbeed0b06b5bdc$var$HIDDEN) && it[$3cfbeed0b06b5bdc$var$HIDDEN][key])) D.enumerable = true;
    return D;
};
var $3cfbeed0b06b5bdc$var$$getOwnPropertyNames = function getOwnPropertyNames(it) {
    var names = $3cfbeed0b06b5bdc$var$gOPN($15QDc(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if (!$lRu3m($3cfbeed0b06b5bdc$var$AllSymbols, key = names[i++]) && key != $3cfbeed0b06b5bdc$var$HIDDEN && key != $3cfbeed0b06b5bdc$require$META) result.push(key);
    return result;
};
var $3cfbeed0b06b5bdc$var$$getOwnPropertySymbols = function getOwnPropertySymbols(it) {
    var IS_OP = it === $3cfbeed0b06b5bdc$var$ObjectProto;
    var names = $3cfbeed0b06b5bdc$var$gOPN(IS_OP ? $3cfbeed0b06b5bdc$var$OPSymbols : $15QDc(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if ($lRu3m($3cfbeed0b06b5bdc$var$AllSymbols, key = names[i++]) && (IS_OP ? $lRu3m($3cfbeed0b06b5bdc$var$ObjectProto, key) : true)) result.push($3cfbeed0b06b5bdc$var$AllSymbols[key]);
    return result;
};



// 19.4.1.1 Symbol([description])
if (!$3cfbeed0b06b5bdc$var$USE_NATIVE) {
    $3cfbeed0b06b5bdc$var$$Symbol = function Symbol() {
        if (this instanceof $3cfbeed0b06b5bdc$var$$Symbol) throw TypeError('Symbol is not a constructor!');
        var tag = $ln3yM(arguments.length > 0 ? arguments[0] : undefined);
        var $set = function(value) {
            if (this === $3cfbeed0b06b5bdc$var$ObjectProto) $set.call($3cfbeed0b06b5bdc$var$OPSymbols, value);
            if ($lRu3m(this, $3cfbeed0b06b5bdc$var$HIDDEN) && $lRu3m(this[$3cfbeed0b06b5bdc$var$HIDDEN], tag)) this[$3cfbeed0b06b5bdc$var$HIDDEN][tag] = false;
            $3cfbeed0b06b5bdc$var$setSymbolDesc(this, tag, $8tLmk(1, value));
        };
        if ($gvOoh && $3cfbeed0b06b5bdc$var$setter) $3cfbeed0b06b5bdc$var$setSymbolDesc($3cfbeed0b06b5bdc$var$ObjectProto, tag, {
            configurable: true,
            set: $set
        });
        return $3cfbeed0b06b5bdc$var$wrap(tag);
    };
    $2D2fi($3cfbeed0b06b5bdc$var$$Symbol[$3cfbeed0b06b5bdc$var$PROTOTYPE], 'toString', function toString() {
        return this._k;
    });
    $5yOh2.f = $3cfbeed0b06b5bdc$var$$getOwnPropertyDescriptor;
    $lWhMZ.f = $3cfbeed0b06b5bdc$var$$defineProperty;
    (parcelRequire("ivFzP")).f = $1uBcr.f = $3cfbeed0b06b5bdc$var$$getOwnPropertyNames;
    (parcelRequire("il6o7")).f = $3cfbeed0b06b5bdc$var$$propertyIsEnumerable;
    $5S6VU.f = $3cfbeed0b06b5bdc$var$$getOwnPropertySymbols;
    if ($gvOoh && !(parcelRequire("aNvO0"))) $2D2fi($3cfbeed0b06b5bdc$var$ObjectProto, 'propertyIsEnumerable', $3cfbeed0b06b5bdc$var$$propertyIsEnumerable, true);
    $cTJIb.f = function(name) {
        return $3cfbeed0b06b5bdc$var$wrap($buDDQ(name));
    };
}
$eqgBB($eqgBB.G + $eqgBB.W + $eqgBB.F * !$3cfbeed0b06b5bdc$var$USE_NATIVE, {
    Symbol: $3cfbeed0b06b5bdc$var$$Symbol
});
for(var $3cfbeed0b06b5bdc$var$es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), $3cfbeed0b06b5bdc$var$j = 0; $3cfbeed0b06b5bdc$var$es6Symbols.length > $3cfbeed0b06b5bdc$var$j;)$buDDQ($3cfbeed0b06b5bdc$var$es6Symbols[$3cfbeed0b06b5bdc$var$j++]);
for(var $3cfbeed0b06b5bdc$var$wellKnownSymbols = $eYXZv($buDDQ.store), $3cfbeed0b06b5bdc$var$k = 0; $3cfbeed0b06b5bdc$var$wellKnownSymbols.length > $3cfbeed0b06b5bdc$var$k;)$b5vfc($3cfbeed0b06b5bdc$var$wellKnownSymbols[$3cfbeed0b06b5bdc$var$k++]);
$eqgBB($eqgBB.S + $eqgBB.F * !$3cfbeed0b06b5bdc$var$USE_NATIVE, 'Symbol', {
    // 19.4.2.1 Symbol.for(key)
    'for': function(key) {
        return $lRu3m($3cfbeed0b06b5bdc$var$SymbolRegistry, key += '') ? $3cfbeed0b06b5bdc$var$SymbolRegistry[key] : $3cfbeed0b06b5bdc$var$SymbolRegistry[key] = $3cfbeed0b06b5bdc$var$$Symbol(key);
    },
    // 19.4.2.5 Symbol.keyFor(sym)
    keyFor: function keyFor(sym) {
        if (!$3cfbeed0b06b5bdc$var$isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
        for(var key in $3cfbeed0b06b5bdc$var$SymbolRegistry)if ($3cfbeed0b06b5bdc$var$SymbolRegistry[key] === sym) return key;
    },
    useSetter: function() {
        $3cfbeed0b06b5bdc$var$setter = true;
    },
    useSimple: function() {
        $3cfbeed0b06b5bdc$var$setter = false;
    }
});
$eqgBB($eqgBB.S + $eqgBB.F * !$3cfbeed0b06b5bdc$var$USE_NATIVE, 'Object', {
    // 19.1.2.2 Object.create(O [, Properties])
    create: $3cfbeed0b06b5bdc$var$$create,
    // 19.1.2.4 Object.defineProperty(O, P, Attributes)
    defineProperty: $3cfbeed0b06b5bdc$var$$defineProperty,
    // 19.1.2.3 Object.defineProperties(O, Properties)
    defineProperties: $3cfbeed0b06b5bdc$var$$defineProperties,
    // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
    getOwnPropertyDescriptor: $3cfbeed0b06b5bdc$var$$getOwnPropertyDescriptor,
    // 19.1.2.7 Object.getOwnPropertyNames(O)
    getOwnPropertyNames: $3cfbeed0b06b5bdc$var$$getOwnPropertyNames,
    // 19.1.2.8 Object.getOwnPropertySymbols(O)
    getOwnPropertySymbols: $3cfbeed0b06b5bdc$var$$getOwnPropertySymbols
});
// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var $3cfbeed0b06b5bdc$var$FAILS_ON_PRIMITIVES = $bjnTD(function() {
    $5S6VU.f(1);
});
$eqgBB($eqgBB.S + $eqgBB.F * $3cfbeed0b06b5bdc$var$FAILS_ON_PRIMITIVES, 'Object', {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        return $5S6VU.f($j50QJ(it));
    }
});
// 24.3.2 JSON.stringify(value [, replacer [, space]])
$3cfbeed0b06b5bdc$var$$JSON && $eqgBB($eqgBB.S + $eqgBB.F * (!$3cfbeed0b06b5bdc$var$USE_NATIVE || $bjnTD(function() {
    var S = $3cfbeed0b06b5bdc$var$$Symbol();
    // MS Edge converts symbol values to JSON as {}
    // WebKit converts symbol values to JSON as null
    // V8 throws on boxed symbols
    return $3cfbeed0b06b5bdc$var$_stringify([
        S
    ]) != '[null]' || $3cfbeed0b06b5bdc$var$_stringify({
        a: S
    }) != '{}' || $3cfbeed0b06b5bdc$var$_stringify(Object(S)) != '{}';
})), 'JSON', {
    stringify: function stringify(it) {
        var args = [
            it
        ];
        var i = 1;
        var replacer, $replacer;
        while(arguments.length > i)args.push(arguments[i++]);
        $replacer = replacer = args[1];
        if (!$h9IVq(replacer) && it === undefined || $3cfbeed0b06b5bdc$var$isSymbol(it)) return; // IE8 returns string on undefined
        if (!$6HMRV(replacer)) replacer = function(key, value) {
            if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
            if (!$3cfbeed0b06b5bdc$var$isSymbol(value)) return value;
        };
        args[1] = replacer;
        return $3cfbeed0b06b5bdc$var$_stringify.apply($3cfbeed0b06b5bdc$var$$JSON, args);
    }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$3cfbeed0b06b5bdc$var$$Symbol[$3cfbeed0b06b5bdc$var$PROTOTYPE][$3cfbeed0b06b5bdc$var$TO_PRIMITIVE] || (parcelRequire("5ujtn"))($3cfbeed0b06b5bdc$var$$Symbol[$3cfbeed0b06b5bdc$var$PROTOTYPE], $3cfbeed0b06b5bdc$var$TO_PRIMITIVE, $3cfbeed0b06b5bdc$var$$Symbol[$3cfbeed0b06b5bdc$var$PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
$k40lc($3cfbeed0b06b5bdc$var$$Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
$k40lc(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
$k40lc($1YuiL.JSON, 'JSON', true);



var $eqgBB = parcelRequire("eqgBB");

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$eqgBB($eqgBB.S, 'Object', {
    create: (parcelRequire("16E7l"))
});



var $eqgBB = parcelRequire("eqgBB");


// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$eqgBB($eqgBB.S + $eqgBB.F * !(parcelRequire("gvOoh")), 'Object', {
    defineProperty: (parcelRequire("lWhMZ")).f
});



var $eqgBB = parcelRequire("eqgBB");


// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$eqgBB($eqgBB.S + $eqgBB.F * !(parcelRequire("gvOoh")), 'Object', {
    defineProperties: (parcelRequire("4MNza"))
});


// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)

var $15QDc = parcelRequire("15QDc");

var $5yOh2 = parcelRequire("5yOh2");
var $4826ba25388f6b9e$require$$getOwnPropertyDescriptor = $5yOh2.f;

(parcelRequire("lTC2m"))('getOwnPropertyDescriptor', function() {
    return function getOwnPropertyDescriptor(it, key) {
        return $4826ba25388f6b9e$require$$getOwnPropertyDescriptor($15QDc(it), key);
    };
});


// 19.1.2.9 Object.getPrototypeOf(O)

var $j50QJ = parcelRequire("j50QJ");

var $9nGSz = parcelRequire("9nGSz");

(parcelRequire("lTC2m"))('getPrototypeOf', function() {
    return function getPrototypeOf(it) {
        return $9nGSz($j50QJ(it));
    };
});


// 19.1.2.14 Object.keys(O)

var $j50QJ = parcelRequire("j50QJ");

var $eYXZv = parcelRequire("eYXZv");

(parcelRequire("lTC2m"))('keys', function() {
    return function keys(it) {
        return $eYXZv($j50QJ(it));
    };
});


// 19.1.2.7 Object.getOwnPropertyNames(O)


(parcelRequire("lTC2m"))('getOwnPropertyNames', function() {
    return (parcelRequire("1uBcr")).f;
});


// 19.1.2.5 Object.freeze(O)

var $h9IVq = parcelRequire("h9IVq");

var $86Fx8 = parcelRequire("86Fx8");
var $51bd2903f70ec16e$require$meta = $86Fx8.onFreeze;

(parcelRequire("lTC2m"))('freeze', function($freeze) {
    return function freeze(it) {
        return $freeze && $h9IVq(it) ? $freeze($51bd2903f70ec16e$require$meta(it)) : it;
    };
});


// 19.1.2.17 Object.seal(O)

var $h9IVq = parcelRequire("h9IVq");

var $86Fx8 = parcelRequire("86Fx8");
var $abdde39344bc8019$require$meta = $86Fx8.onFreeze;

(parcelRequire("lTC2m"))('seal', function($seal) {
    return function seal(it) {
        return $seal && $h9IVq(it) ? $seal($abdde39344bc8019$require$meta(it)) : it;
    };
});


// 19.1.2.15 Object.preventExtensions(O)

var $h9IVq = parcelRequire("h9IVq");

var $86Fx8 = parcelRequire("86Fx8");
var $78183606bb041a6c$require$meta = $86Fx8.onFreeze;

(parcelRequire("lTC2m"))('preventExtensions', function($preventExtensions) {
    return function preventExtensions(it) {
        return $preventExtensions && $h9IVq(it) ? $preventExtensions($78183606bb041a6c$require$meta(it)) : it;
    };
});


// 19.1.2.12 Object.isFrozen(O)

var $h9IVq = parcelRequire("h9IVq");

(parcelRequire("lTC2m"))('isFrozen', function($isFrozen) {
    return function isFrozen(it) {
        return $h9IVq(it) ? $isFrozen ? $isFrozen(it) : false : true;
    };
});


// 19.1.2.13 Object.isSealed(O)

var $h9IVq = parcelRequire("h9IVq");

(parcelRequire("lTC2m"))('isSealed', function($isSealed) {
    return function isSealed(it) {
        return $h9IVq(it) ? $isSealed ? $isSealed(it) : false : true;
    };
});


// 19.1.2.11 Object.isExtensible(O)

var $h9IVq = parcelRequire("h9IVq");

(parcelRequire("lTC2m"))('isExtensible', function($isExtensible) {
    return function isExtensible(it) {
        return $h9IVq(it) ? $isExtensible ? $isExtensible(it) : true : false;
    };
});


// 19.1.3.1 Object.assign(target, source)

var $eqgBB = parcelRequire("eqgBB");

$eqgBB($eqgBB.S + $eqgBB.F, 'Object', {
    assign: (parcelRequire("5cuvo"))
});


// 19.1.3.10 Object.is(value1, value2)

var $eqgBB = parcelRequire("eqgBB");

$eqgBB($eqgBB.S, 'Object', {
    is: (parcelRequire("lnyGt"))
});


// 19.1.3.19 Object.setPrototypeOf(O, proto)

var $eqgBB = parcelRequire("eqgBB");

$eqgBB($eqgBB.S, 'Object', {
    setPrototypeOf: (parcelRequire("iTiy4")).set
});


'use strict';

var $47rfI = parcelRequire("47rfI");
var $d7d3e907bac0cd7e$var$test = {};

var $buDDQ = parcelRequire("buDDQ");
$d7d3e907bac0cd7e$var$test[$buDDQ('toStringTag')] = 'z';

if ($d7d3e907bac0cd7e$var$test + '' != '[object z]') (parcelRequire("2D2fi"))(Object.prototype, 'toString', function toString() {
    return '[object ' + $47rfI(this) + ']';
}, true);


// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)

var $eqgBB = parcelRequire("eqgBB");

$eqgBB($eqgBB.P, 'Function', {
    bind: (parcelRequire("d3CGC"))
});



var $lWhMZ = parcelRequire("lWhMZ");
var $0d3cd37b0c39738a$require$dP = $lWhMZ.f;
var $0d3cd37b0c39738a$var$FProto = Function.prototype;
var $0d3cd37b0c39738a$var$nameRE = /^\s*function ([^ (]*)/;
var $0d3cd37b0c39738a$var$NAME = 'name';

// 19.2.4.2 name
$0d3cd37b0c39738a$var$NAME in $0d3cd37b0c39738a$var$FProto || (parcelRequire("gvOoh")) && $0d3cd37b0c39738a$require$dP($0d3cd37b0c39738a$var$FProto, $0d3cd37b0c39738a$var$NAME, {
    configurable: true,
    get: function() {
        try {
            return ('' + this).match($0d3cd37b0c39738a$var$nameRE)[1];
        } catch (e) {
            return '';
        }
    }
});


'use strict';

var $h9IVq = parcelRequire("h9IVq");

var $9nGSz = parcelRequire("9nGSz");

var $14bf0d3eaacae45a$var$HAS_INSTANCE = (parcelRequire("buDDQ"))('hasInstance');
var $14bf0d3eaacae45a$var$FunctionProto = Function.prototype;

// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!($14bf0d3eaacae45a$var$HAS_INSTANCE in $14bf0d3eaacae45a$var$FunctionProto)) (parcelRequire("lWhMZ")).f($14bf0d3eaacae45a$var$FunctionProto, $14bf0d3eaacae45a$var$HAS_INSTANCE, {
    value: function(O) {
        if (typeof this != 'function' || !$h9IVq(O)) return false;
        if (!$h9IVq(this.prototype)) return O instanceof this;
        // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
        while(O = $9nGSz(O))if (this.prototype === O) return true;
        return false;
    }
});



var $eqgBB = parcelRequire("eqgBB");
var $0ba5470eae4f4a8b$exports = {};

var $1YuiL = parcelRequire("1YuiL");
var $0ba5470eae4f4a8b$require$$parseInt = $1YuiL.parseInt;

var $6vf7z = parcelRequire("6vf7z");
var $0ba5470eae4f4a8b$require$$trim = $6vf7z.trim;

var $7PMIg = parcelRequire("7PMIg");
var $0ba5470eae4f4a8b$var$hex = /^[-+]?0[xX]/;
$0ba5470eae4f4a8b$exports = $0ba5470eae4f4a8b$require$$parseInt($7PMIg + '08') !== 8 || $0ba5470eae4f4a8b$require$$parseInt($7PMIg + '0x16') !== 22 ? function parseInt(str, radix) {
    var string = $0ba5470eae4f4a8b$require$$trim(String(str), 3);
    return $0ba5470eae4f4a8b$require$$parseInt(string, radix >>> 0 || ($0ba5470eae4f4a8b$var$hex.test(string) ? 16 : 10));
} : $0ba5470eae4f4a8b$require$$parseInt;


// 18.2.5 parseInt(string, radix)
$eqgBB($eqgBB.G + $eqgBB.F * (parseInt != $0ba5470eae4f4a8b$exports), {
    parseInt: $0ba5470eae4f4a8b$exports
});



var $eqgBB = parcelRequire("eqgBB");
var $54154b3c2d029ec5$exports = {};

var $1YuiL = parcelRequire("1YuiL");
var $54154b3c2d029ec5$require$$parseFloat = $1YuiL.parseFloat;

var $6vf7z = parcelRequire("6vf7z");
var $54154b3c2d029ec5$require$$trim = $6vf7z.trim;

$54154b3c2d029ec5$exports = 1 / $54154b3c2d029ec5$require$$parseFloat((parcelRequire("7PMIg")) + '-0') !== -Infinity ? function parseFloat(str) {
    var string = $54154b3c2d029ec5$require$$trim(String(str), 3);
    var result = $54154b3c2d029ec5$require$$parseFloat(string);
    return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $54154b3c2d029ec5$require$$parseFloat;


// 18.2.4 parseFloat(string)
$eqgBB($eqgBB.G + $eqgBB.F * (parseFloat != $54154b3c2d029ec5$exports), {
    parseFloat: $54154b3c2d029ec5$exports
});


'use strict';

var $1YuiL = parcelRequire("1YuiL");

var $lRu3m = parcelRequire("lRu3m");

var $P9d0u = parcelRequire("P9d0u");

var $gozGd = parcelRequire("gozGd");

var $9a73R = parcelRequire("9a73R");

var $bjnTD = parcelRequire("bjnTD");

var $ivFzP = parcelRequire("ivFzP");
var $6b37719b5188b3c2$require$gOPN = $ivFzP.f;

var $5yOh2 = parcelRequire("5yOh2");
var $6b37719b5188b3c2$require$gOPD = $5yOh2.f;

var $lWhMZ = parcelRequire("lWhMZ");
var $6b37719b5188b3c2$require$dP = $lWhMZ.f;

var $6vf7z = parcelRequire("6vf7z");
var $6b37719b5188b3c2$require$$trim = $6vf7z.trim;
var $6b37719b5188b3c2$var$NUMBER = 'Number';
var $6b37719b5188b3c2$var$$Number = $1YuiL[$6b37719b5188b3c2$var$NUMBER];
var $6b37719b5188b3c2$var$Base = $6b37719b5188b3c2$var$$Number;
var $6b37719b5188b3c2$var$proto = $6b37719b5188b3c2$var$$Number.prototype;

// Opera ~12 has broken Object#toString
var $6b37719b5188b3c2$var$BROKEN_COF = $P9d0u((parcelRequire("16E7l"))($6b37719b5188b3c2$var$proto)) == $6b37719b5188b3c2$var$NUMBER;
var $6b37719b5188b3c2$var$TRIM = 'trim' in String.prototype;
// 7.1.3 ToNumber(argument)
var $6b37719b5188b3c2$var$toNumber = function(argument) {
    var it = $9a73R(argument, false);
    if (typeof it == 'string' && it.length > 2) {
        it = $6b37719b5188b3c2$var$TRIM ? it.trim() : $6b37719b5188b3c2$require$$trim(it, 3);
        var first = it.charCodeAt(0);
        var third, radix, maxCode;
        if (first === 43 || first === 45) {
            third = it.charCodeAt(2);
            if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
        } else if (first === 48) {
            switch(it.charCodeAt(1)){
                case 66:
                case 98:
                    radix = 2;
                    maxCode = 49;
                    break; // fast equal /^0b[01]+$/i
                case 79:
                case 111:
                    radix = 8;
                    maxCode = 55;
                    break; // fast equal /^0o[0-7]+$/i
                default:
                    return +it;
            }
            for(var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++){
                code = digits.charCodeAt(i);
                // parseInt parses a string to a first unavailable symbol
                // but ToNumber should return NaN if a string contains unavailable symbols
                if (code < 48 || code > maxCode) return NaN;
            }
            return parseInt(digits, radix);
        }
    }
    return +it;
};


if (!$6b37719b5188b3c2$var$$Number(' 0o1') || !$6b37719b5188b3c2$var$$Number('0b1') || $6b37719b5188b3c2$var$$Number('+0x1')) {
    $6b37719b5188b3c2$var$$Number = function Number(value) {
        var it = arguments.length < 1 ? 0 : value;
        var that = this;
        return that instanceof $6b37719b5188b3c2$var$$Number && ($6b37719b5188b3c2$var$BROKEN_COF ? $bjnTD(function() {
            $6b37719b5188b3c2$var$proto.valueOf.call(that);
        }) : $P9d0u(that) != $6b37719b5188b3c2$var$NUMBER) ? $gozGd(new $6b37719b5188b3c2$var$Base($6b37719b5188b3c2$var$toNumber(it)), that, $6b37719b5188b3c2$var$$Number) : $6b37719b5188b3c2$var$toNumber(it);
    };
    for(var $6b37719b5188b3c2$var$keys = (parcelRequire("gvOoh")) ? $6b37719b5188b3c2$require$gOPN($6b37719b5188b3c2$var$Base) : // ES3:
    "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(','), $6b37719b5188b3c2$var$j = 0, $6b37719b5188b3c2$var$key; $6b37719b5188b3c2$var$keys.length > $6b37719b5188b3c2$var$j; $6b37719b5188b3c2$var$j++)if ($lRu3m($6b37719b5188b3c2$var$Base, $6b37719b5188b3c2$var$key = $6b37719b5188b3c2$var$keys[$6b37719b5188b3c2$var$j]) && !$lRu3m($6b37719b5188b3c2$var$$Number, $6b37719b5188b3c2$var$key)) $6b37719b5188b3c2$require$dP($6b37719b5188b3c2$var$$Number, $6b37719b5188b3c2$var$key, $6b37719b5188b3c2$require$gOPD($6b37719b5188b3c2$var$Base, $6b37719b5188b3c2$var$key));
    $6b37719b5188b3c2$var$$Number.prototype = $6b37719b5188b3c2$var$proto;
    $6b37719b5188b3c2$var$proto.constructor = $6b37719b5188b3c2$var$$Number;
    (parcelRequire("2D2fi"))($1YuiL, $6b37719b5188b3c2$var$NUMBER, $6b37719b5188b3c2$var$$Number);
}


'use strict';

var $eqgBB = parcelRequire("eqgBB");

var $dAqin = parcelRequire("dAqin");
var $ca5ea8a34e296d02$exports = {};

var $P9d0u = parcelRequire("P9d0u");
$ca5ea8a34e296d02$exports = function(it, msg) {
    if (typeof it != 'number' && $P9d0u(it) != 'Number') throw TypeError(msg);
    return +it;
};



var $lQVqT = parcelRequire("lQVqT");
var $f0db9779556343c7$var$$toFixed = 1.0.toFixed;
var $f0db9779556343c7$var$floor = Math.floor;
var $f0db9779556343c7$var$data = [
    0,
    0,
    0,
    0,
    0,
    0
];
var $f0db9779556343c7$var$ERROR = 'Number.toFixed: incorrect invocation!';
var $f0db9779556343c7$var$ZERO = '0';
var $f0db9779556343c7$var$multiply = function(n, c) {
    var i = -1;
    var c2 = c;
    while(++i < 6){
        c2 += n * $f0db9779556343c7$var$data[i];
        $f0db9779556343c7$var$data[i] = c2 % 1e7;
        c2 = $f0db9779556343c7$var$floor(c2 / 1e7);
    }
};
var $f0db9779556343c7$var$divide = function(n) {
    var i = 6;
    var c = 0;
    while(--i >= 0){
        c += $f0db9779556343c7$var$data[i];
        $f0db9779556343c7$var$data[i] = $f0db9779556343c7$var$floor(c / n);
        c = c % n * 1e7;
    }
};
var $f0db9779556343c7$var$numToString = function() {
    var i = 6;
    var s = '';
    while(--i >= 0)if (s !== '' || i === 0 || $f0db9779556343c7$var$data[i] !== 0) {
        var t = String($f0db9779556343c7$var$data[i]);
        s = s === '' ? t : s + $lQVqT.call($f0db9779556343c7$var$ZERO, 7 - t.length) + t;
    }
    return s;
};
var $f0db9779556343c7$var$pow = function(x, n, acc) {
    return n === 0 ? acc : n % 2 === 1 ? $f0db9779556343c7$var$pow(x, n - 1, acc * x) : $f0db9779556343c7$var$pow(x * x, n / 2, acc);
};
var $f0db9779556343c7$var$log = function(x) {
    var n = 0;
    var x2 = x;
    while(x2 >= 4096){
        n += 12;
        x2 /= 4096;
    }
    while(x2 >= 2){
        n += 1;
        x2 /= 2;
    }
    return n;
};

$eqgBB($eqgBB.P + $eqgBB.F * (!!$f0db9779556343c7$var$$toFixed && (0.00008.toFixed(3) !== '0.000' || 0.9.toFixed(0) !== '1' || 1.255.toFixed(2) !== '1.25' || 1000000000000000128.0.toFixed(0) !== '1000000000000000128') || !(parcelRequire("bjnTD"))(function() {
    // V8 ~ Android 4.3-
    $f0db9779556343c7$var$$toFixed.call({});
})), 'Number', {
    toFixed: function toFixed(fractionDigits) {
        var x = $ca5ea8a34e296d02$exports(this, $f0db9779556343c7$var$ERROR);
        var f = $dAqin(fractionDigits);
        var s = '';
        var m = $f0db9779556343c7$var$ZERO;
        var e, z, j, k;
        if (f < 0 || f > 20) throw RangeError($f0db9779556343c7$var$ERROR);
        // eslint-disable-next-line no-self-compare
        if (x != x) return 'NaN';
        if (x <= -1000000000000000000000 || x >= 1e21) return String(x);
        if (x < 0) {
            s = '-';
            x = -x;
        }
        if (x > 1e-21) {
            e = $f0db9779556343c7$var$log(x * $f0db9779556343c7$var$pow(2, 69, 1)) - 69;
            z = e < 0 ? x * $f0db9779556343c7$var$pow(2, -e, 1) : x / $f0db9779556343c7$var$pow(2, e, 1);
            z *= 0x10000000000000;
            e = 52 - e;
            if (e > 0) {
                $f0db9779556343c7$var$multiply(0, z);
                j = f;
                while(j >= 7){
                    $f0db9779556343c7$var$multiply(1e7, 0);
                    j -= 7;
                }
                $f0db9779556343c7$var$multiply($f0db9779556343c7$var$pow(10, j, 1), 0);
                j = e - 1;
                while(j >= 23){
                    $f0db9779556343c7$var$divide(8388608);
                    j -= 23;
                }
                $f0db9779556343c7$var$divide(1 << j);
                $f0db9779556343c7$var$multiply(1, 1);
                $f0db9779556343c7$var$divide(2);
                m = $f0db9779556343c7$var$numToString();
            } else {
                $f0db9779556343c7$var$multiply(0, z);
                $f0db9779556343c7$var$multiply(1 << -e, 0);
                m = $f0db9779556343c7$var$numToString() + $lQVqT.call($f0db9779556343c7$var$ZERO, f);
            }
        }
        if (f > 0) {
            k = m.length;
            m = s + (k <= f ? '0.' + $lQVqT.call($f0db9779556343c7$var$ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
        } else m = s + m;
        return m;
    }
});


'use strict';

var $eqgBB = parcelRequire("eqgBB");

var $bjnTD = parcelRequire("bjnTD");

var $125321b09330d6e5$var$$toPrecision = 1.0.toPrecision;
$eqgBB($eqgBB.P + $eqgBB.F * ($bjnTD(function() {
    // IE7-
    return $125321b09330d6e5$var$$toPrecision.call(1, undefined) !== '1';
}) || !$bjnTD(function() {
    // V8 ~ Android 4.3-
    $125321b09330d6e5$var$$toPrecision.call({});
})), 'Number', {
    toPrecision: function toPrecision(precision) {
        var that = $ca5ea8a34e296d02$exports(this, 'Number#toPrecision: incorrect invocation!');
        return precision === undefined ? $125321b09330d6e5$var$$toPrecision.call(that) : $125321b09330d6e5$var$$toPrecision.call(that, precision);
    }
});


// 20.1.2.1 Number.EPSILON

var $eqgBB = parcelRequire("eqgBB");
$eqgBB($eqgBB.S, 'Number', {
    EPSILON: Math.pow(2, -52)
});


// 20.1.2.2 Number.isFinite(number)

var $eqgBB = parcelRequire("eqgBB");

var $1YuiL = parcelRequire("1YuiL");
var $22767466ba91cd65$require$_isFinite = $1YuiL.isFinite;
$eqgBB($eqgBB.S, 'Number', {
    isFinite: function isFinite(it) {
        return typeof it == 'number' && $22767466ba91cd65$require$_isFinite(it);
    }
});


// 20.1.2.3 Number.isInteger(number)

var $eqgBB = parcelRequire("eqgBB");

$eqgBB($eqgBB.S, 'Number', {
    isInteger: (parcelRequire("3DtrK"))
});


// 20.1.2.4 Number.isNaN(number)

var $eqgBB = parcelRequire("eqgBB");
$eqgBB($eqgBB.S, 'Number', {
    isNaN: function isNaN(number) {
        // eslint-disable-next-line no-self-compare
        return number != number;
    }
});


// 20.1.2.5 Number.isSafeInteger(number)

var $eqgBB = parcelRequire("eqgBB");

var $3DtrK = parcelRequire("3DtrK");
var $1957211d23fbf811$var$abs = Math.abs;
$eqgBB($eqgBB.S, 'Number', {
    isSafeInteger: function isSafeInteger(number) {
        return $3DtrK(number) && $1957211d23fbf811$var$abs(number) <= 0x1fffffffffffff;
    }
});


// 20.1.2.6 Number.MAX_SAFE_INTEGER

var $eqgBB = parcelRequire("eqgBB");
$eqgBB($eqgBB.S, 'Number', {
    MAX_SAFE_INTEGER: 0x1fffffffffffff
});


// 20.1.2.10 Number.MIN_SAFE_INTEGER

var $eqgBB = parcelRequire("eqgBB");
$eqgBB($eqgBB.S, 'Number', {
    MIN_SAFE_INTEGER: -9007199254740991
});



var $eqgBB = parcelRequire("eqgBB");

// 20.1.2.12 Number.parseFloat(string)
$eqgBB($eqgBB.S + $eqgBB.F * (Number.parseFloat != $54154b3c2d029ec5$exports), 'Number', {
    parseFloat: $54154b3c2d029ec5$exports
});



var $eqgBB = parcelRequire("eqgBB");

// 20.1.2.13 Number.parseInt(string, radix)
$eqgBB($eqgBB.S + $eqgBB.F * (Number.parseInt != $0ba5470eae4f4a8b$exports), 'Number', {
    parseInt: $0ba5470eae4f4a8b$exports
});


// 20.2.2.3 Math.acosh(x)

var $eqgBB = parcelRequire("eqgBB");

var $7ZXns = parcelRequire("7ZXns");
var $adf34be22ee15fdd$var$sqrt = Math.sqrt;
var $adf34be22ee15fdd$var$$acosh = Math.acosh;
$eqgBB($eqgBB.S + $eqgBB.F * !($adf34be22ee15fdd$var$$acosh && Math.floor($adf34be22ee15fdd$var$$acosh(Number.MAX_VALUE)) == 710 && $adf34be22ee15fdd$var$$acosh(Infinity) == Infinity), 'Math', {
    acosh: function acosh(x) {
        return (x = +x) < 1 ? NaN : x > 94906265.62425156 ? Math.log(x) + Math.LN2 : $7ZXns(x - 1 + $adf34be22ee15fdd$var$sqrt(x - 1) * $adf34be22ee15fdd$var$sqrt(x + 1));
    }
});


// 20.2.2.5 Math.asinh(x)

var $eqgBB = parcelRequire("eqgBB");
var $01023d12b84b249b$var$$asinh = Math.asinh;
function $01023d12b84b249b$var$asinh(x) {
    return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -$01023d12b84b249b$var$asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}
// Tor Browser bug: Math.asinh(0) -> -0
$eqgBB($eqgBB.S + $eqgBB.F * !($01023d12b84b249b$var$$asinh && 1 / $01023d12b84b249b$var$$asinh(0) > 0), 'Math', {
    asinh: $01023d12b84b249b$var$asinh
});


// 20.2.2.7 Math.atanh(x)

var $eqgBB = parcelRequire("eqgBB");
var $21f831c7ebaee7d2$var$$atanh = Math.atanh;
// Tor Browser bug: Math.atanh(-0) -> 0
$eqgBB($eqgBB.S + $eqgBB.F * !($21f831c7ebaee7d2$var$$atanh && 1 / $21f831c7ebaee7d2$var$$atanh(-0) < 0), 'Math', {
    atanh: function atanh(x) {
        return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
    }
});


// 20.2.2.9 Math.cbrt(x)

var $eqgBB = parcelRequire("eqgBB");

var $36EjW = parcelRequire("36EjW");
$eqgBB($eqgBB.S, 'Math', {
    cbrt: function cbrt(x) {
        return $36EjW(x = +x) * Math.pow(Math.abs(x), 1 / 3);
    }
});


// 20.2.2.11 Math.clz32(x)

var $eqgBB = parcelRequire("eqgBB");
$eqgBB($eqgBB.S, 'Math', {
    clz32: function clz32(x) {
        return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
    }
});


// 20.2.2.12 Math.cosh(x)

var $eqgBB = parcelRequire("eqgBB");
var $4a01b3279ed642af$var$exp = Math.exp;
$eqgBB($eqgBB.S, 'Math', {
    cosh: function cosh(x) {
        return ($4a01b3279ed642af$var$exp(x = +x) + $4a01b3279ed642af$var$exp(-x)) / 2;
    }
});


// 20.2.2.14 Math.expm1(x)

var $eqgBB = parcelRequire("eqgBB");
var $a4a8705f2e8714f0$exports = {};
// 20.2.2.14 Math.expm1(x)
var $a4a8705f2e8714f0$var$$expm1 = Math.expm1;
$a4a8705f2e8714f0$exports = !$a4a8705f2e8714f0$var$$expm1 || $a4a8705f2e8714f0$var$$expm1(10) > 22025.465794806719 || $a4a8705f2e8714f0$var$$expm1(10) < 22025.4657948067165168 || $a4a8705f2e8714f0$var$$expm1(-0.00000000000000002) != -0.00000000000000002 ? function expm1(x) {
    return (x = +x) == 0 ? x : x > -0.000001 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $a4a8705f2e8714f0$var$$expm1;


$eqgBB($eqgBB.S + $eqgBB.F * ($a4a8705f2e8714f0$exports != Math.expm1), 'Math', {
    expm1: $a4a8705f2e8714f0$exports
});


// 20.2.2.16 Math.fround(x)

var $eqgBB = parcelRequire("eqgBB");

$eqgBB($eqgBB.S, 'Math', {
    fround: (parcelRequire("6Jdp5"))
});


// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])

var $eqgBB = parcelRequire("eqgBB");
var $1328ec0ba132fb13$var$abs = Math.abs;
$eqgBB($eqgBB.S, 'Math', {
    hypot: function hypot(value1, value2) {
        var sum = 0;
        var i = 0;
        var aLen = arguments.length;
        var larg = 0;
        var arg, div;
        while(i < aLen){
            arg = $1328ec0ba132fb13$var$abs(arguments[i++]);
            if (larg < arg) {
                div = larg / arg;
                sum = sum * div * div + 1;
                larg = arg;
            } else if (arg > 0) {
                div = arg / larg;
                sum += div * div;
            } else sum += arg;
        }
        return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
    }
});


// 20.2.2.18 Math.imul(x, y)

var $eqgBB = parcelRequire("eqgBB");
var $cccf0607ee376125$var$$imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$eqgBB($eqgBB.S + $eqgBB.F * (parcelRequire("bjnTD"))(function() {
    return $cccf0607ee376125$var$$imul(0xffffffff, 5) != -5 || $cccf0607ee376125$var$$imul.length != 2;
}), 'Math', {
    imul: function imul(x, y) {
        var UINT16 = 0xffff;
        var xn = +x;
        var yn = +y;
        var xl = UINT16 & xn;
        var yl = UINT16 & yn;
        return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
    }
});


// 20.2.2.21 Math.log10(x)

var $eqgBB = parcelRequire("eqgBB");
$eqgBB($eqgBB.S, 'Math', {
    log10: function log10(x) {
        return Math.log(x) * Math.LOG10E;
    }
});


// 20.2.2.20 Math.log1p(x)

var $eqgBB = parcelRequire("eqgBB");

$eqgBB($eqgBB.S, 'Math', {
    log1p: (parcelRequire("7ZXns"))
});


// 20.2.2.22 Math.log2(x)

var $eqgBB = parcelRequire("eqgBB");
$eqgBB($eqgBB.S, 'Math', {
    log2: function log2(x) {
        return Math.log(x) / Math.LN2;
    }
});


// 20.2.2.28 Math.sign(x)

var $eqgBB = parcelRequire("eqgBB");

$eqgBB($eqgBB.S, 'Math', {
    sign: (parcelRequire("36EjW"))
});


// 20.2.2.30 Math.sinh(x)

var $eqgBB = parcelRequire("eqgBB");

var $e43bbd91c48f97c6$var$exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$eqgBB($eqgBB.S + $eqgBB.F * (parcelRequire("bjnTD"))(function() {
    return !Math.sinh(-0.00000000000000002) != -0.00000000000000002;
}), 'Math', {
    sinh: function sinh(x) {
        return Math.abs(x = +x) < 1 ? ($a4a8705f2e8714f0$exports(x) - $a4a8705f2e8714f0$exports(-x)) / 2 : ($e43bbd91c48f97c6$var$exp(x - 1) - $e43bbd91c48f97c6$var$exp(-x - 1)) * (Math.E / 2);
    }
});


// 20.2.2.33 Math.tanh(x)

var $eqgBB = parcelRequire("eqgBB");

var $3c3ad6ce55c8e7dc$var$exp = Math.exp;
$eqgBB($eqgBB.S, 'Math', {
    tanh: function tanh(x) {
        var a = $a4a8705f2e8714f0$exports(x = +x);
        var b = $a4a8705f2e8714f0$exports(-x);
        return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / ($3c3ad6ce55c8e7dc$var$exp(x) + $3c3ad6ce55c8e7dc$var$exp(-x));
    }
});


// 20.2.2.34 Math.trunc(x)

var $eqgBB = parcelRequire("eqgBB");
$eqgBB($eqgBB.S, 'Math', {
    trunc: function trunc(it) {
        return (it > 0 ? Math.floor : Math.ceil)(it);
    }
});



var $eqgBB = parcelRequire("eqgBB");

var $aJr6a = parcelRequire("aJr6a");
var $589b8eea76b28250$var$fromCharCode = String.fromCharCode;
var $589b8eea76b28250$var$$fromCodePoint = String.fromCodePoint;
// length should be 1, old FF problem
$eqgBB($eqgBB.S + $eqgBB.F * (!!$589b8eea76b28250$var$$fromCodePoint && $589b8eea76b28250$var$$fromCodePoint.length != 1), 'String', {
    // 21.1.2.2 String.fromCodePoint(...codePoints)
    fromCodePoint: function fromCodePoint(x) {
        var res = [];
        var aLen = arguments.length;
        var i = 0;
        var code;
        while(aLen > i){
            code = +arguments[i++];
            if ($aJr6a(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
            res.push(code < 0x10000 ? $589b8eea76b28250$var$fromCharCode(code) : $589b8eea76b28250$var$fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00));
        }
        return res.join('');
    }
});



var $eqgBB = parcelRequire("eqgBB");

var $15QDc = parcelRequire("15QDc");

var $jsF4z = parcelRequire("jsF4z");
$eqgBB($eqgBB.S, 'String', {
    // 21.1.2.4 String.raw(callSite, ...substitutions)
    raw: function raw(callSite) {
        var tpl = $15QDc(callSite.raw);
        var len = $jsF4z(tpl.length);
        var aLen = arguments.length;
        var res = [];
        var i = 0;
        while(len > i){
            res.push(String(tpl[i++]));
            if (i < aLen) res.push(String(arguments[i]));
        }
        return res.join('');
    }
});


'use strict';

// 21.1.3.25 String.prototype.trim()
(parcelRequire("6vf7z"))('trim', function($trim) {
    return function trim() {
        return $trim(this, 3);
    };
});


'use strict';

var $5e4bb89c3d1df8c3$var$$at = (parcelRequire("2B3HC"))(true);

// 21.1.3.27 String.prototype[@@iterator]()
(parcelRequire("eApyU"))(String, 'String', function(iterated) {
    this._t = String(iterated); // target
    this._i = 0; // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var index = this._i;
    var point;
    if (index >= O.length) return {
        value: undefined,
        done: true
    };
    point = $5e4bb89c3d1df8c3$var$$at(O, index);
    this._i += point.length;
    return {
        value: point,
        done: false
    };
});


'use strict';

var $eqgBB = parcelRequire("eqgBB");

var $9ec8678f1c5ad8bd$var$$at = (parcelRequire("2B3HC"))(false);
$eqgBB($eqgBB.P, 'String', {
    // 21.1.3.3 String.prototype.codePointAt(pos)
    codePointAt: function codePointAt(pos) {
        return $9ec8678f1c5ad8bd$var$$at(this, pos);
    }
});


// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
'use strict';

var $eqgBB = parcelRequire("eqgBB");

var $jsF4z = parcelRequire("jsF4z");
var $67f170a9c7613ef0$exports = {};
// helper for String#{startsWith, endsWith, includes}
var $4a865ed90b3243fb$exports = {};
// 7.2.8 IsRegExp(argument)

var $h9IVq = parcelRequire("h9IVq");

var $P9d0u = parcelRequire("P9d0u");

var $4a865ed90b3243fb$var$MATCH = (parcelRequire("buDDQ"))('match');
$4a865ed90b3243fb$exports = function(it) {
    var isRegExp;
    return $h9IVq(it) && ((isRegExp = it[$4a865ed90b3243fb$var$MATCH]) !== undefined ? !!isRegExp : $P9d0u(it) == 'RegExp');
};



var $6g06V = parcelRequire("6g06V");
$67f170a9c7613ef0$exports = function(that, searchString, NAME) {
    if ($4a865ed90b3243fb$exports(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
    return String($6g06V(that));
};


var $681967e9642e166c$var$ENDS_WITH = 'endsWith';
var $681967e9642e166c$var$$endsWith = ''[$681967e9642e166c$var$ENDS_WITH];

$eqgBB($eqgBB.P + $eqgBB.F * (parcelRequire("caRQI"))($681967e9642e166c$var$ENDS_WITH), 'String', {
    endsWith: function endsWith(searchString /* , endPosition = @length */ ) {
        var that = $67f170a9c7613ef0$exports(this, searchString, $681967e9642e166c$var$ENDS_WITH);
        var endPosition = arguments.length > 1 ? arguments[1] : undefined;
        var len = $jsF4z(that.length);
        var end = endPosition === undefined ? len : Math.min($jsF4z(endPosition), len);
        var search = String(searchString);
        return $681967e9642e166c$var$$endsWith ? $681967e9642e166c$var$$endsWith.call(that, search, end) : that.slice(end - search.length, end) === search;
    }
});


// 21.1.3.7 String.prototype.includes(searchString, position = 0)
'use strict';

var $eqgBB = parcelRequire("eqgBB");

var $8d032be1266b5de4$var$INCLUDES = 'includes';

$eqgBB($eqgBB.P + $eqgBB.F * (parcelRequire("caRQI"))($8d032be1266b5de4$var$INCLUDES), 'String', {
    includes: function includes(searchString /* , position = 0 */ ) {
        return !!~$67f170a9c7613ef0$exports(this, searchString, $8d032be1266b5de4$var$INCLUDES).indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
    }
});



var $eqgBB = parcelRequire("eqgBB");

$eqgBB($eqgBB.P, 'String', {
    // 21.1.3.13 String.prototype.repeat(count)
    repeat: (parcelRequire("lQVqT"))
});


// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
'use strict';

var $eqgBB = parcelRequire("eqgBB");

var $jsF4z = parcelRequire("jsF4z");

var $72e516febf8919be$var$STARTS_WITH = 'startsWith';
var $72e516febf8919be$var$$startsWith = ''[$72e516febf8919be$var$STARTS_WITH];

$eqgBB($eqgBB.P + $eqgBB.F * (parcelRequire("caRQI"))($72e516febf8919be$var$STARTS_WITH), 'String', {
    startsWith: function startsWith(searchString /* , position = 0 */ ) {
        var that = $67f170a9c7613ef0$exports(this, searchString, $72e516febf8919be$var$STARTS_WITH);
        var index = $jsF4z(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
        var search = String(searchString);
        return $72e516febf8919be$var$$startsWith ? $72e516febf8919be$var$$startsWith.call(that, search, index) : that.slice(index, index + search.length) === search;
    }
});


'use strict';

// B.2.3.2 String.prototype.anchor(name)
(parcelRequire("9Zqh5"))('anchor', function(createHTML) {
    return function anchor(name) {
        return createHTML(this, 'a', 'name', name);
    };
});


'use strict';

// B.2.3.3 String.prototype.big()
(parcelRequire("9Zqh5"))('big', function(createHTML) {
    return function big() {
        return createHTML(this, 'big', '', '');
    };
});


'use strict';

// B.2.3.4 String.prototype.blink()
(parcelRequire("9Zqh5"))('blink', function(createHTML) {
    return function blink() {
        return createHTML(this, 'blink', '', '');
    };
});


'use strict';

// B.2.3.5 String.prototype.bold()
(parcelRequire("9Zqh5"))('bold', function(createHTML) {
    return function bold() {
        return createHTML(this, 'b', '', '');
    };
});


'use strict';

// B.2.3.6 String.prototype.fixed()
(parcelRequire("9Zqh5"))('fixed', function(createHTML) {
    return function fixed() {
        return createHTML(this, 'tt', '', '');
    };
});


'use strict';

// B.2.3.7 String.prototype.fontcolor(color)
(parcelRequire("9Zqh5"))('fontcolor', function(createHTML) {
    return function fontcolor(color) {
        return createHTML(this, 'font', 'color', color);
    };
});


'use strict';

// B.2.3.8 String.prototype.fontsize(size)
(parcelRequire("9Zqh5"))('fontsize', function(createHTML) {
    return function fontsize(size) {
        return createHTML(this, 'font', 'size', size);
    };
});


'use strict';

// B.2.3.9 String.prototype.italics()
(parcelRequire("9Zqh5"))('italics', function(createHTML) {
    return function italics() {
        return createHTML(this, 'i', '', '');
    };
});


'use strict';

// B.2.3.10 String.prototype.link(url)
(parcelRequire("9Zqh5"))('link', function(createHTML) {
    return function link(url) {
        return createHTML(this, 'a', 'href', url);
    };
});


'use strict';

// B.2.3.11 String.prototype.small()
(parcelRequire("9Zqh5"))('small', function(createHTML) {
    return function small() {
        return createHTML(this, 'small', '', '');
    };
});


'use strict';

// B.2.3.12 String.prototype.strike()
(parcelRequire("9Zqh5"))('strike', function(createHTML) {
    return function strike() {
        return createHTML(this, 'strike', '', '');
    };
});


'use strict';

// B.2.3.13 String.prototype.sub()
(parcelRequire("9Zqh5"))('sub', function(createHTML) {
    return function sub() {
        return createHTML(this, 'sub', '', '');
    };
});


'use strict';

// B.2.3.14 String.prototype.sup()
(parcelRequire("9Zqh5"))('sup', function(createHTML) {
    return function sup() {
        return createHTML(this, 'sup', '', '');
    };
});


// 20.3.3.1 / 15.9.4.4 Date.now()

var $eqgBB = parcelRequire("eqgBB");
$eqgBB($eqgBB.S, 'Date', {
    now: function() {
        return new Date().getTime();
    }
});


'use strict';

var $eqgBB = parcelRequire("eqgBB");

var $j50QJ = parcelRequire("j50QJ");

var $9a73R = parcelRequire("9a73R");

$eqgBB($eqgBB.P + $eqgBB.F * (parcelRequire("bjnTD"))(function() {
    return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({
        toISOString: function() {
            return 1;
        }
    }) !== 1;
}), 'Date', {
    // eslint-disable-next-line no-unused-vars
    toJSON: function toJSON(key) {
        var O = $j50QJ(this);
        var pv = $9a73R(O);
        return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
    }
});


// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()

var $eqgBB = parcelRequire("eqgBB");
var $76466f78ec16c992$exports = {};
'use strict';

var $bjnTD = parcelRequire("bjnTD");
var $76466f78ec16c992$var$getTime = Date.prototype.getTime;
var $76466f78ec16c992$var$$toISOString = Date.prototype.toISOString;
var $76466f78ec16c992$var$lz = function(num) {
    return num > 9 ? num : '0' + num;
};
// PhantomJS / old WebKit has a broken implementations
$76466f78ec16c992$exports = $bjnTD(function() {
    return $76466f78ec16c992$var$$toISOString.call(new Date(-50000000000000 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !$bjnTD(function() {
    $76466f78ec16c992$var$$toISOString.call(new Date(NaN));
}) ? function toISOString() {
    if (!isFinite($76466f78ec16c992$var$getTime.call(this))) throw RangeError('Invalid time value');
    var d = this;
    var y = d.getUTCFullYear();
    var m = d.getUTCMilliseconds();
    var s = y < 0 ? '-' : y > 9999 ? '+' : '';
    return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) + '-' + $76466f78ec16c992$var$lz(d.getUTCMonth() + 1) + '-' + $76466f78ec16c992$var$lz(d.getUTCDate()) + 'T' + $76466f78ec16c992$var$lz(d.getUTCHours()) + ':' + $76466f78ec16c992$var$lz(d.getUTCMinutes()) + ':' + $76466f78ec16c992$var$lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + $76466f78ec16c992$var$lz(m)) + 'Z';
} : $76466f78ec16c992$var$$toISOString;


// PhantomJS / old WebKit has a broken implementations
$eqgBB($eqgBB.P + $eqgBB.F * (Date.prototype.toISOString !== $76466f78ec16c992$exports), 'Date', {
    toISOString: $76466f78ec16c992$exports
});


var $10dfd4ad25386ed6$var$DateProto = Date.prototype;
var $10dfd4ad25386ed6$var$INVALID_DATE = 'Invalid Date';
var $10dfd4ad25386ed6$var$TO_STRING = 'toString';
var $10dfd4ad25386ed6$var$$toString = $10dfd4ad25386ed6$var$DateProto[$10dfd4ad25386ed6$var$TO_STRING];
var $10dfd4ad25386ed6$var$getTime = $10dfd4ad25386ed6$var$DateProto.getTime;

if (new Date(NaN) + '' != $10dfd4ad25386ed6$var$INVALID_DATE) (parcelRequire("2D2fi"))($10dfd4ad25386ed6$var$DateProto, $10dfd4ad25386ed6$var$TO_STRING, function toString() {
    var value = $10dfd4ad25386ed6$var$getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $10dfd4ad25386ed6$var$$toString.call(this) : $10dfd4ad25386ed6$var$INVALID_DATE;
});



var $913be47c1e81800f$var$TO_PRIMITIVE = (parcelRequire("buDDQ"))('toPrimitive');
var $913be47c1e81800f$var$proto = Date.prototype;


if (!($913be47c1e81800f$var$TO_PRIMITIVE in $913be47c1e81800f$var$proto)) (parcelRequire("5ujtn"))($913be47c1e81800f$var$proto, $913be47c1e81800f$var$TO_PRIMITIVE, (parcelRequire("l8WEI")));


// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)

var $eqgBB = parcelRequire("eqgBB");

$eqgBB($eqgBB.S, 'Array', {
    isArray: (parcelRequire("6HMRV"))
});


'use strict';

var $8luNd = parcelRequire("8luNd");

var $eqgBB = parcelRequire("eqgBB");

var $j50QJ = parcelRequire("j50QJ");

var $a1YsG = parcelRequire("a1YsG");

var $awT0Y = parcelRequire("awT0Y");

var $jsF4z = parcelRequire("jsF4z");
var $067c5645c3e4c3e4$exports = {};
'use strict';

var $lWhMZ = parcelRequire("lWhMZ");

var $8tLmk = parcelRequire("8tLmk");
$067c5645c3e4c3e4$exports = function(object, index, value) {
    if (index in object) $lWhMZ.f(object, index, $8tLmk(0, value));
    else object[index] = value;
};



var $fUVYF = parcelRequire("fUVYF");

$eqgBB($eqgBB.S + $eqgBB.F * !(parcelRequire("5QSWt"))(function(iter) {
    Array.from(iter);
}), 'Array', {
    // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
    from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */ ) {
        var O = $j50QJ(arrayLike);
        var C = typeof this == 'function' ? this : Array;
        var aLen = arguments.length;
        var mapfn = aLen > 1 ? arguments[1] : undefined;
        var mapping = mapfn !== undefined;
        var index = 0;
        var iterFn = $fUVYF(O);
        var length, result, step, iterator;
        if (mapping) mapfn = $8luNd(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
        // if object isn't iterable or it's array with default iterator - use simple case
        if (iterFn != undefined && !(C == Array && $awT0Y(iterFn))) for(iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++)$067c5645c3e4c3e4$exports(result, index, mapping ? $a1YsG(iterator, mapfn, [
            step.value,
            index
        ], true) : step.value);
        else {
            length = $jsF4z(O.length);
            for(result = new C(length); length > index; index++)$067c5645c3e4c3e4$exports(result, index, mapping ? mapfn(O[index], index) : O[index]);
        }
        result.length = index;
        return result;
    }
});


'use strict';

var $eqgBB = parcelRequire("eqgBB");


// WebKit Array.of isn't generic
$eqgBB($eqgBB.S + $eqgBB.F * (parcelRequire("bjnTD"))(function() {
    function F() {}
    return !(Array.of.call(F) instanceof F);
}), 'Array', {
    // 22.1.2.3 Array.of( ...items)
    of: function of() {
        var index = 0;
        var aLen = arguments.length;
        var result = new (typeof this == 'function' ? this : Array)(aLen);
        while(aLen > index)$067c5645c3e4c3e4$exports(result, index, arguments[index++]);
        result.length = aLen;
        return result;
    }
});


'use strict';

var $eqgBB = parcelRequire("eqgBB");

var $15QDc = parcelRequire("15QDc");
var $4f80840940bf5ffc$var$arrayJoin = [].join;


// fallback for not array-like strings
$eqgBB($eqgBB.P + $eqgBB.F * ((parcelRequire("9DkTL")) != Object || !(parcelRequire("QCNTE"))($4f80840940bf5ffc$var$arrayJoin)), 'Array', {
    join: function join(separator) {
        return $4f80840940bf5ffc$var$arrayJoin.call($15QDc(this), separator === undefined ? ',' : separator);
    }
});


'use strict';

var $eqgBB = parcelRequire("eqgBB");

var $ahTLX = parcelRequire("ahTLX");

var $P9d0u = parcelRequire("P9d0u");

var $aJr6a = parcelRequire("aJr6a");

var $jsF4z = parcelRequire("jsF4z");
var $1274a7fa2e354d9e$var$arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$eqgBB($eqgBB.P + $eqgBB.F * (parcelRequire("bjnTD"))(function() {
    if ($ahTLX) $1274a7fa2e354d9e$var$arraySlice.call($ahTLX);
}), 'Array', {
    slice: function slice(begin, end) {
        var len = $jsF4z(this.length);
        var klass = $P9d0u(this);
        end = end === undefined ? len : end;
        if (klass == 'Array') return $1274a7fa2e354d9e$var$arraySlice.call(this, begin, end);
        var start = $aJr6a(begin, len);
        var upTo = $aJr6a(end, len);
        var size = $jsF4z(upTo - start);
        var cloned = new Array(size);
        var i = 0;
        for(; i < size; i++)cloned[i] = klass == 'String' ? this.charAt(start + i) : this[start + i];
        return cloned;
    }
});


'use strict';

var $eqgBB = parcelRequire("eqgBB");

var $4VmiN = parcelRequire("4VmiN");

var $j50QJ = parcelRequire("j50QJ");

var $bjnTD = parcelRequire("bjnTD");
var $2094a4117ef4a43b$var$$sort = [].sort;
var $2094a4117ef4a43b$var$test = [
    1,
    2,
    3
];

$eqgBB($eqgBB.P + $eqgBB.F * ($bjnTD(function() {
    // IE8-
    $2094a4117ef4a43b$var$test.sort(undefined);
}) || !$bjnTD(function() {
    // V8 bug
    $2094a4117ef4a43b$var$test.sort(null);
// Old WebKit
}) || !(parcelRequire("QCNTE"))($2094a4117ef4a43b$var$$sort)), 'Array', {
    // 22.1.3.25 Array.prototype.sort(comparefn)
    sort: function sort(comparefn) {
        return comparefn === undefined ? $2094a4117ef4a43b$var$$sort.call($j50QJ(this)) : $2094a4117ef4a43b$var$$sort.call($j50QJ(this), $4VmiN(comparefn));
    }
});


'use strict';

var $eqgBB = parcelRequire("eqgBB");

var $db8df549b0911694$var$$forEach = (parcelRequire("2ikiy"))(0);

var $db8df549b0911694$var$STRICT = (parcelRequire("QCNTE"))([].forEach, true);
$eqgBB($eqgBB.P + $eqgBB.F * !$db8df549b0911694$var$STRICT, 'Array', {
    // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
    forEach: function forEach(callbackfn /* , thisArg */ ) {
        return $db8df549b0911694$var$$forEach(this, callbackfn, arguments[1]);
    }
});


'use strict';

var $eqgBB = parcelRequire("eqgBB");

var $9a623557d702dc68$var$$map = (parcelRequire("2ikiy"))(1);

$eqgBB($eqgBB.P + $eqgBB.F * !(parcelRequire("QCNTE"))([].map, true), 'Array', {
    // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
    map: function map(callbackfn /* , thisArg */ ) {
        return $9a623557d702dc68$var$$map(this, callbackfn, arguments[1]);
    }
});


'use strict';

var $eqgBB = parcelRequire("eqgBB");

var $429faa8bed702fe8$var$$filter = (parcelRequire("2ikiy"))(2);

$eqgBB($eqgBB.P + $eqgBB.F * !(parcelRequire("QCNTE"))([].filter, true), 'Array', {
    // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
    filter: function filter(callbackfn /* , thisArg */ ) {
        return $429faa8bed702fe8$var$$filter(this, callbackfn, arguments[1]);
    }
});


'use strict';

var $eqgBB = parcelRequire("eqgBB");

var $a460730e5a14ca1b$var$$some = (parcelRequire("2ikiy"))(3);

$eqgBB($eqgBB.P + $eqgBB.F * !(parcelRequire("QCNTE"))([].some, true), 'Array', {
    // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
    some: function some(callbackfn /* , thisArg */ ) {
        return $a460730e5a14ca1b$var$$some(this, callbackfn, arguments[1]);
    }
});


'use strict';

var $eqgBB = parcelRequire("eqgBB");

var $6644cab2e47835a2$var$$every = (parcelRequire("2ikiy"))(4);

$eqgBB($eqgBB.P + $eqgBB.F * !(parcelRequire("QCNTE"))([].every, true), 'Array', {
    // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
    every: function every(callbackfn /* , thisArg */ ) {
        return $6644cab2e47835a2$var$$every(this, callbackfn, arguments[1]);
    }
});


'use strict';

var $eqgBB = parcelRequire("eqgBB");
var $3d7eeba18ec14394$exports = {};

var $4VmiN = parcelRequire("4VmiN");

var $j50QJ = parcelRequire("j50QJ");

var $9DkTL = parcelRequire("9DkTL");

var $jsF4z = parcelRequire("jsF4z");
$3d7eeba18ec14394$exports = function(that, callbackfn, aLen, memo, isRight) {
    $4VmiN(callbackfn);
    var O = $j50QJ(that);
    var self = $9DkTL(O);
    var length = $jsF4z(O.length);
    var index = isRight ? length - 1 : 0;
    var i = isRight ? -1 : 1;
    if (aLen < 2) for(;;){
        if (index in self) {
            memo = self[index];
            index += i;
            break;
        }
        index += i;
        if (isRight ? index < 0 : length <= index) throw TypeError('Reduce of empty array with no initial value');
    }
    for(; isRight ? index >= 0 : length > index; index += i)if (index in self) memo = callbackfn(memo, self[index], index, O);
    return memo;
};



$eqgBB($eqgBB.P + $eqgBB.F * !(parcelRequire("QCNTE"))([].reduce, true), 'Array', {
    // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        return $3d7eeba18ec14394$exports(this, callbackfn, arguments.length, arguments[1], false);
    }
});


'use strict';

var $eqgBB = parcelRequire("eqgBB");


$eqgBB($eqgBB.P + $eqgBB.F * !(parcelRequire("QCNTE"))([].reduceRight, true), 'Array', {
    // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
    reduceRight: function reduceRight(callbackfn /* , initialValue */ ) {
        return $3d7eeba18ec14394$exports(this, callbackfn, arguments.length, arguments[1], true);
    }
});


'use strict';

var $eqgBB = parcelRequire("eqgBB");

var $3d33bba205d85d81$var$$indexOf = (parcelRequire("hKLZ1"))(false);
var $3d33bba205d85d81$var$$native = [].indexOf;
var $3d33bba205d85d81$var$NEGATIVE_ZERO = !!$3d33bba205d85d81$var$$native && 1 / [
    1
].indexOf(1, -0) < 0;

$eqgBB($eqgBB.P + $eqgBB.F * ($3d33bba205d85d81$var$NEGATIVE_ZERO || !(parcelRequire("QCNTE"))($3d33bba205d85d81$var$$native)), 'Array', {
    // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
    indexOf: function indexOf(searchElement /* , fromIndex = 0 */ ) {
        return $3d33bba205d85d81$var$NEGATIVE_ZERO ? $3d33bba205d85d81$var$$native.apply(this, arguments) || 0 : $3d33bba205d85d81$var$$indexOf(this, searchElement, arguments[1]);
    }
});


'use strict';

var $eqgBB = parcelRequire("eqgBB");

var $15QDc = parcelRequire("15QDc");

var $dAqin = parcelRequire("dAqin");

var $jsF4z = parcelRequire("jsF4z");
var $b8fe0a188b7a8398$var$$native = [].lastIndexOf;
var $b8fe0a188b7a8398$var$NEGATIVE_ZERO = !!$b8fe0a188b7a8398$var$$native && 1 / [
    1
].lastIndexOf(1, -0) < 0;

$eqgBB($eqgBB.P + $eqgBB.F * ($b8fe0a188b7a8398$var$NEGATIVE_ZERO || !(parcelRequire("QCNTE"))($b8fe0a188b7a8398$var$$native)), 'Array', {
    // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */ ) {
        // convert -0 to +0
        if ($b8fe0a188b7a8398$var$NEGATIVE_ZERO) return $b8fe0a188b7a8398$var$$native.apply(this, arguments) || 0;
        var O = $15QDc(this);
        var length = $jsF4z(O.length);
        var index = length - 1;
        if (arguments.length > 1) index = Math.min(index, $dAqin(arguments[1]));
        if (index < 0) index = length + index;
        for(; index >= 0; index--)if (index in O) {
            if (O[index] === searchElement) return index || 0;
        }
        return -1;
    }
});


// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var $eqgBB = parcelRequire("eqgBB");

$eqgBB($eqgBB.P, 'Array', {
    copyWithin: (parcelRequire("1sqkh"))
});

(parcelRequire("e0GHn"))('copyWithin');


// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var $eqgBB = parcelRequire("eqgBB");

$eqgBB($eqgBB.P, 'Array', {
    fill: (parcelRequire("7iF8D"))
});

(parcelRequire("e0GHn"))('fill');


'use strict';

var $eqgBB = parcelRequire("eqgBB");

var $78d11b7860feb273$var$$find = (parcelRequire("2ikiy"))(5);
var $78d11b7860feb273$var$KEY = 'find';
var $78d11b7860feb273$var$forced = true;
// Shouldn't skip holes
if ($78d11b7860feb273$var$KEY in []) Array(1)[$78d11b7860feb273$var$KEY](function() {
    $78d11b7860feb273$var$forced = false;
});
$eqgBB($eqgBB.P + $eqgBB.F * $78d11b7860feb273$var$forced, 'Array', {
    find: function find(callbackfn /* , that = undefined */ ) {
        return $78d11b7860feb273$var$$find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});

(parcelRequire("e0GHn"))($78d11b7860feb273$var$KEY);


'use strict';

var $eqgBB = parcelRequire("eqgBB");

var $5d4be5e974bcc0c8$var$$find = (parcelRequire("2ikiy"))(6);
var $5d4be5e974bcc0c8$var$KEY = 'findIndex';
var $5d4be5e974bcc0c8$var$forced = true;
// Shouldn't skip holes
if ($5d4be5e974bcc0c8$var$KEY in []) Array(1)[$5d4be5e974bcc0c8$var$KEY](function() {
    $5d4be5e974bcc0c8$var$forced = false;
});
$eqgBB($eqgBB.P + $eqgBB.F * $5d4be5e974bcc0c8$var$forced, 'Array', {
    findIndex: function findIndex(callbackfn /* , that = undefined */ ) {
        return $5d4be5e974bcc0c8$var$$find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});

(parcelRequire("e0GHn"))($5d4be5e974bcc0c8$var$KEY);



(parcelRequire("4kzAJ"))('Array');


parcelRequire("5Mf7C");

var $1YuiL = parcelRequire("1YuiL");

var $gozGd = parcelRequire("gozGd");

var $lWhMZ = parcelRequire("lWhMZ");
var $6b04ff3f8e09f01c$require$dP = $lWhMZ.f;

var $ivFzP = parcelRequire("ivFzP");
var $6b04ff3f8e09f01c$require$gOPN = $ivFzP.f;


var $gL7EQ = parcelRequire("gL7EQ");
var $6b04ff3f8e09f01c$var$$RegExp = $1YuiL.RegExp;
var $6b04ff3f8e09f01c$var$Base = $6b04ff3f8e09f01c$var$$RegExp;
var $6b04ff3f8e09f01c$var$proto = $6b04ff3f8e09f01c$var$$RegExp.prototype;
var $6b04ff3f8e09f01c$var$re1 = /a/g;
var $6b04ff3f8e09f01c$var$re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var $6b04ff3f8e09f01c$var$CORRECT_NEW = new $6b04ff3f8e09f01c$var$$RegExp($6b04ff3f8e09f01c$var$re1) !== $6b04ff3f8e09f01c$var$re1;



var $buDDQ = parcelRequire("buDDQ");

if ((parcelRequire("gvOoh")) && (!$6b04ff3f8e09f01c$var$CORRECT_NEW || (parcelRequire("bjnTD"))(function() {
    $6b04ff3f8e09f01c$var$re2[$buDDQ('match')] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    return $6b04ff3f8e09f01c$var$$RegExp($6b04ff3f8e09f01c$var$re1) != $6b04ff3f8e09f01c$var$re1 || $6b04ff3f8e09f01c$var$$RegExp($6b04ff3f8e09f01c$var$re2) == $6b04ff3f8e09f01c$var$re2 || $6b04ff3f8e09f01c$var$$RegExp($6b04ff3f8e09f01c$var$re1, 'i') != '/a/i';
}))) {
    $6b04ff3f8e09f01c$var$$RegExp = function RegExp(p, f) {
        var tiRE = this instanceof $6b04ff3f8e09f01c$var$$RegExp;
        var piRE = $4a865ed90b3243fb$exports(p);
        var fiU = f === undefined;
        return !tiRE && piRE && p.constructor === $6b04ff3f8e09f01c$var$$RegExp && fiU ? p : $gozGd($6b04ff3f8e09f01c$var$CORRECT_NEW ? new $6b04ff3f8e09f01c$var$Base(piRE && !fiU ? p.source : p, f) : $6b04ff3f8e09f01c$var$Base((piRE = p instanceof $6b04ff3f8e09f01c$var$$RegExp) ? p.source : p, piRE && fiU ? $gL7EQ.call(p) : f), tiRE ? this : $6b04ff3f8e09f01c$var$proto, $6b04ff3f8e09f01c$var$$RegExp);
    };
    var $6b04ff3f8e09f01c$var$proxy = function(key) {
        key in $6b04ff3f8e09f01c$var$$RegExp || $6b04ff3f8e09f01c$require$dP($6b04ff3f8e09f01c$var$$RegExp, key, {
            configurable: true,
            get: function() {
                return $6b04ff3f8e09f01c$var$Base[key];
            },
            set: function(it) {
                $6b04ff3f8e09f01c$var$Base[key] = it;
            }
        });
    };
    for(var $6b04ff3f8e09f01c$var$keys = $6b04ff3f8e09f01c$require$gOPN($6b04ff3f8e09f01c$var$Base), $6b04ff3f8e09f01c$var$i = 0; $6b04ff3f8e09f01c$var$keys.length > $6b04ff3f8e09f01c$var$i;)$6b04ff3f8e09f01c$var$proxy($6b04ff3f8e09f01c$var$keys[$6b04ff3f8e09f01c$var$i++]);
    $6b04ff3f8e09f01c$var$proto.constructor = $6b04ff3f8e09f01c$var$$RegExp;
    $6b04ff3f8e09f01c$var$$RegExp.prototype = $6b04ff3f8e09f01c$var$proto;
    (parcelRequire("2D2fi"))($1YuiL, 'RegExp', $6b04ff3f8e09f01c$var$$RegExp);
}

(parcelRequire("4kzAJ"))('RegExp');


parcelRequire("j7wg2");
'use strict';
// 21.2.5.3 get RegExp.prototype.flags()



if ((parcelRequire("gvOoh")) && /./g.flags != 'g') (parcelRequire("lWhMZ")).f(RegExp.prototype, 'flags', {
    configurable: true,
    get: (parcelRequire("gL7EQ"))
});



var $6K5GG = parcelRequire("6K5GG");

var $gL7EQ = parcelRequire("gL7EQ");

var $gvOoh = parcelRequire("gvOoh");
var $ffafc84e2d376f8e$var$TO_STRING = 'toString';
var $ffafc84e2d376f8e$var$$toString = /./[$ffafc84e2d376f8e$var$TO_STRING];

var $ffafc84e2d376f8e$var$define = function(fn) {
    (parcelRequire("2D2fi"))(RegExp.prototype, $ffafc84e2d376f8e$var$TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if ((parcelRequire("bjnTD"))(function() {
    return $ffafc84e2d376f8e$var$$toString.call({
        source: 'a',
        flags: 'b'
    }) != '/a/b';
})) $ffafc84e2d376f8e$var$define(function toString() {
    var R = $6K5GG(this);
    return '/'.concat(R.source, '/', 'flags' in R ? R.flags : !$gvOoh && R instanceof RegExp ? $gL7EQ.call(R) : undefined);
});
else if ($ffafc84e2d376f8e$var$$toString.name != $ffafc84e2d376f8e$var$TO_STRING) $ffafc84e2d376f8e$var$define(function toString() {
    return $ffafc84e2d376f8e$var$$toString.call(this);
});



'use strict';

var $6K5GG = parcelRequire("6K5GG");

var $jsF4z = parcelRequire("jsF4z");
var $041088095df660a5$exports = {};
'use strict';

var $041088095df660a5$var$at = (parcelRequire("2B3HC"))(true);
// `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
$041088095df660a5$exports = function(S, index, unicode) {
    return index + (unicode ? $041088095df660a5$var$at(S, index).length : 1);
};


var $f1c9e1022ff96677$exports = {};
'use strict';

var $47rfI = parcelRequire("47rfI");
var $f1c9e1022ff96677$var$builtinExec = RegExp.prototype.exec;
// `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
$f1c9e1022ff96677$exports = function(R, S) {
    var exec = R.exec;
    if (typeof exec === 'function') {
        var result = exec.call(R, S);
        if (typeof result !== 'object') throw new TypeError('RegExp exec method returned something other than an Object or null');
        return result;
    }
    if ($47rfI(R) !== 'RegExp') throw new TypeError('RegExp#exec called on incompatible receiver');
    return $f1c9e1022ff96677$var$builtinExec.call(R, S);
};



// @@match logic
(parcelRequire("ioyf6"))('match', 1, function(defined, MATCH, $match, maybeCallNative) {
    return [
        // `String.prototype.match` method
        // https://tc39.github.io/ecma262/#sec-string.prototype.match
        function match(regexp) {
            var O = defined(this);
            var fn = regexp == undefined ? undefined : regexp[MATCH];
            return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
        },
        // `RegExp.prototype[@@match]` method
        // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
        function(regexp) {
            var res = maybeCallNative($match, regexp, this);
            if (res.done) return res.value;
            var rx = $6K5GG(regexp);
            var S = String(this);
            if (!rx.global) return $f1c9e1022ff96677$exports(rx, S);
            var fullUnicode = rx.unicode;
            rx.lastIndex = 0;
            var A = [];
            var n = 0;
            var result;
            while((result = $f1c9e1022ff96677$exports(rx, S)) !== null){
                var matchStr = String(result[0]);
                A[n] = matchStr;
                if (matchStr === '') rx.lastIndex = $041088095df660a5$exports(S, $jsF4z(rx.lastIndex), fullUnicode);
                n++;
            }
            return n === 0 ? null : A;
        }
    ];
});


'use strict';

var $6K5GG = parcelRequire("6K5GG");

var $j50QJ = parcelRequire("j50QJ");

var $jsF4z = parcelRequire("jsF4z");

var $dAqin = parcelRequire("dAqin");


var $d46608a26ae12395$var$max = Math.max;
var $d46608a26ae12395$var$min = Math.min;
var $d46608a26ae12395$var$floor = Math.floor;
var $d46608a26ae12395$var$SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var $d46608a26ae12395$var$SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;
var $d46608a26ae12395$var$maybeToString = function(it) {
    return it === undefined ? it : String(it);
};

// @@replace logic
(parcelRequire("ioyf6"))('replace', 2, function(defined, REPLACE, $replace, maybeCallNative) {
    return [
        // `String.prototype.replace` method
        // https://tc39.github.io/ecma262/#sec-string.prototype.replace
        function replace(searchValue, replaceValue) {
            var O = defined(this);
            var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
            return fn !== undefined ? fn.call(searchValue, O, replaceValue) : $replace.call(String(O), searchValue, replaceValue);
        },
        // `RegExp.prototype[@@replace]` method
        // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
        function(regexp, replaceValue) {
            var res = maybeCallNative($replace, regexp, this, replaceValue);
            if (res.done) return res.value;
            var rx = $6K5GG(regexp);
            var S = String(this);
            var functionalReplace = typeof replaceValue === 'function';
            if (!functionalReplace) replaceValue = String(replaceValue);
            var global = rx.global;
            if (global) {
                var fullUnicode = rx.unicode;
                rx.lastIndex = 0;
            }
            var results = [];
            while(true){
                var result = $f1c9e1022ff96677$exports(rx, S);
                if (result === null) break;
                results.push(result);
                if (!global) break;
                var matchStr = String(result[0]);
                if (matchStr === '') rx.lastIndex = $041088095df660a5$exports(S, $jsF4z(rx.lastIndex), fullUnicode);
            }
            var accumulatedResult = '';
            var nextSourcePosition = 0;
            for(var i = 0; i < results.length; i++){
                result = results[i];
                var matched = String(result[0]);
                var position = $d46608a26ae12395$var$max($d46608a26ae12395$var$min($dAqin(result.index), S.length), 0);
                var captures = [];
                // NOTE: This is equivalent to
                //   captures = result.slice(1).map(maybeToString)
                // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
                // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
                // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
                for(var j = 1; j < result.length; j++)captures.push($d46608a26ae12395$var$maybeToString(result[j]));
                var namedCaptures = result.groups;
                if (functionalReplace) {
                    var replacerArgs = [
                        matched
                    ].concat(captures, position, S);
                    if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
                    var replacement = String(replaceValue.apply(undefined, replacerArgs));
                } else replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
                if (position >= nextSourcePosition) {
                    accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
                    nextSourcePosition = position + matched.length;
                }
            }
            return accumulatedResult + S.slice(nextSourcePosition);
        }
    ];
    // https://tc39.github.io/ecma262/#sec-getsubstitution
    function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
        var tailPos = position + matched.length;
        var m = captures.length;
        var symbols = $d46608a26ae12395$var$SUBSTITUTION_SYMBOLS_NO_NAMED;
        if (namedCaptures !== undefined) {
            namedCaptures = $j50QJ(namedCaptures);
            symbols = $d46608a26ae12395$var$SUBSTITUTION_SYMBOLS;
        }
        return $replace.call(replacement, symbols, function(match, ch) {
            var capture;
            switch(ch.charAt(0)){
                case '$':
                    return '$';
                case '&':
                    return matched;
                case '`':
                    return str.slice(0, position);
                case "'":
                    return str.slice(tailPos);
                case '<':
                    capture = namedCaptures[ch.slice(1, -1)];
                    break;
                default:
                    var n = +ch;
                    if (n === 0) return match;
                    if (n > m) {
                        var f = $d46608a26ae12395$var$floor(n / 10);
                        if (f === 0) return match;
                        if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
                        return match;
                    }
                    capture = captures[n - 1];
            }
            return capture === undefined ? '' : capture;
        });
    }
});


'use strict';

var $6K5GG = parcelRequire("6K5GG");

var $lnyGt = parcelRequire("lnyGt");


// @@search logic
(parcelRequire("ioyf6"))('search', 1, function(defined, SEARCH, $search, maybeCallNative) {
    return [
        // `String.prototype.search` method
        // https://tc39.github.io/ecma262/#sec-string.prototype.search
        function search(regexp) {
            var O = defined(this);
            var fn = regexp == undefined ? undefined : regexp[SEARCH];
            return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
        },
        // `RegExp.prototype[@@search]` method
        // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
        function(regexp) {
            var res = maybeCallNative($search, regexp, this);
            if (res.done) return res.value;
            var rx = $6K5GG(regexp);
            var S = String(this);
            var previousLastIndex = rx.lastIndex;
            if (!$lnyGt(previousLastIndex, 0)) rx.lastIndex = 0;
            var result = $f1c9e1022ff96677$exports(rx, S);
            if (!$lnyGt(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
            return result === null ? -1 : result.index;
        }
    ];
});


'use strict';


var $6K5GG = parcelRequire("6K5GG");

var $hHXyM = parcelRequire("hHXyM");


var $jsF4z = parcelRequire("jsF4z");


var $krJ8T = parcelRequire("krJ8T");

var $bjnTD = parcelRequire("bjnTD");
var $6f82faaaba892e91$var$$min = Math.min;
var $6f82faaaba892e91$var$$push = [].push;
var $6f82faaaba892e91$var$$SPLIT = 'split';
var $6f82faaaba892e91$var$LENGTH = 'length';
var $6f82faaaba892e91$var$LAST_INDEX = 'lastIndex';
var $6f82faaaba892e91$var$MAX_UINT32 = 0xffffffff;
// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var $6f82faaaba892e91$var$SUPPORTS_Y = !$bjnTD(function() {
    RegExp($6f82faaaba892e91$var$MAX_UINT32, 'y');
});

// @@split logic
(parcelRequire("ioyf6"))('split', 2, function(defined, SPLIT, $split, maybeCallNative) {
    var internalSplit;
    if ('abbc'[$6f82faaaba892e91$var$$SPLIT](/(b)*/)[1] == 'c' || 'test'[$6f82faaaba892e91$var$$SPLIT](/(?:)/, -1)[$6f82faaaba892e91$var$LENGTH] != 4 || 'ab'[$6f82faaaba892e91$var$$SPLIT](/(?:ab)*/)[$6f82faaaba892e91$var$LENGTH] != 2 || '.'[$6f82faaaba892e91$var$$SPLIT](/(.?)(.?)/)[$6f82faaaba892e91$var$LENGTH] != 4 || '.'[$6f82faaaba892e91$var$$SPLIT](/()()/)[$6f82faaaba892e91$var$LENGTH] > 1 || ''[$6f82faaaba892e91$var$$SPLIT](/.?/)[$6f82faaaba892e91$var$LENGTH]) // based on es5-shim implementation, need to rework it
    internalSplit = function(separator, limit) {
        var string = String(this);
        if (separator === undefined && limit === 0) return [];
        // If `separator` is not a regex, use native split
        if (!$4a865ed90b3243fb$exports(separator)) return $split.call(string, separator, limit);
        var output = [];
        var flags = (separator.ignoreCase ? 'i' : '') + (separator.multiline ? 'm' : '') + (separator.unicode ? 'u' : '') + (separator.sticky ? 'y' : '');
        var lastLastIndex = 0;
        var splitLimit = limit === undefined ? $6f82faaaba892e91$var$MAX_UINT32 : limit >>> 0;
        // Make `global` and avoid `lastIndex` issues by working with a copy
        var separatorCopy = new RegExp(separator.source, flags + 'g');
        var match, lastIndex, lastLength;
        while(match = $krJ8T.call(separatorCopy, string)){
            lastIndex = separatorCopy[$6f82faaaba892e91$var$LAST_INDEX];
            if (lastIndex > lastLastIndex) {
                output.push(string.slice(lastLastIndex, match.index));
                if (match[$6f82faaaba892e91$var$LENGTH] > 1 && match.index < string[$6f82faaaba892e91$var$LENGTH]) $6f82faaaba892e91$var$$push.apply(output, match.slice(1));
                lastLength = match[0][$6f82faaaba892e91$var$LENGTH];
                lastLastIndex = lastIndex;
                if (output[$6f82faaaba892e91$var$LENGTH] >= splitLimit) break;
            }
            if (separatorCopy[$6f82faaaba892e91$var$LAST_INDEX] === match.index) separatorCopy[$6f82faaaba892e91$var$LAST_INDEX]++; // Avoid an infinite loop
        }
        if (lastLastIndex === string[$6f82faaaba892e91$var$LENGTH]) {
            if (lastLength || !separatorCopy.test('')) output.push('');
        } else output.push(string.slice(lastLastIndex));
        return output[$6f82faaaba892e91$var$LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
    else if ('0'[$6f82faaaba892e91$var$$SPLIT](undefined, 0)[$6f82faaaba892e91$var$LENGTH]) internalSplit = function(separator, limit) {
        return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
    else internalSplit = $split;
    return [
        // `String.prototype.split` method
        // https://tc39.github.io/ecma262/#sec-string.prototype.split
        function split(separator, limit) {
            var O = defined(this);
            var splitter = separator == undefined ? undefined : separator[SPLIT];
            return splitter !== undefined ? splitter.call(separator, O, limit) : internalSplit.call(String(O), separator, limit);
        },
        // `RegExp.prototype[@@split]` method
        // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
        //
        // NOTE: This cannot be properly polyfilled in engines that don't support
        // the 'y' flag.
        function(regexp, limit) {
            var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
            if (res.done) return res.value;
            var rx = $6K5GG(regexp);
            var S = String(this);
            var C = $hHXyM(rx, RegExp);
            var unicodeMatching = rx.unicode;
            var flags = (rx.ignoreCase ? 'i' : '') + (rx.multiline ? 'm' : '') + (rx.unicode ? 'u' : '') + ($6f82faaaba892e91$var$SUPPORTS_Y ? 'y' : 'g');
            // ^(? + rx + ) is needed, in combination with some S slicing, to
            // simulate the 'y' flag.
            var splitter = new C($6f82faaaba892e91$var$SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
            var lim = limit === undefined ? $6f82faaaba892e91$var$MAX_UINT32 : limit >>> 0;
            if (lim === 0) return [];
            if (S.length === 0) return $f1c9e1022ff96677$exports(splitter, S) === null ? [
                S
            ] : [];
            var p = 0;
            var q = 0;
            var A = [];
            while(q < S.length){
                splitter.lastIndex = $6f82faaaba892e91$var$SUPPORTS_Y ? q : 0;
                var z = $f1c9e1022ff96677$exports(splitter, $6f82faaaba892e91$var$SUPPORTS_Y ? S : S.slice(q));
                var e;
                if (z === null || (e = $6f82faaaba892e91$var$$min($jsF4z(splitter.lastIndex + ($6f82faaaba892e91$var$SUPPORTS_Y ? 0 : q)), S.length)) === p) q = $041088095df660a5$exports(S, q, unicodeMatching);
                else {
                    A.push(S.slice(p, q));
                    if (A.length === lim) return A;
                    for(var i = 1; i <= z.length - 1; i++){
                        A.push(z[i]);
                        if (A.length === lim) return A;
                    }
                    q = p = e;
                }
            }
            A.push(S.slice(p));
            return A;
        }
    ];
});


'use strict';

var $aNvO0 = parcelRequire("aNvO0");

var $1YuiL = parcelRequire("1YuiL");

var $8luNd = parcelRequire("8luNd");

var $47rfI = parcelRequire("47rfI");

var $eqgBB = parcelRequire("eqgBB");

var $h9IVq = parcelRequire("h9IVq");

var $4VmiN = parcelRequire("4VmiN");

var $gVepx = parcelRequire("gVepx");

var $gTqEb = parcelRequire("gTqEb");

var $hHXyM = parcelRequire("hHXyM");

var $7L6vC = parcelRequire("7L6vC");
var $a9dafd596a98064e$require$task = $7L6vC.set;

var $a9dafd596a98064e$var$microtask = (parcelRequire("hIctV"))();
var $c741f86c74d8d9bd$exports = {};

$parcel$export($c741f86c74d8d9bd$exports, "f", function () { return $c741f86c74d8d9bd$export$2d1720544b23b823; }, function (v) { return $c741f86c74d8d9bd$export$2d1720544b23b823 = v; });
var $c741f86c74d8d9bd$export$2d1720544b23b823;
'use strict';

var $4VmiN = parcelRequire("4VmiN");
function $c741f86c74d8d9bd$var$PromiseCapability(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $4VmiN(resolve);
    this.reject = $4VmiN(reject);
}
$c741f86c74d8d9bd$export$2d1720544b23b823 = function(C) {
    return new $c741f86c74d8d9bd$var$PromiseCapability(C);
};


var $57b97b333cb9e520$exports = {};
$57b97b333cb9e520$exports = function(exec) {
    try {
        return {
            e: false,
            v: exec()
        };
    } catch (e) {
        return {
            e: true,
            v: e
        };
    }
};


var $5fc7dd70c0876310$exports = {};

var $1YuiL = parcelRequire("1YuiL");
var $5fc7dd70c0876310$var$navigator = $1YuiL.navigator;
$5fc7dd70c0876310$exports = $5fc7dd70c0876310$var$navigator && $5fc7dd70c0876310$var$navigator.userAgent || '';


var $cac3b1e5c76cb914$exports = {};

var $6K5GG = parcelRequire("6K5GG");

var $h9IVq = parcelRequire("h9IVq");

$cac3b1e5c76cb914$exports = function(C, x) {
    $6K5GG(C);
    if ($h9IVq(x) && x.constructor === C) return x;
    var promiseCapability = $c741f86c74d8d9bd$export$2d1720544b23b823(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};


var $a9dafd596a98064e$var$PROMISE = 'Promise';
var $a9dafd596a98064e$var$TypeError = $1YuiL.TypeError;
var $a9dafd596a98064e$var$process = $1YuiL.process;
var $a9dafd596a98064e$var$versions = $a9dafd596a98064e$var$process && $a9dafd596a98064e$var$process.versions;
var $a9dafd596a98064e$var$v8 = $a9dafd596a98064e$var$versions && $a9dafd596a98064e$var$versions.v8 || '';
var $a9dafd596a98064e$var$$Promise = $1YuiL[$a9dafd596a98064e$var$PROMISE];
var $a9dafd596a98064e$var$isNode = $47rfI($a9dafd596a98064e$var$process) == 'process';
var $a9dafd596a98064e$var$empty = function() {};
var $a9dafd596a98064e$var$Internal, $a9dafd596a98064e$var$newGenericPromiseCapability, $a9dafd596a98064e$var$OwnPromiseCapability, $a9dafd596a98064e$var$Wrapper;
var $a9dafd596a98064e$var$newPromiseCapability = $a9dafd596a98064e$var$newGenericPromiseCapability = $c741f86c74d8d9bd$export$2d1720544b23b823;

var $a9dafd596a98064e$var$USE_NATIVE = !!function() {
    try {
        // correct subclassing with @@species support
        var promise = $a9dafd596a98064e$var$$Promise.resolve(1);
        var FakePromise = (promise.constructor = {})[(parcelRequire("buDDQ"))('species')] = function(exec) {
            exec($a9dafd596a98064e$var$empty, $a9dafd596a98064e$var$empty);
        };
        // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
        return ($a9dafd596a98064e$var$isNode || typeof PromiseRejectionEvent == 'function') && promise.then($a9dafd596a98064e$var$empty) instanceof FakePromise && $a9dafd596a98064e$var$v8.indexOf('6.6') !== 0 && $5fc7dd70c0876310$exports.indexOf('Chrome/66') === -1;
    } catch (e) {}
}();
// helpers
var $a9dafd596a98064e$var$isThenable = function(it) {
    var then;
    return $h9IVq(it) && typeof (then = it.then) == 'function' ? then : false;
};
var $a9dafd596a98064e$var$notify = function(promise, isReject) {
    if (promise._n) return;
    promise._n = true;
    var chain = promise._c;
    $a9dafd596a98064e$var$microtask(function() {
        var value = promise._v;
        var ok = promise._s == 1;
        var i = 0;
        var run = function(reaction) {
            var handler = ok ? reaction.ok : reaction.fail;
            var resolve = reaction.resolve;
            var reject = reaction.reject;
            var domain = reaction.domain;
            var result, then, exited;
            try {
                if (handler) {
                    if (!ok) {
                        if (promise._h == 2) $a9dafd596a98064e$var$onHandleUnhandled(promise);
                        promise._h = 1;
                    }
                    if (handler === true) result = value;
                    else {
                        if (domain) domain.enter();
                        result = handler(value); // may throw
                        if (domain) {
                            domain.exit();
                            exited = true;
                        }
                    }
                    if (result === reaction.promise) reject($a9dafd596a98064e$var$TypeError('Promise-chain cycle'));
                    else if (then = $a9dafd596a98064e$var$isThenable(result)) then.call(result, resolve, reject);
                    else resolve(result);
                } else reject(value);
            } catch (e) {
                if (domain && !exited) domain.exit();
                reject(e);
            }
        };
        while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
        promise._c = [];
        promise._n = false;
        if (isReject && !promise._h) $a9dafd596a98064e$var$onUnhandled(promise);
    });
};
var $a9dafd596a98064e$var$onUnhandled = function(promise) {
    $a9dafd596a98064e$require$task.call($1YuiL, function() {
        var value = promise._v;
        var unhandled = $a9dafd596a98064e$var$isUnhandled(promise);
        var result, handler, console;
        if (unhandled) {
            result = $57b97b333cb9e520$exports(function() {
                if ($a9dafd596a98064e$var$isNode) $a9dafd596a98064e$var$process.emit('unhandledRejection', value, promise);
                else if (handler = $1YuiL.onunhandledrejection) handler({
                    promise: promise,
                    reason: value
                });
                else if ((console = $1YuiL.console) && console.error) console.error('Unhandled promise rejection', value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            promise._h = $a9dafd596a98064e$var$isNode || $a9dafd596a98064e$var$isUnhandled(promise) ? 2 : 1;
        }
        promise._a = undefined;
        if (unhandled && result.e) throw result.v;
    });
};
var $a9dafd596a98064e$var$isUnhandled = function(promise) {
    return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var $a9dafd596a98064e$var$onHandleUnhandled = function(promise) {
    $a9dafd596a98064e$require$task.call($1YuiL, function() {
        var handler;
        if ($a9dafd596a98064e$var$isNode) $a9dafd596a98064e$var$process.emit('rejectionHandled', promise);
        else if (handler = $1YuiL.onrejectionhandled) handler({
            promise: promise,
            reason: promise._v
        });
    });
};
var $a9dafd596a98064e$var$$reject = function(value) {
    var promise = this;
    if (promise._d) return;
    promise._d = true;
    promise = promise._w || promise; // unwrap
    promise._v = value;
    promise._s = 2;
    if (!promise._a) promise._a = promise._c.slice();
    $a9dafd596a98064e$var$notify(promise, true);
};
var $a9dafd596a98064e$var$$resolve = function(value) {
    var promise = this;
    var then;
    if (promise._d) return;
    promise._d = true;
    promise = promise._w || promise; // unwrap
    try {
        if (promise === value) throw $a9dafd596a98064e$var$TypeError("Promise can't be resolved itself");
        if (then = $a9dafd596a98064e$var$isThenable(value)) $a9dafd596a98064e$var$microtask(function() {
            var wrapper = {
                _w: promise,
                _d: false
            }; // wrap
            try {
                then.call(value, $8luNd($a9dafd596a98064e$var$$resolve, wrapper, 1), $8luNd($a9dafd596a98064e$var$$reject, wrapper, 1));
            } catch (e) {
                $a9dafd596a98064e$var$$reject.call(wrapper, e);
            }
        });
        else {
            promise._v = value;
            promise._s = 1;
            $a9dafd596a98064e$var$notify(promise, false);
        }
    } catch (e) {
        $a9dafd596a98064e$var$$reject.call({
            _w: promise,
            _d: false
        }, e); // wrap
    }
};

// constructor polyfill
if (!$a9dafd596a98064e$var$USE_NATIVE) {
    // 25.4.3.1 Promise(executor)
    $a9dafd596a98064e$var$$Promise = function Promise(executor) {
        $gVepx(this, $a9dafd596a98064e$var$$Promise, $a9dafd596a98064e$var$PROMISE, '_h');
        $4VmiN(executor);
        $a9dafd596a98064e$var$Internal.call(this);
        try {
            executor($8luNd($a9dafd596a98064e$var$$resolve, this, 1), $8luNd($a9dafd596a98064e$var$$reject, this, 1));
        } catch (err) {
            $a9dafd596a98064e$var$$reject.call(this, err);
        }
    };
    // eslint-disable-next-line no-unused-vars
    $a9dafd596a98064e$var$Internal = function Promise(executor) {
        this._c = []; // <- awaiting reactions
        this._a = undefined; // <- checked in isUnhandled reactions
        this._s = 0; // <- state
        this._d = false; // <- done
        this._v = undefined; // <- value
        this._h = 0; // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
        this._n = false; // <- notify
    };
    $a9dafd596a98064e$var$Internal.prototype = (parcelRequire("1YB50"))($a9dafd596a98064e$var$$Promise.prototype, {
        // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
        then: function then(onFulfilled, onRejected) {
            var reaction = $a9dafd596a98064e$var$newPromiseCapability($hHXyM(this, $a9dafd596a98064e$var$$Promise));
            reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
            reaction.fail = typeof onRejected == 'function' && onRejected;
            reaction.domain = $a9dafd596a98064e$var$isNode ? $a9dafd596a98064e$var$process.domain : undefined;
            this._c.push(reaction);
            if (this._a) this._a.push(reaction);
            if (this._s) $a9dafd596a98064e$var$notify(this, false);
            return reaction.promise;
        },
        // 25.4.5.1 Promise.prototype.catch(onRejected)
        'catch': function(onRejected) {
            return this.then(undefined, onRejected);
        }
    });
    $a9dafd596a98064e$var$OwnPromiseCapability = function() {
        var promise = new $a9dafd596a98064e$var$Internal();
        this.promise = promise;
        this.resolve = $8luNd($a9dafd596a98064e$var$$resolve, promise, 1);
        this.reject = $8luNd($a9dafd596a98064e$var$$reject, promise, 1);
    };
    $c741f86c74d8d9bd$exports.f = $a9dafd596a98064e$var$newPromiseCapability = function(C) {
        return C === $a9dafd596a98064e$var$$Promise || C === $a9dafd596a98064e$var$Wrapper ? new $a9dafd596a98064e$var$OwnPromiseCapability(C) : $a9dafd596a98064e$var$newGenericPromiseCapability(C);
    };
}
$eqgBB($eqgBB.G + $eqgBB.W + $eqgBB.F * !$a9dafd596a98064e$var$USE_NATIVE, {
    Promise: $a9dafd596a98064e$var$$Promise
});

(parcelRequire("k40lc"))($a9dafd596a98064e$var$$Promise, $a9dafd596a98064e$var$PROMISE);

(parcelRequire("4kzAJ"))($a9dafd596a98064e$var$PROMISE);

$a9dafd596a98064e$var$Wrapper = (parcelRequire("ejAKF"))[$a9dafd596a98064e$var$PROMISE];
// statics
$eqgBB($eqgBB.S + $eqgBB.F * !$a9dafd596a98064e$var$USE_NATIVE, $a9dafd596a98064e$var$PROMISE, {
    // 25.4.4.5 Promise.reject(r)
    reject: function reject(r) {
        var capability = $a9dafd596a98064e$var$newPromiseCapability(this);
        var $$reject = capability.reject;
        $$reject(r);
        return capability.promise;
    }
});
$eqgBB($eqgBB.S + $eqgBB.F * ($aNvO0 || !$a9dafd596a98064e$var$USE_NATIVE), $a9dafd596a98064e$var$PROMISE, {
    // 25.4.4.6 Promise.resolve(x)
    resolve: function resolve(x) {
        return $cac3b1e5c76cb914$exports($aNvO0 && this === $a9dafd596a98064e$var$Wrapper ? $a9dafd596a98064e$var$$Promise : this, x);
    }
});

$eqgBB($eqgBB.S + $eqgBB.F * !($a9dafd596a98064e$var$USE_NATIVE && (parcelRequire("5QSWt"))(function(iter) {
    $a9dafd596a98064e$var$$Promise.all(iter)['catch']($a9dafd596a98064e$var$empty);
})), $a9dafd596a98064e$var$PROMISE, {
    // 25.4.4.1 Promise.all(iterable)
    all: function all(iterable) {
        var C = this;
        var capability = $a9dafd596a98064e$var$newPromiseCapability(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $57b97b333cb9e520$exports(function() {
            var values = [];
            var index = 0;
            var remaining = 1;
            $gTqEb(iterable, false, function(promise) {
                var $index = index++;
                var alreadyCalled = false;
                values.push(undefined);
                remaining++;
                C.resolve(promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[$index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.e) reject(result.v);
        return capability.promise;
    },
    // 25.4.4.4 Promise.race(iterable)
    race: function race(iterable) {
        var C = this;
        var capability = $a9dafd596a98064e$var$newPromiseCapability(C);
        var reject = capability.reject;
        var result = $57b97b333cb9e520$exports(function() {
            $gTqEb(iterable, false, function(promise) {
                C.resolve(promise).then(capability.resolve, reject);
            });
        });
        if (result.e) reject(result.v);
        return capability.promise;
    }
});


var $c21b606cf3ce5039$exports = {};
'use strict';
var $87f09d956304d838$exports = {};
'use strict';

var $lWhMZ = parcelRequire("lWhMZ");
var $87f09d956304d838$require$dP = $lWhMZ.f;

var $16E7l = parcelRequire("16E7l");

var $1YB50 = parcelRequire("1YB50");

var $8luNd = parcelRequire("8luNd");

var $gVepx = parcelRequire("gVepx");

var $gTqEb = parcelRequire("gTqEb");

var $eApyU = parcelRequire("eApyU");

var $1OttB = parcelRequire("1OttB");

var $4kzAJ = parcelRequire("4kzAJ");

var $gvOoh = parcelRequire("gvOoh");

var $86Fx8 = parcelRequire("86Fx8");
var $87f09d956304d838$require$fastKey = $86Fx8.fastKey;

var $6PJwo = parcelRequire("6PJwo");
var $87f09d956304d838$var$SIZE = $gvOoh ? '_s' : 'size';
var $87f09d956304d838$var$getEntry = function(that, key) {
    // fast case
    var index = $87f09d956304d838$require$fastKey(key);
    var entry;
    if (index !== 'F') return that._i[index];
    // frozen object case
    for(entry = that._f; entry; entry = entry.n){
        if (entry.k == key) return entry;
    }
};
$87f09d956304d838$exports = {
    getConstructor: function(wrapper, NAME, IS_MAP, ADDER) {
        var C = wrapper(function(that, iterable) {
            $gVepx(that, C, NAME, '_i');
            that._t = NAME; // collection type
            that._i = $16E7l(null); // index
            that._f = undefined; // first entry
            that._l = undefined; // last entry
            that[$87f09d956304d838$var$SIZE] = 0; // size
            if (iterable != undefined) $gTqEb(iterable, IS_MAP, that[ADDER], that);
        });
        $1YB50(C.prototype, {
            // 23.1.3.1 Map.prototype.clear()
            // 23.2.3.2 Set.prototype.clear()
            clear: function clear() {
                for(var that = $6PJwo(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n){
                    entry.r = true;
                    if (entry.p) entry.p = entry.p.n = undefined;
                    delete data[entry.i];
                }
                that._f = that._l = undefined;
                that[$87f09d956304d838$var$SIZE] = 0;
            },
            // 23.1.3.3 Map.prototype.delete(key)
            // 23.2.3.4 Set.prototype.delete(value)
            'delete': function(key) {
                var that = $6PJwo(this, NAME);
                var entry = $87f09d956304d838$var$getEntry(that, key);
                if (entry) {
                    var next = entry.n;
                    var prev = entry.p;
                    delete that._i[entry.i];
                    entry.r = true;
                    if (prev) prev.n = next;
                    if (next) next.p = prev;
                    if (that._f == entry) that._f = next;
                    if (that._l == entry) that._l = prev;
                    that[$87f09d956304d838$var$SIZE]--;
                }
                return !!entry;
            },
            // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
            // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
            forEach: function forEach(callbackfn /* , that = undefined */ ) {
                $6PJwo(this, NAME);
                var f = $8luNd(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
                var entry;
                while(entry = entry ? entry.n : this._f){
                    f(entry.v, entry.k, this);
                    // revert to the last existing entry
                    while(entry && entry.r)entry = entry.p;
                }
            },
            // 23.1.3.7 Map.prototype.has(key)
            // 23.2.3.7 Set.prototype.has(value)
            has: function has(key) {
                return !!$87f09d956304d838$var$getEntry($6PJwo(this, NAME), key);
            }
        });
        if ($gvOoh) $87f09d956304d838$require$dP(C.prototype, 'size', {
            get: function() {
                return $6PJwo(this, NAME)[$87f09d956304d838$var$SIZE];
            }
        });
        return C;
    },
    def: function(that, key, value) {
        var entry = $87f09d956304d838$var$getEntry(that, key);
        var prev, index;
        // change existing entry
        if (entry) entry.v = value;
        else {
            that._l = entry = {
                i: index = $87f09d956304d838$require$fastKey(key, true),
                k: key,
                v: value,
                p: prev = that._l,
                n: undefined,
                r: false // <- removed
            };
            if (!that._f) that._f = entry;
            if (prev) prev.n = entry;
            that[$87f09d956304d838$var$SIZE]++;
            // add to index
            if (index !== 'F') that._i[index] = entry;
        }
        return that;
    },
    getEntry: $87f09d956304d838$var$getEntry,
    setStrong: function(C, NAME, IS_MAP) {
        // add .keys, .values, .entries, [@@iterator]
        // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
        $eApyU(C, NAME, function(iterated, kind) {
            this._t = $6PJwo(iterated, NAME); // target
            this._k = kind; // kind
            this._l = undefined; // previous
        }, function() {
            var that = this;
            var kind = that._k;
            var entry = that._l;
            // revert to the last existing entry
            while(entry && entry.r)entry = entry.p;
            // get next entry
            if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
                // or finish the iteration
                that._t = undefined;
                return $1OttB(1);
            }
            // return step by kind
            if (kind == 'keys') return $1OttB(0, entry.k);
            if (kind == 'values') return $1OttB(0, entry.v);
            return $1OttB(0, [
                entry.k,
                entry.v
            ]);
        }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
        // add [@@species], 23.1.2.2, 23.2.2.2
        $4kzAJ(NAME);
    }
};



var $6PJwo = parcelRequire("6PJwo");
var $c21b606cf3ce5039$var$MAP = 'Map';

// 23.1 Map Objects
$c21b606cf3ce5039$exports = (parcelRequire("chbv3"))($c21b606cf3ce5039$var$MAP, function(get) {
    return function Map() {
        return get(this, arguments.length > 0 ? arguments[0] : undefined);
    };
}, {
    // 23.1.3.6 Map.prototype.get(key)
    get: function get(key) {
        var entry = $87f09d956304d838$exports.getEntry($6PJwo(this, $c21b606cf3ce5039$var$MAP), key);
        return entry && entry.v;
    },
    // 23.1.3.9 Map.prototype.set(key, value)
    set: function set(key, value) {
        return $87f09d956304d838$exports.def($6PJwo(this, $c21b606cf3ce5039$var$MAP), key === 0 ? 0 : key, value);
    }
}, $87f09d956304d838$exports, true);


var $3e6c52192ccccdd0$exports = {};
'use strict';


var $6PJwo = parcelRequire("6PJwo");
var $3e6c52192ccccdd0$var$SET = 'Set';

// 23.2 Set Objects
$3e6c52192ccccdd0$exports = (parcelRequire("chbv3"))($3e6c52192ccccdd0$var$SET, function(get) {
    return function Set() {
        return get(this, arguments.length > 0 ? arguments[0] : undefined);
    };
}, {
    // 23.2.3.1 Set.prototype.add(value)
    add: function add(value) {
        return $87f09d956304d838$exports.def($6PJwo(this, $3e6c52192ccccdd0$var$SET), value = value === 0 ? 0 : value, value);
    }
}, $87f09d956304d838$exports);


parcelRequire("9dDAH");
'use strict';

var $5cDUT = parcelRequire("5cDUT");

var $6PJwo = parcelRequire("6PJwo");
var $650bf6162a4ecf87$var$WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
(parcelRequire("chbv3"))($650bf6162a4ecf87$var$WEAK_SET, function(get) {
    return function WeakSet() {
        return get(this, arguments.length > 0 ? arguments[0] : undefined);
    };
}, {
    // 23.4.3.1 WeakSet.prototype.add(value)
    add: function add(value) {
        return $5cDUT.def($6PJwo(this, $650bf6162a4ecf87$var$WEAK_SET), value, true);
    }
}, $5cDUT, false, true);


'use strict';

var $eqgBB = parcelRequire("eqgBB");

var $hI4KF = parcelRequire("hI4KF");

var $3LpdK = parcelRequire("3LpdK");

var $6K5GG = parcelRequire("6K5GG");

var $aJr6a = parcelRequire("aJr6a");

var $jsF4z = parcelRequire("jsF4z");

var $h9IVq = parcelRequire("h9IVq");

var $1YuiL = parcelRequire("1YuiL");
var $6d5101b96fe03237$require$ArrayBuffer = $1YuiL.ArrayBuffer;

var $hHXyM = parcelRequire("hHXyM");
var $6d5101b96fe03237$var$$ArrayBuffer = $3LpdK.ArrayBuffer;
var $6d5101b96fe03237$var$$DataView = $3LpdK.DataView;
var $6d5101b96fe03237$var$$isView = $hI4KF.ABV && $6d5101b96fe03237$require$ArrayBuffer.isView;
var $6d5101b96fe03237$var$$slice = $6d5101b96fe03237$var$$ArrayBuffer.prototype.slice;
var $6d5101b96fe03237$var$VIEW = $hI4KF.VIEW;
var $6d5101b96fe03237$var$ARRAY_BUFFER = 'ArrayBuffer';
$eqgBB($eqgBB.G + $eqgBB.W + $eqgBB.F * ($6d5101b96fe03237$require$ArrayBuffer !== $6d5101b96fe03237$var$$ArrayBuffer), {
    ArrayBuffer: $6d5101b96fe03237$var$$ArrayBuffer
});
$eqgBB($eqgBB.S + $eqgBB.F * !$hI4KF.CONSTR, $6d5101b96fe03237$var$ARRAY_BUFFER, {
    // 24.1.3.1 ArrayBuffer.isView(arg)
    isView: function isView(it) {
        return $6d5101b96fe03237$var$$isView && $6d5101b96fe03237$var$$isView(it) || $h9IVq(it) && $6d5101b96fe03237$var$VIEW in it;
    }
});

$eqgBB($eqgBB.P + $eqgBB.U + $eqgBB.F * (parcelRequire("bjnTD"))(function() {
    return !new $6d5101b96fe03237$var$$ArrayBuffer(2).slice(1, undefined).byteLength;
}), $6d5101b96fe03237$var$ARRAY_BUFFER, {
    // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
    slice: function slice(start, end) {
        if ($6d5101b96fe03237$var$$slice !== undefined && end === undefined) return $6d5101b96fe03237$var$$slice.call($6K5GG(this), start); // FF fix
        var len = $6K5GG(this).byteLength;
        var first = $aJr6a(start, len);
        var fin = $aJr6a(end === undefined ? len : end, len);
        var result = new ($hHXyM(this, $6d5101b96fe03237$var$$ArrayBuffer))($jsF4z(fin - first));
        var viewS = new $6d5101b96fe03237$var$$DataView(this);
        var viewT = new $6d5101b96fe03237$var$$DataView(result);
        var index = 0;
        while(first < fin)viewT.setUint8(index++, viewS.getUint8(first++));
        return result;
    }
});

(parcelRequire("4kzAJ"))($6d5101b96fe03237$var$ARRAY_BUFFER);



var $eqgBB = parcelRequire("eqgBB");


$eqgBB($eqgBB.G + $eqgBB.W + $eqgBB.F * !(parcelRequire("hI4KF")).ABV, {
    DataView: (parcelRequire("3LpdK")).DataView
});



(parcelRequire("6JNHC"))('Int8', 1, function(init) {
    return function Int8Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



(parcelRequire("6JNHC"))('Uint8', 1, function(init) {
    return function Uint8Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



(parcelRequire("6JNHC"))('Uint8', 1, function(init) {
    return function Uint8ClampedArray(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
}, true);



(parcelRequire("6JNHC"))('Int16', 2, function(init) {
    return function Int16Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



(parcelRequire("6JNHC"))('Uint16', 2, function(init) {
    return function Uint16Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



(parcelRequire("6JNHC"))('Int32', 4, function(init) {
    return function Int32Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



(parcelRequire("6JNHC"))('Uint32', 4, function(init) {
    return function Uint32Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



(parcelRequire("6JNHC"))('Float32', 4, function(init) {
    return function Float32Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



(parcelRequire("6JNHC"))('Float64', 8, function(init) {
    return function Float64Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)

var $eqgBB = parcelRequire("eqgBB");

var $4VmiN = parcelRequire("4VmiN");

var $6K5GG = parcelRequire("6K5GG");

var $e56ccecccb125030$var$rApply = ((parcelRequire("1YuiL")).Reflect || {}).apply;
var $e56ccecccb125030$var$fApply = Function.apply;

// MS Edge argumentsList argument is optional
$eqgBB($eqgBB.S + $eqgBB.F * !(parcelRequire("bjnTD"))(function() {
    $e56ccecccb125030$var$rApply(function() {});
}), 'Reflect', {
    apply: function apply(target, thisArgument, argumentsList) {
        var T = $4VmiN(target);
        var L = $6K5GG(argumentsList);
        return $e56ccecccb125030$var$rApply ? $e56ccecccb125030$var$rApply(T, thisArgument, L) : $e56ccecccb125030$var$fApply.call(T, thisArgument, L);
    }
});


// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])

var $eqgBB = parcelRequire("eqgBB");

var $16E7l = parcelRequire("16E7l");

var $4VmiN = parcelRequire("4VmiN");

var $6K5GG = parcelRequire("6K5GG");

var $h9IVq = parcelRequire("h9IVq");

var $bjnTD = parcelRequire("bjnTD");

var $d3CGC = parcelRequire("d3CGC");

var $41a476d9858f30e3$var$rConstruct = ((parcelRequire("1YuiL")).Reflect || {}).construct;
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var $41a476d9858f30e3$var$NEW_TARGET_BUG = $bjnTD(function() {
    function F() {}
    return !($41a476d9858f30e3$var$rConstruct(function() {}, [], F) instanceof F);
});
var $41a476d9858f30e3$var$ARGS_BUG = !$bjnTD(function() {
    $41a476d9858f30e3$var$rConstruct(function() {});
});
$eqgBB($eqgBB.S + $eqgBB.F * ($41a476d9858f30e3$var$NEW_TARGET_BUG || $41a476d9858f30e3$var$ARGS_BUG), 'Reflect', {
    construct: function construct(Target, args /* , newTarget */ ) {
        $4VmiN(Target);
        $6K5GG(args);
        var newTarget = arguments.length < 3 ? Target : $4VmiN(arguments[2]);
        if ($41a476d9858f30e3$var$ARGS_BUG && !$41a476d9858f30e3$var$NEW_TARGET_BUG) return $41a476d9858f30e3$var$rConstruct(Target, args, newTarget);
        if (Target == newTarget) {
            // w/o altered newTarget, optimization for 0-4 arguments
            switch(args.length){
                case 0:
                    return new Target();
                case 1:
                    return new Target(args[0]);
                case 2:
                    return new Target(args[0], args[1]);
                case 3:
                    return new Target(args[0], args[1], args[2]);
                case 4:
                    return new Target(args[0], args[1], args[2], args[3]);
            }
            // w/o altered newTarget, lot of arguments case
            var $args = [
                null
            ];
            $args.push.apply($args, args);
            return new ($d3CGC.apply(Target, $args))();
        }
        // with altered newTarget, not support built-in constructors
        var proto = newTarget.prototype;
        var instance = $16E7l($h9IVq(proto) ? proto : Object.prototype);
        var result = Function.apply.call(Target, instance, args);
        return $h9IVq(result) ? result : instance;
    }
});


// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)

var $lWhMZ = parcelRequire("lWhMZ");

var $eqgBB = parcelRequire("eqgBB");

var $6K5GG = parcelRequire("6K5GG");

var $9a73R = parcelRequire("9a73R");

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$eqgBB($eqgBB.S + $eqgBB.F * (parcelRequire("bjnTD"))(function() {
    // eslint-disable-next-line no-undef
    Reflect.defineProperty($lWhMZ.f({}, 1, {
        value: 1
    }), 1, {
        value: 2
    });
}), 'Reflect', {
    defineProperty: function defineProperty(target, propertyKey, attributes) {
        $6K5GG(target);
        propertyKey = $9a73R(propertyKey, true);
        $6K5GG(attributes);
        try {
            $lWhMZ.f(target, propertyKey, attributes);
            return true;
        } catch (e) {
            return false;
        }
    }
});


// 26.1.4 Reflect.deleteProperty(target, propertyKey)

var $eqgBB = parcelRequire("eqgBB");

var $5yOh2 = parcelRequire("5yOh2");
var $3aad073b1e365814$require$gOPD = $5yOh2.f;

var $6K5GG = parcelRequire("6K5GG");
$eqgBB($eqgBB.S, 'Reflect', {
    deleteProperty: function deleteProperty(target, propertyKey) {
        var desc = $3aad073b1e365814$require$gOPD($6K5GG(target), propertyKey);
        return desc && !desc.configurable ? false : delete target[propertyKey];
    }
});


'use strict';

var $eqgBB = parcelRequire("eqgBB");

var $6K5GG = parcelRequire("6K5GG");
var $4617b5f264f51039$var$Enumerate = function(iterated) {
    this._t = $6K5GG(iterated); // target
    this._i = 0; // next index
    var keys = this._k = []; // keys
    var key;
    for(key in iterated)keys.push(key);
};

(parcelRequire("aleMf"))($4617b5f264f51039$var$Enumerate, 'Object', function() {
    var that = this;
    var keys = that._k;
    var key;
    do {
        if (that._i >= keys.length) return {
            value: undefined,
            done: true
        };
    }while (!((key = keys[that._i++]) in that._t));
    return {
        value: key,
        done: false
    };
});
$eqgBB($eqgBB.S, 'Reflect', {
    enumerate: function enumerate(target) {
        return new $4617b5f264f51039$var$Enumerate(target);
    }
});


// 26.1.6 Reflect.get(target, propertyKey [, receiver])

var $5yOh2 = parcelRequire("5yOh2");

var $9nGSz = parcelRequire("9nGSz");

var $lRu3m = parcelRequire("lRu3m");

var $eqgBB = parcelRequire("eqgBB");

var $h9IVq = parcelRequire("h9IVq");

var $6K5GG = parcelRequire("6K5GG");
function $789e4a491237238f$var$get(target, propertyKey /* , receiver */ ) {
    var receiver = arguments.length < 3 ? target : arguments[2];
    var desc, proto;
    if ($6K5GG(target) === receiver) return target[propertyKey];
    if (desc = $5yOh2.f(target, propertyKey)) return $lRu3m(desc, 'value') ? desc.value : desc.get !== undefined ? desc.get.call(receiver) : undefined;
    if ($h9IVq(proto = $9nGSz(target))) return $789e4a491237238f$var$get(proto, propertyKey, receiver);
}
$eqgBB($eqgBB.S, 'Reflect', {
    get: $789e4a491237238f$var$get
});


// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)

var $5yOh2 = parcelRequire("5yOh2");

var $eqgBB = parcelRequire("eqgBB");

var $6K5GG = parcelRequire("6K5GG");
$eqgBB($eqgBB.S, 'Reflect', {
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
        return $5yOh2.f($6K5GG(target), propertyKey);
    }
});


// 26.1.8 Reflect.getPrototypeOf(target)

var $eqgBB = parcelRequire("eqgBB");

var $9nGSz = parcelRequire("9nGSz");

var $6K5GG = parcelRequire("6K5GG");
$eqgBB($eqgBB.S, 'Reflect', {
    getPrototypeOf: function getPrototypeOf(target) {
        return $9nGSz($6K5GG(target));
    }
});


// 26.1.9 Reflect.has(target, propertyKey)

var $eqgBB = parcelRequire("eqgBB");
$eqgBB($eqgBB.S, 'Reflect', {
    has: function has(target, propertyKey) {
        return propertyKey in target;
    }
});


// 26.1.10 Reflect.isExtensible(target)

var $eqgBB = parcelRequire("eqgBB");

var $6K5GG = parcelRequire("6K5GG");
var $55ce838e3acd0212$var$$isExtensible = Object.isExtensible;
$eqgBB($eqgBB.S, 'Reflect', {
    isExtensible: function isExtensible(target) {
        $6K5GG(target);
        return $55ce838e3acd0212$var$$isExtensible ? $55ce838e3acd0212$var$$isExtensible(target) : true;
    }
});


// 26.1.11 Reflect.ownKeys(target)

var $eqgBB = parcelRequire("eqgBB");

$eqgBB($eqgBB.S, 'Reflect', {
    ownKeys: (parcelRequire("755Pi"))
});


// 26.1.12 Reflect.preventExtensions(target)

var $eqgBB = parcelRequire("eqgBB");

var $6K5GG = parcelRequire("6K5GG");
var $d6098ac4f5253961$var$$preventExtensions = Object.preventExtensions;
$eqgBB($eqgBB.S, 'Reflect', {
    preventExtensions: function preventExtensions(target) {
        $6K5GG(target);
        try {
            if ($d6098ac4f5253961$var$$preventExtensions) $d6098ac4f5253961$var$$preventExtensions(target);
            return true;
        } catch (e) {
            return false;
        }
    }
});


// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])

var $lWhMZ = parcelRequire("lWhMZ");

var $5yOh2 = parcelRequire("5yOh2");

var $9nGSz = parcelRequire("9nGSz");

var $lRu3m = parcelRequire("lRu3m");

var $eqgBB = parcelRequire("eqgBB");

var $8tLmk = parcelRequire("8tLmk");

var $6K5GG = parcelRequire("6K5GG");

var $h9IVq = parcelRequire("h9IVq");
function $e6b267dccb4ec1fa$var$set(target, propertyKey, V /* , receiver */ ) {
    var receiver = arguments.length < 4 ? target : arguments[3];
    var ownDesc = $5yOh2.f($6K5GG(target), propertyKey);
    var existingDescriptor, proto;
    if (!ownDesc) {
        if ($h9IVq(proto = $9nGSz(target))) return $e6b267dccb4ec1fa$var$set(proto, propertyKey, V, receiver);
        ownDesc = $8tLmk(0);
    }
    if ($lRu3m(ownDesc, 'value')) {
        if (ownDesc.writable === false || !$h9IVq(receiver)) return false;
        if (existingDescriptor = $5yOh2.f(receiver, propertyKey)) {
            if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
            existingDescriptor.value = V;
            $lWhMZ.f(receiver, propertyKey, existingDescriptor);
        } else $lWhMZ.f(receiver, propertyKey, $8tLmk(0, V));
        return true;
    }
    return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}
$eqgBB($eqgBB.S, 'Reflect', {
    set: $e6b267dccb4ec1fa$var$set
});


// 26.1.14 Reflect.setPrototypeOf(target, proto)

var $eqgBB = parcelRequire("eqgBB");

var $iTiy4 = parcelRequire("iTiy4");
if ($iTiy4) $eqgBB($eqgBB.S, 'Reflect', {
    setPrototypeOf: function setPrototypeOf(target, proto) {
        $iTiy4.check(target, proto);
        try {
            $iTiy4.set(target, proto);
            return true;
        } catch (e) {
            return false;
        }
    }
});


'use strict';

var $eqgBB = parcelRequire("eqgBB");

var $dc4a792c14dac812$var$$includes = (parcelRequire("hKLZ1"))(true);
$eqgBB($eqgBB.P, 'Array', {
    includes: function includes(el /* , fromIndex = 0 */ ) {
        return $dc4a792c14dac812$var$$includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
    }
});

(parcelRequire("e0GHn"))('includes');


'use strict';

var $eqgBB = parcelRequire("eqgBB");
var $473933f0d344f0cd$exports = {};
'use strict';

var $6HMRV = parcelRequire("6HMRV");

var $h9IVq = parcelRequire("h9IVq");

var $jsF4z = parcelRequire("jsF4z");

var $8luNd = parcelRequire("8luNd");

var $473933f0d344f0cd$var$IS_CONCAT_SPREADABLE = (parcelRequire("buDDQ"))('isConcatSpreadable');
function $473933f0d344f0cd$var$flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
    var targetIndex = start;
    var sourceIndex = 0;
    var mapFn = mapper ? $8luNd(mapper, thisArg, 3) : false;
    var element, spreadable;
    while(sourceIndex < sourceLen){
        if (sourceIndex in source) {
            element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
            spreadable = false;
            if ($h9IVq(element)) {
                spreadable = element[$473933f0d344f0cd$var$IS_CONCAT_SPREADABLE];
                spreadable = spreadable !== undefined ? !!spreadable : $6HMRV(element);
            }
            if (spreadable && depth > 0) targetIndex = $473933f0d344f0cd$var$flattenIntoArray(target, original, element, $jsF4z(element.length), targetIndex, depth - 1) - 1;
            else {
                if (targetIndex >= 0x1fffffffffffff) throw TypeError();
                target[targetIndex] = element;
            }
            targetIndex++;
        }
        sourceIndex++;
    }
    return targetIndex;
}
$473933f0d344f0cd$exports = $473933f0d344f0cd$var$flattenIntoArray;



var $j50QJ = parcelRequire("j50QJ");

var $jsF4z = parcelRequire("jsF4z");

var $4VmiN = parcelRequire("4VmiN");

var $8z5mb = parcelRequire("8z5mb");
$eqgBB($eqgBB.P, 'Array', {
    flatMap: function flatMap(callbackfn /* , thisArg */ ) {
        var O = $j50QJ(this);
        var sourceLen, A;
        $4VmiN(callbackfn);
        sourceLen = $jsF4z(O.length);
        A = $8z5mb(O, 0);
        $473933f0d344f0cd$exports(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
        return A;
    }
});

(parcelRequire("e0GHn"))('flatMap');


'use strict';

var $eqgBB = parcelRequire("eqgBB");


var $j50QJ = parcelRequire("j50QJ");

var $jsF4z = parcelRequire("jsF4z");

var $dAqin = parcelRequire("dAqin");

var $8z5mb = parcelRequire("8z5mb");
$eqgBB($eqgBB.P, 'Array', {
    flatten: function flatten() {
        var depthArg = arguments[0];
        var O = $j50QJ(this);
        var sourceLen = $jsF4z(O.length);
        var A = $8z5mb(O, 0);
        $473933f0d344f0cd$exports(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : $dAqin(depthArg));
        return A;
    }
});

(parcelRequire("e0GHn"))('flatten');


'use strict';

var $eqgBB = parcelRequire("eqgBB");

var $74f8915336b27301$var$$at = (parcelRequire("2B3HC"))(true);

var $bjnTD = parcelRequire("bjnTD");
var $74f8915336b27301$var$FORCED = $bjnTD(function() {
    return "\uD842\uDFB7".at(0) !== "\uD842\uDFB7";
});
$eqgBB($eqgBB.P + $eqgBB.F * $74f8915336b27301$var$FORCED, 'String', {
    at: function at(pos) {
        return $74f8915336b27301$var$$at(this, pos);
    }
});


'use strict';

var $eqgBB = parcelRequire("eqgBB");
var $23e5c891fb46df1f$exports = {};
// https://github.com/tc39/proposal-string-pad-start-end

var $jsF4z = parcelRequire("jsF4z");

var $lQVqT = parcelRequire("lQVqT");

var $6g06V = parcelRequire("6g06V");
$23e5c891fb46df1f$exports = function(that, maxLength, fillString, left) {
    var S = String($6g06V(that));
    var stringLength = S.length;
    var fillStr = fillString === undefined ? ' ' : String(fillString);
    var intMaxLength = $jsF4z(maxLength);
    if (intMaxLength <= stringLength || fillStr == '') return S;
    var fillLen = intMaxLength - stringLength;
    var stringFiller = $lQVqT.call(fillStr, Math.ceil(fillLen / fillStr.length));
    if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
    return left ? stringFiller + S : S + stringFiller;
};



// https://github.com/zloirock/core-js/issues/280
var $07dca0df208b63ff$var$WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test($5fc7dd70c0876310$exports);
$eqgBB($eqgBB.P + $eqgBB.F * $07dca0df208b63ff$var$WEBKIT_BUG, 'String', {
    padStart: function padStart(maxLength /* , fillString = ' ' */ ) {
        return $23e5c891fb46df1f$exports(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
    }
});


'use strict';

var $eqgBB = parcelRequire("eqgBB");


// https://github.com/zloirock/core-js/issues/280
var $f9cd352925dad655$var$WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test($5fc7dd70c0876310$exports);
$eqgBB($eqgBB.P + $eqgBB.F * $f9cd352925dad655$var$WEBKIT_BUG, 'String', {
    padEnd: function padEnd(maxLength /* , fillString = ' ' */ ) {
        return $23e5c891fb46df1f$exports(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
    }
});


'use strict';

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
(parcelRequire("6vf7z"))('trimLeft', function($trim) {
    return function trimLeft() {
        return $trim(this, 1);
    };
}, 'trimStart');


'use strict';

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
(parcelRequire("6vf7z"))('trimRight', function($trim) {
    return function trimRight() {
        return $trim(this, 2);
    };
}, 'trimEnd');


'use strict';

var $eqgBB = parcelRequire("eqgBB");

var $6g06V = parcelRequire("6g06V");

var $jsF4z = parcelRequire("jsF4z");


var $gL7EQ = parcelRequire("gL7EQ");
var $6e68ddd8cd0e8379$var$RegExpProto = RegExp.prototype;
var $6e68ddd8cd0e8379$var$$RegExpStringIterator = function(regexp, string) {
    this._r = regexp;
    this._s = string;
};

(parcelRequire("aleMf"))($6e68ddd8cd0e8379$var$$RegExpStringIterator, 'RegExp String', function next() {
    var match = this._r.exec(this._s);
    return {
        value: match,
        done: match === null
    };
});
$eqgBB($eqgBB.P, 'String', {
    matchAll: function matchAll(regexp) {
        $6g06V(this);
        if (!$4a865ed90b3243fb$exports(regexp)) throw TypeError(regexp + ' is not a regexp!');
        var S = String(this);
        var flags = 'flags' in $6e68ddd8cd0e8379$var$RegExpProto ? String(regexp.flags) : $gL7EQ.call(regexp);
        var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
        rx.lastIndex = $jsF4z(regexp.lastIndex);
        return new $6e68ddd8cd0e8379$var$$RegExpStringIterator(rx, S);
    }
});



(parcelRequire("b5vfc"))('asyncIterator');



(parcelRequire("b5vfc"))('observable');


// https://github.com/tc39/proposal-object-getownpropertydescriptors

var $eqgBB = parcelRequire("eqgBB");

var $755Pi = parcelRequire("755Pi");

var $15QDc = parcelRequire("15QDc");

var $5yOh2 = parcelRequire("5yOh2");

$eqgBB($eqgBB.S, 'Object', {
    getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
        var O = $15QDc(object);
        var getDesc = $5yOh2.f;
        var keys = $755Pi(O);
        var result = {};
        var i = 0;
        var key, desc;
        while(keys.length > i){
            desc = getDesc(O, key = keys[i++]);
            if (desc !== undefined) $067c5645c3e4c3e4$exports(result, key, desc);
        }
        return result;
    }
});


// https://github.com/tc39/proposal-object-values-entries

var $eqgBB = parcelRequire("eqgBB");

var $75c0387895cae657$var$$values = (parcelRequire("4AEZp"))(false);
$eqgBB($eqgBB.S, 'Object', {
    values: function values(it) {
        return $75c0387895cae657$var$$values(it);
    }
});


// https://github.com/tc39/proposal-object-values-entries

var $eqgBB = parcelRequire("eqgBB");

var $2f00cf02f70d452d$var$$entries = (parcelRequire("4AEZp"))(true);
$eqgBB($eqgBB.S, 'Object', {
    entries: function entries(it) {
        return $2f00cf02f70d452d$var$$entries(it);
    }
});


'use strict';

var $eqgBB = parcelRequire("eqgBB");

var $j50QJ = parcelRequire("j50QJ");

var $4VmiN = parcelRequire("4VmiN");

var $lWhMZ = parcelRequire("lWhMZ");


// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
(parcelRequire("gvOoh")) && $eqgBB($eqgBB.P + (parcelRequire("19Rte")), 'Object', {
    __defineGetter__: function __defineGetter__(P, getter) {
        $lWhMZ.f($j50QJ(this), P, {
            get: $4VmiN(getter),
            enumerable: true,
            configurable: true
        });
    }
});


'use strict';

var $eqgBB = parcelRequire("eqgBB");

var $j50QJ = parcelRequire("j50QJ");

var $4VmiN = parcelRequire("4VmiN");

var $lWhMZ = parcelRequire("lWhMZ");


// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
(parcelRequire("gvOoh")) && $eqgBB($eqgBB.P + (parcelRequire("19Rte")), 'Object', {
    __defineSetter__: function __defineSetter__(P, setter) {
        $lWhMZ.f($j50QJ(this), P, {
            set: $4VmiN(setter),
            enumerable: true,
            configurable: true
        });
    }
});


'use strict';

var $eqgBB = parcelRequire("eqgBB");

var $j50QJ = parcelRequire("j50QJ");

var $9a73R = parcelRequire("9a73R");

var $9nGSz = parcelRequire("9nGSz");

var $5yOh2 = parcelRequire("5yOh2");
var $967fc0ef96d898f4$require$getOwnPropertyDescriptor = $5yOh2.f;


// B.2.2.4 Object.prototype.__lookupGetter__(P)
(parcelRequire("gvOoh")) && $eqgBB($eqgBB.P + (parcelRequire("19Rte")), 'Object', {
    __lookupGetter__: function __lookupGetter__(P) {
        var O = $j50QJ(this);
        var K = $9a73R(P, true);
        var D;
        do {
            if (D = $967fc0ef96d898f4$require$getOwnPropertyDescriptor(O, K)) return D.get;
        }while (O = $9nGSz(O));
    }
});


'use strict';

var $eqgBB = parcelRequire("eqgBB");

var $j50QJ = parcelRequire("j50QJ");

var $9a73R = parcelRequire("9a73R");

var $9nGSz = parcelRequire("9nGSz");

var $5yOh2 = parcelRequire("5yOh2");
var $d0b45850951899a0$require$getOwnPropertyDescriptor = $5yOh2.f;


// B.2.2.5 Object.prototype.__lookupSetter__(P)
(parcelRequire("gvOoh")) && $eqgBB($eqgBB.P + (parcelRequire("19Rte")), 'Object', {
    __lookupSetter__: function __lookupSetter__(P) {
        var O = $j50QJ(this);
        var K = $9a73R(P, true);
        var D;
        do {
            if (D = $d0b45850951899a0$require$getOwnPropertyDescriptor(O, K)) return D.set;
        }while (O = $9nGSz(O));
    }
});


// https://github.com/DavidBruant/Map-Set.prototype.toJSON

var $eqgBB = parcelRequire("eqgBB");

$eqgBB($eqgBB.P + $eqgBB.R, 'Map', {
    toJSON: (parcelRequire("a5gb2"))('Map')
});


// https://github.com/DavidBruant/Map-Set.prototype.toJSON

var $eqgBB = parcelRequire("eqgBB");

$eqgBB($eqgBB.P + $eqgBB.R, 'Set', {
    toJSON: (parcelRequire("a5gb2"))('Set')
});


// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of

(parcelRequire("gmEKb"))('Map');


// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of

(parcelRequire("gmEKb"))('Set');


// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of

(parcelRequire("gmEKb"))('WeakMap');


// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of

(parcelRequire("gmEKb"))('WeakSet');


// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from

(parcelRequire("i2Pmb"))('Map');


// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from

(parcelRequire("i2Pmb"))('Set');


// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from

(parcelRequire("i2Pmb"))('WeakMap');


// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from

(parcelRequire("i2Pmb"))('WeakSet');


// https://github.com/tc39/proposal-global

var $eqgBB = parcelRequire("eqgBB");

$eqgBB($eqgBB.G, {
    global: (parcelRequire("1YuiL"))
});


// https://github.com/tc39/proposal-global

var $eqgBB = parcelRequire("eqgBB");

$eqgBB($eqgBB.S, 'System', {
    global: (parcelRequire("1YuiL"))
});


// https://github.com/ljharb/proposal-is-error

var $eqgBB = parcelRequire("eqgBB");

var $P9d0u = parcelRequire("P9d0u");
$eqgBB($eqgBB.S, 'Error', {
    isError: function isError(it) {
        return $P9d0u(it) === 'Error';
    }
});


// https://rwaldron.github.io/proposal-math-extensions/

var $eqgBB = parcelRequire("eqgBB");
$eqgBB($eqgBB.S, 'Math', {
    clamp: function clamp(x, lower, upper) {
        return Math.min(upper, Math.max(lower, x));
    }
});


// https://rwaldron.github.io/proposal-math-extensions/

var $eqgBB = parcelRequire("eqgBB");
$eqgBB($eqgBB.S, 'Math', {
    DEG_PER_RAD: Math.PI / 180
});


// https://rwaldron.github.io/proposal-math-extensions/

var $eqgBB = parcelRequire("eqgBB");
var $a84b1671e358a2fd$var$RAD_PER_DEG = 180 / Math.PI;
$eqgBB($eqgBB.S, 'Math', {
    degrees: function degrees(radians) {
        return radians * $a84b1671e358a2fd$var$RAD_PER_DEG;
    }
});


// https://rwaldron.github.io/proposal-math-extensions/

var $eqgBB = parcelRequire("eqgBB");

var $fxKVl = parcelRequire("fxKVl");

var $6Jdp5 = parcelRequire("6Jdp5");
$eqgBB($eqgBB.S, 'Math', {
    fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
        return $6Jdp5($fxKVl(x, inLow, inHigh, outLow, outHigh));
    }
});


// https://gist.github.com/BrendanEich/4294d5c212a6d2254703

var $eqgBB = parcelRequire("eqgBB");
$eqgBB($eqgBB.S, 'Math', {
    iaddh: function iaddh(x0, x1, y0, y1) {
        var $x0 = x0 >>> 0;
        var $x1 = x1 >>> 0;
        var $y0 = y0 >>> 0;
        return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
    }
});


// https://gist.github.com/BrendanEich/4294d5c212a6d2254703

var $eqgBB = parcelRequire("eqgBB");
$eqgBB($eqgBB.S, 'Math', {
    isubh: function isubh(x0, x1, y0, y1) {
        var $x0 = x0 >>> 0;
        var $x1 = x1 >>> 0;
        var $y0 = y0 >>> 0;
        return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
    }
});


// https://gist.github.com/BrendanEich/4294d5c212a6d2254703

var $eqgBB = parcelRequire("eqgBB");
$eqgBB($eqgBB.S, 'Math', {
    imulh: function imulh(u, v) {
        var UINT16 = 0xffff;
        var $u = +u;
        var $v = +v;
        var u0 = $u & UINT16;
        var v0 = $v & UINT16;
        var u1 = $u >> 16;
        var v1 = $v >> 16;
        var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
        return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
    }
});


// https://rwaldron.github.io/proposal-math-extensions/

var $eqgBB = parcelRequire("eqgBB");
$eqgBB($eqgBB.S, 'Math', {
    RAD_PER_DEG: 180 / Math.PI
});


// https://rwaldron.github.io/proposal-math-extensions/

var $eqgBB = parcelRequire("eqgBB");
var $58bb70d3561e37c2$var$DEG_PER_RAD = Math.PI / 180;
$eqgBB($eqgBB.S, 'Math', {
    radians: function radians(degrees) {
        return degrees * $58bb70d3561e37c2$var$DEG_PER_RAD;
    }
});


// https://rwaldron.github.io/proposal-math-extensions/

var $eqgBB = parcelRequire("eqgBB");

$eqgBB($eqgBB.S, 'Math', {
    scale: (parcelRequire("fxKVl"))
});


// https://gist.github.com/BrendanEich/4294d5c212a6d2254703

var $eqgBB = parcelRequire("eqgBB");
$eqgBB($eqgBB.S, 'Math', {
    umulh: function umulh(u, v) {
        var UINT16 = 0xffff;
        var $u = +u;
        var $v = +v;
        var u0 = $u & UINT16;
        var v0 = $v & UINT16;
        var u1 = $u >>> 16;
        var v1 = $v >>> 16;
        var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
        return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
    }
});


// http://jfbastien.github.io/papers/Math.signbit.html

var $eqgBB = parcelRequire("eqgBB");
$eqgBB($eqgBB.S, 'Math', {
    signbit: function signbit(x) {
        // eslint-disable-next-line no-self-compare
        return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
    }
});


// https://github.com/tc39/proposal-promise-finally
'use strict';

var $eqgBB = parcelRequire("eqgBB");

var $ejAKF = parcelRequire("ejAKF");

var $1YuiL = parcelRequire("1YuiL");

var $hHXyM = parcelRequire("hHXyM");

$eqgBB($eqgBB.P + $eqgBB.R, 'Promise', {
    'finally': function(onFinally) {
        var C = $hHXyM(this, $ejAKF.Promise || $1YuiL.Promise);
        var isFunction = typeof onFinally == 'function';
        return this.then(isFunction ? function(x) {
            return $cac3b1e5c76cb914$exports(C, onFinally()).then(function() {
                return x;
            });
        } : onFinally, isFunction ? function(e) {
            return $cac3b1e5c76cb914$exports(C, onFinally()).then(function() {
                throw e;
            });
        } : onFinally);
    }
});


'use strict';

var $eqgBB = parcelRequire("eqgBB");


$eqgBB($eqgBB.S, 'Promise', {
    'try': function(callbackfn) {
        var promiseCapability = $c741f86c74d8d9bd$export$2d1720544b23b823(this);
        var result = $57b97b333cb9e520$exports(callbackfn);
        (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
        return promiseCapability.promise;
    }
});


var $5b167dcc880add7a$exports = {};


var $eqgBB = parcelRequire("eqgBB");

var $5b167dcc880add7a$var$shared = (parcelRequire("6ODIt"))('metadata');

var $5b167dcc880add7a$var$store = $5b167dcc880add7a$var$shared.store || ($5b167dcc880add7a$var$shared.store = new (parcelRequire("9dDAH"))());
var $5b167dcc880add7a$var$getOrCreateMetadataMap = function(target, targetKey, create) {
    var targetMetadata = $5b167dcc880add7a$var$store.get(target);
    if (!targetMetadata) {
        if (!create) return undefined;
        $5b167dcc880add7a$var$store.set(target, targetMetadata = new $c21b606cf3ce5039$exports());
    }
    var keyMetadata = targetMetadata.get(targetKey);
    if (!keyMetadata) {
        if (!create) return undefined;
        targetMetadata.set(targetKey, keyMetadata = new $c21b606cf3ce5039$exports());
    }
    return keyMetadata;
};
var $5b167dcc880add7a$var$ordinaryHasOwnMetadata = function(MetadataKey, O, P) {
    var metadataMap = $5b167dcc880add7a$var$getOrCreateMetadataMap(O, P, false);
    return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var $5b167dcc880add7a$var$ordinaryGetOwnMetadata = function(MetadataKey, O, P) {
    var metadataMap = $5b167dcc880add7a$var$getOrCreateMetadataMap(O, P, false);
    return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var $5b167dcc880add7a$var$ordinaryDefineOwnMetadata = function(MetadataKey, MetadataValue, O, P) {
    $5b167dcc880add7a$var$getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var $5b167dcc880add7a$var$ordinaryOwnMetadataKeys = function(target, targetKey) {
    var metadataMap = $5b167dcc880add7a$var$getOrCreateMetadataMap(target, targetKey, false);
    var keys = [];
    if (metadataMap) metadataMap.forEach(function(_, key) {
        keys.push(key);
    });
    return keys;
};
var $5b167dcc880add7a$var$toMetaKey = function(it) {
    return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var $5b167dcc880add7a$var$exp = function(O) {
    $eqgBB($eqgBB.S, 'Reflect', O);
};
$5b167dcc880add7a$exports = {
    store: $5b167dcc880add7a$var$store,
    map: $5b167dcc880add7a$var$getOrCreateMetadataMap,
    has: $5b167dcc880add7a$var$ordinaryHasOwnMetadata,
    get: $5b167dcc880add7a$var$ordinaryGetOwnMetadata,
    set: $5b167dcc880add7a$var$ordinaryDefineOwnMetadata,
    keys: $5b167dcc880add7a$var$ordinaryOwnMetadataKeys,
    key: $5b167dcc880add7a$var$toMetaKey,
    exp: $5b167dcc880add7a$var$exp
};



var $6K5GG = parcelRequire("6K5GG");
var $8ab554221cff0b3a$var$toMetaKey = $5b167dcc880add7a$exports.key;
var $8ab554221cff0b3a$var$ordinaryDefineOwnMetadata = $5b167dcc880add7a$exports.set;
$5b167dcc880add7a$exports.exp({
    defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
        $8ab554221cff0b3a$var$ordinaryDefineOwnMetadata(metadataKey, metadataValue, $6K5GG(target), $8ab554221cff0b3a$var$toMetaKey(targetKey));
    }
});




var $6K5GG = parcelRequire("6K5GG");
var $5a0e15ed0aa0df31$var$toMetaKey = $5b167dcc880add7a$exports.key;
var $5a0e15ed0aa0df31$var$getOrCreateMetadataMap = $5b167dcc880add7a$exports.map;
var $5a0e15ed0aa0df31$var$store = $5b167dcc880add7a$exports.store;
$5b167dcc880add7a$exports.exp({
    deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */ ) {
        var targetKey = arguments.length < 3 ? undefined : $5a0e15ed0aa0df31$var$toMetaKey(arguments[2]);
        var metadataMap = $5a0e15ed0aa0df31$var$getOrCreateMetadataMap($6K5GG(target), targetKey, false);
        if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
        if (metadataMap.size) return true;
        var targetMetadata = $5a0e15ed0aa0df31$var$store.get(target);
        targetMetadata['delete'](targetKey);
        return !!targetMetadata.size || $5a0e15ed0aa0df31$var$store['delete'](target);
    }
});




var $6K5GG = parcelRequire("6K5GG");

var $9nGSz = parcelRequire("9nGSz");
var $257d4ea2a4d43c29$var$ordinaryHasOwnMetadata = $5b167dcc880add7a$exports.has;
var $257d4ea2a4d43c29$var$ordinaryGetOwnMetadata = $5b167dcc880add7a$exports.get;
var $257d4ea2a4d43c29$var$toMetaKey = $5b167dcc880add7a$exports.key;
var $257d4ea2a4d43c29$var$ordinaryGetMetadata = function(MetadataKey, O, P) {
    var hasOwn = $257d4ea2a4d43c29$var$ordinaryHasOwnMetadata(MetadataKey, O, P);
    if (hasOwn) return $257d4ea2a4d43c29$var$ordinaryGetOwnMetadata(MetadataKey, O, P);
    var parent = $9nGSz(O);
    return parent !== null ? $257d4ea2a4d43c29$var$ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};
$5b167dcc880add7a$exports.exp({
    getMetadata: function getMetadata(metadataKey, target /* , targetKey */ ) {
        return $257d4ea2a4d43c29$var$ordinaryGetMetadata(metadataKey, $6K5GG(target), arguments.length < 3 ? undefined : $257d4ea2a4d43c29$var$toMetaKey(arguments[2]));
    }
});




var $7wV2F = parcelRequire("7wV2F");


var $6K5GG = parcelRequire("6K5GG");

var $9nGSz = parcelRequire("9nGSz");
var $3d3421078aed7465$var$ordinaryOwnMetadataKeys = $5b167dcc880add7a$exports.keys;
var $3d3421078aed7465$var$toMetaKey = $5b167dcc880add7a$exports.key;
var $3d3421078aed7465$var$ordinaryMetadataKeys = function(O, P) {
    var oKeys = $3d3421078aed7465$var$ordinaryOwnMetadataKeys(O, P);
    var parent = $9nGSz(O);
    if (parent === null) return oKeys;
    var pKeys = $3d3421078aed7465$var$ordinaryMetadataKeys(parent, P);
    return pKeys.length ? oKeys.length ? $7wV2F(new $3e6c52192ccccdd0$exports(oKeys.concat(pKeys))) : pKeys : oKeys;
};
$5b167dcc880add7a$exports.exp({
    getMetadataKeys: function getMetadataKeys(target /* , targetKey */ ) {
        return $3d3421078aed7465$var$ordinaryMetadataKeys($6K5GG(target), arguments.length < 2 ? undefined : $3d3421078aed7465$var$toMetaKey(arguments[1]));
    }
});




var $6K5GG = parcelRequire("6K5GG");
var $e2803b40ceb7a74b$var$ordinaryGetOwnMetadata = $5b167dcc880add7a$exports.get;
var $e2803b40ceb7a74b$var$toMetaKey = $5b167dcc880add7a$exports.key;
$5b167dcc880add7a$exports.exp({
    getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */ ) {
        return $e2803b40ceb7a74b$var$ordinaryGetOwnMetadata(metadataKey, $6K5GG(target), arguments.length < 3 ? undefined : $e2803b40ceb7a74b$var$toMetaKey(arguments[2]));
    }
});




var $6K5GG = parcelRequire("6K5GG");
var $7626fb922ecd28ab$var$ordinaryOwnMetadataKeys = $5b167dcc880add7a$exports.keys;
var $7626fb922ecd28ab$var$toMetaKey = $5b167dcc880add7a$exports.key;
$5b167dcc880add7a$exports.exp({
    getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */ ) {
        return $7626fb922ecd28ab$var$ordinaryOwnMetadataKeys($6K5GG(target), arguments.length < 2 ? undefined : $7626fb922ecd28ab$var$toMetaKey(arguments[1]));
    }
});




var $6K5GG = parcelRequire("6K5GG");

var $9nGSz = parcelRequire("9nGSz");
var $464b8068e752630f$var$ordinaryHasOwnMetadata = $5b167dcc880add7a$exports.has;
var $464b8068e752630f$var$toMetaKey = $5b167dcc880add7a$exports.key;
var $464b8068e752630f$var$ordinaryHasMetadata = function(MetadataKey, O, P) {
    var hasOwn = $464b8068e752630f$var$ordinaryHasOwnMetadata(MetadataKey, O, P);
    if (hasOwn) return true;
    var parent = $9nGSz(O);
    return parent !== null ? $464b8068e752630f$var$ordinaryHasMetadata(MetadataKey, parent, P) : false;
};
$5b167dcc880add7a$exports.exp({
    hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */ ) {
        return $464b8068e752630f$var$ordinaryHasMetadata(metadataKey, $6K5GG(target), arguments.length < 3 ? undefined : $464b8068e752630f$var$toMetaKey(arguments[2]));
    }
});




var $6K5GG = parcelRequire("6K5GG");
var $ff25769888fad692$var$ordinaryHasOwnMetadata = $5b167dcc880add7a$exports.has;
var $ff25769888fad692$var$toMetaKey = $5b167dcc880add7a$exports.key;
$5b167dcc880add7a$exports.exp({
    hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */ ) {
        return $ff25769888fad692$var$ordinaryHasOwnMetadata(metadataKey, $6K5GG(target), arguments.length < 3 ? undefined : $ff25769888fad692$var$toMetaKey(arguments[2]));
    }
});




var $6K5GG = parcelRequire("6K5GG");

var $4VmiN = parcelRequire("4VmiN");
var $ce33b16e0f6da20d$var$toMetaKey = $5b167dcc880add7a$exports.key;
var $ce33b16e0f6da20d$var$ordinaryDefineOwnMetadata = $5b167dcc880add7a$exports.set;
$5b167dcc880add7a$exports.exp({
    metadata: function metadata(metadataKey, metadataValue) {
        return function decorator(target, targetKey) {
            $ce33b16e0f6da20d$var$ordinaryDefineOwnMetadata(metadataKey, metadataValue, (targetKey !== undefined ? $6K5GG : $4VmiN)(target), $ce33b16e0f6da20d$var$toMetaKey(targetKey));
        };
    }
});


// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask

var $eqgBB = parcelRequire("eqgBB");

var $00452402b33cda34$var$microtask = (parcelRequire("hIctV"))();

var $1YuiL = parcelRequire("1YuiL");
var $00452402b33cda34$require$process = $1YuiL.process;

var $00452402b33cda34$var$isNode = (parcelRequire("P9d0u"))($00452402b33cda34$require$process) == 'process';
$eqgBB($eqgBB.G, {
    asap: function asap(fn) {
        var domain = $00452402b33cda34$var$isNode && $00452402b33cda34$require$process.domain;
        $00452402b33cda34$var$microtask(domain ? domain.bind(fn) : fn);
    }
});


'use strict';

var $eqgBB = parcelRequire("eqgBB");

var $1YuiL = parcelRequire("1YuiL");

var $ejAKF = parcelRequire("ejAKF");

var $9c5fd61fed588a5e$var$microtask = (parcelRequire("hIctV"))();

var $9c5fd61fed588a5e$var$OBSERVABLE = (parcelRequire("buDDQ"))('observable');

var $4VmiN = parcelRequire("4VmiN");

var $6K5GG = parcelRequire("6K5GG");

var $gVepx = parcelRequire("gVepx");

var $1YB50 = parcelRequire("1YB50");

var $5ujtn = parcelRequire("5ujtn");

var $gTqEb = parcelRequire("gTqEb");
var $9c5fd61fed588a5e$var$RETURN = $gTqEb.RETURN;
var $9c5fd61fed588a5e$var$getMethod = function(fn) {
    return fn == null ? undefined : $4VmiN(fn);
};
var $9c5fd61fed588a5e$var$cleanupSubscription = function(subscription) {
    var cleanup = subscription._c;
    if (cleanup) {
        subscription._c = undefined;
        cleanup();
    }
};
var $9c5fd61fed588a5e$var$subscriptionClosed = function(subscription) {
    return subscription._o === undefined;
};
var $9c5fd61fed588a5e$var$closeSubscription = function(subscription) {
    if (!$9c5fd61fed588a5e$var$subscriptionClosed(subscription)) {
        subscription._o = undefined;
        $9c5fd61fed588a5e$var$cleanupSubscription(subscription);
    }
};
var $9c5fd61fed588a5e$var$Subscription = function(observer, subscriber) {
    $6K5GG(observer);
    this._c = undefined;
    this._o = observer;
    observer = new $9c5fd61fed588a5e$var$SubscriptionObserver(this);
    try {
        var cleanup = subscriber(observer);
        var subscription = cleanup;
        if (cleanup != null) {
            if (typeof cleanup.unsubscribe === 'function') cleanup = function() {
                subscription.unsubscribe();
            };
            else $4VmiN(cleanup);
            this._c = cleanup;
        }
    } catch (e) {
        observer.error(e);
        return;
    }
    if ($9c5fd61fed588a5e$var$subscriptionClosed(this)) $9c5fd61fed588a5e$var$cleanupSubscription(this);
};
$9c5fd61fed588a5e$var$Subscription.prototype = $1YB50({}, {
    unsubscribe: function unsubscribe() {
        $9c5fd61fed588a5e$var$closeSubscription(this);
    }
});
var $9c5fd61fed588a5e$var$SubscriptionObserver = function(subscription) {
    this._s = subscription;
};
$9c5fd61fed588a5e$var$SubscriptionObserver.prototype = $1YB50({}, {
    next: function next(value) {
        var subscription = this._s;
        if (!$9c5fd61fed588a5e$var$subscriptionClosed(subscription)) {
            var observer = subscription._o;
            try {
                var m = $9c5fd61fed588a5e$var$getMethod(observer.next);
                if (m) return m.call(observer, value);
            } catch (e) {
                try {
                    $9c5fd61fed588a5e$var$closeSubscription(subscription);
                } finally{
                    throw e;
                }
            }
        }
    },
    error: function error(value) {
        var subscription = this._s;
        if ($9c5fd61fed588a5e$var$subscriptionClosed(subscription)) throw value;
        var observer = subscription._o;
        subscription._o = undefined;
        try {
            var m = $9c5fd61fed588a5e$var$getMethod(observer.error);
            if (!m) throw value;
            value = m.call(observer, value);
        } catch (e) {
            try {
                $9c5fd61fed588a5e$var$cleanupSubscription(subscription);
            } finally{
                throw e;
            }
        }
        $9c5fd61fed588a5e$var$cleanupSubscription(subscription);
        return value;
    },
    complete: function complete(value) {
        var subscription = this._s;
        if (!$9c5fd61fed588a5e$var$subscriptionClosed(subscription)) {
            var observer = subscription._o;
            subscription._o = undefined;
            try {
                var m = $9c5fd61fed588a5e$var$getMethod(observer.complete);
                value = m ? m.call(observer, value) : undefined;
            } catch (e) {
                try {
                    $9c5fd61fed588a5e$var$cleanupSubscription(subscription);
                } finally{
                    throw e;
                }
            }
            $9c5fd61fed588a5e$var$cleanupSubscription(subscription);
            return value;
        }
    }
});
var $9c5fd61fed588a5e$var$$Observable = function Observable(subscriber) {
    $gVepx(this, $9c5fd61fed588a5e$var$$Observable, 'Observable', '_f')._f = $4VmiN(subscriber);
};
$1YB50($9c5fd61fed588a5e$var$$Observable.prototype, {
    subscribe: function subscribe(observer) {
        return new $9c5fd61fed588a5e$var$Subscription(observer, this._f);
    },
    forEach: function forEach(fn) {
        var that = this;
        return new ($ejAKF.Promise || $1YuiL.Promise)(function(resolve, reject) {
            $4VmiN(fn);
            var subscription = that.subscribe({
                next: function(value) {
                    try {
                        return fn(value);
                    } catch (e) {
                        reject(e);
                        subscription.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
        });
    }
});
$1YB50($9c5fd61fed588a5e$var$$Observable, {
    from: function from(x) {
        var C = typeof this === 'function' ? this : $9c5fd61fed588a5e$var$$Observable;
        var method = $9c5fd61fed588a5e$var$getMethod($6K5GG(x)[$9c5fd61fed588a5e$var$OBSERVABLE]);
        if (method) {
            var observable = $6K5GG(method.call(x));
            return observable.constructor === C ? observable : new C(function(observer) {
                return observable.subscribe(observer);
            });
        }
        return new C(function(observer) {
            var done = false;
            $9c5fd61fed588a5e$var$microtask(function() {
                if (!done) {
                    try {
                        if ($gTqEb(x, false, function(it) {
                            observer.next(it);
                            if (done) return $9c5fd61fed588a5e$var$RETURN;
                        }) === $9c5fd61fed588a5e$var$RETURN) return;
                    } catch (e) {
                        if (done) throw e;
                        observer.error(e);
                        return;
                    }
                    observer.complete();
                }
            });
            return function() {
                done = true;
            };
        });
    },
    of: function of() {
        for(var i = 0, l = arguments.length, items = new Array(l); i < l;)items[i] = arguments[i++];
        return new (typeof this === 'function' ? this : $9c5fd61fed588a5e$var$$Observable)(function(observer) {
            var done = false;
            $9c5fd61fed588a5e$var$microtask(function() {
                if (!done) {
                    for(var j = 0; j < items.length; ++j){
                        observer.next(items[j]);
                        if (done) return;
                    }
                    observer.complete();
                }
            });
            return function() {
                done = true;
            };
        });
    }
});
$5ujtn($9c5fd61fed588a5e$var$$Observable.prototype, $9c5fd61fed588a5e$var$OBSERVABLE, function() {
    return this;
});
$eqgBB($eqgBB.G, {
    Observable: $9c5fd61fed588a5e$var$$Observable
});

(parcelRequire("4kzAJ"))('Observable');


// ie9- setTimeout & setInterval additional parameters fix

var $1YuiL = parcelRequire("1YuiL");

var $eqgBB = parcelRequire("eqgBB");

var $a52c1e68bbeff786$var$slice = [].slice;
var $a52c1e68bbeff786$var$MSIE = /MSIE .\./.test($5fc7dd70c0876310$exports); // <- dirty ie9- check
var $a52c1e68bbeff786$var$wrap = function(set) {
    return function(fn, time /* , ...args */ ) {
        var boundArgs = arguments.length > 2;
        var args = boundArgs ? $a52c1e68bbeff786$var$slice.call(arguments, 2) : false;
        return set(boundArgs ? function() {
            // eslint-disable-next-line no-new-func
            (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
        } : fn, time);
    };
};
$eqgBB($eqgBB.G + $eqgBB.B + $eqgBB.F * $a52c1e68bbeff786$var$MSIE, {
    setTimeout: $a52c1e68bbeff786$var$wrap($1YuiL.setTimeout),
    setInterval: $a52c1e68bbeff786$var$wrap($1YuiL.setInterval)
});



var $eqgBB = parcelRequire("eqgBB");

var $7L6vC = parcelRequire("7L6vC");
$eqgBB($eqgBB.G + $eqgBB.B, {
    setImmediate: $7L6vC.set,
    clearImmediate: $7L6vC.clear
});



var $5Mf7C = parcelRequire("5Mf7C");

var $eYXZv = parcelRequire("eYXZv");

var $2D2fi = parcelRequire("2D2fi");

var $1YuiL = parcelRequire("1YuiL");

var $5ujtn = parcelRequire("5ujtn");

var $kfJlH = parcelRequire("kfJlH");

var $buDDQ = parcelRequire("buDDQ");
var $dc0b7c93590cd113$var$ITERATOR = $buDDQ('iterator');
var $dc0b7c93590cd113$var$TO_STRING_TAG = $buDDQ('toStringTag');
var $dc0b7c93590cd113$var$ArrayValues = $kfJlH.Array;
var $dc0b7c93590cd113$var$DOMIterables = {
    CSSRuleList: true,
    CSSStyleDeclaration: false,
    CSSValueList: false,
    ClientRectList: false,
    DOMRectList: false,
    DOMStringList: false,
    DOMTokenList: true,
    DataTransferItemList: false,
    FileList: false,
    HTMLAllCollection: false,
    HTMLCollection: false,
    HTMLFormElement: false,
    HTMLSelectElement: false,
    MediaList: true,
    MimeTypeArray: false,
    NamedNodeMap: false,
    NodeList: true,
    PaintRequestList: false,
    Plugin: false,
    PluginArray: false,
    SVGLengthList: false,
    SVGNumberList: false,
    SVGPathSegList: false,
    SVGPointList: false,
    SVGStringList: false,
    SVGTransformList: false,
    SourceBufferList: false,
    StyleSheetList: true,
    TextTrackCueList: false,
    TextTrackList: false,
    TouchList: false
};
for(var $dc0b7c93590cd113$var$collections = $eYXZv($dc0b7c93590cd113$var$DOMIterables), $dc0b7c93590cd113$var$i = 0; $dc0b7c93590cd113$var$i < $dc0b7c93590cd113$var$collections.length; $dc0b7c93590cd113$var$i++){
    var $dc0b7c93590cd113$var$NAME = $dc0b7c93590cd113$var$collections[$dc0b7c93590cd113$var$i];
    var $dc0b7c93590cd113$var$explicit = $dc0b7c93590cd113$var$DOMIterables[$dc0b7c93590cd113$var$NAME];
    var $dc0b7c93590cd113$var$Collection = $1YuiL[$dc0b7c93590cd113$var$NAME];
    var $dc0b7c93590cd113$var$proto = $dc0b7c93590cd113$var$Collection && $dc0b7c93590cd113$var$Collection.prototype;
    var $dc0b7c93590cd113$var$key;
    if ($dc0b7c93590cd113$var$proto) {
        if (!$dc0b7c93590cd113$var$proto[$dc0b7c93590cd113$var$ITERATOR]) $5ujtn($dc0b7c93590cd113$var$proto, $dc0b7c93590cd113$var$ITERATOR, $dc0b7c93590cd113$var$ArrayValues);
        if (!$dc0b7c93590cd113$var$proto[$dc0b7c93590cd113$var$TO_STRING_TAG]) $5ujtn($dc0b7c93590cd113$var$proto, $dc0b7c93590cd113$var$TO_STRING_TAG, $dc0b7c93590cd113$var$NAME);
        $kfJlH[$dc0b7c93590cd113$var$NAME] = $dc0b7c93590cd113$var$ArrayValues;
        if ($dc0b7c93590cd113$var$explicit) {
            for($dc0b7c93590cd113$var$key in $5Mf7C)if (!$dc0b7c93590cd113$var$proto[$dc0b7c93590cd113$var$key]) $2D2fi($dc0b7c93590cd113$var$proto, $dc0b7c93590cd113$var$key, $5Mf7C[$dc0b7c93590cd113$var$key], true);
        }
    }
}



$fc815ff806253b78$exports = (parcelRequire("ejAKF"));


var $992ffba6d2c0516f$exports = {};
/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */ !function(global1) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    var inModule = true;
    var runtime = global1.regeneratorRuntime;
    if (runtime) {
        if (inModule) // If regeneratorRuntime is defined globally and we're in a module,
        // make the exports object identical to regeneratorRuntime.
        $992ffba6d2c0516f$exports = runtime;
        // Don't bother evaluating the rest of this file if the runtime was
        // already defined globally.
        return;
    }
    // Define the runtime globally (as expected by generated code) as either
    // module.exports (if we're in a module) or a new, empty object.
    runtime = global1.regeneratorRuntime = inModule ? $992ffba6d2c0516f$exports : {};
    function wrap(innerFn, outerFn, self1, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        generator._invoke = makeInvokeMethod(innerFn, self1, context);
        return generator;
    }
    runtime.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    IteratorPrototype[iteratorSymbol] = function() {
        return this;
    };
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
    GeneratorFunctionPrototype.constructor = GeneratorFunction;
    GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            prototype[method] = function(arg) {
                return this._invoke(method, arg);
            };
        });
    }
    runtime.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    runtime.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            if (!(toStringTagSymbol in genFun)) genFun[toStringTagSymbol] = "GeneratorFunction";
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    runtime.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return Promise.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return Promise.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration. If the Promise is rejected, however, the
                    // result for this iteration will be rejected with the same
                    // reason. Note that rejections of yielded Promises are not
                    // thrown back into the generator function, as is the case
                    // when an awaited Promise is rejected. This difference in
                    // behavior between yield and await is important, because it
                    // allows the consumer to decide what to do with the yielded
                    // rejection (swallow it and continue, manually .throw it back
                    // into the generator, abandon iteration, whatever). With
                    // await, by contrast, there is no opportunity to examine the
                    // rejection reason outside the generator function, so the
                    // only option is to throw it from the await expression, and
                    // let the generator function handle the exception.
                    result.value = unwrapped;
                    resolve(result);
                }, reject);
            }
        }
        if (typeof global1.process === "object" && global1.process.domain) invoke = global1.process.domain.bind(invoke);
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new Promise(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        this._invoke = enqueue;
    }
    defineIteratorMethods(AsyncIterator.prototype);
    AsyncIterator.prototype[asyncIteratorSymbol] = function() {
        return this;
    };
    runtime.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    runtime.async = function(innerFn, outerFn, self1, tryLocsList) {
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self1, tryLocsList));
        return runtime.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self1, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self1, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method always terminates the yield* loop.
            context.delegate = null;
            if (context.method === "throw") {
                if (delegate.iterator.return) {
                    // If the delegate iterator has a return method, give it a
                    // chance to clean up.
                    context.method = "return";
                    context.arg = undefined;
                    maybeInvokeDelegate(delegate, context);
                    if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                    // "return" to "throw", let that override the TypeError below.
                    return ContinueSentinel;
                }
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    Gp[toStringTagSymbol] = "Generator";
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    Gp[iteratorSymbol] = function() {
        return this;
    };
    Gp.toString = function() {
        return "[object Generator]";
    };
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    runtime.keys = function(object) {
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    }
    runtime.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
}(// Among the various tricks for obtaining a reference to the global
// object, this seems to be the most reliable technique that does not
// use indirect eval (which violates Content Security Policy).
typeof $parcel$global === "object" ? $parcel$global : typeof window === "object" ? window : typeof self === "object" ? self : $992ffba6d2c0516f$exports);


var $5f87df774ea31a19$exports = {};
// https://github.com/benjamingr/RexExp.escape

var $eqgBB = parcelRequire("eqgBB");

var $eeda70fa09fdad92$var$$re = (parcelRequire("cWchu"))(/[\\^$*+?.()|[\]{}]/g, '\\$&');
$eqgBB($eqgBB.S, 'RegExp', {
    escape: function escape(it) {
        return $eeda70fa09fdad92$var$$re(it);
    }
});



$5f87df774ea31a19$exports = (parcelRequire("ejAKF")).RegExp.escape;


if ($parcel$global._babelPolyfill) throw new Error("only one instance of babel-polyfill is allowed");
$parcel$global._babelPolyfill = true;
var $c0fcfd2b01f39f69$var$DEFINE_PROPERTY = "defineProperty";
function $c0fcfd2b01f39f69$var$define(O, key, value) {
    O[key] || Object[$c0fcfd2b01f39f69$var$DEFINE_PROPERTY](O, key, {
        writable: true,
        configurable: true,
        value: value
    });
}
$c0fcfd2b01f39f69$var$define(String.prototype, "padLeft", "".padStart);
$c0fcfd2b01f39f69$var$define(String.prototype, "padRight", "".padEnd);
"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function(key) {
    [][key] && $c0fcfd2b01f39f69$var$define(Array, key, Function.call.bind([][key]));
});



var $NdCUR = parcelRequire("NdCUR");

var $g2wso = parcelRequire("g2wso");

var $NdCUR = parcelRequire("NdCUR");


var $NdCUR = parcelRequire("NdCUR");
var $e671d894664c293a$export$cc80c08dc91f1c00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createContext(null);
var $e671d894664c293a$export$2e2bcd8739ae039 = $e671d894664c293a$export$cc80c08dc91f1c00;


// Default to a dummy "batch" implementation that just runs the callback
function $f5f96d54078447f8$var$defaultNoopBatch(callback) {
    callback();
}
var $f5f96d54078447f8$var$batch = $f5f96d54078447f8$var$defaultNoopBatch; // Allow injecting another batching function later
var $f5f96d54078447f8$export$4b9874722d0da7bc = function setBatch(newBatch) {
    return $f5f96d54078447f8$var$batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var $f5f96d54078447f8$export$fc47d4c0ba3bd2c6 = function getBatch() {
    return $f5f96d54078447f8$var$batch;
};


// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $14e79ed1f5ea0f1c$var$createListenerCollection() {
    var batch = (0, $f5f96d54078447f8$export$fc47d4c0ba3bd2c6)();
    var first = null;
    var last = null;
    return {
        clear: function clear() {
            first = null;
            last = null;
        },
        notify: function notify() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function get() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function subscribe(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $14e79ed1f5ea0f1c$var$nullListeners = {
    notify: function notify() {},
    get: function get() {
        return [];
    }
};
function $14e79ed1f5ea0f1c$export$d567d2b9af322f8f(store, parentSub) {
    var unsubscribe;
    var listeners = $14e79ed1f5ea0f1c$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $14e79ed1f5ea0f1c$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $14e79ed1f5ea0f1c$var$nullListeners;
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: function getListeners() {
            return listeners;
        }
    };
    return subscription;
}



var $NdCUR = parcelRequire("NdCUR");
var $c1d92aea347f874b$export$700979bc83e7db82 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $NdCUR.useLayoutEffect) : (0, $NdCUR.useEffect);


function $2ac88c716bc0c424$var$Provider(_ref) {
    var store = _ref.store, context = _ref.context, children = _ref.children;
    var contextValue = (0, $NdCUR.useMemo)(function() {
        var subscription = (0, $14e79ed1f5ea0f1c$export$d567d2b9af322f8f)(store);
        subscription.onStateChange = subscription.notifyNestedSubs;
        return {
            store: store,
            subscription: subscription
        };
    }, [
        store
    ]);
    var previousState = (0, $NdCUR.useMemo)(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, $c1d92aea347f874b$export$700979bc83e7db82)(function() {
        var subscription = contextValue.subscription;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = null;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, $e671d894664c293a$export$cc80c08dc91f1c00);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $2ac88c716bc0c424$export$2e2bcd8739ae039 = $2ac88c716bc0c424$var$Provider;


function $3d1b110f42b1c650$export$2e2bcd8739ae039() {
    return $3d1b110f42b1c650$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3d1b110f42b1c650$export$2e2bcd8739ae039.apply(null, arguments);
}


function $bdedc8073c2ca3ee$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


var $cc6303404373807d$exports = {};
'use strict';
var $ebbb41cea4d2536b$exports = {};
'use strict';

$ebbb41cea4d2536b$exports = (parcelRequire("bVGZs"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $cc6303404373807d$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $cc6303404373807d$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $cc6303404373807d$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $cc6303404373807d$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $cc6303404373807d$var$TYPE_STATICS = {};
$cc6303404373807d$var$TYPE_STATICS[$ebbb41cea4d2536b$exports.ForwardRef] = $cc6303404373807d$var$FORWARD_REF_STATICS;
$cc6303404373807d$var$TYPE_STATICS[$ebbb41cea4d2536b$exports.Memo] = $cc6303404373807d$var$MEMO_STATICS;
function $cc6303404373807d$var$getStatics(component) {
    // React v16.11 and below
    if ($ebbb41cea4d2536b$exports.isMemo(component)) return $cc6303404373807d$var$MEMO_STATICS;
     // React v16.12 and above
    return $cc6303404373807d$var$TYPE_STATICS[component['$$typeof']] || $cc6303404373807d$var$REACT_STATICS;
}
var $cc6303404373807d$var$defineProperty = Object.defineProperty;
var $cc6303404373807d$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $cc6303404373807d$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $cc6303404373807d$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $cc6303404373807d$var$getPrototypeOf = Object.getPrototypeOf;
var $cc6303404373807d$var$objectPrototype = Object.prototype;
function $cc6303404373807d$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($cc6303404373807d$var$objectPrototype) {
            var inheritedComponent = $cc6303404373807d$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $cc6303404373807d$var$objectPrototype) $cc6303404373807d$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $cc6303404373807d$var$getOwnPropertyNames(sourceComponent);
        if ($cc6303404373807d$var$getOwnPropertySymbols) keys = keys.concat($cc6303404373807d$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $cc6303404373807d$var$getStatics(targetComponent);
        var sourceStatics = $cc6303404373807d$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$cc6303404373807d$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $cc6303404373807d$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $cc6303404373807d$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$cc6303404373807d$exports = $cc6303404373807d$var$hoistNonReactStatics;



var $NdCUR = parcelRequire("NdCUR");
var $249d47e389280db9$exports = {};
'use strict';

$249d47e389280db9$exports = (parcelRequire("cgbez"));





var $3855a3ef991c0b82$var$_excluded = [
    "getDisplayName",
    "methodName",
    "renderCountProp",
    "shouldHandleStateChanges",
    "storeKey",
    "withRef",
    "forwardRef",
    "context"
], $3855a3ef991c0b82$var$_excluded2 = [
    "reactReduxForwardedRef"
];
var $3855a3ef991c0b82$var$EMPTY_ARRAY = [];
var $3855a3ef991c0b82$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $3855a3ef991c0b82$var$stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $3855a3ef991c0b82$var$storeStateUpdatesReducer(state, action) {
    var updateCount = state[1];
    return [
        action.payload,
        updateCount + 1
    ];
}
function $3855a3ef991c0b82$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $c1d92aea347f874b$export$700979bc83e7db82)(function() {
        return effectFunc.apply(void 0, effectArgs);
    }, dependencies);
}
function $3855a3ef991c0b82$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    lastChildProps.current = actualChildProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $3855a3ef991c0b82$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function checkForUpdates() {
        if (didUnsubscribe) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
            forceComponentUpdateDispatch({
                type: 'STORE_UPDATED',
                payload: {
                    error: error
                }
            });
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function unsubscribeWrapper() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
}
var $3855a3ef991c0b82$var$initStateUpdates = function initStateUpdates() {
    return [
        null,
        0
    ];
};
function $3855a3ef991c0b82$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $e671d894664c293a$export$cc80c08dc91f1c00) : _ref2$context, connectOptions = (0, $bdedc8073c2ca3ee$export$2e2bcd8739ae039)(_ref2, $3855a3ef991c0b82$var$_excluded);
    var customStoreWarningMessage;
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $3d1b110f42b1c650$export$2e2bcd8739ae039)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        function createChildSelector(store) {
            return selectorFactory(store.dispatch, selectorFactoryOptions);
        } // If we aren't running in "pure" mode, we don't want to memoize values.
        // To avoid conditionally calling hooks, we fall back to a tiny wrapper
        // that just executes the given callback immediately.
        var usePureOnlyMemo = pure ? (0, $NdCUR.useMemo) : function(callback) {
            return callback();
        };
        function ConnectFunction(props) {
            var _useMemo = (0, $NdCUR.useMemo)(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, $bdedc8073c2ca3ee$export$2e2bcd8739ae039)(props, $3855a3ef991c0b82$var$_excluded2);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), propsContext = _useMemo[0], reactReduxForwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
            var ContextToUse = (0, $NdCUR.useMemo)(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && (0, $249d47e389280db9$exports.isContextConsumer)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = (0, $NdCUR.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var childPropsSelector = (0, $NdCUR.useMemo)(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return createChildSelector(store);
            }, [
                store
            ]);
            var _useMemo2 = (0, $NdCUR.useMemo)(function() {
                if (!shouldHandleStateChanges) return $3855a3ef991c0b82$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = (0, $14e79ed1f5ea0f1c$export$d567d2b9af322f8f)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = (0, $NdCUR.useMemo)(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $3d1b110f42b1c650$export$2e2bcd8739ae039)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // We need to force this wrapper component to re-render whenever a Redux store update
            // causes a change to the calculated child component props (or we caught an error in mapState)
            var _useReducer = (0, $NdCUR.useReducer)($3855a3ef991c0b82$var$storeStateUpdatesReducer, $3855a3ef991c0b82$var$EMPTY_ARRAY, $3855a3ef991c0b82$var$initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
            if (previousStateUpdateResult && previousStateUpdateResult.error) throw previousStateUpdateResult.error;
             // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = (0, $NdCUR.useRef)();
            var lastWrapperProps = (0, $NdCUR.useRef)(wrapperProps);
            var childPropsFromStoreUpdate = (0, $NdCUR.useRef)();
            var renderIsScheduled = (0, $NdCUR.useRef)(false);
            var actualChildProps = usePureOnlyMemo(function() {
                // Tricky logic here:
                // - This render may have been triggered by a Redux store update that produced new child props
                // - However, we may have gotten new wrapper props after that
                // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                 // TODO We're reading the store directly in render() here. Bad idea?
                // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                // to determine what the child props should be.
                return childPropsSelector(store.getState(), wrapperProps);
            }, [
                store,
                previousStateUpdateResult,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            $3855a3ef991c0b82$var$useIsomorphicLayoutEffectWithArgs($3855a3ef991c0b82$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                actualChildProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]); // Our re-subscribe logic only runs when the store/subscription setup changes
            $3855a3ef991c0b82$var$useIsomorphicLayoutEffectWithArgs($3855a3ef991c0b82$var$subscribeUpdates, [
                shouldHandleStateChanges,
                store,
                subscription,
                childPropsSelector,
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                childPropsFromStoreUpdate,
                notifyNestedSubs,
                forceComponentUpdateDispatch
            ], [
                store,
                subscription,
                childPropsSelector
            ]); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = (0, $NdCUR.useMemo)(function() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement(WrappedComponent, (0, $3d1b110f42b1c650$export$2e2bcd8739ae039)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = (0, $NdCUR.useMemo)(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
        var Connect = pure ? (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).memo(ConnectFunction) : ConnectFunction;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).forwardRef(function forwardConnectRef(props, ref) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement(Connect, (0, $3d1b110f42b1c650$export$2e2bcd8739ae039)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($cc6303404373807d$exports)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($cc6303404373807d$exports)))(Connect, WrappedComponent);
    };
}






function $a50263ad9211bca8$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $a50263ad9211bca8$export$2e2bcd8739ae039(objA, objB) {
    if ($a50263ad9211bca8$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$a50263ad9211bca8$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}


function $25f01d490cb14aa2$export$2e2bcd8739ae039(actionCreators, dispatch) {
    var boundActionCreators = {};
    var _loop = function _loop(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = function() {
            return dispatch(actionCreator.apply(void 0, arguments));
        };
    };
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}


/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $bc0493fb0394ba01$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}


/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $978bef1eba267272$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


function $077367eddf9cdee3$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $bc0493fb0394ba01$export$2e2bcd8739ae039)(value)) (0, $978bef1eba267272$export$2e2bcd8739ae039)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}


function $8f04da16305d70eb$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $8f04da16305d70eb$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $8f04da16305d70eb$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $8f04da16305d70eb$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $8f04da16305d70eb$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}


function $80549e02e42365ae$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === 'function' ? (0, $8f04da16305d70eb$export$8d46c7f53c8c602f)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function $80549e02e42365ae$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $8f04da16305d70eb$export$710f7c60f68acd3e)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $80549e02e42365ae$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $8f04da16305d70eb$export$710f7c60f68acd3e)(function(dispatch) {
        return (0, $25f01d490cb14aa2$export$2e2bcd8739ae039)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $80549e02e42365ae$export$2e2bcd8739ae039 = [
    $80549e02e42365ae$export$a9f27b4b187c1166,
    $80549e02e42365ae$export$ba20d1a7aa0c4a90,
    $80549e02e42365ae$export$94a6e55709d4d961
];



function $5a43f52388deefcc$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === 'function' ? (0, $8f04da16305d70eb$export$8d46c7f53c8c602f)(mapStateToProps, 'mapStateToProps') : undefined;
}
function $5a43f52388deefcc$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $8f04da16305d70eb$export$710f7c60f68acd3e)(function() {
        return {};
    }) : undefined;
}
var $5a43f52388deefcc$export$2e2bcd8739ae039 = [
    $5a43f52388deefcc$export$23fc470827b14aa,
    $5a43f52388deefcc$export$514bc8c1a53c1d66
];




function $1e8db32eacd8bda4$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $3d1b110f42b1c650$export$2e2bcd8739ae039)({}, ownProps, stateProps, dispatchProps);
}
function $1e8db32eacd8bda4$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $1e8db32eacd8bda4$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === 'function' ? $1e8db32eacd8bda4$export$5b105939c84b5234(mergeProps) : undefined;
}
function $1e8db32eacd8bda4$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $1e8db32eacd8bda4$export$691c327fc30bc857;
    } : undefined;
}
var $1e8db32eacd8bda4$export$2e2bcd8739ae039 = [
    $1e8db32eacd8bda4$export$d61b680184bc3f00,
    $1e8db32eacd8bda4$export$a13ba70ef50dda6d
];




function $39f67307301882cc$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, $978bef1eba267272$export$2e2bcd8739ae039)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $39f67307301882cc$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $39f67307301882cc$var$verify(mapStateToProps, 'mapStateToProps', displayName);
    $39f67307301882cc$var$verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
    $39f67307301882cc$var$verify(mergeProps, 'mergeProps', displayName);
}


var $e13d1103d1820004$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $e13d1103d1820004$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $e13d1103d1820004$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $e13d1103d1820004$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $bdedc8073c2ca3ee$export$2e2bcd8739ae039)(_ref2, $e13d1103d1820004$var$_excluded);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? $e13d1103d1820004$export$d20c0c2ca6eb2b6f : $e13d1103d1820004$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}


var $ad1c01f2a894092c$var$_excluded = [
    "pure",
    "areStatesEqual",
    "areOwnPropsEqual",
    "areStatePropsEqual",
    "areMergedPropsEqual"
];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $ad1c01f2a894092c$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $ad1c01f2a894092c$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $ad1c01f2a894092c$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $3855a3ef991c0b82$export$2e2bcd8739ae039) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $5a43f52388deefcc$export$2e2bcd8739ae039) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $80549e02e42365ae$export$2e2bcd8739ae039) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $1e8db32eacd8bda4$export$2e2bcd8739ae039) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $e13d1103d1820004$export$2e2bcd8739ae039) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $ad1c01f2a894092c$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $a50263ad9211bca8$export$2e2bcd8739ae039) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $a50263ad9211bca8$export$2e2bcd8739ae039) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $a50263ad9211bca8$export$2e2bcd8739ae039) : _ref3$areMergedPropsE, extraOptions = (0, $bdedc8073c2ca3ee$export$2e2bcd8739ae039)(_ref3, $ad1c01f2a894092c$var$_excluded);
        var initMapStateToProps = $ad1c01f2a894092c$var$match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
        var initMapDispatchToProps = $ad1c01f2a894092c$var$match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
        var initMergeProps = $ad1c01f2a894092c$var$match(mergeProps, mergePropsFactories, 'mergeProps');
        return connectHOC(selectorFactory, (0, $3d1b110f42b1c650$export$2e2bcd8739ae039)({
            // used in error messages
            methodName: 'connect',
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $ad1c01f2a894092c$export$2e2bcd8739ae039 = /*#__PURE__*/ $ad1c01f2a894092c$export$9f9feb656dec1fc4();




var $NdCUR = parcelRequire("NdCUR");


var $NdCUR = parcelRequire("NdCUR");

function $ed5cc5abaffe2fbf$export$c1275ca9a6fd3ec5() {
    var contextValue = (0, $NdCUR.useContext)((0, $e671d894664c293a$export$cc80c08dc91f1c00));
    return contextValue;
}


function $8c925f10eb5cf184$export$671dba69185d0304(context) {
    if (context === void 0) context = (0, $e671d894664c293a$export$cc80c08dc91f1c00);
    var useReduxContext = context === (0, $e671d894664c293a$export$cc80c08dc91f1c00) ? (0, $ed5cc5abaffe2fbf$export$c1275ca9a6fd3ec5) : function() {
        return (0, $NdCUR.useContext)(context);
    };
    return function useStore() {
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
        return store;
    };
}
var $8c925f10eb5cf184$export$6ccbb43953eebf8 = /*#__PURE__*/ $8c925f10eb5cf184$export$671dba69185d0304();


function $cc214f6ed98ca6a9$export$bc9b55530897c558(context) {
    if (context === void 0) context = (0, $e671d894664c293a$export$cc80c08dc91f1c00);
    var useStore = context === (0, $e671d894664c293a$export$cc80c08dc91f1c00) ? (0, $8c925f10eb5cf184$export$6ccbb43953eebf8) : (0, $8c925f10eb5cf184$export$671dba69185d0304)(context);
    return function useDispatch() {
        var store = useStore();
        return store.dispatch;
    };
}
var $cc214f6ed98ca6a9$export$8ad76b76a4c905f8 = /*#__PURE__*/ $cc214f6ed98ca6a9$export$bc9b55530897c558();



var $NdCUR = parcelRequire("NdCUR");




var $21c2611adc7e451b$var$refEquality = function refEquality(a, b) {
    return a === b;
};
function $21c2611adc7e451b$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
    var _useReducer = (0, $NdCUR.useReducer)(function(s) {
        return s + 1;
    }, 0), forceRender = _useReducer[1];
    var subscription = (0, $NdCUR.useMemo)(function() {
        return (0, $14e79ed1f5ea0f1c$export$d567d2b9af322f8f)(store, contextSub);
    }, [
        store,
        contextSub
    ]);
    var latestSubscriptionCallbackError = (0, $NdCUR.useRef)();
    var latestSelector = (0, $NdCUR.useRef)();
    var latestStoreState = (0, $NdCUR.useRef)();
    var latestSelectedState = (0, $NdCUR.useRef)();
    var storeState = store.getState();
    var selectedState;
    try {
        if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
            var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
            if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) selectedState = newSelectedState;
            else selectedState = latestSelectedState.current;
        } else selectedState = latestSelectedState.current;
    } catch (err) {
        if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
        throw err;
    }
    (0, $c1d92aea347f874b$export$700979bc83e7db82)(function() {
        latestSelector.current = selector;
        latestStoreState.current = storeState;
        latestSelectedState.current = selectedState;
        latestSubscriptionCallbackError.current = undefined;
    });
    (0, $c1d92aea347f874b$export$700979bc83e7db82)(function() {
        function checkForUpdates() {
            try {
                var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
                if (newStoreState === latestStoreState.current) return;
                var _newSelectedState = latestSelector.current(newStoreState);
                if (equalityFn(_newSelectedState, latestSelectedState.current)) return;
                latestSelectedState.current = _newSelectedState;
                latestStoreState.current = newStoreState;
            } catch (err) {
                // we ignore all errors here, since when the component
                // is re-rendered, the selectors are called again, and
                // will throw again, if neither props nor store state
                // changed
                latestSubscriptionCallbackError.current = err;
            }
            forceRender();
        }
        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe();
        checkForUpdates();
        return function() {
            return subscription.tryUnsubscribe();
        };
    }, [
        store,
        subscription
    ]);
    return selectedState;
}
function $21c2611adc7e451b$export$2b53f90d2bd1cbfb(context) {
    if (context === void 0) context = (0, $e671d894664c293a$export$cc80c08dc91f1c00);
    var useReduxContext = context === (0, $e671d894664c293a$export$cc80c08dc91f1c00) ? (0, $ed5cc5abaffe2fbf$export$c1275ca9a6fd3ec5) : function() {
        return (0, $NdCUR.useContext)(context);
    };
    return function useSelector(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = $21c2611adc7e451b$var$refEquality;
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, contextSub = _useReduxContext.subscription;
        var selectedState = $21c2611adc7e451b$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
        (0, $NdCUR.useDebugValue)(selectedState);
        return selectedState;
    };
}
var $21c2611adc7e451b$export$2105062e25df4afe = /*#__PURE__*/ $21c2611adc7e451b$export$2b53f90d2bd1cbfb();






/* eslint-disable import/no-unresolved */ 
var $g2wso = parcelRequire("g2wso");


var $g2wso = parcelRequire("g2wso");

// with standard React renderers (ReactDOM, React Native)
(0, $f5f96d54078447f8$export$4b9874722d0da7bc)((0, $g2wso.unstable_batchedUpdates));


/* components */ var $06dab2fcf604e778$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $06dab2fcf604e778$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$06dab2fcf604e778$exports = $06dab2fcf604e778$var$invariant;



var $NdCUR = parcelRequire("NdCUR");
var $acabf759e6eea9b8$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 'use strict';

var $NdCUR = parcelRequire("NdCUR");
var $b895013b10aa24eb$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 'use strict';

var $haJ2X = parcelRequire("haJ2X");
// -- Inlined from fbjs --
var $b895013b10aa24eb$var$emptyObject = {};
var $b895013b10aa24eb$var$validateFormat = function validateFormat(format) {};
function $b895013b10aa24eb$var$_invariant(condition, format, a, b, c, d, e, f) {
    $b895013b10aa24eb$var$validateFormat(format);
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
}
var $b895013b10aa24eb$var$warning = function() {};
var $b895013b10aa24eb$var$printWarning;
// /-- Inlined from fbjs --
var $b895013b10aa24eb$var$MIXINS_KEY = 'mixins';
// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function $b895013b10aa24eb$var$identity(fn) {
    return fn;
}
var $b895013b10aa24eb$var$ReactPropTypeLocationNames;
$b895013b10aa24eb$var$ReactPropTypeLocationNames = {};
function $b895013b10aa24eb$var$factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
    /**
   * Policies that describe methods in `ReactClassInterface`.
   */ var injectedMixins = [];
    /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */ var ReactClassInterface = {
        /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */ mixins: 'DEFINE_MANY',
        /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */ statics: 'DEFINE_MANY',
        /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */ propTypes: 'DEFINE_MANY',
        /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */ contextTypes: 'DEFINE_MANY',
        /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */ childContextTypes: 'DEFINE_MANY',
        // ==== Definition methods ====
        /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */ getDefaultProps: 'DEFINE_MANY_MERGED',
        /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */ getInitialState: 'DEFINE_MANY_MERGED',
        /**
     * @return {object}
     * @optional
     */ getChildContext: 'DEFINE_MANY_MERGED',
        /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */ render: 'DEFINE_ONCE',
        // ==== Delegate methods ====
        /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */ componentWillMount: 'DEFINE_MANY',
        /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */ componentDidMount: 'DEFINE_MANY',
        /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */ componentWillReceiveProps: 'DEFINE_MANY',
        /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */ shouldComponentUpdate: 'DEFINE_ONCE',
        /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */ componentWillUpdate: 'DEFINE_MANY',
        /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */ componentDidUpdate: 'DEFINE_MANY',
        /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */ componentWillUnmount: 'DEFINE_MANY',
        /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */ UNSAFE_componentWillMount: 'DEFINE_MANY',
        /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */ UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
        /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */ UNSAFE_componentWillUpdate: 'DEFINE_MANY',
        // ==== Advanced methods ====
        /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */ updateComponent: 'OVERRIDE_BASE'
    };
    /**
   * Similar to ReactClassInterface but for static methods.
   */ var ReactClassStaticInterface = {
        /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */ getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
    };
    /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */ var RESERVED_SPEC_KEYS = {
        displayName: function(Constructor, displayName) {
            Constructor.displayName = displayName;
        },
        mixins: function(Constructor, mixins) {
            if (mixins) for(var i = 0; i < mixins.length; i++)mixSpecIntoComponent(Constructor, mixins[i]);
        },
        childContextTypes: function(Constructor, childContextTypes) {
            Constructor.childContextTypes = $haJ2X({}, Constructor.childContextTypes, childContextTypes);
        },
        contextTypes: function(Constructor, contextTypes) {
            Constructor.contextTypes = $haJ2X({}, Constructor.contextTypes, contextTypes);
        },
        /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */ getDefaultProps: function(Constructor, getDefaultProps) {
            if (Constructor.getDefaultProps) Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
            else Constructor.getDefaultProps = getDefaultProps;
        },
        propTypes: function(Constructor, propTypes) {
            Constructor.propTypes = $haJ2X({}, Constructor.propTypes, propTypes);
        },
        statics: function(Constructor, statics) {
            mixStaticSpecIntoComponent(Constructor, statics);
        },
        autobind: function() {}
    };
    function validateTypeDef(Constructor, typeDef, location) {
        for(var propName in typeDef)typeDef.hasOwnProperty(propName);
    }
    function validateMethodOverride(isAlreadyDefined, name) {
        var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
        // Disallow overriding of base class methods unless explicitly allowed.
        if (ReactClassMixin.hasOwnProperty(name)) $b895013b10aa24eb$var$_invariant(specPolicy === 'OVERRIDE_BASE', "ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.", name);
        // Disallow defining methods more than once unless explicitly allowed.
        if (isAlreadyDefined) $b895013b10aa24eb$var$_invariant(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED', "ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.", name);
    }
    /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */ function mixSpecIntoComponent(Constructor, spec) {
        if (!spec) {
            var typeofSpec, isMixinValid;
            return;
        }
        $b895013b10aa24eb$var$_invariant(typeof spec !== 'function', "ReactClass: You're attempting to use a component class or function as a mixin. Instead, just use a regular object.");
        $b895013b10aa24eb$var$_invariant(!isValidElement(spec), "ReactClass: You're attempting to use a component as a mixin. Instead, just use a regular object.");
        var proto = Constructor.prototype;
        var autoBindPairs = proto.__reactAutoBindPairs;
        // By handling mixins before any other properties, we ensure the same
        // chaining order is applied to methods with DEFINE_MANY policy, whether
        // mixins are listed before or after these methods in the spec.
        if (spec.hasOwnProperty($b895013b10aa24eb$var$MIXINS_KEY)) RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
        for(var name in spec){
            if (!spec.hasOwnProperty(name)) continue;
            if (name === $b895013b10aa24eb$var$MIXINS_KEY) continue;
            var property = spec[name];
            var isAlreadyDefined = proto.hasOwnProperty(name);
            validateMethodOverride(isAlreadyDefined, name);
            if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) RESERVED_SPEC_KEYS[name](Constructor, property);
            else {
                // Setup methods on prototype:
                // The following member methods should not be automatically bound:
                // 1. Expected ReactClass methods (in the "interface").
                // 2. Overridden methods (that were mixed in).
                var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
                var isFunction = typeof property === 'function';
                var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
                if (shouldAutoBind) {
                    autoBindPairs.push(name, property);
                    proto[name] = property;
                } else if (isAlreadyDefined) {
                    var specPolicy = ReactClassInterface[name];
                    // These cases should already be caught by validateMethodOverride.
                    $b895013b10aa24eb$var$_invariant(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY'), "ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.", specPolicy, name);
                    // For methods which are defined more than once, call the existing
                    // methods before calling the new property, merging if appropriate.
                    if (specPolicy === 'DEFINE_MANY_MERGED') proto[name] = createMergedResultFunction(proto[name], property);
                    else if (specPolicy === 'DEFINE_MANY') proto[name] = createChainedFunction(proto[name], property);
                } else proto[name] = property;
            }
        }
    }
    function mixStaticSpecIntoComponent(Constructor, statics) {
        if (!statics) return;
        for(var name in statics){
            var property = statics[name];
            if (!statics.hasOwnProperty(name)) continue;
            var isReserved = name in RESERVED_SPEC_KEYS;
            $b895013b10aa24eb$var$_invariant(!isReserved, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name);
            var isAlreadyDefined = name in Constructor;
            if (isAlreadyDefined) {
                var specPolicy = ReactClassStaticInterface.hasOwnProperty(name) ? ReactClassStaticInterface[name] : null;
                $b895013b10aa24eb$var$_invariant(specPolicy === 'DEFINE_MANY_MERGED', "ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.", name);
                Constructor[name] = createMergedResultFunction(Constructor[name], property);
                return;
            }
            Constructor[name] = property;
        }
    }
    /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */ function mergeIntoWithNoDuplicateKeys(one, two) {
        $b895013b10aa24eb$var$_invariant(one && two && typeof one === 'object' && typeof two === 'object', 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.');
        for(var key in two)if (two.hasOwnProperty(key)) {
            $b895013b10aa24eb$var$_invariant(one[key] === undefined, "mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.", key);
            one[key] = two[key];
        }
        return one;
    }
    /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */ function createMergedResultFunction(one, two) {
        return function mergedResult() {
            var a = one.apply(this, arguments);
            var b = two.apply(this, arguments);
            if (a == null) return b;
            else if (b == null) return a;
            var c = {};
            mergeIntoWithNoDuplicateKeys(c, a);
            mergeIntoWithNoDuplicateKeys(c, b);
            return c;
        };
    }
    /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */ function createChainedFunction(one, two) {
        return function chainedFunction() {
            one.apply(this, arguments);
            two.apply(this, arguments);
        };
    }
    /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */ function bindAutoBindMethod(component, method) {
        var boundMethod = method.bind(component);
        var componentName, _bind;
        return boundMethod;
    }
    /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */ function bindAutoBindMethods(component) {
        var pairs = component.__reactAutoBindPairs;
        for(var i = 0; i < pairs.length; i += 2){
            var autoBindKey = pairs[i];
            var method = pairs[i + 1];
            component[autoBindKey] = bindAutoBindMethod(component, method);
        }
    }
    var IsMountedPreMixin = {
        componentDidMount: function() {
            this.__isMounted = true;
        }
    };
    var IsMountedPostMixin = {
        componentWillUnmount: function() {
            this.__isMounted = false;
        }
    };
    /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */ var ReactClassMixin = {
        /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */ replaceState: function(newState, callback) {
            this.updater.enqueueReplaceState(this, newState, callback);
        },
        /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */ isMounted: function() {
            return !!this.__isMounted;
        }
    };
    var ReactClassComponent = function() {};
    $haJ2X(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
    /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */ function createClass(spec) {
        // To keep our warnings more understandable, we'll use a little hack here to
        // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
        // unnecessarily identify a class without displayName as 'Constructor'.
        var Constructor = $b895013b10aa24eb$var$identity(function(props, context, updater) {
            // Wire up auto-binding
            if (this.__reactAutoBindPairs.length) bindAutoBindMethods(this);
            this.props = props;
            this.context = context;
            this.refs = $b895013b10aa24eb$var$emptyObject;
            this.updater = updater || ReactNoopUpdateQueue;
            this.state = null;
            // ReactClasses doesn't have constructors. Instead, they use the
            // getInitialState and componentWillMount methods for initialization.
            var initialState = this.getInitialState ? this.getInitialState() : null;
            $b895013b10aa24eb$var$_invariant(typeof initialState === 'object' && !Array.isArray(initialState), '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent');
            this.state = initialState;
        });
        Constructor.prototype = new ReactClassComponent();
        Constructor.prototype.constructor = Constructor;
        Constructor.prototype.__reactAutoBindPairs = [];
        injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
        mixSpecIntoComponent(Constructor, IsMountedPreMixin);
        mixSpecIntoComponent(Constructor, spec);
        mixSpecIntoComponent(Constructor, IsMountedPostMixin);
        // Initialize the defaultProps property after all mixins have been merged.
        if (Constructor.getDefaultProps) Constructor.defaultProps = Constructor.getDefaultProps();
        $b895013b10aa24eb$var$_invariant(Constructor.prototype.render, 'createClass(...): Class specification must implement a `render` method.');
        // Reduce time spent doing lookups by setting these on the prototype.
        for(var methodName in ReactClassInterface)if (!Constructor.prototype[methodName]) Constructor.prototype[methodName] = null;
        return Constructor;
    }
    return createClass;
}
$b895013b10aa24eb$exports = $b895013b10aa24eb$var$factory;


if (typeof $NdCUR === 'undefined') throw Error("create-react-class could not find the React object. If you are using script tags, make sure that React is being loaded before create-react-class.");
// Hack to grab NoopUpdateQueue from isomorphic React
var $acabf759e6eea9b8$var$ReactNoopUpdateQueue = new $NdCUR.Component().updater;
$acabf759e6eea9b8$exports = $b895013b10aa24eb$exports($NdCUR.Component, $NdCUR.isValidElement, $acabf759e6eea9b8$var$ReactNoopUpdateQueue);



var $fGw9V = parcelRequire("fGw9V");
var $a6fffc526962516d$exports = {};
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $a6fffc526962516d$var$warning = function() {};
$a6fffc526962516d$exports = $a6fffc526962516d$var$warning;


var $d93390799696f79e$var$warned = {};
function $d93390799696f79e$export$2e2bcd8739ae039(falseToWarn, message) {
    // Only issue deprecation warnings once.
    if (message.indexOf('deprecated') !== -1) {
        if ($d93390799696f79e$var$warned[message]) return;
        $d93390799696f79e$var$warned[message] = true;
    }
    message = '[react-router] ' + message;
    for(var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    (0, (/*@__PURE__*/$parcel$interopDefault($a6fffc526962516d$exports))).apply(undefined, [
        falseToWarn,
        message
    ].concat(args));
}
function $d93390799696f79e$export$5cab780cdca981b6() {
    $d93390799696f79e$var$warned = {};
}



function $f0b6bffd1a813242$var$escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
function $f0b6bffd1a813242$var$_compilePattern(pattern) {
    var regexpSource = '';
    var paramNames = [];
    var tokens = [];
    var match = void 0, lastIndex = 0, matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
    while(match = matcher.exec(pattern)){
        if (match.index !== lastIndex) {
            tokens.push(pattern.slice(lastIndex, match.index));
            regexpSource += $f0b6bffd1a813242$var$escapeRegExp(pattern.slice(lastIndex, match.index));
        }
        if (match[1]) {
            regexpSource += '([^/]+)';
            paramNames.push(match[1]);
        } else if (match[0] === '**') {
            regexpSource += '(.*)';
            paramNames.push('splat');
        } else if (match[0] === '*') {
            regexpSource += '(.*?)';
            paramNames.push('splat');
        } else if (match[0] === '(') regexpSource += '(?:';
        else if (match[0] === ')') regexpSource += ')?';
        else if (match[0] === '\\(') regexpSource += '\\(';
        else if (match[0] === '\\)') regexpSource += '\\)';
        tokens.push(match[0]);
        lastIndex = matcher.lastIndex;
    }
    if (lastIndex !== pattern.length) {
        tokens.push(pattern.slice(lastIndex, pattern.length));
        regexpSource += $f0b6bffd1a813242$var$escapeRegExp(pattern.slice(lastIndex, pattern.length));
    }
    return {
        pattern: pattern,
        regexpSource: regexpSource,
        paramNames: paramNames,
        tokens: tokens
    };
}
var $f0b6bffd1a813242$var$CompiledPatternsCache = Object.create(null);
function $f0b6bffd1a813242$export$2db8af076f277cbf(pattern) {
    if (!$f0b6bffd1a813242$var$CompiledPatternsCache[pattern]) $f0b6bffd1a813242$var$CompiledPatternsCache[pattern] = $f0b6bffd1a813242$var$_compilePattern(pattern);
    return $f0b6bffd1a813242$var$CompiledPatternsCache[pattern];
}
function $f0b6bffd1a813242$export$69cf574f30fda100(pattern, pathname) {
    // Ensure pattern starts with leading slash for consistency with pathname.
    if (pattern.charAt(0) !== '/') pattern = '/' + pattern;
    var _compilePattern2 = $f0b6bffd1a813242$export$2db8af076f277cbf(pattern), regexpSource = _compilePattern2.regexpSource, paramNames = _compilePattern2.paramNames, tokens = _compilePattern2.tokens;
    if (pattern.charAt(pattern.length - 1) !== '/') regexpSource += '/?'; // Allow optional path separator at end.
    // Special-case patterns like '*' for catch-all routes.
    if (tokens[tokens.length - 1] === '*') regexpSource += '$';
    var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
    if (match == null) return null;
    var matchedPath = match[0];
    var remainingPathname = pathname.substr(matchedPath.length);
    if (remainingPathname) {
        // Require that the match ends at a path separator, if we didn't match
        // the full path, so any remaining pathname is a new path segment.
        if (matchedPath.charAt(matchedPath.length - 1) !== '/') return null;
        // If there is a remaining pathname, treat the path separator as part of
        // the remaining pathname for properly continuing the match.
        remainingPathname = '/' + remainingPathname;
    }
    return {
        remainingPathname: remainingPathname,
        paramNames: paramNames,
        paramValues: match.slice(1).map(function(v) {
            return v && decodeURIComponent(v);
        })
    };
}
function $f0b6bffd1a813242$export$61270afbfe1c36ea(pattern) {
    return $f0b6bffd1a813242$export$2db8af076f277cbf(pattern).paramNames;
}
function $f0b6bffd1a813242$export$ec161d740909e39d(pattern, pathname) {
    var match = $f0b6bffd1a813242$export$69cf574f30fda100(pattern, pathname);
    if (!match) return null;
    var paramNames = match.paramNames, paramValues = match.paramValues;
    var params = {};
    paramNames.forEach(function(paramName, index) {
        params[paramName] = paramValues[index];
    });
    return params;
}
function $f0b6bffd1a813242$export$5fc023054452162e(pattern, params) {
    params = params || {};
    var _compilePattern3 = $f0b6bffd1a813242$export$2db8af076f277cbf(pattern), tokens = _compilePattern3.tokens;
    var parenCount = 0, pathname = '', splatIndex = 0, parenHistory = [];
    var token = void 0, paramName = void 0, paramValue = void 0;
    for(var i = 0, len = tokens.length; i < len; ++i){
        token = tokens[i];
        if (token === '*' || token === '**') {
            paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
            !(paramValue != null || parenCount > 0) && (0, (/*@__PURE__*/$parcel$interopDefault($06dab2fcf604e778$exports)))(false);
            if (paramValue != null) pathname += encodeURI(paramValue);
        } else if (token === '(') {
            parenHistory[parenCount] = '';
            parenCount += 1;
        } else if (token === ')') {
            var parenText = parenHistory.pop();
            parenCount -= 1;
            if (parenCount) parenHistory[parenCount - 1] += parenText;
            else pathname += parenText;
        } else if (token === '\\(') pathname += '(';
        else if (token === '\\)') pathname += ')';
        else if (token.charAt(0) === ':') {
            paramName = token.substring(1);
            paramValue = params[paramName];
            !(paramValue != null || parenCount > 0) && (0, (/*@__PURE__*/$parcel$interopDefault($06dab2fcf604e778$exports)))(false);
            if (paramValue == null) {
                if (parenCount) {
                    parenHistory[parenCount - 1] = '';
                    var curTokenIdx = tokens.indexOf(token);
                    var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
                    var nextParenIdx = -1;
                    for(var _i = 0; _i < tokensSubset.length; _i++)if (tokensSubset[_i] == ')') {
                        nextParenIdx = _i;
                        break;
                    }
                    !(nextParenIdx > 0) && (0, (/*@__PURE__*/$parcel$interopDefault($06dab2fcf604e778$exports)))(false);
                    // jump to ending paren
                    i = curTokenIdx + nextParenIdx - 1;
                }
            } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);
            else pathname += encodeURIComponent(paramValue);
        } else if (parenCount) parenHistory[parenCount - 1] += token;
        else pathname += token;
    }
    !(parenCount <= 0) && (0, (/*@__PURE__*/$parcel$interopDefault($06dab2fcf604e778$exports)))(false);
    return pathname.replace(/\/+/g, '/');
}


function $2f9e972a291b92d8$var$routeParamsChanged(route, prevState, nextState) {
    if (!route.path) return false;
    var paramNames = (0, $f0b6bffd1a813242$export$61270afbfe1c36ea)(route.path);
    return paramNames.some(function(paramName) {
        return prevState.params[paramName] !== nextState.params[paramName];
    });
}
/**
 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
 * the change from prevState to nextState. We leave routes if either
 * 1) they are not in the next state or 2) they are in the next state
 * but their params have changed (i.e. /users/123 => /users/456).
 *
 * leaveRoutes are ordered starting at the leaf route of the tree
 * we're leaving up to the common parent route. enterRoutes are ordered
 * from the top of the tree we're entering down to the leaf route.
 *
 * changeRoutes are any routes that didn't leave or enter during
 * the transition.
 */ function $2f9e972a291b92d8$var$computeChangedRoutes(prevState, nextState) {
    var prevRoutes = prevState && prevState.routes;
    var nextRoutes = nextState.routes;
    var leaveRoutes = void 0, changeRoutes = void 0, enterRoutes = void 0;
    if (prevRoutes) {
        var parentIsLeaving = false;
        leaveRoutes = prevRoutes.filter(function(route) {
            if (parentIsLeaving) return true;
            else {
                var isLeaving = nextRoutes.indexOf(route) === -1 || $2f9e972a291b92d8$var$routeParamsChanged(route, prevState, nextState);
                if (isLeaving) parentIsLeaving = true;
                return isLeaving;
            }
        });
        // onLeave hooks start at the leaf route.
        leaveRoutes.reverse();
        enterRoutes = [];
        changeRoutes = [];
        nextRoutes.forEach(function(route) {
            var isNew = prevRoutes.indexOf(route) === -1;
            var paramsChanged = leaveRoutes.indexOf(route) !== -1;
            if (isNew || paramsChanged) enterRoutes.push(route);
            else changeRoutes.push(route);
        });
    } else {
        leaveRoutes = [];
        changeRoutes = [];
        enterRoutes = nextRoutes;
    }
    return {
        leaveRoutes: leaveRoutes,
        changeRoutes: changeRoutes,
        enterRoutes: enterRoutes
    };
}
var $2f9e972a291b92d8$export$2e2bcd8739ae039 = $2f9e972a291b92d8$var$computeChangedRoutes;


function $6eb82d2931f59b4a$export$9ec2b9560cd357f8(turns, work, callback) {
    var currentTurn = 0, isDone = false;
    var sync = false, hasNext = false, doneArgs = void 0;
    function done() {
        isDone = true;
        if (sync) {
            // Iterate instead of recursing if possible.
            doneArgs = [].concat(Array.prototype.slice.call(arguments));
            return;
        }
        callback.apply(this, arguments);
    }
    function next() {
        if (isDone) return;
        hasNext = true;
        if (sync) // Iterate instead of recursing if possible.
        return;
        sync = true;
        while(!isDone && currentTurn < turns && hasNext){
            hasNext = false;
            work.call(this, currentTurn++, next, done);
        }
        sync = false;
        if (isDone) {
            // This means the loop finished synchronously.
            callback.apply(this, doneArgs);
            return;
        }
        if (currentTurn >= turns && hasNext) {
            isDone = true;
            callback();
        }
    }
    next();
}
function $6eb82d2931f59b4a$export$a939ddd3409bd57a(array, work, callback) {
    var length = array.length;
    var values = [];
    if (length === 0) return callback(null, values);
    var isDone = false, doneCount = 0;
    function done(index, error, value) {
        if (isDone) return;
        if (error) {
            isDone = true;
            callback(error);
        } else {
            values[index] = value;
            isDone = ++doneCount === length;
            if (isDone) callback(null, values);
        }
    }
    array.forEach(function(item, index) {
        work(item, index, function(error, value) {
            done(index, error, value);
        });
    });
}


function $d8ac39bbf2be1b59$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $d8ac39bbf2be1b59$var$PendingHooks = function PendingHooks() {
    var _this = this;
    $d8ac39bbf2be1b59$var$_classCallCheck(this, PendingHooks);
    this.hooks = [];
    this.add = function(hook) {
        return _this.hooks.push(hook);
    };
    this.remove = function(hook) {
        return _this.hooks = _this.hooks.filter(function(h) {
            return h !== hook;
        });
    };
    this.has = function(hook) {
        return _this.hooks.indexOf(hook) !== -1;
    };
    this.clear = function() {
        return _this.hooks = [];
    };
};
function $d8ac39bbf2be1b59$export$2e2bcd8739ae039() {
    var enterHooks = new $d8ac39bbf2be1b59$var$PendingHooks();
    var changeHooks = new $d8ac39bbf2be1b59$var$PendingHooks();
    function createTransitionHook(hook, route, asyncArity, pendingHooks) {
        var isSync = hook.length < asyncArity;
        var transitionHook = function transitionHook() {
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            hook.apply(route, args);
            if (isSync) {
                var callback = args[args.length - 1];
                // Assume hook executes synchronously and
                // automatically call the callback.
                callback();
            }
        };
        pendingHooks.add(transitionHook);
        return transitionHook;
    }
    function getEnterHooks(routes) {
        return routes.reduce(function(hooks, route) {
            if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
            return hooks;
        }, []);
    }
    function getChangeHooks(routes) {
        return routes.reduce(function(hooks, route) {
            if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
            return hooks;
        }, []);
    }
    function runTransitionHooks(length, iter, callback) {
        if (!length) {
            callback();
            return;
        }
        var redirectInfo = void 0;
        function replace(location) {
            redirectInfo = location;
        }
        (0, $6eb82d2931f59b4a$export$9ec2b9560cd357f8)(length, function(index, next, done) {
            iter(index, replace, function(error) {
                if (error || redirectInfo) done(error, redirectInfo); // No need to continue.
                else next();
            });
        }, callback);
    }
    /**
   * Runs all onEnter hooks in the given array of routes in order
   * with onEnter(nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */ function runEnterHooks(routes, nextState, callback) {
        enterHooks.clear();
        var hooks = getEnterHooks(routes);
        return runTransitionHooks(hooks.length, function(index, replace, next) {
            var wrappedNext = function wrappedNext() {
                if (enterHooks.has(hooks[index])) {
                    next.apply(undefined, arguments);
                    enterHooks.remove(hooks[index]);
                }
            };
            hooks[index](nextState, replace, wrappedNext);
        }, callback);
    }
    /**
   * Runs all onChange hooks in the given array of routes in order
   * with onChange(prevState, nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */ function runChangeHooks(routes, state, nextState, callback) {
        changeHooks.clear();
        var hooks = getChangeHooks(routes);
        return runTransitionHooks(hooks.length, function(index, replace, next) {
            var wrappedNext = function wrappedNext() {
                if (changeHooks.has(hooks[index])) {
                    next.apply(undefined, arguments);
                    changeHooks.remove(hooks[index]);
                }
            };
            hooks[index](state, nextState, replace, wrappedNext);
        }, callback);
    }
    /**
   * Runs all onLeave hooks in the given array of routes in order.
   */ function runLeaveHooks(routes, prevState) {
        for(var i = 0, len = routes.length; i < len; ++i)if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
    }
    return {
        runEnterHooks: runEnterHooks,
        runChangeHooks: runChangeHooks,
        runLeaveHooks: runLeaveHooks
    };
}



var $d11dad763ab1b1a8$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $d11dad763ab1b1a8$var$deepEqual(a, b) {
    if (a == b) return true;
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $d11dad763ab1b1a8$var$deepEqual(item, b[index]);
    });
    if ((typeof a === 'undefined' ? 'undefined' : $d11dad763ab1b1a8$var$_typeof(a)) === 'object') {
        for(var p in a){
            if (!Object.prototype.hasOwnProperty.call(a, p)) continue;
            if (a[p] === undefined) {
                if (b[p] !== undefined) return false;
            } else if (!Object.prototype.hasOwnProperty.call(b, p)) return false;
            else if (!$d11dad763ab1b1a8$var$deepEqual(a[p], b[p])) return false;
        }
        return true;
    }
    return String(a) === String(b);
}
/**
 * Returns true if the current pathname matches the supplied one, net of
 * leading and trailing slash normalization. This is sufficient for an
 * indexOnly route match.
 */ function $d11dad763ab1b1a8$var$pathIsActive(pathname, currentPathname) {
    // Normalize leading slash for consistency. Leading slash on pathname has
    // already been normalized in isActive. See caveat there.
    if (currentPathname.charAt(0) !== '/') currentPathname = '/' + currentPathname;
    // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
    // `/foo` as active, but in this case, we would already have failed the
    // match.
    if (pathname.charAt(pathname.length - 1) !== '/') pathname += '/';
    if (currentPathname.charAt(currentPathname.length - 1) !== '/') currentPathname += '/';
    return currentPathname === pathname;
}
/**
 * Returns true if the given pathname matches the active routes and params.
 */ function $d11dad763ab1b1a8$var$routeIsActive(pathname, routes, params) {
    var remainingPathname = pathname, paramNames = [], paramValues = [];
    // for...of would work here but it's probably slower post-transpilation.
    for(var i = 0, len = routes.length; i < len; ++i){
        var route = routes[i];
        var pattern = route.path || '';
        if (pattern.charAt(0) === '/') {
            remainingPathname = pathname;
            paramNames = [];
            paramValues = [];
        }
        if (remainingPathname !== null && pattern) {
            var matched = (0, $f0b6bffd1a813242$export$69cf574f30fda100)(pattern, remainingPathname);
            if (matched) {
                remainingPathname = matched.remainingPathname;
                paramNames = [].concat(paramNames, matched.paramNames);
                paramValues = [].concat(paramValues, matched.paramValues);
            } else remainingPathname = null;
            if (remainingPathname === '') // We have an exact match on the route. Just check that all the params
            // match.
            // FIXME: This doesn't work on repeated params.
            return paramNames.every(function(paramName, index) {
                return String(paramValues[index]) === String(params[paramName]);
            });
        }
    }
    return false;
}
/**
 * Returns true if all key/value pairs in the given query are
 * currently active.
 */ function $d11dad763ab1b1a8$var$queryIsActive(query, activeQuery) {
    if (activeQuery == null) return query == null;
    if (query == null) return true;
    return $d11dad763ab1b1a8$var$deepEqual(query, activeQuery);
}
function $d11dad763ab1b1a8$export$2e2bcd8739ae039(_ref, indexOnly, currentLocation, routes, params) {
    var pathname = _ref.pathname, query = _ref.query;
    if (currentLocation == null) return false;
    // TODO: This is a bit ugly. It keeps around support for treating pathnames
    // without preceding slashes as absolute paths, but possibly also works
    // around the same quirks with basenames as in matchRoutes.
    if (pathname.charAt(0) !== '/') pathname = '/' + pathname;
    if (!$d11dad763ab1b1a8$var$pathIsActive(pathname, currentLocation.pathname)) {
        // The path check is necessary and sufficient for indexOnly, but otherwise
        // we still need to check the routes.
        if (indexOnly || !$d11dad763ab1b1a8$var$routeIsActive(pathname, routes, params)) return false;
    }
    return $d11dad763ab1b1a8$var$queryIsActive(query, currentLocation.query);
}



function $374bb8ce51825ec2$export$4369c812aac99591(obj) {
    return obj && typeof obj.then === 'function';
}


function $4731ae3c929b2b00$var$getComponentsForRoute(nextState, route, callback) {
    if (route.component || route.components) {
        callback(null, route.component || route.components);
        return;
    }
    var getComponent = route.getComponent || route.getComponents;
    if (getComponent) {
        var componentReturn = getComponent.call(route, nextState, callback);
        if ((0, $374bb8ce51825ec2$export$4369c812aac99591)(componentReturn)) componentReturn.then(function(component) {
            return callback(null, component);
        }, callback);
    } else callback();
}
/**
 * Asynchronously fetches all components needed for the given router
 * state and calls callback(error, components) when finished.
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getComponents method.
 */ function $4731ae3c929b2b00$var$getComponents(nextState, callback) {
    (0, $6eb82d2931f59b4a$export$a939ddd3409bd57a)(nextState.routes, function(route, index, callback) {
        $4731ae3c929b2b00$var$getComponentsForRoute(nextState, route, callback);
    }, callback);
}
var $4731ae3c929b2b00$export$2e2bcd8739ae039 = $4731ae3c929b2b00$var$getComponents;







var $NdCUR = parcelRequire("NdCUR");
var $7f09464ec030dbdb$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $7f09464ec030dbdb$var$isValidChild(object) {
    return object == null || (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).isValidElement(object);
}
function $7f09464ec030dbdb$export$c1d0e3bf7c5375f6(object) {
    return $7f09464ec030dbdb$var$isValidChild(object) || Array.isArray(object) && object.every($7f09464ec030dbdb$var$isValidChild);
}
function $7f09464ec030dbdb$var$createRoute(defaultProps, props) {
    return $7f09464ec030dbdb$var$_extends({}, defaultProps, props);
}
function $7f09464ec030dbdb$export$d11cfea1c6fa899d(element) {
    var type = element.type;
    var route = $7f09464ec030dbdb$var$createRoute(type.defaultProps, element.props);
    if (route.children) {
        var childRoutes = $7f09464ec030dbdb$export$cba97696d7b05a04(route.children, route);
        if (childRoutes.length) route.childRoutes = childRoutes;
        delete route.children;
    }
    return route;
}
function $7f09464ec030dbdb$export$cba97696d7b05a04(children, parentRoute) {
    var routes = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Children.forEach(children, function(element) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).isValidElement(element)) {
            // Component classes may have a static create* method.
            if (element.type.createRouteFromReactElement) {
                var route = element.type.createRouteFromReactElement(element, parentRoute);
                if (route) routes.push(route);
            } else routes.push($7f09464ec030dbdb$export$d11cfea1c6fa899d(element));
        }
    });
    return routes;
}
function $7f09464ec030dbdb$export$dfc730c04fdecfcb(routes) {
    if ($7f09464ec030dbdb$export$c1d0e3bf7c5375f6(routes)) routes = $7f09464ec030dbdb$export$cba97696d7b05a04(routes);
    else if (routes && !Array.isArray(routes)) routes = [
        routes
    ];
    return routes;
}


var $a2f9f569fb34f443$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $a2f9f569fb34f443$var$getChildRoutes(route, location, paramNames, paramValues, callback) {
    if (route.childRoutes) return [
        null,
        route.childRoutes
    ];
    if (!route.getChildRoutes) return [];
    var sync = true, result = void 0;
    var partialNextState = {
        location: location,
        params: $a2f9f569fb34f443$var$createParams(paramNames, paramValues)
    };
    var childRoutesReturn = route.getChildRoutes(partialNextState, function(error, childRoutes) {
        childRoutes = !error && (0, $7f09464ec030dbdb$export$dfc730c04fdecfcb)(childRoutes);
        if (sync) {
            result = [
                error,
                childRoutes
            ];
            return;
        }
        callback(error, childRoutes);
    });
    if ((0, $374bb8ce51825ec2$export$4369c812aac99591)(childRoutesReturn)) childRoutesReturn.then(function(childRoutes) {
        return callback(null, (0, $7f09464ec030dbdb$export$dfc730c04fdecfcb)(childRoutes));
    }, callback);
    sync = false;
    return result; // Might be undefined.
}
function $a2f9f569fb34f443$var$getIndexRoute(route, location, paramNames, paramValues, callback) {
    if (route.indexRoute) callback(null, route.indexRoute);
    else if (route.getIndexRoute) {
        var partialNextState = {
            location: location,
            params: $a2f9f569fb34f443$var$createParams(paramNames, paramValues)
        };
        var indexRoutesReturn = route.getIndexRoute(partialNextState, function(error, indexRoute) {
            callback(error, !error && (0, $7f09464ec030dbdb$export$dfc730c04fdecfcb)(indexRoute)[0]);
        });
        if ((0, $374bb8ce51825ec2$export$4369c812aac99591)(indexRoutesReturn)) indexRoutesReturn.then(function(indexRoute) {
            return callback(null, (0, $7f09464ec030dbdb$export$dfc730c04fdecfcb)(indexRoute)[0]);
        }, callback);
    } else if (route.childRoutes || route.getChildRoutes) {
        var onChildRoutes = function onChildRoutes(error, childRoutes) {
            if (error) {
                callback(error);
                return;
            }
            var pathless = childRoutes.filter(function(childRoute) {
                return !childRoute.path;
            });
            (0, $6eb82d2931f59b4a$export$9ec2b9560cd357f8)(pathless.length, function(index, next, done) {
                $a2f9f569fb34f443$var$getIndexRoute(pathless[index], location, paramNames, paramValues, function(error, indexRoute) {
                    if (error || indexRoute) {
                        var routes = [
                            pathless[index]
                        ].concat(Array.isArray(indexRoute) ? indexRoute : [
                            indexRoute
                        ]);
                        done(error, routes);
                    } else next();
                });
            }, function(err, routes) {
                callback(null, routes);
            });
        };
        var result = $a2f9f569fb34f443$var$getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
        if (result) onChildRoutes.apply(undefined, result);
    } else callback();
}
function $a2f9f569fb34f443$var$assignParams(params, paramNames, paramValues) {
    return paramNames.reduce(function(params, paramName, index) {
        var paramValue = paramValues && paramValues[index];
        if (Array.isArray(params[paramName])) params[paramName].push(paramValue);
        else if (paramName in params) params[paramName] = [
            params[paramName],
            paramValue
        ];
        else params[paramName] = paramValue;
        return params;
    }, params);
}
function $a2f9f569fb34f443$var$createParams(paramNames, paramValues) {
    return $a2f9f569fb34f443$var$assignParams({}, paramNames, paramValues);
}
function $a2f9f569fb34f443$var$matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
    var pattern = route.path || '';
    if (pattern.charAt(0) === '/') {
        remainingPathname = location.pathname;
        paramNames = [];
        paramValues = [];
    }
    // Only try to match the path if the route actually has a pattern, and if
    // we're not just searching for potential nested absolute paths.
    if (remainingPathname !== null && pattern) {
        try {
            var matched = (0, $f0b6bffd1a813242$export$69cf574f30fda100)(pattern, remainingPathname);
            if (matched) {
                remainingPathname = matched.remainingPathname;
                paramNames = [].concat(paramNames, matched.paramNames);
                paramValues = [].concat(paramValues, matched.paramValues);
            } else remainingPathname = null;
        } catch (error) {
            callback(error);
        }
        // By assumption, pattern is non-empty here, which is the prerequisite for
        // actually terminating a match.
        if (remainingPathname === '') {
            var match = {
                routes: [
                    route
                ],
                params: $a2f9f569fb34f443$var$createParams(paramNames, paramValues)
            };
            $a2f9f569fb34f443$var$getIndexRoute(route, location, paramNames, paramValues, function(error, indexRoute) {
                if (error) callback(error);
                else {
                    if (Array.isArray(indexRoute)) {
                        var _match$routes;
                        (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
                    } else if (indexRoute) match.routes.push(indexRoute);
                    callback(null, match);
                }
            });
            return;
        }
    }
    if (remainingPathname != null || route.childRoutes) {
        // Either a) this route matched at least some of the path or b)
        // we don't have to load this route's children asynchronously. In
        // either case continue checking for matches in the subtree.
        var onChildRoutes = function onChildRoutes(error, childRoutes) {
            if (error) callback(error);
            else if (childRoutes) // Check the child routes to see if any of them match.
            $a2f9f569fb34f443$export$2e2bcd8739ae039(childRoutes, location, function(error, match) {
                if (error) callback(error);
                else if (match) {
                    // A child route matched! Augment the match and pass it up the stack.
                    match.routes.unshift(route);
                    callback(null, match);
                } else callback();
            }, remainingPathname, paramNames, paramValues);
            else callback();
        };
        var result = $a2f9f569fb34f443$var$getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
        if (result) onChildRoutes.apply(undefined, result);
    } else callback();
}
function $a2f9f569fb34f443$export$2e2bcd8739ae039(routes, location, callback, remainingPathname) {
    var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
    if (remainingPathname === undefined) {
        // TODO: This is a little bit ugly, but it works around a quirk in history
        // that strips the leading slash from pathnames when using basenames with
        // trailing slashes.
        if (location.pathname.charAt(0) !== '/') location = $a2f9f569fb34f443$var$_extends({}, location, {
            pathname: '/' + location.pathname
        });
        remainingPathname = location.pathname;
    }
    (0, $6eb82d2931f59b4a$export$9ec2b9560cd357f8)(routes.length, function(index, next, done) {
        $a2f9f569fb34f443$var$matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function(error, match) {
            if (error || match) done(error, match);
            else next();
        });
    }, callback);
}


var $b5bf5a142c1cba35$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $b5bf5a142c1cba35$var$hasAnyProperties(object) {
    for(var p in object){
        if (Object.prototype.hasOwnProperty.call(object, p)) return true;
    }
    return false;
}
function $b5bf5a142c1cba35$export$2e2bcd8739ae039(history, routes) {
    var state = {};
    var _getTransitionUtils = (0, $d8ac39bbf2be1b59$export$2e2bcd8739ae039)(), runEnterHooks = _getTransitionUtils.runEnterHooks, runChangeHooks = _getTransitionUtils.runChangeHooks, runLeaveHooks = _getTransitionUtils.runLeaveHooks;
    // Signature should be (location, indexOnly), but needs to support (path,
    // query, indexOnly)
    function isActive(location, indexOnly) {
        location = history.createLocation(location);
        return (0, $d11dad763ab1b1a8$export$2e2bcd8739ae039)(location, indexOnly, state.location, state.routes, state.params);
    }
    var partialNextState = void 0;
    function match(location, callback) {
        if (partialNextState && partialNextState.location === location) // Continue from where we left off.
        finishMatch(partialNextState, callback);
        else (0, $a2f9f569fb34f443$export$2e2bcd8739ae039)(routes, location, function(error, nextState) {
            if (error) callback(error);
            else if (nextState) finishMatch($b5bf5a142c1cba35$var$_extends({}, nextState, {
                location: location
            }), callback);
            else callback();
        });
    }
    function finishMatch(nextState, callback) {
        var _computeChangedRoutes = (0, $2f9e972a291b92d8$export$2e2bcd8739ae039)(state, nextState), leaveRoutes = _computeChangedRoutes.leaveRoutes, changeRoutes = _computeChangedRoutes.changeRoutes, enterRoutes = _computeChangedRoutes.enterRoutes;
        runLeaveHooks(leaveRoutes, state);
        // Tear down confirmation hooks for left routes
        leaveRoutes.filter(function(route) {
            return enterRoutes.indexOf(route) === -1;
        }).forEach(removeListenBeforeHooksForRoute);
        // change and enter hooks are run in series
        runChangeHooks(changeRoutes, state, nextState, function(error, redirectInfo) {
            if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
            runEnterHooks(enterRoutes, nextState, finishEnterHooks);
        });
        function finishEnterHooks(error, redirectInfo) {
            if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
            // TODO: Fetch components after state is updated.
            (0, $4731ae3c929b2b00$export$2e2bcd8739ae039)(nextState, function(error, components) {
                if (error) callback(error);
                else // TODO: Make match a pure function and have some other API
                // for "match and update state".
                callback(null, null, state = $b5bf5a142c1cba35$var$_extends({}, nextState, {
                    components: components
                }));
            });
        }
        function handleErrorOrRedirect(error, redirectInfo) {
            if (error) callback(error);
            else callback(null, redirectInfo);
        }
    }
    var RouteGuid = 1;
    function getRouteID(route) {
        var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        return route.__id__ || create && (route.__id__ = RouteGuid++);
    }
    var RouteHooks = Object.create(null);
    function getRouteHooksForRoutes(routes) {
        return routes.map(function(route) {
            return RouteHooks[getRouteID(route)];
        }).filter(function(hook) {
            return hook;
        });
    }
    function transitionHook(location, callback) {
        (0, $a2f9f569fb34f443$export$2e2bcd8739ae039)(routes, location, function(error, nextState) {
            if (nextState == null) {
                // TODO: We didn't actually match anything, but hang
                // onto error/nextState so we don't have to matchRoutes
                // again in the listen callback.
                callback();
                return;
            }
            // Cache some state here so we don't have to
            // matchRoutes() again in the listen callback.
            partialNextState = $b5bf5a142c1cba35$var$_extends({}, nextState, {
                location: location
            });
            var hooks = getRouteHooksForRoutes((0, $2f9e972a291b92d8$export$2e2bcd8739ae039)(state, partialNextState).leaveRoutes);
            var result = void 0;
            for(var i = 0, len = hooks.length; result == null && i < len; ++i)// Passing the location arg here indicates to
            // the user that this is a transition hook.
            result = hooks[i](location);
            callback(result);
        });
    }
    /* istanbul ignore next: untestable with Karma */ function beforeUnloadHook() {
        // Synchronously check to see if any route hooks want
        // to prevent the current window/tab from closing.
        if (state.routes) {
            var hooks = getRouteHooksForRoutes(state.routes);
            var message = void 0;
            for(var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i)// Passing no args indicates to the user that this is a
            // beforeunload hook. We don't know the next location.
            message = hooks[i]();
            return message;
        }
    }
    var unlistenBefore = void 0, unlistenBeforeUnload = void 0;
    function removeListenBeforeHooksForRoute(route) {
        var routeID = getRouteID(route);
        if (!routeID) return;
        delete RouteHooks[routeID];
        if (!$b5bf5a142c1cba35$var$hasAnyProperties(RouteHooks)) {
            // teardown transition & beforeunload hooks
            if (unlistenBefore) {
                unlistenBefore();
                unlistenBefore = null;
            }
            if (unlistenBeforeUnload) {
                unlistenBeforeUnload();
                unlistenBeforeUnload = null;
            }
        }
    }
    /**
   * Registers the given hook function to run before leaving the given route.
   *
   * During a normal transition, the hook function receives the next location
   * as its only argument and can return either a prompt message (string) to show the user,
   * to make sure they want to leave the page; or `false`, to prevent the transition.
   * Any other return value will have no effect.
   *
   * During the beforeunload event (in browsers) the hook receives no arguments.
   * In this case it must return a prompt message to prevent the transition.
   *
   * Returns a function that may be used to unbind the listener.
   */ function listenBeforeLeavingRoute(route, hook) {
        var thereWereNoRouteHooks = !$b5bf5a142c1cba35$var$hasAnyProperties(RouteHooks);
        var routeID = getRouteID(route, true);
        RouteHooks[routeID] = hook;
        if (thereWereNoRouteHooks) {
            // setup transition & beforeunload hooks
            unlistenBefore = history.listenBefore(transitionHook);
            if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
        }
        return function() {
            removeListenBeforeHooksForRoute(route);
        };
    }
    /**
   * This is the API for stateful environments. As the location
   * changes, we update state and call the listener. We can also
   * gracefully handle errors and redirects.
   */ function listen(listener) {
        function historyListener(location) {
            if (state.location === location) listener(null, state);
            else match(location, function(error, redirectLocation, nextState) {
                if (error) listener(error);
                else if (redirectLocation) history.replace(redirectLocation);
                else if (nextState) listener(null, nextState);
            });
        }
        // TODO: Only use a single history listener. Otherwise we'll end up with
        // multiple concurrent calls to match.
        // Set up the history listener first in case the initial match redirects.
        var unsubscribe = history.listen(historyListener);
        if (state.location) // Picking up on a matchContext.
        listener(null, state);
        else historyListener(history.getCurrentLocation());
        return unsubscribe;
    }
    return {
        isActive: isActive,
        match: match,
        listenBeforeLeavingRoute: listenBeforeLeavingRoute,
        listen: listen
    };
}



var $fGw9V = parcelRequire("fGw9V");
function $0b1dbabbd5385627$export$74775dafe30d0d0a(props, propName, componentName) {
    if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
}
var $0b1dbabbd5385627$export$55abd4691b317664 = (0, $fGw9V.shape)({
    listen: (0, $fGw9V.func).isRequired,
    push: (0, $fGw9V.func).isRequired,
    replace: (0, $fGw9V.func).isRequired,
    go: (0, $fGw9V.func).isRequired,
    goBack: (0, $fGw9V.func).isRequired,
    goForward: (0, $fGw9V.func).isRequired
});
var $0b1dbabbd5385627$export$d8556a2a8f973135 = (0, $fGw9V.elementType);
var $0b1dbabbd5385627$export$9b5ac10f59f76296 = (0, $fGw9V.oneOfType)([
    $0b1dbabbd5385627$export$d8556a2a8f973135,
    (0, $fGw9V.object)
]);
var $0b1dbabbd5385627$export$4cb887bfde2d34ca = (0, $fGw9V.oneOfType)([
    (0, $fGw9V.object),
    (0, $fGw9V.element)
]);
var $0b1dbabbd5385627$export$66b32f6f30eb4b4 = (0, $fGw9V.oneOfType)([
    $0b1dbabbd5385627$export$4cb887bfde2d34ca,
    (0, $fGw9V.arrayOf)($0b1dbabbd5385627$export$4cb887bfde2d34ca)
]);




var $NdCUR = parcelRequire("NdCUR");



var $fGw9V = parcelRequire("fGw9V");

/**
 * Extracts an object of params the given route cares about from
 * the given params object.
 */ function $2f4df2bce982beca$var$getRouteParams(route, params) {
    var routeParams = {};
    if (!route.path) return routeParams;
    (0, $f0b6bffd1a813242$export$61270afbfe1c36ea)(route.path).forEach(function(p) {
        if (Object.prototype.hasOwnProperty.call(params, p)) routeParams[p] = params[p];
    });
    return routeParams;
}
var $2f4df2bce982beca$export$2e2bcd8739ae039 = $2f4df2bce982beca$var$getRouteParams;



var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");
// Works around issues with context updates failing to propagate.
// Caveat: the context value is expected to never change its identity.
// https://github.com/facebook/react/issues/2517
// https://github.com/reactjs/react-router/issues/470
var $261028c86f371c3b$var$contextProviderShape = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V))).shape({
    subscribe: (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V))).func.isRequired,
    eventIndex: (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V))).number.isRequired
});
function $261028c86f371c3b$var$makeContextName(name) {
    return '@@contextSubscriber/' + name;
}
var $261028c86f371c3b$var$prefixUnsafeLifecycleMethods = typeof (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).forwardRef !== 'undefined';
function $261028c86f371c3b$export$9f27bc3417b4524d(name) {
    var _childContextTypes, _config;
    var contextName = $261028c86f371c3b$var$makeContextName(name);
    var listenersKey = contextName + '/listeners';
    var eventIndexKey = contextName + '/eventIndex';
    var subscribeKey = contextName + '/subscribe';
    var config = (_config = {
        childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = $261028c86f371c3b$var$contextProviderShape.isRequired, _childContextTypes),
        getChildContext: function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextName] = {
                eventIndex: this[eventIndexKey],
                subscribe: this[subscribeKey]
            }, _ref;
        },
        // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
        componentWillMount: function componentWillMount() {
            this[listenersKey] = [];
            this[eventIndexKey] = 0;
        },
        // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
        componentWillReceiveProps: function componentWillReceiveProps() {
            this[eventIndexKey]++;
        },
        componentDidUpdate: function componentDidUpdate() {
            var _this = this;
            this[listenersKey].forEach(function(listener) {
                return listener(_this[eventIndexKey]);
            });
        }
    }, _config[subscribeKey] = function(listener) {
        var _this2 = this;
        // No need to immediately call listener here.
        this[listenersKey].push(listener);
        return function() {
            _this2[listenersKey] = _this2[listenersKey].filter(function(item) {
                return item !== listener;
            });
        };
    }, _config);
    if ($261028c86f371c3b$var$prefixUnsafeLifecycleMethods) {
        config.UNSAFE_componentWillMount = config.componentWillMount;
        config.UNSAFE_componentWillReceiveProps = config.componentWillReceiveProps;
        delete config.componentWillMount;
        delete config.componentWillReceiveProps;
    }
    return config;
}
function $261028c86f371c3b$export$d0b9ad991a1d7967(name) {
    var _contextTypes, _config2;
    var contextName = $261028c86f371c3b$var$makeContextName(name);
    var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
    var handleContextUpdateKey = contextName + '/handleContextUpdate';
    var unsubscribeKey = contextName + '/unsubscribe';
    var config = (_config2 = {
        contextTypes: (_contextTypes = {}, _contextTypes[contextName] = $261028c86f371c3b$var$contextProviderShape, _contextTypes),
        getInitialState: function getInitialState() {
            var _ref2;
            if (!this.context[contextName]) return {};
            return _ref2 = {}, _ref2[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref2;
        },
        componentDidMount: function componentDidMount() {
            if (!this.context[contextName]) return;
            this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
        },
        // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
        componentWillReceiveProps: function componentWillReceiveProps() {
            var _setState;
            if (!this.context[contextName]) return;
            this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
        },
        componentWillUnmount: function componentWillUnmount() {
            if (!this[unsubscribeKey]) return;
            this[unsubscribeKey]();
            this[unsubscribeKey] = null;
        }
    }, _config2[handleContextUpdateKey] = function(eventIndex) {
        if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
            var _setState2;
            this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
        }
    }, _config2);
    if ($261028c86f371c3b$var$prefixUnsafeLifecycleMethods) {
        config.UNSAFE_componentWillReceiveProps = config.componentWillReceiveProps;
        delete config.componentWillReceiveProps;
    }
    return config;
}



var $4c77761f035058c6$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $4c77761f035058c6$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
/**
 * A <RouterContext> renders the component tree for a given router state
 * and sets the history object and the current location in context.
 */ var $4c77761f035058c6$var$RouterContext = (0, (/*@__PURE__*/$parcel$interopDefault($acabf759e6eea9b8$exports)))({
    displayName: 'RouterContext',
    mixins: [
        (0, $261028c86f371c3b$export$9f27bc3417b4524d)('router')
    ],
    propTypes: {
        router: (0, $fGw9V.object).isRequired,
        location: (0, $fGw9V.object).isRequired,
        routes: (0, $fGw9V.array).isRequired,
        params: (0, $fGw9V.object).isRequired,
        components: (0, $fGw9V.array).isRequired,
        createElement: (0, $fGw9V.func).isRequired
    },
    getDefaultProps: function getDefaultProps() {
        return {
            createElement: (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement
        };
    },
    childContextTypes: {
        router: (0, $fGw9V.object).isRequired
    },
    getChildContext: function getChildContext() {
        return {
            router: this.props.router
        };
    },
    createElement: function createElement(component, props) {
        return component == null ? null : this.props.createElement(component, props);
    },
    render: function render() {
        var _this = this;
        var _props = this.props, location = _props.location, routes = _props.routes, params = _props.params, components = _props.components, router = _props.router;
        var element = null;
        if (components) element = components.reduceRight(function(element, components, index) {
            if (components == null) return element; // Don't create new children; use the grandchildren.
            var route = routes[index];
            var routeParams = (0, $2f4df2bce982beca$export$2e2bcd8739ae039)(route, params);
            var props = {
                location: location,
                params: params,
                route: route,
                router: router,
                routeParams: routeParams,
                routes: routes
            };
            if ((0, $7f09464ec030dbdb$export$c1d0e3bf7c5375f6)(element)) props.children = element;
            else if (element) {
                for(var prop in element)if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
            }
            // Handle components is object for { [name]: component } but not valid element
            // type of react, such as React.memo, React.lazy and so on.
            if ((typeof components === 'undefined' ? 'undefined' : $4c77761f035058c6$var$_typeof(components)) === 'object' && !(0, $ebbb41cea4d2536b$exports.isValidElementType)(components)) {
                var elements = {};
                for(var key in components)if (Object.prototype.hasOwnProperty.call(components, key)) // Pass through the key as a prop to createElement to allow
                // custom createElement functions to know which named component
                // they're rendering, for e.g. matching up to fetched data.
                elements[key] = _this.createElement(components[key], $4c77761f035058c6$var$_extends({
                    key: key
                }, props));
                return elements;
            }
            return _this.createElement(components, props);
        }, element);
        !(element === null || element === false || (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).isValidElement(element)) && (0, (/*@__PURE__*/$parcel$interopDefault($06dab2fcf604e778$exports)))(false);
        return element;
    }
});
var $4c77761f035058c6$export$2e2bcd8739ae039 = $4c77761f035058c6$var$RouterContext;



var $b16da4575fd3bd72$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $b16da4575fd3bd72$export$74502efa22785c5f(history, transitionManager, state) {
    var router = $b16da4575fd3bd72$var$_extends({}, history, {
        setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
        isActive: transitionManager.isActive
    });
    return $b16da4575fd3bd72$export$f6289b9b0128e344(router, state);
}
function $b16da4575fd3bd72$export$f6289b9b0128e344(router, _ref) {
    var location = _ref.location, params = _ref.params, routes = _ref.routes;
    router.location = location;
    router.params = params;
    router.routes = routes;
    return router;
}



var $c73532fc4d2afd05$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $c73532fc4d2afd05$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var $c73532fc4d2afd05$var$propTypes = {
    history: (0, $fGw9V.object),
    children: (0, $0b1dbabbd5385627$export$66b32f6f30eb4b4),
    routes: (0, $0b1dbabbd5385627$export$66b32f6f30eb4b4),
    render: (0, $fGw9V.func),
    createElement: (0, $fGw9V.func),
    onError: (0, $fGw9V.func),
    onUpdate: (0, $fGw9V.func),
    // PRIVATE: For client-side rehydration of server match.
    matchContext: (0, $fGw9V.object)
};
var $c73532fc4d2afd05$var$prefixUnsafeLifecycleMethods = typeof (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).forwardRef !== 'undefined';
/**
 * A <Router> is a high-level API for automatically setting up
 * a router that renders a <RouterContext> with all the props
 * it needs each time the URL changes.
 */ var $c73532fc4d2afd05$var$Router = (0, (/*@__PURE__*/$parcel$interopDefault($acabf759e6eea9b8$exports)))({
    displayName: 'Router',
    propTypes: $c73532fc4d2afd05$var$propTypes,
    getDefaultProps: function getDefaultProps() {
        return {
            render: function render(props) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $4c77761f035058c6$export$2e2bcd8739ae039), props);
            }
        };
    },
    getInitialState: function getInitialState() {
        return {
            location: null,
            routes: null,
            params: null,
            components: null
        };
    },
    handleError: function handleError(error) {
        if (this.props.onError) this.props.onError.call(this, error);
        else // Throw errors by default so we don't silently swallow them!
        throw error; // This error probably occurred in getChildRoutes or getComponents.
    },
    createRouterObject: function createRouterObject(state) {
        var matchContext = this.props.matchContext;
        if (matchContext) return matchContext.router;
        var history = this.props.history;
        return (0, $b16da4575fd3bd72$export$74502efa22785c5f)(history, this.transitionManager, state);
    },
    createTransitionManager: function createTransitionManager() {
        var matchContext = this.props.matchContext;
        if (matchContext) return matchContext.transitionManager;
        var history = this.props.history;
        var _props = this.props, routes = _props.routes, children = _props.children;
        !history.getCurrentLocation && (0, (/*@__PURE__*/$parcel$interopDefault($06dab2fcf604e778$exports)))(false);
        return (0, $b5bf5a142c1cba35$export$2e2bcd8739ae039)(history, (0, $7f09464ec030dbdb$export$dfc730c04fdecfcb)(routes || children));
    },
    // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
    componentWillMount: function componentWillMount() {
        var _this = this;
        this.transitionManager = this.createTransitionManager();
        this.router = this.createRouterObject(this.state);
        this._unlisten = this.transitionManager.listen(function(error, state) {
            if (error) _this.handleError(error);
            else {
                // Keep the identity of this.router because of a caveat in ContextUtils:
                // they only work if the object identity is preserved.
                (0, $b16da4575fd3bd72$export$f6289b9b0128e344)(_this.router, state);
                _this.setState(state, _this.props.onUpdate);
            }
        });
    },
    // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
    /* istanbul ignore next: sanity check */ componentWillReceiveProps: function componentWillReceiveProps(nextProps) {},
    componentWillUnmount: function componentWillUnmount() {
        if (this._unlisten) this._unlisten();
    },
    render: function render() {
        var _state = this.state, location = _state.location, routes = _state.routes, params = _state.params, components = _state.components;
        var _props2 = this.props, createElement = _props2.createElement, render = _props2.render, props = $c73532fc4d2afd05$var$_objectWithoutProperties(_props2, [
            'createElement',
            'render'
        ]);
        if (location == null) return null; // Async match
        // Only forward non-Router-specific props to routing context, as those are
        // the only ones that might be custom routing context props.
        Object.keys($c73532fc4d2afd05$var$propTypes).forEach(function(propType) {
            return delete props[propType];
        });
        return render($c73532fc4d2afd05$var$_extends({}, props, {
            router: this.router,
            location: location,
            routes: routes,
            params: params,
            components: components,
            createElement: createElement
        }));
    }
});
if ($c73532fc4d2afd05$var$prefixUnsafeLifecycleMethods) {
    $c73532fc4d2afd05$var$Router.prototype.UNSAFE_componentWillReceiveProps = $c73532fc4d2afd05$var$Router.prototype.componentWillReceiveProps;
    $c73532fc4d2afd05$var$Router.prototype.UNSAFE_componentWillMount = $c73532fc4d2afd05$var$Router.prototype.componentWillMount;
    delete $c73532fc4d2afd05$var$Router.prototype.componentWillReceiveProps;
    delete $c73532fc4d2afd05$var$Router.prototype.componentWillMount;
}
var $c73532fc4d2afd05$export$2e2bcd8739ae039 = $c73532fc4d2afd05$var$Router;



var $NdCUR = parcelRequire("NdCUR");


var $fGw9V = parcelRequire("fGw9V");


var $fGw9V = parcelRequire("fGw9V");
var $ace972b1c0f1ffa7$export$479b7331a4593803 = (0, $fGw9V.shape)({
    push: (0, $fGw9V.func).isRequired,
    replace: (0, $fGw9V.func).isRequired,
    go: (0, $fGw9V.func).isRequired,
    goBack: (0, $fGw9V.func).isRequired,
    goForward: (0, $fGw9V.func).isRequired,
    setRouteLeaveHook: (0, $fGw9V.func).isRequired,
    isActive: (0, $fGw9V.func).isRequired
});
var $ace972b1c0f1ffa7$export$a642924466751f31 = (0, $fGw9V.shape)({
    pathname: (0, $fGw9V.string).isRequired,
    search: (0, $fGw9V.string).isRequired,
    state: (0, $fGw9V.object),
    action: (0, $fGw9V.string).isRequired,
    key: (0, $fGw9V.string)
});



var $ba1cc4424c00aefe$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $ba1cc4424c00aefe$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $ba1cc4424c00aefe$var$isLeftClickEvent(event) {
    return event.button === 0;
}
function $ba1cc4424c00aefe$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
function $ba1cc4424c00aefe$var$isEmptyObject(object) {
    for(var p in object){
        if (Object.prototype.hasOwnProperty.call(object, p)) return false;
    }
    return true;
}
function $ba1cc4424c00aefe$var$resolveToLocation(to, router) {
    return typeof to === 'function' ? to(router.location) : to;
}
/**
 * A <Link> is used to create an <a> element that links to a route.
 * When that route is active, the link gets the value of its
 * activeClassName prop.
 *
 * For example, assuming you have the following route:
 *
 *   <Route path="/posts/:postID" component={Post} />
 *
 * You could use the following component to link to that route:
 *
 *   <Link to={`/posts/${post.id}`} />
 */ var $ba1cc4424c00aefe$var$Link = (0, (/*@__PURE__*/$parcel$interopDefault($acabf759e6eea9b8$exports)))({
    displayName: 'Link',
    mixins: [
        (0, $261028c86f371c3b$export$d0b9ad991a1d7967)('router')
    ],
    contextTypes: {
        router: (0, $ace972b1c0f1ffa7$export$479b7331a4593803)
    },
    propTypes: {
        to: (0, $fGw9V.oneOfType)([
            (0, $fGw9V.string),
            (0, $fGw9V.object),
            (0, $fGw9V.func)
        ]),
        activeStyle: (0, $fGw9V.object),
        activeClassName: (0, $fGw9V.string),
        onlyActiveOnIndex: (0, $fGw9V.bool).isRequired,
        onClick: (0, $fGw9V.func),
        target: (0, $fGw9V.string),
        innerRef: (0, $fGw9V.oneOfType)([
            (0, $fGw9V.string),
            (0, $fGw9V.func),
            (0, $fGw9V.shape)({
                current: (0, $fGw9V.elementType)
            })
        ])
    },
    getDefaultProps: function getDefaultProps() {
        return {
            onlyActiveOnIndex: false,
            style: {}
        };
    },
    handleClick: function handleClick(event) {
        if (this.props.onClick) this.props.onClick(event);
        if (event.defaultPrevented) return;
        var router = this.context.router;
        !router && (0, (/*@__PURE__*/$parcel$interopDefault($06dab2fcf604e778$exports)))(false);
        if ($ba1cc4424c00aefe$var$isModifiedEvent(event) || !$ba1cc4424c00aefe$var$isLeftClickEvent(event)) return;
        // If target prop is set (e.g. to "_blank"), let browser handle link.
        /* istanbul ignore if: untestable with Karma */ if (this.props.target) return;
        event.preventDefault();
        router.push($ba1cc4424c00aefe$var$resolveToLocation(this.props.to, router));
    },
    render: function render() {
        var _props = this.props, to = _props.to, activeClassName = _props.activeClassName, activeStyle = _props.activeStyle, onlyActiveOnIndex = _props.onlyActiveOnIndex, innerRef = _props.innerRef, props = $ba1cc4424c00aefe$var$_objectWithoutProperties(_props, [
            'to',
            'activeClassName',
            'activeStyle',
            'onlyActiveOnIndex',
            'innerRef'
        ]);
        // Ignore if rendered outside the context of router to simplify unit testing.
        var router = this.context.router;
        if (router) {
            // If user does not specify a `to` prop, return an empty anchor tag.
            if (!to) return (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement('a', $ba1cc4424c00aefe$var$_extends({}, props, {
                ref: innerRef
            }));
            var toLocation = $ba1cc4424c00aefe$var$resolveToLocation(to, router);
            props.href = router.createHref(toLocation);
            if (activeClassName || activeStyle != null && !$ba1cc4424c00aefe$var$isEmptyObject(activeStyle)) {
                if (router.isActive(toLocation, onlyActiveOnIndex)) {
                    if (activeClassName) {
                        if (props.className) props.className += ' ' + activeClassName;
                        else props.className = activeClassName;
                    }
                    if (activeStyle) props.style = $ba1cc4424c00aefe$var$_extends({}, props.style, activeStyle);
                }
            }
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement('a', $ba1cc4424c00aefe$var$_extends({}, props, {
            onClick: this.handleClick,
            ref: innerRef
        }));
    }
});
var $ba1cc4424c00aefe$export$2e2bcd8739ae039 = $ba1cc4424c00aefe$var$Link;



var $NdCUR = parcelRequire("NdCUR");


var $6a750707c04c8a13$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
/**
 * An <IndexLink> is used to link to an <IndexRoute>.
 */ var $6a750707c04c8a13$var$IndexLink = (0, (/*@__PURE__*/$parcel$interopDefault($acabf759e6eea9b8$exports)))({
    displayName: 'IndexLink',
    render: function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ba1cc4424c00aefe$export$2e2bcd8739ae039), $6a750707c04c8a13$var$_extends({}, this.props, {
            onlyActiveOnIndex: true
        }));
    }
});
var $6a750707c04c8a13$export$2e2bcd8739ae039 = $6a750707c04c8a13$var$IndexLink;




var $NdCUR = parcelRequire("NdCUR");




var $dffbdf89c590a961$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $dffbdf89c590a961$var$getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
function $dffbdf89c590a961$export$2e2bcd8739ae039(WrappedComponent, options) {
    var withRef = options && options.withRef;
    var WithRouter = (0, (/*@__PURE__*/$parcel$interopDefault($acabf759e6eea9b8$exports)))({
        displayName: 'WithRouter',
        mixins: [
            (0, $261028c86f371c3b$export$d0b9ad991a1d7967)('router')
        ],
        contextTypes: {
            router: (0, $ace972b1c0f1ffa7$export$479b7331a4593803)
        },
        propTypes: {
            router: (0, $ace972b1c0f1ffa7$export$479b7331a4593803)
        },
        getWrappedInstance: function getWrappedInstance() {
            !withRef && (0, (/*@__PURE__*/$parcel$interopDefault($06dab2fcf604e778$exports)))(false);
            return this.wrappedInstance;
        },
        render: function render() {
            var _this = this;
            var router = this.props.router || this.context.router;
            if (!router) return (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement(WrappedComponent, this.props);
            var params = router.params, location = router.location, routes = router.routes;
            var props = $dffbdf89c590a961$var$_extends({}, this.props, {
                router: router,
                params: params,
                location: location,
                routes: routes
            });
            if (withRef) props.ref = function(c) {
                _this.wrappedInstance = c;
            };
            return (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement(WrappedComponent, props);
        }
    });
    WithRouter.displayName = 'withRouter(' + $dffbdf89c590a961$var$getDisplayName(WrappedComponent) + ')';
    WithRouter.WrappedComponent = WrappedComponent;
    return (0, (/*@__PURE__*/$parcel$interopDefault($cc6303404373807d$exports)))(WithRouter, WrappedComponent);
}




var $fGw9V = parcelRequire("fGw9V");




var $fGw9V = parcelRequire("fGw9V");




/**
 * A <Redirect> is used to declare another URL path a client should
 * be sent to when they request a given URL.
 *
 * Redirects are placed alongside routes in the route configuration
 * and are traversed in the same manner.
 */ /* eslint-disable react/require-render-return */ var $e804633964a8b7c1$var$Redirect = (0, (/*@__PURE__*/$parcel$interopDefault($acabf759e6eea9b8$exports)))({
    displayName: 'Redirect',
    statics: {
        createRouteFromReactElement: function createRouteFromReactElement(element) {
            var route = (0, $7f09464ec030dbdb$export$d11cfea1c6fa899d)(element);
            if (route.from) route.path = route.from;
            route.onEnter = function(nextState, replace) {
                var location = nextState.location, params = nextState.params;
                var pathname = void 0;
                if (route.to.charAt(0) === '/') pathname = (0, $f0b6bffd1a813242$export$5fc023054452162e)(route.to, params);
                else if (!route.to) pathname = location.pathname;
                else {
                    var routeIndex = nextState.routes.indexOf(route);
                    var parentPattern = $e804633964a8b7c1$var$Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
                    var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
                    pathname = (0, $f0b6bffd1a813242$export$5fc023054452162e)(pattern, params);
                }
                replace({
                    pathname: pathname,
                    query: route.query || location.query,
                    state: route.state || location.state
                });
            };
            return route;
        },
        getRoutePattern: function getRoutePattern(routes, routeIndex) {
            var parentPattern = '';
            for(var i = routeIndex; i >= 0; i--){
                var route = routes[i];
                var pattern = route.path || '';
                parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
                if (pattern.indexOf('/') === 0) break;
            }
            return '/' + parentPattern;
        }
    },
    propTypes: {
        path: (0, $fGw9V.string),
        from: (0, $fGw9V.string),
        to: (0, $fGw9V.string).isRequired,
        query: (0, $fGw9V.object),
        state: (0, $fGw9V.object),
        onEnter: (0, $0b1dbabbd5385627$export$74775dafe30d0d0a),
        children: (0, $0b1dbabbd5385627$export$74775dafe30d0d0a)
    },
    /* istanbul ignore next: sanity check */ render: function render() {
        (0, (/*@__PURE__*/$parcel$interopDefault($06dab2fcf604e778$exports)))(false);
    }
});
var $e804633964a8b7c1$export$2e2bcd8739ae039 = $e804633964a8b7c1$var$Redirect;



/**
 * An <IndexRedirect> is used to redirect from an indexRoute.
 */ /* eslint-disable react/require-render-return */ var $c132a4a7a0e62c5f$var$IndexRedirect = (0, (/*@__PURE__*/$parcel$interopDefault($acabf759e6eea9b8$exports)))({
    displayName: 'IndexRedirect',
    statics: {
        createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
            /* istanbul ignore else: sanity check */ if (parentRoute) parentRoute.indexRoute = (0, $e804633964a8b7c1$export$2e2bcd8739ae039).createRouteFromReactElement(element);
        }
    },
    propTypes: {
        to: (0, $fGw9V.string).isRequired,
        query: (0, $fGw9V.object),
        state: (0, $fGw9V.object),
        onEnter: (0, $0b1dbabbd5385627$export$74775dafe30d0d0a),
        children: (0, $0b1dbabbd5385627$export$74775dafe30d0d0a)
    },
    /* istanbul ignore next: sanity check */ render: function render() {
        (0, (/*@__PURE__*/$parcel$interopDefault($06dab2fcf604e778$exports)))(false);
    }
});
var $c132a4a7a0e62c5f$export$2e2bcd8739ae039 = $c132a4a7a0e62c5f$var$IndexRedirect;




var $fGw9V = parcelRequire("fGw9V");




/**
 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
 * a JSX route config.
 */ /* eslint-disable react/require-render-return */ var $645b9cff24f98cd0$var$IndexRoute = (0, (/*@__PURE__*/$parcel$interopDefault($acabf759e6eea9b8$exports)))({
    displayName: 'IndexRoute',
    statics: {
        createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
            /* istanbul ignore else: sanity check */ if (parentRoute) parentRoute.indexRoute = (0, $7f09464ec030dbdb$export$d11cfea1c6fa899d)(element);
        }
    },
    propTypes: {
        path: (0, $0b1dbabbd5385627$export$74775dafe30d0d0a),
        component: (0, $0b1dbabbd5385627$export$d8556a2a8f973135),
        components: (0, $0b1dbabbd5385627$export$9b5ac10f59f76296),
        getComponent: (0, $fGw9V.func),
        getComponents: (0, $fGw9V.func)
    },
    /* istanbul ignore next: sanity check */ render: function render() {
        (0, (/*@__PURE__*/$parcel$interopDefault($06dab2fcf604e778$exports)))(false);
    }
});
var $645b9cff24f98cd0$export$2e2bcd8739ae039 = $645b9cff24f98cd0$var$IndexRoute;





var $fGw9V = parcelRequire("fGw9V");



/**
 * A <Route> is used to declare which components are rendered to the
 * page when the URL matches a given pattern.
 *
 * Routes are arranged in a nested tree structure. When a new URL is
 * requested, the tree is searched depth-first to find a route whose
 * path matches the URL.  When one is found, all routes in the tree
 * that lead to it are considered "active" and their components are
 * rendered into the DOM, nested in the same order as in the tree.
 */ /* eslint-disable react/require-render-return */ var $a8b446a49e6c7459$var$Route = (0, (/*@__PURE__*/$parcel$interopDefault($acabf759e6eea9b8$exports)))({
    displayName: 'Route',
    statics: {
        createRouteFromReactElement: (0, $7f09464ec030dbdb$export$d11cfea1c6fa899d)
    },
    propTypes: {
        path: (0, $fGw9V.string),
        component: (0, $0b1dbabbd5385627$export$d8556a2a8f973135),
        components: (0, $0b1dbabbd5385627$export$9b5ac10f59f76296),
        getComponent: (0, $fGw9V.func),
        getComponents: (0, $fGw9V.func)
    },
    /* istanbul ignore next: sanity check */ render: function render() {
        (0, (/*@__PURE__*/$parcel$interopDefault($06dab2fcf604e778$exports)))(false);
    }
});
var $a8b446a49e6c7459$export$2e2bcd8739ae039 = $a8b446a49e6c7459$var$Route;





var $7525598290eef164$exports = {};

$parcel$export($7525598290eef164$exports, "__esModule", function () { return $7525598290eef164$export$1e511d4a378977f5; }, function (v) { return $7525598290eef164$export$1e511d4a378977f5 = v; });
$parcel$export($7525598290eef164$exports, "PUSH", function () { return $7525598290eef164$export$70b1f83e7123989d; }, function (v) { return $7525598290eef164$export$70b1f83e7123989d = v; });
$parcel$export($7525598290eef164$exports, "REPLACE", function () { return $7525598290eef164$export$412b24539e92ced; }, function (v) { return $7525598290eef164$export$412b24539e92ced = v; });
$parcel$export($7525598290eef164$exports, "POP", function () { return $7525598290eef164$export$fa3a15f086be9697; }, function (v) { return $7525598290eef164$export$fa3a15f086be9697 = v; });
var $7525598290eef164$export$1e511d4a378977f5;
var $7525598290eef164$export$70b1f83e7123989d;
var $7525598290eef164$export$412b24539e92ced;
var $7525598290eef164$export$fa3a15f086be9697;
'use strict';
$7525598290eef164$export$1e511d4a378977f5 = true;
/**
 * Indicates that navigation was caused by a call to history.push.
 */ var $7525598290eef164$var$PUSH = $7525598290eef164$export$70b1f83e7123989d = 'PUSH';
/**
 * Indicates that navigation was caused by a call to history.replace.
 */ var $7525598290eef164$var$REPLACE = $7525598290eef164$export$412b24539e92ced = 'REPLACE';
/**
 * Indicates that navigation was caused by some other action such
 * as using a browser's back/forward buttons and/or manually manipulating
 * the URL in a browser's location bar. This is the default.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
 * for more information.
 */ var $7525598290eef164$var$POP = $7525598290eef164$export$fa3a15f086be9697 = 'POP';



var $5058ccf6f66c4484$exports = {};

$parcel$defineInteropFlag($5058ccf6f66c4484$exports);

$parcel$export($5058ccf6f66c4484$exports, "__esModule", function () { return $5058ccf6f66c4484$export$1e511d4a378977f5; }, function (v) { return $5058ccf6f66c4484$export$1e511d4a378977f5 = v; });
$parcel$export($5058ccf6f66c4484$exports, "default", function () { return $5058ccf6f66c4484$export$2e2bcd8739ae039; }, function (v) { return $5058ccf6f66c4484$export$2e2bcd8739ae039 = v; });
var $5058ccf6f66c4484$export$1e511d4a378977f5;
var $5058ccf6f66c4484$export$2e2bcd8739ae039;
'use strict';
$5058ccf6f66c4484$export$1e511d4a378977f5 = true;
var $5058ccf6f66c4484$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $434f8b2da27223e9$export$f9380c9a627682d3;
var $434f8b2da27223e9$export$98e6a39c04603d36;
var $434f8b2da27223e9$export$fac44ee5b035f737;
'use strict';
var $35dc804fa34707f5$exports = {};
'use strict';
$35dc804fa34707f5$exports = function(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
};



var $haJ2X = parcelRequire("haJ2X");
function $434f8b2da27223e9$var$encoderForArrayFormat(opts) {
    switch(opts.arrayFormat){
        case 'index':
            return function(key, value, index) {
                return value === null ? [
                    $434f8b2da27223e9$var$encode(key, opts),
                    '[',
                    index,
                    ']'
                ].join('') : [
                    $434f8b2da27223e9$var$encode(key, opts),
                    '[',
                    $434f8b2da27223e9$var$encode(index, opts),
                    ']=',
                    $434f8b2da27223e9$var$encode(value, opts)
                ].join('');
            };
        case 'bracket':
            return function(key, value) {
                return value === null ? $434f8b2da27223e9$var$encode(key, opts) : [
                    $434f8b2da27223e9$var$encode(key, opts),
                    '[]=',
                    $434f8b2da27223e9$var$encode(value, opts)
                ].join('');
            };
        default:
            return function(key, value) {
                return value === null ? $434f8b2da27223e9$var$encode(key, opts) : [
                    $434f8b2da27223e9$var$encode(key, opts),
                    '=',
                    $434f8b2da27223e9$var$encode(value, opts)
                ].join('');
            };
    }
}
function $434f8b2da27223e9$var$parserForArrayFormat(opts) {
    var result;
    switch(opts.arrayFormat){
        case 'index':
            return function(key, value, accumulator) {
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return function(key, value, accumulator) {
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                } else if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        default:
            return function(key, value, accumulator) {
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $434f8b2da27223e9$var$encode(value, opts) {
    if (opts.encode) return opts.strict ? $35dc804fa34707f5$exports(value) : encodeURIComponent(value);
    return value;
}
function $434f8b2da27223e9$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    else if (typeof input === 'object') return $434f8b2da27223e9$var$keysSorter(Object.keys(input)).sort(function(a, b) {
        return Number(a) - Number(b);
    }).map(function(key) {
        return input[key];
    });
    return input;
}
$434f8b2da27223e9$export$f9380c9a627682d3 = function(str) {
    return str.split('?')[1] || '';
};
$434f8b2da27223e9$export$98e6a39c04603d36 = function(str, opts) {
    opts = $haJ2X({
        arrayFormat: 'none'
    }, opts);
    var formatter = $434f8b2da27223e9$var$parserForArrayFormat(opts);
    // Create an object with no prototype
    // https://github.com/sindresorhus/query-string/issues/47
    var ret = Object.create(null);
    if (typeof str !== 'string') return ret;
    str = str.trim().replace(/^(\?|#|&)/, '');
    if (!str) return ret;
    str.split('&').forEach(function(param) {
        var parts = param.replace(/\+/g, ' ').split('=');
        // Firefox (pre 40) decodes `%3D` to `=`
        // https://github.com/sindresorhus/query-string/pull/37
        var key = parts.shift();
        var val = parts.length > 0 ? parts.join('=') : undefined;
        // missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        val = val === undefined ? null : decodeURIComponent(val);
        formatter(decodeURIComponent(key), val, ret);
    });
    return Object.keys(ret).sort().reduce(function(result, key) {
        var val = ret[key];
        if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) // Sort object keys, not values
        result[key] = $434f8b2da27223e9$var$keysSorter(val);
        else result[key] = val;
        return result;
    }, Object.create(null));
};
$434f8b2da27223e9$export$fac44ee5b035f737 = function(obj, opts) {
    var defaults = {
        encode: true,
        strict: true,
        arrayFormat: 'none'
    };
    opts = $haJ2X(defaults, opts);
    var formatter = $434f8b2da27223e9$var$encoderForArrayFormat(opts);
    return obj ? Object.keys(obj).sort().map(function(key) {
        var val = obj[key];
        if (val === undefined) return '';
        if (val === null) return $434f8b2da27223e9$var$encode(key, opts);
        if (Array.isArray(val)) {
            var result = [];
            val.slice().forEach(function(val2) {
                if (val2 === undefined) return;
                result.push(formatter(key, val2, result.length));
            });
            return result.join('&');
        }
        return $434f8b2da27223e9$var$encode(key, opts) + '=' + $434f8b2da27223e9$var$encode(val, opts);
    }).filter(function(x) {
        return x.length > 0;
    }).join('&') : '';
};


var $4b029d66e041770b$exports = {};

$parcel$defineInteropFlag($4b029d66e041770b$exports);

$parcel$export($4b029d66e041770b$exports, "__esModule", function () { return $4b029d66e041770b$export$1e511d4a378977f5; }, function (v) { return $4b029d66e041770b$export$1e511d4a378977f5 = v; });
$parcel$export($4b029d66e041770b$exports, "default", function () { return $4b029d66e041770b$export$2e2bcd8739ae039; }, function (v) { return $4b029d66e041770b$export$2e2bcd8739ae039 = v; });
var $4b029d66e041770b$export$1e511d4a378977f5;
var $4b029d66e041770b$export$2e2bcd8739ae039;
'use strict';
$4b029d66e041770b$export$1e511d4a378977f5 = true;

var $4b029d66e041770b$var$_warning2 = $4b029d66e041770b$var$_interopRequireDefault($a6fffc526962516d$exports);
function $4b029d66e041770b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $4b029d66e041770b$var$runTransitionHook = function runTransitionHook(hook, location, callback) {
    var result = hook(location, callback);
    if (hook.length < 2) // Assume the hook runs synchronously and automatically
    // call the callback with the return value.
    callback(result);
};
$4b029d66e041770b$export$2e2bcd8739ae039 = $4b029d66e041770b$var$runTransitionHook;


var $5058ccf6f66c4484$var$_runTransitionHook2 = $5058ccf6f66c4484$var$_interopRequireDefault($4b029d66e041770b$exports);
var $f3c3dba28fc87571$export$1e511d4a378977f5;
var $f3c3dba28fc87571$export$c3e8bb440bd55b18;
var $f3c3dba28fc87571$export$f85b5c57dd496263;
var $f3c3dba28fc87571$export$90c043f1c57770b8;
var $f3c3dba28fc87571$export$b0bb00bbf9023ec9;
'use strict';
$f3c3dba28fc87571$export$1e511d4a378977f5 = true;
$f3c3dba28fc87571$export$c3e8bb440bd55b18 = $f3c3dba28fc87571$export$f85b5c57dd496263 = $f3c3dba28fc87571$export$90c043f1c57770b8 = $f3c3dba28fc87571$export$b0bb00bbf9023ec9 = undefined;
var $f3c3dba28fc87571$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $f3c3dba28fc87571$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $f3c3dba28fc87571$var$_invariant2 = $f3c3dba28fc87571$var$_interopRequireDefault($06dab2fcf604e778$exports);

var $f3c3dba28fc87571$var$_warning2 = $f3c3dba28fc87571$var$_interopRequireDefault($a6fffc526962516d$exports);
var $d5fdbd19f96d08cc$export$1e511d4a378977f5;
var $d5fdbd19f96d08cc$export$fe53371bee54353d;
var $d5fdbd19f96d08cc$export$8ccf933b0513f8d0;
var $d5fdbd19f96d08cc$export$9be10eb6501fc5cb;
var $d5fdbd19f96d08cc$export$c5133843bec439c1;
var $d5fdbd19f96d08cc$export$ba97c4fa4c9c94b0;
'use strict';
$d5fdbd19f96d08cc$export$1e511d4a378977f5 = true;
$d5fdbd19f96d08cc$export$fe53371bee54353d = $d5fdbd19f96d08cc$export$8ccf933b0513f8d0 = $d5fdbd19f96d08cc$export$9be10eb6501fc5cb = $d5fdbd19f96d08cc$export$c5133843bec439c1 = $d5fdbd19f96d08cc$export$ba97c4fa4c9c94b0 = undefined;

var $d5fdbd19f96d08cc$var$_warning2 = $d5fdbd19f96d08cc$var$_interopRequireDefault($a6fffc526962516d$exports);
function $d5fdbd19f96d08cc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d5fdbd19f96d08cc$var$addQueryStringValueToPath = $d5fdbd19f96d08cc$export$ba97c4fa4c9c94b0 = function addQueryStringValueToPath(path, key, value) {
    var _parsePath = $d5fdbd19f96d08cc$var$parsePath(path), pathname = _parsePath.pathname, search = _parsePath.search, hash = _parsePath.hash;
    return $d5fdbd19f96d08cc$var$createPath({
        pathname: pathname,
        search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
        hash: hash
    });
};
var $d5fdbd19f96d08cc$var$stripQueryStringValueFromPath = $d5fdbd19f96d08cc$export$c5133843bec439c1 = function stripQueryStringValueFromPath(path, key) {
    var _parsePath2 = $d5fdbd19f96d08cc$var$parsePath(path), pathname = _parsePath2.pathname, search = _parsePath2.search, hash = _parsePath2.hash;
    return $d5fdbd19f96d08cc$var$createPath({
        pathname: pathname,
        search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function(match, prefix, suffix) {
            return prefix === '?' ? prefix : suffix;
        }),
        hash: hash
    });
};
var $d5fdbd19f96d08cc$var$getQueryStringValueFromPath = $d5fdbd19f96d08cc$export$9be10eb6501fc5cb = function getQueryStringValueFromPath(path, key) {
    var _parsePath3 = $d5fdbd19f96d08cc$var$parsePath(path), search = _parsePath3.search;
    var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
    return match && match[1];
};
var $d5fdbd19f96d08cc$var$extractPath = function extractPath(string) {
    var match = string.match(/^(https?:)?\/\/[^\/]*/);
    return match == null ? string : string.substring(match[0].length);
};
var $d5fdbd19f96d08cc$var$parsePath = $d5fdbd19f96d08cc$export$8ccf933b0513f8d0 = function parsePath(path) {
    var pathname = $d5fdbd19f96d08cc$var$extractPath(path);
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substring(hashIndex);
        pathname = pathname.substring(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substring(searchIndex);
        pathname = pathname.substring(0, searchIndex);
    }
    if (pathname === '') pathname = '/';
    return {
        pathname: pathname,
        search: search,
        hash: hash
    };
};
var $d5fdbd19f96d08cc$var$createPath = $d5fdbd19f96d08cc$export$fe53371bee54353d = function createPath(location) {
    if (location == null || typeof location === 'string') return location;
    var basename = location.basename, pathname = location.pathname, search = location.search, hash = location.hash;
    var path = (basename || '') + pathname;
    if (search && search !== '?') path += search;
    if (hash) path += hash;
    return path;
};



function $f3c3dba28fc87571$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $f3c3dba28fc87571$var$createQuery = $f3c3dba28fc87571$export$b0bb00bbf9023ec9 = function createQuery(props) {
    return $f3c3dba28fc87571$var$_extends(Object.create(null), props);
};
var $f3c3dba28fc87571$var$createLocation = $f3c3dba28fc87571$export$90c043f1c57770b8 = function createLocation() {
    var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $7525598290eef164$export$fa3a15f086be9697;
    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var object = typeof input === 'string' ? (0, $d5fdbd19f96d08cc$export$8ccf933b0513f8d0)(input) : input;
    var pathname = object.pathname || '/';
    var search = object.search || '';
    var hash = object.hash || '';
    var state = object.state;
    return {
        pathname: pathname,
        search: search,
        hash: hash,
        state: state,
        action: action,
        key: key
    };
};
var $f3c3dba28fc87571$var$isDate = function isDate(object) {
    return Object.prototype.toString.call(object) === '[object Date]';
};
var $f3c3dba28fc87571$var$statesAreEqual = $f3c3dba28fc87571$export$f85b5c57dd496263 = function statesAreEqual(a, b) {
    if (a === b) return true;
    var typeofA = typeof a === 'undefined' ? 'undefined' : $f3c3dba28fc87571$var$_typeof(a);
    var typeofB = typeof b === 'undefined' ? 'undefined' : $f3c3dba28fc87571$var$_typeof(b);
    if (typeofA !== typeofB) return false;
    !(typeofA !== 'function') && (0, $f3c3dba28fc87571$var$_invariant2.default)(false);
    // Not the same object, but same type.
    if (typeofA === 'object') {
        !!($f3c3dba28fc87571$var$isDate(a) && $f3c3dba28fc87571$var$isDate(b)) && (0, $f3c3dba28fc87571$var$_invariant2.default)(false);
        if (!Array.isArray(a)) {
            var keysofA = Object.keys(a);
            var keysofB = Object.keys(b);
            return keysofA.length === keysofB.length && keysofA.every(function(key) {
                return statesAreEqual(a[key], b[key]);
            });
        }
        return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
            return statesAreEqual(item, b[index]);
        });
    }
    // All other serializable types (string, number, boolean)
    // should be strict equal.
    return false;
};
var $f3c3dba28fc87571$var$locationsAreEqual = $f3c3dba28fc87571$export$c3e8bb440bd55b18 = function locationsAreEqual(a, b) {
    return a.key === b.key && // a.action === b.action && // Different action !== location change.
    a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && $f3c3dba28fc87571$var$statesAreEqual(a.state, b.state);
};



function $5058ccf6f66c4484$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $5058ccf6f66c4484$var$defaultStringifyQuery = function defaultStringifyQuery(query) {
    return (0, $434f8b2da27223e9$export$fac44ee5b035f737)(query).replace(/%20/g, '+');
};
var $5058ccf6f66c4484$var$defaultParseQueryString = $434f8b2da27223e9$export$98e6a39c04603d36;
/**
 * Returns a new createHistory function that may be used to create
 * history objects that know how to handle URL queries.
 */ var $5058ccf6f66c4484$var$useQueries = function useQueries(createHistory) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var history = createHistory(options);
        var stringifyQuery = options.stringifyQuery, parseQueryString = options.parseQueryString;
        if (typeof stringifyQuery !== 'function') stringifyQuery = $5058ccf6f66c4484$var$defaultStringifyQuery;
        if (typeof parseQueryString !== 'function') parseQueryString = $5058ccf6f66c4484$var$defaultParseQueryString;
        var decodeQuery = function decodeQuery(location) {
            if (!location) return location;
            if (location.query == null) location.query = parseQueryString(location.search.substring(1));
            return location;
        };
        var encodeQuery = function encodeQuery(location, query) {
            if (query == null) return location;
            var object = typeof location === 'string' ? (0, $d5fdbd19f96d08cc$export$8ccf933b0513f8d0)(location) : location;
            var queryString = stringifyQuery(query);
            var search = queryString ? '?' + queryString : '';
            return $5058ccf6f66c4484$var$_extends({}, object, {
                search: search
            });
        };
        // Override all read methods with query-aware versions.
        var getCurrentLocation = function getCurrentLocation() {
            return decodeQuery(history.getCurrentLocation());
        };
        var listenBefore = function listenBefore(hook) {
            return history.listenBefore(function(location, callback) {
                return (0, $5058ccf6f66c4484$var$_runTransitionHook2.default)(hook, decodeQuery(location), callback);
            });
        };
        var listen = function listen(listener) {
            return history.listen(function(location) {
                return listener(decodeQuery(location));
            });
        };
        // Override all write methods with query-aware versions.
        var push = function push(location) {
            return history.push(encodeQuery(location, location.query));
        };
        var replace = function replace(location) {
            return history.replace(encodeQuery(location, location.query));
        };
        var createPath = function createPath(location) {
            return history.createPath(encodeQuery(location, location.query));
        };
        var createHref = function createHref(location) {
            return history.createHref(encodeQuery(location, location.query));
        };
        var createLocation = function createLocation(location) {
            for(var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            var newLocation = history.createLocation.apply(history, [
                encodeQuery(location, location.query)
            ].concat(args));
            if (location.query) newLocation.query = (0, $f3c3dba28fc87571$export$b0bb00bbf9023ec9)(location.query);
            return decodeQuery(newLocation);
        };
        return $5058ccf6f66c4484$var$_extends({}, history, {
            getCurrentLocation: getCurrentLocation,
            listenBefore: listenBefore,
            listen: listen,
            push: push,
            replace: replace,
            createPath: createPath,
            createHref: createHref,
            createLocation: createLocation
        });
    };
};
$5058ccf6f66c4484$export$2e2bcd8739ae039 = $5058ccf6f66c4484$var$useQueries;


var $a67113ed51312a28$exports = {};

$parcel$defineInteropFlag($a67113ed51312a28$exports);

$parcel$export($a67113ed51312a28$exports, "__esModule", function () { return $a67113ed51312a28$export$1e511d4a378977f5; }, function (v) { return $a67113ed51312a28$export$1e511d4a378977f5 = v; });
$parcel$export($a67113ed51312a28$exports, "default", function () { return $a67113ed51312a28$export$2e2bcd8739ae039; }, function (v) { return $a67113ed51312a28$export$2e2bcd8739ae039 = v; });
var $a67113ed51312a28$export$1e511d4a378977f5;
var $a67113ed51312a28$export$2e2bcd8739ae039;
'use strict';
$a67113ed51312a28$export$1e511d4a378977f5 = true;
var $a67113ed51312a28$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $a67113ed51312a28$var$_runTransitionHook2 = $a67113ed51312a28$var$_interopRequireDefault($4b029d66e041770b$exports);

function $a67113ed51312a28$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a67113ed51312a28$var$useBasename = function useBasename(createHistory) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var history = createHistory(options);
        var basename = options.basename;
        var addBasename = function addBasename(location) {
            if (!location) return location;
            if (basename && location.basename == null) {
                if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
                    location.pathname = location.pathname.substring(basename.length);
                    location.basename = basename;
                    if (location.pathname === '') location.pathname = '/';
                } else location.basename = '';
            }
            return location;
        };
        var prependBasename = function prependBasename(location) {
            if (!basename) return location;
            var object = typeof location === 'string' ? (0, $d5fdbd19f96d08cc$export$8ccf933b0513f8d0)(location) : location;
            var pname = object.pathname;
            var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
            var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
            var pathname = normalizedBasename + normalizedPathname;
            return $a67113ed51312a28$var$_extends({}, object, {
                pathname: pathname
            });
        };
        // Override all read methods with basename-aware versions.
        var getCurrentLocation = function getCurrentLocation() {
            return addBasename(history.getCurrentLocation());
        };
        var listenBefore = function listenBefore(hook) {
            return history.listenBefore(function(location, callback) {
                return (0, $a67113ed51312a28$var$_runTransitionHook2.default)(hook, addBasename(location), callback);
            });
        };
        var listen = function listen(listener) {
            return history.listen(function(location) {
                return listener(addBasename(location));
            });
        };
        // Override all write methods with basename-aware versions.
        var push = function push(location) {
            return history.push(prependBasename(location));
        };
        var replace = function replace(location) {
            return history.replace(prependBasename(location));
        };
        var createPath = function createPath(location) {
            return history.createPath(prependBasename(location));
        };
        var createHref = function createHref(location) {
            return history.createHref(prependBasename(location));
        };
        var createLocation = function createLocation(location) {
            for(var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return addBasename(history.createLocation.apply(history, [
                prependBasename(location)
            ].concat(args)));
        };
        return $a67113ed51312a28$var$_extends({}, history, {
            getCurrentLocation: getCurrentLocation,
            listenBefore: listenBefore,
            listen: listen,
            push: push,
            replace: replace,
            createPath: createPath,
            createHref: createHref,
            createLocation: createLocation
        });
    };
};
$a67113ed51312a28$export$2e2bcd8739ae039 = $a67113ed51312a28$var$useBasename;


var $c681c3cc939ca893$exports = {};

$parcel$defineInteropFlag($c681c3cc939ca893$exports);

$parcel$export($c681c3cc939ca893$exports, "__esModule", function () { return $c681c3cc939ca893$export$1e511d4a378977f5; }, function (v) { return $c681c3cc939ca893$export$1e511d4a378977f5 = v; });
$parcel$export($c681c3cc939ca893$exports, "default", function () { return $c681c3cc939ca893$export$2e2bcd8739ae039; }, function (v) { return $c681c3cc939ca893$export$2e2bcd8739ae039 = v; });
var $c681c3cc939ca893$export$1e511d4a378977f5;
var $c681c3cc939ca893$export$2e2bcd8739ae039;
'use strict';
$c681c3cc939ca893$export$1e511d4a378977f5 = true;
var $c681c3cc939ca893$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $c681c3cc939ca893$var$_warning2 = $c681c3cc939ca893$var$_interopRequireDefault($a6fffc526962516d$exports);

var $c681c3cc939ca893$var$_invariant2 = $c681c3cc939ca893$var$_interopRequireDefault($06dab2fcf604e778$exports);


var $9891aa318d20d5fc$exports = {};

$parcel$defineInteropFlag($9891aa318d20d5fc$exports);

$parcel$export($9891aa318d20d5fc$exports, "__esModule", function () { return $9891aa318d20d5fc$export$1e511d4a378977f5; }, function (v) { return $9891aa318d20d5fc$export$1e511d4a378977f5 = v; });
$parcel$export($9891aa318d20d5fc$exports, "default", function () { return $9891aa318d20d5fc$export$2e2bcd8739ae039; }, function (v) { return $9891aa318d20d5fc$export$2e2bcd8739ae039 = v; });
var $9891aa318d20d5fc$export$1e511d4a378977f5;
var $9891aa318d20d5fc$export$2e2bcd8739ae039;
'use strict';
$9891aa318d20d5fc$export$1e511d4a378977f5 = true;
var $b138ae60fdc7e3bc$export$1e511d4a378977f5;
var $b138ae60fdc7e3bc$export$9ec2b9560cd357f8;
"use strict";
$b138ae60fdc7e3bc$export$1e511d4a378977f5 = true;
var $b138ae60fdc7e3bc$var$loopAsync = $b138ae60fdc7e3bc$export$9ec2b9560cd357f8 = function loopAsync(turns, work, callback) {
    var currentTurn = 0, isDone = false;
    var isSync = false, hasNext = false, doneArgs = void 0;
    var done = function done() {
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        isDone = true;
        if (isSync) {
            // Iterate instead of recursing if possible.
            doneArgs = args;
            return;
        }
        callback.apply(undefined, args);
    };
    var next = function next() {
        if (isDone) return;
        hasNext = true;
        if (isSync) return; // Iterate instead of recursing if possible.
        isSync = true;
        while(!isDone && currentTurn < turns && hasNext){
            hasNext = false;
            work(currentTurn++, next, done);
        }
        isSync = false;
        if (isDone) {
            // This means the loop finished synchronously.
            callback.apply(undefined, doneArgs);
            return;
        }
        if (currentTurn >= turns && hasNext) {
            isDone = true;
            callback();
        }
    };
    next();
};




var $9891aa318d20d5fc$var$_runTransitionHook2 = $9891aa318d20d5fc$var$_interopRequireDefault($4b029d66e041770b$exports);


function $9891aa318d20d5fc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9891aa318d20d5fc$var$createHistory = function createHistory() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var getCurrentLocation = options.getCurrentLocation, getUserConfirmation = options.getUserConfirmation, pushLocation = options.pushLocation, replaceLocation = options.replaceLocation, go = options.go, keyLength = options.keyLength;
    var currentLocation = void 0;
    var pendingLocation = void 0;
    var beforeListeners = [];
    var listeners = [];
    var allKeys = [];
    var getCurrentIndex = function getCurrentIndex() {
        if (pendingLocation && pendingLocation.action === $7525598290eef164$export$fa3a15f086be9697) return allKeys.indexOf(pendingLocation.key);
        if (currentLocation) return allKeys.indexOf(currentLocation.key);
        return -1;
    };
    var updateLocation = function updateLocation(nextLocation) {
        var currentIndex = getCurrentIndex();
        currentLocation = nextLocation;
        if (currentLocation.action === $7525598290eef164$export$70b1f83e7123989d) allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [
            currentLocation.key
        ]);
        else if (currentLocation.action === $7525598290eef164$export$412b24539e92ced) allKeys[currentIndex] = currentLocation.key;
        listeners.forEach(function(listener) {
            return listener(currentLocation);
        });
    };
    var listenBefore = function listenBefore(listener) {
        beforeListeners.push(listener);
        return function() {
            return beforeListeners = beforeListeners.filter(function(item) {
                return item !== listener;
            });
        };
    };
    var listen = function listen(listener) {
        listeners.push(listener);
        return function() {
            return listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    };
    var confirmTransitionTo = function confirmTransitionTo(location, callback) {
        (0, $b138ae60fdc7e3bc$export$9ec2b9560cd357f8)(beforeListeners.length, function(index, next, done) {
            (0, $9891aa318d20d5fc$var$_runTransitionHook2.default)(beforeListeners[index], location, function(result) {
                return result != null ? done(result) : next();
            });
        }, function(message) {
            if (getUserConfirmation && typeof message === 'string') getUserConfirmation(message, function(ok) {
                return callback(ok !== false);
            });
            else callback(message !== false);
        });
    };
    var transitionTo = function transitionTo(nextLocation) {
        if (currentLocation && (0, $f3c3dba28fc87571$export$c3e8bb440bd55b18)(currentLocation, nextLocation) || pendingLocation && (0, $f3c3dba28fc87571$export$c3e8bb440bd55b18)(pendingLocation, nextLocation)) return; // Nothing to do
        pendingLocation = nextLocation;
        confirmTransitionTo(nextLocation, function(ok) {
            if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation
            pendingLocation = null;
            if (ok) {
                // Treat PUSH to same path like REPLACE to be consistent with browsers
                if (nextLocation.action === $7525598290eef164$export$70b1f83e7123989d) {
                    var prevPath = (0, $d5fdbd19f96d08cc$export$fe53371bee54353d)(currentLocation);
                    var nextPath = (0, $d5fdbd19f96d08cc$export$fe53371bee54353d)(nextLocation);
                    if (nextPath === prevPath && (0, $f3c3dba28fc87571$export$f85b5c57dd496263)(currentLocation.state, nextLocation.state)) nextLocation.action = $7525598290eef164$export$412b24539e92ced;
                }
                if (nextLocation.action === $7525598290eef164$export$fa3a15f086be9697) updateLocation(nextLocation);
                else if (nextLocation.action === $7525598290eef164$export$70b1f83e7123989d) {
                    if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
                } else if (nextLocation.action === $7525598290eef164$export$412b24539e92ced) {
                    if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
                }
            } else if (currentLocation && nextLocation.action === $7525598290eef164$export$fa3a15f086be9697) {
                var prevIndex = allKeys.indexOf(currentLocation.key);
                var nextIndex = allKeys.indexOf(nextLocation.key);
                if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
            }
        });
    };
    var push = function push(input) {
        return transitionTo(createLocation(input, $7525598290eef164$export$70b1f83e7123989d));
    };
    var replace = function replace(input) {
        return transitionTo(createLocation(input, $7525598290eef164$export$412b24539e92ced));
    };
    var goBack = function goBack() {
        return go(-1);
    };
    var goForward = function goForward() {
        return go(1);
    };
    var createKey = function createKey() {
        return Math.random().toString(36).substr(2, keyLength || 6);
    };
    var createHref = function createHref(location) {
        return (0, $d5fdbd19f96d08cc$export$fe53371bee54353d)(location);
    };
    var createLocation = function createLocation(location, action) {
        var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
        return (0, $f3c3dba28fc87571$export$90c043f1c57770b8)(location, action, key);
    };
    return {
        getCurrentLocation: getCurrentLocation,
        listenBefore: listenBefore,
        listen: listen,
        transitionTo: transitionTo,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        createKey: createKey,
        createPath: $d5fdbd19f96d08cc$export$fe53371bee54353d,
        createHref: createHref,
        createLocation: createLocation
    };
};
$9891aa318d20d5fc$export$2e2bcd8739ae039 = $9891aa318d20d5fc$var$createHistory;


var $c681c3cc939ca893$var$_createHistory2 = $c681c3cc939ca893$var$_interopRequireDefault($9891aa318d20d5fc$exports);

function $c681c3cc939ca893$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $c681c3cc939ca893$var$createStateStorage = function createStateStorage(entries) {
    return entries.filter(function(entry) {
        return entry.state;
    }).reduce(function(memo, entry) {
        memo[entry.key] = entry.state;
        return memo;
    }, {});
};
var $c681c3cc939ca893$var$createMemoryHistory = function createMemoryHistory() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (Array.isArray(options)) options = {
        entries: options
    };
    else if (typeof options === 'string') options = {
        entries: [
            options
        ]
    };
    var getCurrentLocation = function getCurrentLocation() {
        var entry = entries[current];
        var path = (0, $d5fdbd19f96d08cc$export$fe53371bee54353d)(entry);
        var key = void 0, state = void 0;
        if (entry.key) {
            key = entry.key;
            state = readState(key);
        }
        var init = (0, $d5fdbd19f96d08cc$export$8ccf933b0513f8d0)(path);
        return (0, $f3c3dba28fc87571$export$90c043f1c57770b8)($c681c3cc939ca893$var$_extends({}, init, {
            state: state
        }), undefined, key);
    };
    var canGo = function canGo(n) {
        var index = current + n;
        return index >= 0 && index < entries.length;
    };
    var go = function go(n) {
        if (!n) return;
        if (!canGo(n)) return;
        current += n;
        var currentLocation = getCurrentLocation();
        // Change action to POP
        history.transitionTo($c681c3cc939ca893$var$_extends({}, currentLocation, {
            action: $7525598290eef164$export$fa3a15f086be9697
        }));
    };
    var pushLocation = function pushLocation(location) {
        current += 1;
        if (current < entries.length) entries.splice(current);
        entries.push(location);
        saveState(location.key, location.state);
    };
    var replaceLocation = function replaceLocation(location) {
        entries[current] = location;
        saveState(location.key, location.state);
    };
    var history = (0, $c681c3cc939ca893$var$_createHistory2.default)($c681c3cc939ca893$var$_extends({}, options, {
        getCurrentLocation: getCurrentLocation,
        pushLocation: pushLocation,
        replaceLocation: replaceLocation,
        go: go
    }));
    var _options = options, entries = _options.entries, current = _options.current;
    if (typeof entries === 'string') entries = [
        entries
    ];
    else if (!Array.isArray(entries)) entries = [
        '/'
    ];
    entries = entries.map(function(entry) {
        return (0, $f3c3dba28fc87571$export$90c043f1c57770b8)(entry);
    });
    if (current == null) current = entries.length - 1;
    else !(current >= 0 && current < entries.length) && (0, $c681c3cc939ca893$var$_invariant2.default)(false);
    var storage = $c681c3cc939ca893$var$createStateStorage(entries);
    var saveState = function saveState(key, state) {
        return storage[key] = state;
    };
    var readState = function readState(key) {
        return storage[key];
    };
    return $c681c3cc939ca893$var$_extends({}, history, {
        canGo: canGo
    });
};
$c681c3cc939ca893$export$2e2bcd8739ae039 = $c681c3cc939ca893$var$createMemoryHistory;


function $dd5c8f130838256c$export$2e2bcd8739ae039(options) {
    // signatures and type checking differ between `useQueries` and
    // `createMemoryHistory`, have to create `memoryHistory` first because
    // `useQueries` doesn't understand the signature
    var memoryHistory = (0, $c681c3cc939ca893$export$2e2bcd8739ae039)(options);
    var createHistory = function createHistory() {
        return memoryHistory;
    };
    var history = (0, $5058ccf6f66c4484$export$2e2bcd8739ae039)((0, $a67113ed51312a28$export$2e2bcd8739ae039)(createHistory))(options);
    return history;
}





var $3ee25c2f19585292$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $3ee25c2f19585292$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
/**
 * A high-level API to be used for server-side rendering.
 *
 * This function matches a location to a set of routes and calls
 * callback(error, redirectLocation, renderProps) when finished.
 *
 * Note: You probably don't want to use this in a browser unless you're using
 * server-side rendering with async routes.
 */ function $3ee25c2f19585292$var$match(_ref, callback) {
    var history = _ref.history, routes = _ref.routes, location = _ref.location, options = $3ee25c2f19585292$var$_objectWithoutProperties(_ref, [
        'history',
        'routes',
        'location'
    ]);
    !(history || location) && (0, (/*@__PURE__*/$parcel$interopDefault($06dab2fcf604e778$exports)))(false);
    history = history ? history : (0, $dd5c8f130838256c$export$2e2bcd8739ae039)(options);
    var transitionManager = (0, $b5bf5a142c1cba35$export$2e2bcd8739ae039)(history, (0, $7f09464ec030dbdb$export$dfc730c04fdecfcb)(routes));
    if (location) // Allow match({ location: '/the/path', ... })
    location = history.createLocation(location);
    else location = history.getCurrentLocation();
    transitionManager.match(location, function(error, redirectLocation, nextState) {
        var renderProps = void 0;
        if (nextState) {
            var router = (0, $b16da4575fd3bd72$export$74502efa22785c5f)(history, transitionManager, nextState);
            renderProps = $3ee25c2f19585292$var$_extends({}, nextState, {
                router: router,
                matchContext: {
                    transitionManager: transitionManager,
                    router: router
                }
            });
        }
        callback(error, redirectLocation && history.createLocation(redirectLocation, (0, $7525598290eef164$export$412b24539e92ced)), renderProps);
    });
}
var $3ee25c2f19585292$export$2e2bcd8739ae039 = $3ee25c2f19585292$var$match;




function $6b4c7860a1964595$export$2e2bcd8739ae039(createHistory) {
    return function(options) {
        var history = (0, $5058ccf6f66c4484$export$2e2bcd8739ae039)((0, $a67113ed51312a28$export$2e2bcd8739ae039)(createHistory))(options);
        return history;
    };
}




var $NdCUR = parcelRequire("NdCUR");


var $49c1b03837986266$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $49c1b03837986266$export$2e2bcd8739ae039 = function() {
    for(var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    var withContext = middlewares.map(function(middleware) {
        return middleware.renderRouterContext;
    }).filter(Boolean);
    var withComponent = middlewares.map(function(middleware) {
        return middleware.renderRouteComponent;
    }).filter(Boolean);
    var makeCreateElement = function makeCreateElement() {
        var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $NdCUR.createElement);
        return function(Component, props) {
            return withComponent.reduceRight(function(previous, renderRouteComponent) {
                return renderRouteComponent(previous, props);
            }, baseCreateElement(Component, props));
        };
    };
    return function(renderProps) {
        return withContext.reduceRight(function(previous, renderRouterContext) {
            return renderRouterContext(previous, renderProps);
        }, (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $4c77761f035058c6$export$2e2bcd8739ae039), $49c1b03837986266$var$_extends({}, renderProps, {
            createElement: makeCreateElement(renderProps.createElement)
        })));
    };
};


var $301b2275904d2cc8$exports = {};

$parcel$defineInteropFlag($301b2275904d2cc8$exports);

$parcel$export($301b2275904d2cc8$exports, "__esModule", function () { return $301b2275904d2cc8$export$1e511d4a378977f5; }, function (v) { return $301b2275904d2cc8$export$1e511d4a378977f5 = v; });
$parcel$export($301b2275904d2cc8$exports, "default", function () { return $301b2275904d2cc8$export$2e2bcd8739ae039; }, function (v) { return $301b2275904d2cc8$export$2e2bcd8739ae039 = v; });
var $301b2275904d2cc8$export$1e511d4a378977f5;
var $301b2275904d2cc8$export$2e2bcd8739ae039;
'use strict';
$301b2275904d2cc8$export$1e511d4a378977f5 = true;
var $301b2275904d2cc8$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $301b2275904d2cc8$var$_invariant2 = $301b2275904d2cc8$var$_interopRequireDefault($06dab2fcf604e778$exports);
var $f447afd9b3df7155$export$1e511d4a378977f5;
var $f447afd9b3df7155$export$71594e8a50f746f4;
'use strict';
$f447afd9b3df7155$export$1e511d4a378977f5 = true;
var $f447afd9b3df7155$var$canUseDOM = $f447afd9b3df7155$export$71594e8a50f746f4 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


var $0693e328ab245220$exports = {};

$parcel$export($0693e328ab245220$exports, "__esModule", function () { return $0693e328ab245220$export$1e511d4a378977f5; }, function (v) { return $0693e328ab245220$export$1e511d4a378977f5 = v; });
$parcel$export($0693e328ab245220$exports, "go", function () { return $0693e328ab245220$export$93bb224d05b3906d; }, function (v) { return $0693e328ab245220$export$93bb224d05b3906d = v; });
$parcel$export($0693e328ab245220$exports, "replaceLocation", function () { return $0693e328ab245220$export$7b3edfcb6482ce6d; }, function (v) { return $0693e328ab245220$export$7b3edfcb6482ce6d = v; });
$parcel$export($0693e328ab245220$exports, "pushLocation", function () { return $0693e328ab245220$export$b2c71ca527aada67; }, function (v) { return $0693e328ab245220$export$b2c71ca527aada67 = v; });
$parcel$export($0693e328ab245220$exports, "startListener", function () { return $0693e328ab245220$export$e7a68fb6594be085; }, function (v) { return $0693e328ab245220$export$e7a68fb6594be085 = v; });
$parcel$export($0693e328ab245220$exports, "getUserConfirmation", function () { return $0693e328ab245220$export$255f30687672904; }, function (v) { return $0693e328ab245220$export$255f30687672904 = v; });
$parcel$export($0693e328ab245220$exports, "getCurrentLocation", function () { return $0693e328ab245220$export$ff18198dd7d35db9; }, function (v) { return $0693e328ab245220$export$ff18198dd7d35db9 = v; });
var $0693e328ab245220$export$1e511d4a378977f5;
var $0693e328ab245220$export$93bb224d05b3906d;
var $0693e328ab245220$export$7b3edfcb6482ce6d;
var $0693e328ab245220$export$b2c71ca527aada67;
var $0693e328ab245220$export$e7a68fb6594be085;
var $0693e328ab245220$export$255f30687672904;
var $0693e328ab245220$export$ff18198dd7d35db9;
'use strict';
$0693e328ab245220$export$1e511d4a378977f5 = true;
$0693e328ab245220$export$93bb224d05b3906d = $0693e328ab245220$export$7b3edfcb6482ce6d = $0693e328ab245220$export$b2c71ca527aada67 = $0693e328ab245220$export$e7a68fb6594be085 = $0693e328ab245220$export$255f30687672904 = $0693e328ab245220$export$ff18198dd7d35db9 = undefined;

var $56e397f69e98ec6f$export$1e511d4a378977f5;
var $56e397f69e98ec6f$export$3f65cefe8380dbea;
var $56e397f69e98ec6f$export$8ff9f68337b520c0;
var $56e397f69e98ec6f$export$67fc34576016d6ec;
var $56e397f69e98ec6f$export$9a5b29ff20eb48f9;
var $56e397f69e98ec6f$export$68abd4ae3bbf6cf3;
var $56e397f69e98ec6f$export$aa3c5b1dd6fed00;
'use strict';
$56e397f69e98ec6f$export$1e511d4a378977f5 = true;
var $56e397f69e98ec6f$var$addEventListener = $56e397f69e98ec6f$export$3f65cefe8380dbea = function addEventListener(node, event, listener) {
    return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};
var $56e397f69e98ec6f$var$removeEventListener = $56e397f69e98ec6f$export$8ff9f68337b520c0 = function removeEventListener(node, event, listener) {
    return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ var $56e397f69e98ec6f$var$supportsHistory = $56e397f69e98ec6f$export$67fc34576016d6ec = function supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
};
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ var $56e397f69e98ec6f$var$supportsGoWithoutReloadUsingHash = $56e397f69e98ec6f$export$9a5b29ff20eb48f9 = function supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
};
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ var $56e397f69e98ec6f$var$supportsPopstateOnHashchange = $56e397f69e98ec6f$export$68abd4ae3bbf6cf3 = function supportsPopstateOnHashchange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
};
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ var $56e397f69e98ec6f$var$isExtraneousPopstateEvent = $56e397f69e98ec6f$export$aa3c5b1dd6fed00 = function isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};


var $ae5cc3d4c0033687$export$1e511d4a378977f5;
var $ae5cc3d4c0033687$export$b07a0010405aa729;
var $ae5cc3d4c0033687$export$fb931cd598921492;
'use strict';
$ae5cc3d4c0033687$export$1e511d4a378977f5 = true;
$ae5cc3d4c0033687$export$b07a0010405aa729 = $ae5cc3d4c0033687$export$fb931cd598921492 = undefined;

var $ae5cc3d4c0033687$var$_warning2 = $ae5cc3d4c0033687$var$_interopRequireDefault($a6fffc526962516d$exports);
function $ae5cc3d4c0033687$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $ae5cc3d4c0033687$var$QuotaExceededErrors = {
    QuotaExceededError: true,
    QUOTA_EXCEEDED_ERR: true
};
var $ae5cc3d4c0033687$var$SecurityErrors = {
    SecurityError: true
};
var $ae5cc3d4c0033687$var$KeyPrefix = '@@History/';
var $ae5cc3d4c0033687$var$createKey = function createKey(key) {
    return $ae5cc3d4c0033687$var$KeyPrefix + key;
};
var $ae5cc3d4c0033687$var$saveState = $ae5cc3d4c0033687$export$fb931cd598921492 = function saveState(key, state) {
    if (!window.sessionStorage) return;
    try {
        if (state == null) window.sessionStorage.removeItem($ae5cc3d4c0033687$var$createKey(key));
        else window.sessionStorage.setItem($ae5cc3d4c0033687$var$createKey(key), JSON.stringify(state));
    } catch (error) {
        if ($ae5cc3d4c0033687$var$SecurityErrors[error.name]) return;
        if ($ae5cc3d4c0033687$var$QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) return;
        throw error;
    }
};
var $ae5cc3d4c0033687$var$readState = $ae5cc3d4c0033687$export$b07a0010405aa729 = function readState(key) {
    var json = void 0;
    try {
        json = window.sessionStorage.getItem($ae5cc3d4c0033687$var$createKey(key));
    } catch (error) {
        if ($ae5cc3d4c0033687$var$SecurityErrors[error.name]) return undefined;
    }
    if (json) try {
        return JSON.parse(json);
    } catch (error) {
    // Ignore invalid JSON.
    }
    return undefined;
};




var $0693e328ab245220$var$PopStateEvent = 'popstate';
var $0693e328ab245220$var$HashChangeEvent = 'hashchange';
var $0693e328ab245220$var$needsHashchangeListener = $f447afd9b3df7155$export$71594e8a50f746f4 && !(0, $56e397f69e98ec6f$export$68abd4ae3bbf6cf3)();
var $0693e328ab245220$var$_createLocation = function _createLocation(historyState) {
    var key = historyState && historyState.key;
    return (0, $f3c3dba28fc87571$export$90c043f1c57770b8)({
        pathname: window.location.pathname,
        search: window.location.search,
        hash: window.location.hash,
        state: key ? (0, $ae5cc3d4c0033687$export$b07a0010405aa729)(key) : undefined
    }, undefined, key);
};
var $0693e328ab245220$var$getCurrentLocation = $0693e328ab245220$export$ff18198dd7d35db9 = function getCurrentLocation() {
    var historyState = void 0;
    try {
        historyState = window.history.state || {};
    } catch (error) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        historyState = {};
    }
    return $0693e328ab245220$var$_createLocation(historyState);
};
var $0693e328ab245220$var$getUserConfirmation = $0693e328ab245220$export$255f30687672904 = function getUserConfirmation(message, callback) {
    return callback(window.confirm(message));
}; // eslint-disable-line no-alert
var $0693e328ab245220$var$startListener = $0693e328ab245220$export$e7a68fb6594be085 = function startListener(listener) {
    var handlePopState = function handlePopState(event) {
        if ((0, $56e397f69e98ec6f$export$aa3c5b1dd6fed00)(event)) return;
        listener($0693e328ab245220$var$_createLocation(event.state));
    };
    (0, $56e397f69e98ec6f$export$3f65cefe8380dbea)(window, $0693e328ab245220$var$PopStateEvent, handlePopState);
    var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
        return listener($0693e328ab245220$var$getCurrentLocation());
    };
    if ($0693e328ab245220$var$needsHashchangeListener) (0, $56e397f69e98ec6f$export$3f65cefe8380dbea)(window, $0693e328ab245220$var$HashChangeEvent, handleUnpoppedHashChange);
    return function() {
        (0, $56e397f69e98ec6f$export$8ff9f68337b520c0)(window, $0693e328ab245220$var$PopStateEvent, handlePopState);
        if ($0693e328ab245220$var$needsHashchangeListener) (0, $56e397f69e98ec6f$export$8ff9f68337b520c0)(window, $0693e328ab245220$var$HashChangeEvent, handleUnpoppedHashChange);
    };
};
var $0693e328ab245220$var$updateLocation = function updateLocation(location, updateState) {
    var state = location.state, key = location.key;
    if (state !== undefined) (0, $ae5cc3d4c0033687$export$fb931cd598921492)(key, state);
    updateState({
        key: key
    }, (0, $d5fdbd19f96d08cc$export$fe53371bee54353d)(location));
};
var $0693e328ab245220$var$pushLocation = $0693e328ab245220$export$b2c71ca527aada67 = function pushLocation(location) {
    return $0693e328ab245220$var$updateLocation(location, function(state, path) {
        return window.history.pushState(state, null, path);
    });
};
var $0693e328ab245220$var$replaceLocation = $0693e328ab245220$export$7b3edfcb6482ce6d = function replaceLocation(location) {
    return $0693e328ab245220$var$updateLocation(location, function(state, path) {
        return window.history.replaceState(state, null, path);
    });
};
var $0693e328ab245220$var$go = $0693e328ab245220$export$93bb224d05b3906d = function go(n) {
    if (n) window.history.go(n);
};


var $301b2275904d2cc8$var$BrowserProtocol = $301b2275904d2cc8$var$_interopRequireWildcard($0693e328ab245220$exports);
var $9de58b41e74bf17e$exports = {};
'use strict';
$9de58b41e74bf17e$exports.__esModule = true;
$9de58b41e74bf17e$exports.replaceLocation = $9de58b41e74bf17e$exports.pushLocation = $9de58b41e74bf17e$exports.getCurrentLocation = $9de58b41e74bf17e$exports.go = $9de58b41e74bf17e$exports.getUserConfirmation = undefined;

Object.defineProperty($9de58b41e74bf17e$exports, 'getUserConfirmation', {
    enumerable: true,
    get: function get() {
        return $0693e328ab245220$export$255f30687672904;
    }
});
Object.defineProperty($9de58b41e74bf17e$exports, 'go', {
    enumerable: true,
    get: function get() {
        return $0693e328ab245220$export$93bb224d05b3906d;
    }
});


var $9de58b41e74bf17e$var$getCurrentLocation = $9de58b41e74bf17e$exports.getCurrentLocation = function getCurrentLocation() {
    return (0, $f3c3dba28fc87571$export$90c043f1c57770b8)(window.location);
};
var $9de58b41e74bf17e$var$pushLocation = $9de58b41e74bf17e$exports.pushLocation = function pushLocation(location) {
    window.location.href = (0, $d5fdbd19f96d08cc$export$fe53371bee54353d)(location);
    return false; // Don't update location
};
var $9de58b41e74bf17e$var$replaceLocation = $9de58b41e74bf17e$exports.replaceLocation = function replaceLocation(location) {
    window.location.replace((0, $d5fdbd19f96d08cc$export$fe53371bee54353d)(location));
    return false; // Don't update location
};


var $301b2275904d2cc8$var$RefreshProtocol = $301b2275904d2cc8$var$_interopRequireWildcard($9de58b41e74bf17e$exports);


var $301b2275904d2cc8$var$_createHistory2 = $301b2275904d2cc8$var$_interopRequireDefault($9891aa318d20d5fc$exports);
function $301b2275904d2cc8$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $301b2275904d2cc8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Creates and returns a history object that uses HTML5's history API
 * (pushState, replaceState, and the popstate event) to manage history.
 * This is the recommended method of managing history in browsers because
 * it provides the cleanest URLs.
 *
 * Note: In browsers that do not support the HTML5 history API full
 * page reloads will be used to preserve clean URLs. You can force this
 * behavior using { forceRefresh: true } in options.
 */ var $301b2275904d2cc8$var$createBrowserHistory = function createBrowserHistory() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    !$f447afd9b3df7155$export$71594e8a50f746f4 && (0, $301b2275904d2cc8$var$_invariant2.default)(false);
    var useRefresh = options.forceRefresh || !(0, $56e397f69e98ec6f$export$67fc34576016d6ec)();
    var Protocol = useRefresh ? $301b2275904d2cc8$var$RefreshProtocol : $301b2275904d2cc8$var$BrowserProtocol;
    var getUserConfirmation = Protocol.getUserConfirmation, getCurrentLocation = Protocol.getCurrentLocation, pushLocation = Protocol.pushLocation, replaceLocation = Protocol.replaceLocation, go = Protocol.go;
    var history = (0, $301b2275904d2cc8$var$_createHistory2.default)($301b2275904d2cc8$var$_extends({
        getUserConfirmation: getUserConfirmation
    }, options, {
        getCurrentLocation: getCurrentLocation,
        pushLocation: pushLocation,
        replaceLocation: replaceLocation,
        go: go
    }));
    var listenerCount = 0, stopListener = void 0;
    var startListener = function startListener(listener, before) {
        if (++listenerCount === 1) stopListener = $301b2275904d2cc8$var$BrowserProtocol.startListener(history.transitionTo);
        var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
        return function() {
            unlisten();
            if (--listenerCount === 0) stopListener();
        };
    };
    var listenBefore = function listenBefore(listener) {
        return startListener(listener, true);
    };
    var listen = function listen(listener) {
        return startListener(listener, false);
    };
    return $301b2275904d2cc8$var$_extends({}, history, {
        listenBefore: listenBefore,
        listen: listen
    });
};
$301b2275904d2cc8$export$2e2bcd8739ae039 = $301b2275904d2cc8$var$createBrowserHistory;



var $41ad0be16b4f1c58$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $41ad0be16b4f1c58$export$2e2bcd8739ae039(createHistory) {
    var history = void 0;
    if ($41ad0be16b4f1c58$var$canUseDOM) history = (0, $6b4c7860a1964595$export$2e2bcd8739ae039)(createHistory)();
    return history;
}


var $0c32e5adc5032137$export$2e2bcd8739ae039 = (0, $41ad0be16b4f1c58$export$2e2bcd8739ae039)((0, $301b2275904d2cc8$export$2e2bcd8739ae039));


var $4b660e95eaaf009c$exports = {};

$parcel$defineInteropFlag($4b660e95eaaf009c$exports);

$parcel$export($4b660e95eaaf009c$exports, "__esModule", function () { return $4b660e95eaaf009c$export$1e511d4a378977f5; }, function (v) { return $4b660e95eaaf009c$export$1e511d4a378977f5 = v; });
$parcel$export($4b660e95eaaf009c$exports, "default", function () { return $4b660e95eaaf009c$export$2e2bcd8739ae039; }, function (v) { return $4b660e95eaaf009c$export$2e2bcd8739ae039 = v; });
var $4b660e95eaaf009c$export$1e511d4a378977f5;
var $4b660e95eaaf009c$export$2e2bcd8739ae039;
'use strict';
$4b660e95eaaf009c$export$1e511d4a378977f5 = true;
var $4b660e95eaaf009c$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $4b660e95eaaf009c$var$_warning2 = $4b660e95eaaf009c$var$_interopRequireDefault($a6fffc526962516d$exports);

var $4b660e95eaaf009c$var$_invariant2 = $4b660e95eaaf009c$var$_interopRequireDefault($06dab2fcf604e778$exports);


var $3024e923924e35c3$exports = {};
'use strict';
$3024e923924e35c3$exports.__esModule = true;
$3024e923924e35c3$exports.replaceLocation = $3024e923924e35c3$exports.pushLocation = $3024e923924e35c3$exports.startListener = $3024e923924e35c3$exports.getCurrentLocation = $3024e923924e35c3$exports.go = $3024e923924e35c3$exports.getUserConfirmation = undefined;

Object.defineProperty($3024e923924e35c3$exports, 'getUserConfirmation', {
    enumerable: true,
    get: function get() {
        return $0693e328ab245220$export$255f30687672904;
    }
});
Object.defineProperty($3024e923924e35c3$exports, 'go', {
    enumerable: true,
    get: function get() {
        return $0693e328ab245220$export$93bb224d05b3906d;
    }
});

var $3024e923924e35c3$var$_warning2 = $3024e923924e35c3$var$_interopRequireDefault($a6fffc526962516d$exports);




function $3024e923924e35c3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $3024e923924e35c3$var$HashChangeEvent = 'hashchange';
var $3024e923924e35c3$var$getHashPath = function getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};
var $3024e923924e35c3$var$pushHashPath = function pushHashPath(path) {
    return window.location.hash = path;
};
var $3024e923924e35c3$var$replaceHashPath = function replaceHashPath(path) {
    var hashIndex = window.location.href.indexOf('#');
    window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};
var $3024e923924e35c3$var$getCurrentLocation = $3024e923924e35c3$exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
    var path = pathCoder.decodePath($3024e923924e35c3$var$getHashPath());
    var key = (0, $d5fdbd19f96d08cc$export$9be10eb6501fc5cb)(path, queryKey);
    var state = void 0;
    if (key) {
        path = (0, $d5fdbd19f96d08cc$export$c5133843bec439c1)(path, queryKey);
        state = (0, $ae5cc3d4c0033687$export$b07a0010405aa729)(key);
    }
    var init = (0, $d5fdbd19f96d08cc$export$8ccf933b0513f8d0)(path);
    init.state = state;
    return (0, $f3c3dba28fc87571$export$90c043f1c57770b8)(init, undefined, key);
};
var $3024e923924e35c3$var$prevLocation = void 0;
var $3024e923924e35c3$var$startListener = $3024e923924e35c3$exports.startListener = function startListener(listener, pathCoder, queryKey) {
    var handleHashChange = function handleHashChange() {
        var path = $3024e923924e35c3$var$getHashPath();
        var encodedPath = pathCoder.encodePath(path);
        if (path !== encodedPath) // Always be sure we have a properly-encoded hash.
        $3024e923924e35c3$var$replaceHashPath(encodedPath);
        else {
            var currentLocation = $3024e923924e35c3$var$getCurrentLocation(pathCoder, queryKey);
            if ($3024e923924e35c3$var$prevLocation && currentLocation.key && $3024e923924e35c3$var$prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events
            $3024e923924e35c3$var$prevLocation = currentLocation;
            listener(currentLocation);
        }
    };
    // Ensure the hash is encoded properly.
    var path = $3024e923924e35c3$var$getHashPath();
    var encodedPath = pathCoder.encodePath(path);
    if (path !== encodedPath) $3024e923924e35c3$var$replaceHashPath(encodedPath);
    (0, $56e397f69e98ec6f$export$3f65cefe8380dbea)(window, $3024e923924e35c3$var$HashChangeEvent, handleHashChange);
    return function() {
        return (0, $56e397f69e98ec6f$export$8ff9f68337b520c0)(window, $3024e923924e35c3$var$HashChangeEvent, handleHashChange);
    };
};
var $3024e923924e35c3$var$updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
    var state = location.state, key = location.key;
    var path = pathCoder.encodePath((0, $d5fdbd19f96d08cc$export$fe53371bee54353d)(location));
    if (state !== undefined) {
        path = (0, $d5fdbd19f96d08cc$export$ba97c4fa4c9c94b0)(path, queryKey, key);
        (0, $ae5cc3d4c0033687$export$fb931cd598921492)(key, state);
    }
    $3024e923924e35c3$var$prevLocation = location;
    updateHash(path);
};
var $3024e923924e35c3$var$pushLocation = $3024e923924e35c3$exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
    return $3024e923924e35c3$var$updateLocation(location, pathCoder, queryKey, function(path) {
        if ($3024e923924e35c3$var$getHashPath() !== path) $3024e923924e35c3$var$pushHashPath(path);
    });
};
var $3024e923924e35c3$var$replaceLocation = $3024e923924e35c3$exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
    return $3024e923924e35c3$var$updateLocation(location, pathCoder, queryKey, function(path) {
        if ($3024e923924e35c3$var$getHashPath() !== path) $3024e923924e35c3$var$replaceHashPath(path);
    });
};


var $4b660e95eaaf009c$var$HashProtocol = $4b660e95eaaf009c$var$_interopRequireWildcard($3024e923924e35c3$exports);

var $4b660e95eaaf009c$var$_createHistory2 = $4b660e95eaaf009c$var$_interopRequireDefault($9891aa318d20d5fc$exports);
function $4b660e95eaaf009c$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $4b660e95eaaf009c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $4b660e95eaaf009c$var$DefaultQueryKey = '_k';
var $4b660e95eaaf009c$var$addLeadingSlash = function addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
};
var $4b660e95eaaf009c$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!' + path;
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substring(1) : path;
        }
    },
    noslash: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '/' ? path.substring(1) : path;
        },
        decodePath: $4b660e95eaaf009c$var$addLeadingSlash
    },
    slash: {
        encodePath: $4b660e95eaaf009c$var$addLeadingSlash,
        decodePath: $4b660e95eaaf009c$var$addLeadingSlash
    }
};
var $4b660e95eaaf009c$var$createHashHistory = function createHashHistory() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    !$f447afd9b3df7155$export$71594e8a50f746f4 && (0, $4b660e95eaaf009c$var$_invariant2.default)(false);
    var queryKey = options.queryKey, hashType = options.hashType;
    if (typeof queryKey !== 'string') queryKey = $4b660e95eaaf009c$var$DefaultQueryKey;
    if (hashType == null) hashType = 'slash';
    if (!(hashType in $4b660e95eaaf009c$var$HashPathCoders)) hashType = 'slash';
    var pathCoder = $4b660e95eaaf009c$var$HashPathCoders[hashType];
    var getUserConfirmation = $4b660e95eaaf009c$var$HashProtocol.getUserConfirmation;
    var getCurrentLocation = function getCurrentLocation() {
        return $4b660e95eaaf009c$var$HashProtocol.getCurrentLocation(pathCoder, queryKey);
    };
    var pushLocation = function pushLocation(location) {
        return $4b660e95eaaf009c$var$HashProtocol.pushLocation(location, pathCoder, queryKey);
    };
    var replaceLocation = function replaceLocation(location) {
        return $4b660e95eaaf009c$var$HashProtocol.replaceLocation(location, pathCoder, queryKey);
    };
    var history = (0, $4b660e95eaaf009c$var$_createHistory2.default)($4b660e95eaaf009c$var$_extends({
        getUserConfirmation: getUserConfirmation
    }, options, {
        getCurrentLocation: getCurrentLocation,
        pushLocation: pushLocation,
        replaceLocation: replaceLocation,
        go: $4b660e95eaaf009c$var$HashProtocol.go
    }));
    var listenerCount = 0, stopListener = void 0;
    var startListener = function startListener(listener, before) {
        if (++listenerCount === 1) stopListener = $4b660e95eaaf009c$var$HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);
        var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
        return function() {
            unlisten();
            if (--listenerCount === 0) stopListener();
        };
    };
    var listenBefore = function listenBefore(listener) {
        return startListener(listener, true);
    };
    var listen = function listen(listener) {
        return startListener(listener, false);
    };
    var goIsSupportedWithoutReload = (0, $56e397f69e98ec6f$export$9a5b29ff20eb48f9)();
    var go = function go(n) {
        history.go(n);
    };
    var createHref = function createHref(path) {
        return '#' + pathCoder.encodePath(history.createHref(path));
    };
    return $4b660e95eaaf009c$var$_extends({}, history, {
        listenBefore: listenBefore,
        listen: listen,
        go: go,
        createHref: createHref
    });
};
$4b660e95eaaf009c$export$2e2bcd8739ae039 = $4b660e95eaaf009c$var$createHashHistory;



var $353c48bd751553a5$export$2e2bcd8739ae039 = (0, $41ad0be16b4f1c58$export$2e2bcd8739ae039)((0, $4b660e95eaaf009c$export$2e2bcd8739ae039));





var $5c2c7cce1dcca23a$exports = {};
'use strict';
$5c2c7cce1dcca23a$exports.__esModule = true;
$5c2c7cce1dcca23a$exports.locationsAreEqual = $5c2c7cce1dcca23a$exports.Actions = $5c2c7cce1dcca23a$exports.useQueries = $5c2c7cce1dcca23a$exports.useBeforeUnload = $5c2c7cce1dcca23a$exports.useBasename = $5c2c7cce1dcca23a$exports.createMemoryHistory = $5c2c7cce1dcca23a$exports.createHashHistory = $5c2c7cce1dcca23a$exports.createHistory = undefined;

Object.defineProperty($5c2c7cce1dcca23a$exports, 'locationsAreEqual', {
    enumerable: true,
    get: function get() {
        return $f3c3dba28fc87571$export$c3e8bb440bd55b18;
    }
});

var $5c2c7cce1dcca23a$var$_createBrowserHistory2 = $5c2c7cce1dcca23a$var$_interopRequireDefault($301b2275904d2cc8$exports);

var $5c2c7cce1dcca23a$var$_createHashHistory3 = $5c2c7cce1dcca23a$var$_interopRequireDefault($4b660e95eaaf009c$exports);

var $5c2c7cce1dcca23a$var$_createMemoryHistory3 = $5c2c7cce1dcca23a$var$_interopRequireDefault($c681c3cc939ca893$exports);

var $5c2c7cce1dcca23a$var$_useBasename3 = $5c2c7cce1dcca23a$var$_interopRequireDefault($a67113ed51312a28$exports);
var $70468dce2dd3dcb1$exports = {};

$parcel$defineInteropFlag($70468dce2dd3dcb1$exports);

$parcel$export($70468dce2dd3dcb1$exports, "__esModule", function () { return $70468dce2dd3dcb1$export$1e511d4a378977f5; }, function (v) { return $70468dce2dd3dcb1$export$1e511d4a378977f5 = v; });
$parcel$export($70468dce2dd3dcb1$exports, "default", function () { return $70468dce2dd3dcb1$export$2e2bcd8739ae039; }, function (v) { return $70468dce2dd3dcb1$export$2e2bcd8739ae039 = v; });
var $70468dce2dd3dcb1$export$1e511d4a378977f5;
var $70468dce2dd3dcb1$export$2e2bcd8739ae039;
'use strict';
$70468dce2dd3dcb1$export$1e511d4a378977f5 = true;
var $70468dce2dd3dcb1$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $70468dce2dd3dcb1$var$_invariant2 = $70468dce2dd3dcb1$var$_interopRequireDefault($06dab2fcf604e778$exports);


function $70468dce2dd3dcb1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $70468dce2dd3dcb1$var$startListener = function startListener(getPromptMessage) {
    var handleBeforeUnload = function handleBeforeUnload(event) {
        var message = getPromptMessage();
        if (typeof message === 'string') {
            (event || window.event).returnValue = message;
            return message;
        }
        return undefined;
    };
    (0, $56e397f69e98ec6f$export$3f65cefe8380dbea)(window, 'beforeunload', handleBeforeUnload);
    return function() {
        return (0, $56e397f69e98ec6f$export$8ff9f68337b520c0)(window, 'beforeunload', handleBeforeUnload);
    };
};
/**
 * Returns a new createHistory function that can be used to create
 * history objects that know how to use the beforeunload event in web
 * browsers to cancel navigation.
 */ var $70468dce2dd3dcb1$var$useBeforeUnload = function useBeforeUnload(createHistory) {
    !$f447afd9b3df7155$export$71594e8a50f746f4 && (0, $70468dce2dd3dcb1$var$_invariant2.default)(false);
    return function(options) {
        var history = createHistory(options);
        var listeners = [];
        var stopListener = void 0;
        var getPromptMessage = function getPromptMessage() {
            var message = void 0;
            for(var i = 0, len = listeners.length; message == null && i < len; ++i)message = listeners[i].call();
            return message;
        };
        var listenBeforeUnload = function listenBeforeUnload(listener) {
            if (listeners.push(listener) === 1) stopListener = $70468dce2dd3dcb1$var$startListener(getPromptMessage);
            return function() {
                listeners = listeners.filter(function(item) {
                    return item !== listener;
                });
                if (listeners.length === 0 && stopListener) {
                    stopListener();
                    stopListener = null;
                }
            };
        };
        return $70468dce2dd3dcb1$var$_extends({}, history, {
            listenBeforeUnload: listenBeforeUnload
        });
    };
};
$70468dce2dd3dcb1$export$2e2bcd8739ae039 = $70468dce2dd3dcb1$var$useBeforeUnload;


var $5c2c7cce1dcca23a$var$_useBeforeUnload3 = $5c2c7cce1dcca23a$var$_interopRequireDefault($70468dce2dd3dcb1$exports);

var $5c2c7cce1dcca23a$var$_useQueries3 = $5c2c7cce1dcca23a$var$_interopRequireDefault($5058ccf6f66c4484$exports);

var $5c2c7cce1dcca23a$var$_Actions = $5c2c7cce1dcca23a$var$_interopRequireWildcard($7525598290eef164$exports);
function $5c2c7cce1dcca23a$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $5c2c7cce1dcca23a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$5c2c7cce1dcca23a$exports.createHistory = $5c2c7cce1dcca23a$var$_createBrowserHistory2.default;
$5c2c7cce1dcca23a$exports.createHashHistory = $5c2c7cce1dcca23a$var$_createHashHistory3.default;
$5c2c7cce1dcca23a$exports.createMemoryHistory = $5c2c7cce1dcca23a$var$_createMemoryHistory3.default;
$5c2c7cce1dcca23a$exports.useBasename = $5c2c7cce1dcca23a$var$_useBasename3.default;
$5c2c7cce1dcca23a$exports.useBeforeUnload = $5c2c7cce1dcca23a$var$_useBeforeUnload3.default;
$5c2c7cce1dcca23a$exports.useQueries = $5c2c7cce1dcca23a$var$_useQueries3.default;
$5c2c7cce1dcca23a$exports.Actions = $5c2c7cce1dcca23a$var$_Actions;


var $14b9f70b6017fdee$exports = {};
'use strict';
Object.defineProperty($14b9f70b6017fdee$exports, "__esModule", {
    value: true
});
$14b9f70b6017fdee$exports.routerMiddleware = $14b9f70b6017fdee$exports.routerActions = $14b9f70b6017fdee$exports.goForward = $14b9f70b6017fdee$exports.goBack = $14b9f70b6017fdee$exports.go = $14b9f70b6017fdee$exports.replace = $14b9f70b6017fdee$exports.push = $14b9f70b6017fdee$exports.CALL_HISTORY_METHOD = $14b9f70b6017fdee$exports.routerReducer = $14b9f70b6017fdee$exports.LOCATION_CHANGE = $14b9f70b6017fdee$exports.syncHistoryWithStore = undefined;
var $0d6271c237556cbf$exports = {};
'use strict';
Object.defineProperty($0d6271c237556cbf$exports, "__esModule", {
    value: true
});
var $0d6271c237556cbf$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
$0d6271c237556cbf$exports.routerReducer = $0d6271c237556cbf$var$routerReducer;
/**
 * This action type will be dispatched when your history
 * receives a location change.
 */ var $0d6271c237556cbf$var$LOCATION_CHANGE = $0d6271c237556cbf$exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
var $0d6271c237556cbf$var$initialState = {
    locationBeforeTransitions: null
};
/**
 * This reducer will update the state with the most recent location history
 * has transitioned to. This may not be in sync with the router, particularly
 * if you have asynchronously-loaded routes, so reading from and relying on
 * this state is discouraged.
 */ function $0d6271c237556cbf$var$routerReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $0d6271c237556cbf$var$initialState;
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, type = _ref.type, payload = _ref.payload;
    if (type === $0d6271c237556cbf$var$LOCATION_CHANGE) return $0d6271c237556cbf$var$_extends({}, state, {
        locationBeforeTransitions: payload
    });
    return state;
}


Object.defineProperty($14b9f70b6017fdee$exports, 'LOCATION_CHANGE', {
    enumerable: true,
    get: function get() {
        return $0d6271c237556cbf$exports.LOCATION_CHANGE;
    }
});
Object.defineProperty($14b9f70b6017fdee$exports, 'routerReducer', {
    enumerable: true,
    get: function get() {
        return $0d6271c237556cbf$exports.routerReducer;
    }
});
var $3ddd3cb1d8e35c2c$exports = {};
'use strict';
Object.defineProperty($3ddd3cb1d8e35c2c$exports, "__esModule", {
    value: true
});
/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */ var $3ddd3cb1d8e35c2c$var$CALL_HISTORY_METHOD = $3ddd3cb1d8e35c2c$exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';
function $3ddd3cb1d8e35c2c$var$updateLocation(method) {
    return function() {
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return {
            type: $3ddd3cb1d8e35c2c$var$CALL_HISTORY_METHOD,
            payload: {
                method: method,
                args: args
            }
        };
    };
}
/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they get to
 * your reducer and reissue them as the matching function on your history.
 */ var $3ddd3cb1d8e35c2c$var$push = $3ddd3cb1d8e35c2c$exports.push = $3ddd3cb1d8e35c2c$var$updateLocation('push');
var $3ddd3cb1d8e35c2c$var$replace = $3ddd3cb1d8e35c2c$exports.replace = $3ddd3cb1d8e35c2c$var$updateLocation('replace');
var $3ddd3cb1d8e35c2c$var$go = $3ddd3cb1d8e35c2c$exports.go = $3ddd3cb1d8e35c2c$var$updateLocation('go');
var $3ddd3cb1d8e35c2c$var$goBack = $3ddd3cb1d8e35c2c$exports.goBack = $3ddd3cb1d8e35c2c$var$updateLocation('goBack');
var $3ddd3cb1d8e35c2c$var$goForward = $3ddd3cb1d8e35c2c$exports.goForward = $3ddd3cb1d8e35c2c$var$updateLocation('goForward');
var $3ddd3cb1d8e35c2c$var$routerActions = $3ddd3cb1d8e35c2c$exports.routerActions = {
    push: $3ddd3cb1d8e35c2c$var$push,
    replace: $3ddd3cb1d8e35c2c$var$replace,
    go: $3ddd3cb1d8e35c2c$var$go,
    goBack: $3ddd3cb1d8e35c2c$var$goBack,
    goForward: $3ddd3cb1d8e35c2c$var$goForward
};


Object.defineProperty($14b9f70b6017fdee$exports, 'CALL_HISTORY_METHOD', {
    enumerable: true,
    get: function get() {
        return $3ddd3cb1d8e35c2c$exports.CALL_HISTORY_METHOD;
    }
});
Object.defineProperty($14b9f70b6017fdee$exports, 'push', {
    enumerable: true,
    get: function get() {
        return $3ddd3cb1d8e35c2c$exports.push;
    }
});
Object.defineProperty($14b9f70b6017fdee$exports, 'replace', {
    enumerable: true,
    get: function get() {
        return $3ddd3cb1d8e35c2c$exports.replace;
    }
});
Object.defineProperty($14b9f70b6017fdee$exports, 'go', {
    enumerable: true,
    get: function get() {
        return $3ddd3cb1d8e35c2c$exports.go;
    }
});
Object.defineProperty($14b9f70b6017fdee$exports, 'goBack', {
    enumerable: true,
    get: function get() {
        return $3ddd3cb1d8e35c2c$exports.goBack;
    }
});
Object.defineProperty($14b9f70b6017fdee$exports, 'goForward', {
    enumerable: true,
    get: function get() {
        return $3ddd3cb1d8e35c2c$exports.goForward;
    }
});
Object.defineProperty($14b9f70b6017fdee$exports, 'routerActions', {
    enumerable: true,
    get: function get() {
        return $3ddd3cb1d8e35c2c$exports.routerActions;
    }
});
var $ffa6a1f059cb314a$exports = {};
'use strict';
Object.defineProperty($ffa6a1f059cb314a$exports, "__esModule", {
    value: true
});
var $ffa6a1f059cb314a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
$ffa6a1f059cb314a$exports['default'] = $ffa6a1f059cb314a$var$syncHistoryWithStore;

var $ffa6a1f059cb314a$var$defaultSelectLocationState = function defaultSelectLocationState(state) {
    return state.routing;
};
/**
 * This function synchronizes your history state with the Redux store.
 * Location changes flow from history to the store. An enhanced history is
 * returned with a listen method that responds to store updates for location.
 *
 * When this history is provided to the router, this means the location data
 * will flow like this:
 * history.push -> store.dispatch -> enhancedHistory.listen -> router
 * This ensures that when the store state changes due to a replay or other
 * event, the router will be updated appropriately and can transition to the
 * correct router state.
 */ function $ffa6a1f059cb314a$var$syncHistoryWithStore(history, store) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, _ref$selectLocationSt = _ref.selectLocationState, selectLocationState = _ref$selectLocationSt === undefined ? $ffa6a1f059cb314a$var$defaultSelectLocationState : _ref$selectLocationSt, _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay, adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;
    // Ensure that the reducer is mounted on the store and functioning properly.
    if (typeof selectLocationState(store.getState()) === 'undefined') throw new Error("Expected the routing state to be available either as `state.routing` or as the custom expression you can specify as `selectLocationState` in the `syncHistoryWithStore()` options. Ensure you have added the `routerReducer` to your store's reducers via `combineReducers` or whatever method you use to isolate your reducers.");
    var initialLocation = void 0;
    var isTimeTraveling = void 0;
    var unsubscribeFromStore = void 0;
    var unsubscribeFromHistory = void 0;
    var currentLocation = void 0;
    // What does the store say about current location?
    var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
        var locationState = selectLocationState(store.getState());
        return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
    };
    // Init initialLocation with potential location in store
    initialLocation = getLocationInStore();
    // If the store is replayed, update the URL in the browser to match.
    if (adjustUrlOnReplay) {
        var handleStoreChange = function handleStoreChange() {
            var locationInStore = getLocationInStore(true);
            if (currentLocation === locationInStore || initialLocation === locationInStore) return;
            // Update address bar to reflect store state
            isTimeTraveling = true;
            currentLocation = locationInStore;
            history.transitionTo($ffa6a1f059cb314a$var$_extends({}, locationInStore, {
                action: 'PUSH'
            }));
            isTimeTraveling = false;
        };
        unsubscribeFromStore = store.subscribe(handleStoreChange);
        handleStoreChange();
    }
    // Whenever location changes, dispatch an action to get it in the store
    var handleLocationChange = function handleLocationChange(location) {
        // ... unless we just caused that location change
        if (isTimeTraveling) return;
        // Remember where we are
        currentLocation = location;
        // Are we being called for the first time?
        if (!initialLocation) {
            // Remember as a fallback in case state is reset
            initialLocation = location;
            // Respect persisted location, if any
            if (getLocationInStore()) return;
        }
        // Tell the store to update by dispatching an action
        store.dispatch({
            type: $0d6271c237556cbf$exports.LOCATION_CHANGE,
            payload: location
        });
    };
    unsubscribeFromHistory = history.listen(handleLocationChange);
    // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
    if (history.getCurrentLocation) handleLocationChange(history.getCurrentLocation());
    // The enhanced history uses store as source of truth
    return $ffa6a1f059cb314a$var$_extends({}, history, {
        // The listeners are subscribed to the store instead of history
        listen: function listen(listener) {
            // Copy of last location.
            var lastPublishedLocation = getLocationInStore(true);
            // Keep track of whether we unsubscribed, as Redux store
            // only applies changes in subscriptions on next dispatch
            var unsubscribed = false;
            var unsubscribeFromStore = store.subscribe(function() {
                var currentLocation = getLocationInStore(true);
                if (currentLocation === lastPublishedLocation) return;
                lastPublishedLocation = currentLocation;
                if (!unsubscribed) listener(lastPublishedLocation);
            });
            // History 2.x listeners expect a synchronous call. Make the first call to the
            // listener after subscribing to the store, in case the listener causes a
            // location change (e.g. when it redirects)
            if (!history.getCurrentLocation) listener(lastPublishedLocation);
            // Let user unsubscribe later
            return function() {
                unsubscribed = true;
                unsubscribeFromStore();
            };
        },
        // It also provides a way to destroy internal listeners
        unsubscribe: function unsubscribe() {
            if (adjustUrlOnReplay) unsubscribeFromStore();
            unsubscribeFromHistory();
        }
    });
}


var $14b9f70b6017fdee$var$_sync2 = $14b9f70b6017fdee$var$_interopRequireDefault($ffa6a1f059cb314a$exports);
var $d8428b7528aabd2c$exports = {};
'use strict';
Object.defineProperty($d8428b7528aabd2c$exports, "__esModule", {
    value: true
});
$d8428b7528aabd2c$exports['default'] = $d8428b7528aabd2c$var$routerMiddleware;

function $d8428b7528aabd2c$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */ function $d8428b7528aabd2c$var$routerMiddleware(history) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type !== $3ddd3cb1d8e35c2c$exports.CALL_HISTORY_METHOD) return next(action);
                var _action$payload = action.payload, method = _action$payload.method, args = _action$payload.args;
                history[method].apply(history, $d8428b7528aabd2c$var$_toConsumableArray(args));
            };
        };
    };
}


var $14b9f70b6017fdee$var$_middleware2 = $14b9f70b6017fdee$var$_interopRequireDefault($d8428b7528aabd2c$exports);
function $14b9f70b6017fdee$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
$14b9f70b6017fdee$exports.syncHistoryWithStore = $14b9f70b6017fdee$var$_sync2['default'];
$14b9f70b6017fdee$exports.routerMiddleware = $14b9f70b6017fdee$var$_middleware2['default'];


/** Detect free variable `global` from Node.js. */ var $66e232f15da3e3ac$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $66e232f15da3e3ac$export$2e2bcd8739ae039 = $66e232f15da3e3ac$var$freeGlobal;


/** Detect free variable `self`. */ var $13d036665b2dd8ae$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $13d036665b2dd8ae$var$root = (0, $66e232f15da3e3ac$export$2e2bcd8739ae039) || $13d036665b2dd8ae$var$freeSelf || Function('return this')();
var $13d036665b2dd8ae$export$2e2bcd8739ae039 = $13d036665b2dd8ae$var$root;


/** Built-in value references. */ var $17330ffdc4abc423$var$Symbol = (0, $13d036665b2dd8ae$export$2e2bcd8739ae039).Symbol;
var $17330ffdc4abc423$export$2e2bcd8739ae039 = $17330ffdc4abc423$var$Symbol;



/** Used for built-in method references. */ var $b56ac86c4214e6a9$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b56ac86c4214e6a9$var$hasOwnProperty = $b56ac86c4214e6a9$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $b56ac86c4214e6a9$var$nativeObjectToString = $b56ac86c4214e6a9$var$objectProto.toString;
/** Built-in value references. */ var $b56ac86c4214e6a9$var$symToStringTag = (0, $17330ffdc4abc423$export$2e2bcd8739ae039) ? (0, $17330ffdc4abc423$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $b56ac86c4214e6a9$var$getRawTag(value) {
    var isOwn = $b56ac86c4214e6a9$var$hasOwnProperty.call(value, $b56ac86c4214e6a9$var$symToStringTag), tag = value[$b56ac86c4214e6a9$var$symToStringTag];
    try {
        value[$b56ac86c4214e6a9$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $b56ac86c4214e6a9$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$b56ac86c4214e6a9$var$symToStringTag] = tag;
        else delete value[$b56ac86c4214e6a9$var$symToStringTag];
    }
    return result;
}
var $b56ac86c4214e6a9$export$2e2bcd8739ae039 = $b56ac86c4214e6a9$var$getRawTag;


/** Used for built-in method references. */ var $4744c2529700541f$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $4744c2529700541f$var$nativeObjectToString = $4744c2529700541f$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $4744c2529700541f$var$objectToString(value) {
    return $4744c2529700541f$var$nativeObjectToString.call(value);
}
var $4744c2529700541f$export$2e2bcd8739ae039 = $4744c2529700541f$var$objectToString;


/** `Object#toString` result references. */ var $fa0d378a5fc8f0ab$var$nullTag = '[object Null]', $fa0d378a5fc8f0ab$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $fa0d378a5fc8f0ab$var$symToStringTag = (0, $17330ffdc4abc423$export$2e2bcd8739ae039) ? (0, $17330ffdc4abc423$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $fa0d378a5fc8f0ab$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $fa0d378a5fc8f0ab$var$undefinedTag : $fa0d378a5fc8f0ab$var$nullTag;
    return $fa0d378a5fc8f0ab$var$symToStringTag && $fa0d378a5fc8f0ab$var$symToStringTag in Object(value) ? (0, $b56ac86c4214e6a9$export$2e2bcd8739ae039)(value) : (0, $4744c2529700541f$export$2e2bcd8739ae039)(value);
}
var $fa0d378a5fc8f0ab$export$2e2bcd8739ae039 = $fa0d378a5fc8f0ab$var$baseGetTag;


/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $c9da63a3d26fb1a7$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $c9da63a3d26fb1a7$export$2e2bcd8739ae039 = $c9da63a3d26fb1a7$var$overArg;


/** Built-in value references. */ var $89313ecbcde4812f$var$getPrototype = (0, $c9da63a3d26fb1a7$export$2e2bcd8739ae039)(Object.getPrototypeOf, Object);
var $89313ecbcde4812f$export$2e2bcd8739ae039 = $89313ecbcde4812f$var$getPrototype;


/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $8ea7a33f7b276b9e$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $8ea7a33f7b276b9e$export$2e2bcd8739ae039 = $8ea7a33f7b276b9e$var$isObjectLike;


/** `Object#toString` result references. */ var $d38b6c6409a1f365$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $d38b6c6409a1f365$var$funcProto = Function.prototype, $d38b6c6409a1f365$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $d38b6c6409a1f365$var$funcToString = $d38b6c6409a1f365$var$funcProto.toString;
/** Used to check objects for own properties. */ var $d38b6c6409a1f365$var$hasOwnProperty = $d38b6c6409a1f365$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $d38b6c6409a1f365$var$objectCtorString = $d38b6c6409a1f365$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $d38b6c6409a1f365$var$isPlainObject(value) {
    if (!(0, $8ea7a33f7b276b9e$export$2e2bcd8739ae039)(value) || (0, $fa0d378a5fc8f0ab$export$2e2bcd8739ae039)(value) != $d38b6c6409a1f365$var$objectTag) return false;
    var proto = (0, $89313ecbcde4812f$export$2e2bcd8739ae039)(value);
    if (proto === null) return true;
    var Ctor = $d38b6c6409a1f365$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $d38b6c6409a1f365$var$funcToString.call(Ctor) == $d38b6c6409a1f365$var$objectCtorString;
}
var $d38b6c6409a1f365$export$2e2bcd8739ae039 = $d38b6c6409a1f365$var$isPlainObject;



var $8gcse = parcelRequire("8gcse");
var $d28a9a1a347ffc66$export$1385d81a6c6bbcd4 = {
    INIT: '@@redux/INIT'
};
function $d28a9a1a347ffc66$export$2e2bcd8739ae039(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error('Expected the enhancer to be a function.');
        return enhancer($d28a9a1a347ffc66$export$2e2bcd8739ae039)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error('Expected the reducer to be a function.');
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error('Expected listener to be a function.');
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!(0, $d38b6c6409a1f365$export$2e2bcd8739ae039)(action)) throw new Error("Actions must be plain objects. Use custom middleware for async actions.");
        if (typeof action.type === 'undefined') throw new Error('Actions may not have an undefined "type" property. Have you misspelled a constant?');
        if (isDispatching) throw new Error('Reducers may not dispatch actions.');
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error('Expected the nextReducer to be a function.');
        currentReducer = nextReducer;
        dispatch({
            type: $d28a9a1a347ffc66$export$1385d81a6c6bbcd4.INIT
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object') throw new TypeError('Expected the observer to be an object.');
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[0, $8gcse.default] = function() {
            return this;
        }, _ref;
    }
    // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $d28a9a1a347ffc66$export$1385d81a6c6bbcd4.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[0, $8gcse.default] = observable, _ref2;
}




/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $f941772f99fdcd61$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


function $902b45bf0a1197fd$var$getUndefinedStateErrorMessage(key, action) {
    var actionType = action && action.type;
    var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
    return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}
function $902b45bf0a1197fd$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === (0, $d28a9a1a347ffc66$export$1385d81a6c6bbcd4).INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!(0, $d38b6c6409a1f365$export$2e2bcd8739ae039)(inputState)) return 'The ' + argumentName + ' has unexpected type of "' + ({}).toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (unexpectedKeys.length > 0) return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $902b45bf0a1197fd$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: (0, $d28a9a1a347ffc66$export$1385d81a6c6bbcd4).INIT
        });
        if (typeof initialState === 'undefined') throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
        var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
        if (typeof reducer(undefined, {
            type: type
        }) === 'undefined') throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + (0, $d28a9a1a347ffc66$export$1385d81a6c6bbcd4).INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    });
}
function $902b45bf0a1197fd$export$2e2bcd8739ae039(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers);
    var unexpectedKeyCache = void 0;
    var shapeAssertionError = void 0;
    try {
        $902b45bf0a1197fd$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var action = arguments[1];
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var errorMessage = $902b45bf0a1197fd$var$getUndefinedStateErrorMessage(_key, action);
                throw new Error(errorMessage);
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        return hasChanged ? nextState : state;
    };
}


function $1f80bbeadc1a0021$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(undefined, arguments));
    };
}
function $1f80bbeadc1a0021$export$2e2bcd8739ae039(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $1f80bbeadc1a0021$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
    var keys = Object.keys(actionCreators);
    var boundActionCreators = {};
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $1f80bbeadc1a0021$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}


/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $4394fcf460bfdf47$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(undefined, arguments));
        };
    });
}


var $786d69f2d9e5855c$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $786d69f2d9e5855c$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function(reducer, preloadedState, enhancer) {
            var store = createStore(reducer, preloadedState, enhancer);
            var _dispatch = store.dispatch;
            var chain = [];
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch(action) {
                    return _dispatch(action);
                }
            };
            chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = (0, $4394fcf460bfdf47$export$2e2bcd8739ae039).apply(undefined, chain)(store.dispatch);
            return $786d69f2d9e5855c$var$_extends({}, store, {
                dispatch: _dispatch
            });
        };
    };
}




/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/ function $7fe539b8ce4c6d44$var$isCrushed() {}




var $acad2f8102dd4763$exports = {};
'use strict';
function $acad2f8102dd4763$var$thunkMiddleware(_ref) {
    var dispatch = _ref.dispatch;
    var getState = _ref.getState;
    return function(next) {
        return function(action) {
            return typeof action === 'function' ? action(dispatch, getState) : next(action);
        };
    };
}
$acad2f8102dd4763$exports = $acad2f8102dd4763$var$thunkMiddleware;



var $hBdgJ = parcelRequire("hBdgJ");

var $hBdgJ = parcelRequire("hBdgJ");
function $d96f38380b9b4c62$export$2b3d06107d1323d4(e) {
    return e?.name === 'CancellationError';
}
class $d96f38380b9b4c62$export$63884d8ee23c8f42 extends Error {
    constructor(...args){
        super(...args);
        this.name = 'CancellationError';
    }
}


let $a537743573e5e486$var$links;
const $a537743573e5e486$export$910b1132ce0498d8 = ({ updatedLinks: updatedLinks })=>{
    $a537743573e5e486$var$links = updatedLinks;
};
// do not prefix route with basepath, ex. for external links
const $a537743573e5e486$var$addBasepath = (url, excludeBasepath)=>{
    const basepath = window.basepath || '';
    return excludeBasepath ? url : `${basepath}${url}`;
};
function $a537743573e5e486$var$generateResponseWithLinks(response, newLinks) {
    const { auth: auth, logout: logout, external: external, users: users, allUsers: allUsers, organizations: organizations, me: meLink, config: config, environment: environment, flux: flux } = newLinks;
    const linksObj = {
        auth: {
            links: auth
        },
        logoutLink: logout,
        external: external,
        users: users,
        allUsers: allUsers,
        organizations: organizations,
        meLink: meLink,
        config: config,
        environment: environment,
        flux: flux
    };
    return Object.assign({}, response, linksObj);
}
async function $a537743573e5e486$var$AJAX({ url: url, resource: resource = null, id: id = null, method: method = 'GET', data: requestData, params: params, headers: requestHeaders, signal: signal }, excludeBasepath = false) {
    url = $a537743573e5e486$var$addBasepath(url, excludeBasepath);
    let body;
    if (resource && $a537743573e5e486$var$links) url = id ? $a537743573e5e486$var$addBasepath(`${$a537743573e5e486$var$links[resource]}/${id}`, excludeBasepath) : $a537743573e5e486$var$addBasepath(`${$a537743573e5e486$var$links[resource]}`, excludeBasepath);
    if (params) {
        const queryString = new URLSearchParams(params);
        if (queryString) url += `?` + queryString;
    }
    if (requestData) body = typeof requestData === 'string' ? requestData : JSON.stringify(requestData);
    const isFluxProxyGet = method === 'GET' && typeof url === 'string' && url.includes('/proxy/flux');
    const requestHeadersWithRequestedWith = method === 'GET' && !isFluxProxyGet ? requestHeaders : {
        ...requestHeaders,
        'X-Requested-With': 'XMLHttpRequest'
    };
    const fetchResponse = await fetch(url, {
        method: method,
        body: body,
        headers: requestHeadersWithRequestedWith,
        signal: signal
    }).catch((e)=>e.name === 'AbortError' ? Promise.reject(new (0, $d96f38380b9b4c62$export$63884d8ee23c8f42)()) : Promise.reject(e));
    let data;
    if (fetchResponse.status === 204) data = '';
    else {
        const isText = (fetchResponse.headers.get('content-type') || 'text/').includes('text/');
        data = isText ? await fetchResponse.text() : await fetchResponse.json();
    }
    const headers = {};
    fetchResponse.headers.forEach((v, k)=>headers[k] = v);
    const response = {
        status: fetchResponse.status,
        statusText: fetchResponse.statusText,
        data: data,
        headers: headers
    };
    const retVal = $a537743573e5e486$var$links ? $a537743573e5e486$var$generateResponseWithLinks(response, $a537743573e5e486$var$links) : response;
    if (!fetchResponse.ok) throw retVal // eslint-disable-line @typescript-eslint/only-throw-error
    ;
    return retVal;
}
async function $a537743573e5e486$export$77a72e302cf027c9(url) {
    try {
        const response = await fetch($a537743573e5e486$var$addBasepath(url, false), {
            method: 'GET'
        });
        if (response.ok) {
            const isText = (response.headers.get('content-type') || '').includes('text/');
            const responseData = isText || response.status === 204 ? await response.text() : await response.json();
            return {
                data: responseData
            };
        }
        const data = await response.text();
        console.error('failed to GET url:', url, 'status:', response.statusText, 'response:', data);
        let errorMessage = response.statusText || `error ${response.status}`;
        // try to parse error message from JSON payload
        if (response.headers.get('content-type').includes('application/json')) try {
            const { message: message } = JSON.parse(data);
            if (message) errorMessage = message;
        } catch (e) {
        // ignore silently, unrecognized error message
        }
        return Promise.reject(new Error(errorMessage));
    } catch (e) {
        console.error('failed to GET url:', url, 'error:', e);
        return Promise.reject(e);
    }
}
var $a537743573e5e486$export$2e2bcd8739ae039 = $a537743573e5e486$var$AJAX;


function $ce33d45777fa0434$export$dd7946daa6163e94() {
    return (0, $a537743573e5e486$export$2e2bcd8739ae039)({
        resource: 'me',
        method: 'GET'
    });
}
const $ce33d45777fa0434$export$8ddaddf355aae59c = async (url, updatedMe)=>{
    try {
        return await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'PUT',
            url: url,
            data: updatedMe
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
};




var $hBdgJ = parcelRequire("hBdgJ");
var $a7b864c61f4e95a7$export$d6f132cca63fb222 = /*#__PURE__*/ function(TimeZones) {
    TimeZones["Local"] = "local";
    TimeZones["UTC"] = "utc";
    return TimeZones;
}({});


var $61056af5b9250c91$export$2a27dae48bac82b3 = /*#__PURE__*/ function(ValidationState) {
    ValidationState["NotStarted"] = "Not Started";
    ValidationState["Success"] = "Success";
    ValidationState["Error"] = "Error";
    ValidationState["Validating"] = "Validating";
    return ValidationState;
}({});
var $61056af5b9250c91$export$89d04bf4bca317e9 = /*#__PURE__*/ function(TypingStatus) {
    TypingStatus["NotStarted"] = "Not Started";
    TypingStatus["Started"] = "Started";
    TypingStatus["Done"] = "Done";
    return TypingStatus;
}({});
var $61056af5b9250c91$export$be0001227188532f = /*#__PURE__*/ function(AlertRuleType) {
    AlertRuleType["Threshold"] = "threshold";
    AlertRuleType["Relative"] = "relative";
    AlertRuleType["Deadman"] = "deadman";
    return AlertRuleType;
}({});


var $b4506126e09430df$export$7c8e26efb80b90e8 = /*#__PURE__*/ function(QueryType) {
    QueryType["Flux"] = "flux";
    QueryType["InfluxQL"] = "influxql";
    return QueryType;
}({});
var $b4506126e09430df$export$2c5a562a272706f8 = /*#__PURE__*/ function(NoteVisibility) {
    NoteVisibility["Default"] = "default";
    NoteVisibility["ShowWhenNoData"] = "showWhenNoData";
    return NoteVisibility;
}({});
var $b4506126e09430df$export$705e36171f4cbbfe = /*#__PURE__*/ function(CellType) {
    CellType["Line"] = "line";
    CellType["Stacked"] = "line-stacked";
    CellType["StepPlot"] = "line-stepplot";
    CellType["Bar"] = "bar";
    CellType["LinePlusSingleStat"] = "line-plus-single-stat";
    CellType["SingleStat"] = "single-stat";
    CellType["Gauge"] = "gauge";
    CellType["Table"] = "table";
    CellType["Alerts"] = "alerts";
    CellType["News"] = "news";
    CellType["Guide"] = "guide";
    CellType["Note"] = "note";
    return CellType;
}({});
var $b4506126e09430df$export$fce0e0c1f55bb653 = /*#__PURE__*/ function(ThresholdType) {
    ThresholdType["Text"] = "text";
    ThresholdType["BG"] = "background";
    ThresholdType["Base"] = "base";
    return ThresholdType;
}({});


var $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b = /*#__PURE__*/ function(TemplateValueType) {
    TemplateValueType["Database"] = "database";
    TemplateValueType["TagKey"] = "tagKey";
    TemplateValueType["FieldKey"] = "fieldKey";
    TemplateValueType["Measurement"] = "measurement";
    TemplateValueType["TagValue"] = "tagValue";
    TemplateValueType["CSV"] = "csv";
    TemplateValueType["Map"] = "map";
    TemplateValueType["Points"] = "points";
    TemplateValueType["Constant"] = "constant";
    TemplateValueType["MetaQuery"] = "influxql";
    TemplateValueType["FluxQuery"] = "flux";
    TemplateValueType["TimeStamp"] = "timeStamp";
    return TemplateValueType;
}({});
var $ae4c87db4f4621dc$export$fd0446c06165ed92 = /*#__PURE__*/ function(TemplateType) {
    TemplateType["AutoGroupBy"] = "autoGroupBy";
    TemplateType["Constant"] = "constant";
    TemplateType["FieldKeys"] = "fieldKeys";
    TemplateType["Measurements"] = "measurements";
    TemplateType["TagKeys"] = "tagKeys";
    TemplateType["TagValues"] = "tagValues";
    TemplateType["CSV"] = "csv";
    TemplateType["Map"] = "map";
    TemplateType["Databases"] = "databases";
    TemplateType["MetaQuery"] = "influxql";
    TemplateType["FluxQuery"] = "flux";
    TemplateType["Text"] = "text";
    TemplateType["TimeStamp"] = "timeStamp";
    return TemplateType;
}({});


var $507599f0e7251de2$export$7d18f7c49c9d7266 = /*#__PURE__*/ function(SourceAuthenticationMethod) {
    SourceAuthenticationMethod["LDAP"] = "ldap";
    SourceAuthenticationMethod["Basic"] = "basic";
    SourceAuthenticationMethod["Shared"] = "shared";
    SourceAuthenticationMethod["Unknown"] = "unknown";
    return SourceAuthenticationMethod;
}({});


var $bf3dd750ec7dcb0a$export$84f725a50b2d16f7 = /*#__PURE__*/ function(RemoteDataState) {
    RemoteDataState["NotStarted"] = "NotStarted";
    RemoteDataState["Loading"] = "Loading";
    RemoteDataState["Done"] = "Done";
    RemoteDataState["Error"] = "Error";
    return RemoteDataState;
}({});
var $bf3dd750ec7dcb0a$export$9f8d0c19ebdb3c7c = /*#__PURE__*/ function(VisType) {
    VisType[VisType["Graph"] = 0] = "Graph";
    VisType[VisType["Table"] = 1] = "Table";
    return VisType;
}({});


var $997a2bc484aadf39$export$209f3caa268488b1 = /*#__PURE__*/ function(WriteDataMode) {
    WriteDataMode["Manual"] = "Manual Entry";
    WriteDataMode["File"] = "File Upload";
    return WriteDataMode;
}({});
var $997a2bc484aadf39$export$f57f948de0498b05 = /*#__PURE__*/ function(QueryUpdateState) {
    QueryUpdateState["CEO"] = "cellEditorOverlay";
    QueryUpdateState["DE"] = "dataExplorer";
    return QueryUpdateState;
}({});





const $e10a8602f56394e3$export$a4ad2735b021c132 = "1.11.7";
const $e10a8602f56394e3$export$de001b401bf3761b = "50662a3e5992b467afcdce362e75afe3620b8a84";
const $e10a8602f56394e3$export$683c77e30cbb1076 = 1000;
const $e10a8602f56394e3$export$707a26a7e04f767e = 700;
const $e10a8602f56394e3$export$f5f6f852ccf1dc7f = 10;
const $e10a8602f56394e3$export$d9e8b2a424c8c4e8 = 'none';
const $e10a8602f56394e3$export$d6eefc103e184eaa = {
    ViewAdmin: {
        description: 'Can view or edit admin screens',
        displayName: 'View Admin'
    },
    ViewChronograf: {
        description: 'Can use Chronograf tools',
        displayName: 'View Chronograf'
    },
    CreateDatabase: {
        description: 'Can create databases',
        displayName: 'Create Databases'
    },
    CreateUserAndRole: {
        description: 'Can create users and roles',
        displayName: 'Create Users & Roles'
    },
    AddRemoveNode: {
        description: 'Can add/remove nodes from a cluster',
        displayName: 'Add/Remove Nodes'
    },
    DropDatabase: {
        description: 'Can drop databases',
        displayName: 'Drop Databases'
    },
    DropData: {
        displayName: 'Drop Data',
        description: 'Can drop measurements and series'
    },
    ReadData: {
        displayName: 'Read',
        description: 'Can read data'
    },
    WriteData: {
        displayName: 'Write',
        description: 'Can write data'
    },
    Rebalance: {
        displayName: 'Rebalance',
        description: 'Can rebalance a cluster'
    },
    ManageShard: {
        displayName: 'Manage Shards',
        description: 'Can copy and delete shards'
    },
    ManageContinuousQuery: {
        displayName: 'Manage Continuous Queries',
        description: 'Can create, show, and drop continuous queries'
    },
    ManageQuery: {
        displayName: 'Manage Queries',
        description: 'Can show and kill queries'
    },
    ManageSubscription: {
        displayName: 'Manage Subscriptions',
        description: 'Can show, add, and drop subscriptions'
    },
    Monitor: {
        displayName: 'Monitor',
        description: 'Can show stats and diagnostics'
    },
    CopyShard: {
        displayName: 'Copy Shard',
        description: 'Can copy shards'
    },
    NoPermissions: {
        displayName: 'Show Databases',
        description: 'Can show databases'
    },
    KapacitorAPI: {
        displayName: 'Kapacitor API',
        description: 'Can create, read, update and delete tasks, topics, handlers and similar Kapacitor artifacts'
    },
    KapacitorConfigAPI: {
        displayName: 'Kapacitor Config API',
        description: 'Can override Kapacitor configuration dynamically'
    }
};
const $e10a8602f56394e3$export$b940073a64112462 = [
    // 1 Color Palettes
    [
        [
            '#00C9FF'
        ],
        [
            '#00C9FF'
        ],
        [
            '#00C9FF'
        ]
    ],
    // 2 Color Palettes
    [
        [
            '#00C9FF',
            '#00C9FF'
        ],
        [
            '#00C9FF',
            '#00C9FF'
        ],
        [
            '#00C9FF',
            '#00C9FF'
        ]
    ],
    // 3 Color Palettes
    [
        [
            '#00C9FF',
            '#9394FF',
            '#4ED8A0'
        ],
        [
            '#00C9FF',
            '#9394FF',
            '#4ED8A0'
        ],
        [
            '#00C9FF',
            '#9394FF',
            '#4ED8A0'
        ]
    ],
    // 4 Color Palettes
    [
        [
            '#00C9FF',
            '#9394FF',
            '#4ED8A0',
            '#ff0054'
        ],
        [
            '#00C9FF',
            '#9394FF',
            '#4ED8A0',
            '#ff0054'
        ],
        [
            '#00C9FF',
            '#9394FF',
            '#4ED8A0',
            '#ff0054'
        ]
    ],
    // 5 Color Palettes
    [
        [
            '#00C9FF',
            '#9394FF',
            '#4ED8A0',
            '#ff0054',
            '#ffcc00'
        ],
        [
            '#00C9FF',
            '#9394FF',
            '#4ED8A0',
            '#ff0054',
            '#ffcc00'
        ],
        [
            '#00C9FF',
            '#9394FF',
            '#4ED8A0',
            '#ff0054',
            '#ffcc00'
        ]
    ],
    // 6 Color Palettes
    [
        [
            '#00C9FF',
            '#9394FF',
            '#4ED8A0',
            '#ff0054',
            '#ffcc00',
            '#33aa99'
        ],
        [
            '#00C9FF',
            '#9394FF',
            '#4ED8A0',
            '#ff0054',
            '#ffcc00',
            '#33aa99'
        ],
        [
            '#00C9FF',
            '#9394FF',
            '#4ED8A0',
            '#ff0054',
            '#ffcc00',
            '#33aa99'
        ]
    ],
    // 7 Color Palettes
    [
        [
            '#00C9FF',
            '#9394FF',
            '#4ED8A0',
            '#ff0054',
            '#ffcc00',
            '#33aa99',
            '#9dfc5d'
        ],
        [
            '#00C9FF',
            '#9394FF',
            '#4ED8A0',
            '#ff0054',
            '#ffcc00',
            '#33aa99',
            '#9dfc5d'
        ],
        [
            '#00C9FF',
            '#9394FF',
            '#4ED8A0',
            '#ff0054',
            '#ffcc00',
            '#33aa99',
            '#9dfc5d'
        ]
    ],
    // 8 Color Palettes
    [
        [
            '#00C9FF',
            '#9394FF',
            '#4ED8A0',
            '#ff0054',
            '#ffcc00',
            '#33aa99',
            '#9dfc5d',
            '#92bcc3'
        ],
        [
            '#00C9FF',
            '#9394FF',
            '#4ED8A0',
            '#ff0054',
            '#ffcc00',
            '#33aa99',
            '#9dfc5d',
            '#92bcc3'
        ],
        [
            '#00C9FF',
            '#9394FF',
            '#4ED8A0',
            '#ff0054',
            '#ffcc00',
            '#33aa99',
            '#9dfc5d',
            '#92bcc3'
        ]
    ],
    // 9 Color Palettes
    [
        [
            '#00C9FF',
            '#9394FF',
            '#4ED8A0',
            '#ff0054',
            '#ffcc00',
            '#33aa99',
            '#9dfc5d',
            '#92bcc3',
            '#ca96fb'
        ],
        [
            '#00C9FF',
            '#9394FF',
            '#4ED8A0',
            '#ff0054',
            '#ffcc00',
            '#33aa99',
            '#9dfc5d',
            '#92bcc3',
            '#ca96fb'
        ],
        [
            '#00C9FF',
            '#9394FF',
            '#4ED8A0',
            '#ff0054',
            '#ffcc00',
            '#33aa99',
            '#9dfc5d',
            '#92bcc3',
            '#ca96fb'
        ]
    ],
    // 10 Color Palettes
    [
        [
            '#00C9FF',
            '#9394FF',
            '#4ED8A0',
            '#ff0054',
            '#ffcc00',
            '#33aa99',
            '#9dfc5d',
            '#92bcc3',
            '#ca96fb',
            '#ff00f0'
        ],
        [
            '#00C9FF',
            '#9394FF',
            '#4ED8A0',
            '#ff0054',
            '#ffcc00',
            '#33aa99',
            '#9dfc5d',
            '#92bcc3',
            '#ca96fb',
            '#ff00f0'
        ],
        [
            '#00C9FF',
            '#9394FF',
            '#4ED8A0',
            '#ff0054',
            '#ffcc00',
            '#33aa99',
            '#9dfc5d',
            '#92bcc3',
            '#ca96fb',
            '#ff00f0'
        ]
    ],
    // 11 Color Palettes
    [
        [
            '#00C9FF',
            '#9394FF',
            '#4ED8A0',
            '#ff0054',
            '#ffcc00',
            '#33aa99',
            '#9dfc5d',
            '#92bcc3',
            '#ca96fb',
            '#ff00f0',
            '#38b94a'
        ],
        [
            '#00C9FF',
            '#9394FF',
            '#4ED8A0',
            '#ff0054',
            '#ffcc00',
            '#33aa99',
            '#9dfc5d',
            '#92bcc3',
            '#ca96fb',
            '#ff00f0',
            '#38b94a'
        ],
        [
            '#00C9FF',
            '#9394FF',
            '#4ED8A0',
            '#ff0054',
            '#ffcc00',
            '#33aa99',
            '#9dfc5d',
            '#92bcc3',
            '#ca96fb',
            '#ff00f0',
            '#38b94a'
        ]
    ],
    // 12 Color Palettes
    [
        [
            '#00C9FF',
            '#9394FF',
            '#4ED8A0',
            '#ff0054',
            '#ffcc00',
            '#33aa99',
            '#9dfc5d',
            '#92bcc3',
            '#ca96fb',
            '#ff00f0',
            '#38b94a',
            '#3844b9'
        ],
        [
            '#00C9FF',
            '#9394FF',
            '#4ED8A0',
            '#ff0054',
            '#ffcc00',
            '#33aa99',
            '#9dfc5d',
            '#92bcc3',
            '#ca96fb',
            '#ff00f0',
            '#38b94a',
            '#3844b9'
        ],
        [
            '#00C9FF',
            '#9394FF',
            '#4ED8A0',
            '#ff0054',
            '#ffcc00',
            '#33aa99',
            '#9dfc5d',
            '#92bcc3',
            '#ca96fb',
            '#ff00f0',
            '#38b94a',
            '#3844b9'
        ]
    ],
    // 13 Color Palettes
    [
        [
            '#00C9FF',
            '#9394FF',
            '#4ED8A0',
            '#ff0054',
            '#ffcc00',
            '#33aa99',
            '#9dfc5d',
            '#92bcc3',
            '#ca96fb',
            '#ff00f0',
            '#38b94a',
            '#3844b9',
            '#a0725b'
        ],
        [
            '#00C9FF',
            '#9394FF',
            '#4ED8A0',
            '#ff0054',
            '#ffcc00',
            '#33aa99',
            '#9dfc5d',
            '#92bcc3',
            '#ca96fb',
            '#ff00f0',
            '#38b94a',
            '#3844b9',
            '#a0725b'
        ],
        [
            '#00C9FF',
            '#9394FF',
            '#4ED8A0',
            '#ff0054',
            '#ffcc00',
            '#33aa99',
            '#9dfc5d',
            '#92bcc3',
            '#ca96fb',
            '#ff00f0',
            '#38b94a',
            '#3844b9',
            '#a0725b'
        ]
    ]
];
const $e10a8602f56394e3$export$41e61fabda09f89a = {
    heavy: 3.5,
    light: 1.5
};
const $e10a8602f56394e3$export$bd1588cc2d72fbf = 240;
const $e10a8602f56394e3$export$31c453b5fe09788d = 10000 // ms
;
const $e10a8602f56394e3$export$6aba70ea7fba2ecd = 0 // In milliseconds.
;
const $e10a8602f56394e3$export$7cead1aa1be9a72f = 1500 // ms
;
const $e10a8602f56394e3$export$adbf103f5d371692 = 401;
const $e10a8602f56394e3$export$cfa9956f1887e28f = 403;
const $e10a8602f56394e3$export$6226897062245741 = 404;
const $e10a8602f56394e3$export$edae9dc8bc463031 = 0 // in milliseconds
;
const $e10a8602f56394e3$export$da42707f023260f8 = 0 // in milliseconds
;
const $e10a8602f56394e3$export$4246073241d5cb73 = false;
const $e10a8602f56394e3$export$1db4bed3f15cffc8 = false;
const $e10a8602f56394e3$export$54428e230c7f6b57 = 'graph';
const $e10a8602f56394e3$export$88a597d0c7ae97b = 'table';
const $e10a8602f56394e3$export$2268e4e3701d5be3 = [
    $e10a8602f56394e3$export$54428e230c7f6b57,
    $e10a8602f56394e3$export$88a597d0c7ae97b
];
const $e10a8602f56394e3$export$77e8fbcbea0ce430 = ':interval:';
const $e10a8602f56394e3$export$24969386fef72130 = ':dashboardTime:';
const $e10a8602f56394e3$export$cb0056005b9f8f1c = ':upperDashboardTime:';
const $e10a8602f56394e3$export$15f21f2bf867530d = [
    $e10a8602f56394e3$export$77e8fbcbea0ce430,
    $e10a8602f56394e3$export$24969386fef72130,
    $e10a8602f56394e3$export$cb0056005b9f8f1c
];
const $e10a8602f56394e3$export$f7102e4775d406a8 = '10s';
const $e10a8602f56394e3$export$4d7f0cfe7906cfdf = 'auto';
const $e10a8602f56394e3$export$d35773d450f5d6df = 'status';
const $e10a8602f56394e3$export$1c31fb3cca4a4835 = 10 // TODO: calculate based on actual Status Page cells
;
const $e10a8602f56394e3$export$aa10bd88079cd4f3 = 60 // TODO: get this dynamically to ensure longevity
;
const $e10a8602f56394e3$export$3886576361c767a1 = 30 // TODO: get this dynamically to ensure longevity
;
const $e10a8602f56394e3$export$4a0da829a08f6fad = 4;
const $e10a8602f56394e3$export$13d5843c9841853c = 83.5;
const $e10a8602f56394e3$export$11baccdc2aa05859 = 16;
const $e10a8602f56394e3$export$50de07a219eb9c8c = 8;
const $e10a8602f56394e3$export$c48e77fd29ce0e07 = 20;
const $e10a8602f56394e3$export$b055de0e665cb20c = {
    url: 'http://localhost:8086',
    name: 'Influx 1',
    username: '',
    password: '',
    default: false,
    telegraf: 'telegraf',
    insecureSkipVerify: false,
    metaUrl: 'http://localhost:8091',
    version: '1.x'
};
const $e10a8602f56394e3$export$7b9591098a50d1e2 = {
    url: 'http://localhost:9092',
    name: 'New Kapacitor',
    username: '',
    password: '',
    active: true,
    insecureSkipVerify: false
};
const $e10a8602f56394e3$export$8feff3278e94238d = [
    {
        value: `${$e10a8602f56394e3$export$707a26a7e04f767e}`,
        type: (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).Points,
        selected: true,
        localSelected: true
    }
];
const $e10a8602f56394e3$export$3174cdbf0a0cbc84 = {
    id: 'interval',
    type: (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).AutoGroupBy,
    tempVar: $e10a8602f56394e3$export$77e8fbcbea0ce430,
    label: 'automatically determine the best group by time',
    values: $e10a8602f56394e3$export$8feff3278e94238d
};
const $e10a8602f56394e3$export$b8020e85ad90bfe5 = [
    $e10a8602f56394e3$export$3174cdbf0a0cbc84
];
const $e10a8602f56394e3$export$1665041fd2ad0d88 = (legend)=>(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(legend, 'type', false) === 'static';
const $e10a8602f56394e3$export$ac392c98ac8ad998 = '/chronograf/v1';
const $e10a8602f56394e3$export$b400e3a9aa7f37dc = (cellType)=>{
    const supportedTypes = [
        (0, $b4506126e09430df$export$705e36171f4cbbfe).Line,
        (0, $b4506126e09430df$export$705e36171f4cbbfe).Bar,
        (0, $b4506126e09430df$export$705e36171f4cbbfe).Line,
        (0, $b4506126e09430df$export$705e36171f4cbbfe).Stacked,
        (0, $b4506126e09430df$export$705e36171f4cbbfe).StepPlot
    ];
    return !!supportedTypes.find((type)=>type === cellType);
};
const $e10a8602f56394e3$export$607dbadbbbb4f68b = 250;
const $e10a8602f56394e3$export$c89f4746f89123d4 = 5000;
const $e10a8602f56394e3$export$6bb19e9a0d29cf9b = 10000;
const $e10a8602f56394e3$export$d8627e3f148ceaf1 = -1;
const $e10a8602f56394e3$export$aba984d1a1d7431b = 100;
const $e10a8602f56394e3$export$285766b0cca1e5ba = 2;
const $e10a8602f56394e3$export$13b6d0f939932bf6 = 'vertical';
const $e10a8602f56394e3$export$60faac65e31b0582 = 'horizontal';
const $e10a8602f56394e3$export$fd882954907eaf33 = 'none';
const $e10a8602f56394e3$export$4d35c276e962a435 = 20;
const $e10a8602f56394e3$export$e84ffb9eaebc4480 = 20;
const $e10a8602f56394e3$export$2cc3c74b8f2f1a6c = 1;
const $e10a8602f56394e3$export$47f68df2ff119ea5 = 0;
const $e10a8602f56394e3$export$2974393620edce23 = 28;
const $e10a8602f56394e3$export$2b517738cc766db5 = 'influx';
const $e10a8602f56394e3$export$610a9003e7f2f0cb = 'influx-enterprise';
const $e10a8602f56394e3$export$56760039c086e0f7 = 'influx-relay';
const $e10a8602f56394e3$export$f19a85207251c5b9 = 'influx-v2';
const $e10a8602f56394e3$export$a76eedc208d7b9c8 = 'influx-v3-core';
const $e10a8602f56394e3$export$28e7e8206aa55fc2 = 'influx-v3-enterprise';
const $e10a8602f56394e3$export$8c103d68b966820a = 'influx-v3-clustered';
const $e10a8602f56394e3$export$211019da7a6116e6 = 'influx-v3-cloud-dedicated';
const $e10a8602f56394e3$export$bf23c8863b1b2fd1 = 'influx-v3-serverless';
const $e10a8602f56394e3$export$8668fc04891bde79 = (source)=>{
    return source.type === $e10a8602f56394e3$export$a76eedc208d7b9c8 || source.type === $e10a8602f56394e3$export$28e7e8206aa55fc2 || source.type === $e10a8602f56394e3$export$8c103d68b966820a || source.type === $e10a8602f56394e3$export$211019da7a6116e6 || source.type === $e10a8602f56394e3$export$bf23c8863b1b2fd1;
};
var $e10a8602f56394e3$export$45c69700ee30a78c = /*#__PURE__*/ function(DataType) {
    DataType["flux"] = "flux";
    DataType["influxQL"] = "influxQL";
    return DataType;
}({});


const $9181978758b3183f$export$8054dcb2b42da45c = async ()=>{
    try {
        const response = await (0, $a537743573e5e486$export$77a72e302cf027c9)((0, $e10a8602f56394e3$export$ac392c98ac8ad998));
        // TODO: Remove use of links entirely from within AJAX function so that
        // call to setAJAXLinks is not necessary. See issue #1486.
        (0, $a537743573e5e486$export$910b1132ce0498d8)({
            updatedLinks: response.data
        });
        return response;
    } catch (error) {
        console.error(error);
        throw error;
    }
};


var $eb59f3357c899aaf$exports = {};

$parcel$export($eb59f3357c899aaf$exports, "errorThrown", function () { return $eb59f3357c899aaf$export$1550334dc0519d45; });
const $eb59f3357c899aaf$export$1550334dc0519d45 = (error, altText, alertType)=>({
        type: 'ERROR_THROWN',
        error: error,
        altText: altText,
        alertType: alertType
    });



var $e443bd9645650029$export$1385d81a6c6bbcd4 = /*#__PURE__*/ function(ActionTypes) {
    ActionTypes["LinksGetRequested"] = "LINKS_GET_REQUESTED";
    ActionTypes["LinksGetCompleted"] = "LINKS_GET_COMPLETED";
    ActionTypes["LinksGetFailed"] = "LINKS_GET_FAILED";
    return ActionTypes;
}({});
const $e443bd9645650029$var$linksGetRequested = ()=>({
        type: "LINKS_GET_REQUESTED"
    });
const $e443bd9645650029$export$66f9467ba0bdbfc5 = (links)=>({
        type: "LINKS_GET_COMPLETED",
        payload: {
            links: links
        }
    });
const $e443bd9645650029$var$linksGetFailed = ()=>({
        type: "LINKS_GET_FAILED"
    });
const $e443bd9645650029$export$3318957a1a5ea6cf = ()=>async (dispatch)=>{
        dispatch($e443bd9645650029$var$linksGetRequested());
        try {
            const { data: data } = await (0, $9181978758b3183f$export$8054dcb2b42da45c)();
            dispatch($e443bd9645650029$export$66f9467ba0bdbfc5(data));
        } catch (error) {
            const message = `Failed to retrieve api links from ${(0, $e10a8602f56394e3$export$ac392c98ac8ad998)}`;
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error, message));
            dispatch($e443bd9645650029$var$linksGetFailed());
        }
    };


const $205d139de2918454$export$5e14cdade93d6f7b = (notification)=>({
        type: 'PUBLISH_NOTIFICATION',
        payload: {
            notification: notification
        }
    });
const $205d139de2918454$export$de4868f3e9cc2a4e = (id)=>({
        type: 'DISMISS_NOTIFICATION',
        payload: {
            id: id
        }
    });



// All copy for notifications should be stored here for easy editing
// and ensuring stylistic consistency

const $ec1f42de4faacc37$var$defaultErrorNotification = {
    type: 'error',
    icon: 'alert-triangle',
    duration: (0, $e10a8602f56394e3$export$6bb19e9a0d29cf9b)
};
const $ec1f42de4faacc37$var$defaultSuccessNotification = {
    type: 'success',
    icon: 'checkmark',
    duration: (0, $e10a8602f56394e3$export$c89f4746f89123d4)
};
const $ec1f42de4faacc37$var$defaultDeletionNotification = {
    type: 'primary',
    icon: 'trash',
    duration: (0, $e10a8602f56394e3$export$c89f4746f89123d4)
};
const $ec1f42de4faacc37$export$8033c234885db562 = ()=>'Could not communicate with server.';
const $ec1f42de4faacc37$export$c04f76a93c206811 = (version)=>({
        type: 'info',
        icon: 'cubo-uniform',
        duration: (0, $e10a8602f56394e3$export$d8627e3f148ceaf1),
        message: `Welcome to the latest Chronograf (${version}). Local settings cleared.`
    });
const $ec1f42de4faacc37$export$ea869160ecd863dc = (error)=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: `Loading local settings failed: ${error}`
    });
const $ec1f42de4faacc37$export$df80ffa52e9aac30 = (type, message)=>({
        type: type,
        icon: 'triangle',
        duration: (0, $e10a8602f56394e3$export$6bb19e9a0d29cf9b),
        message: message
    });
const $ec1f42de4faacc37$export$b656d950fc80bb55 = ()=>({
        type: 'primary',
        icon: 'expand-b',
        duration: 7500,
        message: 'Press ESC to exit Presentation Mode.'
    });
const $ec1f42de4faacc37$export$9a22f1a20d817412 = ()=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        message: 'Data was written successfully.'
    });
const $ec1f42de4faacc37$export$958c58ab5c08f102 = (errorMessage)=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: `Data write failed: ${errorMessage}`
    });
const $ec1f42de4faacc37$export$a39f3d1a85036f69 = ()=>({
        type: 'primary',
        icon: 'triangle',
        duration: (0, $e10a8602f56394e3$export$d8627e3f148ceaf1),
        message: 'Your session has timed out. Log in again to continue.'
    });
const $ec1f42de4faacc37$export$63a21cafda4d93ae = {
    ...$ec1f42de4faacc37$var$defaultErrorNotification,
    message: 'Internal Server Error. Check API Logs.'
};
const $ec1f42de4faacc37$export$aec10c2b4022eddf = (sourceID)=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: `Internal Server Error. Could not retrieve Kapacitor Connections for source ${sourceID}.`
    });
const $ec1f42de4faacc37$export$cf44035ccf0482b3 = (kapacitor)=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: `Internal Server Error. Could not retrieve services for Kapacitor ${kapacitor}`
    });
const $ec1f42de4faacc37$export$c5133a70034ecde1 = ()=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: 'Internal Server Error. Could not delete Kapacitor Connection.'
    });
const $ec1f42de4faacc37$export$fc60433e0406d7a1 = ()=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: 'Unable to download .CSV file'
    });
const $ec1f42de4faacc37$export$8c5a2fe0aa69e394 = ()=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: 'Please upload a .csv file'
    });
const $ec1f42de4faacc37$export$7e5c8f53d6c04d2c = {
    ...$ec1f42de4faacc37$var$defaultErrorNotification,
    message: 'Failed to analyze query.'
};
const $ec1f42de4faacc37$export$175b49316ca08ef4 = ()=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: 'Unable to get Hosts.'
    });
const $ec1f42de4faacc37$export$31c3e1278af532f0 = ()=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: 'Unable to get Apps for Hosts.'
    });
const $ec1f42de4faacc37$export$8d90d31f62c24f5f = (sourceName)=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        icon: 'server2',
        message: `Connected to InfluxDB ${sourceName} successfully.`
    });
const $ec1f42de4faacc37$export$cecd8ab06970b3ec = (sourceName, errorMessage)=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        icon: 'server2',
        message: `Unable to connect to InfluxDB ${sourceName}: ${errorMessage}`
    });
const $ec1f42de4faacc37$export$1755739170576210 = (sourceName, errorMessage)=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        icon: 'server2',
        message: `Failed to update InfluxDB ${sourceName} Connection: ${errorMessage}`
    });
const $ec1f42de4faacc37$export$bb23f64e781656ef = (sourceName)=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        icon: 'server2',
        message: `${sourceName} deleted successfully.`
    });
const $ec1f42de4faacc37$export$5b2aebe776f68ed = (sourceName)=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        icon: 'server2',
        message: `There was a problem deleting ${sourceName}.`
    });
const $ec1f42de4faacc37$export$3dc506cfdd94308c = (sourceName)=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        icon: 'server2',
        message: `Source ${sourceName} is no longer available. Please ensure InfluxDB is running.`
    });
const $ec1f42de4faacc37$export$97fc6ba3e447395e = (errorMessage)=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        icon: 'server2',
        message: `Unable to connect to InfluxDB source: ${errorMessage}`
    });
const $ec1f42de4faacc37$export$3ae1c401848ae404 = ()=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        duration: (0, $e10a8602f56394e3$export$d8627e3f148ceaf1),
        message: 'You have been removed from all organizations. Please contact your administrator.'
    });
const $ec1f42de4faacc37$export$e78f6119814fe84a = ()=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        duration: (0, $e10a8602f56394e3$export$d8627e3f148ceaf1),
        message: 'You were removed from your current organization.'
    });
const $ec1f42de4faacc37$export$dbd0a47d5001e6ec = ()=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        duration: (0, $e10a8602f56394e3$export$d8627e3f148ceaf1),
        message: 'Organization has no sources configured.'
    });
const $ec1f42de4faacc37$export$1b1cddee8605c23d = (orgName, roleName)=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        type: 'primary',
        message: `Now logged in to '${orgName}' as '${roleName}'.`
    });
const $ec1f42de4faacc37$export$4314288848470c1c = ()=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        duration: (0, $e10a8602f56394e3$export$d8627e3f148ceaf1),
        message: 'This organization is private. To gain access, you must be explicitly added by an administrator.'
    });
const $ec1f42de4faacc37$export$e682a4eb6bad9014 = ()=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        duration: (0, $e10a8602f56394e3$export$d8627e3f148ceaf1),
        message: 'Your current organization was deleted.'
    });
const $ec1f42de4faacc37$export$c6e980ccf24e588b = (id, scheme)=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        message: `Mapping ${id}/${scheme} deleted successfully.`
    });
const $ec1f42de4faacc37$export$c0bafb2e341faca8 = (user, organization)=>`${user} has been added to ${organization} successfully.`;
const $ec1f42de4faacc37$export$bd9d907d4a68e0aa = (user, organization)=>`${user} has been removed from ${organization} successfully.`;
const $ec1f42de4faacc37$export$87d9851da6351cab = (message)=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        message: message
    });
const $ec1f42de4faacc37$export$a0f2d8fba649a6a5 = (orgName)=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        message: `Organization ${orgName} deleted successfully.`
    });
const $ec1f42de4faacc37$export$e8553dca2b78ebe6 = (user, isAbsoluteDelete)=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        message: `${user} has been removed from ${isAbsoluteDelete ? 'all organizations and deleted.' : 'the current organization.'}`
    });
const $ec1f42de4faacc37$export$ff016350b0e7cf48 = ()=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        type: 'warning',
        message: 'User must have a Name and Provider.'
    });
const $ec1f42de4faacc37$export$4c6c008a07c69695 = ()=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        message: 'User created successfully.'
    });
const $ec1f42de4faacc37$export$2e63cce792446e71 = (errorMessage)=>`Failed to create User: ${errorMessage}`;
const $ec1f42de4faacc37$export$51f46d16f7deabc9 = (userName)=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        message: `User "${userName}" deleted successfully.`
    });
const $ec1f42de4faacc37$export$5419445d0df6af71 = (errorMessage)=>`Failed to delete User: ${errorMessage}`;
const $ec1f42de4faacc37$export$22867ede2453945c = ()=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        message: 'User Permissions updated successfully.'
    });
const $ec1f42de4faacc37$export$d16f2d60afbbaa40 = (errorMessage)=>`Failed to update User Permissions: ${errorMessage}`;
const $ec1f42de4faacc37$export$ce928715b18e4b9f = ()=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        message: 'User Roles updated successfully.'
    });
const $ec1f42de4faacc37$export$b348072ac3f9c1b9 = (errorMessage)=>`Failed to update User Roles: ${errorMessage}`;
const $ec1f42de4faacc37$export$8a8ab4d4ce2f5a6d = ()=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        message: 'User Password updated successfully.'
    });
const $ec1f42de4faacc37$export$310cbc8347ac0406 = (errorMessage)=>`Failed to update User Password: ${errorMessage}`;
const $ec1f42de4faacc37$export$3c6fbfed387c4eac = ()=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        message: 'Database created successfully.'
    });
const $ec1f42de4faacc37$export$2057d63776a988da = (errorMessage)=>`Failed to create Database: ${errorMessage}`;
const $ec1f42de4faacc37$export$ac5d1ff53db4fcb2 = (databaseName)=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        message: `Database "${databaseName}" deleted successfully.`
    });
const $ec1f42de4faacc37$export$2a521f5871c9b754 = (errorMessage)=>`Failed to delete Database: ${errorMessage}`;
const $ec1f42de4faacc37$export$5756acff3e9ae6fd = ()=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        message: 'Role created successfully.'
    });
const $ec1f42de4faacc37$export$8b003f331ce4581b = (errorMessage)=>`Failed to create Role: ${errorMessage}`;
const $ec1f42de4faacc37$export$81c0d3902693e46b = (roleName)=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        message: `Role "${roleName}" deleted successfully.`
    });
const $ec1f42de4faacc37$export$e907074790b70611 = (errorMessage)=>`Failed to delete Role: ${errorMessage}`;
const $ec1f42de4faacc37$export$2e024db71a7563fb = ()=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        message: 'Role Users updated successfully.'
    });
const $ec1f42de4faacc37$export$d67cdd4a9aa1509f = (errorMessage)=>`Failed to update Role Users: ${errorMessage}`;
const $ec1f42de4faacc37$export$867c0323ff47e90c = ()=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        message: 'Role Permissions updated successfully.'
    });
const $ec1f42de4faacc37$export$e1df1d69e5b00ef = (errorMessage)=>`Failed to update Role Permissions: ${errorMessage}`;
const $ec1f42de4faacc37$export$77da94ed464c9b49 = ()=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        message: 'Retention Policy created successfully.'
    });
const $ec1f42de4faacc37$export$c5a6efc773cc12a6 = ()=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: 'Failed to create Retention Policy. Please check name and duration.'
    });
const $ec1f42de4faacc37$export$4fee75cd22cf084c = (errorMessage)=>`Failed to create Retention Policy: ${errorMessage}`;
const $ec1f42de4faacc37$export$6bde8172d5cb97e1 = (rpName)=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        message: `Retention Policy "${rpName}" deleted successfully.`
    });
const $ec1f42de4faacc37$export$f6ff5581ab8c95df = (errorMessage)=>`Failed to delete Retention Policy: ${errorMessage}`;
const $ec1f42de4faacc37$export$f06db47b4fa62877 = ()=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        message: 'Retention Policy updated successfully.'
    });
const $ec1f42de4faacc37$export$be7fbf4b943ce41c = (errorMessage)=>`Failed to update Retention Policy: ${errorMessage}`;
const $ec1f42de4faacc37$export$43064f5e630893ac = (errorMessage)=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: errorMessage
    });
const $ec1f42de4faacc37$export$6b14ed50c565020f = ()=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: 'Fields cannot be empty.'
    });
const $ec1f42de4faacc37$export$2fb9043fa7492e92 = (databaseName)=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: `Type "DELETE ${databaseName}" to confirm. This action cannot be undone.`
    });
const $ec1f42de4faacc37$export$ea1c3821542ff55e = ()=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: 'User name is too short.'
    });
const $ec1f42de4faacc37$export$64b28869dcd192f = ()=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: 'Password is too short.'
    });
const $ec1f42de4faacc37$export$cc3632ec43d85246 = ()=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: 'User name already exists.'
    });
const $ec1f42de4faacc37$export$f6a944aaea43bf79 = ()=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: 'Role name is too short.'
    });
const $ec1f42de4faacc37$export$a66177f85945ac02 = ()=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: 'Role name already exists.'
    });
const $ec1f42de4faacc37$export$5eec90a2b9dd4cc1 = ()=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: 'Database name cannot be blank.'
    });
const $ec1f42de4faacc37$export$7ed201556d6460db = ()=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: 'A Database by this name already exists.'
    });
const $ec1f42de4faacc37$export$b83ace8621df3dc3 = (tempVarName)=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        icon: 'cube',
        message: `Variable '${tempVarName}' already exists. Please enter a new value.`
    });
const $ec1f42de4faacc37$export$296a221b193442a3 = (dashboardID)=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        icon: 'dash-h',
        message: `Dashboard ${dashboardID} could not be found`
    });
const $ec1f42de4faacc37$export$7aa4f970ba4e5699 = (queryParam)=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        icon: 'dash-h',
        message: `Invalid query parameter value for ${queryParam}, reverting to default`
    });
const $ec1f42de4faacc37$export$b62936ee40a91499 = (name)=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        icon: 'dash-h',
        message: `Dashboard ${name} deleted successfully.`
    });
const $ec1f42de4faacc37$export$d09415c64d64264a = (count)=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        icon: 'dash-h',
        message: `Selected dashboard${count > 1 ? 's have' : ' has'} been created.`
    });
const $ec1f42de4faacc37$export$2b7c46a165a3f8cb = ()=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        icon: 'dash-h',
        message: `There are no suggested dashboards for this source`
    });
const $ec1f42de4faacc37$export$eeb98aa1ba59dfcc = (count)=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        icon: 'dash-h',
        message: `Could not create selected dashboard${count > 1 ? 's' : ''}.`
    });
const $ec1f42de4faacc37$export$94dd573d58c195d3 = (name)=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        icon: 'dash-h',
        message: `Dashboard ${name} exported successfully.`
    });
const $ec1f42de4faacc37$export$7e798f539d06b4f7 = (name, errorMessage)=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        duration: (0, $e10a8602f56394e3$export$d8627e3f148ceaf1),
        message: `Failed to export Dashboard ${name}: ${errorMessage}.`
    });
const $ec1f42de4faacc37$export$b7de63aa72092845 = ()=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        icon: 'dash-h',
        message: `Dashboard imported successfully.`
    });
const $ec1f42de4faacc37$export$bdd074588a01033f = (fileName, errorMessage)=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        duration: (0, $e10a8602f56394e3$export$d8627e3f148ceaf1),
        message: `Failed to import Dashboard from file ${fileName}: ${errorMessage}.`
    });
const $ec1f42de4faacc37$export$2d6345764df5740d = (name, errorMessage)=>`Failed to delete Dashboard ${name}: ${errorMessage}.`;
const $ec1f42de4faacc37$export$f51fb663e05b8eaf = (name)=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        icon: 'dash-h',
        duration: 1900,
        message: `Added "${name}" to dashboard.`
    });
const $ec1f42de4faacc37$export$3216e94217c8d2db = (cellName, dashboardNum)=>{
    const pluralizer = dashboardNum > 1 ? 's' : '';
    return {
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        icon: 'dash-h',
        message: `Added "${cellName}" to ${dashboardNum} dashboard${pluralizer}.`
    };
};
const $ec1f42de4faacc37$export$1150c37069ac095f = (cellName, dashboardName)=>{
    return {
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        icon: 'dash-h',
        message: `Could not add "${cellName}" to ${dashboardName}.`
    };
};
const $ec1f42de4faacc37$export$3e7bb883732c450d = (name)=>({
        ...$ec1f42de4faacc37$var$defaultDeletionNotification,
        icon: 'dash-h',
        duration: 1900,
        message: `Deleted "${name}" from dashboard.`
    });
const $ec1f42de4faacc37$export$394341f316d6da97 = (tempVar, errorMessage)=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        icon: 'cube',
        duration: 7500,
        message: `Invalid query supplied for template variable ${tempVar}: ${errorMessage}`
    });
const $ec1f42de4faacc37$export$b2e458ddb0a0b68a = ({ key: key, value: value })=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        icon: 'cube',
        message: `Invalid URL query value of '${value}' supplied for template variable '${key}'.`
    });
const $ec1f42de4faacc37$export$75fdca74441258b3 = ()=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        icon: 'cube',
        message: `Invalid URL query value supplied for lower or upper time range.`
    });
const $ec1f42de4faacc37$export$12655bda97cfad49 = ()=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        icon: 'cube',
        message: `Template Variables of map type accept two comma separated values per line`
    });
const $ec1f42de4faacc37$export$fddb310f4b93f987 = ()=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        icon: 'cube',
        message: `Invalid URL query value supplied for zoomed lower or zoomed upper time range.`
    });
const $ec1f42de4faacc37$export$5df45d19808f1d9d = (ruleName)=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        message: `${ruleName} created successfully.`
    });
const $ec1f42de4faacc37$export$ed834968f44fc6b8 = (ruleName, errorMessage)=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: `There was a problem creating ${ruleName}: ${errorMessage}`
    });
const $ec1f42de4faacc37$export$7ebcc4382eca02d = (ruleName)=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        message: `${ruleName} saved successfully.`
    });
const $ec1f42de4faacc37$export$47898d2d85291ebb = (ruleName, errorMessage)=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: `There was a problem saving ${ruleName}: ${errorMessage}`
    });
const $ec1f42de4faacc37$export$b9fb5ac3b1648cf = (ruleName)=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        message: `${ruleName} deleted successfully.`
    });
const $ec1f42de4faacc37$export$a023f39c3f194683 = (ruleName)=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: `${ruleName} could not be deleted.`
    });
const $ec1f42de4faacc37$export$41af055b5b12f786 = (ruleName, updatedStatus)=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        message: `${ruleName} ${updatedStatus} successfully.`
    });
const $ec1f42de4faacc37$export$63f2ebe081830a1e = (taskName, updatedStatus)=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        message: `${taskName} is now ${updatedStatus}.`
    });
const $ec1f42de4faacc37$export$163d6d23beef07ab = (ruleName, updatedStatus)=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        message: `${ruleName} could not be ${updatedStatus}.`
    });
const $ec1f42de4faacc37$export$e9e86592d2c92c39 = (taskName, updatedStatus)=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        message: `${taskName} could not be made ${updatedStatus}.`
    });
const $ec1f42de4faacc37$export$b5dc5f7a41f67809 = ()=>'Please select a Database, Measurement, and Field.';
const $ec1f42de4faacc37$export$63c9b60b7014c624 = ()=>'Please enter a value in the Conditions section.';
const $ec1f42de4faacc37$export$ec77ce4d517f2f5e = ()=>'Deadman rules require a Database and Measurement.';
const $ec1f42de4faacc37$export$9984e2e3836bf7bd = (kapacitorName)=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: `There is already a Kapacitor Connection named "${kapacitorName}."`
    });
const $ec1f42de4faacc37$export$d9701f6e26d94d71 = ()=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: 'We could not find a Kapacitor configuration for this source.'
    });
const $ec1f42de4faacc37$export$6ef25cd61bd3e07b = ()=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: 'There was an error getting the Kapacitor configuration.'
    });
const $ec1f42de4faacc37$export$712befa86969b20d = (endpoint)=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        message: `Alert configuration for ${endpoint} saved successfully.`
    });
const $ec1f42de4faacc37$export$eabfbe16422aaee2 = (endpoint, errorMessage)=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: `There was an error saving the alert configuration for ${endpoint}: ${errorMessage}`
    });
const $ec1f42de4faacc37$export$b2ced4ca8b27dade = (endpoint, config, errorMessage)=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: `There was an error deleting the alert configuration for ${endpoint}/${config}: ${errorMessage}`
    });
const $ec1f42de4faacc37$export$31a167bb98c72316 = (endpoint, config)=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        message: `Alert configuration for ${endpoint}/${config} deleted successfully.`
    });
const $ec1f42de4faacc37$export$b68e24ec4022574 = (endpoint)=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        duration: (0, $e10a8602f56394e3$export$6bb19e9a0d29cf9b),
        message: `Test Alert sent to ${endpoint}. If the Alert does not reach its destination, please check your endpoint configuration settings.`
    });
const $ec1f42de4faacc37$export$b5e165c93210c11b = (endpoint, errorMessage = '')=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: `There was an error sending a Test Alert to ${endpoint} ${errorMessage}.`
    });
const $ec1f42de4faacc37$export$e838d276f1588a38 = ()=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: 'Batch Size cannot be empty.'
    });
const $ec1f42de4faacc37$export$3d61248777676e06 = ()=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: 'Could not connect to Kapacitor. Check your connection settings in the Configuration page.'
    });
const $ec1f42de4faacc37$export$9bc16ccd017b167b = ()=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        message: 'Connected to Kapacitor successfully! Configuring endpoints is optional.'
    });
const $ec1f42de4faacc37$export$76f6258963c60ebd = ()=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        message: 'Connected to Kapacitor successfully!'
    });
const $ec1f42de4faacc37$export$3a02db82a483db3a = ()=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: 'There was a problem connecting to Kapacitor.'
    });
const $ec1f42de4faacc37$export$487f49b354cc796d = (kapacitorName)=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: `Could not connect to ${kapacitorName}. Please check your connection parameters.`
    });
const $ec1f42de4faacc37$export$d1d4e05f77d7d304 = (kapacitorName)=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: `Could not connect to updated ${kapacitorName}. Please check your connection parameters.`
    });
const $ec1f42de4faacc37$export$6b6bc939c8a37bfd = ()=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        message: 'Kapacitor Connection updated successfully.'
    });
const $ec1f42de4faacc37$export$925b076dd6957393 = ()=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: 'There was a problem updating the Kapacitor Connection.'
    });
const $ec1f42de4faacc37$export$6d828cef0570d712 = ()=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        message: 'TICKscript successfully created.'
    });
const $ec1f42de4faacc37$export$4b3289079e9741b6 = ()=>'Failed to create TICKscript.';
const $ec1f42de4faacc37$export$74962bbe08d29d34 = ()=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        message: 'TICKscript successfully updated.'
    });
const $ec1f42de4faacc37$export$46ee31e0b5169ec0 = ()=>'Failed to update TICKscript.';
const $ec1f42de4faacc37$export$832db2e7f377c899 = ()=>({
        type: 'warning',
        icon: 'alert-triangle',
        duration: (0, $e10a8602f56394e3$export$d8627e3f148ceaf1),
        message: 'Kapacitor version 1.4 required to view TICKscript logs'
    });
const $ec1f42de4faacc37$export$78d3dfe36c7b2e43 = ()=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: 'Could not collect kapacitor logs'
    });
const $ec1f42de4faacc37$export$e110245f059bd84a = ()=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: 'We could not find a Kapacitor configuration for this source.'
    });
const $ec1f42de4faacc37$export$8b594347a7c4ce0e = ()=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        message: 'No errors found. Happy Happy Joy Joy!'
    });
const $ec1f42de4faacc37$export$9744b69e3922044f = (text, title = '', suffix = ' has been copied to clipboard.')=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        icon: 'dash-h',
        message: `${title}${text === null ? '' : "'" + text + "'"}${suffix}`
    });
const $ec1f42de4faacc37$export$6a59b8139549a56 = (text, title = '', suffix = ' was not copied to clipboard.')=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: `${title}${text === null ? '' : "'" + text + "'"}${suffix}`
    });
const $ec1f42de4faacc37$export$4cdb939c330e25a3 = (fluxName)=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: `There is already a Flux Connection named "${fluxName}."`
    });
const $ec1f42de4faacc37$export$f3f4884ff71b5f96 = (id)=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: `Could not find Flux with id ${id}.`
    });
const $ec1f42de4faacc37$export$bb35a42af25d5094 = {
    ...$ec1f42de4faacc37$var$defaultErrorNotification,
    message: 'We could not get services'
};
const $ec1f42de4faacc37$export$1d636811a3d44443 = {
    ...$ec1f42de4faacc37$var$defaultSuccessNotification,
    message: 'Flux Connection Created.  Script your heart out!'
};
const $ec1f42de4faacc37$export$b2abeceae0c4940c = (message)=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: message
    });
const $ec1f42de4faacc37$export$dfb1ba022092c5ea = (message)=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: message
    });
const $ec1f42de4faacc37$export$26ae873bc32dcbf4 = {
    ...$ec1f42de4faacc37$var$defaultSuccessNotification,
    message: 'Connection Updated. Rejoice!'
};
const $ec1f42de4faacc37$export$33d9dc671f47d2f6 = (truncatedRowCount)=>{
    const thousands = Math.floor(truncatedRowCount / 1000);
    return {
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: `Large response truncated to first ${thousands}K rows`
    };
};
const $ec1f42de4faacc37$export$3b05be0df6912e3d = {
    ...$ec1f42de4faacc37$var$defaultErrorNotification,
    message: 'CSV Export failed'
};
const $ec1f42de4faacc37$export$1fd9c65b41098040 = (message)=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        message: message
    });
const $ec1f42de4faacc37$export$c312505591a86529 = (message)=>({
        ...$ec1f42de4faacc37$var$defaultErrorNotification,
        duration: (0, $e10a8602f56394e3$export$c89f4746f89123d4),
        message: message
    });
const $ec1f42de4faacc37$export$12b4d85bb93671c5 = (bucket, db, rp)=>({
        ...$ec1f42de4faacc37$var$defaultSuccessNotification,
        duration: (0, $e10a8602f56394e3$export$6bb19e9a0d29cf9b),
        message: `Default V1 DBRP mapping created. V2 bucket '${bucket}' is mapped to v1 database '${db}' with retention policy '${rp}'.`
    });


var $7af565d99d629ce9$export$1385d81a6c6bbcd4 = /*#__PURE__*/ function(ActionTypes) {
    ActionTypes["AuthExpired"] = "AUTH_EXPIRED";
    ActionTypes["AuthRequested"] = "AUTH_REQUESTED";
    ActionTypes["MeGetRequested"] = "ME_GET_REQUESTED";
    ActionTypes["MeGetCompleted"] = "ME_GET_COMPLETED";
    ActionTypes["MeGetFailed"] = "ME_GET_FAILED";
    ActionTypes["MeChangeOrganizationRequested"] = "ME_CHANGE_ORGANIZATION_REQUESTED";
    ActionTypes["MeChangeOrganizationCompleted"] = "ME_CHANGE_ORGANIZATION_COMPLETED";
    ActionTypes["MeChangeOrganizationFailed"] = "ME_CHANGE_ORGANIZATION_FAILED";
    return ActionTypes;
}({});
const $7af565d99d629ce9$export$ab83f8a31deeb446 = (auth)=>({
        type: "AUTH_EXPIRED",
        payload: {
            auth: auth
        }
    });
const $7af565d99d629ce9$export$5c58952c6f82e908 = ()=>({
        type: "AUTH_REQUESTED"
    });
const $7af565d99d629ce9$export$11c57b5c65592b9e = ()=>({
        type: "ME_GET_REQUESTED"
    });
const $7af565d99d629ce9$export$262661db531e0821 = ({ me: me, auth: auth, logoutLink: logoutLink })=>({
        type: "ME_GET_COMPLETED",
        payload: {
            me: me,
            auth: auth,
            logoutLink: logoutLink
        }
    });
const $7af565d99d629ce9$export$fa9bcd8ef5948353 = ()=>({
        type: "ME_GET_FAILED"
    });
const $7af565d99d629ce9$export$eadd1b233bba454c = ()=>({
        type: "ME_CHANGE_ORGANIZATION_REQUESTED"
    });
const $7af565d99d629ce9$export$1a1cdd4cdfbde12f = ()=>({
        type: "ME_CHANGE_ORGANIZATION_COMPLETED"
    });
const $7af565d99d629ce9$export$2f910319adc49e0a = ()=>({
        type: "ME_CHANGE_ORGANIZATION_FAILED"
    });
const $7af565d99d629ce9$export$2c21f559fb9e5c02 = ({ shouldResetMe: shouldResetMe = false } = {})=>async (dispatch)=>{
        if (shouldResetMe) {
            dispatch($7af565d99d629ce9$export$5c58952c6f82e908());
            dispatch($7af565d99d629ce9$export$11c57b5c65592b9e());
        }
        try {
            // These non-me objects are added to every response by some AJAX trickery
            const { data: me, auth: auth, logoutLink: logoutLink } = await (0, $ce33d45777fa0434$export$dd7946daa6163e94)();
            // TODO: eventually, get the links for auth and logout out of here and into linksGetCompleted
            dispatch($7af565d99d629ce9$export$262661db531e0821({
                me: me,
                auth: auth,
                logoutLink: logoutLink
            }));
        } catch (error) {
            dispatch($7af565d99d629ce9$export$fa9bcd8ef5948353());
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error));
        }
    };
const $7af565d99d629ce9$export$5327fe44904ab84d = (url, organization)=>async (dispatch)=>{
        dispatch($7af565d99d629ce9$export$eadd1b233bba454c());
        try {
            const { data: me, auth: auth, logoutLink: logoutLink } = await (0, $ce33d45777fa0434$export$8ddaddf355aae59c)(url, organization);
            const currentRole = me.roles.find((r)=>r.organization === me.currentOrganization.id);
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$1b1cddee8605c23d)(me.currentOrganization.name, currentRole.name)));
            dispatch($7af565d99d629ce9$export$1a1cdd4cdfbde12f());
            dispatch($7af565d99d629ce9$export$262661db531e0821({
                me: me,
                auth: auth,
                logoutLink: logoutLink
            }));
            // refresh links after every successful meChangeOrganization to refresh
            // /organizations/:id/users link for Admin / Current Org Users page to load
            dispatch((0, $e443bd9645650029$export$3318957a1a5ea6cf)());
        // TODO: reload sources upon me change org if non-refresh behavior preferred
        // instead of current behavior on both invocations of meChangeOrganization,
        // which is to refresh index via router.push('')
        } catch (error) {
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error));
            dispatch($7af565d99d629ce9$export$2f910319adc49e0a());
        }
    };





const $247e66be5535f58e$var$actionsAllowedDuringBlackout = [
    '@@',
    'AUTH_',
    'ME_',
    'PUBLISH_NOTIFICATION',
    'ERROR_',
    'LINKS_'
];
const $247e66be5535f58e$var$errorsMiddleware = (store)=>(next)=>(action)=>{
            const { auth: { me: me } } = store.getState();
            if (action.type === 'ERROR_THROWN') {
                const { error: error, error: { status: status, auth: auth }, altText: altText, alertType: alertType = 'info' } = action;
                if (status === (0, $e10a8602f56394e3$export$cfa9956f1887e28f)) {
                    const message = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(error, 'data.message', '');
                    const organizationWasRemoved = message === `user's current organization was not found` // eslint-disable-line quotes
                    ;
                    const wasSessionTimeout = me !== null;
                    store.dispatch((0, $7af565d99d629ce9$export$ab83f8a31deeb446)(auth));
                    if (message === `This organization is private. To gain access, you must be explicitly added by an administrator.` // eslint-disable-line quotes
                    ) store.dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$4314288848470c1c)()));
                    if (organizationWasRemoved) store.dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$e682a4eb6bad9014)()));
                    else if (wasSessionTimeout) store.dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$a39f3d1a85036f69)()));
                } else if (altText) store.dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$df80ffa52e9aac30)(alertType, altText)));
            }
            // If auth has expired, do not execute any further actions or redux state
            // changes not related to routing and auth. This allows the error notification
            // telling the user why they've been logged out to persist in the UI. It also
            // prevents further changes to redux state by actions that may have triggered
            // AJAX requests pre-auth expiration and whose response returns post-logout
            if (me === null && !$247e66be5535f58e$var$actionsAllowedDuringBlackout.some((allowedAction)=>action.type.includes(allowedAction))) return;
            next(action);
        };
var $247e66be5535f58e$export$2e2bcd8739ae039 = $247e66be5535f58e$var$errorsMiddleware;


// Trigger resize event to relayout the React Layout plugin
const $d8dda32060b145b0$export$758290ca160a9c16 = ()=>(next)=>(action)=>{
            next(action);
            if (action.type === 'ENABLE_PRESENTATION_MODE' || action.type === 'DISABLE_PRESENTATION_MODE') {
                // Uses longer event object creation method due to IE compatibility.
                const evt = document.createEvent('HTMLEvents');
                evt.initEvent('resize', false, true);
                window.dispatchEvent(evt);
            }
        };


// Middleware generally used for actions needing parsed queryStrings

var $1l8zS = parcelRequire("1l8zS");



var $67853175702c8b4d$export$1385d81a6c6bbcd4 = /*#__PURE__*/ function(ActionTypes) {
    ActionTypes["EnablePresentationMode"] = "ENABLE_PRESENTATION_MODE";
    ActionTypes["DisablePresentationMode"] = "DISABLE_PRESENTATION_MODE";
    ActionTypes["SetAutoRefresh"] = "SET_AUTOREFRESH";
    ActionTypes["ToggleTemplateVariableControlBar"] = "TOGGLE_TEMPLATE_VARIABLE_CONTROL_BAR";
    ActionTypes["ToggleShowAnnotationControls"] = "TOGGLE_SHOW_ANNOTATION_CONTROLS";
    ActionTypes["Noop"] = "NOOP";
    ActionTypes["SetTimeZone"] = "SET_TIME_ZONE";
    ActionTypes["SetTelegrafSystemInterval"] = "SET_TELEGRAF_SYSTEM_INTERVAL";
    ActionTypes["SetHostPageDisplayStatus"] = "SET_HOST_PAGE_DISPLAY_STATUS";
    ActionTypes["SetV3SupportEnabled"] = "SET_V3_SUPPORT_ENABLED";
    return ActionTypes;
}({});


const $cac020f89fc6c82e$export$56fae186acf60d0e = ()=>({
        type: (0, $67853175702c8b4d$export$1385d81a6c6bbcd4).EnablePresentationMode
    });
const $cac020f89fc6c82e$export$35e76ce34554c16c = ()=>({
        type: (0, $67853175702c8b4d$export$1385d81a6c6bbcd4).DisablePresentationMode
    });
const $cac020f89fc6c82e$export$84ea1cdd7d049965 = ()=>async (dispatch)=>setTimeout(()=>{
            dispatch($cac020f89fc6c82e$export$56fae186acf60d0e());
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$b656d950fc80bb55)()));
        }, (0, $e10a8602f56394e3$export$6aba70ea7fba2ecd));
const $cac020f89fc6c82e$export$5a78de5758caee29 = (milliseconds)=>({
        type: (0, $67853175702c8b4d$export$1385d81a6c6bbcd4).SetAutoRefresh,
        payload: {
            milliseconds: milliseconds
        }
    });
const $cac020f89fc6c82e$export$9b87e5c5d16de9de = ()=>({
        type: (0, $67853175702c8b4d$export$1385d81a6c6bbcd4).ToggleTemplateVariableControlBar
    });
const $cac020f89fc6c82e$export$538f3bcfcce55171 = ()=>({
        type: (0, $67853175702c8b4d$export$1385d81a6c6bbcd4).ToggleShowAnnotationControls
    });
const $cac020f89fc6c82e$export$93c56f26d2728d8d = (timeZone)=>({
        type: (0, $67853175702c8b4d$export$1385d81a6c6bbcd4).SetTimeZone,
        payload: {
            timeZone: timeZone
        }
    });


const $af5f7d05017ad785$export$baf9953bdab26da1 = ()=>(dispatch)=>(action)=>{
            dispatch(action);
            const urlQueryParams = (0, (/*@__PURE__*/$parcel$interopDefault($1l8zS))).parse(window.location.search, {
                ignoreQueryPrefix: true
            });
            if (urlQueryParams.present === 'true') dispatch((0, $cac020f89fc6c82e$export$56fae186acf60d0e)());
        };


// he is a library for safely encoding and decoding HTML Entities

var $h4twM = parcelRequire("h4twM");
const $00d2e80eca0b23e9$export$1b2a13ad4537525e = async (url)=>{
    const response = await fetch(url, {
        method: 'GET',
        mode: 'cors'
    });
    return response.json();
};


var $e92b489e10597290$export$1385d81a6c6bbcd4 = /*#__PURE__*/ function(ActionTypes) {
    ActionTypes["FETCH_JSON_FEED_REQUESTED"] = "FETCH_JSON_FEED_REQUESTED";
    ActionTypes["FETCH_JSON_FEED_COMPLETED"] = "FETCH_JSON_FEED_COMPLETED";
    ActionTypes["FETCH_JSON_FEED_FAILED"] = "FETCH_JSON_FEED_FAILED";
    return ActionTypes;
}({});
const $e92b489e10597290$var$fetchJSONFeedRequested = ()=>({
        type: "FETCH_JSON_FEED_REQUESTED"
    });
const $e92b489e10597290$var$fetchJSONFeedCompleted = (data)=>({
        type: "FETCH_JSON_FEED_COMPLETED",
        payload: {
            data: data
        }
    });
const $e92b489e10597290$var$fetchJSONFeedFailed = ()=>({
        type: "FETCH_JSON_FEED_FAILED"
    });
const $e92b489e10597290$export$7a9dc19a21a25eb3 = (url)=>async (dispatch)=>{
        dispatch($e92b489e10597290$var$fetchJSONFeedRequested());
        try {
            const data = await (0, $00d2e80eca0b23e9$export$1b2a13ad4537525e)(url);
            // data could be from a webpage, and thus would be HTML
            if (typeof data === 'string' || !data) dispatch($e92b489e10597290$var$fetchJSONFeedFailed());
            else {
                // decode HTML entities from response text
                const decodedData = {
                    ...data,
                    items: data.items.map((item)=>{
                        item.title = (0, (/*@__PURE__*/$parcel$interopDefault($h4twM))).decode(item.title);
                        item.content_text = (0, (/*@__PURE__*/$parcel$interopDefault($h4twM))).decode(item.content_text);
                        return item;
                    })
                };
                dispatch($e92b489e10597290$var$fetchJSONFeedCompleted(decodedData));
            }
        } catch (error) {
            console.error(error);
            dispatch($e92b489e10597290$var$fetchJSONFeedFailed());
        }
    };


const $211209a3b8290f1b$var$initialState = {
    hasCompletedFetchOnce: false,
    isFetching: false,
    isFailed: false,
    data: null
};
const $211209a3b8290f1b$var$JSONFeedReducer = (state = $211209a3b8290f1b$var$initialState, action)=>{
    switch(action.type){
        case (0, $e92b489e10597290$export$1385d81a6c6bbcd4).FETCH_JSON_FEED_REQUESTED:
            return {
                ...state,
                isFetching: true,
                isFailed: false
            };
        case (0, $e92b489e10597290$export$1385d81a6c6bbcd4).FETCH_JSON_FEED_COMPLETED:
            {
                const { data: data } = action.payload;
                return {
                    ...state,
                    hasCompletedFetchOnce: true,
                    isFetching: false,
                    isFailed: false,
                    data: data
                };
            }
        case (0, $e92b489e10597290$export$1385d81a6c6bbcd4).FETCH_JSON_FEED_FAILED:
            return {
                ...state,
                isFetching: false,
                isFailed: true,
                data: null
            };
        default:
            return state;
    }
};
var $211209a3b8290f1b$export$2e2bcd8739ae039 = $211209a3b8290f1b$var$JSONFeedReducer;


var $20a2cb61bb5feba2$export$2e2bcd8739ae039 = {
    JSONFeed: $211209a3b8290f1b$export$2e2bcd8739ae039
};



var $hBdgJ = parcelRequire("hBdgJ");
/* eslint-disable @typescript-eslint/no-redundant-type-constituents */ 
var $hBdgJ = parcelRequire("hBdgJ");


var $hBdgJ = parcelRequire("hBdgJ");
var $2aff9a9dae44a870$export$deac0a0b3bd8dbae = /*#__PURE__*/ function(AlertTypes) {
    AlertTypes["seperator"] = "";
    AlertTypes["alerta"] = "alerta";
    AlertTypes["httppost"] = "httppost";
    AlertTypes["influxdb"] = "influxdb";
    AlertTypes["kafka"] = "kafka";
    AlertTypes["mqtt"] = "mqtt";
    AlertTypes["opsgenie"] = "opsgenie";
    AlertTypes["opsgenie2"] = "opsgenie2";
    AlertTypes["pagerduty"] = "pagerduty";
    AlertTypes["pagerduty2"] = "pagerduty2";
    AlertTypes["pushover"] = "pushover";
    AlertTypes["sensu"] = "sensu";
    AlertTypes["slack"] = "slack";
    AlertTypes["smtp"] = "smtp";
    AlertTypes["snmptrap"] = "snmptrap";
    AlertTypes["talk"] = "talk";
    AlertTypes["telegram"] = "telegram";
    AlertTypes["victorops"] = "victorops";
    AlertTypes["post"] = "post";
    AlertTypes["tcp"] = "tcp";
    AlertTypes["exec"] = "exec";
    AlertTypes["log"] = "log";
    AlertTypes["servicenow"] = "servicenow";
    AlertTypes["bigpanda"] = "bigpanda";
    AlertTypes["teams"] = "teams";
    AlertTypes["zenoss"] = "zenoss";
    return AlertTypes;
}({});
var $2aff9a9dae44a870$export$e830ee944b1c1767 = /*#__PURE__*/ function(AlertDisplayText) {
    AlertDisplayText["alerta"] = "Alerta";
    AlertDisplayText["kafka"] = "Kafka";
    AlertDisplayText["opsgenie"] = "OpsGenie";
    AlertDisplayText["opsgenie2"] = "OpsGenie2";
    AlertDisplayText["pagerduty"] = "PagerDuty";
    AlertDisplayText["pagerduty2"] = "PagerDuty2";
    AlertDisplayText["pushover"] = "Pushover";
    AlertDisplayText["sensu"] = "Sensu";
    AlertDisplayText["slack"] = "Slack";
    AlertDisplayText["smtp"] = "SMTP";
    AlertDisplayText["talk"] = "Talk";
    AlertDisplayText["telegram"] = "Telegram";
    AlertDisplayText["victorops"] = "VictorOps";
    AlertDisplayText["servicenow"] = "ServiceNow";
    AlertDisplayText["bigpanda"] = "BigPanda";
    AlertDisplayText["teams"] = "Teams";
    AlertDisplayText["zenoss"] = "Zenoss";
    return AlertDisplayText;
}({});
const $2aff9a9dae44a870$export$dd6f23c26abf90c7 = [
    'alerta',
    'bigpanda',
    'kafka',
    'opsgenie',
    'opsgenie2',
    'pagerduty',
    'pagerduty2',
    'pushover',
    'sensu',
    'servicenow',
    'slack',
    'smtp',
    'talk',
    'teams',
    'telegram',
    'victorops',
    'zenoss'
];
const $2aff9a9dae44a870$export$f57641517de48242 = {
    deadman: {
        period: '10m'
    },
    relative: {
        change: 'change',
        shift: '1m',
        operator: 'greater than',
        value: ''
    },
    threshold: {
        operator: 'greater than',
        value: '',
        rangeValue: '',
        relation: 'once',
        percentile: '90'
    }
};
const $2aff9a9dae44a870$export$a8b42427a6648e97 = '30s';
const $2aff9a9dae44a870$export$61f904b372c078a5 = 'equal to';
const $2aff9a9dae44a870$export$f2b6bd6dbf5bc5b6 = 'less than';
const $2aff9a9dae44a870$export$d8f3df6d8f4c0106 = 'greater than';
const $2aff9a9dae44a870$export$15c101733cafc078 = 'not equal to';
const $2aff9a9dae44a870$export$b46c50301ce75154 = 'inside range';
const $2aff9a9dae44a870$export$84ccd2e7a24875dd = 'outside range';
const $2aff9a9dae44a870$export$6ed4b6f4fce92751 = 'equal to or greater';
const $2aff9a9dae44a870$export$34ab6237a348cb9f = 'equal to or less than';
var $2aff9a9dae44a870$export$2d7890f74d4e6421 = /*#__PURE__*/ function(ThresholdOperators) {
    ThresholdOperators["EqualTo"] = "equal to";
    ThresholdOperators["LessThan"] = "less than";
    ThresholdOperators["GreaterThan"] = "greater than";
    ThresholdOperators["NotEqualTo"] = "not equal to";
    ThresholdOperators["InsideRange"] = "inside range";
    ThresholdOperators["OutsideRange"] = "outside range";
    ThresholdOperators["EqualToOrGreaterThan"] = "equal to or greater";
    ThresholdOperators["EqualToOrLessThan"] = "equal to or less than";
    return ThresholdOperators;
}({});
const $2aff9a9dae44a870$export$e41da9f403454a3d = [
    $2aff9a9dae44a870$export$d8f3df6d8f4c0106,
    $2aff9a9dae44a870$export$6ed4b6f4fce92751,
    $2aff9a9dae44a870$export$34ab6237a348cb9f,
    $2aff9a9dae44a870$export$f2b6bd6dbf5bc5b6,
    $2aff9a9dae44a870$export$61f904b372c078a5,
    $2aff9a9dae44a870$export$15c101733cafc078,
    $2aff9a9dae44a870$export$b46c50301ce75154,
    $2aff9a9dae44a870$export$84ccd2e7a24875dd
];
const $2aff9a9dae44a870$export$7078aff415f59dec = [
    $2aff9a9dae44a870$export$d8f3df6d8f4c0106,
    $2aff9a9dae44a870$export$6ed4b6f4fce92751,
    $2aff9a9dae44a870$export$34ab6237a348cb9f,
    $2aff9a9dae44a870$export$f2b6bd6dbf5bc5b6,
    $2aff9a9dae44a870$export$61f904b372c078a5,
    $2aff9a9dae44a870$export$15c101733cafc078
];
const $2aff9a9dae44a870$export$250100a662402f55 = [
    '1m',
    '5m',
    '10m',
    '30m',
    '1h',
    '2h',
    '24h'
];
const $2aff9a9dae44a870$export$8598196f74460271 = [
    'change',
    '% change'
];
const $2aff9a9dae44a870$export$41955167b1d28fc5 = [
    '1m',
    '5m',
    '10m',
    '30m',
    '1h',
    '2h',
    '24h'
];
const $2aff9a9dae44a870$export$f20cff0eb3a8b896 = 'DEFAULT_RULE_ID';
const $2aff9a9dae44a870$export$60a7204fde4e6dc7 = {
    id: {
        label: '{{.ID}}',
        text: 'The ID of the alert'
    },
    name: {
        label: '{{.Name}}',
        text: 'Measurement name'
    },
    taskName: {
        label: '{{.TaskName}}',
        text: 'The name of the task'
    },
    group: {
        label: '{{.Group}}',
        text: 'Concatenation of all group-by tags of the form <code>&#91;key=value,&#93;+</code>. If no groupBy is performed equal to literal &quot;nil&quot;'
    },
    tags: {
        label: '{{.Tags}}',
        text: 'Map of tags.'
    },
    tag: {
        label: '{{ index .Tags "value" }}',
        text: 'A specific tag value'
    },
    level: {
        label: '{{.Level}}',
        text: 'Alert Level, one of: <code>INFO</code><code>WARNING</code><code>CRITICAL</code>'
    },
    fields: {
        label: '{{.Fields}}',
        text: 'Map of fields'
    },
    field: {
        label: '{{ index .Fields "value" }}',
        text: 'A specific field value'
    },
    time: {
        label: '{{.Time}}',
        text: 'The time of the point that triggered the event'
    },
    else: {
        label: '{{else}}',
        text: 'Start of else block'
    },
    end: {
        label: '{{end}}',
        text: 'End of block'
    }
};
const $2aff9a9dae44a870$export$fe077c000bf9de77 = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).map($2aff9a9dae44a870$export$60a7204fde4e6dc7, (t)=>{
    const label = t.label;
    const templateRegexp = /((?:{{)([^{}]+)(?:}}))/g // matches {{*}} where star does not contain '{' or '}'
    ;
    const match = templateRegexp.exec(label);
    return match[2].trim();
});
const $2aff9a9dae44a870$export$919ec570f8ddd5f3 = [
    {
        type: "post",
        enabled: true,
        url: '',
        headers: {},
        headerKey: '',
        headerValue: ''
    },
    {
        type: "tcp",
        enabled: true,
        address: ''
    },
    {
        type: "exec",
        enabled: true,
        command: []
    },
    {
        type: "log",
        enabled: true,
        filePath: ''
    }
];
const $2aff9a9dae44a870$export$86f0d6fad2354a02 = {
    opsgenie: 'opsGenie',
    opsgenie2: 'opsGenie2',
    pagerduty: 'pagerDuty',
    pagerduty2: 'pagerDuty2',
    smtp: 'email',
    victorops: 'victorOps',
    servicenow: 'serviceNow',
    bigpanda: 'bigPanda',
    teams: 'teams',
    zenoss: 'zenoss'
};
const $2aff9a9dae44a870$export$6f8a1490aabaf436 = {
    alerta: [
        'environment',
        'origin',
        'token'
    ],
    kafka: [
        'id'
    ],
    opsGenie: [
        'api-key',
        'teams',
        'recipients'
    ],
    opsGenie2: [
        'api-key',
        'teams',
        'recipients'
    ],
    pagerDuty: [
        'service-key'
    ],
    pagerDuty2: [
        'routing-key'
    ],
    pushover: [
        'token',
        'user-key'
    ],
    sensu: [
        'addr',
        'source'
    ],
    slack: [
        'url',
        'channel',
        'workspace'
    ],
    email: [
        'from',
        'host',
        'password',
        'port',
        'username'
    ],
    talk: [
        'url',
        'author_name'
    ],
    telegram: [
        'token',
        'chat-id',
        'parse-mode',
        'disable-web-page-preview',
        'disable-notification'
    ],
    victorOps: [
        'api-key',
        'routing-key'
    ],
    // snmpTrap: ['trapOid', 'data'], // [oid/type/value]
    // influxdb:[],
    // mqtt:[]
    serviceNow: [
        'url',
        'source',
        'username',
        'password'
    ],
    bigPanda: [
        'app-key'
    ],
    teams: [],
    zenoss: [
        'action',
        'method',
        '_type',
        'tid'
    ]
};
const $2aff9a9dae44a870$export$e5e1e7e16f25f098 = {
    alerta: {},
    opsGenie: {},
    opsGenie2: {},
    pagerDuty: {
        'service-key': 'serviceKey'
    },
    pagerDuty2: {
        'routing-key': 'routingKey'
    },
    pushover: {
        'user-key': 'userKey'
    },
    sensu: {},
    slack: {},
    email: {},
    talk: {},
    telegram: {
        'chat-id': 'chatId',
        'parse-mode': 'parseMode',
        'disable-web-page-preview': 'disableWebPagePreview',
        'disable-notification': 'disableNotification'
    },
    victorOps: {
        'routing-key': 'routingKey'
    },
    // snmpTrap: {},
    // influxd: {},
    // mqtt: {}
    serviceNow: {},
    bigPanda: {},
    teams: {},
    zenoss: {}
};
const $2aff9a9dae44a870$export$2def0f8fba1bcd69 = {
    alerta: [
        'resource',
        'event',
        'environment',
        'group',
        'value',
        'origin',
        'service'
    ],
    kafka: [
        'id',
        'cluster',
        'kafka-topic',
        'template'
    ],
    opsGenie: [
        'teams',
        'recipients'
    ],
    opsGenie2: [
        'teams',
        'recipients'
    ],
    pagerDuty: [],
    pagerDuty2: [],
    pushover: [
        'device',
        'title',
        'sound',
        'url',
        'urlTitle'
    ],
    sensu: [
        'source',
        'handlers'
    ],
    slack: [
        'channel',
        'username',
        'iconEmoji',
        'workspace'
    ],
    email: [
        'to'
    ],
    talk: [],
    telegram: [
        'chatId',
        'parseMode',
        'disableWebPagePreview',
        'disableNotification'
    ],
    victorOps: [
        'routingKey'
    ],
    post: [
        'url',
        'headers',
        'captureResponse'
    ],
    tcp: [
        'address'
    ],
    exec: [
        'command'
    ],
    log: [
        'filePath'
    ],
    // snmpTrap: ['trapOid', 'data'], // [oid/type/value]
    serviceNow: [
        'node',
        'resource',
        'metric_name',
        'message_key',
        'source',
        '_type'
    ],
    bigPanda: [
        'app-key',
        'primary-property',
        'secondary-property'
    ],
    teams: [
        'channel-url'
    ],
    zenoss: [
        'action',
        'method',
        '_type',
        'tid',
        'device',
        'component',
        'evclasskey',
        'evclass'
    ]
};


const $3bff70d0456af5c0$export$5f9bc633b116660f = ()=>{
    return (0, $a537743573e5e486$export$2e2bcd8739ae039)({
        url: null,
        resource: 'sources'
    });
};
const $3bff70d0456af5c0$export$dd2b6e807fb37ba3 = async (id)=>{
    const { data: source } = await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
        url: null,
        resource: 'sources',
        id: id
    });
    return source;
};
const $3bff70d0456af5c0$export$1921362e86c73c88 = async (attributes, params = {})=>{
    const { data: source } = await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
        url: null,
        resource: 'sources',
        method: 'POST',
        data: attributes,
        params: params
    });
    return source;
};
const $3bff70d0456af5c0$export$328b0edc9fda3a36 = async (newSource, params = {})=>{
    const { data: source } = await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
        url: newSource.links.self,
        method: 'PATCH',
        data: newSource,
        params: params
    });
    return source;
};
const $3bff70d0456af5c0$export$53d2b33f203103bf = (source)=>{
    return (0, $a537743573e5e486$export$2e2bcd8739ae039)({
        url: source.links.self,
        method: 'DELETE'
    });
};
const $3bff70d0456af5c0$export$41af5c3435cc7908 = async (kapacitor)=>{
    try {
        await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'GET',
            url: kapacitor.links.ping
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $3bff70d0456af5c0$export$c751af5d7f198354 = async (source, kapacitorID)=>{
    try {
        const { data: data } = await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            url: `${source.links.kapacitors}/${kapacitorID}`,
            method: 'GET'
        });
        return data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $3bff70d0456af5c0$export$82a2e3b7e5164c8a = async (source)=>{
    try {
        const { data: data } = await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            url: source.links.kapacitors,
            method: 'GET'
        });
        const activeKapacitor = data.kapacitors.find((k)=>k.active);
        return activeKapacitor || data.kapacitors[0];
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $3bff70d0456af5c0$export$c006b25b4b2674db = async (source)=>{
    try {
        const { data: { kapacitors: kapacitors } } = await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'GET',
            url: source.links.kapacitors
        });
        return kapacitors;
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $3bff70d0456af5c0$export$37ce3dbbabc847d2 = async (kapacitor)=>{
    try {
        await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'DELETE',
            url: kapacitor.links.self
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $3bff70d0456af5c0$export$3223cd8da62dca03 = (source, kapacitor)=>{
    const { url: url, name: name = 'New Kapacitor', username: username, password: password, insecureSkipVerify: insecureSkipVerify } = kapacitor;
    return (0, $a537743573e5e486$export$2e2bcd8739ae039)({
        url: source.links.kapacitors,
        method: 'POST',
        data: {
            name: name,
            url: url,
            username: username,
            password: password,
            insecureSkipVerify: insecureSkipVerify
        }
    });
};
const $3bff70d0456af5c0$export$aed6d6f44d1e4150 = ({ links: links, url: url, name: name = 'New Kapacitor', username: username, password: password, active: active, insecureSkipVerify: insecureSkipVerify })=>{
    return (0, $a537743573e5e486$export$2e2bcd8739ae039)({
        url: links.self,
        method: 'PATCH',
        data: {
            name: name,
            url: url,
            username: username,
            password: password,
            active: active,
            insecureSkipVerify: insecureSkipVerify
        }
    });
};
const $3bff70d0456af5c0$export$1bad164085925c74 = async (kapacitor)=>{
    try {
        return await $3bff70d0456af5c0$export$83fdb07039bec712(kapacitor, 'GET', '/kapacitor/v1/config', '');
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $3bff70d0456af5c0$export$3661c6b740b40a17 = (kapacitor, section)=>{
    return $3bff70d0456af5c0$export$83fdb07039bec712(kapacitor, 'GET', `/kapacitor/v1/config/${section}`, '');
};
const $3bff70d0456af5c0$export$95c4bfedf542511b = (kapacitor, section, properties, specificConfig)=>{
    const config = specificConfig || '';
    const path = `/kapacitor/v1/config/${section}/${config}`;
    const params = {
        method: 'POST',
        url: kapacitor.links.proxy,
        params: {
            path: path
        },
        data: {
            set: properties
        },
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return (0, $a537743573e5e486$export$2e2bcd8739ae039)(params);
};
const $3bff70d0456af5c0$export$93f16abed62a18d7 = (kapacitor, section, properties)=>{
    return (0, $a537743573e5e486$export$2e2bcd8739ae039)({
        method: 'POST',
        url: kapacitor.links.proxy,
        params: {
            path: `/kapacitor/v1/config/${section}/`
        },
        data: {
            add: properties
        },
        headers: {
            'Content-Type': 'application/json'
        }
    });
};
const $3bff70d0456af5c0$export$4ef4a9eab7a466d3 = (kapacitor, section, specificConfig)=>{
    const path = `/kapacitor/v1/config/${section}`;
    return (0, $a537743573e5e486$export$2e2bcd8739ae039)({
        method: 'POST',
        url: kapacitor.links.proxy,
        params: {
            path: path
        },
        data: {
            remove: [
                specificConfig
            ]
        },
        headers: {
            'Content-Type': 'application/json'
        }
    });
};
const $3bff70d0456af5c0$export$ed3a4ae2fb209f22 = async (kapacitor, outputName, options, specificConfigOptions)=>{
    try {
        const { data: { services: services } } = await $3bff70d0456af5c0$export$83fdb07039bec712(kapacitor, 'GET', '/kapacitor/v1/service-tests');
        const service = services.find((s)=>s.name === outputName);
        let body = {};
        if (options) body = options;
        else if (outputName === (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).slack) body = specificConfigOptions;
        return $3bff70d0456af5c0$export$83fdb07039bec712(kapacitor, 'POST', service.link.href, body);
    } catch (error) {
        console.error(error);
    }
};
const $3bff70d0456af5c0$export$82b5b7cb78251807 = async (kapacitor)=>{
    try {
        const { data: { services: services } } = await $3bff70d0456af5c0$export$83fdb07039bec712(kapacitor, 'GET', '/kapacitor/v1/service-tests');
        return services;
    } catch (error) {
        console.error(error);
    }
};
const $3bff70d0456af5c0$export$5ebbd06bea7d2966 = (kapacitor, id, type, dbrps, script)=>{
    return $3bff70d0456af5c0$export$83fdb07039bec712(kapacitor, 'POST', '/kapacitor/v1/tasks', {
        id: id,
        type: type,
        dbrps: dbrps,
        script: script,
        status: 'enabled'
    });
};
const $3bff70d0456af5c0$export$620dca5fd318a11d = (kapacitor, id)=>{
    return $3bff70d0456af5c0$export$83fdb07039bec712(kapacitor, 'PATCH', `/kapacitor/v1/tasks/${id}`, {
        status: 'enabled'
    });
};
const $3bff70d0456af5c0$export$90a34d72d522932a = (kapacitor, id)=>{
    return $3bff70d0456af5c0$export$83fdb07039bec712(kapacitor, 'PATCH', `/kapacitor/v1/tasks/${id}`, {
        status: 'disabled'
    });
};
const $3bff70d0456af5c0$export$ffc56c38653172f7 = (kapacitor, id)=>{
    return $3bff70d0456af5c0$export$83fdb07039bec712(kapacitor, 'DELETE', `/kapacitor/v1/tasks/${id}`, '');
};
const $3bff70d0456af5c0$export$83fdb07039bec712 = (kapacitor, method, path, body)=>{
    return (0, $a537743573e5e486$export$2e2bcd8739ae039)({
        method: method,
        url: kapacitor.links.proxy,
        params: {
            path: path
        },
        data: body
    });
};
const $3bff70d0456af5c0$export$24149453367e7e3c = async (url, queries)=>{
    try {
        const { data: data } = await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            url: url,
            method: 'POST',
            data: {
                queries: queries
            }
        });
        return data.queries;
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $3bff70d0456af5c0$export$fb88ec638e36f3fd = async (url, queries)=>{
    try {
        const { data: data } = await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            url: url,
            method: 'POST',
            data: {
                queries: queries
            }
        });
        return data.queries;
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $3bff70d0456af5c0$export$a009e3a1163d46fb = async (url)=>{
    try {
        const { data: data } = await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            url: url,
            method: 'GET'
        });
        return data.services;
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $3bff70d0456af5c0$export$3c3e04e1e7d315a1 = async (url, serviceID)=>{
    try {
        const { data: data } = await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            url: `${url}/${serviceID}`,
            method: 'GET'
        });
        return data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $3bff70d0456af5c0$export$9644c6e0cdbe671a = async (source, { url: url, name: name = 'My FluxD', type: type, username: username, password: password, insecureSkipVerify: insecureSkipVerify, metadata: metadata })=>{
    try {
        const { data: data } = await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            url: source.links.services,
            method: 'POST',
            data: {
                url: url,
                name: name,
                type: type,
                username: username,
                password: password,
                insecureSkipVerify: insecureSkipVerify,
                metadata: metadata
            }
        });
        return data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $3bff70d0456af5c0$export$a4c6e9a2ff052368 = async (service)=>{
    try {
        const { data: data } = await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            url: service.links.self,
            method: 'PATCH',
            data: service
        });
        return data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $3bff70d0456af5c0$export$41fc55b84ae9a2f4 = async (service)=>{
    try {
        await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            url: service.links.self,
            method: 'DELETE'
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
};



var $hBdgJ = parcelRequire("hBdgJ");


var $hBdgJ = parcelRequire("hBdgJ");

var $hBdgJ = parcelRequire("hBdgJ");
const $edbbd4040c42aaca$var$rnds8 = new Uint8Array(16);
function $edbbd4040c42aaca$export$2e2bcd8739ae039() {
    return crypto.getRandomValues($edbbd4040c42aaca$var$rnds8);
}


var $369c453e4c1fa6ed$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;


function $7c7a8724425e75e3$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $369c453e4c1fa6ed$export$2e2bcd8739ae039).test(uuid);
}
var $7c7a8724425e75e3$export$2e2bcd8739ae039 = $7c7a8724425e75e3$var$validate;


const $43130c7f15b27f65$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$43130c7f15b27f65$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $43130c7f15b27f65$export$8fb373d660548968(arr, offset = 0) {
    return ($43130c7f15b27f65$var$byteToHex[arr[offset + 0]] + $43130c7f15b27f65$var$byteToHex[arr[offset + 1]] + $43130c7f15b27f65$var$byteToHex[arr[offset + 2]] + $43130c7f15b27f65$var$byteToHex[arr[offset + 3]] + '-' + $43130c7f15b27f65$var$byteToHex[arr[offset + 4]] + $43130c7f15b27f65$var$byteToHex[arr[offset + 5]] + '-' + $43130c7f15b27f65$var$byteToHex[arr[offset + 6]] + $43130c7f15b27f65$var$byteToHex[arr[offset + 7]] + '-' + $43130c7f15b27f65$var$byteToHex[arr[offset + 8]] + $43130c7f15b27f65$var$byteToHex[arr[offset + 9]] + '-' + $43130c7f15b27f65$var$byteToHex[arr[offset + 10]] + $43130c7f15b27f65$var$byteToHex[arr[offset + 11]] + $43130c7f15b27f65$var$byteToHex[arr[offset + 12]] + $43130c7f15b27f65$var$byteToHex[arr[offset + 13]] + $43130c7f15b27f65$var$byteToHex[arr[offset + 14]] + $43130c7f15b27f65$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $43130c7f15b27f65$var$stringify(arr, offset = 0) {
    const uuid = $43130c7f15b27f65$export$8fb373d660548968(arr, offset);
    if (!(0, $7c7a8724425e75e3$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $43130c7f15b27f65$export$2e2bcd8739ae039 = $43130c7f15b27f65$var$stringify;


function $dbdc5944552afab7$var$v4(options, buf, offset) {
    if (!buf && !options && crypto.randomUUID) return crypto.randomUUID();
    return $dbdc5944552afab7$var$_v4(options, buf, offset);
}
function $dbdc5944552afab7$var$_v4(options, buf, offset) {
    options = options || {};
    const rnds = options.random ?? options.rng?.() ?? (0, $edbbd4040c42aaca$export$2e2bcd8739ae039)();
    if (rnds.length < 16) throw new Error('Random bytes length must be >= 16');
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $43130c7f15b27f65$export$8fb373d660548968)(rnds);
}
var $dbdc5944552afab7$export$2e2bcd8739ae039 = $dbdc5944552afab7$var$v4;


class $abfce34f6d695938$var$Deferred {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
}
var $abfce34f6d695938$export$2e2bcd8739ae039 = $abfce34f6d695938$var$Deferred;


var $24f476c448d52fa7$exports = {};

var $kavLi = parcelRequire("kavLi");

var $hlFxx = parcelRequire("hlFxx");
var $24f476c448d52fa7$require$EventEmitter = $hlFxx.EventEmitter;
var $e8c5e35396d7e7ed$exports = {};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $kavLi = parcelRequire("kavLi");
var $e8c5e35396d7e7ed$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $e8c5e35396d7e7ed$var$formatRegExp = /%[sdj%]/g;
$e8c5e35396d7e7ed$exports.format = function(f) {
    if (!$e8c5e35396d7e7ed$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($e8c5e35396d7e7ed$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($e8c5e35396d7e7ed$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($e8c5e35396d7e7ed$var$isNull(x) || !$e8c5e35396d7e7ed$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $e8c5e35396d7e7ed$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
$e8c5e35396d7e7ed$exports.deprecate = function(fn, msg) {
    var warned;
    return function() {
        return $e8c5e35396d7e7ed$exports.deprecate(fn, msg).apply(this, arguments);
    };
    function deprecated() {
        if (!warned) {
            if ($kavLi.throwDeprecation) throw new Error(msg);
            else if ($kavLi.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
};
var $e8c5e35396d7e7ed$var$debugs = {};
var $e8c5e35396d7e7ed$var$debugEnvRegex = /^$/;
var $e8c5e35396d7e7ed$var$debugEnv;
$e8c5e35396d7e7ed$exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$e8c5e35396d7e7ed$var$debugs[set]) {
        if ($e8c5e35396d7e7ed$var$debugEnvRegex.test(set)) {
            var pid = $kavLi.pid;
            $e8c5e35396d7e7ed$var$debugs[set] = function() {
                var msg = $e8c5e35396d7e7ed$exports.format.apply($e8c5e35396d7e7ed$exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $e8c5e35396d7e7ed$var$debugs[set] = function() {};
    }
    return $e8c5e35396d7e7ed$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $e8c5e35396d7e7ed$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $e8c5e35396d7e7ed$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($e8c5e35396d7e7ed$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    $e8c5e35396d7e7ed$exports._extend(ctx, opts);
    // set default options
    if ($e8c5e35396d7e7ed$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($e8c5e35396d7e7ed$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($e8c5e35396d7e7ed$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($e8c5e35396d7e7ed$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $e8c5e35396d7e7ed$var$stylizeWithColor;
    return $e8c5e35396d7e7ed$var$formatValue(ctx, obj, ctx.depth);
}
$e8c5e35396d7e7ed$exports.inspect = $e8c5e35396d7e7ed$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$e8c5e35396d7e7ed$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$e8c5e35396d7e7ed$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $e8c5e35396d7e7ed$var$stylizeWithColor(str, styleType) {
    var style = $e8c5e35396d7e7ed$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $e8c5e35396d7e7ed$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $e8c5e35396d7e7ed$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $e8c5e35396d7e7ed$var$stylizeNoColor(str, styleType) {
    return str;
}
function $e8c5e35396d7e7ed$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $e8c5e35396d7e7ed$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $e8c5e35396d7e7ed$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== $e8c5e35396d7e7ed$exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$e8c5e35396d7e7ed$var$isString(ret)) ret = $e8c5e35396d7e7ed$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $e8c5e35396d7e7ed$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $e8c5e35396d7e7ed$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($e8c5e35396d7e7ed$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $e8c5e35396d7e7ed$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($e8c5e35396d7e7ed$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($e8c5e35396d7e7ed$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($e8c5e35396d7e7ed$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($e8c5e35396d7e7ed$var$isError(value)) return $e8c5e35396d7e7ed$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($e8c5e35396d7e7ed$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($e8c5e35396d7e7ed$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($e8c5e35396d7e7ed$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($e8c5e35396d7e7ed$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($e8c5e35396d7e7ed$var$isError(value)) base = ' ' + $e8c5e35396d7e7ed$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($e8c5e35396d7e7ed$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $e8c5e35396d7e7ed$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $e8c5e35396d7e7ed$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $e8c5e35396d7e7ed$var$reduceToSingleString(output, base, braces);
}
function $e8c5e35396d7e7ed$var$formatPrimitive(ctx, value) {
    if ($e8c5e35396d7e7ed$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($e8c5e35396d7e7ed$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($e8c5e35396d7e7ed$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($e8c5e35396d7e7ed$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($e8c5e35396d7e7ed$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $e8c5e35396d7e7ed$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $e8c5e35396d7e7ed$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($e8c5e35396d7e7ed$var$hasOwnProperty(value, String(i))) output.push($e8c5e35396d7e7ed$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($e8c5e35396d7e7ed$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $e8c5e35396d7e7ed$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$e8c5e35396d7e7ed$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($e8c5e35396d7e7ed$var$isNull(recurseTimes)) str = $e8c5e35396d7e7ed$var$formatValue(ctx, desc.value, null);
            else str = $e8c5e35396d7e7ed$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($e8c5e35396d7e7ed$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $e8c5e35396d7e7ed$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
$e8c5e35396d7e7ed$exports.types = (parcelRequire("9rz1O"));
function $e8c5e35396d7e7ed$var$isArray(ar) {
    return Array.isArray(ar);
}
$e8c5e35396d7e7ed$exports.isArray = $e8c5e35396d7e7ed$var$isArray;
function $e8c5e35396d7e7ed$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
$e8c5e35396d7e7ed$exports.isBoolean = $e8c5e35396d7e7ed$var$isBoolean;
function $e8c5e35396d7e7ed$var$isNull(arg) {
    return arg === null;
}
$e8c5e35396d7e7ed$exports.isNull = $e8c5e35396d7e7ed$var$isNull;
function $e8c5e35396d7e7ed$var$isNullOrUndefined(arg) {
    return arg == null;
}
$e8c5e35396d7e7ed$exports.isNullOrUndefined = $e8c5e35396d7e7ed$var$isNullOrUndefined;
function $e8c5e35396d7e7ed$var$isNumber(arg) {
    return typeof arg === 'number';
}
$e8c5e35396d7e7ed$exports.isNumber = $e8c5e35396d7e7ed$var$isNumber;
function $e8c5e35396d7e7ed$var$isString(arg) {
    return typeof arg === 'string';
}
$e8c5e35396d7e7ed$exports.isString = $e8c5e35396d7e7ed$var$isString;
function $e8c5e35396d7e7ed$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
$e8c5e35396d7e7ed$exports.isSymbol = $e8c5e35396d7e7ed$var$isSymbol;
function $e8c5e35396d7e7ed$var$isUndefined(arg) {
    return arg === void 0;
}
$e8c5e35396d7e7ed$exports.isUndefined = $e8c5e35396d7e7ed$var$isUndefined;
function $e8c5e35396d7e7ed$var$isRegExp(re) {
    return $e8c5e35396d7e7ed$var$isObject(re) && $e8c5e35396d7e7ed$var$objectToString(re) === '[object RegExp]';
}
$e8c5e35396d7e7ed$exports.isRegExp = $e8c5e35396d7e7ed$var$isRegExp;
$e8c5e35396d7e7ed$exports.types.isRegExp = $e8c5e35396d7e7ed$var$isRegExp;
function $e8c5e35396d7e7ed$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
$e8c5e35396d7e7ed$exports.isObject = $e8c5e35396d7e7ed$var$isObject;
function $e8c5e35396d7e7ed$var$isDate(d) {
    return $e8c5e35396d7e7ed$var$isObject(d) && $e8c5e35396d7e7ed$var$objectToString(d) === '[object Date]';
}
$e8c5e35396d7e7ed$exports.isDate = $e8c5e35396d7e7ed$var$isDate;
$e8c5e35396d7e7ed$exports.types.isDate = $e8c5e35396d7e7ed$var$isDate;
function $e8c5e35396d7e7ed$var$isError(e) {
    return $e8c5e35396d7e7ed$var$isObject(e) && ($e8c5e35396d7e7ed$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
$e8c5e35396d7e7ed$exports.isError = $e8c5e35396d7e7ed$var$isError;
$e8c5e35396d7e7ed$exports.types.isNativeError = $e8c5e35396d7e7ed$var$isError;
function $e8c5e35396d7e7ed$var$isFunction(arg) {
    return typeof arg === 'function';
}
$e8c5e35396d7e7ed$exports.isFunction = $e8c5e35396d7e7ed$var$isFunction;
function $e8c5e35396d7e7ed$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
$e8c5e35396d7e7ed$exports.isPrimitive = $e8c5e35396d7e7ed$var$isPrimitive;

$e8c5e35396d7e7ed$exports.isBuffer = (parcelRequire("lw0MU"));
function $e8c5e35396d7e7ed$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $e8c5e35396d7e7ed$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $e8c5e35396d7e7ed$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $e8c5e35396d7e7ed$var$timestamp() {
    var d = new Date();
    var time = [
        $e8c5e35396d7e7ed$var$pad(d.getHours()),
        $e8c5e35396d7e7ed$var$pad(d.getMinutes()),
        $e8c5e35396d7e7ed$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $e8c5e35396d7e7ed$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
$e8c5e35396d7e7ed$exports.log = function() {
    console.log('%s - %s', $e8c5e35396d7e7ed$var$timestamp(), $e8c5e35396d7e7ed$exports.format.apply($e8c5e35396d7e7ed$exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ $e8c5e35396d7e7ed$exports.inherits = (parcelRequire("e10SE"));
$e8c5e35396d7e7ed$exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$e8c5e35396d7e7ed$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $e8c5e35396d7e7ed$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $e8c5e35396d7e7ed$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
$e8c5e35396d7e7ed$exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($e8c5e35396d7e7ed$var$kCustomPromisifiedSymbol && original[$e8c5e35396d7e7ed$var$kCustomPromisifiedSymbol]) {
        var fn = original[$e8c5e35396d7e7ed$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $e8c5e35396d7e7ed$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($e8c5e35396d7e7ed$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $e8c5e35396d7e7ed$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $e8c5e35396d7e7ed$var$getOwnPropertyDescriptors(original));
};
$e8c5e35396d7e7ed$exports.promisify.custom = $e8c5e35396d7e7ed$var$kCustomPromisifiedSymbol;
function $e8c5e35396d7e7ed$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $e8c5e35396d7e7ed$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $kavLi.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $kavLi.nextTick($e8c5e35396d7e7ed$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $e8c5e35396d7e7ed$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
$e8c5e35396d7e7ed$exports.callbackify = $e8c5e35396d7e7ed$var$callbackify;


var $24f476c448d52fa7$require$inherits = $e8c5e35396d7e7ed$exports.inherits;

var $br7jT = parcelRequire("br7jT");
var $d52bfb195e626628$exports = {};
var $f879591cfb1b6c8d$export$b7d0b0b6bf88e01c;
var $f879591cfb1b6c8d$export$bddce72536e51c3d;
var $f879591cfb1b6c8d$export$b7cc577567d0e62c;

$f879591cfb1b6c8d$export$b7d0b0b6bf88e01c = (parcelRequire("6acZf"));

$f879591cfb1b6c8d$export$bddce72536e51c3d = (parcelRequire("a1zeg"));

$f879591cfb1b6c8d$export$b7cc577567d0e62c = (parcelRequire("jV4kG"));


var $d52bfb195e626628$require$AbstractLevelDOWN = $f879591cfb1b6c8d$export$b7d0b0b6bf88e01c;

var $e10SE = parcelRequire("e10SE");
var $a2f3c7ceeac28fdf$exports = {};

var $a2f3c7ceeac28fdf$require$AbstractIterator = $f879591cfb1b6c8d$export$bddce72536e51c3d;

var $e10SE = parcelRequire("e10SE");
function $a2f3c7ceeac28fdf$var$DeferredIterator(options) {
    $a2f3c7ceeac28fdf$require$AbstractIterator.call(this, options);
    this._options = options;
    this._iterator = null;
    this._operations = [];
}
$e10SE($a2f3c7ceeac28fdf$var$DeferredIterator, $a2f3c7ceeac28fdf$require$AbstractIterator);
$a2f3c7ceeac28fdf$var$DeferredIterator.prototype.setDb = function(db) {
    var it = this._iterator = db.iterator(this._options);
    this._operations.forEach(function(op) {
        it[op.method].apply(it, op.args);
    });
};
$a2f3c7ceeac28fdf$var$DeferredIterator.prototype._operation = function(method, args) {
    if (this._iterator) return this._iterator[method].apply(this._iterator, args);
    this._operations.push({
        method: method,
        args: args
    });
};
'next end'.split(' ').forEach(function(m) {
    $a2f3c7ceeac28fdf$var$DeferredIterator.prototype['_' + m] = function() {
        this._operation(m, arguments);
    };
});
$a2f3c7ceeac28fdf$exports = $a2f3c7ceeac28fdf$var$DeferredIterator;


var $d52bfb195e626628$var$deferrables = 'put get del batch'.split(' ');
function $d52bfb195e626628$var$DeferredLevelDOWN(db) {
    $d52bfb195e626628$require$AbstractLevelDOWN.call(this, '');
    this._db = db;
    this._operations = [];
    this._iterators = [];
    $d52bfb195e626628$var$closed(this);
}
$e10SE($d52bfb195e626628$var$DeferredLevelDOWN, $d52bfb195e626628$require$AbstractLevelDOWN);
$d52bfb195e626628$var$DeferredLevelDOWN.prototype._open = function(options, callback) {
    var self = this;
    this._db.open(options, function(err) {
        if (err) return callback(err);
        self._operations.forEach(function(op) {
            self._db[op.method].apply(self._db, op.args);
        });
        self._operations = [];
        self._iterators.forEach(function(it) {
            it.setDb(self._db);
        });
        self._iterators = [];
        $d52bfb195e626628$var$open(self);
        callback();
    });
};
$d52bfb195e626628$var$DeferredLevelDOWN.prototype._close = function(callback) {
    var self = this;
    this._db.close(function(err) {
        if (err) return callback(err);
        $d52bfb195e626628$var$closed(self);
        callback();
    });
};
function $d52bfb195e626628$var$open(self) {
    $d52bfb195e626628$var$deferrables.concat('iterator').forEach(function(m) {
        self['_' + m] = function() {
            return this._db[m].apply(this._db, arguments);
        };
    });
    if (self._db.approximateSize) self.approximateSize = function() {
        return this._db.approximateSize.apply(this._db, arguments);
    };
}
function $d52bfb195e626628$var$closed(self) {
    $d52bfb195e626628$var$deferrables.forEach(function(m) {
        self['_' + m] = function() {
            this._operations.push({
                method: m,
                args: arguments
            });
        };
    });
    if (typeof self._db.approximateSize === 'function') self.approximateSize = function() {
        this._operations.push({
            method: 'approximateSize',
            args: arguments
        });
    };
    self._iterator = function(options) {
        var it = new $a2f3c7ceeac28fdf$exports(options);
        this._iterators.push(it);
        return it;
    };
}
$d52bfb195e626628$var$DeferredLevelDOWN.prototype._serializeKey = function(key) {
    return key;
};
$d52bfb195e626628$var$DeferredLevelDOWN.prototype._serializeValue = function(value) {
    return value;
};
$d52bfb195e626628$exports = $d52bfb195e626628$var$DeferredLevelDOWN;
$d52bfb195e626628$exports.DeferredIterator = $a2f3c7ceeac28fdf$exports;


var $45f698af47b4db7c$exports = {};

var $kavLi = parcelRequire("kavLi");

var $e10SE = parcelRequire("e10SE");

var $cyzRy = parcelRequire("cyzRy");
var $45f698af47b4db7c$require$Readable = $cyzRy.Readable;

var $br7jT = parcelRequire("br7jT");
$45f698af47b4db7c$exports = $45f698af47b4db7c$var$ReadStream;
$e10SE($45f698af47b4db7c$var$ReadStream, $45f698af47b4db7c$require$Readable);
function $45f698af47b4db7c$var$ReadStream(iterator, options) {
    if (!(this instanceof $45f698af47b4db7c$var$ReadStream)) return new $45f698af47b4db7c$var$ReadStream(iterator, options);
    options = options || {};
    $45f698af47b4db7c$require$Readable.call(this, $br7jT(options, {
        objectMode: true
    }));
    this._iterator = iterator;
    this._options = options;
    this.on('end', this.destroy.bind(this, null, null));
}
$45f698af47b4db7c$var$ReadStream.prototype._read = function() {
    var self = this;
    var options = this._options;
    if (this.destroyed) return;
    this._iterator.next(function(err, key, value) {
        if (self.destroyed) return;
        if (err) return self.destroy(err);
        if (key === undefined && value === undefined) self.push(null);
        else if (options.keys !== false && options.values === false) self.push(key);
        else if (options.keys === false && options.values !== false) self.push(value);
        else self.push({
            key: key,
            value: value
        });
    });
};
$45f698af47b4db7c$var$ReadStream.prototype._destroy = function(err, callback) {
    var self = this;
    this._iterator.end(function(err2) {
        callback(err || err2);
        // TODO when the next readable-stream (mirroring node v10) is out:
        // remove this. Since nodejs/node#19836, streams always emit close.
        $kavLi.nextTick(function() {
            self.emit('close');
        });
    });
};


var $2563713cb0389795$exports = {};
var $a555ffa520e4ee49$exports = {};
var $2d3fa13191088e44$exports = {};
var $2d3fa13191088e44$var$all = $2d3fa13191088e44$exports.all = [
    {
        errno: -2,
        code: 'ENOENT',
        description: 'no such file or directory'
    },
    {
        errno: -1,
        code: 'UNKNOWN',
        description: 'unknown error'
    },
    {
        errno: 0,
        code: 'OK',
        description: 'success'
    },
    {
        errno: 1,
        code: 'EOF',
        description: 'end of file'
    },
    {
        errno: 2,
        code: 'EADDRINFO',
        description: 'getaddrinfo error'
    },
    {
        errno: 3,
        code: 'EACCES',
        description: 'permission denied'
    },
    {
        errno: 4,
        code: 'EAGAIN',
        description: 'resource temporarily unavailable'
    },
    {
        errno: 5,
        code: 'EADDRINUSE',
        description: 'address already in use'
    },
    {
        errno: 6,
        code: 'EADDRNOTAVAIL',
        description: 'address not available'
    },
    {
        errno: 7,
        code: 'EAFNOSUPPORT',
        description: 'address family not supported'
    },
    {
        errno: 8,
        code: 'EALREADY',
        description: 'connection already in progress'
    },
    {
        errno: 9,
        code: 'EBADF',
        description: 'bad file descriptor'
    },
    {
        errno: 10,
        code: 'EBUSY',
        description: 'resource busy or locked'
    },
    {
        errno: 11,
        code: 'ECONNABORTED',
        description: 'software caused connection abort'
    },
    {
        errno: 12,
        code: 'ECONNREFUSED',
        description: 'connection refused'
    },
    {
        errno: 13,
        code: 'ECONNRESET',
        description: 'connection reset by peer'
    },
    {
        errno: 14,
        code: 'EDESTADDRREQ',
        description: 'destination address required'
    },
    {
        errno: 15,
        code: 'EFAULT',
        description: 'bad address in system call argument'
    },
    {
        errno: 16,
        code: 'EHOSTUNREACH',
        description: 'host is unreachable'
    },
    {
        errno: 17,
        code: 'EINTR',
        description: 'interrupted system call'
    },
    {
        errno: 18,
        code: 'EINVAL',
        description: 'invalid argument'
    },
    {
        errno: 19,
        code: 'EISCONN',
        description: 'socket is already connected'
    },
    {
        errno: 20,
        code: 'EMFILE',
        description: 'too many open files'
    },
    {
        errno: 21,
        code: 'EMSGSIZE',
        description: 'message too long'
    },
    {
        errno: 22,
        code: 'ENETDOWN',
        description: 'network is down'
    },
    {
        errno: 23,
        code: 'ENETUNREACH',
        description: 'network is unreachable'
    },
    {
        errno: 24,
        code: 'ENFILE',
        description: 'file table overflow'
    },
    {
        errno: 25,
        code: 'ENOBUFS',
        description: 'no buffer space available'
    },
    {
        errno: 26,
        code: 'ENOMEM',
        description: 'not enough memory'
    },
    {
        errno: 27,
        code: 'ENOTDIR',
        description: 'not a directory'
    },
    {
        errno: 28,
        code: 'EISDIR',
        description: 'illegal operation on a directory'
    },
    {
        errno: 29,
        code: 'ENONET',
        description: 'machine is not on the network'
    },
    {
        errno: 31,
        code: 'ENOTCONN',
        description: 'socket is not connected'
    },
    {
        errno: 32,
        code: 'ENOTSOCK',
        description: 'socket operation on non-socket'
    },
    {
        errno: 33,
        code: 'ENOTSUP',
        description: 'operation not supported on socket'
    },
    {
        errno: 34,
        code: 'ENOENT',
        description: 'no such file or directory'
    },
    {
        errno: 35,
        code: 'ENOSYS',
        description: 'function not implemented'
    },
    {
        errno: 36,
        code: 'EPIPE',
        description: 'broken pipe'
    },
    {
        errno: 37,
        code: 'EPROTO',
        description: 'protocol error'
    },
    {
        errno: 38,
        code: 'EPROTONOSUPPORT',
        description: 'protocol not supported'
    },
    {
        errno: 39,
        code: 'EPROTOTYPE',
        description: 'protocol wrong type for socket'
    },
    {
        errno: 40,
        code: 'ETIMEDOUT',
        description: 'connection timed out'
    },
    {
        errno: 41,
        code: 'ECHARSET',
        description: 'invalid Unicode character'
    },
    {
        errno: 42,
        code: 'EAIFAMNOSUPPORT',
        description: 'address family for hostname not supported'
    },
    {
        errno: 44,
        code: 'EAISERVICE',
        description: 'servname not supported for ai_socktype'
    },
    {
        errno: 45,
        code: 'EAISOCKTYPE',
        description: 'ai_socktype not supported'
    },
    {
        errno: 46,
        code: 'ESHUTDOWN',
        description: 'cannot send after transport endpoint shutdown'
    },
    {
        errno: 47,
        code: 'EEXIST',
        description: 'file already exists'
    },
    {
        errno: 48,
        code: 'ESRCH',
        description: 'no such process'
    },
    {
        errno: 49,
        code: 'ENAMETOOLONG',
        description: 'name too long'
    },
    {
        errno: 50,
        code: 'EPERM',
        description: 'operation not permitted'
    },
    {
        errno: 51,
        code: 'ELOOP',
        description: 'too many symbolic links encountered'
    },
    {
        errno: 52,
        code: 'EXDEV',
        description: 'cross-device link not permitted'
    },
    {
        errno: 53,
        code: 'ENOTEMPTY',
        description: 'directory not empty'
    },
    {
        errno: 54,
        code: 'ENOSPC',
        description: 'no space left on device'
    },
    {
        errno: 55,
        code: 'EIO',
        description: 'i/o error'
    },
    {
        errno: 56,
        code: 'EROFS',
        description: 'read-only file system'
    },
    {
        errno: 57,
        code: 'ENODEV',
        description: 'no such device'
    },
    {
        errno: 58,
        code: 'ESPIPE',
        description: 'invalid seek'
    },
    {
        errno: 59,
        code: 'ECANCELED',
        description: 'operation canceled'
    }
];
$2d3fa13191088e44$exports.errno = {};
$2d3fa13191088e44$exports.code = {};
$2d3fa13191088e44$var$all.forEach(function(error) {
    $2d3fa13191088e44$exports.errno[error.errno] = error;
    $2d3fa13191088e44$exports.code[error.code] = error;
});

$2d3fa13191088e44$exports.custom = (parcelRequire("iUF7U"))($2d3fa13191088e44$exports);
$2d3fa13191088e44$exports.create = $2d3fa13191088e44$exports.custom.createError;


var $a555ffa520e4ee49$require$createError = $2d3fa13191088e44$exports.create;
var $a555ffa520e4ee49$var$LevelUPError = $a555ffa520e4ee49$require$createError('LevelUPError');
var $a555ffa520e4ee49$var$NotFoundError = $a555ffa520e4ee49$require$createError('NotFoundError', $a555ffa520e4ee49$var$LevelUPError);
$a555ffa520e4ee49$var$NotFoundError.prototype.notFound = true;
$a555ffa520e4ee49$var$NotFoundError.prototype.status = 404;
$a555ffa520e4ee49$exports = {
    LevelUPError: $a555ffa520e4ee49$var$LevelUPError,
    InitializationError: $a555ffa520e4ee49$require$createError('InitializationError', $a555ffa520e4ee49$var$LevelUPError),
    OpenError: $a555ffa520e4ee49$require$createError('OpenError', $a555ffa520e4ee49$var$LevelUPError),
    ReadError: $a555ffa520e4ee49$require$createError('ReadError', $a555ffa520e4ee49$var$LevelUPError),
    WriteError: $a555ffa520e4ee49$require$createError('WriteError', $a555ffa520e4ee49$var$LevelUPError),
    NotFoundError: $a555ffa520e4ee49$var$NotFoundError,
    EncodingError: $a555ffa520e4ee49$require$createError('EncodingError', $a555ffa520e4ee49$var$LevelUPError)
};


var $2563713cb0389795$require$WriteError = $a555ffa520e4ee49$exports.WriteError;
var $e184e84a78c8058e$exports = {};
function $e184e84a78c8058e$var$promisify() {
    var callback;
    var promise = new Promise(function(resolve, reject) {
        callback = function callback(err, value) {
            if (err) reject(err);
            else resolve(value);
        };
    });
    callback.promise = promise;
    return callback;
}
$e184e84a78c8058e$exports = $e184e84a78c8058e$var$promisify;


var $9af2bfc4aad1166f$export$2a88462d58de88be;
var $9af2bfc4aad1166f$export$d2312e68e1f5ad00;
$9af2bfc4aad1166f$export$2a88462d58de88be = function(options, callback) {
    return typeof options === 'function' ? options : callback;
};
$9af2bfc4aad1166f$export$d2312e68e1f5ad00 = function(options) {
    return typeof options === 'object' && options !== null ? options : {};
};


var $2563713cb0389795$require$getCallback = $9af2bfc4aad1166f$export$2a88462d58de88be;

var $2563713cb0389795$require$getOptions = $9af2bfc4aad1166f$export$d2312e68e1f5ad00;
function $2563713cb0389795$var$Batch(levelup) {
    this._levelup = levelup;
    this.batch = levelup.db.batch();
    this.ops = [];
    this.length = 0;
}
$2563713cb0389795$var$Batch.prototype.put = function(key, value) {
    try {
        this.batch.put(key, value);
    } catch (e) {
        throw new $2563713cb0389795$require$WriteError(e);
    }
    this.ops.push({
        type: 'put',
        key: key,
        value: value
    });
    this.length++;
    return this;
};
$2563713cb0389795$var$Batch.prototype.del = function(key) {
    try {
        this.batch.del(key);
    } catch (err) {
        throw new $2563713cb0389795$require$WriteError(err);
    }
    this.ops.push({
        type: 'del',
        key: key
    });
    this.length++;
    return this;
};
$2563713cb0389795$var$Batch.prototype.clear = function() {
    try {
        this.batch.clear();
    } catch (err) {
        throw new $2563713cb0389795$require$WriteError(err);
    }
    this.ops = [];
    this.length = 0;
    return this;
};
$2563713cb0389795$var$Batch.prototype.write = function(options, callback) {
    var levelup = this._levelup;
    var ops = this.ops;
    var promise;
    callback = $2563713cb0389795$require$getCallback(options, callback);
    if (!callback) {
        callback = $e184e84a78c8058e$exports();
        promise = callback.promise;
    }
    options = $2563713cb0389795$require$getOptions(options);
    try {
        this.batch.write(options, function(err) {
            if (err) return callback(new $2563713cb0389795$require$WriteError(err));
            levelup.emit('batch', ops);
            callback();
        });
    } catch (err) {
        throw new $2563713cb0389795$require$WriteError(err);
    }
    return promise;
};
$2563713cb0389795$exports = $2563713cb0389795$var$Batch;




var $iUbla = parcelRequire("iUbla");


var $24f476c448d52fa7$require$getCallback = $9af2bfc4aad1166f$export$2a88462d58de88be;

var $24f476c448d52fa7$require$getOptions = $9af2bfc4aad1166f$export$d2312e68e1f5ad00;
var $24f476c448d52fa7$var$WriteError = $a555ffa520e4ee49$exports.WriteError;
var $24f476c448d52fa7$var$ReadError = $a555ffa520e4ee49$exports.ReadError;
var $24f476c448d52fa7$var$NotFoundError = $a555ffa520e4ee49$exports.NotFoundError;
var $24f476c448d52fa7$var$OpenError = $a555ffa520e4ee49$exports.OpenError;
var $24f476c448d52fa7$var$InitializationError = $a555ffa520e4ee49$exports.InitializationError;
// Possible AbstractLevelDOWN#status values:
//  - 'new'     - newly created, not opened or closed
//  - 'opening' - waiting for the database to be opened, post open()
//  - 'open'    - successfully opened the database, available for use
//  - 'closing' - waiting for the database to be closed, post close()
//  - 'closed'  - database has been successfully closed, should not be
//                 used except for another open() operation
function $24f476c448d52fa7$var$LevelUP(db, options, callback) {
    if (!(this instanceof $24f476c448d52fa7$var$LevelUP)) return new $24f476c448d52fa7$var$LevelUP(db, options, callback);
    var error;
    $24f476c448d52fa7$require$EventEmitter.call(this);
    this.setMaxListeners(Infinity);
    if (typeof options === 'function') {
        callback = options;
        options = {};
    }
    options = options || {};
    if (!db || typeof db !== 'object') {
        error = new $24f476c448d52fa7$var$InitializationError('First argument must be an abstract-leveldown compliant store');
        if (typeof callback === 'function') return $kavLi.nextTick(callback, error);
        throw error;
    }
    $iUbla.equal(typeof db.status, 'string', '.status required, old abstract-leveldown');
    this.options = $24f476c448d52fa7$require$getOptions(options);
    this._db = db;
    this.db = new $d52bfb195e626628$exports(db);
    this.open(callback);
}
$24f476c448d52fa7$var$LevelUP.prototype.emit = $24f476c448d52fa7$require$EventEmitter.prototype.emit;
$24f476c448d52fa7$var$LevelUP.prototype.once = $24f476c448d52fa7$require$EventEmitter.prototype.once;
$24f476c448d52fa7$require$inherits($24f476c448d52fa7$var$LevelUP, $24f476c448d52fa7$require$EventEmitter);
$24f476c448d52fa7$var$LevelUP.prototype.open = function(callback) {
    var self = this;
    var promise;
    if (!callback) {
        callback = $e184e84a78c8058e$exports();
        promise = callback.promise;
    }
    if (this.isOpen()) {
        $kavLi.nextTick(callback, null, self);
        return promise;
    }
    if (this._isOpening()) {
        this.once('open', function() {
            callback(null, self);
        });
        return promise;
    }
    this.emit('opening');
    this.db.open(this.options, function(err) {
        if (err) return callback(new $24f476c448d52fa7$var$OpenError(err));
        self.db = self._db;
        callback(null, self);
        self.emit('open');
        self.emit('ready');
    });
    return promise;
};
$24f476c448d52fa7$var$LevelUP.prototype.close = function(callback) {
    var self = this;
    var promise;
    if (!callback) {
        callback = $e184e84a78c8058e$exports();
        promise = callback.promise;
    }
    if (this.isOpen()) {
        this.db.close(function() {
            self.emit('closed');
            callback.apply(null, arguments);
        });
        this.emit('closing');
        this.db = new $d52bfb195e626628$exports(this._db);
    } else if (this.isClosed()) $kavLi.nextTick(callback);
    else if (this.db.status === 'closing') this.once('closed', callback);
    else if (this._isOpening()) this.once('open', function() {
        self.close(callback);
    });
    return promise;
};
$24f476c448d52fa7$var$LevelUP.prototype.isOpen = function() {
    return this.db.status === 'open';
};
$24f476c448d52fa7$var$LevelUP.prototype._isOpening = function() {
    return this.db.status === 'opening';
};
$24f476c448d52fa7$var$LevelUP.prototype.isClosed = function() {
    return /^clos|new/.test(this.db.status);
};
$24f476c448d52fa7$var$LevelUP.prototype.get = function(key, options, callback) {
    if (key === null || key === undefined) throw new $24f476c448d52fa7$var$ReadError('get() requires a key argument');
    var promise;
    callback = $24f476c448d52fa7$require$getCallback(options, callback);
    if (!callback) {
        callback = $e184e84a78c8058e$exports();
        promise = callback.promise;
    }
    if ($24f476c448d52fa7$var$maybeError(this, callback)) return promise;
    options = $24f476c448d52fa7$require$getOptions(options);
    this.db.get(key, options, function(err, value) {
        if (err) {
            if (/notfound/i.test(err) || err.notFound) err = new $24f476c448d52fa7$var$NotFoundError('Key not found in database [' + key + ']', err);
            else err = new $24f476c448d52fa7$var$ReadError(err);
            return callback(err);
        }
        callback(null, value);
    });
    return promise;
};
$24f476c448d52fa7$var$LevelUP.prototype.put = function(key, value, options, callback) {
    if (key === null || key === undefined) throw new $24f476c448d52fa7$var$WriteError('put() requires a key argument');
    var self = this;
    var promise;
    callback = $24f476c448d52fa7$require$getCallback(options, callback);
    if (!callback) {
        callback = $e184e84a78c8058e$exports();
        promise = callback.promise;
    }
    if ($24f476c448d52fa7$var$maybeError(this, callback)) return promise;
    options = $24f476c448d52fa7$require$getOptions(options);
    this.db.put(key, value, options, function(err) {
        if (err) return callback(new $24f476c448d52fa7$var$WriteError(err));
        self.emit('put', key, value);
        callback();
    });
    return promise;
};
$24f476c448d52fa7$var$LevelUP.prototype.del = function(key, options, callback) {
    if (key === null || key === undefined) throw new $24f476c448d52fa7$var$WriteError('del() requires a key argument');
    var self = this;
    var promise;
    callback = $24f476c448d52fa7$require$getCallback(options, callback);
    if (!callback) {
        callback = $e184e84a78c8058e$exports();
        promise = callback.promise;
    }
    if ($24f476c448d52fa7$var$maybeError(this, callback)) return promise;
    options = $24f476c448d52fa7$require$getOptions(options);
    this.db.del(key, options, function(err) {
        if (err) return callback(new $24f476c448d52fa7$var$WriteError(err));
        self.emit('del', key);
        callback();
    });
    return promise;
};
$24f476c448d52fa7$var$LevelUP.prototype.batch = function(arr, options, callback) {
    if (!arguments.length) return new $2563713cb0389795$exports(this);
    if (!Array.isArray(arr)) throw new $24f476c448d52fa7$var$WriteError('batch() requires an array argument');
    var self = this;
    var promise;
    callback = $24f476c448d52fa7$require$getCallback(options, callback);
    if (!callback) {
        callback = $e184e84a78c8058e$exports();
        promise = callback.promise;
    }
    if ($24f476c448d52fa7$var$maybeError(this, callback)) return promise;
    options = $24f476c448d52fa7$require$getOptions(options);
    this.db.batch(arr, options, function(err) {
        if (err) return callback(new $24f476c448d52fa7$var$WriteError(err));
        self.emit('batch', arr);
        callback();
    });
    return promise;
};
$24f476c448d52fa7$var$LevelUP.prototype.iterator = function(options) {
    return this.db.iterator(options);
};
$24f476c448d52fa7$var$LevelUP.prototype.readStream = $24f476c448d52fa7$var$LevelUP.prototype.createReadStream = function(options) {
    options = $br7jT({
        keys: true,
        values: true
    }, options);
    if (typeof options.limit !== 'number') options.limit = -1;
    return new $45f698af47b4db7c$exports(this.db.iterator(options), options);
};
$24f476c448d52fa7$var$LevelUP.prototype.keyStream = $24f476c448d52fa7$var$LevelUP.prototype.createKeyStream = function(options) {
    return this.createReadStream($br7jT(options, {
        keys: true,
        values: false
    }));
};
$24f476c448d52fa7$var$LevelUP.prototype.valueStream = $24f476c448d52fa7$var$LevelUP.prototype.createValueStream = function(options) {
    return this.createReadStream($br7jT(options, {
        keys: false,
        values: true
    }));
};
$24f476c448d52fa7$var$LevelUP.prototype.toString = function() {
    return 'LevelUP';
};
function $24f476c448d52fa7$var$maybeError(db, callback) {
    if (!db._isOpening() && !db.isOpen()) {
        $kavLi.nextTick(callback, new $24f476c448d52fa7$var$ReadError('Database is not open'));
        return true;
    }
}
$24f476c448d52fa7$var$LevelUP.errors = $a555ffa520e4ee49$exports;
$24f476c448d52fa7$exports = $24f476c448d52fa7$var$LevelUP.default = $24f476c448d52fa7$var$LevelUP;


var $68adf29740281e8a$exports = {};
'use strict';

var $68adf29740281e8a$require$AbstractLevelDOWN = $f879591cfb1b6c8d$export$b7d0b0b6bf88e01c;

var $68adf29740281e8a$require$AbstractChainedBatch = $f879591cfb1b6c8d$export$b7cc577567d0e62c;

var $68adf29740281e8a$require$AbstractIterator = $f879591cfb1b6c8d$export$bddce72536e51c3d;

var $e10SE = parcelRequire("e10SE");

var $br7jT = parcelRequire("br7jT");
var $6abb5f680b839a55$exports = {};
var $3b4fff7e0a5dec72$exports = {};

var $js3Ea = parcelRequire("js3Ea");
var $3b4fff7e0a5dec72$require$Buffer = $js3Ea.Buffer;
$3b4fff7e0a5dec72$exports.utf8 = $3b4fff7e0a5dec72$exports['utf-8'] = {
    encode: function(data) {
        return $3b4fff7e0a5dec72$var$isBinary(data) ? data : String(data);
    },
    decode: $3b4fff7e0a5dec72$var$identity,
    buffer: false,
    type: 'utf8'
};
$3b4fff7e0a5dec72$exports.json = {
    encode: JSON.stringify,
    decode: JSON.parse,
    buffer: false,
    type: 'json'
};
$3b4fff7e0a5dec72$exports.binary = {
    encode: function(data) {
        return $3b4fff7e0a5dec72$var$isBinary(data) ? data : $3b4fff7e0a5dec72$require$Buffer.from(data);
    },
    decode: $3b4fff7e0a5dec72$var$identity,
    buffer: true,
    type: 'binary'
};
$3b4fff7e0a5dec72$exports.none = {
    encode: $3b4fff7e0a5dec72$var$identity,
    decode: $3b4fff7e0a5dec72$var$identity,
    buffer: false,
    type: 'id'
};
$3b4fff7e0a5dec72$exports.id = $3b4fff7e0a5dec72$exports.none;
var $3b4fff7e0a5dec72$var$bufferEncodings = [
    'hex',
    'ascii',
    'base64',
    'ucs2',
    'ucs-2',
    'utf16le',
    'utf-16le'
];
$3b4fff7e0a5dec72$var$bufferEncodings.forEach(function(type) {
    $3b4fff7e0a5dec72$exports[type] = {
        encode: function(data) {
            return $3b4fff7e0a5dec72$var$isBinary(data) ? data : $3b4fff7e0a5dec72$require$Buffer.from(data, type);
        },
        decode: function(buffer) {
            return buffer.toString(type);
        },
        buffer: true,
        type: type
    };
});
function $3b4fff7e0a5dec72$var$identity(value) {
    return value;
}
function $3b4fff7e0a5dec72$var$isBinary(data) {
    return data === undefined || data === null || $3b4fff7e0a5dec72$require$Buffer.isBuffer(data);
}


$6abb5f680b839a55$exports = $6abb5f680b839a55$var$Codec;
function $6abb5f680b839a55$var$Codec(opts) {
    if (!(this instanceof $6abb5f680b839a55$var$Codec)) return new $6abb5f680b839a55$var$Codec(opts);
    this.opts = opts || {};
    this.encodings = $3b4fff7e0a5dec72$exports;
}
$6abb5f680b839a55$var$Codec.prototype._encoding = function(encoding) {
    if (typeof encoding === 'string') encoding = $3b4fff7e0a5dec72$exports[encoding];
    if (!encoding) encoding = $3b4fff7e0a5dec72$exports.id;
    return encoding;
};
$6abb5f680b839a55$var$Codec.prototype._keyEncoding = function(opts, batchOpts) {
    return this._encoding(batchOpts && batchOpts.keyEncoding || opts && opts.keyEncoding || this.opts.keyEncoding);
};
$6abb5f680b839a55$var$Codec.prototype._valueEncoding = function(opts, batchOpts) {
    return this._encoding(batchOpts && (batchOpts.valueEncoding || batchOpts.encoding) || opts && (opts.valueEncoding || opts.encoding) || this.opts.valueEncoding || this.opts.encoding);
};
$6abb5f680b839a55$var$Codec.prototype.encodeKey = function(key, opts, batchOpts) {
    return this._keyEncoding(opts, batchOpts).encode(key);
};
$6abb5f680b839a55$var$Codec.prototype.encodeValue = function(value, opts, batchOpts) {
    return this._valueEncoding(opts, batchOpts).encode(value);
};
$6abb5f680b839a55$var$Codec.prototype.decodeKey = function(key, opts) {
    return this._keyEncoding(opts).decode(key);
};
$6abb5f680b839a55$var$Codec.prototype.decodeValue = function(value, opts) {
    return this._valueEncoding(opts).decode(value);
};
$6abb5f680b839a55$var$Codec.prototype.encodeBatch = function(ops, opts) {
    var self = this;
    return ops.map(function(_op) {
        var op = {
            type: _op.type,
            key: self.encodeKey(_op.key, opts, _op)
        };
        if (self.keyAsBuffer(opts, _op)) op.keyEncoding = 'binary';
        if (_op.prefix) op.prefix = _op.prefix;
        if ('value' in _op) {
            op.value = self.encodeValue(_op.value, opts, _op);
            if (self.valueAsBuffer(opts, _op)) op.valueEncoding = 'binary';
        }
        return op;
    });
};
var $6abb5f680b839a55$var$ltgtKeys = [
    'lt',
    'gt',
    'lte',
    'gte',
    'start',
    'end'
];
$6abb5f680b839a55$var$Codec.prototype.encodeLtgt = function(ltgt) {
    var self = this;
    var ret = {};
    Object.keys(ltgt).forEach(function(key) {
        ret[key] = $6abb5f680b839a55$var$ltgtKeys.indexOf(key) > -1 ? self.encodeKey(ltgt[key], ltgt) : ltgt[key];
    });
    return ret;
};
$6abb5f680b839a55$var$Codec.prototype.createStreamDecoder = function(opts) {
    var self = this;
    if (opts.keys && opts.values) return function(key, value) {
        return {
            key: self.decodeKey(key, opts),
            value: self.decodeValue(value, opts)
        };
    };
    else if (opts.keys) return function(key) {
        return self.decodeKey(key, opts);
    };
    else if (opts.values) return function(_, value) {
        return self.decodeValue(value, opts);
    };
    else return function() {};
};
$6abb5f680b839a55$var$Codec.prototype.keyAsBuffer = function(opts) {
    return this._keyEncoding(opts).buffer;
};
$6abb5f680b839a55$var$Codec.prototype.valueAsBuffer = function(opts) {
    return this._valueEncoding(opts).buffer;
};



var $68adf29740281e8a$require$EncodingError = $a555ffa520e4ee49$exports.EncodingError;
$68adf29740281e8a$exports = $68adf29740281e8a$var$DB.default = $68adf29740281e8a$var$DB;
function $68adf29740281e8a$var$DB(db, opts) {
    if (!(this instanceof $68adf29740281e8a$var$DB)) return new $68adf29740281e8a$var$DB(db, opts);
    $68adf29740281e8a$require$AbstractLevelDOWN.call(this, '');
    opts = opts || {};
    if (typeof opts.keyEncoding === 'undefined') opts.keyEncoding = 'utf8';
    if (typeof opts.valueEncoding === 'undefined') opts.valueEncoding = 'utf8';
    this.db = db;
    this.codec = new $6abb5f680b839a55$exports(opts);
}
$e10SE($68adf29740281e8a$var$DB, $68adf29740281e8a$require$AbstractLevelDOWN);
$68adf29740281e8a$var$DB.prototype._serializeKey = $68adf29740281e8a$var$DB.prototype._serializeValue = function(datum) {
    return datum;
};
$68adf29740281e8a$var$DB.prototype._open = function(opts, cb) {
    this.db.open(opts, cb);
};
$68adf29740281e8a$var$DB.prototype._close = function(cb) {
    this.db.close(cb);
};
$68adf29740281e8a$var$DB.prototype._put = function(key, value, opts, cb) {
    key = this.codec.encodeKey(key, opts);
    value = this.codec.encodeValue(value, opts);
    this.db.put(key, value, opts, cb);
};
$68adf29740281e8a$var$DB.prototype._get = function(key, opts, cb) {
    var self = this;
    key = this.codec.encodeKey(key, opts);
    opts.asBuffer = this.codec.valueAsBuffer(opts);
    this.db.get(key, opts, function(err, value) {
        if (err) return cb(err);
        try {
            value = self.codec.decodeValue(value, opts);
        } catch (err) {
            return cb(new $68adf29740281e8a$require$EncodingError(err));
        }
        cb(null, value);
    });
};
$68adf29740281e8a$var$DB.prototype._del = function(key, opts, cb) {
    key = this.codec.encodeKey(key, opts);
    this.db.del(key, opts, cb);
};
$68adf29740281e8a$var$DB.prototype._chainedBatch = function() {
    return new $68adf29740281e8a$var$Batch(this);
};
$68adf29740281e8a$var$DB.prototype._batch = function(ops, opts, cb) {
    ops = this.codec.encodeBatch(ops, opts);
    this.db.batch(ops, opts, cb);
};
$68adf29740281e8a$var$DB.prototype._iterator = function(opts) {
    opts.keyAsBuffer = this.codec.keyAsBuffer(opts);
    opts.valueAsBuffer = this.codec.valueAsBuffer(opts);
    return new $68adf29740281e8a$var$Iterator(this, opts);
};
$68adf29740281e8a$var$DB.prototype._setupIteratorOptions = function(options) {
    options = $br7jT(options);
    options.reverse = !!options.reverse;
    options.keys = options.keys !== false;
    options.values = options.values !== false;
    options.limit = 'limit' in options ? options.limit : -1;
    options.keyAsBuffer = options.keyAsBuffer !== false;
    options.valueAsBuffer = options.valueAsBuffer !== false;
    return options;
};
$68adf29740281e8a$var$DB.prototype.approximateSize = function(start, end, opts, cb) {
    return this.db.approximateSize(start, end, opts, cb);
};
function $68adf29740281e8a$var$Iterator(db, opts) {
    $68adf29740281e8a$require$AbstractIterator.call(this, db);
    this.codec = db.codec;
    this.keys = opts.keys;
    this.values = opts.values;
    this.opts = this.codec.encodeLtgt(opts);
    this.it = db.db.iterator(this.opts);
}
$e10SE($68adf29740281e8a$var$Iterator, $68adf29740281e8a$require$AbstractIterator);
$68adf29740281e8a$var$Iterator.prototype._next = function(cb) {
    var self = this;
    this.it.next(function(err, key, value) {
        if (err) return cb(err);
        try {
            if (self.keys && typeof key !== 'undefined') key = self.codec.decodeKey(key, self.opts);
            else key = undefined;
            if (self.values && typeof value !== 'undefined') value = self.codec.decodeValue(value, self.opts);
            else value = undefined;
        } catch (err) {
            return cb(new $68adf29740281e8a$require$EncodingError(err));
        }
        cb(null, key, value);
    });
};
$68adf29740281e8a$var$Iterator.prototype._end = function(cb) {
    this.it.end(cb);
};
function $68adf29740281e8a$var$Batch(db, codec) {
    $68adf29740281e8a$require$AbstractChainedBatch.call(this, db);
    this.codec = db.codec;
    this.batch = db.db.batch();
}
$e10SE($68adf29740281e8a$var$Batch, $68adf29740281e8a$require$AbstractChainedBatch);
$68adf29740281e8a$var$Batch.prototype._put = function(key, value) {
    key = this.codec.encodeKey(key);
    value = this.codec.encodeValue(value);
    this.batch.put(key, value);
};
$68adf29740281e8a$var$Batch.prototype._del = function(key) {
    key = this.codec.encodeKey(key);
    this.batch.del(key);
};
$68adf29740281e8a$var$Batch.prototype._clear = function() {
    this.batch.clear();
};
$68adf29740281e8a$var$Batch.prototype._write = function(opts, cb) {
    this.batch.write(opts, cb);
};


var $6e99105cb8278751$exports = {};
/* global indexedDB */ 
var $js3Ea = parcelRequire("js3Ea");
var $6e99105cb8278751$require$Buffer = $js3Ea.Buffer;
'use strict';
$6e99105cb8278751$exports = $6e99105cb8278751$var$Level;

var $6e99105cb8278751$require$AbstractLevelDOWN = $f879591cfb1b6c8d$export$b7d0b0b6bf88e01c;

var $e10SE = parcelRequire("e10SE");
var $4ef1f2a115ebc12b$exports = {};
/* global IDBKeyRange */ 'use strict';

var $e10SE = parcelRequire("e10SE");

var $4ef1f2a115ebc12b$require$AbstractIterator = $f879591cfb1b6c8d$export$bddce72536e51c3d;
var $8769e963a4abbbd2$export$398604a469f7de9a;
var $8769e963a4abbbd2$export$ec1caa9af1cb521f;
var $8769e963a4abbbd2$export$450bb71ab40039dc;
var $8769e963a4abbbd2$export$9f784c01ba6c64c0;
var $8769e963a4abbbd2$export$2128a2a838848855;
var $8769e963a4abbbd2$export$471a4bc87c20bc7f;
var $8769e963a4abbbd2$export$a242358e9408282d;
var $8769e963a4abbbd2$export$6e1fca9e6c3c928b;
var $8769e963a4abbbd2$export$1e7f253df265a2ba;
var $8769e963a4abbbd2$export$b3571188c770cc5a;
var $8769e963a4abbbd2$export$bd5df0f255a350f8;
var $8769e963a4abbbd2$export$da1e0b1e20cbe47;
var $8769e963a4abbbd2$export$4a5dffb6ab47c800;
var $8769e963a4abbbd2$export$4331ca3320f4592e;
var $8769e963a4abbbd2$export$2344b14b097df817;
var $8769e963a4abbbd2$export$3dea766d36a8935f;

var $js3Ea = parcelRequire("js3Ea");
var $8769e963a4abbbd2$require$Buffer = $js3Ea.Buffer;
$8769e963a4abbbd2$export$398604a469f7de9a = function(a, b) {
    if ($8769e963a4abbbd2$require$Buffer.isBuffer(a)) {
        var l = Math.min(a.length, b.length);
        for(var i = 0; i < l; i++){
            var cmp = a[i] - b[i];
            if (cmp) return cmp;
        }
        return a.length - b.length;
    }
    return a < b ? -1 : a > b ? 1 : 0;
};
// to be compatible with the current abstract-leveldown tests
// nullish or empty strings.
// I could use !!val but I want to permit numbers and booleans,
// if possible.
function $8769e963a4abbbd2$var$isDef(val) {
    return val !== undefined && val !== '';
}
function $8769e963a4abbbd2$var$has(range, name) {
    return Object.hasOwnProperty.call(range, name);
}
function $8769e963a4abbbd2$var$hasKey(range, name) {
    return Object.hasOwnProperty.call(range, name) && name;
}
var $8769e963a4abbbd2$var$lowerBoundKey = $8769e963a4abbbd2$export$ec1caa9af1cb521f = function(range) {
    return $8769e963a4abbbd2$var$hasKey(range, 'gt') || $8769e963a4abbbd2$var$hasKey(range, 'gte') || $8769e963a4abbbd2$var$hasKey(range, 'min') || (range.reverse ? $8769e963a4abbbd2$var$hasKey(range, 'end') : $8769e963a4abbbd2$var$hasKey(range, 'start')) || undefined;
};
var $8769e963a4abbbd2$var$lowerBound = $8769e963a4abbbd2$export$450bb71ab40039dc = function(range, def) {
    var k = $8769e963a4abbbd2$var$lowerBoundKey(range);
    return k ? range[k] : def;
};
var $8769e963a4abbbd2$var$lowerBoundInclusive = $8769e963a4abbbd2$export$9f784c01ba6c64c0 = function(range) {
    return $8769e963a4abbbd2$var$has(range, 'gt') ? false : true;
};
var $8769e963a4abbbd2$var$upperBoundInclusive = $8769e963a4abbbd2$export$2128a2a838848855 = function(range) {
    return $8769e963a4abbbd2$var$has(range, 'lt') ? false : true;
};
var $8769e963a4abbbd2$var$lowerBoundExclusive = $8769e963a4abbbd2$export$471a4bc87c20bc7f = function(range) {
    return !$8769e963a4abbbd2$var$lowerBoundInclusive(range);
};
var $8769e963a4abbbd2$var$upperBoundExclusive = $8769e963a4abbbd2$export$a242358e9408282d = function(range) {
    return !$8769e963a4abbbd2$var$upperBoundInclusive(range);
};
var $8769e963a4abbbd2$var$upperBoundKey = $8769e963a4abbbd2$export$6e1fca9e6c3c928b = function(range) {
    return $8769e963a4abbbd2$var$hasKey(range, 'lt') || $8769e963a4abbbd2$var$hasKey(range, 'lte') || $8769e963a4abbbd2$var$hasKey(range, 'max') || (range.reverse ? $8769e963a4abbbd2$var$hasKey(range, 'start') : $8769e963a4abbbd2$var$hasKey(range, 'end')) || undefined;
};
var $8769e963a4abbbd2$var$upperBound = $8769e963a4abbbd2$export$1e7f253df265a2ba = function(range, def) {
    var k = $8769e963a4abbbd2$var$upperBoundKey(range);
    return k ? range[k] : def;
};
$8769e963a4abbbd2$export$b3571188c770cc5a = function(range, def) {
    return range.reverse ? $8769e963a4abbbd2$var$upperBound(range, def) : $8769e963a4abbbd2$var$lowerBound(range, def);
};
$8769e963a4abbbd2$export$bd5df0f255a350f8 = function(range, def) {
    return range.reverse ? $8769e963a4abbbd2$var$lowerBound(range, def) : $8769e963a4abbbd2$var$upperBound(range, def);
};
$8769e963a4abbbd2$export$da1e0b1e20cbe47 = function(range) {
    return range.reverse ? $8769e963a4abbbd2$var$upperBoundInclusive(range) : $8769e963a4abbbd2$var$lowerBoundInclusive(range);
};
$8769e963a4abbbd2$export$4a5dffb6ab47c800 = function(range) {
    return range.reverse ? $8769e963a4abbbd2$var$lowerBoundInclusive(range) : $8769e963a4abbbd2$var$upperBoundInclusive(range);
};
function $8769e963a4abbbd2$var$id(e) {
    return e;
}
$8769e963a4abbbd2$export$4331ca3320f4592e = function(range, _range, map, lower, upper) {
    _range = _range || {};
    map = map || $8769e963a4abbbd2$var$id;
    var defaults = arguments.length > 3;
    var lb = $8769e963a4abbbd2$export$ec1caa9af1cb521f(range);
    var ub = $8769e963a4abbbd2$export$6e1fca9e6c3c928b(range);
    if (lb) {
        if (lb === 'gt') _range.gt = map(range.gt, false);
        else _range.gte = map(range[lb], false);
    } else if (defaults) _range.gte = map(lower, false);
    if (ub) {
        if (ub === 'lt') _range.lt = map(range.lt, true);
        else _range.lte = map(range[ub], true);
    } else if (defaults) _range.lte = map(upper, true);
    if (range.reverse != null) _range.reverse = !!range.reverse;
    //if range was used mutably
    //(in level-sublevel it's part of an options object
    //that has more properties on it.)
    if ($8769e963a4abbbd2$var$has(_range, 'max')) delete _range.max;
    if ($8769e963a4abbbd2$var$has(_range, 'min')) delete _range.min;
    if ($8769e963a4abbbd2$var$has(_range, 'start')) delete _range.start;
    if ($8769e963a4abbbd2$var$has(_range, 'end')) delete _range.end;
    return _range;
};
$8769e963a4abbbd2$export$2344b14b097df817 = function(range, key, compare) {
    compare = compare || $8769e963a4abbbd2$export$398604a469f7de9a;
    var lb = $8769e963a4abbbd2$var$lowerBound(range);
    if ($8769e963a4abbbd2$var$isDef(lb)) {
        var cmp = compare(key, lb);
        if (cmp < 0 || cmp === 0 && $8769e963a4abbbd2$var$lowerBoundExclusive(range)) return false;
    }
    var ub = $8769e963a4abbbd2$var$upperBound(range);
    if ($8769e963a4abbbd2$var$isDef(ub)) {
        var cmp = compare(key, ub);
        if (cmp > 0 || cmp === 0 && $8769e963a4abbbd2$var$upperBoundExclusive(range)) return false;
    }
    return true;
};
$8769e963a4abbbd2$export$3dea766d36a8935f = function(range, compare) {
    return function(key) {
        return $8769e963a4abbbd2$export$2344b14b097df817(range, key, compare);
    };
};


var $0a5634ea33d58153$exports = {};

var $js3Ea = parcelRequire("js3Ea");
var $0a5634ea33d58153$require$Buffer = $js3Ea.Buffer;
'use strict';
var $8c6e8f1e3083a256$exports = {};
/**
 * Convert a typed array to a Buffer without a copy
 *
 * Author:   Feross Aboukhadijeh <https://feross.org>
 * License:  MIT
 *
 * `npm install typedarray-to-buffer`
 */ 
var $js3Ea = parcelRequire("js3Ea");
var $8c6e8f1e3083a256$require$Buffer = $js3Ea.Buffer;
var $d80f37a1711a8d24$exports = {};
$d80f37a1711a8d24$exports = $d80f37a1711a8d24$var$isTypedArray;
$d80f37a1711a8d24$var$isTypedArray.strict = $d80f37a1711a8d24$var$isStrictTypedArray;
$d80f37a1711a8d24$var$isTypedArray.loose = $d80f37a1711a8d24$var$isLooseTypedArray;
var $d80f37a1711a8d24$var$toString = Object.prototype.toString;
var $d80f37a1711a8d24$var$names = {
    '[object Int8Array]': true,
    '[object Int16Array]': true,
    '[object Int32Array]': true,
    '[object Uint8Array]': true,
    '[object Uint8ClampedArray]': true,
    '[object Uint16Array]': true,
    '[object Uint32Array]': true,
    '[object Float32Array]': true,
    '[object Float64Array]': true
};
function $d80f37a1711a8d24$var$isTypedArray(arr) {
    return $d80f37a1711a8d24$var$isStrictTypedArray(arr) || $d80f37a1711a8d24$var$isLooseTypedArray(arr);
}
function $d80f37a1711a8d24$var$isStrictTypedArray(arr) {
    return arr instanceof Int8Array || arr instanceof Int16Array || arr instanceof Int32Array || arr instanceof Uint8Array || arr instanceof Uint8ClampedArray || arr instanceof Uint16Array || arr instanceof Uint32Array || arr instanceof Float32Array || arr instanceof Float64Array;
}
function $d80f37a1711a8d24$var$isLooseTypedArray(arr) {
    return $d80f37a1711a8d24$var$names[$d80f37a1711a8d24$var$toString.call(arr)];
}


var $8c6e8f1e3083a256$require$isTypedArray = $d80f37a1711a8d24$exports.strict;
$8c6e8f1e3083a256$exports = function typedarrayToBuffer(arr) {
    if ($8c6e8f1e3083a256$require$isTypedArray(arr)) {
        // To avoid a copy, use the typed array's underlying ArrayBuffer to back new Buffer
        var buf = $8c6e8f1e3083a256$require$Buffer.from(arr.buffer);
        if (arr.byteLength !== arr.buffer.byteLength) // Respect the "view", i.e. byteOffset and byteLength, without doing a copy
        buf = buf.slice(arr.byteOffset, arr.byteOffset + arr.byteLength);
        return buf;
    } else // Pass through all other types to `Buffer.from`
    return $8c6e8f1e3083a256$require$Buffer.from(arr);
};


$0a5634ea33d58153$exports = function(value) {
    if (value instanceof Uint8Array) return $8c6e8f1e3083a256$exports(value);
    else if (value instanceof ArrayBuffer) return $0a5634ea33d58153$require$Buffer.from(value);
    else return $0a5634ea33d58153$require$Buffer.from(String(value));
};


var $df44413d251d421a$exports = {};

$df44413d251d421a$exports = (parcelRequire("2gIsH"));


var $4ef1f2a115ebc12b$var$noop = function() {};
$4ef1f2a115ebc12b$exports = $4ef1f2a115ebc12b$var$Iterator;
function $4ef1f2a115ebc12b$var$Iterator(db, location, options) {
    $4ef1f2a115ebc12b$require$AbstractIterator.call(this, db);
    this._limit = options.limit;
    this._count = 0;
    this._callback = null;
    this._cache = [];
    this._completed = false;
    this._aborted = false;
    this._error = null;
    this._transaction = null;
    this._keyAsBuffer = options.keyAsBuffer;
    this._valueAsBuffer = options.valueAsBuffer;
    if (this._limit === 0) {
        this._completed = true;
        return;
    }
    try {
        var keyRange = this.createKeyRange(options);
    } catch (e) {
        // The lower key is greater than the upper key.
        // IndexedDB throws an error, but we'll just return 0 results.
        this._completed = true;
        return;
    }
    this.createIterator(location, keyRange, options.reverse);
}
$e10SE($4ef1f2a115ebc12b$var$Iterator, $4ef1f2a115ebc12b$require$AbstractIterator);
$4ef1f2a115ebc12b$var$Iterator.prototype.createKeyRange = function(options) {
    var lower = $8769e963a4abbbd2$export$450bb71ab40039dc(options);
    var upper = $8769e963a4abbbd2$export$1e7f253df265a2ba(options);
    var lowerOpen = $8769e963a4abbbd2$export$471a4bc87c20bc7f(options);
    var upperOpen = $8769e963a4abbbd2$export$a242358e9408282d(options);
    if (lower !== undefined && upper !== undefined) return IDBKeyRange.bound(lower, upper, lowerOpen, upperOpen);
    else if (lower !== undefined) return IDBKeyRange.lowerBound(lower, lowerOpen);
    else if (upper !== undefined) return IDBKeyRange.upperBound(upper, upperOpen);
    else return null;
};
$4ef1f2a115ebc12b$var$Iterator.prototype.createIterator = function(location, keyRange, reverse) {
    var self = this;
    var transaction = this.db.transaction([
        location
    ], 'readonly');
    var store = transaction.objectStore(location);
    var req = store.openCursor(keyRange, reverse ? 'prev' : 'next');
    req.onsuccess = function(ev) {
        var cursor = ev.target.result;
        if (cursor) self.onItem(cursor);
    };
    this._transaction = transaction;
    // If an error occurs (on the request), the transaction will abort.
    transaction.onabort = function() {
        self.onAbort(self._transaction.error || new Error('aborted by user'));
    };
    transaction.oncomplete = function() {
        self.onComplete();
    };
};
$4ef1f2a115ebc12b$var$Iterator.prototype.onItem = function(cursor) {
    this._cache.push(cursor.key, cursor.value);
    if (this._limit <= 0 || ++this._count < this._limit) cursor['continue']();
    this.maybeNext();
};
$4ef1f2a115ebc12b$var$Iterator.prototype.onAbort = function(err) {
    this._aborted = true;
    this._error = err;
    this.maybeNext();
};
$4ef1f2a115ebc12b$var$Iterator.prototype.onComplete = function() {
    this._completed = true;
    this.maybeNext();
};
$4ef1f2a115ebc12b$var$Iterator.prototype.maybeNext = function() {
    if (this._callback) {
        this._next(this._callback);
        this._callback = null;
    }
};
$4ef1f2a115ebc12b$var$Iterator.prototype._next = function(callback) {
    if (this._aborted) {
        // The error should be picked up by either next() or end().
        var err = this._error;
        this._error = null;
        $df44413d251d421a$exports(function() {
            callback(err);
        });
    } else if (this._cache.length > 0) {
        var key = this._cache.shift();
        var value = this._cache.shift();
        if (this._keyAsBuffer) key = $0a5634ea33d58153$exports(key);
        if (this._valueAsBuffer) value = $0a5634ea33d58153$exports(value);
        $df44413d251d421a$exports(function() {
            callback(null, key, value);
        });
    } else if (this._completed) $df44413d251d421a$exports(callback);
    else this._callback = callback;
};
$4ef1f2a115ebc12b$var$Iterator.prototype._end = function(callback) {
    if (this._aborted || this._completed) {
        var err = this._error;
        $df44413d251d421a$exports(function() {
            callback(err);
        });
        return;
    }
    // Don't advance the cursor anymore, and the transaction will complete
    // on its own in the next tick. This approach is much cleaner than calling
    // transaction.abort() with its unpredictable event order.
    this.onItem = $4ef1f2a115ebc12b$var$noop;
    this.onAbort = callback;
    this.onComplete = callback;
};




var $0dfd625f1d466127$export$e0969da9b8fb378d;
var $0dfd625f1d466127$export$d402c96447400861;
var $0dfd625f1d466127$export$d61a6dc3ac005d58;
'use strict';
$0dfd625f1d466127$export$e0969da9b8fb378d = function(key) {
    return function test(impl) {
        try {
            impl.cmp(key, 0);
            return true;
        } catch (err) {
            return false;
        }
    };
};
$0dfd625f1d466127$export$d402c96447400861 = $0dfd625f1d466127$export$e0969da9b8fb378d(new Uint8Array(0));
$0dfd625f1d466127$export$d61a6dc3ac005d58 = $0dfd625f1d466127$export$e0969da9b8fb378d([
    1
]);


var $6e99105cb8278751$var$DEFAULT_PREFIX = 'level-js-';
function $6e99105cb8278751$var$Level(location, opts) {
    if (!(this instanceof $6e99105cb8278751$var$Level)) return new $6e99105cb8278751$var$Level(location, opts);
    $6e99105cb8278751$require$AbstractLevelDOWN.call(this, location);
    opts = opts || {};
    this.prefix = opts.prefix || $6e99105cb8278751$var$DEFAULT_PREFIX;
    this.version = parseInt(opts.version || 1, 10);
}
$e10SE($6e99105cb8278751$var$Level, $6e99105cb8278751$require$AbstractLevelDOWN);
// Detect binary and array key support (IndexedDB Second Edition)
$6e99105cb8278751$var$Level.binaryKeys = $0dfd625f1d466127$export$d402c96447400861(indexedDB);
$6e99105cb8278751$var$Level.arrayKeys = $0dfd625f1d466127$export$d61a6dc3ac005d58(indexedDB);
$6e99105cb8278751$var$Level.prototype._open = function(options, callback) {
    var req = indexedDB.open(this.prefix + this.location, this.version);
    var self = this;
    req.onerror = function() {
        callback(req.error || new Error('unknown error'));
    };
    req.onsuccess = function() {
        self.db = req.result;
        callback();
    };
    req.onupgradeneeded = function(ev) {
        var db = ev.target.result;
        if (!db.objectStoreNames.contains(self.location)) db.createObjectStore(self.location);
    };
};
$6e99105cb8278751$var$Level.prototype.store = function(mode) {
    var transaction = this.db.transaction([
        this.location
    ], mode);
    return transaction.objectStore(this.location);
};
$6e99105cb8278751$var$Level.prototype.await = function(request, callback) {
    var transaction = request.transaction;
    // Take advantage of the fact that a non-canceled request error aborts
    // the transaction. I.e. no need to listen for "request.onerror".
    transaction.onabort = function() {
        callback(transaction.error || new Error('aborted by user'));
    };
    transaction.oncomplete = function() {
        callback(null, request.result);
    };
};
$6e99105cb8278751$var$Level.prototype._get = function(key, options, callback) {
    var store = this.store('readonly');
    try {
        var req = store.get(key);
    } catch (err) {
        return $df44413d251d421a$exports(function() {
            callback(err);
        });
    }
    this.await(req, function(err, value) {
        if (err) return callback(err);
        if (value === undefined) // 'NotFound' error, consistent with LevelDOWN API
        return callback(new Error('NotFound'));
        if (options.asBuffer) value = $0a5634ea33d58153$exports(value);
        callback(null, value);
    });
};
$6e99105cb8278751$var$Level.prototype._del = function(key, options, callback) {
    var store = this.store('readwrite');
    try {
        var req = store.delete(key);
    } catch (err) {
        return $df44413d251d421a$exports(function() {
            callback(err);
        });
    }
    this.await(req, callback);
};
$6e99105cb8278751$var$Level.prototype._put = function(key, value, options, callback) {
    var store = this.store('readwrite');
    try {
        // Will throw a DataError or DataCloneError if the environment
        // does not support serializing the key or value respectively.
        var req = store.put(value, key);
    } catch (err) {
        return $df44413d251d421a$exports(function() {
            callback(err);
        });
    }
    this.await(req, callback);
};
// Valid key types in IndexedDB Second Edition:
//
// - Number, except NaN. Includes Infinity and -Infinity
// - Date, except invalid (NaN)
// - String
// - ArrayBuffer or a view thereof (typed arrays). In level-js we also support
//   Buffer (which is an Uint8Array) (and the primary binary type of Level).
// - Array, except cyclical and empty (e.g. Array(10)). Elements must be valid
//   types themselves.
$6e99105cb8278751$var$Level.prototype._serializeKey = function(key) {
    if ($6e99105cb8278751$require$Buffer.isBuffer(key)) return $6e99105cb8278751$var$Level.binaryKeys ? key : key.toString();
    else if (Array.isArray(key)) return $6e99105cb8278751$var$Level.arrayKeys ? key.map(this._serializeKey, this) : String(key);
    else if (typeof key === 'boolean' || typeof key === 'number' && isNaN(key)) // These types are invalid per the IndexedDB spec and ideally we'd treat
    // them that way, but they're valid per the current abstract test suite.
    return String(key);
    else return key;
};
$6e99105cb8278751$var$Level.prototype._serializeValue = function(value) {
    return value == null ? '' : value;
};
$6e99105cb8278751$var$Level.prototype._iterator = function(options) {
    return new $4ef1f2a115ebc12b$exports(this.db, this.location, options);
};
$6e99105cb8278751$var$Level.prototype._batch = function(operations, options, callback) {
    if (operations.length === 0) return $df44413d251d421a$exports(callback);
    var store = this.store('readwrite');
    var transaction = store.transaction;
    var index = 0;
    var error;
    transaction.onabort = function() {
        callback(error || transaction.error || new Error('aborted by user'));
    };
    transaction.oncomplete = function() {
        callback();
    };
    // Wait for a request to complete before making the next, saving CPU.
    function loop() {
        var op = operations[index++];
        var key = op.key;
        try {
            var req = op.type === 'del' ? store.delete(key) : store.put(op.value, key);
        } catch (err) {
            error = err;
            transaction.abort();
            return;
        }
        if (index < operations.length) req.onsuccess = loop;
    }
    loop();
};
$6e99105cb8278751$var$Level.prototype._close = function(callback) {
    this.db.close();
    $df44413d251d421a$exports(callback);
};
$6e99105cb8278751$var$Level.destroy = function(location, prefix, callback) {
    if (typeof prefix === 'function') {
        callback = prefix;
        prefix = $6e99105cb8278751$var$DEFAULT_PREFIX;
    }
    var request = indexedDB.deleteDatabase(prefix + location);
    request.onsuccess = function() {
        callback();
    };
    request.onerror = function(err) {
        callback(err);
    };
};


let $d5647239811adf6c$var$DB;
(0, (/*@__PURE__*/$parcel$interopDefault($24f476c448d52fa7$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($68adf29740281e8a$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($6e99105cb8278751$exports)))('worker'), {
    valueEncoding: 'json'
}), (err, db)=>{
    $d5647239811adf6c$var$DB = db;
    if (err) // can happen in Firefox private mode
    // eslint-disable-next-line no-console
    console.debug('IndexedDB is not available');
});
const $d5647239811adf6c$export$8e2febbdce536ea3 = async (msg, payload)=>{
    if ($d5647239811adf6c$var$DB) try {
        await $d5647239811adf6c$var$DB.put(msg.id, payload);
        return;
    } catch (e) {
        console.error('Unable to write to IndexedDB', e);
    }
    msg.payload = payload;
};
const $d5647239811adf6c$export$1ff89f20b837dd41 = async (msg)=>{
    if (msg.payload || !$d5647239811adf6c$var$DB) return msg.payload;
    const payload = await $d5647239811adf6c$var$DB.get(msg.id);
    await $d5647239811adf6c$var$DB.del(msg.id);
    return payload;
};


const $c07cd4c29e466bdb$export$9bfe85d84666e58 = ()=>document.getElementById('react-root');


const $d54b25c31b40a794$export$aee2638d36416d07 = ()=>{
    const rootNode = (0, $c07cd4c29e466bdb$export$9bfe85d84666e58)();
    if (!rootNode) return '';
    let basepath = rootNode.getAttribute('data-basepath') || '';
    if (basepath !== '') basepath = basepath.slice(0, basepath.length - 1);
    return basepath;
};
const $d54b25c31b40a794$export$71c2a1babd78d286 = (pathname, basepath = $d54b25c31b40a794$export$aee2638d36416d07())=>{
    if (basepath === '') return pathname;
    const expr = new RegExp(`^${basepath}`);
    const matches = pathname.match(expr);
    if (matches) return pathname.replace(expr, '');
};


const $3a006c970d7cf650$var$workerCount = navigator.hardwareConcurrency - 1 || 2;
var $f522c48e0ad39998$exports = {};
var $1f07070c916af30c$exports = {};
"use strict";
$1f07070c916af30c$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? 'import ' + JSON.stringify(workerUrl) + ';' : 'importScripts(' + JSON.stringify(workerUrl) + ');';
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: 'application/javascript'
        }));
    }
};


let $f522c48e0ad39998$var$url = new URL($parcel$resolve("9OtVK"));
$f522c48e0ad39998$exports = $1f07070c916af30c$exports($f522c48e0ad39998$var$url.toString(), $f522c48e0ad39998$var$url.origin, true);


class $3a006c970d7cf650$var$JobManager {
    constructor(){
        this.currentIndex = 0;
        this.workers = [];
        this.jobs = {};
        this.tableTransform = async (payload)=>{
            return this.publishDBJob('TABLETRANSFORM', payload);
        };
        this.timeSeriesToTableGraph = (raw)=>{
            return this.publishDBJob('TSTOTABLEGRAPH', {
                raw: raw
            });
        };
        this.timeSeriesToDygraph = (raw, pathname = '')=>{
            return this.publishDBJob('TSTODYGRAPH', {
                raw: raw,
                pathname: pathname
            });
        };
        this.fluxTablesToDygraph = (raw)=>{
            return this.publishDBJob('FLUXTODYGRAPH', {
                raw: raw
            });
        };
        this.fluxTablesToSingleStat = (raw)=>{
            return this.publishDBJob('FLUXTOSINGLE', {
                raw: raw
            });
        };
        this.validateDygraphData = (ts)=>{
            return this.publishDBJob('VALIDATEDYGRAPHDATA', ts);
        };
        this.handleMessage = async (msg)=>{
            const { data: data } = msg;
            const deferred = this.jobs[data.origin];
            if (deferred) {
                if (data.result === 'success') this.fetchPayload(deferred, data);
                else deferred.reject(data.error);
                delete this.jobs[data.origin];
            }
        };
        this.fetchPayload = async (deferred, msg)=>{
            try {
                const payload = await (0, $d5647239811adf6c$export$1ff89f20b837dd41)(msg);
                deferred.resolve(payload);
            } catch (e) {
                console.error(e);
                deferred.reject(e);
            }
        };
        this.handleError = (err)=>{
            console.error(err);
        };
        this.publishJob = async (type, payload)=>{
            const id = (0, $dbdc5944552afab7$export$2e2bcd8739ae039)();
            const deferred = new (0, $abfce34f6d695938$export$2e2bcd8739ae039)();
            this.jobs[id] = deferred;
            this.postMessage({
                id: id,
                type: type,
                payload: payload
            });
            return deferred.promise;
        };
        this.publishDBJob = async (type, payload)=>{
            const id = (0, $dbdc5944552afab7$export$2e2bcd8739ae039)();
            const deferred = new (0, $abfce34f6d695938$export$2e2bcd8739ae039)();
            this.jobs[id] = deferred;
            const msg = {
                id: id,
                type: type
            };
            await (0, $d5647239811adf6c$export$8e2febbdce536ea3)(msg, payload);
            this.postMessage(msg);
            return deferred.promise;
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).times($3a006c970d7cf650$var$workerCount, ()=>{
            const worker = new Worker($f522c48e0ad39998$exports);
            worker.onmessage = this.handleMessage;
            worker.onerror = this.handleError;
            this.workers.push(worker);
        });
    }
    proxy(url, query, db, rp, uuid) {
        if ((0, $d54b25c31b40a794$export$aee2638d36416d07)() !== '') url = `${(0, $d54b25c31b40a794$export$aee2638d36416d07)()}${url}`;
        return this.publishJob('PROXY', {
            url: url,
            query: query,
            db: db,
            rp: rp,
            uuid: uuid
        });
    }
    postJSON(url, body) {
        return this.publishDBJob('POSTJSON', {
            url: url,
            body: body
        });
    }
    get(url) {
        if ((0, $d54b25c31b40a794$export$aee2638d36416d07)() !== '') url = `${(0, $d54b25c31b40a794$export$aee2638d36416d07)()}${url}`;
        return this.publishJob('GET', {
            url: url
        });
    }
    get worker() {
        return this.workers[this.currentIndex];
    }
    postMessage(msg) {
        this.worker.postMessage(msg);
        this.incrementWorker();
    }
    incrementWorker() {
        this.currentIndex += 1;
        this.currentIndex %= $3a006c970d7cf650$var$workerCount;
    }
}
var $3a006c970d7cf650$export$2e2bcd8739ae039 = $3a006c970d7cf650$var$JobManager;
const $3a006c970d7cf650$export$a6385bddcc8e6b77 = new $3a006c970d7cf650$var$JobManager();


async function $aea829e093f1eddb$export$923f96dd5afa9ce6({ source: source, query: query, db: db, rp: rp, uuid: uuid }) {
    try {
        const result = await (0, $3a006c970d7cf650$export$a6385bddcc8e6b77).proxy(source, query, db, rp, uuid);
        return result;
    } catch (error) {
        console.error(error);
        throw error;
    }
}



const $8ba03c44d4b91783$export$46acc72e11cde242 = async (source)=>{
    const query = 'SHOW DATABASES';
    return await (0, $aea829e093f1eddb$export$923f96dd5afa9ce6)({
        source: source,
        query: query
    });
};
const $8ba03c44d4b91783$export$e62df8db5c873ebc = async (source, databases)=>{
    let query;
    if (Array.isArray(databases)) query = databases.map((db)=>`SHOW RETENTION POLICIES ON "${(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).escape(db)}"`).join(';');
    else {
        const dbs = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).split(databases, ',').map((d)=>`${(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).escape(d)}`).join(',');
        query = `SHOW RETENTION POLICIES ON "${dbs}"`;
    }
    return await (0, $aea829e093f1eddb$export$923f96dd5afa9ce6)({
        source: source,
        query: query
    });
};
function $8ba03c44d4b91783$export$b87c83d7687fd7ef(source, db) {
    const query = 'SHOW QUERIES';
    return (0, $aea829e093f1eddb$export$923f96dd5afa9ce6)({
        source: source,
        query: query,
        db: db
    });
}
function $8ba03c44d4b91783$export$fff165c7af0be505(source, queryID, tcpHost) {
    let query;
    if (tcpHost) query = `KILL QUERY ${queryID} ON "${tcpHost}"`;
    else query = `KILL QUERY ${queryID}`;
    return (0, $aea829e093f1eddb$export$923f96dd5afa9ce6)({
        source: source,
        query: query
    });
}
const $8ba03c44d4b91783$export$c71904f041e14568 = async (source, db)=>{
    const query = 'SHOW MEASUREMENTS';
    return await (0, $aea829e093f1eddb$export$923f96dd5afa9ce6)({
        source: source,
        db: db,
        query: query
    });
};
const $8ba03c44d4b91783$export$2e6ff3965e993ace = async ({ source: source, database: database, retentionPolicy: retentionPolicy, measurement: measurement })=>{
    const rp = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).toString(retentionPolicy);
    const query = `SHOW TAG KEYS FROM "${rp}"."${(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).escape(measurement)}"`;
    return await (0, $aea829e093f1eddb$export$923f96dd5afa9ce6)({
        source: source,
        db: database,
        rp: retentionPolicy,
        query: query
    });
};
const $8ba03c44d4b91783$export$ca66e3d7db6697de = async ({ source: source, database: database, retentionPolicy: retentionPolicy, measurement: measurement, tagKeys: tagKeys })=>{
    if (!tagKeys || !tagKeys.length) // return empty response when no tag keys are supplied
    return {
        data: {
            results: [
                {
                    statement_id: 0,
                    series: [
                        {
                            name: 'empty',
                            columns: [
                                'key',
                                'value'
                            ],
                            values: []
                        }
                    ]
                }
            ],
            uuid: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)()
        }
    };
    const keys = tagKeys.sort().map((k)=>`"${(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).escape(k)}"`).join(', ');
    const rp = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).toString(retentionPolicy);
    const query = `SHOW TAG VALUES FROM "${rp}"."${(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).escape(measurement)}" WITH KEY IN (${keys})`;
    return await (0, $aea829e093f1eddb$export$923f96dd5afa9ce6)({
        source: source,
        db: database,
        rp: retentionPolicy,
        query: query
    });
};
function $8ba03c44d4b91783$export$a052c1f6e3bfad19() {
    return (0, $a537743573e5e486$export$2e2bcd8739ae039)({
        url: '/api/int/v1/show-shards'
    });
}
const $8ba03c44d4b91783$export$a6d803488126746d = async (source, db, measurement, rp)=>{
    const query = `SHOW FIELD KEYS FROM "${rp}"."${measurement}"`;
    return await (0, $aea829e093f1eddb$export$923f96dd5afa9ce6)({
        source: source,
        query: query,
        db: db
    });
};


const $b0c8a009bdea2e59$var$parseShowDatabases = (response)=>{
    const results = response.results[0];
    if (results.error) return {
        errors: [
            results.error
        ],
        databases: []
    };
    const series = results.series[0];
    if (!series.values) return {
        errors: [],
        databases: []
    };
    const databases = series.values.map((s)=>{
        return s[0];
    });
    if (!databases.length) alert('No databases were found.') // eslint-disable-line no-alert
    ;
    return {
        errors: [],
        databases: databases
    };
};
var $b0c8a009bdea2e59$export$2e2bcd8739ae039 = $b0c8a009bdea2e59$var$parseShowDatabases;


function $818475225a3c3c78$export$2e2bcd8739ae039(result) {
    if (result.error) return {
        errors: [
            result.error
        ],
        retentionPolicies: []
    };
    const series = result.series[0];
    if (!series.values) return {
        errors: [],
        retentionPolicies: []
    };
    const columns = series.columns;
    const nameIndex = columns.indexOf('name');
    const durationIndex = columns.indexOf('duration');
    const shardGroupDurationIndex = columns.indexOf('shardGroupDuration');
    const replicationIndex = columns.indexOf('replicaN');
    const defaultIndex = columns.indexOf('default');
    const retentionPolicies = series.values.map((arr)=>{
        return {
            name: arr[nameIndex],
            duration: arr[durationIndex],
            shardGroupDuration: arr[shardGroupDurationIndex],
            replication: arr[replicationIndex],
            isDefault: arr[defaultIndex]
        };
    });
    return {
        errors: [],
        retentionPolicies: retentionPolicies
    };
}


const $cafe5a655b6c1200$var$getRetentionPolices = async (proxy, databases)=>{
    let results = [];
    for(let i = 0; i < databases.length; i++){
        const database = databases[i];
        try {
            const { data: { results: rps } } = await (0, $8ba03c44d4b91783$export$e62df8db5c873ebc)(proxy, database);
            for(let j = 0; j < rps.length; j++){
                const rp = rps[j];
                const { retentionPolicies: retentionPolicies } = (0, $818475225a3c3c78$export$2e2bcd8739ae039)(rp);
                const dbrp = retentionPolicies.map((r)=>({
                        database: database,
                        retentionPolicy: r.name
                    }));
                results = [
                    ...results,
                    ...dbrp
                ];
            }
        } catch (e) {
            console.error(`Unable to show retention policies on ${database}`, e);
        }
    }
    return results;
};
const $cafe5a655b6c1200$export$f279f2817c69d78a = async (proxy)=>{
    try {
        const { data: data } = await (0, $8ba03c44d4b91783$export$46acc72e11cde242)(proxy);
        const { databases: databases } = (0, $b0c8a009bdea2e59$export$2e2bcd8739ae039)(data);
        const namespaces = await $cafe5a655b6c1200$var$getRetentionPolices(proxy, databases);
        const sorted = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).sortBy(namespaces, [
            'database',
            'retentionPolicy'
        ]);
        return sorted;
    } catch (err) {
        console.error(err);
        return [];
    }
};



var $hBdgJ = parcelRequire("hBdgJ");

var $axd2S = parcelRequire("axd2S");

const $f6a5aa1a5f0d59f0$export$8244104593af74a6 = 'linear';
const $f6a5aa1a5f0d59f0$export$c53d0f541b41b88e = 'none';
const $f6a5aa1a5f0d59f0$export$b062928682b6d462 = 'null';
const $f6a5aa1a5f0d59f0$export$4e8bcd47a31d751c = 'number';
const $f6a5aa1a5f0d59f0$export$1411ff8619018a7a = 'previous';



var $hBdgJ = parcelRequire("hBdgJ");
function $38eb15bdc4f4caa2$export$cc083bb740ac7702(obj, path, fallback) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(obj, path, fallback);
}



var $hBdgJ = parcelRequire("hBdgJ");


const $93a523326aa94673$export$f934297ec188c667 = -1;
const $93a523326aa94673$export$f248303b5fb71ab5 = '0';
const $93a523326aa94673$export$6e386ac144cffab5 = 'asc';
const $93a523326aa94673$export$f634ff5a7f1c8f3 = 'desc';
const $93a523326aa94673$export$8ea18fa9e35fdf25 = $93a523326aa94673$export$6e386ac144cffab5;
const $93a523326aa94673$export$b5d4db62f5afa6bb = true;
const $93a523326aa94673$export$b892ed7ad2084288 = true;
const $93a523326aa94673$export$aed77359b4c89f21 = 30;



const $9a9ec629fdd38845$export$e55cd9ddf9185ec0 = 'Untitled Graph';
const $9a9ec629fdd38845$export$b5e5479e319061b6 = 'http://momentjs.com/docs/#/parsing/string-format/';
const $9a9ec629fdd38845$export$2684547e8daa20ef = {
    isEnforced: true,
    digits: 2
};
const $9a9ec629fdd38845$export$af0d6a692d995875 = {
    internalName: 'time',
    displayName: '',
    visible: true
};
const $9a9ec629fdd38845$export$d26a3a0fb696ceaa = {
    internalName: '_time',
    displayName: '',
    visible: true
};
const $9a9ec629fdd38845$export$88bc4ccd9afcdcbc = {
    verticalTimeAxis: (0, $93a523326aa94673$export$b892ed7ad2084288),
    sortBy: $9a9ec629fdd38845$export$af0d6a692d995875,
    wrapping: 'truncate',
    fixFirstColumn: (0, $93a523326aa94673$export$b5d4db62f5afa6bb)
};
const $9a9ec629fdd38845$export$c4d2eaadfa3c28df = 'MM/DD/YYYY HH:mm:ss';
const $9a9ec629fdd38845$export$158214ea299486a9 = 'Custom';
const $9a9ec629fdd38845$export$da35197b3e8f20d0 = [
    {
        format: $9a9ec629fdd38845$export$c4d2eaadfa3c28df
    },
    {
        format: 'MM/DD/YYYY HH:mm:ss.SSS'
    },
    {
        format: 'YYYY-MM-DD HH:mm:ss'
    },
    {
        format: 'HH:mm:ss'
    },
    {
        format: 'HH:mm:ss.SSS'
    },
    {
        format: 'MMMM D, YYYY HH:mm:ss'
    },
    {
        format: 'dddd, MMMM D, YYYY HH:mm:ss'
    },
    {
        format: 'X',
        text: 'Unix Time'
    },
    {
        format: 'x',
        text: 'Unix Time (milliseconds)'
    },
    {
        format: $9a9ec629fdd38845$export$158214ea299486a9
    }
];
const $9a9ec629fdd38845$export$f734b87dadf30a98 = [
    $9a9ec629fdd38845$export$af0d6a692d995875
];
const $9a9ec629fdd38845$export$5555fe053dab8f56 = {
    x: 0,
    y: 0,
    w: 4,
    h: 4,
    name: $9a9ec629fdd38845$export$e55cd9ddf9185ec0,
    type: (0, $b4506126e09430df$export$705e36171f4cbbfe).Line,
    queries: [],
    tableOptions: $9a9ec629fdd38845$export$88bc4ccd9afcdcbc,
    timeFormat: $9a9ec629fdd38845$export$c4d2eaadfa3c28df,
    decimalPlaces: $9a9ec629fdd38845$export$2684547e8daa20ef,
    fieldOptions: $9a9ec629fdd38845$export$f734b87dadf30a98,
    inView: true,
    note: '',
    noteVisibility: (0, $b4506126e09430df$export$2c5a562a272706f8).Default
};
const $9a9ec629fdd38845$export$5dcea635764b8e5d = {
    id: '0',
    name: '',
    cells: [
        {
            x: 0,
            y: 0,
            queries: [],
            name: 'Loading...',
            type: (0, $b4506126e09430df$export$705e36171f4cbbfe).Line
        }
    ]
};
const $9a9ec629fdd38845$export$de748f9c6ef6e33d = 'Name This Dashboard';
const $9a9ec629fdd38845$export$d1428f2d92ff8e06 = {
    name: $9a9ec629fdd38845$export$de748f9c6ef6e33d,
    cells: [
        $9a9ec629fdd38845$export$5555fe053dab8f56
    ]
};
const $9a9ec629fdd38845$export$2b1ba191e5fea4cb = {
    name: $9a9ec629fdd38845$export$de748f9c6ef6e33d,
    cells: []
};
const $9a9ec629fdd38845$export$797ae35c568d4e70 = 'queryConfig';
const $9a9ec629fdd38845$export$dcffce4823e82712 = 'shifted queryConfig';
const $9a9ec629fdd38845$export$e4dbfeaaa93e8334 = 'flux';
const $9a9ec629fdd38845$export$11ca3f7205bba4a6 = 50;
var $9a9ec629fdd38845$export$b11a09459547fdbb = /*#__PURE__*/ function(CEOTabs) {
    CEOTabs["Queries"] = "Queries";
    CEOTabs["Vis"] = "Visualization";
    return CEOTabs;
}({});
const $9a9ec629fdd38845$export$88bc046c68ada5a7 = 20 // 20 is the max input to maximumFractionDigits in spec for tolocalestring
;
const $9a9ec629fdd38845$export$a45f245a164ecd67 = '0';
const $9a9ec629fdd38845$export$feaf255c45293dde = $9a9ec629fdd38845$export$88bc046c68ada5a7.toString();
const $9a9ec629fdd38845$export$1b9fd6004a8bc39d = 'dynamic';
const $9a9ec629fdd38845$export$e7bcaad447239ce9 = {
    name: 'Dynamic Source',
    id: $9a9ec629fdd38845$export$1b9fd6004a8bc39d,
    link: ''
};
const $9a9ec629fdd38845$export$46f395fdcdd36a73 = {
    text: 'Dynamic Source',
    sourceInfo: $9a9ec629fdd38845$export$e7bcaad447239ce9,
    importedSourceID: ''
};
const $9a9ec629fdd38845$export$bd9dc338f9c12ec3 = '#292933';
const $9a9ec629fdd38845$export$8f907bc493a43910 = '#FFFFFF';



var $axd2S = parcelRequire("axd2S");
const $11d088397ea0d681$export$8cd2c3eb7eeb9644 = 'absolute';
const $11d088397ea0d681$export$9a105a556e65c2c0 = 'invalid';
const $11d088397ea0d681$export$28d4b82bac2e3b8f = 'relative lower';
const $11d088397ea0d681$export$367ce0effbd3984f = 'relative upper';


const $f109de13c5b1b325$var$now = /^now|^:/ // ether now() or variable reference (':dashboardTime:') is present
;
const $f109de13c5b1b325$export$358d714cd99a37c9 = ({ upper: upper, lower: lower })=>{
    if (!upper && !lower) return 0, $11d088397ea0d681$export$9a105a556e65c2c0;
    const isUpperValid = upper !== null && upper !== undefined && upper !== '' && (upper === ':upperDashboardTime:' || (0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(new Date(upper)).isValid());
    const isLowerValid = lower !== null && lower !== undefined && lower !== '' && (lower === ':dashboardTime:' || (0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(new Date(lower)).isValid());
    // {lower: <Date>, upper: <Date>}
    if (isLowerValid && isUpperValid) return 0, $11d088397ea0d681$export$8cd2c3eb7eeb9644;
    // {lower: now - <Duration>, upper: <empty>}
    if ($f109de13c5b1b325$var$now.test(lower) && !upper) return 0, $11d088397ea0d681$export$28d4b82bac2e3b8f;
    // {lower: <Date>, upper: now() - <Duration>}
    if (isLowerValid && $f109de13c5b1b325$var$now.test(upper)) return 0, $11d088397ea0d681$export$367ce0effbd3984f;
    return 0, $11d088397ea0d681$export$9a105a556e65c2c0;
};
const $f109de13c5b1b325$export$2f7d78e497ad7488 = (timeRange, shift)=>{
    const { upper: upper, lower: lower } = timeRange;
    const { quantity: quantity, unit: unit } = shift;
    const trType = $f109de13c5b1b325$export$358d714cd99a37c9(timeRange);
    const duration = `${quantity}${unit}`;
    const type = 'shifted';
    switch(trType){
        case 0, $11d088397ea0d681$export$367ce0effbd3984f:
        case 0, $11d088397ea0d681$export$8cd2c3eb7eeb9644:
            return {
                lower: `${lower} - ${duration}`,
                upper: `${upper} - ${duration}`,
                type: type
            };
        case 0, $11d088397ea0d681$export$28d4b82bac2e3b8f:
            return {
                lower: `${lower} - ${duration}`,
                upper: `now() - ${duration}`,
                type: type
            };
        default:
            return {
                lower: lower,
                upper: upper,
                type: 'unshifted'
            };
    }
};
const $f109de13c5b1b325$var$getMomentUnit = (unit)=>{
    switch(unit){
        case 'ms':
            return 'milliseconds' // (1 thousandth of a second)
            ;
        case 's':
            return 'seconds';
        case 'm':
            return 'minute';
        case 'h':
            return 'hour';
        case 'd':
            return 'day';
        case 'w':
            return 'week';
        default:
            return unit;
    }
};
const $f109de13c5b1b325$export$a9cf507efa7582ec = (date, quantity, unit)=>{
    if (!date && !quantity && !unit) return (0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(new Date(date));
    return (0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(new Date(date)).add(quantity, $f109de13c5b1b325$var$getMomentUnit(unit));
};


const $7b2c5b24a44a7fa2$export$5fcf45c3fdcbaeb = ({ lower: lower, upper: upper })=>{
    if (lower && lower.includes('Z') && !lower.includes("'")) lower = `'${lower}'`;
    if (upper && upper.includes('Z') && !upper.includes("'")) upper = `'${upper}'`;
    return {
        lower: lower,
        upper: upper
    };
};
function $7b2c5b24a44a7fa2$export$2e2bcd8739ae039(timeRange, config, shift = '') {
    const { groupBy: groupBy, fill: fill = (0, $f6a5aa1a5f0d59f0$export$b062928682b6d462), tags: tags, areTagsAccepted: areTagsAccepted } = config;
    const { upper: upper, lower: lower } = $7b2c5b24a44a7fa2$export$5fcf45c3fdcbaeb(timeRange);
    const select = $7b2c5b24a44a7fa2$export$ff0a4e3f5a9742b3(config, shift);
    if (select === null) return null;
    const condition = $7b2c5b24a44a7fa2$export$d4e107226769a0eb({
        lower: lower,
        upper: upper,
        tags: tags,
        areTagsAccepted: areTagsAccepted
    });
    const dimensions = $7b2c5b24a44a7fa2$export$66bfdb29881e6b31(groupBy);
    const fillClause = groupBy.time ? $7b2c5b24a44a7fa2$export$b0c11a0599a6b63a(fill) : '';
    return `${select}${condition}${dimensions}${fillClause}`;
}
function $7b2c5b24a44a7fa2$export$ff0a4e3f5a9742b3({ fields: fields, database: database, retentionPolicy: retentionPolicy, measurement: measurement }, shift = null) {
    if (!database || !measurement || (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEmpty(fields)) return null;
    const rpSegment = retentionPolicy ? `"${retentionPolicy}"` : '';
    const fieldsClause = $7b2c5b24a44a7fa2$var$buildFields(fields, shift).join(', ');
    const fullyQualifiedMeasurement = `"${database}".${rpSegment}."${measurement}"`;
    const statement = `SELECT ${fieldsClause} FROM ${fullyQualifiedMeasurement}`;
    return statement;
}
const $7b2c5b24a44a7fa2$export$d7b58f10109feb02 = (type, timeRange, config, shift = null)=>{
    switch(type){
        case 0, $9a9ec629fdd38845$export$797ae35c568d4e70:
            return $7b2c5b24a44a7fa2$export$2e2bcd8739ae039(timeRange, config);
        case 0, $9a9ec629fdd38845$export$dcffce4823e82712:
            {
                const { quantity: quantity, unit: unit } = shift;
                return $7b2c5b24a44a7fa2$export$2e2bcd8739ae039((0, $f109de13c5b1b325$export$2f7d78e497ad7488)(timeRange, shift), config, `_shifted__${quantity}__${unit}`);
            }
        case 0, $9a9ec629fdd38845$export$e4dbfeaaa93e8334:
    }
    return $7b2c5b24a44a7fa2$export$2e2bcd8739ae039(timeRange, config);
};
function $7b2c5b24a44a7fa2$export$363bc26e1dad7709(config) {
    return $7b2c5b24a44a7fa2$export$ff0a4e3f5a9742b3(config);
}
function $7b2c5b24a44a7fa2$var$buildFields(fieldFuncs, shift = '', useAlias = true) {
    if (!fieldFuncs) return [];
    return fieldFuncs.map((f)=>{
        switch(f.type){
            case 'field':
                {
                    const quoted = f.value === '*' ? '*' : `"${f.value}"`;
                    const aliased = useAlias && f.alias ? `${quoted} AS "${f.alias}"` : quoted;
                    return aliased;
                }
            case 'wildcard':
                return '*';
            case 'regex':
                return `/${f.value}/`;
            case 'number':
                return `${f.value}`;
            case 'integer':
                return `${f.value}`;
            case 'func':
                {
                    const args = $7b2c5b24a44a7fa2$var$buildFields(f.args, '', false);
                    const alias = f.alias ? ` AS "${f.alias}${shift}"` : '';
                    return `${f.value}(${args.join(', ')})${alias}`;
                }
            case 'infixfunc':
                {
                    const args = $7b2c5b24a44a7fa2$var$buildFields(f.args, '', false);
                    const alias = f.alias ? ` AS "${f.alias}"` : '';
                    return `${args[0]}${f.value}${args[1]}${alias}`;
                }
        }
    });
}
function $7b2c5b24a44a7fa2$export$d4e107226769a0eb({ lower: lower, upper: upper, tags: tags, areTagsAccepted: areTagsAccepted }) {
    const timeClauses = [];
    const timeClause = $7b2c5b24a44a7fa2$export$5fcf45c3fdcbaeb({
        lower: lower,
        upper: upper
    });
    if (timeClause.lower) timeClauses.push(`time > ${lower}`);
    if (timeClause.upper) timeClauses.push(`time < ${upper}`);
    // If a tag key has more than one tag value and areTagsAccepted is true
    // join the tag key with OR (i.e. cpu=cpu1 OR cpu=cpu2)
    // otherwise
    // join the tag key with an AND (i.e. cpu!=cpu1 AND cpu!=cpu2)
    // we do this because cpu!=cpu1 AND cpu!=cpu2 excludes no data
    const tagClauses = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).keys(tags).map((k)=>{
        const operator = areTagsAccepted ? '=' : '!=';
        const cond = areTagsAccepted ? ' OR ' : ' AND ';
        if (tags[k].length > 1) {
            const joinedOnOr = tags[k].map((v)=>`"${k}"${operator}'${v.replace(/'/g, "\\'")}'`).join(cond);
            return `(${joinedOnOr})`;
        }
        return `"${k}"${operator}'${tags[k].map((v)=>v.replace(/'/g, "\\'"))}'`;
    });
    const subClauses = timeClauses.concat(tagClauses);
    if (!subClauses.length) return '';
    return ` WHERE ${subClauses.join(' AND ')}`;
}
function $7b2c5b24a44a7fa2$export$66bfdb29881e6b31(groupBy) {
    return `${$7b2c5b24a44a7fa2$var$buildGroupByTime(groupBy)}${$7b2c5b24a44a7fa2$var$buildGroupByTags(groupBy)}`;
}
function $7b2c5b24a44a7fa2$var$buildGroupByTime(groupBy) {
    if (!groupBy || !groupBy.time) return '';
    return ` GROUP BY time(${groupBy.time === (0, $e10a8602f56394e3$export$4d7f0cfe7906cfdf) ? (0, $e10a8602f56394e3$export$77e8fbcbea0ce430) : `${groupBy.time}`})`;
}
function $7b2c5b24a44a7fa2$var$buildGroupByTags(groupBy) {
    if (!groupBy || !groupBy.tags.length) return '';
    const tags = groupBy.tags.map((t)=>`"${t}"`).join(', ');
    if (groupBy.time) return `, ${tags}`;
    return ` GROUP BY ${tags}`;
}
function $7b2c5b24a44a7fa2$export$b0c11a0599a6b63a(fill) {
    return ` FILL(${fill})`;
}
const $7b2c5b24a44a7fa2$export$1dad96b972e94224 = (config, timeRange)=>config.rawText || $7b2c5b24a44a7fa2$export$2e2bcd8739ae039(timeRange, config) || '';





const $0e5f1280af745b44$export$5b03906d1b94e9d1 = async (proxyLink, namespace, query)=>{
    const { data: data } = await (0, $aea829e093f1eddb$export$923f96dd5afa9ce6)({
        source: proxyLink,
        db: namespace.database,
        rp: namespace.retentionPolicy,
        query: query
    });
    return data;
};
const $0e5f1280af745b44$export$14cabb7f53ef78fa = async (url)=>{
    try {
        return await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'GET',
            url: url
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $0e5f1280af745b44$export$65697e22a0a2f56e = async (url, logConfig)=>{
    try {
        return await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'PUT',
            url: url,
            data: logConfig
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $0e5f1280af745b44$export$4829de2798d13ca2 = async (proxyLink, namespace)=>{
    const query = (0, $39ae7dd6f6a41115$export$678ee9df1e23425d)(namespace, 'syslog');
    return $0e5f1280af745b44$export$5b03906d1b94e9d1(proxyLink, namespace, query);
};


const $17fe399301a568db$export$c4d2eaadfa3c28df = 'YYYY-MM-DD HH:mm:ss';
const $17fe399301a568db$export$5a9d40b22b614c94 = '_timestamp_nsinms';
const $17fe399301a568db$export$2fbfd2daf30e95ae = {
    type: 'infixfunc',
    value: '%',
    alias: $17fe399301a568db$export$5a9d40b22b614c94,
    args: [
        {
            type: 'field',
            value: 'timestamp'
        },
        {
            type: 'integer',
            value: '1000000'
        }
    ]
};
var $17fe399301a568db$export$4882b5974b950793 = /*#__PURE__*/ function(SeverityColorOptions) {
    SeverityColorOptions["ruby"] = "ruby";
    SeverityColorOptions["fire"] = "fire";
    SeverityColorOptions["curacao"] = "curacao";
    SeverityColorOptions["tiger"] = "tiger";
    SeverityColorOptions["pineapple"] = "pineapple";
    SeverityColorOptions["thunder"] = "thunder";
    SeverityColorOptions["sulfur"] = "sulfur";
    SeverityColorOptions["viridian"] = "viridian";
    SeverityColorOptions["rainforest"] = "rainforest";
    SeverityColorOptions["honeydew"] = "honeydew";
    SeverityColorOptions["ocean"] = "ocean";
    SeverityColorOptions["pool"] = "pool";
    SeverityColorOptions["laser"] = "laser";
    SeverityColorOptions["planet"] = "planet";
    SeverityColorOptions["star"] = "star";
    SeverityColorOptions["comet"] = "comet";
    SeverityColorOptions["graphite"] = "graphite";
    SeverityColorOptions["wolf"] = "wolf";
    SeverityColorOptions["mist"] = "mist";
    SeverityColorOptions["pearl"] = "pearl";
    return SeverityColorOptions;
}({});
const $17fe399301a568db$export$c9677b4901769799 = true;
const $17fe399301a568db$export$6cbcd37aa6bd16b6 = {
    ["ruby"]: '#BF3D5E',
    ["fire"]: '#DC4E58',
    ["curacao"]: '#F95F53',
    ["tiger"]: '#F48D38',
    ["pineapple"]: '#FFB94A',
    ["thunder"]: '#FFD255',
    ["sulfur"]: '#FFE480',
    ["viridian"]: '#32B08C',
    ["rainforest"]: '#4ED8A0',
    ["honeydew"]: '#7CE490',
    ["ocean"]: '#4591ED',
    ["pool"]: '#22ADF6',
    ["laser"]: '#00C9FF',
    ["planet"]: '#513CC6',
    ["star"]: '#7A65F2',
    ["comet"]: '#9394FF',
    ["graphite"]: '#545667',
    ["wolf"]: '#8E91A1',
    ["mist"]: '#BEC2CC',
    ["pearl"]: '#E7E8EB'
};
const $17fe399301a568db$export$64b7befa177cf511 = [
    {
        hex: $17fe399301a568db$export$6cbcd37aa6bd16b6["ruby"],
        name: "ruby"
    },
    {
        hex: $17fe399301a568db$export$6cbcd37aa6bd16b6["fire"],
        name: "fire"
    },
    {
        hex: $17fe399301a568db$export$6cbcd37aa6bd16b6["curacao"],
        name: "curacao"
    },
    {
        hex: $17fe399301a568db$export$6cbcd37aa6bd16b6["tiger"],
        name: "tiger"
    },
    {
        hex: $17fe399301a568db$export$6cbcd37aa6bd16b6["pineapple"],
        name: "pineapple"
    },
    {
        hex: $17fe399301a568db$export$6cbcd37aa6bd16b6["thunder"],
        name: "thunder"
    },
    {
        hex: $17fe399301a568db$export$6cbcd37aa6bd16b6["sulfur"],
        name: "sulfur"
    },
    {
        hex: $17fe399301a568db$export$6cbcd37aa6bd16b6["viridian"],
        name: "viridian"
    },
    {
        hex: $17fe399301a568db$export$6cbcd37aa6bd16b6["rainforest"],
        name: "rainforest"
    },
    {
        hex: $17fe399301a568db$export$6cbcd37aa6bd16b6["honeydew"],
        name: "honeydew"
    },
    {
        hex: $17fe399301a568db$export$6cbcd37aa6bd16b6["ocean"],
        name: "ocean"
    },
    {
        hex: $17fe399301a568db$export$6cbcd37aa6bd16b6["pool"],
        name: "pool"
    },
    {
        hex: $17fe399301a568db$export$6cbcd37aa6bd16b6["laser"],
        name: "laser"
    },
    {
        hex: $17fe399301a568db$export$6cbcd37aa6bd16b6["planet"],
        name: "planet"
    },
    {
        hex: $17fe399301a568db$export$6cbcd37aa6bd16b6["star"],
        name: "star"
    },
    {
        hex: $17fe399301a568db$export$6cbcd37aa6bd16b6["comet"],
        name: "comet"
    },
    {
        hex: $17fe399301a568db$export$6cbcd37aa6bd16b6["graphite"],
        name: "graphite"
    },
    {
        hex: $17fe399301a568db$export$6cbcd37aa6bd16b6["wolf"],
        name: "wolf"
    },
    {
        hex: $17fe399301a568db$export$6cbcd37aa6bd16b6["mist"],
        name: "mist"
    },
    {
        hex: $17fe399301a568db$export$6cbcd37aa6bd16b6["pearl"],
        name: "pearl"
    }
];
var $17fe399301a568db$export$4f069e5a50708cd4 = /*#__PURE__*/ function(SeverityLevelOptions) {
    SeverityLevelOptions["emerg"] = "emerg";
    SeverityLevelOptions["alert"] = "alert";
    SeverityLevelOptions["crit"] = "crit";
    SeverityLevelOptions["err"] = "err";
    SeverityLevelOptions["warning"] = "warning";
    SeverityLevelOptions["notice"] = "notice";
    SeverityLevelOptions["info"] = "info";
    SeverityLevelOptions["debug"] = "debug";
    return SeverityLevelOptions;
}({});
const $17fe399301a568db$export$44d8d03845f535a9 = {
    ["emerg"]: 1,
    ["alert"]: 2,
    ["crit"]: 3,
    ["err"]: 4,
    ["warning"]: 5,
    ["notice"]: 6,
    ["info"]: 7,
    ["debug"]: 8
};
const $17fe399301a568db$export$55a84d26829aa31 = {
    ["emerg"]: "ruby",
    ["alert"]: "fire",
    ["crit"]: "curacao",
    ["err"]: "tiger",
    ["warning"]: "pineapple",
    ["notice"]: "rainforest",
    ["info"]: "star",
    ["debug"]: "wolf"
};
var $17fe399301a568db$export$85ce1201a2cc2824 = /*#__PURE__*/ function(SeverityFormatOptions) {
    SeverityFormatOptions["dot"] = "dot";
    SeverityFormatOptions["dotText"] = "dotText";
    SeverityFormatOptions["text"] = "text";
    return SeverityFormatOptions;
}({});
var $17fe399301a568db$export$6592cb873eed5846 = /*#__PURE__*/ function(EncodingTypes) {
    EncodingTypes["visibility"] = "visibility";
    EncodingTypes["display"] = "displayName";
    EncodingTypes["label"] = "label";
    EncodingTypes["color"] = "color";
    return EncodingTypes;
}({});
var $17fe399301a568db$export$98bdffdcaa237968 = /*#__PURE__*/ function(EncodingLabelOptions) {
    EncodingLabelOptions["text"] = "text";
    EncodingLabelOptions["icon"] = "icon";
    return EncodingLabelOptions;
}({});
var $17fe399301a568db$export$feec8660ecb73f20 = /*#__PURE__*/ function(EncodingVisibilityOptions) {
    EncodingVisibilityOptions["visible"] = "visible";
    EncodingVisibilityOptions["hidden"] = "hidden";
    return EncodingVisibilityOptions;
}({});
const $17fe399301a568db$var$MINUTE = 60;
const $17fe399301a568db$var$HOUR = 60 * $17fe399301a568db$var$MINUTE;
const $17fe399301a568db$var$DAY = 24 * $17fe399301a568db$var$HOUR;
const $17fe399301a568db$export$d06a86d34e567220 = [
    {
        text: '1m',
        seconds: $17fe399301a568db$var$MINUTE
    },
    {
        text: '5m',
        seconds: 5 * $17fe399301a568db$var$MINUTE
    },
    {
        text: '1h',
        seconds: $17fe399301a568db$var$HOUR
    },
    {
        text: '6h',
        seconds: 6 * $17fe399301a568db$var$HOUR
    },
    {
        text: '12h',
        seconds: 12 * $17fe399301a568db$var$HOUR
    },
    {
        text: '24h',
        seconds: $17fe399301a568db$var$DAY
    },
    {
        text: '7d',
        seconds: 7 * $17fe399301a568db$var$DAY
    },
    {
        text: '30d',
        seconds: 30 * $17fe399301a568db$var$DAY
    }
];
const $17fe399301a568db$export$86e73ff840e5234 = 0.6;
const $17fe399301a568db$export$d45b825de1ee1bc4 = 0.2;
const $17fe399301a568db$export$ac31e7baba4e5d05 = 1000;
const $17fe399301a568db$export$6f8f9ddc0aeaa6ed = 5000;
const $17fe399301a568db$export$2783d45bfefa692a = 30000;
const $17fe399301a568db$export$fd748333000462a8 = 30000;
const $17fe399301a568db$export$dccafea29eb05d53 = 30000;
const $17fe399301a568db$export$ecb408e1f47ed474 = 0;
const $17fe399301a568db$var$NEWER_CHUNK_SIZE_LIMIT = 100;
const $17fe399301a568db$var$OLDER_CHUNK_SIZE_LIMIT = 100;
const $17fe399301a568db$var$MAX_FETCH_COUNT = Infinity // never stop fetching
;
const $17fe399301a568db$var$MAX_NO_CHANGE_FETCH_COUNT = 10 // but stop after no data are received after a few attempts
;
const $17fe399301a568db$export$8c3b0a2072972ae8 = {
    maxFetchCount: $17fe399301a568db$var$MAX_FETCH_COUNT,
    maxNoChangeFetchCount: $17fe399301a568db$var$MAX_NO_CHANGE_FETCH_COUNT,
    chunkSize: $17fe399301a568db$var$NEWER_CHUNK_SIZE_LIMIT
};
const $17fe399301a568db$export$355b6eb3ee30bab9 = {
    maxFetchCount: $17fe399301a568db$var$MAX_FETCH_COUNT,
    maxNoChangeFetchCount: $17fe399301a568db$var$MAX_NO_CHANGE_FETCH_COUNT,
    chunkSize: $17fe399301a568db$var$OLDER_CHUNK_SIZE_LIMIT
};
const $17fe399301a568db$export$5c00ad534c3ef603 = {
    columns: [
        'time',
        'severity',
        'timestamp',
        'message',
        'facility',
        'procid',
        'appname',
        'hostname',
        'host'
    ],
    values: []
};


const $39ae7dd6f6a41115$var$BIN_COUNT = 30;
const $39ae7dd6f6a41115$var$histogramFields = [
    {
        alias: '',
        args: [
            {
                alias: 'message',
                type: 'field',
                value: 'message'
            }
        ],
        type: 'func',
        value: 'count'
    }
];
const $39ae7dd6f6a41115$var$tableFields = [
    {
        alias: 'severity',
        type: 'field',
        value: 'severity'
    },
    {
        alias: 'timestamp',
        type: 'field',
        value: 'timestamp'
    },
    {
        alias: 'message',
        type: 'field',
        value: 'message'
    },
    {
        alias: 'facility',
        type: 'field',
        value: 'facility'
    },
    {
        alias: 'procid',
        type: 'field',
        value: 'procid'
    },
    {
        alias: 'appname',
        type: 'field',
        value: 'appname'
    },
    {
        alias: 'hostname',
        type: 'field',
        value: 'hostname'
    },
    {
        alias: 'host',
        type: 'field',
        value: 'host'
    }
];
const $39ae7dd6f6a41115$var$defaultQueryConfig = {
    areTagsAccepted: false,
    fill: '0',
    measurement: 'syslog',
    rawText: null,
    shifts: [],
    tags: {}
};
const $39ae7dd6f6a41115$var$keyMapping = (key)=>{
    switch(key){
        case 'severity_1':
            return 'severity';
        default:
            return key;
    }
};
const $39ae7dd6f6a41115$var$operatorMapping = (operator)=>{
    switch(operator){
        case '==':
            return '=';
        default:
            return operator;
    }
};
/* eslint-disable @typescript-eslint/no-base-to-string */ const $39ae7dd6f6a41115$var$valueMapping = (operator, value)=>{
    if (operator === '=~' || operator === '!~') return `${new RegExp(value)}`;
    return `'${value}'`;
};
const $39ae7dd6f6a41115$export$4cbbe566ed6d411d = (filters)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).map(filters, (filter)=>`"${$39ae7dd6f6a41115$var$keyMapping(filter.key)}" ${$39ae7dd6f6a41115$var$operatorMapping(filter.operator)} ${$39ae7dd6f6a41115$var$valueMapping(filter.operator, filter.value)}`).join(' AND ');
};
function $39ae7dd6f6a41115$export$9cf9b10af1a41e2e({ lower: lower, upper: upper, tags: tags, areTagsAccepted: areTagsAccepted }) {
    const timeClauses = [];
    if (lower) timeClauses.push(`time >= '${lower}'`);
    if (upper) timeClauses.push(`time < '${upper}'`);
    const tagClauses = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).keys(tags).map((k)=>{
        const operator = areTagsAccepted ? '=' : '!=';
        if (tags[k].length > 1) {
            const joinedOnOr = tags[k].map((v)=>`"${k}"${operator}'${v}'`).join(' OR ');
            return `(${joinedOnOr})`;
        }
        return `"${k}"${operator}'${tags[k]}'`;
    });
    const subClauses = timeClauses.concat(tagClauses);
    if (!subClauses.length) return '';
    return ` WHERE ${subClauses.join(' AND ')}`;
}
/* eslint-disable @typescript-eslint/no-base-to-string */ function $39ae7dd6f6a41115$var$buildGeneralLogQuery(condition, config, filters, searchTerm = null) {
    const { groupBy: groupBy, fill: fill = (0, $f6a5aa1a5f0d59f0$export$b062928682b6d462) } = config;
    const select = (0, $7b2c5b24a44a7fa2$export$ff0a4e3f5a9742b3)(config, '');
    const dimensions = (0, $7b2c5b24a44a7fa2$export$66bfdb29881e6b31)(groupBy);
    const fillClause = groupBy.time ? (0, $7b2c5b24a44a7fa2$export$b0c11a0599a6b63a)(fill) : '';
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEmpty(searchTerm)) condition = `${condition} AND message =~ ${new RegExp(searchTerm)}`;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEmpty(filters)) condition = `${condition} AND ${$39ae7dd6f6a41115$export$4cbbe566ed6d411d(filters)}`;
    return `${select}${condition}${dimensions}${fillClause}`;
}
async function $39ae7dd6f6a41115$export$1b112b2ea3fe278e(lower, upper, config, filters, searchTerm, proxyLink, namespace) {
    const { database: database, retentionPolicy: retentionPolicy, measurement: measurement } = config;
    let rpSegment = '';
    if (retentionPolicy) rpSegment = `"${retentionPolicy}"`;
    const fullyQualifiedMeasurement = `"${database}".${rpSegment}."${measurement}"`;
    const select = `SELECT count(message) FROM ${fullyQualifiedMeasurement}`;
    let condition = `WHERE time >= '${lower}' AND time <='${upper}'`;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEmpty(searchTerm)) condition = `${condition} AND "message" =~ ${new RegExp(searchTerm)}`;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEmpty(filters)) condition = `${condition} AND ${$39ae7dd6f6a41115$export$4cbbe566ed6d411d(filters)}`;
    const query = `${select} ${condition} FILL(0)`;
    const result = await (0, $0e5f1280af745b44$export$5b03906d1b94e9d1)(proxyLink, namespace, query);
    return (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(result, 'results.0.series.0.values.0.1', 0);
}
function $39ae7dd6f6a41115$export$b9e962ff9ce3c1b2(lower, upper, config, filters, searchTerm = null) {
    const { tags: tags, areTagsAccepted: areTagsAccepted } = config;
    const condition = $39ae7dd6f6a41115$export$9cf9b10af1a41e2e({
        lower: lower,
        upper: upper,
        tags: tags,
        areTagsAccepted: areTagsAccepted
    });
    // add extra "_timestamp_ns" field to be able to know precise nanosecond time
    // with full precision that is lost during JSON deserialization to number
    config = {
        ...config,
        fields: [
            ...config.fields,
            (0, $17fe399301a568db$export$2fbfd2daf30e95ae)
        ]
    };
    return $39ae7dd6f6a41115$var$buildGeneralLogQuery(condition, config, filters, searchTerm);
}
function $39ae7dd6f6a41115$export$bb159e1ae1c9d804(timeRange, config, filters, searchTerm = null) {
    const { groupBy: groupBy, fill: fill = (0, $f6a5aa1a5f0d59f0$export$b062928682b6d462), tags: tags, areTagsAccepted: areTagsAccepted } = config;
    const { upper: upper, lower: lower } = (0, $7b2c5b24a44a7fa2$export$5fcf45c3fdcbaeb)(timeRange);
    const select = (0, $7b2c5b24a44a7fa2$export$ff0a4e3f5a9742b3)(config, '');
    const dimensions = (0, $7b2c5b24a44a7fa2$export$66bfdb29881e6b31)(groupBy);
    const fillClause = groupBy.time ? (0, $7b2c5b24a44a7fa2$export$b0c11a0599a6b63a)(fill) : '';
    let condition = (0, $7b2c5b24a44a7fa2$export$d4e107226769a0eb)({
        lower: lower,
        upper: upper,
        tags: tags,
        areTagsAccepted: areTagsAccepted
    });
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEmpty(searchTerm)) condition = `${condition} AND message =~ ${new RegExp(searchTerm)}`;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEmpty(filters)) condition = `${condition} AND ${$39ae7dd6f6a41115$export$4cbbe566ed6d411d(filters)}`;
    return `${select}${condition}${dimensions}${fillClause}`;
}
const $39ae7dd6f6a41115$var$computeSeconds = (range)=>{
    const { upper: upper, lower: lower, seconds: seconds } = range;
    if (seconds) return seconds;
    else if (upper && upper.match(/now/) && lower) return (0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))().unix() - (0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(lower).unix();
    else if (upper && lower) return (0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(upper).unix() - (0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(lower).unix();
    return 120;
};
const $39ae7dd6f6a41115$var$createGroupBy = (range)=>{
    const seconds = $39ae7dd6f6a41115$var$computeSeconds(range);
    const time = `${Math.max(Math.floor(seconds / $39ae7dd6f6a41115$var$BIN_COUNT), 1)}s`;
    const tags = [
        'severity'
    ];
    return {
        time: time,
        tags: tags
    };
};
const $39ae7dd6f6a41115$export$d149e9eea50f66d8 = (namespace, range)=>{
    const id = (0, $dbdc5944552afab7$export$2e2bcd8739ae039)();
    const { database: database, retentionPolicy: retentionPolicy } = namespace;
    return {
        ...$39ae7dd6f6a41115$var$defaultQueryConfig,
        id: id,
        range: range,
        database: database,
        retentionPolicy: retentionPolicy,
        groupBy: $39ae7dd6f6a41115$var$createGroupBy(range),
        fields: $39ae7dd6f6a41115$var$histogramFields
    };
};
const $39ae7dd6f6a41115$export$566fa0dcbc1c34ab = (namespace, range)=>{
    const id = (0, $dbdc5944552afab7$export$2e2bcd8739ae039)();
    const { database: database, retentionPolicy: retentionPolicy } = namespace;
    return {
        ...$39ae7dd6f6a41115$var$defaultQueryConfig,
        id: id,
        range: range,
        database: database,
        retentionPolicy: retentionPolicy,
        groupBy: {
            tags: []
        },
        fields: $39ae7dd6f6a41115$var$tableFields,
        fill: null
    };
};
const $39ae7dd6f6a41115$export$5d1e524f0b690a50 = (response)=>{
    const series = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(response, 'results.0.series', []);
    const data = series.reduce((acc, current)=>{
        const group = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(current, 'tags.severity', '');
        if (!current.columns || !current.values) return acc;
        const timeColIndex = current.columns.findIndex((v)=>v === 'time');
        const countColIndex = current.columns.findIndex((v)=>v === 'count');
        if (timeColIndex < 0 || countColIndex < 0) return acc;
        const vs = current.values.map((v)=>{
            const time = v[timeColIndex];
            const value = v[countColIndex];
            return {
                key: `${group}-${value}-${time}`,
                time: time,
                value: value,
                group: group
            };
        });
        return [
            ...acc,
            ...vs
        ];
    }, []);
    return data;
};
const $39ae7dd6f6a41115$export$3203edd9e5edd663 = (time)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(time).format((0, $17fe399301a568db$export$c4d2eaadfa3c28df));
};
const $39ae7dd6f6a41115$export$678ee9df1e23425d = (namespace, measurement)=>`SHOW MEASUREMENTS ON "${namespace.database}" WITH measurement = "${measurement}"`;



var $hBdgJ = parcelRequire("hBdgJ");

const $8aa3fe7759a0c09b$export$f5dd0497de3eac55 = (serverConfig)=>{
    const columns = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(serverConfig, 'columns', []);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEmpty(columns)) return;
    const sortedColumns = $8aa3fe7759a0c09b$export$87aff0579c3b839c(columns);
    let severityFormat;
    let severityLevelColors;
    const convertedColumns = sortedColumns.map((c)=>{
        if (c.name === 'severity') {
            severityFormat = $8aa3fe7759a0c09b$export$e7cde8e6e3c80be8(c);
            severityLevelColors = $8aa3fe7759a0c09b$export$5bd2ada171761d50(c);
        }
        return $8aa3fe7759a0c09b$export$bea1f06f38773ae9(c);
    });
    return {
        tableColumns: convertedColumns,
        severityFormat: severityFormat,
        severityLevelColors: severityLevelColors,
        isTruncated: (0, $17fe399301a568db$export$c9677b4901769799)
    };
};
const $8aa3fe7759a0c09b$export$87aff0579c3b839c = (columns)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).sortBy(columns, (c)=>c.position);
};
const $8aa3fe7759a0c09b$export$bea1f06f38773ae9 = (column)=>{
    const internalName = column.name;
    const encodings = column.encodings.reduce((acc, e)=>{
        if (e.type === (0, $17fe399301a568db$export$6592cb873eed5846).visibility && e.value === (0, $17fe399301a568db$export$feec8660ecb73f20).visible) acc.visible = true;
        else if (e.type === (0, $17fe399301a568db$export$6592cb873eed5846).display) acc.displayName = e.value;
        return acc;
    }, {
        visible: false,
        displayName: '',
        internalName: internalName
    });
    return {
        ...encodings,
        internalName: internalName
    };
};
const $8aa3fe7759a0c09b$export$e7cde8e6e3c80be8 = (column)=>{
    let hasText = false;
    let hasIcon = false;
    column.encodings.forEach((e)=>{
        if (e.type === (0, $17fe399301a568db$export$6592cb873eed5846).label) {
            if (e.value === (0, $17fe399301a568db$export$98bdffdcaa237968).icon) hasIcon = true;
            if (e.value === (0, $17fe399301a568db$export$98bdffdcaa237968).text) hasText = true;
        }
    });
    if (hasText && hasIcon) return (0, $17fe399301a568db$export$85ce1201a2cc2824).dotText;
    else if (hasText) return (0, $17fe399301a568db$export$85ce1201a2cc2824).text;
    return (0, $17fe399301a568db$export$85ce1201a2cc2824).dot;
};
const $8aa3fe7759a0c09b$export$5bd2ada171761d50 = (column)=>{
    const colors = column.encodings.filter((e)=>e.type === (0, $17fe399301a568db$export$6592cb873eed5846).color);
    return colors.map((c)=>{
        const level = (0, $17fe399301a568db$export$4f069e5a50708cd4)[c.name];
        const color = (0, $17fe399301a568db$export$4882b5974b950793)[c.value];
        return {
            level: level,
            color: color
        };
    });
};
const $8aa3fe7759a0c09b$export$9553965735d77d5d = (config)=>{
    const tableColumns = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(config, 'tableColumns');
    const severityFormat = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(config, 'severityFormat');
    const severityLevelColors = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(config, 'severityLevelColors');
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEmpty(tableColumns)) return {
        columns: []
    };
    const columns = tableColumns.map((c, i)=>{
        const encodings = $8aa3fe7759a0c09b$export$954f534994abcdcf(c, severityFormat, severityLevelColors);
        const name = c.internalName;
        const position = i;
        return {
            name: name,
            position: position,
            encodings: encodings
        };
    });
    return {
        columns: columns
    };
};
const $8aa3fe7759a0c09b$export$2e456846cada4c30 = (tableColumn)=>{
    const encodings = [];
    if (tableColumn.visible) encodings.push({
        type: (0, $17fe399301a568db$export$6592cb873eed5846).visibility,
        value: (0, $17fe399301a568db$export$feec8660ecb73f20).visible
    });
    else encodings.push({
        type: (0, $17fe399301a568db$export$6592cb873eed5846).visibility,
        value: (0, $17fe399301a568db$export$feec8660ecb73f20).hidden
    });
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEmpty(tableColumn.displayName)) encodings.push({
        type: (0, $17fe399301a568db$export$6592cb873eed5846).display,
        value: tableColumn.displayName
    });
    return encodings;
};
const $8aa3fe7759a0c09b$export$47a6facbfc66ec4f = (format)=>{
    switch(format){
        case (0, $17fe399301a568db$export$85ce1201a2cc2824).dot:
            return [
                {
                    type: (0, $17fe399301a568db$export$6592cb873eed5846).label,
                    value: (0, $17fe399301a568db$export$98bdffdcaa237968).icon
                }
            ];
        case (0, $17fe399301a568db$export$85ce1201a2cc2824).text:
            return [
                {
                    type: (0, $17fe399301a568db$export$6592cb873eed5846).label,
                    value: (0, $17fe399301a568db$export$98bdffdcaa237968).text
                }
            ];
        case (0, $17fe399301a568db$export$85ce1201a2cc2824).dotText:
            return [
                {
                    type: (0, $17fe399301a568db$export$6592cb873eed5846).label,
                    value: (0, $17fe399301a568db$export$98bdffdcaa237968).icon
                },
                {
                    type: (0, $17fe399301a568db$export$6592cb873eed5846).label,
                    value: (0, $17fe399301a568db$export$98bdffdcaa237968).text
                }
            ];
    }
    return null;
};
const $8aa3fe7759a0c09b$export$7d34fcae4d8fe3a = (levelColors)=>{
    return levelColors.map(({ color: color, level: level })=>{
        return {
            type: (0, $17fe399301a568db$export$6592cb873eed5846).color,
            value: color,
            name: level
        };
    });
};
const $8aa3fe7759a0c09b$export$954f534994abcdcf = (tableColumn, format, severityLevelColors)=>{
    let encodings = $8aa3fe7759a0c09b$export$2e456846cada4c30(tableColumn);
    if (tableColumn.internalName === 'severity') encodings = [
        ...encodings,
        ...$8aa3fe7759a0c09b$export$47a6facbfc66ec4f(format),
        ...$8aa3fe7759a0c09b$export$7d34fcae4d8fe3a(severityLevelColors)
    ];
    return encodings;
};




var $d241d8e181bfcafe$export$ca480a6cbcd8239 = /*#__PURE__*/ function(SearchStatus) {
    SearchStatus["None"] = "None";
    SearchStatus["Loading"] = "Loading";
    SearchStatus["NoResults"] = "NoResults";
    SearchStatus["UpdatingTimeBounds"] = "UpdatingTimeBounds";
    SearchStatus["UpdatingFilters"] = "UpdatingFilters";
    SearchStatus["UpdatingSource"] = "UpdatingSource";
    SearchStatus["UpdatingNamespace"] = "UpdatingNamespace";
    SearchStatus["MeasurementMissing"] = "MeasurementMissing";
    SearchStatus["Loaded"] = "Loaded";
    SearchStatus["Clearing"] = "Clearing";
    SearchStatus["Cleared"] = "Cleared";
    return SearchStatus;
}({});
var $d241d8e181bfcafe$export$1d002fc419589aea = /*#__PURE__*/ function(TermType) {
    TermType[TermType["EXCLUDE"] = 0] = "EXCLUDE";
    TermType[TermType["INCLUDE"] = 1] = "INCLUDE";
    return TermType;
}({});
var $d241d8e181bfcafe$export$5ac3d064d508813a = /*#__PURE__*/ function(TermPart) {
    TermPart["EXCLUSION"] = "-";
    TermPart["SINGLE_QUOTED"] = "'([^']+)'";
    TermPart["DOUBLE_QUOTED"] = '"([^"]+)"';
    TermPart["ATTRIBUTE"] = "(\\w+(?=\\:))";
    TermPart["COLON"] = "(?::)";
    TermPart["UNQUOTED_WORD"] = "([\\S]+)";
    return TermPart;
}({});
var $d241d8e181bfcafe$export$fa5f90bfb4dbdbcd = /*#__PURE__*/ function(Operator) {
    Operator["NOT_LIKE"] = "!~";
    Operator["LIKE"] = "=~";
    Operator["EQUAL"] = "==";
    Operator["NOT_EQUAL"] = "!=";
    return Operator;
}({});
var $d241d8e181bfcafe$export$44087f2a0e4739a3 = /*#__PURE__*/ function(MatchType) {
    MatchType["NONE"] = "no-match";
    MatchType["MATCH"] = "match";
    return MatchType;
}({});



const $353d602c97200dee$export$ec97e03929c39fe4 = 1000;
var $353d602c97200dee$export$1385d81a6c6bbcd4 = /*#__PURE__*/ function(ActionTypes) {
    ActionTypes["SetSource"] = "LOGS_SET_SOURCE";
    ActionTypes["SetNamespaces"] = "LOGS_SET_NAMESPACES";
    ActionTypes["SetTimeBounds"] = "LOGS_SET_TIMEBOUNDS";
    ActionTypes["SetTimeWindow"] = "LOGS_SET_TIMEWINDOW";
    ActionTypes["SetTimeMarker"] = "LOGS_SET_TIMEMARKER";
    ActionTypes["SetNamespace"] = "LOGS_SET_NAMESPACE";
    ActionTypes["SetHistogramQueryConfig"] = "LOGS_SET_HISTOGRAM_QUERY_CONFIG";
    ActionTypes["SetHistogramData"] = "LOGS_SET_HISTOGRAM_DATA";
    ActionTypes["SetTableQueryConfig"] = "LOGS_SET_TABLE_QUERY_CONFIG";
    ActionTypes["SetTableData"] = "LOGS_SET_TABLE_DATA";
    ActionTypes["AddFilter"] = "LOGS_ADD_FILTER";
    ActionTypes["RemoveFilter"] = "LOGS_REMOVE_FILTER";
    ActionTypes["ChangeFilter"] = "LOGS_CHANGE_FILTER";
    ActionTypes["ClearFilters"] = "LOGS_CLEAR_FILTERS";
    ActionTypes["IncrementQueryCount"] = "LOGS_INCREMENT_QUERY_COUNT";
    ActionTypes["DecrementQueryCount"] = "LOGS_DECREMENT_QUERY_COUNT";
    ActionTypes["ConcatMoreLogs"] = "LOGS_CONCAT_MORE_LOGS";
    ActionTypes["PrependMoreLogs"] = "LOGS_PREPEND_MORE_LOGS";
    ActionTypes["ReplacePrependedLogs"] = "LOGS_REPLACE_PREPENDED_LOGS";
    ActionTypes["SetConfig"] = "SET_CONFIG";
    ActionTypes["SetTableRelativeTime"] = "SET_TABLE_RELATIVE_TIME";
    ActionTypes["SetTableCustomTime"] = "SET_TABLE_CUSTOM_TIME";
    ActionTypes["SetTableForwardData"] = "SET_TABLE_FORWARD_DATA";
    ActionTypes["SetTableBackwardData"] = "SET_TABLE_BACKWARD_DATA";
    ActionTypes["ClearRowsAdded"] = "CLEAR_ROWS_ADDED";
    ActionTypes["ClearTableData"] = "CLEAR_TABLE_DATA";
    ActionTypes["SetNextOlderUpperBound"] = "SET_NEXT_OLDER_UPPER_BOUND";
    ActionTypes["SetNextOlderLowerBound"] = "SET_NEXT_OLDER_LOWER_BOUND";
    ActionTypes["SetNextNewerUpperBound"] = "SET_NEXT_NEWER_UPPER_BOUND";
    ActionTypes["SetNextNewerLowerBound"] = "SET_NEXT_NEWER_LOWER_BOUND";
    ActionTypes["SetCurrentTailUpperBound"] = "SET_CURRENT_TAIL_UPPER_BOUND";
    ActionTypes["SetNextTailLowerBound"] = "SET_NEXT_TAIL_LOWER_BOUND";
    ActionTypes["SetSearchStatus"] = "SET_SEARCH_STATUS";
    return ActionTypes;
}({});
const $353d602c97200dee$var$getIsTruncated = (state)=>state.logs.logConfig.isTruncated;
const $353d602c97200dee$var$getForwardTableData = (state)=>state.logs.tableInfiniteData.forward;
const $353d602c97200dee$var$getBackwardTableData = (state)=>state.logs.tableInfiniteData.backward;
/**
 * Creates new TableData with the concatted TableData values from args of TableData
 * @param tableDatas
 */ const $353d602c97200dee$var$combineTableData = (...tableDatas)=>({
        columns: tableDatas[0].columns,
        values: (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).flatMap(tableDatas, (t)=>t.values)
    });
const $353d602c97200dee$var$getTimeRange = (state)=>(0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(state, 'logs.timeRange', null);
const $353d602c97200dee$var$getNamespace = (state)=>(0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(state, 'logs.currentNamespace', null);
const $353d602c97200dee$var$getProxyLink = (state)=>(0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(state, 'logs.currentSource.links.proxy', null);
const $353d602c97200dee$var$getHistogramQueryConfig = (state)=>(0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(state, 'logs.histogramQueryConfig', null);
const $353d602c97200dee$var$getTableQueryConfig = (state)=>(0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(state, 'logs.tableQueryConfig', null);
const $353d602c97200dee$var$getSearchTerm = (state)=>(0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(state, 'logs.searchTerm', null);
const $353d602c97200dee$var$getFilters = (state)=>(0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(state, 'logs.filters', []);
const $353d602c97200dee$var$getTableSelectedTime = (state)=>{
    const custom = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(state, 'logs.tableTime.custom', '');
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEmpty(custom)) return Date.parse(custom);
    const relative = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(state, 'logs.tableTime.relative', 0);
    return Date.now() - relative * 1000;
};
const $353d602c97200dee$var$getNextOlderUpperBound = (state)=>{
    const selectedTableTime = $353d602c97200dee$var$getTableSelectedTime(state);
    return (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(state, 'logs.nextOlderUpperBound', selectedTableTime);
};
const $353d602c97200dee$var$getOlderChunkDurationMs = (state)=>{
    return (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(state, 'logs.olderChunkDurationMs', (0, $17fe399301a568db$export$fd748333000462a8));
};
const $353d602c97200dee$var$getNextNewerLowerBound = (state)=>{
    const selectedTableTime = $353d602c97200dee$var$getTableSelectedTime(state);
    return (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(state, 'logs.nextNewerLowerBound', selectedTableTime);
};
const $353d602c97200dee$var$getNewerChunkDurationMs = (state)=>{
    return (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(state, 'logs.newerChunkDurationMs', (0, $17fe399301a568db$export$dccafea29eb05d53));
};
const $353d602c97200dee$var$getNextTailLowerBound = (state)=>state.logs.nextTailLowerBound;
/**
 * Gets the maximum duration that the tail buffer should accumulate
 *  before being flushed to the 'backward' table data.
 * @param state the application state
 */ const $353d602c97200dee$var$getMaxTailBufferDurationMs = (state)=>{
    return (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(state, 'logs.maxTailBufferDurationMs', (0, $17fe399301a568db$export$2783d45bfefa692a));
};
const $353d602c97200dee$export$d535adc77a12c58f = ()=>({
        type: "CLEAR_TABLE_DATA"
    });
const $353d602c97200dee$export$fe61dfd7d10db79f = ()=>({
        type: "CLEAR_ROWS_ADDED"
    });
const $353d602c97200dee$export$e2805e93ed62aac = (time)=>({
        type: "SET_TABLE_CUSTOM_TIME",
        payload: {
            time: time
        }
    });
const $353d602c97200dee$export$e92eebfb8d18cc9 = (time)=>({
        type: "SET_TABLE_RELATIVE_TIME",
        payload: {
            time: time
        }
    });
const $353d602c97200dee$export$71cd7b144eb33e93 = (data)=>({
        type: "SET_TABLE_FORWARD_DATA",
        payload: {
            data: data
        }
    });
const $353d602c97200dee$export$c3323beffab82918 = (data)=>({
        type: "SET_TABLE_BACKWARD_DATA",
        payload: {
            data: data
        }
    });
const $353d602c97200dee$export$dc7aee2bcc03083a = (timeWindow)=>({
        type: "LOGS_SET_TIMEWINDOW",
        payload: {
            timeWindow: timeWindow
        }
    });
const $353d602c97200dee$export$a40b898b9d72fbba = (timeMarker)=>({
        type: "LOGS_SET_TIMEMARKER",
        payload: {
            timeMarker: timeMarker
        }
    });
const $353d602c97200dee$export$59f3db1d7df09881 = (timeBounds)=>({
        type: "LOGS_SET_TIMEBOUNDS",
        payload: {
            timeBounds: timeBounds
        }
    });
const $353d602c97200dee$export$90719193aa2f4428 = (upper)=>({
        type: "SET_NEXT_OLDER_UPPER_BOUND",
        payload: {
            upper: upper
        }
    });
const $353d602c97200dee$export$80ca9dac071e74e9 = (lower)=>({
        type: "SET_NEXT_OLDER_LOWER_BOUND",
        payload: {
            lower: lower
        }
    });
const $353d602c97200dee$export$1dcea1f5b5e846af = (upper)=>({
        type: "SET_NEXT_NEWER_UPPER_BOUND",
        payload: {
            upper: upper
        }
    });
const $353d602c97200dee$export$ccab220fcb0bc359 = (lower)=>({
        type: "SET_NEXT_NEWER_LOWER_BOUND",
        payload: {
            lower: lower
        }
    });
const $353d602c97200dee$export$e2910885d45eabaa = (upper)=>({
        type: "SET_CURRENT_TAIL_UPPER_BOUND",
        payload: {
            upper: upper
        }
    });
const $353d602c97200dee$export$62b3184be770961e = (lower)=>({
        type: "SET_NEXT_TAIL_LOWER_BOUND",
        payload: {
            lower: lower
        }
    });
const $353d602c97200dee$export$f3503bb636498ae7 = (searchStatus)=>({
        type: "SET_SEARCH_STATUS",
        payload: {
            searchStatus: searchStatus
        }
    });
const $353d602c97200dee$export$670c18d1c7d2069c = ()=>(dispatch)=>{
        dispatch($353d602c97200dee$export$90719193aa2f4428(undefined));
        dispatch($353d602c97200dee$export$80ca9dac071e74e9(undefined));
        dispatch($353d602c97200dee$export$1dcea1f5b5e846af(undefined));
        dispatch($353d602c97200dee$export$e2910885d45eabaa(undefined));
        dispatch($353d602c97200dee$export$62b3184be770961e(undefined));
    };
const $353d602c97200dee$export$8bb077ed816673f7 = (searchStatus)=>async (dispatch)=>{
        await dispatch($353d602c97200dee$export$f3503bb636498ae7((0, $d241d8e181bfcafe$export$ca480a6cbcd8239).Clearing));
        dispatch($353d602c97200dee$var$setHistogramData([]));
        dispatch($353d602c97200dee$export$670c18d1c7d2069c());
        dispatch($353d602c97200dee$export$d535adc77a12c58f());
        await dispatch($353d602c97200dee$export$f3503bb636498ae7((0, $d241d8e181bfcafe$export$ca480a6cbcd8239).Cleared));
        await dispatch($353d602c97200dee$export$f3503bb636498ae7(searchStatus));
    };
const $353d602c97200dee$export$e41c4a5ba57a2eda = (time)=>async (dispatch)=>{
        await dispatch($353d602c97200dee$export$e2805e93ed62aac(time));
    };
const $353d602c97200dee$export$9597a83095c7014e = (time)=>async (dispatch)=>{
        await dispatch($353d602c97200dee$export$e92eebfb8d18cc9(time));
    };
const $353d602c97200dee$export$347972a19297a2b7 = (id, operator, value)=>({
        type: "LOGS_CHANGE_FILTER",
        payload: {
            id: id,
            operator: operator,
            value: value
        }
    });
const $353d602c97200dee$export$8b480fb58130ff16 = (source)=>({
        type: "LOGS_SET_SOURCE",
        payload: {
            source: source
        }
    });
const $353d602c97200dee$export$ae939118842f3d6d = (filter)=>({
        type: "LOGS_ADD_FILTER",
        payload: {
            filter: filter
        }
    });
const $353d602c97200dee$export$d0e6b6bfede2a57 = ()=>({
        type: "LOGS_CLEAR_FILTERS"
    });
const $353d602c97200dee$export$3be5fe9f09d6965 = (id)=>({
        type: "LOGS_REMOVE_FILTER",
        payload: {
            id: id
        }
    });
const $353d602c97200dee$var$setHistogramData = (data)=>({
        type: "LOGS_SET_HISTOGRAM_DATA",
        payload: {
            data: data
        }
    });
const $353d602c97200dee$export$aeb6a841efeb4bd3 = ()=>async (dispatch, getState)=>{
        const state = getState();
        const queryConfig = $353d602c97200dee$var$getHistogramQueryConfig(state);
        const timeRange = $353d602c97200dee$var$getTimeRange(state);
        const namespace = $353d602c97200dee$var$getNamespace(state);
        const proxyLink = $353d602c97200dee$var$getProxyLink(state);
        const searchTerm = $353d602c97200dee$var$getSearchTerm(state);
        const filters = $353d602c97200dee$var$getFilters(state);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).every([
            queryConfig,
            timeRange,
            namespace,
            proxyLink
        ])) return;
        try {
            dispatch($353d602c97200dee$export$6e0b995744fe997b());
            const query = (0, $39ae7dd6f6a41115$export$bb159e1ae1c9d804)(timeRange, queryConfig, filters, searchTerm);
            const response = await (0, $0e5f1280af745b44$export$5b03906d1b94e9d1)(proxyLink, namespace, query);
            const data = (0, $39ae7dd6f6a41115$export$5d1e524f0b690a50)(response);
            dispatch($353d602c97200dee$var$setHistogramData(data));
        } finally{
            dispatch($353d602c97200dee$export$860d4a72424d1c61());
        }
    };
const $353d602c97200dee$export$860d4a72424d1c61 = ()=>({
        type: "LOGS_DECREMENT_QUERY_COUNT"
    });
const $353d602c97200dee$export$6e0b995744fe997b = ()=>({
        type: "LOGS_INCREMENT_QUERY_COUNT"
    });
const $353d602c97200dee$export$31d9e9cac3b19147 = ()=>async (dispatch, getState)=>{
        const state = getState();
        const namespace = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(state, 'logs.currentNamespace', null);
        const timeRange = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(state, 'logs.timeRange', null);
        if (timeRange && namespace) {
            const queryTimeRange = {
                upper: timeRange.upper,
                lower: timeRange.lower,
                seconds: timeRange.seconds
            };
            const queryConfig = (0, $39ae7dd6f6a41115$export$d149e9eea50f66d8)(namespace, queryTimeRange);
            dispatch({
                type: "LOGS_SET_HISTOGRAM_QUERY_CONFIG",
                payload: {
                    queryConfig: queryConfig
                }
            });
            dispatch($353d602c97200dee$export$aeb6a841efeb4bd3());
        }
    };
const $353d602c97200dee$export$484584085e5828e7 = (queryConfig)=>({
        type: "LOGS_SET_TABLE_QUERY_CONFIG",
        payload: {
            queryConfig: queryConfig
        }
    });
const $353d602c97200dee$export$ab5ace968191f968 = ()=>async (dispatch, getState)=>{
        const state = getState();
        const namespace = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(state, 'logs.currentNamespace', null);
        const timeRange = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(state, 'logs.timeRange', null);
        if (timeRange && namespace) {
            const queryConfig = (0, $39ae7dd6f6a41115$export$566fa0dcbc1c34ab)(namespace, timeRange);
            dispatch($353d602c97200dee$export$484584085e5828e7(queryConfig));
        }
    };
const $353d602c97200dee$export$6b2592cc9359df84 = ()=>async (dispatch, getState)=>{
        const state = getState();
        const tableQueryConfig = $353d602c97200dee$var$getTableQueryConfig(state);
        const namespace = $353d602c97200dee$var$getNamespace(state);
        const proxyLink = $353d602c97200dee$var$getProxyLink(state);
        const searchTerm = $353d602c97200dee$var$getSearchTerm(state);
        const filters = $353d602c97200dee$var$getFilters(state);
        const params = [
            namespace,
            proxyLink,
            tableQueryConfig
        ];
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).every(params)) {
            const olderUpperBound = $353d602c97200dee$var$getNextOlderUpperBound(state);
            const olderChunkDurationMs = $353d602c97200dee$var$getOlderChunkDurationMs(state);
            const nextOlderUpperBound = olderUpperBound - olderChunkDurationMs;
            dispatch($353d602c97200dee$export$90719193aa2f4428(nextOlderUpperBound));
            const upper = new Date(olderUpperBound).toISOString();
            const lower = new Date(nextOlderUpperBound).toISOString();
            const query = (0, $39ae7dd6f6a41115$export$b9e962ff9ce3c1b2)(lower, upper, tableQueryConfig, filters, searchTerm);
            const response = await (0, $0e5f1280af745b44$export$5b03906d1b94e9d1)(proxyLink, namespace, `${query} ORDER BY time DESC`);
            const logSeries = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(response, 'results.0.series.0', (0, $17fe399301a568db$export$5c00ad534c3ef603));
            await dispatch($353d602c97200dee$export$e9a9165433913789(logSeries));
        } else throw new Error(`Missing params required to fetch older logs. Maybe there's a race condition with setting namespaces?`);
    };
const $353d602c97200dee$export$9867c3abea3f9c6f = ()=>async (dispatch, getState)=>{
        const state = getState();
        const tableQueryConfig = $353d602c97200dee$var$getTableQueryConfig(state);
        const namespace = $353d602c97200dee$var$getNamespace(state);
        const proxyLink = $353d602c97200dee$var$getProxyLink(state);
        const searchTerm = $353d602c97200dee$var$getSearchTerm(state);
        const filters = $353d602c97200dee$var$getFilters(state);
        const params = [
            namespace,
            proxyLink,
            tableQueryConfig
        ];
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).every(params)) {
            const newerLowerBound = $353d602c97200dee$var$getNextNewerLowerBound(state);
            const newerChunkDurationMs = $353d602c97200dee$var$getNewerChunkDurationMs(state);
            const nextNewerLowerBound = newerLowerBound + newerChunkDurationMs;
            dispatch($353d602c97200dee$export$ccab220fcb0bc359(nextNewerLowerBound));
            const upper = new Date(nextNewerLowerBound).toISOString();
            const lower = new Date(newerLowerBound).toISOString();
            const query = (0, $39ae7dd6f6a41115$export$b9e962ff9ce3c1b2)(lower, upper, tableQueryConfig, filters, searchTerm);
            const response = await (0, $0e5f1280af745b44$export$5b03906d1b94e9d1)(proxyLink, namespace, `${query} ORDER BY time DESC`);
            const logSeries = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(response, 'results.0.series.0', (0, $17fe399301a568db$export$5c00ad534c3ef603));
            await dispatch($353d602c97200dee$export$58945f1054af9cb1(logSeries));
        } else throw new Error(`Missing params required to fetch newer logs. Maybe there's a race condition with setting namespaces?`);
    };
const $353d602c97200dee$export$b300bd48a52702ed = ()=>(dispatch, getState)=>{
        const state = getState();
        const currentTailBuffer = $353d602c97200dee$var$getForwardTableData(state);
        const currentBackward = $353d602c97200dee$var$getBackwardTableData(state);
        const combinedBackward = $353d602c97200dee$var$combineTableData(currentTailBuffer, currentBackward);
        dispatch($353d602c97200dee$export$c3323beffab82918(combinedBackward));
        dispatch($353d602c97200dee$export$71cd7b144eb33e93((0, $17fe399301a568db$export$5c00ad534c3ef603)));
    };
const $353d602c97200dee$export$d115d6c69a81f80c = ()=>async (dispatch, getState)=>{
        const state = getState();
        const tableQueryConfig = $353d602c97200dee$var$getTableQueryConfig(state);
        const namespace = $353d602c97200dee$var$getNamespace(state);
        const proxyLink = $353d602c97200dee$var$getProxyLink(state);
        const searchTerm = $353d602c97200dee$var$getSearchTerm(state);
        const filters = $353d602c97200dee$var$getFilters(state);
        const params = [
            namespace,
            proxyLink,
            tableQueryConfig
        ];
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).every(params)) {
            const tailLowerBound = $353d602c97200dee$var$getNextTailLowerBound(state);
            if (!tailLowerBound) throw new Error('tail lower bound is not set');
            const upper = new Date().toISOString();
            const lower = new Date(tailLowerBound).toISOString();
            const upperUTC = Date.parse(upper);
            dispatch($353d602c97200dee$export$e2910885d45eabaa(upperUTC));
            const query = (0, $39ae7dd6f6a41115$export$b9e962ff9ce3c1b2)(lower, upper, tableQueryConfig, filters, searchTerm);
            const response = await (0, $0e5f1280af745b44$export$5b03906d1b94e9d1)(proxyLink, namespace, `${query} ORDER BY time DESC`);
            const logSeries = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(response, 'results.0.series.0', (0, $17fe399301a568db$export$5c00ad534c3ef603));
            const currentForwardBufferDuration = upperUTC - tailLowerBound;
            const maxTailBufferDurationMs = $353d602c97200dee$var$getMaxTailBufferDurationMs(state);
            const isMaxTailBufferDurationExceeded = currentForwardBufferDuration >= maxTailBufferDurationMs;
            if (isMaxTailBufferDurationExceeded) {
                dispatch($353d602c97200dee$export$b300bd48a52702ed());
                await dispatch($353d602c97200dee$export$62b3184be770961e(upperUTC));
            } else await dispatch($353d602c97200dee$export$71cd7b144eb33e93(logSeries));
        } else throw new Error(`Missing params required to fetch tail logs. Maybe there's a race condition with setting namespaces?`);
    };
const $353d602c97200dee$export$e9a9165433913789 = (series)=>({
        type: "LOGS_CONCAT_MORE_LOGS",
        payload: {
            series: series
        }
    });
const $353d602c97200dee$export$58945f1054af9cb1 = (series)=>({
        type: "LOGS_PREPEND_MORE_LOGS",
        payload: {
            series: series
        }
    });
const $353d602c97200dee$export$bfb25655fb3b81b = (namespace)=>async (dispatch)=>{
        dispatch({
            type: "LOGS_SET_NAMESPACE",
            payload: {
                namespace: namespace
            }
        });
        await Promise.all([
            dispatch($353d602c97200dee$export$31d9e9cac3b19147()),
            dispatch($353d602c97200dee$export$ab5ace968191f968())
        ]);
    };
const $353d602c97200dee$export$a2f59495f078ad22 = (namespace)=>async (dispatch, getState)=>{
        try {
            const proxyLink = $353d602c97200dee$var$getProxyLink(getState());
            const response = await (0, $0e5f1280af745b44$export$4829de2798d13ca2)(proxyLink, namespace);
            const series = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(response, 'results.0.series', []);
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEmpty(series)) await dispatch($353d602c97200dee$export$f3503bb636498ae7((0, $d241d8e181bfcafe$export$ca480a6cbcd8239).MeasurementMissing));
        } catch (error) {
            await dispatch($353d602c97200dee$export$f3503bb636498ae7((0, $d241d8e181bfcafe$export$ca480a6cbcd8239).MeasurementMissing));
        }
    };
const $353d602c97200dee$export$9d37cf8e8d033b8b = (namespaces)=>({
        type: "LOGS_SET_NAMESPACES",
        payload: {
            namespaces: namespaces
        }
    });
const $353d602c97200dee$export$b36acc1d2d750740 = ()=>async (dispatch)=>{
        dispatch($353d602c97200dee$export$31d9e9cac3b19147());
        dispatch($353d602c97200dee$export$ab5ace968191f968());
    };
const $353d602c97200dee$export$87caf57dc085f3cb = (source, currentNamespace)=>async (dispatch)=>{
        const proxyLink = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(source, 'links.proxy', null);
        const namespaces = await (0, $cafe5a655b6c1200$export$f279f2817c69d78a)(proxyLink);
        if (namespaces && namespaces.length > 0) {
            dispatch($353d602c97200dee$export$9d37cf8e8d033b8b(namespaces));
            let defaultNamespace;
            if (source) {
                if (currentNamespace) defaultNamespace = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).find(namespaces, (ns)=>ns.database === currentNamespace.database && ns.retentionPolicy === currentNamespace.retentionPolicy);
                if (!defaultNamespace && source.telegraf) defaultNamespace = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).find(namespaces, (ns)=>ns.database === source.telegraf);
            }
            const namespace = defaultNamespace || namespaces[0];
            await Promise.all([
                dispatch($353d602c97200dee$export$bfb25655fb3b81b(namespace)),
                dispatch($353d602c97200dee$export$a2f59495f078ad22(namespace))
            ]);
        }
    };
const $353d602c97200dee$export$c37c3cb83f304b49 = (sourceID)=>async (dispatch)=>{
        const source = await (0, $3bff70d0456af5c0$export$dd2b6e807fb37ba3)(sourceID);
        const proxyLink = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(source, 'links.proxy', null);
        if (proxyLink) {
            dispatch($353d602c97200dee$export$8b480fb58130ff16(source));
            await dispatch($353d602c97200dee$export$87caf57dc085f3cb(source));
        }
    };
const $353d602c97200dee$export$76f9dfcf614176c4 = (url)=>async (dispatch, getState)=>{
        const state = getState();
        const isTruncated = $353d602c97200dee$var$getIsTruncated(state);
        try {
            const { data: data } = await (0, $0e5f1280af745b44$export$14cabb7f53ef78fa)(url);
            const logConfig = {
                ...(0, $8aa3fe7759a0c09b$export$f5dd0497de3eac55)(data),
                isTruncated: isTruncated
            };
            await dispatch($353d602c97200dee$export$940a7873bb071df8(logConfig));
        } catch (error) {
            console.error(error);
        }
    };
const $353d602c97200dee$export$a9ca9aca226bcfdb = (url, config)=>async (dispatch)=>{
        try {
            const configForServer = (0, $8aa3fe7759a0c09b$export$9553965735d77d5d)(config);
            await (0, $0e5f1280af745b44$export$65697e22a0a2f56e)(url, configForServer);
            dispatch($353d602c97200dee$export$940a7873bb071df8(config));
        } catch (error) {
            console.error(error);
        }
    };
const $353d602c97200dee$export$940a7873bb071df8 = (logConfig)=>{
    return {
        type: "SET_CONFIG",
        payload: {
            logConfig: logConfig
        }
    };
};




const $0b515c6bb45d5887$export$49d5fc8cba920a0 = {
    currentSource: null,
    currentNamespaces: [],
    timeRange: {
        upper: null,
        lower: 'now() - 1m',
        seconds: 60,
        windowOption: '1m',
        timeOption: 'now'
    },
    tableInfiniteData: {
        forward: (0, $17fe399301a568db$export$5c00ad534c3ef603),
        backward: (0, $17fe399301a568db$export$5c00ad534c3ef603)
    },
    currentNamespace: null,
    histogramQueryConfig: null,
    tableQueryConfig: null,
    tableData: {
        columns: [],
        values: []
    },
    histogramData: [],
    filters: [],
    queryCount: 0,
    logConfig: {
        tableColumns: [],
        severityFormat: (0, $17fe399301a568db$export$85ce1201a2cc2824).dotText,
        severityLevelColors: [],
        isTruncated: (0, $17fe399301a568db$export$c9677b4901769799)
    },
    tableTime: {
        custom: '',
        relative: 0
    },
    searchStatus: (0, $d241d8e181bfcafe$export$ca480a6cbcd8239).None,
    nextOlderUpperBound: undefined,
    nextOlderLowerBound: undefined,
    nextNewerUpperBound: undefined,
    nextNewerLowerBound: undefined,
    currentTailUpperBound: undefined,
    nextTailLowerBound: undefined,
    tailChunkDurationMs: (0, $17fe399301a568db$export$6f8f9ddc0aeaa6ed),
    olderChunkDurationMs: (0, $17fe399301a568db$export$fd748333000462a8),
    newerChunkDurationMs: (0, $17fe399301a568db$export$dccafea29eb05d53),
    newRowsAdded: 0
};
const $0b515c6bb45d5887$var$clearTableData = (state)=>{
    return {
        ...state,
        tableInfiniteData: {
            forward: (0, $17fe399301a568db$export$5c00ad534c3ef603),
            backward: (0, $17fe399301a568db$export$5c00ad534c3ef603)
        }
    };
};
const $0b515c6bb45d5887$var$removeFilter = (state, action)=>{
    const { id: id } = action.payload;
    const filters = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).filter((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(state, 'filters', []), (filter)=>filter.id !== id);
    return {
        ...state,
        filters: filters
    };
};
const $0b515c6bb45d5887$var$addFilter = (state, action)=>{
    const { filter: filter } = action.payload;
    return {
        ...state,
        filters: [
            filter,
            ...(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(state, 'filters', [])
        ]
    };
};
const $0b515c6bb45d5887$var$clearFilters = (state)=>{
    return {
        ...state,
        filters: []
    };
};
const $0b515c6bb45d5887$var$changeFilter = (state, action)=>{
    const { id: id, operator: operator, value: value } = action.payload;
    const mappedFilters = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).map((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(state, 'filters', []), (f)=>{
        if (f.id === id) return {
            ...f,
            operator: operator,
            value: value
        };
        return f;
    });
    return {
        ...state,
        filters: mappedFilters
    };
};
const $0b515c6bb45d5887$var$decrementQueryCount = (state)=>{
    const { queryCount: queryCount } = state;
    return {
        ...state,
        queryCount: Math.max(queryCount - 1, 0)
    };
};
const $0b515c6bb45d5887$var$incrementQueryCount = (state)=>{
    const { queryCount: queryCount } = state;
    return {
        ...state,
        queryCount: queryCount + 1
    };
};
const $0b515c6bb45d5887$var$concatMoreLogs = (state, action)=>{
    const { series: { columns: columns, values: values } } = action.payload;
    const { tableInfiniteData: tableInfiniteData } = state;
    const { backward: backward } = tableInfiniteData;
    const vals = [
        ...backward.values,
        ...values
    ];
    return {
        ...state,
        tableInfiniteData: {
            ...tableInfiniteData,
            backward: {
                columns: columns,
                values: vals
            }
        }
    };
};
const $0b515c6bb45d5887$var$prependMoreLogs = (state, action)=>{
    const { series: { columns: columns, values: values } } = action.payload;
    const { tableInfiniteData: tableInfiniteData } = state;
    const { forward: forward } = tableInfiniteData;
    const vals = [
        ...values,
        ...forward.values
    ];
    const newRowsAdded = vals.length - forward.values.length;
    return {
        ...state,
        newRowsAdded: newRowsAdded,
        tableInfiniteData: {
            ...tableInfiniteData,
            forward: {
                columns: columns,
                values: vals
            }
        }
    };
};
const $0b515c6bb45d5887$export$b91675638b9c04e7 = (state, action)=>{
    const { logConfig: logConfig } = state;
    const { logConfig: { tableColumns: tableColumns, severityFormat: severityFormat, severityLevelColors: severityLevelColors, isTruncated: isTruncated } } = action.payload;
    const updatedLogConfig = {
        ...logConfig,
        tableColumns: tableColumns,
        severityFormat: severityFormat,
        severityLevelColors: severityLevelColors,
        isTruncated: isTruncated
    };
    return {
        ...state,
        logConfig: updatedLogConfig
    };
};
var $0b515c6bb45d5887$export$2e2bcd8739ae039 = (state = $0b515c6bb45d5887$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case (0, $353d602c97200dee$export$1385d81a6c6bbcd4).SetSource:
            return {
                ...state,
                currentSource: action.payload.source
            };
        case (0, $353d602c97200dee$export$1385d81a6c6bbcd4).SetNamespaces:
            return {
                ...state,
                currentNamespaces: action.payload.namespaces
            };
        case (0, $353d602c97200dee$export$1385d81a6c6bbcd4).SetTimeBounds:
            {
                const { upper: upper, lower: lower } = action.payload.timeBounds;
                return {
                    ...state,
                    timeRange: {
                        ...state.timeRange,
                        upper: upper,
                        lower: lower
                    }
                };
            }
        case (0, $353d602c97200dee$export$1385d81a6c6bbcd4).SetTimeWindow:
            {
                const { windowOption: windowOption, seconds: seconds } = action.payload.timeWindow;
                return {
                    ...state,
                    timeRange: {
                        ...state.timeRange,
                        windowOption: windowOption,
                        seconds: seconds
                    }
                };
            }
        case (0, $353d602c97200dee$export$1385d81a6c6bbcd4).SetTimeMarker:
            {
                const { timeOption: timeOption } = action.payload.timeMarker;
                return {
                    ...state,
                    timeRange: {
                        ...state.timeRange,
                        timeOption: timeOption
                    }
                };
            }
        case (0, $353d602c97200dee$export$1385d81a6c6bbcd4).SetNamespace:
            return {
                ...state,
                currentNamespace: action.payload.namespace
            };
        case (0, $353d602c97200dee$export$1385d81a6c6bbcd4).SetHistogramQueryConfig:
            return {
                ...state,
                histogramQueryConfig: action.payload.queryConfig
            };
        case (0, $353d602c97200dee$export$1385d81a6c6bbcd4).SetHistogramData:
            return {
                ...state,
                histogramData: action.payload.data
            };
        case (0, $353d602c97200dee$export$1385d81a6c6bbcd4).SetTableQueryConfig:
            return {
                ...state,
                tableQueryConfig: action.payload.queryConfig
            };
        case (0, $353d602c97200dee$export$1385d81a6c6bbcd4).SetTableData:
            return {
                ...state,
                tableData: action.payload.data
            };
        case (0, $353d602c97200dee$export$1385d81a6c6bbcd4).ClearRowsAdded:
            return {
                ...state,
                newRowsAdded: null
            };
        case (0, $353d602c97200dee$export$1385d81a6c6bbcd4).SetSearchStatus:
            return {
                ...state,
                searchStatus: action.payload.searchStatus
            };
        case (0, $353d602c97200dee$export$1385d81a6c6bbcd4).SetTableForwardData:
            return {
                ...state,
                tableInfiniteData: {
                    ...state.tableInfiniteData,
                    forward: action.payload.data
                }
            };
        case (0, $353d602c97200dee$export$1385d81a6c6bbcd4).SetTableBackwardData:
            return {
                ...state,
                tableInfiniteData: {
                    ...state.tableInfiniteData,
                    backward: action.payload.data
                }
            };
        case (0, $353d602c97200dee$export$1385d81a6c6bbcd4).SetTableCustomTime:
            return {
                ...state,
                tableTime: {
                    custom: action.payload.time
                }
            };
        case (0, $353d602c97200dee$export$1385d81a6c6bbcd4).SetTableRelativeTime:
            return {
                ...state,
                tableTime: {
                    relative: action.payload.time
                }
            };
        case (0, $353d602c97200dee$export$1385d81a6c6bbcd4).SetNextOlderUpperBound:
            return {
                ...state,
                nextOlderUpperBound: action.payload.upper
            };
        case (0, $353d602c97200dee$export$1385d81a6c6bbcd4).SetNextOlderLowerBound:
            return {
                ...state,
                nextOlderLowerBound: action.payload.lower
            };
        case (0, $353d602c97200dee$export$1385d81a6c6bbcd4).SetNextNewerUpperBound:
            return {
                ...state,
                nextNewerUpperBound: action.payload.upper
            };
        case (0, $353d602c97200dee$export$1385d81a6c6bbcd4).SetNextNewerLowerBound:
            return {
                ...state,
                nextNewerLowerBound: action.payload.lower
            };
        case (0, $353d602c97200dee$export$1385d81a6c6bbcd4).SetCurrentTailUpperBound:
            return {
                ...state,
                currentTailUpperBound: action.payload.upper
            };
        case (0, $353d602c97200dee$export$1385d81a6c6bbcd4).SetNextTailLowerBound:
            return {
                ...state,
                nextTailLowerBound: action.payload.lower
            };
        case (0, $353d602c97200dee$export$1385d81a6c6bbcd4).AddFilter:
            return $0b515c6bb45d5887$var$addFilter(state, action);
        case (0, $353d602c97200dee$export$1385d81a6c6bbcd4).RemoveFilter:
            return $0b515c6bb45d5887$var$removeFilter(state, action);
        case (0, $353d602c97200dee$export$1385d81a6c6bbcd4).ChangeFilter:
            return $0b515c6bb45d5887$var$changeFilter(state, action);
        case (0, $353d602c97200dee$export$1385d81a6c6bbcd4).ClearFilters:
            return $0b515c6bb45d5887$var$clearFilters(state);
        case (0, $353d602c97200dee$export$1385d81a6c6bbcd4).IncrementQueryCount:
            return $0b515c6bb45d5887$var$incrementQueryCount(state);
        case (0, $353d602c97200dee$export$1385d81a6c6bbcd4).DecrementQueryCount:
            return $0b515c6bb45d5887$var$decrementQueryCount(state);
        case (0, $353d602c97200dee$export$1385d81a6c6bbcd4).ConcatMoreLogs:
            return $0b515c6bb45d5887$var$concatMoreLogs(state, action);
        case (0, $353d602c97200dee$export$1385d81a6c6bbcd4).PrependMoreLogs:
            return $0b515c6bb45d5887$var$prependMoreLogs(state, action);
        case (0, $353d602c97200dee$export$1385d81a6c6bbcd4).SetConfig:
            return $0b515c6bb45d5887$export$b91675638b9c04e7(state, action);
        case (0, $353d602c97200dee$export$1385d81a6c6bbcd4).ClearTableData:
            return $0b515c6bb45d5887$var$clearTableData(state);
        default:
            return state;
    }
};






var $0714a56b2816a4c7$export$34a76716dc6df022 = /*#__PURE__*/ function(TagFilterType) {
    TagFilterType["Equals"] = "==";
    TagFilterType["NotEquals"] = "!=";
    TagFilterType["RegEquals"] = "=~";
    TagFilterType["RegNotEquals"] = "!~";
    return TagFilterType;
}({});
var $0714a56b2816a4c7$export$e62cccb760c33405 = /*#__PURE__*/ function(AnnotationsDisplaySetting) {
    AnnotationsDisplaySetting["HideAnnotations"] = "Hide Annotations";
    AnnotationsDisplaySetting["FilterAnnotationsByTag"] = "Filter Annotations By Tags";
    return AnnotationsDisplaySetting;
}({});


const $8b79b2e56a77e61a$var$initialState = {
    ephemeral: {
        inPresentationMode: false
    },
    persisted: {
        autoRefresh: (0, $e10a8602f56394e3$export$edae9dc8bc463031),
        showTemplateVariableControlBar: (0, $e10a8602f56394e3$export$4246073241d5cb73),
        showAnnotationControls: (0, $e10a8602f56394e3$export$1db4bed3f15cffc8),
        annotationsDisplaySetting: (0, $0714a56b2816a4c7$export$e62cccb760c33405).HideAnnotations,
        timeZone: (0, $a7b864c61f4e95a7$export$d6f132cca63fb222).Local
    }
};
const { ephemeral: $8b79b2e56a77e61a$var$initialAppEphemeralState, persisted: $8b79b2e56a77e61a$var$initialAppPersistedState } = $8b79b2e56a77e61a$var$initialState;
const $8b79b2e56a77e61a$var$appEphemeralReducer = (state = $8b79b2e56a77e61a$var$initialAppEphemeralState, action)=>{
    switch(action.type){
        case (0, $67853175702c8b4d$export$1385d81a6c6bbcd4).EnablePresentationMode:
            return {
                ...state,
                inPresentationMode: true
            };
        case (0, $67853175702c8b4d$export$1385d81a6c6bbcd4).DisablePresentationMode:
            return {
                ...state,
                inPresentationMode: false
            };
        default:
            return state;
    }
};
const $8b79b2e56a77e61a$var$appPersistedReducer = (state = $8b79b2e56a77e61a$var$initialAppPersistedState, action)=>{
    switch(action.type){
        case (0, $67853175702c8b4d$export$1385d81a6c6bbcd4).SetAutoRefresh:
            return {
                ...state,
                autoRefresh: action.payload.milliseconds
            };
        case (0, $67853175702c8b4d$export$1385d81a6c6bbcd4).ToggleTemplateVariableControlBar:
            {
                const update = !state.showTemplateVariableControlBar;
                return {
                    ...state,
                    showTemplateVariableControlBar: update
                };
            }
        case (0, $67853175702c8b4d$export$1385d81a6c6bbcd4).ToggleShowAnnotationControls:
            {
                const update = !state.showAnnotationControls;
                return {
                    ...state,
                    showAnnotationControls: update
                };
            }
        case (0, $67853175702c8b4d$export$1385d81a6c6bbcd4).SetTimeZone:
            {
                const { timeZone: timeZone } = action.payload;
                return {
                    ...state,
                    timeZone: timeZone
                };
            }
        case 'ADDING_ANNOTATION':
            return {
                ...state,
                annotationsDisplaySetting: (0, $0714a56b2816a4c7$export$e62cccb760c33405).FilterAnnotationsByTag
            };
        case 'SET_ANNOTATIONS_DISPLAY_SETTING':
            return {
                ...state,
                annotationsDisplaySetting: action.payload
            };
        default:
            return state;
    }
};
const $8b79b2e56a77e61a$var$appReducer = (0, $902b45bf0a1197fd$export$2e2bcd8739ae039)({
    ephemeral: $8b79b2e56a77e61a$var$appEphemeralReducer,
    persisted: $8b79b2e56a77e61a$var$appPersistedReducer
});
var $8b79b2e56a77e61a$export$2e2bcd8739ae039 = $8b79b2e56a77e61a$var$appReducer;



var $hBdgJ = parcelRequire("hBdgJ");
const $a7910b1002260d34$export$2959f045e897f38b = 'member';
const $a7910b1002260d34$export$62bbf68aca1809f0 = 'reader';
const $a7910b1002260d34$export$1d39a112fd67439d = 'viewer';
const $a7910b1002260d34$export$f715f7e27dea2abf = 'editor';
const $a7910b1002260d34$export$856b7354d850707e = 'admin';
const $a7910b1002260d34$export$ccd9fcc6ec6e7386 = 'superadmin';
const $a7910b1002260d34$export$7d499847c5200082 = (meRole, requiredRole)=>{
    switch(requiredRole){
        case $a7910b1002260d34$export$62bbf68aca1809f0:
            return meRole === $a7910b1002260d34$export$62bbf68aca1809f0 || meRole === $a7910b1002260d34$export$1d39a112fd67439d || meRole === $a7910b1002260d34$export$f715f7e27dea2abf || meRole === $a7910b1002260d34$export$856b7354d850707e || meRole === $a7910b1002260d34$export$ccd9fcc6ec6e7386;
        case $a7910b1002260d34$export$1d39a112fd67439d:
            return meRole === $a7910b1002260d34$export$1d39a112fd67439d || meRole === $a7910b1002260d34$export$f715f7e27dea2abf || meRole === $a7910b1002260d34$export$856b7354d850707e || meRole === $a7910b1002260d34$export$ccd9fcc6ec6e7386;
        case $a7910b1002260d34$export$f715f7e27dea2abf:
            return meRole === $a7910b1002260d34$export$f715f7e27dea2abf || meRole === $a7910b1002260d34$export$856b7354d850707e || meRole === $a7910b1002260d34$export$ccd9fcc6ec6e7386;
        case $a7910b1002260d34$export$856b7354d850707e:
            return meRole === $a7910b1002260d34$export$856b7354d850707e || meRole === $a7910b1002260d34$export$ccd9fcc6ec6e7386;
        case $a7910b1002260d34$export$ccd9fcc6ec6e7386:
            return meRole === $a7910b1002260d34$export$ccd9fcc6ec6e7386;
        // 'member' is the default role and has no authorization for anything currently
        case $a7910b1002260d34$export$2959f045e897f38b:
        default:
            return false;
    }
};


const $531691a03f35160f$export$c10c5499c0490345 = (me)=>{
    const currentRoleOrg = me.roles.find((role)=>me.currentOrganization.id === role.organization);
    const currentRole = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(currentRoleOrg, 'name', (0, $a7910b1002260d34$export$2959f045e897f38b));
    return me.superAdmin ? (0, $a7910b1002260d34$export$ccd9fcc6ec6e7386) : currentRole;
};
const $531691a03f35160f$export$75e40963e10e91be = (userA, userB)=>{
    return userA.name === userB.name && userA.provider === userB.provider && userA.scheme === userB.scheme;
};




const $f399838829496166$var$getInitialState = ()=>({
        links: null,
        me: null,
        isMeLoading: false,
        isAuthLoading: false,
        logoutLink: null,
        isUsingAuth: false
    });
const $f399838829496166$export$d4c72bab9d6cc13a = $f399838829496166$var$getInitialState();
const $f399838829496166$var$meGetCompleted = (state, { me: me }, isUsingAuth)=>{
    let newMe = me;
    if (isUsingAuth) newMe = {
        ...newMe,
        role: (0, $531691a03f35160f$export$c10c5499c0490345)(me),
        currentOrganization: me.currentOrganization
    };
    return {
        ...state,
        me: {
            ...newMe
        },
        isMeLoading: false
    };
};
const $f399838829496166$var$authReceived = (state, auth)=>{
    const links = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(auth, 'auth.links', []);
    return {
        ...state,
        links: links,
        isAuthLoading: false
    };
};
const $f399838829496166$var$logoutLinkReceived = (state, { logoutLink: logoutLink }, isUsingAuth)=>({
        ...state,
        logoutLink: logoutLink,
        isUsingAuth: isUsingAuth
    });
const $f399838829496166$var$authReducer = (state = $f399838829496166$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case (0, $7af565d99d629ce9$export$1385d81a6c6bbcd4).AuthExpired:
            {
                const { auth: { links: links } } = action.payload;
                return {
                    ...$f399838829496166$export$d4c72bab9d6cc13a,
                    links: links
                };
            }
        case (0, $7af565d99d629ce9$export$1385d81a6c6bbcd4).AuthRequested:
            return {
                ...state,
                isAuthLoading: true
            };
        case (0, $7af565d99d629ce9$export$1385d81a6c6bbcd4).MeGetRequested:
            return {
                ...state,
                isMeLoading: true
            };
        case (0, $7af565d99d629ce9$export$1385d81a6c6bbcd4).MeGetCompleted:
            {
                const { logoutLink: logoutLink } = action.payload;
                const isUsingAuth = !!logoutLink;
                let newState = $f399838829496166$var$meGetCompleted(state, action.payload, isUsingAuth);
                newState = $f399838829496166$var$authReceived(newState, action.payload);
                newState = $f399838829496166$var$logoutLinkReceived(newState, action.payload, isUsingAuth);
                return newState;
            }
    }
    return state;
};
var $f399838829496166$export$2e2bcd8739ae039 = $f399838829496166$var$authReducer;



const $5e78f513e35bf10e$var$initialState = {
    telegrafSystemInterval: '1m',
    hostPageDisabled: false,
    v3SupportEnabled: false
};
const $5e78f513e35bf10e$var$envReducer = (state = $5e78f513e35bf10e$var$initialState, action)=>{
    switch(action.type){
        case (0, $67853175702c8b4d$export$1385d81a6c6bbcd4).SetTelegrafSystemInterval:
            {
                const { telegrafSystemInterval: telegrafSystemInterval } = action.payload;
                return {
                    ...state,
                    telegrafSystemInterval: telegrafSystemInterval
                };
            }
        case (0, $67853175702c8b4d$export$1385d81a6c6bbcd4).SetHostPageDisplayStatus:
            {
                const { hostPageDisabled: hostPageDisabled } = action.payload;
                return {
                    ...state,
                    hostPageDisabled: hostPageDisabled
                };
            }
        case (0, $67853175702c8b4d$export$1385d81a6c6bbcd4).SetV3SupportEnabled:
            {
                const { v3SupportEnabled: v3SupportEnabled } = action.payload;
                return {
                    ...state,
                    v3SupportEnabled: v3SupportEnabled
                };
            }
        default:
            return state;
    }
};
var $5e78f513e35bf10e$export$2e2bcd8739ae039 = $5e78f513e35bf10e$var$envReducer;


const $e76e4b849002017b$var$initialState = {
    links: {},
    auth: {}
};
const $e76e4b849002017b$var$config = (state = $e76e4b849002017b$var$initialState, action)=>{
    switch(action.type){
        case 'CHRONOGRAF_GET_AUTH_CONFIG_COMPLETED':
        case 'CHRONOGRAF_UPDATE_AUTH_CONFIG_REQUESTED':
        case 'CHRONOGRAF_UPDATE_AUTH_CONFIG_FAILED':
            {
                const { authConfig: auth } = action.payload;
                return {
                    ...state,
                    auth: {
                        ...auth
                    }
                };
            }
    }
    return state;
};
var $e76e4b849002017b$export$2e2bcd8739ae039 = $e76e4b849002017b$var$config;


const $f365920e078dfd45$var$getInitialState = ()=>({
        error: null
    });
const $f365920e078dfd45$export$d4c72bab9d6cc13a = $f365920e078dfd45$var$getInitialState();
const $f365920e078dfd45$var$errorsReducer = (state = $f365920e078dfd45$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 'ERROR_THROWN':
            {
                const { error: error } = action;
                return {
                    error: error
                };
            }
    }
    return state;
};
var $f365920e078dfd45$export$2e2bcd8739ae039 = $f365920e078dfd45$var$errorsReducer;


const $f00f94ad4e7f4582$var$initialState = {
    external: {
        statusFeed: ''
    },
    custom: []
};
const $f00f94ad4e7f4582$var$linksReducer = (state = $f00f94ad4e7f4582$var$initialState, action)=>{
    switch(action.type){
        case 'LINKS_GET_COMPLETED':
            {
                const { links: links } = action.payload;
                return {
                    ...links
                };
            }
    }
    return state;
};
var $f00f94ad4e7f4582$export$2e2bcd8739ae039 = $f00f94ad4e7f4582$var$linksReducer;



const $48b56bc7ae9670d7$export$d4c72bab9d6cc13a = [];
const $48b56bc7ae9670d7$export$6008d97729a90c74 = (state = $48b56bc7ae9670d7$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 'PUBLISH_NOTIFICATION':
            {
                const { notification: notification } = action.payload;
                const publishedNotification = {
                    ...notification,
                    id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)()
                };
                return [
                    publishedNotification,
                    ...state
                ];
            }
        case 'DISMISS_NOTIFICATION':
            {
                const { id: id } = action.payload;
                return state.filter((n)=>n.id !== id);
            }
    }
    return state;
};



var $hBdgJ = parcelRequire("hBdgJ");
const $a7c32c841b6ec6e4$export$d4c72bab9d6cc13a = [];
const $a7c32c841b6ec6e4$var$sourcesReducer = (state = $a7c32c841b6ec6e4$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 'LOAD_SOURCES':
            return action.payload.sources;
        case 'SOURCE_UPDATED':
            {
                const { source: source } = action.payload;
                const updatedIndex = state.findIndex((s)=>s.id === source.id);
                const updatedSources = source.default ? state.map((s)=>{
                    s.default = false;
                    return s;
                }) : [
                    ...state
                ];
                updatedSources[updatedIndex] = source;
                return updatedSources;
            }
        case 'SOURCE_ADDED':
            {
                const { source: source } = action.payload;
                const updatedSources = source.default ? state.map((s)=>{
                    s.default = false;
                    return s;
                }) : state;
                return [
                    ...updatedSources,
                    source
                ];
            }
        case 'LOAD_KAPACITORS':
            {
                const { source: source, kapacitors: kapacitors } = action.payload;
                const sourceIndex = state.findIndex((s)=>s.id === source.id);
                const updatedSources = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).cloneDeep(state);
                if (updatedSources[sourceIndex]) updatedSources[sourceIndex].kapacitors = kapacitors;
                return updatedSources;
            }
        case 'SET_ACTIVE_KAPACITOR':
            {
                const { kapacitor: kapacitor } = action.payload;
                const updatedSources = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).cloneDeep(state);
                updatedSources.forEach((source)=>{
                    source.kapacitors.forEach((k, i)=>{
                        source.kapacitors[i].active = k.id === kapacitor.id;
                    });
                });
                return updatedSources;
            }
        case 'DELETE_KAPACITOR':
            {
                const { kapacitor: kapacitor } = action.payload;
                const updatedSources = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).cloneDeep(state);
                updatedSources.forEach((source)=>{
                    const index = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).findIndex(source.kapacitors, (k)=>k.id === kapacitor.id);
                    if (index >= 0) source.kapacitors.splice(index, 1);
                });
                return updatedSources;
            }
    }
    return state;
};
var $a7c32c841b6ec6e4$export$2e2bcd8739ae039 = $a7c32c841b6ec6e4$var$sourcesReducer;




const $53b1df725ed2947c$export$e4076c0612d5486 = 0.5;
const $53b1df725ed2947c$export$cd452f24a53287fb = 'adding';
const $53b1df725ed2947c$export$2d5490e5c1c94328 = 'editing';
const $53b1df725ed2947c$export$f0b429bbc4916259 = ()=>({
        id: 'tempAnnotation',
        text: 'Name Me',
        startTime: null,
        endTime: null,
        links: {
            self: ''
        }
    });
const $53b1df725ed2947c$export$4d61b4ac02d59f55 = ()=>({
        id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
        tagKey: '',
        tagValue: '',
        filterType: (0, $0714a56b2816a4c7$export$34a76716dc6df022).Equals
    });
const $53b1df725ed2947c$export$adb3bb9e6761deb2 = (xAxisRange, annotations = [])=>{
    const [xStart, xEnd] = xAxisRange;
    if (xStart === 0 && xEnd === 0) return [];
    return annotations.filter((a)=>{
        if (a.startTime === null || a.endTime === null) return false;
        if (a.endTime === a.startTime) return xStart <= a.startTime && a.startTime <= xEnd;
        return !(a.endTime < xStart || xEnd < a.startTime);
    });
};
const $53b1df725ed2947c$export$7e2445fa2039ccf1 = [
    (0, $0714a56b2816a4c7$export$34a76716dc6df022).Equals,
    (0, $0714a56b2816a4c7$export$34a76716dc6df022).NotEquals,
    (0, $0714a56b2816a4c7$export$34a76716dc6df022).RegEquals,
    (0, $0714a56b2816a4c7$export$34a76716dc6df022).RegNotEquals
];
const $53b1df725ed2947c$export$f35938869845200f = [
    'id',
    'startTime',
    'start_time',
    'endTime',
    'end_time',
    'modified_time_ns',
    'deleted'
];
const $53b1df725ed2947c$export$9e9d7abe91c393de = (t)=>{
    switch(t.filterType){
        case (0, $0714a56b2816a4c7$export$34a76716dc6df022).Equals:
            return `"${t.tagKey}" = '${t.tagValue}'`;
        case (0, $0714a56b2816a4c7$export$34a76716dc6df022).NotEquals:
            return `"${t.tagKey}" != '${t.tagValue}'`;
        case (0, $0714a56b2816a4c7$export$34a76716dc6df022).RegEquals:
            return `"${t.tagKey}" =~ /${t.tagValue}/`;
        case (0, $0714a56b2816a4c7$export$34a76716dc6df022).RegNotEquals:
            return `"${t.tagKey}" !~ /${t.tagValue}/`;
    }
};


const $a28c3f2b44ae1966$var$initialState = {
    mode: null,
    isTempHovering: false,
    annotations: {},
    tagKeys: null,
    tagValues: {},
    tagFilters: {}
};
const $a28c3f2b44ae1966$var$annotationsReducer = (state = $a28c3f2b44ae1966$var$initialState, action)=>{
    switch(action.type){
        case 'EDITING_ANNOTATION':
            return {
                ...state,
                mode: (0, $53b1df725ed2947c$export$2d5490e5c1c94328)
            };
        case 'DISMISS_EDITING_ANNOTATION':
            return {
                ...state,
                mode: null
            };
        case 'ADDING_ANNOTATION':
            return {
                ...state,
                mode: (0, $53b1df725ed2947c$export$cd452f24a53287fb),
                isTempHovering: true,
                addingAnnotation: (0, $53b1df725ed2947c$export$f0b429bbc4916259)()
            };
        case 'ADDING_ANNOTATION_SUCCESS':
            return {
                ...state,
                isTempHovering: false,
                mode: null
            };
        case 'DISMISS_ADDING_ANNOTATION':
            return {
                ...state,
                isTempHovering: false,
                mode: null,
                addingAnnotation: null
            };
        case 'MOUSEENTER_TEMP_ANNOTATION':
            {
                const newState = {
                    ...state,
                    isTempHovering: true
                };
                return newState;
            }
        case 'MOUSELEAVE_TEMP_ANNOTATION':
            {
                const newState = {
                    ...state,
                    isTempHovering: false
                };
                return newState;
            }
        case 'SET_ANNOTATIONS':
            {
                const annotations = action.payload.annotations.reduce((acc, a)=>({
                        ...acc,
                        [a.id]: a
                    }), {});
                return {
                    ...state,
                    annotations: annotations
                };
            }
        case 'UPDATE_ANNOTATION':
            {
                const { annotation: annotation } = action.payload;
                return {
                    ...state,
                    annotations: {
                        ...state.annotations,
                        [annotation.id]: annotation
                    }
                };
            }
        case 'SET_ADDING_ANNOTATION':
            return {
                ...state,
                addingAnnotation: action.payload
            };
        case 'DELETE_ANNOTATION':
            {
                const { annotation: annotation } = action.payload;
                return {
                    ...state,
                    annotations: {
                        ...state.annotations,
                        [annotation.id]: null
                    }
                };
            }
        case 'ADD_ANNOTATION':
            {
                const { annotation: annotation } = action.payload;
                return {
                    ...state,
                    annotations: {
                        ...state.annotations,
                        [annotation.id]: annotation
                    }
                };
            }
        case 'SET_EDITING_ANNOTATION':
            return {
                ...state,
                editingAnnotation: action.payload
            };
        case 'UPDATE_TAG_FILTER':
            {
                const { tagFilter: tagFilter, dashboardID: dashboardID } = action.payload;
                const dashboardTagFilters = state.tagFilters[dashboardID] || {};
                return {
                    ...state,
                    tagFilters: {
                        [dashboardID]: {
                            ...dashboardTagFilters,
                            [tagFilter.id]: tagFilter
                        }
                    }
                };
            }
        case 'DELETE_TAG_FILTER':
            {
                const { tagFilter: tagFilter, dashboardID: dashboardID } = action.payload;
                const dashboardTagFilters = state.tagFilters[dashboardID] || {};
                return {
                    ...state,
                    tagFilters: {
                        ...state.tagFilters,
                        [dashboardID]: {
                            ...dashboardTagFilters,
                            [tagFilter.id]: null
                        }
                    }
                };
            }
        case 'SET_TAG_KEYS':
            return {
                ...state,
                tagKeys: action.payload
            };
        case 'SET_TAG_VALUES':
            {
                const { tagKey: tagKey, tagValues: tagValues } = action.payload;
                return {
                    ...state,
                    tagValues: {
                        ...state.tagValues,
                        [tagKey]: tagValues
                    }
                };
            }
    }
    return state;
};
var $a28c3f2b44ae1966$export$2e2bcd8739ae039 = $a28c3f2b44ae1966$var$annotationsReducer;


var $0e0e6c9ee2dc115a$export$2e2bcd8739ae039 = {
    app: $8b79b2e56a77e61a$export$2e2bcd8739ae039,
    auth: $f399838829496166$export$2e2bcd8739ae039,
    env: $5e78f513e35bf10e$export$2e2bcd8739ae039,
    links: $f00f94ad4e7f4582$export$2e2bcd8739ae039,
    config: $e76e4b849002017b$export$2e2bcd8739ae039,
    errors: $f365920e078dfd45$export$2e2bcd8739ae039,
    sources: $a7c32c841b6ec6e4$export$2e2bcd8739ae039,
    annotations: $a28c3f2b44ae1966$export$2e2bcd8739ae039,
    notifications: $48b56bc7ae9670d7$export$6008d97729a90c74
};


const $6a7b0ae94f8ec28f$var$nowMinus30d = 'now() - 30d';
const $6a7b0ae94f8ec28f$export$9b55ef3c660cd071 = [
    {
        defaultGroupBy: '10s',
        seconds: 300,
        inputValue: 'Past 5m',
        lower: 'now() - 5m',
        lowerFlux: '-5m',
        upper: null,
        menuOption: 'Past 5m'
    },
    {
        defaultGroupBy: '1m',
        seconds: 900,
        inputValue: 'Past 15m',
        lower: 'now() - 15m',
        lowerFlux: '-15m',
        upper: null,
        menuOption: 'Past 15m'
    },
    {
        defaultGroupBy: '1m',
        seconds: 3600,
        inputValue: 'Past 1h',
        lower: 'now() - 1h',
        lowerFlux: '-1h',
        upper: null,
        menuOption: 'Past 1h'
    },
    {
        defaultGroupBy: '1m',
        seconds: 21600,
        inputValue: 'Past 6h',
        lower: 'now() - 6h',
        lowerFlux: '-6h',
        upper: null,
        menuOption: 'Past 6h'
    },
    {
        defaultGroupBy: '5m',
        seconds: 43200,
        inputValue: 'Past 12h',
        lower: 'now() - 12h',
        lowerFlux: '-12h',
        upper: null,
        menuOption: 'Past 12h'
    },
    {
        defaultGroupBy: '10m',
        seconds: 86400,
        inputValue: 'Past 24h',
        lower: 'now() - 24h',
        lowerFlux: '-24h',
        upper: null,
        menuOption: 'Past 24h'
    },
    {
        defaultGroupBy: '30m',
        seconds: 172800,
        inputValue: 'Past 2d',
        lower: 'now() - 2d',
        lowerFlux: '-2d',
        upper: null,
        menuOption: 'Past 2d'
    },
    {
        defaultGroupBy: '1h',
        seconds: 604800,
        inputValue: 'Past 7d',
        lower: 'now() - 7d',
        lowerFlux: '-7d',
        upper: null,
        menuOption: 'Past 7d'
    },
    {
        defaultGroupBy: '6h',
        seconds: 2592000,
        inputValue: 'Past 30d',
        lower: $6a7b0ae94f8ec28f$var$nowMinus30d,
        lowerFlux: '-30d',
        upper: null,
        menuOption: 'Past 30d'
    }
];
const $6a7b0ae94f8ec28f$export$ecd1ea28cd2a4eac = 'influxql';
const $6a7b0ae94f8ec28f$export$350d83d6c59c55f7 = {
    upper: null,
    lower: 'now() - 15m',
    lowerFlux: '-15m',
    seconds: 900,
    format: $6a7b0ae94f8ec28f$export$ecd1ea28cd2a4eac
};
const $6a7b0ae94f8ec28f$export$70d073c98082ccc4 = $6a7b0ae94f8ec28f$export$9b55ef3c660cd071.find((tr)=>tr.lower === $6a7b0ae94f8ec28f$var$nowMinus30d);


const { lower: $ac18f694c7513394$var$lower, upper: $ac18f694c7513394$var$upper } = (0, $6a7b0ae94f8ec28f$export$9b55ef3c660cd071).find((tr)=>tr.lower === 'now() - 1h');
const $ac18f694c7513394$var$initialState = {
    upper: $ac18f694c7513394$var$upper,
    lower: $ac18f694c7513394$var$lower
};
const $ac18f694c7513394$var$timeRange = (state = $ac18f694c7513394$var$initialState, action)=>{
    switch(action.type){
        case 'DE_SET_TIME_RANGE':
            {
                const { bounds: bounds } = action.payload;
                return {
                    ...state,
                    ...bounds
                };
            }
    }
    return state;
};
var $ac18f694c7513394$export$2e2bcd8739ae039 = $ac18f694c7513394$var$timeRange;


// Actions
// Types
var $c38c93c59a242a56$export$e4a712fff93fb00f = /*#__PURE__*/ function(ActionType) {
    ActionType["UpdateSourceLink"] = "DE_UPDATE_SOURCE_LINK";
    ActionType["EditQueryStatus"] = "DE_EDIT_QUERY_STATUS";
    ActionType["ResetQueryStatuses"] = "DE_RESET_STATUSES";
    return ActionType;
}({});
const $c38c93c59a242a56$export$a84df2ef2f50de53 = (sourceLink)=>({
        type: "DE_UPDATE_SOURCE_LINK",
        payload: {
            sourceLink: sourceLink
        }
    });
const $c38c93c59a242a56$export$8a793b1eac3a2 = (queryID, status)=>({
        type: "DE_EDIT_QUERY_STATUS",
        payload: {
            queryID: queryID,
            status: status
        }
    });
const $c38c93c59a242a56$export$ef2d6e8602fa6794 = ()=>({
        type: "DE_RESET_STATUSES"
    });


const $fe8c861a2392839e$export$d4c72bab9d6cc13a = {
    sourceLink: '',
    queryStatuses: {}
};
var $fe8c861a2392839e$export$2e2bcd8739ae039 = (state = $fe8c861a2392839e$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case (0, $c38c93c59a242a56$export$e4a712fff93fb00f).UpdateSourceLink:
            {
                const { sourceLink: sourceLink } = action.payload;
                return {
                    ...state,
                    sourceLink: sourceLink
                };
            }
        case (0, $c38c93c59a242a56$export$e4a712fff93fb00f).EditQueryStatus:
            {
                const { queryID: queryID, status: status } = action.payload;
                const { queryStatuses: queryStatuses } = state;
                return {
                    ...state,
                    queryStatuses: {
                        ...queryStatuses,
                        [queryID]: status
                    }
                };
            }
        case (0, $c38c93c59a242a56$export$e4a712fff93fb00f).ResetQueryStatuses:
            return {
                ...state,
                queryStatuses: {}
            };
    }
    return state;
};


var $c1151669d0d15f89$export$2e2bcd8739ae039 = {
    timeRange: $ac18f694c7513394$export$2e2bcd8739ae039,
    dataExplorer: $fe8c861a2392839e$export$2e2bcd8739ae039
};



const $9ec39e41773425eb$var$initialState = {
    users: [],
    organizations: [],
    mappings: [],
    authConfig: {
        superAdminNewUsers: false
    }
};
const $9ec39e41773425eb$var$adminChronograf = (state = $9ec39e41773425eb$var$initialState, action)=>{
    switch(action.type){
        case 'CHRONOGRAF_LOAD_USERS':
            return {
                ...state,
                ...action.payload
            };
        case 'CHRONOGRAF_LOAD_ORGANIZATIONS':
            return {
                ...state,
                ...action.payload
            };
        case 'CHRONOGRAF_ADD_USER':
            {
                const { user: user } = action.payload;
                return {
                    ...state,
                    users: [
                        ...state.users,
                        user
                    ]
                };
            }
        case 'CHRONOGRAF_UPDATE_USER':
            {
                const { user: user, updatedUser: updatedUser } = action.payload;
                return {
                    ...state,
                    users: state.users.map((u)=>u.links.self === user.links.self ? {
                            ...updatedUser
                        } : u)
                };
            }
        case 'CHRONOGRAF_SYNC_USER':
            {
                const { staleUser: staleUser, syncedUser: syncedUser } = action.payload;
                return {
                    ...state,
                    users: state.users.map(// stale user does not have links, so uniqueness is on name, provider, & scheme
                    (u)=>(0, $531691a03f35160f$export$75e40963e10e91be)(u, staleUser) ? {
                            ...syncedUser
                        } : u)
                };
            }
        case 'CHRONOGRAF_REMOVE_USER':
            {
                const { user: user } = action.payload;
                return {
                    ...state,
                    // stale user does not necessarily have links, so uniqueness is on name,
                    // provider, & scheme, except for a created users that is a duplicate
                    // of an existing user, in which case a temp uuid is used to match
                    users: state.users.filter((u)=>user._tempID ? u._tempID !== user._tempID : u.id !== user.id)
                };
            }
        case 'CHRONOGRAF_ADD_ORGANIZATION':
            {
                const { organization: organization } = action.payload;
                return {
                    ...state,
                    organizations: [
                        organization,
                        ...state.organizations
                    ]
                };
            }
        case 'CHRONOGRAF_RENAME_ORGANIZATION':
            {
                const { organization: organization, newName: newName } = action.payload;
                return {
                    ...state,
                    organizations: state.organizations.map((o)=>o.links.self === organization.links.self ? {
                            ...o,
                            name: newName
                        } : o)
                };
            }
        case 'CHRONOGRAF_SYNC_ORGANIZATION':
            {
                const { staleOrganization: staleOrganization, syncedOrganization: syncedOrganization } = action.payload;
                return {
                    ...state,
                    organizations: state.organizations.map((o)=>o.name === staleOrganization.name ? {
                            ...syncedOrganization
                        } : o)
                };
            }
        case 'CHRONOGRAF_REMOVE_ORGANIZATION':
            {
                const { organization: organization } = action.payload;
                return {
                    ...state,
                    organizations: state.organizations.filter((o)=>organization._tempID ? o._tempID !== organization._tempID : o.id !== organization.id)
                };
            }
        case 'CHRONOGRAF_LOAD_MAPPINGS':
            {
                const { mappings: mappings } = action.payload;
                return {
                    ...state,
                    mappings: mappings
                };
            }
        case 'CHRONOGRAF_UPDATE_MAPPING':
            {
                const { staleMapping: staleMapping, updatedMapping: updatedMapping } = action.payload;
                return {
                    ...state,
                    mappings: state.mappings.map((m)=>$9ec39e41773425eb$var$replaceMapping(m, staleMapping, updatedMapping))
                };
            }
        case 'CHRONOGRAF_ADD_MAPPING':
            {
                const { mapping: mapping } = action.payload;
                return {
                    ...state,
                    mappings: [
                        ...state.mappings,
                        mapping
                    ]
                };
            }
        case 'CHRONOGRAF_REMOVE_MAPPING':
            {
                const { mapping: mapping } = action.payload;
                return {
                    ...state,
                    mappings: state.mappings.filter((m)=>mapping._tempID ? m._tempID !== mapping._tempID : m.id !== mapping.id)
                };
            }
    }
    return state;
};
function $9ec39e41773425eb$var$replaceMapping(m, staleMapping, updatedMapping) {
    if (staleMapping._tempID && m._tempID === staleMapping._tempID) return {
        ...updatedMapping
    };
    else if (m.id === staleMapping.id) return {
        ...updatedMapping
    };
    return m;
}
var $9ec39e41773425eb$export$2e2bcd8739ae039 = $9ec39e41773425eb$var$adminChronograf;


var $3b1840a410238012$exports = {};
var $a395ddd63466c02f$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $a395ddd63466c02f$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$a395ddd63466c02f$exports = $a395ddd63466c02f$var$arrayFilter;


var $ee94ed03c5cc70f8$exports = {};
var $225beaa65d209784$exports = {};
var $ec1efa0ba3962647$exports = {};
var $4575ac91773ba98a$exports = {};
var $b54f5a92a25ba6da$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $b54f5a92a25ba6da$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$b54f5a92a25ba6da$exports = $b54f5a92a25ba6da$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $4575ac91773ba98a$var$baseFor = $b54f5a92a25ba6da$exports();
$4575ac91773ba98a$exports = $4575ac91773ba98a$var$baseFor;


var $056379088e51592c$exports = {};
var $fff2bd8ecbb2b6d2$exports = {};
var $491506df5e4048a5$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $491506df5e4048a5$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$491506df5e4048a5$exports = $491506df5e4048a5$var$baseTimes;


var $2b1962154d35d43c$exports = {};
var $a6c3550f4d973786$exports = {};
var $c1801119ed7f09fb$exports = {};
var $ead57c66122851dd$exports = {};

var $6MeXQ = parcelRequire("6MeXQ");
/** Built-in value references. */ var $ead57c66122851dd$var$Symbol = $6MeXQ.Symbol;
$ead57c66122851dd$exports = $ead57c66122851dd$var$Symbol;


var $acb35c9669732741$exports = {};

/** Used for built-in method references. */ var $acb35c9669732741$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $acb35c9669732741$var$hasOwnProperty = $acb35c9669732741$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $acb35c9669732741$var$nativeObjectToString = $acb35c9669732741$var$objectProto.toString;
/** Built-in value references. */ var $acb35c9669732741$var$symToStringTag = $ead57c66122851dd$exports ? $ead57c66122851dd$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $acb35c9669732741$var$getRawTag(value) {
    var isOwn = $acb35c9669732741$var$hasOwnProperty.call(value, $acb35c9669732741$var$symToStringTag), tag = value[$acb35c9669732741$var$symToStringTag];
    try {
        value[$acb35c9669732741$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $acb35c9669732741$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$acb35c9669732741$var$symToStringTag] = tag;
        else delete value[$acb35c9669732741$var$symToStringTag];
    }
    return result;
}
$acb35c9669732741$exports = $acb35c9669732741$var$getRawTag;


var $9cb70d3796de223d$exports = {};
/** Used for built-in method references. */ var $9cb70d3796de223d$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $9cb70d3796de223d$var$nativeObjectToString = $9cb70d3796de223d$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $9cb70d3796de223d$var$objectToString(value) {
    return $9cb70d3796de223d$var$nativeObjectToString.call(value);
}
$9cb70d3796de223d$exports = $9cb70d3796de223d$var$objectToString;


/** `Object#toString` result references. */ var $c1801119ed7f09fb$var$nullTag = '[object Null]', $c1801119ed7f09fb$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $c1801119ed7f09fb$var$symToStringTag = $ead57c66122851dd$exports ? $ead57c66122851dd$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $c1801119ed7f09fb$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $c1801119ed7f09fb$var$undefinedTag : $c1801119ed7f09fb$var$nullTag;
    return $c1801119ed7f09fb$var$symToStringTag && $c1801119ed7f09fb$var$symToStringTag in Object(value) ? $acb35c9669732741$exports(value) : $9cb70d3796de223d$exports(value);
}
$c1801119ed7f09fb$exports = $c1801119ed7f09fb$var$baseGetTag;


var $591571b7706a9b83$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $591571b7706a9b83$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$591571b7706a9b83$exports = $591571b7706a9b83$var$isObjectLike;


/** `Object#toString` result references. */ var $a6c3550f4d973786$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $a6c3550f4d973786$var$baseIsArguments(value) {
    return $591571b7706a9b83$exports(value) && $c1801119ed7f09fb$exports(value) == $a6c3550f4d973786$var$argsTag;
}
$a6c3550f4d973786$exports = $a6c3550f4d973786$var$baseIsArguments;



/** Used for built-in method references. */ var $2b1962154d35d43c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2b1962154d35d43c$var$hasOwnProperty = $2b1962154d35d43c$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $2b1962154d35d43c$var$propertyIsEnumerable = $2b1962154d35d43c$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $2b1962154d35d43c$var$isArguments = $a6c3550f4d973786$exports(function() {
    return arguments;
}()) ? $a6c3550f4d973786$exports : function(value) {
    return $591571b7706a9b83$exports(value) && $2b1962154d35d43c$var$hasOwnProperty.call(value, 'callee') && !$2b1962154d35d43c$var$propertyIsEnumerable.call(value, 'callee');
};
$2b1962154d35d43c$exports = $2b1962154d35d43c$var$isArguments;


var $62cdb8c6d4925eaf$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $62cdb8c6d4925eaf$var$isArray = Array.isArray;
$62cdb8c6d4925eaf$exports = $62cdb8c6d4925eaf$var$isArray;



var $lEd8H = parcelRequire("lEd8H");
var $ed54d9446c437622$exports = {};
/** Used as references for various `Number` constants. */ var $ed54d9446c437622$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $ed54d9446c437622$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $ed54d9446c437622$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $ed54d9446c437622$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $ed54d9446c437622$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$ed54d9446c437622$exports = $ed54d9446c437622$var$isIndex;


var $4b6171d69f23c564$exports = {};
var $01db9c1acc0bdd31$exports = {};

var $ac91b26f95fa5e9e$exports = {};
/** Used as references for various `Number` constants. */ var $ac91b26f95fa5e9e$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $ac91b26f95fa5e9e$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $ac91b26f95fa5e9e$var$MAX_SAFE_INTEGER;
}
$ac91b26f95fa5e9e$exports = $ac91b26f95fa5e9e$var$isLength;



/** `Object#toString` result references. */ var $01db9c1acc0bdd31$var$argsTag = '[object Arguments]', $01db9c1acc0bdd31$var$arrayTag = '[object Array]', $01db9c1acc0bdd31$var$boolTag = '[object Boolean]', $01db9c1acc0bdd31$var$dateTag = '[object Date]', $01db9c1acc0bdd31$var$errorTag = '[object Error]', $01db9c1acc0bdd31$var$funcTag = '[object Function]', $01db9c1acc0bdd31$var$mapTag = '[object Map]', $01db9c1acc0bdd31$var$numberTag = '[object Number]', $01db9c1acc0bdd31$var$objectTag = '[object Object]', $01db9c1acc0bdd31$var$regexpTag = '[object RegExp]', $01db9c1acc0bdd31$var$setTag = '[object Set]', $01db9c1acc0bdd31$var$stringTag = '[object String]', $01db9c1acc0bdd31$var$weakMapTag = '[object WeakMap]';
var $01db9c1acc0bdd31$var$arrayBufferTag = '[object ArrayBuffer]', $01db9c1acc0bdd31$var$dataViewTag = '[object DataView]', $01db9c1acc0bdd31$var$float32Tag = '[object Float32Array]', $01db9c1acc0bdd31$var$float64Tag = '[object Float64Array]', $01db9c1acc0bdd31$var$int8Tag = '[object Int8Array]', $01db9c1acc0bdd31$var$int16Tag = '[object Int16Array]', $01db9c1acc0bdd31$var$int32Tag = '[object Int32Array]', $01db9c1acc0bdd31$var$uint8Tag = '[object Uint8Array]', $01db9c1acc0bdd31$var$uint8ClampedTag = '[object Uint8ClampedArray]', $01db9c1acc0bdd31$var$uint16Tag = '[object Uint16Array]', $01db9c1acc0bdd31$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $01db9c1acc0bdd31$var$typedArrayTags = {};
$01db9c1acc0bdd31$var$typedArrayTags[$01db9c1acc0bdd31$var$float32Tag] = $01db9c1acc0bdd31$var$typedArrayTags[$01db9c1acc0bdd31$var$float64Tag] = $01db9c1acc0bdd31$var$typedArrayTags[$01db9c1acc0bdd31$var$int8Tag] = $01db9c1acc0bdd31$var$typedArrayTags[$01db9c1acc0bdd31$var$int16Tag] = $01db9c1acc0bdd31$var$typedArrayTags[$01db9c1acc0bdd31$var$int32Tag] = $01db9c1acc0bdd31$var$typedArrayTags[$01db9c1acc0bdd31$var$uint8Tag] = $01db9c1acc0bdd31$var$typedArrayTags[$01db9c1acc0bdd31$var$uint8ClampedTag] = $01db9c1acc0bdd31$var$typedArrayTags[$01db9c1acc0bdd31$var$uint16Tag] = $01db9c1acc0bdd31$var$typedArrayTags[$01db9c1acc0bdd31$var$uint32Tag] = true;
$01db9c1acc0bdd31$var$typedArrayTags[$01db9c1acc0bdd31$var$argsTag] = $01db9c1acc0bdd31$var$typedArrayTags[$01db9c1acc0bdd31$var$arrayTag] = $01db9c1acc0bdd31$var$typedArrayTags[$01db9c1acc0bdd31$var$arrayBufferTag] = $01db9c1acc0bdd31$var$typedArrayTags[$01db9c1acc0bdd31$var$boolTag] = $01db9c1acc0bdd31$var$typedArrayTags[$01db9c1acc0bdd31$var$dataViewTag] = $01db9c1acc0bdd31$var$typedArrayTags[$01db9c1acc0bdd31$var$dateTag] = $01db9c1acc0bdd31$var$typedArrayTags[$01db9c1acc0bdd31$var$errorTag] = $01db9c1acc0bdd31$var$typedArrayTags[$01db9c1acc0bdd31$var$funcTag] = $01db9c1acc0bdd31$var$typedArrayTags[$01db9c1acc0bdd31$var$mapTag] = $01db9c1acc0bdd31$var$typedArrayTags[$01db9c1acc0bdd31$var$numberTag] = $01db9c1acc0bdd31$var$typedArrayTags[$01db9c1acc0bdd31$var$objectTag] = $01db9c1acc0bdd31$var$typedArrayTags[$01db9c1acc0bdd31$var$regexpTag] = $01db9c1acc0bdd31$var$typedArrayTags[$01db9c1acc0bdd31$var$setTag] = $01db9c1acc0bdd31$var$typedArrayTags[$01db9c1acc0bdd31$var$stringTag] = $01db9c1acc0bdd31$var$typedArrayTags[$01db9c1acc0bdd31$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $01db9c1acc0bdd31$var$baseIsTypedArray(value) {
    return $591571b7706a9b83$exports(value) && $ac91b26f95fa5e9e$exports(value.length) && !!$01db9c1acc0bdd31$var$typedArrayTags[$c1801119ed7f09fb$exports(value)];
}
$01db9c1acc0bdd31$exports = $01db9c1acc0bdd31$var$baseIsTypedArray;


var $f3857b6918c77042$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $f3857b6918c77042$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$f3857b6918c77042$exports = $f3857b6918c77042$var$baseUnary;



var $38lOQ = parcelRequire("38lOQ");
/* Node.js helper references. */ var $4b6171d69f23c564$var$nodeIsTypedArray = $38lOQ && $38lOQ.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $4b6171d69f23c564$var$isTypedArray = $4b6171d69f23c564$var$nodeIsTypedArray ? $f3857b6918c77042$exports($4b6171d69f23c564$var$nodeIsTypedArray) : $01db9c1acc0bdd31$exports;
$4b6171d69f23c564$exports = $4b6171d69f23c564$var$isTypedArray;


/** Used for built-in method references. */ var $fff2bd8ecbb2b6d2$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $fff2bd8ecbb2b6d2$var$hasOwnProperty = $fff2bd8ecbb2b6d2$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $fff2bd8ecbb2b6d2$var$arrayLikeKeys(value, inherited) {
    var isArr = $62cdb8c6d4925eaf$exports(value), isArg = !isArr && $2b1962154d35d43c$exports(value), isBuff = !isArr && !isArg && $lEd8H(value), isType = !isArr && !isArg && !isBuff && $4b6171d69f23c564$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $491506df5e4048a5$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $fff2bd8ecbb2b6d2$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $ed54d9446c437622$exports(key, length)))) result.push(key);
    return result;
}
$fff2bd8ecbb2b6d2$exports = $fff2bd8ecbb2b6d2$var$arrayLikeKeys;


var $98bf57e01e300936$exports = {};
var $623465aebfb0a612$exports = {};
/** Used for built-in method references. */ var $623465aebfb0a612$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $623465aebfb0a612$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $623465aebfb0a612$var$objectProto;
    return value === proto;
}
$623465aebfb0a612$exports = $623465aebfb0a612$var$isPrototype;


var $32a60d2c5a3be945$exports = {};
var $b481455a096d635f$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $b481455a096d635f$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$b481455a096d635f$exports = $b481455a096d635f$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $32a60d2c5a3be945$var$nativeKeys = $b481455a096d635f$exports(Object.keys, Object);
$32a60d2c5a3be945$exports = $32a60d2c5a3be945$var$nativeKeys;


/** Used for built-in method references. */ var $98bf57e01e300936$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $98bf57e01e300936$var$hasOwnProperty = $98bf57e01e300936$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $98bf57e01e300936$var$baseKeys(object) {
    if (!$623465aebfb0a612$exports(object)) return $32a60d2c5a3be945$exports(object);
    var result = [];
    for(var key in Object(object))if ($98bf57e01e300936$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
$98bf57e01e300936$exports = $98bf57e01e300936$var$baseKeys;


var $bb8c0e46a53b48d1$exports = {};
var $0442f1343cf34522$exports = {};

var $cf434abf2d8b4420$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $cf434abf2d8b4420$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$cf434abf2d8b4420$exports = $cf434abf2d8b4420$var$isObject;


/** `Object#toString` result references. */ var $0442f1343cf34522$var$asyncTag = '[object AsyncFunction]', $0442f1343cf34522$var$funcTag = '[object Function]', $0442f1343cf34522$var$genTag = '[object GeneratorFunction]', $0442f1343cf34522$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $0442f1343cf34522$var$isFunction(value) {
    if (!$cf434abf2d8b4420$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $c1801119ed7f09fb$exports(value);
    return tag == $0442f1343cf34522$var$funcTag || tag == $0442f1343cf34522$var$genTag || tag == $0442f1343cf34522$var$asyncTag || tag == $0442f1343cf34522$var$proxyTag;
}
$0442f1343cf34522$exports = $0442f1343cf34522$var$isFunction;



/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $bb8c0e46a53b48d1$var$isArrayLike(value) {
    return value != null && $ac91b26f95fa5e9e$exports(value.length) && !$0442f1343cf34522$exports(value);
}
$bb8c0e46a53b48d1$exports = $bb8c0e46a53b48d1$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $056379088e51592c$var$keys(object) {
    return $bb8c0e46a53b48d1$exports(object) ? $fff2bd8ecbb2b6d2$exports(object) : $98bf57e01e300936$exports(object);
}
$056379088e51592c$exports = $056379088e51592c$var$keys;


/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $ec1efa0ba3962647$var$baseForOwn(object, iteratee) {
    return object && $4575ac91773ba98a$exports(object, iteratee, $056379088e51592c$exports);
}
$ec1efa0ba3962647$exports = $ec1efa0ba3962647$var$baseForOwn;


var $f4ec477e55bae058$exports = {};

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $f4ec477e55bae058$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$bb8c0e46a53b48d1$exports(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$f4ec477e55bae058$exports = $f4ec477e55bae058$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $225beaa65d209784$var$baseEach = $f4ec477e55bae058$exports($ec1efa0ba3962647$exports);
$225beaa65d209784$exports = $225beaa65d209784$var$baseEach;


/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $ee94ed03c5cc70f8$var$baseFilter(collection, predicate) {
    var result = [];
    $225beaa65d209784$exports(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) result.push(value);
    });
    return result;
}
$ee94ed03c5cc70f8$exports = $ee94ed03c5cc70f8$var$baseFilter;


var $76648cdc70b67884$exports = {};
var $4703ed1ea2a89eda$exports = {};
var $987f94fd936c5516$exports = {};
var $e2af73ab23f38ad8$exports = {};
var $627809b65c82b4ba$exports = {};
var $7599c053907881f4$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $7599c053907881f4$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$7599c053907881f4$exports = $7599c053907881f4$var$listCacheClear;


var $85125be63946db52$exports = {};
var $e3a9340527f8db81$exports = {};
var $7bddb65de45933c2$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $7bddb65de45933c2$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$7bddb65de45933c2$exports = $7bddb65de45933c2$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $e3a9340527f8db81$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($7bddb65de45933c2$exports(array[length][0], key)) return length;
    }
    return -1;
}
$e3a9340527f8db81$exports = $e3a9340527f8db81$var$assocIndexOf;


/** Used for built-in method references. */ var $85125be63946db52$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $85125be63946db52$var$splice = $85125be63946db52$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $85125be63946db52$var$listCacheDelete(key) {
    var data = this.__data__, index = $e3a9340527f8db81$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $85125be63946db52$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$85125be63946db52$exports = $85125be63946db52$var$listCacheDelete;


var $be6c4f4a420f30d2$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $be6c4f4a420f30d2$var$listCacheGet(key) {
    var data = this.__data__, index = $e3a9340527f8db81$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$be6c4f4a420f30d2$exports = $be6c4f4a420f30d2$var$listCacheGet;


var $1519d011972b62a6$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1519d011972b62a6$var$listCacheHas(key) {
    return $e3a9340527f8db81$exports(this.__data__, key) > -1;
}
$1519d011972b62a6$exports = $1519d011972b62a6$var$listCacheHas;


var $e5ad8801333d9c49$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $e5ad8801333d9c49$var$listCacheSet(key, value) {
    var data = this.__data__, index = $e3a9340527f8db81$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$e5ad8801333d9c49$exports = $e5ad8801333d9c49$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $627809b65c82b4ba$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$627809b65c82b4ba$var$ListCache.prototype.clear = $7599c053907881f4$exports;
$627809b65c82b4ba$var$ListCache.prototype['delete'] = $85125be63946db52$exports;
$627809b65c82b4ba$var$ListCache.prototype.get = $be6c4f4a420f30d2$exports;
$627809b65c82b4ba$var$ListCache.prototype.has = $1519d011972b62a6$exports;
$627809b65c82b4ba$var$ListCache.prototype.set = $e5ad8801333d9c49$exports;
$627809b65c82b4ba$exports = $627809b65c82b4ba$var$ListCache;


var $0246df2251d98ae9$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $0246df2251d98ae9$var$stackClear() {
    this.__data__ = new $627809b65c82b4ba$exports;
    this.size = 0;
}
$0246df2251d98ae9$exports = $0246df2251d98ae9$var$stackClear;


var $d22221c8a81abbed$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d22221c8a81abbed$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
$d22221c8a81abbed$exports = $d22221c8a81abbed$var$stackDelete;


var $548879b9865e4f0d$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $548879b9865e4f0d$var$stackGet(key) {
    return this.__data__.get(key);
}
$548879b9865e4f0d$exports = $548879b9865e4f0d$var$stackGet;


var $e7c74f1d89eed6d0$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e7c74f1d89eed6d0$var$stackHas(key) {
    return this.__data__.has(key);
}
$e7c74f1d89eed6d0$exports = $e7c74f1d89eed6d0$var$stackHas;


var $b5fdb6007f5bb3fe$exports = {};

var $f3012de369253e88$exports = {};
var $597f04cf2928ffb3$exports = {};
var $d3cc5bb746d532c9$exports = {};

var $678bb6b8743d95ab$exports = {};
var $a58b572d8e293cd5$exports = {};

var $6MeXQ = parcelRequire("6MeXQ");
/** Used to detect overreaching core-js shims. */ var $a58b572d8e293cd5$var$coreJsData = $6MeXQ["__core-js_shared__"];
$a58b572d8e293cd5$exports = $a58b572d8e293cd5$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $678bb6b8743d95ab$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($a58b572d8e293cd5$exports && $a58b572d8e293cd5$exports.keys && $a58b572d8e293cd5$exports.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $678bb6b8743d95ab$var$isMasked(func) {
    return !!$678bb6b8743d95ab$var$maskSrcKey && $678bb6b8743d95ab$var$maskSrcKey in func;
}
$678bb6b8743d95ab$exports = $678bb6b8743d95ab$var$isMasked;



var $001a333ce63ce98d$exports = {};
/** Used for built-in method references. */ var $001a333ce63ce98d$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $001a333ce63ce98d$var$funcToString = $001a333ce63ce98d$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $001a333ce63ce98d$var$toSource(func) {
    if (func != null) {
        try {
            return $001a333ce63ce98d$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
$001a333ce63ce98d$exports = $001a333ce63ce98d$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $d3cc5bb746d532c9$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $d3cc5bb746d532c9$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $d3cc5bb746d532c9$var$funcProto = Function.prototype, $d3cc5bb746d532c9$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $d3cc5bb746d532c9$var$funcToString = $d3cc5bb746d532c9$var$funcProto.toString;
/** Used to check objects for own properties. */ var $d3cc5bb746d532c9$var$hasOwnProperty = $d3cc5bb746d532c9$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $d3cc5bb746d532c9$var$reIsNative = RegExp('^' + $d3cc5bb746d532c9$var$funcToString.call($d3cc5bb746d532c9$var$hasOwnProperty).replace($d3cc5bb746d532c9$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $d3cc5bb746d532c9$var$baseIsNative(value) {
    if (!$cf434abf2d8b4420$exports(value) || $678bb6b8743d95ab$exports(value)) return false;
    var pattern = $0442f1343cf34522$exports(value) ? $d3cc5bb746d532c9$var$reIsNative : $d3cc5bb746d532c9$var$reIsHostCtor;
    return pattern.test($001a333ce63ce98d$exports(value));
}
$d3cc5bb746d532c9$exports = $d3cc5bb746d532c9$var$baseIsNative;


var $b12eea3d76e805fe$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $b12eea3d76e805fe$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$b12eea3d76e805fe$exports = $b12eea3d76e805fe$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $597f04cf2928ffb3$var$getNative(object, key) {
    var value = $b12eea3d76e805fe$exports(object, key);
    return $d3cc5bb746d532c9$exports(value) ? value : undefined;
}
$597f04cf2928ffb3$exports = $597f04cf2928ffb3$var$getNative;



var $6MeXQ = parcelRequire("6MeXQ");
/* Built-in method references that are verified to be native. */ var $f3012de369253e88$var$Map = $597f04cf2928ffb3$exports($6MeXQ, 'Map');
$f3012de369253e88$exports = $f3012de369253e88$var$Map;


var $712f16a934e6864b$exports = {};
var $f8ce40bb61cf8355$exports = {};
var $d2d4f41bee1f77ed$exports = {};
var $bd94e012b02be09e$exports = {};
var $5bab0e83a1eeb640$exports = {};

/* Built-in method references that are verified to be native. */ var $5bab0e83a1eeb640$var$nativeCreate = $597f04cf2928ffb3$exports(Object, 'create');
$5bab0e83a1eeb640$exports = $5bab0e83a1eeb640$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $bd94e012b02be09e$var$hashClear() {
    this.__data__ = $5bab0e83a1eeb640$exports ? $5bab0e83a1eeb640$exports(null) : {};
    this.size = 0;
}
$bd94e012b02be09e$exports = $bd94e012b02be09e$var$hashClear;


var $5813fd9616d31466$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $5813fd9616d31466$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$5813fd9616d31466$exports = $5813fd9616d31466$var$hashDelete;


var $935fa3239f5c3c42$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $935fa3239f5c3c42$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $935fa3239f5c3c42$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $935fa3239f5c3c42$var$hasOwnProperty = $935fa3239f5c3c42$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $935fa3239f5c3c42$var$hashGet(key) {
    var data = this.__data__;
    if ($5bab0e83a1eeb640$exports) {
        var result = data[key];
        return result === $935fa3239f5c3c42$var$HASH_UNDEFINED ? undefined : result;
    }
    return $935fa3239f5c3c42$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$935fa3239f5c3c42$exports = $935fa3239f5c3c42$var$hashGet;


var $60e2ff8ffcd043a5$exports = {};

/** Used for built-in method references. */ var $60e2ff8ffcd043a5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $60e2ff8ffcd043a5$var$hasOwnProperty = $60e2ff8ffcd043a5$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $60e2ff8ffcd043a5$var$hashHas(key) {
    var data = this.__data__;
    return $5bab0e83a1eeb640$exports ? data[key] !== undefined : $60e2ff8ffcd043a5$var$hasOwnProperty.call(data, key);
}
$60e2ff8ffcd043a5$exports = $60e2ff8ffcd043a5$var$hashHas;


var $ec77bd5dcf97c8c6$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $ec77bd5dcf97c8c6$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $ec77bd5dcf97c8c6$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $5bab0e83a1eeb640$exports && value === undefined ? $ec77bd5dcf97c8c6$var$HASH_UNDEFINED : value;
    return this;
}
$ec77bd5dcf97c8c6$exports = $ec77bd5dcf97c8c6$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $d2d4f41bee1f77ed$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$d2d4f41bee1f77ed$var$Hash.prototype.clear = $bd94e012b02be09e$exports;
$d2d4f41bee1f77ed$var$Hash.prototype['delete'] = $5813fd9616d31466$exports;
$d2d4f41bee1f77ed$var$Hash.prototype.get = $935fa3239f5c3c42$exports;
$d2d4f41bee1f77ed$var$Hash.prototype.has = $60e2ff8ffcd043a5$exports;
$d2d4f41bee1f77ed$var$Hash.prototype.set = $ec77bd5dcf97c8c6$exports;
$d2d4f41bee1f77ed$exports = $d2d4f41bee1f77ed$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $f8ce40bb61cf8355$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $d2d4f41bee1f77ed$exports,
        'map': new ($f3012de369253e88$exports || $627809b65c82b4ba$exports),
        'string': new $d2d4f41bee1f77ed$exports
    };
}
$f8ce40bb61cf8355$exports = $f8ce40bb61cf8355$var$mapCacheClear;


var $6e6895363a760b6b$exports = {};
var $3fdce9ea366b4460$exports = {};
var $40853df882defc25$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $40853df882defc25$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
$40853df882defc25$exports = $40853df882defc25$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $3fdce9ea366b4460$var$getMapData(map, key) {
    var data = map.__data__;
    return $40853df882defc25$exports(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
$3fdce9ea366b4460$exports = $3fdce9ea366b4460$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $6e6895363a760b6b$var$mapCacheDelete(key) {
    var result = $3fdce9ea366b4460$exports(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
$6e6895363a760b6b$exports = $6e6895363a760b6b$var$mapCacheDelete;


var $b39d322e66baadd8$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b39d322e66baadd8$var$mapCacheGet(key) {
    return $3fdce9ea366b4460$exports(this, key).get(key);
}
$b39d322e66baadd8$exports = $b39d322e66baadd8$var$mapCacheGet;


var $6157d2c0644accbc$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $6157d2c0644accbc$var$mapCacheHas(key) {
    return $3fdce9ea366b4460$exports(this, key).has(key);
}
$6157d2c0644accbc$exports = $6157d2c0644accbc$var$mapCacheHas;


var $c96abff08450b7f4$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $c96abff08450b7f4$var$mapCacheSet(key, value) {
    var data = $3fdce9ea366b4460$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$c96abff08450b7f4$exports = $c96abff08450b7f4$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $712f16a934e6864b$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$712f16a934e6864b$var$MapCache.prototype.clear = $f8ce40bb61cf8355$exports;
$712f16a934e6864b$var$MapCache.prototype['delete'] = $6e6895363a760b6b$exports;
$712f16a934e6864b$var$MapCache.prototype.get = $b39d322e66baadd8$exports;
$712f16a934e6864b$var$MapCache.prototype.has = $6157d2c0644accbc$exports;
$712f16a934e6864b$var$MapCache.prototype.set = $c96abff08450b7f4$exports;
$712f16a934e6864b$exports = $712f16a934e6864b$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $b5fdb6007f5bb3fe$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $b5fdb6007f5bb3fe$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $627809b65c82b4ba$exports) {
        var pairs = data.__data__;
        if (!$f3012de369253e88$exports || pairs.length < $b5fdb6007f5bb3fe$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $712f16a934e6864b$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$b5fdb6007f5bb3fe$exports = $b5fdb6007f5bb3fe$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $e2af73ab23f38ad8$var$Stack(entries) {
    var data = this.__data__ = new $627809b65c82b4ba$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$e2af73ab23f38ad8$var$Stack.prototype.clear = $0246df2251d98ae9$exports;
$e2af73ab23f38ad8$var$Stack.prototype['delete'] = $d22221c8a81abbed$exports;
$e2af73ab23f38ad8$var$Stack.prototype.get = $548879b9865e4f0d$exports;
$e2af73ab23f38ad8$var$Stack.prototype.has = $e7c74f1d89eed6d0$exports;
$e2af73ab23f38ad8$var$Stack.prototype.set = $b5fdb6007f5bb3fe$exports;
$e2af73ab23f38ad8$exports = $e2af73ab23f38ad8$var$Stack;


var $fd3d603613dcdb8d$exports = {};
var $2998047a70001512$exports = {};

var $8aeb185068d86515$exports = {};
var $9741b2058ed340c0$exports = {};

var $1b8547c2bd9f4f2b$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $1b8547c2bd9f4f2b$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $1b8547c2bd9f4f2b$var$setCacheAdd(value) {
    this.__data__.set(value, $1b8547c2bd9f4f2b$var$HASH_UNDEFINED);
    return this;
}
$1b8547c2bd9f4f2b$exports = $1b8547c2bd9f4f2b$var$setCacheAdd;


var $347bdadb1b6698a1$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */ function $347bdadb1b6698a1$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$347bdadb1b6698a1$exports = $347bdadb1b6698a1$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $9741b2058ed340c0$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $712f16a934e6864b$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$9741b2058ed340c0$var$SetCache.prototype.add = $9741b2058ed340c0$var$SetCache.prototype.push = $1b8547c2bd9f4f2b$exports;
$9741b2058ed340c0$var$SetCache.prototype.has = $347bdadb1b6698a1$exports;
$9741b2058ed340c0$exports = $9741b2058ed340c0$var$SetCache;


var $c648072cf6f60c9e$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $c648072cf6f60c9e$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$c648072cf6f60c9e$exports = $c648072cf6f60c9e$var$arraySome;


var $530d002bad5670bf$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $530d002bad5670bf$var$cacheHas(cache, key) {
    return cache.has(key);
}
$530d002bad5670bf$exports = $530d002bad5670bf$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $8aeb185068d86515$var$COMPARE_PARTIAL_FLAG = 1, $8aeb185068d86515$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $8aeb185068d86515$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $8aeb185068d86515$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $8aeb185068d86515$var$COMPARE_UNORDERED_FLAG ? new $9741b2058ed340c0$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$c648072cf6f60c9e$exports(other, function(othValue, othIndex) {
                if (!$530d002bad5670bf$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
$8aeb185068d86515$exports = $8aeb185068d86515$var$equalArrays;


var $ef7c364829922b90$exports = {};

var $927bb78d7117fe46$exports = {};

var $6MeXQ = parcelRequire("6MeXQ");
/** Built-in value references. */ var $927bb78d7117fe46$var$Uint8Array = $6MeXQ.Uint8Array;
$927bb78d7117fe46$exports = $927bb78d7117fe46$var$Uint8Array;




var $4f623afe920702a8$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $4f623afe920702a8$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$4f623afe920702a8$exports = $4f623afe920702a8$var$mapToArray;


var $2e9014327564fd16$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $2e9014327564fd16$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$2e9014327564fd16$exports = $2e9014327564fd16$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $ef7c364829922b90$var$COMPARE_PARTIAL_FLAG = 1, $ef7c364829922b90$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $ef7c364829922b90$var$boolTag = '[object Boolean]', $ef7c364829922b90$var$dateTag = '[object Date]', $ef7c364829922b90$var$errorTag = '[object Error]', $ef7c364829922b90$var$mapTag = '[object Map]', $ef7c364829922b90$var$numberTag = '[object Number]', $ef7c364829922b90$var$regexpTag = '[object RegExp]', $ef7c364829922b90$var$setTag = '[object Set]', $ef7c364829922b90$var$stringTag = '[object String]', $ef7c364829922b90$var$symbolTag = '[object Symbol]';
var $ef7c364829922b90$var$arrayBufferTag = '[object ArrayBuffer]', $ef7c364829922b90$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $ef7c364829922b90$var$symbolProto = $ead57c66122851dd$exports ? $ead57c66122851dd$exports.prototype : undefined, $ef7c364829922b90$var$symbolValueOf = $ef7c364829922b90$var$symbolProto ? $ef7c364829922b90$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $ef7c364829922b90$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $ef7c364829922b90$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $ef7c364829922b90$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $927bb78d7117fe46$exports(object), new $927bb78d7117fe46$exports(other))) return false;
            return true;
        case $ef7c364829922b90$var$boolTag:
        case $ef7c364829922b90$var$dateTag:
        case $ef7c364829922b90$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $7bddb65de45933c2$exports(+object, +other);
        case $ef7c364829922b90$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $ef7c364829922b90$var$regexpTag:
        case $ef7c364829922b90$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $ef7c364829922b90$var$mapTag:
            var convert = $4f623afe920702a8$exports;
        case $ef7c364829922b90$var$setTag:
            var isPartial = bitmask & $ef7c364829922b90$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $2e9014327564fd16$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $ef7c364829922b90$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $8aeb185068d86515$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $ef7c364829922b90$var$symbolTag:
            if ($ef7c364829922b90$var$symbolValueOf) return $ef7c364829922b90$var$symbolValueOf.call(object) == $ef7c364829922b90$var$symbolValueOf.call(other);
    }
    return false;
}
$ef7c364829922b90$exports = $ef7c364829922b90$var$equalByTag;


var $a085fb00a25a2a0d$exports = {};
var $0d4400596f574e9d$exports = {};
var $0a7e5223a664f288$exports = {};
var $a02b4f0317aeef2b$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $a02b4f0317aeef2b$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$a02b4f0317aeef2b$exports = $a02b4f0317aeef2b$var$arrayPush;



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $0a7e5223a664f288$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $62cdb8c6d4925eaf$exports(object) ? result : $a02b4f0317aeef2b$exports(result, symbolsFunc(object));
}
$0a7e5223a664f288$exports = $0a7e5223a664f288$var$baseGetAllKeys;


var $41b1c312095a9379$exports = {};

var $fb6a47dc5dcbe42b$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $fb6a47dc5dcbe42b$var$stubArray() {
    return [];
}
$fb6a47dc5dcbe42b$exports = $fb6a47dc5dcbe42b$var$stubArray;


/** Used for built-in method references. */ var $41b1c312095a9379$var$objectProto = Object.prototype;
/** Built-in value references. */ var $41b1c312095a9379$var$propertyIsEnumerable = $41b1c312095a9379$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $41b1c312095a9379$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $41b1c312095a9379$var$getSymbols = !$41b1c312095a9379$var$nativeGetSymbols ? $fb6a47dc5dcbe42b$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $a395ddd63466c02f$exports($41b1c312095a9379$var$nativeGetSymbols(object), function(symbol) {
        return $41b1c312095a9379$var$propertyIsEnumerable.call(object, symbol);
    });
};
$41b1c312095a9379$exports = $41b1c312095a9379$var$getSymbols;



/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $0d4400596f574e9d$var$getAllKeys(object) {
    return $0a7e5223a664f288$exports(object, $056379088e51592c$exports, $41b1c312095a9379$exports);
}
$0d4400596f574e9d$exports = $0d4400596f574e9d$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $a085fb00a25a2a0d$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $a085fb00a25a2a0d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a085fb00a25a2a0d$var$hasOwnProperty = $a085fb00a25a2a0d$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $a085fb00a25a2a0d$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $a085fb00a25a2a0d$var$COMPARE_PARTIAL_FLAG, objProps = $0d4400596f574e9d$exports(object), objLength = objProps.length, othProps = $0d4400596f574e9d$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $a085fb00a25a2a0d$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
$a085fb00a25a2a0d$exports = $a085fb00a25a2a0d$var$equalObjects;


var $6be9ad9ef095ee68$exports = {};
var $1b3f0e7188d5b83a$exports = {};


var $6MeXQ = parcelRequire("6MeXQ");
/* Built-in method references that are verified to be native. */ var $1b3f0e7188d5b83a$var$DataView = $597f04cf2928ffb3$exports($6MeXQ, 'DataView');
$1b3f0e7188d5b83a$exports = $1b3f0e7188d5b83a$var$DataView;



var $494f71885d3b3141$exports = {};


var $6MeXQ = parcelRequire("6MeXQ");
/* Built-in method references that are verified to be native. */ var $494f71885d3b3141$var$Promise = $597f04cf2928ffb3$exports($6MeXQ, 'Promise');
$494f71885d3b3141$exports = $494f71885d3b3141$var$Promise;


var $0bb4aadd52a820c8$exports = {};


var $6MeXQ = parcelRequire("6MeXQ");
/* Built-in method references that are verified to be native. */ var $0bb4aadd52a820c8$var$Set = $597f04cf2928ffb3$exports($6MeXQ, 'Set');
$0bb4aadd52a820c8$exports = $0bb4aadd52a820c8$var$Set;


var $fc97d4cd6b1953c1$exports = {};


var $6MeXQ = parcelRequire("6MeXQ");
/* Built-in method references that are verified to be native. */ var $fc97d4cd6b1953c1$var$WeakMap = $597f04cf2928ffb3$exports($6MeXQ, 'WeakMap');
$fc97d4cd6b1953c1$exports = $fc97d4cd6b1953c1$var$WeakMap;




/** `Object#toString` result references. */ var $6be9ad9ef095ee68$var$mapTag = '[object Map]', $6be9ad9ef095ee68$var$objectTag = '[object Object]', $6be9ad9ef095ee68$var$promiseTag = '[object Promise]', $6be9ad9ef095ee68$var$setTag = '[object Set]', $6be9ad9ef095ee68$var$weakMapTag = '[object WeakMap]';
var $6be9ad9ef095ee68$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $6be9ad9ef095ee68$var$dataViewCtorString = $001a333ce63ce98d$exports($1b3f0e7188d5b83a$exports), $6be9ad9ef095ee68$var$mapCtorString = $001a333ce63ce98d$exports($f3012de369253e88$exports), $6be9ad9ef095ee68$var$promiseCtorString = $001a333ce63ce98d$exports($494f71885d3b3141$exports), $6be9ad9ef095ee68$var$setCtorString = $001a333ce63ce98d$exports($0bb4aadd52a820c8$exports), $6be9ad9ef095ee68$var$weakMapCtorString = $001a333ce63ce98d$exports($fc97d4cd6b1953c1$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $6be9ad9ef095ee68$var$getTag = $c1801119ed7f09fb$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($1b3f0e7188d5b83a$exports && $6be9ad9ef095ee68$var$getTag(new $1b3f0e7188d5b83a$exports(new ArrayBuffer(1))) != $6be9ad9ef095ee68$var$dataViewTag || $f3012de369253e88$exports && $6be9ad9ef095ee68$var$getTag(new $f3012de369253e88$exports) != $6be9ad9ef095ee68$var$mapTag || $494f71885d3b3141$exports && $6be9ad9ef095ee68$var$getTag($494f71885d3b3141$exports.resolve()) != $6be9ad9ef095ee68$var$promiseTag || $0bb4aadd52a820c8$exports && $6be9ad9ef095ee68$var$getTag(new $0bb4aadd52a820c8$exports) != $6be9ad9ef095ee68$var$setTag || $fc97d4cd6b1953c1$exports && $6be9ad9ef095ee68$var$getTag(new $fc97d4cd6b1953c1$exports) != $6be9ad9ef095ee68$var$weakMapTag) $6be9ad9ef095ee68$var$getTag = function(value) {
    var result = $c1801119ed7f09fb$exports(value), Ctor = result == $6be9ad9ef095ee68$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $001a333ce63ce98d$exports(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $6be9ad9ef095ee68$var$dataViewCtorString:
            return $6be9ad9ef095ee68$var$dataViewTag;
        case $6be9ad9ef095ee68$var$mapCtorString:
            return $6be9ad9ef095ee68$var$mapTag;
        case $6be9ad9ef095ee68$var$promiseCtorString:
            return $6be9ad9ef095ee68$var$promiseTag;
        case $6be9ad9ef095ee68$var$setCtorString:
            return $6be9ad9ef095ee68$var$setTag;
        case $6be9ad9ef095ee68$var$weakMapCtorString:
            return $6be9ad9ef095ee68$var$weakMapTag;
    }
    return result;
};
$6be9ad9ef095ee68$exports = $6be9ad9ef095ee68$var$getTag;




var $lEd8H = parcelRequire("lEd8H");

/** Used to compose bitmasks for value comparisons. */ var $2998047a70001512$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $2998047a70001512$var$argsTag = '[object Arguments]', $2998047a70001512$var$arrayTag = '[object Array]', $2998047a70001512$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $2998047a70001512$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2998047a70001512$var$hasOwnProperty = $2998047a70001512$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $2998047a70001512$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $62cdb8c6d4925eaf$exports(object), othIsArr = $62cdb8c6d4925eaf$exports(other), objTag = objIsArr ? $2998047a70001512$var$arrayTag : $6be9ad9ef095ee68$exports(object), othTag = othIsArr ? $2998047a70001512$var$arrayTag : $6be9ad9ef095ee68$exports(other);
    objTag = objTag == $2998047a70001512$var$argsTag ? $2998047a70001512$var$objectTag : objTag;
    othTag = othTag == $2998047a70001512$var$argsTag ? $2998047a70001512$var$objectTag : othTag;
    var objIsObj = objTag == $2998047a70001512$var$objectTag, othIsObj = othTag == $2998047a70001512$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $lEd8H(object)) {
        if (!$lEd8H(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $e2af73ab23f38ad8$exports);
        return objIsArr || $4b6171d69f23c564$exports(object) ? $8aeb185068d86515$exports(object, other, bitmask, customizer, equalFunc, stack) : $ef7c364829922b90$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $2998047a70001512$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $2998047a70001512$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $2998047a70001512$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $e2af73ab23f38ad8$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $e2af73ab23f38ad8$exports);
    return $a085fb00a25a2a0d$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$2998047a70001512$exports = $2998047a70001512$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $fd3d603613dcdb8d$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$591571b7706a9b83$exports(value) && !$591571b7706a9b83$exports(other)) return value !== value && other !== other;
    return $2998047a70001512$exports(value, other, bitmask, customizer, $fd3d603613dcdb8d$var$baseIsEqual, stack);
}
$fd3d603613dcdb8d$exports = $fd3d603613dcdb8d$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $987f94fd936c5516$var$COMPARE_PARTIAL_FLAG = 1, $987f94fd936c5516$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $987f94fd936c5516$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $e2af73ab23f38ad8$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $fd3d603613dcdb8d$exports(srcValue, objValue, $987f94fd936c5516$var$COMPARE_PARTIAL_FLAG | $987f94fd936c5516$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$987f94fd936c5516$exports = $987f94fd936c5516$var$baseIsMatch;


var $7c79fc14263bcdf8$exports = {};
var $27cba71430b1b45f$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $27cba71430b1b45f$var$isStrictComparable(value) {
    return value === value && !$cf434abf2d8b4420$exports(value);
}
$27cba71430b1b45f$exports = $27cba71430b1b45f$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $7c79fc14263bcdf8$var$getMatchData(object) {
    var result = $056379088e51592c$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $27cba71430b1b45f$exports(value)
        ];
    }
    return result;
}
$7c79fc14263bcdf8$exports = $7c79fc14263bcdf8$var$getMatchData;


var $41ef1db4eb29eae8$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $41ef1db4eb29eae8$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$41ef1db4eb29eae8$exports = $41ef1db4eb29eae8$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $4703ed1ea2a89eda$var$baseMatches(source) {
    var matchData = $7c79fc14263bcdf8$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $41ef1db4eb29eae8$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $987f94fd936c5516$exports(object, source, matchData);
    };
}
$4703ed1ea2a89eda$exports = $4703ed1ea2a89eda$var$baseMatches;


var $28cd9c270e1f68d2$exports = {};

var $6bef750c25f25b1e$exports = {};
var $734338988f1c1fe9$exports = {};
var $555653dc3f0215e0$exports = {};

var $6db0b5b6827390ad$exports = {};

var $d1a8a725aa97dcdd$exports = {};


/** `Object#toString` result references. */ var $d1a8a725aa97dcdd$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $d1a8a725aa97dcdd$var$isSymbol(value) {
    return typeof value == 'symbol' || $591571b7706a9b83$exports(value) && $c1801119ed7f09fb$exports(value) == $d1a8a725aa97dcdd$var$symbolTag;
}
$d1a8a725aa97dcdd$exports = $d1a8a725aa97dcdd$var$isSymbol;


/** Used to match property names within property paths. */ var $6db0b5b6827390ad$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $6db0b5b6827390ad$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $6db0b5b6827390ad$var$isKey(value, object) {
    if ($62cdb8c6d4925eaf$exports(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $d1a8a725aa97dcdd$exports(value)) return true;
    return $6db0b5b6827390ad$var$reIsPlainProp.test(value) || !$6db0b5b6827390ad$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$6db0b5b6827390ad$exports = $6db0b5b6827390ad$var$isKey;


var $a97abf5b52877c80$exports = {};
var $d99eebb40968669f$exports = {};
var $c6abd82bf9a92371$exports = {};

/** Error message constants. */ var $c6abd82bf9a92371$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $c6abd82bf9a92371$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($c6abd82bf9a92371$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($c6abd82bf9a92371$var$memoize.Cache || $712f16a934e6864b$exports);
    return memoized;
}
// Expose `MapCache`.
$c6abd82bf9a92371$var$memoize.Cache = $712f16a934e6864b$exports;
$c6abd82bf9a92371$exports = $c6abd82bf9a92371$var$memoize;


/** Used as the maximum memoize cache size. */ var $d99eebb40968669f$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $d99eebb40968669f$var$memoizeCapped(func) {
    var result = $c6abd82bf9a92371$exports(func, function(key) {
        if (cache.size === $d99eebb40968669f$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$d99eebb40968669f$exports = $d99eebb40968669f$var$memoizeCapped;


/** Used to match property names within property paths. */ var $a97abf5b52877c80$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $a97abf5b52877c80$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $a97abf5b52877c80$var$stringToPath = $d99eebb40968669f$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($a97abf5b52877c80$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($a97abf5b52877c80$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
$a97abf5b52877c80$exports = $a97abf5b52877c80$var$stringToPath;


var $37b1416d39027d17$exports = {};
var $758d5708b8481a4b$exports = {};

var $ccf4e6cf384a4c5e$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $ccf4e6cf384a4c5e$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$ccf4e6cf384a4c5e$exports = $ccf4e6cf384a4c5e$var$arrayMap;




/** Used as references for various `Number` constants. */ var $758d5708b8481a4b$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $758d5708b8481a4b$var$symbolProto = $ead57c66122851dd$exports ? $ead57c66122851dd$exports.prototype : undefined, $758d5708b8481a4b$var$symbolToString = $758d5708b8481a4b$var$symbolProto ? $758d5708b8481a4b$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $758d5708b8481a4b$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($62cdb8c6d4925eaf$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $ccf4e6cf384a4c5e$exports(value, $758d5708b8481a4b$var$baseToString) + '';
    if ($d1a8a725aa97dcdd$exports(value)) return $758d5708b8481a4b$var$symbolToString ? $758d5708b8481a4b$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$758d5708b8481a4b$var$INFINITY ? '-0' : result;
}
$758d5708b8481a4b$exports = $758d5708b8481a4b$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $37b1416d39027d17$var$toString(value) {
    return value == null ? '' : $758d5708b8481a4b$exports(value);
}
$37b1416d39027d17$exports = $37b1416d39027d17$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $555653dc3f0215e0$var$castPath(value, object) {
    if ($62cdb8c6d4925eaf$exports(value)) return value;
    return $6db0b5b6827390ad$exports(value, object) ? [
        value
    ] : $a97abf5b52877c80$exports($37b1416d39027d17$exports(value));
}
$555653dc3f0215e0$exports = $555653dc3f0215e0$var$castPath;


var $da13faf060386658$exports = {};

/** Used as references for various `Number` constants. */ var $da13faf060386658$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $da13faf060386658$var$toKey(value) {
    if (typeof value == 'string' || $d1a8a725aa97dcdd$exports(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$da13faf060386658$var$INFINITY ? '-0' : result;
}
$da13faf060386658$exports = $da13faf060386658$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $734338988f1c1fe9$var$baseGet(object, path) {
    path = $555653dc3f0215e0$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$da13faf060386658$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$734338988f1c1fe9$exports = $734338988f1c1fe9$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $6bef750c25f25b1e$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $734338988f1c1fe9$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$6bef750c25f25b1e$exports = $6bef750c25f25b1e$var$get;


var $592de2f4a5da1c23$exports = {};
var $f0c1f1b4857e37ad$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $f0c1f1b4857e37ad$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$f0c1f1b4857e37ad$exports = $f0c1f1b4857e37ad$var$baseHasIn;


var $3b06e05ca9726ad1$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $3b06e05ca9726ad1$var$hasPath(object, path, hasFunc) {
    path = $555653dc3f0215e0$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $da13faf060386658$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $ac91b26f95fa5e9e$exports(length) && $ed54d9446c437622$exports(key, length) && ($62cdb8c6d4925eaf$exports(object) || $2b1962154d35d43c$exports(object));
}
$3b06e05ca9726ad1$exports = $3b06e05ca9726ad1$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $592de2f4a5da1c23$var$hasIn(object, path) {
    return object != null && $3b06e05ca9726ad1$exports(object, path, $f0c1f1b4857e37ad$exports);
}
$592de2f4a5da1c23$exports = $592de2f4a5da1c23$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $28cd9c270e1f68d2$var$COMPARE_PARTIAL_FLAG = 1, $28cd9c270e1f68d2$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $28cd9c270e1f68d2$var$baseMatchesProperty(path, srcValue) {
    if ($6db0b5b6827390ad$exports(path) && $27cba71430b1b45f$exports(srcValue)) return $41ef1db4eb29eae8$exports($da13faf060386658$exports(path), srcValue);
    return function(object) {
        var objValue = $6bef750c25f25b1e$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $592de2f4a5da1c23$exports(object, path) : $fd3d603613dcdb8d$exports(srcValue, objValue, $28cd9c270e1f68d2$var$COMPARE_PARTIAL_FLAG | $28cd9c270e1f68d2$var$COMPARE_UNORDERED_FLAG);
    };
}
$28cd9c270e1f68d2$exports = $28cd9c270e1f68d2$var$baseMatchesProperty;


var $ee673408ad6fac6e$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $ee673408ad6fac6e$var$identity(value) {
    return value;
}
$ee673408ad6fac6e$exports = $ee673408ad6fac6e$var$identity;



var $60f32e7bcc0dae9b$exports = {};
var $8e5a5a2112ae69b3$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $8e5a5a2112ae69b3$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$8e5a5a2112ae69b3$exports = $8e5a5a2112ae69b3$var$baseProperty;


var $342bb7a06f9f0a12$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $342bb7a06f9f0a12$var$basePropertyDeep(path) {
    return function(object) {
        return $734338988f1c1fe9$exports(object, path);
    };
}
$342bb7a06f9f0a12$exports = $342bb7a06f9f0a12$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $60f32e7bcc0dae9b$var$property(path) {
    return $6db0b5b6827390ad$exports(path) ? $8e5a5a2112ae69b3$exports($da13faf060386658$exports(path)) : $342bb7a06f9f0a12$exports(path);
}
$60f32e7bcc0dae9b$exports = $60f32e7bcc0dae9b$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $76648cdc70b67884$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $ee673408ad6fac6e$exports;
    if (typeof value == 'object') return $62cdb8c6d4925eaf$exports(value) ? $28cd9c270e1f68d2$exports(value[0], value[1]) : $4703ed1ea2a89eda$exports(value);
    return $60f32e7bcc0dae9b$exports(value);
}
$76648cdc70b67884$exports = $76648cdc70b67884$var$baseIteratee;



var $166b889bf81cfb7e$exports = {};
/** Error message constants. */ var $166b889bf81cfb7e$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */ function $166b889bf81cfb7e$var$negate(predicate) {
    if (typeof predicate != 'function') throw new TypeError($166b889bf81cfb7e$var$FUNC_ERROR_TEXT);
    return function() {
        var args = arguments;
        switch(args.length){
            case 0:
                return !predicate.call(this);
            case 1:
                return !predicate.call(this, args[0]);
            case 2:
                return !predicate.call(this, args[0], args[1]);
            case 3:
                return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
    };
}
$166b889bf81cfb7e$exports = $166b889bf81cfb7e$var$negate;


/**
 * The opposite of `_.filter`; this method returns the elements of `collection`
 * that `predicate` does **not** return truthy for.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.filter
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': true }
 * ];
 *
 * _.reject(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.reject(users, { 'age': 40, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.reject(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.reject(users, 'active');
 * // => objects for ['barney']
 */ function $3b1840a410238012$var$reject(collection, predicate) {
    var func = $62cdb8c6d4925eaf$exports(collection) ? $a395ddd63466c02f$exports : $ee94ed03c5cc70f8$exports;
    return func(collection, $166b889bf81cfb7e$exports($76648cdc70b67884$exports(predicate, 3)));
}
$3b1840a410238012$exports = $3b1840a410238012$var$reject;


const $d461fe14ae9e01be$export$1dddb0652e9e9170 = {
    name: 'autogen',
    duration: '0',
    replication: 2,
    isDefault: true,
    links: {
        self: ''
    }
};
const $d461fe14ae9e01be$export$1896830dbcbc66cf = {
    name: '',
    duration: '',
    replication: 0,
    links: {
        self: ''
    },
    isNew: true
};
const $d461fe14ae9e01be$export$e235c9dfa22f5bfb = {
    name: '',
    isNew: true,
    retentionPolicies: [
        $d461fe14ae9e01be$export$1dddb0652e9e9170
    ]
};



/**
 * InfluxDuration represents components of InfluxDB duration.
 * See https://docs.influxdata.com/influxdb/v1.8/query_language/spec/#durations
 */ const $66e6bf5fb1169d8c$var$durationPartIndex = {
    w: 0,
    d: 1,
    h: 2,
    m: 3,
    s: 4,
    ms: 5,
    u: 6,
    "\xb5s": 6,
    ns: 7
};
function $66e6bf5fb1169d8c$export$ecae829bb3747ea6(duration) {
    const retVal = new Array(8).fill(0);
    const regExp = /([0-9]+)([^0-9]+)/g;
    let matched;
    while((matched = regExp.exec(duration)) !== null){
        const index = $66e6bf5fb1169d8c$var$durationPartIndex[matched[2]];
        if (index === undefined) continue;
        retVal[index] = parseInt(matched[1], 10);
    }
    return retVal;
}
function $66e6bf5fb1169d8c$export$71cf2fd3f72034e7(a, b) {
    let i = 0;
    for(; i < 8; i++){
        if (a[i] !== b[i]) return a[i] - b[i];
    }
    return 0;
}


function $998600a35464067b$export$a7a925196f2b3c04(prev, next) {
    const retVal = {};
    // indicate all prev values as removed
    prev.forEach(({ name: name })=>retVal[name] = false);
    // indicate all new values as added, existing as undefined
    next.forEach(({ name: name })=>retVal[name] = retVal[name] === false ? undefined : true);
    // filter all undefined values
    let changed = false;
    const onlyChanges = Object.entries(retVal).reduce((acc, [key, value])=>{
        if (value !== undefined) {
            changed = true;
            acc[key] = value;
        }
        return acc;
    }, {});
    return changed ? onlyChanges : undefined;
}
function $998600a35464067b$export$5f9276a58fb43b0d(values, element, changeType) {
    if (changeType === undefined) // no changes requested, do nothing
    return values;
    if (changeType) {
        // insert to the existing collection
        let i = 0;
        for(; i < values.length; i++){
            if (values[i].name.localeCompare(element.name) >= 0) break;
        }
        const retVal = [
            ...values
        ];
        retVal.splice(i, 0, element);
        return retVal;
    }
    // remove from existing collection
    return values.filter(({ name: name })=>name !== element.name);
}


/**
 * AllOrParticularSelection function modifies new values selection to
 * exclude a particular option when all ('*') option is newly selected,
 * and to exclude '*' option when a particular option is newly selected.
 */ function $7c54fbf649e1f116$export$2e2bcd8739ae039(oldVals, newVals) {
    if (newVals.length <= 1) // empty or simpgle selection is always OK
    return newVals;
    const isAll = newVals.includes('*');
    const wasAll = oldVals.includes('*');
    if (wasAll && isAll) // more than one value is selected, remove <ALL> option
    return newVals.filter((x)=>x !== '*');
    if (!wasAll && isAll) // <ALL> option is selected, keep only the <ALL> option
    return [
        '*'
    ];
    return newVals;
}


const $eed4757442137a56$var$querySorters = {
    '+time' (queries) {
        queries.forEach((x)=>x._pd = (0, $66e6bf5fb1169d8c$export$ecae829bb3747ea6)(x.duration));
        return queries.sort((a, b)=>{
            return (0, $66e6bf5fb1169d8c$export$71cf2fd3f72034e7)(a._pd, b._pd);
        });
    },
    '-time' (queries) {
        queries.forEach((x)=>x._pd = (0, $66e6bf5fb1169d8c$export$ecae829bb3747ea6)(x.duration));
        return queries.sort((a, b)=>{
            return -(0, $66e6bf5fb1169d8c$export$71cf2fd3f72034e7)(a._pd, b._pd);
        });
    },
    '+database' (queries) {
        queries.forEach((x)=>x._pd = (0, $66e6bf5fb1169d8c$export$ecae829bb3747ea6)(x.duration));
        return queries.sort((a, b)=>{
            return a.database.localeCompare(b.database);
        });
    },
    '-database' (queries) {
        queries.forEach((x)=>x._pd = (0, $66e6bf5fb1169d8c$export$ecae829bb3747ea6)(x.duration));
        return queries.sort((a, b)=>{
            return -a.database.localeCompare(b.database);
        });
    }
};
const $eed4757442137a56$var$identity = (x)=>x;
function $eed4757442137a56$var$sortQueries(queries, queriesSort) {
    return ($eed4757442137a56$var$querySorters[queriesSort] || $eed4757442137a56$var$identity)(queries);
}
const $eed4757442137a56$export$d4c72bab9d6cc13a = {
    users: [],
    roles: [],
    permissions: [],
    queries: [],
    queriesSort: '-time',
    queryIDToKill: null,
    databases: [],
    selectedDBs: [
        '*'
    ],
    showUsers: true,
    showRoles: true,
    usersFilter: '',
    rolesFilter: ''
};
const $eed4757442137a56$var$adminInfluxDB = (state = $eed4757442137a56$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 'INFLUXDB_LOAD_USERS':
            return {
                ...state,
                ...action.payload,
                usersFilter: ''
            };
        case 'INFLUXDB_LOAD_ROLES':
            return {
                ...state,
                ...action.payload,
                rolesFilter: ''
            };
        case 'INFLUXDB_LOAD_PERMISSIONS':
            return {
                ...state,
                ...action.payload
            };
        case 'INFLUXDB_LOAD_DATABASES':
            {
                const databases = action.payload.databases;
                const selectedDBs = $eed4757442137a56$export$d4c72bab9d6cc13a.selectedDBs;
                return {
                    ...state,
                    databases: databases,
                    selectedDBs: selectedDBs
                };
            }
        case 'INFLUXDB_ADD_DATABASE':
            {
                const newDatabase = {
                    ...(0, $d461fe14ae9e01be$export$e235c9dfa22f5bfb),
                    links: {
                        self: `temp-ID${(0, $dbdc5944552afab7$export$2e2bcd8739ae039)()}`
                    },
                    isEditing: true
                };
                return {
                    ...state,
                    databases: [
                        newDatabase,
                        ...state.databases
                    ]
                };
            }
        case 'INFLUXDB_ADD_RETENTION_POLICY':
            {
                const { database: database } = action.payload;
                const databases = state.databases.map((db)=>db.links.self === database.links.self ? {
                        ...database,
                        retentionPolicies: [
                            {
                                ...(0, $d461fe14ae9e01be$export$1896830dbcbc66cf)
                            },
                            ...database.retentionPolicies
                        ]
                    } : db);
                return {
                    ...state,
                    databases: databases
                };
            }
        case 'INFLUXDB_SYNC_USER':
            {
                const { staleUser: staleUser, syncedUser: syncedUser } = action.payload;
                const newUsers = staleUser.links ? state.users.map((u)=>u.links.self === staleUser.links.self ? {
                        ...syncedUser
                    } : u) : [
                    {
                        ...syncedUser
                    },
                    ...state.users
                ];
                const rolesChange = (0, $998600a35464067b$export$a7a925196f2b3c04)(staleUser.roles || [], syncedUser.roles || []);
                if (rolesChange) {
                    // update roles that add/remove synced user
                    const newRoles = state.roles.map((r)=>{
                        const change = rolesChange[r.name];
                        if (change !== undefined) return {
                            ...r,
                            users: (0, $998600a35464067b$export$5f9276a58fb43b0d)(r.users, {
                                ...syncedUser
                            }, change)
                        };
                        return r;
                    });
                    return {
                        ...state,
                        users: newUsers,
                        roles: newRoles
                    };
                }
                return {
                    ...state,
                    users: newUsers
                };
            }
        case 'INFLUXDB_SYNC_ROLE':
            {
                const { staleRole: staleRole, syncedRole: syncedRole } = action.payload;
                const newRoles = staleRole.links ? state.roles.map((r)=>r.links.self === staleRole.links.self ? {
                        ...syncedRole
                    } : r) : [
                    {
                        ...syncedRole
                    },
                    ...state.roles
                ];
                const usersChange = (0, $998600a35464067b$export$a7a925196f2b3c04)(staleRole.users || [], syncedRole.users || []);
                if (usersChange) {
                    // update users that add/remove synced role
                    const newUsers = state.users.map((u)=>{
                        const change = usersChange[u.name];
                        if (change !== undefined) return {
                            ...u,
                            roles: (0, $998600a35464067b$export$5f9276a58fb43b0d)(u.roles, {
                                ...syncedRole
                            }, change)
                        };
                        return u;
                    });
                    return {
                        ...state,
                        roles: newRoles,
                        users: newUsers
                    };
                }
                return {
                    ...state,
                    roles: newRoles
                };
            }
        case 'INFLUXDB_SYNC_DATABASE':
            {
                const { stale: stale, synced: synced } = action.payload;
                const newState = {
                    databases: state.databases.map((db)=>db.links.self === stale.links.self ? {
                            ...synced
                        } : db)
                };
                return {
                    ...state,
                    ...newState
                };
            }
        case 'INFLUXDB_SYNC_RETENTION_POLICY':
            {
                const { database: database, stale: stale, synced: synced } = action.payload;
                const newState = {
                    databases: state.databases.map((db)=>db.links.self === database.links.self ? {
                            ...db,
                            retentionPolicies: db.retentionPolicies.map((rp)=>rp.links.self === stale.links.self ? {
                                    ...synced
                                } : rp)
                        } : db)
                };
                return {
                    ...state,
                    ...newState
                };
            }
        case 'INFLUXDB_EDIT_DATABASE':
            {
                const { database: database, updates: updates } = action.payload;
                const newState = {
                    databases: state.databases.map((db)=>db.links.self === database.links.self ? {
                            ...db,
                            ...updates
                        } : db)
                };
                return {
                    ...state,
                    ...newState
                };
            }
        case 'INFLUXDB_EDIT_RETENTION_POLICY_REQUESTED':
            {
                const { database: database, retentionPolicy: retentionPolicy, updates: updates } = action.payload;
                const newState = {
                    databases: state.databases.map((db)=>db.links.self === database.links.self ? {
                            ...db,
                            retentionPolicies: db.retentionPolicies.map((rp)=>rp.links.self === retentionPolicy.links.self ? {
                                    ...rp,
                                    ...updates
                                } : rp)
                        } : db)
                };
                return {
                    ...state,
                    ...newState
                };
            }
        case 'INFLUXDB_EDIT_RETENTION_POLICY_FAILED':
            {
                const { database: database, retentionPolicy: retentionPolicy } = action.payload;
                const newState = {
                    databases: state.databases.map((db)=>db.links.self === database.links.self ? {
                            ...db,
                            retentionPolicies: db.retentionPolicies.map((rp)=>rp.links.self === retentionPolicy.links.self ? {
                                    ...rp,
                                    ...retentionPolicy
                                } : rp)
                        } : db)
                };
                return {
                    ...state,
                    ...newState
                };
            }
        case 'INFLUXDB_DELETE_USER':
            {
                const { user: user } = action.payload;
                if (user.links) {
                    const newState = {
                        users: state.users.filter((u)=>u.links.self !== user.links.self)
                    };
                    return {
                        ...state,
                        ...newState
                    };
                }
                return state;
            }
        case 'INFLUXDB_DELETE_ROLE':
            {
                const { role: role } = action.payload;
                if (role.links) {
                    const newState = {
                        roles: state.roles.filter((r)=>r.links.self !== role.links.self)
                    };
                    return {
                        ...state,
                        ...newState
                    };
                }
                return state;
            }
        case 'INFLUXDB_REMOVE_DATABASE':
            {
                const { database: database } = action.payload;
                const newState = {
                    databases: state.databases.filter((db)=>db.links.self !== database.links.self)
                };
                return {
                    ...state,
                    ...newState
                };
            }
        case 'INFLUXDB_REMOVE_RETENTION_POLICY':
            {
                const { database: database, retentionPolicy: retentionPolicy } = action.payload;
                const newState = {
                    databases: state.databases.map((db)=>db.links.self === database.links.self ? {
                            ...db,
                            retentionPolicies: db.retentionPolicies.filter((rp)=>rp.links.self !== retentionPolicy.links.self)
                        } : db)
                };
                return {
                    ...state,
                    ...newState
                };
            }
        case 'INFLUXDB_ADD_DATABASE_DELETE_CODE':
            {
                const { database: database } = action.payload;
                const newState = {
                    databases: state.databases.map((db)=>db.links.self === database.links.self ? {
                            ...db,
                            deleteCode: ''
                        } : db)
                };
                return {
                    ...state,
                    ...newState
                };
            }
        case 'INFLUXDB_REMOVE_DATABASE_DELETE_CODE':
            {
                const { database: database } = action.payload;
                delete database.deleteCode;
                const newState = {
                    databases: state.databases.map((db)=>db.links.self === database.links.self ? {
                            ...database
                        } : db)
                };
                return {
                    ...state,
                    ...newState
                };
            }
        case 'INFLUXDB_LOAD_QUERIES':
            return {
                ...state,
                queries: $eed4757442137a56$var$sortQueries(action.payload.queries, state.queriesSort)
            };
        case 'INFLUXDB_SET_QUERIES_SORT':
            {
                const queriesSort = action.payload.queriesSort;
                return {
                    ...state,
                    queriesSort: queriesSort,
                    queries: $eed4757442137a56$var$sortQueries(state.queries, queriesSort)
                };
            }
        case 'INFLUXDB_FILTER_USERS':
            {
                const { text: text } = action.payload;
                const newState = {
                    users: state.users.map((u)=>{
                        u.hidden = !u.name.toLowerCase().includes(text);
                        return u;
                    })
                };
                return {
                    ...state,
                    ...newState,
                    usersFilter: text
                };
            }
        case 'INFLUXDB_FILTER_ROLES':
            {
                const { text: text } = action.payload;
                const newState = {
                    roles: state.roles.map((r)=>{
                        r.hidden = !r.name.toLowerCase().includes(text);
                        return r;
                    })
                };
                return {
                    ...state,
                    ...newState,
                    rolesFilter: text
                };
            }
        case 'INFLUXDB_KILL_QUERY':
            {
                const { queryID: queryID } = action.payload;
                const nextState = {
                    queries: (0, (/*@__PURE__*/$parcel$interopDefault($3b1840a410238012$exports)))(state.queries, (q)=>+q.id === +queryID)
                };
                return {
                    ...state,
                    ...nextState
                };
            }
        case 'INFLUXDB_SET_QUERY_TO_KILL':
            return {
                ...state,
                ...action.payload
            };
        case 'INFLUXDB_CHANGE_SELECTED_DBS':
            {
                const newDBs = action.payload.selectedDBs;
                const oldDBs = state.selectedDBs || [
                    '*'
                ];
                const selectedDBs = (0, $7c54fbf649e1f116$export$2e2bcd8739ae039)(oldDBs, newDBs);
                return {
                    ...state,
                    selectedDBs: selectedDBs
                };
            }
        case 'INFLUXDB_CHANGE_SHOW_USERS':
            return {
                ...state,
                showUsers: !state.showUsers
            };
        case 'INFLUXDB_CHANGE_SHOW_ROLES':
            return {
                ...state,
                showRoles: !state.showRoles
            };
    }
    return state;
};
var $eed4757442137a56$export$2e2bcd8739ae039 = $eed4757442137a56$var$adminInfluxDB;


var $040ac1d542af6f2e$export$2e2bcd8739ae039 = {
    adminChronograf: $9ec39e41773425eb$export$2e2bcd8739ae039,
    adminInfluxDB: $eed4757442137a56$export$2e2bcd8739ae039
};







const $a3b88d5d27f00a75$export$c4bb51af054593c4 = [
    {
        text: 'Databases',
        type: (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Databases
    },
    {
        text: 'Measurements',
        type: (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Measurements
    },
    {
        text: 'Field Keys',
        type: (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).FieldKeys
    },
    {
        text: 'Tag Keys',
        type: (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).TagKeys
    },
    {
        text: 'Tag Values',
        type: (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).TagValues
    },
    {
        text: 'CSV',
        type: (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).CSV
    },
    {
        text: 'Map',
        type: (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Map
    },
    {
        text: 'InfluxQL Meta Query',
        type: (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).MetaQuery
    },
    {
        text: 'Flux Query',
        type: (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).FluxQuery
    },
    {
        text: 'Text',
        type: (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Text
    }
];
const $a3b88d5d27f00a75$export$4bad5a14b45b58a2 = {
    [(0, $ae4c87db4f4621dc$export$fd0446c06165ed92).CSV]: (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).CSV,
    [(0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Map]: (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).Map,
    [(0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Databases]: (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).Database,
    [(0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Measurements]: (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).Measurement,
    [(0, $ae4c87db4f4621dc$export$fd0446c06165ed92).FieldKeys]: (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).FieldKey,
    [(0, $ae4c87db4f4621dc$export$fd0446c06165ed92).TagKeys]: (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).TagKey,
    [(0, $ae4c87db4f4621dc$export$fd0446c06165ed92).TagValues]: (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).TagValue,
    [(0, $ae4c87db4f4621dc$export$fd0446c06165ed92).MetaQuery]: (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).MetaQuery,
    [(0, $ae4c87db4f4621dc$export$fd0446c06165ed92).FluxQuery]: (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).FluxQuery,
    [(0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Text]: (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).Constant
};
const $a3b88d5d27f00a75$export$a51451e83419e984 = {
    [(0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Databases]: 'SHOW DATABASES',
    [(0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Measurements]: 'SHOW MEASUREMENTS ON :database:',
    [(0, $ae4c87db4f4621dc$export$fd0446c06165ed92).FieldKeys]: 'SHOW FIELD KEYS ON :database: FROM :measurement:',
    [(0, $ae4c87db4f4621dc$export$fd0446c06165ed92).TagKeys]: 'SHOW TAG KEYS ON :database: FROM :measurement:',
    [(0, $ae4c87db4f4621dc$export$fd0446c06165ed92).TagValues]: 'SHOW TAG VALUES ON :database: FROM :measurement: WITH KEY=:tagKey:'
};
const $a3b88d5d27f00a75$export$d5b92d67f1b42228 = {
    [(0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Databases]: ()=>{
        return {
            id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
            tempVar: '',
            values: [
                {
                    value: '_internal',
                    type: (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).Database,
                    selected: true,
                    localSelected: true
                }
            ],
            type: (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Databases,
            label: '',
            query: {
                influxql: $a3b88d5d27f00a75$export$a51451e83419e984[(0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Databases]
            }
        };
    },
    [(0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Measurements]: ()=>{
        return {
            id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
            tempVar: '',
            values: [],
            type: (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Measurements,
            label: '',
            query: {
                influxql: $a3b88d5d27f00a75$export$a51451e83419e984[(0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Measurements],
                db: ''
            }
        };
    },
    [(0, $ae4c87db4f4621dc$export$fd0446c06165ed92).CSV]: ()=>{
        return {
            id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
            tempVar: '',
            values: [],
            type: (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).CSV,
            label: '',
            query: {}
        };
    },
    [(0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Map]: ()=>{
        return {
            id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
            tempVar: '',
            values: [],
            type: (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Map,
            label: '',
            query: {}
        };
    },
    [(0, $ae4c87db4f4621dc$export$fd0446c06165ed92).TagKeys]: ()=>{
        return {
            id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
            tempVar: '',
            values: [],
            type: (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).TagKeys,
            label: '',
            query: {
                influxql: $a3b88d5d27f00a75$export$a51451e83419e984[(0, $ae4c87db4f4621dc$export$fd0446c06165ed92).TagKeys]
            }
        };
    },
    [(0, $ae4c87db4f4621dc$export$fd0446c06165ed92).FieldKeys]: ()=>{
        return {
            id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
            tempVar: '',
            values: [],
            type: (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).FieldKeys,
            label: '',
            query: {
                influxql: $a3b88d5d27f00a75$export$a51451e83419e984[(0, $ae4c87db4f4621dc$export$fd0446c06165ed92).FieldKeys]
            }
        };
    },
    [(0, $ae4c87db4f4621dc$export$fd0446c06165ed92).TagValues]: ()=>{
        return {
            id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
            tempVar: '',
            values: [],
            type: (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).TagValues,
            label: '',
            query: {
                influxql: $a3b88d5d27f00a75$export$a51451e83419e984[(0, $ae4c87db4f4621dc$export$fd0446c06165ed92).TagValues]
            }
        };
    },
    [(0, $ae4c87db4f4621dc$export$fd0446c06165ed92).MetaQuery]: ()=>{
        return {
            id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
            tempVar: ':my-meta-query:',
            values: [],
            type: (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).MetaQuery,
            label: '',
            query: {
                influxql: ''
            }
        };
    },
    [(0, $ae4c87db4f4621dc$export$fd0446c06165ed92).FluxQuery]: ()=>{
        return {
            id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
            tempVar: ':my-flux-query:',
            values: [],
            type: (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).FluxQuery,
            label: '',
            query: {
                flux: ''
            }
        };
    },
    [(0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Text]: ()=>{
        return {
            id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
            tempVar: ':my-text:',
            values: [
                {
                    type: (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).Constant,
                    value: '',
                    selected: false,
                    localSelected: true
                }
            ],
            type: (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Text,
            label: ''
        };
    }
};
const $a3b88d5d27f00a75$export$c13acb51e10a08e2 = [
    ':dashboardTime:',
    ':upperDashboardTime:',
    ':interval:',
    ':lower:',
    ':upper:',
    ':zoomedLower:',
    ':zoomedUpper:'
];
const $a3b88d5d27f00a75$export$d51ff2a67c01c91d = /:[\w-]*/g;
const $a3b88d5d27f00a75$export$e7629fcc9135ebfc = (query)=>{
    const matchWholeTemplates = /:([\w-]*):/g;
    const maskForWholeTemplates = "\uD83D\uDE38$1\uD83D\uDE38";
    return query.replace(matchWholeTemplates, maskForWholeTemplates);
};
const $a3b88d5d27f00a75$export$2c98bf544dbe1480 = (query, tempVar)=>{
    return query.replace($a3b88d5d27f00a75$export$d51ff2a67c01c91d, tempVar);
};
const $a3b88d5d27f00a75$export$43b143dc77822220 = (query)=>{
    return query.replace(/😸/g, ':');
};
const $a3b88d5d27f00a75$export$e45d50782fac2336 = {
    upper: (0, $e10a8602f56394e3$export$cb0056005b9f8f1c),
    lower: (0, $e10a8602f56394e3$export$24969386fef72130)
};
const $a3b88d5d27f00a75$export$2441527122476343 = {
    RESULTS_TO_DISPLAY: 9,
    LI_HEIGHT: 28,
    LI_MARGIN_BOTTOM: 2,
    OFFSET: 14
};


const $12df0e6a12079fa8$var$defaultQueryConfig = ({ id: id, isKapacitorRule: isKapacitorRule = false } = {
    id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)()
})=>{
    const queryConfig = {
        id: id,
        database: null,
        measurement: null,
        retentionPolicy: null,
        fields: [],
        tags: {},
        groupBy: {
            time: null,
            tags: []
        },
        areTagsAccepted: true,
        rawText: null,
        status: null,
        shifts: [],
        fill: null,
        range: isKapacitorRule ? {
            ...(0, $a3b88d5d27f00a75$export$e45d50782fac2336),
            upper: null
        } : (0, $a3b88d5d27f00a75$export$e45d50782fac2336),
        originalQuery: null
    };
    return isKapacitorRule ? queryConfig : {
        ...queryConfig,
        fill: (0, $f6a5aa1a5f0d59f0$export$b062928682b6d462)
    };
};
var $12df0e6a12079fa8$export$2e2bcd8739ae039 = $12df0e6a12079fa8$var$defaultQueryConfig;



var $hBdgJ = parcelRequire("hBdgJ");


var $hBdgJ = parcelRequire("hBdgJ");
const $58ff0395d03c4a96$export$ddfbd4c1a2cd4384 = (fields, fn, acc = [])=>(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).compact((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).flattenDeep(fields.reduce((a, f)=>{
        return [
            ...a,
            fn(f),
            $58ff0395d03c4a96$export$ddfbd4c1a2cd4384((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(f, 'args', []), fn, acc)
        ];
    }, acc)));
const $58ff0395d03c4a96$export$5db8774c0df95fce = (fields, type)=>(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).filter(fields, (f)=>(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(f, 'type') === type);
const $58ff0395d03c4a96$export$d5523731e7fe4ded = (fields)=>$58ff0395d03c4a96$export$5db8774c0df95fce(fields, 'field');
const $58ff0395d03c4a96$export$7d4c14593b8a2193 = (fields)=>$58ff0395d03c4a96$export$5db8774c0df95fce(fields, 'func');
const $58ff0395d03c4a96$export$a975b3bf1e585936 = (fields)=>(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).size($58ff0395d03c4a96$export$7d4c14593b8a2193(fields));
const $58ff0395d03c4a96$export$4b45735d9afb8e07 = (fields)=>$58ff0395d03c4a96$export$7d4c14593b8a2193(fields).map((f)=>f.value);
const $58ff0395d03c4a96$export$c25afe17b5a8cf4a = (fields)=>(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).uniqBy($58ff0395d03c4a96$export$ddfbd4c1a2cd4384(fields, (f)=>(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(f, 'type') === 'field' ? f : null), 'value');
const $58ff0395d03c4a96$export$705ec32051f2e097 = (fields)=>$58ff0395d03c4a96$export$c25afe17b5a8cf4a(fields).map((f)=>(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(f, 'value'));
const $58ff0395d03c4a96$export$9979c65a04baa695 = (fields)=>(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).head($58ff0395d03c4a96$export$705ec32051f2e097(fields));
const $58ff0395d03c4a96$export$1cc7eda84d0bc82b = (fieldName, fields)=>$58ff0395d03c4a96$export$705ec32051f2e097(fields).some((f)=>f === fieldName);
const $58ff0395d03c4a96$export$779842e6202ca4b2 = (fieldName, fields)=>$58ff0395d03c4a96$export$c25afe17b5a8cf4a(fields).filter((f)=>f.value === fieldName);
const $58ff0395d03c4a96$export$b268e95d6510c035 = (fields, type)=>fields.every((f)=>(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(f, 'type') === type);
const $58ff0395d03c4a96$export$5ef414f6a95ea6c = (fields)=>$58ff0395d03c4a96$export$b268e95d6510c035(fields, 'field');
const $58ff0395d03c4a96$export$796f001e2d325876 = (fields)=>$58ff0395d03c4a96$export$b268e95d6510c035(fields, 'func');
const $58ff0395d03c4a96$export$d33ef81c2d08c189 = (fieldName, fields)=>$58ff0395d03c4a96$export$7d4c14593b8a2193(fields).filter((f)=>(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(f, 'args', []).some((a)=>a.value === fieldName));
const $58ff0395d03c4a96$export$5b44493d733ef013 = (fieldName, fields)=>{
    if ($58ff0395d03c4a96$export$5ef414f6a95ea6c(fields)) return fields.filter((f)=>f.value !== fieldName);
    return fields.reduce((acc, f)=>{
        if ($58ff0395d03c4a96$export$1cc7eda84d0bc82b(fieldName, f.args)) return acc;
        return [
            ...acc,
            f
        ];
    }, []);
};
function $58ff0395d03c4a96$export$3128dedc24eee543(fieldFunc) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(fieldFunc, 'type') === 'field' ? (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(fieldFunc, 'value') : $58ff0395d03c4a96$export$9979c65a04baa695((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(fieldFunc, 'args'));
}


const $87900d7d58ddb432$export$fc4dca2ffe8f730e = (query, rawText)=>{
    return {
        ...query,
        rawText: rawText
    };
};
const $87900d7d58ddb432$export$701baf921074a53d = (query, namespace, isKapacitorRule = false)=>({
        ...(0, $12df0e6a12079fa8$export$2e2bcd8739ae039)({
            id: query.id,
            isKapacitorRule: isKapacitorRule
        }),
        ...namespace
    });
const $87900d7d58ddb432$export$3d55885fc623730f = (query, measurement, isKapacitorRule = false)=>({
        ...(0, $12df0e6a12079fa8$export$2e2bcd8739ae039)({
            id: query.id,
            isKapacitorRule: isKapacitorRule
        }),
        database: query.database,
        retentionPolicy: query.retentionPolicy,
        measurement: measurement
    });
const $87900d7d58ddb432$export$3f5db121dd097368 = (query, field)=>{
    if (field.type === 'field') return {
        ...query,
        fields: [
            field
        ],
        groupBy: {
            ...query.groupBy,
            time: null
        }
    };
    return {
        ...query,
        fields: [
            field
        ]
    };
};
const $87900d7d58ddb432$export$c1c141ca8db4cfc3 = (value)=>({
        type: 'func',
        alias: `mean_${value}`,
        args: [
            {
                value: value,
                type: 'field'
            }
        ],
        value: 'mean'
    });
const $87900d7d58ddb432$export$69b3838738298b5d = (query, field, groupBy)=>{
    return {
        ...query,
        fields: [
            $87900d7d58ddb432$export$c1c141ca8db4cfc3(field.value)
        ],
        groupBy: groupBy
    };
};
const $87900d7d58ddb432$export$7c7a7daa922e15cc = (query, { value: value })=>{
    const { fields: fields = [], groupBy: groupBy } = query;
    const isSelected = (0, $58ff0395d03c4a96$export$1cc7eda84d0bc82b)(value, fields);
    const newFuncs = fields.filter((f)=>f.type === 'func');
    if (isSelected) {
        // if list is all fields, remove that field
        // if list is all funcs, remove all funcs that match
        const newFields = (0, $58ff0395d03c4a96$export$5b44493d733ef013)(value, fields);
        if (!newFields.length) return {
            ...query,
            groupBy: {
                ...groupBy,
                time: null
            },
            fields: []
        };
        return {
            ...query,
            fields: newFields
        };
    }
    // if we are not applying functions apply a field
    if (!newFuncs.length) return {
        ...query,
        fields: [
            ...fields,
            {
                value: value,
                type: 'field'
            }
        ]
    };
    const defaultField = {
        type: 'func',
        alias: `mean_${value}`,
        args: [
            {
                value: value,
                type: 'field'
            }
        ],
        value: 'mean'
    };
    return {
        ...query,
        fields: [
            ...fields,
            defaultField
        ]
    };
};
const $87900d7d58ddb432$export$17dbdfc260d411c0 = (query, time)=>({
        ...query,
        groupBy: {
            ...query.groupBy,
            time: time
        }
    });
const $87900d7d58ddb432$export$9563e054e6f787fb = (query, value)=>({
        ...query,
        fill: value
    });
const $87900d7d58ddb432$export$ba46ef16c986791 = (query)=>({
        ...query,
        areTagsAccepted: !query.areTagsAccepted
    });
const $87900d7d58ddb432$export$6c7ecc4b49686af = (query, fields)=>({
        ...query,
        fields: (0, $58ff0395d03c4a96$export$c25afe17b5a8cf4a)(fields),
        groupBy: {
            ...query.groupBy,
            time: null
        }
    });
const $87900d7d58ddb432$export$62c64e38b267511f = (query, { field: field, funcs: funcs = [] }, groupBy)=>{
    const nextFields = query.fields.reduce((acc, f)=>{
        // If there is a func applied to only one field, add it to the other fields
        if (f.type === 'field') return [
            ...acc,
            funcs.map((func)=>{
                const { value: value, type: type } = func;
                const args = [
                    {
                        value: f.value,
                        type: 'field'
                    }
                ];
                const alias = func.alias ? func.alias : `${func.value}_${f.value}`;
                return {
                    value: value,
                    type: type,
                    args: args,
                    alias: alias
                };
            })
        ];
        const fieldToChange = f.args.find((a)=>a.value === field.value);
        // Apply new funcs to field
        if (fieldToChange) {
            const newFuncs = funcs.reduce((acc2, func)=>{
                const funcsToChange = (0, $58ff0395d03c4a96$export$d33ef81c2d08c189)(fieldToChange.value, acc);
                const dup = funcsToChange.find((a)=>a.value === func.value);
                if (dup) return acc2;
                return [
                    ...acc2,
                    {
                        ...func,
                        args: [
                            field
                        ],
                        alias: `${func.value}_${field.value}`
                    }
                ];
            }, []);
            return [
                ...acc,
                ...newFuncs
            ];
        }
        return [
            ...acc,
            f
        ];
    }, []);
    return {
        ...query,
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).flatten(nextFields),
        groupBy: groupBy
    };
};
const $87900d7d58ddb432$export$91fc2eabe55b24c = (query, rawText)=>({
        ...query,
        rawText: rawText
    });
const $87900d7d58ddb432$export$ca2e14d4de2d2b70 = (query, tagKey)=>{
    const oldTags = query.groupBy.tags;
    let newTags;
    // Toggle the presence of the tagKey
    if (oldTags.includes(tagKey)) {
        const i = oldTags.indexOf(tagKey);
        newTags = oldTags.slice();
        newTags.splice(i, 1);
    } else newTags = oldTags.concat(tagKey);
    return {
        ...query,
        groupBy: {
            ...query.groupBy,
            tags: newTags
        }
    };
};
const $87900d7d58ddb432$export$4480d0807bd82ec1 = (query, tag)=>{
    const tagValues = query.tags[tag.key];
    const shouldRemoveTag = tagValues && tagValues.length === 1 && tagValues[0] === tag.value;
    if (shouldRemoveTag) {
        const newTags = {
            ...query.tags
        };
        delete newTags[tag.key];
        return {
            ...query,
            tags: newTags
        };
    }
    const updateTagValues = (newTagValues)=>{
        return {
            ...query,
            tags: {
                ...query.tags,
                [tag.key]: newTagValues
            }
        };
    };
    const oldTagValues = query.tags[tag.key];
    if (!oldTagValues) return updateTagValues([
        tag.value
    ]);
    // If the tag value is already selected, deselect it by removing it from the list
    const tagValuesCopy = oldTagValues.slice();
    const i = tagValuesCopy.indexOf(tag.value);
    if (i > -1) {
        tagValuesCopy.splice(i, 1);
        return updateTagValues(tagValuesCopy);
    }
    return updateTagValues(query.tags[tag.key].concat(tag.value));
};
const $87900d7d58ddb432$export$2cfa160b16d04366 = (query, shift)=>({
        ...query,
        shifts: [
            shift
        ]
    });


const $eb225ea552222dc6$var$IS_KAPACITOR_RULE = true;
const $eb225ea552222dc6$var$queryConfigs = (state = {}, action)=>{
    switch(action.type){
        case 'KAPA_LOAD_QUERY':
            {
                const { query: query } = action.payload;
                const nextState = Object.assign({}, state, {
                    [query.id]: query
                });
                return nextState;
            }
        case 'KAPA_ADD_QUERY':
            {
                const { queryID: queryID } = action.payload;
                return {
                    ...state,
                    [queryID]: (0, $12df0e6a12079fa8$export$2e2bcd8739ae039)({
                        id: queryID,
                        isKapacitorRule: true
                    })
                };
            }
        case 'KAPA_CHOOSE_NAMESPACE':
            {
                const { queryID: queryID, database: database, retentionPolicy: retentionPolicy } = action.payload;
                const nextQueryConfig = (0, $87900d7d58ddb432$export$701baf921074a53d)(state[queryID], {
                    database: database,
                    retentionPolicy: retentionPolicy
                }, $eb225ea552222dc6$var$IS_KAPACITOR_RULE);
                return Object.assign({}, state, {
                    [queryID]: Object.assign(nextQueryConfig, {
                        rawText: null
                    })
                });
            }
        case 'KAPA_CHOOSE_MEASUREMENT':
            {
                const { queryID: queryID, measurement: measurement } = action.payload;
                const nextQueryConfig = (0, $87900d7d58ddb432$export$3d55885fc623730f)(state[queryID], measurement, $eb225ea552222dc6$var$IS_KAPACITOR_RULE);
                return Object.assign({}, state, {
                    [queryID]: Object.assign(nextQueryConfig, {
                        rawText: state[queryID].rawText
                    })
                });
            }
        case 'KAPA_CHOOSE_TAG':
            {
                const { queryID: queryID, tag: tag } = action.payload;
                const nextQueryConfig = (0, $87900d7d58ddb432$export$4480d0807bd82ec1)(state[queryID], tag);
                return Object.assign({}, state, {
                    [queryID]: nextQueryConfig
                });
            }
        case 'KAPA_GROUP_BY_TAG':
            {
                const { queryID: queryID, tagKey: tagKey } = action.payload;
                const nextQueryConfig = (0, $87900d7d58ddb432$export$ca2e14d4de2d2b70)(state[queryID], tagKey);
                return Object.assign({}, state, {
                    [queryID]: nextQueryConfig
                });
            }
        case 'KAPA_TOGGLE_TAG_ACCEPTANCE':
            {
                const { queryID: queryID } = action.payload;
                const nextQueryConfig = (0, $87900d7d58ddb432$export$ba46ef16c986791)(state[queryID]);
                return Object.assign({}, state, {
                    [queryID]: nextQueryConfig
                });
            }
        case 'KAPA_TOGGLE_FIELD':
            {
                const { queryID: queryID, fieldFunc: fieldFunc } = action.payload;
                const nextQueryConfig = (0, $87900d7d58ddb432$export$3f5db121dd097368)(state[queryID], fieldFunc);
                return {
                    ...state,
                    [queryID]: {
                        ...nextQueryConfig,
                        rawText: null
                    }
                };
            }
        case 'KAPA_APPLY_FUNCS_TO_FIELD':
            {
                const { queryID: queryID, fieldFunc: fieldFunc } = action.payload;
                const { groupBy: groupBy } = state[queryID];
                const nextQueryConfig = (0, $87900d7d58ddb432$export$62c64e38b267511f)(state[queryID], fieldFunc, {
                    ...groupBy,
                    time: groupBy.time ? groupBy.time : '10s'
                });
                return {
                    ...state,
                    [queryID]: nextQueryConfig
                };
            }
        case 'KAPA_GROUP_BY_TIME':
            {
                const { queryID: queryID, time: time } = action.payload;
                const nextQueryConfig = (0, $87900d7d58ddb432$export$17dbdfc260d411c0)(state[queryID], time);
                return Object.assign({}, state, {
                    [queryID]: nextQueryConfig
                });
            }
        case 'KAPA_REMOVE_FUNCS':
            {
                const { queryID: queryID, fields: fields } = action.payload;
                const nextQuery = (0, $87900d7d58ddb432$export$6c7ecc4b49686af)(state[queryID], fields);
                // fields with no functions cannot have a group by time
                return {
                    ...state,
                    [queryID]: nextQuery
                };
            }
        case 'KAPA_TIME_SHIFT':
            {
                const { queryID: queryID, shift: shift } = action.payload;
                const nextQuery = (0, $87900d7d58ddb432$export$2cfa160b16d04366)(state[queryID], shift);
                return {
                    ...state,
                    [queryID]: nextQuery
                };
            }
    }
    return state;
};
var $eb225ea552222dc6$export$2e2bcd8739ae039 = $eb225ea552222dc6$var$queryConfigs;




var $hBdgJ = parcelRequire("hBdgJ");
function $8228ebe60b0e2905$export$2e2bcd8739ae039(state = {}, action) {
    switch(action.type){
        case 'LOAD_DEFAULT_RULE':
            {
                const { queryID: queryID } = action.payload;
                return Object.assign({}, state, {
                    [(0, $2aff9a9dae44a870$export$f20cff0eb3a8b896)]: {
                        id: (0, $2aff9a9dae44a870$export$f20cff0eb3a8b896),
                        queryID: queryID,
                        trigger: 'threshold',
                        values: (0, $2aff9a9dae44a870$export$f57641517de48242).threshold,
                        message: '',
                        alertNodes: {
                            stateChangesOnly: true
                        },
                        every: null,
                        name: 'Untitled Rule'
                    }
                });
            }
        case 'LOAD_RULES':
            {
                const theRules = action.payload.rules;
                const ruleIDs = theRules.map((r)=>r.id);
                return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).zipObject(ruleIDs, theRules);
            }
        case 'LOAD_RULE':
            {
                const { rule: rule } = action.payload;
                return Object.assign({}, state, {
                    [rule.id]: rule
                });
            }
        case 'CHOOSE_TRIGGER':
            {
                const trigger = action.payload.trigger;
                const ruleID = action.payload.ruleID;
                return Object.assign({}, state, {
                    [ruleID]: Object.assign({}, state[ruleID], {
                        trigger: trigger.toLowerCase(),
                        values: (0, $2aff9a9dae44a870$export$f57641517de48242)[trigger.toLowerCase()]
                    })
                });
            }
        case 'ADD_EVERY':
            {
                const { ruleID: ruleID, frequency: frequency } = action.payload;
                return {
                    ...state,
                    [ruleID]: {
                        ...state[ruleID],
                        every: frequency
                    }
                };
            }
        case 'REMOVE_EVERY':
            {
                const { ruleID: ruleID } = action.payload;
                return {
                    ...state,
                    [ruleID]: {
                        ...state[ruleID],
                        every: null
                    }
                };
            }
        case 'UPDATE_RULE_VALUES':
            {
                const { ruleID: ruleID, trigger: trigger, values: values } = action.payload;
                return Object.assign({}, state, {
                    [ruleID]: Object.assign({}, state[ruleID], {
                        trigger: trigger.toLowerCase(),
                        values: values
                    })
                });
            }
        case 'UPDATE_RULE_MESSAGE':
            {
                const { ruleID: ruleID, message: message } = action.payload;
                return Object.assign({}, state, {
                    [ruleID]: Object.assign({}, state[ruleID], {
                        message: message
                    })
                });
            }
        case 'UPDATE_RULE_NORECOVERIES':
            {
                const { ruleID: ruleID, noRecoveries: noRecoveries } = action.payload;
                return Object.assign({}, state, {
                    [ruleID]: Object.assign({}, state[ruleID], {
                        alertNodes: {
                            ...state[ruleID].alertNodes,
                            noRecoveries: noRecoveries
                        }
                    })
                });
            }
        case 'UPDATE_RULE_STATECHANGESONLY':
            {
                const { ruleID: ruleID, stateChangesOnly: stateChangesOnly } = action.payload;
                return Object.assign({}, state, {
                    [ruleID]: Object.assign({}, state[ruleID], {
                        alertNodes: {
                            ...state[ruleID].alertNodes,
                            stateChangesOnly: stateChangesOnly
                        }
                    })
                });
            }
        case 'UPDATE_RULE_ALERT_NODES':
            {
                const { ruleID: ruleID, alerts: alerts } = action.payload;
                const alertNodesByType = {
                    noRecoveries: state[ruleID].alertNodes.noRecoveries,
                    stateChangesOnly: state[ruleID].alertNodes.stateChangesOnly
                };
                (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).forEach(alerts, (h)=>{
                    if (h.enabled) {
                        if (h.type === 'post') {
                            if (h.url === '') return;
                            h.headers = {
                                [h.headerKey]: h.headerValue
                            };
                        }
                        if (h.type === 'log' && h.filePath === '') return;
                        if (h.type === 'tcp' && h.address === '') return;
                        if (h.type === 'exec' && h.command.length === 0) return;
                        const existing = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(alertNodesByType, h.type, []);
                        alertNodesByType[h.type] = [
                            ...existing,
                            (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).pick(h, (0, $2aff9a9dae44a870$export$2def0f8fba1bcd69)[h.type])
                        ];
                    }
                });
                return Object.assign({}, state, {
                    [ruleID]: Object.assign({}, state[ruleID], {
                        alertNodes: alertNodesByType
                    })
                });
            }
        case 'UPDATE_RULE_NAME':
            {
                const { ruleID: ruleID, name: name } = action.payload;
                return Object.assign({}, state, {
                    [ruleID]: Object.assign({}, state[ruleID], {
                        name: name
                    })
                });
            }
        case 'DELETE_RULE_SUCCESS':
            {
                const { ruleID: ruleID } = action.payload;
                delete state[ruleID];
                return Object.assign({}, state);
            }
        case 'UPDATE_RULE_DETAILS':
            {
                const { ruleID: ruleID, details: details } = action.payload;
                return {
                    ...state,
                    [ruleID]: {
                        ...state[ruleID],
                        details: details
                    }
                };
            }
        case 'UPDATE_RULE_STATUS_SUCCESS':
            {
                const { ruleID: ruleID, status: status } = action.payload;
                return {
                    ...state,
                    [ruleID]: {
                        ...state[ruleID],
                        status: status
                    }
                };
            }
    }
    return state;
}


function $6b9c2bba4f8d74a8$export$2e2bcd8739ae039(state = [], action) {
    switch(action.type){
        case 'LOAD_FLUX_TASKS':
            return action.payload.tasks;
        case 'UPDATE_FLUX_TASK_STATUS_SUCCESS':
            {
                const { task: task, status: status } = action.payload;
                return state.map((t)=>{
                    if (task.id === t.id) return {
                        ...task,
                        status: status
                    };
                    return t;
                });
            }
        case 'DELETE_FLUX_TASK_SUCCESS':
            {
                const { taskId: taskId } = action.payload;
                return state.filter((t)=>t.id !== taskId);
            }
    }
    return state;
}


var $fb3cce5ac9be00b4$export$2e2bcd8739ae039 = {
    kapacitorQueryConfigs: $eb225ea552222dc6$export$2e2bcd8739ae039,
    rules: $8228ebe60b0e2905$export$2e2bcd8739ae039,
    fluxTasks: $6b9c2bba4f8d74a8$export$2e2bcd8739ae039
};



var $hBdgJ = parcelRequire("hBdgJ");




var $hBdgJ = parcelRequire("hBdgJ");

var $1l8zS = parcelRequire("1l8zS");


const $a7c7af802fab926a$export$b430c2bd97f9d15b = {
    links: [],
    active: null
};
const $a7c7af802fab926a$export$8b84f64b92190876 = (dashboards, source)=>{
    const links = dashboards.map((d)=>{
        return {
            key: String(d.id),
            text: d.name,
            to: `/sources/${source.id}/dashboards/${d.id}`
        };
    });
    return {
        links: links,
        active: null
    };
};
const $a7c7af802fab926a$export$9d5bee8a7028c508 = (dashboardLinks, activeDashboard)=>{
    const { active: active } = dashboardLinks;
    if (!activeDashboard) return {
        ...dashboardLinks,
        active: null
    };
    if (!active || active.key !== String(activeDashboard.id)) return $a7c7af802fab926a$var$updateActiveDashboardLink(dashboardLinks, activeDashboard);
    return $a7c7af802fab926a$var$updateActiveDashboardLinkName(dashboardLinks, activeDashboard);
};
const $a7c7af802fab926a$var$updateActiveDashboardLink = (dashboardLinks, dashboard)=>{
    const active = dashboardLinks.links.find((link)=>link.key === String(dashboard.id));
    return {
        ...dashboardLinks,
        active: active
    };
};
const $a7c7af802fab926a$var$updateActiveDashboardLinkName = (dashboardLinks, dashboard)=>{
    const { name: name } = dashboard;
    let { active: active } = dashboardLinks;
    const links = dashboardLinks.links.map((link)=>{
        if (link.key === String(dashboard.id)) {
            active = {
                ...link,
                text: name
            };
            return active;
        }
        return link;
    });
    return {
        links: links,
        active: active
    };
};



// APIs



function $b90fabf231bb35b3$export$2e2bcd8739ae039(response) {
    const errors = [];
    const fieldSets = {};
    response.results.forEach((result)=>{
        if (result.error) {
            errors.push(result.error);
            return;
        }
        if (!result.series) return;
        const series = result.series[0];
        const fieldKeyIndex = series.columns.indexOf('fieldKey');
        const fields = series.values.map((value)=>{
            return value[fieldKeyIndex];
        });
        const measurement = series.name;
        fieldSets[measurement] = fields;
    });
    return {
        errors: errors,
        fieldSets: fieldSets
    };
}


function $6d45437803cb8b2c$export$2e2bcd8739ae039(response) {
    const results = response.results[0];
    if (results.error) return {
        errors: [
            results.error
        ],
        tagKeys: []
    };
    if (!results.series) return {
        errors: [],
        tagKeys: []
    };
    const series = results.series[0];
    if (!series.values) return {
        errors: [],
        tagKeys: []
    };
    const tagKeys = series.values.map((v)=>{
        return v[0];
    });
    return {
        errors: [],
        tagKeys: tagKeys
    };
}



var $hBdgJ = parcelRequire("hBdgJ");
function $e693016ff8180917$export$2e2bcd8739ae039(response) {
    // Currently only supports SHOW TAG VALUES responses that explicitly specify a measurement,
    // Ceaning we can safely work with just the first result from the response.
    const result = response.results[0];
    if (result.error) return {
        errors: [],
        tags: []
    };
    const tags = {};
    (result.series || []).forEach(({ columns: columns, values: values })=>{
        values.forEach((v)=>{
            const tagKey = v[columns.indexOf('key')];
            const tagValue = v[columns.indexOf('value')];
            if (!tags[tagKey]) tags[tagKey] = [];
            tags[tagKey].push(tagValue);
        });
    });
    // uniqueness of tag values are no longer guaranteed see showTagValueSpec for example
    (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).each(tags, (v, k)=>{
        tags[k] = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).uniq(v).sort();
    });
    return {
        errors: [],
        tags: tags
    };
}


function $4672176ee5bc174b$export$2e2bcd8739ae039(response) {
    const errors = [];
    const measurementSets = [];
    response.results.forEach((result, index)=>{
        if (result.error) {
            errors.push({
                index: index,
                error: result.error
            });
            return;
        }
        if (!result.series) {
            measurementSets.push({
                index: index,
                measurements: []
            });
            return;
        }
        const series = result.series[0];
        const measurementNameIndex = series.columns.indexOf('name');
        const measurements = series.values.map((value)=>value[measurementNameIndex]);
        measurementSets.push({
            index: index,
            measurements: measurements
        });
    });
    return {
        errors: errors,
        measurementSets: measurementSets
    };
}



const $c3eb3b8468824b3d$var$parseShowSeries = (response)=>{
    const results = response.results[0];
    if (results.error) return {
        errors: [
            results.error
        ],
        series: []
    };
    const seriesValues = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(results, 'series.0.values', []);
    if (!seriesValues.length) return {
        errors: [],
        series: []
    };
    const series = seriesValues.map((s)=>s[0]);
    return {
        series: series,
        errors: []
    };
};
var $c3eb3b8468824b3d$export$2e2bcd8739ae039 = $c3eb3b8468824b3d$var$parseShowSeries;


const $82bb95c5c6d74105$export$952c8ad1655ff67d = (metaQuery, response)=>{
    const metaQueryStart = $82bb95c5c6d74105$var$getMetaQueryPrefix(metaQuery);
    if (!metaQueryStart) throw new Error('Could not find parser for meta query');
    const parser = $82bb95c5c6d74105$var$PARSERS[metaQueryStart];
    const extractor = $82bb95c5c6d74105$var$EXTRACTORS[metaQueryStart];
    const parsed = parser(response);
    if (parsed.errors.length) throw new Error(parsed.errors);
    return extractor(parsed);
};
const $82bb95c5c6d74105$export$bc278986e5723948 = (metaQuery)=>!$82bb95c5c6d74105$var$getMetaQueryPrefix(metaQuery);
const $82bb95c5c6d74105$var$getMetaQueryPrefix = (metaQuery)=>{
    const words = metaQuery.trim().toUpperCase().split(' ');
    const firstTwoWords = words.slice(0, 2).join(' ');
    const firstThreeWords = words.slice(0, 3).join(' ');
    return $82bb95c5c6d74105$var$VALID_META_QUERY_PREFIXES.find((q)=>q === firstTwoWords || q === firstThreeWords);
};
const $82bb95c5c6d74105$var$VALID_META_QUERY_PREFIXES = [
    'SHOW DATABASES',
    'SHOW MEASUREMENTS',
    'SHOW SERIES',
    'SHOW TAG VALUES',
    'SHOW FIELD KEYS',
    'SHOW TAG KEYS'
];
const $82bb95c5c6d74105$var$PARSERS = {
    'SHOW DATABASES': (0, $b0c8a009bdea2e59$export$2e2bcd8739ae039),
    'SHOW FIELD KEYS': (0, $b90fabf231bb35b3$export$2e2bcd8739ae039),
    'SHOW MEASUREMENTS': (0, $4672176ee5bc174b$export$2e2bcd8739ae039),
    'SHOW SERIES': (0, $c3eb3b8468824b3d$export$2e2bcd8739ae039),
    'SHOW TAG VALUES': (0, $e693016ff8180917$export$2e2bcd8739ae039),
    'SHOW TAG KEYS': (0, $6d45437803cb8b2c$export$2e2bcd8739ae039)
};
const $82bb95c5c6d74105$var$EXTRACTORS = {
    'SHOW DATABASES': (parsed)=>parsed.databases,
    'SHOW FIELD KEYS': (parsed)=>{
        const { fieldSets: fieldSets } = parsed;
        const fieldSetsValues = Object.values(fieldSets);
        return fieldSetsValues.reduce((acc, current)=>[
                ...acc,
                ...current
            ], []);
    },
    'SHOW MEASUREMENTS': (parsed)=>{
        const { measurementSets: measurementSets } = parsed;
        return measurementSets.reduce((acc, current)=>[
                ...acc,
                ...current.measurements
            ], []);
    },
    'SHOW TAG KEYS': (parsed)=>parsed.tagKeys,
    'SHOW TAG VALUES': (parsed)=>{
        const { tags: tags } = parsed;
        const tagsValues = Object.values(tags);
        return tagsValues.reduce((acc, current)=>[
                ...acc,
                ...current
            ], []);
    },
    'SHOW SERIES': (parsed)=>parsed.series
};




var $hBdgJ = parcelRequire("hBdgJ");
var $22ab81005d9b2ccc$exports = {};
/* @license
Papa Parse
v5.3.2
https://github.com/mholt/PapaParse
License: MIT
*/ !function(e, t) {
    "function" == typeof define && define.amd ? define([], t) : $22ab81005d9b2ccc$exports = t();
}($22ab81005d9b2ccc$exports, function s() {
    "use strict";
    var f = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== f ? f : {};
    var n = !f.document && !!f.postMessage, o = n && /blob:/i.test((f.location || {}).protocol), a = {}, h = 0, b = {
        parse: function(e, t) {
            var i = (t = t || {}).dynamicTyping || !1;
            M(i) && (t.dynamicTypingFunction = i, i = {});
            if (t.dynamicTyping = i, t.transform = !!M(t.transform) && t.transform, t.worker && b.WORKERS_SUPPORTED) {
                var r = function() {
                    if (!b.WORKERS_SUPPORTED) return !1;
                    var e = (i = f.URL || f.webkitURL || null, r = s.toString(), b.BLOB_URL || (b.BLOB_URL = i.createObjectURL(new Blob([
                        "(",
                        r,
                        ")();"
                    ], {
                        type: "text/javascript"
                    })))), t = new f.Worker(e);
                    var i, r;
                    return t.onmessage = _, t.id = h++, a[t.id] = t;
                }();
                return r.userStep = t.step, r.userChunk = t.chunk, r.userComplete = t.complete, r.userError = t.error, t.step = M(t.step), t.chunk = M(t.chunk), t.complete = M(t.complete), t.error = M(t.error), delete t.worker, void r.postMessage({
                    input: e,
                    config: t,
                    workerId: r.id
                });
            }
            var n = null;
            b.NODE_STREAM_INPUT, "string" == typeof e ? n = t.download ? new l(t) : new p(t) : !0 === e.readable && M(e.read) && M(e.on) ? n = new g(t) : (f.File && e instanceof File || e instanceof Object) && (n = new c(t));
            return n.stream(e);
        },
        unparse: function(e, t) {
            var n = !1, _ = !0, m = ",", y = "\r\n", s = '"', a = s + s, i = !1, r = null, o = !1;
            !function() {
                if ("object" != typeof t) return;
                "string" != typeof t.delimiter || b.BAD_DELIMITERS.filter(function(e) {
                    return -1 !== t.delimiter.indexOf(e);
                }).length || (m = t.delimiter);
                ("boolean" == typeof t.quotes || "function" == typeof t.quotes || Array.isArray(t.quotes)) && (n = t.quotes);
                "boolean" != typeof t.skipEmptyLines && "string" != typeof t.skipEmptyLines || (i = t.skipEmptyLines);
                "string" == typeof t.newline && (y = t.newline);
                "string" == typeof t.quoteChar && (s = t.quoteChar);
                "boolean" == typeof t.header && (_ = t.header);
                if (Array.isArray(t.columns)) {
                    if (0 === t.columns.length) throw new Error("Option columns is empty");
                    r = t.columns;
                }
                void 0 !== t.escapeChar && (a = t.escapeChar + s);
                ("boolean" == typeof t.escapeFormulae || t.escapeFormulae instanceof RegExp) && (o = t.escapeFormulae instanceof RegExp ? t.escapeFormulae : /^[=+\-@\t\r].*$/);
            }();
            var h = new RegExp(j(s), "g");
            "string" == typeof e && (e = JSON.parse(e));
            if (Array.isArray(e)) {
                if (!e.length || Array.isArray(e[0])) return u(null, e, i);
                if ("object" == typeof e[0]) return u(r || Object.keys(e[0]), e, i);
            } else if ("object" == typeof e) return "string" == typeof e.data && (e.data = JSON.parse(e.data)), Array.isArray(e.data) && (e.fields || (e.fields = e.meta && e.meta.fields || r), e.fields || (e.fields = Array.isArray(e.data[0]) ? e.fields : "object" == typeof e.data[0] ? Object.keys(e.data[0]) : []), Array.isArray(e.data[0]) || "object" == typeof e.data[0] || (e.data = [
                e.data
            ])), u(e.fields || [], e.data || [], i);
            throw new Error("Unable to serialize unrecognized input");
            function u(e, t, i) {
                var r = "";
                "string" == typeof e && (e = JSON.parse(e)), "string" == typeof t && (t = JSON.parse(t));
                var n = Array.isArray(e) && 0 < e.length, s = !Array.isArray(t[0]);
                if (n && _) {
                    for(var a = 0; a < e.length; a++)0 < a && (r += m), r += v(e[a], a);
                    0 < t.length && (r += y);
                }
                for(var o = 0; o < t.length; o++){
                    var h = n ? e.length : t[o].length, u = !1, f = n ? 0 === Object.keys(t[o]).length : 0 === t[o].length;
                    if (i && !n && (u = "greedy" === i ? "" === t[o].join("").trim() : 1 === t[o].length && 0 === t[o][0].length), "greedy" === i && n) {
                        for(var d = [], l = 0; l < h; l++){
                            var c = s ? e[l] : l;
                            d.push(t[o][c]);
                        }
                        u = "" === d.join("").trim();
                    }
                    if (!u) {
                        for(var p = 0; p < h; p++){
                            0 < p && !f && (r += m);
                            var g = n && s ? e[p] : p;
                            r += v(t[o][g], p);
                        }
                        o < t.length - 1 && (!i || 0 < h && !f) && (r += y);
                    }
                }
                return r;
            }
            function v(e, t) {
                if (null == e) return "";
                if (e.constructor === Date) return JSON.stringify(e).slice(1, 25);
                var i = !1;
                o && "string" == typeof e && o.test(e) && (e = "'" + e, i = !0);
                var r = e.toString().replace(h, a);
                return (i = i || !0 === n || "function" == typeof n && n(e, t) || Array.isArray(n) && n[t] || function(e, t) {
                    for(var i = 0; i < t.length; i++)if (-1 < e.indexOf(t[i])) return !0;
                    return !1;
                }(r, b.BAD_DELIMITERS) || -1 < r.indexOf(m) || " " === r.charAt(0) || " " === r.charAt(r.length - 1)) ? s + r + s : r;
            }
        }
    };
    if (b.RECORD_SEP = String.fromCharCode(30), b.UNIT_SEP = String.fromCharCode(31), b.BYTE_ORDER_MARK = "\ufeff", b.BAD_DELIMITERS = [
        "\r",
        "\n",
        '"',
        b.BYTE_ORDER_MARK
    ], b.WORKERS_SUPPORTED = !n && !!f.Worker, b.NODE_STREAM_INPUT = 1, b.LocalChunkSize = 10485760, b.RemoteChunkSize = 5242880, b.DefaultDelimiter = ",", b.Parser = E, b.ParserHandle = i, b.NetworkStreamer = l, b.FileStreamer = c, b.StringStreamer = p, b.ReadableStreamStreamer = g, f.jQuery) {
        var d = f.jQuery;
        d.fn.parse = function(o) {
            var i = o.config || {}, h = [];
            return this.each(function(e) {
                if (!("INPUT" === d(this).prop("tagName").toUpperCase() && "file" === d(this).attr("type").toLowerCase() && f.FileReader) || !this.files || 0 === this.files.length) return !0;
                for(var t = 0; t < this.files.length; t++)h.push({
                    file: this.files[t],
                    inputElem: this,
                    instanceConfig: d.extend({}, i)
                });
            }), e(), this;
            function e() {
                if (0 !== h.length) {
                    var e, t, i, r, n = h[0];
                    if (M(o.before)) {
                        var s = o.before(n.file, n.inputElem);
                        if ("object" == typeof s) {
                            if ("abort" === s.action) return e = "AbortError", t = n.file, i = n.inputElem, r = s.reason, void (M(o.error) && o.error({
                                name: e
                            }, t, i, r));
                            if ("skip" === s.action) return void u();
                            "object" == typeof s.config && (n.instanceConfig = d.extend(n.instanceConfig, s.config));
                        } else if ("skip" === s) return void u();
                    }
                    var a = n.instanceConfig.complete;
                    n.instanceConfig.complete = function(e) {
                        M(a) && a(e, n.file, n.inputElem), u();
                    }, b.parse(n.file, n.instanceConfig);
                } else M(o.complete) && o.complete();
            }
            function u() {
                h.splice(0, 1), e();
            }
        };
    }
    function u(e) {
        this._handle = null, this._finished = !1, this._completed = !1, this._halted = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = {
            data: [],
            errors: [],
            meta: {}
        }, (function(e) {
            var t = w(e);
            t.chunkSize = parseInt(t.chunkSize), e.step || e.chunk || (t.chunkSize = null);
            this._handle = new i(t), (this._handle.streamer = this)._config = t;
        }).call(this, e), this.parseChunk = function(e, t) {
            if (this.isFirstChunk && M(this._config.beforeFirstChunk)) {
                var i = this._config.beforeFirstChunk(e);
                void 0 !== i && (e = i);
            }
            this.isFirstChunk = !1, this._halted = !1;
            var r = this._partialLine + e;
            this._partialLine = "";
            var n = this._handle.parse(r, this._baseIndex, !this._finished);
            if (!this._handle.paused() && !this._handle.aborted()) {
                var s = n.meta.cursor;
                this._finished || (this._partialLine = r.substring(s - this._baseIndex), this._baseIndex = s), n && n.data && (this._rowCount += n.data.length);
                var a = this._finished || this._config.preview && this._rowCount >= this._config.preview;
                if (o) f.postMessage({
                    results: n,
                    workerId: b.WORKER_ID,
                    finished: a
                });
                else if (M(this._config.chunk) && !t) {
                    if (this._config.chunk(n, this._handle), this._handle.paused() || this._handle.aborted()) return void (this._halted = !0);
                    n = void 0, this._completeResults = void 0;
                }
                return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(n.data), this._completeResults.errors = this._completeResults.errors.concat(n.errors), this._completeResults.meta = n.meta), this._completed || !a || !M(this._config.complete) || n && n.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), a || n && n.meta.paused || this._nextChunk(), n;
            }
            this._halted = !0;
        }, this._sendError = function(e) {
            M(this._config.error) ? this._config.error(e) : o && this._config.error && f.postMessage({
                workerId: b.WORKER_ID,
                error: e,
                finished: !1
            });
        };
    }
    function l(e) {
        var r;
        (e = e || {}).chunkSize || (e.chunkSize = b.RemoteChunkSize), u.call(this, e), this._nextChunk = n ? function() {
            this._readChunk(), this._chunkLoaded();
        } : function() {
            this._readChunk();
        }, this.stream = function(e) {
            this._input = e, this._nextChunk();
        }, this._readChunk = function() {
            if (this._finished) this._chunkLoaded();
            else {
                if (r = new XMLHttpRequest, this._config.withCredentials && (r.withCredentials = this._config.withCredentials), n || (r.onload = v(this._chunkLoaded, this), r.onerror = v(this._chunkError, this)), r.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !n), this._config.downloadRequestHeaders) {
                    var e = this._config.downloadRequestHeaders;
                    for(var t in e)r.setRequestHeader(t, e[t]);
                }
                if (this._config.chunkSize) {
                    var i = this._start + this._config.chunkSize - 1;
                    r.setRequestHeader("Range", "bytes=" + this._start + "-" + i);
                }
                try {
                    r.send(this._config.downloadRequestBody);
                } catch (e) {
                    this._chunkError(e.message);
                }
                n && 0 === r.status && this._chunkError();
            }
        }, this._chunkLoaded = function() {
            4 === r.readyState && (r.status < 200 || 400 <= r.status ? this._chunkError() : (this._start += this._config.chunkSize ? this._config.chunkSize : r.responseText.length, this._finished = !this._config.chunkSize || this._start >= function(e) {
                var t = e.getResponseHeader("Content-Range");
                if (null === t) return -1;
                return parseInt(t.substring(t.lastIndexOf("/") + 1));
            }(r), this.parseChunk(r.responseText)));
        }, this._chunkError = function(e) {
            var t = r.statusText || e;
            this._sendError(new Error(t));
        };
    }
    function c(e) {
        var r, n;
        (e = e || {}).chunkSize || (e.chunkSize = b.LocalChunkSize), u.call(this, e);
        var s = "undefined" != typeof FileReader;
        this.stream = function(e) {
            this._input = e, n = e.slice || e.webkitSlice || e.mozSlice, s ? ((r = new FileReader).onload = v(this._chunkLoaded, this), r.onerror = v(this._chunkError, this)) : r = new FileReaderSync, this._nextChunk();
        }, this._nextChunk = function() {
            this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
        }, this._readChunk = function() {
            var e = this._input;
            if (this._config.chunkSize) {
                var t = Math.min(this._start + this._config.chunkSize, this._input.size);
                e = n.call(e, this._start, t);
            }
            var i = r.readAsText(e, this._config.encoding);
            s || this._chunkLoaded({
                target: {
                    result: i
                }
            });
        }, this._chunkLoaded = function(e) {
            this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(e.target.result);
        }, this._chunkError = function() {
            this._sendError(r.error);
        };
    }
    function p(e) {
        var i;
        u.call(this, e = e || {}), this.stream = function(e) {
            return i = e, this._nextChunk();
        }, this._nextChunk = function() {
            if (!this._finished) {
                var e, t = this._config.chunkSize;
                return t ? (e = i.substring(0, t), i = i.substring(t)) : (e = i, i = ""), this._finished = !i, this.parseChunk(e);
            }
        };
    }
    function g(e) {
        u.call(this, e = e || {});
        var t = [], i = !0, r = !1;
        this.pause = function() {
            u.prototype.pause.apply(this, arguments), this._input.pause();
        }, this.resume = function() {
            u.prototype.resume.apply(this, arguments), this._input.resume();
        }, this.stream = function(e) {
            this._input = e, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
        }, this._checkIsFinished = function() {
            r && 1 === t.length && (this._finished = !0);
        }, this._nextChunk = function() {
            this._checkIsFinished(), t.length ? this.parseChunk(t.shift()) : i = !0;
        }, this._streamData = v(function(e) {
            try {
                t.push("string" == typeof e ? e : e.toString(this._config.encoding)), i && (i = !1, this._checkIsFinished(), this.parseChunk(t.shift()));
            } catch (e) {
                this._streamError(e);
            }
        }, this), this._streamError = v(function(e) {
            this._streamCleanUp(), this._sendError(e);
        }, this), this._streamEnd = v(function() {
            this._streamCleanUp(), r = !0, this._streamData("");
        }, this), this._streamCleanUp = v(function() {
            this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
        }, this);
    }
    function i(m) {
        var a, o, h, r = Math.pow(2, 53), n = -r, s = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/, u = /^(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))$/, t = this, i = 0, f = 0, d = !1, e = !1, l = [], c = {
            data: [],
            errors: [],
            meta: {}
        };
        if (M(m.step)) {
            var p = m.step;
            m.step = function(e) {
                if (c = e, _()) g();
                else {
                    if (g(), 0 === c.data.length) return;
                    i += e.data.length, m.preview && i > m.preview ? o.abort() : (c.data = c.data[0], p(c, t));
                }
            };
        }
        function y(e) {
            return "greedy" === m.skipEmptyLines ? "" === e.join("").trim() : 1 === e.length && 0 === e[0].length;
        }
        function g() {
            return c && h && (k("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + b.DefaultDelimiter + "'"), h = !1), m.skipEmptyLines && (c.data = c.data.filter(function(e) {
                return !y(e);
            })), _() && function() {
                if (!c) return;
                function e(e, t) {
                    M(m.transformHeader) && (e = m.transformHeader(e, t)), l.push(e);
                }
                if (Array.isArray(c.data[0])) {
                    for(var t = 0; _() && t < c.data.length; t++)c.data[t].forEach(e);
                    c.data.splice(0, 1);
                } else c.data.forEach(e);
            }(), function() {
                if (!c || !m.header && !m.dynamicTyping && !m.transform) return c;
                function e(e, t) {
                    var i, r = m.header ? {} : [];
                    for(i = 0; i < e.length; i++){
                        var n = i, s = e[i];
                        m.header && (n = i >= l.length ? "__parsed_extra" : l[i]), m.transform && (s = m.transform(s, n)), s = v(n, s), "__parsed_extra" === n ? (r[n] = r[n] || [], r[n].push(s)) : r[n] = s;
                    }
                    return m.header && (i > l.length ? k("FieldMismatch", "TooManyFields", "Too many fields: expected " + l.length + " fields but parsed " + i, f + t) : i < l.length && k("FieldMismatch", "TooFewFields", "Too few fields: expected " + l.length + " fields but parsed " + i, f + t)), r;
                }
                var t = 1;
                !c.data.length || Array.isArray(c.data[0]) ? (c.data = c.data.map(e), t = c.data.length) : c.data = e(c.data, 0);
                m.header && c.meta && (c.meta.fields = l);
                return f += t, c;
            }();
        }
        function _() {
            return m.header && 0 === l.length;
        }
        function v(e, t) {
            var i;
            return i = e, m.dynamicTypingFunction && void 0 === m.dynamicTyping[i] && (m.dynamicTyping[i] = m.dynamicTypingFunction(i)), !0 === (m.dynamicTyping[i] || m.dynamicTyping) ? "true" === t || "TRUE" === t || "false" !== t && "FALSE" !== t && (function(e) {
                if (s.test(e)) {
                    var t = parseFloat(e);
                    if (n < t && t < r) return !0;
                }
                return !1;
            }(t) ? parseFloat(t) : u.test(t) ? new Date(t) : "" === t ? null : t) : t;
        }
        function k(e, t, i, r) {
            var n = {
                type: e,
                code: t,
                message: i
            };
            void 0 !== r && (n.row = r), c.errors.push(n);
        }
        this.parse = function(e, t, i) {
            var r = m.quoteChar || '"';
            if (m.newline || (m.newline = function(e, t) {
                e = e.substring(0, 1048576);
                var i = new RegExp(j(t) + "([^]*?)" + j(t), "gm"), r = (e = e.replace(i, "")).split("\r"), n = e.split("\n"), s = 1 < n.length && n[0].length < r[0].length;
                if (1 === r.length || s) return "\n";
                for(var a = 0, o = 0; o < r.length; o++)"\n" === r[o][0] && a++;
                return a >= r.length / 2 ? "\r\n" : "\r";
            }(e, r)), h = !1, m.delimiter) M(m.delimiter) && (m.delimiter = m.delimiter(e), c.meta.delimiter = m.delimiter);
            else {
                var n = function(e, t, i, r, n) {
                    var s, a, o, h;
                    n = n || [
                        ",",
                        "\t",
                        "|",
                        ";",
                        b.RECORD_SEP,
                        b.UNIT_SEP
                    ];
                    for(var u = 0; u < n.length; u++){
                        var f = n[u], d = 0, l = 0, c = 0;
                        o = void 0;
                        for(var p = new E({
                            comments: r,
                            delimiter: f,
                            newline: t,
                            preview: 10
                        }).parse(e), g = 0; g < p.data.length; g++)if (i && y(p.data[g])) c++;
                        else {
                            var _ = p.data[g].length;
                            l += _, void 0 !== o ? 0 < _ && (d += Math.abs(_ - o), o = _) : o = _;
                        }
                        0 < p.data.length && (l /= p.data.length - c), (void 0 === a || d <= a) && (void 0 === h || h < l) && 1.99 < l && (a = d, s = f, h = l);
                    }
                    return {
                        successful: !!(m.delimiter = s),
                        bestDelimiter: s
                    };
                }(e, m.newline, m.skipEmptyLines, m.comments, m.delimitersToGuess);
                n.successful ? m.delimiter = n.bestDelimiter : (h = !0, m.delimiter = b.DefaultDelimiter), c.meta.delimiter = m.delimiter;
            }
            var s = w(m);
            return m.preview && m.header && s.preview++, a = e, o = new E(s), c = o.parse(a, t, i), g(), d ? {
                meta: {
                    paused: !0
                }
            } : c || {
                meta: {
                    paused: !1
                }
            };
        }, this.paused = function() {
            return d;
        }, this.pause = function() {
            d = !0, o.abort(), a = M(m.chunk) ? "" : a.substring(o.getCharIndex());
        }, this.resume = function() {
            t.streamer._halted ? (d = !1, t.streamer.parseChunk(a, !0)) : setTimeout(t.resume, 3);
        }, this.aborted = function() {
            return e;
        }, this.abort = function() {
            e = !0, o.abort(), c.meta.aborted = !0, M(m.complete) && m.complete(c), a = "";
        };
    }
    function j(e) {
        return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
    function E(e) {
        var S, O = (e = e || {}).delimiter, x = e.newline, I = e.comments, T = e.step, D = e.preview, A = e.fastMode, L = S = void 0 === e.quoteChar || null === e.quoteChar ? '"' : e.quoteChar;
        if (void 0 !== e.escapeChar && (L = e.escapeChar), ("string" != typeof O || -1 < b.BAD_DELIMITERS.indexOf(O)) && (O = ","), I === O) throw new Error("Comment character same as delimiter");
        !0 === I ? I = "#" : ("string" != typeof I || -1 < b.BAD_DELIMITERS.indexOf(I)) && (I = !1), "\n" !== x && "\r" !== x && "\r\n" !== x && (x = "\n");
        var F = 0, z = !1;
        this.parse = function(r, t, i) {
            if ("string" != typeof r) throw new Error("Input must be a string");
            var n = r.length, e = O.length, s = x.length, a = I.length, o = M(T), h = [], u = [], f = [], d = F = 0;
            if (!r) return C();
            if (A || !1 !== A && -1 === r.indexOf(S)) {
                for(var l = r.split(x), c = 0; c < l.length; c++){
                    if (f = l[c], F += f.length, c !== l.length - 1) F += x.length;
                    else if (i) return C();
                    if (!I || f.substring(0, a) !== I) {
                        if (o) {
                            if (h = [], k(f.split(O)), R(), z) return C();
                        } else k(f.split(O));
                        if (D && D <= c) return h = h.slice(0, D), C(!0);
                    }
                }
                return C();
            }
            for(var p = r.indexOf(O, F), g = r.indexOf(x, F), _ = new RegExp(j(L) + j(S), "g"), m = r.indexOf(S, F);;)if (r[F] !== S) {
                if (I && 0 === f.length && r.substring(F, F + a) === I) {
                    if (-1 === g) return C();
                    F = g + s, g = r.indexOf(x, F), p = r.indexOf(O, F);
                } else if (-1 !== p && (p < g || -1 === g)) f.push(r.substring(F, p)), F = p + e, p = r.indexOf(O, F);
                else {
                    if (-1 === g) break;
                    if (f.push(r.substring(F, g)), w(g + s), o && (R(), z)) return C();
                    if (D && h.length >= D) return C(!0);
                }
            } else for(m = F, F++;;){
                if (-1 === (m = r.indexOf(S, m + 1))) return i || u.push({
                    type: "Quotes",
                    code: "MissingQuotes",
                    message: "Quoted field unterminated",
                    row: h.length,
                    index: F
                }), E();
                if (m === n - 1) return E(r.substring(F, m).replace(_, S));
                if (S !== L || r[m + 1] !== L) {
                    if (S === L || 0 === m || r[m - 1] !== L) {
                        -1 !== p && p < m + 1 && (p = r.indexOf(O, m + 1)), -1 !== g && g < m + 1 && (g = r.indexOf(x, m + 1));
                        var y = b(-1 === g ? p : Math.min(p, g));
                        if (r.substr(m + 1 + y, e) === O) {
                            f.push(r.substring(F, m).replace(_, S)), r[F = m + 1 + y + e] !== S && (m = r.indexOf(S, F)), p = r.indexOf(O, F), g = r.indexOf(x, F);
                            break;
                        }
                        var v = b(g);
                        if (r.substring(m + 1 + v, m + 1 + v + s) === x) {
                            if (f.push(r.substring(F, m).replace(_, S)), w(m + 1 + v + s), p = r.indexOf(O, F), m = r.indexOf(S, F), o && (R(), z)) return C();
                            if (D && h.length >= D) return C(!0);
                            break;
                        }
                        u.push({
                            type: "Quotes",
                            code: "InvalidQuotes",
                            message: "Trailing quote on quoted field is malformed",
                            row: h.length,
                            index: F
                        }), m++;
                    }
                } else m++;
            }
            return E();
            function k(e) {
                h.push(e), d = F;
            }
            function b(e) {
                var t = 0;
                if (-1 !== e) {
                    var i = r.substring(m + 1, e);
                    i && "" === i.trim() && (t = i.length);
                }
                return t;
            }
            function E(e) {
                return i || (void 0 === e && (e = r.substring(F)), f.push(e), F = n, k(f), o && R()), C();
            }
            function w(e) {
                F = e, k(f), f = [], g = r.indexOf(x, F);
            }
            function C(e) {
                return {
                    data: h,
                    errors: u,
                    meta: {
                        delimiter: O,
                        linebreak: x,
                        aborted: z,
                        truncated: !!e,
                        cursor: d + (t || 0)
                    }
                };
            }
            function R() {
                T(C()), h = [], u = [];
            }
        }, this.abort = function() {
            z = !0;
        }, this.getCharIndex = function() {
            return F;
        };
    }
    function _(e) {
        var t = e.data, i = a[t.workerId], r = !1;
        if (t.error) i.userError(t.error, t.file);
        else if (t.results && t.results.data) {
            var n = {
                abort: function() {
                    r = !0, m(t.workerId, {
                        data: [],
                        errors: [],
                        meta: {
                            aborted: !0
                        }
                    });
                },
                pause: y,
                resume: y
            };
            if (M(i.userStep)) {
                for(var s = 0; s < t.results.data.length && (i.userStep({
                    data: t.results.data[s],
                    errors: t.results.errors,
                    meta: t.results.meta
                }, n), !r); s++);
                delete t.results;
            } else M(i.userChunk) && (i.userChunk(t.results, n, t.file), delete t.results);
        }
        t.finished && !r && m(t.workerId, t.results);
    }
    function m(e, t) {
        var i = a[e];
        M(i.userComplete) && i.userComplete(t), i.terminate(), delete a[e];
    }
    function y() {
        throw new Error("Not implemented.");
    }
    function w(e) {
        if ("object" != typeof e || null === e) return e;
        var t = Array.isArray(e) ? [] : {};
        for(var i in e)t[i] = w(e[i]);
        return t;
    }
    function v(e, t) {
        return function() {
            e.apply(t, arguments);
        };
    }
    function M(e) {
        return "function" == typeof e;
    }
    return o && (f.onmessage = function(e) {
        var t = e.data;
        void 0 === b.WORKER_ID && t && (b.WORKER_ID = t.workerId);
        if ("string" == typeof t.input) f.postMessage({
            workerId: b.WORKER_ID,
            results: b.parse(t.input, t.config),
            finished: !0
        });
        else if (f.File && t.input instanceof File || t.input instanceof Object) {
            var i = b.parse(t.input, t.config);
            i && f.postMessage({
                workerId: b.WORKER_ID,
                results: i,
                finished: !0
            });
        }
    }), (l.prototype = Object.create(u.prototype)).constructor = l, (c.prototype = Object.create(u.prototype)).constructor = c, (p.prototype = Object.create(p.prototype)).constructor = p, (g.prototype = Object.create(u.prototype)).constructor = g, b;
});




const $59c041f8acdb6976$export$30e493bbd186d503 = (elt)=>{
    const trimmed = elt.trim();
    const dequoted = trimmed.replace(/(^")|("$)/g, '');
    return dequoted;
};
const $59c041f8acdb6976$export$b9237471bf484894 = (name)=>`:${name.replace(/:/g, '').replace(/\s/g, '')}:`;
const $59c041f8acdb6976$export$9418dc7ef614f74b = (template, newValues, hopefullySelectedValue)=>{
    switch(template.type){
        case (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Text:
            return $59c041f8acdb6976$var$newTemplateValueText(template, hopefullySelectedValue);
        case (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).CSV:
        case (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Map:
            return $59c041f8acdb6976$var$newTemplateValueConstant(template, hopefullySelectedValue);
        case (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).MetaQuery:
        case (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).FluxQuery:
        case (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).FieldKeys:
        case (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Measurements:
        case (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).TagKeys:
        case (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).TagValues:
        case (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Databases:
            return $59c041f8acdb6976$var$newTemplateValueQuery(template, newValues, hopefullySelectedValue);
        default:
            throw new Error(`TemplateValue resolution for TemplateType ${template.type} not implemented`);
    }
};
const $59c041f8acdb6976$var$newTemplateValueQuery = (template, newValues, hopefullySelectedValue)=>{
    if (!newValues || !newValues.length) return [];
    const type = (0, $a3b88d5d27f00a75$export$4bad5a14b45b58a2)[template.type];
    let selectedValue = $59c041f8acdb6976$export$527010a204c46227(template);
    if (!selectedValue || !newValues.includes(selectedValue)) // The persisted selected value may no longer exist as a result for the
    // templates metaquery. In this case we select the first actual result
    selectedValue = newValues[0];
    let localSelectedValue = hopefullySelectedValue;
    if (!localSelectedValue) localSelectedValue = $59c041f8acdb6976$export$648b91d15717bb7b(template);
    if (!localSelectedValue || !newValues.includes(localSelectedValue)) localSelectedValue = selectedValue;
    return newValues.map((value)=>{
        return {
            type: type,
            value: value,
            selected: value === selectedValue,
            localSelected: value === localSelectedValue
        };
    });
};
const $59c041f8acdb6976$var$newTemplateValueConstant = (template, hopefullySelectedValue)=>{
    if (!template.values.length) return [];
    let selectedValue = template.values.find((v)=>v.selected);
    if (!selectedValue) selectedValue = template.values[0];
    let localSelectedValue = template.values.find((v)=>{
        return template.type === (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Map ? v.key === hopefullySelectedValue : v.value === hopefullySelectedValue;
    });
    if (!localSelectedValue) localSelectedValue = template.values.find((v)=>v.localSelected);
    if (!localSelectedValue) localSelectedValue = selectedValue;
    return template.values.map((v)=>({
            ...v,
            selected: v.value === selectedValue.value,
            localSelected: v.value === localSelectedValue.value
        }));
};
const $59c041f8acdb6976$var$newTemplateValueText = (template, hopefullySelectedValue)=>{
    if (hopefullySelectedValue) return [
        {
            value: hopefullySelectedValue,
            type: (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).Constant,
            localSelected: true,
            selected: false
        }
    ];
    else if (template.values.length) return [
        {
            ...template.values[0],
            localSelected: true
        }
    ];
    return [
        {
            value: '',
            type: (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).Constant,
            localSelected: true,
            selected: false
        }
    ];
};
const $59c041f8acdb6976$export$527010a204c46227 = (template)=>{
    const selected = template.values.find((v)=>v.selected);
    if (selected) return selected.value;
    return null;
};
const $59c041f8acdb6976$export$648b91d15717bb7b = (template)=>{
    const selected = template.values.find((v)=>v.localSelected);
    if (selected) return selected.value;
    return null;
};
const $59c041f8acdb6976$export$5e05677a1dcb2c28 = (csv)=>{
    let errors = [];
    const trimmed = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).trimEnd(csv, '\n');
    const parsedTVS = (0, (/*@__PURE__*/$parcel$interopDefault($22ab81005d9b2ccc$exports))).parse(trimmed);
    const templateValuesData = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(parsedTVS, 'data', [
        []
    ]);
    if (templateValuesData.length === 0) return;
    let arrayOfKeys = [];
    let values = [];
    for (const arr of templateValuesData)if (arr.length === 2 || arr.length === 3 && arr[2] === '') {
        const key = $59c041f8acdb6976$export$30e493bbd186d503(arr[0]);
        const value = $59c041f8acdb6976$export$30e493bbd186d503(arr[1]);
        if (!arrayOfKeys.includes(key) && key !== '') {
            values = [
                ...values,
                {
                    type: (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).Map,
                    value: value,
                    key: key,
                    selected: false,
                    localSelected: false
                }
            ];
            arrayOfKeys = [
                ...arrayOfKeys,
                key
            ];
        }
    } else errors = [
        ...errors,
        arr[0]
    ];
    return {
        values: values,
        errors: errors
    };
};
const $59c041f8acdb6976$export$d0fb0a45e146209 = (values)=>values.map((v)=>`${v.key},"${v.value}"`).join('\n');




const $5914150e71c44d02$var$CHECK_LIMIT_INTERVAL = 200;
const $5914150e71c44d02$var$MAX_ROWS = 50000;
const $5914150e71c44d02$export$786299a18b5685fc = async (source, query, uuid)=>{
    // We're using `XMLHttpRequest` directly here rather than through `axios` so
    // that we can poll the response size as it comes back. If the response size
    // is greater than a predefined limit, we close the HTTP connection and
    // return the partial response. We could acheive this more elegantly using
    // `fetch` and the [Streams API][0], but the Streams API is currently behind
    // a feature flag in Firefox.
    //
    // [0]: https://developer.mozilla.org/en-US/docs/Web/API/Streams_API
    const xhr = new XMLHttpRequest();
    const deferred = new (0, $abfce34f6d695938$export$2e2bcd8739ae039)();
    let didTruncate = false;
    let rowCount = 0;
    let rowCountIndex = 0;
    const countNewRows = ()=>{
        // Don't extract this to a non-closure helper, since passing
        // `xhr.responseText` as an argument will be expensive
        if (!xhr.responseText) return 0;
        let count = 0;
        for(let i = rowCountIndex; i < xhr.responseText.length; i++)if (xhr.responseText[i] === '\n') count++;
        return count;
    };
    const resolve = ()=>{
        let csv = xhr.responseText;
        if (didTruncate) // Discard the last line in the response since it may be partially read
        csv = csv.slice(0, csv.lastIndexOf('\n'));
        rowCount += countNewRows();
        const result = {
            csv: csv,
            didTruncate: didTruncate,
            rowCount: rowCount,
            uuid: uuid
        };
        deferred.resolve(result);
        clearTimeout(interval);
    };
    const reject = ()=>{
        let bodyError = null;
        try {
            const json = JSON.parse(xhr.responseText);
            bodyError = json.error;
            if (!bodyError && json.code && json.message) bodyError = json.code + ':\n' + json.message;
        } catch  {
            if (xhr.responseText && xhr.responseText.trim() !== '') bodyError = xhr.responseText;
        }
        const statusError = xhr.statusText;
        const fallbackError = 'failed to execute Flux query';
        const error = new Error(bodyError || statusError || fallbackError);
        error.xhr = xhr;
        deferred.reject(error);
        clearTimeout(interval);
    };
    const interval = setInterval(()=>{
        if (!xhr.responseText) // Haven't received any data yet
        return;
        rowCount += countNewRows();
        rowCountIndex = xhr.responseText.length;
        if (rowCount < $5914150e71c44d02$var$MAX_ROWS) return;
        didTruncate = true;
        resolve();
        xhr.abort();
    }, $5914150e71c44d02$var$CHECK_LIMIT_INTERVAL);
    xhr.onload = ()=>{
        if (xhr.status === 200) resolve();
        else reject();
    };
    xhr.onerror = reject;
    const path = encodeURIComponent(`/api/v2/query?organization=defaultorgname`);
    const url = `${window.basepath}${source.links.flux}?version=${source.version}&path=${path}`;
    const dialect = {
        annotations: [
            'group',
            'datatype',
            'default'
        ]
    };
    const body = JSON.stringify({
        query: query,
        dialect: dialect
    });
    xhr.open('POST', url);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.send(body);
    return deferred.promise;
};




var $hBdgJ = parcelRequire("hBdgJ");

const $c6606ad17445cd52$var$GROUP_KEY_EXCLUSIONS = [];
const $c6606ad17445cd52$export$ba14d9a5a581e827 = (response)=>{
    const chunks = $c6606ad17445cd52$var$parseChunks(response);
    const tables = chunks.reduce((acc, chunk)=>[
            ...acc,
            ...$c6606ad17445cd52$export$c81611b7cfe91367(chunk)
        ], []);
    return tables;
};
const $c6606ad17445cd52$var$parseChunks = (response)=>{
    const trimmedResponse = response.trim();
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEmpty(trimmedResponse)) return [];
    // some influxDB versions (docker v1.8.0) return \r\n as a new line separator
    const chunks = trimmedResponse.split(/\r?\n\s*\n/);
    return chunks;
};
const $c6606ad17445cd52$export$c81611b7cfe91367 = (responseChunk)=>{
    const lines = responseChunk.split('\n');
    const annotationLines = lines.filter((line)=>line.startsWith('#')).join('\n');
    const nonAnnotationLines = lines.filter((line)=>!line.startsWith('#')).join('\n');
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEmpty(annotationLines)) throw new Error('Unable to extract annotation data');
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEmpty(nonAnnotationLines)) // A response may be truncated on an arbitrary line. This guards against
    // the case where a response is truncated on annotation data
    return [];
    const nonAnnotationData = (0, (/*@__PURE__*/$parcel$interopDefault($22ab81005d9b2ccc$exports))).parse(nonAnnotationLines).data;
    const annotationData = (0, (/*@__PURE__*/$parcel$interopDefault($22ab81005d9b2ccc$exports))).parse(annotationLines).data;
    const headerRow = nonAnnotationData[0];
    if (headerRow[1] === 'error' && headerRow[2] === 'reference') throw new Error((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(nonAnnotationData, '1.1'));
    const tableColIndex = headerRow.findIndex((h)=>h === 'table');
    const timeColIndex = headerRow.findIndex((h)=>h === '_time');
    // Group rows by their table id
    const tablesData = Object.values((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).groupBy(nonAnnotationData.slice(1), (row)=>row[tableColIndex]));
    const groupRow = annotationData.find((row)=>row[0] === '#group');
    const defaultsRow = annotationData.find((row)=>row[0] === '#default');
    const dataTypeRow = annotationData.find((row)=>row[0] === '#datatype');
    // groupRow = ['#group', 'false', 'true', 'true', 'false']
    const groupKeyIndices = groupRow.reduce((acc, value, i)=>{
        if (value === 'true' && !$c6606ad17445cd52$var$GROUP_KEY_EXCLUSIONS.includes(headerRow[i])) return [
            ...acc,
            i
        ];
        return acc;
    }, []);
    const tables = tablesData.map((tableData)=>{
        const dataRow = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(tableData, '0', defaultsRow);
        const groupKey = groupKeyIndices.reduce((acc, i)=>{
            return {
                ...acc,
                [headerRow[i]]: (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(dataRow, i, '')
            };
        }, {});
        const name = Object.entries(groupKey).filter(([k])=>![
                '_start',
                '_stop'
            ].includes(k)).map(([k, v])=>`${k}=${v}`).join(' ');
        const dataTypes = dataTypeRow.reduce((acc, dataType, i)=>({
                ...acc,
                [headerRow[i]]: dataType
            }), {});
        const numberColumns = (dataTypeRow || []).reduce((acc, val, i)=>{
            if (val === 'long' || val === 'unsignedLong' || val === 'double') acc.push(i);
            return acc;
        }, []);
        for (const row of tableData){
            if (timeColIndex >= 0) row[timeColIndex] = new Date(row[timeColIndex]).valueOf();
            if (numberColumns.length) numberColumns.forEach((colIndex)=>{
                if (row[colIndex] !== '') row[colIndex] = parseFloat(row[colIndex]);
            });
        }
        const data = [
            headerRow,
            ...tableData
        ];
        return {
            id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
            data: data,
            name: name,
            groupKey: groupKey,
            dataTypes: dataTypes
        };
    });
    return tables;
};
const $c6606ad17445cd52$export$79d54e974ef34873 = (response)=>{
    const chunks = $c6606ad17445cd52$var$parseChunks(response);
    const parsedChunks = chunks.map((c)=>(0, (/*@__PURE__*/$parcel$interopDefault($22ab81005d9b2ccc$exports))).parse(c).data);
    const maxColumnCount = parsedChunks.length > 0 ? Math.max(...parsedChunks.map((c)=>c[0].length)) : 0;
    const data = [];
    for(let i = 0; i < parsedChunks.length; i++){
        if (i !== 0) // Seperate each chunk by an empty line, just like in the unparsed CSV
        data.push([]);
        data.push(...parsedChunks[i]);
        // Add an empty line at the end
        data.push([]);
    }
    return {
        data: data,
        maxColumnCount: maxColumnCount
    };
};


function $7b6b69e6512d0c7d$export$efddc1c90ac650d7(template) {
    if (template.query) {
        if (template.query.influxql) return $7b6b69e6512d0c7d$var$getDependencyNamesHelper(template.query.influxql);
        if (template.query.flux) return $7b6b69e6512d0c7d$var$getDependencyNamesHelper(template.query.flux);
    }
    const names = new Set();
    for (const { value: value } of template.values)for (const name of $7b6b69e6512d0c7d$var$getDependencyNamesHelper(value))names.add(name);
    return [
        ...names
    ];
}
function $7b6b69e6512d0c7d$var$getDependencyNamesHelper(s) {
    const names = [];
    let inName = false;
    let name = '';
    for (const c of s){
        if (inName) {
            if (c === ':') {
                inName = false;
                name += ':';
                names.push(name);
                name = '';
            } else if (c === '\n' || c === ' ' && name.length === 1) {
                // names cannot start with space or contain a new line,
                // this is especially required for flux, where ':'
                // separates parameter names and record values
                inName = false;
                continue;
            } else name += c;
        } else if (c === ':') {
            inName = true;
            name = ':';
        }
    }
    if (inName) throw new Error(`malformed template variable string \`${name}\``);
    return names;
}
function $7b6b69e6512d0c7d$var$verifyAcyclic(graph) {
    for (const node of graph)$7b6b69e6512d0c7d$var$verifyAcyclicHelper(node, []);
}
function $7b6b69e6512d0c7d$var$verifyAcyclicHelper(node, seen) {
    if (seen.includes(node)) {
        const tempVar = node.initialTemplate.tempVar;
        throw new Error(`cyclic dependency in template "${tempVar}"`);
    }
    for (const child of node.children)$7b6b69e6512d0c7d$var$verifyAcyclicHelper(child, [
        ...seen,
        node
    ]);
}
function $7b6b69e6512d0c7d$export$1a7bd1bb4818a731(templates) {
    const nodesById = templates.reduce((acc, t)=>({
            ...acc,
            [t.id]: {
                parents: [],
                children: [],
                status: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).NotStarted,
                initialTemplate: t,
                hydratedTemplate: null
            }
        }), {});
    const nodes = Object.values(nodesById);
    for (const template of templates){
        const childNames = $7b6b69e6512d0c7d$export$efddc1c90ac650d7(template);
        const nodeIsChild = (n)=>childNames.includes(n.initialTemplate.tempVar);
        const children = nodes.filter(nodeIsChild);
        nodesById[template.id].children.push(...children);
        for (const child of children)child.parents.push(nodesById[template.id]);
    }
    $7b6b69e6512d0c7d$var$verifyAcyclic(nodes);
    return nodes;
}
function $7b6b69e6512d0c7d$export$5c0523ec6add5477(nodes) {
    const acc = [];
    const seen = new Set();
    for (const node of nodes)if (!seen.has(node)) $7b6b69e6512d0c7d$var$topologicalSortHelper(node, seen, acc);
    return acc.reverse();
}
function $7b6b69e6512d0c7d$var$topologicalSortHelper(node, seen, acc) {
    seen.add(node);
    for (const child of node.children)if (!seen.has(child)) $7b6b69e6512d0c7d$var$topologicalSortHelper(child, seen, acc);
    acc.push(node);
}
function $7b6b69e6512d0c7d$var$findLeaves(graph) {
    return graph.filter((node)=>!node.children.length);
}
function $7b6b69e6512d0c7d$var$isResolved(node) {
    return node.status === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done;
}
class $7b6b69e6512d0c7d$var$CachingTemplateQueryFetcher {
    constructor(){
        this.cache = {};
    }
    async fetch(query, source, flux, warn = console.warn) {
        const proxyURL = flux ? source.links.flux : source.links.proxy;
        if (!proxyURL) {
            warn(`${flux ? 'Flux' : 'Proxy'} endpoint is not available!`);
            return [];
        }
        if (!this.cache[proxyURL]) this.cache[proxyURL] = {};
        const cached = this.cache[proxyURL][query];
        if (cached) return Promise.resolve([
            ...cached
        ]);
        let values;
        if (flux) {
            const response = await (0, $5914150e71c44d02$export$786299a18b5685fc)(source, query);
            const tables = (0, $c6606ad17445cd52$export$ba14d9a5a581e827)(response.csv);
            if (tables.length === 0) return [];
            if (tables.length > 1) warn('More tables are returned, but only the first is used!');
            const data = tables[0].data;
            if (data.length > 1) {
                const valueIndex = data[0].indexOf('_value');
                if (valueIndex > 0) values = data.slice(1).map((arr)=>String(arr[valueIndex]));
                else {
                    warn('No _value column found!');
                    return [];
                }
            }
        } else {
            const response = await (0, $aea829e093f1eddb$export$923f96dd5afa9ce6)({
                source: proxyURL,
                query: query
            });
            values = (0, $82bb95c5c6d74105$export$952c8ad1655ff67d)(query, response.data);
        }
        this.cache[proxyURL][query] = values;
        return [
            ...values
        ];
    }
}
const $7b6b69e6512d0c7d$var$defaultFetcher = new $7b6b69e6512d0c7d$var$CachingTemplateQueryFetcher();
async function $7b6b69e6512d0c7d$export$62eaf46cfd20a90c(template, templates, { source: source, fetcher: fetcher = $7b6b69e6512d0c7d$var$defaultFetcher, selections: selections = {}, warnFn: warnFn }) {
    let newValues;
    if (template.query && (template.query.influxql || template.query.flux)) {
        const renderedQuery = (0, $d9ab469c58284fd8$export$2e2bcd8739ae039)((0, $d9ab469c58284fd8$export$b0e691007bbef95c)(template), templates);
        newValues = await fetcher.fetch(renderedQuery, source, !!template.query.flux, warnFn);
    }
    const selection = selections[template.tempVar];
    const templateValues = (0, $59c041f8acdb6976$export$9418dc7ef614f74b)(template, newValues, selection);
    return {
        ...template,
        values: templateValues
    };
}
async function $7b6b69e6512d0c7d$export$29bb849e286afd7(templates, sources, hydrateOptions) {
    const graph = $7b6b69e6512d0c7d$export$1a7bd1bb4818a731(templates);
    async function resolve(node) {
        const resolvedTemplates = graph.filter($7b6b69e6512d0c7d$var$isResolved).map((t)=>t.hydratedTemplate);
        node.status = (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading;
        const { initialTemplate: initialTemplate } = node;
        const templateSource = sources.find((s)=>s.id === initialTemplate.sourceID);
        const source = templateSource ? templateSource : hydrateOptions.source;
        node.hydratedTemplate = await $7b6b69e6512d0c7d$export$62eaf46cfd20a90c(node.initialTemplate, resolvedTemplates, {
            ...hydrateOptions,
            source: source
        });
        node.status = (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done;
        const parents = node.parents.filter((p)=>p.children.every($7b6b69e6512d0c7d$var$isResolved)).map(resolve);
        return Promise.all(parents);
    }
    await Promise.all($7b6b69e6512d0c7d$var$findLeaves(graph).map(resolve));
    return graph.map((t)=>t.hydratedTemplate);
}




const $d9ab469c58284fd8$export$c43acf03b2e5f4d1 = 360;
const $d9ab469c58284fd8$export$6900b3a53b23630e = (durationMs)=>{
    return Math.round(durationMs / $d9ab469c58284fd8$export$c43acf03b2e5f4d1);
};
const $d9ab469c58284fd8$export$4d691f96d56ae2ff = (query, durationMs)=>{
    if (!query.includes((0, $e10a8602f56394e3$export$77e8fbcbea0ce430))) return query;
    const interval = $d9ab469c58284fd8$export$6900b3a53b23630e(durationMs);
    const renderedQuery = $d9ab469c58284fd8$var$replaceAll(query, (0, $e10a8602f56394e3$export$77e8fbcbea0ce430), `${interval}ms`);
    return renderedQuery;
};
const $d9ab469c58284fd8$var$sortTemplates = (templates)=>{
    const graph = (0, $7b6b69e6512d0c7d$export$1a7bd1bb4818a731)(templates);
    return (0, $7b6b69e6512d0c7d$export$5c0523ec6add5477)(graph).map((t)=>t.initialTemplate);
};
const $d9ab469c58284fd8$var$templateReplace = (query, templates)=>{
    const sortedTemplates = $d9ab469c58284fd8$var$sortTemplates(templates);
    return sortedTemplates.reduce((acc, template)=>$d9ab469c58284fd8$var$renderTemplate(acc, template), query);
};
const $d9ab469c58284fd8$var$renderTemplate = (query, template)=>{
    if (!template.values.length) return query;
    if (query && !query.includes(template.tempVar)) return query;
    const localSelectedTemplateValue = template.values.find((v)=>v.localSelected);
    const selectedTemplateValue = template.values.find((v)=>v.selected);
    const templateValue = localSelectedTemplateValue || selectedTemplateValue;
    if (!templateValue) return query;
    const { tempVar: tempVar } = template;
    const { value: value, type: type } = templateValue;
    let q = '';
    // First replace all template variable types in regular expressions.  Values should appear unquoted.
    switch(type){
        case (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).TagKey:
        case (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).FieldKey:
        case (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).Measurement:
        case (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).Database:
        case (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).TagValue:
        case (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).TimeStamp:
            q = $d9ab469c58284fd8$var$replaceAllRegex(query, tempVar, value);
            break;
        default:
            q = query;
    }
    // Then render template variables not in regular expressions
    switch(type){
        case (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).TagKey:
        case (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).FieldKey:
        case (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).Measurement:
        case (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).Database:
            return $d9ab469c58284fd8$var$replaceAll(q, tempVar, `"${value}"`);
        case (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).TagValue:
        case (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).TimeStamp:
            return $d9ab469c58284fd8$var$replaceAll(q, tempVar, `'${value}'`);
        case (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).CSV:
        case (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).Constant:
        case (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).MetaQuery:
        case (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).FluxQuery:
        case (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).Map:
            return $d9ab469c58284fd8$var$replaceAll(q, tempVar, value);
        default:
            return query;
    }
};
const $d9ab469c58284fd8$var$REGEX_COMPARATORS = [
    '=~',
    '!~'
];
const $d9ab469c58284fd8$var$REGEX_DELIMITER = '/';
const $d9ab469c58284fd8$var$replaceAllRegex = (query, search, replacement)=>{
    let result = query;
    let i = 0;
    while(i < result.length - 1){
        const chars = result[i] + result[i + 1];
        const isStartOfRegex = $d9ab469c58284fd8$var$REGEX_COMPARATORS.includes(chars);
        if (!isStartOfRegex) {
            i += 1;
            continue;
        }
        const regexStart = $d9ab469c58284fd8$var$findNext(result, $d9ab469c58284fd8$var$REGEX_DELIMITER, i);
        const regexEnd = $d9ab469c58284fd8$var$findNext(result, $d9ab469c58284fd8$var$REGEX_DELIMITER, regexStart + 1);
        const regexContent = result.slice(regexStart + 1, regexEnd);
        const replacedRegexContent = regexContent.replace(search, replacement);
        result = result.slice(0, regexStart + 1) + replacedRegexContent + result.slice(regexEnd);
        i = $d9ab469c58284fd8$var$findNext(result, $d9ab469c58284fd8$var$REGEX_DELIMITER, regexStart + 1);
    }
    return result;
};
const $d9ab469c58284fd8$var$findNext = (s, t, startIndex)=>{
    const tail = s.slice(startIndex);
    const i = tail.indexOf(t);
    if (i === -1) throw new Error(`Expected token '${t}' in '${tail}'`);
    return startIndex + i;
};
const $d9ab469c58284fd8$var$replaceAll = (query, search, replacement)=>{
    return (query || '').split(search).join(replacement);
};
const $d9ab469c58284fd8$export$b0e691007bbef95c = (template)=>{
    if (template.type === (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).MetaQuery) // A custom meta query template may reference other templates whose names
    // conflict with the `database`, `measurement` and `tagKey` fields stored
    // within a template's `query` object. Since these fields are always empty
    // for a custom meta query template, we do not attempt to replace them
    return template.query.influxql;
    if (template.type === (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).FluxQuery) // return flux query as-is
    return template.query.flux;
    const { influxql: influxql, db: db, measurement: measurement, tagKey: tagKey } = template.query;
    return influxql.replace(':database:', `"${db}"`).replace(':measurement:', `"${measurement}"`).replace(':tagKey:', `"${tagKey}"`);
};
var $d9ab469c58284fd8$export$2e2bcd8739ae039 = $d9ab469c58284fd8$var$templateReplace;





const $0ece195804443aff$var$MAX_COLUMNS = 12;
const $0ece195804443aff$var$getMostCommonValue = (values)=>{
    const results = values.reduce((acc, value)=>{
        const { distribution: distribution, mostCommonCount: mostCommonCount } = acc;
        distribution[value] = (distribution[value] || 0) + 1;
        if (distribution[value] > mostCommonCount) return {
            distribution: distribution,
            mostCommonCount: distribution[value],
            mostCommonValue: value
        };
        return acc;
    }, {
        distribution: {},
        mostCommonCount: 0,
        mostCommonValue: null
    });
    return results.mostCommonValue;
};
const $0ece195804443aff$export$ec617d9f902318c7 = (cellName)=>{
    return cellName === (0, $9a9ec629fdd38845$export$e55cd9ddf9185ec0);
};
const $0ece195804443aff$export$57628dc5e2500125 = (cells, newCell)=>{
    const farthestY = cells.map((cell)=>cell.y).reduce((a, b)=>a > b ? a : b);
    const bottomCells = cells.filter((cell)=>cell.y === farthestY);
    const farthestX = bottomCells.map((cell)=>cell.x).reduce((a, b)=>a > b ? a : b);
    const lastCell = bottomCells.find((cell)=>cell.x === farthestX);
    const availableSpace = $0ece195804443aff$var$MAX_COLUMNS - (lastCell.x + lastCell.w);
    const newCellFits = availableSpace >= newCell.w;
    return newCellFits ? {
        x: lastCell.x + lastCell.w,
        y: farthestY
    } : {
        x: 0,
        y: lastCell.y + lastCell.h
    };
};
const $0ece195804443aff$export$47308518c82e405 = (dashboard, cellType = (0, $b4506126e09430df$export$705e36171f4cbbfe).Line)=>{
    const typedCell = {
        ...(0, $9a9ec629fdd38845$export$5555fe053dab8f56),
        type: cellType,
        name: (0, $9a9ec629fdd38845$export$e55cd9ddf9185ec0)
    };
    if (dashboard.cells.length === 0) return typedCell;
    const existingCellWidths = dashboard.cells.map((cell)=>cell.w);
    const existingCellHeights = dashboard.cells.map((cell)=>cell.h);
    const mostCommonCellWidth = $0ece195804443aff$var$getMostCommonValue(existingCellWidths);
    const mostCommonCellHeight = $0ece195804443aff$var$getMostCommonValue(existingCellHeights);
    const newCell = {
        ...typedCell,
        w: mostCommonCellWidth,
        h: mostCommonCellHeight
    };
    const { x: x, y: y } = $0ece195804443aff$export$57628dc5e2500125(dashboard.cells, newCell);
    return {
        ...newCell,
        x: x,
        y: y
    };
};
const $0ece195804443aff$var$incrementCloneName = (cellNames, cellName)=>{
    const rootName = cellName.replace(/\s\(clone\s(\d)+\)/g, '').replace(/\)/, '');
    const filteredNames = cellNames.filter((cn)=>cn.includes(rootName));
    const highestNumberedClone = filteredNames.reduce((acc, name)=>{
        if (name.match(/\(clone(\s|\d)+\)/)) {
            const strippedName = name.replace(rootName, '').replace(/\(clone/, '').replace(/\)/, '');
            const cloneNumber = Number(strippedName);
            return cloneNumber >= acc ? cloneNumber : acc;
        }
        return acc;
    }, 0);
    if (highestNumberedClone) {
        const newCloneNumber = highestNumberedClone + 1;
        return `${cellName.replace(/\(clone\s(\d)+\)/, '')} (clone ${newCloneNumber})`;
    }
    return `${cellName} (clone 1)`;
};
const $0ece195804443aff$export$697db1c258ca5dc9 = (dashboard, cellClone)=>{
    const cellNames = dashboard.cells.map((c)=>c.name);
    const name = $0ece195804443aff$var$incrementCloneName(cellNames, cellClone.name);
    const cellCloneFitsLeft = cellClone.x >= cellClone.w;
    const cellCloneFitsRight = $0ece195804443aff$var$MAX_COLUMNS - (cellClone.w + cellClone.x) >= cellClone.w;
    if (cellCloneFitsRight) return {
        ...cellClone,
        x: cellClone.x + cellClone.w,
        name: name
    };
    if (cellCloneFitsLeft) return {
        ...cellClone,
        x: cellClone.x - cellClone.w,
        name: name
    };
    return {
        ...cellClone,
        y: cellClone.y + cellClone.h,
        name: name
    };
};
const $0ece195804443aff$export$fe73f2cc6771a40f = (queryConfig)=>{
    return $0ece195804443aff$var$getRangeForOriginalQuery(queryConfig.originalQuery, queryConfig.range);
};
const $0ece195804443aff$var$getRangeForOriginalQuery = (originalQuery, range)=>{
    const isUsingDashTime = range && originalQuery && originalQuery.indexOf((0, $a3b88d5d27f00a75$export$e45d50782fac2336).lower) !== -1;
    if (isUsingDashTime || !range) return 0, $a3b88d5d27f00a75$export$e45d50782fac2336;
    return range;
};
const $0ece195804443aff$export$44487a86467333c3 = async (url, id, query, templates)=>{
    const renderedQuery = (0, $d9ab469c58284fd8$export$2e2bcd8739ae039)(query, templates);
    const queries = await (0, $3bff70d0456af5c0$export$24149453367e7e3c)(url, [
        {
            query: renderedQuery,
            id: id
        }
    ]);
    const { queryConfig: queryConfig } = queries.find((q)=>q.id === id);
    const range = $0ece195804443aff$var$getRangeForOriginalQuery(query, queryConfig.range);
    if (queryConfig.rawText) // the query cannot be parsed to query config successfully
    // return back the raw query
    queryConfig.rawText = query;
    return {
        ...queryConfig,
        originalQuery: query,
        range: range
    };
};


const $5715391030c175d1$var$addNewCellToCells = (cells, cell)=>{
    let x = 0;
    let y = 0;
    if (cells.length !== 0) {
        const pos = (0, $0ece195804443aff$export$57628dc5e2500125)(cells, cell);
        x = pos.x;
        y = pos.y;
    }
    return [
        ...cells,
        {
            ...cell,
            x: x,
            y: y
        }
    ];
};
const $5715391030c175d1$var$createTemplatesForProtoboard = (pbTemplates, source)=>{
    const telegraf = source.telegraf || 'telegraf';
    return pbTemplates.map((pbt)=>{
        return {
            ...pbt,
            id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
            query: {
                ...pbt.query,
                db: telegraf
            }
        };
    });
};
const $5715391030c175d1$var$replaceQuery = (q, source)=>q.replace(':db:', source.telegraf || 'telegraf').replace(':rp:', source.defaultRP || 'autogen');
const $5715391030c175d1$var$replaceDbRp = (queries, source)=>queries.map((q)=>({
            ...q,
            query: $5715391030c175d1$var$replaceQuery(q.query, source)
        }));
const $5715391030c175d1$export$36fde1ee93c850bb = (protoboard, source)=>{
    let cellsWithPlaces = protoboard.data.cells;
    const isCellsUnplaced = protoboard.data.cells.every((c)=>c.x === 0 && c.y === 0);
    if (isCellsUnplaced) cellsWithPlaces = protoboard.data.cells.reduce($5715391030c175d1$var$addNewCellToCells, []);
    const pbTemplates = protoboard.data.templates;
    const templates = $5715391030c175d1$var$createTemplatesForProtoboard(pbTemplates, source);
    const cells = cellsWithPlaces.map((c)=>({
            ...c,
            queries: $5715391030c175d1$var$replaceDbRp(c.queries, source)
        }));
    const dashboard = {
        name: protoboard.meta.name,
        cells: cells,
        templates: templates
    };
    return dashboard;
};


const $2adafb01fdaabc72$export$8e4b6d6c4fec08f3 = ()=>{
    return (0, $a537743573e5e486$export$2e2bcd8739ae039)({
        method: 'GET',
        resource: 'dashboards'
    });
};
const $2adafb01fdaabc72$export$646488bd511db359 = async (source, { activeDashboard: activeDashboard, dashboardsAJAX: dashboardsAJAX = $2adafb01fdaabc72$export$8e4b6d6c4fec08f3 })=>{
    const { data: { dashboards: dashboards } } = await dashboardsAJAX();
    const links = (0, $a7c7af802fab926a$export$8b84f64b92190876)(dashboards, source);
    const dashboardLinks = (0, $a7c7af802fab926a$export$9d5bee8a7028c508)(links, activeDashboard);
    return dashboardLinks;
};
const $2adafb01fdaabc72$export$f3fe8eb89c757086 = async (dashboardID)=>{
    try {
        const url = `/chronograf/v1/dashboards/${dashboardID}`;
        return (0, $3a006c970d7cf650$export$a6385bddcc8e6b77).get(url);
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $2adafb01fdaabc72$export$8a2c60458ca4e242 = (dashboard)=>{
    return (0, $a537743573e5e486$export$2e2bcd8739ae039)({
        method: 'PUT',
        url: dashboard.links.self,
        data: dashboard
    });
};
const $2adafb01fdaabc72$export$18f05ab8a5b491fd = (cell)=>{
    return (0, $a537743573e5e486$export$2e2bcd8739ae039)({
        method: 'PUT',
        url: cell.links.self,
        data: cell
    });
};
const $2adafb01fdaabc72$export$eadf0ac433611b3 = async (dashboard)=>{
    try {
        return await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'POST',
            resource: 'dashboards',
            data: dashboard
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $2adafb01fdaabc72$export$3d4a4db1f9a4ff4c = async (protoboard, source)=>{
    const dashboard = (0, $5715391030c175d1$export$36fde1ee93c850bb)(protoboard, source);
    try {
        return await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'POST',
            resource: 'dashboards',
            data: dashboard
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $2adafb01fdaabc72$export$794471fec7cce9b7 = async (dashboard)=>{
    try {
        return await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'DELETE',
            url: dashboard.links.self
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $2adafb01fdaabc72$export$4192c198b4468786 = async (dashboard, cell)=>{
    try {
        return await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'POST',
            url: dashboard.links.cells,
            data: cell
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $2adafb01fdaabc72$export$e4b34c3349d6b5b = async (cell)=>{
    try {
        return await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'DELETE',
            url: cell.links.self
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $2adafb01fdaabc72$export$1b8af70b9a900a55 = async (templateVariable)=>{
    try {
        return await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'PUT',
            url: templateVariable.links.self,
            data: templateVariable
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
};









var $1l8zS = parcelRequire("1l8zS");

const $258ff394ebf672be$export$6aa6378c517e89f1 = ()=>{
    const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($1l8zS))).parse(window.location.search, {
        ignoreQueryPrefix: true
    });
    const tempVars = queryParams.tempVars || {};
    return Object.entries(tempVars).reduce((acc, [tempVar, v])=>({
            ...acc,
            [(0, $59c041f8acdb6976$export$b9237471bf484894)(tempVar)]: v
        }), {});
};
const $258ff394ebf672be$export$a836ba7527040c9f = (templates)=>{
    return templates.reduce((acc, template)=>{
        const tempVar = $258ff394ebf672be$export$e76e85063968ee93(template.tempVar);
        const selection = template.values.find((t)=>t.localSelected);
        if (!selection) return acc;
        const value = template.type === 'map' ? selection.key : selection.value;
        return {
            ...acc,
            [tempVar]: value
        };
    }, {});
};
const $258ff394ebf672be$export$e76e85063968ee93 = (tempVarName)=>tempVarName.substr(1, tempVarName.length - 2);
const $258ff394ebf672be$var$makeSelected = (template, value)=>{
    const found = template.values.find((v)=>v.value === value);
    let valueToChoose;
    if (found) valueToChoose = found.value;
    else valueToChoose = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(template, 'values.0.value', '');
    const valuesWithSelected = template.values.map((v)=>{
        if (v.value === valueToChoose) return {
            ...v,
            selected: true
        };
        return {
            ...v,
            selected: false
        };
    });
    return {
        ...template,
        values: valuesWithSelected
    };
};
const $258ff394ebf672be$export$306a6429e9767166 = (template)=>{
    const selectedValue = '';
    return $258ff394ebf672be$export$a7c14267e33618dc(template, selectedValue);
};
const $258ff394ebf672be$export$a7c14267e33618dc = (template, value)=>{
    const found = template.values.find((v)=>v.value === value);
    const selectedValue = template.values.find((v)=>v.selected);
    let valueToChoose;
    if (found) valueToChoose = found.value;
    else if (selectedValue) valueToChoose = selectedValue.value;
    else valueToChoose = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(template, 'values.0.value', '');
    const valuesWithLocalSelected = template.values.map((v)=>{
        if (v.value === valueToChoose) return {
            ...v,
            localSelected: true
        };
        return {
            ...v,
            localSelected: false
        };
    });
    return {
        ...template,
        values: valuesWithLocalSelected
    };
};
const $258ff394ebf672be$export$1b7f2606dceea62f = (nextTemplate, nextNextTemplate)=>{
    const localSelectedValue = nextTemplate.values.find((v)=>v.localSelected);
    const selectedValue = nextTemplate.values.find((v)=>v.selected);
    const templateWithLocalSelected = $258ff394ebf672be$var$makeSelected(nextNextTemplate, (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(selectedValue, 'value', ''));
    const templateWithLocalSelectedAndSelected = $258ff394ebf672be$export$a7c14267e33618dc(templateWithLocalSelected, (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(localSelectedValue, 'value', ''));
    return templateWithLocalSelectedAndSelected;
};



var $axd2S = parcelRequire("axd2S");

const $78d6d6f4dd3e1375$export$c7f613ca34819a31 = ({ seconds: seconds, lower: lower, upper: upper })=>{
    // Is this a relative time range?
    if (seconds) return {
        since: Date.now() - seconds * 1000,
        until: null
    };
    const since = Date.parse(lower);
    let until;
    if (upper === 'now()') until = Date.now();
    else until = Date.parse(upper);
    return {
        since: since,
        until: until
    };
};
const $78d6d6f4dd3e1375$var$nullTimeRange = {
    lower: null,
    upper: null
};
const $78d6d6f4dd3e1375$var$validRelativeTimeRange = (timeRange)=>{
    const validatedTimeRange = (0, $6a7b0ae94f8ec28f$export$9b55ef3c660cd071).find((t)=>t.lower === timeRange.lower);
    if (validatedTimeRange) return validatedTimeRange;
    return $78d6d6f4dd3e1375$var$nullTimeRange;
};
const $78d6d6f4dd3e1375$export$3689c506c97120a7 = (timeRange)=>{
    if (timeRange.lower && timeRange.upper) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(timeRange.lower).isValid()) {
            if (timeRange.upper === 'now()' || (0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(timeRange.upper).isValid() && (0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(timeRange.lower).isBefore((0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(timeRange.upper))) return timeRange;
        }
    }
    return $78d6d6f4dd3e1375$var$nullTimeRange;
};
const $78d6d6f4dd3e1375$export$aa559e1d0c17b644 = (timeRange)=>{
    const validatedTimeRange = $78d6d6f4dd3e1375$var$validRelativeTimeRange(timeRange);
    if (validatedTimeRange.lower) return validatedTimeRange;
    return $78d6d6f4dd3e1375$export$3689c506c97120a7(timeRange);
};







var $9859d1d8ae3f2524$export$e4a712fff93fb00f = /*#__PURE__*/ function(ActionType) {
    ActionType["LoadDashboards"] = "LOAD_DASHBOARDS";
    ActionType["LoadDashboard"] = "LOAD_DASHBOARD";
    ActionType["SetDashboardTimeRange"] = "SET_DASHBOARD_TIME_RANGE";
    ActionType["SetDashboardZoomedTimeRange"] = "SET_DASHBOARD_ZOOMED_TIME_RANGE";
    ActionType["UpdateDashboard"] = "UPDATE_DASHBOARD";
    ActionType["CreateDashboard"] = "CREATE_DASHBOARD";
    ActionType["DeleteDashboard"] = "DELETE_DASHBOARD";
    ActionType["DeleteDashboardFailed"] = "DELETE_DASHBOARD_FAILED";
    ActionType["AddDashboardCell"] = "ADD_DASHBOARD_CELL";
    ActionType["DeleteDashboardCell"] = "DELETE_DASHBOARD_CELL";
    ActionType["SyncDashboardCell"] = "SYNC_DASHBOARD_CELL";
    ActionType["EditCellQueryStatus"] = "EDIT_CELL_QUERY_STATUS";
    ActionType["TemplateVariableLocalSelected"] = "TEMPLATE_VARIABLE_LOCAL_SELECTED";
    ActionType["UpdateTemplates"] = "UPDATE_TEMPLATES";
    ActionType["SetHoverTime"] = "SET_HOVER_TIME";
    ActionType["SetActiveCell"] = "SET_ACTIVE_CELL";
    ActionType["SetDashboardTimeV1"] = "SET_DASHBOARD_TIME_V1";
    ActionType["SetDashboardRefresh"] = "SET_DASHBOARD_REFRESH";
    ActionType["RetainRangesDashboardTimeV1"] = "RETAIN_RANGES_DASHBOARD_TIME_V1";
    ActionType["RetainDashboardRefresh"] = "RETAIN_DASHBOARD_REFRESH";
    return ActionType;
}({});
const $9859d1d8ae3f2524$export$23c0e7c12112056d = (dashboards, dashboardID)=>({
        type: "LOAD_DASHBOARDS",
        payload: {
            dashboards: dashboards,
            dashboardID: dashboardID
        }
    });
const $9859d1d8ae3f2524$export$3a75641b11dbce93 = (dashboard)=>({
        type: "LOAD_DASHBOARD",
        payload: {
            dashboard: dashboard
        }
    });
const $9859d1d8ae3f2524$export$25a740f44c90929f = (dashboardID, timeRange)=>({
        type: "SET_DASHBOARD_TIME_V1",
        payload: {
            dashboardID: dashboardID,
            timeRange: timeRange
        }
    });
const $9859d1d8ae3f2524$export$6ad1ca08b6b7b636 = (dashboardID, refreshRate)=>({
        type: "SET_DASHBOARD_REFRESH",
        payload: {
            dashboardID: dashboardID,
            refreshRate: refreshRate
        }
    });
const $9859d1d8ae3f2524$export$3139c1361eed5496 = (dashboardIDs)=>({
        type: "RETAIN_RANGES_DASHBOARD_TIME_V1",
        payload: {
            dashboardIDs: dashboardIDs
        }
    });
const $9859d1d8ae3f2524$export$d23cba85a907d123 = (dashboardIDs)=>({
        type: "RETAIN_DASHBOARD_REFRESH",
        payload: {
            dashboardIDs: dashboardIDs
        }
    });
const $9859d1d8ae3f2524$export$bed89c1c05e5d49a = (timeRange)=>({
        type: "SET_DASHBOARD_TIME_RANGE",
        payload: {
            timeRange: timeRange
        }
    });
const $9859d1d8ae3f2524$export$4c0bf62335ec7f62 = (zoomedTimeRange)=>({
        type: "SET_DASHBOARD_ZOOMED_TIME_RANGE",
        payload: {
            zoomedTimeRange: zoomedTimeRange
        }
    });
const $9859d1d8ae3f2524$export$8a2c60458ca4e242 = (dashboard)=>({
        type: "UPDATE_DASHBOARD",
        payload: {
            dashboard: dashboard
        }
    });
const $9859d1d8ae3f2524$export$eadf0ac433611b3 = (dashboard)=>({
        type: "CREATE_DASHBOARD",
        payload: {
            dashboard: dashboard
        }
    });
const $9859d1d8ae3f2524$export$794471fec7cce9b7 = (dashboard)=>({
        type: "DELETE_DASHBOARD",
        payload: {
            dashboard: dashboard
        }
    });
const $9859d1d8ae3f2524$export$ca0841932e4a246f = (dashboard)=>({
        type: "DELETE_DASHBOARD_FAILED",
        payload: {
            dashboard: dashboard
        }
    });
const $9859d1d8ae3f2524$export$566d23a81f63b6e8 = (dashboard, cell)=>({
        type: "SYNC_DASHBOARD_CELL",
        payload: {
            dashboard: dashboard,
            cell: cell
        }
    });
const $9859d1d8ae3f2524$export$4192c198b4468786 = (dashboard, cell)=>({
        type: "ADD_DASHBOARD_CELL",
        payload: {
            dashboard: dashboard,
            cell: cell
        }
    });
const $9859d1d8ae3f2524$export$e4b34c3349d6b5b = (dashboard, cell)=>({
        type: "DELETE_DASHBOARD_CELL",
        payload: {
            dashboard: dashboard,
            cell: cell
        }
    });
const $9859d1d8ae3f2524$export$40f5f2075e1b32d4 = (queryID, status)=>({
        type: "EDIT_CELL_QUERY_STATUS",
        payload: {
            queryID: queryID,
            status: status
        }
    });
const $9859d1d8ae3f2524$export$c637c70fae500106 = (dashboardID, templateID, value)=>({
        type: "TEMPLATE_VARIABLE_LOCAL_SELECTED",
        payload: {
            dashboardID: dashboardID,
            templateID: templateID,
            value: value
        }
    });
const $9859d1d8ae3f2524$export$2ae8a0240b0b88d9 = (templates)=>({
        type: "UPDATE_TEMPLATES",
        payload: {
            templates: templates
        }
    });
const $9859d1d8ae3f2524$export$fe6c3dd773ddd054 = (hoverTime)=>({
        type: "SET_HOVER_TIME",
        payload: {
            hoverTime: hoverTime
        }
    });
const $9859d1d8ae3f2524$export$c1df6941ca12827f = (activeCellID)=>({
        type: "SET_ACTIVE_CELL",
        payload: {
            activeCellID: activeCellID
        }
    });
const $9859d1d8ae3f2524$export$8912edd43a848d84 = (updatedQueryParams)=>{
    const { search: search, pathname: pathname } = window.location;
    const strippedPathname = (0, $d54b25c31b40a794$export$71c2a1babd78d286)(pathname);
    const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).omit((0, (/*@__PURE__*/$parcel$interopDefault($1l8zS))).parse(search, {
        ignoreQueryPrefix: true
    }), [
        'lower',
        'upper',
        'zoomedLower',
        'zoomedUpper'
    ]);
    const newQueryParams = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).pickBy({
        ...parsed,
        ...updatedQueryParams
    }, (v)=>!!v);
    const newSearch = (0, (/*@__PURE__*/$parcel$interopDefault($1l8zS))).stringify(newQueryParams);
    const newLocation = {
        pathname: strippedPathname,
        search: `?${newSearch}`
    };
    return (0, $14b9f70b6017fdee$exports.push)(newLocation);
};
const $9859d1d8ae3f2524$export$92377f461a797888 = (updatedQueryParams)=>{
    const { search: search, pathname: pathname } = window.location;
    const strippedPathname = (0, $d54b25c31b40a794$export$71c2a1babd78d286)(pathname);
    const newQueryParams = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).pickBy({
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1l8zS))).parse(search, {
            ignoreQueryPrefix: true
        }),
        ...updatedQueryParams
    }, (v)=>!!v);
    const newSearch = (0, (/*@__PURE__*/$parcel$interopDefault($1l8zS))).stringify(newQueryParams);
    const newLocation = {
        pathname: strippedPathname,
        search: `?${newSearch}`
    };
    return (0, $14b9f70b6017fdee$exports.replace)(newLocation);
};
const $9859d1d8ae3f2524$var$getDashboard = (state, dashboardId)=>{
    const dashboard = state.dashboardUI.dashboards.find((d)=>d.id === dashboardId);
    if (!dashboard) throw new Error(`Could not find dashboard with id '${dashboardId}'`);
    return dashboard;
};
const $9859d1d8ae3f2524$export$e5b1f1e10b3d70a7 = ()=>async (dispatch)=>{
        try {
            const { data: { dashboards: dashboards } } = await (0, $2adafb01fdaabc72$export$8e4b6d6c4fec08f3)();
            dispatch($9859d1d8ae3f2524$export$23c0e7c12112056d(dashboards));
            return dashboards;
        } catch (error) {
            console.error(error);
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error));
        }
    };
const $9859d1d8ae3f2524$export$af278a8f89c893bc = ()=>async ()=>{
        try {
            const results = await (0, $ce33d45777fa0434$export$dd7946daa6163e94)();
            const version = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(results, 'headers.x-chronograf-version');
            return version;
        } catch (error) {
            console.error(error);
        }
    };
const $9859d1d8ae3f2524$var$removeUnselectedTemplateValues = (dashboard)=>{
    const templates = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(dashboard, 'templates', []).map((template)=>{
        if (template.type === (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).CSV || template.type === (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Map) return template;
        const value = template.values.find((val)=>val.selected);
        const values = value ? [
            value
        ] : [];
        return {
            ...template,
            values: values
        };
    });
    return templates;
};
const $9859d1d8ae3f2524$export$29b6f6999ebdbd60 = (dashboard)=>async (dispatch)=>{
        try {
            // save only selected template values to server
            const templatesWithOnlySelectedValues = $9859d1d8ae3f2524$var$removeUnselectedTemplateValues(dashboard);
            const { data: dashboardWithOnlySelectedTemplateValues } = await (0, $2adafb01fdaabc72$export$8a2c60458ca4e242)({
                ...dashboard,
                templates: templatesWithOnlySelectedValues
            });
            // save all template values to redux
            dispatch($9859d1d8ae3f2524$export$8a2c60458ca4e242({
                ...dashboardWithOnlySelectedTemplateValues,
                templates: dashboard.templates
            }));
        } catch (error) {
            console.error(error);
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error));
        }
    };
const $9859d1d8ae3f2524$export$59693e3bcff1cf23 = (dashboardID)=>async (dispatch, getState)=>{
        try {
            const dashboard = $9859d1d8ae3f2524$var$getDashboard(getState(), dashboardID);
            const templates = $9859d1d8ae3f2524$var$removeUnselectedTemplateValues(dashboard);
            await (0, $2adafb01fdaabc72$export$8a2c60458ca4e242)({
                ...dashboard,
                templates: templates
            });
        } catch (error) {
            console.error(error);
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error));
        }
    };
const $9859d1d8ae3f2524$export$18f05ab8a5b491fd = (dashboard, cell)=>async (dispatch)=>{
        try {
            const { data: data } = await (0, $2adafb01fdaabc72$export$18f05ab8a5b491fd)(cell);
            dispatch($9859d1d8ae3f2524$export$566d23a81f63b6e8(dashboard, data));
        } catch (error) {
            console.error(error);
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error));
        }
    };
const $9859d1d8ae3f2524$export$9cfbbfc4b857b8e5 = (dashboard)=>async (dispatch)=>{
        dispatch($9859d1d8ae3f2524$export$794471fec7cce9b7(dashboard));
        try {
            await (0, $2adafb01fdaabc72$export$794471fec7cce9b7)(dashboard);
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$b62936ee40a91499)(dashboard.name)));
        } catch (error) {
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error, (0, $ec1f42de4faacc37$export$2d6345764df5740d)(dashboard.name, error.data.message)));
            dispatch($9859d1d8ae3f2524$export$ca0841932e4a246f(dashboard));
        }
    };
const $9859d1d8ae3f2524$export$17ae542af88fbb65 = (dashboard, cell)=>async (dispatch)=>{
        try {
            const { data: data } = await (0, $2adafb01fdaabc72$export$4192c198b4468786)(dashboard, cell);
            dispatch($9859d1d8ae3f2524$export$4192c198b4468786(dashboard, data));
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$f51fb663e05b8eaf)(data.name)));
        } catch (error) {
            console.error(error);
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error));
        }
    };
const $9859d1d8ae3f2524$export$bbb7779e826cf2eb = (dashboard, cell)=>async (dispatch)=>{
        try {
            const { data: data } = await (0, $2adafb01fdaabc72$export$4192c198b4468786)(dashboard, cell);
            dispatch($9859d1d8ae3f2524$export$4192c198b4468786(dashboard, data));
            return {
                success: true,
                dashboard: dashboard
            };
        } catch (error) {
            console.error(error);
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error));
            return {
                success: false,
                dashboard: dashboard
            };
        }
    };
const $9859d1d8ae3f2524$export$296fabffdb579a4f = (dashboard, cell)=>async (dispatch)=>{
        try {
            const clonedCell = (0, $0ece195804443aff$export$697db1c258ca5dc9)(dashboard, cell);
            const { data: data } = await (0, $2adafb01fdaabc72$export$4192c198b4468786)(dashboard, clonedCell);
            dispatch($9859d1d8ae3f2524$export$4192c198b4468786(dashboard, data));
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$f51fb663e05b8eaf)(clonedCell.name)));
        } catch (error) {
            console.error(error);
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error));
        }
    };
const $9859d1d8ae3f2524$export$1874906bbeb2f659 = (dashboard, cell)=>async (dispatch)=>{
        try {
            await (0, $2adafb01fdaabc72$export$e4b34c3349d6b5b)(cell);
            dispatch($9859d1d8ae3f2524$export$e4b34c3349d6b5b(dashboard, cell));
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$3e7bb883732c450d)(cell.name)));
        } catch (error) {
            console.error(error);
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error));
        }
    };
const $9859d1d8ae3f2524$export$9bb49e3c808ea88c = (dashboard)=>async (dispatch)=>{
        try {
            // save only selected template values to server
            const templatesWithOnlySelectedValues = $9859d1d8ae3f2524$var$removeUnselectedTemplateValues(dashboard);
            const results = await (0, $2adafb01fdaabc72$export$eadf0ac433611b3)({
                ...dashboard,
                templates: templatesWithOnlySelectedValues
            });
            const dashboardWithOnlySelectedTemplateValues = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(results, 'data');
            // save all template values to redux
            dispatch($9859d1d8ae3f2524$export$eadf0ac433611b3({
                ...dashboardWithOnlySelectedTemplateValues,
                templates: dashboard.templates
            }));
            const { data: { dashboards: dashboards } } = await (0, $2adafb01fdaabc72$export$8e4b6d6c4fec08f3)();
            dispatch($9859d1d8ae3f2524$export$23c0e7c12112056d(dashboards));
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$b7de63aa72092845)()));
        } catch (error) {
            const errorMessage = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(error, 'data.message', 'Could not upload dashboard');
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$bdd074588a01033f)('', errorMessage)));
            console.error(error);
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error));
        }
    };
const $9859d1d8ae3f2524$var$updateTimeRangeFromQueryParams = (dashboardID)=>(dispatch, getState)=>{
        const { dashTimeV1: dashTimeV1 } = getState();
        const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($1l8zS))).parse(window.location.search, {
            ignoreQueryPrefix: true
        });
        const timeRangeFromQueries = {
            lower: queryParams.lower,
            upper: queryParams.upper
        };
        const zoomedTimeRangeFromQueries = {
            lower: queryParams.zoomedLower,
            upper: queryParams.zoomedUpper
        };
        let validatedTimeRange = (0, $78d6d6f4dd3e1375$export$aa559e1d0c17b644)(timeRangeFromQueries);
        if (!validatedTimeRange.lower) {
            const dashboardTimeRange = dashTimeV1.ranges.find((r)=>r.dashboardID === dashboardID);
            validatedTimeRange = dashboardTimeRange || (0, $6a7b0ae94f8ec28f$export$350d83d6c59c55f7);
            if (timeRangeFromQueries.lower || timeRangeFromQueries.upper) dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$75fdca74441258b3)()));
        }
        dispatch($9859d1d8ae3f2524$export$25a740f44c90929f(dashboardID, validatedTimeRange));
        const validatedZoomedTimeRange = (0, $78d6d6f4dd3e1375$export$3689c506c97120a7)(zoomedTimeRangeFromQueries);
        if (!validatedZoomedTimeRange.lower && (queryParams.zoomedLower || queryParams.zoomedUpper)) dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$fddb310f4b93f987)()));
        dispatch($9859d1d8ae3f2524$export$4c0bf62335ec7f62(validatedZoomedTimeRange));
        const updatedQueryParams = {
            lower: validatedTimeRange.lower,
            upper: validatedTimeRange.upper,
            zoomedLower: validatedZoomedTimeRange.lower,
            zoomedUpper: validatedZoomedTimeRange.upper
        };
        dispatch($9859d1d8ae3f2524$export$92377f461a797888(updatedQueryParams));
    };
const $9859d1d8ae3f2524$export$ec042ffaea15d906 = (dashboardId, source, sources)=>async (dispatch)=>{
        let dashboard;
        try {
            dashboard = await (0, $2adafb01fdaabc72$export$f3fe8eb89c757086)(dashboardId);
        } catch  {
            dispatch((0, $14b9f70b6017fdee$exports.replace)(`/sources/${source.id}/dashboards`));
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$296a221b193442a3)(dashboardId)));
            return;
        }
        const selections = (0, $258ff394ebf672be$export$6aa6378c517e89f1)();
        const templates = await (0, $7b6b69e6512d0c7d$export$29bb849e286afd7)(dashboard.templates, sources, {
            source: source,
            selections: selections
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).each(selections, (val, key)=>{
            const result = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).some(templates, (temp)=>temp.tempVar === key && (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).some(temp.values, (v)=>{
                    if (v.key) return v.key === val;
                    return v.value === val;
                }));
            if (!result) dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$7aa4f970ba4e5699)(key)));
        });
        dispatch($9859d1d8ae3f2524$export$3a75641b11dbce93({
            ...dashboard,
            templates: templates
        }));
        dispatch($9859d1d8ae3f2524$export$61a23c00684e4186(dashboardId));
        dispatch($9859d1d8ae3f2524$var$updateTimeRangeFromQueryParams(dashboardId));
    };
const $9859d1d8ae3f2524$export$bb40b898163aec67 = (dashboardId, source, sources)=>async (dispatch, getState)=>{
        const dashboard = $9859d1d8ae3f2524$var$getDashboard(getState(), dashboardId);
        const templates = await (0, $7b6b69e6512d0c7d$export$29bb849e286afd7)(dashboard.templates, sources, {
            source: source
        });
        dispatch($9859d1d8ae3f2524$export$2ae8a0240b0b88d9(templates));
        dispatch($9859d1d8ae3f2524$export$61a23c00684e4186(dashboardId));
    };
const $9859d1d8ae3f2524$export$61a23c00684e4186 = (dashboardId)=>(dispatch, getState)=>{
        const templates = $9859d1d8ae3f2524$var$getDashboard(getState(), dashboardId).templates;
        const updatedQueryParams = {
            tempVars: (0, $258ff394ebf672be$export$a836ba7527040c9f)(templates)
        };
        dispatch($9859d1d8ae3f2524$export$92377f461a797888(updatedQueryParams));
    };



const { lower: $636faddae325eded$var$lower, upper: $636faddae325eded$var$upper } = (0, $6a7b0ae94f8ec28f$export$9b55ef3c660cd071).find((tr)=>tr.lower === 'now() - 1h');
const $636faddae325eded$export$d4c72bab9d6cc13a = {
    dashboards: [],
    timeRange: {
        lower: $636faddae325eded$var$lower,
        upper: $636faddae325eded$var$upper
    },
    zoomedTimeRange: {
        lower: null,
        upper: null
    },
    isEditMode: false,
    cellQueryStatuses: {},
    hoverTime: (0, $93a523326aa94673$export$f248303b5fb71ab5),
    activeCellID: ''
};
var $636faddae325eded$export$2e2bcd8739ae039 = (state = $636faddae325eded$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case (0, $9859d1d8ae3f2524$export$e4a712fff93fb00f).LoadDashboards:
            {
                const { dashboards: dashboards } = action.payload;
                const newState = {
                    dashboards: dashboards
                };
                return {
                    ...state,
                    ...newState,
                    cellQueryStatuses: {}
                };
            }
        case (0, $9859d1d8ae3f2524$export$e4a712fff93fb00f).LoadDashboard:
            {
                const { dashboard: dashboard } = action.payload;
                const newDashboards = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).unionBy([
                    dashboard
                ], state.dashboards, 'id');
                return {
                    ...state,
                    dashboards: newDashboards,
                    cellQueryStatuses: {}
                };
            }
        case (0, $9859d1d8ae3f2524$export$e4a712fff93fb00f).SetDashboardTimeRange:
            {
                const { timeRange: timeRange } = action.payload;
                return {
                    ...state,
                    timeRange: timeRange
                };
            }
        case (0, $9859d1d8ae3f2524$export$e4a712fff93fb00f).SetDashboardZoomedTimeRange:
            {
                const { zoomedTimeRange: zoomedTimeRange } = action.payload;
                return {
                    ...state,
                    zoomedTimeRange: zoomedTimeRange
                };
            }
        case (0, $9859d1d8ae3f2524$export$e4a712fff93fb00f).UpdateDashboard:
            {
                const { dashboard: dashboard } = action.payload;
                const newState = {
                    dashboards: state.dashboards.map((d)=>d.id === dashboard.id ? dashboard : d)
                };
                return {
                    ...state,
                    ...newState
                };
            }
        case (0, $9859d1d8ae3f2524$export$e4a712fff93fb00f).CreateDashboard:
            {
                const { dashboard: dashboard } = action.payload;
                const newState = {
                    dashboards: [
                        ...state.dashboards,
                        dashboard
                    ]
                };
                return {
                    ...state,
                    ...newState
                };
            }
        case (0, $9859d1d8ae3f2524$export$e4a712fff93fb00f).DeleteDashboard:
            {
                const { dashboard: dashboard } = action.payload;
                const newState = {
                    dashboards: state.dashboards.filter((d)=>d.id !== dashboard.id)
                };
                return {
                    ...state,
                    ...newState
                };
            }
        case (0, $9859d1d8ae3f2524$export$e4a712fff93fb00f).DeleteDashboardFailed:
            {
                const { dashboard: dashboard } = action.payload;
                const newState = {
                    dashboards: [
                        (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).cloneDeep(dashboard),
                        ...state.dashboards
                    ]
                };
                return {
                    ...state,
                    ...newState
                };
            }
        case (0, $9859d1d8ae3f2524$export$e4a712fff93fb00f).AddDashboardCell:
            {
                const { cell: cell, dashboard: dashboard } = action.payload;
                const { dashboards: dashboards } = state;
                const newCells = [
                    cell,
                    ...dashboard.cells
                ];
                const newDashboard = {
                    ...dashboard,
                    cells: newCells
                };
                const newDashboards = dashboards.map((d)=>d.id === dashboard.id ? newDashboard : d);
                const newState = {
                    dashboards: newDashboards
                };
                return {
                    ...state,
                    ...newState
                };
            }
        case (0, $9859d1d8ae3f2524$export$e4a712fff93fb00f).DeleteDashboardCell:
            {
                const { dashboard: dashboard, cell: cell } = action.payload;
                const newCells = dashboard.cells.filter((c)=>!(c.x === cell.x && c.y === cell.y));
                const newDashboard = {
                    ...dashboard,
                    cells: newCells
                };
                const newState = {
                    dashboards: state.dashboards.map((d)=>d.id === dashboard.id ? newDashboard : d)
                };
                return {
                    ...state,
                    ...newState
                };
            }
        case (0, $9859d1d8ae3f2524$export$e4a712fff93fb00f).SyncDashboardCell:
            {
                const { cell: cell, dashboard: dashboard } = action.payload;
                const newDashboard = {
                    ...dashboard,
                    cells: dashboard.cells.map((c)=>c.x === cell.x && c.y === cell.y ? cell : c)
                };
                const newState = {
                    dashboards: state.dashboards.map((d)=>d.id === dashboard.id ? newDashboard : d)
                };
                return {
                    ...state,
                    ...newState
                };
            }
        case (0, $9859d1d8ae3f2524$export$e4a712fff93fb00f).EditCellQueryStatus:
            {
                const { queryID: queryID, status: status } = action.payload;
                const { cellQueryStatuses: cellQueryStatuses } = state;
                return {
                    ...state,
                    cellQueryStatuses: {
                        ...cellQueryStatuses,
                        [queryID]: status
                    }
                };
            }
        case (0, $9859d1d8ae3f2524$export$e4a712fff93fb00f).TemplateVariableLocalSelected:
            {
                const { dashboardID: dashboardID, templateID: templateID, value: newValue } = action.payload;
                const dashboards = state.dashboards.map((dashboard)=>{
                    if (dashboard.id !== dashboardID) return dashboard;
                    const templates = dashboard.templates.map((template)=>{
                        if (template.id !== templateID) return template;
                        let values;
                        if (template.type === (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Text) values = [
                            newValue
                        ];
                        else values = template.values.map((value)=>{
                            const localSelected = value.value === newValue.value;
                            return {
                                ...value,
                                localSelected: localSelected
                            };
                        });
                        return {
                            ...template,
                            values: values
                        };
                    });
                    return {
                        ...dashboard,
                        templates: templates
                    };
                });
                return {
                    ...state,
                    dashboards: dashboards
                };
            }
        case (0, $9859d1d8ae3f2524$export$e4a712fff93fb00f).UpdateTemplates:
            {
                const { templates: updatedTemplates } = action.payload;
                const dashboards = state.dashboards.map((dashboard)=>{
                    const templates = dashboard.templates.reduce((acc, existingTemplate)=>{
                        const updatedTemplate = updatedTemplates.find((t)=>t.id === existingTemplate.id);
                        if (updatedTemplate) return [
                            ...acc,
                            updatedTemplate
                        ];
                        return [
                            ...acc,
                            existingTemplate
                        ];
                    }, []);
                    return {
                        ...dashboard,
                        templates: templates
                    };
                });
                return {
                    ...state,
                    dashboards: dashboards
                };
            }
        case (0, $9859d1d8ae3f2524$export$e4a712fff93fb00f).SetHoverTime:
            {
                const { hoverTime: hoverTime } = action.payload;
                return {
                    ...state,
                    hoverTime: hoverTime
                };
            }
        case (0, $9859d1d8ae3f2524$export$e4a712fff93fb00f).SetActiveCell:
            {
                const { activeCellID: activeCellID } = action.payload;
                return {
                    ...state,
                    activeCellID: activeCellID
                };
            }
    }
    return state;
};


// actions
// Types
var $0a1fef76cb2a2e9d$export$e4a712fff93fb00f = /*#__PURE__*/ function(ActionType) {
    ActionType["ClearCEO"] = "CLEAR_CEO";
    ActionType["UpdateEditorTimeRange"] = "UPDATE_EDITOR_TIME_RANGE";
    return ActionType;
}({});
const $0a1fef76cb2a2e9d$export$daf9b15f740d8268 = ()=>({
        type: "CLEAR_CEO"
    });


const $3eeac9af39b94eb2$export$d4c72bab9d6cc13a = {
    cell: null,
    timeRange: null
};
var $3eeac9af39b94eb2$export$2e2bcd8739ae039 = (state = $3eeac9af39b94eb2$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case (0, $0a1fef76cb2a2e9d$export$e4a712fff93fb00f).ClearCEO:
            {
                const cell = null;
                const timeRange = null;
                return {
                    ...state,
                    cell: cell,
                    timeRange: timeRange
                };
            }
        case (0, $0a1fef76cb2a2e9d$export$e4a712fff93fb00f).UpdateEditorTimeRange:
            {
                const { timeRange: timeRange } = action.payload;
                return {
                    ...state,
                    timeRange: timeRange
                };
            }
    }
    return state;
};



var $hBdgJ = parcelRequire("hBdgJ");

const $e503120c8c539704$var$initialState = {
    ranges: [],
    refreshes: []
};
var $e503120c8c539704$export$2e2bcd8739ae039 = (state = $e503120c8c539704$var$initialState, action)=>{
    switch(action.type){
        case (0, $9859d1d8ae3f2524$export$e4a712fff93fb00f).DeleteDashboard:
            {
                const { dashboard: dashboard } = action.payload;
                const ranges = state.ranges.filter((r)=>r.dashboardID !== dashboard.id);
                return {
                    ...state,
                    ranges: ranges
                };
            }
        case (0, $9859d1d8ae3f2524$export$e4a712fff93fb00f).RetainRangesDashboardTimeV1:
            {
                const { dashboardIDs: dashboardIDs } = action.payload;
                let dashboardIDsHash = {};
                if (Array.isArray(dashboardIDs)) dashboardIDsHash = dashboardIDs.reduce((accum, id)=>{
                    accum[id] = true;
                    return accum;
                }, dashboardIDsHash);
                const ranges = state.ranges.filter((r)=>dashboardIDsHash[r.dashboardID]);
                return {
                    ...state,
                    ranges: ranges
                };
            }
        case (0, $9859d1d8ae3f2524$export$e4a712fff93fb00f).RetainDashboardRefresh:
            {
                const { dashboardIDs: dashboardIDs } = action.payload;
                let dashboardIDsHash = {};
                if (Array.isArray(dashboardIDs)) dashboardIDsHash = dashboardIDs.reduce((accum, id)=>{
                    accum[id] = true;
                    return accum;
                }, dashboardIDsHash);
                const refreshes = state.refreshes.filter((r)=>dashboardIDsHash[r.dashboardID]);
                return {
                    ...state,
                    refreshes: refreshes
                };
            }
        case (0, $9859d1d8ae3f2524$export$e4a712fff93fb00f).SetDashboardTimeV1:
            {
                const { dashboardID: dashboardID, timeRange: timeRange } = action.payload;
                const newTimeRange = [
                    {
                        dashboardID: dashboardID,
                        ...timeRange
                    }
                ];
                const ranges = (0, $hBdgJ.unionBy)(newTimeRange, state.ranges, 'dashboardID');
                return {
                    ...state,
                    ranges: ranges
                };
            }
        case (0, $9859d1d8ae3f2524$export$e4a712fff93fb00f).SetDashboardRefresh:
            {
                const { dashboardID: dashboardID, refreshRate: refreshRate } = action.payload;
                const newRefresh = [
                    {
                        dashboardID: dashboardID,
                        refreshRate: refreshRate
                    }
                ];
                const refreshes = (0, $hBdgJ.unionBy)(newRefresh, state.refreshes, 'dashboardID');
                return {
                    ...state,
                    refreshes: refreshes
                };
            }
    }
    return state;
};



var $hBdgJ = parcelRequire("hBdgJ");

var $hBdgJ = parcelRequire("hBdgJ");
/* eslint-disable no-prototype-builtins */ 
var $hBdgJ = parcelRequire("hBdgJ");
const $e48655f528136ff4$var$dashtime = (ranges)=>{
    if (!Array.isArray(ranges)) return [];
    const normalized = ranges.filter((r)=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isObject(r)) return false;
        // check for presence of keys
        if (!r.hasOwnProperty('dashboardID') || !r.hasOwnProperty('lower') || !r.hasOwnProperty('upper')) return false;
        const { dashboardID: dashboardID, lower: lower, upper: upper } = r;
        if (!dashboardID || typeof dashboardID !== 'number') return false;
        if (!lower && !upper) return false;
        const isCorrectType = (bound)=>(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isString(bound) || (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isNull(bound) || (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isInteger(bound);
        if (!isCorrectType(lower) || !isCorrectType(upper)) return false;
        return true;
    });
    return normalized;
};
var $e48655f528136ff4$export$2e2bcd8739ae039 = $e48655f528136ff4$var$dashtime;



var $hBdgJ = parcelRequire("hBdgJ");
const $2b2d61853e686ac9$var$dashrefresh = (refreshes)=>{
    if (!Array.isArray(refreshes)) return [];
    const normalized = refreshes.filter((r)=>{
        if (!(0, $hBdgJ.isObject)(r)) return false;
        const { dashboardID: dashboardID, refreshRate: refreshRate } = r;
        const isTypeOfRefreshRate = !refreshRate || typeof refreshRate === 'number';
        if (typeof dashboardID !== 'number' || !isTypeOfRefreshRate) return false;
        return true;
    });
    return normalized;
};
var $2b2d61853e686ac9$export$2e2bcd8739ae039 = $2b2d61853e686ac9$var$dashrefresh;






const $92ae4c2e27237e7e$export$d3dfa491819f2d3c = (errorsQueue)=>{
    try {
        const serializedState = localStorage.getItem('state');
        const state = JSON.parse(serializedState) || {};
        const gitSHAChanged = state.GIT_SHA && state.GIT_SHA !== (0, $e10a8602f56394e3$export$de001b401bf3761b);
        const npmVersionChanged = state.VERSION && state.VERSION !== (0, $e10a8602f56394e3$export$a4ad2735b021c132);
        if (npmVersionChanged || gitSHAChanged || window.location.search === '?clearLocalStorage') {
            window.localStorage.removeItem('state');
            if (npmVersionChanged) errorsQueue.push((0, $ec1f42de4faacc37$export$c04f76a93c206811)((0, $e10a8602f56394e3$export$a4ad2735b021c132)));
            // eslint-disable-next-line no-console
            console.debug('Cleared Chronograf localStorage state');
            return {};
        }
        delete state.VERSION;
        delete state.GIT_SHA;
        state.adminInfluxDB = {
            ...(0, $eed4757442137a56$export$d4c72bab9d6cc13a),
            ...state.adminInfluxDB
        };
        return state;
    } catch (error) {
        console.error((0, $ec1f42de4faacc37$export$ea869160ecd863dc)(error).message);
        errorsQueue.push((0, $ec1f42de4faacc37$export$ea869160ecd863dc)(error));
        return {};
    }
};
const $92ae4c2e27237e7e$export$1b8cd2d0ef9a8e5d = ({ app: app, timeRange: timeRange, dashTimeV1: { ranges: ranges, refreshes: refreshes }, logs: logs, script: script, adminInfluxDB: { showUsers: showUsers, showRoles: showRoles } })=>{
    try {
        const dashTimeV1 = {
            ranges: (0, $e48655f528136ff4$export$2e2bcd8739ae039)(ranges),
            refreshes: (0, $2b2d61853e686ac9$export$2e2bcd8739ae039)(refreshes)
        };
        const minimalLogs = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).omit(logs, [
            'tableData',
            'histogramData',
            'queryCount',
            'tableInfiniteData',
            'newRowsAdded',
            'searchStatus',
            'queryCount',
            'nextOlderUpperBound',
            'nextOlderLowerBound',
            'nextNewerUpperBound',
            'nextNewerLowerBound',
            'currentTailUpperBound',
            'nextTailLowerBound',
            'tailChunkDurationMs',
            'olderChunkDurationMs',
            'newerChunkDurationMs'
        ]);
        window.localStorage.setItem('state', JSON.stringify({
            app: {
                ...app,
                persisted: app.persisted
            },
            VERSION: $e10a8602f56394e3$export$a4ad2735b021c132,
            GIT_SHA: $e10a8602f56394e3$export$de001b401bf3761b,
            timeRange: timeRange,
            dashTimeV1: dashTimeV1,
            script: script,
            logs: {
                ...minimalLogs,
                histogramData: [],
                tableData: {},
                queryCount: 0,
                tableInfiniteData: {
                    forward: (0, $17fe399301a568db$export$5c00ad534c3ef603),
                    backward: (0, $17fe399301a568db$export$5c00ad534c3ef603)
                },
                tableTime: minimalLogs.tableTime || {}
            },
            adminInfluxDB: {
                showRoles: showRoles,
                showUsers: showUsers
            }
        }));
    } catch (err) {
        console.error('Unable to save data explorer: ', JSON.parse(err));
    }
};


function $1747d4293ff586be$export$2e2bcd8739ae039() {
    return (next)=>(reducer, initialState, enhancer)=>{
            const store = next(reducer, initialState, enhancer);
            const throttleMs = 1000;
            store.subscribe((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).throttle(()=>{
                (0, $92ae4c2e27237e7e$export$1b8cd2d0ef9a8e5d)(store.getState());
            }, throttleMs));
            return store;
        };
}


const $41ffc5470ced2371$export$d4c72bab9d6cc13a = [];
const $41ffc5470ced2371$var$servicesReducer = (state = $41ffc5470ced2371$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 'LOAD_SERVICES':
            return action.payload.services;
        case 'ADD_SERVICE':
            {
                const { service: service } = action.payload;
                return [
                    ...state,
                    service
                ];
            }
        case 'DELETE_SERVICE':
            {
                const { service: service } = action.payload;
                const services = state.filter((s)=>s.id !== service.id);
                return services;
            }
        case 'UPDATE_SERVICE':
            {
                const { service: service } = action.payload;
                const newState = state.map((s)=>{
                    if (s.id === service.id) return {
                        ...s,
                        ...service
                    };
                    return {
                        ...s
                    };
                });
                return newState;
            }
        case 'SET_ACTIVE_SERVICE':
            {
                const { source: source, service: service } = action.payload;
                let otherServices = [];
                const currentServices = state.filter((s)=>{
                    if (s.sourceID !== source.id) otherServices = [
                        ...otherServices,
                        s
                    ];
                    return s.sourceID === source.id;
                });
                const updatedServices = currentServices.map((s)=>{
                    if (s.sourceID === source.id) {
                        const metadata = {
                            active: s.id === service.id
                        };
                        s.metadata = metadata;
                        return s;
                    }
                });
                return [
                    ...otherServices,
                    ...updatedServices
                ];
            }
    }
    return state;
};
var $41ffc5470ced2371$export$2e2bcd8739ae039 = $41ffc5470ced2371$var$servicesReducer;





const $5ec1f1185c4ee201$export$d4c72bab9d6cc13a = {
    selectedBucket: '',
    buckets: [],
    status: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).NotStarted,
    searchTerm: ''
};
const $5ec1f1185c4ee201$var$bucketsReducer = (state = $5ec1f1185c4ee201$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 'FQB_BUCKETS_SEARCH_TERM':
            return {
                ...state,
                searchTerm: action.payload.term
            };
        case 'FQB_BUCKETS_SELECT':
            return {
                ...state,
                selectedBucket: action.payload.bucket
            };
        case 'FQB_BUCKETS_STATUS':
            return {
                ...state,
                status: action.payload.status
            };
        case 'FQB_BUCKETS_BUCKETS':
            return {
                ...state,
                buckets: action.payload.buckets
            };
    }
    return state;
};
var $5ec1f1185c4ee201$export$2e2bcd8739ae039 = $5ec1f1185c4ee201$var$bucketsReducer;


const $4d8b66f6adad74a3$export$3eff6d3d8f7c566 = 'auto';
const $4d8b66f6adad74a3$export$3341b722787e1f7a = 'none';
const $4d8b66f6adad74a3$export$1a599877262ec172 = false;
const $4d8b66f6adad74a3$export$4c43b8c2d41caaf5 = 'mean';
const $4d8b66f6adad74a3$export$74f6a832d246e098 = [
    '5s',
    '15s',
    '1m',
    '5m',
    '15m',
    '1h',
    '6h',
    '12h',
    '24h',
    '2d',
    '7d',
    '30d'
];
const $4d8b66f6adad74a3$export$4c6ea7847599cc12 = (func, period = $4d8b66f6adad74a3$export$3341b722787e1f7a, fillValues = false)=>{
    if (period === $4d8b66f6adad74a3$export$3341b722787e1f7a) return `|> ${func}()`;
    switch(func){
        case 'derivative':
            return `|> derivative(unit: 1s, nonNegative: false)`;
        case 'nonnegative derivative':
            return `|> derivative(unit: 1s, nonNegative: true)`;
        case 'median':
        case 'mean':
        case 'max':
        case 'min':
        case 'sum':
        case 'stddev':
        case 'first':
        case 'last':
            return `|> aggregateWindow(every: ${period}, fn: ${func}, createEmpty: ${fillValues})`;
        default:
            return `|> ${func}()`;
    }
};
const $4d8b66f6adad74a3$export$bf81023080f51390 = [
    {
        name: 'mean',
        flux: (period, fillValues)=>$4d8b66f6adad74a3$export$4c6ea7847599cc12('mean', period, fillValues)
    },
    {
        name: 'median',
        flux: (period, fillValues)=>$4d8b66f6adad74a3$export$4c6ea7847599cc12('median', period, fillValues)
    },
    {
        name: 'last',
        flux: (period, fillValues)=>$4d8b66f6adad74a3$export$4c6ea7847599cc12('last', period, fillValues)
    }
];
const $4d8b66f6adad74a3$export$599f8541cd7f6f57 = [
    $4d8b66f6adad74a3$export$bf81023080f51390[0],
    $4d8b66f6adad74a3$export$bf81023080f51390[1],
    {
        name: 'max',
        flux: (period, fillValues)=>$4d8b66f6adad74a3$export$4c6ea7847599cc12('max', period, fillValues)
    },
    {
        name: 'min',
        flux: (period, fillValues)=>$4d8b66f6adad74a3$export$4c6ea7847599cc12('min', period, fillValues)
    },
    {
        name: 'sum',
        flux: (period, fillValues)=>$4d8b66f6adad74a3$export$4c6ea7847599cc12('sum', period, fillValues)
    },
    {
        name: 'derivative',
        flux: (period, fillValues)=>$4d8b66f6adad74a3$export$4c6ea7847599cc12('derivative', period, fillValues)
    },
    {
        name: 'nonnegative derivative',
        flux: (period, fillValues)=>$4d8b66f6adad74a3$export$4c6ea7847599cc12('nonnegative derivative', period, fillValues)
    },
    {
        name: 'distinct',
        flux: (period, fillValues)=>$4d8b66f6adad74a3$export$4c6ea7847599cc12('distinct', period, fillValues)
    },
    {
        name: 'count',
        flux: (period, fillValues)=>$4d8b66f6adad74a3$export$4c6ea7847599cc12('count', period, fillValues)
    },
    {
        name: 'increase',
        flux: (period, fillValues)=>$4d8b66f6adad74a3$export$4c6ea7847599cc12('increase', period, fillValues)
    },
    {
        name: 'skew',
        flux: (period, fillValues)=>$4d8b66f6adad74a3$export$4c6ea7847599cc12('skew', period, fillValues)
    },
    {
        name: 'spread',
        flux: (period, fillValues)=>$4d8b66f6adad74a3$export$4c6ea7847599cc12('spread', period, fillValues)
    },
    {
        name: 'stddev',
        flux: (period, fillValues)=>$4d8b66f6adad74a3$export$4c6ea7847599cc12('stddev', period, fillValues)
    },
    {
        name: 'first',
        flux: (period, fillValues)=>$4d8b66f6adad74a3$export$4c6ea7847599cc12('first', period, fillValues)
    },
    $4d8b66f6adad74a3$export$bf81023080f51390[2],
    {
        name: 'unique',
        flux: (period, fillValues)=>$4d8b66f6adad74a3$export$4c6ea7847599cc12('unique', period, fillValues)
    },
    {
        name: 'sort',
        flux: (period, fillValues)=>$4d8b66f6adad74a3$export$4c6ea7847599cc12('sort', period, fillValues)
    }
];
const $4d8b66f6adad74a3$export$42db895a6297a476 = $4d8b66f6adad74a3$export$599f8541cd7f6f57.map((f)=>f.name);


const $5571c3798985cc89$export$d4c72bab9d6cc13a = {
    fillMissing: false,
    period: (0, $4d8b66f6adad74a3$export$3eff6d3d8f7c566),
    selectedFunctions: [
        'mean'
    ]
};
const $5571c3798985cc89$var$aggregationReducer = (state = $5571c3798985cc89$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 'FQB_AGG_FILL_MISSING':
            return {
                ...state,
                fillMissing: action.payload.fillMissing
            };
        case 'FQB_AGG_PERIOD':
            return {
                ...state,
                period: action.payload.period
            };
        case 'FQB_AGG_SELECTED_FNS':
            return {
                ...state,
                selectedFunctions: action.payload.functions
            };
    }
    return state;
};
var $5571c3798985cc89$export$2e2bcd8739ae039 = $5571c3798985cc89$var$aggregationReducer;



// APIs
// Types

// the following constants were taken from v2 UI
const $d0723b176055474a$var$FLUX_RESPONSE_BYTES_LIMIT = 28311552;
const $d0723b176055474a$var$RATE_LIMIT_ERROR_STATUS = 429;
const $d0723b176055474a$var$RATE_LIMIT_ERROR_TEXT = 'Oops. It looks like you have exceeded the query limits allowed as part of your plan. If you would like to increase your query limits, reach out to support@influxdata.com.';
class $d0723b176055474a$export$5db8ebadb53b7f77 extends Error {
    constructor(retryAfter){
        super($d0723b176055474a$var$RATE_LIMIT_ERROR_TEXT);
        this.retryAfter = retryAfter;
        this.name = 'RateLimitError';
    }
}
class $d0723b176055474a$export$65bd6083489bd8bb extends Error {
    constructor(message, code){
        super(message);
        this.code = code;
        this.name = 'HttpError';
    }
}
const $d0723b176055474a$export$1b084def02c50fa0 = (source, query, abortController = new AbortController())=>{
    const path = encodeURIComponent(`/api/v2/query?organization=defaultorgname`);
    const url = `${window.basepath}${source.links.flux}?version=${source.version}&path=${path}`;
    const dialect = {
        annotations: [
            'group',
            'datatype',
            'default'
        ]
    };
    const headers = {
        'Content-Type': 'application/json',
        'Accept-Encoding': 'gzip',
        'X-Requested-With': 'XMLHttpRequest'
    };
    const request = fetch(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
            query: query,
            dialect: dialect
        }),
        signal: abortController.signal
    });
    const promise = request.then($d0723b176055474a$export$21fcb6cfd5628534).catch((e)=>e.name === 'AbortError' ? Promise.reject(new (0, $d96f38380b9b4c62$export$63884d8ee23c8f42)()) : Promise.reject(e));
    return {
        promise: promise,
        cancel: ()=>abortController.abort()
    };
};
const $d0723b176055474a$export$21fcb6cfd5628534 = async (response)=>{
    switch(response.status){
        case 200:
            return $d0723b176055474a$var$processSuccessResponse(response);
        case $d0723b176055474a$var$RATE_LIMIT_ERROR_STATUS:
            $d0723b176055474a$var$throwRateLimitError(response);
            break;
        default:
            $d0723b176055474a$var$throwError(response);
    }
};
const $d0723b176055474a$var$processSuccessResponse = async (response)=>{
    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let csv = '';
    let bytesRead = 0;
    let didTruncate = false;
    let read = await reader.read();
    while(!read.done){
        const text = decoder.decode(read.value);
        bytesRead += read.value.byteLength;
        if (bytesRead > $d0723b176055474a$var$FLUX_RESPONSE_BYTES_LIMIT) {
            csv += $d0723b176055474a$var$trimPartialLines(text);
            didTruncate = true;
            break;
        } else {
            csv += text;
            read = await reader.read();
        }
    }
    reader.cancel();
    return {
        csv: csv,
        bytesRead: bytesRead,
        didTruncate: didTruncate
    };
};
const $d0723b176055474a$var$throwRateLimitError = (response)=>{
    const retryAfter = response.headers.get('Retry-After');
    throw new $d0723b176055474a$export$5db8ebadb53b7f77(retryAfter !== null ? parseInt(retryAfter, 10) : null);
};
const $d0723b176055474a$var$throwError = async (response)=>{
    try {
        const body = await response.text();
        const json = JSON.parse(body);
        const message = json.message || json.error;
        const code = json.code;
        throw new $d0723b176055474a$export$65bd6083489bd8bb(message, code);
    } catch  {
        let message = 'Failed to execute Flux query';
        if (response.statusText) message += ': ' + response.statusText;
        throw new $d0723b176055474a$export$65bd6083489bd8bb(message, response.status);
    }
};
/*
  Given an arbitrary text chunk of a Flux CSV, trim partial lines off of the end
  of the text.

  For example, given the following partial Flux response,

            r,baz,3
      foo,bar,baz,2
      foo,bar,b

  we want to trim the last incomplete line, so that the result is

            r,baz,3
      foo,bar,baz,2

*/ const $d0723b176055474a$var$trimPartialLines = (partialResp)=>{
    let i = partialResp.length - 1;
    while(partialResp[i] !== '\n'){
        if (i <= 0) return partialResp;
        i -= 1;
    }
    return partialResp.slice(0, i + 1);
};



const $20f55d6bf1566b03$var$FLUX_ESCAPE = {
    '\r': '\\r',
    '\n': '\\n',
    '\t': '\\t',
    '"': '\\"',
    '\\': '\\\\',
    '${': '\\${'
};
function $20f55d6bf1566b03$export$2e2bcd8739ae039(s) {
    return `"${s.replace(/\r|\n|\t|"|\\|\$\{/g, (x)=>$20f55d6bf1566b03$var$FLUX_ESCAPE[x])}"`;
}



function $d61eb6bd66956357$export$280c21bfbdbf1397(tag) {
    return tag.tagValues.map((value)=>`r[${(0, $20f55d6bf1566b03$export$2e2bcd8739ae039)(tag.tagKey)}] == ${(0, $20f55d6bf1566b03$export$2e2bcd8739ae039)(value)}`).join(' or ');
}
function $d61eb6bd66956357$export$d7b58f10109feb02(state) {
    const bucket = state.buckets.selectedBucket;
    if (!bucket) return;
    let query = `from(bucket: ${(0, $20f55d6bf1566b03$export$2e2bcd8739ae039)(bucket)})`;
    query += '\n  |> range(start: v.timeRangeStart, stop: v.timeRangeStop)';
    state.tags.forEach((tag)=>{
        query += $d61eb6bd66956357$var$formatTagSelectorFilter(tag);
    });
    const functions = state.aggregation.selectedFunctions;
    if (functions.length === 0) return query;
    const period = state.aggregation.period;
    const fillMissing = state.aggregation.fillMissing;
    return functions.map((fn)=>query + $d61eb6bd66956357$var$formatAggregationFunction(fn, period, fillMissing)).join('\n\n');
}
function $d61eb6bd66956357$var$formatTagSelectorFilter(tag) {
    if (!tag.tagKey) return '';
    if (tag.aggregateFunctionType === 'filter') {
        if (!tag.tagValues.length) return '';
        return `\n  |> filter(fn: (r) => ${$d61eb6bd66956357$export$280c21bfbdbf1397(tag)})`;
    }
    if (tag.aggregateFunctionType === 'group') {
        if (!tag.tagValues?.length) return '' // do not group when no values selected
        ;
        return `\n  |> group(columns: [${tag.tagValues.map((x)=>(0, $20f55d6bf1566b03$export$2e2bcd8739ae039)(x)).join(', ')}])`;
    }
}
function $d61eb6bd66956357$var$formatAggregationFunction(fn, period, fillValues) {
    const fnSpec = (0, $4d8b66f6adad74a3$export$599f8541cd7f6f57).find((spec)=>spec.name === fn);
    if (!fnSpec) return `\n  |> yield(name: "${fn}")`;
    return `\n  ${fnSpec.flux($d61eb6bd66956357$var$formatPeriod(period), fillValues)}\n  |> yield(name: "${fn}")`;
}
const $d61eb6bd66956357$var$formatPeriod = (period)=>{
    if (period === (0, $4d8b66f6adad74a3$export$3eff6d3d8f7c566) || !period) return `v.windowPeriod`;
    return period;
};



function $a9c01ddfa0a1c3ae$export$2e2bcd8739ae039(timeRange) {
    const start = timeRange.lowerFlux ? timeRange.lowerFlux : timeRange.lower;
    return timeRange.upper && timeRange.upper !== 'now()' ? `start: ${start}, stop: ${timeRange.upper}` : `start: ${start}`;
}


const $afe396ec0883bd0e$var$DEFAULT_TIME_RANGE = {
    lower: 'now() - 30d',
    lowerFlux: '-30d'
};
const $afe396ec0883bd0e$export$a9aff4ddd6ec631a = 200;
function $afe396ec0883bd0e$export$10fe5cbd6698f9ce(source, { limit: limit }) {
    const query = `buckets()
  |> sort(columns: ["name"])${limit > 0 ? ` |> limit(n: ${limit})` : ''}`;
    return $afe396ec0883bd0e$var$extractBoxedCol((0, $d0723b176055474a$export$1b084def02c50fa0)(source, query), 'name', limit);
}
function $afe396ec0883bd0e$export$8382f3d8ef168792({ source: source, bucket: bucket, tagsSelections: tagsSelections, searchTerm: searchTerm = '', timeRange: timeRange = $afe396ec0883bd0e$var$DEFAULT_TIME_RANGE, limit: limit = $afe396ec0883bd0e$export$a9aff4ddd6ec631a }) {
    const tagFilter = $afe396ec0883bd0e$export$9d0233b9326d3c87(tagsSelections);
    const previousKeyFilter = $afe396ec0883bd0e$export$da99437729d89331(tagsSelections);
    const timeRangeArguments = (0, $a9c01ddfa0a1c3ae$export$2e2bcd8739ae039)(timeRange);
    // requires Flux package to work which we will put in the query
    const searchFilter = !searchTerm ? '' : `\n  |> filter(fn: (r) => r._value =~ regexp.compile(v: "(?i:" + regexp.quoteMeta(v: "${searchTerm}") + ")"))`;
    const query = `import "regexp"
  
from(bucket: "${bucket}")
  |> range(${timeRangeArguments})${tagFilter}
  |> keys()
  |> keep(columns: ["_value"])
  |> distinct()${searchFilter}${previousKeyFilter}
  |> filter(fn: (r) => r._value != "_time" and r._value != "_start" and r._value !=  "_stop" and r._value != "_value")
  |> sort()
  |> limit(n: ${limit})`;
    return $afe396ec0883bd0e$var$extractBoxedCol((0, $d0723b176055474a$export$1b084def02c50fa0)(source, query), '_value', limit);
}
function $afe396ec0883bd0e$export$17650c32b95a08ef(searchTerm, dbVersion, tagsSelections, bucket, timeRangeArguments, tagFilter, key, limit) {
    // requires Flux package to work which we will put in the query
    const searchFilter = !searchTerm ? '' : `\n  |> filter(fn: (r) => r._value =~ regexp.compile(v: "(?i:" + regexp.quoteMeta(v: ${(0, $20f55d6bf1566b03$export$2e2bcd8739ae039)(searchTerm)}) + ")"))`;
    // 1.x InfluxDB produce wrong results when _field tag is filtered,
    // experiments showed that keeping an extra column is a workaround
    const version = dbVersion || '';
    const v1ExtraKeep = (version.startsWith('1.') || version === 'ENT') && tagsSelections.some((x)=>x.tagKey === '_field' && x.tagValues?.length) ? ', "_field"' : '';
    const query = `import "regexp"
  
from(bucket: ${(0, $20f55d6bf1566b03$export$2e2bcd8739ae039)(bucket)})
  |> range(${timeRangeArguments})${tagFilter}
  |> keep(columns: [${(0, $20f55d6bf1566b03$export$2e2bcd8739ae039)(key)}${v1ExtraKeep}])
  |> group()
  |> distinct(column: ${(0, $20f55d6bf1566b03$export$2e2bcd8739ae039)(key)})${searchFilter}
  |> sort()
  |> limit(n: ${limit})`;
    return query;
}
function $afe396ec0883bd0e$export$a8f1a400fa0f8036({ source: source, bucket: bucket, tagsSelections: tagsSelections, key: key, searchTerm: searchTerm = '', timeRange: timeRange = $afe396ec0883bd0e$var$DEFAULT_TIME_RANGE, limit: limit = $afe396ec0883bd0e$export$a9aff4ddd6ec631a }) {
    const tagFilter = $afe396ec0883bd0e$export$9d0233b9326d3c87(tagsSelections);
    const timeRangeArguments = (0, $a9c01ddfa0a1c3ae$export$2e2bcd8739ae039)(timeRange);
    const query = $afe396ec0883bd0e$export$17650c32b95a08ef(searchTerm, source.version, tagsSelections, bucket, timeRangeArguments, tagFilter, key, limit);
    return $afe396ec0883bd0e$var$extractBoxedCol((0, $d0723b176055474a$export$1b084def02c50fa0)(source, query), '_value', limit);
}
function $afe396ec0883bd0e$var$extractBoxedCol(resp, colName, limit) {
    const promise = resp.promise.then(({ csv: csv })=>{
        const result = $afe396ec0883bd0e$var$extractCol(csv, colName);
        return {
            result: result,
            truncated: result.length === limit
        };
    });
    return {
        promise: promise,
        cancel: resp.cancel
    };
}
function $afe396ec0883bd0e$var$extractCol(csv, colName) {
    const tables = (0, $c6606ad17445cd52$export$ba14d9a5a581e827)(csv);
    if (tables && tables.length > 0) {
        const data = tables[0].data;
        if (data.length > 1) {
            const columnIndex = data[0].indexOf(colName);
            if (columnIndex > 0) return data.slice(1).map((arr)=>arr[columnIndex]);
        }
    }
    return [];
}
function $afe396ec0883bd0e$export$9d0233b9326d3c87(tagsSelections) {
    const validSelections = tagsSelections.filter(({ tagKey: tagKey, tagValues: tagValues })=>tagKey && tagValues.length);
    if (!validSelections.length) return '';
    const body = validSelections.map((tag)=>`(${(0, $d61eb6bd66956357$export$280c21bfbdbf1397)(tag)})`).join(' and ');
    return `\n  |> filter(fn: (r) => ${body})`;
}
function $afe396ec0883bd0e$export$da99437729d89331(tagsSelections) {
    const keys = tagsSelections.map(({ tagKey: key })=>key);
    if (!keys.length) return '';
    const fnBody = keys.map((key)=>`r._value != ${(0, $20f55d6bf1566b03$export$2e2bcd8739ae039)(key)}`).join(' and ');
    return `\n  |> filter(fn: (r) => ${fnBody})`;
}


const $a73d077aba14c3ad$export$d4c72bab9d6cc13a = [];
function $a73d077aba14c3ad$export$815031b683b331f5(tagIndex = 0, aggregateFunctionType = 'filter') {
    return {
        tagIndex: tagIndex,
        aggregateFunctionType: aggregateFunctionType,
        keys: [],
        keysSearchTerm: '',
        keysStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).NotStarted,
        keysTruncated: false,
        keysLimit: (0, $afe396ec0883bd0e$export$a9aff4ddd6ec631a),
        tagKey: '',
        values: [],
        valuesSearchTerm: '',
        valuesStatus: undefined,
        valuesTruncated: false,
        tagValues: [],
        valuesLimit: (0, $afe396ec0883bd0e$export$a9aff4ddd6ec631a)
    };
}
function $a73d077aba14c3ad$var$changeTagSelector(state, tagIndex, fn) {
    if (state[tagIndex]) {
        state = [
            ...state
        ];
        state[tagIndex] = {
            ...state[tagIndex],
            ...fn(state[tagIndex], tagIndex)
        };
    }
    return state;
}
const $a73d077aba14c3ad$var$aggregationReducer = (state = $a73d077aba14c3ad$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 'FQB_TAG_ADD':
            return [
                ...state,
                $a73d077aba14c3ad$export$815031b683b331f5(state.length)
            ];
        case 'FQB_TAG_RESET':
            return [
                $a73d077aba14c3ad$export$815031b683b331f5(0, state.length ? state[0].aggregateFunctionType : 'filter')
            ];
        case 'FQB_TAG_REMOVE':
            {
                const id = action.payload.tagIndex;
                return state.filter(({ tagIndex: tagIndex })=>tagIndex !== id).map((tag, tagIndex)=>({
                        ...tag,
                        tagIndex: tagIndex
                    }));
            }
        case 'FQB_TAG_CHANGE_TYPE':
            return $a73d077aba14c3ad$var$changeTagSelector(state, action.payload.tagIndex, ()=>({
                    aggregateFunctionType: action.payload.type,
                    tagValues: [],
                    valuesSearchTerm: ''
                }));
        case 'FQB_TAG_CHANGE_KEY_SEARCHTERM':
            return $a73d077aba14c3ad$var$changeTagSelector(state, action.payload.tagIndex, ()=>({
                    keysSearchTerm: action.payload.term
                }));
        case 'FQB_TAG_CHANGE_VALUES_SEARCHTERM':
            return $a73d077aba14c3ad$var$changeTagSelector(state, action.payload.tagIndex, ()=>({
                    valuesSearchTerm: action.payload.term
                }));
        case 'FQB_TAG_INC_KEYS_LIMIT':
            return $a73d077aba14c3ad$var$changeTagSelector(state, action.payload.tagIndex, (tagState)=>({
                    keysLimit: (tagState.keysLimit || 0) + (0, $afe396ec0883bd0e$export$a9aff4ddd6ec631a)
                }));
        case 'FQB_TAG_SELECT_KEY':
            return $a73d077aba14c3ad$var$changeTagSelector(state, action.payload.tagIndex, ()=>({
                    tagKey: action.payload.key,
                    values: [],
                    aggregateFunctionType: 'filter'
                }));
        case 'FQB_TAG_SELECT_VALUES':
            return $a73d077aba14c3ad$var$changeTagSelector(state, action.payload.tagIndex, ()=>({
                    tagValues: action.payload.values
                }));
        case 'FQB_TAG_SEARCH_KEY':
            return $a73d077aba14c3ad$var$changeTagSelector(state, action.payload.tagIndex, ()=>({
                    keysStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading
                }));
        case 'FQB_TAG_SEARCH_VALUES':
            return $a73d077aba14c3ad$var$changeTagSelector(state, action.payload.tagIndex, ()=>({
                    valuesStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading
                }));
        case 'FQB_TAG_INC_VALUES_LIMIT':
            return $a73d077aba14c3ad$var$changeTagSelector(state, action.payload.tagIndex, (tagState)=>({
                    valuesLimit: (tagState.valuesLimit || 0) + (0, $afe396ec0883bd0e$export$a9aff4ddd6ec631a)
                }));
        case 'FQB_TAG_KEY_STATUS':
            {
                const { tagIndex: tagIndex, status: status } = action.payload;
                if (state[tagIndex] === undefined) return state;
                state = [
                    ...state
                ];
                state[tagIndex] = {
                    ...state[tagIndex],
                    keysStatus: status
                };
                if (status === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading) {
                    state[tagIndex].valuesStatus = (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).NotStarted;
                    for(let i = tagIndex + 1; i < state.length; i++)state[i] = {
                        ...state[i],
                        keysStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).NotStarted
                    };
                }
                return state;
            }
        case 'FQB_TAG_VALUES_STATUS':
            return $a73d077aba14c3ad$var$changeTagSelector(state, action.payload.tagIndex, ()=>({
                    valuesStatus: action.payload.status
                }));
        case 'FQB_TAG_KEYS':
            return $a73d077aba14c3ad$var$changeTagSelector(state, action.payload.tagIndex, ()=>({
                    keys: action.payload.keys,
                    keysStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done,
                    keysTruncated: action.payload.truncated
                }));
        case 'FQB_TAG_VALUES':
            return $a73d077aba14c3ad$var$changeTagSelector(state, action.payload.tagIndex, ()=>({
                    values: action.payload.values,
                    valuesStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done,
                    valuesTruncated: action.payload.truncated
                }));
    }
    return state;
};
var $a73d077aba14c3ad$export$2e2bcd8739ae039 = $a73d077aba14c3ad$var$aggregationReducer;


var $e3d6fdcc9e359d7f$export$2e2bcd8739ae039 = (0, $902b45bf0a1197fd$export$2e2bcd8739ae039)({
    buckets: $5ec1f1185c4ee201$export$2e2bcd8739ae039,
    aggregation: $5571c3798985cc89$export$2e2bcd8739ae039,
    tags: $a73d077aba14c3ad$export$2e2bcd8739ae039
});


const $2da2fd17d668b688$var$rootReducer = (0, $902b45bf0a1197fd$export$2e2bcd8739ae039)({
    ...(0, $20a2cb61bb5feba2$export$2e2bcd8739ae039),
    ...(0, $0e0e6c9ee2dc115a$export$2e2bcd8739ae039),
    ...(0, $c1151669d0d15f89$export$2e2bcd8739ae039),
    ...(0, $fb3cce5ac9be00b4$export$2e2bcd8739ae039),
    ...(0, $040ac1d542af6f2e$export$2e2bcd8739ae039),
    dashboardUI: $636faddae325eded$export$2e2bcd8739ae039,
    cellEditorOverlay: $3eeac9af39b94eb2$export$2e2bcd8739ae039,
    dashTimeV1: $e503120c8c539704$export$2e2bcd8739ae039,
    envReducer: $5e78f513e35bf10e$export$2e2bcd8739ae039,
    logs: (0, $0b515c6bb45d5887$export$2e2bcd8739ae039),
    routing: (0, $14b9f70b6017fdee$exports.routerReducer),
    services: (0, $41ffc5470ced2371$export$2e2bcd8739ae039),
    fluxQueryBuilder: $e3d6fdcc9e359d7f$export$2e2bcd8739ae039
});
const $2da2fd17d668b688$var$composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || (0, $4394fcf460bfdf47$export$2e2bcd8739ae039);
const $2da2fd17d668b688$var$KEY_ORG = 'orgchrono' // local storage key holding active organization
;
let $2da2fd17d668b688$var$currentOrg = '' // active organization, possibly empty or undefined
;
function $2da2fd17d668b688$export$2e2bcd8739ae039(initialState, browserHistory) {
    const routingMiddleware = (0, $14b9f70b6017fdee$exports.routerMiddleware)(browserHistory);
    const createPersistentStore = $2da2fd17d668b688$var$composeEnhancers((0, $1747d4293ff586be$export$2e2bcd8739ae039)(), (0, $786d69f2d9e5855c$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($acad2f8102dd4763$exports))), routingMiddleware, (0, $247e66be5535f58e$export$2e2bcd8739ae039), (0, $af5f7d05017ad785$export$baf9953bdab26da1), (0, $d8dda32060b145b0$export$758290ca160a9c16), $2da2fd17d668b688$var$signalizeChangedOrg))((0, $d28a9a1a347ffc66$export$2e2bcd8739ae039));
    // reload whenever current organization is changed from another tab/window
    try {
        $2da2fd17d668b688$var$currentOrg = window.localStorage.getItem($2da2fd17d668b688$var$KEY_ORG) || '';
        window.addEventListener('storage', function(e) {
            if (e.storageArea !== window.localStorage || e.key !== $2da2fd17d668b688$var$KEY_ORG) return;
            if (e.newValue !== $2da2fd17d668b688$var$currentOrg) // reload the page on organization change made from another tab
            window.location.reload();
        });
    } catch (e) {
        // ignore window.localStorage unavailability or getItem error
        console.error(e);
    }
    // https://github.com/elgerlambert/redux-localstorage/issues/42
    // createPersistantStore should ONLY take reducer and initialState
    // any store enhancers must be added to the compose() function.
    return createPersistentStore($2da2fd17d668b688$var$rootReducer, initialState);
}
/**
 * SignalizeChangedOrg is a redux middleware that
 * stores current organization ID into localStorage so that
 * browser windows/tabs can be notified about session change.
 */ const $2da2fd17d668b688$var$signalizeChangedOrg = ()=>(next)=>(action)=>{
            next(action);
            try {
                if (action.type === 'ME_GET_COMPLETED') {
                    const orgId = (0, $hBdgJ.get)(action, [
                        'payload',
                        'me',
                        'currentOrganization',
                        'id'
                    ], '');
                    if (orgId !== $2da2fd17d668b688$var$currentOrg) {
                        $2da2fd17d668b688$var$currentOrg = orgId;
                        window.localStorage.setItem($2da2fd17d668b688$var$KEY_ORG, $2da2fd17d668b688$var$currentOrg);
                    }
                }
                if (action.type === 'AUTH_EXPIRED') {
                    $2da2fd17d668b688$var$currentOrg = '';
                    window.localStorage.setItem($2da2fd17d668b688$var$KEY_ORG, $2da2fd17d668b688$var$currentOrg);
                }
            } catch (e) {
                // ignore window.localStorage unavailability or setItem errors
                console.error(e);
            }
        };






var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");

var $NdCUR = parcelRequire("NdCUR");



var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");



class $091cfcd49e339acd$var$Authorized extends (0, $NdCUR.Component) {
    UNSAFE_componentWillUpdate() {
        const { router: router, me: me } = this.props;
        if (me === null) router.push('/login');
    }
    render() {
        const { children: children, me: me, isUsingAuth: isUsingAuth, requiredRole: requiredRole, replaceWithIfNotAuthorized: replaceWithIfNotAuthorized, replaceWithIfNotUsingAuth: replaceWithIfNotUsingAuth, replaceWithIfAuthorized: replaceWithIfAuthorized, propsOverride: propsOverride } = this.props;
        if (me === null) return null;
        // if me response has not been received yet, render nothing
        if (typeof isUsingAuth !== 'boolean') return null;
        // React.isValidElement guards against multiple children wrapped by Authorized
        const firstChild = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).isValidElement(children) ? children : children[0];
        if (!isUsingAuth) return replaceWithIfNotUsingAuth || firstChild;
        if ((0, $a7910b1002260d34$export$7d499847c5200082)(me.role, requiredRole)) return replaceWithIfAuthorized || firstChild;
        if (propsOverride) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).cloneElement(firstChild, {
            ...propsOverride
        });
        return replaceWithIfNotAuthorized || null;
    }
}
const { bool: $091cfcd49e339acd$var$bool, node: $091cfcd49e339acd$var$node, shape: $091cfcd49e339acd$var$shape, string: $091cfcd49e339acd$var$string } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$091cfcd49e339acd$var$Authorized.propTypes = {
    isUsingAuth: $091cfcd49e339acd$var$bool,
    replaceWithIfNotUsingAuth: $091cfcd49e339acd$var$node,
    replaceWithIfAuthorized: $091cfcd49e339acd$var$node,
    replaceWithIfNotAuthorized: $091cfcd49e339acd$var$node,
    children: $091cfcd49e339acd$var$node.isRequired,
    router: $091cfcd49e339acd$var$shape().isRequired,
    me: $091cfcd49e339acd$var$shape({
        role: $091cfcd49e339acd$var$string
    }),
    requiredRole: $091cfcd49e339acd$var$string.isRequired,
    propsOverride: $091cfcd49e339acd$var$shape()
};
const $091cfcd49e339acd$var$mapStateToProps = ({ auth: { me: me, isUsingAuth: isUsingAuth } })=>({
        me: me,
        isUsingAuth: isUsingAuth
    });
var $091cfcd49e339acd$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($091cfcd49e339acd$var$mapStateToProps)((0, $dffbdf89c590a961$export$2e2bcd8739ae039)($091cfcd49e339acd$var$Authorized));


// Libraries

var $NdCUR = parcelRequire("NdCUR");

// Libraries

var $1v7mg = parcelRequire("1v7mg");

var $NdCUR = parcelRequire("NdCUR");

/*
tslint:disable no-console
tslint:disable max-classes-per-file
*/ /* eslint-disable @typescript-eslint/no-redundant-type-constituents */ 
var $NdCUR = parcelRequire("NdCUR");

class $855a64e5014f72b2$export$c73ca302efeda3b4 extends (0, $NdCUR.Component) {
    render() {
        const { error: error } = this.props;
        const { stack: stack, message: message } = error;
        const finalMessage = ` Chronograf (${(0, $e10a8602f56394e3$export$a4ad2735b021c132)}) ${message}`;
        const mdMarker = '```';
        const template = `

What browser are you using (name and version)?

What operating system are you using?

Please describe what you were trying to do when you encountered this error:

${mdMarker}
${stack}
${mdMarker}

    `;
        const href = encodeURI(`https://github.com/influxdata/chronograf/issues/new?title=${finalMessage}&body=${template}`);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", {
            className: "unexpected-error"
        }, "A Chronograf error has occurred. Please report the issue\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("a", {
            href: href
        }, "here"), ".");
    }
}
function $855a64e5014f72b2$export$54c2ee5106b5cb32(Error, alwaysDisplay = false) {
    return (base)=>{
        return class extends base {
            static get displayName() {
                return base.name;
            }
            componentDidCatch(err, info) {
                console.error(err);
                console.warn(info);
                this.error = true;
                this.err = err;
                this.forceUpdate();
            }
            render() {
                if (this.error || alwaysDisplay) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement(Error, {
                    error: this.err
                });
                return super.render();
            }
            constructor(...args){
                super(...args), this.error = false, this.err = null;
            }
        };
    };
}
const $855a64e5014f72b2$export$b648208ff1c161a7 = $855a64e5014f72b2$export$54c2ee5106b5cb32($855a64e5014f72b2$export$c73ca302efeda3b4);


class $15c437711711b56c$var$OrgLink extends (0, $NdCUR.PureComponent) {
    render() {
        const { role: role } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: this.className,
            onClick: this.handleChangeOrganization
        }, this.orgName, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("strong", null, "(", role.name, ")"));
    }
    get orgName() {
        const { me: me, role: role } = this.props;
        const org = me.organizations.find((o)=>o.id === role.organization);
        if (!org) return '';
        return org.name;
    }
    get isCurrentOrg() {
        const { me: me, role: role } = this.props;
        return me.currentOrganization.id === role.organization;
    }
    get className() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('sidebar-menu--item', {
            active: this.isCurrentOrg
        });
    }
    constructor(...args){
        super(...args), this.handleChangeOrganization = async ()=>{
            const { router: router, meLink: meLink, onMeChangeOrg: onMeChangeOrg, role: role } = this.props;
            try {
                await onMeChangeOrg(meLink, {
                    organization: role.organization
                });
                router.push('');
            } catch (error) {
                console.error(error);
            }
        };
    }
}
var $15c437711711b56c$export$2e2bcd8739ae039 = (0, $dffbdf89c590a961$export$2e2bcd8739ae039)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($15c437711711b56c$var$OrgLink));



var $hBdgJ = parcelRequire("hBdgJ");

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");
var $5c857c96f4e15ca9$exports = {};
'use strict';
Object.defineProperty($5c857c96f4e15ca9$exports, "__esModule", {
    value: true
});
$5c857c96f4e15ca9$exports.Scrollbars = undefined;
var $6064277e05de6a97$exports = {};
'use strict';
Object.defineProperty($6064277e05de6a97$exports, "__esModule", {
    value: true
});
var $6064277e05de6a97$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $6064277e05de6a97$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $b7825a1699a1f292$exports = {};
var $09c3b62c9634fa2b$exports = {};
// Generated by CoffeeScript 1.12.2
(function() {
    var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
    if (typeof performance !== "undefined" && performance !== null && performance.now) $09c3b62c9634fa2b$exports = function() {
        return performance.now();
    };
    else if (Date.now) {
        $09c3b62c9634fa2b$exports = function() {
            return Date.now() - loadTime;
        };
        loadTime = Date.now();
    } else {
        $09c3b62c9634fa2b$exports = function() {
            return new Date().getTime() - loadTime;
        };
        loadTime = new Date().getTime();
    }
}).call($09c3b62c9634fa2b$exports);


var $b7825a1699a1f292$var$root = typeof window === 'undefined' ? $parcel$global : window, $b7825a1699a1f292$var$vendors = [
    'moz',
    'webkit'
], $b7825a1699a1f292$var$suffix = 'AnimationFrame', $b7825a1699a1f292$var$raf = $b7825a1699a1f292$var$root['request' + $b7825a1699a1f292$var$suffix], $b7825a1699a1f292$var$caf = $b7825a1699a1f292$var$root['cancel' + $b7825a1699a1f292$var$suffix] || $b7825a1699a1f292$var$root['cancelRequest' + $b7825a1699a1f292$var$suffix];
for(var $b7825a1699a1f292$var$i = 0; !$b7825a1699a1f292$var$raf && $b7825a1699a1f292$var$i < $b7825a1699a1f292$var$vendors.length; $b7825a1699a1f292$var$i++){
    $b7825a1699a1f292$var$raf = $b7825a1699a1f292$var$root[$b7825a1699a1f292$var$vendors[$b7825a1699a1f292$var$i] + 'Request' + $b7825a1699a1f292$var$suffix];
    $b7825a1699a1f292$var$caf = $b7825a1699a1f292$var$root[$b7825a1699a1f292$var$vendors[$b7825a1699a1f292$var$i] + 'Cancel' + $b7825a1699a1f292$var$suffix] || $b7825a1699a1f292$var$root[$b7825a1699a1f292$var$vendors[$b7825a1699a1f292$var$i] + 'CancelRequest' + $b7825a1699a1f292$var$suffix];
}
// Some versions of FF have rAF but not cAF
if (!$b7825a1699a1f292$var$raf || !$b7825a1699a1f292$var$caf) {
    var $b7825a1699a1f292$var$last = 0, $b7825a1699a1f292$var$id = 0, $b7825a1699a1f292$var$queue = [], $b7825a1699a1f292$var$frameDuration = 1000 / 60;
    $b7825a1699a1f292$var$raf = function(callback) {
        if ($b7825a1699a1f292$var$queue.length === 0) {
            var _now = $09c3b62c9634fa2b$exports(), next = Math.max(0, $b7825a1699a1f292$var$frameDuration - (_now - $b7825a1699a1f292$var$last));
            $b7825a1699a1f292$var$last = next + _now;
            setTimeout(function() {
                var cp = $b7825a1699a1f292$var$queue.slice(0);
                // Clear queue here to prevent
                // callbacks from appending listeners
                // to the current frame's queue
                $b7825a1699a1f292$var$queue.length = 0;
                for(var i = 0; i < cp.length; i++){
                    if (!cp[i].cancelled) try {
                        cp[i].callback($b7825a1699a1f292$var$last);
                    } catch (e) {
                        setTimeout(function() {
                            throw e;
                        }, 0);
                    }
                }
            }, Math.round(next));
        }
        $b7825a1699a1f292$var$queue.push({
            handle: ++$b7825a1699a1f292$var$id,
            callback: callback,
            cancelled: false
        });
        return $b7825a1699a1f292$var$id;
    };
    $b7825a1699a1f292$var$caf = function(handle) {
        for(var i = 0; i < $b7825a1699a1f292$var$queue.length; i++)if ($b7825a1699a1f292$var$queue[i].handle === handle) $b7825a1699a1f292$var$queue[i].cancelled = true;
    };
}
$b7825a1699a1f292$exports = function(fn) {
    // Wrap in a new function to prevent
    // `cancel` potentially being assigned
    // to the native rAF function
    return $b7825a1699a1f292$var$raf.call($b7825a1699a1f292$var$root, fn);
};
$b7825a1699a1f292$exports.cancel = function() {
    $b7825a1699a1f292$var$caf.apply($b7825a1699a1f292$var$root, arguments);
};
$b7825a1699a1f292$exports.polyfill = function(object) {
    if (!object) object = $b7825a1699a1f292$var$root;
    object.requestAnimationFrame = $b7825a1699a1f292$var$raf;
    object.cancelAnimationFrame = $b7825a1699a1f292$var$caf;
};


var $6064277e05de6a97$var$_raf3 = $6064277e05de6a97$var$_interopRequireDefault($b7825a1699a1f292$exports);
var $f3da27235013bf13$exports = {};
var $3cd28bf75e2e26af$exports = {};
var $3cd28bf75e2e26af$var$div = null;
var $3cd28bf75e2e26af$var$prefixes = [
    'Webkit',
    'Moz',
    'O',
    'ms'
];
$3cd28bf75e2e26af$exports = function prefixStyle(prop) {
    // re-use a dummy div
    if (!$3cd28bf75e2e26af$var$div) $3cd28bf75e2e26af$var$div = document.createElement('div');
    var style = $3cd28bf75e2e26af$var$div.style;
    // prop exists without prefix
    if (prop in style) return prop;
    // borderRadius -> BorderRadius
    var titleCase = prop.charAt(0).toUpperCase() + prop.slice(1);
    // find the vendor-prefixed prop
    for(var i = $3cd28bf75e2e26af$var$prefixes.length; i >= 0; i--){
        var name = $3cd28bf75e2e26af$var$prefixes[i] + titleCase;
        // e.g. WebkitBorderRadius or webkitBorderRadius
        if (name in style) return name;
    }
    return false;
};


var $02ef10aad8cfbcc7$exports = {};
var $d2eee958a20d2435$exports = {};
var $0c9fe9fb541fd467$exports = {};
/**
 * Export.
 */ $0c9fe9fb541fd467$exports = $0c9fe9fb541fd467$var$toNoCase;
/**
 * Test whether a string is camel-case.
 */ var $0c9fe9fb541fd467$var$hasSpace = /\s/;
var $0c9fe9fb541fd467$var$hasSeparator = /(_|-|\.|:)/;
var $0c9fe9fb541fd467$var$hasCamel = /([a-z][A-Z]|[A-Z][a-z])/;
/**
 * Remove any starting case from a `string`, like camel or snake, but keep
 * spaces and punctuation that may be important otherwise.
 *
 * @param {String} string
 * @return {String}
 */ function $0c9fe9fb541fd467$var$toNoCase(string) {
    if ($0c9fe9fb541fd467$var$hasSpace.test(string)) return string.toLowerCase();
    if ($0c9fe9fb541fd467$var$hasSeparator.test(string)) return ($0c9fe9fb541fd467$var$unseparate(string) || string).toLowerCase();
    if ($0c9fe9fb541fd467$var$hasCamel.test(string)) return $0c9fe9fb541fd467$var$uncamelize(string).toLowerCase();
    return string.toLowerCase();
}
/**
 * Separator splitter.
 */ var $0c9fe9fb541fd467$var$separatorSplitter = /[\W_]+(.|$)/g;
/**
 * Un-separate a `string`.
 *
 * @param {String} string
 * @return {String}
 */ function $0c9fe9fb541fd467$var$unseparate(string) {
    return string.replace($0c9fe9fb541fd467$var$separatorSplitter, function(m, next) {
        return next ? ' ' + next : '';
    });
}
/**
 * Camelcase splitter.
 */ var $0c9fe9fb541fd467$var$camelSplitter = /(.)([A-Z]+)/g;
/**
 * Un-camelcase a `string`.
 *
 * @param {String} string
 * @return {String}
 */ function $0c9fe9fb541fd467$var$uncamelize(string) {
    return string.replace($0c9fe9fb541fd467$var$camelSplitter, function(m, previous, uppers) {
        return previous + ' ' + uppers.toLowerCase().split('').join(' ');
    });
}


/**
 * Export.
 */ $d2eee958a20d2435$exports = $d2eee958a20d2435$var$toSpaceCase;
/**
 * Convert a `string` to space case.
 *
 * @param {String} string
 * @return {String}
 */ function $d2eee958a20d2435$var$toSpaceCase(string) {
    return $0c9fe9fb541fd467$exports(string).replace(/[\W_]+(.|$)/g, function(matches, match) {
        return match ? ' ' + match : '';
    }).trim();
}


/**
 * Export.
 */ $02ef10aad8cfbcc7$exports = $02ef10aad8cfbcc7$var$toCamelCase;
/**
 * Convert a `string` to camel case.
 *
 * @param {String} string
 * @return {String}
 */ function $02ef10aad8cfbcc7$var$toCamelCase(string) {
    return $d2eee958a20d2435$exports(string).replace(/\s(\w)/g, function(matches, letter) {
        return letter.toUpperCase();
    });
}


var $f3da27235013bf13$var$cache = {
    'float': 'cssFloat'
};
var $cf8183f559aca9a6$exports = {};
/* The following list is defined in React's core */ var $cf8183f559aca9a6$var$IS_UNITLESS = {
    animationIterationCount: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridRow: true,
    gridColumn: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    // SVG-related properties
    fillOpacity: true,
    stopOpacity: true,
    strokeDashoffset: true,
    strokeOpacity: true,
    strokeWidth: true
};
$cf8183f559aca9a6$exports = function(name, value) {
    if (typeof value === 'number' && !$cf8183f559aca9a6$var$IS_UNITLESS[name]) return value + 'px';
    else return value;
};


function $f3da27235013bf13$var$style(element, property, value) {
    var camel = $f3da27235013bf13$var$cache[property];
    if (typeof camel === 'undefined') camel = $f3da27235013bf13$var$detect(property);
    // may be false if CSS prop is unsupported
    if (camel) {
        if (value === undefined) return element.style[camel];
        element.style[camel] = $cf8183f559aca9a6$exports(camel, value);
    }
}
function $f3da27235013bf13$var$each(element, properties) {
    for(var k in properties)if (properties.hasOwnProperty(k)) $f3da27235013bf13$var$style(element, k, properties[k]);
}
function $f3da27235013bf13$var$detect(cssProp) {
    var camel = $02ef10aad8cfbcc7$exports(cssProp);
    var result = $3cd28bf75e2e26af$exports(camel);
    $f3da27235013bf13$var$cache[camel] = $f3da27235013bf13$var$cache[cssProp] = $f3da27235013bf13$var$cache[result] = result;
    return result;
}
function $f3da27235013bf13$var$set() {
    if (arguments.length === 2) {
        if (typeof arguments[1] === 'string') arguments[0].style.cssText = arguments[1];
        else $f3da27235013bf13$var$each(arguments[0], arguments[1]);
    } else $f3da27235013bf13$var$style(arguments[0], arguments[1], arguments[2]);
}
$f3da27235013bf13$exports = $f3da27235013bf13$var$set;
$f3da27235013bf13$exports.set = $f3da27235013bf13$var$set;
$f3da27235013bf13$exports.get = function(element, properties) {
    if (Array.isArray(properties)) return properties.reduce(function(obj, prop) {
        obj[prop] = $f3da27235013bf13$var$style(element, prop || '');
        return obj;
    }, {});
    else return $f3da27235013bf13$var$style(element, properties || '');
};


var $6064277e05de6a97$var$_domCss2 = $6064277e05de6a97$var$_interopRequireDefault($f3da27235013bf13$exports);

var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");
var $6064277e05de6a97$var$_propTypes2 = $6064277e05de6a97$var$_interopRequireDefault($fGw9V);
var $2217982632d56730$exports = {};
'use strict';
Object.defineProperty($2217982632d56730$exports, "__esModule", {
    value: true
});
$2217982632d56730$exports["default"] = $2217982632d56730$var$isString;
function $2217982632d56730$var$isString(maybe) {
    return typeof maybe === 'string';
}


var $6064277e05de6a97$var$_isString2 = $6064277e05de6a97$var$_interopRequireDefault($2217982632d56730$exports);
var $f0540829e2e1f53d$exports = {};
'use strict';
Object.defineProperty($f0540829e2e1f53d$exports, "__esModule", {
    value: true
});
$f0540829e2e1f53d$exports["default"] = $f0540829e2e1f53d$var$getScrollbarWidth;

var $f0540829e2e1f53d$var$_domCss2 = $f0540829e2e1f53d$var$_interopRequireDefault($f3da27235013bf13$exports);
function $f0540829e2e1f53d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $f0540829e2e1f53d$var$scrollbarWidth = false;
function $f0540829e2e1f53d$var$getScrollbarWidth() {
    if ($f0540829e2e1f53d$var$scrollbarWidth !== false) return $f0540829e2e1f53d$var$scrollbarWidth;
    /* istanbul ignore else */ if (typeof document !== 'undefined') {
        var div = document.createElement('div');
        (0, $f0540829e2e1f53d$var$_domCss2["default"])(div, {
            width: 100,
            height: 100,
            position: 'absolute',
            top: -9999,
            overflow: 'scroll',
            MsOverflowStyle: 'scrollbar'
        });
        document.body.appendChild(div);
        $f0540829e2e1f53d$var$scrollbarWidth = div.offsetWidth - div.clientWidth;
        document.body.removeChild(div);
    } else $f0540829e2e1f53d$var$scrollbarWidth = 0;
    return $f0540829e2e1f53d$var$scrollbarWidth || 0;
}


var $6064277e05de6a97$var$_getScrollbarWidth2 = $6064277e05de6a97$var$_interopRequireDefault($f0540829e2e1f53d$exports);
var $9e041e66efbcf1d4$exports = {};
"use strict";
Object.defineProperty($9e041e66efbcf1d4$exports, "__esModule", {
    value: true
});
$9e041e66efbcf1d4$exports["default"] = $9e041e66efbcf1d4$var$returnFalse;
function $9e041e66efbcf1d4$var$returnFalse() {
    return false;
}


var $6064277e05de6a97$var$_returnFalse2 = $6064277e05de6a97$var$_interopRequireDefault($9e041e66efbcf1d4$exports);
var $f29ffb3ed0ea59a3$exports = {};
"use strict";
Object.defineProperty($f29ffb3ed0ea59a3$exports, "__esModule", {
    value: true
});
$f29ffb3ed0ea59a3$exports["default"] = $f29ffb3ed0ea59a3$var$getInnerWidth;
function $f29ffb3ed0ea59a3$var$getInnerWidth(el) {
    var clientWidth = el.clientWidth;
    var _getComputedStyle = getComputedStyle(el), paddingLeft = _getComputedStyle.paddingLeft, paddingRight = _getComputedStyle.paddingRight;
    return clientWidth - parseFloat(paddingLeft) - parseFloat(paddingRight);
}


var $6064277e05de6a97$var$_getInnerWidth2 = $6064277e05de6a97$var$_interopRequireDefault($f29ffb3ed0ea59a3$exports);
var $7b6accb6cbd13a79$exports = {};
"use strict";
Object.defineProperty($7b6accb6cbd13a79$exports, "__esModule", {
    value: true
});
$7b6accb6cbd13a79$exports["default"] = $7b6accb6cbd13a79$var$getInnerHeight;
function $7b6accb6cbd13a79$var$getInnerHeight(el) {
    var clientHeight = el.clientHeight;
    var _getComputedStyle = getComputedStyle(el), paddingTop = _getComputedStyle.paddingTop, paddingBottom = _getComputedStyle.paddingBottom;
    return clientHeight - parseFloat(paddingTop) - parseFloat(paddingBottom);
}


var $6064277e05de6a97$var$_getInnerHeight2 = $6064277e05de6a97$var$_interopRequireDefault($7b6accb6cbd13a79$exports);
var $afd0ebd5164789fa$exports = {};
'use strict';
Object.defineProperty($afd0ebd5164789fa$exports, "__esModule", {
    value: true
});
var $afd0ebd5164789fa$var$containerStyleDefault = $afd0ebd5164789fa$exports.containerStyleDefault = {
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
    height: '100%'
};
// Overrides containerStyleDefault properties
var $afd0ebd5164789fa$var$containerStyleAutoHeight = $afd0ebd5164789fa$exports.containerStyleAutoHeight = {
    height: 'auto'
};
var $afd0ebd5164789fa$var$viewStyleDefault = $afd0ebd5164789fa$exports.viewStyleDefault = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: 'scroll',
    WebkitOverflowScrolling: 'touch'
};
// Overrides viewStyleDefault properties
var $afd0ebd5164789fa$var$viewStyleAutoHeight = $afd0ebd5164789fa$exports.viewStyleAutoHeight = {
    position: 'relative',
    top: undefined,
    left: undefined,
    right: undefined,
    bottom: undefined
};
var $afd0ebd5164789fa$var$viewStyleUniversalInitial = $afd0ebd5164789fa$exports.viewStyleUniversalInitial = {
    overflow: 'hidden',
    marginRight: 0,
    marginBottom: 0
};
var $afd0ebd5164789fa$var$trackHorizontalStyleDefault = $afd0ebd5164789fa$exports.trackHorizontalStyleDefault = {
    position: 'absolute',
    height: 6
};
var $afd0ebd5164789fa$var$trackVerticalStyleDefault = $afd0ebd5164789fa$exports.trackVerticalStyleDefault = {
    position: 'absolute',
    width: 6
};
var $afd0ebd5164789fa$var$thumbHorizontalStyleDefault = $afd0ebd5164789fa$exports.thumbHorizontalStyleDefault = {
    position: 'relative',
    display: 'block',
    height: '100%'
};
var $afd0ebd5164789fa$var$thumbVerticalStyleDefault = $afd0ebd5164789fa$exports.thumbVerticalStyleDefault = {
    position: 'relative',
    display: 'block',
    width: '100%'
};
var $afd0ebd5164789fa$var$disableSelectStyle = $afd0ebd5164789fa$exports.disableSelectStyle = {
    userSelect: 'none'
};
var $afd0ebd5164789fa$var$disableSelectStyleReset = $afd0ebd5164789fa$exports.disableSelectStyleReset = {
    userSelect: ''
};


var $1ec1dee2a75c4667$exports = {};
'use strict';
Object.defineProperty($1ec1dee2a75c4667$exports, "__esModule", {
    value: true
});
var $1ec1dee2a75c4667$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
$1ec1dee2a75c4667$exports.renderViewDefault = $1ec1dee2a75c4667$var$renderViewDefault;
$1ec1dee2a75c4667$exports.renderTrackHorizontalDefault = $1ec1dee2a75c4667$var$renderTrackHorizontalDefault;
$1ec1dee2a75c4667$exports.renderTrackVerticalDefault = $1ec1dee2a75c4667$var$renderTrackVerticalDefault;
$1ec1dee2a75c4667$exports.renderThumbHorizontalDefault = $1ec1dee2a75c4667$var$renderThumbHorizontalDefault;
$1ec1dee2a75c4667$exports.renderThumbVerticalDefault = $1ec1dee2a75c4667$var$renderThumbVerticalDefault;

var $NdCUR = parcelRequire("NdCUR");
var $1ec1dee2a75c4667$var$_react2 = $1ec1dee2a75c4667$var$_interopRequireDefault($NdCUR);
function $1ec1dee2a75c4667$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $1ec1dee2a75c4667$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
/* eslint-disable react/prop-types */ function $1ec1dee2a75c4667$var$renderViewDefault(props) {
    return $1ec1dee2a75c4667$var$_react2["default"].createElement('div', props);
}
function $1ec1dee2a75c4667$var$renderTrackHorizontalDefault(_ref) {
    var style = _ref.style, props = $1ec1dee2a75c4667$var$_objectWithoutProperties(_ref, [
        'style'
    ]);
    var finalStyle = $1ec1dee2a75c4667$var$_extends({}, style, {
        right: 2,
        bottom: 2,
        left: 2,
        borderRadius: 3
    });
    return $1ec1dee2a75c4667$var$_react2["default"].createElement('div', $1ec1dee2a75c4667$var$_extends({
        style: finalStyle
    }, props));
}
function $1ec1dee2a75c4667$var$renderTrackVerticalDefault(_ref2) {
    var style = _ref2.style, props = $1ec1dee2a75c4667$var$_objectWithoutProperties(_ref2, [
        'style'
    ]);
    var finalStyle = $1ec1dee2a75c4667$var$_extends({}, style, {
        right: 2,
        bottom: 2,
        top: 2,
        borderRadius: 3
    });
    return $1ec1dee2a75c4667$var$_react2["default"].createElement('div', $1ec1dee2a75c4667$var$_extends({
        style: finalStyle
    }, props));
}
function $1ec1dee2a75c4667$var$renderThumbHorizontalDefault(_ref3) {
    var style = _ref3.style, props = $1ec1dee2a75c4667$var$_objectWithoutProperties(_ref3, [
        'style'
    ]);
    var finalStyle = $1ec1dee2a75c4667$var$_extends({}, style, {
        cursor: 'pointer',
        borderRadius: 'inherit',
        backgroundColor: 'rgba(0,0,0,.2)'
    });
    return $1ec1dee2a75c4667$var$_react2["default"].createElement('div', $1ec1dee2a75c4667$var$_extends({
        style: finalStyle
    }, props));
}
function $1ec1dee2a75c4667$var$renderThumbVerticalDefault(_ref4) {
    var style = _ref4.style, props = $1ec1dee2a75c4667$var$_objectWithoutProperties(_ref4, [
        'style'
    ]);
    var finalStyle = $1ec1dee2a75c4667$var$_extends({}, style, {
        cursor: 'pointer',
        borderRadius: 'inherit',
        backgroundColor: 'rgba(0,0,0,.2)'
    });
    return $1ec1dee2a75c4667$var$_react2["default"].createElement('div', $1ec1dee2a75c4667$var$_extends({
        style: finalStyle
    }, props));
}


function $6064277e05de6a97$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $6064277e05de6a97$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $6064277e05de6a97$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6064277e05de6a97$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $6064277e05de6a97$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $6064277e05de6a97$var$Scrollbars = function(_Component) {
    $6064277e05de6a97$var$_inherits(Scrollbars, _Component);
    function Scrollbars(props) {
        var _ref;
        $6064277e05de6a97$var$_classCallCheck(this, Scrollbars);
        for(var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
        var _this = $6064277e05de6a97$var$_possibleConstructorReturn(this, (_ref = Scrollbars.__proto__ || Object.getPrototypeOf(Scrollbars)).call.apply(_ref, [
            this,
            props
        ].concat(rest)));
        _this.getScrollLeft = _this.getScrollLeft.bind(_this);
        _this.getScrollTop = _this.getScrollTop.bind(_this);
        _this.getScrollWidth = _this.getScrollWidth.bind(_this);
        _this.getScrollHeight = _this.getScrollHeight.bind(_this);
        _this.getClientWidth = _this.getClientWidth.bind(_this);
        _this.getClientHeight = _this.getClientHeight.bind(_this);
        _this.getValues = _this.getValues.bind(_this);
        _this.getThumbHorizontalWidth = _this.getThumbHorizontalWidth.bind(_this);
        _this.getThumbVerticalHeight = _this.getThumbVerticalHeight.bind(_this);
        _this.getScrollLeftForOffset = _this.getScrollLeftForOffset.bind(_this);
        _this.getScrollTopForOffset = _this.getScrollTopForOffset.bind(_this);
        _this.scrollLeft = _this.scrollLeft.bind(_this);
        _this.scrollTop = _this.scrollTop.bind(_this);
        _this.scrollToLeft = _this.scrollToLeft.bind(_this);
        _this.scrollToTop = _this.scrollToTop.bind(_this);
        _this.scrollToRight = _this.scrollToRight.bind(_this);
        _this.scrollToBottom = _this.scrollToBottom.bind(_this);
        _this.handleTrackMouseEnter = _this.handleTrackMouseEnter.bind(_this);
        _this.handleTrackMouseLeave = _this.handleTrackMouseLeave.bind(_this);
        _this.handleHorizontalTrackMouseDown = _this.handleHorizontalTrackMouseDown.bind(_this);
        _this.handleVerticalTrackMouseDown = _this.handleVerticalTrackMouseDown.bind(_this);
        _this.handleHorizontalThumbMouseDown = _this.handleHorizontalThumbMouseDown.bind(_this);
        _this.handleVerticalThumbMouseDown = _this.handleVerticalThumbMouseDown.bind(_this);
        _this.handleWindowResize = _this.handleWindowResize.bind(_this);
        _this.handleScroll = _this.handleScroll.bind(_this);
        _this.handleDrag = _this.handleDrag.bind(_this);
        _this.handleDragEnd = _this.handleDragEnd.bind(_this);
        _this.state = {
            didMountUniversal: false
        };
        return _this;
    }
    $6064277e05de6a97$var$_createClass(Scrollbars, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.addListeners();
                this.update();
                this.componentDidMountUniversal();
            }
        },
        {
            key: 'componentDidMountUniversal',
            value: function componentDidMountUniversal() {
                // eslint-disable-line react/sort-comp
                var universal = this.props.universal;
                if (!universal) return;
                this.setState({
                    didMountUniversal: true
                });
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate() {
                this.update();
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.removeListeners();
                (0, $b7825a1699a1f292$exports.cancel)(this.requestFrame);
                clearTimeout(this.hideTracksTimeout);
                clearInterval(this.detectScrollingInterval);
            }
        },
        {
            key: 'getScrollLeft',
            value: function getScrollLeft() {
                if (!this.view) return 0;
                return this.view.scrollLeft;
            }
        },
        {
            key: 'getScrollTop',
            value: function getScrollTop() {
                if (!this.view) return 0;
                return this.view.scrollTop;
            }
        },
        {
            key: 'getScrollWidth',
            value: function getScrollWidth() {
                if (!this.view) return 0;
                return this.view.scrollWidth;
            }
        },
        {
            key: 'getScrollHeight',
            value: function getScrollHeight() {
                if (!this.view) return 0;
                return this.view.scrollHeight;
            }
        },
        {
            key: 'getClientWidth',
            value: function getClientWidth() {
                if (!this.view) return 0;
                return this.view.clientWidth;
            }
        },
        {
            key: 'getClientHeight',
            value: function getClientHeight() {
                if (!this.view) return 0;
                return this.view.clientHeight;
            }
        },
        {
            key: 'getValues',
            value: function getValues() {
                var _ref2 = this.view || {}, _ref2$scrollLeft = _ref2.scrollLeft, scrollLeft = _ref2$scrollLeft === undefined ? 0 : _ref2$scrollLeft, _ref2$scrollTop = _ref2.scrollTop, scrollTop = _ref2$scrollTop === undefined ? 0 : _ref2$scrollTop, _ref2$scrollWidth = _ref2.scrollWidth, scrollWidth = _ref2$scrollWidth === undefined ? 0 : _ref2$scrollWidth, _ref2$scrollHeight = _ref2.scrollHeight, scrollHeight = _ref2$scrollHeight === undefined ? 0 : _ref2$scrollHeight, _ref2$clientWidth = _ref2.clientWidth, clientWidth = _ref2$clientWidth === undefined ? 0 : _ref2$clientWidth, _ref2$clientHeight = _ref2.clientHeight, clientHeight = _ref2$clientHeight === undefined ? 0 : _ref2$clientHeight;
                return {
                    left: scrollLeft / (scrollWidth - clientWidth) || 0,
                    top: scrollTop / (scrollHeight - clientHeight) || 0,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    scrollWidth: scrollWidth,
                    scrollHeight: scrollHeight,
                    clientWidth: clientWidth,
                    clientHeight: clientHeight
                };
            }
        },
        {
            key: 'getThumbHorizontalWidth',
            value: function getThumbHorizontalWidth() {
                var _props = this.props, thumbSize = _props.thumbSize, thumbMinSize = _props.thumbMinSize;
                var _view = this.view, scrollWidth = _view.scrollWidth, clientWidth = _view.clientWidth;
                var trackWidth = (0, $6064277e05de6a97$var$_getInnerWidth2["default"])(this.trackHorizontal);
                var width = Math.ceil(clientWidth / scrollWidth * trackWidth);
                if (trackWidth === width) return 0;
                if (thumbSize) return thumbSize;
                return Math.max(width, thumbMinSize);
            }
        },
        {
            key: 'getThumbVerticalHeight',
            value: function getThumbVerticalHeight() {
                var _props2 = this.props, thumbSize = _props2.thumbSize, thumbMinSize = _props2.thumbMinSize;
                var _view2 = this.view, scrollHeight = _view2.scrollHeight, clientHeight = _view2.clientHeight;
                var trackHeight = (0, $6064277e05de6a97$var$_getInnerHeight2["default"])(this.trackVertical);
                var height = Math.ceil(clientHeight / scrollHeight * trackHeight);
                if (trackHeight === height) return 0;
                if (thumbSize) return thumbSize;
                return Math.max(height, thumbMinSize);
            }
        },
        {
            key: 'getScrollLeftForOffset',
            value: function getScrollLeftForOffset(offset) {
                var _view3 = this.view, scrollWidth = _view3.scrollWidth, clientWidth = _view3.clientWidth;
                var trackWidth = (0, $6064277e05de6a97$var$_getInnerWidth2["default"])(this.trackHorizontal);
                var thumbWidth = this.getThumbHorizontalWidth();
                return offset / (trackWidth - thumbWidth) * (scrollWidth - clientWidth);
            }
        },
        {
            key: 'getScrollTopForOffset',
            value: function getScrollTopForOffset(offset) {
                var _view4 = this.view, scrollHeight = _view4.scrollHeight, clientHeight = _view4.clientHeight;
                var trackHeight = (0, $6064277e05de6a97$var$_getInnerHeight2["default"])(this.trackVertical);
                var thumbHeight = this.getThumbVerticalHeight();
                return offset / (trackHeight - thumbHeight) * (scrollHeight - clientHeight);
            }
        },
        {
            key: 'scrollLeft',
            value: function scrollLeft() {
                var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (!this.view) return;
                this.view.scrollLeft = left;
            }
        },
        {
            key: 'scrollTop',
            value: function scrollTop() {
                var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (!this.view) return;
                this.view.scrollTop = top;
            }
        },
        {
            key: 'scrollToLeft',
            value: function scrollToLeft() {
                if (!this.view) return;
                this.view.scrollLeft = 0;
            }
        },
        {
            key: 'scrollToTop',
            value: function scrollToTop() {
                if (!this.view) return;
                this.view.scrollTop = 0;
            }
        },
        {
            key: 'scrollToRight',
            value: function scrollToRight() {
                if (!this.view) return;
                this.view.scrollLeft = this.view.scrollWidth;
            }
        },
        {
            key: 'scrollToBottom',
            value: function scrollToBottom() {
                if (!this.view) return;
                this.view.scrollTop = this.view.scrollHeight;
            }
        },
        {
            key: 'addListeners',
            value: function addListeners() {
                /* istanbul ignore if */ if (typeof document === 'undefined' || !this.view) return;
                var view = this.view, trackHorizontal = this.trackHorizontal, trackVertical = this.trackVertical, thumbHorizontal = this.thumbHorizontal, thumbVertical = this.thumbVertical;
                view.addEventListener('scroll', this.handleScroll);
                if (!(0, $6064277e05de6a97$var$_getScrollbarWidth2["default"])()) return;
                trackHorizontal.addEventListener('mouseenter', this.handleTrackMouseEnter);
                trackHorizontal.addEventListener('mouseleave', this.handleTrackMouseLeave);
                trackHorizontal.addEventListener('mousedown', this.handleHorizontalTrackMouseDown);
                trackVertical.addEventListener('mouseenter', this.handleTrackMouseEnter);
                trackVertical.addEventListener('mouseleave', this.handleTrackMouseLeave);
                trackVertical.addEventListener('mousedown', this.handleVerticalTrackMouseDown);
                thumbHorizontal.addEventListener('mousedown', this.handleHorizontalThumbMouseDown);
                thumbVertical.addEventListener('mousedown', this.handleVerticalThumbMouseDown);
                window.addEventListener('resize', this.handleWindowResize);
            }
        },
        {
            key: 'removeListeners',
            value: function removeListeners() {
                /* istanbul ignore if */ if (typeof document === 'undefined' || !this.view) return;
                var view = this.view, trackHorizontal = this.trackHorizontal, trackVertical = this.trackVertical, thumbHorizontal = this.thumbHorizontal, thumbVertical = this.thumbVertical;
                view.removeEventListener('scroll', this.handleScroll);
                if (!(0, $6064277e05de6a97$var$_getScrollbarWidth2["default"])()) return;
                trackHorizontal.removeEventListener('mouseenter', this.handleTrackMouseEnter);
                trackHorizontal.removeEventListener('mouseleave', this.handleTrackMouseLeave);
                trackHorizontal.removeEventListener('mousedown', this.handleHorizontalTrackMouseDown);
                trackVertical.removeEventListener('mouseenter', this.handleTrackMouseEnter);
                trackVertical.removeEventListener('mouseleave', this.handleTrackMouseLeave);
                trackVertical.removeEventListener('mousedown', this.handleVerticalTrackMouseDown);
                thumbHorizontal.removeEventListener('mousedown', this.handleHorizontalThumbMouseDown);
                thumbVertical.removeEventListener('mousedown', this.handleVerticalThumbMouseDown);
                window.removeEventListener('resize', this.handleWindowResize);
                // Possibly setup by `handleDragStart`
                this.teardownDragging();
            }
        },
        {
            key: 'handleScroll',
            value: function handleScroll(event) {
                var _this2 = this;
                var _props3 = this.props, onScroll = _props3.onScroll, onScrollFrame = _props3.onScrollFrame;
                if (onScroll) onScroll(event);
                this.update(function(values) {
                    var scrollLeft = values.scrollLeft, scrollTop = values.scrollTop;
                    _this2.viewScrollLeft = scrollLeft;
                    _this2.viewScrollTop = scrollTop;
                    if (onScrollFrame) onScrollFrame(values);
                });
                this.detectScrolling();
            }
        },
        {
            key: 'handleScrollStart',
            value: function handleScrollStart() {
                var onScrollStart = this.props.onScrollStart;
                if (onScrollStart) onScrollStart();
                this.handleScrollStartAutoHide();
            }
        },
        {
            key: 'handleScrollStartAutoHide',
            value: function handleScrollStartAutoHide() {
                var autoHide = this.props.autoHide;
                if (!autoHide) return;
                this.showTracks();
            }
        },
        {
            key: 'handleScrollStop',
            value: function handleScrollStop() {
                var onScrollStop = this.props.onScrollStop;
                if (onScrollStop) onScrollStop();
                this.handleScrollStopAutoHide();
            }
        },
        {
            key: 'handleScrollStopAutoHide',
            value: function handleScrollStopAutoHide() {
                var autoHide = this.props.autoHide;
                if (!autoHide) return;
                this.hideTracks();
            }
        },
        {
            key: 'handleWindowResize',
            value: function handleWindowResize() {
                this.update();
            }
        },
        {
            key: 'handleHorizontalTrackMouseDown',
            value: function handleHorizontalTrackMouseDown(event) {
                event.preventDefault();
                var target = event.target, clientX = event.clientX;
                var _target$getBoundingCl = target.getBoundingClientRect(), targetLeft = _target$getBoundingCl.left;
                var thumbWidth = this.getThumbHorizontalWidth();
                var offset = Math.abs(targetLeft - clientX) - thumbWidth / 2;
                this.view.scrollLeft = this.getScrollLeftForOffset(offset);
            }
        },
        {
            key: 'handleVerticalTrackMouseDown',
            value: function handleVerticalTrackMouseDown(event) {
                event.preventDefault();
                var target = event.target, clientY = event.clientY;
                var _target$getBoundingCl2 = target.getBoundingClientRect(), targetTop = _target$getBoundingCl2.top;
                var thumbHeight = this.getThumbVerticalHeight();
                var offset = Math.abs(targetTop - clientY) - thumbHeight / 2;
                this.view.scrollTop = this.getScrollTopForOffset(offset);
            }
        },
        {
            key: 'handleHorizontalThumbMouseDown',
            value: function handleHorizontalThumbMouseDown(event) {
                event.preventDefault();
                this.handleDragStart(event);
                var target = event.target, clientX = event.clientX;
                var offsetWidth = target.offsetWidth;
                var _target$getBoundingCl3 = target.getBoundingClientRect(), left = _target$getBoundingCl3.left;
                this.prevPageX = offsetWidth - (clientX - left);
            }
        },
        {
            key: 'handleVerticalThumbMouseDown',
            value: function handleVerticalThumbMouseDown(event) {
                event.preventDefault();
                this.handleDragStart(event);
                var target = event.target, clientY = event.clientY;
                var offsetHeight = target.offsetHeight;
                var _target$getBoundingCl4 = target.getBoundingClientRect(), top = _target$getBoundingCl4.top;
                this.prevPageY = offsetHeight - (clientY - top);
            }
        },
        {
            key: 'setupDragging',
            value: function setupDragging() {
                (0, $6064277e05de6a97$var$_domCss2["default"])(document.body, $afd0ebd5164789fa$exports.disableSelectStyle);
                document.addEventListener('mousemove', this.handleDrag);
                document.addEventListener('mouseup', this.handleDragEnd);
                document.onselectstart = $6064277e05de6a97$var$_returnFalse2["default"];
            }
        },
        {
            key: 'teardownDragging',
            value: function teardownDragging() {
                (0, $6064277e05de6a97$var$_domCss2["default"])(document.body, $afd0ebd5164789fa$exports.disableSelectStyleReset);
                document.removeEventListener('mousemove', this.handleDrag);
                document.removeEventListener('mouseup', this.handleDragEnd);
                document.onselectstart = undefined;
            }
        },
        {
            key: 'handleDragStart',
            value: function handleDragStart(event) {
                this.dragging = true;
                event.stopImmediatePropagation();
                this.setupDragging();
            }
        },
        {
            key: 'handleDrag',
            value: function handleDrag(event) {
                if (this.prevPageX) {
                    var clientX = event.clientX;
                    var _trackHorizontal$getB = this.trackHorizontal.getBoundingClientRect(), trackLeft = _trackHorizontal$getB.left;
                    var thumbWidth = this.getThumbHorizontalWidth();
                    var clickPosition = thumbWidth - this.prevPageX;
                    var offset = -trackLeft + clientX - clickPosition;
                    this.view.scrollLeft = this.getScrollLeftForOffset(offset);
                }
                if (this.prevPageY) {
                    var clientY = event.clientY;
                    var _trackVertical$getBou = this.trackVertical.getBoundingClientRect(), trackTop = _trackVertical$getBou.top;
                    var thumbHeight = this.getThumbVerticalHeight();
                    var _clickPosition = thumbHeight - this.prevPageY;
                    var _offset = -trackTop + clientY - _clickPosition;
                    this.view.scrollTop = this.getScrollTopForOffset(_offset);
                }
                return false;
            }
        },
        {
            key: 'handleDragEnd',
            value: function handleDragEnd() {
                this.dragging = false;
                this.prevPageX = this.prevPageY = 0;
                this.teardownDragging();
                this.handleDragEndAutoHide();
            }
        },
        {
            key: 'handleDragEndAutoHide',
            value: function handleDragEndAutoHide() {
                var autoHide = this.props.autoHide;
                if (!autoHide) return;
                this.hideTracks();
            }
        },
        {
            key: 'handleTrackMouseEnter',
            value: function handleTrackMouseEnter() {
                this.trackMouseOver = true;
                this.handleTrackMouseEnterAutoHide();
            }
        },
        {
            key: 'handleTrackMouseEnterAutoHide',
            value: function handleTrackMouseEnterAutoHide() {
                var autoHide = this.props.autoHide;
                if (!autoHide) return;
                this.showTracks();
            }
        },
        {
            key: 'handleTrackMouseLeave',
            value: function handleTrackMouseLeave() {
                this.trackMouseOver = false;
                this.handleTrackMouseLeaveAutoHide();
            }
        },
        {
            key: 'handleTrackMouseLeaveAutoHide',
            value: function handleTrackMouseLeaveAutoHide() {
                var autoHide = this.props.autoHide;
                if (!autoHide) return;
                this.hideTracks();
            }
        },
        {
            key: 'showTracks',
            value: function showTracks() {
                clearTimeout(this.hideTracksTimeout);
                (0, $6064277e05de6a97$var$_domCss2["default"])(this.trackHorizontal, {
                    opacity: 1
                });
                (0, $6064277e05de6a97$var$_domCss2["default"])(this.trackVertical, {
                    opacity: 1
                });
            }
        },
        {
            key: 'hideTracks',
            value: function hideTracks() {
                var _this3 = this;
                if (this.dragging) return;
                if (this.scrolling) return;
                if (this.trackMouseOver) return;
                var autoHideTimeout = this.props.autoHideTimeout;
                clearTimeout(this.hideTracksTimeout);
                this.hideTracksTimeout = setTimeout(function() {
                    (0, $6064277e05de6a97$var$_domCss2["default"])(_this3.trackHorizontal, {
                        opacity: 0
                    });
                    (0, $6064277e05de6a97$var$_domCss2["default"])(_this3.trackVertical, {
                        opacity: 0
                    });
                }, autoHideTimeout);
            }
        },
        {
            key: 'detectScrolling',
            value: function detectScrolling() {
                var _this4 = this;
                if (this.scrolling) return;
                this.scrolling = true;
                this.handleScrollStart();
                this.detectScrollingInterval = setInterval(function() {
                    if (_this4.lastViewScrollLeft === _this4.viewScrollLeft && _this4.lastViewScrollTop === _this4.viewScrollTop) {
                        clearInterval(_this4.detectScrollingInterval);
                        _this4.scrolling = false;
                        _this4.handleScrollStop();
                    }
                    _this4.lastViewScrollLeft = _this4.viewScrollLeft;
                    _this4.lastViewScrollTop = _this4.viewScrollTop;
                }, 100);
            }
        },
        {
            key: 'raf',
            value: function raf(callback) {
                var _this5 = this;
                if (this.requestFrame) $6064277e05de6a97$var$_raf3["default"].cancel(this.requestFrame);
                this.requestFrame = (0, $6064277e05de6a97$var$_raf3["default"])(function() {
                    _this5.requestFrame = undefined;
                    callback();
                });
            }
        },
        {
            key: 'update',
            value: function update(callback) {
                var _this6 = this;
                this.raf(function() {
                    return _this6._update(callback);
                });
            }
        },
        {
            key: '_update',
            value: function _update(callback) {
                var _props4 = this.props, onUpdate = _props4.onUpdate, hideTracksWhenNotNeeded = _props4.hideTracksWhenNotNeeded;
                var values = this.getValues();
                if ((0, $6064277e05de6a97$var$_getScrollbarWidth2["default"])()) {
                    var scrollLeft = values.scrollLeft, clientWidth = values.clientWidth, scrollWidth = values.scrollWidth;
                    var trackHorizontalWidth = (0, $6064277e05de6a97$var$_getInnerWidth2["default"])(this.trackHorizontal);
                    var thumbHorizontalWidth = this.getThumbHorizontalWidth();
                    var thumbHorizontalX = scrollLeft / (scrollWidth - clientWidth) * (trackHorizontalWidth - thumbHorizontalWidth);
                    var thumbHorizontalStyle = {
                        width: thumbHorizontalWidth,
                        transform: 'translateX(' + thumbHorizontalX + 'px)'
                    };
                    var scrollTop = values.scrollTop, clientHeight = values.clientHeight, scrollHeight = values.scrollHeight;
                    var trackVerticalHeight = (0, $6064277e05de6a97$var$_getInnerHeight2["default"])(this.trackVertical);
                    var thumbVerticalHeight = this.getThumbVerticalHeight();
                    var thumbVerticalY = scrollTop / (scrollHeight - clientHeight) * (trackVerticalHeight - thumbVerticalHeight);
                    var thumbVerticalStyle = {
                        height: thumbVerticalHeight,
                        transform: 'translateY(' + thumbVerticalY + 'px)'
                    };
                    if (hideTracksWhenNotNeeded) {
                        var trackHorizontalStyle = {
                            visibility: scrollWidth > clientWidth ? 'visible' : 'hidden'
                        };
                        var trackVerticalStyle = {
                            visibility: scrollHeight > clientHeight ? 'visible' : 'hidden'
                        };
                        (0, $6064277e05de6a97$var$_domCss2["default"])(this.trackHorizontal, trackHorizontalStyle);
                        (0, $6064277e05de6a97$var$_domCss2["default"])(this.trackVertical, trackVerticalStyle);
                    }
                    (0, $6064277e05de6a97$var$_domCss2["default"])(this.thumbHorizontal, thumbHorizontalStyle);
                    (0, $6064277e05de6a97$var$_domCss2["default"])(this.thumbVertical, thumbVerticalStyle);
                }
                if (onUpdate) onUpdate(values);
                if (typeof callback !== 'function') return;
                callback(values);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this7 = this;
                var scrollbarWidth = (0, $6064277e05de6a97$var$_getScrollbarWidth2["default"])();
                /* eslint-disable no-unused-vars */ var _props5 = this.props, onScroll = _props5.onScroll, onScrollFrame = _props5.onScrollFrame, onScrollStart = _props5.onScrollStart, onScrollStop = _props5.onScrollStop, onUpdate = _props5.onUpdate, renderView = _props5.renderView, renderTrackHorizontal = _props5.renderTrackHorizontal, renderTrackVertical = _props5.renderTrackVertical, renderThumbHorizontal = _props5.renderThumbHorizontal, renderThumbVertical = _props5.renderThumbVertical, tagName = _props5.tagName, hideTracksWhenNotNeeded = _props5.hideTracksWhenNotNeeded, autoHide = _props5.autoHide, autoHideTimeout = _props5.autoHideTimeout, autoHideDuration = _props5.autoHideDuration, thumbSize = _props5.thumbSize, thumbMinSize = _props5.thumbMinSize, universal = _props5.universal, autoHeight = _props5.autoHeight, autoHeightMin = _props5.autoHeightMin, autoHeightMax = _props5.autoHeightMax, style = _props5.style, children = _props5.children, props = $6064277e05de6a97$var$_objectWithoutProperties(_props5, [
                    'onScroll',
                    'onScrollFrame',
                    'onScrollStart',
                    'onScrollStop',
                    'onUpdate',
                    'renderView',
                    'renderTrackHorizontal',
                    'renderTrackVertical',
                    'renderThumbHorizontal',
                    'renderThumbVertical',
                    'tagName',
                    'hideTracksWhenNotNeeded',
                    'autoHide',
                    'autoHideTimeout',
                    'autoHideDuration',
                    'thumbSize',
                    'thumbMinSize',
                    'universal',
                    'autoHeight',
                    'autoHeightMin',
                    'autoHeightMax',
                    'style',
                    'children'
                ]);
                /* eslint-enable no-unused-vars */ var didMountUniversal = this.state.didMountUniversal;
                var containerStyle = $6064277e05de6a97$var$_extends({}, $afd0ebd5164789fa$exports.containerStyleDefault, autoHeight && $6064277e05de6a97$var$_extends({}, $afd0ebd5164789fa$exports.containerStyleAutoHeight, {
                    minHeight: autoHeightMin,
                    maxHeight: autoHeightMax
                }), style);
                var viewStyle = $6064277e05de6a97$var$_extends({}, $afd0ebd5164789fa$exports.viewStyleDefault, {
                    // Hide scrollbars by setting a negative margin
                    marginRight: scrollbarWidth ? -scrollbarWidth : 0,
                    marginBottom: scrollbarWidth ? -scrollbarWidth : 0
                }, autoHeight && $6064277e05de6a97$var$_extends({}, $afd0ebd5164789fa$exports.viewStyleAutoHeight, {
                    // Add scrollbarWidth to autoHeight in order to compensate negative margins
                    minHeight: (0, $6064277e05de6a97$var$_isString2["default"])(autoHeightMin) ? 'calc(' + autoHeightMin + ' + ' + scrollbarWidth + 'px)' : autoHeightMin + scrollbarWidth,
                    maxHeight: (0, $6064277e05de6a97$var$_isString2["default"])(autoHeightMax) ? 'calc(' + autoHeightMax + ' + ' + scrollbarWidth + 'px)' : autoHeightMax + scrollbarWidth
                }), autoHeight && universal && !didMountUniversal && {
                    minHeight: autoHeightMin,
                    maxHeight: autoHeightMax
                }, universal && !didMountUniversal && $afd0ebd5164789fa$exports.viewStyleUniversalInitial);
                var trackAutoHeightStyle = {
                    transition: 'opacity ' + autoHideDuration + 'ms',
                    opacity: 0
                };
                var trackHorizontalStyle = $6064277e05de6a97$var$_extends({}, $afd0ebd5164789fa$exports.trackHorizontalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
                    display: 'none'
                });
                var trackVerticalStyle = $6064277e05de6a97$var$_extends({}, $afd0ebd5164789fa$exports.trackVerticalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
                    display: 'none'
                });
                return (0, $NdCUR.createElement)(tagName, $6064277e05de6a97$var$_extends({}, props, {
                    style: containerStyle,
                    ref: function ref(_ref3) {
                        _this7.container = _ref3;
                    }
                }), [
                    (0, $NdCUR.cloneElement)(renderView({
                        style: viewStyle
                    }), {
                        key: 'view',
                        ref: function ref(_ref4) {
                            _this7.view = _ref4;
                        }
                    }, children),
                    (0, $NdCUR.cloneElement)(renderTrackHorizontal({
                        style: trackHorizontalStyle
                    }), {
                        key: 'trackHorizontal',
                        ref: function ref(_ref5) {
                            _this7.trackHorizontal = _ref5;
                        }
                    }, (0, $NdCUR.cloneElement)(renderThumbHorizontal({
                        style: $afd0ebd5164789fa$exports.thumbHorizontalStyleDefault
                    }), {
                        ref: function ref(_ref6) {
                            _this7.thumbHorizontal = _ref6;
                        }
                    })),
                    (0, $NdCUR.cloneElement)(renderTrackVertical({
                        style: trackVerticalStyle
                    }), {
                        key: 'trackVertical',
                        ref: function ref(_ref7) {
                            _this7.trackVertical = _ref7;
                        }
                    }, (0, $NdCUR.cloneElement)(renderThumbVertical({
                        style: $afd0ebd5164789fa$exports.thumbVerticalStyleDefault
                    }), {
                        ref: function ref(_ref8) {
                            _this7.thumbVertical = _ref8;
                        }
                    }))
                ]);
            }
        }
    ]);
    return Scrollbars;
}($NdCUR.Component);
$6064277e05de6a97$exports["default"] = $6064277e05de6a97$var$Scrollbars;
$6064277e05de6a97$var$Scrollbars.propTypes = {
    onScroll: $6064277e05de6a97$var$_propTypes2["default"].func,
    onScrollFrame: $6064277e05de6a97$var$_propTypes2["default"].func,
    onScrollStart: $6064277e05de6a97$var$_propTypes2["default"].func,
    onScrollStop: $6064277e05de6a97$var$_propTypes2["default"].func,
    onUpdate: $6064277e05de6a97$var$_propTypes2["default"].func,
    renderView: $6064277e05de6a97$var$_propTypes2["default"].func,
    renderTrackHorizontal: $6064277e05de6a97$var$_propTypes2["default"].func,
    renderTrackVertical: $6064277e05de6a97$var$_propTypes2["default"].func,
    renderThumbHorizontal: $6064277e05de6a97$var$_propTypes2["default"].func,
    renderThumbVertical: $6064277e05de6a97$var$_propTypes2["default"].func,
    tagName: $6064277e05de6a97$var$_propTypes2["default"].string,
    thumbSize: $6064277e05de6a97$var$_propTypes2["default"].number,
    thumbMinSize: $6064277e05de6a97$var$_propTypes2["default"].number,
    hideTracksWhenNotNeeded: $6064277e05de6a97$var$_propTypes2["default"].bool,
    autoHide: $6064277e05de6a97$var$_propTypes2["default"].bool,
    autoHideTimeout: $6064277e05de6a97$var$_propTypes2["default"].number,
    autoHideDuration: $6064277e05de6a97$var$_propTypes2["default"].number,
    autoHeight: $6064277e05de6a97$var$_propTypes2["default"].bool,
    autoHeightMin: $6064277e05de6a97$var$_propTypes2["default"].oneOfType([
        $6064277e05de6a97$var$_propTypes2["default"].number,
        $6064277e05de6a97$var$_propTypes2["default"].string
    ]),
    autoHeightMax: $6064277e05de6a97$var$_propTypes2["default"].oneOfType([
        $6064277e05de6a97$var$_propTypes2["default"].number,
        $6064277e05de6a97$var$_propTypes2["default"].string
    ]),
    universal: $6064277e05de6a97$var$_propTypes2["default"].bool,
    style: $6064277e05de6a97$var$_propTypes2["default"].object,
    children: $6064277e05de6a97$var$_propTypes2["default"].node
};
$6064277e05de6a97$var$Scrollbars.defaultProps = {
    renderView: $1ec1dee2a75c4667$exports.renderViewDefault,
    renderTrackHorizontal: $1ec1dee2a75c4667$exports.renderTrackHorizontalDefault,
    renderTrackVertical: $1ec1dee2a75c4667$exports.renderTrackVerticalDefault,
    renderThumbHorizontal: $1ec1dee2a75c4667$exports.renderThumbHorizontalDefault,
    renderThumbVertical: $1ec1dee2a75c4667$exports.renderThumbVerticalDefault,
    tagName: 'div',
    thumbMinSize: 30,
    hideTracksWhenNotNeeded: false,
    autoHide: false,
    autoHideTimeout: 1000,
    autoHideDuration: 200,
    autoHeight: false,
    autoHeightMin: 0,
    autoHeightMax: 200,
    universal: false
};


var $5c857c96f4e15ca9$var$_Scrollbars2 = $5c857c96f4e15ca9$var$_interopRequireDefault($6064277e05de6a97$exports);
function $5c857c96f4e15ca9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
$5c857c96f4e15ca9$exports["default"] = $5c857c96f4e15ca9$var$_Scrollbars2["default"];
$5c857c96f4e15ca9$exports.Scrollbars = $5c857c96f4e15ca9$var$_Scrollbars2["default"];



class $fd3a484677319113$var$FancyScrollbar extends (0, $NdCUR.Component) {
    static{
        this.defaultProps = {
            autoHide: true,
            autoHeight: false,
            maxHeight: null,
            style: {},
            setScrollTop: ()=>{}
        };
    }
    constructor(props){
        super(props), this.handleMakeDiv = (className)=>(props)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                    ...props,
                    className: `fancy-scroll--${className}`
                });
            };
        this.ref = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createRef();
    }
    updateScroll() {
        const ref = this.ref.current;
        if (ref && !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isNil(this.props.scrollTop)) ref.scrollTop(this.props.scrollTop);
        if (ref && !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isNil(this.props.scrollLeft)) ref.scrollLeft(this.props.scrollLeft);
    }
    componentDidMount() {
        this.updateScroll();
    }
    componentDidUpdate() {
        this.updateScroll();
    }
    render() {
        const { autoHide: autoHide, autoHeight: autoHeight, children: children, className: className, maxHeight: maxHeight, setScrollTop: setScrollTop, style: style } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $5c857c96f4e15ca9$exports.Scrollbars), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('fancy-scroll--container', {
                [className]: className
            }),
            ref: this.ref,
            style: style,
            onScroll: setScrollTop,
            autoHide: autoHide,
            autoHideTimeout: 1000,
            autoHideDuration: 250,
            autoHeight: autoHeight,
            autoHeightMax: maxHeight,
            renderTrackHorizontal: this.handleMakeDiv('track-h'),
            renderTrackVertical: this.handleMakeDiv('track-v'),
            renderThumbHorizontal: this.handleMakeDiv('thumb-h'),
            renderThumbVertical: this.handleMakeDiv('thumb-v'),
            renderView: this.handleMakeDiv('view'),
            thumbMinSize: 30
        }, children);
    }
}
var $fd3a484677319113$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($fd3a484677319113$var$FancyScrollbar);





class $21e072852e81bd41$var$UserNavBlock extends (0, $NdCUR.PureComponent) {
    render() {
        const { logoutLink: logoutLink, me: me, links: links, meChangeOrg: meChangeOrg, header: header } = this.props;
        const extraModifier = header ? 'header' : 'sidenav';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: `sidebar--item sidebar--${extraModifier}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "sidebar--square"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "sidebar--icon icon user-outline"
        }), this.isSuperAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "sidebar--icon sidebar--icon__superadmin icon crown2"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: `sidebar-menu sidebar-menu--user-nav sidebar-menu--${extraModifier}`
        }, !!this.customLinks && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "sidebar-menu--section sidebar-menu--section__custom-links"
        }, "Custom Links"), !!this.customLinks && this.customLinks.map((link, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("a", {
                key: i,
                className: "sidebar-menu--item sidebar-menu--item__link-name",
                href: link.url,
                target: "_blank"
            }, link.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "sidebar-menu--section sidebar-menu--section__switch-orgs"
        }, "Switch Organizations"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), {
            className: "sidebar-menu--scrollbar",
            autoHeight: true,
            maxHeight: 100,
            autoHide: false
        }, me.roles.map((r, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $15c437711711b56c$export$2e2bcd8739ae039), {
                onMeChangeOrg: meChangeOrg,
                meLink: links.me,
                key: i,
                me: me,
                role: r
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "sidebar-menu--section sidebar-menu--section__account"
        }, "Account"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "sidebar-menu--provider"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null, me.scheme, " / ", me.provider)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("a", {
            className: "sidebar-menu--item sidebar-menu--item__logout",
            href: logoutLink
        }, "Log out"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "sidebar-menu--heading sidebar--no-hover"
        }, me.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "sidebar-menu--triangle"
        })));
    }
    get customLinks() {
        return this.props.links.external.custom;
    }
    get isSuperAdmin() {
        return this.props.me.role === (0, $a7910b1002260d34$export$ccd9fcc6ec6e7386);
    }
}
const $21e072852e81bd41$var$mdtp = {
    meChangeOrg: (0, $7af565d99d629ce9$export$5327fe44904ab84d)
};
var $21e072852e81bd41$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)(null, $21e072852e81bd41$var$mdtp)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($21e072852e81bd41$var$UserNavBlock));



var $NdCUR = parcelRequire("NdCUR");


var $1v7mg = parcelRequire("1v7mg");

var $hBdgJ = parcelRequire("hBdgJ");
const $22b2b2dcb11b543a$export$fb2cdcb3115dd74c = ({ link: link, children: children, location: location, useAnchor: useAnchor, isExternal: isExternal })=>{
    const isActive = location.startsWith(link);
    return useAnchor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("a", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('sidebar-menu--item', {
            active: isActive
        }),
        href: link,
        target: isExternal ? '_blank' : '_self'
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ba1cc4424c00aefe$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('sidebar-menu--item', {
            active: isActive
        }),
        to: link
    }, children);
};
const $22b2b2dcb11b543a$export$5cd4c9f17c82d9bc = ({ link: link, title: title, useAnchor: useAnchor })=>{
    // Some nav items, such as Logout, need to hit an external link rather
    // than simply route to an internal page. Anchor tags serve that purpose.
    return useAnchor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("a", {
        className: "sidebar-menu--heading",
        href: link
    }, title) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ba1cc4424c00aefe$export$2e2bcd8739ae039), {
        className: "sidebar-menu--heading",
        to: link
    }, title);
};
class $22b2b2dcb11b543a$export$eaccebc2e2bd8125 extends (0, $NdCUR.PureComponent) {
    render() {
        const { location: location, className: className, highlightWhen: highlightWhen, highlightUnless: highlightUnless } = this.props;
        const locationParts = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).split(location, '/');
        const { length: length } = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).intersection(locationParts, highlightWhen);
        let isActive = !!length;
        if (isActive && highlightUnless) isActive = !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).intersection(locationParts, highlightUnless);
        const children = (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Children.map(this.props.children, (child)=>{
            // FIXME
            if (child && String(child.type) === String($22b2b2dcb11b543a$export$fb2cdcb3115dd74c)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).cloneElement(child, {
                location: location
            });
            return child;
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('sidebar--item', className, {
                active: isActive
            })
        }, this.renderSquare(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "sidebar-menu"
        }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "sidebar-menu--triangle"
        })));
    }
    renderSquare() {
        const { link: link, icon: icon } = this.props;
        if (!link) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "sidebar--square"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: `sidebar--icon icon ${icon}`
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ba1cc4424c00aefe$export$2e2bcd8739ae039), {
            className: "sidebar--square",
            to: link
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: `sidebar--icon icon ${icon}`
        }));
    }
}




class $9e001ca9bd079f2c$var$SideNav extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props);
    }
    render() {
        const { params: { sourceID: sourceID }, location: { pathname: location }, isHidden: isHidden, isUsingAuth: isUsingAuth, logoutLink: logoutLink, links: links, me: me, env: env, sources: sources = [] } = this.props;
        const defaultSource = sources.find((s)=>s.default);
        const id = sourceID || (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(defaultSource, 'id', 0);
        if (isUsingAuth && !(0, $a7910b1002260d34$export$7d499847c5200082)(me.role, (0, $a7910b1002260d34$export$1d39a112fd67439d))) // sidenav is available at least for VIEWER_ROLE
        return null;
        const sourcePrefix = `/sources/${id}`;
        const dataExplorerLink = `${sourcePrefix}/chronograf/data-explorer`;
        const isDefaultPage = location.split('/').includes((0, $e10a8602f56394e3$export$d35773d450f5d6df));
        const hostPageIsEnabled = !env.hostPageDisabled;
        return isHidden ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("nav", {
            className: "sidebar",
            "data-test": "sidebar"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: isDefaultPage ? 'sidebar--item active' : 'sidebar--item'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ba1cc4424c00aefe$export$2e2bcd8739ae039), {
            to: `${sourcePrefix}/${(0, $e10a8602f56394e3$export$d35773d450f5d6df)}`,
            className: "sidebar--square sidebar--logo"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "sidebar--icon icon cubo-uniform"
        }))), hostPageIsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $22b2b2dcb11b543a$export$eaccebc2e2bd8125), {
            highlightWhen: [
                'hosts'
            ],
            icon: "eye",
            link: `${sourcePrefix}/hosts`,
            location: location
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $22b2b2dcb11b543a$export$5cd4c9f17c82d9bc), {
            link: `${sourcePrefix}/hosts`,
            title: "Host List"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $22b2b2dcb11b543a$export$eaccebc2e2bd8125), {
            highlightWhen: [
                'data-explorer'
            ],
            icon: "graphline-2",
            link: dataExplorerLink,
            location: location
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $22b2b2dcb11b543a$export$5cd4c9f17c82d9bc), {
            link: dataExplorerLink,
            title: "Explore"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $22b2b2dcb11b543a$export$eaccebc2e2bd8125), {
            highlightWhen: [
                'dashboards'
            ],
            icon: "dash-j",
            link: `${sourcePrefix}/dashboards`,
            location: location
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $22b2b2dcb11b543a$export$5cd4c9f17c82d9bc), {
            link: `${sourcePrefix}/dashboards`,
            title: "Dashboards"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $22b2b2dcb11b543a$export$eaccebc2e2bd8125), {
            highlightWhen: [
                'alerts',
                'alert-rules',
                'tickscript',
                'tickscripts',
                'flux-tasks',
                'fluxtasks'
            ],
            icon: "alerts",
            link: `${sourcePrefix}/alert-rules`,
            location: location
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $22b2b2dcb11b543a$export$5cd4c9f17c82d9bc), {
            link: `${sourcePrefix}/tickscripts`,
            title: "Alerting"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $22b2b2dcb11b543a$export$fb2cdcb3115dd74c), {
            link: `${sourcePrefix}/alert-rules`
        }, "Alert Rules"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $22b2b2dcb11b543a$export$fb2cdcb3115dd74c), {
            link: `${sourcePrefix}/tickscripts`
        }, "TICKscripts"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $22b2b2dcb11b543a$export$fb2cdcb3115dd74c), {
            link: `${sourcePrefix}/flux-tasks`
        }, "Flux Tasks"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $22b2b2dcb11b543a$export$fb2cdcb3115dd74c), {
            link: `${sourcePrefix}/alerts`
        }, "Alert History")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $22b2b2dcb11b543a$export$eaccebc2e2bd8125), {
            highlightWhen: [
                'logs'
            ],
            icon: "wood",
            link: "/logs",
            location: location
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $22b2b2dcb11b543a$export$5cd4c9f17c82d9bc), {
            link: '/logs',
            title: "Log Viewer"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $091cfcd49e339acd$export$2e2bcd8739ae039), {
            requiredRole: (0, $a7910b1002260d34$export$856b7354d850707e),
            replaceWithIfNotUsingAuth: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $22b2b2dcb11b543a$export$eaccebc2e2bd8125), {
                highlightWhen: [
                    'admin-influxdb'
                ],
                icon: "crown-outline",
                link: `${sourcePrefix}/admin-influxdb/databases`,
                location: location
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $22b2b2dcb11b543a$export$5cd4c9f17c82d9bc), {
                link: `${sourcePrefix}/admin-influxdb/databases`,
                title: "InfluxDB Admin"
            }))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $22b2b2dcb11b543a$export$eaccebc2e2bd8125), {
            highlightWhen: [
                'admin-chronograf',
                'admin-influxdb'
            ],
            icon: "crown-outline",
            link: `${sourcePrefix}/admin-chronograf/current-organization`,
            location: location
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $22b2b2dcb11b543a$export$5cd4c9f17c82d9bc), {
            link: `${sourcePrefix}/admin-chronograf/current-organization`,
            title: "Admin"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $22b2b2dcb11b543a$export$fb2cdcb3115dd74c), {
            link: `${sourcePrefix}/admin-chronograf/current-organization`
        }, "Chronograf"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $22b2b2dcb11b543a$export$fb2cdcb3115dd74c), {
            link: `${sourcePrefix}/admin-influxdb/databases`
        }, "InfluxDB"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $22b2b2dcb11b543a$export$eaccebc2e2bd8125), {
            highlightWhen: [
                'manage-sources',
                'kapacitors'
            ],
            highlightUnless: [
                'alert-rules',
                'tickscripts',
                'fluxtasks'
            ],
            icon: "wrench",
            link: `${sourcePrefix}/manage-sources`,
            location: location
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $22b2b2dcb11b543a$export$5cd4c9f17c82d9bc), {
            link: `${sourcePrefix}/manage-sources`,
            title: "Configuration"
        })), isUsingAuth && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21e072852e81bd41$export$2e2bcd8739ae039), {
            logoutLink: logoutLink,
            links: links,
            me: me
        }));
    }
}
const $9e001ca9bd079f2c$var$mapStateToProps = ({ sources: sources, auth: { isUsingAuth: isUsingAuth, logoutLink: logoutLink, me: me }, app: { ephemeral: { inPresentationMode: inPresentationMode } }, links: links, env: env })=>({
        sources: sources,
        isHidden: inPresentationMode,
        isUsingAuth: isUsingAuth,
        logoutLink: logoutLink,
        links: links,
        env: env,
        me: me
    });
var $9e001ca9bd079f2c$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($9e001ca9bd079f2c$var$mapStateToProps)((0, $dffbdf89c590a961$export$2e2bcd8739ae039)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($9e001ca9bd079f2c$var$SideNav)));


var $a2fd61a41165de5f$export$2e2bcd8739ae039 = (0, $9e001ca9bd079f2c$export$2e2bcd8739ae039);



var $NdCUR = parcelRequire("NdCUR");


var $NdCUR = parcelRequire("NdCUR");



var $1v7mg = parcelRequire("1v7mg");



class $12d6cf5ce555f10d$var$Notification extends (0, $NdCUR.Component) {
    constructor(props){
        super(props), this.updateHeight = ()=>{
            if (this.notificationRef) {
                const { height: height } = this.notificationRef.getBoundingClientRect();
                this.setState({
                    height: height
                });
            }
        }, this.handleDismiss = ()=>{
            const { notification: { id: id }, dismissNotification: dismissNotification } = this.props;
            this.setState({
                dismissed: true
            });
            this.deletionTimer = window.setTimeout(()=>dismissNotification(id), (0, $e10a8602f56394e3$export$607dbadbbbb4f68b));
        }, this.handleNotificationRef = (ref)=>{
            this.notificationRef = ref;
            this.updateHeight();
        };
        this.state = {
            opacity: 1,
            height: 0,
            dismissed: false
        };
    }
    componentDidMount() {
        const { notification: { duration: duration } } = this.props;
        this.updateHeight();
        if (duration >= 0) // Automatically dismiss notification after duration prop
        this.dismissalTimer = window.setTimeout(this.handleDismiss, duration);
    }
    componentWillUnmount() {
        clearTimeout(this.dismissalTimer);
        clearTimeout(this.deletionTimer);
    }
    render() {
        const { notification: { message: message, icon: icon } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.containerClassname,
            style: this.notificationStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.notificationClassname,
            ref: this.handleNotificationRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: `icon ${icon}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "notification-message"
        }, message), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "notification-close",
            onClick: this.handleDismiss
        })));
    }
    get notificationClassname() {
        const { notification: { type: type } } = this.props;
        return `notification notification-${type}`;
    }
    get containerClassname() {
        const { height: height, dismissed: dismissed } = this.state;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('notification-container', {
            show: !!height,
            'notification-dismissed': dismissed
        });
    }
    get notificationStyle() {
        const { height: height } = this.state;
        const NOTIFICATION_MARGIN = 4;
        return {
            height: height + NOTIFICATION_MARGIN
        };
    }
}
const $12d6cf5ce555f10d$var$mapDispatchToProps = (dispatch)=>({
        dismissNotification: (0, $1f80bbeadc1a0021$export$2e2bcd8739ae039)((0, $205d139de2918454$export$de4868f3e9cc2a4e), dispatch)
    });
var $12d6cf5ce555f10d$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)(null, $12d6cf5ce555f10d$var$mapDispatchToProps)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($12d6cf5ce555f10d$var$Notification));


class $6c7f63564a51019c$var$Notifications extends (0, $NdCUR.PureComponent) {
    static{
        this.defaultProps = {
            inPresentationMode: false
        };
    }
    render() {
        const { notifications: notifications } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.className
        }, notifications.map((n)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $12d6cf5ce555f10d$export$2e2bcd8739ae039), {
                key: n.id,
                notification: n
            })));
    }
    get className() {
        const { inPresentationMode: inPresentationMode } = this.props;
        if (inPresentationMode) return 'notification-center__presentation-mode';
        return 'notification-center';
    }
}
const $6c7f63564a51019c$var$mapStateToProps = ({ notifications: notifications, app: { ephemeral: { inPresentationMode: inPresentationMode } } })=>({
        notifications: notifications,
        inPresentationMode: inPresentationMode
    });
var $6c7f63564a51019c$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($6c7f63564a51019c$var$mapStateToProps, null)($6c7f63564a51019c$var$Notifications);


const $8678b5e670940e88$var$App = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "chronograf-root"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $6c7f63564a51019c$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a2fd61a41165de5f$export$2e2bcd8739ae039), null), children);
var $8678b5e670940e88$export$2e2bcd8739ae039 = $8678b5e670940e88$var$App;



var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");


var $NdCUR = parcelRequire("NdCUR");
const $810ad5a94daa03b8$var$PageSpinner = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "page-spinner-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "page-spinner"
    }));
};
var $810ad5a94daa03b8$export$2e2bcd8739ae039 = $810ad5a94daa03b8$var$PageSpinner;



var $NdCUR = parcelRequire("NdCUR");
const $2f116926a5c97d9d$var$SplashPage = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "auth-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "auth-box"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "auth-logo"
    }), children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", {
        className: "auth-credits"
    }, "Made by ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        className: "icon cubo-uniform"
    }), "InfluxData"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "auth-image"
    }));
var $2f116926a5c97d9d$export$2e2bcd8739ae039 = $2f116926a5c97d9d$var$SplashPage;




const $985a502d70a1bfe1$var$REDIRECT_KEY = 'chronoRedirect';
function $985a502d70a1bfe1$var$storeRedirectPath() {
    try {
        const url = new URL(window.location.href);
        const redirect = url.searchParams.get('redirect');
        window.localStorage.setItem($985a502d70a1bfe1$var$REDIRECT_KEY, redirect || '');
    } catch (e) {
    // will perform default redirect if localStorage is not available
    }
}
function $985a502d70a1bfe1$export$d164ee800969599c() {
    let retVal;
    try {
        retVal = window.localStorage.getItem($985a502d70a1bfe1$var$REDIRECT_KEY);
        window.localStorage.removeItem($985a502d70a1bfe1$var$REDIRECT_KEY);
    } catch (e) {
    // localStorage is not available, use default
    }
    // return redirect to localStorage page or root page
    return retVal || '/';
}
const $985a502d70a1bfe1$var$Login = ({ auth: auth })=>{
    if (Array.isArray(auth.links) && auth.links.length === 1 && auth.links[0].redirectLogin) window.location.href = auth.links[0].login;
    if (auth.isAuthLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $810ad5a94daa03b8$export$2e2bcd8739ae039), null);
    $985a502d70a1bfe1$var$storeRedirectPath();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $6c7f63564a51019c$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $2f116926a5c97d9d$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h1", {
        className: "auth-text-logo"
    }, "Chronograf"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("strong", null, (0, $e10a8602f56394e3$export$a4ad2735b021c132)), " / Time-Series Data Visualization"), auth.links && auth.links.map(({ name: name, login: login, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("a", {
            key: name,
            className: "btn btn-primary",
            href: login
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: `icon ${name}`
        }), "Log in with ", label))));
};
const { array: $985a502d70a1bfe1$var$array, bool: $985a502d70a1bfe1$var$bool, shape: $985a502d70a1bfe1$var$shape } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$985a502d70a1bfe1$var$Login.propTypes = {
    auth: $985a502d70a1bfe1$var$shape({
        me: $985a502d70a1bfe1$var$shape(),
        links: $985a502d70a1bfe1$var$array,
        isLoading: $985a502d70a1bfe1$var$bool
    })
};
const $985a502d70a1bfe1$var$mapStateToProps = ({ auth: auth })=>({
        auth: auth
    });
var $985a502d70a1bfe1$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($985a502d70a1bfe1$var$mapStateToProps, null)($985a502d70a1bfe1$var$Login);



var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");







var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");

const $72621ec5defabef3$var$PurgatoryAuthItem = ({ roleAndOrg: roleAndOrg, onClickLogin: onClickLogin, superAdmin: superAdmin })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: roleAndOrg.currentOrganization ? 'auth--list-item current' : 'auth--list-item'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "auth--list-info"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "auth--list-org"
    }, roleAndOrg.organization.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "auth--list-role"
    }, roleAndOrg.role)), superAdmin || (0, $a7910b1002260d34$export$7d499847c5200082)(roleAndOrg.role, (0, $a7910b1002260d34$export$62bbf68aca1809f0)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
        className: "btn btn-sm btn-primary",
        onClick: onClickLogin(roleAndOrg.organization)
    }, "Log in") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        className: "auth--list-blocked"
    }, "Contact your Admin", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("br", null), "for access"));
const { bool: $72621ec5defabef3$var$bool, func: $72621ec5defabef3$var$func, shape: $72621ec5defabef3$var$shape, string: $72621ec5defabef3$var$string } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$72621ec5defabef3$var$PurgatoryAuthItem.propTypes = {
    roleAndOrg: $72621ec5defabef3$var$shape({
        organization: $72621ec5defabef3$var$shape({
            name: $72621ec5defabef3$var$string,
            id: $72621ec5defabef3$var$string
        }),
        role: $72621ec5defabef3$var$string,
        currentOrganization: $72621ec5defabef3$var$bool
    }).isRequired,
    superAdmin: $72621ec5defabef3$var$bool,
    onClickLogin: $72621ec5defabef3$var$func.isRequired
};
var $72621ec5defabef3$export$2e2bcd8739ae039 = $72621ec5defabef3$var$PurgatoryAuthItem;


const $9de6e52768b61007$var$getRoleNameByOrgID = (id, roles)=>{
    const role = roles.find((r)=>r.organization === id);
    return role && role.name || 'ghost';
};
const $9de6e52768b61007$var$handleClickLogin = (props)=>(organization)=>async (e)=>{
            e.preventDefault();
            const { router: router, links: links, meChangeOrganization: meChangeOrganization } = props;
            await meChangeOrganization(links.me, {
                organization: organization.id
            });
            router.push('');
        };
class $9de6e52768b61007$var$Purgatory extends (0, $NdCUR.Component) {
    UNSAFE_componentWillUpdate() {
        const { router: router, me: me } = this.props;
        if (me === null) router.push('/login');
    }
    render() {
        const { me: me, meChangeOrganization: meChangeOrganization, logoutLink: logoutLink, router: router, links: links } = this.props;
        if (me === null) return null;
        const { name: name, provider: provider, scheme: scheme, currentOrganization: currentOrganization, roles: roles, organizations: organizations, superAdmin: superAdmin } = me;
        const rolesAndOrgs = organizations.map((organization)=>({
                organization: organization,
                role: $9de6e52768b61007$var$getRoleNameByOrgID(organization.id, roles),
                currentOrganization: organization.id === currentOrganization.id
            }));
        const subHeading = rolesAndOrgs.length === 1 ? 'Authenticated in 1 Organization' : `Authenticated in ${rolesAndOrgs.length} Organizations`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $6c7f63564a51019c$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $2f116926a5c97d9d$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "auth--purgatory"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h3", null, name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h6", null, subHeading, ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("code", null, scheme, "/", provider)), rolesAndOrgs.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "auth--list"
        }, rolesAndOrgs.map((rag, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $72621ec5defabef3$export$2e2bcd8739ae039), {
                key: i,
                roleAndOrg: rag,
                superAdmin: superAdmin,
                onClickLogin: $9de6e52768b61007$var$handleClickLogin({
                    router: router,
                    links: links,
                    meChangeOrganization: meChangeOrganization
                })
            }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, "You are a Lost Soul"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("a", {
            href: logoutLink,
            className: "btn btn-sm btn-link auth--logout"
        }, "Log out"))));
    }
}
const { arrayOf: $9de6e52768b61007$var$arrayOf, bool: $9de6e52768b61007$var$bool, func: $9de6e52768b61007$var$func, shape: $9de6e52768b61007$var$shape, string: $9de6e52768b61007$var$string } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$9de6e52768b61007$var$Purgatory.propTypes = {
    router: $9de6e52768b61007$var$shape({
        push: $9de6e52768b61007$var$func.isRequired
    }).isRequired,
    links: $9de6e52768b61007$var$shape({
        me: $9de6e52768b61007$var$string
    }),
    me: $9de6e52768b61007$var$shape({
        name: $9de6e52768b61007$var$string.isRequired,
        provider: $9de6e52768b61007$var$string.isRequired,
        scheme: $9de6e52768b61007$var$string.isRequired,
        currentOrganization: $9de6e52768b61007$var$shape({
            id: $9de6e52768b61007$var$string.isRequired,
            name: $9de6e52768b61007$var$string.isRequired
        }).isRequired,
        roles: $9de6e52768b61007$var$arrayOf($9de6e52768b61007$var$shape({
            name: $9de6e52768b61007$var$string,
            organization: $9de6e52768b61007$var$string
        })).isRequired,
        organizations: $9de6e52768b61007$var$arrayOf($9de6e52768b61007$var$shape({
            id: $9de6e52768b61007$var$string,
            name: $9de6e52768b61007$var$string
        })).isRequired,
        superAdmin: $9de6e52768b61007$var$bool
    }),
    logoutLink: $9de6e52768b61007$var$string,
    meChangeOrganization: $9de6e52768b61007$var$func.isRequired
};
const $9de6e52768b61007$var$mapStateToProps = ({ links: links, auth: { me: me, logoutLink: logoutLink } })=>({
        links: links,
        logoutLink: logoutLink,
        me: me
    });
const $9de6e52768b61007$var$mapDispatchToProps = (dispatch)=>({
        meChangeOrganization: (0, $1f80bbeadc1a0021$export$2e2bcd8739ae039)((0, $7af565d99d629ce9$export$5327fe44904ab84d), dispatch)
    });
var $9de6e52768b61007$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($9de6e52768b61007$var$mapStateToProps, $9de6e52768b61007$var$mapDispatchToProps)((0, $dffbdf89c590a961$export$2e2bcd8739ae039)($9de6e52768b61007$var$Purgatory));




var $7be03f09a1b1e4ca$exports = {};
'use strict';
Object.defineProperty($7be03f09a1b1e4ca$exports, "__esModule", {
    value: true
});
$7be03f09a1b1e4ca$exports.createOnEnter = $7be03f09a1b1e4ca$exports.connectedReduxRedirect = $7be03f09a1b1e4ca$exports.connectedRouterRedirect = undefined;
var $7be03f09a1b1e4ca$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $1fa5154d9ed0576d$exports = {};
'use strict';
Object.defineProperty($1fa5154d9ed0576d$exports, "__esModule", {
    value: true
});
var $1fa5154d9ed0576d$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $1pxUG = parcelRequire("1pxUG");
var $1fa5154d9ed0576d$var$_url2 = $1fa5154d9ed0576d$var$_interopRequireDefault($1pxUG);
function $1fa5154d9ed0576d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1fa5154d9ed0576d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $1fa5154d9ed0576d$var$defaults = {
    redirectQueryParamName: 'redirect',
    locationSelector: function locationSelector(_ref) {
        var location = _ref.location;
        return location;
    }
};
$1fa5154d9ed0576d$exports.default = function(args) {
    var _defaults$args = $1fa5154d9ed0576d$var$_extends({}, $1fa5154d9ed0576d$var$defaults, args), redirectQueryParamName = _defaults$args.redirectQueryParamName, locationSelector = _defaults$args.locationSelector;
    var getRedirectQueryParam = function getRedirectQueryParam(props) {
        var location = locationSelector(props);
        return location.query[redirectQueryParamName];
    };
    var createRedirectLoc = function createRedirectLoc(allowRedirectBack) {
        return function(props, redirectPath) {
            var location = locationSelector(props);
            var redirectLoc = $1fa5154d9ed0576d$var$_url2.default.parse(redirectPath, true);
            var query = void 0;
            if (allowRedirectBack) query = $1fa5154d9ed0576d$var$_defineProperty({}, redirectQueryParamName, '' + location.pathname + location.search + location.hash);
            else query = {};
            query = $1fa5154d9ed0576d$var$_extends({}, query, redirectLoc.query);
            return {
                pathname: redirectLoc.pathname,
                hash: redirectLoc.hash,
                query: query
            };
        };
    };
    return {
        getRedirectQueryParam: getRedirectQueryParam,
        createRedirectLoc: createRedirectLoc
    };
};


var $7be03f09a1b1e4ca$var$_locationHelper2 = $7be03f09a1b1e4ca$var$_interopRequireDefault($1fa5154d9ed0576d$exports);
var $d6f8f157b9195453$exports = {};
'use strict';
Object.defineProperty($d6f8f157b9195453$exports, "__esModule", {
    value: true
});
var $d6f8f157b9195453$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};


var $d6f8f157b9195453$var$_invariant2 = $d6f8f157b9195453$var$_interopRequireDefault($06dab2fcf604e778$exports);
var $135816f3dac9e1fa$exports = {};
'use strict';
Object.defineProperty($135816f3dac9e1fa$exports, "__esModule", {
    value: true
});
var $135816f3dac9e1fa$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $135816f3dac9e1fa$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $NdCUR = parcelRequire("NdCUR");
var $135816f3dac9e1fa$var$_react2 = $135816f3dac9e1fa$var$_interopRequireDefault($NdCUR);

var $fGw9V = parcelRequire("fGw9V");
var $135816f3dac9e1fa$var$_propTypes2 = $135816f3dac9e1fa$var$_interopRequireDefault($fGw9V);

var $135816f3dac9e1fa$var$_hoistNonReactStatics2 = $135816f3dac9e1fa$var$_interopRequireDefault($cc6303404373807d$exports);
function $135816f3dac9e1fa$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $135816f3dac9e1fa$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $135816f3dac9e1fa$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $135816f3dac9e1fa$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $135816f3dac9e1fa$var$defaults = {
    AuthenticatingComponent: function AuthenticatingComponent() {
        return null;
    },
    FailureComponent: function FailureComponent() {
        return null;
    },
    wrapperDisplayName: 'AuthWrapper'
};
$135816f3dac9e1fa$exports.default = function(args) {
    var _defaults$args = $135816f3dac9e1fa$var$_extends({}, $135816f3dac9e1fa$var$defaults, args), AuthenticatingComponent = _defaults$args.AuthenticatingComponent, FailureComponent = _defaults$args.FailureComponent, wrapperDisplayName = _defaults$args.wrapperDisplayName;
    // Wraps the component that needs the auth enforcement
    function wrapComponent(DecoratedComponent) {
        var _class, _temp;
        var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
        var UserAuthWrapper = (_temp = _class = function(_Component) {
            $135816f3dac9e1fa$var$_inherits(UserAuthWrapper, _Component);
            function UserAuthWrapper() {
                $135816f3dac9e1fa$var$_classCallCheck(this, UserAuthWrapper);
                return $135816f3dac9e1fa$var$_possibleConstructorReturn(this, (UserAuthWrapper.__proto__ || Object.getPrototypeOf(UserAuthWrapper)).apply(this, arguments));
            }
            $135816f3dac9e1fa$var$_createClass(UserAuthWrapper, [
                {
                    key: 'render',
                    value: function render() {
                        var _props = this.props, isAuthenticated = _props.isAuthenticated, isAuthenticating = _props.isAuthenticating;
                        if (isAuthenticated) return $135816f3dac9e1fa$var$_react2.default.createElement(DecoratedComponent, this.props);
                        else if (isAuthenticating) return $135816f3dac9e1fa$var$_react2.default.createElement(AuthenticatingComponent, this.props);
                        else return $135816f3dac9e1fa$var$_react2.default.createElement(FailureComponent, this.props);
                    }
                }
            ]);
            return UserAuthWrapper;
        }($NdCUR.Component), _class.displayName = wrapperDisplayName + '(' + displayName + ')', _class.propTypes = {
            isAuthenticated: $135816f3dac9e1fa$var$_propTypes2.default.bool,
            isAuthenticating: $135816f3dac9e1fa$var$_propTypes2.default.bool
        }, _class.defaultProps = {
            isAuthenticating: false
        }, _temp);
        return (0, $135816f3dac9e1fa$var$_hoistNonReactStatics2.default)(UserAuthWrapper, DecoratedComponent);
    }
    return wrapComponent;
};


var $d6f8f157b9195453$var$_authWrapper2 = $d6f8f157b9195453$var$_interopRequireDefault($135816f3dac9e1fa$exports);
var $3d5702144e4d20ac$exports = {};
'use strict';
Object.defineProperty($3d5702144e4d20ac$exports, "__esModule", {
    value: true
});
$3d5702144e4d20ac$exports.default = undefined;
var $3d5702144e4d20ac$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $3d5702144e4d20ac$var$_class, $3d5702144e4d20ac$var$_temp;

var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");
var $3d5702144e4d20ac$var$_propTypes2 = $3d5702144e4d20ac$var$_interopRequireDefault($fGw9V);
function $3d5702144e4d20ac$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3d5702144e4d20ac$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3d5702144e4d20ac$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $3d5702144e4d20ac$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $3d5702144e4d20ac$var$Redirect = ($3d5702144e4d20ac$var$_temp = $3d5702144e4d20ac$var$_class = function(_Component) {
    $3d5702144e4d20ac$var$_inherits(Redirect, _Component);
    function Redirect() {
        $3d5702144e4d20ac$var$_classCallCheck(this, Redirect);
        return $3d5702144e4d20ac$var$_possibleConstructorReturn(this, (Redirect.__proto__ || Object.getPrototypeOf(Redirect)).apply(this, arguments));
    }
    $3d5702144e4d20ac$var$_createClass(Redirect, [
        {
            key: 'UNSAFE_componentWillMount',
            value: function UNSAFE_componentWillMount() {
                this.props.redirect(this.props, this.props.redirectPath);
            }
        },
        {
            key: 'render',
            value: function render() {
                // Redirect should happen before this is rendered
                return null;
            }
        }
    ]);
    return Redirect;
}($NdCUR.Component), $3d5702144e4d20ac$var$_class.propTypes = {
    redirectPath: $3d5702144e4d20ac$var$_propTypes2.default.string.isRequired,
    redirect: $3d5702144e4d20ac$var$_propTypes2.default.func.isRequired
}, $3d5702144e4d20ac$var$_temp);
$3d5702144e4d20ac$exports.default = $3d5702144e4d20ac$var$Redirect;


var $d6f8f157b9195453$var$_redirect2 = $d6f8f157b9195453$var$_interopRequireDefault($3d5702144e4d20ac$exports);
function $d6f8f157b9195453$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d6f8f157b9195453$var$connectedDefaults = {
    authenticatingSelector: function authenticatingSelector() {
        return false;
    },
    allowRedirectBack: true,
    FailureComponent: $d6f8f157b9195453$var$_redirect2.default,
    redirectQueryParamName: 'redirect'
};
$d6f8f157b9195453$exports.default = function(_ref) {
    var locationHelperBuilder = _ref.locationHelperBuilder, getRouterRedirect = _ref.getRouterRedirect;
    var connectedRouterRedirect = function connectedRouterRedirect(args) {
        var allArgs = $d6f8f157b9195453$var$_extends({}, $d6f8f157b9195453$var$connectedDefaults, args);
        var FailureComponent = allArgs.FailureComponent, redirectPath = allArgs.redirectPath, authenticatedSelector = allArgs.authenticatedSelector, authenticatingSelector = allArgs.authenticatingSelector, allowRedirectBack = allArgs.allowRedirectBack, redirectQueryParamName = allArgs.redirectQueryParamName;
        var _locationHelperBuilde = locationHelperBuilder({
            redirectQueryParamName: redirectQueryParamName
        }), createRedirectLoc = _locationHelperBuilde.createRedirectLoc;
        var redirectPathSelector = void 0;
        if (typeof redirectPath === 'string') redirectPathSelector = function redirectPathSelector() {
            return redirectPath;
        };
        else if (typeof redirectPath === 'function') redirectPathSelector = redirectPath;
        else (0, $d6f8f157b9195453$var$_invariant2.default)(false, 'redirectPath must be either a string or a function');
        var allowRedirectBackFn = void 0;
        if (typeof allowRedirectBack === 'boolean') allowRedirectBackFn = function allowRedirectBackFn() {
            return allowRedirectBack;
        };
        else if (typeof allowRedirectBack === 'function') allowRedirectBackFn = allowRedirectBack;
        else (0, $d6f8f157b9195453$var$_invariant2.default)(false, 'allowRedirectBack must be either a boolean or a function');
        var redirect = function redirect(replace) {
            return function(props, path) {
                return replace(createRedirectLoc(allowRedirectBackFn(props, path))(props, path));
            };
        };
        var ConnectedFailureComponent = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)(function(state, ownProps) {
            return {
                redirect: redirect(getRouterRedirect(ownProps))
            };
        })(FailureComponent);
        return function(DecoratedComponent) {
            return (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)(function(state, ownProps) {
                return {
                    redirectPath: redirectPathSelector(state, ownProps),
                    isAuthenticated: authenticatedSelector(state, ownProps),
                    isAuthenticating: authenticatingSelector(state, ownProps)
                };
            })((0, $d6f8f157b9195453$var$_authWrapper2.default)($d6f8f157b9195453$var$_extends({}, allArgs, {
                FailureComponent: ConnectedFailureComponent
            }))(DecoratedComponent));
        };
    };
    var connectedReduxRedirect = function connectedReduxRedirect(args) {
        var allArgs = $d6f8f157b9195453$var$_extends({}, $d6f8f157b9195453$var$connectedDefaults, args);
        var FailureComponent = allArgs.FailureComponent, redirectPath = allArgs.redirectPath, authenticatedSelector = allArgs.authenticatedSelector, authenticatingSelector = allArgs.authenticatingSelector, allowRedirectBack = allArgs.allowRedirectBack, redirectAction = allArgs.redirectAction, redirectQueryParamName = allArgs.redirectQueryParamName;
        var _locationHelperBuilde2 = locationHelperBuilder({
            redirectQueryParamName: redirectQueryParamName
        }), createRedirectLoc = _locationHelperBuilde2.createRedirectLoc;
        var redirectPathSelector = void 0;
        if (typeof redirectPath === 'string') redirectPathSelector = function redirectPathSelector() {
            return redirectPath;
        };
        else if (typeof redirectPath === 'function') redirectPathSelector = redirectPath;
        else (0, $d6f8f157b9195453$var$_invariant2.default)(false, 'redirectPath must be either a string or a function');
        var allowRedirectBackFn = void 0;
        if (typeof allowRedirectBack === 'boolean') allowRedirectBackFn = function allowRedirectBackFn() {
            return allowRedirectBack;
        };
        else if (typeof allowRedirectBack === 'function') allowRedirectBackFn = allowRedirectBack;
        else (0, $d6f8f157b9195453$var$_invariant2.default)(false, 'allowRedirectBack must be either a boolean or a function');
        var createRedirect = function createRedirect(dispatch) {
            return {
                redirect: function redirect(props, path) {
                    return dispatch(redirectAction(createRedirectLoc(allowRedirectBackFn(props, path))(props, path)));
                }
            };
        };
        var ConnectedFailureComponent = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)(null, createRedirect)(FailureComponent);
        return function(DecoratedComponent) {
            return (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)(function(state, ownProps) {
                return {
                    redirectPath: redirectPathSelector(state, ownProps),
                    isAuthenticated: authenticatedSelector(state, ownProps),
                    isAuthenticating: authenticatingSelector(state, ownProps)
                };
            })((0, $d6f8f157b9195453$var$_authWrapper2.default)($d6f8f157b9195453$var$_extends({}, allArgs, {
                FailureComponent: ConnectedFailureComponent
            }))(DecoratedComponent));
        };
    };
    return {
        connectedRouterRedirect: connectedRouterRedirect,
        connectedReduxRedirect: connectedReduxRedirect
    };
};


var $7be03f09a1b1e4ca$var$_redirect2 = $7be03f09a1b1e4ca$var$_interopRequireDefault($d6f8f157b9195453$exports);

var $7be03f09a1b1e4ca$var$_invariant2 = $7be03f09a1b1e4ca$var$_interopRequireDefault($06dab2fcf604e778$exports);
function $7be03f09a1b1e4ca$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $7be03f09a1b1e4ca$var$_redirectUtil = (0, $7be03f09a1b1e4ca$var$_redirect2.default)({
    locationHelperBuilder: $7be03f09a1b1e4ca$var$_locationHelper2.default,
    getRouterRedirect: function getRouterRedirect(_ref) {
        var router = _ref.router;
        return router.replace;
    }
});
var $7be03f09a1b1e4ca$var$connectedRouterRedirect = $7be03f09a1b1e4ca$var$_redirectUtil.connectedRouterRedirect, $7be03f09a1b1e4ca$var$connectedReduxRedirect = $7be03f09a1b1e4ca$var$_redirectUtil.connectedReduxRedirect;
$7be03f09a1b1e4ca$exports.connectedRouterRedirect = $7be03f09a1b1e4ca$var$connectedRouterRedirect;
$7be03f09a1b1e4ca$exports.connectedReduxRedirect = $7be03f09a1b1e4ca$var$connectedReduxRedirect;
var $7be03f09a1b1e4ca$var$onEnterDefaults = {
    allowRedirectBack: true,
    authenticatingSelector: function authenticatingSelector() {
        return false;
    },
    redirectQueryParamName: 'redirect'
};
var $7be03f09a1b1e4ca$var$createOnEnter = $7be03f09a1b1e4ca$exports.createOnEnter = function createOnEnter(config) {
    var _onEnterDefaults$conf = $7be03f09a1b1e4ca$var$_extends({}, $7be03f09a1b1e4ca$var$onEnterDefaults, config), authenticatedSelector = _onEnterDefaults$conf.authenticatedSelector, authenticatingSelector = _onEnterDefaults$conf.authenticatingSelector, redirectPath = _onEnterDefaults$conf.redirectPath, allowRedirectBack = _onEnterDefaults$conf.allowRedirectBack, redirectQueryParamName = _onEnterDefaults$conf.redirectQueryParamName;
    var redirectPathSelector = void 0;
    if (typeof redirectPath === 'string') redirectPathSelector = function redirectPathSelector() {
        return redirectPath;
    };
    else if (typeof redirectPath === 'function') redirectPathSelector = redirectPath;
    else (0, $7be03f09a1b1e4ca$var$_invariant2.default)(false, 'redirectPath must be either a string or a function');
    var allowRedirectBackFn = void 0;
    if (typeof allowRedirectBack === 'boolean') allowRedirectBackFn = function allowRedirectBackFn() {
        return allowRedirectBack;
    };
    else if (typeof allowRedirectBack === 'function') allowRedirectBackFn = allowRedirectBack;
    else (0, $7be03f09a1b1e4ca$var$_invariant2.default)(false, 'allowRedirectBack must be either a boolean or a function');
    return function(store, nextState, replace) {
        var _locationHelperBuilde = (0, $7be03f09a1b1e4ca$var$_locationHelper2.default)({
            redirectQueryParamName: redirectQueryParamName
        }), createRedirectLoc = _locationHelperBuilde.createRedirectLoc;
        var isAuthenticated = authenticatedSelector(store.getState(), nextState);
        var isAuthenticating = authenticatingSelector(store.getState(), nextState);
        if (!isAuthenticated && !isAuthenticating) {
            var _redirectPath = redirectPathSelector(store.getState(), nextState);
            replace(createRedirectLoc(allowRedirectBackFn(nextState, _redirectPath))(nextState, _redirectPath));
        }
    };
};



const $787b801d874c919a$var$locationHelper = (0, (/*@__PURE__*/$parcel$interopDefault($1fa5154d9ed0576d$exports)))({});
const $787b801d874c919a$export$6e030bb0a4caa92a = (0, $7be03f09a1b1e4ca$exports.connectedReduxRedirect)({
    redirectPath: '/login',
    AuthenticatingComponent: (0, $810ad5a94daa03b8$export$2e2bcd8739ae039),
    wrapperDisplayName: 'UserIsAuthenticated',
    redirectAction: (0, $14b9f70b6017fdee$exports.routerActions).replace,
    authenticatedSelector: ({ auth: { me: me, isMeLoading: isMeLoading } })=>!isMeLoading && me !== null,
    authenticatingSelector: ({ auth: { isMeLoading: isMeLoading } })=>isMeLoading
});
const $787b801d874c919a$export$ae0753c39619b4bc = (0, $7be03f09a1b1e4ca$exports.connectedReduxRedirect)({
    redirectPath: (state, ownProps)=>$787b801d874c919a$var$locationHelper.getRedirectQueryParam(ownProps) || '/',
    wrapperDisplayName: 'UserIsNotAuthenticated',
    authenticatedSelector: ({ auth: { me: me, isMeLoading: isMeLoading } })=>!isMeLoading && me === null,
    authenticatingSelector: ({ auth: { isMeLoading: isMeLoading } })=>isMeLoading,
    AuthenticatingComponent: (0, $810ad5a94daa03b8$export$2e2bcd8739ae039),
    redirectAction: (0, $14b9f70b6017fdee$exports.routerActions).replace
});






var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");

var $fGw9V = parcelRequire("fGw9V");







const $bb4988507d545d48$export$18b39542128314d4 = async (url)=>{
    try {
        await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            url: url
        });
    } catch (error) {
        console.error(`Unable to contact source ${url}`, error);
        throw error;
    }
};
const $bb4988507d545d48$export$b12ddf621b40b921 = async ()=>{
    try {
        const { data: { protoboards: protoboards } } = await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'GET',
            resource: 'protoboards'
        });
        return protoboards;
    } catch (error) {
        console.error(`Error fetching dashboard prototypes`, error);
        throw error;
    }
};


// APIS





const $b73fb830e0a94a1d$export$3c5f4c9f15eeb5cb = (sources)=>({
        type: 'LOAD_SOURCES',
        payload: {
            sources: sources
        }
    });
const $b73fb830e0a94a1d$export$328b0edc9fda3a36 = (source)=>({
        type: 'SOURCE_UPDATED',
        payload: {
            source: source
        }
    });
const $b73fb830e0a94a1d$export$bc333c64f07a75c4 = (source)=>({
        type: 'SOURCE_ADDED',
        payload: {
            source: source
        }
    });
const $b73fb830e0a94a1d$export$f511ad1a2b191dba = (source, kapacitors)=>({
        type: 'LOAD_KAPACITORS',
        payload: {
            source: source,
            kapacitors: kapacitors
        }
    });
const $b73fb830e0a94a1d$export$892e7a997d6ce9e2 = (kapacitor)=>({
        type: 'SET_ACTIVE_KAPACITOR',
        payload: {
            kapacitor: kapacitor
        }
    });
const $b73fb830e0a94a1d$export$37ce3dbbabc847d2 = (kapacitor)=>({
        type: 'DELETE_KAPACITOR',
        payload: {
            kapacitor: kapacitor
        }
    });
const $b73fb830e0a94a1d$export$2bb09a8b12c55257 = (source)=>async (dispatch, getState)=>{
        const { sources: sources = [] } = getState();
        const filteredSources = sources.filter((s)=>s.id !== source.id);
        dispatch($b73fb830e0a94a1d$export$3c5f4c9f15eeb5cb(filteredSources));
        try {
            try {
                await (0, $3bff70d0456af5c0$export$53d2b33f203103bf)(source);
            } catch (err) {
                dispatch($b73fb830e0a94a1d$export$3c5f4c9f15eeb5cb(sources));
                // A 404 means that either a concurrent write occurred or the source
                // passed to this action creator doesn't exist (or is undefined)
                if (err.status !== (0, $e10a8602f56394e3$export$6226897062245741)) throw err;
            }
            const { data: { sources: newSources } } = await (0, $3bff70d0456af5c0$export$5f9bc633b116660f)();
            dispatch($b73fb830e0a94a1d$export$3c5f4c9f15eeb5cb(newSources));
        } catch (err) {
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$63a21cafda4d93ae)));
        }
    };
const $b73fb830e0a94a1d$export$c18bacb24d8f6935 = (source)=>async (dispatch)=>{
        try {
            const kapacitors = await (0, $3bff70d0456af5c0$export$c006b25b4b2674db)(source);
            dispatch($b73fb830e0a94a1d$export$f511ad1a2b191dba(source, kapacitors));
        } catch (err) {
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$aec10c2b4022eddf)(source.id)));
        }
    };
const $b73fb830e0a94a1d$export$ac5e5ccaf8abc797 = (source)=>async (dispatch)=>{
        const kapacitors = await (0, $3bff70d0456af5c0$export$c006b25b4b2674db)(source);
        dispatch($b73fb830e0a94a1d$export$f511ad1a2b191dba(source, kapacitors));
    };
const $b73fb830e0a94a1d$export$7bafe015e336e80b = (kapacitor)=>async (dispatch)=>{
        // eagerly update the redux state
        dispatch($b73fb830e0a94a1d$export$892e7a997d6ce9e2(kapacitor));
        const kapacitorPost = {
            ...kapacitor,
            active: true
        };
        await (0, $3bff70d0456af5c0$export$aed6d6f44d1e4150)(kapacitorPost);
    };
const $b73fb830e0a94a1d$export$4a7c8a5c76d44143 = (kapacitor)=>async (dispatch)=>{
        try {
            await (0, $3bff70d0456af5c0$export$37ce3dbbabc847d2)(kapacitor);
            dispatch($b73fb830e0a94a1d$export$37ce3dbbabc847d2(kapacitor));
        } catch (err) {
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$c5133a70034ecde1)()));
        }
    };
const $b73fb830e0a94a1d$export$5f6ba1bbbf575a21 = ()=>async (dispatch)=>{
        try {
            const { data: data } = await (0, $3bff70d0456af5c0$export$5f9bc633b116660f)();
            const sources = data.sources;
            // const sourcesWithFluxLink = await Promise.all(sources.map(addSourceLink))
            dispatch($b73fb830e0a94a1d$export$3c5f4c9f15eeb5cb(sources));
            return sources;
        } catch (error) {
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error));
        }
    };





const $c8cd79e362cba2a4$export$5416f05742cfa18a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createContext(undefined);
function $c8cd79e362cba2a4$export$a520fb22fccea800(Wrapped) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($c8cd79e362cba2a4$export$5416f05742cfa18a.Consumer, null, (source)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement(Wrapped, {
                ...props,
                source: source
            }));
}
class $c8cd79e362cba2a4$export$b2b0c83082a4f482 extends (0, $NdCUR.Component) {
    static{
        this.childContextTypes = {
            source: (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V))).shape({
                links: (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V))).shape({
                    proxy: (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V))).string.isRequired,
                    self: (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V))).string.isRequired,
                    kapacitors: (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V))).string.isRequired,
                    queries: (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V))).string.isRequired,
                    permissions: (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V))).string.isRequired,
                    users: (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V))).string.isRequired,
                    databases: (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V))).string.isRequired
                }).isRequired
            })
        };
    }
    constructor(props){
        super(props);
        this.state = {
            isFetching: true
        };
    }
    getChildContext() {
        const { sources: sources, params: params } = this.props;
        return {
            source: sources.find((s)=>s.id === params.sourceID)
        };
    }
    async UNSAFE_componentWillMount() {
        const { router: router, auth: { isUsingAuth: isUsingAuth, me: me } } = this.props;
        if (!isUsingAuth || (0, $a7910b1002260d34$export$7d499847c5200082)(me.role, (0, $a7910b1002260d34$export$62bbf68aca1809f0))) {
            await this.props.getSources();
            this.setState({
                isFetching: false
            });
        } else {
            router.push('/purgatory');
            return;
        }
    }
    shouldComponentUpdate(nextProps) {
        const { location: location } = nextProps;
        if (!this.state.isFetching && this.props.location.pathname === location.pathname) return false;
        return true;
    }
    async UNSAFE_componentWillUpdate(nextProps, nextState) {
        const { router: router, location: location, params: params, sources: sources, auth: { isUsingAuth: isUsingAuth, me: me }, notify: notify } = nextProps;
        const organizations = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(me, 'organizations', []);
        const currentOrganization = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(me, 'currentOrganization');
        const { isFetching: isFetching } = nextState;
        const source = sources.find((s)=>s.id === params.sourceID);
        const defaultSource = sources.find((s)=>s.default === true);
        const role = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(this.props, 'auth.me.role', '');
        const nextRole = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(nextProps, 'auth.me.role', '');
        if ((0, $a7910b1002260d34$export$7d499847c5200082)(role, (0, $a7910b1002260d34$export$856b7354d850707e)) && !(0, $a7910b1002260d34$export$7d499847c5200082)(nextRole, (0, $a7910b1002260d34$export$856b7354d850707e))) return router.push('/');
        if (!isFetching && isUsingAuth && !organizations.length) {
            notify($ec1f42de4faacc37$export$3ae1c401848ae404());
            return router.push('/purgatory');
        }
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(me, 'superAdmin', false) && !organizations.find((o)=>o.id === currentOrganization.id)) {
            notify($ec1f42de4faacc37$export$e78f6119814fe84a());
            return router.push('/purgatory');
        }
        if (!isFetching && isUsingAuth && !(0, $a7910b1002260d34$export$7d499847c5200082)(me.role, (0, $a7910b1002260d34$export$62bbf68aca1809f0))) // if you're a member, go to purgatory.
        return router.push('/purgatory');
        if (!isFetching && isUsingAuth && me.role === (0, $a7910b1002260d34$export$62bbf68aca1809f0) && params.sourceID) {
            const dashboardsPath = `/sources/${params.sourceID}/dashboards`;
            if (location.pathname !== dashboardsPath && !location.pathname.startsWith(dashboardsPath + '/')) return router.push(dashboardsPath);
        }
        // TODO: At this point, the sources we have in Redux may be out of sync with what's on the server
        // Do we need to refresh this data more frequently? Does it need to come as frequently as the `me` response?
        if (!isFetching && !source) {
            const rest = location.pathname.match(/\/sources\/\d+?\/(.+)/);
            let restString = rest === null ? (0, $e10a8602f56394e3$export$d35773d450f5d6df) : rest[1];
            if (isUsingAuth) {
                if (!(0, $a7910b1002260d34$export$7d499847c5200082)(me.role, (0, $a7910b1002260d34$export$f715f7e27dea2abf))) {
                    if (me.role === (0, $a7910b1002260d34$export$62bbf68aca1809f0)) // reader role can only read dashboards
                    {
                        if (!restString.startsWith('dashboards')) restString = 'dashboards';
                    }
                    if (defaultSource) return router.push(`/sources/${defaultSource.id}/${restString}`);
                    else if (sources[0]) return router.push(`/sources/${sources[0].id}/${restString}`);
                    // if you're a viewer and there are no sources, go to purgatory.
                    notify($ec1f42de4faacc37$export$dbd0a47d5001e6ec());
                    return router.push('/purgatory');
                }
            }
            // if you're an editor or not using auth, try for sources or otherwise
            // create one
            if (defaultSource) return router.push(`/sources/${defaultSource.id}/${restString}`);
            else if (sources[0]) return router.push(`/sources/${sources[0].id}/${restString}`);
            return router.push(`/sources/new?redirectPath=${location.pathname}`);
        }
        if (!isFetching && !location.pathname.includes('/manage-sources')) try {
            await (0, $bb4988507d545d48$export$18b39542128314d4)(source.links.health);
        } catch (error) {
            notify($ec1f42de4faacc37$export$3dc506cfdd94308c(source.name));
        }
    }
    render() {
        const { params: params, sources: sources, auth: { isUsingAuth: isUsingAuth, me: me } } = this.props;
        const { isFetching: isFetching } = this.state;
        const source = sources.find((s)=>s.id === params.sourceID);
        const currentOrganization = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(me, 'currentOrganization');
        if (isFetching || !source || isUsingAuth && !currentOrganization) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $810ad5a94daa03b8$export$2e2bcd8739ae039), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($c8cd79e362cba2a4$export$5416f05742cfa18a.Provider, {
            value: source
        }, this.props.children);
    }
}
const $c8cd79e362cba2a4$var$mapStateToProps = ({ sources: sources, auth: auth })=>({
        sources: sources,
        auth: auth
    });
const $c8cd79e362cba2a4$var$mapDispatchToProps = (dispatch)=>({
        getSources: (0, $1f80bbeadc1a0021$export$2e2bcd8739ae039)((0, $b73fb830e0a94a1d$export$5f6ba1bbbf575a21), dispatch),
        notify: (0, $1f80bbeadc1a0021$export$2e2bcd8739ae039)((0, $205d139de2918454$export$5e14cdade93d6f7b), dispatch)
    });
var $c8cd79e362cba2a4$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($c8cd79e362cba2a4$var$mapStateToProps, $c8cd79e362cba2a4$var$mapDispatchToProps)((0, $dffbdf89c590a961$export$2e2bcd8739ae039)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($c8cd79e362cba2a4$export$b2b0c83082a4f482)));


// Libraries

var $NdCUR = parcelRequire("NdCUR");


// Libraries

var $NdCUR = parcelRequire("NdCUR");
var $559ca5de843865e1$exports = {};

$559ca5de843865e1$exports = (parcelRequire("2qxpy")).default;

$559ca5de843865e1$exports.utils = (parcelRequire("1VByH"));

$559ca5de843865e1$exports.Responsive = (parcelRequire("8bVNH")).default;

$559ca5de843865e1$exports.Responsive.utils = (parcelRequire("9OLJg"));

$559ca5de843865e1$exports.WidthProvider = (parcelRequire("lj1I1")).default;



// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");

var $NdCUR = parcelRequire("NdCUR");

var $NdCUR = parcelRequire("NdCUR");


// Components

var $NdCUR = parcelRequire("NdCUR");


var $hBdgJ = parcelRequire("hBdgJ");

// Libraries

var $NdCUR = parcelRequire("NdCUR");


var $1v7mg = parcelRequire("1v7mg");

var $axd2S = parcelRequire("axd2S");
const $fe3f5b7319b16714$export$fddb4c2055b8b4af = {
    colName: 'calc(55% - 216px)',
    colLevel: '62px',
    colTime: '190px',
    colHost: 'calc(45% - 196px)',
    colValue: '160px'
};



const { colName: $2b97018ab0170fe9$var$colName, colLevel: $2b97018ab0170fe9$var$colLevel, colTime: $2b97018ab0170fe9$var$colTime, colHost: $2b97018ab0170fe9$var$colHost, colValue: $2b97018ab0170fe9$var$colValue } = (0, $fe3f5b7319b16714$export$fddb4c2055b8b4af);
class $2b97018ab0170fe9$var$AlertsTableRow extends (0, $NdCUR.PureComponent) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, this.nameCell, this.levelCell, this.timeCell, this.hostCell, this.valueCell);
    }
    get nameCell() {
        const { name: name } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "alert-history-table--td",
            style: {
                width: $2b97018ab0170fe9$var$colName
            },
            "data-test": "nameCell"
        }, name === null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", null, "\u2013") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", null, name));
    }
    get levelCell() {
        const { level: level } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: `alert-history-table--td alert-level-${level === null ? 'null' : level.toLowerCase()}`,
            style: {
                width: $2b97018ab0170fe9$var$colLevel
            },
            "data-test": "levelCell"
        }, level === null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", null, "\u2013") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('table-dot', {
                'dot-critical': level === 'CRITICAL'
            }, {
                'dot-success': level === 'OK'
            })
        }));
    }
    get timeCell() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "alert-history-table--td",
            style: {
                width: $2b97018ab0170fe9$var$colTime
            },
            "data-test": "timeCell"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", null, this.formattedTime));
    }
    get formattedTime() {
        const { time: time, timeZone: timeZone } = this.props;
        if (time === null) return "\u2013";
        if (timeZone === (0, $a7b864c61f4e95a7$export$d6f132cca63fb222).UTC) return new Date(Number(time)).toISOString();
        return (0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(Number(time)).format('YYYY-MM-DDTHH:mm:ss.SSS');
    }
    get hostCell() {
        const { sourceID: sourceID, host: host } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "alert-history-table--td alert-history-table--host",
            style: {
                width: $2b97018ab0170fe9$var$colHost
            },
            "data-test": "hostCell"
        }, host === null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", null, "\u2013") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ba1cc4424c00aefe$export$2e2bcd8739ae039), {
            to: `/sources/${sourceID}/hosts/${host}`,
            title: host
        }, host));
    }
    get valueCell() {
        const { value: value } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "alert-history-table--td",
            style: {
                width: $2b97018ab0170fe9$var$colValue
            },
            "data-test": "valueCell"
        }, value === null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", null, "\u2013") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", null, value));
    }
}
var $2b97018ab0170fe9$export$2e2bcd8739ae039 = $2b97018ab0170fe9$var$AlertsTableRow;



var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");

var $1v7mg = parcelRequire("1v7mg");


var $hBdgJ = parcelRequire("hBdgJ");

const { arrayOf: $a5457b7c0d559293$var$arrayOf, number: $a5457b7c0d559293$var$number, shape: $a5457b7c0d559293$var$shape, string: $a5457b7c0d559293$var$string } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
class $a5457b7c0d559293$var$InfiniteScroll extends (0, $NdCUR.Component) {
    // Cache values from Scrollbars events that need to be independent of render
    // Should not be setState as need not trigger a re-render
    scrollbarsScrollTop = 0;
    scrollbarsClientHeight = 0;
    state = {
        topIndex: 0,
        bottomIndex: 0,
        topPadding: 0,
        bottomPadding: 0,
        windowHeight: window.innerHeight
    };
    windowing = (props, state)=>{
        const { itemHeight: itemHeight, items: items } = props;
        const { bottomIndex: bottomIndex } = state;
        const itemDistance = Math.round(this.scrollbarsScrollTop / itemHeight);
        const itemCount = Math.round(this.scrollbarsClientHeight / itemHeight) + 1;
        // If state is the same, do not setState to the same value multiple times.
        // Improves performance and prevents errors.
        if (bottomIndex === itemDistance + itemCount) return;
        this.setState({
            // Number of items from top
            topIndex: itemDistance,
            // Number of items that can fit inside the container div
            bottomIndex: itemDistance + itemCount,
            // Offset list from top
            topPadding: itemDistance * itemHeight,
            // Provide scrolling room at the bottom of the list
            bottomPadding: (items.length - itemDistance - itemCount) * itemHeight
        });
    };
    handleScroll = ({ clientHeight: clientHeight, scrollTop: scrollTop })=>{
        let shouldUpdate = false;
        if (typeof clientHeight !== 'undefined' && this.scrollbarsClientHeight !== clientHeight || typeof scrollTop !== 'undefined' && this.scrollbarsScrollTop !== scrollTop) shouldUpdate = true;
        this.scrollbarsClientHeight = clientHeight;
        this.scrollbarsScrollTop = scrollTop;
        if (shouldUpdate) this.windowing(this.props, this.state);
    };
    throttledHandleScroll = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).throttle(this.handleScroll, 100);
    handleResize = ()=>{
        this.setState({
            windowHeight: window.innerHeight
        });
    };
    throttledHandleResize = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).throttle(this.handleResize, 100);
    handleMakeDiv = (className)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                ...props,
                className: `fancy-scroll--${className}`
            });
    componentDidMount() {
        window.addEventListener('resize', this.handleResize, true);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize, true);
    }
    UNSAFE_componentWillReceiveProps(nextProps, nextState) {
        // Updates values if new items are added
        this.windowing(nextProps, nextState);
    }
    render() {
        const { className: className, items: items } = this.props;
        const { topIndex: topIndex, bottomIndex: bottomIndex, topPadding: topPadding, bottomPadding: bottomPadding, windowHeight: windowHeight } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $5c857c96f4e15ca9$exports.Scrollbars), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))(className, 'fancy-scroll--container'),
            autoHide: true,
            autoHideTimeout: 1000,
            autoHideDuration: 250,
            autoHeight: false,
            renderTrackHorizontal: this.handleMakeDiv('track-h'),
            renderTrackVertical: this.handleMakeDiv('track-v'),
            renderThumbHorizontal: this.handleMakeDiv('thumb-h'),
            renderThumbVertical: this.handleMakeDiv('thumb-v'),
            renderView: this.handleMakeDiv('view'),
            onScrollFrame: this.throttledHandleScroll,
            onUpdate: this.throttledHandleScroll,
            key: windowHeight
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            style: {
                height: topPadding
            }
        }), items.filter((_item, i)=>i >= topIndex && i <= bottomIndex), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            style: {
                height: bottomPadding
            }
        }));
    }
}
$a5457b7c0d559293$var$InfiniteScroll.propTypes = {
    itemHeight: $a5457b7c0d559293$var$number.isRequired,
    items: $a5457b7c0d559293$var$arrayOf($a5457b7c0d559293$var$shape()).isRequired,
    className: $a5457b7c0d559293$var$string
};
var $a5457b7c0d559293$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($a5457b7c0d559293$var$InfiniteScroll);



var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");

class $bf83b2aeb2e43fcf$var$SearchBar extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleSearch = ()=>{
            this.props.onSearch(this.state.searchTerm);
        }, this.handleChange = (e)=>{
            this.setState({
                searchTerm: e.target.value
            }, this.handleSearch);
        };
        this.state = {
            searchTerm: ''
        };
    }
    UNSAFE_componentWillMount() {
        const waitPeriod = 300;
        this.handleSearch = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).debounce(this.handleSearch, waitPeriod);
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "search-widget",
            style: {
                width: '260px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            type: "text",
            className: "form-control input-sm",
            placeholder: "Filter Alerts...",
            onChange: this.handleChange,
            value: this.state.searchTerm
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon search"
        }));
    }
}
var $bf83b2aeb2e43fcf$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($bf83b2aeb2e43fcf$var$SearchBar);




var $1734047328051b52$var$Direction = /*#__PURE__*/ function(Direction) {
    Direction["ASC"] = "asc";
    Direction["DESC"] = "desc";
    Direction["NONE"] = "none";
    return Direction;
}($1734047328051b52$var$Direction || {});
class $1734047328051b52$var$AlertsTable extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.filterAlerts = (searchTerm, newAlerts)=>{
            const alerts = newAlerts || this.props.alerts;
            const filterText = searchTerm.toLowerCase();
            const filteredAlerts = alerts.filter(({ name: name, host: host, level: level })=>{
                return name && name.toLowerCase().includes(filterText) || host && host.toLowerCase().includes(filterText) || level && level.toLowerCase().includes(filterText);
            });
            this.setState({
                searchTerm: searchTerm,
                filteredAlerts: filteredAlerts
            });
        }, this.changeSort = (key)=>()=>{
                // if we're using the key, reverse order; otherwise, set it with ascending
                if (this.state.sortKey === key) {
                    const reverseDirection = this.state.sortDirection === "asc" ? "desc" : "asc";
                    this.setState({
                        sortDirection: reverseDirection
                    });
                } else this.setState({
                    sortKey: key,
                    sortDirection: "asc"
                });
            }, this.sortableClasses = (key)=>{
            if (this.state.sortKey === key) {
                if (this.state.sortDirection === "asc") return 'alert-history-table--th sortable-header sorting-ascending';
                return 'alert-history-table--th sortable-header sorting-descending';
            }
            return 'alert-history-table--th sortable-header';
        }, this.sort = (alerts, key, direction)=>{
            switch(direction){
                case "asc":
                    return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).sortBy(alerts, (e)=>e[key]);
                case "desc":
                    return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).sortBy(alerts, (e)=>e[key]).reverse();
                default:
                    return alerts;
            }
        };
        this.state = {
            searchTerm: '',
            filteredAlerts: this.props.alerts,
            sortDirection: "none",
            sortKey: ''
        };
    }
    UNSAFE_componentWillReceiveProps(newProps) {
        this.filterAlerts(this.state.searchTerm, newProps.alerts);
    }
    render() {
        const { shouldNotBeFilterable: shouldNotBeFilterable, limit: limit, onGetMoreAlerts: onGetMoreAlerts, isAlertsMaxedOut: isAlertsMaxedOut, alertsCount: alertsCount } = this.props;
        return shouldNotBeFilterable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "alerts-widget"
        }, this.renderTable(), limit && alertsCount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-sm btn-default btn-block",
            onClick: onGetMoreAlerts,
            disabled: isAlertsMaxedOut,
            style: {
                marginBottom: '20px'
            }
        }, isAlertsMaxedOut ? `All ${alertsCount} Alerts displayed` : 'Load next 30 Alerts') : null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel-heading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h2", {
            className: "panel-title"
        }, this.props.alerts.length, " Alerts"), this.props.alerts.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $bf83b2aeb2e43fcf$export$2e2bcd8739ae039), {
            onSearch: this.filterAlerts
        }) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel-body"
        }, this.renderTable()));
    }
    renderTable() {
        const { source: { id: id }, timeZone: timeZone } = this.props;
        const alerts = this.sort(this.state.filteredAlerts, this.state.sortKey, this.state.sortDirection);
        const { colName: colName, colLevel: colLevel, colTime: colTime, colHost: colHost, colValue: colValue } = (0, $fe3f5b7319b16714$export$fddb4c2055b8b4af);
        return this.props.alerts.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "alert-history-table"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "alert-history-table--thead"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            onClick: this.changeSort('name'),
            className: this.sortableClasses('name'),
            style: {
                width: colName
            }
        }, "Name ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon caret-up"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            onClick: this.changeSort('level'),
            className: this.sortableClasses('level'),
            style: {
                width: colLevel
            }
        }, "Level ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon caret-up"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            onClick: this.changeSort('time'),
            className: this.sortableClasses('time'),
            style: {
                width: colTime
            }
        }, "Time (", timeZone, ")", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon caret-up"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            onClick: this.changeSort('host'),
            className: this.sortableClasses('host'),
            style: {
                width: colHost
            }
        }, "Host ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon caret-up"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            onClick: this.changeSort('value'),
            className: this.sortableClasses('value'),
            style: {
                width: colValue
            }
        }, "Value ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon caret-up"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a5457b7c0d559293$export$2e2bcd8739ae039), {
            className: "alert-history-table--tbody",
            itemHeight: 25,
            items: alerts.map((alert, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                    className: "alert-history-table--tr",
                    key: i
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $2b97018ab0170fe9$export$2e2bcd8739ae039), {
                    sourceID: id,
                    ...alert,
                    timeZone: timeZone
                })))
        })) : this.renderTableEmpty();
    }
    renderTableEmpty() {
        const { source: { id: id }, shouldNotBeFilterable: shouldNotBeFilterable } = this.props;
        return shouldNotBeFilterable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "graph-empty"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, "Learn how to configure your first ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("strong", null, "Rule"), " in", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("br", null), "the ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("em", null, "Getting Started"), " guide")) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "generic-empty-state"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", {
            className: "no-user-select"
        }, "There are no Alerts to display"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h6", {
            className: "no-user-select"
        }, "Try changing the Time Range or", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ba1cc4424c00aefe$export$2e2bcd8739ae039), {
            style: {
                marginLeft: '10px'
            },
            to: `/sources/${id}/alert-rules/new`,
            className: "btn btn-primary btn-sm"
        }, "Create an Alert Rule")));
    }
}
const $1734047328051b52$var$mstp = ({ app: app })=>({
        timeZone: app.persisted.timeZone
    });
var $1734047328051b52$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($1734047328051b52$var$mstp, null)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($1734047328051b52$var$AlertsTable));



var $NdCUR = parcelRequire("NdCUR");


const $16af25b437b7972f$var$NoKapacitorError = ({ source: source })=>{
    const path = `/sources/${source.id}/kapacitors/new`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "graph-empty"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, "The current source does not have an associated Kapacitor instance", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $091cfcd49e339acd$export$2e2bcd8739ae039), {
        requiredRole: (0, $a7910b1002260d34$export$f715f7e27dea2abf)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ba1cc4424c00aefe$export$2e2bcd8739ae039), {
        to: path,
        className: "btn btn-sm btn-primary"
    }, "Configure Kapacitor"))));
};
var $16af25b437b7972f$export$2e2bcd8739ae039 = $16af25b437b7972f$var$NoKapacitorError;



var $NdCUR = parcelRequire("NdCUR");

var $axd2S = parcelRequire("axd2S");

var $1v7mg = parcelRequire("1v7mg");

var $NdCUR = parcelRequire("NdCUR");

var $g2wso = parcelRequire("g2wso");

class $1f11d3536bc98f8a$var$ClickOutside extends (0, $NdCUR.PureComponent) {
    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside, true);
    }
    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside, true);
    }
    render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Children.only(this.props.children);
    }
    constructor(...args){
        super(...args), this.handleClickOutside = (e)=>{
            const domNode = (0, (/*@__PURE__*/$parcel$interopDefault($g2wso))).findDOMNode(this);
            if (!domNode || !domNode.contains(e.target)) this.props.onClickOutside();
        };
    }
}
const $1f11d3536bc98f8a$export$c16e4f034c84cb3f = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($1f11d3536bc98f8a$var$ClickOutside);



var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");
var $e3fe4930b4cc098f$exports = {};
'use strict';

var $axd2S = parcelRequire("axd2S");
var $d2cb3f09a0c90dd7$exports = {};
'use strict';
'use strict';
if (!Function.prototype.bind) Function.prototype.bind = function(context) {
    if (typeof this !== 'function') throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
    var curried = Array.prototype.slice.call(arguments, 1);
    var original = this;
    var NoOp = function() {};
    var bound = function() {
        var ctx = this instanceof NoOp && context ? this : context;
        var args = curried.concat(Array.prototype.slice.call(arguments));
        return original.apply(ctx, args);
    };
    NoOp.prototype = this.prototype;
    bound.prototype = new NoOp();
    return bound;
};


'use strict';
if (!Array.prototype.forEach) Array.prototype.forEach = function(fn, ctx) {
    if (this === void 0 || this === null || typeof fn !== 'function') throw new TypeError();
    var t = this;
    var len = t.length;
    for(var i = 0; i < len; i++)if (i in t) fn.call(ctx, t[i], i, t);
};


'use strict';
if (!Array.prototype.map) Array.prototype.map = function(fn, ctx) {
    var context, result, i;
    if (this == null) throw new TypeError('this is null or not defined');
    var source = Object(this);
    var len = source.length >>> 0;
    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    if (arguments.length > 1) context = ctx;
    result = new Array(len);
    i = 0;
    while(i < len){
        if (i in source) result[i] = fn.call(context, source[i], i, source);
        i++;
    }
    return result;
};


'use strict';
if (!Array.prototype.filter) Array.prototype.filter = function(fn, ctx) {
    var f = [];
    this.forEach(function(v, i, t) {
        if (fn.call(ctx, v, i, t)) f.push(v);
    }, ctx);
    return f;
};


'use strict';
Array.isArray || (Array.isArray = function(a) {
    return '' + a !== a && Object.prototype.toString.call(a) === '[object Array]';
});


'use strict';
if (!Array.prototype.indexOf) Array.prototype.indexOf = function(what, start) {
    if (this === undefined || this === null) throw new TypeError();
    var length = this.length;
    start = +start || 0;
    if (Math.abs(start) === Infinity) start = 0;
    else if (start < 0) {
        start += length;
        if (start < 0) start = 0;
    }
    for(; start < length; start++){
        if (this[start] === what) return start;
    }
    return -1;
};


'use strict';
if (!Array.prototype.some) Array.prototype.some = function(fn, ctx) {
    var context, i;
    if (this == null) throw new TypeError('this is null or not defined');
    var source = Object(this);
    var len = source.length >>> 0;
    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    if (arguments.length > 1) context = ctx;
    i = 0;
    while(i < len){
        if (i in source) {
            var test = fn.call(context, source[i], i, source);
            if (test) return true;
        }
        i++;
    }
    return false;
};


'use strict';
if (!String.prototype.trim) String.prototype.trim = function() {
    return this.replace(/^\s+|\s+$/g, '');
};


'use strict';
var $02e63291403e147d$var$hasOwn = Object.prototype.hasOwnProperty;
var $02e63291403e147d$var$hasDontEnumBug = !({
    toString: null
}).propertyIsEnumerable('toString');
var $02e63291403e147d$var$dontEnums = [
    'toString',
    'toLocaleString',
    'valueOf',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'constructor'
];
var $02e63291403e147d$var$dontEnumsLength = $02e63291403e147d$var$dontEnums.length;
if (!Object.keys) Object.keys = function(obj) {
    if (typeof obj !== 'object' && (typeof obj !== 'function' || obj === null)) throw new TypeError('Object.keys called on non-object');
    var result = [], prop, i;
    for(prop in obj)if ($02e63291403e147d$var$hasOwn.call(obj, prop)) result.push(prop);
    if ($02e63291403e147d$var$hasDontEnumBug) {
        for(i = 0; i < $02e63291403e147d$var$dontEnumsLength; i++)if ($02e63291403e147d$var$hasOwn.call(obj, $02e63291403e147d$var$dontEnums[i])) result.push($02e63291403e147d$var$dontEnums[i]);
    }
    return result;
};


var $d8f2de8e0916ef91$exports = {};
'use strict';

var $fMgII = parcelRequire("fMgII");
var $2a97a3b7c4601928$exports = {};
'use strict';
var $a18850637d618268$exports = {};
'use strict';
var $509b743e4c4ec2dc$exports = {};
var $509b743e4c4ec2dc$var$NativeCustomEvent = $parcel$global.CustomEvent;
function $509b743e4c4ec2dc$var$useNative() {
    try {
        var p = new $509b743e4c4ec2dc$var$NativeCustomEvent('cat', {
            detail: {
                foo: 'bar'
            }
        });
        return 'cat' === p.type && 'bar' === p.detail.foo;
    } catch (e) {}
    return false;
}
/**
 * Cross-browser `CustomEvent` constructor.
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent.CustomEvent
 *
 * @public
 */ $509b743e4c4ec2dc$exports = $509b743e4c4ec2dc$var$useNative() ? $509b743e4c4ec2dc$var$NativeCustomEvent : // IE >= 9
'function' === typeof document.createEvent ? function CustomEvent(type, params) {
    var e = document.createEvent('CustomEvent');
    if (params) e.initCustomEvent(type, params.bubbles, params.cancelable, params.detail);
    else e.initCustomEvent(type, false, false, void 0);
    return e;
} : // IE <= 8
function CustomEvent(type, params) {
    var e = document.createEventObject();
    e.type = type;
    if (params) {
        e.bubbles = Boolean(params.bubbles);
        e.cancelable = Boolean(params.cancelable);
        e.detail = params.detail;
    } else {
        e.bubbles = false;
        e.cancelable = false;
        e.detail = void 0;
    }
    return e;
};


var $a285a81345d2d555$exports = {};
'use strict';
var $a285a81345d2d555$var$eventmap = [];
var $a285a81345d2d555$var$eventname = '';
var $a285a81345d2d555$var$ron = /^on/;
for($a285a81345d2d555$var$eventname in $parcel$global)if ($a285a81345d2d555$var$ron.test($a285a81345d2d555$var$eventname)) $a285a81345d2d555$var$eventmap.push($a285a81345d2d555$var$eventname.slice(2));
$a285a81345d2d555$exports = $a285a81345d2d555$var$eventmap;


var $a18850637d618268$var$doc = document;
var $a18850637d618268$var$addEvent = $a18850637d618268$var$addEventEasy;
var $a18850637d618268$var$removeEvent = $a18850637d618268$var$removeEventEasy;
var $a18850637d618268$var$hardCache = [];
if (!$parcel$global.addEventListener) {
    $a18850637d618268$var$addEvent = $a18850637d618268$var$addEventHard;
    $a18850637d618268$var$removeEvent = $a18850637d618268$var$removeEventHard;
}
function $a18850637d618268$var$addEventEasy(el, type, fn, capturing) {
    return el.addEventListener(type, fn, capturing);
}
function $a18850637d618268$var$addEventHard(el, type, fn) {
    return el.attachEvent('on' + type, $a18850637d618268$var$wrap(el, type, fn));
}
function $a18850637d618268$var$removeEventEasy(el, type, fn, capturing) {
    return el.removeEventListener(type, fn, capturing);
}
function $a18850637d618268$var$removeEventHard(el, type, fn) {
    return el.detachEvent('on' + type, $a18850637d618268$var$unwrap(el, type, fn));
}
function $a18850637d618268$var$fabricateEvent(el, type, model) {
    var e = $a285a81345d2d555$exports.indexOf(type) === -1 ? makeCustomEvent() : makeClassicEvent();
    if (el.dispatchEvent) el.dispatchEvent(e);
    else el.fireEvent('on' + type, e);
    function makeClassicEvent() {
        var e;
        if ($a18850637d618268$var$doc.createEvent) {
            e = $a18850637d618268$var$doc.createEvent('Event');
            e.initEvent(type, true, true);
        } else if ($a18850637d618268$var$doc.createEventObject) e = $a18850637d618268$var$doc.createEventObject();
        return e;
    }
    function makeCustomEvent() {
        return new $509b743e4c4ec2dc$exports(type, {
            detail: model
        });
    }
}
function $a18850637d618268$var$wrapperFactory(el, type, fn) {
    return function wrapper(originalEvent) {
        var e = originalEvent || $parcel$global.event;
        e.target = e.target || e.srcElement;
        e.preventDefault = e.preventDefault || function preventDefault() {
            e.returnValue = false;
        };
        e.stopPropagation = e.stopPropagation || function stopPropagation() {
            e.cancelBubble = true;
        };
        e.which = e.which || e.keyCode;
        fn.call(el, e);
    };
}
function $a18850637d618268$var$wrap(el, type, fn) {
    var wrapper = $a18850637d618268$var$unwrap(el, type, fn) || $a18850637d618268$var$wrapperFactory(el, type, fn);
    $a18850637d618268$var$hardCache.push({
        wrapper: wrapper,
        element: el,
        type: type,
        fn: fn
    });
    return wrapper;
}
function $a18850637d618268$var$unwrap(el, type, fn) {
    var i = $a18850637d618268$var$find(el, type, fn);
    if (i) {
        var wrapper = $a18850637d618268$var$hardCache[i].wrapper;
        $a18850637d618268$var$hardCache.splice(i, 1); // free up a tad of memory
        return wrapper;
    }
}
function $a18850637d618268$var$find(el, type, fn) {
    var i, item;
    for(i = 0; i < $a18850637d618268$var$hardCache.length; i++){
        item = $a18850637d618268$var$hardCache[i];
        if (item.element === el && item.type === type && item.fn === fn) return i;
    }
}
$a18850637d618268$exports = {
    add: $a18850637d618268$var$addEvent,
    remove: $a18850637d618268$var$removeEvent,
    fabricate: $a18850637d618268$var$fabricateEvent
};


var $ed6c1e273a3cca93$exports = {};
'use strict';
var $dae43bc3b0091a53$exports = {};
'use strict';
var $38e4d29c0de9d34f$exports = {};
var $38e4d29c0de9d34f$var$NativeCustomEvent = $parcel$global.CustomEvent;
function $38e4d29c0de9d34f$var$useNative() {
    try {
        var p = new $38e4d29c0de9d34f$var$NativeCustomEvent('cat', {
            detail: {
                foo: 'bar'
            }
        });
        return 'cat' === p.type && 'bar' === p.detail.foo;
    } catch (e) {}
    return false;
}
/**
 * Cross-browser `CustomEvent` constructor.
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent.CustomEvent
 *
 * @public
 */ $38e4d29c0de9d34f$exports = $38e4d29c0de9d34f$var$useNative() ? $38e4d29c0de9d34f$var$NativeCustomEvent : // IE >= 9
'undefined' !== typeof document && 'function' === typeof document.createEvent ? function CustomEvent(type, params) {
    var e = document.createEvent('CustomEvent');
    if (params) e.initCustomEvent(type, params.bubbles, params.cancelable, params.detail);
    else e.initCustomEvent(type, false, false, void 0);
    return e;
} : // IE <= 8
function CustomEvent(type, params) {
    var e = document.createEventObject();
    e.type = type;
    if (params) {
        e.bubbles = Boolean(params.bubbles);
        e.cancelable = Boolean(params.cancelable);
        e.detail = params.detail;
    } else {
        e.bubbles = false;
        e.cancelable = false;
        e.detail = void 0;
    }
    return e;
};


var $764e54a0fc135875$exports = {};
'use strict';
var $764e54a0fc135875$var$eventmap = [];
var $764e54a0fc135875$var$eventname = '';
var $764e54a0fc135875$var$ron = /^on/;
for($764e54a0fc135875$var$eventname in $parcel$global)if ($764e54a0fc135875$var$ron.test($764e54a0fc135875$var$eventname)) $764e54a0fc135875$var$eventmap.push($764e54a0fc135875$var$eventname.slice(2));
$764e54a0fc135875$exports = $764e54a0fc135875$var$eventmap;


var $dae43bc3b0091a53$var$doc = $parcel$global.document;
var $dae43bc3b0091a53$var$addEvent = $dae43bc3b0091a53$var$addEventEasy;
var $dae43bc3b0091a53$var$removeEvent = $dae43bc3b0091a53$var$removeEventEasy;
var $dae43bc3b0091a53$var$hardCache = [];
if (!$parcel$global.addEventListener) {
    $dae43bc3b0091a53$var$addEvent = $dae43bc3b0091a53$var$addEventHard;
    $dae43bc3b0091a53$var$removeEvent = $dae43bc3b0091a53$var$removeEventHard;
}
$dae43bc3b0091a53$exports = {
    add: $dae43bc3b0091a53$var$addEvent,
    remove: $dae43bc3b0091a53$var$removeEvent,
    fabricate: $dae43bc3b0091a53$var$fabricateEvent
};
function $dae43bc3b0091a53$var$addEventEasy(el, type, fn, capturing) {
    return el.addEventListener(type, fn, capturing);
}
function $dae43bc3b0091a53$var$addEventHard(el, type, fn) {
    return el.attachEvent('on' + type, $dae43bc3b0091a53$var$wrap(el, type, fn));
}
function $dae43bc3b0091a53$var$removeEventEasy(el, type, fn, capturing) {
    return el.removeEventListener(type, fn, capturing);
}
function $dae43bc3b0091a53$var$removeEventHard(el, type, fn) {
    var listener = $dae43bc3b0091a53$var$unwrap(el, type, fn);
    if (listener) return el.detachEvent('on' + type, listener);
}
function $dae43bc3b0091a53$var$fabricateEvent(el, type, model) {
    var e = $764e54a0fc135875$exports.indexOf(type) === -1 ? makeCustomEvent() : makeClassicEvent();
    if (el.dispatchEvent) el.dispatchEvent(e);
    else el.fireEvent('on' + type, e);
    function makeClassicEvent() {
        var e;
        if ($dae43bc3b0091a53$var$doc.createEvent) {
            e = $dae43bc3b0091a53$var$doc.createEvent('Event');
            e.initEvent(type, true, true);
        } else if ($dae43bc3b0091a53$var$doc.createEventObject) e = $dae43bc3b0091a53$var$doc.createEventObject();
        return e;
    }
    function makeCustomEvent() {
        return new $38e4d29c0de9d34f$exports(type, {
            detail: model
        });
    }
}
function $dae43bc3b0091a53$var$wrapperFactory(el, type, fn) {
    return function wrapper(originalEvent) {
        var e = originalEvent || $parcel$global.event;
        e.target = e.target || e.srcElement;
        e.preventDefault = e.preventDefault || function preventDefault() {
            e.returnValue = false;
        };
        e.stopPropagation = e.stopPropagation || function stopPropagation() {
            e.cancelBubble = true;
        };
        e.which = e.which || e.keyCode;
        fn.call(el, e);
    };
}
function $dae43bc3b0091a53$var$wrap(el, type, fn) {
    var wrapper = $dae43bc3b0091a53$var$unwrap(el, type, fn) || $dae43bc3b0091a53$var$wrapperFactory(el, type, fn);
    $dae43bc3b0091a53$var$hardCache.push({
        wrapper: wrapper,
        element: el,
        type: type,
        fn: fn
    });
    return wrapper;
}
function $dae43bc3b0091a53$var$unwrap(el, type, fn) {
    var i = $dae43bc3b0091a53$var$find(el, type, fn);
    if (i) {
        var wrapper = $dae43bc3b0091a53$var$hardCache[i].wrapper;
        $dae43bc3b0091a53$var$hardCache.splice(i, 1); // free up a tad of memory
        return wrapper;
    }
}
function $dae43bc3b0091a53$var$find(el, type, fn) {
    var i, item;
    for(i = 0; i < $dae43bc3b0091a53$var$hardCache.length; i++){
        item = $dae43bc3b0091a53$var$hardCache[i];
        if (item.element === el && item.type === type && item.fn === fn) return i;
    }
}


var $d2ed8a4bf2561f96$exports = {};
'use strict';
function $d2ed8a4bf2561f96$var$throttle(fn, boundary) {
    var last = -Infinity;
    var timer;
    return function bounced() {
        if (timer) return;
        unbound();
        function unbound() {
            clearTimeout(timer);
            timer = null;
            var next = last + boundary;
            var now = Date.now();
            if (now > next) {
                last = now;
                fn();
            } else timer = setTimeout(unbound, next - now);
        }
    };
}
$d2ed8a4bf2561f96$exports = $d2ed8a4bf2561f96$var$throttle;


var $df459237e1045145$exports = {};
'use strict';
var $cda263d9b3dace34$exports = {};
'use strict';
var $cda263d9b3dace34$var$get = $cda263d9b3dace34$var$easyGet;
var $cda263d9b3dace34$var$set = $cda263d9b3dace34$var$easySet;
if (document.selection && document.selection.createRange) {
    $cda263d9b3dace34$var$get = $cda263d9b3dace34$var$hardGet;
    $cda263d9b3dace34$var$set = $cda263d9b3dace34$var$hardSet;
}
function $cda263d9b3dace34$var$easyGet(el) {
    return {
        start: el.selectionStart,
        end: el.selectionEnd
    };
}
function $cda263d9b3dace34$var$hardGet(el) {
    var active = document.activeElement;
    if (active !== el) el.focus();
    var range = document.selection.createRange();
    var bookmark = range.getBookmark();
    var original = el.value;
    var marker = $cda263d9b3dace34$var$getUniqueMarker(original);
    var parent = range.parentElement();
    if (parent === null || !$cda263d9b3dace34$var$inputs(parent)) return result(0, 0);
    range.text = marker + range.text + marker;
    var contents = el.value;
    el.value = original;
    range.moveToBookmark(bookmark);
    range.select();
    return result(contents.indexOf(marker), contents.lastIndexOf(marker) - marker.length);
    function result(start, end) {
        if (active !== el) {
            if (active) active.focus();
            else el.blur();
        }
        return {
            start: start,
            end: end
        };
    }
}
function $cda263d9b3dace34$var$getUniqueMarker(contents) {
    var marker;
    do marker = '@@marker.' + Math.random() * new Date();
    while (contents.indexOf(marker) !== -1);
    return marker;
}
function $cda263d9b3dace34$var$inputs(el) {
    return el.tagName === 'INPUT' && el.type === 'text' || el.tagName === 'TEXTAREA';
}
function $cda263d9b3dace34$var$easySet(el, p) {
    el.selectionStart = $cda263d9b3dace34$var$parse(el, p.start);
    el.selectionEnd = $cda263d9b3dace34$var$parse(el, p.end);
}
function $cda263d9b3dace34$var$hardSet(el, p) {
    var range = el.createTextRange();
    if (p.start === 'end' && p.end === 'end') {
        range.collapse(false);
        range.select();
    } else {
        range.collapse(true);
        range.moveEnd('character', $cda263d9b3dace34$var$parse(el, p.end));
        range.moveStart('character', $cda263d9b3dace34$var$parse(el, p.start));
        range.select();
    }
}
function $cda263d9b3dace34$var$parse(el, value) {
    return value === 'end' ? el.value.length : value || 0;
}
function $cda263d9b3dace34$var$sell(el, p) {
    if (arguments.length === 2) $cda263d9b3dace34$var$set(el, p);
    return $cda263d9b3dace34$var$get(el);
}
$cda263d9b3dace34$exports = $cda263d9b3dace34$var$sell;



var $e82e523c16f1915a$exports = {};
'use strict';
var $16800b95a044e1db$exports = {};
'use strict';
var $16800b95a044e1db$var$getSelection;
var $16800b95a044e1db$var$doc = $parcel$global.document;
var $ced412b95455408e$exports = {};
'use strict';
function $ced412b95455408e$var$getSelectionRaw() {
    return $parcel$global.getSelection();
}
$ced412b95455408e$exports = $ced412b95455408e$var$getSelectionRaw;


var $4d8cdfc8dd5f23d8$exports = {};
'use strict';
function $4d8cdfc8dd5f23d8$var$noop() {}
function $4d8cdfc8dd5f23d8$var$getSelectionNullOp() {
    return {
        removeAllRanges: $4d8cdfc8dd5f23d8$var$noop,
        addRange: $4d8cdfc8dd5f23d8$var$noop
    };
}
$4d8cdfc8dd5f23d8$exports = $4d8cdfc8dd5f23d8$var$getSelectionNullOp;


var $4085fd6ffa4f83a4$exports = {};
'use strict';
var $882961d4e8b23167$exports = {};
'use strict';
var $882961d4e8b23167$var$doc = $parcel$global.document;
var $882961d4e8b23167$var$body = $882961d4e8b23167$var$doc.body;
function $882961d4e8b23167$var$rangeToTextRange(p) {
    if (p.collapsed) return $882961d4e8b23167$var$createBoundaryTextRange({
        node: p.startContainer,
        offset: p.startOffset
    }, true);
    var startRange = $882961d4e8b23167$var$createBoundaryTextRange({
        node: p.startContainer,
        offset: p.startOffset
    }, true);
    var endRange = $882961d4e8b23167$var$createBoundaryTextRange({
        node: p.endContainer,
        offset: p.endOffset
    }, false);
    var textRange = $882961d4e8b23167$var$body.createTextRange();
    textRange.setEndPoint('StartToStart', startRange);
    textRange.setEndPoint('EndToEnd', endRange);
    return textRange;
}
function $882961d4e8b23167$var$isCharacterDataNode(node) {
    var t = node.nodeType;
    return t === 3 || t === 4 || t === 8;
}
function $882961d4e8b23167$var$createBoundaryTextRange(p, starting) {
    var bound;
    var parent;
    var offset = p.offset;
    var workingNode;
    var childNodes;
    var range = $882961d4e8b23167$var$body.createTextRange();
    var data = $882961d4e8b23167$var$isCharacterDataNode(p.node);
    if (data) {
        bound = p.node;
        parent = bound.parentNode;
    } else {
        childNodes = p.node.childNodes;
        bound = offset < childNodes.length ? childNodes[offset] : null;
        parent = p.node;
    }
    workingNode = $882961d4e8b23167$var$doc.createElement('span');
    workingNode.innerHTML = '&#feff;';
    if (bound) parent.insertBefore(workingNode, bound);
    else parent.appendChild(workingNode);
    range.moveToElementText(workingNode);
    range.collapse(!starting);
    parent.removeChild(workingNode);
    if (data) range[starting ? 'moveStart' : 'moveEnd']('character', offset);
    return range;
}
$882961d4e8b23167$exports = $882961d4e8b23167$var$rangeToTextRange;


var $4085fd6ffa4f83a4$var$doc = $parcel$global.document;
var $4085fd6ffa4f83a4$var$body = $4085fd6ffa4f83a4$var$doc.body;
var $4085fd6ffa4f83a4$var$GetSelectionProto = $4085fd6ffa4f83a4$var$GetSelection.prototype;
function $4085fd6ffa4f83a4$var$GetSelection(selection) {
    var self = this;
    var range = selection.createRange();
    this._selection = selection;
    this._ranges = [];
    if (selection.type === 'Control') $4085fd6ffa4f83a4$var$updateControlSelection(self);
    else if ($4085fd6ffa4f83a4$var$isTextRange(range)) $4085fd6ffa4f83a4$var$updateFromTextRange(self, range);
    else $4085fd6ffa4f83a4$var$updateEmptySelection(self);
}
$4085fd6ffa4f83a4$var$GetSelectionProto.removeAllRanges = function() {
    var textRange;
    try {
        this._selection.empty();
        if (this._selection.type !== 'None') {
            textRange = $4085fd6ffa4f83a4$var$body.createTextRange();
            textRange.select();
            this._selection.empty();
        }
    } catch (e) {}
    $4085fd6ffa4f83a4$var$updateEmptySelection(this);
};
$4085fd6ffa4f83a4$var$GetSelectionProto.addRange = function(range) {
    if (this._selection.type === 'Control') $4085fd6ffa4f83a4$var$addRangeToControlSelection(this, range);
    else {
        $882961d4e8b23167$exports(range).select();
        this._ranges[0] = range;
        this.rangeCount = 1;
        this.isCollapsed = this._ranges[0].collapsed;
        $4085fd6ffa4f83a4$var$updateAnchorAndFocusFromRange(this, range, false);
    }
};
$4085fd6ffa4f83a4$var$GetSelectionProto.setRanges = function(ranges) {
    this.removeAllRanges();
    var rangeCount = ranges.length;
    if (rangeCount > 1) $4085fd6ffa4f83a4$var$createControlSelection(this, ranges);
    else if (rangeCount) this.addRange(ranges[0]);
};
$4085fd6ffa4f83a4$var$GetSelectionProto.getRangeAt = function(index) {
    if (index < 0 || index >= this.rangeCount) throw new Error('getRangeAt(): index out of bounds');
    else return this._ranges[index].cloneRange();
};
$4085fd6ffa4f83a4$var$GetSelectionProto.removeRange = function(range) {
    if (this._selection.type !== 'Control') {
        $4085fd6ffa4f83a4$var$removeRangeManually(this, range);
        return;
    }
    var controlRange = this._selection.createRange();
    var rangeElement = $4085fd6ffa4f83a4$var$getSingleElementFromRange(range);
    var newControlRange = $4085fd6ffa4f83a4$var$body.createControlRange();
    var el;
    var removed = false;
    for(var i = 0, len = controlRange.length; i < len; ++i){
        el = controlRange.item(i);
        if (el !== rangeElement || removed) newControlRange.add(controlRange.item(i));
        else removed = true;
    }
    newControlRange.select();
    $4085fd6ffa4f83a4$var$updateControlSelection(this);
};
$4085fd6ffa4f83a4$var$GetSelectionProto.eachRange = function(fn, returnValue) {
    var i = 0;
    var len = this._ranges.length;
    for(i = 0; i < len; ++i){
        if (fn(this.getRangeAt(i))) return returnValue;
    }
};
$4085fd6ffa4f83a4$var$GetSelectionProto.getAllRanges = function() {
    var ranges = [];
    this.eachRange(function(range) {
        ranges.push(range);
    });
    return ranges;
};
$4085fd6ffa4f83a4$var$GetSelectionProto.setSingleRange = function(range) {
    this.removeAllRanges();
    this.addRange(range);
};
function $4085fd6ffa4f83a4$var$createControlSelection(sel, ranges) {
    var controlRange = $4085fd6ffa4f83a4$var$body.createControlRange();
    for(var i = 0, el, len = ranges.length; i < len; ++i){
        el = $4085fd6ffa4f83a4$var$getSingleElementFromRange(ranges[i]);
        try {
            controlRange.add(el);
        } catch (e) {
            throw new Error('setRanges(): Element could not be added to control selection');
        }
    }
    controlRange.select();
    $4085fd6ffa4f83a4$var$updateControlSelection(sel);
}
function $4085fd6ffa4f83a4$var$removeRangeManually(sel, range) {
    var ranges = sel.getAllRanges();
    sel.removeAllRanges();
    for(var i = 0, len = ranges.length; i < len; ++i)if (!$4085fd6ffa4f83a4$var$isSameRange(range, ranges[i])) sel.addRange(ranges[i]);
    if (!sel.rangeCount) $4085fd6ffa4f83a4$var$updateEmptySelection(sel);
}
function $4085fd6ffa4f83a4$var$updateAnchorAndFocusFromRange(sel, range) {
    var anchorPrefix = 'start';
    var focusPrefix = 'end';
    sel.anchorNode = range[anchorPrefix + 'Container'];
    sel.anchorOffset = range[anchorPrefix + 'Offset'];
    sel.focusNode = range[focusPrefix + 'Container'];
    sel.focusOffset = range[focusPrefix + 'Offset'];
}
function $4085fd6ffa4f83a4$var$updateEmptySelection(sel) {
    sel.anchorNode = sel.focusNode = null;
    sel.anchorOffset = sel.focusOffset = 0;
    sel.rangeCount = 0;
    sel.isCollapsed = true;
    sel._ranges.length = 0;
}
function $4085fd6ffa4f83a4$var$rangeContainsSingleElement(rangeNodes) {
    if (!rangeNodes.length || rangeNodes[0].nodeType !== 1) return false;
    for(var i = 1, len = rangeNodes.length; i < len; ++i){
        if (!$4085fd6ffa4f83a4$var$isAncestorOf(rangeNodes[0], rangeNodes[i])) return false;
    }
    return true;
}
function $4085fd6ffa4f83a4$var$getSingleElementFromRange(range) {
    var nodes = range.getNodes();
    if (!$4085fd6ffa4f83a4$var$rangeContainsSingleElement(nodes)) throw new Error('getSingleElementFromRange(): range did not consist of a single element');
    return nodes[0];
}
function $4085fd6ffa4f83a4$var$isTextRange(range) {
    return range && range.text !== void 0;
}
function $4085fd6ffa4f83a4$var$updateFromTextRange(sel, range) {
    sel._ranges = [
        range
    ];
    $4085fd6ffa4f83a4$var$updateAnchorAndFocusFromRange(sel, range, false);
    sel.rangeCount = 1;
    sel.isCollapsed = range.collapsed;
}
function $4085fd6ffa4f83a4$var$updateControlSelection(sel) {
    sel._ranges.length = 0;
    if (sel._selection.type === 'None') $4085fd6ffa4f83a4$var$updateEmptySelection(sel);
    else {
        var controlRange = sel._selection.createRange();
        if ($4085fd6ffa4f83a4$var$isTextRange(controlRange)) $4085fd6ffa4f83a4$var$updateFromTextRange(sel, controlRange);
        else {
            sel.rangeCount = controlRange.length;
            var range;
            for(var i = 0; i < sel.rangeCount; ++i){
                range = $4085fd6ffa4f83a4$var$doc.createRange();
                range.selectNode(controlRange.item(i));
                sel._ranges.push(range);
            }
            sel.isCollapsed = sel.rangeCount === 1 && sel._ranges[0].collapsed;
            $4085fd6ffa4f83a4$var$updateAnchorAndFocusFromRange(sel, sel._ranges[sel.rangeCount - 1], false);
        }
    }
}
function $4085fd6ffa4f83a4$var$addRangeToControlSelection(sel, range) {
    var controlRange = sel._selection.createRange();
    var rangeElement = $4085fd6ffa4f83a4$var$getSingleElementFromRange(range);
    var newControlRange = $4085fd6ffa4f83a4$var$body.createControlRange();
    for(var i = 0, len = controlRange.length; i < len; ++i)newControlRange.add(controlRange.item(i));
    try {
        newControlRange.add(rangeElement);
    } catch (e) {
        throw new Error('addRange(): Element could not be added to control selection');
    }
    newControlRange.select();
    $4085fd6ffa4f83a4$var$updateControlSelection(sel);
}
function $4085fd6ffa4f83a4$var$isSameRange(left, right) {
    return left.startContainer === right.startContainer && left.startOffset === right.startOffset && left.endContainer === right.endContainer && left.endOffset === right.endOffset;
}
function $4085fd6ffa4f83a4$var$isAncestorOf(ancestor, descendant) {
    var node = descendant;
    while(node.parentNode){
        if (node.parentNode === ancestor) return true;
        node = node.parentNode;
    }
    return false;
}
function $4085fd6ffa4f83a4$var$getSelection() {
    return new $4085fd6ffa4f83a4$var$GetSelection($parcel$global.document.selection);
}
$4085fd6ffa4f83a4$exports = $4085fd6ffa4f83a4$var$getSelection;


var $1424c7fa6b5f7943$exports = {};
'use strict';
function $1424c7fa6b5f7943$var$isHostMethod(host, prop) {
    var type = typeof host[prop];
    return type === 'function' || !!(type === 'object' && host[prop]) || type === 'unknown';
}
function $1424c7fa6b5f7943$var$isHostProperty(host, prop) {
    return typeof host[prop] !== 'undefined';
}
function $1424c7fa6b5f7943$var$many(fn) {
    return function areHosted(host, props) {
        var i = props.length;
        while(i--){
            if (!fn(host, props[i])) return false;
        }
        return true;
    };
}
$1424c7fa6b5f7943$exports = {
    method: $1424c7fa6b5f7943$var$isHostMethod,
    methods: $1424c7fa6b5f7943$var$many($1424c7fa6b5f7943$var$isHostMethod),
    property: $1424c7fa6b5f7943$var$isHostProperty,
    properties: $1424c7fa6b5f7943$var$many($1424c7fa6b5f7943$var$isHostProperty)
};


if ($1424c7fa6b5f7943$exports.method($parcel$global, 'getSelection')) $16800b95a044e1db$var$getSelection = $ced412b95455408e$exports;
else if (typeof $16800b95a044e1db$var$doc.selection === 'object' && $16800b95a044e1db$var$doc.selection) $16800b95a044e1db$var$getSelection = $4085fd6ffa4f83a4$exports;
else $16800b95a044e1db$var$getSelection = $4d8cdfc8dd5f23d8$exports;
$16800b95a044e1db$exports = $16800b95a044e1db$var$getSelection;


var $2aeadac5b7e5e378$exports = {};
'use strict';


var $2aeadac5b7e5e378$var$doc = $parcel$global.document;
function $2aeadac5b7e5e378$var$setSelection(p) {
    if ($2aeadac5b7e5e378$var$doc.createRange) modernSelection();
    else oldSelection();
    function modernSelection() {
        var sel = $16800b95a044e1db$exports();
        var range = $2aeadac5b7e5e378$var$doc.createRange();
        if (!p.startContainer) return;
        if (p.endContainer) range.setEnd(p.endContainer, p.endOffset);
        else range.setEnd(p.startContainer, p.startOffset);
        range.setStart(p.startContainer, p.startOffset);
        sel.removeAllRanges();
        sel.addRange(range);
    }
    function oldSelection() {
        $882961d4e8b23167$exports(p).select();
    }
}
$2aeadac5b7e5e378$exports = $2aeadac5b7e5e378$var$setSelection;


$e82e523c16f1915a$exports = {
    get: $16800b95a044e1db$exports,
    set: $2aeadac5b7e5e378$exports
};



var $df459237e1045145$var$getSelection = $e82e523c16f1915a$exports.get;
var $df459237e1045145$var$props = [
    'direction',
    'boxSizing',
    'width',
    'height',
    'overflowX',
    'overflowY',
    'borderTopWidth',
    'borderRightWidth',
    'borderBottomWidth',
    'borderLeftWidth',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'fontStyle',
    'fontVariant',
    'fontWeight',
    'fontStretch',
    'fontSize',
    'fontSizeAdjust',
    'lineHeight',
    'fontFamily',
    'textAlign',
    'textTransform',
    'textIndent',
    'textDecoration',
    'letterSpacing',
    'wordSpacing'
];
var $df459237e1045145$var$win = $parcel$global;
var $df459237e1045145$var$doc = document;
var $df459237e1045145$var$ff = $df459237e1045145$var$win.mozInnerScreenX !== null && $df459237e1045145$var$win.mozInnerScreenX !== void 0;
function $df459237e1045145$var$tailormade(el, options) {
    var textInput = el.tagName === 'INPUT' || el.tagName === 'TEXTAREA';
    var throttledRefresh = $d2ed8a4bf2561f96$exports(refresh, 30);
    var o = options || {};
    bind();
    return {
        read: readPosition,
        refresh: throttledRefresh,
        destroy: destroy
    };
    function noop() {}
    function readPosition() {
        return (textInput ? coordsText : coordsHTML)();
    }
    function refresh() {
        if (o.sleeping) return;
        return (o.update || noop)(readPosition());
    }
    function coordsText() {
        var p = $cda263d9b3dace34$exports(el);
        var context = prepare();
        var readings = readTextCoords(context, p.start);
        $df459237e1045145$var$doc.body.removeChild(context.mirror);
        return readings;
    }
    function coordsHTML() {
        var sel = $df459237e1045145$var$getSelection();
        if (sel.rangeCount) {
            var range = sel.getRangeAt(0);
            var needsToWorkAroundNewlineBug = range.startContainer.nodeName === 'P' && range.startOffset === 0;
            if (needsToWorkAroundNewlineBug) return {
                x: range.startContainer.offsetLeft,
                y: range.startContainer.offsetTop,
                absolute: true
            };
            if (range.getClientRects) {
                var rects = range.getClientRects();
                if (rects.length > 0) return {
                    x: rects[0].left,
                    y: rects[0].top,
                    absolute: true
                };
            }
        }
        return {
            x: 0,
            y: 0
        };
    }
    function readTextCoords(context, p) {
        var rest = $df459237e1045145$var$doc.createElement('span');
        var mirror = context.mirror;
        var computed = context.computed;
        write(mirror, read(el).substring(0, p));
        if (el.tagName === 'INPUT') mirror.textContent = mirror.textContent.replace(/\s/g, '\u00a0');
        write(rest, read(el).substring(p) || '.');
        mirror.appendChild(rest);
        return {
            x: rest.offsetLeft + parseInt(computed['borderLeftWidth']),
            y: rest.offsetTop + parseInt(computed['borderTopWidth'])
        };
    }
    function read(el) {
        return textInput ? el.value : el.innerHTML;
    }
    function prepare() {
        var computed = $df459237e1045145$var$win.getComputedStyle ? getComputedStyle(el) : el.currentStyle;
        var mirror = $df459237e1045145$var$doc.createElement('div');
        var style = mirror.style;
        $df459237e1045145$var$doc.body.appendChild(mirror);
        if (el.tagName !== 'INPUT') style.wordWrap = 'break-word';
        style.whiteSpace = 'pre-wrap';
        style.position = 'absolute';
        style.visibility = 'hidden';
        $df459237e1045145$var$props.forEach(copy);
        if ($df459237e1045145$var$ff) {
            style.width = parseInt(computed.width) - 2 + 'px';
            if (el.scrollHeight > parseInt(computed.height)) style.overflowY = 'scroll';
        } else style.overflow = 'hidden';
        return {
            mirror: mirror,
            computed: computed
        };
        function copy(prop) {
            style[prop] = computed[prop];
        }
    }
    function write(el, value) {
        if (textInput) el.textContent = value;
        else el.innerHTML = value;
    }
    function bind(remove) {
        var op = remove ? 'remove' : 'add';
        $dae43bc3b0091a53$exports[op](el, 'keydown', throttledRefresh);
        $dae43bc3b0091a53$exports[op](el, 'keyup', throttledRefresh);
        $dae43bc3b0091a53$exports[op](el, 'input', throttledRefresh);
        $dae43bc3b0091a53$exports[op](el, 'paste', throttledRefresh);
        $dae43bc3b0091a53$exports[op](el, 'change', throttledRefresh);
    }
    function destroy() {
        bind(true);
    }
}
$df459237e1045145$exports = $df459237e1045145$var$tailormade;


function $ed6c1e273a3cca93$var$bullseye(el, target, options) {
    var o = options;
    var domTarget = target && target.tagName;
    if (!domTarget && arguments.length === 2) o = target;
    if (!domTarget) target = el;
    if (!o) o = {};
    var destroyed = false;
    var throttledWrite = $d2ed8a4bf2561f96$exports(write, 30);
    var tailorOptions = {
        update: o.autoupdateToCaret !== false && update
    };
    var tailor = o.caret && $df459237e1045145$exports(target, tailorOptions);
    write();
    if (o.tracking !== false) $dae43bc3b0091a53$exports.add(window, 'resize', throttledWrite);
    return {
        read: readNull,
        refresh: write,
        destroy: destroy,
        sleep: sleep
    };
    function sleep() {
        tailorOptions.sleeping = true;
    }
    function readNull() {
        return read();
    }
    function read(readings) {
        var bounds = target.getBoundingClientRect();
        var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
        if (tailor) {
            readings = tailor.read();
            return {
                x: (readings.absolute ? 0 : bounds.left) + readings.x,
                y: (readings.absolute ? 0 : bounds.top) + scrollTop + readings.y + 20
            };
        }
        return {
            x: bounds.left,
            y: bounds.top + scrollTop
        };
    }
    function update(readings) {
        write(readings);
    }
    function write(readings) {
        if (destroyed) throw new Error('Bullseye can\'t refresh after being destroyed. Create another instance instead.');
        if (tailor && !readings) {
            tailorOptions.sleeping = false;
            tailor.refresh();
            return;
        }
        var p = read(readings);
        if (!tailor && target !== el) p.y += target.offsetHeight;
        el.style.left = p.x + 'px';
        el.style.top = p.y + 'px';
    }
    function destroy() {
        if (tailor) tailor.destroy();
        $dae43bc3b0091a53$exports.remove(window, 'resize', throttledWrite);
        destroyed = true;
    }
}
$ed6c1e273a3cca93$exports = $ed6c1e273a3cca93$var$bullseye;


var $6e44122a51588a32$exports = {};
'use strict';
$6e44122a51588a32$exports = function throttle(fn, boundary) {
    var last = -Infinity;
    var timer;
    return function bounced() {
        if (timer) return;
        unbound();
        function unbound() {
            clearTimeout(timer);
            timer = null;
            var next = last + boundary;
            var now = +new Date();
            if (now > next) {
                last = now;
                fn.apply(this, arguments);
            } else timer = setTimeout(unbound, next - now);
        }
    };
};


var $5e47bb76f53e3849$exports = {};
'use strict';

var $k0LC7 = parcelRequire("k0LC7");
// naïve implementation, specifically meant to clone `options` objects
function $5e47bb76f53e3849$var$clone(thing) {
    var copy = {};
    var value;
    for(var key in thing){
        value = thing[key];
        if (!value) copy[key] = value;
        else if ($k0LC7.isMoment(value)) copy[key] = value.clone();
        else if (value._isStylesConfiguration) copy[key] = $5e47bb76f53e3849$var$clone(value);
        else copy[key] = value;
    }
    return copy;
}
$5e47bb76f53e3849$exports = $5e47bb76f53e3849$var$clone;


var $020382e08049b2ed$exports = {};
'use strict';

var $9FL18 = parcelRequire("9FL18");

var $gBEl8 = parcelRequire("gBEl8");

var $k0LC7 = parcelRequire("k0LC7");
function $020382e08049b2ed$var$defaults(options, cal) {
    var temp;
    var no;
    var o = options || {};
    if (o.autoHideOnClick === no) o.autoHideOnClick = true;
    if (o.autoHideOnBlur === no) o.autoHideOnBlur = true;
    if (o.autoClose === no) o.autoClose = true;
    if (o.appendTo === no) o.appendTo = document.body;
    if (o.appendTo === 'parent') {
        if ($gBEl8(cal.associated)) o.appendTo = cal.associated.parentNode;
        else throw new Error('Inline calendars must be appended to a parent node explicitly.');
    }
    if (o.invalidate === no) o.invalidate = true;
    if (o.required === no) o.required = false;
    if (o.date === no) o.date = true;
    if (o.time === no) o.time = true;
    if (o.date === false && o.time === false) throw new Error('At least one of `date` or `time` must be `true`.');
    if (o.inputFormat === no) {
        if (o.date && o.time) o.inputFormat = 'YYYY-MM-DD HH:mm';
        else if (o.date) o.inputFormat = 'YYYY-MM-DD';
        else o.inputFormat = 'HH:mm';
    }
    if (o.initialValue === no) o.initialValue = null;
    else o.initialValue = $9FL18(o.initialValue, o.inputFormat);
    if (o.min === no) o.min = null;
    else o.min = $9FL18(o.min, o.inputFormat);
    if (o.max === no) o.max = null;
    else o.max = $9FL18(o.max, o.inputFormat);
    if (o.timeInterval === no) o.timeInterval = 1800;
     // 30 minutes by default
    if (o.min && o.max) {
        if (o.max.isBefore(o.min)) {
            temp = o.max;
            o.max = o.min;
            o.min = temp;
        }
        if (o.date === true) {
            if (o.max.clone().subtract(1, 'days').isBefore(o.min)) throw new Error('`max` must be at least one day after `min`');
        } else if (o.timeInterval * 1000 - o.min % (o.timeInterval * 1000) > o.max - o.min) throw new Error('`min` to `max` range must allow for at least one time option that matches `timeInterval`');
    }
    if (o.dateValidator === no) o.dateValidator = Function.prototype;
    if (o.timeValidator === no) o.timeValidator = Function.prototype;
    if (o.timeFormat === no) o.timeFormat = 'HH:mm';
    if (o.weekStart === no) o.weekStart = $k0LC7.moment().weekday(0).day();
    if (o.weekdayFormat === no) o.weekdayFormat = 'min';
    if (o.weekdayFormat === 'long') o.weekdayFormat = $k0LC7.moment.weekdays();
    else if (o.weekdayFormat === 'short') o.weekdayFormat = $k0LC7.moment.weekdaysShort();
    else if (o.weekdayFormat === 'min') o.weekdayFormat = $k0LC7.moment.weekdaysMin();
    else if (!Array.isArray(o.weekdayFormat) || o.weekdayFormat.length < 7) throw new Error('`weekdays` must be `min`, `short`, or `long`');
    if (o.monthsInCalendar === no) o.monthsInCalendar = 1;
    if (o.monthFormat === no) o.monthFormat = 'MMMM YYYY';
    if (o.dayFormat === no) o.dayFormat = 'DD';
    if (o.styles === no) o.styles = {};
    o.styles._isStylesConfiguration = true;
    var styl = o.styles;
    if (styl.back === no) styl.back = 'rd-back';
    if (styl.container === no) styl.container = 'rd-container';
    if (styl.positioned === no) styl.positioned = 'rd-container-attachment';
    if (styl.date === no) styl.date = 'rd-date';
    if (styl.dayBody === no) styl.dayBody = 'rd-days-body';
    if (styl.dayBodyElem === no) styl.dayBodyElem = 'rd-day-body';
    if (styl.dayPrevMonth === no) styl.dayPrevMonth = 'rd-day-prev-month';
    if (styl.dayNextMonth === no) styl.dayNextMonth = 'rd-day-next-month';
    if (styl.dayDisabled === no) styl.dayDisabled = 'rd-day-disabled';
    if (styl.dayConcealed === no) styl.dayConcealed = 'rd-day-concealed';
    if (styl.dayHead === no) styl.dayHead = 'rd-days-head';
    if (styl.dayHeadElem === no) styl.dayHeadElem = 'rd-day-head';
    if (styl.dayRow === no) styl.dayRow = 'rd-days-row';
    if (styl.dayTable === no) styl.dayTable = 'rd-days';
    if (styl.month === no) styl.month = 'rd-month';
    if (styl.monthLabel === no) styl.monthLabel = 'rd-month-label';
    if (styl.next === no) styl.next = 'rd-next';
    if (styl.selectedDay === no) styl.selectedDay = 'rd-day-selected';
    if (styl.selectedTime === no) styl.selectedTime = 'rd-time-selected';
    if (styl.time === no) styl.time = 'rd-time';
    if (styl.timeList === no) styl.timeList = 'rd-time-list';
    if (styl.timeOption === no) styl.timeOption = 'rd-time-option';
    return o;
}
$020382e08049b2ed$exports = $020382e08049b2ed$var$defaults;


var $31fd9ab1e2ae3e98$exports = {};
'use strict';

var $9c65d61a0e9f9e05$exports = {};
'use strict';
var $f1e015c75890b0c9$exports = {};
$f1e015c75890b0c9$exports = function atoa(a, n) {
    return Array.prototype.slice.call(a, n);
};


var $e3a9377624e2e136$exports = {};
'use strict';
var $7cab828b291b6040$exports = {};
var $7cab828b291b6040$var$si = typeof setImmediate === 'function', $7cab828b291b6040$var$tick;
if ($7cab828b291b6040$var$si) $7cab828b291b6040$var$tick = function(fn) {
    setImmediate(fn);
};
else $7cab828b291b6040$var$tick = function(fn) {
    setTimeout(fn, 0);
};
$7cab828b291b6040$exports = $7cab828b291b6040$var$tick;


$e3a9377624e2e136$exports = function debounce(fn, args, ctx) {
    if (!fn) return;
    $7cab828b291b6040$exports(function run() {
        fn.apply(ctx || null, args || []);
    });
};


$9c65d61a0e9f9e05$exports = function emitter(thing, options) {
    var opts = options || {};
    var evt = {};
    if (thing === undefined) thing = {};
    thing.on = function(type, fn) {
        if (!evt[type]) evt[type] = [
            fn
        ];
        else evt[type].push(fn);
        return thing;
    };
    thing.once = function(type, fn) {
        fn._once = true; // thing.off(fn) still works!
        thing.on(type, fn);
        return thing;
    };
    thing.off = function(type, fn) {
        var c = arguments.length;
        if (c === 1) delete evt[type];
        else if (c === 0) evt = {};
        else {
            var et = evt[type];
            if (!et) return thing;
            et.splice(et.indexOf(fn), 1);
        }
        return thing;
    };
    thing.emit = function() {
        var args = $f1e015c75890b0c9$exports(arguments);
        return thing.emitterSnapshot(args.shift()).apply(this, args);
    };
    thing.emitterSnapshot = function(type) {
        var et = (evt[type] || []).slice(0);
        return function() {
            var args = $f1e015c75890b0c9$exports(arguments);
            var ctx = this || thing;
            if (type === 'error' && opts.throws !== false && !et.length) throw args.length === 1 ? args[0] : args;
            et.forEach(function emitter(listen) {
                if (opts.async) $e3a9377624e2e136$exports(listen, args, ctx);
                else listen.apply(ctx, args);
                if (listen._once) thing.off(type, listen);
            });
            return thing;
        };
    };
    return thing;
};


var $94a5c6ab2c287c72$exports = {};
'use strict';
function $94a5c6ab2c287c72$var$dom(options) {
    var o = options || {};
    if (!o.type) o.type = 'div';
    var elem = document.createElement(o.type);
    if (o.className) elem.className = o.className;
    if (o.text) elem.innerText = elem.textContent = o.text;
    if (o.attributes) Object.keys(o.attributes).forEach(function(key) {
        elem.setAttribute(key, o.attributes[key]);
    });
    if (o.parent) o.parent.appendChild(elem);
    return elem;
}
$94a5c6ab2c287c72$exports = $94a5c6ab2c287c72$var$dom;


var $fe818bce31d3da13$exports = {};
'use strict';
function $fe818bce31d3da13$var$text(elem, value) {
    if (arguments.length === 2) elem.innerText = elem.textContent = value;
    return elem.innerText || elem.textContent;
}
$fe818bce31d3da13$exports = $fe818bce31d3da13$var$text;



var $9FL18 = parcelRequire("9FL18");



var $k0LC7 = parcelRequire("k0LC7");
var $37cb1f8a5909f3e4$exports = {};
'use strict';
var $37cb1f8a5909f3e4$var$trim = /^\s+|\s+$/g;
var $37cb1f8a5909f3e4$var$whitespace = /\s+/;
function $37cb1f8a5909f3e4$var$classes(node) {
    return node.className.replace($37cb1f8a5909f3e4$var$trim, '').split($37cb1f8a5909f3e4$var$whitespace);
}
function $37cb1f8a5909f3e4$var$set(node, value) {
    node.className = value.join(' ');
}
function $37cb1f8a5909f3e4$var$add(node, value) {
    var values = $37cb1f8a5909f3e4$var$remove(node, value);
    values.push(value);
    $37cb1f8a5909f3e4$var$set(node, values);
}
function $37cb1f8a5909f3e4$var$remove(node, value) {
    var values = $37cb1f8a5909f3e4$var$classes(node);
    var i = values.indexOf(value);
    if (i !== -1) {
        values.splice(i, 1);
        $37cb1f8a5909f3e4$var$set(node, values);
    }
    return values;
}
function $37cb1f8a5909f3e4$var$contains(node, value) {
    return $37cb1f8a5909f3e4$var$classes(node).indexOf(value) !== -1;
}
$37cb1f8a5909f3e4$exports = {
    add: $37cb1f8a5909f3e4$var$add,
    remove: $37cb1f8a5909f3e4$var$remove,
    contains: $37cb1f8a5909f3e4$var$contains
};


var $a93ba6a3c0794d22$exports = {};
'use strict';
function $a93ba6a3c0794d22$var$noop() {}
$a93ba6a3c0794d22$exports = $a93ba6a3c0794d22$var$noop;


var $31fd9ab1e2ae3e98$var$no;
function $31fd9ab1e2ae3e98$var$calendar(calendarOptions) {
    var o;
    var ref;
    var refCal;
    var container;
    var rendered = false;
    // date variables
    var monthOffsetAttribute = 'data-rome-offset';
    var weekdays;
    var weekdayCount;
    var calendarMonths = [];
    var lastYear;
    var lastMonth;
    var lastDay;
    var lastDayElement;
    var datewrapper;
    var back;
    var next;
    // time variables
    var secondsInDay = 86400;
    var time;
    var timelist;
    var api = $9c65d61a0e9f9e05$exports({
        associated: calendarOptions.associated
    });
    init();
    setTimeout(ready, 0);
    return api;
    function napi() {
        return api;
    }
    function init(initOptions) {
        o = $020382e08049b2ed$exports(initOptions || calendarOptions, api);
        if (!container) container = $94a5c6ab2c287c72$exports({
            className: o.styles.container
        });
        weekdays = o.weekdayFormat;
        weekdayCount = weekdays.length;
        lastMonth = $31fd9ab1e2ae3e98$var$no;
        lastYear = $31fd9ab1e2ae3e98$var$no;
        lastDay = $31fd9ab1e2ae3e98$var$no;
        lastDayElement = $31fd9ab1e2ae3e98$var$no;
        o.appendTo.appendChild(container);
        removeChildren(container);
        rendered = false;
        ref = o.initialValue ? o.initialValue : $k0LC7.moment();
        refCal = ref.clone();
        api.back = subtractMonth;
        api.container = container;
        api.destroyed = false;
        api.destroy = destroy.bind(api, false);
        api.emitValues = emitValues;
        api.getDate = getDate;
        api.getDateString = getDateString;
        api.getMoment = getMoment;
        api.hide = hide;
        api.next = addMonth;
        api.options = changeOptions;
        api.options.reset = resetOptions;
        api.refresh = refresh;
        api.restore = napi;
        api.setValue = setValue;
        api.show = show;
        eventListening();
        ready();
        return api;
    }
    function ready() {
        api.emit('ready', $5e47bb76f53e3849$exports(o));
    }
    function destroy(silent) {
        if (container && container.parentNode) container.parentNode.removeChild(container);
        if (o) eventListening(true);
        var destroyed = api.emitterSnapshot('destroyed');
        api.back = $a93ba6a3c0794d22$exports;
        api.destroyed = true;
        api.destroy = napi;
        api.emitValues = napi;
        api.getDate = $a93ba6a3c0794d22$exports;
        api.getDateString = $a93ba6a3c0794d22$exports;
        api.getMoment = $a93ba6a3c0794d22$exports;
        api.hide = napi;
        api.next = $a93ba6a3c0794d22$exports;
        api.options = napi;
        api.options.reset = napi;
        api.refresh = napi;
        api.restore = init;
        api.setValue = napi;
        api.show = napi;
        api.off();
        if (silent !== true) destroyed();
        return api;
    }
    function eventListening(remove) {
        var op = remove ? 'remove' : 'add';
        if (o.autoHideOnBlur) $a18850637d618268$exports[op](document.documentElement, 'focus', hideOnBlur, true);
        if (o.autoHideOnClick) $a18850637d618268$exports[op](document, 'click', hideOnClick);
    }
    function changeOptions(options) {
        if (arguments.length === 0) return $5e47bb76f53e3849$exports(o);
        destroy();
        init(options);
        return api;
    }
    function resetOptions() {
        return changeOptions({
            appendTo: o.appendTo
        });
    }
    function render() {
        if (rendered) return;
        rendered = true;
        renderDates();
        renderTime();
        api.emit('render');
    }
    function renderDates() {
        if (!o.date) return;
        var i;
        calendarMonths = [];
        datewrapper = $94a5c6ab2c287c72$exports({
            className: o.styles.date,
            parent: container
        });
        for(i = 0; i < o.monthsInCalendar; i++)renderMonth(i);
        $a18850637d618268$exports.add(back, 'click', subtractMonth);
        $a18850637d618268$exports.add(next, 'click', addMonth);
        $a18850637d618268$exports.add(datewrapper, 'click', pickDay);
        function renderMonth(i) {
            var month = $94a5c6ab2c287c72$exports({
                className: o.styles.month,
                parent: datewrapper
            });
            if (i === 0) back = $94a5c6ab2c287c72$exports({
                type: 'button',
                className: o.styles.back,
                attributes: {
                    type: 'button'
                },
                parent: month
            });
            if (i === o.monthsInCalendar - 1) next = $94a5c6ab2c287c72$exports({
                type: 'button',
                className: o.styles.next,
                attributes: {
                    type: 'button'
                },
                parent: month
            });
            var label = $94a5c6ab2c287c72$exports({
                className: o.styles.monthLabel,
                parent: month
            });
            var date = $94a5c6ab2c287c72$exports({
                type: 'table',
                className: o.styles.dayTable,
                parent: month
            });
            var datehead = $94a5c6ab2c287c72$exports({
                type: 'thead',
                className: o.styles.dayHead,
                parent: date
            });
            var dateheadrow = $94a5c6ab2c287c72$exports({
                type: 'tr',
                className: o.styles.dayRow,
                parent: datehead
            });
            var datebody = $94a5c6ab2c287c72$exports({
                type: 'tbody',
                className: o.styles.dayBody,
                parent: date
            });
            var j;
            for(j = 0; j < weekdayCount; j++)$94a5c6ab2c287c72$exports({
                type: 'th',
                className: o.styles.dayHeadElem,
                parent: dateheadrow,
                text: weekdays[weekday(j)]
            });
            datebody.setAttribute(monthOffsetAttribute, i);
            calendarMonths.push({
                label: label,
                body: datebody
            });
        }
    }
    function renderTime() {
        if (!o.time || !o.timeInterval) return;
        var timewrapper = $94a5c6ab2c287c72$exports({
            className: o.styles.time,
            parent: container
        });
        time = $94a5c6ab2c287c72$exports({
            className: o.styles.selectedTime,
            parent: timewrapper,
            text: ref.format(o.timeFormat)
        });
        $a18850637d618268$exports.add(time, 'click', toggleTimeList);
        timelist = $94a5c6ab2c287c72$exports({
            className: o.styles.timeList,
            parent: timewrapper
        });
        $a18850637d618268$exports.add(timelist, 'click', pickTime);
        var next = $k0LC7.moment('00:00:00', 'HH:mm:ss');
        var latest = next.clone().add(1, 'days');
        while(next.isBefore(latest)){
            $94a5c6ab2c287c72$exports({
                className: o.styles.timeOption,
                parent: timelist,
                text: next.format(o.timeFormat)
            });
            next.add(o.timeInterval, 'seconds');
        }
    }
    function weekday(index, backwards) {
        var factor = backwards ? -1 : 1;
        var offset = index + o.weekStart * factor;
        if (offset >= weekdayCount || offset < 0) offset += weekdayCount * -factor;
        return offset;
    }
    function displayValidTimesOnly() {
        if (!o.time || !rendered) return;
        var times = timelist.children;
        var length = times.length;
        var date;
        var time;
        var item;
        var i;
        for(i = 0; i < length; i++){
            item = times[i];
            time = $k0LC7.moment($fe818bce31d3da13$exports(item), o.timeFormat);
            date = setTime(ref.clone(), time);
            item.style.display = isInRange(date, false, o.timeValidator) ? 'block' : 'none';
        }
    }
    function toggleTimeList(show) {
        var display = typeof show === 'boolean' ? show : timelist.style.display === 'none';
        if (display) showTimeList();
        else hideTimeList();
    }
    function showTimeList() {
        if (timelist) timelist.style.display = 'block';
    }
    function hideTimeList() {
        if (timelist) timelist.style.display = 'none';
    }
    function showCalendar() {
        container.style.display = 'inline-block';
        api.emit('show');
    }
    function hideCalendar() {
        if (container.style.display !== 'none') {
            container.style.display = 'none';
            api.emit('hide');
        }
    }
    function show() {
        render();
        refresh();
        toggleTimeList(!o.date);
        showCalendar();
        return api;
    }
    function hide() {
        hideTimeList();
        setTimeout(hideCalendar, 0);
        return api;
    }
    function hideConditionally() {
        hideTimeList();
        var pos = $37cb1f8a5909f3e4$exports.contains(container, o.styles.positioned);
        if (pos) setTimeout(hideCalendar, 0);
        return api;
    }
    function calendarEventTarget(e) {
        var target = e.target;
        if (target === api.associated) return true;
        while(target){
            if (target === container) return true;
            target = target.parentNode;
        }
    }
    function hideOnBlur(e) {
        if (calendarEventTarget(e)) return;
        hideConditionally();
    }
    function hideOnClick(e) {
        if (calendarEventTarget(e)) return;
        hideConditionally();
    }
    function subtractMonth() {
        changeMonth('subtract');
    }
    function addMonth() {
        changeMonth('add');
    }
    function changeMonth(op) {
        var bound;
        var direction = op === 'add' ? -1 : 1;
        var offset = o.monthsInCalendar + direction * getMonthOffset(lastDayElement);
        refCal[op](offset, 'months');
        bound = inRange(refCal.clone());
        ref = bound || ref;
        if (bound) refCal = bound.clone();
        update();
        api.emit(op === 'add' ? 'next' : 'back', ref.month());
    }
    function update(silent) {
        updateCalendar();
        updateTime();
        if (silent !== true) emitValues();
        displayValidTimesOnly();
    }
    function updateCalendar() {
        if (!o.date || !rendered) return;
        var y = refCal.year();
        var m = refCal.month();
        var d = refCal.date();
        if (d === lastDay && m === lastMonth && y === lastYear) return;
        var canStay = isDisplayed();
        lastDay = refCal.date();
        lastMonth = refCal.month();
        lastYear = refCal.year();
        if (canStay) {
            updateCalendarSelection();
            return;
        }
        calendarMonths.forEach(updateMonth);
        renderAllDays();
        function updateMonth(month, i) {
            var offsetCal = refCal.clone().add(i, 'months');
            $fe818bce31d3da13$exports(month.label, offsetCal.format(o.monthFormat));
            removeChildren(month.body);
        }
    }
    function updateCalendarSelection() {
        var day = refCal.date() - 1;
        selectDayElement(false);
        calendarMonths.forEach(function(cal) {
            var days;
            if (sameCalendarMonth(cal.date, refCal)) {
                days = cast(cal.body.children).map(aggregate);
                days = Array.prototype.concat.apply([], days).filter(inside);
                selectDayElement(days[day]);
            }
        });
        function cast(like) {
            var dest = [];
            var i;
            for(i = 0; i < like.length; i++)dest.push(like[i]);
            return dest;
        }
        function aggregate(child) {
            return cast(child.children);
        }
        function inside(child) {
            return !$37cb1f8a5909f3e4$exports.contains(child, o.styles.dayPrevMonth) && !$37cb1f8a5909f3e4$exports.contains(child, o.styles.dayNextMonth);
        }
    }
    function isDisplayed() {
        return calendarMonths.some(matches);
        function matches(cal) {
            if (!lastYear) return false;
            return sameCalendarMonth(cal.date, refCal);
        }
    }
    function sameCalendarMonth(left, right) {
        return left && right && left.year() === right.year() && left.month() === right.month();
    }
    function updateTime() {
        if (!o.time || !rendered) return;
        $fe818bce31d3da13$exports(time, ref.format(o.timeFormat));
    }
    function emitValues() {
        api.emit('data', getDateString());
        api.emit('year', ref.year());
        api.emit('month', ref.month());
        api.emit('day', ref.day());
        api.emit('time', ref.format(o.timeFormat));
        return api;
    }
    function refresh() {
        lastYear = false;
        lastMonth = false;
        lastDay = false;
        update(true);
        return api;
    }
    function setValue(value) {
        var date = $9FL18(value, o.inputFormat);
        if (date === null) return;
        ref = inRange(date) || ref;
        refCal = ref.clone();
        update(true);
        return api;
    }
    function removeChildren(elem, self) {
        while(elem && elem.firstChild)elem.removeChild(elem.firstChild);
        if (self === true) elem.parentNode.removeChild(elem);
    }
    function renderAllDays() {
        var i;
        for(i = 0; i < o.monthsInCalendar; i++)renderDays(i);
    }
    function renderDays(offset) {
        var month = calendarMonths[offset];
        var offsetCal = refCal.clone().add(offset, 'months');
        var total = offsetCal.daysInMonth();
        var current = offsetCal.month() !== ref.month() ? -1 : ref.date(); // -1 : 1..31
        var first = offsetCal.clone().date(1);
        var firstDay = weekday(first.day(), true); // 0..6
        var tr = $94a5c6ab2c287c72$exports({
            type: 'tr',
            className: o.styles.dayRow,
            parent: month.body
        });
        var prevMonth = hiddenWhen(offset !== 0, [
            o.styles.dayBodyElem,
            o.styles.dayPrevMonth
        ]);
        var nextMonth = hiddenWhen(offset !== o.monthsInCalendar - 1, [
            o.styles.dayBodyElem,
            o.styles.dayNextMonth
        ]);
        var disabled = o.styles.dayDisabled;
        var lastDay;
        part({
            base: first.clone().subtract(firstDay, 'days'),
            length: firstDay,
            cell: prevMonth
        });
        part({
            base: first.clone(),
            length: total,
            cell: [
                o.styles.dayBodyElem
            ],
            selectable: true
        });
        lastDay = first.clone().add(total, 'days');
        part({
            base: lastDay,
            length: weekdayCount - tr.children.length,
            cell: nextMonth
        });
        back.disabled = !isInRangeLeft(first, true);
        next.disabled = !isInRangeRight(lastDay, true);
        month.date = offsetCal.clone();
        function part(data) {
            var i, day, node;
            for(i = 0; i < data.length; i++){
                if (tr.children.length === weekdayCount) tr = $94a5c6ab2c287c72$exports({
                    type: 'tr',
                    className: o.styles.dayRow,
                    parent: month.body
                });
                day = data.base.clone().add(i, 'days');
                node = $94a5c6ab2c287c72$exports({
                    type: 'td',
                    parent: tr,
                    text: day.format(o.dayFormat),
                    className: validationTest(day, data.cell.join(' ').split(' ')).join(' ')
                });
                if (data.selectable && day.date() === current) selectDayElement(node);
            }
        }
        function validationTest(day, cell) {
            if (!isInRange(day, true, o.dateValidator)) cell.push(disabled);
            return cell;
        }
        function hiddenWhen(value, cell) {
            if (value) cell.push(o.styles.dayConcealed);
            return cell;
        }
    }
    function isInRange(date, allday, validator) {
        if (!isInRangeLeft(date, allday)) return false;
        if (!isInRangeRight(date, allday)) return false;
        var valid = (validator || Function.prototype).call(api, date.toDate());
        return valid !== false;
    }
    function isInRangeLeft(date, allday) {
        var min = !o.min ? false : allday ? o.min.clone().startOf('day') : o.min;
        return !min || !date.isBefore(min);
    }
    function isInRangeRight(date, allday) {
        var max = !o.max ? false : allday ? o.max.clone().endOf('day') : o.max;
        return !max || !date.isAfter(max);
    }
    function inRange(date) {
        if (o.min && date.isBefore(o.min)) return inRange(o.min.clone());
        else if (o.max && date.isAfter(o.max)) return inRange(o.max.clone());
        var value = date.clone().subtract(1, 'days');
        if (validateTowards(value, date, 'add')) return inTimeRange(value);
        value = date.clone();
        if (validateTowards(value, date, 'subtract')) return inTimeRange(value);
    }
    function inTimeRange(value) {
        var copy = value.clone().subtract(o.timeInterval, 'seconds');
        var times = Math.ceil(secondsInDay / o.timeInterval);
        var i;
        for(i = 0; i < times; i++){
            copy.add(o.timeInterval, 'seconds');
            if (copy.date() > value.date()) copy.subtract(1, 'days');
            if (o.timeValidator.call(api, copy.toDate()) !== false) return copy;
        }
    }
    function validateTowards(value, date, op) {
        var valid = false;
        while(valid === false){
            value[op](1, 'days');
            if (value.month() !== date.month()) break;
            valid = o.dateValidator.call(api, value.toDate());
        }
        return valid !== false;
    }
    function pickDay(e) {
        var target = e.target;
        if ($37cb1f8a5909f3e4$exports.contains(target, o.styles.dayDisabled) || !$37cb1f8a5909f3e4$exports.contains(target, o.styles.dayBodyElem)) return;
        var day = parseInt($fe818bce31d3da13$exports(target), 10);
        var prev = $37cb1f8a5909f3e4$exports.contains(target, o.styles.dayPrevMonth);
        var next = $37cb1f8a5909f3e4$exports.contains(target, o.styles.dayNextMonth);
        var offset = getMonthOffset(target) - getMonthOffset(lastDayElement);
        ref.add(offset, 'months');
        if (prev || next) ref.add(prev ? -1 : 1, 'months');
        selectDayElement(target);
        ref.date(day); // must run after setting the month
        setTime(ref, inRange(ref) || ref);
        refCal = ref.clone();
        if (o.autoClose === true) hideConditionally();
        update();
    }
    function selectDayElement(node) {
        if (lastDayElement) $37cb1f8a5909f3e4$exports.remove(lastDayElement, o.styles.selectedDay);
        if (node) $37cb1f8a5909f3e4$exports.add(node, o.styles.selectedDay);
        lastDayElement = node;
    }
    function getMonthOffset(elem) {
        var offset;
        while(elem && elem.getAttribute){
            offset = elem.getAttribute(monthOffsetAttribute);
            if (typeof offset === 'string') return parseInt(offset, 10);
            elem = elem.parentNode;
        }
        return 0;
    }
    function setTime(to, from) {
        to.hour(from.hour()).minute(from.minute()).second(from.second());
        return to;
    }
    function pickTime(e) {
        var target = e.target;
        if (!$37cb1f8a5909f3e4$exports.contains(target, o.styles.timeOption)) return;
        var value = $k0LC7.moment($fe818bce31d3da13$exports(target), o.timeFormat);
        setTime(ref, value);
        refCal = ref.clone();
        emitValues();
        updateTime();
        if (!o.date && o.autoClose === true || o.autoClose === 'time') hideConditionally();
        else hideTimeList();
    }
    function getDate() {
        return ref.toDate();
    }
    function getDateString(format) {
        return ref.format(format || o.inputFormat);
    }
    function getMoment() {
        return ref.clone();
    }
}
$31fd9ab1e2ae3e98$exports = $31fd9ab1e2ae3e98$var$calendar;



var $k0LC7 = parcelRequire("k0LC7");

function $2a97a3b7c4601928$var$inputCalendar(input, calendarOptions) {
    var o = calendarOptions || {};
    o.associated = input;
    var api = $31fd9ab1e2ae3e98$exports(o);
    var throttledTakeInput = $6e44122a51588a32$exports(takeInput, 30);
    var ignoreInvalidation;
    var ignoreShow;
    var eye;
    init(o);
    return api;
    function init(initOptions) {
        o = $020382e08049b2ed$exports(initOptions || o, api);
        $37cb1f8a5909f3e4$exports.add(api.container, o.styles.positioned);
        $a18850637d618268$exports.add(api.container, 'mousedown', containerMouseDown);
        $a18850637d618268$exports.add(api.container, 'click', containerClick);
        api.getDate = unrequire(api.getDate);
        api.getDateString = unrequire(api.getDateString);
        api.getMoment = unrequire(api.getMoment);
        if (o.initialValue) input.value = o.initialValue.format(o.inputFormat);
        eye = $ed6c1e273a3cca93$exports(api.container, input);
        api.on('data', updateInput);
        api.on('show', eye.refresh);
        eventListening();
        throttledTakeInput();
    }
    function destroy() {
        eventListening(true);
        eye.destroy();
        eye = null;
    }
    function eventListening(remove) {
        var op = remove ? 'remove' : 'add';
        $a18850637d618268$exports[op](input, 'click', show);
        $a18850637d618268$exports[op](input, 'touchend', show);
        $a18850637d618268$exports[op](input, 'focusin', show);
        $a18850637d618268$exports[op](input, 'change', throttledTakeInput);
        $a18850637d618268$exports[op](input, 'keypress', throttledTakeInput);
        $a18850637d618268$exports[op](input, 'keydown', throttledTakeInput);
        $a18850637d618268$exports[op](input, 'input', throttledTakeInput);
        if (o.invalidate) $a18850637d618268$exports[op](input, 'blur', invalidateInput);
        if (remove) {
            api.once('ready', init);
            api.off('destroyed', destroy);
        } else {
            api.off('ready', init);
            api.once('destroyed', destroy);
        }
    }
    function containerClick() {
        ignoreShow = true;
        input.focus();
        ignoreShow = false;
    }
    function containerMouseDown() {
        ignoreInvalidation = true;
        setTimeout(unignore, 0);
        function unignore() {
            ignoreInvalidation = false;
        }
    }
    function invalidateInput() {
        if (!ignoreInvalidation && !isEmpty()) api.emitValues();
    }
    function show() {
        if (ignoreShow) return;
        api.show();
    }
    function takeInput() {
        var value = input.value.trim();
        if (isEmpty()) return;
        var date = $k0LC7.moment(value, o.inputFormat, o.strictParse);
        api.setValue(date);
    }
    function updateInput(data) {
        input.value = data;
    }
    function isEmpty() {
        return o.required === false && input.value.trim() === '';
    }
    function unrequire(fn) {
        return function maybe() {
            return isEmpty() ? null : fn.apply(this, arguments);
        };
    }
}
$2a97a3b7c4601928$exports = $2a97a3b7c4601928$var$inputCalendar;


var $8b2acba77d73a848$exports = {};
'use strict';

function $8b2acba77d73a848$var$inline(elem, calendarOptions) {
    var o = calendarOptions || {};
    o.appendTo = elem;
    o.associated = elem;
    var cal = $31fd9ab1e2ae3e98$exports(o);
    cal.show();
    return cal;
}
$8b2acba77d73a848$exports = $8b2acba77d73a848$var$inline;



var $gBEl8 = parcelRequire("gBEl8");
function $d8f2de8e0916ef91$var$core(elem, options) {
    var cal;
    var existing = $fMgII.find(elem);
    if (existing) return existing;
    if ($gBEl8(elem)) cal = $2a97a3b7c4601928$exports(elem, options);
    else cal = $8b2acba77d73a848$exports(elem, options);
    $fMgII.assign(elem, cal);
    return cal;
}
$d8f2de8e0916ef91$exports = $d8f2de8e0916ef91$var$core;



var $fMgII = parcelRequire("fMgII");
var $1728c914150bb270$exports = {};
'use strict';

var $k0LC7 = parcelRequire("k0LC7");
function $1728c914150bb270$var$use(moment) {
    this.moment = $k0LC7.moment = moment;
}
$1728c914150bb270$exports = $1728c914150bb270$var$use;


$d8f2de8e0916ef91$exports.use = $1728c914150bb270$exports.bind($d8f2de8e0916ef91$exports);
$d8f2de8e0916ef91$exports.find = $fMgII.find;

$d8f2de8e0916ef91$exports.val = (parcelRequire("lyPqm"));
$d2cb3f09a0c90dd7$exports = $d8f2de8e0916ef91$exports;


$d2cb3f09a0c90dd7$exports.use($axd2S);
$e3fe4930b4cc098f$exports = $d2cb3f09a0c90dd7$exports;



var $axd2S = parcelRequire("axd2S");


var $hBdgJ = parcelRequire("hBdgJ");

var $axd2S = parcelRequire("axd2S");
const $1e96af9f52ee26c2$var$dateFormat = 'YYYY-MM-DD HH:mm';
const $1e96af9f52ee26c2$export$b40fc491ceb69c4e = (timeRange)=>{
    if (!timeRange) return '';
    if (timeRange === 'now()') return (0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(new Date()).format($1e96af9f52ee26c2$var$dateFormat);
    if (timeRange.match(/^now/)) {
        const [, duration, unitOfTime] = timeRange.match(/(\d+)(\w+)/);
        const d = duration;
        (0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))().subtract(d, unitOfTime);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(timeRange.replace(/\'/g, '')).format($1e96af9f52ee26c2$var$dateFormat);
};


const $dc10740f6802551a$var$timeRangeDefaults = [
    {
        id: 'pastWeek',
        name: 'Past Week'
    },
    {
        id: 'pastMonth',
        name: 'Past Month'
    },
    {
        id: 'pastYear',
        name: 'Past Year'
    },
    {
        id: 'thisWeek',
        name: 'This Week'
    },
    {
        id: 'thisMonth',
        name: 'This Month'
    },
    {
        id: 'thisYear',
        name: 'This Year'
    }
];
var $dc10740f6802551a$export$2e2bcd8739ae039 = $dc10740f6802551a$var$timeRangeDefaults;




const $7725d0f67cc4984c$var$dateFormat = 'YYYY-MM-DD HH:mm';
class $7725d0f67cc4984c$var$CustomTimeRange extends (0, $NdCUR.Component) {
    constructor(props){
        super(props);
        this.state = {
            isNow: this.props.timeRange.upper === 'now()'
        };
    }
    componentDidMount() {
        const { timeRange: timeRange, timeInterval: timeInterval } = this.props;
        const lower = (0, (/*@__PURE__*/$parcel$interopDefault($e3fe4930b4cc098f$exports)))(this.lower, {
            dateValidator: (0, (/*@__PURE__*/$parcel$interopDefault($e3fe4930b4cc098f$exports))).val.beforeEq(this.upper),
            appendTo: this.lowerContainer,
            initialValue: this.getInitialDate(timeRange.lower),
            autoClose: false,
            autoHideOnBlur: false,
            autoHideOnClick: false,
            timeInterval: timeInterval
        });
        const upper = (0, (/*@__PURE__*/$parcel$interopDefault($e3fe4930b4cc098f$exports)))(this.upper, {
            dateValidator: (0, (/*@__PURE__*/$parcel$interopDefault($e3fe4930b4cc098f$exports))).val.afterEq(this.lower),
            appendTo: this.upperContainer,
            autoClose: false,
            initialValue: this.getInitialDate(timeRange.upper),
            autoHideOnBlur: false,
            autoHideOnClick: false,
            timeInterval: timeInterval
        });
        this.lowerCal = lower;
        this.upperCal = upper;
        this.lowerCal.show();
        this.upperCal.show();
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { lower: lower, upper: upper } = nextProps.timeRange;
        if (lower) {
            const momentVal = this._toMoment(lower);
            this.lowerCal.setValue(momentVal);
            this.lower.value = momentVal.format($7725d0f67cc4984c$var$dateFormat);
        }
        if (upper) {
            const momentVal = this._toMoment(upper);
            this.upperCal.setValue(momentVal);
            this.upper.value = momentVal.format($7725d0f67cc4984c$var$dateFormat);
        }
    }
    getInitialDate = (time)=>{
        const { upper: upper, lower: lower } = this.props.timeRange;
        if (upper || lower) return this._toMoment(time);
        return this.timeZoned((0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))());
    };
    timeZoned = (momentVal)=>{
        if (this.props.timeZone === (0, $a7b864c61f4e95a7$export$d6f132cca63fb222).UTC) return momentVal.utc();
        return momentVal;
    };
    handleRefreshCals = ()=>{
        this.lowerCal.refresh();
        this.upperCal.refresh();
    };
    handleToggleNow = ()=>{
        this.setState({
            isNow: !this.state.isNow
        });
    };
    handleNowOff = ()=>{
        this.setState({
            isNow: false
        });
    };
    /*
   * Upper and lower time ranges are passed in with single quotes as part of
   * the string literal, i.e. "'2015-09-23T18:00:00.000Z'".  Remove them
   * before passing the string to be parsed. Additionally, return the moment
   * in the timeZone so that it is formatted well.
   */ _toMoment = (timeRange)=>{
        const strVal = (0, $1e96af9f52ee26c2$export$b40fc491ceb69c4e)(timeRange);
        const retVal = (0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(strVal, $7725d0f67cc4984c$var$dateFormat);
        if (this.props.timeZone === (0, $a7b864c61f4e95a7$export$d6f132cca63fb222).UTC) retVal.utc();
        return retVal;
    };
    handleClick = ()=>{
        const { onApplyTimeRange: onApplyTimeRange, onClose: onClose } = this.props;
        const { isNow: isNow } = this.state;
        const lowerMoment = this.lowerCal.getMoment();
        const upperMoment = this.upperCal.getMoment();
        if (this.props.timeZone === (0, $a7b864c61f4e95a7$export$d6f132cca63fb222).UTC) {
            // rome calendar does not respect that UTC moment was set
            if (!lowerMoment.creationData().isUTC) lowerMoment.utc(true);
            if (!upperMoment.creationData().isUTC) upperMoment.utc(true);
        }
        const lower = lowerMoment.toDate().toISOString();
        const upper = upperMoment.toDate().toISOString();
        if (isNow) onApplyTimeRange({
            lower: lower,
            upper: 'now()'
        });
        else onApplyTimeRange({
            lower: lower,
            upper: upper
        });
        if (onClose) onClose();
    };
    handleTimeRangeShortcut = (shortcut)=>{
        return ()=>{
            let lower;
            const upper = this.timeZoned((0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))());
            switch(shortcut){
                case 'pastWeek':
                    lower = (0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(upper).subtract(1, 'week');
                    break;
                case 'pastMonth':
                    lower = (0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(upper).subtract(1, 'month');
                    break;
                case 'pastYear':
                    lower = (0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(upper).subtract(1, 'year');
                    break;
                case 'thisWeek':
                    lower = (0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(upper).startOf('week');
                    break;
                case 'thisMonth':
                    lower = (0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(upper).startOf('month');
                    break;
                case 'thisYear':
                    lower = (0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(upper).startOf('year');
                    break;
            }
            this.lower.value = lower.format($7725d0f67cc4984c$var$dateFormat);
            this.upper.value = upper.format($7725d0f67cc4984c$var$dateFormat);
            this.lowerCal.setValue(lower);
            this.upperCal.setValue(upper);
            this.handleRefreshCals();
        };
    };
    render() {
        const { isNow: isNow } = this.state;
        const { page: page } = this.props;
        const isNowDisplayed = page !== 'DataExplorer';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "custom-time--container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "custom-time--shortcuts"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "custom-time--shortcuts-header"
        }, "Shortcuts"), (0, $dc10740f6802551a$export$2e2bcd8739ae039).map(({ id: id, name: name })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                key: id,
                className: "custom-time--shortcut",
                onClick: this.handleTimeRangeShortcut(id)
            }, name))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "custom-time--wrap"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "custom-time--dates",
            onClick: this.handleRefreshCals
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "custom-time--lower-container",
            ref: (r)=>this.lowerContainer = r
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "custom-time--lower form-control input-sm",
            ref: (r)=>this.lower = r,
            placeholder: "from",
            onKeyUp: this.handleRefreshCals
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "custom-time--upper-container",
            ref: (r)=>this.upperContainer = r,
            disabled: isNow
        }, isNowDisplayed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: `btn btn-xs custom-time--now ${isNow ? 'btn-primary' : 'btn-default'}`,
            onClick: this.handleToggleNow
        }, "Now") : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "custom-time--upper form-control input-sm",
            ref: (r)=>this.upper = r,
            placeholder: "to",
            onKeyUp: this.handleRefreshCals,
            disabled: isNow
        }), isNow && page !== 'DataExplorer' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "custom-time--mask",
            onClick: this.handleNowOff
        }) : null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "custom-time--apply btn btn-sm btn-primary",
            onClick: this.handleClick
        }, "Apply")));
    }
}
$7725d0f67cc4984c$var$CustomTimeRange.defaultProps = {
    timeInterval: 1800
};
const { func: $7725d0f67cc4984c$var$func, shape: $7725d0f67cc4984c$var$shape, string: $7725d0f67cc4984c$var$string, number: $7725d0f67cc4984c$var$number } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$7725d0f67cc4984c$var$CustomTimeRange.propTypes = {
    onApplyTimeRange: $7725d0f67cc4984c$var$func.isRequired,
    timeRange: $7725d0f67cc4984c$var$shape({
        lower: $7725d0f67cc4984c$var$string.isRequired,
        upper: $7725d0f67cc4984c$var$string
    }).isRequired,
    timeInterval: $7725d0f67cc4984c$var$number,
    onClose: $7725d0f67cc4984c$var$func,
    page: $7725d0f67cc4984c$var$string,
    timeZone: $7725d0f67cc4984c$var$string
};
const $7725d0f67cc4984c$var$mstp = (state)=>({
        timeZone: (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(state, [
            'app',
            'persisted',
            'timeZone'
        ])
    });
var $7725d0f67cc4984c$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($7725d0f67cc4984c$var$mstp)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($7725d0f67cc4984c$var$CustomTimeRange));



class $1c72f9d52d9aedd5$var$CustomTimeRangeDropdown extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleToggleDropdown = ()=>{
            this.setState({
                expanded: !this.state.expanded
            });
        }, this.closeDropdown = ()=>{
            this.setState({
                expanded: false
            });
        };
        this.state = {
            expanded: false
        };
    }
    render() {
        const { timeRange: timeRange, onApplyTimeRange: onApplyTimeRange } = this.props;
        const { expanded: expanded } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1f11d3536bc98f8a$export$c16e4f034c84cb3f), {
            onClickOutside: this.closeDropdown
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('dropdown dropdown-280 custom-time-range', {
                open: expanded
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-sm btn-default dropdown-toggle",
            onClick: this.handleToggleDropdown
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon clock"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "dropdown-selected"
        }, this.lowerTimeRange, " \u2014 ", this.upperTimeRange), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "caret"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7725d0f67cc4984c$export$2e2bcd8739ae039), {
            onApplyTimeRange: onApplyTimeRange,
            timeRange: timeRange,
            onClose: this.closeDropdown
        })));
    }
    get upperTimeRange() {
        const { timeRange: { upper: upper } } = this.props;
        if (upper === 'now()') return (0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))().format(this.timeFormat);
        return (0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(upper).format(this.timeFormat);
    }
    get lowerTimeRange() {
        const { timeRange: { lower: lower } } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(lower).format(this.timeFormat);
    }
    get timeFormat() {
        return 'MMM Do HH:mm';
    }
}
var $1c72f9d52d9aedd5$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($1c72f9d52d9aedd5$var$CustomTimeRangeDropdown);


// Import Components
// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");
var $918c9f03a35fe03f$export$c1cedbc1c46e937d = /*#__PURE__*/ function(ComponentColor) {
    ComponentColor["Default"] = "default";
    ComponentColor["Primary"] = "primary";
    ComponentColor["Secondary"] = "secondary";
    ComponentColor["Success"] = "success";
    ComponentColor["Warning"] = "warning";
    ComponentColor["Danger"] = "danger";
    ComponentColor["Alert"] = "alert";
    return ComponentColor;
}({});
var $918c9f03a35fe03f$export$fafce5c139da9687 = /*#__PURE__*/ function(ComponentSize) {
    ComponentSize["ExtraSmall"] = "xs";
    ComponentSize["Small"] = "sm";
    ComponentSize["Medium"] = "md";
    ComponentSize["Large"] = "lg";
    return ComponentSize;
}({});
var $918c9f03a35fe03f$export$f58bd244391b65a5 = /*#__PURE__*/ function(ComponentStatus) {
    ComponentStatus["Default"] = "default";
    ComponentStatus["Loading"] = "loading";
    ComponentStatus["Error"] = "error";
    ComponentStatus["Valid"] = "valid";
    ComponentStatus["Disabled"] = "disabled";
    return ComponentStatus;
}({});
var $918c9f03a35fe03f$export$a59a7abdb1a34163 = /*#__PURE__*/ function(DropdownMenuColors) {
    DropdownMenuColors["Amethyst"] = "amethyst";
    DropdownMenuColors["Malachite"] = "malachite";
    DropdownMenuColors["Sapphire"] = "sapphire";
    DropdownMenuColors["Onyx"] = "onyx";
    return DropdownMenuColors;
}({});
var $918c9f03a35fe03f$export$ce765fb8bb08a599 = /*#__PURE__*/ function(ButtonShape) {
    ButtonShape["Default"] = "none";
    ButtonShape["Square"] = "square";
    ButtonShape["StretchToFit"] = "stretch";
    return ButtonShape;
}({});
var $918c9f03a35fe03f$export$5fbd7a106ab5f092 = /*#__PURE__*/ function(Greys) {
    Greys["Obsidian"] = "#0f0e15";
    Greys["Raven"] = "#1c1c21";
    Greys["Kevlar"] = "#202028";
    Greys["Castle"] = "#292933";
    Greys["Onyx"] = "#31313d";
    Greys["Pepper"] = "#383846";
    Greys["Smoke"] = "#434453";
    Greys["Graphite"] = "#545667";
    Greys["Storm"] = "#676978";
    Greys["Mountain"] = "#757888";
    Greys["Wolf"] = "#8e91a1";
    Greys["Sidewalk"] = "#999dab";
    Greys["Forge"] = "#a4a8b6";
    Greys["Mist"] = "#bec2cc";
    Greys["Chromium"] = "#c6cad3";
    Greys["Platinum"] = "#d4d7dd";
    Greys["Pearl"] = "#e7e8eb";
    Greys["Whisper"] = "#eeeff2";
    Greys["Cloud"] = "#f6f6f8";
    Greys["Ghost"] = "#fafafc";
    Greys["White"] = "#ffffff";
    return Greys;
}({});
var $918c9f03a35fe03f$export$62c9c0cf752cde38 = /*#__PURE__*/ function(IconFont) {
    IconFont["AddCell"] = "add-cell";
    IconFont["AlertTriangle"] = "alert-triangle";
    IconFont["Alerts"] = "alerts";
    IconFont["Annotate"] = "annotate";
    IconFont["AnnotatePlus"] = "annotate-plus";
    IconFont["AuthZero"] = "authzero";
    IconFont["BarChart"] = "bar-chart";
    IconFont["Capacitor"] = "capacitor2";
    IconFont["CaretDown"] = "caret-down";
    IconFont["CaretLeft"] = "caret-left";
    IconFont["CaretRight"] = "caret-right";
    IconFont["CaretUp"] = "caret-up";
    IconFont["Chat"] = "chat";
    IconFont["Checkmark"] = "checkmark";
    IconFont["Circle"] = "circle";
    IconFont["CircleThick"] = "circle-thick";
    IconFont["Clock"] = "clock";
    IconFont["CogOutline"] = "cog-outline";
    IconFont["CogThick"] = "cog-thick";
    IconFont["Collapse"] = "collapse";
    IconFont["CrownOutline"] = "crown-outline";
    IconFont["CrownSolid"] = "crown2";
    IconFont["Cube"] = "cube";
    IconFont["Cubouniform"] = "cubo-uniform";
    IconFont["DashF"] = "dash-f";
    IconFont["DashH"] = "dash-h";
    IconFont["DashJ"] = "dash-j";
    IconFont["Disks"] = "disks";
    IconFont["Download"] = "download";
    IconFont["Duplicate"] = "duplicate";
    IconFont["ExpandA"] = "expand-a";
    IconFont["ExpandB"] = "expand-b";
    IconFont["Export"] = "export";
    IconFont["Eye"] = "eye";
    IconFont["EyeClosed"] = "eye-closed";
    IconFont["EyeOpen"] = "eye-open";
    IconFont["GitHub"] = "github";
    IconFont["Google"] = "google";
    IconFont["GraphLine"] = "graphline2";
    IconFont["Group"] = "group";
    IconFont["Heroku"] = "heroku";
    IconFont["HerokuSimple"] = "";
    IconFont["Import"] = "import";
    IconFont["Link"] = "link";
    IconFont["OAuth"] = "oauth";
    IconFont["Octagon"] = "octagon";
    IconFont["Okta"] = "okta";
    IconFont["Pause"] = "pause";
    IconFont["Pencil"] = "pencil";
    IconFont["Play"] = "play";
    IconFont["Plus"] = "plus";
    IconFont["PlusSkinny"] = "plus-skinny";
    IconFont["Pulse"] = "pulse-c";
    IconFont["Refresh"] = "refresh";
    IconFont["Remove"] = "remove";
    IconFont["Search"] = "search";
    IconFont["Server"] = "server2";
    IconFont["Shuffle"] = "shuffle";
    IconFont["Square"] = "square";
    IconFont["TextBlock"] = "text-block";
    IconFont["Trash"] = "trash";
    IconFont["Triangle"] = "triangle";
    IconFont["User"] = "user";
    IconFont["UserAdd"] = "user-add";
    IconFont["UserOutline"] = "user-outline";
    IconFont["UserRemove"] = "user-remove";
    IconFont["Wood"] = "wood";
    IconFont["Wrench"] = "wrench";
    IconFont["Star"] = "star";
    IconFont["Stop"] = "stop";
    IconFont["Zap"] = "zap";
    return IconFont;
}({});
var $918c9f03a35fe03f$export$f02cc02ad0e0bba3 = /*#__PURE__*/ function(Columns) {
    Columns[Columns["One"] = 1] = "One";
    Columns[Columns["Two"] = 2] = "Two";
    Columns[Columns["Three"] = 3] = "Three";
    Columns[Columns["Four"] = 4] = "Four";
    Columns[Columns["Five"] = 5] = "Five";
    Columns[Columns["Six"] = 6] = "Six";
    Columns[Columns["Seven"] = 7] = "Seven";
    Columns[Columns["Eight"] = 8] = "Eight";
    Columns[Columns["Nine"] = 9] = "Nine";
    Columns[Columns["Ten"] = 10] = "Ten";
    Columns[Columns["Eleven"] = 11] = "Eleven";
    Columns[Columns["Twelve"] = 12] = "Twelve";
    return Columns;
}({});



class $7c1c09dc355c9bd4$var$Button extends (0, $NdCUR.Component) {
    static{
        this.defaultProps = {
            color: (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Default,
            size: (0, $918c9f03a35fe03f$export$fafce5c139da9687).Small,
            shape: (0, $918c9f03a35fe03f$export$ce765fb8bb08a599).Default,
            status: (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Default,
            active: false
        };
    }
    render() {
        const { onClick: onClick, text: text, titleText: titleText, tabIndex: tabIndex, testId: testId } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: this.className,
            disabled: this.disabled,
            onClick: onClick,
            title: titleText || text,
            tabIndex: tabIndex ? tabIndex : 0,
            "data-test": testId
        }, this.icon, this.text, this.statusIndicator);
    }
    get icon() {
        const { icon: icon } = this.props;
        if (icon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: `button-icon icon ${icon}`
        });
        return null;
    }
    get text() {
        const { text: text, shape: shape } = this.props;
        if (shape === (0, $918c9f03a35fe03f$export$ce765fb8bb08a599).Square) return null;
        return text;
    }
    get disabled() {
        const { status: status } = this.props;
        return status === (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Disabled || status === (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Loading;
    }
    get statusIndicator() {
        const { status: status, size: size } = this.props;
        if (status === (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: `button-spinner button-spinner--${size}`
        });
        return null;
    }
    get className() {
        const { color: color, size: size, shape: shape, status: status, active: active, customClass: customClass } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))(`button button-${size} button-${color}`, {
            'button-square': shape === (0, $918c9f03a35fe03f$export$ce765fb8bb08a599).Square,
            'button-stretch': shape === (0, $918c9f03a35fe03f$export$ce765fb8bb08a599).StretchToFit,
            'button--loading': status === (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Loading,
            'button--disabled': status === (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Disabled,
            active: active,
            [customClass]: customClass
        });
    }
}
var $7c1c09dc355c9bd4$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($7c1c09dc355c9bd4$var$Button);


// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");

// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");

class $f515a3f4a3a5b4b1$var$DropdownDivider extends (0, $NdCUR.Component) {
    static{
        this.defaultProps = {
            text: ''
        };
    }
    render() {
        const { text: text } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('dropdown--divider', {
                line: !text
            })
        }, text);
    }
}
var $f515a3f4a3a5b4b1$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($f515a3f4a3a5b4b1$var$DropdownDivider);


// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");

class $093f5c40e23587aa$var$DropdownItem extends (0, $NdCUR.Component) {
    static{
        this.defaultProps = {
            checkbox: false,
            selected: false
        };
    }
    render() {
        const { selected: selected, checkbox: checkbox } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('dropdown--item', {
                active: selected,
                'multi-select--item': checkbox
            }),
            onClick: this.handleClick,
            "data-test": "dropdown--item"
        }, this.checkBox, this.dot, this.childElements);
    }
    get checkBox() {
        const { checkbox: checkbox } = this.props;
        if (checkbox) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "dropdown-item--checkbox"
        });
        return null;
    }
    get dot() {
        const { checkbox: checkbox, selected: selected } = this.props;
        if (selected && !checkbox) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "dropdown-item--dot"
        });
    }
    get childElements() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "dropdown-item--children"
        }, children);
    }
    constructor(...args){
        super(...args), this.handleClick = ()=>{
            const { onClick: onClick, value: value } = this.props;
            onClick(value);
        };
    }
}
var $093f5c40e23587aa$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($093f5c40e23587aa$var$DropdownItem);


// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");


class $a78c73fd7253b0a5$var$DropdownButton extends (0, $NdCUR.Component) {
    static{
        this.defaultProps = {
            color: (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Default,
            size: (0, $918c9f03a35fe03f$export$fafce5c139da9687).Small,
            status: (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Default,
            active: false
        };
    }
    render() {
        const { onClick: onClick, children: children, title: title } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: this.classname,
            onClick: onClick,
            disabled: this.isDisabled,
            title: title,
            "data-test": "wizard-bucket-selected"
        }, this.icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "dropdown--selected"
        }, children), this.caret);
    }
    get classname() {
        const { active: active, color: color, size: size } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('dropdown--button button', {
            'button-stretch': true,
            'button--disabled': this.isDisabled,
            [`button-${color}`]: color,
            [`button-${size}`]: size,
            active: active
        });
    }
    get caret() {
        const { active: active } = this.props;
        if (active) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "dropdown--caret icon caret-up"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "dropdown--caret icon caret-down"
        });
    }
    get isDisabled() {
        const { status: status } = this.props;
        const isDisabled = [
            (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Disabled,
            (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Loading,
            (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Error
        ].includes(status);
        return isDisabled;
    }
    get icon() {
        const { icon: icon } = this.props;
        if (icon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: `dropdown--icon icon ${icon}`
        });
        return null;
    }
}
var $a78c73fd7253b0a5$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($a78c73fd7253b0a5$var$DropdownButton);





var $f040dbec7e8f99c8$export$14df593178718d76 = /*#__PURE__*/ function(DropdownMode) {
    DropdownMode["ActionList"] = "action";
    DropdownMode["Radio"] = "radio";
    return DropdownMode;
}({});
class $f040dbec7e8f99c8$var$Dropdown extends (0, $NdCUR.Component) {
    static{
        this.defaultProps = {
            buttonColor: (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Default,
            buttonSize: (0, $918c9f03a35fe03f$export$fafce5c139da9687).Small,
            status: (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Default,
            wrapText: false,
            maxMenuHeight: 250,
            menuColor: (0, $918c9f03a35fe03f$export$a59a7abdb1a34163).Sapphire,
            mode: "radio",
            titleText: '',
            selectedID: '',
            zIndex: 'auto'
        };
    }
    static{
        this.Button = (0, $a78c73fd7253b0a5$export$2e2bcd8739ae039);
    }
    static{
        this.Item = (0, $093f5c40e23587aa$export$2e2bcd8739ae039);
    }
    static{
        this.Divider = (0, $f515a3f4a3a5b4b1$export$2e2bcd8739ae039);
    }
    constructor(props){
        super(props), this.toggleMenu = ()=>{
            this.setState({
                expanded: !this.state.expanded
            });
        }, this.collapseMenu = ()=>{
            this.setState({
                expanded: false
            });
        }, this.handleItemClick = (value)=>{
            const { onChange: onChange } = this.props;
            onChange(value);
            this.collapseMenu();
        }, this.validateChildCount = ()=>{
            const { children: children } = this.props;
            if (this.shouldHaveChildren && (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Children.count(children) === 0) throw new Error('Dropdowns require at least 1 child element. We recommend using Dropdown.Item and/or Dropdown.Divider.');
        }, this.validateMode = ()=>{
            const { mode: mode, selectedID: selectedID, titleText: titleText } = this.props;
            if (mode === "action" && titleText === '') throw new Error('Dropdowns in ActionList mode require a titleText prop.');
            if (mode === "radio" && this.shouldHaveChildren && selectedID === '') throw new Error('Dropdowns in Radio mode require a selectedID prop.');
        }, this.childTypeIsValid = (child)=>child.type === (0, $093f5c40e23587aa$export$2e2bcd8739ae039) || child.type === (0, $f515a3f4a3a5b4b1$export$2e2bcd8739ae039);
        this.state = {
            expanded: false
        };
    }
    render() {
        const { widthPixels: widthPixels, zIndex: zIndex } = this.props;
        const width = widthPixels ? `${widthPixels}px` : '100%';
        const style = {
            width: width,
            zIndex: zIndex
        };
        this.validateChildCount();
        this.validateMode();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1f11d3536bc98f8a$export$c16e4f034c84cb3f), {
            onClickOutside: this.collapseMenu
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.containerClassName,
            style: style
        }, this.button, this.menuItems));
    }
    get containerClassName() {
        const { buttonColor: buttonColor, buttonSize: buttonSize, status: status, wrapText: wrapText, customClass: customClass } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))(`dropdown dropdown-${buttonSize} dropdown-${buttonColor}`, {
            disabled: status === (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Disabled,
            'dropdown-wrap': wrapText,
            [customClass]: customClass
        });
    }
    get button() {
        const { selectedID: selectedID, status: status, buttonColor: buttonColor, buttonSize: buttonSize, icon: icon, children: children, titleText: titleText } = this.props;
        const { expanded: expanded } = this.state;
        const selectedChild = children.find((child)=>child.props.id === selectedID);
        const isLoading = status === (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Loading;
        let dropdownLabel;
        if (isLoading) dropdownLabel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "dropdown--loading"
        });
        else if (selectedChild) dropdownLabel = selectedChild.props.children;
        else dropdownLabel = titleText;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a78c73fd7253b0a5$export$2e2bcd8739ae039), {
            active: expanded,
            color: buttonColor,
            size: buttonSize,
            icon: icon,
            onClick: this.toggleMenu,
            status: status,
            title: titleText
        }, dropdownLabel);
    }
    get menuItems() {
        const { selectedID: selectedID, maxMenuHeight: maxMenuHeight, menuColor: menuColor, children: children } = this.props;
        const { expanded: expanded } = this.state;
        if (expanded) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: `dropdown--menu-container dropdown--${menuColor}`,
            style: this.menuStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), {
            autoHide: false,
            autoHeight: true,
            maxHeight: maxMenuHeight
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "dropdown--menu"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Children.map(children, (child)=>{
            if (this.childTypeIsValid(child)) {
                if (child.type === (0, $093f5c40e23587aa$export$2e2bcd8739ae039)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $093f5c40e23587aa$export$2e2bcd8739ae039), {
                    ...child.props,
                    key: child.props.id,
                    selected: child.props.id === selectedID,
                    onClick: this.handleItemClick
                }, child.props.children);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $f515a3f4a3a5b4b1$export$2e2bcd8739ae039), {
                    ...child.props,
                    key: child.props.id
                });
            }
            throw new Error('Expected children of type <Dropdown.Item /> or <Dropdown.Divider />');
        }))));
        return null;
    }
    get menuStyle() {
        const { wrapText: wrapText, widthPixels: widthPixels } = this.props;
        let containerWidth = '100%';
        if (widthPixels) containerWidth = `${widthPixels}px`;
        if (wrapText && widthPixels) return {
            width: containerWidth
        };
        return {
            minWidth: containerWidth
        };
    }
    get shouldHaveChildren() {
        const { status: status } = this.props;
        return status === (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Default || status === (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Valid;
    }
}
var $f040dbec7e8f99c8$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($f040dbec7e8f99c8$var$Dropdown);


// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");

var $hBdgJ = parcelRequire("hBdgJ");







class $fba4704c463778f3$var$MultiSelectDropdown extends (0, $NdCUR.Component) {
    static{
        this.defaultProps = {
            buttonColor: (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Default,
            buttonSize: (0, $918c9f03a35fe03f$export$fafce5c139da9687).Small,
            status: (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Default,
            wrapText: false,
            maxMenuHeight: 250,
            menuColor: (0, $918c9f03a35fe03f$export$a59a7abdb1a34163).Sapphire,
            emptyText: 'Choose an item',
            separatorText: ', '
        };
    }
    static{
        this.Button = (0, $a78c73fd7253b0a5$export$2e2bcd8739ae039);
    }
    static{
        this.Item = (0, $093f5c40e23587aa$export$2e2bcd8739ae039);
    }
    static{
        this.Divider = (0, $f515a3f4a3a5b4b1$export$2e2bcd8739ae039);
    }
    constructor(props){
        super(props), this.toggleMenu = ()=>{
            this.setState({
                expanded: !this.state.expanded
            });
        }, this.collapseMenu = ()=>{
            const { onCollapse: onCollapse } = this.props;
            this.setState({
                expanded: false
            });
            if (onCollapse) onCollapse();
        }, this.handleItemClick = (value)=>{
            const { onChange: onChange, selectedIDs: selectedIDs } = this.props;
            let updatedSelection;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).includes(selectedIDs, value.id)) updatedSelection = selectedIDs.filter((id)=>id !== value.id);
            else updatedSelection = [
                ...selectedIDs,
                value.id
            ];
            onChange(updatedSelection, value);
        }, this.validateChildCount = ()=>{
            const { children: children } = this.props;
            if (this.shouldHaveChildren && (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Children.count(children) === 0) throw new Error('Dropdowns require at least 1 child element. We recommend using Dropdown.Item and/or Dropdown.Divider.');
        }, this.childTypeIsValid = (child)=>child.type === (0, $093f5c40e23587aa$export$2e2bcd8739ae039) || child.type === (0, $f515a3f4a3a5b4b1$export$2e2bcd8739ae039);
        this.state = {
            expanded: false
        };
    }
    render() {
        this.validateChildCount();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1f11d3536bc98f8a$export$c16e4f034c84cb3f), {
            onClickOutside: this.collapseMenu
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.containerClassName,
            style: this.containerStyle
        }, this.button, this.menuItems));
    }
    get containerStyle() {
        const { widthPixels: widthPixels } = this.props;
        if (widthPixels) return {
            width: `${widthPixels}px`
        };
        return {
            width: '100%'
        };
    }
    get containerClassName() {
        const { buttonColor: buttonColor, buttonSize: buttonSize, status: status, wrapText: wrapText, customClass: customClass } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))(`dropdown dropdown-${buttonSize} dropdown-${buttonColor}`, {
            disabled: status === (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Disabled,
            'dropdown-wrap': wrapText,
            [customClass]: customClass
        });
    }
    get button() {
        const { selectedIDs: selectedIDs, status: status, buttonColor: buttonColor, buttonSize: buttonSize, icon: icon, children: children, emptyText: emptyText, separatorText: separatorText } = this.props;
        const { expanded: expanded } = this.state;
        const selectedChildren = children.filter((child)=>(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).includes(selectedIDs, child.props.id));
        let label;
        if (status === (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Loading) label = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "dropdown--loading"
        });
        else if (selectedChildren.length) label = selectedChildren.map((sc, i)=>{
            if (i < selectedChildren.length - 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $NdCUR.Fragment), {
                key: sc.props.id
            }, sc.props.children, separatorText);
            return sc.props.children;
        });
        else label = emptyText;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a78c73fd7253b0a5$export$2e2bcd8739ae039), {
            active: expanded,
            color: buttonColor,
            size: buttonSize,
            icon: icon,
            onClick: this.toggleMenu,
            status: status
        }, label);
    }
    get menuItems() {
        const { selectedIDs: selectedIDs, maxMenuHeight: maxMenuHeight, menuColor: menuColor, children: children } = this.props;
        const { expanded: expanded } = this.state;
        if (expanded) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: `dropdown--menu-container dropdown--${menuColor}`,
            style: this.menuStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), {
            autoHide: false,
            autoHeight: true,
            maxHeight: maxMenuHeight
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "dropdown--menu",
            "data-test": "dropdown-menu"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Children.map(children, (child)=>{
            if (this.childTypeIsValid(child)) {
                if (child.type === (0, $093f5c40e23587aa$export$2e2bcd8739ae039)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $093f5c40e23587aa$export$2e2bcd8739ae039), {
                    ...child.props,
                    key: child.props.id,
                    checkbox: true,
                    selected: (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).includes(selectedIDs, child.props.id),
                    onClick: this.handleItemClick
                }, child.props.children);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $f515a3f4a3a5b4b1$export$2e2bcd8739ae039), {
                    ...child.props,
                    key: child.props.id
                });
            }
            throw new Error('Expected children of type <Dropdown.Item /> or <Dropdown.Divider />');
        }))));
        return null;
    }
    get menuStyle() {
        const { wrapText: wrapText, widthPixels: widthPixels } = this.props;
        let containerWidth = '100%';
        if (widthPixels) containerWidth = `${widthPixels}px`;
        if (wrapText && widthPixels) return {
            width: containerWidth
        };
        return {
            minWidth: containerWidth
        };
    }
    get shouldHaveChildren() {
        const { status: status } = this.props;
        return status === (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Default || status === (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Valid;
    }
}
var $fba4704c463778f3$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($fba4704c463778f3$var$MultiSelectDropdown);


// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");
// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");
// Libraries

var $NdCUR = parcelRequire("NdCUR");

class $4b5c3026f1982ae2$var$FormLabel extends (0, $NdCUR.Component) {
    render() {
        const { label: label } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            className: "form--label"
        }, label);
    }
}
var $4b5c3026f1982ae2$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($4b5c3026f1982ae2$var$FormLabel);


// Libraries

var $NdCUR = parcelRequire("NdCUR");

class $d4af08b6d61e805a$var$FormElementError extends (0, $NdCUR.Component) {
    render() {
        const { message: message } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "form--element-error"
        }, message);
    }
}
var $d4af08b6d61e805a$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($d4af08b6d61e805a$var$FormElementError);


// Libraries

var $NdCUR = parcelRequire("NdCUR");

class $50b1b32e5996b939$var$FormHelpText extends (0, $NdCUR.Component) {
    render() {
        const { text: text } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "form--help-text"
        }, text);
    }
}
var $50b1b32e5996b939$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($50b1b32e5996b939$var$FormHelpText);




class $4b068530eeef95bb$var$FormElement extends (0, $NdCUR.Component) {
    static{
        this.defaultProps = {
            label: '',
            helpText: '',
            errorMessage: '',
            colsXS: (0, $918c9f03a35fe03f$export$f02cc02ad0e0bba3).Twelve
        };
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.className
        }, this.groupLabel, children, this.errorMessage, this.helpText);
    }
    get className() {
        const { colsXS: colsXS, colsSM: colsSM, colsMD: colsMD, colsLG: colsLG, offsetXS: offsetXS, offsetSM: offsetSM, offsetMD: offsetMD, offsetLG: offsetLG } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('form--element', {
            [`col-xs-${colsXS}`]: colsXS,
            [`col-sm-${colsSM}`]: colsSM,
            [`col-md-${colsMD}`]: colsMD,
            [`col-lg-${colsLG}`]: colsLG,
            [`col-xs-offset-${offsetXS}`]: offsetXS,
            [`col-sm-offset-${offsetSM}`]: offsetSM,
            [`col-md-offset-${offsetMD}`]: offsetMD,
            [`col-lg-offset-${offsetLG}`]: offsetLG
        });
    }
    get groupLabel() {
        const { label: label } = this.props;
        if (label) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $4b5c3026f1982ae2$export$2e2bcd8739ae039), {
            label: label
        });
    }
    get helpText() {
        const { helpText: helpText } = this.props;
        if (helpText) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $50b1b32e5996b939$export$2e2bcd8739ae039), {
            text: helpText
        });
    }
    get errorMessage() {
        const { errorMessage: errorMessage } = this.props;
        if (errorMessage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $d4af08b6d61e805a$export$2e2bcd8739ae039), {
            message: errorMessage
        });
    }
}
var $4b068530eeef95bb$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($4b068530eeef95bb$var$FormElement);



// Libraries

var $NdCUR = parcelRequire("NdCUR");

class $74fa897bd20a7994$var$FormDivider extends (0, $NdCUR.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            className: "form---divider"
        });
    }
}
var $74fa897bd20a7994$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($74fa897bd20a7994$var$FormDivider);


// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");


class $c8067424667a915b$var$FormFooter extends (0, $NdCUR.Component) {
    static{
        this.defaultProps = {
            colsXS: (0, $918c9f03a35fe03f$export$f02cc02ad0e0bba3).Twelve
        };
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.className
        }, children);
    }
    get className() {
        const { colsXS: colsXS, colsSM: colsSM, colsMD: colsMD, colsLG: colsLG, offsetXS: offsetXS, offsetSM: offsetSM, offsetMD: offsetMD, offsetLG: offsetLG } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('form--element form--submit', {
            [`col-xs-${colsXS}`]: colsXS,
            [`col-sm-${colsSM}`]: colsSM,
            [`col-md-${colsMD}`]: colsMD,
            [`col-lg-${colsLG}`]: colsLG,
            [`col-xs-offset-${offsetXS}`]: offsetXS,
            [`col-sm-offset-${offsetSM}`]: offsetSM,
            [`col-md-offset-${offsetMD}`]: offsetMD,
            [`col-lg-offset-${offsetLG}`]: offsetLG
        });
    }
}
var $c8067424667a915b$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($c8067424667a915b$var$FormFooter);



class $c5881206d41e0616$var$Form extends (0, $NdCUR.Component) {
    static{
        this.Element = (0, $4b068530eeef95bb$export$2e2bcd8739ae039);
    }
    static{
        this.Label = (0, $4b5c3026f1982ae2$export$2e2bcd8739ae039);
    }
    static{
        this.Divider = (0, $74fa897bd20a7994$export$2e2bcd8739ae039);
    }
    static{
        this.Footer = (0, $c8067424667a915b$export$2e2bcd8739ae039);
    }
    static{
        this.ValidChildTypes = [
            (0, $4b068530eeef95bb$export$2e2bcd8739ae039),
            (0, $4b5c3026f1982ae2$export$2e2bcd8739ae039),
            (0, $74fa897bd20a7994$export$2e2bcd8739ae039),
            (0, $c8067424667a915b$export$2e2bcd8739ae039)
        ];
    }
    static{
        this.ValidChildNames = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).map($c5881206d41e0616$var$Form.ValidChildTypes, (valid)=>{
            const name = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(valid, 'displayName', '').split('Form').pop();
            return `<Form.${name}>`;
        }).join(', ');
    }
    render() {
        const { children: children } = this.props;
        this.validateChildren();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form--wrapper"
        }, children);
    }
    constructor(...args){
        super(...args), this.validateChildren = ()=>{
            const childArray = (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Children.toArray(this.props.children);
            if (childArray.length === 0) throw new Error('Form require at least 1 child element. We recommend using <Form.Element>');
            const childrenAreValid = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).every(childArray, this.childTypeIsValid);
            if (!childrenAreValid) throw new Error(`<Form> expected children of type ${$c5881206d41e0616$var$Form.ValidChildNames}`);
        }, this.childTypeIsValid = (child)=>(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).includes($c5881206d41e0616$var$Form.ValidChildTypes, child.type);
    }
}
var $c5881206d41e0616$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($c5881206d41e0616$var$Form);


// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");

var $86817c9e53a28f66$export$476dfc2401bc286b = /*#__PURE__*/ function(InputType) {
    InputType["Text"] = "text";
    InputType["Number"] = "number";
    InputType["Password"] = "password";
    InputType["Email"] = "email";
    return InputType;
}({});
class $86817c9e53a28f66$var$Input extends (0, $NdCUR.Component) {
    static{
        this.defaultProps = {
            value: '',
            placeholder: '',
            titleText: '',
            disabledTitleText: 'This input is disabled',
            size: (0, $918c9f03a35fe03f$export$fafce5c139da9687).Small,
            status: (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Default,
            autoFocus: false,
            spellCheck: false,
            type: "text"
        };
    }
    constructor(props){
        super(props);
        this.inputRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createRef();
    }
    componentDidMount() {
        if (this.props.autoFocus) this.timeoutHandle = setTimeout(()=>{
            this.inputRef.current.focus();
            this.timeoutHandle = undefined;
        }, 50);
    }
    componentWillUnmount() {
        if (this.timeoutHandle) clearTimeout(this.timeoutHandle);
    }
    render() {
        const { status: status, type: type, value: value, placeholder: placeholder, autoFocus: autoFocus, spellCheck: spellCheck, autoComplete: autoComplete, onChange: onChange, onBlur: onBlur, onFocus: onFocus, onKeyPress: onKeyPress, onKeyUp: onKeyUp, onKeyDown: onKeyDown, testId: testId } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.className,
            style: this.containerStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            title: this.title,
            type: type,
            value: value,
            placeholder: placeholder,
            autoFocus: autoFocus,
            autoComplete: autoComplete,
            spellCheck: spellCheck,
            onChange: onChange,
            onBlur: onBlur,
            onFocus: onFocus,
            onKeyPress: onKeyPress,
            onKeyUp: onKeyUp,
            onKeyDown: onKeyDown,
            className: "input-field",
            "data-test": testId,
            disabled: status === (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Disabled,
            ref: this.inputRef
        }), this.icon, this.statusIndicator);
    }
    get icon() {
        const { icon: icon } = this.props;
        if (icon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: `input-icon icon ${icon}`
        });
        return null;
    }
    get title() {
        const { titleText: titleText, disabledTitleText: disabledTitleText, status: status } = this.props;
        if (status === (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Disabled) return disabledTitleText;
        return titleText;
    }
    get statusIndicator() {
        const { status: status } = this.props;
        if (status === (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "input-status"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "input-spinner"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "input-shadow"
        }));
        if (status === (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: `input-status icon ${(0, $918c9f03a35fe03f$export$62c9c0cf752cde38).AlertTriangle}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "input-shadow"
        }));
        if (status === (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Valid) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: `input-status icon ${(0, $918c9f03a35fe03f$export$62c9c0cf752cde38).Checkmark}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "input-shadow"
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "input-shadow"
        });
    }
    get className() {
        const { size: size, status: status, icon: icon, customClass: customClass } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('input', {
            [`input-${size}`]: size,
            'input--has-icon': icon,
            'input--valid': status === (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Valid,
            'input--error': status === (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Error,
            'input--loading': status === (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Loading,
            'input--disabled': status === (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Disabled,
            [`${customClass}`]: customClass
        });
    }
    get containerStyle() {
        const { widthPixels: widthPixels } = this.props;
        if (widthPixels) return {
            width: `${widthPixels}px`
        };
        return {
            width: '100%'
        };
    }
}
var $86817c9e53a28f66$export$2e2bcd8739ae039 = $86817c9e53a28f66$var$Input;


// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");

class $827fcd4cb090ac0e$var$OverlayTechnology extends (0, $NdCUR.Component) {
    static getDerivedStateFromProps(props) {
        if (props.visible) return {
            showChildren: true
        };
        return {};
    }
    constructor(props){
        super(props), this.hideChildren = ()=>{
            this.setState({
                showChildren: false
            });
        };
        this.state = {
            showChildren: false
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.visible && !this.props.visible) {
            clearTimeout(this.animationTimer);
            this.animationTimer = window.setTimeout(this.hideChildren, 300);
        }
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.overlayClass
        }, this.childContainer, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "overlay--mask"
        }));
    }
    get childContainer() {
        const { children: children } = this.props;
        const { showChildren: showChildren } = this.state;
        if (showChildren) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "overlay--dialog",
            "data-test": "overlay-children"
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "overlay--dialog",
            "data-test": "overlay-children"
        });
    }
    get overlayClass() {
        const { visible: visible } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('overlay-tech', {
            show: visible
        });
    }
}
var $827fcd4cb090ac0e$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($827fcd4cb090ac0e$var$OverlayTechnology);



var $NdCUR = parcelRequire("NdCUR");
class $1868bdace58643df$var$OverlayContainer extends (0, $NdCUR.Component) {
    static{
        this.defaultProps = {
            maxWidth: 600
        };
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "overlay--container",
            style: this.style
        }, children);
    }
    get style() {
        const { maxWidth: maxWidth } = this.props;
        return {
            maxWidth: `${maxWidth}px`
        };
    }
}
var $1868bdace58643df$export$2e2bcd8739ae039 = $1868bdace58643df$var$OverlayContainer;



var $NdCUR = parcelRequire("NdCUR");
class $1372e03f76900c5b$var$OverlayHeading extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props);
    }
    render() {
        const { title: title, onDismiss: onDismiss, children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "overlay--heading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "overlay--title"
        }, title), onDismiss && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "overlay--dismiss",
            onClick: onDismiss,
            "data-test": "dismiss-button"
        }), children && children);
    }
}
var $1372e03f76900c5b$export$2e2bcd8739ae039 = $1372e03f76900c5b$var$OverlayHeading;



var $NdCUR = parcelRequire("NdCUR");
const $1e8c886c7914a527$var$OverlayBody = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "overlay--body"
    }, children);
var $1e8c886c7914a527$export$2e2bcd8739ae039 = $1e8c886c7914a527$var$OverlayBody;


// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");
// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");

var $NdCUR = parcelRequire("NdCUR");
const $8b5a95f66af3dc98$var$PageTitle = ({ title: title })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h1", {
        className: "page-header--title"
    }, title);
var $8b5a95f66af3dc98$export$2e2bcd8739ae039 = $8b5a95f66af3dc98$var$PageTitle;


// Libraries

var $NdCUR = parcelRequire("NdCUR");
// Constants
const $2a66c2d01ee443f1$var$DEFAULT_OFFSET = 0;
const $2a66c2d01ee443f1$var$MIN_CHILD_COUNT = 1;
class $2a66c2d01ee443f1$var$PageHeaderLeft extends (0, $NdCUR.Component) {
    static{
        this.defaultProps = {
            offsetPixels: $2a66c2d01ee443f1$var$DEFAULT_OFFSET
        };
    }
    render() {
        const { children: children } = this.props;
        this.validateChildCount();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "page-header--left",
            style: this.styles
        }, children);
    }
    get styles() {
        const { offsetPixels: offsetPixels } = this.props;
        if (offsetPixels === $2a66c2d01ee443f1$var$DEFAULT_OFFSET) return;
        return {
            flex: `1 0 calc(50% - ${offsetPixels}px)`
        };
    }
    constructor(...args){
        super(...args), this.validateChildCount = ()=>{
            const { children: children } = this.props;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Children.count(children) < $2a66c2d01ee443f1$var$MIN_CHILD_COUNT) throw new Error('Page.Header.Left require at least 1 child element. We recommend using <Page.Title />');
        };
    }
}
var $2a66c2d01ee443f1$export$2e2bcd8739ae039 = $2a66c2d01ee443f1$var$PageHeaderLeft;


// Libraries

var $NdCUR = parcelRequire("NdCUR");
const $5f54aea8aabe046b$export$59d85090c819c684 = 200;


const $e9f63e5cb2b075e1$var$MIN_CHILD_COUNT = 1;
class $e9f63e5cb2b075e1$var$PageHeaderCenter extends (0, $NdCUR.Component) {
    static{
        this.defaultProps = {
            widthPixels: (0, $5f54aea8aabe046b$export$59d85090c819c684)
        };
    }
    render() {
        const { children: children } = this.props;
        this.validateChildCount();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "page-header--center",
            style: this.styles,
            "data-test": "page-header--center"
        }, children);
    }
    get styles() {
        const { widthPixels: widthPixels } = this.props;
        return {
            flex: `1 0 ${widthPixels}px`
        };
    }
    constructor(...args){
        super(...args), this.validateChildCount = ()=>{
            const { children: children } = this.props;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Children.count(children) < $e9f63e5cb2b075e1$var$MIN_CHILD_COUNT) throw new Error('Page.Header.Left require at least 1 child element. We recommend using <Page.Title />');
        };
    }
}
var $e9f63e5cb2b075e1$export$2e2bcd8739ae039 = $e9f63e5cb2b075e1$var$PageHeaderCenter;


// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");

var $NdCUR = parcelRequire("NdCUR");
function $82a18451bb6f6ba0$var$___$insertStyle(css) {
    if (!css) return;
    if (typeof window === 'undefined') return;
    var style = document.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    document.head.appendChild(style);
    return css;
}
function $82a18451bb6f6ba0$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $82a18451bb6f6ba0$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $82a18451bb6f6ba0$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $82a18451bb6f6ba0$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $82a18451bb6f6ba0$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $82a18451bb6f6ba0$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $82a18451bb6f6ba0$var$_extends() {
    $82a18451bb6f6ba0$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $82a18451bb6f6ba0$var$_extends.apply(this, arguments);
}
function $82a18451bb6f6ba0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $82a18451bb6f6ba0$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $82a18451bb6f6ba0$var$ownKeys(Object(source), true).forEach(function(key) {
            $82a18451bb6f6ba0$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $82a18451bb6f6ba0$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $82a18451bb6f6ba0$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $82a18451bb6f6ba0$var$_setPrototypeOf(subClass, superClass);
}
function $82a18451bb6f6ba0$var$_getPrototypeOf(o) {
    $82a18451bb6f6ba0$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $82a18451bb6f6ba0$var$_getPrototypeOf(o);
}
function $82a18451bb6f6ba0$var$_setPrototypeOf(o, p) {
    $82a18451bb6f6ba0$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $82a18451bb6f6ba0$var$_setPrototypeOf(o, p);
}
function $82a18451bb6f6ba0$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $82a18451bb6f6ba0$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    return $82a18451bb6f6ba0$var$_assertThisInitialized(self);
}
function $82a18451bb6f6ba0$var$createCommonjsModule(fn, module) {
    return module = {
        exports: {}
    }, fn(module, module.exports), module.exports;
}
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ function $82a18451bb6f6ba0$var$makeEmptyFunction(arg) {
    return function() {
        return arg;
    };
}
/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */ var $82a18451bb6f6ba0$var$emptyFunction = function emptyFunction() {};
$82a18451bb6f6ba0$var$emptyFunction.thatReturns = $82a18451bb6f6ba0$var$makeEmptyFunction;
$82a18451bb6f6ba0$var$emptyFunction.thatReturnsFalse = $82a18451bb6f6ba0$var$makeEmptyFunction(false);
$82a18451bb6f6ba0$var$emptyFunction.thatReturnsTrue = $82a18451bb6f6ba0$var$makeEmptyFunction(true);
$82a18451bb6f6ba0$var$emptyFunction.thatReturnsNull = $82a18451bb6f6ba0$var$makeEmptyFunction(null);
$82a18451bb6f6ba0$var$emptyFunction.thatReturnsThis = function() {
    return this;
};
$82a18451bb6f6ba0$var$emptyFunction.thatReturnsArgument = function(arg) {
    return arg;
};
var $82a18451bb6f6ba0$var$emptyFunction_1 = $82a18451bb6f6ba0$var$emptyFunction;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ /**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $82a18451bb6f6ba0$var$validateFormat = function validateFormat(format) {};
function $82a18451bb6f6ba0$var$invariant(condition, format, a, b, c, d, e, f) {
    $82a18451bb6f6ba0$var$validateFormat(format);
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
}
var $82a18451bb6f6ba0$var$invariant_1 = $82a18451bb6f6ba0$var$invariant;
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $82a18451bb6f6ba0$var$warning = $82a18451bb6f6ba0$var$emptyFunction_1;
var $82a18451bb6f6ba0$var$printWarning;
var $82a18451bb6f6ba0$var$warning_1 = $82a18451bb6f6ba0$var$warning;
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ /* eslint-disable no-unused-vars */ var $82a18451bb6f6ba0$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $82a18451bb6f6ba0$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $82a18451bb6f6ba0$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $82a18451bb6f6ba0$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $82a18451bb6f6ba0$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
var $82a18451bb6f6ba0$var$objectAssign = $82a18451bb6f6ba0$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $82a18451bb6f6ba0$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($82a18451bb6f6ba0$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($82a18451bb6f6ba0$var$getOwnPropertySymbols) {
            symbols = $82a18451bb6f6ba0$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($82a18451bb6f6ba0$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $82a18451bb6f6ba0$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var $82a18451bb6f6ba0$var$ReactPropTypesSecret_1 = $82a18451bb6f6ba0$var$ReactPropTypesSecret;
var $82a18451bb6f6ba0$var$invariant$1, $82a18451bb6f6ba0$var$warning$1, $82a18451bb6f6ba0$var$ReactPropTypesSecret$1, $82a18451bb6f6ba0$var$loggedTypeFailures;
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */ function $82a18451bb6f6ba0$var$checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    var typeSpecName, error, ex, stack;
}
var $82a18451bb6f6ba0$var$checkPropTypes_1 = $82a18451bb6f6ba0$var$checkPropTypes;
var $82a18451bb6f6ba0$var$factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
    /* global Symbol */ var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
    /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */ function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === 'function') return iteratorFn;
    }
    /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */ var ANONYMOUS = '<<anonymous>>';
    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
        array: createPrimitiveTypeChecker('array'),
        bool: createPrimitiveTypeChecker('boolean'),
        func: createPrimitiveTypeChecker('function'),
        number: createPrimitiveTypeChecker('number'),
        object: createPrimitiveTypeChecker('object'),
        string: createPrimitiveTypeChecker('string'),
        symbol: createPrimitiveTypeChecker('symbol'),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
    };
    /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */ /*eslint-disable no-self-compare*/ function is(x, y) {
        // SameValue algorithm
        if (x === y) // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
        else // Step 6.a: NaN == NaN
        return x !== x && y !== y;
    }
    /*eslint-enable no-self-compare*/ /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */ function PropTypeError(message) {
        this.message = message;
        this.stack = '';
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
        var manualPropTypeCallCache, manualPropTypeWarningCount;
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
            componentName = componentName || ANONYMOUS;
            propFullName = propFullName || propName;
            if (secret !== $82a18451bb6f6ba0$var$ReactPropTypesSecret_1) {
                if (throwOnDirectAccess) // New behavior only for users of `prop-types` package
                $82a18451bb6f6ba0$var$invariant_1(false, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                else var cacheKey;
            }
            if (props[propName] == null) {
                if (isRequired) {
                    if (props[propName] === null) return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
                    return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
                }
                return null;
            } else return validate(props, propName, componentName, location, propFullName);
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== expectedType) {
                // `propValue` being instance of, say, date/regexp, pass the 'object'
                // check, but we can offer a more precise error message here rather than
                // 'of type `object`'.
                var preciseType = getPreciseType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
        return createChainableTypeChecker($82a18451bb6f6ba0$var$emptyFunction_1.thatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== 'function') return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
            var propValue = props[propName];
            if (!Array.isArray(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
            }
            for(var i = 0; i < propValue.length; i++){
                var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', $82a18451bb6f6ba0$var$ReactPropTypesSecret_1);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!isValidElement(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
            if (!(props[propName] instanceof expectedClass)) {
                var expectedClassName = expectedClass.name || ANONYMOUS;
                var actualClassName = getClassName(props[propName]);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) return $82a18451bb6f6ba0$var$emptyFunction_1.thatReturnsNull;
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            for(var i = 0; i < expectedValues.length; i++){
                if (is(propValue, expectedValues[i])) return null;
            }
            var valuesString = JSON.stringify(expectedValues);
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
        }
        return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== 'function') return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
            for(var key in propValue)if (propValue.hasOwnProperty(key)) {
                var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, $82a18451bb6f6ba0$var$ReactPropTypesSecret_1);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) return $82a18451bb6f6ba0$var$emptyFunction_1.thatReturnsNull;
        for(var i = 0; i < arrayOfTypeCheckers.length; i++){
            var checker = arrayOfTypeCheckers[i];
            if (typeof checker !== 'function') {
                $82a18451bb6f6ba0$var$warning_1(false, "Invalid argument supplied to oneOfType. Expected an array of check functions, but received %s at index %s.", getPostfixForTypeWarning(checker), i);
                return $82a18451bb6f6ba0$var$emptyFunction_1.thatReturnsNull;
            }
        }
        function validate(props, propName, componentName, location, propFullName) {
            for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                var checker = arrayOfTypeCheckers[i];
                if (checker(props, propName, componentName, location, propFullName, $82a18451bb6f6ba0$var$ReactPropTypesSecret_1) == null) return null;
            }
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
        }
        return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            if (!isNode(props[propName])) return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
            for(var key in shapeTypes){
                var checker = shapeTypes[key];
                if (!checker) continue;
                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, $82a18451bb6f6ba0$var$ReactPropTypesSecret_1);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
            // We need to check all keys in case some are required but missing from
            // props.
            var allKeys = $82a18451bb6f6ba0$var$objectAssign({}, props[propName], shapeTypes);
            for(var key in allKeys){
                var checker = shapeTypes[key];
                if (!checker) return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, $82a18451bb6f6ba0$var$ReactPropTypesSecret_1);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
        switch(typeof propValue){
            case 'number':
            case 'string':
            case 'undefined':
                return true;
            case 'boolean':
                return !propValue;
            case 'object':
                if (Array.isArray(propValue)) return propValue.every(isNode);
                if (propValue === null || isValidElement(propValue)) return true;
                var iteratorFn = getIteratorFn(propValue);
                if (iteratorFn) {
                    var iterator = iteratorFn.call(propValue);
                    var step;
                    if (iteratorFn !== propValue.entries) while(!(step = iterator.next()).done){
                        if (!isNode(step.value)) return false;
                    }
                    else // Iterator will provide entry [k,v] tuples rather than values.
                    while(!(step = iterator.next()).done){
                        var entry = step.value;
                        if (entry) {
                            if (!isNode(entry[1])) return false;
                        }
                    }
                } else return false;
                return true;
            default:
                return false;
        }
    }
    function isSymbol(propType, propValue) {
        // Native Symbol.
        if (propType === 'symbol') return true;
        // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
        if (propValue['@@toStringTag'] === 'Symbol') return true;
        // Fallback for non-spec compliant Symbols which are polyfilled.
        if (typeof Symbol === 'function' && propValue instanceof Symbol) return true;
        return false;
    }
    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) return 'array';
        if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return 'object';
        if (isSymbol(propType, propValue)) return 'symbol';
        return propType;
    }
    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
        if (typeof propValue === 'undefined' || propValue === null) return '' + propValue;
        var propType = getPropType(propValue);
        if (propType === 'object') {
            if (propValue instanceof Date) return 'date';
            else if (propValue instanceof RegExp) return 'regexp';
        }
        return propType;
    }
    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch(type){
            case 'array':
            case 'object':
                return 'an ' + type;
            case 'boolean':
            case 'date':
            case 'regexp':
                return 'a ' + type;
            default:
                return type;
        }
    }
    // Returns class name of the object, if any.
    function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) return ANONYMOUS;
        return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = $82a18451bb6f6ba0$var$checkPropTypes_1;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};
var $82a18451bb6f6ba0$var$factoryWithThrowingShims = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $82a18451bb6f6ba0$var$ReactPropTypesSecret_1) // It is still safe when called from React.
        return;
        $82a18451bb6f6ba0$var$invariant_1(false, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    } // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim
    };
    ReactPropTypes.checkPropTypes = $82a18451bb6f6ba0$var$emptyFunction_1;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};
var $82a18451bb6f6ba0$var$propTypes = $82a18451bb6f6ba0$var$createCommonjsModule(function(module) {
    var REACT_ELEMENT_TYPE, isValidElement, throwOnDirectAccess;
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    module.exports = $82a18451bb6f6ba0$var$factoryWithThrowingShims();
});
var $82a18451bb6f6ba0$var$CONSTANT = {
    GLOBAL: {
        HIDE: "__react_tooltip_hide_event",
        REBUILD: "__react_tooltip_rebuild_event",
        SHOW: "__react_tooltip_show_event"
    }
};
/**
 * Static methods for react-tooltip
 */ var $82a18451bb6f6ba0$var$dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
    // Compatible with IE
    // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
    var event;
    if (typeof window.CustomEvent === "function") event = new window.CustomEvent(eventName, {
        detail: opts
    });
    else {
        event = document.createEvent("Event");
        event.initEvent(eventName, false, true);
        event.detail = opts;
    }
    window.dispatchEvent(event);
};
function $82a18451bb6f6ba0$var$staticMethods(target) {
    /**
   * Hide all tooltip
   * @trigger ReactTooltip.hide()
   */ target.hide = function(target) {
        $82a18451bb6f6ba0$var$dispatchGlobalEvent($82a18451bb6f6ba0$var$CONSTANT.GLOBAL.HIDE, {
            target: target
        });
    };
    /**
   * Rebuild all tooltip
   * @trigger ReactTooltip.rebuild()
   */ target.rebuild = function() {
        $82a18451bb6f6ba0$var$dispatchGlobalEvent($82a18451bb6f6ba0$var$CONSTANT.GLOBAL.REBUILD);
    };
    /**
   * Show specific tooltip
   * @trigger ReactTooltip.show()
   */ target.show = function(target) {
        $82a18451bb6f6ba0$var$dispatchGlobalEvent($82a18451bb6f6ba0$var$CONSTANT.GLOBAL.SHOW, {
            target: target
        });
    };
    target.prototype.globalRebuild = function() {
        if (this.mount) {
            this.unbindListener();
            this.bindListener();
        }
    };
    target.prototype.globalShow = function(event) {
        if (this.mount) {
            // Create a fake event, specific show will limit the type to `solid`
            // only `float` type cares e.clientX e.clientY
            var e = {
                currentTarget: event.detail.target
            };
            this.showTooltip(e, true);
        }
    };
    target.prototype.globalHide = function(event) {
        if (this.mount) {
            var hasTarget = event && event.detail && event.detail.target && true || false;
            this.hideTooltip({
                currentTarget: hasTarget && event.detail.target
            }, hasTarget);
        }
    };
}
/**
 * Events that should be bound to the window
 */ function $82a18451bb6f6ba0$var$windowListener(target) {
    target.prototype.bindWindowEvents = function(resizeHide) {
        // ReactTooltip.hide
        window.removeEventListener($82a18451bb6f6ba0$var$CONSTANT.GLOBAL.HIDE, this.globalHide);
        window.addEventListener($82a18451bb6f6ba0$var$CONSTANT.GLOBAL.HIDE, this.globalHide, false); // ReactTooltip.rebuild
        window.removeEventListener($82a18451bb6f6ba0$var$CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
        window.addEventListener($82a18451bb6f6ba0$var$CONSTANT.GLOBAL.REBUILD, this.globalRebuild, false); // ReactTooltip.show
        window.removeEventListener($82a18451bb6f6ba0$var$CONSTANT.GLOBAL.SHOW, this.globalShow);
        window.addEventListener($82a18451bb6f6ba0$var$CONSTANT.GLOBAL.SHOW, this.globalShow, false); // Resize
        if (resizeHide) {
            window.removeEventListener("resize", this.onWindowResize);
            window.addEventListener("resize", this.onWindowResize, false);
        }
    };
    target.prototype.unbindWindowEvents = function() {
        window.removeEventListener($82a18451bb6f6ba0$var$CONSTANT.GLOBAL.HIDE, this.globalHide);
        window.removeEventListener($82a18451bb6f6ba0$var$CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
        window.removeEventListener($82a18451bb6f6ba0$var$CONSTANT.GLOBAL.SHOW, this.globalShow);
        window.removeEventListener("resize", this.onWindowResize);
    };
    /**
   * invoked by resize event of window
   */ target.prototype.onWindowResize = function() {
        if (!this.mount) return;
        this.hideTooltip();
    };
}
/**
 * Custom events to control showing and hiding of tooltip
 *
 * @attributes
 * - `event` {String}
 * - `eventOff` {String}
 */ var $82a18451bb6f6ba0$var$checkStatus = function checkStatus(dataEventOff, e) {
    var show = this.state.show;
    var id = this.props.id;
    var isCapture = this.isCapture(e.currentTarget);
    var currentItem = e.currentTarget.getAttribute("currentItem");
    if (!isCapture) e.stopPropagation();
    if (show && currentItem === "true") {
        if (!dataEventOff) this.hideTooltip(e);
    } else {
        e.currentTarget.setAttribute("currentItem", "true");
        $82a18451bb6f6ba0$var$setUntargetItems(e.currentTarget, this.getTargetArray(id));
        this.showTooltip(e);
    }
};
var $82a18451bb6f6ba0$var$setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
    for(var i = 0; i < targetArray.length; i++)if (currentTarget !== targetArray[i]) targetArray[i].setAttribute("currentItem", "false");
    else targetArray[i].setAttribute("currentItem", "true");
};
var $82a18451bb6f6ba0$var$customListeners = {
    id: "9b69f92e-d3fe-498b-b1b4-c5e63a51b0cf",
    set: function set(target, event, listener) {
        if (this.id in target) {
            var map = target[this.id];
            map[event] = listener;
        } else // this is workaround for WeakMap, which is not supported in older browsers, such as IE
        Object.defineProperty(target, this.id, {
            configurable: true,
            value: $82a18451bb6f6ba0$var$_defineProperty({}, event, listener)
        });
    },
    get: function get(target, event) {
        var map = target[this.id];
        if (map !== undefined) return map[event];
    }
};
function $82a18451bb6f6ba0$var$customEvent(target) {
    target.prototype.isCustomEvent = function(ele) {
        var event = this.state.event;
        return event || !!ele.getAttribute("data-event");
    };
    /* Bind listener for custom event */ target.prototype.customBindListener = function(ele) {
        var _this = this;
        var _this$state = this.state, event = _this$state.event, eventOff = _this$state.eventOff;
        var dataEvent = ele.getAttribute("data-event") || event;
        var dataEventOff = ele.getAttribute("data-event-off") || eventOff;
        dataEvent.split(" ").forEach(function(event) {
            ele.removeEventListener(event, $82a18451bb6f6ba0$var$customListeners.get(ele, event));
            var customListener = $82a18451bb6f6ba0$var$checkStatus.bind(_this, dataEventOff);
            $82a18451bb6f6ba0$var$customListeners.set(ele, event, customListener);
            ele.addEventListener(event, customListener, false);
        });
        if (dataEventOff) dataEventOff.split(" ").forEach(function(event) {
            ele.removeEventListener(event, _this.hideTooltip);
            ele.addEventListener(event, _this.hideTooltip, false);
        });
    };
    /* Unbind listener for custom event */ target.prototype.customUnbindListener = function(ele) {
        var _this$state2 = this.state, event = _this$state2.event, eventOff = _this$state2.eventOff;
        var dataEvent = event || ele.getAttribute("data-event");
        var dataEventOff = eventOff || ele.getAttribute("data-event-off");
        ele.removeEventListener(dataEvent, $82a18451bb6f6ba0$var$customListeners.get(ele, event));
        if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
    };
}
/**
 * Util method to judge if it should follow capture model
 */ function $82a18451bb6f6ba0$var$isCapture(target) {
    target.prototype.isCapture = function(currentTarget) {
        return currentTarget && currentTarget.getAttribute("data-iscapture") === "true" || this.props.isCapture || false;
    };
}
/**
 * Util method to get effect
 */ function $82a18451bb6f6ba0$var$getEffect(target) {
    target.prototype.getEffect = function(currentTarget) {
        var dataEffect = currentTarget.getAttribute("data-effect");
        return dataEffect || this.props.effect || "float";
    };
}
/**
 * Util method to get effect
 */ var $82a18451bb6f6ba0$var$makeProxy = function makeProxy(e) {
    var proxy = {};
    for(var key in e)if (typeof e[key] === "function") proxy[key] = e[key].bind(e);
    else proxy[key] = e[key];
    return proxy;
};
var $82a18451bb6f6ba0$var$bodyListener = function bodyListener(callback, options, e) {
    var _options$respectEffec = options.respectEffect, respectEffect = _options$respectEffec === void 0 ? false : _options$respectEffec, _options$customEvent = options.customEvent, customEvent = _options$customEvent === void 0 ? false : _options$customEvent;
    var id = this.props.id;
    var tip = e.target.getAttribute("data-tip") || null;
    var forId = e.target.getAttribute("data-for") || null;
    var target = e.target;
    if (this.isCustomEvent(target) && !customEvent) return;
    var isTargetBelongsToTooltip = id == null && forId == null || forId === id;
    if (tip != null && (!respectEffect || this.getEffect(target) === "float") && isTargetBelongsToTooltip) {
        var proxy = $82a18451bb6f6ba0$var$makeProxy(e);
        proxy.currentTarget = target;
        callback(proxy);
    }
};
var $82a18451bb6f6ba0$var$findCustomEvents = function findCustomEvents(targetArray, dataAttribute) {
    var events = {};
    targetArray.forEach(function(target) {
        var event = target.getAttribute(dataAttribute);
        if (event) event.split(" ").forEach(function(event) {
            return events[event] = true;
        });
    });
    return events;
};
var $82a18451bb6f6ba0$var$getBody = function getBody() {
    return document.getElementsByTagName("body")[0];
};
function $82a18451bb6f6ba0$var$bodyMode(target) {
    target.prototype.isBodyMode = function() {
        return !!this.props.bodyMode;
    };
    target.prototype.bindBodyListener = function(targetArray) {
        var _this = this;
        var _this$state = this.state, event = _this$state.event, eventOff = _this$state.eventOff, possibleCustomEvents = _this$state.possibleCustomEvents, possibleCustomEventsOff = _this$state.possibleCustomEventsOff;
        var body = $82a18451bb6f6ba0$var$getBody();
        var customEvents = $82a18451bb6f6ba0$var$findCustomEvents(targetArray, "data-event");
        var customEventsOff = $82a18451bb6f6ba0$var$findCustomEvents(targetArray, "data-event-off");
        if (event != null) customEvents[event] = true;
        if (eventOff != null) customEventsOff[eventOff] = true;
        possibleCustomEvents.split(" ").forEach(function(event) {
            return customEvents[event] = true;
        });
        possibleCustomEventsOff.split(" ").forEach(function(event) {
            return customEventsOff[event] = true;
        });
        this.unbindBodyListener(body);
        var listeners = this.bodyModeListeners = {};
        if (event == null) {
            listeners.mouseover = $82a18451bb6f6ba0$var$bodyListener.bind(this, this.showTooltip, {});
            listeners.mousemove = $82a18451bb6f6ba0$var$bodyListener.bind(this, this.updateTooltip, {
                respectEffect: true
            });
            listeners.mouseout = $82a18451bb6f6ba0$var$bodyListener.bind(this, this.hideTooltip, {});
        }
        for(var _event in customEvents)listeners[_event] = $82a18451bb6f6ba0$var$bodyListener.bind(this, function(e) {
            var targetEventOff = e.currentTarget.getAttribute("data-event-off") || eventOff;
            $82a18451bb6f6ba0$var$checkStatus.call(_this, targetEventOff, e);
        }, {
            customEvent: true
        });
        for(var _event2 in customEventsOff)listeners[_event2] = $82a18451bb6f6ba0$var$bodyListener.bind(this, this.hideTooltip, {
            customEvent: true
        });
        for(var _event3 in listeners)body.addEventListener(_event3, listeners[_event3]);
    };
    target.prototype.unbindBodyListener = function(body) {
        body = body || $82a18451bb6f6ba0$var$getBody();
        var listeners = this.bodyModeListeners;
        for(var event in listeners)body.removeEventListener(event, listeners[event]);
    };
}
/**
 * Tracking target removing from DOM.
 * It's necessary to hide tooltip when it's target disappears.
 * Otherwise, the tooltip would be shown forever until another target
 * is triggered.
 *
 * If MutationObserver is not available, this feature just doesn't work.
 */ // https://hacks.mozilla.org/2012/05/dom-mutationobserver-reacting-to-dom-changes-without-killing-browser-performance/
var $82a18451bb6f6ba0$var$getMutationObserverClass = function getMutationObserverClass() {
    return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
};
function $82a18451bb6f6ba0$var$trackRemoval(target) {
    target.prototype.bindRemovalTracker = function() {
        var _this = this;
        var MutationObserver = $82a18451bb6f6ba0$var$getMutationObserverClass();
        if (MutationObserver == null) return;
        var observer = new MutationObserver(function(mutations) {
            for(var m1 = 0; m1 < mutations.length; m1++){
                var mutation = mutations[m1];
                for(var m2 = 0; m2 < mutation.removedNodes.length; m2++){
                    var element = mutation.removedNodes[m2];
                    if (element === _this.state.currentTarget) {
                        _this.hideTooltip();
                        return;
                    }
                }
            }
        });
        observer.observe(window.document, {
            childList: true,
            subtree: true
        });
        this.removalTracker = observer;
    };
    target.prototype.unbindRemovalTracker = function() {
        if (this.removalTracker) {
            this.removalTracker.disconnect();
            this.removalTracker = null;
        }
    };
}
/**
 * Calculate the position of tooltip
 *
 * @params
 * - `e` {Event} the event of current mouse
 * - `target` {Element} the currentTarget of the event
 * - `node` {DOM} the react-tooltip object
 * - `place` {String} top / right / bottom / left
 * - `effect` {String} float / solid
 * - `offset` {Object} the offset to default position
 *
 * @return {Object}
 * - `isNewState` {Bool} required
 * - `newState` {Object}
 * - `position` {Object} {left: {Number}, top: {Number}}
 */ function $82a18451bb6f6ba0$var$getPosition(e, target, node, place, desiredPlace, effect, offset) {
    var _getDimensions = $82a18451bb6f6ba0$var$getDimensions(node), tipWidth = _getDimensions.width, tipHeight = _getDimensions.height;
    var _getDimensions2 = $82a18451bb6f6ba0$var$getDimensions(target), targetWidth = _getDimensions2.width, targetHeight = _getDimensions2.height;
    var _getCurrentOffset = $82a18451bb6f6ba0$var$getCurrentOffset(e, target, effect), mouseX = _getCurrentOffset.mouseX, mouseY = _getCurrentOffset.mouseY;
    var defaultOffset = $82a18451bb6f6ba0$var$getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight);
    var _calculateOffset = $82a18451bb6f6ba0$var$calculateOffset(offset), extraOffset_X = _calculateOffset.extraOffset_X, extraOffset_Y = _calculateOffset.extraOffset_Y;
    var windowWidth = window.innerWidth;
    var windowHeight = window.innerHeight;
    var _getParent = $82a18451bb6f6ba0$var$getParent(node), parentTop = _getParent.parentTop, parentLeft = _getParent.parentLeft; // Get the edge offset of the tooltip
    var getTipOffsetLeft = function getTipOffsetLeft(place) {
        var offset_X = defaultOffset[place].l;
        return mouseX + offset_X + extraOffset_X;
    };
    var getTipOffsetRight = function getTipOffsetRight(place) {
        var offset_X = defaultOffset[place].r;
        return mouseX + offset_X + extraOffset_X;
    };
    var getTipOffsetTop = function getTipOffsetTop(place) {
        var offset_Y = defaultOffset[place].t;
        return mouseY + offset_Y + extraOffset_Y;
    };
    var getTipOffsetBottom = function getTipOffsetBottom(place) {
        var offset_Y = defaultOffset[place].b;
        return mouseY + offset_Y + extraOffset_Y;
    }; //
    // Functions to test whether the tooltip's sides are inside
    // the client window for a given orientation p
    //
    //  _____________
    // |             | <-- Right side
    // | p = 'left'  |\
    // |             |/  |\
    // |_____________|   |_\  <-- Mouse
    //      / \           |
    //       |
    //       |
    //  Bottom side
    //
    var outsideLeft = function outsideLeft(p) {
        return getTipOffsetLeft(p) < 0;
    };
    var outsideRight = function outsideRight(p) {
        return getTipOffsetRight(p) > windowWidth;
    };
    var outsideTop = function outsideTop(p) {
        return getTipOffsetTop(p) < 0;
    };
    var outsideBottom = function outsideBottom(p) {
        return getTipOffsetBottom(p) > windowHeight;
    }; // Check whether the tooltip with orientation p is completely inside the client window
    var outside = function outside(p) {
        return outsideLeft(p) || outsideRight(p) || outsideTop(p) || outsideBottom(p);
    };
    var inside = function inside(p) {
        return !outside(p);
    };
    var placesList = [
        "top",
        "bottom",
        "left",
        "right"
    ];
    var insideList = [];
    for(var i = 0; i < 4; i++){
        var p = placesList[i];
        if (inside(p)) insideList.push(p);
    }
    var isNewState = false;
    var newPlace;
    var shouldUpdatePlace = desiredPlace !== place;
    if (inside(desiredPlace) && shouldUpdatePlace) {
        isNewState = true;
        newPlace = desiredPlace;
    } else if (insideList.length > 0 && shouldUpdatePlace && outside(desiredPlace) && outside(place)) {
        isNewState = true;
        newPlace = insideList[0];
    }
    if (isNewState) return {
        isNewState: true,
        newState: {
            place: newPlace
        }
    };
    return {
        isNewState: false,
        position: {
            left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
            top: parseInt(getTipOffsetTop(place) - parentTop, 10)
        }
    };
}
var $82a18451bb6f6ba0$var$getDimensions = function getDimensions(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), height = _node$getBoundingClie.height, width = _node$getBoundingClie.width;
    return {
        height: parseInt(height, 10),
        width: parseInt(width, 10)
    };
}; // Get current mouse offset
var $82a18451bb6f6ba0$var$getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
    var boundingClientRect = currentTarget.getBoundingClientRect();
    var targetTop = boundingClientRect.top;
    var targetLeft = boundingClientRect.left;
    var _getDimensions3 = $82a18451bb6f6ba0$var$getDimensions(currentTarget), targetWidth = _getDimensions3.width, targetHeight = _getDimensions3.height;
    if (effect === "float") return {
        mouseX: e.clientX,
        mouseY: e.clientY
    };
    return {
        mouseX: targetLeft + targetWidth / 2,
        mouseY: targetTop + targetHeight / 2
    };
}; // List all possibility of tooltip final offset
// This is useful in judging if it is necessary for tooltip to switch position when out of window
var $82a18451bb6f6ba0$var$getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
    var top;
    var right;
    var bottom;
    var left;
    var disToMouse = 3;
    var triangleHeight = 2;
    var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip
    if (effect === "float") {
        top = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: -(tipHeight + disToMouse + triangleHeight),
            b: -disToMouse
        };
        bottom = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: disToMouse + cursorHeight,
            b: tipHeight + disToMouse + triangleHeight + cursorHeight
        };
        left = {
            l: -(tipWidth + disToMouse + triangleHeight),
            r: -disToMouse,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
        right = {
            l: disToMouse,
            r: tipWidth + disToMouse + triangleHeight,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
    } else if (effect === "solid") {
        top = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: -(targetHeight / 2 + tipHeight + triangleHeight),
            b: -(targetHeight / 2)
        };
        bottom = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: targetHeight / 2,
            b: targetHeight / 2 + tipHeight + triangleHeight
        };
        left = {
            l: -(tipWidth + targetWidth / 2 + triangleHeight),
            r: -(targetWidth / 2),
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
        right = {
            l: targetWidth / 2,
            r: tipWidth + targetWidth / 2 + triangleHeight,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
    }
    return {
        top: top,
        bottom: bottom,
        left: left,
        right: right
    };
}; // Consider additional offset into position calculation
var $82a18451bb6f6ba0$var$calculateOffset = function calculateOffset(offset) {
    var extraOffset_X = 0;
    var extraOffset_Y = 0;
    if (Object.prototype.toString.apply(offset) === "[object String]") offset = JSON.parse(offset.toString().replace(/\'/g, '"'));
    for(var key in offset){
        if (key === "top") extraOffset_Y -= parseInt(offset[key], 10);
        else if (key === "bottom") extraOffset_Y += parseInt(offset[key], 10);
        else if (key === "left") extraOffset_X -= parseInt(offset[key], 10);
        else if (key === "right") extraOffset_X += parseInt(offset[key], 10);
    }
    return {
        extraOffset_X: extraOffset_X,
        extraOffset_Y: extraOffset_Y
    };
}; // Get the offset of the parent elements
var $82a18451bb6f6ba0$var$getParent = function getParent(currentTarget) {
    var currentParent = currentTarget;
    while(currentParent){
        if (window.getComputedStyle(currentParent).getPropertyValue("transform") !== "none") break;
        currentParent = currentParent.parentElement;
    }
    var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
    var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;
    return {
        parentTop: parentTop,
        parentLeft: parentLeft
    };
};
/**
 * To get the tooltip content
 * it may comes from data-tip or this.props.children
 * it should support multiline
 *
 * @params
 * - `tip` {String} value of data-tip
 * - `children` {ReactElement} this.props.children
 * - `multiline` {Any} could be Bool(true/false) or String('true'/'false')
 *
 * @return
 * - String or react component
 */ function $82a18451bb6f6ba0$var$getTipContent(tip, children, getContent, multiline) {
    if (children) return children;
    if (getContent !== undefined && getContent !== null) return getContent; // getContent can be 0, '', etc.
    if (getContent === null) return null; // Tip not exist and children is null or undefined
    var regexp = /<br\s*\/?>/;
    if (!multiline || multiline === "false" || !regexp.test(tip)) // No trim(), so that user can keep their input
    return tip;
     // Multiline tooltip content
    return tip.split(regexp).map(function(d, i) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            key: i,
            className: "multi-line"
        }, d);
    });
}
/**
 * Support aria- and role in ReactTooltip
 *
 * @params props {Object}
 * @return {Object}
 */ function $82a18451bb6f6ba0$var$parseAria(props) {
    var ariaObj = {};
    Object.keys(props).filter(function(prop) {
        // aria-xxx and role is acceptable
        return /(^aria-\w+$|^role$)/.test(prop);
    }).forEach(function(prop) {
        ariaObj[prop] = props[prop];
    });
    return ariaObj;
}
/**
 * Convert nodelist to array
 * @see https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/core/createArrayFromMixed.js#L24
 * NodeLists are functions in Safari
 */ function $82a18451bb6f6ba0$var$nodeListToArray(nodeList) {
    var length = nodeList.length;
    if (nodeList.hasOwnProperty) return Array.prototype.slice.call(nodeList);
    return new Array(length).fill().map(function(index) {
        return nodeList[index];
    });
}
$82a18451bb6f6ba0$var$___$insertStyle(".__react_component_tooltip {\n  border-radius: 3px;\n  display: inline-block;\n  font-size: 13px;\n  left: -999em;\n  opacity: 0;\n  padding: 8px 21px;\n  position: fixed;\n  pointer-events: none;\n  transition: opacity 0.3s ease-out;\n  top: -999em;\n  visibility: hidden;\n  z-index: 999;\n}\n.__react_component_tooltip.allow_hover, .__react_component_tooltip.allow_click {\n  pointer-events: auto;\n}\n.__react_component_tooltip:before, .__react_component_tooltip:after {\n  content: \"\";\n  width: 0;\n  height: 0;\n  position: absolute;\n}\n.__react_component_tooltip.show {\n  opacity: 0.9;\n  margin-top: 0px;\n  margin-left: 0px;\n  visibility: visible;\n}\n.__react_component_tooltip.type-dark {\n  color: #fff;\n  background-color: #222;\n}\n.__react_component_tooltip.type-dark.place-top:after {\n  border-top-color: #222;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-dark.place-bottom:after {\n  border-bottom-color: #222;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-dark.place-left:after {\n  border-left-color: #222;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-dark.place-right:after {\n  border-right-color: #222;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-dark.border {\n  border: 1px solid #fff;\n}\n.__react_component_tooltip.type-dark.border.place-top:before {\n  border-top: 8px solid #fff;\n}\n.__react_component_tooltip.type-dark.border.place-bottom:before {\n  border-bottom: 8px solid #fff;\n}\n.__react_component_tooltip.type-dark.border.place-left:before {\n  border-left: 8px solid #fff;\n}\n.__react_component_tooltip.type-dark.border.place-right:before {\n  border-right: 8px solid #fff;\n}\n.__react_component_tooltip.type-success {\n  color: #fff;\n  background-color: #8DC572;\n}\n.__react_component_tooltip.type-success.place-top:after {\n  border-top-color: #8DC572;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-success.place-bottom:after {\n  border-bottom-color: #8DC572;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-success.place-left:after {\n  border-left-color: #8DC572;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-success.place-right:after {\n  border-right-color: #8DC572;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-success.border {\n  border: 1px solid #fff;\n}\n.__react_component_tooltip.type-success.border.place-top:before {\n  border-top: 8px solid #fff;\n}\n.__react_component_tooltip.type-success.border.place-bottom:before {\n  border-bottom: 8px solid #fff;\n}\n.__react_component_tooltip.type-success.border.place-left:before {\n  border-left: 8px solid #fff;\n}\n.__react_component_tooltip.type-success.border.place-right:before {\n  border-right: 8px solid #fff;\n}\n.__react_component_tooltip.type-warning {\n  color: #fff;\n  background-color: #F0AD4E;\n}\n.__react_component_tooltip.type-warning.place-top:after {\n  border-top-color: #F0AD4E;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-warning.place-bottom:after {\n  border-bottom-color: #F0AD4E;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-warning.place-left:after {\n  border-left-color: #F0AD4E;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-warning.place-right:after {\n  border-right-color: #F0AD4E;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-warning.border {\n  border: 1px solid #fff;\n}\n.__react_component_tooltip.type-warning.border.place-top:before {\n  border-top: 8px solid #fff;\n}\n.__react_component_tooltip.type-warning.border.place-bottom:before {\n  border-bottom: 8px solid #fff;\n}\n.__react_component_tooltip.type-warning.border.place-left:before {\n  border-left: 8px solid #fff;\n}\n.__react_component_tooltip.type-warning.border.place-right:before {\n  border-right: 8px solid #fff;\n}\n.__react_component_tooltip.type-error {\n  color: #fff;\n  background-color: #BE6464;\n}\n.__react_component_tooltip.type-error.place-top:after {\n  border-top-color: #BE6464;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-error.place-bottom:after {\n  border-bottom-color: #BE6464;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-error.place-left:after {\n  border-left-color: #BE6464;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-error.place-right:after {\n  border-right-color: #BE6464;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-error.border {\n  border: 1px solid #fff;\n}\n.__react_component_tooltip.type-error.border.place-top:before {\n  border-top: 8px solid #fff;\n}\n.__react_component_tooltip.type-error.border.place-bottom:before {\n  border-bottom: 8px solid #fff;\n}\n.__react_component_tooltip.type-error.border.place-left:before {\n  border-left: 8px solid #fff;\n}\n.__react_component_tooltip.type-error.border.place-right:before {\n  border-right: 8px solid #fff;\n}\n.__react_component_tooltip.type-info {\n  color: #fff;\n  background-color: #337AB7;\n}\n.__react_component_tooltip.type-info.place-top:after {\n  border-top-color: #337AB7;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-info.place-bottom:after {\n  border-bottom-color: #337AB7;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-info.place-left:after {\n  border-left-color: #337AB7;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-info.place-right:after {\n  border-right-color: #337AB7;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-info.border {\n  border: 1px solid #fff;\n}\n.__react_component_tooltip.type-info.border.place-top:before {\n  border-top: 8px solid #fff;\n}\n.__react_component_tooltip.type-info.border.place-bottom:before {\n  border-bottom: 8px solid #fff;\n}\n.__react_component_tooltip.type-info.border.place-left:before {\n  border-left: 8px solid #fff;\n}\n.__react_component_tooltip.type-info.border.place-right:before {\n  border-right: 8px solid #fff;\n}\n.__react_component_tooltip.type-light {\n  color: #222;\n  background-color: #fff;\n}\n.__react_component_tooltip.type-light.place-top:after {\n  border-top-color: #fff;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-light.place-bottom:after {\n  border-bottom-color: #fff;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-light.place-left:after {\n  border-left-color: #fff;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-light.place-right:after {\n  border-right-color: #fff;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-light.border {\n  border: 1px solid #222;\n}\n.__react_component_tooltip.type-light.border.place-top:before {\n  border-top: 8px solid #222;\n}\n.__react_component_tooltip.type-light.border.place-bottom:before {\n  border-bottom: 8px solid #222;\n}\n.__react_component_tooltip.type-light.border.place-left:before {\n  border-left: 8px solid #222;\n}\n.__react_component_tooltip.type-light.border.place-right:before {\n  border-right: 8px solid #222;\n}\n.__react_component_tooltip.place-top {\n  margin-top: -10px;\n}\n.__react_component_tooltip.place-top:before {\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  bottom: -8px;\n  left: 50%;\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-top:after {\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  bottom: -6px;\n  left: 50%;\n  margin-left: -8px;\n}\n.__react_component_tooltip.place-bottom {\n  margin-top: 10px;\n}\n.__react_component_tooltip.place-bottom:before {\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  top: -8px;\n  left: 50%;\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-bottom:after {\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  top: -6px;\n  left: 50%;\n  margin-left: -8px;\n}\n.__react_component_tooltip.place-left {\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-left:before {\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  right: -8px;\n  top: 50%;\n  margin-top: -5px;\n}\n.__react_component_tooltip.place-left:after {\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  right: -6px;\n  top: 50%;\n  margin-top: -4px;\n}\n.__react_component_tooltip.place-right {\n  margin-left: 10px;\n}\n.__react_component_tooltip.place-right:before {\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  left: -8px;\n  top: 50%;\n  margin-top: -5px;\n}\n.__react_component_tooltip.place-right:after {\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  left: -6px;\n  top: 50%;\n  margin-top: -4px;\n}\n.__react_component_tooltip .multi-line {\n  display: block;\n  padding: 2px 0px;\n  text-align: center;\n}");
var $82a18451bb6f6ba0$var$_class, $82a18451bb6f6ba0$var$_class2, $82a18451bb6f6ba0$var$_temp;
var $82a18451bb6f6ba0$var$ReactTooltip = $82a18451bb6f6ba0$var$staticMethods($82a18451bb6f6ba0$var$_class = $82a18451bb6f6ba0$var$windowListener($82a18451bb6f6ba0$var$_class = $82a18451bb6f6ba0$var$customEvent($82a18451bb6f6ba0$var$_class = $82a18451bb6f6ba0$var$isCapture($82a18451bb6f6ba0$var$_class = $82a18451bb6f6ba0$var$getEffect($82a18451bb6f6ba0$var$_class = $82a18451bb6f6ba0$var$bodyMode($82a18451bb6f6ba0$var$_class = $82a18451bb6f6ba0$var$trackRemoval($82a18451bb6f6ba0$var$_class = ($82a18451bb6f6ba0$var$_temp = $82a18451bb6f6ba0$var$_class2 = /*#__PURE__*/ function(_React$Component) {
    $82a18451bb6f6ba0$var$_inherits(ReactTooltip, _React$Component);
    function ReactTooltip(props) {
        var _this;
        $82a18451bb6f6ba0$var$_classCallCheck(this, ReactTooltip);
        _this = $82a18451bb6f6ba0$var$_possibleConstructorReturn(this, $82a18451bb6f6ba0$var$_getPrototypeOf(ReactTooltip).call(this, props));
        _this.state = {
            place: props.place || "top",
            // Direction of tooltip
            desiredPlace: props.place || "top",
            type: "dark",
            // Color theme of tooltip
            effect: "float",
            // float or fixed
            show: false,
            border: false,
            offset: {},
            extraClass: "",
            html: false,
            delayHide: 0,
            delayShow: 0,
            event: props.event || null,
            eventOff: props.eventOff || null,
            currentEvent: null,
            // Current mouse event
            currentTarget: null,
            // Current target of mouse event
            ariaProps: $82a18451bb6f6ba0$var$parseAria(props),
            // aria- and role attributes
            isEmptyTip: false,
            disable: false,
            possibleCustomEvents: props.possibleCustomEvents || "",
            possibleCustomEventsOff: props.possibleCustomEventsOff || "",
            originTooltip: null,
            isMultiline: false
        };
        _this.bind([
            "showTooltip",
            "updateTooltip",
            "hideTooltip",
            "hideTooltipOnScroll",
            "getTooltipContent",
            "globalRebuild",
            "globalShow",
            "globalHide",
            "onWindowResize",
            "mouseOnToolTip"
        ]);
        _this.mount = true;
        _this.delayShowLoop = null;
        _this.delayHideLoop = null;
        _this.delayReshow = null;
        _this.intervalUpdateContent = null;
        return _this;
    }
    /**
   * For unify the bind and unbind listener
   */ $82a18451bb6f6ba0$var$_createClass(ReactTooltip, [
        {
            key: "bind",
            value: function bind(methodArray) {
                var _this2 = this;
                methodArray.forEach(function(method) {
                    _this2[method] = _this2[method].bind(_this2);
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props = this.props, insecure = _this$props.insecure, resizeHide = _this$props.resizeHide;
                this.bindListener(); // Bind listener for tooltip
                this.bindWindowEvents(resizeHide); // Bind global event for static method
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mount = false;
                this.clearTimer();
                this.unbindListener();
                this.removeScrollListener();
                this.unbindWindowEvents();
            }
        },
        {
            key: "mouseOnToolTip",
            value: function mouseOnToolTip() {
                var show = this.state.show;
                if (show && this.tooltipRef) {
                    /* old IE or Firefox work around */ if (!this.tooltipRef.matches) {
                        /* old IE work around */ if (this.tooltipRef.msMatchesSelector) this.tooltipRef.matches = this.tooltipRef.msMatchesSelector;
                        else /* old Firefox work around */ this.tooltipRef.matches = this.tooltipRef.mozMatchesSelector;
                    }
                    return this.tooltipRef.matches(":hover");
                }
                return false;
            }
        },
        {
            key: "getTargetArray",
            value: function getTargetArray(id) {
                var targetArray;
                if (!id) targetArray = document.querySelectorAll("[data-tip]:not([data-for])");
                else {
                    var escaped = id.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
                    targetArray = document.querySelectorAll("[data-tip][data-for=\"".concat(escaped, "\"]"));
                } // targetArray is a NodeList, convert it to a real array
                return $82a18451bb6f6ba0$var$nodeListToArray(targetArray);
            }
        },
        {
            key: "bindListener",
            value: function bindListener() {
                var _this3 = this;
                var _this$props2 = this.props, id = _this$props2.id, globalEventOff = _this$props2.globalEventOff, isCapture = _this$props2.isCapture;
                var targetArray = this.getTargetArray(id);
                targetArray.forEach(function(target) {
                    if (target.getAttribute("currentItem") === null) target.setAttribute("currentItem", "false");
                    _this3.unbindBasicListener(target);
                    if (_this3.isCustomEvent(target)) _this3.customUnbindListener(target);
                });
                if (this.isBodyMode()) this.bindBodyListener(targetArray);
                else targetArray.forEach(function(target) {
                    var isCaptureMode = _this3.isCapture(target);
                    var effect = _this3.getEffect(target);
                    if (_this3.isCustomEvent(target)) {
                        _this3.customBindListener(target);
                        return;
                    }
                    target.addEventListener("mouseenter", _this3.showTooltip, isCaptureMode);
                    if (effect === "float") target.addEventListener("mousemove", _this3.updateTooltip, isCaptureMode);
                    target.addEventListener("mouseleave", _this3.hideTooltip, isCaptureMode);
                });
                 // Global event to hide tooltip
                if (globalEventOff) {
                    window.removeEventListener(globalEventOff, this.hideTooltip);
                    window.addEventListener(globalEventOff, this.hideTooltip, isCapture);
                } // Track removal of targetArray elements from DOM
                this.bindRemovalTracker();
            }
        },
        {
            key: "unbindListener",
            value: function unbindListener() {
                var _this4 = this;
                var _this$props3 = this.props, id = _this$props3.id, globalEventOff = _this$props3.globalEventOff;
                if (this.isBodyMode()) this.unbindBodyListener();
                else {
                    var targetArray = this.getTargetArray(id);
                    targetArray.forEach(function(target) {
                        _this4.unbindBasicListener(target);
                        if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
                    });
                }
                if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
                this.unbindRemovalTracker();
            }
        },
        {
            key: "unbindBasicListener",
            value: function unbindBasicListener(target) {
                var isCaptureMode = this.isCapture(target);
                target.removeEventListener("mouseenter", this.showTooltip, isCaptureMode);
                target.removeEventListener("mousemove", this.updateTooltip, isCaptureMode);
                target.removeEventListener("mouseleave", this.hideTooltip, isCaptureMode);
            }
        },
        {
            key: "getTooltipContent",
            value: function getTooltipContent() {
                var _this$props4 = this.props, getContent = _this$props4.getContent, children = _this$props4.children; // Generate tooltip content
                var content;
                if (getContent) {
                    if (Array.isArray(getContent)) content = getContent[0] && getContent[0](this.state.originTooltip);
                    else content = getContent(this.state.originTooltip);
                }
                return $82a18451bb6f6ba0$var$getTipContent(this.state.originTooltip, children, content, this.state.isMultiline);
            }
        },
        {
            key: "isEmptyTip",
            value: function isEmptyTip(placeholder) {
                return typeof placeholder === "string" && placeholder === "" || placeholder === null;
            }
        },
        {
            key: "showTooltip",
            value: function showTooltip(e, isGlobalCall) {
                if (isGlobalCall) {
                    // Don't trigger other elements belongs to other ReactTooltip
                    var targetArray = this.getTargetArray(this.props.id);
                    var isMyElement = targetArray.some(function(ele) {
                        return ele === e.currentTarget;
                    });
                    if (!isMyElement) return;
                } // Get the tooltip content
                // calculate in this phrase so that tip width height can be detected
                var _this$props5 = this.props, multiline = _this$props5.multiline, getContent = _this$props5.getContent;
                var originTooltip = e.currentTarget.getAttribute("data-tip");
                var isMultiline = e.currentTarget.getAttribute("data-multiline") || multiline || false; // If it is focus event or called by ReactTooltip.show, switch to `solid` effect
                var switchToSolid = e instanceof window.FocusEvent || isGlobalCall; // if it needs to skip adding hide listener to scroll
                var scrollHide = true;
                if (e.currentTarget.getAttribute("data-scroll-hide")) scrollHide = e.currentTarget.getAttribute("data-scroll-hide") === "true";
                else if (this.props.scrollHide != null) scrollHide = this.props.scrollHide;
                 // Make sure the correct place is set
                var desiredPlace = e.currentTarget.getAttribute("data-place") || this.props.place || "top";
                var effect = switchToSolid && "solid" || this.getEffect(e.currentTarget);
                var offset = e.currentTarget.getAttribute("data-offset") || this.props.offset || {};
                var result = $82a18451bb6f6ba0$var$getPosition(e, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
                if (result.position && this.props.overridePosition) result.position = this.props.overridePosition(result.position, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
                var place = result.isNewState ? result.newState.place : desiredPlace; // To prevent previously created timers from triggering
                this.clearTimer();
                var target = e.currentTarget;
                var reshowDelay = this.state.show ? target.getAttribute("data-delay-update") || this.props.delayUpdate : 0;
                var self = this;
                var updateState = function updateState() {
                    self.setState({
                        originTooltip: originTooltip,
                        isMultiline: isMultiline,
                        desiredPlace: desiredPlace,
                        place: place,
                        type: target.getAttribute("data-type") || self.props.type || "dark",
                        effect: effect,
                        offset: offset,
                        html: target.getAttribute("data-html") ? target.getAttribute("data-html") === "true" : self.props.html || false,
                        delayShow: target.getAttribute("data-delay-show") || self.props.delayShow || 0,
                        delayHide: target.getAttribute("data-delay-hide") || self.props.delayHide || 0,
                        delayUpdate: target.getAttribute("data-delay-update") || self.props.delayUpdate || 0,
                        border: target.getAttribute("data-border") ? target.getAttribute("data-border") === "true" : self.props.border || false,
                        extraClass: target.getAttribute("data-class") || self.props["class"] || self.props.className || "",
                        disable: target.getAttribute("data-tip-disable") ? target.getAttribute("data-tip-disable") === "true" : self.props.disable || false,
                        currentTarget: target
                    }, function() {
                        if (scrollHide) self.addScrollListener(self.state.currentTarget);
                        self.updateTooltip(e);
                        if (getContent && Array.isArray(getContent)) self.intervalUpdateContent = setInterval(function() {
                            if (self.mount) {
                                var _getContent = self.props.getContent;
                                var placeholder = $82a18451bb6f6ba0$var$getTipContent(originTooltip, "", _getContent[0](), isMultiline);
                                var isEmptyTip = self.isEmptyTip(placeholder);
                                self.setState({
                                    isEmptyTip: isEmptyTip
                                });
                                self.updatePosition();
                            }
                        }, getContent[1]);
                    });
                }; // If there is no delay call immediately, don't allow events to get in first.
                if (reshowDelay) this.delayReshow = setTimeout(updateState, reshowDelay);
                else updateState();
            }
        },
        {
            key: "updateTooltip",
            value: function updateTooltip(e) {
                var _this5 = this;
                var _this$state = this.state, delayShow = _this$state.delayShow, disable = _this$state.disable;
                var afterShow = this.props.afterShow;
                var placeholder = this.getTooltipContent();
                var delayTime = parseInt(delayShow, 10);
                var eventTarget = e.currentTarget || e.target; // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
                if (this.mouseOnToolTip()) return;
                if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip
                var updateState = function updateState() {
                    if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
                        var isInvisible = !_this5.state.show;
                        _this5.setState({
                            currentEvent: e,
                            currentTarget: eventTarget,
                            show: true
                        }, function() {
                            _this5.updatePosition();
                            if (isInvisible && afterShow) afterShow(e);
                        });
                    }
                };
                clearTimeout(this.delayShowLoop);
                if (delayShow) this.delayShowLoop = setTimeout(updateState, delayTime);
                else updateState();
            }
        },
        {
            key: "listenForTooltipExit",
            value: function listenForTooltipExit() {
                var show = this.state.show;
                if (show && this.tooltipRef) this.tooltipRef.addEventListener("mouseleave", this.hideTooltip);
            }
        },
        {
            key: "removeListenerForTooltipExit",
            value: function removeListenerForTooltipExit() {
                var show = this.state.show;
                if (show && this.tooltipRef) this.tooltipRef.removeEventListener("mouseleave", this.hideTooltip);
            }
        },
        {
            key: "hideTooltip",
            value: function hideTooltip(e, hasTarget) {
                var _this6 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
                    isScroll: false
                };
                var disable = this.state.disable;
                var isScroll = options.isScroll;
                var delayHide = isScroll ? 0 : this.state.delayHide;
                var afterHide = this.props.afterHide;
                var placeholder = this.getTooltipContent();
                if (!this.mount) return;
                if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip
                if (hasTarget) {
                    // Don't trigger other elements belongs to other ReactTooltip
                    var targetArray = this.getTargetArray(this.props.id);
                    var isMyElement = targetArray.some(function(ele) {
                        return ele === e.currentTarget;
                    });
                    if (!isMyElement || !this.state.show) return;
                }
                var resetState = function resetState() {
                    var isVisible = _this6.state.show; // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
                    if (_this6.mouseOnToolTip()) {
                        _this6.listenForTooltipExit();
                        return;
                    }
                    _this6.removeListenerForTooltipExit();
                    _this6.setState({
                        show: false
                    }, function() {
                        _this6.removeScrollListener();
                        if (isVisible && afterHide) afterHide(e);
                    });
                };
                this.clearTimer();
                if (delayHide) this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
                else resetState();
            }
        },
        {
            key: "hideTooltipOnScroll",
            value: function hideTooltipOnScroll(event, hasTarget) {
                this.hideTooltip(event, hasTarget, {
                    isScroll: true
                });
            }
        },
        {
            key: "addScrollListener",
            value: function addScrollListener(currentTarget) {
                var isCaptureMode = this.isCapture(currentTarget);
                window.addEventListener("scroll", this.hideTooltipOnScroll, isCaptureMode);
            }
        },
        {
            key: "removeScrollListener",
            value: function removeScrollListener() {
                window.removeEventListener("scroll", this.hideTooltipOnScroll);
            } // Calculation the position
        },
        {
            key: "updatePosition",
            value: function updatePosition() {
                var _this7 = this;
                var _this$state2 = this.state, currentEvent = _this$state2.currentEvent, currentTarget = _this$state2.currentTarget, place = _this$state2.place, desiredPlace = _this$state2.desiredPlace, effect = _this$state2.effect, offset = _this$state2.offset;
                var node = this.tooltipRef;
                var result = $82a18451bb6f6ba0$var$getPosition(currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
                if (result.position && this.props.overridePosition) result.position = this.props.overridePosition(result.position, currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
                if (result.isNewState) // Switch to reverse placement
                return this.setState(result.newState, function() {
                    _this7.updatePosition();
                });
                 // Set tooltip position
                node.style.left = result.position.left + "px";
                node.style.top = result.position.top + "px";
            }
        },
        {
            key: "clearTimer",
            value: function clearTimer() {
                clearTimeout(this.delayShowLoop);
                clearTimeout(this.delayHideLoop);
                clearTimeout(this.delayReshow);
                clearInterval(this.intervalUpdateContent);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this8 = this;
                var _this$state3 = this.state, extraClass = _this$state3.extraClass, html = _this$state3.html, ariaProps = _this$state3.ariaProps, disable = _this$state3.disable;
                var placeholder = this.getTooltipContent();
                var isEmptyTip = this.isEmptyTip(placeholder);
                var tooltipClass = "__react_component_tooltip" + (this.state.show && !disable && !isEmptyTip ? " show" : "") + (this.state.border ? " border" : "") + " place-".concat(this.state.place) + // top, bottom, left, right
                " type-".concat(this.state.type) + (this.props.delayUpdate ? " allow_hover" : "") + (this.props.clickable ? " allow_click" : "");
                var Wrapper = this.props.wrapper;
                if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) Wrapper = ReactTooltip.defaultProps.wrapper;
                var wrapperClassName = [
                    tooltipClass,
                    extraClass
                ].filter(Boolean).join(" ");
                if (html) return (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement(Wrapper, $82a18451bb6f6ba0$var$_extends({
                    className: wrapperClassName,
                    id: this.props.id,
                    ref: function ref(_ref) {
                        return _this8.tooltipRef = _ref;
                    }
                }, ariaProps, {
                    "data-id": "tooltip",
                    dangerouslySetInnerHTML: {
                        __html: placeholder
                    }
                }));
                else return (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement(Wrapper, $82a18451bb6f6ba0$var$_extends({
                    className: wrapperClassName,
                    id: this.props.id
                }, ariaProps, {
                    ref: function ref(_ref2) {
                        return _this8.tooltipRef = _ref2;
                    },
                    "data-id": "tooltip"
                }), placeholder);
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var ariaProps = prevState.ariaProps;
                var newAriaProps = $82a18451bb6f6ba0$var$parseAria(nextProps);
                var isChanged = Object.keys(newAriaProps).some(function(props) {
                    return newAriaProps[props] !== ariaProps[props];
                });
                if (!isChanged) return null;
                return $82a18451bb6f6ba0$var$_objectSpread2({}, prevState, {
                    ariaProps: newAriaProps
                });
            }
        }
    ]);
    return ReactTooltip;
}((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Component), $82a18451bb6f6ba0$var$_defineProperty($82a18451bb6f6ba0$var$_class2, "propTypes", {
    children: $82a18451bb6f6ba0$var$propTypes.any,
    place: $82a18451bb6f6ba0$var$propTypes.string,
    type: $82a18451bb6f6ba0$var$propTypes.string,
    effect: $82a18451bb6f6ba0$var$propTypes.string,
    offset: $82a18451bb6f6ba0$var$propTypes.object,
    multiline: $82a18451bb6f6ba0$var$propTypes.bool,
    border: $82a18451bb6f6ba0$var$propTypes.bool,
    insecure: $82a18451bb6f6ba0$var$propTypes.bool,
    "class": $82a18451bb6f6ba0$var$propTypes.string,
    className: $82a18451bb6f6ba0$var$propTypes.string,
    id: $82a18451bb6f6ba0$var$propTypes.string,
    html: $82a18451bb6f6ba0$var$propTypes.bool,
    delayHide: $82a18451bb6f6ba0$var$propTypes.number,
    delayUpdate: $82a18451bb6f6ba0$var$propTypes.number,
    delayShow: $82a18451bb6f6ba0$var$propTypes.number,
    event: $82a18451bb6f6ba0$var$propTypes.string,
    eventOff: $82a18451bb6f6ba0$var$propTypes.string,
    watchWindow: $82a18451bb6f6ba0$var$propTypes.bool,
    isCapture: $82a18451bb6f6ba0$var$propTypes.bool,
    globalEventOff: $82a18451bb6f6ba0$var$propTypes.string,
    getContent: $82a18451bb6f6ba0$var$propTypes.any,
    afterShow: $82a18451bb6f6ba0$var$propTypes.func,
    afterHide: $82a18451bb6f6ba0$var$propTypes.func,
    overridePosition: $82a18451bb6f6ba0$var$propTypes.func,
    disable: $82a18451bb6f6ba0$var$propTypes.bool,
    scrollHide: $82a18451bb6f6ba0$var$propTypes.bool,
    resizeHide: $82a18451bb6f6ba0$var$propTypes.bool,
    wrapper: $82a18451bb6f6ba0$var$propTypes.string,
    bodyMode: $82a18451bb6f6ba0$var$propTypes.bool,
    possibleCustomEvents: $82a18451bb6f6ba0$var$propTypes.string,
    possibleCustomEventsOff: $82a18451bb6f6ba0$var$propTypes.string,
    clickable: $82a18451bb6f6ba0$var$propTypes.bool
}), $82a18451bb6f6ba0$var$_defineProperty($82a18451bb6f6ba0$var$_class2, "defaultProps", {
    insecure: true,
    resizeHide: true,
    wrapper: "div",
    clickable: false
}), $82a18451bb6f6ba0$var$_defineProperty($82a18451bb6f6ba0$var$_class2, "supportedWrappers", [
    "div",
    "span"
]), $82a18451bb6f6ba0$var$_defineProperty($82a18451bb6f6ba0$var$_class2, "displayName", "ReactTooltip"), $82a18451bb6f6ba0$var$_temp)) || $82a18451bb6f6ba0$var$_class) || $82a18451bb6f6ba0$var$_class) || $82a18451bb6f6ba0$var$_class) || $82a18451bb6f6ba0$var$_class) || $82a18451bb6f6ba0$var$_class) || $82a18451bb6f6ba0$var$_class) || $82a18451bb6f6ba0$var$_class;
var $82a18451bb6f6ba0$export$2e2bcd8739ae039 = $82a18451bb6f6ba0$var$ReactTooltip;



const $8752b2e41ed956b3$var$getTooltipText = (source, sourceOverride)=>{
    const { name: name, url: url } = source;
    const sourceName = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(sourceOverride, 'name', name);
    const sourceUrl = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(sourceOverride, 'url', url);
    return `<h1>Connected to Source:</h1><p><code>${sourceName} @ ${sourceUrl}</code></p>`;
};
const $8752b2e41ed956b3$var$SourceIndicator = ({ sourceOverride: sourceOverride })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c8cd79e362cba2a4$export$5416f05742cfa18a).Consumer, null, (source)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "source-indicator",
            "data-for": "source-indicator",
            "data-tip": $8752b2e41ed956b3$var$getTooltipText(source, sourceOverride)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon disks"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $82a18451bb6f6ba0$export$2e2bcd8739ae039), {
            id: "source-indicator",
            effect: "solid",
            html: true,
            place: "left",
            class: "influx-tooltip"
        })));
};
var $8752b2e41ed956b3$export$2e2bcd8739ae039 = $8752b2e41ed956b3$var$SourceIndicator;


// Constants
const $35ce5743a0309091$var$DEFAULT_OFFSET = 0;
class $35ce5743a0309091$var$PageHeaderRight extends (0, $NdCUR.Component) {
    static{
        this.defaultProps = {
            offsetPixels: $35ce5743a0309091$var$DEFAULT_OFFSET,
            showSourceIndicator: false
        };
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "page-header--right",
            style: this.styles
        }, this.sourceIndicator, children);
    }
    get sourceIndicator() {
        const { showSourceIndicator: showSourceIndicator } = this.props;
        if (showSourceIndicator) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $8752b2e41ed956b3$export$2e2bcd8739ae039), null);
    }
    get styles() {
        const { offsetPixels: offsetPixels } = this.props;
        if (offsetPixels === $35ce5743a0309091$var$DEFAULT_OFFSET) return;
        return {
            flex: `1 0 calc(50% - ${offsetPixels}px)`
        };
    }
}
var $35ce5743a0309091$export$2e2bcd8739ae039 = $35ce5743a0309091$var$PageHeaderRight;



class $d48a9e286ff9fac5$var$PageHeader extends (0, $NdCUR.Component) {
    static{
        this.defaultProps = {
            fullWidth: false,
            inPresentationMode: false
        };
    }
    static{
        this.Title = (0, $8b5a95f66af3dc98$export$2e2bcd8739ae039);
    }
    static{
        this.Left = (0, $2a66c2d01ee443f1$export$2e2bcd8739ae039);
    }
    static{
        this.Center = (0, $e9f63e5cb2b075e1$export$2e2bcd8739ae039);
    }
    static{
        this.Right = (0, $35ce5743a0309091$export$2e2bcd8739ae039);
    }
    render() {
        const { inPresentationMode: inPresentationMode } = this.props;
        if (inPresentationMode) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.className
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "page-header--container"
        }, this.children));
    }
    get className() {
        const { fullWidth: fullWidth } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('page-header', {
            'full-width': fullWidth
        });
    }
    get children() {
        const { children: children } = this.props;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Children.count(children) === 0) throw new Error('<Page.Header> requires 1 child of each type: <Page.Header.Left> and <Page.Header.Right>');
        (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Children.forEach(children, (child)=>{
            if (!this.childTypeIsValid(child)) throw new Error('<Page.Header> expected children of type <Page.Header.Left>, <Page.Header.Center>, or <Page.Header.Right>');
        });
        let leftChildCount = 0;
        let centerChildCount = 0;
        let rightChildCount = 0;
        let centerWidthPixels = 0;
        (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Children.forEach(children, (child)=>{
            if (child.type === (0, $2a66c2d01ee443f1$export$2e2bcd8739ae039)) leftChildCount += 1;
            if (child.type === (0, $e9f63e5cb2b075e1$export$2e2bcd8739ae039)) {
                centerChildCount += 1;
                centerWidthPixels = child.props.widthPixels;
            }
            if (child.type === (0, $35ce5743a0309091$export$2e2bcd8739ae039)) rightChildCount += 1;
        });
        if (leftChildCount > 1 || centerChildCount > 1 || rightChildCount > 1) throw new Error('<Page.Header> expects at most 1 of each child type: <Page.Header.Left>, <Page.Header.Center>, or <Page.Header.Right>');
        if (leftChildCount === 0 || rightChildCount === 0) throw new Error('<Page.Header> requires 1 child of each type: <Page.Header.Left> and <Page.Header.Right>');
        if (centerWidthPixels) return (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Children.map(children, (child)=>{
            if (child.type === (0, $2a66c2d01ee443f1$export$2e2bcd8739ae039)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $2a66c2d01ee443f1$export$2e2bcd8739ae039), {
                ...child.props,
                offsetPixels: centerWidthPixels / 2
            });
            if (child.type === (0, $35ce5743a0309091$export$2e2bcd8739ae039)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $35ce5743a0309091$export$2e2bcd8739ae039), {
                ...child.props,
                offsetPixels: centerWidthPixels / 2
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $e9f63e5cb2b075e1$export$2e2bcd8739ae039), child.props);
        });
        return children;
    }
    constructor(...args){
        super(...args), this.childTypeIsValid = (child)=>child.type === (0, $2a66c2d01ee443f1$export$2e2bcd8739ae039) || child.type === (0, $e9f63e5cb2b075e1$export$2e2bcd8739ae039) || child.type === (0, $35ce5743a0309091$export$2e2bcd8739ae039);
    }
}
var $d48a9e286ff9fac5$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($d48a9e286ff9fac5$var$PageHeader);



// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");


class $30fad273fd1200e2$var$PageContents extends (0, $NdCUR.Component) {
    static{
        this.defaultProps = {
            fullWidth: false,
            scrollable: true,
            inPresentationMode: false
        };
    }
    render() {
        const { scrollable: scrollable, setScrollTop: setScrollTop, scrollTop: scrollTop, scrollLeft: scrollLeft } = this.props;
        if (scrollable) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), {
            className: this.className,
            setScrollTop: setScrollTop,
            scrollTop: scrollTop,
            scrollLeft: scrollLeft
        }, this.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.className
        }, this.children);
    }
    get children() {
        const { children: children, fullWidth: fullWidth } = this.props;
        if (fullWidth) return children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "container-fluid"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "col-md-12"
        }, children)));
    }
    get className() {
        const { fullWidth: fullWidth, inPresentationMode: inPresentationMode, className: className } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('page-contents', {
            'full-width': fullWidth,
            'presentation-mode': inPresentationMode,
            [`${className}`]: className
        });
    }
}
var $30fad273fd1200e2$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($30fad273fd1200e2$var$PageContents);



class $dad0aa542284157e$var$Page extends (0, $NdCUR.Component) {
    static{
        this.Header = (0, $d48a9e286ff9fac5$export$2e2bcd8739ae039);
    }
    static{
        this.Title = (0, $8b5a95f66af3dc98$export$2e2bcd8739ae039);
    }
    static{
        this.Contents = (0, $30fad273fd1200e2$export$2e2bcd8739ae039);
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.className
        }, this.props.children);
    }
    get className() {
        const { className: className } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('page', {
            [`${className}`]: className
        });
    }
}
var $dad0aa542284157e$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($dad0aa542284157e$var$Page);


// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");

var $hBdgJ = parcelRequire("hBdgJ");
// Libraries

var $NdCUR = parcelRequire("NdCUR");

class $13619cfc09eddd57$var$PanelHeader extends (0, $NdCUR.Component) {
    render() {
        const { children: children, title: title } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel-header"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel-title"
        }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel-controls"
        }, children));
    }
}
var $13619cfc09eddd57$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($13619cfc09eddd57$var$PanelHeader);


// Libraries

var $NdCUR = parcelRequire("NdCUR");

class $a34313f2a10b4010$var$PanelBody extends (0, $NdCUR.Component) {
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel-body"
        }, children);
    }
}
var $a34313f2a10b4010$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($a34313f2a10b4010$var$PanelBody);


// Libraries

var $NdCUR = parcelRequire("NdCUR");

class $7acdadd025d91aca$var$PanelFooter extends (0, $NdCUR.Component) {
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel-footer"
        }, children);
    }
}
var $7acdadd025d91aca$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($7acdadd025d91aca$var$PanelFooter);



var $0315f0a2a32bcd24$export$969277cf61e5a7aa = /*#__PURE__*/ function(PanelType) {
    PanelType["Default"] = "";
    PanelType["Solid"] = "solid";
    return PanelType;
}({});
class $0315f0a2a32bcd24$var$Panel extends (0, $NdCUR.Component) {
    static{
        this.defaultProps = {
            type: ""
        };
    }
    static{
        this.Header = (0, $13619cfc09eddd57$export$2e2bcd8739ae039);
    }
    static{
        this.Body = (0, $a34313f2a10b4010$export$2e2bcd8739ae039);
    }
    static{
        this.Footer = (0, $7acdadd025d91aca$export$2e2bcd8739ae039);
    }
    static{
        this.ValidChildTypes = [
            (0, $13619cfc09eddd57$export$2e2bcd8739ae039),
            (0, $a34313f2a10b4010$export$2e2bcd8739ae039),
            (0, $7acdadd025d91aca$export$2e2bcd8739ae039)
        ];
    }
    static{
        this.ValidChildNames = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).map($0315f0a2a32bcd24$var$Panel.ValidChildTypes, (child)=>{
            const name = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(child, 'displayName', '').split('Panel').pop();
            return `<Panel.${name}>`;
        }).join(', ');
    }
    render() {
        const { children: children } = this.props;
        this.validateChildren();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.className
        }, children);
    }
    get className() {
        const { type: type } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('panel', {
            'panel-solid': type === "solid"
        });
    }
    constructor(...args){
        super(...args), this.validateChildren = ()=>{
            const childArray = (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Children.toArray(this.props.children);
            if (childArray.length === 0) throw new Error('<Panel> requires at least 1 child element. We recommend using <Panel.Body>');
            const childrenAreValid = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).every(childArray, this.childTypeIsValid);
            if (!childrenAreValid) throw new Error(`<Panel> expected children of type ${$0315f0a2a32bcd24$var$Panel.ValidChildNames}`);
        }, this.childTypeIsValid = (child)=>(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).includes($0315f0a2a32bcd24$var$Panel.ValidChildTypes, child.type);
    }
}
var $0315f0a2a32bcd24$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($0315f0a2a32bcd24$var$Panel);


// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");
// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");

class $9b6bb2912632ad33$var$RadioButton extends (0, $NdCUR.Component) {
    static{
        this.defaultProps = {
            disabled: false,
            disabledTitleText: 'This option is disabled'
        };
    }
    render() {
        const { children: children, disabled: disabled } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            type: "button",
            className: this.className,
            disabled: disabled,
            onClick: this.handleClick,
            title: this.title
        }, children);
    }
    get className() {
        const { active: active, disabled: disabled } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('radio-button', {
            active: active,
            disabled: disabled
        });
    }
    get title() {
        const { titleText: titleText, disabledTitleText: disabledTitleText, disabled: disabled } = this.props;
        if (disabled) return disabledTitleText;
        return titleText;
    }
    constructor(...args){
        super(...args), this.handleClick = ()=>{
            const { onClick: onClick, value: value } = this.props;
            onClick(value);
        };
    }
}
var $9b6bb2912632ad33$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($9b6bb2912632ad33$var$RadioButton);




class $21a9fdccc7481b10$var$Radio extends (0, $NdCUR.Component) {
    static{
        this.defaultProps = {
            color: (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Default,
            size: (0, $918c9f03a35fe03f$export$fafce5c139da9687).Small,
            shape: (0, $918c9f03a35fe03f$export$ce765fb8bb08a599).Default
        };
    }
    static{
        this.Button = (0, $9b6bb2912632ad33$export$2e2bcd8739ae039);
    }
    render() {
        const { children: children } = this.props;
        this.validateChildCount();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.containerClassName
        }, (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Children.map(children, (child)=>{
            if (this.childTypeIsValid(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $9b6bb2912632ad33$export$2e2bcd8739ae039), {
                ...child.props,
                key: child.props.id
            });
            throw new Error('<Radio> expected children of type <Radio.Button />');
        }));
    }
    get containerClassName() {
        const { color: color, size: size, shape: shape, customClass: customClass } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('radio-buttons', {
            [`radio-buttons--${color}`]: color,
            [`radio-buttons--${size}`]: size,
            'radio-buttons--square': shape === (0, $918c9f03a35fe03f$export$ce765fb8bb08a599).Square,
            'radio-buttons--stretch': shape === (0, $918c9f03a35fe03f$export$ce765fb8bb08a599).StretchToFit,
            [customClass]: customClass
        });
    }
    constructor(...args){
        super(...args), this.validateChildCount = ()=>{
            const { children: children } = this.props;
            const MINIMUM_CHILD_COUNT = 2;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Children.count(children) < MINIMUM_CHILD_COUNT) throw new Error('<Radio> requires at least 2 child elements. We recommend using <Radio.Button />');
        }, this.childTypeIsValid = (child)=>child.type === (0, $9b6bb2912632ad33$export$2e2bcd8739ae039);
    }
}
var $21a9fdccc7481b10$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($21a9fdccc7481b10$var$Radio);


// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");


class $4115c6d17e8dc56b$var$SlideToggle extends (0, $NdCUR.Component) {
    static{
        this.defaultProps = {
            size: (0, $918c9f03a35fe03f$export$fafce5c139da9687).Small,
            color: (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Primary,
            tooltipText: '',
            disabled: false
        };
    }
    render() {
        const { tooltipText: tooltipText, testId: testId } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.className,
            onClick: this.handleClick,
            title: tooltipText,
            "data-test": testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "slide-toggle--knob"
        }));
    }
    get className() {
        const { size: size, color: color, disabled: disabled, active: active } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))(`slide-toggle slide-toggle-${size} slide-toggle-${color}`, {
            active: active,
            disabled: disabled
        });
    }
    constructor(...args){
        super(...args), this.handleClick = ()=>{
            const { onChange: onChange, disabled: disabled } = this.props;
            if (disabled) return;
            onChange();
        };
    }
}
var $4115c6d17e8dc56b$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($4115c6d17e8dc56b$var$SlideToggle);


// Libraries

var $NdCUR = parcelRequire("NdCUR");


class $4ee59a55fab29874$var$Spinner extends (0, $NdCUR.Component) {
    render() {
        return this.children;
    }
    get children() {
        const { loading: loading, children: children } = this.props;
        if (loading === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading || loading === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).NotStarted) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "spinner"
        });
        return children;
    }
}
var $4ee59a55fab29874$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($4ee59a55fab29874$var$Spinner);


// Libraries

var $NdCUR = parcelRequire("NdCUR");

function $ab2e782baa03cd84$export$2e2bcd8739ae039({ total: total, page: page, pageSize: pageSize = 100, onChange: onChange, diameter: diameter, width: width }) {
    if (!diameter) {
        if (!width) diameter = 4;
        else diameter = Math.trunc(Math.max(0, width - 350) / 80) * 2;
    }
    const maxPage = Math.trunc((total - 1) / pageSize);
    const radius = Math.trunc(diameter / 2);
    if (page < 0) page = 0;
    if (page > maxPage) page = maxPage;
    let startPage = Math.max(0, page - radius);
    let endPage = Math.min(page + radius, maxPage);
    // try to show at least 1+diameter page buttons
    if (endPage - startPage < diameter) startPage = Math.max(startPage - (diameter - endPage + startPage), 0);
    if (endPage - startPage < diameter) endPage = Math.min(endPage + (diameter - endPage + startPage), maxPage);
    const buttons = new Array(endPage - startPage + 1);
    for(let i = startPage; i <= endPage; i++)buttons[i] = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
        key: `page-${i}`,
        active: page === i,
        onClick: ()=>onChange(i, pageSize),
        text: String(i + 1)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        style: {
            display: 'inline-flex',
            alignItems: 'baseline',
            gap: '10px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
        className: "btn btn-sm btn-default",
        disabled: page === 0,
        onClick: ()=>onChange(Math.max(0, page - 1), pageSize),
        style: {
            minWidth: '70px'
        },
        title: "Previous Page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        className: "icon caret-left"
    }), " Prev"), startPage !== 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
        key: "page-0",
        onClick: ()=>onChange(0, pageSize),
        text: "1"
    }) : undefined, startPage > 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        style: {
            margin: '0px 10px'
        }
    }, "...") : undefined, buttons, endPage < maxPage - 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        style: {
            margin: '0px 10px'
        }
    }, "...") : undefined, endPage !== maxPage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
        key: `page-${maxPage}`,
        onClick: ()=>onChange(maxPage, pageSize),
        text: String(maxPage + 1)
    }) : undefined, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
        className: "btn btn-sm btn-default",
        disabled: page === maxPage,
        onClick: ()=>onChange(Math.min(page + 1, maxPage), pageSize),
        style: {
            minWidth: '70px'
        },
        title: "Next Page"
    }, "Next ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        className: "icon caret-right"
    })));
}







const $9860a2e9a07cf9f7$export$8239abe85d231080 = (source, timeRange, limit)=>{
    const query = `SELECT host, value, level, alertName FROM alerts WHERE time >= '${timeRange.lower}' AND time <= '${timeRange.upper}' ORDER BY time desc ${limit ? `LIMIT ${limit}` : ''}`;
    return (0, $aea829e093f1eddb$export$923f96dd5afa9ce6)({
        source: source,
        query: query,
        db: 'chronograf'
    });
};




var $hBdgJ = parcelRequire("hBdgJ");

var $axd2S = parcelRequire("axd2S");

class $f03dc95120ce491d$var$AlertsApp extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.fetchAlerts = ()=>{
            (0, $9860a2e9a07cf9f7$export$8239abe85d231080)(this.props.source.links.proxy, this.state.timeRange, this.state.limit * this.state.limitMultiplier).then((resp)=>{
                const results = [];
                const alertSeries = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(resp, [
                    'data',
                    'results',
                    '0',
                    'series'
                ], []);
                if (alertSeries.length === 0) {
                    this.setState({
                        loading: false,
                        alerts: []
                    });
                    return;
                }
                const timeIndex = alertSeries[0].columns.findIndex((col)=>col === 'time');
                const hostIndex = alertSeries[0].columns.findIndex((col)=>col === 'host');
                const valueIndex = alertSeries[0].columns.findIndex((col)=>col === 'value');
                const levelIndex = alertSeries[0].columns.findIndex((col)=>col === 'level');
                const nameIndex = alertSeries[0].columns.findIndex((col)=>col === 'alertName');
                alertSeries[0].values.forEach((s)=>{
                    results.push({
                        time: `${s[timeIndex]}`,
                        host: s[hostIndex],
                        value: `${s[valueIndex]}`,
                        level: s[levelIndex],
                        name: `${s[nameIndex]}`
                    });
                });
                // TODO: factor these setStates out to make a pure function and implement true limit & offset
                this.setState({
                    error: false,
                    loading: false,
                    alerts: results,
                    // this.state.alerts.length === results.length ||
                    isAlertsMaxedOut: results.length !== this.props.limit * this.state.limitMultiplier
                });
            }).catch((e)=>{
                this.setState({
                    error: e,
                    loading: false,
                    alerts: [],
                    isAlertsMaxedOut: false
                });
            });
        }, this.handleGetMoreAlerts = ()=>{
            this.setState({
                limitMultiplier: this.state.limitMultiplier + 1
            }, ()=>{
                this.fetchAlerts();
            });
        }, this.renderSubComponents = ()=>{
            const { source: source, isWidget: isWidget, limit: limit } = this.props;
            const { isAlertsMaxedOut: isAlertsMaxedOut, alerts: alerts, hasKapacitor: hasKapacitor, error: error } = this.state;
            if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null, error.toString()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null, "Check console logs."));
            return hasKapacitor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1734047328051b52$export$2e2bcd8739ae039), {
                limit: limit,
                source: source,
                alerts: alerts,
                shouldNotBeFilterable: isWidget,
                onGetMoreAlerts: this.handleGetMoreAlerts,
                isAlertsMaxedOut: isAlertsMaxedOut,
                alertsCount: alerts.length
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $16af25b437b7972f$export$2e2bcd8739ae039), {
                source: source
            });
        }, this.handleApplyTime = (timeRange)=>{
            this.setState({
                timeRange: timeRange
            });
        };
        const lowerInSec = props.timeRange ? (0, $6a7b0ae94f8ec28f$export$9b55ef3c660cd071).find((tr)=>tr.lower === props.timeRange.lower).seconds : undefined;
        const oneDayInSec = 86400;
        this.state = {
            loading: true,
            hasKapacitor: false,
            alerts: [],
            timeRange: {
                upper: (0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))().format(),
                lower: (0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))().subtract(lowerInSec || oneDayInSec, 'seconds').format()
            },
            limit: props.limit || 0,
            limitMultiplier: 1,
            isAlertsMaxedOut: false
        };
    }
    // TODO: show a loading screen until we figure out if there is a kapacitor and fetch the alerts
    componentDidMount() {
        const { source: source } = this.props;
        (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            url: source.links.kapacitors,
            method: 'GET'
        }).then(({ data: data })=>{
            if (data.kapacitors[0]) {
                this.setState({
                    hasKapacitor: true
                });
                this.fetchAlerts();
            } else this.setState({
                loading: false
            });
        }).catch((e)=>{
            this.setState({
                loading: false,
                error: e
            });
        });
    }
    componentDidUpdate(__, prevState) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEqual(prevState.timeRange, this.state.timeRange)) this.fetchAlerts();
    }
    render() {
        const { isWidget: isWidget, source: source } = this.props;
        const { loading: loading, timeRange: timeRange } = this.state;
        if (loading || !source) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $810ad5a94daa03b8$export$2e2bcd8739ae039), null);
        return isWidget ? this.renderSubComponents() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039), {
            className: "alert-history-page"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header.Left, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Title, {
            title: "Alert History"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header.Right, {
            showSourceIndicator: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1c72f9d52d9aedd5$export$2e2bcd8739ae039), {
            onApplyTimeRange: this.handleApplyTime,
            timeRange: timeRange
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Contents, {
            scrollable: false
        }, this.renderSubComponents()));
    }
}
var $f03dc95120ce491d$export$2e2bcd8739ae039 = (0, $c8cd79e362cba2a4$export$a520fb22fccea800)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($f03dc95120ce491d$var$AlertsApp));



var $NdCUR = parcelRequire("NdCUR");




var $NdCUR = parcelRequire("NdCUR");

var $axd2S = parcelRequire("axd2S");
const $e6b963951a14d382$var$JSONFeedReader = ({ data: data })=>data && data.items ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "newsfeed"
    }, data.items ? data.items.map(({ id: id, date_published: datePublished, url: url, title: title, authors: authors, image: image, content_text: contentText })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            key: id,
            className: "newsfeed--post"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "newsfeed--date"
        }, `${(0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(datePublished).format('MMM DD')}`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "newsfeed--post-title"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("a", {
            href: url,
            target: "_blank"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h6", null, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", null, "by ", authors.map((author)=>author.name).join(' & '))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "newsfeed--content"
        }, image ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("img", {
            src: image
        }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, contentText)))) : null) : null;
var $e6b963951a14d382$export$2e2bcd8739ae039 = $e6b963951a14d382$var$JSONFeedReader;



class $317b0261bc221791$var$NewsFeed extends (0, $NdCUR.Component) {
    render() {
        const { hasCompletedFetchOnce: hasCompletedFetchOnce, isFetching: isFetching, isFailed: isFailed, data: data } = this.props;
        if (!hasCompletedFetchOnce) return isFailed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "graph-empty"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, "Failed to load News Feed")) : // TODO: Factor this out of here and AutoRefresh
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "graph-fetching"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "graph-spinner"
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), {
            autoHide: false,
            className: "newsfeed--container"
        }, isFetching ? // TODO: Factor this out of here and AutoRefresh
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "graph-panel__refreshing"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null)) : null, isFailed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "graph-empty"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, "Failed to refresh News Feed")) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $e6b963951a14d382$export$2e2bcd8739ae039), {
            data: data
        }));
    }
    // TODO: implement interval polling a la AutoRefresh
    componentDidMount() {
        const { statusFeedURL: statusFeedURL, fetchJSONFeed: fetchJSONFeed } = this.props;
        fetchJSONFeed(statusFeedURL);
    }
}
const $317b0261bc221791$var$mstp = ({ links: { external: { statusFeed: statusFeedURL } }, JSONFeed: { hasCompletedFetchOnce: hasCompletedFetchOnce, isFetching: isFetching, isFailed: isFailed, data: data } })=>({
        hasCompletedFetchOnce: hasCompletedFetchOnce,
        isFetching: isFetching,
        isFailed: isFailed,
        data: data,
        statusFeedURL: statusFeedURL
    });
const $317b0261bc221791$var$mdtp = {
    fetchJSONFeed: (0, $e92b489e10597290$export$7a9dc19a21a25eb3)
};
var $317b0261bc221791$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($317b0261bc221791$var$mstp, $317b0261bc221791$var$mdtp)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($317b0261bc221791$var$NewsFeed));



var $NdCUR = parcelRequire("NdCUR");


class $7f4b333717849c04$var$GettingStarted extends (0, $NdCUR.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), {
            className: "getting-started--container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "getting-started"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "getting-started--cell intro"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h5", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon cubo-uniform"
        }), " Welcome to Chronograf!"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, "Follow the links below to explore Chronograf\u2019s features.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "getting-started--cell"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("strong", null, "Install the TICK Stack"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("br", null), "Save some time and use this handy tool to install the rest of the stack:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("a", {
            href: "https://github.com/influxdata/sandbox",
            target: "_blank"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon github"
        }), " TICK Sandbox"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "getting-started--cell"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("strong", null, "Guides")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("a", {
            href: "https://docs.influxdata.com/chronograf/latest/guides/create-a-dashboard/",
            target: "_blank"
        }, "Create a Dashboard"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("a", {
            href: "https://docs.influxdata.com/chronograf/latest/guides/create-a-kapacitor-alert/",
            target: "_blank"
        }, "Create a Kapacitor Alert"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("a", {
            href: "https://docs.influxdata.com/chronograf/latest/guides/configure-kapacitor-event-handlers/",
            target: "_blank"
        }, "Configure Kapacitor Event Handlers"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("a", {
            href: "https://docs.influxdata.com/chronograf/latest/guides/transition-web-admin-interface/",
            target: "_blank"
        }, "Transition from InfluxDB's Web Admin Interface"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("a", {
            href: "https://docs.influxdata.com/chronograf/latest/guides/dashboard-template-variables/",
            target: "_blank"
        }, "Dashboard Template Variables"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("a", {
            href: "https://docs.influxdata.com/chronograf/latest/guides/advanced-kapacitor/",
            target: "_blank"
        }, "Advanced Kapacitor Usage"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "getting-started--cell"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("strong", null, "Questions & Comments")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, "If you have any product feedback please open a GitHub issue and we'll take a look. For any questions or other issues try posting on our\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("a", {
            href: "https://community.influxdata.com/",
            target: "_blank"
        }, "Community Forum"), "."))));
    }
}
var $7f4b333717849c04$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($7f4b333717849c04$var$GettingStarted);


const $422903df42856977$export$384bf9fba2f41db = 30;


const $23793b77a5ad447d$var$WidgetCell = ({ cell: cell, source: source, timeRange: timeRange })=>{
    switch(cell.type){
        case 'alerts':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $f03dc95120ce491d$export$2e2bcd8739ae039), {
                source: source,
                timeRange: timeRange,
                isWidget: true,
                limit: (0, $422903df42856977$export$384bf9fba2f41db)
            });
        case 'news':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $317b0261bc221791$export$2e2bcd8739ae039), null);
        case 'guide':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7f4b333717849c04$export$2e2bcd8739ae039), null);
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                className: "graph-empty"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", {
                "data-test": "data-explorer-no-results"
            }, "Nothing to show"));
    }
};
var $23793b77a5ad447d$export$2e2bcd8739ae039 = $23793b77a5ad447d$var$WidgetCell;



var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");


var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");

var $NdCUR = parcelRequire("NdCUR");


var $1v7mg = parcelRequire("1v7mg");

class $c802404e96f3c2c9$var$MenuTooltipButton extends (0, $NdCUR.Component) {
    static{
        this.defaultProps = {
            theme: 'default'
        };
    }
    constructor(props){
        super(props), this.handleButtonClick = ()=>{
            const { informParent: informParent } = this.props;
            this.setState({
                expanded: !this.state.expanded
            });
            informParent();
        }, this.handleMenuItemClick = (action)=>()=>{
                const { informParent: informParent } = this.props;
                this.setState({
                    expanded: false
                });
                action();
                informParent();
            }, this.handleClickOutside = ()=>{
            const { informParent: informParent } = this.props;
            const { expanded: expanded } = this.state;
            if (expanded === false) return;
            this.setState({
                expanded: false
            });
            informParent();
        };
        this.state = {
            expanded: false
        };
    }
    render() {
        const { expanded: expanded } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1f11d3536bc98f8a$export$c16e4f034c84cb3f), {
            onClickOutside: this.handleClickOutside
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.className,
            onClick: this.handleButtonClick
        }, this.icon, expanded && this.renderMenu));
    }
    get className() {
        const { expanded: expanded } = this.state;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('dash-graph-context--button', {
            active: expanded
        });
    }
    get icon() {
        const { icon: icon } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: `icon ${icon}`
        });
    }
    get renderMenu() {
        const { menuItems: menuItems, theme: theme } = this.props;
        const { expanded: expanded } = this.state;
        if (expanded === false) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: `dash-graph-context--menu ${theme}`
        }, menuItems.map((option, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                key: i,
                className: `dash-graph-context--menu-item${option.disabled ? ' disabled' : ''}`,
                onClick: option.disabled ? null : this.handleMenuItemClick(option.action)
            }, option.text)));
    }
}
var $c802404e96f3c2c9$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($c802404e96f3c2c9$var$MenuTooltipButton);



var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");

const $0c9b423cc219ec01$var$CustomTimeIndicator = ({ queries: queries })=>{
    const q = queries.find((query)=>(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(query, 'text', '').includes((0, $e10a8602f56394e3$export$24969386fef72130)) === false);
    const customLower = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(q, [
        'queryConfig',
        'range',
        'lower'
    ], null);
    const customUpper = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(q, [
        'queryConfig',
        'range',
        'upper'
    ], null);
    if (!customLower) return null;
    const customTimeRange = customUpper ? `${customLower} AND ${customUpper}` : customLower;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        className: "custom-indicator"
    }, customTimeRange);
};
var $0c9b423cc219ec01$export$2e2bcd8739ae039 = $0c9b423cc219ec01$var$CustomTimeIndicator;





class $f7d656b1dd08c61a$var$LayoutCellMenu extends (0, $NdCUR.Component) {
    constructor(props){
        super(props), this.handleEditCell = ()=>{
            const { onEdit: onEdit } = this.props;
            onEdit();
        }, this.handleDeleteCell = ()=>{
            const { onDelete: onDelete, cell: cell } = this.props;
            onDelete(cell);
        }, this.handleCloneCell = ()=>{
            const { onClone: onClone, cell: cell } = this.props;
            onClone(cell);
        }, this.handleToggleSubMenu = ()=>{
            this.setState({
                subMenuIsOpen: !this.state.subMenuIsOpen
            });
        };
        this.state = {
            subMenuIsOpen: false
        };
    }
    render() {
        const { queries: queries } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.contextMenuClassname
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.customIndicatorsClassname
        }, queries && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $0c9b423cc219ec01$export$2e2bcd8739ae039), {
            queries: queries
        })), this.renderMenu);
    }
    get renderMenu() {
        const { isEditable: isEditable } = this.props;
        if (!isEditable) return;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "dash-graph-context--buttons"
        }, this.pencilMenu, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $091cfcd49e339acd$export$2e2bcd8739ae039), {
            requiredRole: (0, $a7910b1002260d34$export$f715f7e27dea2abf)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c802404e96f3c2c9$export$2e2bcd8739ae039), {
            icon: "duplicate",
            menuItems: this.cloneMenuItems,
            informParent: this.handleToggleSubMenu
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c802404e96f3c2c9$export$2e2bcd8739ae039), {
            icon: "trash",
            theme: "danger",
            menuItems: this.deleteMenuItems,
            informParent: this.handleToggleSubMenu
        }));
    }
    get pencilMenu() {
        const { queries: queries } = this.props;
        if (!queries.length) return;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c802404e96f3c2c9$export$2e2bcd8739ae039), {
            icon: "pencil",
            menuItems: this.editMenuItems,
            informParent: this.handleToggleSubMenu
        });
    }
    get contextMenuClassname() {
        const { subMenuIsOpen: subMenuIsOpen } = this.state;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('dash-graph-context', {
            'dash-graph-context__open': subMenuIsOpen
        });
    }
    get customIndicatorsClassname() {
        const { isEditable: isEditable } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('dash-graph--custom-indicators', {
            'dash-graph--draggable': isEditable
        });
    }
    get editMenuItems() {
        const { dataExists: dataExists, onCSVDownload: onCSVDownload, toggleVisType: toggleVisType, visType: visType, isFluxQuery: isFluxQuery } = this.props;
        const visTypeItem = {
            text: 'View Raw Data',
            action: toggleVisType,
            disabled: false
        };
        if (visType === (0, $bf3dd750ec7dcb0a$export$9f8d0c19ebdb3c7c).Table) visTypeItem.text = 'View Visualization';
        const menuItems = [
            {
                text: 'Configure',
                action: this.handleEditCell,
                disabled: false
            },
            {
                text: 'Download CSV',
                action: onCSVDownload,
                disabled: !dataExists
            }
        ];
        if (isFluxQuery) menuItems.push(visTypeItem);
        return menuItems;
    }
    get cloneMenuItems() {
        return [
            {
                text: 'Clone Cell',
                action: this.handleCloneCell,
                disabled: false
            }
        ];
    }
    get deleteMenuItems() {
        return [
            {
                text: 'Confirm',
                action: this.handleDeleteCell,
                disabled: false
            }
        ];
    }
}
var $f7d656b1dd08c61a$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($f7d656b1dd08c61a$var$LayoutCellMenu);



var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");

var $gmCTX = parcelRequire("gmCTX");



class $3745f30dfc5d7c7d$var$LayoutCellHeader extends (0, $NdCUR.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.headingClass
        }, this.cellName, this.headingBar);
    }
    get headingClass() {
        const { isEditable: isEditable } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('dash-graph--heading', {
            'dash-graph--draggable': isEditable,
            'dash-graph--heading-draggable': isEditable
        });
    }
    get cellName() {
        const { cellName: cellName, makeSpaceForCellNote: makeSpaceForCellNote, cellTextColor: cellTextColor, cellBackgroundColor: cellBackgroundColor } = this.props;
        const className = (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('dash-graph--name', {
            'dash-graph--name__default': (0, $0ece195804443aff$export$ec617d9f902318c7)(cellName),
            'dash-graph--name__note': makeSpaceForCellNote
        });
        let nameStyle = {};
        if (cellBackgroundColor !== (0, $9a9ec629fdd38845$export$bd9dc338f9c12ec3)) nameStyle = {
            color: cellTextColor
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: className,
            style: nameStyle
        }, cellName);
    }
    get headingBar() {
        const { isEditable: isEditable, cellBackgroundColor: cellBackgroundColor } = this.props;
        if (isEditable) {
            let barStyle;
            if (cellBackgroundColor !== (0, $9a9ec629fdd38845$export$bd9dc338f9c12ec3)) barStyle = {
                backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($gmCTX)))(cellBackgroundColor).brighten()
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                className: "dash-graph--heading-bar",
                style: barStyle
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                className: "dash-graph--heading-dragger"
            }));
        }
    }
}
var $3745f30dfc5d7c7d$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($3745f30dfc5d7c7d$var$LayoutCellHeader);


// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");
var $ff69c7c0605f9fd2$exports = {};
'use strict';

var $NdCUR = parcelRequire("NdCUR");
var $e854e354124f8583$exports = {};
'use strict';

$e854e354124f8583$exports = (parcelRequire("eocIy"));


var $b9ae0a596083e0cf$exports = {};
'use strict';
var $2522dace72d97abe$exports = {};
'use strict';
$2522dace72d97abe$exports = $2522dace72d97abe$var$bail;
function $2522dace72d97abe$var$bail(err) {
    if (err) throw err;
}



var $cQ3eS = parcelRequire("cQ3eS");
var $e5eeb404797f0d66$exports = {};
'use strict';
var $e5eeb404797f0d66$var$hasOwn = Object.prototype.hasOwnProperty;
var $e5eeb404797f0d66$var$toStr = Object.prototype.toString;
var $e5eeb404797f0d66$var$defineProperty = Object.defineProperty;
var $e5eeb404797f0d66$var$gOPD = Object.getOwnPropertyDescriptor;
var $e5eeb404797f0d66$var$isArray = function isArray(arr) {
    if (typeof Array.isArray === 'function') return Array.isArray(arr);
    return $e5eeb404797f0d66$var$toStr.call(arr) === '[object Array]';
};
var $e5eeb404797f0d66$var$isPlainObject = function isPlainObject(obj) {
    if (!obj || $e5eeb404797f0d66$var$toStr.call(obj) !== '[object Object]') return false;
    var hasOwnConstructor = $e5eeb404797f0d66$var$hasOwn.call(obj, 'constructor');
    var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && $e5eeb404797f0d66$var$hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
    // Not own constructor property must be Object
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) return false;
    // Own properties are enumerated firstly, so to speed up,
    // if last one is own, then all properties are own.
    var key;
    for(key in obj);
    return typeof key === 'undefined' || $e5eeb404797f0d66$var$hasOwn.call(obj, key);
};
// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var $e5eeb404797f0d66$var$setProperty = function setProperty(target, options) {
    if ($e5eeb404797f0d66$var$defineProperty && options.name === '__proto__') $e5eeb404797f0d66$var$defineProperty(target, options.name, {
        enumerable: true,
        configurable: true,
        value: options.newValue,
        writable: true
    });
    else target[options.name] = options.newValue;
};
// Return undefined instead of __proto__ if '__proto__' is not an own property
var $e5eeb404797f0d66$var$getProperty = function getProperty(obj, name) {
    if (name === '__proto__') {
        if (!$e5eeb404797f0d66$var$hasOwn.call(obj, name)) return void 0;
        else if ($e5eeb404797f0d66$var$gOPD) // In early versions of node, obj['__proto__'] is buggy when obj has
        // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
        return $e5eeb404797f0d66$var$gOPD(obj, name).value;
    }
    return obj[name];
};
$e5eeb404797f0d66$exports = function extend() {
    var options, name, src, copy, copyIsArray, clone;
    var target = arguments[0];
    var i = 1;
    var length = arguments.length;
    var deep = false;
    // Handle a deep copy situation
    if (typeof target === 'boolean') {
        deep = target;
        target = arguments[1] || {};
        // skip the boolean and the target
        i = 2;
    }
    if (target == null || typeof target !== 'object' && typeof target !== 'function') target = {};
    for(; i < length; ++i){
        options = arguments[i];
        // Only deal with non-null/undefined values
        if (options != null) // Extend the base object
        for(name in options){
            src = $e5eeb404797f0d66$var$getProperty(target, name);
            copy = $e5eeb404797f0d66$var$getProperty(options, name);
            // Prevent never-ending loop
            if (target !== copy) {
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && ($e5eeb404797f0d66$var$isPlainObject(copy) || (copyIsArray = $e5eeb404797f0d66$var$isArray(copy)))) {
                    if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && $e5eeb404797f0d66$var$isArray(src) ? src : [];
                    } else clone = src && $e5eeb404797f0d66$var$isPlainObject(src) ? src : {};
                    // Never move original objects, clone them
                    $e5eeb404797f0d66$var$setProperty(target, {
                        name: name,
                        newValue: extend(deep, clone, copy)
                    });
                // Don't bring in undefined values
                } else if (typeof copy !== 'undefined') $e5eeb404797f0d66$var$setProperty(target, {
                    name: name,
                    newValue: copy
                });
            }
        }
    }
    // Return the modified object
    return target;
};


var $9ee89d30c62ebb49$exports = {};
'use strict';
$9ee89d30c62ebb49$exports = (value)=>{
    if (Object.prototype.toString.call(value) !== '[object Object]') return false;
    const prototype = Object.getPrototypeOf(value);
    return prototype === null || prototype === Object.prototype;
};


var $18617fc1938d5a2b$exports = {};
'use strict';
var $e8c25dc86fbd52c3$exports = {};
'use strict';
var $e8c25dc86fbd52c3$var$slice = [].slice;
$e8c25dc86fbd52c3$exports = $e8c25dc86fbd52c3$var$wrap;
// Wrap `fn`.
// Can be sync or async; return a promise, receive a completion handler, return
// new values and errors.
function $e8c25dc86fbd52c3$var$wrap(fn, callback) {
    var invoked;
    return wrapped;
    function wrapped() {
        var params = $e8c25dc86fbd52c3$var$slice.call(arguments, 0);
        var callback = fn.length > params.length;
        var result;
        if (callback) params.push(done);
        try {
            result = fn.apply(null, params);
        } catch (error) {
            // Well, this is quite the pickle.
            // `fn` received a callback and invoked it (thus continuing the pipeline),
            // but later also threw an error.
            // We’re not about to restart the pipeline again, so the only thing left
            // to do is to throw the thing instead.
            if (callback && invoked) throw error;
            return done(error);
        }
        if (!callback) {
            if (result && typeof result.then === 'function') result.then(then, done);
            else if (result instanceof Error) done(result);
            else then(result);
        }
    }
    // Invoke `next`, only once.
    function done() {
        if (!invoked) {
            invoked = true;
            callback.apply(null, arguments);
        }
    }
    // Invoke `done` with one value.
    // Tracks if an error is passed, too.
    function then(value) {
        done(null, value);
    }
}


$18617fc1938d5a2b$exports = $18617fc1938d5a2b$var$trough;
$18617fc1938d5a2b$var$trough.wrap = $e8c25dc86fbd52c3$exports;
var $18617fc1938d5a2b$var$slice = [].slice;
// Create new middleware.
function $18617fc1938d5a2b$var$trough() {
    var fns = [];
    var middleware = {};
    middleware.run = run;
    middleware.use = use;
    return middleware;
    // Run `fns`.  Last argument must be a completion handler.
    function run() {
        var index = -1;
        var input = $18617fc1938d5a2b$var$slice.call(arguments, 0, -1);
        var done = arguments[arguments.length - 1];
        if (typeof done !== 'function') throw new Error('Expected function as last argument, not ' + done);
        next.apply(null, [
            null
        ].concat(input));
        // Run the next `fn`, if any.
        function next(err) {
            var fn = fns[++index];
            var params = $18617fc1938d5a2b$var$slice.call(arguments, 0);
            var values = params.slice(1);
            var length = input.length;
            var pos = -1;
            if (err) {
                done(err);
                return;
            }
            // Copy non-nully input into values.
            while(++pos < length)if (values[pos] === null || values[pos] === undefined) values[pos] = input[pos];
            input = values;
            // Next or done.
            if (fn) $e8c25dc86fbd52c3$exports(fn, next).apply(null, input);
            else done.apply(null, [
                null
            ].concat(input));
        }
    }
    // Add `fn` to the list.
    function use(fn) {
        if (typeof fn !== 'function') throw new Error('Expected `fn` to be a function, not ' + fn);
        fns.push(fn);
        return middleware;
    }
}



// Expose a frozen processor.
$b9ae0a596083e0cf$exports = $b9ae0a596083e0cf$var$unified().freeze();
var $b9ae0a596083e0cf$var$slice = [].slice;
var $b9ae0a596083e0cf$var$own = {}.hasOwnProperty;
// Process pipeline.
var $b9ae0a596083e0cf$var$pipeline = $18617fc1938d5a2b$exports().use($b9ae0a596083e0cf$var$pipelineParse).use($b9ae0a596083e0cf$var$pipelineRun).use($b9ae0a596083e0cf$var$pipelineStringify);
function $b9ae0a596083e0cf$var$pipelineParse(p, ctx) {
    ctx.tree = p.parse(ctx.file);
}
function $b9ae0a596083e0cf$var$pipelineRun(p, ctx, next) {
    p.run(ctx.tree, ctx.file, done);
    function done(error, tree, file) {
        if (error) next(error);
        else {
            ctx.tree = tree;
            ctx.file = file;
            next();
        }
    }
}
function $b9ae0a596083e0cf$var$pipelineStringify(p, ctx) {
    var result = p.stringify(ctx.tree, ctx.file);
    if (result === undefined || result === null) ;
    else if (typeof result === 'string' || $cQ3eS(result)) {
        if ('value' in ctx.file) ctx.file.value = result;
        ctx.file.contents = result;
    } else ctx.file.result = result;
}
// Function to create the first processor.
function $b9ae0a596083e0cf$var$unified() {
    var attachers = [];
    var transformers = $18617fc1938d5a2b$exports();
    var namespace = {};
    var freezeIndex = -1;
    var frozen;
    // Data management.
    processor.data = data;
    // Lock.
    processor.freeze = freeze;
    // Plugins.
    processor.attachers = attachers;
    processor.use = use;
    // API.
    processor.parse = parse;
    processor.stringify = stringify;
    processor.run = run;
    processor.runSync = runSync;
    processor.process = process;
    processor.processSync = processSync;
    // Expose.
    return processor;
    // Create a new processor based on the processor in the current scope.
    function processor() {
        var destination = $b9ae0a596083e0cf$var$unified();
        var index = -1;
        while(++index < attachers.length)destination.use.apply(null, attachers[index]);
        destination.data($e5eeb404797f0d66$exports(true, {}, namespace));
        return destination;
    }
    // Freeze: used to signal a processor that has finished configuration.
    //
    // For example, take unified itself: it’s frozen.
    // Plugins should not be added to it.
    // Rather, it should be extended, by invoking it, before modifying it.
    //
    // In essence, always invoke this when exporting a processor.
    function freeze() {
        var values;
        var transformer;
        if (frozen) return processor;
        while(++freezeIndex < attachers.length){
            values = attachers[freezeIndex];
            if (values[1] === false) continue;
            if (values[1] === true) values[1] = undefined;
            transformer = values[0].apply(processor, values.slice(1));
            if (typeof transformer === 'function') transformers.use(transformer);
        }
        frozen = true;
        freezeIndex = Infinity;
        return processor;
    }
    // Data management.
    // Getter / setter for processor-specific informtion.
    function data(key, value) {
        if (typeof key === 'string') {
            // Set `key`.
            if (arguments.length === 2) {
                $b9ae0a596083e0cf$var$assertUnfrozen('data', frozen);
                namespace[key] = value;
                return processor;
            }
            // Get `key`.
            return $b9ae0a596083e0cf$var$own.call(namespace, key) && namespace[key] || null;
        }
        // Set space.
        if (key) {
            $b9ae0a596083e0cf$var$assertUnfrozen('data', frozen);
            namespace = key;
            return processor;
        }
        // Get space.
        return namespace;
    }
    // Plugin management.
    //
    // Pass it:
    // *   an attacher and options,
    // *   a preset,
    // *   a list of presets, attachers, and arguments (list of attachers and
    //     options).
    function use(value) {
        var settings;
        $b9ae0a596083e0cf$var$assertUnfrozen('use', frozen);
        if (value === null || value === undefined) ;
        else if (typeof value === 'function') addPlugin.apply(null, arguments);
        else if (typeof value === 'object') {
            if ('length' in value) addList(value);
            else addPreset(value);
        } else throw new Error('Expected usable value, not `' + value + '`');
        if (settings) namespace.settings = $e5eeb404797f0d66$exports(namespace.settings || {}, settings);
        return processor;
        function addPreset(result) {
            addList(result.plugins);
            if (result.settings) settings = $e5eeb404797f0d66$exports(settings || {}, result.settings);
        }
        function add(value) {
            if (typeof value === 'function') addPlugin(value);
            else if (typeof value === 'object') {
                if ('length' in value) addPlugin.apply(null, value);
                else addPreset(value);
            } else throw new Error('Expected usable value, not `' + value + '`');
        }
        function addList(plugins) {
            var index = -1;
            if (plugins === null || plugins === undefined) ;
            else if (typeof plugins === 'object' && 'length' in plugins) while(++index < plugins.length)add(plugins[index]);
            else throw new Error('Expected a list of plugins, not `' + plugins + '`');
        }
        function addPlugin(plugin, value) {
            var entry = find(plugin);
            if (entry) {
                if ($9ee89d30c62ebb49$exports(entry[1]) && $9ee89d30c62ebb49$exports(value)) value = $e5eeb404797f0d66$exports(true, entry[1], value);
                entry[1] = value;
            } else attachers.push($b9ae0a596083e0cf$var$slice.call(arguments));
        }
    }
    function find(plugin) {
        var index = -1;
        while(++index < attachers.length){
            if (attachers[index][0] === plugin) return attachers[index];
        }
    }
    // Parse a file (in string or vfile representation) into a unist node using
    // the `Parser` on the processor.
    function parse(doc) {
        var file = $e854e354124f8583$exports(doc);
        var Parser;
        freeze();
        Parser = processor.Parser;
        $b9ae0a596083e0cf$var$assertParser('parse', Parser);
        if ($b9ae0a596083e0cf$var$newable(Parser, 'parse')) return new Parser(String(file), file).parse();
        return Parser(String(file), file) // eslint-disable-line new-cap
        ;
    }
    // Run transforms on a unist node representation of a file (in string or
    // vfile representation), async.
    function run(node, file, cb) {
        $b9ae0a596083e0cf$var$assertNode(node);
        freeze();
        if (!cb && typeof file === 'function') {
            cb = file;
            file = null;
        }
        if (!cb) return new Promise(executor);
        executor(null, cb);
        function executor(resolve, reject) {
            transformers.run(node, $e854e354124f8583$exports(file), done);
            function done(error, tree, file) {
                tree = tree || node;
                if (error) reject(error);
                else if (resolve) resolve(tree);
                else cb(null, tree, file);
            }
        }
    }
    // Run transforms on a unist node representation of a file (in string or
    // vfile representation), sync.
    function runSync(node, file) {
        var result;
        var complete;
        run(node, file, done);
        $b9ae0a596083e0cf$var$assertDone('runSync', 'run', complete);
        return result;
        function done(error, tree) {
            complete = true;
            result = tree;
            $2522dace72d97abe$exports(error);
        }
    }
    // Stringify a unist node representation of a file (in string or vfile
    // representation) into a string using the `Compiler` on the processor.
    function stringify(node, doc) {
        var file = $e854e354124f8583$exports(doc);
        var Compiler;
        freeze();
        Compiler = processor.Compiler;
        $b9ae0a596083e0cf$var$assertCompiler('stringify', Compiler);
        $b9ae0a596083e0cf$var$assertNode(node);
        if ($b9ae0a596083e0cf$var$newable(Compiler, 'compile')) return new Compiler(node, file).compile();
        return Compiler(node, file) // eslint-disable-line new-cap
        ;
    }
    // Parse a file (in string or vfile representation) into a unist node using
    // the `Parser` on the processor, then run transforms on that node, and
    // compile the resulting node using the `Compiler` on the processor, and
    // store that result on the vfile.
    function process(doc, cb) {
        freeze();
        $b9ae0a596083e0cf$var$assertParser('process', processor.Parser);
        $b9ae0a596083e0cf$var$assertCompiler('process', processor.Compiler);
        if (!cb) return new Promise(executor);
        executor(null, cb);
        function executor(resolve, reject) {
            var file = $e854e354124f8583$exports(doc);
            $b9ae0a596083e0cf$var$pipeline.run(processor, {
                file: file
            }, done);
            function done(error) {
                if (error) reject(error);
                else if (resolve) resolve(file);
                else cb(null, file);
            }
        }
    }
    // Process the given document (in string or vfile representation), sync.
    function processSync(doc) {
        var file;
        var complete;
        freeze();
        $b9ae0a596083e0cf$var$assertParser('processSync', processor.Parser);
        $b9ae0a596083e0cf$var$assertCompiler('processSync', processor.Compiler);
        file = $e854e354124f8583$exports(doc);
        process(file, done);
        $b9ae0a596083e0cf$var$assertDone('processSync', 'process', complete);
        return file;
        function done(error) {
            complete = true;
            $2522dace72d97abe$exports(error);
        }
    }
}
// Check if `value` is a constructor.
function $b9ae0a596083e0cf$var$newable(value, name) {
    return typeof value === 'function' && value.prototype && // A function with keys in its prototype is probably a constructor.
    // Classes’ prototype methods are not enumerable, so we check if some value
    // exists in the prototype.
    ($b9ae0a596083e0cf$var$keys(value.prototype) || name in value.prototype);
}
// Check if `value` is an object with keys.
function $b9ae0a596083e0cf$var$keys(value) {
    var key;
    for(key in value)return true;
    return false;
}
// Assert a parser is available.
function $b9ae0a596083e0cf$var$assertParser(name, Parser) {
    if (typeof Parser !== 'function') throw new Error('Cannot `' + name + '` without `Parser`');
}
// Assert a compiler is available.
function $b9ae0a596083e0cf$var$assertCompiler(name, Compiler) {
    if (typeof Compiler !== 'function') throw new Error('Cannot `' + name + '` without `Compiler`');
}
// Assert the processor is not frozen.
function $b9ae0a596083e0cf$var$assertUnfrozen(name, frozen) {
    if (frozen) throw new Error('Cannot invoke `' + name + '` on a frozen processor.\nCreate a new processor first, by invoking it: use `processor()` instead of `processor`.');
}
// Assert `node` is a unist node.
function $b9ae0a596083e0cf$var$assertNode(node) {
    if (!node || typeof node.type !== 'string') throw new Error('Expected node, got `' + node + '`');
}
// Assert that `complete` is `true`.
function $b9ae0a596083e0cf$var$assertDone(name, asyncName, complete) {
    if (!complete) throw new Error('`' + name + '` finished async. Use `' + asyncName + '` instead');
}


var $5531e72d137601a5$exports = {};
'use strict';
$5531e72d137601a5$exports = $5531e72d137601a5$var$parse;
var $3fbfc0cc794063a5$exports = {};
'use strict';

$3fbfc0cc794063a5$exports = (parcelRequire("5BMBa"));


function $5531e72d137601a5$var$parse(options) {
    var self = this;
    this.Parser = parse;
    function parse(doc) {
        return $3fbfc0cc794063a5$exports(doc, Object.assign({}, self.data('settings'), options, {
            // Note: these options are not in the readme.
            // The goal is for them to be set by plugins on `data` instead of being
            // passed by users.
            extensions: self.data('micromarkExtensions') || [],
            mdastExtensions: self.data('fromMarkdownExtensions') || []
        }));
    }
}


var $65b30ef505dd219f$exports = {};
'use strict';
var $d522e2f9692ec3a3$exports = {};
'use strict';

$d522e2f9692ec3a3$exports = (parcelRequire("6xjLC"));


$65b30ef505dd219f$exports = $65b30ef505dd219f$var$remark2rehype;
// Attacher.
// If a destination is given, runs the destination with the new hast tree
// (bridge mode).
// Without destination, returns the tree: further plugins run on that tree
// (mutate mode).
function $65b30ef505dd219f$var$remark2rehype(destination, options) {
    if (destination && !destination.process) {
        options = destination;
        destination = null;
    }
    return destination ? $65b30ef505dd219f$var$bridge(destination, options) : $65b30ef505dd219f$var$mutate(options);
}
// Bridge mode.
// Runs the destination with the new hast tree.
function $65b30ef505dd219f$var$bridge(destination, options) {
    return transformer;
    function transformer(node, file, next) {
        destination.run($d522e2f9692ec3a3$exports(node, options), file, done);
        function done(error) {
            next(error);
        }
    }
}
// Mutate-mode.
// Further transformers run on the hast tree.
function $65b30ef505dd219f$var$mutate(options) {
    return transformer;
    function transformer(node) {
        return $d522e2f9692ec3a3$exports(node, options);
    }
}



var $fGw9V = parcelRequire("fGw9V");
var $0313be7775ad9c20$exports = {};
'use strict';
var $7c4a581dd783fc4a$exports = {};
'use strict';

var $br7jT = parcelRequire("br7jT");
var $9c36b662a64fa45d$exports = {};
'use strict';
$9c36b662a64fa45d$exports = $9c36b662a64fa45d$var$Schema;
var $9c36b662a64fa45d$var$proto = $9c36b662a64fa45d$var$Schema.prototype;
$9c36b662a64fa45d$var$proto.space = null;
$9c36b662a64fa45d$var$proto.normal = {};
$9c36b662a64fa45d$var$proto.property = {};
function $9c36b662a64fa45d$var$Schema(property, normal, space) {
    this.property = property;
    this.normal = normal;
    if (space) this.space = space;
}


$7c4a581dd783fc4a$exports = $7c4a581dd783fc4a$var$merge;
function $7c4a581dd783fc4a$var$merge(definitions) {
    var length = definitions.length;
    var property = [];
    var normal = [];
    var index = -1;
    var info;
    var space;
    while(++index < length){
        info = definitions[index];
        property.push(info.property);
        normal.push(info.normal);
        space = info.space;
    }
    return new $9c36b662a64fa45d$exports($br7jT.apply(null, property), $br7jT.apply(null, normal), space);
}


var $9497ebe8dc3e435e$exports = {};
'use strict';
var $797ab05b7fef13a4$exports = {};
'use strict';
var $0f0b16c99e5d1bbf$exports = {};
'use strict';
$0f0b16c99e5d1bbf$exports = $0f0b16c99e5d1bbf$var$normalize;
function $0f0b16c99e5d1bbf$var$normalize(value) {
    return value.toLowerCase();
}



var $3450a939bd5d1c44$exports = {};
'use strict';
var $e40260d1629313c0$exports = {};
'use strict';
$e40260d1629313c0$exports = $e40260d1629313c0$var$Info;
var $e40260d1629313c0$var$proto = $e40260d1629313c0$var$Info.prototype;
$e40260d1629313c0$var$proto.space = null;
$e40260d1629313c0$var$proto.attribute = null;
$e40260d1629313c0$var$proto.property = null;
$e40260d1629313c0$var$proto.boolean = false;
$e40260d1629313c0$var$proto.booleanish = false;
$e40260d1629313c0$var$proto.overloadedBoolean = false;
$e40260d1629313c0$var$proto.number = false;
$e40260d1629313c0$var$proto.commaSeparated = false;
$e40260d1629313c0$var$proto.spaceSeparated = false;
$e40260d1629313c0$var$proto.commaOrSpaceSeparated = false;
$e40260d1629313c0$var$proto.mustUseProperty = false;
$e40260d1629313c0$var$proto.defined = false;
function $e40260d1629313c0$var$Info(property, attribute) {
    this.property = property;
    this.attribute = attribute;
}


var $c0d6026c0199d149$exports = {};

$parcel$export($c0d6026c0199d149$exports, "boolean", function () { return $c0d6026c0199d149$export$4a21f16c33752377; }, function (v) { return $c0d6026c0199d149$export$4a21f16c33752377 = v; });
$parcel$export($c0d6026c0199d149$exports, "booleanish", function () { return $c0d6026c0199d149$export$55e9e1fbc638dc8f; }, function (v) { return $c0d6026c0199d149$export$55e9e1fbc638dc8f = v; });
$parcel$export($c0d6026c0199d149$exports, "overloadedBoolean", function () { return $c0d6026c0199d149$export$242ac3d3042558aa; }, function (v) { return $c0d6026c0199d149$export$242ac3d3042558aa = v; });
$parcel$export($c0d6026c0199d149$exports, "number", function () { return $c0d6026c0199d149$export$98e628dec113755e; }, function (v) { return $c0d6026c0199d149$export$98e628dec113755e = v; });
$parcel$export($c0d6026c0199d149$exports, "spaceSeparated", function () { return $c0d6026c0199d149$export$ab8645c862eb5a3e; }, function (v) { return $c0d6026c0199d149$export$ab8645c862eb5a3e = v; });
$parcel$export($c0d6026c0199d149$exports, "commaSeparated", function () { return $c0d6026c0199d149$export$9c8d678629b3d3; }, function (v) { return $c0d6026c0199d149$export$9c8d678629b3d3 = v; });
$parcel$export($c0d6026c0199d149$exports, "commaOrSpaceSeparated", function () { return $c0d6026c0199d149$export$2ad25cfebf36cacd; }, function (v) { return $c0d6026c0199d149$export$2ad25cfebf36cacd = v; });
var $c0d6026c0199d149$export$4a21f16c33752377;
var $c0d6026c0199d149$export$55e9e1fbc638dc8f;
var $c0d6026c0199d149$export$242ac3d3042558aa;
var $c0d6026c0199d149$export$98e628dec113755e;
var $c0d6026c0199d149$export$ab8645c862eb5a3e;
var $c0d6026c0199d149$export$9c8d678629b3d3;
var $c0d6026c0199d149$export$2ad25cfebf36cacd;
'use strict';
var $c0d6026c0199d149$var$powers = 0;
$c0d6026c0199d149$export$4a21f16c33752377 = $c0d6026c0199d149$var$increment();
$c0d6026c0199d149$export$55e9e1fbc638dc8f = $c0d6026c0199d149$var$increment();
$c0d6026c0199d149$export$242ac3d3042558aa = $c0d6026c0199d149$var$increment();
$c0d6026c0199d149$export$98e628dec113755e = $c0d6026c0199d149$var$increment();
$c0d6026c0199d149$export$ab8645c862eb5a3e = $c0d6026c0199d149$var$increment();
$c0d6026c0199d149$export$9c8d678629b3d3 = $c0d6026c0199d149$var$increment();
$c0d6026c0199d149$export$2ad25cfebf36cacd = $c0d6026c0199d149$var$increment();
function $c0d6026c0199d149$var$increment() {
    return Math.pow(2, ++$c0d6026c0199d149$var$powers);
}


$3450a939bd5d1c44$exports = $3450a939bd5d1c44$var$DefinedInfo;
$3450a939bd5d1c44$var$DefinedInfo.prototype = new $e40260d1629313c0$exports();
$3450a939bd5d1c44$var$DefinedInfo.prototype.defined = true;
var $3450a939bd5d1c44$var$checks = [
    'boolean',
    'booleanish',
    'overloadedBoolean',
    'number',
    'commaSeparated',
    'spaceSeparated',
    'commaOrSpaceSeparated'
];
var $3450a939bd5d1c44$var$checksLength = $3450a939bd5d1c44$var$checks.length;
function $3450a939bd5d1c44$var$DefinedInfo(property, attribute, mask, space) {
    var index = -1;
    var check;
    $3450a939bd5d1c44$var$mark(this, 'space', space);
    $e40260d1629313c0$exports.call(this, property, attribute);
    while(++index < $3450a939bd5d1c44$var$checksLength){
        check = $3450a939bd5d1c44$var$checks[index];
        $3450a939bd5d1c44$var$mark(this, check, (mask & $c0d6026c0199d149$exports[check]) === $c0d6026c0199d149$exports[check]);
    }
}
function $3450a939bd5d1c44$var$mark(values, key, value) {
    if (value) values[key] = value;
}


$797ab05b7fef13a4$exports = $797ab05b7fef13a4$var$create;
function $797ab05b7fef13a4$var$create(definition) {
    var space = definition.space;
    var mustUseProperty = definition.mustUseProperty || [];
    var attributes = definition.attributes || {};
    var props = definition.properties;
    var transform = definition.transform;
    var property = {};
    var normal = {};
    var prop;
    var info;
    for(prop in props){
        info = new $3450a939bd5d1c44$exports(prop, transform(attributes, prop), props[prop], space);
        if (mustUseProperty.indexOf(prop) !== -1) info.mustUseProperty = true;
        property[prop] = info;
        normal[$0f0b16c99e5d1bbf$exports(prop)] = prop;
        normal[$0f0b16c99e5d1bbf$exports(info.attribute)] = prop;
    }
    return new $9c36b662a64fa45d$exports(property, normal, space);
}


$9497ebe8dc3e435e$exports = $797ab05b7fef13a4$exports({
    space: 'xlink',
    transform: $9497ebe8dc3e435e$var$xlinkTransform,
    properties: {
        xLinkActuate: null,
        xLinkArcRole: null,
        xLinkHref: null,
        xLinkRole: null,
        xLinkShow: null,
        xLinkTitle: null,
        xLinkType: null
    }
});
function $9497ebe8dc3e435e$var$xlinkTransform(_, prop) {
    return 'xlink:' + prop.slice(5).toLowerCase();
}


var $f8b5b525819e8b31$exports = {};
'use strict';

$f8b5b525819e8b31$exports = $797ab05b7fef13a4$exports({
    space: 'xml',
    transform: $f8b5b525819e8b31$var$xmlTransform,
    properties: {
        xmlLang: null,
        xmlBase: null,
        xmlSpace: null
    }
});
function $f8b5b525819e8b31$var$xmlTransform(_, prop) {
    return 'xml:' + prop.slice(3).toLowerCase();
}


var $65f1b65559a218d3$exports = {};
'use strict';

var $67092fd40eea65e1$exports = {};
'use strict';
var $43aa68f71e7fd3fa$exports = {};
'use strict';
$43aa68f71e7fd3fa$exports = $43aa68f71e7fd3fa$var$caseSensitiveTransform;
function $43aa68f71e7fd3fa$var$caseSensitiveTransform(attributes, attribute) {
    return attribute in attributes ? attributes[attribute] : attribute;
}


$67092fd40eea65e1$exports = $67092fd40eea65e1$var$caseInsensitiveTransform;
function $67092fd40eea65e1$var$caseInsensitiveTransform(attributes, property) {
    return $43aa68f71e7fd3fa$exports(attributes, property.toLowerCase());
}


$65f1b65559a218d3$exports = $797ab05b7fef13a4$exports({
    space: 'xmlns',
    attributes: {
        xmlnsxlink: 'xmlns:xlink'
    },
    transform: $67092fd40eea65e1$exports,
    properties: {
        xmlns: null,
        xmlnsXLink: null
    }
});


var $c2183e6dfdb244e5$exports = {};
'use strict';


var $c2183e6dfdb244e5$var$booleanish = $c0d6026c0199d149$export$55e9e1fbc638dc8f;
var $c2183e6dfdb244e5$var$number = $c0d6026c0199d149$export$98e628dec113755e;
var $c2183e6dfdb244e5$var$spaceSeparated = $c0d6026c0199d149$export$ab8645c862eb5a3e;
$c2183e6dfdb244e5$exports = $797ab05b7fef13a4$exports({
    transform: $c2183e6dfdb244e5$var$ariaTransform,
    properties: {
        ariaActiveDescendant: null,
        ariaAtomic: $c2183e6dfdb244e5$var$booleanish,
        ariaAutoComplete: null,
        ariaBusy: $c2183e6dfdb244e5$var$booleanish,
        ariaChecked: $c2183e6dfdb244e5$var$booleanish,
        ariaColCount: $c2183e6dfdb244e5$var$number,
        ariaColIndex: $c2183e6dfdb244e5$var$number,
        ariaColSpan: $c2183e6dfdb244e5$var$number,
        ariaControls: $c2183e6dfdb244e5$var$spaceSeparated,
        ariaCurrent: null,
        ariaDescribedBy: $c2183e6dfdb244e5$var$spaceSeparated,
        ariaDetails: null,
        ariaDisabled: $c2183e6dfdb244e5$var$booleanish,
        ariaDropEffect: $c2183e6dfdb244e5$var$spaceSeparated,
        ariaErrorMessage: null,
        ariaExpanded: $c2183e6dfdb244e5$var$booleanish,
        ariaFlowTo: $c2183e6dfdb244e5$var$spaceSeparated,
        ariaGrabbed: $c2183e6dfdb244e5$var$booleanish,
        ariaHasPopup: null,
        ariaHidden: $c2183e6dfdb244e5$var$booleanish,
        ariaInvalid: null,
        ariaKeyShortcuts: null,
        ariaLabel: null,
        ariaLabelledBy: $c2183e6dfdb244e5$var$spaceSeparated,
        ariaLevel: $c2183e6dfdb244e5$var$number,
        ariaLive: null,
        ariaModal: $c2183e6dfdb244e5$var$booleanish,
        ariaMultiLine: $c2183e6dfdb244e5$var$booleanish,
        ariaMultiSelectable: $c2183e6dfdb244e5$var$booleanish,
        ariaOrientation: null,
        ariaOwns: $c2183e6dfdb244e5$var$spaceSeparated,
        ariaPlaceholder: null,
        ariaPosInSet: $c2183e6dfdb244e5$var$number,
        ariaPressed: $c2183e6dfdb244e5$var$booleanish,
        ariaReadOnly: $c2183e6dfdb244e5$var$booleanish,
        ariaRelevant: null,
        ariaRequired: $c2183e6dfdb244e5$var$booleanish,
        ariaRoleDescription: $c2183e6dfdb244e5$var$spaceSeparated,
        ariaRowCount: $c2183e6dfdb244e5$var$number,
        ariaRowIndex: $c2183e6dfdb244e5$var$number,
        ariaRowSpan: $c2183e6dfdb244e5$var$number,
        ariaSelected: $c2183e6dfdb244e5$var$booleanish,
        ariaSetSize: $c2183e6dfdb244e5$var$number,
        ariaSort: null,
        ariaValueMax: $c2183e6dfdb244e5$var$number,
        ariaValueMin: $c2183e6dfdb244e5$var$number,
        ariaValueNow: $c2183e6dfdb244e5$var$number,
        ariaValueText: null,
        role: null
    }
});
function $c2183e6dfdb244e5$var$ariaTransform(_, prop) {
    return prop === 'role' ? prop : 'aria-' + prop.slice(4).toLowerCase();
}


var $ee32309c5d37dc08$exports = {};
'use strict';



var $ee32309c5d37dc08$var$boolean = $c0d6026c0199d149$export$4a21f16c33752377;
var $ee32309c5d37dc08$var$overloadedBoolean = $c0d6026c0199d149$export$242ac3d3042558aa;
var $ee32309c5d37dc08$var$booleanish = $c0d6026c0199d149$export$55e9e1fbc638dc8f;
var $ee32309c5d37dc08$var$number = $c0d6026c0199d149$export$98e628dec113755e;
var $ee32309c5d37dc08$var$spaceSeparated = $c0d6026c0199d149$export$ab8645c862eb5a3e;
var $ee32309c5d37dc08$var$commaSeparated = $c0d6026c0199d149$export$9c8d678629b3d3;
$ee32309c5d37dc08$exports = $797ab05b7fef13a4$exports({
    space: 'html',
    attributes: {
        acceptcharset: 'accept-charset',
        classname: 'class',
        htmlfor: 'for',
        httpequiv: 'http-equiv'
    },
    transform: $67092fd40eea65e1$exports,
    mustUseProperty: [
        'checked',
        'multiple',
        'muted',
        'selected'
    ],
    properties: {
        // Standard Properties.
        abbr: null,
        accept: $ee32309c5d37dc08$var$commaSeparated,
        acceptCharset: $ee32309c5d37dc08$var$spaceSeparated,
        accessKey: $ee32309c5d37dc08$var$spaceSeparated,
        action: null,
        allow: null,
        allowFullScreen: $ee32309c5d37dc08$var$boolean,
        allowPaymentRequest: $ee32309c5d37dc08$var$boolean,
        allowUserMedia: $ee32309c5d37dc08$var$boolean,
        alt: null,
        as: null,
        async: $ee32309c5d37dc08$var$boolean,
        autoCapitalize: null,
        autoComplete: $ee32309c5d37dc08$var$spaceSeparated,
        autoFocus: $ee32309c5d37dc08$var$boolean,
        autoPlay: $ee32309c5d37dc08$var$boolean,
        capture: $ee32309c5d37dc08$var$boolean,
        charSet: null,
        checked: $ee32309c5d37dc08$var$boolean,
        cite: null,
        className: $ee32309c5d37dc08$var$spaceSeparated,
        cols: $ee32309c5d37dc08$var$number,
        colSpan: null,
        content: null,
        contentEditable: $ee32309c5d37dc08$var$booleanish,
        controls: $ee32309c5d37dc08$var$boolean,
        controlsList: $ee32309c5d37dc08$var$spaceSeparated,
        coords: $ee32309c5d37dc08$var$number | $ee32309c5d37dc08$var$commaSeparated,
        crossOrigin: null,
        data: null,
        dateTime: null,
        decoding: null,
        default: $ee32309c5d37dc08$var$boolean,
        defer: $ee32309c5d37dc08$var$boolean,
        dir: null,
        dirName: null,
        disabled: $ee32309c5d37dc08$var$boolean,
        download: $ee32309c5d37dc08$var$overloadedBoolean,
        draggable: $ee32309c5d37dc08$var$booleanish,
        encType: null,
        enterKeyHint: null,
        form: null,
        formAction: null,
        formEncType: null,
        formMethod: null,
        formNoValidate: $ee32309c5d37dc08$var$boolean,
        formTarget: null,
        headers: $ee32309c5d37dc08$var$spaceSeparated,
        height: $ee32309c5d37dc08$var$number,
        hidden: $ee32309c5d37dc08$var$boolean,
        high: $ee32309c5d37dc08$var$number,
        href: null,
        hrefLang: null,
        htmlFor: $ee32309c5d37dc08$var$spaceSeparated,
        httpEquiv: $ee32309c5d37dc08$var$spaceSeparated,
        id: null,
        imageSizes: null,
        imageSrcSet: $ee32309c5d37dc08$var$commaSeparated,
        inputMode: null,
        integrity: null,
        is: null,
        isMap: $ee32309c5d37dc08$var$boolean,
        itemId: null,
        itemProp: $ee32309c5d37dc08$var$spaceSeparated,
        itemRef: $ee32309c5d37dc08$var$spaceSeparated,
        itemScope: $ee32309c5d37dc08$var$boolean,
        itemType: $ee32309c5d37dc08$var$spaceSeparated,
        kind: null,
        label: null,
        lang: null,
        language: null,
        list: null,
        loading: null,
        loop: $ee32309c5d37dc08$var$boolean,
        low: $ee32309c5d37dc08$var$number,
        manifest: null,
        max: null,
        maxLength: $ee32309c5d37dc08$var$number,
        media: null,
        method: null,
        min: null,
        minLength: $ee32309c5d37dc08$var$number,
        multiple: $ee32309c5d37dc08$var$boolean,
        muted: $ee32309c5d37dc08$var$boolean,
        name: null,
        nonce: null,
        noModule: $ee32309c5d37dc08$var$boolean,
        noValidate: $ee32309c5d37dc08$var$boolean,
        onAbort: null,
        onAfterPrint: null,
        onAuxClick: null,
        onBeforePrint: null,
        onBeforeUnload: null,
        onBlur: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onContextMenu: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFormData: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLanguageChange: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadEnd: null,
        onLoadStart: null,
        onMessage: null,
        onMessageError: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRejectionHandled: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSecurityPolicyViolation: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onSlotChange: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnhandledRejection: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onWheel: null,
        open: $ee32309c5d37dc08$var$boolean,
        optimum: $ee32309c5d37dc08$var$number,
        pattern: null,
        ping: $ee32309c5d37dc08$var$spaceSeparated,
        placeholder: null,
        playsInline: $ee32309c5d37dc08$var$boolean,
        poster: null,
        preload: null,
        readOnly: $ee32309c5d37dc08$var$boolean,
        referrerPolicy: null,
        rel: $ee32309c5d37dc08$var$spaceSeparated,
        required: $ee32309c5d37dc08$var$boolean,
        reversed: $ee32309c5d37dc08$var$boolean,
        rows: $ee32309c5d37dc08$var$number,
        rowSpan: $ee32309c5d37dc08$var$number,
        sandbox: $ee32309c5d37dc08$var$spaceSeparated,
        scope: null,
        scoped: $ee32309c5d37dc08$var$boolean,
        seamless: $ee32309c5d37dc08$var$boolean,
        selected: $ee32309c5d37dc08$var$boolean,
        shape: null,
        size: $ee32309c5d37dc08$var$number,
        sizes: null,
        slot: null,
        span: $ee32309c5d37dc08$var$number,
        spellCheck: $ee32309c5d37dc08$var$booleanish,
        src: null,
        srcDoc: null,
        srcLang: null,
        srcSet: $ee32309c5d37dc08$var$commaSeparated,
        start: $ee32309c5d37dc08$var$number,
        step: null,
        style: null,
        tabIndex: $ee32309c5d37dc08$var$number,
        target: null,
        title: null,
        translate: null,
        type: null,
        typeMustMatch: $ee32309c5d37dc08$var$boolean,
        useMap: null,
        value: $ee32309c5d37dc08$var$booleanish,
        width: $ee32309c5d37dc08$var$number,
        wrap: null,
        // Legacy.
        // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
        align: null,
        aLink: null,
        archive: $ee32309c5d37dc08$var$spaceSeparated,
        axis: null,
        background: null,
        bgColor: null,
        border: $ee32309c5d37dc08$var$number,
        borderColor: null,
        bottomMargin: $ee32309c5d37dc08$var$number,
        cellPadding: null,
        cellSpacing: null,
        char: null,
        charOff: null,
        classId: null,
        clear: null,
        code: null,
        codeBase: null,
        codeType: null,
        color: null,
        compact: $ee32309c5d37dc08$var$boolean,
        declare: $ee32309c5d37dc08$var$boolean,
        event: null,
        face: null,
        frame: null,
        frameBorder: null,
        hSpace: $ee32309c5d37dc08$var$number,
        leftMargin: $ee32309c5d37dc08$var$number,
        link: null,
        longDesc: null,
        lowSrc: null,
        marginHeight: $ee32309c5d37dc08$var$number,
        marginWidth: $ee32309c5d37dc08$var$number,
        noResize: $ee32309c5d37dc08$var$boolean,
        noHref: $ee32309c5d37dc08$var$boolean,
        noShade: $ee32309c5d37dc08$var$boolean,
        noWrap: $ee32309c5d37dc08$var$boolean,
        object: null,
        profile: null,
        prompt: null,
        rev: null,
        rightMargin: $ee32309c5d37dc08$var$number,
        rules: null,
        scheme: null,
        scrolling: $ee32309c5d37dc08$var$booleanish,
        standby: null,
        summary: null,
        text: null,
        topMargin: $ee32309c5d37dc08$var$number,
        valueType: null,
        version: null,
        vAlign: null,
        vLink: null,
        vSpace: $ee32309c5d37dc08$var$number,
        // Non-standard Properties.
        allowTransparency: null,
        autoCorrect: null,
        autoSave: null,
        disablePictureInPicture: $ee32309c5d37dc08$var$boolean,
        disableRemotePlayback: $ee32309c5d37dc08$var$boolean,
        prefix: null,
        property: null,
        results: $ee32309c5d37dc08$var$number,
        security: null,
        unselectable: null
    }
});


$0313be7775ad9c20$exports = $7c4a581dd783fc4a$exports([
    $f8b5b525819e8b31$exports,
    $9497ebe8dc3e435e$exports,
    $65f1b65559a218d3$exports,
    $c2183e6dfdb244e5$exports,
    $ee32309c5d37dc08$exports
]);


var $9a8e86b12b0e5913$exports = {};

var $lxQxI = parcelRequire("lxQxI");
$9a8e86b12b0e5913$exports = $9a8e86b12b0e5913$var$rehypeFilter;
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Element} Element
 *
 * @callback AllowElement
 * @param {Element} element
 * @param {number} index
 * @param {Element|Root} parent
 * @returns {boolean|undefined}
 *
 * @typedef RehypeFilterOptions
 * @property {Array.<string>} [allowedElements]
 * @property {Array.<string>} [disallowedElements=[]]
 * @property {AllowElement} [allowElement]
 * @property {boolean} [unwrapDisallowed=false]
 */ /**
 * @type {import('unified').Plugin<[RehypeFilterOptions]>}
 */ function $9a8e86b12b0e5913$var$rehypeFilter(options) {
    if (options.allowedElements && options.disallowedElements) throw new TypeError('Only one of `allowedElements` and `disallowedElements` should be defined');
    if (options.allowedElements || options.disallowedElements || options.allowElement) return (tree)=>{
        const node = /** @type {Root} */ tree;
        $lxQxI(node, 'element', onelement);
    };
    /**
   * @param {Node} node_
   * @param {number|null|undefined} index
   * @param {Node|null|undefined} parent_
   * @returns {number|void}
   */ function onelement(node_, index, parent_) {
        const node = /** @type {Element} */ node_;
        const parent = /** @type {Element|Root} */ parent_;
        /** @type {boolean|undefined} */ let remove;
        if (options.allowedElements) remove = !options.allowedElements.includes(node.tagName);
        else if (options.disallowedElements) remove = options.disallowedElements.includes(node.tagName);
        if (!remove && options.allowElement && typeof index === 'number') remove = !options.allowElement(node, index, parent);
        if (remove && typeof index === 'number') {
            if (options.unwrapDisallowed && node.children) parent.children.splice(index, 1, ...node.children);
            else parent.children.splice(index, 1);
            return index;
        }
        return undefined;
    }
}


var $d40bff02d2225b9a$exports = {};
const $d40bff02d2225b9a$var$protocols = [
    'http',
    'https',
    'mailto',
    'tel'
];
$d40bff02d2225b9a$exports = $d40bff02d2225b9a$var$uriTransformer;
/**
 * @param {string} uri
 * @returns {string}
 */ function $d40bff02d2225b9a$var$uriTransformer(uri) {
    const url = (uri || '').trim();
    const first = url.charAt(0);
    if (first === '#' || first === '/') return url;
    const colon = url.indexOf(':');
    if (colon === -1) return url;
    let index = -1;
    while(++index < $d40bff02d2225b9a$var$protocols.length){
        const protocol = $d40bff02d2225b9a$var$protocols[index];
        if (colon === protocol.length && url.slice(0, protocol.length).toLowerCase() === protocol) return url;
    }
    index = url.indexOf('?');
    if (index !== -1 && colon > index) return url;
    index = url.indexOf('#');
    if (index !== -1 && colon > index) return url;
    // eslint-disable-next-line no-script-url
    return 'javascript:void(0)';
}


var $4109724e8f83713a$export$d8abd7e5fb6871f9;
var $4109724e8f83713a$export$d88ad6fc8b890afd;
'use strict';

var $NdCUR = parcelRequire("NdCUR");
var $cd2b54b2fab3a898$exports = {};
'use strict';

$cd2b54b2fab3a898$exports = (parcelRequire("diARD"));


var $89f200badabc8da1$exports = {};
'use strict';





var $22d676380c5d7d8e$exports = {};
'use strict';



var $22d676380c5d7d8e$var$boolean = $c0d6026c0199d149$export$4a21f16c33752377;
var $22d676380c5d7d8e$var$number = $c0d6026c0199d149$export$98e628dec113755e;
var $22d676380c5d7d8e$var$spaceSeparated = $c0d6026c0199d149$export$ab8645c862eb5a3e;
var $22d676380c5d7d8e$var$commaSeparated = $c0d6026c0199d149$export$9c8d678629b3d3;
var $22d676380c5d7d8e$var$commaOrSpaceSeparated = $c0d6026c0199d149$export$2ad25cfebf36cacd;
$22d676380c5d7d8e$exports = $797ab05b7fef13a4$exports({
    space: 'svg',
    attributes: {
        accentHeight: 'accent-height',
        alignmentBaseline: 'alignment-baseline',
        arabicForm: 'arabic-form',
        baselineShift: 'baseline-shift',
        capHeight: 'cap-height',
        className: 'class',
        clipPath: 'clip-path',
        clipRule: 'clip-rule',
        colorInterpolation: 'color-interpolation',
        colorInterpolationFilters: 'color-interpolation-filters',
        colorProfile: 'color-profile',
        colorRendering: 'color-rendering',
        crossOrigin: 'crossorigin',
        dataType: 'datatype',
        dominantBaseline: 'dominant-baseline',
        enableBackground: 'enable-background',
        fillOpacity: 'fill-opacity',
        fillRule: 'fill-rule',
        floodColor: 'flood-color',
        floodOpacity: 'flood-opacity',
        fontFamily: 'font-family',
        fontSize: 'font-size',
        fontSizeAdjust: 'font-size-adjust',
        fontStretch: 'font-stretch',
        fontStyle: 'font-style',
        fontVariant: 'font-variant',
        fontWeight: 'font-weight',
        glyphName: 'glyph-name',
        glyphOrientationHorizontal: 'glyph-orientation-horizontal',
        glyphOrientationVertical: 'glyph-orientation-vertical',
        hrefLang: 'hreflang',
        horizAdvX: 'horiz-adv-x',
        horizOriginX: 'horiz-origin-x',
        horizOriginY: 'horiz-origin-y',
        imageRendering: 'image-rendering',
        letterSpacing: 'letter-spacing',
        lightingColor: 'lighting-color',
        markerEnd: 'marker-end',
        markerMid: 'marker-mid',
        markerStart: 'marker-start',
        navDown: 'nav-down',
        navDownLeft: 'nav-down-left',
        navDownRight: 'nav-down-right',
        navLeft: 'nav-left',
        navNext: 'nav-next',
        navPrev: 'nav-prev',
        navRight: 'nav-right',
        navUp: 'nav-up',
        navUpLeft: 'nav-up-left',
        navUpRight: 'nav-up-right',
        onAbort: 'onabort',
        onActivate: 'onactivate',
        onAfterPrint: 'onafterprint',
        onBeforePrint: 'onbeforeprint',
        onBegin: 'onbegin',
        onCancel: 'oncancel',
        onCanPlay: 'oncanplay',
        onCanPlayThrough: 'oncanplaythrough',
        onChange: 'onchange',
        onClick: 'onclick',
        onClose: 'onclose',
        onCopy: 'oncopy',
        onCueChange: 'oncuechange',
        onCut: 'oncut',
        onDblClick: 'ondblclick',
        onDrag: 'ondrag',
        onDragEnd: 'ondragend',
        onDragEnter: 'ondragenter',
        onDragExit: 'ondragexit',
        onDragLeave: 'ondragleave',
        onDragOver: 'ondragover',
        onDragStart: 'ondragstart',
        onDrop: 'ondrop',
        onDurationChange: 'ondurationchange',
        onEmptied: 'onemptied',
        onEnd: 'onend',
        onEnded: 'onended',
        onError: 'onerror',
        onFocus: 'onfocus',
        onFocusIn: 'onfocusin',
        onFocusOut: 'onfocusout',
        onHashChange: 'onhashchange',
        onInput: 'oninput',
        onInvalid: 'oninvalid',
        onKeyDown: 'onkeydown',
        onKeyPress: 'onkeypress',
        onKeyUp: 'onkeyup',
        onLoad: 'onload',
        onLoadedData: 'onloadeddata',
        onLoadedMetadata: 'onloadedmetadata',
        onLoadStart: 'onloadstart',
        onMessage: 'onmessage',
        onMouseDown: 'onmousedown',
        onMouseEnter: 'onmouseenter',
        onMouseLeave: 'onmouseleave',
        onMouseMove: 'onmousemove',
        onMouseOut: 'onmouseout',
        onMouseOver: 'onmouseover',
        onMouseUp: 'onmouseup',
        onMouseWheel: 'onmousewheel',
        onOffline: 'onoffline',
        onOnline: 'ononline',
        onPageHide: 'onpagehide',
        onPageShow: 'onpageshow',
        onPaste: 'onpaste',
        onPause: 'onpause',
        onPlay: 'onplay',
        onPlaying: 'onplaying',
        onPopState: 'onpopstate',
        onProgress: 'onprogress',
        onRateChange: 'onratechange',
        onRepeat: 'onrepeat',
        onReset: 'onreset',
        onResize: 'onresize',
        onScroll: 'onscroll',
        onSeeked: 'onseeked',
        onSeeking: 'onseeking',
        onSelect: 'onselect',
        onShow: 'onshow',
        onStalled: 'onstalled',
        onStorage: 'onstorage',
        onSubmit: 'onsubmit',
        onSuspend: 'onsuspend',
        onTimeUpdate: 'ontimeupdate',
        onToggle: 'ontoggle',
        onUnload: 'onunload',
        onVolumeChange: 'onvolumechange',
        onWaiting: 'onwaiting',
        onZoom: 'onzoom',
        overlinePosition: 'overline-position',
        overlineThickness: 'overline-thickness',
        paintOrder: 'paint-order',
        panose1: 'panose-1',
        pointerEvents: 'pointer-events',
        referrerPolicy: 'referrerpolicy',
        renderingIntent: 'rendering-intent',
        shapeRendering: 'shape-rendering',
        stopColor: 'stop-color',
        stopOpacity: 'stop-opacity',
        strikethroughPosition: 'strikethrough-position',
        strikethroughThickness: 'strikethrough-thickness',
        strokeDashArray: 'stroke-dasharray',
        strokeDashOffset: 'stroke-dashoffset',
        strokeLineCap: 'stroke-linecap',
        strokeLineJoin: 'stroke-linejoin',
        strokeMiterLimit: 'stroke-miterlimit',
        strokeOpacity: 'stroke-opacity',
        strokeWidth: 'stroke-width',
        tabIndex: 'tabindex',
        textAnchor: 'text-anchor',
        textDecoration: 'text-decoration',
        textRendering: 'text-rendering',
        typeOf: 'typeof',
        underlinePosition: 'underline-position',
        underlineThickness: 'underline-thickness',
        unicodeBidi: 'unicode-bidi',
        unicodeRange: 'unicode-range',
        unitsPerEm: 'units-per-em',
        vAlphabetic: 'v-alphabetic',
        vHanging: 'v-hanging',
        vIdeographic: 'v-ideographic',
        vMathematical: 'v-mathematical',
        vectorEffect: 'vector-effect',
        vertAdvY: 'vert-adv-y',
        vertOriginX: 'vert-origin-x',
        vertOriginY: 'vert-origin-y',
        wordSpacing: 'word-spacing',
        writingMode: 'writing-mode',
        xHeight: 'x-height',
        // These were camelcased in Tiny. Now lowercased in SVG 2
        playbackOrder: 'playbackorder',
        timelineBegin: 'timelinebegin'
    },
    transform: $43aa68f71e7fd3fa$exports,
    properties: {
        about: $22d676380c5d7d8e$var$commaOrSpaceSeparated,
        accentHeight: $22d676380c5d7d8e$var$number,
        accumulate: null,
        additive: null,
        alignmentBaseline: null,
        alphabetic: $22d676380c5d7d8e$var$number,
        amplitude: $22d676380c5d7d8e$var$number,
        arabicForm: null,
        ascent: $22d676380c5d7d8e$var$number,
        attributeName: null,
        attributeType: null,
        azimuth: $22d676380c5d7d8e$var$number,
        bandwidth: null,
        baselineShift: null,
        baseFrequency: null,
        baseProfile: null,
        bbox: null,
        begin: null,
        bias: $22d676380c5d7d8e$var$number,
        by: null,
        calcMode: null,
        capHeight: $22d676380c5d7d8e$var$number,
        className: $22d676380c5d7d8e$var$spaceSeparated,
        clip: null,
        clipPath: null,
        clipPathUnits: null,
        clipRule: null,
        color: null,
        colorInterpolation: null,
        colorInterpolationFilters: null,
        colorProfile: null,
        colorRendering: null,
        content: null,
        contentScriptType: null,
        contentStyleType: null,
        crossOrigin: null,
        cursor: null,
        cx: null,
        cy: null,
        d: null,
        dataType: null,
        defaultAction: null,
        descent: $22d676380c5d7d8e$var$number,
        diffuseConstant: $22d676380c5d7d8e$var$number,
        direction: null,
        display: null,
        dur: null,
        divisor: $22d676380c5d7d8e$var$number,
        dominantBaseline: null,
        download: $22d676380c5d7d8e$var$boolean,
        dx: null,
        dy: null,
        edgeMode: null,
        editable: null,
        elevation: $22d676380c5d7d8e$var$number,
        enableBackground: null,
        end: null,
        event: null,
        exponent: $22d676380c5d7d8e$var$number,
        externalResourcesRequired: null,
        fill: null,
        fillOpacity: $22d676380c5d7d8e$var$number,
        fillRule: null,
        filter: null,
        filterRes: null,
        filterUnits: null,
        floodColor: null,
        floodOpacity: null,
        focusable: null,
        focusHighlight: null,
        fontFamily: null,
        fontSize: null,
        fontSizeAdjust: null,
        fontStretch: null,
        fontStyle: null,
        fontVariant: null,
        fontWeight: null,
        format: null,
        fr: null,
        from: null,
        fx: null,
        fy: null,
        g1: $22d676380c5d7d8e$var$commaSeparated,
        g2: $22d676380c5d7d8e$var$commaSeparated,
        glyphName: $22d676380c5d7d8e$var$commaSeparated,
        glyphOrientationHorizontal: null,
        glyphOrientationVertical: null,
        glyphRef: null,
        gradientTransform: null,
        gradientUnits: null,
        handler: null,
        hanging: $22d676380c5d7d8e$var$number,
        hatchContentUnits: null,
        hatchUnits: null,
        height: null,
        href: null,
        hrefLang: null,
        horizAdvX: $22d676380c5d7d8e$var$number,
        horizOriginX: $22d676380c5d7d8e$var$number,
        horizOriginY: $22d676380c5d7d8e$var$number,
        id: null,
        ideographic: $22d676380c5d7d8e$var$number,
        imageRendering: null,
        initialVisibility: null,
        in: null,
        in2: null,
        intercept: $22d676380c5d7d8e$var$number,
        k: $22d676380c5d7d8e$var$number,
        k1: $22d676380c5d7d8e$var$number,
        k2: $22d676380c5d7d8e$var$number,
        k3: $22d676380c5d7d8e$var$number,
        k4: $22d676380c5d7d8e$var$number,
        kernelMatrix: $22d676380c5d7d8e$var$commaOrSpaceSeparated,
        kernelUnitLength: null,
        keyPoints: null,
        keySplines: null,
        keyTimes: null,
        kerning: null,
        lang: null,
        lengthAdjust: null,
        letterSpacing: null,
        lightingColor: null,
        limitingConeAngle: $22d676380c5d7d8e$var$number,
        local: null,
        markerEnd: null,
        markerMid: null,
        markerStart: null,
        markerHeight: null,
        markerUnits: null,
        markerWidth: null,
        mask: null,
        maskContentUnits: null,
        maskUnits: null,
        mathematical: null,
        max: null,
        media: null,
        mediaCharacterEncoding: null,
        mediaContentEncodings: null,
        mediaSize: $22d676380c5d7d8e$var$number,
        mediaTime: null,
        method: null,
        min: null,
        mode: null,
        name: null,
        navDown: null,
        navDownLeft: null,
        navDownRight: null,
        navLeft: null,
        navNext: null,
        navPrev: null,
        navRight: null,
        navUp: null,
        navUpLeft: null,
        navUpRight: null,
        numOctaves: null,
        observer: null,
        offset: null,
        onAbort: null,
        onActivate: null,
        onAfterPrint: null,
        onBeforePrint: null,
        onBegin: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnd: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFocusIn: null,
        onFocusOut: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadStart: null,
        onMessage: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onMouseWheel: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRepeat: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onShow: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onZoom: null,
        opacity: null,
        operator: null,
        order: null,
        orient: null,
        orientation: null,
        origin: null,
        overflow: null,
        overlay: null,
        overlinePosition: $22d676380c5d7d8e$var$number,
        overlineThickness: $22d676380c5d7d8e$var$number,
        paintOrder: null,
        panose1: null,
        path: null,
        pathLength: $22d676380c5d7d8e$var$number,
        patternContentUnits: null,
        patternTransform: null,
        patternUnits: null,
        phase: null,
        ping: $22d676380c5d7d8e$var$spaceSeparated,
        pitch: null,
        playbackOrder: null,
        pointerEvents: null,
        points: null,
        pointsAtX: $22d676380c5d7d8e$var$number,
        pointsAtY: $22d676380c5d7d8e$var$number,
        pointsAtZ: $22d676380c5d7d8e$var$number,
        preserveAlpha: null,
        preserveAspectRatio: null,
        primitiveUnits: null,
        propagate: null,
        property: $22d676380c5d7d8e$var$commaOrSpaceSeparated,
        r: null,
        radius: null,
        referrerPolicy: null,
        refX: null,
        refY: null,
        rel: $22d676380c5d7d8e$var$commaOrSpaceSeparated,
        rev: $22d676380c5d7d8e$var$commaOrSpaceSeparated,
        renderingIntent: null,
        repeatCount: null,
        repeatDur: null,
        requiredExtensions: $22d676380c5d7d8e$var$commaOrSpaceSeparated,
        requiredFeatures: $22d676380c5d7d8e$var$commaOrSpaceSeparated,
        requiredFonts: $22d676380c5d7d8e$var$commaOrSpaceSeparated,
        requiredFormats: $22d676380c5d7d8e$var$commaOrSpaceSeparated,
        resource: null,
        restart: null,
        result: null,
        rotate: null,
        rx: null,
        ry: null,
        scale: null,
        seed: null,
        shapeRendering: null,
        side: null,
        slope: null,
        snapshotTime: null,
        specularConstant: $22d676380c5d7d8e$var$number,
        specularExponent: $22d676380c5d7d8e$var$number,
        spreadMethod: null,
        spacing: null,
        startOffset: null,
        stdDeviation: null,
        stemh: null,
        stemv: null,
        stitchTiles: null,
        stopColor: null,
        stopOpacity: null,
        strikethroughPosition: $22d676380c5d7d8e$var$number,
        strikethroughThickness: $22d676380c5d7d8e$var$number,
        string: null,
        stroke: null,
        strokeDashArray: $22d676380c5d7d8e$var$commaOrSpaceSeparated,
        strokeDashOffset: null,
        strokeLineCap: null,
        strokeLineJoin: null,
        strokeMiterLimit: $22d676380c5d7d8e$var$number,
        strokeOpacity: $22d676380c5d7d8e$var$number,
        strokeWidth: null,
        style: null,
        surfaceScale: $22d676380c5d7d8e$var$number,
        syncBehavior: null,
        syncBehaviorDefault: null,
        syncMaster: null,
        syncTolerance: null,
        syncToleranceDefault: null,
        systemLanguage: $22d676380c5d7d8e$var$commaOrSpaceSeparated,
        tabIndex: $22d676380c5d7d8e$var$number,
        tableValues: null,
        target: null,
        targetX: $22d676380c5d7d8e$var$number,
        targetY: $22d676380c5d7d8e$var$number,
        textAnchor: null,
        textDecoration: null,
        textRendering: null,
        textLength: null,
        timelineBegin: null,
        title: null,
        transformBehavior: null,
        type: null,
        typeOf: $22d676380c5d7d8e$var$commaOrSpaceSeparated,
        to: null,
        transform: null,
        u1: null,
        u2: null,
        underlinePosition: $22d676380c5d7d8e$var$number,
        underlineThickness: $22d676380c5d7d8e$var$number,
        unicode: null,
        unicodeBidi: null,
        unicodeRange: null,
        unitsPerEm: $22d676380c5d7d8e$var$number,
        values: null,
        vAlphabetic: $22d676380c5d7d8e$var$number,
        vMathematical: $22d676380c5d7d8e$var$number,
        vectorEffect: null,
        vHanging: $22d676380c5d7d8e$var$number,
        vIdeographic: $22d676380c5d7d8e$var$number,
        version: null,
        vertAdvY: $22d676380c5d7d8e$var$number,
        vertOriginX: $22d676380c5d7d8e$var$number,
        vertOriginY: $22d676380c5d7d8e$var$number,
        viewBox: null,
        viewTarget: null,
        visibility: null,
        width: null,
        widths: null,
        wordSpacing: null,
        writingMode: null,
        x: null,
        x1: null,
        x2: null,
        xChannelSelector: null,
        xHeight: $22d676380c5d7d8e$var$number,
        y: null,
        y1: null,
        y2: null,
        yChannelSelector: null,
        z: null,
        zoomAndPan: null
    }
});


$89f200badabc8da1$exports = $7c4a581dd783fc4a$exports([
    $f8b5b525819e8b31$exports,
    $9497ebe8dc3e435e$exports,
    $65f1b65559a218d3$exports,
    $c2183e6dfdb244e5$exports,
    $22d676380c5d7d8e$exports
]);


var $f684eeaae89bffe2$exports = {};
'use strict';



var $f684eeaae89bffe2$var$data = 'data';
$f684eeaae89bffe2$exports = $f684eeaae89bffe2$var$find;
var $f684eeaae89bffe2$var$valid = /^data[-\w.:]+$/i;
var $f684eeaae89bffe2$var$dash = /-[a-z]/g;
var $f684eeaae89bffe2$var$cap = /[A-Z]/g;
function $f684eeaae89bffe2$var$find(schema, value) {
    var normal = $0f0b16c99e5d1bbf$exports(value);
    var prop = value;
    var Type = $e40260d1629313c0$exports;
    if (normal in schema.normal) return schema.property[schema.normal[normal]];
    if (normal.length > 4 && normal.slice(0, 4) === $f684eeaae89bffe2$var$data && $f684eeaae89bffe2$var$valid.test(value)) {
        // Attribute or property.
        if (value.charAt(4) === '-') prop = $f684eeaae89bffe2$var$datasetToProperty(value);
        else value = $f684eeaae89bffe2$var$datasetToAttribute(value);
        Type = $3450a939bd5d1c44$exports;
    }
    return new Type(prop, value);
}
function $f684eeaae89bffe2$var$datasetToProperty(attribute) {
    var value = attribute.slice(5).replace($f684eeaae89bffe2$var$dash, $f684eeaae89bffe2$var$camelcase);
    return $f684eeaae89bffe2$var$data + value.charAt(0).toUpperCase() + value.slice(1);
}
function $f684eeaae89bffe2$var$datasetToAttribute(property) {
    var value = property.slice(4);
    if ($f684eeaae89bffe2$var$dash.test(value)) return property;
    value = value.replace($f684eeaae89bffe2$var$cap, $f684eeaae89bffe2$var$kebab);
    if (value.charAt(0) !== '-') value = '-' + value;
    return $f684eeaae89bffe2$var$data + value;
}
function $f684eeaae89bffe2$var$kebab($0) {
    return '-' + $0.toLowerCase();
}
function $f684eeaae89bffe2$var$camelcase($0) {
    return $0.charAt(1).toUpperCase();
}


var $4c01cfc1354c934c$exports = {};
$4c01cfc1354c934c$exports = JSON.parse("{\"classId\":\"classID\",\"dataType\":\"datatype\",\"itemId\":\"itemID\",\"strokeDashArray\":\"strokeDasharray\",\"strokeDashOffset\":\"strokeDashoffset\",\"strokeLineCap\":\"strokeLinecap\",\"strokeLineJoin\":\"strokeLinejoin\",\"strokeMiterLimit\":\"strokeMiterlimit\",\"typeOf\":\"typeof\",\"xLinkActuate\":\"xlinkActuate\",\"xLinkArcRole\":\"xlinkArcrole\",\"xLinkHref\":\"xlinkHref\",\"xLinkRole\":\"xlinkRole\",\"xLinkShow\":\"xlinkShow\",\"xLinkTitle\":\"xlinkTitle\",\"xLinkType\":\"xlinkType\",\"xmlnsXLink\":\"xmlnsXlink\"}");


var $ec965cf8923cefe1$exports = {};

$parcel$export($ec965cf8923cefe1$exports, "parse", function () { return $ec965cf8923cefe1$export$98e6a39c04603d36; }, function (v) { return $ec965cf8923cefe1$export$98e6a39c04603d36 = v; });
$parcel$export($ec965cf8923cefe1$exports, "stringify", function () { return $ec965cf8923cefe1$export$fac44ee5b035f737; }, function (v) { return $ec965cf8923cefe1$export$fac44ee5b035f737 = v; });
var $ec965cf8923cefe1$export$98e6a39c04603d36;
var $ec965cf8923cefe1$export$fac44ee5b035f737;
'use strict';
$ec965cf8923cefe1$export$98e6a39c04603d36 = $ec965cf8923cefe1$var$parse;
$ec965cf8923cefe1$export$fac44ee5b035f737 = $ec965cf8923cefe1$var$stringify;
var $ec965cf8923cefe1$var$empty = '';
var $ec965cf8923cefe1$var$space = ' ';
var $ec965cf8923cefe1$var$whiteSpace = /[ \t\n\r\f]+/g;
function $ec965cf8923cefe1$var$parse(value) {
    var input = String(value || $ec965cf8923cefe1$var$empty).trim();
    return input === $ec965cf8923cefe1$var$empty ? [] : input.split($ec965cf8923cefe1$var$whiteSpace);
}
function $ec965cf8923cefe1$var$stringify(values) {
    return values.join($ec965cf8923cefe1$var$space).trim();
}


var $cce03bc2f3fec0fc$exports = {};

$parcel$export($cce03bc2f3fec0fc$exports, "parse", function () { return $cce03bc2f3fec0fc$export$98e6a39c04603d36; }, function (v) { return $cce03bc2f3fec0fc$export$98e6a39c04603d36 = v; });
$parcel$export($cce03bc2f3fec0fc$exports, "stringify", function () { return $cce03bc2f3fec0fc$export$fac44ee5b035f737; }, function (v) { return $cce03bc2f3fec0fc$export$fac44ee5b035f737 = v; });
var $cce03bc2f3fec0fc$export$98e6a39c04603d36;
var $cce03bc2f3fec0fc$export$fac44ee5b035f737;
'use strict';
$cce03bc2f3fec0fc$export$98e6a39c04603d36 = $cce03bc2f3fec0fc$var$parse;
$cce03bc2f3fec0fc$export$fac44ee5b035f737 = $cce03bc2f3fec0fc$var$stringify;
var $cce03bc2f3fec0fc$var$comma = ',';
var $cce03bc2f3fec0fc$var$space = ' ';
var $cce03bc2f3fec0fc$var$empty = '';
// Parse comma-separated tokens to an array.
function $cce03bc2f3fec0fc$var$parse(value) {
    var values = [];
    var input = String(value || $cce03bc2f3fec0fc$var$empty);
    var index = input.indexOf($cce03bc2f3fec0fc$var$comma);
    var lastIndex = 0;
    var end = false;
    var val;
    while(!end){
        if (index === -1) {
            index = input.length;
            end = true;
        }
        val = input.slice(lastIndex, index).trim();
        if (val || !end) values.push(val);
        lastIndex = index + 1;
        index = input.indexOf($cce03bc2f3fec0fc$var$comma, lastIndex);
    }
    return values;
}
// Compile an array to comma-separated tokens.
// `options.padLeft` (default: `true`) pads a space left of each token, and
// `options.padRight` (default: `false`) pads a space to the right of each token.
function $cce03bc2f3fec0fc$var$stringify(values, options) {
    var settings = options || {};
    var left = settings.padLeft === false ? $cce03bc2f3fec0fc$var$empty : $cce03bc2f3fec0fc$var$space;
    var right = settings.padRight ? $cce03bc2f3fec0fc$var$space : $cce03bc2f3fec0fc$var$empty;
    // Ensure the last empty entry is seen.
    if (values[values.length - 1] === $cce03bc2f3fec0fc$var$empty) values = values.concat($cce03bc2f3fec0fc$var$empty);
    return values.join(right + $cce03bc2f3fec0fc$var$comma + left).trim();
}


var $a026f656d32a4b2c$exports = {};
var $e6180cccd6a5c402$exports = {};
// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var $e6180cccd6a5c402$var$COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var $e6180cccd6a5c402$var$NEWLINE_REGEX = /\n/g;
var $e6180cccd6a5c402$var$WHITESPACE_REGEX = /^\s*/;
// declaration
var $e6180cccd6a5c402$var$PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var $e6180cccd6a5c402$var$COLON_REGEX = /^:\s*/;
var $e6180cccd6a5c402$var$VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var $e6180cccd6a5c402$var$SEMICOLON_REGEX = /^[;\s]*/;
// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var $e6180cccd6a5c402$var$TRIM_REGEX = /^\s+|\s+$/g;
// strings
var $e6180cccd6a5c402$var$NEWLINE = '\n';
var $e6180cccd6a5c402$var$FORWARD_SLASH = '/';
var $e6180cccd6a5c402$var$ASTERISK = '*';
var $e6180cccd6a5c402$var$EMPTY_STRING = '';
// types
var $e6180cccd6a5c402$var$TYPE_COMMENT = 'comment';
var $e6180cccd6a5c402$var$TYPE_DECLARATION = 'declaration';
/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */ $e6180cccd6a5c402$exports = function(style, options) {
    if (typeof style !== 'string') throw new TypeError('First argument must be a string');
    if (!style) return [];
    options = options || {};
    /**
   * Positional.
   */ var lineno = 1;
    var column = 1;
    /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */ function updatePosition(str) {
        var lines = str.match($e6180cccd6a5c402$var$NEWLINE_REGEX);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf($e6180cccd6a5c402$var$NEWLINE);
        column = ~i ? str.length - i : column + str.length;
    }
    /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */ function position() {
        var start = {
            line: lineno,
            column: column
        };
        return function(node) {
            node.position = new Position(start);
            whitespace();
            return node;
        };
    }
    /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */ function Position(start) {
        this.start = start;
        this.end = {
            line: lineno,
            column: column
        };
        this.source = options.source;
    }
    /**
   * Non-enumerable source string.
   */ Position.prototype.content = style;
    var errorsList = [];
    /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */ function error(msg) {
        var err = new Error(options.source + ':' + lineno + ':' + column + ': ' + msg);
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = style;
        if (options.silent) errorsList.push(err);
        else throw err;
    }
    /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */ function match(re) {
        var m = re.exec(style);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        style = style.slice(str.length);
        return m;
    }
    /**
   * Parse whitespace.
   */ function whitespace() {
        match($e6180cccd6a5c402$var$WHITESPACE_REGEX);
    }
    /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */ function comments(rules) {
        var c;
        rules = rules || [];
        while(c = comment())if (c !== false) rules.push(c);
        return rules;
    }
    /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */ function comment() {
        var pos = position();
        if ($e6180cccd6a5c402$var$FORWARD_SLASH != style.charAt(0) || $e6180cccd6a5c402$var$ASTERISK != style.charAt(1)) return;
        var i = 2;
        while($e6180cccd6a5c402$var$EMPTY_STRING != style.charAt(i) && ($e6180cccd6a5c402$var$ASTERISK != style.charAt(i) || $e6180cccd6a5c402$var$FORWARD_SLASH != style.charAt(i + 1)))++i;
        i += 2;
        if ($e6180cccd6a5c402$var$EMPTY_STRING === style.charAt(i - 1)) return error('End of comment missing');
        var str = style.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        style = style.slice(i);
        column += 2;
        return pos({
            type: $e6180cccd6a5c402$var$TYPE_COMMENT,
            comment: str
        });
    }
    /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */ function declaration() {
        var pos = position();
        // prop
        var prop = match($e6180cccd6a5c402$var$PROPERTY_REGEX);
        if (!prop) return;
        comment();
        // :
        if (!match($e6180cccd6a5c402$var$COLON_REGEX)) return error("property missing ':'");
        // val
        var val = match($e6180cccd6a5c402$var$VALUE_REGEX);
        var ret = pos({
            type: $e6180cccd6a5c402$var$TYPE_DECLARATION,
            property: $e6180cccd6a5c402$var$trim(prop[0].replace($e6180cccd6a5c402$var$COMMENT_REGEX, $e6180cccd6a5c402$var$EMPTY_STRING)),
            value: val ? $e6180cccd6a5c402$var$trim(val[0].replace($e6180cccd6a5c402$var$COMMENT_REGEX, $e6180cccd6a5c402$var$EMPTY_STRING)) : $e6180cccd6a5c402$var$EMPTY_STRING
        });
        // ;
        match($e6180cccd6a5c402$var$SEMICOLON_REGEX);
        return ret;
    }
    /**
   * Parse declarations.
   *
   * @return {Object[]}
   */ function declarations() {
        var decls = [];
        comments(decls);
        // declarations
        var decl;
        while(decl = declaration())if (decl !== false) {
            decls.push(decl);
            comments(decls);
        }
        return decls;
    }
    whitespace();
    return declarations();
};
/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */ function $e6180cccd6a5c402$var$trim(str) {
    return str ? str.replace($e6180cccd6a5c402$var$TRIM_REGEX, $e6180cccd6a5c402$var$EMPTY_STRING) : $e6180cccd6a5c402$var$EMPTY_STRING;
}


/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */ function $a026f656d32a4b2c$var$StyleToObject(style, iterator) {
    var output = null;
    if (!style || typeof style !== 'string') return output;
    var declaration;
    var declarations = $e6180cccd6a5c402$exports(style);
    var hasIterator = typeof iterator === 'function';
    var property;
    var value;
    for(var i = 0, len = declarations.length; i < len; i++){
        declaration = declarations[i];
        property = declaration.property;
        value = declaration.value;
        if (hasIterator) iterator(property, value, declaration);
        else if (value) {
            output || (output = {});
            output[property] = value;
        }
    }
    return output;
}
$a026f656d32a4b2c$exports = $a026f656d32a4b2c$var$StyleToObject;


$4109724e8f83713a$export$d8abd7e5fb6871f9 = $4109724e8f83713a$var$toReact;
$4109724e8f83713a$export$d88ad6fc8b890afd = $4109724e8f83713a$var$childrenToReact;
/**
 * @typedef {JSX.IntrinsicElements} IntrinsicElements
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('unist').Position} Position
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Text} Text
 * @typedef {import('hast').Comment} Comment
 * @typedef {import('hast').DocType} Doctype
 */ /**
 * @typedef Info
 * @property {string?} space
 * @property {string?} attribute
 * @property {string?} property
 * @property {boolean} boolean
 * @property {boolean} booleanish
 * @property {boolean} overloadedBoolean
 * @property {boolean} number
 * @property {boolean} commaSeparated
 * @property {boolean} spaceSeparated
 * @property {boolean} commaOrSpaceSeparated
 * @property {boolean} mustUseProperty
 * @property {boolean} defined
 *
 * @typedef Schema
 * @property {Object.<string, Info>} property
 * @property {Object.<string, string>} normal
 * @property {string?} space
 *
 * @typedef Raw
 * @property {'raw'} type
 * @property {string} value
 *
 * @typedef Context
 * @property {TransformOptions} options
 * @property {Schema} schema
 * @property {number} listDepth
 *
 * @callback TransformLink
 * @param {string} href
 * @param {Array.<Comment|Element|Text>} children
 * @param {string?} title
 * @returns {string}
 *
 * @callback TransformImage
 * @param {string} src
 * @param {string} alt
 * @param {string?} title
 * @returns {string}
 *
 * @callback TransformLinkTarget
 * @param {string} href
 * @param {Array.<Comment|Element|Text>} children
 * @param {string?} title
 * @returns {string|undefined}
 *
 * @typedef {keyof IntrinsicElements} ReactMarkdownNames
 *
 * To do: is `data-sourcepos` typeable?
 *
 * @typedef ReactMarkdownProps
 * @property {Element} node
 * @property {string} key
 * @property {ReactNode[]} children
 * @property {Position?} [sourcePosition] Passed when `options.rawSourcePos` is given
 * @property {number} [index] Passed when `options.includeElementIndex` is given
 * @property {number} [siblingCount] Passed when `options.includeElementIndex` is given
 *
 * @callback CodeComponent
 * @param {JSX.IntrinsicElements['code'] & ReactMarkdownProps & {inline?: boolean}} props
 * @returns {ReactNode}
 *
 * @callback HeadingComponent
 * @param {JSX.IntrinsicElements['h1'] & ReactMarkdownProps & {level: number}} props
 * @returns {ReactNode}
 *
 * @callback LiComponent
 * @param {JSX.IntrinsicElements['li'] & ReactMarkdownProps & {checked: boolean|null, index: number, ordered: boolean}} props
 * @returns {ReactNode}
 *
 * @callback OrderedListComponent
 * @param {JSX.IntrinsicElements['ol'] & ReactMarkdownProps & {depth: number, ordered: true}} props
 * @returns {ReactNode}
 *
 * @callback TableCellComponent
 * @param {JSX.IntrinsicElements['table'] & ReactMarkdownProps & {style?: Object.<string, unknown>, isHeader: boolean}} props
 * @returns {ReactNode}
 *
 * @callback TableRowComponent
 * @param {JSX.IntrinsicElements['tr'] & ReactMarkdownProps & {isHeader: boolean}} props
 * @returns {ReactNode}
 *
 * @callback UnorderedListComponent
 * @param {JSX.IntrinsicElements['ul'] & ReactMarkdownProps & {depth: number, ordered: false}} props
 * @returns {ReactNode}
 *
 * @typedef SpecialComponents
 * @property {CodeComponent|ReactMarkdownNames} code
 * @property {HeadingComponent|ReactMarkdownNames} h1
 * @property {HeadingComponent|ReactMarkdownNames} h2
 * @property {HeadingComponent|ReactMarkdownNames} h3
 * @property {HeadingComponent|ReactMarkdownNames} h4
 * @property {HeadingComponent|ReactMarkdownNames} h5
 * @property {HeadingComponent|ReactMarkdownNames} h6
 * @property {LiComponent|ReactMarkdownNames} li
 * @property {OrderedListComponent|ReactMarkdownNames} ol
 * @property {TableCellComponent|ReactMarkdownNames} td
 * @property {TableCellComponent|ReactMarkdownNames} th
 * @property {TableRowComponent|ReactMarkdownNames} tr
 * @property {UnorderedListComponent|ReactMarkdownNames} ul
 *
 * @typedef {{[TagName in keyof IntrinsicElements]: TagName | ((props: IntrinsicElements[TagName] & ReactMarkdownProps) => ReactNode)}} NormalComponents
 * @typedef {Partial<Omit<NormalComponents, keyof SpecialComponents> & SpecialComponents>} Components
 */ /**
 * @typedef TransformOptions
 * @property {boolean} [sourcePos=false]
 * @property {boolean} [rawSourcePos=false]
 * @property {boolean} [skipHtml=false]
 * @property {boolean} [includeElementIndex=false]
 * @property {null|false|TransformLink} [transformLinkUri]
 * @property {TransformImage} [transformImageUri]
 * @property {string|TransformLinkTarget} [linkTarget]
 * @property {Components} [components]
 */ const $4109724e8f83713a$var$own = {}.hasOwnProperty;
// The table-related elements that must not contain whitespace text according
// to React.
const $4109724e8f83713a$var$tableElements = new Set([
    'table',
    'thead',
    'tbody',
    'tfoot',
    'tr'
]);
/**
 * @param {Context} context
 * @param {Element|Root} node
 */ function $4109724e8f83713a$var$childrenToReact(context, node) {
    /** @type {Array.<ReactNode>} */ const children = [];
    let childIndex = -1;
    /** @type {Comment|Doctype|Element|Raw|Text} */ let child;
    while(++childIndex < node.children.length){
        child = node.children[childIndex];
        if (child.type === 'element') children.push($4109724e8f83713a$var$toReact(context, child, childIndex, node));
        else if (child.type === 'text') // React does not permit whitespace text elements as children of table:
        // cf. https://github.com/remarkjs/react-markdown/issues/576
        {
            if (node.type !== 'element' || !$4109724e8f83713a$var$tableElements.has(node.tagName) || child.value !== '\n') children.push(child.value);
        } else if (child.type === 'raw' && !context.options.skipHtml) // Default behavior is to show (encoded) HTML.
        // @ts-expect-error `raw` nodes are non-standard
        children.push(child.value);
    }
    return children;
}
/**
 * @param {Context} context
 * @param {Element} node
 * @param {number} index
 * @param {Element|Root} parent
 */ function $4109724e8f83713a$var$toReact(context, node, index, parent) {
    const options = context.options;
    const parentSchema = context.schema;
    /** @type {ReactMarkdownNames} */ // @ts-expect-error assume a known HTML/SVG element.
    const name = node.tagName;
    /** @type {Object.<string, unknown>} */ const properties = {};
    let schema = parentSchema;
    /** @type {string} */ let property;
    if (parentSchema.space === 'html' && name === 'svg') {
        schema = $89f200badabc8da1$exports;
        context.schema = schema;
    }
    /* istanbul ignore else - types say they’re optional. */ if (node.properties) {
        for(property in node.properties)/* istanbul ignore else - prototype polution. */ if ($4109724e8f83713a$var$own.call(node.properties, property)) $4109724e8f83713a$var$addProperty(properties, property, node.properties[property], context);
    }
    if (name === 'ol' || name === 'ul') context.listDepth++;
    const children = $4109724e8f83713a$var$childrenToReact(context, node);
    if (name === 'ol' || name === 'ul') context.listDepth--;
    // Restore parent schema.
    context.schema = parentSchema;
    // Nodes created by plugins do not have positional info, in which case we use
    // an object that matches the positon interface.
    const position = node.position || {
        start: {
            line: null,
            column: null,
            offset: null
        },
        end: {
            line: null,
            column: null,
            offset: null
        }
    };
    const component = options.components && $4109724e8f83713a$var$own.call(options.components, name) ? options.components[name] : name;
    const basic = typeof component === 'string' || component === $NdCUR.Fragment;
    if (!$cd2b54b2fab3a898$exports.isValidElementType(component)) throw new TypeError(`Component for name \`${name}\` not defined or is not renderable`);
    properties.key = [
        name,
        position.start.line,
        position.start.column,
        index
    ].join('-');
    if (name === 'a' && options.linkTarget) properties.target = typeof options.linkTarget === 'function' ? options.linkTarget(properties.href, node.children, properties.title) : options.linkTarget;
    if (name === 'a' && options.transformLinkUri) properties.href = options.transformLinkUri(// @ts-expect-error assume `href` is a string
    properties.href, node.children, properties.title);
    if (!basic && name === 'code' && parent.type === 'element' && parent.tagName !== 'pre') properties.inline = true;
    if (!basic && (name === 'h1' || name === 'h2' || name === 'h3' || name === 'h4' || name === 'h5' || name === 'h6')) properties.level = parseInt(name.charAt(1), 10);
    if (name === 'img' && options.transformImageUri) properties.src = options.transformImageUri(// @ts-expect-error assume `src` is a string
    properties.src, properties.alt, properties.title);
    if (!basic && name === 'li' && parent.type === 'element') {
        const input = $4109724e8f83713a$var$getInputElement(node);
        properties.checked = input && input.properties ? Boolean(input.properties.checked) : null;
        properties.index = $4109724e8f83713a$var$getElementsBeforeCount(parent, node);
        properties.ordered = parent.tagName === 'ol';
    }
    if (!basic && (name === 'ol' || name === 'ul')) {
        properties.ordered = name === 'ol';
        properties.depth = context.listDepth;
    }
    if (name === 'td' || name === 'th') {
        if (properties.align) {
            if (!properties.style) properties.style = {};
            // @ts-expect-error assume `style` is an object
            properties.style.textAlign = properties.align;
            delete properties.align;
        }
        if (!basic) properties.isHeader = name === 'th';
    }
    if (!basic && name === 'tr' && parent.type === 'element') properties.isHeader = Boolean(parent.tagName === 'thead');
    // If `sourcePos` is given, pass source information (line/column info from markdown source).
    if (options.sourcePos) properties['data-sourcepos'] = $4109724e8f83713a$var$flattenPosition(position);
    if (!basic && options.rawSourcePos) properties.sourcePosition = node.position;
    // If `includeElementIndex` is given, pass node index info to components.
    if (!basic && options.includeElementIndex) {
        properties.index = $4109724e8f83713a$var$getElementsBeforeCount(parent, node);
        properties.siblingCount = $4109724e8f83713a$var$getElementsBeforeCount(parent);
    }
    if (!basic) properties.node = node;
    // Ensure no React warnings are emitted for void elements w/ children.
    return children.length > 0 ? $NdCUR.createElement(component, properties, children) : $NdCUR.createElement(component, properties);
}
/**
 * @param {Element|Root} node
 * @returns {Element?}
 */ function $4109724e8f83713a$var$getInputElement(node) {
    let index = -1;
    while(++index < node.children.length){
        const child = node.children[index];
        if (child.type === 'element' && child.tagName === 'input') return child;
    }
    return null;
}
/**
 * @param {Element|Root} parent
 * @param {Element} [node]
 * @returns {number}
 */ function $4109724e8f83713a$var$getElementsBeforeCount(parent, node) {
    let index = -1;
    let count = 0;
    while(++index < parent.children.length){
        if (parent.children[index] === node) break;
        if (parent.children[index].type === 'element') count++;
    }
    return count;
}
/**
 * @param {Object.<string, unknown>} props
 * @param {string} prop
 * @param {unknown} value
 * @param {Context} ctx
 */ function $4109724e8f83713a$var$addProperty(props, prop, value, ctx) {
    /** @type {Info} */ const info = $f684eeaae89bffe2$exports(ctx.schema, prop);
    let result = value;
    // Ignore nullish and `NaN` values.
    // eslint-disable-next-line no-self-compare
    if (result === null || result === undefined || result !== result) return;
    // Accept `array`.
    // Most props are space-separated.
    if (result && typeof result === 'object' && 'length' in result) // type-coverage:ignore-next-line remove when typed.
    result = (info.commaSeparated ? $cce03bc2f3fec0fc$exports : $ec965cf8923cefe1$exports).stringify(result);
    if (info.property === 'style' && typeof result === 'string') result = $4109724e8f83713a$var$parseStyle(result);
    /* istanbul ignore else - types say they’re optional. */ if (info.space && info.property) props[$4109724e8f83713a$var$own.call($4c01cfc1354c934c$exports, info.property) ? $4c01cfc1354c934c$exports[info.property] : info.property] = result;
    else if (info.attribute) props[info.attribute] = result;
}
/**
 * @param {string} value
 * @returns {Object.<string, string>}
 */ function $4109724e8f83713a$var$parseStyle(value) {
    /** @type {Object.<string, string>} */ const result = {};
    try {
        $a026f656d32a4b2c$exports(value, iterator);
    } catch (/** @type {unknown} */ _) {
    // Silent.
    }
    return result;
    /**
   * @param {string} name
   * @param {string} v
   */ function iterator(name, v) {
        const k = name.slice(0, 4) === '-ms-' ? `ms-${name.slice(4)}` : name;
        result[k.replace(/-([a-z])/g, $4109724e8f83713a$var$styleReplacer)] = v;
    }
}
/**
 * @param {unknown} _
 * @param {string} $1
 */ function $4109724e8f83713a$var$styleReplacer(_, $1) {
    return $1.toUpperCase();
}
/**
 * @param {Position|{start: {line: null, column: null, offset: null}, end: {line: null, column: null, offset: null}}} pos
 * @returns {string}
 */ function $4109724e8f83713a$var$flattenPosition(pos) {
    return [
        pos.start.line,
        ':',
        pos.start.column,
        '-',
        pos.end.line,
        ':',
        pos.end.column
    ].map((d)=>String(d)).join('');
}


var $ff69c7c0605f9fd2$require$childrenToReact = $4109724e8f83713a$export$d88ad6fc8b890afd;
/**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('react').ReactElement<{}>} ReactElement
 * @typedef {import('unified').PluggableList} PluggableList
 * @typedef {import('hast').Root} Root
 * @typedef {import('./rehype-filter.js').RehypeFilterOptions} FilterOptions
 * @typedef {import('./ast-to-react.js').TransformOptions} TransformOptions
 *
 * @typedef CoreOptions
 * @property {string} children
 *
 * @typedef PluginOptions
 * @property {PluggableList} [plugins=[]] **deprecated**: use `remarkPlugins` instead
 * @property {PluggableList} [remarkPlugins=[]]
 * @property {PluggableList} [rehypePlugins=[]]
 *
 * @typedef LayoutOptions
 * @property {string} [className]
 *
 * @typedef {CoreOptions & PluginOptions & LayoutOptions & FilterOptions & TransformOptions} ReactMarkdownOptions
 */ $ff69c7c0605f9fd2$exports = $ff69c7c0605f9fd2$var$ReactMarkdown;
const $ff69c7c0605f9fd2$var$own = {}.hasOwnProperty;
const $ff69c7c0605f9fd2$var$changelog = 'https://github.com/remarkjs/react-markdown/blob/main/changelog.md';
/**
 * @typedef Deprecation
 * @property {string} id
 * @property {string} [to]
 */ /**
 * @type {Object.<string, Deprecation>}
 */ const $ff69c7c0605f9fd2$var$deprecated = {
    renderers: {
        to: 'components',
        id: 'change-renderers-to-components'
    },
    astPlugins: {
        id: 'remove-buggy-html-in-markdown-parser'
    },
    allowDangerousHtml: {
        id: 'remove-buggy-html-in-markdown-parser'
    },
    escapeHtml: {
        id: 'remove-buggy-html-in-markdown-parser'
    },
    source: {
        to: 'children',
        id: 'change-source-to-children'
    },
    allowNode: {
        to: 'allowElement',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes'
    },
    allowedTypes: {
        to: 'allowedElements',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes'
    },
    disallowedTypes: {
        to: 'disallowedElements',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes'
    },
    includeNodeIndex: {
        to: 'includeElementIndex',
        id: 'change-includenodeindex-to-includeelementindex'
    }
};
/**
 * @param {ReactMarkdownOptions} options
 * @returns {ReactElement}
 */ function $ff69c7c0605f9fd2$var$ReactMarkdown(options) {
    for(const key in $ff69c7c0605f9fd2$var$deprecated)if ($ff69c7c0605f9fd2$var$own.call($ff69c7c0605f9fd2$var$deprecated, key) && $ff69c7c0605f9fd2$var$own.call(options, key)) {
        /** @type {Deprecation} */ const deprecation = $ff69c7c0605f9fd2$var$deprecated[key];
        console.warn(`[react-markdown] Warning: please ${deprecation.to ? `use \`${deprecation.to}\` instead of` : 'remove'} \`${key}\` (see <${$ff69c7c0605f9fd2$var$changelog}#${deprecation.id}> for more info)`);
        delete $ff69c7c0605f9fd2$var$deprecated[key];
    }
    const processor = $b9ae0a596083e0cf$exports().use($5531e72d137601a5$exports)// TODO: deprecate `plugins` in v7.0.0.
    .use(options.remarkPlugins || options.plugins || []).use($65b30ef505dd219f$exports, {
        allowDangerousHtml: true
    }).use(options.rehypePlugins || []).use($9a8e86b12b0e5913$exports, options);
    /** @type {vfile} */ let file;
    if (typeof options.children === 'string') file = $e854e354124f8583$exports(options.children);
    else {
        if (options.children !== undefined && options.children !== null) console.warn(`[react-markdown] Warning: please pass a string as \`children\` (not: \`${options.children}\`)`);
        file = $e854e354124f8583$exports();
    }
    /** @type {Root} */ // @ts-expect-error we’ll throw if it isn’t a root next.
    const hastNode = processor.runSync(processor.parse(file), file);
    if (hastNode.type !== 'root') throw new TypeError('Expected a `root` node');
    /** @type {ReactElement} */ let result = $NdCUR.createElement($NdCUR.Fragment, {}, $ff69c7c0605f9fd2$require$childrenToReact({
        options: options,
        schema: $0313be7775ad9c20$exports,
        listDepth: 0
    }, hastNode));
    if (options.className) result = $NdCUR.createElement('div', {
        className: options.className
    }, result);
    return result;
}
$ff69c7c0605f9fd2$var$ReactMarkdown.defaultProps = {
    transformLinkUri: $d40bff02d2225b9a$exports
};
$ff69c7c0605f9fd2$var$ReactMarkdown.propTypes = {
    // Core options:
    children: $fGw9V.string,
    // Layout options:
    className: $fGw9V.string,
    // Filter options:
    allowElement: $fGw9V.func,
    allowedElements: $fGw9V.arrayOf($fGw9V.string),
    disallowedElements: $fGw9V.arrayOf($fGw9V.string),
    unwrapDisallowed: $fGw9V.bool,
    // Plugin options:
    // type-coverage:ignore-next-line
    remarkPlugins: $fGw9V.arrayOf($fGw9V.oneOfType([
        $fGw9V.object,
        $fGw9V.func,
        $fGw9V.arrayOf($fGw9V.oneOfType([
            $fGw9V.object,
            $fGw9V.func
        ]))
    ])),
    // type-coverage:ignore-next-line
    rehypePlugins: $fGw9V.arrayOf($fGw9V.oneOfType([
        $fGw9V.object,
        $fGw9V.func,
        $fGw9V.arrayOf($fGw9V.oneOfType([
            $fGw9V.object,
            $fGw9V.func
        ]))
    ])),
    // Transform options:
    sourcePos: $fGw9V.bool,
    rawSourcePos: $fGw9V.bool,
    skipHtml: $fGw9V.bool,
    includeElementIndex: $fGw9V.bool,
    transformLinkUri: $fGw9V.oneOfType([
        $fGw9V.func,
        $fGw9V.bool
    ]),
    linkTarget: $fGw9V.oneOfType([
        $fGw9V.func,
        $fGw9V.string
    ]),
    transformImageUri: $fGw9V.func,
    components: $fGw9V.object
};
$ff69c7c0605f9fd2$var$ReactMarkdown.uriTransformer = $d40bff02d2225b9a$exports;



const $8450edce046a69e2$export$11d70625c9cbd359 = (text)=>{
    if (text) return text.replace(/&gt;/g, '>').replace(/&#39;/g, "'");
    return '';
};




class $5a3be1671ef7b74f$var$LayoutCellNote extends (0, $NdCUR.Component) {
    render() {
        const { note: note, cellType: cellType, visibility: visibility } = this.props;
        if (!note || note === '' || cellType === (0, $b4506126e09430df$export$705e36171f4cbbfe).Note || visibility === (0, $b4506126e09430df$export$2c5a562a272706f8).ShowWhenNoData) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "dash-graph--note"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "dash-graph--note-icon",
            style: this.noteIconStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon chat"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.noteContentsClass
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), {
            autoHide: false,
            autoHeight: true,
            maxHeight: 140
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "dash-graph--note-contents"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ff69c7c0605f9fd2$exports))), {
            className: "markdown-format"
        }, (0, $8450edce046a69e2$export$11d70625c9cbd359)(note))))));
    }
    get noteIconStyle() {
        const { cellBackgroundColor: cellBackgroundColor, cellTextColor: cellTextColor } = this.props;
        if (cellBackgroundColor !== (0, $9a9ec629fdd38845$export$bd9dc338f9c12ec3)) return {
            color: cellTextColor
        };
    }
    get noteContentsClass() {
        const { cellX: cellX, cellY: cellY } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('dash-graph--note-tooltip', {
            'dash-graph--note__top': cellY === 0,
            'dash-graph--note__bottom': cellY > 0,
            'dash-graph--note__left': cellX > 0,
            'dash-graph--note__right': cellX === 0
        });
    }
}
var $5a3be1671ef7b74f$export$2e2bcd8739ae039 = $5a3be1671ef7b74f$var$LayoutCellNote;






var $hBdgJ = parcelRequire("hBdgJ");

var $axd2S = parcelRequire("axd2S");

var $b0uZf = parcelRequire("b0uZf");
const $4df9fb1dcd0c24df$export$3ae94a2503e890a1 = (timestamp)=>(0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(timestamp).format('M/D/YYYY h:mm:ss.SSSSSSSSS A');
const $4df9fb1dcd0c24df$export$73d4febfebc3e99d = ([titleRow, ...valueRows])=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEmpty(titleRow)) return '';
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEmpty(valueRows)) return [
        'date',
        titleRow.slice(1)
    ].join(',');
    if (titleRow[0] === 'time') {
        const titlesString = [
            'date',
            titleRow.slice(1)
        ].join(',');
        const valuesString = (0, $b0uZf.map)(valueRows, ([timestamp, ...values])=>[
                [
                    $4df9fb1dcd0c24df$export$3ae94a2503e890a1(timestamp),
                    ...values
                ].join(',')
            ]).join('\n');
        return `${titlesString}\n${valuesString}`;
    }
    const allRows = [
        titleRow,
        ...valueRows
    ];
    const allRowsStringArray = (0, $b0uZf.map)(allRows, (r)=>r.join(','));
    return allRowsStringArray.join('\n');
};


function $4e86f29e59d731b4$export$61f84df1ca3d669(subject, iterator, initialValue) {
    const length = subject.length;
    let i;
    let result;
    if (initialValue === undefined) {
        i = 1;
        result = subject[0];
    } else {
        i = 0;
        result = initialValue;
    }
    for(; i < length; i++)result = iterator(result, subject[i], i, subject);
    return result;
}
function $4e86f29e59d731b4$export$979fdb12e1580393(subject, iterator) {
    const length = subject.length;
    const result = new Array(length);
    for(let i = 0; i < length; i++)result[i] = iterator(subject[i], i, subject);
    return result;
}
function $4e86f29e59d731b4$export$d3cadc0dbdb0aafa(subject, iterator) {
    const length = subject.length;
    const result = [];
    for(let i = 0; i < length; i++)if (iterator(subject[i], i, subject)) result.push(subject[i]);
    return result;
}
function $4e86f29e59d731b4$export$d596ecf47a8e8b93(subject, iterator) {
    const length = subject.length;
    for(let i = 0; i < length; i++)iterator(subject[i], i, subject);
}
function $4e86f29e59d731b4$export$155cf72f1717903a(...args) {
    const length = args.length;
    const arr = [];
    let item = [];
    let childLength = 0;
    for(let i = 0; i < length; i++){
        item = args[i];
        if (Array.isArray(item)) {
            childLength = item.length;
            for(let j = 0; j < childLength; j++)arr.push(item[j]);
        } else arr.push(item);
    }
    return arr;
}
function $4e86f29e59d731b4$export$68e6fb3363e57611(input) {
    const length = input.length;
    const cloned = new Array(length);
    for(let i = 0; i < length; i++)cloned[i] = input[i];
    return cloned;
}



const $4420ff9299c1c25c$export$6f8771e84995407d = async (raw, pathname = '')=>{
    const result = await (0, $3a006c970d7cf650$export$a6385bddcc8e6b77).timeSeriesToDygraph(raw, pathname);
    const { timeSeries: timeSeries } = result;
    let unsupportedValue;
    const newTimeSeries = (0, $4e86f29e59d731b4$export$979fdb12e1580393)(timeSeries, ([time, ...values])=>{
        if (unsupportedValue === undefined) unsupportedValue = values.find((x)=>x !== null && typeof x !== 'number');
        return [
            new Date(time),
            ...values
        ];
    });
    return {
        ...result,
        timeSeries: newTimeSeries,
        unsupportedValue: unsupportedValue
    };
};
const $4420ff9299c1c25c$export$7aed24273b682d1e = async (raw)=>{
    return await (0, $3a006c970d7cf650$export$a6385bddcc8e6b77).timeSeriesToTableGraph(raw);
};



// Libraries

var $axd2S = parcelRequire("axd2S");


/* eslint-disable @typescript-eslint/no-redundant-type-constituents */ 




// Types
const $6e043f3c946cd3bd$export$2c0e528ae5e9a9b3 = 'skipped';


function $5ecbe528a4dce188$export$fb39b3f5106bb554(source, queries, templates, uuid) {
    return new Promise((resolve)=>{
        const results = [];
        let counter = queries.length;
        for(let i = 0; i < queries.length; i++){
            const q = queries[i];
            if (q.queryConfig?.isExcluded && !q.queryConfig.status?.isManuallySubmitted) {
                results[i] = {
                    value: null,
                    error: (0, $6e043f3c946cd3bd$export$2c0e528ae5e9a9b3)
                };
                counter -= 1;
                if (counter === 0) resolve(results);
                continue;
            }
            $5ecbe528a4dce188$export$786299a18b5685fc(source, queries[i], templates, uuid).then((result)=>results[i] = {
                    value: result,
                    error: null
                }).catch((result)=>results[i] = {
                    value: null,
                    error: result
                })// eslint-disable-next-line no-loop-func
            .then(()=>{
                counter -= 1;
                if (counter === 0) resolve(results);
            });
        }
    });
}
const $5ecbe528a4dce188$export$786299a18b5685fc = async (source, query, templates, uuid)=>{
    const text = await $5ecbe528a4dce188$var$replace(query.text, source, templates);
    const { data: data } = await (0, $aea829e093f1eddb$export$923f96dd5afa9ce6)({
        source: source.links.proxy,
        rp: query.queryConfig?.retentionPolicy,
        query: text,
        db: query.queryConfig?.database,
        uuid: uuid
    });
    return data;
};
const $5ecbe528a4dce188$var$replace = async (query, source, templates)=>{
    const templateReplacedQuery = (0, $d9ab469c58284fd8$export$2e2bcd8739ae039)(query, templates);
    if (!templateReplacedQuery.includes((0, $e10a8602f56394e3$export$77e8fbcbea0ce430))) return templateReplacedQuery;
    const durationMs = await $5ecbe528a4dce188$export$1f34108aa9eb96ab(templateReplacedQuery, source);
    const replacedQuery = (0, $d9ab469c58284fd8$export$4d691f96d56ae2ff)(templateReplacedQuery, durationMs);
    return replacedQuery;
};
const $5ecbe528a4dce188$export$1f34108aa9eb96ab = async (query, source)=>{
    const analysis = await (0, $3bff70d0456af5c0$export$fb88ec638e36f3fd)(source.links.queries, [
        {
            query: query
        }
    ]);
    const queryDuration = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(analysis, '0.durationMs', (0, $e10a8602f56394e3$export$683c77e30cbb1076));
    return queryDuration;
};







const $574ac1b431fc0723$export$1ab6d957e7a2fb4d = async (request)=>{
    const { url: url, body: body } = request;
    const { data: data, status: status } = await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
        method: 'POST',
        url: url,
        data: {
            body: body
        }
    });
    if (status !== 200) throw new Error('Failed to parse query');
    if (!data.valid) throw new Error(data.error);
    return data.ast;
};


const $96edc64b6d349da4$export$b212ce79c2437839 = async (url, query)=>{
    if (!url) return {
        imports: '',
        body: query
    };
    const ast = await (0, $574ac1b431fc0723$export$1ab6d957e7a2fb4d)({
        url: url,
        body: query
    });
    const { imports: imports, body: body } = ast.files[0];
    const importStatements = (imports || []).map((i)=>i.location.source).join('\n');
    const bodyStatements = (body || []).map((b)=>b.location.source).join('\n');
    return {
        imports: importStatements,
        body: bodyStatements
    };
};



var $hBdgJ = parcelRequire("hBdgJ");

async function $70bc03cbe9476f79$export$9e87bc6c16545701(astLink, fluxQuery) {
    if (!astLink) return 600000;
    const ast = await (0, $574ac1b431fc0723$export$1ab6d957e7a2fb4d)({
        url: astLink,
        body: fluxQuery
    });
    const result = $70bc03cbe9476f79$export$c0542a03c6e37e7c(ast);
    return result;
}
function $70bc03cbe9476f79$export$c0542a03c6e37e7c(ast) {
    // We can't take the minimum of durations of each range individually, since
    // seperate ranges are potentially combined via an inner `join` call. So the
    // approach is to:
    //
    // 1. Find every possible `[start, stop]` combination for all start and stop
    //    times across every `range` call
    // 2. Map each combination to a duration via `stop - start`
    // 3. Filter out the non-positive durations
    // 4. Take the minimum duration
    //
    const times = $70bc03cbe9476f79$export$330f7051370febe3(ast);
    const starts = times.map((t)=>t[0]);
    const stops = times.map((t)=>t[1]);
    const crossProduct = starts.map((start)=>stops.map((stop)=>[
                start,
                stop
            ]));
    const durations = [].concat(...crossProduct).map(([start, stop])=>stop - start).filter((d)=>d > 0);
    const result = Math.min(...durations);
    return result;
}
function $70bc03cbe9476f79$export$330f7051370febe3(ast) {
    const now = Date.now();
    return $70bc03cbe9476f79$var$findNodes($70bc03cbe9476f79$var$isRangeNode, ast).map((node)=>$70bc03cbe9476f79$var$rangeTimes(ast, node, now));
}
/*
  Given a `range` call in an AST, reports the `start` and `stop` arguments the
  the call as absolute instants in time. If the `start` or `stop` argument is a
  relative duration literal, it is interpreted as relative to now (`Date.now()`).
*/ function $70bc03cbe9476f79$var$rangeTimes(ast, rangeNode, now) {
    const properties = rangeNode.arguments[0].properties;
    // The `start` argument is required
    const startProperty = properties.find((p)=>p.key.name === 'start');
    const start = $70bc03cbe9476f79$var$propertyTime(ast, startProperty.value, now);
    // The `end` argument to a `range` call is optional, and defaults to now
    const endProperty = properties.find((p)=>p.key.name === 'stop');
    const end = endProperty ? $70bc03cbe9476f79$var$propertyTime(ast, endProperty.value, now) : now;
    if (isNaN(start) || isNaN(end)) throw new Error('failed to analyze query');
    return [
        start,
        end
    ];
}
function $70bc03cbe9476f79$var$propertyTime(ast, value, now) {
    switch(value.type){
        case 'UnaryExpression':
            return now - $70bc03cbe9476f79$var$durationDuration(value.argument);
        case 'DurationLiteral':
            return now + $70bc03cbe9476f79$var$durationDuration(value);
        case 'DateTimeLiteral':
            return Date.parse(value.value);
        case 'IntegerLiteral':
            return new Date(+value.value * 1000).getTime();
        case 'Identifier':
            return $70bc03cbe9476f79$var$propertyTime(ast, $70bc03cbe9476f79$var$resolveDeclaration(ast, value.name), now);
        case 'MemberExpression':
            return $70bc03cbe9476f79$var$propertyTime(ast, $70bc03cbe9476f79$var$resolveDeclaration(ast, value.object.name, value.property.name), now);
        case 'BinaryExpression':
            {
                const leftTime = Date.parse(value.left.value);
                const rightDuration = $70bc03cbe9476f79$var$durationDuration(value.right);
                switch(value.operator){
                    case '+':
                        return leftTime + rightDuration;
                    case '-':
                        return leftTime - rightDuration;
                }
            }
    }
}
const $70bc03cbe9476f79$var$UNIT_TO_APPROX_DURATION = {
    ns: 0.000001,
    "\xb5s": 0.001,
    us: 0.001,
    ms: 1,
    s: 1000,
    m: 60000,
    h: 3600000,
    d: 86400000,
    w: 604800000,
    mo: 2592000000,
    y: 31536000000
};
function $70bc03cbe9476f79$var$durationDuration(durationLiteral) {
    const duration = durationLiteral.values.reduce((sum, { magnitude: magnitude, unit: unit })=>sum + magnitude * $70bc03cbe9476f79$var$UNIT_TO_APPROX_DURATION[unit], 0);
    return duration;
}
/*
  Find the node in the `ast` that defines the value of the variable with the
  given `name`.
*/ function $70bc03cbe9476f79$var$resolveDeclaration(ast, name, property) {
    const isDeclarator = (node)=>{
        return (0, $hBdgJ.get)(node, 'type') === 'VariableAssignment' && (0, $hBdgJ.get)(node, 'id.name') === name;
    };
    const declarator = $70bc03cbe9476f79$var$findNodes(isDeclarator, ast);
    if (!declarator.length) throw new Error(`unable to resolve identifier "${name}"`);
    if (declarator.length > 1) throw new Error('cannot resolve identifier with duplicate declarations');
    const init = declarator[0].init;
    // init can be an ObjectExpression, extract the property when known
    if (property && Array.isArray(init.properties)) {
        const propVal = (0, $hBdgJ.find)(init.properties, (x)=>x.key.name === property);
        if (!propVal) throw new Error(`cannot resolve object expression ${name}.${propVal}`);
        return propVal.value;
    }
    return init;
}
function $70bc03cbe9476f79$var$isRangeNode(node) {
    return (0, $hBdgJ.get)(node, 'type') === 'CallExpression' && (0, $hBdgJ.get)(node, 'callee.type') === 'Identifier' && (0, $hBdgJ.get)(node, 'callee.name') === 'range';
}
/*
  Find all nodes in a tree matching the `predicate` function. Each node in the
  tree is an object, which may contain objects or arrays of objects as children
  under any key.
*/ function $70bc03cbe9476f79$var$findNodes(predicate, node, acc = []) {
    if (predicate(node)) acc.push(node);
    for (const value of Object.values(node)){
        if ((0, $hBdgJ.isObject)(value)) $70bc03cbe9476f79$var$findNodes(predicate, value, acc);
        else if ((0, $hBdgJ.isArray)(value)) for (const innerValue of value)$70bc03cbe9476f79$var$findNodes(predicate, innerValue, acc);
    }
    return acc;
}



const $31b9ad045b09659f$export$8ba01d856b30a62e = 'v.timeRangeStart';
const $31b9ad045b09659f$export$98c78465c580e509 = 'v.timeRangeStop';
const $31b9ad045b09659f$export$d80c7b1ab8f7391f = 'v.windowPeriod';
const $31b9ad045b09659f$var$INTERVAL_REGEX = /autoInterval|v\.windowPeriod/g;
function $31b9ad045b09659f$var$templateVariableValue(template) {
    let value = '';
    if (template.values.length) for (const tmplVal of template.values){
        if (tmplVal.localSelected) {
            value = tmplVal.value;
            break;
        }
        if (tmplVal.selected) value = tmplVal.value;
    }
    return (0, $20f55d6bf1566b03$export$2e2bcd8739ae039)(value);
}
function $31b9ad045b09659f$var$templateVariables(templates) {
    const extras = (templates || []).filter((x)=>x.id !== 'dashtime' && x.id !== 'upperdashtime' && x.id !== 'interval' && x.tempVar.startsWith(':') && x.tempVar.endsWith(':') && x.values).map((t)=>{
        return ` "${t.tempVar.substring(1, t.tempVar.length - 1)}" : ${$31b9ad045b09659f$var$templateVariableValue(t)} `;
    }, '');
    return extras.length ? `${extras.join(',')} ,` : '';
}
function $31b9ad045b09659f$var$fluxVariables(lower, upper, extraVars, interval) {
    // dashboardTime, upperDashboardTime and autoInterval are added for bacward compatibility with 1.8.x
    if (interval) return `dashboardTime = ${lower}\nupperDashboardTime = ${upper}\nautoInterval = ${interval}ms\nv = {${extraVars} timeRangeStart: dashboardTime , timeRangeStop: upperDashboardTime , windowPeriod: autoInterval }`;
    return `dashboardTime = ${lower}\nupperDashboardTime = ${upper}\nv = {${extraVars} timeRangeStart: dashboardTime , timeRangeStop: upperDashboardTime }`;
}
function $31b9ad045b09659f$export$f6d501c8983af57(templates) {
    const lower = templates.find((x)=>x.tempVar === (0, $e10a8602f56394e3$export$24969386fef72130));
    const upper = templates.find((x)=>x.tempVar === (0, $e10a8602f56394e3$export$cb0056005b9f8f1c));
    if (!lower || !upper) return undefined;
    if (lower.values?.[0]?.type === (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).TimeStamp && upper.values?.[0]?.type === (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).TimeStamp) return {
        lower: lower.values?.[0]?.value,
        upper: upper.values?.[0]?.value
    };
    return undefined;
}
const $31b9ad045b09659f$export$49ddf62bc528f276 = async (script, timeRange, templates, astLink)=>{
    let dashboardTime;
    let upperDashboardTime;
    if (timeRange.upper) {
        dashboardTime = timeRange.lower;
        upperDashboardTime = timeRange.upper;
    } else {
        dashboardTime = timeRange.lowerFlux || '-1h';
        upperDashboardTime = new Date().toISOString();
    }
    const { imports: imports, body: body } = await (0, $96edc64b6d349da4$export$b212ce79c2437839)(astLink, script);
    const extraVars = $31b9ad045b09659f$var$templateVariables(templates);
    let variables = $31b9ad045b09659f$var$fluxVariables(dashboardTime, upperDashboardTime, extraVars);
    let rendered = `${variables}\n\n${body}`;
    if (!script.match($31b9ad045b09659f$var$INTERVAL_REGEX)) return `${imports}\n\n${rendered}`;
    let duration;
    try {
        duration = await (0, $70bc03cbe9476f79$export$9e87bc6c16545701)(astLink, rendered);
    } catch (error) {
        console.error(error);
        duration = (0, $e10a8602f56394e3$export$683c77e30cbb1076);
    }
    const interval = (0, $d9ab469c58284fd8$export$6900b3a53b23630e)(duration);
    variables = $31b9ad045b09659f$var$fluxVariables(dashboardTime, upperDashboardTime, extraVars, interval);
    rendered = `${imports}\n\n${variables}\n\n${body}`;
    return rendered;
};



const $e67c1d5c385472c9$export$5806e7ef9ca71a9d = async (queries, templates, timeZone = (0, $a7b864c61f4e95a7$export$d6f132cca63fb222).UTC)=>{
    const responses = await Promise.all(queries.map((query)=>(0, $5ecbe528a4dce188$export$786299a18b5685fc)(query.queryConfig.source, query, templates)));
    const csv = await $e67c1d5c385472c9$var$timeseriesToCSV(responses, timeZone);
    $e67c1d5c385472c9$export$35193a8a641bb1b(csv, $e67c1d5c385472c9$var$csvName());
};
const $e67c1d5c385472c9$export$6118cfcaa4df65e9 = async (source, script, timeRange, templates, fluxASTLink)=>{
    const renderedScript = await (0, $31b9ad045b09659f$export$49ddf62bc528f276)(script, timeRange, templates, fluxASTLink);
    const { csv: csv, didTruncate: didTruncate, rowCount: rowCount } = await (0, $5914150e71c44d02$export$786299a18b5685fc)(source, renderedScript);
    $e67c1d5c385472c9$export$35193a8a641bb1b(csv, $e67c1d5c385472c9$var$csvName());
    return {
        didTruncate: didTruncate,
        rowCount: rowCount
    };
};
const $e67c1d5c385472c9$var$timeseriesToCSV = async (responses, timeZone)=>{
    const wrapped = responses.map((response)=>({
            response: response
        }));
    const tableResponse = await (0, $4420ff9299c1c25c$export$7aed24273b682d1e)(wrapped);
    const table = tableResponse.data;
    if (!table.length) throw new Error('no results');
    const tableHeader = table[0];
    const tableData = table.slice(1);
    const timeIndex = tableHeader.indexOf('time');
    const isLocal = timeZone === (0, $a7b864c61f4e95a7$export$d6f132cca63fb222).Local;
    if (timeIndex > -1) for(let i = 0; i < tableData.length; i++)// Convert times to a (somewhat) human readable ISO8601 string
    tableData[i][timeIndex] = (0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(new Date(tableData[i][timeIndex])).toISOString(isLocal);
    return (0, $22ab81005d9b2ccc$exports.unparse)({
        data: tableData,
        fields: tableHeader
    }, {
        quotes: true
    });
};
const $e67c1d5c385472c9$var$csvName = ()=>{
    // Strange time format since `:` can't be used in a filename
    const now = (0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))().format('YYYY-MM-DD-HH-mm');
    return `${now} Chronograf Data.csv`;
};
const $e67c1d5c385472c9$export$35193a8a641bb1b = (csv, title)=>{
    const blob = new Blob([
        csv
    ], {
        type: 'text/csv'
    });
    const a = document.createElement('a');
    a.href = window.URL.createObjectURL(blob);
    a.target = '_blank';
    a.download = title;
    document.body.appendChild(a);
    a.click();
    a.parentNode.removeChild(a);
};




class $c0c6867ff228b8c4$var$LayoutCell extends (0, $NdCUR.Component) {
    render() {
        const { cell: cell, isEditable: isEditable, cellData: cellData, cellFluxData: cellFluxData, onDeleteCell: onDeleteCell, onCloneCell: onCloneCell, visType: visType, toggleVisType: toggleVisType, isFluxQuery: isFluxQuery } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "dash-graph",
            style: this.cellStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $091cfcd49e339acd$export$2e2bcd8739ae039), {
            requiredRole: (0, $a7910b1002260d34$export$f715f7e27dea2abf)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $f7d656b1dd08c61a$export$2e2bcd8739ae039), {
            cell: cell,
            isEditable: isEditable,
            dataExists: !!(cellData.length || cellFluxData.length),
            onEdit: this.handleSummonOverlay,
            onClone: onCloneCell,
            onDelete: onDeleteCell,
            onCSVDownload: this.handleCSVDownload,
            queries: this.queries,
            isFluxQuery: isFluxQuery,
            visType: visType,
            toggleVisType: toggleVisType
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $5a3be1671ef7b74f$export$2e2bcd8739ae039), {
            visibility: cell.noteVisibility,
            cellType: cell.type,
            note: cell.note,
            cellX: cell.x,
            cellY: cell.y,
            cellBackgroundColor: this.cellBackgroundColor,
            cellTextColor: this.cellTextColor
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $3745f30dfc5d7c7d$export$2e2bcd8739ae039), {
            cellName: this.cellName,
            isEditable: isEditable,
            makeSpaceForCellNote: this.makeSpaceForCellNote,
            cellBackgroundColor: this.cellBackgroundColor,
            cellTextColor: this.cellTextColor
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "dash-graph--container"
        }, this.renderGraph)), this.gradientBorder);
    }
    get makeSpaceForCellNote() {
        const { cell: cell } = this.props;
        return !!cell.note && cell.type !== (0, $b4506126e09430df$export$705e36171f4cbbfe).Note && cell.noteVisibility === (0, $b4506126e09430df$export$2c5a562a272706f8).Default;
    }
    get cellName() {
        const { templates: templates, cell: { name: name } } = this.props;
        const renderedCellName = (0, $d9ab469c58284fd8$export$2e2bcd8739ae039)(name, templates);
        return renderedCellName;
    }
    get queries() {
        const { cell: cell } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(cell, [
            'queries'
        ], []);
    }
    get renderGraph() {
        const { cell: cell, children: children } = this.props;
        if (this.queries.length) {
            const child = (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Children.only(children);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).cloneElement(child, {
                cellID: cell.i,
                onUpdateCellColors: this.onUpdateCellColors
            });
        }
        return this.emptyGraph;
    }
    get emptyGraph() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "graph-empty"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $091cfcd49e339acd$export$2e2bcd8739ae039), {
            requiredRole: (0, $a7910b1002260d34$export$f715f7e27dea2abf)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "no-query--button btn btn-md btn-primary",
            onClick: this.handleSummonOverlay,
            "data-test": "add-data-btn"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon plus"
        }), " Add Data")));
    }
    async downloadInfluxQLCSV() {
        const { cellData: cellData, cell: cell } = this.props;
        const name = `${(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(cell, 'name', '').split(' ').join('_')}.csv`;
        let csv;
        try {
            const { data: data } = await (0, $4420ff9299c1c25c$export$7aed24273b682d1e)(cellData);
            csv = (0, $4df9fb1dcd0c24df$export$73d4febfebc3e99d)(data);
        } catch (error) {
            (0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$fc60433e0406d7a1)());
            console.error(error);
            return;
        }
        (0, $e67c1d5c385472c9$export$35193a8a641bb1b)(csv, name);
    }
    downloadFluxCSV() {
        const { cellFluxData: cellFluxData, cell: cell } = this.props;
        const joinedName = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(cell, 'name', '').split(' ').join('_');
        (0, $e67c1d5c385472c9$export$35193a8a641bb1b)(cellFluxData, joinedName);
    }
    get gradientBorder() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "dash-graph--gradient-border"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "dash-graph--gradient-top-left"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "dash-graph--gradient-top-right"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "dash-graph--gradient-bottom-left"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "dash-graph--gradient-bottom-right"
        }));
    }
    get cellStyle() {
        return {
            backgroundColor: this.cellBackgroundColor,
            borderColor: this.cellBackgroundColor
        };
    }
    constructor(...args){
        super(...args), this.cellBackgroundColor = (0, $9a9ec629fdd38845$export$bd9dc338f9c12ec3), this.cellTextColor = (0, $9a9ec629fdd38845$export$8f907bc493a43910), this.handleSummonOverlay = ()=>{
            const { cell: cell, onSummonOverlayTechnologies: onSummonOverlayTechnologies } = this.props;
            onSummonOverlayTechnologies(cell);
        }, this.handleCSVDownload = async ()=>{
            if (this.props.isFluxQuery) this.downloadFluxCSV();
            else this.downloadInfluxQLCSV();
        }, this.onUpdateCellColors = (bgColor, textColor)=>{
            this.cellBackgroundColor = bgColor || (0, $9a9ec629fdd38845$export$bd9dc338f9c12ec3);
            this.cellTextColor = textColor || (0, $9a9ec629fdd38845$export$8f907bc493a43910);
        };
    }
}
var $c0c6867ff228b8c4$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($c0c6867ff228b8c4$var$LayoutCell);


// Libraries

var $NdCUR = parcelRequire("NdCUR");


var $hBdgJ = parcelRequire("hBdgJ");
function $7ab60400c9be8a6b$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}


function $ce23bd95f695b09b$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $ce23bd95f695b09b$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ce23bd95f695b09b$export$2e2bcd8739ae039(o);
}



function $ec7351c704475ade$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $ce23bd95f695b09b$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $ce23bd95f695b09b$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $a8d928d6af3d03c8$export$2e2bcd8739ae039(t) {
    var i = (0, $ec7351c704475ade$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $ce23bd95f695b09b$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $f742022c5d2ac646$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $a8d928d6af3d03c8$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $f742022c5d2ac646$export$2e2bcd8739ae039(e, r, t) {
    return r && $f742022c5d2ac646$var$_defineProperties(e.prototype, r), t && $f742022c5d2ac646$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}



function $45b2d0714f2ea8c5$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $a26915f7b982dd67$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $ce23bd95f695b09b$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(t);
}


function $eae1db55e7e69c3d$export$2e2bcd8739ae039(t) {
    return $eae1db55e7e69c3d$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $eae1db55e7e69c3d$export$2e2bcd8739ae039(t);
}



function $b82aceeb3d62d08a$export$2e2bcd8739ae039(t, e) {
    return $b82aceeb3d62d08a$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $b82aceeb3d62d08a$export$2e2bcd8739ae039(t, e);
}


function $fe3f597ee5eaea5e$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $b82aceeb3d62d08a$export$2e2bcd8739ae039)(t, e);
}



function $005fda52a7adba61$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $a8d928d6af3d03c8$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}



var $NdCUR = parcelRequire("NdCUR");
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $e7f50e4820b1eac7$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $e7f50e4820b1eac7$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $e7f50e4820b1eac7$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$e7f50e4820b1eac7$var$componentWillMount.__suppressDeprecationWarning = true;
$e7f50e4820b1eac7$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$e7f50e4820b1eac7$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $e7f50e4820b1eac7$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $e7f50e4820b1eac7$var$componentWillMount;
        prototype.componentWillReceiveProps = $e7f50e4820b1eac7$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $e7f50e4820b1eac7$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}











var $NdCUR = parcelRequire("NdCUR");

var $lbxdO = parcelRequire("lbxdO");
/**
 * Helper method that determines when to recalculate row or column metadata.
 */ function $3df9016791526e33$export$2e2bcd8739ae039(_ref) {
    var cellCount = _ref.cellCount, cellSize = _ref.cellSize, computeMetadataCallback = _ref.computeMetadataCallback, computeMetadataCallbackProps = _ref.computeMetadataCallbackProps, nextCellsCount = _ref.nextCellsCount, nextCellSize = _ref.nextCellSize, nextScrollToIndex = _ref.nextScrollToIndex, scrollToIndex = _ref.scrollToIndex, updateScrollOffsetForScrollToIndex = _ref.updateScrollOffsetForScrollToIndex;
    // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
    // In that event users should use the manual recompute methods to inform of changes.
    if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
        computeMetadataCallback(computeMetadataCallbackProps); // Updated cell metadata may have hidden the previous scrolled-to item.
        // In this case we should also update the scrollTop to ensure it stays visible.
        if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) updateScrollOffsetForScrollToIndex();
    }
}



function $c54935d4bae462e6$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $bdedc8073c2ca3ee$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}








parcelRequire("NdCUR");


var $91b2a52445036272$export$c6672e3011d1ba14 = null;
var $91b2a52445036272$export$629e389fcb95c4cb = null;
var $91b2a52445036272$export$dfc898c43d6b42e2 = null;
var $91b2a52445036272$export$f43ca98f92747835 = null;
var $91b2a52445036272$export$4b96dfc4e581b95e = null;
var $91b2a52445036272$export$e59512b25f53b1de = null;
var $91b2a52445036272$export$2eac0c8356154c53 = null;
var $91b2a52445036272$export$6032bf9d66579eb8 = null;
var $91b2a52445036272$export$881fa5755aa5a532 = null;
var $91b2a52445036272$export$fe7633a03acdcfd1 = null;
var $91b2a52445036272$export$bf6962873c294da8 = null;
var $91b2a52445036272$export$52184174be905dd4 = null;
var $91b2a52445036272$export$9534019005791a3c = null;
var $91b2a52445036272$export$7cb061b68d6f54bb = null;
var $91b2a52445036272$export$b27813263ea8fb17 = null;
var $91b2a52445036272$export$6fd1d8de91170d0e = null;
var $91b2a52445036272$export$1f814ddae3c3a0a1 = null;
var $91b2a52445036272$export$33ac8a0817160c66 = null;


/**
 * Just-in-time calculates and caches size and position information for a collection of cells.
 */ var $45f1f4d67b7dd87a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    // Cache of size and position data for cells, mapped by cell index.
    // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex
    // Measurements for cells up to this index can be trusted; cells afterward should be estimated.
    // Used in deferred mode to track which cells have been queued for measurement.
    function CellSizeAndPositionManager(_ref) {
        var cellCount = _ref.cellCount, cellSizeGetter = _ref.cellSizeGetter, estimatedCellSize = _ref.estimatedCellSize;
        (0, $7ab60400c9be8a6b$export$2e2bcd8739ae039)(this, CellSizeAndPositionManager);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)(this, "_cellSizeAndPositionData", {});
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)(this, "_lastMeasuredIndex", -1);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)(this, "_lastBatchedIndex", -1);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)(this, "_cellCount", void 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)(this, "_cellSizeGetter", void 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)(this, "_estimatedCellSize", void 0);
        this._cellSizeGetter = cellSizeGetter;
        this._cellCount = cellCount;
        this._estimatedCellSize = estimatedCellSize;
    }
    (0, $f742022c5d2ac646$export$2e2bcd8739ae039)(CellSizeAndPositionManager, [
        {
            key: "areOffsetsAdjusted",
            value: function areOffsetsAdjusted() {
                return false;
            }
        },
        {
            key: "configure",
            value: function configure(_ref2) {
                var cellCount = _ref2.cellCount, estimatedCellSize = _ref2.estimatedCellSize, cellSizeGetter = _ref2.cellSizeGetter;
                this._cellCount = cellCount;
                this._estimatedCellSize = estimatedCellSize;
                this._cellSizeGetter = cellSizeGetter;
            }
        },
        {
            key: "getCellCount",
            value: function getCellCount() {
                return this._cellCount;
            }
        },
        {
            key: "getEstimatedCellSize",
            value: function getEstimatedCellSize() {
                return this._estimatedCellSize;
            }
        },
        {
            key: "getLastMeasuredIndex",
            value: function getLastMeasuredIndex() {
                return this._lastMeasuredIndex;
            }
        },
        {
            key: "getOffsetAdjustment",
            value: function getOffsetAdjustment() {
                return 0;
            }
        },
        {
            key: "getSizeAndPositionOfCell",
            value: function getSizeAndPositionOfCell(index) {
                if (index < 0 || index >= this._cellCount) throw Error("Requested index ".concat(index, " is outside of range 0..").concat(this._cellCount));
                if (index > this._lastMeasuredIndex) {
                    var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
                    var offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
                    for(var i = this._lastMeasuredIndex + 1; i <= index; i++){
                        var size = this._cellSizeGetter({
                            index: i
                        }); // undefined or NaN probably means a logic error in the size getter.
                        // null means we're using CellMeasurer and haven't yet measured a given index.
                        if (size === undefined || isNaN(size)) throw Error("Invalid size returned for cell ".concat(i, " of value ").concat(size));
                        else if (size === null) {
                            this._cellSizeAndPositionData[i] = {
                                offset: offset,
                                size: 0
                            };
                            this._lastBatchedIndex = index;
                        } else {
                            this._cellSizeAndPositionData[i] = {
                                offset: offset,
                                size: size
                            };
                            offset += size;
                            this._lastMeasuredIndex = index;
                        }
                    }
                }
                return this._cellSizeAndPositionData[index];
            }
        },
        {
            key: "getSizeAndPositionOfLastMeasuredCell",
            value: function getSizeAndPositionOfLastMeasuredCell() {
                return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
                    offset: 0,
                    size: 0
                };
            }
        },
        {
            key: "getTotalSize",
            value: function getTotalSize() {
                var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
                var totalSizeOfMeasuredCells = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
                var numUnmeasuredCells = this._cellCount - this._lastMeasuredIndex - 1;
                var totalSizeOfUnmeasuredCells = numUnmeasuredCells * this._estimatedCellSize;
                return totalSizeOfMeasuredCells + totalSizeOfUnmeasuredCells;
            }
        },
        {
            key: "getUpdatedOffsetForIndex",
            value: function getUpdatedOffsetForIndex(_ref3) {
                var _ref3$align = _ref3.align, align = _ref3$align === void 0 ? 'auto' : _ref3$align, containerSize = _ref3.containerSize, currentOffset = _ref3.currentOffset, targetIndex = _ref3.targetIndex;
                if (containerSize <= 0) return 0;
                var datum = this.getSizeAndPositionOfCell(targetIndex);
                var maxOffset = datum.offset;
                var minOffset = maxOffset - containerSize + datum.size;
                var idealOffset;
                switch(align){
                    case 'start':
                        idealOffset = maxOffset;
                        break;
                    case 'end':
                        idealOffset = minOffset;
                        break;
                    case 'center':
                        idealOffset = maxOffset - (containerSize - datum.size) / 2;
                        break;
                    default:
                        idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
                        break;
                }
                var totalSize = this.getTotalSize();
                return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
            }
        },
        {
            key: "getVisibleCellRange",
            value: function getVisibleCellRange(params) {
                var containerSize = params.containerSize, offset = params.offset;
                var totalSize = this.getTotalSize();
                if (totalSize === 0) return {};
                var maxOffset = offset + containerSize;
                var start = this._findNearestCell(offset);
                var datum = this.getSizeAndPositionOfCell(start);
                offset = datum.offset + datum.size;
                var stop = start;
                while(offset < maxOffset && stop < this._cellCount - 1){
                    stop++;
                    offset += this.getSizeAndPositionOfCell(stop).size;
                }
                return {
                    start: start,
                    stop: stop
                };
            }
        },
        {
            key: "resetCell",
            value: function resetCell(index) {
                this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
            }
        },
        {
            key: "_binarySearch",
            value: function _binarySearch(high, low, offset) {
                while(low <= high){
                    var middle = low + Math.floor((high - low) / 2);
                    var currentOffset = this.getSizeAndPositionOfCell(middle).offset;
                    if (currentOffset === offset) return middle;
                    else if (currentOffset < offset) low = middle + 1;
                    else if (currentOffset > offset) high = middle - 1;
                }
                if (low > 0) return low - 1;
                else return 0;
            }
        },
        {
            key: "_exponentialSearch",
            value: function _exponentialSearch(index, offset) {
                var interval = 1;
                while(index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset){
                    index += interval;
                    interval *= 2;
                }
                return this._binarySearch(Math.min(index, this._cellCount - 1), Math.floor(index / 2), offset);
            }
        },
        {
            key: "_findNearestCell",
            value: function _findNearestCell(offset) {
                if (isNaN(offset)) throw Error("Invalid offset ".concat(offset, " specified"));
                 // Our search algorithms find the nearest match at or below the specified offset.
                // So make sure the offset is at least 0 or no match will be found.
                offset = Math.max(0, offset);
                var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
                var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);
                if (lastMeasuredCellSizeAndPosition.offset >= offset) // If we've already measured cells within this range just use a binary search as it's faster.
                return this._binarySearch(lastMeasuredIndex, 0, offset);
                else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
                // The exponential search avoids pre-computing sizes for the full set of cells as a binary search would.
                // The overall complexity for this approach is O(log n).
                return this._exponentialSearch(lastMeasuredIndex, offset);
            }
        }
    ]);
    return CellSizeAndPositionManager;
}();


var $6003e651370dcf04$var$DEFAULT_MAX_ELEMENT_SIZE = 1500000;
var $6003e651370dcf04$var$CHROME_MAX_ELEMENT_SIZE = 1.67771e7;
var $6003e651370dcf04$var$isBrowser = function isBrowser() {
    return typeof window !== 'undefined';
};
var $6003e651370dcf04$var$isChrome = function isChrome() {
    return !!window.chrome;
};
var $6003e651370dcf04$export$d0dd9fc28a7917e7 = function getMaxElementSize() {
    if ($6003e651370dcf04$var$isBrowser()) {
        if ($6003e651370dcf04$var$isChrome()) return $6003e651370dcf04$var$CHROME_MAX_ELEMENT_SIZE;
    }
    return $6003e651370dcf04$var$DEFAULT_MAX_ELEMENT_SIZE;
};



/**
 * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
 */ var $a25d55465e3b0417$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ScalingCellSizeAndPositionManager(_ref) {
        var _ref$maxScrollSize = _ref.maxScrollSize, maxScrollSize = _ref$maxScrollSize === void 0 ? (0, $6003e651370dcf04$export$d0dd9fc28a7917e7)() : _ref$maxScrollSize, params = (0, $c54935d4bae462e6$export$2e2bcd8739ae039)(_ref, [
            "maxScrollSize"
        ]);
        (0, $7ab60400c9be8a6b$export$2e2bcd8739ae039)(this, ScalingCellSizeAndPositionManager);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)(this, "_cellSizeAndPositionManager", void 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)(this, "_maxScrollSize", void 0);
        // Favor composition over inheritance to simplify IE10 support
        this._cellSizeAndPositionManager = new (0, $45f1f4d67b7dd87a$export$2e2bcd8739ae039)(params);
        this._maxScrollSize = maxScrollSize;
    }
    (0, $f742022c5d2ac646$export$2e2bcd8739ae039)(ScalingCellSizeAndPositionManager, [
        {
            key: "areOffsetsAdjusted",
            value: function areOffsetsAdjusted() {
                return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
            }
        },
        {
            key: "configure",
            value: function configure(params) {
                this._cellSizeAndPositionManager.configure(params);
            }
        },
        {
            key: "getCellCount",
            value: function getCellCount() {
                return this._cellSizeAndPositionManager.getCellCount();
            }
        },
        {
            key: "getEstimatedCellSize",
            value: function getEstimatedCellSize() {
                return this._cellSizeAndPositionManager.getEstimatedCellSize();
            }
        },
        {
            key: "getLastMeasuredIndex",
            value: function getLastMeasuredIndex() {
                return this._cellSizeAndPositionManager.getLastMeasuredIndex();
            }
        },
        {
            key: "getOffsetAdjustment",
            value: function getOffsetAdjustment(_ref2) {
                var containerSize = _ref2.containerSize, offset = _ref2.offset;
                var totalSize = this._cellSizeAndPositionManager.getTotalSize();
                var safeTotalSize = this.getTotalSize();
                var offsetPercentage = this._getOffsetPercentage({
                    containerSize: containerSize,
                    offset: offset,
                    totalSize: safeTotalSize
                });
                return Math.round(offsetPercentage * (safeTotalSize - totalSize));
            }
        },
        {
            key: "getSizeAndPositionOfCell",
            value: function getSizeAndPositionOfCell(index) {
                return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
            }
        },
        {
            key: "getSizeAndPositionOfLastMeasuredCell",
            value: function getSizeAndPositionOfLastMeasuredCell() {
                return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
            }
        },
        {
            key: "getTotalSize",
            value: function getTotalSize() {
                return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
            }
        },
        {
            key: "getUpdatedOffsetForIndex",
            value: function getUpdatedOffsetForIndex(_ref3) {
                var _ref3$align = _ref3.align, align = _ref3$align === void 0 ? 'auto' : _ref3$align, containerSize = _ref3.containerSize, currentOffset = _ref3.currentOffset, targetIndex = _ref3.targetIndex;
                currentOffset = this._safeOffsetToOffset({
                    containerSize: containerSize,
                    offset: currentOffset
                });
                var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
                    align: align,
                    containerSize: containerSize,
                    currentOffset: currentOffset,
                    targetIndex: targetIndex
                });
                return this._offsetToSafeOffset({
                    containerSize: containerSize,
                    offset: offset
                });
            }
        },
        {
            key: "getVisibleCellRange",
            value: function getVisibleCellRange(_ref4) {
                var containerSize = _ref4.containerSize, offset = _ref4.offset;
                offset = this._safeOffsetToOffset({
                    containerSize: containerSize,
                    offset: offset
                });
                return this._cellSizeAndPositionManager.getVisibleCellRange({
                    containerSize: containerSize,
                    offset: offset
                });
            }
        },
        {
            key: "resetCell",
            value: function resetCell(index) {
                this._cellSizeAndPositionManager.resetCell(index);
            }
        },
        {
            key: "_getOffsetPercentage",
            value: function _getOffsetPercentage(_ref5) {
                var containerSize = _ref5.containerSize, offset = _ref5.offset, totalSize = _ref5.totalSize;
                return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
            }
        },
        {
            key: "_offsetToSafeOffset",
            value: function _offsetToSafeOffset(_ref6) {
                var containerSize = _ref6.containerSize, offset = _ref6.offset;
                var totalSize = this._cellSizeAndPositionManager.getTotalSize();
                var safeTotalSize = this.getTotalSize();
                if (totalSize === safeTotalSize) return offset;
                else {
                    var offsetPercentage = this._getOffsetPercentage({
                        containerSize: containerSize,
                        offset: offset,
                        totalSize: totalSize
                    });
                    return Math.round(offsetPercentage * (safeTotalSize - containerSize));
                }
            }
        },
        {
            key: "_safeOffsetToOffset",
            value: function _safeOffsetToOffset(_ref7) {
                var containerSize = _ref7.containerSize, offset = _ref7.offset;
                var totalSize = this._cellSizeAndPositionManager.getTotalSize();
                var safeTotalSize = this.getTotalSize();
                if (totalSize === safeTotalSize) return offset;
                else {
                    var offsetPercentage = this._getOffsetPercentage({
                        containerSize: containerSize,
                        offset: offset,
                        totalSize: safeTotalSize
                    });
                    return Math.round(offsetPercentage * (totalSize - containerSize));
                }
            }
        }
    ]);
    return ScalingCellSizeAndPositionManager;
}();


/**
 * Helper utility that updates the specified callback whenever any of the specified indices have changed.
 */ function $79f8f58d6f9cdb6e$export$2e2bcd8739ae039() {
    var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var cachedIndices = {};
    return function(_ref) {
        var callback = _ref.callback, indices = _ref.indices;
        var keys = Object.keys(indices);
        var allInitialized = !requireAllKeys || keys.every(function(key) {
            var value = indices[key];
            return Array.isArray(value) ? value.length > 0 : value >= 0;
        });
        var indexChanged = keys.length !== Object.keys(cachedIndices).length || keys.some(function(key) {
            var cachedValue = cachedIndices[key];
            var value = indices[key];
            return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
        });
        cachedIndices = indices;
        if (allInitialized && indexChanged) callback(indices);
    };
}



var $06c7deb352f71857$export$4a9c12fc9cd91d00 = -1;
var $06c7deb352f71857$export$f30397fa35598134 = 1;
var $06c7deb352f71857$export$bd8d94980b275a2d = 'horizontal';
var $06c7deb352f71857$export$11bc73ef6d36df46 = 'vertical';
function $06c7deb352f71857$export$2e2bcd8739ae039(_ref) {
    var cellCount = _ref.cellCount, overscanCellsCount = _ref.overscanCellsCount, scrollDirection = _ref.scrollDirection, startIndex = _ref.startIndex, stopIndex = _ref.stopIndex;
    if (scrollDirection === $06c7deb352f71857$export$f30397fa35598134) return {
        overscanStartIndex: Math.max(0, startIndex),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
    else return {
        overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex)
    };
}




function $500fd37f17bfb611$export$2e2bcd8739ae039(_ref) {
    var cellSize = _ref.cellSize, cellSizeAndPositionManager = _ref.cellSizeAndPositionManager, previousCellsCount = _ref.previousCellsCount, previousCellSize = _ref.previousCellSize, previousScrollToAlignment = _ref.previousScrollToAlignment, previousScrollToIndex = _ref.previousScrollToIndex, previousSize = _ref.previousSize, scrollOffset = _ref.scrollOffset, scrollToAlignment = _ref.scrollToAlignment, scrollToIndex = _ref.scrollToIndex, size = _ref.size, sizeJustIncreasedFromZero = _ref.sizeJustIncreasedFromZero, updateScrollIndexCallback = _ref.updateScrollIndexCallback;
    var cellCount = cellSizeAndPositionManager.getCellCount();
    var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
    var sizeHasChanged = size !== previousSize || sizeJustIncreasedFromZero || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize; // If we have a new scroll target OR if height/row-height has changed,
    // We should ensure that the scroll target is visible.
    if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) updateScrollIndexCallback(scrollToIndex); // If we don't have a selected item but list size or number of children have decreased,
    else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) // We need to ensure that the current scroll offset is still within the collection's range.
    // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
    // Just check to make sure we're still okay.
    // Only adjust the scroll position if we've scrolled below the last set of rows.
    {
        if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) updateScrollIndexCallback(cellCount - 1);
    }
}


/**
 * Default implementation of cellRangeRenderer used by Grid.
 * This renderer supports cell-caching while the user is scrolling.
 */ 
function $05eb516410a3f7d3$export$2e2bcd8739ae039(_ref) {
    var cellCache = _ref.cellCache, cellRenderer = _ref.cellRenderer, columnSizeAndPositionManager = _ref.columnSizeAndPositionManager, columnStartIndex = _ref.columnStartIndex, columnStopIndex = _ref.columnStopIndex, deferredMeasurementCache = _ref.deferredMeasurementCache, horizontalOffsetAdjustment = _ref.horizontalOffsetAdjustment, isScrolling = _ref.isScrolling, isScrollingOptOut = _ref.isScrollingOptOut, parent = _ref.parent, rowSizeAndPositionManager = _ref.rowSizeAndPositionManager, rowStartIndex = _ref.rowStartIndex, rowStopIndex = _ref.rowStopIndex, styleCache = _ref.styleCache, verticalOffsetAdjustment = _ref.verticalOffsetAdjustment, visibleColumnIndices = _ref.visibleColumnIndices, visibleRowIndices = _ref.visibleRowIndices;
    var renderedCells = []; // Browsers have native size limits for elements (eg Chrome 33M pixels, IE 1.5M pixes).
    // User cannot scroll beyond these size limitations.
    // In order to work around this, ScalingCellSizeAndPositionManager compresses offsets.
    // We should never cache styles for compressed offsets though as this can lead to bugs.
    // See issue #576 for more.
    var areOffsetsAdjusted = columnSizeAndPositionManager.areOffsetsAdjusted() || rowSizeAndPositionManager.areOffsetsAdjusted();
    var canCacheStyle = !isScrolling && !areOffsetsAdjusted;
    for(var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++){
        var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);
        for(var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++){
            var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
            var isVisible = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
            var key = "".concat(rowIndex, "-").concat(columnIndex);
            var style = void 0; // Cache style objects so shallow-compare doesn't re-render unnecessarily.
            if (canCacheStyle && styleCache[key]) style = styleCache[key];
            else // In deferred mode, cells will be initially rendered before we know their size.
            // Don't interfere with CellMeasurer's measurements by setting an invalid size.
            if (deferredMeasurementCache && !deferredMeasurementCache.has(rowIndex, columnIndex)) // Position not-yet-measured cells at top/left 0,0,
            // And give them width/height of 'auto' so they can grow larger than the parent Grid if necessary.
            // Positioning them further to the right/bottom influences their measured size.
            style = {
                height: 'auto',
                left: 0,
                position: 'absolute',
                top: 0,
                width: 'auto'
            };
            else {
                style = {
                    height: rowDatum.size,
                    left: columnDatum.offset + horizontalOffsetAdjustment,
                    position: 'absolute',
                    top: rowDatum.offset + verticalOffsetAdjustment,
                    width: columnDatum.size
                };
                styleCache[key] = style;
            }
            var cellRendererParams = {
                columnIndex: columnIndex,
                isScrolling: isScrolling,
                isVisible: isVisible,
                key: key,
                parent: parent,
                rowIndex: rowIndex,
                style: style
            };
            var renderedCell = void 0; // Avoid re-creating cells while scrolling.
            // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
            // If a scroll is in progress- cache and reuse cells.
            // This cache will be thrown away once scrolling completes.
            // However if we are scaling scroll positions and sizes, we should also avoid caching.
            // This is because the offset changes slightly as scroll position changes and caching leads to stale values.
            // For more info refer to issue #395
            //
            // If isScrollingOptOut is specified, we always cache cells.
            // For more info refer to issue #1028
            if ((isScrollingOptOut || isScrolling) && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
                if (!cellCache[key]) cellCache[key] = cellRenderer(cellRendererParams);
                renderedCell = cellCache[key]; // If the user is no longer scrolling, don't cache cells.
            // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
            } else renderedCell = cellRenderer(cellRendererParams);
            if (renderedCell == null || renderedCell === false) continue;
            renderedCells.push(renderedCell);
        }
    }
    return renderedCells;
}
function $05eb516410a3f7d3$var$warnAboutMissingStyle(parent, renderedCell) {}


var $937d9c54079d51f9$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


var $d9d1c13ba37938cf$var$size;
function $d9d1c13ba37938cf$export$2e2bcd8739ae039(recalc) {
    if (!$d9d1c13ba37938cf$var$size && $d9d1c13ba37938cf$var$size !== 0 || recalc) {
        if (0, $937d9c54079d51f9$export$2e2bcd8739ae039) {
            var scrollDiv = document.createElement('div');
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            document.body.appendChild(scrollDiv);
            $d9d1c13ba37938cf$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $d9d1c13ba37938cf$var$size;
}



// Properly handle server-side rendering.
var $c16b1eace93f1ba7$var$win;
if (typeof window !== 'undefined') $c16b1eace93f1ba7$var$win = window;
else if (typeof self !== 'undefined') $c16b1eace93f1ba7$var$win = self;
else $c16b1eace93f1ba7$var$win = {};
 // requestAnimationFrame() shim by Paul Irish
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
var $c16b1eace93f1ba7$var$request = $c16b1eace93f1ba7$var$win.requestAnimationFrame || $c16b1eace93f1ba7$var$win.webkitRequestAnimationFrame || $c16b1eace93f1ba7$var$win.mozRequestAnimationFrame || $c16b1eace93f1ba7$var$win.oRequestAnimationFrame || $c16b1eace93f1ba7$var$win.msRequestAnimationFrame || function(callback) {
    return $c16b1eace93f1ba7$var$win.setTimeout(callback, 1000 / 60);
};
var $c16b1eace93f1ba7$var$cancel = $c16b1eace93f1ba7$var$win.cancelAnimationFrame || $c16b1eace93f1ba7$var$win.webkitCancelAnimationFrame || $c16b1eace93f1ba7$var$win.mozCancelAnimationFrame || $c16b1eace93f1ba7$var$win.oCancelAnimationFrame || $c16b1eace93f1ba7$var$win.msCancelAnimationFrame || function(id) {
    $c16b1eace93f1ba7$var$win.clearTimeout(id);
};
var $c16b1eace93f1ba7$export$27f233d61a9e2fa4 = $c16b1eace93f1ba7$var$request;
var $c16b1eace93f1ba7$export$75aab3dbee8deceb = $c16b1eace93f1ba7$var$cancel;



var $ef0c7be04d84646a$export$4bc1eeb5a78bb6df = null;
var $ef0c7be04d84646a$export$3b976196c7d0d7a6 = function cancelAnimationTimeout(frame) {
    return (0, $c16b1eace93f1ba7$export$75aab3dbee8deceb)(frame.id);
};
var $ef0c7be04d84646a$export$62c6fa81f9943047 = function requestAnimationTimeout(callback, delay) {
    var start; // wait for end of processing current event handler, because event handler may be long
    Promise.resolve().then(function() {
        start = Date.now();
    });
    var timeout = function timeout() {
        if (Date.now() - start >= delay) callback.call();
        else frame.id = (0, $c16b1eace93f1ba7$export$27f233d61a9e2fa4)(timeout);
    };
    var frame = {
        id: (0, $c16b1eace93f1ba7$export$27f233d61a9e2fa4)(timeout)
    };
    return frame;
};




var $df00be2467032761$var$_class, $df00be2467032761$var$_temp;
function $df00be2467032761$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $df00be2467032761$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $df00be2467032761$var$ownKeys(source, true).forEach(function(key) {
            (0, $005fda52a7adba61$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $df00be2467032761$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $df00be2467032761$export$c51e03d5b92ea76f = 150;
/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */ var $df00be2467032761$var$SCROLL_POSITION_CHANGE_REASONS = {
    OBSERVED: 'observed',
    REQUESTED: 'requested'
};
var $df00be2467032761$var$renderNull = function renderNull() {
    return null;
};
/**
 * Renders tabular data with virtualization along the vertical and horizontal axes.
 * Row heights and column widths must be known ahead of time and specified as properties.
 */ var $df00be2467032761$var$Grid = ($df00be2467032761$var$_temp = $df00be2467032761$var$_class = /*#__PURE__*/ function(_React$PureComponent) {
    (0, $fe3f597ee5eaea5e$export$2e2bcd8739ae039)(Grid, _React$PureComponent);
    // Invokes onSectionRendered callback only when start/stop row or column indices change
    function Grid(props) {
        var _this;
        (0, $7ab60400c9be8a6b$export$2e2bcd8739ae039)(this, Grid);
        _this = (0, $a26915f7b982dd67$export$2e2bcd8739ae039)(this, (0, $eae1db55e7e69c3d$export$2e2bcd8739ae039)(Grid).call(this, props));
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_onGridRenderedMemoizer", (0, $79f8f58d6f9cdb6e$export$2e2bcd8739ae039)());
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_onScrollMemoizer", (0, $79f8f58d6f9cdb6e$export$2e2bcd8739ae039)(false));
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_deferredInvalidateColumnIndex", null);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_deferredInvalidateRowIndex", null);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_recomputeScrollLeftFlag", false);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_recomputeScrollTopFlag", false);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_horizontalScrollBarSize", 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_verticalScrollBarSize", 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_scrollbarPresenceChanged", false);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_scrollingContainer", void 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_childrenToDisplay", void 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_columnStartIndex", void 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_columnStopIndex", void 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_rowStartIndex", void 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_rowStopIndex", void 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_renderedColumnStartIndex", 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_renderedColumnStopIndex", 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_renderedRowStartIndex", 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_renderedRowStopIndex", 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_initialScrollTop", void 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_initialScrollLeft", void 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_disablePointerEventsTimeoutId", void 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_styleCache", {});
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_cellCache", {});
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_debounceScrollEndedCallback", function() {
            _this._disablePointerEventsTimeoutId = null; // isScrolling is used to determine if we reset styleCache
            _this.setState({
                isScrolling: false,
                needToResetStyleCache: false
            });
        });
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_invokeOnGridRenderedHelper", function() {
            var onSectionRendered = _this.props.onSectionRendered;
            _this._onGridRenderedMemoizer({
                callback: onSectionRendered,
                indices: {
                    columnOverscanStartIndex: _this._columnStartIndex,
                    columnOverscanStopIndex: _this._columnStopIndex,
                    columnStartIndex: _this._renderedColumnStartIndex,
                    columnStopIndex: _this._renderedColumnStopIndex,
                    rowOverscanStartIndex: _this._rowStartIndex,
                    rowOverscanStopIndex: _this._rowStopIndex,
                    rowStartIndex: _this._renderedRowStartIndex,
                    rowStopIndex: _this._renderedRowStopIndex
                }
            });
        });
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_setScrollingContainerRef", function(ref) {
            _this._scrollingContainer = ref;
        });
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_onScroll", function(event) {
            // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
            // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
            // See issue #404 for more information.
            if (event.target === _this._scrollingContainer) _this.handleScrollEvent(event.target);
        });
        var columnSizeAndPositionManager = new (0, $a25d55465e3b0417$export$2e2bcd8739ae039)({
            cellCount: props.columnCount,
            cellSizeGetter: function cellSizeGetter(params) {
                return Grid._wrapSizeGetter(props.columnWidth)(params);
            },
            estimatedCellSize: Grid._getEstimatedColumnSize(props)
        });
        var rowSizeAndPositionManager = new (0, $a25d55465e3b0417$export$2e2bcd8739ae039)({
            cellCount: props.rowCount,
            cellSizeGetter: function cellSizeGetter(params) {
                return Grid._wrapSizeGetter(props.rowHeight)(params);
            },
            estimatedCellSize: Grid._getEstimatedRowSize(props)
        });
        _this.state = {
            instanceProps: {
                columnSizeAndPositionManager: columnSizeAndPositionManager,
                rowSizeAndPositionManager: rowSizeAndPositionManager,
                prevColumnWidth: props.columnWidth,
                prevRowHeight: props.rowHeight,
                prevColumnCount: props.columnCount,
                prevRowCount: props.rowCount,
                prevIsScrolling: props.isScrolling === true,
                prevScrollToColumn: props.scrollToColumn,
                prevScrollToRow: props.scrollToRow,
                scrollbarSize: 0,
                scrollbarSizeMeasured: false
            },
            isScrolling: false,
            scrollDirectionHorizontal: (0, $06c7deb352f71857$export$f30397fa35598134),
            scrollDirectionVertical: (0, $06c7deb352f71857$export$f30397fa35598134),
            scrollLeft: 0,
            scrollTop: 0,
            scrollPositionChangeReason: null,
            needToResetStyleCache: false
        };
        if (props.scrollToRow > 0) _this._initialScrollTop = _this._getCalculatedScrollTop(props, _this.state);
        if (props.scrollToColumn > 0) _this._initialScrollLeft = _this._getCalculatedScrollLeft(props, _this.state);
        return _this;
    }
    /**
   * Gets offsets for a given cell and alignment.
   */ (0, $f742022c5d2ac646$export$2e2bcd8739ae039)(Grid, [
        {
            key: "getOffsetForCell",
            value: function getOffsetForCell() {
                var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$alignment = _ref.alignment, alignment = _ref$alignment === void 0 ? this.props.scrollToAlignment : _ref$alignment, _ref$columnIndex = _ref.columnIndex, columnIndex = _ref$columnIndex === void 0 ? this.props.scrollToColumn : _ref$columnIndex, _ref$rowIndex = _ref.rowIndex, rowIndex = _ref$rowIndex === void 0 ? this.props.scrollToRow : _ref$rowIndex;
                var offsetProps = $df00be2467032761$var$_objectSpread({}, this.props, {
                    scrollToAlignment: alignment,
                    scrollToColumn: columnIndex,
                    scrollToRow: rowIndex
                });
                return {
                    scrollLeft: this._getCalculatedScrollLeft(offsetProps),
                    scrollTop: this._getCalculatedScrollTop(offsetProps)
                };
            }
        },
        {
            key: "getTotalRowsHeight",
            value: function getTotalRowsHeight() {
                return this.state.instanceProps.rowSizeAndPositionManager.getTotalSize();
            }
        },
        {
            key: "getTotalColumnsWidth",
            value: function getTotalColumnsWidth() {
                return this.state.instanceProps.columnSizeAndPositionManager.getTotalSize();
            }
        },
        {
            key: "handleScrollEvent",
            value: function handleScrollEvent(_ref2) {
                var _ref2$scrollLeft = _ref2.scrollLeft, scrollLeftParam = _ref2$scrollLeft === void 0 ? 0 : _ref2$scrollLeft, _ref2$scrollTop = _ref2.scrollTop, scrollTopParam = _ref2$scrollTop === void 0 ? 0 : _ref2$scrollTop;
                // On iOS, we can arrive at negative offsets by swiping past the start.
                // To prevent flicker here, we make playing in the negative offset zone cause nothing to happen.
                if (scrollTopParam < 0) return;
                 // Prevent pointer events from interrupting a smooth scroll
                this._debounceScrollEnded();
                var _this$props = this.props, autoHeight = _this$props.autoHeight, autoWidth = _this$props.autoWidth, height = _this$props.height, width = _this$props.width;
                var instanceProps = this.state.instanceProps; // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
                // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
                // This causes a series of rapid renders that is slow for long lists.
                // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.
                var scrollbarSize = instanceProps.scrollbarSize;
                var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), scrollLeftParam);
                var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), scrollTopParam); // Certain devices (like Apple touchpad) rapid-fire duplicate events.
                // Don't force a re-render if this is the case.
                // The mouse may move faster then the animation frame does.
                // Use requestAnimationFrame to avoid over-updating.
                if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
                    // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
                    // Don't change direction for an axis unless scroll offset has changed.
                    var scrollDirectionHorizontal = scrollLeft !== this.state.scrollLeft ? scrollLeft > this.state.scrollLeft ? (0, $06c7deb352f71857$export$f30397fa35598134) : (0, $06c7deb352f71857$export$4a9c12fc9cd91d00) : this.state.scrollDirectionHorizontal;
                    var scrollDirectionVertical = scrollTop !== this.state.scrollTop ? scrollTop > this.state.scrollTop ? (0, $06c7deb352f71857$export$f30397fa35598134) : (0, $06c7deb352f71857$export$4a9c12fc9cd91d00) : this.state.scrollDirectionVertical;
                    var newState = {
                        isScrolling: true,
                        scrollDirectionHorizontal: scrollDirectionHorizontal,
                        scrollDirectionVertical: scrollDirectionVertical,
                        scrollPositionChangeReason: $df00be2467032761$var$SCROLL_POSITION_CHANGE_REASONS.OBSERVED
                    };
                    if (!autoHeight) newState.scrollTop = scrollTop;
                    if (!autoWidth) newState.scrollLeft = scrollLeft;
                    newState.needToResetStyleCache = false;
                    this.setState(newState);
                }
                this._invokeOnScrollMemoizer({
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    totalColumnsWidth: totalColumnsWidth,
                    totalRowsHeight: totalRowsHeight
                });
            }
        },
        {
            key: "invalidateCellSizeAfterRender",
            value: function invalidateCellSizeAfterRender(_ref3) {
                var columnIndex = _ref3.columnIndex, rowIndex = _ref3.rowIndex;
                this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
                this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
            }
        },
        {
            key: "measureAllCells",
            value: function measureAllCells() {
                var _this$props2 = this.props, columnCount = _this$props2.columnCount, rowCount = _this$props2.rowCount;
                var instanceProps = this.state.instanceProps;
                instanceProps.columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
                instanceProps.rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
            }
        },
        {
            key: "recomputeGridSize",
            value: function recomputeGridSize() {
                var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref4$columnIndex = _ref4.columnIndex, columnIndex = _ref4$columnIndex === void 0 ? 0 : _ref4$columnIndex, _ref4$rowIndex = _ref4.rowIndex, rowIndex = _ref4$rowIndex === void 0 ? 0 : _ref4$rowIndex;
                var _this$props3 = this.props, scrollToColumn = _this$props3.scrollToColumn, scrollToRow = _this$props3.scrollToRow;
                var instanceProps = this.state.instanceProps;
                instanceProps.columnSizeAndPositionManager.resetCell(columnIndex);
                instanceProps.rowSizeAndPositionManager.resetCell(rowIndex); // Cell sizes may be determined by a function property.
                // In this case the cDU handler can't know if they changed.
                // Store this flag to let the next cDU pass know it needs to recompute the scroll offset.
                this._recomputeScrollLeftFlag = scrollToColumn >= 0 && (this.state.scrollDirectionHorizontal === (0, $06c7deb352f71857$export$f30397fa35598134) ? columnIndex <= scrollToColumn : columnIndex >= scrollToColumn);
                this._recomputeScrollTopFlag = scrollToRow >= 0 && (this.state.scrollDirectionVertical === (0, $06c7deb352f71857$export$f30397fa35598134) ? rowIndex <= scrollToRow : rowIndex >= scrollToRow); // Clear cell cache in case we are scrolling;
                // Invalid row heights likely mean invalid cached content as well.
                this._styleCache = {};
                this._cellCache = {};
                this.forceUpdate();
            }
        },
        {
            key: "scrollToCell",
            value: function scrollToCell(_ref5) {
                var columnIndex = _ref5.columnIndex, rowIndex = _ref5.rowIndex;
                var columnCount = this.props.columnCount;
                var props = this.props; // Don't adjust scroll offset for single-column grids (eg List, Table).
                // This can cause a funky scroll offset because of the vertical scrollbar width.
                if (columnCount > 1 && columnIndex !== undefined) this._updateScrollLeftForScrollToColumn($df00be2467032761$var$_objectSpread({}, props, {
                    scrollToColumn: columnIndex
                }));
                if (rowIndex !== undefined) this._updateScrollTopForScrollToRow($df00be2467032761$var$_objectSpread({}, props, {
                    scrollToRow: rowIndex
                }));
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props4 = this.props, getScrollbarSize = _this$props4.getScrollbarSize, height = _this$props4.height, scrollLeft = _this$props4.scrollLeft, scrollToColumn = _this$props4.scrollToColumn, scrollTop = _this$props4.scrollTop, scrollToRow = _this$props4.scrollToRow, width = _this$props4.width;
                var instanceProps = this.state.instanceProps; // Reset initial offsets to be ignored in browser
                this._initialScrollTop = 0;
                this._initialScrollLeft = 0; // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
                // We must do this at the start of the method as we may calculate and update scroll position below.
                this._handleInvalidatedGridSize(); // If this component was first rendered server-side, scrollbar size will be undefined.
                // In that event we need to remeasure.
                if (!instanceProps.scrollbarSizeMeasured) this.setState(function(prevState) {
                    var stateUpdate = $df00be2467032761$var$_objectSpread({}, prevState, {
                        needToResetStyleCache: false
                    });
                    stateUpdate.instanceProps.scrollbarSize = getScrollbarSize();
                    stateUpdate.instanceProps.scrollbarSizeMeasured = true;
                    return stateUpdate;
                });
                if (typeof scrollLeft === 'number' && scrollLeft >= 0 || typeof scrollTop === 'number' && scrollTop >= 0) {
                    var stateUpdate = Grid._getScrollToPositionStateUpdate({
                        prevState: this.state,
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop
                    });
                    if (stateUpdate) {
                        stateUpdate.needToResetStyleCache = false;
                        this.setState(stateUpdate);
                    }
                } // refs don't work in `react-test-renderer`
                if (this._scrollingContainer) {
                    // setting the ref's scrollLeft and scrollTop.
                    // Somehow in MultiGrid the main grid doesn't trigger a update on mount.
                    if (this._scrollingContainer.scrollLeft !== this.state.scrollLeft) this._scrollingContainer.scrollLeft = this.state.scrollLeft;
                    if (this._scrollingContainer.scrollTop !== this.state.scrollTop) this._scrollingContainer.scrollTop = this.state.scrollTop;
                } // Don't update scroll offset if the size is 0; we don't render any cells in this case.
                // Setting a state may cause us to later thing we've updated the offce when we haven't.
                var sizeIsBiggerThanZero = height > 0 && width > 0;
                if (scrollToColumn >= 0 && sizeIsBiggerThanZero) this._updateScrollLeftForScrollToColumn();
                if (scrollToRow >= 0 && sizeIsBiggerThanZero) this._updateScrollTopForScrollToRow();
                 // Update onRowsRendered callback
                this._invokeOnGridRenderedHelper(); // Initialize onScroll callback
                this._invokeOnScrollMemoizer({
                    scrollLeft: scrollLeft || 0,
                    scrollTop: scrollTop || 0,
                    totalColumnsWidth: instanceProps.columnSizeAndPositionManager.getTotalSize(),
                    totalRowsHeight: instanceProps.rowSizeAndPositionManager.getTotalSize()
                });
                this._maybeCallOnScrollbarPresenceChange();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var _this2 = this;
                var _this$props5 = this.props, autoHeight = _this$props5.autoHeight, autoWidth = _this$props5.autoWidth, columnCount = _this$props5.columnCount, height = _this$props5.height, rowCount = _this$props5.rowCount, scrollToAlignment = _this$props5.scrollToAlignment, scrollToColumn = _this$props5.scrollToColumn, scrollToRow = _this$props5.scrollToRow, width = _this$props5.width;
                var _this$state = this.state, scrollLeft = _this$state.scrollLeft, scrollPositionChangeReason = _this$state.scrollPositionChangeReason, scrollTop = _this$state.scrollTop, instanceProps = _this$state.instanceProps; // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
                // We must do this at the start of the method as we may calculate and update scroll position below.
                this._handleInvalidatedGridSize(); // Handle edge case where column or row count has only just increased over 0.
                // In this case we may have to restore a previously-specified scroll offset.
                // For more info see bvaughn/react-virtualized/issues/218
                var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0; // Make sure requested changes to :scrollLeft or :scrollTop get applied.
                // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
                // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
                // So we only set these when we require an adjustment of the scroll position.
                // See issue #2 for more information.
                if (scrollPositionChangeReason === $df00be2467032761$var$SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
                    // @TRICKY :autoHeight and :autoWidth properties instructs Grid to leave :scrollTop and :scrollLeft management to an external HOC (eg WindowScroller).
                    // In this case we should avoid checking scrollingContainer.scrollTop and scrollingContainer.scrollLeft since it forces layout/flow.
                    if (!autoWidth && scrollLeft >= 0 && (scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) this._scrollingContainer.scrollLeft = scrollLeft;
                    if (!autoHeight && scrollTop >= 0 && (scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) this._scrollingContainer.scrollTop = scrollTop;
                } // Special case where the previous size was 0:
                // In this case we don't show any windowed cells at all.
                // So we should always recalculate offset afterwards.
                var sizeJustIncreasedFromZero = (prevProps.width === 0 || prevProps.height === 0) && height > 0 && width > 0; // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
                // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?
                if (this._recomputeScrollLeftFlag) {
                    this._recomputeScrollLeftFlag = false;
                    this._updateScrollLeftForScrollToColumn(this.props);
                } else (0, $500fd37f17bfb611$export$2e2bcd8739ae039)({
                    cellSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
                    previousCellsCount: prevProps.columnCount,
                    previousCellSize: prevProps.columnWidth,
                    previousScrollToAlignment: prevProps.scrollToAlignment,
                    previousScrollToIndex: prevProps.scrollToColumn,
                    previousSize: prevProps.width,
                    scrollOffset: scrollLeft,
                    scrollToAlignment: scrollToAlignment,
                    scrollToIndex: scrollToColumn,
                    size: width,
                    sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
                    updateScrollIndexCallback: function updateScrollIndexCallback() {
                        return _this2._updateScrollLeftForScrollToColumn(_this2.props);
                    }
                });
                if (this._recomputeScrollTopFlag) {
                    this._recomputeScrollTopFlag = false;
                    this._updateScrollTopForScrollToRow(this.props);
                } else (0, $500fd37f17bfb611$export$2e2bcd8739ae039)({
                    cellSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
                    previousCellsCount: prevProps.rowCount,
                    previousCellSize: prevProps.rowHeight,
                    previousScrollToAlignment: prevProps.scrollToAlignment,
                    previousScrollToIndex: prevProps.scrollToRow,
                    previousSize: prevProps.height,
                    scrollOffset: scrollTop,
                    scrollToAlignment: scrollToAlignment,
                    scrollToIndex: scrollToRow,
                    size: height,
                    sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
                    updateScrollIndexCallback: function updateScrollIndexCallback() {
                        return _this2._updateScrollTopForScrollToRow(_this2.props);
                    }
                });
                 // Update onRowsRendered callback if start/stop indices have changed
                this._invokeOnGridRenderedHelper(); // Changes to :scrollLeft or :scrollTop should also notify :onScroll listeners
                if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
                    var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                    var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                    this._invokeOnScrollMemoizer({
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop,
                        totalColumnsWidth: totalColumnsWidth,
                        totalRowsHeight: totalRowsHeight
                    });
                }
                this._maybeCallOnScrollbarPresenceChange();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this._disablePointerEventsTimeoutId) (0, $ef0c7be04d84646a$export$3b976196c7d0d7a6)(this._disablePointerEventsTimeoutId);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, autoContainerWidth = _this$props6.autoContainerWidth, autoHeight = _this$props6.autoHeight, autoWidth = _this$props6.autoWidth, className = _this$props6.className, containerProps = _this$props6.containerProps, containerRole = _this$props6.containerRole, containerStyle = _this$props6.containerStyle, height = _this$props6.height, id = _this$props6.id, noContentRenderer = _this$props6.noContentRenderer, role = _this$props6.role, style = _this$props6.style, tabIndex = _this$props6.tabIndex, width = _this$props6.width;
                var _this$state2 = this.state, instanceProps = _this$state2.instanceProps, needToResetStyleCache = _this$state2.needToResetStyleCache;
                var isScrolling = this._isScrolling();
                var gridStyle = {
                    boxSizing: 'border-box',
                    direction: 'ltr',
                    height: autoHeight ? 'auto' : height,
                    position: 'relative',
                    width: autoWidth ? 'auto' : width,
                    WebkitOverflowScrolling: 'touch',
                    willChange: 'transform'
                };
                if (needToResetStyleCache) this._styleCache = {};
                 // calculate _styleCache here
                // if state.isScrolling (not from _isScrolling) then reset
                if (!this.state.isScrolling) this._resetStyleCache();
                 // calculate children to render here
                this._calculateChildrenToRender(this.props, this.state);
                var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize(); // Force browser to hide scrollbars when we know they aren't necessary.
                // Otherwise once scrollbars appear they may not disappear again.
                // For more info see issue #116
                var verticalScrollBarSize = totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
                var horizontalScrollBarSize = totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
                if (horizontalScrollBarSize !== this._horizontalScrollBarSize || verticalScrollBarSize !== this._verticalScrollBarSize) {
                    this._horizontalScrollBarSize = horizontalScrollBarSize;
                    this._verticalScrollBarSize = verticalScrollBarSize;
                    this._scrollbarPresenceChanged = true;
                } // Also explicitly init styles to 'auto' if scrollbars are required.
                // This works around an obscure edge case where external CSS styles have not yet been loaded,
                // But an initial scroll index of offset is set as an external prop.
                // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
                // This was originally reported via clauderic/react-infinite-calendar/issues/23
                gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
                gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
                var childrenToDisplay = this._childrenToDisplay;
                var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;
                return $NdCUR.createElement("div", (0, $3d1b110f42b1c650$export$2e2bcd8739ae039)({
                    ref: this._setScrollingContainerRef
                }, containerProps, {
                    "aria-label": this.props['aria-label'],
                    "aria-readonly": this.props['aria-readonly'],
                    className: (0, $lbxdO.default)('ReactVirtualized__Grid', className),
                    id: id,
                    onScroll: this._onScroll,
                    role: role,
                    style: $df00be2467032761$var$_objectSpread({}, gridStyle, {}, style),
                    tabIndex: tabIndex
                }), childrenToDisplay.length > 0 && $NdCUR.createElement("div", {
                    className: "ReactVirtualized__Grid__innerScrollContainer",
                    role: containerRole,
                    style: $df00be2467032761$var$_objectSpread({
                        width: autoContainerWidth ? 'auto' : totalColumnsWidth,
                        height: totalRowsHeight,
                        maxWidth: totalColumnsWidth,
                        maxHeight: totalRowsHeight,
                        overflow: 'hidden',
                        pointerEvents: isScrolling ? 'none' : '',
                        position: 'relative'
                    }, containerStyle)
                }, childrenToDisplay), showNoContentRenderer && noContentRenderer());
            }
        },
        {
            key: "_calculateChildrenToRender",
            value: function _calculateChildrenToRender() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                var cellRenderer = props.cellRenderer, cellRangeRenderer = props.cellRangeRenderer, columnCount = props.columnCount, deferredMeasurementCache = props.deferredMeasurementCache, height = props.height, overscanColumnCount = props.overscanColumnCount, overscanIndicesGetter = props.overscanIndicesGetter, overscanRowCount = props.overscanRowCount, rowCount = props.rowCount, width = props.width, isScrollingOptOut = props.isScrollingOptOut;
                var scrollDirectionHorizontal = state.scrollDirectionHorizontal, scrollDirectionVertical = state.scrollDirectionVertical, instanceProps = state.instanceProps;
                var scrollTop = this._initialScrollTop > 0 ? this._initialScrollTop : state.scrollTop;
                var scrollLeft = this._initialScrollLeft > 0 ? this._initialScrollLeft : state.scrollLeft;
                var isScrolling = this._isScrolling(props, state);
                this._childrenToDisplay = []; // Render only enough columns and rows to cover the visible area of the grid.
                if (height > 0 && width > 0) {
                    var visibleColumnIndices = instanceProps.columnSizeAndPositionManager.getVisibleCellRange({
                        containerSize: width,
                        offset: scrollLeft
                    });
                    var visibleRowIndices = instanceProps.rowSizeAndPositionManager.getVisibleCellRange({
                        containerSize: height,
                        offset: scrollTop
                    });
                    var horizontalOffsetAdjustment = instanceProps.columnSizeAndPositionManager.getOffsetAdjustment({
                        containerSize: width,
                        offset: scrollLeft
                    });
                    var verticalOffsetAdjustment = instanceProps.rowSizeAndPositionManager.getOffsetAdjustment({
                        containerSize: height,
                        offset: scrollTop
                    }); // Store for _invokeOnGridRenderedHelper()
                    this._renderedColumnStartIndex = visibleColumnIndices.start;
                    this._renderedColumnStopIndex = visibleColumnIndices.stop;
                    this._renderedRowStartIndex = visibleRowIndices.start;
                    this._renderedRowStopIndex = visibleRowIndices.stop;
                    var overscanColumnIndices = overscanIndicesGetter({
                        direction: 'horizontal',
                        cellCount: columnCount,
                        overscanCellsCount: overscanColumnCount,
                        scrollDirection: scrollDirectionHorizontal,
                        startIndex: typeof visibleColumnIndices.start === 'number' ? visibleColumnIndices.start : 0,
                        stopIndex: typeof visibleColumnIndices.stop === 'number' ? visibleColumnIndices.stop : -1
                    });
                    var overscanRowIndices = overscanIndicesGetter({
                        direction: 'vertical',
                        cellCount: rowCount,
                        overscanCellsCount: overscanRowCount,
                        scrollDirection: scrollDirectionVertical,
                        startIndex: typeof visibleRowIndices.start === 'number' ? visibleRowIndices.start : 0,
                        stopIndex: typeof visibleRowIndices.stop === 'number' ? visibleRowIndices.stop : -1
                    }); // Store for _invokeOnGridRenderedHelper()
                    var columnStartIndex = overscanColumnIndices.overscanStartIndex;
                    var columnStopIndex = overscanColumnIndices.overscanStopIndex;
                    var rowStartIndex = overscanRowIndices.overscanStartIndex;
                    var rowStopIndex = overscanRowIndices.overscanStopIndex; // Advanced use-cases (eg CellMeasurer) require batched measurements to determine accurate sizes.
                    if (deferredMeasurementCache) {
                        // If rows have a dynamic height, scan the rows we are about to render.
                        // If any have not yet been measured, then we need to render all columns initially,
                        // Because the height of the row is equal to the tallest cell within that row,
                        // (And so we can't know the height without measuring all column-cells first).
                        if (!deferredMeasurementCache.hasFixedHeight()) {
                            for(var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++)if (!deferredMeasurementCache.has(rowIndex, 0)) {
                                columnStartIndex = 0;
                                columnStopIndex = columnCount - 1;
                                break;
                            }
                        } // If columns have a dynamic width, scan the columns we are about to render.
                        // If any have not yet been measured, then we need to render all rows initially,
                        // Because the width of the column is equal to the widest cell within that column,
                        // (And so we can't know the width without measuring all row-cells first).
                        if (!deferredMeasurementCache.hasFixedWidth()) {
                            for(var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++)if (!deferredMeasurementCache.has(0, columnIndex)) {
                                rowStartIndex = 0;
                                rowStopIndex = rowCount - 1;
                                break;
                            }
                        }
                    }
                    this._childrenToDisplay = cellRangeRenderer({
                        cellCache: this._cellCache,
                        cellRenderer: cellRenderer,
                        columnSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
                        columnStartIndex: columnStartIndex,
                        columnStopIndex: columnStopIndex,
                        deferredMeasurementCache: deferredMeasurementCache,
                        horizontalOffsetAdjustment: horizontalOffsetAdjustment,
                        isScrolling: isScrolling,
                        isScrollingOptOut: isScrollingOptOut,
                        parent: this,
                        rowSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
                        rowStartIndex: rowStartIndex,
                        rowStopIndex: rowStopIndex,
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop,
                        styleCache: this._styleCache,
                        verticalOffsetAdjustment: verticalOffsetAdjustment,
                        visibleColumnIndices: visibleColumnIndices,
                        visibleRowIndices: visibleRowIndices
                    }); // update the indices
                    this._columnStartIndex = columnStartIndex;
                    this._columnStopIndex = columnStopIndex;
                    this._rowStartIndex = rowStartIndex;
                    this._rowStopIndex = rowStopIndex;
                }
            }
        },
        {
            key: "_debounceScrollEnded",
            value: function _debounceScrollEnded() {
                var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;
                if (this._disablePointerEventsTimeoutId) (0, $ef0c7be04d84646a$export$3b976196c7d0d7a6)(this._disablePointerEventsTimeoutId);
                this._disablePointerEventsTimeoutId = (0, $ef0c7be04d84646a$export$62c6fa81f9943047)(this._debounceScrollEndedCallback, scrollingResetTimeInterval);
            }
        },
        {
            key: "_handleInvalidatedGridSize",
            /**
     * Check for batched CellMeasurer size invalidations.
     * This will occur the first time one or more previously unmeasured cells are rendered.
     */ value: function _handleInvalidatedGridSize() {
                if (typeof this._deferredInvalidateColumnIndex === 'number' && typeof this._deferredInvalidateRowIndex === 'number') {
                    var columnIndex = this._deferredInvalidateColumnIndex;
                    var rowIndex = this._deferredInvalidateRowIndex;
                    this._deferredInvalidateColumnIndex = null;
                    this._deferredInvalidateRowIndex = null;
                    this.recomputeGridSize({
                        columnIndex: columnIndex,
                        rowIndex: rowIndex
                    });
                }
            }
        },
        {
            key: "_invokeOnScrollMemoizer",
            value: function _invokeOnScrollMemoizer(_ref6) {
                var _this3 = this;
                var scrollLeft = _ref6.scrollLeft, scrollTop = _ref6.scrollTop, totalColumnsWidth = _ref6.totalColumnsWidth, totalRowsHeight = _ref6.totalRowsHeight;
                this._onScrollMemoizer({
                    callback: function callback(_ref7) {
                        var scrollLeft = _ref7.scrollLeft, scrollTop = _ref7.scrollTop;
                        var _this3$props = _this3.props, height = _this3$props.height, onScroll = _this3$props.onScroll, width = _this3$props.width;
                        onScroll({
                            clientHeight: height,
                            clientWidth: width,
                            scrollHeight: totalRowsHeight,
                            scrollLeft: scrollLeft,
                            scrollTop: scrollTop,
                            scrollWidth: totalColumnsWidth
                        });
                    },
                    indices: {
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop
                    }
                });
            }
        },
        {
            key: "_isScrolling",
            value: function _isScrolling() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                // If isScrolling is defined in props, use it to override the value in state
                // This is a performance optimization for WindowScroller + Grid
                return Object.hasOwnProperty.call(props, 'isScrolling') ? Boolean(props.isScrolling) : Boolean(state.isScrolling);
            }
        },
        {
            key: "_maybeCallOnScrollbarPresenceChange",
            value: function _maybeCallOnScrollbarPresenceChange() {
                if (this._scrollbarPresenceChanged) {
                    var onScrollbarPresenceChange = this.props.onScrollbarPresenceChange;
                    this._scrollbarPresenceChanged = false;
                    onScrollbarPresenceChange({
                        horizontal: this._horizontalScrollBarSize > 0,
                        size: this.state.instanceProps.scrollbarSize,
                        vertical: this._verticalScrollBarSize > 0
                    });
                }
            }
        },
        {
            key: "scrollToPosition",
            /**
     * Scroll to the specified offset(s).
     * Useful for animating position changes.
     */ value: function scrollToPosition(_ref8) {
                var scrollLeft = _ref8.scrollLeft, scrollTop = _ref8.scrollTop;
                var stateUpdate = Grid._getScrollToPositionStateUpdate({
                    prevState: this.state,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop
                });
                if (stateUpdate) {
                    stateUpdate.needToResetStyleCache = false;
                    this.setState(stateUpdate);
                }
            }
        },
        {
            key: "_getCalculatedScrollLeft",
            value: function _getCalculatedScrollLeft() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                return Grid._getCalculatedScrollLeft(props, state);
            }
        },
        {
            key: "_updateScrollLeftForScrollToColumn",
            value: function _updateScrollLeftForScrollToColumn() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                var stateUpdate = Grid._getScrollLeftForScrollToColumnStateUpdate(props, state);
                if (stateUpdate) {
                    stateUpdate.needToResetStyleCache = false;
                    this.setState(stateUpdate);
                }
            }
        },
        {
            key: "_getCalculatedScrollTop",
            value: function _getCalculatedScrollTop() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                return Grid._getCalculatedScrollTop(props, state);
            }
        },
        {
            key: "_resetStyleCache",
            value: function _resetStyleCache() {
                var styleCache = this._styleCache;
                var cellCache = this._cellCache;
                var isScrollingOptOut = this.props.isScrollingOptOut; // Reset cell and style caches once scrolling stops.
                // This makes Grid simpler to use (since cells commonly change).
                // And it keeps the caches from growing too large.
                // Performance is most sensitive when a user is scrolling.
                // Don't clear visible cells from cellCache if isScrollingOptOut is specified.
                // This keeps the cellCache to a resonable size.
                this._cellCache = {};
                this._styleCache = {}; // Copy over the visible cell styles so avoid unnecessary re-render.
                for(var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++)for(var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++){
                    var key = "".concat(rowIndex, "-").concat(columnIndex);
                    this._styleCache[key] = styleCache[key];
                    if (isScrollingOptOut) this._cellCache[key] = cellCache[key];
                }
            }
        },
        {
            key: "_updateScrollTopForScrollToRow",
            value: function _updateScrollTopForScrollToRow() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                var stateUpdate = Grid._getScrollTopForScrollToRowStateUpdate(props, state);
                if (stateUpdate) {
                    stateUpdate.needToResetStyleCache = false;
                    this.setState(stateUpdate);
                }
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var newState = {};
                if (nextProps.columnCount === 0 && prevState.scrollLeft !== 0 || nextProps.rowCount === 0 && prevState.scrollTop !== 0) {
                    newState.scrollLeft = 0;
                    newState.scrollTop = 0; // only use scroll{Left,Top} from props if scrollTo{Column,Row} isn't specified
                // scrollTo{Column,Row} should override scroll{Left,Top}
                } else if (nextProps.scrollLeft !== prevState.scrollLeft && nextProps.scrollToColumn < 0 || nextProps.scrollTop !== prevState.scrollTop && nextProps.scrollToRow < 0) Object.assign(newState, Grid._getScrollToPositionStateUpdate({
                    prevState: prevState,
                    scrollLeft: nextProps.scrollLeft,
                    scrollTop: nextProps.scrollTop
                }));
                var instanceProps = prevState.instanceProps; // Initially we should not clearStyleCache
                newState.needToResetStyleCache = false;
                if (nextProps.columnWidth !== instanceProps.prevColumnWidth || nextProps.rowHeight !== instanceProps.prevRowHeight) // Reset cache. set it to {} in render
                newState.needToResetStyleCache = true;
                instanceProps.columnSizeAndPositionManager.configure({
                    cellCount: nextProps.columnCount,
                    estimatedCellSize: Grid._getEstimatedColumnSize(nextProps),
                    cellSizeGetter: Grid._wrapSizeGetter(nextProps.columnWidth)
                });
                instanceProps.rowSizeAndPositionManager.configure({
                    cellCount: nextProps.rowCount,
                    estimatedCellSize: Grid._getEstimatedRowSize(nextProps),
                    cellSizeGetter: Grid._wrapSizeGetter(nextProps.rowHeight)
                });
                if (instanceProps.prevColumnCount === 0 || instanceProps.prevRowCount === 0) {
                    instanceProps.prevColumnCount = 0;
                    instanceProps.prevRowCount = 0;
                } // If scrolling is controlled outside this component, clear cache when scrolling stops
                if (nextProps.autoHeight && nextProps.isScrolling === false && instanceProps.prevIsScrolling === true) Object.assign(newState, {
                    isScrolling: false
                });
                var maybeStateA;
                var maybeStateB;
                (0, $3df9016791526e33$export$2e2bcd8739ae039)({
                    cellCount: instanceProps.prevColumnCount,
                    cellSize: typeof instanceProps.prevColumnWidth === 'number' ? instanceProps.prevColumnWidth : null,
                    computeMetadataCallback: function computeMetadataCallback() {
                        return instanceProps.columnSizeAndPositionManager.resetCell(0);
                    },
                    computeMetadataCallbackProps: nextProps,
                    nextCellsCount: nextProps.columnCount,
                    nextCellSize: typeof nextProps.columnWidth === 'number' ? nextProps.columnWidth : null,
                    nextScrollToIndex: nextProps.scrollToColumn,
                    scrollToIndex: instanceProps.prevScrollToColumn,
                    updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
                        maybeStateA = Grid._getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState);
                    }
                });
                (0, $3df9016791526e33$export$2e2bcd8739ae039)({
                    cellCount: instanceProps.prevRowCount,
                    cellSize: typeof instanceProps.prevRowHeight === 'number' ? instanceProps.prevRowHeight : null,
                    computeMetadataCallback: function computeMetadataCallback() {
                        return instanceProps.rowSizeAndPositionManager.resetCell(0);
                    },
                    computeMetadataCallbackProps: nextProps,
                    nextCellsCount: nextProps.rowCount,
                    nextCellSize: typeof nextProps.rowHeight === 'number' ? nextProps.rowHeight : null,
                    nextScrollToIndex: nextProps.scrollToRow,
                    scrollToIndex: instanceProps.prevScrollToRow,
                    updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
                        maybeStateB = Grid._getScrollTopForScrollToRowStateUpdate(nextProps, prevState);
                    }
                });
                instanceProps.prevColumnCount = nextProps.columnCount;
                instanceProps.prevColumnWidth = nextProps.columnWidth;
                instanceProps.prevIsScrolling = nextProps.isScrolling === true;
                instanceProps.prevRowCount = nextProps.rowCount;
                instanceProps.prevRowHeight = nextProps.rowHeight;
                instanceProps.prevScrollToColumn = nextProps.scrollToColumn;
                instanceProps.prevScrollToRow = nextProps.scrollToRow; // getting scrollBarSize (moved from componentWillMount)
                instanceProps.scrollbarSize = nextProps.getScrollbarSize();
                if (instanceProps.scrollbarSize === undefined) {
                    instanceProps.scrollbarSizeMeasured = false;
                    instanceProps.scrollbarSize = 0;
                } else instanceProps.scrollbarSizeMeasured = true;
                newState.instanceProps = instanceProps;
                return $df00be2467032761$var$_objectSpread({}, newState, {}, maybeStateA, {}, maybeStateB);
            }
        },
        {
            key: "_getEstimatedColumnSize",
            value: function _getEstimatedColumnSize(props) {
                return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
            }
        },
        {
            key: "_getEstimatedRowSize",
            value: function _getEstimatedRowSize(props) {
                return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
            }
        },
        {
            key: "_getScrollToPositionStateUpdate",
            /**
     * Get the updated state after scrolling to
     * scrollLeft and scrollTop
     */ value: function _getScrollToPositionStateUpdate(_ref9) {
                var prevState = _ref9.prevState, scrollLeft = _ref9.scrollLeft, scrollTop = _ref9.scrollTop;
                var newState = {
                    scrollPositionChangeReason: $df00be2467032761$var$SCROLL_POSITION_CHANGE_REASONS.REQUESTED
                };
                if (typeof scrollLeft === 'number' && scrollLeft >= 0) {
                    newState.scrollDirectionHorizontal = scrollLeft > prevState.scrollLeft ? (0, $06c7deb352f71857$export$f30397fa35598134) : (0, $06c7deb352f71857$export$4a9c12fc9cd91d00);
                    newState.scrollLeft = scrollLeft;
                }
                if (typeof scrollTop === 'number' && scrollTop >= 0) {
                    newState.scrollDirectionVertical = scrollTop > prevState.scrollTop ? (0, $06c7deb352f71857$export$f30397fa35598134) : (0, $06c7deb352f71857$export$4a9c12fc9cd91d00);
                    newState.scrollTop = scrollTop;
                }
                if (typeof scrollLeft === 'number' && scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft || typeof scrollTop === 'number' && scrollTop >= 0 && scrollTop !== prevState.scrollTop) return newState;
                return {};
            }
        },
        {
            key: "_wrapSizeGetter",
            value: function _wrapSizeGetter(value) {
                return typeof value === 'function' ? value : function() {
                    return value;
                };
            }
        },
        {
            key: "_getCalculatedScrollLeft",
            value: function _getCalculatedScrollLeft(nextProps, prevState) {
                var columnCount = nextProps.columnCount, height = nextProps.height, scrollToAlignment = nextProps.scrollToAlignment, scrollToColumn = nextProps.scrollToColumn, width = nextProps.width;
                var scrollLeft = prevState.scrollLeft, instanceProps = prevState.instanceProps;
                if (columnCount > 0) {
                    var finalColumn = columnCount - 1;
                    var targetIndex = scrollToColumn < 0 ? finalColumn : Math.min(finalColumn, scrollToColumn);
                    var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                    var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
                    return instanceProps.columnSizeAndPositionManager.getUpdatedOffsetForIndex({
                        align: scrollToAlignment,
                        containerSize: width - scrollBarSize,
                        currentOffset: scrollLeft,
                        targetIndex: targetIndex
                    });
                }
                return 0;
            }
        },
        {
            key: "_getScrollLeftForScrollToColumnStateUpdate",
            value: function _getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState) {
                var scrollLeft = prevState.scrollLeft;
                var calculatedScrollLeft = Grid._getCalculatedScrollLeft(nextProps, prevState);
                if (typeof calculatedScrollLeft === 'number' && calculatedScrollLeft >= 0 && scrollLeft !== calculatedScrollLeft) return Grid._getScrollToPositionStateUpdate({
                    prevState: prevState,
                    scrollLeft: calculatedScrollLeft,
                    scrollTop: -1
                });
                return {};
            }
        },
        {
            key: "_getCalculatedScrollTop",
            value: function _getCalculatedScrollTop(nextProps, prevState) {
                var height = nextProps.height, rowCount = nextProps.rowCount, scrollToAlignment = nextProps.scrollToAlignment, scrollToRow = nextProps.scrollToRow, width = nextProps.width;
                var scrollTop = prevState.scrollTop, instanceProps = prevState.instanceProps;
                if (rowCount > 0) {
                    var finalRow = rowCount - 1;
                    var targetIndex = scrollToRow < 0 ? finalRow : Math.min(finalRow, scrollToRow);
                    var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                    var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
                    return instanceProps.rowSizeAndPositionManager.getUpdatedOffsetForIndex({
                        align: scrollToAlignment,
                        containerSize: height - scrollBarSize,
                        currentOffset: scrollTop,
                        targetIndex: targetIndex
                    });
                }
                return 0;
            }
        },
        {
            key: "_getScrollTopForScrollToRowStateUpdate",
            value: function _getScrollTopForScrollToRowStateUpdate(nextProps, prevState) {
                var scrollTop = prevState.scrollTop;
                var calculatedScrollTop = Grid._getCalculatedScrollTop(nextProps, prevState);
                if (typeof calculatedScrollTop === 'number' && calculatedScrollTop >= 0 && scrollTop !== calculatedScrollTop) return Grid._getScrollToPositionStateUpdate({
                    prevState: prevState,
                    scrollLeft: -1,
                    scrollTop: calculatedScrollTop
                });
                return {};
            }
        }
    ]);
    return Grid;
}($NdCUR.PureComponent), (0, $005fda52a7adba61$export$2e2bcd8739ae039)($df00be2467032761$var$_class, "propTypes", null), $df00be2467032761$var$_temp);
(0, $005fda52a7adba61$export$2e2bcd8739ae039)($df00be2467032761$var$Grid, "defaultProps", {
    'aria-label': 'grid',
    'aria-readonly': true,
    autoContainerWidth: false,
    autoHeight: false,
    autoWidth: false,
    cellRangeRenderer: (0, $05eb516410a3f7d3$export$2e2bcd8739ae039),
    containerRole: 'rowgroup',
    containerStyle: {},
    estimatedColumnSize: 100,
    estimatedRowSize: 30,
    getScrollbarSize: (0, $d9d1c13ba37938cf$export$2e2bcd8739ae039),
    noContentRenderer: $df00be2467032761$var$renderNull,
    onScroll: function onScroll() {},
    onScrollbarPresenceChange: function onScrollbarPresenceChange() {},
    onSectionRendered: function onSectionRendered() {},
    overscanColumnCount: 0,
    overscanIndicesGetter: (0, $06c7deb352f71857$export$2e2bcd8739ae039),
    overscanRowCount: 10,
    role: 'grid',
    scrollingResetTimeInterval: $df00be2467032761$export$c51e03d5b92ea76f,
    scrollToAlignment: 'auto',
    scrollToColumn: -1,
    scrollToRow: -1,
    style: {},
    tabIndex: 0,
    isScrollingOptOut: false
});
(0, $e7f50e4820b1eac7$export$cea1c58a6db52bca)($df00be2467032761$var$Grid);
var $df00be2467032761$export$2e2bcd8739ae039 = $df00be2467032761$var$Grid;



var $7608b63d3b3be2cd$export$4a9c12fc9cd91d00 = -1;
var $7608b63d3b3be2cd$export$f30397fa35598134 = 1;
var $7608b63d3b3be2cd$export$bd8d94980b275a2d = 'horizontal';
var $7608b63d3b3be2cd$export$11bc73ef6d36df46 = 'vertical';
function $7608b63d3b3be2cd$export$2e2bcd8739ae039(_ref) {
    var cellCount = _ref.cellCount, overscanCellsCount = _ref.overscanCellsCount, scrollDirection = _ref.scrollDirection, startIndex = _ref.startIndex, stopIndex = _ref.stopIndex;
    // Make sure we render at least 1 cell extra before and after (except near boundaries)
    // This is necessary in order to support keyboard navigation (TAB/SHIFT+TAB) in some cases
    // For more info see issues #625
    overscanCellsCount = Math.max(1, overscanCellsCount);
    if (scrollDirection === $7608b63d3b3be2cd$export$f30397fa35598134) return {
        overscanStartIndex: Math.max(0, startIndex - 1),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
    else return {
        overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex + 1)
    };
}








var $0d9e6667c6fe2c04$export$e470e6595e6bd76b = null;



var $26c06cb01b6a93d4$var$_class, $26c06cb01b6a93d4$var$_temp;
function $26c06cb01b6a93d4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $26c06cb01b6a93d4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $26c06cb01b6a93d4$var$ownKeys(source, true).forEach(function(key) {
            (0, $005fda52a7adba61$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $26c06cb01b6a93d4$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * This HOC decorates a virtualized component and responds to arrow-key events by scrolling one row or column at a time.
 */ var $26c06cb01b6a93d4$var$ArrowKeyStepper = ($26c06cb01b6a93d4$var$_temp = $26c06cb01b6a93d4$var$_class = /*#__PURE__*/ function(_React$PureComponent) {
    (0, $fe3f597ee5eaea5e$export$2e2bcd8739ae039)(ArrowKeyStepper, _React$PureComponent);
    function ArrowKeyStepper() {
        var _getPrototypeOf2;
        var _this;
        (0, $7ab60400c9be8a6b$export$2e2bcd8739ae039)(this, ArrowKeyStepper);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, $a26915f7b982dd67$export$2e2bcd8739ae039)(this, (_getPrototypeOf2 = (0, $eae1db55e7e69c3d$export$2e2bcd8739ae039)(ArrowKeyStepper)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "state", {
            scrollToColumn: 0,
            scrollToRow: 0,
            instanceProps: {
                prevScrollToColumn: 0,
                prevScrollToRow: 0
            }
        });
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_columnStartIndex", 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_columnStopIndex", 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_rowStartIndex", 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_rowStopIndex", 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_onKeyDown", function(event) {
            var _this$props = _this.props, columnCount = _this$props.columnCount, disabled = _this$props.disabled, mode = _this$props.mode, rowCount = _this$props.rowCount;
            if (disabled) return;
            var _this$_getScrollState = _this._getScrollState(), scrollToColumnPrevious = _this$_getScrollState.scrollToColumn, scrollToRowPrevious = _this$_getScrollState.scrollToRow;
            var _this$_getScrollState2 = _this._getScrollState(), scrollToColumn = _this$_getScrollState2.scrollToColumn, scrollToRow = _this$_getScrollState2.scrollToRow; // The above cases all prevent default event event behavior.
            // This is to keep the grid from scrolling after the snap-to update.
            switch(event.key){
                case 'ArrowDown':
                    scrollToRow = mode === 'cells' ? Math.min(scrollToRow + 1, rowCount - 1) : Math.min(_this._rowStopIndex + 1, rowCount - 1);
                    break;
                case 'ArrowLeft':
                    scrollToColumn = mode === 'cells' ? Math.max(scrollToColumn - 1, 0) : Math.max(_this._columnStartIndex - 1, 0);
                    break;
                case 'ArrowRight':
                    scrollToColumn = mode === 'cells' ? Math.min(scrollToColumn + 1, columnCount - 1) : Math.min(_this._columnStopIndex + 1, columnCount - 1);
                    break;
                case 'ArrowUp':
                    scrollToRow = mode === 'cells' ? Math.max(scrollToRow - 1, 0) : Math.max(_this._rowStartIndex - 1, 0);
                    break;
            }
            if (scrollToColumn !== scrollToColumnPrevious || scrollToRow !== scrollToRowPrevious) {
                event.preventDefault();
                _this._updateScrollState({
                    scrollToColumn: scrollToColumn,
                    scrollToRow: scrollToRow
                });
            }
        });
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_onSectionRendered", function(_ref) {
            var columnStartIndex = _ref.columnStartIndex, columnStopIndex = _ref.columnStopIndex, rowStartIndex = _ref.rowStartIndex, rowStopIndex = _ref.rowStopIndex;
            _this._columnStartIndex = columnStartIndex;
            _this._columnStopIndex = columnStopIndex;
            _this._rowStartIndex = rowStartIndex;
            _this._rowStopIndex = rowStopIndex;
        });
        return _this;
    }
    (0, $f742022c5d2ac646$export$2e2bcd8739ae039)(ArrowKeyStepper, [
        {
            key: "setScrollIndexes",
            value: function setScrollIndexes(_ref2) {
                var scrollToColumn = _ref2.scrollToColumn, scrollToRow = _ref2.scrollToRow;
                this.setState({
                    scrollToRow: scrollToRow,
                    scrollToColumn: scrollToColumn
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, className = _this$props2.className, children = _this$props2.children;
                var _this$_getScrollState3 = this._getScrollState(), scrollToColumn = _this$_getScrollState3.scrollToColumn, scrollToRow = _this$_getScrollState3.scrollToRow;
                return $NdCUR.createElement("div", {
                    className: className,
                    onKeyDown: this._onKeyDown
                }, children({
                    onSectionRendered: this._onSectionRendered,
                    scrollToColumn: scrollToColumn,
                    scrollToRow: scrollToRow
                }));
            }
        },
        {
            key: "_getScrollState",
            value: function _getScrollState() {
                return this.props.isControlled ? this.props : this.state;
            }
        },
        {
            key: "_updateScrollState",
            value: function _updateScrollState(_ref3) {
                var scrollToColumn = _ref3.scrollToColumn, scrollToRow = _ref3.scrollToRow;
                var _this$props3 = this.props, isControlled = _this$props3.isControlled, onScrollToChange = _this$props3.onScrollToChange;
                if (typeof onScrollToChange === 'function') onScrollToChange({
                    scrollToColumn: scrollToColumn,
                    scrollToRow: scrollToRow
                });
                if (!isControlled) this.setState({
                    scrollToColumn: scrollToColumn,
                    scrollToRow: scrollToRow
                });
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.isControlled) return {};
                if (nextProps.scrollToColumn !== prevState.instanceProps.prevScrollToColumn || nextProps.scrollToRow !== prevState.instanceProps.prevScrollToRow) return $26c06cb01b6a93d4$var$_objectSpread({}, prevState, {
                    scrollToColumn: nextProps.scrollToColumn,
                    scrollToRow: nextProps.scrollToRow,
                    instanceProps: {
                        prevScrollToColumn: nextProps.scrollToColumn,
                        prevScrollToRow: nextProps.scrollToRow
                    }
                });
                return {};
            }
        }
    ]);
    return ArrowKeyStepper;
}($NdCUR.PureComponent), (0, $005fda52a7adba61$export$2e2bcd8739ae039)($26c06cb01b6a93d4$var$_class, "propTypes", null), $26c06cb01b6a93d4$var$_temp);
(0, $005fda52a7adba61$export$2e2bcd8739ae039)($26c06cb01b6a93d4$var$ArrowKeyStepper, "defaultProps", {
    disabled: false,
    isControlled: false,
    mode: 'edges',
    scrollToColumn: 0,
    scrollToRow: 0
});
(0, $e7f50e4820b1eac7$export$cea1c58a6db52bca)($26c06cb01b6a93d4$var$ArrowKeyStepper);
var $26c06cb01b6a93d4$export$2e2bcd8739ae039 = $26c06cb01b6a93d4$var$ArrowKeyStepper;













var $NdCUR = parcelRequire("NdCUR");
/**
 * Detect Element Resize.
 * https://github.com/sdecima/javascript-detect-element-resize
 * Sebastian Decima
 *
 * Forked from version 0.5.3; includes the following modifications:
 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
 * 4) Add nonce for style element.
 * 5) Added support for injecting custom window object
 **/ function $07c0ac0711ff4538$export$2e2bcd8739ae039(nonce, hostWindow) {
    // Check `document` and `window` in case of server-side rendering
    var _window;
    if (typeof hostWindow !== 'undefined') _window = hostWindow;
    else if (typeof window !== 'undefined') _window = window;
    else if (typeof self !== 'undefined') _window = self;
    else _window = $parcel$global;
    var attachEvent = typeof _window.document !== 'undefined' && _window.document.attachEvent;
    if (!attachEvent) {
        var requestFrame = function() {
            var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function(fn) {
                return _window.setTimeout(fn, 20);
            };
            return function(fn) {
                return raf(fn);
            };
        }();
        var cancelFrame = function() {
            var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
            return function(id) {
                return cancel(id);
            };
        }();
        var resetTriggers = function resetTriggers(element) {
            var triggers = element.__resizeTriggers__, expand = triggers.firstElementChild, contract = triggers.lastElementChild, expandChild = expand.firstElementChild;
            contract.scrollLeft = contract.scrollWidth;
            contract.scrollTop = contract.scrollHeight;
            expandChild.style.width = expand.offsetWidth + 1 + 'px';
            expandChild.style.height = expand.offsetHeight + 1 + 'px';
            expand.scrollLeft = expand.scrollWidth;
            expand.scrollTop = expand.scrollHeight;
        };
        var checkTriggers = function checkTriggers(element) {
            return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
        };
        var scrollListener = function scrollListener(e) {
            // Don't measure (which forces) reflow for scrolls that happen inside of children!
            if (e.target.className && typeof e.target.className.indexOf === 'function' && e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) return;
            var element = this;
            resetTriggers(this);
            if (this.__resizeRAF__) cancelFrame(this.__resizeRAF__);
            this.__resizeRAF__ = requestFrame(function() {
                if (checkTriggers(element)) {
                    element.__resizeLast__.width = element.offsetWidth;
                    element.__resizeLast__.height = element.offsetHeight;
                    element.__resizeListeners__.forEach(function(fn) {
                        fn.call(element, e);
                    });
                }
            });
        };
        /* Detect CSS Animations support to detect element display/re-attach */ var animation = false, keyframeprefix = '', animationstartevent = 'animationstart', domPrefixes = 'Webkit Moz O ms'.split(' '), startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '), pfx = '';
        var elm = _window.document.createElement('fakeelement');
        if (elm.style.animationName !== undefined) animation = true;
        if (animation === false) {
            for(var i = 0; i < domPrefixes.length; i++)if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
                pfx = domPrefixes[i];
                keyframeprefix = '-' + pfx.toLowerCase() + '-';
                animationstartevent = startEvents[i];
                animation = true;
                break;
            }
        }
        var animationName = 'resizeanim';
        var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
        var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
    }
    var createStyles = function createStyles(doc) {
        if (!doc.getElementById('detectElementResize')) {
            //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
            var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }', head = doc.head || doc.getElementsByTagName('head')[0], style = doc.createElement('style');
            style.id = 'detectElementResize';
            style.type = 'text/css';
            if (nonce != null) style.setAttribute('nonce', nonce);
            if (style.styleSheet) style.styleSheet.cssText = css;
            else style.appendChild(doc.createTextNode(css));
            head.appendChild(style);
        }
    };
    var addResizeListener = function addResizeListener(element, fn) {
        if (attachEvent) element.attachEvent('onresize', fn);
        else {
            if (!element.__resizeTriggers__) {
                var doc = element.ownerDocument;
                var elementStyle = _window.getComputedStyle(element);
                if (elementStyle && elementStyle.position == 'static') element.style.position = 'relative';
                createStyles(doc);
                element.__resizeLast__ = {};
                element.__resizeListeners__ = [];
                (element.__resizeTriggers__ = doc.createElement('div')).className = 'resize-triggers';
                var resizeTriggersHtml = '<div class="expand-trigger"><div></div></div><div class="contract-trigger"></div>';
                if (window.trustedTypes) {
                    var staticPolicy = trustedTypes.createPolicy('react-virtualized-auto-sizer', {
                        createHTML: function createHTML() {
                            return resizeTriggersHtml;
                        }
                    });
                    element.__resizeTriggers__.innerHTML = staticPolicy.createHTML('');
                } else element.__resizeTriggers__.innerHTML = resizeTriggersHtml;
                element.appendChild(element.__resizeTriggers__);
                resetTriggers(element);
                element.addEventListener('scroll', scrollListener, true);
                /* Listen for a css animation to detect element display/re-attach */ if (animationstartevent) {
                    element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
                        if (e.animationName == animationName) resetTriggers(element);
                    };
                    element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
                }
            }
            element.__resizeListeners__.push(fn);
        }
    };
    var removeResizeListener = function removeResizeListener(element, fn) {
        if (attachEvent) element.detachEvent('onresize', fn);
        else {
            element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
            if (!element.__resizeListeners__.length) {
                element.removeEventListener('scroll', scrollListener, true);
                if (element.__resizeTriggers__.__animationListener__) {
                    element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
                    element.__resizeTriggers__.__animationListener__ = null;
                }
                try {
                    element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
                } catch (e) {}
            }
        }
    };
    return {
        addResizeListener: addResizeListener,
        removeResizeListener: removeResizeListener
    };
}



var $9cf5f10972873d72$var$_class, $9cf5f10972873d72$var$_temp;
function $9cf5f10972873d72$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9cf5f10972873d72$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $9cf5f10972873d72$var$ownKeys(source, true).forEach(function(key) {
            (0, $005fda52a7adba61$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $9cf5f10972873d72$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $9cf5f10972873d72$export$2e2bcd8739ae039 = ($9cf5f10972873d72$var$_temp = $9cf5f10972873d72$var$_class = /*#__PURE__*/ function(_React$Component) {
    (0, $fe3f597ee5eaea5e$export$2e2bcd8739ae039)(AutoSizer, _React$Component);
    function AutoSizer() {
        var _getPrototypeOf2;
        var _this;
        (0, $7ab60400c9be8a6b$export$2e2bcd8739ae039)(this, AutoSizer);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, $a26915f7b982dd67$export$2e2bcd8739ae039)(this, (_getPrototypeOf2 = (0, $eae1db55e7e69c3d$export$2e2bcd8739ae039)(AutoSizer)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "state", {
            height: _this.props.defaultHeight || 0,
            width: _this.props.defaultWidth || 0
        });
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_parentNode", void 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_autoSizer", void 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_window", void 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_detectElementResize", void 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_onResize", function() {
            var _this$props = _this.props, disableHeight = _this$props.disableHeight, disableWidth = _this$props.disableWidth, onResize = _this$props.onResize;
            if (_this._parentNode) {
                // Guard against AutoSizer component being removed from the DOM immediately after being added.
                // This can result in invalid style values which can result in NaN values if we don't handle them.
                // See issue #150 for more context.
                var height = _this._parentNode.offsetHeight || 0;
                var width = _this._parentNode.offsetWidth || 0;
                var win = _this._window || window;
                var style = win.getComputedStyle(_this._parentNode) || {};
                var paddingLeft = parseInt(style.paddingLeft, 10) || 0;
                var paddingRight = parseInt(style.paddingRight, 10) || 0;
                var paddingTop = parseInt(style.paddingTop, 10) || 0;
                var paddingBottom = parseInt(style.paddingBottom, 10) || 0;
                var newHeight = height - paddingTop - paddingBottom;
                var newWidth = width - paddingLeft - paddingRight;
                if (!disableHeight && _this.state.height !== newHeight || !disableWidth && _this.state.width !== newWidth) {
                    _this.setState({
                        height: height - paddingTop - paddingBottom,
                        width: width - paddingLeft - paddingRight
                    });
                    onResize({
                        height: height,
                        width: width
                    });
                }
            }
        });
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_setRef", function(autoSizer) {
            _this._autoSizer = autoSizer;
        });
        return _this;
    }
    (0, $f742022c5d2ac646$export$2e2bcd8739ae039)(AutoSizer, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var nonce = this.props.nonce;
                if (this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement) {
                    // Delay access of parentNode until mount.
                    // This handles edge-cases where the component has already been unmounted before its ref has been set,
                    // As well as libraries like react-lite which have a slightly different lifecycle.
                    this._parentNode = this._autoSizer.parentNode;
                    this._window = this._autoSizer.parentNode.ownerDocument.defaultView; // Defer requiring resize handler in order to support server-side rendering.
                    // See issue #41
                    this._detectElementResize = (0, $07c0ac0711ff4538$export$2e2bcd8739ae039)(nonce, this._window);
                    this._detectElementResize.addResizeListener(this._parentNode, this._onResize);
                    this._onResize();
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this._detectElementResize && this._parentNode) this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, children = _this$props2.children, className = _this$props2.className, disableHeight = _this$props2.disableHeight, disableWidth = _this$props2.disableWidth, style = _this$props2.style;
                var _this$state = this.state, height = _this$state.height, width = _this$state.width; // Outer div should not force width/height since that may prevent containers from shrinking.
                // Inner component should overflow and use calculated width/height.
                // See issue #68 for more information.
                var outerStyle = {
                    overflow: 'visible'
                };
                var childParams = {};
                if (!disableHeight) {
                    outerStyle.height = 0;
                    childParams.height = height;
                }
                if (!disableWidth) {
                    outerStyle.width = 0;
                    childParams.width = width;
                }
                /**
       * TODO: Avoid rendering children before the initial measurements have been collected.
       * At best this would just be wasting cycles.
       * Add this check into version 10 though as it could break too many ref callbacks in version 9.
       * Note that if default width/height props were provided this would still work with SSR.
      if (
        height !== 0 &&
        width !== 0
      ) {
        child = children({ height, width })
      }
      */ return $NdCUR.createElement("div", {
                    className: className,
                    ref: this._setRef,
                    style: $9cf5f10972873d72$var$_objectSpread({}, outerStyle, {}, style)
                }, children(childParams));
            }
        }
    ]);
    return AutoSizer;
}($NdCUR.Component), (0, $005fda52a7adba61$export$2e2bcd8739ae039)($9cf5f10972873d72$var$_class, "propTypes", null), $9cf5f10972873d72$var$_temp);
(0, $005fda52a7adba61$export$2e2bcd8739ae039)($9cf5f10972873d72$export$2e2bcd8739ae039, "defaultProps", {
    onResize: function onResize() {},
    disableHeight: false,
    disableWidth: false,
    style: {}
});












var $NdCUR = parcelRequire("NdCUR");

var $g2wso = parcelRequire("g2wso");

var $c5ddad749a02077c$export$d013910bd650a87f = null;



var $03a7243f991fbb68$var$_class, $03a7243f991fbb68$var$_temp;
/**
 * Wraps a cell and measures its rendered content.
 * Measurements are stored in a per-cell cache.
 * Cached-content is not be re-measured.
 */ var $03a7243f991fbb68$export$2e2bcd8739ae039 = ($03a7243f991fbb68$var$_temp = $03a7243f991fbb68$var$_class = /*#__PURE__*/ function(_React$PureComponent) {
    (0, $fe3f597ee5eaea5e$export$2e2bcd8739ae039)(CellMeasurer, _React$PureComponent);
    function CellMeasurer() {
        var _getPrototypeOf2;
        var _this;
        (0, $7ab60400c9be8a6b$export$2e2bcd8739ae039)(this, CellMeasurer);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, $a26915f7b982dd67$export$2e2bcd8739ae039)(this, (_getPrototypeOf2 = (0, $eae1db55e7e69c3d$export$2e2bcd8739ae039)(CellMeasurer)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_child", void 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_measure", function() {
            var _this$props = _this.props, cache = _this$props.cache, _this$props$columnInd = _this$props.columnIndex, columnIndex = _this$props$columnInd === void 0 ? 0 : _this$props$columnInd, parent = _this$props.parent, _this$props$rowIndex = _this$props.rowIndex, rowIndex = _this$props$rowIndex === void 0 ? _this.props.index || 0 : _this$props$rowIndex;
            var _this$_getCellMeasure = _this._getCellMeasurements(), height = _this$_getCellMeasure.height, width = _this$_getCellMeasure.width;
            if (height !== cache.getHeight(rowIndex, columnIndex) || width !== cache.getWidth(rowIndex, columnIndex)) {
                cache.set(rowIndex, columnIndex, width, height);
                if (parent && typeof parent.recomputeGridSize === 'function') parent.recomputeGridSize({
                    columnIndex: columnIndex,
                    rowIndex: rowIndex
                });
            }
        });
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_registerChild", function(element) {
            if (element && !(element instanceof Element)) console.warn('CellMeasurer registerChild expects to be passed Element or null');
            _this._child = element;
            if (element) _this._maybeMeasureCell();
        });
        return _this;
    }
    (0, $f742022c5d2ac646$export$2e2bcd8739ae039)(CellMeasurer, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this._maybeMeasureCell();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this._maybeMeasureCell();
            }
        },
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return typeof children === 'function' ? children({
                    measure: this._measure,
                    registerChild: this._registerChild
                }) : children;
            }
        },
        {
            key: "_getCellMeasurements",
            value: function _getCellMeasurements() {
                var cache = this.props.cache;
                var node = this._child || (0, $g2wso.findDOMNode)(this); // TODO Check for a bad combination of fixedWidth and missing numeric width or vice versa with height
                if (node && node.ownerDocument && node.ownerDocument.defaultView && node instanceof node.ownerDocument.defaultView.HTMLElement) {
                    var styleWidth = node.style.width;
                    var styleHeight = node.style.height; // If we are re-measuring a cell that has already been measured,
                    // It will have a hard-coded width/height from the previous measurement.
                    // The fact that we are measuring indicates this measurement is probably stale,
                    // So explicitly clear it out (eg set to "auto") so we can recalculate.
                    // See issue #593 for more info.
                    // Even if we are measuring initially- if we're inside of a MultiGrid component,
                    // Explicitly clear width/height before measuring to avoid being tainted by another Grid.
                    // eg top/left Grid renders before bottom/right Grid
                    // Since the CellMeasurerCache is shared between them this taints derived cell size values.
                    if (!cache.hasFixedWidth()) node.style.width = 'auto';
                    if (!cache.hasFixedHeight()) node.style.height = 'auto';
                    var height = Math.ceil(node.offsetHeight);
                    var width = Math.ceil(node.offsetWidth); // Reset after measuring to avoid breaking styles; see #660
                    if (styleWidth) node.style.width = styleWidth;
                    if (styleHeight) node.style.height = styleHeight;
                    return {
                        height: height,
                        width: width
                    };
                } else return {
                    height: 0,
                    width: 0
                };
            }
        },
        {
            key: "_maybeMeasureCell",
            value: function _maybeMeasureCell() {
                var _this$props2 = this.props, cache = _this$props2.cache, _this$props2$columnIn = _this$props2.columnIndex, columnIndex = _this$props2$columnIn === void 0 ? 0 : _this$props2$columnIn, parent = _this$props2.parent, _this$props2$rowIndex = _this$props2.rowIndex, rowIndex = _this$props2$rowIndex === void 0 ? this.props.index || 0 : _this$props2$rowIndex;
                if (!cache.has(rowIndex, columnIndex)) {
                    var _this$_getCellMeasure2 = this._getCellMeasurements(), height = _this$_getCellMeasure2.height, width = _this$_getCellMeasure2.width;
                    cache.set(rowIndex, columnIndex, width, height); // If size has changed, let Grid know to re-render.
                    if (parent && typeof parent.invalidateCellSizeAfterRender === 'function') parent.invalidateCellSizeAfterRender({
                        columnIndex: columnIndex,
                        rowIndex: rowIndex
                    });
                }
            }
        }
    ]);
    return CellMeasurer;
}($NdCUR.PureComponent), (0, $005fda52a7adba61$export$2e2bcd8739ae039)($03a7243f991fbb68$var$_class, "propTypes", null), $03a7243f991fbb68$var$_temp); // Used for DEV mode warning check
(0, $005fda52a7adba61$export$2e2bcd8739ae039)($03a7243f991fbb68$export$2e2bcd8739ae039, "__internalCellMeasurerFlag", false);






var $16957229c71aa890$export$611c894df53833b0 = 30;
var $16957229c71aa890$export$aa4eace044cdfdbf = 100; // Enables more intelligent mapping of a given column and row index to an item ID.
// This prevents a cell cache from being invalidated when its parent collection is modified.
/**
 * Caches measurements for a given cell.
 */ var $16957229c71aa890$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function CellMeasurerCache() {
        var _this = this;
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $7ab60400c9be8a6b$export$2e2bcd8739ae039)(this, CellMeasurerCache);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)(this, "_cellHeightCache", {});
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)(this, "_cellWidthCache", {});
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)(this, "_columnWidthCache", {});
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)(this, "_rowHeightCache", {});
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)(this, "_defaultHeight", void 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)(this, "_defaultWidth", void 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)(this, "_minHeight", void 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)(this, "_minWidth", void 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)(this, "_keyMapper", void 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)(this, "_hasFixedHeight", void 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)(this, "_hasFixedWidth", void 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)(this, "_columnCount", 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)(this, "_rowCount", 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)(this, "columnWidth", function(_ref) {
            var index = _ref.index;
            var key = _this._keyMapper(0, index);
            return _this._columnWidthCache[key] !== undefined ? _this._columnWidthCache[key] : _this._defaultWidth;
        });
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)(this, "rowHeight", function(_ref2) {
            var index = _ref2.index;
            var key = _this._keyMapper(index, 0);
            return _this._rowHeightCache[key] !== undefined ? _this._rowHeightCache[key] : _this._defaultHeight;
        });
        var defaultHeight = params.defaultHeight, defaultWidth = params.defaultWidth, fixedHeight = params.fixedHeight, fixedWidth = params.fixedWidth, keyMapper = params.keyMapper, minHeight = params.minHeight, minWidth = params.minWidth;
        this._hasFixedHeight = fixedHeight === true;
        this._hasFixedWidth = fixedWidth === true;
        this._minHeight = minHeight || 0;
        this._minWidth = minWidth || 0;
        this._keyMapper = keyMapper || $16957229c71aa890$var$defaultKeyMapper;
        this._defaultHeight = Math.max(this._minHeight, typeof defaultHeight === 'number' ? defaultHeight : $16957229c71aa890$export$611c894df53833b0);
        this._defaultWidth = Math.max(this._minWidth, typeof defaultWidth === 'number' ? defaultWidth : $16957229c71aa890$export$aa4eace044cdfdbf);
    }
    (0, $f742022c5d2ac646$export$2e2bcd8739ae039)(CellMeasurerCache, [
        {
            key: "clear",
            value: function clear(rowIndex) {
                var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var key = this._keyMapper(rowIndex, columnIndex);
                delete this._cellHeightCache[key];
                delete this._cellWidthCache[key];
                this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
            }
        },
        {
            key: "clearAll",
            value: function clearAll() {
                this._cellHeightCache = {};
                this._cellWidthCache = {};
                this._columnWidthCache = {};
                this._rowHeightCache = {};
                this._rowCount = 0;
                this._columnCount = 0;
            }
        },
        {
            key: "hasFixedHeight",
            value: function hasFixedHeight() {
                return this._hasFixedHeight;
            }
        },
        {
            key: "hasFixedWidth",
            value: function hasFixedWidth() {
                return this._hasFixedWidth;
            }
        },
        {
            key: "getHeight",
            value: function getHeight(rowIndex) {
                var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                if (this._hasFixedHeight) return this._defaultHeight;
                else {
                    var _key = this._keyMapper(rowIndex, columnIndex);
                    return this._cellHeightCache[_key] !== undefined ? Math.max(this._minHeight, this._cellHeightCache[_key]) : this._defaultHeight;
                }
            }
        },
        {
            key: "getWidth",
            value: function getWidth(rowIndex) {
                var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                if (this._hasFixedWidth) return this._defaultWidth;
                else {
                    var _key2 = this._keyMapper(rowIndex, columnIndex);
                    return this._cellWidthCache[_key2] !== undefined ? Math.max(this._minWidth, this._cellWidthCache[_key2]) : this._defaultWidth;
                }
            }
        },
        {
            key: "has",
            value: function has(rowIndex) {
                var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var key = this._keyMapper(rowIndex, columnIndex);
                return this._cellHeightCache[key] !== undefined;
            }
        },
        {
            key: "set",
            value: function set(rowIndex, columnIndex, width, height) {
                var key = this._keyMapper(rowIndex, columnIndex);
                if (columnIndex >= this._columnCount) this._columnCount = columnIndex + 1;
                if (rowIndex >= this._rowCount) this._rowCount = rowIndex + 1;
                 // Size is cached per cell so we don't have to re-measure if cells are re-ordered.
                this._cellHeightCache[key] = height;
                this._cellWidthCache[key] = width;
                this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
            }
        },
        {
            key: "_updateCachedColumnAndRowSizes",
            value: function _updateCachedColumnAndRowSizes(rowIndex, columnIndex) {
                // :columnWidth and :rowHeight are derived based on all cells in a column/row.
                // Pre-cache these derived values for faster lookup later.
                // Reads are expected to occur more frequently than writes in this case.
                // Only update non-fixed dimensions though to avoid doing unnecessary work.
                if (!this._hasFixedWidth) {
                    var columnWidth = 0;
                    for(var i = 0; i < this._rowCount; i++)columnWidth = Math.max(columnWidth, this.getWidth(i, columnIndex));
                    var columnKey = this._keyMapper(0, columnIndex);
                    this._columnWidthCache[columnKey] = columnWidth;
                }
                if (!this._hasFixedHeight) {
                    var rowHeight = 0;
                    for(var _i = 0; _i < this._columnCount; _i++)rowHeight = Math.max(rowHeight, this.getHeight(rowIndex, _i));
                    var rowKey = this._keyMapper(rowIndex, 0);
                    this._rowHeightCache[rowKey] = rowHeight;
                }
            }
        },
        {
            key: "defaultHeight",
            get: function get() {
                return this._defaultHeight;
            }
        },
        {
            key: "defaultWidth",
            get: function get() {
                return this._defaultWidth;
            }
        }
    ]);
    return CellMeasurerCache;
}();
function $16957229c71aa890$var$defaultKeyMapper(rowIndex, columnIndex) {
    return "".concat(rowIndex, "-").concat(columnIndex);
}


var $66138acffaab7bc2$export$2e2bcd8739ae039 = (0, $03a7243f991fbb68$export$2e2bcd8739ae039);












var $NdCUR = parcelRequire("NdCUR");








var $lbxdO = parcelRequire("lbxdO");


var $NdCUR = parcelRequire("NdCUR");



function $e2b500b023488d98$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e2b500b023488d98$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $e2b500b023488d98$var$ownKeys(source, true).forEach(function(key) {
            (0, $005fda52a7adba61$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $e2b500b023488d98$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */ var $e2b500b023488d98$var$IS_SCROLLING_TIMEOUT = 150;
/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */ var $e2b500b023488d98$var$SCROLL_POSITION_CHANGE_REASONS = {
    OBSERVED: 'observed',
    REQUESTED: 'requested'
};
/**
 * Monitors changes in properties (eg. cellCount) and state (eg. scroll offsets) to determine when rendering needs to occur.
 * This component does not render any visible content itself; it defers to the specified :cellLayoutManager.
 */ var $e2b500b023488d98$var$CollectionView = /*#__PURE__*/ function(_React$PureComponent) {
    (0, $fe3f597ee5eaea5e$export$2e2bcd8739ae039)(CollectionView, _React$PureComponent);
    // Invokes callbacks only when their values have changed.
    function CollectionView() {
        var _getPrototypeOf2;
        var _this;
        (0, $7ab60400c9be8a6b$export$2e2bcd8739ae039)(this, CollectionView);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, $a26915f7b982dd67$export$2e2bcd8739ae039)(this, (_getPrototypeOf2 = (0, $eae1db55e7e69c3d$export$2e2bcd8739ae039)(CollectionView)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args))); // If this component is being rendered server-side, getScrollbarSize() will return undefined.
        // We handle this case in componentDidMount()
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "state", {
            isScrolling: false,
            scrollLeft: 0,
            scrollTop: 0
        });
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_calculateSizeAndPositionDataOnNextUpdate", false);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_onSectionRenderedMemoizer", (0, $79f8f58d6f9cdb6e$export$2e2bcd8739ae039)());
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_onScrollMemoizer", (0, $79f8f58d6f9cdb6e$export$2e2bcd8739ae039)(false));
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_invokeOnSectionRenderedHelper", function() {
            var _this$props = _this.props, cellLayoutManager = _this$props.cellLayoutManager, onSectionRendered = _this$props.onSectionRendered;
            _this._onSectionRenderedMemoizer({
                callback: onSectionRendered,
                indices: {
                    indices: cellLayoutManager.getLastRenderedIndices()
                }
            });
        });
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_setScrollingContainerRef", function(ref) {
            _this._scrollingContainer = ref;
        });
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_updateScrollPositionForScrollToCell", function() {
            var _this$props2 = _this.props, cellLayoutManager = _this$props2.cellLayoutManager, height = _this$props2.height, scrollToAlignment = _this$props2.scrollToAlignment, scrollToCell = _this$props2.scrollToCell, width = _this$props2.width;
            var _this$state = _this.state, scrollLeft = _this$state.scrollLeft, scrollTop = _this$state.scrollTop;
            if (scrollToCell >= 0) {
                var scrollPosition = cellLayoutManager.getScrollPositionForCell({
                    align: scrollToAlignment,
                    cellIndex: scrollToCell,
                    height: height,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    width: width
                });
                if (scrollPosition.scrollLeft !== scrollLeft || scrollPosition.scrollTop !== scrollTop) _this._setScrollPosition(scrollPosition);
            }
        });
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_onScroll", function(event) {
            // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
            // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
            // See issue #404 for more information.
            if (event.target !== _this._scrollingContainer) return;
             // Prevent pointer events from interrupting a smooth scroll
            _this._enablePointerEventsAfterDelay(); // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
            // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
            // This causes a series of rapid renders that is slow for long lists.
            // We can avoid that by doing some simple bounds checking to ensure that scrollTop never exceeds the total height.
            var _this$props3 = _this.props, cellLayoutManager = _this$props3.cellLayoutManager, height = _this$props3.height, isScrollingChange = _this$props3.isScrollingChange, width = _this$props3.width;
            var scrollbarSize = _this._scrollbarSize;
            var _cellLayoutManager$ge = cellLayoutManager.getTotalSize(), totalHeight = _cellLayoutManager$ge.height, totalWidth = _cellLayoutManager$ge.width;
            var scrollLeft = Math.max(0, Math.min(totalWidth - width + scrollbarSize, event.target.scrollLeft));
            var scrollTop = Math.max(0, Math.min(totalHeight - height + scrollbarSize, event.target.scrollTop)); // Certain devices (like Apple touchpad) rapid-fire duplicate events.
            // Don't force a re-render if this is the case.
            // The mouse may move faster then the animation frame does.
            // Use requestAnimationFrame to avoid over-updating.
            if (_this.state.scrollLeft !== scrollLeft || _this.state.scrollTop !== scrollTop) {
                // Browsers with cancelable scroll events (eg. Firefox) interrupt scrolling animations if scrollTop/scrollLeft is set.
                // Other browsers (eg. Safari) don't scroll as well without the help under certain conditions (DOM or style changes during scrolling).
                // All things considered, this seems to be the best current work around that I'm aware of.
                // For more information see https://github.com/bvaughn/react-virtualized/pull/124
                var scrollPositionChangeReason = event.cancelable ? $e2b500b023488d98$var$SCROLL_POSITION_CHANGE_REASONS.OBSERVED : $e2b500b023488d98$var$SCROLL_POSITION_CHANGE_REASONS.REQUESTED; // Synchronously set :isScrolling the first time (since _setNextState will reschedule its animation frame each time it's called)
                if (!_this.state.isScrolling) isScrollingChange(true);
                _this.setState({
                    isScrolling: true,
                    scrollLeft: scrollLeft,
                    scrollPositionChangeReason: scrollPositionChangeReason,
                    scrollTop: scrollTop
                });
            }
            _this._invokeOnScrollMemoizer({
                scrollLeft: scrollLeft,
                scrollTop: scrollTop,
                totalWidth: totalWidth,
                totalHeight: totalHeight
            });
        });
        _this._scrollbarSize = (0, $d9d1c13ba37938cf$export$2e2bcd8739ae039)();
        if (_this._scrollbarSize === undefined) {
            _this._scrollbarSizeMeasured = false;
            _this._scrollbarSize = 0;
        } else _this._scrollbarSizeMeasured = true;
        return _this;
    }
    /**
   * Forced recompute of cell sizes and positions.
   * This function should be called if cell sizes have changed but nothing else has.
   * Since cell positions are calculated by callbacks, the collection view has no way of detecting when the underlying data has changed.
   */ (0, $f742022c5d2ac646$export$2e2bcd8739ae039)(CollectionView, [
        {
            key: "recomputeCellSizesAndPositions",
            value: function recomputeCellSizesAndPositions() {
                this._calculateSizeAndPositionDataOnNextUpdate = true;
                this.forceUpdate();
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props4 = this.props, cellLayoutManager = _this$props4.cellLayoutManager, scrollLeft = _this$props4.scrollLeft, scrollToCell = _this$props4.scrollToCell, scrollTop = _this$props4.scrollTop; // If this component was first rendered server-side, scrollbar size will be undefined.
                // In that event we need to remeasure.
                if (!this._scrollbarSizeMeasured) {
                    this._scrollbarSize = (0, $d9d1c13ba37938cf$export$2e2bcd8739ae039)();
                    this._scrollbarSizeMeasured = true;
                    this.setState({});
                }
                if (scrollToCell >= 0) this._updateScrollPositionForScrollToCell();
                else if (scrollLeft >= 0 || scrollTop >= 0) this._setScrollPosition({
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop
                });
                 // Update onSectionRendered callback.
                this._invokeOnSectionRenderedHelper();
                var _cellLayoutManager$ge2 = cellLayoutManager.getTotalSize(), totalHeight = _cellLayoutManager$ge2.height, totalWidth = _cellLayoutManager$ge2.width; // Initialize onScroll callback.
                this._invokeOnScrollMemoizer({
                    scrollLeft: scrollLeft || 0,
                    scrollTop: scrollTop || 0,
                    totalHeight: totalHeight,
                    totalWidth: totalWidth
                });
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var _this$props5 = this.props, height = _this$props5.height, scrollToAlignment = _this$props5.scrollToAlignment, scrollToCell = _this$props5.scrollToCell, width = _this$props5.width;
                var _this$state2 = this.state, scrollLeft = _this$state2.scrollLeft, scrollPositionChangeReason = _this$state2.scrollPositionChangeReason, scrollTop = _this$state2.scrollTop; // Make sure requested changes to :scrollLeft or :scrollTop get applied.
                // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
                // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
                // So we only set these when we require an adjustment of the scroll position.
                // See issue #2 for more information.
                if (scrollPositionChangeReason === $e2b500b023488d98$var$SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
                    if (scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft && scrollLeft !== this._scrollingContainer.scrollLeft) this._scrollingContainer.scrollLeft = scrollLeft;
                    if (scrollTop >= 0 && scrollTop !== prevState.scrollTop && scrollTop !== this._scrollingContainer.scrollTop) this._scrollingContainer.scrollTop = scrollTop;
                } // Update scroll offsets if the current :scrollToCell values requires it
                if (height !== prevProps.height || scrollToAlignment !== prevProps.scrollToAlignment || scrollToCell !== prevProps.scrollToCell || width !== prevProps.width) this._updateScrollPositionForScrollToCell();
                 // Update onRowsRendered callback if start/stop indices have changed
                this._invokeOnSectionRenderedHelper();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this._disablePointerEventsTimeoutId) clearTimeout(this._disablePointerEventsTimeoutId);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, autoHeight = _this$props6.autoHeight, cellCount = _this$props6.cellCount, cellLayoutManager = _this$props6.cellLayoutManager, className = _this$props6.className, height = _this$props6.height, horizontalOverscanSize = _this$props6.horizontalOverscanSize, id = _this$props6.id, noContentRenderer = _this$props6.noContentRenderer, style = _this$props6.style, verticalOverscanSize = _this$props6.verticalOverscanSize, width = _this$props6.width;
                var _this$state3 = this.state, isScrolling = _this$state3.isScrolling, scrollLeft = _this$state3.scrollLeft, scrollTop = _this$state3.scrollTop; // Memoization reset
                if (this._lastRenderedCellCount !== cellCount || this._lastRenderedCellLayoutManager !== cellLayoutManager || this._calculateSizeAndPositionDataOnNextUpdate) {
                    this._lastRenderedCellCount = cellCount;
                    this._lastRenderedCellLayoutManager = cellLayoutManager;
                    this._calculateSizeAndPositionDataOnNextUpdate = false;
                    cellLayoutManager.calculateSizeAndPositionData();
                }
                var _cellLayoutManager$ge3 = cellLayoutManager.getTotalSize(), totalHeight = _cellLayoutManager$ge3.height, totalWidth = _cellLayoutManager$ge3.width; // Safely expand the rendered area by the specified overscan amount
                var left = Math.max(0, scrollLeft - horizontalOverscanSize);
                var top = Math.max(0, scrollTop - verticalOverscanSize);
                var right = Math.min(totalWidth, scrollLeft + width + horizontalOverscanSize);
                var bottom = Math.min(totalHeight, scrollTop + height + verticalOverscanSize);
                var childrenToDisplay = height > 0 && width > 0 ? cellLayoutManager.cellRenderers({
                    height: bottom - top,
                    isScrolling: isScrolling,
                    width: right - left,
                    x: left,
                    y: top
                }) : [];
                var collectionStyle = {
                    boxSizing: 'border-box',
                    direction: 'ltr',
                    height: autoHeight ? 'auto' : height,
                    position: 'relative',
                    WebkitOverflowScrolling: 'touch',
                    width: width,
                    willChange: 'transform'
                }; // Force browser to hide scrollbars when we know they aren't necessary.
                // Otherwise once scrollbars appear they may not disappear again.
                // For more info see issue #116
                var verticalScrollBarSize = totalHeight > height ? this._scrollbarSize : 0;
                var horizontalScrollBarSize = totalWidth > width ? this._scrollbarSize : 0; // Also explicitly init styles to 'auto' if scrollbars are required.
                // This works around an obscure edge case where external CSS styles have not yet been loaded,
                // But an initial scroll index of offset is set as an external prop.
                // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
                // This was originally reported via clauderic/react-infinite-calendar/issues/23
                collectionStyle.overflowX = totalWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
                collectionStyle.overflowY = totalHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
                return $NdCUR.createElement("div", {
                    ref: this._setScrollingContainerRef,
                    "aria-label": this.props['aria-label'],
                    className: (0, $lbxdO.default)('ReactVirtualized__Collection', className),
                    id: id,
                    onScroll: this._onScroll,
                    role: "grid",
                    style: $e2b500b023488d98$var$_objectSpread({}, collectionStyle, {}, style),
                    tabIndex: 0
                }, cellCount > 0 && $NdCUR.createElement("div", {
                    className: "ReactVirtualized__Collection__innerScrollContainer",
                    style: {
                        height: totalHeight,
                        maxHeight: totalHeight,
                        maxWidth: totalWidth,
                        overflow: 'hidden',
                        pointerEvents: isScrolling ? 'none' : '',
                        width: totalWidth
                    }
                }, childrenToDisplay), cellCount === 0 && noContentRenderer());
            }
        },
        {
            key: "_enablePointerEventsAfterDelay",
            value: function _enablePointerEventsAfterDelay() {
                var _this2 = this;
                if (this._disablePointerEventsTimeoutId) clearTimeout(this._disablePointerEventsTimeoutId);
                this._disablePointerEventsTimeoutId = setTimeout(function() {
                    var isScrollingChange = _this2.props.isScrollingChange;
                    isScrollingChange(false);
                    _this2._disablePointerEventsTimeoutId = null;
                    _this2.setState({
                        isScrolling: false
                    });
                }, $e2b500b023488d98$var$IS_SCROLLING_TIMEOUT);
            }
        },
        {
            key: "_invokeOnScrollMemoizer",
            value: function _invokeOnScrollMemoizer(_ref) {
                var _this3 = this;
                var scrollLeft = _ref.scrollLeft, scrollTop = _ref.scrollTop, totalHeight = _ref.totalHeight, totalWidth = _ref.totalWidth;
                this._onScrollMemoizer({
                    callback: function callback(_ref2) {
                        var scrollLeft = _ref2.scrollLeft, scrollTop = _ref2.scrollTop;
                        var _this3$props = _this3.props, height = _this3$props.height, onScroll = _this3$props.onScroll, width = _this3$props.width;
                        onScroll({
                            clientHeight: height,
                            clientWidth: width,
                            scrollHeight: totalHeight,
                            scrollLeft: scrollLeft,
                            scrollTop: scrollTop,
                            scrollWidth: totalWidth
                        });
                    },
                    indices: {
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop
                    }
                });
            }
        },
        {
            key: "_setScrollPosition",
            value: function _setScrollPosition(_ref3) {
                var scrollLeft = _ref3.scrollLeft, scrollTop = _ref3.scrollTop;
                var newState = {
                    scrollPositionChangeReason: $e2b500b023488d98$var$SCROLL_POSITION_CHANGE_REASONS.REQUESTED
                };
                if (scrollLeft >= 0) newState.scrollLeft = scrollLeft;
                if (scrollTop >= 0) newState.scrollTop = scrollTop;
                if (scrollLeft >= 0 && scrollLeft !== this.state.scrollLeft || scrollTop >= 0 && scrollTop !== this.state.scrollTop) this.setState(newState);
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.cellCount === 0 && (prevState.scrollLeft !== 0 || prevState.scrollTop !== 0)) return {
                    scrollLeft: 0,
                    scrollTop: 0,
                    scrollPositionChangeReason: $e2b500b023488d98$var$SCROLL_POSITION_CHANGE_REASONS.REQUESTED
                };
                else if (nextProps.scrollLeft !== prevState.scrollLeft || nextProps.scrollTop !== prevState.scrollTop) return {
                    scrollLeft: nextProps.scrollLeft != null ? nextProps.scrollLeft : prevState.scrollLeft,
                    scrollTop: nextProps.scrollTop != null ? nextProps.scrollTop : prevState.scrollTop,
                    scrollPositionChangeReason: $e2b500b023488d98$var$SCROLL_POSITION_CHANGE_REASONS.REQUESTED
                };
                return null;
            }
        }
    ]);
    return CollectionView;
}($NdCUR.PureComponent);
(0, $005fda52a7adba61$export$2e2bcd8739ae039)($e2b500b023488d98$var$CollectionView, "defaultProps", {
    'aria-label': 'grid',
    horizontalOverscanSize: 0,
    noContentRenderer: function noContentRenderer() {
        return null;
    },
    onScroll: function onScroll() {
        return null;
    },
    onSectionRendered: function onSectionRendered() {
        return null;
    },
    scrollToAlignment: 'auto',
    scrollToCell: -1,
    style: {},
    verticalOverscanSize: 0
});
$e2b500b023488d98$var$CollectionView.propTypes = {};
(0, $e7f50e4820b1eac7$export$cea1c58a6db52bca)($e2b500b023488d98$var$CollectionView);
var $e2b500b023488d98$export$2e2bcd8739ae039 = $e2b500b023488d98$var$CollectionView;







var $a883732cecdd7651$export$31d28c97eb4f2d9d = null;
var $a883732cecdd7651$export$c4831bf543ed2595 = null;
var $a883732cecdd7651$export$6e2f347511b90f58 = null;
var $a883732cecdd7651$export$aaccbd51d1a42a1f = null;
var $a883732cecdd7651$export$4bbb48243c242eb8 = null;


/**
 * A section of the Window.
 * Window Sections are used to group nearby cells.
 * This enables us to more quickly determine which cells to display in a given region of the Window.
 * Sections have a fixed size and contain 0 to many cells (tracked by their indices).
 */ var $f4dd1a82c231782d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Section(_ref) {
        var height = _ref.height, width = _ref.width, x = _ref.x, y = _ref.y;
        (0, $7ab60400c9be8a6b$export$2e2bcd8739ae039)(this, Section);
        this.height = height;
        this.width = width;
        this.x = x;
        this.y = y;
        this._indexMap = {};
        this._indices = [];
    }
    /** Add a cell to this section. */ (0, $f742022c5d2ac646$export$2e2bcd8739ae039)(Section, [
        {
            key: "addCellIndex",
            value: function addCellIndex(_ref2) {
                var index = _ref2.index;
                if (!this._indexMap[index]) {
                    this._indexMap[index] = true;
                    this._indices.push(index);
                }
            }
        },
        {
            key: "getCellIndices",
            value: function getCellIndices() {
                return this._indices;
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.x, ",").concat(this.y, " ").concat(this.width, "x").concat(this.height);
            }
        }
    ]);
    return Section;
}();



var $15f8fe11bfeba93a$var$SECTION_SIZE = 100;
/**
 * Contains 0 to many Sections.
 * Grows (and adds Sections) dynamically as cells are registered.
 * Automatically adds cells to the appropriate Section(s).
 */ var $15f8fe11bfeba93a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function SectionManager() {
        var sectionSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $15f8fe11bfeba93a$var$SECTION_SIZE;
        (0, $7ab60400c9be8a6b$export$2e2bcd8739ae039)(this, SectionManager);
        this._sectionSize = sectionSize;
        this._cellMetadata = [];
        this._sections = {};
    }
    /**
   * Gets all cell indices contained in the specified region.
   * A region may encompass 1 or more Sections.
   */ (0, $f742022c5d2ac646$export$2e2bcd8739ae039)(SectionManager, [
        {
            key: "getCellIndices",
            value: function getCellIndices(_ref) {
                var height = _ref.height, width = _ref.width, x = _ref.x, y = _ref.y;
                var indices = {};
                this.getSections({
                    height: height,
                    width: width,
                    x: x,
                    y: y
                }).forEach(function(section) {
                    return section.getCellIndices().forEach(function(index) {
                        indices[index] = index;
                    });
                }); // Object keys are strings; this function returns numbers
                return Object.keys(indices).map(function(index) {
                    return indices[index];
                });
            }
        },
        {
            key: "getCellMetadata",
            value: function getCellMetadata(_ref2) {
                var index = _ref2.index;
                return this._cellMetadata[index];
            }
        },
        {
            key: "getSections",
            value: function getSections(_ref3) {
                var height = _ref3.height, width = _ref3.width, x = _ref3.x, y = _ref3.y;
                var sectionXStart = Math.floor(x / this._sectionSize);
                var sectionXStop = Math.floor((x + width - 1) / this._sectionSize);
                var sectionYStart = Math.floor(y / this._sectionSize);
                var sectionYStop = Math.floor((y + height - 1) / this._sectionSize);
                var sections = [];
                for(var sectionX = sectionXStart; sectionX <= sectionXStop; sectionX++)for(var sectionY = sectionYStart; sectionY <= sectionYStop; sectionY++){
                    var key = "".concat(sectionX, ".").concat(sectionY);
                    if (!this._sections[key]) this._sections[key] = new (0, $f4dd1a82c231782d$export$2e2bcd8739ae039)({
                        height: this._sectionSize,
                        width: this._sectionSize,
                        x: sectionX * this._sectionSize,
                        y: sectionY * this._sectionSize
                    });
                    sections.push(this._sections[key]);
                }
                return sections;
            }
        },
        {
            key: "getTotalSectionCount",
            value: function getTotalSectionCount() {
                return Object.keys(this._sections).length;
            }
        },
        {
            key: "toString",
            value: function toString() {
                var _this = this;
                return Object.keys(this._sections).map(function(index) {
                    return _this._sections[index].toString();
                });
            }
        },
        {
            key: "registerCell",
            value: function registerCell(_ref4) {
                var cellMetadatum = _ref4.cellMetadatum, index = _ref4.index;
                this._cellMetadata[index] = cellMetadatum;
                this.getSections(cellMetadatum).forEach(function(section) {
                    return section.addCellIndex({
                        index: index
                    });
                });
            }
        }
    ]);
    return SectionManager;
}();


function $92f08469ccfb495d$export$2e2bcd8739ae039(_ref) {
    var cellCount = _ref.cellCount, cellSizeAndPositionGetter = _ref.cellSizeAndPositionGetter, sectionSize = _ref.sectionSize;
    var cellMetadata = [];
    var sectionManager = new (0, $15f8fe11bfeba93a$export$2e2bcd8739ae039)(sectionSize);
    var height = 0;
    var width = 0;
    for(var index = 0; index < cellCount; index++){
        var cellMetadatum = cellSizeAndPositionGetter({
            index: index
        });
        if (cellMetadatum.height == null || isNaN(cellMetadatum.height) || cellMetadatum.width == null || isNaN(cellMetadatum.width) || cellMetadatum.x == null || isNaN(cellMetadatum.x) || cellMetadatum.y == null || isNaN(cellMetadatum.y)) throw Error("Invalid metadata returned for cell ".concat(index, ":\n        x:").concat(cellMetadatum.x, ", y:").concat(cellMetadatum.y, ", width:").concat(cellMetadatum.width, ", height:").concat(cellMetadatum.height));
        height = Math.max(height, cellMetadatum.y + cellMetadatum.height);
        width = Math.max(width, cellMetadatum.x + cellMetadatum.width);
        cellMetadata[index] = cellMetadatum;
        sectionManager.registerCell({
            cellMetadatum: cellMetadatum,
            index: index
        });
    }
    return {
        cellMetadata: cellMetadata,
        height: height,
        sectionManager: sectionManager,
        width: width
    };
}


/**
 * Determines a new offset that ensures a certain cell is visible, given the current offset.
 * If the cell is already visible then the current offset will be returned.
 * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
 *
 * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
 * @param cellOffset Offset (x or y) position for cell
 * @param cellSize Size (width or height) of cell
 * @param containerSize Total size (width or height) of the container
 * @param currentOffset Container's current (x or y) offset
 * @return Offset to use to ensure the specified cell is visible
 */ function $87ef4b7d7405a365$export$2e2bcd8739ae039(_ref) {
    var _ref$align = _ref.align, align = _ref$align === void 0 ? 'auto' : _ref$align, cellOffset = _ref.cellOffset, cellSize = _ref.cellSize, containerSize = _ref.containerSize, currentOffset = _ref.currentOffset;
    var maxOffset = cellOffset;
    var minOffset = maxOffset - containerSize + cellSize;
    switch(align){
        case 'start':
            return maxOffset;
        case 'end':
            return minOffset;
        case 'center':
            return maxOffset - (containerSize - cellSize) / 2;
        default:
            return Math.max(minOffset, Math.min(maxOffset, currentOffset));
    }
}



/**
 * Renders scattered or non-linear data.
 * Unlike Grid, which renders checkerboard data, Collection can render arbitrarily positioned- even overlapping- data.
 */ var $c2c7b0c228af64d2$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$PureComponent) {
    (0, $fe3f597ee5eaea5e$export$2e2bcd8739ae039)(Collection, _React$PureComponent);
    function Collection(props, context) {
        var _this;
        (0, $7ab60400c9be8a6b$export$2e2bcd8739ae039)(this, Collection);
        _this = (0, $a26915f7b982dd67$export$2e2bcd8739ae039)(this, (0, $eae1db55e7e69c3d$export$2e2bcd8739ae039)(Collection).call(this, props, context));
        _this._cellMetadata = [];
        _this._lastRenderedCellIndices = []; // Cell cache during scroll (for performance)
        _this._cellCache = [];
        _this._isScrollingChange = _this._isScrollingChange.bind((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this));
        _this._setCollectionViewRef = _this._setCollectionViewRef.bind((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this));
        return _this;
    }
    (0, $f742022c5d2ac646$export$2e2bcd8739ae039)(Collection, [
        {
            key: "forceUpdate",
            value: function forceUpdate() {
                if (this._collectionView !== undefined) this._collectionView.forceUpdate();
            }
        },
        {
            key: "recomputeCellSizesAndPositions",
            value: function recomputeCellSizesAndPositions() {
                this._cellCache = [];
                this._collectionView.recomputeCellSizesAndPositions();
            }
        },
        {
            key: "render",
            value: function render() {
                var props = (0, $3d1b110f42b1c650$export$2e2bcd8739ae039)({}, this.props);
                return $NdCUR.createElement((0, $e2b500b023488d98$export$2e2bcd8739ae039), (0, $3d1b110f42b1c650$export$2e2bcd8739ae039)({
                    cellLayoutManager: this,
                    isScrollingChange: this._isScrollingChange,
                    ref: this._setCollectionViewRef
                }, props));
            }
        },
        {
            key: "calculateSizeAndPositionData",
            value: function calculateSizeAndPositionData() {
                var _this$props = this.props, cellCount = _this$props.cellCount, cellSizeAndPositionGetter = _this$props.cellSizeAndPositionGetter, sectionSize = _this$props.sectionSize;
                var data = (0, $92f08469ccfb495d$export$2e2bcd8739ae039)({
                    cellCount: cellCount,
                    cellSizeAndPositionGetter: cellSizeAndPositionGetter,
                    sectionSize: sectionSize
                });
                this._cellMetadata = data.cellMetadata;
                this._sectionManager = data.sectionManager;
                this._height = data.height;
                this._width = data.width;
            }
        },
        {
            key: "getLastRenderedIndices",
            value: function getLastRenderedIndices() {
                return this._lastRenderedCellIndices;
            }
        },
        {
            key: "getScrollPositionForCell",
            value: function getScrollPositionForCell(_ref) {
                var align = _ref.align, cellIndex = _ref.cellIndex, height = _ref.height, scrollLeft = _ref.scrollLeft, scrollTop = _ref.scrollTop, width = _ref.width;
                var cellCount = this.props.cellCount;
                if (cellIndex >= 0 && cellIndex < cellCount) {
                    var cellMetadata = this._cellMetadata[cellIndex];
                    scrollLeft = (0, $87ef4b7d7405a365$export$2e2bcd8739ae039)({
                        align: align,
                        cellOffset: cellMetadata.x,
                        cellSize: cellMetadata.width,
                        containerSize: width,
                        currentOffset: scrollLeft,
                        targetIndex: cellIndex
                    });
                    scrollTop = (0, $87ef4b7d7405a365$export$2e2bcd8739ae039)({
                        align: align,
                        cellOffset: cellMetadata.y,
                        cellSize: cellMetadata.height,
                        containerSize: height,
                        currentOffset: scrollTop,
                        targetIndex: cellIndex
                    });
                }
                return {
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop
                };
            }
        },
        {
            key: "getTotalSize",
            value: function getTotalSize() {
                return {
                    height: this._height,
                    width: this._width
                };
            }
        },
        {
            key: "cellRenderers",
            value: function cellRenderers(_ref2) {
                var _this2 = this;
                var height = _ref2.height, isScrolling = _ref2.isScrolling, width = _ref2.width, x = _ref2.x, y = _ref2.y;
                var _this$props2 = this.props, cellGroupRenderer = _this$props2.cellGroupRenderer, cellRenderer = _this$props2.cellRenderer; // Store for later calls to getLastRenderedIndices()
                this._lastRenderedCellIndices = this._sectionManager.getCellIndices({
                    height: height,
                    width: width,
                    x: x,
                    y: y
                });
                return cellGroupRenderer({
                    cellCache: this._cellCache,
                    cellRenderer: cellRenderer,
                    cellSizeAndPositionGetter: function cellSizeAndPositionGetter(_ref3) {
                        var index = _ref3.index;
                        return _this2._sectionManager.getCellMetadata({
                            index: index
                        });
                    },
                    indices: this._lastRenderedCellIndices,
                    isScrolling: isScrolling
                });
            }
        },
        {
            key: "_isScrollingChange",
            value: function _isScrollingChange(isScrolling) {
                if (!isScrolling) this._cellCache = [];
            }
        },
        {
            key: "_setCollectionViewRef",
            value: function _setCollectionViewRef(ref) {
                this._collectionView = ref;
            }
        }
    ]);
    return Collection;
}($NdCUR.PureComponent);
(0, $005fda52a7adba61$export$2e2bcd8739ae039)($c2c7b0c228af64d2$export$2e2bcd8739ae039, "defaultProps", {
    'aria-label': 'grid',
    cellGroupRenderer: $c2c7b0c228af64d2$var$defaultCellGroupRenderer
});
$c2c7b0c228af64d2$export$2e2bcd8739ae039.propTypes = {};
function $c2c7b0c228af64d2$var$defaultCellGroupRenderer(_ref4) {
    var cellCache = _ref4.cellCache, cellRenderer = _ref4.cellRenderer, cellSizeAndPositionGetter = _ref4.cellSizeAndPositionGetter, indices = _ref4.indices, isScrolling = _ref4.isScrolling;
    return indices.map(function(index) {
        var cellMetadata = cellSizeAndPositionGetter({
            index: index
        });
        var cellRendererProps = {
            index: index,
            isScrolling: isScrolling,
            key: index,
            style: {
                height: cellMetadata.height,
                left: cellMetadata.x,
                position: 'absolute',
                top: cellMetadata.y,
                width: cellMetadata.width
            }
        }; // Avoid re-creating cells while scrolling.
        // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
        // If a scroll is in progress- cache and reuse cells.
        // This cache will be thrown away once scrolling complets.
        if (isScrolling) {
            if (!(index in cellCache)) cellCache[index] = cellRenderer(cellRendererProps);
            return cellCache[index];
        } else return cellRenderer(cellRendererProps);
    }).filter(function(renderedCell) {
        return !!renderedCell;
    });
}


var $c2aba187dcb11318$export$2e2bcd8739ae039 = (0, $c2c7b0c228af64d2$export$2e2bcd8739ae039);










var $NdCUR = parcelRequire("NdCUR");
/**
 * High-order component that auto-calculates column-widths for `Grid` cells.
 */ var $3de865826e50231a$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$PureComponent) {
    (0, $fe3f597ee5eaea5e$export$2e2bcd8739ae039)(ColumnSizer, _React$PureComponent);
    function ColumnSizer(props, context) {
        var _this;
        (0, $7ab60400c9be8a6b$export$2e2bcd8739ae039)(this, ColumnSizer);
        _this = (0, $a26915f7b982dd67$export$2e2bcd8739ae039)(this, (0, $eae1db55e7e69c3d$export$2e2bcd8739ae039)(ColumnSizer).call(this, props, context));
        _this._registerChild = _this._registerChild.bind((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this));
        return _this;
    }
    (0, $f742022c5d2ac646$export$2e2bcd8739ae039)(ColumnSizer, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props = this.props, columnMaxWidth = _this$props.columnMaxWidth, columnMinWidth = _this$props.columnMinWidth, columnCount = _this$props.columnCount, width = _this$props.width;
                if (columnMaxWidth !== prevProps.columnMaxWidth || columnMinWidth !== prevProps.columnMinWidth || columnCount !== prevProps.columnCount || width !== prevProps.width) {
                    if (this._registeredChild) this._registeredChild.recomputeGridSize();
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, children = _this$props2.children, columnMaxWidth = _this$props2.columnMaxWidth, columnMinWidth = _this$props2.columnMinWidth, columnCount = _this$props2.columnCount, width = _this$props2.width;
                var safeColumnMinWidth = columnMinWidth || 1;
                var safeColumnMaxWidth = columnMaxWidth ? Math.min(columnMaxWidth, width) : width;
                var columnWidth = width / columnCount;
                columnWidth = Math.max(safeColumnMinWidth, columnWidth);
                columnWidth = Math.min(safeColumnMaxWidth, columnWidth);
                columnWidth = Math.floor(columnWidth);
                var adjustedWidth = Math.min(width, columnWidth * columnCount);
                return children({
                    adjustedWidth: adjustedWidth,
                    columnWidth: columnWidth,
                    getColumnWidth: function getColumnWidth() {
                        return columnWidth;
                    },
                    registerChild: this._registerChild
                });
            }
        },
        {
            key: "_registerChild",
            value: function _registerChild(child) {
                if (child && typeof child.recomputeGridSize !== 'function') throw Error('Unexpected child type registered; only Grid/MultiGrid children are supported.');
                this._registeredChild = child;
                if (this._registeredChild) this._registeredChild.recomputeGridSize();
            }
        }
    ]);
    return ColumnSizer;
}($NdCUR.PureComponent);
$3de865826e50231a$export$2e2bcd8739ae039.propTypes = {};


var $a5292c4a1bcca9df$export$2e2bcd8739ae039 = (0, $3de865826e50231a$export$2e2bcd8739ae039);



function $fc457b11b9557628$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $75d1a6dcc00fd748$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $fc457b11b9557628$export$2e2bcd8739ae039)(r);
}


function $22024904f9f0fa88$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $7531cc0c442d3666$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $fc457b11b9557628$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $fc457b11b9557628$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $08d45ae3ee313a2a$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $9d575d1563c3b9be$export$2e2bcd8739ae039(r) {
    return (0, $75d1a6dcc00fd748$export$2e2bcd8739ae039)(r) || (0, $22024904f9f0fa88$export$2e2bcd8739ae039)(r) || (0, $7531cc0c442d3666$export$2e2bcd8739ae039)(r) || (0, $08d45ae3ee313a2a$export$2e2bcd8739ae039)();
}










var $NdCUR = parcelRequire("NdCUR");


/**
 * Higher-order component that manages lazy-loading for "infinite" data.
 * This component decorates a virtual component and just-in-time prefetches rows as a user scrolls.
 * It is intended as a convenience component; fork it if you'd like finer-grained control over data-loading.
 */ var $9324e56cd5b2aaa8$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$PureComponent) {
    (0, $fe3f597ee5eaea5e$export$2e2bcd8739ae039)(InfiniteLoader, _React$PureComponent);
    function InfiniteLoader(props, context) {
        var _this;
        (0, $7ab60400c9be8a6b$export$2e2bcd8739ae039)(this, InfiniteLoader);
        _this = (0, $a26915f7b982dd67$export$2e2bcd8739ae039)(this, (0, $eae1db55e7e69c3d$export$2e2bcd8739ae039)(InfiniteLoader).call(this, props, context));
        _this._loadMoreRowsMemoizer = (0, $79f8f58d6f9cdb6e$export$2e2bcd8739ae039)();
        _this._onRowsRendered = _this._onRowsRendered.bind((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this));
        _this._registerChild = _this._registerChild.bind((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this));
        return _this;
    }
    (0, $f742022c5d2ac646$export$2e2bcd8739ae039)(InfiniteLoader, [
        {
            key: "resetLoadMoreRowsCache",
            value: function resetLoadMoreRowsCache(autoReload) {
                this._loadMoreRowsMemoizer = (0, $79f8f58d6f9cdb6e$export$2e2bcd8739ae039)();
                if (autoReload) this._doStuff(this._lastRenderedStartIndex, this._lastRenderedStopIndex);
            }
        },
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return children({
                    onRowsRendered: this._onRowsRendered,
                    registerChild: this._registerChild
                });
            }
        },
        {
            key: "_loadUnloadedRanges",
            value: function _loadUnloadedRanges(unloadedRanges) {
                var _this2 = this;
                var loadMoreRows = this.props.loadMoreRows;
                unloadedRanges.forEach(function(unloadedRange) {
                    var promise = loadMoreRows(unloadedRange);
                    if (promise) promise.then(function() {
                        // Refresh the visible rows if any of them have just been loaded.
                        // Otherwise they will remain in their unloaded visual state.
                        if ($9324e56cd5b2aaa8$export$f5bcfb715736e8f2({
                            lastRenderedStartIndex: _this2._lastRenderedStartIndex,
                            lastRenderedStopIndex: _this2._lastRenderedStopIndex,
                            startIndex: unloadedRange.startIndex,
                            stopIndex: unloadedRange.stopIndex
                        })) {
                            if (_this2._registeredChild) $9324e56cd5b2aaa8$export$2d6239c612aaa6dd(_this2._registeredChild, _this2._lastRenderedStartIndex);
                        }
                    });
                });
            }
        },
        {
            key: "_onRowsRendered",
            value: function _onRowsRendered(_ref) {
                var startIndex = _ref.startIndex, stopIndex = _ref.stopIndex;
                this._lastRenderedStartIndex = startIndex;
                this._lastRenderedStopIndex = stopIndex;
                this._doStuff(startIndex, stopIndex);
            }
        },
        {
            key: "_doStuff",
            value: function _doStuff(startIndex, stopIndex) {
                var _ref2, _this3 = this;
                var _this$props = this.props, isRowLoaded = _this$props.isRowLoaded, minimumBatchSize = _this$props.minimumBatchSize, rowCount = _this$props.rowCount, threshold = _this$props.threshold;
                var unloadedRanges = $9324e56cd5b2aaa8$export$2e183c7e20fa8fbf({
                    isRowLoaded: isRowLoaded,
                    minimumBatchSize: minimumBatchSize,
                    rowCount: rowCount,
                    startIndex: Math.max(0, startIndex - threshold),
                    stopIndex: Math.min(rowCount - 1, stopIndex + threshold)
                }); // For memoize comparison
                var squashedUnloadedRanges = (_ref2 = []).concat.apply(_ref2, (0, $9d575d1563c3b9be$export$2e2bcd8739ae039)(unloadedRanges.map(function(_ref3) {
                    var startIndex = _ref3.startIndex, stopIndex = _ref3.stopIndex;
                    return [
                        startIndex,
                        stopIndex
                    ];
                })));
                this._loadMoreRowsMemoizer({
                    callback: function callback() {
                        _this3._loadUnloadedRanges(unloadedRanges);
                    },
                    indices: {
                        squashedUnloadedRanges: squashedUnloadedRanges
                    }
                });
            }
        },
        {
            key: "_registerChild",
            value: function _registerChild(registeredChild) {
                this._registeredChild = registeredChild;
            }
        }
    ]);
    return InfiniteLoader;
}($NdCUR.PureComponent);
/**
 * Determines if the specified start/stop range is visible based on the most recently rendered range.
 */ (0, $005fda52a7adba61$export$2e2bcd8739ae039)($9324e56cd5b2aaa8$export$2e2bcd8739ae039, "defaultProps", {
    minimumBatchSize: 10,
    rowCount: 0,
    threshold: 15
});
$9324e56cd5b2aaa8$export$2e2bcd8739ae039.propTypes = {};
function $9324e56cd5b2aaa8$export$f5bcfb715736e8f2(_ref4) {
    var lastRenderedStartIndex = _ref4.lastRenderedStartIndex, lastRenderedStopIndex = _ref4.lastRenderedStopIndex, startIndex = _ref4.startIndex, stopIndex = _ref4.stopIndex;
    return !(startIndex > lastRenderedStopIndex || stopIndex < lastRenderedStartIndex);
}
function $9324e56cd5b2aaa8$export$2e183c7e20fa8fbf(_ref5) {
    var isRowLoaded = _ref5.isRowLoaded, minimumBatchSize = _ref5.minimumBatchSize, rowCount = _ref5.rowCount, startIndex = _ref5.startIndex, stopIndex = _ref5.stopIndex;
    var unloadedRanges = [];
    var rangeStartIndex = null;
    var rangeStopIndex = null;
    for(var index = startIndex; index <= stopIndex; index++){
        var loaded = isRowLoaded({
            index: index
        });
        if (!loaded) {
            rangeStopIndex = index;
            if (rangeStartIndex === null) rangeStartIndex = index;
        } else if (rangeStopIndex !== null) {
            unloadedRanges.push({
                startIndex: rangeStartIndex,
                stopIndex: rangeStopIndex
            });
            rangeStartIndex = rangeStopIndex = null;
        }
    } // If :rangeStopIndex is not null it means we haven't ran out of unloaded rows.
    // Scan forward to try filling our :minimumBatchSize.
    if (rangeStopIndex !== null) {
        var potentialStopIndex = Math.min(Math.max(rangeStopIndex, rangeStartIndex + minimumBatchSize - 1), rowCount - 1);
        for(var _index = rangeStopIndex + 1; _index <= potentialStopIndex; _index++){
            if (!isRowLoaded({
                index: _index
            })) rangeStopIndex = _index;
            else break;
        }
        unloadedRanges.push({
            startIndex: rangeStartIndex,
            stopIndex: rangeStopIndex
        });
    } // Check to see if our first range ended prematurely.
    // In this case we should scan backwards to try filling our :minimumBatchSize.
    if (unloadedRanges.length) {
        var firstUnloadedRange = unloadedRanges[0];
        while(firstUnloadedRange.stopIndex - firstUnloadedRange.startIndex + 1 < minimumBatchSize && firstUnloadedRange.startIndex > 0){
            var _index2 = firstUnloadedRange.startIndex - 1;
            if (!isRowLoaded({
                index: _index2
            })) firstUnloadedRange.startIndex = _index2;
            else break;
        }
    }
    return unloadedRanges;
}
function $9324e56cd5b2aaa8$export$2d6239c612aaa6dd(component) {
    var currentIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var recomputeSize = typeof component.recomputeGridSize === 'function' ? component.recomputeGridSize : component.recomputeRowHeights;
    if (recomputeSize) recomputeSize.call(component, currentIndex);
    else component.forceUpdate();
}


var $9cc40b9fa877c2c1$export$2e2bcd8739ae039 = (0, $9324e56cd5b2aaa8$export$2e2bcd8739ae039);












var $NdCUR = parcelRequire("NdCUR");

var $lbxdO = parcelRequire("lbxdO");
parcelRequire("NdCUR");

var $9f3d17f3470296f7$export$3a716df7746a4f4e = null;
var $9f3d17f3470296f7$export$ca2ef1a3c9fad673 = null;
var $9f3d17f3470296f7$export$99ebbe0230797f72 = null;
var $9f3d17f3470296f7$export$bf6962873c294da8 = null;



var $3ea382774dcf21ac$var$_class, $3ea382774dcf21ac$var$_temp;
/**
 * It is inefficient to create and manage a large list of DOM elements within a scrolling container
 * if only a few of those elements are visible. The primary purpose of this component is to improve
 * performance by only rendering the DOM nodes that a user is able to see based on their current
 * scroll position.
 *
 * This component renders a virtualized list of elements with either fixed or dynamic heights.
 */ var $3ea382774dcf21ac$export$2e2bcd8739ae039 = ($3ea382774dcf21ac$var$_temp = $3ea382774dcf21ac$var$_class = /*#__PURE__*/ function(_React$PureComponent) {
    (0, $fe3f597ee5eaea5e$export$2e2bcd8739ae039)(List, _React$PureComponent);
    function List() {
        var _getPrototypeOf2;
        var _this;
        (0, $7ab60400c9be8a6b$export$2e2bcd8739ae039)(this, List);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, $a26915f7b982dd67$export$2e2bcd8739ae039)(this, (_getPrototypeOf2 = (0, $eae1db55e7e69c3d$export$2e2bcd8739ae039)(List)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "Grid", void 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_cellRenderer", function(_ref) {
            var parent = _ref.parent, rowIndex = _ref.rowIndex, style = _ref.style, isScrolling = _ref.isScrolling, isVisible = _ref.isVisible, key = _ref.key;
            var rowRenderer = _this.props.rowRenderer; // TRICKY The style object is sometimes cached by Grid.
            // This prevents new style objects from bypassing shallowCompare().
            // However as of React 16, style props are auto-frozen (at least in dev mode)
            // Check to make sure we can still modify the style before proceeding.
            // https://github.com/facebook/react/commit/977357765b44af8ff0cfea327866861073095c12#commitcomment-20648713
            var widthDescriptor = Object.getOwnPropertyDescriptor(style, 'width');
            if (widthDescriptor && widthDescriptor.writable) // By default, List cells should be 100% width.
            // This prevents them from flowing under a scrollbar (if present).
            style.width = '100%';
            return rowRenderer({
                index: rowIndex,
                style: style,
                isScrolling: isScrolling,
                isVisible: isVisible,
                key: key,
                parent: parent
            });
        });
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_setRef", function(ref) {
            _this.Grid = ref;
        });
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_onScroll", function(_ref2) {
            var clientHeight = _ref2.clientHeight, scrollHeight = _ref2.scrollHeight, scrollTop = _ref2.scrollTop;
            var onScroll = _this.props.onScroll;
            onScroll({
                clientHeight: clientHeight,
                scrollHeight: scrollHeight,
                scrollTop: scrollTop
            });
        });
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_onSectionRendered", function(_ref3) {
            var rowOverscanStartIndex = _ref3.rowOverscanStartIndex, rowOverscanStopIndex = _ref3.rowOverscanStopIndex, rowStartIndex = _ref3.rowStartIndex, rowStopIndex = _ref3.rowStopIndex;
            var onRowsRendered = _this.props.onRowsRendered;
            onRowsRendered({
                overscanStartIndex: rowOverscanStartIndex,
                overscanStopIndex: rowOverscanStopIndex,
                startIndex: rowStartIndex,
                stopIndex: rowStopIndex
            });
        });
        return _this;
    }
    (0, $f742022c5d2ac646$export$2e2bcd8739ae039)(List, [
        {
            key: "forceUpdateGrid",
            value: function forceUpdateGrid() {
                if (this.Grid) this.Grid.forceUpdate();
            }
        },
        {
            key: "getOffsetForRow",
            value: function getOffsetForRow(_ref4) {
                var alignment = _ref4.alignment, index = _ref4.index;
                if (this.Grid) {
                    var _this$Grid$getOffsetF = this.Grid.getOffsetForCell({
                        alignment: alignment,
                        rowIndex: index,
                        columnIndex: 0
                    }), scrollTop = _this$Grid$getOffsetF.scrollTop;
                    return scrollTop;
                }
                return 0;
            }
        },
        {
            key: "invalidateCellSizeAfterRender",
            value: function invalidateCellSizeAfterRender(_ref5) {
                var columnIndex = _ref5.columnIndex, rowIndex = _ref5.rowIndex;
                if (this.Grid) this.Grid.invalidateCellSizeAfterRender({
                    rowIndex: rowIndex,
                    columnIndex: columnIndex
                });
            }
        },
        {
            key: "measureAllRows",
            value: function measureAllRows() {
                if (this.Grid) this.Grid.measureAllCells();
            }
        },
        {
            key: "recomputeGridSize",
            value: function recomputeGridSize() {
                var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref6$columnIndex = _ref6.columnIndex, columnIndex = _ref6$columnIndex === void 0 ? 0 : _ref6$columnIndex, _ref6$rowIndex = _ref6.rowIndex, rowIndex = _ref6$rowIndex === void 0 ? 0 : _ref6$rowIndex;
                if (this.Grid) this.Grid.recomputeGridSize({
                    rowIndex: rowIndex,
                    columnIndex: columnIndex
                });
            }
        },
        {
            key: "recomputeRowHeights",
            value: function recomputeRowHeights() {
                var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.recomputeGridSize({
                    rowIndex: index,
                    columnIndex: 0
                });
            }
        },
        {
            key: "scrollToPosition",
            value: function scrollToPosition() {
                var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.scrollToPosition({
                    scrollTop: scrollTop
                });
            }
        },
        {
            key: "scrollToRow",
            value: function scrollToRow() {
                var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.scrollToCell({
                    columnIndex: 0,
                    rowIndex: index
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, className = _this$props.className, noRowsRenderer = _this$props.noRowsRenderer, scrollToIndex = _this$props.scrollToIndex, width = _this$props.width;
                var classNames = (0, $lbxdO.default)('ReactVirtualized__List', className);
                return $NdCUR.createElement((0, $df00be2467032761$export$2e2bcd8739ae039), (0, $3d1b110f42b1c650$export$2e2bcd8739ae039)({}, this.props, {
                    autoContainerWidth: true,
                    cellRenderer: this._cellRenderer,
                    className: classNames,
                    columnWidth: width,
                    columnCount: 1,
                    noContentRenderer: noRowsRenderer,
                    onScroll: this._onScroll,
                    onSectionRendered: this._onSectionRendered,
                    ref: this._setRef,
                    scrollToRow: scrollToIndex
                }));
            }
        }
    ]);
    return List;
}($NdCUR.PureComponent), (0, $005fda52a7adba61$export$2e2bcd8739ae039)($3ea382774dcf21ac$var$_class, "propTypes", null), $3ea382774dcf21ac$var$_temp);
(0, $005fda52a7adba61$export$2e2bcd8739ae039)($3ea382774dcf21ac$export$2e2bcd8739ae039, "defaultProps", {
    autoHeight: false,
    estimatedRowSize: 30,
    onScroll: function onScroll() {},
    noRowsRenderer: function noRowsRenderer() {
        return null;
    },
    onRowsRendered: function onRowsRendered() {},
    overscanIndicesGetter: (0, $7608b63d3b3be2cd$export$2e2bcd8739ae039),
    overscanRowCount: 10,
    scrollToAlignment: 'auto',
    scrollToIndex: -1,
    style: {}
});













var $lbxdO = parcelRequire("lbxdO");

var $NdCUR = parcelRequire("NdCUR");

function $20da54572b304dfa$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $04432a8c2ce59dd3$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}



function $2cf207aeb71bf9ea$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $cee92fdb1c3de2a9$export$2e2bcd8739ae039(r, e) {
    return (0, $20da54572b304dfa$export$2e2bcd8739ae039)(r) || (0, $04432a8c2ce59dd3$export$2e2bcd8739ae039)(r, e) || (0, $7531cc0c442d3666$export$2e2bcd8739ae039)(r, e) || (0, $2cf207aeb71bf9ea$export$2e2bcd8739ae039)();
}





/**
 * Binary Search Bounds
 * https://github.com/mikolalysenko/interval-tree-1d
 * Mikola Lysenko
 *
 * Inlined because of Content Security Policy issue caused by the use of `new Function(...)` syntax in an upstream dependency.
 * Issue reported here: https://github.com/mikolalysenko/binary-search-bounds/issues/5
 **/ /**
 * Binary Search Bounds
 * https://github.com/mikolalysenko/binary-search-bounds
 * Mikola Lysenko
 *
 * Inlined because of Content Security Policy issue caused by the use of `new Function(...)` syntax.
 * Issue reported here: https://github.com/mikolalysenko/binary-search-bounds/issues/5
 **/ function $533371c66ff231b8$var$_GEA(a, l, h, y) {
    var i = h + 1;
    while(l <= h){
        var m = l + h >>> 1, x = a[m];
        if (x >= y) {
            i = m;
            h = m - 1;
        } else l = m + 1;
    }
    return i;
}
function $533371c66ff231b8$var$_GEP(a, l, h, y, c) {
    var i = h + 1;
    while(l <= h){
        var m = l + h >>> 1, x = a[m];
        if (c(x, y) >= 0) {
            i = m;
            h = m - 1;
        } else l = m + 1;
    }
    return i;
}
function $533371c66ff231b8$var$dispatchBsearchGE(a, y, c, l, h) {
    if (typeof c === 'function') return $533371c66ff231b8$var$_GEP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
    else return $533371c66ff231b8$var$_GEA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
}
function $533371c66ff231b8$var$_GTA(a, l, h, y) {
    var i = h + 1;
    while(l <= h){
        var m = l + h >>> 1, x = a[m];
        if (x > y) {
            i = m;
            h = m - 1;
        } else l = m + 1;
    }
    return i;
}
function $533371c66ff231b8$var$_GTP(a, l, h, y, c) {
    var i = h + 1;
    while(l <= h){
        var m = l + h >>> 1, x = a[m];
        if (c(x, y) > 0) {
            i = m;
            h = m - 1;
        } else l = m + 1;
    }
    return i;
}
function $533371c66ff231b8$var$dispatchBsearchGT(a, y, c, l, h) {
    if (typeof c === 'function') return $533371c66ff231b8$var$_GTP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
    else return $533371c66ff231b8$var$_GTA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
}
function $533371c66ff231b8$var$_LTA(a, l, h, y) {
    var i = l - 1;
    while(l <= h){
        var m = l + h >>> 1, x = a[m];
        if (x < y) {
            i = m;
            l = m + 1;
        } else h = m - 1;
    }
    return i;
}
function $533371c66ff231b8$var$_LTP(a, l, h, y, c) {
    var i = l - 1;
    while(l <= h){
        var m = l + h >>> 1, x = a[m];
        if (c(x, y) < 0) {
            i = m;
            l = m + 1;
        } else h = m - 1;
    }
    return i;
}
function $533371c66ff231b8$var$dispatchBsearchLT(a, y, c, l, h) {
    if (typeof c === 'function') return $533371c66ff231b8$var$_LTP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
    else return $533371c66ff231b8$var$_LTA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
}
function $533371c66ff231b8$var$_LEA(a, l, h, y) {
    var i = l - 1;
    while(l <= h){
        var m = l + h >>> 1, x = a[m];
        if (x <= y) {
            i = m;
            l = m + 1;
        } else h = m - 1;
    }
    return i;
}
function $533371c66ff231b8$var$_LEP(a, l, h, y, c) {
    var i = l - 1;
    while(l <= h){
        var m = l + h >>> 1, x = a[m];
        if (c(x, y) <= 0) {
            i = m;
            l = m + 1;
        } else h = m - 1;
    }
    return i;
}
function $533371c66ff231b8$var$dispatchBsearchLE(a, y, c, l, h) {
    if (typeof c === 'function') return $533371c66ff231b8$var$_LEP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
    else return $533371c66ff231b8$var$_LEA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
}
function $533371c66ff231b8$var$_EQA(a, l, h, y) {
    l;
    while(l <= h){
        var m = l + h >>> 1, x = a[m];
        if (x === y) return m;
        else if (x <= y) l = m + 1;
        else h = m - 1;
    }
    return -1;
}
function $533371c66ff231b8$var$_EQP(a, l, h, y, c) {
    l;
    while(l <= h){
        var m = l + h >>> 1, x = a[m];
        var p = c(x, y);
        if (p === 0) return m;
        else if (p <= 0) l = m + 1;
        else h = m - 1;
    }
    return -1;
}
function $533371c66ff231b8$var$dispatchBsearchEQ(a, y, c, l, h) {
    if (typeof c === 'function') return $533371c66ff231b8$var$_EQP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
    else return $533371c66ff231b8$var$_EQA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
}
var $533371c66ff231b8$export$2e2bcd8739ae039 = {
    ge: $533371c66ff231b8$var$dispatchBsearchGE,
    gt: $533371c66ff231b8$var$dispatchBsearchGT,
    lt: $533371c66ff231b8$var$dispatchBsearchLT,
    le: $533371c66ff231b8$var$dispatchBsearchLE,
    eq: $533371c66ff231b8$var$dispatchBsearchEQ
};


var $fbd7331d5a5a7d0d$var$NOT_FOUND = 0;
var $fbd7331d5a5a7d0d$var$SUCCESS = 1;
var $fbd7331d5a5a7d0d$var$EMPTY = 2;
function $fbd7331d5a5a7d0d$var$IntervalTreeNode(mid, left, right, leftPoints, rightPoints) {
    this.mid = mid;
    this.left = left;
    this.right = right;
    this.leftPoints = leftPoints;
    this.rightPoints = rightPoints;
    this.count = (left ? left.count : 0) + (right ? right.count : 0) + leftPoints.length;
}
var $fbd7331d5a5a7d0d$var$proto = $fbd7331d5a5a7d0d$var$IntervalTreeNode.prototype;
function $fbd7331d5a5a7d0d$var$copy(a, b) {
    a.mid = b.mid;
    a.left = b.left;
    a.right = b.right;
    a.leftPoints = b.leftPoints;
    a.rightPoints = b.rightPoints;
    a.count = b.count;
}
function $fbd7331d5a5a7d0d$var$rebuild(node, intervals) {
    var ntree = $fbd7331d5a5a7d0d$var$createIntervalTree(intervals);
    node.mid = ntree.mid;
    node.left = ntree.left;
    node.right = ntree.right;
    node.leftPoints = ntree.leftPoints;
    node.rightPoints = ntree.rightPoints;
    node.count = ntree.count;
}
function $fbd7331d5a5a7d0d$var$rebuildWithInterval(node, interval) {
    var intervals = node.intervals([]);
    intervals.push(interval);
    $fbd7331d5a5a7d0d$var$rebuild(node, intervals);
}
function $fbd7331d5a5a7d0d$var$rebuildWithoutInterval(node, interval) {
    var intervals = node.intervals([]);
    var idx = intervals.indexOf(interval);
    if (idx < 0) return $fbd7331d5a5a7d0d$var$NOT_FOUND;
    intervals.splice(idx, 1);
    $fbd7331d5a5a7d0d$var$rebuild(node, intervals);
    return $fbd7331d5a5a7d0d$var$SUCCESS;
}
$fbd7331d5a5a7d0d$var$proto.intervals = function(result) {
    result.push.apply(result, this.leftPoints);
    if (this.left) this.left.intervals(result);
    if (this.right) this.right.intervals(result);
    return result;
};
$fbd7331d5a5a7d0d$var$proto.insert = function(interval) {
    var weight = this.count - this.leftPoints.length;
    this.count += 1;
    if (interval[1] < this.mid) {
        if (this.left) {
            if (4 * (this.left.count + 1) > 3 * (weight + 1)) $fbd7331d5a5a7d0d$var$rebuildWithInterval(this, interval);
            else this.left.insert(interval);
        } else this.left = $fbd7331d5a5a7d0d$var$createIntervalTree([
            interval
        ]);
    } else if (interval[0] > this.mid) {
        if (this.right) {
            if (4 * (this.right.count + 1) > 3 * (weight + 1)) $fbd7331d5a5a7d0d$var$rebuildWithInterval(this, interval);
            else this.right.insert(interval);
        } else this.right = $fbd7331d5a5a7d0d$var$createIntervalTree([
            interval
        ]);
    } else {
        var l = (0, $533371c66ff231b8$export$2e2bcd8739ae039).ge(this.leftPoints, interval, $fbd7331d5a5a7d0d$var$compareBegin);
        var r = (0, $533371c66ff231b8$export$2e2bcd8739ae039).ge(this.rightPoints, interval, $fbd7331d5a5a7d0d$var$compareEnd);
        this.leftPoints.splice(l, 0, interval);
        this.rightPoints.splice(r, 0, interval);
    }
};
$fbd7331d5a5a7d0d$var$proto.remove = function(interval) {
    var weight = this.count - this.leftPoints;
    if (interval[1] < this.mid) {
        if (!this.left) return $fbd7331d5a5a7d0d$var$NOT_FOUND;
        var rw = this.right ? this.right.count : 0;
        if (4 * rw > 3 * (weight - 1)) return $fbd7331d5a5a7d0d$var$rebuildWithoutInterval(this, interval);
        var r = this.left.remove(interval);
        if (r === $fbd7331d5a5a7d0d$var$EMPTY) {
            this.left = null;
            this.count -= 1;
            return $fbd7331d5a5a7d0d$var$SUCCESS;
        } else if (r === $fbd7331d5a5a7d0d$var$SUCCESS) this.count -= 1;
        return r;
    } else if (interval[0] > this.mid) {
        if (!this.right) return $fbd7331d5a5a7d0d$var$NOT_FOUND;
        var lw = this.left ? this.left.count : 0;
        if (4 * lw > 3 * (weight - 1)) return $fbd7331d5a5a7d0d$var$rebuildWithoutInterval(this, interval);
        var r = this.right.remove(interval);
        if (r === $fbd7331d5a5a7d0d$var$EMPTY) {
            this.right = null;
            this.count -= 1;
            return $fbd7331d5a5a7d0d$var$SUCCESS;
        } else if (r === $fbd7331d5a5a7d0d$var$SUCCESS) this.count -= 1;
        return r;
    } else {
        if (this.count === 1) {
            if (this.leftPoints[0] === interval) return $fbd7331d5a5a7d0d$var$EMPTY;
            else return $fbd7331d5a5a7d0d$var$NOT_FOUND;
        }
        if (this.leftPoints.length === 1 && this.leftPoints[0] === interval) {
            if (this.left && this.right) {
                var p = this;
                var n = this.left;
                while(n.right){
                    p = n;
                    n = n.right;
                }
                if (p === this) n.right = this.right;
                else {
                    var l = this.left;
                    var r = this.right;
                    p.count -= n.count;
                    p.right = n.left;
                    n.left = l;
                    n.right = r;
                }
                $fbd7331d5a5a7d0d$var$copy(this, n);
                this.count = (this.left ? this.left.count : 0) + (this.right ? this.right.count : 0) + this.leftPoints.length;
            } else if (this.left) $fbd7331d5a5a7d0d$var$copy(this, this.left);
            else $fbd7331d5a5a7d0d$var$copy(this, this.right);
            return $fbd7331d5a5a7d0d$var$SUCCESS;
        }
        for(var l = (0, $533371c66ff231b8$export$2e2bcd8739ae039).ge(this.leftPoints, interval, $fbd7331d5a5a7d0d$var$compareBegin); l < this.leftPoints.length; ++l){
            if (this.leftPoints[l][0] !== interval[0]) break;
            if (this.leftPoints[l] === interval) {
                this.count -= 1;
                this.leftPoints.splice(l, 1);
                for(var r = (0, $533371c66ff231b8$export$2e2bcd8739ae039).ge(this.rightPoints, interval, $fbd7331d5a5a7d0d$var$compareEnd); r < this.rightPoints.length; ++r){
                    if (this.rightPoints[r][1] !== interval[1]) break;
                    else if (this.rightPoints[r] === interval) {
                        this.rightPoints.splice(r, 1);
                        return $fbd7331d5a5a7d0d$var$SUCCESS;
                    }
                }
            }
        }
        return $fbd7331d5a5a7d0d$var$NOT_FOUND;
    }
};
function $fbd7331d5a5a7d0d$var$reportLeftRange(arr, hi, cb) {
    for(var i = 0; i < arr.length && arr[i][0] <= hi; ++i){
        var r = cb(arr[i]);
        if (r) return r;
    }
}
function $fbd7331d5a5a7d0d$var$reportRightRange(arr, lo, cb) {
    for(var i = arr.length - 1; i >= 0 && arr[i][1] >= lo; --i){
        var r = cb(arr[i]);
        if (r) return r;
    }
}
function $fbd7331d5a5a7d0d$var$reportRange(arr, cb) {
    for(var i = 0; i < arr.length; ++i){
        var r = cb(arr[i]);
        if (r) return r;
    }
}
$fbd7331d5a5a7d0d$var$proto.queryPoint = function(x, cb) {
    if (x < this.mid) {
        if (this.left) {
            var r = this.left.queryPoint(x, cb);
            if (r) return r;
        }
        return $fbd7331d5a5a7d0d$var$reportLeftRange(this.leftPoints, x, cb);
    } else if (x > this.mid) {
        if (this.right) {
            var r = this.right.queryPoint(x, cb);
            if (r) return r;
        }
        return $fbd7331d5a5a7d0d$var$reportRightRange(this.rightPoints, x, cb);
    } else return $fbd7331d5a5a7d0d$var$reportRange(this.leftPoints, cb);
};
$fbd7331d5a5a7d0d$var$proto.queryInterval = function(lo, hi, cb) {
    if (lo < this.mid && this.left) {
        var r = this.left.queryInterval(lo, hi, cb);
        if (r) return r;
    }
    if (hi > this.mid && this.right) {
        var r = this.right.queryInterval(lo, hi, cb);
        if (r) return r;
    }
    if (hi < this.mid) return $fbd7331d5a5a7d0d$var$reportLeftRange(this.leftPoints, hi, cb);
    else if (lo > this.mid) return $fbd7331d5a5a7d0d$var$reportRightRange(this.rightPoints, lo, cb);
    else return $fbd7331d5a5a7d0d$var$reportRange(this.leftPoints, cb);
};
function $fbd7331d5a5a7d0d$var$compareNumbers(a, b) {
    return a - b;
}
function $fbd7331d5a5a7d0d$var$compareBegin(a, b) {
    var d = a[0] - b[0];
    if (d) return d;
    return a[1] - b[1];
}
function $fbd7331d5a5a7d0d$var$compareEnd(a, b) {
    var d = a[1] - b[1];
    if (d) return d;
    return a[0] - b[0];
}
function $fbd7331d5a5a7d0d$var$createIntervalTree(intervals) {
    if (intervals.length === 0) return null;
    var pts = [];
    for(var i = 0; i < intervals.length; ++i)pts.push(intervals[i][0], intervals[i][1]);
    pts.sort($fbd7331d5a5a7d0d$var$compareNumbers);
    var mid = pts[pts.length >> 1];
    var leftIntervals = [];
    var rightIntervals = [];
    var centerIntervals = [];
    for(var i = 0; i < intervals.length; ++i){
        var s = intervals[i];
        if (s[1] < mid) leftIntervals.push(s);
        else if (mid < s[0]) rightIntervals.push(s);
        else centerIntervals.push(s);
    } //Split center intervals
    var leftPoints = centerIntervals;
    var rightPoints = centerIntervals.slice();
    leftPoints.sort($fbd7331d5a5a7d0d$var$compareBegin);
    rightPoints.sort($fbd7331d5a5a7d0d$var$compareEnd);
    return new $fbd7331d5a5a7d0d$var$IntervalTreeNode(mid, $fbd7331d5a5a7d0d$var$createIntervalTree(leftIntervals), $fbd7331d5a5a7d0d$var$createIntervalTree(rightIntervals), leftPoints, rightPoints);
} //User friendly wrapper that makes it possible to support empty trees
function $fbd7331d5a5a7d0d$var$IntervalTree(root) {
    this.root = root;
}
var $fbd7331d5a5a7d0d$var$tproto = $fbd7331d5a5a7d0d$var$IntervalTree.prototype;
$fbd7331d5a5a7d0d$var$tproto.insert = function(interval) {
    if (this.root) this.root.insert(interval);
    else this.root = new $fbd7331d5a5a7d0d$var$IntervalTreeNode(interval[0], null, null, [
        interval
    ], [
        interval
    ]);
};
$fbd7331d5a5a7d0d$var$tproto.remove = function(interval) {
    if (this.root) {
        var r = this.root.remove(interval);
        if (r === $fbd7331d5a5a7d0d$var$EMPTY) this.root = null;
        return r !== $fbd7331d5a5a7d0d$var$NOT_FOUND;
    }
    return false;
};
$fbd7331d5a5a7d0d$var$tproto.queryPoint = function(p, cb) {
    if (this.root) return this.root.queryPoint(p, cb);
};
$fbd7331d5a5a7d0d$var$tproto.queryInterval = function(lo, hi, cb) {
    if (lo <= hi && this.root) return this.root.queryInterval(lo, hi, cb);
};
Object.defineProperty($fbd7331d5a5a7d0d$var$tproto, 'count', {
    get: function get() {
        if (this.root) return this.root.count;
        return 0;
    }
});
Object.defineProperty($fbd7331d5a5a7d0d$var$tproto, 'intervals', {
    get: function get() {
        if (this.root) return this.root.intervals([]);
        return [];
    }
});
function $fbd7331d5a5a7d0d$export$2e2bcd8739ae039(intervals) {
    if (!intervals || intervals.length === 0) return new $fbd7331d5a5a7d0d$var$IntervalTree(null);
    return new $fbd7331d5a5a7d0d$var$IntervalTree($fbd7331d5a5a7d0d$var$createIntervalTree(intervals));
}


// Position cache requirements:
//   O(log(n)) lookup of cells to render for a given viewport size
//   O(1) lookup of shortest measured column (so we know when to enter phase 1)
var $0b5891fb81632469$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function PositionCache() {
        (0, $7ab60400c9be8a6b$export$2e2bcd8739ae039)(this, PositionCache);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)(this, "_columnSizeMap", {});
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)(this, "_intervalTree", (0, $fbd7331d5a5a7d0d$export$2e2bcd8739ae039)());
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)(this, "_leftMap", {});
    }
    (0, $f742022c5d2ac646$export$2e2bcd8739ae039)(PositionCache, [
        {
            key: "estimateTotalHeight",
            value: function estimateTotalHeight(cellCount, columnCount, defaultCellHeight) {
                var unmeasuredCellCount = cellCount - this.count;
                return this.tallestColumnSize + Math.ceil(unmeasuredCellCount / columnCount) * defaultCellHeight;
            } // Render all cells visible within the viewport range defined.
        },
        {
            key: "range",
            value: function range(scrollTop, clientHeight, renderCallback) {
                var _this = this;
                this._intervalTree.queryInterval(scrollTop, scrollTop + clientHeight, function(_ref) {
                    var _ref2 = (0, $cee92fdb1c3de2a9$export$2e2bcd8739ae039)(_ref, 3), top = _ref2[0], _ = _ref2[1], index = _ref2[2];
                    return renderCallback(index, _this._leftMap[index], top);
                });
            }
        },
        {
            key: "setPosition",
            value: function setPosition(index, left, top, height) {
                this._intervalTree.insert([
                    top,
                    top + height,
                    index
                ]);
                this._leftMap[index] = left;
                var columnSizeMap = this._columnSizeMap;
                var columnHeight = columnSizeMap[left];
                if (columnHeight === undefined) columnSizeMap[left] = top + height;
                else columnSizeMap[left] = Math.max(columnHeight, top + height);
            }
        },
        {
            key: "count",
            get: function get() {
                return this._intervalTree.count;
            }
        },
        {
            key: "shortestColumnSize",
            get: function get() {
                var columnSizeMap = this._columnSizeMap;
                var size = 0;
                for(var i in columnSizeMap){
                    var height = columnSizeMap[i];
                    size = size === 0 ? height : Math.min(size, height);
                }
                return size;
            }
        },
        {
            key: "tallestColumnSize",
            get: function get() {
                var columnSizeMap = this._columnSizeMap;
                var size = 0;
                for(var i in columnSizeMap){
                    var height = columnSizeMap[i];
                    size = Math.max(size, height);
                }
                return size;
            }
        }
    ]);
    return PositionCache;
}();




var $bbec7f919afd6999$var$_class, $bbec7f919afd6999$var$_temp;
function $bbec7f919afd6999$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bbec7f919afd6999$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $bbec7f919afd6999$var$ownKeys(source, true).forEach(function(key) {
            (0, $005fda52a7adba61$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $bbec7f919afd6999$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $bbec7f919afd6999$var$emptyObject = {};
var $bbec7f919afd6999$export$c51e03d5b92ea76f = 150;
/**
 * This component efficiently displays arbitrarily positioned cells using windowing techniques.
 * Cell position is determined by an injected `cellPositioner` property.
 * Windowing is vertical; this component does not support horizontal scrolling.
 *
 * Rendering occurs in two phases:
 * 1) First pass uses estimated cell sizes (provided by the cache) to determine how many cells to measure in a batch.
 *    Batch size is chosen using a fast, naive layout algorithm that stacks images in order until the viewport has been filled.
 *    After measurement is complete (componentDidMount or componentDidUpdate) this component evaluates positioned cells
 *    in order to determine if another measurement pass is required (eg if actual cell sizes were less than estimated sizes).
 *    All measurements are permanently cached (keyed by `keyMapper`) for performance purposes.
 * 2) Second pass uses the external `cellPositioner` to layout cells.
 *    At this time the positioner has access to cached size measurements for all cells.
 *    The positions it returns are cached by Masonry for fast access later.
 *    Phase one is repeated if the user scrolls beyond the current layout's bounds.
 *    If the layout is invalidated due to eg a resize, cached positions can be cleared using `recomputeCellPositions()`.
 *
 * Animation constraints:
 *   Simple animations are supported (eg translate/slide into place on initial reveal).
 *   More complex animations are not (eg flying from one position to another on resize).
 *
 * Layout constraints:
 *   This component supports multi-column layout.
 *   The height of each item may vary.
 *   The width of each item must not exceed the width of the column it is "in".
 *   The left position of all items within a column must align.
 *   (Items may not span multiple columns.)
 */ var $bbec7f919afd6999$var$Masonry = ($bbec7f919afd6999$var$_temp = $bbec7f919afd6999$var$_class = /*#__PURE__*/ function(_React$PureComponent) {
    (0, $fe3f597ee5eaea5e$export$2e2bcd8739ae039)(Masonry, _React$PureComponent);
    function Masonry() {
        var _getPrototypeOf2;
        var _this;
        (0, $7ab60400c9be8a6b$export$2e2bcd8739ae039)(this, Masonry);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, $a26915f7b982dd67$export$2e2bcd8739ae039)(this, (_getPrototypeOf2 = (0, $eae1db55e7e69c3d$export$2e2bcd8739ae039)(Masonry)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "state", {
            isScrolling: false,
            scrollTop: 0
        });
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_debounceResetIsScrollingId", void 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_invalidateOnUpdateStartIndex", null);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_invalidateOnUpdateStopIndex", null);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_positionCache", new (0, $0b5891fb81632469$export$2e2bcd8739ae039)());
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_startIndex", null);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_startIndexMemoized", null);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_stopIndex", null);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_stopIndexMemoized", null);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_debounceResetIsScrollingCallback", function() {
            _this.setState({
                isScrolling: false
            });
        });
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_setScrollingContainerRef", function(ref) {
            _this._scrollingContainer = ref;
        });
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_onScroll", function(event) {
            var height = _this.props.height;
            var eventScrollTop = event.currentTarget.scrollTop; // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
            // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
            // This causes a series of rapid renders that is slow for long lists.
            // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.
            var scrollTop = Math.min(Math.max(0, _this._getEstimatedTotalHeight() - height), eventScrollTop); // On iOS, we can arrive at negative offsets by swiping past the start or end.
            // Avoid re-rendering in this case as it can cause problems; see #532 for more.
            if (eventScrollTop !== scrollTop) return;
             // Prevent pointer events from interrupting a smooth scroll
            _this._debounceResetIsScrolling(); // Certain devices (like Apple touchpad) rapid-fire duplicate events.
            // Don't force a re-render if this is the case.
            // The mouse may move faster then the animation frame does.
            // Use requestAnimationFrame to avoid over-updating.
            if (_this.state.scrollTop !== scrollTop) _this.setState({
                isScrolling: true,
                scrollTop: scrollTop
            });
        });
        return _this;
    }
    (0, $f742022c5d2ac646$export$2e2bcd8739ae039)(Masonry, [
        {
            key: "clearCellPositions",
            value: function clearCellPositions() {
                this._positionCache = new (0, $0b5891fb81632469$export$2e2bcd8739ae039)();
                this.forceUpdate();
            } // HACK This method signature was intended for Grid
        },
        {
            key: "invalidateCellSizeAfterRender",
            value: function invalidateCellSizeAfterRender(_ref) {
                var index = _ref.rowIndex;
                if (this._invalidateOnUpdateStartIndex === null) {
                    this._invalidateOnUpdateStartIndex = index;
                    this._invalidateOnUpdateStopIndex = index;
                } else {
                    this._invalidateOnUpdateStartIndex = Math.min(this._invalidateOnUpdateStartIndex, index);
                    this._invalidateOnUpdateStopIndex = Math.max(this._invalidateOnUpdateStopIndex, index);
                }
            }
        },
        {
            key: "recomputeCellPositions",
            value: function recomputeCellPositions() {
                var stopIndex = this._positionCache.count - 1;
                this._positionCache = new (0, $0b5891fb81632469$export$2e2bcd8739ae039)();
                this._populatePositionCache(0, stopIndex);
                this.forceUpdate();
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this._checkInvalidateOnUpdate();
                this._invokeOnScrollCallback();
                this._invokeOnCellsRenderedCallback();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                this._checkInvalidateOnUpdate();
                this._invokeOnScrollCallback();
                this._invokeOnCellsRenderedCallback();
                if (this.props.scrollTop !== prevProps.scrollTop) this._debounceResetIsScrolling();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this._debounceResetIsScrollingId) (0, $ef0c7be04d84646a$export$3b976196c7d0d7a6)(this._debounceResetIsScrollingId);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, autoHeight = _this$props.autoHeight, cellCount = _this$props.cellCount, cellMeasurerCache = _this$props.cellMeasurerCache, cellRenderer = _this$props.cellRenderer, className = _this$props.className, height = _this$props.height, id = _this$props.id, keyMapper = _this$props.keyMapper, overscanByPixels = _this$props.overscanByPixels, role = _this$props.role, style = _this$props.style, tabIndex = _this$props.tabIndex, width = _this$props.width, rowDirection = _this$props.rowDirection;
                var _this$state = this.state, isScrolling = _this$state.isScrolling, scrollTop = _this$state.scrollTop;
                var children = [];
                var estimateTotalHeight = this._getEstimatedTotalHeight();
                var shortestColumnSize = this._positionCache.shortestColumnSize;
                var measuredCellCount = this._positionCache.count;
                var startIndex = 0;
                var stopIndex;
                this._positionCache.range(Math.max(0, scrollTop - overscanByPixels), height + overscanByPixels * 2, function(index, left, top) {
                    var _style;
                    if (typeof stopIndex === 'undefined') {
                        startIndex = index;
                        stopIndex = index;
                    } else {
                        startIndex = Math.min(startIndex, index);
                        stopIndex = Math.max(stopIndex, index);
                    }
                    children.push(cellRenderer({
                        index: index,
                        isScrolling: isScrolling,
                        key: keyMapper(index),
                        parent: _this2,
                        style: (_style = {
                            height: cellMeasurerCache.getHeight(index)
                        }, (0, $005fda52a7adba61$export$2e2bcd8739ae039)(_style, rowDirection === 'ltr' ? 'left' : 'right', left), (0, $005fda52a7adba61$export$2e2bcd8739ae039)(_style, "position", 'absolute'), (0, $005fda52a7adba61$export$2e2bcd8739ae039)(_style, "top", top), (0, $005fda52a7adba61$export$2e2bcd8739ae039)(_style, "width", cellMeasurerCache.getWidth(index)), _style)
                    }));
                }); // We need to measure additional cells for this layout
                if (shortestColumnSize < scrollTop + height + overscanByPixels && measuredCellCount < cellCount) {
                    var batchSize = Math.min(cellCount - measuredCellCount, Math.ceil((scrollTop + height + overscanByPixels - shortestColumnSize) / cellMeasurerCache.defaultHeight * width / cellMeasurerCache.defaultWidth));
                    for(var _index = measuredCellCount; _index < measuredCellCount + batchSize; _index++){
                        stopIndex = _index;
                        children.push(cellRenderer({
                            index: _index,
                            isScrolling: isScrolling,
                            key: keyMapper(_index),
                            parent: this,
                            style: {
                                width: cellMeasurerCache.getWidth(_index)
                            }
                        }));
                    }
                }
                this._startIndex = startIndex;
                this._stopIndex = stopIndex;
                return $NdCUR.createElement("div", {
                    ref: this._setScrollingContainerRef,
                    "aria-label": this.props['aria-label'],
                    className: (0, $lbxdO.default)('ReactVirtualized__Masonry', className),
                    id: id,
                    onScroll: this._onScroll,
                    role: role,
                    style: $bbec7f919afd6999$var$_objectSpread({
                        boxSizing: 'border-box',
                        direction: 'ltr',
                        height: autoHeight ? 'auto' : height,
                        overflowX: 'hidden',
                        overflowY: estimateTotalHeight < height ? 'hidden' : 'auto',
                        position: 'relative',
                        width: width,
                        WebkitOverflowScrolling: 'touch',
                        willChange: 'transform'
                    }, style),
                    tabIndex: tabIndex
                }, $NdCUR.createElement("div", {
                    className: "ReactVirtualized__Masonry__innerScrollContainer",
                    style: {
                        width: '100%',
                        height: estimateTotalHeight,
                        maxWidth: '100%',
                        maxHeight: estimateTotalHeight,
                        overflow: 'hidden',
                        pointerEvents: isScrolling ? 'none' : '',
                        position: 'relative'
                    }
                }, children));
            }
        },
        {
            key: "_checkInvalidateOnUpdate",
            value: function _checkInvalidateOnUpdate() {
                if (typeof this._invalidateOnUpdateStartIndex === 'number') {
                    var startIndex = this._invalidateOnUpdateStartIndex;
                    var stopIndex = this._invalidateOnUpdateStopIndex;
                    this._invalidateOnUpdateStartIndex = null;
                    this._invalidateOnUpdateStopIndex = null; // Query external layout logic for position of newly-measured cells
                    this._populatePositionCache(startIndex, stopIndex);
                    this.forceUpdate();
                }
            }
        },
        {
            key: "_debounceResetIsScrolling",
            value: function _debounceResetIsScrolling() {
                var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;
                if (this._debounceResetIsScrollingId) (0, $ef0c7be04d84646a$export$3b976196c7d0d7a6)(this._debounceResetIsScrollingId);
                this._debounceResetIsScrollingId = (0, $ef0c7be04d84646a$export$62c6fa81f9943047)(this._debounceResetIsScrollingCallback, scrollingResetTimeInterval);
            }
        },
        {
            key: "_getEstimatedTotalHeight",
            value: function _getEstimatedTotalHeight() {
                var _this$props2 = this.props, cellCount = _this$props2.cellCount, cellMeasurerCache = _this$props2.cellMeasurerCache, width = _this$props2.width;
                var estimatedColumnCount = Math.max(1, Math.floor(width / cellMeasurerCache.defaultWidth));
                return this._positionCache.estimateTotalHeight(cellCount, estimatedColumnCount, cellMeasurerCache.defaultHeight);
            }
        },
        {
            key: "_invokeOnScrollCallback",
            value: function _invokeOnScrollCallback() {
                var _this$props3 = this.props, height = _this$props3.height, onScroll = _this$props3.onScroll;
                var scrollTop = this.state.scrollTop;
                if (this._onScrollMemoized !== scrollTop) {
                    onScroll({
                        clientHeight: height,
                        scrollHeight: this._getEstimatedTotalHeight(),
                        scrollTop: scrollTop
                    });
                    this._onScrollMemoized = scrollTop;
                }
            }
        },
        {
            key: "_invokeOnCellsRenderedCallback",
            value: function _invokeOnCellsRenderedCallback() {
                if (this._startIndexMemoized !== this._startIndex || this._stopIndexMemoized !== this._stopIndex) {
                    var onCellsRendered = this.props.onCellsRendered;
                    onCellsRendered({
                        startIndex: this._startIndex,
                        stopIndex: this._stopIndex
                    });
                    this._startIndexMemoized = this._startIndex;
                    this._stopIndexMemoized = this._stopIndex;
                }
            }
        },
        {
            key: "_populatePositionCache",
            value: function _populatePositionCache(startIndex, stopIndex) {
                var _this$props4 = this.props, cellMeasurerCache = _this$props4.cellMeasurerCache, cellPositioner = _this$props4.cellPositioner;
                for(var _index2 = startIndex; _index2 <= stopIndex; _index2++){
                    var _cellPositioner = cellPositioner(_index2), left = _cellPositioner.left, top = _cellPositioner.top;
                    this._positionCache.setPosition(_index2, left, top, cellMeasurerCache.getHeight(_index2));
                }
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.scrollTop !== undefined && prevState.scrollTop !== nextProps.scrollTop) return {
                    isScrolling: true,
                    scrollTop: nextProps.scrollTop
                };
                return null;
            }
        }
    ]);
    return Masonry;
}($NdCUR.PureComponent), (0, $005fda52a7adba61$export$2e2bcd8739ae039)($bbec7f919afd6999$var$_class, "propTypes", null), $bbec7f919afd6999$var$_temp);
(0, $005fda52a7adba61$export$2e2bcd8739ae039)($bbec7f919afd6999$var$Masonry, "defaultProps", {
    autoHeight: false,
    keyMapper: $bbec7f919afd6999$var$identity,
    onCellsRendered: $bbec7f919afd6999$var$noop,
    onScroll: $bbec7f919afd6999$var$noop,
    overscanByPixels: 20,
    role: 'grid',
    scrollingResetTimeInterval: $bbec7f919afd6999$export$c51e03d5b92ea76f,
    style: $bbec7f919afd6999$var$emptyObject,
    tabIndex: 0,
    rowDirection: 'ltr'
});
function $bbec7f919afd6999$var$identity(value) {
    return value;
}
function $bbec7f919afd6999$var$noop() {}
var $bbec7f919afd6999$export$d0ff04c4baca3470 = null;
(0, $e7f50e4820b1eac7$export$cea1c58a6db52bca)($bbec7f919afd6999$var$Masonry);
var $bbec7f919afd6999$export$2e2bcd8739ae039 = $bbec7f919afd6999$var$Masonry;
var $bbec7f919afd6999$export$8eb93bb8d3be3940 = null;


function $ff28f7cded562661$export$2e2bcd8739ae039(_ref) {
    var cellMeasurerCache = _ref.cellMeasurerCache, columnCount = _ref.columnCount, columnWidth = _ref.columnWidth, _ref$spacer = _ref.spacer, spacer = _ref$spacer === void 0 ? 0 : _ref$spacer;
    var columnHeights;
    initOrResetDerivedValues();
    function cellPositioner(index) {
        // Find the shortest column and use it.
        var columnIndex = 0;
        for(var i = 1; i < columnHeights.length; i++)if (columnHeights[i] < columnHeights[columnIndex]) columnIndex = i;
        var left = columnIndex * (columnWidth + spacer);
        var top = columnHeights[columnIndex] || 0;
        columnHeights[columnIndex] = top + cellMeasurerCache.getHeight(index) + spacer;
        return {
            left: left,
            top: top
        };
    }
    function initOrResetDerivedValues() {
        // Track the height of each column.
        // Layout algorithm below always inserts into the shortest column.
        columnHeights = [];
        for(var i = 0; i < columnCount; i++)columnHeights[i] = 0;
    }
    function reset(params) {
        columnCount = params.columnCount;
        columnWidth = params.columnWidth;
        spacer = params.spacer;
        initOrResetDerivedValues();
    }
    cellPositioner.reset = reset;
    return cellPositioner;
}



var $029898f02cba8e8d$export$2e2bcd8739ae039 = (0, $bbec7f919afd6999$export$2e2bcd8739ae039);













var $NdCUR = parcelRequire("NdCUR");





/**
 * Caches measurements for a given cell.
 */ var $22b5705e8fea783e$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function CellMeasurerCacheDecorator() {
        var _this = this;
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $7ab60400c9be8a6b$export$2e2bcd8739ae039)(this, CellMeasurerCacheDecorator);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)(this, "_cellMeasurerCache", void 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)(this, "_columnIndexOffset", void 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)(this, "_rowIndexOffset", void 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)(this, "columnWidth", function(_ref) {
            var index = _ref.index;
            _this._cellMeasurerCache.columnWidth({
                index: index + _this._columnIndexOffset
            });
        });
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)(this, "rowHeight", function(_ref2) {
            var index = _ref2.index;
            _this._cellMeasurerCache.rowHeight({
                index: index + _this._rowIndexOffset
            });
        });
        var cellMeasurerCache = params.cellMeasurerCache, _params$columnIndexOf = params.columnIndexOffset, columnIndexOffset = _params$columnIndexOf === void 0 ? 0 : _params$columnIndexOf, _params$rowIndexOffse = params.rowIndexOffset, rowIndexOffset = _params$rowIndexOffse === void 0 ? 0 : _params$rowIndexOffse;
        this._cellMeasurerCache = cellMeasurerCache;
        this._columnIndexOffset = columnIndexOffset;
        this._rowIndexOffset = rowIndexOffset;
    }
    (0, $f742022c5d2ac646$export$2e2bcd8739ae039)(CellMeasurerCacheDecorator, [
        {
            key: "clear",
            value: function clear(rowIndex, columnIndex) {
                this._cellMeasurerCache.clear(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
            }
        },
        {
            key: "clearAll",
            value: function clearAll() {
                this._cellMeasurerCache.clearAll();
            }
        },
        {
            key: "hasFixedHeight",
            value: function hasFixedHeight() {
                return this._cellMeasurerCache.hasFixedHeight();
            }
        },
        {
            key: "hasFixedWidth",
            value: function hasFixedWidth() {
                return this._cellMeasurerCache.hasFixedWidth();
            }
        },
        {
            key: "getHeight",
            value: function getHeight(rowIndex) {
                var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                return this._cellMeasurerCache.getHeight(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
            }
        },
        {
            key: "getWidth",
            value: function getWidth(rowIndex) {
                var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                return this._cellMeasurerCache.getWidth(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
            }
        },
        {
            key: "has",
            value: function has(rowIndex) {
                var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                return this._cellMeasurerCache.has(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
            }
        },
        {
            key: "set",
            value: function set(rowIndex, columnIndex, width, height) {
                this._cellMeasurerCache.set(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset, width, height);
            }
        },
        {
            key: "defaultHeight",
            get: function get() {
                return this._cellMeasurerCache.defaultHeight;
            }
        },
        {
            key: "defaultWidth",
            get: function get() {
                return this._cellMeasurerCache.defaultWidth;
            }
        }
    ]);
    return CellMeasurerCacheDecorator;
}();



function $b7ade1ce0987eefe$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b7ade1ce0987eefe$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $b7ade1ce0987eefe$var$ownKeys(source, true).forEach(function(key) {
            (0, $005fda52a7adba61$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $b7ade1ce0987eefe$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $b7ade1ce0987eefe$var$SCROLLBAR_SIZE_BUFFER = 20;
/**
 * Renders 1, 2, or 4 Grids depending on configuration.
 * A main (body) Grid will always be rendered.
 * Optionally, 1-2 Grids for sticky header rows will also be rendered.
 * If no sticky columns, only 1 sticky header Grid will be rendered.
 * If sticky columns, 2 sticky header Grids will be rendered.
 */ var $b7ade1ce0987eefe$var$MultiGrid = /*#__PURE__*/ function(_React$PureComponent) {
    (0, $fe3f597ee5eaea5e$export$2e2bcd8739ae039)(MultiGrid, _React$PureComponent);
    function MultiGrid(props, context) {
        var _this;
        (0, $7ab60400c9be8a6b$export$2e2bcd8739ae039)(this, MultiGrid);
        _this = (0, $a26915f7b982dd67$export$2e2bcd8739ae039)(this, (0, $eae1db55e7e69c3d$export$2e2bcd8739ae039)(MultiGrid).call(this, props, context));
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "state", {
            scrollLeft: 0,
            scrollTop: 0,
            scrollbarSize: 0,
            showHorizontalScrollbar: false,
            showVerticalScrollbar: false
        });
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_deferredInvalidateColumnIndex", null);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_deferredInvalidateRowIndex", null);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_bottomLeftGridRef", function(ref) {
            _this._bottomLeftGrid = ref;
        });
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_bottomRightGridRef", function(ref) {
            _this._bottomRightGrid = ref;
        });
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_cellRendererBottomLeftGrid", function(_ref) {
            var rowIndex = _ref.rowIndex, rest = (0, $c54935d4bae462e6$export$2e2bcd8739ae039)(_ref, [
                "rowIndex"
            ]);
            var _this$props = _this.props, cellRenderer = _this$props.cellRenderer, fixedRowCount = _this$props.fixedRowCount, rowCount = _this$props.rowCount;
            if (rowIndex === rowCount - fixedRowCount) return $NdCUR.createElement("div", {
                key: rest.key,
                style: $b7ade1ce0987eefe$var$_objectSpread({}, rest.style, {
                    height: $b7ade1ce0987eefe$var$SCROLLBAR_SIZE_BUFFER
                })
            });
            else return cellRenderer($b7ade1ce0987eefe$var$_objectSpread({}, rest, {
                parent: (0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this),
                rowIndex: rowIndex + fixedRowCount
            }));
        });
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_cellRendererBottomRightGrid", function(_ref2) {
            var columnIndex = _ref2.columnIndex, rowIndex = _ref2.rowIndex, rest = (0, $c54935d4bae462e6$export$2e2bcd8739ae039)(_ref2, [
                "columnIndex",
                "rowIndex"
            ]);
            var _this$props2 = _this.props, cellRenderer = _this$props2.cellRenderer, fixedColumnCount = _this$props2.fixedColumnCount, fixedRowCount = _this$props2.fixedRowCount;
            return cellRenderer($b7ade1ce0987eefe$var$_objectSpread({}, rest, {
                columnIndex: columnIndex + fixedColumnCount,
                parent: (0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this),
                rowIndex: rowIndex + fixedRowCount
            }));
        });
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_cellRendererTopRightGrid", function(_ref3) {
            var columnIndex = _ref3.columnIndex, rest = (0, $c54935d4bae462e6$export$2e2bcd8739ae039)(_ref3, [
                "columnIndex"
            ]);
            var _this$props3 = _this.props, cellRenderer = _this$props3.cellRenderer, columnCount = _this$props3.columnCount, fixedColumnCount = _this$props3.fixedColumnCount;
            if (columnIndex === columnCount - fixedColumnCount) return $NdCUR.createElement("div", {
                key: rest.key,
                style: $b7ade1ce0987eefe$var$_objectSpread({}, rest.style, {
                    width: $b7ade1ce0987eefe$var$SCROLLBAR_SIZE_BUFFER
                })
            });
            else return cellRenderer($b7ade1ce0987eefe$var$_objectSpread({}, rest, {
                columnIndex: columnIndex + fixedColumnCount,
                parent: (0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this)
            }));
        });
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_columnWidthRightGrid", function(_ref4) {
            var index = _ref4.index;
            var _this$props4 = _this.props, columnCount = _this$props4.columnCount, fixedColumnCount = _this$props4.fixedColumnCount, columnWidth = _this$props4.columnWidth;
            var _this$state = _this.state, scrollbarSize = _this$state.scrollbarSize, showHorizontalScrollbar = _this$state.showHorizontalScrollbar; // An extra cell is added to the count
            // This gives the smaller Grid extra room for offset,
            // In case the main (bottom right) Grid has a scrollbar
            // If no scrollbar, the extra space is overflow:hidden anyway
            if (showHorizontalScrollbar && index === columnCount - fixedColumnCount) return scrollbarSize;
            return typeof columnWidth === 'function' ? columnWidth({
                index: index + fixedColumnCount
            }) : columnWidth;
        });
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_onScroll", function(scrollInfo) {
            var scrollLeft = scrollInfo.scrollLeft, scrollTop = scrollInfo.scrollTop;
            _this.setState({
                scrollLeft: scrollLeft,
                scrollTop: scrollTop
            });
            var onScroll = _this.props.onScroll;
            if (onScroll) onScroll(scrollInfo);
        });
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_onScrollbarPresenceChange", function(_ref5) {
            var horizontal = _ref5.horizontal, size = _ref5.size, vertical = _ref5.vertical;
            var _this$state2 = _this.state, showHorizontalScrollbar = _this$state2.showHorizontalScrollbar, showVerticalScrollbar = _this$state2.showVerticalScrollbar;
            if (horizontal !== showHorizontalScrollbar || vertical !== showVerticalScrollbar) {
                _this.setState({
                    scrollbarSize: size,
                    showHorizontalScrollbar: horizontal,
                    showVerticalScrollbar: vertical
                });
                var onScrollbarPresenceChange = _this.props.onScrollbarPresenceChange;
                if (typeof onScrollbarPresenceChange === 'function') onScrollbarPresenceChange({
                    horizontal: horizontal,
                    size: size,
                    vertical: vertical
                });
            }
        });
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_onScrollLeft", function(scrollInfo) {
            var scrollLeft = scrollInfo.scrollLeft;
            _this._onScroll({
                scrollLeft: scrollLeft,
                scrollTop: _this.state.scrollTop
            });
        });
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_onScrollTop", function(scrollInfo) {
            var scrollTop = scrollInfo.scrollTop;
            _this._onScroll({
                scrollTop: scrollTop,
                scrollLeft: _this.state.scrollLeft
            });
        });
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_rowHeightBottomGrid", function(_ref6) {
            var index = _ref6.index;
            var _this$props5 = _this.props, fixedRowCount = _this$props5.fixedRowCount, rowCount = _this$props5.rowCount, rowHeight = _this$props5.rowHeight;
            var _this$state3 = _this.state, scrollbarSize = _this$state3.scrollbarSize, showVerticalScrollbar = _this$state3.showVerticalScrollbar; // An extra cell is added to the count
            // This gives the smaller Grid extra room for offset,
            // In case the main (bottom right) Grid has a scrollbar
            // If no scrollbar, the extra space is overflow:hidden anyway
            if (showVerticalScrollbar && index === rowCount - fixedRowCount) return scrollbarSize;
            return typeof rowHeight === 'function' ? rowHeight({
                index: index + fixedRowCount
            }) : rowHeight;
        });
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_topLeftGridRef", function(ref) {
            _this._topLeftGrid = ref;
        });
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_topRightGridRef", function(ref) {
            _this._topRightGrid = ref;
        });
        var deferredMeasurementCache = props.deferredMeasurementCache, _fixedColumnCount = props.fixedColumnCount, _fixedRowCount = props.fixedRowCount;
        _this._maybeCalculateCachedStyles(true);
        if (deferredMeasurementCache) {
            _this._deferredMeasurementCacheBottomLeftGrid = _fixedRowCount > 0 ? new (0, $22b5705e8fea783e$export$2e2bcd8739ae039)({
                cellMeasurerCache: deferredMeasurementCache,
                columnIndexOffset: 0,
                rowIndexOffset: _fixedRowCount
            }) : deferredMeasurementCache;
            _this._deferredMeasurementCacheBottomRightGrid = _fixedColumnCount > 0 || _fixedRowCount > 0 ? new (0, $22b5705e8fea783e$export$2e2bcd8739ae039)({
                cellMeasurerCache: deferredMeasurementCache,
                columnIndexOffset: _fixedColumnCount,
                rowIndexOffset: _fixedRowCount
            }) : deferredMeasurementCache;
            _this._deferredMeasurementCacheTopRightGrid = _fixedColumnCount > 0 ? new (0, $22b5705e8fea783e$export$2e2bcd8739ae039)({
                cellMeasurerCache: deferredMeasurementCache,
                columnIndexOffset: _fixedColumnCount,
                rowIndexOffset: 0
            }) : deferredMeasurementCache;
        }
        return _this;
    }
    (0, $f742022c5d2ac646$export$2e2bcd8739ae039)(MultiGrid, [
        {
            key: "forceUpdateGrids",
            value: function forceUpdateGrids() {
                this._bottomLeftGrid && this._bottomLeftGrid.forceUpdate();
                this._bottomRightGrid && this._bottomRightGrid.forceUpdate();
                this._topLeftGrid && this._topLeftGrid.forceUpdate();
                this._topRightGrid && this._topRightGrid.forceUpdate();
            }
        },
        {
            key: "invalidateCellSizeAfterRender",
            value: function invalidateCellSizeAfterRender() {
                var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref7$columnIndex = _ref7.columnIndex, columnIndex = _ref7$columnIndex === void 0 ? 0 : _ref7$columnIndex, _ref7$rowIndex = _ref7.rowIndex, rowIndex = _ref7$rowIndex === void 0 ? 0 : _ref7$rowIndex;
                this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
                this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
            }
        },
        {
            key: "measureAllCells",
            value: function measureAllCells() {
                this._bottomLeftGrid && this._bottomLeftGrid.measureAllCells();
                this._bottomRightGrid && this._bottomRightGrid.measureAllCells();
                this._topLeftGrid && this._topLeftGrid.measureAllCells();
                this._topRightGrid && this._topRightGrid.measureAllCells();
            }
        },
        {
            key: "recomputeGridSize",
            value: function recomputeGridSize() {
                var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref8$columnIndex = _ref8.columnIndex, columnIndex = _ref8$columnIndex === void 0 ? 0 : _ref8$columnIndex, _ref8$rowIndex = _ref8.rowIndex, rowIndex = _ref8$rowIndex === void 0 ? 0 : _ref8$rowIndex;
                var _this$props6 = this.props, fixedColumnCount = _this$props6.fixedColumnCount, fixedRowCount = _this$props6.fixedRowCount;
                var adjustedColumnIndex = Math.max(0, columnIndex - fixedColumnCount);
                var adjustedRowIndex = Math.max(0, rowIndex - fixedRowCount);
                this._bottomLeftGrid && this._bottomLeftGrid.recomputeGridSize({
                    columnIndex: columnIndex,
                    rowIndex: adjustedRowIndex
                });
                this._bottomRightGrid && this._bottomRightGrid.recomputeGridSize({
                    columnIndex: adjustedColumnIndex,
                    rowIndex: adjustedRowIndex
                });
                this._topLeftGrid && this._topLeftGrid.recomputeGridSize({
                    columnIndex: columnIndex,
                    rowIndex: rowIndex
                });
                this._topRightGrid && this._topRightGrid.recomputeGridSize({
                    columnIndex: adjustedColumnIndex,
                    rowIndex: rowIndex
                });
                this._leftGridWidth = null;
                this._topGridHeight = null;
                this._maybeCalculateCachedStyles(true);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props7 = this.props, scrollLeft = _this$props7.scrollLeft, scrollTop = _this$props7.scrollTop;
                if (scrollLeft > 0 || scrollTop > 0) {
                    var newState = {};
                    if (scrollLeft > 0) newState.scrollLeft = scrollLeft;
                    if (scrollTop > 0) newState.scrollTop = scrollTop;
                    this.setState(newState);
                }
                this._handleInvalidatedGridSize();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this._handleInvalidatedGridSize();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props8 = this.props, onScroll = _this$props8.onScroll, onSectionRendered = _this$props8.onSectionRendered, onScrollbarPresenceChange = _this$props8.onScrollbarPresenceChange, scrollLeftProp = _this$props8.scrollLeft, scrollToColumn = _this$props8.scrollToColumn, scrollTopProp = _this$props8.scrollTop, scrollToRow = _this$props8.scrollToRow, rest = (0, $c54935d4bae462e6$export$2e2bcd8739ae039)(_this$props8, [
                    "onScroll",
                    "onSectionRendered",
                    "onScrollbarPresenceChange",
                    "scrollLeft",
                    "scrollToColumn",
                    "scrollTop",
                    "scrollToRow"
                ]);
                this._prepareForRender(); // Don't render any of our Grids if there are no cells.
                // This mirrors what Grid does,
                // And prevents us from recording inaccurage measurements when used with CellMeasurer.
                if (this.props.width === 0 || this.props.height === 0) return null;
                 // scrollTop and scrollLeft props are explicitly filtered out and ignored
                var _this$state4 = this.state, scrollLeft = _this$state4.scrollLeft, scrollTop = _this$state4.scrollTop;
                return $NdCUR.createElement("div", {
                    style: this._containerOuterStyle
                }, $NdCUR.createElement("div", {
                    style: this._containerTopStyle
                }, this._renderTopLeftGrid(rest), this._renderTopRightGrid($b7ade1ce0987eefe$var$_objectSpread({}, rest, {
                    onScroll: onScroll,
                    scrollLeft: scrollLeft
                }))), $NdCUR.createElement("div", {
                    style: this._containerBottomStyle
                }, this._renderBottomLeftGrid($b7ade1ce0987eefe$var$_objectSpread({}, rest, {
                    onScroll: onScroll,
                    scrollTop: scrollTop
                })), this._renderBottomRightGrid($b7ade1ce0987eefe$var$_objectSpread({}, rest, {
                    onScroll: onScroll,
                    onSectionRendered: onSectionRendered,
                    scrollLeft: scrollLeft,
                    scrollToColumn: scrollToColumn,
                    scrollToRow: scrollToRow,
                    scrollTop: scrollTop
                }))));
            }
        },
        {
            key: "_getBottomGridHeight",
            value: function _getBottomGridHeight(props) {
                var height = props.height;
                var topGridHeight = this._getTopGridHeight(props);
                return height - topGridHeight;
            }
        },
        {
            key: "_getLeftGridWidth",
            value: function _getLeftGridWidth(props) {
                var fixedColumnCount = props.fixedColumnCount, columnWidth = props.columnWidth;
                if (this._leftGridWidth == null) {
                    if (typeof columnWidth === 'function') {
                        var leftGridWidth = 0;
                        for(var index = 0; index < fixedColumnCount; index++)leftGridWidth += columnWidth({
                            index: index
                        });
                        this._leftGridWidth = leftGridWidth;
                    } else this._leftGridWidth = columnWidth * fixedColumnCount;
                }
                return this._leftGridWidth;
            }
        },
        {
            key: "_getRightGridWidth",
            value: function _getRightGridWidth(props) {
                var width = props.width;
                var leftGridWidth = this._getLeftGridWidth(props);
                return width - leftGridWidth;
            }
        },
        {
            key: "_getTopGridHeight",
            value: function _getTopGridHeight(props) {
                var fixedRowCount = props.fixedRowCount, rowHeight = props.rowHeight;
                if (this._topGridHeight == null) {
                    if (typeof rowHeight === 'function') {
                        var topGridHeight = 0;
                        for(var index = 0; index < fixedRowCount; index++)topGridHeight += rowHeight({
                            index: index
                        });
                        this._topGridHeight = topGridHeight;
                    } else this._topGridHeight = rowHeight * fixedRowCount;
                }
                return this._topGridHeight;
            }
        },
        {
            key: "_handleInvalidatedGridSize",
            value: function _handleInvalidatedGridSize() {
                if (typeof this._deferredInvalidateColumnIndex === 'number') {
                    var columnIndex = this._deferredInvalidateColumnIndex;
                    var rowIndex = this._deferredInvalidateRowIndex;
                    this._deferredInvalidateColumnIndex = null;
                    this._deferredInvalidateRowIndex = null;
                    this.recomputeGridSize({
                        columnIndex: columnIndex,
                        rowIndex: rowIndex
                    });
                    this.forceUpdate();
                }
            }
        },
        {
            key: "_maybeCalculateCachedStyles",
            value: function _maybeCalculateCachedStyles(resetAll) {
                var _this$props9 = this.props, columnWidth = _this$props9.columnWidth, enableFixedColumnScroll = _this$props9.enableFixedColumnScroll, enableFixedRowScroll = _this$props9.enableFixedRowScroll, height = _this$props9.height, fixedColumnCount = _this$props9.fixedColumnCount, fixedRowCount = _this$props9.fixedRowCount, rowHeight = _this$props9.rowHeight, style = _this$props9.style, styleBottomLeftGrid = _this$props9.styleBottomLeftGrid, styleBottomRightGrid = _this$props9.styleBottomRightGrid, styleTopLeftGrid = _this$props9.styleTopLeftGrid, styleTopRightGrid = _this$props9.styleTopRightGrid, width = _this$props9.width;
                var sizeChange = resetAll || height !== this._lastRenderedHeight || width !== this._lastRenderedWidth;
                var leftSizeChange = resetAll || columnWidth !== this._lastRenderedColumnWidth || fixedColumnCount !== this._lastRenderedFixedColumnCount;
                var topSizeChange = resetAll || fixedRowCount !== this._lastRenderedFixedRowCount || rowHeight !== this._lastRenderedRowHeight;
                if (resetAll || sizeChange || style !== this._lastRenderedStyle) this._containerOuterStyle = $b7ade1ce0987eefe$var$_objectSpread({
                    height: height,
                    overflow: 'visible',
                    // Let :focus outline show through
                    width: width
                }, style);
                if (resetAll || sizeChange || topSizeChange) {
                    this._containerTopStyle = {
                        height: this._getTopGridHeight(this.props),
                        position: 'relative',
                        width: width
                    };
                    this._containerBottomStyle = {
                        height: height - this._getTopGridHeight(this.props),
                        overflow: 'visible',
                        // Let :focus outline show through
                        position: 'relative',
                        width: width
                    };
                }
                if (resetAll || styleBottomLeftGrid !== this._lastRenderedStyleBottomLeftGrid) this._bottomLeftGridStyle = $b7ade1ce0987eefe$var$_objectSpread({
                    left: 0,
                    overflowX: 'hidden',
                    overflowY: enableFixedColumnScroll ? 'auto' : 'hidden',
                    position: 'absolute'
                }, styleBottomLeftGrid);
                if (resetAll || leftSizeChange || styleBottomRightGrid !== this._lastRenderedStyleBottomRightGrid) this._bottomRightGridStyle = $b7ade1ce0987eefe$var$_objectSpread({
                    left: this._getLeftGridWidth(this.props),
                    position: 'absolute'
                }, styleBottomRightGrid);
                if (resetAll || styleTopLeftGrid !== this._lastRenderedStyleTopLeftGrid) this._topLeftGridStyle = $b7ade1ce0987eefe$var$_objectSpread({
                    left: 0,
                    overflowX: 'hidden',
                    overflowY: 'hidden',
                    position: 'absolute',
                    top: 0
                }, styleTopLeftGrid);
                if (resetAll || leftSizeChange || styleTopRightGrid !== this._lastRenderedStyleTopRightGrid) this._topRightGridStyle = $b7ade1ce0987eefe$var$_objectSpread({
                    left: this._getLeftGridWidth(this.props),
                    overflowX: enableFixedRowScroll ? 'auto' : 'hidden',
                    overflowY: 'hidden',
                    position: 'absolute',
                    top: 0
                }, styleTopRightGrid);
                this._lastRenderedColumnWidth = columnWidth;
                this._lastRenderedFixedColumnCount = fixedColumnCount;
                this._lastRenderedFixedRowCount = fixedRowCount;
                this._lastRenderedHeight = height;
                this._lastRenderedRowHeight = rowHeight;
                this._lastRenderedStyle = style;
                this._lastRenderedStyleBottomLeftGrid = styleBottomLeftGrid;
                this._lastRenderedStyleBottomRightGrid = styleBottomRightGrid;
                this._lastRenderedStyleTopLeftGrid = styleTopLeftGrid;
                this._lastRenderedStyleTopRightGrid = styleTopRightGrid;
                this._lastRenderedWidth = width;
            }
        },
        {
            key: "_prepareForRender",
            value: function _prepareForRender() {
                if (this._lastRenderedColumnWidth !== this.props.columnWidth || this._lastRenderedFixedColumnCount !== this.props.fixedColumnCount) this._leftGridWidth = null;
                if (this._lastRenderedFixedRowCount !== this.props.fixedRowCount || this._lastRenderedRowHeight !== this.props.rowHeight) this._topGridHeight = null;
                this._maybeCalculateCachedStyles();
                this._lastRenderedColumnWidth = this.props.columnWidth;
                this._lastRenderedFixedColumnCount = this.props.fixedColumnCount;
                this._lastRenderedFixedRowCount = this.props.fixedRowCount;
                this._lastRenderedRowHeight = this.props.rowHeight;
            }
        },
        {
            key: "_renderBottomLeftGrid",
            value: function _renderBottomLeftGrid(props) {
                var enableFixedColumnScroll = props.enableFixedColumnScroll, fixedColumnCount = props.fixedColumnCount, fixedRowCount = props.fixedRowCount, rowCount = props.rowCount, hideBottomLeftGridScrollbar = props.hideBottomLeftGridScrollbar;
                var showVerticalScrollbar = this.state.showVerticalScrollbar;
                if (!fixedColumnCount) return null;
                var additionalRowCount = showVerticalScrollbar ? 1 : 0, height = this._getBottomGridHeight(props), width = this._getLeftGridWidth(props), scrollbarSize = this.state.showVerticalScrollbar ? this.state.scrollbarSize : 0, gridWidth = hideBottomLeftGridScrollbar ? width + scrollbarSize : width;
                var bottomLeftGrid = $NdCUR.createElement((0, $df00be2467032761$export$2e2bcd8739ae039), (0, $3d1b110f42b1c650$export$2e2bcd8739ae039)({}, props, {
                    cellRenderer: this._cellRendererBottomLeftGrid,
                    className: this.props.classNameBottomLeftGrid,
                    columnCount: fixedColumnCount,
                    deferredMeasurementCache: this._deferredMeasurementCacheBottomLeftGrid,
                    height: height,
                    onScroll: enableFixedColumnScroll ? this._onScrollTop : undefined,
                    ref: this._bottomLeftGridRef,
                    rowCount: Math.max(0, rowCount - fixedRowCount) + additionalRowCount,
                    rowHeight: this._rowHeightBottomGrid,
                    style: this._bottomLeftGridStyle,
                    tabIndex: null,
                    width: gridWidth
                }));
                if (hideBottomLeftGridScrollbar) return $NdCUR.createElement("div", {
                    className: "BottomLeftGrid_ScrollWrapper",
                    style: $b7ade1ce0987eefe$var$_objectSpread({}, this._bottomLeftGridStyle, {
                        height: height,
                        width: width,
                        overflowY: 'hidden'
                    })
                }, bottomLeftGrid);
                return bottomLeftGrid;
            }
        },
        {
            key: "_renderBottomRightGrid",
            value: function _renderBottomRightGrid(props) {
                var columnCount = props.columnCount, fixedColumnCount = props.fixedColumnCount, fixedRowCount = props.fixedRowCount, rowCount = props.rowCount, scrollToColumn = props.scrollToColumn, scrollToRow = props.scrollToRow;
                return $NdCUR.createElement((0, $df00be2467032761$export$2e2bcd8739ae039), (0, $3d1b110f42b1c650$export$2e2bcd8739ae039)({}, props, {
                    cellRenderer: this._cellRendererBottomRightGrid,
                    className: this.props.classNameBottomRightGrid,
                    columnCount: Math.max(0, columnCount - fixedColumnCount),
                    columnWidth: this._columnWidthRightGrid,
                    deferredMeasurementCache: this._deferredMeasurementCacheBottomRightGrid,
                    height: this._getBottomGridHeight(props),
                    onScroll: this._onScroll,
                    onScrollbarPresenceChange: this._onScrollbarPresenceChange,
                    ref: this._bottomRightGridRef,
                    rowCount: Math.max(0, rowCount - fixedRowCount),
                    rowHeight: this._rowHeightBottomGrid,
                    scrollToColumn: scrollToColumn - fixedColumnCount,
                    scrollToRow: scrollToRow - fixedRowCount,
                    style: this._bottomRightGridStyle,
                    width: this._getRightGridWidth(props)
                }));
            }
        },
        {
            key: "_renderTopLeftGrid",
            value: function _renderTopLeftGrid(props) {
                var fixedColumnCount = props.fixedColumnCount, fixedRowCount = props.fixedRowCount;
                if (!fixedColumnCount || !fixedRowCount) return null;
                return $NdCUR.createElement((0, $df00be2467032761$export$2e2bcd8739ae039), (0, $3d1b110f42b1c650$export$2e2bcd8739ae039)({}, props, {
                    className: this.props.classNameTopLeftGrid,
                    columnCount: fixedColumnCount,
                    height: this._getTopGridHeight(props),
                    ref: this._topLeftGridRef,
                    rowCount: fixedRowCount,
                    style: this._topLeftGridStyle,
                    tabIndex: null,
                    width: this._getLeftGridWidth(props)
                }));
            }
        },
        {
            key: "_renderTopRightGrid",
            value: function _renderTopRightGrid(props) {
                var columnCount = props.columnCount, enableFixedRowScroll = props.enableFixedRowScroll, fixedColumnCount = props.fixedColumnCount, fixedRowCount = props.fixedRowCount, scrollLeft = props.scrollLeft, hideTopRightGridScrollbar = props.hideTopRightGridScrollbar;
                var _this$state5 = this.state, showHorizontalScrollbar = _this$state5.showHorizontalScrollbar, scrollbarSize = _this$state5.scrollbarSize;
                if (!fixedRowCount) return null;
                var additionalColumnCount = showHorizontalScrollbar ? 1 : 0, height = this._getTopGridHeight(props), width = this._getRightGridWidth(props), additionalHeight = showHorizontalScrollbar ? scrollbarSize : 0;
                var gridHeight = height, style = this._topRightGridStyle;
                if (hideTopRightGridScrollbar) {
                    gridHeight = height + additionalHeight;
                    style = $b7ade1ce0987eefe$var$_objectSpread({}, this._topRightGridStyle, {
                        left: 0
                    });
                }
                var topRightGrid = $NdCUR.createElement((0, $df00be2467032761$export$2e2bcd8739ae039), (0, $3d1b110f42b1c650$export$2e2bcd8739ae039)({}, props, {
                    cellRenderer: this._cellRendererTopRightGrid,
                    className: this.props.classNameTopRightGrid,
                    columnCount: Math.max(0, columnCount - fixedColumnCount) + additionalColumnCount,
                    columnWidth: this._columnWidthRightGrid,
                    deferredMeasurementCache: this._deferredMeasurementCacheTopRightGrid,
                    height: gridHeight,
                    onScroll: enableFixedRowScroll ? this._onScrollLeft : undefined,
                    ref: this._topRightGridRef,
                    rowCount: fixedRowCount,
                    scrollLeft: scrollLeft,
                    style: style,
                    tabIndex: null,
                    width: width
                }));
                if (hideTopRightGridScrollbar) return $NdCUR.createElement("div", {
                    className: "TopRightGrid_ScrollWrapper",
                    style: $b7ade1ce0987eefe$var$_objectSpread({}, this._topRightGridStyle, {
                        height: height,
                        width: width,
                        overflowX: 'hidden'
                    })
                }, topRightGrid);
                return topRightGrid;
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.scrollLeft !== prevState.scrollLeft || nextProps.scrollTop !== prevState.scrollTop) return {
                    scrollLeft: nextProps.scrollLeft != null && nextProps.scrollLeft >= 0 ? nextProps.scrollLeft : prevState.scrollLeft,
                    scrollTop: nextProps.scrollTop != null && nextProps.scrollTop >= 0 ? nextProps.scrollTop : prevState.scrollTop
                };
                return null;
            }
        }
    ]);
    return MultiGrid;
}($NdCUR.PureComponent);
(0, $005fda52a7adba61$export$2e2bcd8739ae039)($b7ade1ce0987eefe$var$MultiGrid, "defaultProps", {
    classNameBottomLeftGrid: '',
    classNameBottomRightGrid: '',
    classNameTopLeftGrid: '',
    classNameTopRightGrid: '',
    enableFixedColumnScroll: false,
    enableFixedRowScroll: false,
    fixedColumnCount: 0,
    fixedRowCount: 0,
    scrollToColumn: -1,
    scrollToRow: -1,
    style: {},
    styleBottomLeftGrid: {},
    styleBottomRightGrid: {},
    styleTopLeftGrid: {},
    styleTopRightGrid: {},
    hideTopRightGridScrollbar: false,
    hideBottomLeftGridScrollbar: false
});
$b7ade1ce0987eefe$var$MultiGrid.propTypes = {};
(0, $e7f50e4820b1eac7$export$cea1c58a6db52bca)($b7ade1ce0987eefe$var$MultiGrid);
var $b7ade1ce0987eefe$export$2e2bcd8739ae039 = $b7ade1ce0987eefe$var$MultiGrid;


var $6981cb871ae83ebc$export$2e2bcd8739ae039 = (0, $b7ade1ce0987eefe$export$2e2bcd8739ae039);










var $NdCUR = parcelRequire("NdCUR");
/**
 * HOC that simplifies the process of synchronizing scrolling between two or more virtualized components.
 */ var $90281d031d04adb7$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$PureComponent) {
    (0, $fe3f597ee5eaea5e$export$2e2bcd8739ae039)(ScrollSync, _React$PureComponent);
    function ScrollSync(props, context) {
        var _this;
        (0, $7ab60400c9be8a6b$export$2e2bcd8739ae039)(this, ScrollSync);
        _this = (0, $a26915f7b982dd67$export$2e2bcd8739ae039)(this, (0, $eae1db55e7e69c3d$export$2e2bcd8739ae039)(ScrollSync).call(this, props, context));
        _this.state = {
            clientHeight: 0,
            clientWidth: 0,
            scrollHeight: 0,
            scrollLeft: 0,
            scrollTop: 0,
            scrollWidth: 0
        };
        _this._onScroll = _this._onScroll.bind((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this));
        return _this;
    }
    (0, $f742022c5d2ac646$export$2e2bcd8739ae039)(ScrollSync, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                var _this$state = this.state, clientHeight = _this$state.clientHeight, clientWidth = _this$state.clientWidth, scrollHeight = _this$state.scrollHeight, scrollLeft = _this$state.scrollLeft, scrollTop = _this$state.scrollTop, scrollWidth = _this$state.scrollWidth;
                return children({
                    clientHeight: clientHeight,
                    clientWidth: clientWidth,
                    onScroll: this._onScroll,
                    scrollHeight: scrollHeight,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    scrollWidth: scrollWidth
                });
            }
        },
        {
            key: "_onScroll",
            value: function _onScroll(_ref) {
                var clientHeight = _ref.clientHeight, clientWidth = _ref.clientWidth, scrollHeight = _ref.scrollHeight, scrollLeft = _ref.scrollLeft, scrollTop = _ref.scrollTop, scrollWidth = _ref.scrollWidth;
                this.setState({
                    clientHeight: clientHeight,
                    clientWidth: clientWidth,
                    scrollHeight: scrollHeight,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    scrollWidth: scrollWidth
                });
            }
        }
    ]);
    return ScrollSync;
}($NdCUR.PureComponent);
$90281d031d04adb7$export$2e2bcd8739ae039.propTypes = {};


var $30e87854af041d78$export$2e2bcd8739ae039 = (0, $90281d031d04adb7$export$2e2bcd8739ae039);


function $2942b31dd9c6de78$export$2e2bcd8739ae039(sortCallback) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, defaultSortBy = _ref.defaultSortBy, _ref$defaultSortDirec = _ref.defaultSortDirection, defaultSortDirection = _ref$defaultSortDirec === void 0 ? {} : _ref$defaultSortDirec;
    if (!sortCallback) throw Error("Required parameter \"sortCallback\" not specified");
    var sortBy = defaultSortBy || [];
    var sortDirection = {};
    sortBy.forEach(function(dataKey) {
        sortDirection[dataKey] = defaultSortDirection[dataKey] !== undefined ? defaultSortDirection[dataKey] : 'ASC';
    });
    function sort(_ref2) {
        var defaultSortDirection = _ref2.defaultSortDirection, event = _ref2.event, dataKey = _ref2.sortBy;
        if (event.shiftKey) {
            // Shift + click appends a column to existing criteria
            if (sortDirection[dataKey] !== undefined) sortDirection[dataKey] = sortDirection[dataKey] === 'ASC' ? 'DESC' : 'ASC';
            else {
                sortDirection[dataKey] = defaultSortDirection;
                sortBy.push(dataKey);
            }
        } else if (event.ctrlKey || event.metaKey) {
            // Control + click removes column from sort (if pressent)
            var index = sortBy.indexOf(dataKey);
            if (index >= 0) {
                sortBy.splice(index, 1);
                delete sortDirection[dataKey];
            }
        } else {
            // Clear sortBy array of all non-selected keys
            sortBy.length = 0;
            sortBy.push(dataKey); // Clear sortDirection object of all non-selected keys
            var sortDirectionKeys = Object.keys(sortDirection);
            sortDirectionKeys.forEach(function(key) {
                if (key !== dataKey) delete sortDirection[key];
            }); // If key is already selected, reverse sort direction.
            // Else, set sort direction to default direction.
            if (sortDirection[dataKey] !== undefined) sortDirection[dataKey] = sortDirection[dataKey] === 'ASC' ? 'DESC' : 'ASC';
            else sortDirection[dataKey] = defaultSortDirection;
        } // Notify application code
        sortCallback({
            sortBy: sortBy,
            sortDirection: sortDirection
        });
    }
    return {
        sort: sort,
        sortBy: sortBy,
        sortDirection: sortDirection
    };
}


/**
 * Default accessor for returning a cell value for a given attribute.
 * This function expects to operate on either a vanilla Object or an Immutable Map.
 * You should override the column's cellDataGetter if your data is some other type of object.
 */ 
var $74d3a3d9a1be8fa6$export$6c06e2d2e5625b4a = null;
var $74d3a3d9a1be8fa6$export$629e389fcb95c4cb = null;
var $74d3a3d9a1be8fa6$export$175128f55a6cb4f9 = null;
var $74d3a3d9a1be8fa6$export$4012a7792a488b95 = null;
var $74d3a3d9a1be8fa6$export$3a716df7746a4f4e = null;


function $5680bbc0ba3ec897$export$2e2bcd8739ae039(_ref) {
    var dataKey = _ref.dataKey, rowData = _ref.rowData;
    if (typeof rowData.get === 'function') return rowData.get(dataKey);
    else return rowData[dataKey];
}


/**
 * Default cell renderer that displays an attribute as a simple string
 * You should override the column's cellRenderer if your data is some other type of object.
 */ 
function $0d0f7beca7f6eb1a$export$2e2bcd8739ae039(_ref) {
    var cellData = _ref.cellData;
    if (cellData == null) return '';
    else return String(cellData);
}



var $NdCUR = parcelRequire("NdCUR");


function $f1984f503dc62ab6$export$2e2bcd8739ae039(_ref) {
    var className = _ref.className, columns = _ref.columns, style = _ref.style;
    return $NdCUR.createElement("div", {
        className: className,
        role: "row",
        style: style
    }, columns);
}
$f1984f503dc62ab6$export$2e2bcd8739ae039.propTypes = null;



var $NdCUR = parcelRequire("NdCUR");

var $lbxdO = parcelRequire("lbxdO");


var $NdCUR = parcelRequire("NdCUR");
var $785fc1f5d4c5f70c$var$SortDirection = {
    /**
   * Sort items in ascending order.
   * This means arranging from the lowest value to the highest (e.g. a-z, 0-9).
   */ ASC: 'ASC',
    /**
   * Sort items in descending order.
   * This means arranging from the highest value to the lowest (e.g. z-a, 9-0).
   */ DESC: 'DESC'
};
var $785fc1f5d4c5f70c$export$2e2bcd8739ae039 = $785fc1f5d4c5f70c$var$SortDirection;


function $45d85e0369d2f012$export$2e2bcd8739ae039(_ref) {
    var sortDirection = _ref.sortDirection;
    var classNames = (0, $lbxdO.default)('ReactVirtualized__Table__sortableHeaderIcon', {
        'ReactVirtualized__Table__sortableHeaderIcon--ASC': sortDirection === (0, $785fc1f5d4c5f70c$export$2e2bcd8739ae039).ASC,
        'ReactVirtualized__Table__sortableHeaderIcon--DESC': sortDirection === (0, $785fc1f5d4c5f70c$export$2e2bcd8739ae039).DESC
    });
    return $NdCUR.createElement("svg", {
        className: classNames,
        width: 18,
        height: 18,
        viewBox: "0 0 24 24"
    }, sortDirection === (0, $785fc1f5d4c5f70c$export$2e2bcd8739ae039).ASC ? $NdCUR.createElement("path", {
        d: "M7 14l5-5 5 5z"
    }) : $NdCUR.createElement("path", {
        d: "M7 10l5 5 5-5z"
    }), $NdCUR.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }));
}
$45d85e0369d2f012$export$2e2bcd8739ae039.propTypes = {};




function $940fca69d053a414$export$2e2bcd8739ae039(_ref) {
    var dataKey = _ref.dataKey, label = _ref.label, sortBy = _ref.sortBy, sortDirection = _ref.sortDirection;
    var showSortIndicator = sortBy === dataKey;
    var children = [
        $NdCUR.createElement("span", {
            className: "ReactVirtualized__Table__headerTruncatedText",
            key: "label",
            title: typeof label === 'string' ? label : null
        }, label)
    ];
    if (showSortIndicator) children.push($NdCUR.createElement((0, $45d85e0369d2f012$export$2e2bcd8739ae039), {
        key: "SortIndicator",
        sortDirection: sortDirection
    }));
    return children;
}
$940fca69d053a414$export$2e2bcd8739ae039.propTypes = null;




var $NdCUR = parcelRequire("NdCUR");


function $1b84d58dae263c89$export$2e2bcd8739ae039(_ref) {
    var className = _ref.className, columns = _ref.columns, index = _ref.index, key = _ref.key, onRowClick = _ref.onRowClick, onRowDoubleClick = _ref.onRowDoubleClick, onRowMouseOut = _ref.onRowMouseOut, onRowMouseOver = _ref.onRowMouseOver, onRowRightClick = _ref.onRowRightClick, rowData = _ref.rowData, style = _ref.style;
    var a11yProps = {
        'aria-rowindex': index + 1
    };
    if (onRowClick || onRowDoubleClick || onRowMouseOut || onRowMouseOver || onRowRightClick) {
        a11yProps['aria-label'] = 'row';
        a11yProps.tabIndex = 0;
        if (onRowClick) a11yProps.onClick = function(event) {
            return onRowClick({
                event: event,
                index: index,
                rowData: rowData
            });
        };
        if (onRowDoubleClick) a11yProps.onDoubleClick = function(event) {
            return onRowDoubleClick({
                event: event,
                index: index,
                rowData: rowData
            });
        };
        if (onRowMouseOut) a11yProps.onMouseOut = function(event) {
            return onRowMouseOut({
                event: event,
                index: index,
                rowData: rowData
            });
        };
        if (onRowMouseOver) a11yProps.onMouseOver = function(event) {
            return onRowMouseOver({
                event: event,
                index: index,
                rowData: rowData
            });
        };
        if (onRowRightClick) a11yProps.onContextMenu = function(event) {
            return onRowRightClick({
                event: event,
                index: index,
                rowData: rowData
            });
        };
    }
    return $NdCUR.createElement("div", (0, $3d1b110f42b1c650$export$2e2bcd8739ae039)({}, a11yProps, {
        className: className,
        key: key,
        role: "row",
        style: style
    }), columns);
}
$1b84d58dae263c89$export$2e2bcd8739ae039.propTypes = null;









var $NdCUR = parcelRequire("NdCUR");




/**
 * Describes the header and cell contents of a table column.
 */ var $df46f33cc5631302$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    (0, $fe3f597ee5eaea5e$export$2e2bcd8739ae039)(Column, _React$Component);
    function Column() {
        (0, $7ab60400c9be8a6b$export$2e2bcd8739ae039)(this, Column);
        return (0, $a26915f7b982dd67$export$2e2bcd8739ae039)(this, (0, $eae1db55e7e69c3d$export$2e2bcd8739ae039)(Column).apply(this, arguments));
    }
    return Column;
}($NdCUR.Component);
(0, $005fda52a7adba61$export$2e2bcd8739ae039)($df46f33cc5631302$export$2e2bcd8739ae039, "defaultProps", {
    cellDataGetter: (0, $5680bbc0ba3ec897$export$2e2bcd8739ae039),
    cellRenderer: (0, $0d0f7beca7f6eb1a$export$2e2bcd8739ae039),
    defaultSortDirection: (0, $785fc1f5d4c5f70c$export$2e2bcd8739ae039).ASC,
    flexGrow: 0,
    flexShrink: 1,
    headerRenderer: (0, $940fca69d053a414$export$2e2bcd8739ae039),
    style: {}
});
$df46f33cc5631302$export$2e2bcd8739ae039.propTypes = {};













var $lbxdO = parcelRequire("lbxdO");



var $NdCUR = parcelRequire("NdCUR");

var $g2wso = parcelRequire("g2wso");




function $dd36f39b0c3b2bc4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $dd36f39b0c3b2bc4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $dd36f39b0c3b2bc4$var$ownKeys(source, true).forEach(function(key) {
            (0, $005fda52a7adba61$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $dd36f39b0c3b2bc4$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * Table component with fixed headers and virtualized rows for improved performance with large data sets.
 * This component expects explicit width, height, and padding parameters.
 */ var $dd36f39b0c3b2bc4$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$PureComponent) {
    (0, $fe3f597ee5eaea5e$export$2e2bcd8739ae039)(Table, _React$PureComponent);
    function Table(props) {
        var _this;
        (0, $7ab60400c9be8a6b$export$2e2bcd8739ae039)(this, Table);
        _this = (0, $a26915f7b982dd67$export$2e2bcd8739ae039)(this, (0, $eae1db55e7e69c3d$export$2e2bcd8739ae039)(Table).call(this, props));
        _this.state = {
            scrollbarWidth: 0
        };
        _this._createColumn = _this._createColumn.bind((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this));
        _this._createRow = _this._createRow.bind((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this));
        _this._onScroll = _this._onScroll.bind((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this));
        _this._onSectionRendered = _this._onSectionRendered.bind((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this));
        _this._setRef = _this._setRef.bind((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this));
        return _this;
    }
    (0, $f742022c5d2ac646$export$2e2bcd8739ae039)(Table, [
        {
            key: "forceUpdateGrid",
            value: function forceUpdateGrid() {
                if (this.Grid) this.Grid.forceUpdate();
            }
        },
        {
            key: "getOffsetForRow",
            value: function getOffsetForRow(_ref) {
                var alignment = _ref.alignment, index = _ref.index;
                if (this.Grid) {
                    var _this$Grid$getOffsetF = this.Grid.getOffsetForCell({
                        alignment: alignment,
                        rowIndex: index
                    }), scrollTop = _this$Grid$getOffsetF.scrollTop;
                    return scrollTop;
                }
                return 0;
            }
        },
        {
            key: "invalidateCellSizeAfterRender",
            value: function invalidateCellSizeAfterRender(_ref2) {
                var columnIndex = _ref2.columnIndex, rowIndex = _ref2.rowIndex;
                if (this.Grid) this.Grid.invalidateCellSizeAfterRender({
                    rowIndex: rowIndex,
                    columnIndex: columnIndex
                });
            }
        },
        {
            key: "measureAllRows",
            value: function measureAllRows() {
                if (this.Grid) this.Grid.measureAllCells();
            }
        },
        {
            key: "recomputeGridSize",
            value: function recomputeGridSize() {
                var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref3$columnIndex = _ref3.columnIndex, columnIndex = _ref3$columnIndex === void 0 ? 0 : _ref3$columnIndex, _ref3$rowIndex = _ref3.rowIndex, rowIndex = _ref3$rowIndex === void 0 ? 0 : _ref3$rowIndex;
                if (this.Grid) this.Grid.recomputeGridSize({
                    rowIndex: rowIndex,
                    columnIndex: columnIndex
                });
            }
        },
        {
            key: "recomputeRowHeights",
            value: function recomputeRowHeights() {
                var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.recomputeGridSize({
                    rowIndex: index
                });
            }
        },
        {
            key: "scrollToPosition",
            value: function scrollToPosition() {
                var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.scrollToPosition({
                    scrollTop: scrollTop
                });
            }
        },
        {
            key: "scrollToRow",
            value: function scrollToRow() {
                var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.scrollToCell({
                    columnIndex: 0,
                    rowIndex: index
                });
            }
        },
        {
            key: "getScrollbarWidth",
            value: function getScrollbarWidth() {
                if (this.Grid) {
                    var _Grid = (0, $g2wso.findDOMNode)(this.Grid);
                    var clientWidth = _Grid.clientWidth || 0;
                    var offsetWidth = _Grid.offsetWidth || 0;
                    return offsetWidth - clientWidth;
                }
                return 0;
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this._setScrollbarWidth();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this._setScrollbarWidth();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, children = _this$props.children, className = _this$props.className, disableHeader = _this$props.disableHeader, gridClassName = _this$props.gridClassName, gridStyle = _this$props.gridStyle, headerHeight = _this$props.headerHeight, headerRowRenderer = _this$props.headerRowRenderer, height = _this$props.height, id = _this$props.id, noRowsRenderer = _this$props.noRowsRenderer, rowClassName = _this$props.rowClassName, rowStyle = _this$props.rowStyle, scrollToIndex = _this$props.scrollToIndex, style = _this$props.style, width = _this$props.width;
                var scrollbarWidth = this.state.scrollbarWidth;
                var availableRowsHeight = disableHeader ? height : height - headerHeight;
                var rowClass = typeof rowClassName === 'function' ? rowClassName({
                    index: -1
                }) : rowClassName;
                var rowStyleObject = typeof rowStyle === 'function' ? rowStyle({
                    index: -1
                }) : rowStyle; // Precompute and cache column styles before rendering rows and columns to speed things up
                this._cachedColumnStyles = [];
                $NdCUR.Children.toArray(children).forEach(function(column, index) {
                    var flexStyles = _this2._getFlexStyleForColumn(column, column.props.style);
                    _this2._cachedColumnStyles[index] = $dd36f39b0c3b2bc4$var$_objectSpread({
                        overflow: 'hidden'
                    }, flexStyles);
                }); // Note that we specify :rowCount, :scrollbarWidth, :sortBy, and :sortDirection as properties on Grid even though these have nothing to do with Grid.
                // This is done because Grid is a pure component and won't update unless its properties or state has changed.
                // Any property that should trigger a re-render of Grid then is specified here to avoid a stale display.
                return $NdCUR.createElement("div", {
                    "aria-label": this.props['aria-label'],
                    "aria-labelledby": this.props['aria-labelledby'],
                    "aria-colcount": $NdCUR.Children.toArray(children).length,
                    "aria-rowcount": this.props.rowCount,
                    className: (0, $lbxdO.default)('ReactVirtualized__Table', className),
                    id: id,
                    role: "grid",
                    style: style
                }, !disableHeader && headerRowRenderer({
                    className: (0, $lbxdO.default)('ReactVirtualized__Table__headerRow', rowClass),
                    columns: this._getHeaderColumns(),
                    style: $dd36f39b0c3b2bc4$var$_objectSpread({
                        height: headerHeight,
                        overflow: 'hidden',
                        paddingRight: scrollbarWidth,
                        width: width
                    }, rowStyleObject)
                }), $NdCUR.createElement((0, $df00be2467032761$export$2e2bcd8739ae039), (0, $3d1b110f42b1c650$export$2e2bcd8739ae039)({}, this.props, {
                    "aria-readonly": null,
                    autoContainerWidth: true,
                    className: (0, $lbxdO.default)('ReactVirtualized__Table__Grid', gridClassName),
                    cellRenderer: this._createRow,
                    columnWidth: width,
                    columnCount: 1,
                    height: availableRowsHeight,
                    id: undefined,
                    noContentRenderer: noRowsRenderer,
                    onScroll: this._onScroll,
                    onSectionRendered: this._onSectionRendered,
                    ref: this._setRef,
                    role: "rowgroup",
                    scrollbarWidth: scrollbarWidth,
                    scrollToRow: scrollToIndex,
                    style: $dd36f39b0c3b2bc4$var$_objectSpread({}, gridStyle, {
                        overflowX: 'hidden'
                    })
                })));
            }
        },
        {
            key: "_createColumn",
            value: function _createColumn(_ref4) {
                var column = _ref4.column, columnIndex = _ref4.columnIndex, isScrolling = _ref4.isScrolling, parent = _ref4.parent, rowData = _ref4.rowData, rowIndex = _ref4.rowIndex;
                var onColumnClick = this.props.onColumnClick;
                var _column$props = column.props, cellDataGetter = _column$props.cellDataGetter, cellRenderer = _column$props.cellRenderer, className = _column$props.className, columnData = _column$props.columnData, dataKey = _column$props.dataKey, id = _column$props.id;
                var cellData = cellDataGetter({
                    columnData: columnData,
                    dataKey: dataKey,
                    rowData: rowData
                });
                var renderedCell = cellRenderer({
                    cellData: cellData,
                    columnData: columnData,
                    columnIndex: columnIndex,
                    dataKey: dataKey,
                    isScrolling: isScrolling,
                    parent: parent,
                    rowData: rowData,
                    rowIndex: rowIndex
                });
                var onClick = function onClick(event) {
                    onColumnClick && onColumnClick({
                        columnData: columnData,
                        dataKey: dataKey,
                        event: event
                    });
                };
                var style = this._cachedColumnStyles[columnIndex];
                var title = typeof renderedCell === 'string' ? renderedCell : null; // Avoid using object-spread syntax with multiple objects here,
                // Since it results in an extra method call to 'babel-runtime/helpers/extends'
                // See PR https://github.com/bvaughn/react-virtualized/pull/942
                return $NdCUR.createElement("div", {
                    "aria-colindex": columnIndex + 1,
                    "aria-describedby": id,
                    className: (0, $lbxdO.default)('ReactVirtualized__Table__rowColumn', className),
                    key: 'Row' + rowIndex + '-' + 'Col' + columnIndex,
                    onClick: onClick,
                    role: "gridcell",
                    style: style,
                    title: title
                }, renderedCell);
            }
        },
        {
            key: "_createHeader",
            value: function _createHeader(_ref5) {
                var column = _ref5.column, index = _ref5.index;
                var _this$props2 = this.props, headerClassName = _this$props2.headerClassName, headerStyle = _this$props2.headerStyle, onHeaderClick = _this$props2.onHeaderClick, sort = _this$props2.sort, sortBy = _this$props2.sortBy, sortDirection = _this$props2.sortDirection;
                var _column$props2 = column.props, columnData = _column$props2.columnData, dataKey = _column$props2.dataKey, defaultSortDirection = _column$props2.defaultSortDirection, disableSort = _column$props2.disableSort, headerRenderer = _column$props2.headerRenderer, id = _column$props2.id, label = _column$props2.label;
                var sortEnabled = !disableSort && sort;
                var classNames = (0, $lbxdO.default)('ReactVirtualized__Table__headerColumn', headerClassName, column.props.headerClassName, {
                    ReactVirtualized__Table__sortableHeaderColumn: sortEnabled
                });
                var style = this._getFlexStyleForColumn(column, $dd36f39b0c3b2bc4$var$_objectSpread({}, headerStyle, {}, column.props.headerStyle));
                var renderedHeader = headerRenderer({
                    columnData: columnData,
                    dataKey: dataKey,
                    disableSort: disableSort,
                    label: label,
                    sortBy: sortBy,
                    sortDirection: sortDirection
                });
                var headerOnClick, headerOnKeyDown, headerTabIndex, headerAriaSort, headerAriaLabel;
                if (sortEnabled || onHeaderClick) {
                    // If this is a sortable header, clicking it should update the table data's sorting.
                    var isFirstTimeSort = sortBy !== dataKey; // If this is the firstTime sort of this column, use the column default sort order.
                    // Otherwise, invert the direction of the sort.
                    var newSortDirection = isFirstTimeSort ? defaultSortDirection : sortDirection === (0, $785fc1f5d4c5f70c$export$2e2bcd8739ae039).DESC ? (0, $785fc1f5d4c5f70c$export$2e2bcd8739ae039).ASC : (0, $785fc1f5d4c5f70c$export$2e2bcd8739ae039).DESC;
                    var onClick = function onClick(event) {
                        sortEnabled && sort({
                            defaultSortDirection: defaultSortDirection,
                            event: event,
                            sortBy: dataKey,
                            sortDirection: newSortDirection
                        });
                        onHeaderClick && onHeaderClick({
                            columnData: columnData,
                            dataKey: dataKey,
                            event: event
                        });
                    };
                    var onKeyDown = function onKeyDown(event) {
                        if (event.key === 'Enter' || event.key === ' ') onClick(event);
                    };
                    headerAriaLabel = column.props['aria-label'] || label || dataKey;
                    headerAriaSort = 'none';
                    headerTabIndex = 0;
                    headerOnClick = onClick;
                    headerOnKeyDown = onKeyDown;
                }
                if (sortBy === dataKey) headerAriaSort = sortDirection === (0, $785fc1f5d4c5f70c$export$2e2bcd8739ae039).ASC ? 'ascending' : 'descending';
                 // Avoid using object-spread syntax with multiple objects here,
                // Since it results in an extra method call to 'babel-runtime/helpers/extends'
                // See PR https://github.com/bvaughn/react-virtualized/pull/942
                return $NdCUR.createElement("div", {
                    "aria-label": headerAriaLabel,
                    "aria-sort": headerAriaSort,
                    className: classNames,
                    id: id,
                    key: 'Header-Col' + index,
                    onClick: headerOnClick,
                    onKeyDown: headerOnKeyDown,
                    role: "columnheader",
                    style: style,
                    tabIndex: headerTabIndex
                }, renderedHeader);
            }
        },
        {
            key: "_createRow",
            value: function _createRow(_ref6) {
                var _this3 = this;
                var index = _ref6.rowIndex, isScrolling = _ref6.isScrolling, key = _ref6.key, parent = _ref6.parent, style = _ref6.style;
                var _this$props3 = this.props, children = _this$props3.children, onRowClick = _this$props3.onRowClick, onRowDoubleClick = _this$props3.onRowDoubleClick, onRowRightClick = _this$props3.onRowRightClick, onRowMouseOver = _this$props3.onRowMouseOver, onRowMouseOut = _this$props3.onRowMouseOut, rowClassName = _this$props3.rowClassName, rowGetter = _this$props3.rowGetter, rowRenderer = _this$props3.rowRenderer, rowStyle = _this$props3.rowStyle;
                var scrollbarWidth = this.state.scrollbarWidth;
                var rowClass = typeof rowClassName === 'function' ? rowClassName({
                    index: index
                }) : rowClassName;
                var rowStyleObject = typeof rowStyle === 'function' ? rowStyle({
                    index: index
                }) : rowStyle;
                var rowData = rowGetter({
                    index: index
                });
                var columns = $NdCUR.Children.toArray(children).map(function(column, columnIndex) {
                    return _this3._createColumn({
                        column: column,
                        columnIndex: columnIndex,
                        isScrolling: isScrolling,
                        parent: parent,
                        rowData: rowData,
                        rowIndex: index,
                        scrollbarWidth: scrollbarWidth
                    });
                });
                var className = (0, $lbxdO.default)('ReactVirtualized__Table__row', rowClass);
                var flattenedStyle = $dd36f39b0c3b2bc4$var$_objectSpread({}, style, {
                    height: this._getRowHeight(index),
                    overflow: 'hidden',
                    paddingRight: scrollbarWidth
                }, rowStyleObject);
                return rowRenderer({
                    className: className,
                    columns: columns,
                    index: index,
                    isScrolling: isScrolling,
                    key: key,
                    onRowClick: onRowClick,
                    onRowDoubleClick: onRowDoubleClick,
                    onRowRightClick: onRowRightClick,
                    onRowMouseOver: onRowMouseOver,
                    onRowMouseOut: onRowMouseOut,
                    rowData: rowData,
                    style: flattenedStyle
                });
            }
        },
        {
            key: "_getFlexStyleForColumn",
            value: function _getFlexStyleForColumn(column) {
                var customStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var flexValue = "".concat(column.props.flexGrow, " ").concat(column.props.flexShrink, " ").concat(column.props.width, "px");
                var style = $dd36f39b0c3b2bc4$var$_objectSpread({}, customStyle, {
                    flex: flexValue,
                    msFlex: flexValue,
                    WebkitFlex: flexValue
                });
                if (column.props.maxWidth) style.maxWidth = column.props.maxWidth;
                if (column.props.minWidth) style.minWidth = column.props.minWidth;
                return style;
            }
        },
        {
            key: "_getHeaderColumns",
            value: function _getHeaderColumns() {
                var _this4 = this;
                var _this$props4 = this.props, children = _this$props4.children, disableHeader = _this$props4.disableHeader;
                var items = disableHeader ? [] : $NdCUR.Children.toArray(children);
                return items.map(function(column, index) {
                    return _this4._createHeader({
                        column: column,
                        index: index
                    });
                });
            }
        },
        {
            key: "_getRowHeight",
            value: function _getRowHeight(rowIndex) {
                var rowHeight = this.props.rowHeight;
                return typeof rowHeight === 'function' ? rowHeight({
                    index: rowIndex
                }) : rowHeight;
            }
        },
        {
            key: "_onScroll",
            value: function _onScroll(_ref7) {
                var clientHeight = _ref7.clientHeight, scrollHeight = _ref7.scrollHeight, scrollTop = _ref7.scrollTop;
                var onScroll = this.props.onScroll;
                onScroll({
                    clientHeight: clientHeight,
                    scrollHeight: scrollHeight,
                    scrollTop: scrollTop
                });
            }
        },
        {
            key: "_onSectionRendered",
            value: function _onSectionRendered(_ref8) {
                var rowOverscanStartIndex = _ref8.rowOverscanStartIndex, rowOverscanStopIndex = _ref8.rowOverscanStopIndex, rowStartIndex = _ref8.rowStartIndex, rowStopIndex = _ref8.rowStopIndex;
                var onRowsRendered = this.props.onRowsRendered;
                onRowsRendered({
                    overscanStartIndex: rowOverscanStartIndex,
                    overscanStopIndex: rowOverscanStopIndex,
                    startIndex: rowStartIndex,
                    stopIndex: rowStopIndex
                });
            }
        },
        {
            key: "_setRef",
            value: function _setRef(ref) {
                this.Grid = ref;
            }
        },
        {
            key: "_setScrollbarWidth",
            value: function _setScrollbarWidth() {
                var scrollbarWidth = this.getScrollbarWidth();
                this.setState({
                    scrollbarWidth: scrollbarWidth
                });
            }
        }
    ]);
    return Table;
}($NdCUR.PureComponent);
(0, $005fda52a7adba61$export$2e2bcd8739ae039)($dd36f39b0c3b2bc4$export$2e2bcd8739ae039, "defaultProps", {
    disableHeader: false,
    estimatedRowSize: 30,
    headerHeight: 0,
    headerStyle: {},
    noRowsRenderer: function noRowsRenderer() {
        return null;
    },
    onRowsRendered: function onRowsRendered() {
        return null;
    },
    onScroll: function onScroll() {
        return null;
    },
    overscanIndicesGetter: (0, $7608b63d3b3be2cd$export$2e2bcd8739ae039),
    overscanRowCount: 10,
    rowRenderer: (0, $1b84d58dae263c89$export$2e2bcd8739ae039),
    headerRowRenderer: (0, $f1984f503dc62ab6$export$2e2bcd8739ae039),
    rowStyle: {},
    scrollToAlignment: 'auto',
    scrollToIndex: -1,
    style: {}
});
$dd36f39b0c3b2bc4$export$2e2bcd8739ae039.propTypes = {};


var $f549c8e9d3f46fa3$export$2e2bcd8739ae039 = (0, $dd36f39b0c3b2bc4$export$2e2bcd8739ae039);










var $NdCUR = parcelRequire("NdCUR");

var $g2wso = parcelRequire("g2wso");


var $cbd03fd77d9dd910$var$mountedInstances = [];
var $cbd03fd77d9dd910$var$originalBodyPointerEvents = null;
var $cbd03fd77d9dd910$var$disablePointerEventsTimeoutId = null;
function $cbd03fd77d9dd910$var$enablePointerEventsIfDisabled() {
    if ($cbd03fd77d9dd910$var$disablePointerEventsTimeoutId) {
        $cbd03fd77d9dd910$var$disablePointerEventsTimeoutId = null;
        if (document.body && $cbd03fd77d9dd910$var$originalBodyPointerEvents != null) document.body.style.pointerEvents = $cbd03fd77d9dd910$var$originalBodyPointerEvents;
        $cbd03fd77d9dd910$var$originalBodyPointerEvents = null;
    }
}
function $cbd03fd77d9dd910$var$enablePointerEventsAfterDelayCallback() {
    $cbd03fd77d9dd910$var$enablePointerEventsIfDisabled();
    $cbd03fd77d9dd910$var$mountedInstances.forEach(function(instance) {
        return instance.__resetIsScrolling();
    });
}
function $cbd03fd77d9dd910$var$enablePointerEventsAfterDelay() {
    if ($cbd03fd77d9dd910$var$disablePointerEventsTimeoutId) (0, $ef0c7be04d84646a$export$3b976196c7d0d7a6)($cbd03fd77d9dd910$var$disablePointerEventsTimeoutId);
    var maximumTimeout = 0;
    $cbd03fd77d9dd910$var$mountedInstances.forEach(function(instance) {
        maximumTimeout = Math.max(maximumTimeout, instance.props.scrollingResetTimeInterval);
    });
    $cbd03fd77d9dd910$var$disablePointerEventsTimeoutId = (0, $ef0c7be04d84646a$export$62c6fa81f9943047)($cbd03fd77d9dd910$var$enablePointerEventsAfterDelayCallback, maximumTimeout);
}
function $cbd03fd77d9dd910$var$onScrollWindow(event) {
    if (event.currentTarget === window && $cbd03fd77d9dd910$var$originalBodyPointerEvents == null && document.body) {
        $cbd03fd77d9dd910$var$originalBodyPointerEvents = document.body.style.pointerEvents;
        document.body.style.pointerEvents = 'none';
    }
    $cbd03fd77d9dd910$var$enablePointerEventsAfterDelay();
    $cbd03fd77d9dd910$var$mountedInstances.forEach(function(instance) {
        if (instance.props.scrollElement === event.currentTarget) instance.__handleWindowScrollEvent();
    });
}
function $cbd03fd77d9dd910$export$2ae59a3a1c144a62(component, element) {
    if (!$cbd03fd77d9dd910$var$mountedInstances.some(function(instance) {
        return instance.props.scrollElement === element;
    })) element.addEventListener('scroll', $cbd03fd77d9dd910$var$onScrollWindow);
    $cbd03fd77d9dd910$var$mountedInstances.push(component);
}
function $cbd03fd77d9dd910$export$9eab03f1e587e004(component, element) {
    $cbd03fd77d9dd910$var$mountedInstances = $cbd03fd77d9dd910$var$mountedInstances.filter(function(instance) {
        return instance !== component;
    });
    if (!$cbd03fd77d9dd910$var$mountedInstances.length) {
        element.removeEventListener('scroll', $cbd03fd77d9dd910$var$onScrollWindow);
        if ($cbd03fd77d9dd910$var$disablePointerEventsTimeoutId) {
            (0, $ef0c7be04d84646a$export$3b976196c7d0d7a6)($cbd03fd77d9dd910$var$disablePointerEventsTimeoutId);
            $cbd03fd77d9dd910$var$enablePointerEventsIfDisabled();
        }
    }
}


/**
 * Gets the dimensions of the element, accounting for API differences between
 * `window` and other DOM elements.
 */ // TODO Move this into WindowScroller and import from there
var $0c25a930a2a0bc5e$var$isWindow = function isWindow(element) {
    return element === window;
};
var $0c25a930a2a0bc5e$var$getBoundingBox = function getBoundingBox(element) {
    return element.getBoundingClientRect();
};
function $0c25a930a2a0bc5e$export$d1aa971bf69c7e87(scrollElement, props) {
    if (!scrollElement) return {
        height: props.serverHeight,
        width: props.serverWidth
    };
    else if ($0c25a930a2a0bc5e$var$isWindow(scrollElement)) {
        var _window = window, innerHeight = _window.innerHeight, innerWidth = _window.innerWidth;
        return {
            height: typeof innerHeight === 'number' ? innerHeight : 0,
            width: typeof innerWidth === 'number' ? innerWidth : 0
        };
    } else return $0c25a930a2a0bc5e$var$getBoundingBox(scrollElement);
}
function $0c25a930a2a0bc5e$export$49c9ca06677d64ad(element, container) {
    if ($0c25a930a2a0bc5e$var$isWindow(container) && document.documentElement) {
        var containerElement = document.documentElement;
        var elementRect = $0c25a930a2a0bc5e$var$getBoundingBox(element);
        var containerRect = $0c25a930a2a0bc5e$var$getBoundingBox(containerElement);
        return {
            top: elementRect.top - containerRect.top,
            left: elementRect.left - containerRect.left
        };
    } else {
        var scrollOffset = $0c25a930a2a0bc5e$export$760208e927c198fa(container);
        var _elementRect = $0c25a930a2a0bc5e$var$getBoundingBox(element);
        var _containerRect = $0c25a930a2a0bc5e$var$getBoundingBox(container);
        return {
            top: _elementRect.top + scrollOffset.top - _containerRect.top,
            left: _elementRect.left + scrollOffset.left - _containerRect.left
        };
    }
}
function $0c25a930a2a0bc5e$export$760208e927c198fa(element) {
    if ($0c25a930a2a0bc5e$var$isWindow(element) && document.documentElement) return {
        top: 'scrollY' in window ? window.scrollY : document.documentElement.scrollTop,
        left: 'scrollX' in window ? window.scrollX : document.documentElement.scrollLeft
    };
    else return {
        top: element.scrollTop,
        left: element.scrollLeft
    };
}




var $e4eb5868750d20fe$var$_class, $e4eb5868750d20fe$var$_temp;
function $e4eb5868750d20fe$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e4eb5868750d20fe$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $e4eb5868750d20fe$var$ownKeys(source, true).forEach(function(key) {
            (0, $005fda52a7adba61$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $e4eb5868750d20fe$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $e4eb5868750d20fe$export$4c2e2096c8dd4c46 = 150;
var $e4eb5868750d20fe$var$getWindow = function getWindow() {
    return typeof window !== 'undefined' ? window : undefined;
};
var $e4eb5868750d20fe$export$2e2bcd8739ae039 = ($e4eb5868750d20fe$var$_temp = $e4eb5868750d20fe$var$_class = /*#__PURE__*/ function(_React$PureComponent) {
    (0, $fe3f597ee5eaea5e$export$2e2bcd8739ae039)(WindowScroller, _React$PureComponent);
    function WindowScroller() {
        var _getPrototypeOf2;
        var _this;
        (0, $7ab60400c9be8a6b$export$2e2bcd8739ae039)(this, WindowScroller);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, $a26915f7b982dd67$export$2e2bcd8739ae039)(this, (_getPrototypeOf2 = (0, $eae1db55e7e69c3d$export$2e2bcd8739ae039)(WindowScroller)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_window", $e4eb5868750d20fe$var$getWindow());
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_isMounted", false);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_positionFromTop", 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_positionFromLeft", 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_detectElementResize", void 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_child", void 0);
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "state", $e4eb5868750d20fe$var$_objectSpread({}, (0, $0c25a930a2a0bc5e$export$d1aa971bf69c7e87)(_this.props.scrollElement, _this.props), {
            isScrolling: false,
            scrollLeft: 0,
            scrollTop: 0
        }));
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_registerChild", function(element) {
            if (element && !(element instanceof Element)) console.warn('WindowScroller registerChild expects to be passed Element or null');
            _this._child = element;
            _this.updatePosition();
        });
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_onChildScroll", function(_ref) {
            var scrollTop = _ref.scrollTop;
            if (_this.state.scrollTop === scrollTop) return;
            var scrollElement = _this.props.scrollElement;
            if (scrollElement) {
                if (typeof scrollElement.scrollTo === 'function') scrollElement.scrollTo(0, scrollTop + _this._positionFromTop);
                else scrollElement.scrollTop = scrollTop + _this._positionFromTop;
            }
        });
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_registerResizeListener", function(element) {
            if (element === window) window.addEventListener('resize', _this._onResize, false);
            else _this._detectElementResize.addResizeListener(element, _this._onResize);
        });
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_unregisterResizeListener", function(element) {
            if (element === window) window.removeEventListener('resize', _this._onResize, false);
            else if (element) _this._detectElementResize.removeResizeListener(element, _this._onResize);
        });
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "_onResize", function() {
            _this.updatePosition();
        });
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "__handleWindowScrollEvent", function() {
            if (!_this._isMounted) return;
            var onScroll = _this.props.onScroll;
            var scrollElement = _this.props.scrollElement;
            if (scrollElement) {
                var scrollOffset = (0, $0c25a930a2a0bc5e$export$760208e927c198fa)(scrollElement);
                var scrollLeft = Math.max(0, scrollOffset.left - _this._positionFromLeft);
                var scrollTop = Math.max(0, scrollOffset.top - _this._positionFromTop);
                _this.setState({
                    isScrolling: true,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop
                });
                onScroll({
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop
                });
            }
        });
        (0, $005fda52a7adba61$export$2e2bcd8739ae039)((0, $45b2d0714f2ea8c5$export$2e2bcd8739ae039)(_this), "__resetIsScrolling", function() {
            _this.setState({
                isScrolling: false
            });
        });
        return _this;
    }
    (0, $f742022c5d2ac646$export$2e2bcd8739ae039)(WindowScroller, [
        {
            key: "updatePosition",
            value: function updatePosition() {
                var scrollElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.scrollElement;
                var onResize = this.props.onResize;
                var _this$state = this.state, height = _this$state.height, width = _this$state.width;
                var thisNode = this._child || $g2wso.findDOMNode(this);
                if (thisNode instanceof Element && scrollElement) {
                    var offset = (0, $0c25a930a2a0bc5e$export$49c9ca06677d64ad)(thisNode, scrollElement);
                    this._positionFromTop = offset.top;
                    this._positionFromLeft = offset.left;
                }
                var dimensions = (0, $0c25a930a2a0bc5e$export$d1aa971bf69c7e87)(scrollElement, this.props);
                if (height !== dimensions.height || width !== dimensions.width) {
                    this.setState({
                        height: dimensions.height,
                        width: dimensions.width
                    });
                    onResize({
                        height: dimensions.height,
                        width: dimensions.width
                    });
                }
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var scrollElement = this.props.scrollElement;
                this._detectElementResize = (0, $07c0ac0711ff4538$export$2e2bcd8739ae039)();
                this.updatePosition(scrollElement);
                if (scrollElement) {
                    (0, $cbd03fd77d9dd910$export$2ae59a3a1c144a62)(this, scrollElement);
                    this._registerResizeListener(scrollElement);
                }
                this._isMounted = true;
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var scrollElement = this.props.scrollElement;
                var prevScrollElement = prevProps.scrollElement;
                if (prevScrollElement !== scrollElement && prevScrollElement != null && scrollElement != null) {
                    this.updatePosition(scrollElement);
                    (0, $cbd03fd77d9dd910$export$9eab03f1e587e004)(this, prevScrollElement);
                    (0, $cbd03fd77d9dd910$export$2ae59a3a1c144a62)(this, scrollElement);
                    this._unregisterResizeListener(prevScrollElement);
                    this._registerResizeListener(scrollElement);
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var scrollElement = this.props.scrollElement;
                if (scrollElement) {
                    (0, $cbd03fd77d9dd910$export$9eab03f1e587e004)(this, scrollElement);
                    this._unregisterResizeListener(scrollElement);
                }
                this._isMounted = false;
            }
        },
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                var _this$state2 = this.state, isScrolling = _this$state2.isScrolling, scrollTop = _this$state2.scrollTop, scrollLeft = _this$state2.scrollLeft, height = _this$state2.height, width = _this$state2.width;
                return children({
                    onChildScroll: this._onChildScroll,
                    registerChild: this._registerChild,
                    height: height,
                    isScrolling: isScrolling,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    width: width
                });
            }
        }
    ]);
    return WindowScroller;
}($NdCUR.PureComponent), (0, $005fda52a7adba61$export$2e2bcd8739ae039)($e4eb5868750d20fe$var$_class, "propTypes", null), $e4eb5868750d20fe$var$_temp);
(0, $005fda52a7adba61$export$2e2bcd8739ae039)($e4eb5868750d20fe$export$2e2bcd8739ae039, "defaultProps", {
    onResize: function onResize() {},
    onScroll: function onScroll() {},
    scrollingResetTimeInterval: $e4eb5868750d20fe$export$4c2e2096c8dd4c46,
    scrollElement: $e4eb5868750d20fe$var$getWindow(),
    serverHeight: 0,
    serverWidth: 0
});


var $30b2a6b875ae2ac1$export$2e2bcd8739ae039 = (0, $e4eb5868750d20fe$export$2e2bcd8739ae039);




// Libraries

var $NdCUR = parcelRequire("NdCUR");
/* eslint-disable no-undef */ // Libraries

var $NdCUR = parcelRequire("NdCUR");


var $hBdgJ = parcelRequire("hBdgJ");
var $25fe38ccc270c16a$exports = {};



(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        'exports',
        'bignumber.js',
        'core-decorators',
        'memoizerific'
    ], factory);
    else {
        var mod;
        factory($25fe38ccc270c16a$exports, (parcelRequire("gO4UB")), (parcelRequire("7LIhW")), (parcelRequire("k76Eu")));
    }
})($25fe38ccc270c16a$exports, function(exports1, _bignumber, _coreDecorators, _memoizerific) {
    'use strict';
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    var _bignumber2 = _interopRequireDefault(_bignumber);
    var _memoizerific2 = _interopRequireDefault(_memoizerific);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    var _createClass = function() {
        function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
        var desc = {};
        Object["keys"](descriptor).forEach(function(key) {
            desc[key] = descriptor[key];
        });
        desc.enumerable = !!desc.enumerable;
        desc.configurable = !!desc.configurable;
        if ('value' in desc || desc.initializer) desc.writable = true;
        desc = decorators.slice().reverse().reduce(function(desc, decorator) {
            return decorator(target, property, desc) || desc;
        }, desc);
        if (context && desc.initializer !== void 0) {
            desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
            desc.initializer = undefined;
        }
        if (desc.initializer === void 0) {
            Object["defineProperty"](target, property, desc);
            desc = null;
        }
        return desc;
    }
    var _dec, _dec2, _dec3, _class, _desc, _value, _class2;
    // Cache original 'Date' class. User may set window.Date = NanoDate;
    if (typeof window === 'undefined') /* istanbul ignore next */ var BaseDate = Date;
    else var BaseDate = window.Date;
    var ISO_8601_FULL = /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?(([+-]\d\d:\d\d)|Z)?$/i;
    var MILLI_TO_NANO_DIFF = 1000000;
    var DIGETS_IN_NANO = 19;
    var DIGETS_IN_MILLI = 13;
    var MINIMUM_DIGETS = DIGETS_IN_NANO - DIGETS_IN_MILLI;
    var YEAR = 'year';
    var MONTH = 'month';
    var DAY = 'day';
    var HOUR = 'hour';
    var MINUTE = 'minute';
    var SECOND = 'second';
    var MILLI = 'milli';
    var MICRO = 'micro';
    var NANO = 'nano';
    var DAYS = {
        0: 31,
        1: 28,
        2: 31,
        3: 30,
        4: 31,
        5: 30,
        6: 31,
        7: 31,
        8: 30,
        9: 31,
        10: 30,
        11: 31
    };
    var DAYS_LEAP_YEAR = {
        0: 31,
        1: 29,
        2: 31,
        3: 30,
        4: 31,
        5: 30,
        6: 31,
        7: 31,
        8: 30,
        9: 31,
        10: 30,
        11: 31
    };
    function pad(num) {
        return addZeros(num, num < 100 ? num < 10 ? 2 : 1 : 0, true);
    }
    function padEndTo(num, toLen) {
        return addZeros(num, 9 - ('' + num).length);
    }
    function addZeros(str) {
        var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var front = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        if (count === 0) return str;
        return addZeros('' + (front ? '0' : '') + str + (!front ? '0' : ''), count - 1, front);
    }
    function toNano(num) {
        var str = '' + num;
        if (str.length <= DIGETS_IN_NANO) {
            if (str.indexOf('.') > -1) {
                str = num.toFixed(3);
                return new _bignumber2.default(str.replace('.', '') + '000');
            }
            return new _bignumber2.default(str);
        }
        return new _bignumber2.default(str.slice(0, DIGETS_IN_NANO));
    }
    function onlyDigits(num) {
        return /^(-)?\d+$/.test('' + num);
    }
    function leapYear(yearBase) {
        var year = yearBase.toNumber();
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    function daysForYear(year) {
        return leapYear(year) ? 366 : 365;
    }
    function daysForMonth(year, month) {
        var days = leapYear(year) ? DAYS_LEAP_YEAR : DAYS;
        return days[month.toNumber()];
    }
    function handleNotAnInteger(items, funcName, names) {
        var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        var item = items[index];
        var name = names[index];
        if (typeof item !== 'number' || !onlyDigits(item)) throw new Error('Parameter ' + name + ' value for ' + funcName + ' has to be an integer.');
        else if (names.length > index && notUndefined(items[index + 1])) handleNotAnInteger(items, funcName, names, index + 1);
    }
    function notUndefined(item) {
        return typeof item !== 'undefined';
    }
    function buildSetFunction(scope, name, argumentNames, getMethod, valueKey) {
        var moreVarsFunc = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : function() {};
        var utc = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
        function setFunction() {
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            handleNotAnInteger(args, name, argumentNames);
            var currentValue = getMethod();
            if (currentValue !== args[0]) {
                if (currentValue < args[0]) {
                    var v = scope._getValue.call(scope, scope, valueKey, args[0] - currentValue, utc);
                    scope._full = scope._full.plus(v).truncated();
                } else {
                    var _v = scope._getValue.call(scope, scope, valueKey, currentValue - args[0], utc);
                    scope._full = scope._full.minus(_v).truncated();
                }
                if (args.length === 1 || args.length > 1 && !notUndefined(args[1])) scope._setupFunctions.call(scope);
            }
            if (args.length > 1 && notUndefined(args[1])) {
                args.shift();
                moreVarsFunc.apply(scope, args);
            }
            return getMethod();
        }
        Object.defineProperty(setFunction, 'name', {
            value: name,
            writable: false
        });
        return setFunction.bind(scope);
    }
    var passThroughMethods = [
        'getFullYear',
        'getYear',
        'getMonth',
        'getDate',
        'getDay',
        'getHours',
        'getMinutes',
        'getSeconds',
        'getMilliseconds',
        'getUTCFullYear',
        'getUTCYear',
        'getUTCMonth',
        'getUTCDate',
        'getUTCDay',
        'getUTCHours',
        'getUTCMinutes',
        'getUTCSeconds',
        'getUTCMilliseconds',
        'toDateString',
        'toLocaleDateString',
        'toLocaleString',
        'toTimeString',
        'toLocaleTimeString',
        'toISOString',
        'getTimezoneOffset'
    ];
    var NanoDate = (_dec = (0, _coreDecorators.decorate)((0, _memoizerific2.default)(250)), _dec2 = (0, _coreDecorators.decorate)((0, _memoizerific2.default)(100)), _dec3 = (0, _coreDecorators.deprecate)('Use toUTCString() instead'), (0, _coreDecorators.autobind)(_class = (_class2 = function() {
        function NanoDate(a, b, c, d, e, f, g, h) {
            _classCallCheck(this, NanoDate);
            if (typeof a === 'string') this._full = onlyDigits(a) ? toNano(a) : toNano(new BaseDate(a).valueOf() * MILLI_TO_NANO_DIFF);
            else if (arguments.length === 0) this._full = toNano(new BaseDate().valueOf() * MILLI_TO_NANO_DIFF);
            else if (arguments.length === 1) {
                if (a instanceof NanoDate) this._full = a._full;
                else if (a instanceof BaseDate) this._full = toNano(a.valueOf() * MILLI_TO_NANO_DIFF);
                else if (typeof a === 'number') {
                    var multi = MILLI_TO_NANO_DIFF;
                    if (('' + a).indexOf('.') > -1) multi = 1;
                    this._full = toNano(a * multi);
                } else throw Error('Input not of any type that can be converted to a date');
            } else {
                var date = void 0;
                if (typeof a === 'boolean') date = BaseDate.UTC(b, c || 0, d || 0, e || 0, f || 0, g || 0, h || 0);
                else date = new BaseDate(a, b, c || 0, d || 0, e || 0, f || 0, g || 0);
                this._full = toNano(date.valueOf() * MILLI_TO_NANO_DIFF);
            }
            this._setupFunctions();
            if (typeof a === 'string' && ISO_8601_FULL.test(a) && a.indexOf('.') > -1) {
                var match = a.match(ISO_8601_FULL);
                if (typeof match[1] !== 'undefined') {
                    var padded = padEndTo(match[1].replace('.', ''), 9);
                    var nanos = parseInt(padded, 10);
                    // set milliseconds
                    if (nanos > 0) {
                        this.setMilliseconds(Math.floor(nanos / MILLI_TO_NANO_DIFF));
                        nanos = nanos % MILLI_TO_NANO_DIFF;
                    }
                    // set microseconds
                    if (nanos > 0) {
                        this.setMicroseconds(Math.floor(nanos / 1000));
                        nanos = nanos % 1000;
                    }
                    // set nanoseconds
                    if (nanos > 0) this.setNanoseconds(Math.floor(nanos));
                }
            }
        }
        _createClass(NanoDate, [
            {
                key: '_setupFunctions',
                value: function _setupFunctions() {
                    var _this = this;
                    this._date = new BaseDate(this.valueOf());
                    passThroughMethods.forEach(function(name) {
                        _this[name] = function() {
                            var _date;
                            return (_date = _this._date)[name].apply(_date, arguments);
                        };
                    });
                    this._buildSetFunctions();
                }
            },
            {
                key: '_getDaysBetween',
                value: function _getDaysBetween(a, b, func) {
                    if (a.eq(b)) return new _bignumber2.default(0);
                    var days = new _bignumber2.default(0);
                    var diff = a.lt(b) ? 1 : -1;
                    var start = new _bignumber2.default(a);
                    while(!start.eq(b)){
                        var val = func(start);
                        days = days.plus(val);
                        start = start.plus(diff);
                    }
                    return days.times(diff);
                }
            },
            {
                key: '_getFullYear',
                value: function _getFullYear(utc) {
                    return utc ? this.getUTCFullYear() : this.getFullYear();
                }
            },
            {
                key: '_getDate',
                value: function _getDate(utc) {
                    return utc ? this.getUTCDate() : this.getDate();
                }
            },
            {
                key: '_getMonth',
                value: function _getMonth(utc) {
                    return utc ? this.getUTCMonth() : this.getMonth();
                }
            },
            {
                key: '_getDays',
                value: function _getDays(unit) {
                    var utc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                    var currentYear = new _bignumber2.default(this._getFullYear(utc));
                    var base = new _bignumber2.default(unit);
                    var res = new _bignumber2.default(this._getDate(utc)).minus(1);
                    if (unit >= 12) {
                        var years = base.dividedToIntegerBy(12);
                        var start = new _bignumber2.default(currentYear);
                        var end = start.plus(years);
                        res = this._getDaysBetween(start, end, daysForYear);
                        base = base.plus(years.times(12).times(base.lessThan(0) ? 1 : -1));
                    }
                    var month = new _bignumber2.default(this._getMonth(utc));
                    var diff = month.plus(base);
                    if (diff.greaterThan(11)) diff = month.minus(base);
                    // console.log('days between', res.toNumber(), diff.toNumber(), month.toNumber());
                    if (diff.lessThan(month)) return res.plus(this._getDaysBetween(diff, month, daysForMonth.bind(null, currentYear)));
                    return res.plus(this._getDaysBetween(month, diff, daysForMonth.bind(null, currentYear)));
                }
            },
            {
                key: '_getValue',
                value: function _getValue(scope, type, unit) {
                    var utc = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
                    var numUnit = new _bignumber2.default(unit);
                    switch(type){
                        case YEAR:
                            return scope._getValue(scope, MONTH, numUnit.times(12), utc);
                        case MONTH:
                            return scope._getValue(scope, DAY, scope._getDays(numUnit, utc), utc);
                        case DAY:
                            return scope._getValue(scope, HOUR, numUnit.times(24), utc);
                        case HOUR:
                            return scope._getValue(scope, MINUTE, numUnit.times(60), utc);
                        case MINUTE:
                            return scope._getValue(scope, SECOND, numUnit.times(60), utc);
                        case SECOND:
                            return scope._getValue(scope, MILLI, numUnit.times(1000), utc);
                        case MILLI:
                            return scope._getValue(scope, MICRO, numUnit.times(1000), utc);
                        case MICRO:
                            return scope._getValue(scope, NANO, numUnit.times(1000), utc);
                        case NANO:
                        default:
                            return numUnit;
                    }
                }
            },
            {
                key: 'getTime',
                value: function getTime() {
                    return this._full.toString();
                }
            },
            {
                key: 'valueOf',
                value: function valueOf() {
                    return this._full.dividedBy(MILLI_TO_NANO_DIFF).truncated().toNumber();
                }
            },
            {
                key: 'valueOfWithMicro',
                value: function valueOfWithMicro() {
                    return parseFloat(this.valueOf() + '.' + pad(this.getMicroseconds()), 10);
                }
            },
            {
                key: 'valueOfWithNano',
                value: function valueOfWithNano() {
                    return '' + this.valueOfWithMicro().toFixed(3) + pad(this.getNanoseconds());
                }
            },
            {
                key: 'getMicroseconds',
                value: function getMicroseconds() {
                    return this._full.minus(this.valueOf() * MILLI_TO_NANO_DIFF).dividedBy(1000).truncated().toNumber();
                }
            },
            {
                key: 'getUTCMicroseconds',
                value: function getUTCMicroseconds() {
                    return this.getMicroseconds();
                }
            },
            {
                key: 'getNanoseconds',
                value: function getNanoseconds() {
                    return this._full.minus(this.valueOf() * MILLI_TO_NANO_DIFF).minus(this.getMicroseconds() * 1000).truncated().toNumber();
                }
            },
            {
                key: 'getUTCNanoseconds',
                value: function getUTCNanoseconds() {
                    return this.getNanoseconds();
                }
            },
            {
                key: '_buildSetFunctions',
                value: function _buildSetFunctions() {
                    var build = buildSetFunction.bind(this, this);
                    this.setUTCNanoseconds = this.setNanoseconds = build('setNanoseconds', [
                        'nanosecond'
                    ], this.getUTCNanoseconds, NANO);
                    this.setUTCMicroseconds = this.setMicroseconds = build('setMicoseconds', [
                        'microsecond',
                        'nanosecond'
                    ], this.getUTCMicroseconds, MICRO, this.setUTCNanoseconds);
                    this.setUTCMilliseconds = this.setMilliseconds = build('setMilliseconds', [
                        'millisecond',
                        'microsecond',
                        'nanosecond'
                    ], this.getUTCMilliseconds, MILLI, this.setUTCMicroseconds);
                    this.setUTCSeconds = build('setUTCSeconds', [
                        'second',
                        'millisecond',
                        'microsecond',
                        'nanosecond'
                    ], this.getUTCSeconds, SECOND, this.setUTCMilliseconds, true);
                    this.setSeconds = build('setSeconds', [
                        'second',
                        'millisecond',
                        'microsecond',
                        'nanosecond'
                    ], this.getSeconds, SECOND, this.setMilliseconds);
                    this.setUTCMinutes = build('setUTCMinutes', [
                        'minute',
                        'second',
                        'millisecond',
                        'microsecond',
                        'nanosecond'
                    ], this.getUTCMinutes, MINUTE, this.setUTCSeconds, true);
                    this.setMinutes = build('setMinutes', [
                        'minute',
                        'second',
                        'millisecond',
                        'microsecond',
                        'nanosecond'
                    ], this.getMinutes, MINUTE, this.setSeconds);
                    this.setUTCHours = build('setUTCHours', [
                        'hour',
                        'minute',
                        'second',
                        'millisecond',
                        'microsecond',
                        'nanosecond'
                    ], this.getUTCHours, HOUR, this.setUTCMinutes, true);
                    this.setHours = build('setHours', [
                        'hour',
                        'minute',
                        'second',
                        'millisecond',
                        'microsecond',
                        'nanosecond'
                    ], this.getHours, HOUR, this.setMinutes);
                    this.setUTCDate = build('setUTCDate', [
                        'day'
                    ], this.getUTCDate, DAY, function() {}, true);
                    this.setDate = build('setDate', [
                        'day'
                    ], this.getDate, DAY);
                    this.setUTCMonth = build('setUTCMonth', [
                        'month',
                        'day'
                    ], this.getUTCMonth, MONTH, this.setUTCDate, true);
                    this.setMonth = build('setMonth', [
                        'month',
                        'day'
                    ], this.getMonth, MONTH, this.setDate);
                    this.setUTCFullYear = build('setUTCFullYear', [
                        'year',
                        'month',
                        'day'
                    ], this.getUTCFullYear, YEAR, this.setUTCMonth, true);
                    this.setFullYear = build('setFullYear', [
                        'year',
                        'month',
                        'day'
                    ], this.getFullYear, YEAR, this.setMonth);
                }
            },
            {
                key: 'setTime',
                value: function setTime(time) {
                    this._full = toNano(time);
                    this._setupFunctions();
                    return time;
                }
            },
            {
                key: 'setUTCTime',
                value: function setUTCTime(time) {
                    return this.setTime(time);
                }
            },
            {
                key: '_toString',
                value: function _toString(funcName) {
                    var split = this._date[funcName]().split(' GMT');
                    var milli = this.getMilliseconds();
                    var micro = this.getMicroseconds();
                    var nano = this.getNanoseconds();
                    split[0] += '.' + pad(milli) + pad(micro) + pad(nano);
                    return split.join(' GMT');
                }
            },
            {
                key: 'toString',
                value: function toString() {
                    return this._toString('toString');
                }
            },
            {
                key: 'toUTCString',
                value: function toUTCString() {
                    return this._toString('toUTCString');
                }
            },
            {
                key: 'toISOStringFull',
                value: function toISOStringFull() {
                    var micro = this.getMicroseconds();
                    var nano = this.getNanoseconds();
                    return this._date.toISOString().replace('Z', '' + pad(micro) + pad(nano) + 'Z');
                }
            },
            {
                key: 'toGMTString',
                value: function toGMTString() {
                    return this.toUTCString();
                }
            }
        ], [
            {
                key: 'now',
                value: function now() {
                    return new NanoDate().valueOf();
                }
            },
            {
                key: 'parse',
                value: function parse() {
                    return BaseDate.parse.apply(BaseDate, arguments);
                }
            },
            {
                key: 'UTC',
                value: function UTC() {
                    for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                    return new (Function.prototype.bind.apply(NanoDate, [
                        null
                    ].concat([
                        true
                    ], args)))();
                }
            }
        ]);
        return NanoDate;
    }(), _applyDecoratedDescriptor(_class2.prototype, '_getDaysBetween', [
        _dec
    ], Object.getOwnPropertyDescriptor(_class2.prototype, '_getDaysBetween'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, '_getValue', [
        _dec2
    ], Object.getOwnPropertyDescriptor(_class2.prototype, '_getValue'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'toGMTString', [
        _dec3
    ], Object.getOwnPropertyDescriptor(_class2.prototype, 'toGMTString'), _class2.prototype), _class2)) || _class);
    exports1.default = NanoDate;
});



var $NdCUR = parcelRequire("NdCUR");

var $g2wso = parcelRequire("g2wso");
/* global Reflect, Promise */ var $8d02d0065a7826a6$var$extendStatics = function(d, b) {
    $8d02d0065a7826a6$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $8d02d0065a7826a6$var$extendStatics(d, b);
};
function $8d02d0065a7826a6$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $8d02d0065a7826a6$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $8d02d0065a7826a6$var$__assign = function() {
    $8d02d0065a7826a6$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8d02d0065a7826a6$var$__assign.apply(this, arguments);
};
function $8d02d0065a7826a6$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var $8d02d0065a7826a6$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {}; /**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ 
function $8d02d0065a7826a6$var$isObject$3(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $8d02d0065a7826a6$var$isObject_1 = $8d02d0065a7826a6$var$isObject$3; /** Detect free variable `global` from Node.js. */ 
var $8d02d0065a7826a6$var$freeGlobal$1 = typeof $8d02d0065a7826a6$var$commonjsGlobal == 'object' && $8d02d0065a7826a6$var$commonjsGlobal && $8d02d0065a7826a6$var$commonjsGlobal.Object === Object && $8d02d0065a7826a6$var$commonjsGlobal;
var $8d02d0065a7826a6$var$_freeGlobal = $8d02d0065a7826a6$var$freeGlobal$1;
var $8d02d0065a7826a6$var$freeGlobal = $8d02d0065a7826a6$var$_freeGlobal;
/** Detect free variable `self`. */ var $8d02d0065a7826a6$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $8d02d0065a7826a6$var$root$2 = $8d02d0065a7826a6$var$freeGlobal || $8d02d0065a7826a6$var$freeSelf || Function('return this')();
var $8d02d0065a7826a6$var$_root = $8d02d0065a7826a6$var$root$2;
var $8d02d0065a7826a6$var$root$1 = $8d02d0065a7826a6$var$_root;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $8d02d0065a7826a6$var$now$1 = function() {
    return $8d02d0065a7826a6$var$root$1.Date.now();
};
var $8d02d0065a7826a6$var$now_1 = $8d02d0065a7826a6$var$now$1; /** Used to match a single whitespace character. */ 
var $8d02d0065a7826a6$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $8d02d0065a7826a6$var$trimmedEndIndex$1(string) {
    var index = string.length;
    while(index-- && $8d02d0065a7826a6$var$reWhitespace.test(string.charAt(index)));
    return index;
}
var $8d02d0065a7826a6$var$_trimmedEndIndex = $8d02d0065a7826a6$var$trimmedEndIndex$1;
var $8d02d0065a7826a6$var$trimmedEndIndex = $8d02d0065a7826a6$var$_trimmedEndIndex;
/** Used to match leading whitespace. */ var $8d02d0065a7826a6$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $8d02d0065a7826a6$var$baseTrim$1(string) {
    return string ? string.slice(0, $8d02d0065a7826a6$var$trimmedEndIndex(string) + 1).replace($8d02d0065a7826a6$var$reTrimStart, '') : string;
}
var $8d02d0065a7826a6$var$_baseTrim = $8d02d0065a7826a6$var$baseTrim$1;
var $8d02d0065a7826a6$var$root = $8d02d0065a7826a6$var$_root;
/** Built-in value references. */ var $8d02d0065a7826a6$var$Symbol$2 = $8d02d0065a7826a6$var$root.Symbol;
var $8d02d0065a7826a6$var$_Symbol = $8d02d0065a7826a6$var$Symbol$2;
var $8d02d0065a7826a6$var$Symbol$1 = $8d02d0065a7826a6$var$_Symbol;
/** Used for built-in method references. */ var $8d02d0065a7826a6$var$objectProto$1 = Object.prototype;
/** Used to check objects for own properties. */ var $8d02d0065a7826a6$var$hasOwnProperty = $8d02d0065a7826a6$var$objectProto$1.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $8d02d0065a7826a6$var$nativeObjectToString$1 = $8d02d0065a7826a6$var$objectProto$1.toString;
/** Built-in value references. */ var $8d02d0065a7826a6$var$symToStringTag$1 = $8d02d0065a7826a6$var$Symbol$1 ? $8d02d0065a7826a6$var$Symbol$1.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $8d02d0065a7826a6$var$getRawTag$1(value) {
    var isOwn = $8d02d0065a7826a6$var$hasOwnProperty.call(value, $8d02d0065a7826a6$var$symToStringTag$1), tag = value[$8d02d0065a7826a6$var$symToStringTag$1];
    try {
        value[$8d02d0065a7826a6$var$symToStringTag$1] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $8d02d0065a7826a6$var$nativeObjectToString$1.call(value);
    if (unmasked) {
        if (isOwn) value[$8d02d0065a7826a6$var$symToStringTag$1] = tag;
        else delete value[$8d02d0065a7826a6$var$symToStringTag$1];
    }
    return result;
}
var $8d02d0065a7826a6$var$_getRawTag = $8d02d0065a7826a6$var$getRawTag$1; /** Used for built-in method references. */ 
var $8d02d0065a7826a6$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $8d02d0065a7826a6$var$nativeObjectToString = $8d02d0065a7826a6$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $8d02d0065a7826a6$var$objectToString$1(value) {
    return $8d02d0065a7826a6$var$nativeObjectToString.call(value);
}
var $8d02d0065a7826a6$var$_objectToString = $8d02d0065a7826a6$var$objectToString$1;
var $8d02d0065a7826a6$var$Symbol = $8d02d0065a7826a6$var$_Symbol, $8d02d0065a7826a6$var$getRawTag = $8d02d0065a7826a6$var$_getRawTag, $8d02d0065a7826a6$var$objectToString = $8d02d0065a7826a6$var$_objectToString;
/** `Object#toString` result references. */ var $8d02d0065a7826a6$var$nullTag = '[object Null]', $8d02d0065a7826a6$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $8d02d0065a7826a6$var$symToStringTag = $8d02d0065a7826a6$var$Symbol ? $8d02d0065a7826a6$var$Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $8d02d0065a7826a6$var$baseGetTag$1(value) {
    if (value == null) return value === undefined ? $8d02d0065a7826a6$var$undefinedTag : $8d02d0065a7826a6$var$nullTag;
    return $8d02d0065a7826a6$var$symToStringTag && $8d02d0065a7826a6$var$symToStringTag in Object(value) ? $8d02d0065a7826a6$var$getRawTag(value) : $8d02d0065a7826a6$var$objectToString(value);
}
var $8d02d0065a7826a6$var$_baseGetTag = $8d02d0065a7826a6$var$baseGetTag$1; /**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ 
function $8d02d0065a7826a6$var$isObjectLike$1(value) {
    return value != null && typeof value == 'object';
}
var $8d02d0065a7826a6$var$isObjectLike_1 = $8d02d0065a7826a6$var$isObjectLike$1;
var $8d02d0065a7826a6$var$baseGetTag = $8d02d0065a7826a6$var$_baseGetTag, $8d02d0065a7826a6$var$isObjectLike = $8d02d0065a7826a6$var$isObjectLike_1;
/** `Object#toString` result references. */ var $8d02d0065a7826a6$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $8d02d0065a7826a6$var$isSymbol$1(value) {
    return typeof value == 'symbol' || $8d02d0065a7826a6$var$isObjectLike(value) && $8d02d0065a7826a6$var$baseGetTag(value) == $8d02d0065a7826a6$var$symbolTag;
}
var $8d02d0065a7826a6$var$isSymbol_1 = $8d02d0065a7826a6$var$isSymbol$1;
var $8d02d0065a7826a6$var$baseTrim = $8d02d0065a7826a6$var$_baseTrim, $8d02d0065a7826a6$var$isObject$2 = $8d02d0065a7826a6$var$isObject_1, $8d02d0065a7826a6$var$isSymbol = $8d02d0065a7826a6$var$isSymbol_1;
/** Used as references for various `Number` constants. */ var $8d02d0065a7826a6$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $8d02d0065a7826a6$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $8d02d0065a7826a6$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $8d02d0065a7826a6$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $8d02d0065a7826a6$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $8d02d0065a7826a6$var$toNumber$1(value) {
    if (typeof value == 'number') return value;
    if ($8d02d0065a7826a6$var$isSymbol(value)) return $8d02d0065a7826a6$var$NAN;
    if ($8d02d0065a7826a6$var$isObject$2(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $8d02d0065a7826a6$var$isObject$2(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $8d02d0065a7826a6$var$baseTrim(value);
    var isBinary = $8d02d0065a7826a6$var$reIsBinary.test(value);
    return isBinary || $8d02d0065a7826a6$var$reIsOctal.test(value) ? $8d02d0065a7826a6$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $8d02d0065a7826a6$var$reIsBadHex.test(value) ? $8d02d0065a7826a6$var$NAN : +value;
}
var $8d02d0065a7826a6$var$toNumber_1 = $8d02d0065a7826a6$var$toNumber$1;
var $8d02d0065a7826a6$var$isObject$1 = $8d02d0065a7826a6$var$isObject_1, $8d02d0065a7826a6$var$now = $8d02d0065a7826a6$var$now_1, $8d02d0065a7826a6$var$toNumber = $8d02d0065a7826a6$var$toNumber_1;
/** Error message constants. */ var $8d02d0065a7826a6$var$FUNC_ERROR_TEXT$1 = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $8d02d0065a7826a6$var$nativeMax = Math.max, $8d02d0065a7826a6$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $8d02d0065a7826a6$var$debounce$1(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($8d02d0065a7826a6$var$FUNC_ERROR_TEXT$1);
    wait = $8d02d0065a7826a6$var$toNumber(wait) || 0;
    if ($8d02d0065a7826a6$var$isObject$1(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $8d02d0065a7826a6$var$nativeMax($8d02d0065a7826a6$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $8d02d0065a7826a6$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $8d02d0065a7826a6$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($8d02d0065a7826a6$var$now());
    }
    function debounced() {
        var time = $8d02d0065a7826a6$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
var $8d02d0065a7826a6$var$debounce_1 = $8d02d0065a7826a6$var$debounce$1;
var $8d02d0065a7826a6$var$debounce = $8d02d0065a7826a6$var$debounce_1, $8d02d0065a7826a6$var$isObject = $8d02d0065a7826a6$var$isObject_1;
/** Error message constants. */ var $8d02d0065a7826a6$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $8d02d0065a7826a6$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($8d02d0065a7826a6$var$FUNC_ERROR_TEXT);
    if ($8d02d0065a7826a6$var$isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $8d02d0065a7826a6$var$debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
var $8d02d0065a7826a6$var$throttle_1 = $8d02d0065a7826a6$var$throttle;
var $8d02d0065a7826a6$var$patchResizeHandler = function(resizeCallback, refreshMode, refreshRate, refreshOptions) {
    switch(refreshMode){
        case 'debounce':
            return $8d02d0065a7826a6$var$debounce_1(resizeCallback, refreshRate, refreshOptions);
        case 'throttle':
            return $8d02d0065a7826a6$var$throttle_1(resizeCallback, refreshRate, refreshOptions);
        default:
            return resizeCallback;
    }
};
var $8d02d0065a7826a6$var$isFunction = function(fn) {
    return typeof fn === 'function';
};
var $8d02d0065a7826a6$var$isSSR = function() {
    return typeof window === 'undefined';
};
var $8d02d0065a7826a6$var$isDOMElement = function(element) {
    return element instanceof Element || element instanceof HTMLDocument;
};
var $8d02d0065a7826a6$var$createNotifier = function(onResize, setSize, handleWidth, handleHeight) {
    return function(_a) {
        var width = _a.width, height = _a.height;
        setSize(function(prev) {
            if (prev.width === width && prev.height === height) // skip if dimensions haven't changed
            return prev;
            if (prev.width === width && !handleHeight || prev.height === height && !handleWidth) // process `handleHeight/handleWidth` props
            return prev;
            if (onResize && $8d02d0065a7826a6$var$isFunction(onResize)) onResize(width, height);
            return {
                width: width,
                height: height
            };
        });
    };
};
var $8d02d0065a7826a6$export$2e2bcd8739ae039 = /** @class */ function(_super) {
    $8d02d0065a7826a6$var$__extends(ResizeDetector, _super);
    function ResizeDetector(props) {
        var _this = _super.call(this, props) || this;
        _this.cancelHandler = function() {
            if (_this.resizeHandler && _this.resizeHandler.cancel) {
                // cancel debounced handler
                _this.resizeHandler.cancel();
                _this.resizeHandler = null;
            }
        };
        _this.attachObserver = function() {
            var _a = _this.props, targetRef = _a.targetRef, observerOptions = _a.observerOptions;
            if ($8d02d0065a7826a6$var$isSSR()) return;
            if (targetRef && targetRef.current) _this.targetRef.current = targetRef.current;
            var element = _this.getElement();
            if (!element) // can't find element to observe
            return;
            if (_this.observableElement && _this.observableElement === element) // element is already observed
            return;
            _this.observableElement = element;
            _this.resizeObserver.observe(element, observerOptions);
        };
        _this.getElement = function() {
            var _a = _this.props, querySelector = _a.querySelector, targetDomEl = _a.targetDomEl;
            if ($8d02d0065a7826a6$var$isSSR()) return null;
            // in case we pass a querySelector
            if (querySelector) return document.querySelector(querySelector);
            // in case we pass a DOM element
            if (targetDomEl && $8d02d0065a7826a6$var$isDOMElement(targetDomEl)) return targetDomEl;
            // in case we pass a React ref using React.createRef()
            if (_this.targetRef && $8d02d0065a7826a6$var$isDOMElement(_this.targetRef.current)) return _this.targetRef.current;
            // the worse case when we don't receive any information from the parent and the library doesn't add any wrappers
            // we have to use a deprecated `findDOMNode` method in order to find a DOM element to attach to
            var currentElement = (0, $g2wso.findDOMNode)(_this);
            if (!currentElement) return null;
            var renderType = _this.getRenderType();
            switch(renderType){
                case 'renderProp':
                    return currentElement;
                case 'childFunction':
                    return currentElement;
                case 'child':
                    return currentElement;
                case 'childArray':
                    return currentElement;
                default:
                    return currentElement.parentElement;
            }
        };
        _this.createResizeHandler = function(entries) {
            var _a = _this.props, _b = _a.handleWidth, handleWidth = _b === void 0 ? true : _b, _c = _a.handleHeight, handleHeight = _c === void 0 ? true : _c, onResize = _a.onResize;
            if (!handleWidth && !handleHeight) return;
            var notifyResize = $8d02d0065a7826a6$var$createNotifier(onResize, _this.setState.bind(_this), handleWidth, handleHeight);
            entries.forEach(function(entry) {
                var _a = entry && entry.contentRect || {}, width = _a.width, height = _a.height;
                var shouldSetSize = !_this.skipOnMount && !$8d02d0065a7826a6$var$isSSR();
                if (shouldSetSize) notifyResize({
                    width: width,
                    height: height
                });
                _this.skipOnMount = false;
            });
        };
        _this.getRenderType = function() {
            var _a = _this.props, render = _a.render, children = _a.children;
            if ($8d02d0065a7826a6$var$isFunction(render)) // DEPRECATED. Use `Child Function Pattern` instead
            return 'renderProp';
            if ($8d02d0065a7826a6$var$isFunction(children)) return 'childFunction';
            if ((0, $NdCUR.isValidElement)(children)) return 'child';
            if (Array.isArray(children)) // DEPRECATED. Wrap children with a single parent
            return 'childArray';
            // DEPRECATED. Use `Child Function Pattern` instead
            return 'parent';
        };
        var skipOnMount = props.skipOnMount, refreshMode = props.refreshMode, _a = props.refreshRate, refreshRate = _a === void 0 ? 1000 : _a, refreshOptions = props.refreshOptions;
        _this.state = {
            width: undefined,
            height: undefined
        };
        _this.skipOnMount = skipOnMount;
        _this.targetRef = (0, $NdCUR.createRef)();
        _this.observableElement = null;
        if ($8d02d0065a7826a6$var$isSSR()) return _this;
        _this.resizeHandler = $8d02d0065a7826a6$var$patchResizeHandler(_this.createResizeHandler, refreshMode, refreshRate, refreshOptions);
        _this.resizeObserver = new window.ResizeObserver(_this.resizeHandler);
        return _this;
    }
    ResizeDetector.prototype.componentDidMount = function() {
        this.attachObserver();
    };
    ResizeDetector.prototype.componentDidUpdate = function() {
        this.attachObserver();
    };
    ResizeDetector.prototype.componentWillUnmount = function() {
        if ($8d02d0065a7826a6$var$isSSR()) return;
        this.resizeObserver.disconnect();
        this.cancelHandler();
    };
    ResizeDetector.prototype.render = function() {
        var _a = this.props, render = _a.render, children = _a.children, _b = _a.nodeType, WrapperTag = _b === void 0 ? 'div' : _b;
        var _c = this.state, width = _c.width, height = _c.height;
        var childProps = {
            width: width,
            height: height,
            targetRef: this.targetRef
        };
        var renderType = this.getRenderType();
        var typedChildren;
        switch(renderType){
            case 'renderProp':
                return render && render(childProps);
            case 'childFunction':
                typedChildren = children;
                return typedChildren(childProps);
            case 'child':
                // @TODO bug prone logic
                typedChildren = children;
                if (typedChildren.type && typeof typedChildren.type === 'string') {
                    // child is a native DOM elements such as div, span etc
                    childProps.targetRef;
                    var nativeProps = $8d02d0065a7826a6$var$__rest(childProps, [
                        "targetRef"
                    ]);
                    return (0, $NdCUR.cloneElement)(typedChildren, nativeProps);
                }
                // class or functional component otherwise
                return (0, $NdCUR.cloneElement)(typedChildren, childProps);
            case 'childArray':
                typedChildren = children;
                return typedChildren.map(function(el) {
                    return !!el && (0, $NdCUR.cloneElement)(el, childProps);
                });
            default:
                return $NdCUR.createElement(WrapperTag, null);
        }
    };
    return ResizeDetector;
}((0, $NdCUR.PureComponent));
function $8d02d0065a7826a6$export$fa0519968090da40(ComponentInner, options) {
    if (options === void 0) options = {};
    var ResizeDetectorHOC = /** @class */ function(_super) {
        $8d02d0065a7826a6$var$__extends(ResizeDetectorHOC, _super);
        function ResizeDetectorHOC() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.ref = (0, $NdCUR.createRef)();
            return _this;
        }
        ResizeDetectorHOC.prototype.render = function() {
            var _a = this.props, forwardedRef = _a.forwardedRef, rest = $8d02d0065a7826a6$var$__rest(_a, [
                "forwardedRef"
            ]);
            var targetRef = forwardedRef !== null && forwardedRef !== void 0 ? forwardedRef : this.ref;
            return $NdCUR.createElement($8d02d0065a7826a6$export$2e2bcd8739ae039, $8d02d0065a7826a6$var$__assign({}, options, {
                targetRef: targetRef
            }), $NdCUR.createElement(ComponentInner, $8d02d0065a7826a6$var$__assign({
                targetRef: targetRef
            }, rest)));
        };
        return ResizeDetectorHOC;
    }((0, $NdCUR.Component));
    function forwardRefWrapper(props, ref) {
        return $NdCUR.createElement(ResizeDetectorHOC, $8d02d0065a7826a6$var$__assign({}, props, {
            forwardedRef: ref
        }));
    }
    var name = ComponentInner.displayName || ComponentInner.name;
    forwardRefWrapper.displayName = "withResizeDetector(".concat(name, ")");
    return (0, $NdCUR.forwardRef)(forwardRefWrapper);
}
var $8d02d0065a7826a6$var$useEnhancedEffect = $8d02d0065a7826a6$var$isSSR() ? (0, $NdCUR.useEffect) : (0, $NdCUR.useLayoutEffect);
function $8d02d0065a7826a6$export$453c3d1cba18d800(props) {
    if (props === void 0) props = {};
    var _a = props.skipOnMount, skipOnMount = _a === void 0 ? false : _a, refreshMode = props.refreshMode, _b = props.refreshRate, refreshRate = _b === void 0 ? 1000 : _b, refreshOptions = props.refreshOptions, _c = props.handleWidth, handleWidth = _c === void 0 ? true : _c, _d = props.handleHeight, handleHeight = _d === void 0 ? true : _d, targetRef = props.targetRef, observerOptions = props.observerOptions, onResize = props.onResize;
    var skipResize = (0, $NdCUR.useRef)(skipOnMount);
    var localRef = (0, $NdCUR.useRef)(null);
    var ref = targetRef !== null && targetRef !== void 0 ? targetRef : localRef;
    var resizeHandler = (0, $NdCUR.useRef)();
    var _e = (0, $NdCUR.useState)({
        width: undefined,
        height: undefined
    }), size = _e[0], setSize = _e[1];
    $8d02d0065a7826a6$var$useEnhancedEffect(function() {
        if ($8d02d0065a7826a6$var$isSSR()) return;
        var notifyResize = $8d02d0065a7826a6$var$createNotifier(onResize, setSize, handleWidth, handleHeight);
        var resizeCallback = function(entries) {
            if (!handleWidth && !handleHeight) return;
            entries.forEach(function(entry) {
                var _a = entry && entry.contentRect || {}, width = _a.width, height = _a.height;
                var shouldSetSize = !skipResize.current && !$8d02d0065a7826a6$var$isSSR();
                if (shouldSetSize) notifyResize({
                    width: width,
                    height: height
                });
                skipResize.current = false;
            });
        };
        resizeHandler.current = $8d02d0065a7826a6$var$patchResizeHandler(resizeCallback, refreshMode, refreshRate, refreshOptions);
        var resizeObserver = new window.ResizeObserver(resizeHandler.current);
        if (ref.current) // Something wrong with typings here...
        resizeObserver.observe(ref.current, observerOptions);
        return function() {
            resizeObserver.disconnect();
            var patchedResizeHandler = resizeHandler.current;
            if (patchedResizeHandler && patchedResizeHandler.cancel) patchedResizeHandler.cancel();
        };
    }, [
        refreshMode,
        refreshRate,
        refreshOptions,
        handleWidth,
        handleHeight,
        onResize,
        observerOptions,
        ref.current
    ]);
    return $8d02d0065a7826a6$var$__assign({
        ref: ref
    }, size);
}


var $6c6177bbe259d59a$var$simpleIsEqual = function simpleIsEqual(a, b) {
    return a === b;
};
function $6c6177bbe259d59a$var$index(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $6c6177bbe259d59a$var$simpleIsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    var isNewArgEqualToLast = function isNewArgEqualToLast(newArg, index) {
        return isEqual(newArg, lastArgs[index], index);
    };
    var result = function result() {
        for(var _len = arguments.length, newArgs = new Array(_len), _key = 0; _key < _len; _key++)newArgs[_key] = arguments[_key];
        if (calledOnce && lastThis === this && newArgs.length === lastArgs.length && newArgs.every(isNewArgEqualToLast)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    };
    return result;
}
var $6c6177bbe259d59a$export$2e2bcd8739ae039 = $6c6177bbe259d59a$var$index;


var $298304f644e9f727$exports = {};
/**
 * @license
 * Copyright 2006 Dan Vanderkam (danvdk@gmail.com)
 * MIT-licensed (http://opensource.org/licenses/MIT)
 */ /**
 * @fileoverview Creates an interactive, zoomable graph based on a CSV file or
 * string. Dygraph can handle multiple series with or without error bars. The
 * date/value ranges will be automatically set. Dygraph uses the
 * &lt;canvas&gt; tag, so it only works in FF1.5+.
 * @author danvdk@gmail.com (Dan Vanderkam)

  Usage:
   <div id="graphdiv" style="width:800px; height:500px;"></div>
   <script type="text/javascript">
     new Dygraph(document.getElementById("graphdiv"),
                 "datafile.csv",  // CSV file with headers
                 { }); // options
   </script>

 The CSV file is of the form

   Date,SeriesA,SeriesB,SeriesC
   YYYYMMDD,A1,B1,C1
   YYYYMMDD,A2,B2,C2

 If the 'errorBars' option is set in the constructor, the input should be of
 the form
   Date,SeriesA,SeriesB,...
   YYYYMMDD,A1,sigmaA1,B1,sigmaB1,...
   YYYYMMDD,A2,sigmaA2,B2,sigmaB2,...

 If the 'fractions' option is set, the input should be of the form:

   Date,SeriesA,SeriesB,...
   YYYYMMDD,A1/B1,A2/B2,...
   YYYYMMDD,A1/B1,A2/B2,...

 And error bars will be calculated automatically using a binomial distribution.

 For further documentation and examples, see http://dygraphs.com/
 */ 'use strict';
Object.defineProperty($298304f644e9f727$exports, '__esModule', {
    value: true
});
var $298304f644e9f727$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i['return']) _i['return']();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError('Invalid attempt to destructure non-iterable instance');
    };
}();
function $298304f644e9f727$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj['default'] = obj;
        return newObj;
    }
}
function $298304f644e9f727$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $852ab21d3dc0462c$exports = {};
/**
 * @license
 * Copyright 2011 Dan Vanderkam (danvdk@gmail.com)
 * MIT-licensed (http://opensource.org/licenses/MIT)
 */ /**
 * @fileoverview Based on PlotKitLayout, but modified to meet the needs of
 * dygraphs.
 */ /*global Dygraph:false */ "use strict";
Object.defineProperty($852ab21d3dc0462c$exports, '__esModule', {
    value: true
});
function $852ab21d3dc0462c$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj['default'] = obj;
        return newObj;
    }
}
var $ad57523a9e758dd4$exports = {};
/**
 * @license
 * Copyright 2011 Dan Vanderkam (danvdk@gmail.com)
 * MIT-licensed (http://opensource.org/licenses/MIT)
 */ /**
 * @fileoverview This file contains utility functions used by dygraphs. These
 * are typically static (i.e. not related to any particular dygraph). Examples
 * include date/time formatting functions, basic algorithms (e.g. binary
 * search) and generic DOM-manipulation functions.
 */ /*global Dygraph:false, Node:false */ "use strict";
Object.defineProperty($ad57523a9e758dd4$exports, "__esModule", {
    value: true
});
$ad57523a9e758dd4$exports.removeEvent = $ad57523a9e758dd4$var$removeEvent;
$ad57523a9e758dd4$exports.cancelEvent = $ad57523a9e758dd4$var$cancelEvent;
$ad57523a9e758dd4$exports.hsvToRGB = $ad57523a9e758dd4$var$hsvToRGB;
$ad57523a9e758dd4$exports.findPos = $ad57523a9e758dd4$var$findPos;
$ad57523a9e758dd4$exports.pageX = $ad57523a9e758dd4$var$pageX;
$ad57523a9e758dd4$exports.pageY = $ad57523a9e758dd4$var$pageY;
$ad57523a9e758dd4$exports.dragGetX_ = $ad57523a9e758dd4$var$dragGetX_;
$ad57523a9e758dd4$exports.dragGetY_ = $ad57523a9e758dd4$var$dragGetY_;
$ad57523a9e758dd4$exports.isOK = $ad57523a9e758dd4$var$isOK;
$ad57523a9e758dd4$exports.isValidPoint = $ad57523a9e758dd4$var$isValidPoint;
$ad57523a9e758dd4$exports.floatFormat = $ad57523a9e758dd4$var$floatFormat;
$ad57523a9e758dd4$exports.zeropad = $ad57523a9e758dd4$var$zeropad;
$ad57523a9e758dd4$exports.hmsString_ = $ad57523a9e758dd4$var$hmsString_;
$ad57523a9e758dd4$exports.dateString_ = $ad57523a9e758dd4$var$dateString_;
$ad57523a9e758dd4$exports.round_ = $ad57523a9e758dd4$var$round_;
$ad57523a9e758dd4$exports.binarySearch = $ad57523a9e758dd4$var$binarySearch;
$ad57523a9e758dd4$exports.dateParser = $ad57523a9e758dd4$var$dateParser;
$ad57523a9e758dd4$exports.dateStrToMillis = $ad57523a9e758dd4$var$dateStrToMillis;
$ad57523a9e758dd4$exports.update = $ad57523a9e758dd4$var$update;
$ad57523a9e758dd4$exports.updateDeep = $ad57523a9e758dd4$var$updateDeep;
$ad57523a9e758dd4$exports.isArrayLike = $ad57523a9e758dd4$var$isArrayLike;
$ad57523a9e758dd4$exports.isDateLike = $ad57523a9e758dd4$var$isDateLike;
$ad57523a9e758dd4$exports.clone = $ad57523a9e758dd4$var$clone;
$ad57523a9e758dd4$exports.createCanvas = $ad57523a9e758dd4$var$createCanvas;
$ad57523a9e758dd4$exports.getContextPixelRatio = $ad57523a9e758dd4$var$getContextPixelRatio;
$ad57523a9e758dd4$exports.Iterator = $ad57523a9e758dd4$var$Iterator;
$ad57523a9e758dd4$exports.createIterator = $ad57523a9e758dd4$var$createIterator;
$ad57523a9e758dd4$exports.repeatAndCleanup = $ad57523a9e758dd4$var$repeatAndCleanup;
$ad57523a9e758dd4$exports.isPixelChangingOptionList = $ad57523a9e758dd4$var$isPixelChangingOptionList;
$ad57523a9e758dd4$exports.detectLineDelimiter = $ad57523a9e758dd4$var$detectLineDelimiter;
$ad57523a9e758dd4$exports.isNodeContainedBy = $ad57523a9e758dd4$var$isNodeContainedBy;
$ad57523a9e758dd4$exports.pow = $ad57523a9e758dd4$var$pow;
$ad57523a9e758dd4$exports.toRGB_ = $ad57523a9e758dd4$var$toRGB_;
$ad57523a9e758dd4$exports.isCanvasSupported = $ad57523a9e758dd4$var$isCanvasSupported;
$ad57523a9e758dd4$exports.parseFloat_ = $ad57523a9e758dd4$var$parseFloat_;
$ad57523a9e758dd4$exports.numberValueFormatter = $ad57523a9e758dd4$var$numberValueFormatter;
$ad57523a9e758dd4$exports.numberAxisLabelFormatter = $ad57523a9e758dd4$var$numberAxisLabelFormatter;
$ad57523a9e758dd4$exports.dateAxisLabelFormatter = $ad57523a9e758dd4$var$dateAxisLabelFormatter;
$ad57523a9e758dd4$exports.dateValueFormatter = $ad57523a9e758dd4$var$dateValueFormatter;
function $ad57523a9e758dd4$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj["default"] = obj;
        return newObj;
    }
}
var $c566217f290f99d9$exports = {};
/**
 * @license
 * Copyright 2011 Dan Vanderkam (danvdk@gmail.com)
 * MIT-licensed (http://opensource.org/licenses/MIT)
 */ /**
 * @fileoverview Description of this file.
 * @author danvk@google.com (Dan Vanderkam)
 *
 * A ticker is a function with the following interface:
 *
 * function(a, b, pixels, options_view, dygraph, forced_values);
 * -> [ { v: tick1_v, label: tick1_label[, label_v: label_v1] },
 *      { v: tick2_v, label: tick2_label[, label_v: label_v2] },
 *      ...
 *    ]
 *
 * The returned value is called a "tick list".
 *
 * Arguments
 * ---------
 *
 * [a, b] is the range of the axis for which ticks are being generated. For a
 * numeric axis, these will simply be numbers. For a date axis, these will be
 * millis since epoch (convertable to Date objects using "new Date(a)" and "new
 * Date(b)").
 *
 * opts provides access to chart- and axis-specific options. It can be used to
 * access number/date formatting code/options, check for a log scale, etc.
 *
 * pixels is the length of the axis in pixels. opts('pixelsPerLabel') is the
 * minimum amount of space to be allotted to each label. For instance, if
 * pixels=400 and opts('pixelsPerLabel')=40 then the ticker should return
 * between zero and ten (400/40) ticks.
 *
 * dygraph is the Dygraph object for which an axis is being constructed.
 *
 * forced_values is used for secondary y-axes. The tick positions are typically
 * set by the primary y-axis, so the secondary y-axis has no choice in where to
 * put these. It simply has to generate labels for these data values.
 *
 * Tick lists
 * ----------
 * Typically a tick will have both a grid/tick line and a label at one end of
 * that line (at the bottom for an x-axis, at left or right for the y-axis).
 *
 * A tick may be missing one of these two components:
 * - If "label_v" is specified instead of "v", then there will be no tick or
 *   gridline, just a label.
 * - Similarly, if "label" is not specified, then there will be a gridline
 *   without a label.
 *
 * This flexibility is useful in a few situations:
 * - For log scales, some of the tick lines may be too close to all have labels.
 * - For date scales where years are being displayed, it is desirable to display
 *   tick marks at the beginnings of years but labels (e.g. "2006") in the
 *   middle of the years.
 */ /*jshint sub:true */ /*global Dygraph:false */ "use strict";
Object.defineProperty($c566217f290f99d9$exports, '__esModule', {
    value: true
});
function $c566217f290f99d9$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj['default'] = obj;
        return newObj;
    }
}

var $c566217f290f99d9$var$utils = $c566217f290f99d9$var$_interopRequireWildcard($ad57523a9e758dd4$exports);
/** @typedef {Array.<{v:number, label:string, label_v:(string|undefined)}>} */ var $c566217f290f99d9$var$TickList = undefined; // the ' = undefined' keeps jshint happy.
/** @typedef {function(
 *    number,
 *    number,
 *    number,
 *    function(string):*,
 *    Dygraph=,
 *    Array.<number>=
 *  ): TickList}
 */ var $c566217f290f99d9$var$Ticker = undefined; // the ' = undefined' keeps jshint happy.
/** @type {Ticker} */ var $c566217f290f99d9$var$numericLinearTicks = function numericLinearTicks(a, b, pixels, opts, dygraph, vals) {
    var nonLogscaleOpts = function nonLogscaleOpts(opt) {
        if (opt === 'logscale') return false;
        return opts(opt);
    };
    return $c566217f290f99d9$var$numericTicks(a, b, pixels, nonLogscaleOpts, dygraph, vals);
};
$c566217f290f99d9$exports.numericLinearTicks = $c566217f290f99d9$var$numericLinearTicks;
/** @type {Ticker} */ var $c566217f290f99d9$var$numericTicks = function numericTicks(a, b, pixels, opts, dygraph, vals) {
    var pixels_per_tick = /** @type{number} */ opts('pixelsPerLabel');
    var ticks = [];
    var i, j, tickV, nTicks;
    if (vals) for(i = 0; i < vals.length; i++)ticks.push({
        v: vals[i]
    });
    else {
        // TODO(danvk): factor this log-scale block out into a separate function.
        if (opts("logscale")) {
            nTicks = Math.floor(pixels / pixels_per_tick);
            var minIdx = $c566217f290f99d9$var$utils.binarySearch(a, $c566217f290f99d9$var$PREFERRED_LOG_TICK_VALUES, 1);
            var maxIdx = $c566217f290f99d9$var$utils.binarySearch(b, $c566217f290f99d9$var$PREFERRED_LOG_TICK_VALUES, -1);
            if (minIdx == -1) minIdx = 0;
            if (maxIdx == -1) maxIdx = $c566217f290f99d9$var$PREFERRED_LOG_TICK_VALUES.length - 1;
            // Count the number of tick values would appear, if we can get at least
            // nTicks / 4 accept them.
            var lastDisplayed = null;
            if (maxIdx - minIdx >= nTicks / 4) {
                for(var idx = maxIdx; idx >= minIdx; idx--){
                    var tickValue = $c566217f290f99d9$var$PREFERRED_LOG_TICK_VALUES[idx];
                    var pixel_coord = Math.log(tickValue / a) / Math.log(b / a) * pixels;
                    var tick = {
                        v: tickValue
                    };
                    if (lastDisplayed === null) lastDisplayed = {
                        tickValue: tickValue,
                        pixel_coord: pixel_coord
                    };
                    else if (Math.abs(pixel_coord - lastDisplayed.pixel_coord) >= pixels_per_tick) lastDisplayed = {
                        tickValue: tickValue,
                        pixel_coord: pixel_coord
                    };
                    else tick.label = "";
                    ticks.push(tick);
                }
                // Since we went in backwards order.
                ticks.reverse();
            }
        }
        // ticks.length won't be 0 if the log scale function finds values to insert.
        if (ticks.length === 0) {
            // Basic idea:
            // Try labels every 1, 2, 5, 10, 20, 50, 100, etc.
            // Calculate the resulting tick spacing (i.e. this.height_ / nTicks).
            // The first spacing greater than pixelsPerYLabel is what we use.
            // TODO(danvk): version that works on a log scale.
            var kmg2 = opts("labelsKMG2");
            var mults, base;
            if (kmg2) {
                mults = [
                    1,
                    2,
                    4,
                    8,
                    16,
                    32,
                    64,
                    128,
                    256
                ];
                base = 16;
            } else {
                mults = [
                    1,
                    2,
                    5,
                    10,
                    20,
                    50,
                    100
                ];
                base = 10;
            }
            // Get the maximum number of permitted ticks based on the
            // graph's pixel size and pixels_per_tick setting.
            var max_ticks = Math.ceil(pixels / pixels_per_tick);
            // Now calculate the data unit equivalent of this tick spacing.
            // Use abs() since graphs may have a reversed Y axis.
            var units_per_tick = Math.abs(b - a) / max_ticks;
            // Based on this, get a starting scale which is the largest
            // integer power of the chosen base (10 or 16) that still remains
            // below the requested pixels_per_tick spacing.
            var base_power = Math.floor(Math.log(units_per_tick) / Math.log(base));
            var base_scale = Math.pow(base, base_power);
            // Now try multiples of the starting scale until we find one
            // that results in tick marks spaced sufficiently far apart.
            // The "mults" array should cover the range 1 .. base^2 to
            // adjust for rounding and edge effects.
            var scale, low_val, high_val, spacing;
            for(j = 0; j < mults.length; j++){
                scale = base_scale * mults[j];
                low_val = Math.floor(a / scale) * scale;
                high_val = Math.ceil(b / scale) * scale;
                nTicks = Math.abs(high_val - low_val) / scale;
                spacing = pixels / nTicks;
                if (spacing > pixels_per_tick) break;
            }
            // Construct the set of ticks.
            // Allow reverse y-axis if it's explicitly requested.
            if (low_val > high_val) scale *= -1;
            for(i = 0; i <= nTicks; i++){
                tickV = low_val + i * scale;
                ticks.push({
                    v: tickV
                });
            }
        }
    }
    var formatter = /**@type{AxisLabelFormatter}*/ opts('axisLabelFormatter');
    // Add labels to the ticks.
    for(i = 0; i < ticks.length; i++){
        if (ticks[i].label !== undefined) continue; // Use current label.
        // TODO(danvk): set granularity to something appropriate here.
        ticks[i].label = formatter.call(dygraph, ticks[i].v, 0, opts, dygraph);
    }
    return ticks;
};
$c566217f290f99d9$exports.numericTicks = $c566217f290f99d9$var$numericTicks;
/** @type {Ticker} */ var $c566217f290f99d9$var$dateTicker = function dateTicker(a, b, pixels, opts, dygraph, vals) {
    var chosen = $c566217f290f99d9$var$pickDateTickGranularity(a, b, pixels, opts);
    if (chosen >= 0) return $c566217f290f99d9$var$getDateAxis(a, b, chosen, opts, dygraph);
    else // this can happen if self.width_ is zero.
    return [];
};
$c566217f290f99d9$exports.dateTicker = $c566217f290f99d9$var$dateTicker;
// Time granularity enumeration
var $c566217f290f99d9$var$Granularity = {
    MILLISECONDLY: 0,
    TWO_MILLISECONDLY: 1,
    FIVE_MILLISECONDLY: 2,
    TEN_MILLISECONDLY: 3,
    FIFTY_MILLISECONDLY: 4,
    HUNDRED_MILLISECONDLY: 5,
    FIVE_HUNDRED_MILLISECONDLY: 6,
    SECONDLY: 7,
    TWO_SECONDLY: 8,
    FIVE_SECONDLY: 9,
    TEN_SECONDLY: 10,
    THIRTY_SECONDLY: 11,
    MINUTELY: 12,
    TWO_MINUTELY: 13,
    FIVE_MINUTELY: 14,
    TEN_MINUTELY: 15,
    THIRTY_MINUTELY: 16,
    HOURLY: 17,
    TWO_HOURLY: 18,
    SIX_HOURLY: 19,
    DAILY: 20,
    TWO_DAILY: 21,
    WEEKLY: 22,
    MONTHLY: 23,
    QUARTERLY: 24,
    BIANNUAL: 25,
    ANNUAL: 26,
    DECADAL: 27,
    CENTENNIAL: 28,
    NUM_GRANULARITIES: 29
};
$c566217f290f99d9$exports.Granularity = $c566217f290f99d9$var$Granularity;
// Date components enumeration (in the order of the arguments in Date)
// TODO: make this an @enum
var $c566217f290f99d9$var$DateField = {
    DATEFIELD_Y: 0,
    DATEFIELD_M: 1,
    DATEFIELD_D: 2,
    DATEFIELD_HH: 3,
    DATEFIELD_MM: 4,
    DATEFIELD_SS: 5,
    DATEFIELD_MS: 6,
    NUM_DATEFIELDS: 7
};
/**
 * The value of datefield will start at an even multiple of "step", i.e.
 *   if datefield=SS and step=5 then the first tick will be on a multiple of 5s.
 *
 * For granularities <= HOURLY, ticks are generated every `spacing` ms.
 *
 * At coarser granularities, ticks are generated by incrementing `datefield` by
 *   `step`. In this case, the `spacing` value is only used to estimate the
 *   number of ticks. It should roughly correspond to the spacing between
 *   adjacent ticks.
 *
 * @type {Array.<{datefield:number, step:number, spacing:number}>}
 */ var $c566217f290f99d9$var$TICK_PLACEMENT = [];
$c566217f290f99d9$var$TICK_PLACEMENT[$c566217f290f99d9$var$Granularity.MILLISECONDLY] = {
    datefield: $c566217f290f99d9$var$DateField.DATEFIELD_MS,
    step: 1,
    spacing: 1
};
$c566217f290f99d9$var$TICK_PLACEMENT[$c566217f290f99d9$var$Granularity.TWO_MILLISECONDLY] = {
    datefield: $c566217f290f99d9$var$DateField.DATEFIELD_MS,
    step: 2,
    spacing: 2
};
$c566217f290f99d9$var$TICK_PLACEMENT[$c566217f290f99d9$var$Granularity.FIVE_MILLISECONDLY] = {
    datefield: $c566217f290f99d9$var$DateField.DATEFIELD_MS,
    step: 5,
    spacing: 5
};
$c566217f290f99d9$var$TICK_PLACEMENT[$c566217f290f99d9$var$Granularity.TEN_MILLISECONDLY] = {
    datefield: $c566217f290f99d9$var$DateField.DATEFIELD_MS,
    step: 10,
    spacing: 10
};
$c566217f290f99d9$var$TICK_PLACEMENT[$c566217f290f99d9$var$Granularity.FIFTY_MILLISECONDLY] = {
    datefield: $c566217f290f99d9$var$DateField.DATEFIELD_MS,
    step: 50,
    spacing: 50
};
$c566217f290f99d9$var$TICK_PLACEMENT[$c566217f290f99d9$var$Granularity.HUNDRED_MILLISECONDLY] = {
    datefield: $c566217f290f99d9$var$DateField.DATEFIELD_MS,
    step: 100,
    spacing: 100
};
$c566217f290f99d9$var$TICK_PLACEMENT[$c566217f290f99d9$var$Granularity.FIVE_HUNDRED_MILLISECONDLY] = {
    datefield: $c566217f290f99d9$var$DateField.DATEFIELD_MS,
    step: 500,
    spacing: 500
};
$c566217f290f99d9$var$TICK_PLACEMENT[$c566217f290f99d9$var$Granularity.SECONDLY] = {
    datefield: $c566217f290f99d9$var$DateField.DATEFIELD_SS,
    step: 1,
    spacing: 1000
};
$c566217f290f99d9$var$TICK_PLACEMENT[$c566217f290f99d9$var$Granularity.TWO_SECONDLY] = {
    datefield: $c566217f290f99d9$var$DateField.DATEFIELD_SS,
    step: 2,
    spacing: 2000
};
$c566217f290f99d9$var$TICK_PLACEMENT[$c566217f290f99d9$var$Granularity.FIVE_SECONDLY] = {
    datefield: $c566217f290f99d9$var$DateField.DATEFIELD_SS,
    step: 5,
    spacing: 5000
};
$c566217f290f99d9$var$TICK_PLACEMENT[$c566217f290f99d9$var$Granularity.TEN_SECONDLY] = {
    datefield: $c566217f290f99d9$var$DateField.DATEFIELD_SS,
    step: 10,
    spacing: 10000
};
$c566217f290f99d9$var$TICK_PLACEMENT[$c566217f290f99d9$var$Granularity.THIRTY_SECONDLY] = {
    datefield: $c566217f290f99d9$var$DateField.DATEFIELD_SS,
    step: 30,
    spacing: 30000
};
$c566217f290f99d9$var$TICK_PLACEMENT[$c566217f290f99d9$var$Granularity.MINUTELY] = {
    datefield: $c566217f290f99d9$var$DateField.DATEFIELD_MM,
    step: 1,
    spacing: 60000
};
$c566217f290f99d9$var$TICK_PLACEMENT[$c566217f290f99d9$var$Granularity.TWO_MINUTELY] = {
    datefield: $c566217f290f99d9$var$DateField.DATEFIELD_MM,
    step: 2,
    spacing: 120000
};
$c566217f290f99d9$var$TICK_PLACEMENT[$c566217f290f99d9$var$Granularity.FIVE_MINUTELY] = {
    datefield: $c566217f290f99d9$var$DateField.DATEFIELD_MM,
    step: 5,
    spacing: 300000
};
$c566217f290f99d9$var$TICK_PLACEMENT[$c566217f290f99d9$var$Granularity.TEN_MINUTELY] = {
    datefield: $c566217f290f99d9$var$DateField.DATEFIELD_MM,
    step: 10,
    spacing: 600000
};
$c566217f290f99d9$var$TICK_PLACEMENT[$c566217f290f99d9$var$Granularity.THIRTY_MINUTELY] = {
    datefield: $c566217f290f99d9$var$DateField.DATEFIELD_MM,
    step: 30,
    spacing: 1800000
};
$c566217f290f99d9$var$TICK_PLACEMENT[$c566217f290f99d9$var$Granularity.HOURLY] = {
    datefield: $c566217f290f99d9$var$DateField.DATEFIELD_HH,
    step: 1,
    spacing: 3600000
};
$c566217f290f99d9$var$TICK_PLACEMENT[$c566217f290f99d9$var$Granularity.TWO_HOURLY] = {
    datefield: $c566217f290f99d9$var$DateField.DATEFIELD_HH,
    step: 2,
    spacing: 7200000
};
$c566217f290f99d9$var$TICK_PLACEMENT[$c566217f290f99d9$var$Granularity.SIX_HOURLY] = {
    datefield: $c566217f290f99d9$var$DateField.DATEFIELD_HH,
    step: 6,
    spacing: 21600000
};
$c566217f290f99d9$var$TICK_PLACEMENT[$c566217f290f99d9$var$Granularity.DAILY] = {
    datefield: $c566217f290f99d9$var$DateField.DATEFIELD_D,
    step: 1,
    spacing: 86400000
};
$c566217f290f99d9$var$TICK_PLACEMENT[$c566217f290f99d9$var$Granularity.TWO_DAILY] = {
    datefield: $c566217f290f99d9$var$DateField.DATEFIELD_D,
    step: 2,
    spacing: 172800000
};
$c566217f290f99d9$var$TICK_PLACEMENT[$c566217f290f99d9$var$Granularity.WEEKLY] = {
    datefield: $c566217f290f99d9$var$DateField.DATEFIELD_D,
    step: 7,
    spacing: 604800000
};
$c566217f290f99d9$var$TICK_PLACEMENT[$c566217f290f99d9$var$Granularity.MONTHLY] = {
    datefield: $c566217f290f99d9$var$DateField.DATEFIELD_M,
    step: 1,
    spacing: 2629817280
}; // 1e3 * 60 * 60 * 24 * 365.2524 / 12
$c566217f290f99d9$var$TICK_PLACEMENT[$c566217f290f99d9$var$Granularity.QUARTERLY] = {
    datefield: $c566217f290f99d9$var$DateField.DATEFIELD_M,
    step: 3,
    spacing: 7889451840.000001
}; // 1e3 * 60 * 60 * 24 * 365.2524 / 4
$c566217f290f99d9$var$TICK_PLACEMENT[$c566217f290f99d9$var$Granularity.BIANNUAL] = {
    datefield: $c566217f290f99d9$var$DateField.DATEFIELD_M,
    step: 6,
    spacing: 15778903680.000002
}; // 1e3 * 60 * 60 * 24 * 365.2524 / 2
$c566217f290f99d9$var$TICK_PLACEMENT[$c566217f290f99d9$var$Granularity.ANNUAL] = {
    datefield: $c566217f290f99d9$var$DateField.DATEFIELD_Y,
    step: 1,
    spacing: 31557807360.000004
}; // 1e3 * 60 * 60 * 24 * 365.2524 * 1
$c566217f290f99d9$var$TICK_PLACEMENT[$c566217f290f99d9$var$Granularity.DECADAL] = {
    datefield: $c566217f290f99d9$var$DateField.DATEFIELD_Y,
    step: 10,
    spacing: 315578073600
}; // 1e3 * 60 * 60 * 24 * 365.2524 * 10
$c566217f290f99d9$var$TICK_PLACEMENT[$c566217f290f99d9$var$Granularity.CENTENNIAL] = {
    datefield: $c566217f290f99d9$var$DateField.DATEFIELD_Y,
    step: 100,
    spacing: 3155780736000
}; // 1e3 * 60 * 60 * 24 * 365.2524 * 100
/**
 * This is a list of human-friendly values at which to show tick marks on a log
 * scale. It is k * 10^n, where k=1..9 and n=-39..+39, so:
 * ..., 1, 2, 3, 4, 5, ..., 9, 10, 20, 30, ..., 90, 100, 200, 300, ...
 * NOTE: this assumes that utils.LOG_SCALE = 10.
 * @type {Array.<number>}
 */ var $c566217f290f99d9$var$PREFERRED_LOG_TICK_VALUES = function() {
    var vals = [];
    for(var power = -39; power <= 39; power++){
        var range = Math.pow(10, power);
        for(var mult = 1; mult <= 9; mult++){
            var val = range * mult;
            vals.push(val);
        }
    }
    return vals;
}();
/**
 * Determine the correct granularity of ticks on a date axis.
 *
 * @param {number} a Left edge of the chart (ms)
 * @param {number} b Right edge of the chart (ms)
 * @param {number} pixels Size of the chart in the relevant dimension (width).
 * @param {function(string):*} opts Function mapping from option name -&gt; value.
 * @return {number} The appropriate axis granularity for this chart. See the
 *     enumeration of possible values in dygraph-tickers.js.
 */ var $c566217f290f99d9$var$pickDateTickGranularity = function pickDateTickGranularity(a, b, pixels, opts) {
    var pixels_per_tick = /** @type{number} */ opts('pixelsPerLabel');
    for(var i = 0; i < $c566217f290f99d9$var$Granularity.NUM_GRANULARITIES; i++){
        var num_ticks = $c566217f290f99d9$var$numDateTicks(a, b, i);
        if (pixels / num_ticks >= pixels_per_tick) return i;
    }
    return -1;
};
/**
 * Compute the number of ticks on a date axis for a given granularity.
 * @param {number} start_time
 * @param {number} end_time
 * @param {number} granularity (one of the granularities enumerated above)
 * @return {number} (Approximate) number of ticks that would result.
 */ var $c566217f290f99d9$var$numDateTicks = function numDateTicks(start_time, end_time, granularity) {
    var spacing = $c566217f290f99d9$var$TICK_PLACEMENT[granularity].spacing;
    return Math.round(1.0 * (end_time - start_time) / spacing);
};
/**
 * Compute the positions and labels of ticks on a date axis for a given granularity.
 * @param {number} start_time
 * @param {number} end_time
 * @param {number} granularity (one of the granularities enumerated above)
 * @param {function(string):*} opts Function mapping from option name -&gt; value.
 * @param {Dygraph=} dg
 * @return {!TickList}
 */ var $c566217f290f99d9$var$getDateAxis = function getDateAxis(start_time, end_time, granularity, opts, dg) {
    var formatter = /** @type{AxisLabelFormatter} */ opts("axisLabelFormatter");
    var utc = opts("labelsUTC");
    var accessors = utc ? $c566217f290f99d9$var$utils.DateAccessorsUTC : $c566217f290f99d9$var$utils.DateAccessorsLocal;
    var datefield = $c566217f290f99d9$var$TICK_PLACEMENT[granularity].datefield;
    var step = $c566217f290f99d9$var$TICK_PLACEMENT[granularity].step;
    var spacing = $c566217f290f99d9$var$TICK_PLACEMENT[granularity].spacing;
    // Choose a nice tick position before the initial instant.
    // Currently, this code deals properly with the existent daily granularities:
    // DAILY (with step of 1) and WEEKLY (with step of 7 but specially handled).
    // Other daily granularities (say TWO_DAILY) should also be handled specially
    // by setting the start_date_offset to 0.
    var start_date = new Date(start_time);
    var date_array = [];
    date_array[$c566217f290f99d9$var$DateField.DATEFIELD_Y] = accessors.getFullYear(start_date);
    date_array[$c566217f290f99d9$var$DateField.DATEFIELD_M] = accessors.getMonth(start_date);
    date_array[$c566217f290f99d9$var$DateField.DATEFIELD_D] = accessors.getDate(start_date);
    date_array[$c566217f290f99d9$var$DateField.DATEFIELD_HH] = accessors.getHours(start_date);
    date_array[$c566217f290f99d9$var$DateField.DATEFIELD_MM] = accessors.getMinutes(start_date);
    date_array[$c566217f290f99d9$var$DateField.DATEFIELD_SS] = accessors.getSeconds(start_date);
    date_array[$c566217f290f99d9$var$DateField.DATEFIELD_MS] = accessors.getMilliseconds(start_date);
    var start_date_offset = date_array[datefield] % step;
    if (granularity == $c566217f290f99d9$var$Granularity.WEEKLY) // This will put the ticks on Sundays.
    start_date_offset = accessors.getDay(start_date);
    date_array[datefield] -= start_date_offset;
    for(var df = datefield + 1; df < $c566217f290f99d9$var$DateField.NUM_DATEFIELDS; df++)// The minimum value is 1 for the day of month, and 0 for all other fields.
    date_array[df] = df === $c566217f290f99d9$var$DateField.DATEFIELD_D ? 1 : 0;
    // Generate the ticks.
    // For granularities not coarser than HOURLY we use the fact that:
    //   the number of milliseconds between ticks is constant
    //   and equal to the defined spacing.
    // Otherwise we rely on the 'roll over' property of the Date functions:
    //   when some date field is set to a value outside of its logical range,
    //   the excess 'rolls over' the next (more significant) field.
    // However, when using local time with DST transitions,
    // there are dates that do not represent any time value at all
    // (those in the hour skipped at the 'spring forward'),
    // and the JavaScript engines usually return an equivalent value.
    // Hence we have to check that the date is properly increased at each step,
    // returning a date at a nice tick position.
    var ticks = [];
    var tick_date = accessors.makeDate.apply(null, date_array);
    var tick_time = tick_date.getTime();
    if (granularity <= $c566217f290f99d9$var$Granularity.HOURLY) {
        if (tick_time < start_time) {
            tick_time += spacing;
            tick_date = new Date(tick_time);
        }
        while(tick_time <= end_time){
            ticks.push({
                v: tick_time,
                label: formatter.call(dg, tick_date, granularity, opts, dg)
            });
            tick_time += spacing;
            tick_date = new Date(tick_time);
        }
    } else {
        if (tick_time < start_time) {
            date_array[datefield] += step;
            tick_date = accessors.makeDate.apply(null, date_array);
            tick_time = tick_date.getTime();
        }
        while(tick_time <= end_time){
            if (granularity >= $c566217f290f99d9$var$Granularity.DAILY || accessors.getHours(tick_date) % step === 0) ticks.push({
                v: tick_time,
                label: formatter.call(dg, tick_date, granularity, opts, dg)
            });
            date_array[datefield] += step;
            tick_date = accessors.makeDate.apply(null, date_array);
            tick_time = tick_date.getTime();
        }
    }
    return ticks;
};
$c566217f290f99d9$exports.getDateAxis = $c566217f290f99d9$var$getDateAxis;


var $ad57523a9e758dd4$var$DygraphTickers = $ad57523a9e758dd4$var$_interopRequireWildcard($c566217f290f99d9$exports);
var $ad57523a9e758dd4$var$LOG_SCALE = 10;
$ad57523a9e758dd4$exports.LOG_SCALE = $ad57523a9e758dd4$var$LOG_SCALE;
var $ad57523a9e758dd4$var$LN_TEN = Math.log($ad57523a9e758dd4$var$LOG_SCALE);
$ad57523a9e758dd4$exports.LN_TEN = $ad57523a9e758dd4$var$LN_TEN;
/**
 * @private
 * @param {number} x
 * @return {number}
 */ var $ad57523a9e758dd4$var$log10 = function log10(x) {
    return Math.log(x) / $ad57523a9e758dd4$var$LN_TEN;
};
$ad57523a9e758dd4$exports.log10 = $ad57523a9e758dd4$var$log10;
/**
 * @private
 * @param {number} r0
 * @param {number} r1
 * @param {number} pct
 * @return {number}
 */ var $ad57523a9e758dd4$var$logRangeFraction = function logRangeFraction(r0, r1, pct) {
    // Computing the inverse of toPercentXCoord. The function was arrived at with
    // the following steps:
    //
    // Original calcuation:
    // pct = (log(x) - log(xRange[0])) / (log(xRange[1]) - log(xRange[0])));
    //
    // Multiply both sides by the right-side denominator.
    // pct * (log(xRange[1] - log(xRange[0]))) = log(x) - log(xRange[0])
    //
    // add log(xRange[0]) to both sides
    // log(xRange[0]) + (pct * (log(xRange[1]) - log(xRange[0])) = log(x);
    //
    // Swap both sides of the equation,
    // log(x) = log(xRange[0]) + (pct * (log(xRange[1]) - log(xRange[0]))
    //
    // Use both sides as the exponent in 10^exp and we're done.
    // x = 10 ^ (log(xRange[0]) + (pct * (log(xRange[1]) - log(xRange[0])))
    var logr0 = $ad57523a9e758dd4$var$log10(r0);
    var logr1 = $ad57523a9e758dd4$var$log10(r1);
    var exponent = logr0 + pct * (logr1 - logr0);
    var value = Math.pow($ad57523a9e758dd4$var$LOG_SCALE, exponent);
    return value;
};
$ad57523a9e758dd4$exports.logRangeFraction = $ad57523a9e758dd4$var$logRangeFraction;
/** A dotted line stroke pattern. */ var $ad57523a9e758dd4$var$DOTTED_LINE = [
    2,
    2
];
$ad57523a9e758dd4$exports.DOTTED_LINE = $ad57523a9e758dd4$var$DOTTED_LINE;
/** A dashed line stroke pattern. */ var $ad57523a9e758dd4$var$DASHED_LINE = [
    7,
    3
];
$ad57523a9e758dd4$exports.DASHED_LINE = $ad57523a9e758dd4$var$DASHED_LINE;
/** A dot dash stroke pattern. */ var $ad57523a9e758dd4$var$DOT_DASH_LINE = [
    7,
    2,
    2,
    2
];
$ad57523a9e758dd4$exports.DOT_DASH_LINE = $ad57523a9e758dd4$var$DOT_DASH_LINE;
// Directions for panning and zooming. Use bit operations when combined
// values are possible.
var $ad57523a9e758dd4$var$HORIZONTAL = 1;
$ad57523a9e758dd4$exports.HORIZONTAL = $ad57523a9e758dd4$var$HORIZONTAL;
var $ad57523a9e758dd4$var$VERTICAL = 2;
$ad57523a9e758dd4$exports.VERTICAL = $ad57523a9e758dd4$var$VERTICAL;
/**
 * Return the 2d context for a dygraph canvas.
 *
 * This method is only exposed for the sake of replacing the function in
 * automated tests.
 *
 * @param {!HTMLCanvasElement} canvas
 * @return {!CanvasRenderingContext2D}
 * @private
 */ var $ad57523a9e758dd4$var$getContext = function getContext(canvas) {
    return /** @type{!CanvasRenderingContext2D}*/ canvas.getContext("2d");
};
$ad57523a9e758dd4$exports.getContext = $ad57523a9e758dd4$var$getContext;
/**
 * Add an event handler.
 * @param {!Node} elem The element to add the event to.
 * @param {string} type The type of the event, e.g. 'click' or 'mousemove'.
 * @param {function(Event):(boolean|undefined)} fn The function to call
 *     on the event. The function takes one parameter: the event object.
 * @private
 */ var $ad57523a9e758dd4$var$addEvent = function addEvent(elem, type, fn) {
    elem.addEventListener(type, fn, false);
};
$ad57523a9e758dd4$exports.addEvent = $ad57523a9e758dd4$var$addEvent;
/**
 * Remove an event handler.
 * @param {!Node} elem The element to remove the event from.
 * @param {string} type The type of the event, e.g. 'click' or 'mousemove'.
 * @param {function(Event):(boolean|undefined)} fn The function to call
 *     on the event. The function takes one parameter: the event object.
 */ function $ad57523a9e758dd4$var$removeEvent(elem, type, fn) {
    elem.removeEventListener(type, fn, false);
}
/**
 * Cancels further processing of an event. This is useful to prevent default
 * browser actions, e.g. highlighting text on a double-click.
 * Based on the article at
 * http://www.switchonthecode.com/tutorials/javascript-tutorial-the-scroll-wheel
 * @param {!Event} e The event whose normal behavior should be canceled.
 * @private
 */ function $ad57523a9e758dd4$var$cancelEvent(e) {
    e = e ? e : window.event;
    if (e.stopPropagation) e.stopPropagation();
    if (e.preventDefault) e.preventDefault();
    e.cancelBubble = true;
    e.cancel = true;
    e.returnValue = false;
    return false;
}
/**
 * Convert hsv values to an rgb(r,g,b) string. Taken from MochiKit.Color. This
 * is used to generate default series colors which are evenly spaced on the
 * color wheel.
 * @param { number } hue Range is 0.0-1.0.
 * @param { number } saturation Range is 0.0-1.0.
 * @param { number } value Range is 0.0-1.0.
 * @return { string } "rgb(r,g,b)" where r, g and b range from 0-255.
 * @private
 */ function $ad57523a9e758dd4$var$hsvToRGB(hue, saturation, value) {
    var red;
    var green;
    var blue;
    if (saturation === 0) {
        red = value;
        green = value;
        blue = value;
    } else {
        var i = Math.floor(hue * 6);
        var f = hue * 6 - i;
        var p = value * (1 - saturation);
        var q = value * (1 - saturation * f);
        var t = value * (1 - saturation * (1 - f));
        switch(i){
            case 1:
                red = q;
                green = value;
                blue = p;
                break;
            case 2:
                red = p;
                green = value;
                blue = t;
                break;
            case 3:
                red = p;
                green = q;
                blue = value;
                break;
            case 4:
                red = t;
                green = p;
                blue = value;
                break;
            case 5:
                red = value;
                green = p;
                blue = q;
                break;
            case 6:
            case 0:
                red = value;
                green = t;
                blue = p;
                break;
        }
    }
    red = Math.floor(255 * red + 0.5);
    green = Math.floor(255 * green + 0.5);
    blue = Math.floor(255 * blue + 0.5);
    return 'rgb(' + red + ',' + green + ',' + blue + ')';
}
/**
 * Find the coordinates of an object relative to the top left of the page.
 *
 * @param {Node} obj
 * @return {{x:number,y:number}}
 * @private
 */ function $ad57523a9e758dd4$var$findPos(obj) {
    var p = obj.getBoundingClientRect(), w = window, d = document.documentElement;
    return {
        x: p.left + (w.pageXOffset || d.scrollLeft),
        y: p.top + (w.pageYOffset || d.scrollTop)
    };
}
/**
 * Returns the x-coordinate of the event in a coordinate system where the
 * top-left corner of the page (not the window) is (0,0).
 * Taken from MochiKit.Signal
 * @param {!Event} e
 * @return {number}
 * @private
 */ function $ad57523a9e758dd4$var$pageX(e) {
    return !e.pageX || e.pageX < 0 ? 0 : e.pageX;
}
/**
 * Returns the y-coordinate of the event in a coordinate system where the
 * top-left corner of the page (not the window) is (0,0).
 * Taken from MochiKit.Signal
 * @param {!Event} e
 * @return {number}
 * @private
 */ function $ad57523a9e758dd4$var$pageY(e) {
    return !e.pageY || e.pageY < 0 ? 0 : e.pageY;
}
/**
 * Converts page the x-coordinate of the event to pixel x-coordinates on the
 * canvas (i.e. DOM Coords).
 * @param {!Event} e Drag event.
 * @param {!DygraphInteractionContext} context Interaction context object.
 * @return {number} The amount by which the drag has moved to the right.
 */ function $ad57523a9e758dd4$var$dragGetX_(e, context) {
    return $ad57523a9e758dd4$var$pageX(e) - context.px;
}
/**
 * Converts page the y-coordinate of the event to pixel y-coordinates on the
 * canvas (i.e. DOM Coords).
 * @param {!Event} e Drag event.
 * @param {!DygraphInteractionContext} context Interaction context object.
 * @return {number} The amount by which the drag has moved down.
 */ function $ad57523a9e758dd4$var$dragGetY_(e, context) {
    return $ad57523a9e758dd4$var$pageY(e) - context.py;
}
/**
 * This returns true unless the parameter is 0, null, undefined or NaN.
 * TODO(danvk): rename this function to something like 'isNonZeroNan'.
 *
 * @param {number} x The number to consider.
 * @return {boolean} Whether the number is zero or NaN.
 * @private
 */ function $ad57523a9e758dd4$var$isOK(x) {
    return !!x && !isNaN(x);
}
/**
 * @param {{x:?number,y:?number,yval:?number}} p The point to consider, valid
 *     points are {x, y} objects
 * @param {boolean=} opt_allowNaNY Treat point with y=NaN as valid
 * @return {boolean} Whether the point has numeric x and y.
 * @private
 */ function $ad57523a9e758dd4$var$isValidPoint(p, opt_allowNaNY) {
    if (!p) return false; // null or undefined object
    if (p.yval === null) return false; // missing point
    if (p.x === null || p.x === undefined) return false;
    if (p.y === null || p.y === undefined) return false;
    if (isNaN(p.x) || !opt_allowNaNY && isNaN(p.y)) return false;
    return true;
}
/**
 * Number formatting function which mimics the behavior of %g in printf, i.e.
 * either exponential or fixed format (without trailing 0s) is used depending on
 * the length of the generated string.  The advantage of this format is that
 * there is a predictable upper bound on the resulting string length,
 * significant figures are not dropped, and normal numbers are not displayed in
 * exponential notation.
 *
 * NOTE: JavaScript's native toPrecision() is NOT a drop-in replacement for %g.
 * It creates strings which are too long for absolute values between 10^-4 and
 * 10^-6, e.g. '0.00001' instead of '1e-5'. See tests/number-format.html for
 * output examples.
 *
 * @param {number} x The number to format
 * @param {number=} opt_precision The precision to use, default 2.
 * @return {string} A string formatted like %g in printf.  The max generated
 *                  string length should be precision + 6 (e.g 1.123e+300).
 */ function $ad57523a9e758dd4$var$floatFormat(x, opt_precision) {
    // Avoid invalid precision values; [1, 21] is the valid range.
    var p = Math.min(Math.max(1, opt_precision || 2), 21);
    // This is deceptively simple.  The actual algorithm comes from:
    //
    // Max allowed length = p + 4
    // where 4 comes from 'e+n' and '.'.
    //
    // Length of fixed format = 2 + y + p
    // where 2 comes from '0.' and y = # of leading zeroes.
    //
    // Equating the two and solving for y yields y = 2, or 0.00xxxx which is
    // 1.0e-3.
    //
    // Since the behavior of toPrecision() is identical for larger numbers, we
    // don't have to worry about the other bound.
    //
    // Finally, the argument for toExponential() is the number of trailing digits,
    // so we take off 1 for the value before the '.'.
    return Math.abs(x) < 1.0e-3 && x !== 0.0 ? x.toExponential(p - 1) : x.toPrecision(p);
}
/**
 * Converts '9' to '09' (useful for dates)
 * @param {number} x
 * @return {string}
 * @private
 */ function $ad57523a9e758dd4$var$zeropad(x) {
    if (x < 10) return "0" + x;
    else return "" + x;
}
/**
 * Date accessors to get the parts of a calendar date (year, month,
 * day, hour, minute, second and millisecond) according to local time,
 * and factory method to call the Date constructor with an array of arguments.
 */ var $ad57523a9e758dd4$var$DateAccessorsLocal = {
    getFullYear: function getFullYear(d) {
        return d.getFullYear();
    },
    getMonth: function getMonth(d) {
        return d.getMonth();
    },
    getDate: function getDate(d) {
        return d.getDate();
    },
    getHours: function getHours(d) {
        return d.getHours();
    },
    getMinutes: function getMinutes(d) {
        return d.getMinutes();
    },
    getSeconds: function getSeconds(d) {
        return d.getSeconds();
    },
    getMilliseconds: function getMilliseconds(d) {
        return d.getMilliseconds();
    },
    getDay: function getDay(d) {
        return d.getDay();
    },
    makeDate: function makeDate(y, m, d, hh, mm, ss, ms) {
        return new Date(y, m, d, hh, mm, ss, ms);
    }
};
$ad57523a9e758dd4$exports.DateAccessorsLocal = $ad57523a9e758dd4$var$DateAccessorsLocal;
/**
 * Date accessors to get the parts of a calendar date (year, month,
 * day of month, hour, minute, second and millisecond) according to UTC time,
 * and factory method to call the Date constructor with an array of arguments.
 */ var $ad57523a9e758dd4$var$DateAccessorsUTC = {
    getFullYear: function getFullYear(d) {
        return d.getUTCFullYear();
    },
    getMonth: function getMonth(d) {
        return d.getUTCMonth();
    },
    getDate: function getDate(d) {
        return d.getUTCDate();
    },
    getHours: function getHours(d) {
        return d.getUTCHours();
    },
    getMinutes: function getMinutes(d) {
        return d.getUTCMinutes();
    },
    getSeconds: function getSeconds(d) {
        return d.getUTCSeconds();
    },
    getMilliseconds: function getMilliseconds(d) {
        return d.getUTCMilliseconds();
    },
    getDay: function getDay(d) {
        return d.getUTCDay();
    },
    makeDate: function makeDate(y, m, d, hh, mm, ss, ms) {
        return new Date(Date.UTC(y, m, d, hh, mm, ss, ms));
    }
};
$ad57523a9e758dd4$exports.DateAccessorsUTC = $ad57523a9e758dd4$var$DateAccessorsUTC;
/**
 * Return a string version of the hours, minutes and seconds portion of a date.
 * @param {number} hh The hours (from 0-23)
 * @param {number} mm The minutes (from 0-59)
 * @param {number} ss The seconds (from 0-59)
 * @return {string} A time of the form "HH:MM" or "HH:MM:SS"
 * @private
 */ function $ad57523a9e758dd4$var$hmsString_(hh, mm, ss, ms) {
    var ret = $ad57523a9e758dd4$var$zeropad(hh) + ":" + $ad57523a9e758dd4$var$zeropad(mm);
    if (ss) {
        ret += ":" + $ad57523a9e758dd4$var$zeropad(ss);
        if (ms) {
            var str = "" + ms;
            ret += "." + ('000' + str).substring(str.length);
        }
    }
    return ret;
}
/**
 * Convert a JS date (millis since epoch) to a formatted string.
 * @param {number} time The JavaScript time value (ms since epoch)
 * @param {boolean} utc Whether output UTC or local time
 * @return {string} A date of one of these forms:
 *     "YYYY/MM/DD", "YYYY/MM/DD HH:MM" or "YYYY/MM/DD HH:MM:SS"
 * @private
 */ function $ad57523a9e758dd4$var$dateString_(time, utc) {
    var accessors = utc ? $ad57523a9e758dd4$var$DateAccessorsUTC : $ad57523a9e758dd4$var$DateAccessorsLocal;
    var date = new Date(time);
    var y = accessors.getFullYear(date);
    var m = accessors.getMonth(date);
    var d = accessors.getDate(date);
    var hh = accessors.getHours(date);
    var mm = accessors.getMinutes(date);
    var ss = accessors.getSeconds(date);
    var ms = accessors.getMilliseconds(date);
    // Get a year string:
    var year = "" + y;
    // Get a 0 padded month string
    var month = $ad57523a9e758dd4$var$zeropad(m + 1); //months are 0-offset, sigh
    // Get a 0 padded day string
    var day = $ad57523a9e758dd4$var$zeropad(d);
    var frac = hh * 3600 + mm * 60 + ss + 1e-3 * ms;
    var ret = year + "/" + month + "/" + day;
    if (frac) ret += " " + $ad57523a9e758dd4$var$hmsString_(hh, mm, ss, ms);
    return ret;
}
/**
 * Round a number to the specified number of digits past the decimal point.
 * @param {number} num The number to round
 * @param {number} places The number of decimals to which to round
 * @return {number} The rounded number
 * @private
 */ function $ad57523a9e758dd4$var$round_(num, places) {
    var shift = Math.pow(10, places);
    return Math.round(num * shift) / shift;
}
/**
 * Implementation of binary search over an array.
 * Currently does not work when val is outside the range of arry's values.
 * @param {number} val the value to search for
 * @param {Array.<number>} arry is the value over which to search
 * @param {number} abs If abs > 0, find the lowest entry greater than val
 *     If abs < 0, find the highest entry less than val.
 *     If abs == 0, find the entry that equals val.
 * @param {number=} low The first index in arry to consider (optional)
 * @param {number=} high The last index in arry to consider (optional)
 * @return {number} Index of the element, or -1 if it isn't found.
 * @private
 */ function $ad57523a9e758dd4$var$binarySearch(_x, _x2, _x3, _x4, _x5) {
    var _again = true;
    _function: while(_again){
        var val = _x, arry = _x2, abs = _x3, low = _x4, high = _x5;
        _again = false;
        if (low === null || low === undefined || high === null || high === undefined) {
            low = 0;
            high = arry.length - 1;
        }
        if (low > high) return -1;
        if (abs === null || abs === undefined) abs = 0;
        var validIndex = function validIndex(idx) {
            return idx >= 0 && idx < arry.length;
        };
        var mid = parseInt((low + high) / 2, 10);
        var element = arry[mid];
        var idx;
        if (element == val) return mid;
        else if (element > val) {
            if (abs > 0) {
                // Accept if element > val, but also if prior element < val.
                idx = mid - 1;
                if (validIndex(idx) && arry[idx] < val) return mid;
            }
            _x = val;
            _x2 = arry;
            _x3 = abs;
            _x4 = low;
            _x5 = mid - 1;
            _again = true;
            validIndex = mid = element = idx = undefined;
            continue _function;
        } else if (element < val) {
            if (abs < 0) {
                // Accept if element < val, but also if prior element > val.
                idx = mid + 1;
                if (validIndex(idx) && arry[idx] > val) return mid;
            }
            _x = val;
            _x2 = arry;
            _x3 = abs;
            _x4 = mid + 1;
            _x5 = high;
            _again = true;
            validIndex = mid = element = idx = undefined;
            continue _function;
        }
        return -1; // can't actually happen, but makes closure compiler happy
    }
}
/**
 * Parses a date, returning the number of milliseconds since epoch. This can be
 * passed in as an xValueParser in the Dygraph constructor.
 * TODO(danvk): enumerate formats that this understands.
 *
 * @param {string} dateStr A date in a variety of possible string formats.
 * @return {number} Milliseconds since epoch.
 * @private
 */ function $ad57523a9e758dd4$var$dateParser(dateStr) {
    var dateStrSlashed;
    var d;
    // Let the system try the format first, with one caveat:
    // YYYY-MM-DD[ HH:MM:SS] is interpreted as UTC by a variety of browsers.
    // dygraphs displays dates in local time, so this will result in surprising
    // inconsistencies. But if you specify "T" or "Z" (i.e. YYYY-MM-DDTHH:MM:SS),
    // then you probably know what you're doing, so we'll let you go ahead.
    // Issue: http://code.google.com/p/dygraphs/issues/detail?id=255
    if (dateStr.search("-") == -1 || dateStr.search("T") != -1 || dateStr.search("Z") != -1) {
        d = $ad57523a9e758dd4$var$dateStrToMillis(dateStr);
        if (d && !isNaN(d)) return d;
    }
    if (dateStr.search("-") != -1) {
        // e.g. '2009-7-12' or '2009-07-12'
        dateStrSlashed = dateStr.replace("-", "/", "g");
        while(dateStrSlashed.search("-") != -1)dateStrSlashed = dateStrSlashed.replace("-", "/");
        d = $ad57523a9e758dd4$var$dateStrToMillis(dateStrSlashed);
    } else if (dateStr.length == 8) {
        // e.g. '20090712'
        // TODO(danvk): remove support for this format. It's confusing.
        dateStrSlashed = dateStr.substr(0, 4) + "/" + dateStr.substr(4, 2) + "/" + dateStr.substr(6, 2);
        d = $ad57523a9e758dd4$var$dateStrToMillis(dateStrSlashed);
    } else // Any format that Date.parse will accept, e.g. "2009/07/12" or
    // "2009/07/12 12:34:56"
    d = $ad57523a9e758dd4$var$dateStrToMillis(dateStr);
    if (!d || isNaN(d)) console.error("Couldn't parse " + dateStr + " as a date");
    return d;
}
/**
 * This is identical to JavaScript's built-in Date.parse() method, except that
 * it doesn't get replaced with an incompatible method by aggressive JS
 * libraries like MooTools or Joomla.
 * @param {string} str The date string, e.g. "2011/05/06"
 * @return {number} millis since epoch
 * @private
 */ function $ad57523a9e758dd4$var$dateStrToMillis(str) {
    return new Date(str).getTime();
}
// These functions are all based on MochiKit.
/**
 * Copies all the properties from o to self.
 *
 * @param {!Object} self
 * @param {!Object} o
 * @return {!Object}
 */ function $ad57523a9e758dd4$var$update(self, o) {
    if (typeof o != 'undefined' && o !== null) {
        for(var k in o)if (o.hasOwnProperty(k)) self[k] = o[k];
    }
    return self;
}
/**
 * Copies all the properties from o to self.
 *
 * @param {!Object} self
 * @param {!Object} o
 * @return {!Object}
 * @private
 */ function $ad57523a9e758dd4$var$updateDeep(self, o) {
    // Taken from http://stackoverflow.com/questions/384286/javascript-isdom-how-do-you-check-if-a-javascript-object-is-a-dom-object
    function isNode(o) {
        return typeof Node === "object" ? o instanceof Node : typeof o === "object" && typeof o.nodeType === "number" && typeof o.nodeName === "string";
    }
    if (typeof o != 'undefined' && o !== null) {
        for(var k in o)if (o.hasOwnProperty(k)) {
            if (o[k] === null) self[k] = null;
            else if ($ad57523a9e758dd4$var$isArrayLike(o[k])) self[k] = o[k].slice();
            else if (isNode(o[k])) // DOM objects are shallowly-copied.
            self[k] = o[k];
            else if (typeof o[k] == 'object') {
                if (typeof self[k] != 'object' || self[k] === null) self[k] = {};
                $ad57523a9e758dd4$var$updateDeep(self[k], o[k]);
            } else self[k] = o[k];
        }
    }
    return self;
}
/**
 * @param {*} o
 * @return {boolean}
 * @private
 */ function $ad57523a9e758dd4$var$isArrayLike(o) {
    var typ = typeof o;
    if (typ != 'object' && !(typ == 'function' && typeof o.item == 'function') || o === null || typeof o.length != 'number' || o.nodeType === 3) return false;
    return true;
}
/**
 * @param {Object} o
 * @return {boolean}
 * @private
 */ function $ad57523a9e758dd4$var$isDateLike(o) {
    if (typeof o != "object" || o === null || typeof o.getTime != 'function') return false;
    return true;
}
/**
 * Note: this only seems to work for arrays.
 * @param {!Array} o
 * @return {!Array}
 * @private
 */ function $ad57523a9e758dd4$var$clone(o) {
    // TODO(danvk): figure out how MochiKit's version works
    var r = [];
    for(var i = 0; i < o.length; i++)if ($ad57523a9e758dd4$var$isArrayLike(o[i])) r.push($ad57523a9e758dd4$var$clone(o[i]));
    else r.push(o[i]);
    return r;
}
/**
 * Create a new canvas element.
 *
 * @return {!HTMLCanvasElement}
 * @private
 */ function $ad57523a9e758dd4$var$createCanvas() {
    return document.createElement('canvas');
}
/**
 * Returns the context's pixel ratio, which is the ratio between the device
 * pixel ratio and the backing store ratio. Typically this is 1 for conventional
 * displays, and > 1 for HiDPI displays (such as the Retina MBP).
 * See http://www.html5rocks.com/en/tutorials/canvas/hidpi/ for more details.
 *
 * @param {!CanvasRenderingContext2D} context The canvas's 2d context.
 * @return {number} The ratio of the device pixel ratio and the backing store
 * ratio for the specified context.
 */ function $ad57523a9e758dd4$var$getContextPixelRatio(context) {
    try {
        var devicePixelRatio = window.devicePixelRatio;
        var backingStoreRatio = context.webkitBackingStorePixelRatio || context.mozBackingStorePixelRatio || context.msBackingStorePixelRatio || context.oBackingStorePixelRatio || context.backingStorePixelRatio || 1;
        if (devicePixelRatio !== undefined) return devicePixelRatio / backingStoreRatio;
        else // At least devicePixelRatio must be defined for this ratio to make sense.
        // We default backingStoreRatio to 1: this does not exist on some browsers
        // (i.e. desktop Chrome).
        return 1;
    } catch (e) {
        return 1;
    }
}
/**
 * TODO(danvk): use @template here when it's better supported for classes.
 * @param {!Array} array
 * @param {number} start
 * @param {number} length
 * @param {function(!Array,?):boolean=} predicate
 * @constructor
 */ function $ad57523a9e758dd4$var$Iterator(array, start, length, predicate) {
    start = start || 0;
    length = length || array.length;
    this.hasNext = true; // Use to identify if there's another element.
    this.peek = null; // Use for look-ahead
    this.start_ = start;
    this.array_ = array;
    this.predicate_ = predicate;
    this.end_ = Math.min(array.length, start + length);
    this.nextIdx_ = start - 1; // use -1 so initial advance works.
    this.next(); // ignoring result.
}
/**
 * @return {Object}
 */ $ad57523a9e758dd4$var$Iterator.prototype.next = function() {
    if (!this.hasNext) return null;
    var obj = this.peek;
    var nextIdx = this.nextIdx_ + 1;
    var found = false;
    while(nextIdx < this.end_){
        if (!this.predicate_ || this.predicate_(this.array_, nextIdx)) {
            this.peek = this.array_[nextIdx];
            found = true;
            break;
        }
        nextIdx++;
    }
    this.nextIdx_ = nextIdx;
    if (!found) {
        this.hasNext = false;
        this.peek = null;
    }
    return obj;
};
/**
 * Returns a new iterator over array, between indexes start and
 * start + length, and only returns entries that pass the accept function
 *
 * @param {!Array} array the array to iterate over.
 * @param {number} start the first index to iterate over, 0 if absent.
 * @param {number} length the number of elements in the array to iterate over.
 *     This, along with start, defines a slice of the array, and so length
 *     doesn't imply the number of elements in the iterator when accept doesn't
 *     always accept all values. array.length when absent.
 * @param {function(?):boolean=} opt_predicate a function that takes
 *     parameters array and idx, which returns true when the element should be
 *     returned.  If omitted, all elements are accepted.
 * @private
 */ function $ad57523a9e758dd4$var$createIterator(array, start, length, opt_predicate) {
    return new $ad57523a9e758dd4$var$Iterator(array, start, length, opt_predicate);
}
// Shim layer with setTimeout fallback.
// From: http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// Should be called with the window context:
//   Dygraph.requestAnimFrame.call(window, function() {})
var $ad57523a9e758dd4$var$requestAnimFrame = function() {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function(callback) {
        window.setTimeout(callback, 1000 / 60);
    };
}();
$ad57523a9e758dd4$exports.requestAnimFrame = $ad57523a9e758dd4$var$requestAnimFrame;
/**
 * Call a function at most maxFrames times at an attempted interval of
 * framePeriodInMillis, then call a cleanup function once. repeatFn is called
 * once immediately, then at most (maxFrames - 1) times asynchronously. If
 * maxFrames==1, then cleanup_fn() is also called synchronously.  This function
 * is used to sequence animation.
 * @param {function(number)} repeatFn Called repeatedly -- takes the frame
 *     number (from 0 to maxFrames-1) as an argument.
 * @param {number} maxFrames The max number of times to call repeatFn
 * @param {number} framePeriodInMillis Max requested time between frames.
 * @param {function()} cleanupFn A function to call after all repeatFn calls.
 * @private
 */ function $ad57523a9e758dd4$var$repeatAndCleanup(repeatFn, maxFrames, framePeriodInMillis, cleanupFn) {
    var frameNumber = 0;
    var previousFrameNumber;
    var startTime = new Date().getTime();
    repeatFn(frameNumber);
    if (maxFrames == 1) {
        cleanupFn();
        return;
    }
    var maxFrameArg = maxFrames - 1;
    (function loop() {
        if (frameNumber >= maxFrames) return;
        $ad57523a9e758dd4$var$requestAnimFrame.call(window, function() {
            // Determine which frame to draw based on the delay so far.  Will skip
            // frames if necessary.
            var currentTime = new Date().getTime();
            var delayInMillis = currentTime - startTime;
            previousFrameNumber = frameNumber;
            frameNumber = Math.floor(delayInMillis / framePeriodInMillis);
            var frameDelta = frameNumber - previousFrameNumber;
            // If we predict that the subsequent repeatFn call will overshoot our
            // total frame target, so our last call will cause a stutter, then jump to
            // the last call immediately.  If we're going to cause a stutter, better
            // to do it faster than slower.
            var predictOvershootStutter = frameNumber + frameDelta > maxFrameArg;
            if (predictOvershootStutter || frameNumber >= maxFrameArg) {
                repeatFn(maxFrameArg); // Ensure final call with maxFrameArg.
                cleanupFn();
            } else {
                if (frameDelta !== 0) // Don't call repeatFn with duplicate frames.
                repeatFn(frameNumber);
                loop();
            }
        });
    })();
}
// A whitelist of options that do not change pixel positions.
var $ad57523a9e758dd4$var$pixelSafeOptions = {
    'annotationClickHandler': true,
    'annotationDblClickHandler': true,
    'annotationMouseOutHandler': true,
    'annotationMouseOverHandler': true,
    'axisLineColor': true,
    'axisLineWidth': true,
    'clickCallback': true,
    'drawCallback': true,
    'drawHighlightPointCallback': true,
    'drawPoints': true,
    'drawPointCallback': true,
    'drawGrid': true,
    'fillAlpha': true,
    'gridLineColor': true,
    'gridLineWidth': true,
    'hideOverlayOnMouseOut': true,
    'highlightCallback': true,
    'highlightCircleSize': true,
    'interactionModel': true,
    'labelsDiv': true,
    'labelsKMB': true,
    'labelsKMG2': true,
    'labelsSeparateLines': true,
    'labelsShowZeroValues': true,
    'legend': true,
    'panEdgeFraction': true,
    'pixelsPerYLabel': true,
    'pointClickCallback': true,
    'pointSize': true,
    'rangeSelectorPlotFillColor': true,
    'rangeSelectorPlotFillGradientColor': true,
    'rangeSelectorPlotStrokeColor': true,
    'rangeSelectorBackgroundStrokeColor': true,
    'rangeSelectorBackgroundLineWidth': true,
    'rangeSelectorPlotLineWidth': true,
    'rangeSelectorForegroundStrokeColor': true,
    'rangeSelectorForegroundLineWidth': true,
    'rangeSelectorAlpha': true,
    'showLabelsOnHighlight': true,
    'showRoller': true,
    'strokeWidth': true,
    'underlayCallback': true,
    'unhighlightCallback': true,
    'zoomCallback': true
};
/**
 * This function will scan the option list and determine if they
 * require us to recalculate the pixel positions of each point.
 * TODO: move this into dygraph-options.js
 * @param {!Array.<string>} labels a list of options to check.
 * @param {!Object} attrs
 * @return {boolean} true if the graph needs new points else false.
 * @private
 */ function $ad57523a9e758dd4$var$isPixelChangingOptionList(labels, attrs) {
    // Assume that we do not require new points.
    // This will change to true if we actually do need new points.
    // Create a dictionary of series names for faster lookup.
    // If there are no labels, then the dictionary stays empty.
    var seriesNamesDictionary = {};
    if (labels) for(var i = 1; i < labels.length; i++)seriesNamesDictionary[labels[i]] = true;
    // Scan through a flat (i.e. non-nested) object of options.
    // Returns true/false depending on whether new points are needed.
    var scanFlatOptions = function scanFlatOptions(options) {
        for(var property in options){
            if (options.hasOwnProperty(property) && !$ad57523a9e758dd4$var$pixelSafeOptions[property]) return true;
        }
        return false;
    };
    // Iterate through the list of updated options.
    for(var property in attrs){
        if (!attrs.hasOwnProperty(property)) continue;
        // Find out of this field is actually a series specific options list.
        if (property == 'highlightSeriesOpts' || seriesNamesDictionary[property] && !attrs.series) {
            // This property value is a list of options for this series.
            if (scanFlatOptions(attrs[property])) return true;
        } else if (property == 'series' || property == 'axes') {
            // This is twice-nested options list.
            var perSeries = attrs[property];
            for(var series in perSeries){
                if (perSeries.hasOwnProperty(series) && scanFlatOptions(perSeries[series])) return true;
            }
        } else {
            // If this was not a series specific option list, check if it's a pixel
            // changing property.
            if (!$ad57523a9e758dd4$var$pixelSafeOptions[property]) return true;
        }
    }
    return false;
}
var $ad57523a9e758dd4$var$Circles = {
    DEFAULT: function DEFAULT(g, name, ctx, canvasx, canvasy, color, radius) {
        ctx.beginPath();
        ctx.fillStyle = color;
        ctx.arc(canvasx, canvasy, radius, 0, 2 * Math.PI, false);
        ctx.fill();
    }
};
$ad57523a9e758dd4$exports.Circles = $ad57523a9e758dd4$var$Circles;
/**
 * Determine whether |data| is delimited by CR, CRLF, LF, LFCR.
 * @param {string} data
 * @return {?string} the delimiter that was detected (or null on failure).
 */ function $ad57523a9e758dd4$var$detectLineDelimiter(data) {
    for(var i = 0; i < data.length; i++){
        var code = data.charAt(i);
        if (code === '\r') {
            // Might actually be "\r\n".
            if (i + 1 < data.length && data.charAt(i + 1) === '\n') return '\r\n';
            return code;
        }
        if (code === '\n') {
            // Might actually be "\n\r".
            if (i + 1 < data.length && data.charAt(i + 1) === '\r') return '\n\r';
            return code;
        }
    }
    return null;
}
/**
 * Is one node contained by another?
 * @param {Node} containee The contained node.
 * @param {Node} container The container node.
 * @return {boolean} Whether containee is inside (or equal to) container.
 * @private
 */ function $ad57523a9e758dd4$var$isNodeContainedBy(containee, container) {
    if (container === null || containee === null) return false;
    var containeeNode = /** @type {Node} */ containee;
    while(containeeNode && containeeNode !== container)containeeNode = containeeNode.parentNode;
    return containeeNode === container;
}
// This masks some numeric issues in older versions of Firefox,
// where 1.0/Math.pow(10,2) != Math.pow(10,-2).
/** @type {function(number,number):number} */ function $ad57523a9e758dd4$var$pow(base, exp) {
    if (exp < 0) return 1.0 / Math.pow(base, -exp);
    return Math.pow(base, exp);
}
var $ad57523a9e758dd4$var$RGBA_RE = /^rgba?\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})(?:,\s*([01](?:\.\d+)?))?\)$/;
/**
 * Helper for toRGB_ which parses strings of the form:
 * rgb(123, 45, 67)
 * rgba(123, 45, 67, 0.5)
 * @return parsed {r,g,b,a?} tuple or null.
 */ function $ad57523a9e758dd4$var$parseRGBA(rgbStr) {
    var bits = $ad57523a9e758dd4$var$RGBA_RE.exec(rgbStr);
    if (!bits) return null;
    var r = parseInt(bits[1], 10), g = parseInt(bits[2], 10), b = parseInt(bits[3], 10);
    if (bits[4]) return {
        r: r,
        g: g,
        b: b,
        a: parseFloat(bits[4])
    };
    else return {
        r: r,
        g: g,
        b: b
    };
}
/**
 * Converts any valid CSS color (hex, rgb(), named color) to an RGB tuple.
 *
 * @param {!string} colorStr Any valid CSS color string.
 * @return {{r:number,g:number,b:number,a:number?}} Parsed RGB tuple.
 * @private
 */ function $ad57523a9e758dd4$var$toRGB_(colorStr) {
    // Strategy: First try to parse colorStr directly. This is fast & avoids DOM
    // manipulation.  If that fails (e.g. for named colors like 'red'), then
    // create a hidden DOM element and parse its computed color.
    var rgb = $ad57523a9e758dd4$var$parseRGBA(colorStr);
    if (rgb) return rgb;
    var div = document.createElement('div');
    div.style.backgroundColor = colorStr;
    div.style.visibility = 'hidden';
    document.body.appendChild(div);
    var rgbStr = window.getComputedStyle(div, null).backgroundColor;
    document.body.removeChild(div);
    return $ad57523a9e758dd4$var$parseRGBA(rgbStr);
}
/**
 * Checks whether the browser supports the &lt;canvas&gt; tag.
 * @param {HTMLCanvasElement=} opt_canvasElement Pass a canvas element as an
 *     optimization if you have one.
 * @return {boolean} Whether the browser supports canvas.
 */ function $ad57523a9e758dd4$var$isCanvasSupported(opt_canvasElement) {
    try {
        var canvas = opt_canvasElement || document.createElement("canvas");
        canvas.getContext("2d");
    } catch (e) {
        return false;
    }
    return true;
}
/**
 * Parses the value as a floating point number. This is like the parseFloat()
 * built-in, but with a few differences:
 * - the empty string is parsed as null, rather than NaN.
 * - if the string cannot be parsed at all, an error is logged.
 * If the string can't be parsed, this method returns null.
 * @param {string} x The string to be parsed
 * @param {number=} opt_line_no The line number from which the string comes.
 * @param {string=} opt_line The text of the line from which the string comes.
 */ function $ad57523a9e758dd4$var$parseFloat_(x, opt_line_no, opt_line) {
    var val = parseFloat(x);
    if (!isNaN(val)) return val;
    // Try to figure out what happeend.
    // If the value is the empty string, parse it as null.
    if (/^ *$/.test(x)) return null;
    // If it was actually "NaN", return it as NaN.
    if (/^ *nan *$/i.test(x)) return NaN;
    // Looks like a parsing error.
    var msg = "Unable to parse '" + x + "' as a number";
    if (opt_line !== undefined && opt_line_no !== undefined) msg += " on line " + (1 + (opt_line_no || 0)) + " ('" + opt_line + "') of CSV.";
    console.error(msg);
    return null;
}
// Label constants for the labelsKMB and labelsKMG2 options.
// (i.e. '100000' -> '100K')
var $ad57523a9e758dd4$var$KMB_LABELS = [
    'K',
    'M',
    'B',
    'T',
    'Q'
];
var $ad57523a9e758dd4$var$KMG2_BIG_LABELS = [
    'k',
    'M',
    'G',
    'T',
    'P',
    'E',
    'Z',
    'Y'
];
var $ad57523a9e758dd4$var$KMG2_SMALL_LABELS = [
    'm',
    'u',
    'n',
    'p',
    'f',
    'a',
    'z',
    'y'
];
/**
 * @private
 * Return a string version of a number. This respects the digitsAfterDecimal
 * and maxNumberWidth options.
 * @param {number} x The number to be formatted
 * @param {Dygraph} opts An options view
 */ function $ad57523a9e758dd4$var$numberValueFormatter(x, opts) {
    var sigFigs = opts('sigFigs');
    if (sigFigs !== null) // User has opted for a fixed number of significant figures.
    return $ad57523a9e758dd4$var$floatFormat(x, sigFigs);
    var digits = opts('digitsAfterDecimal');
    var maxNumberWidth = opts('maxNumberWidth');
    var kmb = opts('labelsKMB');
    var kmg2 = opts('labelsKMG2');
    var label;
    // switch to scientific notation if we underflow or overflow fixed display.
    if (x !== 0.0 && (Math.abs(x) >= Math.pow(10, maxNumberWidth) || Math.abs(x) < Math.pow(10, -digits))) label = x.toExponential(digits);
    else label = '' + $ad57523a9e758dd4$var$round_(x, digits);
    if (kmb || kmg2) {
        var k;
        var k_labels = [];
        var m_labels = [];
        if (kmb) {
            k = 1000;
            k_labels = $ad57523a9e758dd4$var$KMB_LABELS;
        }
        if (kmg2) {
            if (kmb) console.warn("Setting both labelsKMB and labelsKMG2. Pick one!");
            k = 1024;
            k_labels = $ad57523a9e758dd4$var$KMG2_BIG_LABELS;
            m_labels = $ad57523a9e758dd4$var$KMG2_SMALL_LABELS;
        }
        var absx = Math.abs(x);
        var n = $ad57523a9e758dd4$var$pow(k, k_labels.length);
        for(var j = k_labels.length - 1; j >= 0; j--, n /= k)if (absx >= n) {
            label = $ad57523a9e758dd4$var$round_(x / n, digits) + k_labels[j];
            break;
        }
        if (kmg2) {
            // TODO(danvk): clean up this logic. Why so different than kmb?
            var x_parts = String(x.toExponential()).split('e-');
            if (x_parts.length === 2 && x_parts[1] >= 3 && x_parts[1] <= 24) {
                if (x_parts[1] % 3 > 0) label = $ad57523a9e758dd4$var$round_(x_parts[0] / $ad57523a9e758dd4$var$pow(10, x_parts[1] % 3), digits);
                else label = Number(x_parts[0]).toFixed(2);
                label += m_labels[Math.floor(x_parts[1] / 3) - 1];
            }
        }
    }
    return label;
}
/**
 * variant for use as an axisLabelFormatter.
 * @private
 */ function $ad57523a9e758dd4$var$numberAxisLabelFormatter(x, granularity, opts) {
    return $ad57523a9e758dd4$var$numberValueFormatter.call(this, x, opts);
}
/**
 * @type {!Array.<string>}
 * @private
 * @constant
 */ var $ad57523a9e758dd4$var$SHORT_MONTH_NAMES_ = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
/**
 * Convert a JS date to a string appropriate to display on an axis that
 * is displaying values at the stated granularity. This respects the
 * labelsUTC option.
 * @param {Date} date The date to format
 * @param {number} granularity One of the Dygraph granularity constants
 * @param {Dygraph} opts An options view
 * @return {string} The date formatted as local time
 * @private
 */ function $ad57523a9e758dd4$var$dateAxisLabelFormatter(date, granularity, opts) {
    var utc = opts('labelsUTC');
    var accessors = utc ? $ad57523a9e758dd4$var$DateAccessorsUTC : $ad57523a9e758dd4$var$DateAccessorsLocal;
    var year = accessors.getFullYear(date), month = accessors.getMonth(date), day = accessors.getDate(date), hours = accessors.getHours(date), mins = accessors.getMinutes(date), secs = accessors.getSeconds(date), millis = accessors.getMilliseconds(date);
    if (granularity >= $ad57523a9e758dd4$var$DygraphTickers.Granularity.DECADAL) return '' + year;
    else if (granularity >= $ad57523a9e758dd4$var$DygraphTickers.Granularity.MONTHLY) return $ad57523a9e758dd4$var$SHORT_MONTH_NAMES_[month] + '&#160;' + year;
    else {
        var frac = hours * 3600 + mins * 60 + secs + 1e-3 * millis;
        if (frac === 0 || granularity >= $ad57523a9e758dd4$var$DygraphTickers.Granularity.DAILY) // e.g. '21 Jan' (%d%b)
        return $ad57523a9e758dd4$var$zeropad(day) + '&#160;' + $ad57523a9e758dd4$var$SHORT_MONTH_NAMES_[month];
        else if (granularity < $ad57523a9e758dd4$var$DygraphTickers.Granularity.SECONDLY) {
            // e.g. 40.310 (meaning 40 seconds and 310 milliseconds)
            var str = "" + millis;
            return $ad57523a9e758dd4$var$zeropad(secs) + "." + ('000' + str).substring(str.length);
        } else if (granularity > $ad57523a9e758dd4$var$DygraphTickers.Granularity.MINUTELY) return $ad57523a9e758dd4$var$hmsString_(hours, mins, secs, 0);
        else return $ad57523a9e758dd4$var$hmsString_(hours, mins, secs, millis);
    }
}
// alias in case anyone is referencing the old method.
// Dygraph.dateAxisFormatter = Dygraph.dateAxisLabelFormatter;
/**
 * Return a string version of a JS date for a value label. This respects the
 * labelsUTC option.
 * @param {Date} date The date to be formatted
 * @param {Dygraph} opts An options view
 * @private
 */ function $ad57523a9e758dd4$var$dateValueFormatter(d, opts) {
    return $ad57523a9e758dd4$var$dateString_(d, opts('labelsUTC'));
}


var $852ab21d3dc0462c$var$utils = $852ab21d3dc0462c$var$_interopRequireWildcard($ad57523a9e758dd4$exports);
/**
 * Creates a new DygraphLayout object.
 *
 * This class contains all the data to be charted.
 * It uses data coordinates, but also records the chart range (in data
 * coordinates) and hence is able to calculate percentage positions ('In this
 * view, Point A lies 25% down the x-axis.')
 *
 * Two things that it does not do are:
 * 1. Record pixel coordinates for anything.
 * 2. (oddly) determine anything about the layout of chart elements.
 *
 * The naming is a vestige of Dygraph's original PlotKit roots.
 *
 * @constructor
 */ var $852ab21d3dc0462c$var$DygraphLayout = function DygraphLayout(dygraph) {
    this.dygraph_ = dygraph;
    /**
   * Array of points for each series.
   *
   * [series index][row index in series] = |Point| structure,
   * where series index refers to visible series only, and the
   * point index is for the reduced set of points for the current
   * zoom region (including one point just outside the window).
   * All points in the same row index share the same X value.
   *
   * @type {Array.<Array.<Dygraph.PointType>>}
   */ this.points = [];
    this.setNames = [];
    this.annotations = [];
    this.yAxes_ = null;
    // TODO(danvk): it's odd that xTicks_ and yTicks_ are inputs, but xticks and
    // yticks are outputs. Clean this up.
    this.xTicks_ = null;
    this.yTicks_ = null;
};
/**
 * Add points for a single series.
 *
 * @param {string} setname Name of the series.
 * @param {Array.<Dygraph.PointType>} set_xy Points for the series.
 */ $852ab21d3dc0462c$var$DygraphLayout.prototype.addDataset = function(setname, set_xy) {
    this.points.push(set_xy);
    this.setNames.push(setname);
};
/**
 * Returns the box which the chart should be drawn in. This is the canvas's
 * box, less space needed for the axis and chart labels.
 *
 * @return {{x: number, y: number, w: number, h: number}}
 */ $852ab21d3dc0462c$var$DygraphLayout.prototype.getPlotArea = function() {
    return this.area_;
};
// Compute the box which the chart should be drawn in. This is the canvas's
// box, less space needed for axis, chart labels, and other plug-ins.
// NOTE: This should only be called by Dygraph.predraw_().
$852ab21d3dc0462c$var$DygraphLayout.prototype.computePlotArea = function() {
    var area = {
        // TODO(danvk): per-axis setting.
        x: 0,
        y: 0
    };
    area.w = this.dygraph_.width_ - area.x - this.dygraph_.getOption('rightGap');
    area.h = this.dygraph_.height_;
    // Let plugins reserve space.
    var e = {
        chart_div: this.dygraph_.graphDiv,
        reserveSpaceLeft: function reserveSpaceLeft(px) {
            var r = {
                x: area.x,
                y: area.y,
                w: px,
                h: area.h
            };
            area.x += px;
            area.w -= px;
            return r;
        },
        reserveSpaceRight: function reserveSpaceRight(px) {
            var r = {
                x: area.x + area.w - px,
                y: area.y,
                w: px,
                h: area.h
            };
            area.w -= px;
            return r;
        },
        reserveSpaceTop: function reserveSpaceTop(px) {
            var r = {
                x: area.x,
                y: area.y,
                w: area.w,
                h: px
            };
            area.y += px;
            area.h -= px;
            return r;
        },
        reserveSpaceBottom: function reserveSpaceBottom(px) {
            var r = {
                x: area.x,
                y: area.y + area.h - px,
                w: area.w,
                h: px
            };
            area.h -= px;
            return r;
        },
        chartRect: function chartRect() {
            return {
                x: area.x,
                y: area.y,
                w: area.w,
                h: area.h
            };
        }
    };
    this.dygraph_.cascadeEvents_('layout', e);
    this.area_ = area;
};
$852ab21d3dc0462c$var$DygraphLayout.prototype.setAnnotations = function(ann) {
    // The Dygraph object's annotations aren't parsed. We parse them here and
    // save a copy. If there is no parser, then the user must be using raw format.
    this.annotations = [];
    var parse = this.dygraph_.getOption('xValueParser') || function(x) {
        return x;
    };
    for(var i = 0; i < ann.length; i++){
        var a = {};
        if (!ann[i].xval && ann[i].x === undefined) {
            console.error("Annotations must have an 'x' property");
            return;
        }
        if (ann[i].icon && !(ann[i].hasOwnProperty('width') && ann[i].hasOwnProperty('height'))) {
            console.error("Must set width and height when setting annotation.icon property");
            return;
        }
        $852ab21d3dc0462c$var$utils.update(a, ann[i]);
        if (!a.xval) a.xval = parse(a.x);
        this.annotations.push(a);
    }
};
$852ab21d3dc0462c$var$DygraphLayout.prototype.setXTicks = function(xTicks) {
    this.xTicks_ = xTicks;
};
// TODO(danvk): add this to the Dygraph object's API or move it into Layout.
$852ab21d3dc0462c$var$DygraphLayout.prototype.setYAxes = function(yAxes) {
    this.yAxes_ = yAxes;
};
$852ab21d3dc0462c$var$DygraphLayout.prototype.evaluate = function() {
    this._xAxis = {};
    this._evaluateLimits();
    this._evaluateLineCharts();
    this._evaluateLineTicks();
    this._evaluateAnnotations();
};
$852ab21d3dc0462c$var$DygraphLayout.prototype._evaluateLimits = function() {
    var xlimits = this.dygraph_.xAxisRange();
    this._xAxis.minval = xlimits[0];
    this._xAxis.maxval = xlimits[1];
    var xrange = xlimits[1] - xlimits[0];
    this._xAxis.scale = xrange !== 0 ? 1 / xrange : 1.0;
    if (this.dygraph_.getOptionForAxis("logscale", 'x')) {
        this._xAxis.xlogrange = $852ab21d3dc0462c$var$utils.log10(this._xAxis.maxval) - $852ab21d3dc0462c$var$utils.log10(this._xAxis.minval);
        this._xAxis.xlogscale = this._xAxis.xlogrange !== 0 ? 1.0 / this._xAxis.xlogrange : 1.0;
    }
    for(var i = 0; i < this.yAxes_.length; i++){
        var axis = this.yAxes_[i];
        axis.minyval = axis.computedValueRange[0];
        axis.maxyval = axis.computedValueRange[1];
        axis.yrange = axis.maxyval - axis.minyval;
        axis.yscale = axis.yrange !== 0 ? 1.0 / axis.yrange : 1.0;
        if (this.dygraph_.getOption("logscale")) {
            axis.ylogrange = $852ab21d3dc0462c$var$utils.log10(axis.maxyval) - $852ab21d3dc0462c$var$utils.log10(axis.minyval);
            axis.ylogscale = axis.ylogrange !== 0 ? 1.0 / axis.ylogrange : 1.0;
            if (!isFinite(axis.ylogrange) || isNaN(axis.ylogrange)) console.error('axis ' + i + ' of graph at ' + axis.g + ' can\'t be displayed in log scale for range [' + axis.minyval + ' - ' + axis.maxyval + ']');
        }
    }
};
$852ab21d3dc0462c$var$DygraphLayout.calcXNormal_ = function(value, xAxis, logscale) {
    if (logscale) return ($852ab21d3dc0462c$var$utils.log10(value) - $852ab21d3dc0462c$var$utils.log10(xAxis.minval)) * xAxis.xlogscale;
    else return (value - xAxis.minval) * xAxis.scale;
};
/**
 * @param {DygraphAxisType} axis
 * @param {number} value
 * @param {boolean} logscale
 * @return {number}
 */ $852ab21d3dc0462c$var$DygraphLayout.calcYNormal_ = function(axis, value, logscale) {
    if (logscale) {
        var x = 1.0 - ($852ab21d3dc0462c$var$utils.log10(value) - $852ab21d3dc0462c$var$utils.log10(axis.minyval)) * axis.ylogscale;
        return isFinite(x) ? x : NaN; // shim for v8 issue; see pull request 276
    } else return 1.0 - (value - axis.minyval) * axis.yscale;
};
$852ab21d3dc0462c$var$DygraphLayout.prototype._evaluateLineCharts = function() {
    var isStacked = this.dygraph_.getOption("stackedGraph");
    var isLogscaleForX = this.dygraph_.getOptionForAxis("logscale", 'x');
    for(var setIdx = 0; setIdx < this.points.length; setIdx++){
        var points = this.points[setIdx];
        var setName = this.setNames[setIdx];
        var connectSeparated = this.dygraph_.getOption('connectSeparatedPoints', setName);
        var axis = this.dygraph_.axisPropertiesForSeries(setName);
        // TODO (konigsberg): use optionsForAxis instead.
        var logscale = this.dygraph_.attributes_.getForSeries("logscale", setName);
        for(var j = 0; j < points.length; j++){
            var point = points[j];
            // Range from 0-1 where 0 represents left and 1 represents right.
            point.x = $852ab21d3dc0462c$var$DygraphLayout.calcXNormal_(point.xval, this._xAxis, isLogscaleForX);
            // Range from 0-1 where 0 represents top and 1 represents bottom
            var yval = point.yval;
            if (isStacked) {
                point.y_stacked = $852ab21d3dc0462c$var$DygraphLayout.calcYNormal_(axis, point.yval_stacked, logscale);
                if (yval !== null && !isNaN(yval)) yval = point.yval_stacked;
            }
            if (yval === null) {
                yval = NaN;
                if (!connectSeparated) point.yval = NaN;
            }
            point.y = $852ab21d3dc0462c$var$DygraphLayout.calcYNormal_(axis, yval, logscale);
        }
        this.dygraph_.dataHandler_.onLineEvaluated(points, axis, logscale);
    }
};
$852ab21d3dc0462c$var$DygraphLayout.prototype._evaluateLineTicks = function() {
    var i, tick, label, pos, v, has_tick;
    this.xticks = [];
    for(i = 0; i < this.xTicks_.length; i++){
        tick = this.xTicks_[i];
        label = tick.label;
        has_tick = !('label_v' in tick);
        v = has_tick ? tick.v : tick.label_v;
        pos = this.dygraph_.toPercentXCoord(v);
        if (pos >= 0.0 && pos < 1.0) this.xticks.push({
            pos: pos,
            label: label,
            has_tick: has_tick
        });
    }
    this.yticks = [];
    for(i = 0; i < this.yAxes_.length; i++){
        var axis = this.yAxes_[i];
        for(var j = 0; j < axis.ticks.length; j++){
            tick = axis.ticks[j];
            label = tick.label;
            has_tick = !('label_v' in tick);
            v = has_tick ? tick.v : tick.label_v;
            pos = this.dygraph_.toPercentYCoord(v, i);
            if (pos > 0.0 && pos <= 1.0) this.yticks.push({
                axis: i,
                pos: pos,
                label: label,
                has_tick: has_tick
            });
        }
    }
};
$852ab21d3dc0462c$var$DygraphLayout.prototype._evaluateAnnotations = function() {
    // Add the annotations to the point to which they belong.
    // Make a map from (setName, xval) to annotation for quick lookups.
    var i;
    var annotations = {};
    for(i = 0; i < this.annotations.length; i++){
        var a = this.annotations[i];
        annotations[a.xval + "," + a.series] = a;
    }
    this.annotated_points = [];
    // Exit the function early if there are no annotations.
    if (!this.annotations || !this.annotations.length) return;
    // TODO(antrob): loop through annotations not points.
    for(var setIdx = 0; setIdx < this.points.length; setIdx++){
        var points = this.points[setIdx];
        for(i = 0; i < points.length; i++){
            var p = points[i];
            var k = p.xval + "," + p.name;
            if (k in annotations) {
                p.annotation = annotations[k];
                this.annotated_points.push(p);
            }
        }
    }
};
/**
 * Convenience function to remove all the data sets from a graph
 */ $852ab21d3dc0462c$var$DygraphLayout.prototype.removeAllDatasets = function() {
    delete this.points;
    delete this.setNames;
    delete this.setPointsLengths;
    delete this.setPointsOffsets;
    this.points = [];
    this.setNames = [];
    this.setPointsLengths = [];
    this.setPointsOffsets = [];
};
$852ab21d3dc0462c$exports['default'] = $852ab21d3dc0462c$var$DygraphLayout;
$852ab21d3dc0462c$exports = $852ab21d3dc0462c$exports['default'];


var $298304f644e9f727$var$_dygraphLayout2 = $298304f644e9f727$var$_interopRequireDefault($852ab21d3dc0462c$exports);
var $96f2ef959710507f$exports = {};
/**
 * @license
 * Copyright 2006 Dan Vanderkam (danvdk@gmail.com)
 * MIT-licensed (http://opensource.org/licenses/MIT)
 */ /**
 * @fileoverview Based on PlotKit.CanvasRenderer, but modified to meet the
 * needs of dygraphs.
 *
 * In particular, support for:
 * - grid overlays
 * - error bars
 * - dygraphs attribute system
 */ /**
 * The DygraphCanvasRenderer class does the actual rendering of the chart onto
 * a canvas. It's based on PlotKit.CanvasRenderer.
 * @param {Object} element The canvas to attach to
 * @param {Object} elementContext The 2d context of the canvas (injected so it
 * can be mocked for testing.)
 * @param {Layout} layout The DygraphLayout object for this graph.
 * @constructor
 */ /*global Dygraph:false */ "use strict";
Object.defineProperty($96f2ef959710507f$exports, '__esModule', {
    value: true
});
function $96f2ef959710507f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
function $96f2ef959710507f$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj['default'] = obj;
        return newObj;
    }
}

var $96f2ef959710507f$var$utils = $96f2ef959710507f$var$_interopRequireWildcard($ad57523a9e758dd4$exports);

var $96f2ef959710507f$var$_dygraph2 = $96f2ef959710507f$var$_interopRequireDefault($298304f644e9f727$exports);
/**
 * @constructor
 *
 * This gets called when there are "new points" to chart. This is generally the
 * case when the underlying data being charted has changed. It is _not_ called
 * in the common case that the user has zoomed or is panning the view.
 *
 * The chart canvas has already been created by the Dygraph object. The
 * renderer simply gets a drawing context.
 *
 * @param {Dygraph} dygraph The chart to which this renderer belongs.
 * @param {HTMLCanvasElement} element The &lt;canvas&gt; DOM element on which to draw.
 * @param {CanvasRenderingContext2D} elementContext The drawing context.
 * @param {DygraphLayout} layout The chart's DygraphLayout object.
 *
 * TODO(danvk): remove the elementContext property.
 */ var $96f2ef959710507f$var$DygraphCanvasRenderer = function DygraphCanvasRenderer(dygraph, element, elementContext, layout) {
    this.dygraph_ = dygraph;
    this.layout = layout;
    this.element = element;
    this.elementContext = elementContext;
    this.height = dygraph.height_;
    this.width = dygraph.width_;
    // --- check whether everything is ok before we return
    if (!$96f2ef959710507f$var$utils.isCanvasSupported(this.element)) throw "Canvas is not supported.";
    // internal state
    this.area = layout.getPlotArea();
    // Set up a clipping area for the canvas (and the interaction canvas).
    // This ensures that we don't overdraw.
    var ctx = this.dygraph_.canvas_ctx_;
    ctx.beginPath();
    ctx.rect(this.area.x, this.area.y, this.area.w, this.area.h);
    ctx.clip();
    ctx = this.dygraph_.hidden_ctx_;
    ctx.beginPath();
    ctx.rect(this.area.x, this.area.y, this.area.w, this.area.h);
    ctx.clip();
};
/**
 * Clears out all chart content and DOM elements.
 * This is called immediately before render() on every frame, including
 * during zooms and pans.
 * @private
 */ $96f2ef959710507f$var$DygraphCanvasRenderer.prototype.clear = function() {
    this.elementContext.clearRect(0, 0, this.width, this.height);
};
/**
 * This method is responsible for drawing everything on the chart, including
 * lines, error bars, fills and axes.
 * It is called immediately after clear() on every frame, including during pans
 * and zooms.
 * @private
 */ $96f2ef959710507f$var$DygraphCanvasRenderer.prototype.render = function() {
    // attaches point.canvas{x,y}
    this._updatePoints();
    // actually draws the chart.
    this._renderLineChart();
};
/**
 * Returns a predicate to be used with an iterator, which will
 * iterate over points appropriately, depending on whether
 * connectSeparatedPoints is true. When it's false, the predicate will
 * skip over points with missing yVals.
 */ $96f2ef959710507f$var$DygraphCanvasRenderer._getIteratorPredicate = function(connectSeparatedPoints) {
    return connectSeparatedPoints ? $96f2ef959710507f$var$DygraphCanvasRenderer._predicateThatSkipsEmptyPoints : null;
};
$96f2ef959710507f$var$DygraphCanvasRenderer._predicateThatSkipsEmptyPoints = function(array, idx) {
    return array[idx].yval !== null;
};
/**
 * Draws a line with the styles passed in and calls all the drawPointCallbacks.
 * @param {Object} e The dictionary passed to the plotter function.
 * @private
 */ $96f2ef959710507f$var$DygraphCanvasRenderer._drawStyledLine = function(e, color, strokeWidth, strokePattern, drawPoints, drawPointCallback, pointSize) {
    var g = e.dygraph;
    // TODO(konigsberg): Compute attributes outside this method call.
    var stepPlot = g.getBooleanOption("stepPlot", e.setName);
    if (!$96f2ef959710507f$var$utils.isArrayLike(strokePattern)) strokePattern = null;
    var drawGapPoints = g.getBooleanOption('drawGapEdgePoints', e.setName);
    var points = e.points;
    var setName = e.setName;
    var iter = $96f2ef959710507f$var$utils.createIterator(points, 0, points.length, $96f2ef959710507f$var$DygraphCanvasRenderer._getIteratorPredicate(g.getBooleanOption("connectSeparatedPoints", setName)));
    var stroking = strokePattern && strokePattern.length >= 2;
    var ctx = e.drawingContext;
    ctx.save();
    if (stroking) {
        if (ctx.setLineDash) ctx.setLineDash(strokePattern);
    }
    var pointsOnLine = $96f2ef959710507f$var$DygraphCanvasRenderer._drawSeries(e, iter, strokeWidth, pointSize, drawPoints, drawGapPoints, stepPlot, color);
    $96f2ef959710507f$var$DygraphCanvasRenderer._drawPointsOnLine(e, pointsOnLine, drawPointCallback, color, pointSize);
    if (stroking) {
        if (ctx.setLineDash) ctx.setLineDash([]);
    }
    ctx.restore();
};
/**
 * This does the actual drawing of lines on the canvas, for just one series.
 * Returns a list of [canvasx, canvasy] pairs for points for which a
 * drawPointCallback should be fired.  These include isolated points, or all
 * points if drawPoints=true.
 * @param {Object} e The dictionary passed to the plotter function.
 * @private
 */ $96f2ef959710507f$var$DygraphCanvasRenderer._drawSeries = function(e, iter, strokeWidth, pointSize, drawPoints, drawGapPoints, stepPlot, color) {
    var prevCanvasX = null;
    var prevCanvasY = null;
    var nextCanvasY = null;
    var isIsolated; // true if this point is isolated (no line segments)
    var point; // the point being processed in the while loop
    var pointsOnLine = []; // Array of [canvasx, canvasy] pairs.
    var first = true; // the first cycle through the while loop
    var ctx = e.drawingContext;
    ctx.beginPath();
    ctx.strokeStyle = color;
    ctx.lineWidth = strokeWidth;
    // NOTE: we break the iterator's encapsulation here for about a 25% speedup.
    var arr = iter.array_;
    var limit = iter.end_;
    var predicate = iter.predicate_;
    for(var i = iter.start_; i < limit; i++){
        point = arr[i];
        if (predicate) {
            while(i < limit && !predicate(arr, i))i++;
            if (i == limit) break;
            point = arr[i];
        }
        // FIXME: The 'canvasy != canvasy' test here catches NaN values but the test
        // doesn't catch Infinity values. Could change this to
        // !isFinite(point.canvasy), but I assume it avoids isNaN for performance?
        if (point.canvasy === null || point.canvasy != point.canvasy) {
            if (stepPlot && prevCanvasX !== null) {
                // Draw a horizontal line to the start of the missing data
                ctx.moveTo(prevCanvasX, prevCanvasY);
                ctx.lineTo(point.canvasx, prevCanvasY);
            }
            prevCanvasX = prevCanvasY = null;
        } else {
            isIsolated = false;
            if (drawGapPoints || prevCanvasX === null) {
                iter.nextIdx_ = i;
                iter.next();
                nextCanvasY = iter.hasNext ? iter.peek.canvasy : null;
                var isNextCanvasYNullOrNaN = nextCanvasY === null || nextCanvasY != nextCanvasY;
                isIsolated = prevCanvasX === null && isNextCanvasYNullOrNaN;
                if (drawGapPoints) // Also consider a point to be "isolated" if it's adjacent to a
                // null point, excluding the graph edges.
                {
                    if (!first && prevCanvasX === null || iter.hasNext && isNextCanvasYNullOrNaN) isIsolated = true;
                }
            }
            if (prevCanvasX !== null) {
                if (strokeWidth) {
                    if (stepPlot) {
                        ctx.moveTo(prevCanvasX, prevCanvasY);
                        ctx.lineTo(point.canvasx, prevCanvasY);
                    }
                    ctx.lineTo(point.canvasx, point.canvasy);
                }
            } else ctx.moveTo(point.canvasx, point.canvasy);
            if (drawPoints || isIsolated) pointsOnLine.push([
                point.canvasx,
                point.canvasy,
                point.idx
            ]);
            prevCanvasX = point.canvasx;
            prevCanvasY = point.canvasy;
        }
        first = false;
    }
    ctx.stroke();
    return pointsOnLine;
};
/**
 * This fires the drawPointCallback functions, which draw dots on the points by
 * default. This gets used when the "drawPoints" option is set, or when there
 * are isolated points.
 * @param {Object} e The dictionary passed to the plotter function.
 * @private
 */ $96f2ef959710507f$var$DygraphCanvasRenderer._drawPointsOnLine = function(e, pointsOnLine, drawPointCallback, color, pointSize) {
    var ctx = e.drawingContext;
    for(var idx = 0; idx < pointsOnLine.length; idx++){
        var cb = pointsOnLine[idx];
        ctx.save();
        drawPointCallback.call(e.dygraph, e.dygraph, e.setName, ctx, cb[0], cb[1], color, pointSize, cb[2]);
        ctx.restore();
    }
};
/**
 * Attaches canvas coordinates to the points array.
 * @private
 */ $96f2ef959710507f$var$DygraphCanvasRenderer.prototype._updatePoints = function() {
    // Update Points
    // TODO(danvk): here
    //
    // TODO(bhs): this loop is a hot-spot for high-point-count charts. These
    // transformations can be pushed into the canvas via linear transformation
    // matrices.
    // NOTE(danvk): this is trickier than it sounds at first. The transformation
    // needs to be done before the .moveTo() and .lineTo() calls, but must be
    // undone before the .stroke() call to ensure that the stroke width is
    // unaffected.  An alternative is to reduce the stroke width in the
    // transformed coordinate space, but you can't specify different values for
    // each dimension (as you can with .scale()). The speedup here is ~12%.
    var sets = this.layout.points;
    for(var i = sets.length; i--;){
        var points = sets[i];
        for(var j = points.length; j--;){
            var point = points[j];
            point.canvasx = this.area.w * point.x + this.area.x;
            point.canvasy = this.area.h * point.y + this.area.y;
        }
    }
};
/**
 * Add canvas Actually draw the lines chart, including error bars.
 *
 * This function can only be called if DygraphLayout's points array has been
 * updated with canvas{x,y} attributes, i.e. by
 * DygraphCanvasRenderer._updatePoints.
 *
 * @param {string=} opt_seriesName when specified, only that series will
 *     be drawn. (This is used for expedited redrawing with highlightSeriesOpts)
 * @param {CanvasRenderingContext2D} opt_ctx when specified, the drawing
 *     context.  However, lines are typically drawn on the object's
 *     elementContext.
 * @private
 */ $96f2ef959710507f$var$DygraphCanvasRenderer.prototype._renderLineChart = function(opt_seriesName, opt_ctx) {
    var ctx = opt_ctx || this.elementContext;
    var i;
    var sets = this.layout.points;
    var setNames = this.layout.setNames;
    var setName;
    this.colors = this.dygraph_.colorsMap_;
    // Determine which series have specialized plotters.
    var plotter_attr = this.dygraph_.getOption("plotter");
    var plotters = plotter_attr;
    if (!$96f2ef959710507f$var$utils.isArrayLike(plotters)) plotters = [
        plotters
    ];
    var setPlotters = {}; // series name -> plotter fn.
    for(i = 0; i < setNames.length; i++){
        setName = setNames[i];
        var setPlotter = this.dygraph_.getOption("plotter", setName);
        if (setPlotter == plotter_attr) continue; // not specialized.
        setPlotters[setName] = setPlotter;
    }
    for(i = 0; i < plotters.length; i++){
        var plotter = plotters[i];
        var is_last = i == plotters.length - 1;
        for(var j = 0; j < sets.length; j++){
            setName = setNames[j];
            if (opt_seriesName && setName != opt_seriesName) continue;
            var points = sets[j];
            // Only throw in the specialized plotters on the last iteration.
            var p = plotter;
            if (setName in setPlotters) {
                if (is_last) p = setPlotters[setName];
                else continue;
            }
            var color = this.colors[setName];
            var strokeWidth = this.dygraph_.getOption("strokeWidth", setName);
            ctx.save();
            ctx.strokeStyle = color;
            ctx.lineWidth = strokeWidth;
            p({
                points: points,
                setName: setName,
                drawingContext: ctx,
                color: color,
                strokeWidth: strokeWidth,
                dygraph: this.dygraph_,
                axis: this.dygraph_.axisPropertiesForSeries(setName),
                plotArea: this.area,
                seriesIndex: j,
                seriesCount: sets.length,
                singleSeriesName: opt_seriesName,
                allSeriesPoints: sets
            });
            ctx.restore();
        }
    }
};
/**
 * Standard plotters. These may be used by clients via Dygraph.Plotters.
 * See comments there for more details.
 */ $96f2ef959710507f$var$DygraphCanvasRenderer._Plotters = {
    linePlotter: function linePlotter(e) {
        $96f2ef959710507f$var$DygraphCanvasRenderer._linePlotter(e);
    },
    fillPlotter: function fillPlotter(e) {
        $96f2ef959710507f$var$DygraphCanvasRenderer._fillPlotter(e);
    },
    errorPlotter: function errorPlotter(e) {
        $96f2ef959710507f$var$DygraphCanvasRenderer._errorPlotter(e);
    }
};
/**
 * Plotter which draws the central lines for a series.
 * @private
 */ $96f2ef959710507f$var$DygraphCanvasRenderer._linePlotter = function(e) {
    var g = e.dygraph;
    var setName = e.setName;
    var strokeWidth = e.strokeWidth;
    // TODO(danvk): Check if there's any performance impact of just calling
    // getOption() inside of _drawStyledLine. Passing in so many parameters makes
    // this code a bit nasty.
    var borderWidth = g.getNumericOption("strokeBorderWidth", setName);
    var drawPointCallback = g.getOption("drawPointCallback", setName) || $96f2ef959710507f$var$utils.Circles.DEFAULT;
    var strokePattern = g.getOption("strokePattern", setName);
    var drawPoints = g.getBooleanOption("drawPoints", setName);
    var pointSize = g.getNumericOption("pointSize", setName);
    if (borderWidth && strokeWidth) $96f2ef959710507f$var$DygraphCanvasRenderer._drawStyledLine(e, g.getOption("strokeBorderColor", setName), strokeWidth + 2 * borderWidth, strokePattern, drawPoints, drawPointCallback, pointSize);
    $96f2ef959710507f$var$DygraphCanvasRenderer._drawStyledLine(e, e.color, strokeWidth, strokePattern, drawPoints, drawPointCallback, pointSize);
};
/**
 * Draws the shaded error bars/confidence intervals for each series.
 * This happens before the center lines are drawn, since the center lines
 * need to be drawn on top of the error bars for all series.
 * @private
 */ $96f2ef959710507f$var$DygraphCanvasRenderer._errorPlotter = function(e) {
    var g = e.dygraph;
    var setName = e.setName;
    var errorBars = g.getBooleanOption("errorBars") || g.getBooleanOption("customBars");
    if (!errorBars) return;
    var fillGraph = g.getBooleanOption("fillGraph", setName);
    if (fillGraph) console.warn("Can't use fillGraph option with error bars");
    var ctx = e.drawingContext;
    var color = e.color;
    var fillAlpha = g.getNumericOption('fillAlpha', setName);
    var stepPlot = g.getBooleanOption("stepPlot", setName);
    var points = e.points;
    var iter = $96f2ef959710507f$var$utils.createIterator(points, 0, points.length, $96f2ef959710507f$var$DygraphCanvasRenderer._getIteratorPredicate(g.getBooleanOption("connectSeparatedPoints", setName)));
    var newYs;
    // setup graphics context
    var prevX = NaN;
    var prevY = NaN;
    var prevYs = [
        -1,
        -1
    ];
    // should be same color as the lines but only 15% opaque.
    var rgb = $96f2ef959710507f$var$utils.toRGB_(color);
    var err_color = 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + fillAlpha + ')';
    ctx.fillStyle = err_color;
    ctx.beginPath();
    var isNullUndefinedOrNaN = function isNullUndefinedOrNaN(x) {
        return x === null || x === undefined || isNaN(x);
    };
    while(iter.hasNext){
        var point = iter.next();
        if (!stepPlot && isNullUndefinedOrNaN(point.y) || stepPlot && !isNaN(prevY) && isNullUndefinedOrNaN(prevY)) {
            prevX = NaN;
            continue;
        }
        newYs = [
            point.y_bottom,
            point.y_top
        ];
        if (stepPlot) prevY = point.y;
        // The documentation specifically disallows nulls inside the point arrays,
        // but in case it happens we should do something sensible.
        if (isNaN(newYs[0])) newYs[0] = point.y;
        if (isNaN(newYs[1])) newYs[1] = point.y;
        newYs[0] = e.plotArea.h * newYs[0] + e.plotArea.y;
        newYs[1] = e.plotArea.h * newYs[1] + e.plotArea.y;
        if (!isNaN(prevX)) {
            if (stepPlot) {
                ctx.moveTo(prevX, prevYs[0]);
                ctx.lineTo(point.canvasx, prevYs[0]);
                ctx.lineTo(point.canvasx, prevYs[1]);
            } else {
                ctx.moveTo(prevX, prevYs[0]);
                ctx.lineTo(point.canvasx, newYs[0]);
                ctx.lineTo(point.canvasx, newYs[1]);
            }
            ctx.lineTo(prevX, prevYs[1]);
            ctx.closePath();
        }
        prevYs = newYs;
        prevX = point.canvasx;
    }
    ctx.fill();
};
/**
 * Proxy for CanvasRenderingContext2D which drops moveTo/lineTo calls which are
 * superfluous. It accumulates all movements which haven't changed the x-value
 * and only applies the two with the most extreme y-values.
 *
 * Calls to lineTo/moveTo must have non-decreasing x-values.
 */ $96f2ef959710507f$var$DygraphCanvasRenderer._fastCanvasProxy = function(context) {
    var pendingActions = []; // array of [type, x, y] tuples
    var lastRoundedX = null;
    var lastFlushedX = null;
    var LINE_TO = 1, MOVE_TO = 2;
    var actionCount = 0; // number of moveTos and lineTos passed to context.
    // Drop superfluous motions
    // Assumes all pendingActions have the same (rounded) x-value.
    var compressActions = function compressActions(opt_losslessOnly) {
        if (pendingActions.length <= 1) return;
        // Lossless compression: drop inconsequential moveTos.
        for(var i = pendingActions.length - 1; i > 0; i--){
            var action = pendingActions[i];
            if (action[0] == MOVE_TO) {
                var prevAction = pendingActions[i - 1];
                if (prevAction[1] == action[1] && prevAction[2] == action[2]) pendingActions.splice(i, 1);
            }
        }
        // Lossless compression: ... drop consecutive moveTos ...
        for(var i = 0; i < pendingActions.length - 1;)/* incremented internally */ {
            var action = pendingActions[i];
            if (action[0] == MOVE_TO && pendingActions[i + 1][0] == MOVE_TO) pendingActions.splice(i, 1);
            else i++;
        }
        // Lossy compression: ... drop all but the extreme y-values ...
        if (pendingActions.length > 2 && !opt_losslessOnly) {
            // keep an initial moveTo, but drop all others.
            var startIdx = 0;
            if (pendingActions[0][0] == MOVE_TO) startIdx++;
            var minIdx = null, maxIdx = null;
            for(var i = startIdx; i < pendingActions.length; i++){
                var action = pendingActions[i];
                if (action[0] != LINE_TO) continue;
                if (minIdx === null && maxIdx === null) {
                    minIdx = i;
                    maxIdx = i;
                } else {
                    var y = action[2];
                    if (y < pendingActions[minIdx][2]) minIdx = i;
                    else if (y > pendingActions[maxIdx][2]) maxIdx = i;
                }
            }
            var minAction = pendingActions[minIdx], maxAction = pendingActions[maxIdx];
            pendingActions.splice(startIdx, pendingActions.length - startIdx);
            if (minIdx < maxIdx) {
                pendingActions.push(minAction);
                pendingActions.push(maxAction);
            } else if (minIdx > maxIdx) {
                pendingActions.push(maxAction);
                pendingActions.push(minAction);
            } else pendingActions.push(minAction);
        }
    };
    var flushActions = function flushActions(opt_noLossyCompression) {
        compressActions(opt_noLossyCompression);
        for(var i = 0, len = pendingActions.length; i < len; i++){
            var action = pendingActions[i];
            if (action[0] == LINE_TO) context.lineTo(action[1], action[2]);
            else if (action[0] == MOVE_TO) context.moveTo(action[1], action[2]);
        }
        if (pendingActions.length) lastFlushedX = pendingActions[pendingActions.length - 1][1];
        actionCount += pendingActions.length;
        pendingActions = [];
    };
    var addAction = function addAction(action, x, y) {
        var rx = Math.round(x);
        if (lastRoundedX === null || rx != lastRoundedX) {
            // if there are large gaps on the x-axis, it's essential to keep the
            // first and last point as well.
            var hasGapOnLeft = lastRoundedX - lastFlushedX > 1, hasGapOnRight = rx - lastRoundedX > 1, hasGap = hasGapOnLeft || hasGapOnRight;
            flushActions(hasGap);
            lastRoundedX = rx;
        }
        pendingActions.push([
            action,
            x,
            y
        ]);
    };
    return {
        moveTo: function moveTo(x, y) {
            addAction(MOVE_TO, x, y);
        },
        lineTo: function lineTo(x, y) {
            addAction(LINE_TO, x, y);
        },
        // for major operations like stroke/fill, we skip compression to ensure
        // that there are no artifacts at the right edge.
        stroke: function stroke() {
            flushActions(true);
            context.stroke();
        },
        fill: function fill() {
            flushActions(true);
            context.fill();
        },
        beginPath: function beginPath() {
            flushActions(true);
            context.beginPath();
        },
        closePath: function closePath() {
            flushActions(true);
            context.closePath();
        },
        _count: function _count() {
            return actionCount;
        }
    };
};
/**
 * Draws the shaded regions when "fillGraph" is set. Not to be confused with
 * error bars.
 *
 * For stacked charts, it's more convenient to handle all the series
 * simultaneously. So this plotter plots all the points on the first series
 * it's asked to draw, then ignores all the other series.
 *
 * @private
 */ $96f2ef959710507f$var$DygraphCanvasRenderer._fillPlotter = function(e) {
    // Skip if we're drawing a single series for interactive highlight overlay.
    if (e.singleSeriesName) return;
    // We'll handle all the series at once, not one-by-one.
    if (e.seriesIndex !== 0) return;
    var g = e.dygraph;
    var setNames = g.getLabels().slice(1); // remove x-axis
    // getLabels() includes names for invisible series, which are not included in
    // allSeriesPoints. We remove those to make the two match.
    // TODO(danvk): provide a simpler way to get this information.
    for(var i = setNames.length; i >= 0; i--)if (!g.visibility()[i]) setNames.splice(i, 1);
    var anySeriesFilled = function() {
        for(var i = 0; i < setNames.length; i++){
            if (g.getBooleanOption("fillGraph", setNames[i])) return true;
        }
        return false;
    }();
    if (!anySeriesFilled) return;
    var area = e.plotArea;
    var sets = e.allSeriesPoints;
    var setCount = sets.length;
    var stackedGraph = g.getBooleanOption("stackedGraph");
    var colors = g.getColors();
    // For stacked graphs, track the baseline for filling.
    //
    // The filled areas below graph lines are trapezoids with two
    // vertical edges. The top edge is the line segment being drawn, and
    // the baseline is the bottom edge. Each baseline corresponds to the
    // top line segment from the previous stacked line. In the case of
    // step plots, the trapezoids are rectangles.
    var baseline = {};
    var currBaseline;
    var prevStepPlot; // for different line drawing modes (line/step) per series
    // Helper function to trace a line back along the baseline.
    var traceBackPath = function traceBackPath(ctx, baselineX, baselineY, pathBack) {
        ctx.lineTo(baselineX, baselineY);
        if (stackedGraph) for(var i = pathBack.length - 1; i >= 0; i--){
            var pt = pathBack[i];
            ctx.lineTo(pt[0], pt[1]);
        }
    };
    // process sets in reverse order (needed for stacked graphs)
    for(var setIdx = setCount - 1; setIdx >= 0; setIdx--){
        var ctx = e.drawingContext;
        var setName = setNames[setIdx];
        if (!g.getBooleanOption('fillGraph', setName)) continue;
        var fillAlpha = g.getNumericOption('fillAlpha', setName);
        var stepPlot = g.getBooleanOption('stepPlot', setName);
        var color = colors[setIdx];
        var axis = g.axisPropertiesForSeries(setName);
        var axisY = 1.0 + axis.minyval * axis.yscale;
        if (axisY < 0.0) axisY = 0.0;
        else if (axisY > 1.0) axisY = 1.0;
        axisY = area.h * axisY + area.y;
        var points = sets[setIdx];
        var iter = $96f2ef959710507f$var$utils.createIterator(points, 0, points.length, $96f2ef959710507f$var$DygraphCanvasRenderer._getIteratorPredicate(g.getBooleanOption("connectSeparatedPoints", setName)));
        // setup graphics context
        var prevX = NaN;
        var prevYs = [
            -1,
            -1
        ];
        var newYs;
        // should be same color as the lines but only 15% opaque.
        var rgb = $96f2ef959710507f$var$utils.toRGB_(color);
        var err_color = 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + fillAlpha + ')';
        ctx.fillStyle = err_color;
        ctx.beginPath();
        var last_x, is_first = true;
        // If the point density is high enough, dropping segments on their way to
        // the canvas justifies the overhead of doing so.
        if (points.length > 2 * g.width_ || $96f2ef959710507f$var$_dygraph2['default'].FORCE_FAST_PROXY) ctx = $96f2ef959710507f$var$DygraphCanvasRenderer._fastCanvasProxy(ctx);
        // For filled charts, we draw points from left to right, then back along
        // the x-axis to complete a shape for filling.
        // For stacked plots, this "back path" is a more complex shape. This array
        // stores the [x, y] values needed to trace that shape.
        var pathBack = [];
        // TODO(danvk): there are a lot of options at play in this loop.
        //     The logic would be much clearer if some (e.g. stackGraph and
        //     stepPlot) were split off into separate sub-plotters.
        var point;
        while(iter.hasNext){
            point = iter.next();
            if (!$96f2ef959710507f$var$utils.isOK(point.y) && !stepPlot) {
                traceBackPath(ctx, prevX, prevYs[1], pathBack);
                pathBack = [];
                prevX = NaN;
                if (point.y_stacked !== null && !isNaN(point.y_stacked)) baseline[point.canvasx] = area.h * point.y_stacked + area.y;
                continue;
            }
            if (stackedGraph) {
                if (!is_first && last_x == point.xval) continue;
                else {
                    is_first = false;
                    last_x = point.xval;
                }
                currBaseline = baseline[point.canvasx];
                var lastY;
                if (currBaseline === undefined) lastY = axisY;
                else if (prevStepPlot) lastY = currBaseline[0];
                else lastY = currBaseline;
                newYs = [
                    point.canvasy,
                    lastY
                ];
                if (stepPlot) {
                    // Step plots must keep track of the top and bottom of
                    // the baseline at each point.
                    if (prevYs[0] === -1) baseline[point.canvasx] = [
                        point.canvasy,
                        axisY
                    ];
                    else baseline[point.canvasx] = [
                        point.canvasy,
                        prevYs[0]
                    ];
                } else baseline[point.canvasx] = point.canvasy;
            } else if (isNaN(point.canvasy) && stepPlot) newYs = [
                area.y + area.h,
                axisY
            ];
            else newYs = [
                point.canvasy,
                axisY
            ];
            if (!isNaN(prevX)) {
                // Move to top fill point
                if (stepPlot) {
                    ctx.lineTo(point.canvasx, prevYs[0]);
                    ctx.lineTo(point.canvasx, newYs[0]);
                } else ctx.lineTo(point.canvasx, newYs[0]);
                // Record the baseline for the reverse path.
                if (stackedGraph) {
                    pathBack.push([
                        prevX,
                        prevYs[1]
                    ]);
                    if (prevStepPlot && currBaseline) // Draw to the bottom of the baseline
                    pathBack.push([
                        point.canvasx,
                        currBaseline[1]
                    ]);
                    else pathBack.push([
                        point.canvasx,
                        newYs[1]
                    ]);
                }
            } else {
                ctx.moveTo(point.canvasx, newYs[1]);
                ctx.lineTo(point.canvasx, newYs[0]);
            }
            prevYs = newYs;
            prevX = point.canvasx;
        }
        prevStepPlot = stepPlot;
        if (newYs && point) {
            traceBackPath(ctx, point.canvasx, newYs[1], pathBack);
            pathBack = [];
        }
        ctx.fill();
    }
};
$96f2ef959710507f$exports['default'] = $96f2ef959710507f$var$DygraphCanvasRenderer;
$96f2ef959710507f$exports = $96f2ef959710507f$exports['default'];


var $298304f644e9f727$var$_dygraphCanvas2 = $298304f644e9f727$var$_interopRequireDefault($96f2ef959710507f$exports);
var $55a286a8f09ea149$exports = {};
/**
 * @license
 * Copyright 2011 Dan Vanderkam (danvdk@gmail.com)
 * MIT-licensed (http://opensource.org/licenses/MIT)
 */ /**
 * @fileoverview DygraphOptions is responsible for parsing and returning
 * information about options.
 */ // TODO: remove this jshint directive & fix the warnings.
/*jshint sub:true */ "use strict";
Object.defineProperty($55a286a8f09ea149$exports, '__esModule', {
    value: true
});
function $55a286a8f09ea149$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
function $55a286a8f09ea149$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj['default'] = obj;
        return newObj;
    }
}

var $55a286a8f09ea149$var$utils = $55a286a8f09ea149$var$_interopRequireWildcard($ad57523a9e758dd4$exports);
var $f2f2fb336886899a$exports = {};
'use strict';
Object.defineProperty($f2f2fb336886899a$exports, '__esModule', {
    value: true
});
function $f2f2fb336886899a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
function $f2f2fb336886899a$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj['default'] = obj;
        return newObj;
    }
}

var $f2f2fb336886899a$var$DygraphTickers = $f2f2fb336886899a$var$_interopRequireWildcard($c566217f290f99d9$exports);
var $e4a9bb31f64d7836$exports = {};
/**
 * @license
 * Copyright 2011 Robert Konigsberg (konigsberg@google.com)
 * MIT-licensed (http://opensource.org/licenses/MIT)
 */ /**
 * @fileoverview The default interaction model for Dygraphs. This is kept out
 * of dygraph.js for better navigability.
 * @author Robert Konigsberg (konigsberg@google.com)
 */ /*global Dygraph:false */ "use strict";
Object.defineProperty($e4a9bb31f64d7836$exports, "__esModule", {
    value: true
});
function $e4a9bb31f64d7836$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj["default"] = obj;
        return newObj;
    }
}

var $e4a9bb31f64d7836$var$utils = $e4a9bb31f64d7836$var$_interopRequireWildcard($ad57523a9e758dd4$exports);
/**
 * You can drag this many pixels past the edge of the chart and still have it
 * be considered a zoom. This makes it easier to zoom to the exact edge of the
 * chart, a fairly common operation.
 */ var $e4a9bb31f64d7836$var$DRAG_EDGE_MARGIN = 100;
/**
 * A collection of functions to facilitate build custom interaction models.
 * @class
 */ var $e4a9bb31f64d7836$var$DygraphInteraction = {};
/**
 * Checks whether the beginning & ending of an event were close enough that it
 * should be considered a click. If it should, dispatch appropriate events.
 * Returns true if the event was treated as a click.
 *
 * @param {Event} event
 * @param {Dygraph} g
 * @param {Object} context
 */ $e4a9bb31f64d7836$var$DygraphInteraction.maybeTreatMouseOpAsClick = function(event, g, context) {
    context.dragEndX = $e4a9bb31f64d7836$var$utils.dragGetX_(event, context);
    context.dragEndY = $e4a9bb31f64d7836$var$utils.dragGetY_(event, context);
    var regionWidth = Math.abs(context.dragEndX - context.dragStartX);
    var regionHeight = Math.abs(context.dragEndY - context.dragStartY);
    if (regionWidth < 2 && regionHeight < 2 && g.lastx_ !== undefined && g.lastx_ != -1) $e4a9bb31f64d7836$var$DygraphInteraction.treatMouseOpAsClick(g, event, context);
    context.regionWidth = regionWidth;
    context.regionHeight = regionHeight;
};
/**
 * Called in response to an interaction model operation that
 * should start the default panning behavior.
 *
 * It's used in the default callback for "mousedown" operations.
 * Custom interaction model builders can use it to provide the default
 * panning behavior.
 *
 * @param {Event} event the event object which led to the startPan call.
 * @param {Dygraph} g The dygraph on which to act.
 * @param {Object} context The dragging context object (with
 *     dragStartX/dragStartY/etc. properties). This function modifies the
 *     context.
 */ $e4a9bb31f64d7836$var$DygraphInteraction.startPan = function(event, g, context) {
    var i, axis;
    context.isPanning = true;
    var xRange = g.xAxisRange();
    if (g.getOptionForAxis("logscale", "x")) {
        context.initialLeftmostDate = $e4a9bb31f64d7836$var$utils.log10(xRange[0]);
        context.dateRange = $e4a9bb31f64d7836$var$utils.log10(xRange[1]) - $e4a9bb31f64d7836$var$utils.log10(xRange[0]);
    } else {
        context.initialLeftmostDate = xRange[0];
        context.dateRange = xRange[1] - xRange[0];
    }
    context.xUnitsPerPixel = context.dateRange / (g.plotter_.area.w - 1);
    if (g.getNumericOption("panEdgeFraction")) {
        var maxXPixelsToDraw = g.width_ * g.getNumericOption("panEdgeFraction");
        var xExtremes = g.xAxisExtremes(); // I REALLY WANT TO CALL THIS xTremes!
        var boundedLeftX = g.toDomXCoord(xExtremes[0]) - maxXPixelsToDraw;
        var boundedRightX = g.toDomXCoord(xExtremes[1]) + maxXPixelsToDraw;
        var boundedLeftDate = g.toDataXCoord(boundedLeftX);
        var boundedRightDate = g.toDataXCoord(boundedRightX);
        context.boundedDates = [
            boundedLeftDate,
            boundedRightDate
        ];
        var boundedValues = [];
        var maxYPixelsToDraw = g.height_ * g.getNumericOption("panEdgeFraction");
        for(i = 0; i < g.axes_.length; i++){
            axis = g.axes_[i];
            var yExtremes = axis.extremeRange;
            var boundedTopY = g.toDomYCoord(yExtremes[0], i) + maxYPixelsToDraw;
            var boundedBottomY = g.toDomYCoord(yExtremes[1], i) - maxYPixelsToDraw;
            var boundedTopValue = g.toDataYCoord(boundedTopY, i);
            var boundedBottomValue = g.toDataYCoord(boundedBottomY, i);
            boundedValues[i] = [
                boundedTopValue,
                boundedBottomValue
            ];
        }
        context.boundedValues = boundedValues;
    }
    // Record the range of each y-axis at the start of the drag.
    // If any axis has a valueRange, then we want a 2D pan.
    // We can't store data directly in g.axes_, because it does not belong to us
    // and could change out from under us during a pan (say if there's a data
    // update).
    context.is2DPan = false;
    context.axes = [];
    for(i = 0; i < g.axes_.length; i++){
        axis = g.axes_[i];
        var axis_data = {};
        var yRange = g.yAxisRange(i);
        // TODO(konigsberg): These values should be in |context|.
        // In log scale, initialTopValue, dragValueRange and unitsPerPixel are log scale.
        var logscale = g.attributes_.getForAxis("logscale", i);
        if (logscale) {
            axis_data.initialTopValue = $e4a9bb31f64d7836$var$utils.log10(yRange[1]);
            axis_data.dragValueRange = $e4a9bb31f64d7836$var$utils.log10(yRange[1]) - $e4a9bb31f64d7836$var$utils.log10(yRange[0]);
        } else {
            axis_data.initialTopValue = yRange[1];
            axis_data.dragValueRange = yRange[1] - yRange[0];
        }
        axis_data.unitsPerPixel = axis_data.dragValueRange / (g.plotter_.area.h - 1);
        context.axes.push(axis_data);
        // While calculating axes, set 2dpan.
        if (axis.valueRange) context.is2DPan = true;
    }
};
/**
 * Called in response to an interaction model operation that
 * responds to an event that pans the view.
 *
 * It's used in the default callback for "mousemove" operations.
 * Custom interaction model builders can use it to provide the default
 * panning behavior.
 *
 * @param {Event} event the event object which led to the movePan call.
 * @param {Dygraph} g The dygraph on which to act.
 * @param {Object} context The dragging context object (with
 *     dragStartX/dragStartY/etc. properties). This function modifies the
 *     context.
 */ $e4a9bb31f64d7836$var$DygraphInteraction.movePan = function(event, g, context) {
    context.dragEndX = $e4a9bb31f64d7836$var$utils.dragGetX_(event, context);
    context.dragEndY = $e4a9bb31f64d7836$var$utils.dragGetY_(event, context);
    var minDate = context.initialLeftmostDate - (context.dragEndX - context.dragStartX) * context.xUnitsPerPixel;
    if (context.boundedDates) minDate = Math.max(minDate, context.boundedDates[0]);
    var maxDate = minDate + context.dateRange;
    if (context.boundedDates) {
        if (maxDate > context.boundedDates[1]) {
            // Adjust minDate, and recompute maxDate.
            minDate = minDate - (maxDate - context.boundedDates[1]);
            maxDate = minDate + context.dateRange;
        }
    }
    if (g.getOptionForAxis("logscale", "x")) g.dateWindow_ = [
        Math.pow($e4a9bb31f64d7836$var$utils.LOG_SCALE, minDate),
        Math.pow($e4a9bb31f64d7836$var$utils.LOG_SCALE, maxDate)
    ];
    else g.dateWindow_ = [
        minDate,
        maxDate
    ];
    // y-axis scaling is automatic unless this is a full 2D pan.
    if (context.is2DPan) {
        var pixelsDragged = context.dragEndY - context.dragStartY;
        // Adjust each axis appropriately.
        for(var i = 0; i < g.axes_.length; i++){
            var axis = g.axes_[i];
            var axis_data = context.axes[i];
            var unitsDragged = pixelsDragged * axis_data.unitsPerPixel;
            var boundedValue = context.boundedValues ? context.boundedValues[i] : null;
            // In log scale, maxValue and minValue are the logs of those values.
            var maxValue = axis_data.initialTopValue + unitsDragged;
            if (boundedValue) maxValue = Math.min(maxValue, boundedValue[1]);
            var minValue = maxValue - axis_data.dragValueRange;
            if (boundedValue) {
                if (minValue < boundedValue[0]) {
                    // Adjust maxValue, and recompute minValue.
                    maxValue = maxValue - (minValue - boundedValue[0]);
                    minValue = maxValue - axis_data.dragValueRange;
                }
            }
            if (g.attributes_.getForAxis("logscale", i)) axis.valueRange = [
                Math.pow($e4a9bb31f64d7836$var$utils.LOG_SCALE, minValue),
                Math.pow($e4a9bb31f64d7836$var$utils.LOG_SCALE, maxValue)
            ];
            else axis.valueRange = [
                minValue,
                maxValue
            ];
        }
    }
    g.drawGraph_(false);
};
/**
 * Called in response to an interaction model operation that
 * responds to an event that ends panning.
 *
 * It's used in the default callback for "mouseup" operations.
 * Custom interaction model builders can use it to provide the default
 * panning behavior.
 *
 * @param {Event} event the event object which led to the endPan call.
 * @param {Dygraph} g The dygraph on which to act.
 * @param {Object} context The dragging context object (with
 *     dragStartX/dragStartY/etc. properties). This function modifies the
 *     context.
 */ $e4a9bb31f64d7836$var$DygraphInteraction.endPan = $e4a9bb31f64d7836$var$DygraphInteraction.maybeTreatMouseOpAsClick;
/**
 * Called in response to an interaction model operation that
 * responds to an event that starts zooming.
 *
 * It's used in the default callback for "mousedown" operations.
 * Custom interaction model builders can use it to provide the default
 * zooming behavior.
 *
 * @param {Event} event the event object which led to the startZoom call.
 * @param {Dygraph} g The dygraph on which to act.
 * @param {Object} context The dragging context object (with
 *     dragStartX/dragStartY/etc. properties). This function modifies the
 *     context.
 */ $e4a9bb31f64d7836$var$DygraphInteraction.startZoom = function(event, g, context) {
    context.isZooming = true;
    context.zoomMoved = false;
};
/**
 * Called in response to an interaction model operation that
 * responds to an event that defines zoom boundaries.
 *
 * It's used in the default callback for "mousemove" operations.
 * Custom interaction model builders can use it to provide the default
 * zooming behavior.
 *
 * @param {Event} event the event object which led to the moveZoom call.
 * @param {Dygraph} g The dygraph on which to act.
 * @param {Object} context The dragging context object (with
 *     dragStartX/dragStartY/etc. properties). This function modifies the
 *     context.
 */ $e4a9bb31f64d7836$var$DygraphInteraction.moveZoom = function(event, g, context) {
    context.zoomMoved = true;
    context.dragEndX = $e4a9bb31f64d7836$var$utils.dragGetX_(event, context);
    context.dragEndY = $e4a9bb31f64d7836$var$utils.dragGetY_(event, context);
    var xDelta = Math.abs(context.dragStartX - context.dragEndX);
    var yDelta = Math.abs(context.dragStartY - context.dragEndY);
    // drag direction threshold for y axis is twice as large as x axis
    context.dragDirection = xDelta < yDelta / 2 ? $e4a9bb31f64d7836$var$utils.VERTICAL : $e4a9bb31f64d7836$var$utils.HORIZONTAL;
    g.drawZoomRect_(context.dragDirection, context.dragStartX, context.dragEndX, context.dragStartY, context.dragEndY, context.prevDragDirection, context.prevEndX, context.prevEndY);
    context.prevEndX = context.dragEndX;
    context.prevEndY = context.dragEndY;
    context.prevDragDirection = context.dragDirection;
};
/**
 * TODO(danvk): move this logic into dygraph.js
 * @param {Dygraph} g
 * @param {Event} event
 * @param {Object} context
 */ $e4a9bb31f64d7836$var$DygraphInteraction.treatMouseOpAsClick = function(g, event, context) {
    var clickCallback = g.getFunctionOption('clickCallback');
    var pointClickCallback = g.getFunctionOption('pointClickCallback');
    var selectedPoint = null;
    // Find out if the click occurs on a point.
    var closestIdx = -1;
    var closestDistance = Number.MAX_VALUE;
    // check if the click was on a particular point.
    for(var i = 0; i < g.selPoints_.length; i++){
        var p = g.selPoints_[i];
        var distance = Math.pow(p.canvasx - context.dragEndX, 2) + Math.pow(p.canvasy - context.dragEndY, 2);
        if (!isNaN(distance) && (closestIdx == -1 || distance < closestDistance)) {
            closestDistance = distance;
            closestIdx = i;
        }
    }
    // Allow any click within two pixels of the dot.
    var radius = g.getNumericOption('highlightCircleSize') + 2;
    if (closestDistance <= radius * radius) selectedPoint = g.selPoints_[closestIdx];
    if (selectedPoint) {
        var e = {
            cancelable: true,
            point: selectedPoint,
            canvasx: context.dragEndX,
            canvasy: context.dragEndY
        };
        var defaultPrevented = g.cascadeEvents_('pointClick', e);
        if (defaultPrevented) // Note: this also prevents click / clickCallback from firing.
        return;
        if (pointClickCallback) pointClickCallback.call(g, event, selectedPoint);
    }
    var e = {
        cancelable: true,
        xval: g.lastx_,
        pts: g.selPoints_,
        canvasx: context.dragEndX,
        canvasy: context.dragEndY
    };
    if (!g.cascadeEvents_('click', e)) {
        if (clickCallback) // TODO(danvk): pass along more info about the points, e.g. 'x'
        clickCallback.call(g, event, g.lastx_, g.selPoints_);
    }
};
/**
 * Called in response to an interaction model operation that
 * responds to an event that performs a zoom based on previously defined
 * bounds..
 *
 * It's used in the default callback for "mouseup" operations.
 * Custom interaction model builders can use it to provide the default
 * zooming behavior.
 *
 * @param {Event} event the event object which led to the endZoom call.
 * @param {Dygraph} g The dygraph on which to end the zoom.
 * @param {Object} context The dragging context object (with
 *     dragStartX/dragStartY/etc. properties). This function modifies the
 *     context.
 */ $e4a9bb31f64d7836$var$DygraphInteraction.endZoom = function(event, g, context) {
    g.clearZoomRect_();
    context.isZooming = false;
    $e4a9bb31f64d7836$var$DygraphInteraction.maybeTreatMouseOpAsClick(event, g, context);
    // The zoom rectangle is visibly clipped to the plot area, so its behavior
    // should be as well.
    // See http://code.google.com/p/dygraphs/issues/detail?id=280
    var plotArea = g.getArea();
    if (context.regionWidth >= 10 && context.dragDirection == $e4a9bb31f64d7836$var$utils.HORIZONTAL) {
        var left = Math.min(context.dragStartX, context.dragEndX), right = Math.max(context.dragStartX, context.dragEndX);
        left = Math.max(left, plotArea.x);
        right = Math.min(right, plotArea.x + plotArea.w);
        if (left < right) g.doZoomX_(left, right);
        context.cancelNextDblclick = true;
    } else if (context.regionHeight >= 10 && context.dragDirection == $e4a9bb31f64d7836$var$utils.VERTICAL) {
        var top = Math.min(context.dragStartY, context.dragEndY), bottom = Math.max(context.dragStartY, context.dragEndY);
        top = Math.max(top, plotArea.y);
        bottom = Math.min(bottom, plotArea.y + plotArea.h);
        if (top < bottom) g.doZoomY_(top, bottom);
        context.cancelNextDblclick = true;
    }
    context.dragStartX = null;
    context.dragStartY = null;
};
/**
 * @private
 */ $e4a9bb31f64d7836$var$DygraphInteraction.startTouch = function(event, g, context) {
    event.preventDefault(); // touch browsers are all nice.
    if (event.touches.length > 1) // If the user ever puts two fingers down, it's not a double tap.
    context.startTimeForDoubleTapMs = null;
    var touches = [];
    for(var i = 0; i < event.touches.length; i++){
        var t = event.touches[i];
        // we dispense with 'dragGetX_' because all touchBrowsers support pageX
        touches.push({
            pageX: t.pageX,
            pageY: t.pageY,
            dataX: g.toDataXCoord(t.pageX),
            dataY: g.toDataYCoord(t.pageY)
        });
    }
    context.initialTouches = touches;
    if (touches.length == 1) {
        // This is just a swipe.
        context.initialPinchCenter = touches[0];
        context.touchDirections = {
            x: true,
            y: true
        };
    } else if (touches.length >= 2) {
        // It's become a pinch!
        // In case there are 3+ touches, we ignore all but the "first" two.
        // only screen coordinates can be averaged (data coords could be log scale).
        context.initialPinchCenter = {
            pageX: 0.5 * (touches[0].pageX + touches[1].pageX),
            pageY: 0.5 * (touches[0].pageY + touches[1].pageY),
            // TODO(danvk): remove
            dataX: 0.5 * (touches[0].dataX + touches[1].dataX),
            dataY: 0.5 * (touches[0].dataY + touches[1].dataY)
        };
        // Make pinches in a 45-degree swath around either axis 1-dimensional zooms.
        var initialAngle = 180 / Math.PI * Math.atan2(context.initialPinchCenter.pageY - touches[0].pageY, touches[0].pageX - context.initialPinchCenter.pageX);
        // use symmetry to get it into the first quadrant.
        initialAngle = Math.abs(initialAngle);
        if (initialAngle > 90) initialAngle = 90 - initialAngle;
        context.touchDirections = {
            x: initialAngle < 67.5,
            y: initialAngle > 22.5
        };
    }
    // save the full x & y ranges.
    context.initialRange = {
        x: g.xAxisRange(),
        y: g.yAxisRange()
    };
};
/**
 * @private
 */ $e4a9bb31f64d7836$var$DygraphInteraction.moveTouch = function(event, g, context) {
    // If the tap moves, then it's definitely not part of a double-tap.
    context.startTimeForDoubleTapMs = null;
    var i, touches = [];
    for(i = 0; i < event.touches.length; i++){
        var t = event.touches[i];
        touches.push({
            pageX: t.pageX,
            pageY: t.pageY
        });
    }
    var initialTouches = context.initialTouches;
    var c_now;
    // old and new centers.
    var c_init = context.initialPinchCenter;
    if (touches.length == 1) c_now = touches[0];
    else c_now = {
        pageX: 0.5 * (touches[0].pageX + touches[1].pageX),
        pageY: 0.5 * (touches[0].pageY + touches[1].pageY)
    };
    // this is the "swipe" component
    // we toss it out for now, but could use it in the future.
    var swipe = {
        pageX: c_now.pageX - c_init.pageX,
        pageY: c_now.pageY - c_init.pageY
    };
    var dataWidth = context.initialRange.x[1] - context.initialRange.x[0];
    var dataHeight = context.initialRange.y[0] - context.initialRange.y[1];
    swipe.dataX = swipe.pageX / g.plotter_.area.w * dataWidth;
    swipe.dataY = swipe.pageY / g.plotter_.area.h * dataHeight;
    var xScale, yScale;
    // The residual bits are usually split into scale & rotate bits, but we split
    // them into x-scale and y-scale bits.
    if (touches.length == 1) {
        xScale = 1.0;
        yScale = 1.0;
    } else if (touches.length >= 2) {
        var initHalfWidth = initialTouches[1].pageX - c_init.pageX;
        xScale = (touches[1].pageX - c_now.pageX) / initHalfWidth;
        var initHalfHeight = initialTouches[1].pageY - c_init.pageY;
        yScale = (touches[1].pageY - c_now.pageY) / initHalfHeight;
    }
    // Clip scaling to [1/8, 8] to prevent too much blowup.
    xScale = Math.min(8, Math.max(0.125, xScale));
    yScale = Math.min(8, Math.max(0.125, yScale));
    var didZoom = false;
    if (context.touchDirections.x) {
        g.dateWindow_ = [
            c_init.dataX - swipe.dataX + (context.initialRange.x[0] - c_init.dataX) / xScale,
            c_init.dataX - swipe.dataX + (context.initialRange.x[1] - c_init.dataX) / xScale
        ];
        didZoom = true;
    }
    if (context.touchDirections.y) for(i = 0; i < 1 /*g.axes_.length*/ ; i++){
        var axis = g.axes_[i];
        var logscale = g.attributes_.getForAxis("logscale", i);
        if (logscale) ;
        else {
            axis.valueRange = [
                c_init.dataY - swipe.dataY + (context.initialRange.y[0] - c_init.dataY) / yScale,
                c_init.dataY - swipe.dataY + (context.initialRange.y[1] - c_init.dataY) / yScale
            ];
            didZoom = true;
        }
    }
    g.drawGraph_(false);
    // We only call zoomCallback on zooms, not pans, to mirror desktop behavior.
    if (didZoom && touches.length > 1 && g.getFunctionOption('zoomCallback')) {
        var viewWindow = g.xAxisRange();
        g.getFunctionOption("zoomCallback").call(g, viewWindow[0], viewWindow[1], g.yAxisRanges());
    }
};
/**
 * @private
 */ $e4a9bb31f64d7836$var$DygraphInteraction.endTouch = function(event, g, context) {
    if (event.touches.length !== 0) // this is effectively a "reset"
    $e4a9bb31f64d7836$var$DygraphInteraction.startTouch(event, g, context);
    else if (event.changedTouches.length == 1) {
        // Could be part of a "double tap"
        // The heuristic here is that it's a double-tap if the two touchend events
        // occur within 500ms and within a 50x50 pixel box.
        var now = new Date().getTime();
        var t = event.changedTouches[0];
        if (context.startTimeForDoubleTapMs && now - context.startTimeForDoubleTapMs < 500 && context.doubleTapX && Math.abs(context.doubleTapX - t.screenX) < 50 && context.doubleTapY && Math.abs(context.doubleTapY - t.screenY) < 50) g.resetZoom();
        else {
            context.startTimeForDoubleTapMs = now;
            context.doubleTapX = t.screenX;
            context.doubleTapY = t.screenY;
        }
    }
};
// Determine the distance from x to [left, right].
var $e4a9bb31f64d7836$var$distanceFromInterval = function distanceFromInterval(x, left, right) {
    if (x < left) return left - x;
    else if (x > right) return x - right;
    else return 0;
};
/**
 * Returns the number of pixels by which the event happens from the nearest
 * edge of the chart. For events in the interior of the chart, this returns zero.
 */ var $e4a9bb31f64d7836$var$distanceFromChart = function distanceFromChart(event, g) {
    var chartPos = $e4a9bb31f64d7836$var$utils.findPos(g.canvas_);
    var box = {
        left: chartPos.x,
        right: chartPos.x + g.canvas_.offsetWidth,
        top: chartPos.y,
        bottom: chartPos.y + g.canvas_.offsetHeight
    };
    var pt = {
        x: $e4a9bb31f64d7836$var$utils.pageX(event),
        y: $e4a9bb31f64d7836$var$utils.pageY(event)
    };
    var dx = $e4a9bb31f64d7836$var$distanceFromInterval(pt.x, box.left, box.right), dy = $e4a9bb31f64d7836$var$distanceFromInterval(pt.y, box.top, box.bottom);
    return Math.max(dx, dy);
};
/**
 * Default interation model for dygraphs. You can refer to specific elements of
 * this when constructing your own interaction model, e.g.:
 * g.updateOptions( {
 *   interactionModel: {
 *     mousedown: DygraphInteraction.defaultInteractionModel.mousedown
 *   }
 * } );
 */ $e4a9bb31f64d7836$var$DygraphInteraction.defaultModel = {
    // Track the beginning of drag events
    mousedown: function mousedown(event, g, context) {
        // Right-click should not initiate a zoom.
        if (event.button && event.button == 2) return;
        context.initializeMouseDown(event, g, context);
        if (event.altKey || event.shiftKey) $e4a9bb31f64d7836$var$DygraphInteraction.startPan(event, g, context);
        else $e4a9bb31f64d7836$var$DygraphInteraction.startZoom(event, g, context);
        // Note: we register mousemove/mouseup on document to allow some leeway for
        // events to move outside of the chart. Interaction model events get
        // registered on the canvas, which is too small to allow this.
        var mousemove = function mousemove(event) {
            if (context.isZooming) {
                // When the mouse moves >200px from the chart edge, cancel the zoom.
                var d = $e4a9bb31f64d7836$var$distanceFromChart(event, g);
                if (d < $e4a9bb31f64d7836$var$DRAG_EDGE_MARGIN) $e4a9bb31f64d7836$var$DygraphInteraction.moveZoom(event, g, context);
                else if (context.dragEndX !== null) {
                    context.dragEndX = null;
                    context.dragEndY = null;
                    g.clearZoomRect_();
                }
            } else if (context.isPanning) $e4a9bb31f64d7836$var$DygraphInteraction.movePan(event, g, context);
        };
        var mouseup = function mouseup(event) {
            if (context.isZooming) {
                if (context.dragEndX !== null) $e4a9bb31f64d7836$var$DygraphInteraction.endZoom(event, g, context);
                else $e4a9bb31f64d7836$var$DygraphInteraction.maybeTreatMouseOpAsClick(event, g, context);
            } else if (context.isPanning) $e4a9bb31f64d7836$var$DygraphInteraction.endPan(event, g, context);
            $e4a9bb31f64d7836$var$utils.removeEvent(document, 'mousemove', mousemove);
            $e4a9bb31f64d7836$var$utils.removeEvent(document, 'mouseup', mouseup);
            context.destroy();
        };
        g.addAndTrackEvent(document, 'mousemove', mousemove);
        g.addAndTrackEvent(document, 'mouseup', mouseup);
    },
    willDestroyContextMyself: true,
    touchstart: function touchstart(event, g, context) {
        $e4a9bb31f64d7836$var$DygraphInteraction.startTouch(event, g, context);
    },
    touchmove: function touchmove(event, g, context) {
        $e4a9bb31f64d7836$var$DygraphInteraction.moveTouch(event, g, context);
    },
    touchend: function touchend(event, g, context) {
        $e4a9bb31f64d7836$var$DygraphInteraction.endTouch(event, g, context);
    },
    // Disable zooming out if panning.
    dblclick: function dblclick(event, g, context) {
        if (context.cancelNextDblclick) {
            context.cancelNextDblclick = false;
            return;
        }
        // Give plugins a chance to grab this event.
        var e = {
            canvasx: context.dragEndX,
            canvasy: context.dragEndY,
            cancelable: true
        };
        if (g.cascadeEvents_('dblclick', e)) return;
        if (event.altKey || event.shiftKey) return;
        g.resetZoom();
    }
};
/*
Dygraph.DEFAULT_ATTRS.interactionModel = DygraphInteraction.defaultModel;

// old ways of accessing these methods/properties
Dygraph.defaultInteractionModel = DygraphInteraction.defaultModel;
Dygraph.endZoom = DygraphInteraction.endZoom;
Dygraph.moveZoom = DygraphInteraction.moveZoom;
Dygraph.startZoom = DygraphInteraction.startZoom;
Dygraph.endPan = DygraphInteraction.endPan;
Dygraph.movePan = DygraphInteraction.movePan;
Dygraph.startPan = DygraphInteraction.startPan;
*/ $e4a9bb31f64d7836$var$DygraphInteraction.nonInteractiveModel_ = {
    mousedown: function mousedown(event, g, context) {
        context.initializeMouseDown(event, g, context);
    },
    mouseup: $e4a9bb31f64d7836$var$DygraphInteraction.maybeTreatMouseOpAsClick
};
// Default interaction model when using the range selector.
$e4a9bb31f64d7836$var$DygraphInteraction.dragIsPanInteractionModel = {
    mousedown: function mousedown(event, g, context) {
        context.initializeMouseDown(event, g, context);
        $e4a9bb31f64d7836$var$DygraphInteraction.startPan(event, g, context);
    },
    mousemove: function mousemove(event, g, context) {
        if (context.isPanning) $e4a9bb31f64d7836$var$DygraphInteraction.movePan(event, g, context);
    },
    mouseup: function mouseup(event, g, context) {
        if (context.isPanning) $e4a9bb31f64d7836$var$DygraphInteraction.endPan(event, g, context);
    }
};
$e4a9bb31f64d7836$exports["default"] = $e4a9bb31f64d7836$var$DygraphInteraction;
$e4a9bb31f64d7836$exports = $e4a9bb31f64d7836$exports["default"];


var $f2f2fb336886899a$var$_dygraphInteractionModel2 = $f2f2fb336886899a$var$_interopRequireDefault($e4a9bb31f64d7836$exports);

var $f2f2fb336886899a$var$_dygraphCanvas2 = $f2f2fb336886899a$var$_interopRequireDefault($96f2ef959710507f$exports);

var $f2f2fb336886899a$var$utils = $f2f2fb336886899a$var$_interopRequireWildcard($ad57523a9e758dd4$exports);
// Default attribute values.
var $f2f2fb336886899a$var$DEFAULT_ATTRS = {
    highlightCircleSize: 3,
    highlightSeriesOpts: null,
    highlightSeriesBackgroundAlpha: 0.5,
    highlightSeriesBackgroundColor: 'rgb(255, 255, 255)',
    labelsSeparateLines: false,
    labelsShowZeroValues: true,
    labelsKMB: false,
    labelsKMG2: false,
    showLabelsOnHighlight: true,
    digitsAfterDecimal: 2,
    maxNumberWidth: 6,
    sigFigs: null,
    strokeWidth: 1.0,
    strokeBorderWidth: 0,
    strokeBorderColor: "white",
    axisTickSize: 3,
    axisLabelFontSize: 14,
    rightGap: 5,
    showRoller: false,
    xValueParser: undefined,
    delimiter: ',',
    sigma: 2.0,
    errorBars: false,
    fractions: false,
    wilsonInterval: true,
    customBars: false,
    fillGraph: false,
    fillAlpha: 0.15,
    connectSeparatedPoints: false,
    stackedGraph: false,
    stackedGraphNaNFill: 'all',
    hideOverlayOnMouseOut: true,
    legend: 'onmouseover',
    stepPlot: false,
    xRangePad: 0,
    yRangePad: null,
    drawAxesAtZero: false,
    // Sizes of the various chart labels.
    titleHeight: 28,
    xLabelHeight: 18,
    yLabelWidth: 18,
    axisLineColor: "black",
    axisLineWidth: 0.3,
    gridLineWidth: 0.3,
    axisLabelWidth: 50,
    gridLineColor: "rgb(128,128,128)",
    interactionModel: $f2f2fb336886899a$var$_dygraphInteractionModel2['default'].defaultModel,
    animatedZooms: false,
    // Range selector options
    showRangeSelector: false,
    rangeSelectorHeight: 40,
    rangeSelectorPlotStrokeColor: "#808FAB",
    rangeSelectorPlotFillGradientColor: "white",
    rangeSelectorPlotFillColor: "#A7B1C4",
    rangeSelectorBackgroundStrokeColor: "gray",
    rangeSelectorBackgroundLineWidth: 1,
    rangeSelectorPlotLineWidth: 1.5,
    rangeSelectorForegroundStrokeColor: "black",
    rangeSelectorForegroundLineWidth: 1,
    rangeSelectorAlpha: 0.6,
    showInRangeSelector: null,
    // The ordering here ensures that central lines always appear above any
    // fill bars/error bars.
    plotter: [
        $f2f2fb336886899a$var$_dygraphCanvas2['default']._fillPlotter,
        $f2f2fb336886899a$var$_dygraphCanvas2['default']._errorPlotter,
        $f2f2fb336886899a$var$_dygraphCanvas2['default']._linePlotter
    ],
    plugins: [],
    // per-axis options
    axes: {
        x: {
            pixelsPerLabel: 70,
            axisLabelWidth: 60,
            axisLabelFormatter: $f2f2fb336886899a$var$utils.dateAxisLabelFormatter,
            valueFormatter: $f2f2fb336886899a$var$utils.dateValueFormatter,
            drawGrid: true,
            drawAxis: true,
            independentTicks: true,
            ticker: $f2f2fb336886899a$var$DygraphTickers.dateTicker
        },
        y: {
            axisLabelWidth: 50,
            pixelsPerLabel: 30,
            valueFormatter: $f2f2fb336886899a$var$utils.numberValueFormatter,
            axisLabelFormatter: $f2f2fb336886899a$var$utils.numberAxisLabelFormatter,
            drawGrid: true,
            drawAxis: true,
            independentTicks: true,
            ticker: $f2f2fb336886899a$var$DygraphTickers.numericTicks
        },
        y2: {
            axisLabelWidth: 50,
            pixelsPerLabel: 30,
            valueFormatter: $f2f2fb336886899a$var$utils.numberValueFormatter,
            axisLabelFormatter: $f2f2fb336886899a$var$utils.numberAxisLabelFormatter,
            drawAxis: true,
            drawGrid: false,
            independentTicks: false,
            ticker: $f2f2fb336886899a$var$DygraphTickers.numericTicks
        }
    }
};
$f2f2fb336886899a$exports['default'] = $f2f2fb336886899a$var$DEFAULT_ATTRS;
$f2f2fb336886899a$exports = $f2f2fb336886899a$exports['default'];


var $55a286a8f09ea149$var$_dygraphDefaultAttrs2 = $55a286a8f09ea149$var$_interopRequireDefault($f2f2fb336886899a$exports);
var $96fe51d6df0cf40d$exports = {};
/**
 * @license
 * Copyright 2011 Dan Vanderkam (danvdk@gmail.com)
 * MIT-licensed (http://opensource.org/licenses/MIT)
 */ "use strict";
Object.defineProperty($96fe51d6df0cf40d$exports, '__esModule', {
    value: true
});
var $96fe51d6df0cf40d$var$OPTIONS_REFERENCE = null;
var $96fe51d6df0cf40d$var$warn, $96fe51d6df0cf40d$var$flds, $96fe51d6df0cf40d$var$valid_cats, $96fe51d6df0cf40d$var$i, $96fe51d6df0cf40d$var$cats, $96fe51d6df0cf40d$var$k, $96fe51d6df0cf40d$var$op, $96fe51d6df0cf40d$var$labels;
$96fe51d6df0cf40d$exports['default'] = $96fe51d6df0cf40d$var$OPTIONS_REFERENCE;
$96fe51d6df0cf40d$exports = $96fe51d6df0cf40d$exports['default'];


var $55a286a8f09ea149$var$_dygraphOptionsReference2 = $55a286a8f09ea149$var$_interopRequireDefault($96fe51d6df0cf40d$exports);
/*
 * Interesting member variables: (REMOVING THIS LIST AS I CLOSURIZE)
 * global_ - global attributes (common among all graphs, AIUI)
 * user - attributes set by the user
 * series_ - { seriesName -> { idx, yAxis, options }}
 */ /**
 * This parses attributes into an object that can be easily queried.
 *
 * It doesn't necessarily mean that all options are available, specifically
 * if labels are not yet available, since those drive details of the per-series
 * and per-axis options.
 *
 * @param {Dygraph} dygraph The chart to which these options belong.
 * @constructor
 */ var $55a286a8f09ea149$var$DygraphOptions = function DygraphOptions(dygraph) {
    /**
   * The dygraph.
   * @type {!Dygraph}
   */ this.dygraph_ = dygraph;
    /**
   * Array of axis index to { series : [ series names ] , options : { axis-specific options. }
   * @type {Array.<{series : Array.<string>, options : Object}>} @private
   */ this.yAxes_ = [];
    /**
   * Contains x-axis specific options, which are stored in the options key.
   * This matches the yAxes_ object structure (by being a dictionary with an
   * options element) allowing for shared code.
   * @type {options: Object} @private
   */ this.xAxis_ = {};
    this.series_ = {};
    // Once these two objects are initialized, you can call get();
    this.global_ = this.dygraph_.attrs_;
    this.user_ = this.dygraph_.user_attrs_ || {};
    /**
   * A list of series in columnar order.
   * @type {Array.<string>}
   */ this.labels_ = [];
    this.highlightSeries_ = this.get("highlightSeriesOpts") || {};
    this.reparseSeries();
};
/**
 * Not optimal, but does the trick when you're only using two axes.
 * If we move to more axes, this can just become a function.
 *
 * @type {Object.<number>}
 * @private
 */ $55a286a8f09ea149$var$DygraphOptions.AXIS_STRING_MAPPINGS_ = {
    'y': 0,
    'Y': 0,
    'y1': 0,
    'Y1': 0,
    'y2': 1,
    'Y2': 1
};
/**
 * @param {string|number} axis
 * @private
 */ $55a286a8f09ea149$var$DygraphOptions.axisToIndex_ = function(axis) {
    if (typeof axis == "string") {
        if ($55a286a8f09ea149$var$DygraphOptions.AXIS_STRING_MAPPINGS_.hasOwnProperty(axis)) return $55a286a8f09ea149$var$DygraphOptions.AXIS_STRING_MAPPINGS_[axis];
        throw "Unknown axis : " + axis;
    }
    if (typeof axis == "number") {
        if (axis === 0 || axis === 1) return axis;
        throw "Dygraphs only supports two y-axes, indexed from 0-1.";
    }
    if (axis) throw "Unknown axis : " + axis;
    // No axis specification means axis 0.
    return 0;
};
/**
 * Reparses options that are all related to series. This typically occurs when
 * options are either updated, or source data has been made available.
 *
 * TODO(konigsberg): The method name is kind of weak; fix.
 */ $55a286a8f09ea149$var$DygraphOptions.prototype.reparseSeries = function() {
    var labels = this.get("labels");
    if (!labels) return; // -- can't do more for now, will parse after getting the labels.
    this.labels_ = labels.slice(1);
    this.yAxes_ = [
        {
            series: [],
            options: {}
        }
    ]; // Always one axis at least.
    this.xAxis_ = {
        options: {}
    };
    this.series_ = {};
    // Series are specified in the series element:
    //
    // {
    //   labels: [ "X", "foo", "bar" ],
    //   pointSize: 3,
    //   series : {
    //     foo : {}, // options for foo
    //     bar : {} // options for bar
    //   }
    // }
    //
    // So, if series is found, it's expected to contain per-series data, otherwise set a
    // default.
    var seriesDict = this.user_.series || {};
    for(var idx = 0; idx < this.labels_.length; idx++){
        var seriesName = this.labels_[idx];
        var optionsForSeries = seriesDict[seriesName] || {};
        var yAxis = $55a286a8f09ea149$var$DygraphOptions.axisToIndex_(optionsForSeries["axis"]);
        this.series_[seriesName] = {
            idx: idx,
            yAxis: yAxis,
            options: optionsForSeries
        };
        if (!this.yAxes_[yAxis]) this.yAxes_[yAxis] = {
            series: [
                seriesName
            ],
            options: {}
        };
        else this.yAxes_[yAxis].series.push(seriesName);
    }
    var axis_opts = this.user_["axes"] || {};
    $55a286a8f09ea149$var$utils.update(this.yAxes_[0].options, axis_opts["y"] || {});
    if (this.yAxes_.length > 1) $55a286a8f09ea149$var$utils.update(this.yAxes_[1].options, axis_opts["y2"] || {});
    $55a286a8f09ea149$var$utils.update(this.xAxis_.options, axis_opts["x"] || {});
};
/**
 * Get a global value.
 *
 * @param {string} name the name of the option.
 */ $55a286a8f09ea149$var$DygraphOptions.prototype.get = function(name) {
    var result = this.getGlobalUser_(name);
    if (result !== null) return result;
    return this.getGlobalDefault_(name);
};
$55a286a8f09ea149$var$DygraphOptions.prototype.getGlobalUser_ = function(name) {
    if (this.user_.hasOwnProperty(name)) return this.user_[name];
    return null;
};
$55a286a8f09ea149$var$DygraphOptions.prototype.getGlobalDefault_ = function(name) {
    if (this.global_.hasOwnProperty(name)) return this.global_[name];
    if ($55a286a8f09ea149$var$_dygraphDefaultAttrs2['default'].hasOwnProperty(name)) return $55a286a8f09ea149$var$_dygraphDefaultAttrs2['default'][name];
    return null;
};
/**
 * Get a value for a specific axis. If there is no specific value for the axis,
 * the global value is returned.
 *
 * @param {string} name the name of the option.
 * @param {string|number} axis the axis to search. Can be the string representation
 * ("y", "y2") or the axis number (0, 1).
 */ $55a286a8f09ea149$var$DygraphOptions.prototype.getForAxis = function(name, axis) {
    var axisIdx;
    var axisString;
    // Since axis can be a number or a string, straighten everything out here.
    if (typeof axis == 'number') {
        axisIdx = axis;
        axisString = axisIdx === 0 ? "y" : "y2";
    } else {
        if (axis == "y1") axis = "y";
         // Standardize on 'y'. Is this bad? I think so.
        if (axis == "y") axisIdx = 0;
        else if (axis == "y2") axisIdx = 1;
        else if (axis == "x") axisIdx = -1; // simply a placeholder for below.
        else throw "Unknown axis " + axis;
        axisString = axis;
    }
    var userAxis = axisIdx == -1 ? this.xAxis_ : this.yAxes_[axisIdx];
    // Search the user-specified axis option first.
    if (userAxis) {
        // This condition could be removed if we always set up this.yAxes_ for y2.
        var axisOptions = userAxis.options;
        if (axisOptions.hasOwnProperty(name)) return axisOptions[name];
    }
    // User-specified global options second.
    // But, hack, ignore globally-specified 'logscale' for 'x' axis declaration.
    if (!(axis === 'x' && name === 'logscale')) {
        var result = this.getGlobalUser_(name);
        if (result !== null) return result;
    }
    // Default axis options third.
    var defaultAxisOptions = $55a286a8f09ea149$var$_dygraphDefaultAttrs2['default'].axes[axisString];
    if (defaultAxisOptions.hasOwnProperty(name)) return defaultAxisOptions[name];
    // Default global options last.
    return this.getGlobalDefault_(name);
};
/**
 * Get a value for a specific series. If there is no specific value for the series,
 * the value for the axis is returned (and afterwards, the global value.)
 *
 * @param {string} name the name of the option.
 * @param {string} series the series to search.
 */ $55a286a8f09ea149$var$DygraphOptions.prototype.getForSeries = function(name, series) {
    // Honors indexes as series.
    if (series === this.dygraph_.getHighlightSeries()) {
        if (this.highlightSeries_.hasOwnProperty(name)) return this.highlightSeries_[name];
    }
    if (!this.series_.hasOwnProperty(series)) throw "Unknown series: " + series;
    var seriesObj = this.series_[series];
    var seriesOptions = seriesObj["options"];
    if (seriesOptions.hasOwnProperty(name)) return seriesOptions[name];
    return this.getForAxis(name, seriesObj["yAxis"]);
};
/**
 * Returns the number of y-axes on the chart.
 * @return {number} the number of axes.
 */ $55a286a8f09ea149$var$DygraphOptions.prototype.numAxes = function() {
    return this.yAxes_.length;
};
/**
 * Return the y-axis for a given series, specified by name.
 */ $55a286a8f09ea149$var$DygraphOptions.prototype.axisForSeries = function(series) {
    return this.series_[series].yAxis;
};
/**
 * Returns the options for the specified axis.
 */ // TODO(konigsberg): this is y-axis specific. Support the x axis.
$55a286a8f09ea149$var$DygraphOptions.prototype.axisOptions = function(yAxis) {
    return this.yAxes_[yAxis].options;
};
/**
 * Return the series associated with an axis.
 */ $55a286a8f09ea149$var$DygraphOptions.prototype.seriesForAxis = function(yAxis) {
    return this.yAxes_[yAxis].series;
};
/**
 * Return the list of all series, in their columnar order.
 */ $55a286a8f09ea149$var$DygraphOptions.prototype.seriesNames = function() {
    return this.labels_;
};
var $55a286a8f09ea149$var$WARNINGS;
$55a286a8f09ea149$exports['default'] = $55a286a8f09ea149$var$DygraphOptions;
$55a286a8f09ea149$exports = $55a286a8f09ea149$exports['default'];


var $298304f644e9f727$var$_dygraphOptions2 = $298304f644e9f727$var$_interopRequireDefault($55a286a8f09ea149$exports);

var $298304f644e9f727$var$_dygraphInteractionModel2 = $298304f644e9f727$var$_interopRequireDefault($e4a9bb31f64d7836$exports);

var $298304f644e9f727$var$DygraphTickers = $298304f644e9f727$var$_interopRequireWildcard($c566217f290f99d9$exports);

var $298304f644e9f727$var$utils = $298304f644e9f727$var$_interopRequireWildcard($ad57523a9e758dd4$exports);

var $298304f644e9f727$var$_dygraphDefaultAttrs2 = $298304f644e9f727$var$_interopRequireDefault($f2f2fb336886899a$exports);

var $298304f644e9f727$var$_dygraphOptionsReference2 = $298304f644e9f727$var$_interopRequireDefault($96fe51d6df0cf40d$exports);
var $ede8be30660062dd$exports = {};
/**
 * To create a "drag" interaction, you typically register a mousedown event
 * handler on the element where the drag begins. In that handler, you register a
 * mouseup handler on the window to determine when the mouse is released,
 * wherever that release happens. This works well, except when the user releases
 * the mouse over an off-domain iframe. In that case, the mouseup event is
 * handled by the iframe and never bubbles up to the window handler.
 *
 * To deal with this issue, we cover iframes with high z-index divs to make sure
 * they don't capture mouseup.
 *
 * Usage:
 * element.addEventListener('mousedown', function() {
 *   var tarper = new IFrameTarp();
 *   tarper.cover();
 *   var mouseUpHandler = function() {
 *     ...
 *     window.removeEventListener(mouseUpHandler);
 *     tarper.uncover();
 *   };
 *   window.addEventListener('mouseup', mouseUpHandler);
 * };
 *
 * @constructor
 */ "use strict";
Object.defineProperty($ede8be30660062dd$exports, "__esModule", {
    value: true
});
function $ede8be30660062dd$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj["default"] = obj;
        return newObj;
    }
}

var $ede8be30660062dd$var$utils = $ede8be30660062dd$var$_interopRequireWildcard($ad57523a9e758dd4$exports);
function $ede8be30660062dd$var$IFrameTarp() {
    /** @type {Array.<!HTMLDivElement>} */ this.tarps = [];
}
/**
 * Find all the iframes in the document and cover them with high z-index
 * transparent divs.
 */ $ede8be30660062dd$var$IFrameTarp.prototype.cover = function() {
    var iframes = document.getElementsByTagName("iframe");
    for(var i = 0; i < iframes.length; i++){
        var iframe = iframes[i];
        var pos = $ede8be30660062dd$var$utils.findPos(iframe), x = pos.x, y = pos.y, width = iframe.offsetWidth, height = iframe.offsetHeight;
        var div = document.createElement("div");
        div.style.position = "absolute";
        div.style.left = x + 'px';
        div.style.top = y + 'px';
        div.style.width = width + 'px';
        div.style.height = height + 'px';
        div.style.zIndex = 999;
        document.body.appendChild(div);
        this.tarps.push(div);
    }
};
/**
 * Remove all the iframe covers. You should call this in a mouseup handler.
 */ $ede8be30660062dd$var$IFrameTarp.prototype.uncover = function() {
    for(var i = 0; i < this.tarps.length; i++)this.tarps[i].parentNode.removeChild(this.tarps[i]);
    this.tarps = [];
};
$ede8be30660062dd$exports["default"] = $ede8be30660062dd$var$IFrameTarp;
$ede8be30660062dd$exports = $ede8be30660062dd$exports["default"];


var $298304f644e9f727$var$_iframeTarp2 = $298304f644e9f727$var$_interopRequireDefault($ede8be30660062dd$exports);
var $a48ee8dda7f46294$exports = {};
/**
 * @license
 * Copyright 2013 David Eberlein (david.eberlein@ch.sauter-bc.com)
 * MIT-licensed (http://opensource.org/licenses/MIT)
 */ /**
 * @fileoverview DataHandler default implementation used for simple line charts.
 * @author David Eberlein (david.eberlein@ch.sauter-bc.com)
 */ /*global Dygraph:false */ "use strict";
Object.defineProperty($a48ee8dda7f46294$exports, '__esModule', {
    value: true
});
function $a48ee8dda7f46294$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $61be5135933f4d60$exports = {};
/**
 * @license
 * Copyright 2013 David Eberlein (david.eberlein@ch.sauter-bc.com)
 * MIT-licensed (http://opensource.org/licenses/MIT)
 */ /**
 * @fileoverview This file contains the managment of data handlers
 * @author David Eberlein (david.eberlein@ch.sauter-bc.com)
 *
 * The idea is to define a common, generic data format that works for all data
 * structures supported by dygraphs. To make this possible, the DataHandler
 * interface is introduced. This makes it possible, that dygraph itself can work
 * with the same logic for every data type independent of the actual format and
 * the DataHandler takes care of the data format specific jobs.
 * DataHandlers are implemented for all data types supported by Dygraphs and
 * return Dygraphs compliant formats.
 * By default the correct DataHandler is chosen based on the options set.
 * Optionally the user may use his own DataHandler (similar to the plugin
 * system).
 *
 *
 * The unified data format returend by each handler is defined as so:
 * series[n][point] = [x,y,(extras)]
 *
 * This format contains the common basis that is needed to draw a simple line
 * series extended by optional extras for more complex graphing types. It
 * contains a primitive x value as first array entry, a primitive y value as
 * second array entry and an optional extras object for additional data needed.
 *
 * x must always be a number.
 * y must always be a number, NaN of type number or null.
 * extras is optional and must be interpreted by the DataHandler. It may be of
 * any type.
 *
 * In practice this might look something like this:
 * default: [x, yVal]
 * errorBar / customBar: [x, yVal, [yTopVariance, yBottomVariance] ]
 *
 */ /*global Dygraph:false */ /*global DygraphLayout:false */ "use strict";
/**
 *
 * The data handler is responsible for all data specific operations. All of the
 * series data it receives and returns is always in the unified data format.
 * Initially the unified data is created by the extractSeries method
 * @constructor
 */ Object.defineProperty($61be5135933f4d60$exports, "__esModule", {
    value: true
});
var $61be5135933f4d60$var$DygraphDataHandler = function DygraphDataHandler() {};
var $61be5135933f4d60$var$handler = $61be5135933f4d60$var$DygraphDataHandler;
/**
 * X-value array index constant for unified data samples.
 * @const
 * @type {number}
 */ $61be5135933f4d60$var$handler.X = 0;
/**
 * Y-value array index constant for unified data samples.
 * @const
 * @type {number}
 */ $61be5135933f4d60$var$handler.Y = 1;
/**
 * Extras-value array index constant for unified data samples.
 * @const
 * @type {number}
 */ $61be5135933f4d60$var$handler.EXTRAS = 2;
/**
 * Extracts one series from the raw data (a 2D array) into an array of the
 * unified data format.
 * This is where undesirable points (i.e. negative values on log scales and
 * missing values through which we wish to connect lines) are dropped.
 * TODO(danvk): the "missing values" bit above doesn't seem right.
 *
 * @param {!Array.<Array>} rawData The raw data passed into dygraphs where
 *     rawData[i] = [x,ySeries1,...,ySeriesN].
 * @param {!number} seriesIndex Index of the series to extract. All other
 *     series should be ignored.
 * @param {!DygraphOptions} options Dygraph options.
 * @return {Array.<[!number,?number,?]>} The series in the unified data format
 *     where series[i] = [x,y,{extras}].
 */ $61be5135933f4d60$var$handler.prototype.extractSeries = function(rawData, seriesIndex, options) {};
/**
 * Converts a series to a Point array.  The resulting point array must be
 * returned in increasing order of idx property.
 *
 * @param {!Array.<[!number,?number,?]>} series The series in the unified
 *          data format where series[i] = [x,y,{extras}].
 * @param {!string} setName Name of the series.
 * @param {!number} boundaryIdStart Index offset of the first point, equal to the
 *          number of skipped points left of the date window minimum (if any).
 * @return {!Array.<Dygraph.PointType>} List of points for this series.
 */ $61be5135933f4d60$var$handler.prototype.seriesToPoints = function(series, setName, boundaryIdStart) {
    // TODO(bhs): these loops are a hot-spot for high-point-count charts. In
    // fact,
    // on chrome+linux, they are 6 times more expensive than iterating through
    // the
    // points and drawing the lines. The brunt of the cost comes from allocating
    // the |point| structures.
    var points = [];
    for(var i = 0; i < series.length; ++i){
        var item = series[i];
        var yraw = item[1];
        var yval = yraw === null ? null : $61be5135933f4d60$var$handler.parseFloat(yraw);
        var point = {
            x: NaN,
            y: NaN,
            xval: $61be5135933f4d60$var$handler.parseFloat(item[0]),
            yval: yval,
            name: setName,
            idx: i + boundaryIdStart
        };
        points.push(point);
    }
    this.onPointsCreated_(series, points);
    return points;
};
/**
 * Callback called for each series after the series points have been generated
 * which will later be used by the plotters to draw the graph.
 * Here data may be added to the seriesPoints which is needed by the plotters.
 * The indexes of series and points are in sync meaning the original data
 * sample for series[i] is points[i].
 *
 * @param {!Array.<[!number,?number,?]>} series The series in the unified
 *     data format where series[i] = [x,y,{extras}].
 * @param {!Array.<Dygraph.PointType>} points The corresponding points passed
 *     to the plotter.
 * @protected
 */ $61be5135933f4d60$var$handler.prototype.onPointsCreated_ = function(series, points) {};
/**
 * Calculates the rolling average of a data set.
 *
 * @param {!Array.<[!number,?number,?]>} series The series in the unified
 *          data format where series[i] = [x,y,{extras}].
 * @param {!number} rollPeriod The number of points over which to average the data
 * @param {!DygraphOptions} options The dygraph options.
 * @return {!Array.<[!number,?number,?]>} the rolled series.
 */ $61be5135933f4d60$var$handler.prototype.rollingAverage = function(series, rollPeriod, options) {};
/**
 * Computes the range of the data series (including confidence intervals).
 *
 * @param {!Array.<[!number,?number,?]>} series The series in the unified
 *     data format where series[i] = [x, y, {extras}].
 * @param {!Array.<number>} dateWindow The x-value range to display with
 *     the format: [min, max].
 * @param {!DygraphOptions} options The dygraph options.
 * @return {Array.<number>} The low and high extremes of the series in the
 *     given window with the format: [low, high].
 */ $61be5135933f4d60$var$handler.prototype.getExtremeYValues = function(series, dateWindow, options) {};
/**
 * Callback called for each series after the layouting data has been
 * calculated before the series is drawn. Here normalized positioning data
 * should be calculated for the extras of each point.
 *
 * @param {!Array.<Dygraph.PointType>} points The points passed to
 *          the plotter.
 * @param {!Object} axis The axis on which the series will be plotted.
 * @param {!boolean} logscale Weather or not to use a logscale.
 */ $61be5135933f4d60$var$handler.prototype.onLineEvaluated = function(points, axis, logscale) {};
/**
 * Optimized replacement for parseFloat, which was way too slow when almost
 * all values were type number, with few edge cases, none of which were strings.
 * @param {?number} val
 * @return {number}
 * @protected
 */ $61be5135933f4d60$var$handler.parseFloat = function(val) {
    // parseFloat(null) is NaN
    if (val === null) return NaN;
    // Assume it's a number or NaN. If it's something else, I'll be shocked.
    return val;
};
$61be5135933f4d60$exports["default"] = $61be5135933f4d60$var$DygraphDataHandler;
$61be5135933f4d60$exports = $61be5135933f4d60$exports["default"];


var $a48ee8dda7f46294$var$_datahandler2 = $a48ee8dda7f46294$var$_interopRequireDefault($61be5135933f4d60$exports);
/**
 * @constructor
 * @extends Dygraph.DataHandler
 */ var $a48ee8dda7f46294$var$DefaultHandler = function DefaultHandler() {};
$a48ee8dda7f46294$var$DefaultHandler.prototype = new $a48ee8dda7f46294$var$_datahandler2['default']();
/** @inheritDoc */ $a48ee8dda7f46294$var$DefaultHandler.prototype.extractSeries = function(rawData, i, options) {
    // TODO(danvk): pre-allocate series here.
    var series = [];
    var logScale = options.get('logscale');
    for(var j = 0; j < rawData.length; j++){
        var x = rawData[j][0];
        var point = rawData[j][i];
        if (logScale) // On the log scale, points less than zero do not exist.
        // This will create a gap in the chart.
        {
            if (point <= 0) point = null;
        }
        series.push([
            x,
            point
        ]);
    }
    return series;
};
/** @inheritDoc */ $a48ee8dda7f46294$var$DefaultHandler.prototype.rollingAverage = function(originalData, rollPeriod, options) {
    rollPeriod = Math.min(rollPeriod, originalData.length);
    var rollingData = [];
    var i, j, y, sum, num_ok;
    // Calculate the rolling average for the first rollPeriod - 1 points
    // where
    // there is not enough data to roll over the full number of points
    if (rollPeriod == 1) return originalData;
    for(i = 0; i < originalData.length; i++){
        sum = 0;
        num_ok = 0;
        for(j = Math.max(0, i - rollPeriod + 1); j < i + 1; j++){
            y = originalData[j][1];
            if (y === null || isNaN(y)) continue;
            num_ok++;
            sum += originalData[j][1];
        }
        if (num_ok) rollingData[i] = [
            originalData[i][0],
            sum / num_ok
        ];
        else rollingData[i] = [
            originalData[i][0],
            null
        ];
    }
    return rollingData;
};
/** @inheritDoc */ $a48ee8dda7f46294$var$DefaultHandler.prototype.getExtremeYValues = function(series, dateWindow, options) {
    var minY = null, maxY = null, y;
    var firstIdx = 0, lastIdx = series.length - 1;
    for(var j = firstIdx; j <= lastIdx; j++){
        y = series[j][1];
        if (y === null || isNaN(y)) continue;
        if (maxY === null || y > maxY) maxY = y;
        if (minY === null || y < minY) minY = y;
    }
    return [
        minY,
        maxY
    ];
};
$a48ee8dda7f46294$exports['default'] = $a48ee8dda7f46294$var$DefaultHandler;
$a48ee8dda7f46294$exports = $a48ee8dda7f46294$exports['default'];


var $298304f644e9f727$var$_datahandlerDefault2 = $298304f644e9f727$var$_interopRequireDefault($a48ee8dda7f46294$exports);
var $5d4dbc4161d4f1f0$exports = {};
/**
 * @license
 * Copyright 2013 David Eberlein (david.eberlein@ch.sauter-bc.com)
 * MIT-licensed (http://opensource.org/licenses/MIT)
 */ /**
 * @fileoverview DataHandler implementation for the error bars option.
 * @author David Eberlein (david.eberlein@ch.sauter-bc.com)
 */ /*global Dygraph:false */ "use strict";
Object.defineProperty($5d4dbc4161d4f1f0$exports, "__esModule", {
    value: true
});
function $5d4dbc4161d4f1f0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $c4542dbc82c2e840$exports = {};
/**
 * @license
 * Copyright 2013 David Eberlein (david.eberlein@ch.sauter-bc.com)
 * MIT-licensed (http://opensource.org/licenses/MIT)
 */ /**
 * @fileoverview DataHandler base implementation for the "bar" 
 * data formats. This implementation must be extended and the
 * extractSeries and rollingAverage must be implemented.
 * @author David Eberlein (david.eberlein@ch.sauter-bc.com)
 */ /*global Dygraph:false */ /*global DygraphLayout:false */ "use strict";
Object.defineProperty($c4542dbc82c2e840$exports, '__esModule', {
    value: true
});
function $c4542dbc82c2e840$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}

var $c4542dbc82c2e840$var$_datahandler2 = $c4542dbc82c2e840$var$_interopRequireDefault($61be5135933f4d60$exports);

var $c4542dbc82c2e840$var$_dygraphLayout2 = $c4542dbc82c2e840$var$_interopRequireDefault($852ab21d3dc0462c$exports);
/**
 * @constructor
 * @extends {Dygraph.DataHandler}
 */ var $c4542dbc82c2e840$var$BarsHandler = function BarsHandler() {
    $c4542dbc82c2e840$var$_datahandler2['default'].call(this);
};
$c4542dbc82c2e840$var$BarsHandler.prototype = new $c4542dbc82c2e840$var$_datahandler2['default']();
// TODO(danvk): figure out why the jsdoc has to be copy/pasted from superclass.
//   (I get closure compiler errors if this isn't here.)
/**
 * @override
 * @param {!Array.<Array>} rawData The raw data passed into dygraphs where 
 *     rawData[i] = [x,ySeries1,...,ySeriesN].
 * @param {!number} seriesIndex Index of the series to extract. All other
 *     series should be ignored.
 * @param {!DygraphOptions} options Dygraph options.
 * @return {Array.<[!number,?number,?]>} The series in the unified data format
 *     where series[i] = [x,y,{extras}]. 
 */ $c4542dbc82c2e840$var$BarsHandler.prototype.extractSeries = function(rawData, seriesIndex, options) {
// Not implemented here must be extended
};
/**
 * @override
 * @param {!Array.<[!number,?number,?]>} series The series in the unified 
 *          data format where series[i] = [x,y,{extras}].
 * @param {!number} rollPeriod The number of points over which to average the data
 * @param {!DygraphOptions} options The dygraph options.
 * TODO(danvk): be more specific than "Array" here.
 * @return {!Array.<[!number,?number,?]>} the rolled series.
 */ $c4542dbc82c2e840$var$BarsHandler.prototype.rollingAverage = function(series, rollPeriod, options) {
// Not implemented here, must be extended.
};
/** @inheritDoc */ $c4542dbc82c2e840$var$BarsHandler.prototype.onPointsCreated_ = function(series, points) {
    for(var i = 0; i < series.length; ++i){
        var item = series[i];
        var point = points[i];
        point.y_top = NaN;
        point.y_bottom = NaN;
        point.yval_minus = $c4542dbc82c2e840$var$_datahandler2['default'].parseFloat(item[2][0]);
        point.yval_plus = $c4542dbc82c2e840$var$_datahandler2['default'].parseFloat(item[2][1]);
    }
};
/** @inheritDoc */ $c4542dbc82c2e840$var$BarsHandler.prototype.getExtremeYValues = function(series, dateWindow, options) {
    var minY = null, maxY = null, y;
    var firstIdx = 0;
    var lastIdx = series.length - 1;
    for(var j = firstIdx; j <= lastIdx; j++){
        y = series[j][1];
        if (y === null || isNaN(y)) continue;
        var low = series[j][2][0];
        var high = series[j][2][1];
        if (low > y) low = y; // this can happen with custom bars,
        if (high < y) high = y; // e.g. in tests/custom-bars.html
        if (maxY === null || high > maxY) maxY = high;
        if (minY === null || low < minY) minY = low;
    }
    return [
        minY,
        maxY
    ];
};
/** @inheritDoc */ $c4542dbc82c2e840$var$BarsHandler.prototype.onLineEvaluated = function(points, axis, logscale) {
    var point;
    for(var j = 0; j < points.length; j++){
        // Copy over the error terms
        point = points[j];
        point.y_top = $c4542dbc82c2e840$var$_dygraphLayout2['default'].calcYNormal_(axis, point.yval_minus, logscale);
        point.y_bottom = $c4542dbc82c2e840$var$_dygraphLayout2['default'].calcYNormal_(axis, point.yval_plus, logscale);
    }
};
$c4542dbc82c2e840$exports['default'] = $c4542dbc82c2e840$var$BarsHandler;
$c4542dbc82c2e840$exports = $c4542dbc82c2e840$exports['default'];


var $5d4dbc4161d4f1f0$var$_bars2 = $5d4dbc4161d4f1f0$var$_interopRequireDefault($c4542dbc82c2e840$exports);
/**
 * @constructor
 * @extends BarsHandler
 */ var $5d4dbc4161d4f1f0$var$ErrorBarsHandler = function ErrorBarsHandler() {};
$5d4dbc4161d4f1f0$var$ErrorBarsHandler.prototype = new $5d4dbc4161d4f1f0$var$_bars2["default"]();
/** @inheritDoc */ $5d4dbc4161d4f1f0$var$ErrorBarsHandler.prototype.extractSeries = function(rawData, i, options) {
    // TODO(danvk): pre-allocate series here.
    var series = [];
    var x, y, variance, point;
    var sigma = options.get("sigma");
    var logScale = options.get('logscale');
    for(var j = 0; j < rawData.length; j++){
        x = rawData[j][0];
        point = rawData[j][i];
        if (logScale && point !== null) // On the log scale, points less than zero do not exist.
        // This will create a gap in the chart.
        {
            if (point[0] <= 0 || point[0] - sigma * point[1] <= 0) point = null;
        }
        // Extract to the unified data format.
        if (point !== null) {
            y = point[0];
            if (y !== null && !isNaN(y)) {
                variance = sigma * point[1];
                // preserve original error value in extras for further
                // filtering
                series.push([
                    x,
                    y,
                    [
                        y - variance,
                        y + variance,
                        point[1]
                    ]
                ]);
            } else series.push([
                x,
                y,
                [
                    y,
                    y,
                    y
                ]
            ]);
        } else series.push([
            x,
            null,
            [
                null,
                null,
                null
            ]
        ]);
    }
    return series;
};
/** @inheritDoc */ $5d4dbc4161d4f1f0$var$ErrorBarsHandler.prototype.rollingAverage = function(originalData, rollPeriod, options) {
    rollPeriod = Math.min(rollPeriod, originalData.length);
    var rollingData = [];
    var sigma = options.get("sigma");
    var i, j, y, v, sum, num_ok, stddev, variance, value;
    // Calculate the rolling average for the first rollPeriod - 1 points
    // where there is not enough data to roll over the full number of points
    for(i = 0; i < originalData.length; i++){
        sum = 0;
        variance = 0;
        num_ok = 0;
        for(j = Math.max(0, i - rollPeriod + 1); j < i + 1; j++){
            y = originalData[j][1];
            if (y === null || isNaN(y)) continue;
            num_ok++;
            sum += y;
            variance += Math.pow(originalData[j][2][2], 2);
        }
        if (num_ok) {
            stddev = Math.sqrt(variance) / num_ok;
            value = sum / num_ok;
            rollingData[i] = [
                originalData[i][0],
                value,
                [
                    value - sigma * stddev,
                    value + sigma * stddev
                ]
            ];
        } else {
            // This explicitly preserves NaNs to aid with "independent
            // series".
            // See testRollingAveragePreservesNaNs.
            v = rollPeriod == 1 ? originalData[i][1] : null;
            rollingData[i] = [
                originalData[i][0],
                v,
                [
                    v,
                    v
                ]
            ];
        }
    }
    return rollingData;
};
$5d4dbc4161d4f1f0$exports["default"] = $5d4dbc4161d4f1f0$var$ErrorBarsHandler;
$5d4dbc4161d4f1f0$exports = $5d4dbc4161d4f1f0$exports["default"];


var $298304f644e9f727$var$_datahandlerBarsError2 = $298304f644e9f727$var$_interopRequireDefault($5d4dbc4161d4f1f0$exports);
var $a549ef8eeceef7da$exports = {};
/**
 * @license
 * Copyright 2013 David Eberlein (david.eberlein@ch.sauter-bc.com)
 * MIT-licensed (http://opensource.org/licenses/MIT)
 */ /**
 * @fileoverview DataHandler implementation for the custom bars option.
 * @author David Eberlein (david.eberlein@ch.sauter-bc.com)
 */ /*global Dygraph:false */ "use strict";
Object.defineProperty($a549ef8eeceef7da$exports, '__esModule', {
    value: true
});
function $a549ef8eeceef7da$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}

var $a549ef8eeceef7da$var$_bars2 = $a549ef8eeceef7da$var$_interopRequireDefault($c4542dbc82c2e840$exports);
/**
 * @constructor
 * @extends Dygraph.DataHandlers.BarsHandler
 */ var $a549ef8eeceef7da$var$CustomBarsHandler = function CustomBarsHandler() {};
$a549ef8eeceef7da$var$CustomBarsHandler.prototype = new $a549ef8eeceef7da$var$_bars2['default']();
/** @inheritDoc */ $a549ef8eeceef7da$var$CustomBarsHandler.prototype.extractSeries = function(rawData, i, options) {
    // TODO(danvk): pre-allocate series here.
    var series = [];
    var x, y, point;
    var logScale = options.get('logscale');
    for(var j = 0; j < rawData.length; j++){
        x = rawData[j][0];
        point = rawData[j][i];
        if (logScale && point !== null) // On the log scale, points less than zero do not exist.
        // This will create a gap in the chart.
        {
            if (point[0] <= 0 || point[1] <= 0 || point[2] <= 0) point = null;
        }
        // Extract to the unified data format.
        if (point !== null) {
            y = point[1];
            if (y !== null && !isNaN(y)) series.push([
                x,
                y,
                [
                    point[0],
                    point[2]
                ]
            ]);
            else series.push([
                x,
                y,
                [
                    y,
                    y
                ]
            ]);
        } else series.push([
            x,
            null,
            [
                null,
                null
            ]
        ]);
    }
    return series;
};
/** @inheritDoc */ $a549ef8eeceef7da$var$CustomBarsHandler.prototype.rollingAverage = function(originalData, rollPeriod, options) {
    rollPeriod = Math.min(rollPeriod, originalData.length);
    var rollingData = [];
    var y, low, high, mid, count, i, extremes;
    low = 0;
    mid = 0;
    high = 0;
    count = 0;
    for(i = 0; i < originalData.length; i++){
        y = originalData[i][1];
        extremes = originalData[i][2];
        rollingData[i] = originalData[i];
        if (y !== null && !isNaN(y)) {
            low += extremes[0];
            mid += y;
            high += extremes[1];
            count += 1;
        }
        if (i - rollPeriod >= 0) {
            var prev = originalData[i - rollPeriod];
            if (prev[1] !== null && !isNaN(prev[1])) {
                low -= prev[2][0];
                mid -= prev[1];
                high -= prev[2][1];
                count -= 1;
            }
        }
        if (count) rollingData[i] = [
            originalData[i][0],
            1.0 * mid / count,
            [
                1.0 * low / count,
                1.0 * high / count
            ]
        ];
        else rollingData[i] = [
            originalData[i][0],
            null,
            [
                null,
                null
            ]
        ];
    }
    return rollingData;
};
$a549ef8eeceef7da$exports['default'] = $a549ef8eeceef7da$var$CustomBarsHandler;
$a549ef8eeceef7da$exports = $a549ef8eeceef7da$exports['default'];


var $298304f644e9f727$var$_datahandlerBarsCustom2 = $298304f644e9f727$var$_interopRequireDefault($a549ef8eeceef7da$exports);
var $5de2c719d704a5d1$exports = {};
/**
 * @license
 * Copyright 2013 David Eberlein (david.eberlein@ch.sauter-bc.com)
 * MIT-licensed (http://opensource.org/licenses/MIT)
 */ /**
 * @fileoverview DataHandler implementation for the fractions option.
 * @author David Eberlein (david.eberlein@ch.sauter-bc.com)
 */ /*global Dygraph:false */ "use strict";
Object.defineProperty($5de2c719d704a5d1$exports, '__esModule', {
    value: true
});
function $5de2c719d704a5d1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}

var $5de2c719d704a5d1$var$_datahandler2 = $5de2c719d704a5d1$var$_interopRequireDefault($61be5135933f4d60$exports);

var $5de2c719d704a5d1$var$_default2 = $5de2c719d704a5d1$var$_interopRequireDefault($a48ee8dda7f46294$exports);
/**
 * @extends DefaultHandler
 * @constructor
 */ var $5de2c719d704a5d1$var$DefaultFractionHandler = function DefaultFractionHandler() {};
$5de2c719d704a5d1$var$DefaultFractionHandler.prototype = new $5de2c719d704a5d1$var$_default2['default']();
$5de2c719d704a5d1$var$DefaultFractionHandler.prototype.extractSeries = function(rawData, i, options) {
    // TODO(danvk): pre-allocate series here.
    var series = [];
    var x, y, point, num, den, value;
    var mult = 100.0;
    var logScale = options.get('logscale');
    for(var j = 0; j < rawData.length; j++){
        x = rawData[j][0];
        point = rawData[j][i];
        if (logScale && point !== null) // On the log scale, points less than zero do not exist.
        // This will create a gap in the chart.
        {
            if (point[0] <= 0 || point[1] <= 0) point = null;
        }
        // Extract to the unified data format.
        if (point !== null) {
            num = point[0];
            den = point[1];
            if (num !== null && !isNaN(num)) {
                value = den ? num / den : 0.0;
                y = mult * value;
                // preserve original values in extras for further filtering
                series.push([
                    x,
                    y,
                    [
                        num,
                        den
                    ]
                ]);
            } else series.push([
                x,
                num,
                [
                    num,
                    den
                ]
            ]);
        } else series.push([
            x,
            null,
            [
                null,
                null
            ]
        ]);
    }
    return series;
};
$5de2c719d704a5d1$var$DefaultFractionHandler.prototype.rollingAverage = function(originalData, rollPeriod, options) {
    rollPeriod = Math.min(rollPeriod, originalData.length);
    var rollingData = [];
    var i;
    var num = 0;
    var den = 0; // numerator/denominator
    var mult = 100.0;
    for(i = 0; i < originalData.length; i++){
        num += originalData[i][2][0];
        den += originalData[i][2][1];
        if (i - rollPeriod >= 0) {
            num -= originalData[i - rollPeriod][2][0];
            den -= originalData[i - rollPeriod][2][1];
        }
        var date = originalData[i][0];
        var value = den ? num / den : 0.0;
        rollingData[i] = [
            date,
            mult * value
        ];
    }
    return rollingData;
};
$5de2c719d704a5d1$exports['default'] = $5de2c719d704a5d1$var$DefaultFractionHandler;
$5de2c719d704a5d1$exports = $5de2c719d704a5d1$exports['default'];


var $298304f644e9f727$var$_datahandlerDefaultFractions2 = $298304f644e9f727$var$_interopRequireDefault($5de2c719d704a5d1$exports);
var $53bbbd9aebcb8f76$exports = {};
/**
 * @license
 * Copyright 2013 David Eberlein (david.eberlein@ch.sauter-bc.com)
 * MIT-licensed (http://opensource.org/licenses/MIT)
 */ /**
 * @fileoverview DataHandler implementation for the combination 
 * of error bars and fractions options.
 * @author David Eberlein (david.eberlein@ch.sauter-bc.com)
 */ /*global Dygraph:false */ "use strict";
Object.defineProperty($53bbbd9aebcb8f76$exports, "__esModule", {
    value: true
});
function $53bbbd9aebcb8f76$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

var $53bbbd9aebcb8f76$var$_bars2 = $53bbbd9aebcb8f76$var$_interopRequireDefault($c4542dbc82c2e840$exports);
/**
 * @constructor
 * @extends Dygraph.DataHandlers.BarsHandler
 */ var $53bbbd9aebcb8f76$var$FractionsBarsHandler = function FractionsBarsHandler() {};
$53bbbd9aebcb8f76$var$FractionsBarsHandler.prototype = new $53bbbd9aebcb8f76$var$_bars2["default"]();
/** @inheritDoc */ $53bbbd9aebcb8f76$var$FractionsBarsHandler.prototype.extractSeries = function(rawData, i, options) {
    // TODO(danvk): pre-allocate series here.
    var series = [];
    var x, y, point, num, den, value, stddev, variance;
    var mult = 100.0;
    var sigma = options.get("sigma");
    var logScale = options.get('logscale');
    for(var j = 0; j < rawData.length; j++){
        x = rawData[j][0];
        point = rawData[j][i];
        if (logScale && point !== null) // On the log scale, points less than zero do not exist.
        // This will create a gap in the chart.
        {
            if (point[0] <= 0 || point[1] <= 0) point = null;
        }
        // Extract to the unified data format.
        if (point !== null) {
            num = point[0];
            den = point[1];
            if (num !== null && !isNaN(num)) {
                value = den ? num / den : 0.0;
                stddev = den ? sigma * Math.sqrt(value * (1 - value) / den) : 1.0;
                variance = mult * stddev;
                y = mult * value;
                // preserve original values in extras for further filtering
                series.push([
                    x,
                    y,
                    [
                        y - variance,
                        y + variance,
                        num,
                        den
                    ]
                ]);
            } else series.push([
                x,
                num,
                [
                    num,
                    num,
                    num,
                    den
                ]
            ]);
        } else series.push([
            x,
            null,
            [
                null,
                null,
                null,
                null
            ]
        ]);
    }
    return series;
};
/** @inheritDoc */ $53bbbd9aebcb8f76$var$FractionsBarsHandler.prototype.rollingAverage = function(originalData, rollPeriod, options) {
    rollPeriod = Math.min(rollPeriod, originalData.length);
    var rollingData = [];
    var sigma = options.get("sigma");
    var wilsonInterval = options.get("wilsonInterval");
    var low, high, i, stddev;
    var num = 0;
    var den = 0; // numerator/denominator
    var mult = 100.0;
    for(i = 0; i < originalData.length; i++){
        num += originalData[i][2][2];
        den += originalData[i][2][3];
        if (i - rollPeriod >= 0) {
            num -= originalData[i - rollPeriod][2][2];
            den -= originalData[i - rollPeriod][2][3];
        }
        var date = originalData[i][0];
        var value = den ? num / den : 0.0;
        if (wilsonInterval) {
            // For more details on this confidence interval, see:
            // http://en.wikipedia.org/wiki/Binomial_confidence_interval
            if (den) {
                var p = value < 0 ? 0 : value, n = den;
                var pm = sigma * Math.sqrt(p * (1 - p) / n + sigma * sigma / (4 * n * n));
                var denom = 1 + sigma * sigma / den;
                low = (p + sigma * sigma / (2 * den) - pm) / denom;
                high = (p + sigma * sigma / (2 * den) + pm) / denom;
                rollingData[i] = [
                    date,
                    p * mult,
                    [
                        low * mult,
                        high * mult
                    ]
                ];
            } else rollingData[i] = [
                date,
                0,
                [
                    0,
                    0
                ]
            ];
        } else {
            stddev = den ? sigma * Math.sqrt(value * (1 - value) / den) : 1.0;
            rollingData[i] = [
                date,
                mult * value,
                [
                    mult * (value - stddev),
                    mult * (value + stddev)
                ]
            ];
        }
    }
    return rollingData;
};
$53bbbd9aebcb8f76$exports["default"] = $53bbbd9aebcb8f76$var$FractionsBarsHandler;
$53bbbd9aebcb8f76$exports = $53bbbd9aebcb8f76$exports["default"];


var $298304f644e9f727$var$_datahandlerBarsFractions2 = $298304f644e9f727$var$_interopRequireDefault($53bbbd9aebcb8f76$exports);

var $298304f644e9f727$var$_datahandlerBars2 = $298304f644e9f727$var$_interopRequireDefault($c4542dbc82c2e840$exports);
var $9e46aba5e3de5276$exports = {};
/**
 * @license
 * Copyright 2012 Dan Vanderkam (danvdk@gmail.com)
 * MIT-licensed (http://opensource.org/licenses/MIT)
 */ /*global Dygraph:false */ "use strict";
/**
Current bits of jankiness:
- Uses dygraph.layout_ to get the parsed annotations.
- Uses dygraph.plotter_.area

It would be nice if the plugin didn't require so much special support inside
the core dygraphs classes, but annotations involve quite a bit of parsing and
layout.

TODO(danvk): cache DOM elements.
*/ Object.defineProperty($9e46aba5e3de5276$exports, "__esModule", {
    value: true
});
var $9e46aba5e3de5276$var$annotations = function annotations() {
    this.annotations_ = [];
};
$9e46aba5e3de5276$var$annotations.prototype.toString = function() {
    return "Annotations Plugin";
};
$9e46aba5e3de5276$var$annotations.prototype.activate = function(g) {
    return {
        clearChart: this.clearChart,
        didDrawChart: this.didDrawChart
    };
};
$9e46aba5e3de5276$var$annotations.prototype.detachLabels = function() {
    for(var i = 0; i < this.annotations_.length; i++){
        var a = this.annotations_[i];
        if (a.parentNode) a.parentNode.removeChild(a);
        this.annotations_[i] = null;
    }
    this.annotations_ = [];
};
$9e46aba5e3de5276$var$annotations.prototype.clearChart = function(e) {
    this.detachLabels();
};
$9e46aba5e3de5276$var$annotations.prototype.didDrawChart = function(e) {
    var g = e.dygraph;
    // Early out in the (common) case of zero annotations.
    var points = g.layout_.annotated_points;
    if (!points || points.length === 0) return;
    var containerDiv = e.canvas.parentNode;
    var bindEvt = function bindEvt(eventName, classEventName, pt) {
        return function(annotation_event) {
            var a = pt.annotation;
            if (a.hasOwnProperty(eventName)) a[eventName](a, pt, g, annotation_event);
            else if (g.getOption(classEventName)) g.getOption(classEventName)(a, pt, g, annotation_event);
        };
    };
    // Add the annotations one-by-one.
    var area = e.dygraph.getArea();
    // x-coord to sum of previous annotation's heights (used for stacking).
    var xToUsedHeight = {};
    for(var i = 0; i < points.length; i++){
        var p = points[i];
        if (p.canvasx < area.x || p.canvasx > area.x + area.w || p.canvasy < area.y || p.canvasy > area.y + area.h) continue;
        var a = p.annotation;
        var tick_height = 6;
        if (a.hasOwnProperty("tickHeight")) tick_height = a.tickHeight;
        // TODO: deprecate axisLabelFontSize in favor of CSS
        var div = document.createElement("div");
        div.style['fontSize'] = g.getOption('axisLabelFontSize') + "px";
        var className = 'dygraph-annotation';
        if (!a.hasOwnProperty('icon')) // camelCase class names are deprecated.
        className += ' dygraphDefaultAnnotation dygraph-default-annotation';
        if (a.hasOwnProperty('cssClass')) className += " " + a.cssClass;
        div.className = className;
        var width = a.hasOwnProperty('width') ? a.width : 16;
        var height = a.hasOwnProperty('height') ? a.height : 16;
        if (a.hasOwnProperty('icon')) {
            var img = document.createElement("img");
            img.src = a.icon;
            img.width = width;
            img.height = height;
            div.appendChild(img);
        } else if (p.annotation.hasOwnProperty('shortText')) div.appendChild(document.createTextNode(p.annotation.shortText));
        var left = p.canvasx - width / 2;
        div.style.left = left + "px";
        var divTop = 0;
        if (a.attachAtBottom) {
            var y = area.y + area.h - height - tick_height;
            if (xToUsedHeight[left]) y -= xToUsedHeight[left];
            else xToUsedHeight[left] = 0;
            xToUsedHeight[left] += tick_height + height;
            divTop = y;
        } else divTop = p.canvasy - height - tick_height;
        div.style.top = divTop + "px";
        div.style.width = width + "px";
        div.style.height = height + "px";
        div.title = p.annotation.text;
        div.style.color = g.colorsMap_[p.name];
        div.style.borderColor = g.colorsMap_[p.name];
        a.div = div;
        g.addAndTrackEvent(div, 'click', bindEvt('clickHandler', 'annotationClickHandler', p, this));
        g.addAndTrackEvent(div, 'mouseover', bindEvt('mouseOverHandler', 'annotationMouseOverHandler', p, this));
        g.addAndTrackEvent(div, 'mouseout', bindEvt('mouseOutHandler', 'annotationMouseOutHandler', p, this));
        g.addAndTrackEvent(div, 'dblclick', bindEvt('dblClickHandler', 'annotationDblClickHandler', p, this));
        containerDiv.appendChild(div);
        this.annotations_.push(div);
        var ctx = e.drawingContext;
        ctx.save();
        ctx.strokeStyle = a.hasOwnProperty('tickColor') ? a.tickColor : g.colorsMap_[p.name];
        ctx.lineWidth = a.hasOwnProperty('tickWidth') ? a.tickWidth : g.getOption('strokeWidth');
        ctx.beginPath();
        if (!a.attachAtBottom) {
            ctx.moveTo(p.canvasx, p.canvasy);
            ctx.lineTo(p.canvasx, p.canvasy - 2 - tick_height);
        } else {
            var y = divTop + height;
            ctx.moveTo(p.canvasx, y);
            ctx.lineTo(p.canvasx, y + tick_height);
        }
        ctx.closePath();
        ctx.stroke();
        ctx.restore();
    }
};
$9e46aba5e3de5276$var$annotations.prototype.destroy = function() {
    this.detachLabels();
};
$9e46aba5e3de5276$exports["default"] = $9e46aba5e3de5276$var$annotations;
$9e46aba5e3de5276$exports = $9e46aba5e3de5276$exports["default"];


var $298304f644e9f727$var$_pluginsAnnotations2 = $298304f644e9f727$var$_interopRequireDefault($9e46aba5e3de5276$exports);
var $2707bece187c94fc$exports = {};
/**
 * @license
 * Copyright 2012 Dan Vanderkam (danvdk@gmail.com)
 * MIT-licensed (http://opensource.org/licenses/MIT)
 */ /*global Dygraph:false */ 'use strict';
/*
Bits of jankiness:
- Direct layout access
- Direct area access
- Should include calculation of ticks, not just the drawing.

Options left to make axis-friendly.
  ('drawAxesAtZero')
  ('xAxisHeight')
*/ Object.defineProperty($2707bece187c94fc$exports, '__esModule', {
    value: true
});
function $2707bece187c94fc$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj['default'] = obj;
        return newObj;
    }
}

var $2707bece187c94fc$var$utils = $2707bece187c94fc$var$_interopRequireWildcard($ad57523a9e758dd4$exports);
/**
 * Draws the axes. This includes the labels on the x- and y-axes, as well
 * as the tick marks on the axes.
 * It does _not_ draw the grid lines which span the entire chart.
 */ var $2707bece187c94fc$var$axes = function axes() {
    this.xlabels_ = [];
    this.ylabels_ = [];
};
$2707bece187c94fc$var$axes.prototype.toString = function() {
    return 'Axes Plugin';
};
$2707bece187c94fc$var$axes.prototype.activate = function(g) {
    return {
        layout: this.layout,
        clearChart: this.clearChart,
        willDrawChart: this.willDrawChart
    };
};
$2707bece187c94fc$var$axes.prototype.layout = function(e) {
    var g = e.dygraph;
    if (g.getOptionForAxis('drawAxis', 'y')) {
        var w = g.getOptionForAxis('axisLabelWidth', 'y') + 2 * g.getOptionForAxis('axisTickSize', 'y');
        e.reserveSpaceLeft(w);
    }
    if (g.getOptionForAxis('drawAxis', 'x')) {
        var h;
        // NOTE: I think this is probably broken now, since g.getOption() now
        // hits the dictionary. (That is, g.getOption('xAxisHeight') now always
        // has a value.)
        if (g.getOption('xAxisHeight')) h = g.getOption('xAxisHeight');
        else h = g.getOptionForAxis('axisLabelFontSize', 'x') + 2 * g.getOptionForAxis('axisTickSize', 'x');
        e.reserveSpaceBottom(h);
    }
    if (g.numAxes() == 2) {
        if (g.getOptionForAxis('drawAxis', 'y2')) {
            var w = g.getOptionForAxis('axisLabelWidth', 'y2') + 2 * g.getOptionForAxis('axisTickSize', 'y2');
            e.reserveSpaceRight(w);
        }
    } else if (g.numAxes() > 2) g.error("Only two y-axes are supported at this time. (Trying to use " + g.numAxes() + ')');
};
$2707bece187c94fc$var$axes.prototype.detachLabels = function() {
    function removeArray(ary) {
        for(var i = 0; i < ary.length; i++){
            var el = ary[i];
            if (el.parentNode) el.parentNode.removeChild(el);
        }
    }
    removeArray(this.xlabels_);
    removeArray(this.ylabels_);
    this.xlabels_ = [];
    this.ylabels_ = [];
};
$2707bece187c94fc$var$axes.prototype.clearChart = function(e) {
    this.detachLabels();
};
$2707bece187c94fc$var$axes.prototype.willDrawChart = function(e) {
    var _this = this;
    var g = e.dygraph;
    if (!g.getOptionForAxis('drawAxis', 'x') && !g.getOptionForAxis('drawAxis', 'y') && !g.getOptionForAxis('drawAxis', 'y2')) return;
    // Round pixels to half-integer boundaries for crisper drawing.
    function halfUp(x) {
        return Math.round(x) + 0.5;
    }
    function halfDown(y) {
        return Math.round(y) - 0.5;
    }
    var context = e.drawingContext;
    var containerDiv = e.canvas.parentNode;
    var canvasWidth = g.width_; // e.canvas.width is affected by pixel ratio.
    var canvasHeight = g.height_;
    var label, x, y, tick, i;
    var makeLabelStyle = function makeLabelStyle(axis) {
        return {
            position: 'absolute',
            fontSize: g.getOptionForAxis('axisLabelFontSize', axis) + 'px',
            width: g.getOptionForAxis('axisLabelWidth', axis) + 'px'
        };
    };
    var labelStyles = {
        x: makeLabelStyle('x'),
        y: makeLabelStyle('y'),
        y2: makeLabelStyle('y2')
    };
    var makeDiv = function makeDiv(txt, axis, prec_axis) {
        /*
     * This seems to be called with the following three sets of axis/prec_axis:
     * x: undefined
     * y: y1
     * y: y2
     */ var div = document.createElement('div');
        var labelStyle = labelStyles[prec_axis == 'y2' ? 'y2' : axis];
        $2707bece187c94fc$var$utils.update(div.style, labelStyle);
        // TODO: combine outer & inner divs
        var inner_div = document.createElement('div');
        inner_div.className = "dygraph-axis-label dygraph-axis-label-" + axis + (prec_axis ? ' dygraph-axis-label-' + prec_axis : '');
        inner_div.innerHTML = txt;
        div.appendChild(inner_div);
        return div;
    };
    // axis lines
    context.save();
    var layout = g.layout_;
    var area = e.dygraph.plotter_.area;
    // Helper for repeated axis-option accesses.
    var makeOptionGetter = function makeOptionGetter(axis) {
        return function(option) {
            return g.getOptionForAxis(option, axis);
        };
    };
    if (g.getOptionForAxis('drawAxis', 'y')) {
        if (layout.yticks && layout.yticks.length > 0) {
            var num_axes = g.numAxes();
            var getOptions = [
                makeOptionGetter('y'),
                makeOptionGetter('y2')
            ];
            layout.yticks.forEach(function(tick) {
                if (tick.label === undefined) return; // this tick only has a grid line.
                x = area.x;
                var sgn = 1;
                var prec_axis = 'y1';
                var getAxisOption = getOptions[0];
                if (tick.axis == 1) {
                    // right-side y-axis
                    x = area.x + area.w;
                    sgn = -1;
                    prec_axis = 'y2';
                    getAxisOption = getOptions[1];
                }
                var fontSize = getAxisOption('axisLabelFontSize');
                y = area.y + tick.pos * area.h;
                /* Tick marks are currently clipped, so don't bother drawing them.
        context.beginPath();
        context.moveTo(halfUp(x), halfDown(y));
        context.lineTo(halfUp(x - sgn * this.attr_('axisTickSize')), halfDown(y));
        context.closePath();
        context.stroke();
        */ label = makeDiv(tick.label, 'y', num_axes == 2 ? prec_axis : null);
                var top = y - fontSize / 2;
                if (top < 0) top = 0;
                if (top + fontSize + 3 > canvasHeight) label.style.bottom = '0';
                else label.style.top = top + 'px';
                // TODO: replace these with css classes?
                if (tick.axis === 0) {
                    label.style.left = area.x - getAxisOption('axisLabelWidth') - getAxisOption('axisTickSize') + 'px';
                    label.style.textAlign = 'right';
                } else if (tick.axis == 1) {
                    label.style.left = area.x + area.w + getAxisOption('axisTickSize') + 'px';
                    label.style.textAlign = 'left';
                }
                label.style.width = getAxisOption('axisLabelWidth') + 'px';
                containerDiv.appendChild(label);
                _this.ylabels_.push(label);
            });
            // The lowest tick on the y-axis often overlaps with the leftmost
            // tick on the x-axis. Shift the bottom tick up a little bit to
            // compensate if necessary.
            var bottomTick = this.ylabels_[0];
            // Interested in the y2 axis also?
            var fontSize = g.getOptionForAxis('axisLabelFontSize', 'y');
            var bottom = parseInt(bottomTick.style.top, 10) + fontSize;
            if (bottom > canvasHeight - fontSize) bottomTick.style.top = parseInt(bottomTick.style.top, 10) - fontSize / 2 + 'px';
        }
        // draw a vertical line on the left to separate the chart from the labels.
        var axisX;
        if (g.getOption('drawAxesAtZero')) {
            var r = g.toPercentXCoord(0);
            if (r > 1 || r < 0 || isNaN(r)) r = 0;
            axisX = halfUp(area.x + r * area.w);
        } else axisX = halfUp(area.x);
        context.strokeStyle = g.getOptionForAxis('axisLineColor', 'y');
        context.lineWidth = g.getOptionForAxis('axisLineWidth', 'y');
        context.beginPath();
        context.moveTo(axisX, halfDown(area.y));
        context.lineTo(axisX, halfDown(area.y + area.h));
        context.closePath();
        context.stroke();
        // if there's a secondary y-axis, draw a vertical line for that, too.
        if (g.numAxes() == 2) {
            context.strokeStyle = g.getOptionForAxis('axisLineColor', 'y2');
            context.lineWidth = g.getOptionForAxis('axisLineWidth', 'y2');
            context.beginPath();
            context.moveTo(halfDown(area.x + area.w), halfDown(area.y));
            context.lineTo(halfDown(area.x + area.w), halfDown(area.y + area.h));
            context.closePath();
            context.stroke();
        }
    }
    if (g.getOptionForAxis('drawAxis', 'x')) {
        if (layout.xticks) {
            var getAxisOption = makeOptionGetter('x');
            layout.xticks.forEach(function(tick) {
                if (tick.label === undefined) return; // this tick only has a grid line.
                x = area.x + tick.pos * area.w;
                y = area.y + area.h;
                /* Tick marks are currently clipped, so don't bother drawing them.
        context.beginPath();
        context.moveTo(halfUp(x), halfDown(y));
        context.lineTo(halfUp(x), halfDown(y + this.attr_('axisTickSize')));
        context.closePath();
        context.stroke();
        */ label = makeDiv(tick.label, 'x');
                label.style.textAlign = 'center';
                label.style.top = y + getAxisOption('axisTickSize') + 'px';
                var left = x - getAxisOption('axisLabelWidth') / 2;
                if (left + getAxisOption('axisLabelWidth') > canvasWidth) {
                    left = canvasWidth - getAxisOption('axisLabelWidth');
                    label.style.textAlign = 'right';
                }
                if (left < 0) {
                    left = 0;
                    label.style.textAlign = 'left';
                }
                label.style.left = left + 'px';
                label.style.width = getAxisOption('axisLabelWidth') + 'px';
                containerDiv.appendChild(label);
                _this.xlabels_.push(label);
            });
        }
        context.strokeStyle = g.getOptionForAxis('axisLineColor', 'x');
        context.lineWidth = g.getOptionForAxis('axisLineWidth', 'x');
        context.beginPath();
        var axisY;
        if (g.getOption('drawAxesAtZero')) {
            var r = g.toPercentYCoord(0, 0);
            if (r > 1 || r < 0) r = 1;
            axisY = halfDown(area.y + r * area.h);
        } else axisY = halfDown(area.y + area.h);
        context.moveTo(halfUp(area.x), axisY);
        context.lineTo(halfUp(area.x + area.w), axisY);
        context.closePath();
        context.stroke();
    }
    context.restore();
};
$2707bece187c94fc$exports['default'] = $2707bece187c94fc$var$axes;
$2707bece187c94fc$exports = $2707bece187c94fc$exports['default'];


var $298304f644e9f727$var$_pluginsAxes2 = $298304f644e9f727$var$_interopRequireDefault($2707bece187c94fc$exports);
var $1bfd2575b3feacb6$exports = {};
/**
 * @license
 * Copyright 2012 Dan Vanderkam (danvdk@gmail.com)
 * MIT-licensed (http://opensource.org/licenses/MIT)
 */ /*global Dygraph:false */ "use strict";
// TODO(danvk): move chart label options out of dygraphs and into the plugin.
// TODO(danvk): only tear down & rebuild the DIVs when it's necessary.
Object.defineProperty($1bfd2575b3feacb6$exports, "__esModule", {
    value: true
});
var $1bfd2575b3feacb6$var$chart_labels = function chart_labels() {
    this.title_div_ = null;
    this.xlabel_div_ = null;
    this.ylabel_div_ = null;
    this.y2label_div_ = null;
};
$1bfd2575b3feacb6$var$chart_labels.prototype.toString = function() {
    return "ChartLabels Plugin";
};
$1bfd2575b3feacb6$var$chart_labels.prototype.activate = function(g) {
    return {
        layout: this.layout,
        // clearChart: this.clearChart,
        didDrawChart: this.didDrawChart
    };
};
// QUESTION: should there be a plugin-utils.js?
var $1bfd2575b3feacb6$var$createDivInRect = function createDivInRect(r) {
    var div = document.createElement('div');
    div.style.position = 'absolute';
    div.style.left = r.x + 'px';
    div.style.top = r.y + 'px';
    div.style.width = r.w + 'px';
    div.style.height = r.h + 'px';
    return div;
};
// Detach and null out any existing nodes.
$1bfd2575b3feacb6$var$chart_labels.prototype.detachLabels_ = function() {
    var els = [
        this.title_div_,
        this.xlabel_div_,
        this.ylabel_div_,
        this.y2label_div_
    ];
    for(var i = 0; i < els.length; i++){
        var el = els[i];
        if (!el) continue;
        if (el.parentNode) el.parentNode.removeChild(el);
    }
    this.title_div_ = null;
    this.xlabel_div_ = null;
    this.ylabel_div_ = null;
    this.y2label_div_ = null;
};
var $1bfd2575b3feacb6$var$createRotatedDiv = function createRotatedDiv(g, box, axis, classes, html) {
    // TODO(danvk): is this outer div actually necessary?
    var div = document.createElement("div");
    div.style.position = 'absolute';
    if (axis == 1) // NOTE: this is cheating. Should be positioned relative to the box.
    div.style.left = '0px';
    else div.style.left = box.x + 'px';
    div.style.top = box.y + 'px';
    div.style.width = box.w + 'px';
    div.style.height = box.h + 'px';
    div.style.fontSize = g.getOption('yLabelWidth') - 2 + 'px';
    var inner_div = document.createElement("div");
    inner_div.style.position = 'absolute';
    inner_div.style.width = box.h + 'px';
    inner_div.style.height = box.w + 'px';
    inner_div.style.top = box.h / 2 - box.w / 2 + 'px';
    inner_div.style.left = box.w / 2 - box.h / 2 + 'px';
    // TODO: combine inner_div and class_div.
    inner_div.className = 'dygraph-label-rotate-' + (axis == 1 ? 'right' : 'left');
    var class_div = document.createElement("div");
    class_div.className = classes;
    class_div.innerHTML = html;
    inner_div.appendChild(class_div);
    div.appendChild(inner_div);
    return div;
};
$1bfd2575b3feacb6$var$chart_labels.prototype.layout = function(e) {
    this.detachLabels_();
    var g = e.dygraph;
    var div = e.chart_div;
    if (g.getOption('title')) {
        // QUESTION: should this return an absolutely-positioned div instead?
        var title_rect = e.reserveSpaceTop(g.getOption('titleHeight'));
        this.title_div_ = $1bfd2575b3feacb6$var$createDivInRect(title_rect);
        this.title_div_.style.fontSize = g.getOption('titleHeight') - 8 + 'px';
        var class_div = document.createElement("div");
        class_div.className = 'dygraph-label dygraph-title';
        class_div.innerHTML = g.getOption('title');
        this.title_div_.appendChild(class_div);
        div.appendChild(this.title_div_);
    }
    if (g.getOption('xlabel')) {
        var x_rect = e.reserveSpaceBottom(g.getOption('xLabelHeight'));
        this.xlabel_div_ = $1bfd2575b3feacb6$var$createDivInRect(x_rect);
        this.xlabel_div_.style.fontSize = g.getOption('xLabelHeight') - 2 + 'px';
        var class_div = document.createElement("div");
        class_div.className = 'dygraph-label dygraph-xlabel';
        class_div.innerHTML = g.getOption('xlabel');
        this.xlabel_div_.appendChild(class_div);
        div.appendChild(this.xlabel_div_);
    }
    if (g.getOption('ylabel')) {
        // It would make sense to shift the chart here to make room for the y-axis
        // label, but the default yAxisLabelWidth is large enough that this results
        // in overly-padded charts. The y-axis label should fit fine. If it
        // doesn't, the yAxisLabelWidth option can be increased.
        var y_rect = e.reserveSpaceLeft(0);
        this.ylabel_div_ = $1bfd2575b3feacb6$var$createRotatedDiv(g, y_rect, 1, 'dygraph-label dygraph-ylabel', g.getOption('ylabel'));
        div.appendChild(this.ylabel_div_);
    }
    if (g.getOption('y2label') && g.numAxes() == 2) {
        // same logic applies here as for ylabel.
        var y2_rect = e.reserveSpaceRight(0);
        this.y2label_div_ = $1bfd2575b3feacb6$var$createRotatedDiv(g, y2_rect, 2, 'dygraph-label dygraph-y2label', g.getOption('y2label'));
        div.appendChild(this.y2label_div_);
    }
};
$1bfd2575b3feacb6$var$chart_labels.prototype.didDrawChart = function(e) {
    var g = e.dygraph;
    if (this.title_div_) this.title_div_.children[0].innerHTML = g.getOption('title');
    if (this.xlabel_div_) this.xlabel_div_.children[0].innerHTML = g.getOption('xlabel');
    if (this.ylabel_div_) this.ylabel_div_.children[0].children[0].innerHTML = g.getOption('ylabel');
    if (this.y2label_div_) this.y2label_div_.children[0].children[0].innerHTML = g.getOption('y2label');
};
$1bfd2575b3feacb6$var$chart_labels.prototype.clearChart = function() {};
$1bfd2575b3feacb6$var$chart_labels.prototype.destroy = function() {
    this.detachLabels_();
};
$1bfd2575b3feacb6$exports["default"] = $1bfd2575b3feacb6$var$chart_labels;
$1bfd2575b3feacb6$exports = $1bfd2575b3feacb6$exports["default"];


var $298304f644e9f727$var$_pluginsChartLabels2 = $298304f644e9f727$var$_interopRequireDefault($1bfd2575b3feacb6$exports);
var $b3c0c0366fb774d5$exports = {};
/**
 * @license
 * Copyright 2012 Dan Vanderkam (danvdk@gmail.com)
 * MIT-licensed (http://opensource.org/licenses/MIT)
 */ /*global Dygraph:false */ /*

Current bits of jankiness:
- Direct layout access
- Direct area access

*/ "use strict";
/**
 * Draws the gridlines, i.e. the gray horizontal & vertical lines running the
 * length of the chart.
 *
 * @constructor
 */ Object.defineProperty($b3c0c0366fb774d5$exports, "__esModule", {
    value: true
});
var $b3c0c0366fb774d5$var$grid = function grid() {};
$b3c0c0366fb774d5$var$grid.prototype.toString = function() {
    return "Gridline Plugin";
};
$b3c0c0366fb774d5$var$grid.prototype.activate = function(g) {
    return {
        willDrawChart: this.willDrawChart
    };
};
$b3c0c0366fb774d5$var$grid.prototype.willDrawChart = function(e) {
    // Draw the new X/Y grid. Lines appear crisper when pixels are rounded to
    // half-integers. This prevents them from drawing in two rows/cols.
    var g = e.dygraph;
    var ctx = e.drawingContext;
    var layout = g.layout_;
    var area = e.dygraph.plotter_.area;
    function halfUp(x) {
        return Math.round(x) + 0.5;
    }
    function halfDown(y) {
        return Math.round(y) - 0.5;
    }
    var x, y, i, ticks;
    if (g.getOptionForAxis('drawGrid', 'y')) {
        var axes = [
            "y",
            "y2"
        ];
        var strokeStyles = [], lineWidths = [], drawGrid = [], stroking = [], strokePattern = [];
        for(var i = 0; i < axes.length; i++){
            drawGrid[i] = g.getOptionForAxis('drawGrid', axes[i]);
            if (drawGrid[i]) {
                strokeStyles[i] = g.getOptionForAxis('gridLineColor', axes[i]);
                lineWidths[i] = g.getOptionForAxis('gridLineWidth', axes[i]);
                strokePattern[i] = g.getOptionForAxis('gridLinePattern', axes[i]);
                stroking[i] = strokePattern[i] && strokePattern[i].length >= 2;
            }
        }
        ticks = layout.yticks;
        ctx.save();
        // draw grids for the different y axes
        ticks.forEach(function(tick) {
            if (!tick.has_tick) return;
            var axis = tick.axis;
            if (drawGrid[axis]) {
                ctx.save();
                if (stroking[axis]) {
                    if (ctx.setLineDash) ctx.setLineDash(strokePattern[axis]);
                }
                ctx.strokeStyle = strokeStyles[axis];
                ctx.lineWidth = lineWidths[axis];
                x = halfUp(area.x);
                y = halfDown(area.y + tick.pos * area.h);
                ctx.beginPath();
                ctx.moveTo(x, y);
                ctx.lineTo(x + area.w, y);
                ctx.stroke();
                ctx.restore();
            }
        });
        ctx.restore();
    }
    // draw grid for x axis
    if (g.getOptionForAxis('drawGrid', 'x')) {
        ticks = layout.xticks;
        ctx.save();
        var strokePattern = g.getOptionForAxis('gridLinePattern', 'x');
        var stroking = strokePattern && strokePattern.length >= 2;
        if (stroking) {
            if (ctx.setLineDash) ctx.setLineDash(strokePattern);
        }
        ctx.strokeStyle = g.getOptionForAxis('gridLineColor', 'x');
        ctx.lineWidth = g.getOptionForAxis('gridLineWidth', 'x');
        ticks.forEach(function(tick) {
            if (!tick.has_tick) return;
            x = halfUp(area.x + tick.pos * area.w);
            y = halfDown(area.y + area.h);
            ctx.beginPath();
            ctx.moveTo(x, y);
            ctx.lineTo(x, area.y);
            ctx.closePath();
            ctx.stroke();
        });
        if (stroking) {
            if (ctx.setLineDash) ctx.setLineDash([]);
        }
        ctx.restore();
    }
};
$b3c0c0366fb774d5$var$grid.prototype.destroy = function() {};
$b3c0c0366fb774d5$exports["default"] = $b3c0c0366fb774d5$var$grid;
$b3c0c0366fb774d5$exports = $b3c0c0366fb774d5$exports["default"];


var $298304f644e9f727$var$_pluginsGrid2 = $298304f644e9f727$var$_interopRequireDefault($b3c0c0366fb774d5$exports);
var $f9046a74888c150f$exports = {};
/**
 * @license
 * Copyright 2012 Dan Vanderkam (danvdk@gmail.com)
 * MIT-licensed (http://opensource.org/licenses/MIT)
 */ /*global Dygraph:false */ /*
Current bits of jankiness:
- Uses two private APIs:
    1. Dygraph.optionsViewForAxis_
    2. dygraph.plotter_.area
- Registers for a "predraw" event, which should be renamed.
- I call calculateEmWidthInDiv more often than needed.
*/ /*global Dygraph:false */ "use strict";
Object.defineProperty($f9046a74888c150f$exports, "__esModule", {
    value: true
});
function $f9046a74888c150f$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj["default"] = obj;
        return newObj;
    }
}

var $f9046a74888c150f$var$utils = $f9046a74888c150f$var$_interopRequireWildcard($ad57523a9e758dd4$exports);
/**
 * Creates the legend, which appears when the user hovers over the chart.
 * The legend can be either a user-specified or generated div.
 *
 * @constructor
 */ var $f9046a74888c150f$var$Legend = function Legend() {
    this.legend_div_ = null;
    this.is_generated_div_ = false; // do we own this div, or was it user-specified?
};
$f9046a74888c150f$var$Legend.prototype.toString = function() {
    return "Legend Plugin";
};
/**
 * This is called during the dygraph constructor, after options have been set
 * but before the data is available.
 *
 * Proper tasks to do here include:
 * - Reading your own options
 * - DOM manipulation
 * - Registering event listeners
 *
 * @param {Dygraph} g Graph instance.
 * @return {object.<string, function(ev)>} Mapping of event names to callbacks.
 */ $f9046a74888c150f$var$Legend.prototype.activate = function(g) {
    var div;
    var userLabelsDiv = g.getOption('labelsDiv');
    if (userLabelsDiv && null !== userLabelsDiv) {
        if (typeof userLabelsDiv == "string" || userLabelsDiv instanceof String) div = document.getElementById(userLabelsDiv);
        else div = userLabelsDiv;
    } else {
        div = document.createElement("div");
        div.className = "dygraph-legend";
        // TODO(danvk): come up with a cleaner way to expose this.
        g.graphDiv.appendChild(div);
        this.is_generated_div_ = true;
    }
    this.legend_div_ = div;
    this.one_em_width_ = 10; // just a guess, will be updated.
    return {
        select: this.select,
        deselect: this.deselect,
        // TODO(danvk): rethink the name "predraw" before we commit to it in any API.
        predraw: this.predraw,
        didDrawChart: this.didDrawChart
    };
};
// Needed for dashed lines.
var $f9046a74888c150f$var$calculateEmWidthInDiv = function calculateEmWidthInDiv(div) {
    var sizeSpan = document.createElement('span');
    sizeSpan.setAttribute('style', 'margin: 0; padding: 0 0 0 1em; border: 0;');
    div.appendChild(sizeSpan);
    var oneEmWidth = sizeSpan.offsetWidth;
    div.removeChild(sizeSpan);
    return oneEmWidth;
};
var $f9046a74888c150f$var$escapeHTML = function escapeHTML(str) {
    return str.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
};
$f9046a74888c150f$var$Legend.prototype.select = function(e) {
    var xValue = e.selectedX;
    var points = e.selectedPoints;
    var row = e.selectedRow;
    var legendMode = e.dygraph.getOption('legend');
    if (legendMode === 'never') {
        this.legend_div_.style.display = 'none';
        return;
    }
    if (legendMode === 'follow') {
        // create floating legend div
        var area = e.dygraph.plotter_.area;
        var labelsDivWidth = this.legend_div_.offsetWidth;
        var yAxisLabelWidth = e.dygraph.getOptionForAxis('axisLabelWidth', 'y');
        // determine floating [left, top] coordinates of the legend div
        // within the plotter_ area
        // offset 50 px to the right and down from the first selection point
        // 50 px is guess based on mouse cursor size
        var leftLegend = points[0].x * area.w + 50;
        var topLegend = points[0].y * area.h - 50;
        // if legend floats to end of the chart area, it flips to the other
        // side of the selection point
        if (leftLegend + labelsDivWidth + 1 > area.w) leftLegend = leftLegend - 100 - labelsDivWidth - (yAxisLabelWidth - area.x);
        e.dygraph.graphDiv.appendChild(this.legend_div_);
        this.legend_div_.style.left = yAxisLabelWidth + leftLegend + "px";
        this.legend_div_.style.top = topLegend + "px";
    }
    var html = $f9046a74888c150f$var$Legend.generateLegendHTML(e.dygraph, xValue, points, this.one_em_width_, row);
    this.legend_div_.innerHTML = html;
    this.legend_div_.style.display = '';
};
$f9046a74888c150f$var$Legend.prototype.deselect = function(e) {
    var legendMode = e.dygraph.getOption('legend');
    if (legendMode !== 'always') this.legend_div_.style.display = "none";
    // Have to do this every time, since styles might have changed.
    var oneEmWidth = $f9046a74888c150f$var$calculateEmWidthInDiv(this.legend_div_);
    this.one_em_width_ = oneEmWidth;
    var html = $f9046a74888c150f$var$Legend.generateLegendHTML(e.dygraph, undefined, undefined, oneEmWidth, null);
    this.legend_div_.innerHTML = html;
};
$f9046a74888c150f$var$Legend.prototype.didDrawChart = function(e) {
    this.deselect(e);
};
// Right edge should be flush with the right edge of the charting area (which
// may not be the same as the right edge of the div, if we have two y-axes.
// TODO(danvk): is any of this really necessary? Could just set "right" in "activate".
/**
 * Position the labels div so that:
 * - its right edge is flush with the right edge of the charting area
 * - its top edge is flush with the top edge of the charting area
 * @private
 */ $f9046a74888c150f$var$Legend.prototype.predraw = function(e) {
    // Don't touch a user-specified labelsDiv.
    if (!this.is_generated_div_) return;
    // TODO(danvk): only use real APIs for this.
    e.dygraph.graphDiv.appendChild(this.legend_div_);
    var area = e.dygraph.getArea();
    var labelsDivWidth = this.legend_div_.offsetWidth;
    this.legend_div_.style.left = area.x + area.w - labelsDivWidth - 1 + "px";
    this.legend_div_.style.top = area.y + "px";
};
/**
 * Called when dygraph.destroy() is called.
 * You should null out any references and detach any DOM elements.
 */ $f9046a74888c150f$var$Legend.prototype.destroy = function() {
    this.legend_div_ = null;
};
/**
 * Generates HTML for the legend which is displayed when hovering over the
 * chart. If no selected points are specified, a default legend is returned
 * (this may just be the empty string).
 * @param {number} x The x-value of the selected points.
 * @param {Object} sel_points List of selected points for the given
 *   x-value. Should have properties like 'name', 'yval' and 'canvasy'.
 * @param {number} oneEmWidth The pixel width for 1em in the legend. Only
 *   relevant when displaying a legend with no selection (i.e. {legend:
 *   'always'}) and with dashed lines.
 * @param {number} row The selected row index.
 * @private
 */ $f9046a74888c150f$var$Legend.generateLegendHTML = function(g, x, sel_points, oneEmWidth, row) {
    // Data about the selection to pass to legendFormatter
    var data = {
        dygraph: g,
        x: x,
        series: []
    };
    var labelToSeries = {};
    var labels = g.getLabels();
    if (labels) for(var i = 1; i < labels.length; i++){
        var series = g.getPropertiesForSeries(labels[i]);
        var strokePattern = g.getOption('strokePattern', labels[i]);
        var seriesData = {
            dashHTML: $f9046a74888c150f$var$generateLegendDashHTML(strokePattern, series.color, oneEmWidth),
            label: labels[i],
            labelHTML: $f9046a74888c150f$var$escapeHTML(labels[i]),
            isVisible: series.visible,
            color: series.color
        };
        data.series.push(seriesData);
        labelToSeries[labels[i]] = seriesData;
    }
    if (typeof x !== 'undefined') {
        var xOptView = g.optionsViewForAxis_('x');
        var xvf = xOptView('valueFormatter');
        data.xHTML = xvf.call(g, x, xOptView, labels[0], g, row, 0);
        var yOptViews = [];
        var num_axes = g.numAxes();
        for(var i = 0; i < num_axes; i++)// TODO(danvk): remove this use of a private API
        yOptViews[i] = g.optionsViewForAxis_('y' + (i ? 1 + i : ''));
        var showZeros = g.getOption('labelsShowZeroValues');
        var highlightSeries = g.getHighlightSeries();
        for(i = 0; i < sel_points.length; i++){
            var pt = sel_points[i];
            var seriesData = labelToSeries[pt.name];
            seriesData.y = pt.yval;
            if (pt.yval === 0 && !showZeros || isNaN(pt.canvasy)) {
                seriesData.isVisible = false;
                continue;
            }
            var series = g.getPropertiesForSeries(pt.name);
            var yOptView = yOptViews[series.axis - 1];
            var fmtFunc = yOptView('valueFormatter');
            var yHTML = fmtFunc.call(g, pt.yval, yOptView, pt.name, g, row, labels.indexOf(pt.name));
            $f9046a74888c150f$var$utils.update(seriesData, {
                yHTML: yHTML
            });
            if (pt.name == highlightSeries) seriesData.isHighlighted = true;
        }
    }
    var formatter = g.getOption('legendFormatter') || $f9046a74888c150f$var$Legend.defaultFormatter;
    return formatter.call(g, data);
};
$f9046a74888c150f$var$Legend.defaultFormatter = function(data) {
    var g = data.dygraph;
    // TODO(danvk): deprecate this option in place of {legend: 'never'}
    // XXX should this logic be in the formatter?
    if (g.getOption('showLabelsOnHighlight') !== true) return '';
    var sepLines = g.getOption('labelsSeparateLines');
    var html;
    if (typeof data.x === 'undefined') {
        // TODO: this check is duplicated in generateLegendHTML. Put it in one place.
        if (g.getOption('legend') != 'always') return '';
        html = '';
        for(var i = 0; i < data.series.length; i++){
            var series = data.series[i];
            if (!series.isVisible) continue;
            if (html !== '') html += sepLines ? '<br/>' : ' ';
            html += "<span style='font-weight: bold; color: " + series.color + ";'>" + series.dashHTML + " " + series.labelHTML + "</span>";
        }
        return html;
    }
    html = data.xHTML + ':';
    for(var i = 0; i < data.series.length; i++){
        var series = data.series[i];
        if (!series.isVisible) continue;
        if (sepLines) html += '<br>';
        var cls = series.isHighlighted ? ' class="highlight"' : '';
        html += "<span" + cls + "> <b><span style='color: " + series.color + ";'>" + series.labelHTML + "</span></b>:&#160;" + series.yHTML + "</span>";
    }
    return html;
};
/**
 * Generates html for the "dash" displayed on the legend when using "legend: always".
 * In particular, this works for dashed lines with any stroke pattern. It will
 * try to scale the pattern to fit in 1em width. Or if small enough repeat the
 * pattern for 1em width.
 *
 * @param strokePattern The pattern
 * @param color The color of the series.
 * @param oneEmWidth The width in pixels of 1em in the legend.
 * @private
 */ // TODO(danvk): cache the results of this
function $f9046a74888c150f$var$generateLegendDashHTML(strokePattern, color, oneEmWidth) {
    // Easy, common case: a solid line
    if (!strokePattern || strokePattern.length <= 1) return "<div class=\"dygraph-legend-line\" style=\"border-bottom-color: " + color + ";\"></div>";
    var i, j, paddingLeft, marginRight;
    var strokePixelLength = 0, segmentLoop = 0;
    var normalizedPattern = [];
    var loop;
    // Compute the length of the pixels including the first segment twice,
    // since we repeat it.
    for(i = 0; i <= strokePattern.length; i++)strokePixelLength += strokePattern[i % strokePattern.length];
    // See if we can loop the pattern by itself at least twice.
    loop = Math.floor(oneEmWidth / (strokePixelLength - strokePattern[0]));
    if (loop > 1) {
        // This pattern fits at least two times, no scaling just convert to em;
        for(i = 0; i < strokePattern.length; i++)normalizedPattern[i] = strokePattern[i] / oneEmWidth;
        // Since we are repeating the pattern, we don't worry about repeating the
        // first segment in one draw.
        segmentLoop = normalizedPattern.length;
    } else {
        // If the pattern doesn't fit in the legend we scale it to fit.
        loop = 1;
        for(i = 0; i < strokePattern.length; i++)normalizedPattern[i] = strokePattern[i] / strokePixelLength;
        // For the scaled patterns we do redraw the first segment.
        segmentLoop = normalizedPattern.length + 1;
    }
    // Now make the pattern.
    var dash = "";
    for(j = 0; j < loop; j++)for(i = 0; i < segmentLoop; i += 2){
        // The padding is the drawn segment.
        paddingLeft = normalizedPattern[i % normalizedPattern.length];
        if (i < strokePattern.length) // The margin is the space segment.
        marginRight = normalizedPattern[(i + 1) % normalizedPattern.length];
        else // The repeated first segment has no right margin.
        marginRight = 0;
        dash += "<div class=\"dygraph-legend-dash\" style=\"margin-right: " + marginRight + "em; padding-left: " + paddingLeft + "em;\"></div>";
    }
    return dash;
}
$f9046a74888c150f$exports["default"] = $f9046a74888c150f$var$Legend;
$f9046a74888c150f$exports = $f9046a74888c150f$exports["default"];


var $298304f644e9f727$var$_pluginsLegend2 = $298304f644e9f727$var$_interopRequireDefault($f9046a74888c150f$exports);
var $174201254fd40c2e$exports = {};
/**
 * @license
 * Copyright 2011 Paul Felix (paul.eric.felix@gmail.com)
 * MIT-licensed (http://opensource.org/licenses/MIT)
 */ /*global Dygraph:false,TouchEvent:false */ /**
 * @fileoverview This file contains the RangeSelector plugin used to provide
 * a timeline range selector widget for dygraphs.
 */ /*global Dygraph:false */ "use strict";
Object.defineProperty($174201254fd40c2e$exports, '__esModule', {
    value: true
});
function $174201254fd40c2e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
function $174201254fd40c2e$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj['default'] = obj;
        return newObj;
    }
}

var $174201254fd40c2e$var$utils = $174201254fd40c2e$var$_interopRequireWildcard($ad57523a9e758dd4$exports);

var $174201254fd40c2e$var$_dygraphInteractionModel2 = $174201254fd40c2e$var$_interopRequireDefault($e4a9bb31f64d7836$exports);

var $174201254fd40c2e$var$_iframeTarp2 = $174201254fd40c2e$var$_interopRequireDefault($ede8be30660062dd$exports);
var $174201254fd40c2e$var$rangeSelector = function rangeSelector() {
    this.hasTouchInterface_ = typeof TouchEvent != 'undefined';
    this.isMobileDevice_ = /mobile|android/gi.test(navigator.appVersion);
    this.interfaceCreated_ = false;
};
$174201254fd40c2e$var$rangeSelector.prototype.toString = function() {
    return "RangeSelector Plugin";
};
$174201254fd40c2e$var$rangeSelector.prototype.activate = function(dygraph) {
    this.dygraph_ = dygraph;
    if (this.getOption_('showRangeSelector')) this.createInterface_();
    return {
        layout: this.reserveSpace_,
        predraw: this.renderStaticLayer_,
        didDrawChart: this.renderInteractiveLayer_
    };
};
$174201254fd40c2e$var$rangeSelector.prototype.destroy = function() {
    this.bgcanvas_ = null;
    this.fgcanvas_ = null;
    this.leftZoomHandle_ = null;
    this.rightZoomHandle_ = null;
};
//------------------------------------------------------------------
// Private methods
//------------------------------------------------------------------
$174201254fd40c2e$var$rangeSelector.prototype.getOption_ = function(name, opt_series) {
    return this.dygraph_.getOption(name, opt_series);
};
$174201254fd40c2e$var$rangeSelector.prototype.setDefaultOption_ = function(name, value) {
    this.dygraph_.attrs_[name] = value;
};
/**
 * @private
 * Creates the range selector elements and adds them to the graph.
 */ $174201254fd40c2e$var$rangeSelector.prototype.createInterface_ = function() {
    this.createCanvases_();
    this.createZoomHandles_();
    this.initInteraction_();
    // Range selector and animatedZooms have a bad interaction. See issue 359.
    if (this.getOption_('animatedZooms')) {
        console.warn('Animated zooms and range selector are not compatible; disabling animatedZooms.');
        this.dygraph_.updateOptions({
            animatedZooms: false
        }, true);
    }
    this.interfaceCreated_ = true;
    this.addToGraph_();
};
/**
 * @private
 * Adds the range selector to the graph.
 */ $174201254fd40c2e$var$rangeSelector.prototype.addToGraph_ = function() {
    var graphDiv = this.graphDiv_ = this.dygraph_.graphDiv;
    graphDiv.appendChild(this.bgcanvas_);
    graphDiv.appendChild(this.fgcanvas_);
    graphDiv.appendChild(this.leftZoomHandle_);
    graphDiv.appendChild(this.rightZoomHandle_);
};
/**
 * @private
 * Removes the range selector from the graph.
 */ $174201254fd40c2e$var$rangeSelector.prototype.removeFromGraph_ = function() {
    var graphDiv = this.graphDiv_;
    graphDiv.removeChild(this.bgcanvas_);
    graphDiv.removeChild(this.fgcanvas_);
    graphDiv.removeChild(this.leftZoomHandle_);
    graphDiv.removeChild(this.rightZoomHandle_);
    this.graphDiv_ = null;
};
/**
 * @private
 * Called by Layout to allow range selector to reserve its space.
 */ $174201254fd40c2e$var$rangeSelector.prototype.reserveSpace_ = function(e) {
    if (this.getOption_('showRangeSelector')) e.reserveSpaceBottom(this.getOption_('rangeSelectorHeight') + 4);
};
/**
 * @private
 * Renders the static portion of the range selector at the predraw stage.
 */ $174201254fd40c2e$var$rangeSelector.prototype.renderStaticLayer_ = function() {
    if (!this.updateVisibility_()) return;
    this.resize_();
    this.drawStaticLayer_();
};
/**
 * @private
 * Renders the interactive portion of the range selector after the chart has been drawn.
 */ $174201254fd40c2e$var$rangeSelector.prototype.renderInteractiveLayer_ = function() {
    if (!this.updateVisibility_() || this.isChangingRange_) return;
    this.placeZoomHandles_();
    this.drawInteractiveLayer_();
};
/**
 * @private
 * Check to see if the range selector is enabled/disabled and update visibility accordingly.
 */ $174201254fd40c2e$var$rangeSelector.prototype.updateVisibility_ = function() {
    var enabled = this.getOption_('showRangeSelector');
    if (enabled) {
        if (!this.interfaceCreated_) this.createInterface_();
        else if (!this.graphDiv_ || !this.graphDiv_.parentNode) this.addToGraph_();
    } else if (this.graphDiv_) {
        this.removeFromGraph_();
        var dygraph = this.dygraph_;
        setTimeout(function() {
            dygraph.width_ = 0;
            dygraph.resize();
        }, 1);
    }
    return enabled;
};
/**
 * @private
 * Resizes the range selector.
 */ $174201254fd40c2e$var$rangeSelector.prototype.resize_ = function() {
    function setElementRect(canvas, context, rect, pixelRatioOption) {
        var canvasScale = pixelRatioOption || $174201254fd40c2e$var$utils.getContextPixelRatio(context);
        canvas.style.top = rect.y + 'px';
        canvas.style.left = rect.x + 'px';
        canvas.width = rect.w * canvasScale;
        canvas.height = rect.h * canvasScale;
        canvas.style.width = rect.w + 'px';
        canvas.style.height = rect.h + 'px';
        if (canvasScale != 1) context.scale(canvasScale, canvasScale);
    }
    var plotArea = this.dygraph_.layout_.getPlotArea();
    var xAxisLabelHeight = 0;
    if (this.dygraph_.getOptionForAxis('drawAxis', 'x')) xAxisLabelHeight = this.getOption_('xAxisHeight') || this.getOption_('axisLabelFontSize') + 2 * this.getOption_('axisTickSize');
    this.canvasRect_ = {
        x: plotArea.x,
        y: plotArea.y + plotArea.h + xAxisLabelHeight + 4,
        w: plotArea.w,
        h: this.getOption_('rangeSelectorHeight')
    };
    var pixelRatioOption = this.dygraph_.getNumericOption('pixelRatio');
    setElementRect(this.bgcanvas_, this.bgcanvas_ctx_, this.canvasRect_, pixelRatioOption);
    setElementRect(this.fgcanvas_, this.fgcanvas_ctx_, this.canvasRect_, pixelRatioOption);
};
/**
 * @private
 * Creates the background and foreground canvases.
 */ $174201254fd40c2e$var$rangeSelector.prototype.createCanvases_ = function() {
    this.bgcanvas_ = $174201254fd40c2e$var$utils.createCanvas();
    this.bgcanvas_.className = 'dygraph-rangesel-bgcanvas';
    this.bgcanvas_.style.position = 'absolute';
    this.bgcanvas_.style.zIndex = 9;
    this.bgcanvas_ctx_ = $174201254fd40c2e$var$utils.getContext(this.bgcanvas_);
    this.fgcanvas_ = $174201254fd40c2e$var$utils.createCanvas();
    this.fgcanvas_.className = 'dygraph-rangesel-fgcanvas';
    this.fgcanvas_.style.position = 'absolute';
    this.fgcanvas_.style.zIndex = 9;
    this.fgcanvas_.style.cursor = 'default';
    this.fgcanvas_ctx_ = $174201254fd40c2e$var$utils.getContext(this.fgcanvas_);
};
/**
 * @private
 * Creates the zoom handle elements.
 */ $174201254fd40c2e$var$rangeSelector.prototype.createZoomHandles_ = function() {
    var img = new Image();
    img.className = 'dygraph-rangesel-zoomhandle';
    img.style.position = 'absolute';
    img.style.zIndex = 10;
    img.style.visibility = 'hidden'; // Initially hidden so they don't show up in the wrong place.
    img.style.cursor = 'col-resize';
    // TODO: change image to more options
    img.width = 9;
    img.height = 16;
    img.src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAQCAYAAADESFVDAAAAAXNSR0IArs4c6QAAAAZiS0dEANAAzwDP4Z7KegAAAAlwSFlzAAAOxAAADsQBlSsOGwAAAAd0SU1FB9sHGw0cMqdt1UwAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAaElEQVQoz+3SsRFAQBCF4Z9WJM8KCDVwownl6YXsTmCUsyKGkZzcl7zkz3YLkypgAnreFmDEpHkIwVOMfpdi9CEEN2nGpFdwD03yEqDtOgCaun7sqSTDH32I1pQA2Pb9sZecAxc5r3IAb21d6878xsAAAAAASUVORK5CYII=";
    if (this.isMobileDevice_) {
        img.width *= 2;
        img.height *= 2;
    }
    this.leftZoomHandle_ = img;
    this.rightZoomHandle_ = img.cloneNode(false);
};
/**
 * @private
 * Sets up the interaction for the range selector.
 */ $174201254fd40c2e$var$rangeSelector.prototype.initInteraction_ = function() {
    var self = this;
    var topElem = document;
    var clientXLast = 0;
    var handle = null;
    var isZooming = false;
    var isPanning = false;
    var dynamic = !this.isMobileDevice_;
    // We cover iframes during mouse interactions. See comments in
    // dygraph-utils.js for more info on why this is a good idea.
    var tarp = new $174201254fd40c2e$var$_iframeTarp2['default']();
    // functions, defined below.  Defining them this way (rather than with
    // "function foo() {...}" makes JSHint happy.
    var toXDataWindow, onZoomStart, onZoom, onZoomEnd, doZoom, isMouseInPanZone, onPanStart, onPan, onPanEnd, doPan, onCanvasHover;
    // Touch event functions
    var onZoomHandleTouchEvent, onCanvasTouchEvent, addTouchEvents;
    toXDataWindow = function(zoomHandleStatus) {
        var xDataLimits = self.dygraph_.xAxisExtremes();
        var fact = (xDataLimits[1] - xDataLimits[0]) / self.canvasRect_.w;
        var xDataMin = xDataLimits[0] + (zoomHandleStatus.leftHandlePos - self.canvasRect_.x) * fact;
        var xDataMax = xDataLimits[0] + (zoomHandleStatus.rightHandlePos - self.canvasRect_.x) * fact;
        return [
            xDataMin,
            xDataMax
        ];
    };
    onZoomStart = function(e) {
        $174201254fd40c2e$var$utils.cancelEvent(e);
        isZooming = true;
        clientXLast = e.clientX;
        handle = e.target ? e.target : e.srcElement;
        if (e.type === 'mousedown' || e.type === 'dragstart') {
            // These events are removed manually.
            $174201254fd40c2e$var$utils.addEvent(topElem, 'mousemove', onZoom);
            $174201254fd40c2e$var$utils.addEvent(topElem, 'mouseup', onZoomEnd);
        }
        self.fgcanvas_.style.cursor = 'col-resize';
        tarp.cover();
        return true;
    };
    onZoom = function(e) {
        if (!isZooming) return false;
        $174201254fd40c2e$var$utils.cancelEvent(e);
        var delX = e.clientX - clientXLast;
        if (Math.abs(delX) < 4) return true;
        clientXLast = e.clientX;
        // Move handle.
        var zoomHandleStatus = self.getZoomHandleStatus_();
        var newPos;
        if (handle == self.leftZoomHandle_) {
            newPos = zoomHandleStatus.leftHandlePos + delX;
            newPos = Math.min(newPos, zoomHandleStatus.rightHandlePos - handle.width - 3);
            newPos = Math.max(newPos, self.canvasRect_.x);
        } else {
            newPos = zoomHandleStatus.rightHandlePos + delX;
            newPos = Math.min(newPos, self.canvasRect_.x + self.canvasRect_.w);
            newPos = Math.max(newPos, zoomHandleStatus.leftHandlePos + handle.width + 3);
        }
        var halfHandleWidth = handle.width / 2;
        handle.style.left = newPos - halfHandleWidth + 'px';
        self.drawInteractiveLayer_();
        // Zoom on the fly.
        if (dynamic) doZoom();
        return true;
    };
    onZoomEnd = function(e) {
        if (!isZooming) return false;
        isZooming = false;
        tarp.uncover();
        $174201254fd40c2e$var$utils.removeEvent(topElem, 'mousemove', onZoom);
        $174201254fd40c2e$var$utils.removeEvent(topElem, 'mouseup', onZoomEnd);
        self.fgcanvas_.style.cursor = 'default';
        // If on a slower device, zoom now.
        if (!dynamic) doZoom();
        return true;
    };
    doZoom = function() {
        try {
            var zoomHandleStatus = self.getZoomHandleStatus_();
            self.isChangingRange_ = true;
            if (!zoomHandleStatus.isZoomed) self.dygraph_.resetZoom();
            else {
                var xDataWindow = toXDataWindow(zoomHandleStatus);
                self.dygraph_.doZoomXDates_(xDataWindow[0], xDataWindow[1]);
            }
        } finally{
            self.isChangingRange_ = false;
        }
    };
    isMouseInPanZone = function(e) {
        var rect = self.leftZoomHandle_.getBoundingClientRect();
        var leftHandleClientX = rect.left + rect.width / 2;
        rect = self.rightZoomHandle_.getBoundingClientRect();
        var rightHandleClientX = rect.left + rect.width / 2;
        return e.clientX > leftHandleClientX && e.clientX < rightHandleClientX;
    };
    onPanStart = function(e) {
        if (!isPanning && isMouseInPanZone(e) && self.getZoomHandleStatus_().isZoomed) {
            $174201254fd40c2e$var$utils.cancelEvent(e);
            isPanning = true;
            clientXLast = e.clientX;
            if (e.type === 'mousedown') {
                // These events are removed manually.
                $174201254fd40c2e$var$utils.addEvent(topElem, 'mousemove', onPan);
                $174201254fd40c2e$var$utils.addEvent(topElem, 'mouseup', onPanEnd);
            }
            return true;
        }
        return false;
    };
    onPan = function(e) {
        if (!isPanning) return false;
        $174201254fd40c2e$var$utils.cancelEvent(e);
        var delX = e.clientX - clientXLast;
        if (Math.abs(delX) < 4) return true;
        clientXLast = e.clientX;
        // Move range view
        var zoomHandleStatus = self.getZoomHandleStatus_();
        var leftHandlePos = zoomHandleStatus.leftHandlePos;
        var rightHandlePos = zoomHandleStatus.rightHandlePos;
        var rangeSize = rightHandlePos - leftHandlePos;
        if (leftHandlePos + delX <= self.canvasRect_.x) {
            leftHandlePos = self.canvasRect_.x;
            rightHandlePos = leftHandlePos + rangeSize;
        } else if (rightHandlePos + delX >= self.canvasRect_.x + self.canvasRect_.w) {
            rightHandlePos = self.canvasRect_.x + self.canvasRect_.w;
            leftHandlePos = rightHandlePos - rangeSize;
        } else {
            leftHandlePos += delX;
            rightHandlePos += delX;
        }
        var halfHandleWidth = self.leftZoomHandle_.width / 2;
        self.leftZoomHandle_.style.left = leftHandlePos - halfHandleWidth + 'px';
        self.rightZoomHandle_.style.left = rightHandlePos - halfHandleWidth + 'px';
        self.drawInteractiveLayer_();
        // Do pan on the fly.
        if (dynamic) doPan();
        return true;
    };
    onPanEnd = function(e) {
        if (!isPanning) return false;
        isPanning = false;
        $174201254fd40c2e$var$utils.removeEvent(topElem, 'mousemove', onPan);
        $174201254fd40c2e$var$utils.removeEvent(topElem, 'mouseup', onPanEnd);
        // If on a slower device, do pan now.
        if (!dynamic) doPan();
        return true;
    };
    doPan = function() {
        try {
            self.isChangingRange_ = true;
            self.dygraph_.dateWindow_ = toXDataWindow(self.getZoomHandleStatus_());
            self.dygraph_.drawGraph_(false);
        } finally{
            self.isChangingRange_ = false;
        }
    };
    onCanvasHover = function(e) {
        if (isZooming || isPanning) return;
        var cursor = isMouseInPanZone(e) ? 'move' : 'default';
        if (cursor != self.fgcanvas_.style.cursor) self.fgcanvas_.style.cursor = cursor;
    };
    onZoomHandleTouchEvent = function(e) {
        if (e.type == 'touchstart' && e.targetTouches.length == 1) {
            if (onZoomStart(e.targetTouches[0])) $174201254fd40c2e$var$utils.cancelEvent(e);
        } else if (e.type == 'touchmove' && e.targetTouches.length == 1) {
            if (onZoom(e.targetTouches[0])) $174201254fd40c2e$var$utils.cancelEvent(e);
        } else onZoomEnd(e);
    };
    onCanvasTouchEvent = function(e) {
        if (e.type == 'touchstart' && e.targetTouches.length == 1) {
            if (onPanStart(e.targetTouches[0])) $174201254fd40c2e$var$utils.cancelEvent(e);
        } else if (e.type == 'touchmove' && e.targetTouches.length == 1) {
            if (onPan(e.targetTouches[0])) $174201254fd40c2e$var$utils.cancelEvent(e);
        } else onPanEnd(e);
    };
    addTouchEvents = function(elem, fn) {
        var types = [
            'touchstart',
            'touchend',
            'touchmove',
            'touchcancel'
        ];
        for(var i = 0; i < types.length; i++)self.dygraph_.addAndTrackEvent(elem, types[i], fn);
    };
    this.setDefaultOption_('interactionModel', $174201254fd40c2e$var$_dygraphInteractionModel2['default'].dragIsPanInteractionModel);
    this.setDefaultOption_('panEdgeFraction', 0.0001);
    var dragStartEvent = window.opera ? 'mousedown' : 'dragstart';
    this.dygraph_.addAndTrackEvent(this.leftZoomHandle_, dragStartEvent, onZoomStart);
    this.dygraph_.addAndTrackEvent(this.rightZoomHandle_, dragStartEvent, onZoomStart);
    this.dygraph_.addAndTrackEvent(this.fgcanvas_, 'mousedown', onPanStart);
    this.dygraph_.addAndTrackEvent(this.fgcanvas_, 'mousemove', onCanvasHover);
    // Touch events
    if (this.hasTouchInterface_) {
        addTouchEvents(this.leftZoomHandle_, onZoomHandleTouchEvent);
        addTouchEvents(this.rightZoomHandle_, onZoomHandleTouchEvent);
        addTouchEvents(this.fgcanvas_, onCanvasTouchEvent);
    }
};
/**
 * @private
 * Draws the static layer in the background canvas.
 */ $174201254fd40c2e$var$rangeSelector.prototype.drawStaticLayer_ = function() {
    var ctx = this.bgcanvas_ctx_;
    ctx.clearRect(0, 0, this.canvasRect_.w, this.canvasRect_.h);
    try {
        this.drawMiniPlot_();
    } catch (ex) {
        console.warn(ex);
    }
    var margin = 0.5;
    this.bgcanvas_ctx_.lineWidth = this.getOption_('rangeSelectorBackgroundLineWidth');
    ctx.strokeStyle = this.getOption_('rangeSelectorBackgroundStrokeColor');
    ctx.beginPath();
    ctx.moveTo(margin, margin);
    ctx.lineTo(margin, this.canvasRect_.h - margin);
    ctx.lineTo(this.canvasRect_.w - margin, this.canvasRect_.h - margin);
    ctx.lineTo(this.canvasRect_.w - margin, margin);
    ctx.stroke();
};
/**
 * @private
 * Draws the mini plot in the background canvas.
 */ $174201254fd40c2e$var$rangeSelector.prototype.drawMiniPlot_ = function() {
    var fillStyle = this.getOption_('rangeSelectorPlotFillColor');
    var fillGradientStyle = this.getOption_('rangeSelectorPlotFillGradientColor');
    var strokeStyle = this.getOption_('rangeSelectorPlotStrokeColor');
    if (!fillStyle && !strokeStyle) return;
    var stepPlot = this.getOption_('stepPlot');
    var combinedSeriesData = this.computeCombinedSeriesAndLimits_();
    var yRange = combinedSeriesData.yMax - combinedSeriesData.yMin;
    // Draw the mini plot.
    var ctx = this.bgcanvas_ctx_;
    var margin = 0.5;
    var xExtremes = this.dygraph_.xAxisExtremes();
    var xRange = Math.max(xExtremes[1] - xExtremes[0], 1.e-30);
    var xFact = (this.canvasRect_.w - margin) / xRange;
    var yFact = (this.canvasRect_.h - margin) / yRange;
    var canvasWidth = this.canvasRect_.w - margin;
    var canvasHeight = this.canvasRect_.h - margin;
    var prevX = null, prevY = null;
    ctx.beginPath();
    ctx.moveTo(margin, canvasHeight);
    for(var i = 0; i < combinedSeriesData.data.length; i++){
        var dataPoint = combinedSeriesData.data[i];
        var x = dataPoint[0] !== null ? (dataPoint[0] - xExtremes[0]) * xFact : NaN;
        var y = dataPoint[1] !== null ? canvasHeight - (dataPoint[1] - combinedSeriesData.yMin) * yFact : NaN;
        // Skip points that don't change the x-value. Overly fine-grained points
        // can cause major slowdowns with the ctx.fill() call below.
        if (!stepPlot && prevX !== null && Math.round(x) == Math.round(prevX)) continue;
        if (isFinite(x) && isFinite(y)) {
            if (prevX === null) ctx.lineTo(x, canvasHeight);
            else if (stepPlot) ctx.lineTo(x, prevY);
            ctx.lineTo(x, y);
            prevX = x;
            prevY = y;
        } else {
            if (prevX !== null) {
                if (stepPlot) {
                    ctx.lineTo(x, prevY);
                    ctx.lineTo(x, canvasHeight);
                } else ctx.lineTo(prevX, canvasHeight);
            }
            prevX = prevY = null;
        }
    }
    ctx.lineTo(canvasWidth, canvasHeight);
    ctx.closePath();
    if (fillStyle) {
        var lingrad = this.bgcanvas_ctx_.createLinearGradient(0, 0, 0, canvasHeight);
        if (fillGradientStyle) lingrad.addColorStop(0, fillGradientStyle);
        lingrad.addColorStop(1, fillStyle);
        this.bgcanvas_ctx_.fillStyle = lingrad;
        ctx.fill();
    }
    if (strokeStyle) {
        this.bgcanvas_ctx_.strokeStyle = strokeStyle;
        this.bgcanvas_ctx_.lineWidth = this.getOption_('rangeSelectorPlotLineWidth');
        ctx.stroke();
    }
};
/**
 * @private
 * Computes and returns the combined series data along with min/max for the mini plot.
 * The combined series consists of averaged values for all series.
 * When series have error bars, the error bars are ignored.
 * @return {Object} An object containing combined series array, ymin, ymax.
 */ $174201254fd40c2e$var$rangeSelector.prototype.computeCombinedSeriesAndLimits_ = function() {
    var g = this.dygraph_;
    var logscale = this.getOption_('logscale');
    var i;
    // Select series to combine. By default, all series are combined.
    var numColumns = g.numColumns();
    var labels = g.getLabels();
    var includeSeries = new Array(numColumns);
    var anySet = false;
    var visibility = g.visibility();
    var inclusion = [];
    for(i = 1; i < numColumns; i++){
        var include = this.getOption_('showInRangeSelector', labels[i]);
        inclusion.push(include);
        if (include !== null) anySet = true; // it's set explicitly for this series
    }
    if (anySet) for(i = 1; i < numColumns; i++)includeSeries[i] = inclusion[i - 1];
    else for(i = 1; i < numColumns; i++)includeSeries[i] = visibility[i - 1];
    // Create a combined series (average of selected series values).
    // TODO(danvk): short-circuit if there's only one series.
    var rolledSeries = [];
    var dataHandler = g.dataHandler_;
    var options = g.attributes_;
    for(i = 1; i < g.numColumns(); i++){
        if (!includeSeries[i]) continue;
        var series = dataHandler.extractSeries(g.rawData_, i, options);
        if (g.rollPeriod() > 1) series = dataHandler.rollingAverage(series, g.rollPeriod(), options);
        rolledSeries.push(series);
    }
    var combinedSeries = [];
    for(i = 0; i < rolledSeries[0].length; i++){
        var sum = 0;
        var count = 0;
        for(var j = 0; j < rolledSeries.length; j++){
            var y = rolledSeries[j][i][1];
            if (y === null || isNaN(y)) continue;
            count++;
            sum += y;
        }
        combinedSeries.push([
            rolledSeries[0][i][0],
            sum / count
        ]);
    }
    // Compute the y range.
    var yMin = Number.MAX_VALUE;
    var yMax = -Number.MAX_VALUE;
    for(i = 0; i < combinedSeries.length; i++){
        var yVal = combinedSeries[i][1];
        if (yVal !== null && isFinite(yVal) && (!logscale || yVal > 0)) {
            yMin = Math.min(yMin, yVal);
            yMax = Math.max(yMax, yVal);
        }
    }
    // Convert Y data to log scale if needed.
    // Also, expand the Y range to compress the mini plot a little.
    var extraPercent = 0.25;
    if (logscale) {
        yMax = $174201254fd40c2e$var$utils.log10(yMax);
        yMax += yMax * extraPercent;
        yMin = $174201254fd40c2e$var$utils.log10(yMin);
        for(i = 0; i < combinedSeries.length; i++)combinedSeries[i][1] = $174201254fd40c2e$var$utils.log10(combinedSeries[i][1]);
    } else {
        var yExtra;
        var yRange = yMax - yMin;
        if (yRange <= Number.MIN_VALUE) yExtra = yMax * extraPercent;
        else yExtra = yRange * extraPercent;
        yMax += yExtra;
        yMin -= yExtra;
    }
    return {
        data: combinedSeries,
        yMin: yMin,
        yMax: yMax
    };
};
/**
 * @private
 * Places the zoom handles in the proper position based on the current X data window.
 */ $174201254fd40c2e$var$rangeSelector.prototype.placeZoomHandles_ = function() {
    var xExtremes = this.dygraph_.xAxisExtremes();
    var xWindowLimits = this.dygraph_.xAxisRange();
    var xRange = xExtremes[1] - xExtremes[0];
    var leftPercent = Math.max(0, (xWindowLimits[0] - xExtremes[0]) / xRange);
    var rightPercent = Math.max(0, (xExtremes[1] - xWindowLimits[1]) / xRange);
    var leftCoord = this.canvasRect_.x + this.canvasRect_.w * leftPercent;
    var rightCoord = this.canvasRect_.x + this.canvasRect_.w * (1 - rightPercent);
    var handleTop = Math.max(this.canvasRect_.y, this.canvasRect_.y + (this.canvasRect_.h - this.leftZoomHandle_.height) / 2);
    var halfHandleWidth = this.leftZoomHandle_.width / 2;
    this.leftZoomHandle_.style.left = leftCoord - halfHandleWidth + 'px';
    this.leftZoomHandle_.style.top = handleTop + 'px';
    this.rightZoomHandle_.style.left = rightCoord - halfHandleWidth + 'px';
    this.rightZoomHandle_.style.top = this.leftZoomHandle_.style.top;
    this.leftZoomHandle_.style.visibility = 'visible';
    this.rightZoomHandle_.style.visibility = 'visible';
};
/**
 * @private
 * Draws the interactive layer in the foreground canvas.
 */ $174201254fd40c2e$var$rangeSelector.prototype.drawInteractiveLayer_ = function() {
    var ctx = this.fgcanvas_ctx_;
    ctx.clearRect(0, 0, this.canvasRect_.w, this.canvasRect_.h);
    var margin = 1;
    var width = this.canvasRect_.w - margin;
    var height = this.canvasRect_.h - margin;
    var zoomHandleStatus = this.getZoomHandleStatus_();
    ctx.strokeStyle = this.getOption_('rangeSelectorForegroundStrokeColor');
    ctx.lineWidth = this.getOption_('rangeSelectorForegroundLineWidth');
    if (!zoomHandleStatus.isZoomed) {
        ctx.beginPath();
        ctx.moveTo(margin, margin);
        ctx.lineTo(margin, height);
        ctx.lineTo(width, height);
        ctx.lineTo(width, margin);
        ctx.stroke();
    } else {
        var leftHandleCanvasPos = Math.max(margin, zoomHandleStatus.leftHandlePos - this.canvasRect_.x);
        var rightHandleCanvasPos = Math.min(width, zoomHandleStatus.rightHandlePos - this.canvasRect_.x);
        ctx.fillStyle = 'rgba(240, 240, 240, ' + this.getOption_('rangeSelectorAlpha').toString() + ')';
        ctx.fillRect(0, 0, leftHandleCanvasPos, this.canvasRect_.h);
        ctx.fillRect(rightHandleCanvasPos, 0, this.canvasRect_.w - rightHandleCanvasPos, this.canvasRect_.h);
        ctx.beginPath();
        ctx.moveTo(margin, margin);
        ctx.lineTo(leftHandleCanvasPos, margin);
        ctx.lineTo(leftHandleCanvasPos, height);
        ctx.lineTo(rightHandleCanvasPos, height);
        ctx.lineTo(rightHandleCanvasPos, margin);
        ctx.lineTo(width, margin);
        ctx.stroke();
    }
};
/**
 * @private
 * Returns the current zoom handle position information.
 * @return {Object} The zoom handle status.
 */ $174201254fd40c2e$var$rangeSelector.prototype.getZoomHandleStatus_ = function() {
    var halfHandleWidth = this.leftZoomHandle_.width / 2;
    var leftHandlePos = parseFloat(this.leftZoomHandle_.style.left) + halfHandleWidth;
    var rightHandlePos = parseFloat(this.rightZoomHandle_.style.left) + halfHandleWidth;
    return {
        leftHandlePos: leftHandlePos,
        rightHandlePos: rightHandlePos,
        isZoomed: leftHandlePos - 1 > this.canvasRect_.x || rightHandlePos + 1 < this.canvasRect_.x + this.canvasRect_.w
    };
};
$174201254fd40c2e$exports['default'] = $174201254fd40c2e$var$rangeSelector;
$174201254fd40c2e$exports = $174201254fd40c2e$exports['default'];


var $298304f644e9f727$var$_pluginsRangeSelector2 = $298304f644e9f727$var$_interopRequireDefault($174201254fd40c2e$exports);
var $6795d7e6092e875a$exports = {};
/**
 * @license
 * Copyright 2011 Dan Vanderkam (danvdk@gmail.com)
 * MIT-licensed (http://opensource.org/licenses/MIT)
 */ /**
 * @fileoverview A wrapper around the Dygraph class which implements the
 * interface for a GViz (aka Google Visualization API) visualization.
 * It is designed to be a drop-in replacement for Google's AnnotatedTimeline,
 * so the documentation at
 * http://code.google.com/apis/chart/interactive/docs/gallery/annotatedtimeline.html
 * translates over directly.
 *
 * For a full demo, see:
 * - http://dygraphs.com/tests/gviz.html
 * - http://dygraphs.com/tests/annotation-gviz.html
 */ /*global Dygraph:false */ "use strict";
Object.defineProperty($6795d7e6092e875a$exports, '__esModule', {
    value: true
});
function $6795d7e6092e875a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}

var $6795d7e6092e875a$var$_dygraph2 = $6795d7e6092e875a$var$_interopRequireDefault($298304f644e9f727$exports);
/**
 * A wrapper around Dygraph that implements the gviz API.
 * @param {!HTMLDivElement} container The DOM object the visualization should
 *     live in.
 * @constructor
 */ var $6795d7e6092e875a$var$GVizChart = function GVizChart(container) {
    this.container = container;
};
/**
 * @param {GVizDataTable} data
 * @param {Object.<*>} options
 */ $6795d7e6092e875a$var$GVizChart.prototype.draw = function(data, options) {
    // Clear out any existing dygraph.
    // TODO(danvk): would it make more sense to simply redraw using the current
    // date_graph object?
    this.container.innerHTML = '';
    if (typeof this.date_graph != 'undefined') this.date_graph.destroy();
    this.date_graph = new $6795d7e6092e875a$var$_dygraph2['default'](this.container, data, options);
};
/**
 * Google charts compatible setSelection
 * Only row selection is supported, all points in the row will be highlighted
 * @param {Array.<{row:number}>} selection_array array of the selected cells
 * @public
 */ $6795d7e6092e875a$var$GVizChart.prototype.setSelection = function(selection_array) {
    var row = false;
    if (selection_array.length) row = selection_array[0].row;
    this.date_graph.setSelection(row);
};
/**
 * Google charts compatible getSelection implementation
 * @return {Array.<{row:number,column:number}>} array of the selected cells
 * @public
 */ $6795d7e6092e875a$var$GVizChart.prototype.getSelection = function() {
    var selection = [];
    var row = this.date_graph.getSelection();
    if (row < 0) return selection;
    var points = this.date_graph.layout_.points;
    for(var setIdx = 0; setIdx < points.length; ++setIdx)selection.push({
        row: row,
        column: setIdx + 1
    });
    return selection;
};
$6795d7e6092e875a$exports['default'] = $6795d7e6092e875a$var$GVizChart;
$6795d7e6092e875a$exports = $6795d7e6092e875a$exports['default'];


var $298304f644e9f727$var$_dygraphGviz2 = $298304f644e9f727$var$_interopRequireDefault($6795d7e6092e875a$exports);
"use strict";
/**
 * Creates an interactive, zoomable chart.
 *
 * @constructor
 * @param {div | String} div A div or the id of a div into which to construct
 * the chart.
 * @param {String | Function} file A file containing CSV data or a function
 * that returns this data. The most basic expected format for each line is
 * "YYYY/MM/DD,val1,val2,...". For more information, see
 * http://dygraphs.com/data.html.
 * @param {Object} attrs Various other attributes, e.g. errorBars determines
 * whether the input data contains error ranges. For a complete list of
 * options, see http://dygraphs.com/options.html.
 */ var $298304f644e9f727$var$Dygraph = function Dygraph(div, data, opts) {
    this.__init__(div, data, opts);
};
$298304f644e9f727$var$Dygraph.NAME = "Dygraph";
$298304f644e9f727$var$Dygraph.VERSION = "2.0.0";
// Various default values
$298304f644e9f727$var$Dygraph.DEFAULT_ROLL_PERIOD = 1;
$298304f644e9f727$var$Dygraph.DEFAULT_WIDTH = 480;
$298304f644e9f727$var$Dygraph.DEFAULT_HEIGHT = 320;
// For max 60 Hz. animation:
$298304f644e9f727$var$Dygraph.ANIMATION_STEPS = 12;
$298304f644e9f727$var$Dygraph.ANIMATION_DURATION = 200;
/**
 * Standard plotters. These may be used by clients.
 * Available plotters are:
 * - Dygraph.Plotters.linePlotter: draws central lines (most common)
 * - Dygraph.Plotters.errorPlotter: draws error bars
 * - Dygraph.Plotters.fillPlotter: draws fills under lines (used with fillGraph)
 *
 * By default, the plotter is [fillPlotter, errorPlotter, linePlotter].
 * This causes all the lines to be drawn over all the fills/error bars.
 */ $298304f644e9f727$var$Dygraph.Plotters = $298304f644e9f727$var$_dygraphCanvas2['default']._Plotters;
// Used for initializing annotation CSS rules only once.
$298304f644e9f727$var$Dygraph.addedAnnotationCSS = false;
/**
 * Initializes the Dygraph. This creates a new DIV and constructs the PlotKit
 * and context &lt;canvas&gt; inside of it. See the constructor for details.
 * on the parameters.
 * @param {Element} div the Element to render the graph into.
 * @param {string | Function} file Source data
 * @param {Object} attrs Miscellaneous other options
 * @private
 */ $298304f644e9f727$var$Dygraph.prototype.__init__ = function(div, file, attrs) {
    this.is_initial_draw_ = true;
    this.readyFns_ = [];
    // Support two-argument constructor
    if (attrs === null || attrs === undefined) attrs = {};
    attrs = $298304f644e9f727$var$Dygraph.copyUserAttrs_(attrs);
    if (typeof div == 'string') div = document.getElementById(div);
    if (!div) throw new Error('Constructing dygraph with a non-existent div!');
    // Copy the important bits into the object
    // TODO(danvk): most of these should just stay in the attrs_ dictionary.
    this.maindiv_ = div;
    this.file_ = file;
    this.rollPeriod_ = attrs.rollPeriod || $298304f644e9f727$var$Dygraph.DEFAULT_ROLL_PERIOD;
    this.previousVerticalX_ = -1;
    this.fractions_ = attrs.fractions || false;
    this.dateWindow_ = attrs.dateWindow || null;
    this.annotations_ = [];
    // Clear the div. This ensure that, if multiple dygraphs are passed the same
    // div, then only one will be drawn.
    div.innerHTML = "";
    // For historical reasons, the 'width' and 'height' options trump all CSS
    // rules _except_ for an explicit 'width' or 'height' on the div.
    // As an added convenience, if the div has zero height (like <div></div> does
    // without any styles), then we use a default height/width.
    if (div.style.width === '' && attrs.width) div.style.width = attrs.width + "px";
    if (div.style.height === '' && attrs.height) div.style.height = attrs.height + "px";
    if (div.style.height === '' && div.clientHeight === 0) {
        div.style.height = $298304f644e9f727$var$Dygraph.DEFAULT_HEIGHT + "px";
        if (div.style.width === '') div.style.width = $298304f644e9f727$var$Dygraph.DEFAULT_WIDTH + "px";
    }
    // These will be zero if the dygraph's div is hidden. In that case,
    // use the user-specified attributes if present. If not, use zero
    // and assume the user will call resize to fix things later.
    this.width_ = div.clientWidth || attrs.width || 0;
    this.height_ = div.clientHeight || attrs.height || 0;
    // TODO(danvk): set fillGraph to be part of attrs_ here, not user_attrs_.
    if (attrs.stackedGraph) attrs.fillGraph = true;
    // DEPRECATION WARNING: All option processing should be moved from
    // attrs_ and user_attrs_ to options_, which holds all this information.
    //
    // Dygraphs has many options, some of which interact with one another.
    // To keep track of everything, we maintain two sets of options:
    //
    //  this.user_attrs_   only options explicitly set by the user.
    //  this.attrs_        defaults, options derived from user_attrs_, data.
    //
    // Options are then accessed this.attr_('attr'), which first looks at
    // user_attrs_ and then computed attrs_. This way Dygraphs can set intelligent
    // defaults without overriding behavior that the user specifically asks for.
    this.user_attrs_ = {};
    $298304f644e9f727$var$utils.update(this.user_attrs_, attrs);
    // This sequence ensures that Dygraph.DEFAULT_ATTRS is never modified.
    this.attrs_ = {};
    $298304f644e9f727$var$utils.updateDeep(this.attrs_, $298304f644e9f727$var$_dygraphDefaultAttrs2['default']);
    this.boundaryIds_ = [];
    this.setIndexByName_ = {};
    this.datasetIndex_ = [];
    this.registeredEvents_ = [];
    this.eventListeners_ = {};
    this.attributes_ = new $298304f644e9f727$var$_dygraphOptions2['default'](this);
    // Create the containing DIV and other interactive elements
    this.createInterface_();
    // Activate plugins.
    this.plugins_ = [];
    var plugins = $298304f644e9f727$var$Dygraph.PLUGINS.concat(this.getOption('plugins'));
    for(var i = 0; i < plugins.length; i++){
        // the plugins option may contain either plugin classes or instances.
        // Plugin instances contain an activate method.
        var Plugin = plugins[i]; // either a constructor or an instance.
        var pluginInstance;
        if (typeof Plugin.activate !== 'undefined') pluginInstance = Plugin;
        else pluginInstance = new Plugin();
        var pluginDict = {
            plugin: pluginInstance,
            events: {},
            options: {},
            pluginOptions: {}
        };
        var handlers = pluginInstance.activate(this);
        for(var eventName in handlers){
            if (!handlers.hasOwnProperty(eventName)) continue;
            // TODO(danvk): validate eventName.
            pluginDict.events[eventName] = handlers[eventName];
        }
        this.plugins_.push(pluginDict);
    }
    // At this point, plugins can no longer register event handlers.
    // Construct a map from event -> ordered list of [callback, plugin].
    for(var i = 0; i < this.plugins_.length; i++){
        var plugin_dict = this.plugins_[i];
        for(var eventName in plugin_dict.events){
            if (!plugin_dict.events.hasOwnProperty(eventName)) continue;
            var callback = plugin_dict.events[eventName];
            var pair = [
                plugin_dict.plugin,
                callback
            ];
            if (!(eventName in this.eventListeners_)) this.eventListeners_[eventName] = [
                pair
            ];
            else this.eventListeners_[eventName].push(pair);
        }
    }
    this.createDragInterface_();
    this.start_();
};
/**
 * Triggers a cascade of events to the various plugins which are interested in them.
 * Returns true if the "default behavior" should be prevented, i.e. if one
 * of the event listeners called event.preventDefault().
 * @private
 */ $298304f644e9f727$var$Dygraph.prototype.cascadeEvents_ = function(name, extra_props) {
    if (!(name in this.eventListeners_)) return false;
    // QUESTION: can we use objects & prototypes to speed this up?
    var e = {
        dygraph: this,
        cancelable: false,
        defaultPrevented: false,
        preventDefault: function preventDefault() {
            if (!e.cancelable) throw "Cannot call preventDefault on non-cancelable event.";
            e.defaultPrevented = true;
        },
        propagationStopped: false,
        stopPropagation: function stopPropagation() {
            e.propagationStopped = true;
        }
    };
    $298304f644e9f727$var$utils.update(e, extra_props);
    var callback_plugin_pairs = this.eventListeners_[name];
    if (callback_plugin_pairs) for(var i = callback_plugin_pairs.length - 1; i >= 0; i--){
        var plugin = callback_plugin_pairs[i][0];
        var callback = callback_plugin_pairs[i][1];
        callback.call(plugin, e);
        if (e.propagationStopped) break;
    }
    return e.defaultPrevented;
};
/**
 * Fetch a plugin instance of a particular class. Only for testing.
 * @private
 * @param {!Class} type The type of the plugin.
 * @return {Object} Instance of the plugin, or null if there is none.
 */ $298304f644e9f727$var$Dygraph.prototype.getPluginInstance_ = function(type) {
    for(var i = 0; i < this.plugins_.length; i++){
        var p = this.plugins_[i];
        if (p.plugin instanceof type) return p.plugin;
    }
    return null;
};
/**
 * Returns the zoomed status of the chart for one or both axes.
 *
 * Axis is an optional parameter. Can be set to 'x' or 'y'.
 *
 * The zoomed status for an axis is set whenever a user zooms using the mouse
 * or when the dateWindow or valueRange are updated. Double-clicking or calling
 * resetZoom() resets the zoom status for the chart.
 */ $298304f644e9f727$var$Dygraph.prototype.isZoomed = function(axis) {
    var isZoomedX = !!this.dateWindow_;
    if (axis === 'x') return isZoomedX;
    var isZoomedY = this.axes_.map(function(axis) {
        return !!axis.valueRange;
    }).indexOf(true) >= 0;
    if (axis === null || axis === undefined) return isZoomedX || isZoomedY;
    if (axis === 'y') return isZoomedY;
    throw new Error('axis parameter is [' + axis + '] must be null, \'x\' or \'y\'.');
};
/**
 * Returns information about the Dygraph object, including its containing ID.
 */ $298304f644e9f727$var$Dygraph.prototype.toString = function() {
    var maindiv = this.maindiv_;
    var id = maindiv && maindiv.id ? maindiv.id : maindiv;
    return "[Dygraph " + id + "]";
};
/**
 * @private
 * Returns the value of an option. This may be set by the user (either in the
 * constructor or by calling updateOptions) or by dygraphs, and may be set to a
 * per-series value.
 * @param {string} name The name of the option, e.g. 'rollPeriod'.
 * @param {string} [seriesName] The name of the series to which the option
 * will be applied. If no per-series value of this option is available, then
 * the global value is returned. This is optional.
 * @return { ... } The value of the option.
 */ $298304f644e9f727$var$Dygraph.prototype.attr_ = function(name, seriesName) {
    return seriesName ? this.attributes_.getForSeries(name, seriesName) : this.attributes_.get(name);
};
/**
 * Returns the current value for an option, as set in the constructor or via
 * updateOptions. You may pass in an (optional) series name to get per-series
 * values for the option.
 *
 * All values returned by this method should be considered immutable. If you
 * modify them, there is no guarantee that the changes will be honored or that
 * dygraphs will remain in a consistent state. If you want to modify an option,
 * use updateOptions() instead.
 *
 * @param {string} name The name of the option (e.g. 'strokeWidth')
 * @param {string=} opt_seriesName Series name to get per-series values.
 * @return {*} The value of the option.
 */ $298304f644e9f727$var$Dygraph.prototype.getOption = function(name, opt_seriesName) {
    return this.attr_(name, opt_seriesName);
};
/**
 * Like getOption(), but specifically returns a number.
 * This is a convenience function for working with the Closure Compiler.
 * @param {string} name The name of the option (e.g. 'strokeWidth')
 * @param {string=} opt_seriesName Series name to get per-series values.
 * @return {number} The value of the option.
 * @private
 */ $298304f644e9f727$var$Dygraph.prototype.getNumericOption = function(name, opt_seriesName) {
    return /** @type{number} */ this.getOption(name, opt_seriesName);
};
/**
 * Like getOption(), but specifically returns a string.
 * This is a convenience function for working with the Closure Compiler.
 * @param {string} name The name of the option (e.g. 'strokeWidth')
 * @param {string=} opt_seriesName Series name to get per-series values.
 * @return {string} The value of the option.
 * @private
 */ $298304f644e9f727$var$Dygraph.prototype.getStringOption = function(name, opt_seriesName) {
    return /** @type{string} */ this.getOption(name, opt_seriesName);
};
/**
 * Like getOption(), but specifically returns a boolean.
 * This is a convenience function for working with the Closure Compiler.
 * @param {string} name The name of the option (e.g. 'strokeWidth')
 * @param {string=} opt_seriesName Series name to get per-series values.
 * @return {boolean} The value of the option.
 * @private
 */ $298304f644e9f727$var$Dygraph.prototype.getBooleanOption = function(name, opt_seriesName) {
    return /** @type{boolean} */ this.getOption(name, opt_seriesName);
};
/**
 * Like getOption(), but specifically returns a function.
 * This is a convenience function for working with the Closure Compiler.
 * @param {string} name The name of the option (e.g. 'strokeWidth')
 * @param {string=} opt_seriesName Series name to get per-series values.
 * @return {function(...)} The value of the option.
 * @private
 */ $298304f644e9f727$var$Dygraph.prototype.getFunctionOption = function(name, opt_seriesName) {
    return /** @type{function(...)} */ this.getOption(name, opt_seriesName);
};
$298304f644e9f727$var$Dygraph.prototype.getOptionForAxis = function(name, axis) {
    return this.attributes_.getForAxis(name, axis);
};
/**
 * @private
 * @param {string} axis The name of the axis (i.e. 'x', 'y' or 'y2')
 * @return { ... } A function mapping string -> option value
 */ $298304f644e9f727$var$Dygraph.prototype.optionsViewForAxis_ = function(axis) {
    var self = this;
    return function(opt) {
        var axis_opts = self.user_attrs_.axes;
        if (axis_opts && axis_opts[axis] && axis_opts[axis].hasOwnProperty(opt)) return axis_opts[axis][opt];
        // I don't like that this is in a second spot.
        if (axis === 'x' && opt === 'logscale') // return the default value.
        // TODO(konigsberg): pull the default from a global default.
        return false;
        // user-specified attributes always trump defaults, even if they're less
        // specific.
        if (typeof self.user_attrs_[opt] != 'undefined') return self.user_attrs_[opt];
        axis_opts = self.attrs_.axes;
        if (axis_opts && axis_opts[axis] && axis_opts[axis].hasOwnProperty(opt)) return axis_opts[axis][opt];
        // check old-style axis options
        // TODO(danvk): add a deprecation warning if either of these match.
        if (axis == 'y' && self.axes_[0].hasOwnProperty(opt)) return self.axes_[0][opt];
        else if (axis == 'y2' && self.axes_[1].hasOwnProperty(opt)) return self.axes_[1][opt];
        return self.attr_(opt);
    };
};
/**
 * Returns the current rolling period, as set by the user or an option.
 * @return {number} The number of points in the rolling window
 */ $298304f644e9f727$var$Dygraph.prototype.rollPeriod = function() {
    return this.rollPeriod_;
};
/**
 * Returns the currently-visible x-range. This can be affected by zooming,
 * panning or a call to updateOptions.
 * Returns a two-element array: [left, right].
 * If the Dygraph has dates on the x-axis, these will be millis since epoch.
 */ $298304f644e9f727$var$Dygraph.prototype.xAxisRange = function() {
    return this.dateWindow_ ? this.dateWindow_ : this.xAxisExtremes();
};
/**
 * Returns the lower- and upper-bound x-axis values of the data set.
 */ $298304f644e9f727$var$Dygraph.prototype.xAxisExtremes = function() {
    var pad = this.getNumericOption('xRangePad') / this.plotter_.area.w;
    if (this.numRows() === 0) return [
        0 - pad,
        1 + pad
    ];
    var left = this.rawData_[0][0];
    var right = this.rawData_[this.rawData_.length - 1][0];
    if (pad) {
        // Must keep this in sync with dygraph-layout _evaluateLimits()
        var range = right - left;
        left -= range * pad;
        right += range * pad;
    }
    return [
        left,
        right
    ];
};
/**
 * Returns the lower- and upper-bound y-axis values for each axis. These are
 * the ranges you'll get if you double-click to zoom out or call resetZoom().
 * The return value is an array of [low, high] tuples, one for each y-axis.
 */ $298304f644e9f727$var$Dygraph.prototype.yAxisExtremes = function() {
    // TODO(danvk): this is pretty inefficient
    var packed = this.gatherDatasets_(this.rolledSeries_, null);
    var extremes = packed.extremes;
    var saveAxes = this.axes_;
    this.computeYAxisRanges_(extremes);
    var newAxes = this.axes_;
    this.axes_ = saveAxes;
    return newAxes.map(function(axis) {
        return axis.extremeRange;
    });
};
/**
 * Returns the currently-visible y-range for an axis. This can be affected by
 * zooming, panning or a call to updateOptions. Axis indices are zero-based. If
 * called with no arguments, returns the range of the first axis.
 * Returns a two-element array: [bottom, top].
 */ $298304f644e9f727$var$Dygraph.prototype.yAxisRange = function(idx) {
    if (typeof idx == "undefined") idx = 0;
    if (idx < 0 || idx >= this.axes_.length) return null;
    var axis = this.axes_[idx];
    return [
        axis.computedValueRange[0],
        axis.computedValueRange[1]
    ];
};
/**
 * Returns the currently-visible y-ranges for each axis. This can be affected by
 * zooming, panning, calls to updateOptions, etc.
 * Returns an array of [bottom, top] pairs, one for each y-axis.
 */ $298304f644e9f727$var$Dygraph.prototype.yAxisRanges = function() {
    var ret = [];
    for(var i = 0; i < this.axes_.length; i++)ret.push(this.yAxisRange(i));
    return ret;
};
// TODO(danvk): use these functions throughout dygraphs.
/**
 * Convert from data coordinates to canvas/div X/Y coordinates.
 * If specified, do this conversion for the coordinate system of a particular
 * axis. Uses the first axis by default.
 * Returns a two-element array: [X, Y]
 *
 * Note: use toDomXCoord instead of toDomCoords(x, null) and use toDomYCoord
 * instead of toDomCoords(null, y, axis).
 */ $298304f644e9f727$var$Dygraph.prototype.toDomCoords = function(x, y, axis) {
    return [
        this.toDomXCoord(x),
        this.toDomYCoord(y, axis)
    ];
};
/**
 * Convert from data x coordinates to canvas/div X coordinate.
 * If specified, do this conversion for the coordinate system of a particular
 * axis.
 * Returns a single value or null if x is null.
 */ $298304f644e9f727$var$Dygraph.prototype.toDomXCoord = function(x) {
    if (x === null) return null;
    var area = this.plotter_.area;
    var xRange = this.xAxisRange();
    return area.x + (x - xRange[0]) / (xRange[1] - xRange[0]) * area.w;
};
/**
 * Convert from data x coordinates to canvas/div Y coordinate and optional
 * axis. Uses the first axis by default.
 *
 * returns a single value or null if y is null.
 */ $298304f644e9f727$var$Dygraph.prototype.toDomYCoord = function(y, axis) {
    var pct = this.toPercentYCoord(y, axis);
    if (pct === null) return null;
    var area = this.plotter_.area;
    return area.y + pct * area.h;
};
/**
 * Convert from canvas/div coords to data coordinates.
 * If specified, do this conversion for the coordinate system of a particular
 * axis. Uses the first axis by default.
 * Returns a two-element array: [X, Y].
 *
 * Note: use toDataXCoord instead of toDataCoords(x, null) and use toDataYCoord
 * instead of toDataCoords(null, y, axis).
 */ $298304f644e9f727$var$Dygraph.prototype.toDataCoords = function(x, y, axis) {
    return [
        this.toDataXCoord(x),
        this.toDataYCoord(y, axis)
    ];
};
/**
 * Convert from canvas/div x coordinate to data coordinate.
 *
 * If x is null, this returns null.
 */ $298304f644e9f727$var$Dygraph.prototype.toDataXCoord = function(x) {
    if (x === null) return null;
    var area = this.plotter_.area;
    var xRange = this.xAxisRange();
    if (!this.attributes_.getForAxis("logscale", 'x')) return xRange[0] + (x - area.x) / area.w * (xRange[1] - xRange[0]);
    else {
        var pct = (x - area.x) / area.w;
        return $298304f644e9f727$var$utils.logRangeFraction(xRange[0], xRange[1], pct);
    }
};
/**
 * Convert from canvas/div y coord to value.
 *
 * If y is null, this returns null.
 * if axis is null, this uses the first axis.
 */ $298304f644e9f727$var$Dygraph.prototype.toDataYCoord = function(y, axis) {
    if (y === null) return null;
    var area = this.plotter_.area;
    var yRange = this.yAxisRange(axis);
    if (typeof axis == "undefined") axis = 0;
    if (!this.attributes_.getForAxis("logscale", axis)) return yRange[0] + (area.y + area.h - y) / area.h * (yRange[1] - yRange[0]);
    else {
        // Computing the inverse of toDomCoord.
        var pct = (y - area.y) / area.h;
        // Note reversed yRange, y1 is on top with pct==0.
        return $298304f644e9f727$var$utils.logRangeFraction(yRange[1], yRange[0], pct);
    }
};
/**
 * Converts a y for an axis to a percentage from the top to the
 * bottom of the drawing area.
 *
 * If the coordinate represents a value visible on the canvas, then
 * the value will be between 0 and 1, where 0 is the top of the canvas.
 * However, this method will return values outside the range, as
 * values can fall outside the canvas.
 *
 * If y is null, this returns null.
 * if axis is null, this uses the first axis.
 *
 * @param {number} y The data y-coordinate.
 * @param {number} [axis] The axis number on which the data coordinate lives.
 * @return {number} A fraction in [0, 1] where 0 = the top edge.
 */ $298304f644e9f727$var$Dygraph.prototype.toPercentYCoord = function(y, axis) {
    if (y === null) return null;
    if (typeof axis == "undefined") axis = 0;
    var yRange = this.yAxisRange(axis);
    var pct;
    var logscale = this.attributes_.getForAxis("logscale", axis);
    if (logscale) {
        var logr0 = $298304f644e9f727$var$utils.log10(yRange[0]);
        var logr1 = $298304f644e9f727$var$utils.log10(yRange[1]);
        pct = (logr1 - $298304f644e9f727$var$utils.log10(y)) / (logr1 - logr0);
    } else // yRange[1] - y is unit distance from the bottom.
    // yRange[1] - yRange[0] is the scale of the range.
    // (yRange[1] - y) / (yRange[1] - yRange[0]) is the % from the bottom.
    pct = (yRange[1] - y) / (yRange[1] - yRange[0]);
    return pct;
};
/**
 * Converts an x value to a percentage from the left to the right of
 * the drawing area.
 *
 * If the coordinate represents a value visible on the canvas, then
 * the value will be between 0 and 1, where 0 is the left of the canvas.
 * However, this method will return values outside the range, as
 * values can fall outside the canvas.
 *
 * If x is null, this returns null.
 * @param {number} x The data x-coordinate.
 * @return {number} A fraction in [0, 1] where 0 = the left edge.
 */ $298304f644e9f727$var$Dygraph.prototype.toPercentXCoord = function(x) {
    if (x === null) return null;
    var xRange = this.xAxisRange();
    var pct;
    var logscale = this.attributes_.getForAxis("logscale", 'x');
    if (logscale === true) {
        // logscale can be null so we test for true explicitly.
        var logr0 = $298304f644e9f727$var$utils.log10(xRange[0]);
        var logr1 = $298304f644e9f727$var$utils.log10(xRange[1]);
        pct = ($298304f644e9f727$var$utils.log10(x) - logr0) / (logr1 - logr0);
    } else // x - xRange[0] is unit distance from the left.
    // xRange[1] - xRange[0] is the scale of the range.
    // The full expression below is the % from the left.
    pct = (x - xRange[0]) / (xRange[1] - xRange[0]);
    return pct;
};
/**
 * Returns the number of columns (including the independent variable).
 * @return {number} The number of columns.
 */ $298304f644e9f727$var$Dygraph.prototype.numColumns = function() {
    if (!this.rawData_) return 0;
    return this.rawData_[0] ? this.rawData_[0].length : this.attr_("labels").length;
};
/**
 * Returns the number of rows (excluding any header/label row).
 * @return {number} The number of rows, less any header.
 */ $298304f644e9f727$var$Dygraph.prototype.numRows = function() {
    if (!this.rawData_) return 0;
    return this.rawData_.length;
};
/**
 * Returns the value in the given row and column. If the row and column exceed
 * the bounds on the data, returns null. Also returns null if the value is
 * missing.
 * @param {number} row The row number of the data (0-based). Row 0 is the
 *     first row of data, not a header row.
 * @param {number} col The column number of the data (0-based)
 * @return {number} The value in the specified cell or null if the row/col
 *     were out of range.
 */ $298304f644e9f727$var$Dygraph.prototype.getValue = function(row, col) {
    if (row < 0 || row > this.rawData_.length) return null;
    if (col < 0 || col > this.rawData_[row].length) return null;
    return this.rawData_[row][col];
};
/**
 * Generates interface elements for the Dygraph: a containing div, a div to
 * display the current point, and a textbox to adjust the rolling average
 * period. Also creates the Renderer/Layout elements.
 * @private
 */ $298304f644e9f727$var$Dygraph.prototype.createInterface_ = function() {
    // Create the all-enclosing graph div
    var enclosing = this.maindiv_;
    this.graphDiv = document.createElement("div");
    // TODO(danvk): any other styles that are useful to set here?
    this.graphDiv.style.textAlign = 'left'; // This is a CSS "reset"
    this.graphDiv.style.position = 'relative';
    enclosing.appendChild(this.graphDiv);
    // Create the canvas for interactive parts of the chart.
    this.canvas_ = $298304f644e9f727$var$utils.createCanvas();
    this.canvas_.style.position = "absolute";
    // ... and for static parts of the chart.
    this.hidden_ = this.createPlotKitCanvas_(this.canvas_);
    this.canvas_ctx_ = $298304f644e9f727$var$utils.getContext(this.canvas_);
    this.hidden_ctx_ = $298304f644e9f727$var$utils.getContext(this.hidden_);
    this.resizeElements_();
    // The interactive parts of the graph are drawn on top of the chart.
    this.graphDiv.appendChild(this.hidden_);
    this.graphDiv.appendChild(this.canvas_);
    this.mouseEventElement_ = this.createMouseEventElement_();
    // Create the grapher
    this.layout_ = new $298304f644e9f727$var$_dygraphLayout2['default'](this);
    var dygraph = this;
    this.mouseMoveHandler_ = function(e) {
        dygraph.mouseMove_(e);
    };
    this.mouseOutHandler_ = function(e) {
        // The mouse has left the chart if:
        // 1. e.target is inside the chart
        // 2. e.relatedTarget is outside the chart
        var target = e.target || e.fromElement;
        var relatedTarget = e.relatedTarget || e.toElement;
        if ($298304f644e9f727$var$utils.isNodeContainedBy(target, dygraph.graphDiv) && !$298304f644e9f727$var$utils.isNodeContainedBy(relatedTarget, dygraph.graphDiv)) dygraph.mouseOut_(e);
    };
    this.addAndTrackEvent(window, 'mouseout', this.mouseOutHandler_);
    this.addAndTrackEvent(this.mouseEventElement_, 'mousemove', this.mouseMoveHandler_);
    // Don't recreate and register the resize handler on subsequent calls.
    // This happens when the graph is resized.
    if (!this.resizeHandler_) {
        this.resizeHandler_ = function(e) {
            dygraph.resize();
        };
        // Update when the window is resized.
        // TODO(danvk): drop frames depending on complexity of the chart.
        this.addAndTrackEvent(window, 'resize', this.resizeHandler_);
    }
};
$298304f644e9f727$var$Dygraph.prototype.resizeElements_ = function() {
    this.graphDiv.style.width = this.width_ + "px";
    this.graphDiv.style.height = this.height_ + "px";
    var pixelRatioOption = this.getNumericOption('pixelRatio');
    var canvasScale = pixelRatioOption || $298304f644e9f727$var$utils.getContextPixelRatio(this.canvas_ctx_);
    this.canvas_.width = this.width_ * canvasScale;
    this.canvas_.height = this.height_ * canvasScale;
    this.canvas_.style.width = this.width_ + "px"; // for IE
    this.canvas_.style.height = this.height_ + "px"; // for IE
    if (canvasScale !== 1) this.canvas_ctx_.scale(canvasScale, canvasScale);
    var hiddenScale = pixelRatioOption || $298304f644e9f727$var$utils.getContextPixelRatio(this.hidden_ctx_);
    this.hidden_.width = this.width_ * hiddenScale;
    this.hidden_.height = this.height_ * hiddenScale;
    this.hidden_.style.width = this.width_ + "px"; // for IE
    this.hidden_.style.height = this.height_ + "px"; // for IE
    if (hiddenScale !== 1) this.hidden_ctx_.scale(hiddenScale, hiddenScale);
};
/**
 * Detach DOM elements in the dygraph and null out all data references.
 * Calling this when you're done with a dygraph can dramatically reduce memory
 * usage. See, e.g., the tests/perf.html example.
 */ $298304f644e9f727$var$Dygraph.prototype.destroy = function() {
    this.canvas_ctx_.restore();
    this.hidden_ctx_.restore();
    // Destroy any plugins, in the reverse order that they were registered.
    for(var i = this.plugins_.length - 1; i >= 0; i--){
        var p = this.plugins_.pop();
        if (p.plugin.destroy) p.plugin.destroy();
    }
    var removeRecursive = function removeRecursive(node) {
        while(node.hasChildNodes()){
            removeRecursive(node.firstChild);
            node.removeChild(node.firstChild);
        }
    };
    this.removeTrackedEvents_();
    // remove mouse event handlers (This may not be necessary anymore)
    $298304f644e9f727$var$utils.removeEvent(window, 'mouseout', this.mouseOutHandler_);
    $298304f644e9f727$var$utils.removeEvent(this.mouseEventElement_, 'mousemove', this.mouseMoveHandler_);
    // remove window handlers
    $298304f644e9f727$var$utils.removeEvent(window, 'resize', this.resizeHandler_);
    this.resizeHandler_ = null;
    removeRecursive(this.maindiv_);
    var nullOut = function nullOut(obj) {
        for(var n in obj)if (typeof obj[n] === 'object') obj[n] = null;
    };
    // These may not all be necessary, but it can't hurt...
    nullOut(this.layout_);
    nullOut(this.plotter_);
    nullOut(this);
};
/**
 * Creates the canvas on which the chart will be drawn. Only the Renderer ever
 * draws on this particular canvas. All Dygraph work (i.e. drawing hover dots
 * or the zoom rectangles) is done on this.canvas_.
 * @param {Object} canvas The Dygraph canvas over which to overlay the plot
 * @return {Object} The newly-created canvas
 * @private
 */ $298304f644e9f727$var$Dygraph.prototype.createPlotKitCanvas_ = function(canvas) {
    var h = $298304f644e9f727$var$utils.createCanvas();
    h.style.position = "absolute";
    // TODO(danvk): h should be offset from canvas. canvas needs to include
    // some extra area to make it easier to zoom in on the far left and far
    // right. h needs to be precisely the plot area, so that clipping occurs.
    h.style.top = canvas.style.top;
    h.style.left = canvas.style.left;
    h.width = this.width_;
    h.height = this.height_;
    h.style.width = this.width_ + "px"; // for IE
    h.style.height = this.height_ + "px"; // for IE
    return h;
};
/**
 * Creates an overlay element used to handle mouse events.
 * @return {Object} The mouse event element.
 * @private
 */ $298304f644e9f727$var$Dygraph.prototype.createMouseEventElement_ = function() {
    return this.canvas_;
};
/**
 * Generate a set of distinct colors for the data series. This is done with a
 * color wheel. Saturation/Value are customizable, and the hue is
 * equally-spaced around the color wheel. If a custom set of colors is
 * specified, that is used instead.
 * @private
 */ $298304f644e9f727$var$Dygraph.prototype.setColors_ = function() {
    var labels = this.getLabels();
    var num = labels.length - 1;
    this.colors_ = [];
    this.colorsMap_ = {};
    // These are used for when no custom colors are specified.
    var sat = this.getNumericOption('colorSaturation') || 1.0;
    var val = this.getNumericOption('colorValue') || 0.5;
    var half = Math.ceil(num / 2);
    var colors = this.getOption('colors');
    var visibility = this.visibility();
    for(var i = 0; i < num; i++){
        if (!visibility[i]) continue;
        var label = labels[i + 1];
        var colorStr = this.attributes_.getForSeries('color', label);
        if (!colorStr) {
            if (colors) colorStr = colors[i % colors.length];
            else {
                // alternate colors for high contrast.
                var idx = i % 2 ? half + (i + 1) / 2 : Math.ceil((i + 1) / 2);
                var hue = 1.0 * idx / (1 + num);
                colorStr = $298304f644e9f727$var$utils.hsvToRGB(hue, sat, val);
            }
        }
        this.colors_.push(colorStr);
        this.colorsMap_[label] = colorStr;
    }
};
/**
 * Return the list of colors. This is either the list of colors passed in the
 * attributes or the autogenerated list of rgb(r,g,b) strings.
 * This does not return colors for invisible series.
 * @return {Array.<string>} The list of colors.
 */ $298304f644e9f727$var$Dygraph.prototype.getColors = function() {
    return this.colors_;
};
/**
 * Returns a few attributes of a series, i.e. its color, its visibility, which
 * axis it's assigned to, and its column in the original data.
 * Returns null if the series does not exist.
 * Otherwise, returns an object with column, visibility, color and axis properties.
 * The "axis" property will be set to 1 for y1 and 2 for y2.
 * The "column" property can be fed back into getValue(row, column) to get
 * values for this series.
 */ $298304f644e9f727$var$Dygraph.prototype.getPropertiesForSeries = function(series_name) {
    var idx = -1;
    var labels = this.getLabels();
    for(var i = 1; i < labels.length; i++)if (labels[i] == series_name) {
        idx = i;
        break;
    }
    if (idx == -1) return null;
    return {
        name: series_name,
        column: idx,
        visible: this.visibility()[idx - 1],
        color: this.colorsMap_[series_name],
        axis: 1 + this.attributes_.axisForSeries(series_name)
    };
};
/**
 * Create the text box to adjust the averaging period
 * @private
 */ $298304f644e9f727$var$Dygraph.prototype.createRollInterface_ = function() {
    var _this = this;
    // Create a roller if one doesn't exist already.
    var roller = this.roller_;
    if (!roller) {
        this.roller_ = roller = document.createElement("input");
        roller.type = "text";
        roller.style.display = "none";
        roller.className = 'dygraph-roller';
        this.graphDiv.appendChild(roller);
    }
    var display = this.getBooleanOption('showRoller') ? 'block' : 'none';
    var area = this.getArea();
    var textAttr = {
        "top": area.y + area.h - 25 + "px",
        "left": area.x + 1 + "px",
        "display": display
    };
    roller.size = "2";
    roller.value = this.rollPeriod_;
    $298304f644e9f727$var$utils.update(roller.style, textAttr);
    roller.onchange = function() {
        return _this.adjustRoll(roller.value);
    };
};
/**
 * Set up all the mouse handlers needed to capture dragging behavior for zoom
 * events.
 * @private
 */ $298304f644e9f727$var$Dygraph.prototype.createDragInterface_ = function() {
    var context = {
        // Tracks whether the mouse is down right now
        isZooming: false,
        isPanning: false,
        is2DPan: false,
        dragStartX: null,
        dragStartY: null,
        dragEndX: null,
        dragEndY: null,
        dragDirection: null,
        prevEndX: null,
        prevEndY: null,
        prevDragDirection: null,
        cancelNextDblclick: false,
        // The value on the left side of the graph when a pan operation starts.
        initialLeftmostDate: null,
        // The number of units each pixel spans. (This won't be valid for log
        // scales)
        xUnitsPerPixel: null,
        // TODO(danvk): update this comment
        // The range in second/value units that the viewport encompasses during a
        // panning operation.
        dateRange: null,
        // Top-left corner of the canvas, in DOM coords
        // TODO(konigsberg): Rename topLeftCanvasX, topLeftCanvasY.
        px: 0,
        py: 0,
        // Values for use with panEdgeFraction, which limit how far outside the
        // graph's data boundaries it can be panned.
        boundedDates: null,
        boundedValues: null,
        // We cover iframes during mouse interactions. See comments in
        // dygraph-utils.js for more info on why this is a good idea.
        tarp: new $298304f644e9f727$var$_iframeTarp2['default'](),
        // contextB is the same thing as this context object but renamed.
        initializeMouseDown: function initializeMouseDown(event, g, contextB) {
            // prevents mouse drags from selecting page text.
            if (event.preventDefault) event.preventDefault(); // Firefox, Chrome, etc.
            else {
                event.returnValue = false; // IE
                event.cancelBubble = true;
            }
            var canvasPos = $298304f644e9f727$var$utils.findPos(g.canvas_);
            contextB.px = canvasPos.x;
            contextB.py = canvasPos.y;
            contextB.dragStartX = $298304f644e9f727$var$utils.dragGetX_(event, contextB);
            contextB.dragStartY = $298304f644e9f727$var$utils.dragGetY_(event, contextB);
            contextB.cancelNextDblclick = false;
            contextB.tarp.cover();
        },
        destroy: function destroy() {
            var context = this;
            if (context.isZooming || context.isPanning) {
                context.isZooming = false;
                context.dragStartX = null;
                context.dragStartY = null;
            }
            if (context.isPanning) {
                context.isPanning = false;
                context.draggingDate = null;
                context.dateRange = null;
                for(var i = 0; i < self.axes_.length; i++){
                    delete self.axes_[i].draggingValue;
                    delete self.axes_[i].dragValueRange;
                }
            }
            context.tarp.uncover();
        }
    };
    var interactionModel = this.getOption("interactionModel");
    // Self is the graph.
    var self = this;
    // Function that binds the graph and context to the handler.
    var bindHandler = function bindHandler(handler) {
        return function(event) {
            handler(event, self, context);
        };
    };
    for(var eventName in interactionModel){
        if (!interactionModel.hasOwnProperty(eventName)) continue;
        this.addAndTrackEvent(this.mouseEventElement_, eventName, bindHandler(interactionModel[eventName]));
    }
    // If the user releases the mouse button during a drag, but not over the
    // canvas, then it doesn't count as a zooming action.
    if (!interactionModel.willDestroyContextMyself) {
        var mouseUpHandler = function mouseUpHandler(event) {
            context.destroy();
        };
        this.addAndTrackEvent(document, 'mouseup', mouseUpHandler);
    }
};
/**
 * Draw a gray zoom rectangle over the desired area of the canvas. Also clears
 * up any previous zoom rectangles that were drawn. This could be optimized to
 * avoid extra redrawing, but it's tricky to avoid interactions with the status
 * dots.
 *
 * @param {number} direction the direction of the zoom rectangle. Acceptable
 *     values are utils.HORIZONTAL and utils.VERTICAL.
 * @param {number} startX The X position where the drag started, in canvas
 *     coordinates.
 * @param {number} endX The current X position of the drag, in canvas coords.
 * @param {number} startY The Y position where the drag started, in canvas
 *     coordinates.
 * @param {number} endY The current Y position of the drag, in canvas coords.
 * @param {number} prevDirection the value of direction on the previous call to
 *     this function. Used to avoid excess redrawing
 * @param {number} prevEndX The value of endX on the previous call to this
 *     function. Used to avoid excess redrawing
 * @param {number} prevEndY The value of endY on the previous call to this
 *     function. Used to avoid excess redrawing
 * @private
 */ $298304f644e9f727$var$Dygraph.prototype.drawZoomRect_ = function(direction, startX, endX, startY, endY, prevDirection, prevEndX, prevEndY) {
    var ctx = this.canvas_ctx_;
    // Clean up from the previous rect if necessary
    if (prevDirection == $298304f644e9f727$var$utils.HORIZONTAL) ctx.clearRect(Math.min(startX, prevEndX), this.layout_.getPlotArea().y, Math.abs(startX - prevEndX), this.layout_.getPlotArea().h);
    else if (prevDirection == $298304f644e9f727$var$utils.VERTICAL) ctx.clearRect(this.layout_.getPlotArea().x, Math.min(startY, prevEndY), this.layout_.getPlotArea().w, Math.abs(startY - prevEndY));
    // Draw a light-grey rectangle to show the new viewing area
    if (direction == $298304f644e9f727$var$utils.HORIZONTAL) {
        if (endX && startX) {
            ctx.fillStyle = "rgba(128,128,128,0.33)";
            ctx.fillRect(Math.min(startX, endX), this.layout_.getPlotArea().y, Math.abs(endX - startX), this.layout_.getPlotArea().h);
        }
    } else if (direction == $298304f644e9f727$var$utils.VERTICAL) {
        if (endY && startY) {
            ctx.fillStyle = "rgba(128,128,128,0.33)";
            ctx.fillRect(this.layout_.getPlotArea().x, Math.min(startY, endY), this.layout_.getPlotArea().w, Math.abs(endY - startY));
        }
    }
};
/**
 * Clear the zoom rectangle (and perform no zoom).
 * @private
 */ $298304f644e9f727$var$Dygraph.prototype.clearZoomRect_ = function() {
    this.currentZoomRectArgs_ = null;
    this.canvas_ctx_.clearRect(0, 0, this.width_, this.height_);
};
/**
 * Zoom to something containing [lowX, highX]. These are pixel coordinates in
 * the canvas. The exact zoom window may be slightly larger if there are no data
 * points near lowX or highX. Don't confuse this function with doZoomXDates,
 * which accepts dates that match the raw data. This function redraws the graph.
 *
 * @param {number} lowX The leftmost pixel value that should be visible.
 * @param {number} highX The rightmost pixel value that should be visible.
 * @private
 */ $298304f644e9f727$var$Dygraph.prototype.doZoomX_ = function(lowX, highX) {
    this.currentZoomRectArgs_ = null;
    // Find the earliest and latest dates contained in this canvasx range.
    // Convert the call to date ranges of the raw data.
    var minDate = this.toDataXCoord(lowX);
    var maxDate = this.toDataXCoord(highX);
    this.doZoomXDates_(minDate, maxDate);
};
/**
 * Zoom to something containing [minDate, maxDate] values. Don't confuse this
 * method with doZoomX which accepts pixel coordinates. This function redraws
 * the graph.
 *
 * @param {number} minDate The minimum date that should be visible.
 * @param {number} maxDate The maximum date that should be visible.
 * @private
 */ $298304f644e9f727$var$Dygraph.prototype.doZoomXDates_ = function(minDate, maxDate) {
    var _this2 = this;
    // TODO(danvk): when xAxisRange is null (i.e. "fit to data", the animation
    // can produce strange effects. Rather than the x-axis transitioning slowly
    // between values, it can jerk around.)
    var old_window = this.xAxisRange();
    var new_window = [
        minDate,
        maxDate
    ];
    var zoomCallback = this.getFunctionOption('zoomCallback');
    this.doAnimatedZoom(old_window, new_window, null, null, function() {
        if (zoomCallback) zoomCallback.call(_this2, minDate, maxDate, _this2.yAxisRanges());
    });
};
/**
 * Zoom to something containing [lowY, highY]. These are pixel coordinates in
 * the canvas. This function redraws the graph.
 *
 * @param {number} lowY The topmost pixel value that should be visible.
 * @param {number} highY The lowest pixel value that should be visible.
 * @private
 */ $298304f644e9f727$var$Dygraph.prototype.doZoomY_ = function(lowY, highY) {
    var _this3 = this;
    this.currentZoomRectArgs_ = null;
    // Find the highest and lowest values in pixel range for each axis.
    // Note that lowY (in pixels) corresponds to the max Value (in data coords).
    // This is because pixels increase as you go down on the screen, whereas data
    // coordinates increase as you go up the screen.
    var oldValueRanges = this.yAxisRanges();
    var newValueRanges = [];
    for(var i = 0; i < this.axes_.length; i++){
        var hi = this.toDataYCoord(lowY, i);
        var low = this.toDataYCoord(highY, i);
        newValueRanges.push([
            low,
            hi
        ]);
    }
    var zoomCallback = this.getFunctionOption('zoomCallback');
    this.doAnimatedZoom(null, null, oldValueRanges, newValueRanges, function() {
        if (zoomCallback) {
            var _xAxisRange = _this3.xAxisRange();
            var _xAxisRange2 = $298304f644e9f727$var$_slicedToArray(_xAxisRange, 2);
            var minX = _xAxisRange2[0];
            var maxX = _xAxisRange2[1];
            zoomCallback.call(_this3, minX, maxX, _this3.yAxisRanges());
        }
    });
};
/**
 * Transition function to use in animations. Returns values between 0.0
 * (totally old values) and 1.0 (totally new values) for each frame.
 * @private
 */ $298304f644e9f727$var$Dygraph.zoomAnimationFunction = function(frame, numFrames) {
    var k = 1.5;
    return (1.0 - Math.pow(k, -frame)) / (1.0 - Math.pow(k, -numFrames));
};
/**
 * Reset the zoom to the original view coordinates. This is the same as
 * double-clicking on the graph.
 */ $298304f644e9f727$var$Dygraph.prototype.resetZoom = function() {
    var _this4 = this;
    var dirtyX = this.isZoomed('x');
    var dirtyY = this.isZoomed('y');
    var dirty = dirtyX || dirtyY;
    // Clear any selection, since it's likely to be drawn in the wrong place.
    this.clearSelection();
    if (!dirty) return;
    // Calculate extremes to avoid lack of padding on reset.
    var _xAxisExtremes = this.xAxisExtremes();
    var _xAxisExtremes2 = $298304f644e9f727$var$_slicedToArray(_xAxisExtremes, 2);
    var minDate = _xAxisExtremes2[0];
    var maxDate = _xAxisExtremes2[1];
    var animatedZooms = this.getBooleanOption('animatedZooms');
    var zoomCallback = this.getFunctionOption('zoomCallback');
    // TODO(danvk): merge this block w/ the code below.
    // TODO(danvk): factor out a generic, public zoomTo method.
    if (!animatedZooms) {
        this.dateWindow_ = null;
        this.axes_.forEach(function(axis) {
            if (axis.valueRange) delete axis.valueRange;
        });
        this.drawGraph_();
        if (zoomCallback) zoomCallback.call(this, minDate, maxDate, this.yAxisRanges());
        return;
    }
    var oldWindow = null, newWindow = null, oldValueRanges = null, newValueRanges = null;
    if (dirtyX) {
        oldWindow = this.xAxisRange();
        newWindow = [
            minDate,
            maxDate
        ];
    }
    if (dirtyY) {
        oldValueRanges = this.yAxisRanges();
        newValueRanges = this.yAxisExtremes();
    }
    this.doAnimatedZoom(oldWindow, newWindow, oldValueRanges, newValueRanges, function() {
        _this4.dateWindow_ = null;
        _this4.axes_.forEach(function(axis) {
            if (axis.valueRange) delete axis.valueRange;
        });
        if (zoomCallback) zoomCallback.call(_this4, minDate, maxDate, _this4.yAxisRanges());
    });
};
/**
 * Combined animation logic for all zoom functions.
 * either the x parameters or y parameters may be null.
 * @private
 */ $298304f644e9f727$var$Dygraph.prototype.doAnimatedZoom = function(oldXRange, newXRange, oldYRanges, newYRanges, callback) {
    var _this5 = this;
    var steps = this.getBooleanOption("animatedZooms") ? $298304f644e9f727$var$Dygraph.ANIMATION_STEPS : 1;
    var windows = [];
    var valueRanges = [];
    var step, frac;
    if (oldXRange !== null && newXRange !== null) for(step = 1; step <= steps; step++){
        frac = $298304f644e9f727$var$Dygraph.zoomAnimationFunction(step, steps);
        windows[step - 1] = [
            oldXRange[0] * (1 - frac) + frac * newXRange[0],
            oldXRange[1] * (1 - frac) + frac * newXRange[1]
        ];
    }
    if (oldYRanges !== null && newYRanges !== null) for(step = 1; step <= steps; step++){
        frac = $298304f644e9f727$var$Dygraph.zoomAnimationFunction(step, steps);
        var thisRange = [];
        for(var j = 0; j < this.axes_.length; j++)thisRange.push([
            oldYRanges[j][0] * (1 - frac) + frac * newYRanges[j][0],
            oldYRanges[j][1] * (1 - frac) + frac * newYRanges[j][1]
        ]);
        valueRanges[step - 1] = thisRange;
    }
    $298304f644e9f727$var$utils.repeatAndCleanup(function(step) {
        if (valueRanges.length) for(var i = 0; i < _this5.axes_.length; i++){
            var w = valueRanges[step][i];
            _this5.axes_[i].valueRange = [
                w[0],
                w[1]
            ];
        }
        if (windows.length) _this5.dateWindow_ = windows[step];
        _this5.drawGraph_();
    }, steps, $298304f644e9f727$var$Dygraph.ANIMATION_DURATION / steps, callback);
};
/**
 * Get the current graph's area object.
 *
 * Returns: {x, y, w, h}
 */ $298304f644e9f727$var$Dygraph.prototype.getArea = function() {
    return this.plotter_.area;
};
/**
 * Convert a mouse event to DOM coordinates relative to the graph origin.
 *
 * Returns a two-element array: [X, Y].
 */ $298304f644e9f727$var$Dygraph.prototype.eventToDomCoords = function(event) {
    if (event.offsetX && event.offsetY) return [
        event.offsetX,
        event.offsetY
    ];
    else {
        var eventElementPos = $298304f644e9f727$var$utils.findPos(this.mouseEventElement_);
        var canvasx = $298304f644e9f727$var$utils.pageX(event) - eventElementPos.x;
        var canvasy = $298304f644e9f727$var$utils.pageY(event) - eventElementPos.y;
        return [
            canvasx,
            canvasy
        ];
    }
};
/**
 * Given a canvas X coordinate, find the closest row.
 * @param {number} domX graph-relative DOM X coordinate
 * Returns {number} row number.
 * @private
 */ $298304f644e9f727$var$Dygraph.prototype.findClosestRow = function(domX) {
    var minDistX = Infinity;
    var closestRow = -1;
    var sets = this.layout_.points;
    for(var i = 0; i < sets.length; i++){
        var points = sets[i];
        var len = points.length;
        for(var j = 0; j < len; j++){
            var point = points[j];
            if (!$298304f644e9f727$var$utils.isValidPoint(point, true)) continue;
            var dist = Math.abs(point.canvasx - domX);
            if (dist < minDistX) {
                minDistX = dist;
                closestRow = point.idx;
            }
        }
    }
    return closestRow;
};
/**
 * Given canvas X,Y coordinates, find the closest point.
 *
 * This finds the individual data point across all visible series
 * that's closest to the supplied DOM coordinates using the standard
 * Euclidean X,Y distance.
 *
 * @param {number} domX graph-relative DOM X coordinate
 * @param {number} domY graph-relative DOM Y coordinate
 * Returns: {row, seriesName, point}
 * @private
 */ $298304f644e9f727$var$Dygraph.prototype.findClosestPoint = function(domX, domY) {
    var minDist = Infinity;
    var dist, dx, dy, point, closestPoint, closestSeries, closestRow;
    for(var setIdx = this.layout_.points.length - 1; setIdx >= 0; --setIdx){
        var points = this.layout_.points[setIdx];
        for(var i = 0; i < points.length; ++i){
            point = points[i];
            if (!$298304f644e9f727$var$utils.isValidPoint(point)) continue;
            dx = point.canvasx - domX;
            dy = point.canvasy - domY;
            dist = dx * dx + dy * dy;
            if (dist < minDist) {
                minDist = dist;
                closestPoint = point;
                closestSeries = setIdx;
                closestRow = point.idx;
            }
        }
    }
    var name = this.layout_.setNames[closestSeries];
    return {
        row: closestRow,
        seriesName: name,
        point: closestPoint
    };
};
/**
 * Given canvas X,Y coordinates, find the touched area in a stacked graph.
 *
 * This first finds the X data point closest to the supplied DOM X coordinate,
 * then finds the series which puts the Y coordinate on top of its filled area,
 * using linear interpolation between adjacent point pairs.
 *
 * @param {number} domX graph-relative DOM X coordinate
 * @param {number} domY graph-relative DOM Y coordinate
 * Returns: {row, seriesName, point}
 * @private
 */ $298304f644e9f727$var$Dygraph.prototype.findStackedPoint = function(domX, domY) {
    var row = this.findClosestRow(domX);
    var closestPoint, closestSeries;
    for(var setIdx = 0; setIdx < this.layout_.points.length; ++setIdx){
        var boundary = this.getLeftBoundary_(setIdx);
        var rowIdx = row - boundary;
        var points = this.layout_.points[setIdx];
        if (rowIdx >= points.length) continue;
        var p1 = points[rowIdx];
        if (!$298304f644e9f727$var$utils.isValidPoint(p1)) continue;
        var py = p1.canvasy;
        if (domX > p1.canvasx && rowIdx + 1 < points.length) {
            // interpolate series Y value using next point
            var p2 = points[rowIdx + 1];
            if ($298304f644e9f727$var$utils.isValidPoint(p2)) {
                var dx = p2.canvasx - p1.canvasx;
                if (dx > 0) {
                    var r = (domX - p1.canvasx) / dx;
                    py += r * (p2.canvasy - p1.canvasy);
                }
            }
        } else if (domX < p1.canvasx && rowIdx > 0) {
            // interpolate series Y value using previous point
            var p0 = points[rowIdx - 1];
            if ($298304f644e9f727$var$utils.isValidPoint(p0)) {
                var dx = p1.canvasx - p0.canvasx;
                if (dx > 0) {
                    var r = (p1.canvasx - domX) / dx;
                    py += r * (p0.canvasy - p1.canvasy);
                }
            }
        }
        // Stop if the point (domX, py) is above this series' upper edge
        if (setIdx === 0 || py < domY) {
            closestPoint = p1;
            closestSeries = setIdx;
        }
    }
    var name = this.layout_.setNames[closestSeries];
    return {
        row: row,
        seriesName: name,
        point: closestPoint
    };
};
/**
 * When the mouse moves in the canvas, display information about a nearby data
 * point and draw dots over those points in the data series. This function
 * takes care of cleanup of previously-drawn dots.
 * @param {Object} event The mousemove event from the browser.
 * @private
 */ $298304f644e9f727$var$Dygraph.prototype.mouseMove_ = function(event) {
    // This prevents JS errors when mousing over the canvas before data loads.
    var points = this.layout_.points;
    if (points === undefined || points === null) return;
    var canvasCoords = this.eventToDomCoords(event);
    var canvasx = canvasCoords[0];
    var canvasy = canvasCoords[1];
    var highlightSeriesOpts = this.getOption("highlightSeriesOpts");
    var selectionChanged = false;
    if (highlightSeriesOpts && !this.isSeriesLocked()) {
        var closest;
        if (this.getBooleanOption("stackedGraph")) closest = this.findStackedPoint(canvasx, canvasy);
        else closest = this.findClosestPoint(canvasx, canvasy);
        selectionChanged = this.setSelection(closest.row, closest.seriesName);
    } else {
        var idx = this.findClosestRow(canvasx);
        selectionChanged = this.setSelection(idx);
    }
    var callback = this.getFunctionOption("highlightCallback");
    if (callback && selectionChanged) callback.call(this, event, this.lastx_, this.selPoints_, this.lastRow_, this.highlightSet_);
};
/**
 * Fetch left offset from the specified set index or if not passed, the
 * first defined boundaryIds record (see bug #236).
 * @private
 */ $298304f644e9f727$var$Dygraph.prototype.getLeftBoundary_ = function(setIdx) {
    if (this.boundaryIds_[setIdx]) return this.boundaryIds_[setIdx][0];
    else {
        for(var i = 0; i < this.boundaryIds_.length; i++){
            if (this.boundaryIds_[i] !== undefined) return this.boundaryIds_[i][0];
        }
        return 0;
    }
};
$298304f644e9f727$var$Dygraph.prototype.animateSelection_ = function(direction) {
    var totalSteps = 10;
    var millis = 30;
    if (this.fadeLevel === undefined) this.fadeLevel = 0;
    if (this.animateId === undefined) this.animateId = 0;
    var start = this.fadeLevel;
    var steps = direction < 0 ? start : totalSteps - start;
    if (steps <= 0) {
        if (this.fadeLevel) this.updateSelection_(1.0);
        return;
    }
    var thisId = ++this.animateId;
    var that = this;
    var cleanupIfClearing = function cleanupIfClearing() {
        // if we haven't reached fadeLevel 0 in the max frame time,
        // ensure that the clear happens and just go to 0
        if (that.fadeLevel !== 0 && direction < 0) {
            that.fadeLevel = 0;
            that.clearSelection();
        }
    };
    $298304f644e9f727$var$utils.repeatAndCleanup(function(n) {
        // ignore simultaneous animations
        if (that.animateId != thisId) return;
        that.fadeLevel += direction;
        if (that.fadeLevel === 0) that.clearSelection();
        else that.updateSelection_(that.fadeLevel / totalSteps);
    }, steps, millis, cleanupIfClearing);
};
/**
 * Draw dots over the selectied points in the data series. This function
 * takes care of cleanup of previously-drawn dots.
 * @private
 */ $298304f644e9f727$var$Dygraph.prototype.updateSelection_ = function(opt_animFraction) {
    /*var defaultPrevented = */ this.cascadeEvents_('select', {
        selectedRow: this.lastRow_ === -1 ? undefined : this.lastRow_,
        selectedX: this.lastx_ === -1 ? undefined : this.lastx_,
        selectedPoints: this.selPoints_
    });
    // TODO(danvk): use defaultPrevented here?
    // Clear the previously drawn vertical, if there is one
    var i;
    var ctx = this.canvas_ctx_;
    if (this.getOption('highlightSeriesOpts')) {
        ctx.clearRect(0, 0, this.width_, this.height_);
        var alpha = 1.0 - this.getNumericOption('highlightSeriesBackgroundAlpha');
        var backgroundColor = $298304f644e9f727$var$utils.toRGB_(this.getOption('highlightSeriesBackgroundColor'));
        if (alpha) {
            // Activating background fade includes an animation effect for a gradual
            // fade. TODO(klausw): make this independently configurable if it causes
            // issues? Use a shared preference to control animations?
            var animateBackgroundFade = true;
            if (animateBackgroundFade) {
                if (opt_animFraction === undefined) {
                    // start a new animation
                    this.animateSelection_(1);
                    return;
                }
                alpha *= opt_animFraction;
            }
            ctx.fillStyle = 'rgba(' + backgroundColor.r + ',' + backgroundColor.g + ',' + backgroundColor.b + ',' + alpha + ')';
            ctx.fillRect(0, 0, this.width_, this.height_);
        }
        // Redraw only the highlighted series in the interactive canvas (not the
        // static plot canvas, which is where series are usually drawn).
        this.plotter_._renderLineChart(this.highlightSet_, ctx);
    } else if (this.previousVerticalX_ >= 0) {
        // Determine the maximum highlight circle size.
        var maxCircleSize = 0;
        var labels = this.attr_('labels');
        for(i = 1; i < labels.length; i++){
            var r = this.getNumericOption('highlightCircleSize', labels[i]);
            if (r > maxCircleSize) maxCircleSize = r;
        }
        var px = this.previousVerticalX_;
        ctx.clearRect(px - maxCircleSize - 1, 0, 2 * maxCircleSize + 2, this.height_);
    }
    if (this.selPoints_.length > 0) {
        // Draw colored circles over the center of each selected point
        var canvasx = this.selPoints_[0].canvasx;
        ctx.save();
        for(i = 0; i < this.selPoints_.length; i++){
            var pt = this.selPoints_[i];
            if (isNaN(pt.canvasy)) continue;
            var circleSize = this.getNumericOption('highlightCircleSize', pt.name);
            var callback = this.getFunctionOption("drawHighlightPointCallback", pt.name);
            var color = this.plotter_.colors[pt.name];
            if (!callback) callback = $298304f644e9f727$var$utils.Circles.DEFAULT;
            ctx.lineWidth = this.getNumericOption('strokeWidth', pt.name);
            ctx.strokeStyle = color;
            ctx.fillStyle = color;
            callback.call(this, this, pt.name, ctx, canvasx, pt.canvasy, color, circleSize, pt.idx);
        }
        ctx.restore();
        this.previousVerticalX_ = canvasx;
    }
};
/**
 * Manually set the selected points and display information about them in the
 * legend. The selection can be cleared using clearSelection() and queried
 * using getSelection().
 *
 * To set a selected series but not a selected point, call setSelection with
 * row=false and the selected series name.
 *
 * @param {number} row Row number that should be highlighted (i.e. appear with
 * hover dots on the chart).
 * @param {seriesName} optional series name to highlight that series with the
 * the highlightSeriesOpts setting.
 * @param { locked } optional If true, keep seriesName selected when mousing
 * over the graph, disabling closest-series highlighting. Call clearSelection()
 * to unlock it.
 */ $298304f644e9f727$var$Dygraph.prototype.setSelection = function(row, opt_seriesName, opt_locked) {
    // Extract the points we've selected
    this.selPoints_ = [];
    var changed = false;
    if (row !== false && row >= 0) {
        if (row != this.lastRow_) changed = true;
        this.lastRow_ = row;
        for(var setIdx = 0; setIdx < this.layout_.points.length; ++setIdx){
            var points = this.layout_.points[setIdx];
            // Check if the point at the appropriate index is the point we're looking
            // for.  If it is, just use it, otherwise search the array for a point
            // in the proper place.
            var setRow = row - this.getLeftBoundary_(setIdx);
            if (setRow >= 0 && setRow < points.length && points[setRow].idx == row) {
                var point = points[setRow];
                if (point.yval !== null) this.selPoints_.push(point);
            } else for(var pointIdx = 0; pointIdx < points.length; ++pointIdx){
                var point = points[pointIdx];
                if (point.idx == row) {
                    if (point.yval !== null) this.selPoints_.push(point);
                    break;
                }
            }
        }
    } else {
        if (this.lastRow_ >= 0) changed = true;
        this.lastRow_ = -1;
    }
    if (this.selPoints_.length) this.lastx_ = this.selPoints_[0].xval;
    else this.lastx_ = -1;
    if (opt_seriesName !== undefined) {
        if (this.highlightSet_ !== opt_seriesName) changed = true;
        this.highlightSet_ = opt_seriesName;
    }
    if (opt_locked !== undefined) this.lockedSet_ = opt_locked;
    if (changed) this.updateSelection_(undefined);
    return changed;
};
/**
 * The mouse has left the canvas. Clear out whatever artifacts remain
 * @param {Object} event the mouseout event from the browser.
 * @private
 */ $298304f644e9f727$var$Dygraph.prototype.mouseOut_ = function(event) {
    if (this.getFunctionOption("unhighlightCallback")) this.getFunctionOption("unhighlightCallback").call(this, event);
    if (this.getBooleanOption("hideOverlayOnMouseOut") && !this.lockedSet_) this.clearSelection();
};
/**
 * Clears the current selection (i.e. points that were highlighted by moving
 * the mouse over the chart).
 */ $298304f644e9f727$var$Dygraph.prototype.clearSelection = function() {
    this.cascadeEvents_('deselect', {});
    this.lockedSet_ = false;
    // Get rid of the overlay data
    if (this.fadeLevel) {
        this.animateSelection_(-1);
        return;
    }
    this.canvas_ctx_.clearRect(0, 0, this.width_, this.height_);
    this.fadeLevel = 0;
    this.selPoints_ = [];
    this.lastx_ = -1;
    this.lastRow_ = -1;
    this.highlightSet_ = null;
};
/**
 * Returns the number of the currently selected row. To get data for this row,
 * you can use the getValue method.
 * @return {number} row number, or -1 if nothing is selected
 */ $298304f644e9f727$var$Dygraph.prototype.getSelection = function() {
    if (!this.selPoints_ || this.selPoints_.length < 1) return -1;
    for(var setIdx = 0; setIdx < this.layout_.points.length; setIdx++){
        var points = this.layout_.points[setIdx];
        for(var row = 0; row < points.length; row++){
            if (points[row].x == this.selPoints_[0].x) return points[row].idx;
        }
    }
    return -1;
};
/**
 * Returns the name of the currently-highlighted series.
 * Only available when the highlightSeriesOpts option is in use.
 */ $298304f644e9f727$var$Dygraph.prototype.getHighlightSeries = function() {
    return this.highlightSet_;
};
/**
 * Returns true if the currently-highlighted series was locked
 * via setSelection(..., seriesName, true).
 */ $298304f644e9f727$var$Dygraph.prototype.isSeriesLocked = function() {
    return this.lockedSet_;
};
/**
 * Fires when there's data available to be graphed.
 * @param {string} data Raw CSV data to be plotted
 * @private
 */ $298304f644e9f727$var$Dygraph.prototype.loadedEvent_ = function(data) {
    this.rawData_ = this.parseCSV_(data);
    this.cascadeDataDidUpdateEvent_();
    this.predraw_();
};
/**
 * Add ticks on the x-axis representing years, months, quarters, weeks, or days
 * @private
 */ $298304f644e9f727$var$Dygraph.prototype.addXTicks_ = function() {
    // Determine the correct ticks scale on the x-axis: quarterly, monthly, ...
    var range;
    if (this.dateWindow_) range = [
        this.dateWindow_[0],
        this.dateWindow_[1]
    ];
    else range = this.xAxisExtremes();
    var xAxisOptionsView = this.optionsViewForAxis_('x');
    var xTicks = xAxisOptionsView('ticker')(range[0], range[1], this.plotter_.area.w, xAxisOptionsView, this);
    // var msg = 'ticker(' + range[0] + ', ' + range[1] + ', ' + this.width_ + ', ' + this.attr_('pixelsPerXLabel') + ') -> ' + JSON.stringify(xTicks);
    // console.log(msg);
    this.layout_.setXTicks(xTicks);
};
/**
 * Returns the correct handler class for the currently set options.
 * @private
 */ $298304f644e9f727$var$Dygraph.prototype.getHandlerClass_ = function() {
    var handlerClass;
    if (this.attr_('dataHandler')) handlerClass = this.attr_('dataHandler');
    else if (this.fractions_) {
        if (this.getBooleanOption('errorBars')) handlerClass = $298304f644e9f727$var$_datahandlerBarsFractions2['default'];
        else handlerClass = $298304f644e9f727$var$_datahandlerDefaultFractions2['default'];
    } else if (this.getBooleanOption('customBars')) handlerClass = $298304f644e9f727$var$_datahandlerBarsCustom2['default'];
    else if (this.getBooleanOption('errorBars')) handlerClass = $298304f644e9f727$var$_datahandlerBarsError2['default'];
    else handlerClass = $298304f644e9f727$var$_datahandlerDefault2['default'];
    return handlerClass;
};
/**
 * @private
 * This function is called once when the chart's data is changed or the options
 * dictionary is updated. It is _not_ called when the user pans or zooms. The
 * idea is that values derived from the chart's data can be computed here,
 * rather than every time the chart is drawn. This includes things like the
 * number of axes, rolling averages, etc.
 */ $298304f644e9f727$var$Dygraph.prototype.predraw_ = function() {
    var start = new Date();
    // Create the correct dataHandler
    this.dataHandler_ = new (this.getHandlerClass_())();
    this.layout_.computePlotArea();
    // TODO(danvk): move more computations out of drawGraph_ and into here.
    this.computeYAxes_();
    if (!this.is_initial_draw_) {
        this.canvas_ctx_.restore();
        this.hidden_ctx_.restore();
    }
    this.canvas_ctx_.save();
    this.hidden_ctx_.save();
    // Create a new plotter.
    this.plotter_ = new $298304f644e9f727$var$_dygraphCanvas2['default'](this, this.hidden_, this.hidden_ctx_, this.layout_);
    // The roller sits in the bottom left corner of the chart. We don't know where
    // this will be until the options are available, so it's positioned here.
    this.createRollInterface_();
    this.cascadeEvents_('predraw');
    // Convert the raw data (a 2D array) into the internal format and compute
    // rolling averages.
    this.rolledSeries_ = [
        null
    ]; // x-axis is the first series and it's special
    for(var i = 1; i < this.numColumns(); i++){
        // var logScale = this.attr_('logscale', i); // TODO(klausw): this looks wrong // konigsberg thinks so too.
        var series = this.dataHandler_.extractSeries(this.rawData_, i, this.attributes_);
        if (this.rollPeriod_ > 1) series = this.dataHandler_.rollingAverage(series, this.rollPeriod_, this.attributes_);
        this.rolledSeries_.push(series);
    }
    // If the data or options have changed, then we'd better redraw.
    this.drawGraph_();
    // This is used to determine whether to do various animations.
    var end = new Date();
    this.drawingTimeMs_ = end - start;
};
/**
 * Point structure.
 *
 * xval_* and yval_* are the original unscaled data values,
 * while x_* and y_* are scaled to the range (0.0-1.0) for plotting.
 * yval_stacked is the cumulative Y value used for stacking graphs,
 * and bottom/top/minus/plus are used for error bar graphs.
 *
 * @typedef {{
 *     idx: number,
 *     name: string,
 *     x: ?number,
 *     xval: ?number,
 *     y_bottom: ?number,
 *     y: ?number,
 *     y_stacked: ?number,
 *     y_top: ?number,
 *     yval_minus: ?number,
 *     yval: ?number,
 *     yval_plus: ?number,
 *     yval_stacked
 * }}
 */ $298304f644e9f727$var$Dygraph.PointType = undefined;
/**
 * Calculates point stacking for stackedGraph=true.
 *
 * For stacking purposes, interpolate or extend neighboring data across
 * NaN values based on stackedGraphNaNFill settings. This is for display
 * only, the underlying data value as shown in the legend remains NaN.
 *
 * @param {Array.<Dygraph.PointType>} points Point array for a single series.
 *     Updates each Point's yval_stacked property.
 * @param {Array.<number>} cumulativeYval Accumulated top-of-graph stacked Y
 *     values for the series seen so far. Index is the row number. Updated
 *     based on the current series's values.
 * @param {Array.<number>} seriesExtremes Min and max values, updated
 *     to reflect the stacked values.
 * @param {string} fillMethod Interpolation method, one of 'all', 'inside', or
 *     'none'.
 * @private
 */ $298304f644e9f727$var$Dygraph.stackPoints_ = function(points, cumulativeYval, seriesExtremes, fillMethod) {
    var lastXval = null;
    var prevPoint = null;
    var nextPoint = null;
    var nextPointIdx = -1;
    // Find the next stackable point starting from the given index.
    var updateNextPoint = function updateNextPoint(idx) {
        // If we've previously found a non-NaN point and haven't gone past it yet,
        // just use that.
        if (nextPointIdx >= idx) return;
        // We haven't found a non-NaN point yet or have moved past it,
        // look towards the right to find a non-NaN point.
        for(var j = idx; j < points.length; ++j){
            // Clear out a previously-found point (if any) since it's no longer
            // valid, we shouldn't use it for interpolation anymore.
            nextPoint = null;
            if (!isNaN(points[j].yval) && points[j].yval !== null) {
                nextPointIdx = j;
                nextPoint = points[j];
                break;
            }
        }
    };
    for(var i = 0; i < points.length; ++i){
        var point = points[i];
        var xval = point.xval;
        if (cumulativeYval[xval] === undefined) cumulativeYval[xval] = 0;
        var actualYval = point.yval;
        if (isNaN(actualYval) || actualYval === null) {
            if (fillMethod == 'none') actualYval = 0;
            else {
                // Interpolate/extend for stacking purposes if possible.
                updateNextPoint(i);
                if (prevPoint && nextPoint && fillMethod != 'none') // Use linear interpolation between prevPoint and nextPoint.
                actualYval = prevPoint.yval + (nextPoint.yval - prevPoint.yval) * ((xval - prevPoint.xval) / (nextPoint.xval - prevPoint.xval));
                else if (prevPoint && fillMethod == 'all') actualYval = prevPoint.yval;
                else if (nextPoint && fillMethod == 'all') actualYval = nextPoint.yval;
                else actualYval = 0;
            }
        } else prevPoint = point;
        var stackedYval = cumulativeYval[xval];
        if (lastXval != xval) {
            // If an x-value is repeated, we ignore the duplicates.
            stackedYval += actualYval;
            cumulativeYval[xval] = stackedYval;
        }
        lastXval = xval;
        point.yval_stacked = stackedYval;
        if (stackedYval > seriesExtremes[1]) seriesExtremes[1] = stackedYval;
        if (stackedYval < seriesExtremes[0]) seriesExtremes[0] = stackedYval;
    }
};
/**
 * Loop over all fields and create datasets, calculating extreme y-values for
 * each series and extreme x-indices as we go.
 *
 * dateWindow is passed in as an explicit parameter so that we can compute
 * extreme values "speculatively", i.e. without actually setting state on the
 * dygraph.
 *
 * @param {Array.<Array.<Array.<(number|Array<number>)>>} rolledSeries, where
 *     rolledSeries[seriesIndex][row] = raw point, where
 *     seriesIndex is the column number starting with 1, and
 *     rawPoint is [x,y] or [x, [y, err]] or [x, [y, yminus, yplus]].
 * @param {?Array.<number>} dateWindow [xmin, xmax] pair, or null.
 * @return {{
 *     points: Array.<Array.<Dygraph.PointType>>,
 *     seriesExtremes: Array.<Array.<number>>,
 *     boundaryIds: Array.<number>}}
 * @private
 */ $298304f644e9f727$var$Dygraph.prototype.gatherDatasets_ = function(rolledSeries, dateWindow) {
    var boundaryIds = [];
    var points = [];
    var cumulativeYval = []; // For stacked series.
    var extremes = {}; // series name -> [low, high]
    var seriesIdx, sampleIdx;
    var firstIdx, lastIdx;
    var axisIdx;
    // Loop over the fields (series).  Go from the last to the first,
    // because if they're stacked that's how we accumulate the values.
    var num_series = rolledSeries.length - 1;
    var series;
    for(seriesIdx = num_series; seriesIdx >= 1; seriesIdx--){
        if (!this.visibility()[seriesIdx - 1]) continue;
        // Prune down to the desired range, if necessary (for zooming)
        // Because there can be lines going to points outside of the visible area,
        // we actually prune to visible points, plus one on either side.
        if (dateWindow) {
            series = rolledSeries[seriesIdx];
            var low = dateWindow[0];
            var high = dateWindow[1];
            // TODO(danvk): do binary search instead of linear search.
            // TODO(danvk): pass firstIdx and lastIdx directly to the renderer.
            firstIdx = null;
            lastIdx = null;
            for(sampleIdx = 0; sampleIdx < series.length; sampleIdx++){
                if (series[sampleIdx][0] >= low && firstIdx === null) firstIdx = sampleIdx;
                if (series[sampleIdx][0] <= high) lastIdx = sampleIdx;
            }
            if (firstIdx === null) firstIdx = 0;
            var correctedFirstIdx = firstIdx;
            var isInvalidValue = true;
            while(isInvalidValue && correctedFirstIdx > 0){
                correctedFirstIdx--;
                // check if the y value is null.
                isInvalidValue = series[correctedFirstIdx][1] === null;
            }
            if (lastIdx === null) lastIdx = series.length - 1;
            var correctedLastIdx = lastIdx;
            isInvalidValue = true;
            while(isInvalidValue && correctedLastIdx < series.length - 1){
                correctedLastIdx++;
                isInvalidValue = series[correctedLastIdx][1] === null;
            }
            if (correctedFirstIdx !== firstIdx) firstIdx = correctedFirstIdx;
            if (correctedLastIdx !== lastIdx) lastIdx = correctedLastIdx;
            boundaryIds[seriesIdx - 1] = [
                firstIdx,
                lastIdx
            ];
            // .slice's end is exclusive, we want to include lastIdx.
            series = series.slice(firstIdx, lastIdx + 1);
        } else {
            series = rolledSeries[seriesIdx];
            boundaryIds[seriesIdx - 1] = [
                0,
                series.length - 1
            ];
        }
        var seriesName = this.attr_("labels")[seriesIdx];
        var seriesExtremes = this.dataHandler_.getExtremeYValues(series, dateWindow, this.getBooleanOption("stepPlot", seriesName));
        var seriesPoints = this.dataHandler_.seriesToPoints(series, seriesName, boundaryIds[seriesIdx - 1][0]);
        if (this.getBooleanOption("stackedGraph")) {
            axisIdx = this.attributes_.axisForSeries(seriesName);
            if (cumulativeYval[axisIdx] === undefined) cumulativeYval[axisIdx] = [];
            $298304f644e9f727$var$Dygraph.stackPoints_(seriesPoints, cumulativeYval[axisIdx], seriesExtremes, this.getBooleanOption("stackedGraphNaNFill"));
        }
        extremes[seriesName] = seriesExtremes;
        points[seriesIdx] = seriesPoints;
    }
    return {
        points: points,
        extremes: extremes,
        boundaryIds: boundaryIds
    };
};
/**
 * Update the graph with new data. This method is called when the viewing area
 * has changed. If the underlying data or options have changed, predraw_ will
 * be called before drawGraph_ is called.
 *
 * @private
 */ $298304f644e9f727$var$Dygraph.prototype.drawGraph_ = function() {
    var start = new Date();
    // This is used to set the second parameter to drawCallback, below.
    var is_initial_draw = this.is_initial_draw_;
    this.is_initial_draw_ = false;
    this.layout_.removeAllDatasets();
    this.setColors_();
    this.attrs_.pointSize = 0.5 * this.getNumericOption('highlightCircleSize');
    var packed = this.gatherDatasets_(this.rolledSeries_, this.dateWindow_);
    var points = packed.points;
    var extremes = packed.extremes;
    this.boundaryIds_ = packed.boundaryIds;
    this.setIndexByName_ = {};
    var labels = this.attr_("labels");
    var dataIdx = 0;
    for(var i = 1; i < points.length; i++){
        if (!this.visibility()[i - 1]) continue;
        this.layout_.addDataset(labels[i], points[i]);
        this.datasetIndex_[i] = dataIdx++;
    }
    for(var i = 0; i < labels.length; i++)this.setIndexByName_[labels[i]] = i;
    this.computeYAxisRanges_(extremes);
    this.layout_.setYAxes(this.axes_);
    this.addXTicks_();
    // Tell PlotKit to use this new data and render itself
    this.layout_.evaluate();
    this.renderGraph_(is_initial_draw);
    if (this.getStringOption("timingName")) {
        var end = new Date();
        console.log(this.getStringOption("timingName") + " - drawGraph: " + (end - start) + "ms");
    }
};
/**
 * This does the work of drawing the chart. It assumes that the layout and axis
 * scales have already been set (e.g. by predraw_).
 *
 * @private
 */ $298304f644e9f727$var$Dygraph.prototype.renderGraph_ = function(is_initial_draw) {
    this.cascadeEvents_('clearChart');
    this.plotter_.clear();
    var underlayCallback = this.getFunctionOption('underlayCallback');
    if (underlayCallback) // NOTE: we pass the dygraph object to this callback twice to avoid breaking
    // users who expect a deprecated form of this callback.
    underlayCallback.call(this, this.hidden_ctx_, this.layout_.getPlotArea(), this, this);
    var e = {
        canvas: this.hidden_,
        drawingContext: this.hidden_ctx_
    };
    this.cascadeEvents_('willDrawChart', e);
    this.plotter_.render();
    this.cascadeEvents_('didDrawChart', e);
    this.lastRow_ = -1; // because plugins/legend.js clears the legend
    // TODO(danvk): is this a performance bottleneck when panning?
    // The interaction canvas should already be empty in that situation.
    this.canvas_.getContext('2d').clearRect(0, 0, this.width_, this.height_);
    var drawCallback = this.getFunctionOption("drawCallback");
    if (drawCallback !== null) drawCallback.call(this, this, is_initial_draw);
    if (is_initial_draw) {
        this.readyFired_ = true;
        while(this.readyFns_.length > 0){
            var fn = this.readyFns_.pop();
            fn(this);
        }
    }
};
/**
 * @private
 * Determine properties of the y-axes which are independent of the data
 * currently being displayed. This includes things like the number of axes and
 * the style of the axes. It does not include the range of each axis and its
 * tick marks.
 * This fills in this.axes_.
 * axes_ = [ { options } ]
 *   indices are into the axes_ array.
 */ $298304f644e9f727$var$Dygraph.prototype.computeYAxes_ = function() {
    var axis, index, opts, v;
    // this.axes_ doesn't match this.attributes_.axes_.options. It's used for
    // data computation as well as options storage.
    // Go through once and add all the axes.
    this.axes_ = [];
    for(axis = 0; axis < this.attributes_.numAxes(); axis++){
        // Add a new axis, making a copy of its per-axis options.
        opts = {
            g: this
        };
        $298304f644e9f727$var$utils.update(opts, this.attributes_.axisOptions(axis));
        this.axes_[axis] = opts;
    }
    for(axis = 0; axis < this.axes_.length; axis++)if (axis === 0) {
        opts = this.optionsViewForAxis_('y' + (axis ? '2' : ''));
        v = opts("valueRange");
        if (v) this.axes_[axis].valueRange = v;
    } else {
        // To keep old behavior
        var axes = this.user_attrs_.axes;
        if (axes && axes.y2) {
            v = axes.y2.valueRange;
            if (v) this.axes_[axis].valueRange = v;
        }
    }
};
/**
 * Returns the number of y-axes on the chart.
 * @return {number} the number of axes.
 */ $298304f644e9f727$var$Dygraph.prototype.numAxes = function() {
    return this.attributes_.numAxes();
};
/**
 * @private
 * Returns axis properties for the given series.
 * @param {string} setName The name of the series for which to get axis
 * properties, e.g. 'Y1'.
 * @return {Object} The axis properties.
 */ $298304f644e9f727$var$Dygraph.prototype.axisPropertiesForSeries = function(series) {
    // TODO(danvk): handle errors.
    return this.axes_[this.attributes_.axisForSeries(series)];
};
/**
 * @private
 * Determine the value range and tick marks for each axis.
 * @param {Object} extremes A mapping from seriesName -> [low, high]
 * This fills in the valueRange and ticks fields in each entry of this.axes_.
 */ $298304f644e9f727$var$Dygraph.prototype.computeYAxisRanges_ = function(extremes) {
    var isNullUndefinedOrNaN = function isNullUndefinedOrNaN(num) {
        return isNaN(parseFloat(num));
    };
    var numAxes = this.attributes_.numAxes();
    var ypadCompat, span, series, ypad;
    var p_axis;
    // Compute extreme values, a span and tick marks for each axis.
    for(var i = 0; i < numAxes; i++){
        var axis = this.axes_[i];
        var logscale = this.attributes_.getForAxis("logscale", i);
        var includeZero = this.attributes_.getForAxis("includeZero", i);
        var independentTicks = this.attributes_.getForAxis("independentTicks", i);
        series = this.attributes_.seriesForAxis(i);
        // Add some padding. This supports two Y padding operation modes:
        //
        // - backwards compatible (yRangePad not set):
        //   10% padding for automatic Y ranges, but not for user-supplied
        //   ranges, and move a close-to-zero edge to zero, since drawing at the edge
        //   results in invisible lines. Unfortunately lines drawn at the edge of a
        //   user-supplied range will still be invisible. If logscale is
        //   set, add a variable amount of padding at the top but
        //   none at the bottom.
        //
        // - new-style (yRangePad set by the user):
        //   always add the specified Y padding.
        //
        ypadCompat = true;
        ypad = 0.1; // add 10%
        var yRangePad = this.getNumericOption('yRangePad');
        if (yRangePad !== null) {
            ypadCompat = false;
            // Convert pixel padding to ratio
            ypad = yRangePad / this.plotter_.area.h;
        }
        if (series.length === 0) // If no series are defined or visible then use a reasonable default
        axis.extremeRange = [
            0,
            1
        ];
        else {
            // Calculate the extremes of extremes.
            var minY = Infinity; // extremes[series[0]][0];
            var maxY = -Infinity; // extremes[series[0]][1];
            var extremeMinY, extremeMaxY;
            for(var j = 0; j < series.length; j++){
                // this skips invisible series
                if (!extremes.hasOwnProperty(series[j])) continue;
                // Only use valid extremes to stop null data series' from corrupting the scale.
                extremeMinY = extremes[series[j]][0];
                if (extremeMinY !== null) minY = Math.min(extremeMinY, minY);
                extremeMaxY = extremes[series[j]][1];
                if (extremeMaxY !== null) maxY = Math.max(extremeMaxY, maxY);
            }
            // Include zero if requested by the user.
            if (includeZero && !logscale) {
                if (minY > 0) minY = 0;
                if (maxY < 0) maxY = 0;
            }
            // Ensure we have a valid scale, otherwise default to [0, 1] for safety.
            if (minY == Infinity) minY = 0;
            if (maxY == -Infinity) maxY = 1;
            span = maxY - minY;
            // special case: if we have no sense of scale, center on the sole value.
            if (span === 0) {
                if (maxY !== 0) span = Math.abs(maxY);
                else {
                    // ... and if the sole value is zero, use range 0-1.
                    maxY = 1;
                    span = 1;
                }
            }
            var maxAxisY = maxY, minAxisY = minY;
            if (ypadCompat) {
                if (logscale) {
                    maxAxisY = maxY + ypad * span;
                    minAxisY = minY;
                } else {
                    maxAxisY = maxY + ypad * span;
                    minAxisY = minY - ypad * span;
                    // Backwards-compatible behavior: Move the span to start or end at zero if it's
                    // close to zero.
                    if (minAxisY < 0 && minY >= 0) minAxisY = 0;
                    if (maxAxisY > 0 && maxY <= 0) maxAxisY = 0;
                }
            }
            axis.extremeRange = [
                minAxisY,
                maxAxisY
            ];
        }
        if (axis.valueRange) {
            // This is a user-set value range for this axis.
            var y0 = isNullUndefinedOrNaN(axis.valueRange[0]) ? axis.extremeRange[0] : axis.valueRange[0];
            var y1 = isNullUndefinedOrNaN(axis.valueRange[1]) ? axis.extremeRange[1] : axis.valueRange[1];
            axis.computedValueRange = [
                y0,
                y1
            ];
        } else axis.computedValueRange = axis.extremeRange;
        if (!ypadCompat) {
            // When using yRangePad, adjust the upper/lower bounds to add
            // padding unless the user has zoomed/panned the Y axis range.
            if (logscale) {
                y0 = axis.computedValueRange[0];
                y1 = axis.computedValueRange[1];
                var y0pct = ypad / (2 * ypad - 1);
                var y1pct = (ypad - 1) / (2 * ypad - 1);
                axis.computedValueRange[0] = $298304f644e9f727$var$utils.logRangeFraction(y0, y1, y0pct);
                axis.computedValueRange[1] = $298304f644e9f727$var$utils.logRangeFraction(y0, y1, y1pct);
            } else {
                y0 = axis.computedValueRange[0];
                y1 = axis.computedValueRange[1];
                span = y1 - y0;
                axis.computedValueRange[0] = y0 - span * ypad;
                axis.computedValueRange[1] = y1 + span * ypad;
            }
        }
        if (independentTicks) {
            axis.independentTicks = independentTicks;
            var opts = this.optionsViewForAxis_('y' + (i ? '2' : ''));
            var ticker = opts('ticker');
            axis.ticks = ticker(axis.computedValueRange[0], axis.computedValueRange[1], this.plotter_.area.h, opts, this);
            // Define the first independent axis as primary axis.
            if (!p_axis) p_axis = axis;
        }
    }
    if (p_axis === undefined) throw "Configuration Error: At least one axis has to have the \"independentTicks\" option activated.";
    // Add ticks. By default, all axes inherit the tick positions of the
    // primary axis. However, if an axis is specifically marked as having
    // independent ticks, then that is permissible as well.
    for(var i = 0; i < numAxes; i++){
        var axis = this.axes_[i];
        if (!axis.independentTicks) {
            var opts = this.optionsViewForAxis_('y' + (i ? '2' : ''));
            var ticker = opts('ticker');
            var p_ticks = p_axis.ticks;
            var p_scale = p_axis.computedValueRange[1] - p_axis.computedValueRange[0];
            var scale = axis.computedValueRange[1] - axis.computedValueRange[0];
            var tick_values = [];
            for(var k = 0; k < p_ticks.length; k++){
                var y_frac = (p_ticks[k].v - p_axis.computedValueRange[0]) / p_scale;
                var y_val = axis.computedValueRange[0] + y_frac * scale;
                tick_values.push(y_val);
            }
            axis.ticks = ticker(axis.computedValueRange[0], axis.computedValueRange[1], this.plotter_.area.h, opts, this, tick_values);
        }
    }
};
/**
 * Detects the type of the str (date or numeric) and sets the various
 * formatting attributes in this.attrs_ based on this type.
 * @param {string} str An x value.
 * @private
 */ $298304f644e9f727$var$Dygraph.prototype.detectTypeFromString_ = function(str) {
    var isDate = false;
    var dashPos = str.indexOf('-'); // could be 2006-01-01 _or_ 1.0e-2
    if (dashPos > 0 && str[dashPos - 1] != 'e' && str[dashPos - 1] != 'E' || str.indexOf('/') >= 0 || isNaN(parseFloat(str))) isDate = true;
    else if (str.length == 8 && str > '19700101' && str < '20371231') // TODO(danvk): remove support for this format.
    isDate = true;
    this.setXAxisOptions_(isDate);
};
$298304f644e9f727$var$Dygraph.prototype.setXAxisOptions_ = function(isDate) {
    if (isDate) {
        this.attrs_.xValueParser = $298304f644e9f727$var$utils.dateParser;
        this.attrs_.axes.x.valueFormatter = $298304f644e9f727$var$utils.dateValueFormatter;
        this.attrs_.axes.x.ticker = $298304f644e9f727$var$DygraphTickers.dateTicker;
        this.attrs_.axes.x.axisLabelFormatter = $298304f644e9f727$var$utils.dateAxisLabelFormatter;
    } else {
        /** @private (shut up, jsdoc!) */ this.attrs_.xValueParser = function(x) {
            return parseFloat(x);
        };
        // TODO(danvk): use Dygraph.numberValueFormatter here?
        /** @private (shut up, jsdoc!) */ this.attrs_.axes.x.valueFormatter = function(x) {
            return x;
        };
        this.attrs_.axes.x.ticker = $298304f644e9f727$var$DygraphTickers.numericTicks;
        this.attrs_.axes.x.axisLabelFormatter = this.attrs_.axes.x.valueFormatter;
    }
};
/**
 * @private
 * Parses a string in a special csv format.  We expect a csv file where each
 * line is a date point, and the first field in each line is the date string.
 * We also expect that all remaining fields represent series.
 * if the errorBars attribute is set, then interpret the fields as:
 * date, series1, stddev1, series2, stddev2, ...
 * @param {[Object]} data See above.
 *
 * @return [Object] An array with one entry for each row. These entries
 * are an array of cells in that row. The first entry is the parsed x-value for
 * the row. The second, third, etc. are the y-values. These can take on one of
 * three forms, depending on the CSV and constructor parameters:
 * 1. numeric value
 * 2. [ value, stddev ]
 * 3. [ low value, center value, high value ]
 */ $298304f644e9f727$var$Dygraph.prototype.parseCSV_ = function(data) {
    var ret = [];
    var line_delimiter = $298304f644e9f727$var$utils.detectLineDelimiter(data);
    var lines = data.split(line_delimiter || "\n");
    var vals, j;
    // Use the default delimiter or fall back to a tab if that makes sense.
    var delim = this.getStringOption('delimiter');
    if (lines[0].indexOf(delim) == -1 && lines[0].indexOf('\t') >= 0) delim = '\t';
    var start = 0;
    if (!('labels' in this.user_attrs_)) {
        // User hasn't explicitly set labels, so they're (presumably) in the CSV.
        start = 1;
        this.attrs_.labels = lines[0].split(delim); // NOTE: _not_ user_attrs_.
        this.attributes_.reparseSeries();
    }
    var line_no = 0;
    var xParser;
    var defaultParserSet = false; // attempt to auto-detect x value type
    var expectedCols = this.attr_("labels").length;
    var outOfOrder = false;
    for(var i = start; i < lines.length; i++){
        var line = lines[i];
        line_no = i;
        if (line.length === 0) continue; // skip blank lines
        if (line[0] == '#') continue; // skip comment lines
        var inFields = line.split(delim);
        if (inFields.length < 2) continue;
        var fields = [];
        if (!defaultParserSet) {
            this.detectTypeFromString_(inFields[0]);
            xParser = this.getFunctionOption("xValueParser");
            defaultParserSet = true;
        }
        fields[0] = xParser(inFields[0], this);
        // If fractions are expected, parse the numbers as "A/B"
        if (this.fractions_) for(j = 1; j < inFields.length; j++){
            // TODO(danvk): figure out an appropriate way to flag parse errors.
            vals = inFields[j].split("/");
            if (vals.length != 2) {
                console.error('Expected fractional "num/den" values in CSV data but found a value \'' + inFields[j] + "' on line " + (1 + i) + " ('" + line + "') which is not of this form.");
                fields[j] = [
                    0,
                    0
                ];
            } else fields[j] = [
                $298304f644e9f727$var$utils.parseFloat_(vals[0], i, line),
                $298304f644e9f727$var$utils.parseFloat_(vals[1], i, line)
            ];
        }
        else if (this.getBooleanOption("errorBars")) {
            // If there are error bars, values are (value, stddev) pairs
            if (inFields.length % 2 != 1) console.error("Expected alternating (value, stdev.) pairs in CSV data but line " + (1 + i) + ' has an odd number of values (' + (inFields.length - 1) + "): '" + line + "'");
            for(j = 1; j < inFields.length; j += 2)fields[(j + 1) / 2] = [
                $298304f644e9f727$var$utils.parseFloat_(inFields[j], i, line),
                $298304f644e9f727$var$utils.parseFloat_(inFields[j + 1], i, line)
            ];
        } else if (this.getBooleanOption("customBars")) // Bars are a low;center;high tuple
        for(j = 1; j < inFields.length; j++){
            var val = inFields[j];
            if (/^ *$/.test(val)) fields[j] = [
                null,
                null,
                null
            ];
            else {
                vals = val.split(";");
                if (vals.length == 3) fields[j] = [
                    $298304f644e9f727$var$utils.parseFloat_(vals[0], i, line),
                    $298304f644e9f727$var$utils.parseFloat_(vals[1], i, line),
                    $298304f644e9f727$var$utils.parseFloat_(vals[2], i, line)
                ];
                else console.warn('When using customBars, values must be either blank or "low;center;high" tuples (got "' + val + '" on line ' + (1 + i));
            }
        }
        else // Values are just numbers
        for(j = 1; j < inFields.length; j++)fields[j] = $298304f644e9f727$var$utils.parseFloat_(inFields[j], i, line);
        if (ret.length > 0 && fields[0] < ret[ret.length - 1][0]) outOfOrder = true;
        if (fields.length != expectedCols) console.error("Number of columns in line " + i + " (" + fields.length + ") does not agree with number of labels (" + expectedCols + ") " + line);
        // If the user specified the 'labels' option and none of the cells of the
        // first row parsed correctly, then they probably double-specified the
        // labels. We go with the values set in the option, discard this row and
        // log a warning to the JS console.
        if (i === 0 && this.attr_('labels')) {
            var all_null = true;
            for(j = 0; all_null && j < fields.length; j++)if (fields[j]) all_null = false;
            if (all_null) {
                console.warn("The dygraphs 'labels' option is set, but the first row of CSV data ('" + line + "') appears to also contain " + "labels. Will drop the CSV labels and use the option " + "labels.");
                continue;
            }
        }
        ret.push(fields);
    }
    if (outOfOrder) {
        console.warn("CSV is out of order; order it correctly to speed loading.");
        ret.sort(function(a, b) {
            return a[0] - b[0];
        });
    }
    return ret;
};
// In native format, all values must be dates or numbers.
// This check isn't perfect but will catch most mistaken uses of strings.
function $298304f644e9f727$var$validateNativeFormat(data) {
    var firstRow = data[0];
    var firstX = firstRow[0];
    if (typeof firstX !== 'number' && !$298304f644e9f727$var$utils.isDateLike(firstX)) throw new Error('Expected number or date but got ' + typeof firstX + ': ' + firstX + '.');
    for(var i = 1; i < firstRow.length; i++){
        var val = firstRow[i];
        if (val === null || val === undefined) continue;
        if (typeof val === 'number') continue;
        if ($298304f644e9f727$var$utils.isArrayLike(val)) continue; // e.g. error bars or custom bars.
        throw new Error('Expected number or array but got ' + typeof val + ': ' + val + '.');
    }
}
/**
 * The user has provided their data as a pre-packaged JS array. If the x values
 * are numeric, this is the same as dygraphs' internal format. If the x values
 * are dates, we need to convert them from Date objects to ms since epoch.
 * @param {!Array} data
 * @return {Object} data with numeric x values.
 * @private
 */ $298304f644e9f727$var$Dygraph.prototype.parseArray_ = function(data) {
    // Peek at the first x value to see if it's numeric.
    if (data.length === 0) {
        console.error("Can't plot empty data set");
        return null;
    }
    if (data[0].length === 0) {
        console.error("Data set cannot contain an empty row");
        return null;
    }
    $298304f644e9f727$var$validateNativeFormat(data);
    var i;
    if (this.attr_("labels") === null) {
        console.warn("Using default labels. Set labels explicitly via 'labels' in the options parameter");
        this.attrs_.labels = [
            "X"
        ];
        for(i = 1; i < data[0].length; i++)this.attrs_.labels.push("Y" + i); // Not user_attrs_.
        this.attributes_.reparseSeries();
    } else {
        var num_labels = this.attr_("labels");
        if (num_labels.length != data[0].length) {
            console.error("Mismatch between number of labels (" + num_labels + ")" + " and number of columns in array (" + data[0].length + ")");
            return null;
        }
    }
    if ($298304f644e9f727$var$utils.isDateLike(data[0][0])) {
        // Some intelligent defaults for a date x-axis.
        this.attrs_.axes.x.valueFormatter = $298304f644e9f727$var$utils.dateValueFormatter;
        this.attrs_.axes.x.ticker = $298304f644e9f727$var$DygraphTickers.dateTicker;
        this.attrs_.axes.x.axisLabelFormatter = $298304f644e9f727$var$utils.dateAxisLabelFormatter;
        // Assume they're all dates.
        var parsedData = $298304f644e9f727$var$utils.clone(data);
        for(i = 0; i < data.length; i++){
            if (parsedData[i].length === 0) {
                console.error("Row " + (1 + i) + " of data is empty");
                return null;
            }
            if (parsedData[i][0] === null || typeof parsedData[i][0].getTime != 'function' || isNaN(parsedData[i][0].getTime())) {
                console.error("x value in row " + (1 + i) + " is not a Date");
                return null;
            }
            parsedData[i][0] = parsedData[i][0].getTime();
        }
        return parsedData;
    } else {
        // Some intelligent defaults for a numeric x-axis.
        /** @private (shut up, jsdoc!) */ this.attrs_.axes.x.valueFormatter = function(x) {
            return x;
        };
        this.attrs_.axes.x.ticker = $298304f644e9f727$var$DygraphTickers.numericTicks;
        this.attrs_.axes.x.axisLabelFormatter = $298304f644e9f727$var$utils.numberAxisLabelFormatter;
        return data;
    }
};
/**
 * Parses a DataTable object from gviz.
 * The data is expected to have a first column that is either a date or a
 * number. All subsequent columns must be numbers. If there is a clear mismatch
 * between this.xValueParser_ and the type of the first column, it will be
 * fixed. Fills out rawData_.
 * @param {!google.visualization.DataTable} data See above.
 * @private
 */ $298304f644e9f727$var$Dygraph.prototype.parseDataTable_ = function(data) {
    var shortTextForAnnotationNum = function shortTextForAnnotationNum(num) {
        // converts [0-9]+ [A-Z][a-z]*
        // example: 0=A, 1=B, 25=Z, 26=Aa, 27=Ab
        // and continues like.. Ba Bb .. Za .. Zz..Aaa...Zzz Aaaa Zzzz
        var shortText = String.fromCharCode(65 /* A */  + num % 26);
        num = Math.floor(num / 26);
        while(num > 0){
            shortText = String.fromCharCode(65 /* A */  + (num - 1) % 26) + shortText.toLowerCase();
            num = Math.floor((num - 1) / 26);
        }
        return shortText;
    };
    var cols = data.getNumberOfColumns();
    var rows = data.getNumberOfRows();
    var indepType = data.getColumnType(0);
    if (indepType == 'date' || indepType == 'datetime') {
        this.attrs_.xValueParser = $298304f644e9f727$var$utils.dateParser;
        this.attrs_.axes.x.valueFormatter = $298304f644e9f727$var$utils.dateValueFormatter;
        this.attrs_.axes.x.ticker = $298304f644e9f727$var$DygraphTickers.dateTicker;
        this.attrs_.axes.x.axisLabelFormatter = $298304f644e9f727$var$utils.dateAxisLabelFormatter;
    } else if (indepType == 'number') {
        this.attrs_.xValueParser = function(x) {
            return parseFloat(x);
        };
        this.attrs_.axes.x.valueFormatter = function(x) {
            return x;
        };
        this.attrs_.axes.x.ticker = $298304f644e9f727$var$DygraphTickers.numericTicks;
        this.attrs_.axes.x.axisLabelFormatter = this.attrs_.axes.x.valueFormatter;
    } else throw new Error("only 'date', 'datetime' and 'number' types are supported for column 1 of DataTable input (Got '" + indepType + "')");
    // Array of the column indices which contain data (and not annotations).
    var colIdx = [];
    var annotationCols = {}; // data index -> [annotation cols]
    var hasAnnotations = false;
    var i, j;
    for(i = 1; i < cols; i++){
        var type = data.getColumnType(i);
        if (type == 'number') colIdx.push(i);
        else if (type == 'string' && this.getBooleanOption('displayAnnotations')) {
            // This is OK -- it's an annotation column.
            var dataIdx = colIdx[colIdx.length - 1];
            if (!annotationCols.hasOwnProperty(dataIdx)) annotationCols[dataIdx] = [
                i
            ];
            else annotationCols[dataIdx].push(i);
            hasAnnotations = true;
        } else throw new Error("Only 'number' is supported as a dependent type with Gviz. 'string' is only supported if displayAnnotations is true");
    }
    // Read column labels
    // TODO(danvk): add support back for errorBars
    var labels = [
        data.getColumnLabel(0)
    ];
    for(i = 0; i < colIdx.length; i++){
        labels.push(data.getColumnLabel(colIdx[i]));
        if (this.getBooleanOption("errorBars")) i += 1;
    }
    this.attrs_.labels = labels;
    cols = labels.length;
    var ret = [];
    var outOfOrder = false;
    var annotations = [];
    for(i = 0; i < rows; i++){
        var row = [];
        if (typeof data.getValue(i, 0) === 'undefined' || data.getValue(i, 0) === null) {
            console.warn("Ignoring row " + i + " of DataTable because of undefined or null first column.");
            continue;
        }
        if (indepType == 'date' || indepType == 'datetime') row.push(data.getValue(i, 0).getTime());
        else row.push(data.getValue(i, 0));
        if (!this.getBooleanOption("errorBars")) {
            for(j = 0; j < colIdx.length; j++){
                var col = colIdx[j];
                row.push(data.getValue(i, col));
                if (hasAnnotations && annotationCols.hasOwnProperty(col) && data.getValue(i, annotationCols[col][0]) !== null) {
                    var ann = {};
                    ann.series = data.getColumnLabel(col);
                    ann.xval = row[0];
                    ann.shortText = shortTextForAnnotationNum(annotations.length);
                    ann.text = '';
                    for(var k = 0; k < annotationCols[col].length; k++){
                        if (k) ann.text += "\n";
                        ann.text += data.getValue(i, annotationCols[col][k]);
                    }
                    annotations.push(ann);
                }
            }
            // Strip out infinities, which give dygraphs problems later on.
            for(j = 0; j < row.length; j++)if (!isFinite(row[j])) row[j] = null;
        } else for(j = 0; j < cols - 1; j++)row.push([
            data.getValue(i, 1 + 2 * j),
            data.getValue(i, 2 + 2 * j)
        ]);
        if (ret.length > 0 && row[0] < ret[ret.length - 1][0]) outOfOrder = true;
        ret.push(row);
    }
    if (outOfOrder) {
        console.warn("DataTable is out of order; order it correctly to speed loading.");
        ret.sort(function(a, b) {
            return a[0] - b[0];
        });
    }
    this.rawData_ = ret;
    if (annotations.length > 0) this.setAnnotations(annotations, true);
    this.attributes_.reparseSeries();
};
/**
 * Signals to plugins that the chart data has updated.
 * This happens after the data has updated but before the chart has redrawn.
 * @private
 */ $298304f644e9f727$var$Dygraph.prototype.cascadeDataDidUpdateEvent_ = function() {
    // TODO(danvk): there are some issues checking xAxisRange() and using
    // toDomCoords from handlers of this event. The visible range should be set
    // when the chart is drawn, not derived from the data.
    this.cascadeEvents_('dataDidUpdate', {});
};
/**
 * Get the CSV data. If it's in a function, call that function. If it's in a
 * file, do an XMLHttpRequest to get it.
 * @private
 */ $298304f644e9f727$var$Dygraph.prototype.start_ = function() {
    var data = this.file_;
    // Functions can return references of all other types.
    if (typeof data == 'function') data = data();
    if ($298304f644e9f727$var$utils.isArrayLike(data)) {
        this.rawData_ = this.parseArray_(data);
        this.cascadeDataDidUpdateEvent_();
        this.predraw_();
    } else if (typeof data == 'object' && typeof data.getColumnRange == 'function') {
        // must be a DataTable from gviz.
        this.parseDataTable_(data);
        this.cascadeDataDidUpdateEvent_();
        this.predraw_();
    } else if (typeof data == 'string') {
        // Heuristic: a newline means it's CSV data. Otherwise it's an URL.
        var line_delimiter = $298304f644e9f727$var$utils.detectLineDelimiter(data);
        if (line_delimiter) this.loadedEvent_(data);
        else {
            // REMOVE_FOR_IE
            var req;
            if (window.XMLHttpRequest) // Firefox, Opera, IE7, and other browsers will use the native object
            req = new XMLHttpRequest();
            else // IE 5 and 6 will use the ActiveX control
            req = new ActiveXObject("Microsoft.XMLHTTP");
            var caller = this;
            req.onreadystatechange = function() {
                if (req.readyState == 4) {
                    if (req.status === 200 || // Normal http
                    req.status === 0) // Chrome w/ --allow-file-access-from-files
                    caller.loadedEvent_(req.responseText);
                }
            };
            req.open("GET", data, true);
            req.send(null);
        }
    } else console.error("Unknown data format: " + typeof data);
};
/**
 * Changes various properties of the graph. These can include:
 * <ul>
 * <li>file: changes the source data for the graph</li>
 * <li>errorBars: changes whether the data contains stddev</li>
 * </ul>
 *
 * There's a huge variety of options that can be passed to this method. For a
 * full list, see http://dygraphs.com/options.html.
 *
 * @param {Object} input_attrs The new properties and values
 * @param {boolean} block_redraw Usually the chart is redrawn after every
 *     call to updateOptions(). If you know better, you can pass true to
 *     explicitly block the redraw. This can be useful for chaining
 *     updateOptions() calls, avoiding the occasional infinite loop and
 *     preventing redraws when it's not necessary (e.g. when updating a
 *     callback).
 */ $298304f644e9f727$var$Dygraph.prototype.updateOptions = function(input_attrs, block_redraw) {
    if (typeof block_redraw == 'undefined') block_redraw = false;
    // copyUserAttrs_ drops the "file" parameter as a convenience to us.
    var file = input_attrs.file;
    var attrs = $298304f644e9f727$var$Dygraph.copyUserAttrs_(input_attrs);
    // TODO(danvk): this is a mess. Move these options into attr_.
    if ('rollPeriod' in attrs) this.rollPeriod_ = attrs.rollPeriod;
    if ('dateWindow' in attrs) this.dateWindow_ = attrs.dateWindow;
    // TODO(danvk): validate per-series options.
    // Supported:
    // strokeWidth
    // pointSize
    // drawPoints
    // highlightCircleSize
    // Check if this set options will require new points.
    var requiresNewPoints = $298304f644e9f727$var$utils.isPixelChangingOptionList(this.attr_("labels"), attrs);
    $298304f644e9f727$var$utils.updateDeep(this.user_attrs_, attrs);
    this.attributes_.reparseSeries();
    if (file) {
        // This event indicates that the data is about to change, but hasn't yet.
        // TODO(danvk): support cancellation of the update via this event.
        this.cascadeEvents_('dataWillUpdate', {});
        this.file_ = file;
        if (!block_redraw) this.start_();
    } else if (!block_redraw) {
        if (requiresNewPoints) this.predraw_();
        else this.renderGraph_(false);
    }
};
/**
 * Make a copy of input attributes, removing file as a convenience.
 * @private
 */ $298304f644e9f727$var$Dygraph.copyUserAttrs_ = function(attrs) {
    var my_attrs = {};
    for(var k in attrs){
        if (!attrs.hasOwnProperty(k)) continue;
        if (k == 'file') continue;
        if (attrs.hasOwnProperty(k)) my_attrs[k] = attrs[k];
    }
    return my_attrs;
};
/**
 * Resizes the dygraph. If no parameters are specified, resizes to fill the
 * containing div (which has presumably changed size since the dygraph was
 * instantiated. If the width/height are specified, the div will be resized.
 *
 * This is far more efficient than destroying and re-instantiating a
 * Dygraph, since it doesn't have to reparse the underlying data.
 *
 * @param {number} width Width (in pixels)
 * @param {number} height Height (in pixels)
 */ $298304f644e9f727$var$Dygraph.prototype.resize = function(width, height) {
    if (this.resize_lock) return;
    this.resize_lock = true;
    if (width === null != (height === null)) {
        console.warn("Dygraph.resize() should be called with zero parameters or two non-NULL parameters. Pretending it was zero.");
        width = height = null;
    }
    var old_width = this.width_;
    var old_height = this.height_;
    if (width) {
        this.maindiv_.style.width = width + "px";
        this.maindiv_.style.height = height + "px";
        this.width_ = width;
        this.height_ = height;
    } else {
        this.width_ = this.maindiv_.clientWidth;
        this.height_ = this.maindiv_.clientHeight;
    }
    if (old_width != this.width_ || old_height != this.height_) {
        // Resizing a canvas erases it, even when the size doesn't change, so
        // any resize needs to be followed by a redraw.
        this.resizeElements_();
        this.predraw_();
    }
    this.resize_lock = false;
};
/**
 * Adjusts the number of points in the rolling average. Updates the graph to
 * reflect the new averaging period.
 * @param {number} length Number of points over which to average the data.
 */ $298304f644e9f727$var$Dygraph.prototype.adjustRoll = function(length) {
    this.rollPeriod_ = length;
    this.predraw_();
};
/**
 * Returns a boolean array of visibility statuses.
 */ $298304f644e9f727$var$Dygraph.prototype.visibility = function() {
    // Do lazy-initialization, so that this happens after we know the number of
    // data series.
    if (!this.getOption("visibility")) this.attrs_.visibility = [];
    // TODO(danvk): it looks like this could go into an infinite loop w/ user_attrs.
    while(this.getOption("visibility").length < this.numColumns() - 1)this.attrs_.visibility.push(true);
    return this.getOption("visibility");
};
/**
 * Changes the visibility of one or more series.
 *
 * @param {number|number[]|object} num the series index or an array of series indices
 *                                     or a boolean array of visibility states by index
 *                                     or an object mapping series numbers, as keys, to
 *                                     visibility state (boolean values)
 * @param {boolean} value the visibility state expressed as a boolean
 */ $298304f644e9f727$var$Dygraph.prototype.setVisibility = function(num, value) {
    var x = this.visibility();
    var numIsObject = false;
    if (!Array.isArray(num)) {
        if (num !== null && typeof num === 'object') numIsObject = true;
        else num = [
            num
        ];
    }
    if (numIsObject) {
        for(var i in num)if (num.hasOwnProperty(i)) {
            if (i < 0 || i >= x.length) console.warn("Invalid series number in setVisibility: " + i);
            else x[i] = num[i];
        }
    } else for(var i = 0; i < num.length; i++){
        if (typeof num[i] === 'boolean') {
            if (i >= x.length) console.warn("Invalid series number in setVisibility: " + i);
            else x[i] = num[i];
        } else if (num[i] < 0 || num[i] >= x.length) console.warn("Invalid series number in setVisibility: " + num[i]);
        else x[num[i]] = value;
    }
    this.predraw_();
};
/**
 * How large of an area will the dygraph render itself in?
 * This is used for testing.
 * @return A {width: w, height: h} object.
 * @private
 */ $298304f644e9f727$var$Dygraph.prototype.size = function() {
    return {
        width: this.width_,
        height: this.height_
    };
};
/**
 * Update the list of annotations and redraw the chart.
 * See dygraphs.com/annotations.html for more info on how to use annotations.
 * @param ann {Array} An array of annotation objects.
 * @param suppressDraw {Boolean} Set to "true" to block chart redraw (optional).
 */ $298304f644e9f727$var$Dygraph.prototype.setAnnotations = function(ann, suppressDraw) {
    // Only add the annotation CSS rule once we know it will be used.
    this.annotations_ = ann;
    if (!this.layout_) {
        console.warn("Tried to setAnnotations before dygraph was ready. Try setting them in a ready() block. See dygraphs.com/tests/annotation.html");
        return;
    }
    this.layout_.setAnnotations(this.annotations_);
    if (!suppressDraw) this.predraw_();
};
/**
 * Return the list of annotations.
 */ $298304f644e9f727$var$Dygraph.prototype.annotations = function() {
    return this.annotations_;
};
/**
 * Get the list of label names for this graph. The first column is the
 * x-axis, so the data series names start at index 1.
 *
 * Returns null when labels have not yet been defined.
 */ $298304f644e9f727$var$Dygraph.prototype.getLabels = function() {
    var labels = this.attr_("labels");
    return labels ? labels.slice() : null;
};
/**
 * Get the index of a series (column) given its name. The first column is the
 * x-axis, so the data series start with index 1.
 */ $298304f644e9f727$var$Dygraph.prototype.indexFromSetName = function(name) {
    return this.setIndexByName_[name];
};
/**
 * Find the row number corresponding to the given x-value.
 * Returns null if there is no such x-value in the data.
 * If there are multiple rows with the same x-value, this will return the
 * first one.
 * @param {number} xVal The x-value to look for (e.g. millis since epoch).
 * @return {?number} The row number, which you can pass to getValue(), or null.
 */ $298304f644e9f727$var$Dygraph.prototype.getRowForX = function(xVal) {
    var low = 0, high = this.numRows() - 1;
    while(low <= high){
        var idx = high + low >> 1;
        var x = this.getValue(idx, 0);
        if (x < xVal) low = idx + 1;
        else if (x > xVal) high = idx - 1;
        else if (low != idx) // equal, but there may be an earlier match.
        high = idx;
        else return idx;
    }
    return null;
};
/**
 * Trigger a callback when the dygraph has drawn itself and is ready to be
 * manipulated. This is primarily useful when dygraphs has to do an XHR for the
 * data (i.e. a URL is passed as the data source) and the chart is drawn
 * asynchronously. If the chart has already drawn, the callback will fire
 * immediately.
 *
 * This is a good place to call setAnnotation().
 *
 * @param {function(!Dygraph)} callback The callback to trigger when the chart
 *     is ready.
 */ $298304f644e9f727$var$Dygraph.prototype.ready = function(callback) {
    if (this.is_initial_draw_) this.readyFns_.push(callback);
    else callback.call(this, this);
};
/**
 * Add an event handler. This event handler is kept until the graph is
 * destroyed with a call to graph.destroy().
 *
 * @param {!Node} elem The element to add the event to.
 * @param {string} type The type of the event, e.g. 'click' or 'mousemove'.
 * @param {function(Event):(boolean|undefined)} fn The function to call
 *     on the event. The function takes one parameter: the event object.
 * @private
 */ $298304f644e9f727$var$Dygraph.prototype.addAndTrackEvent = function(elem, type, fn) {
    $298304f644e9f727$var$utils.addEvent(elem, type, fn);
    this.registeredEvents_.push({
        elem: elem,
        type: type,
        fn: fn
    });
};
$298304f644e9f727$var$Dygraph.prototype.removeTrackedEvents_ = function() {
    if (this.registeredEvents_) for(var idx = 0; idx < this.registeredEvents_.length; idx++){
        var reg = this.registeredEvents_[idx];
        $298304f644e9f727$var$utils.removeEvent(reg.elem, reg.type, reg.fn);
    }
    this.registeredEvents_ = [];
};
// Installed plugins, in order of precedence (most-general to most-specific).
$298304f644e9f727$var$Dygraph.PLUGINS = [
    $298304f644e9f727$var$_pluginsLegend2['default'],
    $298304f644e9f727$var$_pluginsAxes2['default'],
    $298304f644e9f727$var$_pluginsRangeSelector2['default'],
    $298304f644e9f727$var$_pluginsChartLabels2['default'],
    $298304f644e9f727$var$_pluginsAnnotations2['default'],
    $298304f644e9f727$var$_pluginsGrid2['default']
];
// There are many symbols which have historically been available through the
// Dygraph class. These are exported here for backwards compatibility.
$298304f644e9f727$var$Dygraph.GVizChart = $298304f644e9f727$var$_dygraphGviz2['default'];
$298304f644e9f727$var$Dygraph.DASHED_LINE = $298304f644e9f727$var$utils.DASHED_LINE;
$298304f644e9f727$var$Dygraph.DOT_DASH_LINE = $298304f644e9f727$var$utils.DOT_DASH_LINE;
$298304f644e9f727$var$Dygraph.dateAxisLabelFormatter = $298304f644e9f727$var$utils.dateAxisLabelFormatter;
$298304f644e9f727$var$Dygraph.toRGB_ = $298304f644e9f727$var$utils.toRGB_;
$298304f644e9f727$var$Dygraph.findPos = $298304f644e9f727$var$utils.findPos;
$298304f644e9f727$var$Dygraph.pageX = $298304f644e9f727$var$utils.pageX;
$298304f644e9f727$var$Dygraph.pageY = $298304f644e9f727$var$utils.pageY;
$298304f644e9f727$var$Dygraph.dateString_ = $298304f644e9f727$var$utils.dateString_;
$298304f644e9f727$var$Dygraph.defaultInteractionModel = $298304f644e9f727$var$_dygraphInteractionModel2['default'].defaultModel;
$298304f644e9f727$var$Dygraph.nonInteractiveModel = $298304f644e9f727$var$Dygraph.nonInteractiveModel_ = $298304f644e9f727$var$_dygraphInteractionModel2['default'].nonInteractiveModel_;
$298304f644e9f727$var$Dygraph.Circles = $298304f644e9f727$var$utils.Circles;
$298304f644e9f727$var$Dygraph.Plugins = {
    Legend: $298304f644e9f727$var$_pluginsLegend2['default'],
    Axes: $298304f644e9f727$var$_pluginsAxes2['default'],
    Annotations: $298304f644e9f727$var$_pluginsAnnotations2['default'],
    ChartLabels: $298304f644e9f727$var$_pluginsChartLabels2['default'],
    Grid: $298304f644e9f727$var$_pluginsGrid2['default'],
    RangeSelector: $298304f644e9f727$var$_pluginsRangeSelector2['default']
};
$298304f644e9f727$var$Dygraph.DataHandlers = {
    DefaultHandler: $298304f644e9f727$var$_datahandlerDefault2['default'],
    BarsHandler: $298304f644e9f727$var$_datahandlerBars2['default'],
    CustomBarsHandler: $298304f644e9f727$var$_datahandlerBarsCustom2['default'],
    DefaultFractionHandler: $298304f644e9f727$var$_datahandlerDefaultFractions2['default'],
    ErrorBarsHandler: $298304f644e9f727$var$_datahandlerBarsError2['default'],
    FractionsBarsHandler: $298304f644e9f727$var$_datahandlerBarsFractions2['default']
};
$298304f644e9f727$var$Dygraph.startPan = $298304f644e9f727$var$_dygraphInteractionModel2['default'].startPan;
$298304f644e9f727$var$Dygraph.startZoom = $298304f644e9f727$var$_dygraphInteractionModel2['default'].startZoom;
$298304f644e9f727$var$Dygraph.movePan = $298304f644e9f727$var$_dygraphInteractionModel2['default'].movePan;
$298304f644e9f727$var$Dygraph.moveZoom = $298304f644e9f727$var$_dygraphInteractionModel2['default'].moveZoom;
$298304f644e9f727$var$Dygraph.endPan = $298304f644e9f727$var$_dygraphInteractionModel2['default'].endPan;
$298304f644e9f727$var$Dygraph.endZoom = $298304f644e9f727$var$_dygraphInteractionModel2['default'].endZoom;
$298304f644e9f727$var$Dygraph.numericLinearTicks = $298304f644e9f727$var$DygraphTickers.numericLinearTicks;
$298304f644e9f727$var$Dygraph.numericTicks = $298304f644e9f727$var$DygraphTickers.numericTicks;
$298304f644e9f727$var$Dygraph.dateTicker = $298304f644e9f727$var$DygraphTickers.dateTicker;
$298304f644e9f727$var$Dygraph.Granularity = $298304f644e9f727$var$DygraphTickers.Granularity;
$298304f644e9f727$var$Dygraph.getDateAxis = $298304f644e9f727$var$DygraphTickers.getDateAxis;
$298304f644e9f727$var$Dygraph.floatFormat = $298304f644e9f727$var$utils.floatFormat;
$298304f644e9f727$exports['default'] = $298304f644e9f727$var$Dygraph;
$298304f644e9f727$exports = $298304f644e9f727$exports['default'];


/* eslint-disable */ /**
 * Synchronize zooming and/or selections between a set of dygraphs.
 *
 * Usage:
 *
 *   var g1 = new Dygraph(...),
 *       g2 = new Dygraph(...),
 *       ...;
 *   var sync = Dygraph.synchronize(g1, g2, ...);
 *   // graphs are now synchronized
 *   sync.detach();
 *   // graphs are no longer synchronized
 *
 * You can set options using the last parameter, for example:
 *
 *   var sync = Dygraph.synchronize(g1, g2, g3, {
 *      selection: true,
 *      zoom: true
 *   });
 *
 * The default is to synchronize both of these.
 *
 * Instead of passing one Dygraph object as each parameter, you may also pass an
 * array of dygraphs:
 *
 *   var sync = Dygraph.synchronize([g1, g2, g3], {
 *      selection: false,
 *      zoom: true
 *   });
 *
 * You may also set `range: false` if you wish to only sync the x-axis.
 * The `range` option has no effect unless `zoom` is true (the default).
 */ var $7358174edaa32bc8$var$synchronize = function() {
    if (arguments.length === 0) throw 'Invalid invocation of Dygraph.synchronize(). Need >= 1 argument.';
    var OPTIONS = [
        'selection',
        'zoom',
        'range'
    ];
    var opts = {
        selection: true,
        zoom: true,
        range: true
    };
    var dygraphs = [];
    var prevCallbacks = [];
    var parseOpts = function(obj) {
        if (!(obj instanceof Object)) throw 'Last argument must be either Dygraph or Object.';
        else for(var i = 0; i < OPTIONS.length; i++){
            var optName = OPTIONS[i];
            if (obj.hasOwnProperty(optName)) opts[optName] = obj[optName];
        }
    };
    if (arguments[0] instanceof (0, (/*@__PURE__*/$parcel$interopDefault($298304f644e9f727$exports)))) {
        // Arguments are Dygraph objects.
        for(var i = 0; i < arguments.length; i++){
            if (arguments[i] instanceof (0, (/*@__PURE__*/$parcel$interopDefault($298304f644e9f727$exports)))) dygraphs.push(arguments[i]);
            else break;
        }
        if (i < arguments.length - 1) throw "Invalid invocation of Dygraph.synchronize(). All but the last argument must be Dygraph objects.";
        else if (i == arguments.length - 1) parseOpts(arguments[arguments.length - 1]);
    } else if (arguments[0].length) {
        // Invoked w/ list of dygraphs, options
        for(var i = 0; i < arguments[0].length; i++)dygraphs.push(arguments[0][i]);
        if (arguments.length == 2) parseOpts(arguments[1]);
        else if (arguments.length > 2) throw "Invalid invocation of Dygraph.synchronize(). Expected two arguments: array and optional options argument.";
         // otherwise arguments.length == 1, which is fine.
    } else throw "Invalid invocation of Dygraph.synchronize(). First parameter must be either Dygraph or list of Dygraphs.";
    if (dygraphs.length < 2) throw "Invalid invocation of Dygraph.synchronize(). Need two or more dygraphs to synchronize.";
    var readycount = dygraphs.length;
    for(var i = 0; i < dygraphs.length; i++){
        var g = dygraphs[i];
        g.ready(function() {
            if (--readycount == 0) {
                // store original callbacks
                var callBackTypes = [
                    'drawCallback',
                    'highlightCallback',
                    'unhighlightCallback'
                ];
                for(var j = 0; j < dygraphs.length; j++){
                    if (!prevCallbacks[j]) prevCallbacks[j] = {};
                    for(var k = callBackTypes.length - 1; k >= 0; k--)prevCallbacks[j][callBackTypes[k]] = dygraphs[j].getFunctionOption(callBackTypes[k]);
                }
                // Listen for draw, highlight, unhighlight callbacks.
                if (opts.zoom) $7358174edaa32bc8$var$attachZoomHandlers(dygraphs, opts, prevCallbacks);
                if (opts.selection) $7358174edaa32bc8$var$attachSelectionHandlers(dygraphs, prevCallbacks);
            }
        });
    }
    return {
        detach: function() {
            for(var i = 0; i < dygraphs.length; i++){
                var g = dygraphs[i];
                if (opts.zoom) g.updateOptions({
                    drawCallback: prevCallbacks[i].drawCallback
                });
                if (opts.selection) g.updateOptions({
                    highlightCallback: prevCallbacks[i].highlightCallback,
                    unhighlightCallback: prevCallbacks[i].unhighlightCallback
                });
            }
            // release references & make subsequent calls throw.
            dygraphs = null;
            opts = null;
            prevCallbacks = null;
        }
    };
};
function $7358174edaa32bc8$var$arraysAreEqual(a, b) {
    if (!Array.isArray(a) || !Array.isArray(b)) return false;
    var i = a.length;
    if (i !== b.length) return false;
    while(i--){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $7358174edaa32bc8$var$attachZoomHandlers(gs, syncOpts, prevCallbacks) {
    var block = false;
    for(var i = 0; i < gs.length; i++){
        var g = gs[i];
        g.updateOptions({
            drawCallback: function(me, initial) {
                if (block || initial) return;
                block = true;
                // In the original code, the following assignment was originally
                // var opts = {dateWindow: me.xAxisRange()}, but this assumed that
                // all graphs shared the same time range and thus enforced that.
                var opts = {};
                if (syncOpts.range) opts.valueRange = me.yAxisRange();
                for(var j = 0; j < gs.length; j++){
                    if (gs[j] == me) {
                        if (prevCallbacks[j] && prevCallbacks[j].drawCallback) prevCallbacks[j].drawCallback.apply(this, arguments);
                        continue;
                    }
                    // Only redraw if there are new options
                    if ($7358174edaa32bc8$var$arraysAreEqual(opts.dateWindow, gs[j].getOption('dateWindow')) && $7358174edaa32bc8$var$arraysAreEqual(opts.valueRange, gs[j].getOption('valueRange'))) continue;
                    gs[j].updateOptions(opts);
                }
                block = false;
            }
        }, true);
    }
}
function $7358174edaa32bc8$var$attachSelectionHandlers(gs, prevCallbacks) {
    var block = false;
    for(var i = 0; i < gs.length; i++){
        var g = gs[i];
        g.updateOptions({
            highlightCallback: function(event, x, points, row, seriesName) {
                if (block) return;
                block = true;
                var me = this;
                for(var i = 0; i < gs.length; i++){
                    if (me == gs[i]) {
                        if (prevCallbacks[i] && prevCallbacks[i].highlightCallback) prevCallbacks[i].highlightCallback.apply(this, arguments);
                        continue;
                    }
                    var idx = gs[i].getRowForX(x);
                    if (idx !== null) gs[i].setSelection(idx, seriesName);
                }
                block = false;
            },
            unhighlightCallback: function(event) {
                if (block) return;
                block = true;
                var me = this;
                for(var i = 0; i < gs.length; i++){
                    if (me == gs[i]) {
                        if (prevCallbacks[i] && prevCallbacks[i].unhighlightCallback) prevCallbacks[i].unhighlightCallback.apply(this, arguments);
                        continue;
                    }
                    gs[i].clearSelection();
                }
                block = false;
            }
        }, true);
    }
}
function $7358174edaa32bc8$var$isValidPoint(p, opt_allowNaNY) {
    if (!p) return false // null or undefined object
    ;
    if (p.yval === null) return false // missing point
    ;
    if (p.x === null || p.x === undefined) return false;
    if (p.y === null || p.y === undefined) return false;
    if (isNaN(p.x) || !opt_allowNaNY && isNaN(p.y)) return false;
    return true;
}
(0, (/*@__PURE__*/$parcel$interopDefault($298304f644e9f727$exports))).prototype.findClosestPoint = function(domX, domY) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($298304f644e9f727$exports))).VERSION !== '2.0.0') console.error(`Dygraph version changed to ${(0, (/*@__PURE__*/$parcel$interopDefault($298304f644e9f727$exports))).VERSION} - re-copy findClosestPoint`);
    var minXDist = Infinity;
    var minYDist = Infinity;
    var xdist, ydist, dx, dy, point, closestPoint, closestSeries, closestRow;
    for(var setIdx = this.layout_.points.length - 1; setIdx >= 0; --setIdx){
        var points = this.layout_.points[setIdx];
        for(var i = 0; i < points.length; ++i){
            point = points[i];
            if (!$7358174edaa32bc8$var$isValidPoint(point)) continue;
            dx = point.canvasx - domX;
            dy = point.canvasy - domY;
            xdist = dx * dx;
            ydist = dy * dy;
            if (xdist < minXDist) {
                minXDist = xdist;
                minYDist = ydist;
                closestRow = point.idx;
                closestSeries = setIdx;
                closestPoint = point;
            } else if (xdist === minXDist && ydist < minYDist) {
                minXDist = xdist;
                minYDist = ydist;
                closestRow = point.idx;
                closestSeries = setIdx;
                closestPoint = point;
            }
        }
    }
    var name = this.layout_.setNames[closestSeries];
    return {
        row: closestRow,
        seriesName: name,
        point: closestPoint
    };
};
(0, (/*@__PURE__*/$parcel$interopDefault($298304f644e9f727$exports))).synchronize = $7358174edaa32bc8$var$synchronize;
(0, (/*@__PURE__*/$parcel$interopDefault($298304f644e9f727$exports))).Plugins.Crosshair = function() {
    'use strict';
    /**
   * Creates the crosshair
   *
   * @constructor
   */ var crosshair = function(opt_options) {
        this.canvas_ = document.createElement('canvas');
        opt_options = opt_options || {};
        this.direction_ = opt_options.direction || null;
    };
    crosshair.prototype.toString = function() {
        return 'Crosshair Plugin';
    };
    /**
   * @param {Dygraph} g Graph instance.
   * @return {object.<string, function(ev)>} Mapping of event names to callbacks.
   */ crosshair.prototype.activate = function(g) {
        g.graphDiv.appendChild(this.canvas_);
        return {
            select: this.select,
            deselect: this.deselect
        };
    };
    crosshair.prototype.select = function(e) {
        if (this.direction_ === null) return;
        var width = e.dygraph.width_;
        var height = e.dygraph.height_;
        var xLabelPixels = 20;
        this.canvas_.width = width;
        this.canvas_.height = height - xLabelPixels;
        this.canvas_.style.width = width + 'px' // for IE
        ;
        this.canvas_.style.height = height - xLabelPixels + 'px' // for IE
        ;
        var ctx = this.canvas_.getContext('2d');
        ctx.clearRect(0, 0, width, height);
        ctx.strokeStyle = '#C6CAD3';
        ctx.lineWidth = 1;
        // If graphs have different time ranges, it's possible to select a point on
        // one graph that doesn't exist in another, resulting in an exception.
        if (e.dygraph.selPoints_.length) {
            ctx.beginPath();
            var canvasx = Math.floor(e.dygraph.selPoints_[0].canvasx) + 0.5 // crisper rendering
            ;
            if (this.direction_ === 'vertical' || this.direction_ === 'both') {
                ctx.moveTo(canvasx, 0);
                ctx.lineTo(canvasx, height);
            }
            if (this.direction_ === 'horizontal' || this.direction_ === 'both') for(var i = 0; i < e.dygraph.selPoints_.length; i++){
                var canvasy = Math.floor(e.dygraph.selPoints_[i].canvasy) + 0.5 // crisper rendering
                ;
                ctx.moveTo(0, canvasy);
                ctx.lineTo(width, canvasy);
            }
            ctx.stroke();
            ctx.closePath();
        }
    };
    crosshair.prototype.deselect = function(e) {
        var ctx = this.canvas_.getContext('2d');
        ctx.clearRect(0, 0, this.canvas_.width, this.canvas_.height);
    };
    crosshair.prototype.destroy = function() {
        this.canvas_ = null;
    };
    return crosshair;
}();
var /* eslint-enable */ $7358174edaa32bc8$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($298304f644e9f727$exports)));


// Libraries

var $NdCUR = parcelRequire("NdCUR");


var $hBdgJ = parcelRequire("hBdgJ");

var $1v7mg = parcelRequire("1v7mg");

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");
class $cd8abe241c7db21b$var$DygraphLegendSort extends (0, $NdCUR.PureComponent) {
    render() {
        const { isAscending: isAscending, top: top, bottom: bottom, onSort: onSort, isActive: isActive } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('sort-btn btn btn-xs btn-square', {
                'btn-primary': isActive,
                'btn-default': !isActive,
                'sort-btn--asc': isAscending && isActive,
                'sort-btn--desc': !isAscending && isActive
            }),
            onClick: onSort
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "sort-btn--rotator"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "sort-btn--top"
        }, top), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "sort-btn--bottom"
        }, bottom)));
    }
}
var $cd8abe241c7db21b$export$2e2bcd8739ae039 = $cd8abe241c7db21b$var$DygraphLegendSort;



// Libraries

var $hBdgJ = parcelRequire("hBdgJ");
// Helper functions copied from dygraphs/src/dygraph-utils
const $ca3a48dfd8d0fa5f$var$RGBA_RE = /^rgba?\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})(?:,\s*([01](?:\.\d+)?))?\)$/;
function $ca3a48dfd8d0fa5f$var$parseRGBA(rgbStr) {
    const bits = $ca3a48dfd8d0fa5f$var$RGBA_RE.exec(rgbStr);
    if (!bits) return null;
    const r = parseInt(bits[1], 10);
    const g = parseInt(bits[2], 10);
    const b = parseInt(bits[3], 10);
    if (bits[4]) return {
        r: r,
        g: g,
        b: b,
        a: parseFloat(bits[4])
    };
    return {
        r: r,
        g: g,
        b: b
    };
}
function $ca3a48dfd8d0fa5f$export$c0374a851d79f51b(colorStr) {
    // Strategy: First try to parse colorStr directly. This is fast & avoids DOM
    // manipulation.  If that fails (e.g. for named colors like 'red'), then
    // create a hidden DOM element and parse its computed color.
    const rgb = $ca3a48dfd8d0fa5f$var$parseRGBA(colorStr);
    if (rgb) return rgb;
    const div = document.createElement('div');
    div.style.backgroundColor = colorStr;
    div.style.visibility = 'hidden';
    document.body.appendChild(div);
    const rgbStr = window.getComputedStyle(div, null).backgroundColor;
    document.body.removeChild(div);
    return $ca3a48dfd8d0fa5f$var$parseRGBA(rgbStr);
}




const $28d93691ce0d4d34$export$b7f07238211e7efd = [
    '#00C9FF',
    '#9394FF',
    '#4ED8A0',
    '#ff0054',
    '#ffcc00',
    '#33aa99',
    '#9dfc5d',
    '#92bcc3',
    '#ca96fb',
    '#ff00f0',
    '#38b94a',
    '#3844b9',
    '#a0725b'
];
const $28d93691ce0d4d34$export$259f24f30746f96e = 2;
const $28d93691ce0d4d34$export$d3a2f40bf7ab619b = (colorStr)=>{
    // Defined in dygraph-utils.js
    const color = (0, $ca3a48dfd8d0fa5f$export$c0374a851d79f51b)(colorStr);
    color.r = Math.floor((255 + color.r) / 2);
    color.g = Math.floor((255 + color.g) / 2);
    color.b = Math.floor((255 + color.b) / 2);
    return `rgb(${color.r},${color.g},${color.b})`;
};
const $28d93691ce0d4d34$export$a92ee9f37d6dc335 = (e)=>{
    // We need to handle all the series simultaneously.
    if (e.seriesIndex !== 0) return;
    const g = e.dygraph;
    const ctx = e.drawingContext;
    const sets = e.allSeriesPoints;
    const yBottom = e.dygraph.toDomYCoord(0);
    // Find the minimum separation between x-values.
    // This determines the bar width.
    let minSep = Infinity;
    for(let j = 0; j < sets.length; j++){
        const points = sets[j];
        for(let i = 1; i < points.length; i++){
            const sep = points[i].canvasx - points[i - 1].canvasx;
            if (sep < minSep) minSep = sep;
        }
    }
    // calculate bar width using some graphics math while
    // ensuring a bar is never smaller than one px, so it is always rendered
    const barWidth = Math.max(Math.floor(2.0 / 3.0 * minSep), 1.0);
    const fillColors = [];
    const strokeColors = g.getColors();
    let selPointX;
    if (g.selPoints_ && g.selPoints_.length) selPointX = g.selPoints_[0].canvasx;
    for(let i = 0; i < strokeColors.length; i++)fillColors.push($28d93691ce0d4d34$export$d3a2f40bf7ab619b(strokeColors[i]));
    ctx.lineWidth = 2;
    for(let j = 0; j < sets.length; j++){
        ctx.strokeStyle = strokeColors[j];
        for(let i = 0; i < sets[j].length; i++){
            const p = sets[j][i];
            const centerX = p.canvasx;
            ctx.fillStyle = fillColors[j];
            const xLeft = sets.length === 1 ? centerX - barWidth : centerX - barWidth * (1 - j / sets.length);
            ctx.fillRect(xLeft, p.canvasy, barWidth / sets.length, yBottom - p.canvasy);
            // hover highlighting
            if (selPointX === centerX) ctx.strokeRect(xLeft, p.canvasy, barWidth / sets.length, yBottom - p.canvasy);
        }
    }
};
const $28d93691ce0d4d34$export$b322dcebec73b11b = (graphDiv, legendDiv, legendMouseX)=>{
    if (!graphDiv || !legendDiv || legendMouseX === null) return {};
    const graphRect = graphDiv.getBoundingClientRect();
    const legendRect = legendDiv.getBoundingClientRect();
    const normalizedLegendMouseX = legendMouseX > 0 ? legendMouseX : 0;
    const mouseX = normalizedLegendMouseX + graphRect.left;
    const halfLegendWidth = legendRect.width / 2;
    const pageHeaderHeight = 60;
    const minimumX = graphRect.left;
    const maximumX = Math.max(graphRect.left + graphRect.width - halfLegendWidth, minimumX);
    const minimumY = graphRect.top - pageHeaderHeight;
    let translateX = mouseX - halfLegendWidth;
    let translateY = graphRect.height + graphRect.top;
    // Enforce Left Edge of Graph
    if (mouseX - halfLegendWidth < minimumX) translateX = minimumX;
    // Enforce Right Edge of Graph
    if (mouseX > maximumX) translateX = Math.max(maximumX - halfLegendWidth, minimumX);
    // Prevent Legend from rendering off screen
    const rightMargin = window.innerWidth - (mouseX + graphRect.left);
    const LEGEND_BUFFER = 12;
    if (window.innerHeight - graphRect.bottom < legendRect.height) {
        translateX = mouseX + LEGEND_BUFFER;
        translateY = Math.max(minimumY, pageHeaderHeight + LEGEND_BUFFER);
        if (rightMargin < legendRect.width + LEGEND_BUFFER) translateX = mouseX - (legendRect.width + LEGEND_BUFFER);
    }
    return {
        transform: `translate(${translateX}px, ${translateY}px)`
    };
};
const $28d93691ce0d4d34$export$8aef85b89d537123 = (label = '')=>{
    const [measurement] = label.match(/^([^.])+./g) || [
        ''
    ];
    return label.replace(measurement, '');
};
const $28d93691ce0d4d34$export$9cb9147b2efb6542 = (str, len)=>str.split('').map((char)=>char.charCodeAt(0)).reduce((hash, code)=>hash + code, 0) % len;
const $28d93691ce0d4d34$export$fc6b1e9923bb7632 = 44;
const $28d93691ce0d4d34$export$43e392df2a2e2f5e = 7;
const $28d93691ce0d4d34$export$8b7313ca2ebb28e = (data, dataType)=>{
    if (dataType === (0, $e10a8602f56394e3$export$45c69700ee30a78c).influxQL) return $28d93691ce0d4d34$var$getInfluxQLDataUUID(data);
    return $28d93691ce0d4d34$var$getFluxDataUUID(data);
};
const $28d93691ce0d4d34$var$getInfluxQLDataUUID = (data)=>{
    return (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(data, '0.response.uuid', '');
};
const $28d93691ce0d4d34$var$getFluxDataUUID = (data)=>{
    return (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(data, '0.id', '');
};
const $28d93691ce0d4d34$export$12c6ee516c60b754 = (prevData, newData)=>{
    return $28d93691ce0d4d34$var$getFluxDataUUID(prevData) === $28d93691ce0d4d34$var$getFluxDataUUID(newData);
};
const $28d93691ce0d4d34$export$c02dfba073881d63 = (prevData, newData)=>{
    return $28d93691ce0d4d34$var$getInfluxQLDataUUID(prevData) === $28d93691ce0d4d34$var$getInfluxQLDataUUID(newData);
};
const $28d93691ce0d4d34$export$5857ed7288c181de = (prevProps, newProps)=>{
    const isDataTypeChanged = prevProps.dataType !== newProps.dataType;
    const isDataIDsChanged = $28d93691ce0d4d34$export$8b7313ca2ebb28e(prevProps.data, prevProps.dataType) !== $28d93691ce0d4d34$export$8b7313ca2ebb28e(newProps.data, newProps.dataType);
    const isTimeRangeChanged = !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEqual((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(prevProps, 'timeRange'), (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(newProps, 'timeRange'));
    const isDataChanged = isDataTypeChanged || isDataIDsChanged || isTimeRangeChanged;
    return isDataChanged;
};




class $461bf492cf59acf5$var$DygraphLegend extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.legendRef = null, this.handleHide = ()=>{
            this.props.onHide();
            this.props.setActiveCell((0, $e10a8602f56394e3$export$d9e8b2a424c8c4e8));
        }, this.handleToggleFilter = ()=>{
            this.setState({
                isFilterVisible: !this.state.isFilterVisible,
                filterText: ''
            });
        }, this.handleLegendInputChange = (e)=>{
            const { dygraph: dygraph } = this.props;
            const { legend: legend } = this.state;
            const filterText = e.target.value;
            legend.series.map((__, i)=>{
                if (!legend.series[i]) return dygraph.setVisibility(i, true);
                dygraph.setVisibility(i, !!legend.series[i].label.match(filterText));
            });
            this.setState({
                filterText: filterText
            });
        }, this.handleSortLegend = (sortType)=>()=>{
                this.setState({
                    sortType: sortType,
                    isAscending: !this.state.isAscending
                });
            }, this.highlightCallback = (e)=>{
            if (this.props.activeCellID !== this.props.cellID) this.props.setActiveCell(this.props.cellID);
            this.setState({
                pageX: e.pageX
            });
            this.props.onShow(e);
        }, this.legendFormatter = (legend)=>{
            if (!legend.x) return '';
            const { legend: prevLegend } = this.state;
            const highlighted = legend.series.find((s)=>s.isHighlighted);
            const prevHighlighted = prevLegend.series.find((s)=>s.isHighlighted);
            const yVal = highlighted && highlighted.y;
            const prevY = prevHighlighted && prevHighlighted.y;
            if (legend.x === prevLegend.x && yVal === prevY) return '';
            this.setState({
                legend: legend
            });
            return '';
        }, this.unhighlightCallback = (e)=>{
            const { top: top, bottom: bottom, left: left, right: right } = this.legendRef.getBoundingClientRect();
            const mouseY = e.clientY;
            const mouseX = e.clientX;
            const mouseBuffer = 5;
            const mouseInLegendY = mouseY <= bottom && mouseY >= top - mouseBuffer;
            const mouseInLegendX = mouseX <= right && mouseX >= left;
            const isMouseHoveringLegend = mouseInLegendY && mouseInLegendX;
            if (!isMouseHoveringLegend) this.handleHide();
        };
        this.props.dygraph.updateOptions({
            legendFormatter: this.legendFormatter,
            highlightCallback: this.highlightCallback,
            unhighlightCallback: this.unhighlightCallback
        });
        this.state = {
            legend: {
                x: null,
                series: [],
                xHTML: ''
            },
            sortType: 'numeric',
            isAscending: false,
            filterText: '',
            isFilterVisible: false,
            legendStyles: {},
            pageX: null,
            cellID: null
        };
    }
    componentWillUnmount() {
        if (!this.props.dygraph.graphDiv || !this.props.dygraph.visibility().find((bool)=>bool === true)) this.setState({
            filterText: ''
        });
    }
    render() {
        const { onMouseEnter: onMouseEnter } = this.props;
        const { legend: legend, filterText: filterText, isAscending: isAscending, isFilterVisible: isFilterVisible } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: `dygraph-legend ${this.hidden}`,
            ref: (el)=>this.legendRef = el,
            onMouseEnter: onMouseEnter,
            onMouseLeave: this.handleHide,
            style: this.styles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "dygraph-legend--header"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "dygraph-legend--timestamp"
        }, legend.xHTML), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $cd8abe241c7db21b$export$2e2bcd8739ae039), {
            isAscending: isAscending,
            isActive: this.isAphaSort,
            top: "A",
            bottom: "Z",
            onSort: this.handleSortLegend('alphabetic')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $cd8abe241c7db21b$export$2e2bcd8739ae039), {
            isAscending: isAscending,
            isActive: this.isNumSort,
            top: "0",
            bottom: "9",
            onSort: this.handleSortLegend('numeric')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('btn btn-square btn-xs', {
                'btn-default': !isFilterVisible,
                'btn-primary': isFilterVisible
            }),
            onClick: this.handleToggleFilter
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon search"
        }))), isFilterVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "dygraph-legend--filter form-control input-xs",
            type: "text",
            value: filterText,
            onChange: this.handleLegendInputChange,
            placeholder: "Filter items...",
            autoFocus: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "dygraph-legend--contents"
        }, this.filtered.map(({ label: label, color: color, yHTML: yHTML, isHighlighted: isHighlighted }, i)=>{
            const seriesClass = isHighlighted ? 'dygraph-legend--row highlight' : 'dygraph-legend--row';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                key: i,
                className: seriesClass
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
                style: {
                    color: color
                }
            }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("figure", null, yHTML || 'no value'));
        })));
    }
    get filtered() {
        const { legend: legend, sortType: sortType, isAscending: isAscending, filterText: filterText } = this.state;
        const withValues = legend.series.filter((s)=>!(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isNil(s.y));
        const sorted = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).sortBy(withValues, ({ y: y, label: label })=>sortType === 'numeric' ? y : label);
        const ordered = isAscending ? sorted : sorted.reverse();
        return ordered.filter((s)=>s.label.match(filterText));
    }
    get isAphaSort() {
        return this.state.sortType === 'alphabetic';
    }
    get isNumSort() {
        return this.state.sortType === 'numeric';
    }
    get isVisible() {
        const { cellID: cellID, activeCellID: activeCellID } = this.props;
        return cellID === activeCellID;
    }
    get hidden() {
        if (this.isVisible) return '';
        return 'hidden';
    }
    get styles() {
        const { dygraph: dygraph, dygraph: { graphDiv: graphDiv }, hoverTime: hoverTime } = this.props;
        const legendHoverX = Math.max(dygraph.toDomXCoord(hoverTime), 0);
        return (0, $28d93691ce0d4d34$export$b322dcebec73b11b)(graphDiv, this.legendRef, legendHoverX);
    }
}
const $461bf492cf59acf5$var$mapDispatchToProps = {
    setActiveCell: $9859d1d8ae3f2524$export$c1df6941ca12827f
};
const $461bf492cf59acf5$var$mapStateToProps = ({ dashboardUI: dashboardUI })=>({
        activeCellID: dashboardUI.activeCellID,
        hoverTime: +dashboardUI.hoverTime
    });
var $461bf492cf59acf5$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($461bf492cf59acf5$var$mapStateToProps, $461bf492cf59acf5$var$mapDispatchToProps)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($461bf492cf59acf5$var$DygraphLegend));


// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");
// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");

class $ba8d5b260b89fdea$var$StaticLegend extends (0, $NdCUR.Component) {
    static{
        this.defaultProps = {
            enabled: true
        };
    }
    render() {
        const { color: color, label: label } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.className,
            onMouseDown: this.handleMouseDown
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            style: {
                color: color
            }
        }, label));
    }
    get className() {
        const { enabled: enabled, hoverEnabled: hoverEnabled } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('', {
            disabled: !enabled,
            'static-legend--item': hoverEnabled,
            'static-legend--single': !hoverEnabled
        });
    }
    constructor(...args){
        super(...args), this.handleMouseDown = (e)=>{
            const { onMouseDown: onMouseDown, index: index } = this.props;
            onMouseDown(index, e);
        };
    }
}
var $ba8d5b260b89fdea$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($ba8d5b260b89fdea$var$StaticLegend);




class $6a5e88528b288b14$var$StaticLegend extends (0, $NdCUR.Component) {
    constructor(props){
        super(props), this.handleMouseDown = (i, e)=>{
            const visibilities = this.props.dygraph.visibility();
            const clickStatus = this.state.clickStatus;
            if (e.shiftKey || e.metaKey) {
                visibilities[i] = !visibilities[i];
                this.props.dygraph.setVisibility(visibilities);
                this.setState({
                    visibilities: visibilities
                });
                return;
            }
            const prevClickStatus = clickStatus && visibilities[i];
            const newVisibilities = prevClickStatus ? (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).map(visibilities, ()=>true) : (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).map(visibilities, ()=>false);
            newVisibilities[i] = true;
            this.props.dygraph.setVisibility(newVisibilities);
            this.setState({
                visibilities: newVisibilities,
                clickStatus: !prevClickStatus
            });
        };
        this.staticLegendRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createRef();
        this.state = {
            visibilities: [],
            clickStatus: false
        };
    }
    componentDidMount() {
        const { height: height } = this.staticLegendRef.current.getBoundingClientRect();
        this.props.onUpdateHeight(height);
    }
    componentDidUpdate(prevProps) {
        const { height: height } = this.staticLegendRef.current.getBoundingClientRect();
        if (prevProps.height === height) return;
        this.props.onUpdateHeight(height);
    }
    componentWillUnmount() {
        this.props.onUpdateHeight(0);
    }
    render() {
        const { visibilities: visibilities } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "static-legend",
            ref: this.staticLegendRef
        }, (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).map(this.labels, (v, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ba8d5b260b89fdea$export$2e2bcd8739ae039), {
                index: i,
                onMouseDown: this.handleMouseDown,
                hoverEnabled: this.multipleLabelsExist,
                color: this.labelColors[i],
                label: (0, $28d93691ce0d4d34$export$8aef85b89d537123)(v),
                key: `static-legend--${i}-${(0, $28d93691ce0d4d34$export$8aef85b89d537123)(v)}`,
                enabled: visibilities[i]
            })));
    }
    get multipleLabelsExist() {
        return this.labels.length > 1;
    }
    get labels() {
        const { dygraphSeries: dygraphSeries } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).keys(dygraphSeries);
    }
    get labelColors() {
        const { dygraphSeries: dygraphSeries } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).map(this.labels, (l)=>dygraphSeries[l].color);
    }
}
var $6a5e88528b288b14$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($6a5e88528b288b14$var$StaticLegend);



var $NdCUR = parcelRequire("NdCUR");


var $NdCUR = parcelRequire("NdCUR");

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");





const $f639ba30c8310bf2$var$msToRFCString = (ms)=>ms && new Date(Math.round(ms)).toISOString();
const $f639ba30c8310bf2$var$rfcStringToMS = (rfc3339)=>rfc3339 && Date.parse(rfc3339);
const $f639ba30c8310bf2$var$annoToMillisecond = (annotation)=>({
        ...annotation,
        startTime: $f639ba30c8310bf2$var$rfcStringToMS(annotation.startTime),
        endTime: $f639ba30c8310bf2$var$rfcStringToMS(annotation.endTime)
    });
const $f639ba30c8310bf2$var$annoToRFC = (annotation)=>({
        ...annotation,
        startTime: $f639ba30c8310bf2$var$msToRFCString(annotation.startTime),
        endTime: $f639ba30c8310bf2$var$msToRFCString(annotation.endTime)
    });
const $f639ba30c8310bf2$export$51eda81011da4982 = async (url, annotation)=>{
    const data = $f639ba30c8310bf2$var$annoToRFC(annotation);
    const response = await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
        method: 'POST',
        url: url,
        data: data
    });
    return $f639ba30c8310bf2$var$annoToMillisecond(response.data);
};
const $f639ba30c8310bf2$export$ef1244b182aaad16 = async (url, since, until, tagFilters)=>{
    let paramedUrl = `${url}?since=${encodeURIComponent($f639ba30c8310bf2$var$msToRFCString(since))}`;
    if (until) paramedUrl += `&until=${encodeURIComponent($f639ba30c8310bf2$var$msToRFCString(until))}`;
    if (tagFilters.length) for (const t of tagFilters)paramedUrl += `&tag=${encodeURIComponent((0, $53b1df725ed2947c$export$9e9d7abe91c393de)(t))}`;
    const { data: data } = await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
        method: 'GET',
        url: paramedUrl
    });
    return data.annotations.map($f639ba30c8310bf2$var$annoToMillisecond);
};
const $f639ba30c8310bf2$export$a193961559973879 = async (annotation)=>{
    const url = annotation.links.self;
    await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
        method: 'DELETE',
        url: url
    });
};
const $f639ba30c8310bf2$export$a0d1273a43af0f5a = async (annotation)=>{
    const url = annotation.links.self;
    const data = $f639ba30c8310bf2$var$annoToRFC(annotation);
    await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
        method: 'PATCH',
        url: url,
        data: data
    });
};




var $0f7af1bd1239a074$export$1e511d4a378977f5;
var $0f7af1bd1239a074$export$281bff7f05488aa2;
var $0f7af1bd1239a074$export$5943f4447f6ef248;
var $0f7af1bd1239a074$export$75979cfcd91bf38f;
var $0f7af1bd1239a074$export$595d22ed68ca2841;
'use strict';
$0f7af1bd1239a074$export$1e511d4a378977f5 = true;
$0f7af1bd1239a074$export$281bff7f05488aa2 = $0f7af1bd1239a074$var$defaultMemoize;
$0f7af1bd1239a074$export$5943f4447f6ef248 = $0f7af1bd1239a074$var$createSelectorCreator;
$0f7af1bd1239a074$export$75979cfcd91bf38f = $0f7af1bd1239a074$var$createStructuredSelector;
function $0f7af1bd1239a074$var$defaultEqualityCheck(a, b) {
    return a === b;
}
function $0f7af1bd1239a074$var$areArgumentsShallowlyEqual(equalityCheck, prev, next) {
    if (prev === null || next === null || prev.length !== next.length) return false;
    // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
    var length = prev.length;
    for(var i = 0; i < length; i++){
        if (!equalityCheck(prev[i], next[i])) return false;
    }
    return true;
}
function $0f7af1bd1239a074$var$defaultMemoize(func) {
    var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $0f7af1bd1239a074$var$defaultEqualityCheck;
    var lastArgs = null;
    var lastResult = null;
    // we reference arguments instead of spreading them for performance reasons
    return function() {
        if (!$0f7af1bd1239a074$var$areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) // apply arguments instead of spreading for performance.
        lastResult = func.apply(null, arguments);
        lastArgs = arguments;
        return lastResult;
    };
}
function $0f7af1bd1239a074$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === 'function';
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep;
        }).join(', ');
        throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
    }
    return dependencies;
}
function $0f7af1bd1239a074$var$createSelectorCreator(memoize) {
    for(var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptions[_key - 1] = arguments[_key];
    return function() {
        for(var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var recomputations = 0;
        var resultFunc = funcs.pop();
        var dependencies = $0f7af1bd1239a074$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(undefined, [
            function() {
                recomputations++;
                // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(memoizeOptions));
        // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = $0f7af1bd1239a074$var$defaultMemoize(function() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            params.push(dependencies[i].apply(null, arguments));
            // apply arguments instead of spreading for performance.
            return memoizedResultFunc.apply(null, params);
        });
        selector.resultFunc = resultFunc;
        selector.recomputations = function() {
            return recomputations;
        };
        selector.resetRecomputations = function() {
            return recomputations = 0;
        };
        return selector;
    };
}
var $0f7af1bd1239a074$var$createSelector = $0f7af1bd1239a074$export$595d22ed68ca2841 = $0f7af1bd1239a074$var$createSelectorCreator($0f7af1bd1239a074$var$defaultMemoize);
function $0f7af1bd1239a074$var$createStructuredSelector(selectors) {
    var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $0f7af1bd1239a074$var$createSelector;
    if (typeof selectors !== 'object') throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
    var objectKeys = Object.keys(selectors);
    return selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
}



const $eeeaf526f24e9bde$var$getAnnotationsById = (state)=>state.annotations.annotations;
const $eeeaf526f24e9bde$var$getDisplaySetting = (state)=>state.app.persisted.annotationsDisplaySetting;
const $eeeaf526f24e9bde$export$5d1d3c74879025e4 = (0, $0f7af1bd1239a074$export$595d22ed68ca2841)($eeeaf526f24e9bde$var$getAnnotationsById, $eeeaf526f24e9bde$var$getDisplaySetting, (annotationsById, annotationsDisplaySetting)=>{
    if (annotationsDisplaySetting === (0, $0714a56b2816a4c7$export$e62cccb760c33405).HideAnnotations) return [];
    return Object.values(annotationsById).filter((a)=>!!a);
});
const $eeeaf526f24e9bde$var$getTagFiltersById = (state, dashboardID)=>state.annotations.tagFilters[dashboardID];
const $eeeaf526f24e9bde$export$16e65df6d1ee4126 = (0, $0f7af1bd1239a074$export$595d22ed68ca2841)($eeeaf526f24e9bde$var$getTagFiltersById, (tagFiltersById)=>{
    return Object.values(tagFiltersById || {}).filter((v)=>!!v);
});
const $eeeaf526f24e9bde$export$39a7b01bba763513 = (0, $0f7af1bd1239a074$export$595d22ed68ca2841)($eeeaf526f24e9bde$export$16e65df6d1ee4126, (tagFilters)=>{
    return tagFilters.filter((t)=>t.filterType === (0, $0714a56b2816a4c7$export$34a76716dc6df022).Equals).reduce((acc, t)=>({
            ...acc,
            [t.tagKey]: t.tagValue
        }), {});
});




const $d86454733477636e$export$fe73f2cc6771a40f = (state, dashboardID)=>state.dashTimeV1.ranges.find((r)=>r.dashboardID === dashboardID) || (0, $6a7b0ae94f8ec28f$export$350d83d6c59c55f7);
const $d86454733477636e$export$db55aefb333a1ced = (state, dashboardID)=>{
    const { refreshRate: refreshRate = (0, $e10a8602f56394e3$export$da42707f023260f8) } = state.dashTimeV1.refreshes.find((refr)=>refr.dashboardID === dashboardID) || {};
    return refreshRate;
};








const $fa0d0f2e90b47171$export$f0f23d51e0fdcf17 = ()=>({
        type: 'EDITING_ANNOTATION'
    });
const $fa0d0f2e90b47171$export$29606ee39da5bcdf = ()=>({
        type: 'DISMISS_EDITING_ANNOTATION'
    });
const $fa0d0f2e90b47171$export$3dbce9299df8a230 = ()=>({
        type: 'ADDING_ANNOTATION'
    });
const $fa0d0f2e90b47171$export$c0457b78d99df4ac = ()=>({
        type: 'ADDING_ANNOTATION_SUCCESS'
    });
const $fa0d0f2e90b47171$export$b6196d50b015cc18 = ()=>({
        type: 'DISMISS_ADDING_ANNOTATION'
    });
const $fa0d0f2e90b47171$export$560b55fbe45ae499 = ()=>({
        type: 'MOUSEENTER_TEMP_ANNOTATION'
    });
const $fa0d0f2e90b47171$export$c60dbed701abcae5 = ()=>({
        type: 'MOUSELEAVE_TEMP_ANNOTATION'
    });
const $fa0d0f2e90b47171$export$120134fdce164aea = (annotations)=>({
        type: 'SET_ANNOTATIONS',
        payload: {
            annotations: annotations
        }
    });
const $fa0d0f2e90b47171$export$a0d1273a43af0f5a = (annotation)=>({
        type: 'UPDATE_ANNOTATION',
        payload: {
            annotation: annotation
        }
    });
const $fa0d0f2e90b47171$export$9d88a6218867f830 = (annotation)=>({
        type: 'SET_ADDING_ANNOTATION',
        payload: annotation
    });
const $fa0d0f2e90b47171$export$a193961559973879 = (annotation)=>({
        type: 'DELETE_ANNOTATION',
        payload: {
            annotation: annotation
        }
    });
const $fa0d0f2e90b47171$export$96447d1aec912558 = (annotation)=>({
        type: 'ADD_ANNOTATION',
        payload: {
            annotation: annotation
        }
    });
const $fa0d0f2e90b47171$export$25e35a3d0d8da4da = (id)=>({
        type: 'SET_EDITING_ANNOTATION',
        payload: id
    });
const $fa0d0f2e90b47171$export$fc64c54f0e1d3b9e = (dashboardID, tagFilter)=>({
        type: 'UPDATE_TAG_FILTER',
        payload: {
            dashboardID: dashboardID,
            tagFilter: tagFilter
        }
    });
const $fa0d0f2e90b47171$export$219928f238b0bf3f = (dashboardID, tagFilter)=>({
        type: 'DELETE_TAG_FILTER',
        payload: {
            dashboardID: dashboardID,
            tagFilter: tagFilter
        }
    });
const $fa0d0f2e90b47171$export$907079e2e957715f = (tagKeys)=>({
        type: 'SET_TAG_KEYS',
        payload: tagKeys
    });
const $fa0d0f2e90b47171$export$863d6f22f704f044 = (tagKey, tagValues)=>({
        type: 'SET_TAG_VALUES',
        payload: {
            tagKey: tagKey,
            tagValues: tagValues
        }
    });
const $fa0d0f2e90b47171$export$a1c2cacba2645386 = (setting)=>({
        type: 'SET_ANNOTATIONS_DISPLAY_SETTING',
        payload: setting
    });
const $fa0d0f2e90b47171$export$f53e579da2356fd6 = (createUrl, annotation)=>async (dispatch)=>{
        dispatch($fa0d0f2e90b47171$export$96447d1aec912558(annotation));
        try {
            const savedAnnotation = await $f639ba30c8310bf2$export$51eda81011da4982(createUrl, annotation);
            dispatch($fa0d0f2e90b47171$export$a193961559973879(annotation));
            dispatch($fa0d0f2e90b47171$export$96447d1aec912558(savedAnnotation));
        } catch  {
            dispatch($fa0d0f2e90b47171$export$a193961559973879(annotation));
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$1fd9c65b41098040)('Error saving annotation')));
        }
    };
const $fa0d0f2e90b47171$export$fafa59bd2ee01f48 = (indexUrl, dashboardID)=>async (dispatch, getState)=>{
        const { annotationsDisplaySetting: annotationsDisplaySetting } = getState().app.persisted;
        if (annotationsDisplaySetting === (0, $0714a56b2816a4c7$export$e62cccb760c33405).HideAnnotations) return;
        const timeRange = (0, $d86454733477636e$export$fe73f2cc6771a40f)(getState(), dashboardID);
        const { since: since, until: until } = (0, $78d6d6f4dd3e1375$export$c7f613ca34819a31)(timeRange);
        const tagFilters = (0, $eeeaf526f24e9bde$export$16e65df6d1ee4126)(getState(), dashboardID);
        const annotations = await $f639ba30c8310bf2$export$ef1244b182aaad16(indexUrl, since, until, tagFilters);
        dispatch($fa0d0f2e90b47171$export$120134fdce164aea(annotations));
    };
const $fa0d0f2e90b47171$export$ea09476dbc4c7660 = (annotation)=>async (dispatch)=>{
        try {
            dispatch($fa0d0f2e90b47171$export$a193961559973879(annotation));
            await $f639ba30c8310bf2$export$a193961559973879(annotation);
        } catch  {
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$1fd9c65b41098040)('Error deleting annotation')));
            dispatch($fa0d0f2e90b47171$export$96447d1aec912558(annotation));
        }
    };
const $fa0d0f2e90b47171$export$c5f1221ab1e036d0 = (annotation)=>async (dispatch)=>{
        try {
            await $f639ba30c8310bf2$export$a0d1273a43af0f5a(annotation);
            dispatch($fa0d0f2e90b47171$export$a0d1273a43af0f5a(annotation));
        } catch  {
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$1fd9c65b41098040)('Error saving annotation')));
        }
    };
const $fa0d0f2e90b47171$export$359b5cf394a2d642 = (indexURL, dashboardID, tagFilter)=>async (dispatch, getState)=>{
        const state = getState().annotations;
        const currentTagFilter = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(state, `${dashboardID}.${tagFilter.id}`, null);
        const isNew = !currentTagFilter;
        try {
            dispatch($fa0d0f2e90b47171$export$fc64c54f0e1d3b9e(dashboardID, tagFilter));
            await $fa0d0f2e90b47171$export$fafa59bd2ee01f48(indexURL, dashboardID)(dispatch, getState);
        } catch  {
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$1fd9c65b41098040)('Error saving tag filter')));
            if (isNew) dispatch($fa0d0f2e90b47171$export$219928f238b0bf3f(dashboardID, tagFilter));
            else dispatch($fa0d0f2e90b47171$export$fc64c54f0e1d3b9e(dashboardID, currentTagFilter));
        }
    };
const $fa0d0f2e90b47171$export$e0d940591f229d7f = (indexURL, dashboardID, tagFilter)=>async (dispatch, getState)=>{
        try {
            dispatch($fa0d0f2e90b47171$export$219928f238b0bf3f(dashboardID, tagFilter));
            await $fa0d0f2e90b47171$export$fafa59bd2ee01f48(indexURL, dashboardID)(dispatch, getState);
        } catch  {
            dispatch($fa0d0f2e90b47171$export$fc64c54f0e1d3b9e(dashboardID, tagFilter));
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$1fd9c65b41098040)('Error deleting tag filter')));
        }
    };
const $fa0d0f2e90b47171$export$3e0c61203e6f47fc = (source)=>async (dispatch)=>{
        const query = 'SHOW TAG KEYS ON chronograf FROM annotations';
        const resp = await (0, $aea829e093f1eddb$export$923f96dd5afa9ce6)({
            query: query,
            source: source
        });
        const tagKeys = (0, $82bb95c5c6d74105$export$952c8ad1655ff67d)(query, resp.data).filter((keys)=>!(0, $53b1df725ed2947c$export$f35938869845200f).includes(keys));
        dispatch($fa0d0f2e90b47171$export$907079e2e957715f(tagKeys));
    };
const $fa0d0f2e90b47171$export$bafb7deb947f563e = (source, tagKey)=>async (dispatch)=>{
        const query = `SHOW TAG VALUES ON chronograf FROM annotations WITH KEY = "${tagKey}"`;
        const resp = await (0, $aea829e093f1eddb$export$923f96dd5afa9ce6)({
            query: query,
            source: source
        });
        const tagValues = (0, $82bb95c5c6d74105$export$952c8ad1655ff67d)(query, resp.data);
        dispatch($fa0d0f2e90b47171$export$863d6f22f704f044(tagKey, tagValues));
    };



var $NdCUR = parcelRequire("NdCUR");


var $axd2S = parcelRequire("axd2S");

var $1v7mg = parcelRequire("1v7mg");

var $NdCUR = parcelRequire("NdCUR");





class $a0c93b862ec3ec9b$var$AnnotationTagsDropdown extends (0, $NdCUR.PureComponent) {
    render() {
        const { tags: tags } = this.props;
        const entries = Object.entries(tags);
        const pluralizer = entries.length === 1 ? '' : 's';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "annotation-tag-count"
        }, entries.length, " Tag", pluralizer, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "annotation-tooltip--tags"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "annotation-tooltip--tags-list"
        }, entries.map(([tagKey, tagValue])=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
                key: `${tagKey} = ${tagValue}`,
                onClick: this.handleAddTagFilter(tagKey, tagValue)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("strong", null, tagKey, ":"), " ", tagValue)))));
    }
    constructor(...args){
        super(...args), this.handleAddTagFilter = (tagKey, tagValue)=>()=>{
                const { annotationsIndexURL: annotationsIndexURL, onUpdateTagFilterAsync: onUpdateTagFilterAsync } = this.props;
                const { dashboardID: dashboardID } = this.props.params;
                const newTagFilter = {
                    id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
                    tagKey: tagKey,
                    tagValue: tagValue,
                    filterType: (0, $0714a56b2816a4c7$export$34a76716dc6df022).Equals
                };
                onUpdateTagFilterAsync(annotationsIndexURL, dashboardID, newTagFilter);
            };
    }
}
const $a0c93b862ec3ec9b$var$mstp = (state, ownProps)=>{
    const { sourceID: sourceID } = ownProps.params;
    const source = state.sources.find((s)=>s.id = sourceID);
    if (!source) throw new Error('Could not find current source');
    return {
        annotationsIndexURL: source.links.annotations
    };
};
const $a0c93b862ec3ec9b$var$mdtp = {
    onUpdateTagFilterAsync: (0, $fa0d0f2e90b47171$export$359b5cf394a2d642)
};
var $a0c93b862ec3ec9b$export$2e2bcd8739ae039 = (0, $dffbdf89c590a961$export$2e2bcd8739ae039)((0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($a0c93b862ec3ec9b$var$mstp, $a0c93b862ec3ec9b$var$mdtp)($a0c93b862ec3ec9b$var$AnnotationTagsDropdown));




const $eade2e1efefbf7e6$var$TimeStamp = ({ time: time })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "annotation-tooltip--timestamp"
    }, `${(0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(time).format('YYYY/MM/DD HH:mm:ss.SS')}`);
const $eade2e1efefbf7e6$var$AnnotationTooltip = (props)=>{
    const { annotation: annotation, onMouseLeave: onMouseLeave, timestamp: timestamp, annotationState: { isDragging: isDragging, isMouseOver: isMouseOver }, onSetEditingAnnotation: onSetEditingAnnotation, isUsingAuth: isUsingAuth, me: me } = props;
    const tooltipClass = (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('annotation-tooltip', {
        hidden: !(isDragging || isMouseOver)
    });
    const setEditing = ()=>onSetEditingAnnotation(annotation.id);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        id: `tooltip-${annotation.id}`,
        onMouseLeave: onMouseLeave,
        className: tooltipClass
    }, isDragging ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($eade2e1efefbf7e6$var$TimeStamp, {
        time: timestamp
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "annotation-tooltip--items"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "annotation-tooltip-text"
    }, annotation.text, !isUsingAuth || (0, $a7910b1002260d34$export$7d499847c5200082)(me.role, (0, $a7910b1002260d34$export$1d39a112fd67439d)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        className: "annotation-tooltip--edit icon pencil",
        onClick: setEditing
    }) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "annotation-tooltip--lower"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($eade2e1efefbf7e6$var$TimeStamp, {
        time: timestamp
    }), !!annotation.tags && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a0c93b862ec3ec9b$export$2e2bcd8739ae039), {
        tags: annotation.tags
    }))));
};
const $eade2e1efefbf7e6$var$mstp = ({ auth: { isUsingAuth: isUsingAuth, me: me } })=>({
        isUsingAuth: isUsingAuth,
        me: me
    });
const $eade2e1efefbf7e6$var$mdtp = {
    onSetEditingAnnotation: (0, $fa0d0f2e90b47171$export$25e35a3d0d8da4da)
};
var $eade2e1efefbf7e6$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($eade2e1efefbf7e6$var$mstp, $eade2e1efefbf7e6$var$mdtp)($eade2e1efefbf7e6$var$AnnotationTooltip);



class $3a87a8f678f92cb7$var$AnnotationPoint extends (0, $NdCUR.Component) {
    static{
        this.defaultProps = {
            staticLegendHeight: 0
        };
    }
    render() {
        const { annotation: annotation } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.markerClass,
            style: this.markerStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.clickClass,
            draggable: true,
            onDrag: this.handleDrag,
            onDragStart: this.handleDragStart,
            onDragEnd: this.handleDragEnd,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.flagClass,
            style: this.flagStyle
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $eade2e1efefbf7e6$export$2e2bcd8739ae039), {
            timestamp: annotation.startTime,
            annotation: annotation,
            onMouseLeave: this.handleMouseLeave,
            annotationState: this.state
        }));
    }
    get markerStyle() {
        const { annotation: annotation, dygraph: dygraph, staticLegendHeight: staticLegendHeight } = this.props;
        const left = `${dygraph.toDomXCoord(Number(annotation.startTime)) + (0, $e10a8602f56394e3$export$11baccdc2aa05859)}px`;
        const height = `calc(100% - ${staticLegendHeight + (0, $e10a8602f56394e3$export$c48e77fd29ce0e07) + (0, $e10a8602f56394e3$export$50de07a219eb9c8c) * 2}px)`;
        const backgroundColor = annotation.color || undefined;
        return {
            left: left,
            height: height,
            backgroundColor: backgroundColor
        };
    }
    get flagStyle() {
        return {
            backgroundColor: this.props.annotation.color || undefined
        };
    }
    get markerClass() {
        const { isDragging: isDragging, isMouseOver: isMouseOver } = this.state;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('annotation', {
            dragging: isDragging,
            expanded: isMouseOver
        });
    }
    get clickClass() {
        const isEditing = this.props.mode === (0, $53b1df725ed2947c$export$2d5490e5c1c94328);
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('annotation--click-area', {
            editing: isEditing
        });
    }
    get flagClass() {
        const { isDragging: isDragging } = this.state;
        if (isDragging) return 'annotation-point--flag__dragging';
        return 'annotation-point--flag';
    }
    constructor(...args){
        super(...args), this.state = {
            isMouseOver: false,
            isDragging: false
        }, this.handleMouseEnter = ()=>{
            this.setState({
                isMouseOver: true
            });
        }, this.handleMouseLeave = (e)=>{
            const { annotation: annotation } = this.props;
            if (e.relatedTarget instanceof Element) {
                if (e.relatedTarget.id === `tooltip-${annotation.id}`) return this.setState({
                    isDragging: false
                });
            }
            this.setState({
                isMouseOver: false
            });
        }, this.handleDragStart = ()=>{
            this.setState({
                isDragging: true
            });
        }, this.handleDragEnd = ()=>{
            const { annotation: annotation, updateAnnotationAsync: updateAnnotationAsync } = this.props;
            updateAnnotationAsync(annotation);
            this.setState({
                isDragging: false
            });
        }, this.handleDrag = (e)=>{
            if (this.props.mode !== (0, $53b1df725ed2947c$export$2d5490e5c1c94328)) return;
            const { pageX: pageX } = e;
            const { annotation: annotation, dygraph: dygraph, updateAnnotation: updateAnnotation } = this.props;
            if (pageX === 0) return;
            const { startTime: startTime } = annotation;
            const { left: left } = dygraph.graphDiv.getBoundingClientRect();
            const [startX, endX] = dygraph.xAxisRange();
            const graphX = pageX - left;
            let newTime = dygraph.toDataXCoord(graphX);
            const oldTime = +startTime;
            if (Math.abs(dygraph.toPercentXCoord(newTime) - dygraph.toPercentXCoord(oldTime)) * 100 < (0, $53b1df725ed2947c$export$e4076c0612d5486)) return;
            if (newTime >= endX) newTime = endX;
            if (newTime <= startX) newTime = startX;
            updateAnnotation({
                ...annotation,
                startTime: newTime,
                endTime: newTime
            });
            e.preventDefault();
            e.stopPropagation();
        };
    }
}
const $3a87a8f678f92cb7$var$mdtp = {
    updateAnnotationAsync: $fa0d0f2e90b47171$export$c5f1221ab1e036d0,
    updateAnnotation: $fa0d0f2e90b47171$export$a0d1273a43af0f5a
};
var $3a87a8f678f92cb7$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)(null, $3a87a8f678f92cb7$var$mdtp)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($3a87a8f678f92cb7$var$AnnotationPoint));



var $NdCUR = parcelRequire("NdCUR");






var $NdCUR = parcelRequire("NdCUR");

const $79e7f0012fbe27b8$var$windowDimensions = (anno, dygraph, staticLegendHeight)=>{
    // TODO: export and test this function
    const [startX, endX] = dygraph.xAxisRange();
    const startTime = Math.max(+anno.startTime, startX);
    const endTime = Math.min(+anno.endTime, endX);
    const windowStartXCoord = dygraph.toDomXCoord(startTime);
    const windowEndXCoord = dygraph.toDomXCoord(endTime);
    const windowWidth = Math.abs(windowEndXCoord - windowStartXCoord);
    const windowLeftXCoord = Math.min(windowStartXCoord, windowEndXCoord) + (0, $e10a8602f56394e3$export$11baccdc2aa05859);
    const height = staticLegendHeight ? `calc(100% - ${staticLegendHeight + (0, $e10a8602f56394e3$export$c48e77fd29ce0e07) + (0, $e10a8602f56394e3$export$50de07a219eb9c8c) * 2}px)` : 'calc(100% - 36px)';
    return {
        left: `${windowLeftXCoord}px`,
        width: `${windowWidth}px`,
        height: height
    };
};
const $79e7f0012fbe27b8$var$AnnotationWindow = ({ annotation: annotation, dygraph: dygraph, active: active, staticLegendHeight: staticLegendHeight })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: `annotation-window${active ? ' active' : ''}`,
        style: $79e7f0012fbe27b8$var$windowDimensions(annotation, dygraph, staticLegendHeight)
    });
var $79e7f0012fbe27b8$export$2e2bcd8739ae039 = $79e7f0012fbe27b8$var$AnnotationWindow;



class $82cc4dab182376b0$var$AnnotationSpan extends (0, $NdCUR.Component) {
    static{
        this.defaultProps = {
            staticLegendHeight: 0
        };
    }
    render() {
        const { annotation: annotation, dygraph: dygraph, staticLegendHeight: staticLegendHeight } = this.props;
        const { isDragging: isDragging } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $79e7f0012fbe27b8$export$2e2bcd8739ae039), {
            annotation: annotation,
            dygraph: dygraph,
            active: !!isDragging,
            staticLegendHeight: staticLegendHeight
        }), this.renderLeftMarker(annotation.startTime, dygraph), this.renderRightMarker(annotation.endTime, dygraph));
    }
    renderLeftMarker(startTime, dygraph) {
        const isEditing = this.props.mode === (0, $53b1df725ed2947c$export$2d5490e5c1c94328);
        const { isDragging: isDragging, isMouseOver: isMouseOver } = this.state;
        const { annotation: annotation, staticLegendHeight: staticLegendHeight } = this.props;
        const flagClass = isDragging ? 'annotation-span--left-flag dragging' : 'annotation-span--left-flag';
        const flagStyle = {
            borderLeftColor: annotation.color || undefined
        };
        const markerClass = isDragging ? 'annotation dragging' : 'annotation';
        const clickClass = isEditing ? 'annotation--click-area editing' : 'annotation--click-area';
        const leftBound = dygraph.xAxisRange()[0];
        if (startTime < leftBound) return null;
        const showTooltip = isDragging === 'left' || isMouseOver === 'left';
        const markerStyles = {
            left: `${dygraph.toDomXCoord(startTime) + (0, $e10a8602f56394e3$export$11baccdc2aa05859)}px`,
            backgroundColor: annotation.color || undefined,
            height: `calc(100% - ${staticLegendHeight + (0, $e10a8602f56394e3$export$c48e77fd29ce0e07) + (0, $e10a8602f56394e3$export$50de07a219eb9c8c) * 2}px)`
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: markerClass,
            style: markerStyles
        }, showTooltip && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $eade2e1efefbf7e6$export$2e2bcd8739ae039), {
            timestamp: annotation.startTime,
            annotation: annotation,
            onMouseLeave: this.handleMouseLeave,
            annotationState: this.state
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: clickClass,
            draggable: true,
            onDrag: this.handleDrag('startTime'),
            onDragStart: this.handleDragStart('left'),
            onDragEnd: this.handleDragEnd,
            onMouseEnter: this.handleMouseEnter('left'),
            onMouseLeave: this.handleMouseLeave
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: flagClass,
            style: flagStyle
        }));
    }
    renderRightMarker(endTime, dygraph) {
        const isEditing = this.props.mode === (0, $53b1df725ed2947c$export$2d5490e5c1c94328);
        const { isDragging: isDragging, isMouseOver: isMouseOver } = this.state;
        const { annotation: annotation, staticLegendHeight: staticLegendHeight } = this.props;
        const flagClass = isDragging ? 'annotation-span--right-flag dragging' : 'annotation-span--right-flag';
        const flagStyle = {
            borderRightColor: annotation.color || undefined
        };
        const markerClass = isDragging ? 'annotation dragging' : 'annotation';
        const clickClass = isEditing ? 'annotation--click-area editing' : 'annotation--click-area';
        const rightBound = dygraph.xAxisRange()[1];
        if (rightBound < endTime) return null;
        const showTooltip = isDragging === 'right' || isMouseOver === 'right';
        const markerStyles = {
            left: `${dygraph.toDomXCoord(endTime) + (0, $e10a8602f56394e3$export$11baccdc2aa05859)}px`,
            backgroundColor: annotation.color || undefined,
            height: `calc(100% - ${staticLegendHeight + (0, $e10a8602f56394e3$export$c48e77fd29ce0e07) + (0, $e10a8602f56394e3$export$50de07a219eb9c8c) * 2}px)`
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: markerClass,
            style: markerStyles
        }, showTooltip && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $eade2e1efefbf7e6$export$2e2bcd8739ae039), {
            timestamp: annotation.endTime,
            annotation: annotation,
            onMouseLeave: this.handleMouseLeave,
            annotationState: this.state
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: clickClass,
            draggable: true,
            onDrag: this.handleDrag('endTime'),
            onDragStart: this.handleDragStart('right'),
            onDragEnd: this.handleDragEnd,
            onMouseEnter: this.handleMouseEnter('right'),
            onMouseLeave: this.handleMouseLeave
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: flagClass,
            style: flagStyle
        }));
    }
    constructor(...args){
        super(...args), this.state = {
            isDragging: null,
            isMouseOver: null
        }, this.handleMouseEnter = (direction)=>()=>{
                this.setState({
                    isMouseOver: direction
                });
            }, this.handleMouseLeave = (e)=>{
            const { annotation: annotation } = this.props;
            if (e.relatedTarget instanceof Element) {
                if (e.relatedTarget.id === `tooltip-${annotation.id}`) return this.setState({
                    isDragging: null
                });
            }
            this.setState({
                isMouseOver: null
            });
        }, this.handleDragStart = (direction)=>()=>{
                this.setState({
                    isDragging: direction
                });
            }, this.handleDragEnd = ()=>{
            const { annotation: annotation, updateAnnotationAsync: updateAnnotationAsync } = this.props;
            const [startTime, endTime] = [
                annotation.startTime,
                annotation.endTime
            ].sort();
            const newAnnotation = {
                ...annotation,
                startTime: startTime,
                endTime: endTime
            };
            updateAnnotationAsync(newAnnotation);
            this.setState({
                isDragging: null
            });
        }, this.handleDrag = (timeProp)=>(e)=>{
                if (this.props.mode !== (0, $53b1df725ed2947c$export$2d5490e5c1c94328)) return;
                const { pageX: pageX } = e;
                const { annotation: annotation, dygraph: dygraph, updateAnnotation: updateAnnotation } = this.props;
                if (pageX === 0) return;
                const oldTime = +annotation[timeProp];
                const { left: left } = dygraph.graphDiv.getBoundingClientRect();
                const [startX, endX] = dygraph.xAxisRange();
                const graphX = pageX - left;
                let newTime = dygraph.toDataXCoord(graphX);
                if (Math.abs(dygraph.toPercentXCoord(newTime) - dygraph.toPercentXCoord(oldTime)) * 100 < (0, $53b1df725ed2947c$export$e4076c0612d5486)) return;
                if (newTime >= endX) newTime = endX;
                if (newTime <= startX) newTime = startX;
                updateAnnotation({
                    ...annotation,
                    [timeProp]: `${newTime}`
                });
                e.preventDefault();
                e.stopPropagation();
            };
    }
}
const $82cc4dab182376b0$var$mapDispatchToProps = {
    updateAnnotationAsync: $fa0d0f2e90b47171$export$c5f1221ab1e036d0,
    updateAnnotation: $fa0d0f2e90b47171$export$a0d1273a43af0f5a
};
var $82cc4dab182376b0$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)(null, $82cc4dab182376b0$var$mapDispatchToProps)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($82cc4dab182376b0$var$AnnotationSpan));


const $e5ef61785a9c81e1$var$Annotation = ({ mode: mode, dygraph: dygraph, xAxisRange: xAxisRange, annotation: annotation, staticLegendHeight: staticLegendHeight })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null, annotation.startTime === annotation.endTime ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $3a87a8f678f92cb7$export$2e2bcd8739ae039), {
        mode: mode,
        dygraph: dygraph,
        annotation: annotation,
        staticLegendHeight: staticLegendHeight,
        xAxisRange: xAxisRange
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $82cc4dab182376b0$export$2e2bcd8739ae039), {
        mode: mode,
        dygraph: dygraph,
        annotation: annotation,
        staticLegendHeight: staticLegendHeight,
        xAxisRange: xAxisRange
    }));
var $e5ef61785a9c81e1$export$2e2bcd8739ae039 = $e5ef61785a9c81e1$var$Annotation;



var $NdCUR = parcelRequire("NdCUR");


var $1v7mg = parcelRequire("1v7mg");







const $c8b84b4dfcf7c961$var$INITIAL_X_COORD = 100;
class $c8b84b4dfcf7c961$var$NewAnnotation extends (0, $NdCUR.Component) {
    constructor(props){
        super(props), this.clampWithinGraphTimerange = (timestamp)=>{
            const [xRangeStart] = this.props.dygraph.xAxisRange();
            return Math.max(xRangeStart, timestamp);
        }, this.eventToTimestamp = ({ pageX: pxBetweenMouseAndPage })=>{
            const { left: pxBetweenGraphAndPage } = this.wrapperRef.current.getBoundingClientRect();
            const graphXCoordinate = pxBetweenMouseAndPage - pxBetweenGraphAndPage;
            const timestamp = this.props.dygraph.toDataXCoord(graphXCoordinate);
            const clamped = this.clampWithinGraphTimerange(timestamp);
            return clamped;
        }, this.handleMouseDown = (e)=>{
            const startTime = this.eventToTimestamp(e);
            this.props.onSetAddingAnnotation({
                ...this.props.addingAnnotation,
                startTime: startTime
            });
            this.setState({
                gatherMode: 'endTime'
            });
        }, this.handleMouseMove = (e)=>{
            if (this.props.isTempHovering === false) return;
            const { addingAnnotation: addingAnnotation, onSetAddingAnnotation: onSetAddingAnnotation } = this.props;
            const newTime = this.eventToTimestamp(e);
            if (this.state.gatherMode === 'startTime') onSetAddingAnnotation({
                ...addingAnnotation,
                startTime: newTime,
                endTime: newTime
            });
            else onSetAddingAnnotation({
                ...addingAnnotation,
                endTime: newTime
            });
        }, this.handleMouseUp = (e)=>{
            const { addingAnnotation: addingAnnotation, onSetAddingAnnotation: onSetAddingAnnotation, onAddAnnotationAsync: onAddAnnotationAsync, onAddingAnnotationSuccess: onAddingAnnotationSuccess, onMouseLeaveTempAnnotation: onMouseLeaveTempAnnotation, source: source, annotationTags: annotationTags } = this.props;
            const createUrl = source.links.annotations;
            const upTime = this.eventToTimestamp(e);
            const downTime = addingAnnotation.startTime;
            const [startTime, endTime] = [
                downTime,
                upTime
            ].sort();
            const newAnnotation = {
                ...addingAnnotation,
                startTime: startTime,
                endTime: endTime,
                tags: annotationTags
            };
            onSetAddingAnnotation(newAnnotation);
            onAddAnnotationAsync(createUrl, {
                ...newAnnotation,
                id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)()
            });
            onAddingAnnotationSuccess();
            onMouseLeaveTempAnnotation();
            this.setState({
                isMouseOver: false,
                gatherMode: 'startTime'
            });
        }, this.handleMouseOver = (e)=>{
            this.setState({
                isMouseOver: true
            });
            this.handleMouseMove(e);
            this.props.onMouseEnterTempAnnotation();
        }, this.handleMouseLeave = ()=>{
            this.setState({
                isMouseOver: false
            });
            this.props.onMouseLeaveTempAnnotation();
        };
        this.wrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createRef();
        this.state = {
            isMouseOver: false,
            gatherMode: 'startTime'
        };
    }
    render() {
        const { dygraph: dygraph, isTempHovering: isTempHovering, addingAnnotation: addingAnnotation, addingAnnotation: { startTime: startTime, endTime: endTime }, staticLegendHeight: staticLegendHeight } = this.props;
        const initialTime = dygraph.toDataXCoord($c8b84b4dfcf7c961$var$INITIAL_X_COORD);
        const resolvedStartTime = startTime ? startTime : initialTime;
        const resolvedEndTime = endTime ? endTime : initialTime;
        const { isMouseOver: isMouseOver } = this.state;
        const crosshairOne = Math.max(-1000, dygraph.toDomXCoord(resolvedStartTime));
        const crosshairTwo = dygraph.toDomXCoord(resolvedEndTime);
        const crosshairHeight = `calc(100% - ${staticLegendHeight + (0, $e10a8602f56394e3$export$c48e77fd29ce0e07)}px)`;
        const isDragging = resolvedStartTime !== resolvedEndTime;
        const flagOneClass = crosshairOne < crosshairTwo ? 'annotation-span--left-flag dragging' : 'annotation-span--right-flag dragging';
        const flagTwoClass = crosshairOne < crosshairTwo ? 'annotation-span--right-flag dragging' : 'annotation-span--left-flag dragging';
        const pointFlagClass = 'annotation-point--flag__dragging';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null, isDragging && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $79e7f0012fbe27b8$export$2e2bcd8739ae039), {
            annotation: addingAnnotation,
            dygraph: dygraph,
            active: true,
            staticLegendHeight: staticLegendHeight
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('new-annotation', {
                hover: isTempHovering
            }),
            ref: this.wrapperRef,
            onMouseMove: this.handleMouseMove,
            onMouseOver: this.handleMouseOver,
            onMouseLeave: this.handleMouseLeave,
            onMouseUp: this.handleMouseUp,
            onMouseDown: this.handleMouseDown
        }, isDragging && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "new-annotation--crosshair",
            style: {
                left: crosshairTwo,
                height: crosshairHeight
            }
        }, isMouseOver && isDragging && this.renderTimestamp(resolvedEndTime), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: flagTwoClass
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "new-annotation--crosshair",
            style: {
                left: crosshairOne,
                height: crosshairHeight
            }
        }, isMouseOver && !isDragging && this.renderTimestamp(resolvedStartTime), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: isDragging ? flagOneClass : pointFlagClass
        }))));
    }
    renderTimestamp(time) {
        const timestamp = `${new Date(time)}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "new-annotation-tooltip"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "new-annotation-helper"
        }, "Click or Drag to Annotate"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "new-annotation-timestamp"
        }, timestamp));
    }
}
const $c8b84b4dfcf7c961$var$mstp = (state, ownProps)=>{
    const { dashboardID: dashboardID } = ownProps.params;
    // The new annotation will be created with tags derived from the current
    // dashboard's tag filters
    const annotationTags = (0, $eeeaf526f24e9bde$export$39a7b01bba763513)(state, dashboardID);
    return {
        annotationTags: annotationTags
    };
};
const $c8b84b4dfcf7c961$var$mdtp = {
    onAddAnnotationAsync: (0, $fa0d0f2e90b47171$export$f53e579da2356fd6),
    onSetAddingAnnotation: (0, $fa0d0f2e90b47171$export$9d88a6218867f830),
    onAddingAnnotationSuccess: (0, $fa0d0f2e90b47171$export$c0457b78d99df4ac),
    onMouseEnterTempAnnotation: (0, $fa0d0f2e90b47171$export$560b55fbe45ae499),
    onMouseLeaveTempAnnotation: (0, $fa0d0f2e90b47171$export$c60dbed701abcae5)
};
var $c8b84b4dfcf7c961$export$2e2bcd8739ae039 = (0, $dffbdf89c590a961$export$2e2bcd8739ae039)((0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($c8b84b4dfcf7c961$var$mstp, $c8b84b4dfcf7c961$var$mdtp)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($c8b84b4dfcf7c961$var$NewAnnotation)));






class $48ea0df480f2833d$var$Annotations extends (0, $NdCUR.Component) {
    render() {
        const { mode: mode, dWidth: dWidth, dygraph: dygraph, xAxisRange: xAxisRange, annotations: annotations, isTempHovering: isTempHovering, addingAnnotation: addingAnnotation, handleAddingAnnotationSuccess: handleAddingAnnotationSuccess, handleMouseEnterTempAnnotation: handleMouseEnterTempAnnotation, handleMouseLeaveTempAnnotation: handleMouseLeaveTempAnnotation, staticLegendHeight: staticLegendHeight } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "annotations-container"
        }, mode === (0, $53b1df725ed2947c$export$cd452f24a53287fb) && addingAnnotation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c8cd79e362cba2a4$export$5416f05742cfa18a).Consumer, null, (source)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c8b84b4dfcf7c961$export$2e2bcd8739ae039), {
                dygraph: dygraph,
                source: source,
                isTempHovering: isTempHovering,
                addingAnnotation: addingAnnotation,
                staticLegendHeight: staticLegendHeight,
                onAddingAnnotationSuccess: handleAddingAnnotationSuccess,
                onMouseEnterTempAnnotation: handleMouseEnterTempAnnotation,
                onMouseLeaveTempAnnotation: handleMouseLeaveTempAnnotation
            })), annotations.map((a)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $e5ef61785a9c81e1$export$2e2bcd8739ae039), {
                key: a.id,
                mode: mode,
                xAxisRange: xAxisRange,
                annotation: a,
                dygraph: dygraph,
                dWidth: dWidth,
                staticLegendHeight: staticLegendHeight
            })));
    }
}
const $48ea0df480f2833d$var$mstp = (state, props)=>{
    const { mode: mode, isTempHovering: isTempHovering, addingAnnotation: addingAnnotation } = state.annotations;
    const annotations = (0, $53b1df725ed2947c$export$adb3bb9e6761deb2)(props.xAxisRange, (0, $eeeaf526f24e9bde$export$5d1d3c74879025e4)(state));
    return {
        annotations: annotations,
        addingAnnotation: addingAnnotation,
        mode: mode || 'NORMAL',
        isTempHovering: isTempHovering
    };
};
var $48ea0df480f2833d$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($48ea0df480f2833d$var$mstp)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($48ea0df480f2833d$var$Annotations));



var $hBdgJ = parcelRequire("hBdgJ");

var $NdCUR = parcelRequire("NdCUR");



class $761aec314d6fe7e9$var$Crosshair extends (0, $NdCUR.PureComponent) {
    render() {
        if (!this.isVisible) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "crosshair-container"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "crosshair-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "crosshair",
            style: {
                transform: this.crosshairLeft,
                height: this.crosshairHeight
            }
        }));
    }
    get isVisible() {
        const { dygraph: dygraph, hoverTime: hoverTime } = this.props;
        const timeRanges = dygraph.xAxisRange();
        const minTimeRange = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(timeRanges, '0', 0);
        if (hoverTime <= minTimeRange) return false;
        const maxTimeRange = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(timeRanges, '1', Infinity);
        if (hoverTime >= maxTimeRange) return false;
        return hoverTime !== 0 && (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isFinite(hoverTime);
    }
    get crosshairLeft() {
        const { dygraph: dygraph, hoverTime: hoverTime } = this.props;
        const cursorOffset = 16;
        const translateX = Math.max(dygraph.toDomXCoord(hoverTime) + cursorOffset, cursorOffset);
        return `translateX(${translateX}px)`;
    }
    get crosshairHeight() {
        return `calc(100% - ${this.props.staticLegendHeight + (0, $e10a8602f56394e3$export$c48e77fd29ce0e07)}px)`;
    }
}
const $761aec314d6fe7e9$var$mapStateToProps = ({ dashboardUI: dashboardUI, annotations: { mode: mode } })=>({
        mode: mode,
        hoverTime: +dashboardUI.hoverTime
    });
var $761aec314d6fe7e9$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($761aec314d6fe7e9$var$mapStateToProps, null)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($761aec314d6fe7e9$var$Crosshair));



var $gO4UB = parcelRequire("gO4UB");
const $66e9028799656e9e$var$ADD_FACTOR = 1.1;
const $66e9028799656e9e$var$SUB_FACTOR = 0.9;
const $66e9028799656e9e$var$checkNumeric = (num)=>isFinite(num) ? num : null;
const $66e9028799656e9e$var$considerEmpty = (userNumber, num)=>{
    if (userNumber) return +userNumber;
    return num;
};
const $66e9028799656e9e$var$getRange = (timeSeries, userSelectedRange = [
    null,
    null
], ruleValues)=>{
    if (!ruleValues) ruleValues = {
        value: null,
        rangeValue: null,
        operator: ''
    };
    const { value: value, rangeValue: rangeValue, operator: operator } = ruleValues;
    const [uMin, uMax] = userSelectedRange;
    const userMin = $66e9028799656e9e$var$checkNumeric(uMin);
    const userMax = $66e9028799656e9e$var$checkNumeric(uMax);
    const addPad = (bigNum)=>bigNum.times($66e9028799656e9e$var$ADD_FACTOR).toNumber();
    const subPad = (bigNum)=>bigNum.times($66e9028799656e9e$var$SUB_FACTOR).toNumber();
    const pad = (v)=>{
        if (v === null || v === '' || !isFinite(v)) return null;
        const val = new (0, (/*@__PURE__*/$parcel$interopDefault($gO4UB)))(v);
        if (operator === 'less than') return val.lessThan(0) ? addPad(val) : subPad(val);
        return val.lessThan(0) ? subPad(val) : addPad(val);
    };
    const points = [
        ...timeSeries,
        [
            null,
            pad(value)
        ],
        [
            null,
            pad(rangeValue)
        ]
    ];
    const range = points.reduce(// eslint-disable-next-line @typescript-eslint/no-shadow
    ([min, max] = [], series)=>{
        for(let i = 1; i < series.length; i++){
            const val = series[i];
            if (max === null) max = val;
            if (min === null) min = val;
            if (typeof val === 'number') {
                min = Math.min(min, val);
                max = Math.max(max, val);
            }
        }
        return [
            min,
            max
        ];
    }, [
        null,
        null
    ]);
    const [calcMin, calcMax] = range;
    const min = $66e9028799656e9e$var$considerEmpty(userMin, calcMin);
    const max = $66e9028799656e9e$var$considerEmpty(userMax, calcMax);
    if (min === max) {
        if (min > 0) return [
            0,
            max
        ];
        if (min < 0) return [
            min,
            0
        ];
    }
    // prevents inversion of graph
    if (min > max) return [
        min,
        min + 1
    ];
    return [
        min,
        max
    ];
};
const $66e9028799656e9e$var$coerceToNum = (str)=>str ? +str : null;
const $66e9028799656e9e$export$a22b660adc6449cb = (bounds = [
    null,
    null
])=>[
        $66e9028799656e9e$var$coerceToNum(bounds[0]),
        $66e9028799656e9e$var$coerceToNum(bounds[1])
    ];
var $66e9028799656e9e$export$2e2bcd8739ae039 = $66e9028799656e9e$var$getRange;




var $hBdgJ = parcelRequire("hBdgJ");
const $d1eae937b60051ec$var$KMB_LABELS = [
    'K',
    'M',
    'B',
    'T',
    'Q'
];
const $d1eae937b60051ec$var$KMG2_BIG_LABELS = [
    'k',
    'M',
    'G',
    'T',
    'P',
    'E',
    'Z',
    'Y'
];
const $d1eae937b60051ec$var$KMG2_SMALL_LABELS = [
    'm',
    'u',
    'n',
    'p',
    'f',
    'a',
    'z',
    'y'
];
const $d1eae937b60051ec$var$pow = (base, exp)=>{
    if (exp < 0) return 1.0 / Math.pow(base, -exp);
    return Math.pow(base, exp);
};
const $d1eae937b60051ec$var$roundNum = (num, places)=>{
    const shift = Math.pow(10, places);
    return Math.round(num * shift) / shift;
};
const $d1eae937b60051ec$var$floatFormat = (x, optPrecision)=>{
    // Avoid invalid precision values; [1, 21] is the valid range.
    const p = Math.min(Math.max(1, optPrecision || 2), 21);
    // This is deceptively simple.  The actual algorithm comes from:
    //
    // Max allowed length = p + 4
    // where 4 comes from 'e+n' and '.'.
    //
    // Length of fixed format = 2 + y + p
    // where 2 comes from '0.' and y = # of leading zeroes.
    //
    // Equating the two and solving for y yields y = 2, or 0.00xxxx which is
    // 1.0e-3.
    //
    // Since the behavior of toPrecision() is identical for larger numbers, we
    // don't have to worry about the other bound.
    //
    // Finally, the argument for toExponential() is the number of trailing digits,
    // so we take off 1 for the value before the '.'.
    return Math.abs(x) < 1.0e-3 && x !== 0.0 ? x.toExponential(p - 1) : x.toPrecision(p);
};
const $d1eae937b60051ec$export$16d0a55ae0552f78 = (x, opts, prefix, suffix)=>{
    const sigFigs = opts('sigFigs');
    if (sigFigs !== null) // User has opted for a fixed number of significant figures.
    return $d1eae937b60051ec$var$floatFormat(x, sigFigs);
    const digits = opts('digitsAfterDecimal');
    const maxNumberWidth = opts('maxNumberWidth');
    const kmb = opts('labelsKMB');
    const kmg2 = opts('labelsKMG2');
    let label;
    // switch to scientific notation if we underflow or overflow fixed display.
    if (x !== 0.0 && (Math.abs(x) >= Math.pow(10, maxNumberWidth) || Math.abs(x) < Math.pow(10, -digits))) label = x.toExponential(digits);
    else label = `${$d1eae937b60051ec$var$roundNum(x, digits)}`;
    if (kmb || kmg2) {
        let k;
        let kLabels = [];
        let mLabels = [];
        if (kmb) {
            k = 1000;
            kLabels = $d1eae937b60051ec$var$KMB_LABELS;
        }
        if (kmg2) {
            if (kmb) console.error('Setting both labelsKMB and labelsKMG2. Pick one!');
            k = 1024;
            kLabels = $d1eae937b60051ec$var$KMG2_BIG_LABELS;
            mLabels = $d1eae937b60051ec$var$KMG2_SMALL_LABELS;
        }
        const absx = Math.abs(x);
        let n = $d1eae937b60051ec$var$pow(k, kLabels.length);
        for(let j = kLabels.length - 1; j >= 0; j -= 1, n /= k)if (absx >= n) {
            label = $d1eae937b60051ec$var$roundNum(x / n, digits) + kLabels[j];
            break;
        }
        if (kmg2) {
            const xParts = String(x.toExponential()).split('e-').map(Number);
            if (xParts.length === 2 && xParts[1] >= 3 && xParts[1] <= 24) {
                if (xParts[1] % 3 > 0) label = $d1eae937b60051ec$var$roundNum(xParts[0] / $d1eae937b60051ec$var$pow(10, xParts[1] % 3), digits);
                else label = Number(xParts[0]).toFixed(2);
                label += mLabels[Math.floor(xParts[1] / 3) - 1];
            }
        }
    }
    return `${prefix}${label}${suffix}`;
};
const $d1eae937b60051ec$export$e2ad482cc86adb89 = (duration)=>{
    if (!duration) return;
    if (duration === '0' || duration === '0s') return "\u221E";
    let adjustedTime = duration;
    const durationMatcher = /(?:(\d*)d)?(?:(\d*)h)?(?:(\d*)m)?(?:(\d*)s)?/;
    const result = duration.match(durationMatcher);
    const days = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(result, 1, '0');
    const hours = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(result, 2, '0');
    const minutes = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(result, 3, '0');
    const seconds = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(result, 4, '0');
    const hoursInDay = 24;
    if (+days) {
        adjustedTime = `${days}d`;
        adjustedTime += +hours === 0 ? '' : `${hours}h`;
        adjustedTime += +minutes === 0 ? '' : `${minutes}m`;
        adjustedTime += +seconds === 0 ? '' : `${seconds}s`;
    } else if (+hours > hoursInDay) {
        const hoursRemainder = +hours % hoursInDay;
        const daysQuotient = (+hours - hoursRemainder) / hoursInDay;
        adjustedTime = `${daysQuotient}d`;
        adjustedTime += +hoursRemainder === 0 ? '' : `${hoursRemainder}h`;
        adjustedTime += +minutes === 0 ? '' : `${minutes}m`;
        adjustedTime += +seconds === 0 ? '' : `${seconds}s`;
    } else {
        adjustedTime = `${hours}h`;
        adjustedTime += +minutes === 0 ? '' : `${minutes}m`;
        adjustedTime += +seconds === 0 ? '' : `${seconds}s`;
    }
    return adjustedTime;
};




var $hBdgJ = parcelRequire("hBdgJ");

var $gmCTX = parcelRequire("gmCTX");

var $hBdgJ = parcelRequire("hBdgJ");
const $687ef8d4c4e21a50$export$e825345a8afe09c1 = 5;
const $687ef8d4c4e21a50$export$1ffb333534e7f6f7 = 2;
const $687ef8d4c4e21a50$export$16b5ae62e2387119 = 'min';
const $687ef8d4c4e21a50$export$4efca9f8f9bfa6d0 = 0;
const $687ef8d4c4e21a50$export$3da69863bfecc247 = 'max';
const $687ef8d4c4e21a50$export$375fdf781bc228a8 = 100;
const $687ef8d4c4e21a50$export$a4cd1ddf7920c908 = 'threshold';
const $687ef8d4c4e21a50$export$e47f0887676fb162 = 'text';
const $687ef8d4c4e21a50$export$283d67e9e61f9265 = 'background';
const $687ef8d4c4e21a50$export$e0707546bf05d408 = 'base';
const $687ef8d4c4e21a50$export$d2d74e32cf0de1d5 = {
    hex: '#ffffff',
    name: 'white'
};
const $687ef8d4c4e21a50$export$5d93f993ca7fe88c = [
    {
        hex: '#BF3D5E',
        name: 'ruby'
    },
    {
        hex: '#DC4E58',
        name: 'fire'
    },
    {
        hex: '#F95F53',
        name: 'curacao'
    },
    {
        hex: '#F48D38',
        name: 'tiger'
    },
    {
        hex: '#FFB94A',
        name: 'pineapple'
    },
    {
        hex: '#FFD255',
        name: 'thunder'
    },
    {
        hex: '#7CE490',
        name: 'honeydew'
    },
    {
        hex: '#4ED8A0',
        name: 'rainforest'
    },
    {
        hex: '#32B08C',
        name: 'viridian'
    },
    {
        hex: '#4591ED',
        name: 'ocean'
    },
    {
        hex: '#22ADF6',
        name: 'pool'
    },
    {
        hex: '#00C9FF',
        name: 'laser'
    },
    {
        hex: '#513CC6',
        name: 'planet'
    },
    {
        hex: '#7A65F2',
        name: 'star'
    },
    {
        hex: '#9394FF',
        name: 'comet'
    },
    {
        hex: '#383846',
        name: 'pepper'
    },
    {
        hex: '#545667',
        name: 'graphite'
    },
    $687ef8d4c4e21a50$export$d2d74e32cf0de1d5,
    {
        hex: '#292933',
        name: 'castle'
    }
];
const $687ef8d4c4e21a50$export$b9b550d6033567cd = [
    {
        type: $687ef8d4c4e21a50$export$16b5ae62e2387119,
        hex: $687ef8d4c4e21a50$export$5d93f993ca7fe88c[11].hex,
        id: '0',
        name: $687ef8d4c4e21a50$export$5d93f993ca7fe88c[11].name,
        value: $687ef8d4c4e21a50$export$4efca9f8f9bfa6d0
    },
    {
        type: $687ef8d4c4e21a50$export$3da69863bfecc247,
        hex: $687ef8d4c4e21a50$export$5d93f993ca7fe88c[14].hex,
        id: '1',
        name: $687ef8d4c4e21a50$export$5d93f993ca7fe88c[14].name,
        value: $687ef8d4c4e21a50$export$375fdf781bc228a8
    }
];
const $687ef8d4c4e21a50$export$3422d7c4ce2358c9 = [
    {
        type: $687ef8d4c4e21a50$export$e47f0887676fb162,
        hex: $687ef8d4c4e21a50$export$5d93f993ca7fe88c[11].hex,
        id: $687ef8d4c4e21a50$export$e0707546bf05d408,
        name: $687ef8d4c4e21a50$export$5d93f993ca7fe88c[11].name,
        value: -1000000000000000000
    }
];
const $687ef8d4c4e21a50$export$9f0e460e075d61e4 = (colors)=>{
    const type = $687ef8d4c4e21a50$var$getThresholdsListType(colors);
    if (!colors || colors.length === 0) return $687ef8d4c4e21a50$export$3422d7c4ce2358c9;
    const colorsAreIncorrectType = colors.reduce((acc, color)=>{
        if (color.type === $687ef8d4c4e21a50$export$e0707546bf05d408 || color.type === $687ef8d4c4e21a50$export$e47f0887676fb162 || color.type === $687ef8d4c4e21a50$export$283d67e9e61f9265) return acc += 1;
    }, 0) !== colors.length;
    if (colorsAreIncorrectType) return $687ef8d4c4e21a50$export$3422d7c4ce2358c9;
    let containsBaseColor = false;
    const formattedColors = colors.map((color)=>{
        if (color.id === $687ef8d4c4e21a50$export$e0707546bf05d408) {
            // Check for existance of base color
            containsBaseColor = true;
            return {
                ...color,
                value: Number(color.value),
                type: type
            };
        }
        // Single stat colors should all have type of 'text' or 'background'
        return {
            ...color,
            value: Number(color.value),
            type: type
        };
    });
    const formattedColorsWithBase = [
        ...formattedColors,
        $687ef8d4c4e21a50$export$3422d7c4ce2358c9[0]
    ];
    return containsBaseColor ? formattedColors : formattedColorsWithBase;
};
const $687ef8d4c4e21a50$var$getThresholdsListType = (colors)=>{
    const type = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(colors, [
        '0',
        'type'
    ], false);
    if (type && (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).includes([
        $687ef8d4c4e21a50$export$e47f0887676fb162,
        $687ef8d4c4e21a50$export$283d67e9e61f9265
    ], type)) return type;
    return $687ef8d4c4e21a50$export$e47f0887676fb162;
};
const $687ef8d4c4e21a50$export$7262f438e3d270ab = (colors)=>{
    if (!colors || colors.length < $687ef8d4c4e21a50$export$1ffb333534e7f6f7) return $687ef8d4c4e21a50$export$b9b550d6033567cd;
    const colorsAreIncorrectType = colors.reduce((acc, color)=>{
        if (color.type === $687ef8d4c4e21a50$export$16b5ae62e2387119 || color.type === $687ef8d4c4e21a50$export$3da69863bfecc247 || color.type === $687ef8d4c4e21a50$export$a4cd1ddf7920c908) return acc += 1;
    }, 0) !== colors.length;
    if (colorsAreIncorrectType) return $687ef8d4c4e21a50$export$b9b550d6033567cd;
    // Gauge colors should have a type of min, any number of thresholds, and a max
    const formattedColors = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).sortBy(colors, (color)=>Number(color.value)).map((color)=>({
            ...color,
            value: Number(color.value),
            type: $687ef8d4c4e21a50$export$a4cd1ddf7920c908
        }));
    formattedColors[0].type = $687ef8d4c4e21a50$export$16b5ae62e2387119;
    formattedColors[formattedColors.length - 1].type = $687ef8d4c4e21a50$export$3da69863bfecc247;
    return formattedColors;
};
const $687ef8d4c4e21a50$export$ee00554e37fca064 = (colors)=>{
    return colors.map((color)=>({
            ...color,
            value: `${color.value}`
        }));
};



const $e09670a2eb92b732$var$getLegibleTextColor = (bgColorHex)=>{
    const darkText = '#292933';
    const lightText = '#ffffff';
    const [red, green, blue] = (0, (/*@__PURE__*/$parcel$interopDefault($gmCTX)))(bgColorHex).rgb();
    const average = (red + green + blue) / 3;
    const mediumGrey = 128;
    return average > mediumGrey ? darkText : lightText;
};
const $e09670a2eb92b732$var$findNearestCrossedThreshold = (colors, lastValue)=>{
    const sortedColors = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).sortBy(colors, (color)=>Number(color.value));
    const nearestCrossedThreshold = sortedColors.filter((color)=>lastValue >= color.value).pop();
    return nearestCrossedThreshold;
};
const $e09670a2eb92b732$export$ee00554e37fca064 = (colors)=>{
    return colors.map((color)=>({
            ...color,
            value: `${color.value}`
        }));
};
const $e09670a2eb92b732$export$2c00ede3bdd18539 = ({ colors: colors, lastValue: lastValue, cellType: cellType = 'line' })=>{
    const defaultColoring = {
        bgColor: null,
        textColor: cellType === (0, $b4506126e09430df$export$705e36171f4cbbfe).Table ? '#BEC2CC' : (0, $687ef8d4c4e21a50$export$5d93f993ca7fe88c)[11].hex
    };
    const lastValueNumber = Number(lastValue) || 0;
    let bgColor;
    let textColor;
    if (!colors.length) return defaultColoring;
    // baseColor is expected in all cases
    const baseColor = colors.find((color)=>color.id = (0, $687ef8d4c4e21a50$export$e0707546bf05d408)) || {
        hex: defaultColoring.textColor
    };
    if (!lastValue && lastValue !== 0) return {
        ...defaultColoring,
        textColor: baseColor.hex
    };
    // If the single stat is above a line graph never have a background color
    if (cellType === (0, $b4506126e09430df$export$705e36171f4cbbfe).LinePlusSingleStat) return baseColor ? {
        bgColor: null,
        textColor: baseColor.hex
    } : defaultColoring;
    // When there is only a base color and it's applied to the text
    const shouldColorizeText = !!colors.find((color)=>color.type === (0, $687ef8d4c4e21a50$export$e47f0887676fb162));
    if (shouldColorizeText && colors.length === 1) return baseColor ? {
        bgColor: null,
        textColor: baseColor.hex
    } : defaultColoring;
    // When there's multiple colors and they're applied to the text
    if (shouldColorizeText && colors.length > 1) {
        const nearestCrossedThreshold = $e09670a2eb92b732$var$findNearestCrossedThreshold(colors, lastValueNumber);
        return {
            bgColor: null,
            textColor: nearestCrossedThreshold.hex
        };
    }
    // When there is only a base color and it's applued to the background
    if (colors.length === 1) {
        bgColor = baseColor.hex;
        textColor = $e09670a2eb92b732$var$getLegibleTextColor(bgColor);
        return {
            bgColor: bgColor,
            textColor: textColor
        };
    }
    // When there are multiple colors and they're applied to the background
    if (colors.length > 1) {
        const nearestCrossedThreshold = $e09670a2eb92b732$var$findNearestCrossedThreshold(colors, lastValueNumber);
        bgColor = nearestCrossedThreshold ? nearestCrossedThreshold.hex : baseColor.hex;
        textColor = $e09670a2eb92b732$var$getLegibleTextColor(bgColor);
        return {
            bgColor: bgColor,
            textColor: textColor
        };
    }
    // If all else fails, use safe default
    bgColor = null;
    textColor = baseColor.hex;
    return {
        bgColor: bgColor,
        textColor: textColor
    };
};



const $727a6ab7dfc948a3$export$aeea68bb229a3a4d = (cellType)=>{
    switch(cellType){
        case 'table':
            return 0, $9a9ec629fdd38845$export$88bc4ccd9afcdcbc;
        default:
            return 0, $9a9ec629fdd38845$export$88bc4ccd9afcdcbc;
    }
};
const $727a6ab7dfc948a3$export$98a6bbea2e7b1f09 = {
    LINEAR: 'linear',
    LOG: 'log',
    BASE_2: '2',
    BASE_10: '10',
    BASE_RAW: 'raw'
};
const $727a6ab7dfc948a3$export$308b7fb3973197ea = {
    prefix: '',
    suffix: '',
    base: $727a6ab7dfc948a3$export$98a6bbea2e7b1f09.BASE_10,
    scale: $727a6ab7dfc948a3$export$98a6bbea2e7b1f09.LINEAR,
    label: ''
};
const $727a6ab7dfc948a3$export$d936f909e9425fec = {
    ...$727a6ab7dfc948a3$export$308b7fb3973197ea,
    bounds: [
        '',
        ''
    ]
};
const $727a6ab7dfc948a3$export$c0dadf556788a63f = {
    x: $727a6ab7dfc948a3$export$d936f909e9425fec,
    y: $727a6ab7dfc948a3$export$d936f909e9425fec
};
const $727a6ab7dfc948a3$export$be1e3eb56b1b752d = ({ cellType: cellType, gaugeColors: gaugeColors, thresholdsListColors: thresholdsListColors, lineColors: lineColors })=>{
    switch(cellType){
        case (0, $b4506126e09430df$export$705e36171f4cbbfe).Gauge:
            return (0, $e09670a2eb92b732$export$ee00554e37fca064)(gaugeColors);
        case (0, $b4506126e09430df$export$705e36171f4cbbfe).SingleStat:
        case (0, $b4506126e09430df$export$705e36171f4cbbfe).Table:
            return (0, $e09670a2eb92b732$export$ee00554e37fca064)(thresholdsListColors);
        case (0, $b4506126e09430df$export$705e36171f4cbbfe).Bar:
        case (0, $b4506126e09430df$export$705e36171f4cbbfe).Line:
        case (0, $b4506126e09430df$export$705e36171f4cbbfe).LinePlusSingleStat:
        case (0, $b4506126e09430df$export$705e36171f4cbbfe).Stacked:
        case (0, $b4506126e09430df$export$705e36171f4cbbfe).StepPlot:
            return (0, $e09670a2eb92b732$export$ee00554e37fca064)(lineColors);
        default:
            return [];
    }
};
const $727a6ab7dfc948a3$export$bce5511945345ed = {
    type: 'static',
    orientation: 'bottom'
};



var $hBdgJ = parcelRequire("hBdgJ");


function $2b35f344ea99f322$export$c3545c530da0cc9e(roles) {
    return roles.map((role)=>{
        return Object.assign({}, role, {
            permissions: $2b35f344ea99f322$var$buildPermissionsWithResources(role.permissions),
            users: role.users || []
        });
    });
}
function $2b35f344ea99f322$var$buildPermissionsWithResources(rawPermissions) {
    const nextPermissions = {};
    (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).each(rawPermissions, (permissions, resource)=>{
        permissions.forEach((p)=>{
            if (nextPermissions[p]) nextPermissions[p].push(resource);
            else nextPermissions[p] = [
                resource
            ];
        });
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).map(nextPermissions, (resources, permissionName)=>{
        if (!(0, $e10a8602f56394e3$export$d6eefc103e184eaa)[permissionName]) {
            console.error('Could not find details for plutonium permission!') // eslint-disable-line no-console
            ;
            return {
                name: permissionName,
                displayName: '',
                description: '',
                resources: resources
            };
        }
        const { displayName: displayName, description: description } = (0, $e10a8602f56394e3$export$d6eefc103e184eaa)[permissionName];
        return {
            name: permissionName,
            displayName: displayName,
            description: description,
            resources: resources
        };
    });
}
function $2b35f344ea99f322$export$593c6acdf0b898f6() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).map((0, $e10a8602f56394e3$export$d6eefc103e184eaa), ({ displayName: displayName, description: description }, permissionName)=>{
        if (!(0, $e10a8602f56394e3$export$d6eefc103e184eaa)[permissionName]) {
            console.error('Could not find details for plutonium permission!') // eslint-disable-line no-console
            ;
            return {
                name: permissionName,
                displayName: '',
                description: '',
                resources: []
            };
        }
        return {
            name: permissionName,
            displayName: displayName,
            description: description,
            resources: []
        };
    });
}
function $2b35f344ea99f322$export$f4a8141547c5d7f3(permissionName, resources) {
    if (!(0, $e10a8602f56394e3$export$d6eefc103e184eaa)[permissionName]) {
        console.error('Could not find details for plutonium permission!') // eslint-disable-line no-console
        ;
        return {
            name: permissionName,
            displayName: '',
            description: '',
            resources: []
        };
    }
    return Object.assign({}, {
        name: permissionName,
        resources: resources
    }, (0, $e10a8602f56394e3$export$d6eefc103e184eaa)[permissionName]);
}
function $2b35f344ea99f322$export$b39e1e1f62fb393(users = [], roles = []) {
    return users.map((user)=>{
        return Object.assign({}, user, {
            roles: $2b35f344ea99f322$var$getRolesForUser(roles, user),
            permissions: $2b35f344ea99f322$var$buildPermissionsWithResources(user.permissions)
        });
    });
}
function $2b35f344ea99f322$var$getRolesForUser(roles, user) {
    const userRoles = roles.filter((role)=>{
        if (!role.users) return false;
        return role.users.includes(user.name);
    });
    return $2b35f344ea99f322$export$c3545c530da0cc9e(userRoles);
}
const $2b35f344ea99f322$export$84fdfe841cd5b241 = (queryConfig)=>{
    const { measurement: measurement } = queryConfig;
    const fields = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(queryConfig, [
        'fields',
        '0'
    ], []);
    const isEmpty = !measurement && !fields.length;
    if (isEmpty) return '';
    const walkZerothArgs = (f)=>{
        if (f.type === 'field') return f.value;
        return `${f.value}${(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(f, [
            '0',
            'args',
            'value'
        ], '')}`;
    };
    const values = (0, $58ff0395d03c4a96$export$ddfbd4c1a2cd4384)([
        fields
    ], walkZerothArgs);
    return `${measurement}.${values.join('_')}`;
};





var $gmCTX = parcelRequire("gmCTX");

const $b00e3cd70e675d45$var$COLOR_TYPE_SCALE = 'scale';
const $b00e3cd70e675d45$export$4599f7126847d45d = [
    {
        type: $b00e3cd70e675d45$var$COLOR_TYPE_SCALE,
        hex: '#31C0F6',
        id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
        name: 'Nineteen Eighty Four',
        value: '0'
    },
    {
        type: $b00e3cd70e675d45$var$COLOR_TYPE_SCALE,
        hex: '#A500A5',
        id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
        name: 'Nineteen Eighty Four',
        value: '0'
    },
    {
        type: $b00e3cd70e675d45$var$COLOR_TYPE_SCALE,
        hex: '#FF7E27',
        id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
        name: 'Nineteen Eighty Four',
        value: '0'
    }
];
const $b00e3cd70e675d45$export$16f845f9d86a0be6 = [
    {
        type: $b00e3cd70e675d45$var$COLOR_TYPE_SCALE,
        hex: '#74D495',
        id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
        name: 'Atlantis',
        value: '0'
    },
    {
        type: $b00e3cd70e675d45$var$COLOR_TYPE_SCALE,
        hex: '#3F3FBA',
        id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
        name: 'Atlantis',
        value: '0'
    },
    {
        type: $b00e3cd70e675d45$var$COLOR_TYPE_SCALE,
        hex: '#FF4D9E',
        id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
        name: 'Atlantis',
        value: '0'
    }
];
const $b00e3cd70e675d45$export$87fddd00c5b524d6 = [
    {
        type: $b00e3cd70e675d45$var$COLOR_TYPE_SCALE,
        hex: '#8F8AF4',
        id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
        name: 'Do Androids Dream of Electric Sheep?',
        value: '0'
    },
    {
        type: $b00e3cd70e675d45$var$COLOR_TYPE_SCALE,
        hex: '#A51414',
        id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
        name: 'Do Androids Dream of Electric Sheep?',
        value: '0'
    },
    {
        type: $b00e3cd70e675d45$var$COLOR_TYPE_SCALE,
        hex: '#F4CF31',
        id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
        name: 'Do Androids Dream of Electric Sheep?',
        value: '0'
    }
];
const $b00e3cd70e675d45$export$502f0a07e6fcbb9 = [
    {
        type: $b00e3cd70e675d45$var$COLOR_TYPE_SCALE,
        hex: '#FD7A5D',
        id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
        name: 'Delorean',
        value: '0'
    },
    {
        type: $b00e3cd70e675d45$var$COLOR_TYPE_SCALE,
        hex: '#5F1CF2',
        id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
        name: 'Delorean',
        value: '0'
    },
    {
        type: $b00e3cd70e675d45$var$COLOR_TYPE_SCALE,
        hex: '#4CE09A',
        id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
        name: 'Delorean',
        value: '0'
    }
];
const $b00e3cd70e675d45$export$9b42f0eaf05168d = [
    {
        type: $b00e3cd70e675d45$var$COLOR_TYPE_SCALE,
        hex: '#FDC44F',
        id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
        name: 'Cthulhu',
        value: '0'
    },
    {
        type: $b00e3cd70e675d45$var$COLOR_TYPE_SCALE,
        hex: '#007C76',
        id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
        name: 'Cthulhu',
        value: '0'
    },
    {
        type: $b00e3cd70e675d45$var$COLOR_TYPE_SCALE,
        hex: '#8983FF',
        id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
        name: 'Cthulhu',
        value: '0'
    }
];
const $b00e3cd70e675d45$export$1875b68c5b860f79 = [
    {
        type: $b00e3cd70e675d45$var$COLOR_TYPE_SCALE,
        hex: '#DA6FF1',
        id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
        name: 'Ectoplasm',
        value: '0'
    },
    {
        type: $b00e3cd70e675d45$var$COLOR_TYPE_SCALE,
        hex: '#00717A',
        id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
        name: 'Ectoplasm',
        value: '0'
    },
    {
        type: $b00e3cd70e675d45$var$COLOR_TYPE_SCALE,
        hex: '#ACFF76',
        id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
        name: 'Ectoplasm',
        value: '0'
    }
];
const $b00e3cd70e675d45$export$283b75ed4181bb04 = [
    {
        type: $b00e3cd70e675d45$var$COLOR_TYPE_SCALE,
        hex: '#F6F6F8',
        id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
        name: 'T-Max 400 Film',
        value: '0'
    },
    {
        type: $b00e3cd70e675d45$var$COLOR_TYPE_SCALE,
        hex: '#A4A8B6',
        id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
        name: 'T-Max 400 Film',
        value: '0'
    },
    {
        type: $b00e3cd70e675d45$var$COLOR_TYPE_SCALE,
        hex: '#545667',
        id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
        name: 'T-Max 400 Film',
        value: '0'
    }
];
const $b00e3cd70e675d45$export$68073cd983ce53ee = [
    {
        type: $b00e3cd70e675d45$var$COLOR_TYPE_SCALE,
        hex: '#7CE490',
        id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
        name: 'Honeydew',
        value: '0'
    },
    {
        type: $b00e3cd70e675d45$var$COLOR_TYPE_SCALE,
        hex: '#22ADF6',
        id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
        name: 'Pool',
        value: '0'
    }
];
const $b00e3cd70e675d45$export$b940073a64112462 = $b00e3cd70e675d45$export$4599f7126847d45d;
const $b00e3cd70e675d45$export$db1d57afe3d5285d = [
    $b00e3cd70e675d45$export$4599f7126847d45d,
    $b00e3cd70e675d45$export$16f845f9d86a0be6,
    $b00e3cd70e675d45$export$87fddd00c5b524d6,
    $b00e3cd70e675d45$export$502f0a07e6fcbb9,
    $b00e3cd70e675d45$export$9b42f0eaf05168d,
    $b00e3cd70e675d45$export$1875b68c5b860f79,
    $b00e3cd70e675d45$export$283b75ed4181bb04
].map((colorScale)=>{
    const name = colorScale[0].name;
    const colors = colorScale;
    const id = colorScale[0].id;
    return {
        name: name,
        colors: colors,
        id: id
    };
});
const $b00e3cd70e675d45$export$a20036365ba1ef4 = (colors, numSeries = 0)=>{
    const multipleSeriesButOneColor = numSeries > 1 && colors.length < 2;
    if (!colors || colors.length === 0 || multipleSeriesButOneColor) return $b00e3cd70e675d45$export$b940073a64112462;
    const testColorsTypes = colors.filter((color)=>color.type === $b00e3cd70e675d45$var$COLOR_TYPE_SCALE).length === colors.length;
    return testColorsTypes ? colors : $b00e3cd70e675d45$export$b940073a64112462;
};
const $b00e3cd70e675d45$export$a7358e9f62c10a32 = (colors, numSeries)=>{
    const validatedColors = $b00e3cd70e675d45$export$a20036365ba1ef4(colors, numSeries) // ensures safe defaults
    ;
    const colorsHexArray = validatedColors.map((color)=>color.hex);
    if (numSeries === 1 || numSeries === 0) return [
        colorsHexArray[0]
    ];
    if (numSeries === 2) return [
        colorsHexArray[0],
        colorsHexArray[1]
    ];
    return (0, (/*@__PURE__*/$parcel$interopDefault($gmCTX))).scale(colorsHexArray).mode('lch').colors(numSeries);
};




const { LOG: $c99ab73e7002f8ba$var$LOG, BASE_10: $c99ab73e7002f8ba$var$BASE_10, BASE_2: $c99ab73e7002f8ba$var$BASE_2 } = (0, $727a6ab7dfc948a3$export$98a6bbea2e7b1f09);
const $c99ab73e7002f8ba$var$Dygraphs = (0, $7358174edaa32bc8$export$2e2bcd8739ae039);
const $c99ab73e7002f8ba$var$getRangeMemoizedY = (0, $6c6177bbe259d59a$export$2e2bcd8739ae039)((0, $66e9028799656e9e$export$2e2bcd8739ae039));
const $c99ab73e7002f8ba$var$DEFAULT_DYGRAPH_OPTIONS = {
    rightGap: 0,
    axisLineWidth: 2,
    gridLineWidth: 1,
    colors: (0, $28d93691ce0d4d34$export$b7f07238211e7efd),
    animatedZooms: true,
    highlightCircleSize: 3,
    labelsSeparateLines: false,
    hideOverlayOnMouseOut: false,
    highlightSeriesBackgroundAlpha: 1.0,
    highlightSeriesBackgroundColor: 'rgb(41, 41, 51)'
};
class $c99ab73e7002f8ba$var$Dygraph extends (0, $NdCUR.Component) {
    static{
        this.defaultProps = {
            axes: {
                x: {
                    bounds: [
                        null,
                        null
                    ],
                    ...(0, $727a6ab7dfc948a3$export$308b7fb3973197ea)
                },
                y: {
                    bounds: [
                        null,
                        null
                    ],
                    ...(0, $727a6ab7dfc948a3$export$308b7fb3973197ea)
                }
            },
            containerStyle: {},
            isGraphFilled: true,
            onZoom: ()=>{},
            staticLegend: false,
            handleSetHoverTime: ()=>{},
            underlayCallback: ()=>{}
        };
    }
    constructor(props){
        super(props), this.getYRange = (timeSeries)=>{
            const { options: options, axes: { y: y }, ruleValues: ruleValues } = this.props;
            if (options.stackedGraph) return (0, $66e9028799656e9e$export$a22b660adc6449cb)(y.bounds);
            let range = $c99ab73e7002f8ba$var$getRangeMemoizedY(timeSeries, y.bounds, ruleValues);
            const [min, max] = range;
            // Bug in Dygraph calculates a negative range for logscale when min range is 0
            if (y.scale === $c99ab73e7002f8ba$var$LOG && min <= 0) range = [
                0.01,
                max
            ];
            return range;
        }, this.handleZoom = (lower, upper)=>{
            const { onZoom: onZoom } = this.props;
            if (this.dygraph.isZoomed('x')) return onZoom({
                lower: this.formatTimeRange(lower),
                upper: this.formatTimeRange(upper)
            });
            return onZoom({
                lower: null,
                upper: null
            });
        }, this.handleDraw = ()=>{
            if (!this.dygraph) return;
            const { xAxisRange: xAxisRange } = this.state;
            const newXAxisRange = this.dygraph.xAxisRange();
            if (!(0, $hBdgJ.isEqual)(xAxisRange, newXAxisRange)) this.setState({
                xAxisRange: newXAxisRange
            });
        }, this.formatYVal = (yval, __, opts)=>{
            const { axes: { y: { prefix: prefix, suffix: suffix } } } = this.props;
            return (0, $d1eae937b60051ec$export$16d0a55ae0552f78)(yval, opts, prefix, suffix);
        }, this.eventToTimestamp = ({ pageX: pxBetweenMouseAndPage })=>{
            const pxBetweenGraphAndPage = this.graphRef.current.getBoundingClientRect().left;
            const graphXCoordinate = pxBetweenMouseAndPage - pxBetweenGraphAndPage;
            const timestamp = this.dygraph.toDataXCoord(graphXCoordinate);
            const [xRangeStart] = this.dygraph.xAxisRange();
            const clamped = Math.max(xRangeStart, timestamp);
            return String(clamped);
        }, this.handleHideLegend = ()=>{
            this.setState({
                isMouseInLegend: false
            });
            this.props.handleSetHoverTime((0, $93a523326aa94673$export$f248303b5fb71ab5));
        }, this.handleShowLegend = (e)=>{
            const { isMouseInLegend: isMouseInLegend } = this.state;
            if (isMouseInLegend) return;
            const newTime = this.eventToTimestamp(e);
            this.props.handleSetHoverTime(newTime);
        }, this.getLabel = (axis)=>{
            const { axes: axes, labels: labels, queries: queries } = this.props;
            // if label comes back as '', use the y axis label from props.labels, if it exists
            // see https://github.com/influxdata/chronograf/issues/5314
            const fallbackLabel = labels[1] || '';
            const label = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(axes, `${axis}.label`, '') || fallbackLabel;
            const queryConfig = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(queries, '0.queryConfig', false);
            if (label || !queryConfig) return label;
            return (0, $2b35f344ea99f322$export$84fdfe841cd5b241)(queryConfig);
        }, this.resize = ()=>{
            if (this.dygraph) {
                this.dygraph.resizeElements_();
                this.dygraph.predraw_();
                this.dygraph.resize();
            }
        }, this.formatTimeRange = (date)=>{
            if (!date) return '';
            const nanoDate = new (0, (/*@__PURE__*/$parcel$interopDefault($25fe38ccc270c16a$exports)))(date);
            return nanoDate.toISOString();
        }, this.handleUpdateStaticLegendHeight = (staticLegendHeight)=>{
            this.setState({
                staticLegendHeight: staticLegendHeight
            });
        }, this.handleMouseEnterLegend = ()=>{
            this.setState({
                isMouseInLegend: true
            });
        };
        this.state = {
            staticLegendHeight: 0,
            xAxisRange: [
                0,
                0
            ],
            isMouseInLegend: false
        };
        this.graphRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createRef();
    }
    componentDidMount() {
        const options = this.collectDygraphOptions();
        const initialOptions = {
            ...$c99ab73e7002f8ba$var$DEFAULT_DYGRAPH_OPTIONS,
            ...options
        };
        this.dygraph = new $c99ab73e7002f8ba$var$Dygraphs(this.graphRef.current, this.timeSeries, initialOptions);
        this.dygraphOptions = options;
        this.setState({
            xAxisRange: this.dygraph.xAxisRange()
        });
    }
    componentWillUnmount() {
        if (this.dygraph) {
            this.dygraph.destroy();
            delete this.dygraph;
        }
    }
    componentDidUpdate(prevProps) {
        const dygraph = this.dygraph;
        const options = this.collectDygraphOptions();
        const optionsChanged = this.haveDygraphOptionsChanged(options);
        const timeRangeChanged = !(0, $hBdgJ.isEqual)(prevProps.timeRange, this.props.timeRange);
        const staticLegendChanged = prevProps.staticLegend !== this.props.staticLegend;
        if (optionsChanged) {
            dygraph.updateOptions(options);
            this.dygraphOptions = options;
        }
        if (dygraph.isZoomed('x') && timeRangeChanged) dygraph.resetZoom();
        if (staticLegendChanged || optionsChanged) setTimeout(this.resize, 0);
    }
    render() {
        const { staticLegendHeight: staticLegendHeight, xAxisRange: xAxisRange } = this.state;
        const { staticLegend: staticLegend, cellID: cellID } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "dygraph-child",
            onMouseMove: this.handleShowLegend,
            onMouseLeave: this.handleHideLegend
        }, this.dygraph && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "dygraph-addons"
        }, this.areAnnotationsVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $48ea0df480f2833d$export$2e2bcd8739ae039), {
            dygraph: this.dygraph,
            dWidth: this.dygraph.getArea().w,
            staticLegendHeight: staticLegendHeight,
            xAxisRange: xAxisRange
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $461bf492cf59acf5$export$2e2bcd8739ae039), {
            cellID: cellID,
            dygraph: this.dygraph,
            onHide: this.handleHideLegend,
            onShow: this.handleShowLegend,
            onMouseEnter: this.handleMouseEnterLegend
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $761aec314d6fe7e9$export$2e2bcd8739ae039), {
            dygraph: this.dygraph,
            staticLegendHeight: staticLegendHeight
        })), staticLegend && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $6a5e88528b288b14$export$2e2bcd8739ae039), {
            dygraphSeries: this.colorDygraphSeries,
            dygraph: this.dygraph,
            height: staticLegendHeight,
            onUpdateHeight: this.handleUpdateStaticLegendHeight
        }), this.nestedGraph && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).cloneElement(this.nestedGraph, {
            staticLegendHeight: staticLegendHeight
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            id: `graph-ref-${cellID}`,
            className: "dygraph-child-container",
            ref: this.graphRef,
            style: this.dygraphStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $8d02d0065a7826a6$export$2e2bcd8739ae039), {
            targetRef: this.graphRef,
            handleWidth: true,
            handleHeight: true,
            onResize: this.resize
        })));
    }
    get nestedGraph() {
        const { children: children } = this.props;
        if (children) {
            if (children[0]) return children[0];
            return children;
        }
        return null;
    }
    get dygraphStyle() {
        const { containerStyle: containerStyle, staticLegend: staticLegend } = this.props;
        const { staticLegendHeight: staticLegendHeight } = this.state;
        if (staticLegend) {
            const cellVerticalPadding = 16;
            return {
                ...containerStyle,
                zIndex: 2,
                height: `calc(100% - ${staticLegendHeight + cellVerticalPadding}px)`
            };
        }
        return {
            ...containerStyle,
            zIndex: 2
        };
    }
    get labelWidth() {
        const { axes: { y: y } } = this.props;
        return (0, $28d93691ce0d4d34$export$fc6b1e9923bb7632) + y.prefix.length * (0, $28d93691ce0d4d34$export$43e392df2a2e2f5e) + y.suffix.length * (0, $28d93691ce0d4d34$export$43e392df2a2e2f5e);
    }
    get timeSeries() {
        const { timeSeries: timeSeries } = this.props;
        // Avoid 'Can't plot empty data set' errors by falling back to a default
        // dataset that's valid for Dygraph.
        return timeSeries && timeSeries.length ? timeSeries : [
            [
                0
            ]
        ];
    }
    get colorDygraphSeries() {
        const { dygraphSeries: dygraphSeries, colors: colors } = this.props;
        const numSeries = Object.keys(dygraphSeries).length;
        const dygraphSeriesKeys = Object.keys(dygraphSeries).sort();
        const lineColors = (0, $b00e3cd70e675d45$export$a7358e9f62c10a32)(colors, numSeries);
        const coloredDygraphSeries = {};
        for(const seriesName in dygraphSeries)// eslint-disable-next-line no-prototype-builtins
        if (dygraphSeries.hasOwnProperty(seriesName)) {
            const series = dygraphSeries[seriesName];
            const color = lineColors[dygraphSeriesKeys.indexOf(seriesName)];
            coloredDygraphSeries[seriesName] = {
                ...series,
                color: color
            };
        }
        return coloredDygraphSeries;
    }
    get areAnnotationsVisible() {
        return !!this.dygraph;
    }
    collectDygraphOptions() {
        const { labels: labels, axes: { y: y }, type: type, underlayCallback: underlayCallback, isGraphFilled: isGraphFilled, timeZone: timeZone } = this.props;
        const { colorDygraphSeries: colorDygraphSeries, handleDraw: handleDraw, handleZoom: handleZoom, timeSeries: timeSeries, labelWidth: labelWidth, formatYVal: formatYVal } = this;
        const options = {
            labels: labels,
            underlayCallback: underlayCallback,
            file: timeSeries,
            zoomCallback: handleZoom,
            drawCallback: handleDraw,
            fillGraph: isGraphFilled,
            logscale: y.scale === $c99ab73e7002f8ba$var$LOG,
            ylabel: this.getLabel('y'),
            series: colorDygraphSeries,
            plotter: type === (0, $b4506126e09430df$export$705e36171f4cbbfe).Bar ? (0, $28d93691ce0d4d34$export$a92ee9f37d6dc335) : null,
            axes: {
                y: {
                    axisLabelWidth: labelWidth,
                    labelsKMB: y.base === $c99ab73e7002f8ba$var$BASE_10,
                    labelsKMG2: y.base === $c99ab73e7002f8ba$var$BASE_2,
                    axisLabelFormatter: formatYVal,
                    valueRange: this.getYRange(timeSeries)
                }
            },
            labelsUTC: timeZone === (0, $a7b864c61f4e95a7$export$d6f132cca63fb222).UTC,
            ...this.props.options
        };
        return options;
    }
    haveDygraphOptionsChanged(nextOptions) {
        const options = this.dygraphOptions;
        const pred = (__, key)=>key !== 'file';
        // Peform a deep comparison of the current options and next options, but
        // check the `file` property of each object by reference rather than by
        // logical identity since it can be quite large (it contains all the time
        // series data)
        return !(0, $hBdgJ.isEqual)((0, $hBdgJ.filter)(options, pred), (0, $hBdgJ.filter)(nextOptions, pred)) || options.file !== nextOptions.file;
    }
}
const $c99ab73e7002f8ba$var$mstp = ({ annotations: { mode: mode }, app: app })=>({
        mode: mode,
        timeZone: app.persisted.timeZone
    });
var $c99ab73e7002f8ba$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($c99ab73e7002f8ba$var$mstp, null)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($c99ab73e7002f8ba$var$Dygraph));




// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");

var $hBdgJ = parcelRequire("hBdgJ");


var $NdCUR = parcelRequire("NdCUR");



class $8ff1a4fbb307e59d$var$InvalidData extends (0, $NdCUR.PureComponent) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "graph-empty"
        }, this.errorMessage);
    }
    get errorMessage() {
        if (this.props.message) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, this.props.message);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, "The data returned from the query can't be visualized with this graph type.", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("br", null), this.props.onUpdateVisType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
            text: 'Switch to Table Graph',
            onClick: this.handleSwitchToTableGraph,
            color: (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Primary,
            size: (0, $918c9f03a35fe03f$export$fafce5c139da9687).Small
        })));
    }
    constructor(...args){
        super(...args), this.handleSwitchToTableGraph = ()=>{
            this.props.onUpdateVisType((0, $b4506126e09430df$export$705e36171f4cbbfe).Table);
        };
    }
}
var $8ff1a4fbb307e59d$export$2e2bcd8739ae039 = $8ff1a4fbb307e59d$var$InvalidData;





var $hBdgJ = parcelRequire("hBdgJ");
function $c86764ab25b18722$export$2e2bcd8739ae039(timeSeriesResponse) {
    const values = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(timeSeriesResponse, [
        '0',
        'response',
        'results',
        '0',
        'series',
        '0',
        'values'
    ], [
        [
            '',
            ''
        ]
    ]);
    const series = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(timeSeriesResponse, [
        '0',
        'response',
        'results',
        '0',
        'series',
        '0',
        'columns'
    ], [
        '',
        ''
    ]).slice(1);
    const lastValues = values[values.length - 1].slice(1) // remove time with slice 1
    ;
    return {
        values: lastValues,
        series: series
    };
}




var $hBdgJ = parcelRequire("hBdgJ");



var $59efbcd42a6b4649$export$e8d6de90187c4250 = /*#__PURE__*/ function(InfluxQLQueryType) {
    InfluxQLQueryType["MetaQuery"] = "MetaQuery";
    InfluxQLQueryType["DataQuery"] = "DataQuery";
    InfluxQLQueryType["ComboQuery"] = "CombinationQuery";
    return InfluxQLQueryType;
}({});




const $182b28bda5c9878f$var$calculateSize = (message)=>{
    return message.length * 7;
};
var $182b28bda5c9878f$export$43a750ddd9f2303e = /*#__PURE__*/ function(ErrorTypes) {
    ErrorTypes["MetaQueryCombo"] = "MetaQueryCombo";
    ErrorTypes["GeneralError"] = "Error";
    return ErrorTypes;
}({});
const $182b28bda5c9878f$export$76fed1d1c9cba1e6 = (errorType)=>{
    switch(errorType){
        case "MetaQueryCombo":
            return 'Cannot display data for meta queries mixed with data queries';
        default:
            return null;
    }
};
const $182b28bda5c9878f$var$calculateTimeColumnWidth = (timeFormat)=>{
    // Force usage of longest format names for ideal measurement
    timeFormat = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).replace(timeFormat, 'MMMM', 'September');
    timeFormat = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).replace(timeFormat, 'dddd', 'Wednesday');
    timeFormat = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).replace(timeFormat, 'A', 'AM');
    timeFormat = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).replace(timeFormat, 'h', '00');
    timeFormat = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).replace(timeFormat, 'X', '1522286058');
    timeFormat = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).replace(timeFormat, 'x', '1536106867461');
    const width = $182b28bda5c9878f$var$calculateSize(timeFormat);
    return width + (0, $93a523326aa94673$export$aed77359b4c89f21);
};
const $182b28bda5c9878f$var$updateMaxWidths = (row, maxColumnWidths, topRow, isTopRow, fieldOptions, timeFormatWidth, verticalTimeAxis, decimalPlaces)=>{
    const maxWidths = (0, $4e86f29e59d731b4$export$61f84df1ca3d669)(row, (acc, col, c)=>{
        const isLabel = verticalTimeAxis && isTopRow || !verticalTimeAxis && c === 0;
        const foundField = isLabel && (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isString(col) ? fieldOptions.find((field)=>field.internalName === col) : null;
        let colValue = `${col}`;
        if (foundField && foundField.displayName) colValue = foundField.displayName;
        else if ((0, $e4e77e3c79ee997a$export$881c80522fdbdba7)(col, decimalPlaces)) colValue = (0, $e4e77e3c79ee997a$export$a81f732198733497)(col, decimalPlaces);
        const columnLabel = topRow[c];
        const isTimeColumn = columnLabel === (0, $9a9ec629fdd38845$export$af0d6a692d995875).internalName || columnLabel === (0, $9a9ec629fdd38845$export$d26a3a0fb696ceaa).internalName;
        const isTimeRow = topRow[0] === (0, $9a9ec629fdd38845$export$af0d6a692d995875).internalName || topRow[0] === (0, $9a9ec629fdd38845$export$d26a3a0fb696ceaa).internalName;
        const useTimeWidth = isTimeColumn && verticalTimeAxis && !isTopRow || !verticalTimeAxis && isTopRow && isTimeRow && c !== 0;
        const currentWidth = useTimeWidth ? timeFormatWidth : $182b28bda5c9878f$var$calculateSize(colValue.toString().trim()) + (0, $93a523326aa94673$export$aed77359b4c89f21);
        const { widths: Widths } = maxColumnWidths;
        const maxWidth = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(Widths, `${columnLabel}`, 0);
        if (isTopRow || currentWidth > maxWidth) {
            acc.widths[columnLabel] = currentWidth;
            acc.totalWidths += currentWidth - maxWidth;
        }
        return acc;
    }, {
        ...maxColumnWidths
    });
    return maxWidths;
};
const $182b28bda5c9878f$export$d4a669fa0f2c95ae = (dataType)=>{
    if (dataType === (0, $e10a8602f56394e3$export$45c69700ee30a78c).flux) return 0, $9a9ec629fdd38845$export$d26a3a0fb696ceaa;
    return 0, $9a9ec629fdd38845$export$af0d6a692d995875;
};
const $182b28bda5c9878f$export$edfce68a1e2dc732 = (existingFieldOptions, sortedLabels, dataType, influxQLQueryType)=>{
    const defaultTimeField = $182b28bda5c9878f$export$d4a669fa0f2c95ae(dataType);
    let astNames = [];
    if (dataType === (0, $e10a8602f56394e3$export$45c69700ee30a78c).influxQL && influxQLQueryType === (0, $59efbcd42a6b4649$export$e8d6de90187c4250).DataQuery) astNames = [
        defaultTimeField
    ];
    sortedLabels.forEach(({ label: label })=>{
        const field = {
            internalName: label,
            displayName: '',
            visible: true
        };
        astNames = [
            ...astNames,
            field
        ];
    });
    if (dataType === (0, $e10a8602f56394e3$export$45c69700ee30a78c).influxQL && influxQLQueryType === (0, $59efbcd42a6b4649$export$e8d6de90187c4250).MetaQuery) return astNames;
    const intersection = existingFieldOptions.filter((f)=>{
        return astNames.find((a)=>a.internalName === f.internalName);
    });
    const newFields = astNames.filter((a)=>{
        return !existingFieldOptions.find((f)=>f.internalName === a.internalName);
    });
    return [
        ...intersection,
        ...newFields
    ];
};
const $182b28bda5c9878f$export$a837f502a233ed30 = (data, fieldOptions, timeFormat, verticalTimeAxis, decimalPlaces)=>{
    const timeFormatWidth = $182b28bda5c9878f$var$calculateTimeColumnWidth(timeFormat === '' ? (0, $9a9ec629fdd38845$export$c4d2eaadfa3c28df) : timeFormat);
    return (0, $4e86f29e59d731b4$export$61f84df1ca3d669)(data, (acc, row, r)=>{
        return $182b28bda5c9878f$var$updateMaxWidths(row, acc, data[0], r === 0, fieldOptions, timeFormatWidth, verticalTimeAxis, decimalPlaces);
    }, {
        widths: {},
        totalWidths: 0
    });
};
const $182b28bda5c9878f$export$554cd5520b0fdd6b = (data, fieldOptions)=>{
    const visibility = {};
    const filteredData = (0, $4e86f29e59d731b4$export$979fdb12e1580393)(data, (row, i)=>{
        return (0, $4e86f29e59d731b4$export$d3cadc0dbdb0aafa)(row, (col, j)=>{
            if (i === 0) {
                const foundField = fieldOptions.find((field)=>field.internalName === col);
                visibility[j] = foundField ? foundField.visible : true;
            }
            return visibility[j];
        });
    });
    return filteredData[0].length ? filteredData : [
        []
    ];
};
const $182b28bda5c9878f$export$1a306919e5294bf2 = (data, fieldOptions)=>{
    const fieldsSortOrder = fieldOptions.map((fieldOption)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).findIndex(data[0], (dataLabel)=>{
            return dataLabel === fieldOption.internalName;
        });
    });
    const filteredFieldSortOrder = fieldsSortOrder.filter((f)=>f !== -1);
    const orderedData = (0, $4e86f29e59d731b4$export$979fdb12e1580393)(data, (row)=>{
        return row.map((__, j, arr)=>arr[filteredFieldSortOrder[j]]);
    });
    return orderedData[0].length ? orderedData : [
        []
    ];
};
const $182b28bda5c9878f$export$5c02598d1d061cf8 = (data, sort)=>{
    const sortIndex = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).indexOf(data[0], sort.field);
    const dataValues = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).drop(data, 1);
    const sortedData = [
        data[0],
        ...(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).orderBy(dataValues, sortIndex, [
            sort.direction
        ])
    ];
    const sortedTimeVals = (0, $4e86f29e59d731b4$export$979fdb12e1580393)(sortedData, (r)=>r[0]);
    return {
        sortedData: sortedData,
        sortedTimeVals: sortedTimeVals
    };
};
const $182b28bda5c9878f$export$c3b0842aa945c548 = (data, sort, fieldOptions, tableOptions, timeFormat, decimalPlaces)=>{
    const { verticalTimeAxis: verticalTimeAxis } = tableOptions;
    const { sortedData: sortedData, sortedTimeVals: sortedTimeVals } = $182b28bda5c9878f$export$5c02598d1d061cf8(data, sort);
    const filteredData = $182b28bda5c9878f$export$554cd5520b0fdd6b(sortedData, fieldOptions);
    const orderedData = $182b28bda5c9878f$export$1a306919e5294bf2(filteredData, fieldOptions);
    const transformedData = verticalTimeAxis ? orderedData : (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).unzip(orderedData);
    const columnWidths = $182b28bda5c9878f$export$a837f502a233ed30(transformedData, fieldOptions, timeFormat, verticalTimeAxis, decimalPlaces);
    return {
        transformedData: transformedData,
        sortedTimeVals: sortedTimeVals,
        columnWidths: columnWidths
    };
};
const $182b28bda5c9878f$export$af8089bcf7a32f69 = (x)=>typeof x === 'number' || !isNaN(Number(x)) && !isNaN(parseFloat(x));
const $182b28bda5c9878f$export$8641a8e317a91205 = (cellData, decimalPlaces)=>{
    const cellValue = typeof cellData === 'number' ? cellData : parseFloat(cellData);
    if ((0, $e4e77e3c79ee997a$export$881c80522fdbdba7)(cellValue, decimalPlaces)) return (0, $e4e77e3c79ee997a$export$a81f732198733497)(cellValue, decimalPlaces);
    return `${cellValue}`;
};



var $hBdgJ = parcelRequire("hBdgJ");
const $e4e77e3c79ee997a$export$881c80522fdbdba7 = (value, decimalPlaces)=>(0, $hBdgJ.isFinite)(value) && decimalPlaces.isEnforced;
const $e4e77e3c79ee997a$export$a81f732198733497 = (value, decimalPlaces)=>{
    const { digits: digits } = decimalPlaces;
    if (!(0, $hBdgJ.isFinite)(digits)) return `${value}`;
    else if (digits < 0) return value.toFixed(0);
    else if (digits > 20) return value.toFixed(20);
    return value.toFixed(digits);
};
const $e4e77e3c79ee997a$export$54c7b4b3a1bb17ef = (stringValue, min, max)=>{
    if (!(0, $182b28bda5c9878f$export$af8089bcf7a32f69)(stringValue)) return min;
    const value = +parseFloat(stringValue).toFixed(0);
    if (value < +min) return min;
    else if (value > +max) return max;
    return `${value}`;
};





const $7360539980ea45cc$var$NOOP = ()=>{};
class $7360539980ea45cc$var$SingleStat extends (0, $NdCUR.PureComponent) {
    static{
        this.defaultProps = {
            prefix: '',
            suffix: '',
            onUpdateCellColors: $7360539980ea45cc$var$NOOP,
            fluxTablesToSingleStat: (0, $3a006c970d7cf650$export$a6385bddcc8e6b77).fluxTablesToSingleStat
        };
    }
    constructor(props){
        super(props), this.memoizedTimeSeriesToSingleStat = (0, $6c6177bbe259d59a$export$2e2bcd8739ae039)((0, $c86764ab25b18722$export$2e2bcd8739ae039), (0, $28d93691ce0d4d34$export$c02dfba073881d63));
        this.memoizedFluxTablesToSingleStat = (0, $6c6177bbe259d59a$export$2e2bcd8739ae039)(props.fluxTablesToSingleStat, (0, $28d93691ce0d4d34$export$12c6ee516c60b754));
        this.state = {
            isValidData: true
        };
    }
    async componentDidMount() {
        this.isComponentMounted = true;
        this.lastUUID = (0, $28d93691ce0d4d34$export$8b7313ca2ebb28e)(this.props.data, this.props.dataType);
        await this.dataToLastValues();
    }
    async componentDidUpdate(prevProps) {
        this.lastUUID = (0, $28d93691ce0d4d34$export$8b7313ca2ebb28e)(this.props.data, this.props.dataType);
        const isDataChanged = (0, $28d93691ce0d4d34$export$5857ed7288c181de)(prevProps, this.props);
        if (isDataChanged) await this.dataToLastValues();
    }
    componentWillUnmount() {
        this.isComponentMounted = false;
    }
    render() {
        if (!this.state.isValidData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $8ff1a4fbb307e59d$export$2e2bcd8739ae039), null);
        if (!this.state.lastValues) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h3", {
            className: "graph-spinner"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "single-stat",
            style: this.containerStyle
        }, this.resizerBox);
    }
    get renderShadow() {
        const { lineGraph: lineGraph } = this.props;
        return lineGraph && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "single-stat--shadow"
        });
    }
    get prefixSuffixValue() {
        const { prefix: prefix, suffix: suffix } = this.props;
        return `${prefix}${this.roundedLastValue}${suffix}`;
    }
    get lastValue() {
        const { lastValues: lastValues } = this.state;
        if (lastValues) {
            const { values: values, series: series } = lastValues;
            const firstAlphabeticalSeriesName = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).sortBy(series)[0];
            const firstAlphabeticalIndex = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).indexOf(series, firstAlphabeticalSeriesName);
            return Number(values[firstAlphabeticalIndex]);
        }
    }
    get roundedLastValue() {
        const { decimalPlaces: decimalPlaces } = this.props;
        if (this.lastValue === null || this.lastValue === undefined) return `${0}`;
        let roundedValue = `${this.lastValue}`;
        if ((0, $e4e77e3c79ee997a$export$881c80522fdbdba7)(this.lastValue, decimalPlaces)) roundedValue = (0, $e4e77e3c79ee997a$export$a81f732198733497)(this.lastValue, decimalPlaces);
        return this.formatToLocale(+roundedValue);
    }
    formatToLocale(n) {
        const maximumFractionDigits = 20;
        return n.toLocaleString(undefined, {
            maximumFractionDigits: maximumFractionDigits
        });
    }
    get containerStyle() {
        const { staticLegendHeight: staticLegendHeight } = this.props;
        const height = `calc(100% - ${staticLegendHeight + (0, $e10a8602f56394e3$export$50de07a219eb9c8c) * 2}px)`;
        const { backgroundColor: backgroundColor } = this.coloration;
        if (staticLegendHeight) return {
            backgroundColor: backgroundColor,
            height: height
        };
        return {
            backgroundColor: backgroundColor
        };
    }
    get coloration() {
        const { colors: colors, lineGraph: lineGraph, onUpdateCellColors: onUpdateCellColors } = this.props;
        const { lastValues: lastValues } = this.state;
        let lastValue = 0;
        if (lastValues) {
            const { values: values, series: series } = lastValues;
            const firstAlphabeticalSeriesName = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).sortBy(series)[0];
            const firstAlphabeticalIndex = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).indexOf(series, firstAlphabeticalSeriesName);
            lastValue = Number(values[firstAlphabeticalIndex]);
        }
        const { bgColor: bgColor, textColor: textColor } = (0, $e09670a2eb92b732$export$2c00ede3bdd18539)({
            colors: colors,
            lastValue: lastValue,
            cellType: lineGraph ? (0, $b4506126e09430df$export$705e36171f4cbbfe).LinePlusSingleStat : (0, $b4506126e09430df$export$705e36171f4cbbfe).SingleStat
        });
        onUpdateCellColors(bgColor, textColor);
        return {
            backgroundColor: bgColor,
            color: textColor
        };
    }
    get resizerBox() {
        const { lineGraph: lineGraph, cellHeight: cellHeight } = this.props;
        const { color: color } = this.coloration;
        if (lineGraph) {
            const className = (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('single-stat--value', {
                small: cellHeight <= (0, $28d93691ce0d4d34$export$259f24f30746f96e)
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
                className: className,
                style: {
                    color: color
                }
            }, this.prefixSuffixValue, this.renderShadow);
        }
        const viewBox = `0 0 ${this.prefixSuffixValue.length * 55} 100`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "single-stat--resizer"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("svg", {
            width: "100%",
            height: "100%",
            viewBox: viewBox,
            style: {
                display: 'block'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("text", {
            className: "single-stat--text",
            fontSize: "87",
            y: "59%",
            x: "50%",
            dominantBaseline: "middle",
            textAnchor: "middle",
            style: {
                fill: color
            }
        }, this.prefixSuffixValue)));
    }
    async dataToLastValues() {
        const { data: data, dataType: dataType } = this.props;
        let lastValues;
        let isValidData = true;
        try {
            if (dataType === (0, $e10a8602f56394e3$export$45c69700ee30a78c).flux) lastValues = await this.memoizedFluxTablesToSingleStat(data);
            else if (dataType === (0, $e10a8602f56394e3$export$45c69700ee30a78c).influxQL) lastValues = this.memoizedTimeSeriesToSingleStat(data);
            if (!this.isComponentMounted || this.lastUUID !== (0, $28d93691ce0d4d34$export$8b7313ca2ebb28e)(data, dataType)) return;
        } catch (err) {
            isValidData = false;
        }
        this.setState({
            lastValues: lastValues,
            isValidData: isValidData
        });
    }
}
var $7360539980ea45cc$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($7360539980ea45cc$var$SingleStat);








const $1d489b0ec51ec869$export$e9b32bd4274d2145 = async (tables)=>{
    const { labels: labels, dygraphsData: dygraphsData } = await (0, $3a006c970d7cf650$export$a6385bddcc8e6b77).fluxTablesToDygraph(tables);
    const timeSeries = (0, $4e86f29e59d731b4$export$979fdb12e1580393)(dygraphsData, ([time, ...values])=>[
            new Date(time),
            ...values
        ]);
    const dygraphSeries = labels.reduce((acc, label)=>({
            ...acc,
            [label]: {
                axis: 'y'
            }
        }), {});
    return {
        labels: labels,
        dygraphSeries: dygraphSeries,
        timeSeries: timeSeries
    };
};





class $955b06aab2478f91$var$LineGraph extends (0, $NdCUR.PureComponent) {
    static{
        this.defaultProps = {
            staticLegend: false
        };
    }
    constructor(props){
        super(props), this.isComponentMounted = false, this.isValidData = true, this.memoizedTimeSeriesToDygraph = (0, $6c6177bbe259d59a$export$2e2bcd8739ae039)((0, $4420ff9299c1c25c$export$6f8771e84995407d), (0, $28d93691ce0d4d34$export$c02dfba073881d63)), this.memoizedFluxTablesToDygraph = (0, $6c6177bbe259d59a$export$2e2bcd8739ae039)((0, $1d489b0ec51ec869$export$e9b32bd4274d2145), (0, $28d93691ce0d4d34$export$12c6ee516c60b754));
        this.state = {};
    }
    async componentDidMount() {
        this.isComponentMounted = true;
        const { data: data, dataType: dataType } = this.props;
        await this.parseTimeSeries(data, dataType);
    }
    componentWillUnmount() {
        this.isComponentMounted = false;
    }
    async parseTimeSeries(data, dataType) {
        let timeSeries;
        this.latestUUID = (0, $28d93691ce0d4d34$export$8b7313ca2ebb28e)(data, dataType);
        try {
            const { result: result, uuid: uuid } = await this.convertToDygraphData(data, dataType);
            timeSeries = result;
            if (!this.isComponentMounted || uuid !== this.latestUUID) return;
            this.isValidData = await (0, $3a006c970d7cf650$export$a6385bddcc8e6b77).validateDygraphData(timeSeries.timeSeries);
        } catch (err) {
            this.isValidData = false;
        }
        this.setState({
            timeSeries: timeSeries
        });
    }
    componentDidUpdate(prevProps) {
        const isDataChanged = (0, $28d93691ce0d4d34$export$5857ed7288c181de)(prevProps, this.props);
        if (this.props.loading === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done && isDataChanged) this.parseTimeSeries(this.props.data, this.props.dataType);
    }
    render() {
        if (!this.isValidData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $8ff1a4fbb307e59d$export$2e2bcd8739ae039), {
            onUpdateVisType: this.props.onUpdateVisType
        });
        const { data: data, axes: axes, type: type, colors: colors, cellID: cellID, onZoom: onZoom, loading: loading, queries: queries, dataType: dataType, timeRange: timeRange, cellHeight: cellHeight, staticLegend: staticLegend, decimalPlaces: decimalPlaces, handleSetHoverTime: handleSetHoverTime } = this.props;
        if (!this.state.timeSeries) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h3", {
            className: "graph-spinner"
        });
        const { labels: labels, timeSeries: timeSeries, dygraphSeries: dygraphSeries } = this.state.timeSeries;
        const options = {
            rightGap: 0,
            yRangePad: 10,
            labelsKMB: true,
            fillGraph: true,
            axisLabelWidth: 60,
            animatedZooms: true,
            drawAxesAtZero: true,
            axisLineColor: '#383846',
            gridLineColor: '#383846',
            connectSeparatedPoints: true,
            stepPlot: type === 'line-stepplot',
            stackedGraph: type === 'line-stacked'
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "dygraph graph--hasYLabel",
            style: this.style
        }, loading === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($955b06aab2478f91$var$GraphLoadingDots, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c99ab73e7002f8ba$export$2e2bcd8739ae039), {
            type: type,
            axes: axes,
            cellID: cellID,
            colors: colors,
            onZoom: onZoom,
            labels: labels,
            queries: queries,
            options: options,
            timeRange: timeRange,
            timeSeries: timeSeries,
            staticLegend: staticLegend,
            dygraphSeries: dygraphSeries,
            isGraphFilled: this.isGraphFilled,
            containerStyle: this.containerStyle,
            handleSetHoverTime: handleSetHoverTime
        }, type === (0, $b4506126e09430df$export$705e36171f4cbbfe).LinePlusSingleStat && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7360539980ea45cc$export$2e2bcd8739ae039), {
            data: data,
            dataType: dataType,
            lineGraph: true,
            colors: colors,
            prefix: this.prefix,
            suffix: this.suffix,
            cellHeight: cellHeight,
            decimalPlaces: decimalPlaces
        })));
    }
    get isGraphFilled() {
        const { type: type } = this.props;
        if (type === (0, $b4506126e09430df$export$705e36171f4cbbfe).LinePlusSingleStat) return false;
        return true;
    }
    get style() {
        return {
            height: '100%'
        };
    }
    get prefix() {
        const { axes: axes } = this.props;
        if (!axes) return '';
        return axes.y.prefix;
    }
    get suffix() {
        const { axes: axes } = this.props;
        if (!axes) return '';
        return axes.y.suffix;
    }
    get containerStyle() {
        return {
            width: 'calc(100% - 32px)',
            height: 'calc(100% - 16px)',
            position: 'absolute',
            top: '8px',
            left: '16px'
        };
    }
    async convertToDygraphData(data, dataType) {
        const { location: location } = this.props;
        let result;
        if (dataType === (0, $e10a8602f56394e3$export$45c69700ee30a78c).influxQL) result = await this.memoizedTimeSeriesToDygraph(data, location.pathname);
        if (dataType === (0, $e10a8602f56394e3$export$45c69700ee30a78c).flux) result = await this.memoizedFluxTablesToDygraph(data);
        return {
            result: result,
            uuid: (0, $28d93691ce0d4d34$export$8b7313ca2ebb28e)(data, dataType)
        };
    }
}
const $955b06aab2478f91$var$GraphLoadingDots = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "graph-panel__refreshing"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null));
var $955b06aab2478f91$export$2e2bcd8739ae039 = (0, $dffbdf89c590a961$export$2e2bcd8739ae039)((0, $855a64e5014f72b2$export$54c2ee5106b5cb32)((0, $8ff1a4fbb307e59d$export$2e2bcd8739ae039))($955b06aab2478f91$var$LineGraph));


// Libraries

var $NdCUR = parcelRequire("NdCUR");

// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");
const $5d5cbf73876c1ac2$export$5b938290db9a35a9 = {
    degree: Math.PI / 180,
    lineCount: 5,
    smallLineCount: 10,
    lineColor: '#545667',
    labelColor: '#8E91A1',
    labelFontSize: 13,
    lineStrokeSmall: 1,
    lineStrokeLarge: 3,
    tickSizeSmall: 9,
    tickSizeLarge: 18,
    minFontSize: 22,
    minLineWidth: 24,
    valueColor: '#ffffff',
    needleColor0: '#434453',
    needleColor1: '#ffffff'
};





class $1d7f28243064e9cb$var$Gauge extends (0, $NdCUR.Component) {
    constructor(props){
        super(props), this.resetCanvas = (canvas, context)=>{
            context.setTransform(1, 0, 0, 1, 0, 0);
            context.clearRect(0, 0, canvas.width, canvas.height);
        }, this.updateCanvas = ()=>{
            const canvas = this.canvasRef.current;
            canvas.width = canvas.height * (canvas.clientWidth / canvas.clientHeight);
            const ctx = canvas.getContext('2d');
            this.resetCanvas(canvas, ctx);
            const centerX = canvas.width / 2;
            const centerY = canvas.height / 2 * 1.13;
            const radius = Math.min(canvas.width, canvas.height) / 2 * 0.5;
            const { minLineWidth: minLineWidth, minFontSize: minFontSize } = (0, $5d5cbf73876c1ac2$export$5b938290db9a35a9);
            const gradientThickness = Math.max(minLineWidth, radius / 4);
            const labelValueFontSize = Math.max(minFontSize, radius / 4);
            const { colors: colors } = this.props;
            if (!colors || colors.length === 0) return;
            // Distill out max and min values
            const minValue = Number(colors.find((color)=>color.type === (0, $687ef8d4c4e21a50$export$16b5ae62e2387119)).value);
            const maxValue = Number(colors.find((color)=>color.type === (0, $687ef8d4c4e21a50$export$3da69863bfecc247)).value);
            // The following functions must be called in the specified order
            if (colors.length === (0, $687ef8d4c4e21a50$export$1ffb333534e7f6f7)) this.drawGradientGauge(ctx, centerX, centerY, radius, gradientThickness);
            else this.drawSegmentedGauge(ctx, centerX, centerY, radius, minValue, maxValue, gradientThickness);
            this.drawGaugeLines(ctx, centerX, centerY, radius, gradientThickness);
            this.drawGaugeLabels(ctx, radius, gradientThickness, minValue, maxValue);
            this.drawGaugeValue(ctx, radius, labelValueFontSize);
            this.drawNeedle(ctx, radius, minValue, maxValue);
        }, this.drawGradientGauge = (ctx, xc, yc, r, gradientThickness)=>{
            const { colors: colors } = this.props;
            const sortedColors = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).sortBy(colors, (color)=>Number(color.value));
            const arcStart = Math.PI * 0.75;
            const arcEnd = arcStart + Math.PI * 1.5;
            // Determine coordinates for gradient
            const xStart = xc + Math.cos(arcStart) * r;
            const yStart = yc + Math.sin(arcStart) * r;
            const xEnd = xc + Math.cos(arcEnd) * r;
            const yEnd = yc + Math.sin(arcEnd) * r;
            const gradient = ctx.createLinearGradient(xStart, yStart, xEnd, yEnd);
            gradient.addColorStop(0, sortedColors[0].hex);
            gradient.addColorStop(1.0, sortedColors[1].hex);
            ctx.beginPath();
            ctx.lineWidth = gradientThickness;
            ctx.strokeStyle = gradient;
            ctx.arc(xc, yc, r, arcStart, arcEnd);
            ctx.stroke();
        }, this.drawSegmentedGauge = (ctx, xc, yc, r, minValue, maxValue, gradientThickness)=>{
            const { colors: colors } = this.props;
            const sortedColors = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).sortBy(colors, (color)=>Number(color.value));
            const trueValueRange = Math.abs(maxValue - minValue);
            const totalArcLength = Math.PI * 1.5;
            let startingPoint = Math.PI * 0.75;
            // Iterate through colors, draw arc for each
            for(let c = 0; c < sortedColors.length - 1; c++){
                // Use this color and the next to determine arc length
                const color = sortedColors[c];
                const nextColor = sortedColors[c + 1];
                // adjust values by subtracting minValue from them
                const adjustedValue = Number(color.value) - minValue;
                const adjustedNextValue = Number(nextColor.value) - minValue;
                const thisArc = Math.abs(adjustedValue - adjustedNextValue);
                // Multiply by arcLength to determine this arc's length
                const arcLength = totalArcLength * (thisArc / trueValueRange);
                // Draw arc
                ctx.beginPath();
                ctx.lineWidth = gradientThickness;
                ctx.strokeStyle = color.hex;
                ctx.arc(xc, yc, r, startingPoint, startingPoint + arcLength);
                ctx.stroke();
                // Add this arc's length to starting point
                startingPoint += arcLength;
            }
        }, this.drawGaugeLines = (ctx, xc, yc, radius, gradientThickness)=>{
            const { degree: degree, lineCount: lineCount, lineColor: lineColor, lineStrokeSmall: lineStrokeSmall, lineStrokeLarge: lineStrokeLarge, tickSizeSmall: tickSizeSmall, tickSizeLarge: tickSizeLarge, smallLineCount: smallLineCount } = (0, $5d5cbf73876c1ac2$export$5b938290db9a35a9);
            const arcStart = Math.PI * 0.75;
            const arcLength = Math.PI * 1.5;
            const arcStop = arcStart + arcLength;
            const totalSmallLineCount = lineCount * smallLineCount;
            const startDegree = degree * 135;
            const arcLargeIncrement = arcLength / lineCount;
            const arcSmallIncrement = arcLength / totalSmallLineCount;
            // Semi-circle
            const arcRadius = radius + gradientThickness * 0.8;
            ctx.beginPath();
            ctx.arc(xc, yc, arcRadius, arcStart, arcStop);
            ctx.lineWidth = 3;
            ctx.lineCap = 'round';
            ctx.strokeStyle = lineColor;
            ctx.stroke();
            ctx.closePath();
            // Match center of canvas to center of gauge
            ctx.translate(xc, yc);
            // Draw Large ticks
            for(let lt = 0; lt <= lineCount; lt++){
                // Rototion before drawing line
                ctx.rotate(startDegree);
                ctx.rotate(lt * arcLargeIncrement);
                // Draw line
                ctx.beginPath();
                ctx.lineWidth = lineStrokeLarge;
                ctx.lineCap = 'round';
                ctx.strokeStyle = lineColor;
                ctx.moveTo(arcRadius, 0);
                ctx.lineTo(arcRadius + tickSizeLarge, 0);
                ctx.stroke();
                ctx.closePath();
                // Return to starting rotation
                ctx.rotate(-lt * arcLargeIncrement);
                ctx.rotate(-startDegree);
            }
            // Draw Small ticks
            for(let lt = 0; lt <= totalSmallLineCount; lt++){
                // Rototion before drawing line
                ctx.rotate(startDegree);
                ctx.rotate(lt * arcSmallIncrement);
                // Draw line
                ctx.beginPath();
                ctx.lineWidth = lineStrokeSmall;
                ctx.lineCap = 'round';
                ctx.strokeStyle = lineColor;
                ctx.moveTo(arcRadius, 0);
                ctx.lineTo(arcRadius + tickSizeSmall, 0);
                ctx.stroke();
                ctx.closePath();
                // Return to starting rotation
                ctx.rotate(-lt * arcSmallIncrement);
                ctx.rotate(-startDegree);
            }
        }, this.drawGaugeLabels = (ctx, radius, gradientThickness, minValue, maxValue)=>{
            const { prefix: prefix, suffix: suffix } = this.props;
            const { degree: degree, lineCount: lineCount, labelColor: labelColor, labelFontSize: labelFontSize } = (0, $5d5cbf73876c1ac2$export$5b938290db9a35a9);
            const incrementValue = (maxValue - minValue) / lineCount;
            const gaugeValues = [];
            for(let g = minValue; g < maxValue; g += incrementValue){
                const valueString = this.labelToString(g);
                gaugeValues.push(valueString);
            }
            gaugeValues.push(this.labelToString(maxValue));
            const startDegree = degree * 135;
            const arcLength = Math.PI * 1.5;
            const arcIncrement = arcLength / lineCount;
            // Format labels text
            ctx.font = `bold ${labelFontSize}px Helvetica`;
            ctx.fillStyle = labelColor;
            ctx.textBaseline = 'middle';
            ctx.textAlign = 'right';
            let labelRadius;
            for(let i = 0; i <= lineCount; i++){
                if (i === 3) {
                    ctx.textAlign = 'center';
                    labelRadius = radius + gradientThickness + 30;
                } else labelRadius = radius + gradientThickness + 23;
                if (i > 3) ctx.textAlign = 'left';
                const labelText = `${prefix}${gaugeValues[i]}${suffix}`;
                ctx.rotate(startDegree);
                ctx.rotate(i * arcIncrement);
                ctx.translate(labelRadius, 0);
                ctx.rotate(i * -arcIncrement);
                ctx.rotate(-startDegree);
                ctx.fillText(labelText, 0, 0);
                ctx.rotate(startDegree);
                ctx.rotate(i * arcIncrement);
                ctx.translate(-labelRadius, 0);
                ctx.rotate(i * -arcIncrement);
                ctx.rotate(-startDegree);
            }
        }, this.drawGaugeValue = (ctx, radius, labelValueFontSize)=>{
            const { gaugePosition: gaugePosition, prefix: prefix, suffix: suffix } = this.props;
            const { valueColor: valueColor } = (0, $5d5cbf73876c1ac2$export$5b938290db9a35a9);
            ctx.font = `${labelValueFontSize}px Roboto`;
            ctx.fillStyle = valueColor;
            ctx.textBaseline = 'middle';
            ctx.textAlign = 'center';
            const valueString = this.valueToString(gaugePosition);
            const textY = radius;
            const textContent = `${prefix}${valueString}${suffix}`;
            ctx.fillText(textContent, 0, textY);
        }, this.drawNeedle = (ctx, radius, minValue, maxValue)=>{
            const { gaugePosition: gaugePosition } = this.props;
            const { degree: degree, needleColor0: needleColor0, needleColor1: needleColor1 } = (0, $5d5cbf73876c1ac2$export$5b938290db9a35a9);
            const arcDistance = Math.PI * 1.5;
            const limitedGaugePosition = Math.max(Math.min(gaugePosition, maxValue), minValue);
            const needleRotation = (limitedGaugePosition - minValue) / (maxValue - minValue);
            const needleGradient = ctx.createLinearGradient(0, -10, 0, radius);
            needleGradient.addColorStop(0, needleColor0);
            needleGradient.addColorStop(1, needleColor1);
            // Starting position of needle is at minimum
            ctx.rotate(degree * 45);
            ctx.rotate(arcDistance * needleRotation);
            ctx.beginPath();
            ctx.fillStyle = needleGradient;
            ctx.arc(0, 0, 10, 0, Math.PI, true);
            ctx.lineTo(0, radius);
            ctx.lineTo(10, 0);
            ctx.fill();
        };
        this.canvasRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createRef();
    }
    componentDidMount() {
        this.updateCanvas();
    }
    componentDidUpdate() {
        this.updateCanvas();
    }
    render() {
        const { width: width, height: height } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("canvas", {
            className: "gauge",
            width: width,
            height: height,
            ref: this.canvasRef
        });
    }
    labelToString(value) {
        const { decimalPlaces: decimalPlaces } = this.props;
        let valueString;
        if (decimalPlaces.isEnforced) {
            const digits = Math.min(decimalPlaces.digits, (0, $9a9ec629fdd38845$export$88bc046c68ada5a7));
            valueString = value.toLocaleString(undefined, {
                minimumFractionDigits: 0,
                maximumFractionDigits: digits
            });
        } else valueString = value.toLocaleString(undefined, {
            minimumFractionDigits: 0,
            maximumFractionDigits: (0, $9a9ec629fdd38845$export$88bc046c68ada5a7)
        });
        return valueString;
    }
    valueToString(value) {
        const { decimalPlaces: decimalPlaces } = this.props;
        let valueString;
        if (decimalPlaces.isEnforced) {
            const digits = Math.min(decimalPlaces.digits, (0, $9a9ec629fdd38845$export$88bc046c68ada5a7));
            valueString = value.toLocaleString(undefined, {
                minimumFractionDigits: digits,
                maximumFractionDigits: digits
            });
        } else valueString = value.toLocaleString(undefined, {
            minimumFractionDigits: 0,
            maximumFractionDigits: (0, $9a9ec629fdd38845$export$88bc046c68ada5a7)
        });
        return valueString;
    }
}
var $1d7f28243064e9cb$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($1d7f28243064e9cb$var$Gauge);











class $16970b6bda664789$var$GaugeChart extends (0, $NdCUR.PureComponent) {
    static{
        this.defaultProps = {
            colors: (0, $e09670a2eb92b732$export$ee00554e37fca064)((0, $687ef8d4c4e21a50$export$b9b550d6033567cd)),
            fluxTablesToSingleStat: (0, $3a006c970d7cf650$export$a6385bddcc8e6b77).fluxTablesToSingleStat
        };
    }
    constructor(props){
        super(props), this.memoizedTimeSeriesToSingleStat = (0, $6c6177bbe259d59a$export$2e2bcd8739ae039)((0, $c86764ab25b18722$export$2e2bcd8739ae039), (0, $28d93691ce0d4d34$export$c02dfba073881d63));
        this.memoizedFluxTablesToSingleStat = (0, $6c6177bbe259d59a$export$2e2bcd8739ae039)(props.fluxTablesToSingleStat, (0, $28d93691ce0d4d34$export$12c6ee516c60b754));
        this.state = {
            isValidData: true
        };
    }
    async componentDidMount() {
        this.isComponentMounted = true;
        this.lastUUID = (0, $28d93691ce0d4d34$export$8b7313ca2ebb28e)(this.props.data, this.props.dataType);
        await this.dataToLastValues();
    }
    async componentDidUpdate(prevProps) {
        const isDataChanged = (0, $28d93691ce0d4d34$export$5857ed7288c181de)(prevProps, this.props);
        this.lastUUID = (0, $28d93691ce0d4d34$export$8b7313ca2ebb28e)(this.props.data, this.props.dataType);
        if (isDataChanged) await this.dataToLastValues();
    }
    componentWillUnmount() {
        this.isComponentMounted = false;
    }
    render() {
        const { colors: colors, prefix: prefix, suffix: suffix, decimalPlaces: decimalPlaces } = this.props;
        if (!this.state.isValidData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $8ff1a4fbb307e59d$export$2e2bcd8739ae039), null);
        if (!this.state.lastValues) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h3", {
            className: "graph-spinner"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "single-stat"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1d7f28243064e9cb$export$2e2bcd8739ae039), {
            width: "900",
            colors: colors,
            height: this.height,
            prefix: prefix,
            suffix: suffix,
            gaugePosition: this.lastValueForGauge,
            decimalPlaces: decimalPlaces
        }));
    }
    get height() {
        const { resizerTopHeight: resizerTopHeight } = this.props;
        return (this.initialCellHeight || resizerTopHeight || 300).toString();
    }
    get initialCellHeight() {
        const { cellHeight: cellHeight } = this.props;
        if (cellHeight) return (cellHeight * (0, $e10a8602f56394e3$export$13d5843c9841853c)).toString();
        return null;
    }
    get lastValueForGauge() {
        const { lastValues: lastValues } = this.state;
        const lastValue = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(lastValues, 'values.0', 0);
        switch(typeof lastValue){
            case 'number':
            case 'string':
                return Number(lastValue);
            default:
                return 0;
        }
    }
    async dataToLastValues() {
        const { data: data, dataType: dataType } = this.props;
        let lastValues;
        let isValidData = true;
        try {
            if (dataType === (0, $e10a8602f56394e3$export$45c69700ee30a78c).flux) lastValues = await this.memoizedFluxTablesToSingleStat(data);
            else if (dataType === (0, $e10a8602f56394e3$export$45c69700ee30a78c).influxQL) lastValues = this.memoizedTimeSeriesToSingleStat(data);
            if (!this.isComponentMounted || this.lastUUID !== (0, $28d93691ce0d4d34$export$8b7313ca2ebb28e)(data, dataType)) return;
        } catch (err) {
            isValidData = false;
        }
        this.setState({
            lastValues: lastValues,
            isValidData: isValidData
        });
    }
}
var $16970b6bda664789$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($16970b6bda664789$var$GaugeChart);


// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");

var $1v7mg = parcelRequire("1v7mg");


var $axd2S = parcelRequire("axd2S");

/* eslint-disable @typescript-eslint/no-empty-object-type */ 
var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");


const $770c9b085403cbf9$var$SCROLLBAR_SIZE_BUFFER = 20;
const $770c9b085403cbf9$var$ROW_HEIGHT = 30;
const $770c9b085403cbf9$var$VSCROLLBAR_WIDTH = 12;
class $770c9b085403cbf9$var$MultiGrid extends $NdCUR.PureComponent {
    static{
        this.defaultProps = {
            classNameBottomLeftGrid: '',
            classNameBottomRightGrid: '',
            classNameTopLeftGrid: '',
            classNameTopRightGrid: '',
            fixedColumnCount: 0,
            fixedRowCount: 0,
            scrollToColumn: -1,
            scrollToRow: -1,
            styleBottomLeftGrid: {},
            styleBottomRightGrid: {},
            styleTopLeftGrid: {},
            styleTopRightGrid: {}
        };
    }
    static getDerivedStateFromProps(nextProps) {
        const { scrollToRow: scrollToRow, rowCount: rowCount, height: height } = nextProps;
        const scrollTop = scrollToRow * $770c9b085403cbf9$var$ROW_HEIGHT;
        const maxScrollTop = (rowCount + 1) * $770c9b085403cbf9$var$ROW_HEIGHT - (height + $770c9b085403cbf9$var$ROW_HEIGHT);
        const visibleRowsCount = Math.floor(height / $770c9b085403cbf9$var$ROW_HEIGHT);
        const maxRow = rowCount - visibleRowsCount / 2;
        // hovering on this grid
        if (scrollTop < 0) return {
            scrollToRow: scrollToRow
        };
        if (scrollToRow > maxRow) return {
            scrollToRow: rowCount
        };
        if (scrollTop > maxScrollTop) return {
            scrollTop: maxScrollTop
        };
        // hovering on another cell
        return {
            scrollToRow: scrollToRow - 1,
            scrollTop: Math.max(scrollToRow * $770c9b085403cbf9$var$ROW_HEIGHT - $770c9b085403cbf9$var$ROW_HEIGHT, 0)
        };
    }
    constructor(props, context){
        super(props, context), this.leftGridWidth = 0, this.topGridHeight = 0, this.cellRendererBottomLeftGrid = ({ rowIndex: rowIndex, ...rest })=>{
            const { cellRenderer: cellRenderer, fixedRowCount: fixedRowCount, rowCount: rowCount } = this.props;
            if (rowIndex === rowCount - fixedRowCount) return /*#__PURE__*/ $NdCUR.createElement("div", {
                key: rest.key,
                style: {
                    ...rest.style,
                    height: $770c9b085403cbf9$var$SCROLLBAR_SIZE_BUFFER
                }
            });
            return cellRenderer({
                ...rest,
                style: {
                    ...rest.style
                },
                parent: this,
                rowIndex: rowIndex + fixedRowCount
            });
        }, this.onScrollbarsScroll = (e)=>{
            const { scrollTop: scrollTop } = e.target;
            const { scrollLeft: scrollLeft } = this.state;
            this.onScroll({
                scrollTop: scrollTop,
                scrollLeft: scrollLeft
            });
        }, this.onGridScroll = ({ scrollLeft: scrollLeft })=>{
            const { scrollTop: scrollTop } = this.state;
            this.onScroll({
                scrollTop: scrollTop,
                scrollLeft: scrollLeft
            });
        }, this.onScroll = (scrollInfo)=>{
            const { onScroll: onScroll, externalScroll: externalScroll } = this.props;
            const { scrollLeft: scrollLeft, scrollTop: scrollTop } = scrollInfo;
            if (externalScroll) return;
            this.setState({
                scrollLeft: scrollLeft,
                scrollTop: scrollTop
            });
            if (onScroll) onScroll(scrollInfo);
        }, this.getCalculatedRowHeight = (height, calculatedRowCount)=>{
            const calculatedRowHeight = calculatedRowCount !== 0 ? height / calculatedRowCount : 0;
            return Math.max(calculatedRowHeight, $770c9b085403cbf9$var$ROW_HEIGHT);
        }, this.topLeftGridRef = (ref)=>{
            this.topLeftGrid = ref;
        }, this.topRightGridRef = (ref)=>{
            this.topRightGrid = ref;
        }, this.bottomLeftGridRef = (ref)=>{
            this.bottomLeftGrid = ref;
        }, this.bottomRightGridRef = (ref)=>{
            this.bottomRightGrid = ref;
        }, this.cellRendererBottomRightGrid = ({ columnIndex: columnIndex, rowIndex: rowIndex, ...rest })=>{
            const { cellRenderer: cellRenderer, fixedColumnCount: fixedColumnCount, fixedRowCount: fixedRowCount } = this.props;
            return cellRenderer({
                ...rest,
                columnIndex: columnIndex + fixedColumnCount,
                parent: this,
                rowIndex: rowIndex + fixedRowCount
            });
        }, this.cellRendererTopRightGrid = ({ columnIndex: columnIndex, ...rest })=>{
            const { cellRenderer: cellRenderer, columnCount: columnCount, fixedColumnCount: fixedColumnCount } = this.props;
            if (columnIndex === columnCount - fixedColumnCount) return /*#__PURE__*/ $NdCUR.createElement("div", {
                key: rest.key,
                style: {
                    ...rest.style,
                    width: $770c9b085403cbf9$var$SCROLLBAR_SIZE_BUFFER
                }
            });
            return cellRenderer({
                ...rest,
                columnIndex: columnIndex + fixedColumnCount,
                parent: this
            });
        }, this.columnWidthRightGrid = ({ index: index })=>{
            const { columnCount: columnCount, fixedColumnCount: fixedColumnCount, columnWidth: columnWidth } = this.props;
            const { scrollbarSize: scrollbarSize, showHorizontalScrollbar: showHorizontalScrollbar } = this.state;
            // An extra cell is added to the count
            // This gives the smaller Grid extra room for offset,
            // In case the main (bottom right) Grid has a scrollbar
            // If no scrollbar, the extra space is overflow:hidden anyway
            if (showHorizontalScrollbar && index === columnCount - fixedColumnCount) return scrollbarSize;
            return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isFunction(columnWidth) ? columnWidth({
                index: index + fixedColumnCount
            }) : columnWidth;
        };
        this.state = {
            scrollToRow: props.scrollToRow,
            scrollLeft: 0,
            scrollTop: 0,
            scrollbarSize: 0,
            showHorizontalScrollbar: false,
            showVerticalScrollbar: false
        };
    }
    recomputeGridSize({ columnIndex: columnIndex = 0, rowIndex: rowIndex = 0 } = {}) {
        const { fixedColumnCount: fixedColumnCount, fixedRowCount: fixedRowCount } = this.props;
        const adjustedColumnIndex = Math.max(0, columnIndex - fixedColumnCount);
        const adjustedRowIndex = Math.max(0, rowIndex - fixedRowCount);
        if (this.bottomLeftGrid) this.bottomLeftGrid.recomputeGridSize({
            columnIndex: columnIndex,
            rowIndex: adjustedRowIndex
        });
        if (this.bottomRightGrid) this.bottomRightGrid.recomputeGridSize({
            columnIndex: adjustedColumnIndex,
            rowIndex: adjustedRowIndex
        });
        if (this.topLeftGrid) this.topLeftGrid.recomputeGridSize({
            columnIndex: columnIndex,
            rowIndex: rowIndex
        });
        if (this.topRightGrid) this.topRightGrid.recomputeGridSize({
            columnIndex: adjustedColumnIndex,
            rowIndex: rowIndex
        });
        this.leftGridWidth = null;
        this.topGridHeight = null;
        this.maybeCalculateCachedStyles(true);
    }
    componentDidMount() {
        if (this.props.onMount) this.props.onMount(this);
    }
    componentDidUpdate() {
        if (this.topRightGrid) this.topRightGrid.forceUpdate();
    }
    render() {
        const { onScroll: onScroll, ...rest } = this.props;
        this.prepareForRender();
        if (this.props.width === 0 || this.props.height === 0) return null;
        const { scrollLeft: scrollLeft, scrollTop: scrollTop } = this.state;
        return /*#__PURE__*/ $NdCUR.createElement("div", {
            style: this.containerOuterStyle
        }, /*#__PURE__*/ $NdCUR.createElement("div", {
            style: this.containerTopStyle
        }, this.renderTopLeftGrid(rest), this.renderTopRightGrid({
            ...rest,
            ...onScroll,
            scrollLeft: scrollLeft
        })), /*#__PURE__*/ $NdCUR.createElement("div", {
            style: this.containerBottomStyle
        }, this.renderBottomLeftGrid({
            ...rest,
            onScroll: onScroll,
            scrollTop: scrollTop
        }), this.renderBottomRightGrid({
            ...rest,
            onScroll: onScroll,
            scrollLeft: scrollLeft,
            scrollTop: scrollTop
        })));
    }
    getLeftGridWidth(props) {
        const { fixedColumnCount: fixedColumnCount, columnWidth: columnWidth } = props;
        if (this.leftGridWidth === null) {
            if (typeof columnWidth === 'function') {
                let leftGridWidth = 0;
                for(let index = 0; index < fixedColumnCount; index++)leftGridWidth += columnWidth({
                    index: index
                });
                this.leftGridWidth = leftGridWidth;
            } else this.leftGridWidth = columnWidth * fixedColumnCount;
        }
        return this.leftGridWidth;
    }
    getRightGridWidth(props) {
        const { width: width } = props;
        return width - this.getLeftGridWidth(props);
    }
    getTopGridHeight(props) {
        const { fixedRowCount: fixedRowCount, rowHeight: rowHeight } = props;
        if (this.topGridHeight === null) {
            if (typeof rowHeight === 'function') {
                let topGridHeight = 0;
                for(let index = 0; index < fixedRowCount; index++)topGridHeight += rowHeight({
                    index: index
                });
                this.topGridHeight = topGridHeight;
            } else this.topGridHeight = rowHeight * fixedRowCount;
        }
        return this.topGridHeight;
    }
    renderBottomLeftGrid(props) {
        const { fixedColumnCount: fixedColumnCount, fixedRowCount: fixedRowCount, rowCount: rowCount, columnWidth: columnWidth } = props;
        const { scrollToRow: scrollToRow } = this.state;
        if (!fixedColumnCount) return null;
        const calculatedRowCount = Math.max(rowCount - fixedRowCount, 0);
        return /*#__PURE__*/ $NdCUR.createElement((0, $9cf5f10972873d72$export$2e2bcd8739ae039), null, ({ width: width, height: height })=>{
            // limit the visible width of fixed columns
            // for the vertical scrollbar to appear in this area
            const leftGridWidth = this.getLeftGridWidth(props);
            width = Math.min(width, leftGridWidth);
            return /*#__PURE__*/ $NdCUR.createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), {
                style: {
                    width: width,
                    height: this.props.height - $770c9b085403cbf9$var$ROW_HEIGHT
                },
                autoHide: true,
                scrollTop: this.state.scrollTop,
                scrollLeft: this.state.scrollLeft,
                setScrollTop: this.onScrollbarsScroll
            }, /*#__PURE__*/ $NdCUR.createElement((0, $df00be2467032761$export$2e2bcd8739ae039), {
                ...props,
                scrollToRow: scrollToRow,
                cellRenderer: this.cellRendererBottomLeftGrid,
                className: this.props.classNameBottomLeftGrid,
                columnCount: fixedColumnCount,
                height: height,
                ref: this.bottomLeftGridRef,
                rowCount: calculatedRowCount,
                rowHeight: this.getCalculatedRowHeight(height, calculatedRowCount),
                columnWidth: columnWidth,
                style: {
                    overflowY: 'hidden',
                    height: Math.max(calculatedRowCount * $770c9b085403cbf9$var$ROW_HEIGHT + $770c9b085403cbf9$var$SCROLLBAR_SIZE_BUFFER, height)
                },
                tabIndex: null,
                width: leftGridWidth
            }));
        });
    }
    renderBottomRightGrid(props) {
        const { columnCount: columnCount, fixedColumnCount: fixedColumnCount, fixedRowCount: fixedRowCount, rowCount: rowCount, scrollLeft: scrollLeft, scrollTop: scrollTop } = props;
        const { scrollToRow: scrollToRow } = this.state;
        const calculatedRowCount = Math.max(0, rowCount - fixedRowCount);
        const leftWidth = this.getLeftGridWidth(props);
        let passingProps = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).omit(props, [
            'scrollToColumn'
        ]);
        if (props.externalScroll) passingProps = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).omit(props, [
            'scrollToColumn',
            'scrollTop'
        ]);
        return /*#__PURE__*/ $NdCUR.createElement((0, $9cf5f10972873d72$export$2e2bcd8739ae039), null, ({ width: width, height: height })=>{
            const scrollPaneHeight = calculatedRowCount * $770c9b085403cbf9$var$ROW_HEIGHT + $770c9b085403cbf9$var$SCROLLBAR_SIZE_BUFFER;
            const verticalScrollbarWidth = scrollPaneHeight <= height ? 0 : $770c9b085403cbf9$var$VSCROLLBAR_WIDTH;
            const lastColumnIndex = columnCount - fixedColumnCount - 1;
            let columnWidth = this.columnWidthRightGrid;
            if (verticalScrollbarWidth !== 0) // adjust the last column so that the vertical scrollbar
            // is not placed over the contents of the column
            columnWidth = (params)=>{
                const colWidth = this.columnWidthRightGrid(params);
                return params.index === lastColumnIndex ? colWidth - verticalScrollbarWidth : colWidth;
            };
            return /*#__PURE__*/ $NdCUR.createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), {
                style: {
                    marginLeft: leftWidth,
                    width: this.props.width - leftWidth,
                    height: this.props.height - $770c9b085403cbf9$var$ROW_HEIGHT
                },
                autoHide: verticalScrollbarWidth === 0,
                scrollTop: scrollTop,
                scrollLeft: scrollLeft,
                setScrollTop: this.onScrollbarsScroll
            }, /*#__PURE__*/ $NdCUR.createElement((0, $df00be2467032761$export$2e2bcd8739ae039), {
                ...passingProps,
                cellRenderer: this.cellRendererBottomRightGrid,
                className: this.props.classNameBottomRightGrid,
                columnCount: Math.max(0, lastColumnIndex + 1),
                columnWidth: columnWidth,
                overscanRowCount: 100,
                height: height,
                ref: this.bottomRightGridRef,
                onScroll: this.onGridScroll,
                rowCount: calculatedRowCount,
                rowHeight: this.getCalculatedRowHeight(height, calculatedRowCount),
                scrollToRow: scrollToRow - fixedRowCount,
                style: {
                    overflowY: 'hidden',
                    height: Math.max(scrollPaneHeight, height)
                },
                width: width - leftWidth - verticalScrollbarWidth
            }));
        });
    }
    renderTopLeftGrid(props) {
        const { fixedColumnCount: fixedColumnCount, fixedRowCount: fixedRowCount } = props;
        if (!fixedColumnCount || !fixedRowCount) return null;
        return /*#__PURE__*/ $NdCUR.createElement((0, $df00be2467032761$export$2e2bcd8739ae039), {
            ...props,
            className: this.props.classNameTopLeftGrid,
            columnCount: fixedColumnCount,
            height: this.getTopGridHeight(props),
            ref: this.topLeftGridRef,
            rowCount: fixedRowCount,
            style: this.topLeftGridStyle,
            tabIndex: null,
            width: this.getLeftGridWidth(props)
        });
    }
    renderTopRightGrid(props) {
        const { columnCount: columnCount, fixedColumnCount: fixedColumnCount, fixedRowCount: fixedRowCount, scrollLeft: scrollLeft } = props;
        if (!fixedRowCount) return null;
        const width = this.getRightGridWidth(props);
        const height = this.getTopGridHeight(props);
        return /*#__PURE__*/ $NdCUR.createElement((0, $df00be2467032761$export$2e2bcd8739ae039), {
            ...props,
            cellRenderer: this.cellRendererTopRightGrid,
            className: this.props.classNameTopRightGrid,
            columnCount: Math.max(0, columnCount - fixedColumnCount),
            columnWidth: this.columnWidthRightGrid,
            height: height,
            onScroll: this.onGridScroll,
            ref: this.topRightGridRef,
            rowCount: fixedRowCount,
            scrollLeft: scrollLeft,
            style: this.topRightGridStyle,
            tabIndex: null,
            width: width
        });
    }
    /**
   * Avoid recreating inline styles each render; this bypasses Grid's shallowCompare.
   * This method recalculates styles only when specific props change.
   */ maybeCalculateCachedStyles(resetAll) {
        const { height: height, width: width } = this.props;
        if (resetAll) this.containerOuterStyle = {
            height: height,
            overflow: 'visible',
            width: width
        };
        if (resetAll) {
            this.containerTopStyle = {
                height: this.getTopGridHeight(this.props),
                position: 'relative',
                width: width
            };
            this.containerBottomStyle = {
                height: height - this.getTopGridHeight(this.props),
                overflow: 'visible',
                position: 'relative',
                width: width
            };
        }
        if (resetAll) this.topLeftGridStyle = {
            left: 0,
            overflowX: 'hidden',
            overflowY: 'hidden',
            position: 'absolute',
            top: 0
        };
        if (resetAll) this.topRightGridStyle = {
            left: this.getLeftGridWidth(this.props),
            overflowX: 'hidden',
            overflowY: 'hidden',
            position: 'absolute',
            top: 0
        };
    }
    prepareForRender() {
        this.maybeCalculateCachedStyles(false);
    }
}
var $770c9b085403cbf9$export$2e2bcd8739ae039 = $770c9b085403cbf9$var$MultiGrid;











const $2f794503406fd30c$var$COLUMN_MIN_WIDTH = 100;
const $2f794503406fd30c$var$ROW_HEIGHT = 30;
class $2f794503406fd30c$export$379b400cc0e0b9f8 extends (0, $NdCUR.PureComponent) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "table-graph-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $855a64e5014f72b2$export$c73ca302efeda3b4), {
            error: this.props.error
        }));
    }
}
class $2f794503406fd30c$var$TableGraph extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleMultiGridMount = (ref)=>{
            this.multiGrid = ref;
            ref.forceUpdate();
        }, this.handleUpdateFieldOptions = (fieldOptions)=>{
            const { onUpdateFieldOptions: onUpdateFieldOptions } = this.props;
            if (onUpdateFieldOptions) onUpdateFieldOptions(fieldOptions);
        }, this.handleHover = (e)=>{
            const { dataset: dataset } = e.target;
            const { handleSetHoverTime: handleSetHoverTime } = this.props;
            const { data: { sortedTimeVals: sortedTimeVals } } = this.props;
            const { isTimeVisible: isTimeVisible } = this.state;
            if (this.isVerticalTimeAxis && +dataset.rowIndex === 0) return;
            if (handleSetHoverTime && isTimeVisible) {
                const hoverTime = this.isVerticalTimeAxis ? sortedTimeVals[dataset.rowIndex] : sortedTimeVals[dataset.columnIndex];
                handleSetHoverTime((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).defaultTo(hoverTime, '').toString());
            }
            this.setState({
                hoveredColumnIndex: +dataset.columnIndex,
                hoveredRowIndex: +dataset.rowIndex
            });
        }, this.handleMouseLeave = ()=>{
            if (this.props.handleSetHoverTime) {
                this.props.handleSetHoverTime((0, $93a523326aa94673$export$f248303b5fb71ab5));
                this.setState({
                    hoveredColumnIndex: (0, $93a523326aa94673$export$f934297ec188c667),
                    hoveredRowIndex: (0, $93a523326aa94673$export$f934297ec188c667)
                });
            }
        }, this.handleClickFieldName = (clickedFieldName)=>async ()=>{
                this.props.onSort(clickedFieldName);
            }, // adjustedWidth is the size of the table
        // columnSizerWidth is the size of the table / the amount of columns
        this.calculateColumnWidth = (columnSizerWidth, adjustedWidth)=>(column)=>{
                const { index: index } = column;
                const { data: { transformedData: transformedData, columnWidths: { widths: columnWidths, totalWidths: totalColumnWidths } } } = this.props;
                const columnLabel = transformedData[0][index];
                const original = columnWidths[columnLabel];
                if (original > adjustedWidth) // if the original calculated size of the column is greater than the table size
                // use the table size - half the average column size to determine the size of the column
                return adjustedWidth - columnSizerWidth / 2;
                if (this.fixFirstColumn && index === 0) return original;
                if (adjustedWidth <= totalColumnWidths) return original;
                if (this.columnCount <= 1) return columnSizerWidth;
                const difference = adjustedWidth - totalColumnWidths;
                const increment = difference / this.computedColumnCount;
                return original + increment;
            }, this.createCellContents = (cellData, fieldName, isTimeData, isFieldName)=>{
            const { timeFormat: timeFormat, timeZone: timeZone, decimalPlaces: decimalPlaces } = this.props;
            if (isTimeData) {
                if (timeZone === (0, $a7b864c61f4e95a7$export$d6f132cca63fb222).UTC) return (0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(cellData).utc().format(timeFormat);
                return (0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(cellData).format(timeFormat);
            }
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isString(cellData) && isFieldName) return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).defaultTo(fieldName, '').toString();
            if (typeof cellData === 'number') return (0, $182b28bda5c9878f$export$8641a8e317a91205)(cellData, decimalPlaces);
            return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).defaultTo(cellData, '').toString();
        }, this.handleResize = ()=>{
            this.forceUpdate();
        }, this.cellRenderer = ({ columnIndex: columnIndex, rowIndex: rowIndex, key: key, parent: parent, style: style })=>{
            const { hoveredColumnIndex: hoveredColumnIndex, hoveredRowIndex: hoveredRowIndex, isTimeVisible: isTimeVisible } = this.state;
            const { data: { transformedData: transformedData }, sort: sort } = this.props;
            const { fieldOptions: fieldOptions = [
                this.defaultTimeField
            ], colors: colors } = this.props;
            const cellData = transformedData[rowIndex][columnIndex];
            const isSorted = sort.field === cellData;
            const isAscending = sort.direction === (0, $93a523326aa94673$export$6e386ac144cffab5);
            const isFirstRow = rowIndex === 0;
            const isFirstCol = columnIndex === 0;
            const isFixedRow = isFirstRow && !isFirstCol;
            const isFixedColumn = this.fixFirstColumn && !isFirstRow && isFirstCol;
            const isTimeData = isTimeVisible && (this.isVerticalTimeAxis ? !isFirstRow && columnIndex === this.timeFieldIndex : rowIndex === this.timeFieldIndex && !isFirstCol);
            const isFieldName = this.isVerticalTimeAxis ? isFirstRow : isFirstCol;
            const isFixedCorner = isFirstRow && isFirstCol;
            const cellDataIsNumerical = typeof cellData === 'number';
            let cellStyle = style // tslint:disable-line
            ;
            if (!isFixedRow && !isFixedColumn && !isFixedCorner && !isTimeData && cellDataIsNumerical) {
                const thresholdData = {
                    colors: colors,
                    lastValue: cellData,
                    cellType: 'table'
                };
                const { bgColor: bgColor, textColor: textColor } = (0, $e09670a2eb92b732$export$2c00ede3bdd18539)(thresholdData);
                cellStyle = {
                    ...cellStyle,
                    backgroundColor: bgColor,
                    color: textColor
                };
            }
            const foundField = isFieldName && fieldOptions.find(({ internalName: internalName })=>internalName === cellData);
            const fieldName = foundField && (foundField.displayName || foundField.internalName);
            const isHighlightedRow = rowIndex === parent.props.scrollToRow || rowIndex === hoveredRowIndex && hoveredRowIndex > 0;
            const isHighlightedColumn = columnIndex === hoveredColumnIndex && hoveredColumnIndex > 0;
            const cellClass = (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('table-graph-cell', {
                'table-graph-cell__fixed-row': isFixedRow,
                'table-graph-cell__fixed-column': isFixedColumn,
                'table-graph-cell__fixed-corner': isFixedCorner,
                'table-graph-cell__highlight-row': isHighlightedRow,
                'table-graph-cell__highlight-column': isHighlightedColumn,
                'table-graph-cell__numerical': cellDataIsNumerical,
                'table-graph-cell__field-name': isFieldName,
                'table-graph-cell__sort-asc': isFieldName && isSorted && isAscending,
                'table-graph-cell__sort-desc': isFieldName && isSorted && !isAscending
            });
            const cellContents = this.createCellContents(cellData, fieldName, isTimeData, isFieldName);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                key: key,
                style: cellStyle,
                className: cellClass,
                onClick: isFieldName && (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isString(cellData) ? this.handleClickFieldName(cellData) : null,
                "data-column-index": columnIndex,
                "data-row-index": rowIndex,
                onMouseOver: this.handleHover,
                title: cellContents,
                "data-test": "table-graph"
            }, cellContents);
        };
        this.state = {
            shouldResize: false,
            sortedLabels: [],
            hoveredColumnIndex: (0, $93a523326aa94673$export$f934297ec188c667),
            hoveredRowIndex: (0, $93a523326aa94673$export$f934297ec188c667),
            isTimeVisible: true,
            timeColumnWidth: 0
        };
    }
    render() {
        const { data: { transformedData: transformedData } } = this.props;
        const columnCount = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(transformedData, [
            '0',
            'length'
        ], 0);
        const rowCount = columnCount === 0 ? 0 : transformedData.length;
        const fixedColumnCount = this.fixFirstColumn && columnCount > 1 ? 1 : 0;
        const { scrollToColumn: scrollToColumn, scrollToRow: scrollToRow, externalScroll: externalScroll } = this.scrollToColRow;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.tableContainerClassName,
            onMouseLeave: this.handleMouseLeave
        }, rowCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $9cf5f10972873d72$export$2e2bcd8739ae039), null, ({ width: width, height: height })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $3de865826e50231a$export$2e2bcd8739ae039), {
                columnCount: this.computedColumnCount,
                columnMinWidth: $2f794503406fd30c$var$COLUMN_MIN_WIDTH,
                width: width
            }, ({ adjustedWidth: adjustedWidth, columnWidth: columnWidth, registerChild: registerChild })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $770c9b085403cbf9$export$2e2bcd8739ae039), {
                    height: height,
                    fixedRowCount: 1,
                    ref: registerChild,
                    rowCount: rowCount,
                    width: adjustedWidth,
                    rowHeight: $2f794503406fd30c$var$ROW_HEIGHT,
                    columnCount: columnCount,
                    scrollToRow: scrollToRow,
                    scrollToColumn: scrollToColumn,
                    externalScroll: externalScroll,
                    cellRenderer: this.cellRenderer,
                    onMount: this.handleMultiGridMount,
                    fixedColumnCount: fixedColumnCount,
                    classNameBottomRightGrid: "table-graph--scroll-window",
                    columnWidth: this.calculateColumnWidth(columnWidth, adjustedWidth)
                }))));
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }
    get timeField() {
        const { fieldOptions: fieldOptions } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).find(fieldOptions, (f)=>f.internalName === this.defaultTimeField.internalName);
    }
    async componentDidMount() {
        const { fieldOptions: fieldOptions } = this.props;
        window.addEventListener('resize', this.handleResize);
        this.handleUpdateFieldOptions(fieldOptions);
        const isTimeVisible = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(this.timeField, 'visible', false);
        this.setState({
            hoveredColumnIndex: (0, $93a523326aa94673$export$f934297ec188c667),
            hoveredRowIndex: (0, $93a523326aa94673$export$f934297ec188c667),
            isTimeVisible: isTimeVisible
        }, ()=>{
            window.setTimeout(()=>{
                this.forceUpdate();
            }, 0);
        });
    }
    async UNSAFE_componentWillReceiveProps(nextProps) {
        const { dataType: dataType } = nextProps;
        const defaultTimeField = (0, $182b28bda5c9878f$export$d4a669fa0f2c95ae)(dataType);
        const timeField = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).find(nextProps.fieldOptions, (f)=>{
            return f.internalName === defaultTimeField.internalName;
        });
        const isTimeVisible = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(timeField, 'visible', this.state.isTimeVisible);
        const updatedProps = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).keys((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).omit(nextProps, 'data')).filter((k)=>!(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEqual(this.props[k], nextProps[k]));
        const shouldResize = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).includes(updatedProps, 'tableOptions') || (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).includes(updatedProps, 'fieldOptions') || (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).includes(updatedProps, 'timeFormat');
        this.setState({
            isTimeVisible: isTimeVisible,
            shouldResize: shouldResize
        });
    }
    componentDidUpdate(prevProps) {
        if (this.state.shouldResize) {
            if (this.multiGrid) this.multiGrid.recomputeGridSize();
            this.setState({
                shouldResize: false
            });
        }
        if (this.multiGrid) this.multiGrid.forceUpdate();
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEqual(this.props.fieldOptions, prevProps.fieldOptions)) this.handleUpdateFieldOptions(this.props.fieldOptions);
    }
    get tableContainerClassName() {
        const { dataType: dataType } = this.props;
        if (dataType === (0, $e10a8602f56394e3$export$45c69700ee30a78c).flux) return 'time-machine-table';
        return 'table-graph-container';
    }
    get fixFirstColumn() {
        const { tableOptions: tableOptions, fieldOptions: fieldOptions } = this.props;
        const { fixFirstColumn: fixFirstColumn = (0, $93a523326aa94673$export$b5d4db62f5afa6bb) } = tableOptions;
        if (fieldOptions.length === 1) return false;
        const visibleFields = fieldOptions.reduce((acc, f)=>{
            if (f.visible) acc += 1;
            return acc;
        }, 0);
        if (visibleFields === 1) return false;
        return fixFirstColumn;
    }
    get columnCount() {
        const { data: { transformedData: transformedData } } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(transformedData, [
            '0',
            'length'
        ], 0);
    }
    get computedColumnCount() {
        if (this.fixFirstColumn) return this.columnCount - 1;
        return this.columnCount;
    }
    get isEmpty() {
        const { data: { transformedData: transformedData } } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEmpty(transformedData);
    }
    get scrollToColRow() {
        const { data: { sortedTimeVals: sortedTimeVals } } = this.props;
        const { hoveredColumnIndex: hoveredColumnIndex, isTimeVisible: isTimeVisible } = this.state;
        const { hoverTime: hoverTime } = this.props;
        const hoveringThisTable = hoveredColumnIndex !== (0, $93a523326aa94673$export$f934297ec188c667);
        const notHovering = hoverTime === (0, $93a523326aa94673$export$f248303b5fb71ab5);
        const hoveringOtherCell = !notHovering && !hoveringThisTable;
        if (this.isEmpty || notHovering || hoveringThisTable || !isTimeVisible) return {
            scrollToColumn: 0,
            scrollToRow: -1,
            externalScroll: hoveringOtherCell
        };
        const firstDiff = this.getTimeDifference(hoverTime, sortedTimeVals[1]) // sortedTimeVals[0] is "time"
        ;
        const hoverTimeFound = (0, $4e86f29e59d731b4$export$61f84df1ca3d669)(sortedTimeVals, (acc, currentTime, index)=>{
            const thisDiff = this.getTimeDifference(hoverTime, currentTime);
            if (thisDiff < acc.diff) return {
                index: index,
                diff: thisDiff
            };
            return acc;
        }, {
            index: 1,
            diff: firstDiff
        });
        const scrollToColumn = this.isVerticalTimeAxis ? -1 : hoverTimeFound.index;
        const scrollToRow = this.isVerticalTimeAxis ? hoverTimeFound.index : null;
        return {
            scrollToRow: scrollToRow,
            scrollToColumn: scrollToColumn,
            externalScroll: hoveringOtherCell
        };
    }
    getTimeDifference(hoverTime, time) {
        return Math.abs(parseInt(hoverTime, 10) - parseInt(time, 10));
    }
    get isVerticalTimeAxis() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(this.props, 'tableOptions.verticalTimeAxis', (0, $93a523326aa94673$export$b892ed7ad2084288));
    }
    get defaultTimeField() {
        const { dataType: dataType } = this.props;
        return (0, $182b28bda5c9878f$export$d4a669fa0f2c95ae)(dataType);
    }
    get timeFieldIndex() {
        const { fieldOptions: fieldOptions } = this.props;
        let hiddenBeforeTime = 0;
        const timeIndex = fieldOptions.findIndex(({ internalName: internalName, visible: visible })=>{
            if (!visible) hiddenBeforeTime += 1;
            return internalName === this.defaultTimeField.internalName;
        });
        return timeIndex - hiddenBeforeTime;
    }
}
const $2f794503406fd30c$var$mstp = ({ dashboardUI: dashboardUI, app: app })=>({
        hoverTime: dashboardUI.hoverTime,
        timeZone: app.persisted.timeZone
    });
var $2f794503406fd30c$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($2f794503406fd30c$var$mstp)((0, $855a64e5014f72b2$export$54c2ee5106b5cb32)($2f794503406fd30c$export$379b400cc0e0b9f8)($2f794503406fd30c$var$TableGraph));



// Libraries

var $NdCUR = parcelRequire("NdCUR");




class $22b5f864d4a30de4$var$MarkdownCell extends (0, $NdCUR.Component) {
    render() {
        const { text: text } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), {
            className: "markdown-cell",
            autoHide: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "markdown-cell--contents"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ff69c7c0605f9fd2$exports))), {
            className: "markdown-format"
        }, (0, $8450edce046a69e2$export$11d70625c9cbd359)(text))));
    }
}
var $22b5f864d4a30de4$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($22b5f864d4a30de4$var$MarkdownCell);


// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");




var $hBdgJ = parcelRequire("hBdgJ");






const $006aaeac7e238898$var$parsers = {
    databases: $b0c8a009bdea2e59$export$2e2bcd8739ae039,
    measurements: (data)=>{
        const { errors: errors, measurementSets: measurementSets } = (0, $4672176ee5bc174b$export$2e2bcd8739ae039)(data);
        return {
            errors: errors,
            measurements: (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(measurementSets, [
                '0',
                'measurements'
            ], [])
        };
    },
    fieldKeys: (data, key)=>{
        const { errors: errors, fieldSets: fieldSets } = (0, $b90fabf231bb35b3$export$2e2bcd8739ae039)(data);
        return {
            errors: errors,
            fieldKeys: (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(fieldSets, key, [])
        };
    },
    tagKeys: $6d45437803cb8b2c$export$2e2bcd8739ae039,
    tagValues: (data, key)=>{
        const { errors: errors, tags: tags } = (0, $e693016ff8180917$export$2e2bcd8739ae039)(data);
        return {
            errors: errors,
            tagValues: (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(tags, key, [])
        };
    }
};
const $006aaeac7e238898$export$e1a7bff10f59b482 = (data)=>{
    const error = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(data, 'results.0.error', null);
    const series = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(data, 'results.0.series', null);
    if (error) return error;
    if (!series) return 'Your query or command is syntactically correct but returned no results';
    return null;
};
const $006aaeac7e238898$export$7747ec1c527bdee4 = (errorMessage)=>{
    if (!errorMessage) return 'Could not retrieve data';
    const parseErrorMatch = errorMessage.match && errorMessage.match('error parsing query');
    if (parseErrorMatch) return errorMessage.slice(parseErrorMatch.index);
    return errorMessage;
};
var $006aaeac7e238898$export$2e2bcd8739ae039 = $006aaeac7e238898$var$parsers;





function $fd27df6641fc3529$export$b54537f4467277c6(f) {
    let deferred;
    let id = 0;
    const checkResult = async (promise, promiseID)=>{
        let result;
        let isOk = true;
        try {
            result = await promise;
        } catch (error) {
            result = error;
            isOk = false;
        }
        if (promiseID !== id) return;
        if (isOk) deferred.resolve(result);
        else deferred.reject(result);
        deferred = null;
    };
    return (...args)=>{
        if (!deferred) deferred = new (0, $abfce34f6d695938$export$2e2bcd8739ae039)();
        const promise = f(...args);
        id += 1;
        checkResult(promise, id);
        return deferred.promise;
    };
}




class $075f3b99bb3716e4$var$DefaultDebouncer {
    constructor(){
        this.timers = {};
    }
    call(f, ms) {
        const key = f.toString();
        const timer = this.timers[key];
        if (timer) clearTimeout(timer);
        this.timers[key] = setTimeout(f, ms);
    }
    cancel(f) {
        const timer = this.timers[f.toString()];
        if (timer) clearTimeout(timer);
    }
    cancelAll() {
        const timers = Object.values(this.timers);
        for (const timer of timers)clearTimeout(timer);
    }
}
var $075f3b99bb3716e4$export$2e2bcd8739ae039 = $075f3b99bb3716e4$var$DefaultDebouncer;




const $6cc05668b9e9ec3f$export$e80a9284539c1797 = (error)=>{
    if (error.data) {
        if (typeof error.data === 'string') {
            const s = error.data.slice(0, -5) // There is a 'null\n' at the end of these responses
            ;
            const data = JSON.parse(s);
            return {
                type: 'error',
                text: data.message
            };
        } else if (typeof error.data === 'object') {
            if (error.data.error) return {
                type: 'error',
                text: error.data.error
            };
        }
    }
    if (error.message) return {
        type: 'error',
        text: error.message
    };
    if (error.statusText) return {
        type: 'error',
        text: error.statusText
    };
    return {
        type: 'error',
        text: error.toString()
    };
};


const $11dac49c5bd352c2$export$39956d113a695 = [
    {
        response: {
            results: []
        }
    }
];
const $11dac49c5bd352c2$var$EXECUTE_QUERIES_DEBOUNCE_MS = 400;
const $11dac49c5bd352c2$var$GraphLoadingDots = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "graph-panel__refreshing"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null));
class $11dac49c5bd352c2$var$TimeSeries extends (0, $NdCUR.PureComponent) {
    static{
        this.defaultProps = {
            inView: true,
            templates: [],
            xPixels: (0, $e10a8602f56394e3$export$707a26a7e04f767e),
            editQueryStatus: ()=>({
                    type: 'NOOP',
                    payload: {}
                })
        };
    }
    constructor(props){
        super(props), this.executeFluxQuery = (0, $fd27df6641fc3529$export$b54537f4467277c6)((0, $5914150e71c44d02$export$786299a18b5685fc)), this.executeInfluxQLQueries = (0, $fd27df6641fc3529$export$b54537f4467277c6)((0, $5ecbe528a4dce188$export$fb39b3f5106bb554)), this.debouncer = new (0, $075f3b99bb3716e4$export$2e2bcd8739ae039)(), this.executeQueries = async ()=>{
            const { inView: inView, queries: queries, grabDataForDownload: grabDataForDownload, grabFluxData: grabFluxData } = this.props;
            if (!inView) return;
            if (!queries.length) {
                this.setState({
                    timeSeriesInfluxQL: $11dac49c5bd352c2$export$39956d113a695,
                    timeSeriesFlux: []
                });
                return;
            }
            let timeSeriesInfluxQL = [];
            let timeSeriesFlux = [];
            let rawFluxData = '';
            let responseUUID;
            let loading = null;
            const latestUUID = (0, $dbdc5944552afab7$export$2e2bcd8739ae039)();
            this.setState({
                loading: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading,
                fetchCount: this.state.fetchCount + 1
            });
            let errorMessage = '';
            try {
                if (this.isFluxQuery) {
                    const results = await this.executeTemplatedFluxQuery(latestUUID);
                    timeSeriesFlux = results.tables;
                    rawFluxData = results.csv;
                    responseUUID = results.uuid;
                } else {
                    timeSeriesInfluxQL = await this.executeInfluxQLWithStatus(latestUUID);
                    responseUUID = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(timeSeriesInfluxQL, '0.response.uuid');
                }
                loading = (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done;
            } catch (err) {
                loading = (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error;
                errorMessage = (0, $6cc05668b9e9ec3f$export$e80a9284539c1797)(err).text;
                // eslint-disable-next-line no-console
                console.trace(err, errorMessage);
            }
            this.setState({
                timeSeriesInfluxQL: timeSeriesInfluxQL,
                timeSeriesFlux: timeSeriesFlux,
                rawFluxData: rawFluxData,
                loading: loading,
                latestUUID: responseUUID,
                errorMessage: errorMessage
            });
            if (grabDataForDownload) grabDataForDownload(timeSeriesInfluxQL);
            if (grabFluxData) grabFluxData(rawFluxData);
        }, this.executeTemplatedFluxQuery = async (latestUUID)=>{
            const { queries: queries, onNotify: onNotify, source: source, timeRange: timeRange, fluxASTLink: fluxASTLink, templates: templates } = this.props;
            const script = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(queries, '0.text', '');
            const renderedScript = await (0, $31b9ad045b09659f$export$49ddf62bc528f276)(script, (0, $31b9ad045b09659f$export$f6d501c8983af57)(templates) || timeRange, templates, fluxASTLink);
            const results = await this.executeFluxQuery(source, renderedScript, latestUUID);
            if (results.didTruncate && onNotify) onNotify((0, $ec1f42de4faacc37$export$33d9dc671f47d2f6)(results.rowCount));
            return {
                ...results,
                tables: (0, $c6606ad17445cd52$export$ba14d9a5a581e827)(results.csv)
            };
        }, this.executeInfluxQLWithStatus = async (latestUUID)=>{
            const { source: source, templates: templates, editQueryStatus: editQueryStatus, queries: queries } = this.props;
            for (const query of queries){
                const prevStatus = query.queryConfig?.status;
                editQueryStatus(query.id, {
                    loading: true,
                    isManuallySubmitted: prevStatus?.isManuallySubmitted,
                    submittedStatus: prevStatus?.submittedStatus,
                    submittedQuery: prevStatus?.submittedQuery
                });
            }
            const results = await this.executeInfluxQLQueries(source, queries, templates, latestUUID);
            for(let i = 0; i < queries.length; i++){
                const { value: value, error: error } = results[i];
                const query = queries[i];
                let queryStatus;
                if (error) queryStatus = {
                    error: (0, $006aaeac7e238898$export$7747ec1c527bdee4)(error)
                };
                else {
                    const warningMessage = (0, $006aaeac7e238898$export$e1a7bff10f59b482)(value);
                    if (warningMessage) queryStatus = {
                        warn: warningMessage
                    };
                    else queryStatus = {
                        success: 'Success!'
                    };
                }
                const shouldPreserve = query.queryConfig?.isExcluded && !query.queryConfig.status?.isManuallySubmitted;
                editQueryStatus(query.id, {
                    ...queryStatus,
                    submittedStatus: shouldPreserve ? query.queryConfig.status.submittedStatus : queryStatus,
                    submittedQuery: shouldPreserve ? query.queryConfig.status.submittedQuery : query.text
                });
            }
            const validQueryResults = results.filter((result)=>!result.error).map((result)=>({
                    response: result.value
                }));
            return validQueryResults;
        };
        this.state = {
            timeSeriesInfluxQL: $11dac49c5bd352c2$export$39956d113a695,
            loading: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).NotStarted,
            fetchCount: 0,
            timeSeriesFlux: [],
            rawFluxData: '',
            latestUUID: null,
            errorMessage: ''
        };
    }
    componentDidMount() {
        this.executeQueries();
    }
    componentWillUnmount() {
        this.debouncer.cancelAll();
    }
    async componentDidUpdate(prevProps) {
        const prevQueries = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).map(prevProps.queries, (q)=>q.text);
        const currQueries = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).map(this.props.queries, (q)=>q.text);
        const queriesDifferent = !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEqual(prevQueries, currQueries);
        let manualSubmit = false;
        if (!queriesDifferent) for(let i = 0; i < this.props.queries.length; i++){
            const query = this.props.queries[i];
            const prevQuery = prevProps.queries[i];
            if (query.queryConfig?.status?.isManuallySubmitted && !prevQuery.queryConfig?.status?.isManuallySubmitted) {
                manualSubmit = true;
                break;
            }
        }
        const prevTemplates = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(prevProps, 'templates');
        const newTemplates = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(this.props, 'templates');
        // templates includes dashTime and upperDashTime which capture zoomedTimeRange
        const templatesDifferent = !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEqual(prevTemplates, newTemplates);
        const oldLower = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(prevProps, 'timeRange.lower');
        const oldUpper = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(prevProps, 'timeRange.upper');
        const newLower = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(this.props, 'timeRange.lower');
        const newUpper = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(this.props, 'timeRange.upper');
        const timeRangeChanged = oldLower !== newLower || oldUpper !== newUpper;
        const shouldExecuteQueries = manualSubmit || queriesDifferent || timeRangeChanged || templatesDifferent || this.props.uuid !== prevProps.uuid || this.state.fetchCount === 0 || this.props.xPixels !== prevProps.xPixels;
        if (shouldExecuteQueries) this.debouncer.call(this.executeQueries, $11dac49c5bd352c2$var$EXECUTE_QUERIES_DEBOUNCE_MS);
    }
    render() {
        const { timeSeriesInfluxQL: timeSeriesInfluxQL, timeSeriesFlux: timeSeriesFlux, rawFluxData: rawFluxData, loading: loading, latestUUID: latestUUID, errorMessage: errorMessage } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, this.loadingDots, this.props.children({
            timeSeriesInfluxQL: timeSeriesInfluxQL,
            timeSeriesFlux: timeSeriesFlux,
            rawFluxData: rawFluxData,
            isInitialFetch: this.isInitialFetch,
            loading: loading,
            uuid: latestUUID,
            errorMessage: errorMessage
        }));
    }
    get isFluxQuery() {
        const { queries: queries } = this.props;
        return (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(queries, '0.type', '') === (0, $b4506126e09430df$export$7c8e26efb80b90e8).Flux;
    }
    get isInitialFetch() {
        const { fetchCount: fetchCount } = this.state;
        const isInitialFetch = fetchCount === 1;
        return isInitialFetch;
    }
    get loadingDots() {
        const { loading: loading } = this.state;
        if (loading === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading && !this.isInitialFetch) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($11dac49c5bd352c2$var$GraphLoadingDots, null);
        return null;
    }
}
var $11dac49c5bd352c2$export$2e2bcd8739ae039 = $11dac49c5bd352c2$var$TimeSeries;


// Libraries

var $NdCUR = parcelRequire("NdCUR");



var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");



var $NdCUR = parcelRequire("NdCUR");

class $bd30fd1856614941$var$TableSidebarItem extends (0, $NdCUR.PureComponent) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: `time-machine-sidebar-item ${this.active}`,
            onClick: this.handleClick
        }, this.name);
    }
    get name() {
        const keysIHate = [
            '_start',
            '_stop'
        ];
        return Object.entries(this.props.groupKey).filter(([k])=>!keysIHate.includes(k)).map(([k, v], i)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $NdCUR.Fragment), {
                key: i
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
                className: "key"
            }, k), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
                className: "equals"
            }, "="), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
                className: "value"
            }, v));
        });
    }
    get active() {
        if (this.props.isSelected) return 'active';
        return '';
    }
    constructor(...args){
        super(...args), this.handleClick = ()=>{
            this.props.onSelect(this.props.name);
        };
    }
}
var $bd30fd1856614941$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($bd30fd1856614941$var$TableSidebarItem);


class $24f02bd36bafa46a$var$TableSidebar extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleSearch = (e)=>{
            this.setState({
                searchTerm: e.target.value
            });
        };
        this.state = {
            searchTerm: ''
        };
    }
    render() {
        const { selectedResultName: selectedResultName, onSelectResult: onSelectResult } = this.props;
        const { searchTerm: searchTerm } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "time-machine-sidebar"
        }, !this.isDataEmpty && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "time-machine-sidebar--heading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            type: "text",
            className: "form-control input-xs time-machine-sidebar--filter",
            onChange: this.handleSearch,
            placeholder: "Filter tables",
            value: searchTerm
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "time-machine-sidebar--items"
        }, this.data.map(({ groupKey: groupKey, id: id, name: name })=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $bd30fd1856614941$export$2e2bcd8739ae039), {
                id: id,
                key: id,
                name: name,
                groupKey: groupKey,
                onSelect: onSelectResult,
                isSelected: name === selectedResultName
            });
        }))));
    }
    get data() {
        const { data: data } = this.props;
        const { searchTerm: searchTerm } = this.state;
        return data.filter((d)=>d.name.includes(searchTerm));
    }
    get isDataEmpty() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEmpty(this.props.data);
    }
}
var $24f02bd36bafa46a$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($24f02bd36bafa46a$var$TableSidebar);



var $NdCUR = parcelRequire("NdCUR");
const $df538166d7698406$var$NoResult = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "graph-empty"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, "No Results"));
var $df538166d7698406$export$2e2bcd8739ae039 = $df538166d7698406$var$NoResult;



// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");







class $31d8119fd059e6cb$var$TableGraphTransform extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.memoizedTimeSeriesToTableGraph = (0, $6c6177bbe259d59a$export$2e2bcd8739ae039)((0, $4420ff9299c1c25c$export$7aed24273b682d1e), (0, $28d93691ce0d4d34$export$c02dfba073881d63));
        this.state = {
            transformedData: null,
            invalidDataError: null
        };
    }
    render() {
        if (this.state.invalidDataError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $8ff1a4fbb307e59d$export$2e2bcd8739ae039), {
            message: (0, $182b28bda5c9878f$export$76fed1d1c9cba1e6)(this.state.invalidDataError)
        });
        if (!this.state.transformedData) return null;
        return this.props.children(this.state.transformedData, (0, $dbdc5944552afab7$export$2e2bcd8739ae039)());
    }
    componentDidMount() {
        this.isComponentMounted = true;
        this.transformData();
    }
    componentWillUnmount() {
        this.isComponentMounted = false;
    }
    componentDidUpdate(prevProps) {
        if (prevProps.uuid !== this.props.uuid) this.transformData();
    }
    async transformData() {
        const { dataType: dataType, data: data } = this.props;
        if (dataType === (0, $e10a8602f56394e3$export$45c69700ee30a78c).influxQL) {
            try {
                const influxQLData = await this.memoizedTimeSeriesToTableGraph(data);
                if (!this.isComponentMounted) return;
                this.setState({
                    transformedData: influxQLData,
                    invalidDataError: null
                });
            } catch (err) {
                let invalidDataError;
                switch(err.toString()){
                    case 'Error: Cannot display meta and data query':
                        invalidDataError = (0, $182b28bda5c9878f$export$43a750ddd9f2303e).MetaQueryCombo;
                        break;
                    default:
                        invalidDataError = (0, $182b28bda5c9878f$export$43a750ddd9f2303e).GeneralError;
                        break;
                }
                if (!this.isComponentMounted) return;
                this.setState({
                    invalidDataError: invalidDataError
                });
            }
            return;
        }
        const resultData = data.data;
        const sortedLabels = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(resultData, '0', []).map((label)=>({
                label: label,
                seriesIndex: 0,
                responseIndex: 0
            }));
        const fluxData = {
            data: resultData,
            sortedLabels: sortedLabels
        };
        if (!this.isComponentMounted) return;
        this.setState({
            transformedData: fluxData
        });
    }
}
var $31d8119fd059e6cb$export$2e2bcd8739ae039 = $31d8119fd059e6cb$var$TableGraphTransform;


// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");





const $fd345492e25e8636$var$areFormatPropertiesEqual = (prevProperties, newProperties)=>{
    const formatProps = [
        'uuid',
        'tableOptions',
        'fieldOptions',
        'timeFormat',
        'sort'
    ];
    const areEqual = formatProps.every((k)=>(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEqual(prevProperties[k], newProperties[k]));
    return areEqual;
};
class $fd345492e25e8636$var$TableGraphFormat extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.memoizedTableTransform = (0, $6c6177bbe259d59a$export$2e2bcd8739ae039)((0, $3a006c970d7cf650$export$a6385bddcc8e6b77).tableTransform, $fd345492e25e8636$var$areFormatPropertiesEqual), this.formatData = async (sortField)=>{
            const { fieldOptions: fieldOptions, data: { sortedLabels: sortedLabels, influxQLQueryType: influxQLQueryType }, dataType: dataType, tableOptions: tableOptions, timeFormat: timeFormat, decimalPlaces: decimalPlaces } = this.props;
            const sort = {
                ...this.state.sort
            };
            if (sortField === sort.field) sort.direction = sort.direction === (0, $93a523326aa94673$export$6e386ac144cffab5) ? (0, $93a523326aa94673$export$f634ff5a7f1c8f3) : (0, $93a523326aa94673$export$6e386ac144cffab5);
            else if (sortField !== undefined) {
                // setup sort unless the data are refreshed
                sort.field = sortField || this.sortField;
                sort.direction = (0, $93a523326aa94673$export$8ea18fa9e35fdf25);
            }
            const latestUUID = this.props.uuid;
            const computedFieldOptions = (0, $182b28bda5c9878f$export$edfce68a1e2dc732)(fieldOptions, sortedLabels, dataType, influxQLQueryType);
            try {
                const formattedData = await this.memoizedTableTransform({
                    data: this.props.data.data,
                    sort: sort,
                    fieldOptions: computedFieldOptions,
                    tableOptions: tableOptions,
                    timeFormat: timeFormat,
                    decimalPlaces: decimalPlaces,
                    uuid: latestUUID
                });
                if (!this.isComponentMounted) return;
                if (this.props.uuid === latestUUID) this.setState({
                    formattedData: formattedData,
                    sort: sort,
                    computedFieldOptions: computedFieldOptions,
                    invalidDataError: null
                });
            } catch (err) {
                if (!this.isComponentMounted) return;
                console.error(err);
                this.setState({
                    invalidDataError: (0, $182b28bda5c9878f$export$43a750ddd9f2303e).GeneralError
                });
            }
        };
        const sortField = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(this.props, 'tableOptions.sortBy.internalName', '');
        this.state = {
            formattedData: null,
            sort: {
                field: sortField,
                direction: (0, $93a523326aa94673$export$8ea18fa9e35fdf25)
            },
            computedFieldOptions: props.fieldOptions,
            invalidDataError: null
        };
    }
    render() {
        if (this.state.invalidDataError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $8ff1a4fbb307e59d$export$2e2bcd8739ae039), {
            message: (0, $182b28bda5c9878f$export$76fed1d1c9cba1e6)(this.state.invalidDataError)
        });
        if (!this.state.formattedData) return null;
        return this.props.children(this.state.formattedData, this.state.sort, this.state.computedFieldOptions, this.formatData);
    }
    componentDidMount() {
        this.isComponentMounted = true;
        this.formatData();
    }
    componentWillUnmount() {
        this.isComponentMounted = false;
    }
    componentDidUpdate(prevProps) {
        if (!$fd345492e25e8636$var$areFormatPropertiesEqual(prevProps, this.props)) this.formatData();
    }
    get sortField() {
        const { fieldOptions: fieldOptions, dataType: dataType } = this.props;
        let sortField = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(this.props, [
            'tableOptions',
            'sortBy',
            'internalName'
        ], '');
        const isValidSortField = !!fieldOptions.find((f)=>f.internalName === sortField);
        if (!isValidSortField) sortField = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get((0, $182b28bda5c9878f$export$d4a669fa0f2c95ae)(dataType), 'internalName', (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(fieldOptions, '0.internalName', ''));
        return sortField;
    }
}
var $fd345492e25e8636$export$2e2bcd8739ae039 = $fd345492e25e8636$var$TableGraphFormat;



const $9344f7135de656b8$var$filterTables = (tables)=>{
    const IGNORED_COLUMNS = [
        '',
        'result',
        'table',
        '_start',
        '_stop'
    ];
    return tables.map((table)=>{
        const header = table.data[0];
        const indices = IGNORED_COLUMNS.map((name)=>header.indexOf(name));
        const tableData = table.data;
        const data = tableData.map((row)=>{
            return row.filter((__, i)=>!indices.includes(i));
        });
        return {
            ...table,
            data: data
        };
    });
};
class $9344f7135de656b8$var$TimeMachineTables extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.filteredTablesMemoized = (0, $6c6177bbe259d59a$export$2e2bcd8739ae039)($9344f7135de656b8$var$filterTables), this.handleSelectResult = (selectedResultName)=>{
            this.setState({
                selectedResultName: selectedResultName
            });
        };
        this.state = {
            selectedResultName: this.defaultResultName
        };
    }
    componentDidUpdate() {
        if (!this.selectedResult) this.setState({
            selectedResultName: this.defaultResultName
        });
    }
    render() {
        const { width: width, height: height, colors: colors, dataType: dataType, timeFormat: timeFormat, tableOptions: tableOptions, decimalPlaces: decimalPlaces, editorLocation: editorLocation, handleSetHoverTime: handleSetHoverTime, onUpdateFieldOptions: onUpdateFieldOptions } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "time-machine-tables",
            style: {
                width: `${width}px`,
                height: `${height}px`
            }
        }, this.showSidebar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $24f02bd36bafa46a$export$2e2bcd8739ae039), {
            data: this.props.data,
            selectedResultName: this.state.selectedResultName,
            onSelectResult: this.handleSelectResult
        }), this.shouldShowTable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $31d8119fd059e6cb$export$2e2bcd8739ae039), {
            data: this.selectedResult,
            dataType: dataType,
            uuid: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)()
        }, (transformedData, nextUUID)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd345492e25e8636$export$2e2bcd8739ae039), {
                data: transformedData,
                uuid: nextUUID,
                dataType: dataType,
                tableOptions: tableOptions,
                timeFormat: timeFormat,
                decimalPlaces: decimalPlaces,
                fieldOptions: this.fieldOptions
            }, (formattedData, sort, computedFieldOptions, onSort)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $2f794503406fd30c$export$2e2bcd8739ae039), {
                    data: formattedData,
                    sort: sort,
                    onSort: onSort,
                    dataType: dataType,
                    colors: colors,
                    tableOptions: tableOptions,
                    fieldOptions: computedFieldOptions,
                    timeFormat: timeFormat,
                    decimalPlaces: decimalPlaces,
                    editorLocation: editorLocation,
                    handleSetHoverTime: handleSetHoverTime,
                    onUpdateFieldOptions: onUpdateFieldOptions
                }))), !this.hasResults && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $df538166d7698406$export$2e2bcd8739ae039), null));
    }
    get fieldOptions() {
        const { fieldOptions: fieldOptions } = this.props;
        const internalName = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(fieldOptions, '0.internalName', '');
        if (fieldOptions.length === 0 || fieldOptions.length === 1 && (internalName === 'time' || internalName === '_time')) {
            const headers = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(this.selectedResult, 'data.0', []);
            return headers.map((h)=>({
                    internalName: h,
                    displayName: '',
                    visible: true
                }));
        }
        return fieldOptions;
    }
    get showSidebar() {
        return this.props.data.length > 1;
    }
    get hasResults() {
        return !!this.props.data.length;
    }
    get shouldShowTable() {
        return !!this.props.data && !!this.selectedResult;
    }
    get defaultResultName() {
        const { data: data } = this.props;
        if (data.length && !!data[0]) return data[0].name;
        return null;
    }
    get selectedResult() {
        const filteredTables = this.filteredTablesMemoized(this.props.data);
        const table = filteredTables.find((d)=>d.name === this.state.selectedResultName);
        return table;
    }
}
var $9344f7135de656b8$export$2e2bcd8739ae039 = $9344f7135de656b8$var$TimeMachineTables;



var $NdCUR = parcelRequire("NdCUR");




const $fd6f464114bb61f5$var$ROW_HEIGHT = 30;
const $fd6f464114bb61f5$var$MIN_COLUMN_WIDTH = 100;
const $fd6f464114bb61f5$var$PADDING = 10;
const $fd6f464114bb61f5$var$parseResponseRawMemoized = (0, $6c6177bbe259d59a$export$2e2bcd8739ae039)((0, $c6606ad17445cd52$export$79d54e974ef34873));
class $fd6f464114bb61f5$var$RawFluxDataTable extends (0, $NdCUR.PureComponent) {
    render() {
        const { width: width, height: height, csv: csv } = this.props;
        const { scrollTop: scrollTop, scrollLeft: scrollLeft } = this.state;
        const { data: data, maxColumnCount: maxColumnCount } = $fd6f464114bb61f5$var$parseResponseRawMemoized(csv);
        const tableWidth = width - $fd6f464114bb61f5$var$PADDING * 2;
        const tableHeight = height - $fd6f464114bb61f5$var$PADDING * 2;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "raw-flux-data-table",
            style: {
                padding: `${$fd6f464114bb61f5$var$PADDING}px`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), {
            style: {
                overflowY: 'hidden',
                width: tableWidth,
                height: tableHeight
            },
            autoHide: false,
            scrollTop: scrollTop,
            scrollLeft: scrollLeft,
            setScrollTop: this.onScrollbarsScroll
        }, this.renderGrid(tableWidth, tableHeight, data, maxColumnCount, scrollLeft, scrollTop)));
    }
    renderGrid(width, height, data, maxColumnCount, scrollLeft, scrollTop) {
        const rowCount = data.length;
        const columnWidth = maxColumnCount > 0 ? Math.max($fd6f464114bb61f5$var$MIN_COLUMN_WIDTH, width / maxColumnCount) : $fd6f464114bb61f5$var$MIN_COLUMN_WIDTH;
        const style = this.gridStyle(columnWidth, maxColumnCount, rowCount);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $df00be2467032761$export$2e2bcd8739ae039), {
            width: width,
            height: height,
            cellRenderer: this.renderCell(data),
            columnCount: maxColumnCount,
            rowCount: rowCount,
            rowHeight: $fd6f464114bb61f5$var$ROW_HEIGHT,
            columnWidth: columnWidth,
            scrollLeft: scrollLeft,
            scrollTop: scrollTop,
            style: style
        });
    }
    gridStyle(columnWidth, maxColumnCount, rowCount) {
        const width = columnWidth * maxColumnCount;
        const height = $fd6f464114bb61f5$var$ROW_HEIGHT * rowCount;
        return {
            width: width,
            height: height
        };
    }
    constructor(...args){
        super(...args), this.state = {
            scrollLeft: 0,
            scrollTop: 0
        }, this.onScrollbarsScroll = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            const { scrollTop: scrollTop, scrollLeft: scrollLeft } = e.currentTarget;
            this.setState({
                scrollLeft: scrollLeft,
                scrollTop: scrollTop
            });
        }, this.renderCell = (data)=>({ columnIndex: columnIndex, key: key, rowIndex: rowIndex, style: style })=>{
                const datum = data[rowIndex][columnIndex];
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                    key: key,
                    style: style,
                    className: "raw-flux-data-table--cell",
                    title: datum
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                    className: "raw-flux-data-table--cell-bg"
                }, datum));
            };
    }
}
var $fd6f464114bb61f5$export$2e2bcd8739ae039 = $fd6f464114bb61f5$var$RawFluxDataTable;






var $NdCUR = parcelRequire("NdCUR");
class $4795326f11362e74$export$2e2bcd8739ae039 extends (0, $NdCUR.PureComponent) {
    static getDerivedStateFromProps(nextProps, state) {
        if (state.manualRefresh !== nextProps.manualRefresh) return {
            id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
            manualRefresh: nextProps.manualRefresh
        };
        return false;
    }
    constructor(props){
        super(props), this.update = ()=>{
            this.setState({
                id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)()
            });
        };
        this.state = {
            manualRefresh: props.manualRefresh,
            id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)()
        };
    }
    render() {
        return this.props.children(this.state.id);
    }
    componentDidMount() {
        const { autoRefresh: autoRefresh } = this.props;
        if (autoRefresh) autoRefresh.subscribe(this.update);
    }
    componentWillUnmount() {
        const { autoRefresh: autoRefresh } = this.props;
        if (autoRefresh) autoRefresh.unsubscribe(this.update);
    }
}




var $hBdgJ = parcelRequire("hBdgJ");
const $47cee289883ed1c6$var$emptyFunny = [
    "Looks like you don\u2019t have any queries. Be a lot cooler if you did!",
    'Create a query. Go on!',
    'Create a query. Have fun!'
];
const $47cee289883ed1c6$export$a613abf07ec8b359 = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).sample($47cee289883ed1c6$var$emptyFunny);




class $a926ccb172fe03ce$export$260d1793ec17c683 {
    subscribe(fn) {
        this.subscribers = [
            ...this.subscribers,
            fn
        ];
    }
    unsubscribe(fn) {
        this.subscribers = this.subscribers.filter((f)=>f !== fn);
    }
    poll(refreshMs) {
        this.clearInterval();
        if (refreshMs) this.intervalID = setInterval(this.refresh, refreshMs);
    }
    stopPolling() {
        this.clearInterval();
    }
    clearInterval() {
        if (!this.intervalID) return;
        clearInterval(this.intervalID);
        this.intervalID = null;
    }
    constructor(){
        this.subscribers = [];
        this.refresh = ()=>{
            this.subscribers.forEach((fn)=>fn());
        };
    }
}
const $a926ccb172fe03ce$export$a3ea0b2d0765f52e = new $a926ccb172fe03ce$export$260d1793ec17c683();







class $dc81def588caa8ef$var$RefreshingGraph extends (0, $NdCUR.Component) {
    static{
        this.defaultProps = {
            inView: true,
            manualRefresh: 0,
            staticLegend: false,
            timeFormat: (0, $9a9ec629fdd38845$export$c4d2eaadfa3c28df),
            decimalPlaces: (0, $9a9ec629fdd38845$export$2684547e8daa20ef),
            autoRefresher: (0, $a926ccb172fe03ce$export$a3ea0b2d0765f52e)
        };
    }
    shouldComponentUpdate(nextProps) {
        return this.haveVisOptionsChanged(nextProps);
    }
    render() {
        const { type: type, source: source, inView: inView, queries: queries, cellNote: cellNote, onNotify: onNotify, queryType: queryType, timeRange: timeRange, templates: templates, fluxASTLink: fluxASTLink, grabFluxData: grabFluxData, manualRefresh: manualRefresh, autoRefresher: autoRefresher, showRawFluxData: showRawFluxData, editQueryStatus: editQueryStatus, cellNoteVisibility: cellNoteVisibility, grabDataForDownload: grabDataForDownload } = this.props;
        if (this.shouldShowNoResults) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "graph-empty"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", {
            "data-test": "data-explorer-no-results"
        }, (0, $47cee289883ed1c6$export$a613abf07ec8b359)));
        if (type === (0, $b4506126e09430df$export$705e36171f4cbbfe).Note) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $22b5f864d4a30de4$export$2e2bcd8739ae039), {
            text: cellNote
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $9cf5f10972873d72$export$2e2bcd8739ae039), null, ({ width: width, height: height })=>{
            if (width === 0) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $4795326f11362e74$export$2e2bcd8739ae039), {
                autoRefresh: autoRefresher,
                manualRefresh: manualRefresh
            }, (refreshingUUID)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $11dac49c5bd352c2$export$2e2bcd8739ae039), {
                    uuid: refreshingUUID,
                    source: source,
                    inView: inView,
                    queries: this.queries,
                    timeRange: timeRange,
                    xPixels: width,
                    templates: templates,
                    fluxASTLink: fluxASTLink,
                    editQueryStatus: editQueryStatus,
                    onNotify: onNotify,
                    grabDataForDownload: grabDataForDownload,
                    grabFluxData: grabFluxData
                }, ({ timeSeriesInfluxQL: timeSeriesInfluxQL, timeSeriesFlux: timeSeriesFlux, rawFluxData: rawFluxData, loading: loading, isInitialFetch: isInitialFetch, uuid: uuid, errorMessage: errorMessage })=>{
                    if (isInitialFetch && loading === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                        className: "graph-empty"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h3", {
                        className: "graph-spinner"
                    }));
                    if (!this.hasValues(timeSeriesFlux, timeSeriesInfluxQL)) {
                        if (errorMessage && (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(queries, '0.text', '').trim()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $8ff1a4fbb307e59d$export$2e2bcd8739ae039), {
                            message: errorMessage
                        });
                        if (cellNoteVisibility === (0, $b4506126e09430df$export$2c5a562a272706f8).ShowWhenNoData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $22b5f864d4a30de4$export$2e2bcd8739ae039), {
                            text: cellNote
                        });
                        if (this.isFluxQuery && !(0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(source, 'links.flux', null)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                            className: "graph-empty"
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, "The current source does not support Flux"));
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                            className: "graph-empty"
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, "No Results"));
                    }
                    if (showRawFluxData && queryType === (0, $b4506126e09430df$export$7c8e26efb80b90e8).Flux && !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEmpty(rawFluxData)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd6f464114bb61f5$export$2e2bcd8739ae039), {
                        csv: rawFluxData,
                        width: width,
                        height: height
                    });
                    switch(type){
                        case (0, $b4506126e09430df$export$705e36171f4cbbfe).SingleStat:
                            return this.singleStat(timeSeriesInfluxQL, timeSeriesFlux);
                        case (0, $b4506126e09430df$export$705e36171f4cbbfe).Table:
                            return this.table(timeSeriesInfluxQL, timeSeriesFlux, uuid, width, height);
                        case (0, $b4506126e09430df$export$705e36171f4cbbfe).Gauge:
                            return this.gauge(timeSeriesInfluxQL, timeSeriesFlux);
                        default:
                            return this.lineGraph(timeSeriesInfluxQL, timeSeriesFlux, loading);
                    }
                }));
        });
    }
    get isFluxQuery() {
        const { queryType: queryType } = this.props;
        return queryType === (0, $b4506126e09430df$export$7c8e26efb80b90e8).Flux;
    }
    get shouldShowNoResults() {
        const { queries: queries } = this.props;
        const isEmptyFluxQuery = this.isFluxQuery && (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(queries, '0.text', '').trim() === '';
        return !queries.length || isEmptyFluxQuery;
    }
    hasValues(timeSeriesFlux, timeSeriesInfluxQL) {
        const hasFluxValues = timeSeriesFlux.length;
        const hasInfluxQLValues = timeSeriesInfluxQL.some((r)=>(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(r, 'response.results.0.series'));
        return hasFluxValues || hasInfluxQLValues;
    }
    haveVisOptionsChanged(prevProps) {
        const visProps = [
            'axes',
            'colors',
            'type',
            'tableOptions',
            'fieldOptions',
            'decimalPlaces',
            'timeFormat',
            'showRawFluxData',
            'queries',
            'templates',
            'manualRefresh',
            'timeRange',
            'inView'
        ];
        const prevVisValues = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).pick(prevProps, visProps);
        const curVisValues = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).pick(this.props, visProps);
        return !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEqual(prevVisValues, curVisValues);
    }
    get queries() {
        const { queries: queries, type: type } = this.props;
        if (type === (0, $b4506126e09430df$export$705e36171f4cbbfe).SingleStat) return [
            queries[0]
        ];
        if (type === (0, $b4506126e09430df$export$705e36171f4cbbfe).Gauge) return [
            queries[0]
        ];
        return queries;
    }
    get prefix() {
        const { axes: axes } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(axes, 'y.prefix', '');
    }
    get suffix() {
        const { axes: axes } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(axes, 'y.suffix', '');
    }
    getTypeAndData(influxQLData, fluxData) {
        if (influxQLData.length) return {
            dataType: (0, $e10a8602f56394e3$export$45c69700ee30a78c).influxQL,
            data: influxQLData
        };
        if (fluxData.length) return {
            dataType: (0, $e10a8602f56394e3$export$45c69700ee30a78c).flux,
            data: fluxData
        };
        return {
            dataType: (0, $e10a8602f56394e3$export$45c69700ee30a78c).influxQL,
            data: []
        };
    }
    constructor(...args){
        super(...args), this.singleStat = (influxQLData, fluxData)=>{
            const { colors: colors, cellHeight: cellHeight, decimalPlaces: decimalPlaces, manualRefresh: manualRefresh, onUpdateVisType: onUpdateVisType, onUpdateCellColors: onUpdateCellColors } = this.props;
            const { dataType: dataType, data: data } = this.getTypeAndData(influxQLData, fluxData);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7360539980ea45cc$export$2e2bcd8739ae039), {
                dataType: dataType,
                data: data,
                colors: colors,
                prefix: this.prefix,
                suffix: this.suffix,
                lineGraph: false,
                key: manualRefresh,
                cellHeight: cellHeight,
                decimalPlaces: decimalPlaces,
                onUpdateVisType: onUpdateVisType,
                onUpdateCellColors: onUpdateCellColors
            });
        }, this.table = (influxQLData, fluxData, uuid, width, height)=>{
            const { colors: colors, fieldOptions: fieldOptions, timeFormat: timeFormat, tableOptions: tableOptions, decimalPlaces: decimalPlaces, manualRefresh: manualRefresh, handleSetHoverTime: handleSetHoverTime, editorLocation: editorLocation, onUpdateFieldOptions: onUpdateFieldOptions } = this.props;
            const { dataType: dataType, data: data } = this.getTypeAndData(influxQLData, fluxData);
            if (dataType === (0, $e10a8602f56394e3$export$45c69700ee30a78c).flux) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $9344f7135de656b8$export$2e2bcd8739ae039), {
                data: data,
                uuid: uuid,
                dataType: dataType,
                colors: colors,
                width: width,
                height: height,
                key: manualRefresh,
                tableOptions: tableOptions,
                fieldOptions: fieldOptions,
                timeFormat: timeFormat,
                decimalPlaces: decimalPlaces,
                editorLocation: editorLocation,
                handleSetHoverTime: handleSetHoverTime,
                onUpdateFieldOptions: onUpdateFieldOptions
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $31d8119fd059e6cb$export$2e2bcd8739ae039), {
                data: data,
                uuid: uuid,
                dataType: dataType
            }, (transformedData, nextUUID)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd345492e25e8636$export$2e2bcd8739ae039), {
                    data: transformedData,
                    uuid: nextUUID,
                    dataType: dataType,
                    tableOptions: tableOptions,
                    fieldOptions: fieldOptions,
                    timeFormat: timeFormat,
                    decimalPlaces: decimalPlaces
                }, (formattedData, sort, computedFieldOptions, onSort)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $2f794503406fd30c$export$2e2bcd8739ae039), {
                        data: formattedData,
                        sort: sort,
                        onSort: onSort,
                        dataType: dataType,
                        colors: colors,
                        key: manualRefresh,
                        tableOptions: tableOptions,
                        fieldOptions: computedFieldOptions,
                        timeFormat: timeFormat,
                        decimalPlaces: decimalPlaces,
                        editorLocation: editorLocation,
                        handleSetHoverTime: handleSetHoverTime,
                        onUpdateFieldOptions: onUpdateFieldOptions
                    })));
        }, this.gauge = (influxQLData, fluxData)=>{
            const { colors: colors, cellID: cellID, cellHeight: cellHeight, decimalPlaces: decimalPlaces, manualRefresh: manualRefresh, resizerTopHeight: resizerTopHeight } = this.props;
            const { dataType: dataType, data: data } = this.getTypeAndData(influxQLData, fluxData);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $16970b6bda664789$export$2e2bcd8739ae039), {
                data: data,
                dataType: dataType,
                cellID: cellID,
                colors: colors,
                prefix: this.prefix,
                suffix: this.suffix,
                key: manualRefresh,
                cellHeight: cellHeight,
                decimalPlaces: decimalPlaces,
                resizerTopHeight: resizerTopHeight
            });
        }, this.lineGraph = (influxQLData, fluxData, loading)=>{
            const { axes: axes, type: type, colors: colors, onZoom: onZoom, cellID: cellID, queries: queries, timeRange: timeRange, cellHeight: cellHeight, decimalPlaces: decimalPlaces, staticLegend: staticLegend, manualRefresh: manualRefresh, onUpdateVisType: onUpdateVisType, handleSetHoverTime: handleSetHoverTime } = this.props;
            const { dataType: dataType, data: data } = this.getTypeAndData(influxQLData, fluxData);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $955b06aab2478f91$export$2e2bcd8739ae039), {
                data: data,
                type: type,
                axes: axes,
                cellID: cellID,
                colors: colors,
                onZoom: onZoom,
                queries: queries,
                loading: loading,
                dataType: dataType,
                key: manualRefresh,
                timeRange: timeRange,
                cellHeight: cellHeight,
                staticLegend: staticLegend,
                decimalPlaces: decimalPlaces,
                onUpdateVisType: onUpdateVisType,
                handleSetHoverTime: handleSetHoverTime
            });
        };
    }
}
const $dc81def588caa8ef$var$mapStateToProps = ({ links: links })=>({
        fluxASTLink: links.flux.ast
    });
const $dc81def588caa8ef$var$mdtp = {
    handleSetHoverTime: (0, $9859d1d8ae3f2524$export$fe6c3dd773ddd054),
    onNotify: (0, $205d139de2918454$export$5e14cdade93d6f7b)
};
var $dc81def588caa8ef$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($dc81def588caa8ef$var$mapStateToProps, $dc81def588caa8ef$var$mdtp)($dc81def588caa8ef$var$RefreshingGraph);



var $hBdgJ = parcelRequire("hBdgJ");




const $c5348ae249ce64eb$var$buildCannedDashboardQuery = (query, { lower: lower, upper: upper }, host)=>{
    const { defaultGroupBy: defaultGroupBy } = (0, $6a7b0ae94f8ec28f$export$9b55ef3c660cd071).find((range)=>range.lower === lower) || {
        defaultGroupBy: '5m'
    };
    let text = query.query;
    const wheres = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(query, 'wheres');
    const groupbys = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(query, 'groupbys');
    if (upper) text += ` where time > '${lower}' AND time < '${upper}'`;
    else text += ` where time > ${lower}`;
    if (host) text += ` and \"host\" = '${host}'`;
    if (wheres && wheres.length > 0) text += ` and ${wheres.join(' and ')}`;
    if (groupbys) {
        if (groupbys.find((g)=>g.includes('time'))) text += ` group by ${groupbys.join(',')}`;
        else if (groupbys.length > 0) text += ` group by time(${defaultGroupBy}),${groupbys.join(',')}`;
        else text += ` group by time(${defaultGroupBy})`;
    } else text += ` group by time(${defaultGroupBy})`;
    return text;
};
const $c5348ae249ce64eb$var$addTimeBoundsToRawText = (rawText)=>{
    if (!rawText) return;
    const dashboardTimeRegex = new RegExp(`time( )?>( )?${(0, $e10a8602f56394e3$export$24969386fef72130)}`, 'g');
    const dashboardTimeText = `time > ${(0, $e10a8602f56394e3$export$24969386fef72130)}`;
    const isUsingTimeSelectorBounds = !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEmpty(rawText.match(dashboardTimeRegex));
    if (isUsingTimeSelectorBounds) {
        const upperTimeBoundRegex = new RegExp('time( )?<', 'g');
        const hasUpperTimeBound = !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEmpty(rawText.match(upperTimeBoundRegex));
        if (rawText.indexOf((0, $e10a8602f56394e3$export$cb0056005b9f8f1c)) === -1 && !hasUpperTimeBound) {
            const upperDashboardTimeText = `time < ${(0, $e10a8602f56394e3$export$cb0056005b9f8f1c)}`;
            const fullTimeText = `${dashboardTimeText} AND ${upperDashboardTimeText}`;
            const boundedQueryText = rawText.replace(dashboardTimeRegex, fullTimeText);
            return boundedQueryText;
        }
    }
    return rawText;
};
const $c5348ae249ce64eb$export$1a9b4773bc0025c0 = (cell, timeRange, host)=>{
    return cell.queries.map((query)=>{
        let queryText;
        // Canned dashboards use an different a schema different from queryConfig.
        if (query.queryConfig) {
            const { queryConfig: { database: database, measurement: measurement, fields: fields, shifts: shifts, rawText: rawText, range: range } } = query;
            const tR = range || {
                upper: (0, $e10a8602f56394e3$export$cb0056005b9f8f1c),
                lower: (0, $e10a8602f56394e3$export$24969386fef72130)
            };
            queryText = $c5348ae249ce64eb$var$addTimeBoundsToRawText(rawText) || (0, $7b2c5b24a44a7fa2$export$d7b58f10109feb02)((0, $9a9ec629fdd38845$export$797ae35c568d4e70), tR, query.queryConfig);
            const isParsable = !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEmpty(database) && !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEmpty(measurement) && fields.length > 0;
            if (shifts && shifts.length && isParsable) {
                const shiftedQueries = shifts.filter((s)=>s.unit).map((s)=>(0, $7b2c5b24a44a7fa2$export$d7b58f10109feb02)((0, $9a9ec629fdd38845$export$dcffce4823e82712), timeRange, query.queryConfig, s));
                queryText = `${queryText};${shiftedQueries.join(';')}`;
            }
        } else queryText = $c5348ae249ce64eb$var$buildCannedDashboardQuery(query, timeRange, host);
        return {
            ...query,
            text: queryText
        };
    });
};







class $cdd21231ef2d2466$var$Layout extends (0, $NdCUR.Component) {
    render() {
        const { cell: cell, templates: templates, isEditable: isEditable, onCloneCell: onCloneCell, onDeleteCell: onDeleteCell, onSummonOverlayTechnologies: onSummonOverlayTechnologies } = this.props;
        const { cellData: cellData, cellFluxData: cellFluxData } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c0c6867ff228b8c4$export$2e2bcd8739ae039), {
            cell: cell,
            cellData: cellData,
            cellFluxData: cellFluxData,
            templates: templates,
            visType: this.visType,
            isEditable: isEditable,
            onCloneCell: onCloneCell,
            onDeleteCell: onDeleteCell,
            isFluxQuery: this.isFluxQuery,
            toggleVisType: this.toggleVisType,
            onSummonOverlayTechnologies: onSummonOverlayTechnologies
        }, this.visualization);
    }
    get isFluxQuery() {
        const { cell: cell } = this.props;
        const type = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(cell, 'queries.0.type', '');
        return type === 'flux';
    }
    get fluxVis() {
        const { cell: cell, onZoom: onZoom, timeRange: timeRange, manualRefresh: manualRefresh, templates: templates, source: source } = this.props;
        const { visType: visType } = this.state;
        const showRawFluxData = visType === (0, $bf3dd750ec7dcb0a$export$9f8d0c19ebdb3c7c).Table;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dc81def588caa8ef$export$2e2bcd8739ae039), {
            onZoom: onZoom,
            queryType: (0, $b4506126e09430df$export$7c8e26efb80b90e8).Flux,
            timeFormat: cell.timeFormat,
            axes: cell.axes,
            type: cell.type,
            inView: cell.inView,
            colors: cell.colors,
            tableOptions: cell.tableOptions,
            fieldOptions: cell.fieldOptions,
            decimalPlaces: cell.decimalPlaces,
            timeRange: timeRange,
            templates: templates,
            manualRefresh: manualRefresh,
            staticLegend: (0, $e10a8602f56394e3$export$1665041fd2ad0d88)(cell.legend),
            grabDataForDownload: this.grabDataForDownload,
            grabFluxData: this.grabFluxData,
            queries: cell.queries,
            source: source,
            cellNote: cell.note,
            cellNoteVisibility: cell.noteVisibility,
            showRawFluxData: showRawFluxData
        });
    }
    get influxQLVis() {
        const { cell: cell, host: host, source: source, sources: sources, onZoom: onZoom, timeRange: timeRange, manualRefresh: manualRefresh, templates: templates } = this.props;
        if (cell.isWidget) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $23793b77a5ad447d$export$2e2bcd8739ae039), {
            cell: cell,
            timeRange: timeRange,
            source: source
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dc81def588caa8ef$export$2e2bcd8739ae039), {
            onZoom: onZoom,
            queryType: (0, $b4506126e09430df$export$7c8e26efb80b90e8).InfluxQL,
            timeFormat: cell.timeFormat,
            axes: cell.axes,
            type: cell.type,
            inView: cell.inView,
            colors: cell.colors,
            tableOptions: cell.tableOptions,
            fieldOptions: cell.fieldOptions,
            decimalPlaces: cell.decimalPlaces,
            timeRange: timeRange,
            templates: templates,
            manualRefresh: manualRefresh,
            staticLegend: (0, $e10a8602f56394e3$export$1665041fd2ad0d88)(cell.legend),
            grabDataForDownload: this.grabDataForDownload,
            queries: (0, $c5348ae249ce64eb$export$1a9b4773bc0025c0)(cell, timeRange, host),
            source: this.getSource(cell, source, sources, source),
            cellNote: cell.note,
            cellNoteVisibility: cell.noteVisibility
        });
    }
    get visualization() {
        if (this.isFluxQuery) return this.fluxVis;
        return this.influxQLVis;
    }
    get visType() {
        return this.state.visType;
    }
    constructor(...args){
        super(...args), this.state = {
            cellData: [],
            cellFluxData: '',
            visType: (0, $bf3dd750ec7dcb0a$export$9f8d0c19ebdb3c7c).Graph
        }, this.toggleVisType = ()=>{
            const newVisType = this.state.visType === (0, $bf3dd750ec7dcb0a$export$9f8d0c19ebdb3c7c).Graph ? (0, $bf3dd750ec7dcb0a$export$9f8d0c19ebdb3c7c).Table : (0, $bf3dd750ec7dcb0a$export$9f8d0c19ebdb3c7c).Graph;
            this.setState({
                visType: newVisType
            });
        }, this.grabDataForDownload = (cellData)=>{
            this.setState({
                cellData: cellData
            });
        }, this.grabFluxData = (cellFluxData)=>{
            this.setState({
                cellFluxData: cellFluxData
            });
        }, this.getSource = (cell, source, sources, defaultSource)=>{
            const s = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(cell, [
                'queries',
                '0',
                'source'
            ], null);
            if (!s) return source;
            return sources.find((src)=>src.links.self === s) || defaultSource;
        };
    }
}
var $cdd21231ef2d2466$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($cdd21231ef2d2466$var$Layout);





const $3abcc8f3edbea0d9$var$GridLayout = (0, $559ca5de843865e1$exports.WidthProvider)((0, (/*@__PURE__*/$parcel$interopDefault($559ca5de843865e1$exports))));
class $3abcc8f3edbea0d9$var$LayoutRenderer extends (0, $NdCUR.Component) {
    constructor(props){
        super(props), this.handleLayoutChange = (layout)=>{
            if (!this.props.onPositionChange) return;
            let changed = false;
            const newCells = this.props.cells.map((cell)=>{
                const l = layout.find((ly)=>ly.i === cell.i);
                if (cell.x !== l.x || cell.y !== l.y || cell.h !== l.h || cell.w !== l.w) changed = true;
                const newLayout = {
                    x: l.x,
                    y: l.y,
                    h: l.h,
                    w: l.w
                };
                return {
                    ...cell,
                    ...newLayout
                };
            });
            if (changed) this.props.onPositionChange(newCells);
        }, // ensures that Status Page height fits the window
        this.calculateRowHeight = ()=>{
            const { isStatusPage: isStatusPage } = this.props;
            return isStatusPage ? (window.innerHeight - (0, $e10a8602f56394e3$export$1c31fb3cca4a4835) * (0, $e10a8602f56394e3$export$4a0da829a08f6fad) - (0, $e10a8602f56394e3$export$aa10bd88079cd4f3) - (0, $e10a8602f56394e3$export$3886576361c767a1) - (0, $e10a8602f56394e3$export$3886576361c767a1)) / (0, $e10a8602f56394e3$export$1c31fb3cca4a4835) : (0, $e10a8602f56394e3$export$13d5843c9841853c);
        };
        this.state = {
            rowHeight: this.calculateRowHeight()
        };
    }
    render() {
        const { host: host, cells: cells, source: source, sources: sources, onZoom: onZoom, templates: templates, timeRange: timeRange, isEditable: isEditable, manualRefresh: manualRefresh, onDeleteCell: onDeleteCell, onCloneCell: onCloneCell, onSummonOverlayTechnologies: onSummonOverlayTechnologies } = this.props;
        const { rowHeight: rowHeight } = this.state;
        const isDashboard = !!this.props.onPositionChange;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $091cfcd49e339acd$export$2e2bcd8739ae039), {
            requiredRole: (0, $a7910b1002260d34$export$f715f7e27dea2abf),
            propsOverride: {
                isDraggable: false,
                isResizable: false,
                draggableHandle: null
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($3abcc8f3edbea0d9$var$GridLayout, {
            layout: cells,
            cols: 12,
            rowHeight: rowHeight,
            margin: [
                (0, $e10a8602f56394e3$export$4a0da829a08f6fad),
                (0, $e10a8602f56394e3$export$4a0da829a08f6fad)
            ],
            containerPadding: [
                0,
                0
            ],
            useCSSTransforms: false,
            onLayoutChange: this.handleLayoutChange,
            draggableHandle: '.dash-graph--draggable',
            isDraggable: isDashboard,
            isResizable: isDashboard
        }, (0, $4e86f29e59d731b4$export$979fdb12e1580393)(cells, (cell)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                key: cell.i
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $091cfcd49e339acd$export$2e2bcd8739ae039), {
                requiredRole: (0, $a7910b1002260d34$export$f715f7e27dea2abf),
                propsOverride: {
                    isEditable: false
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $cdd21231ef2d2466$export$2e2bcd8739ae039), {
                key: cell.i,
                cell: cell,
                host: host,
                source: source,
                onZoom: onZoom,
                sources: sources,
                templates: templates,
                timeRange: timeRange,
                isEditable: isEditable,
                onDeleteCell: onDeleteCell,
                onCloneCell: onCloneCell,
                manualRefresh: manualRefresh,
                onSummonOverlayTechnologies: onSummonOverlayTechnologies
            }))))));
    }
}
var $3abcc8f3edbea0d9$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($3abcc8f3edbea0d9$var$LayoutRenderer);



// Libraries

var $NdCUR = parcelRequire("NdCUR");


const $ed11f2457ce5ca00$var$TimeZoneToggle = ({ onSetTimeZone: onSetTimeZone, timeZone: timeZone })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039).Button, {
        id: "influxql-source",
        titleText: "UTC",
        value: (0, $a7b864c61f4e95a7$export$d6f132cca63fb222).UTC,
        onClick: onSetTimeZone,
        active: timeZone === (0, $a7b864c61f4e95a7$export$d6f132cca63fb222).UTC
    }, "UTC"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039).Button, {
        id: "flux-source",
        titleText: "Local",
        value: (0, $a7b864c61f4e95a7$export$d6f132cca63fb222).Local,
        onClick: onSetTimeZone,
        active: timeZone === (0, $a7b864c61f4e95a7$export$d6f132cca63fb222).Local
    }, "Local"));
};
var $ed11f2457ce5ca00$export$2e2bcd8739ae039 = $ed11f2457ce5ca00$var$TimeZoneToggle;









const $4f40e78b129a73fb$var$emptyQuery = {
    query: '',
    source: '',
    queryConfig: {
        database: '',
        measurement: '',
        retentionPolicy: '',
        fields: [],
        tags: {},
        groupBy: {},
        areTagsAccepted: false,
        rawText: null,
        range: null
    },
    type: (0, $b4506126e09430df$export$7c8e26efb80b90e8).InfluxQL
};
const $4f40e78b129a73fb$var$emptyAxes = {
    x: (0, $727a6ab7dfc948a3$export$308b7fb3973197ea),
    y: (0, $727a6ab7dfc948a3$export$308b7fb3973197ea)
};
const $4f40e78b129a73fb$export$11c184550e9112e5 = [
    {
        ...(0, $9a9ec629fdd38845$export$5555fe053dab8f56),
        axes: $4f40e78b129a73fb$var$emptyAxes,
        i: 'alerts-bar-graph',
        type: (0, $b4506126e09430df$export$705e36171f4cbbfe).Bar,
        isWidget: false,
        x: 0,
        y: 0,
        w: 12,
        h: 4,
        legend: {},
        name: "Alert Events per Day \u2013 Last 30 Days",
        colors: (0, $b00e3cd70e675d45$export$b940073a64112462),
        queries: [
            {
                id: '1234',
                query: `SELECT count("value") AS "count_value" FROM "chronograf"."autogen"."alerts" WHERE time > ${(0, $e10a8602f56394e3$export$24969386fef72130)} GROUP BY time(1d)`,
                source: '',
                type: (0, $b4506126e09430df$export$7c8e26efb80b90e8).InfluxQL,
                queryConfig: {
                    database: 'chronograf',
                    measurement: 'alerts',
                    retentionPolicy: 'autogen',
                    fields: [
                        {
                            value: 'count',
                            type: 'func',
                            alias: 'count_value',
                            args: [
                                {
                                    value: 'value',
                                    type: 'field'
                                }
                            ]
                        }
                    ],
                    tags: {},
                    groupBy: {
                        time: '1d',
                        tags: []
                    },
                    areTagsAccepted: false,
                    rawText: null,
                    range: null
                }
            }
        ],
        links: {
            self: '/chronograf/v1/status/23/cells/c-bar-graphs-fly'
        }
    },
    {
        ...(0, $9a9ec629fdd38845$export$5555fe053dab8f56),
        axes: $4f40e78b129a73fb$var$emptyAxes,
        i: 'recent-alerts',
        type: (0, $b4506126e09430df$export$705e36171f4cbbfe).Alerts,
        isWidget: true,
        name: "Alerts \u2013 Last 30 Days",
        x: 0,
        y: 5,
        w: 6.5,
        h: 6,
        legend: {},
        queries: [
            $4f40e78b129a73fb$var$emptyQuery
        ],
        colors: (0, $b00e3cd70e675d45$export$b940073a64112462),
        links: {
            self: ''
        }
    },
    {
        ...(0, $9a9ec629fdd38845$export$5555fe053dab8f56),
        axes: $4f40e78b129a73fb$var$emptyAxes,
        i: 'news-feed',
        type: (0, $b4506126e09430df$export$705e36171f4cbbfe).News,
        isWidget: true,
        name: 'News Feed',
        x: 6.5,
        y: 5,
        w: 3,
        h: 6,
        legend: {},
        queries: [
            $4f40e78b129a73fb$var$emptyQuery
        ],
        colors: (0, $b00e3cd70e675d45$export$b940073a64112462),
        links: {
            self: ''
        }
    },
    {
        ...(0, $9a9ec629fdd38845$export$5555fe053dab8f56),
        axes: $4f40e78b129a73fb$var$emptyAxes,
        i: 'getting-started',
        type: (0, $b4506126e09430df$export$705e36171f4cbbfe).Guide,
        isWidget: true,
        name: 'Getting Started',
        x: 9.5,
        y: 5,
        w: 2.5,
        h: 6,
        legend: {},
        queries: [
            $4f40e78b129a73fb$var$emptyQuery
        ],
        colors: (0, $b00e3cd70e675d45$export$b940073a64112462),
        links: {
            self: ''
        }
    }
];





const $cb74a3ac1e224099$var$timeRange = (0, $6a7b0ae94f8ec28f$export$70d073c98082ccc4);
class $cb74a3ac1e224099$var$StatusPage extends (0, $NdCUR.Component) {
    render() {
        const { source: source, onSetTimeZone: onSetTimeZone, timeZone: timeZone } = this.props;
        const cells = (0, $4f40e78b129a73fb$export$11c184550e9112e5);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header, {
            fullWidth: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header.Left, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Title, {
            title: "Status"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header.Right, {
            showSourceIndicator: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ed11f2457ce5ca00$export$2e2bcd8739ae039), {
            onSetTimeZone: onSetTimeZone,
            timeZone: timeZone
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Contents, {
            fullWidth: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "dashboard container-fluid full-width"
        }, cells.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $3abcc8f3edbea0d9$export$2e2bcd8739ae039), {
            host: "",
            sources: [],
            cells: cells,
            source: source,
            manualRefresh: 0,
            isEditable: false,
            isStatusPage: true,
            timeRange: $cb74a3ac1e224099$var$timeRange,
            templates: this.templates
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", null, "Loading Status Page..."))));
    }
    get templates() {
        const dashboardTime = {
            id: 'dashtime',
            tempVar: (0, $e10a8602f56394e3$export$24969386fef72130),
            type: (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Constant,
            label: '',
            values: [
                {
                    value: $cb74a3ac1e224099$var$timeRange.lower,
                    type: (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).Constant,
                    selected: true,
                    localSelected: true
                }
            ]
        };
        const upperDashboardTime = {
            id: 'upperdashtime',
            tempVar: (0, $e10a8602f56394e3$export$cb0056005b9f8f1c),
            type: (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Constant,
            label: '',
            values: [
                {
                    value: 'now()',
                    type: (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).Constant,
                    selected: true,
                    localSelected: true
                }
            ]
        };
        return [
            dashboardTime,
            upperDashboardTime
        ];
    }
}
const $cb74a3ac1e224099$var$mstp = ({ app: app })=>({
        timeZone: app.persisted.timeZone
    });
const $cb74a3ac1e224099$var$mdtp = {
    onSetTimeZone: $cac020f89fc6c82e$export$93c56f26d2728d8d
};
var $cb74a3ac1e224099$export$2e2bcd8739ae039 = (0, $c8cd79e362cba2a4$export$a520fb22fccea800)((0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($cb74a3ac1e224099$var$mstp, $cb74a3ac1e224099$var$mdtp)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($cb74a3ac1e224099$var$StatusPage)));




// Libraries

var $NdCUR = parcelRequire("NdCUR");




var $hBdgJ = parcelRequire("hBdgJ");


var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");

// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");

class $23c724436dc30b29$var$SearchBar extends (0, $NdCUR.PureComponent) {
    static{
        this.defaultProps = {
            width: 260
        };
    }
    constructor(props){
        super(props), this.handleSearch = ()=>{
            this.props.onSearch(this.state.searchTerm);
        }, this.handleChange = (e)=>{
            this.setState({
                searchTerm: e.target.value
            }, this.debouncedHandleSearch);
        };
        this.state = {
            searchTerm: ''
        };
    }
    UNSAFE_componentWillMount() {
        this.debouncedHandleSearch = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).debounce(this.handleSearch, 50);
    }
    render() {
        const { placeholder: placeholder, width: width, testId: testId } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "search-widget",
            style: {
                width: `${width}px`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            type: "text",
            className: "form-control input-sm",
            placeholder: placeholder,
            onChange: this.handleChange,
            "data-test": testId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon search"
        }));
    }
}
var $23c724436dc30b29$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($23c724436dc30b29$var$SearchBar);



var $NdCUR = parcelRequire("NdCUR");


var $1v7mg = parcelRequire("1v7mg");
const $cb6614d128a2130a$export$959e293aa241489 = {
    NameWidth: '40%',
    StatusWidth: '74px',
    CPUWidth: '70px',
    LoadWidth: '68px'
};


const $b13d1eabf1169189$var$HostRow = ({ host: host, sourceID: sourceID })=>{
    const { name: name, cpu: cpu, load: load, apps: apps = [] } = host;
    const { NameWidth: NameWidth, StatusWidth: StatusWidth, CPUWidth: CPUWidth, LoadWidth: LoadWidth } = (0, $cb6614d128a2130a$export$959e293aa241489);
    const CPUValue = isNaN(cpu) ? 'N/A' : `${cpu.toFixed(2)}%`;
    const loadValue = isNaN(load) ? 'N/A' : `${load.toFixed(2)}`;
    const dotClassName = (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('table-dot', Math.max(host.deltaUptime || 0, host.winDeltaUptime || 0) > 0 ? 'dot-success' : 'dot-critical');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "hosts-table--tr"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "hosts-table--td",
        style: {
            width: NameWidth
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ba1cc4424c00aefe$export$2e2bcd8739ae039), {
        to: `/sources/${sourceID}/hosts/${name}`
    }, name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "hosts-table--td",
        style: {
            width: StatusWidth
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: dotClassName
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        style: {
            width: CPUWidth
        },
        className: "monotype hosts-table--td"
    }, CPUValue), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        style: {
            width: LoadWidth
        },
        className: "monotype hosts-table--td"
    }, loadValue), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "hosts-table--td"
    }, apps.map((app, index)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            key: app
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ba1cc4424c00aefe$export$2e2bcd8739ae039), {
            style: {
                marginLeft: '2px'
            },
            to: {
                pathname: `/sources/${sourceID}/hosts/${name}`,
                query: {
                    app: app
                }
            }
        }, app), index === apps.length - 1 ? null : ', ');
    })));
};
var $b13d1eabf1169189$export$2e2bcd8739ae039 = $b13d1eabf1169189$var$HostRow;







var $55d77eff080b7bf9$var$SortDirection = /*#__PURE__*/ function(SortDirection) {
    SortDirection["ASC"] = "asc";
    SortDirection["DESC"] = "desc";
    return SortDirection;
}($55d77eff080b7bf9$var$SortDirection || {});
class $55d77eff080b7bf9$var$HostsTable extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.getSortedHosts = (0, $6c6177bbe259d59a$export$2e2bcd8739ae039)((hosts, searchTerm, sortKey, sortDirection)=>{
            return this.sort(this.filter(hosts, searchTerm), sortKey, sortDirection);
        }), this.updateSearchTerm = (searchTerm)=>{
            this.setState({
                searchTerm: searchTerm
            });
        }, this.updateSort = (key)=>()=>{
                const { sortKey: sortKey, sortDirection: sortDirection } = this.state;
                if (sortKey === key) {
                    const reverseDirection = sortDirection === "asc" ? "desc" : "asc";
                    this.setState({
                        sortDirection: reverseDirection
                    });
                } else this.setState({
                    sortKey: key,
                    sortDirection: "asc"
                });
            }, this.sortableClasses = (key)=>{
            const { sortKey: sortKey, sortDirection: sortDirection } = this.state;
            if (sortKey === key) {
                if (sortDirection === "asc") return 'hosts-table--th sortable-header sorting-ascending';
                return 'hosts-table--th sortable-header sorting-descending';
            }
            return 'hosts-table--th sortable-header';
        };
        this.state = {
            searchTerm: '',
            sortDirection: "asc",
            sortKey: null
        };
    }
    filter(allHosts, searchTerm) {
        const filterText = searchTerm.toLowerCase();
        return allHosts.filter((h)=>{
            const apps = h.apps ? h.apps.join(', ') : '';
            let tagResult = false;
            if (h.tags) tagResult = Object.keys(h.tags).reduce((acc, key)=>{
                return acc || h.tags[key].toLowerCase().includes(filterText);
            }, false);
            else tagResult = false;
            return h.name.toLowerCase().includes(filterText) || apps.toLowerCase().includes(filterText) || tagResult;
        });
    }
    sort(hosts, key, direction) {
        switch(direction){
            case "asc":
                return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).sortBy(hosts, (e)=>e[key]);
            case "desc":
                return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).sortBy(hosts, (e)=>e[key]).reverse();
            default:
                return hosts;
        }
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel-heading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h2", {
            className: "panel-title"
        }, this.HostsTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $23c724436dc30b29$export$2e2bcd8739ae039), {
            placeholder: "Filter by Host...",
            onSearch: this.updateSearchTerm
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel-body"
        }, this.TableContents));
    }
    get TableContents() {
        const { hosts: hosts, hostsPageStatus: hostsPageStatus } = this.props;
        const { sortKey: sortKey, sortDirection: sortDirection, searchTerm: searchTerm } = this.state;
        const sortedHosts = this.getSortedHosts(hosts, searchTerm, sortKey, sortDirection);
        if (hostsPageStatus === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading) return this.LoadingState;
        if (hostsPageStatus === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error) return this.ErrorState;
        if (hosts.length === 0) return this.NoHostsState;
        if (sortedHosts.length === 0) return this.NoSortedHostsState;
        return this.TableWithHosts;
    }
    get TableWithHosts() {
        const { source: source, hosts: hosts } = this.props;
        const { sortKey: sortKey, sortDirection: sortDirection, searchTerm: searchTerm } = this.state;
        const sortedHosts = this.getSortedHosts(hosts, searchTerm, sortKey, sortDirection);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "hosts-table"
        }, this.HostsTableHeader, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a5457b7c0d559293$export$2e2bcd8739ae039), {
            items: sortedHosts.map((h)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b13d1eabf1169189$export$2e2bcd8739ae039), {
                    key: h.name,
                    host: h,
                    sourceID: source.id
                })),
            itemHeight: 26,
            className: "hosts-table--tbody"
        }));
    }
    get LoadingState() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $810ad5a94daa03b8$export$2e2bcd8739ae039), null);
    }
    get ErrorState() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "generic-empty-state"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", {
            style: {
                margin: '90px 0'
            }
        }, "There was a problem loading hosts"));
    }
    get NoHostsState() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "generic-empty-state"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", {
            style: {
                margin: '90px 0'
            }
        }, "No Hosts found"));
    }
    get NoSortedHostsState() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "generic-empty-state"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", {
            style: {
                margin: '90px 0'
            }
        }, "There are no hosts that match the search criteria"));
    }
    get HostsTitle() {
        const { hostsPageStatus: hostsPageStatus, hosts: hosts } = this.props;
        const { sortKey: sortKey, sortDirection: sortDirection, searchTerm: searchTerm } = this.state;
        const sortedHosts = this.getSortedHosts(hosts, searchTerm, sortKey, sortDirection);
        const hostsCount = sortedHosts.length;
        if (hostsPageStatus === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading) return 'Loading Hosts...';
        if (hostsCount === 1) return `1 Host`;
        return `${hostsCount} Hosts`;
    }
    get HostsTableHeader() {
        const { NameWidth: NameWidth, StatusWidth: StatusWidth, CPUWidth: CPUWidth, LoadWidth: LoadWidth } = (0, $cb6614d128a2130a$export$959e293aa241489);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "hosts-table--thead"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "hosts-table--tr"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            onClick: this.updateSort('name'),
            className: this.sortableClasses('name'),
            style: {
                width: NameWidth
            }
        }, "Host", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon caret-up"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            onClick: this.updateSort('deltaUptime'),
            className: this.sortableClasses('deltaUptime'),
            style: {
                width: StatusWidth
            }
        }, "Status", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon caret-up"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            onClick: this.updateSort('cpu'),
            className: this.sortableClasses('cpu'),
            style: {
                width: CPUWidth
            }
        }, "CPU", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon caret-up"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            onClick: this.updateSort('load'),
            className: this.sortableClasses('load'),
            style: {
                width: LoadWidth
            }
        }, "Load", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon caret-up"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "hosts-table--th"
        }, "Apps")));
    }
}
var $55d77eff080b7bf9$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($55d77eff080b7bf9$var$HostsTable);


// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");

var $7be8d2ddc7f80e0c$export$227e9d723189d8e5 = /*#__PURE__*/ function(AutoRefreshOptionType) {
    AutoRefreshOptionType["Option"] = "option";
    AutoRefreshOptionType["Header"] = "header";
    return AutoRefreshOptionType;
}({});
const $7be8d2ddc7f80e0c$export$47c563f91f55e1eb = {
    id: 'auto-refresh-paused',
    milliseconds: 0,
    label: 'Paused',
    type: "option"
};
const $7be8d2ddc7f80e0c$var$defaultAutoRefreshOptions = [
    {
        id: 'auto-refresh-header',
        milliseconds: 9999,
        label: 'Refresh',
        type: "header"
    },
    $7be8d2ddc7f80e0c$export$47c563f91f55e1eb,
    {
        id: 'auto-refresh-5s',
        milliseconds: 5000,
        label: '5s',
        type: "option"
    },
    {
        id: 'auto-refresh-10s',
        milliseconds: 10000,
        label: '10s',
        type: "option"
    },
    {
        id: 'auto-refresh-15s',
        milliseconds: 15000,
        label: '15s',
        type: "option"
    },
    {
        id: 'auto-refresh-30s',
        milliseconds: 30000,
        label: '30s',
        type: "option"
    },
    {
        id: 'auto-refresh-60s',
        milliseconds: 60000,
        label: '60s',
        type: "option"
    }
];
let $7be8d2ddc7f80e0c$var$autoRefreshOptions = [
    ...$7be8d2ddc7f80e0c$var$defaultAutoRefreshOptions
];
function $7be8d2ddc7f80e0c$export$6b3dc096e22ed40(customSpec) {
    if (customSpec === undefined) return;
    const [header, paused, ...otherDefault] = $7be8d2ddc7f80e0c$var$defaultAutoRefreshOptions;
    const customOptions = customSpec.split(';').reduce((acc, singleSpec)=>{
        if (!singleSpec) return acc // ignore empty values
        ;
        try {
            const [a, b] = singleSpec.split('=');
            const label = a.trim();
            const milliseconds = parseInt(b, 10);
            if (!(milliseconds >= 100)) throw new Error('Miliseconds is not a positive number >= 100');
            acc.push({
                id: `custom-refresh-${label}`,
                milliseconds: milliseconds,
                label: label,
                type: "option"
            });
        } catch (e) {
            console.warn(`Ignoring custom autoRefreshOption "${singleSpec}", it must have format label=milliseconds !, e
          }`);
        }
        return acc;
    }, []);
    $7be8d2ddc7f80e0c$var$autoRefreshOptions = [
        header,
        paused,
        ...[
            ...otherDefault,
            ...customOptions
        ].sort((a, b)=>a.milliseconds - b.milliseconds)
    ];
}
function $7be8d2ddc7f80e0c$export$f646e68351a87786() {
    return $7be8d2ddc7f80e0c$var$autoRefreshOptions;
}



class $e6a8d4614c25ddf0$var$AutoRefreshDropdown extends (0, $NdCUR.Component) {
    static{
        this.defaultProps = {
            showManualRefresh: true
        };
    }
    constructor(props){
        super(props), this.handleDropdownChange = (autoRefreshOption)=>{
            const { onChoose: onChoose } = this.props;
            onChoose(autoRefreshOption);
        };
        this.state = {
            isOpen: false
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.className
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $f040dbec7e8f99c8$export$2e2bcd8739ae039), {
            icon: this.dropdownIcon,
            widthPixels: this.dropdownWidthPixels,
            onChange: this.handleDropdownChange,
            selectedID: this.selectedID
        }, (0, $7be8d2ddc7f80e0c$export$f646e68351a87786)().map((option)=>{
            if (option.type === (0, $7be8d2ddc7f80e0c$export$227e9d723189d8e5).Header) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $f040dbec7e8f99c8$export$2e2bcd8739ae039).Divider, {
                key: option.id,
                id: option.id,
                text: option.label
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $f040dbec7e8f99c8$export$2e2bcd8739ae039).Item, {
                key: option.id,
                id: option.id,
                value: option
            }, option.label);
        })), this.manualRefreshButton);
    }
    get isPaused() {
        const { selected: selected } = this.props;
        return selected === 0;
    }
    get className() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('autorefresh-dropdown', {
            paused: this.isPaused
        });
    }
    get dropdownIcon() {
        if (this.isPaused) return (0, $918c9f03a35fe03f$export$62c9c0cf752cde38).Pause;
        return (0, $918c9f03a35fe03f$export$62c9c0cf752cde38).Refresh;
    }
    get dropdownWidthPixels() {
        if (this.isPaused) return 50;
        return 84;
    }
    get selectedID() {
        const { selected: selected } = this.props;
        const selectedOption = (0, $7be8d2ddc7f80e0c$export$f646e68351a87786)().find((option)=>option.milliseconds === selected);
        return selectedOption.id;
    }
    get manualRefreshButton() {
        const { showManualRefresh: showManualRefresh, onManualRefresh: onManualRefresh } = this.props;
        if (!showManualRefresh) return;
        if (this.isPaused) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
            shape: (0, $918c9f03a35fe03f$export$ce765fb8bb08a599).Square,
            icon: (0, $918c9f03a35fe03f$export$62c9c0cf752cde38).Refresh,
            onClick: onManualRefresh
        });
        return null;
    }
}
var $e6a8d4614c25ddf0$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($e6a8d4614c25ddf0$var$AutoRefreshDropdown);



var $NdCUR = parcelRequire("NdCUR");
function $bfd6e1b2bb3e3a9d$var$ManualRefresh(WrappedComponent) {
    return class extends (0, $NdCUR.Component) {
        constructor(props){
            super(props), this.handleManualRefresh = ()=>{
                this.setState({
                    manualRefresh: Date.now()
                });
            };
            this.state = {
                manualRefresh: Date.now()
            };
        }
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement(WrappedComponent, {
                ...this.props,
                manualRefresh: this.state.manualRefresh,
                onManualRefresh: this.handleManualRefresh
            });
        }
    };
}
var $bfd6e1b2bb3e3a9d$export$2e2bcd8739ae039 = $bfd6e1b2bb3e3a9d$var$ManualRefresh;





var $hBdgJ = parcelRequire("hBdgJ");




const $d839674bffa6f50c$export$b430c2bd97f9d15b = {
    links: [],
    active: null
};
const $d839674bffa6f50c$export$c332c482646ebb53 = (hostNames, source)=>{
    const links = Object.values(hostNames).map((h)=>{
        return {
            key: h.name,
            text: h.name,
            to: `/sources/${source.id}/hosts/${h.name}`
        };
    });
    return {
        links: links,
        active: null
    };
};
const $d839674bffa6f50c$export$3fd869fe7c1f5d66 = (hostLinks, host)=>{
    const active = hostLinks.links.find((link)=>link.key === host.name);
    return {
        ...hostLinks,
        active: active
    };
};


const $1cf43c986b8bf24f$var$EmptyHost = {
    name: '',
    cpu: 0.0,
    load: 0.0,
    deltaUptime: -1,
    apps: []
};
const $1cf43c986b8bf24f$export$d7283db715c4d532 = async (proxyLink, telegrafDB, telegrafSystemInterval, tempVars)=>{
    const query = (0, $d9ab469c58284fd8$export$2e2bcd8739ae039)(`SHOW TAG VALUES WITH KEY = "host" WHERE TIME > now() - 10m;
      SELECT mean("usage_user") FROM \":db:\".\":rp:\".\"cpu\" WHERE "cpu" = 'cpu-total' AND time > now() - 10m GROUP BY host;
      SELECT mean("load1") FROM \":db:\".\":rp:\".\"system\" WHERE time > now() - 10m GROUP BY host;
      SELECT non_negative_derivative(mean(uptime)) AS deltaUptime FROM \":db:\".\":rp:\".\"system\" WHERE time > now() - ${telegrafSystemInterval} * 10 GROUP BY host, time(${telegrafSystemInterval}) fill(0);
      SELECT mean("Percent_Processor_Time") FROM \":db:\".\":rp:\".\"win_cpu\" WHERE time > now() - 10m GROUP BY host;
      SELECT mean("Processor_Queue_Length") FROM \":db:\".\":rp:\".\"win_system\" WHERE time > now() - 10m GROUP BY host;
      SELECT non_negative_derivative(mean("System_Up_Time")) AS winDeltaUptime FROM \":db:\".\":rp:\".\"win_system\" WHERE time > now() - ${telegrafSystemInterval} * 10 GROUP BY host, time(${telegrafSystemInterval}) fill(0);`, tempVars);
    const { data: data } = await (0, $aea829e093f1eddb$export$923f96dd5afa9ce6)({
        source: proxyLink,
        query: query,
        db: telegrafDB
    });
    return $1cf43c986b8bf24f$export$6369f662debf6412(data);
};
const $1cf43c986b8bf24f$export$6369f662debf6412 = (data)=>{
    const hosts = {};
    const precision = 100;
    const allHostsSeries = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(data, 'results.[0].series', []);
    const cpuSeries = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(data, 'results.[1].series', []);
    const loadSeries = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(data, 'results.[2].series', []);
    const uptimeSeries = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(data, 'results.[3].series', []);
    const winCPUSeries = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(data, 'results.[4].series', []);
    const winLoadSeries = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(data, 'results.[5].series', []);
    const winUptimeSeries = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(data, 'results.[6].series', []);
    allHostsSeries.forEach((s)=>{
        const hostnameIndex = s.columns.findIndex((col)=>col === 'value');
        s.values.forEach((v)=>{
            const hostname = v[hostnameIndex];
            hosts[hostname] = {
                ...$1cf43c986b8bf24f$var$EmptyHost,
                name: hostname
            };
        });
    });
    cpuSeries.forEach((s)=>{
        const meanIndex = s.columns.findIndex((col)=>col === 'mean');
        hosts[s.tags.host] = {
            ...$1cf43c986b8bf24f$var$EmptyHost,
            name: s.tags.host,
            cpu: Math.round(Number(s.values[0][meanIndex]) * precision) / precision
        };
    });
    loadSeries.forEach((s)=>{
        const meanIndex = s.columns.findIndex((col)=>col === 'mean');
        hosts[s.tags.host].load = Math.round(Number(s.values[0][meanIndex]) * precision) / precision;
    });
    uptimeSeries.forEach((s)=>{
        const uptimeIndex = s.columns.findIndex((col)=>col === 'deltaUptime');
        hosts[s.tags.host].deltaUptime = Number(s.values[s.values.length - 1][uptimeIndex]);
    });
    winCPUSeries.forEach((s)=>{
        const meanIndex = s.columns.findIndex((col)=>col === 'mean');
        hosts[s.tags.host] = {
            name: s.tags.host,
            cpu: Math.round(Number(s.values[0][meanIndex]) * precision) / precision
        };
    });
    winLoadSeries.forEach((s)=>{
        const meanIndex = s.columns.findIndex((col)=>col === 'mean');
        hosts[s.tags.host].load = Math.round(Number(s.values[0][meanIndex]) * precision) / precision;
    });
    winUptimeSeries.forEach((s)=>{
        const winUptimeIndex = s.columns.findIndex((col)=>col === 'winDeltaUptime');
        hosts[s.tags.host].winDeltaUptime = Number(s.values[s.values.length - 1][winUptimeIndex]);
    });
    return hosts;
};
const $1cf43c986b8bf24f$var$getAllHosts = async (source)=>{
    const { telegraf: telegraf, links: { proxy: proxyLink } } = source;
    try {
        const { data: data } = await (0, $aea829e093f1eddb$export$923f96dd5afa9ce6)({
            source: proxyLink,
            query: 'show tag values with key = "host"',
            db: telegraf
        });
        const hosts = {};
        const allHostsSeries = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(data, 'results[0].series', []);
        allHostsSeries.forEach((s)=>{
            const hostnameIndex = s.columns.findIndex((col)=>col === 'value');
            s.values.forEach((v)=>{
                const hostname = v[hostnameIndex];
                hosts[hostname] = {
                    name: hostname
                };
            });
        });
        return hosts;
    } catch (error) {
        console.error(error) // eslint-disable-line no-console
        ;
        throw error;
    }
};
const $1cf43c986b8bf24f$export$fcfcb6181e9c856e = async (source, activeHost)=>{
    const hostNames = await $1cf43c986b8bf24f$var$getAllHosts(source);
    return $1cf43c986b8bf24f$export$8fa91be6f77ea1a0(source, activeHost, hostNames);
};
const $1cf43c986b8bf24f$export$8fa91be6f77ea1a0 = async (source, activeHost, hostNames)=>{
    const allLinks = (0, $d839674bffa6f50c$export$c332c482646ebb53)(hostNames, source);
    return (0, $d839674bffa6f50c$export$3fd869fe7c1f5d66)(allLinks, activeHost);
};
const $1cf43c986b8bf24f$export$9340fad0531287fd = ()=>(0, $a537743573e5e486$export$2e2bcd8739ae039)({
        method: 'GET',
        resource: 'layouts'
    });
const $1cf43c986b8bf24f$export$81a06a432192210b = async (proxyLink, host, appLayouts, telegrafDB)=>{
    const measurements = appLayouts.map((m)=>`^${m.measurement}$`).join('|');
    const measurementsToApps = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).zipObject(appLayouts.map((m)=>m.measurement), appLayouts.map(({ app: app })=>app));
    const { data: data } = await (0, $aea829e093f1eddb$export$923f96dd5afa9ce6)({
        source: proxyLink,
        query: `show series from /${measurements}/ where host = '${host}'`,
        db: telegrafDB
    });
    const appsForHost = {
        apps: [],
        tags: {
            host: null
        }
    };
    const allSeries = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(data, 'results.0.series.0.values', []);
    allSeries.forEach((series)=>{
        const seriesObj = $1cf43c986b8bf24f$var$parseSeries(series[0]);
        const measurement = seriesObj.measurement;
        appsForHost.apps = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).uniq(appsForHost.apps.concat(measurementsToApps[measurement]));
        (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).assign(appsForHost.tags, seriesObj.tags);
    });
    return appsForHost;
};
const $1cf43c986b8bf24f$export$82f0d732267ea60 = async (proxyLink, hosts, appLayouts, telegrafDB)=>{
    const measurements = appLayouts.map((m)=>`^${m.measurement}$`).join('|');
    const measurementsToApps = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).zipObject(appLayouts.map((m)=>m.measurement), appLayouts.map(({ app: app })=>app));
    const { data: data } = await (0, $aea829e093f1eddb$export$923f96dd5afa9ce6)({
        source: proxyLink,
        query: `show series from /${measurements}/ where time > now() - 10m`,
        db: telegrafDB
    });
    const newHosts = {
        ...hosts
    };
    const allSeries = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(data, 'results.[0].series.[0].values', []);
    allSeries.forEach((series)=>{
        const seriesObj = $1cf43c986b8bf24f$var$parseSeries(series[0]);
        const measurement = seriesObj.measurement;
        const host = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(seriesObj, 'tags.host', '');
        if (!newHosts[host]) return;
        if (!newHosts[host].apps) newHosts[host].apps = [];
        if (!newHosts[host].tags) newHosts[host].tags = {};
        newHosts[host].apps = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).uniq(newHosts[host].apps.concat(measurementsToApps[measurement]));
        (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).assign(newHosts[host].tags, seriesObj.tags);
    });
    return newHosts;
};
const $1cf43c986b8bf24f$export$93106d668d19e91b = async (source, host)=>{
    const { data: data } = await (0, $aea829e093f1eddb$export$923f96dd5afa9ce6)({
        source: source.links.proxy,
        query: `SHOW MEASUREMENTS WHERE "host" = '${host}'`,
        db: source.telegraf
    });
    if ($1cf43c986b8bf24f$var$isEmpty(data) || $1cf43c986b8bf24f$var$hasError(data)) return [];
    const values = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(data, 'results.[0].series.[0].values', []);
    const measurements = values.map((m)=>{
        return m[0];
    });
    return measurements;
};
const $1cf43c986b8bf24f$var$parseSeries = (seriesString)=>{
    const ident = /\w+/;
    const tag = /,?([^=]+)=([^,]+)/;
    const parseMeasurement = (s, obj)=>{
        const match = ident.exec(s);
        const measurement = match[0];
        if (measurement) obj.measurement = measurement;
        return s.slice(match.index + measurement.length);
    };
    const parseTag = (s, obj)=>{
        const match = tag.exec(s);
        if (match) {
            const kv = match[0];
            const key = match[1];
            const value = match[2];
            if (key) {
                if (!obj.tags) obj.tags = {};
                obj.tags[key] = value;
            }
            return s.slice(match.index + kv.length);
        }
        return '';
    };
    let workStr = seriesString.slice();
    const out = {
        measurement: null,
        tags: {
            host: null
        }
    };
    // Consume measurement
    workStr = parseMeasurement(workStr, out);
    // Consume tags
    while(workStr.length > 0)workStr = parseTag(workStr, out);
    return out;
};
const $1cf43c986b8bf24f$var$isEmpty = (resp)=>{
    return !resp.results[0].series;
};
const $1cf43c986b8bf24f$var$hasError = (resp)=>{
    return !!resp.results[0].error;
};



const $8724956c7a46b140$var$DEFAULT_ENVS = {
    telegrafSystemInterval: '1m',
    hostPageDisabled: false,
    customAutoRefresh: undefined,
    v3SupportEnabled: false
};
const $8724956c7a46b140$export$4bd44a2aa29d3d6e = async (url)=>{
    try {
        const { data: data } = await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'GET',
            url: url
        });
        return data;
    } catch (error) {
        console.error('Error retrieving envs: ', error);
        return $8724956c7a46b140$var$DEFAULT_ENVS;
    }
};





const $a6ce8e821e7d53dd$export$9fc03b814431a2e0 = (source)=>[
        {
            tempVar: ':db:',
            id: 'db',
            type: (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Constant,
            label: '',
            values: [
                {
                    value: source.telegraf,
                    type: (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).Constant,
                    selected: true,
                    localSelected: true
                }
            ]
        },
        {
            tempVar: ':rp:',
            id: 'rp',
            type: (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Constant,
            label: '',
            values: [
                {
                    value: source.defaultRP,
                    type: (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).Constant,
                    selected: true,
                    localSelected: true
                }
            ]
        }
    ];




class $e332d644fe278728$export$42bd6b8eed053555 extends (0, $NdCUR.PureComponent) {
    static{
        this.defaultProps = {
            manualRefresh: 0
        };
    }
    constructor(props){
        super(props);
        this.state = {
            hostsObject: {},
            hostsPageStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).NotStarted,
            layouts: []
        };
        this.handleChooseAutoRefresh = this.handleChooseAutoRefresh.bind(this);
    }
    async componentDidMount() {
        const { notify: notify, autoRefresh: autoRefresh } = this.props;
        this.setState({
            hostsPageStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading
        });
        const layoutResults = await (0, $1cf43c986b8bf24f$export$9340fad0531287fd)();
        const layouts = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(layoutResults, 'data.layouts', []);
        if (!layouts) {
            notify((0, $ec1f42de4faacc37$export$31c3e1278af532f0)());
            this.setState({
                hostsPageStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error,
                layouts: layouts
            });
            return;
        }
        await this.fetchHostsData(layouts);
        if (autoRefresh) this.intervalID = window.setInterval(()=>this.fetchHostsData(layouts), autoRefresh);
        this.setState({
            layouts: layouts
        });
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { layouts: layouts } = this.state;
        if (layouts) {
            if (this.props.manualRefresh !== nextProps.manualRefresh) this.fetchHostsData(layouts);
            if (this.props.autoRefresh !== nextProps.autoRefresh) {
                clearInterval(this.intervalID);
                if (nextProps.autoRefresh) this.intervalID = window.setInterval(()=>this.fetchHostsData(layouts), nextProps.autoRefresh);
            }
        }
    }
    componentWillUnmount() {
        clearInterval(this.intervalID);
        this.intervalID = null;
    }
    handleChooseAutoRefresh(option) {
        const { onChooseAutoRefresh: onChooseAutoRefresh } = this.props;
        const { milliseconds: milliseconds } = option;
        onChooseAutoRefresh(milliseconds);
    }
    render() {
        const { source: source, autoRefresh: autoRefresh, onManualRefresh: onManualRefresh } = this.props;
        const { hostsObject: hostsObject, hostsPageStatus: hostsPageStatus } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039), {
            className: "hosts-list-page"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header.Left, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Title, {
            title: "Host List"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header.Right, {
            showSourceIndicator: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $e6a8d4614c25ddf0$export$2e2bcd8739ae039), {
            selected: autoRefresh,
            onChoose: this.handleChooseAutoRefresh,
            onManualRefresh: onManualRefresh
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Contents, {
            scrollable: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $55d77eff080b7bf9$export$2e2bcd8739ae039), {
            source: source,
            hosts: (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).values(hostsObject),
            hostsPageStatus: hostsPageStatus
        })));
    }
    async fetchHostsData(layouts) {
        const { source: source, links: links, notify: notify } = this.props;
        const envVars = await (0, $8724956c7a46b140$export$4bd44a2aa29d3d6e)(links.environment);
        const telegrafSystemInterval = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(envVars, 'telegrafSystemInterval', '');
        const hostsError = (0, $ec1f42de4faacc37$export$175b49316ca08ef4)().message;
        const tempVars = (0, $a6ce8e821e7d53dd$export$9fc03b814431a2e0)(source);
        try {
            const hostsObject = await (0, $1cf43c986b8bf24f$export$d7283db715c4d532)(source.links.proxy, source.telegraf, telegrafSystemInterval, tempVars);
            if (!hostsObject) throw new Error(hostsError);
            const newHosts = await (0, $1cf43c986b8bf24f$export$82f0d732267ea60)(source.links.proxy, hostsObject, layouts, source.telegraf);
            this.setState({
                hostsObject: newHosts,
                hostsPageStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done
            });
        } catch (error) {
            console.error(error);
            notify((0, $ec1f42de4faacc37$export$175b49316ca08ef4)());
            this.setState({
                hostsPageStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error
            });
        }
    }
}
const $e332d644fe278728$var$mstp = (state)=>{
    const { app: { persisted: { autoRefresh: autoRefresh } }, links: links } = state;
    return {
        links: links,
        autoRefresh: autoRefresh
    };
};
const $e332d644fe278728$var$mdtp = (dispatch)=>({
        onChooseAutoRefresh: (0, $1f80bbeadc1a0021$export$2e2bcd8739ae039)((0, $cac020f89fc6c82e$export$5a78de5758caee29), dispatch),
        notify: (0, $1f80bbeadc1a0021$export$2e2bcd8739ae039)((0, $205d139de2918454$export$5e14cdade93d6f7b), dispatch)
    });
var $e332d644fe278728$export$2e2bcd8739ae039 = (0, $c8cd79e362cba2a4$export$a520fb22fccea800)((0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($e332d644fe278728$var$mstp, $e332d644fe278728$var$mdtp)((0, $bfd6e1b2bb3e3a9d$export$2e2bcd8739ae039)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($e332d644fe278728$export$42bd6b8eed053555))));



var $NdCUR = parcelRequire("NdCUR");



var $1v7mg = parcelRequire("1v7mg");

// Libraries

var $NdCUR = parcelRequire("NdCUR");


var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");

var $1v7mg = parcelRequire("1v7mg");

var $axd2S = parcelRequire("axd2S");

var $NdCUR = parcelRequire("NdCUR");

var $g2wso = parcelRequire("g2wso");
function $1636633b789d0ee3$export$2e2bcd8739ae039(WrappedComponent) {
    return class extends (0, $NdCUR.Component) {
        componentDidMount() {
            document.addEventListener('click', this.handleClickOutside, true);
        }
        componentWillUnmount() {
            document.removeEventListener('click', this.handleClickOutside, true);
        }
        handleClickOutside = (e)=>{
            const domNode = (0, (/*@__PURE__*/$parcel$interopDefault($g2wso))).findDOMNode(this);
            if ((!domNode || !domNode.contains(e.target)) && typeof this.wrappedComponent.handleClickOutside === 'function') this.wrappedComponent.handleClickOutside(e);
        };
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement(WrappedComponent, {
                ...this.props,
                ref: (ref)=>this.wrappedComponent = ref
            });
        }
    };
}




var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");

var $NdCUR = parcelRequire("NdCUR");

var $g2wso = parcelRequire("g2wso");
function $23ae721fc6e771d0$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $23ae721fc6e771d0$var$_setPrototypeOf(subClass, superClass);
}
function $23ae721fc6e771d0$var$_setPrototypeOf(o, p) {
    $23ae721fc6e771d0$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $23ae721fc6e771d0$var$_setPrototypeOf(o, p);
}
function $23ae721fc6e771d0$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $23ae721fc6e771d0$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
} /**
 * Check whether some DOM node is our Component's node.
 */ 
function $23ae721fc6e771d0$var$isNodeFound(current, componentNode, ignoreClass) {
    if (current === componentNode) return true;
     // SVG <use/> elements do not technically reside in the rendered DOM, so
    // they do not have classList directly, but they offer a link to their
    // corresponding element, which can have classList. This extra check is for
    // that case.
    // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
    // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
    if (current.correspondingElement) return current.correspondingElement.classList.contains(ignoreClass);
    return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */ function $23ae721fc6e771d0$var$findHighest(current, componentNode, ignoreClass) {
    if (current === componentNode) return true;
     // If source=local then this event came from 'somewhere'
    // inside and should be ignored. We could handle this with
    // a layered approach, too, but that requires going back to
    // thinking in terms of Dom node nesting, running counter
    // to React's 'you shouldn't care about the DOM' philosophy.
    // Also cover shadowRoot node by checking current.host
    while(current.parentNode || current.host){
        // Only check normal node without shadowRoot
        if (current.parentNode && $23ae721fc6e771d0$var$isNodeFound(current, componentNode, ignoreClass)) return true;
        current = current.parentNode || current.host;
    }
    return current;
}
/**
 * Check if the browser scrollbar was clicked
 */ function $23ae721fc6e771d0$var$clickedScrollbar(evt) {
    return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
} // ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var $23ae721fc6e771d0$var$testPassiveEventSupport = function testPassiveEventSupport() {
    if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') return;
    var passive = false;
    var options = Object.defineProperty({}, 'passive', {
        get: function get() {
            passive = true;
        }
    });
    var noop = function noop() {};
    window.addEventListener('testPassiveEventSupport', noop, options);
    window.removeEventListener('testPassiveEventSupport', noop, options);
    return passive;
};
function $23ae721fc6e771d0$var$autoInc(seed) {
    if (seed === void 0) seed = 0;
    return function() {
        return ++seed;
    };
}
var $23ae721fc6e771d0$var$uid = $23ae721fc6e771d0$var$autoInc();
var $23ae721fc6e771d0$var$passiveEventSupport;
var $23ae721fc6e771d0$var$handlersMap = {};
var $23ae721fc6e771d0$var$enabledInstances = {};
var $23ae721fc6e771d0$var$touchEvents = [
    'touchstart',
    'touchmove'
];
var $23ae721fc6e771d0$export$e2911fc69bd3195e = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */ function $23ae721fc6e771d0$var$getEventHandlerOptions(instance, eventName) {
    var handlerOptions = null;
    var isTouchEvent = $23ae721fc6e771d0$var$touchEvents.indexOf(eventName) !== -1;
    if (isTouchEvent && $23ae721fc6e771d0$var$passiveEventSupport) handlerOptions = {
        passive: !instance.props.preventDefault
    };
    return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */ function $23ae721fc6e771d0$var$onClickOutsideHOC(WrappedComponent, config) {
    var _class, _temp;
    var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    return _temp = _class = /*#__PURE__*/ function(_Component) {
        $23ae721fc6e771d0$var$_inheritsLoose(onClickOutside, _Component);
        function onClickOutside(props) {
            var _this;
            _this = _Component.call(this, props) || this;
            _this.__outsideClickHandler = function(event) {
                if (typeof _this.__clickOutsideHandlerProp === 'function') {
                    _this.__clickOutsideHandlerProp(event);
                    return;
                }
                var instance = _this.getInstance();
                if (typeof instance.props.handleClickOutside === 'function') {
                    instance.props.handleClickOutside(event);
                    return;
                }
                if (typeof instance.handleClickOutside === 'function') {
                    instance.handleClickOutside(event);
                    return;
                }
                throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
            };
            _this.__getComponentNode = function() {
                var instance = _this.getInstance();
                if (config && typeof config.setClickOutsideRef === 'function') return config.setClickOutsideRef()(instance);
                if (typeof instance.setClickOutsideRef === 'function') return instance.setClickOutsideRef();
                return (0, $g2wso.findDOMNode)(instance);
            };
            _this.enableOnClickOutside = function() {
                if (typeof document === 'undefined' || $23ae721fc6e771d0$var$enabledInstances[_this._uid]) return;
                if (typeof $23ae721fc6e771d0$var$passiveEventSupport === 'undefined') $23ae721fc6e771d0$var$passiveEventSupport = $23ae721fc6e771d0$var$testPassiveEventSupport();
                $23ae721fc6e771d0$var$enabledInstances[_this._uid] = true;
                var events = _this.props.eventTypes;
                if (!events.forEach) events = [
                    events
                ];
                $23ae721fc6e771d0$var$handlersMap[_this._uid] = function(event) {
                    if (_this.componentNode === null) return;
                    if (_this.props.preventDefault) event.preventDefault();
                    if (_this.props.stopPropagation) event.stopPropagation();
                    if (_this.props.excludeScrollbar && $23ae721fc6e771d0$var$clickedScrollbar(event)) return;
                    var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;
                    if ($23ae721fc6e771d0$var$findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) return;
                    _this.__outsideClickHandler(event);
                };
                events.forEach(function(eventName) {
                    document.addEventListener(eventName, $23ae721fc6e771d0$var$handlersMap[_this._uid], $23ae721fc6e771d0$var$getEventHandlerOptions($23ae721fc6e771d0$var$_assertThisInitialized(_this), eventName));
                });
            };
            _this.disableOnClickOutside = function() {
                delete $23ae721fc6e771d0$var$enabledInstances[_this._uid];
                var fn = $23ae721fc6e771d0$var$handlersMap[_this._uid];
                if (fn && typeof document !== 'undefined') {
                    var events = _this.props.eventTypes;
                    if (!events.forEach) events = [
                        events
                    ];
                    events.forEach(function(eventName) {
                        return document.removeEventListener(eventName, fn, $23ae721fc6e771d0$var$getEventHandlerOptions($23ae721fc6e771d0$var$_assertThisInitialized(_this), eventName));
                    });
                    delete $23ae721fc6e771d0$var$handlersMap[_this._uid];
                }
            };
            _this.getRef = function(ref) {
                return _this.instanceRef = ref;
            };
            _this._uid = $23ae721fc6e771d0$var$uid();
            return _this;
        }
        /**
     * Access the WrappedComponent's instance.
     */ var _proto = onClickOutside.prototype;
        _proto.getInstance = function getInstance() {
            if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) return this;
            var ref = this.instanceRef;
            return ref.getInstance ? ref.getInstance() : ref;
        };
        /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */ _proto.componentDidMount = function componentDidMount() {
            // If we are in an environment without a DOM such
            // as shallow rendering or snapshots then we exit
            // early to prevent any unhandled errors being thrown.
            if (typeof document === 'undefined' || !document.createElement) return;
            var instance = this.getInstance();
            if (config && typeof config.handleClickOutside === 'function') {
                this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
                if (typeof this.__clickOutsideHandlerProp !== 'function') throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
            }
            this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside
            if (this.props.disableOnClickOutside) return;
            this.enableOnClickOutside();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            this.componentNode = this.__getComponentNode();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.disableOnClickOutside();
        };
        /**
     * Pass-through render
     */ _proto.render = function render() {
            // eslint-disable-next-line no-unused-vars
            var _this$props = this.props;
            _this$props.excludeScrollbar;
            var props = $23ae721fc6e771d0$var$_objectWithoutPropertiesLoose(_this$props, [
                "excludeScrollbar"
            ]);
            if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) props.ref = this.getRef;
            else props.wrappedRef = this.getRef;
            props.disableOnClickOutside = this.disableOnClickOutside;
            props.enableOnClickOutside = this.enableOnClickOutside;
            return (0, $NdCUR.createElement)(WrappedComponent, props);
        };
        return onClickOutside;
    }((0, $NdCUR.Component)), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
        eventTypes: [
            'mousedown',
            'touchstart'
        ],
        excludeScrollbar: config && config.excludeScrollbar || false,
        outsideClickIgnoreClass: $23ae721fc6e771d0$export$e2911fc69bd3195e,
        preventDefault: false,
        stopPropagation: false
    }, _class.getClass = function() {
        return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
    }, _temp;
}
var $23ae721fc6e771d0$export$2e2bcd8739ae039 = $23ae721fc6e771d0$var$onClickOutsideHOC;




class $9a9c21a962c277dc$var$CustomTimeRangeOverlay extends (0, $NdCUR.Component) {
    constructor(props){
        super(props);
    }
    handleClickOutside() {
        this.props.onClose();
    }
    render() {
        const { onClose: onClose, timeRange: timeRange, onApplyTimeRange: onApplyTimeRange, page: page } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "custom-time--overlay"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7725d0f67cc4984c$export$2e2bcd8739ae039), {
            onApplyTimeRange: onApplyTimeRange,
            timeRange: timeRange,
            onClose: onClose,
            page: page
        }));
    }
}
const { func: $9a9c21a962c277dc$var$func, shape: $9a9c21a962c277dc$var$shape, string: $9a9c21a962c277dc$var$string } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$9a9c21a962c277dc$var$CustomTimeRangeOverlay.propTypes = {
    onApplyTimeRange: $9a9c21a962c277dc$var$func.isRequired,
    timeRange: $9a9c21a962c277dc$var$shape({
        lower: $9a9c21a962c277dc$var$string.isRequired,
        upper: $9a9c21a962c277dc$var$string
    }).isRequired,
    onClose: $9a9c21a962c277dc$var$func,
    page: $9a9c21a962c277dc$var$string
};
var $9a9c21a962c277dc$export$2e2bcd8739ae039 = (0, $23ae721fc6e771d0$export$2e2bcd8739ae039)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($9a9c21a962c277dc$var$CustomTimeRangeOverlay));






var $axd2S = parcelRequire("axd2S");




var $hBdgJ = parcelRequire("hBdgJ");

var $NdCUR = parcelRequire("NdCUR");
const $557b602c140cbcc0$var$dateFormat = 'YYYY-MM-DD HH:mm';
const $557b602c140cbcc0$var$format = (t, timeZone)=>{
    const m = (0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(t.replace(/'/g, ''));
    if (timeZone === (0, $a7b864c61f4e95a7$export$d6f132cca63fb222).UTC) m.utc();
    return m.format($557b602c140cbcc0$var$dateFormat);
};
function $557b602c140cbcc0$export$2168f5e111e02aa9({ timeRange: { upper: upper, lower: lower }, timeZone: timeZone }) {
    if (upper && lower) {
        if (upper === 'now()') return `${$557b602c140cbcc0$var$format(lower, timeZone)} - Now`;
        return `${$557b602c140cbcc0$var$format(lower, timeZone)} - ${$557b602c140cbcc0$var$format(upper, timeZone)}`;
    }
    const selected = (0, $6a7b0ae94f8ec28f$export$9b55ef3c660cd071).find((range)=>range.lower === lower);
    return selected ? selected.inputValue : 'Custom';
}
class $557b602c140cbcc0$var$TimeRangeLabel extends (0, $NdCUR.PureComponent) {
    render() {
        return $557b602c140cbcc0$export$2168f5e111e02aa9(this.props);
    }
}
const $557b602c140cbcc0$var$mstp = (state)=>({
        timeZone: (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(state, [
            'app',
            'persisted',
            'timeZone'
        ])
    });
var $557b602c140cbcc0$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($557b602c140cbcc0$var$mstp)($557b602c140cbcc0$var$TimeRangeLabel);


const $80cff9834e653b0a$var$emptyTime = {
    lower: '',
    upper: ''
};
let $80cff9834e653b0a$var$timeoutHandle;
function $80cff9834e653b0a$export$71a9f17adbf66515(e) {
    if (e && e.preventDefault) e.preventDefault();
    const el1 = document.getElementsByClassName('time-range-dropdown')[0];
    if (el1) {
        if (!$80cff9834e653b0a$var$timeoutHandle) el1.classList.add('highlight');
        else clearTimeout($80cff9834e653b0a$var$timeoutHandle);
        $80cff9834e653b0a$var$timeoutHandle = setTimeout(()=>{
            const el2 = document.getElementsByClassName('time-range-dropdown')[0];
            if (el2) el2.classList.remove('highlight');
            $80cff9834e653b0a$var$timeoutHandle = undefined;
        }, 1000);
    }
}
class $80cff9834e653b0a$var$TimeRangeDropdown extends (0, $NdCUR.Component) {
    constructor(props){
        super(props);
        const { lower: lower, upper: upper } = props.selected;
        const isTimeValid = (0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(upper).isValid() && (0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(lower).isValid();
        const customTimeRange = isTimeValid ? {
            lower: lower,
            upper: upper
        } : $80cff9834e653b0a$var$emptyTime;
        this.state = {
            autobind: false,
            isOpen: false,
            isCustomTimeRangeOpen: false,
            customTimeRange: customTimeRange
        };
    }
    handleClickOutside = ()=>{
        this.setState({
            isOpen: false
        });
    };
    handleSelection = (timeRange)=>()=>{
            this.setState({
                customTimeRange: $80cff9834e653b0a$var$emptyTime,
                isOpen: false
            }, ()=>{
                window.setTimeout(()=>{
                    this.props.onChooseTimeRange(timeRange);
                }, 0);
            });
        };
    toggleMenu = ()=>{
        this.setState({
            isOpen: !this.state.isOpen
        });
    };
    showCustomTimeRange = ()=>{
        this.setState({
            isCustomTimeRangeOpen: true
        });
    };
    handleApplyCustomTimeRange = (customTimeRange)=>{
        this.props.onChooseTimeRange({
            ...customTimeRange
        });
        this.setState({
            customTimeRange: customTimeRange,
            isOpen: false
        });
    };
    handleToggleCustomTimeRange = ()=>{
        this.setState({
            isCustomTimeRangeOpen: !this.state.isCustomTimeRangeOpen
        });
    };
    handleCloseCustomTimeRange = ()=>{
        this.setState({
            isCustomTimeRangeOpen: false
        });
    };
    render() {
        const { selected: selected, preventCustomTimeRange: preventCustomTimeRange, page: page } = this.props;
        const { isOpen: isOpen, customTimeRange: customTimeRange, isCustomTimeRangeOpen: isCustomTimeRangeOpen } = this.state;
        const isRelativeTimeRange = selected.upper === null;
        const isNow = selected.upper === 'now()';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "time-range-dropdown"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('dropdown', {
                'dropdown-120': isRelativeTimeRange,
                'dropdown-210': isNow,
                'dropdown-290': !isRelativeTimeRange && !isNow,
                open: isOpen
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "btn btn-sm btn-default dropdown-toggle",
            onClick: this.toggleMenu
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon clock"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "dropdown-selected"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $557b602c140cbcc0$export$2e2bcd8739ae039), {
            timeRange: selected
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "caret"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("ul", {
            className: "dropdown-menu"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), {
            autoHide: false,
            autoHeight: true,
            maxHeight: (0, $e10a8602f56394e3$export$bd1588cc2d72fbf)
        }, preventCustomTimeRange ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("li", {
            className: "dropdown-header"
        }, "Absolute Time"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("li", {
            className: isCustomTimeRangeOpen ? 'active dropdown-item custom-timerange' : 'dropdown-item custom-timerange'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("a", {
            href: "#",
            onClick: this.showCustomTimeRange
        }, "Date Picker"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("li", {
            className: "dropdown-header"
        }, preventCustomTimeRange ? '' : 'Relative ', "Time"), (0, $6a7b0ae94f8ec28f$export$9b55ef3c660cd071).map((item)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("li", {
                className: "dropdown-item",
                key: item.menuOption
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("a", {
                href: "#",
                onClick: this.handleSelection(item)
            }, item.menuOption));
        })))), isCustomTimeRangeOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $9a9c21a962c277dc$export$2e2bcd8739ae039), {
            onApplyTimeRange: this.handleApplyCustomTimeRange,
            timeRange: customTimeRange,
            isVisible: isCustomTimeRangeOpen,
            onToggle: this.handleToggleCustomTimeRange,
            onClose: this.handleCloseCustomTimeRange,
            page: page
        }) : null);
    }
}
const { bool: $80cff9834e653b0a$var$bool, func: $80cff9834e653b0a$var$func, shape: $80cff9834e653b0a$var$shape, string: $80cff9834e653b0a$var$string } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$80cff9834e653b0a$var$TimeRangeDropdown.defaultProps = {
    page: 'default'
};
$80cff9834e653b0a$var$TimeRangeDropdown.propTypes = {
    selected: $80cff9834e653b0a$var$shape({
        lower: $80cff9834e653b0a$var$string,
        upper: $80cff9834e653b0a$var$string
    }).isRequired,
    onChooseTimeRange: $80cff9834e653b0a$var$func.isRequired,
    preventCustomTimeRange: $80cff9834e653b0a$var$bool,
    page: $80cff9834e653b0a$var$string
};
var $80cff9834e653b0a$export$2e2bcd8739ae039 = (0, $1636633b789d0ee3$export$2e2bcd8739ae039)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($80cff9834e653b0a$var$TimeRangeDropdown));



var $NdCUR = parcelRequire("NdCUR");

const $3489e5a069c3594c$var$graphTipsText = '<h1>Graph Tips:</h1><p><code>Click + Drag</code> Zoom in (X or Y)<br/><code>Shift + Click</code> Pan Graph Window<br/><code>Double Click</code> Reset Graph Window</p><h1>Static Legend Tips:</h1><p><code>Click</code>Focus on single Series<br/><code>Shift + Click</code> Show/Hide single Series</p>';
const $3489e5a069c3594c$var$GraphTips = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "graph-tips",
        "data-for": "graph-tips-tooltip",
        "data-tip": $3489e5a069c3594c$var$graphTipsText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", null, "?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $82a18451bb6f6ba0$export$2e2bcd8739ae039), {
        id: "graph-tips-tooltip",
        effect: "solid",
        html: true,
        place: "bottom",
        class: "influx-tooltip"
    }));
var $3489e5a069c3594c$export$2e2bcd8739ae039 = $3489e5a069c3594c$var$GraphTips;


// Libraries

var $NdCUR = parcelRequire("NdCUR");


class $5ee81dbb90cfaed2$var$RenameDashboard extends (0, $NdCUR.Component) {
    constructor(props){
        super(props), this.handleStartEditing = ()=>{
            this.setState({
                isEditing: true
            });
        }, this.handleInputBlur = (e)=>{
            const { onRename: onRename } = this.props;
            const { reset: reset } = this.state;
            if (reset) this.setState({
                isEditing: false
            });
            else {
                const newName = e.target.value || (0, $9a9ec629fdd38845$export$de748f9c6ef6e33d);
                onRename(newName);
            }
            this.setState({
                isEditing: false,
                reset: false
            });
        }, this.handleKeyDown = (e)=>{
            if (e.key === 'Enter') this.inputRef.blur();
            if (e.key === 'Escape') {
                this.inputRef.value = this.props.name;
                this.setState({
                    reset: true
                }, ()=>this.inputRef.blur());
            }
        }, this.handleFocus = (e)=>{
            e.target.select();
        };
        this.state = {
            isEditing: false,
            reset: false
        };
    }
    render() {
        const { isEditing: isEditing } = this.state;
        const { name: name } = this.props;
        if (isEditing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "rename-dashboard"
        }, this.input);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "rename-dashboard",
            "data-test": "rename-dashboard"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "rename-dashboard--title",
            onClick: this.handleStartEditing
        }, name, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon pencil"
        })));
    }
    get input() {
        const { name: name } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            maxLength: (0, $9a9ec629fdd38845$export$11ca3f7205bba4a6),
            type: "text",
            className: "rename-dashboard--input form-control input-sm",
            defaultValue: name,
            autoComplete: "off",
            autoFocus: true,
            spellCheck: false,
            onBlur: this.handleInputBlur,
            onKeyDown: this.handleKeyDown,
            onFocus: this.handleFocus,
            placeholder: "Name this Dashboard",
            ref: (r)=>this.inputRef = r
        });
    }
}
var $5ee81dbb90cfaed2$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($5ee81dbb90cfaed2$var$RenameDashboard);



var $NdCUR = parcelRequire("NdCUR");


var $hBdgJ = parcelRequire("hBdgJ");

var $1v7mg = parcelRequire("1v7mg");




class $958ea781e9ff4fcd$var$DashboardSwitcher extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleClickOutside = ()=>{
            this.setState({
                isOpen: false
            });
        }, this.handleToggleMenu = ()=>{
            this.setState({
                isOpen: !this.state.isOpen
            });
        }, this.handleCloseMenu = ()=>{
            this.setState({
                isOpen: false
            });
        };
        this.state = {
            isOpen: false
        };
    }
    render() {
        const { isOpen: isOpen } = this.state;
        const openClass = isOpen ? 'open' : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: `dropdown dashboard-switcher ${openClass}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-square btn-default btn-sm dropdown-toggle",
            onClick: this.handleToggleMenu
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon dash-h"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("ul", {
            className: "dropdown-menu"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), {
            autoHeight: true,
            maxHeight: (0, $e10a8602f56394e3$export$bd1588cc2d72fbf)
        }, this.links)));
    }
    get links() {
        const { links: links, active: active } = this.props.dashboardLinks;
        return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).sortBy(links, ({ text: text, key: key })=>[
                text.toLowerCase(),
                key
            ]).map((link)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("li", {
                key: link.key,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('dropdown-item', {
                    active: link === active
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ba1cc4424c00aefe$export$2e2bcd8739ae039), {
                to: link.to,
                onClick: this.handleCloseMenu
            }, link.text));
        });
    }
}
var $958ea781e9ff4fcd$export$2e2bcd8739ae039 = (0, $1636633b789d0ee3$export$2e2bcd8739ae039)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($958ea781e9ff4fcd$var$DashboardSwitcher));






class $2af4af39d360d566$var$DashboardHeader extends (0, $NdCUR.Component) {
    static{
        this.defaultProps = {
            zoomedTimeRange: {
                upper: null,
                lower: null
            }
        };
    }
    static getDerivedStateFromProps(props) {
        const { upper: upper, lower: lower } = props.zoomedTimeRange;
        if (upper || lower) return {
            selected: {
                upper: upper,
                lower: lower
            }
        };
        if (!props.zoomedTimeRange.lower) return {
            selected: {
                upper: props.timeRange.upper,
                lower: props.timeRange.lower
            }
        };
        return {};
    }
    constructor(props){
        super(props), this.handleChooseTimeRange = (timeRange)=>{
            this.setState({
                selected: timeRange
            }, ()=>{
                window.setTimeout(()=>{
                    this.props.handleChooseTimeRange(timeRange);
                }, 0);
            });
        }, this.handleClickPresentationButton = ()=>{
            this.props.handleClickPresentationButton();
        };
        const { timeRange: timeRange, zoomedTimeRange: zoomedTimeRange } = props;
        this.state = {
            selected: {
                upper: timeRange.upper || zoomedTimeRange.upper,
                lower: timeRange.lower || zoomedTimeRange.lower
            }
        };
    }
    render() {
        const { isHidden: isHidden, timeZone: timeZone, autoRefresh: autoRefresh, onSetTimeZone: onSetTimeZone, onManualRefresh: onManualRefresh, handleChooseAutoRefresh: handleChooseAutoRefresh, children: children } = this.props;
        const { selected: selected } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header, {
            fullWidth: true,
            inPresentationMode: isHidden
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header.Left, null, this.dashboardSwitcher, this.dashboardTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header.Right, {
            showSourceIndicator: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $3489e5a069c3594c$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ed11f2457ce5ca00$export$2e2bcd8739ae039), {
            timeZone: timeZone,
            onSetTimeZone: onSetTimeZone
        }), this.addCellButton, this.toolButtons, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $e6a8d4614c25ddf0$export$2e2bcd8739ae039), {
            onChoose: handleChooseAutoRefresh,
            onManualRefresh: onManualRefresh,
            selected: autoRefresh
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $80cff9834e653b0a$export$2e2bcd8739ae039), {
            onChooseTimeRange: this.handleChooseTimeRange,
            selected: selected
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
            icon: (0, $918c9f03a35fe03f$export$62c9c0cf752cde38).ExpandA,
            onClick: this.handleClickPresentationButton,
            shape: (0, $918c9f03a35fe03f$export$ce765fb8bb08a599).Square,
            titleText: "Enter Full-Screen Presentation Mode"
        }), children));
    }
    get addCellButton() {
        const { dashboard: dashboard, onAddCell: onAddCell } = this.props;
        if (dashboard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $091cfcd49e339acd$export$2e2bcd8739ae039), {
            requiredRole: (0, $a7910b1002260d34$export$f715f7e27dea2abf)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
            shape: (0, $918c9f03a35fe03f$export$ce765fb8bb08a599).Square,
            color: (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Primary,
            icon: (0, $918c9f03a35fe03f$export$62c9c0cf752cde38).AddCell,
            onClick: onAddCell,
            titleText: "Add a Cell to Dashboard",
            testId: "add-cell"
        }));
    }
    get toolButtons() {
        const { dashboard: dashboard, showTempVarControls: showTempVarControls, onToggleShowTempVarControls: onToggleShowTempVarControls, showAnnotationControls: showAnnotationControls, onToggleShowAnnotationControls: onToggleShowAnnotationControls } = this.props;
        if (dashboard) {
            let variablesTooltip = 'Show Template Variables Controls';
            let annotationsTooltip = 'Show Annotations Controls';
            let variablesDataTest = 'show-variables--button';
            let annotationsDataTest = 'show-annotations--button';
            if (showTempVarControls) {
                variablesTooltip = 'Hide Template Variables Controls';
                variablesDataTest = 'hide-variables--button';
            }
            if (showAnnotationControls) {
                annotationsTooltip = 'Hide Annotations Controls';
                annotationsDataTest = 'hide-annotations--button';
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
                text: "Variables",
                icon: (0, $918c9f03a35fe03f$export$62c9c0cf752cde38).Cube,
                onClick: onToggleShowTempVarControls,
                active: showTempVarControls,
                titleText: variablesTooltip,
                testId: variablesDataTest
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
                text: "Annotations",
                icon: (0, $918c9f03a35fe03f$export$62c9c0cf752cde38).Annotate,
                onClick: onToggleShowAnnotationControls,
                active: showAnnotationControls,
                titleText: annotationsTooltip,
                testId: annotationsDataTest
            }));
        }
    }
    get dashboardSwitcher() {
        const { dashboardLinks: dashboardLinks } = this.props;
        if (dashboardLinks.links.length > 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $958ea781e9ff4fcd$export$2e2bcd8739ae039), {
            dashboardLinks: dashboardLinks
        });
    }
    get dashboardTitle() {
        const { dashboard: dashboard, activeDashboard: activeDashboard, onRenameDashboard: onRenameDashboard } = this.props;
        if (dashboard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $091cfcd49e339acd$export$2e2bcd8739ae039), {
            requiredRole: (0, $a7910b1002260d34$export$f715f7e27dea2abf),
            replaceWithIfNotAuthorized: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Title, {
                title: activeDashboard
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $5ee81dbb90cfaed2$export$2e2bcd8739ae039), {
            onRename: onRenameDashboard,
            name: activeDashboard
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Title, {
            title: activeDashboard
        });
    }
}
var $2af4af39d360d566$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($2af4af39d360d566$var$DashboardHeader);







const $366e79a20fc561c5$export$b430c2bd97f9d15b = {
    links: [],
    active: null
};






var $hBdgJ = parcelRequire("hBdgJ");


const $ee716cce310893b3$var$CELL_WIDTH = 4;
const $ee716cce310893b3$var$CELL_HEIGHT = 4;
const $ee716cce310893b3$var$PAGE_WIDTH = 12;
function $ee716cce310893b3$export$23ddd1bf7e858cfc(layouts, source) {
    const layoutCells = $ee716cce310893b3$var$getLayoutCells(layouts);
    const cells = layoutCells.map((d)=>$ee716cce310893b3$var$toCell(d, source));
    return cells;
}
function $ee716cce310893b3$var$getLayoutCells(layouts) {
    if (layouts.length === 0) return [];
    const autoflowLayouts = layouts.filter((l)=>!!l.autoflow);
    const autoflowCells = (0, $hBdgJ.flatten)(autoflowLayouts.map((l)=>l.cells));
    const staticLayouts = layouts.filter((layout)=>!layout.autoflow);
    const cellGroups = [
        $ee716cce310893b3$var$autoPositionCells(autoflowCells),
        ...staticLayouts.map((layout)=>layout.cells)
    ];
    const cells = $ee716cce310893b3$var$translateCellGroups(cellGroups);
    return cells;
}
function $ee716cce310893b3$var$autoPositionCells(cells) {
    return cells.reduce((acc, cell, i)=>{
        const x = i * $ee716cce310893b3$var$CELL_WIDTH % $ee716cce310893b3$var$PAGE_WIDTH;
        const y = Math.floor(i * $ee716cce310893b3$var$CELL_WIDTH / $ee716cce310893b3$var$PAGE_WIDTH) * $ee716cce310893b3$var$CELL_HEIGHT;
        const newCell = {
            ...cell,
            w: $ee716cce310893b3$var$CELL_WIDTH,
            h: $ee716cce310893b3$var$CELL_HEIGHT,
            x: x,
            y: y
        };
        return [
            ...acc,
            newCell
        ];
    }, []);
}
function $ee716cce310893b3$var$translateCellGroups(groups) {
    const cells = [];
    let translateY = 0;
    for (const group of groups){
        let maxY = 0;
        for (const cell of group){
            cell.y += translateY;
            if (cell.y > translateY) maxY = cell.y;
            cells.push(cell);
        }
        translateY = maxY;
    }
    return cells;
}
function $ee716cce310893b3$var$toCell(layoutCell, source) {
    const queries = layoutCell.queries.map((d)=>$ee716cce310893b3$var$toCellQuery(d, source));
    const cell = {
        ...(0, $9a9ec629fdd38845$export$5555fe053dab8f56),
        ...layoutCell,
        queries: queries,
        links: {},
        legend: {},
        type: (0, $b4506126e09430df$export$705e36171f4cbbfe).Line,
        colors: []
    };
    return cell;
}
function $ee716cce310893b3$var$toCellQuery(layoutQuery, source) {
    const cellQuery = {
        ...layoutQuery,
        source: source.url,
        type: 'influxql'
    };
    return cellQuery;
}


class $d7371a9c353b1d15$var$HostPage extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleChooseTimeRange = ({ lower: lower, upper: upper })=>{
            if (upper) this.setState({
                timeRange: {
                    lower: lower,
                    upper: upper
                }
            });
            else {
                const timeRange = (0, $6a7b0ae94f8ec28f$export$9b55ef3c660cd071).find((range)=>range.lower === lower);
                this.setState({
                    timeRange: timeRange
                });
            }
        }, this.getHostLinks = async ()=>{
            const { source: source, params: { hostID: hostID } } = this.props;
            const activeHost = {
                name: hostID
            };
            const links = await (0, $1cf43c986b8bf24f$export$fcfcb6181e9c856e)(source, activeHost);
            return links;
        };
        this.state = {
            layouts: [],
            hostLinks: (0, $366e79a20fc561c5$export$b430c2bd97f9d15b),
            timeRange: (0, $6a7b0ae94f8ec28f$export$9b55ef3c660cd071).find((tr)=>tr.lower === 'now() - 1h')
        };
        this.handleChooseAutoRefresh = this.handleChooseAutoRefresh.bind(this);
    }
    async componentDidMount() {
        const { location: location, autoRefresh: autoRefresh } = this.props;
        const { data: { layouts: layouts } } = await (0, $1cf43c986b8bf24f$export$9340fad0531287fd)();
        // fetching layouts and mappings can be done at the same time
        const { host: host, measurements: measurements } = await this.fetchHostsAndMeasurements(layouts);
        const focusedApp = location.query.app;
        const filteredLayouts = layouts.filter((layout)=>{
            if (focusedApp) return layout.app === focusedApp;
            return host.apps && host.apps.includes(layout.app) && measurements.includes(layout.measurement);
        });
        const hostLinks = await this.getHostLinks();
        this.setState({
            layouts: filteredLayouts,
            hostLinks: hostLinks
        }) // eslint-disable-line react/no-did-mount-set-state
        ;
        (0, $a926ccb172fe03ce$export$a3ea0b2d0765f52e).poll(autoRefresh);
    }
    componentDidUpdate(prevProps) {
        const { autoRefresh: autoRefresh } = this.props;
        if (prevProps.autoRefresh !== autoRefresh) (0, $a926ccb172fe03ce$export$a3ea0b2d0765f52e).poll(autoRefresh);
    }
    componentWillUnmount() {
        (0, $a926ccb172fe03ce$export$a3ea0b2d0765f52e).stopPolling();
    }
    handleChooseAutoRefresh(option) {
        const { handleChooseTimeRange: handleChooseTimeRange } = this.props;
        const { milliseconds: milliseconds } = option;
        handleChooseTimeRange(milliseconds);
    }
    render() {
        const { autoRefresh: autoRefresh, manualRefresh: manualRefresh, onManualRefresh: onManualRefresh, params: { hostID: hostID }, inPresentationMode: inPresentationMode, handleClickPresentationButton: handleClickPresentationButton, source: source, timeZone: timeZone, onSetTimeZone: onSetTimeZone } = this.props;
        const { timeRange: timeRange, hostLinks: hostLinks, layouts: layouts } = this.state;
        const layoutCells = (0, $ee716cce310893b3$export$23ddd1bf7e858cfc)(layouts, source);
        const tempVars = (0, $a6ce8e821e7d53dd$export$9fc03b814431a2e0)(source);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "page"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $2af4af39d360d566$export$2e2bcd8739ae039), {
            timeRange: timeRange,
            activeDashboard: hostID,
            autoRefresh: autoRefresh,
            isHidden: inPresentationMode,
            onManualRefresh: onManualRefresh,
            handleChooseAutoRefresh: this.handleChooseAutoRefresh,
            handleChooseTimeRange: this.handleChooseTimeRange,
            handleClickPresentationButton: handleClickPresentationButton,
            dashboardLinks: hostLinks,
            timeZone: timeZone,
            onSetTimeZone: onSetTimeZone
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))({
                'page-contents': true,
                'presentation-mode': inPresentationMode
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "container-fluid full-width dashboard"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $3abcc8f3edbea0d9$export$2e2bcd8739ae039), {
            source: source,
            sources: [
                source
            ],
            isStatusPage: false,
            isEditable: false,
            cells: layoutCells,
            templates: tempVars,
            timeRange: timeRange,
            manualRefresh: manualRefresh,
            host: this.props.params.hostID
        }))));
    }
    async fetchHostsAndMeasurements(layouts) {
        const { source: source, params: params } = this.props;
        const fetchMeasurements = (0, $1cf43c986b8bf24f$export$93106d668d19e91b)(source, params.hostID);
        const fetchHosts = (0, $1cf43c986b8bf24f$export$81a06a432192210b)(source.links.proxy, params.hostID, layouts, source.telegraf);
        const [host, measurements] = await Promise.all([
            fetchHosts,
            fetchMeasurements
        ]);
        return {
            host: host,
            measurements: measurements
        };
    }
}
const $d7371a9c353b1d15$var$mstp = ({ app: { ephemeral: { inPresentationMode: inPresentationMode }, persisted: { autoRefresh: autoRefresh, timeZone: timeZone } } })=>({
        inPresentationMode: inPresentationMode,
        autoRefresh: autoRefresh,
        timeZone: timeZone
    });
const $d7371a9c353b1d15$var$mdtp = {
    handleChooseTimeRange: (0, $cac020f89fc6c82e$export$5a78de5758caee29),
    handleClickPresentationButton: (0, $cac020f89fc6c82e$export$84ea1cdd7d049965),
    onSetTimeZone: (0, $cac020f89fc6c82e$export$93c56f26d2728d8d)
};
var $d7371a9c353b1d15$export$2e2bcd8739ae039 = (0, $c8cd79e362cba2a4$export$a520fb22fccea800)((0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($d7371a9c353b1d15$var$mstp, $d7371a9c353b1d15$var$mdtp)((0, $bfd6e1b2bb3e3a9d$export$2e2bcd8739ae039)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($d7371a9c353b1d15$var$HostPage))));





var $NdCUR = parcelRequire("NdCUR");

// Libraries

var $NdCUR = parcelRequire("NdCUR");



var $NdCUR = parcelRequire("NdCUR");
// Libraries

var $hBdgJ = parcelRequire("hBdgJ");





// Libraries


var $hBdgJ = parcelRequire("hBdgJ");







function $975a79a7c96f3d95$export$c384300448dab5fa(cell) {
    const queryDrafts = $975a79a7c96f3d95$var$initialQueryDrafts(cell);
    const queryType = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(cell, 'queries.0.type', (0, $b4506126e09430df$export$7c8e26efb80b90e8).InfluxQL);
    const initialState = {
        queryDrafts: queryDrafts,
        type: cell.type,
        queryType: queryType,
        fieldOptions: cell.fieldOptions,
        timeFormat: cell.timeFormat,
        decimalPlaces: cell.decimalPlaces,
        note: cell.note,
        noteVisibility: cell.noteVisibility
    };
    if ((0, $hBdgJ.get)(cell, 'queries.0.type') === (0, $b4506126e09430df$export$7c8e26efb80b90e8).Flux) {
        initialState.script = (0, $hBdgJ.get)(cell, 'queries.0.query', '');
        initialState.draftScript = (0, $hBdgJ.get)(cell, 'queries.0.query', '');
    }
    if (cell.tableOptions) initialState.tableOptions = cell.tableOptions;
    const axes = cell.axes;
    const colors = cell.colors;
    if (axes) initialState.axes = axes;
    if (colors) {
        initialState.gaugeColors = (0, $687ef8d4c4e21a50$export$7262f438e3d270ab)(colors);
        initialState.thresholdsListColors = (0, $687ef8d4c4e21a50$export$9f0e460e075d61e4)(colors);
        initialState.lineColors = (0, $b00e3cd70e675d45$export$a20036365ba1ef4)(colors);
    }
    return initialState;
}
function $975a79a7c96f3d95$var$initialQueryDrafts(cell) {
    const queries = (0, $hBdgJ.get)(cell, 'queries', []);
    if (!cell.queries.length) return [
        $975a79a7c96f3d95$export$8d2e39f192e88e4((0, $b4506126e09430df$export$7c8e26efb80b90e8).InfluxQL)
    ];
    if (cell.queries[0].type === (0, $b4506126e09430df$export$7c8e26efb80b90e8).Flux) return [
        $975a79a7c96f3d95$export$8d2e39f192e88e4((0, $b4506126e09430df$export$7c8e26efb80b90e8).InfluxQL, cell.queries[0].source)
    ];
    return queries.map((q)=>{
        const id = (0, $dbdc5944552afab7$export$2e2bcd8739ae039)();
        const queryConfig = {
            ...q.queryConfig,
            range: (0, $0ece195804443aff$export$fe73f2cc6771a40f)(q.queryConfig),
            id: id
        };
        return {
            ...q,
            queryConfig: queryConfig,
            id: id
        };
    });
}
function $975a79a7c96f3d95$export$8d2e39f192e88e4(type, source = '') {
    const id = (0, $dbdc5944552afab7$export$2e2bcd8739ae039)();
    const defaultDraft = {
        id: id,
        type: type,
        source: source,
        query: '',
        queryConfig: (0, $12df0e6a12079fa8$export$2e2bcd8739ae039)({
            id: id
        })
    };
    return defaultDraft;
}
var $975a79a7c96f3d95$export$ec78b6147013e463 = /*#__PURE__*/ function(TMLocalStorageKey) {
    TMLocalStorageKey["DataExplorer"] = "dataExplorer";
    TMLocalStorageKey["CellEditorOverlay"] = "cellEditorOverlay";
    return TMLocalStorageKey;
}({});
function $975a79a7c96f3d95$export$f22967b337b5cd11() {
    const location = window.location.toString();
    if (location.indexOf('/dashboards/') !== -1) return "cellEditorOverlay";
    return "dataExplorer";
}
function $975a79a7c96f3d95$export$d3720feff416e85b(key) {
    try {
        const { version: version, data: data } = JSON.parse(window.localStorage.getItem(key));
        if (version !== (0, $e10a8602f56394e3$export$de001b401bf3761b)) return {};
        if (key === "cellEditorOverlay") {
            const { fluxProportions: fluxProportions, timeMachineProportions: timeMachineProportions, thresholdsListType: thresholdsListType } = data;
            return {
                fluxProportions: fluxProportions,
                timeMachineProportions: timeMachineProportions,
                thresholdsListType: thresholdsListType
            };
        }
        return data;
    } catch  {
        return {};
    }
}
function $975a79a7c96f3d95$export$1f73f60bdb811cb1(key, data) {
    const localStorageData = {
        version: (0, $e10a8602f56394e3$export$de001b401bf3761b),
        data: data
    };
    window.localStorage.setItem(key, JSON.stringify(localStorageData));
}


const $d6713fc94c521d4a$var$excludedStatements = [
    'drop',
    'delete',
    'alter',
    'create',
    'grant',
    'revoke',
    'use'
];
const $d6713fc94c521d4a$export$63fabf44ec222040 = (query)=>{
    return $d6713fc94c521d4a$var$excludedStatements.some((statement)=>query?.toLowerCase().startsWith(statement));
};







const $85c5ce2a0e85a1fb$export$9ee8aa157542e05b = [
    'mean',
    'median',
    'count',
    'min',
    'max',
    'sum',
    'first',
    'last',
    'spread',
    'stddev'
];
const $85c5ce2a0e85a1fb$export$5db4faff3209ddab = {
    queryMaker: 350,
    visualization: 200
};
const $85c5ce2a0e85a1fb$export$2fda72d75c6bc4fb = {
    queryMaker: '66.666%',
    visualization: '33.334%'
};
var $85c5ce2a0e85a1fb$export$24d041d6bfd6dced = /*#__PURE__*/ function(DropdownChildTypes) {
    DropdownChildTypes["Item"] = "item";
    DropdownChildTypes["Divider"] = "divider";
    return DropdownChildTypes;
}({});
const $85c5ce2a0e85a1fb$export$679c04984489026d = [
    {
        id: 'Show Databases',
        text: 'Show Databases',
        query: 'SHOW DATABASES',
        type: "item"
    },
    {
        id: 'Create Database',
        text: 'Create Database',
        query: 'CREATE DATABASE "db_name"',
        type: "item"
    },
    {
        id: 'Drop Database',
        text: 'Drop Database',
        query: 'DROP DATABASE "db_name"',
        type: "item"
    },
    {
        id: `mqtd-divider-1`,
        type: "divider"
    },
    {
        id: 'Show Measurements',
        text: 'Show Measurements',
        query: 'SHOW MEASUREMENTS ON "db_name"',
        type: "item"
    },
    {
        id: 'Show Tag Keys',
        text: 'Show Tag Keys',
        query: 'SHOW TAG KEYS ON "db_name" FROM "measurement_name"',
        type: "item"
    },
    {
        id: 'Show Tag Values',
        text: 'Show Tag Values',
        query: 'SHOW TAG VALUES ON "db_name" FROM "measurement_name" WITH KEY = "tag_key"',
        type: "item"
    },
    {
        id: `mqtd-divider-2`,
        type: "divider"
    },
    {
        id: 'Show Field Keys',
        text: 'Show Field Keys',
        query: 'SHOW FIELD KEYS ON "db_name"',
        type: "item"
    },
    {
        id: 'Show Field Key Cardinality',
        text: 'Show Field Key Cardinality',
        query: 'SHOW FIELD KEY CARDINALITY ON "db_name"',
        type: "item"
    },
    {
        id: 'Show Measurement Cardinality',
        text: 'Show Measurement Cardinality',
        query: 'SHOW MEASUREMENT CARDINALITY ON "db_name"',
        type: "item"
    },
    {
        id: 'Show Series Cardinality',
        text: 'Show Series Cardinality',
        query: 'SHOW SERIES CARDINALITY ON "db_name"',
        type: "item"
    },
    {
        id: 'Show Tag Key Cardinality',
        text: 'Show Tag Key Cardinality',
        query: 'SHOW TAG KEY CARDINALITY ON "db_name"',
        type: "item"
    },
    {
        id: 'Show Tag Values Cardinality',
        text: 'Show Tag Values Cardinality',
        query: 'SHOW TAG VALUES CARDINALITY ON "db_name" WITH KEY = "tag_key"',
        type: "item"
    },
    {
        id: `mqtd-divider-3`,
        type: "divider"
    },
    {
        id: 'Show Retention Policies',
        text: 'Show Retention Policies',
        query: 'SHOW RETENTION POLICIES on "db_name"',
        type: "item"
    },
    {
        id: 'Create Retention Policy',
        text: 'Create Retention Policy',
        query: 'CREATE RETENTION POLICY "rp_name" ON "db_name" DURATION 30d REPLICATION 1 DEFAULT',
        type: "item"
    },
    {
        id: 'Drop Retention Policy',
        text: 'Drop Retention Policy',
        query: 'DROP RETENTION POLICY "rp_name" ON "db_name"',
        type: "item"
    },
    {
        id: `mqtd-divider-4`,
        type: "divider"
    },
    {
        id: 'Show Continuous Queries',
        text: 'Show Continuous Queries',
        query: 'SHOW CONTINUOUS QUERIES',
        type: "item"
    },
    {
        id: 'Create Continuous Query',
        text: 'Create Continuous Query',
        query: 'CREATE CONTINUOUS QUERY "cq_name" ON "db_name" BEGIN SELECT min("field") INTO "target_measurement" FROM "current_measurement" GROUP BY time(30m) END',
        type: "item"
    },
    {
        id: 'Drop Continuous Query',
        text: 'Drop Continuous Query',
        query: 'DROP CONTINUOUS QUERY "cq_name" ON "db_name"',
        type: "item"
    },
    {
        id: `mqtd-divider-5`,
        type: "divider"
    },
    {
        id: 'Show Users',
        text: 'Show Users',
        query: 'SHOW USERS',
        type: "item"
    },
    {
        id: 'Show Grants',
        text: 'Show Grants',
        query: 'SHOW GRANTS FOR "username"',
        type: "item"
    },
    {
        id: 'Create User',
        text: 'Create User',
        query: 'CREATE USER "username" WITH PASSWORD \'password\'',
        type: "item"
    },
    {
        id: 'Create Admin User',
        text: 'Create Admin User',
        query: 'CREATE USER "username" WITH PASSWORD \'password\' WITH ALL PRIVILEGES',
        type: "item"
    },
    {
        id: 'Drop User',
        text: 'Drop User',
        query: 'DROP USER "username"',
        type: "item"
    },
    {
        id: `mqtd-divider-6`,
        type: "divider"
    },
    {
        id: 'Drop Measurement',
        text: 'Drop Measurement',
        query: 'USE "db_name"; DROP MEASUREMENT "measurement_name"',
        type: "item"
    },
    {
        id: 'Drop Series',
        text: 'Drop Series',
        query: 'USE "db_name"; DROP SERIES FROM "measurement_name" WHERE "tag" = \'value\'',
        type: "item"
    },
    {
        id: 'Delete',
        text: 'Delete',
        query: 'USE "db_name"; DELETE FROM "measurement_name" WHERE "tag" = \'value\' AND time < \'2020-01-01\'',
        type: "item"
    },
    {
        id: `mqtd-divider-7`,
        type: "divider"
    },
    {
        id: 'Explain',
        text: 'Explain',
        query: 'EXPLAIN SELECT * FROM "db_name"."rp_name"."measurement"',
        type: "item"
    },
    {
        id: 'Explain Analyze',
        text: 'Explain Analyze',
        query: 'EXPLAIN ANALYZE SELECT * FROM "db_name"."rp_name"."measurement"',
        type: "item"
    },
    {
        id: `mqtd-divider-8`,
        type: "divider"
    },
    {
        id: 'Show Stats',
        text: 'Show Stats',
        query: 'SHOW STATS',
        type: "item"
    },
    {
        id: 'Show Diagnostics',
        text: 'Show Diagnostics',
        query: 'SHOW DIAGNOSTICS',
        type: "item"
    },
    {
        id: 'Show Subscriptions',
        text: 'Show Subscriptions',
        query: 'SHOW SUBSCRIPTIONS',
        type: "item"
    },
    {
        id: 'Show Queries',
        text: 'Show Queries',
        query: 'SHOW QUERIES',
        type: "item"
    },
    {
        id: 'Show Shards',
        text: 'Show Shards',
        query: 'SHOW SHARDS',
        type: "item"
    },
    {
        id: 'Show Shard Groups',
        text: 'Show Shard Groups',
        query: 'SHOW SHARD GROUPS',
        type: "item"
    }
];
const $85c5ce2a0e85a1fb$export$4f8f1eeca08ae90 = 'https://docs.influxdata.com/influxdb/v1.8/write_protocols/line_protocol_tutorial/';
const $85c5ce2a0e85a1fb$export$350d83d6c59c55f7 = (0, $6a7b0ae94f8ec28f$export$9b55ef3c660cd071).find((tr)=>tr.lower === 'now() - 1h');





function $635753e8b5aca64b$export$2e2bcd8739ae039(key) {
    if (key && /[^A-Za-z0-9_]/.test(key)) return `r.[${(0, $20f55d6bf1566b03$export$2e2bcd8739ae039)(key)}]`;
    return `r.${key}`;
}



const $a65bd3e21b67b74a$var$LOCAL_STORAGE_DELAY_MS = 1000;
const $a65bd3e21b67b74a$var$DEFAULT_STATE = ()=>({
        script: '',
        draftScript: '',
        queryDrafts: [
            (0, $975a79a7c96f3d95$export$8d2e39f192e88e4)((0, $b4506126e09430df$export$7c8e26efb80b90e8).InfluxQL)
        ],
        timeRange: (0, $85c5ce2a0e85a1fb$export$350d83d6c59c55f7),
        type: (0, $b4506126e09430df$export$705e36171f4cbbfe).Line,
        queryType: (0, $b4506126e09430df$export$7c8e26efb80b90e8).InfluxQL,
        note: '',
        noteVisibility: (0, $b4506126e09430df$export$2c5a562a272706f8).Default,
        thresholdsListType: (0, $b4506126e09430df$export$fce0e0c1f55bb653).Text,
        thresholdsListColors: (0, $687ef8d4c4e21a50$export$3422d7c4ce2358c9),
        gaugeColors: (0, $687ef8d4c4e21a50$export$b9b550d6033567cd),
        lineColors: (0, $b00e3cd70e675d45$export$b940073a64112462),
        axes: (0, $727a6ab7dfc948a3$export$c0dadf556788a63f),
        tableOptions: (0, $9a9ec629fdd38845$export$88bc4ccd9afcdcbc),
        timeFormat: (0, $9a9ec629fdd38845$export$c4d2eaadfa3c28df),
        decimalPlaces: (0, $9a9ec629fdd38845$export$2684547e8daa20ef),
        fieldOptions: (0, $9a9ec629fdd38845$export$f734b87dadf30a98),
        fluxProportions: [
            0.2,
            0.6,
            0.2
        ],
        timeMachineProportions: [
            0.33,
            0.67
        ]
    });
class $a65bd3e21b67b74a$export$d13dd2a73cddd67e {
    setState(state) {
        this.state = {
            ...this.state,
            ...state
        };
    }
    constructor(){
        this.state = $a65bd3e21b67b74a$var$DEFAULT_STATE();
        this.debouncer = new (0, $075f3b99bb3716e4$export$2e2bcd8739ae039)();
        this.reset = (initialState = {})=>{
            this.localStorageKey = (0, $975a79a7c96f3d95$export$f22967b337b5cd11)();
            const localStorageState = (0, $975a79a7c96f3d95$export$d3720feff416e85b)(this.localStorageKey) || {};
            let state = {
                ...$a65bd3e21b67b74a$var$DEFAULT_STATE(),
                ...localStorageState,
                ...initialState
            };
            if ((0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(state, 'queryDrafts.length', 0) === 0) {
                const newEmptyQueryDraft = (0, $975a79a7c96f3d95$export$8d2e39f192e88e4)((0, $b4506126e09430df$export$7c8e26efb80b90e8).InfluxQL);
                const queryDrafts = [
                    newEmptyQueryDraft
                ];
                state = {
                    ...state,
                    queryDrafts: queryDrafts
                };
            }
            // prevents DDL and DML statements from being persisted.
            const savable = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(state, 'queryDrafts', []).filter(({ query: query, type: type })=>{
                if (type !== 'influxql') return true;
                if (!query) return true;
                const queries = query.split(';');
                let isSavable = true;
                for(let i = 0; i <= queries.length; i++){
                    const qs = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(queries, `${i}`, '');
                    if ((0, $d6713fc94c521d4a$export$63fabf44ec222040)(qs)) isSavable = false;
                }
                return isSavable;
            });
            state = {
                ...state,
                queryDrafts: savable
            };
            return this.setAndPersistState(state);
        };
        this.handleUpdateQueryType = (queryType)=>{
            return this.setAndPersistState({
                queryType: queryType
            });
        };
        this.handleChangeScript = (script)=>{
            return this.setAndPersistState({
                script: script
            });
        };
        this.handleUpdateDraftScript = (draftScript)=>{
            return this.setAndPersistState({
                draftScript: draftScript
            });
        };
        this.handleAddFilter = (db, filter)=>{
            let { draftScript: draftScript } = this.state;
            const body = Object.entries(filter).map(([key, value])=>{
                return `${(0, $635753e8b5aca64b$export$2e2bcd8739ae039)(key)} == "${value}"`;
            }).join(' and ');
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEmpty(draftScript)) draftScript = `from(bucket: "${db}")\n  |> range(start: ${0, $31b9ad045b09659f$export$8ba01d856b30a62e})`;
            const newDraftScript = `${draftScript}\n  |> filter(fn: (r) => ${body})`;
            return this.setAndPersistState({
                draftScript: newDraftScript
            });
        };
        this.handleInitFluxScript = (script)=>{
            this.setAndPersistState({
                script: script,
                draftScript: script
            });
        };
        this.handleUpdateTimeRange = (timeRange)=>{
            return this.setAndPersistState({
                timeRange: timeRange
            });
        };
        this.handleUpdateQueryDrafts = (queryDrafts)=>{
            return this.setAndPersistState({
                queryDrafts: queryDrafts
            });
        };
        this.handleSetFluxProportions = (fluxProportions)=>{
            return this.setAndPersistState({
                fluxProportions: fluxProportions
            });
        };
        this.handleSetTimeMachineProportions = (timeMachineProportions)=>{
            return this.setAndPersistState({
                timeMachineProportions: timeMachineProportions
            });
        };
        this.handleToggleField = (queryID, fieldFunc)=>{
            return this.updateQueryDrafts(queryID, (q)=>({
                    ...(0, $87900d7d58ddb432$export$7c7a7daa922e15cc)(q, fieldFunc),
                    rawText: null
                }));
        };
        this.handleGroupByTime = (queryID, time)=>{
            return this.updateQueryDrafts(queryID, (q)=>(0, $87900d7d58ddb432$export$17dbdfc260d411c0)(q, time));
        };
        this.handleFill = (queryID, value)=>{
            return this.updateQueryDrafts(queryID, (q)=>(0, $87900d7d58ddb432$export$9563e054e6f787fb)(q, value));
        };
        this.handleRemoveFuncs = (queryID, fields)=>{
            return this.updateQueryDrafts(queryID, (q)=>(0, $87900d7d58ddb432$export$6c7ecc4b49686af)(q, fields));
        };
        this.handleApplyFuncsToField = (queryID, fieldFunc, groupBy)=>{
            return this.updateQueryDrafts(queryID, (q)=>(0, $87900d7d58ddb432$export$62c64e38b267511f)(q, fieldFunc, groupBy));
        };
        this.handleChooseTag = (queryID, tag)=>{
            return this.updateQueryDrafts(queryID, (q)=>(0, $87900d7d58ddb432$export$4480d0807bd82ec1)(q, tag));
        };
        this.handleChooseNamespace = (queryID, options)=>{
            return this.updateQueryDrafts(queryID, (q)=>(0, $87900d7d58ddb432$export$701baf921074a53d)(q, options));
        };
        this.handleChooseMeasurement = (queryID, measurement)=>{
            return this.updateQueryDrafts(queryID, (q)=>({
                    ...(0, $87900d7d58ddb432$export$3d55885fc623730f)(q, measurement),
                    rawText: q.rawText || ''
                }));
        };
        this.handleGroupByTag = (queryID, tagKey)=>{
            return this.updateQueryDrafts(queryID, (q)=>(0, $87900d7d58ddb432$export$ca2e14d4de2d2b70)(q, tagKey));
        };
        this.handleToggleTagAcceptance = (queryID)=>{
            return this.updateQueryDrafts(queryID, (q)=>(0, $87900d7d58ddb432$export$ba46ef16c986791)(q));
        };
        this.handleAddInitialField = (queryID, field, groupBy)=>{
            return this.updateQueryDrafts(queryID, (q)=>(0, $87900d7d58ddb432$export$69b3838738298b5d)(q, field, groupBy));
        };
        this.handleEditQueryStatus = (queryID, status)=>{
            return this.updateQueryDrafts(queryID, (q)=>({
                    ...q,
                    status: status
                }));
        };
        this.handleTimeShift = (queryID, shift)=>{
            return this.updateQueryDrafts(queryID, (q)=>(0, $87900d7d58ddb432$export$2cfa160b16d04366)(q, shift));
        };
        this.handleAddQuery = ()=>{
            const { queryDrafts: queryDrafts } = this.state;
            const newQueryDraft = (0, $975a79a7c96f3d95$export$8d2e39f192e88e4)((0, $b4506126e09430df$export$7c8e26efb80b90e8).InfluxQL);
            return this.setAndPersistState({
                queryDrafts: [
                    ...queryDrafts,
                    newQueryDraft
                ]
            });
        };
        this.handleDeleteQuery = (queryID)=>{
            const { queryDrafts: queryDrafts } = this.state;
            const updatedQueryDrafts = queryDrafts.filter((query)=>query.id !== queryID);
            return this.setAndPersistState({
                queryDrafts: updatedQueryDrafts
            });
        };
        this.handleUpdateType = (type)=>{
            return this.setAndPersistState({
                type: type
            });
        };
        this.handleUpdateNote = (note)=>{
            return this.setAndPersistState({
                note: note
            });
        };
        this.handleUpdateNoteVisibility = (noteVisibility)=>{
            return this.setAndPersistState({
                noteVisibility: noteVisibility
            });
        };
        this.handleUpdateThresholdsListColors = (thresholdsListColors)=>{
            return this.setAndPersistState({
                thresholdsListColors: thresholdsListColors
            });
        };
        this.handleUpdateThresholdsListType = (thresholdsListType)=>{
            const thresholdsListColors = this.state.thresholdsListColors.map((color)=>({
                    ...color,
                    type: thresholdsListType
                }));
            return this.setAndPersistState({
                thresholdsListType: thresholdsListType,
                thresholdsListColors: thresholdsListColors
            });
        };
        this.handleUpdateGaugeColors = (gaugeColors)=>{
            return this.setAndPersistState({
                gaugeColors: gaugeColors
            });
        };
        this.handleUpdateAxes = (axes)=>{
            return this.setAndPersistState({
                axes: axes
            });
        };
        this.handleUpdateTableOptions = (tableOptions)=>{
            return this.setAndPersistState({
                tableOptions: tableOptions
            });
        };
        this.handleUpdateLineColors = (lineColors)=>{
            return this.setAndPersistState({
                lineColors: lineColors
            });
        };
        this.handleUpdateTimeFormat = (timeFormat)=>{
            return this.setAndPersistState({
                timeFormat: timeFormat
            });
        };
        this.handleUpdateDecimalPlaces = (decimalPlaces)=>{
            return this.setAndPersistState({
                decimalPlaces: decimalPlaces
            });
        };
        this.handleUpdateFieldOptions = (fieldOptions)=>{
            return this.setAndPersistState({
                fieldOptions: fieldOptions
            });
        };
        this.updateQueryDrafts = (queryID, nextQueryConfigFn)=>{
            const { queryDrafts: queryDrafts } = this.state;
            const updatedQueryDrafts = queryDrafts.map((query)=>{
                if (query.id === queryID) {
                    const nextQueryConfig = nextQueryConfigFn(query.queryConfig);
                    const queryText = (0, $7b2c5b24a44a7fa2$export$d7b58f10109feb02)((0, $9a9ec629fdd38845$export$797ae35c568d4e70), (0, $0ece195804443aff$export$fe73f2cc6771a40f)(nextQueryConfig), nextQueryConfig);
                    return {
                        ...query,
                        query: queryText,
                        text: queryText,
                        queryConfig: {
                            ...nextQueryConfig,
                            rawText: queryText
                        }
                    };
                }
                return query;
            });
            return this.setAndPersistState({
                queryDrafts: updatedQueryDrafts
            });
        };
        this.setAndPersistState = (state)=>{
            if (this.localStorageKey) this.debouncer.call(this.setLocalStorageState, $a65bd3e21b67b74a$var$LOCAL_STORAGE_DELAY_MS);
            this.setState(state);
            return Promise.resolve();
        };
        this.setLocalStorageState = ()=>{
            (0, $975a79a7c96f3d95$export$1f73f60bdb811cb1)(this.localStorageKey, this.state);
        };
    }
}


const $b029b3af5fc2e5d5$var$TimeMachineContext = /*#__PURE__*/ (0, $NdCUR.createContext)(undefined);
const $b029b3af5fc2e5d5$var$container = new (0, $a65bd3e21b67b74a$export$d13dd2a73cddd67e)();
const $b029b3af5fc2e5d5$export$7d87f8b720f7653e = ({ children: children })=>{
    const value = (0, $NdCUR.useContext)($b029b3af5fc2e5d5$var$TimeMachineContext);
    if (value === undefined) throw new Error('Component must be wrapped with <TimeMachineContextProvider>');
    return children($b029b3af5fc2e5d5$var$container);
};
// optimization only
let $b029b3af5fc2e5d5$var$lastSetState;
const $b029b3af5fc2e5d5$export$f622d6318304b0fa = ({ children: children })=>{
    const [state, setState] = (0, $NdCUR.useState)($b029b3af5fc2e5d5$var$container.state);
    $b029b3af5fc2e5d5$var$container.state = state;
    if (setState !== $b029b3af5fc2e5d5$var$lastSetState) {
        // setState is stable in React, so this should be executed at most once
        $b029b3af5fc2e5d5$var$container.setState = function(s) {
            setState((previous)=>({
                    ...previous,
                    ...s
                }));
        };
        $b029b3af5fc2e5d5$var$lastSetState = setState;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($b029b3af5fc2e5d5$var$TimeMachineContext.Provider, {
        value: state
    }, children);
};



var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");


var $NdCUR = parcelRequire("NdCUR");

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");

class $5d85df1480865aa0$var$WriteDataFooter extends (0, $NdCUR.PureComponent) {
    render() {
        const { handleSubmit: handleSubmit } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "write-data-form--footer"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "write-data-form--helper"
        }, "Need help writing InfluxDB Line Protocol? -\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("a", {
            href: (0, $85c5ce2a0e85a1fb$export$4f8f1eeca08ae90),
            target: "_blank"
        }, "See Documentation")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: this.buttonClass,
            onClick: handleSubmit,
            disabled: this.buttonDisabled,
            "data-test": "write-data-submit-button"
        }, "Write"));
    }
    get buttonDisabled() {
        const { inputContent: inputContent } = this.props;
        if (inputContent) return false;
        return true;
    }
    get buttonClass() {
        const { isUploading: isUploading } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('btn btn-sm btn-success write-data-form--submit', {
            'btn-spinner': isUploading
        });
    }
}
var $5d85df1480865aa0$export$2e2bcd8739ae039 = $5d85df1480865aa0$var$WriteDataFooter;



class $3a0ccc8151427d75$var$WriteDataBody extends (0, $NdCUR.PureComponent) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "write-data-form--body"
        }, this.input, this.footer);
    }
    get input() {
        const { mode: mode } = this.props;
        if (mode === (0, $997a2bc484aadf39$export$209f3caa268488b1).File) return this.dragArea;
        return this.textarea;
    }
    get textarea() {
        const { handleKeyUp: handleKeyUp, handleEdit: handleEdit } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("textarea", {
            spellCheck: false,
            autoFocus: true,
            autoComplete: "off",
            onKeyUp: handleKeyUp,
            onChange: handleEdit,
            "data-test": "manual-entry-field",
            className: "form-control write-data-form--input",
            placeholder: "<measurement>,<tag_key>=<tag_value> <field_key>=<field_value>"
        });
    }
    get dragArea() {
        const { fileInput: fileInput, handleFileOpen: handleFileOpen } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.dragAreaClass,
            onClick: handleFileOpen
        }, this.dragAreaHeader, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.infoClass
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            type: "file",
            ref: fileInput,
            className: "write-data-form--upload",
            accept: "text/*, application/gzip",
            onChange: this.handleFile
        }), this.buttons);
    }
    get dragAreaHeader() {
        const { uploadContent: uploadContent, fileName: fileName } = this.props;
        if (uploadContent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h3", {
            className: "write-data-form--filepath_selected"
        }, fileName);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h3", {
            className: "write-data-form--filepath_empty"
        }, "Drop a file here or click to upload");
    }
    get infoClass() {
        const { uploadContent: uploadContent } = this.props;
        if (uploadContent) return 'write-data-form--graphic write-data-form--graphic_success';
        return 'write-data-form--graphic';
    }
    get buttons() {
        const { uploadContent: uploadContent, handleSubmit: handleSubmit, handleCancelFile: handleCancelFile } = this.props;
        if (!uploadContent) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "write-data-form--file-submit"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-md btn-success",
            onClick: handleSubmit
        }, "Write this File"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-md btn-default",
            onClick: handleCancelFile
        }, "Cancel"));
    }
    get dragAreaClass() {
        const { uploadContent: uploadContent } = this.props;
        if (uploadContent) return 'write-data-form--file';
        return 'write-data-form--file write-data-form--file_active';
    }
    get footer() {
        const { isUploading: isUploading, inputContent: inputContent, handleSubmit: handleSubmit, mode: mode } = this.props;
        if (mode === (0, $997a2bc484aadf39$export$209f3caa268488b1).File) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $5d85df1480865aa0$export$2e2bcd8739ae039), {
            isUploading: isUploading,
            inputContent: inputContent,
            handleSubmit: handleSubmit
        });
    }
    constructor(...args){
        super(...args), this.handleFile = (e)=>{
            this.props.handleFile(false)(e);
        };
    }
}
var $3a0ccc8151427d75$export$2e2bcd8739ae039 = $3a0ccc8151427d75$var$WriteDataBody;



var $NdCUR = parcelRequire("NdCUR");

var $NdCUR = parcelRequire("NdCUR");

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");


var $NdCUR = parcelRequire("NdCUR");


var $1v7mg = parcelRequire("1v7mg");



var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");

var $1v7mg = parcelRequire("1v7mg");
const $df937c4b75769882$var$DropdownMenuItem = ({ item: item, highlightedItemIndex: highlightedItemIndex, onSelection: onSelection, onHighlight: onHighlight, actions: actions, onAction: onAction, selected: selected, index: index })=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isString(item)) item = {
        text: item
    };
    if (item.text === 'SEPARATOR') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("li", {
        className: "dropdown-divider"
    });
    const onClick = (0, $NdCUR.useCallback)((e)=>{
        e.preventDefault();
        onSelection(item)(e);
    }, [
        item
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("li", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('dropdown-item', {
            highlight: index === highlightedItemIndex,
            active: item.text === selected
        }),
        "data-test": `${item.text}-dropdown-item`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("a", {
        href: "#",
        onClick: onClick,
        onMouseOver: onHighlight(index)
    }, item.text), actions && !!actions.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "dropdown-actions"
    }, actions.map((action)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            key: action.text,
            className: "dropdown-action",
            onClick: onAction(action, item)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            title: action.text,
            className: `icon ${action.icon}`
        }));
    })));
};
var $df937c4b75769882$export$2e2bcd8739ae039 = $df937c4b75769882$var$DropdownMenuItem;




const $53fa614fe011b7d9$var$AddNewButton = ({ url: url, text: text, handler: handler, stopPropagation: stopPropagation })=>{
    if (handler) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("li", {
        className: "multi-select--apply"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
        text: text,
        onClick: (e)=>{
            if (stopPropagation) e.stopPropagation();
            handler();
        },
        color: (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Default,
        size: (0, $918c9f03a35fe03f$export$fafce5c139da9687).ExtraSmall,
        shape: (0, $918c9f03a35fe03f$export$ce765fb8bb08a599).StretchToFit,
        icon: (0, $918c9f03a35fe03f$export$62c9c0cf752cde38).Plus
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("li", {
        className: "multi-select--apply"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ba1cc4424c00aefe$export$2e2bcd8739ae039), {
        className: "btn btn-xs btn-default",
        to: url
    }, text));
};
const $53fa614fe011b7d9$var$DropdownMenu = ({ items: items, addNew: addNew, actions: actions, selected: selected, onAction: onAction, menuClass: menuClass, menuWidth: menuWidth, menuLabel: menuLabel, onSelection: onSelection, onHighlight: onHighlight, useAutoComplete: useAutoComplete, highlightedItemIndex: highlightedItemIndex })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("ul", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('dropdown-menu', {
            'dropdown-menu--no-highlight': useAutoComplete,
            [menuClass]: menuClass
        }),
        style: {
            width: menuWidth
        },
        "data-test": "dropdown-ul"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), {
        autoHide: false,
        autoHeight: true,
        maxHeight: (0, $e10a8602f56394e3$export$bd1588cc2d72fbf)
    }, menuLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("li", {
        className: "dropdown-header",
        key: "header"
    }, menuLabel) : null, items.map((item, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $df937c4b75769882$export$2e2bcd8739ae039), {
            item: item,
            actions: actions,
            onAction: onAction,
            highlightedItemIndex: highlightedItemIndex,
            onHighlight: onHighlight,
            selected: selected,
            onSelection: onSelection,
            index: i,
            key: i
        })), addNew && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($53fa614fe011b7d9$var$AddNewButton, {
        url: addNew.url,
        text: addNew.text,
        handler: addNew.handler,
        stopPropagation: addNew.stopPropagation
    })));
};
const $53fa614fe011b7d9$export$da7287102a80edf6 = ({ useAutoComplete: useAutoComplete, menuClass: menuClass })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("ul", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('dropdown-menu', {
            'dropdown-menu--no-highlight': useAutoComplete,
            [menuClass]: menuClass
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("li", {
        className: "dropdown-empty"
    }, "No matching items"));
var $53fa614fe011b7d9$export$2e2bcd8739ae039 = $53fa614fe011b7d9$var$DropdownMenu;



var $NdCUR = parcelRequire("NdCUR");
const $1a3a3ccede5f85ba$var$disabledClass = (disabled)=>disabled ? ' disabled' : '';
const $1a3a3ccede5f85ba$var$selectAllTextInInput = (event)=>{
    event.target.select();
};
const $1a3a3ccede5f85ba$var$DropdownInput = ({ searchTerm: searchTerm, buttonSize: buttonSize, buttonColor: buttonColor, selectedValue: selectedValue = '', toggleStyle: toggleStyle, disabled: disabled, onFilterChange: onFilterChange, onFilterKeyPress: onFilterKeyPress, placeholder: placeholder = 'Filter items...' })=>{
    // show actually selected value only if search term is empty
    const renderSelected = (0, $NdCUR.useRef)(!searchTerm);
    const value = (0, $NdCUR.useMemo)(()=>{
        if (searchTerm) return searchTerm;
        return renderSelected.current ? selectedValue : '';
    }, [
        searchTerm,
        renderSelected.current
    ]);
    const onChange = (0, $NdCUR.useCallback)((e)=>{
        renderSelected.current = false;
        onFilterChange(e);
    }, [
        onFilterChange
    ]);
    const onKeyPress = (0, $NdCUR.useCallback)((e)=>{
        renderSelected.current = false;
        onFilterKeyPress(e);
    }, [
        onFilterKeyPress
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: `dropdown-autocomplete dropdown-toggle ${buttonSize} ${buttonColor}${$1a3a3ccede5f85ba$var$disabledClass(disabled)}`,
        style: toggleStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
        className: "dropdown-autocomplete--input",
        type: "text",
        autoFocus: true,
        placeholder: placeholder,
        spellCheck: false,
        onChange: onChange,
        onKeyDown: onKeyPress,
        onFocus: $1a3a3ccede5f85ba$var$selectAllTextInInput,
        value: value
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        className: "caret"
    }));
};
var $1a3a3ccede5f85ba$export$2e2bcd8739ae039 = $1a3a3ccede5f85ba$var$DropdownInput;



var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");
const $8071b456283d6d39$var$disabledClass = (disabled)=>disabled ? ' disabled' : '';
const $8071b456283d6d39$var$DropdownHead = ({ iconName: iconName, selected: selected, buttonSize: buttonSize, toggleStyle: toggleStyle, buttonColor: buttonColor, disabled: disabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: `btn dropdown-toggle ${buttonSize} ${buttonColor}${$8071b456283d6d39$var$disabledClass(disabled)}`,
        style: toggleStyle
    }, iconName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('icon', {
            [iconName]: true
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        className: "dropdown-selected",
        "data-test": `dropdown-selected--${selected}`
    }, selected), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        className: "caret"
    }));
var $8071b456283d6d39$export$2e2bcd8739ae039 = $8071b456283d6d39$var$DropdownHead;



class $ca4f14339173643c$var$Dropdown extends (0, $NdCUR.Component) {
    static{
        this.defaultProps = {
            actions: [],
            buttonSize: 'btn-sm',
            buttonColor: 'btn-default',
            menuWidth: '100%',
            useAutoComplete: false,
            disabled: false,
            tabIndex: 0
        };
    }
    constructor(props){
        super(props), this.handleClickOutside = ()=>{
            this.setState({
                isOpen: false
            });
        }, this.handleSelection = (item)=>()=>{
                this.toggleMenu();
                this.props.onChoose(item);
                this.dropdownRef.focus();
            }, this.handleHighlight = (itemIndex)=>()=>{
                // setup highlighted element only in auto-complete mode,
                // otherwise rely upon CSS :hover highlighting
                if (this.props.useAutoComplete) this.setState({
                    highlightedItemIndex: itemIndex
                });
            }, this.toggleMenu = (e)=>{
            if (e) e.stopPropagation();
            if (!this.state.isOpen) this.setState({
                searchTerm: '',
                filteredItems: this.props.items,
                highlightedItemIndex: null
            });
            this.setState({
                isOpen: !this.state.isOpen
            });
        }, this.handleAction = (action, item)=>(e)=>{
                e.stopPropagation();
                action.handler(item);
            }, this.handleFilterKeyPress = (e)=>{
            const { filteredItems: filteredItems, highlightedItemIndex: highlightedItemIndex } = this.state;
            if (e.key === 'Enter' && filteredItems.length) {
                this.setState({
                    isOpen: false
                });
                this.props.onChoose(filteredItems[highlightedItemIndex]);
            }
            if (e.key === 'Escape') this.setState({
                isOpen: false
            });
            if (e.key === 'ArrowUp' && highlightedItemIndex > 0) this.setState({
                highlightedItemIndex: highlightedItemIndex - 1
            });
            if (e.key === 'ArrowDown') {
                if (highlightedItemIndex < filteredItems.length - 1) this.setState({
                    highlightedItemIndex: highlightedItemIndex + 1
                });
                if (highlightedItemIndex === null && filteredItems.length) this.setState({
                    highlightedItemIndex: 0
                });
            }
        }, this.handleFilterChange = (e)=>{
            if (e.target.value) return this.setState({
                searchTerm: e.target.value
            }, ()=>this.applyFilter(this.state.searchTerm));
            this.setState({
                searchTerm: '',
                filteredItems: this.props.items,
                highlightedItemIndex: null
            });
        }, this.applyFilter = (searchTerm)=>{
            const { items: items } = this.props;
            const filterText = searchTerm.toLowerCase();
            const matchingItems = items.filter((item)=>{
                if (!item) return false;
                return item.text.toLowerCase().includes(filterText);
            });
            this.setState({
                filteredItems: matchingItems,
                highlightedItemIndex: 0
            });
        }, this.setDropdownRef = (ref)=>{
            this.dropdownRef = ref;
        }, this.handleClick = (e)=>{
            const { disabled: disabled, onClick: onClick } = this.props;
            if (disabled) return;
            this.toggleMenu(e);
            if (onClick) onClick(e);
        };
        this.state = {
            isOpen: false,
            searchTerm: '',
            filteredItems: this.props.items,
            highlightedItemIndex: null
        };
    }
    render() {
        const { items: items, addNew: addNew, actions: actions, selected: selected, disabled: disabled, iconName: iconName, tabIndex: tabIndex, className: className, menuClass: menuClass, menuWidth: menuWidth, menuLabel: menuLabel, buttonSize: buttonSize, buttonColor: buttonColor, toggleStyle: toggleStyle, useAutoComplete: useAutoComplete } = this.props;
        const { isOpen: isOpen, searchTerm: searchTerm, filteredItems: filteredItems, highlightedItemIndex: highlightedItemIndex } = this.state;
        const menuItems = useAutoComplete ? filteredItems : items;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            onClick: this.handleClick,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('dropdown', {
                open: isOpen,
                [className]: className
            }),
            tabIndex: tabIndex,
            ref: this.setDropdownRef,
            "data-test": "dropdown-toggle"
        }, useAutoComplete && isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1a3a3ccede5f85ba$export$2e2bcd8739ae039), {
            searchTerm: searchTerm,
            buttonSize: buttonSize,
            buttonColor: buttonColor,
            selectedValue: selected,
            toggleStyle: toggleStyle,
            disabled: disabled,
            onFilterChange: this.handleFilterChange,
            onFilterKeyPress: this.handleFilterKeyPress
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $8071b456283d6d39$export$2e2bcd8739ae039), {
            iconName: iconName,
            selected: selected,
            buttonSize: buttonSize,
            buttonColor: buttonColor,
            toggleStyle: toggleStyle,
            disabled: disabled
        }), isOpen && menuItems.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $53fa614fe011b7d9$export$2e2bcd8739ae039), {
            addNew: addNew,
            actions: actions,
            items: menuItems,
            selected: selected,
            menuClass: menuClass,
            menuWidth: menuWidth,
            menuLabel: menuLabel,
            onAction: this.handleAction,
            useAutoComplete: useAutoComplete,
            onSelection: this.handleSelection,
            onHighlight: this.handleHighlight,
            highlightedItemIndex: highlightedItemIndex
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $53fa614fe011b7d9$export$da7287102a80edf6), {
            useAutoComplete: useAutoComplete,
            menuClass: menuClass
        }));
    }
}
const $ca4f14339173643c$export$931cbfb6bfb85fc = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($ca4f14339173643c$var$Dropdown);
var $ca4f14339173643c$export$2e2bcd8739ae039 = (0, $1636633b789d0ee3$export$2e2bcd8739ae039)($ca4f14339173643c$export$931cbfb6bfb85fc);






var $NdCUR = parcelRequire("NdCUR");

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");
// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");

// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");



var $hBdgJ = parcelRequire("hBdgJ");

const $a172f65827ac51a7$var$parseValuesColumn = (resp)=>{
    const results = (0, $c6606ad17445cd52$export$ba14d9a5a581e827)(resp);
    if (results.length === 0) return [];
    const tags = results.reduce((acc, result)=>{
        const colIndex = result.data[0].findIndex((header)=>header === '_value');
        if (colIndex === -1) return [
            ...acc
        ];
        const resultTags = result.data.slice(1).map((row)=>row[colIndex]);
        return [
            ...acc,
            ...resultTags
        ];
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).sortBy(tags, (t)=>t.toLocaleLowerCase());
};
const $a172f65827ac51a7$export$ff5efc8b9360afc1 = (resp)=>{
    const results = (0, $c6606ad17445cd52$export$ba14d9a5a581e827)(resp);
    if (results.length === 0) return {
        fields: [],
        fieldsByMeasurements: {}
    };
    return results.reduce((acc, result)=>{
        const fieldIndex = result.data[0].findIndex((header)=>header === '_field');
        const measurementIndex = result.data[0].findIndex((header)=>header === '_measurement');
        if (fieldIndex === -1) return acc;
        const data = result.data.slice(1);
        data.forEach((row)=>{
            const field = row[fieldIndex];
            if (!acc.fields.includes(field)) acc.fields.push(field);
            if (measurementIndex !== -1) {
                const measurement = row[measurementIndex];
                const existingMeasurementFields = acc.fieldsByMeasurements[measurement];
                if (existingMeasurementFields) acc.fieldsByMeasurements[measurement] = [
                    ...existingMeasurementFields,
                    field
                ];
                else acc.fieldsByMeasurements[measurement] = [
                    field
                ];
            }
        });
        return acc;
    }, {
        fields: [],
        fieldsByMeasurements: {}
    });
};
var $a172f65827ac51a7$export$2e2bcd8739ae039 = $a172f65827ac51a7$var$parseValuesColumn;



const $60998f94e3811eb1$export$26da6653a562009 = async (source, timeRange, bucket)=>{
    return $60998f94e3811eb1$export$b6b561cd67098bda({
        bucket: bucket,
        source: source,
        tagKey: '_measurement',
        limit: 0,
        timeRange: timeRange
    });
};
const $60998f94e3811eb1$export$d1f03315a1ae1d59 = async (source, timeRange, bucket)=>{
    const script = `
  from(bucket:${(0, $20f55d6bf1566b03$export$2e2bcd8739ae039)(bucket)})
    |> range(${(0, $a9c01ddfa0a1c3ae$export$2e2bcd8739ae039)(timeRange)})
    |> group(columns: ["_field", "_measurement"], mode: "by")
    |> distinct(column: "_field")
    |> group()
    |> map(fn: (r) => ({_measurement: r._measurement, _field: r._field}))
  `;
    const response = await $60998f94e3811eb1$export$923f96dd5afa9ce6(source, script);
    return (0, $a172f65827ac51a7$export$ff5efc8b9360afc1)(response);
};
const $60998f94e3811eb1$export$8a3da65e62ec881c = async (source, timeRange, bucket)=>{
    const script = `
from(bucket:${(0, $20f55d6bf1566b03$export$2e2bcd8739ae039)(bucket)}) 
  |> range(${(0, $a9c01ddfa0a1c3ae$export$2e2bcd8739ae039)(timeRange)}) 
  |> keys()
  |> keep(columns: ["_value"])
  |> distinct()`;
    const response = await $60998f94e3811eb1$export$923f96dd5afa9ce6(source, script);
    return (0, $a172f65827ac51a7$export$2e2bcd8739ae039)(response);
};
const $60998f94e3811eb1$export$b6b561cd67098bda = async ({ bucket: bucket, source: source, tagKey: tagKey, timeRange: timeRange, limit: limit, searchTerm: searchTerm = '', count: count = false })=>{
    let regexFilter = '';
    if (searchTerm) regexFilter = `\n  |> filter(fn: (r) => r["_value"] =~ /${searchTerm}/)`;
    const limitFunc = count || !limit ? '' : `\n  |> limit(n:${limit})`;
    const countFunc = count ? '\n  |> count()' : '';
    const script = `
from(bucket:${(0, $20f55d6bf1566b03$export$2e2bcd8739ae039)(bucket)})
  |> range(${(0, $a9c01ddfa0a1c3ae$export$2e2bcd8739ae039)(timeRange)})
  |> keep(columns: [${(0, $20f55d6bf1566b03$export$2e2bcd8739ae039)(tagKey)}])
  |> group()
  |> distinct(column: ${(0, $20f55d6bf1566b03$export$2e2bcd8739ae039)(tagKey)})${regexFilter}${limitFunc}${countFunc}
  `;
    const csvResponse = await $60998f94e3811eb1$export$923f96dd5afa9ce6(source, script);
    return (0, $a172f65827ac51a7$export$2e2bcd8739ae039)(csvResponse);
};
const $60998f94e3811eb1$export$923f96dd5afa9ce6 = async (source, script)=>{
    const mark = encodeURIComponent('?');
    const minimizedScript = script.replace(/\s/g, '') // server cannot handle whitespace
    ;
    const dialect = {
        annotations: [
            'group',
            'datatype',
            'default'
        ]
    };
    const data = {
        query: minimizedScript,
        dialect: dialect
    };
    const base = source.links.flux;
    try {
        const response = await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'POST',
            url: `${base}?version=${source.version}&path=/api/v2/query${mark}organization=defaultorgname`,
            data: data,
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.data.toString();
    } catch (error) {
        $60998f94e3811eb1$var$handleError(error);
    }
};
const $60998f94e3811eb1$var$handleError = (error)=>{
    console.error('Problem fetching data', error);
    throw (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(error, 'headers.x-influx-error', false) || (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(error, 'data.message', "unknown error \uD83E\uDD37");
};



class $dd29dd224a5df6c7$var$FetchMeasurements extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props);
        this.state = {
            measurements: [],
            loading: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).NotStarted
        };
    }
    componentDidMount() {
        this.fetchData();
    }
    render() {
        return this.props.children(this.state.measurements, this.state.loading);
    }
    async fetchData() {
        const { source: source, timeRange: timeRange, bucket: bucket } = this.props;
        this.setState({
            loading: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading
        });
        try {
            const measurements = await (0, $60998f94e3811eb1$export$26da6653a562009)(source, timeRange, bucket);
            this.setState({
                measurements: measurements,
                loading: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done
            });
        } catch (error) {
            this.setState({
                loading: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error
            });
        }
    }
}
var $dd29dd224a5df6c7$export$2e2bcd8739ae039 = $dd29dd224a5df6c7$var$FetchMeasurements;


// Libraries

var $NdCUR = parcelRequire("NdCUR");


class $2691424a37e5cbb9$var$FetchTagKeys extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props);
        this.state = {
            tagKeys: [],
            loading: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).NotStarted
        };
    }
    componentDidMount() {
        this.fetchData();
    }
    render() {
        return this.props.children(this.state.tagKeys, this.state.loading);
    }
    async fetchData() {
        const { source: source, timeRange: timeRange, bucket: bucket } = this.props;
        this.setState({
            loading: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading
        });
        try {
            const tagKeys = await (0, $60998f94e3811eb1$export$8a3da65e62ec881c)(source, timeRange, bucket);
            this.setState({
                tagKeys: tagKeys,
                loading: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done
            });
        } catch (error) {
            this.setState({
                loading: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error
            });
        }
    }
}
var $2691424a37e5cbb9$export$2e2bcd8739ae039 = $2691424a37e5cbb9$var$FetchTagKeys;


// Libraries

var $NdCUR = parcelRequire("NdCUR");


class $1ce3914649e4b851$var$FetchFields extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props);
        this.state = {
            fields: [],
            fieldsByMeasurements: {},
            loading: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).NotStarted
        };
    }
    componentDidMount() {
        this.fetchFields();
    }
    render() {
        return this.props.children(this.state.fields, this.state.fieldsByMeasurements, this.state.loading);
    }
    async fetchFields() {
        const { source: source, timeRange: timeRange, bucket: bucket } = this.props;
        this.setState({
            loading: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading
        });
        try {
            const { fields: fields, fieldsByMeasurements: fieldsByMeasurements } = await (0, $60998f94e3811eb1$export$d1f03315a1ae1d59)(source, timeRange, bucket);
            this.setState({
                fields: fields,
                fieldsByMeasurements: fieldsByMeasurements,
                loading: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done
            });
        } catch (error) {
            this.setState({
                loading: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error
            });
        }
    }
}
var $1ce3914649e4b851$export$2e2bcd8739ae039 = $1ce3914649e4b851$var$FetchFields;


class $bd34937b631ab295$var$SchemaExplorerTree extends (0, $NdCUR.PureComponent) {
    render() {
        const { source: source, timeRange: timeRange, bucket: bucket } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dd29dd224a5df6c7$export$2e2bcd8739ae039), {
            source: source,
            timeRange: timeRange,
            bucket: bucket
        }, (measurements, measurementsLoading)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $2691424a37e5cbb9$export$2e2bcd8739ae039), {
                source: source,
                timeRange: timeRange,
                bucket: bucket
            }, (tagKeys, tagsLoading)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1ce3914649e4b851$export$2e2bcd8739ae039), {
                    source: source,
                    timeRange: timeRange,
                    bucket: bucket
                }, (fields, fieldsByMeasurements, fieldsLoading)=>this.props.children(this.tree(measurements, tagKeys, fields, fieldsByMeasurements, measurementsLoading, tagsLoading, fieldsLoading)))));
    }
    tree(measurements, tagKeys, fields, fieldsByMeasurements, measurementsLoading, tagsLoading, fieldsLoading) {
        return {
            measurements: this.measurementsTree(measurements, fieldsByMeasurements),
            fields: fields,
            tagKeys: tagKeys,
            measurementsLoading: measurementsLoading,
            tagsLoading: tagsLoading,
            fieldsLoading: fieldsLoading
        };
    }
    measurementsTree(measurements, fieldsByMeasurements) {
        const measurementsWithNoFields = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).difference(measurements, Object.keys(fieldsByMeasurements));
        return measurementsWithNoFields.reduce((acc, m)=>{
            acc[m] = [];
            return acc;
        }, fieldsByMeasurements);
    }
}
var $bd34937b631ab295$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($bd34937b631ab295$var$SchemaExplorerTree);


const $604643028e2b69bf$export$ca8e1abb1d21cde4 = 10;
var $604643028e2b69bf$export$c4ba782e0833b2fb = /*#__PURE__*/ function(OpenState) {
    OpenState["UNOPENED"] = "unopened";
    OpenState["OPENED"] = "opened";
    OpenState["ClOSED"] = "closed";
    return OpenState;
}({});


// Libraries

var $NdCUR = parcelRequire("NdCUR");
// Libraries

var $NdCUR = parcelRequire("NdCUR");
// Libraries

var $NdCUR = parcelRequire("NdCUR");
// Libraries

var $NdCUR = parcelRequire("NdCUR");
// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");
const $108cef20b0325ec8$var$handleClick = (e)=>{
    e.stopPropagation();
};
const $108cef20b0325ec8$var$randomSize = ()=>{
    const width = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).random(60, 200);
    return {
        width: `${width}px`
    };
};
const $108cef20b0325ec8$var$LoaderSkeleton = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "flux-schema-tree flux-schema--child",
        onClick: $108cef20b0325ec8$var$handleClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "flux-schema--item no-hover"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "flux-schema--expander"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "flux-schema--item-skeleton",
        style: $108cef20b0325ec8$var$randomSize()
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "flux-schema-tree flux-schema--child"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "flux-schema--item no-hover"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "flux-schema--expander"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "flux-schema--item-skeleton",
        style: $108cef20b0325ec8$var$randomSize()
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "flux-schema-tree flux-schema--child"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "flux-schema--item no-hover"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "flux-schema--expander"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "flux-schema--item-skeleton",
        style: $108cef20b0325ec8$var$randomSize()
    }))));
};
var $108cef20b0325ec8$export$2e2bcd8739ae039 = $108cef20b0325ec8$var$LoaderSkeleton;



var $NdCUR = parcelRequire("NdCUR");
class $377d531c50f14b76$export$2e2bcd8739ae039 extends (0, $NdCUR.PureComponent) {
    render() {
        const { field: field } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-schema-tree flux-schema--child",
            key: field,
            onClick: this.handleClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-schema--item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flex-schema-item-group"
        }, field, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "flux-schema--type"
        }, "Field"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "button button-xs button-primary",
            onClick: this.handleAddFilter
        }, "Add Filter"))));
    }
    constructor(...args){
        super(...args), this.handleAddFilter = (e)=>{
            const { onAddFilter: onAddFilter, measurement: measurement, field: field } = this.props;
            e.stopPropagation();
            if (!onAddFilter) return;
            if (measurement) onAddFilter({
                _measurement: measurement,
                _field: field
            });
            else onAddFilter({
                _field: field
            });
        }, this.handleClick = (e)=>{
            e.stopPropagation();
        };
    }
}




class $36cad4cee81aa443$var$FieldList extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleClick = (e)=>{
            e.stopPropagation();
        }, this.onSearch = (e)=>{
            this.setState({
                searchTerm: e.target.value
            });
        }, this.handleInputClick = (e)=>{
            e.stopPropagation();
        };
        this.state = {
            searchTerm: ''
        };
    }
    render() {
        const { searchTerm: searchTerm } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, !this.props.measurement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-schema--filter"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control input-xs",
            placeholder: 'Filter Fields',
            type: "text",
            spellCheck: false,
            autoComplete: "off",
            value: searchTerm,
            onClick: this.handleInputClick,
            onChange: this.onSearch
        })), this.fields);
    }
    get fields() {
        const { loading: loading, measurement: measurement, onAddFilter: onAddFilter } = this.props;
        const { searchTerm: searchTerm } = this.state;
        if (loading === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: `flux-schema-tree flux-schema--child flux-schema-tree--error`,
            onClick: this.handleClick
        }, "Could not fetch fields");
        if (loading !== (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $108cef20b0325ec8$export$2e2bcd8739ae039), null);
        const term = searchTerm.toLocaleLowerCase();
        const fields = this.props.fields.filter((f)=>f.toLocaleLowerCase().includes(term));
        if (fields.length) return fields.map((field)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $377d531c50f14b76$export$2e2bcd8739ae039), {
                key: `fieldlistitem-${field}`,
                field: field,
                measurement: measurement,
                onAddFilter: onAddFilter
            }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-schema-tree flux-schema--child"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-schema--item no-hover",
            onClick: this.handleClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "no-results"
        }, `No ${term ? 'matching ' : ''}fields in the selected time range.`)));
    }
}
var $36cad4cee81aa443$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($36cad4cee81aa443$var$FieldList);




class $1539461b1b86f14c$var$MeasurementListItem extends (0, $NdCUR.PureComponent) {
    static getDerivedStateFromProps(props, state) {
        if (props.opened === (0, $604643028e2b69bf$export$c4ba782e0833b2fb).OPENED && state.opened === (0, $604643028e2b69bf$export$c4ba782e0833b2fb).UNOPENED) return {
            ...state,
            opened: props.opened
        };
        return null;
    }
    constructor(props){
        super(props), this.handleAddFilter = (e)=>{
            e.stopPropagation();
            const { onAddFilter: onAddFilter, measurement: measurement } = this.props;
            if (!onAddFilter) return;
            onAddFilter({
                _measurement: measurement
            });
        }, this.handleItemClick = (e)=>{
            e.stopPropagation();
            const opened = this.state.opened;
            if (opened === (0, $604643028e2b69bf$export$c4ba782e0833b2fb).OPENED) {
                this.setState({
                    opened: (0, $604643028e2b69bf$export$c4ba782e0833b2fb).ClOSED
                });
                return;
            }
            this.setState({
                opened: (0, $604643028e2b69bf$export$c4ba782e0833b2fb).OPENED
            });
        };
        this.state = {
            opened: props.opened
        };
    }
    render() {
        const { db: db, source: source, measurement: measurement, fields: fields, notify: notify, loading: loading } = this.props;
        const { opened: opened } = this.state;
        const isOpen = opened === (0, $604643028e2b69bf$export$c4ba782e0833b2fb).OPENED;
        const isUnopen = opened === (0, $604643028e2b69bf$export$c4ba782e0833b2fb).UNOPENED;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: `flux-schema-tree flux-schema--child ${isOpen ? 'expanded' : ''}`,
            key: measurement,
            onClick: this.handleItemClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-schema--item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flex-schema-item-group flux-schema-item--expandable"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-schema--expander"
        }), measurement, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "flux-schema--type"
        }, "Measurement"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "button button-xs button-primary",
            onClick: this.handleAddFilter
        }, "Add Filter"))), !isUnopen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: `flux-schema--children ${isOpen ? '' : 'hidden'}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $36cad4cee81aa443$export$2e2bcd8739ae039), {
            db: db,
            source: source,
            notify: notify,
            fields: fields,
            measurement: measurement,
            loading: loading,
            onAddFilter: this.props.onAddFilter
        })));
    }
}
var $1539461b1b86f14c$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($1539461b1b86f14c$var$MeasurementListItem);






class $e6de9eaea94d7ff3$var$MeasurementsList extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.onSearch = (e)=>{
            this.setState({
                searchTerm: e.target.value
            });
        }, this.handleClick = (e)=>{
            e.stopPropagation();
        };
        this.state = {
            searchTerm: ''
        };
    }
    render() {
        const { searchTerm: searchTerm } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-schema--filter"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control input-xs",
            placeholder: "Filter within Measurements",
            type: "text",
            spellCheck: false,
            autoComplete: "off",
            value: searchTerm,
            onClick: this.handleClick,
            onChange: this.onSearch
        })), this.measurements);
    }
    // all matching children and the path in the tree that leads
    // to them should be displayed
    get measurements() {
        const { source: source, db: db, notify: notify, loading: loading } = this.props;
        const { searchTerm: searchTerm } = this.state;
        const measurementEntries = Object.entries(this.props.measurements);
        measurementEntries.sort((a, b)=>a[0].localeCompare(b[0]));
        if (loading === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: `flux-schema-tree flux-schema--child flux-schema-tree--error`,
            onClick: this.handleClick
        }, "Could not fetch measurements");
        if (loading !== (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $108cef20b0325ec8$export$2e2bcd8739ae039), null);
        const term = searchTerm.toLocaleLowerCase();
        const measurements = measurementEntries.filter((entry)=>{
            const measurement = entry[0];
            const fieldsForMeasurement = entry[1];
            const fieldsIncludesTerm = fieldsForMeasurement.find((field)=>{
                return field.toLocaleLowerCase().includes(term);
            });
            return measurement.toLocaleLowerCase().includes(term) || fieldsIncludesTerm;
        });
        if (measurements.length) return measurements.map(([measurement, fields])=>{
            let startOpen = (0, $604643028e2b69bf$export$c4ba782e0833b2fb).UNOPENED;
            let fieldsIncludesTerm = false;
            const filteredFields = fields.filter((field)=>{
                if (field.toLocaleLowerCase().includes(term)) {
                    fieldsIncludesTerm = true;
                    return field;
                }
            });
            if (term !== '' && fieldsIncludesTerm) startOpen = (0, $604643028e2b69bf$export$c4ba782e0833b2fb).OPENED;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1539461b1b86f14c$export$2e2bcd8739ae039), {
                source: source,
                db: db,
                searchTerm: searchTerm,
                measurement: measurement,
                key: measurement,
                notify: notify,
                fields: filteredFields,
                opened: startOpen,
                loading: loading,
                onAddFilter: this.props.onAddFilter
            });
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-schema-tree flux-schema--child"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-schema--item no-hover",
            onClick: this.handleClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "no-results"
        }, `No ${term ? 'matching ' : ''}measurements in the selected time range.`)));
    }
}
var $e6de9eaea94d7ff3$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($e6de9eaea94d7ff3$var$MeasurementsList);



// Libraries

var $NdCUR = parcelRequire("NdCUR");
// Libraries

var $NdCUR = parcelRequire("NdCUR");
// Libraries

var $NdCUR = parcelRequire("NdCUR");
// Libraries

var $NdCUR = parcelRequire("NdCUR");

class $bc47d201fd720d5c$var$TagValueListItem extends (0, $NdCUR.PureComponent) {
    render() {
        const { tagValue: tagValue } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: `flux-schema-tree flux-schema--child`,
            key: tagValue,
            onClick: this.handleClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-schema--item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flex-schema-item-group"
        }, tagValue, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "flux-schema--type"
        }, "Tag Value"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "button button-xs button-primary",
            onClick: this.handleAddFilter
        }, "Add Filter"))));
    }
    constructor(...args){
        super(...args), this.handleAddFilter = (e)=>{
            e.stopPropagation();
            const { onAddFilter: onAddFilter, tagValue: tagValue, tagKey: tagKey } = this.props;
            if (!onAddFilter) return;
            onAddFilter({
                [tagKey]: tagValue
            });
        }, this.handleClick = (e)=>{
            e.stopPropagation();
        };
    }
}
var $bc47d201fd720d5c$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($bc47d201fd720d5c$var$TagValueListItem);




var $NdCUR = parcelRequire("NdCUR");
const $3f24f31e899f9593$var$LoadingSpinner = ({ style: style })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "loading-spinner",
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "spinner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "bounce1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "bounce2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "bounce3"
    })));
};
var $3f24f31e899f9593$export$2e2bcd8739ae039 = $3f24f31e899f9593$var$LoadingSpinner;






const $6fd283ce8a1ba168$var$TAG_VALUES_LIMIT = 25;
class $6fd283ce8a1ba168$var$TagValueList extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.debouncer = new (0, $075f3b99bb3716e4$export$2e2bcd8739ae039)(), this.fetchData = async ()=>{
            const { source: source, timeRange: timeRange, db: db, tagKey: tagKey } = this.props;
            const { searchTerm: searchTerm, limit: limit } = this.state;
            return await (0, $60998f94e3811eb1$export$b6b561cd67098bda)({
                source: source,
                timeRange: timeRange,
                bucket: db,
                tagKey: tagKey,
                limit: limit,
                searchTerm: searchTerm
            });
        }, this.onSearch = (e)=>{
            this.setState({
                searchTerm: e.target.value
            }, ()=>{
                try {
                    this.debouncer.call(async ()=>{
                        const tagValues = await this.fetchData();
                        this.setState({
                            tagValues: tagValues
                        });
                    }, 50);
                } catch (error) {
                    this.setState({
                        loading: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error,
                        loadingMoreValues: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error
                    });
                }
            });
        }, this.handleClick = (e)=>{
            e.stopPropagation();
        }, this.onLoadMoreValues = (e)=>{
            e.stopPropagation();
            const previousTagValuesCount = this.state.tagValues.length;
            this.setState({
                limit: this.state.limit + $6fd283ce8a1ba168$var$TAG_VALUES_LIMIT,
                loadingMoreValues: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading
            }, // eslint-disable-next-line @typescript-eslint/no-misused-promises
            async ()=>{
                try {
                    const tagValues = await this.fetchData();
                    this.setState({
                        tagValues: tagValues,
                        loading: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done,
                        loadingMoreValues: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done
                    });
                } catch (error) {
                    this.setState({
                        loading: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error,
                        loadingMoreValues: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error
                    });
                }
                if (this.state.tagValues.length < previousTagValuesCount + $6fd283ce8a1ba168$var$TAG_VALUES_LIMIT) this.setState({
                    shouldShowMoreValues: false
                });
            });
        };
        this.state = {
            tagValues: [],
            searchTerm: '',
            loading: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading,
            loadingMoreValues: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).NotStarted,
            limit: $6fd283ce8a1ba168$var$TAG_VALUES_LIMIT,
            shouldShowMoreValues: true
        };
    }
    async componentDidMount() {
        this.setState({
            loading: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading
        });
        try {
            const tagValues = await this.fetchData();
            this.setState({
                tagValues: tagValues,
                loading: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done,
                shouldShowMoreValues: tagValues.length >= $6fd283ce8a1ba168$var$TAG_VALUES_LIMIT
            });
        } catch (error) {
            this.setState({
                loading: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error
            });
        }
    }
    componentWillUnmount() {
        this.debouncer.cancelAll();
    }
    render() {
        const { tagKey: tagKey } = this.props;
        const { searchTerm: searchTerm } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-schema--filter"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control input-xs",
            placeholder: `Filter within ${tagKey}`,
            type: "text",
            spellCheck: false,
            autoComplete: "off",
            value: searchTerm,
            onClick: this.handleClick,
            onChange: this.onSearch
        })), this.tagValues);
    }
    get tagValues() {
        const { source: source, db: db, tagKey: tagKey, notify: notify } = this.props;
        const { searchTerm: searchTerm, loading: loading, shouldShowMoreValues: shouldShowMoreValues } = this.state;
        if (loading === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: `flux-schema-tree flux-schema--child flux-schema-tree--error`,
            onClick: this.handleClick
        }, "Could not fetch tag values");
        if (loading === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $108cef20b0325ec8$export$2e2bcd8739ae039), null);
        const term = searchTerm.toLocaleLowerCase();
        const tagValues = this.state.tagValues.filter((tv)=>tv !== '' && tv.toLocaleLowerCase().includes(term));
        if (tagValues.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, tagValues.map((tagValue)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $bc47d201fd720d5c$export$2e2bcd8739ae039), {
                source: source,
                db: db,
                searchTerm: searchTerm,
                tagValue: tagValue,
                tagKey: tagKey,
                key: tagValue,
                notify: notify,
                onAddFilter: this.props.onAddFilter
            })), shouldShowMoreValues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-schema-tree flux-schema--child"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-schema--item no-hover"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-xs btn-default increase-values-limit",
            onClick: this.onLoadMoreValues
        }, this.loadMoreButtonValue))));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-schema-tree flux-schema--child"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-schema--item no-hover",
            onClick: this.handleClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "no-results"
        }, `No ${term ? 'matching ' : ''}tag values in the selected time range.`)));
    }
    get loadMoreButtonValue() {
        const { tagKey: tagKey } = this.props;
        const { loadingMoreValues: loadingMoreValues } = this.state;
        if (loadingMoreValues === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $3f24f31e899f9593$export$2e2bcd8739ae039), null);
        return `Load next ${$6fd283ce8a1ba168$var$TAG_VALUES_LIMIT} values for ${tagKey}`;
    }
}
var $6fd283ce8a1ba168$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($6fd283ce8a1ba168$var$TagValueList);




class $c1204e955bb53501$var$TagKeyListItem extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleItemClick = (e)=>{
            e.stopPropagation();
            const opened = this.state.opened;
            if (opened === (0, $604643028e2b69bf$export$c4ba782e0833b2fb).OPENED) {
                this.setState({
                    opened: (0, $604643028e2b69bf$export$c4ba782e0833b2fb).ClOSED
                });
                return;
            }
            this.setState({
                opened: (0, $604643028e2b69bf$export$c4ba782e0833b2fb).OPENED
            });
        };
        this.state = {
            opened: (0, $604643028e2b69bf$export$c4ba782e0833b2fb).UNOPENED
        };
    }
    render() {
        const { db: db, source: source, timeRange: timeRange, tagKey: tagKey, notify: notify } = this.props;
        const { opened: opened } = this.state;
        const isOpen = opened === (0, $604643028e2b69bf$export$c4ba782e0833b2fb).OPENED;
        const isUnopen = opened === (0, $604643028e2b69bf$export$c4ba782e0833b2fb).UNOPENED;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: `flux-schema-tree flux-schema--child ${isOpen ? 'expanded' : ''}`,
            key: tagKey,
            onClick: this.handleItemClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-schema--item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flex-schema-item-group flux-schema-item--expandable"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-schema--expander"
        }), tagKey, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "flux-schema--type"
        }, "Tag Key"))), !isUnopen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: `flux-schema--children ${isOpen ? '' : 'hidden'}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $6fd283ce8a1ba168$export$2e2bcd8739ae039), {
            db: db,
            source: source,
            timeRange: timeRange,
            tagKey: tagKey,
            notify: notify,
            onAddFilter: this.props.onAddFilter
        })));
    }
}
var $c1204e955bb53501$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($c1204e955bb53501$var$TagKeyListItem);





const $83ef5f69dba1481a$var$excludedTagKeys = [
    '_measurement',
    '_field',
    '_start',
    '_stop'
];
class $83ef5f69dba1481a$var$TagKeyList extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleClick = (e)=>{
            e.stopPropagation();
        };
        this.state = {
            searchTerm: ''
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, this.tagKeys);
    }
    get tagKeys() {
        const { db: db, source: source, timeRange: timeRange, notify: notify, loading: loading } = this.props;
        if (loading === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: `flux-schema-tree flux-schema--child flux-schema-tree--error`,
            onClick: this.handleClick
        }, "Could not fetch tag keys");
        if (loading !== (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $108cef20b0325ec8$export$2e2bcd8739ae039), null);
        const tagKeys = this.props.tagKeys.filter((tk)=>!$83ef5f69dba1481a$var$excludedTagKeys.includes(tk));
        if (tagKeys.length) return tagKeys.map((tagKey)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c1204e955bb53501$export$2e2bcd8739ae039), {
                db: db,
                source: source,
                timeRange: timeRange,
                tagKey: tagKey,
                key: tagKey,
                notify: notify,
                onAddFilter: this.props.onAddFilter
            }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-schema-tree flux-schema--child"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-schema--item no-hover",
            onClick: this.handleClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "no-results"
        }, "No tag keys in the selected time range.")));
    }
}
var $83ef5f69dba1481a$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($83ef5f69dba1481a$var$TagKeyList);






var $0dc0ddc6d5cad234$export$809ff1aea83412ce = /*#__PURE__*/ function(CategoryType) {
    CategoryType["Measurements"] = "measurements";
    CategoryType["Fields"] = "fields";
    CategoryType["Tags"] = "tags";
    return CategoryType;
}({});
class $0dc0ddc6d5cad234$var$SchemaItemCategory extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleClick = (e)=>{
            e.stopPropagation();
            const opened = this.state.opened;
            if (opened === (0, $604643028e2b69bf$export$c4ba782e0833b2fb).OPENED) {
                this.setState({
                    opened: (0, $604643028e2b69bf$export$c4ba782e0833b2fb).ClOSED
                });
                return;
            }
            this.setState({
                opened: (0, $604643028e2b69bf$export$c4ba782e0833b2fb).OPENED
            });
        }, this.handleAddFilter = (filter)=>{
            this.props.onAddFilter(this.props.db, filter);
        };
        this.state = {
            opened: (0, $604643028e2b69bf$export$c4ba782e0833b2fb).UNOPENED
        };
    }
    render() {
        const { opened: opened } = this.state;
        const isOpen = opened === (0, $604643028e2b69bf$export$c4ba782e0833b2fb).OPENED;
        const isUnopened = opened === (0, $604643028e2b69bf$export$c4ba782e0833b2fb).UNOPENED;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: `flux-schema-tree flux-schema--child ${isOpen ? 'expanded' : ''}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-schema--item",
            onClick: this.handleClick,
            "data-test": "schema-category-field"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flex-schema-item-group flux-schema-item--expandable"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-schema--expander",
            "data-test": "schema-category-item"
        }), this.categoryName, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "flux-schema--type"
        }, "(", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $557b602c140cbcc0$export$2e2bcd8739ae039), {
            timeRange: this.props.timeRange
        }), ")"))), !isUnopened && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: `flux-schema--children ${isOpen ? '' : 'hidden'}`
        }, this.itemList));
    }
    get categoryName() {
        switch(this.props.type){
            case "measurements":
                return 'MEASUREMENTS';
            case "fields":
                return 'FIELDS';
            case "tags":
                return 'TAGS';
        }
    }
    get itemList() {
        const { type: type, db: db, timeRange: timeRange, source: source, notify: notify, categoryTree: categoryTree } = this.props;
        switch(type){
            case "measurements":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $e6de9eaea94d7ff3$export$2e2bcd8739ae039), {
                    db: db,
                    source: source,
                    notify: notify,
                    measurements: categoryTree.measurements,
                    loading: categoryTree.measurementsLoading,
                    onAddFilter: this.handleAddFilter
                });
            case "fields":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $36cad4cee81aa443$export$2e2bcd8739ae039), {
                    db: db,
                    source: source,
                    notify: notify,
                    fields: categoryTree.fields,
                    loading: categoryTree.fieldsLoading,
                    onAddFilter: this.handleAddFilter
                });
            case "tags":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $83ef5f69dba1481a$export$2e2bcd8739ae039), {
                    db: db,
                    source: source,
                    timeRange: timeRange,
                    notify: notify,
                    tagKeys: categoryTree.tagKeys,
                    loading: categoryTree.tagsLoading,
                    onAddFilter: this.handleAddFilter
                });
        }
    }
}
const $0dc0ddc6d5cad234$var$SchemaItemCategory2 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($0dc0ddc6d5cad234$var$SchemaItemCategory);
const $0dc0ddc6d5cad234$var$ConnectedSchemaItemCategory = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b029b3af5fc2e5d5$export$7d87f8b720f7653e), null, (container)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($0dc0ddc6d5cad234$var$SchemaItemCategory2, {
            ...props,
            onAddFilter: container.handleAddFilter
        });
    });
};
var $0dc0ddc6d5cad234$export$2e2bcd8739ae039 = $0dc0ddc6d5cad234$var$ConnectedSchemaItemCategory;



class $864ebed53f5ada8c$var$SchemaItemCategories extends (0, $NdCUR.PureComponent) {
    render() {
        const { source: source, timeRange: timeRange, db: db, categoryTree: categoryTree, notify: notify } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $0dc0ddc6d5cad234$export$2e2bcd8739ae039), {
            source: source,
            timeRange: timeRange,
            db: db,
            type: (0, $0dc0ddc6d5cad234$export$809ff1aea83412ce).Measurements,
            categoryTree: categoryTree,
            notify: notify
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $0dc0ddc6d5cad234$export$2e2bcd8739ae039), {
            source: source,
            timeRange: timeRange,
            db: db,
            type: (0, $0dc0ddc6d5cad234$export$809ff1aea83412ce).Tags,
            categoryTree: categoryTree,
            notify: notify
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $0dc0ddc6d5cad234$export$2e2bcd8739ae039), {
            source: source,
            timeRange: timeRange,
            db: db,
            type: (0, $0dc0ddc6d5cad234$export$809ff1aea83412ce).Fields,
            categoryTree: categoryTree,
            notify: notify
        }));
    }
}
var $864ebed53f5ada8c$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($864ebed53f5ada8c$var$SchemaItemCategories);


class $b4addc53eb08435f$var$DatabaseListItem extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleClick = (e)=>{
            e.stopPropagation();
            const opened = this.state.opened;
            if (opened === (0, $604643028e2b69bf$export$c4ba782e0833b2fb).OPENED) {
                this.setState({
                    opened: (0, $604643028e2b69bf$export$c4ba782e0833b2fb).ClOSED
                });
                return;
            }
            this.setState({
                opened: (0, $604643028e2b69bf$export$c4ba782e0833b2fb).OPENED
            });
        };
        this.state = {
            opened: (0, $604643028e2b69bf$export$c4ba782e0833b2fb).UNOPENED,
            searchTerm: ''
        };
    }
    render() {
        const { db: db } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.className,
            onClick: this.handleClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-schema--item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flex-schema-item-group flux-schema-item--expandable"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-schema--expander",
            "data-test": "flux-schema--expander"
        }), db, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "flux-schema--type"
        }, "Bucket"))), this.categories);
    }
    get categories() {
        const { db: db, source: source, timeRange: timeRange, notify: notify } = this.props;
        const { opened: opened } = this.state;
        const isOpen = opened === (0, $604643028e2b69bf$export$c4ba782e0833b2fb).OPENED;
        const isUnopen = opened === (0, $604643028e2b69bf$export$c4ba782e0833b2fb).UNOPENED;
        if (!isUnopen) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: `flux-schema--children ${isOpen ? '' : 'hidden'}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $bd34937b631ab295$export$2e2bcd8739ae039), {
            bucket: db,
            source: source,
            timeRange: timeRange,
            key: db + ':' + timeRange.lower + ':' + timeRange.upper
        }, (tree)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $864ebed53f5ada8c$export$2e2bcd8739ae039), {
                db: db,
                source: source,
                timeRange: timeRange,
                notify: notify,
                categoryTree: tree
            })));
    }
    get className() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('flux-schema-tree', {
            expanded: this.state.opened === (0, $604643028e2b69bf$export$c4ba782e0833b2fb).OPENED
        });
    }
}
var $b4addc53eb08435f$export$2e2bcd8739ae039 = $b4addc53eb08435f$var$DatabaseListItem;






var $hBdgJ = parcelRequire("hBdgJ");
async function $4342653b815ad7ef$export$3663ee6d2a431e72(source) {
    const { csv: csv } = await (0, $5914150e71c44d02$export$786299a18b5685fc)(source, 'buckets()');
    const tables = (0, $c6606ad17445cd52$export$ba14d9a5a581e827)(csv);
    if (tables && tables.length > 0) {
        const data = tables[0].data;
        if (data.length > 1) {
            const nameIndex = data[0].indexOf('name');
            if (nameIndex > 0) {
                const buckets = data.slice(1).map((arr)=>arr[nameIndex]);
                return buckets.sort();
            }
        }
    }
    return [];
}
class $4342653b815ad7ef$var$DatabaseList extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props);
        this.state = {
            databases: []
        };
    }
    componentDidMount() {
        this.getDatabases();
    }
    componentDidUpdate({ source: prevSource }) {
        const { source: nextSource } = this.props;
        const differentSource = !(0, $hBdgJ.isEqual)(prevSource, nextSource);
        if (differentSource) {
            this.setState({
                databases: []
            });
            this.getDatabases();
        }
    }
    async getDatabases() {
        const { source: source } = this.props;
        try {
            const buckets = await $4342653b815ad7ef$export$3663ee6d2a431e72(source);
            this.setState({
                databases: buckets
            });
        } catch (err) {
            console.error(err);
        }
    }
    render() {
        const { databases: databases } = this.state;
        const { source: source, timeRange: timeRange, notify: notify } = this.props;
        return databases.map((db)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b4addc53eb08435f$export$2e2bcd8739ae039), {
                db: db,
                key: db,
                source: source,
                timeRange: timeRange,
                notify: notify
            });
        });
    }
}
var $4342653b815ad7ef$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($4342653b815ad7ef$var$DatabaseList);


const { databases: $fec5a5fc404d322c$var$showDatabasesParser } = (0, $006aaeac7e238898$export$2e2bcd8739ae039);
class $fec5a5fc404d322c$var$DatabaseDropdown extends (0, $NdCUR.Component) {
    constructor(props){
        super(props), this.getDatabasesAsync = async ()=>{
            const { source: source, database: database, onSelectDatabase: onSelectDatabase, onErrorThrown: onErrorThrown, useBuckets: useBuckets } = this.props;
            let databases;
            if (useBuckets) try {
                databases = await (0, $4342653b815ad7ef$export$3663ee6d2a431e72)(source);
                databases.sort((a, b)=>{
                    // databases starting with '_' are the last
                    if (b.startsWith('_')) {
                        if (a.startsWith('_')) return a.localeCompare(b);
                        return -1;
                    }
                    return a.localeCompare(b);
                });
            } catch (e) {
                console.error(e);
                onErrorThrown(e);
                return;
            }
            else try {
                const proxy = source.links.proxy;
                const { data: data } = await (0, $8ba03c44d4b91783$export$46acc72e11cde242)(proxy);
                const parserResult = $fec5a5fc404d322c$var$showDatabasesParser(data);
                if (parserResult.errors.length > 0) throw parserResult.errors[0] // only one error can come back from this, but it's returned as an array
                ;
                databases = parserResult.databases;
            } catch (error) {
                console.error(error);
                onErrorThrown(error);
                return;
            }
            const nonSystemDatabases = databases.filter((name)=>!name.startsWith('_internal'));
            this.setState({
                databases: nonSystemDatabases
            });
            const selectedDatabaseText = nonSystemDatabases.includes(database) ? database : nonSystemDatabases[0] || 'No databases';
            onSelectDatabase({
                text: selectedDatabaseText
            });
        };
        this.state = {
            databases: []
        };
    }
    componentDidMount() {
        this.getDatabasesAsync();
    }
    render() {
        const { databases: databases } = this.state;
        const { database: database, onSelectDatabase: onSelectDatabase, onStartEdit: onStartEdit } = this.props;
        if (!database) this.componentDidMount();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ca4f14339173643c$export$2e2bcd8739ae039), {
            items: databases.map((text)=>({
                    text: text
                })),
            selected: database || 'Loading...',
            onChoose: onSelectDatabase,
            onClick: onStartEdit ? onStartEdit : null
        });
    }
}
var $fec5a5fc404d322c$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($fec5a5fc404d322c$var$DatabaseDropdown);





class $5b98ea00cd53715e$var$WriteDataHeader extends (0, $NdCUR.PureComponent) {
    render() {
        const { handleSelectDatabase: handleSelectDatabase, selectedDatabase: selectedDatabase, errorThrown: errorThrown, onClose: onClose, source: source, precision: precision, useBuckets: useBuckets } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "write-data-form--header"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "page-header--left"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h1", {
            className: "page-header--title"
        }, "Write Data To"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fec5a5fc404d322c$export$2e2bcd8739ae039), {
            source: source,
            onSelectDatabase: handleSelectDatabase,
            database: selectedDatabase,
            useBuckets: useBuckets,
            onErrorThrown: errorThrown
        }), this.modeSelector), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "page-header--right"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h1", {
            className: "page-header--title"
        }, "With"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ca4f14339173643c$export$2e2bcd8739ae039), {
            items: [
                {
                    text: 's'
                },
                {
                    text: 'ms'
                },
                {
                    text: 'u'
                },
                {
                    text: 'ns'
                }
            ],
            selected: precision,
            useAutoComplete: false,
            toggleStyle: {
                width: 50
            },
            onChoose: this.handlePrecisionChange
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h1", {
            className: "page-header--title"
        }, "Precision"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "page-header__dismiss",
            onClick: onClose
        })));
    }
    get modeSelector() {
        const { mode: mode, onToggleMode: onToggleMode } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039).Button, {
            id: `write-data-${(0, $997a2bc484aadf39$export$209f3caa268488b1).File}`,
            value: (0, $997a2bc484aadf39$export$209f3caa268488b1).File,
            titleText: "Upload a file",
            onClick: onToggleMode,
            active: mode === (0, $997a2bc484aadf39$export$209f3caa268488b1).File
        }, "Upload File"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039).Button, {
            id: `write-data-${(0, $997a2bc484aadf39$export$209f3caa268488b1).Manual}`,
            value: (0, $997a2bc484aadf39$export$209f3caa268488b1).Manual,
            titleText: "Write data manually using Line Protocol",
            onClick: onToggleMode,
            active: mode === (0, $997a2bc484aadf39$export$209f3caa268488b1).Manual
        }, "Manual Entry"));
    }
    constructor(...args){
        super(...args), this.handlePrecisionChange = (item)=>this.props.handlePrecisionChange(item.text);
    }
}
var $5b98ea00cd53715e$export$2e2bcd8739ae039 = $5b98ea00cd53715e$var$WriteDataHeader;


const $f2ffe05a717df471$export$6448b13da8c2f965 = 'ceo';




let $59a17a34051de5aa$var$dragCounter = 0;
class $59a17a34051de5aa$var$WriteDataForm extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleToggleMode = (mode)=>{
            this.setState({
                mode: mode
            });
        }, this.handlePrecisionChange = (precision)=>{
            this.setState({
                precision: precision
            });
        }, this.handleSelectDatabase = (item)=>{
            this.setState({
                selectedDatabase: item.text
            });
        }, this.handleKeyUp = (e)=>{
            e.stopPropagation();
            if (e.key === 'Escape') {
                const { onClose: onClose } = this.props;
                onClose();
            }
        }, this.handleSubmit = async ()=>{
            const { onClose: onClose, source: source, writeLineProtocol: writeLineProtocol, useV2: useV2 } = this.props;
            const { inputContent: inputContent, uploadContent: uploadContent, selectedDatabase: selectedDatabase, mode: mode, precision: precision } = this.state;
            let content = inputContent;
            if (mode === (0, $997a2bc484aadf39$export$209f3caa268488b1).File) content = uploadContent;
            this.setState({
                isUploading: true
            });
            try {
                await writeLineProtocol(source, selectedDatabase, content, precision, useV2);
                this.setState({
                    isUploading: false
                });
                onClose();
                window.location.reload();
            } catch (error) {
                this.setState({
                    isUploading: false
                });
                console.error(error.data);
            }
        }, this.handleEdit = (e)=>{
            this.setState({
                inputContent: e.target.value.trim()
            });
        }, this.handleFile = (drop)=>(e)=>{
                let file;
                if (drop) {
                    file = e.dataTransfer.files[0];
                    this.setState({
                        dragClass: 'drag-none'
                    });
                } else file = e.currentTarget.files[0];
                if (!file) return;
                e.preventDefault();
                e.stopPropagation();
                const reader = new FileReader();
                reader.readAsText(file);
                reader.onload = (loadEvent)=>{
                    this.setState({
                        uploadContent: loadEvent.target.result,
                        fileName: file.name
                    });
                };
            }, this.handleCancelFile = ()=>{
            this.setState({
                uploadContent: ''
            });
            this.fileInput.value = '';
        }, this.handleDragOver = (e)=>{
            e.preventDefault();
            e.stopPropagation();
        }, this.handleDragEnter = (e)=>{
            $59a17a34051de5aa$var$dragCounter += 1;
            e.preventDefault();
            this.setState({
                dragClass: 'drag-over'
            });
        }, this.handleDragLeave = (e)=>{
            $59a17a34051de5aa$var$dragCounter -= 1;
            e.preventDefault();
            if ($59a17a34051de5aa$var$dragCounter === 0) this.setState({
                dragClass: 'drag-none'
            });
        }, this.handleFileOpen = ()=>{
            const { uploadContent: uploadContent } = this.state;
            if (uploadContent === '') this.fileInput.click();
        }, this.handleFileInputRef = (r)=>this.fileInput = r;
        this.state = {
            selectedDatabase: props.selectedDatabase,
            inputContent: null,
            uploadContent: '',
            fileName: '',
            progress: '',
            mode: (0, $997a2bc484aadf39$export$209f3caa268488b1).File,
            dragClass: 'drag-none',
            isUploading: false,
            precision: 'ns'
        };
    }
    render() {
        const { onClose: onClose, errorThrown: errorThrown, source: source, useV2: useV2 } = this.props;
        const { dragClass: dragClass } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            onDrop: this.handleFile(true),
            onDragOver: this.handleDragOver,
            onDragEnter: this.handleDragEnter,
            onDragExit: this.handleDragLeave,
            onDragLeave: this.handleDragLeave,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))((0, $f2ffe05a717df471$export$6448b13da8c2f965), dragClass)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "write-data-form"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $5b98ea00cd53715e$export$2e2bcd8739ae039), {
            ...this.state,
            source: source,
            onClose: onClose,
            errorThrown: errorThrown,
            onToggleMode: this.handleToggleMode,
            useBuckets: useV2,
            handlePrecisionChange: this.handlePrecisionChange,
            handleSelectDatabase: this.handleSelectDatabase
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $3a0ccc8151427d75$export$2e2bcd8739ae039), {
            ...this.state,
            fileInput: this.handleFileInputRef,
            handleEdit: this.handleEdit,
            handleFile: this.handleFile,
            handleKeyUp: this.handleKeyUp,
            handleSubmit: this.handleSubmit,
            handleFileOpen: this.handleFileOpen,
            handleCancelFile: this.handleCancelFile
        })));
    }
}
var $59a17a34051de5aa$export$2e2bcd8739ae039 = (0, $1636633b789d0ee3$export$2e2bcd8739ae039)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($59a17a34051de5aa$var$WriteDataForm));



// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");









const $39b3d9c631bf809f$var$NEW_DASHBOARD_ID = 'new';
class $39b3d9c631bf809f$var$SendToDashboardOverlay extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.onSendAllQueriesCheckChange = (val)=>{
            this.setState({
                sendAllQueries: val.target.checked
            });
        }, this.onSendActiveQueriesCheckChange = (val)=>{
            this.setState({
                sendAllQueries: !val.target.checked
            });
        }, this.handleChangeName = (e)=>{
            const name = e.target.value;
            this.setState({
                name: name
            });
        }, this.handleChangeNewDashboardName = (e)=>{
            const newDashboardName = e.target.value;
            this.setState({
                newDashboardName: newDashboardName
            });
        }, this.rawText = (queryConfig)=>{
            const { timeRange: timeRange } = this.props;
            if (queryConfig) return (0, $7b2c5b24a44a7fa2$export$1dad96b972e94224)(queryConfig, timeRange);
            return '';
        }, this.handleSelect = async (selectedIDs)=>{
            this.setState({
                selectedIDs: selectedIDs
            });
        }, this.notifyResolutions = (resolved, cellName)=>{
            const { notify: notify } = this.props;
            const failures = resolved.filter((r)=>r.success === false);
            if (failures.length === 0) {
                notify((0, $ec1f42de4faacc37$export$3216e94217c8d2db)(cellName, resolved.length));
                return;
            }
            failures.forEach((f)=>{
                notify((0, $ec1f42de4faacc37$export$1150c37069ac095f)(cellName, f.dashboard.name));
            });
        }, this.sendToDashboard = async ()=>{
            const { name: name, newDashboardName: newDashboardName, sendAllQueries: sendAllQueries } = this.state;
            const { queryType: queryType, script: script, sendDashboardCell: sendDashboardCell, source: source, onCancel: onCancel, visualizationOptions: visualizationOptions, isStaticLegend: isStaticLegend, queryDrafts: queryDrafts } = this.props;
            const { type: type, gaugeColors: gaugeColors, thresholdsListColors: thresholdsListColors, lineColors: lineColors, axes: axes, decimalPlaces: decimalPlaces, timeFormat: timeFormat, note: note, noteVisibility: noteVisibility, fieldOptions: fieldOptions } = visualizationOptions;
            const isFluxQuery = queryType === (0, $b4506126e09430df$export$7c8e26efb80b90e8).Flux;
            let newCellQueries;
            if (isFluxQuery) newCellQueries = [
                {
                    queryConfig: null,
                    query: script,
                    source: source.links.self,
                    type: (0, $b4506126e09430df$export$7c8e26efb80b90e8).Flux
                }
            ];
            else {
                const createInfluxQLCellQuery = (queryConfig)=>{
                    const rawText = this.rawText(queryConfig);
                    return {
                        queryConfig: queryConfig,
                        query: rawText,
                        source: source.links.self,
                        type: (0, $b4506126e09430df$export$7c8e26efb80b90e8).InfluxQL
                    };
                };
                // InfluxQL
                if (sendAllQueries) newCellQueries = queryDrafts.reduce((acc, val)=>{
                    acc.push(createInfluxQLCellQuery(val.queryConfig));
                    return acc;
                }, []);
                else newCellQueries = [
                    createInfluxQLCellQuery(this.activeQueryConfig)
                ];
            }
            const colors = (0, $727a6ab7dfc948a3$export$be1e3eb56b1b752d)({
                cellType: type,
                gaugeColors: gaugeColors,
                thresholdsListColors: thresholdsListColors,
                lineColors: lineColors
            });
            const legend = isStaticLegend ? (0, $727a6ab7dfc948a3$export$bce5511945345ed) : {};
            let selectedDashboards = this.selectedDashboards;
            if (this.isNewDashboardSelected) {
                let result;
                if (newDashboardName === '') result = await (0, $2adafb01fdaabc72$export$eadf0ac433611b3)((0, $9a9ec629fdd38845$export$2b1ba191e5fea4cb));
                else result = await (0, $2adafb01fdaabc72$export$eadf0ac433611b3)({
                    ...(0, $9a9ec629fdd38845$export$2b1ba191e5fea4cb),
                    name: newDashboardName
                });
                const newDashboard = result.data;
                selectedDashboards = [
                    ...selectedDashboards,
                    newDashboard
                ];
            }
            const resolved = await Promise.all(selectedDashboards.map((dashboard)=>{
                const emptyCell = (0, $0ece195804443aff$export$47308518c82e405)(dashboard);
                const newCell = {
                    ...emptyCell,
                    name: name,
                    queries: newCellQueries,
                    type: type,
                    axes: axes,
                    legend: legend,
                    colors: colors,
                    decimalPlaces: decimalPlaces,
                    timeFormat: timeFormat,
                    note: note,
                    noteVisibility: noteVisibility,
                    fieldOptions: fieldOptions
                };
                return sendDashboardCell(dashboard, newCell);
            }));
            this.notifyResolutions(resolved, name);
            onCancel();
        };
        this.state = {
            selectedIDs: [],
            name: '',
            newDashboardName: '',
            sendAllQueries: false
        };
    }
    async componentDidMount() {
        const { handleGetDashboards: handleGetDashboards } = this.props;
        await handleGetDashboards();
    }
    render() {
        const { onCancel: onCancel, queryDrafts: queryDrafts, queryType: queryType } = this.props;
        const { name: name, selectedIDs: selectedIDs, newDashboardName: newDashboardName, sendAllQueries: sendAllQueries } = this.state;
        const numberDashboards = selectedIDs.length > 1 ? selectedIDs.length : '';
        const pluralizer = selectedIDs.length > 1 ? 's' : '';
        const multipleQueries = queryType === (0, $b4506126e09430df$export$7c8e26efb80b90e8).InfluxQL && queryDrafts.length > 1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1868bdace58643df$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1372e03f76900c5b$export$2e2bcd8739ae039), {
            title: "Send to Dashboard",
            onDismiss: onCancel
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1e8c886c7914a527$export$2e2bcd8739ae039), null, this.hasQuery() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c5881206d41e0616$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c5881206d41e0616$export$2e2bcd8739ae039).Element, {
            label: "Target Dashboard(s)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fba4704c463778f3$export$2e2bcd8739ae039), {
            onChange: this.handleSelect,
            selectedIDs: this.state.selectedIDs,
            emptyText: "Choose at least 1 dashboard"
        }, this.dropdownItems)), this.isNewDashboardSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c5881206d41e0616$export$2e2bcd8739ae039).Element, {
            label: "Name new dashboard"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $86817c9e53a28f66$export$2e2bcd8739ae039), {
            value: newDashboardName,
            onChange: this.handleChangeNewDashboardName,
            placeholder: 'Name new dashboard'
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c5881206d41e0616$export$2e2bcd8739ae039).Element, {
            label: "Cell Name"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $86817c9e53a28f66$export$2e2bcd8739ae039), {
            value: name,
            onChange: this.handleChangeName,
            placeholder: 'Name this new cell'
        })), multipleQueries && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c5881206d41e0616$export$2e2bcd8739ae039).Element, {
            label: "Queries"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-control-static"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "radio-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            id: "active_query_option",
            type: "radio",
            name: "queriesRadio",
            value: "active",
            checked: !sendAllQueries,
            onChange: this.onSendActiveQueriesCheckChange
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "active_query_option",
            title: "Query from the selected tab"
        }, "Active Query")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "radio-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            id: "all_queries_option",
            type: "radio",
            name: "queriesRadio",
            value: "all",
            checked: sendAllQueries,
            onChange: this.onSendAllQueriesCheckChange
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "all_queries_option",
            title: "Queries from all tabs"
        }, "All Queries"))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c5881206d41e0616$export$2e2bcd8739ae039).Footer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
            color: (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Success,
            text: `Send to ${numberDashboards} Dashboard${pluralizer}`,
            titleText: "Must choose at least 1 dashboard and set a name",
            status: this.submitButtonStatus,
            onClick: this.sendToDashboard
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
            text: "Cancel",
            onClick: onCancel
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c5881206d41e0616$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c5881206d41e0616$export$2e2bcd8739ae039).Element, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "text-center"
        }, "No", this.props.queryType === (0, $b4506126e09430df$export$7c8e26efb80b90e8).Flux ? ' script ' : ' query ', "specified!")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c5881206d41e0616$export$2e2bcd8739ae039).Footer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
            text: "Back",
            onClick: onCancel
        })))));
    }
    get dropdownItems() {
        const { dashboards: dashboards } = this.props;
        const { newDashboardName: newDashboardName } = this.state;
        const simpleArray = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).sortBy(dashboards.map((d)=>({
                id: d.id.toString(),
                name: d.name
            })), (element)=>{
            return element.name.toLowerCase();
        });
        const items = simpleArray.map((dashboard)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fba4704c463778f3$export$2e2bcd8739ae039).Item, {
                key: dashboard.id,
                id: dashboard.id,
                value: dashboard
            }, dashboard.name);
        });
        const newDashboardItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fba4704c463778f3$export$2e2bcd8739ae039).Item, {
            key: $39b3d9c631bf809f$var$NEW_DASHBOARD_ID,
            id: $39b3d9c631bf809f$var$NEW_DASHBOARD_ID,
            value: {
                id: $39b3d9c631bf809f$var$NEW_DASHBOARD_ID,
                name: newDashboardName
            }
        }, "Send to a New Dashboard");
        const divider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fba4704c463778f3$export$2e2bcd8739ae039).Divider, {
            key: 'divider',
            id: 'divider'
        });
        return [
            newDashboardItem,
            divider,
            ...items
        ];
    }
    get isNewDashboardSelected() {
        return this.state.selectedIDs.includes($39b3d9c631bf809f$var$NEW_DASHBOARD_ID);
    }
    get activeQueryConfig() {
        const { queryDrafts: queryDrafts, activeQueryIndex: activeQueryIndex } = this.props;
        if (queryDrafts === undefined || queryDrafts.length === 0) return undefined;
        if (activeQueryIndex < queryDrafts.length) return queryDrafts[activeQueryIndex].queryConfig;
        return queryDrafts[0].queryConfig;
    }
    hasQuery() {
        const { script: script, queryType: queryType } = this.props;
        if (queryType === (0, $b4506126e09430df$export$7c8e26efb80b90e8).Flux) return script && !!script.trim();
        const rawText = this.rawText(this.activeQueryConfig);
        return rawText && !!rawText.trim();
    }
    get selectedDashboards() {
        const { dashboards: dashboards } = this.props;
        const { selectedIDs: selectedIDs } = this.state;
        return dashboards.filter((d)=>{
            return selectedIDs.includes(d.id.toString());
        });
    }
    get submitButtonStatus() {
        const { name: name, selectedIDs: selectedIDs } = this.state;
        if (selectedIDs.length === 0 || name.trim().length === 0) return (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Disabled;
        return (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Default;
    }
}
const $39b3d9c631bf809f$var$ConnectedSendToDashboardOverlay = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b029b3af5fc2e5d5$export$7d87f8b720f7653e), null, (timeMachineContainer)=>{
        const { type: type, tableOptions: tableOptions, fieldOptions: fieldOptions, timeFormat: timeFormat, decimalPlaces: decimalPlaces, note: note, noteVisibility: noteVisibility, axes: axes, thresholdsListColors: thresholdsListColors, thresholdsListType: thresholdsListType, gaugeColors: gaugeColors, lineColors: lineColors, queryType: queryType, queryDrafts: queryDrafts, timeRange: timeRange, draftScript: draftScript } = timeMachineContainer.state;
        const visualizationOptions = {
            type: type,
            axes: axes,
            tableOptions: tableOptions,
            fieldOptions: fieldOptions,
            timeFormat: timeFormat,
            decimalPlaces: decimalPlaces,
            note: note,
            noteVisibility: noteVisibility,
            thresholdsListColors: thresholdsListColors,
            gaugeColors: gaugeColors,
            lineColors: lineColors,
            thresholdsListType: thresholdsListType
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($39b3d9c631bf809f$var$SendToDashboardOverlay, {
            ...props,
            queryType: queryType,
            queryDrafts: queryDrafts,
            timeRange: timeRange,
            script: draftScript,
            visualizationOptions: visualizationOptions
        });
    });
};
var $39b3d9c631bf809f$export$2e2bcd8739ae039 = $39b3d9c631bf809f$var$ConnectedSendToDashboardOverlay;



// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");


var $hBdgJ = parcelRequire("hBdgJ");

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");
var $9595af9b15fd4b76$exports = {};
"use strict";
function $9595af9b15fd4b76$var$createDummyElement(text, options) {
    var element = document.createElement('div');
    var textNode = document.createTextNode(text);
    element.appendChild(textNode);
    element.style.fontFamily = options.font;
    element.style.fontSize = options.fontSize;
    element.style.fontWeight = options.fontWeight;
    element.style.position = 'absolute';
    element.style.visibility = 'hidden';
    element.style.left = '-999px';
    element.style.top = '-999px';
    element.style.width = options.width;
    element.style.height = 'auto';
    document.body.appendChild(element);
    return element;
}
function $9595af9b15fd4b76$var$destroyElement(element) {
    element.parentNode.removeChild(element);
}
var $9595af9b15fd4b76$var$cache = {};
Object.defineProperty($9595af9b15fd4b76$exports, "__esModule", {
    value: true
});
$9595af9b15fd4b76$exports.default = function(text, options) {
    if (options === void 0) options = {};
    var cacheKey = JSON.stringify({
        text: text,
        options: options
    });
    if ($9595af9b15fd4b76$var$cache[cacheKey]) return $9595af9b15fd4b76$var$cache[cacheKey];
    options.font = options.font || 'Times';
    options.fontSize = options.fontSize || '16px';
    options.fontWeight = options.fontWeight || 'normal';
    options.width = options.width || 'auto';
    var element = $9595af9b15fd4b76$var$createDummyElement(text, options);
    var size = {
        width: element.offsetWidth,
        height: element.offsetHeight
    };
    $9595af9b15fd4b76$var$destroyElement(element);
    $9595af9b15fd4b76$var$cache[cacheKey] = size;
    return size;
};



var $NdCUR = parcelRequire("NdCUR");

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");

class $224a74090fadb7be$var$DivisionMenu extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleExpandMenu = ()=>{
            this.setState({
                expanded: true
            });
        }, this.handleCollapseMenu = ()=>{
            this.setState({
                expanded: false
            });
        }, this.handleMenuItemClick = (action)=>()=>{
                this.setState({
                    expanded: false
                });
                action();
            };
        this.state = {
            expanded: false
        };
    }
    render() {
        const { expanded: expanded } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1f11d3536bc98f8a$export$c16e4f034c84cb3f), {
            onClickOutside: this.handleCollapseMenu
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.menuClass
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: this.buttonClass,
            onClick: this.handleExpandMenu
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon caret-down"
        })), expanded && this.renderMenu));
    }
    get menuClass() {
        const { expanded: expanded } = this.state;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('dropdown threesizer--menu', {
            open: expanded
        });
    }
    get buttonClass() {
        const { expanded: expanded } = this.state;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('btn btn-xs btn-square btn-default', {
            active: expanded
        });
    }
    get renderMenu() {
        const { menuItems: menuItems } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("ul", {
            className: "dropdown-menu"
        }, menuItems.map((item, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("li", {
                key: i,
                className: "dropdown-item",
                onClick: this.handleMenuItemClick(item.action)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("a", {
                href: "#"
            }, item.text))));
    }
}
var $224a74090fadb7be$export$2e2bcd8739ae039 = $224a74090fadb7be$var$DivisionMenu;


class $31b462fa28d19bfc$var$DivisionHeader extends (0, $NdCUR.PureComponent) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "threesizer--header"
        }, this.renderName, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "threesizer--header-controls",
            "data-test": "threesizer-header-controls"
        }, this.props.buttons.map((b)=>b), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $224a74090fadb7be$export$2e2bcd8739ae039), {
            menuItems: this.menuItems
        })));
    }
    get renderName() {
        const { name: name } = this.props;
        if (!name) return;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "threesizer--header-name"
        }, name);
    }
    get menuItems() {
        const { onEqualize: onEqualize, onMaximize: onMaximize, onMinimize: onMinimize, menuOptions: menuOptions } = this.props;
        return [
            ...menuOptions,
            {
                action: onMaximize,
                text: 'Maximize'
            },
            {
                action: onMinimize,
                text: 'Minimize'
            },
            {
                action: onEqualize,
                text: 'Reset'
            }
        ];
    }
}
var $31b462fa28d19bfc$export$2e2bcd8739ae039 = $31b462fa28d19bfc$var$DivisionHeader;



const $1f7189bf20c9785f$var$NOOP = ()=>{};
class $1f7189bf20c9785f$var$Division extends (0, $NdCUR.PureComponent) {
    static{
        this.defaultProps = {
            name: '',
            handleDisplay: 'visible',
            style: {}
        };
    }
    constructor(props){
        super(props), this.collapseThreshold = 0, this.divisionPixels = 0, this.drag = (e)=>{
            const { draggable: draggable, id: id } = this.props;
            if (!draggable) return $1f7189bf20c9785f$var$NOOP;
            this.props.onHandleStartDrag(id, e);
        }, this.handleDoubleClick = ()=>{
            const { onDoubleClick: onDoubleClick, id: id } = this.props;
            onDoubleClick(id);
        }, this.handleMinimize = ()=>{
            const { id: id, onMinimize: onMinimize } = this.props;
            onMinimize(id);
        }, this.handleMaximize = ()=>{
            const { id: id, onMaximize: onMaximize } = this.props;
            onMaximize(id);
        }, this.calcDivisionPixels = ()=>{
            const { orientation: orientation } = this.props;
            const { clientWidth: clientWidth, clientHeight: clientHeight } = this.divisionRef.current;
            let divisionPixels = clientWidth;
            if (orientation === (0, $e10a8602f56394e3$export$60faac65e31b0582)) divisionPixels = clientHeight;
            this.divisionPixels = divisionPixels;
        };
        this.divisionRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createRef();
    }
    componentDidMount() {
        const { name: name } = this.props;
        this.calcDivisionPixels();
        if (!name) return 0;
        const { width: width } = (0, (/*@__PURE__*/$parcel$interopDefault($9595af9b15fd4b76$exports)))(name, {
            font: '"Roboto", Helvetica, Arial, Tahoma, Verdana, sans-serif',
            fontSize: '16px',
            fontWeight: '500'
        });
        const NAME_OFFSET = 96;
        this.collapseThreshold = width + NAME_OFFSET;
    }
    componentDidUpdate() {
        this.calcDivisionPixels();
    }
    render() {
        const { render: render } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.containerClass,
            style: this.containerStyle,
            ref: this.divisionRef
        }, this.renderDragHandle, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.contentsClass,
            style: this.contentStyle
        }, this.renderHeader, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "threesizer--body"
        }, render(this.visibility, this.divisionPixels))));
    }
    get renderHeader() {
        const { name: name, headerButtons: headerButtons, menuOptions: menuOptions, orientation: orientation, onEqualize: onEqualize } = this.props;
        if (!name) return null;
        if (orientation === (0, $e10a8602f56394e3$export$13b6d0f939932bf6)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $31b462fa28d19bfc$export$2e2bcd8739ae039), {
            buttons: headerButtons,
            menuOptions: menuOptions,
            onEqualize: onEqualize,
            onMinimize: this.handleMinimize,
            onMaximize: this.handleMaximize
        });
    }
    get visibility() {
        if (this.props.size === 0) return 'hidden';
        return 'visible';
    }
    get title() {
        return 'Drag to resize.\nDouble click to expand.';
    }
    get contentStyle() {
        if (this.props.orientation === (0, $e10a8602f56394e3$export$60faac65e31b0582)) return {
            height: `calc(100% - ${this.handlePixels}px)`
        };
        return {
            width: `calc(100% - ${this.handlePixels}px)`
        };
    }
    get renderDragHandle() {
        const { draggable: draggable } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            style: this.handleStyle,
            title: this.title,
            draggable: draggable,
            onDragStart: this.drag,
            className: this.handleClass,
            onDoubleClick: this.handleDoubleClick
        }, this.renderDragHandleContents);
    }
    get renderDragHandleContents() {
        const { name: name, handlePixels: handlePixels, orientation: orientation, headerButtons: headerButtons, menuOptions: menuOptions, onEqualize: onEqualize } = this.props;
        if (!name) return;
        if (orientation === (0, $e10a8602f56394e3$export$60faac65e31b0582) && handlePixels >= (0, $e10a8602f56394e3$export$e84ffb9eaebc4480)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $31b462fa28d19bfc$export$2e2bcd8739ae039), {
            buttons: headerButtons,
            menuOptions: menuOptions,
            onEqualize: onEqualize,
            onMinimize: this.handleMinimize,
            onMaximize: this.handleMaximize,
            name: name
        });
        if (handlePixels >= (0, $e10a8602f56394e3$export$e84ffb9eaebc4480)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.titleClass
        }, name);
    }
    get handleStyle() {
        const { handleDisplay: display, orientation: orientation, handlePixels: handlePixels } = this.props;
        if (orientation === (0, $e10a8602f56394e3$export$60faac65e31b0582)) return {
            display: display,
            height: `${handlePixels}px`
        };
        return {
            display: display,
            width: `${handlePixels}px`
        };
    }
    get containerStyle() {
        const { style: style, orientation: orientation } = this.props;
        if (orientation === (0, $e10a8602f56394e3$export$60faac65e31b0582)) return {
            ...style,
            height: this.size
        };
        return {
            ...style,
            width: this.size
        };
    }
    get size() {
        const { size: size, offset: offset } = this.props;
        return `calc((100% - ${offset}px) * ${size} + ${this.handlePixels}px)`;
    }
    get handlePixels() {
        if (this.props.handleDisplay === 'none') return 0;
        return this.props.handlePixels;
    }
    get containerClass() {
        const { orientation: orientation, customClass: customClass } = this.props;
        const isAnyHandleBeingDragged = !!this.props.activeHandleID;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('threesizer--division', {
            dragging: isAnyHandleBeingDragged,
            vertical: orientation === (0, $e10a8602f56394e3$export$13b6d0f939932bf6),
            horizontal: orientation === (0, $e10a8602f56394e3$export$60faac65e31b0582),
            [customClass]: !!customClass
        });
    }
    get handleClass() {
        const { draggable: draggable, orientation: orientation, name: name } = this.props;
        const collapsed = orientation === (0, $e10a8602f56394e3$export$13b6d0f939932bf6) && this.isTitleObscured;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('threesizer--handle', {
            'threesizer--collapsed': collapsed,
            disabled: !draggable,
            dragging: this.isDragging,
            vertical: orientation === (0, $e10a8602f56394e3$export$13b6d0f939932bf6),
            horizontal: orientation === (0, $e10a8602f56394e3$export$60faac65e31b0582),
            named: name
        });
    }
    get contentsClass() {
        const { headerOrientation: headerOrientation, size: size } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))(`threesizer--contents ${headerOrientation}`, {
            'no-shadows': !size
        });
    }
    get titleClass() {
        const { orientation: orientation } = this.props;
        const collapsed = orientation === (0, $e10a8602f56394e3$export$13b6d0f939932bf6) && this.isTitleObscured;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('threesizer--title', {
            'threesizer--collapsed': collapsed,
            vertical: orientation === (0, $e10a8602f56394e3$export$13b6d0f939932bf6),
            horizontal: orientation === (0, $e10a8602f56394e3$export$60faac65e31b0582)
        });
    }
    get isTitleObscured() {
        if (this.props.size === 0) return true;
        if (!this.divisionRef.current || this.props.size >= 0.33) return false;
        const { width: width } = this.divisionRef.current.getBoundingClientRect();
        return width <= this.collapseThreshold;
    }
    get isDragging() {
        const { id: id, activeHandleID: activeHandleID } = this.props;
        return id === activeHandleID;
    }
}
var $1f7189bf20c9785f$export$2e2bcd8739ae039 = $1f7189bf20c9785f$var$Division;





const $71205b63ef953f49$var$initialDragEvent = {
    percentX: 0,
    percentY: 0,
    mouseX: null,
    mouseY: null
};
class $71205b63ef953f49$var$Threesizer extends (0, $NdCUR.PureComponent) {
    static{
        this.defaultProps = {
            orientation: (0, $e10a8602f56394e3$export$60faac65e31b0582),
            containerClass: ''
        };
    }
    constructor(props){
        super(props), this.debouncer = new (0, $075f3b99bb3716e4$export$2e2bcd8739ae039)(), this.handleResize = ()=>{
            this.debouncer.call(this.handleResizeImmediate, 100);
        }, this.handleResizeImmediate = ()=>{
            const { onResize: onResize } = this.props;
            if (!onResize) return;
            onResize(this.state.divisions.map((d)=>d.size));
        }, this.handleDoubleClick = (id)=>{
            const clickedDiv = this.state.divisions.find((d)=>d.id === id);
            if (!clickedDiv) return;
            const isMaxed = clickedDiv.size === 1;
            if (isMaxed) return this.equalize();
            const divisionSizes = this.state.divisions.map((d)=>{
                if (d.id !== id) return 0;
                return 1;
            });
            this.props.onResize(divisionSizes);
        }, this.handleMaximize = (id)=>{
            const maxDiv = this.state.divisions.find((d)=>d.id === id);
            if (!maxDiv) return;
            const divisionSizes = this.state.divisions.map((d)=>{
                if (d.id !== id) return 0;
                return 1;
            });
            this.props.onResize(divisionSizes);
        }, this.handleMinimize = (id)=>{
            const minDiv = this.state.divisions.find((d)=>d.id === id);
            const numDivisions = this.state.divisions.length;
            if (!minDiv) return;
            let size;
            if (numDivisions <= 1) size = 1;
            else size = 1 / (this.state.divisions.length - 1);
            const divisionSizes = this.state.divisions.map((d)=>{
                if (d.id !== id) return size;
                return 0;
            });
            this.props.onResize(divisionSizes);
        }, this.equalize = ()=>{
            const denominator = this.state.divisions.length;
            const divisionSizes = this.state.divisions.map(()=>{
                return 1 / denominator;
            });
            this.props.onResize(divisionSizes);
        }, this.handleStartDrag = (activeHandleID, e)=>{
            const dragEvent = this.mousePosWithinContainer(e);
            this.setState({
                activeHandleID: activeHandleID,
                dragEvent: dragEvent
            });
        }, this.handleStopDrag = ()=>{
            if (this.state.activeHandleID) this.setState({
                activeHandleID: '',
                dragEvent: $71205b63ef953f49$var$initialDragEvent
            });
        }, this.mousePosWithinContainer = (e)=>{
            const { pageY: pageY, pageX: pageX } = e;
            const { top: top, left: left, width: width, height: height } = this.containerRef.getBoundingClientRect();
            const mouseX = pageX - left;
            const mouseY = pageY - top;
            const percentX = mouseX / width;
            const percentY = mouseY / height;
            return {
                mouseX: mouseX,
                mouseY: mouseY,
                percentX: percentX,
                percentY: percentY
            };
        }, this.percentChange = (startValue, endValue)=>{
            if (!startValue || !endValue) return 0;
            const delta = Math.abs(startValue - endValue);
            return delta;
        }, this.handleDrag = (e)=>{
            const { activeHandleID: activeHandleID } = this.state;
            if (!activeHandleID) return;
            const dragEvent = this.mousePosWithinContainer(e);
            this.setState({
                dragEvent: dragEvent
            });
        }, this.up = (activePosition)=>()=>{
                const divisionSizes = this.state.divisions.map((d, i)=>{
                    if (!activePosition) return d.size;
                    const first = i === 0;
                    const before = i === activePosition - 1;
                    const current = i === activePosition;
                    if (first && !before) {
                        const second = this.state.divisions[1];
                        if (second && second.size === 0) return this.shorter(d.size);
                        return d.size;
                    }
                    if (before) return this.shorter(d.size);
                    if (current) return this.taller(d.size);
                    return d.size;
                });
                this.props.onResize(divisionSizes);
            }, this.left = (activePosition)=>()=>{
                const divisionSizes = this.state.divisions.map((d, i)=>{
                    if (!activePosition) return d.size;
                    const first = i === 0;
                    const before = i === activePosition - 1;
                    const active = i === activePosition;
                    if (first && !before) {
                        const second = this.state.divisions[1];
                        if (second && second.size === 0) return this.thinner(d.size);
                        return d.size;
                    }
                    if (before) return this.thinner(d.size);
                    if (active) return this.fatter(d.size);
                    return d.size;
                });
                this.props.onResize(divisionSizes);
            }, this.taller = (size)=>{
            const newSize = size + this.percentChangeY;
            return this.enforceMax(newSize);
        }, this.fatter = (size)=>{
            const newSize = size + this.percentChangeX;
            return this.enforceMax(newSize);
        }, this.shorter = (size)=>{
            const newSize = size - this.percentChangeY;
            return this.enforceMin(newSize);
        }, this.thinner = (size)=>{
            const newSize = size - this.percentChangeX;
            return this.enforceMin(newSize);
        }, this.right = (activePosition)=>()=>{
                const divisionSizes = this.state.divisions.map((d, i, divs)=>{
                    const before = i === activePosition - 1;
                    const active = i === activePosition;
                    const after = i === activePosition + 1;
                    if (before) return this.fatter(d.size);
                    if (active) return this.thinner(d.size);
                    if (after) {
                        const leftIndex = i - 1;
                        const left = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(divs, leftIndex, {
                            size: 'none'
                        });
                        if (left && left.size === 0) return this.thinner(d.size);
                        return d.size;
                    }
                    return d.size;
                });
                this.props.onResize(divisionSizes);
            }, this.down = (activePosition)=>()=>{
                const divisionSizes = this.state.divisions.map((d, i, divs)=>{
                    const before = i === activePosition - 1;
                    const current = i === activePosition;
                    const after = i === activePosition + 1;
                    if (before) return this.taller(d.size);
                    if (current) return this.shorter(d.size);
                    if (after) {
                        const above = divs[i - 1];
                        if (above && above.size === 0) return this.shorter(d.size);
                        return d.size;
                    }
                    return d.size;
                });
                this.props.onResize(divisionSizes);
            }, this.enforceMax = (size)=>{
            return size > (0, $e10a8602f56394e3$export$2cc3c74b8f2f1a6c) ? (0, $e10a8602f56394e3$export$2cc3c74b8f2f1a6c) : size;
        }, this.enforceMin = (size)=>{
            return size < (0, $e10a8602f56394e3$export$47f68df2ff119ea5) ? (0, $e10a8602f56394e3$export$47f68df2ff119ea5) : size;
        };
        this.state = {
            activeHandleID: null,
            divisions: this.divisions,
            dragEvent: $71205b63ef953f49$var$initialDragEvent,
            dragDirection: ''
        };
    }
    componentDidMount() {
        document.addEventListener('mouseup', this.handleStopDrag);
        document.addEventListener('mouseleave', this.handleStopDrag);
    }
    componentWillUnmount() {
        document.removeEventListener('mouseup', this.handleStopDrag);
        document.removeEventListener('mouseleave', this.handleStopDrag);
    }
    componentDidUpdate(__, prevState) {
        const { dragEvent: dragEvent, divisions: divisions } = this.state;
        const { orientation: orientation } = this.props;
        const stateDivisionSizes = divisions.map((d)=>d.size);
        const propDivisionSizes = this.props.divisions.map((d)=>d.size);
        const updateDivisions = this.state.divisions.map((d, i)=>({
                ...d,
                size: this.props.divisions[i].size
            }));
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEqual(propDivisionSizes, stateDivisionSizes)) this.setState({
            divisions: updateDivisions
        });
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEqual(dragEvent, prevState.dragEvent)) return;
        this.percentChangeX = this.percentChange(prevState.dragEvent.percentX, dragEvent.percentX);
        this.percentChangeY = this.percentChange(prevState.dragEvent.percentY, dragEvent.percentY);
        const { percentX: percentX, percentY: percentY } = dragEvent;
        const { dragEvent: prevDrag } = prevState;
        if (orientation === (0, $e10a8602f56394e3$export$13b6d0f939932bf6) && percentX < prevDrag.percentX) this.move.left();
        else if (orientation === (0, $e10a8602f56394e3$export$13b6d0f939932bf6)) this.move.right();
        else if (percentY < prevDrag.percentY) this.move.up();
        else this.move.down();
        this.handleResize();
    }
    render() {
        const { activeHandleID: activeHandleID, divisions: divisions } = this.state;
        const { orientation: orientation } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.className,
            onMouseUp: this.handleStopDrag,
            onMouseMove: this.handleDrag,
            ref: (r)=>this.containerRef = r
        }, divisions.map((d, i)=>{
            const headerOrientation = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(d, 'headerOrientation', orientation);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1f7189bf20c9785f$export$2e2bcd8739ae039), {
                key: d.id,
                id: d.id,
                name: d.name,
                size: d.size,
                style: d.style,
                offset: this.offset,
                draggable: i > 0,
                customClass: d.customClass,
                orientation: orientation,
                handlePixels: d.handlePixels,
                handleDisplay: d.handleDisplay,
                activeHandleID: activeHandleID,
                onMaximize: this.handleMaximize,
                onMinimize: this.handleMinimize,
                onEqualize: this.equalize,
                headerOrientation: headerOrientation,
                onDoubleClick: this.handleDoubleClick,
                render: this.props.divisions[i].render,
                onHandleStartDrag: this.handleStartDrag,
                menuOptions: this.props.divisions[i].menuOptions,
                headerButtons: this.props.divisions[i].headerButtons
            });
        }));
    }
    get offset() {
        const handlesPixelCount = this.state.divisions.reduce((acc, d)=>{
            if (d.handleDisplay === (0, $e10a8602f56394e3$export$fd882954907eaf33)) return acc;
            return acc + d.handlePixels;
        }, 0);
        return handlesPixelCount;
    }
    get className() {
        const { orientation: orientation, containerClass: containerClass } = this.props;
        const { activeHandleID: activeHandleID } = this.state;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))(`threesizer ${containerClass}`, {
            dragging: activeHandleID,
            horizontal: orientation === (0, $e10a8602f56394e3$export$60faac65e31b0582),
            vertical: orientation === (0, $e10a8602f56394e3$export$13b6d0f939932bf6)
        });
    }
    get divisions() {
        const { divisions: divisions } = this.props;
        const defaultSize = 1 / divisions.length;
        return divisions.map((d)=>{
            let size = defaultSize;
            if (d.size || d.size === 0) size = d.size;
            return {
                ...d,
                id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
                size: size,
                handlePixels: d.handlePixels || (0, $e10a8602f56394e3$export$4d35c276e962a435)
            };
        });
    }
    get move() {
        const { activeHandleID: activeHandleID } = this.state;
        const activePosition = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).findIndex(this.state.divisions, (d)=>d.id === activeHandleID);
        return {
            up: this.up(activePosition),
            down: this.down(activePosition),
            left: this.left(activePosition),
            right: this.right(activePosition)
        };
    }
}
var $71205b63ef953f49$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($71205b63ef953f49$var$Threesizer);


// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");

var $NdCUR = parcelRequire("NdCUR");
const $8b94d8adf97500e0$var$EmptyQueryState = ({ onAddQuery: onAddQuery })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "query-maker--empty"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h5", null, "This Graph has no Queries"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "btn btn-primary",
        onClick: onAddQuery,
        "data-test": "add-query--button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        className: "icon plus"
    }), " Add a Query"));
var $8b94d8adf97500e0$export$2e2bcd8739ae039 = $8b94d8adf97500e0$var$EmptyQueryState;



var $NdCUR = parcelRequire("NdCUR");

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");

class $b039b81823623a3b$var$QueryMakerTab extends (0, $NdCUR.PureComponent) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('query-maker--tab', {
                active: this.props.isActive
            }),
            onClick: this.handleSelect
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", null, this.props.queryTabText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "query-maker--delete",
            onClick: this.handleDelete,
            "data-test": "query-maker-delete"
        }));
    }
    constructor(...args){
        super(...args), this.handleSelect = ()=>{
            this.props.onSelect(this.props.queryIndex);
        }, this.handleDelete = (e)=>{
            e.stopPropagation();
            this.props.onDelete(this.props.queryIndex);
        };
    }
}
var $b039b81823623a3b$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($b039b81823623a3b$var$QueryMakerTab);




class $857ada34c8644d6d$export$2e2bcd8739ae039 extends (0, $NdCUR.PureComponent) {
    render() {
        const { queries: queries, onAddQuery: onAddQuery, onDeleteQuery: onDeleteQuery, activeQueryIndex: activeQueryIndex, setActiveQueryIndex: setActiveQueryIndex } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "query-maker--tabs"
        }, queries.map((q, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b039b81823623a3b$export$2e2bcd8739ae039), {
                key: i,
                isActive: i === activeQueryIndex,
                query: q,
                onSelect: setActiveQueryIndex,
                onDelete: onDeleteQuery,
                queryTabText: this.queryTabText(i, q),
                queryIndex: i
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
            size: (0, $918c9f03a35fe03f$export$fafce5c139da9687).ExtraSmall,
            color: (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Primary,
            customClass: "query-maker--new",
            icon: (0, $918c9f03a35fe03f$export$62c9c0cf752cde38).PlusSkinny,
            onClick: onAddQuery,
            shape: (0, $918c9f03a35fe03f$export$ce765fb8bb08a599).Square
        }));
    }
    constructor(...args){
        super(...args), this.queryTabText = (i, query)=>{
            const { timeRange: timeRange } = this.props;
            return query.rawText || (0, $7b2c5b24a44a7fa2$export$2e2bcd8739ae039)(timeRange, query) || `Query ${i + 1}`;
        };
    }
}


// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");

var $1v7mg = parcelRequire("1v7mg");
// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");

var $hBdgJ = parcelRequire("hBdgJ");
var $b1cb9a1ab496dfeb$exports = {};
'use strict';
function $b1cb9a1ab496dfeb$var$_extends() {
    $b1cb9a1ab496dfeb$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b1cb9a1ab496dfeb$var$_extends.apply(this, arguments);
}
function $b1cb9a1ab496dfeb$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $b1cb9a1ab496dfeb$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $b1cb9a1ab496dfeb$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $b1cb9a1ab496dfeb$var$_typeof(obj);
}
var $b1cb9a1ab496dfeb$var$__extends = function() {
    var _extendStatics = function extendStatics(d, b) {
        _extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return _extendStatics(d, b);
    };
    return function(d, b) {
        _extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($b1cb9a1ab496dfeb$exports, '__esModule', {
    value: true
});
$b1cb9a1ab496dfeb$exports.UnControlled = $b1cb9a1ab496dfeb$exports.Controlled = void 0;

var $NdCUR = parcelRequire("NdCUR");
var $b1cb9a1ab496dfeb$var$SERVER_RENDERED = typeof navigator === 'undefined' || $parcel$global['PREVENT_CODEMIRROR_RENDER'] === true;
var $b1cb9a1ab496dfeb$var$cm;

if (!$b1cb9a1ab496dfeb$var$SERVER_RENDERED) $b1cb9a1ab496dfeb$var$cm = (parcelRequire("4csXa"));
var $b1cb9a1ab496dfeb$var$Helper = function() {
    function Helper() {}
    Helper.equals = function(x, y) {
        var _this = this;
        var ok = Object.keys, tx = $b1cb9a1ab496dfeb$var$_typeof(x), ty = $b1cb9a1ab496dfeb$var$_typeof(y);
        return x && y && tx === 'object' && tx === ty ? ok(x).length === ok(y).length && ok(x).every(function(key) {
            return _this.equals(x[key], y[key]);
        }) : x === y;
    };
    return Helper;
}();
var $b1cb9a1ab496dfeb$var$Shared = function() {
    function Shared(editor, props) {
        this.editor = editor;
        this.props = props;
    }
    Shared.prototype.delegateCursor = function(position, scroll, focus) {
        var doc = this.editor.getDoc();
        if (focus) this.editor.focus();
        scroll ? doc.setCursor(position) : doc.setCursor(position, null, {
            scroll: false
        });
    };
    Shared.prototype.delegateScroll = function(coordinates) {
        this.editor.scrollTo(coordinates.x, coordinates.y);
    };
    Shared.prototype.delegateSelection = function(ranges, focus) {
        var doc = this.editor.getDoc();
        doc.setSelections(ranges);
        if (focus) this.editor.focus();
    };
    Shared.prototype.apply = function(props) {
        if (props && props.selection && props.selection.ranges) this.delegateSelection(props.selection.ranges, props.selection.focus || false);
        if (props && props.cursor) this.delegateCursor(props.cursor, props.autoScroll || false, this.editor.getOption('autofocus') || false);
        if (props && props.scroll) this.delegateScroll(props.scroll);
    };
    Shared.prototype.applyNext = function(props, next, preserved) {
        if (props && props.selection && props.selection.ranges) {
            if (next && next.selection && next.selection.ranges && !$b1cb9a1ab496dfeb$var$Helper.equals(props.selection.ranges, next.selection.ranges)) this.delegateSelection(next.selection.ranges, next.selection.focus || false);
        }
        if (props && props.cursor) {
            if (next && next.cursor && !$b1cb9a1ab496dfeb$var$Helper.equals(props.cursor, next.cursor)) this.delegateCursor(preserved.cursor || next.cursor, next.autoScroll || false, next.autoCursor || false);
        }
        if (props && props.scroll) {
            if (next && next.scroll && !$b1cb9a1ab496dfeb$var$Helper.equals(props.scroll, next.scroll)) this.delegateScroll(next.scroll);
        }
    };
    Shared.prototype.applyUserDefined = function(props, preserved) {
        if (preserved && preserved.cursor) this.delegateCursor(preserved.cursor, props.autoScroll || false, this.editor.getOption('autofocus') || false);
    };
    Shared.prototype.wire = function(props) {
        var _this = this;
        Object.keys(props || {}).filter(function(p) {
            return /^on/.test(p);
        }).forEach(function(prop) {
            switch(prop){
                case 'onBlur':
                    _this.editor.on('blur', function(cm, event) {
                        _this.props.onBlur(_this.editor, event);
                    });
                    break;
                case 'onContextMenu':
                    _this.editor.on('contextmenu', function(cm, event) {
                        _this.props.onContextMenu(_this.editor, event);
                    });
                    break;
                case 'onCopy':
                    _this.editor.on('copy', function(cm, event) {
                        _this.props.onCopy(_this.editor, event);
                    });
                    break;
                case 'onCursor':
                    _this.editor.on('cursorActivity', function(cm) {
                        _this.props.onCursor(_this.editor, _this.editor.getDoc().getCursor());
                    });
                    break;
                case 'onCursorActivity':
                    _this.editor.on('cursorActivity', function(cm) {
                        _this.props.onCursorActivity(_this.editor);
                    });
                    break;
                case 'onCut':
                    _this.editor.on('cut', function(cm, event) {
                        _this.props.onCut(_this.editor, event);
                    });
                    break;
                case 'onDblClick':
                    _this.editor.on('dblclick', function(cm, event) {
                        _this.props.onDblClick(_this.editor, event);
                    });
                    break;
                case 'onDragEnter':
                    _this.editor.on('dragenter', function(cm, event) {
                        _this.props.onDragEnter(_this.editor, event);
                    });
                    break;
                case 'onDragLeave':
                    _this.editor.on('dragleave', function(cm, event) {
                        _this.props.onDragLeave(_this.editor, event);
                    });
                    break;
                case 'onDragOver':
                    _this.editor.on('dragover', function(cm, event) {
                        _this.props.onDragOver(_this.editor, event);
                    });
                    break;
                case 'onDragStart':
                    _this.editor.on('dragstart', function(cm, event) {
                        _this.props.onDragStart(_this.editor, event);
                    });
                    break;
                case 'onDrop':
                    _this.editor.on('drop', function(cm, event) {
                        _this.props.onDrop(_this.editor, event);
                    });
                    break;
                case 'onFocus':
                    _this.editor.on('focus', function(cm, event) {
                        _this.props.onFocus(_this.editor, event);
                    });
                    break;
                case 'onGutterClick':
                    _this.editor.on('gutterClick', function(cm, lineNumber, gutter, event) {
                        _this.props.onGutterClick(_this.editor, lineNumber, gutter, event);
                    });
                    break;
                case 'onInputRead':
                    _this.editor.on('inputRead', function(cm, EditorChangeEvent) {
                        _this.props.onInputRead(_this.editor, EditorChangeEvent);
                    });
                    break;
                case 'onKeyDown':
                    _this.editor.on('keydown', function(cm, event) {
                        _this.props.onKeyDown(_this.editor, event);
                    });
                    break;
                case 'onKeyHandled':
                    _this.editor.on('keyHandled', function(cm, key, event) {
                        _this.props.onKeyHandled(_this.editor, key, event);
                    });
                    break;
                case 'onKeyPress':
                    _this.editor.on('keypress', function(cm, event) {
                        _this.props.onKeyPress(_this.editor, event);
                    });
                    break;
                case 'onKeyUp':
                    _this.editor.on('keyup', function(cm, event) {
                        _this.props.onKeyUp(_this.editor, event);
                    });
                    break;
                case 'onMouseDown':
                    _this.editor.on('mousedown', function(cm, event) {
                        _this.props.onMouseDown(_this.editor, event);
                    });
                    break;
                case 'onPaste':
                    _this.editor.on('paste', function(cm, event) {
                        _this.props.onPaste(_this.editor, event);
                    });
                    break;
                case 'onRenderLine':
                    _this.editor.on('renderLine', function(cm, line, element) {
                        _this.props.onRenderLine(_this.editor, line, element);
                    });
                    break;
                case 'onScroll':
                    _this.editor.on('scroll', function(cm) {
                        _this.props.onScroll(_this.editor, _this.editor.getScrollInfo());
                    });
                    break;
                case 'onSelection':
                    _this.editor.on('beforeSelectionChange', function(cm, data) {
                        _this.props.onSelection(_this.editor, data);
                    });
                    break;
                case 'onTouchStart':
                    _this.editor.on('touchstart', function(cm, event) {
                        _this.props.onTouchStart(_this.editor, event);
                    });
                    break;
                case 'onUpdate':
                    _this.editor.on('update', function(cm) {
                        _this.props.onUpdate(_this.editor);
                    });
                    break;
                case 'onViewportChange':
                    _this.editor.on('viewportChange', function(cm, from, to) {
                        _this.props.onViewportChange(_this.editor, from, to);
                    });
                    break;
            }
        });
    };
    return Shared;
}();
var $b1cb9a1ab496dfeb$var$Controlled = function(_super) {
    $b1cb9a1ab496dfeb$var$__extends(Controlled, _super);
    function Controlled(props) {
        var _this = _super.call(this, props) || this;
        if ($b1cb9a1ab496dfeb$var$SERVER_RENDERED) return _this;
        _this.applied = false;
        _this.appliedNext = false;
        _this.appliedUserDefined = false;
        _this.deferred = null;
        _this.emulating = false;
        _this.hydrated = false;
        _this.initCb = function() {
            if (_this.props.editorDidConfigure) _this.props.editorDidConfigure(_this.editor);
        };
        _this.mounted = false;
        return _this;
    }
    Controlled.prototype.hydrate = function(props) {
        var _this = this;
        var _options = props && props.options ? props.options : {};
        var userDefinedOptions = $b1cb9a1ab496dfeb$var$_extends({}, $b1cb9a1ab496dfeb$var$cm.defaults, this.editor.options, _options);
        var optionDelta = Object.keys(userDefinedOptions).some(function(key) {
            return _this.editor.getOption(key) !== userDefinedOptions[key];
        });
        if (optionDelta) Object.keys(userDefinedOptions).forEach(function(key) {
            if (_options.hasOwnProperty(key)) {
                if (_this.editor.getOption(key) !== userDefinedOptions[key]) {
                    _this.editor.setOption(key, userDefinedOptions[key]);
                    _this.mirror.setOption(key, userDefinedOptions[key]);
                }
            }
        });
        if (!this.hydrated) this.deferred ? this.resolveChange(props.value) : this.initChange(props.value || '');
        this.hydrated = true;
    };
    Controlled.prototype.initChange = function(value) {
        this.emulating = true;
        var doc = this.editor.getDoc();
        var lastLine = doc.lastLine();
        var lastChar = doc.getLine(doc.lastLine()).length;
        doc.replaceRange(value || '', {
            line: 0,
            ch: 0
        }, {
            line: lastLine,
            ch: lastChar
        });
        this.mirror.setValue(value);
        doc.clearHistory();
        this.mirror.clearHistory();
        this.emulating = false;
    };
    Controlled.prototype.resolveChange = function(value) {
        this.emulating = true;
        var doc = this.editor.getDoc();
        if (this.deferred.origin === 'undo') doc.undo();
        else if (this.deferred.origin === 'redo') doc.redo();
        else doc.replaceRange(this.deferred.text, this.deferred.from, this.deferred.to, this.deferred.origin);
        if (value && value !== doc.getValue()) {
            var cursor = doc.getCursor();
            doc.setValue(value);
            doc.setCursor(cursor);
        }
        this.emulating = false;
        this.deferred = null;
    };
    Controlled.prototype.mirrorChange = function(deferred) {
        var doc = this.editor.getDoc();
        if (deferred.origin === 'undo') {
            doc.setHistory(this.mirror.getHistory());
            this.mirror.undo();
        } else if (deferred.origin === 'redo') {
            doc.setHistory(this.mirror.getHistory());
            this.mirror.redo();
        } else this.mirror.replaceRange(deferred.text, deferred.from, deferred.to, deferred.origin);
        return this.mirror.getValue();
    };
    Controlled.prototype.componentDidMount = function() {
        var _this = this;
        if ($b1cb9a1ab496dfeb$var$SERVER_RENDERED) return;
        if (this.props.defineMode) {
            if (this.props.defineMode.name && this.props.defineMode.fn) $b1cb9a1ab496dfeb$var$cm.defineMode(this.props.defineMode.name, this.props.defineMode.fn);
        }
        this.editor = $b1cb9a1ab496dfeb$var$cm(this.ref, this.props.options);
        this.shared = new $b1cb9a1ab496dfeb$var$Shared(this.editor, this.props);
        this.mirror = $b1cb9a1ab496dfeb$var$cm(function() {}, this.props.options);
        this.editor.on('electricInput', function() {
            _this.mirror.setHistory(_this.editor.getDoc().getHistory());
        });
        this.editor.on('cursorActivity', function() {
            _this.mirror.setCursor(_this.editor.getDoc().getCursor());
        });
        this.editor.on('beforeChange', function(cm, data) {
            if (_this.emulating) return;
            data.cancel();
            _this.deferred = data;
            var phantomChange = _this.mirrorChange(_this.deferred);
            if (_this.props.onBeforeChange) _this.props.onBeforeChange(_this.editor, _this.deferred, phantomChange);
        });
        this.editor.on('change', function(cm, data) {
            if (!_this.mounted) return;
            if (_this.props.onChange) _this.props.onChange(_this.editor, data, _this.editor.getValue());
        });
        this.hydrate(this.props);
        this.shared.apply(this.props);
        this.applied = true;
        this.mounted = true;
        this.shared.wire(this.props);
        if (this.editor.getOption('autofocus')) this.editor.focus();
        if (this.props.editorDidMount) this.props.editorDidMount(this.editor, this.editor.getValue(), this.initCb);
    };
    Controlled.prototype.componentDidUpdate = function(prevProps) {
        if ($b1cb9a1ab496dfeb$var$SERVER_RENDERED) return;
        var preserved = {
            cursor: null
        };
        if (this.props.value !== prevProps.value) this.hydrated = false;
        if (!this.props.autoCursor && this.props.autoCursor !== undefined) preserved.cursor = this.editor.getDoc().getCursor();
        this.hydrate(this.props);
        if (!this.appliedNext) {
            this.shared.applyNext(prevProps, this.props, preserved);
            this.appliedNext = true;
        }
        this.shared.applyUserDefined(prevProps, preserved);
        this.appliedUserDefined = true;
    };
    Controlled.prototype.componentWillUnmount = function() {
        if ($b1cb9a1ab496dfeb$var$SERVER_RENDERED) return;
        if (this.props.editorWillUnmount) this.props.editorWillUnmount($b1cb9a1ab496dfeb$var$cm);
    };
    Controlled.prototype.shouldComponentUpdate = function(nextProps, nextState) {
        return !$b1cb9a1ab496dfeb$var$SERVER_RENDERED;
    };
    Controlled.prototype.render = function() {
        var _this = this;
        if ($b1cb9a1ab496dfeb$var$SERVER_RENDERED) return null;
        var className = this.props.className ? 'react-codemirror2 ' + this.props.className : 'react-codemirror2';
        return $NdCUR.createElement('div', {
            className: className,
            ref: function ref(self) {
                return _this.ref = self;
            }
        });
    };
    return Controlled;
}($NdCUR.Component);
$b1cb9a1ab496dfeb$exports.Controlled = $b1cb9a1ab496dfeb$var$Controlled;
var $b1cb9a1ab496dfeb$var$UnControlled = function(_super) {
    $b1cb9a1ab496dfeb$var$__extends(UnControlled, _super);
    function UnControlled(props) {
        var _this = _super.call(this, props) || this;
        if ($b1cb9a1ab496dfeb$var$SERVER_RENDERED) return _this;
        _this.applied = false;
        _this.appliedUserDefined = false;
        _this.continueChange = false;
        _this.detached = false;
        _this.hydrated = false;
        _this.initCb = function() {
            if (_this.props.editorDidConfigure) _this.props.editorDidConfigure(_this.editor);
        };
        _this.mounted = false;
        _this.onBeforeChangeCb = function() {
            _this.continueChange = true;
        };
        return _this;
    }
    UnControlled.prototype.hydrate = function(props) {
        var _this = this;
        var _options = props && props.options ? props.options : {};
        var userDefinedOptions = $b1cb9a1ab496dfeb$var$_extends({}, $b1cb9a1ab496dfeb$var$cm.defaults, this.editor.options, _options);
        var optionDelta = Object.keys(userDefinedOptions).some(function(key) {
            return _this.editor.getOption(key) !== userDefinedOptions[key];
        });
        if (optionDelta) Object.keys(userDefinedOptions).forEach(function(key) {
            if (_options.hasOwnProperty(key)) {
                if (_this.editor.getOption(key) !== userDefinedOptions[key]) _this.editor.setOption(key, userDefinedOptions[key]);
            }
        });
        if (!this.hydrated) {
            var doc = this.editor.getDoc();
            var lastLine = doc.lastLine();
            var lastChar = doc.getLine(doc.lastLine()).length;
            doc.replaceRange(props.value || '', {
                line: 0,
                ch: 0
            }, {
                line: lastLine,
                ch: lastChar
            });
        }
        this.hydrated = true;
    };
    UnControlled.prototype.componentDidMount = function() {
        var _this = this;
        if ($b1cb9a1ab496dfeb$var$SERVER_RENDERED) return;
        this.detached = this.props.detach === true;
        if (this.props.defineMode) {
            if (this.props.defineMode.name && this.props.defineMode.fn) $b1cb9a1ab496dfeb$var$cm.defineMode(this.props.defineMode.name, this.props.defineMode.fn);
        }
        this.editor = $b1cb9a1ab496dfeb$var$cm(this.ref, this.props.options);
        this.shared = new $b1cb9a1ab496dfeb$var$Shared(this.editor, this.props);
        this.editor.on('beforeChange', function(cm, data) {
            if (_this.props.onBeforeChange) _this.props.onBeforeChange(_this.editor, data, _this.editor.getValue(), _this.onBeforeChangeCb);
        });
        this.editor.on('change', function(cm, data) {
            if (!_this.mounted || !_this.props.onChange) return;
            if (_this.props.onBeforeChange) {
                if (_this.continueChange) _this.props.onChange(_this.editor, data, _this.editor.getValue());
            } else _this.props.onChange(_this.editor, data, _this.editor.getValue());
        });
        this.hydrate(this.props);
        this.shared.apply(this.props);
        this.applied = true;
        this.mounted = true;
        this.shared.wire(this.props);
        this.editor.getDoc().clearHistory();
        if (this.props.editorDidMount) this.props.editorDidMount(this.editor, this.editor.getValue(), this.initCb);
    };
    UnControlled.prototype.componentDidUpdate = function(prevProps) {
        if (this.detached && this.props.detach === false) {
            this.detached = false;
            if (prevProps.editorDidAttach) prevProps.editorDidAttach(this.editor);
        }
        if (!this.detached && this.props.detach === true) {
            this.detached = true;
            if (prevProps.editorDidDetach) prevProps.editorDidDetach(this.editor);
        }
        if ($b1cb9a1ab496dfeb$var$SERVER_RENDERED || this.detached) return;
        var preserved = {
            cursor: null
        };
        if (this.props.value !== prevProps.value) {
            this.hydrated = false;
            this.applied = false;
            this.appliedUserDefined = false;
        }
        if (!prevProps.autoCursor && prevProps.autoCursor !== undefined) preserved.cursor = this.editor.getDoc().getCursor();
        this.hydrate(this.props);
        if (!this.applied) {
            this.shared.apply(prevProps);
            this.applied = true;
        }
        if (!this.appliedUserDefined) {
            this.shared.applyUserDefined(prevProps, preserved);
            this.appliedUserDefined = true;
        }
    };
    UnControlled.prototype.componentWillUnmount = function() {
        if ($b1cb9a1ab496dfeb$var$SERVER_RENDERED) return;
        if (this.props.editorWillUnmount) this.props.editorWillUnmount($b1cb9a1ab496dfeb$var$cm);
    };
    UnControlled.prototype.shouldComponentUpdate = function(nextProps, nextState) {
        var update = true;
        if ($b1cb9a1ab496dfeb$var$SERVER_RENDERED) update = false;
        if (this.detached && nextProps.detach) update = false;
        return update;
    };
    UnControlled.prototype.render = function() {
        var _this = this;
        if ($b1cb9a1ab496dfeb$var$SERVER_RENDERED) return null;
        var className = this.props.className ? 'react-codemirror2 ' + this.props.className : 'react-codemirror2';
        return $NdCUR.createElement('div', {
            className: className,
            ref: function ref(self) {
                return _this.ref = self;
            }
        });
    };
    return UnControlled;
}($NdCUR.Component);
$b1cb9a1ab496dfeb$exports.UnControlled = $b1cb9a1ab496dfeb$var$UnControlled;



const $4af725ed5f546b55$export$b134a65f91c63512 = (title, tempVar)=>{
    const marker = document.createElement('span');
    const replacementText = document.createTextNode(`${tempVar}`);
    marker.setAttribute('title', title);
    marker.appendChild(replacementText);
    marker.classList.add('cm-temp-var');
    return marker;
};






const $e2ed7e2fe3751fa0$var$CODE_MIRROR_OPTIONS = {
    tabindex: 1,
    mode: 'influxQL',
    readOnly: false,
    lineNumbers: false,
    theme: 'influxql',
    lineWrapping: true,
    autofocus: true
};
var $e2ed7e2fe3751fa0$var$SelectionDirection = /*#__PURE__*/ function(SelectionDirection) {
    SelectionDirection[SelectionDirection["Missing"] = 0] = "Missing";
    SelectionDirection[SelectionDirection["Next"] = 1] = "Next";
    SelectionDirection[SelectionDirection["Previous"] = 2] = "Previous";
    return SelectionDirection;
}($e2ed7e2fe3751fa0$var$SelectionDirection || {});
const $e2ed7e2fe3751fa0$var$NOOP = ()=>{};
const $e2ed7e2fe3751fa0$var$TEMPLATE_TYPES = [
    'temp-system',
    'temp-var'
];
class $e2ed7e2fe3751fa0$var$ReactCodeMirror extends (0, $NdCUR.PureComponent) {
    render() {
        const { value: value, onFocus: onFocus, onBlur: onBlur } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.queryCodeClassName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b1cb9a1ab496dfeb$exports.Controlled), {
            autoCursor: true,
            options: this.options,
            onTouchStart: $e2ed7e2fe3751fa0$var$NOOP,
            value: value,
            onChange: this.handleChange,
            onFocus: onFocus,
            onBlur: onBlur,
            onKeyDown: this.handleKeyDownEditor,
            editorWillUnmount: this.handleUnmountEditor,
            editorDidMount: this.handleMountEditor,
            onBeforeChange: this.handleBeforeChange
        }));
    }
    componentDidUpdate(prevProps) {
        if (this.props.isShowingTemplateValues !== prevProps.isShowingTemplateValues) {
            if (this.props.isShowingTemplateValues) this.showTemplateValues();
            else this.hideTemplateValues();
        }
        if (this.props.focused && this.editor && !this.editor.hasFocus()) this.focusEditor();
    }
    focusEditor() {
        this.props.onFocus();
        this.editor.focus();
    }
    get options() {
        const { readOnly: readOnly } = this.props;
        return {
            ...$e2ed7e2fe3751fa0$var$CODE_MIRROR_OPTIONS,
            readOnly: readOnly,
            theme: readOnly ? 'influxql-read-only' : $e2ed7e2fe3751fa0$var$CODE_MIRROR_OPTIONS.theme,
            mode: readOnly ? 'influxQLReadOnly' : $e2ed7e2fe3751fa0$var$CODE_MIRROR_OPTIONS.mode
        };
    }
    get queryCodeClassName() {
        const { focused: focused, readOnly: readOnly } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('query-editor--code', {
            focus: focused,
            'read-only': readOnly
        });
    }
    hideTemplateValues() {
        const { markers: markers } = this.state;
        markers.forEach((m)=>{
            m.clear();
        });
        this.setState({
            markers: []
        });
    }
    findTempVar(selection) {
        const { filteredTemplates: templates, selectedTemplate: selectedTemplate } = this.props;
        const i = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).findIndex(templates, selectedTemplate);
        const length = templates.length;
        if (i === -1) selection = 0;
        switch(selection){
            case 1:
                return templates[(i + 1) % length];
            case 2:
                return templates[(i - 1 + length) % length];
            default:
                return templates[0];
        }
    }
    getTemplateTokens() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).flatten(this.editorTokens).filter((t)=>$e2ed7e2fe3751fa0$var$TEMPLATE_TYPES.includes(t.type));
    }
    get editorTokens() {
        if (!this.editor) return;
        const lineCount = this.editor.getDoc().lineCount();
        return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).times(lineCount, (line)=>{
            const tokens = this.editor.getLineTokens(line);
            const editorTokens = tokens.map((token)=>({
                    ...token,
                    start: {
                        line: line,
                        ch: token.start
                    },
                    end: {
                        line: line,
                        ch: token.end
                    }
                }));
            return editorTokens;
        });
    }
    getTemplateSelection(maskedText, newTempVar, replaceWholeTemplate) {
        // unicode safe template start index lookup
        const startIndex = Array.from(maskedText).indexOf(':');
        const position = this.editor.getDoc().posFromIndex(startIndex);
        const enterModifier = replaceWholeTemplate ? 1 : 0;
        const charStart = 1 + startIndex;
        const tempVarLength = newTempVar.length - 1 + enterModifier;
        const end = {
            line: position.line,
            ch: charStart + tempVarLength
        };
        let start = end;
        if (!replaceWholeTemplate) start = {
            line: position.line,
            ch: charStart
        };
        return {
            start: start,
            end: end
        };
    }
    constructor(...args){
        super(...args), this.handleTemplateReplace = (selectedTemplate, replaceWholeTemplate)=>{
            if (!selectedTemplate) return;
            const { value: value } = this.props;
            const { tempVar: tempVar } = selectedTemplate;
            const newTempVar = replaceWholeTemplate ? tempVar : tempVar.substring(0, tempVar.length - 1);
            // mask matches that will confuse our regex
            const masked = (0, $a3b88d5d27f00a75$export$e7629fcc9135ebfc)(value);
            let templatedQueryText;
            templatedQueryText = (0, $a3b88d5d27f00a75$export$2c98bf544dbe1480)(masked, newTempVar);
            templatedQueryText = (0, $a3b88d5d27f00a75$export$43b143dc77822220)(templatedQueryText);
            this.props.onTemplateSelection(selectedTemplate, templatedQueryText);
            const selection = this.getTemplateSelection(masked, newTempVar, replaceWholeTemplate);
            if (this.editor) this.editor.getDoc().setSelection(selection.end, selection.start);
        }, this.handleMountEditor = (editor)=>{
            this.editor = editor;
        }, this.handleUnmountEditor = ()=>{
            this.editor = null;
        }, this.handleBeforeChange = (__, ___, value)=>{
            this.props.onBeforeChange(value);
        }, this.handleChange = (__, ___, value)=>{
            this.props.onChange(value);
        }, this.handleKeyDownEditor = (__, e)=>{
            this.handleTemplatingKeys(e);
            this.props.onKeyDown(e);
        }, this.showTemplateValues = async ()=>{
            const markers = await this.replaceTemplateTokens();
            this.setState({
                markers: markers
            });
            if (this.editor) this.editor.focus();
        }, this.handleTemplatingKeys = (e)=>{
            const { isTemplating: isTemplating } = this.props;
            if (isTemplating) switch(e.key){
                case 'Tab':
                case 'ArrowRight':
                case 'ArrowDown':
                    e.preventDefault();
                    return this.handleTemplateReplace(this.findTempVar(1), false);
                case 'ArrowLeft':
                case 'ArrowUp':
                    e.preventDefault();
                    return this.handleTemplateReplace(this.findTempVar(2), false);
                case 'Enter':
                    e.preventDefault();
                    this.handleTemplateReplace(this.props.selectedTemplate, true);
            }
        }, this.replaceTemplateTokens = async ()=>{
            if (!this.editor) return;
            const { templates: templates } = this.props;
            const allTokens = this.getTemplateTokens();
            const [intervalTokens, otherTokens] = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).partition(allTokens, (t)=>t.string === ':interval:');
            const tokenMarkers = otherTokens.map((template)=>{
                const { string: tempVar, start: start, end: end } = template;
                const found = templates.find((t)=>t.tempVar === tempVar);
                if (found) {
                    const selected = (0, $59c041f8acdb6976$export$527010a204c46227)(found);
                    const localSelected = (0, $59c041f8acdb6976$export$648b91d15717bb7b)(found);
                    const value = selected || localSelected;
                    const replacedWith = (0, $4af725ed5f546b55$export$b134a65f91c63512)(tempVar, value);
                    return this.editor.getDoc().markText(start, end, {
                        replacedWith: replacedWith
                    });
                }
            });
            const intervalMarkers = await this.getIntervalMarkers(intervalTokens);
            return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).compact([
                ...tokenMarkers,
                ...intervalMarkers
            ]);
        }, // requires an API call to get the duration used in the query
        this.getIntervalMarkers = async (intervalTokens)=>{
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEmpty(intervalTokens)) return [];
            const durationValue = await this.fetchQueryInterval();
            return intervalTokens.map(({ start: start, end: end })=>{
                const replacedWith = (0, $4af725ed5f546b55$export$b134a65f91c63512)(':interval:', durationValue);
                return this.editor.getDoc().markText(start, end, {
                    replacedWith: replacedWith
                });
            });
        }, this.fetchQueryInterval = async ()=>{
            const { value: value, templates: templates, config: config } = this.props;
            const query = (0, $d9ab469c58284fd8$export$2e2bcd8739ae039)(value, templates);
            const durationMs = await (0, $5ecbe528a4dce188$export$1f34108aa9eb96ab)(query, config.source);
            return (0, $d9ab469c58284fd8$export$4d691f96d56ae2ff)(':interval:', durationMs);
        };
    }
}
var $e2ed7e2fe3751fa0$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($e2ed7e2fe3751fa0$var$ReactCodeMirror);



var $NdCUR = parcelRequire("NdCUR");


var $1v7mg = parcelRequire("1v7mg");
// TemplateDrawer must be a class component,
// functional components are not supported by react-onclickoutside
class $c77519543916f8eb$var$TemplateDrawer extends (0, $NdCUR.Component) {
    constructor(props){
        super(props);
    }
    render() {
        const { templates: templates, selected: selected, onMouseOverTempVar: onMouseOverTempVar, onClickTempVar: onClickTempVar } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "template-drawer"
        }, templates.map((t)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('template-drawer--item', {
                    'template-drawer--selected': t.tempVar === selected.tempVar
                }),
                onMouseOver: onMouseOverTempVar(t),
                onMouseDown: onClickTempVar(t),
                key: t.tempVar
            }, ' ', t.tempVar, ' ')));
    }
}
var $c77519543916f8eb$export$2e2bcd8739ae039 = (0, $23ae721fc6e771d0$export$2e2bcd8739ae039)($c77519543916f8eb$var$TemplateDrawer);



var $NdCUR = parcelRequire("NdCUR");

var $NdCUR = parcelRequire("NdCUR");
class $63c6ea9f81c4c951$var$LoadingDots extends (0, $NdCUR.Component) {
    static{
        this.defaultProps = {
            className: ''
        };
    }
    render() {
        const { className: className } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: `loading-dots ${className}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null));
    }
}
var $63c6ea9f81c4c951$export$2e2bcd8739ae039 = $63c6ea9f81c4c951$var$LoadingDots;



var $1v7mg = parcelRequire("1v7mg");
class $86e938451ff03fce$var$QueryStatus extends (0, $NdCUR.PureComponent) {
    render() {
        const { status: status, isShowingTemplateValues: isShowingTemplateValues } = this.props;
        if (isShowingTemplateValues) return this.previewingStatus;
        if (this.isUnsubmitted) return this.unsubmittedStatus;
        if (status.loading) return this.loadingStatus;
        return this.resolvedStatus;
    }
    get resolvedStatus() {
        const { status: status, children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "query-editor--status"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('query-status-output', {
                'query-status-output--error': !!status.error,
                'query-status-output--success': !!status.success,
                'query-status-output--warning': !!status.warn
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('icon', {
                stop: !!status.error,
                checkmark: !!status.success,
                'alert-triangle': !!status.warn
            })
        }), String(status.error || status.warn || status.success)), children);
    }
    get previewingStatus() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "query-editor--status"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "query-status-output"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon eye-open"
        }), "Previewing substituted Template Variable values, editing is disabled"));
    }
    get unsubmittedStatus() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "query-editor--status"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "query-status-output"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon alert-triangle"
        }), "Unsubmitted"), this.props.children);
    }
    get loadingStatus() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "query-editor--status"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $63c6ea9f81c4c951$export$2e2bcd8739ae039), {
            className: "query-editor--loading"
        }), this.props.children);
    }
    get isUnsubmitted() {
        return !(this.props.status && this.props.isSubmitted);
    }
}
var $86e938451ff03fce$export$2e2bcd8739ae039 = $86e938451ff03fce$var$QueryStatus;





const $579a07f413eba085$export$650623e0d6d022b5 = (promise)=>{
    let isCanceled = false;
    // eslint-disable-next-line no-async-promise-executor
    const wrappedPromise = new Promise(async (resolve, reject)=>{
        try {
            const value = await promise;
            if (isCanceled) reject({
                isCanceled: isCanceled
            });
            else resolve(value);
        } catch (error) {
            if (isCanceled) reject({
                isCanceled: isCanceled
            });
            else reject(error);
        }
    });
    return {
        promise: wrappedPromise,
        cancel () {
            isCanceled = true;
        }
    };
};






const $275431a82cc4454f$var$FIRST_TEMP_VAR = '0.tempVar';
const $275431a82cc4454f$var$BLURRED_EDITOR_STATE = {
    focused: false,
    isTemplating: false,
    isShowingTemplateValues: false
};
const $275431a82cc4454f$var$TEMPLATE_VAR = /[:]\w+[:]/g;
class $275431a82cc4454f$var$InfluxQLEditor extends (0, $NdCUR.Component) {
    static getDerivedStateFromProps(nextProps, prevState) {
        const { isSubmitted: isSubmitted, editedQueryText: editedQueryText } = prevState;
        const { query: query, config: config, templates: templates } = nextProps;
        const isQueryConfigChanged = config.id !== prevState.configID;
        const isQueryTextChanged = editedQueryText.trim() !== query.trim();
        // if query has been switched, set submitted state for excluded query based on the previous submitted way
        let submitted;
        if (isQueryConfigChanged) submitted = (0, $d6713fc94c521d4a$export$63fabf44ec222040)(query) ? config.status?.error !== (0, $6e043f3c946cd3bd$export$2c0e528ae5e9a9b3) : true;
        else submitted = isSubmitted;
        if (submitted && isQueryTextChanged || isQueryConfigChanged) return {
            ...$275431a82cc4454f$var$BLURRED_EDITOR_STATE,
            selectedTemplate: {
                tempVar: (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(templates, $275431a82cc4454f$var$FIRST_TEMP_VAR, '')
            },
            filteredTemplates: templates,
            templatingQueryText: query,
            editedQueryText: query,
            configID: config.id,
            focused: isQueryConfigChanged,
            isSubmitted: submitted,
            isExcluded: (0, $d6713fc94c521d4a$export$63fabf44ec222040)(query)
        };
        return null;
    }
    constructor(props){
        super(props), this.handleTemplateSelection = (selectedTemplate, templatingQueryText)=>{
            this.setState({
                selectedTemplate: selectedTemplate,
                templatingQueryText: templatingQueryText,
                editedQueryText: templatingQueryText
            });
        }, this.handleFocusEditor = ()=>{
            this.setState({
                focused: true
            });
        }, this.handleBlurEditor = ()=>{
            this.setState({
                focused: false,
                isShowingTemplateValues: false
            });
            this.handleUpdate(true);
        }, this.handleCloseDrawer = ()=>{
            this.setState({
                isTemplating: false
            });
        }, this.handleMouseOverTempVar = (template)=>()=>{
                const codeMirror = this.codeMirrorRef.current;
                codeMirror.handleTemplateReplace(template, false);
            }, this.handleClickTempVar = (template)=>()=>{
                // Clicking a tempVar does the same thing as hitting 'Enter'
                const codeMirror = this.codeMirrorRef.current;
                codeMirror.handleTemplateReplace(template, true);
                this.closeDrawer();
            }, this.handleMouseDown = (e)=>{
            this.setState({
                focused: true
            });
            e.stopPropagation();
            e.preventDefault();
        }, this.handleUpdateTemplatingQueryText = (value)=>{
            this.setState({
                templatingQueryText: value
            });
        }, this.handleChange = (value)=>{
            const { templates: templates, query: query } = this.props;
            const isEditedChanged = value !== this.state.editedQueryText;
            const isSubmitted = value.trim() === query.trim();
            if (!isEditedChanged || this.state.isShowingTemplateValues) return;
            // mask matches that will confuse our regex
            const masked = (0, $a3b88d5d27f00a75$export$e7629fcc9135ebfc)(value);
            const matched = masked.match((0, $a3b88d5d27f00a75$export$d51ff2a67c01c91d));
            const isTemplating = matched && !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEmpty(templates);
            if (isTemplating) {
                // maintain cursor position
                const matchedVar = {
                    tempVar: `${matched[0]}:`
                };
                const filteredTemplates = this.filterTemplates(matched[0]);
                const selectedTemplate = this.selectMatchingTemplate(filteredTemplates, matchedVar);
                this.setState({
                    isTemplating: isTemplating,
                    templatingQueryText: value,
                    selectedTemplate: selectedTemplate,
                    filteredTemplates: filteredTemplates,
                    editedQueryText: value,
                    isSubmitted: isSubmitted
                });
            } else {
                const isExcluded = (0, $d6713fc94c521d4a$export$63fabf44ec222040)(value);
                this.setState({
                    isTemplating: isTemplating,
                    isExcluded: isExcluded,
                    templatingQueryText: value,
                    editedQueryText: value,
                    isSubmitted: isSubmitted
                });
            }
        }, this.handleUpdate = async (isAutoSubmitted)=>{
            const { onUpdate: onUpdate, config: config } = this.props;
            const { editedQueryText: editedQueryText, isSubmitted: isSubmitted, isExcluded: isExcluded } = this.state;
            if (!this.isDisabled && (!isSubmitted || isExcluded && config.status?.error === (0, $6e043f3c946cd3bd$export$2c0e528ae5e9a9b3))) {
                this.cancelPendingUpdates();
                const update = onUpdate(editedQueryText, isAutoSubmitted);
                const cancelableUpdate = (0, $579a07f413eba085$export$650623e0d6d022b5)(update);
                this.pendingUpdates = [
                    ...this.pendingUpdates,
                    cancelableUpdate
                ];
                try {
                    await cancelableUpdate.promise;
                    // prevent changing submitted status when edited while awaiting update
                    if (this.state.editedQueryText === editedQueryText && (!isExcluded || !isAutoSubmitted)) this.setState({
                        isSubmitted: true
                    });
                } catch (error) {
                    if (!error.isCanceled) console.error(error);
                } finally{
                    this.pendingUpdates = this.pendingUpdates.filter((p)=>p !== cancelableUpdate);
                }
            }
        }, this.handleKeyDownEditor = (e)=>{
            const { isTemplating: isTemplating } = this.state;
            if (isTemplating) switch(e.key){
                case 'Enter':
                    e.preventDefault();
                    return this.closeDrawer();
                case 'Escape':
                    e.preventDefault();
                    return this.closeDrawer();
            }
            else if (e.key === 'Escape') {
                e.preventDefault();
                this.setState({
                    isTemplating: false
                });
            } else if (e.key === 'Enter') {
                e.preventDefault();
                this.handleUpdate();
            }
        }, this.handleHideAndFocus = ()=>{
            this.setState({
                isShowingTemplateValues: false,
                focused: true
            });
        }, this.handleShowTemplateValues = ()=>{
            this.setState({
                isShowingTemplateValues: true
            });
        }, this.handleChooseMetaQuery = (mqto)=>{
            if (this.props.onMetaQuerySelected) this.props.onMetaQuerySelected();
            this.handleChange(mqto.query);
        }, this.closeDrawer = ()=>{
            this.setState({
                isTemplating: false,
                selectedTemplate: {
                    tempVar: (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(this.props.templates, $275431a82cc4454f$var$FIRST_TEMP_VAR, '')
                }
            });
        };
        this.codeMirrorRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createRef();
        this.pendingUpdates = [];
        this.state = {
            ...$275431a82cc4454f$var$BLURRED_EDITOR_STATE,
            selectedTemplate: {
                tempVar: (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(props.templates, $275431a82cc4454f$var$FIRST_TEMP_VAR, '')
            },
            filteredTemplates: props.templates,
            templatingQueryText: props.query,
            editedQueryText: props.query,
            configID: props.config.id,
            isSubmitted: true,
            isExcluded: (0, $d6713fc94c521d4a$export$63fabf44ec222040)(props.query)
        };
    }
    componentWillUnmount() {
        this.cancelPendingUpdates();
    }
    componentDidMount() {
        this.handleFocusEditor();
    }
    render() {
        const { config: config, templates: templates } = this.props;
        const { templatingQueryText: templatingQueryText, isTemplating: isTemplating, selectedTemplate: selectedTemplate, filteredTemplates: filteredTemplates, isShowingTemplateValues: isShowingTemplateValues, focused: focused, isSubmitted: isSubmitted, isExcluded: isExcluded } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "query-editor",
            onMouseDown: this.handleMouseDown
        }, this.dismissPreviewButton, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $e2ed7e2fe3751fa0$export$2e2bcd8739ae039), {
            ref: this.codeMirrorRef,
            focused: focused,
            value: templatingQueryText,
            config: config,
            templates: templates,
            isTemplating: isTemplating,
            selectedTemplate: selectedTemplate,
            filteredTemplates: filteredTemplates,
            readOnly: isShowingTemplateValues,
            onChange: this.handleChange,
            onFocus: this.handleFocusEditor,
            onBlur: this.handleBlurEditor,
            isShowingTemplateValues: isShowingTemplateValues,
            onKeyDown: this.handleKeyDownEditor,
            onBeforeChange: this.handleUpdateTemplatingQueryText,
            onTemplateSelection: this.handleTemplateSelection
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('varmoji', {
                'varmoji-rotated': isTemplating,
                focus: focused,
                'read-only': isShowingTemplateValues
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "varmoji-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "varmoji-front"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $86e938451ff03fce$export$2e2bcd8739ae039), {
            status: config.status?.error === (0, $6e043f3c946cd3bd$export$2c0e528ae5e9a9b3) ? config.status.submittedStatus : config.status,
            isShowingTemplateValues: isShowingTemplateValues,
            isSubmitted: isSubmitted && !isExcluded || isExcluded && templatingQueryText === config.status?.submittedQuery
        }, this.queryStatusButtons)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "varmoji-back"
        }, isTemplating ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c77519543916f8eb$export$2e2bcd8739ae039), {
            onClickTempVar: this.handleClickTempVar,
            templates: filteredTemplates,
            selected: selectedTemplate,
            onMouseOverTempVar: this.handleMouseOverTempVar,
            handleClickOutside: this.handleCloseDrawer
        }) : null))));
    }
    filterTemplates(matchText) {
        const { templates: templates } = this.props;
        const filterText = matchText.substr(1).toLowerCase();
        return templates.filter((t)=>t.tempVar.toLowerCase().includes(filterText));
    }
    selectMatchingTemplate(filteredTemplates, defaultVar) {
        const { selectedTemplate: selectedTemplate } = this.state;
        const found = filteredTemplates.find((t)=>selectedTemplate && t.tempVar === selectedTemplate.tempVar);
        if (found) return found;
        return (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(filteredTemplates, '0', defaultVar);
    }
    cancelPendingUpdates() {
        this.pendingUpdates.forEach((p)=>{
            p.cancel();
        });
    }
    get isDisabled() {
        return this.state.isTemplating || this.state.isShowingTemplateValues;
    }
    get dismissPreviewButton() {
        const { isShowingTemplateValues: isShowingTemplateValues } = this.state;
        if (isShowingTemplateValues) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "query-editor--dismiss",
            onClick: this.handleHideAndFocus
        });
        return null;
    }
    get queryStatusButtons() {
        const { isTemplating: isTemplating, editedQueryText: editedQueryText } = this.state;
        const queryHasNoTempVars = !editedQueryText.match($275431a82cc4454f$var$TEMPLATE_VAR);
        let tempVarButtonTitle = 'See substituted Template Variable values';
        if (queryHasNoTempVars) tempVarButtonTitle = 'Query has no Template Variables to preview';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "query-editor--status-actions"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
            size: (0, $918c9f03a35fe03f$export$fafce5c139da9687).ExtraSmall,
            onClick: this.handleShowTemplateValues,
            text: "Show Template Values",
            titleText: tempVarButtonTitle,
            status: (isTemplating || queryHasNoTempVars) && (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Disabled
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $f040dbec7e8f99c8$export$2e2bcd8739ae039), {
            titleText: "Metaquery Templates",
            mode: (0, $f040dbec7e8f99c8$export$14df593178718d76).ActionList,
            onChange: this.handleChooseMetaQuery,
            buttonSize: (0, $918c9f03a35fe03f$export$fafce5c139da9687).ExtraSmall,
            widthPixels: 163
        }, (0, $85c5ce2a0e85a1fb$export$679c04984489026d).map((mqto)=>{
            if (mqto.type === (0, $85c5ce2a0e85a1fb$export$24d041d6bfd6dced).Item) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $f040dbec7e8f99c8$export$2e2bcd8739ae039).Item, {
                key: mqto.id,
                id: mqto.text,
                value: mqto
            }, mqto.text);
            else if (mqto.type === (0, $85c5ce2a0e85a1fb$export$24d041d6bfd6dced).Divider) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $f040dbec7e8f99c8$export$2e2bcd8739ae039).Divider, {
                key: mqto.id,
                id: mqto.id
            });
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
            size: (0, $918c9f03a35fe03f$export$fafce5c139da9687).ExtraSmall,
            color: (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Primary,
            status: this.isDisabled && (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Disabled,
            onClick: ()=>this.handleUpdate(),
            text: "Submit Query"
        }));
    }
}
var $275431a82cc4454f$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($275431a82cc4454f$var$InfluxQLEditor);


// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");

var $hBdgJ = parcelRequire("hBdgJ");

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");
const $2631cd432b3bab46$var$DatabaseListItem = ({ isActive: isActive, namespace: namespace, namespace: { database: database, retentionPolicy: retentionPolicy }, onChooseNamespace: onChooseNamespace })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('query-builder--list-item', {
            active: isActive
        }),
        onClick: onChooseNamespace(namespace)
    }, database, ".", retentionPolicy);
var $2631cd432b3bab46$export$2e2bcd8739ae039 = $2631cd432b3bab46$var$DatabaseListItem;




// Libraries

var $NdCUR = parcelRequire("NdCUR");
const $7ba6e1db17640a51$var$LoadingSpinner = ({ diameter: diameter = 30 })=>{
    const style = {
        width: `${diameter}px`,
        height: `${diameter}px`
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "loading-spinner--container",
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "loading-spinner--circle",
        style: style
    }));
};
var $7ba6e1db17640a51$export$2e2bcd8739ae039 = $7ba6e1db17640a51$var$LoadingSpinner;



const { shape: $bc7a39c4dbc338a6$var$shape } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
class $bc7a39c4dbc338a6$var$DatabaseList extends (0, $NdCUR.Component) {
    static{
        this.contextTypes = {
            source: $bc7a39c4dbc338a6$var$shape({
                links: $bc7a39c4dbc338a6$var$shape({}).isRequired
            }).isRequired
        };
    }
    static{
        this.defaultProps = {
            source: null
        };
    }
    constructor(props){
        super(props);
        this.getDbRp = this.getDbRp.bind(this);
        this.handleChooseNamespace = this.handleChooseNamespace.bind(this);
        this.state = {
            namespaces: [],
            isLoading: false
        };
    }
    componentDidMount() {
        this.getDbRp();
    }
    componentDidUpdate({ querySource: prevSource, query: prevQuery }) {
        const { querySource: nextSource, query: nextQuery } = this.props;
        const differentSource = !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEqual(prevSource, nextSource);
        const newMetaQuery = nextQuery.rawText && nextQuery.rawText.match(/^(create|drop)/i) && nextQuery.rawText !== prevQuery.rawText;
        if (differentSource || newMetaQuery) this.getDbRp();
    }
    async getDbRp() {
        const { source: source } = this.context;
        const { querySource: querySource } = this.props;
        const proxy = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(querySource, [
            'links',
            'proxy'
        ], source.links.proxy);
        this.setState({
            isLoading: true
        });
        try {
            const sorted = await (0, $cafe5a655b6c1200$export$f279f2817c69d78a)(proxy);
            this.setState({
                namespaces: sorted,
                isLoading: false
            });
        } catch (err) {
            console.error(err);
            this.setState({
                isLoading: false
            });
        }
    }
    handleChooseNamespace(namespace) {
        return ()=>this.props.onChooseNamespace(namespace);
    }
    isActive(query, { database: database, retentionPolicy: retentionPolicy }) {
        return database === query.database && retentionPolicy === query.retentionPolicy;
    }
    isLoading() {
        return this.state.isLoading;
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "query-builder--column query-builder--column-db"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "query-builder--heading"
        }, "DB.RetentionPolicy"), this.isLoading() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "query-builder--list-empty"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7ba6e1db17640a51$export$2e2bcd8739ae039), {
            diameter: 40
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "query-builder--list"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), null, this.state.namespaces.map((namespace)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $2631cd432b3bab46$export$2e2bcd8739ae039), {
                isActive: this.isActive(this.props.query, namespace),
                namespace: namespace,
                onChooseNamespace: this.handleChooseNamespace,
                key: namespace.database + namespace.retentionPolicy
            })))));
    }
}
var $bc7a39c4dbc338a6$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($bc7a39c4dbc338a6$var$DatabaseList);



var $fGw9V = parcelRequire("fGw9V");

var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");




var $NdCUR = parcelRequire("NdCUR");
const $584f2a94bb234c82$var$QueryBuilderFilter = ({ onEscape: onEscape, onFilterText: onFilterText, filterText: filterText })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "query-builder--filter"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
        className: "form-control input-sm",
        placeholder: "Filter",
        type: "text",
        value: filterText,
        onChange: onFilterText,
        onKeyUp: onEscape,
        spellCheck: false,
        autoComplete: "false"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        className: "icon search"
    }));
var $584f2a94bb234c82$export$2e2bcd8739ae039 = $584f2a94bb234c82$var$QueryBuilderFilter;



var $hBdgJ = parcelRequire("hBdgJ");

var $1v7mg = parcelRequire("1v7mg");

var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");

var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");

var $1v7mg = parcelRequire("1v7mg");

var $hBdgJ = parcelRequire("hBdgJ");

var $NdCUR = parcelRequire("NdCUR");

class $264b9991d9c81e71$var$TagListItem extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props);
        this.state = {
            filterText: '',
            isOpen: false
        };
        this.handleEscape = this.handleEscape.bind(this);
        this.handleChoose = this.handleChoose.bind(this);
        this.handleGroupBy = this.handleGroupBy.bind(this);
        this.handleClickKey = this.handleClickKey.bind(this);
        this.handleFilterText = this.handleFilterText.bind(this);
        this.handleInputClick = this.handleInputClick.bind(this);
    }
    handleChoose(tagValue, e) {
        e.stopPropagation();
        const { isQuerySupportedByExplorer: isQuerySupportedByExplorer } = this.props;
        if (!isQuerySupportedByExplorer) return;
        this.props.onChooseTag({
            key: this.props.tagKey,
            value: tagValue
        });
    }
    handleClickKey(e) {
        e.stopPropagation();
        this.setState({
            isOpen: !this.state.isOpen
        });
    }
    handleFilterText(e) {
        e.stopPropagation();
        this.setState({
            filterText: e.target.value
        });
    }
    handleEscape(e) {
        if (e.key !== 'Escape') return;
        e.stopPropagation();
        this.setState({
            filterText: ''
        });
    }
    handleGroupBy(e) {
        const { isQuerySupportedByExplorer: isQuerySupportedByExplorer } = this.props;
        e.stopPropagation();
        if (!isQuerySupportedByExplorer) return;
        this.props.onGroupByTag(this.props.tagKey);
    }
    handleInputClick(e) {
        e.stopPropagation();
    }
    renderTagValues() {
        const { tagValues: tagValues, selectedTagValues: selectedTagValues, isQuerySupportedByExplorer: isQuerySupportedByExplorer } = this.props;
        if (!tagValues || !tagValues.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null, "no tag values");
        const filterText = this.state.filterText.toLowerCase();
        const filtered = tagValues.filter((v)=>!!v && v.toLowerCase().includes(filterText));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "query-builder--sub-list"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "query-builder--filter"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control input-sm",
            placeholder: `Filter within ${this.props.tagKey}`,
            type: "text",
            value: this.state.filterText,
            onChange: this.handleFilterText,
            onKeyUp: this.handleEscape,
            onClick: this.handleInputClick,
            spellCheck: false,
            autoComplete: "false"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon search"
        })), filtered.map((v)=>{
            const cx = (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('query-builder--list-item', {
                active: selectedTagValues.indexOf(v) > -1,
                disabled: !isQuerySupportedByExplorer
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                className: cx,
                onClick: (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).wrap(v, this.handleChoose),
                key: v,
                "data-test": `query-builder-list-item-tag-value-${v}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                className: "query-builder--checkbox"
            }), v));
        }));
    }
    render() {
        const { tagKey: tagKey, tagValues: tagValues, isUsingGroupBy: isUsingGroupBy, isQuerySupportedByExplorer: isQuerySupportedByExplorer } = this.props;
        const { isOpen: isOpen } = this.state;
        const tagItemLabel = `${tagKey} \u{2014} ${tagValues.length}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('query-builder--list-item', {
                active: isOpen
            }),
            onClick: this.handleClickKey,
            "data-test": `query-builder-list-item-tag-${tagKey}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "query-builder--caret icon caret-right"
        }), tagItemLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('btn btn-xs group-by-tag', {
                'btn-default': !isUsingGroupBy,
                'btn-primary': isUsingGroupBy,
                disabled: !isQuerySupportedByExplorer
            }),
            onClick: this.handleGroupBy
        }, "Group By ", tagKey)), isOpen ? this.renderTagValues() : null);
    }
}
var $264b9991d9c81e71$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($264b9991d9c81e71$var$TagListItem);






const { shape: $0b8c56b439efa4d3$var$shape } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
class $0b8c56b439efa4d3$var$TagList extends (0, $NdCUR.PureComponent) {
    static{
        this.contextTypes = {
            source: $0b8c56b439efa4d3$var$shape({
                links: $0b8c56b439efa4d3$var$shape({}).isRequired
            }).isRequired
        };
    }
    static{
        this.defaultProps = {
            querySource: null
        };
    }
    constructor(props){
        super(props);
        this.state = {
            tags: {}
        };
    }
    componentDidMount() {
        const { database: database, measurement: measurement, retentionPolicy: retentionPolicy } = this.props.query;
        if (!database || !measurement || !retentionPolicy) return;
        this.getTags();
    }
    componentDidUpdate(prevProps) {
        const { query: query, querySource: querySource } = this.props;
        const { database: database, measurement: measurement, retentionPolicy: retentionPolicy } = query;
        const { database: prevDB, measurement: prevMeas, retentionPolicy: prevRP } = prevProps.query;
        if (!database || !measurement || !retentionPolicy) return;
        if (database === prevDB && measurement === prevMeas && retentionPolicy === prevRP && (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEqual(prevProps.querySource, querySource)) return;
        this.getTags();
    }
    async getTags() {
        const { source: source } = this.context;
        const { querySource: querySource } = this.props;
        const { database: database, measurement: measurement, retentionPolicy: retentionPolicy } = this.props.query;
        const proxy = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(querySource, [
            'links',
            'proxy'
        ], source.links.proxy);
        const { data: data } = await (0, $8ba03c44d4b91783$export$2e6ff3965e993ace)({
            database: database,
            measurement: measurement,
            retentionPolicy: retentionPolicy,
            source: proxy
        });
        const { tagKeys: tagKeys } = (0, $6d45437803cb8b2c$export$2e2bcd8739ae039)(data);
        const response = await (0, $8ba03c44d4b91783$export$ca66e3d7db6697de)({
            database: database,
            measurement: measurement,
            retentionPolicy: retentionPolicy,
            source: proxy,
            tagKeys: tagKeys
        });
        const { tags: tags } = (0, $e693016ff8180917$export$2e2bcd8739ae039)(response.data);
        this.setState({
            tags: tags
        });
    }
    render() {
        const { query: query, onChooseTag: onChooseTag, onGroupByTag: onGroupByTag, isQuerySupportedByExplorer: isQuerySupportedByExplorer } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "query-builder--sub-list"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).map(this.state.tags, (tagValues, tagKey)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $264b9991d9c81e71$export$2e2bcd8739ae039), {
                key: tagKey,
                tagKey: tagKey,
                tagValues: tagValues,
                onChooseTag: onChooseTag,
                onGroupByTag: onGroupByTag,
                selectedTagValues: query.tags[tagKey] || [],
                isUsingGroupBy: query.groupBy.tags.indexOf(tagKey) > -1,
                isQuerySupportedByExplorer: isQuerySupportedByExplorer
            })));
    }
}
var $0b8c56b439efa4d3$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($0b8c56b439efa4d3$var$TagList);



class $15884a9fbb46979f$var$MeasurementListItem extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleAcceptReject = (e)=>{
            e.stopPropagation();
            const { isQuerySupportedByExplorer: isQuerySupportedByExplorer } = this.props;
            if (!isQuerySupportedByExplorer) return;
            const { onAcceptReject: onAcceptReject } = this.props;
            onAcceptReject();
        }, this.handleClick = ()=>{
            const { measurement: measurement, onChooseMeasurement: onChooseMeasurement } = this.props;
            if (!this.isCurrentMeasurement) this.setState({
                isOpen: true
            }, ()=>{
                onChooseMeasurement(measurement)();
            });
            else this.setState({
                isOpen: !this.state.isOpen
            });
        };
        this.state = {
            isOpen: this.isCurrentMeasurement
        };
    }
    render() {
        const { query: query, querySource: querySource, measurement: measurement, onChooseTag: onChooseTag, onGroupByTag: onGroupByTag, numTagsActive: numTagsActive, areTagsAccepted: areTagsAccepted, isQuerySupportedByExplorer: isQuerySupportedByExplorer } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            key: measurement,
            onClick: this.handleClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('query-builder--list-item', {
                active: this.shouldShow
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "query-builder--caret icon caret-right"
        }), measurement), this.shouldShow && numTagsActive >= 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('flip-toggle', {
                flipped: areTagsAccepted,
                disabled: !isQuerySupportedByExplorer
            }),
            onClick: this.handleAcceptReject
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flip-toggle--container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flip-toggle--front"
        }, "!="), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flip-toggle--back"
        }, "=")))), this.shouldShow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $0b8c56b439efa4d3$export$2e2bcd8739ae039), {
            query: query,
            querySource: querySource,
            onChooseTag: onChooseTag,
            onGroupByTag: onGroupByTag,
            isQuerySupportedByExplorer: isQuerySupportedByExplorer
        }));
    }
    get shouldShow() {
        return this.isCurrentMeasurement && this.state.isOpen;
    }
    get isCurrentMeasurement() {
        const { query: query, measurement: measurement } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(query, 'measurement') === measurement;
    }
}
var $15884a9fbb46979f$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($15884a9fbb46979f$var$MeasurementListItem);



const { shape: $b7417221f063c35e$var$shape } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
class $b7417221f063c35e$var$MeasurementList extends (0, $NdCUR.PureComponent) {
    static{
        this.contextTypes = {
            source: $b7417221f063c35e$var$shape({
                links: $b7417221f063c35e$var$shape({}).isRequired
            }).isRequired
        };
    }
    static{
        this.defaultProps = {
            querySource: null
        };
    }
    constructor(props){
        super(props);
        this.state = {
            filterText: '',
            filtered: [],
            measurements: []
        };
        this.handleEscape = this.handleEscape.bind(this);
        this.handleFilterText = this.handleFilterText.bind(this);
        this.handleAcceptReject = this.handleAcceptReject.bind(this);
        this.handleFilterMeasuremet = this.handleFilterMeasuremet.bind(this);
        this.handleChoosemeasurement = this.handleChoosemeasurement.bind(this);
    }
    componentDidMount() {
        if (!this.props.query.database) return;
        this.getMeasurements();
    }
    componentDidUpdate(prevProps) {
        const { query: query, querySource: querySource } = this.props;
        if (!query.database) return;
        if (prevProps.query.database === query.database && (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEqual(prevProps.querySource, querySource)) return;
        this.getMeasurements();
    }
    handleFilterText(e) {
        e.stopPropagation();
        const filterText = e.target.value;
        this.setState({
            filterText: filterText,
            filtered: this.handleFilterMeasuremet(filterText)
        });
    }
    handleFilterMeasuremet(filter) {
        return this.state.measurements.filter((m)=>m.toLowerCase().includes(filter.toLowerCase()));
    }
    handleEscape(e) {
        if (e.key !== 'Escape') return;
        e.stopPropagation();
        this.setState({
            filterText: ''
        });
    }
    handleAcceptReject() {
        this.props.onToggleTagAcceptance();
    }
    handleChoosemeasurement(measurement) {
        return ()=>this.props.onChooseMeasurement(measurement);
    }
    render() {
        const { query: query, querySource: querySource, onChooseTag: onChooseTag, onGroupByTag: onGroupByTag, isQuerySupportedByExplorer: isQuerySupportedByExplorer, isKapacitorRule: isKapacitorRule } = this.props;
        const { database: database, areTagsAccepted: areTagsAccepted } = query;
        const { filtered: filtered } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "query-builder--column"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "query-builder--heading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", null, "Measurements & Tags"), database && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $584f2a94bb234c82$export$2e2bcd8739ae039), {
            onEscape: this.handleEscape,
            onFilterText: this.handleFilterText,
            filterText: this.state.filterText
        })), database ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "query-builder--list"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), null, filtered.map((measurement)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $15884a9fbb46979f$export$2e2bcd8739ae039), {
                query: query,
                key: measurement,
                measurement: measurement,
                querySource: querySource,
                onChooseTag: onChooseTag,
                onGroupByTag: onGroupByTag,
                areTagsAccepted: areTagsAccepted,
                onAcceptReject: this.handleAcceptReject,
                isActive: measurement === query.measurement,
                isQuerySupportedByExplorer: isKapacitorRule || isQuerySupportedByExplorer,
                numTagsActive: Object.keys(query.tags).length,
                onChooseMeasurement: this.handleChoosemeasurement
            })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "query-builder--list-empty"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", null, "No ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("strong", null, "Database"), " selected")));
    }
    async getMeasurements() {
        const { source: source } = this.context;
        const { querySource: querySource, query: query } = this.props;
        const proxy = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(querySource, [
            'links',
            'proxy'
        ], source.links.proxy);
        try {
            const { data: data } = await (0, $8ba03c44d4b91783$export$c71904f041e14568)(proxy, query.database);
            const { measurementSets: measurementSets } = (0, $4672176ee5bc174b$export$2e2bcd8739ae039)(data);
            const measurements = measurementSets[0].measurements;
            this.setState({
                measurements: measurements,
                filtered: measurements
            });
        } catch (err) {
            console.error(err);
        }
    }
}
var $b7417221f063c35e$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($b7417221f063c35e$var$MeasurementList);



var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");

var $NdCUR = parcelRequire("NdCUR");

var $NdCUR = parcelRequire("NdCUR");


const $da65989c207ee344$var$groupByTimes = [
    {
        defaultTimeBound: (0, $e10a8602f56394e3$export$77e8fbcbea0ce430),
        seconds: 604800,
        menuOption: 'auto'
    },
    {
        defaultTimeBound: 'now() - 5m',
        seconds: 10,
        menuOption: '10s'
    },
    {
        defaultTimeBound: 'now() - 15m',
        seconds: 60,
        menuOption: '1m'
    },
    {
        defaultTimeBound: 'now() - 1h',
        seconds: 300,
        menuOption: '5m'
    },
    {
        defaultTimeBound: 'now() - 6h',
        seconds: 600,
        menuOption: '10m'
    },
    {
        defaultTimeBound: 'now() - 12h',
        seconds: 1800,
        menuOption: '30m'
    },
    {
        defaultTimeBound: 'now() - 24h',
        seconds: 3600,
        menuOption: '1h'
    },
    {
        defaultTimeBound: 'now() - 2d',
        seconds: 21600,
        menuOption: '6h'
    },
    {
        defaultTimeBound: 'now() - 7d',
        seconds: 86400,
        menuOption: '1d'
    },
    {
        defaultTimeBound: 'now() - 30d',
        seconds: 604800,
        menuOption: '7d'
    }
];
var $da65989c207ee344$export$2e2bcd8739ae039 = $da65989c207ee344$var$groupByTimes;




const $7a923bfd5b99ca68$var$isInRuleBuilder = (pathname)=>pathname.includes('alert-rules');
const $7a923bfd5b99ca68$var$getOptions = (pathname)=>$7a923bfd5b99ca68$var$isInRuleBuilder(pathname) ? (0, $da65989c207ee344$export$2e2bcd8739ae039).filter(({ menuOption: menuOption })=>menuOption !== (0, $e10a8602f56394e3$export$4d7f0cfe7906cfdf)) : (0, $da65989c207ee344$export$2e2bcd8739ae039);
const $7a923bfd5b99ca68$var$GroupByTimeDropdown = ({ selected: selected, onChooseGroupByTime: onChooseGroupByTime, location: { pathname: pathname }, isDisabled: isDisabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "group-by-time"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
        className: "group-by-time--label"
    }, "Group by:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ca4f14339173643c$export$2e2bcd8739ae039), {
        className: "group-by-time--dropdown",
        menuClass: $7a923bfd5b99ca68$var$isInRuleBuilder(pathname) ? 'dropdown-malachite' : null,
        buttonColor: $7a923bfd5b99ca68$var$isInRuleBuilder(pathname) ? 'btn-default' : 'btn-info',
        items: $7a923bfd5b99ca68$var$getOptions(pathname).map((groupBy)=>({
                ...groupBy,
                text: groupBy.menuOption
            })),
        onChoose: onChooseGroupByTime,
        selected: selected || 'Time',
        disabled: isDisabled
    }));
var $7a923bfd5b99ca68$export$2e2bcd8739ae039 = (0, $dffbdf89c590a961$export$2e2bcd8739ae039)($7a923bfd5b99ca68$var$GroupByTimeDropdown);



var $NdCUR = parcelRequire("NdCUR");

const $0d8cd96913de10fb$export$6977970ea4943d23 = [
    {
        label: 'none',
        text: 'none',
        quantity: null,
        unit: null
    },
    {
        label: '1m',
        text: '1m',
        quantity: '1',
        unit: 'm'
    },
    {
        label: '1h',
        text: '1h',
        quantity: '1',
        unit: 'h'
    },
    {
        label: '12h',
        text: '12h',
        quantity: '12',
        unit: 'h'
    },
    {
        label: '1d',
        text: '1d',
        quantity: '1',
        unit: 'd'
    },
    {
        label: '7d',
        text: '7d',
        quantity: '7',
        unit: 'd'
    },
    {
        label: '30d',
        text: '30d',
        quantity: '30',
        unit: 'd'
    },
    {
        label: '365d',
        text: '365d',
        quantity: '365',
        unit: 'd'
    }
];


const $490a50b58865dd8e$var$TimeShiftDropdown = ({ selected: selected, onChooseTimeShift: onChooseTimeShift, isDisabled: isDisabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "group-by-time"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
        className: "group-by-time--label"
    }, "Compare:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ca4f14339173643c$export$2e2bcd8739ae039), {
        className: "group-by-time--dropdown",
        buttonColor: "btn-info",
        items: (0, $0d8cd96913de10fb$export$6977970ea4943d23),
        onChoose: onChooseTimeShift,
        selected: selected || 'none',
        disabled: isDisabled
    }));
var $490a50b58865dd8e$export$2e2bcd8739ae039 = $490a50b58865dd8e$var$TimeShiftDropdown;



var $NdCUR = parcelRequire("NdCUR");


const $be2e901b1ce69c60$var$queryFills = [
    {
        type: 'null',
        text: 'null',
        menuOption: '(null)',
        inputValue: 'null',
        isValidForKapaNodes: true
    },
    {
        type: 'previous',
        text: 'previous',
        menuOption: '(previous)',
        inputValue: 'previous',
        isValidForKapaNodes: false
    },
    {
        type: 'number',
        text: 'number',
        menuOption: '(number)',
        inputValue: '0',
        isValidForKapaNodes: true
    },
    {
        type: 'none',
        text: 'none',
        menuOption: '(none)',
        inputValue: 'none',
        isValidForKapaNodes: true
    },
    {
        type: 'linear',
        text: 'linear',
        menuOption: '(linear)',
        inputValue: 'linear',
        isValidForKapaNodes: false
    }
];
var // for if/when filtering FillQuery queryFill types not supported as Kapacitor nodes:
// queryFills.filter(fill => !(isKapacitorRule && !fill.isValidForKapaNodes))
$be2e901b1ce69c60$export$2e2bcd8739ae039 = $be2e901b1ce69c60$var$queryFills;



class $95a8e27579f98236$var$FillQuery extends (0, $NdCUR.PureComponent) {
    static{
        this.defaultProps = {
            size: 'sm',
            theme: 'blue',
            value: (0, $f6a5aa1a5f0d59f0$export$b062928682b6d462)
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.value === props.value) return false;
        const isNumberValue = !isNaN(Number(props.value));
        if (isNumberValue) return {
            selected: (0, $be2e901b1ce69c60$export$2e2bcd8739ae039).find((fill)=>fill.type === (0, $f6a5aa1a5f0d59f0$export$4e8bcd47a31d751c)),
            currentNumberValue: props.value,
            resetNumberValue: props.value,
            value: props.value
        };
        return {
            selected: (0, $be2e901b1ce69c60$export$2e2bcd8739ae039).find((fill)=>fill.type === props.value),
            value: props.value
        };
    }
    constructor(props){
        super(props), this.handleDropdown = (item)=>{
            if (item.text === (0, $f6a5aa1a5f0d59f0$export$4e8bcd47a31d751c)) this.setState({
                selected: item
            }, ()=>{
                this.numberInput.focus();
            });
            else this.setState({
                selected: item
            }, ()=>{
                this.props.onChooseFill(item.text);
            });
        }, this.handleInputBlur = (e)=>{
            const nextNumberValue = e.target.value ? e.target.value : this.state.resetNumberValue || '0';
            this.setState({
                currentNumberValue: nextNumberValue,
                resetNumberValue: nextNumberValue
            });
            this.props.onChooseFill(nextNumberValue);
        }, this.handleInputChange = (e)=>{
            const currentNumberValue = e.target.value;
            this.setState({
                currentNumberValue: currentNumberValue
            });
        }, this.handleKeyDown = (e)=>{
            if (e.key === 'Enter') this.numberInput.blur();
        }, this.handleKeyUp = (e)=>{
            if (e.key === 'Escape') this.setState({
                currentNumberValue: this.state.resetNumberValue
            }, ()=>{
                this.numberInput.blur();
            });
        }, this.getColor = (theme)=>{
            switch(theme){
                case 'BLUE':
                    return 'plutonium';
                case 'GREEN':
                    return 'malachite';
                case 'PURPLE':
                    return 'astronaut';
                default:
                    return 'plutonium';
            }
        };
        const isNumberValue = !isNaN(Number(props.value));
        this.state = isNumberValue ? {
            selected: (0, $be2e901b1ce69c60$export$2e2bcd8739ae039).find((fill)=>fill.type === (0, $f6a5aa1a5f0d59f0$export$4e8bcd47a31d751c)),
            currentNumberValue: props.value,
            resetNumberValue: props.value,
            value: props.value
        } : {
            selected: (0, $be2e901b1ce69c60$export$2e2bcd8739ae039).find((fill)=>fill.type === props.value),
            currentNumberValue: '0',
            resetNumberValue: '0',
            value: props.value
        };
    }
    render() {
        const { size: size, theme: theme, isDisabled: isDisabled } = this.props;
        const { selected: selected, currentNumberValue: currentNumberValue } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: `fill-query fill-query--${size}`
        }, selected.type === (0, $f6a5aa1a5f0d59f0$export$4e8bcd47a31d751c) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            ref: (r)=>this.numberInput = r,
            type: "number",
            className: `form-control monotype form-${this.getColor(theme)} input-${size} fill-query--input`,
            placeholder: "Custom Value",
            value: currentNumberValue,
            onKeyUp: this.handleKeyUp,
            onKeyDown: this.handleKeyDown,
            onChange: this.handleInputChange,
            onBlur: this.handleInputBlur
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ca4f14339173643c$export$2e2bcd8739ae039), {
            selected: selected.text,
            items: (0, $be2e901b1ce69c60$export$2e2bcd8739ae039),
            className: "fill-query--dropdown dropdown-100",
            buttonSize: `btn-${size}`,
            buttonColor: "btn-info",
            menuClass: `dropdown-${this.getColor(theme)}`,
            onChoose: this.handleDropdown,
            disabled: isDisabled
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            className: "fill-query--label"
        }, "Fill:"));
    }
}
var $95a8e27579f98236$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($95a8e27579f98236$var$FillQuery);


const $1b6e38a43f1cda28$var$QueryOptions = ({ fill: fill, shift: shift, onFill: onFill, groupBy: groupBy, onTimeShift: onTimeShift, onGroupByTime: onGroupByTime, isKapacitorRule: isKapacitorRule, isDisabled: isDisabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "query-builder--groupby-fill-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7a923bfd5b99ca68$export$2e2bcd8739ae039), {
        selected: groupBy.time,
        onChooseGroupByTime: onGroupByTime,
        isDisabled: isDisabled
    }), isKapacitorRule ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $490a50b58865dd8e$export$2e2bcd8739ae039), {
        selected: shift && shift.label,
        onChooseTimeShift: onTimeShift,
        isDisabled: isDisabled
    }), isKapacitorRule ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $95a8e27579f98236$export$2e2bcd8739ae039), {
        value: fill,
        onChooseFill: onFill,
        isDisabled: isDisabled
    }));
var $1b6e38a43f1cda28$export$2e2bcd8739ae039 = $1b6e38a43f1cda28$var$QueryOptions;



var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");

var $hBdgJ = parcelRequire("hBdgJ");


class $f797f5238ae5aa64$var$FunctionSelector extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.onSelect = (item, e)=>{
            e.stopPropagation();
            const { localSelectedItems: localSelectedItems } = this.state;
            let nextItems;
            if (this.isSelected(item)) nextItems = localSelectedItems.filter((i)=>i !== item);
            else nextItems = [
                ...localSelectedItems,
                item
            ];
            this.setState({
                localSelectedItems: nextItems
            });
        }, this.onSingleSelect = (item)=>{
            if (item === this.state.localSelectedItems[0]) {
                this.props.onApply([]);
                this.setState({
                    localSelectedItems: []
                });
            } else {
                this.props.onApply([
                    item
                ]);
                this.setState({
                    localSelectedItems: [
                        item
                    ]
                });
            }
        }, this.isSelected = (item)=>{
            return !!this.state.localSelectedItems.find((text)=>text === item);
        }, this.handleApplyFunctions = (e)=>{
            e.stopPropagation();
            this.props.onApply(this.state.localSelectedItems);
        };
        this.state = {
            localSelectedItems: this.props.selectedItems
        };
    }
    UNSAFE_componentWillUpdate(nextProps) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEqual(this.props.selectedItems, nextProps.selectedItems)) this.setState({
            localSelectedItems: nextProps.selectedItems
        });
    }
    render() {
        const { singleSelect: singleSelect } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "function-selector"
        }, !singleSelect && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "function-selector--header"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", null, this.headerText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "btn btn-xs btn-success",
            onClick: this.handleApplyFunctions,
            "data-test": "function-selector-apply"
        }, "Apply")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "function-selector--grid"
        }, (0, $85c5ce2a0e85a1fb$export$9ee8aa157542e05b).map((f, i)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                key: i,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('function-selector--item', {
                    active: this.isSelected(f)
                }),
                onClick: (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).wrap(f, singleSelect ? this.onSingleSelect : this.onSelect),
                "data-test": `function-selector-item-${f}`
            }, f);
        })));
    }
    get headerText() {
        const numItems = this.state.localSelectedItems.length;
        if (!numItems) return 'Select functions below';
        return `${numItems} Selected`;
    }
}
var $f797f5238ae5aa64$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($f797f5238ae5aa64$var$FunctionSelector);



class $51e9aeaec2b189df$var$FieldListItem extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.toggleFunctionsMenu = (e)=>{
            e.stopPropagation();
            const { isDisabled: isDisabled } = this.props;
            if (isDisabled) return;
            this.setState({
                isOpen: !this.state.isOpen
            });
        }, this.close = ()=>{
            this.setState({
                isOpen: false
            });
        }, this.handleToggleField = ()=>{
            const { onToggleField: onToggleField, fieldName: fieldName } = this.props;
            onToggleField({
                value: fieldName,
                type: 'field'
            });
            this.close();
        }, this.handleApplyFunctions = (selectedFuncs)=>{
            const { onApplyFuncsToField: onApplyFuncsToField, fieldName: fieldName } = this.props;
            const field = {
                value: fieldName,
                type: 'field'
            };
            onApplyFuncsToField({
                field: field,
                funcs: selectedFuncs.map((val)=>this.makeFuncArg(val))
            });
            this.close();
        }, this.makeFuncArg = (value)=>({
                value: value,
                type: 'func'
            });
        this.state = {
            isOpen: false
        };
    }
    render() {
        const { isKapacitorRule: isKapacitorRule, isSelected: isSelected, fieldName: fieldName, funcs: funcs, isDisabled: isDisabled } = this.props;
        const { isOpen: isOpen } = this.state;
        let fieldFuncsLabel;
        const num = funcs.length;
        switch(num){
            case 0:
                fieldFuncsLabel = '0 Functions';
                break;
            case 1:
                fieldFuncsLabel = `${num} Function`;
                break;
            default:
                fieldFuncsLabel = `${num} Functions`;
                break;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('query-builder--list-item', {
                active: isSelected,
                disabled: isDisabled
            }),
            onClick: this.handleToggleField,
            "data-test": `query-builder-list-item-field-${fieldName}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "query-builder--checkbox"
        }), fieldName), isSelected ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('btn btn-xs', {
                active: isOpen,
                'btn-default': !num,
                'btn-primary': num,
                disabled: isDisabled
            }),
            onClick: this.toggleFunctionsMenu,
            "data-test": `query-builder-list-item-function-${fieldName}`
        }, fieldFuncsLabel) : null), isSelected && isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $f797f5238ae5aa64$export$2e2bcd8739ae039), {
            onApply: this.handleApplyFunctions,
            selectedItems: funcs,
            singleSelect: isKapacitorRule
        }) : null);
    }
}
var $51e9aeaec2b189df$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($51e9aeaec2b189df$var$FieldListItem);








class $b1ff4c63c24666bb$var$FieldList extends (0, $NdCUR.PureComponent) {
    static{
        this.defaultProps = {
            isKapacitorRule: false,
            initialGroupByTime: null
        };
    }
    constructor(props){
        super(props), this.handleFilterText = (e)=>{
            e.stopPropagation();
            const filterText = e.currentTarget.value;
            this.setState({
                filterText: filterText
            });
        }, this.handleEscapeFilter = (e)=>{
            if (e.key !== 'Escape') return;
            e.stopPropagation();
            this.setState({
                filterText: ''
            });
        }, this.handleGroupByTime = (groupBy)=>{
            this.props.onGroupByTime(groupBy.menuOption);
        }, this.handleFill = (fill)=>{
            this.props.onFill(fill);
        }, this.handleToggleField = (field)=>{
            const { query: query, onToggleField: onToggleField, addInitialField: addInitialField, initialGroupByTime: time, isKapacitorRule: isKapacitorRule, isQuerySupportedByExplorer: isQuerySupportedByExplorer } = this.props;
            const { fields: fields, groupBy: groupBy } = query;
            const isDisabled = !isKapacitorRule && !isQuerySupportedByExplorer;
            if (isDisabled) return;
            const initialGroupBy = {
                ...groupBy,
                time: time
            };
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).size(fields)) return isKapacitorRule ? onToggleField(field) : addInitialField(field, initialGroupBy);
            onToggleField(field);
        }, this.handleApplyFuncs = (fieldFunc)=>{
            const { query: query, removeFuncs: removeFuncs, applyFuncsToField: applyFuncsToField, initialGroupByTime: time } = this.props;
            const { groupBy: groupBy, fields: fields } = query;
            const { funcs: funcs } = fieldFunc;
            // If one field has no funcs, all fields must have no funcs
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).size(funcs)) return removeFuncs(fields);
            // If there is no groupBy time, set one
            if (!groupBy.time) return applyFuncsToField(fieldFunc, {
                ...groupBy,
                time: time
            });
            applyFuncsToField(fieldFunc, groupBy);
        }, this.handleTimeShift = (shift)=>{
            this.props.onTimeShift(shift);
        }, this.getFields = ()=>{
            const { database: database, measurement: measurement, retentionPolicy: retentionPolicy } = this.props.query;
            const { querySource: querySource, source: source } = this.props;
            const proxy = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(querySource, [
                'links',
                'proxy'
            ], null) || source.links.proxy;
            (0, $8ba03c44d4b91783$export$a6d803488126746d)(proxy, database, measurement, retentionPolicy).then((resp)=>{
                const { errors: errors, fieldSets: fieldSets } = (0, $b90fabf231bb35b3$export$2e2bcd8739ae039)(resp.data);
                if (errors.length) console.error('Error parsing fields keys: ', errors);
                const newFields = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(fieldSets, measurement, []).map((f)=>({
                        value: f,
                        type: 'field'
                    }));
                this.setState({
                    fields: (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).uniqBy(newFields, 'value')
                });
            });
        };
        this.state = {
            filterText: '',
            fields: []
        };
    }
    componentDidMount() {
        const { database: database, measurement: measurement } = this.props.query;
        if (!database || !measurement) return;
        this.getFields();
    }
    componentDidUpdate(prevProps) {
        const { querySource: querySource, query: query } = this.props;
        const { database: database, measurement: measurement, retentionPolicy: retentionPolicy } = query;
        const { database: prevDB, measurement: prevMeas, retentionPolicy: prevRP } = prevProps.query;
        if (!database || !measurement) return;
        if (database === prevDB && measurement === prevMeas && retentionPolicy === prevRP && (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEqual(prevProps.querySource, querySource)) return;
        this.getFields();
    }
    render() {
        const { query: { database: database, measurement: measurement, fields: fields = [], groupBy: groupBy, fill: fill, shifts: shifts }, isQuerySupportedByExplorer: isQuerySupportedByExplorer, isKapacitorRule: isKapacitorRule } = this.props;
        const hasAggregates = (0, $58ff0395d03c4a96$export$a975b3bf1e585936)(fields) > 0;
        const noDBorMeas = !database || !measurement;
        const isDisabled = !isKapacitorRule && !isQuerySupportedByExplorer;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "query-builder--column"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "query-builder--heading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", null, "Fields"), hasAggregates ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1b6e38a43f1cda28$export$2e2bcd8739ae039), {
            fill: fill,
            shift: (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).first(shifts),
            groupBy: groupBy,
            onFill: this.handleFill,
            isKapacitorRule: isKapacitorRule,
            onTimeShift: this.handleTimeShift,
            onGroupByTime: this.handleGroupByTime,
            isDisabled: isDisabled
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $584f2a94bb234c82$export$2e2bcd8739ae039), {
            filterText: this.state.filterText,
            onEscape: this.handleEscapeFilter,
            onFilterText: this.handleFilterText
        })), noDBorMeas ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "query-builder--list-empty"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", null, "No ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("strong", null, "Measurement"), " selected")) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "query-builder--list"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), null, this.state.fields.map((fieldFunc, i)=>{
            const selectedFields = (0, $58ff0395d03c4a96$export$779842e6202ca4b2)(fieldFunc.value, fields);
            const fieldName = (0, $58ff0395d03c4a96$export$3128dedc24eee543)(fieldFunc);
            if (this.state.filterText && !selectedFields.length && !fieldName.toLowerCase().includes(this.state.filterText.toLowerCase())) // do not render the item unless it is selected or matches filter
            return;
            const funcs = (0, $58ff0395d03c4a96$export$d33ef81c2d08c189)(fieldFunc.value, fields);
            const fieldFuncs = selectedFields.length ? selectedFields : [
                fieldFunc
            ];
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $51e9aeaec2b189df$export$2e2bcd8739ae039), {
                key: i,
                onToggleField: this.handleToggleField,
                onApplyFuncsToField: this.handleApplyFuncs,
                isSelected: !!selectedFields.length,
                fieldName: fieldName,
                fieldFuncs: fieldFuncs,
                funcs: (0, $58ff0395d03c4a96$export$4b45735d9afb8e07)(funcs),
                isKapacitorRule: isKapacitorRule,
                isDisabled: isDisabled
            });
        })))), hasAggregates ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "query-builder--heading",
            style: {
                backgroundColor: 'transparent'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $584f2a94bb234c82$export$2e2bcd8739ae039), {
            filterText: this.state.filterText,
            onEscape: this.handleEscapeFilter,
            onFilterText: this.handleFilterText
        })) : undefined);
    }
}
var $b1ff4c63c24666bb$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($b1ff4c63c24666bb$var$FieldList);


const $0a1957e611a19886$var$actionBinder = (id, action)=>(...args)=>{
        return action(id, ...args);
    };
const $0a1957e611a19886$var$SchemaExplorer = ({ query: query, source: source, initialGroupByTime: initialGroupByTime, onFill: onFill, onTimeShift: onTimeShift, onChooseTag: onChooseTag, onGroupByTag: onGroupByTag, onGroupByTime: onGroupByTime, onToggleField: onToggleField, onRemoveFuncs: onRemoveFuncs, onAddInitialField: onAddInitialField, onChooseNamespace: onChooseNamespace, onChooseMeasurement: onChooseMeasurement, onApplyFuncsToField: onApplyFuncsToField, onToggleTagAcceptance: onToggleTagAcceptance, isQuerySupportedByExplorer: isQuerySupportedByExplorer = true })=>{
    const { id: id } = query;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "query-builder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $bc7a39c4dbc338a6$export$2e2bcd8739ae039), {
        query: query,
        querySource: source,
        onChooseNamespace: $0a1957e611a19886$var$actionBinder(id, onChooseNamespace)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b7417221f063c35e$export$2e2bcd8739ae039), {
        query: query,
        querySource: source,
        onChooseTag: $0a1957e611a19886$var$actionBinder(id, onChooseTag),
        onGroupByTag: $0a1957e611a19886$var$actionBinder(id, onGroupByTag),
        onChooseMeasurement: $0a1957e611a19886$var$actionBinder(id, onChooseMeasurement),
        onToggleTagAcceptance: $0a1957e611a19886$var$actionBinder(id, onToggleTagAcceptance),
        isQuerySupportedByExplorer: isQuerySupportedByExplorer
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b1ff4c63c24666bb$export$2e2bcd8739ae039), {
        source: source,
        query: query,
        querySource: source,
        onFill: $0a1957e611a19886$var$actionBinder(id, onFill),
        initialGroupByTime: initialGroupByTime,
        onTimeShift: $0a1957e611a19886$var$actionBinder(id, onTimeShift),
        removeFuncs: $0a1957e611a19886$var$actionBinder(id, onRemoveFuncs),
        onToggleField: $0a1957e611a19886$var$actionBinder(id, onToggleField),
        onGroupByTime: $0a1957e611a19886$var$actionBinder(id, onGroupByTime),
        addInitialField: $0a1957e611a19886$var$actionBinder(id, onAddInitialField),
        applyFuncsToField: $0a1957e611a19886$var$actionBinder(id, onApplyFuncsToField),
        isQuerySupportedByExplorer: isQuerySupportedByExplorer
    }));
};
var $0a1957e611a19886$export$2e2bcd8739ae039 = $0a1957e611a19886$var$SchemaExplorer;







const $046d5031e62bfbb4$var$buildText = (q)=>{
    return q.rawText || (0, $7b2c5b24a44a7fa2$export$d7b58f10109feb02)((0, $9a9ec629fdd38845$export$797ae35c568d4e70), q.range, q) || '';
};
const $046d5031e62bfbb4$var$QueryMaker = ({ source: source, queries: queries, timeRange: timeRange, templates: templates, onAddQuery: onAddQuery, activeQuery: activeQuery, onDeleteQuery: onDeleteQuery, activeQueryIndex: activeQueryIndex, setActiveQueryIndex: setActiveQueryIndex, onEditRawText: onEditRawText, onFill: onFill, onTimeShift: onTimeShift, onChooseTag: onChooseTag, onGroupByTag: onGroupByTag, onGroupByTime: onGroupByTime, onToggleField: onToggleField, onRemoveFuncs: onRemoveFuncs, onAddInitialField: onAddInitialField, onChooseNamespace: onChooseNamespace, onChooseMeasurement: onChooseMeasurement, onApplyFuncsToField: onApplyFuncsToField, onToggleTagAcceptance: onToggleTagAcceptance, onMetaQuerySelected: onMetaQuerySelected })=>{
    if (!activeQuery || !activeQuery.id) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "query-maker"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $8b94d8adf97500e0$export$2e2bcd8739ae039), {
        onAddQuery: onAddQuery
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), {
        className: "query-maker--container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "query-maker"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $857ada34c8644d6d$export$2e2bcd8739ae039), {
        queries: queries,
        timeRange: timeRange,
        onAddQuery: onAddQuery,
        onDeleteQuery: onDeleteQuery,
        activeQueryIndex: activeQueryIndex,
        setActiveQueryIndex: setActiveQueryIndex
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "query-maker--tab-contents"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $275431a82cc4454f$export$2e2bcd8739ae039), {
        query: $046d5031e62bfbb4$var$buildText(activeQuery),
        config: activeQuery,
        onUpdate: onEditRawText,
        templates: templates,
        onMetaQuerySelected: onMetaQuerySelected
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $0a1957e611a19886$export$2e2bcd8739ae039), {
        source: source,
        query: activeQuery,
        initialGroupByTime: (0, $e10a8602f56394e3$export$4d7f0cfe7906cfdf),
        isQuerySupportedByExplorer: (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(activeQuery, 'isQuerySupportedByExplorer', true),
        onFill: onFill,
        onTimeShift: onTimeShift,
        onChooseTag: onChooseTag,
        onGroupByTag: onGroupByTag,
        onGroupByTime: onGroupByTime,
        onToggleField: onToggleField,
        onRemoveFuncs: onRemoveFuncs,
        onAddInitialField: onAddInitialField,
        onChooseNamespace: onChooseNamespace,
        onChooseMeasurement: onChooseMeasurement,
        onApplyFuncsToField: onApplyFuncsToField,
        onToggleTagAcceptance: onToggleTagAcceptance
    }))));
};
const $046d5031e62bfbb4$var$ConnectedQueryMaker = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b029b3af5fc2e5d5$export$7d87f8b720f7653e), null, (container)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($046d5031e62bfbb4$var$QueryMaker, {
            ...props,
            timeRange: container.state.timeRange,
            onFill: container.handleFill,
            onTimeShift: container.handleTimeShift,
            onChooseTag: container.handleChooseTag,
            onGroupByTag: container.handleGroupByTag,
            onGroupByTime: container.handleGroupByTime,
            onToggleField: container.handleToggleField,
            onRemoveFuncs: container.handleRemoveFuncs,
            onAddInitialField: container.handleAddInitialField,
            onChooseNamespace: container.handleChooseNamespace,
            onChooseMeasurement: container.handleChooseMeasurement,
            onApplyFuncsToField: container.handleApplyFuncsToField,
            onToggleTagAcceptance: container.handleToggleTagAcceptance
        }));
var $046d5031e62bfbb4$export$2e2bcd8739ae039 = $046d5031e62bfbb4$var$ConnectedQueryMaker;


// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");
// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");


var $NdCUR = parcelRequire("NdCUR");

const $68fa0144111754ce$var$GRAPH_SVGS = {
    line: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "graph-type-selector--graphic"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("svg", {
        width: "100%",
        height: "100%",
        version: "1.1",
        id: "Line",
        x: "0px",
        y: "0px",
        viewBox: "0 0 150 150",
        preserveAspectRatio: "none meet",
        shapeRendering: "geometricPrecision"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("polygon", {
        className: "graph-type-selector--graphic-fill graphic-fill-a",
        points: "148,40 111.5,47.2 75,25 38.5,90.8 2,111.8 2,125 148,125  "
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("polyline", {
        className: "graph-type-selector--graphic-line graphic-line-a",
        points: "2,111.8 38.5,90.8 75,25 111.5,47.2 148,40  "
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("polygon", {
        className: "graph-type-selector--graphic-fill graphic-fill-b",
        points: "148,88.2 111.5,95.5 75,61.7 38.5,49.3 2,90.8 2,125 148,125  "
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("polyline", {
        className: "graph-type-selector--graphic-line graphic-line-b",
        points: "2,90.8 38.5,49.3 75,61.7 111.5,95.5 148,88.2  "
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("polygon", {
        className: "graph-type-selector--graphic-fill graphic-fill-c",
        points: "148,96 111.5,106.3 75,85.7 38.5,116.5 2,115 2,125 148,125  "
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("polyline", {
        className: "graph-type-selector--graphic-line graphic-line-c",
        points: "2,115 38.5,116.5 75,85.7 111.5,106.3 148,96  "
    }))),
    'line-stacked': /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "graph-type-selector--graphic"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("svg", {
        width: "100%",
        height: "100%",
        version: "1.1",
        id: "LineStacked",
        x: "0px",
        y: "0px",
        viewBox: "0 0 150 150",
        preserveAspectRatio: "none meet",
        shapeRendering: "geometricPrecision"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("polygon", {
        className: "graph-type-selector--graphic-fill graphic-fill-a",
        points: "148,25 111.5,25 75,46 38.5,39.1 2,85.5 2,125 148,125  "
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("polyline", {
        className: "graph-type-selector--graphic-line graphic-line-a",
        points: "2,85.5 38.5,39.1 75,46 111.5,25 148,25  "
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("polygon", {
        className: "graph-type-selector--graphic-fill graphic-fill-b",
        points: "148,53 111.5,49.9 75,88.5 38.5,71 2,116 2,125 148,125  "
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("polyline", {
        className: "graph-type-selector--graphic-line graphic-line-b",
        points: "2,116 38.5,71 75,88.5 111.5,49.9 148,53  "
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("polygon", {
        className: "graph-type-selector--graphic-fill graphic-fill-c",
        points: "148,86.2 111.5,88.6 75,108.6 38.5,98 2,121.1 2,125 148,125  "
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("polyline", {
        className: "graph-type-selector--graphic-line graphic-line-c",
        points: "2,121.1 38.5,98 75,108.6 111.5,88.6 148,86.2  "
    }))),
    'line-stepplot': /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "graph-type-selector--graphic"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("svg", {
        width: "100%",
        height: "100%",
        version: "1.1",
        id: "StepPlot",
        x: "0px",
        y: "0px",
        viewBox: "0 0 150 150",
        preserveAspectRatio: "none meet",
        shapeRendering: "geometricPrecision"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("polygon", {
        className: "graph-type-selector--graphic-fill graphic-fill-a",
        points: "148,61.9 129.8,61.9 129.8,25 93.2,25 93.2,40.6 56.8,40.6 56.8,25 20.2,25 20.2,67.8 2,67.8 2,125 148,125  "
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("polyline", {
        className: "graph-type-selector--graphic-line graphic-line-a",
        points: "2,67.8 20.2,67.8 20.2,25 56.8,25 56.8,40.6 93.2,40.6 93.2,25 129.8,25 129.8,61.9 148,61.9  "
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("polygon", {
        className: "graph-type-selector--graphic-fill graphic-fill-b",
        points: "148,91.9 129.8,91.9 129.8,70.2 93.2,70.2 93.2,67 56.8,67 56.8,50.1 20.2,50.1 20.2,87 2,87 2,125 148,125  "
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("polyline", {
        className: "graph-type-selector--graphic-line graphic-line-b",
        points: "2,87 20.2,87 20.2,50.1 56.8,50.1 56.8,67 93.2,67 93.2,70.2 129.8,70.2 129.8,91.9 148,91.9  "
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("polygon", {
        className: "graph-type-selector--graphic-fill graphic-fill-c",
        points: "148,103.5 129.8,103.5 129.8,118.2 93.2,118.2 93.2,84.5 56.8,84.5 56.8,75 20.2,75 20.2,100.2 2,100.2 2,125 148,125  "
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("polyline", {
        className: "graph-type-selector--graphic-line graphic-line-c",
        points: "2,100.2 20.2,100.2 20.2,75 56.8,75 56.8,84.5 93.2,84.5 93.2,118.2 129.8,118.2 129.8,103.5 148,103.5  "
    }))),
    'single-stat': /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "graph-type-selector--graphic"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("svg", {
        width: "100%",
        height: "100%",
        version: "1.1",
        id: "SingleStat",
        x: "0px",
        y: "0px",
        viewBox: "0 0 150 150",
        preserveAspectRatio: "none meet",
        shapeRendering: "geometricPrecision"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("path", {
        className: "graph-type-selector--graphic-fill graphic-fill-d",
        d: "M35.6,80.4h4.9v1.1h-4.9v7.8h-1.1v-7.8H20.7v-0.6l13.6-20.1h1.3V80.4z M22.4,80.4h12.1V62.1l-1.6,2.7 L22.4,80.4z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("path", {
        className: "graph-type-selector--graphic-fill graphic-fill-d",
        d: "M58.6,75.1c-0.7,1.5-1.8,2.7-3.2,3.6c-1.5,0.9-3.1,1.4-4.9,1.4c-1.6,0-3-0.4-4.2-1.3s-2.2-2-2.9-3.5 c-0.7-1.5-1.1-3.1-1.1-4.8c0-1.9,0.4-3.6,1.1-5.1c0.7-1.6,1.7-2.8,3-3.7c1.3-0.9,2.7-1.3,4.3-1.3c2.9,0,5.2,1,6.7,2.9 c1.5,1.9,2.3,4.7,2.3,8.3v3.3c0,4.8-1.1,8.5-3.2,11c-2.1,2.5-5.3,3.8-9.4,3.9H46l0-1.1h0.8c3.8,0,6.7-1.2,8.7-3.5 C57.6,82.8,58.6,79.5,58.6,75.1z M50.4,79c1.9,0,3.6-0.6,5.1-1.7s2.5-2.6,3-4.5v-1.2c0-3.3-0.7-5.8-2-7.5c-1.4-1.7-3.3-2.6-5.8-2.6 c-1.4,0-2.7,0.4-3.8,1.2s-2,1.9-2.6,3.3c-0.6,1.4-0.9,2.9-0.9,4.5c0,1.5,0.3,3,0.9,4.3c0.6,1.3,1.5,2.4,2.5,3.1 C47.8,78.7,49.1,79,50.4,79z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("path", {
        className: "graph-type-selector--graphic-fill graphic-fill-d",
        d: "M81.3,89.2h-17v-1.1L74,77c1.6-1.9,2.8-3.5,3.5-5c0.8-1.4,1.2-2.8,1.2-4c0-2.1-0.6-3.7-1.8-4.9 c-1.2-1.2-2.9-1.7-5.1-1.7c-1.3,0-2.5,0.3-3.6,1c-1.1,0.6-2,1.5-2.6,2.6c-0.6,1.1-0.9,2.4-0.9,3.8h-1.1c0-1.5,0.4-2.9,1.1-4.2 c0.7-1.3,1.7-2.3,2.9-3.1s2.6-1.1,4.2-1.1c2.5,0,4.5,0.7,5.9,2c1.4,1.3,2.1,3.2,2.1,5.6c0,2.2-1.2,4.9-3.7,7.9l-1.8,2.2l-8.6,10 h15.6V89.2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("path", {
        className: "graph-type-selector--graphic-fill graphic-fill-d",
        d: "M85.3,88.3c0-0.3,0.1-0.6,0.3-0.8c0.2-0.2,0.5-0.3,0.8-0.3c0.3,0,0.6,0.1,0.8,0.3s0.3,0.5,0.3,0.8 c0,0.3-0.1,0.6-0.3,0.8s-0.5,0.3-0.8,0.3c-0.3,0-0.6-0.1-0.8-0.3C85.4,88.8,85.3,88.6,85.3,88.3z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("path", {
        className: "graph-type-selector--graphic-fill graphic-fill-d",
        d: "M92.7,74.3L94,60.8h13.9v1.1H95l-1.2,11.4c0.7-0.6,1.6-1,2.7-1.4s2.2-0.5,3.3-0.5c2.6,0,4.6,0.8,6.1,2.4 c1.5,1.6,2.3,3.8,2.3,6.4c0,3.1-0.7,5.4-2.1,7c-1.4,1.6-3.4,2.4-5.9,2.4c-2.4,0-4.4-0.7-5.9-2.1c-1.5-1.4-2.3-3.3-2.5-5.8h1.1 c0.2,2.2,0.9,3.9,2.2,5.1c1.2,1.2,3,1.7,5.2,1.7c2.3,0,4.1-0.7,5.2-2.1c1.1-1.4,1.7-3.5,1.7-6.2c0-2.4-0.7-4.3-2-5.7 c-1.3-1.4-3.1-2.1-5.3-2.1c-1.4,0-2.6,0.2-3.6,0.5c-1,0.4-1.9,0.9-2.7,1.7L92.7,74.3z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("path", {
        className: "graph-type-selector--graphic-fill graphic-fill-d",
        d: "M113.8,74.3l1.3-13.6H129v1.1h-12.9l-1.2,11.4c0.7-0.6,1.6-1,2.7-1.4s2.2-0.5,3.3-0.5c2.6,0,4.6,0.8,6.1,2.4 c1.5,1.6,2.3,3.8,2.3,6.4c0,3.1-0.7,5.4-2.1,7c-1.4,1.6-3.4,2.4-5.9,2.4c-2.4,0-4.4-0.7-5.9-2.1c-1.5-1.4-2.3-3.3-2.5-5.8h1.1 c0.2,2.2,0.9,3.9,2.2,5.1c1.2,1.2,3,1.7,5.2,1.7c2.3,0,4.1-0.7,5.2-2.1c1.1-1.4,1.7-3.5,1.7-6.2c0-2.4-0.7-4.3-2-5.7 c-1.3-1.4-3.1-2.1-5.3-2.1c-1.4,0-2.6,0.2-3.6,0.5c-1,0.4-1.9,0.9-2.7,1.7L113.8,74.3z"
    }))),
    'line-plus-single-stat': /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "graph-type-selector--graphic"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("svg", {
        width: "100%",
        height: "100%",
        version: "1.1",
        id: "LineAndSingleStat",
        x: "0px",
        y: "0px",
        viewBox: "0 0 150 150",
        preserveAspectRatio: "none meet",
        shapeRendering: "geometricPrecision"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("polygon", {
        className: "graph-type-selector--graphic-fill graphic-fill-c",
        points: "148,88.2 111.5,95.5 75,25 38.5,54.7 2,66.7 2,125 148,125"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("polyline", {
        className: "graph-type-selector--graphic-line graphic-line-c",
        points: "2,66.7 38.5,54.7 75,25 111.5,95.5 148,88.2"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("path", {
        className: "graph-type-selector--graphic-fill graphic-fill-d",
        d: "M35.6,80.4h4.9v1.1h-4.9v7.8h-1.1v-7.8H20.7v-0.6l13.6-20.1h1.3V80.4z M22.4,80.4h12.1V62.1l-1.6,2.7 L22.4,80.4z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("path", {
        className: "graph-type-selector--graphic-fill graphic-fill-d",
        d: "M58.6,75.1c-0.7,1.5-1.8,2.7-3.2,3.6c-1.5,0.9-3.1,1.4-4.9,1.4c-1.6,0-3-0.4-4.2-1.3s-2.2-2-2.9-3.5 c-0.7-1.5-1.1-3.1-1.1-4.8c0-1.9,0.4-3.6,1.1-5.1c0.7-1.6,1.7-2.8,3-3.7c1.3-0.9,2.7-1.3,4.3-1.3c2.9,0,5.2,1,6.7,2.9 c1.5,1.9,2.3,4.7,2.3,8.3v3.3c0,4.8-1.1,8.5-3.2,11c-2.1,2.5-5.3,3.8-9.4,3.9H46l0-1.1h0.8c3.8,0,6.7-1.2,8.7-3.5 C57.6,82.8,58.6,79.5,58.6,75.1z M50.4,79c1.9,0,3.6-0.6,5.1-1.7s2.5-2.6,3-4.5v-1.2c0-3.3-0.7-5.8-2-7.5c-1.4-1.7-3.3-2.6-5.8-2.6 c-1.4,0-2.7,0.4-3.8,1.2s-2,1.9-2.6,3.3c-0.6,1.4-0.9,2.9-0.9,4.5c0,1.5,0.3,3,0.9,4.3c0.6,1.3,1.5,2.4,2.5,3.1 C47.8,78.7,49.1,79,50.4,79z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("path", {
        className: "graph-type-selector--graphic-fill graphic-fill-d",
        d: "M81.3,89.2h-17v-1.1L74,77c1.6-1.9,2.8-3.5,3.5-5c0.8-1.4,1.2-2.8,1.2-4c0-2.1-0.6-3.7-1.8-4.9 c-1.2-1.2-2.9-1.7-5.1-1.7c-1.3,0-2.5,0.3-3.6,1c-1.1,0.6-2,1.5-2.6,2.6c-0.6,1.1-0.9,2.4-0.9,3.8h-1.1c0-1.5,0.4-2.9,1.1-4.2 c0.7-1.3,1.7-2.3,2.9-3.1s2.6-1.1,4.2-1.1c2.5,0,4.5,0.7,5.9,2c1.4,1.3,2.1,3.2,2.1,5.6c0,2.2-1.2,4.9-3.7,7.9l-1.8,2.2l-8.6,10 h15.6V89.2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("path", {
        className: "graph-type-selector--graphic-fill graphic-fill-d",
        d: "M85.3,88.3c0-0.3,0.1-0.6,0.3-0.8c0.2-0.2,0.5-0.3,0.8-0.3c0.3,0,0.6,0.1,0.8,0.3s0.3,0.5,0.3,0.8 c0,0.3-0.1,0.6-0.3,0.8s-0.5,0.3-0.8,0.3c-0.3,0-0.6-0.1-0.8-0.3C85.4,88.8,85.3,88.6,85.3,88.3z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("path", {
        className: "graph-type-selector--graphic-fill graphic-fill-d",
        d: "M92.7,74.3L94,60.8h13.9v1.1H95l-1.2,11.4c0.7-0.6,1.6-1,2.7-1.4s2.2-0.5,3.3-0.5c2.6,0,4.6,0.8,6.1,2.4 c1.5,1.6,2.3,3.8,2.3,6.4c0,3.1-0.7,5.4-2.1,7c-1.4,1.6-3.4,2.4-5.9,2.4c-2.4,0-4.4-0.7-5.9-2.1c-1.5-1.4-2.3-3.3-2.5-5.8h1.1 c0.2,2.2,0.9,3.9,2.2,5.1c1.2,1.2,3,1.7,5.2,1.7c2.3,0,4.1-0.7,5.2-2.1c1.1-1.4,1.7-3.5,1.7-6.2c0-2.4-0.7-4.3-2-5.7 c-1.3-1.4-3.1-2.1-5.3-2.1c-1.4,0-2.6,0.2-3.6,0.5c-1,0.4-1.9,0.9-2.7,1.7L92.7,74.3z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("path", {
        className: "graph-type-selector--graphic-fill graphic-fill-d",
        d: "M113.8,74.3l1.3-13.6H129v1.1h-12.9l-1.2,11.4c0.7-0.6,1.6-1,2.7-1.4s2.2-0.5,3.3-0.5c2.6,0,4.6,0.8,6.1,2.4 c1.5,1.6,2.3,3.8,2.3,6.4c0,3.1-0.7,5.4-2.1,7c-1.4,1.6-3.4,2.4-5.9,2.4c-2.4,0-4.4-0.7-5.9-2.1c-1.5-1.4-2.3-3.3-2.5-5.8h1.1 c0.2,2.2,0.9,3.9,2.2,5.1c1.2,1.2,3,1.7,5.2,1.7c2.3,0,4.1-0.7,5.2-2.1c1.1-1.4,1.7-3.5,1.7-6.2c0-2.4-0.7-4.3-2-5.7 c-1.3-1.4-3.1-2.1-5.3-2.1c-1.4,0-2.6,0.2-3.6,0.5c-1,0.4-1.9,0.9-2.7,1.7L113.8,74.3z"
    }))),
    bar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "graph-type-selector--graphic"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("svg", {
        width: "100%",
        height: "100%",
        version: "1.1",
        id: "Bar",
        x: "0px",
        y: "0px",
        viewBox: "0 0 150 150",
        preserveAspectRatio: "none meet",
        shapeRendering: "geometricPrecision"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("rect", {
        x: "2",
        y: "108.4",
        className: "graph-type-selector--graphic-line graphic-line-a",
        width: "26.8",
        height: "16.6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("rect", {
        x: "31.8",
        y: "82.4",
        className: "graph-type-selector--graphic-line graphic-line-b",
        width: "26.8",
        height: "42.6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("rect", {
        x: "61.6",
        y: "28.8",
        className: "graph-type-selector--graphic-line graphic-line-c",
        width: "26.8",
        height: "96.2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("rect", {
        x: "91.4",
        y: "47.9",
        className: "graph-type-selector--graphic-line graphic-line-a",
        width: "26.8",
        height: "77.1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("rect", {
        x: "121.2",
        y: "25",
        className: "graph-type-selector--graphic-line graphic-line-b",
        width: "26.8",
        height: "100"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("rect", {
        x: "2",
        y: "108.4",
        className: "graph-type-selector--graphic-fill graphic-fill-a",
        width: "26.8",
        height: "16.6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("rect", {
        x: "31.8",
        y: "82.4",
        className: "graph-type-selector--graphic-fill graphic-fill-b",
        width: "26.8",
        height: "42.6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("rect", {
        x: "61.6",
        y: "28.8",
        className: "graph-type-selector--graphic-fill graphic-fill-c",
        width: "26.8",
        height: "96.2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("rect", {
        x: "91.4",
        y: "47.9",
        className: "graph-type-selector--graphic-fill graphic-fill-a",
        width: "26.8",
        height: "77.1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("rect", {
        x: "121.2",
        y: "25",
        className: "graph-type-selector--graphic-fill graphic-fill-b",
        width: "26.8",
        height: "100"
    }))),
    gauge: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "graph-type-selector--graphic"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("svg", {
        width: "100%",
        height: "100%",
        version: "1.1",
        id: "Bar",
        x: "0px",
        y: "0px",
        viewBox: "0 0 150 150",
        preserveAspectRatio: "none meet",
        shapeRendering: "geometricPrecision"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("path", {
        className: "graph-type-selector--graphic-line graphic-line-d",
        d: "M110.9,110.9c19.9-19.9,19.9-52,0-71.9s-52-19.9-71.9,0s-19.9,52,0,71.9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("line", {
        className: "graph-type-selector--graphic-line graphic-line-d",
        x1: "39.1",
        y1: "110.9",
        x2: "35",
        y2: "115"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("line", {
        className: "graph-type-selector--graphic-line graphic-line-d",
        x1: "110.9",
        y1: "110.9",
        x2: "115",
        y2: "115"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("line", {
        className: "graph-type-selector--graphic-line graphic-line-d",
        x1: "122",
        y1: "94.5",
        x2: "127.2",
        y2: "96.6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("line", {
        className: "graph-type-selector--graphic-line graphic-line-d",
        x1: "125.8",
        y1: "75",
        x2: "131.5",
        y2: "75"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("line", {
        className: "graph-type-selector--graphic-line graphic-line-d",
        x1: "122",
        y1: "55.5",
        x2: "127.2",
        y2: "53.4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("line", {
        className: "graph-type-selector--graphic-line graphic-line-d",
        x1: "110.9",
        y1: "39.1",
        x2: "115",
        y2: "35"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("line", {
        className: "graph-type-selector--graphic-line graphic-line-d",
        x1: "94.5",
        y1: "28",
        x2: "96.6",
        y2: "22.8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("line", {
        className: "graph-type-selector--graphic-line graphic-line-d",
        x1: "75",
        y1: "24.2",
        x2: "75",
        y2: "18.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("line", {
        className: "graph-type-selector--graphic-line graphic-line-d",
        x1: "55.5",
        y1: "28",
        x2: "53.4",
        y2: "22.8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("line", {
        className: "graph-type-selector--graphic-line graphic-line-d",
        x1: "39.1",
        y1: "39.1",
        x2: "35",
        y2: "35"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("line", {
        className: "graph-type-selector--graphic-line graphic-line-d",
        x1: "28",
        y1: "55.5",
        x2: "22.8",
        y2: "53.4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("line", {
        className: "graph-type-selector--graphic-line graphic-line-d",
        x1: "24.2",
        y1: "75",
        x2: "18.5",
        y2: "75"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("line", {
        className: "graph-type-selector--graphic-line graphic-line-d",
        x1: "28",
        y1: "94.5",
        x2: "22.8",
        y2: "96.6"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("path", {
        className: "graph-type-selector--graphic-fill graphic-fill-d",
        d: "M78.6,73.4L75,56.3l-3.6,17.1c-0.2,0.5-0.3,1-0.3,1.6c0,2.2,1.8,3.9,3.9,3.9s3.9-1.8,3.9-3.9C78.9,74.4,78.8,73.9,78.6,73.4z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("path", {
        className: "graph-type-selector--graphic-fill graphic-fill-a",
        d: "M58.9,58.9c8.9-8.9,23.4-8.9,32.3,0l17.1-17.1c-18.4-18.4-48.2-18.4-66.5,0C32.5,50.9,27.9,63,27.9,75h24.2C52.2,69.2,54.4,63.3,58.9,58.9z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("path", {
        className: "graph-type-selector--graphic-line graphic-line-a",
        d: "M58.9,58.9c8.9-8.9,23.4-8.9,32.3,0l17.1-17.1c-18.4-18.4-48.2-18.4-66.5,0C32.5,50.9,27.9,63,27.9,75h24.2C52.2,69.2,54.4,63.3,58.9,58.9z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("path", {
        className: "graph-type-selector--graphic-fill graphic-fill-b",
        d: "M58.9,91.1c-4.5-4.5-6.7-10.3-6.7-16.1H27.9c0,12,4.6,24.1,13.8,33.3L58.9,91.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("path", {
        className: "graph-type-selector--graphic-line graphic-line-b",
        d: "M58.9,91.1c-4.5-4.5-6.7-10.3-6.7-16.1H27.9c0,12,4.6,24.1,13.8,33.3L58.9,91.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("path", {
        className: "graph-type-selector--graphic-fill graphic-fill-c",
        d: "M91.1,91.1l17.1,17.1c18.4-18.4,18.4-48.2,0-66.6L91.1,58.9C100.1,67.8,100.1,82.2,91.1,91.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("path", {
        className: "graph-type-selector--graphic-line graphic-line-c",
        d: "M91.1,91.1l17.1,17.1c18.4-18.4,18.4-48.2,0-66.6L91.1,58.9C100.1,67.8,100.1,82.2,91.1,91.1z"
    }))),
    table: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "graph-type-selector--graphic"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("svg", {
        id: "Table",
        x: "0px",
        y: "0px",
        width: "100%",
        height: "100%",
        viewBox: "0 0 150 150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("path", {
        className: "graph-type-selector--graphic-fill graphic-fill-c",
        d: "M55.5,115H19.7c-1.7,0-3.1-1.4-3.1-3.1V61.7h38.9V115z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("path", {
        className: "graph-type-selector--graphic-fill graphic-fill-b",
        d: "M133.4,61.7H55.5V35h74.8c1.7,0,3.1,1.4,3.1,3.1V61.7z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("path", {
        className: "graph-type-selector--graphic-fill graphic-fill-a",
        d: "M55.5,61.7H16.6V38.1c0-1.7,1.4-3.1,3.1-3.1h35.9V61.7z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("path", {
        className: "graph-type-selector--graphic-line graphic-line-c",
        d: "M16.6,88.3v23.6c0,1.7,1.4,3.1,3.1,3.1h35.9V88.3H16.6z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("rect", {
        className: "graph-type-selector--graphic-line graphic-line-c",
        x: "16.6",
        y: "61.7",
        width: "38.9",
        height: "26.7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("path", {
        className: "graph-type-selector--graphic-line graphic-line-b",
        d: "M94.5,35v26.7h38.9V38.1c0-1.7-1.4-3.1-3.1-3.1H94.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("rect", {
        className: "graph-type-selector--graphic-line graphic-line-b",
        x: "55.5",
        y: "35",
        width: "38.9",
        height: "26.7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("path", {
        className: "graph-type-selector--graphic-line graphic-line-d",
        d: "M94.5,115h35.9c1.7,0,3.1-1.4,3.1-3.1V88.3H94.5V115z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("rect", {
        className: "graph-type-selector--graphic-line graphic-line-d",
        x: "55.5",
        y: "88.3",
        width: "38.9",
        height: "26.7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("rect", {
        className: "graph-type-selector--graphic-line graphic-line-d",
        x: "94.5",
        y: "61.7",
        width: "38.9",
        height: "26.7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("rect", {
        className: "graph-type-selector--graphic-line graphic-line-d",
        x: "55.5",
        y: "61.7",
        width: "38.9",
        height: "26.7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("path", {
        className: "graph-type-selector--graphic-line graphic-line-a",
        d: "M55.5,35H19.7c-1.7,0-3.1,1.4-3.1,3.1v23.6h38.9V35z"
    }))),
    note: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "graph-type-selector--graphic"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("svg", {
        id: "Note",
        x: "0px",
        y: "0px",
        width: "100%",
        height: "100%",
        viewBox: "0 0 150 150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("path", {
        className: "graph-type-selector--graphic-fill graphic-fill-a",
        d: "M61,97.3H37l-4.2,13.6H14l26.7-72.8h16.5l26.9,72.8H65.3L61,97.3z M41.2,83.8h15.7L49,58.5L41.2,83.8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("path", {
        className: "graph-type-selector--graphic-fill graphic-fill-b",
        d: "M119.1,110.9c-0.6-1.1-1.1-2.7-1.6-4.9c-3.1,3.9-7.4,5.9-13,5.9c-5.1,0-9.4-1.5-13-4.6c-3.6-3.1-5.4-7-5.4-11.6  c0-5.9,2.2-10.3,6.5-13.3c4.3-3,10.6-4.5,18.9-4.5h5.2V75c0-5-2.2-7.5-6.5-7.5c-4,0-6,2-6,5.9H87.5c0-5.2,2.2-9.5,6.7-12.7  c4.5-3.3,10.1-4.9,17-4.9c6.9,0,12.4,1.7,16.4,5.1c4,3.4,6.1,8,6.2,13.9v24c0.1,5,0.8,8.8,2.3,11.4v0.9H119.1z M108.6,99.9  c2.1,0,3.8-0.5,5.2-1.4c1.4-0.9,2.4-1.9,3-3.1v-8.7h-4.9c-5.9,0-8.8,2.6-8.8,7.9c0,1.5,0.5,2.8,1.6,3.7  C105.7,99.4,107,99.9,108.6,99.9z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("path", {
        className: "graph-type-selector--graphic-line graphic-line-a",
        d: "M61,97.3H37l-4.2,13.6H14l26.7-72.8h16.5l26.9,72.8H65.3L61,97.3z M41.2,83.8h15.7L49,58.5L41.2,83.8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("path", {
        className: "graph-type-selector--graphic-line graphic-line-b",
        d: "M119.1,110.9c-0.6-1.1-1.1-2.7-1.6-4.9c-3.1,3.9-7.4,5.9-13,5.9c-5.1,0-9.4-1.5-13-4.6c-3.6-3.1-5.4-7-5.4-11.6  c0-5.9,2.2-10.3,6.5-13.3c4.3-3,10.6-4.5,18.9-4.5h5.2V75c0-5-2.2-7.5-6.5-7.5c-4,0-6,2-6,5.9H87.5c0-5.2,2.2-9.5,6.7-12.7  c4.5-3.3,10.1-4.9,17-4.9c6.9,0,12.4,1.7,16.4,5.1c4,3.4,6.1,8,6.2,13.9v24c0.1,5,0.8,8.8,2.3,11.4v0.9H119.1z M108.6,99.9  c2.1,0,3.8-0.5,5.2-1.4c1.4-0.9,2.4-1.9,3-3.1v-8.7h-4.9c-5.9,0-8.8,2.6-8.8,7.9c0,1.5,0.5,2.8,1.6,3.7  C105.7,99.4,107,99.9,108.6,99.9z"
    })))
};
const $68fa0144111754ce$export$68ca4bab3ef5b52c = [
    {
        type: (0, $b4506126e09430df$export$705e36171f4cbbfe).Line,
        menuOption: 'Line',
        graphic: $68fa0144111754ce$var$GRAPH_SVGS[(0, $b4506126e09430df$export$705e36171f4cbbfe).Line]
    },
    {
        type: (0, $b4506126e09430df$export$705e36171f4cbbfe).Stacked,
        menuOption: 'Stacked',
        graphic: $68fa0144111754ce$var$GRAPH_SVGS[(0, $b4506126e09430df$export$705e36171f4cbbfe).Stacked]
    },
    {
        type: (0, $b4506126e09430df$export$705e36171f4cbbfe).StepPlot,
        menuOption: 'Step-Plot',
        graphic: $68fa0144111754ce$var$GRAPH_SVGS[(0, $b4506126e09430df$export$705e36171f4cbbfe).StepPlot]
    },
    {
        type: (0, $b4506126e09430df$export$705e36171f4cbbfe).Bar,
        menuOption: 'Bar',
        graphic: $68fa0144111754ce$var$GRAPH_SVGS[(0, $b4506126e09430df$export$705e36171f4cbbfe).Bar]
    },
    {
        type: (0, $b4506126e09430df$export$705e36171f4cbbfe).LinePlusSingleStat,
        menuOption: 'Line + Single Stat',
        graphic: $68fa0144111754ce$var$GRAPH_SVGS[(0, $b4506126e09430df$export$705e36171f4cbbfe).LinePlusSingleStat]
    },
    {
        type: (0, $b4506126e09430df$export$705e36171f4cbbfe).SingleStat,
        menuOption: 'Single Stat',
        graphic: $68fa0144111754ce$var$GRAPH_SVGS[(0, $b4506126e09430df$export$705e36171f4cbbfe).SingleStat]
    },
    {
        type: (0, $b4506126e09430df$export$705e36171f4cbbfe).Gauge,
        menuOption: 'Gauge',
        graphic: $68fa0144111754ce$var$GRAPH_SVGS[(0, $b4506126e09430df$export$705e36171f4cbbfe).Gauge]
    },
    {
        type: (0, $b4506126e09430df$export$705e36171f4cbbfe).Table,
        menuOption: 'Table',
        graphic: $68fa0144111754ce$var$GRAPH_SVGS[(0, $b4506126e09430df$export$705e36171f4cbbfe).Table]
    },
    {
        type: (0, $b4506126e09430df$export$705e36171f4cbbfe).Note,
        menuOption: 'Note',
        graphic: $68fa0144111754ce$var$GRAPH_SVGS[(0, $b4506126e09430df$export$705e36171f4cbbfe).Note]
    }
];



class $478edc63805402e8$var$GraphTypeSelector extends (0, $NdCUR.Component) {
    render() {
        const { type: type } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), {
            autoHide: false,
            className: "graph-type-selector"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "graph-type-selector--container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "graph-type-selector--grid"
        }, (0, $68fa0144111754ce$export$68ca4bab3ef5b52c).map((graphType)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                key: graphType.type,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('graph-type-selector--option', {
                    active: graphType.type === type
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                onClick: this.onChangeCellType(graphType.type)
            }, graphType.graphic, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, graphType.menuOption)))))));
    }
    constructor(...args){
        super(...args), this.onChangeCellType = (newType)=>()=>{
                this.props.onUpdateVisType(newType);
            };
    }
}
var $478edc63805402e8$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($478edc63805402e8$var$GraphTypeSelector);


// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");



var $NdCUR = parcelRequire("NdCUR");

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");




class $5e39ab524a8799f2$var$ColorDropdown extends (0, $NdCUR.Component) {
    static{
        this.defaultProps = {
            stretchToFit: false,
            disabled: false
        };
    }
    constructor(props){
        super(props), this.handleToggleMenu = ()=>{
            const { disabled: disabled } = this.props;
            if (disabled) return;
            this.setState({
                visible: !this.state.visible
            });
        }, this.handleClickOutside = ()=>{
            this.setState({
                visible: false
            });
        }, this.handleColorClick = (color)=>()=>{
                this.props.onChoose(color);
                this.setState({
                    visible: false
                });
            };
        this.state = {
            visible: false
        };
    }
    render() {
        const { visible: visible } = this.state;
        const { selected: selected } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1f11d3536bc98f8a$export$c16e4f034c84cb3f), {
            onClickOutside: this.handleClickOutside
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.dropdownClassNames
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.buttonClassNames,
            onClick: this.handleToggleMenu
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "color-dropdown--swatch",
            style: {
                backgroundColor: selected.hex
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "color-dropdown--name"
        }, selected.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "caret"
        })), visible && this.renderMenu));
    }
    get dropdownClassNames() {
        const { stretchToFit: stretchToFit } = this.props;
        const { visible: visible } = this.state;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('color-dropdown', {
            open: visible,
            'color-dropdown--stretch': stretchToFit
        });
    }
    get buttonClassNames() {
        const { disabled: disabled } = this.props;
        const { visible: visible } = this.state;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('btn btn-sm btn-default color-dropdown--toggle', {
            active: visible,
            'color-dropdown__disabled': disabled
        });
    }
    get renderMenu() {
        const { colors: colors, selected: selected } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "color-dropdown--menu"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), {
            autoHide: false,
            autoHeight: true,
            maxHeight: (0, $e10a8602f56394e3$export$bd1588cc2d72fbf)
        }, colors.map((color, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                className: color.name === selected.name ? 'color-dropdown--item active' : 'color-dropdown--item',
                key: i,
                onClick: this.handleColorClick(color),
                "data-test": "base-colour"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
                className: "color-dropdown--swatch",
                style: {
                    backgroundColor: color.hex
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
                className: "color-dropdown--name"
            }, color.name)))));
    }
}
var $5e39ab524a8799f2$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($5e39ab524a8799f2$var$ColorDropdown);




class $7551fc5268596d42$var$Threshold extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleChooseColor = (color)=>{
            const { onChooseColor: onChooseColor, threshold: threshold } = this.props;
            const { hex: hex, name: name } = color;
            onChooseColor({
                ...threshold,
                hex: hex,
                name: name
            });
        }, this.handleChangeWorkingValue = (e)=>{
            const { threshold: threshold, onValidateColorValue: onValidateColorValue } = this.props;
            const targetValue = e.target.value;
            const valid = onValidateColorValue(threshold, Number(targetValue));
            this.setState({
                valid: valid,
                workingValue: targetValue
            });
        }, this.handleBlur = ()=>{
            const { valid: valid, workingValue: workingValue } = this.state;
            const { threshold: threshold, onUpdateColorValue: onUpdateColorValue } = this.props;
            if (valid) onUpdateColorValue(threshold, Number(workingValue));
            else this.setState({
                workingValue: threshold.value,
                valid: true
            });
        }, this.handleKeyUp = (e)=>{
            if (e.key === 'Enter') this.thresholdInputRef.blur();
        }, this.handleInputRef = (ref)=>{
            this.thresholdInputRef = ref;
        }, this.handleDelete = ()=>{
            const { threshold: threshold, onDeleteThreshold: onDeleteThreshold } = this.props;
            onDeleteThreshold(threshold);
        };
        this.state = {
            workingValue: this.props.threshold.value,
            valid: true
        };
    }
    render() {
        const { disableMaxColor: disableMaxColor, isMax: isMax } = this.props;
        const { workingValue: workingValue } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "threshold-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.labelClass
        }, this.label), this.canBeDeleted ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-default btn-sm btn-square",
            onClick: this.handleDelete
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon remove"
        })) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            value: workingValue,
            className: this.inputClass,
            type: "number",
            onChange: this.handleChangeWorkingValue,
            onBlur: this.handleBlur,
            onKeyUp: this.handleKeyUp,
            ref: this.handleInputRef
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $5e39ab524a8799f2$export$2e2bcd8739ae039), {
            colors: (0, $687ef8d4c4e21a50$export$5d93f993ca7fe88c),
            selected: this.selectedColor,
            onChoose: this.handleChooseColor,
            disabled: isMax && disableMaxColor
        }));
    }
    get selectedColor() {
        const { threshold: { hex: hex, name: name, type: type, value: value, id: id } } = this.props;
        return {
            hex: hex,
            name: name,
            type: type,
            value: value,
            id: id
        };
    }
    get inputClass() {
        const { valid: valid } = this.state;
        const inputClass = valid ? 'form-control input-sm threshold-item--input' : 'form-control input-sm threshold-item--input form-volcano';
        return inputClass;
    }
    get canBeDeleted() {
        const { visualizationType: visualizationType, isMax: isMax, isMin: isMin } = this.props;
        let canBeDeleted = true;
        if (visualizationType === 'gauge') canBeDeleted = !(isMin || isMax);
        return canBeDeleted;
    }
    get labelClass() {
        const { visualizationType: visualizationType, isMax: isMax, isMin: isMin } = this.props;
        let labelClass = 'threshold-item--label__editable';
        if (visualizationType === 'gauge') labelClass = isMin || isMax ? 'threshold-item--label' : 'threshold-item--label__editable';
        return labelClass;
    }
    get label() {
        let label = 'Threshold';
        const { visualizationType: visualizationType, isMax: isMax, isMin: isMin } = this.props;
        if (isMin && visualizationType === 'gauge') label = 'Minimum';
        if (isMax && visualizationType === 'gauge') label = 'Maximum';
        return label;
    }
}
var $7551fc5268596d42$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($7551fc5268596d42$var$Threshold);



var $NdCUR = parcelRequire("NdCUR");


var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");


var $NdCUR = parcelRequire("NdCUR");


class $1bd4a1c0f48c0186$var$ClickOutsideInput extends (0, $NdCUR.Component) {
    constructor(props){
        super(props), this.handleClickOutside = (e)=>{
            this.props.handleClickOutsideInput(e);
        };
    }
    render() {
        const { id: id, min: min = '', type: type, onFocus: onFocus, onChange: onChange, onGetRef: onGetRef, onKeyDown: onKeyDown, customValue: customValue, customPlaceholder: customPlaceholder, max: max } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control input-sm",
            id: id,
            min: min,
            max: max,
            type: type,
            name: customPlaceholder,
            ref: onGetRef,
            value: customValue,
            onFocus: onFocus,
            onChange: onChange,
            onKeyDown: onKeyDown,
            placeholder: customPlaceholder
        });
    }
}
var $1bd4a1c0f48c0186$export$2e2bcd8739ae039 = (0, $1636633b789d0ee3$export$2e2bcd8739ae039)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($1bd4a1c0f48c0186$var$ClickOutsideInput));




class $7cd59214313b7fad$var$OptIn extends (0, $NdCUR.Component) {
    static{
        this.defaultProps = {
            min: '',
            fixedValue: '',
            customValue: '',
            fixedPlaceholder: 'auto',
            customPlaceholder: 'Custom Value'
        };
    }
    constructor(props){
        super(props), this.useFixedValue = ()=>{
            this.setState({
                useCustomValue: false,
                customValue: ''
            }, ()=>this.setValue());
        }, this.useCustomValue = ()=>{
            this.setState({
                useCustomValue: true
            }, ()=>this.setValue());
        }, this.handleClickToggle = ()=>{
            const useCustomValueNext = !this.state.useCustomValue;
            if (useCustomValueNext) {
                this.useCustomValue();
                this.customValueInput.focus();
            } else this.useFixedValue();
        }, this.handleFocusCustomValueInput = ()=>{
            this.isCustomValueInputFocused = true;
            this.useCustomValue();
        }, // Typing into number inputs does not enforce min/max
        this.handleChangeCustomValue = (e)=>{
            const { min: min, max: max, type: type } = this.props;
            const { value: value } = e.target;
            if (value === '') this.setCustomValue('');
            else if (type === 'text') this.setCustomValue(value);
            else if (type === 'number') this.setCustomValue((0, $e4e77e3c79ee997a$export$54c7b4b3a1bb17ef)(value, min, max));
        }, this.handleKeyDownCustomValueInput = (e)=>{
            if (e.key === 'Enter' || e.key === 'Tab') {
                if (e.key === 'Enter') this.customValueInput.blur();
                this.considerResetCustomValue();
            }
        }, this.handleClickOutsideInput = (e)=>{
            if (e.currentTarget.id !== this.grooveKnob.id && e.currentTarget.id !== this.grooveKnobContainer.id && this.isCustomValueInputFocused) this.considerResetCustomValue();
        }, this.considerResetCustomValue = ()=>{
            const customValue = this.customValueInput.value.trim();
            this.setState({
                customValue: customValue
            });
            if (customValue === '') this.useFixedValue();
            this.isCustomValueInputFocused = false;
        }, this.setCustomValue = (value)=>{
            this.setState({
                customValue: value
            }, this.setValue);
        }, this.setValue = ()=>{
            const { onSetValue: onSetValue } = this.props;
            const { useCustomValue: useCustomValue, fixedValue: fixedValue, customValue: customValue } = this.state;
            if (useCustomValue) onSetValue(customValue);
            else onSetValue(fixedValue);
        }, this.handleInputRef = (el)=>this.customValueInput = el;
        const { customValue: customValue, fixedValue: fixedValue } = props;
        this.state = {
            useCustomValue: customValue !== '',
            fixedValue: fixedValue,
            customValue: customValue
        };
        this.id = (0, $dbdc5944552afab7$export$2e2bcd8739ae039)();
        this.isCustomValueInputFocused = false;
    }
    render() {
        const { fixedPlaceholder: fixedPlaceholder, customPlaceholder: customPlaceholder, type: type, min: min, max: max } = this.props;
        const { useCustomValue: useCustomValue, customValue: customValue } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('opt-in', {
                'right-toggled': useCustomValue
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1bd4a1c0f48c0186$export$2e2bcd8739ae039), {
            id: this.id,
            min: min,
            type: type,
            max: max,
            customValue: customValue,
            onGetRef: this.handleInputRef,
            customPlaceholder: customPlaceholder,
            onChange: this.handleChangeCustomValue,
            onFocus: this.handleFocusCustomValueInput,
            onKeyDown: this.handleKeyDownCustomValueInput,
            handleClickOutsideInput: this.handleClickOutsideInput
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "opt-in--container",
            id: this.id,
            ref: (el)=>this.grooveKnobContainer = el
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "opt-in--groove-knob",
            id: this.id,
            ref: (el)=>this.grooveKnob = el,
            onClick: this.handleClickToggle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "opt-in--gradient"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "opt-in--label",
            onClick: this.useFixedValue
        }, fixedPlaceholder)));
    }
}
var $7cd59214313b7fad$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($7cd59214313b7fad$var$OptIn);



const $10b110c1051f2fb8$var$fixedValueString = 'fixed';
const $10b110c1051f2fb8$var$defaultPlaceholder = 'unlimited';
class $10b110c1051f2fb8$var$GraphOptionsDecimalPlaces extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleSetValue = (valueFromSelector)=>{
            let digits;
            let isEnforced;
            if (valueFromSelector === $10b110c1051f2fb8$var$fixedValueString) {
                digits = this.props.digits;
                isEnforced = false;
            } else if (valueFromSelector === '') {
                digits = this.props.digits;
                isEnforced = true;
            } else {
                digits = Number(valueFromSelector);
                if (digits < 0) digits = 0;
                isEnforced = true;
            }
            this.props.onDecimalPlacesChange({
                digits: digits,
                isEnforced: isEnforced
            });
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", null, " Decimal Places "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7cd59214313b7fad$export$2e2bcd8739ae039), {
            min: (0, $9a9ec629fdd38845$export$a45f245a164ecd67),
            max: (0, $9a9ec629fdd38845$export$feaf255c45293dde),
            type: "number",
            fixedPlaceholder: "",
            customValue: this.value,
            fixedValue: $10b110c1051f2fb8$var$fixedValueString,
            onSetValue: this.handleSetValue,
            customPlaceholder: this.placeholder
        }));
    }
    get placeholder() {
        const { isEnforced: isEnforced, digits: digits } = this.props;
        if (!isEnforced) return $10b110c1051f2fb8$var$defaultPlaceholder;
        return `${digits}`;
    }
    get value() {
        const { isEnforced: isEnforced, digits: digits } = this.props;
        if (!isEnforced) return '';
        return `${digits}`;
    }
}
var $10b110c1051f2fb8$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($10b110c1051f2fb8$var$GraphOptionsDecimalPlaces);




class $9cb4a18217166637$var$GaugeOptions extends (0, $NdCUR.PureComponent) {
    render() {
        const { gaugeColors: gaugeColors, axes: axes, decimalPlaces: decimalPlaces } = this.props;
        const { y: y } = axes;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), {
            className: "display-options",
            autoHide: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "display-options--wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h5", {
            className: "display-options--header"
        }, "Gauge Controls"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "thresholds-list"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-sm btn-primary",
            onClick: this.handleAddThreshold,
            disabled: this.disableAddThreshold
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon plus"
        }), " Add Threshold"), this.sortedGaugeColors.map((color, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7551fc5268596d42$export$2e2bcd8739ae039), {
                isMin: index === 0,
                isMax: index === gaugeColors.length - 1,
                visualizationType: "gauge",
                threshold: color,
                key: index,
                disableMaxColor: this.disableMaxColor,
                onChooseColor: this.handleChooseColor,
                onValidateColorValue: this.handleValidateColorValue,
                onUpdateColorValue: this.handleUpdateColorValue,
                onDeleteThreshold: this.handleDeleteThreshold
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "graph-options-group form-group-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", null, "Prefix"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control input-sm",
            placeholder: "%, MPH, etc.",
            defaultValue: y.prefix,
            onChange: this.handleUpdatePrefix
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", null, "Suffix"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control input-sm",
            placeholder: "%, MPH, etc.",
            defaultValue: y.suffix,
            onChange: this.handleUpdateSuffix
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $10b110c1051f2fb8$export$2e2bcd8739ae039), {
            digits: decimalPlaces.digits,
            isEnforced: decimalPlaces.isEnforced,
            onDecimalPlacesChange: this.handleDecimalPlacesChange
        }))));
    }
    get disableMaxColor() {
        const { gaugeColors: gaugeColors } = this.props;
        return gaugeColors.length > (0, $687ef8d4c4e21a50$export$1ffb333534e7f6f7);
    }
    get disableAddThreshold() {
        const { gaugeColors: gaugeColors } = this.props;
        return gaugeColors.length > (0, $687ef8d4c4e21a50$export$e825345a8afe09c1);
    }
    get sortedGaugeColors() {
        const { gaugeColors: gaugeColors } = this.props;
        const sortedColors = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).sortBy(gaugeColors, 'value');
        return sortedColors;
    }
    constructor(...args){
        super(...args), this.handleDecimalPlacesChange = (decimalPlaces)=>{
            const { onUpdateDecimalPlaces: onUpdateDecimalPlaces } = this.props;
            onUpdateDecimalPlaces(decimalPlaces);
        }, this.handleAddThreshold = ()=>{
            const { gaugeColors: gaugeColors, onUpdateGaugeColors: onUpdateGaugeColors, onResetFocus: onResetFocus } = this.props;
            const sortedColors = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).sortBy(gaugeColors, (color)=>color.value);
            if (sortedColors.length <= (0, $687ef8d4c4e21a50$export$e825345a8afe09c1)) {
                const randomColor = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).random(0, (0, $687ef8d4c4e21a50$export$5d93f993ca7fe88c).length - 1);
                const maxValue = sortedColors[sortedColors.length - 1].value;
                const minValue = sortedColors[0].value;
                const colorsValues = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).mapValues(gaugeColors, 'value');
                let randomValue;
                do randomValue = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).round((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).random(minValue, maxValue, true), 2);
                while ((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).includes(colorsValues, randomValue));
                const newThreshold = {
                    type: (0, $687ef8d4c4e21a50$export$a4cd1ddf7920c908),
                    id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
                    value: randomValue,
                    hex: (0, $687ef8d4c4e21a50$export$5d93f993ca7fe88c)[randomColor].hex,
                    name: (0, $687ef8d4c4e21a50$export$5d93f993ca7fe88c)[randomColor].name
                };
                const updatedColors = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).sortBy([
                    ...gaugeColors,
                    newThreshold
                ], (color)=>color.value);
                onUpdateGaugeColors(updatedColors);
            } else onResetFocus();
        }, this.handleDeleteThreshold = (threshold)=>{
            const { onUpdateGaugeColors: onUpdateGaugeColors, onResetFocus: onResetFocus } = this.props;
            const gaugeColors = this.props.gaugeColors.filter((color)=>color.id !== threshold.id);
            const sortedColors = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).sortBy(gaugeColors, (color)=>color.value);
            onUpdateGaugeColors(sortedColors);
            onResetFocus();
        }, this.handleChooseColor = (threshold)=>{
            const { onUpdateGaugeColors: onUpdateGaugeColors } = this.props;
            const gaugeColors = this.props.gaugeColors.map((color)=>color.id === threshold.id ? {
                    ...color,
                    hex: threshold.hex,
                    name: threshold.name
                } : color);
            onUpdateGaugeColors(gaugeColors);
        }, this.handleUpdateColorValue = (threshold, value)=>{
            const { onUpdateGaugeColors: onUpdateGaugeColors } = this.props;
            const gaugeColors = this.props.gaugeColors.map((color)=>color.id === threshold.id ? {
                    ...color,
                    value: value
                } : color);
            onUpdateGaugeColors(gaugeColors);
        }, this.handleValidateColorValue = (threshold, targetValue)=>{
            const { gaugeColors: gaugeColors } = this.props;
            const thresholdValue = threshold.value;
            let allowedToUpdate = false;
            const sortedColors = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).sortBy(gaugeColors, (color)=>color.value);
            const minValue = sortedColors[0].value;
            const maxValue = sortedColors[sortedColors.length - 1].value;
            // If lowest value, make sure it is less than the next threshold
            if (thresholdValue === minValue) {
                const nextValue = sortedColors[1].value;
                allowedToUpdate = targetValue < nextValue;
            }
            // If highest value, make sure it is greater than the previous threshold
            if (thresholdValue === maxValue) {
                const previousValue = sortedColors[sortedColors.length - 2].value;
                allowedToUpdate = previousValue < targetValue;
            }
            // If not min or max, make sure new value is greater than min, less than max, and unique
            if (thresholdValue !== minValue && thresholdValue !== maxValue) {
                const greaterThanMin = targetValue > minValue;
                const lessThanMax = targetValue < maxValue;
                const colorsWithoutMinOrMax = sortedColors.slice(1, sortedColors.length - 1);
                const isUnique = !colorsWithoutMinOrMax.some((color)=>color.value === targetValue && color.id !== threshold.id);
                allowedToUpdate = greaterThanMin && lessThanMax && isUnique;
            }
            return allowedToUpdate;
        }, this.handleUpdatePrefix = (e)=>{
            const { onUpdateAxes: onUpdateAxes, axes: axes } = this.props;
            const newAxes = {
                ...axes,
                y: {
                    ...axes.y,
                    prefix: e.target.value
                }
            };
            onUpdateAxes(newAxes);
        }, this.handleUpdateSuffix = (e)=>{
            const { onUpdateAxes: onUpdateAxes, axes: axes } = this.props;
            const newAxes = {
                ...axes,
                y: {
                    ...axes.y,
                    suffix: e.target.value
                }
            };
            onUpdateAxes(newAxes);
        };
    }
}
var $9cb4a18217166637$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($9cb4a18217166637$var$GaugeOptions);


// Libraries

var $NdCUR = parcelRequire("NdCUR");

// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");





class $64a4459bb2082149$var$ThresholdsList extends (0, $NdCUR.PureComponent) {
    static{
        this.defaultProps = {
            showListHeading: false
        };
    }
    get sortedColors() {
        const { thresholdsListColors: thresholdsListColors } = this.props;
        const sortedColors = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).sortBy(thresholdsListColors, 'value');
        return sortedColors;
    }
    render() {
        const { thresholdsListColors: thresholdsListColors, showListHeading: showListHeading } = this.props;
        const disableAddThreshold = thresholdsListColors.length > (0, $687ef8d4c4e21a50$export$e825345a8afe09c1);
        const thresholdsListClass = `thresholds-list${showListHeading ? ' graph-options-group' : ''}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: thresholdsListClass
        }, showListHeading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            className: "form-label"
        }, "Thresholds"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-sm btn-primary",
            onClick: this.handleAddThreshold,
            disabled: disableAddThreshold
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon plus"
        }), " Add Threshold"), this.sortedColors.map((color, i)=>color.id === (0, $687ef8d4c4e21a50$export$e0707546bf05d408) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                className: "threshold-item",
                key: i
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                className: "threshold-item--label"
            }, "Base Color"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $5e39ab524a8799f2$export$2e2bcd8739ae039), {
                colors: (0, $687ef8d4c4e21a50$export$5d93f993ca7fe88c),
                selected: color,
                onChoose: this.handleChangeBaseColor,
                stretchToFit: true
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7551fc5268596d42$export$2e2bcd8739ae039), {
                key: color.id,
                visualizationType: "single-stat",
                threshold: color,
                onChooseColor: this.handleChooseColor,
                onValidateColorValue: this.handleValidateColorValue,
                onUpdateColorValue: this.handleUpdateColorValue,
                onDeleteThreshold: this.handleDeleteThreshold,
                disableMaxColor: false,
                isMin: false,
                isMax: false
            })));
    }
    constructor(...args){
        super(...args), this.handleAddThreshold = ()=>{
            const { thresholdsListColors: thresholdsListColors, thresholdsListType: thresholdsListType, onUpdateThresholdsListColors: onUpdateThresholdsListColors, onResetFocus: onResetFocus } = this.props;
            const randomColor = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).random(0, (0, $687ef8d4c4e21a50$export$5d93f993ca7fe88c).length - 1);
            const maxValue = (0, $687ef8d4c4e21a50$export$4efca9f8f9bfa6d0);
            const minValue = (0, $687ef8d4c4e21a50$export$375fdf781bc228a8);
            let randomValue = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).round((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).random(minValue, maxValue, true), 2);
            if (thresholdsListColors.length > 0) {
                const colorsValues = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).mapValues(thresholdsListColors, 'value');
                do randomValue = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).round((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).random(minValue, maxValue, true), 2);
                while ((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).includes(colorsValues, randomValue));
            }
            const newThreshold = {
                type: thresholdsListType,
                id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
                value: randomValue,
                hex: (0, $687ef8d4c4e21a50$export$5d93f993ca7fe88c)[randomColor].hex,
                name: (0, $687ef8d4c4e21a50$export$5d93f993ca7fe88c)[randomColor].name
            };
            const updatedColors = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).sortBy([
                ...thresholdsListColors,
                newThreshold
            ], (color)=>color.value);
            onUpdateThresholdsListColors(updatedColors);
            onResetFocus();
        }, this.handleChangeBaseColor = (updatedColor)=>{
            const { onUpdateThresholdsListColors: onUpdateThresholdsListColors } = this.props;
            const { hex: hex, name: name } = updatedColor;
            const thresholdsListColors = this.props.thresholdsListColors.map((color)=>color.id === (0, $687ef8d4c4e21a50$export$e0707546bf05d408) ? {
                    ...color,
                    hex: hex,
                    name: name
                } : color);
            onUpdateThresholdsListColors(thresholdsListColors);
        }, this.handleChooseColor = (updatedColor)=>{
            const { onUpdateThresholdsListColors: onUpdateThresholdsListColors } = this.props;
            const thresholdsListColors = this.props.thresholdsListColors.map((color)=>color.id === updatedColor.id ? updatedColor : color);
            onUpdateThresholdsListColors(thresholdsListColors);
        }, this.handleDeleteThreshold = (threshold)=>{
            const { onUpdateThresholdsListColors: onUpdateThresholdsListColors, onResetFocus: onResetFocus, thresholdsListColors: thresholdsListColors } = this.props;
            const updatedThresholdsListColors = thresholdsListColors.filter((color)=>color.id !== threshold.id);
            const sortedColors = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).sortBy(updatedThresholdsListColors, (color)=>color.value);
            onUpdateThresholdsListColors(sortedColors);
            onResetFocus();
        }, this.handleUpdateColorValue = (threshold, value)=>{
            const { onUpdateThresholdsListColors: onUpdateThresholdsListColors } = this.props;
            const thresholdsListColors = this.props.thresholdsListColors.map((color)=>color.id === threshold.id ? {
                    ...color,
                    value: value
                } : color);
            onUpdateThresholdsListColors(thresholdsListColors);
        }, this.handleValidateColorValue = (__, targetValue)=>{
            const { thresholdsListColors: thresholdsListColors } = this.props;
            const sortedColors = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).sortBy(thresholdsListColors, (color)=>color.value);
            return !sortedColors.some((color)=>color.value === targetValue);
        };
    }
}
var $64a4459bb2082149$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($64a4459bb2082149$var$ThresholdsList);


// Libraries

var $NdCUR = parcelRequire("NdCUR");



class $979fcf825228ddba$var$ThresholdsListTypeToggle extends (0, $NdCUR.Component) {
    render() {
        const { containerClass: containerClass, thresholdsListType: thresholdsListType, onUpdateThresholdsListType: onUpdateThresholdsListType } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: containerClass
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", null, "Threshold Coloring"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039), {
            shape: (0, $918c9f03a35fe03f$export$ce765fb8bb08a599).StretchToFit
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039).Button, {
            id: "threshold-list-type--background",
            value: (0, $687ef8d4c4e21a50$export$283d67e9e61f9265),
            active: thresholdsListType === (0, $687ef8d4c4e21a50$export$283d67e9e61f9265),
            onClick: onUpdateThresholdsListType,
            titleText: "Apply coloration to cell background"
        }, "Background"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039).Button, {
            id: "threshold-list-type--text",
            value: (0, $687ef8d4c4e21a50$export$e47f0887676fb162),
            active: thresholdsListType === (0, $687ef8d4c4e21a50$export$e47f0887676fb162),
            onClick: onUpdateThresholdsListType,
            titleText: "Apply coloration to cell text"
        }, "Text")));
    }
}
var $979fcf825228ddba$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($979fcf825228ddba$var$ThresholdsListTypeToggle);




class $493de12400449f4d$var$SingleStatOptions extends (0, $NdCUR.PureComponent) {
    render() {
        const { axes: { y: { prefix: prefix, suffix: suffix } }, onResetFocus: onResetFocus, decimalPlaces: decimalPlaces, onUpdateThresholdsListColors: onUpdateThresholdsListColors, thresholdsListType: thresholdsListType, thresholdsListColors: thresholdsListColors, onUpdateThresholdsListType: onUpdateThresholdsListType } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), {
            className: "display-options",
            autoHide: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "display-options--wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h5", {
            className: "display-options--header"
        }, "Single Stat Controls"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $64a4459bb2082149$export$2e2bcd8739ae039), {
            onResetFocus: onResetFocus,
            thresholdsListType: thresholdsListType,
            thresholdsListColors: thresholdsListColors,
            onUpdateThresholdsListColors: onUpdateThresholdsListColors
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "graph-options-group form-group-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", null, "Prefix"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control input-sm",
            placeholder: "%, MPH, etc.",
            defaultValue: prefix,
            onChange: this.handleUpdatePrefix
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", null, "Suffix"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control input-sm",
            placeholder: "%, MPH, etc.",
            defaultValue: suffix,
            onChange: this.handleUpdateSuffix
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $10b110c1051f2fb8$export$2e2bcd8739ae039), {
            digits: decimalPlaces.digits,
            isEnforced: decimalPlaces.isEnforced,
            onDecimalPlacesChange: this.handleDecimalPlacesChange
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $979fcf825228ddba$export$2e2bcd8739ae039), {
            containerClass: "form-group col-xs-6",
            thresholdsListType: thresholdsListType,
            onUpdateThresholdsListType: onUpdateThresholdsListType
        }))));
    }
    constructor(...args){
        super(...args), this.handleDecimalPlacesChange = (decimalPlaces)=>{
            const { onUpdateDecimalPlaces: onUpdateDecimalPlaces } = this.props;
            onUpdateDecimalPlaces(decimalPlaces);
        }, this.handleUpdatePrefix = (e)=>{
            const { onUpdateAxes: onUpdateAxes, axes: axes } = this.props;
            const newAxes = {
                ...axes,
                y: {
                    ...axes.y,
                    prefix: e.target.value
                }
            };
            onUpdateAxes(newAxes);
        }, this.handleUpdateSuffix = (e)=>{
            const { onUpdateAxes: onUpdateAxes, axes: axes } = this.props;
            const newAxes = {
                ...axes,
                y: {
                    ...axes.y,
                    suffix: e.target.value
                }
            };
            onUpdateAxes(newAxes);
        };
    }
}
var $493de12400449f4d$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($493de12400449f4d$var$SingleStatOptions);


// Libraries

var $NdCUR = parcelRequire("NdCUR");



var $NdCUR = parcelRequire("NdCUR");
const $c9bb223eb908b780$var$DisplayOptionsInput = ({ id: id, name: name, value: value, onChange: onChange, labelText: labelText, colWidth: colWidth, placeholder: placeholder })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: `form-group ${colWidth}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
        htmlFor: name
    }, labelText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
        className: "form-control input-sm",
        type: "text",
        name: name,
        id: id,
        value: value,
        onChange: onChange,
        placeholder: placeholder
    }));
$c9bb223eb908b780$var$DisplayOptionsInput.defaultProps = {
    value: '',
    colWidth: 'col-sm-6',
    placeholder: ''
};
var $c9bb223eb908b780$export$2e2bcd8739ae039 = $c9bb223eb908b780$var$DisplayOptionsInput;





var $NdCUR = parcelRequire("NdCUR");

var $NdCUR = parcelRequire("NdCUR");


var $1v7mg = parcelRequire("1v7mg");





class $b234b8576967623a$var$ColorScaleDropdown extends (0, $NdCUR.Component) {
    static{
        this.defaultProps = {
            disabled: false,
            stretchToFit: false
        };
    }
    constructor(props){
        super(props), this.handleToggleMenu = ()=>{
            const { disabled: disabled } = this.props;
            if (disabled) return;
            this.setState({
                expanded: !this.state.expanded
            });
        }, this.handleClickOutside = ()=>{
            this.setState({
                expanded: false
            });
        }, this.handleDropdownClick = (colorScale)=>()=>{
                this.props.onChoose(colorScale);
                this.setState({
                    expanded: false
                });
            }, this.generateGradientStyle = (colors)=>({
                background: `linear-gradient(to right, ${colors[0].hex} 0%,${colors[1].hex} 50%,${colors[2].hex} 100%)`
            });
        this.state = {
            expanded: false
        };
    }
    render() {
        const { expanded: expanded } = this.state;
        const { selected: selected } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1f11d3536bc98f8a$export$c16e4f034c84cb3f), {
            onClickOutside: this.handleClickOutside
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.dropdownClassName,
            "data-test": "line-colours"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.buttonClassName,
            onClick: this.handleToggleMenu
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "color-dropdown--swatches",
            style: this.generateGradientStyle(selected)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "color-dropdown--name"
        }, selected[0].name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "caret"
        })), expanded && this.renderMenu));
    }
    get renderMenu() {
        const { selected: selected } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "color-dropdown--menu"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), {
            autoHide: false,
            autoHeight: true,
            maxHeight: (0, $e10a8602f56394e3$export$bd1588cc2d72fbf)
        }, (0, $b00e3cd70e675d45$export$db1d57afe3d5285d).map((colorScale)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                className: colorScale.name === selected[0].name ? 'color-dropdown--item active' : 'color-dropdown--item',
                key: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
                onClick: this.handleDropdownClick(colorScale)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                className: "color-dropdown--swatches",
                style: this.generateGradientStyle(colorScale.colors)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
                className: "color-dropdown--name"
            }, colorScale.name)))));
    }
    get buttonClassName() {
        const { disabled: disabled } = this.props;
        const { expanded: expanded } = this.state;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('btn btn-sm btn-default color-dropdown--toggle', {
            active: expanded,
            'color-dropdown__disabled': disabled
        });
    }
    get dropdownClassName() {
        const { stretchToFit: stretchToFit } = this.props;
        const { expanded: expanded } = this.state;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('color-dropdown', {
            open: expanded,
            'color-dropdown--stretch': stretchToFit
        });
    }
}
var $b234b8576967623a$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($b234b8576967623a$var$ColorScaleDropdown);



class $084bf3695064722f$var$LineGraphColorSelector extends (0, $NdCUR.Component) {
    render() {
        const { lineColors: lineColors } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", null, "Line Colors"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b234b8576967623a$export$2e2bcd8739ae039), {
            onChoose: this.handleSelectColors,
            stretchToFit: true,
            selected: lineColors
        }));
    }
    constructor(...args){
        super(...args), this.handleSelectColors = (colorScale)=>{
            const { onUpdateLineColors: onUpdateLineColors } = this.props;
            const { colors: colors } = colorScale;
            onUpdateLineColors(colors);
        };
    }
}
var $084bf3695064722f$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($084bf3695064722f$var$LineGraphColorSelector);







const { LINEAR: $9cbbb77c7ba00ca7$var$LINEAR, LOG: $9cbbb77c7ba00ca7$var$LOG, BASE_2: $9cbbb77c7ba00ca7$var$BASE_2, BASE_10: $9cbbb77c7ba00ca7$var$BASE_10, BASE_RAW: $9cbbb77c7ba00ca7$var$BASE_RAW } = (0, $727a6ab7dfc948a3$export$98a6bbea2e7b1f09);
const $9cbbb77c7ba00ca7$var$getInputMin = ()=>(-Infinity).toString();
class $9cbbb77c7ba00ca7$var$AxesOptions extends (0, $NdCUR.PureComponent) {
    static{
        this.defaultProps = {
            axes: {
                y: {
                    bounds: [
                        '',
                        ''
                    ],
                    prefix: '',
                    suffix: '',
                    base: $9cbbb77c7ba00ca7$var$BASE_10,
                    scale: $9cbbb77c7ba00ca7$var$LINEAR,
                    label: ''
                },
                x: {
                    bounds: [
                        '',
                        ''
                    ],
                    prefix: '',
                    suffix: '',
                    base: $9cbbb77c7ba00ca7$var$BASE_10,
                    scale: $9cbbb77c7ba00ca7$var$LINEAR,
                    label: ''
                }
            }
        };
    }
    constructor(props){
        super(props), this.handleSetPrefix = (e)=>{
            const { onUpdateAxes: onUpdateAxes, axes: axes } = this.props;
            const prefix = e.target.value;
            const newAxes = {
                ...axes,
                y: {
                    ...axes.y,
                    prefix: prefix
                }
            };
            this.setState({
                prefix: prefix
            }, ()=>onUpdateAxes(newAxes));
        }, this.handleSetSuffix = (e)=>{
            const { onUpdateAxes: onUpdateAxes, axes: axes } = this.props;
            const suffix = e.target.value;
            const newAxes = {
                ...axes,
                y: {
                    ...axes.y,
                    suffix: suffix
                }
            };
            this.setState({
                suffix: suffix
            }, ()=>onUpdateAxes(newAxes));
        }, this.handleSetYAxisBoundMin = (min)=>{
            const { onUpdateAxes: onUpdateAxes, axes: axes } = this.props;
            const { y: { bounds: [, max] } } = this.props.axes;
            const bounds = [
                min,
                max
            ];
            const newAxes = {
                ...axes,
                y: {
                    ...axes.y,
                    bounds: bounds
                }
            };
            onUpdateAxes(newAxes);
        }, this.handleSetYAxisBoundMax = (max)=>{
            const { onUpdateAxes: onUpdateAxes, axes: axes } = this.props;
            const { y: { bounds: [min] } } = axes;
            const bounds = [
                min,
                max
            ];
            const newAxes = {
                ...axes,
                y: {
                    ...axes.y,
                    bounds: bounds
                }
            };
            onUpdateAxes(newAxes);
        }, this.handleSetLabel = (label)=>{
            const { onUpdateAxes: onUpdateAxes, axes: axes } = this.props;
            const newAxes = {
                ...axes,
                y: {
                    ...axes.y,
                    label: label
                }
            };
            onUpdateAxes(newAxes);
        }, this.handleSetScale = (scale)=>{
            const { onUpdateAxes: onUpdateAxes, axes: axes } = this.props;
            const newAxes = {
                ...axes,
                y: {
                    ...axes.y,
                    scale: scale
                }
            };
            onUpdateAxes(newAxes);
        }, this.handleSetBase = (base)=>{
            const { onUpdateAxes: onUpdateAxes, axes: axes } = this.props;
            const newAxes = {
                ...axes,
                y: {
                    ...axes.y,
                    base: base
                }
            };
            onUpdateAxes(newAxes);
        };
        this.state = {
            prefix: (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(props, 'axes.y.prefix', ''),
            suffix: (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(props, 'axes.y.suffix', '')
        };
    }
    render() {
        const { axes: { y: { bounds: bounds, label: label } }, type: type, lineColors: lineColors, defaultYLabel: defaultYLabel, onUpdateLineColors: onUpdateLineColors } = this.props;
        const { prefix: prefix, suffix: suffix } = this.state;
        const [min, max] = bounds;
        const { menuOption: menuOption } = (0, $68fa0144111754ce$export$68ca4bab3ef5b52c).find((graph)=>graph.type === type);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), {
            className: "display-options",
            autoHide: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "display-options--wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h5", {
            className: "display-options--header"
        }, menuOption, " Controls"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("form", {
            autoComplete: "off",
            className: "form-group-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-sm-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "prefix"
        }, "Title"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7cd59214313b7fad$export$2e2bcd8739ae039), {
            type: "text",
            customValue: label,
            onSetValue: this.handleSetLabel,
            customPlaceholder: defaultYLabel || 'y-axis title'
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $084bf3695064722f$export$2e2bcd8739ae039), {
            onUpdateLineColors: onUpdateLineColors,
            lineColors: lineColors
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-sm-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "min"
        }, "Min"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7cd59214313b7fad$export$2e2bcd8739ae039), {
            customPlaceholder: 'min',
            customValue: min,
            onSetValue: this.handleSetYAxisBoundMin,
            type: "number",
            min: $9cbbb77c7ba00ca7$var$getInputMin()
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-sm-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "max"
        }, "Max"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7cd59214313b7fad$export$2e2bcd8739ae039), {
            customPlaceholder: "max",
            customValue: max,
            onSetValue: this.handleSetYAxisBoundMax,
            type: "number",
            min: $9cbbb77c7ba00ca7$var$getInputMin()
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c9bb223eb908b780$export$2e2bcd8739ae039), {
            name: "prefix",
            id: "prefix",
            value: prefix,
            labelText: "Y-Value's Prefix",
            onChange: this.handleSetPrefix
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c9bb223eb908b780$export$2e2bcd8739ae039), {
            name: "suffix",
            id: "suffix",
            value: suffix,
            labelText: "Y-Value's Suffix",
            onChange: this.handleSetSuffix
        }), this.yValuesFormatTabs, this.scaleTabs, this.decimalPlaces, this.staticLegendTabs)));
    }
    get staticLegendTabs() {
        const { staticLegend: staticLegend, onToggleStaticLegend: onToggleStaticLegend } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-sm-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", null, "Static Legend"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039), {
            shape: (0, $918c9f03a35fe03f$export$ce765fb8bb08a599).StretchToFit
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039).Button, {
            id: "static-legend-tab--show",
            value: true,
            active: staticLegend === true,
            titleText: "Show static legend below graph",
            onClick: onToggleStaticLegend
        }, "Show"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039).Button, {
            id: "static-legend-tab--hide",
            value: false,
            active: staticLegend === false,
            titleText: "Hide static legend",
            onClick: onToggleStaticLegend
        }, "Hide")));
    }
    get scaleTabs() {
        const { axes: { y: { scale: scale } } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-sm-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", null, "Scale"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039), {
            shape: (0, $918c9f03a35fe03f$export$ce765fb8bb08a599).StretchToFit
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039).Button, {
            id: "y-scale-tab--linear",
            value: $9cbbb77c7ba00ca7$var$LINEAR,
            active: scale === $9cbbb77c7ba00ca7$var$LINEAR || scale === '',
            titleText: "Set Y-Axis to Linear Scale",
            onClick: this.handleSetScale
        }, "Linear"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039).Button, {
            id: "y-scale-tab--logarithmic",
            value: $9cbbb77c7ba00ca7$var$LOG,
            active: scale === $9cbbb77c7ba00ca7$var$LOG,
            titleText: "Set Y-Axis to Logarithmic Scale",
            onClick: this.handleSetScale
        }, "Logarithmic")));
    }
    get yValuesFormatTabs() {
        const { axes: { y: { base: base } } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-sm-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", null, "Y-Value's Format"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039), {
            shape: (0, $918c9f03a35fe03f$export$ce765fb8bb08a599).StretchToFit
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039).Button, {
            id: "y-values-format-tab--raw",
            value: $9cbbb77c7ba00ca7$var$BASE_RAW,
            active: base === '' || base === $9cbbb77c7ba00ca7$var$BASE_RAW,
            titleText: "Don't format values",
            onClick: this.handleSetBase
        }, "Raw"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039).Button, {
            id: "y-values-format-tab--kmb",
            value: $9cbbb77c7ba00ca7$var$BASE_10,
            active: base === $9cbbb77c7ba00ca7$var$BASE_10,
            titleText: "Thousand / Million / Billion",
            onClick: this.handleSetBase
        }, "K/M/B"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039).Button, {
            id: "y-values-format-tab--kmg",
            value: $9cbbb77c7ba00ca7$var$BASE_2,
            active: base === $9cbbb77c7ba00ca7$var$BASE_2,
            titleText: "Kilo / Mega / Giga",
            onClick: this.handleSetBase
        }, "K/M/G")));
    }
    get decimalPlaces() {
        const { onUpdateDecimalPlaces: onUpdateDecimalPlaces, decimalPlaces: decimalPlaces, type: type } = this.props;
        if (type !== (0, $b4506126e09430df$export$705e36171f4cbbfe).LinePlusSingleStat) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $10b110c1051f2fb8$export$2e2bcd8739ae039), {
            digits: decimalPlaces.digits,
            isEnforced: decimalPlaces.isEnforced,
            onDecimalPlacesChange: onUpdateDecimalPlaces
        });
    }
}
var $9cbbb77c7ba00ca7$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($9cbbb77c7ba00ca7$var$AxesOptions);


// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");

var $NdCUR = parcelRequire("NdCUR");
var $db9eac57989e0572$exports = {};
'use strict';
Object.defineProperty($db9eac57989e0572$exports, "__esModule", {
    value: true
});
var $05c834ae934a4136$exports = {};
'use strict';
Object.defineProperty($05c834ae934a4136$exports, "__esModule", {
    value: true
});
$05c834ae934a4136$exports.unpackBackendForEs5Users = $05c834ae934a4136$exports.createChildContext = $05c834ae934a4136$exports.CHILD_CONTEXT_TYPES = undefined;
var $05c834ae934a4136$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $05c834ae934a4136$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $05c834ae934a4136$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
$05c834ae934a4136$exports.default = $05c834ae934a4136$var$DragDropContext;

var $NdCUR = parcelRequire("NdCUR");
var $05c834ae934a4136$var$_react2 = $05c834ae934a4136$var$_interopRequireDefault($NdCUR);

var $fGw9V = parcelRequire("fGw9V");
var $05c834ae934a4136$var$_propTypes2 = $05c834ae934a4136$var$_interopRequireDefault($fGw9V);
var $a088142e142fdb75$exports = {};
'use strict';
Object.defineProperty($a088142e142fdb75$exports, "__esModule", {
    value: true
});
var $585d8f259a1ab7ea$exports = {};
'use strict';
Object.defineProperty($585d8f259a1ab7ea$exports, "__esModule", {
    value: true
});
var $585d8f259a1ab7ea$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $a4bf6be119e92756$exports = {};

$parcel$defineInteropFlag($a4bf6be119e92756$exports);

$parcel$export($a4bf6be119e92756$exports, "__esModule", function () { return $a4bf6be119e92756$export$1e511d4a378977f5; }, function (v) { return $a4bf6be119e92756$export$1e511d4a378977f5 = v; });
$parcel$export($a4bf6be119e92756$exports, "ActionTypes", function () { return $a4bf6be119e92756$export$1385d81a6c6bbcd4; }, function (v) { return $a4bf6be119e92756$export$1385d81a6c6bbcd4 = v; });
$parcel$export($a4bf6be119e92756$exports, "default", function () { return $a4bf6be119e92756$export$2e2bcd8739ae039; }, function (v) { return $a4bf6be119e92756$export$2e2bcd8739ae039 = v; });
var $a4bf6be119e92756$export$1e511d4a378977f5;
var $a4bf6be119e92756$export$1385d81a6c6bbcd4;
var $a4bf6be119e92756$export$2e2bcd8739ae039;
'use strict';
$a4bf6be119e92756$export$1e511d4a378977f5 = true;
$a4bf6be119e92756$export$1385d81a6c6bbcd4 = undefined;
$a4bf6be119e92756$export$2e2bcd8739ae039 = $a4bf6be119e92756$var$createStore;
var $fafe96f2de46333f$exports = {};

var $cff0f9381a87c10d$exports = {};

/** Built-in value references. */ var $cff0f9381a87c10d$var$getPrototype = $b481455a096d635f$exports(Object.getPrototypeOf, Object);
$cff0f9381a87c10d$exports = $cff0f9381a87c10d$var$getPrototype;



/** `Object#toString` result references. */ var $fafe96f2de46333f$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $fafe96f2de46333f$var$funcProto = Function.prototype, $fafe96f2de46333f$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $fafe96f2de46333f$var$funcToString = $fafe96f2de46333f$var$funcProto.toString;
/** Used to check objects for own properties. */ var $fafe96f2de46333f$var$hasOwnProperty = $fafe96f2de46333f$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $fafe96f2de46333f$var$objectCtorString = $fafe96f2de46333f$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $fafe96f2de46333f$var$isPlainObject(value) {
    if (!$591571b7706a9b83$exports(value) || $c1801119ed7f09fb$exports(value) != $fafe96f2de46333f$var$objectTag) return false;
    var proto = $cff0f9381a87c10d$exports(value);
    if (proto === null) return true;
    var Ctor = $fafe96f2de46333f$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $fafe96f2de46333f$var$funcToString.call(Ctor) == $fafe96f2de46333f$var$objectCtorString;
}
$fafe96f2de46333f$exports = $fafe96f2de46333f$var$isPlainObject;


var $a4bf6be119e92756$var$_isPlainObject2 = $a4bf6be119e92756$var$_interopRequireDefault($fafe96f2de46333f$exports);

var $8gcse = parcelRequire("8gcse");
var $a4bf6be119e92756$var$_symbolObservable2 = $a4bf6be119e92756$var$_interopRequireDefault($8gcse);
function $a4bf6be119e92756$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $a4bf6be119e92756$var$ActionTypes = $a4bf6be119e92756$export$1385d81a6c6bbcd4 = {
    INIT: '@@redux/INIT'
};
function $a4bf6be119e92756$var$createStore(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error('Expected the enhancer to be a function.');
        return enhancer($a4bf6be119e92756$var$createStore)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error('Expected the reducer to be a function.');
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error('Expected listener to be a function.');
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!(0, $a4bf6be119e92756$var$_isPlainObject2['default'])(action)) throw new Error("Actions must be plain objects. Use custom middleware for async actions.");
        if (typeof action.type === 'undefined') throw new Error('Actions may not have an undefined "type" property. Have you misspelled a constant?');
        if (isDispatching) throw new Error('Reducers may not dispatch actions.');
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error('Expected the nextReducer to be a function.');
        currentReducer = nextReducer;
        dispatch({
            type: $a4bf6be119e92756$var$ActionTypes.INIT
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object') throw new TypeError('Expected the observer to be an object.');
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$a4bf6be119e92756$var$_symbolObservable2['default']] = function() {
            return this;
        }, _ref;
    }
    // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $a4bf6be119e92756$var$ActionTypes.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$a4bf6be119e92756$var$_symbolObservable2['default']] = observable, _ref2;
}


var $585d8f259a1ab7ea$var$_createStore2 = $585d8f259a1ab7ea$var$_interopRequireDefault($a4bf6be119e92756$exports);
var $49542ad051169292$exports = {};
'use strict';
Object.defineProperty($49542ad051169292$exports, "__esModule", {
    value: true
});
$49542ad051169292$exports.default = $49542ad051169292$var$reduce;
var $c4900fad33c0b9a3$exports = {};
'use strict';
Object.defineProperty($c4900fad33c0b9a3$exports, "__esModule", {
    value: true
});
var $c4900fad33c0b9a3$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
$c4900fad33c0b9a3$exports.default = $c4900fad33c0b9a3$var$dragOffset;
$c4900fad33c0b9a3$exports.getSourceClientOffset = $c4900fad33c0b9a3$var$getSourceClientOffset;
$c4900fad33c0b9a3$exports.getDifferenceFromInitialOffset = $c4900fad33c0b9a3$var$getDifferenceFromInitialOffset;
var $38128f7d3b5b6d4a$exports = {};
'use strict';
Object.defineProperty($38128f7d3b5b6d4a$exports, "__esModule", {
    value: true
});
$38128f7d3b5b6d4a$exports.END_DRAG = $38128f7d3b5b6d4a$exports.DROP = $38128f7d3b5b6d4a$exports.HOVER = $38128f7d3b5b6d4a$exports.PUBLISH_DRAG_SOURCE = $38128f7d3b5b6d4a$exports.BEGIN_DRAG = undefined;
var $38128f7d3b5b6d4a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
$38128f7d3b5b6d4a$exports.beginDrag = $38128f7d3b5b6d4a$var$beginDrag;
$38128f7d3b5b6d4a$exports.publishDragSource = $38128f7d3b5b6d4a$var$publishDragSource;
$38128f7d3b5b6d4a$exports.hover = $38128f7d3b5b6d4a$var$hover;
$38128f7d3b5b6d4a$exports.drop = $38128f7d3b5b6d4a$var$drop;
$38128f7d3b5b6d4a$exports.endDrag = $38128f7d3b5b6d4a$var$endDrag;

var $38128f7d3b5b6d4a$var$_invariant2 = $38128f7d3b5b6d4a$var$_interopRequireDefault($06dab2fcf604e778$exports);

var $38128f7d3b5b6d4a$var$_isArray2 = $38128f7d3b5b6d4a$var$_interopRequireDefault($62cdb8c6d4925eaf$exports);

var $38128f7d3b5b6d4a$var$_isObject2 = $38128f7d3b5b6d4a$var$_interopRequireDefault($cf434abf2d8b4420$exports);
var $217d20e9021e6d93$exports = {};
'use strict';
Object.defineProperty($217d20e9021e6d93$exports, "__esModule", {
    value: true
});
$217d20e9021e6d93$exports.default = $217d20e9021e6d93$var$matchesType;

var $217d20e9021e6d93$var$_isArray2 = $217d20e9021e6d93$var$_interopRequireDefault($62cdb8c6d4925eaf$exports);
function $217d20e9021e6d93$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $217d20e9021e6d93$var$matchesType(targetType, draggedItemType) {
    if ((0, $217d20e9021e6d93$var$_isArray2.default)(targetType)) return targetType.some(function(t) {
        return t === draggedItemType;
    });
    else return targetType === draggedItemType;
}


var $38128f7d3b5b6d4a$var$_matchesType2 = $38128f7d3b5b6d4a$var$_interopRequireDefault($217d20e9021e6d93$exports);
function $38128f7d3b5b6d4a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $38128f7d3b5b6d4a$var$BEGIN_DRAG = $38128f7d3b5b6d4a$exports.BEGIN_DRAG = 'dnd-core/BEGIN_DRAG';
var $38128f7d3b5b6d4a$var$PUBLISH_DRAG_SOURCE = $38128f7d3b5b6d4a$exports.PUBLISH_DRAG_SOURCE = 'dnd-core/PUBLISH_DRAG_SOURCE';
var $38128f7d3b5b6d4a$var$HOVER = $38128f7d3b5b6d4a$exports.HOVER = 'dnd-core/HOVER';
var $38128f7d3b5b6d4a$var$DROP = $38128f7d3b5b6d4a$exports.DROP = 'dnd-core/DROP';
var $38128f7d3b5b6d4a$var$END_DRAG = $38128f7d3b5b6d4a$exports.END_DRAG = 'dnd-core/END_DRAG';
function $38128f7d3b5b6d4a$var$beginDrag(sourceIds) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        publishSource: true,
        clientOffset: null
    };
    var publishSource = options.publishSource, clientOffset = options.clientOffset, getSourceClientOffset = options.getSourceClientOffset;
    (0, $38128f7d3b5b6d4a$var$_invariant2.default)((0, $38128f7d3b5b6d4a$var$_isArray2.default)(sourceIds), 'Expected sourceIds to be an array.');
    var monitor = this.getMonitor();
    var registry = this.getRegistry();
    (0, $38128f7d3b5b6d4a$var$_invariant2.default)(!monitor.isDragging(), 'Cannot call beginDrag while dragging.');
    for(var i = 0; i < sourceIds.length; i++)(0, $38128f7d3b5b6d4a$var$_invariant2.default)(registry.getSource(sourceIds[i]), 'Expected sourceIds to be registered.');
    var sourceId = null;
    for(var _i = sourceIds.length - 1; _i >= 0; _i--)if (monitor.canDragSource(sourceIds[_i])) {
        sourceId = sourceIds[_i];
        break;
    }
    if (sourceId === null) return;
    var sourceClientOffset = null;
    if (clientOffset) {
        (0, $38128f7d3b5b6d4a$var$_invariant2.default)(typeof getSourceClientOffset === 'function', 'When clientOffset is provided, getSourceClientOffset must be a function.');
        sourceClientOffset = getSourceClientOffset(sourceId);
    }
    var source = registry.getSource(sourceId);
    var item = source.beginDrag(monitor, sourceId);
    (0, $38128f7d3b5b6d4a$var$_invariant2.default)((0, $38128f7d3b5b6d4a$var$_isObject2.default)(item), 'Item must be an object.');
    registry.pinSource(sourceId);
    var itemType = registry.getSourceType(sourceId);
    return {
        type: $38128f7d3b5b6d4a$var$BEGIN_DRAG,
        itemType: itemType,
        item: item,
        sourceId: sourceId,
        clientOffset: clientOffset,
        sourceClientOffset: sourceClientOffset,
        isSourcePublic: publishSource
    };
}
function $38128f7d3b5b6d4a$var$publishDragSource() {
    var monitor = this.getMonitor();
    if (!monitor.isDragging()) return;
    return {
        type: $38128f7d3b5b6d4a$var$PUBLISH_DRAG_SOURCE
    };
}
function $38128f7d3b5b6d4a$var$hover(targetIdsArg) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$clientOffset = _ref.clientOffset, clientOffset = _ref$clientOffset === undefined ? null : _ref$clientOffset;
    (0, $38128f7d3b5b6d4a$var$_invariant2.default)((0, $38128f7d3b5b6d4a$var$_isArray2.default)(targetIdsArg), 'Expected targetIds to be an array.');
    var targetIds = targetIdsArg.slice(0);
    var monitor = this.getMonitor();
    var registry = this.getRegistry();
    (0, $38128f7d3b5b6d4a$var$_invariant2.default)(monitor.isDragging(), 'Cannot call hover while not dragging.');
    (0, $38128f7d3b5b6d4a$var$_invariant2.default)(!monitor.didDrop(), 'Cannot call hover after drop.');
    // First check invariants.
    for(var i = 0; i < targetIds.length; i++){
        var targetId = targetIds[i];
        (0, $38128f7d3b5b6d4a$var$_invariant2.default)(targetIds.lastIndexOf(targetId) === i, 'Expected targetIds to be unique in the passed array.');
        var target = registry.getTarget(targetId);
        (0, $38128f7d3b5b6d4a$var$_invariant2.default)(target, 'Expected targetIds to be registered.');
    }
    var draggedItemType = monitor.getItemType();
    // Remove those targetIds that don't match the targetType.  This
    // fixes shallow isOver which would only be non-shallow because of
    // non-matching targets.
    for(var _i2 = targetIds.length - 1; _i2 >= 0; _i2--){
        var _targetId = targetIds[_i2];
        var targetType = registry.getTargetType(_targetId);
        if (!(0, $38128f7d3b5b6d4a$var$_matchesType2.default)(targetType, draggedItemType)) targetIds.splice(_i2, 1);
    }
    // Finally call hover on all matching targets.
    for(var _i3 = 0; _i3 < targetIds.length; _i3++){
        var _targetId2 = targetIds[_i3];
        var _target = registry.getTarget(_targetId2);
        _target.hover(monitor, _targetId2);
    }
    return {
        type: $38128f7d3b5b6d4a$var$HOVER,
        targetIds: targetIds,
        clientOffset: clientOffset
    };
}
function $38128f7d3b5b6d4a$var$drop() {
    var _this = this;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var monitor = this.getMonitor();
    var registry = this.getRegistry();
    (0, $38128f7d3b5b6d4a$var$_invariant2.default)(monitor.isDragging(), 'Cannot call drop while not dragging.');
    (0, $38128f7d3b5b6d4a$var$_invariant2.default)(!monitor.didDrop(), 'Cannot call drop twice during one drag operation.');
    var targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);
    targetIds.reverse();
    targetIds.forEach(function(targetId, index) {
        var target = registry.getTarget(targetId);
        var dropResult = target.drop(monitor, targetId);
        (0, $38128f7d3b5b6d4a$var$_invariant2.default)(typeof dropResult === 'undefined' || (0, $38128f7d3b5b6d4a$var$_isObject2.default)(dropResult), 'Drop result must either be an object or undefined.');
        if (typeof dropResult === 'undefined') dropResult = index === 0 ? {} : monitor.getDropResult();
        _this.store.dispatch({
            type: $38128f7d3b5b6d4a$var$DROP,
            dropResult: $38128f7d3b5b6d4a$var$_extends({}, options, dropResult)
        });
    });
}
function $38128f7d3b5b6d4a$var$endDrag() {
    var monitor = this.getMonitor();
    var registry = this.getRegistry();
    (0, $38128f7d3b5b6d4a$var$_invariant2.default)(monitor.isDragging(), 'Cannot call endDrag while not dragging.');
    var sourceId = monitor.getSourceId();
    var source = registry.getSource(sourceId, true);
    source.endDrag(monitor, sourceId);
    registry.unpinSource();
    return {
        type: $38128f7d3b5b6d4a$var$END_DRAG
    };
}


var $c4900fad33c0b9a3$var$initialState = {
    initialSourceClientOffset: null,
    initialClientOffset: null,
    clientOffset: null
};
function $c4900fad33c0b9a3$var$areOffsetsEqual(offsetA, offsetB) {
    if (offsetA === offsetB) return true;
    return offsetA && offsetB && offsetA.x === offsetB.x && offsetA.y === offsetB.y;
}
function $c4900fad33c0b9a3$var$dragOffset() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $c4900fad33c0b9a3$var$initialState;
    var action = arguments[1];
    switch(action.type){
        case $38128f7d3b5b6d4a$exports.BEGIN_DRAG:
            return {
                initialSourceClientOffset: action.sourceClientOffset,
                initialClientOffset: action.clientOffset,
                clientOffset: action.clientOffset
            };
        case $38128f7d3b5b6d4a$exports.HOVER:
            if ($c4900fad33c0b9a3$var$areOffsetsEqual(state.clientOffset, action.clientOffset)) return state;
            return $c4900fad33c0b9a3$var$_extends({}, state, {
                clientOffset: action.clientOffset
            });
        case $38128f7d3b5b6d4a$exports.END_DRAG:
        case $38128f7d3b5b6d4a$exports.DROP:
            return $c4900fad33c0b9a3$var$initialState;
        default:
            return state;
    }
}
function $c4900fad33c0b9a3$var$getSourceClientOffset(state) {
    var clientOffset = state.clientOffset, initialClientOffset = state.initialClientOffset, initialSourceClientOffset = state.initialSourceClientOffset;
    if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) return null;
    return {
        x: clientOffset.x + initialSourceClientOffset.x - initialClientOffset.x,
        y: clientOffset.y + initialSourceClientOffset.y - initialClientOffset.y
    };
}
function $c4900fad33c0b9a3$var$getDifferenceFromInitialOffset(state) {
    var clientOffset = state.clientOffset, initialClientOffset = state.initialClientOffset;
    if (!clientOffset || !initialClientOffset) return null;
    return {
        x: clientOffset.x - initialClientOffset.x,
        y: clientOffset.y - initialClientOffset.y
    };
}


var $49542ad051169292$var$_dragOffset2 = $49542ad051169292$var$_interopRequireDefault($c4900fad33c0b9a3$exports);
var $348d487c67414795$exports = {};
'use strict';
Object.defineProperty($348d487c67414795$exports, "__esModule", {
    value: true
});
var $348d487c67414795$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
$348d487c67414795$exports.default = $348d487c67414795$var$dragOperation;
var $43f8232def0d8ab2$exports = {};
var $01a7e0a6b8ca7b21$exports = {};

var $4c26a10efa414c83$exports = {};
var $34976c32039d305a$exports = {};
var $66741fd29e0b0c59$exports = {};
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $66741fd29e0b0c59$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
$66741fd29e0b0c59$exports = $66741fd29e0b0c59$var$baseFindIndex;


var $51d0e22ac7399246$exports = {};
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $51d0e22ac7399246$var$baseIsNaN(value) {
    return value !== value;
}
$51d0e22ac7399246$exports = $51d0e22ac7399246$var$baseIsNaN;


var $29f28ee9adc86cfc$exports = {};
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $29f28ee9adc86cfc$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
$29f28ee9adc86cfc$exports = $29f28ee9adc86cfc$var$strictIndexOf;


/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $34976c32039d305a$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $29f28ee9adc86cfc$exports(array, value, fromIndex) : $66741fd29e0b0c59$exports(array, $51d0e22ac7399246$exports, fromIndex);
}
$34976c32039d305a$exports = $34976c32039d305a$var$baseIndexOf;


/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $4c26a10efa414c83$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $34976c32039d305a$exports(array, value, 0) > -1;
}
$4c26a10efa414c83$exports = $4c26a10efa414c83$var$arrayIncludes;


var $1cfd41f8e9193304$exports = {};
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $1cfd41f8e9193304$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
$1cfd41f8e9193304$exports = $1cfd41f8e9193304$var$arrayIncludesWith;





/** Used as the size to enable large array optimizations. */ var $01a7e0a6b8ca7b21$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function $01a7e0a6b8ca7b21$var$baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = $4c26a10efa414c83$exports, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = $ccf4e6cf384a4c5e$exports(values, $f3857b6918c77042$exports(iteratee));
    if (comparator) {
        includes = $1cfd41f8e9193304$exports;
        isCommon = false;
    } else if (values.length >= $01a7e0a6b8ca7b21$var$LARGE_ARRAY_SIZE) {
        includes = $530d002bad5670bf$exports;
        isCommon = false;
        values = new $9741b2058ed340c0$exports(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
$01a7e0a6b8ca7b21$exports = $01a7e0a6b8ca7b21$var$baseDifference;


var $ff83c7c0ae177e74$exports = {};

var $f3c71a816de9b626$exports = {};
var $c92179e17c2ae551$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $c92179e17c2ae551$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$c92179e17c2ae551$exports = $c92179e17c2ae551$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $f3c71a816de9b626$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $f3c71a816de9b626$var$overRest(func, start, transform) {
    start = $f3c71a816de9b626$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $f3c71a816de9b626$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $c92179e17c2ae551$exports(func, this, otherArgs);
    };
}
$f3c71a816de9b626$exports = $f3c71a816de9b626$var$overRest;


var $1b68fa40c7443473$exports = {};
var $9a27e70d9e98cc55$exports = {};
var $182a65ee272ae71f$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $182a65ee272ae71f$var$constant(value) {
    return function() {
        return value;
    };
}
$182a65ee272ae71f$exports = $182a65ee272ae71f$var$constant;


var $6905595e75d6f96c$exports = {};

var $6905595e75d6f96c$var$defineProperty = function() {
    try {
        var func = $597f04cf2928ffb3$exports(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
$6905595e75d6f96c$exports = $6905595e75d6f96c$var$defineProperty;



/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $9a27e70d9e98cc55$var$baseSetToString = !$6905595e75d6f96c$exports ? $ee673408ad6fac6e$exports : function(func, string) {
    return $6905595e75d6f96c$exports(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $182a65ee272ae71f$exports(string),
        'writable': true
    });
};
$9a27e70d9e98cc55$exports = $9a27e70d9e98cc55$var$baseSetToString;


var $6b3dbdb1ffd5167f$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $6b3dbdb1ffd5167f$var$HOT_COUNT = 800, $6b3dbdb1ffd5167f$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6b3dbdb1ffd5167f$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $6b3dbdb1ffd5167f$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $6b3dbdb1ffd5167f$var$nativeNow(), remaining = $6b3dbdb1ffd5167f$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $6b3dbdb1ffd5167f$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$6b3dbdb1ffd5167f$exports = $6b3dbdb1ffd5167f$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $1b68fa40c7443473$var$setToString = $6b3dbdb1ffd5167f$exports($9a27e70d9e98cc55$exports);
$1b68fa40c7443473$exports = $1b68fa40c7443473$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $ff83c7c0ae177e74$var$baseRest(func, start) {
    return $1b68fa40c7443473$exports($f3c71a816de9b626$exports(func, start, $ee673408ad6fac6e$exports), func + '');
}
$ff83c7c0ae177e74$exports = $ff83c7c0ae177e74$var$baseRest;


var $b2f7b852db6286b1$exports = {};


/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $b2f7b852db6286b1$var$isArrayLikeObject(value) {
    return $591571b7706a9b83$exports(value) && $bb8c0e46a53b48d1$exports(value);
}
$b2f7b852db6286b1$exports = $b2f7b852db6286b1$var$isArrayLikeObject;


/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */ var $43f8232def0d8ab2$var$without = $ff83c7c0ae177e74$exports(function(array, values) {
    return $b2f7b852db6286b1$exports(array) ? $01a7e0a6b8ca7b21$exports(array, values) : [];
});
$43f8232def0d8ab2$exports = $43f8232def0d8ab2$var$without;


var $348d487c67414795$var$_without2 = $348d487c67414795$var$_interopRequireDefault($43f8232def0d8ab2$exports);

var $8960679e31887519$exports = {};
'use strict';
Object.defineProperty($8960679e31887519$exports, "__esModule", {
    value: true
});
$8960679e31887519$exports.addSource = $8960679e31887519$var$addSource;
$8960679e31887519$exports.addTarget = $8960679e31887519$var$addTarget;
$8960679e31887519$exports.removeSource = $8960679e31887519$var$removeSource;
$8960679e31887519$exports.removeTarget = $8960679e31887519$var$removeTarget;
var $8960679e31887519$var$ADD_SOURCE = $8960679e31887519$exports.ADD_SOURCE = 'dnd-core/ADD_SOURCE';
var $8960679e31887519$var$ADD_TARGET = $8960679e31887519$exports.ADD_TARGET = 'dnd-core/ADD_TARGET';
var $8960679e31887519$var$REMOVE_SOURCE = $8960679e31887519$exports.REMOVE_SOURCE = 'dnd-core/REMOVE_SOURCE';
var $8960679e31887519$var$REMOVE_TARGET = $8960679e31887519$exports.REMOVE_TARGET = 'dnd-core/REMOVE_TARGET';
function $8960679e31887519$var$addSource(sourceId) {
    return {
        type: $8960679e31887519$var$ADD_SOURCE,
        sourceId: sourceId
    };
}
function $8960679e31887519$var$addTarget(targetId) {
    return {
        type: $8960679e31887519$var$ADD_TARGET,
        targetId: targetId
    };
}
function $8960679e31887519$var$removeSource(sourceId) {
    return {
        type: $8960679e31887519$var$REMOVE_SOURCE,
        sourceId: sourceId
    };
}
function $8960679e31887519$var$removeTarget(targetId) {
    return {
        type: $8960679e31887519$var$REMOVE_TARGET,
        targetId: targetId
    };
}


function $348d487c67414795$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $348d487c67414795$var$initialState = {
    itemType: null,
    item: null,
    sourceId: null,
    targetIds: [],
    dropResult: null,
    didDrop: false,
    isSourcePublic: null
};
function $348d487c67414795$var$dragOperation() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $348d487c67414795$var$initialState;
    var action = arguments[1];
    switch(action.type){
        case $38128f7d3b5b6d4a$exports.BEGIN_DRAG:
            return $348d487c67414795$var$_extends({}, state, {
                itemType: action.itemType,
                item: action.item,
                sourceId: action.sourceId,
                isSourcePublic: action.isSourcePublic,
                dropResult: null,
                didDrop: false
            });
        case $38128f7d3b5b6d4a$exports.PUBLISH_DRAG_SOURCE:
            return $348d487c67414795$var$_extends({}, state, {
                isSourcePublic: true
            });
        case $38128f7d3b5b6d4a$exports.HOVER:
            return $348d487c67414795$var$_extends({}, state, {
                targetIds: action.targetIds
            });
        case $8960679e31887519$exports.REMOVE_TARGET:
            if (state.targetIds.indexOf(action.targetId) === -1) return state;
            return $348d487c67414795$var$_extends({}, state, {
                targetIds: (0, $348d487c67414795$var$_without2.default)(state.targetIds, action.targetId)
            });
        case $38128f7d3b5b6d4a$exports.DROP:
            return $348d487c67414795$var$_extends({}, state, {
                dropResult: action.dropResult,
                didDrop: true,
                targetIds: []
            });
        case $38128f7d3b5b6d4a$exports.END_DRAG:
            return $348d487c67414795$var$_extends({}, state, {
                itemType: null,
                item: null,
                sourceId: null,
                dropResult: null,
                didDrop: false,
                isSourcePublic: null,
                targetIds: []
            });
        default:
            return state;
    }
}


var $49542ad051169292$var$_dragOperation2 = $49542ad051169292$var$_interopRequireDefault($348d487c67414795$exports);
var $08bdab87db9b2786$exports = {};
'use strict';
Object.defineProperty($08bdab87db9b2786$exports, "__esModule", {
    value: true
});
$08bdab87db9b2786$exports.default = $08bdab87db9b2786$var$refCount;

function $08bdab87db9b2786$var$refCount() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var action = arguments[1];
    switch(action.type){
        case $8960679e31887519$exports.ADD_SOURCE:
        case $8960679e31887519$exports.ADD_TARGET:
            return state + 1;
        case $8960679e31887519$exports.REMOVE_SOURCE:
        case $8960679e31887519$exports.REMOVE_TARGET:
            return state - 1;
        default:
            return state;
    }
}


var $49542ad051169292$var$_refCount2 = $49542ad051169292$var$_interopRequireDefault($08bdab87db9b2786$exports);
var $fd870c04d85931de$exports = {};
'use strict';
Object.defineProperty($fd870c04d85931de$exports, "__esModule", {
    value: true
});
$fd870c04d85931de$exports.default = $fd870c04d85931de$var$dirtyHandlerIds;
$fd870c04d85931de$exports.areDirty = $fd870c04d85931de$var$areDirty;
var $1dd26491c26d68c8$exports = {};


var $fb473dd04e6e8e6e$exports = {};

var $6bc15f8cc5a05c72$exports = {};

var $26c703a7e8d98fb4$exports = {};



/** Built-in value references. */ var $26c703a7e8d98fb4$var$spreadableSymbol = $ead57c66122851dd$exports ? $ead57c66122851dd$exports.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $26c703a7e8d98fb4$var$isFlattenable(value) {
    return $62cdb8c6d4925eaf$exports(value) || $2b1962154d35d43c$exports(value) || !!($26c703a7e8d98fb4$var$spreadableSymbol && value && value[$26c703a7e8d98fb4$var$spreadableSymbol]);
}
$26c703a7e8d98fb4$exports = $26c703a7e8d98fb4$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $6bc15f8cc5a05c72$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $26c703a7e8d98fb4$exports);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $6bc15f8cc5a05c72$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $a02b4f0317aeef2b$exports(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
$6bc15f8cc5a05c72$exports = $6bc15f8cc5a05c72$var$baseFlatten;


var $a1f8839e2550ec0f$exports = {};




var $25fca6971a2d5901$exports = {};

var $f06a40ac7ca7d7b2$exports = {};
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $f06a40ac7ca7d7b2$var$noop() {
// No operation performed.
}
$f06a40ac7ca7d7b2$exports = $f06a40ac7ca7d7b2$var$noop;



/** Used as references for various `Number` constants. */ var $25fca6971a2d5901$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $25fca6971a2d5901$var$createSet = !($0bb4aadd52a820c8$exports && 1 / $2e9014327564fd16$exports(new $0bb4aadd52a820c8$exports([
    ,
    -0
]))[1] == $25fca6971a2d5901$var$INFINITY) ? $f06a40ac7ca7d7b2$exports : function(values) {
    return new $0bb4aadd52a820c8$exports(values);
};
$25fca6971a2d5901$exports = $25fca6971a2d5901$var$createSet;



/** Used as the size to enable large array optimizations. */ var $a1f8839e2550ec0f$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $a1f8839e2550ec0f$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $4c26a10efa414c83$exports, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $1cfd41f8e9193304$exports;
    } else if (length >= $a1f8839e2550ec0f$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $25fca6971a2d5901$exports(array);
        if (set) return $2e9014327564fd16$exports(set);
        isCommon = false;
        includes = $530d002bad5670bf$exports;
        seen = new $9741b2058ed340c0$exports;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
$a1f8839e2550ec0f$exports = $a1f8839e2550ec0f$var$baseUniq;


/**
 * The base implementation of methods like `_.xor`, without support for
 * iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of values.
 */ function $fb473dd04e6e8e6e$var$baseXor(arrays, iteratee, comparator) {
    var length = arrays.length;
    if (length < 2) return length ? $a1f8839e2550ec0f$exports(arrays[0]) : [];
    var index = -1, result = Array(length);
    while(++index < length){
        var array = arrays[index], othIndex = -1;
        while(++othIndex < length)if (othIndex != index) result[index] = $01a7e0a6b8ca7b21$exports(result[index] || array, arrays[othIndex], iteratee, comparator);
    }
    return $a1f8839e2550ec0f$exports($6bc15f8cc5a05c72$exports(result, 1), iteratee, comparator);
}
$fb473dd04e6e8e6e$exports = $fb473dd04e6e8e6e$var$baseXor;



/**
 * Creates an array of unique values that is the
 * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
 * of the given arrays. The order of result values is determined by the order
 * they occur in the arrays.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.without
 * @example
 *
 * _.xor([2, 1], [2, 3]);
 * // => [1, 3]
 */ var $1dd26491c26d68c8$var$xor = $ff83c7c0ae177e74$exports(function(arrays) {
    return $fb473dd04e6e8e6e$exports($a395ddd63466c02f$exports(arrays, $b2f7b852db6286b1$exports));
});
$1dd26491c26d68c8$exports = $1dd26491c26d68c8$var$xor;


var $fd870c04d85931de$var$_xor2 = $fd870c04d85931de$var$_interopRequireDefault($1dd26491c26d68c8$exports);
var $85039bdf46a1aa33$exports = {};

var $2d22439086fc95cd$exports = {};






/* Built-in method references for those with the same name as other `lodash` methods. */ var $2d22439086fc95cd$var$nativeMin = Math.min;
/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */ function $2d22439086fc95cd$var$baseIntersection(arrays, iteratee, comparator) {
    var includes = comparator ? $1cfd41f8e9193304$exports : $4c26a10efa414c83$exports, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result = [];
    while(othIndex--){
        var array = arrays[othIndex];
        if (othIndex && iteratee) array = $ccf4e6cf384a4c5e$exports(array, $f3857b6918c77042$exports(iteratee));
        maxLength = $2d22439086fc95cd$var$nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new $9741b2058ed340c0$exports(othIndex && array) : undefined;
    }
    array = arrays[0];
    var index = -1, seen = caches[0];
    outer: while(++index < length && result.length < maxLength){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (!(seen ? $530d002bad5670bf$exports(seen, computed) : includes(result, computed, comparator))) {
            othIndex = othLength;
            while(--othIndex){
                var cache = caches[othIndex];
                if (!(cache ? $530d002bad5670bf$exports(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
            }
            if (seen) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
$2d22439086fc95cd$exports = $2d22439086fc95cd$var$baseIntersection;



var $345f10251f5a27fa$exports = {};

/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */ function $345f10251f5a27fa$var$castArrayLikeObject(value) {
    return $b2f7b852db6286b1$exports(value) ? value : [];
}
$345f10251f5a27fa$exports = $345f10251f5a27fa$var$castArrayLikeObject;


/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */ var $85039bdf46a1aa33$var$intersection = $ff83c7c0ae177e74$exports(function(arrays) {
    var mapped = $ccf4e6cf384a4c5e$exports(arrays, $345f10251f5a27fa$exports);
    return mapped.length && mapped[0] === arrays[0] ? $2d22439086fc95cd$exports(mapped) : [];
});
$85039bdf46a1aa33$exports = $85039bdf46a1aa33$var$intersection;


var $fd870c04d85931de$var$_intersection2 = $fd870c04d85931de$var$_interopRequireDefault($85039bdf46a1aa33$exports);


function $fd870c04d85931de$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $fd870c04d85931de$var$NONE = [];
var $fd870c04d85931de$var$ALL = [];
function $fd870c04d85931de$var$dirtyHandlerIds() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $fd870c04d85931de$var$NONE;
    var action = arguments[1];
    var dragOperation = arguments[2];
    switch(action.type){
        case $38128f7d3b5b6d4a$exports.HOVER:
            break;
        case $8960679e31887519$exports.ADD_SOURCE:
        case $8960679e31887519$exports.ADD_TARGET:
        case $8960679e31887519$exports.REMOVE_TARGET:
        case $8960679e31887519$exports.REMOVE_SOURCE:
            return $fd870c04d85931de$var$NONE;
        case $38128f7d3b5b6d4a$exports.BEGIN_DRAG:
        case $38128f7d3b5b6d4a$exports.PUBLISH_DRAG_SOURCE:
        case $38128f7d3b5b6d4a$exports.END_DRAG:
        case $38128f7d3b5b6d4a$exports.DROP:
        default:
            return $fd870c04d85931de$var$ALL;
    }
    var targetIds = action.targetIds;
    var prevTargetIds = dragOperation.targetIds;
    var result = (0, $fd870c04d85931de$var$_xor2.default)(targetIds, prevTargetIds);
    var didChange = false;
    if (result.length === 0) {
        for(var i = 0; i < targetIds.length; i++)if (targetIds[i] !== prevTargetIds[i]) {
            didChange = true;
            break;
        }
    } else didChange = true;
    if (!didChange) return $fd870c04d85931de$var$NONE;
    var prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
    var innermostTargetId = targetIds[targetIds.length - 1];
    if (prevInnermostTargetId !== innermostTargetId) {
        if (prevInnermostTargetId) result.push(prevInnermostTargetId);
        if (innermostTargetId) result.push(innermostTargetId);
    }
    return result;
}
function $fd870c04d85931de$var$areDirty(state, handlerIds) {
    if (state === $fd870c04d85931de$var$NONE) return false;
    if (state === $fd870c04d85931de$var$ALL || typeof handlerIds === 'undefined') return true;
    return (0, $fd870c04d85931de$var$_intersection2.default)(handlerIds, state).length > 0;
}


var $49542ad051169292$var$_dirtyHandlerIds2 = $49542ad051169292$var$_interopRequireDefault($fd870c04d85931de$exports);
var $ba32bddc96b9a473$exports = {};
"use strict";
Object.defineProperty($ba32bddc96b9a473$exports, "__esModule", {
    value: true
});
$ba32bddc96b9a473$exports.default = $ba32bddc96b9a473$var$stateId;
function $ba32bddc96b9a473$var$stateId() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return state + 1;
}


var $49542ad051169292$var$_stateId2 = $49542ad051169292$var$_interopRequireDefault($ba32bddc96b9a473$exports);
function $49542ad051169292$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $49542ad051169292$var$reduce() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];
    return {
        dirtyHandlerIds: (0, $49542ad051169292$var$_dirtyHandlerIds2.default)(state.dirtyHandlerIds, action, state.dragOperation),
        dragOffset: (0, $49542ad051169292$var$_dragOffset2.default)(state.dragOffset, action),
        refCount: (0, $49542ad051169292$var$_refCount2.default)(state.refCount, action),
        dragOperation: (0, $49542ad051169292$var$_dragOperation2.default)(state.dragOperation, action),
        stateId: (0, $49542ad051169292$var$_stateId2.default)(state.stateId)
    };
}


var $585d8f259a1ab7ea$var$_reducers2 = $585d8f259a1ab7ea$var$_interopRequireDefault($49542ad051169292$exports);

var $585d8f259a1ab7ea$var$dragDropActions = $585d8f259a1ab7ea$var$_interopRequireWildcard($38128f7d3b5b6d4a$exports);
var $ebb680a63590e74b$exports = {};
'use strict';
Object.defineProperty($ebb680a63590e74b$exports, "__esModule", {
    value: true
});
var $ebb680a63590e74b$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $ebb680a63590e74b$var$_invariant2 = $ebb680a63590e74b$var$_interopRequireDefault($06dab2fcf604e778$exports);

var $ebb680a63590e74b$var$_isArray2 = $ebb680a63590e74b$var$_interopRequireDefault($62cdb8c6d4925eaf$exports);

var $ebb680a63590e74b$var$_matchesType2 = $ebb680a63590e74b$var$_interopRequireDefault($217d20e9021e6d93$exports);
var $880b77e3611eaa31$exports = {};
'use strict';
Object.defineProperty($880b77e3611eaa31$exports, "__esModule", {
    value: true
});
var $880b77e3611eaa31$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $880b77e3611eaa31$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var $880b77e3611eaa31$var$_invariant2 = $880b77e3611eaa31$var$_interopRequireDefault($06dab2fcf604e778$exports);

var $880b77e3611eaa31$var$_isArray2 = $880b77e3611eaa31$var$_interopRequireDefault($62cdb8c6d4925eaf$exports);
var $973d8332c11ea074$exports = {};
"use strict";
var $2f0aa12e6bc7ce1d$exports = {};
"use strict";
// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
$2f0aa12e6bc7ce1d$exports = $2f0aa12e6bc7ce1d$var$rawAsap;
function $2f0aa12e6bc7ce1d$var$rawAsap(task) {
    if (!$2f0aa12e6bc7ce1d$var$queue.length) {
        $2f0aa12e6bc7ce1d$var$requestFlush();
        $2f0aa12e6bc7ce1d$var$flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    $2f0aa12e6bc7ce1d$var$queue[$2f0aa12e6bc7ce1d$var$queue.length] = task;
}
var $2f0aa12e6bc7ce1d$var$queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var $2f0aa12e6bc7ce1d$var$flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var $2f0aa12e6bc7ce1d$var$requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var $2f0aa12e6bc7ce1d$var$index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var $2f0aa12e6bc7ce1d$var$capacity = 1024;
// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function $2f0aa12e6bc7ce1d$var$flush() {
    while($2f0aa12e6bc7ce1d$var$index < $2f0aa12e6bc7ce1d$var$queue.length){
        var currentIndex = $2f0aa12e6bc7ce1d$var$index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        $2f0aa12e6bc7ce1d$var$index = $2f0aa12e6bc7ce1d$var$index + 1;
        $2f0aa12e6bc7ce1d$var$queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if ($2f0aa12e6bc7ce1d$var$index > $2f0aa12e6bc7ce1d$var$capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for(var scan = 0, newLength = $2f0aa12e6bc7ce1d$var$queue.length - $2f0aa12e6bc7ce1d$var$index; scan < newLength; scan++)$2f0aa12e6bc7ce1d$var$queue[scan] = $2f0aa12e6bc7ce1d$var$queue[scan + $2f0aa12e6bc7ce1d$var$index];
            $2f0aa12e6bc7ce1d$var$queue.length -= $2f0aa12e6bc7ce1d$var$index;
            $2f0aa12e6bc7ce1d$var$index = 0;
        }
    }
    $2f0aa12e6bc7ce1d$var$queue.length = 0;
    $2f0aa12e6bc7ce1d$var$index = 0;
    $2f0aa12e6bc7ce1d$var$flushing = false;
}
// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
/* globals self */ var $2f0aa12e6bc7ce1d$var$scope = typeof $parcel$global !== "undefined" ? $parcel$global : self;
var $2f0aa12e6bc7ce1d$var$BrowserMutationObserver = $2f0aa12e6bc7ce1d$var$scope.MutationObserver || $2f0aa12e6bc7ce1d$var$scope.WebKitMutationObserver;
// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof $2f0aa12e6bc7ce1d$var$BrowserMutationObserver === "function") $2f0aa12e6bc7ce1d$var$requestFlush = $2f0aa12e6bc7ce1d$var$makeRequestCallFromMutationObserver($2f0aa12e6bc7ce1d$var$flush);
else $2f0aa12e6bc7ce1d$var$requestFlush = $2f0aa12e6bc7ce1d$var$makeRequestCallFromTimer($2f0aa12e6bc7ce1d$var$flush);
// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
$2f0aa12e6bc7ce1d$var$rawAsap.requestFlush = $2f0aa12e6bc7ce1d$var$requestFlush;
// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function $2f0aa12e6bc7ce1d$var$makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new $2f0aa12e6bc7ce1d$var$BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {
        characterData: true
    });
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}
// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html
// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.
// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }
// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.
// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }
// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.
// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.
function $2f0aa12e6bc7ce1d$var$makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);
        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}
// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
$2f0aa12e6bc7ce1d$var$rawAsap.makeRequestCallFromTimer = $2f0aa12e6bc7ce1d$var$makeRequestCallFromTimer; // ASAP was originally a nextTick shim included in Q. This was factored out
 // into this ASAP package. It was later adapted to RSVP which made further
 // amendments. These decisions, particularly to marginalize MessageChannel and
 // to capture the MutationObserver implementation in a closure, were integrated
 // back into ASAP proper.
 // https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js


// RawTasks are recycled to reduce GC churn.
var $973d8332c11ea074$var$freeTasks = [];
// We queue errors to ensure they are thrown in right order (FIFO).
// Array-as-queue is good enough here, since we are just dealing with exceptions.
var $973d8332c11ea074$var$pendingErrors = [];
var $973d8332c11ea074$var$requestErrorThrow = $2f0aa12e6bc7ce1d$exports.makeRequestCallFromTimer($973d8332c11ea074$var$throwFirstError);
function $973d8332c11ea074$var$throwFirstError() {
    if ($973d8332c11ea074$var$pendingErrors.length) throw $973d8332c11ea074$var$pendingErrors.shift();
}
/**
 * Calls a task as soon as possible after returning, in its own event, with priority
 * over other events like animation, reflow, and repaint. An error thrown from an
 * event will not interrupt, nor even substantially slow down the processing of
 * other events, but will be rather postponed to a lower priority event.
 * @param {{call}} task A callable object, typically a function that takes no
 * arguments.
 */ $973d8332c11ea074$exports = $973d8332c11ea074$var$asap;
function $973d8332c11ea074$var$asap(task) {
    var rawTask;
    if ($973d8332c11ea074$var$freeTasks.length) rawTask = $973d8332c11ea074$var$freeTasks.pop();
    else rawTask = new $973d8332c11ea074$var$RawTask();
    rawTask.task = task;
    $2f0aa12e6bc7ce1d$exports(rawTask);
}
// We wrap tasks with recyclable task objects.  A task object implements
// `call`, just like a function.
function $973d8332c11ea074$var$RawTask() {
    this.task = null;
}
// The sole purpose of wrapping the task is to catch the exception and recycle
// the task object after its single use.
$973d8332c11ea074$var$RawTask.prototype.call = function() {
    try {
        this.task.call();
    } catch (error) {
        if ($973d8332c11ea074$var$asap.onerror) // This hook exists purely for testing purposes.
        // Its name will be periodically randomized to break any code that
        // depends on its existence.
        $973d8332c11ea074$var$asap.onerror(error);
        else {
            // In a web browser, exceptions are not fatal. However, to avoid
            // slowing down the queue of pending tasks, we rethrow the error in a
            // lower priority turn.
            $973d8332c11ea074$var$pendingErrors.push(error);
            $973d8332c11ea074$var$requestErrorThrow();
        }
    } finally{
        this.task = null;
        $973d8332c11ea074$var$freeTasks[$973d8332c11ea074$var$freeTasks.length] = this;
    }
};


var $880b77e3611eaa31$var$_asap2 = $880b77e3611eaa31$var$_interopRequireDefault($973d8332c11ea074$exports);

var $b0690eacfc12b9b9$exports = {};
"use strict";
Object.defineProperty($b0690eacfc12b9b9$exports, "__esModule", {
    value: true
});
$b0690eacfc12b9b9$exports.default = $b0690eacfc12b9b9$var$getNextUniqueId;
var $b0690eacfc12b9b9$var$nextUniqueId = 0;
function $b0690eacfc12b9b9$var$getNextUniqueId() {
    return $b0690eacfc12b9b9$var$nextUniqueId++;
}


var $880b77e3611eaa31$var$_getNextUniqueId2 = $880b77e3611eaa31$var$_interopRequireDefault($b0690eacfc12b9b9$exports);
function $880b77e3611eaa31$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $880b77e3611eaa31$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $880b77e3611eaa31$var$HandlerRoles = {
    SOURCE: 'SOURCE',
    TARGET: 'TARGET'
};
function $880b77e3611eaa31$var$validateSourceContract(source) {
    (0, $880b77e3611eaa31$var$_invariant2.default)(typeof source.canDrag === 'function', 'Expected canDrag to be a function.');
    (0, $880b77e3611eaa31$var$_invariant2.default)(typeof source.beginDrag === 'function', 'Expected beginDrag to be a function.');
    (0, $880b77e3611eaa31$var$_invariant2.default)(typeof source.endDrag === 'function', 'Expected endDrag to be a function.');
}
function $880b77e3611eaa31$var$validateTargetContract(target) {
    (0, $880b77e3611eaa31$var$_invariant2.default)(typeof target.canDrop === 'function', 'Expected canDrop to be a function.');
    (0, $880b77e3611eaa31$var$_invariant2.default)(typeof target.hover === 'function', 'Expected hover to be a function.');
    (0, $880b77e3611eaa31$var$_invariant2.default)(typeof target.drop === 'function', 'Expected beginDrag to be a function.');
}
function $880b77e3611eaa31$var$validateType(type, allowArray) {
    if (allowArray && (0, $880b77e3611eaa31$var$_isArray2.default)(type)) {
        type.forEach(function(t) {
            return $880b77e3611eaa31$var$validateType(t, false);
        });
        return;
    }
    (0, $880b77e3611eaa31$var$_invariant2.default)(typeof type === 'string' || (typeof type === 'undefined' ? 'undefined' : $880b77e3611eaa31$var$_typeof(type)) === 'symbol', allowArray ? 'Type can only be a string, a symbol, or an array of either.' : 'Type can only be a string or a symbol.');
}
function $880b77e3611eaa31$var$getNextHandlerId(role) {
    var id = (0, $880b77e3611eaa31$var$_getNextUniqueId2.default)().toString();
    switch(role){
        case $880b77e3611eaa31$var$HandlerRoles.SOURCE:
            return 'S' + id;
        case $880b77e3611eaa31$var$HandlerRoles.TARGET:
            return 'T' + id;
        default:
            (0, $880b77e3611eaa31$var$_invariant2.default)(false, 'Unknown role: ' + role);
    }
}
function $880b77e3611eaa31$var$parseRoleFromHandlerId(handlerId) {
    switch(handlerId[0]){
        case 'S':
            return $880b77e3611eaa31$var$HandlerRoles.SOURCE;
        case 'T':
            return $880b77e3611eaa31$var$HandlerRoles.TARGET;
        default:
            (0, $880b77e3611eaa31$var$_invariant2.default)(false, 'Cannot parse handler ID: ' + handlerId);
    }
}
var $880b77e3611eaa31$var$HandlerRegistry = function() {
    function HandlerRegistry(store) {
        $880b77e3611eaa31$var$_classCallCheck(this, HandlerRegistry);
        this.store = store;
        this.types = {};
        this.handlers = {};
        this.pinnedSourceId = null;
        this.pinnedSource = null;
    }
    $880b77e3611eaa31$var$_createClass(HandlerRegistry, [
        {
            key: 'addSource',
            value: function addSource(type, source) {
                $880b77e3611eaa31$var$validateType(type);
                $880b77e3611eaa31$var$validateSourceContract(source);
                var sourceId = this.addHandler($880b77e3611eaa31$var$HandlerRoles.SOURCE, type, source);
                this.store.dispatch((0, $8960679e31887519$exports.addSource)(sourceId));
                return sourceId;
            }
        },
        {
            key: 'addTarget',
            value: function addTarget(type, target) {
                $880b77e3611eaa31$var$validateType(type, true);
                $880b77e3611eaa31$var$validateTargetContract(target);
                var targetId = this.addHandler($880b77e3611eaa31$var$HandlerRoles.TARGET, type, target);
                this.store.dispatch((0, $8960679e31887519$exports.addTarget)(targetId));
                return targetId;
            }
        },
        {
            key: 'addHandler',
            value: function addHandler(role, type, handler) {
                var id = $880b77e3611eaa31$var$getNextHandlerId(role);
                this.types[id] = type;
                this.handlers[id] = handler;
                return id;
            }
        },
        {
            key: 'containsHandler',
            value: function containsHandler(handler) {
                var _this = this;
                return Object.keys(this.handlers).some(function(key) {
                    return _this.handlers[key] === handler;
                });
            }
        },
        {
            key: 'getSource',
            value: function getSource(sourceId, includePinned) {
                (0, $880b77e3611eaa31$var$_invariant2.default)(this.isSourceId(sourceId), 'Expected a valid source ID.');
                var isPinned = includePinned && sourceId === this.pinnedSourceId;
                var source = isPinned ? this.pinnedSource : this.handlers[sourceId];
                return source;
            }
        },
        {
            key: 'getTarget',
            value: function getTarget(targetId) {
                (0, $880b77e3611eaa31$var$_invariant2.default)(this.isTargetId(targetId), 'Expected a valid target ID.');
                return this.handlers[targetId];
            }
        },
        {
            key: 'getSourceType',
            value: function getSourceType(sourceId) {
                (0, $880b77e3611eaa31$var$_invariant2.default)(this.isSourceId(sourceId), 'Expected a valid source ID.');
                return this.types[sourceId];
            }
        },
        {
            key: 'getTargetType',
            value: function getTargetType(targetId) {
                (0, $880b77e3611eaa31$var$_invariant2.default)(this.isTargetId(targetId), 'Expected a valid target ID.');
                return this.types[targetId];
            }
        },
        {
            key: 'isSourceId',
            value: function isSourceId(handlerId) {
                var role = $880b77e3611eaa31$var$parseRoleFromHandlerId(handlerId);
                return role === $880b77e3611eaa31$var$HandlerRoles.SOURCE;
            }
        },
        {
            key: 'isTargetId',
            value: function isTargetId(handlerId) {
                var role = $880b77e3611eaa31$var$parseRoleFromHandlerId(handlerId);
                return role === $880b77e3611eaa31$var$HandlerRoles.TARGET;
            }
        },
        {
            key: 'removeSource',
            value: function removeSource(sourceId) {
                var _this2 = this;
                (0, $880b77e3611eaa31$var$_invariant2.default)(this.getSource(sourceId), 'Expected an existing source.');
                this.store.dispatch((0, $8960679e31887519$exports.removeSource)(sourceId));
                (0, $880b77e3611eaa31$var$_asap2.default)(function() {
                    delete _this2.handlers[sourceId];
                    delete _this2.types[sourceId];
                });
            }
        },
        {
            key: 'removeTarget',
            value: function removeTarget(targetId) {
                var _this3 = this;
                (0, $880b77e3611eaa31$var$_invariant2.default)(this.getTarget(targetId), 'Expected an existing target.');
                this.store.dispatch((0, $8960679e31887519$exports.removeTarget)(targetId));
                (0, $880b77e3611eaa31$var$_asap2.default)(function() {
                    delete _this3.handlers[targetId];
                    delete _this3.types[targetId];
                });
            }
        },
        {
            key: 'pinSource',
            value: function pinSource(sourceId) {
                var source = this.getSource(sourceId);
                (0, $880b77e3611eaa31$var$_invariant2.default)(source, 'Expected an existing source.');
                this.pinnedSourceId = sourceId;
                this.pinnedSource = source;
            }
        },
        {
            key: 'unpinSource',
            value: function unpinSource() {
                (0, $880b77e3611eaa31$var$_invariant2.default)(this.pinnedSource, 'No source is pinned at the time.');
                this.pinnedSourceId = null;
                this.pinnedSource = null;
            }
        }
    ]);
    return HandlerRegistry;
}();
$880b77e3611eaa31$exports.default = $880b77e3611eaa31$var$HandlerRegistry;


var $ebb680a63590e74b$var$_HandlerRegistry2 = $ebb680a63590e74b$var$_interopRequireDefault($880b77e3611eaa31$exports);


function $ebb680a63590e74b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ebb680a63590e74b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $ebb680a63590e74b$var$DragDropMonitor = function() {
    function DragDropMonitor(store) {
        $ebb680a63590e74b$var$_classCallCheck(this, DragDropMonitor);
        this.store = store;
        this.registry = new $ebb680a63590e74b$var$_HandlerRegistry2.default(store);
    }
    $ebb680a63590e74b$var$_createClass(DragDropMonitor, [
        {
            key: 'subscribeToStateChange',
            value: function subscribeToStateChange(listener) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var handlerIds = options.handlerIds;
                (0, $ebb680a63590e74b$var$_invariant2.default)(typeof listener === 'function', 'listener must be a function.');
                (0, $ebb680a63590e74b$var$_invariant2.default)(typeof handlerIds === 'undefined' || (0, $ebb680a63590e74b$var$_isArray2.default)(handlerIds), 'handlerIds, when specified, must be an array of strings.');
                var prevStateId = this.store.getState().stateId;
                var handleChange = function handleChange() {
                    var state = _this.store.getState();
                    var currentStateId = state.stateId;
                    try {
                        var canSkipListener = currentStateId === prevStateId || currentStateId === prevStateId + 1 && !(0, $fd870c04d85931de$exports.areDirty)(state.dirtyHandlerIds, handlerIds);
                        if (!canSkipListener) listener();
                    } finally{
                        prevStateId = currentStateId;
                    }
                };
                return this.store.subscribe(handleChange);
            }
        },
        {
            key: 'subscribeToOffsetChange',
            value: function subscribeToOffsetChange(listener) {
                var _this2 = this;
                (0, $ebb680a63590e74b$var$_invariant2.default)(typeof listener === 'function', 'listener must be a function.');
                var previousState = this.store.getState().dragOffset;
                var handleChange = function handleChange() {
                    var nextState = _this2.store.getState().dragOffset;
                    if (nextState === previousState) return;
                    previousState = nextState;
                    listener();
                };
                return this.store.subscribe(handleChange);
            }
        },
        {
            key: 'canDragSource',
            value: function canDragSource(sourceId) {
                var source = this.registry.getSource(sourceId);
                (0, $ebb680a63590e74b$var$_invariant2.default)(source, 'Expected to find a valid source.');
                if (this.isDragging()) return false;
                return source.canDrag(this, sourceId);
            }
        },
        {
            key: 'canDropOnTarget',
            value: function canDropOnTarget(targetId) {
                var target = this.registry.getTarget(targetId);
                (0, $ebb680a63590e74b$var$_invariant2.default)(target, 'Expected to find a valid target.');
                if (!this.isDragging() || this.didDrop()) return false;
                var targetType = this.registry.getTargetType(targetId);
                var draggedItemType = this.getItemType();
                return (0, $ebb680a63590e74b$var$_matchesType2.default)(targetType, draggedItemType) && target.canDrop(this, targetId);
            }
        },
        {
            key: 'isDragging',
            value: function isDragging() {
                return Boolean(this.getItemType());
            }
        },
        {
            key: 'isDraggingSource',
            value: function isDraggingSource(sourceId) {
                var source = this.registry.getSource(sourceId, true);
                (0, $ebb680a63590e74b$var$_invariant2.default)(source, 'Expected to find a valid source.');
                if (!this.isDragging() || !this.isSourcePublic()) return false;
                var sourceType = this.registry.getSourceType(sourceId);
                var draggedItemType = this.getItemType();
                if (sourceType !== draggedItemType) return false;
                return source.isDragging(this, sourceId);
            }
        },
        {
            key: 'isOverTarget',
            value: function isOverTarget(targetId) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    shallow: false
                };
                var shallow = options.shallow;
                if (!this.isDragging()) return false;
                var targetType = this.registry.getTargetType(targetId);
                var draggedItemType = this.getItemType();
                if (!(0, $ebb680a63590e74b$var$_matchesType2.default)(targetType, draggedItemType)) return false;
                var targetIds = this.getTargetIds();
                if (!targetIds.length) return false;
                var index = targetIds.indexOf(targetId);
                if (shallow) return index === targetIds.length - 1;
                else return index > -1;
            }
        },
        {
            key: 'getItemType',
            value: function getItemType() {
                return this.store.getState().dragOperation.itemType;
            }
        },
        {
            key: 'getItem',
            value: function getItem() {
                return this.store.getState().dragOperation.item;
            }
        },
        {
            key: 'getSourceId',
            value: function getSourceId() {
                return this.store.getState().dragOperation.sourceId;
            }
        },
        {
            key: 'getTargetIds',
            value: function getTargetIds() {
                return this.store.getState().dragOperation.targetIds;
            }
        },
        {
            key: 'getDropResult',
            value: function getDropResult() {
                return this.store.getState().dragOperation.dropResult;
            }
        },
        {
            key: 'didDrop',
            value: function didDrop() {
                return this.store.getState().dragOperation.didDrop;
            }
        },
        {
            key: 'isSourcePublic',
            value: function isSourcePublic() {
                return this.store.getState().dragOperation.isSourcePublic;
            }
        },
        {
            key: 'getInitialClientOffset',
            value: function getInitialClientOffset() {
                return this.store.getState().dragOffset.initialClientOffset;
            }
        },
        {
            key: 'getInitialSourceClientOffset',
            value: function getInitialSourceClientOffset() {
                return this.store.getState().dragOffset.initialSourceClientOffset;
            }
        },
        {
            key: 'getClientOffset',
            value: function getClientOffset() {
                return this.store.getState().dragOffset.clientOffset;
            }
        },
        {
            key: 'getSourceClientOffset',
            value: function getSourceClientOffset() {
                return (0, $c4900fad33c0b9a3$exports.getSourceClientOffset)(this.store.getState().dragOffset);
            }
        },
        {
            key: 'getDifferenceFromInitialOffset',
            value: function getDifferenceFromInitialOffset() {
                return (0, $c4900fad33c0b9a3$exports.getDifferenceFromInitialOffset)(this.store.getState().dragOffset);
            }
        }
    ]);
    return DragDropMonitor;
}();
$ebb680a63590e74b$exports.default = $ebb680a63590e74b$var$DragDropMonitor;


var $585d8f259a1ab7ea$var$_DragDropMonitor2 = $585d8f259a1ab7ea$var$_interopRequireDefault($ebb680a63590e74b$exports);
function $585d8f259a1ab7ea$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $585d8f259a1ab7ea$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $585d8f259a1ab7ea$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $585d8f259a1ab7ea$var$DragDropManager = function() {
    function DragDropManager(createBackend) {
        var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        $585d8f259a1ab7ea$var$_classCallCheck(this, DragDropManager);
        var store = (0, $585d8f259a1ab7ea$var$_createStore2.default)($585d8f259a1ab7ea$var$_reducers2.default);
        this.context = context;
        this.store = store;
        this.monitor = new $585d8f259a1ab7ea$var$_DragDropMonitor2.default(store);
        this.registry = this.monitor.registry;
        this.backend = createBackend(this);
        store.subscribe(this.handleRefCountChange.bind(this));
    }
    $585d8f259a1ab7ea$var$_createClass(DragDropManager, [
        {
            key: 'handleRefCountChange',
            value: function handleRefCountChange() {
                var shouldSetUp = this.store.getState().refCount > 0;
                if (shouldSetUp && !this.isSetUp) {
                    this.backend.setup();
                    this.isSetUp = true;
                } else if (!shouldSetUp && this.isSetUp) {
                    this.backend.teardown();
                    this.isSetUp = false;
                }
            }
        },
        {
            key: 'getContext',
            value: function getContext() {
                return this.context;
            }
        },
        {
            key: 'getMonitor',
            value: function getMonitor() {
                return this.monitor;
            }
        },
        {
            key: 'getBackend',
            value: function getBackend() {
                return this.backend;
            }
        },
        {
            key: 'getRegistry',
            value: function getRegistry() {
                return this.registry;
            }
        },
        {
            key: 'getActions',
            value: function getActions() {
                var manager = this;
                var dispatch = this.store.dispatch;
                function bindActionCreator(actionCreator) {
                    return function() {
                        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        var action = actionCreator.apply(manager, args);
                        if (typeof action !== 'undefined') dispatch(action);
                    };
                }
                return Object.keys($585d8f259a1ab7ea$var$dragDropActions).filter(function(key) {
                    return typeof $585d8f259a1ab7ea$var$dragDropActions[key] === 'function';
                }).reduce(function(boundActions, key) {
                    var action = $585d8f259a1ab7ea$var$dragDropActions[key];
                    boundActions[key] = bindActionCreator(action); // eslint-disable-line no-param-reassign
                    return boundActions;
                }, {});
            }
        }
    ]);
    return DragDropManager;
}();
$585d8f259a1ab7ea$exports.default = $585d8f259a1ab7ea$var$DragDropManager;


Object.defineProperty($a088142e142fdb75$exports, 'DragDropManager', {
    enumerable: true,
    get: function get() {
        return $a088142e142fdb75$var$_interopRequireDefault($585d8f259a1ab7ea$exports).default;
    }
});
var $4a9964e70906e1ad$exports = {};
"use strict";
Object.defineProperty($4a9964e70906e1ad$exports, "__esModule", {
    value: true
});
var $4a9964e70906e1ad$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $4a9964e70906e1ad$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $4a9964e70906e1ad$var$DragSource = function() {
    function DragSource() {
        $4a9964e70906e1ad$var$_classCallCheck(this, DragSource);
    }
    $4a9964e70906e1ad$var$_createClass(DragSource, [
        {
            key: "canDrag",
            value: function canDrag() {
                return true;
            }
        },
        {
            key: "isDragging",
            value: function isDragging(monitor, handle) {
                return handle === monitor.getSourceId();
            }
        },
        {
            key: "endDrag",
            value: function endDrag() {}
        }
    ]);
    return DragSource;
}();
$4a9964e70906e1ad$exports.default = $4a9964e70906e1ad$var$DragSource;


Object.defineProperty($a088142e142fdb75$exports, 'DragSource', {
    enumerable: true,
    get: function get() {
        return $a088142e142fdb75$var$_interopRequireDefault($4a9964e70906e1ad$exports).default;
    }
});
var $40e01a633a28869a$exports = {};
"use strict";
Object.defineProperty($40e01a633a28869a$exports, "__esModule", {
    value: true
});
var $40e01a633a28869a$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $40e01a633a28869a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $40e01a633a28869a$var$DropTarget = function() {
    function DropTarget() {
        $40e01a633a28869a$var$_classCallCheck(this, DropTarget);
    }
    $40e01a633a28869a$var$_createClass(DropTarget, [
        {
            key: "canDrop",
            value: function canDrop() {
                return true;
            }
        },
        {
            key: "hover",
            value: function hover() {}
        },
        {
            key: "drop",
            value: function drop() {}
        }
    ]);
    return DropTarget;
}();
$40e01a633a28869a$exports.default = $40e01a633a28869a$var$DropTarget;


Object.defineProperty($a088142e142fdb75$exports, 'DropTarget', {
    enumerable: true,
    get: function get() {
        return $a088142e142fdb75$var$_interopRequireDefault($40e01a633a28869a$exports).default;
    }
});
var $5c9f5468b94fe910$exports = {};
'use strict';
Object.defineProperty($5c9f5468b94fe910$exports, "__esModule", {
    value: true
});
var $5c9f5468b94fe910$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
$5c9f5468b94fe910$exports.default = $5c9f5468b94fe910$var$createBackend;

var $5c9f5468b94fe910$var$_noop2 = $5c9f5468b94fe910$var$_interopRequireDefault($f06a40ac7ca7d7b2$exports);
function $5c9f5468b94fe910$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5c9f5468b94fe910$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $5c9f5468b94fe910$var$TestBackend = function() {
    function TestBackend(manager) {
        $5c9f5468b94fe910$var$_classCallCheck(this, TestBackend);
        this.actions = manager.getActions();
    }
    $5c9f5468b94fe910$var$_createClass(TestBackend, [
        {
            key: 'setup',
            value: function setup() {
                this.didCallSetup = true;
            }
        },
        {
            key: 'teardown',
            value: function teardown() {
                this.didCallTeardown = true;
            }
        },
        {
            key: 'connectDragSource',
            value: function connectDragSource() {
                return $5c9f5468b94fe910$var$_noop2.default;
            }
        },
        {
            key: 'connectDragPreview',
            value: function connectDragPreview() {
                return $5c9f5468b94fe910$var$_noop2.default;
            }
        },
        {
            key: 'connectDropTarget',
            value: function connectDropTarget() {
                return $5c9f5468b94fe910$var$_noop2.default;
            }
        },
        {
            key: 'simulateBeginDrag',
            value: function simulateBeginDrag(sourceIds, options) {
                this.actions.beginDrag(sourceIds, options);
            }
        },
        {
            key: 'simulatePublishDragSource',
            value: function simulatePublishDragSource() {
                this.actions.publishDragSource();
            }
        },
        {
            key: 'simulateHover',
            value: function simulateHover(targetIds, options) {
                this.actions.hover(targetIds, options);
            }
        },
        {
            key: 'simulateDrop',
            value: function simulateDrop() {
                this.actions.drop();
            }
        },
        {
            key: 'simulateEndDrag',
            value: function simulateEndDrag() {
                this.actions.endDrag();
            }
        }
    ]);
    return TestBackend;
}();
function $5c9f5468b94fe910$var$createBackend(manager) {
    return new $5c9f5468b94fe910$var$TestBackend(manager);
}


Object.defineProperty($a088142e142fdb75$exports, 'createTestBackend', {
    enumerable: true,
    get: function get() {
        return $a088142e142fdb75$var$_interopRequireDefault($5c9f5468b94fe910$exports).default;
    }
});
function $a088142e142fdb75$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}



var $05c834ae934a4136$var$_invariant2 = $05c834ae934a4136$var$_interopRequireDefault($06dab2fcf604e778$exports);
var $defe7d9837bba1eb$exports = {};
'use strict';
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $defe7d9837bba1eb$var$REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $defe7d9837bba1eb$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $defe7d9837bba1eb$var$defineProperty = Object.defineProperty;
var $defe7d9837bba1eb$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $defe7d9837bba1eb$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $defe7d9837bba1eb$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $defe7d9837bba1eb$var$getPrototypeOf = Object.getPrototypeOf;
var $defe7d9837bba1eb$var$objectPrototype = $defe7d9837bba1eb$var$getPrototypeOf && $defe7d9837bba1eb$var$getPrototypeOf(Object);
function $defe7d9837bba1eb$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        if ($defe7d9837bba1eb$var$objectPrototype) {
            var inheritedComponent = $defe7d9837bba1eb$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $defe7d9837bba1eb$var$objectPrototype) $defe7d9837bba1eb$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $defe7d9837bba1eb$var$getOwnPropertyNames(sourceComponent);
        if ($defe7d9837bba1eb$var$getOwnPropertySymbols) keys = keys.concat($defe7d9837bba1eb$var$getOwnPropertySymbols(sourceComponent));
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$defe7d9837bba1eb$var$REACT_STATICS[key] && !$defe7d9837bba1eb$var$KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = $defe7d9837bba1eb$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $defe7d9837bba1eb$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
        return targetComponent;
    }
    return targetComponent;
}
$defe7d9837bba1eb$exports = $defe7d9837bba1eb$var$hoistNonReactStatics;


var $05c834ae934a4136$var$_hoistNonReactStatics2 = $05c834ae934a4136$var$_interopRequireDefault($defe7d9837bba1eb$exports);
var $05c912093a27ac54$exports = {};
'use strict';
Object.defineProperty($05c912093a27ac54$exports, "__esModule", {
    value: true
});
$05c912093a27ac54$exports.default = $05c912093a27ac54$var$checkDecoratorArguments;
function $05c912093a27ac54$var$checkDecoratorArguments(functionName, signature) {
    var i, arg;
}


var $05c834ae934a4136$var$_checkDecoratorArguments2 = $05c834ae934a4136$var$_interopRequireDefault($05c912093a27ac54$exports);
function $05c834ae934a4136$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $05c834ae934a4136$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $05c834ae934a4136$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $05c834ae934a4136$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $05c834ae934a4136$var$CHILD_CONTEXT_TYPES = $05c834ae934a4136$exports.CHILD_CONTEXT_TYPES = {
    dragDropManager: $05c834ae934a4136$var$_propTypes2.default.object.isRequired
};
var $05c834ae934a4136$var$createChildContext = $05c834ae934a4136$exports.createChildContext = function createChildContext(backend, context) {
    return {
        dragDropManager: new $a088142e142fdb75$exports.DragDropManager(backend, context)
    };
};
var $05c834ae934a4136$var$unpackBackendForEs5Users = $05c834ae934a4136$exports.unpackBackendForEs5Users = function unpackBackendForEs5Users(backendOrModule) {
    // Auto-detect ES6 default export for people still using ES5
    var backend = backendOrModule;
    if ((typeof backend === 'undefined' ? 'undefined' : $05c834ae934a4136$var$_typeof(backend)) === 'object' && typeof backend.default === 'function') backend = backend.default;
    (0, $05c834ae934a4136$var$_invariant2.default)(typeof backend === 'function', "Expected the backend to be a function or an ES6 module exporting a default function. Read more: http://react-dnd.github.io/react-dnd/docs-drag-drop-context.html");
    return backend;
};
function $05c834ae934a4136$var$DragDropContext(backendOrModule) {
    $05c834ae934a4136$var$_checkDecoratorArguments2.default.apply(undefined, [
        'DragDropContext',
        'backend'
    ].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line prefer-rest-params
    var backend = $05c834ae934a4136$var$unpackBackendForEs5Users(backendOrModule);
    var childContext = $05c834ae934a4136$var$createChildContext(backend);
    return function decorateContext(DecoratedComponent) {
        var _class, _temp;
        var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
        var DragDropContextContainer = (_temp = _class = function(_Component) {
            $05c834ae934a4136$var$_inherits(DragDropContextContainer, _Component);
            function DragDropContextContainer() {
                $05c834ae934a4136$var$_classCallCheck(this, DragDropContextContainer);
                return $05c834ae934a4136$var$_possibleConstructorReturn(this, (DragDropContextContainer.__proto__ || Object.getPrototypeOf(DragDropContextContainer)).apply(this, arguments));
            }
            $05c834ae934a4136$var$_createClass(DragDropContextContainer, [
                {
                    key: 'getDecoratedComponentInstance',
                    value: function getDecoratedComponentInstance() {
                        (0, $05c834ae934a4136$var$_invariant2.default)(this.child, 'In order to access an instance of the decorated component it can not be a stateless component.');
                        return this.child;
                    }
                },
                {
                    key: 'getManager',
                    value: function getManager() {
                        return childContext.dragDropManager;
                    }
                },
                {
                    key: 'getChildContext',
                    value: function getChildContext() {
                        return childContext;
                    }
                },
                {
                    key: 'render',
                    value: function render() {
                        var _this2 = this;
                        return $05c834ae934a4136$var$_react2.default.createElement(DecoratedComponent, $05c834ae934a4136$var$_extends({}, this.props, {
                            ref: function ref(child) {
                                _this2.child = child;
                            }
                        }));
                    }
                }
            ]);
            return DragDropContextContainer;
        }($NdCUR.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = 'DragDropContext(' + displayName + ')', _class.childContextTypes = $05c834ae934a4136$var$CHILD_CONTEXT_TYPES, _temp);
        return (0, $05c834ae934a4136$var$_hoistNonReactStatics2.default)(DragDropContextContainer, DecoratedComponent);
    };
}


Object.defineProperty($db9eac57989e0572$exports, 'DragDropContext', {
    enumerable: true,
    get: function get() {
        return $db9eac57989e0572$var$_interopRequireDefault($05c834ae934a4136$exports).default;
    }
});
var $22028045d6cdaf00$exports = {};
'use strict';
Object.defineProperty($22028045d6cdaf00$exports, "__esModule", {
    value: true
});
$22028045d6cdaf00$exports.default = undefined;
var $22028045d6cdaf00$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $22028045d6cdaf00$var$_class, $22028045d6cdaf00$var$_temp;

var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");
var $22028045d6cdaf00$var$_propTypes2 = $22028045d6cdaf00$var$_interopRequireDefault($fGw9V);

function $22028045d6cdaf00$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $22028045d6cdaf00$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $22028045d6cdaf00$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $22028045d6cdaf00$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * This class is a React-Component based version of the DragDropContext.
 * This is an alternative to decorating an application component with an ES7 decorator.
 */ var $22028045d6cdaf00$var$DragDropContextProvider = ($22028045d6cdaf00$var$_temp = $22028045d6cdaf00$var$_class = function(_Component) {
    $22028045d6cdaf00$var$_inherits(DragDropContextProvider, _Component);
    function DragDropContextProvider(props, context) {
        $22028045d6cdaf00$var$_classCallCheck(this, DragDropContextProvider);
        /**
   * This property determines which window global to use for creating the DragDropManager.
   * If a window has been injected explicitly via props, that is used first. If it is available
   * as a context value, then use that, otherwise use the browser global.
   */ var _this = $22028045d6cdaf00$var$_possibleConstructorReturn(this, (DragDropContextProvider.__proto__ || Object.getPrototypeOf(DragDropContextProvider)).call(this, props, context));
        var getWindow = function getWindow() {
            if (props && props.window) return props.window;
            else if (context && context.window) return context.window;
            else if (typeof window !== 'undefined') return window;
            return undefined;
        };
        _this.backend = (0, $05c834ae934a4136$exports.unpackBackendForEs5Users)(props.backend);
        _this.childContext = (0, $05c834ae934a4136$exports.createChildContext)(_this.backend, {
            window: getWindow()
        });
        return _this;
    }
    $22028045d6cdaf00$var$_createClass(DragDropContextProvider, [
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if (nextProps.backend !== this.props.backend || nextProps.window !== this.props.window) throw new Error('DragDropContextProvider backend and window props must not change.');
            }
        },
        {
            key: 'getChildContext',
            value: function getChildContext() {
                return this.childContext;
            }
        },
        {
            key: 'render',
            value: function render() {
                return $NdCUR.Children.only(this.props.children);
            }
        }
    ]);
    return DragDropContextProvider;
}($NdCUR.Component), $22028045d6cdaf00$var$_class.propTypes = {
    backend: $22028045d6cdaf00$var$_propTypes2.default.oneOfType([
        $22028045d6cdaf00$var$_propTypes2.default.func,
        $22028045d6cdaf00$var$_propTypes2.default.object
    ]).isRequired,
    children: $22028045d6cdaf00$var$_propTypes2.default.element.isRequired,
    window: $22028045d6cdaf00$var$_propTypes2.default.object // eslint-disable-line react/forbid-prop-types
}, $22028045d6cdaf00$var$_class.defaultProps = {
    window: undefined
}, $22028045d6cdaf00$var$_class.childContextTypes = $05c834ae934a4136$exports.CHILD_CONTEXT_TYPES, $22028045d6cdaf00$var$_class.displayName = 'DragDropContextProvider', $22028045d6cdaf00$var$_class.contextTypes = {
    window: $22028045d6cdaf00$var$_propTypes2.default.object
}, $22028045d6cdaf00$var$_temp);
$22028045d6cdaf00$exports.default = $22028045d6cdaf00$var$DragDropContextProvider;


Object.defineProperty($db9eac57989e0572$exports, 'DragDropContextProvider', {
    enumerable: true,
    get: function get() {
        return $db9eac57989e0572$var$_interopRequireDefault($22028045d6cdaf00$exports).default;
    }
});
var $e874dd3d2849914e$exports = {};
'use strict';
Object.defineProperty($e874dd3d2849914e$exports, "__esModule", {
    value: true
});
var $e874dd3d2849914e$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $e874dd3d2849914e$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $e874dd3d2849914e$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
$e874dd3d2849914e$exports.default = $e874dd3d2849914e$var$DragLayer;

var $NdCUR = parcelRequire("NdCUR");
var $e874dd3d2849914e$var$_react2 = $e874dd3d2849914e$var$_interopRequireDefault($NdCUR);

var $fGw9V = parcelRequire("fGw9V");
var $e874dd3d2849914e$var$_propTypes2 = $e874dd3d2849914e$var$_interopRequireDefault($fGw9V);

var $e874dd3d2849914e$var$_hoistNonReactStatics2 = $e874dd3d2849914e$var$_interopRequireDefault($defe7d9837bba1eb$exports);

var $e874dd3d2849914e$var$_isPlainObject2 = $e874dd3d2849914e$var$_interopRequireDefault($fafe96f2de46333f$exports);

var $e874dd3d2849914e$var$_invariant2 = $e874dd3d2849914e$var$_interopRequireDefault($06dab2fcf604e778$exports);
var $82a8cc261b3db7d8$exports = {};
"use strict";
Object.defineProperty($82a8cc261b3db7d8$exports, "__esModule", {
    value: true
});
$82a8cc261b3db7d8$exports.default = $82a8cc261b3db7d8$var$shallowEqual;
function $82a8cc261b3db7d8$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    var hasOwn = Object.prototype.hasOwnProperty;
    for(var i = 0; i < keysA.length; i += 1){
        if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
        var valA = objA[keysA[i]];
        var valB = objB[keysA[i]];
        if (valA !== valB) return false;
    }
    return true;
}


var $e874dd3d2849914e$var$_shallowEqual2 = $e874dd3d2849914e$var$_interopRequireDefault($82a8cc261b3db7d8$exports);
var $93ee096e6b4d8055$exports = {};
'use strict';
Object.defineProperty($93ee096e6b4d8055$exports, "__esModule", {
    value: true
});
var $93ee096e6b4d8055$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
$93ee096e6b4d8055$exports.default = $93ee096e6b4d8055$var$shallowEqualScalar;
function $93ee096e6b4d8055$var$shallowEqualScalar(objA, objB) {
    if (objA === objB) return true;
    if ((typeof objA === 'undefined' ? 'undefined' : $93ee096e6b4d8055$var$_typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : $93ee096e6b4d8055$var$_typeof(objB)) !== 'object' || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    var hasOwn = Object.prototype.hasOwnProperty;
    for(var i = 0; i < keysA.length; i += 1){
        if (!hasOwn.call(objB, keysA[i])) return false;
        var valA = objA[keysA[i]];
        var valB = objB[keysA[i]];
        if (valA !== valB || (typeof valA === 'undefined' ? 'undefined' : $93ee096e6b4d8055$var$_typeof(valA)) === 'object' || (typeof valB === 'undefined' ? 'undefined' : $93ee096e6b4d8055$var$_typeof(valB)) === 'object') return false;
    }
    return true;
}


var $e874dd3d2849914e$var$_shallowEqualScalar2 = $e874dd3d2849914e$var$_interopRequireDefault($93ee096e6b4d8055$exports);

var $e874dd3d2849914e$var$_checkDecoratorArguments2 = $e874dd3d2849914e$var$_interopRequireDefault($05c912093a27ac54$exports);
function $e874dd3d2849914e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e874dd3d2849914e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e874dd3d2849914e$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $e874dd3d2849914e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $e874dd3d2849914e$var$DragLayer(collect) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    $e874dd3d2849914e$var$_checkDecoratorArguments2.default.apply(undefined, [
        'DragLayer',
        'collect[, options]'
    ].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line prefer-rest-params
    (0, $e874dd3d2849914e$var$_invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the first argument to DragLayer to be a function that collects props to inject into the component. ', 'Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs-drag-layer.html', collect);
    (0, $e874dd3d2849914e$var$_invariant2.default)((0, $e874dd3d2849914e$var$_isPlainObject2.default)(options), 'Expected "options" provided as the second argument to DragLayer to be a plain object when specified. Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs-drag-layer.html', options);
    return function decorateLayer(DecoratedComponent) {
        var _class, _temp;
        var _options$arePropsEqua = options.arePropsEqual, arePropsEqual = _options$arePropsEqua === undefined ? $e874dd3d2849914e$var$_shallowEqualScalar2.default : _options$arePropsEqua;
        var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
        var DragLayerContainer = (_temp = _class = function(_Component) {
            $e874dd3d2849914e$var$_inherits(DragLayerContainer, _Component);
            $e874dd3d2849914e$var$_createClass(DragLayerContainer, [
                {
                    key: 'getDecoratedComponentInstance',
                    value: function getDecoratedComponentInstance() {
                        (0, $e874dd3d2849914e$var$_invariant2.default)(this.child, 'In order to access an instance of the decorated component it can not be a stateless component.');
                        return this.child;
                    }
                },
                {
                    key: 'shouldComponentUpdate',
                    value: function shouldComponentUpdate(nextProps, nextState) {
                        return !arePropsEqual(nextProps, this.props) || !(0, $e874dd3d2849914e$var$_shallowEqual2.default)(nextState, this.state);
                    }
                }
            ]);
            function DragLayerContainer(props, context) {
                $e874dd3d2849914e$var$_classCallCheck(this, DragLayerContainer);
                var _this = $e874dd3d2849914e$var$_possibleConstructorReturn(this, (DragLayerContainer.__proto__ || Object.getPrototypeOf(DragLayerContainer)).call(this, props));
                _this.handleChange = _this.handleChange.bind(_this);
                _this.manager = context.dragDropManager;
                (0, $e874dd3d2849914e$var$_invariant2.default)($e874dd3d2849914e$var$_typeof(_this.manager) === 'object', "Could not find the drag and drop manager in the context of %s. Make sure to wrap the top-level component of your app with DragDropContext. Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#could-not-find-the-drag-and-drop-manager-in-the-context", displayName, displayName);
                _this.state = _this.getCurrentState();
                return _this;
            }
            $e874dd3d2849914e$var$_createClass(DragLayerContainer, [
                {
                    key: 'componentDidMount',
                    value: function componentDidMount() {
                        this.isCurrentlyMounted = true;
                        var monitor = this.manager.getMonitor();
                        this.unsubscribeFromOffsetChange = monitor.subscribeToOffsetChange(this.handleChange);
                        this.unsubscribeFromStateChange = monitor.subscribeToStateChange(this.handleChange);
                        this.handleChange();
                    }
                },
                {
                    key: 'componentWillUnmount',
                    value: function componentWillUnmount() {
                        this.isCurrentlyMounted = false;
                        this.unsubscribeFromOffsetChange();
                        this.unsubscribeFromStateChange();
                    }
                },
                {
                    key: 'handleChange',
                    value: function handleChange() {
                        if (!this.isCurrentlyMounted) return;
                        var nextState = this.getCurrentState();
                        if (!(0, $e874dd3d2849914e$var$_shallowEqual2.default)(nextState, this.state)) this.setState(nextState);
                    }
                },
                {
                    key: 'getCurrentState',
                    value: function getCurrentState() {
                        var monitor = this.manager.getMonitor();
                        return collect(monitor, this.props);
                    }
                },
                {
                    key: 'render',
                    value: function render() {
                        var _this2 = this;
                        return $e874dd3d2849914e$var$_react2.default.createElement(DecoratedComponent, $e874dd3d2849914e$var$_extends({}, this.props, this.state, {
                            ref: function ref(child) {
                                _this2.child = child;
                            }
                        }));
                    }
                }
            ]);
            return DragLayerContainer;
        }($NdCUR.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = 'DragLayer(' + displayName + ')', _class.contextTypes = {
            dragDropManager: $e874dd3d2849914e$var$_propTypes2.default.object.isRequired
        }, _temp);
        return (0, $e874dd3d2849914e$var$_hoistNonReactStatics2.default)(DragLayerContainer, DecoratedComponent);
    };
}


Object.defineProperty($db9eac57989e0572$exports, 'DragLayer', {
    enumerable: true,
    get: function get() {
        return $db9eac57989e0572$var$_interopRequireDefault($e874dd3d2849914e$exports).default;
    }
});
var $84d7f1239bfb9a58$exports = {};
'use strict';
Object.defineProperty($84d7f1239bfb9a58$exports, "__esModule", {
    value: true
});
$84d7f1239bfb9a58$exports.default = $84d7f1239bfb9a58$var$DragSource;

var $84d7f1239bfb9a58$var$_invariant2 = $84d7f1239bfb9a58$var$_interopRequireDefault($06dab2fcf604e778$exports);

var $84d7f1239bfb9a58$var$_isPlainObject2 = $84d7f1239bfb9a58$var$_interopRequireDefault($fafe96f2de46333f$exports);

var $84d7f1239bfb9a58$var$_checkDecoratorArguments2 = $84d7f1239bfb9a58$var$_interopRequireDefault($05c912093a27ac54$exports);
var $5a90f3023b5161ba$exports = {};
'use strict';
Object.defineProperty($5a90f3023b5161ba$exports, "__esModule", {
    value: true
});
var $5a90f3023b5161ba$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $5a90f3023b5161ba$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $5a90f3023b5161ba$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
$5a90f3023b5161ba$exports.default = $5a90f3023b5161ba$var$decorateHandler;

var $NdCUR = parcelRequire("NdCUR");
var $5a90f3023b5161ba$var$_react2 = $5a90f3023b5161ba$var$_interopRequireDefault($NdCUR);

var $fGw9V = parcelRequire("fGw9V");
var $5a90f3023b5161ba$var$_propTypes2 = $5a90f3023b5161ba$var$_interopRequireDefault($fGw9V);
var $ac6a2ce54e04fe32$export$1e511d4a378977f5;
var $ac6a2ce54e04fe32$export$e29d65b7eabdc6dd;
var $ac6a2ce54e04fe32$export$252720412a173de;
var $ac6a2ce54e04fe32$export$9ad012e5c3534b20;
var $ac6a2ce54e04fe32$export$9c59780726206893;
'use strict';
$ac6a2ce54e04fe32$export$1e511d4a378977f5 = true;
function $ac6a2ce54e04fe32$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $d5a7c8f7502bcf64$exports = {};
'use strict';
$d5a7c8f7502bcf64$exports.__esModule = true;
$d5a7c8f7502bcf64$exports['default'] = $d5a7c8f7502bcf64$var$isDisposable;
function $d5a7c8f7502bcf64$var$isDisposable(obj) {
    return Boolean(obj && typeof obj.dispose === 'function');
}
$d5a7c8f7502bcf64$exports = $d5a7c8f7502bcf64$exports['default'];


var $ac6a2ce54e04fe32$var$_isDisposable3 = $ac6a2ce54e04fe32$var$_interopRequireDefault($d5a7c8f7502bcf64$exports);
$ac6a2ce54e04fe32$export$e29d65b7eabdc6dd = $ac6a2ce54e04fe32$var$_isDisposable3['default'];
var $0147232e1e03ac23$exports = {};
"use strict";
$0147232e1e03ac23$exports.__esModule = true;
var $0147232e1e03ac23$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $0147232e1e03ac23$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $0147232e1e03ac23$var$noop = function noop() {};
/**
 * The basic disposable.
 */ var $0147232e1e03ac23$var$Disposable = function() {
    $0147232e1e03ac23$var$_createClass(Disposable, null, [
        {
            key: "empty",
            value: {
                dispose: $0147232e1e03ac23$var$noop
            },
            enumerable: true
        }
    ]);
    function Disposable(action) {
        $0147232e1e03ac23$var$_classCallCheck(this, Disposable);
        this.isDisposed = false;
        this.action = action || $0147232e1e03ac23$var$noop;
    }
    Disposable.prototype.dispose = function dispose() {
        if (!this.isDisposed) {
            this.action.call(null);
            this.isDisposed = true;
        }
    };
    return Disposable;
}();
$0147232e1e03ac23$exports["default"] = $0147232e1e03ac23$var$Disposable;
$0147232e1e03ac23$exports = $0147232e1e03ac23$exports["default"];


var $ac6a2ce54e04fe32$var$_Disposable3 = $ac6a2ce54e04fe32$var$_interopRequireDefault($0147232e1e03ac23$exports);
$ac6a2ce54e04fe32$export$252720412a173de = $ac6a2ce54e04fe32$var$_Disposable3['default'];
var $b470d9c0ec4ef357$exports = {};
'use strict';
$b470d9c0ec4ef357$exports.__esModule = true;
function $b470d9c0ec4ef357$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
function $b470d9c0ec4ef357$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}

var $b470d9c0ec4ef357$var$_isDisposable2 = $b470d9c0ec4ef357$var$_interopRequireDefault($d5a7c8f7502bcf64$exports);
/**
 * Represents a group of disposable resources that are disposed together.
 */ var $b470d9c0ec4ef357$var$CompositeDisposable = function() {
    function CompositeDisposable() {
        for(var _len = arguments.length, disposables = Array(_len), _key = 0; _key < _len; _key++)disposables[_key] = arguments[_key];
        $b470d9c0ec4ef357$var$_classCallCheck(this, CompositeDisposable);
        if (Array.isArray(disposables[0]) && disposables.length === 1) disposables = disposables[0];
        for(var i = 0; i < disposables.length; i++){
            if (!$b470d9c0ec4ef357$var$_isDisposable2['default'](disposables[i])) throw new Error('Expected a disposable');
        }
        this.disposables = disposables;
        this.isDisposed = false;
    }
    /**
   * Adds a disposable to the CompositeDisposable or disposes the disposable if the CompositeDisposable is disposed.
   * @param {Disposable} item Disposable to add.
   */ CompositeDisposable.prototype.add = function add(item) {
        if (this.isDisposed) item.dispose();
        else this.disposables.push(item);
    };
    /**
   * Removes and disposes the first occurrence of a disposable from the CompositeDisposable.
   * @param {Disposable} item Disposable to remove.
   * @returns {Boolean} true if found; false otherwise.
   */ CompositeDisposable.prototype.remove = function remove(item) {
        if (this.isDisposed) return false;
        var index = this.disposables.indexOf(item);
        if (index === -1) return false;
        this.disposables.splice(index, 1);
        item.dispose();
        return true;
    };
    /**
   * Disposes all disposables in the group and removes them from the group.
   */ CompositeDisposable.prototype.dispose = function dispose() {
        if (this.isDisposed) return;
        var len = this.disposables.length;
        var currentDisposables = new Array(len);
        for(var i = 0; i < len; i++)currentDisposables[i] = this.disposables[i];
        this.isDisposed = true;
        this.disposables = [];
        this.length = 0;
        for(var i = 0; i < len; i++)currentDisposables[i].dispose();
    };
    return CompositeDisposable;
}();
$b470d9c0ec4ef357$exports['default'] = $b470d9c0ec4ef357$var$CompositeDisposable;
$b470d9c0ec4ef357$exports = $b470d9c0ec4ef357$exports['default'];


var $ac6a2ce54e04fe32$var$_CompositeDisposable3 = $ac6a2ce54e04fe32$var$_interopRequireDefault($b470d9c0ec4ef357$exports);
$ac6a2ce54e04fe32$export$9ad012e5c3534b20 = $ac6a2ce54e04fe32$var$_CompositeDisposable3['default'];
var $8db84a794e4aa76b$exports = {};
'use strict';
$8db84a794e4aa76b$exports.__esModule = true;
function $8db84a794e4aa76b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
function $8db84a794e4aa76b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}

var $8db84a794e4aa76b$var$_isDisposable2 = $8db84a794e4aa76b$var$_interopRequireDefault($d5a7c8f7502bcf64$exports);
var $8db84a794e4aa76b$var$SerialDisposable = function() {
    function SerialDisposable() {
        $8db84a794e4aa76b$var$_classCallCheck(this, SerialDisposable);
        this.isDisposed = false;
        this.current = null;
    }
    /**
   * Gets the underlying disposable.
   * @return The underlying disposable.
   */ SerialDisposable.prototype.getDisposable = function getDisposable() {
        return this.current;
    };
    /**
   * Sets the underlying disposable.
   * @param {Disposable} value The new underlying disposable.
   */ SerialDisposable.prototype.setDisposable = function setDisposable() {
        var value = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];
        if (value != null && !$8db84a794e4aa76b$var$_isDisposable2['default'](value)) throw new Error('Expected either an empty value or a valid disposable');
        var isDisposed = this.isDisposed;
        var previous = undefined;
        if (!isDisposed) {
            previous = this.current;
            this.current = value;
        }
        if (previous) previous.dispose();
        if (isDisposed && value) value.dispose();
    };
    /**
   * Disposes the underlying disposable as well as all future replacements.
   */ SerialDisposable.prototype.dispose = function dispose() {
        if (this.isDisposed) return;
        this.isDisposed = true;
        var previous = this.current;
        this.current = null;
        if (previous) previous.dispose();
    };
    return SerialDisposable;
}();
$8db84a794e4aa76b$exports['default'] = $8db84a794e4aa76b$var$SerialDisposable;
$8db84a794e4aa76b$exports = $8db84a794e4aa76b$exports['default'];


var $ac6a2ce54e04fe32$var$_SerialDisposable3 = $ac6a2ce54e04fe32$var$_interopRequireDefault($8db84a794e4aa76b$exports);
$ac6a2ce54e04fe32$export$9c59780726206893 = $ac6a2ce54e04fe32$var$_SerialDisposable3['default'];



var $5a90f3023b5161ba$var$_isPlainObject2 = $5a90f3023b5161ba$var$_interopRequireDefault($fafe96f2de46333f$exports);

var $5a90f3023b5161ba$var$_invariant2 = $5a90f3023b5161ba$var$_interopRequireDefault($06dab2fcf604e778$exports);

var $5a90f3023b5161ba$var$_hoistNonReactStatics2 = $5a90f3023b5161ba$var$_interopRequireDefault($defe7d9837bba1eb$exports);

var $5a90f3023b5161ba$var$_shallowEqual2 = $5a90f3023b5161ba$var$_interopRequireDefault($82a8cc261b3db7d8$exports);

var $5a90f3023b5161ba$var$_shallowEqualScalar2 = $5a90f3023b5161ba$var$_interopRequireDefault($93ee096e6b4d8055$exports);
function $5a90f3023b5161ba$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5a90f3023b5161ba$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5a90f3023b5161ba$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $5a90f3023b5161ba$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $5a90f3023b5161ba$var$isClassComponent = function isClassComponent(Comp) {
    return Boolean(Comp && Comp.prototype && typeof Comp.prototype.render === 'function');
};
function $5a90f3023b5161ba$var$decorateHandler(_ref) {
    var _class, _temp;
    var DecoratedComponent = _ref.DecoratedComponent, createHandler = _ref.createHandler, createMonitor = _ref.createMonitor, createConnector = _ref.createConnector, registerHandler = _ref.registerHandler, containerDisplayName = _ref.containerDisplayName, getType = _ref.getType, collect = _ref.collect, options = _ref.options;
    var _options$arePropsEqua = options.arePropsEqual, arePropsEqual = _options$arePropsEqua === undefined ? $5a90f3023b5161ba$var$_shallowEqualScalar2.default : _options$arePropsEqua;
    var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
    var DragDropContainer = (_temp = _class = function(_Component) {
        $5a90f3023b5161ba$var$_inherits(DragDropContainer, _Component);
        $5a90f3023b5161ba$var$_createClass(DragDropContainer, [
            {
                key: 'getHandlerId',
                value: function getHandlerId() {
                    return this.handlerId;
                }
            },
            {
                key: 'getDecoratedComponentInstance',
                value: function getDecoratedComponentInstance() {
                    return this.decoratedComponentInstance;
                }
            },
            {
                key: 'shouldComponentUpdate',
                value: function shouldComponentUpdate(nextProps, nextState) {
                    return !arePropsEqual(nextProps, this.props) || !(0, $5a90f3023b5161ba$var$_shallowEqual2.default)(nextState, this.state);
                }
            }
        ]);
        function DragDropContainer(props, context) {
            $5a90f3023b5161ba$var$_classCallCheck(this, DragDropContainer);
            var _this = $5a90f3023b5161ba$var$_possibleConstructorReturn(this, (DragDropContainer.__proto__ || Object.getPrototypeOf(DragDropContainer)).call(this, props, context));
            _this.handleChange = _this.handleChange.bind(_this);
            _this.handleChildRef = _this.handleChildRef.bind(_this);
            (0, $5a90f3023b5161ba$var$_invariant2.default)($5a90f3023b5161ba$var$_typeof(_this.context.dragDropManager) === 'object', "Could not find the drag and drop manager in the context of %s. Make sure to wrap the top-level component of your app with DragDropContext. Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#could-not-find-the-drag-and-drop-manager-in-the-context", displayName, displayName);
            _this.manager = _this.context.dragDropManager;
            _this.handlerMonitor = createMonitor(_this.manager);
            _this.handlerConnector = createConnector(_this.manager.getBackend());
            _this.handler = createHandler(_this.handlerMonitor);
            _this.disposable = new $ac6a2ce54e04fe32$export$9c59780726206893();
            _this.receiveProps(props);
            _this.state = _this.getCurrentState();
            _this.dispose();
            return _this;
        }
        $5a90f3023b5161ba$var$_createClass(DragDropContainer, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    this.isCurrentlyMounted = true;
                    this.disposable = new $ac6a2ce54e04fe32$export$9c59780726206893();
                    this.currentType = null;
                    this.receiveProps(this.props);
                    this.handleChange();
                }
            },
            {
                key: 'componentWillReceiveProps',
                value: function componentWillReceiveProps(nextProps) {
                    if (!arePropsEqual(nextProps, this.props)) {
                        this.receiveProps(nextProps);
                        this.handleChange();
                    }
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    this.dispose();
                    this.isCurrentlyMounted = false;
                }
            },
            {
                key: 'receiveProps',
                value: function receiveProps(props) {
                    this.handler.receiveProps(props);
                    this.receiveType(getType(props));
                }
            },
            {
                key: 'receiveType',
                value: function receiveType(type) {
                    if (type === this.currentType) return;
                    this.currentType = type;
                    var _registerHandler = registerHandler(type, this.handler, this.manager), handlerId = _registerHandler.handlerId, unregister = _registerHandler.unregister;
                    this.handlerId = handlerId;
                    this.handlerMonitor.receiveHandlerId(handlerId);
                    this.handlerConnector.receiveHandlerId(handlerId);
                    var globalMonitor = this.manager.getMonitor();
                    var unsubscribe = globalMonitor.subscribeToStateChange(this.handleChange, {
                        handlerIds: [
                            handlerId
                        ]
                    });
                    this.disposable.setDisposable(new $ac6a2ce54e04fe32$export$9ad012e5c3534b20(new $ac6a2ce54e04fe32$export$252720412a173de(unsubscribe), new $ac6a2ce54e04fe32$export$252720412a173de(unregister)));
                }
            },
            {
                key: 'handleChange',
                value: function handleChange() {
                    if (!this.isCurrentlyMounted) return;
                    var nextState = this.getCurrentState();
                    if (!(0, $5a90f3023b5161ba$var$_shallowEqual2.default)(nextState, this.state)) this.setState(nextState);
                }
            },
            {
                key: 'dispose',
                value: function dispose() {
                    this.disposable.dispose();
                    this.handlerConnector.receiveHandlerId(null);
                }
            },
            {
                key: 'handleChildRef',
                value: function handleChildRef(component) {
                    this.decoratedComponentInstance = component;
                    this.handler.receiveComponent(component);
                }
            },
            {
                key: 'getCurrentState',
                value: function getCurrentState() {
                    var nextState = collect(this.handlerConnector.hooks, this.handlerMonitor);
                    return nextState;
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $5a90f3023b5161ba$var$_react2.default.createElement(DecoratedComponent, $5a90f3023b5161ba$var$_extends({}, this.props, this.state, {
                        ref: $5a90f3023b5161ba$var$isClassComponent(DecoratedComponent) ? this.handleChildRef : null
                    }));
                }
            }
        ]);
        return DragDropContainer;
    }($NdCUR.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = containerDisplayName + '(' + displayName + ')', _class.contextTypes = {
        dragDropManager: $5a90f3023b5161ba$var$_propTypes2.default.object.isRequired
    }, _temp);
    return (0, $5a90f3023b5161ba$var$_hoistNonReactStatics2.default)(DragDropContainer, DecoratedComponent);
}


var $84d7f1239bfb9a58$var$_decorateHandler2 = $84d7f1239bfb9a58$var$_interopRequireDefault($5a90f3023b5161ba$exports);
var $2e2fc16a1e4b819d$exports = {};
"use strict";
Object.defineProperty($2e2fc16a1e4b819d$exports, "__esModule", {
    value: true
});
$2e2fc16a1e4b819d$exports.default = $2e2fc16a1e4b819d$var$registerSource;
function $2e2fc16a1e4b819d$var$registerSource(type, source, manager) {
    var registry = manager.getRegistry();
    var sourceId = registry.addSource(type, source);
    function unregisterSource() {
        registry.removeSource(sourceId);
    }
    return {
        handlerId: sourceId,
        unregister: unregisterSource
    };
}


var $84d7f1239bfb9a58$var$_registerSource2 = $84d7f1239bfb9a58$var$_interopRequireDefault($2e2fc16a1e4b819d$exports);
var $9596ec5576153249$exports = {};
'use strict';
Object.defineProperty($9596ec5576153249$exports, "__esModule", {
    value: true
});
var $9596ec5576153249$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
$9596ec5576153249$exports.default = $9596ec5576153249$var$createSourceFactory;

var $9596ec5576153249$var$_invariant2 = $9596ec5576153249$var$_interopRequireDefault($06dab2fcf604e778$exports);

var $9596ec5576153249$var$_isPlainObject2 = $9596ec5576153249$var$_interopRequireDefault($fafe96f2de46333f$exports);
function $9596ec5576153249$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9596ec5576153249$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $9596ec5576153249$var$ALLOWED_SPEC_METHODS = [
    'canDrag',
    'beginDrag',
    'isDragging',
    'endDrag'
];
var $9596ec5576153249$var$REQUIRED_SPEC_METHODS = [
    'beginDrag'
];
function $9596ec5576153249$var$createSourceFactory(spec) {
    Object.keys(spec).forEach(function(key) {
        (0, $9596ec5576153249$var$_invariant2.default)($9596ec5576153249$var$ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drag source specification to only have some of the following keys: %s. Instead received a specification with an unexpected "%s" key. Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', $9596ec5576153249$var$ALLOWED_SPEC_METHODS.join(', '), key);
        (0, $9596ec5576153249$var$_invariant2.default)(typeof spec[key] === 'function', "Expected %s in the drag source specification to be a function. Instead received a specification with %s: %s. Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html", key, key, spec[key]);
    });
    $9596ec5576153249$var$REQUIRED_SPEC_METHODS.forEach(function(key) {
        (0, $9596ec5576153249$var$_invariant2.default)(typeof spec[key] === 'function', "Expected %s in the drag source specification to be a function. Instead received a specification with %s: %s. Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html", key, key, spec[key]);
    });
    var Source = function() {
        function Source(monitor) {
            $9596ec5576153249$var$_classCallCheck(this, Source);
            this.monitor = monitor;
            this.props = null;
            this.component = null;
        }
        $9596ec5576153249$var$_createClass(Source, [
            {
                key: 'receiveProps',
                value: function receiveProps(props) {
                    this.props = props;
                }
            },
            {
                key: 'receiveComponent',
                value: function receiveComponent(component) {
                    this.component = component;
                }
            },
            {
                key: 'canDrag',
                value: function canDrag() {
                    if (!spec.canDrag) return true;
                    return spec.canDrag(this.props, this.monitor);
                }
            },
            {
                key: 'isDragging',
                value: function isDragging(globalMonitor, sourceId) {
                    if (!spec.isDragging) return sourceId === globalMonitor.getSourceId();
                    return spec.isDragging(this.props, this.monitor);
                }
            },
            {
                key: 'beginDrag',
                value: function beginDrag() {
                    var item = spec.beginDrag(this.props, this.monitor, this.component);
                    return item;
                }
            },
            {
                key: 'endDrag',
                value: function endDrag() {
                    if (!spec.endDrag) return;
                    spec.endDrag(this.props, this.monitor, this.component);
                }
            }
        ]);
        return Source;
    }();
    return function createSource(monitor) {
        return new Source(monitor);
    };
}


var $84d7f1239bfb9a58$var$_createSourceFactory2 = $84d7f1239bfb9a58$var$_interopRequireDefault($9596ec5576153249$exports);
var $25a06caa0cf8a9f9$exports = {};
'use strict';
Object.defineProperty($25a06caa0cf8a9f9$exports, "__esModule", {
    value: true
});
var $25a06caa0cf8a9f9$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
$25a06caa0cf8a9f9$exports.default = $25a06caa0cf8a9f9$var$createSourceMonitor;

var $25a06caa0cf8a9f9$var$_invariant2 = $25a06caa0cf8a9f9$var$_interopRequireDefault($06dab2fcf604e778$exports);
function $25a06caa0cf8a9f9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $25a06caa0cf8a9f9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $25a06caa0cf8a9f9$var$isCallingCanDrag = false;
var $25a06caa0cf8a9f9$var$isCallingIsDragging = false;
var $25a06caa0cf8a9f9$var$SourceMonitor = function() {
    function SourceMonitor(manager) {
        $25a06caa0cf8a9f9$var$_classCallCheck(this, SourceMonitor);
        this.internalMonitor = manager.getMonitor();
    }
    $25a06caa0cf8a9f9$var$_createClass(SourceMonitor, [
        {
            key: 'receiveHandlerId',
            value: function receiveHandlerId(sourceId) {
                this.sourceId = sourceId;
            }
        },
        {
            key: 'canDrag',
            value: function canDrag() {
                (0, $25a06caa0cf8a9f9$var$_invariant2.default)(!$25a06caa0cf8a9f9$var$isCallingCanDrag, "You may not call monitor.canDrag() inside your canDrag() implementation. Read more: http://react-dnd.github.io/react-dnd/docs-drag-source-monitor.html");
                try {
                    $25a06caa0cf8a9f9$var$isCallingCanDrag = true;
                    return this.internalMonitor.canDragSource(this.sourceId);
                } finally{
                    $25a06caa0cf8a9f9$var$isCallingCanDrag = false;
                }
            }
        },
        {
            key: 'isDragging',
            value: function isDragging() {
                (0, $25a06caa0cf8a9f9$var$_invariant2.default)(!$25a06caa0cf8a9f9$var$isCallingIsDragging, "You may not call monitor.isDragging() inside your isDragging() implementation. Read more: http://react-dnd.github.io/react-dnd/docs-drag-source-monitor.html");
                try {
                    $25a06caa0cf8a9f9$var$isCallingIsDragging = true;
                    return this.internalMonitor.isDraggingSource(this.sourceId);
                } finally{
                    $25a06caa0cf8a9f9$var$isCallingIsDragging = false;
                }
            }
        },
        {
            key: 'getItemType',
            value: function getItemType() {
                return this.internalMonitor.getItemType();
            }
        },
        {
            key: 'getItem',
            value: function getItem() {
                return this.internalMonitor.getItem();
            }
        },
        {
            key: 'getDropResult',
            value: function getDropResult() {
                return this.internalMonitor.getDropResult();
            }
        },
        {
            key: 'didDrop',
            value: function didDrop() {
                return this.internalMonitor.didDrop();
            }
        },
        {
            key: 'getInitialClientOffset',
            value: function getInitialClientOffset() {
                return this.internalMonitor.getInitialClientOffset();
            }
        },
        {
            key: 'getInitialSourceClientOffset',
            value: function getInitialSourceClientOffset() {
                return this.internalMonitor.getInitialSourceClientOffset();
            }
        },
        {
            key: 'getSourceClientOffset',
            value: function getSourceClientOffset() {
                return this.internalMonitor.getSourceClientOffset();
            }
        },
        {
            key: 'getClientOffset',
            value: function getClientOffset() {
                return this.internalMonitor.getClientOffset();
            }
        },
        {
            key: 'getDifferenceFromInitialOffset',
            value: function getDifferenceFromInitialOffset() {
                return this.internalMonitor.getDifferenceFromInitialOffset();
            }
        }
    ]);
    return SourceMonitor;
}();
function $25a06caa0cf8a9f9$var$createSourceMonitor(manager) {
    return new $25a06caa0cf8a9f9$var$SourceMonitor(manager);
}


var $84d7f1239bfb9a58$var$_createSourceMonitor2 = $84d7f1239bfb9a58$var$_interopRequireDefault($25a06caa0cf8a9f9$exports);
var $aeebe73c4b4b5ec9$exports = {};
'use strict';
Object.defineProperty($aeebe73c4b4b5ec9$exports, "__esModule", {
    value: true
});
$aeebe73c4b4b5ec9$exports.default = $aeebe73c4b4b5ec9$var$createSourceConnector;
var $92457c089624634d$exports = {};
'use strict';
Object.defineProperty($92457c089624634d$exports, "__esModule", {
    value: true
});
$92457c089624634d$exports.default = $92457c089624634d$var$wrapConnectorHooks;

var $NdCUR = parcelRequire("NdCUR");
var $215add6d108aa109$exports = {};
'use strict';
Object.defineProperty($215add6d108aa109$exports, "__esModule", {
    value: true
});
$215add6d108aa109$exports.default = $215add6d108aa109$var$cloneWithRef;

var $215add6d108aa109$var$_invariant2 = $215add6d108aa109$var$_interopRequireDefault($06dab2fcf604e778$exports);

var $NdCUR = parcelRequire("NdCUR");
function $215add6d108aa109$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $215add6d108aa109$var$cloneWithRef(element, newRef) {
    var previousRef = element.ref;
    (0, $215add6d108aa109$var$_invariant2.default)(typeof previousRef !== 'string', "Cannot connect React DnD to an element with an existing string ref. Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. Read more: https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute");
    if (!previousRef) // When there is no ref on the element, use the new ref directly
    return (0, $NdCUR.cloneElement)(element, {
        ref: newRef
    });
    return (0, $NdCUR.cloneElement)(element, {
        ref: function ref(node) {
            newRef(node);
            if (previousRef) previousRef(node);
        }
    });
}


var $92457c089624634d$var$_cloneWithRef2 = $92457c089624634d$var$_interopRequireDefault($215add6d108aa109$exports);
function $92457c089624634d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $92457c089624634d$var$throwIfCompositeComponentElement(element) {
    // Custom components can no longer be wrapped directly in React DnD 2.0
    // so that we don't need to depend on findDOMNode() from react-dom.
    if (typeof element.type === 'string') return;
    var displayName = element.type.displayName || element.type.name || 'the component';
    throw new Error('Only native element nodes can now be passed to React DnD connectors.' + ('You can either wrap ' + displayName + ' into a <div>, or turn it into a ') + 'drag source or a drop target itself.');
}
function $92457c089624634d$var$wrapHookToRecognizeElement(hook) {
    return function() {
        var elementOrNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        // When passed a node, call the hook straight away.
        if (!(0, $NdCUR.isValidElement)(elementOrNode)) {
            var node = elementOrNode;
            hook(node, options);
            return undefined;
        }
        // If passed a ReactElement, clone it and attach this function as a ref.
        // This helps us achieve a neat API where user doesn't even know that refs
        // are being used under the hood.
        var element = elementOrNode;
        $92457c089624634d$var$throwIfCompositeComponentElement(element);
        // When no options are passed, use the hook directly
        var ref = options ? function(node) {
            return hook(node, options);
        } : hook;
        return (0, $92457c089624634d$var$_cloneWithRef2.default)(element, ref);
    };
}
function $92457c089624634d$var$wrapConnectorHooks(hooks) {
    var wrappedHooks = {};
    Object.keys(hooks).forEach(function(key) {
        var hook = hooks[key];
        var wrappedHook = $92457c089624634d$var$wrapHookToRecognizeElement(hook);
        wrappedHooks[key] = function() {
            return wrappedHook;
        };
    });
    return wrappedHooks;
}


var $aeebe73c4b4b5ec9$var$_wrapConnectorHooks2 = $aeebe73c4b4b5ec9$var$_interopRequireDefault($92457c089624634d$exports);
var $fd719b8c34aa0d07$exports = {};
'use strict';
Object.defineProperty($fd719b8c34aa0d07$exports, "__esModule", {
    value: true
});
$fd719b8c34aa0d07$exports.default = $fd719b8c34aa0d07$var$areOptionsEqual;

var $fd719b8c34aa0d07$var$_shallowEqual2 = $fd719b8c34aa0d07$var$_interopRequireDefault($82a8cc261b3db7d8$exports);
function $fd719b8c34aa0d07$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $fd719b8c34aa0d07$var$areOptionsEqual(nextOptions, currentOptions) {
    if (currentOptions === nextOptions) return true;
    return currentOptions !== null && nextOptions !== null && (0, $fd719b8c34aa0d07$var$_shallowEqual2.default)(currentOptions, nextOptions);
}


var $aeebe73c4b4b5ec9$var$_areOptionsEqual2 = $aeebe73c4b4b5ec9$var$_interopRequireDefault($fd719b8c34aa0d07$exports);
function $aeebe73c4b4b5ec9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $aeebe73c4b4b5ec9$var$createSourceConnector(backend) {
    var currentHandlerId = void 0;
    var currentDragSourceNode = void 0;
    var currentDragSourceOptions = void 0;
    var disconnectCurrentDragSource = void 0;
    var currentDragPreviewNode = void 0;
    var currentDragPreviewOptions = void 0;
    var disconnectCurrentDragPreview = void 0;
    function reconnectDragSource() {
        if (disconnectCurrentDragSource) {
            disconnectCurrentDragSource();
            disconnectCurrentDragSource = null;
        }
        if (currentHandlerId && currentDragSourceNode) disconnectCurrentDragSource = backend.connectDragSource(currentHandlerId, currentDragSourceNode, currentDragSourceOptions);
    }
    function reconnectDragPreview() {
        if (disconnectCurrentDragPreview) {
            disconnectCurrentDragPreview();
            disconnectCurrentDragPreview = null;
        }
        if (currentHandlerId && currentDragPreviewNode) disconnectCurrentDragPreview = backend.connectDragPreview(currentHandlerId, currentDragPreviewNode, currentDragPreviewOptions);
    }
    function receiveHandlerId(handlerId) {
        if (handlerId === currentHandlerId) return;
        currentHandlerId = handlerId;
        reconnectDragSource();
        reconnectDragPreview();
    }
    var hooks = (0, $aeebe73c4b4b5ec9$var$_wrapConnectorHooks2.default)({
        dragSource: function connectDragSource(node, options) {
            if (node === currentDragSourceNode && (0, $aeebe73c4b4b5ec9$var$_areOptionsEqual2.default)(options, currentDragSourceOptions)) return;
            currentDragSourceNode = node;
            currentDragSourceOptions = options;
            reconnectDragSource();
        },
        dragPreview: function connectDragPreview(node, options) {
            if (node === currentDragPreviewNode && (0, $aeebe73c4b4b5ec9$var$_areOptionsEqual2.default)(options, currentDragPreviewOptions)) return;
            currentDragPreviewNode = node;
            currentDragPreviewOptions = options;
            reconnectDragPreview();
        }
    });
    return {
        receiveHandlerId: receiveHandlerId,
        hooks: hooks
    };
}


var $84d7f1239bfb9a58$var$_createSourceConnector2 = $84d7f1239bfb9a58$var$_interopRequireDefault($aeebe73c4b4b5ec9$exports);
var $d0c27c3da4ff041d$exports = {};
'use strict';
Object.defineProperty($d0c27c3da4ff041d$exports, "__esModule", {
    value: true
});
var $d0c27c3da4ff041d$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
$d0c27c3da4ff041d$exports.default = $d0c27c3da4ff041d$var$isValidType;

var $d0c27c3da4ff041d$var$_isArray2 = $d0c27c3da4ff041d$var$_interopRequireDefault($62cdb8c6d4925eaf$exports);
function $d0c27c3da4ff041d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d0c27c3da4ff041d$var$isValidType(type, allowArray) {
    return typeof type === 'string' || (typeof type === 'undefined' ? 'undefined' : $d0c27c3da4ff041d$var$_typeof(type)) === 'symbol' || allowArray && (0, $d0c27c3da4ff041d$var$_isArray2.default)(type) && type.every(function(t) {
        return $d0c27c3da4ff041d$var$isValidType(t, false);
    });
}


var $84d7f1239bfb9a58$var$_isValidType2 = $84d7f1239bfb9a58$var$_interopRequireDefault($d0c27c3da4ff041d$exports);
function $84d7f1239bfb9a58$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $84d7f1239bfb9a58$var$DragSource(type, spec, collect) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    $84d7f1239bfb9a58$var$_checkDecoratorArguments2.default.apply(undefined, [
        'DragSource',
        'type, spec, collect[, options]'
    ].concat(Array.prototype.slice.call(arguments)));
    var getType = type;
    if (typeof type !== 'function') {
        (0, $84d7f1239bfb9a58$var$_invariant2.default)((0, $84d7f1239bfb9a58$var$_isValidType2.default)(type), 'Expected "type" provided as the first argument to DragSource to be a string, or a function that returns a string given the current props. Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', type);
        getType = function getType() {
            return type;
        };
    }
    (0, $84d7f1239bfb9a58$var$_invariant2.default)((0, $84d7f1239bfb9a58$var$_isPlainObject2.default)(spec), 'Expected "spec" provided as the second argument to DragSource to be a plain object. Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', spec);
    var createSource = (0, $84d7f1239bfb9a58$var$_createSourceFactory2.default)(spec);
    (0, $84d7f1239bfb9a58$var$_invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the third argument to DragSource to be a function that returns a plain object of props to inject. Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', collect);
    (0, $84d7f1239bfb9a58$var$_invariant2.default)((0, $84d7f1239bfb9a58$var$_isPlainObject2.default)(options), 'Expected "options" provided as the fourth argument to DragSource to be a plain object when specified. Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', collect);
    return function decorateSource(DecoratedComponent) {
        return (0, $84d7f1239bfb9a58$var$_decorateHandler2.default)({
            connectBackend: function connectBackend(backend, sourceId) {
                return backend.connectDragSource(sourceId);
            },
            containerDisplayName: 'DragSource',
            createHandler: createSource,
            registerHandler: $84d7f1239bfb9a58$var$_registerSource2.default,
            createMonitor: $84d7f1239bfb9a58$var$_createSourceMonitor2.default,
            createConnector: $84d7f1239bfb9a58$var$_createSourceConnector2.default,
            DecoratedComponent: DecoratedComponent,
            getType: getType,
            collect: collect,
            options: options
        });
    };
}


Object.defineProperty($db9eac57989e0572$exports, 'DragSource', {
    enumerable: true,
    get: function get() {
        return $db9eac57989e0572$var$_interopRequireDefault($84d7f1239bfb9a58$exports).default;
    }
});
var $01c47dfb0dcc31d8$exports = {};
'use strict';
Object.defineProperty($01c47dfb0dcc31d8$exports, "__esModule", {
    value: true
});
$01c47dfb0dcc31d8$exports.default = $01c47dfb0dcc31d8$var$DropTarget;

var $01c47dfb0dcc31d8$var$_invariant2 = $01c47dfb0dcc31d8$var$_interopRequireDefault($06dab2fcf604e778$exports);

var $01c47dfb0dcc31d8$var$_isPlainObject2 = $01c47dfb0dcc31d8$var$_interopRequireDefault($fafe96f2de46333f$exports);

var $01c47dfb0dcc31d8$var$_checkDecoratorArguments2 = $01c47dfb0dcc31d8$var$_interopRequireDefault($05c912093a27ac54$exports);

var $01c47dfb0dcc31d8$var$_decorateHandler2 = $01c47dfb0dcc31d8$var$_interopRequireDefault($5a90f3023b5161ba$exports);
var $c305cc903827979e$exports = {};
"use strict";
Object.defineProperty($c305cc903827979e$exports, "__esModule", {
    value: true
});
$c305cc903827979e$exports.default = $c305cc903827979e$var$registerTarget;
function $c305cc903827979e$var$registerTarget(type, target, manager) {
    var registry = manager.getRegistry();
    var targetId = registry.addTarget(type, target);
    function unregisterTarget() {
        registry.removeTarget(targetId);
    }
    return {
        handlerId: targetId,
        unregister: unregisterTarget
    };
}


var $01c47dfb0dcc31d8$var$_registerTarget2 = $01c47dfb0dcc31d8$var$_interopRequireDefault($c305cc903827979e$exports);
var $f01874cce87df059$exports = {};
'use strict';
Object.defineProperty($f01874cce87df059$exports, "__esModule", {
    value: true
});
var $f01874cce87df059$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
$f01874cce87df059$exports.default = $f01874cce87df059$var$createTargetFactory;

var $f01874cce87df059$var$_invariant2 = $f01874cce87df059$var$_interopRequireDefault($06dab2fcf604e778$exports);

var $f01874cce87df059$var$_isPlainObject2 = $f01874cce87df059$var$_interopRequireDefault($fafe96f2de46333f$exports);
function $f01874cce87df059$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f01874cce87df059$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $f01874cce87df059$var$ALLOWED_SPEC_METHODS = [
    'canDrop',
    'hover',
    'drop'
];
function $f01874cce87df059$var$createTargetFactory(spec) {
    Object.keys(spec).forEach(function(key) {
        (0, $f01874cce87df059$var$_invariant2.default)($f01874cce87df059$var$ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drop target specification to only have some of the following keys: %s. Instead received a specification with an unexpected "%s" key. Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', $f01874cce87df059$var$ALLOWED_SPEC_METHODS.join(', '), key);
        (0, $f01874cce87df059$var$_invariant2.default)(typeof spec[key] === 'function', "Expected %s in the drop target specification to be a function. Instead received a specification with %s: %s. Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html", key, key, spec[key]);
    });
    var Target = function() {
        function Target(monitor) {
            $f01874cce87df059$var$_classCallCheck(this, Target);
            this.monitor = monitor;
            this.props = null;
            this.component = null;
        }
        $f01874cce87df059$var$_createClass(Target, [
            {
                key: 'receiveProps',
                value: function receiveProps(props) {
                    this.props = props;
                }
            },
            {
                key: 'receiveMonitor',
                value: function receiveMonitor(monitor) {
                    this.monitor = monitor;
                }
            },
            {
                key: 'receiveComponent',
                value: function receiveComponent(component) {
                    this.component = component;
                }
            },
            {
                key: 'canDrop',
                value: function canDrop() {
                    if (!spec.canDrop) return true;
                    return spec.canDrop(this.props, this.monitor);
                }
            },
            {
                key: 'hover',
                value: function hover() {
                    if (!spec.hover) return;
                    spec.hover(this.props, this.monitor, this.component);
                }
            },
            {
                key: 'drop',
                value: function drop() {
                    if (!spec.drop) return undefined;
                    var dropResult = spec.drop(this.props, this.monitor, this.component);
                    return dropResult;
                }
            }
        ]);
        return Target;
    }();
    return function createTarget(monitor) {
        return new Target(monitor);
    };
}


var $01c47dfb0dcc31d8$var$_createTargetFactory2 = $01c47dfb0dcc31d8$var$_interopRequireDefault($f01874cce87df059$exports);
var $449600cb70a50ebf$exports = {};
'use strict';
Object.defineProperty($449600cb70a50ebf$exports, "__esModule", {
    value: true
});
var $449600cb70a50ebf$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
$449600cb70a50ebf$exports.default = $449600cb70a50ebf$var$createTargetMonitor;

var $449600cb70a50ebf$var$_invariant2 = $449600cb70a50ebf$var$_interopRequireDefault($06dab2fcf604e778$exports);
function $449600cb70a50ebf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $449600cb70a50ebf$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $449600cb70a50ebf$var$isCallingCanDrop = false;
var $449600cb70a50ebf$var$TargetMonitor = function() {
    function TargetMonitor(manager) {
        $449600cb70a50ebf$var$_classCallCheck(this, TargetMonitor);
        this.internalMonitor = manager.getMonitor();
    }
    $449600cb70a50ebf$var$_createClass(TargetMonitor, [
        {
            key: 'receiveHandlerId',
            value: function receiveHandlerId(targetId) {
                this.targetId = targetId;
            }
        },
        {
            key: 'canDrop',
            value: function canDrop() {
                (0, $449600cb70a50ebf$var$_invariant2.default)(!$449600cb70a50ebf$var$isCallingCanDrop, "You may not call monitor.canDrop() inside your canDrop() implementation. Read more: http://react-dnd.github.io/react-dnd/docs-drop-target-monitor.html");
                try {
                    $449600cb70a50ebf$var$isCallingCanDrop = true;
                    return this.internalMonitor.canDropOnTarget(this.targetId);
                } finally{
                    $449600cb70a50ebf$var$isCallingCanDrop = false;
                }
            }
        },
        {
            key: 'isOver',
            value: function isOver(options) {
                return this.internalMonitor.isOverTarget(this.targetId, options);
            }
        },
        {
            key: 'getItemType',
            value: function getItemType() {
                return this.internalMonitor.getItemType();
            }
        },
        {
            key: 'getItem',
            value: function getItem() {
                return this.internalMonitor.getItem();
            }
        },
        {
            key: 'getDropResult',
            value: function getDropResult() {
                return this.internalMonitor.getDropResult();
            }
        },
        {
            key: 'didDrop',
            value: function didDrop() {
                return this.internalMonitor.didDrop();
            }
        },
        {
            key: 'getInitialClientOffset',
            value: function getInitialClientOffset() {
                return this.internalMonitor.getInitialClientOffset();
            }
        },
        {
            key: 'getInitialSourceClientOffset',
            value: function getInitialSourceClientOffset() {
                return this.internalMonitor.getInitialSourceClientOffset();
            }
        },
        {
            key: 'getSourceClientOffset',
            value: function getSourceClientOffset() {
                return this.internalMonitor.getSourceClientOffset();
            }
        },
        {
            key: 'getClientOffset',
            value: function getClientOffset() {
                return this.internalMonitor.getClientOffset();
            }
        },
        {
            key: 'getDifferenceFromInitialOffset',
            value: function getDifferenceFromInitialOffset() {
                return this.internalMonitor.getDifferenceFromInitialOffset();
            }
        }
    ]);
    return TargetMonitor;
}();
function $449600cb70a50ebf$var$createTargetMonitor(manager) {
    return new $449600cb70a50ebf$var$TargetMonitor(manager);
}


var $01c47dfb0dcc31d8$var$_createTargetMonitor2 = $01c47dfb0dcc31d8$var$_interopRequireDefault($449600cb70a50ebf$exports);
var $9fa9f04856dbfd0e$exports = {};
'use strict';
Object.defineProperty($9fa9f04856dbfd0e$exports, "__esModule", {
    value: true
});
$9fa9f04856dbfd0e$exports.default = $9fa9f04856dbfd0e$var$createTargetConnector;

var $9fa9f04856dbfd0e$var$_wrapConnectorHooks2 = $9fa9f04856dbfd0e$var$_interopRequireDefault($92457c089624634d$exports);

var $9fa9f04856dbfd0e$var$_areOptionsEqual2 = $9fa9f04856dbfd0e$var$_interopRequireDefault($fd719b8c34aa0d07$exports);
function $9fa9f04856dbfd0e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9fa9f04856dbfd0e$var$createTargetConnector(backend) {
    var currentHandlerId = void 0;
    var currentDropTargetNode = void 0;
    var currentDropTargetOptions = void 0;
    var disconnectCurrentDropTarget = void 0;
    function reconnectDropTarget() {
        if (disconnectCurrentDropTarget) {
            disconnectCurrentDropTarget();
            disconnectCurrentDropTarget = null;
        }
        if (currentHandlerId && currentDropTargetNode) disconnectCurrentDropTarget = backend.connectDropTarget(currentHandlerId, currentDropTargetNode, currentDropTargetOptions);
    }
    function receiveHandlerId(handlerId) {
        if (handlerId === currentHandlerId) return;
        currentHandlerId = handlerId;
        reconnectDropTarget();
    }
    var hooks = (0, $9fa9f04856dbfd0e$var$_wrapConnectorHooks2.default)({
        dropTarget: function connectDropTarget(node, options) {
            if (node === currentDropTargetNode && (0, $9fa9f04856dbfd0e$var$_areOptionsEqual2.default)(options, currentDropTargetOptions)) return;
            currentDropTargetNode = node;
            currentDropTargetOptions = options;
            reconnectDropTarget();
        }
    });
    return {
        receiveHandlerId: receiveHandlerId,
        hooks: hooks
    };
}


var $01c47dfb0dcc31d8$var$_createTargetConnector2 = $01c47dfb0dcc31d8$var$_interopRequireDefault($9fa9f04856dbfd0e$exports);

var $01c47dfb0dcc31d8$var$_isValidType2 = $01c47dfb0dcc31d8$var$_interopRequireDefault($d0c27c3da4ff041d$exports);
function $01c47dfb0dcc31d8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $01c47dfb0dcc31d8$var$DropTarget(type, spec, collect) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    $01c47dfb0dcc31d8$var$_checkDecoratorArguments2.default.apply(undefined, [
        'DropTarget',
        'type, spec, collect[, options]'
    ].concat(Array.prototype.slice.call(arguments)));
    var getType = type;
    if (typeof type !== 'function') {
        (0, $01c47dfb0dcc31d8$var$_invariant2.default)((0, $01c47dfb0dcc31d8$var$_isValidType2.default)(type, true), 'Expected "type" provided as the first argument to DropTarget to be a string, an array of strings, or a function that returns either given the current props. Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', type);
        getType = function getType() {
            return type;
        };
    }
    (0, $01c47dfb0dcc31d8$var$_invariant2.default)((0, $01c47dfb0dcc31d8$var$_isPlainObject2.default)(spec), 'Expected "spec" provided as the second argument to DropTarget to be a plain object. Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', spec);
    var createTarget = (0, $01c47dfb0dcc31d8$var$_createTargetFactory2.default)(spec);
    (0, $01c47dfb0dcc31d8$var$_invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the third argument to DropTarget to be a function that returns a plain object of props to inject. Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', collect);
    (0, $01c47dfb0dcc31d8$var$_invariant2.default)((0, $01c47dfb0dcc31d8$var$_isPlainObject2.default)(options), 'Expected "options" provided as the fourth argument to DropTarget to be a plain object when specified. Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', collect);
    return function decorateTarget(DecoratedComponent) {
        return (0, $01c47dfb0dcc31d8$var$_decorateHandler2.default)({
            connectBackend: function connectBackend(backend, targetId) {
                return backend.connectDropTarget(targetId);
            },
            containerDisplayName: 'DropTarget',
            createHandler: createTarget,
            registerHandler: $01c47dfb0dcc31d8$var$_registerTarget2.default,
            createMonitor: $01c47dfb0dcc31d8$var$_createTargetMonitor2.default,
            createConnector: $01c47dfb0dcc31d8$var$_createTargetConnector2.default,
            DecoratedComponent: DecoratedComponent,
            getType: getType,
            collect: collect,
            options: options
        });
    };
}


Object.defineProperty($db9eac57989e0572$exports, 'DropTarget', {
    enumerable: true,
    get: function get() {
        return $db9eac57989e0572$var$_interopRequireDefault($01c47dfb0dcc31d8$exports).default;
    }
});
function $db9eac57989e0572$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}


var $3d979c1ec0f4ae95$exports = {};
'use strict';
Object.defineProperty($3d979c1ec0f4ae95$exports, "__esModule", {
    value: true
});
$3d979c1ec0f4ae95$exports.getEmptyImage = $3d979c1ec0f4ae95$exports.NativeTypes = undefined;
$3d979c1ec0f4ae95$exports.default = $3d979c1ec0f4ae95$var$createHTML5Backend;
var $c7e8d5b5e632486b$exports = {};
'use strict';
Object.defineProperty($c7e8d5b5e632486b$exports, "__esModule", {
    value: true
});
var $c7e8d5b5e632486b$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}(); /* eslint-disable no-underscore-dangle */ 
var $5923b878cda4d313$exports = {};


var $cb2fddfb04ae1826$exports = {};




/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $cb2fddfb04ae1826$var$isIterateeCall(value, index, object) {
    if (!$cf434abf2d8b4420$exports(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $bb8c0e46a53b48d1$exports(object) && $ed54d9446c437622$exports(index, object.length) : type == 'string' && index in object) return $7bddb65de45933c2$exports(object[index], value);
    return false;
}
$cb2fddfb04ae1826$exports = $cb2fddfb04ae1826$var$isIterateeCall;


var $8d94a150bc26d666$exports = {};

var $8d21a8c88cecb49a$exports = {};


var $8a270c533612aaa9$exports = {};
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $8a270c533612aaa9$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
$8a270c533612aaa9$exports = $8a270c533612aaa9$var$nativeKeysIn;


/** Used for built-in method references. */ var $8d21a8c88cecb49a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8d21a8c88cecb49a$var$hasOwnProperty = $8d21a8c88cecb49a$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $8d21a8c88cecb49a$var$baseKeysIn(object) {
    if (!$cf434abf2d8b4420$exports(object)) return $8a270c533612aaa9$exports(object);
    var isProto = $623465aebfb0a612$exports(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$8d21a8c88cecb49a$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
$8d21a8c88cecb49a$exports = $8d21a8c88cecb49a$var$baseKeysIn;



/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $8d94a150bc26d666$var$keysIn(object) {
    return $bb8c0e46a53b48d1$exports(object) ? $fff2bd8ecbb2b6d2$exports(object, true) : $8d21a8c88cecb49a$exports(object);
}
$8d94a150bc26d666$exports = $8d94a150bc26d666$var$keysIn;


/** Used for built-in method references. */ var $5923b878cda4d313$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $5923b878cda4d313$var$hasOwnProperty = $5923b878cda4d313$var$objectProto.hasOwnProperty;
/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */ var $5923b878cda4d313$var$defaults = $ff83c7c0ae177e74$exports(function(object, sources) {
    object = Object(object);
    var index = -1;
    var length = sources.length;
    var guard = length > 2 ? sources[2] : undefined;
    if (guard && $cb2fddfb04ae1826$exports(sources[0], sources[1], guard)) length = 1;
    while(++index < length){
        var source = sources[index];
        var props = $8d94a150bc26d666$exports(source);
        var propsIndex = -1;
        var propsLength = props.length;
        while(++propsIndex < propsLength){
            var key = props[propsIndex];
            var value = object[key];
            if (value === undefined || $7bddb65de45933c2$exports(value, $5923b878cda4d313$var$objectProto[key]) && !$5923b878cda4d313$var$hasOwnProperty.call(object, key)) object[key] = source[key];
        }
    }
    return object;
});
$5923b878cda4d313$exports = $5923b878cda4d313$var$defaults;


var $c7e8d5b5e632486b$var$_defaults2 = $c7e8d5b5e632486b$var$_interopRequireDefault($5923b878cda4d313$exports);
var $fc289dc171730bea$exports = {};
"use strict";
Object.defineProperty($fc289dc171730bea$exports, "__esModule", {
    value: true
});
$fc289dc171730bea$exports.default = $fc289dc171730bea$var$shallowEqual;
function $fc289dc171730bea$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    var hasOwn = Object.prototype.hasOwnProperty;
    for(var i = 0; i < keysA.length; i += 1){
        if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
        var valA = objA[keysA[i]];
        var valB = objB[keysA[i]];
        if (valA !== valB) return false;
    }
    return true;
}


var $c7e8d5b5e632486b$var$_shallowEqual2 = $c7e8d5b5e632486b$var$_interopRequireDefault($fc289dc171730bea$exports);
var $fb0ed5e3798e18b3$exports = {};
'use strict';
Object.defineProperty($fb0ed5e3798e18b3$exports, "__esModule", {
    value: true
});
var $fb0ed5e3798e18b3$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $b9b9a5be574cc65b$exports = {};




/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */ var $b9b9a5be574cc65b$var$union = $ff83c7c0ae177e74$exports(function(arrays) {
    return $a1f8839e2550ec0f$exports($6bc15f8cc5a05c72$exports(arrays, 1, $b2f7b852db6286b1$exports, true));
});
$b9b9a5be574cc65b$exports = $b9b9a5be574cc65b$var$union;


var $fb0ed5e3798e18b3$var$_union2 = $fb0ed5e3798e18b3$var$_interopRequireDefault($b9b9a5be574cc65b$exports);

var $fb0ed5e3798e18b3$var$_without2 = $fb0ed5e3798e18b3$var$_interopRequireDefault($43f8232def0d8ab2$exports);
function $fb0ed5e3798e18b3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $fb0ed5e3798e18b3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $fb0ed5e3798e18b3$var$EnterLeaveCounter = function() {
    function EnterLeaveCounter() {
        $fb0ed5e3798e18b3$var$_classCallCheck(this, EnterLeaveCounter);
        this.entered = [];
    }
    $fb0ed5e3798e18b3$var$_createClass(EnterLeaveCounter, [
        {
            key: 'enter',
            value: function enter(enteringNode) {
                var previousLength = this.entered.length;
                var isNodeEntered = function isNodeEntered(node) {
                    return document.documentElement.contains(node) && (!node.contains || node.contains(enteringNode));
                };
                this.entered = (0, $fb0ed5e3798e18b3$var$_union2.default)(this.entered.filter(isNodeEntered), [
                    enteringNode
                ]);
                return previousLength === 0 && this.entered.length > 0;
            }
        },
        {
            key: 'leave',
            value: function leave(leavingNode) {
                var previousLength = this.entered.length;
                this.entered = (0, $fb0ed5e3798e18b3$var$_without2.default)(this.entered.filter(function(node) {
                    return document.documentElement.contains(node);
                }), leavingNode);
                return previousLength > 0 && this.entered.length === 0;
            }
        },
        {
            key: 'reset',
            value: function reset() {
                this.entered = [];
            }
        }
    ]);
    return EnterLeaveCounter;
}();
$fb0ed5e3798e18b3$exports.default = $fb0ed5e3798e18b3$var$EnterLeaveCounter;


var $c7e8d5b5e632486b$var$_EnterLeaveCounter2 = $c7e8d5b5e632486b$var$_interopRequireDefault($fb0ed5e3798e18b3$exports);
var $3ed0475040fe994b$exports = {};
'use strict';
Object.defineProperty($3ed0475040fe994b$exports, "__esModule", {
    value: true
});
$3ed0475040fe994b$exports.isSafari = $3ed0475040fe994b$exports.isFirefox = undefined;

var $3ed0475040fe994b$var$_memoize2 = $3ed0475040fe994b$var$_interopRequireDefault($c6abd82bf9a92371$exports);
function $3ed0475040fe994b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $3ed0475040fe994b$var$isFirefox = $3ed0475040fe994b$exports.isFirefox = (0, $3ed0475040fe994b$var$_memoize2.default)(function() {
    return /firefox/i.test(navigator.userAgent);
});
var $3ed0475040fe994b$var$isSafari = $3ed0475040fe994b$exports.isSafari = (0, $3ed0475040fe994b$var$_memoize2.default)(function() {
    return Boolean(window.safari);
});


var $495fc93671dd90d7$exports = {};
'use strict';
Object.defineProperty($495fc93671dd90d7$exports, "__esModule", {
    value: true
});
$495fc93671dd90d7$exports.getNodeClientOffset = $495fc93671dd90d7$var$getNodeClientOffset;
$495fc93671dd90d7$exports.getEventClientOffset = $495fc93671dd90d7$var$getEventClientOffset;
$495fc93671dd90d7$exports.getDragPreviewOffset = $495fc93671dd90d7$var$getDragPreviewOffset;

var $200d5420e76d0f6d$exports = {};
"use strict";
Object.defineProperty($200d5420e76d0f6d$exports, "__esModule", {
    value: true
});
var $200d5420e76d0f6d$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $200d5420e76d0f6d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
/* eslint
   no-plusplus: off,
   no-mixed-operators: off
*/ var $200d5420e76d0f6d$var$MonotonicInterpolant = function() {
    function MonotonicInterpolant(xs, ys) {
        $200d5420e76d0f6d$var$_classCallCheck(this, MonotonicInterpolant);
        var length = xs.length;
        // Rearrange xs and ys so that xs is sorted
        var indexes = [];
        for(var i = 0; i < length; i++)indexes.push(i);
        indexes.sort(function(a, b) {
            return xs[a] < xs[b] ? -1 : 1;
        });
        // Get consecutive differences and slopes
        var dys = [];
        var dxs = [];
        var ms = [];
        var dx = void 0;
        var dy = void 0;
        for(var _i = 0; _i < length - 1; _i++){
            dx = xs[_i + 1] - xs[_i];
            dy = ys[_i + 1] - ys[_i];
            dxs.push(dx);
            dys.push(dy);
            ms.push(dy / dx);
        }
        // Get degree-1 coefficients
        var c1s = [
            ms[0]
        ];
        for(var _i2 = 0; _i2 < dxs.length - 1; _i2++){
            var _m = ms[_i2];
            var mNext = ms[_i2 + 1];
            if (_m * mNext <= 0) c1s.push(0);
            else {
                dx = dxs[_i2];
                var dxNext = dxs[_i2 + 1];
                var common = dx + dxNext;
                c1s.push(3 * common / ((common + dxNext) / _m + (common + dx) / mNext));
            }
        }
        c1s.push(ms[ms.length - 1]);
        // Get degree-2 and degree-3 coefficients
        var c2s = [];
        var c3s = [];
        var m = void 0;
        for(var _i3 = 0; _i3 < c1s.length - 1; _i3++){
            m = ms[_i3];
            var c1 = c1s[_i3];
            var invDx = 1 / dxs[_i3];
            var _common = c1 + c1s[_i3 + 1] - m - m;
            c2s.push((m - c1 - _common) * invDx);
            c3s.push(_common * invDx * invDx);
        }
        this.xs = xs;
        this.ys = ys;
        this.c1s = c1s;
        this.c2s = c2s;
        this.c3s = c3s;
    }
    $200d5420e76d0f6d$var$_createClass(MonotonicInterpolant, [
        {
            key: "interpolate",
            value: function interpolate(x) {
                var xs = this.xs, ys = this.ys, c1s = this.c1s, c2s = this.c2s, c3s = this.c3s;
                // The rightmost point in the dataset should give an exact result
                var i = xs.length - 1;
                if (x === xs[i]) return ys[i];
                // Search for the interval x is in, returning the corresponding y if x is one of the original xs
                var low = 0;
                var high = c3s.length - 1;
                var mid = void 0;
                while(low <= high){
                    mid = Math.floor(0.5 * (low + high));
                    var xHere = xs[mid];
                    if (xHere < x) low = mid + 1;
                    else if (xHere > x) high = mid - 1;
                    else return ys[mid];
                }
                i = Math.max(0, high);
                // Interpolate
                var diff = x - xs[i];
                var diffSq = diff * diff;
                return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
            }
        }
    ]);
    return MonotonicInterpolant;
}();
$200d5420e76d0f6d$exports.default = $200d5420e76d0f6d$var$MonotonicInterpolant;


var $495fc93671dd90d7$var$_MonotonicInterpolant2 = $495fc93671dd90d7$var$_interopRequireDefault($200d5420e76d0f6d$exports);
function $495fc93671dd90d7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/* eslint
   no-mixed-operators: off
*/ var $495fc93671dd90d7$var$ELEMENT_NODE = 1;
function $495fc93671dd90d7$var$getNodeClientOffset(node) {
    var el = node.nodeType === $495fc93671dd90d7$var$ELEMENT_NODE ? node : node.parentElement;
    if (!el) return null;
    var _el$getBoundingClient = el.getBoundingClientRect(), top = _el$getBoundingClient.top, left = _el$getBoundingClient.left;
    return {
        x: left,
        y: top
    };
}
function $495fc93671dd90d7$var$getEventClientOffset(e) {
    return {
        x: e.clientX,
        y: e.clientY
    };
}
function $495fc93671dd90d7$var$isImageNode(node) {
    return node.nodeName === 'IMG' && ((0, $3ed0475040fe994b$exports.isFirefox)() || !document.documentElement.contains(node));
}
function $495fc93671dd90d7$var$getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight) {
    var dragPreviewWidth = isImage ? dragPreview.width : sourceWidth;
    var dragPreviewHeight = isImage ? dragPreview.height : sourceHeight;
    // Work around @2x coordinate discrepancies in browsers
    if ((0, $3ed0475040fe994b$exports.isSafari)() && isImage) {
        dragPreviewHeight /= window.devicePixelRatio;
        dragPreviewWidth /= window.devicePixelRatio;
    }
    return {
        dragPreviewWidth: dragPreviewWidth,
        dragPreviewHeight: dragPreviewHeight
    };
}
function $495fc93671dd90d7$var$getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint) {
    // The browsers will use the image intrinsic size under different conditions.
    // Firefox only cares if it's an image, but WebKit also wants it to be detached.
    var isImage = $495fc93671dd90d7$var$isImageNode(dragPreview);
    var dragPreviewNode = isImage ? sourceNode : dragPreview;
    var dragPreviewNodeOffsetFromClient = $495fc93671dd90d7$var$getNodeClientOffset(dragPreviewNode);
    var offsetFromDragPreview = {
        x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
        y: clientOffset.y - dragPreviewNodeOffsetFromClient.y
    };
    var sourceWidth = sourceNode.offsetWidth, sourceHeight = sourceNode.offsetHeight;
    var anchorX = anchorPoint.anchorX, anchorY = anchorPoint.anchorY;
    var _getDragPreviewSize = $495fc93671dd90d7$var$getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight), dragPreviewWidth = _getDragPreviewSize.dragPreviewWidth, dragPreviewHeight = _getDragPreviewSize.dragPreviewHeight;
    var calculateYOffset = function calculateYOffset() {
        var interpolantY = new $495fc93671dd90d7$var$_MonotonicInterpolant2.default([
            0,
            0.5,
            1
        ], [
            // Dock to the top
            offsetFromDragPreview.y,
            // Align at the center
            offsetFromDragPreview.y / sourceHeight * dragPreviewHeight,
            // Dock to the bottom
            offsetFromDragPreview.y + dragPreviewHeight - sourceHeight
        ]);
        var y = interpolantY.interpolate(anchorY);
        // Work around Safari 8 positioning bug
        if ((0, $3ed0475040fe994b$exports.isSafari)() && isImage) // We'll have to wait for @3x to see if this is entirely correct
        y += (window.devicePixelRatio - 1) * dragPreviewHeight;
        return y;
    };
    var calculateXOffset = function calculateXOffset() {
        // Interpolate coordinates depending on anchor point
        // If you know a simpler way to do this, let me know
        var interpolantX = new $495fc93671dd90d7$var$_MonotonicInterpolant2.default([
            0,
            0.5,
            1
        ], [
            // Dock to the left
            offsetFromDragPreview.x,
            // Align at the center
            offsetFromDragPreview.x / sourceWidth * dragPreviewWidth,
            // Dock to the right
            offsetFromDragPreview.x + dragPreviewWidth - sourceWidth
        ]);
        return interpolantX.interpolate(anchorX);
    };
    // Force offsets if specified in the options.
    var offsetX = offsetPoint.offsetX, offsetY = offsetPoint.offsetY;
    var isManualOffsetX = offsetX === 0 || offsetX;
    var isManualOffsetY = offsetY === 0 || offsetY;
    return {
        x: isManualOffsetX ? offsetX : calculateXOffset(),
        y: isManualOffsetY ? offsetY : calculateYOffset()
    };
}


var $ea3c5e7968e376b1$exports = {};
'use strict';
Object.defineProperty($ea3c5e7968e376b1$exports, "__esModule", {
    value: true
});
var $ea3c5e7968e376b1$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $ea3c5e7968e376b1$var$_nativeTypesConfig;
$ea3c5e7968e376b1$exports.createNativeDragSource = $ea3c5e7968e376b1$var$createNativeDragSource;
$ea3c5e7968e376b1$exports.matchNativeItemType = $ea3c5e7968e376b1$var$matchNativeItemType;
var $99e62feed255a6da$exports = {};
'use strict';
Object.defineProperty($99e62feed255a6da$exports, "__esModule", {
    value: true
});
var $99e62feed255a6da$var$FILE = $99e62feed255a6da$exports.FILE = '__NATIVE_FILE__';
var $99e62feed255a6da$var$URL = $99e62feed255a6da$exports.URL = '__NATIVE_URL__';
var $99e62feed255a6da$var$TEXT = $99e62feed255a6da$exports.TEXT = '__NATIVE_TEXT__';


var $ea3c5e7968e376b1$var$NativeTypes = $ea3c5e7968e376b1$var$_interopRequireWildcard($99e62feed255a6da$exports);
function $ea3c5e7968e376b1$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $ea3c5e7968e376b1$var$_defineEnumerableProperties(obj, descs) {
    for(var key in descs){
        var desc = descs[key];
        desc.configurable = desc.enumerable = true;
        if ("value" in desc) desc.writable = true;
        Object.defineProperty(obj, key, desc);
    }
    return obj;
}
function $ea3c5e7968e376b1$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ea3c5e7968e376b1$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ea3c5e7968e376b1$var$getDataFromDataTransfer(dataTransfer, typesToTry, defaultValue) {
    var result = typesToTry.reduce(function(resultSoFar, typeToTry) {
        return resultSoFar || dataTransfer.getData(typeToTry);
    }, null);
    return result != null // eslint-disable-line eqeqeq
     ? result : defaultValue;
}
var $ea3c5e7968e376b1$var$nativeTypesConfig = ($ea3c5e7968e376b1$var$_nativeTypesConfig = {}, $ea3c5e7968e376b1$var$_defineProperty($ea3c5e7968e376b1$var$_nativeTypesConfig, $ea3c5e7968e376b1$var$NativeTypes.FILE, {
    exposeProperty: 'files',
    matchesTypes: [
        'Files'
    ],
    getData: function getData(dataTransfer) {
        return Array.prototype.slice.call(dataTransfer.files);
    }
}), $ea3c5e7968e376b1$var$_defineProperty($ea3c5e7968e376b1$var$_nativeTypesConfig, $ea3c5e7968e376b1$var$NativeTypes.URL, {
    exposeProperty: 'urls',
    matchesTypes: [
        'Url',
        'text/uri-list'
    ],
    getData: function getData(dataTransfer, matchesTypes) {
        return $ea3c5e7968e376b1$var$getDataFromDataTransfer(dataTransfer, matchesTypes, '').split('\n');
    }
}), $ea3c5e7968e376b1$var$_defineProperty($ea3c5e7968e376b1$var$_nativeTypesConfig, $ea3c5e7968e376b1$var$NativeTypes.TEXT, {
    exposeProperty: 'text',
    matchesTypes: [
        'Text',
        'text/plain'
    ],
    getData: function getData(dataTransfer, matchesTypes) {
        return $ea3c5e7968e376b1$var$getDataFromDataTransfer(dataTransfer, matchesTypes, '');
    }
}), $ea3c5e7968e376b1$var$_nativeTypesConfig);
function $ea3c5e7968e376b1$var$createNativeDragSource(type) {
    var _nativeTypesConfig$ty = $ea3c5e7968e376b1$var$nativeTypesConfig[type], exposeProperty = _nativeTypesConfig$ty.exposeProperty, matchesTypes = _nativeTypesConfig$ty.matchesTypes, getData = _nativeTypesConfig$ty.getData;
    return function() {
        function NativeDragSource() {
            var _item, _mutatorMap;
            $ea3c5e7968e376b1$var$_classCallCheck(this, NativeDragSource);
            this.item = (_item = {}, _mutatorMap = {}, _mutatorMap[exposeProperty] = _mutatorMap[exposeProperty] || {}, _mutatorMap[exposeProperty].get = function() {
                // eslint-disable-next-line no-console
                console.warn('Browser doesn\'t allow reading "' + exposeProperty + '" until the drop event.');
                return null;
            }, $ea3c5e7968e376b1$var$_defineEnumerableProperties(_item, _mutatorMap), _item);
        }
        $ea3c5e7968e376b1$var$_createClass(NativeDragSource, [
            {
                key: 'mutateItemByReadingDataTransfer',
                value: function mutateItemByReadingDataTransfer(dataTransfer) {
                    delete this.item[exposeProperty];
                    this.item[exposeProperty] = getData(dataTransfer, matchesTypes);
                }
            },
            {
                key: 'canDrag',
                value: function canDrag() {
                    return true;
                }
            },
            {
                key: 'beginDrag',
                value: function beginDrag() {
                    return this.item;
                }
            },
            {
                key: 'isDragging',
                value: function isDragging(monitor, handle) {
                    return handle === monitor.getSourceId();
                }
            },
            {
                key: 'endDrag',
                value: function endDrag() {}
            }
        ]);
        return NativeDragSource;
    }();
}
function $ea3c5e7968e376b1$var$matchNativeItemType(dataTransfer) {
    var dataTransferTypes = Array.prototype.slice.call(dataTransfer.types || []);
    return Object.keys($ea3c5e7968e376b1$var$nativeTypesConfig).filter(function(nativeItemType) {
        var matchesTypes = $ea3c5e7968e376b1$var$nativeTypesConfig[nativeItemType].matchesTypes;
        return matchesTypes.some(function(t) {
            return dataTransferTypes.indexOf(t) > -1;
        });
    })[0] || null;
}



var $c7e8d5b5e632486b$var$NativeTypes = $c7e8d5b5e632486b$var$_interopRequireWildcard($99e62feed255a6da$exports);
function $c7e8d5b5e632486b$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $c7e8d5b5e632486b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c7e8d5b5e632486b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $c7e8d5b5e632486b$var$HTML5Backend = function() {
    function HTML5Backend(manager) {
        $c7e8d5b5e632486b$var$_classCallCheck(this, HTML5Backend);
        this.actions = manager.getActions();
        this.monitor = manager.getMonitor();
        this.registry = manager.getRegistry();
        this.context = manager.getContext();
        this.sourcePreviewNodes = {};
        this.sourcePreviewNodeOptions = {};
        this.sourceNodes = {};
        this.sourceNodeOptions = {};
        this.enterLeaveCounter = new $c7e8d5b5e632486b$var$_EnterLeaveCounter2.default();
        this.dragStartSourceIds = [];
        this.dropTargetIds = [];
        this.dragEnterTargetIds = [];
        this.currentNativeSource = null;
        this.currentNativeHandle = null;
        this.currentDragSourceNode = null;
        this.currentDragSourceNodeOffset = null;
        this.currentDragSourceNodeOffsetChanged = false;
        this.altKeyPressed = false;
        this.mouseMoveTimeoutTimer = null;
        this.getSourceClientOffset = this.getSourceClientOffset.bind(this);
        this.handleTopDragStart = this.handleTopDragStart.bind(this);
        this.handleTopDragStartCapture = this.handleTopDragStartCapture.bind(this);
        this.handleTopDragEndCapture = this.handleTopDragEndCapture.bind(this);
        this.handleTopDragEnter = this.handleTopDragEnter.bind(this);
        this.handleTopDragEnterCapture = this.handleTopDragEnterCapture.bind(this);
        this.handleTopDragLeaveCapture = this.handleTopDragLeaveCapture.bind(this);
        this.handleTopDragOver = this.handleTopDragOver.bind(this);
        this.handleTopDragOverCapture = this.handleTopDragOverCapture.bind(this);
        this.handleTopDrop = this.handleTopDrop.bind(this);
        this.handleTopDropCapture = this.handleTopDropCapture.bind(this);
        this.handleSelectStart = this.handleSelectStart.bind(this);
        this.endDragIfSourceWasRemovedFromDOM = this.endDragIfSourceWasRemovedFromDOM.bind(this);
        this.endDragNativeItem = this.endDragNativeItem.bind(this);
        this.asyncEndDragNativeItem = this.asyncEndDragNativeItem.bind(this);
        this.isNodeInDocument = this.isNodeInDocument.bind(this);
    }
    $c7e8d5b5e632486b$var$_createClass(HTML5Backend, [
        {
            key: 'setup',
            value: function setup() {
                if (this.window === undefined) return;
                if (this.window.__isReactDndBackendSetUp) throw new Error('Cannot have two HTML5 backends at the same time.');
                this.window.__isReactDndBackendSetUp = true;
                this.addEventListeners(this.window);
            }
        },
        {
            key: 'teardown',
            value: function teardown() {
                if (this.window === undefined) return;
                this.window.__isReactDndBackendSetUp = false;
                this.removeEventListeners(this.window);
                this.clearCurrentDragSourceNode();
                if (this.asyncEndDragFrameId) this.window.cancelAnimationFrame(this.asyncEndDragFrameId);
            }
        },
        {
            key: 'addEventListeners',
            value: function addEventListeners(target) {
                // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
                if (!target.addEventListener) return;
                target.addEventListener('dragstart', this.handleTopDragStart);
                target.addEventListener('dragstart', this.handleTopDragStartCapture, true);
                target.addEventListener('dragend', this.handleTopDragEndCapture, true);
                target.addEventListener('dragenter', this.handleTopDragEnter);
                target.addEventListener('dragenter', this.handleTopDragEnterCapture, true);
                target.addEventListener('dragleave', this.handleTopDragLeaveCapture, true);
                target.addEventListener('dragover', this.handleTopDragOver);
                target.addEventListener('dragover', this.handleTopDragOverCapture, true);
                target.addEventListener('drop', this.handleTopDrop);
                target.addEventListener('drop', this.handleTopDropCapture, true);
            }
        },
        {
            key: 'removeEventListeners',
            value: function removeEventListeners(target) {
                // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
                if (!target.removeEventListener) return;
                target.removeEventListener('dragstart', this.handleTopDragStart);
                target.removeEventListener('dragstart', this.handleTopDragStartCapture, true);
                target.removeEventListener('dragend', this.handleTopDragEndCapture, true);
                target.removeEventListener('dragenter', this.handleTopDragEnter);
                target.removeEventListener('dragenter', this.handleTopDragEnterCapture, true);
                target.removeEventListener('dragleave', this.handleTopDragLeaveCapture, true);
                target.removeEventListener('dragover', this.handleTopDragOver);
                target.removeEventListener('dragover', this.handleTopDragOverCapture, true);
                target.removeEventListener('drop', this.handleTopDrop);
                target.removeEventListener('drop', this.handleTopDropCapture, true);
            }
        },
        {
            key: 'connectDragPreview',
            value: function connectDragPreview(sourceId, node, options) {
                var _this = this;
                this.sourcePreviewNodeOptions[sourceId] = options;
                this.sourcePreviewNodes[sourceId] = node;
                return function() {
                    delete _this.sourcePreviewNodes[sourceId];
                    delete _this.sourcePreviewNodeOptions[sourceId];
                };
            }
        },
        {
            key: 'connectDragSource',
            value: function connectDragSource(sourceId, node, options) {
                var _this2 = this;
                this.sourceNodes[sourceId] = node;
                this.sourceNodeOptions[sourceId] = options;
                var handleDragStart = function handleDragStart(e) {
                    return _this2.handleDragStart(e, sourceId);
                };
                var handleSelectStart = function handleSelectStart(e) {
                    return _this2.handleSelectStart(e, sourceId);
                };
                node.setAttribute('draggable', true);
                node.addEventListener('dragstart', handleDragStart);
                node.addEventListener('selectstart', handleSelectStart);
                return function() {
                    delete _this2.sourceNodes[sourceId];
                    delete _this2.sourceNodeOptions[sourceId];
                    node.removeEventListener('dragstart', handleDragStart);
                    node.removeEventListener('selectstart', handleSelectStart);
                    node.setAttribute('draggable', false);
                };
            }
        },
        {
            key: 'connectDropTarget',
            value: function connectDropTarget(targetId, node) {
                var _this3 = this;
                var handleDragEnter = function handleDragEnter(e) {
                    return _this3.handleDragEnter(e, targetId);
                };
                var handleDragOver = function handleDragOver(e) {
                    return _this3.handleDragOver(e, targetId);
                };
                var handleDrop = function handleDrop(e) {
                    return _this3.handleDrop(e, targetId);
                };
                node.addEventListener('dragenter', handleDragEnter);
                node.addEventListener('dragover', handleDragOver);
                node.addEventListener('drop', handleDrop);
                return function() {
                    node.removeEventListener('dragenter', handleDragEnter);
                    node.removeEventListener('dragover', handleDragOver);
                    node.removeEventListener('drop', handleDrop);
                };
            }
        },
        {
            key: 'getCurrentSourceNodeOptions',
            value: function getCurrentSourceNodeOptions() {
                var sourceId = this.monitor.getSourceId();
                var sourceNodeOptions = this.sourceNodeOptions[sourceId];
                return (0, $c7e8d5b5e632486b$var$_defaults2.default)(sourceNodeOptions || {}, {
                    dropEffect: this.altKeyPressed ? 'copy' : 'move'
                });
            }
        },
        {
            key: 'getCurrentDropEffect',
            value: function getCurrentDropEffect() {
                if (this.isDraggingNativeItem()) // It makes more sense to default to 'copy' for native resources
                return 'copy';
                return this.getCurrentSourceNodeOptions().dropEffect;
            }
        },
        {
            key: 'getCurrentSourcePreviewNodeOptions',
            value: function getCurrentSourcePreviewNodeOptions() {
                var sourceId = this.monitor.getSourceId();
                var sourcePreviewNodeOptions = this.sourcePreviewNodeOptions[sourceId];
                return (0, $c7e8d5b5e632486b$var$_defaults2.default)(sourcePreviewNodeOptions || {}, {
                    anchorX: 0.5,
                    anchorY: 0.5,
                    captureDraggingState: false
                });
            }
        },
        {
            key: 'getSourceClientOffset',
            value: function getSourceClientOffset(sourceId) {
                return (0, $495fc93671dd90d7$exports.getNodeClientOffset)(this.sourceNodes[sourceId]);
            }
        },
        {
            key: 'isDraggingNativeItem',
            value: function isDraggingNativeItem() {
                var itemType = this.monitor.getItemType();
                return Object.keys($c7e8d5b5e632486b$var$NativeTypes).some(function(key) {
                    return $c7e8d5b5e632486b$var$NativeTypes[key] === itemType;
                });
            }
        },
        {
            key: 'beginDragNativeItem',
            value: function beginDragNativeItem(type) {
                this.clearCurrentDragSourceNode();
                var SourceType = (0, $ea3c5e7968e376b1$exports.createNativeDragSource)(type);
                this.currentNativeSource = new SourceType();
                this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
                this.actions.beginDrag([
                    this.currentNativeHandle
                ]);
            }
        },
        {
            key: 'asyncEndDragNativeItem',
            value: function asyncEndDragNativeItem() {
                this.asyncEndDragFrameId = this.window.requestAnimationFrame(this.endDragNativeItem);
            }
        },
        {
            key: 'endDragNativeItem',
            value: function endDragNativeItem() {
                if (!this.isDraggingNativeItem()) return;
                this.actions.endDrag();
                this.registry.removeSource(this.currentNativeHandle);
                this.currentNativeHandle = null;
                this.currentNativeSource = null;
            }
        },
        {
            key: 'isNodeInDocument',
            value: function isNodeInDocument(node) {
                // Check the node either in the main document or in the current context
                return document.body.contains(node) || this.window ? this.window.document.body.contains(node) : false;
            }
        },
        {
            key: 'endDragIfSourceWasRemovedFromDOM',
            value: function endDragIfSourceWasRemovedFromDOM() {
                var node = this.currentDragSourceNode;
                if (this.isNodeInDocument(node)) return;
                if (this.clearCurrentDragSourceNode()) this.actions.endDrag();
            }
        },
        {
            key: 'setCurrentDragSourceNode',
            value: function setCurrentDragSourceNode(node) {
                var _this4 = this;
                this.clearCurrentDragSourceNode();
                this.currentDragSourceNode = node;
                this.currentDragSourceNodeOffset = (0, $495fc93671dd90d7$exports.getNodeClientOffset)(node);
                this.currentDragSourceNodeOffsetChanged = false;
                // A timeout of > 0 is necessary to resolve Firefox issue referenced
                // See:
                //   * https://github.com/react-dnd/react-dnd/pull/928
                //   * https://github.com/react-dnd/react-dnd/issues/869
                var MOUSE_MOVE_TIMEOUT = 1000;
                // Receiving a mouse event in the middle of a dragging operation
                // means it has ended and the drag source node disappeared from DOM,
                // so the browser didn't dispatch the dragend event.
                //
                // We need to wait before we start listening for mousemove events.
                // This is needed because the drag preview needs to be drawn or else it fires an 'mousemove' event
                // immediately in some browsers.
                //
                // See:
                //   * https://github.com/react-dnd/react-dnd/pull/928
                //   * https://github.com/react-dnd/react-dnd/issues/869
                //
                this.mouseMoveTimeoutTimer = setTimeout(function() {
                    _this4.mouseMoveTimeoutId = null;
                    return _this4.window.addEventListener('mousemove', _this4.endDragIfSourceWasRemovedFromDOM, true);
                }, MOUSE_MOVE_TIMEOUT);
            }
        },
        {
            key: 'clearCurrentDragSourceNode',
            value: function clearCurrentDragSourceNode() {
                if (this.currentDragSourceNode) {
                    this.currentDragSourceNode = null;
                    this.currentDragSourceNodeOffset = null;
                    this.currentDragSourceNodeOffsetChanged = false;
                    this.window.clearTimeout(this.mouseMoveTimeoutTimer);
                    this.window.removeEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
                    this.mouseMoveTimeoutTimer = null;
                    return true;
                }
                return false;
            }
        },
        {
            key: 'checkIfCurrentDragSourceRectChanged',
            value: function checkIfCurrentDragSourceRectChanged() {
                var node = this.currentDragSourceNode;
                if (!node) return false;
                if (this.currentDragSourceNodeOffsetChanged) return true;
                this.currentDragSourceNodeOffsetChanged = !(0, $c7e8d5b5e632486b$var$_shallowEqual2.default)((0, $495fc93671dd90d7$exports.getNodeClientOffset)(node), this.currentDragSourceNodeOffset);
                return this.currentDragSourceNodeOffsetChanged;
            }
        },
        {
            key: 'handleTopDragStartCapture',
            value: function handleTopDragStartCapture() {
                this.clearCurrentDragSourceNode();
                this.dragStartSourceIds = [];
            }
        },
        {
            key: 'handleDragStart',
            value: function handleDragStart(e, sourceId) {
                this.dragStartSourceIds.unshift(sourceId);
            }
        },
        {
            key: 'handleTopDragStart',
            value: function handleTopDragStart(e) {
                var _this5 = this;
                var dragStartSourceIds = this.dragStartSourceIds;
                this.dragStartSourceIds = null;
                var clientOffset = (0, $495fc93671dd90d7$exports.getEventClientOffset)(e);
                // Avoid crashing if we missed a drop event or our previous drag died
                if (this.monitor.isDragging()) this.actions.endDrag();
                // Don't publish the source just yet (see why below)
                this.actions.beginDrag(dragStartSourceIds, {
                    publishSource: false,
                    getSourceClientOffset: this.getSourceClientOffset,
                    clientOffset: clientOffset
                });
                var dataTransfer = e.dataTransfer;
                var nativeType = (0, $ea3c5e7968e376b1$exports.matchNativeItemType)(dataTransfer);
                if (this.monitor.isDragging()) {
                    if (typeof dataTransfer.setDragImage === 'function') {
                        // Use custom drag image if user specifies it.
                        // If child drag source refuses drag but parent agrees,
                        // use parent's node as drag image. Neither works in IE though.
                        var sourceId = this.monitor.getSourceId();
                        var sourceNode = this.sourceNodes[sourceId];
                        var dragPreview = this.sourcePreviewNodes[sourceId] || sourceNode;
                        var _getCurrentSourcePrev = this.getCurrentSourcePreviewNodeOptions(), anchorX = _getCurrentSourcePrev.anchorX, anchorY = _getCurrentSourcePrev.anchorY, offsetX = _getCurrentSourcePrev.offsetX, offsetY = _getCurrentSourcePrev.offsetY;
                        var anchorPoint = {
                            anchorX: anchorX,
                            anchorY: anchorY
                        };
                        var offsetPoint = {
                            offsetX: offsetX,
                            offsetY: offsetY
                        };
                        var dragPreviewOffset = (0, $495fc93671dd90d7$exports.getDragPreviewOffset)(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint);
                        dataTransfer.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
                    }
                    try {
                        // Firefox won't drag without setting data
                        dataTransfer.setData('application/json', {});
                    } catch (err) {}
                    // IE doesn't support MIME types in setData
                    // Store drag source node so we can check whether
                    // it is removed from DOM and trigger endDrag manually.
                    this.setCurrentDragSourceNode(e.target);
                    // Now we are ready to publish the drag source.. or are we not?
                    var _getCurrentSourcePrev2 = this.getCurrentSourcePreviewNodeOptions(), captureDraggingState = _getCurrentSourcePrev2.captureDraggingState;
                    if (!captureDraggingState) // Usually we want to publish it in the next tick so that browser
                    // is able to screenshot the current (not yet dragging) state.
                    //
                    // It also neatly avoids a situation where render() returns null
                    // in the same tick for the source element, and browser freaks out.
                    setTimeout(function() {
                        return _this5.actions.publishDragSource();
                    });
                    else // In some cases the user may want to override this behavior, e.g.
                    // to work around IE not supporting custom drag previews.
                    //
                    // When using a custom drag layer, the only way to prevent
                    // the default drag preview from drawing in IE is to screenshot
                    // the dragging state in which the node itself has zero opacity
                    // and height. In this case, though, returning null from render()
                    // will abruptly end the dragging, which is not obvious.
                    //
                    // This is the reason such behavior is strictly opt-in.
                    this.actions.publishDragSource();
                } else if (nativeType) // A native item (such as URL) dragged from inside the document
                this.beginDragNativeItem(nativeType);
                else if (!dataTransfer.types && (!e.target.hasAttribute || !e.target.hasAttribute('draggable'))) // Looks like a Safari bug: dataTransfer.types is null, but there was no draggable.
                // Just let it drag. It's a native type (URL or text) and will be picked up in
                // dragenter handler.
                return; // eslint-disable-line no-useless-return
                else // If by this time no drag source reacted, tell browser not to drag.
                e.preventDefault();
            }
        },
        {
            key: 'handleTopDragEndCapture',
            value: function handleTopDragEndCapture() {
                if (this.clearCurrentDragSourceNode()) // Firefox can dispatch this event in an infinite loop
                // if dragend handler does something like showing an alert.
                // Only proceed if we have not handled it already.
                this.actions.endDrag();
            }
        },
        {
            key: 'handleTopDragEnterCapture',
            value: function handleTopDragEnterCapture(e) {
                this.dragEnterTargetIds = [];
                var isFirstEnter = this.enterLeaveCounter.enter(e.target);
                if (!isFirstEnter || this.monitor.isDragging()) return;
                var dataTransfer = e.dataTransfer;
                var nativeType = (0, $ea3c5e7968e376b1$exports.matchNativeItemType)(dataTransfer);
                if (nativeType) // A native item (such as file or URL) dragged from outside the document
                this.beginDragNativeItem(nativeType);
            }
        },
        {
            key: 'handleDragEnter',
            value: function handleDragEnter(e, targetId) {
                this.dragEnterTargetIds.unshift(targetId);
            }
        },
        {
            key: 'handleTopDragEnter',
            value: function handleTopDragEnter(e) {
                var _this6 = this;
                var dragEnterTargetIds = this.dragEnterTargetIds;
                this.dragEnterTargetIds = [];
                if (!this.monitor.isDragging()) // This is probably a native item type we don't understand.
                return;
                this.altKeyPressed = e.altKey;
                if (!(0, $3ed0475040fe994b$exports.isFirefox)()) // Don't emit hover in `dragenter` on Firefox due to an edge case.
                // If the target changes position as the result of `dragenter`, Firefox
                // will still happily dispatch `dragover` despite target being no longer
                // there. The easy solution is to only fire `hover` in `dragover` on FF.
                this.actions.hover(dragEnterTargetIds, {
                    clientOffset: (0, $495fc93671dd90d7$exports.getEventClientOffset)(e)
                });
                var canDrop = dragEnterTargetIds.some(function(targetId) {
                    return _this6.monitor.canDropOnTarget(targetId);
                });
                if (canDrop) {
                    // IE requires this to fire dragover events
                    e.preventDefault();
                    e.dataTransfer.dropEffect = this.getCurrentDropEffect();
                }
            }
        },
        {
            key: 'handleTopDragOverCapture',
            value: function handleTopDragOverCapture() {
                this.dragOverTargetIds = [];
            }
        },
        {
            key: 'handleDragOver',
            value: function handleDragOver(e, targetId) {
                this.dragOverTargetIds.unshift(targetId);
            }
        },
        {
            key: 'handleTopDragOver',
            value: function handleTopDragOver(e) {
                var _this7 = this;
                var dragOverTargetIds = this.dragOverTargetIds;
                this.dragOverTargetIds = [];
                if (!this.monitor.isDragging()) {
                    // This is probably a native item type we don't understand.
                    // Prevent default "drop and blow away the whole document" action.
                    e.preventDefault();
                    e.dataTransfer.dropEffect = 'none';
                    return;
                }
                this.altKeyPressed = e.altKey;
                this.actions.hover(dragOverTargetIds, {
                    clientOffset: (0, $495fc93671dd90d7$exports.getEventClientOffset)(e)
                });
                var canDrop = dragOverTargetIds.some(function(targetId) {
                    return _this7.monitor.canDropOnTarget(targetId);
                });
                if (canDrop) {
                    // Show user-specified drop effect.
                    e.preventDefault();
                    e.dataTransfer.dropEffect = this.getCurrentDropEffect();
                } else if (this.isDraggingNativeItem()) {
                    // Don't show a nice cursor but still prevent default
                    // "drop and blow away the whole document" action.
                    e.preventDefault();
                    e.dataTransfer.dropEffect = 'none';
                } else if (this.checkIfCurrentDragSourceRectChanged()) {
                    // Prevent animating to incorrect position.
                    // Drop effect must be other than 'none' to prevent animation.
                    e.preventDefault();
                    e.dataTransfer.dropEffect = 'move';
                }
            }
        },
        {
            key: 'handleTopDragLeaveCapture',
            value: function handleTopDragLeaveCapture(e) {
                if (this.isDraggingNativeItem()) e.preventDefault();
                var isLastLeave = this.enterLeaveCounter.leave(e.target);
                if (!isLastLeave) return;
                if (this.isDraggingNativeItem()) this.endDragNativeItem();
            }
        },
        {
            key: 'handleTopDropCapture',
            value: function handleTopDropCapture(e) {
                this.dropTargetIds = [];
                e.preventDefault();
                if (this.isDraggingNativeItem()) this.currentNativeSource.mutateItemByReadingDataTransfer(e.dataTransfer);
                this.enterLeaveCounter.reset();
            }
        },
        {
            key: 'handleDrop',
            value: function handleDrop(e, targetId) {
                this.dropTargetIds.unshift(targetId);
            }
        },
        {
            key: 'handleTopDrop',
            value: function handleTopDrop(e) {
                var dropTargetIds = this.dropTargetIds;
                this.dropTargetIds = [];
                this.actions.hover(dropTargetIds, {
                    clientOffset: (0, $495fc93671dd90d7$exports.getEventClientOffset)(e)
                });
                this.actions.drop({
                    dropEffect: this.getCurrentDropEffect()
                });
                if (this.isDraggingNativeItem()) this.endDragNativeItem();
                else this.endDragIfSourceWasRemovedFromDOM();
            }
        },
        {
            key: 'handleSelectStart',
            value: function handleSelectStart(e) {
                var target = e.target;
                // Only IE requires us to explicitly say
                // we want drag drop operation to start
                if (typeof target.dragDrop !== 'function') return;
                // Inputs and textareas should be selectable
                if (target.tagName === 'INPUT' || target.tagName === 'SELECT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return;
                // For other targets, ask IE
                // to enable drag and drop
                e.preventDefault();
                target.dragDrop();
            }
        },
        {
            key: 'window',
            get: function get() {
                if (this.context && this.context.window) return this.context.window;
                else if (typeof window !== 'undefined') return window;
                return undefined;
            }
        }
    ]);
    return HTML5Backend;
}();
$c7e8d5b5e632486b$exports.default = $c7e8d5b5e632486b$var$HTML5Backend;


var $3d979c1ec0f4ae95$var$_HTML5Backend2 = $3d979c1ec0f4ae95$var$_interopRequireDefault($c7e8d5b5e632486b$exports);
var $06357c3d118abfb5$exports = {};
'use strict';
Object.defineProperty($06357c3d118abfb5$exports, "__esModule", {
    value: true
});
$06357c3d118abfb5$exports.default = $06357c3d118abfb5$var$getEmptyImage;
var $06357c3d118abfb5$var$emptyImage = void 0;
function $06357c3d118abfb5$var$getEmptyImage() {
    if (!$06357c3d118abfb5$var$emptyImage) {
        $06357c3d118abfb5$var$emptyImage = new Image();
        $06357c3d118abfb5$var$emptyImage.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
    }
    return $06357c3d118abfb5$var$emptyImage;
}


var $3d979c1ec0f4ae95$var$_getEmptyImage2 = $3d979c1ec0f4ae95$var$_interopRequireDefault($06357c3d118abfb5$exports);

var $3d979c1ec0f4ae95$var$NativeTypes = $3d979c1ec0f4ae95$var$_interopRequireWildcard($99e62feed255a6da$exports);
function $3d979c1ec0f4ae95$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $3d979c1ec0f4ae95$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$3d979c1ec0f4ae95$exports.NativeTypes = $3d979c1ec0f4ae95$var$NativeTypes;
$3d979c1ec0f4ae95$exports.getEmptyImage = $3d979c1ec0f4ae95$var$_getEmptyImage2.default;
function $3d979c1ec0f4ae95$var$createHTML5Backend(manager) {
    return new $3d979c1ec0f4ae95$var$_HTML5Backend2.default(manager);
}



var $NdCUR = parcelRequire("NdCUR");

var $g2wso = parcelRequire("g2wso");


const $478d990beadcf6ef$var$fieldType = 'field';
const $478d990beadcf6ef$var$fieldSource = {
    beginDrag (props) {
        return {
            id: props.id,
            index: props.index
        };
    }
};
const $478d990beadcf6ef$var$fieldTarget = {
    hover (props, monitor, component) {
        const dragIndex = monitor.getItem().index;
        const hoverIndex = props.index;
        // Don't replace items with themselves
        if (dragIndex === hoverIndex) return;
        // Determine rectangle on screen
        const domNode = (0, $g2wso.findDOMNode)(component);
        const hoverBoundingRect = domNode.getBoundingClientRect();
        // Get vertical middle
        const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
        // Determine mouse position
        const clientOffset = monitor.getClientOffset();
        // Get pixels to the top
        const hoverClientY = clientOffset.y - hoverBoundingRect.top;
        // Only perform the move when the mouse has crossed half of the items height
        // When dragging downwards, only move when the cursor is below 50%
        // When dragging upwards, only move when the cursor is above 50%
        // Dragging downwards
        if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) return;
        // Dragging upwards
        if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) return;
        // Time to actually perform the action
        props.moveField(dragIndex, hoverIndex);
        // Note: we're mutating the monitor item here!
        // Generally it's better to avoid mutations,
        // but it's good here for the sake of performance
        // to avoid expensive index searches.
        monitor.getItem().index = hoverIndex;
    }
};
function $478d990beadcf6ef$var$MyDropTarget(dropv1, dropv2, dropfunc1) {
    return (target)=>(0, $db9eac57989e0572$exports.DropTarget)(dropv1, dropv2, dropfunc1)(target);
}
function $478d990beadcf6ef$var$MyDragSource(dragv1, dragv2, dragfunc1) {
    return (target)=>(0, $db9eac57989e0572$exports.DragSource)(dragv1, dragv2, dragfunc1)(target);
}
class $478d990beadcf6ef$var$GraphOptionsCustomizableField extends (0, $NdCUR.Component) {
    constructor(props){
        super(props);
        this.handleFieldRename = this.handleFieldRename.bind(this);
        this.handleToggleVisible = this.handleToggleVisible.bind(this);
    }
    render() {
        const { internalName: internalName, displayName: displayName, isDragging: isDragging, connectDragSource: connectDragSource, connectDragPreview: connectDragPreview, connectDropTarget: connectDropTarget, visible: visible } = this.props;
        const fieldClass = `customizable-field${isDragging ? ' dragging' : ''}`;
        const labelClass = `${visible ? 'customizable-field--label' : 'customizable-field--label__hidden'}`;
        const visibilityTitle = visible ? `Click to HIDE ${internalName}` : `Click to SHOW ${internalName}`;
        return connectDragPreview(connectDropTarget(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: fieldClass
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: labelClass
        }, connectDragSource(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "customizable-field--drag"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "hamburger"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "customizable-field--visibility",
            onClick: this.handleToggleVisible,
            title: visibilityTitle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: visible ? 'icon eye-open' : 'icon eye-closed'
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "customizable-field--name"
        }, internalName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control input-sm customizable-field--input",
            type: "text",
            spellCheck: false,
            id: "internalName",
            value: displayName,
            "data-test": "custom-time-format",
            onChange: this.handleFieldRename,
            placeholder: `Rename ${internalName}`,
            disabled: !visible
        }))));
    }
    handleFieldRename(e) {
        const { onFieldUpdate: onFieldUpdate, internalName: internalName, visible: visible } = this.props;
        onFieldUpdate({
            internalName: internalName,
            displayName: e.target.value,
            visible: visible
        });
    }
    handleToggleVisible() {
        const { onFieldUpdate: onFieldUpdate, internalName: internalName, displayName: displayName, visible: visible } = this.props;
        onFieldUpdate({
            internalName: internalName,
            displayName: displayName,
            visible: !visible
        });
    }
}
var $478d990beadcf6ef$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($478d990beadcf6ef$var$MyDropTarget($478d990beadcf6ef$var$fieldType, $478d990beadcf6ef$var$fieldTarget, (connect)=>({
        connectDropTarget: connect.dropTarget()
    }))($478d990beadcf6ef$var$MyDragSource($478d990beadcf6ef$var$fieldType, $478d990beadcf6ef$var$fieldSource, (connect, monitor)=>({
        connectDragSource: connect.dragSource(),
        connectDragPreview: connect.dragPreview(),
        isDragging: monitor.isDragging()
    }))($478d990beadcf6ef$var$GraphOptionsCustomizableField)));


class $061f68dd3ce43b54$var$GraphOptionsCustomizeFields extends (0, $NdCUR.PureComponent) {
    render() {
        const { fields: fields, onFieldUpdate: onFieldUpdate, moveField: moveField } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "graph-options-group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            className: "form-label"
        }, "Customize Fields"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null, fields.map((field, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $478d990beadcf6ef$export$2e2bcd8739ae039), {
                key: field.internalName,
                index: i,
                id: field.internalName,
                internalName: field.internalName,
                displayName: field.displayName,
                visible: field.visible,
                onFieldUpdate: onFieldUpdate,
                moveField: moveField
            }))));
    }
}
var $061f68dd3ce43b54$export$2e2bcd8739ae039 = (0, $db9eac57989e0572$exports.DragDropContext)((0, (/*@__PURE__*/$parcel$interopDefault($3d979c1ec0f4ae95$exports))))($061f68dd3ce43b54$var$GraphOptionsCustomizeFields);



var $NdCUR = parcelRequire("NdCUR");
const $845c29c3b14c9c73$var$GraphOptionsFixFirstColumn = ({ fixed: fixed, onToggleFixFirstColumn: onToggleFixFirstColumn })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "form-group col-xs-12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "form-control-static"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
        type: "checkbox",
        id: "fixFirstColumnCheckbox",
        checked: !!fixed,
        onChange: onToggleFixFirstColumn
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
        htmlFor: "fixFirstColumnCheckbox"
    }, "Lock First Column")));
var $845c29c3b14c9c73$export$2e2bcd8739ae039 = $845c29c3b14c9c73$var$GraphOptionsFixFirstColumn;



var $NdCUR = parcelRequire("NdCUR");

const $56c4030734605956$var$GraphOptionsSortBy = ({ sortByOptions: sortByOptions, onChooseSortBy: onChooseSortBy, selected: selected })=>{
    const selectedValue = selected.displayName || selected.internalName;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "form-group col-xs-6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", null, "Default Sort Field"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ca4f14339173643c$export$2e2bcd8739ae039), {
        items: sortByOptions,
        selected: selectedValue,
        buttonColor: "btn-default",
        buttonSize: "btn-sm",
        className: "dropdown-stretch",
        onChoose: onChooseSortBy
    }));
};
var $56c4030734605956$export$2e2bcd8739ae039 = $56c4030734605956$var$GraphOptionsSortBy;


// Libraries

var $NdCUR = parcelRequire("NdCUR");

const $cab89f33cc009158$var$GraphOptionsTimeAxis = ({ verticalTimeAxis: verticalTimeAxis, onToggleVerticalTimeAxis: onToggleVerticalTimeAxis })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "form-group col-xs-12 col-sm-6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", null, "Time Axis"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039), {
        shape: (0, $918c9f03a35fe03f$export$ce765fb8bb08a599).StretchToFit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039).Button, {
        id: "graph-time-axis--vertical",
        value: true,
        active: verticalTimeAxis,
        onClick: onToggleVerticalTimeAxis,
        titleText: "Position time on the vertical table axis"
    }, "Vertical"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039).Button, {
        id: "graph-time-axis--horizontal",
        value: false,
        active: !verticalTimeAxis,
        onClick: onToggleVerticalTimeAxis,
        titleText: "Position time on the horizontal table axis"
    }, "Horizontal")));
var $cab89f33cc009158$export$2e2bcd8739ae039 = $cab89f33cc009158$var$GraphOptionsTimeAxis;



var $NdCUR = parcelRequire("NdCUR");


var $NdCUR = parcelRequire("NdCUR");

const $1ca55233f3c1ef57$var$QuestionMarkTooltip = ({ tipID: tipID, tipContent: tipContent })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "question-mark-tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "question-mark-tooltip--icon",
        "data-for": `${tipID}-tooltip`,
        "data-tip": tipContent,
        "data-delay-hide": "100",
        "data-delay-show": "50"
    }, "?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $82a18451bb6f6ba0$export$2e2bcd8739ae039), {
        id: `${tipID}-tooltip`,
        effect: "solid",
        html: true,
        place: "bottom",
        class: "influx-tooltip"
    }));
var $1ca55233f3c1ef57$export$2e2bcd8739ae039 = $1ca55233f3c1ef57$var$QuestionMarkTooltip;




class $d48bba10e3bf954a$var$GraphOptionsTimeFormat extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleChangeFormat = (e)=>{
            const format = e.target.value;
            this.onTimeFormatChange(format);
            this.setState({
                format: format
            });
        }, this.handleChooseFormat = (format)=>{
            if (format === (0, $9a9ec629fdd38845$export$158214ea299486a9)) this.setState({
                customFormat: true
            });
            else {
                this.onTimeFormatChange(format);
                this.setState({
                    format: format,
                    customFormat: false
                });
            }
        };
        this.state = {
            customFormat: false,
            format: this.props.timeFormat || (0, $9a9ec629fdd38845$export$c4d2eaadfa3c28df)
        };
    }
    get onTimeFormatChange() {
        return this.props.onTimeFormatChange;
    }
    render() {
        const { format: format, customFormat: customFormat } = this.state;
        const tipContent = `For information on formatting, see <br/><a href="#">${(0, $9a9ec629fdd38845$export$b5e5479e319061b6)}</a>`;
        const formatOption = (0, $9a9ec629fdd38845$export$da35197b3e8f20d0).find((op)=>op.format === format);
        const showCustom = !formatOption || customFormat;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", null, "Time Format", showCustom && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("a", {
            href: (0, $9a9ec629fdd38845$export$b5e5479e319061b6),
            target: "_blank"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1ca55233f3c1ef57$export$2e2bcd8739ae039), {
            tipID: "Time Axis Format",
            tipContent: tipContent
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $f040dbec7e8f99c8$export$2e2bcd8739ae039), {
            selectedID: showCustom ? (0, $9a9ec629fdd38845$export$158214ea299486a9) : format,
            onChange: this.handleChooseFormat,
            customClass: "dropdown-stretch"
        }, (0, $9a9ec629fdd38845$export$da35197b3e8f20d0).map(({ text: text, format: optionFormat })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $f040dbec7e8f99c8$export$2e2bcd8739ae039).Item, {
                key: optionFormat,
                id: optionFormat,
                value: optionFormat
            }, text ? text : optionFormat))), showCustom && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            type: "text",
            spellCheck: false,
            placeholder: "Enter custom format...",
            value: format,
            "data-test": "custom-time-format",
            className: "form-control input-sm custom-time-format",
            onChange: this.handleChangeFormat
        }));
    }
}
var $d48bba10e3bf954a$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($d48bba10e3bf954a$var$GraphOptionsTimeFormat);








class $4cd5c7d69a80853b$var$TableOptions extends (0, $NdCUR.Component) {
    constructor(props){
        super(props), this.handleChooseSortBy = (option)=>{
            const { tableOptions: tableOptions, onUpdateTableOptions: onUpdateTableOptions, fieldOptions: fieldOptions } = this.props;
            const sortBy = fieldOptions.find((f)=>f.internalName === option.key);
            onUpdateTableOptions({
                ...tableOptions,
                sortBy: sortBy
            });
        }, this.handleTimeFormatChange = (timeFormat)=>{
            const { onUpdateTimeFormat: onUpdateTimeFormat } = this.props;
            onUpdateTimeFormat(timeFormat);
        }, this.handleDecimalPlacesChange = (decimalPlaces)=>{
            const { onUpdateDecimalPlaces: onUpdateDecimalPlaces } = this.props;
            onUpdateDecimalPlaces(decimalPlaces);
        }, this.handleToggleVerticalTimeAxis = (verticalTimeAxis)=>{
            const { tableOptions: tableOptions, onUpdateTableOptions: onUpdateTableOptions } = this.props;
            onUpdateTableOptions({
                ...tableOptions,
                verticalTimeAxis: verticalTimeAxis
            });
        }, this.handleToggleFixFirstColumn = ()=>{
            const { onUpdateTableOptions: onUpdateTableOptions, tableOptions: tableOptions } = this.props;
            const fixFirstColumn = !tableOptions.fixFirstColumn;
            onUpdateTableOptions({
                ...tableOptions,
                fixFirstColumn: fixFirstColumn
            });
        }, this.handleFieldUpdate = (field)=>{
            const { onUpdateTableOptions: onUpdateTableOptions, onUpdateFieldOptions: onUpdateFieldOptions, tableOptions: tableOptions, fieldOptions: fieldOptions } = this.props;
            const { sortBy: sortBy } = tableOptions;
            const updatedFieldOptions = fieldOptions.map((f)=>f.internalName === field.internalName ? field : f);
            if (sortBy.internalName === field.internalName) {
                const updatedSortBy = {
                    ...sortBy,
                    displayName: field.displayName
                };
                onUpdateTableOptions({
                    ...tableOptions,
                    sortBy: updatedSortBy
                });
            }
            onUpdateFieldOptions(updatedFieldOptions);
        };
        this.moveField = this.moveField.bind(this);
    }
    render() {
        const { tableOptions: { verticalTimeAxis: verticalTimeAxis, fixFirstColumn: fixFirstColumn }, fieldOptions: fieldOptions, timeFormat: timeFormat, onResetFocus: onResetFocus, tableOptions: tableOptions, decimalPlaces: decimalPlaces, onUpdateThresholdsListColors: onUpdateThresholdsListColors, thresholdsListType: thresholdsListType, thresholdsListColors: thresholdsListColors, onUpdateThresholdsListType: onUpdateThresholdsListType } = this.props;
        const tableSortByOptions = fieldOptions.map((field)=>({
                key: field.internalName,
                text: field.displayName || field.internalName
            }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), {
            className: "display-options",
            autoHide: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "display-options--wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h5", {
            className: "display-options--header"
        }, "Table Controls"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $56c4030734605956$export$2e2bcd8739ae039), {
            selected: tableOptions.sortBy || (0, $9a9ec629fdd38845$export$af0d6a692d995875),
            sortByOptions: tableSortByOptions,
            onChooseSortBy: this.handleChooseSortBy
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $10b110c1051f2fb8$export$2e2bcd8739ae039), {
            digits: decimalPlaces.digits,
            isEnforced: decimalPlaces.isEnforced,
            onDecimalPlacesChange: this.handleDecimalPlacesChange
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $cab89f33cc009158$export$2e2bcd8739ae039), {
            verticalTimeAxis: verticalTimeAxis,
            onToggleVerticalTimeAxis: this.handleToggleVerticalTimeAxis
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $d48bba10e3bf954a$export$2e2bcd8739ae039), {
            timeFormat: timeFormat,
            onTimeFormatChange: this.handleTimeFormatChange
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $845c29c3b14c9c73$export$2e2bcd8739ae039), {
            fixed: fixFirstColumn,
            onToggleFixFirstColumn: this.handleToggleFixFirstColumn
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $061f68dd3ce43b54$export$2e2bcd8739ae039), {
            fields: fieldOptions,
            onFieldUpdate: this.handleFieldUpdate,
            moveField: this.moveField
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $64a4459bb2082149$export$2e2bcd8739ae039), {
            showListHeading: true,
            onResetFocus: onResetFocus,
            thresholdsListType: thresholdsListType,
            thresholdsListColors: thresholdsListColors,
            onUpdateThresholdsListColors: onUpdateThresholdsListColors
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group-wrapper graph-options-group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $979fcf825228ddba$export$2e2bcd8739ae039), {
            containerClass: "form-group col-xs-6",
            thresholdsListType: thresholdsListType,
            onUpdateThresholdsListType: onUpdateThresholdsListType
        }))));
    }
    moveField(dragIndex, hoverIndex) {
        const { onUpdateFieldOptions: onUpdateFieldOptions, fieldOptions: fieldOptions } = this.props;
        const draggedField = fieldOptions[dragIndex];
        const fieldOptionsRemoved = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).concat((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).slice(fieldOptions, 0, dragIndex), (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).slice(fieldOptions, dragIndex + 1));
        const fieldOptionsAdded = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).concat((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).slice(fieldOptionsRemoved, 0, hoverIndex), [
            draggedField
        ], (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).slice(fieldOptionsRemoved, hoverIndex));
        onUpdateFieldOptions(fieldOptionsAdded);
    }
}
var $4cd5c7d69a80853b$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($4cd5c7d69a80853b$var$TableOptions);



var $NdCUR = parcelRequire("NdCUR");
const $d0acfb96d2f8b0e1$var$NoteOptions = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "note-options---panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "note-options--text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, "This cell type displays the cell's note contents", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("br", null), "Use the ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("strong", null, "Add a Note"), " panel to customize")));
var $d0acfb96d2f8b0e1$export$2e2bcd8739ae039 = $d0acfb96d2f8b0e1$var$NoteOptions;


// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");






class $f62e6a7e497bee6b$var$CellNoteEditor extends (0, $NdCUR.Component) {
    constructor(props){
        super(props), this.handleSlideToggle = ()=>{
            const { noteVisibility: noteVisibility, onUpdateNoteVisibility: onUpdateNoteVisibility } = this.props;
            if (noteVisibility === (0, $b4506126e09430df$export$2c5a562a272706f8).Default) onUpdateNoteVisibility((0, $b4506126e09430df$export$2c5a562a272706f8).ShowWhenNoData);
            else onUpdateNoteVisibility((0, $b4506126e09430df$export$2c5a562a272706f8).Default);
        }, this.handleFocus = ()=>{
            this.setState({
                editorIsFocused: true
            });
        }, this.handleBlur = ()=>{
            const { onUpdateNote: onUpdateNote } = this.props;
            const { noteDraft: noteDraft } = this.state;
            this.setState({
                editorIsFocused: false
            });
            onUpdateNote(noteDraft);
        }, this.onTouchStart = ()=>{}, this.handleChange = (_, __, note)=>{
            this.setState({
                noteDraft: note
            });
        };
        this.state = {
            noteDraft: props.note || '',
            editorIsFocused: false
        };
    }
    render() {
        const { noteVisibility: noteVisibility } = this.props;
        const { noteDraft: noteDraft } = this.state;
        const options = {
            tabIndex: 1,
            mode: 'markdown',
            readonly: false,
            lineNumbers: false,
            autoRefresh: true,
            theme: 'markdown',
            completeSingle: false,
            lineWrapping: true,
            placeholder: 'Notes are a great way to help others on your team use dashboards more effectively.\nYou can also talk to your future self!\n\nWhy not add a note?'
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), {
            className: "cell-note-editor--container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "cell-note-editor"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-control-static cell-note-editor--display-option"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $4115c6d17e8dc56b$export$2e2bcd8739ae039), {
            size: (0, $918c9f03a35fe03f$export$fafce5c139da9687).ExtraSmall,
            onChange: this.handleSlideToggle,
            active: noteVisibility === (0, $b4506126e09430df$export$2c5a562a272706f8).ShowWhenNoData
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", null, "Display note in cell when query returns no results")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "cell-note-editor--header"
        }, "Markdown is supported"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.fieldClassName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b1cb9a1ab496dfeb$exports.Controlled), {
            autoCursor: true,
            value: (0, $8450edce046a69e2$export$11d70625c9cbd359)(noteDraft),
            options: options,
            onBeforeChange: this.handleChange,
            onTouchStart: this.onTouchStart,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur
        }))));
    }
    get fieldClassName() {
        const { editorIsFocused: editorIsFocused } = this.state;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('cell-note-editor--field', {
            focus: editorIsFocused
        });
    }
}
var $f62e6a7e497bee6b$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($f62e6a7e497bee6b$var$CellNoteEditor);









class $8c579bbea77c7b68$var$DisplayOptions extends (0, $NdCUR.Component) {
    constructor(props){
        super(props), this.handleResize = (proportions)=>{
            this.setState({
                proportions: proportions
            });
        }, this.renderOptions = ()=>{
            const { type: type, decimalPlaces: decimalPlaces, lineColors: lineColors, gaugeColors: gaugeColors, staticLegend: staticLegend, onToggleStaticLegend: onToggleStaticLegend, onResetFocus: onResetFocus, queryConfigs: queryConfigs, thresholdsListType: thresholdsListType, thresholdsListColors: thresholdsListColors, timeFormat: timeFormat, tableOptions: tableOptions, fieldOptions: fieldOptions, onUpdateAxes: onUpdateAxes, onUpdateDecimalPlaces: onUpdateDecimalPlaces, onUpdateGaugeColors: onUpdateGaugeColors, onUpdateThresholdsListColors: onUpdateThresholdsListColors, onUpdateThresholdsListType: onUpdateThresholdsListType, onUpdateFieldOptions: onUpdateFieldOptions, onUpdateLineColors: onUpdateLineColors, onUpdateTableOptions: onUpdateTableOptions, onUpdateTimeFormat: onUpdateTimeFormat } = this.props;
            const { defaultYLabel: defaultYLabel } = this.state;
            switch(type){
                case (0, $b4506126e09430df$export$705e36171f4cbbfe).Gauge:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $9cb4a18217166637$export$2e2bcd8739ae039), {
                        onResetFocus: onResetFocus,
                        axes: this.axes,
                        decimalPlaces: decimalPlaces,
                        gaugeColors: gaugeColors,
                        onUpdateAxes: onUpdateAxes,
                        onUpdateDecimalPlaces: onUpdateDecimalPlaces,
                        onUpdateGaugeColors: onUpdateGaugeColors
                    });
                case (0, $b4506126e09430df$export$705e36171f4cbbfe).Note:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $d0acfb96d2f8b0e1$export$2e2bcd8739ae039), null);
                case (0, $b4506126e09430df$export$705e36171f4cbbfe).SingleStat:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $493de12400449f4d$export$2e2bcd8739ae039), {
                        onResetFocus: onResetFocus,
                        axes: this.axes,
                        decimalPlaces: decimalPlaces,
                        onUpdateAxes: onUpdateAxes,
                        thresholdsListType: thresholdsListType,
                        thresholdsListColors: thresholdsListColors,
                        onUpdateDecimalPlaces: onUpdateDecimalPlaces,
                        onUpdateThresholdsListType: onUpdateThresholdsListType,
                        onUpdateThresholdsListColors: onUpdateThresholdsListColors
                    });
                case (0, $b4506126e09430df$export$705e36171f4cbbfe).Table:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $4cd5c7d69a80853b$export$2e2bcd8739ae039), {
                        onResetFocus: onResetFocus,
                        queryConfigs: queryConfigs,
                        timeFormat: timeFormat,
                        tableOptions: tableOptions,
                        fieldOptions: fieldOptions,
                        decimalPlaces: decimalPlaces,
                        thresholdsListType: thresholdsListType,
                        thresholdsListColors: thresholdsListColors,
                        onUpdateDecimalPlaces: onUpdateDecimalPlaces,
                        onUpdateFieldOptions: onUpdateFieldOptions,
                        onUpdateTableOptions: onUpdateTableOptions,
                        onUpdateTimeFormat: onUpdateTimeFormat,
                        onUpdateThresholdsListColors: onUpdateThresholdsListColors,
                        onUpdateThresholdsListType: onUpdateThresholdsListType
                    });
                default:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $9cbbb77c7ba00ca7$export$2e2bcd8739ae039), {
                        axes: this.axes,
                        type: type,
                        lineColors: lineColors,
                        staticLegend: staticLegend,
                        defaultYLabel: defaultYLabel,
                        decimalPlaces: decimalPlaces,
                        onUpdateAxes: onUpdateAxes,
                        onToggleStaticLegend: onToggleStaticLegend,
                        onUpdateLineColors: onUpdateLineColors,
                        onUpdateDecimalPlaces: onUpdateDecimalPlaces
                    });
            }
        };
        this.state = {
            defaultYLabel: this.defaultYLabel,
            proportions: [
                undefined,
                undefined,
                undefined
            ]
        };
    }
    componentDidUpdate(prevProps) {
        const { queryConfigs: queryConfigs } = prevProps;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEqual(queryConfigs[0], this.props.queryConfigs[0])) this.setState({
            defaultYLabel: this.defaultYLabel
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $71205b63ef953f49$export$2e2bcd8739ae039), {
            orientation: (0, $e10a8602f56394e3$export$13b6d0f939932bf6),
            divisions: this.threesizerDivisions,
            onResize: this.handleResize
        });
    }
    get threesizerDivisions() {
        const { type: type, note: note, noteVisibility: noteVisibility, onUpdateType: onUpdateType, onUpdateNote: onUpdateNote, onUpdateNoteVisibility: onUpdateNoteVisibility } = this.props;
        const { proportions: proportions } = this.state;
        const [leftSize, middleSize, rightSize] = proportions;
        return [
            {
                name: 'Visualization Type',
                headerButtons: [],
                menuOptions: [],
                size: leftSize,
                render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $478edc63805402e8$export$2e2bcd8739ae039), {
                        type: type,
                        onUpdateVisType: onUpdateType
                    }),
                headerOrientation: (0, $e10a8602f56394e3$export$13b6d0f939932bf6)
            },
            {
                name: 'Customize',
                headerButtons: [],
                menuOptions: [],
                size: middleSize,
                render: this.renderOptions,
                headerOrientation: (0, $e10a8602f56394e3$export$13b6d0f939932bf6)
            },
            {
                name: 'Add a Note',
                headerButtons: [],
                menuOptions: [],
                size: rightSize,
                render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $f62e6a7e497bee6b$export$2e2bcd8739ae039), {
                        note: note || '',
                        noteVisibility: noteVisibility,
                        onUpdateNote: onUpdateNote,
                        onUpdateNoteVisibility: onUpdateNoteVisibility
                    }),
                headerOrientation: (0, $e10a8602f56394e3$export$13b6d0f939932bf6)
            }
        ];
    }
    get axes() {
        return this.props.axes || (0, $727a6ab7dfc948a3$export$c0dadf556788a63f);
    }
    get defaultYLabel() {
        const { queryConfigs: queryConfigs } = this.props;
        if (queryConfigs.length) return (0, $2b35f344ea99f322$export$84fdfe841cd5b241)(queryConfigs[0]);
        return '';
    }
}
const $8c579bbea77c7b68$var$DisplayOptions2 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($8c579bbea77c7b68$var$DisplayOptions);
const $8c579bbea77c7b68$var$ConnectedDisplayOptions = (props)=>{
    // TODO: Have individual display option components subscribe directly to
    // relevant props, rather than passing them through here
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b029b3af5fc2e5d5$export$7d87f8b720f7653e), null, (timeMachineContainer)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($8c579bbea77c7b68$var$DisplayOptions2, {
            ...props,
            type: timeMachineContainer.state.type,
            axes: timeMachineContainer.state.axes,
            tableOptions: timeMachineContainer.state.tableOptions,
            fieldOptions: timeMachineContainer.state.fieldOptions,
            timeFormat: timeMachineContainer.state.timeFormat,
            decimalPlaces: timeMachineContainer.state.decimalPlaces,
            note: timeMachineContainer.state.note,
            noteVisibility: timeMachineContainer.state.noteVisibility,
            thresholdsListColors: timeMachineContainer.state.thresholdsListColors,
            thresholdsListType: timeMachineContainer.state.thresholdsListType,
            gaugeColors: timeMachineContainer.state.gaugeColors,
            lineColors: timeMachineContainer.state.lineColors,
            onUpdateType: timeMachineContainer.handleUpdateType,
            onUpdateAxes: timeMachineContainer.handleUpdateAxes,
            onUpdateTableOptions: timeMachineContainer.handleUpdateTableOptions,
            onUpdateFieldOptions: timeMachineContainer.handleUpdateFieldOptions,
            onUpdateTimeFormat: timeMachineContainer.handleUpdateTimeFormat,
            onUpdateDecimalPlaces: timeMachineContainer.handleUpdateDecimalPlaces,
            onUpdateNote: timeMachineContainer.handleUpdateNote,
            onUpdateNoteVisibility: timeMachineContainer.handleUpdateNoteVisibility,
            onUpdateThresholdsListColors: timeMachineContainer.handleUpdateThresholdsListColors,
            onUpdateThresholdsListType: timeMachineContainer.handleUpdateThresholdsListType,
            onUpdateGaugeColors: timeMachineContainer.handleUpdateGaugeColors,
            onUpdateLineColors: timeMachineContainer.handleUpdateLineColors
        }));
};
var $8c579bbea77c7b68$export$2e2bcd8739ae039 = $8c579bbea77c7b68$var$ConnectedDisplayOptions;



var $NdCUR = parcelRequire("NdCUR");
const $ff707b0eec354c12$var$TimeMachineBottom = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "deceo--bottom"
    }, children);
var $ff707b0eec354c12$export$2e2bcd8739ae039 = $ff707b0eec354c12$var$TimeMachineBottom;


// Libraries

var $NdCUR = parcelRequire("NdCUR");
// Libraries

var $NdCUR = parcelRequire("NdCUR");
// Libraries

var $NdCUR = parcelRequire("NdCUR");

const $682f08314e650e04$export$b1608e4822eb69b2 = 'The minimum Role a user must have<br />in order to access this source.';
const $682f08314e650e04$export$c21a3cc87aee594d = '<p>Kapacitor Connections are<br/>scoped per InfluxDB Connection.<br/>Only one can be active at a time.</p>';
var $682f08314e650e04$export$efb380429f847dce = /*#__PURE__*/ function(DynamicSource) {
    DynamicSource["name"] = "Dynamic Source";
    DynamicSource["id"] = "dynamic";
    return DynamicSource;
}({});


class $daaa6355868bebe1$var$SourceDropdown extends (0, $NdCUR.PureComponent) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $f040dbec7e8f99c8$export$2e2bcd8739ae039), {
            onChange: this.handleSelect,
            selectedID: this.selectedID,
            widthPixels: this.props.widthPixels,
            zIndex: this.props.zIndex
        }, this.dropdownItems);
    }
    get dropdownItems() {
        const { sources: sources, allowDynamicSource: allowDynamicSource } = this.props;
        const sourceOptions = sources.map((source)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $f040dbec7e8f99c8$export$2e2bcd8739ae039).Item, {
                key: source.id,
                id: source.id,
                value: this.sourceDropdownItemValue(source)
            }, source.name));
        if (allowDynamicSource) {
            sourceOptions.push(this.dynamicSourceOption);
            return sourceOptions;
        }
        return sourceOptions;
    }
    get dynamicSourceOption() {
        const dynamicSourceDropdownItem = {
            sourceID: (0, $682f08314e650e04$export$efb380429f847dce).id
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $f040dbec7e8f99c8$export$2e2bcd8739ae039).Item, {
            key: (0, $682f08314e650e04$export$efb380429f847dce).id,
            id: (0, $682f08314e650e04$export$efb380429f847dce).id,
            value: dynamicSourceDropdownItem
        }, (0, $682f08314e650e04$export$efb380429f847dce).name);
    }
    sourceDropdownItemValue(source) {
        return {
            sourceID: source.id,
            links: source.links
        };
    }
    get selectedID() {
        const { source: source, allowDynamicSource: allowDynamicSource, isDynamicSourceSelected: isDynamicSourceSelected } = this.props;
        if (allowDynamicSource && isDynamicSourceSelected) return (0, $682f08314e650e04$export$efb380429f847dce).id;
        return source.id;
    }
    constructor(...args){
        super(...args), this.handleSelect = (choice)=>{
            const { sources: sources, onChangeSource: onChangeSource, onSelectDynamicSource: onSelectDynamicSource, type: type } = this.props;
            if (choice.sourceID === (0, $682f08314e650e04$export$efb380429f847dce).id && onSelectDynamicSource) {
                onSelectDynamicSource();
                return;
            }
            const source = sources.find((src)=>{
                return src.id === choice.sourceID;
            });
            onChangeSource(source, type);
        };
    }
}
var $daaa6355868bebe1$export$2e2bcd8739ae039 = $daaa6355868bebe1$var$SourceDropdown;





function $2a4acd705f23b142$var$fluxDisabledTooltip(source) {
    // if source is version 2, recommend InfluxDB v2 authentication
    if (!source.version || source.version.startsWith('2.')) return 'To enable Flux modify the connection to use InfluxDB v2 Auth with an organization and a token.';
    return `The current source does not support Flux.<br>
  See <a href="https://docs.influxdata.com/influxdb/v1.8/flux/installation/" 
  target="_blank">https://docs.influxdata.com/influxdb/v1.8/flux/installation/</a>`;
}
const $2a4acd705f23b142$var$SourceSelector = ({ source: source, sources: sources = [], queries: queries, toggleFlux: toggleFlux, isFluxSelected: isFluxSelected, onChangeSource: onChangeSource, sourceSupportsFlux: sourceSupportsFlux, isDynamicSourceSelected: isDynamicSourceSelected, onSelectDynamicSource: onSelectDynamicSource })=>{
    if (!sources.length || !queries.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "source-selector"
    });
    const type = isFluxSelected ? (0, $b4506126e09430df$export$7c8e26efb80b90e8).Flux : (0, $b4506126e09430df$export$7c8e26efb80b90e8).InfluxQL;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "source-selector",
        "data-test": "source-button-selector"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $daaa6355868bebe1$export$2e2bcd8739ae039), {
        source: source,
        type: type,
        sources: sources,
        allowDynamicSource: true,
        isDynamicSourceSelected: isDynamicSourceSelected,
        onChangeSource: onChangeSource,
        onSelectDynamicSource: onSelectDynamicSource,
        widthPixels: 250
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039).Button, {
        id: "influxql-source",
        titleText: "InfluxQL",
        value: (0, $b4506126e09430df$export$7c8e26efb80b90e8).InfluxQL,
        onClick: toggleFlux,
        active: !isFluxSelected,
        disabled: !sourceSupportsFlux,
        disabledTitleText: ""
    }, "InfluxQL"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039).Button, {
        id: "flux-source",
        titleText: "Flux",
        value: (0, $b4506126e09430df$export$7c8e26efb80b90e8).Flux,
        onClick: toggleFlux,
        active: isFluxSelected,
        disabled: !sourceSupportsFlux
    }, "Flux")), !sourceSupportsFlux && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1ca55233f3c1ef57$export$2e2bcd8739ae039), {
        tipID: "token",
        tipContent: `<p>${$2a4acd705f23b142$var$fluxDisabledTooltip(source)}</p>`
    }));
};
var $2a4acd705f23b142$export$2e2bcd8739ae039 = $2a4acd705f23b142$var$SourceSelector;




var $NdCUR = parcelRequire("NdCUR");





class $c7ed2d6aa5bc7a19$var$CSVExporter extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleClick = async ()=>{
            const { isFluxSelected: isFluxSelected, onNotify: onNotify } = this.props;
            this.setState({
                buttonStatus: (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Loading
            });
            try {
                if (isFluxSelected) await this.downloadFluxCSV();
                else await this.downloadInfluxQLCSV();
            } catch  {
                onNotify((0, $ec1f42de4faacc37$export$3b05be0df6912e3d));
            }
            this.setState({
                buttonStatus: (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Default
            });
        }, this.downloadInfluxQLCSV = ()=>{
            const { queries: queries, templates: templates, timeZone: timeZone } = this.props;
            return (0, $e67c1d5c385472c9$export$5806e7ef9ca71a9d)(queries, templates, timeZone);
        }, this.downloadFluxCSV = async ()=>{
            const { source: source, script: script, onNotify: onNotify, timeRange: timeRange, fluxASTLink: fluxASTLink, templates: templates } = this.props;
            const { didTruncate: didTruncate, rowCount: rowCount } = await (0, $e67c1d5c385472c9$export$6118cfcaa4df65e9)(source, script, timeRange, templates, fluxASTLink);
            if (didTruncate) onNotify((0, $ec1f42de4faacc37$export$33d9dc671f47d2f6)(rowCount));
            return;
        };
        this.state = {
            buttonStatus: (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Default
        };
    }
    render() {
        const { buttonStatus: buttonStatus } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
            customClass: "csv-export",
            text: "CSV",
            icon: (0, $918c9f03a35fe03f$export$62c9c0cf752cde38).Download,
            status: buttonStatus,
            onClick: this.handleClick
        });
    }
}
const $c7ed2d6aa5bc7a19$var$mstp = (state)=>({
        fluxASTLink: state.links.flux.ast,
        timeZone: state.app.persisted.timeZone
    });
const $c7ed2d6aa5bc7a19$var$mdtp = {
    onNotify: (0, $205d139de2918454$export$5e14cdade93d6f7b)
};
var $c7ed2d6aa5bc7a19$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($c7ed2d6aa5bc7a19$var$mstp, $c7ed2d6aa5bc7a19$var$mdtp)($c7ed2d6aa5bc7a19$var$CSVExporter);





var $hBdgJ = parcelRequire("hBdgJ");



const $88fea4b168b314ad$var$buildQueries = (queryConfigs, tR)=>{
    if (!queryConfigs) return [];
    const statements = queryConfigs.map((query)=>{
        const { rawText: rawText, range: range, id: id, shifts: shifts, database: database, measurement: measurement, fields: fields } = query;
        const timeRange = range || tR;
        const text = rawText || (0, $7b2c5b24a44a7fa2$export$d7b58f10109feb02)((0, $9a9ec629fdd38845$export$797ae35c568d4e70), timeRange, query);
        const isParsable = !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEmpty(database) && !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEmpty(measurement) && fields.length > 0;
        if (shifts && shifts.length && isParsable) {
            const shiftedQueries = shifts.filter((s)=>s.unit).map((s)=>(0, $7b2c5b24a44a7fa2$export$d7b58f10109feb02)((0, $9a9ec629fdd38845$export$dcffce4823e82712), timeRange, query, s));
            return {
                text: `${text};${shiftedQueries.join(';')}`,
                id: id,
                queryConfig: query
            };
        }
        return {
            text: text,
            id: id,
            queryConfig: query
        };
    });
    const queries = statements.filter((s)=>s.text !== null).map(({ queryConfig: queryConfig, text: text, id: id })=>{
        return {
            text: text,
            id: id,
            queryConfig: queryConfig,
            type: (0, $b4506126e09430df$export$7c8e26efb80b90e8).InfluxQL
        };
    });
    return queries;
};
var $88fea4b168b314ad$export$2e2bcd8739ae039 = $88fea4b168b314ad$var$buildQueries;


const $3b680e0d9e258850$var$TimeMachineControls = ({ script: script, source: source, sources: sources, queries: queries, templates: templates, timeRange: timeRange, toggleFlux: toggleFlux, isFluxSelected: isFluxSelected, isViewingRawData: isViewingRawData, autoRefreshDuration: autoRefreshDuration, onChangeAutoRefreshDuration: onChangeAutoRefreshDuration, onManualRefresh: onManualRefresh, onChangeSource: onChangeSource, sourceSupportsFlux: sourceSupportsFlux, onSelectDynamicSource: onSelectDynamicSource, toggleIsViewingRawData: toggleIsViewingRawData, isDynamicSourceSelected: isDynamicSourceSelected, updateEditorTimeRange: updateEditorTimeRange })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "deceo--controls"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $2a4acd705f23b142$export$2e2bcd8739ae039), {
        source: source,
        sources: sources,
        queries: queries,
        toggleFlux: toggleFlux,
        sourceSupportsFlux: sourceSupportsFlux,
        isFluxSelected: isFluxSelected,
        onChangeSource: onChangeSource,
        isDynamicSourceSelected: isDynamicSourceSelected,
        onSelectDynamicSource: onSelectDynamicSource
    }), isFluxSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "time-machine-vis--raw-toggle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $4115c6d17e8dc56b$export$2e2bcd8739ae039), {
        active: isViewingRawData,
        onChange: toggleIsViewingRawData,
        size: (0, $918c9f03a35fe03f$export$fafce5c139da9687).ExtraSmall
    }), "View Raw Data"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c7ed2d6aa5bc7a19$export$2e2bcd8739ae039), {
        script: script,
        source: source,
        isFluxSelected: isFluxSelected,
        queries: (0, $88fea4b168b314ad$export$2e2bcd8739ae039)(queries, timeRange),
        templates: templates,
        timeRange: timeRange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $e6a8d4614c25ddf0$export$2e2bcd8739ae039), {
        selected: autoRefreshDuration,
        onChoose: onChangeAutoRefreshDuration,
        onManualRefresh: onManualRefresh,
        showManualRefresh: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $80cff9834e653b0a$export$2e2bcd8739ae039), {
        onChooseTimeRange: updateEditorTimeRange,
        selected: timeRange
    }));
};
var $3b680e0d9e258850$export$2e2bcd8739ae039 = $3b680e0d9e258850$var$TimeMachineControls;



var $NdCUR = parcelRequire("NdCUR");



const $6636068b2dc4465d$var$TimeMachineVisualization = (props)=>{
    const colors = (0, $727a6ab7dfc948a3$export$be1e3eb56b1b752d)({
        cellType: props.type,
        gaugeColors: props.gaugeColors,
        thresholdsListColors: props.thresholdsListColors,
        lineColors: props.lineColors
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "deceo--top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "deceo--visualization"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "graph-container",
        "data-test": "graph-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dc81def588caa8ef$export$2e2bcd8739ae039), {
        source: props.source,
        colors: colors,
        queryType: props.queryType,
        autoRefresher: props.autoRefresher,
        queries: props.queries,
        templates: props.templates,
        editQueryStatus: props.onEditQueryStatus,
        staticLegend: props.staticLegend,
        timeRange: props.timeRange,
        manualRefresh: props.manualRefresh,
        editorLocation: props.editorLocation,
        showRawFluxData: props.showRawFluxData,
        type: props.type,
        axes: props.axes,
        tableOptions: props.tableOptions,
        fieldOptions: props.fieldOptions,
        timeFormat: props.timeFormat,
        decimalPlaces: props.decimalPlaces,
        cellNote: props.note,
        cellNoteVisibility: props.noteVisibility,
        onUpdateFieldOptions: props.onUpdateFieldOptions,
        onUpdateVisType: props.onUpdateVisType
    }))));
};
const $6636068b2dc4465d$var$ConnectedTimeMachineVisualization = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b029b3af5fc2e5d5$export$7d87f8b720f7653e), null, (container)=>{
        const { state: state } = container;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($6636068b2dc4465d$var$TimeMachineVisualization, {
            ...props,
            timeRange: state.timeRange,
            type: state.type,
            axes: state.axes,
            queryType: state.queryType,
            tableOptions: state.tableOptions,
            fieldOptions: state.fieldOptions,
            timeFormat: state.timeFormat,
            decimalPlaces: state.decimalPlaces,
            thresholdsListColors: state.thresholdsListColors,
            thresholdsListType: state.thresholdsListType,
            gaugeColors: state.gaugeColors,
            lineColors: state.lineColors,
            note: state.note,
            noteVisibility: state.noteVisibility,
            onUpdateFieldOptions: container.handleUpdateFieldOptions,
            onUpdateVisType: container.handleUpdateType
        });
    });
var $6636068b2dc4465d$export$2e2bcd8739ae039 = $6636068b2dc4465d$var$ConnectedTimeMachineVisualization;


// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $NdCUR = parcelRequire("NdCUR");


class $0b6b6176a30515ab$var$SchemaExplorer extends (0, $NdCUR.PureComponent) {
    render() {
        const { source: source, timeRange: timeRange, notify: notify } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-schema-explorer"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $4342653b815ad7ef$export$2e2bcd8739ae039), {
            source: source,
            timeRange: timeRange,
            notify: notify
        })));
    }
}
var $0b6b6176a30515ab$export$2e2bcd8739ae039 = $0b6b6176a30515ab$var$SchemaExplorer;


// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");

var $NdCUR = parcelRequire("NdCUR");


const $346dfb5d1aff5c20$export$6e48ebf5f0972073 = new Set([
    'ArrowRight',
    'ArrowLeft',
    'ArrowDown',
    'ArrowUp',
    'Backspace',
    'Tab',
    'Enter',
    'Shift',
    'Ctrl',
    'Control',
    'Alt',
    'Pause',
    'Capslock',
    'Escape',
    'Pageup',
    'Pagedown',
    'End',
    'Home',
    'Left',
    'Up',
    'Right',
    'Down',
    'Insert',
    'Delete',
    'Left window key',
    'Right window key',
    'Select',
    'Add',
    'Subtract',
    'Decimal point',
    'Divide',
    '>',
    '|',
    ')',
    'F1',
    'F2',
    'F3',
    'F4',
    'F5',
    'F6',
    'F7',
    'F8',
    'F9',
    'F10',
    'F11',
    'F12',
    'Numlock',
    'Scrolllock',
    'Semicolon',
    'Equalsign',
    'Comma',
    'Dash',
    'Slash',
    'Graveaccent',
    'Backslash',
    'Quote',
    'Meta',
    ' '
]);
const $346dfb5d1aff5c20$var$V_OBJECT_SUGGESTIONS = [
    {
        text: 'timeRangeStart',
        displayText: 'timeRangeStart'
    },
    {
        text: 'timeRangeStop',
        displayText: 'timeRangeStop'
    },
    {
        text: 'windowPeriod',
        displayText: 'windowPeriod'
    }
];
const $346dfb5d1aff5c20$export$cb01122796bc0228 = (editor, allSuggestions)=>{
    const cursor = editor.getDoc().getCursor();
    const currentLineNumber = cursor.line;
    const currentLineText = editor.getDoc().getLine(cursor.line);
    const cursorPosition = cursor.ch;
    const { start: start, end: end, suggestions: suggestions } = $346dfb5d1aff5c20$export$e993528da10f68f(currentLineText, cursorPosition, allSuggestions);
    return {
        from: {
            line: currentLineNumber,
            ch: start
        },
        to: {
            line: currentLineNumber,
            ch: end
        },
        list: suggestions
    };
};
const $346dfb5d1aff5c20$export$e993528da10f68f = (currentLineText, cursorPosition, allSuggestions)=>{
    if ($346dfb5d1aff5c20$var$shouldCompleteParam(currentLineText, cursorPosition)) return $346dfb5d1aff5c20$export$d685777a25796b36(currentLineText, cursorPosition, allSuggestions);
    if ($346dfb5d1aff5c20$var$shouldCompleteFunction(currentLineText, cursorPosition)) return $346dfb5d1aff5c20$export$9337244e12af9f8f(currentLineText, cursorPosition, allSuggestions);
    if ($346dfb5d1aff5c20$var$shouldCompleteVObject(currentLineText, cursorPosition)) return {
        start: cursorPosition,
        end: cursorPosition,
        suggestions: $346dfb5d1aff5c20$var$V_OBJECT_SUGGESTIONS
    };
    return {
        start: -1,
        end: -1,
        suggestions: []
    };
};
const $346dfb5d1aff5c20$var$shouldCompleteFunction = (currentLineText, cursorPosition)=>{
    const startOfFunc = '(';
    const endOfFunc = ')';
    const endOfParamKey = ':';
    const endOfParam = ',';
    const pipe = '|>';
    let i = cursorPosition;
    // First travel left; the first special characters we should see are from a pipe
    while(i){
        const char = currentLineText[i];
        const charBefore = currentLineText[i - 1];
        if (charBefore + char === pipe || charBefore + char === endOfFunc + ' ') break;
        else if (char === startOfFunc || char === endOfParamKey) return false;
        i -= 1;
    }
    i = cursorPosition;
    // Then travel right; the first special character we should see is an opening paren '('
    while(i < currentLineText.length){
        const char = currentLineText[i];
        if (char === endOfParamKey || char === endOfFunc || char === endOfParam) return false;
        i += 1;
    }
    return true;
};
const $346dfb5d1aff5c20$var$shouldCompleteParam = (currentLineText, cursorPosition)=>{
    let i = cursorPosition;
    while(i){
        const char = currentLineText[i - 1];
        const charBefore = currentLineText[i - 2];
        if (char === ':' || char === '>' || char === ')') return false;
        if (char === '(' || charBefore + char === ', ') return true;
        i -= 1;
    }
    return false;
};
const $346dfb5d1aff5c20$var$shouldCompleteVObject = (currentLineText, cursorPosition)=>{
    // check whether "[ :]v." preceeds current position
    const char1 = currentLineText[cursorPosition - 3];
    return (char1 === ' ' || char1 === ':') && currentLineText[cursorPosition - 2] === 'v' && currentLineText[cursorPosition - 1] === '.';
};
const $346dfb5d1aff5c20$export$d685777a25796b36 = (currentLineText, cursorPosition, allSuggestions)=>{
    let end = cursorPosition;
    while(end && currentLineText[end] !== '(')end -= 1;
    let start = end;
    while(start && /[\w\(]/.test(currentLineText[start]))start -= 1;
    const functionName = currentLineText.slice(start, end).trim();
    const func = allSuggestions.find(({ name: name })=>name === functionName);
    if (!func) return {
        start: start,
        end: end,
        suggestions: []
    };
    let startOfParamKey = cursorPosition;
    while(![
        '(',
        ' '
    ].includes(currentLineText[startOfParamKey - 1]))startOfParamKey -= 1;
    return {
        start: startOfParamKey,
        end: cursorPosition,
        suggestions: Object.entries(func.params).map(([paramName, paramType])=>{
            let displayText = paramName;
            // Work around a bug in Flux where types are sometimes returned as "invalid"
            if (paramType !== 'invalid') displayText = `${paramName} <${paramType}>`;
            return {
                text: `${paramName}: `,
                displayText: displayText
            };
        })
    };
};
const $346dfb5d1aff5c20$export$9337244e12af9f8f = (currentLineText, cursorPosition, allSuggestions)=>{
    const formatter = $346dfb5d1aff5c20$export$d1dff406c8fca505(currentLineText, cursorPosition);
    const trailingWhitespace = /[\w]+/;
    let start = cursorPosition;
    let end = start;
    // Move end marker until a space or end of line is reached
    while(end < currentLineText.length && trailingWhitespace.test(currentLineText.charAt(end)))end += 1;
    // Move start marker until a space or the beginning of line is reached
    while(start && trailingWhitespace.test(currentLineText.charAt(start - 1)))start -= 1;
    // If not completing inside a current word, return list of all possible suggestions
    if (start === end) return {
        start: start,
        end: end,
        suggestions: allSuggestions.map(({ name: name })=>({
                text: formatter(name),
                displayText: name
            }))
    };
    // Otherwise return suggestions that contain the current word as a substring
    const currentWord = currentLineText.slice(start, end);
    const listFilter = new RegExp(`^${currentWord}`, 'i');
    const suggestions = allSuggestions.map((s)=>s.name).filter((name)=>name.match(listFilter)).map((displayText)=>({
            text: formatter(displayText),
            displayText: displayText
        }));
    return {
        start: start,
        end: end,
        suggestions: suggestions
    };
};
const $346dfb5d1aff5c20$export$d1dff406c8fca505 = (currentLineText, cursorPosition)=>{
    // Get the last two characters before the cursor that are neither whitespace nor alphanumeric
    const untilCursor = currentLineText.slice(0, cursorPosition).replace(/[a-z0-0]*/gi, '').replace(/\s/g, '');
    const n = untilCursor.length;
    const prevTwoChars = (untilCursor[n - 2] || '') + (untilCursor[n - 1] || '');
    const formatter = (name)=>{
        if (prevTwoChars === '|>' || name.startsWith('from')) return name;
        return `|> ${name}`;
    };
    return formatter;
};


const $cf98da20efabdfdf$export$cff997f8dd14bdca = {
    // The start state contains the rules that are intially used
    start: [
        // Flux Syntax
        {
            regex: /[|][>]/,
            token: 'pipe-forward'
        },
        {
            regex: /\w+(?=[(])/,
            token: 'function'
        },
        {
            regex: /[\w\d]+(?=\s[=]\s)/,
            token: 'variable'
        },
        {
            regex: /[=][>]/,
            token: 'arrow-function'
        },
        {
            regex: /\w+(?=[)]\s[=][>])(?![(])/,
            token: 'function-arg'
        },
        {
            regex: /\w+(?=[[]["]|[.])/,
            token: 'function-arg-ref'
        },
        {
            regex: /AND|OR|[=][=]|[!][=]|[<][=]|[>][=]/,
            token: 'operator'
        },
        {
            regex: /\w+[:]/,
            token: 'argument'
        },
        // The regex matches the token, the token property contains the type
        {
            regex: /"(?:[^\\]|\\.)*?(?:"|$)/,
            token: 'string-double'
        },
        {
            regex: /'(?:[^\\]|\\.)*?(?:'|$)/,
            token: 'string-single'
        },
        {
            regex: /(function)(\s+)([a-z$][\w$]*)/,
            token: [
                'keyword',
                null,
                'variable-2'
            ]
        },
        {
            regex: /true|false|TRUE|FALSE/,
            token: 'boolean'
        },
        {
            regex: /null|undefined/,
            token: 'null'
        },
        {
            regex: /0x[a-f\d]+|[-+]?(?:\.\d+|\d+\.?\d*)(?:e[-+]?\d+)?/i,
            token: 'number'
        },
        {
            regex: /({.+:.+})/,
            token: 'object'
        },
        {
            regex: /\/\/.*/,
            token: 'comment'
        },
        // A next property will cause the mode to move to a different state
        {
            regex: /\/\*/,
            token: 'comment',
            next: 'comment'
        },
        {
            regex: /[-+\/*=<>!]+/,
            token: 'operator'
        }
    ],
    // The multi-line comment state.
    comment: [
        {
            regex: /.*?\*\//,
            token: 'comment',
            next: 'start'
        },
        {
            regex: /.*/,
            token: 'comment'
        }
    ],
    // The meta property contains global information about the mode. It
    // can contain properties like lineComment, which are supported by
    // all modes, and also directives like dontIndentStates, which are
    // specific to simple modes.
    meta: {
        dontIndentStates: [
            'comment'
        ],
        lineComment: '//'
    }
};
const $cf98da20efabdfdf$export$afb559abf82b9894 = {
    // The start state contains the rules that are intially used
    start: [
        // The regex matches the token, the token property contains the type
        // A next property will cause the mode to move to a different state
        {
            regex: /"/,
            token: 'string.double',
            next: 'stringdouble'
        },
        {
            regex: /'/,
            token: 'string.single',
            next: 'stringsingle'
        },
        {
            regex: /(function)(\s+)([A-Za-z][\w]*)/,
            token: [
                'keyword',
                null,
                'variable-2'
            ]
        },
        // Rules are matched in the order in which they appear, so there is
        // no ambiguity between this one and the one above
        {
            regex: /(?:var|return|dbrp|if|for|while|else|do|this|stream|batch|influxql|lambda)/,
            token: 'keyword'
        },
        {
            regex: /TRUE|FALSE/,
            token: 'atom'
        },
        {
            regex: /0x[a-f\d]+|[-+]?(?:\.\d+|\d+\.?\d*)(?:e[-+]?\d+)?/i,
            token: 'number'
        },
        {
            regex: /\/\/.*/,
            token: 'comment'
        },
        {
            regex: /\/(?:[^\\]|\\.)*?\//,
            token: 'variable-3'
        },
        {
            regex: /AND|OR|[-~+\/*=<>!]+/,
            token: 'operator'
        },
        {
            regex: /[@]?[A-Za-z][\w$]*/,
            token: 'variable'
        }
    ],
    stringdouble: [
        {
            regex: /"/,
            token: 'string.double',
            next: 'start'
        },
        {
            regex: /[^"]/,
            token: 'string.double'
        }
    ],
    stringsingle: [
        {
            regex: /'/,
            token: 'string.single',
            next: 'start'
        },
        {
            regex: /[^']/,
            token: 'string.single'
        }
    ],
    // The meta property contains global information about the mode. It
    // can contain properties like lineComment, which are supported by
    // all modes, and also directives like dontIndentStates, which are
    // specific to simple modes.
    meta: {
        lineComment: '//'
    }
};
const $cf98da20efabdfdf$export$1a6772d63b0aaafd = {
    // The start state contains the rules that are intially used
    start: [
        // The regex matches the token, the token property contains the type
        {
            regex: /"(?:[^\\]|\\.)*?(?:"|$)/,
            token: 'string.double'
        },
        {
            regex: /'(?:[^\\]|\\.)*?(?:'|$)/,
            token: 'string.single'
        },
        {
            regex: /(function)(\s+)([a-z$][\w$]*)/,
            token: [
                'keyword',
                null,
                'variable-2'
            ]
        },
        // Rules are matched in the order in which they appear, so there is
        // no ambiguity between this one and the one above
        {
            regex: /(SELECT\s|AS\s|FROM\s|WHERE\s|GROUP\sBY\s)/i,
            token: 'clause'
        },
        {
            regex: /FILL(?=[(])/i,
            token: 'clause'
        },
        {
            regex: /(CREATE\s|SHOW\s|DROP\s)/i,
            token: 'meta'
        },
        {
            regex: /0x[a-f\d]+|[-+]?(?:\.\d+|\d+\.?\d*)(?:e[-+]?\d+)?/i,
            token: 'number'
        },
        {
            regex: /[:](interval|dashboardTime|dashboardUpper)[:]/,
            token: 'temp-system'
        },
        {
            regex: /[:]\w+[:]/,
            token: 'temp-var'
        },
        {
            regex: /now[(][)]\s\S\s\S+/,
            token: 'now'
        },
        {
            regex: /[-+\/*=~<>!]+/,
            token: 'operator'
        },
        {
            regex: /(NULL)/i,
            token: 'null'
        }
    ],
    // The multi-line comment state.
    comment: [
        {
            regex: /.*?\*\//,
            token: 'comment',
            next: 'start'
        },
        {
            regex: /.*/,
            token: 'comment'
        }
    ],
    // The meta property contains global information about the mode. It
    // can contain properties like lineComment, which are supported by
    // all modes, and also directives like dontIndentStates, which are
    // specific to simple modes.
    meta: {
        dontIndentStates: [
            'comment'
        ],
        lineComment: '//'
    }
};
const $cf98da20efabdfdf$export$305bc805efee2c20 = {
    // The start state contains the rules that are intially used
    start: [
        // The regex matches the token, the token property contains the type
        {
            regex: /"(?:[^\\]|\\.)*?(?:"|$)/,
            token: 'string.double'
        },
        {
            regex: /'(?:[^\\]|\\.)*?(?:'|$)/,
            token: 'string.single'
        },
        {
            regex: /(function)(\s+)([a-z$][\w$]*)/,
            token: [
                'keyword',
                null,
                'variable-2'
            ]
        },
        // Rules are matched in the order in which they appear, so there is
        // no ambiguity between this one and the one above
        {
            regex: /(SELECT\s|AS\s|FROM\s|WHERE\s|GROUP\sBY\s)/i,
            token: 'clause'
        },
        {
            regex: /FILL(?=[(])/i,
            token: 'clause'
        },
        {
            regex: /(CREATE\s|SHOW\s|DROP\s)/i,
            token: 'meta'
        },
        {
            regex: /[:]['](\w|[-:.])+['][:]/,
            token: 'temp-var'
        },
        {
            regex: /[:]now[(][)]\s[-]\s(\w+)[:]/,
            token: 'temp-var'
        },
        {
            regex: /[:]\w+[:]/,
            token: 'temp-var'
        },
        {
            regex: /0x[a-f\d]+|[-+]?(?:\.\d+|\d+\.?\d*)(?:e[-+]?\d+)?/i,
            token: 'number'
        },
        {
            regex: /(NULL)/i,
            token: 'null'
        }
    ],
    // The multi-line comment state.
    comment: [
        {
            regex: /.*?\*\//,
            token: 'comment',
            next: 'start'
        },
        {
            regex: /.*/,
            token: 'comment'
        }
    ],
    // The meta property contains global information about the mode. It
    // can contain properties like lineComment, which are supported by
    // all modes, and also directives like dontIndentStates, which are
    // specific to simple modes.
    meta: {
        dontIndentStates: [
            'comment'
        ],
        lineComment: '//'
    }
};
const $cf98da20efabdfdf$export$2c588dde1c802fb6 = {
    // The start state contains the rules that are intially used
    start: [
        // The regex matches the token, the token property contains the type
        {
            regex: /[*](\s|\w)+[*]/,
            token: 'italic'
        },
        {
            regex: /[*][*](\s|\w)+[*][*]/,
            token: 'bold'
        },
        {
            regex: /[~][~](\s|\w)+[~][~]/,
            token: 'strikethrough'
        },
        {
            regex: /\#+\s.+(?=$)/gm,
            token: 'heading'
        },
        {
            regex: /\>.+(?=$)/gm,
            token: 'blockquote'
        },
        {
            regex: /\[.+\]\(.+\)/,
            token: 'link'
        },
        {
            regex: /[!]\[.+\]\(.+\)/,
            token: 'image'
        }
    ],
    // The multi-line comment state.
    comment: [
        {
            regex: /.*?\*\//,
            token: 'comment',
            next: 'start'
        },
        {
            regex: /.*/,
            token: 'comment'
        }
    ],
    // The meta property contains global information about the mode. It
    // can contain properties like lineComment, which are supported by
    // all modes, and also directives like dontIndentStates, which are
    // specific to simple modes.
    meta: {
        dontIndentStates: [
            'comment'
        ],
        lineComment: '//'
    }
};



// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
// declare global: DOMRect
(function(mod) {
    mod((parcelRequire("4csXa")));
})(function(CodeMirror) {
    "use strict";
    var HINT_ELEMENT_CLASS = "CodeMirror-hint";
    var ACTIVE_HINT_ELEMENT_CLASS = "CodeMirror-hint-active";
    // This is the old interface, kept around for now to stay
    // backwards-compatible.
    CodeMirror.showHint = function(cm, getHints, options) {
        if (!getHints) return cm.showHint(options);
        if (options && options.async) getHints.async = true;
        var newOpts = {
            hint: getHints
        };
        if (options) for(var prop in options)newOpts[prop] = options[prop];
        return cm.showHint(newOpts);
    };
    CodeMirror.defineExtension("showHint", function(options) {
        options = parseOptions(this, this.getCursor("start"), options);
        var selections = this.listSelections();
        if (selections.length > 1) return;
        // By default, don't allow completion when something is selected.
        // A hint function can have a `supportsSelection` property to
        // indicate that it can handle selections.
        if (this.somethingSelected()) {
            if (!options.hint.supportsSelection) return;
            // Don't try with cross-line selections
            for(var i = 0; i < selections.length; i++)if (selections[i].head.line != selections[i].anchor.line) return;
        }
        if (this.state.completionActive) this.state.completionActive.close();
        var completion = this.state.completionActive = new Completion(this, options);
        if (!completion.options.hint) return;
        CodeMirror.signal(this, "startCompletion", this);
        completion.update(true);
    });
    CodeMirror.defineExtension("closeHint", function() {
        if (this.state.completionActive) this.state.completionActive.close();
    });
    function Completion(cm, options) {
        this.cm = cm;
        this.options = options;
        this.widget = null;
        this.debounce = 0;
        this.tick = 0;
        this.startPos = this.cm.getCursor("start");
        this.startLen = this.cm.getLine(this.startPos.line).length - this.cm.getSelection().length;
        if (this.options.updateOnCursorActivity) {
            var self = this;
            cm.on("cursorActivity", this.activityFunc = function() {
                self.cursorActivity();
            });
        }
    }
    var requestAnimationFrame = window.requestAnimationFrame || function(fn) {
        return setTimeout(fn, 1000 / 60);
    };
    var cancelAnimationFrame = window.cancelAnimationFrame || clearTimeout;
    Completion.prototype = {
        close: function() {
            if (!this.active()) return;
            this.cm.state.completionActive = null;
            this.tick = null;
            if (this.options.updateOnCursorActivity) this.cm.off("cursorActivity", this.activityFunc);
            if (this.widget && this.data) CodeMirror.signal(this.data, "close");
            if (this.widget) this.widget.close();
            CodeMirror.signal(this.cm, "endCompletion", this.cm);
        },
        active: function() {
            return this.cm.state.completionActive == this;
        },
        pick: function(data, i) {
            var completion = data.list[i], self = this;
            this.cm.operation(function() {
                if (completion.hint) completion.hint(self.cm, data, completion);
                else self.cm.replaceRange(getText(completion), completion.from || data.from, completion.to || data.to, "complete");
                CodeMirror.signal(data, "pick", completion);
                self.cm.scrollIntoView();
            });
            if (this.options.closeOnPick) this.close();
        },
        cursorActivity: function() {
            if (this.debounce) {
                cancelAnimationFrame(this.debounce);
                this.debounce = 0;
            }
            var identStart = this.startPos;
            if (this.data) identStart = this.data.from;
            var pos = this.cm.getCursor(), line = this.cm.getLine(pos.line);
            if (pos.line != this.startPos.line || line.length - pos.ch != this.startLen - this.startPos.ch || pos.ch < identStart.ch || this.cm.somethingSelected() || !pos.ch || this.options.closeCharacters.test(line.charAt(pos.ch - 1))) this.close();
            else {
                var self = this;
                this.debounce = requestAnimationFrame(function() {
                    self.update();
                });
                if (this.widget) this.widget.disable();
            }
        },
        update: function(first) {
            if (this.tick == null) return;
            var self = this, myTick = ++this.tick;
            fetchHints(this.options.hint, this.cm, this.options, function(data) {
                if (self.tick == myTick) self.finishUpdate(data, first);
            });
        },
        finishUpdate: function(data, first) {
            if (this.data) CodeMirror.signal(this.data, "update");
            var picked = this.widget && this.widget.picked || first && this.options.completeSingle;
            if (this.widget) this.widget.close();
            this.data = data;
            if (data && data.list.length) {
                if (picked && data.list.length == 1) this.pick(data, 0);
                else {
                    this.widget = new Widget(this, data);
                    CodeMirror.signal(data, "shown");
                }
            }
        }
    };
    function parseOptions(cm, pos, options) {
        var editor = cm.options.hintOptions;
        var out = {};
        for(var prop in defaultOptions)out[prop] = defaultOptions[prop];
        if (editor) {
            for(var prop in editor)if (editor[prop] !== undefined) out[prop] = editor[prop];
        }
        if (options) {
            for(var prop in options)if (options[prop] !== undefined) out[prop] = options[prop];
        }
        if (out.hint.resolve) out.hint = out.hint.resolve(cm, pos);
        return out;
    }
    function getText(completion) {
        if (typeof completion == "string") return completion;
        else return completion.text;
    }
    function buildKeyMap(completion, handle) {
        var baseMap = {
            Up: function() {
                handle.moveFocus(-1);
            },
            Down: function() {
                handle.moveFocus(1);
            },
            PageUp: function() {
                handle.moveFocus(-handle.menuSize() + 1, true);
            },
            PageDown: function() {
                handle.moveFocus(handle.menuSize() - 1, true);
            },
            Home: function() {
                handle.setFocus(0);
            },
            End: function() {
                handle.setFocus(handle.length - 1);
            },
            Enter: handle.pick,
            Tab: handle.pick,
            Esc: handle.close
        };
        var mac = /Mac/.test(navigator.platform);
        if (mac) {
            baseMap["Ctrl-P"] = function() {
                handle.moveFocus(-1);
            };
            baseMap["Ctrl-N"] = function() {
                handle.moveFocus(1);
            };
        }
        var custom = completion.options.customKeys;
        var ourMap = custom ? {} : baseMap;
        function addBinding(key, val) {
            var bound;
            if (typeof val != "string") bound = function(cm) {
                return val(cm, handle);
            };
            else if (baseMap.hasOwnProperty(val)) bound = baseMap[val];
            else bound = val;
            ourMap[key] = bound;
        }
        if (custom) {
            for(var key in custom)if (custom.hasOwnProperty(key)) addBinding(key, custom[key]);
        }
        var extra = completion.options.extraKeys;
        if (extra) {
            for(var key in extra)if (extra.hasOwnProperty(key)) addBinding(key, extra[key]);
        }
        return ourMap;
    }
    function getHintElement(hintsElement, el) {
        while(el && el != hintsElement){
            if (el.nodeName.toUpperCase() === "LI" && el.parentNode == hintsElement) return el;
            el = el.parentNode;
        }
    }
    function Widget(completion, data) {
        this.id = "cm-complete-" + Math.floor(Math.random(1e6));
        this.completion = completion;
        this.data = data;
        this.picked = false;
        var widget = this, cm = completion.cm;
        var ownerDocument = cm.getInputField().ownerDocument;
        var parentWindow = ownerDocument.defaultView || ownerDocument.parentWindow;
        var hints = this.hints = ownerDocument.createElement("ul");
        hints.setAttribute("role", "listbox");
        hints.setAttribute("aria-expanded", "true");
        hints.id = this.id;
        var theme = completion.cm.options.theme;
        hints.className = "CodeMirror-hints " + theme;
        this.selectedHint = data.selectedHint || 0;
        var completions = data.list;
        for(var i = 0; i < completions.length; ++i){
            var elt = hints.appendChild(ownerDocument.createElement("li")), cur = completions[i];
            var className = HINT_ELEMENT_CLASS + (i != this.selectedHint ? "" : " " + ACTIVE_HINT_ELEMENT_CLASS);
            if (cur.className != null) className = cur.className + " " + className;
            elt.className = className;
            if (i == this.selectedHint) elt.setAttribute("aria-selected", "true");
            elt.id = this.id + "-" + i;
            elt.setAttribute("role", "option");
            if (cur.render) cur.render(elt, data, cur);
            else elt.appendChild(ownerDocument.createTextNode(cur.displayText || getText(cur)));
            elt.hintId = i;
        }
        var container = completion.options.container || ownerDocument.body;
        var pos = cm.cursorCoords(completion.options.alignWithWord ? data.from : null);
        var left = pos.left, top = pos.bottom, below = true;
        var offsetLeft = 0, offsetTop = 0;
        if (container !== ownerDocument.body) {
            // We offset the cursor position because left and top are relative to the offsetParent's top left corner.
            var isContainerPositioned = [
                'absolute',
                'relative',
                'fixed'
            ].indexOf(parentWindow.getComputedStyle(container).position) !== -1;
            var offsetParent = isContainerPositioned ? container : container.offsetParent;
            var offsetParentPosition = offsetParent.getBoundingClientRect();
            var bodyPosition = ownerDocument.body.getBoundingClientRect();
            offsetLeft = offsetParentPosition.left - bodyPosition.left - offsetParent.scrollLeft;
            offsetTop = offsetParentPosition.top - bodyPosition.top - offsetParent.scrollTop;
        }
        hints.style.left = left - offsetLeft + "px";
        hints.style.top = top - offsetTop + "px";
        // If we're at the edge of the screen, then we want the menu to appear on the left of the cursor.
        var winW = parentWindow.innerWidth || Math.max(ownerDocument.body.offsetWidth, ownerDocument.documentElement.offsetWidth);
        var winH = parentWindow.innerHeight || Math.max(ownerDocument.body.offsetHeight, ownerDocument.documentElement.offsetHeight);
        container.appendChild(hints);
        cm.getInputField().setAttribute("aria-autocomplete", "list");
        cm.getInputField().setAttribute("aria-owns", this.id);
        cm.getInputField().setAttribute("aria-activedescendant", this.id + "-" + this.selectedHint);
        var box = completion.options.moveOnOverlap ? hints.getBoundingClientRect() : new DOMRect();
        var scrolls = completion.options.paddingForScrollbar ? hints.scrollHeight > hints.clientHeight + 1 : false;
        // Compute in the timeout to avoid reflow on init
        var startScroll;
        setTimeout(function() {
            startScroll = cm.getScrollInfo();
        });
        var overlapY = box.bottom - winH;
        if (overlapY > 0) {
            var height = box.bottom - box.top, curTop = pos.top - (pos.bottom - box.top);
            if (curTop - height > 0) {
                hints.style.top = (top = pos.top - height - offsetTop) + "px";
                below = false;
            } else if (height > winH) {
                hints.style.height = winH - 5 + "px";
                hints.style.top = (top = pos.bottom - box.top - offsetTop) + "px";
                var cursor = cm.getCursor();
                if (data.from.ch != cursor.ch) {
                    pos = cm.cursorCoords(cursor);
                    hints.style.left = (left = pos.left - offsetLeft) + "px";
                    box = hints.getBoundingClientRect();
                }
            }
        }
        var overlapX = box.right - winW;
        if (scrolls) overlapX += cm.display.nativeBarWidth;
        if (overlapX > 0) {
            if (box.right - box.left > winW) {
                hints.style.width = winW - 5 + "px";
                overlapX -= box.right - box.left - winW;
            }
            hints.style.left = (left = pos.left - overlapX - offsetLeft) + "px";
        }
        if (scrolls) for(var node = hints.firstChild; node; node = node.nextSibling)node.style.paddingRight = cm.display.nativeBarWidth + "px";
        cm.addKeyMap(this.keyMap = buildKeyMap(completion, {
            moveFocus: function(n, avoidWrap) {
                widget.changeActive(widget.selectedHint + n, avoidWrap);
            },
            setFocus: function(n) {
                widget.changeActive(n);
            },
            menuSize: function() {
                return widget.screenAmount();
            },
            length: completions.length,
            close: function() {
                completion.close();
            },
            pick: function() {
                widget.pick();
            },
            data: data
        }));
        if (completion.options.closeOnUnfocus) {
            var closingOnBlur;
            cm.on("blur", this.onBlur = function() {
                closingOnBlur = setTimeout(function() {
                    completion.close();
                }, 100);
            });
            cm.on("focus", this.onFocus = function() {
                clearTimeout(closingOnBlur);
            });
        }
        cm.on("scroll", this.onScroll = function() {
            var curScroll = cm.getScrollInfo(), editor = cm.getWrapperElement().getBoundingClientRect();
            if (!startScroll) startScroll = cm.getScrollInfo();
            var newTop = top + startScroll.top - curScroll.top;
            var point = newTop - (parentWindow.pageYOffset || (ownerDocument.documentElement || ownerDocument.body).scrollTop);
            if (!below) point += hints.offsetHeight;
            if (point <= editor.top || point >= editor.bottom) return completion.close();
            hints.style.top = newTop + "px";
            hints.style.left = left + startScroll.left - curScroll.left + "px";
        });
        CodeMirror.on(hints, "dblclick", function(e) {
            var t = getHintElement(hints, e.target || e.srcElement);
            if (t && t.hintId != null) {
                widget.changeActive(t.hintId);
                widget.pick();
            }
        });
        CodeMirror.on(hints, "click", function(e) {
            var t = getHintElement(hints, e.target || e.srcElement);
            if (t && t.hintId != null) {
                widget.changeActive(t.hintId);
                if (completion.options.completeOnSingleClick) widget.pick();
            }
        });
        CodeMirror.on(hints, "mousedown", function() {
            setTimeout(function() {
                cm.focus();
            }, 20);
        });
        // The first hint doesn't need to be scrolled to on init
        var selectedHintRange = this.getSelectedHintRange();
        if (selectedHintRange.from !== 0 || selectedHintRange.to !== 0) this.scrollToActive();
        CodeMirror.signal(data, "select", completions[this.selectedHint], hints.childNodes[this.selectedHint]);
        return true;
    }
    Widget.prototype = {
        close: function() {
            if (this.completion.widget != this) return;
            this.completion.widget = null;
            if (this.hints.parentNode) this.hints.parentNode.removeChild(this.hints);
            this.completion.cm.removeKeyMap(this.keyMap);
            var input = this.completion.cm.getInputField();
            input.removeAttribute("aria-activedescendant");
            input.removeAttribute("aria-owns");
            var cm = this.completion.cm;
            if (this.completion.options.closeOnUnfocus) {
                cm.off("blur", this.onBlur);
                cm.off("focus", this.onFocus);
            }
            cm.off("scroll", this.onScroll);
        },
        disable: function() {
            this.completion.cm.removeKeyMap(this.keyMap);
            var widget = this;
            this.keyMap = {
                Enter: function() {
                    widget.picked = true;
                }
            };
            this.completion.cm.addKeyMap(this.keyMap);
        },
        pick: function() {
            this.completion.pick(this.data, this.selectedHint);
        },
        changeActive: function(i, avoidWrap) {
            if (i >= this.data.list.length) i = avoidWrap ? this.data.list.length - 1 : 0;
            else if (i < 0) i = avoidWrap ? 0 : this.data.list.length - 1;
            if (this.selectedHint == i) return;
            var node = this.hints.childNodes[this.selectedHint];
            if (node) {
                node.className = node.className.replace(" " + ACTIVE_HINT_ELEMENT_CLASS, "");
                node.removeAttribute("aria-selected");
            }
            node = this.hints.childNodes[this.selectedHint = i];
            node.className += " " + ACTIVE_HINT_ELEMENT_CLASS;
            node.setAttribute("aria-selected", "true");
            this.completion.cm.getInputField().setAttribute("aria-activedescendant", node.id);
            this.scrollToActive();
            CodeMirror.signal(this.data, "select", this.data.list[this.selectedHint], node);
        },
        scrollToActive: function() {
            var selectedHintRange = this.getSelectedHintRange();
            var node1 = this.hints.childNodes[selectedHintRange.from];
            var node2 = this.hints.childNodes[selectedHintRange.to];
            var firstNode = this.hints.firstChild;
            if (node1.offsetTop < this.hints.scrollTop) this.hints.scrollTop = node1.offsetTop - firstNode.offsetTop;
            else if (node2.offsetTop + node2.offsetHeight > this.hints.scrollTop + this.hints.clientHeight) this.hints.scrollTop = node2.offsetTop + node2.offsetHeight - this.hints.clientHeight + firstNode.offsetTop;
        },
        screenAmount: function() {
            return Math.floor(this.hints.clientHeight / this.hints.firstChild.offsetHeight) || 1;
        },
        getSelectedHintRange: function() {
            var margin = this.completion.options.scrollMargin || 0;
            return {
                from: Math.max(0, this.selectedHint - margin),
                to: Math.min(this.data.list.length - 1, this.selectedHint + margin)
            };
        }
    };
    function applicableHelpers(cm, helpers) {
        if (!cm.somethingSelected()) return helpers;
        var result = [];
        for(var i = 0; i < helpers.length; i++)if (helpers[i].supportsSelection) result.push(helpers[i]);
        return result;
    }
    function fetchHints(hint, cm, options, callback) {
        if (hint.async) hint(cm, callback, options);
        else {
            var result = hint(cm, options);
            if (result && result.then) result.then(callback);
            else callback(result);
        }
    }
    function resolveAutoHints(cm, pos) {
        var helpers = cm.getHelpers(pos, "hint"), words;
        if (helpers.length) {
            var resolved = function(cm, callback, options) {
                var app = applicableHelpers(cm, helpers);
                function run(i) {
                    if (i == app.length) return callback(null);
                    fetchHints(app[i], cm, options, function(result) {
                        if (result && result.list.length > 0) callback(result);
                        else run(i + 1);
                    });
                }
                run(0);
            };
            resolved.async = true;
            resolved.supportsSelection = true;
            return resolved;
        } else if (words = cm.getHelper(cm.getCursor(), "hintWords")) return function(cm) {
            return CodeMirror.hint.fromList(cm, {
                words: words
            });
        };
        else if (CodeMirror.hint.anyword) return function(cm, options) {
            return CodeMirror.hint.anyword(cm, options);
        };
        else return function() {};
    }
    CodeMirror.registerHelper("hint", "auto", {
        resolve: resolveAutoHints
    });
    CodeMirror.registerHelper("hint", "fromList", function(cm, options) {
        var cur = cm.getCursor(), token = cm.getTokenAt(cur);
        var term, from = CodeMirror.Pos(cur.line, token.start), to = cur;
        if (token.start < cur.ch && /\w/.test(token.string.charAt(cur.ch - token.start - 1))) term = token.string.substr(0, cur.ch - token.start);
        else {
            term = "";
            from = cur;
        }
        var found = [];
        for(var i = 0; i < options.words.length; i++){
            var word = options.words[i];
            if (word.slice(0, term.length) == term) found.push(word);
        }
        if (found.length) return {
            list: found,
            from: from,
            to: to
        };
    });
    CodeMirror.commands.autocomplete = CodeMirror.showHint;
    var defaultOptions = {
        hint: CodeMirror.hint.auto,
        completeSingle: true,
        alignWithWord: true,
        closeCharacters: /[\s()\[\]{};:>,]/,
        closeOnPick: true,
        closeOnUnfocus: true,
        updateOnCursorActivity: true,
        completeOnSingleClick: true,
        container: null,
        customKeys: null,
        extraKeys: null,
        paddingForScrollbar: true,
        moveOnOverlap: true
    };
    CodeMirror.defineOption("hintOptions", null);
});



var $4csXa = parcelRequire("4csXa");
$4csXa.defineSimpleMode = function(name, states) {
    $4csXa.defineMode(name, function(config) {
        return $4csXa.simpleMode(config, states);
    });
};
$4csXa.simpleMode = function(config, states) {
    $ed0cc34e8c3dfe53$var$ensureState(states, 'start');
    const states_ = {}, meta = states.meta || {};
    let hasIndentation = false;
    for(const state in states)if (state !== meta && states.hasOwnProperty(state)) {
        const list = states_[state] = [], orig = states[state];
        for(let i = 0; i < orig.length; i++){
            const data = orig[i];
            list.push(new $ed0cc34e8c3dfe53$var$Rule(data, states));
            if (data.indent || data.dedent) hasIndentation = true;
        }
    }
    const mode = {
        startState () {
            return {
                state: 'start',
                pending: null,
                local: null,
                localState: null,
                indent: hasIndentation ? [] : null
            };
        },
        copyState (state) {
            const s = {
                state: state.state,
                pending: state.pending,
                local: state.local,
                localState: null,
                indent: state.indent && state.indent.slice(0)
            };
            if (state.localState) s.localState = $4csXa.copyState(state.local.mode, state.localState);
            if (state.stack) s.stack = state.stack.slice(0);
            for(let pers = state.persistentStates; pers; pers = pers.next)s.persistentStates = {
                mode: pers.mode,
                spec: pers.spec,
                state: pers.state === state.localState ? s.localState : $4csXa.copyState(pers.mode, pers.state),
                next: s.persistentStates
            };
            return s;
        },
        token: $ed0cc34e8c3dfe53$var$tokenFunction(states_, config),
        innerMode (state) {
            return state.local && {
                mode: state.local.mode,
                state: state.localState
            };
        },
        indent: $ed0cc34e8c3dfe53$var$indentFunction(states_, meta)
    };
    if (meta) {
        for(const prop in meta)if (meta.hasOwnProperty(prop)) mode[prop] = meta[prop];
    }
    return mode;
};
$4csXa.defineOption('placeholder', '', function(cm, val, old) {
    var prev = old && old != $4csXa.Init;
    if (val && !prev) {
        cm.on('blur', $ed0cc34e8c3dfe53$var$onBlur);
        cm.on('change', $ed0cc34e8c3dfe53$var$onChange);
        cm.on('swapDoc', $ed0cc34e8c3dfe53$var$onChange);
        $ed0cc34e8c3dfe53$var$onChange(cm);
    } else if (!val && prev) {
        cm.off('blur', $ed0cc34e8c3dfe53$var$onBlur);
        cm.off('change', $ed0cc34e8c3dfe53$var$onChange);
        cm.off('swapDoc', $ed0cc34e8c3dfe53$var$onChange);
        $ed0cc34e8c3dfe53$var$clearPlaceholder(cm);
        var wrapper = cm.getWrapperElement();
        wrapper.className = wrapper.className.replace(' CodeMirror-empty', '');
    }
    if (val && !cm.hasFocus()) $ed0cc34e8c3dfe53$var$onBlur(cm);
});
function $ed0cc34e8c3dfe53$var$clearPlaceholder(cm) {
    if (cm.state.placeholder) {
        cm.state.placeholder.parentNode.removeChild(cm.state.placeholder);
        cm.state.placeholder = null;
    }
}
function $ed0cc34e8c3dfe53$var$setPlaceholder(cm) {
    $ed0cc34e8c3dfe53$var$clearPlaceholder(cm);
    var elt = cm.state.placeholder = document.createElement('pre');
    elt.style.cssText = 'height: 0; overflow: visible';
    elt.style.direction = cm.getOption('direction');
    elt.className = 'CodeMirror-placeholder';
    var placeHolder = cm.getOption('placeholder');
    if (typeof placeHolder == 'string') placeHolder = document.createTextNode(placeHolder);
    elt.appendChild(placeHolder);
    cm.display.lineSpace.insertBefore(elt, cm.display.lineSpace.firstChild);
}
function $ed0cc34e8c3dfe53$var$onBlur(cm) {
    if ($ed0cc34e8c3dfe53$var$isEmpty(cm)) $ed0cc34e8c3dfe53$var$setPlaceholder(cm);
}
function $ed0cc34e8c3dfe53$var$onChange(cm) {
    var wrapper = cm.getWrapperElement(), empty = $ed0cc34e8c3dfe53$var$isEmpty(cm);
    wrapper.className = wrapper.className.replace(' CodeMirror-empty', '') + (empty ? ' CodeMirror-empty' : '');
    if (empty) $ed0cc34e8c3dfe53$var$setPlaceholder(cm);
    else $ed0cc34e8c3dfe53$var$clearPlaceholder(cm);
}
function $ed0cc34e8c3dfe53$var$isEmpty(cm) {
    return cm.lineCount() === 1 && cm.getLine(0) === '';
}
function $ed0cc34e8c3dfe53$var$ensureState(states, name) {
    if (!states.hasOwnProperty(name)) throw new Error(`Undefined state ${name} in simple mode`);
}
function $ed0cc34e8c3dfe53$var$toRegex(val, caret) {
    if (!val) return /(?:)/;
    let flags = '';
    if (val instanceof RegExp) {
        if (val.ignoreCase) flags = 'i';
        val = val.source;
    } else val = String(val);
    return new RegExp(`${caret === false ? '' : '^'}(?:${val})`, flags);
}
function $ed0cc34e8c3dfe53$var$asToken(val) {
    if (!val) return null;
    if (val.apply) return val;
    if (typeof val === 'string') return val.replace(/\./g, ' ');
    const result = [];
    for(let i = 0; i < val.length; i++)result.push(val[i] && val[i].replace(/\./g, ' '));
    return result;
}
function $ed0cc34e8c3dfe53$var$Rule(data, states) {
    if (data.next || data.push) $ed0cc34e8c3dfe53$var$ensureState(states, data.next || data.push);
    this.regex = $ed0cc34e8c3dfe53$var$toRegex(data.regex);
    this.token = $ed0cc34e8c3dfe53$var$asToken(data.token);
    this.data = data;
}
function $ed0cc34e8c3dfe53$var$tokenFunction(states, config) {
    return function(stream, state) {
        if (state.pending) {
            const pend = state.pending.shift();
            if (state.pending.length === 0) state.pending = null;
            stream.pos += pend.text.length;
            return pend.token;
        }
        if (state.local) {
            let tok, m;
            if (state.local.end && stream.match(state.local.end)) {
                tok = state.local.endToken || null;
                state.local = state.localState = null;
                return tok;
            }
            tok = state.local.mode.token(stream, state.localState);
            if (state.local.endScan && (m = state.local.endScan.exec(stream.current()))) stream.pos = stream.start + m.index;
            return tok;
        }
        const curState = states[state.state];
        for(let i = 0; i < curState.length; i++){
            const rule = curState[i];
            const matches = (!rule.data.sol || stream.sol()) && stream.match(rule.regex);
            if (matches) {
                if (rule.data.next) state.state = rule.data.next;
                else if (rule.data.push) {
                    (state.stack || (state.stack = [])).push(state.state);
                    state.state = rule.data.push;
                } else if (rule.data.pop && state.stack && state.stack.length) state.state = state.stack.pop();
                if (rule.data.mode) $ed0cc34e8c3dfe53$var$enterLocalMode(config, state, rule.data.mode, rule.token);
                if (rule.data.indent) state.indent.push(stream.indentation() + config.indentUnit);
                if (rule.data.dedent) state.indent.pop();
                let token = rule.token;
                if (token && token.apply) token = token(matches);
                if (matches.length > 2) {
                    state.pending = [];
                    for(let j = 2; j < matches.length; j++)if (matches[j]) state.pending.push({
                        text: matches[j],
                        token: rule.token[j - 1]
                    });
                    stream.backUp(matches[0].length - (matches[1] ? matches[1].length : 0));
                    return token[0];
                } else if (token && token.join) return token[0];
                return token;
            }
        }
        stream.next();
        return null;
    };
}
function $ed0cc34e8c3dfe53$var$cmp(a, b) {
    if (a === b) return true;
    if (!a || typeof a !== 'object' || !b || typeof b !== 'object') return false;
    let props = 0;
    for(const prop in a)if (a.hasOwnProperty(prop)) {
        if (!b.hasOwnProperty(prop) || !$ed0cc34e8c3dfe53$var$cmp(a[prop], b[prop])) return false;
        props += 1;
    }
    for(const prop in b)if (b.hasOwnProperty(prop)) props -= 1;
    return props === 0;
}
function $ed0cc34e8c3dfe53$var$enterLocalMode(config, state, spec, token) {
    let pers;
    if (spec.persistent) {
        for(let p = state.persistentStates; p && !pers; p = p.next)if (spec.spec ? $ed0cc34e8c3dfe53$var$cmp(spec.spec, p.spec) : spec.mode === p.mode) pers = p;
    }
    const mode = pers ? pers.mode : spec.mode || $4csXa.getMode(config, spec.spec);
    const lState = pers ? pers.state : $4csXa.startState(mode);
    if (spec.persistent && !pers) state.persistentStates = {
        mode: mode,
        spec: spec.spec,
        state: lState,
        next: state.persistentStates
    };
    state.localState = lState;
    state.local = {
        mode: mode,
        end: spec.end && $ed0cc34e8c3dfe53$var$toRegex(spec.end),
        endScan: spec.end && spec.forceEnd !== false && $ed0cc34e8c3dfe53$var$toRegex(spec.end, false),
        endToken: token && token.join ? token[token.length - 1] : token
    };
}
function $ed0cc34e8c3dfe53$var$indexOf(val, arr) {
    for(let i = 0; i < arr.length; i++){
        if (arr[i] === val) return true;
    }
}
function $ed0cc34e8c3dfe53$var$indentFunction(states, meta) {
    return function(state, textAfter, line) {
        if (state.local && state.local.mode.indent) return state.local.mode.indent(state.localState, textAfter, line);
        if (state.indent === null || state.local || meta.dontIndentStates && $ed0cc34e8c3dfe53$var$indexOf(state.state, meta.dontIndentStates) > -1) return $4csXa.Pass;
        let pos = state.indent.length - 1, rules = states[state.state];
        scan: for(;;){
            for(let i = 0; i < rules.length; i++){
                const rule = rules[i];
                if (rule.data.dedent && rule.data.dedentIfLineStart !== false) {
                    const m = rule.regex.exec(textAfter);
                    if (m && m[0]) {
                        pos -= 1;
                        if (rule.next || rule.push) rules = states[rule.next || rule.push];
                        textAfter = textAfter.slice(m[0].length);
                        continue scan;
                    }
                }
            }
            break;
        }
        return pos < 0 ? 0 : state.indent[pos];
    };
}
// Modes
$4csXa.defineSimpleMode('flux', (0, $cf98da20efabdfdf$export$cff997f8dd14bdca));
$4csXa.defineSimpleMode('tickscript', (0, $cf98da20efabdfdf$export$afb559abf82b9894));
$4csXa.defineSimpleMode('influxQL', (0, $cf98da20efabdfdf$export$1a6772d63b0aaafd));
$4csXa.defineSimpleMode('influxQLReadOnly', (0, $cf98da20efabdfdf$export$305bc805efee2c20));
$4csXa.defineSimpleMode('markdown', (0, $cf98da20efabdfdf$export$2c588dde1c802fb6));


class $a58c20547c7c0b21$var$FluxScriptEditor extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.lineWidgets = [], this.containerDimensions = {
            height: 0,
            width: 0
        }, this.handleCursorChange = (__, position)=>{
            const { onCursorChange: onCursorChange } = this.props;
            if (onCursorChange) onCursorChange(position);
        }, this.handleMouseEnter = (e)=>{
            const { width: width, height: height } = e.currentTarget.getBoundingClientRect();
            const { width: prevWidth, height: prevHeight } = this.containerDimensions;
            if (prevWidth !== width || prevHeight !== height) this.editor.refresh();
            this.containerDimensions = {
                width: width,
                height: height
            };
        }, this.handleClickError = (text, line)=>()=>{
                let widget = this.lineWidgets.find((w)=>w.node.textContent === text);
                if (widget) return this.clearWidget(widget);
                const errorDiv = document.createElement('div');
                errorDiv.className = 'inline-error-message';
                errorDiv.innerText = text;
                widget = this.editor.addLineWidget(line, errorDiv);
                this.lineWidgets = [
                    ...this.lineWidgets,
                    widget
                ];
            }, this.clearWidget = (widget)=>{
            widget.clear();
            this.lineWidgets = this.lineWidgets.filter((w)=>w.node.textContent !== widget.node.textContent);
        }, this.clearWidgets = ()=>{
            this.lineWidgets.forEach((w)=>{
                w.clear();
            });
            this.lineWidgets = [];
        }, this.handleMount = (instance)=>{
            instance.refresh() // required to for proper line height on mount
            ;
            this.editor = instance;
        }, this.onTouchStart = ()=>{}, this.handleKeyUp = (__, e)=>{
            const { ctrlKey: ctrlKey, key: key } = e;
            if (ctrlKey && key === ' ') {
                this.showAutoComplete();
                return;
            }
            if (ctrlKey && key === 'Enter') {
                this.props.onSubmitScript();
                return;
            }
            if (ctrlKey || (0, $346dfb5d1aff5c20$export$6e48ebf5f0972073).has(key)) return;
            this.showAutoComplete();
        }, this.beforeChange = (___, ____, script)=>{
            this.setState({
                script: script
            });
        }, this.updateCode = (___, ____, script)=>{
            this.props.onChangeScript(script);
        };
        this.state = {
            script: props.script,
            cursorPosition: null
        };
    }
    componentDidUpdate(prevProps) {
        const { status: status, visibility: visibility } = this.props;
        if (prevProps.script !== this.props.script) this.setState({
            script: this.props.script
        });
        if (status.type === 'error') this.makeError();
        if (status.type !== 'error') {
            this.editor.clearGutter('error-gutter');
            this.clearWidgets();
        }
        if (prevProps.visibility === visibility) return;
        if (visibility === 'visible') setTimeout(()=>this.editor.refresh(), 60);
    }
    render() {
        const { children: children, readOnly: readOnly } = this.props;
        const options = {
            tabIndex: 1,
            mode: 'flux',
            readOnly: !!readOnly,
            lineNumbers: true,
            autoRefresh: true,
            indentUnit: 2,
            smartIndent: false,
            electricChars: false,
            theme: 'time-machine',
            completeSingle: false,
            gutters: [
                'error-gutter'
            ],
            autoFocus: true
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-script-editor",
            onMouseEnter: this.handleMouseEnter
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b1cb9a1ab496dfeb$exports.Controlled), {
            autoCursor: true,
            value: this.state.script,
            options: options,
            onBeforeChange: this.beforeChange,
            onChange: this.updateCode,
            onTouchStart: this.onTouchStart,
            editorDidMount: this.handleMount,
            onKeyUp: this.handleKeyUp,
            onCursor: this.handleCursorChange
        }), children);
    }
    makeError() {
        this.editor.clearGutter('error-gutter');
        const lineNumbers = this.statusLine;
        lineNumbers.forEach(({ line: line, text: text })=>{
            const lineNumber = line - 1;
            this.editor.setGutterMarker(lineNumber, 'error-gutter', this.errorMarker(text, lineNumber));
        });
        this.editor.refresh();
    }
    errorMarker(message, line) {
        const span = document.createElement('span');
        span.className = 'icon stop error-warning';
        span.title = message;
        span.addEventListener('click', this.handleClickError(message, line));
        return span;
    }
    get statusLine() {
        const { status: status } = this.props;
        const messages = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(status, 'text', '').split('\n');
        const lineNumbers = messages.map((text)=>{
            const [numbers] = text.split(' ');
            const [lineNumber] = numbers.split(':');
            return {
                line: Number(lineNumber),
                text: text
            };
        }).filter((d)=>!isNaN(d.line));
        return lineNumbers;
    }
    showAutoComplete() {
        const { suggestions: suggestions } = this.props;
        const filteredSuggestions = (0, $346dfb5d1aff5c20$export$cb01122796bc0228)(this.editor, suggestions);
        if (!filteredSuggestions.list.length) return;
        this.editor.showHint({
            hint: ()=>filteredSuggestions,
            completeSingle: false
        });
    }
}
var $a58c20547c7c0b21$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($a58c20547c7c0b21$var$FluxScriptEditor);



class $06cdf5bcf6486c0a$var$FluxEditor extends (0, $NdCUR.PureComponent) {
    render() {
        const { status: status, script: script, visibility: visibility, suggestions: suggestions, onChangeScript: onChangeScript, onSubmitScript: onSubmitScript, onShowWizard: onShowWizard, onCursorChange: onCursorChange } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-editor"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a58c20547c7c0b21$export$2e2bcd8739ae039), {
            status: status,
            script: script,
            visibility: visibility,
            suggestions: suggestions,
            onChangeScript: onChangeScript,
            onSubmitScript: onSubmitScript,
            onCursorChange: onCursorChange
        }, script.trim() === '' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-script-wizard--bg-hint"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, "New to Flux? Give the", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
            text: 'Script Builder',
            color: (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Primary,
            titleText: 'Open Flux Script Builder',
            size: (0, $918c9f03a35fe03f$export$fafce5c139da9687).Large,
            onClick: onShowWizard
        }), ' ', "a try"))));
    }
}
var $06cdf5bcf6486c0a$export$2e2bcd8739ae039 = $06cdf5bcf6486c0a$var$FluxEditor;




// Libraries

var $NdCUR = parcelRequire("NdCUR");
// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");

class $28ed0021233d4002$var$TransformToolbarFunctions extends (0, $NdCUR.PureComponent) {
    render() {
        return this.props.children(this.sortedFunctions);
    }
    get sortedFunctions() {
        return this.sortFunctions(this.filterFunctions());
    }
    filterFunctions() {
        const { searchTerm: searchTerm, funcs: funcs } = this.props;
        if (!searchTerm) return funcs;
        return funcs.filter((func)=>func.name.toLowerCase().includes(searchTerm.toLowerCase()));
    }
    sortFunctions(functions) {
        const grouped = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).groupBy(functions, 'category');
        const sorted = Object.keys(grouped).sort().reduce((acc, key)=>{
            acc[key] = grouped[key];
            return acc;
        }, {});
        return sorted;
    }
}
var $28ed0021233d4002$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($28ed0021233d4002$var$TransformToolbarFunctions);


// Libraries

var $NdCUR = parcelRequire("NdCUR");
// Libraries

var $NdCUR = parcelRequire("NdCUR");
// Libraries

var $NdCUR = parcelRequire("NdCUR");

// Libraries

var $NdCUR = parcelRequire("NdCUR");

class $c546ea5764ae41d9$var$TooltipDescription extends (0, $NdCUR.PureComponent) {
    render() {
        const { description: description } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("article", {
            className: "flux-functions-toolbar--description"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-functions-toolbar--heading"
        }, "Description"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", null, description));
    }
}
var $c546ea5764ae41d9$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($c546ea5764ae41d9$var$TooltipDescription);


// Libraries

var $NdCUR = parcelRequire("NdCUR");

class $2f20a00fd450cf1a$var$TooltipArguments extends (0, $NdCUR.PureComponent) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("article", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-functions-toolbar--heading"
        }, "Arguments"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-functions-toolbar--snippet"
        }, this.arguments));
    }
    get arguments() {
        const { argsList: argsList } = this.props;
        if (argsList.length > 0) return argsList.map((a)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                className: "flux-functions-toolbar--arguments",
                key: a.name
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", null, a.name, ":"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", null, a.type), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null, a.desc));
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-functions-toolbar--arguments"
        }, "None");
    }
}
var $2f20a00fd450cf1a$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($2f20a00fd450cf1a$var$TooltipArguments);


// Libraries

var $NdCUR = parcelRequire("NdCUR");

class $51c19965a86d7c11$var$TooltipExample extends (0, $NdCUR.PureComponent) {
    render() {
        const { example: example } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("article", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-functions-toolbar--heading"
        }, "Example"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-functions-toolbar--snippet"
        }, example));
    }
}
var $51c19965a86d7c11$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($51c19965a86d7c11$var$TooltipExample);


// Libraries

var $NdCUR = parcelRequire("NdCUR");

class $6c64c9dafc72d61f$var$TooltipLink extends (0, $NdCUR.PureComponent) {
    render() {
        const { link: link } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, "Still have questions? Check out the", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("a", {
            target: "_blank",
            href: link
        }, "Flux Docs"), ".");
    }
}
var $6c64c9dafc72d61f$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($6c64c9dafc72d61f$var$TooltipLink);



const $6040b3d9a71b7603$var$MAX_HEIGHT = 400;
class $6040b3d9a71b7603$var$FunctionTooltip extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.tooltipRef = /*#__PURE__*/ (0, $NdCUR.createRef)(), this.handleDismiss = (e)=>{
            const { onDismiss: onDismiss } = this.props;
            e.preventDefault();
            e.stopPropagation();
            onDismiss();
        };
        this.state = {
            bottomPosition: null
        };
    }
    componentDidMount() {
        const { bottom: bottom, height: height } = this.tooltipRef.current.getBoundingClientRect();
        if (bottom > window.innerHeight) this.setState({
            bottomPosition: height / 2
        });
    }
    render() {
        const { func: { desc: desc, args: args, example: example, link: link } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            style: this.stylePosition,
            className: "flux-functions-toolbar--tooltip",
            ref: this.tooltipRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "flux-functions-toolbar--tooltip-dismiss",
            onClick: this.handleDismiss
        }), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-functions-toolbar--tooltip-contents"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), {
            autoHeight: true,
            maxHeight: $6040b3d9a71b7603$var$MAX_HEIGHT,
            autoHide: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c546ea5764ae41d9$export$2e2bcd8739ae039), {
            description: desc
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $2f20a00fd450cf1a$export$2e2bcd8739ae039), {
            argsList: args
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $51c19965a86d7c11$export$2e2bcd8739ae039), {
            example: example
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $6c64c9dafc72d61f$export$2e2bcd8739ae039), {
            link: link
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "flux-functions-toolbar--tooltip-caret",
            style: this.styleCaretPosition
        }));
    }
    get styleCaretPosition() {
        const { tipPosition: { top: top, right: right } } = this.props;
        return {
            top: `${Math.min(top, window.innerHeight)}px`,
            right: `${right + 4}px`
        };
    }
    get stylePosition() {
        const { tipPosition: { top: top, right: right } } = this.props;
        const { bottomPosition: bottomPosition } = this.state;
        return {
            bottom: `${bottomPosition || window.innerHeight - top - 15}px`,
            right: `${right + 2}px`
        };
    }
}
var $6040b3d9a71b7603$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($6040b3d9a71b7603$var$FunctionTooltip);



class $52db437e61a56f16$var$ToolbarFunction extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.functionRef = /*#__PURE__*/ (0, $NdCUR.createRef)(), this.handleHover = ()=>{
            const { top: top, left: left } = this.functionRef.current.getBoundingClientRect();
            const right = window.innerWidth - left;
            this.setState({
                isActive: true,
                hoverPosition: {
                    top: top,
                    right: right
                }
            });
        }, this.handleStopHover = ()=>{
            this.setState({
                isActive: false
            });
        }, this.handleClickFunction = ()=>{
            const { func: func, onClickFunction: onClickFunction } = this.props;
            onClickFunction(func);
        };
        this.state = {
            isActive: false,
            hoverPosition: undefined
        };
    }
    render() {
        const { func: func } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-functions-toolbar--function",
            ref: this.functionRef,
            onMouseEnter: this.handleHover,
            onMouseLeave: this.handleStopHover
        }, this.tooltip, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("dd", {
            onClick: this.handleClickFunction
        }, func.name, " ", this.helperText));
    }
    get tooltip() {
        if (this.state.isActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $6040b3d9a71b7603$export$2e2bcd8739ae039), {
            func: this.props.func,
            onDismiss: this.handleStopHover,
            tipPosition: this.state.hoverPosition
        });
    }
    get helperText() {
        if (this.state.isActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "flux-functions-toolbar--helper"
        }, "Click to Add");
    }
}
var $52db437e61a56f16$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($52db437e61a56f16$var$ToolbarFunction);



class $b80d0662c69b8fa7$var$FunctionCategory extends (0, $NdCUR.PureComponent) {
    render() {
        const { category: category, funcs: funcs, onClickFunction: onClickFunction } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("dl", {
            className: "flux-functions-toolbar--category"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("dt", null, category), funcs.map((func)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $52db437e61a56f16$export$2e2bcd8739ae039), {
                onClickFunction: onClickFunction,
                key: func.name,
                func: func
            })));
    }
}
var $b80d0662c69b8fa7$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($b80d0662c69b8fa7$var$FunctionCategory);


// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");



class $18a73859436fc264$var$SearchBar extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleSearch = ()=>{
            this.props.onSearch(this.state.searchTerm);
        }, this.handleChange = (e)=>{
            this.setState({
                searchTerm: e.target.value
            }, this.handleSearch);
        };
        this.state = {
            searchTerm: ''
        };
    }
    componentDidMount() {
        const waitPeriod = 100;
        this.handleSearch = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).debounce(this.handleSearch, waitPeriod);
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-functions-toolbar--search"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $86817c9e53a28f66$export$2e2bcd8739ae039), {
            type: (0, $86817c9e53a28f66$export$476dfc2401bc286b).Text,
            icon: (0, $918c9f03a35fe03f$export$62c9c0cf752cde38).Search,
            placeholder: "Filter Functions...",
            onChange: this.handleChange,
            value: this.state.searchTerm
        }));
    }
}
var $18a73859436fc264$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($18a73859436fc264$var$SearchBar);



const $f3c6a3e5c6466088$export$18bbd41dfe510229 = {
    name: 'from',
    args: [
        {
            name: 'bucket',
            desc: 'Name of the bucket to query.',
            type: 'String'
        },
        {
            name: 'bucketID',
            desc: 'String-encoded bucket ID to query.',
            type: 'String'
        },
        {
            name: 'host',
            desc: 'URL of the InfluxDB instance to query.',
            type: 'String'
        },
        {
            name: 'org',
            desc: 'Organization name.',
            type: 'String'
        },
        {
            name: 'orgID',
            desc: 'String-encoded organization ID to query.',
            type: 'String'
        },
        {
            name: 'token',
            desc: 'InfluxDB API token.',
            type: 'String'
        }
    ],
    package: '',
    desc: 'Queries data from an InfluxDB data source.',
    example: 'from(bucket: "example-bucket")',
    category: 'Inputs',
    link: 'https://docs.influxdata.com/flux/v0/stdlib/influxdata/influxdb/from/'
};
const $f3c6a3e5c6466088$export$ab16b6888600a62 = {
    name: 'range',
    args: [
        {
            name: 'start',
            desc: 'Earliest time to include in results.',
            type: 'Duration | Time'
        },
        {
            name: 'stop',
            desc: 'Latest time to include in results. Default is `now()`.',
            type: 'Duration | Time'
        }
    ],
    package: '',
    desc: 'Filters rows based on time bounds.',
    example: 'range(start: -12h)',
    category: 'Transformations',
    link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/range/'
};
const $f3c6a3e5c6466088$export$45d7b2022dbf6f60 = {
    name: 'mean',
    args: [
        {
            name: 'column',
            desc: 'Column to use to compute means. Default is `_value`.',
            type: 'String'
        }
    ],
    package: '',
    desc: 'Returns the average of non-null values in a specified column from each input table.',
    example: 'mean()',
    category: 'Aggregates',
    link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/mean/'
};
const $f3c6a3e5c6466088$export$36eaf5aa2923fe81 = {
    name: 'union',
    args: [
        {
            name: 'tables',
            desc: 'List of two or more streams of tables to union together.',
            type: 'Array of Strings'
        }
    ],
    package: '',
    desc: 'Merges two or more input streams into a single output stream.',
    example: 'union(tables: [t1, t2])',
    category: 'Transformations',
    link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/union/'
};
const $f3c6a3e5c6466088$export$cce5e961b94c702 = {
    name: 'math.abs',
    args: [
        {
            name: 'x',
            desc: 'Value to operate on.',
            type: 'Float'
        }
    ],
    package: 'math',
    desc: 'Returns the absolute value of `x`.',
    example: 'math.abs(x: -1.22)',
    category: 'Transformations',
    link: 'https://docs.influxdata.com/flux/v0/stdlib/math/abs/'
};
const $f3c6a3e5c6466088$export$cb3e7ee0cee6eda6 = {
    name: 'math.floor',
    args: [
        {
            name: 'x',
            desc: 'Value to operate on.',
            type: 'Float'
        }
    ],
    package: 'math',
    desc: 'Returns the greatest integer value less than or equal to `x`.',
    example: 'math.floor(x: 1.22)',
    category: 'Transformations',
    link: 'https://docs.influxdata.com/flux/v0/stdlib/math/floor/'
};
const $f3c6a3e5c6466088$export$1d6c461d480e7b01 = {
    name: 'strings.title',
    args: [
        {
            name: 'v',
            desc: 'String value to convert.',
            type: 'String'
        }
    ],
    package: 'strings',
    desc: 'Converts a string to title case.',
    example: 'strings.title(v: r._value)',
    category: 'Transformations',
    link: 'https://docs.influxdata.com/flux/v0/stdlib/strings/title/'
};
const $f3c6a3e5c6466088$export$ec513df0dfe23b76 = {
    name: 'strings.trim',
    args: [
        {
            name: 'v',
            desc: 'String to remove characters from.',
            type: 'String'
        },
        {
            name: 'cutset',
            desc: 'Leading and trailing characters to remove from the string.',
            type: 'String'
        }
    ],
    package: 'strings',
    desc: 'Removes leading and trailing characters specified in the cutset from a string.',
    example: 'strings.trim(v: r._value, cutset: "smpl_")',
    category: 'Transformations',
    link: 'https://docs.influxdata.com/flux/v0/stdlib/strings/trim/'
};
const $f3c6a3e5c6466088$export$599f8541cd7f6f57 = [
    {
        name: 'aggregate.rate',
        args: [
            {
                name: 'every',
                desc: 'Duration of time windows.',
                type: 'Duration'
            },
            {
                name: 'groupColumns',
                desc: 'List of columns to group by. Default is `[]`.',
                type: 'Array of Strings'
            },
            {
                name: 'unit',
                desc: 'Time duration to use when calculating the rate. Default is `1s`.',
                type: 'Array of Strings'
            }
        ],
        package: 'experimental/aggregate',
        desc: 'Calculates the average rate of increase per window of time for each input table.',
        example: 'aggregate.rate(every: 30s, unit: 1s, groupColumns: ["tag"])',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/aggregate/rate/'
    },
    {
        name: 'aggregateWindow',
        args: [
            {
                name: 'every',
                desc: 'Duration of time between windows.',
                type: 'Duration'
            },
            {
                name: 'period',
                desc: 'Duration of windows. Default is the `every` value.',
                type: 'Duration'
            },
            {
                name: 'offset',
                desc: 'Duration to shift the window boundaries by. Default is `0s`.',
                type: 'Duration'
            },
            {
                name: 'fn',
                desc: 'Aggregate or selector function to apply to each time window.',
                type: 'Unquoted String'
            },
            {
                name: 'location',
                desc: 'Location used to determine timezone. Default is the `location` option.',
                type: 'Object'
            },
            {
                name: 'column',
                desc: 'Column to operate on.',
                type: 'String'
            },
            {
                name: 'timeSrc',
                desc: 'Column to use as the source of the new time value for aggregate values.',
                type: 'String'
            },
            {
                name: 'timeDst',
                desc: 'Column to store time values for aggregate values in.',
                type: 'String'
            },
            {
                name: 'createEmpty',
                desc: 'Create empty tables for empty window. Default is `true`.',
                type: 'Boolean'
            }
        ],
        package: '',
        desc: 'Downsamples data by grouping data into fixed windows of time and applying an aggregate or selector function to each window.',
        example: 'aggregateWindow(every: 20s, fn: mean)',
        category: 'Aggregates',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/aggregatewindow/'
    },
    {
        name: 'bigtable.from',
        args: [
            {
                name: 'token',
                desc: 'Google Cloud IAM token to use to access the Cloud Bigtable database.',
                type: 'String'
            },
            {
                name: 'project',
                desc: 'Cloud Bigtable project ID.',
                type: 'String'
            },
            {
                name: 'instance',
                desc: 'Cloud Bigtable instance ID.',
                type: 'String'
            },
            {
                name: 'table',
                desc: 'Cloud Bigtable table name.',
                type: 'String'
            }
        ],
        package: 'experimental/bigtable',
        desc: 'Retrieves data from a Google Cloud Bigtable (https://cloud.google.com/bigtable/) data source.',
        example: 'bigtable.from( token: "example-token", project: "example-project", instance: "example-instance", table: "example-table")',
        category: 'Inputs',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/bigtable/from/'
    },
    {
        name: 'bool',
        args: [
            {
                name: 'v',
                desc: 'Value to convert.',
                type: 'String, Integer, UInteger, Float'
            }
        ],
        package: '',
        desc: 'Converts a value to a boolean type.',
        example: 'bool(v: "true")',
        category: 'Type Conversions',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/bool/'
    },
    {
        name: 'bottom',
        args: [
            {
                name: 'n',
                desc: 'Number of rows to return from each input table.',
                type: 'Integer'
            },
            {
                name: 'columns',
                desc: 'List of columns to sort by. Default is `["_value"]`.',
                type: 'Array of Strings'
            }
        ],
        package: '',
        desc: 'Sorts each input table by specified columns and keeps the bottom `n` records in each table.',
        example: 'bottom(n: 2)',
        category: 'Selectors',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/bottom/'
    },
    {
        name: 'bytes',
        args: [
            {
                name: 'v',
                desc: 'Value to convert.',
                type: 'String, Integer, UInteger, Float, Boolean'
            }
        ],
        package: '',
        desc: 'Converts a string value to a bytes type.',
        example: 'bytes(v: "Example string")',
        category: 'Type Conversions',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/bytes/'
    },
    {
        name: 'chandeMomentumOscillator',
        args: [
            {
                name: 'n',
                desc: 'Period or number of points to use in the calculation.',
                type: 'Integer'
            },
            {
                name: 'columns',
                desc: 'List of columns to operate on. Default is `["_value"]`.',
                type: 'Array of Strings`'
            }
        ],
        package: '',
        desc: 'Applies the technical momentum indicator developed by Tushar Chande to input data.',
        example: 'chandeMomentumOscillator(n: 2)',
        category: 'Aggregates',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/chandemomentumoscillator/'
    },
    {
        name: 'columns',
        args: [
            {
                name: 'column',
                desc: 'Name of the output column to store column labels in.',
                type: 'String'
            }
        ],
        package: '',
        desc: 'Returns the column labels in each input table.',
        example: 'columns(column: "labels")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/columns/'
    },
    {
        name: 'contains',
        args: [
            {
                name: 'value',
                desc: 'Value to search for.',
                type: 'Boolean, Integer, UInteger, Float, String, Time'
            },
            {
                name: 'set',
                desc: 'Array to search.',
                type: 'Boolean, Integer, UInteger, Float, String, Time'
            }
        ],
        package: '',
        desc: 'Tests if an array contains a specified value and returns `true` or `false`.',
        example: 'contains(value: r._field, set: fields)',
        category: 'Tests',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/contains/'
    },
    {
        name: 'count',
        args: [
            {
                name: 'column',
                desc: 'Column to count values in and store the total count.',
                type: 'String'
            }
        ],
        package: '',
        desc: 'Returns the number of records in each input table.',
        example: 'count()',
        category: 'Aggregates',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/count/'
    },
    {
        name: 'cov',
        args: [
            {
                name: 'x',
                desc: 'First input stream.',
                type: 'Object'
            },
            {
                name: 'y',
                desc: 'Second input stream.',
                type: 'Object'
            },
            {
                name: 'on',
                desc: 'List of columns to join on.',
                type: 'Array of Strings'
            },
            {
                name: 'pearsonr',
                desc: 'Normalize results to the Pearson R coefficient. Default is `false`.',
                type: 'Boolean'
            }
        ],
        package: '',
        desc: 'Computes the covariance between two streams of tables.',
        example: 'cov(x: stream1, y: stream2, on: ["_time"])',
        category: 'Aggregates',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/cov/'
    },
    {
        name: 'covariance',
        args: [
            {
                name: 'columns',
                desc: 'List of two columns to operate on.',
                type: 'Array of Strings'
            },
            {
                name: 'pearsonr',
                desc: 'Normalize results to the Pearson R coefficient. Default is `false`.',
                type: 'Boolean'
            },
            {
                name: 'valueDst',
                desc: 'Column to store the result in. Default is `_value`.',
                type: 'String'
            }
        ],
        package: '',
        desc: 'Computes the covariance between two columns.',
        example: 'covariance(columns: ["x", "y"])',
        category: 'Aggregates',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/covariance/'
    },
    {
        name: 'csv.from (file)',
        args: [
            {
                name: 'file',
                desc: 'File path of the CSV file to query.',
                type: 'String'
            }
        ],
        package: 'csv',
        desc: 'Retrieves data from a comma separated value (CSV) data source and returns a stream of tables.',
        example: 'csv.from(file: path)',
        category: 'Inputs',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/csv/from/'
    },
    {
        name: 'csv.from (csvData)',
        args: [
            {
                name: 'csv',
                desc: 'CSV data.',
                type: 'String'
            }
        ],
        package: 'csv',
        desc: 'Retrieves data from a comma separated value (CSV) data source and returns a stream of tables.',
        example: 'csv.from(csv: csvData)',
        category: 'Inputs',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/csv/from/'
    },
    {
        name: 'csv.from (url)',
        args: [
            {
                name: 'url',
                desc: 'URL to retrieve annotated CSV from.',
                type: 'String'
            }
        ],
        package: 'experimental/csv',
        desc: 'Retrieves annotated CSV (/influxdb/v2/reference/syntax/annotated-csv/) **from a URL**.',
        example: 'csv.from(url: "http://example.com/data.csv")',
        category: 'Inputs',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/csv/from/'
    },
    {
        name: 'cumulativeSum',
        args: [
            {
                name: 'columns',
                desc: 'List of columns to operate on. Default is `["_value"]`.',
                type: 'Array of Strings'
            }
        ],
        package: '',
        desc: 'Computes a running sum for non-null records in a table.',
        example: 'cumulativeSum()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/cumulativesum/'
    },
    {
        name: 'date.hour',
        args: [
            {
                name: 't',
                desc: 'Time to operate on.',
                type: 'Time'
            },
            {
                name: 'location',
                desc: 'Location used to determine timezone.',
                type: 'Object'
            }
        ],
        package: 'date',
        desc: 'Returns the hour of a specified time. Results range from `[0 - 23]`.',
        example: 'date.hour(t: 2020-02-11T12:21:03.29353494Z)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/date/hour/'
    },
    {
        name: 'date.microsecond',
        args: [
            {
                name: 't',
                desc: 'Time to operate on.',
                type: 'Time'
            }
        ],
        package: 'date',
        desc: 'Returns the microseconds for a specified time. Results range `from [0-999999]`.',
        example: 'date.microsecond(t: 2020-02-11T12:21:03.29353494Z)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/date/microsecond/'
    },
    {
        name: 'date.millisecond',
        args: [
            {
                name: 't',
                desc: 'Time to operate on.',
                type: 'Time'
            }
        ],
        package: 'date',
        desc: 'Returns the milliseconds for a specified time. Results range from `[0-999]`.',
        example: 'date.millisecond(t: 2020-02-11T12:21:03.29353494Z)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/date/millisecond/'
    },
    {
        name: 'date.minute',
        args: [
            {
                name: 't',
                desc: 'Time to operate on.',
                type: 'Time'
            },
            {
                name: 'location',
                desc: 'Location used to determine timezone.',
                type: 'Object'
            }
        ],
        package: 'date',
        desc: 'Returns the minute of a specified time. Results range from `[0 - 59]`.',
        example: 'date.minute(t: 2020-02-11T12:21:03.29353494Z)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/date/minute/'
    },
    {
        name: 'date.month',
        args: [
            {
                name: 't',
                desc: 'Time to operate on.',
                type: 'Time'
            },
            {
                name: 'location',
                desc: 'Location used to determine timezone.',
                type: 'Object'
            }
        ],
        package: 'date',
        desc: 'Returns the month of a specified time. Results range from `[1 - 12]`.',
        example: 'date.month(t: 2020-02-11T12:21:03.29353494Z)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/date/month/'
    },
    {
        name: 'date.monthDay',
        args: [
            {
                name: 't',
                desc: 'Time to operate on.',
                type: 'Time'
            },
            {
                name: 'location',
                desc: 'Location used to determine timezone.',
                type: 'Object'
            }
        ],
        package: 'date',
        desc: 'Returns the day of the month for a specified time. Results range from `[1 - 31]`.',
        example: 'date.monthDay(t: 2020-02-11T12:21:03.29353494Z)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/date/monthday/'
    },
    {
        name: 'date.nanosecond',
        args: [
            {
                name: 't',
                desc: 'Time to operate on.',
                type: 'Time'
            }
        ],
        package: 'date',
        desc: 'Returns the nanoseconds for a specified time. Results range from `[0-999999999]`.',
        example: 'date.nanosecond(t: 2020-02-11T12:21:03.29353494Z)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/date/nanosecond/'
    },
    {
        name: 'date.quarter',
        args: [
            {
                name: 't',
                desc: 'Time to operate on.',
                type: 'Time'
            },
            {
                name: 'location',
                desc: 'Location used to determine timezone.',
                type: 'Object'
            }
        ],
        package: 'date',
        desc: 'Returns the quarter for a specified time. Results range from `[1-4]`.',
        example: 'date.quarter(t: 2020-02-11T12:21:03.29353494Z)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/date/quarter/'
    },
    {
        name: 'date.second',
        args: [
            {
                name: 't',
                desc: 'Time to operate on.',
                type: 'Time'
            }
        ],
        package: 'date',
        desc: 'Returns the second of a specified time. Results range from `[0 - 59]`.',
        example: 'date.second(t: 2020-02-11T12:21:03.29353494Z)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/date/second/'
    },
    {
        name: 'date.truncate',
        args: [
            {
                name: 't',
                desc: 'Time to operate on.',
                type: 'Time'
            },
            {
                name: 'unit',
                desc: 'Unit of time to truncate to.',
                type: 'Duration'
            },
            {
                name: 'location',
                desc: 'Location used to determine timezone.',
                type: 'Object'
            }
        ],
        package: 'date',
        desc: 'Returns a time truncated to the specified duration unit.',
        example: 'date.truncate(t: 2019-06-03T13:59:01Z, unit: 1s)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/date/truncate/'
    },
    {
        name: 'date.week',
        args: [
            {
                name: 't',
                desc: 'Time to operate on.',
                type: 'Time'
            },
            {
                name: 'location',
                desc: 'Location used to determine timezone.',
                type: 'Object'
            }
        ],
        package: 'date',
        desc: 'Returns the ISO week of the year for a specified time. Results range from `[1 - 53]`.',
        example: 'date.week(t: 2020-02-11T12:21:03.29353494Z)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/date/week/'
    },
    {
        name: 'date.weekDay',
        args: [
            {
                name: 't',
                desc: 'Time to operate on.',
                type: 'Time'
            },
            {
                name: 'location',
                desc: 'Location used to determine timezone.',
                type: 'Object'
            }
        ],
        package: 'date',
        desc: 'Returns the day of the week for a specified time. Results range from `[0 - 6]`.',
        example: 'date.weekDay(t: 2020-02-11T12:21:03.29353494Z)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/date/weekday/'
    },
    {
        name: 'date.year',
        args: [
            {
                name: 't',
                desc: 'Time to operate on.',
                type: 'Time'
            },
            {
                name: 'location',
                desc: 'Location used to determine timezone.',
                type: 'Object'
            }
        ],
        package: 'date',
        desc: 'Returns the year of a specified time.',
        example: 'date.year(t: 2020-02-11T12:21:03.29353494Z)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/date/year/'
    },
    {
        name: 'date.yearDay',
        args: [
            {
                name: 't',
                desc: 'Time to operate on.',
                type: 'Time'
            },
            {
                name: 'location',
                desc: 'Location used to determine timezone.',
                type: 'Object'
            }
        ],
        package: 'date',
        desc: 'Returns the day of the year for a specified time. Results can include leap days and range from `[1 - 366]`.',
        example: 'date.yearDay(t: 2020-02-11T12:21:03.29353494Z)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/date/yearday/'
    },
    {
        name: 'derivative',
        args: [
            {
                name: 'unit',
                desc: 'Time duration used to calculate the derivative. Default is `1s`.',
                type: 'Duration'
            },
            {
                name: 'nonNegative',
                desc: 'Disallow negative derivative values. Default is `false`.',
                type: 'Boolean'
            },
            {
                name: 'columns',
                desc: 'List of columns to operate on. Default is `["_value"]`.',
                type: 'Array of Strings'
            },
            {
                name: 'timeColumn',
                desc: 'Column containing time values to use in the calculation.',
                type: 'String'
            },
            {
                name: 'initialZero',
                desc: 'Use zero (0) as the initial value in the derivative calculation',
                type: 'Boolean'
            }
        ],
        package: '',
        desc: 'Computes the rate of change per unit of time between subsequent non-null records.',
        example: 'derivative(nonNegative: true)',
        category: 'Aggregates',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/derivative/'
    },
    {
        name: 'difference',
        args: [
            {
                name: 'nonNegative',
                desc: 'Disallow negative differences. Default is `false`.',
                type: 'Boolean'
            },
            {
                name: 'columns',
                desc: 'List of columns to operate on. Default is `["_value"]`.',
                type: 'Array of Strings'
            },
            {
                name: 'keepFirst',
                desc: 'Keep the first row in each input table. Default is `false`.',
                type: 'Boolean'
            },
            {
                name: 'initialZero',
                desc: 'Use zero (0) as the initial value in the difference calculation',
                type: 'Boolean'
            }
        ],
        package: '',
        desc: 'Returns the difference between subsequent values.',
        example: 'difference()',
        category: 'Aggregates',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/difference/'
    },
    {
        name: 'distinct',
        args: [
            {
                name: 'column',
                desc: 'Column to return unique values from. Default is `_value`.',
                type: 'String'
            }
        ],
        package: '',
        desc: 'Returns all unique values in a specified column.',
        example: 'distinct()',
        category: 'Selectors',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/distinct/'
    },
    {
        name: 'doubleEMA',
        args: [
            {
                name: 'n',
                desc: 'Number of points to average.',
                type: 'Integer'
            }
        ],
        package: '',
        desc: 'Returns the double exponential moving average (DEMA) of values in the `_value` column grouped into `n` number of points, giving more weight to recent data.',
        example: 'doubleEMA(n: 3)',
        category: 'Aggregates',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/doubleema/'
    },
    {
        name: 'drop',
        args: [
            {
                name: 'columns',
                desc: 'List of columns to remove from input tables. Mutually exclusive with `fn`.',
                type: 'Array of Strings'
            },
            {
                name: 'fn',
                desc: 'Predicate function with a `column` parameter that returns a boolean',
                type: 'Function'
            }
        ],
        package: '',
        desc: 'Removes specified columns from a table.',
        example: 'drop(columns: ["_time", "tag"])',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/drop/'
    },
    {
        name: 'duplicate',
        args: [
            {
                name: 'column',
                desc: 'Column to duplicate.',
                type: 'String'
            },
            {
                name: 'as',
                desc: 'Name to assign to the duplicate column.',
                type: 'String'
            }
        ],
        package: '',
        desc: 'Duplicates a specified column in a table.',
        example: 'duplicate(column: "tag", as: "tag_dup")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/duplicate/'
    },
    {
        name: 'duration',
        args: [
            {
                name: 'v',
                desc: 'Value to convert.',
                type: 'String'
            }
        ],
        package: '',
        desc: 'Converts a value to a duration type.',
        example: 'duration(v: "1h20m")',
        category: 'Type Conversions',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/duration/'
    },
    {
        name: 'experimental.addDuration',
        args: [
            {
                name: 'd',
                desc: 'Duration to add.',
                type: 'Duration'
            },
            {
                name: 'to',
                desc: 'Time to add the duration to.',
                type: 'Time'
            },
            {
                name: 'location',
                desc: 'Location to use for the time value.',
                type: 'Object'
            }
        ],
        package: 'experimental',
        desc: 'Adds a duration to a time value and returns the resulting time value.',
        example: 'experimental.addDuration(d: 6h, to: 2019-09-16T12:00:00Z)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/addduration/'
    },
    {
        name: 'experimental.group',
        args: [
            {
                name: 'columns',
                desc: 'List of columns to use in the grouping operation. Default is `[]`.',
                type: 'Array of Strings'
            },
            {
                name: 'mode',
                desc: 'Grouping mode. `extend` is the only mode available to `experimental.group()`.',
                type: 'String'
            }
        ],
        package: 'experimental',
        desc: 'Introduces an `extend` mode to the existing `group()` function.',
        example: 'experimental.group(columns: ["region"], mode: "extend")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/group/'
    },
    {
        name: 'experimental.join',
        args: [
            {
                name: 'left',
                desc: 'First of two streams of tables to join.',
                type: 'Stream of tables'
            },
            {
                name: 'right',
                desc: 'Second of two streams of tables to join.',
                type: 'Stream of tables'
            },
            {
                name: 'fn',
                desc: 'Function with left and right arguments that maps a new output record',
                type: 'Function'
            }
        ],
        package: 'experimental',
        desc: 'Joins two streams of tables on the **group key and `_time` column**.',
        example: 'experimental.join( left: left, right: right, fn: (left, right) => ({left with lv: left._value, rv: right._value, diff: left._value - right._value}))',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/join/'
    },
    {
        name: 'experimental.objectKeys',
        args: [
            {
                name: 'o',
                desc: 'Record to return property keys from.',
                type: 'Object'
            }
        ],
        package: 'experimental',
        desc: 'Returns an array of property keys in a specified record.',
        example: 'experimental.objectKeys(o: user)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/objectkeys/'
    },
    {
        name: 'experimental.set',
        args: [
            {
                name: 'o',
                desc: 'Record that defines the columns and values to set.',
                type: 'Object'
            }
        ],
        package: 'experimental',
        desc: 'Sets multiple static column values on all records.',
        example: 'experimental.set(o: {_field: "temperature", unit: "\xb0F", location: "San Francisco"})',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/set/'
    },
    {
        name: 'experimental.subDuration',
        args: [
            {
                name: 'from',
                desc: 'Time to subtract the duration from.',
                type: 'Time'
            },
            {
                name: 'd',
                desc: 'Duration to subtract.',
                type: 'Duration'
            },
            {
                name: 'location',
                desc: 'Location to use for the time value.',
                type: 'Object'
            }
        ],
        package: 'experimental',
        desc: 'Subtracts a duration from a time value and returns the resulting time value.',
        example: 'experimental.subDuration(from: 2019-09-16T12:00:00Z, d: 6h)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/subduration/'
    },
    {
        name: 'experimental.to',
        args: [
            {
                name: 'bucket',
                desc: 'Name of the bucket to write to.',
                type: 'String'
            },
            {
                name: 'bucketID',
                desc: 'String-encoded bucket ID to to write to.',
                type: 'String'
            },
            {
                name: 'host',
                desc: 'URL of the InfluxDB instance to write to.',
                type: 'String'
            },
            {
                name: 'org',
                desc: 'Organization name.',
                type: 'String'
            },
            {
                name: 'orgID',
                desc: 'String-encoded organization ID to query.',
                type: 'String'
            },
            {
                name: 'token',
                desc: 'InfluxDB API token.',
                type: 'String'
            }
        ],
        package: 'experimental',
        desc: 'Writes _pivoted_ data to an InfluxDB 2.x or InfluxDB Cloud bucket.',
        example: 'experimental.to(bucket: "example-target-bucket")',
        category: 'Outputs',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/to/'
    },
    {
        name: 'elapsed',
        args: [
            {
                name: 'unit',
                desc: 'Unit of time used in the calculation. Default is `1s`.',
                type: 'Duration'
            },
            {
                name: 'timeColumn',
                desc: 'Column to use to compute the elapsed time. Default is `_time`.',
                type: 'String`'
            },
            {
                name: 'columnName',
                desc: 'Column to store elapsed times in. Default is `elapsed`.',
                type: 'String'
            }
        ],
        package: '',
        desc: 'Returns the time between subsequent records.',
        example: 'elapsed(unit: 1s)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/elapsed/'
    },
    {
        name: 'exponentialMovingAverage',
        args: [
            {
                name: 'n',
                desc: 'Number of values to average.',
                type: 'Integer'
            }
        ],
        package: '',
        desc: 'Calculates the exponential moving average of `n` number of values in the `_value` column giving more weight to more recent data.',
        example: 'exponentialMovingAverage(n: 3)',
        category: 'Aggregates',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/exponentialmovingaverage/'
    },
    {
        name: 'fill',
        args: [
            {
                name: 'column',
                desc: 'Column to replace null values in. Default is `_value`.',
                type: 'String'
            },
            {
                name: 'value',
                desc: 'Constant value to replace null values with.',
                type: 'Value type of `column`'
            },
            {
                name: 'usePrevious',
                desc: 'Replace null values with the previous non-null value.',
                type: 'Boolean'
            }
        ],
        package: '',
        desc: 'Replaces all null values in input tables with a non-null value.',
        example: 'fill(value: 0)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/fill/'
    },
    {
        name: 'filter',
        args: [
            {
                name: 'fn',
                desc: 'Single argument predicate function that evaluates `true` or `false`.',
                type: 'Function'
            },
            {
                name: 'onEmpty',
                desc: 'Action to take with empty tables. Default is `drop`.',
                type: 'String'
            }
        ],
        package: '',
        desc: 'Filters data based on conditions defined in a predicate function (`fn`).',
        example: 'filter( fn: (r) => r._measurement == "cpu" and r._field == "usage_system" and r.cpu == "cpu-total")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/filter/'
    },
    {
        name: 'first',
        args: [
            {
                name: 'column',
                desc: 'Column to operate on. Default is `_value`.',
                type: 'String'
            }
        ],
        package: '',
        desc: 'Returns the first non-null record from each input table.',
        example: 'first()',
        category: 'Selectors',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/first/'
    },
    {
        name: 'float',
        args: [
            {
                name: 'v',
                desc: 'Value to convert.',
                type: 'String, Integer, UInteger, Boolean'
            }
        ],
        package: '',
        desc: 'Converts a value to a float type.',
        example: 'float(v: "3.14")',
        category: 'Type Conversions',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/float/'
    },
    {
        name: 'from',
        args: [
            {
                name: 'bucket',
                desc: 'Name of the bucket to query.',
                type: 'String'
            },
            {
                name: 'bucketID',
                desc: 'String-encoded bucket ID to query.',
                type: 'String'
            },
            {
                name: 'host',
                desc: 'URL of the InfluxDB instance to query.',
                type: 'String'
            },
            {
                name: 'org',
                desc: 'Organization name.',
                type: 'String'
            },
            {
                name: 'orgID',
                desc: 'String-encoded organization ID to query.',
                type: 'String'
            },
            {
                name: 'token',
                desc: 'InfluxDB API token.',
                type: 'String'
            }
        ],
        package: '',
        desc: 'Queries data from an InfluxDB data source.',
        example: 'from(bucket: "example-bucket")',
        category: 'Inputs',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/influxdata/influxdb/from/'
    },
    {
        name: 'geo.asTracks',
        args: [
            {
                name: 'groupBy',
                desc: 'Columns to group by. These columns should uniquely identify each track.',
                type: 'Array of Strings'
            },
            {
                name: 'orderBy',
                desc: 'Columns to order results by. Default is `["_time"]`.',
                type: 'Array of Strings'
            }
        ],
        package: 'experimental/geo',
        desc: 'Groups rows into tracks (sequential, related data points).',
        example: 'geo.asTracks()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/geo/astracks/'
    },
    {
        name: 'geo.filterRows',
        args: [
            {
                name: 'region',
                desc: 'Region containing the desired data points.',
                type: 'Object'
            },
            {
                name: 'minSize',
                desc: 'Minimum number of cells that cover the specified region.',
                type: 'Integer'
            },
            {
                name: 'maxSize',
                desc: 'Maximum number of cells that cover the specified region.',
                type: 'Object'
            },
            {
                name: 'level',
                desc: 'S2 cell level (https://s2geometry.io/resources/s2cell_statistics.html)',
                type: 'Integer'
            },
            {
                name: 's2cellIDLevel',
                desc: 'S2 cell level (https://s2geometry.io/resources/s2cell_statistics.html)',
                type: 'Integer'
            },
            {
                name: 'strict',
                desc: 'Enable strict geographic data filtering. Default is `true`.',
                type: 'Boolean'
            }
        ],
        package: 'experimental/geo',
        desc: 'Filters data by a specified geographic region with the option of strict filtering.',
        example: 'geo.filterRows(region: {lat: 40.69335938, lon: -73.30078125, radius: 100.0})',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/geo/filterrows/'
    },
    {
        name: 'geo.gridFilter',
        args: [
            {
                name: 'region',
                desc: 'Region containing the desired data points.',
                type: 'Object'
            },
            {
                name: 'minSize',
                desc: 'Minimum number of cells that cover the specified region.',
                type: 'Integer'
            },
            {
                name: 'maxSize',
                desc: 'Maximum number of cells that cover the specified region.',
                type: 'Object'
            },
            {
                name: 'level',
                desc: 'S2 cell level (https://s2geometry.io/resources/s2cell_statistics.html)',
                type: 'Integer'
            },
            {
                name: 's2cellIDLevel',
                desc: 'S2 cell level (https://s2geometry.io/resources/s2cell_statistics.html)',
                type: 'Integer'
            },
            {
                name: 'units',
                desc: 'Record that defines the unit of measurement for distance.',
                type: 'Object'
            }
        ],
        package: 'experimental/geo',
        desc: 'Filters data by a specified geographic region.',
        example: 'geo.gridFilter(region: {lat: 40.69335938, lon: -73.30078125, radius: 20.0})',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/geo/gridfilter/'
    },
    {
        name: 'geo.groupByArea',
        args: [
            {
                name: 'newColumn',
                desc: 'Name of the new column for the unique identifier for each geographic area.',
                type: 'String'
            },
            {
                name: 'level',
                desc: 'S2 Cell level (https://s2geometry.io/resources/s2cell_statistics.html)',
                type: 'Integer'
            },
            {
                name: 's2cellIDLevel',
                desc: 'S2 Cell level (https://s2geometry.io/resources/s2cell_statistics.html)',
                type: 'Integer'
            }
        ],
        package: 'experimental/geo',
        desc: 'Groups rows by geographic area.',
        example: 'geo.groupByArea(newColumn: "foo", level: 4)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/geo/groupbyarea/'
    },
    {
        name: 'geo.s2CellIDToken',
        args: [
            {
                name: 'token',
                desc: 'S2 cell ID token to update.',
                type: 'String'
            },
            {
                name: 'point',
                desc: 'Record with `lat` and `lon` properties that specify the latitude and',
                type: 'Object'
            },
            {
                name: 'level',
                desc: 'S2 cell level to use when generating the S2 cell ID token.',
                type: 'Integer'
            }
        ],
        package: 'experimental/geo',
        desc: 'Returns and S2 cell ID token for given cell or point at a specified S2 cell level.',
        example: 'geo.s2CellIDToken(point: {lat: r.lat, lon: r.lon}, level: 10)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/geo/s2cellidtoken/'
    },
    {
        name: 'geo.shapeData',
        args: [
            {
                name: 'latField',
                desc: 'Name of the existing field that contains the latitude value in decimal degrees (WGS 84).',
                type: 'String'
            },
            {
                name: 'lonField',
                desc: 'Name of the existing field that contains the longitude value in decimal degrees (WGS 84).',
                type: 'String'
            },
            {
                name: 'level',
                desc: 'S2 cell level (https://s2geometry.io/resources/s2cell_statistics.html)',
                type: 'Integer'
            }
        ],
        package: 'experimental/geo',
        desc: 'Renames existing latitude and longitude fields to **lat** and **lon** and adds an **s2\\_cell\\_id** tag.',
        example: 'geo.shapeData(latField: "latitude", lonField: "longitude", level: 10)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/geo/shapedata/'
    },
    {
        name: 'geo.strictFilter',
        args: [
            {
                name: 'region',
                desc: 'Region containing the desired data points.',
                type: 'Object'
            }
        ],
        package: 'experimental/geo',
        desc: 'Filters data by latitude and longitude in a specified region.',
        example: 'geo.strictFilter(region: {lat: 40.69335938, lon: -73.30078125, radius: 50.0})',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/geo/strictfilter/'
    },
    {
        name: 'geo.toRows',
        args: [],
        package: 'experimental/geo',
        desc: 'Pivots fields into columns based on time.',
        example: 'geo.toRows()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/geo/torows/'
    },
    {
        name: 'getColumn',
        args: [
            {
                name: 'column',
                desc: 'Column to extract.',
                type: 'String'
            },
            {
                name: 'table',
                desc: 'Input table. Default is piped-forward data (`<-`).',
                type: 'Stream of tables'
            }
        ],
        package: '',
        desc: 'Extracts a specified column from a table as an array.',
        example: 'getColumn(column: "_value")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/getcolumn/'
    },
    {
        name: 'getRecord',
        args: [
            {
                name: 'idx',
                desc: 'Index of the record to extract.',
                type: 'Integer'
            },
            {
                name: 'table',
                desc: 'Input table. Default is piped-forward data (`<-`).',
                type: 'Stream of tables'
            }
        ],
        package: '',
        desc: 'Extracts a row at a specified index from a table as a record.',
        example: 'getRecord(idx: 0)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/getrecord/'
    },
    {
        name: 'group',
        args: [
            {
                name: 'columns',
                desc: 'List of columns to use in the grouping operation. Default is `[]`.',
                type: 'Array of Strings'
            },
            {
                name: 'mode',
                desc: 'Grouping mode. Default is `by`.',
                type: 'String'
            }
        ],
        package: '',
        desc: 'Regroups input data by modifying group key of input tables.',
        example: 'group(columns: ["_time", "tag"])',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/group/'
    },
    {
        name: 'highestAverage',
        args: [
            {
                name: 'n',
                desc: 'Number of records to return.',
                type: 'Integer'
            },
            {
                name: 'column',
                desc: 'Column to evaluate. Default is `_value`.',
                type: 'String'
            },
            {
                name: 'groupColumns',
                desc: 'List of columns to group by. Default is `[]`.',
                type: 'Array of Strings'
            }
        ],
        package: '',
        desc: 'Calculates the average of each input table and returns the highest `n` averages.',
        example: 'highestAverage(n: 1, groupColumns: ["tag"])',
        category: 'Selectors',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/highestaverage/'
    },
    {
        name: 'highestCurrent',
        args: [
            {
                name: 'n',
                desc: 'Number of records to return.',
                type: 'Integer'
            },
            {
                name: 'column',
                desc: 'Column to evaluate. Default is `_value`.',
                type: 'String'
            },
            {
                name: 'groupColumns',
                desc: 'List of columns to group by. Default is `[]`.',
                type: 'Array of Strings'
            }
        ],
        package: '',
        desc: 'Selects the last record from each input table and returns the highest `n` records.',
        example: 'highestCurrent(n: 1, groupColumns: ["tag"])',
        category: 'Selectors',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/highestcurrent/'
    },
    {
        name: 'highestMax',
        args: [
            {
                name: 'n',
                desc: 'Number of records to return.',
                type: 'Integer'
            },
            {
                name: 'column',
                desc: 'Column to evaluate. Default is `_value`.',
                type: 'String'
            },
            {
                name: 'groupColumns',
                desc: 'List of columns to group by. Default is `[]`.',
                type: 'Array of Strings'
            }
        ],
        package: '',
        desc: 'Selects the record with the highest value in the specified `column` from each input table and returns the highest `n` records.',
        example: 'highestMax(n: 2, groupColumns: ["tag"])',
        category: 'Selectors',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/highestmax/'
    },
    {
        name: 'histogram',
        args: [
            {
                name: 'column',
                desc: 'Column containing input values. Column must be of type float.',
                type: 'Strings'
            },
            {
                name: 'upperBoundColumn',
                desc: 'Column to store bin upper bounds in. Default is `le`.',
                type: 'String'
            },
            {
                name: 'countColumn',
                desc: 'Column to store bin counts in. Default is `_value`.',
                type: 'String'
            },
            {
                name: 'bins',
                desc: 'List of upper bounds to use when computing the histogram frequencies.',
                type: 'Array of Floats'
            },
            {
                name: 'normalize',
                desc: 'Convert counts into frequency values between 0 and 1.',
                type: 'Boolean'
            }
        ],
        package: '',
        desc: 'Approximates the cumulative distribution of a dataset by counting data frequencies for a list of bins.',
        example: 'histogram(bins: [0.0, 5.0, 10.0, 20.0])',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/histogram/'
    },
    {
        name: 'histogramQuantile',
        args: [
            {
                name: 'quantile',
                desc: 'Quantile to compute. Value must be between 0 and 1.',
                type: 'Float'
            },
            {
                name: 'countColumn',
                desc: 'Column containing histogram bin counts. Default is `_value`.',
                type: 'String'
            },
            {
                name: 'upperBoundColumn',
                desc: 'Column containing histogram bin upper bounds.',
                type: 'String'
            },
            {
                name: 'valueColumn',
                desc: 'Column to store the computed quantile in. Default is `_value.',
                type: 'String'
            },
            {
                name: 'minValue',
                desc: 'Assumed minimum value of the dataset. Default is `0.0`.',
                type: 'Float'
            },
            {
                name: 'onNonmonotonic',
                desc: 'Describes behavior when counts are not monotonically increasing',
                type: 'String'
            }
        ],
        package: '',
        desc: 'Approximates a quantile given a histogram that approximates the cumulative distribution of the dataset.',
        example: 'histogramQuantile(quantile: 0.9)',
        category: 'Aggregates',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/histogramquantile/'
    },
    {
        name: 'holtWinters',
        args: [
            {
                name: 'n',
                desc: 'Number of values to predict.',
                type: 'Integer'
            },
            {
                name: 'interval',
                desc: 'Interval between two data points.',
                type: 'Duration'
            },
            {
                name: 'withFit',
                desc: 'Return fitted data in results. Default is `false`.',
                type: 'Boolean'
            },
            {
                name: 'column',
                desc: 'Column to operate on. Default is `_value`.',
                type: 'String'
            },
            {
                name: 'timeColumn',
                desc: 'Column containing time values to use in the calculating.',
                type: 'String'
            },
            {
                name: 'seasonality',
                desc: 'Number of points in a season. Default is `0`.',
                type: 'Integer'
            },
            {
                name: 'withMinSSE',
                desc: 'Return minSSE data in results. Default is `false`.',
                type: 'Boolean'
            }
        ],
        package: '',
        desc: 'Applies the Holt-Winters forecasting method to input tables.',
        example: 'holtWinters(n: 6, interval: 10s)',
        category: 'Aggregates',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/holtwinters/'
    },
    {
        name: 'hourSelection',
        args: [
            {
                name: 'start',
                desc: 'First hour of the hour range (inclusive). Hours range from `[0-23]`.',
                type: 'Integer'
            },
            {
                name: 'stop',
                desc: 'Last hour of the hour range (inclusive). Hours range from `[0-23]`.',
                type: 'Integer`'
            },
            {
                name: 'location',
                desc: 'Location used to determine timezone. Default is the `location` option.',
                type: 'Object'
            },
            {
                name: 'timeColumn',
                desc: 'Column that contains the time value. Default is `_time`.',
                type: 'String`'
            }
        ],
        package: '',
        desc: 'Filters rows by time values in a specified hour range.',
        example: 'hourSelection(start: 9, stop: 17)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/hourselection/'
    },
    {
        name: 'http.get',
        args: [
            {
                name: 'url',
                desc: 'URL to send the GET request to.',
                type: 'String'
            },
            {
                name: 'headers',
                desc: 'Headers to include with the GET request.',
                type: 'Object'
            },
            {
                name: 'timeout',
                desc: 'Timeout for the GET request. Default is `30s`.',
                type: 'Duration'
            }
        ],
        package: 'experimental/http',
        desc: 'Submits an HTTP GET request to the specified URL and returns the HTTP status code, response body, and response headers.',
        example: 'http.get( url: "http://localhost:8086/health", headers: {Authorization: "Token mY5up3RS3crE7t0k3N", Accept: "application/json"})',
        category: 'Miscellaneous',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/http/get/'
    },
    {
        name: 'http.post',
        args: [
            {
                name: 'url',
                desc: 'URL to send the POST request to.',
                type: 'String'
            },
            {
                name: 'headers',
                desc: 'Headers to include with the POST request.',
                type: 'Object'
            },
            {
                name: 'data',
                desc: 'Data body to include with the POST request.',
                type: 'Bytes'
            }
        ],
        package: 'http',
        desc: 'Sends an HTTP POST request to the specified URL with headers and data and returns the HTTP status code.',
        example: 'http.post( url: "http://myawsomeurl.com/api/notify", headers: {Authorization: "Bearer mySuPerSecRetTokEn", "Content-type": "application/json"}, data: json.encode(v: lastReported[0]))',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/http/post/'
    },
    {
        name: 'increase',
        args: [
            {
                name: 'columns',
                desc: 'List of columns to operate on. Default is `["_value"]`.',
                type: 'Array of Strings'
            }
        ],
        package: '',
        desc: 'Returns the cumulative sum of non-negative differences between subsequent values.',
        example: 'increase()',
        category: 'Aggregates',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/increase/'
    },
    {
        name: 'int',
        args: [
            {
                name: 'v',
                desc: 'Value to convert.',
                type: 'String, Integer, UInteger, Float, Boolean'
            }
        ],
        package: '',
        desc: 'Converts a value to an integer type.',
        example: 'int(v: 10.12)',
        category: 'Type Conversions',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/int/'
    },
    {
        name: 'integral',
        args: [
            {
                name: 'unit',
                desc: 'Unit of time to use to compute the integral.',
                type: 'Duration'
            },
            {
                name: 'column',
                desc: 'Column to operate on. Default is `_value`.',
                type: 'String'
            },
            {
                name: 'timeColumn',
                desc: 'Column that contains time values to use in the operation.',
                type: 'String'
            },
            {
                name: 'interpolate',
                desc: 'Type of interpolation to use. Default is `""`.',
                type: 'String'
            }
        ],
        package: '',
        desc: 'Computes the area under the curve per unit of time of subsequent non-null records.',
        example: 'integral(unit: 10s)',
        category: 'Aggregates',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/integral/'
    },
    {
        name: 'join',
        args: [
            {
                name: 'on',
                desc: 'List of columns to join on.',
                type: 'Array of Strings'
            },
            {
                name: 'method',
                desc: 'Join method. Default is `inner`.',
                type: 'String'
            }
        ],
        package: '',
        desc: 'Merges two streams of tables into a single output stream based on columns with equal values. Null values are not considered equal when comparing column values. The resulting schema is the union of the input schemas. The resulting group key is the union of the input group keys.',
        example: 'join(tables: {t1: t1, t2: t2}, on: ["_time", "tag"])',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/join/'
    },
    {
        name: 'json.encode',
        args: [
            {
                name: 'v',
                desc: 'Value to convert.',
                type: 'Boolean, Duration, Float, Integer, String, Time, UInteger'
            }
        ],
        package: 'json',
        desc: 'Converts a value into JSON bytes.',
        example: 'json.encode( v: jsonData)',
        category: 'Type Conversions',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/json/encode/'
    },
    {
        name: 'kaufmansAMA',
        args: [
            {
                name: 'n',
                desc: 'Period or number of points to use in the calculation.',
                type: 'Integer'
            },
            {
                name: 'column',
                desc: 'Column to operate on. Default is `_value`.',
                type: 'String'
            }
        ],
        package: '',
        desc: "Calculates the Kaufman\u2019s Adaptive Moving Average (KAMA) using values in input tables.",
        example: 'kaufmansAMA(n: 3)',
        category: 'Aggregates',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/kaufmansama/'
    },
    {
        name: 'kaufmansER',
        args: [
            {
                name: 'n',
                desc: 'Period or number of points to use in the calculation.',
                type: 'Integer'
            }
        ],
        package: '',
        desc: "Computes the Kaufman's Efficiency Ratio (KER) of values in the `_value` column for each input table.",
        example: 'kaufmansER(n: 3)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/kaufmanser/'
    },
    {
        name: 'keep',
        args: [
            {
                name: 'columns',
                desc: 'Columns to keep in output tables. Cannot be used with `fn`.',
                type: 'Array of Strings'
            },
            {
                name: 'fn',
                desc: 'Predicate function that takes a column name as a parameter (column) and',
                type: 'Function'
            }
        ],
        package: '',
        desc: 'Returns a stream of tables containing only the specified columns.',
        example: 'keep(columns: ["_time", "_value"])',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/keep/'
    },
    {
        name: 'keys',
        args: [
            {
                name: 'column',
                desc: 'Column to store group key labels in. Default is `_value`.',
                type: 'String'
            }
        ],
        package: '',
        desc: 'Returns the columns that are in the group key of each input table.',
        example: 'keys()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/keys/'
    },
    {
        name: 'keyValues',
        args: [
            {
                name: 'keyColumns',
                desc: 'List of columns from which values are extracted.',
                type: 'Array of Strings'
            }
        ],
        package: '',
        desc: "Returns a stream of tables with each input tables' group key and two columns, _key and _value, that correspond to unique column label and value pairs for each input table.",
        example: 'keyValues(keyColumns: ["sensorID", "_field"])',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/keyvalues/'
    },
    {
        name: 'last',
        args: [
            {
                name: 'column',
                desc: 'Column to use to verify the existence of a value.',
                type: 'String'
            }
        ],
        package: '',
        desc: 'Returns the last row with a non-null value from each input table.',
        example: 'last()',
        category: 'Selectors',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/last/'
    },
    {
        name: 'length',
        args: [
            {
                name: 'arr',
                desc: 'Array to evaluate. Default is the piped-forward array (`<-`).',
                type: 'Array'
            }
        ],
        package: '',
        desc: 'Returns the number of elements in an array.',
        example: 'length()',
        category: 'Miscellaneous',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/length/'
    },
    {
        name: 'limit',
        args: [
            {
                name: 'n',
                desc: 'Maximum number of rows to return.',
                type: 'Integer'
            },
            {
                name: 'offset',
                desc: 'Number of rows to skip per table before limiting to `n`.',
                type: 'Integer'
            }
        ],
        package: '',
        desc: 'Returns the first `n` rows after the specified `offset` from each input table.',
        example: 'limit(n: 3)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/limit/'
    },
    {
        name: 'linearBins',
        args: [
            {
                name: 'start',
                desc: 'First value to return in the list.',
                type: 'Float'
            },
            {
                name: 'width',
                desc: 'Distance between subsequent values.',
                type: 'Float'
            },
            {
                name: 'count',
                desc: 'Number of values to return.',
                type: 'Integer'
            },
            {
                name: 'infinity',
                desc: 'Include an infinite value at the end of the list. Default is `true`.',
                type: 'Boolean'
            }
        ],
        package: '',
        desc: 'Generates a list of linearly separated float values.',
        example: 'linearBins( start: 0.0, width: 10.0, count: 10)',
        category: 'Miscellaneous',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/linearbins/'
    },
    {
        name: 'logarithmicBins',
        args: [
            {
                name: 'start',
                desc: 'First value to return in the list.',
                type: 'Float'
            },
            {
                name: 'factor',
                desc: 'Multiplier to apply to subsequent values.',
                type: 'Float'
            },
            {
                name: 'count',
                desc: 'Number of values to return.',
                type: 'Integer'
            },
            {
                name: 'infinity',
                desc: 'Include an infinite value at the end of the list. Default is `true`.',
                type: 'Boolean'
            }
        ],
        package: '',
        desc: 'Generates a list of exponentially separated float values.',
        example: 'logarithmicBins( start: 1.0, factor: 2.0, count: 10, infinity: true)',
        category: 'Miscellaneous',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/logarithmicbins/'
    },
    {
        name: 'lowestAverage',
        args: [
            {
                name: 'n',
                desc: 'Number of records to return.',
                type: 'Integer'
            },
            {
                name: 'column',
                desc: 'Column to evaluate. Default is `_value`.',
                type: 'String'
            },
            {
                name: 'groupColumns',
                desc: 'List of columns to group by. Default is `[]`.',
                type: 'Array of Strings'
            }
        ],
        package: '',
        desc: 'Calculates the average of each input table and returns the lowest `n` averages.',
        example: 'lowestAverage(n: 1, groupColumns: ["tag"])',
        category: 'Selectors',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/lowestaverage/'
    },
    {
        name: 'lowestCurrent',
        args: [
            {
                name: 'n',
                desc: 'Number of records to return.',
                type: 'Integer'
            },
            {
                name: 'column',
                desc: 'Column to evaluate. Default is `_value`.',
                type: 'String'
            },
            {
                name: 'groupColumns',
                desc: 'List of columns to group by. Default is `[]`.',
                type: 'Array of Strings'
            }
        ],
        package: '',
        desc: 'Selects the last record from each input table and returns the lowest `n` records.',
        example: 'lowestCurrent(n: 1, groupColumns: ["tag"])',
        category: 'Selectors',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/lowestcurrent/'
    },
    {
        name: 'lowestMin',
        args: [
            {
                name: 'n',
                desc: 'Number of records to return.',
                type: 'Integer'
            },
            {
                name: 'column',
                desc: 'Column to evaluate. Default is `_value`.',
                type: 'String'
            },
            {
                name: 'groupColumns',
                desc: 'List of columns to group by. Default is `[]`.',
                type: 'Array of Strings'
            }
        ],
        package: '',
        desc: 'Selects the record with the lowest value in the specified `column` from each input table and returns the bottom `n` records.',
        example: 'lowestMin(n: 2, groupColumns: ["tag"])',
        category: 'Selectors',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/lowestmin/'
    },
    {
        name: 'map',
        args: [
            {
                name: 'fn',
                desc: 'Single argument function to apply to each record.',
                type: 'Function'
            },
            {
                name: 'mergeKey',
                desc: '_(Deprecated)_ Merge group keys of mapped records. Default is `false`.',
                type: 'Boolean'
            }
        ],
        package: '',
        desc: 'Iterates over and applies a function to input rows.',
        example: 'map(fn: (r) => ({r with _value: r._value * r._value}))',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/map/'
    },
    {
        name: 'math.abs',
        args: [
            {
                name: 'x',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the absolute value of `x`.',
        example: 'math.abs(x: -1.22)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/abs/'
    },
    {
        name: 'math.acos',
        args: [
            {
                name: 'x',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the acosine of `x` in radians.',
        example: 'math.acos(x: 0.22)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/acos/'
    },
    {
        name: 'math.acosh',
        args: [
            {
                name: 'x',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the inverse hyperbolic cosine of `x`.',
        example: 'math.acosh(x: 1.22)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/acosh/'
    },
    {
        name: 'math.asin',
        args: [
            {
                name: 'x',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the arcsine of `x` in radians.',
        example: 'math.asin(x: 0.22)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/asin/'
    },
    {
        name: 'math.asinh',
        args: [
            {
                name: 'x',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the inverse hyperbolic sine of `x`.',
        example: 'math.asinh(x: 3.14)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/asinh/'
    },
    {
        name: 'math.atan',
        args: [
            {
                name: 'x',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the arctangent of `x` in radians.',
        example: 'math.atan(x: 3.14)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/atan/'
    },
    {
        name: 'math.atan2',
        args: [
            {
                name: 'y',
                desc: 'y-coordinate to use in the operation.',
                type: 'Float'
            },
            {
                name: 'x',
                desc: 'x-coordinate to use in the operation.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the artangent of `x/y`, using the signs of the two to determine the quadrant of the return value.',
        example: 'math.atan2(y: r.y_coord, x: r.x_coord)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/atan2/'
    },
    {
        name: 'math.atanh',
        args: [
            {
                name: 'x',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the inverse hyperbolic tangent of `x`.',
        example: 'math.atanh(x: 0.22)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/atanh/'
    },
    {
        name: 'math.cbrt',
        args: [
            {
                name: 'x',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the cube root of x.',
        example: 'math.cbrt(x: 1728.0)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/cbrt/'
    },
    {
        name: 'math.ceil',
        args: [
            {
                name: 'x',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the least integer value greater than or equal to `x`.',
        example: 'math.ceil(x: 3.14)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/ceil/'
    },
    {
        name: 'math.copysign',
        args: [
            {
                name: 'x',
                desc: 'Magnitude to use in the operation.',
                type: 'Float'
            },
            {
                name: 'y',
                desc: 'Sign to use in the operation.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns a value with the magnitude `x` and the sign of `y`.',
        example: 'math.copysign(x: 1.0, y: 2.0)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/copysign/'
    },
    {
        name: 'math.cos',
        args: [
            {
                name: 'x',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the cosine of the radian argument `x`.',
        example: 'math.cos(x: r._value)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/cos/'
    },
    {
        name: 'math.cosh',
        args: [
            {
                name: 'x',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the hyperbolic cosine of `x`.',
        example: 'math.cosh(x: r._value)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/cosh/'
    },
    {
        name: 'math.dim',
        args: [
            {
                name: 'x',
                desc: 'x-value to use in the operation.',
                type: 'Float'
            },
            {
                name: 'y',
                desc: 'y-value to use in the operation.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the maximum of `x - y` or `0`.',
        example: 'math.dim(x: 12.2, y: 8.1)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/dim/'
    },
    {
        name: 'math.erf',
        args: [
            {
                name: 'x',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the error function of `x`.',
        example: 'math.erf(x: 22.6)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/erf/'
    },
    {
        name: 'math.erfc',
        args: [
            {
                name: 'x',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the complementary error function of `x`.',
        example: 'math.erfc(x: 22.6)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/erfc/'
    },
    {
        name: 'math.erfcinv',
        args: [
            {
                name: 'x',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the inverse of `math.erfc()`.',
        example: 'math.erfcinv(x: 0.42345)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/erfcinv/'
    },
    {
        name: 'math.erfinv',
        args: [
            {
                name: 'x',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the inverse error function of `x`.',
        example: 'math.erfinv(x: 0.22)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/erfinv/'
    },
    {
        name: 'math.exp',
        args: [
            {
                name: 'x',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns `e**x`, the base-e exponential of `x`.',
        example: 'math.exp(x: 21.0)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/exp/'
    },
    {
        name: 'math.exp2',
        args: [
            {
                name: 'x',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns `2**x`, the base-2 exponential of `x`.',
        example: 'math.exp2(x: 21.0)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/exp2/'
    },
    {
        name: 'math.expm1',
        args: [
            {
                name: 'x',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns `e**x - 1`, the base-e exponential of `x` minus 1. It is more accurate than `math.exp(x:x) - 1` when `x` is near zero.',
        example: 'math.expm1(x: 0.022)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/expm1/'
    },
    {
        name: 'math.float64bits',
        args: [
            {
                name: 'f',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the IEEE 754 binary representation of `f`, with the sign bit of `f` and the result in the same bit position.',
        example: 'math.float64bits(f: 1234.56)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/float64bits/'
    },
    {
        name: 'math.floor',
        args: [
            {
                name: 'x',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the greatest integer value less than or equal to `x`.',
        example: 'math.floor(x: 1.22)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/floor/'
    },
    {
        name: 'math.frexp',
        args: [
            {
                name: 'f',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Breaks `f` into a normalized fraction and an integral part of two.',
        example: 'math.frexp(f: 22.0)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/frexp/'
    },
    {
        name: 'math.gamma',
        args: [
            {
                name: 'x',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the gamma function of `x`.',
        example: 'math.gamma(x: 2.12)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/gamma/'
    },
    {
        name: 'math.hypot',
        args: [
            {
                name: 'p',
                desc: 'p-value to use in the operation.',
                type: 'Float'
            },
            {
                name: 'q',
                desc: 'q-value to use in the operation.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the square root of `p*p + q*q`, taking care to avoid overflow and underflow.',
        example: 'math.hypot(p: 2.0, q: 5.0)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/hypot/'
    },
    {
        name: 'math.ilogb',
        args: [
            {
                name: 'x',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the binary exponent of `x` as an integer.',
        example: 'math.ilogb(x: 123.45)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/ilogb/'
    },
    {
        name: 'math.isInf',
        args: [
            {
                name: 'f',
                desc: 'is the value used in the evaluation.',
                type: 'Float'
            },
            {
                name: 'sign',
                desc: 'is the sign used in the evaluation.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Reports whether `f` is an infinity, according to `sign`.',
        example: 'math.isInf(f: 2.12, sign: 3)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/isinf/'
    },
    {
        name: 'math.isNaN',
        args: [
            {
                name: 'f',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Reports whether `f` is an IEEE 754 "not-a-number" value.',
        example: 'math.isNaN(f: 12.345)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/isnan/'
    },
    {
        name: 'math.j0',
        args: [
            {
                name: 'x',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the order-zero Bessel function of the first kind.',
        example: 'math.j0(x: 1.23)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/j0/'
    },
    {
        name: 'math.j1',
        args: [
            {
                name: 'x',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Is a function that returns the order-one Bessel function for the first kind.',
        example: 'math.j1(x: 1.23)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/j1/'
    },
    {
        name: 'math.jn',
        args: [
            {
                name: 'n',
                desc: 'Order number.',
                type: 'Float'
            },
            {
                name: 'x',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the order-n Bessel function of the first kind.',
        example: 'math.jn(n: 2, x: 1.23)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/jn/'
    },
    {
        name: 'math.ldexp',
        args: [
            {
                name: 'frac',
                desc: 'Fraction to use in the operation.',
                type: 'Float'
            },
            {
                name: 'exp',
                desc: 'Exponent to use in the operation.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Is the inverse of `math.frexp()`. It returns `frac x 2**exp`.',
        example: 'math.ldexp(frac: 0.5, exp: 6)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/ldexp/'
    },
    {
        name: 'math.lgamma',
        args: [
            {
                name: 'x',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the natural logarithm and sign (-1 or +1) of `math.gamma(x:x)`.',
        example: 'math.lgamma(x: 3.14)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/lgamma/'
    },
    {
        name: 'math.log',
        args: [
            {
                name: 'x',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the natural logarithm of `x`.',
        example: 'math.log(x: 3.14)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/log/'
    },
    {
        name: 'math.log1p',
        args: [
            {
                name: 'x',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the natural logarithm of 1 plus `x`. This operation is more accurate than `math.log(x: 1 + x)` when `x` is near zero.',
        example: 'math.log1p(x: 0.56)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/log1p/'
    },
    {
        name: 'math.log2',
        args: [
            {
                name: 'x',
                desc: 'the value used in the operation.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Is a function returns the binary logarithm of `x`.',
        example: 'math.log2(x: 3.14)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/log2/'
    },
    {
        name: 'math.logb',
        args: [
            {
                name: 'x',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the binary exponent of `x`.',
        example: 'math.logb(x: 3.14)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/logb/'
    },
    {
        name: 'math.mInf',
        args: [
            {
                name: 'sign',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns positive infinity if `sign >= 0`, negative infinity if `sign < 0`.',
        example: 'math.mInf(sign: 1)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/minf/'
    },
    {
        name: 'math.mMax',
        args: [
            {
                name: 'x',
                desc: 'x-value to use in the operation.',
                type: 'Float'
            },
            {
                name: 'y',
                desc: 'y-value to use in the operation.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the larger of `x` or `y`.',
        example: 'math.mMax(x: 1.23, y: 4.56)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/mmax/'
    },
    {
        name: 'math.mMin',
        args: [
            {
                name: 'x',
                desc: 'x-value to use in the operation.',
                type: 'Float'
            },
            {
                name: 'y',
                desc: 'y-value to use in the operation.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Is a function that returns the lesser of `x` or `y`.',
        example: 'math.mMin(x: 1.23, y: 4.56)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/mmin/'
    },
    {
        name: 'math.mod',
        args: [
            {
                name: 'x',
                desc: 'x-value to use in the operation.',
                type: 'Float'
            },
            {
                name: 'y',
                desc: 'y-value to use in the operation.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns a floating-point remainder of `x/y`.',
        example: 'math.mod(x: 4.56, y: 1.23)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/mod/'
    },
    {
        name: 'math.modf',
        args: [
            {
                name: 'f',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns integer and fractional floating-point numbers that sum to `f`.',
        example: 'math.modf(f: 3.14)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/modf/'
    },
    {
        name: 'math.NaN',
        args: [],
        package: 'math',
        desc: 'Returns a IEEE 754 "not-a-number" value.',
        example: 'math.NaN()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/nan/'
    },
    {
        name: 'math.nextafter',
        args: [
            {
                name: 'x',
                desc: 'x-value to use in the operation.',
                type: 'Float'
            },
            {
                name: 'y',
                desc: 'y-value to use in the operation.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the next representable float value after `x` towards `y`.',
        example: 'math.nextafter(x: 1.23, y: 4.56)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/nextafter/'
    },
    {
        name: 'math.pow',
        args: [
            {
                name: 'x',
                desc: 'Base value to operate on.',
                type: 'Float'
            },
            {
                name: 'y',
                desc: 'Exponent value.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns `x**y`, the base-x exponential of `y`.',
        example: 'math.pow(x: 2.0, y: 3.0)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/pow/'
    },
    {
        name: 'math.pow10',
        args: [
            {
                name: 'n',
                desc: 'Exponent value.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns 10**n, the base-10 exponential of `n`.',
        example: 'math.pow10(n: 3)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/pow10/'
    },
    {
        name: 'math.remainder',
        args: [
            {
                name: 'x',
                desc: 'Numerator to use in the operation.',
                type: 'Float'
            },
            {
                name: 'y',
                desc: 'Denominator to use in the operation.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the IEEE 754 floating-point remainder of `x/y`.',
        example: 'math.remainder(x: 21.0, y: 4.0)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/remainder/'
    },
    {
        name: 'math.round',
        args: [
            {
                name: 'x',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the nearest integer, rounding half away from zero.',
        example: 'math.round(x: 2.12)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/round/'
    },
    {
        name: 'math.roundtoeven',
        args: [
            {
                name: 'x',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the nearest integer, rounding ties to even.',
        example: 'math.roundtoeven(x: 3.14)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/roundtoeven/'
    },
    {
        name: 'math.signbit',
        args: [
            {
                name: 'x',
                desc: 'Value to evaluate.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Reports whether `x` is negative or negative zero.',
        example: 'math.signbit(x: -1.2)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/signbit/'
    },
    {
        name: 'math.sin',
        args: [
            {
                name: 'x',
                desc: 'Radian value to use in the operation.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the sine of the radian argument `x`.',
        example: 'math.sin(x: 3.14)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/sin/'
    },
    {
        name: 'math.sincos',
        args: [
            {
                name: 'x',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the values of `math.sin(x:x)` and `math.cos(x:x)`.',
        example: 'math.sincos(x: 1.23)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/sincos/'
    },
    {
        name: 'math.sinh',
        args: [
            {
                name: 'x',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the hyperbolic sine of `x`.',
        example: 'math.sinh(x: 1.23)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/sinh/'
    },
    {
        name: 'math.sqrt',
        args: [
            {
                name: 'x',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the square root of `x`.',
        example: 'math.sqrt(x: 4.0)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/sqrt/'
    },
    {
        name: 'math.tan',
        args: [
            {
                name: 'x',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the tangent of the radian argument `x`.',
        example: 'math.tan(x: 3.14)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/tan/'
    },
    {
        name: 'math.tanh',
        args: [
            {
                name: 'x',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the hyperbolic tangent of `x`.',
        example: 'math.tanh(x: 1.23)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/tanh/'
    },
    {
        name: 'math.trunc',
        args: [
            {
                name: 'x',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the integer value of `x`.',
        example: 'math.trunc(x: 3.14)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/trunc/'
    },
    {
        name: 'math.y0',
        args: [
            {
                name: 'x',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the order-zero Bessel function of the second kind.',
        example: 'math.y0(x: 3.14)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/y0/'
    },
    {
        name: 'math.y1',
        args: [
            {
                name: 'x',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the order-one Bessel function of the second kind.',
        example: 'math.y1(x: 3.14)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/y1/'
    },
    {
        name: 'math.yn',
        args: [
            {
                name: 'n',
                desc: 'Order number to use in the operation.',
                type: 'Float'
            },
            {
                name: 'x',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the order-n Bessel function of the second kind.',
        example: 'math.yn(n: 3, x: 3.14)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/yn/'
    },
    {
        name: 'max',
        args: [
            {
                name: 'column',
                desc: 'Column to return maximum values from. Default is `_value`.',
                type: 'String'
            }
        ],
        package: '',
        desc: 'Returns the row with the maximum value in a specified column from each input table.',
        example: 'max()',
        category: 'Selectors',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/max/'
    },
    {
        name: 'mean',
        args: [
            {
                name: 'column',
                desc: 'Column to use to compute means. Default is `_value`.',
                type: 'String'
            }
        ],
        package: '',
        desc: 'Returns the average of non-null values in a specified column from each input table.',
        example: 'mean()',
        category: 'Aggregates',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/mean/'
    },
    {
        name: 'median',
        args: [
            {
                name: 'column',
                desc: 'Column to use to compute the median. Default is `_value`.',
                type: 'String'
            },
            {
                name: 'method',
                desc: 'Computation method. Default is `estimate_tdigest`.',
                type: 'String'
            },
            {
                name: 'compression',
                desc: 'Number of centroids to use when compressing the dataset.',
                type: 'Float'
            }
        ],
        package: '',
        desc: 'Returns the median `_value` of an input table or all non-null records in the input table with values that fall within the 0.5 quantile (50th percentile).',
        example: 'median()',
        category: 'Aggregates',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/median/'
    },
    {
        name: 'min',
        args: [
            {
                name: 'column',
                desc: 'Column to return minimum values from. Default is `_value`.',
                type: 'String'
            }
        ],
        package: '',
        desc: 'Returns the row with the minimum value in a specified column from each input table.',
        example: 'min()',
        category: 'Selectors',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/min/'
    },
    {
        name: 'mode',
        args: [
            {
                name: 'column',
                desc: 'Column to return the mode from. Default is `_value`.',
                type: 'String'
            }
        ],
        package: '',
        desc: 'Returns the non-null value or values that occur most often in a specified column in each input table.',
        example: 'mode()',
        category: 'Aggregates',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/mode/'
    },
    {
        name: 'movingAverage',
        args: [
            {
                name: 'n',
                desc: 'Number of values to average.',
                type: 'Duration'
            }
        ],
        package: '',
        desc: 'Calculates the mean of non-null values using the current value and `n - 1` previous values in the `_values` column.',
        example: 'movingAverage(n: 3)',
        category: 'Aggregates',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/movingaverage/'
    },
    {
        name: 'mqtt.to',
        args: [
            {
                name: 'broker',
                desc: 'MQTT broker connection string.',
                type: 'String'
            },
            {
                name: 'topic',
                desc: 'MQTT topic to send data to.',
                type: 'String'
            },
            {
                name: 'qos',
                desc: 'MQTT Quality of Service (QoS) level. Values range from `[0-2]`. Default is `0`.',
                type: 'Integer'
            },
            {
                name: 'retain',
                desc: 'MQTT retain flag. Default is `false`.',
                type: 'Boolean'
            },
            {
                name: 'clientid',
                desc: 'MQTT client ID.',
                type: 'String'
            },
            {
                name: 'username',
                desc: 'Username to send to the MQTT broker.',
                type: 'String'
            },
            {
                name: 'password',
                desc: 'Password to send to the MQTT broker.',
                type: 'String'
            },
            {
                name: 'name',
                desc: 'Name for the MQTT message.',
                type: 'String'
            },
            {
                name: 'timeout',
                desc: 'MQTT connection timeout. Default is `1s`.',
                type: 'Duration'
            },
            {
                name: 'timeColumn',
                desc: 'Column to use as time values in the output line protocol.',
                type: 'String'
            },
            {
                name: 'tagColumns',
                desc: 'Columns to use as tag sets in the output line protocol.',
                type: 'Array of Strings'
            },
            {
                name: 'valueColumns',
                desc: 'Columns to use as field values in the output line protocol.',
                type: 'Array of Strings'
            }
        ],
        package: 'experimental/mqtt',
        desc: 'Outputs data from a stream of tables to an MQTT broker using MQTT protocol.',
        example: 'mqtt.to( broker: "tcp://localhost:8883", topic: "example-topic", clientid: r.id, tagColumns: ["id"], valueColumns: ["_value"])',
        category: 'Outputs',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/mqtt/to/'
    },
    {
        name: 'pearsonr',
        args: [
            {
                name: 'x',
                desc: 'First input stream.',
                type: 'Object'
            },
            {
                name: 'y',
                desc: 'Second input stream.',
                type: 'Object'
            },
            {
                name: 'on',
                desc: 'List of columns to join on.',
                type: 'Array of Strings'
            }
        ],
        package: '',
        desc: 'Returns the covariance of two streams of tables normalized to the Pearson R coefficient.',
        example: 'pearsonr(x: stream1, y: stream2, on: ["_time"])',
        category: 'Aggregates',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/pearsonr/'
    },
    {
        name: 'pivot',
        args: [
            {
                name: 'rowKey',
                desc: 'Columns to use to uniquely identify an output row.',
                type: 'Array of Strings'
            },
            {
                name: 'columnKey',
                desc: 'Columns to use to identify new output columns.',
                type: 'Array of Strings'
            },
            {
                name: 'valueColumn',
                desc: 'Column to use to populate the value of pivoted `columnKey` columns.',
                type: 'String'
            }
        ],
        package: '',
        desc: 'Collects unique values stored vertically (column-wise) and aligns them horizontally (row-wise) into logical sets.',
        example: 'pivot(rowKey: ["_time"], columnKey: ["_field"], valueColumn: "_value")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/pivot/'
    },
    {
        name: 'prometheus.histogramQuantile',
        args: [
            {
                name: 'quantile',
                desc: 'Quantile to compute. Must be a float value between 0.0 and 1.0.',
                type: 'Float'
            },
            {
                name: 'metricVersion',
                desc: 'Prometheus metric parsing format (/influxdb/v2/reference/prometheus-metrics/)',
                type: 'Object'
            },
            {
                name: 'onNonmonotonic',
                desc: 'Describes behavior when counts are not monotonically increasing',
                type: 'String'
            }
        ],
        package: 'experimental/prometheus',
        desc: 'Calculates a quantile on a set of Prometheus histogram values.',
        example: 'prometheus.histogramQuantile(quantile: 0.99)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/prometheus/histogramquantile/'
    },
    {
        name: 'prometheus.scrape',
        args: [
            {
                name: 'url',
                desc: 'URL to scrape Prometheus metrics from.',
                type: 'String'
            }
        ],
        package: 'experimental/prometheus',
        desc: 'Scrapes Prometheus metrics from an HTTP-accessible endpoint and returns them as a stream of tables.',
        example: 'prometheus.scrape(url: "http://localhost:8086/metrics")',
        category: 'Inputs',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/prometheus/scrape/'
    },
    {
        name: 'quantile',
        args: [
            {
                name: 'column',
                desc: 'Column to use to compute the quantile. Default is `_value`.',
                type: 'String'
            },
            {
                name: 'q',
                desc: 'Quantile to compute. Must be between `0.0` and `1.0`.',
                type: 'Float'
            },
            {
                name: 'method',
                desc: 'Computation method. Default is `estimate_tdigest`.',
                type: 'String'
            },
            {
                name: 'compression',
                desc: 'Number of centroids to use when compressing the dataset.',
                type: 'Float'
            }
        ],
        package: '',
        desc: 'Returns rows from each input table with values that fall within a specified quantile or returns the row with the value that represents the specified quantile.',
        example: 'quantile(q: 0.99, method: "estimate_tdigest")',
        category: 'Aggregates',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/quantile/'
    },
    {
        name: 'query.filterFields',
        args: [
            {
                name: 'fields',
                desc: 'Fields to filter by. Default is `[]`.',
                type: 'Array of Strings'
            },
            {
                name: 'table',
                desc: 'Input data. Default is piped-forward data (`<-`).',
                type: 'Stream of tables'
            }
        ],
        package: 'experimental/query',
        desc: 'Filters input data by field.',
        example: 'query.filterFields(fields: ["used_percent", "available_percent"])',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/query/filterfields/'
    },
    {
        name: 'query.filterMeasurement',
        args: [
            {
                name: 'measurement',
                desc: 'InfluxDB measurement name to filter by.',
                type: 'String'
            },
            {
                name: 'table',
                desc: 'Input data. Default is piped-forward data (`<-`).',
                type: 'Stream of tables'
            }
        ],
        package: 'experimental/query',
        desc: 'Filters input data by measurement.',
        example: 'query.filterMeasurement(measurement: "example-measurement")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/query/filtermeasurement/'
    },
    {
        name: 'query.fromRange',
        args: [
            {
                name: 'bucket',
                desc: 'InfluxDB bucket name.',
                type: 'String'
            },
            {
                name: 'start',
                desc: 'Earliest time to include in results.',
                type: 'Duration | Time'
            },
            {
                name: 'stop',
                desc: 'Latest time to include in results. Default is `now()`.',
                type: 'Duration | Time'
            }
        ],
        package: 'experimental/query',
        desc: 'Returns all data from a specified bucket within given time bounds.',
        example: 'query.fromRange(bucket: "example-bucket", start: -1h)',
        category: 'Inputs',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/query/fromrange/'
    },
    {
        name: 'query.inBucket',
        args: [
            {
                name: 'bucket',
                desc: 'InfluxDB bucket name.',
                type: 'String'
            },
            {
                name: 'measurement',
                desc: 'InfluxDB measurement name to filter by.',
                type: 'String'
            },
            {
                name: 'start',
                desc: 'Earliest time to include in results.',
                type: 'Duration | Time'
            },
            {
                name: 'stop',
                desc: 'Latest time to include in results. Default is `now()`.',
                type: 'Duration | Time'
            },
            {
                name: 'fields',
                desc: 'Fields to filter by. Default is `[]`.',
                type: 'Array of Strings'
            },
            {
                name: 'predicate',
                desc: 'Predicate function that evaluates column values and returns `true` or `false`.',
                type: 'Function'
            }
        ],
        package: 'experimental/query',
        desc: 'Queries data from a specified InfluxDB bucket within given time bounds, filters data by measurement, field, and optional predicate expressions.',
        example: 'query.inBucket( bucket: "example-buckt", start: -1h, measurement: "mem", fields: ["field1", "field2"], predicate: (r) => r.host == "host1")',
        category: 'Inputs',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/query/inbucket/'
    },
    {
        name: 'range',
        args: [
            {
                name: 'start',
                desc: 'Earliest time to include in results.',
                type: 'Duration | Time'
            },
            {
                name: 'stop',
                desc: 'Latest time to include in results. Default is `now()`.',
                type: 'Duration | Time'
            }
        ],
        package: '',
        desc: 'Filters rows based on time bounds.',
        example: 'range(start: -12h)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/range/'
    },
    {
        name: 'reduce',
        args: [
            {
                name: 'fn',
                desc: 'Reducer function to apply to each row record (`r`).',
                type: 'Function'
            },
            {
                name: 'identity',
                desc: 'Record that defines the reducer record and provides initial values',
                type: 'Object'
            }
        ],
        package: '',
        desc: 'Aggregates rows in each input table using a reducer function (`fn`).',
        example: 'reduce(fn: (r, accumulator) => ({sum: r._value + accumulator.sum}), identity: {sum: 0})',
        category: 'Aggregates',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/reduce/'
    },
    {
        name: 'regexp.compile',
        args: [
            {
                name: 'v',
                desc: 'String value to parse into a regular expression.',
                type: 'String'
            }
        ],
        package: 'regexp',
        desc: 'Parses a string into a regular expression and returns a regexp type that can be used to match against strings.',
        example: 'regexp.compile(v: "abcd")',
        category: 'Type Conversions',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/regexp/compile/'
    },
    {
        name: 'regexp.findString',
        args: [
            {
                name: 'r',
                desc: 'Regular expression used to search `v`.',
                type: 'Regexp'
            },
            {
                name: 'v',
                desc: 'String value to search.',
                type: 'String'
            }
        ],
        package: 'regexp',
        desc: 'Returns the left-most regular expression match in a string.',
        example: 'regexp.findString(r: /foo.?/, v: "seafood fool")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/regexp/findstring/'
    },
    {
        name: 'regexp.findStringIndex',
        args: [
            {
                name: 'r',
                desc: 'Regular expression used to search `v`.',
                type: 'Regexp'
            },
            {
                name: 'v',
                desc: 'String value to search.',
                type: 'String'
            }
        ],
        package: 'regexp',
        desc: 'Returns a two-element array of integers that represent the beginning and ending indexes of the first regular expression match in a string.',
        example: 'regexp.findStringIndex(r: /ab?/, v: "tablet")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/regexp/findstringindex/'
    },
    {
        name: 'regexp.getString',
        args: [
            {
                name: 'r',
                desc: 'Regular expression object to convert to a string.',
                type: 'Regexp'
            }
        ],
        package: 'regexp',
        desc: 'Returns the source string used to compile a regular expression.',
        example: 'regexp.getString(r: /[a-zA-Z]/)',
        category: 'Type Conversions',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/regexp/getstring/'
    },
    {
        name: 'regexp.matchRegexpString',
        args: [
            {
                name: 'r',
                desc: 'Regular expression used to search `v`.',
                type: 'Regexp'
            },
            {
                name: 'v',
                desc: 'String value to search.',
                type: 'String'
            }
        ],
        package: 'regexp',
        desc: 'Tests if a string contains any match to a regular expression.',
        example: 'regexp.matchRegexpString(r: /(gopher){2}/, v: "gophergophergopher")',
        category: 'Tests',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/regexp/matchregexpstring/'
    },
    {
        name: 'regexp.quoteMeta',
        args: [
            {
                name: 'v',
                desc: 'String that contains regular expression metacharacters to escape.',
                type: 'String'
            }
        ],
        package: 'regexp',
        desc: 'Escapes all regular expression metacharacters in a string.',
        example: 'regexp.quoteMeta(v: ".+*?()|[]{}^$")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/regexp/quotemeta/'
    },
    {
        name: 'regexp.replaceAllString',
        args: [
            {
                name: 'r',
                desc: 'Regular expression used to search `v`.',
                type: 'Regexp'
            },
            {
                name: 'v',
                desc: 'String value to search.',
                type: 'String'
            },
            {
                name: 't',
                desc: 'Replacement for matches to `r`.',
                type: 'String'
            }
        ],
        package: 'regexp',
        desc: 'Replaces all reguar expression matches in a string with a specified replacement.',
        example: 'regexp.replaceAllString(r: /a(x*)b/, v: "-ab-axxb-", t: "T")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/regexp/replaceallstring/'
    },
    {
        name: 'regexp.splitRegexp',
        args: [
            {
                name: 'r',
                desc: 'Regular expression used to search `v`.',
                type: 'Regexp'
            },
            {
                name: 'v',
                desc: 'String value to be searched.',
                type: 'String'
            },
            {
                name: 'i',
                desc: 'Maximum number of substrings to return.',
                type: 'Integer'
            }
        ],
        package: 'regexp',
        desc: 'Splits a string into substrings separated by regular expression matches and returns an array of `i` substrings between matches.',
        example: 'regexp.splitRegexp(r: /a*/, v: "abaabaccadaaae", i: -1)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/regexp/splitregexp/'
    },
    {
        name: 'relativeStrengthIndex',
        args: [
            {
                name: 'n',
                desc: 'Number of values to use to calculate the RSI.',
                type: 'Integer'
            },
            {
                name: 'columns',
                desc: 'Columns to operate on. Default is `["_value"]`.',
                type: 'Array of Strings`'
            }
        ],
        package: '',
        desc: 'Measures the relative speed and change of values in input tables.',
        example: 'relativeStrengthIndex(n: 3)',
        category: 'Aggregates',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/relativestrengthindex/'
    },
    {
        name: 'rename',
        args: [
            {
                name: 'columns',
                desc: 'Record that maps old column names to new column names.',
                type: 'Object'
            },
            {
                name: 'fn',
                desc: 'Function that takes the current column name (`column`) and returns a',
                type: 'Function'
            }
        ],
        package: '',
        desc: 'Renames columns in a table.',
        example: 'rename(columns: {tag: "uid", _value: "val"})',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/rename/'
    },
    {
        name: 'runtime.version',
        args: [],
        package: 'runtime',
        desc: 'Returns the current Flux version.',
        example: 'runtime.version()',
        category: 'Miscellaneous',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/runtime/version/'
    },
    {
        name: 'sample',
        args: [
            {
                name: 'n',
                desc: 'Sample every Nth element.',
                type: 'Integer'
            },
            {
                name: 'pos',
                desc: 'Position offset from the start of results where sampling begins.',
                type: 'Integer'
            },
            {
                name: 'column',
                desc: 'Column to operate on.',
                type: 'String'
            }
        ],
        package: '',
        desc: 'Selects a subset of the rows from each input table.',
        example: 'sample(n: 2, pos: 1)',
        category: 'Selectors',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/sample/'
    },
    {
        name: 'secrets.get',
        args: [
            {
                name: 'key',
                desc: 'Secret key to retrieve.',
                type: 'String'
            }
        ],
        package: 'influxdata/influxdb/secrets',
        desc: 'Retrieves a secret from the InfluxDB secret store.',
        example: 'secrets.get(key: "KEY_NAME")',
        category: 'Miscellaneous',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/influxdata/influxdb/secrets/get/'
    },
    {
        name: 'set',
        args: [
            {
                name: 'key',
                desc: 'Label of the column to modify or set.',
                type: 'String'
            },
            {
                name: 'value',
                desc: 'String value to set.',
                type: 'String'
            }
        ],
        package: '',
        desc: 'Assigns a static column value to each row in the input tables.',
        example: 'set(key: "host", value: "prod1")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/set/'
    },
    {
        name: 'skew',
        args: [
            {
                name: 'column',
                desc: 'Column to operate on. Default is `_value`.',
                type: 'String'
            }
        ],
        package: '',
        desc: 'Returns the skew of non-null records in each input table as a float.',
        example: 'skew()',
        category: 'Aggregates',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/skew/'
    },
    {
        name: 'sort',
        args: [
            {
                name: 'columns',
                desc: 'List of columns to sort by. Default is `["_value"]`.',
                type: 'Array of Strings'
            },
            {
                name: 'desc',
                desc: 'Sort results in descending order. Default is `false`.',
                type: 'Boolean'
            }
        ],
        package: '',
        desc: 'Orders rows in each input table based on values in specified columns.',
        example: 'sort()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/sort/'
    },
    {
        name: 'spread',
        args: [
            {
                name: 'column',
                desc: 'Column to operate on. Default is `_value`.',
                type: 'String'
            }
        ],
        package: '',
        desc: 'Returns the difference between the minimum and maximum values in a specified column.',
        example: 'spread()',
        category: 'Aggregates',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/spread/'
    },
    {
        name: 'sql.from',
        args: [
            {
                name: 'driverName',
                desc: 'Driver to use to connect to the SQL database.',
                type: 'String'
            },
            {
                name: 'dataSourceName',
                desc: 'Data source name (DNS) or connection string used to connect',
                type: 'String'
            },
            {
                name: 'query',
                desc: 'Query to run against the SQL database.',
                type: 'String'
            }
        ],
        package: 'sql',
        desc: 'Retrieves data from a SQL data source.',
        example: 'sql.from(driverName: "postgres", dataSourceName: "postgresql://user:password@localhost", query:"SELECT * FROM example_table")',
        category: 'Inputs',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/sql/from/'
    },
    {
        name: 'sql.to',
        args: [
            {
                name: 'driverName',
                desc: 'Driver used to connect to the SQL database.',
                type: 'String'
            },
            {
                name: 'dataSourceName',
                desc: 'Data source name (DNS) or connection string used',
                type: 'String'
            },
            {
                name: 'table',
                desc: 'Destination table.',
                type: 'String'
            },
            {
                name: 'batchSize',
                desc: 'Number of parameters or columns that can be queued within each',
                type: 'Integer'
            }
        ],
        package: 'sql',
        desc: 'Writes data to an SQL database.',
        example: 'sql.to(driverName: "postgres", dataSourceName: "postgresql://user:password@localhost", table: "example_table")',
        category: 'Outputs',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/sql/to/'
    },
    {
        name: 'stateCount',
        args: [
            {
                name: 'fn',
                desc: 'Predicate function that identifies the state of a record.',
                type: 'Function'
            },
            {
                name: 'column',
                desc: 'Column to store the state count in. Default is `stateCount`.',
                type: 'String'
            }
        ],
        package: '',
        desc: 'Returns the number of consecutive rows in a given state.',
        example: 'stateCount(fn: (r) => r._value < 10)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/statecount/'
    },
    {
        name: 'stateDuration',
        args: [
            {
                name: 'fn',
                desc: 'Predicate function that identifies the state of a record.',
                type: 'Function'
            },
            {
                name: 'column',
                desc: 'Column to store the state duration in. Default is `stateDuration`.',
                type: 'String'
            },
            {
                name: 'timeColumn',
                desc: 'Time column to use to calculate elapsed time between rows.',
                type: 'String'
            },
            {
                name: 'unit',
                desc: 'Unit of time to use to increment state duration. Default is `1s` (seconds).',
                type: 'Duration'
            }
        ],
        package: '',
        desc: 'Returns the cumulative duration of a given state.',
        example: 'stateDuration(fn: (r) => r._value < 15)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/stateduration/'
    },
    {
        name: 'stddev',
        args: [
            {
                name: 'column',
                desc: 'Column to operate on. Default is `_value`.',
                type: 'String'
            },
            {
                name: 'mode',
                desc: 'Standard deviation mode or type of standard deviation to calculate.',
                type: 'String'
            }
        ],
        package: '',
        desc: 'Returns the standard deviation of non-null values in a specified column.',
        example: 'stddev()',
        category: 'Aggregates',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/stddev/'
    },
    {
        name: 'string',
        args: [
            {
                name: 'v',
                desc: 'Value to convert.',
                type: 'Integer, UInteger, Float, Boolean, Duration, Time'
            }
        ],
        package: '',
        desc: 'Converts a value to a string type.',
        example: 'string(v: true)',
        category: 'Type Conversions',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/string/'
    },
    {
        name: 'strings.compare',
        args: [
            {
                name: 'v',
                desc: 'String value to compare.',
                type: 'String'
            },
            {
                name: 't',
                desc: 'String value to compare against.',
                type: 'String'
            }
        ],
        package: 'strings',
        desc: 'Compares the lexicographical order of two strings.',
        example: 'strings.compare(v: r.string1, t: r.string2)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/strings/compare/'
    },
    {
        name: 'strings.containsAny',
        args: [
            {
                name: 'v',
                desc: 'String value to search.',
                type: 'String'
            },
            {
                name: 'chars',
                desc: 'Characters to search for.',
                type: 'String'
            }
        ],
        package: 'strings',
        desc: 'Reports whether a specified string contains characters from another string.',
        example: 'strings.containsAny(v: r._value, chars: "a79")',
        category: 'Tests',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/strings/containsany/'
    },
    {
        name: 'strings.containsStr',
        args: [
            {
                name: 'v',
                desc: 'String value to search.',
                type: 'String'
            },
            {
                name: 'substr',
                desc: 'Substring value to search for.',
                type: 'String'
            }
        ],
        package: 'strings',
        desc: 'Reports whether a string contains a specified substring.',
        example: 'strings.containsStr(v: r._value, substr: "5")',
        category: 'Tests',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/strings/containsstr/'
    },
    {
        name: 'strings.countStr',
        args: [
            {
                name: 'v',
                desc: 'String value to search.',
                type: 'String'
            },
            {
                name: 'substr',
                desc: 'Substring to count occurrences of.',
                type: 'String'
            }
        ],
        package: 'strings',
        desc: 'Counts the number of non-overlapping instances of a substring appears in a string.',
        example: 'strings.countStr(v: r._value, substr: "p")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/strings/countstr/'
    },
    {
        name: 'strings.equalFold',
        args: [
            {
                name: 'v',
                desc: 'String value to compare.',
                type: 'String'
            },
            {
                name: 't',
                desc: 'String value to compare against.',
                type: 'String'
            }
        ],
        package: 'strings',
        desc: 'Reports whether two UTF-8 strings are equal under Unicode case-folding.',
        example: 'strings.equalFold(v: r.string1, t: r.string2)',
        category: 'Tests',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/strings/equalfold/'
    },
    {
        name: 'strings.hasPrefix',
        args: [
            {
                name: 'v',
                desc: 'String value to search.',
                type: 'String'
            },
            {
                name: 'prefix',
                desc: 'Prefix to search for.',
                type: 'String'
            }
        ],
        package: 'strings',
        desc: 'Indicates if a string begins with a specified prefix.',
        example: 'strings.hasPrefix(v: r._value, prefix: "smpl_5")',
        category: 'Tests',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/strings/hasprefix/'
    },
    {
        name: 'strings.hasSuffix',
        args: [
            {
                name: 'v',
                desc: 'String value to search.',
                type: 'String'
            },
            {
                name: 'suffix',
                desc: 'Suffix to search for.',
                type: 'String'
            }
        ],
        package: 'strings',
        desc: 'Indicates if a string ends with a specified suffix.',
        example: 'strings.hasSuffix(v: r._value, suffix: "4")',
        category: 'Tests',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/strings/hassuffix/'
    },
    {
        name: 'strings.index',
        args: [
            {
                name: 'v',
                desc: 'String value to search.',
                type: 'String'
            },
            {
                name: 'substr',
                desc: 'Substring to search for.',
                type: 'String'
            }
        ],
        package: 'strings',
        desc: 'Returns the index of the first instance of a substring in a string. If the substring is not present, it returns `-1`.',
        example: 'strings.index(v: r._value, substr: "g")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/strings/index-fn/'
    },
    {
        name: 'strings.indexAny',
        args: [
            {
                name: 'v',
                desc: 'String value to search.',
                type: 'String'
            },
            {
                name: 'chars',
                desc: 'Characters to search for.',
                type: 'String'
            }
        ],
        package: 'strings',
        desc: 'Returns the index of the first instance of specified characters in a string. If none of the specified characters are present, it returns `-1`.',
        example: 'strings.indexAny(v: r._value, chars: "g7t")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/strings/indexany/'
    },
    {
        name: 'strings.isDigit',
        args: [
            {
                name: 'v',
                desc: 'Single-character string to test.',
                type: 'String'
            }
        ],
        package: 'strings',
        desc: 'Tests if a single-character string is a digit (0-9).',
        example: 'strings.isDigit(v: r._value)',
        category: 'Tests',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/strings/isdigit/'
    },
    {
        name: 'strings.isLetter',
        args: [
            {
                name: 'v',
                desc: 'Single-character string to test.',
                type: 'String'
            }
        ],
        package: 'strings',
        desc: 'Tests if a single character string is a letter (a-z, A-Z).',
        example: 'strings.isLetter(v: r._value)',
        category: 'Tests',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/strings/isletter/'
    },
    {
        name: 'strings.isLower',
        args: [
            {
                name: 'v',
                desc: 'Single-character string value to test.',
                type: 'String'
            }
        ],
        package: 'strings',
        desc: 'Tests if a single-character string is lowercase.',
        example: 'strings.isLower(v: r._value)',
        category: 'Tests',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/strings/islower/'
    },
    {
        name: 'strings.isUpper',
        args: [
            {
                name: 'v',
                desc: 'Single-character string value to test.',
                type: 'String'
            }
        ],
        package: 'strings',
        desc: 'Tests if a single character string is uppercase.',
        example: 'strings.isUpper(v: r._value)',
        category: 'Tests',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/strings/isupper/'
    },
    {
        name: 'strings.joinStr',
        args: [
            {
                name: 'arr',
                desc: 'Array of strings to concatenate.',
                type: 'Array of Strings'
            },
            {
                name: 'v',
                desc: 'Separator to use in the concatenated value.',
                type: 'String'
            }
        ],
        package: 'strings',
        desc: 'Concatenates elements of a string array into a single string using a specified separator.',
        example: 'strings.joinStr(arr: ["foo", "bar", "baz", "quz"], v: ", ")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/strings/joinstr/'
    },
    {
        name: 'strings.lastIndex',
        args: [
            {
                name: 'v',
                desc: 'String value to search.',
                type: 'String'
            },
            {
                name: 'substr',
                desc: 'Substring to search for.',
                type: 'String'
            }
        ],
        package: 'strings',
        desc: 'Returns the index of the last instance of a substring in a string. If the substring is not present, the function returns -1.',
        example: 'strings.lastIndex(v: r._value, substr: "g")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/strings/lastindex/'
    },
    {
        name: 'strings.lastIndexAny',
        args: [
            {
                name: 'v',
                desc: 'String value to search.',
                type: 'String'
            },
            {
                name: 'chars',
                desc: 'Characters to search for.',
                type: 'String'
            }
        ],
        package: 'strings',
        desc: 'Returns the index of the last instance of any specified characters in a string. If none of the specified characters are present, the function returns `-1`.',
        example: 'strings.lastIndexAny(v: r._value, chars: "g7t")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/strings/lastindexany/'
    },
    {
        name: 'strings.repeat',
        args: [
            {
                name: 'v',
                desc: 'String value to repeat.',
                type: 'String'
            },
            {
                name: 'i',
                desc: 'Number of times to repeat `v`.',
                type: 'Integer'
            }
        ],
        package: 'strings',
        desc: 'Returns a string consisting of `i` copies of a specified string.',
        example: 'strings.repeat(v: "ha", i: r._value)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/strings/repeat/'
    },
    {
        name: 'strings.replace',
        args: [
            {
                name: 'v',
                desc: 'String value to search.',
                type: 'String'
            },
            {
                name: 't',
                desc: 'Substring value to replace.',
                type: 'String'
            },
            {
                name: 'u',
                desc: 'Replacement for `i` instances of `t`.',
                type: 'String'
            },
            {
                name: 'i',
                desc: 'Number of non-overlapping `t` matches to replace.',
                type: 'Integer'
            }
        ],
        package: 'strings',
        desc: 'Replaces the first `i` non-overlapping instances of a substring with a specified replacement.',
        example: 'strings.replace(v: r._value, t: "p", u: "XX", i: 2)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/strings/replace/'
    },
    {
        name: 'strings.replaceAll',
        args: [
            {
                name: 'v',
                desc: 'String value to search.',
                type: 'String'
            },
            {
                name: 't',
                desc: 'Substring to replace.',
                type: 'String'
            },
            {
                name: 'u',
                desc: 'Replacement for all instances of `t`.',
                type: 'String'
            }
        ],
        package: 'strings',
        desc: 'Replaces all non-overlapping instances of a substring with a specified replacement.',
        example: 'strings.replaceAll(v: r._value, t: "p", u: "XX")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/strings/replaceall/'
    },
    {
        name: 'strings.split',
        args: [
            {
                name: 'v',
                desc: 'String value to split.',
                type: 'String'
            },
            {
                name: 't',
                desc: 'String value that acts as the separator.',
                type: 'String'
            }
        ],
        package: 'strings',
        desc: 'Splits a string on a specified separator and returns an array of substrings.',
        example: 'strings.split(v: "foo, bar, baz, quz", t: ", ")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/strings/split/'
    },
    {
        name: 'strings.splitAfter',
        args: [
            {
                name: 'v',
                desc: 'String value to split.',
                type: 'String'
            },
            {
                name: 't',
                desc: 'String value that acts as the separator.',
                type: 'String'
            }
        ],
        package: 'strings',
        desc: 'Splits a string after a specified separator and returns an array of substrings. Split substrings include the separator, `t`.',
        example: 'strings.splitAfter(v: "foo, bar, baz, quz", t: ", ")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/strings/splitafter/'
    },
    {
        name: 'strings.splitAfterN',
        args: [
            {
                name: 'v',
                desc: 'String value to split.',
                type: 'String'
            },
            {
                name: 't',
                desc: 'String value that acts as the separator.',
                type: 'String'
            },
            {
                name: 'i',
                desc: 'Maximum number of split substrings to return.',
                type: 'Integer'
            }
        ],
        package: 'strings',
        desc: 'Splits a string after a specified separator and returns an array of `i` substrings. Split substrings include the separator, `t`.',
        example: 'strings.splitAfterN(v: "foo, bar, baz, quz", t: ", ", i: 3)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/strings/splitaftern/'
    },
    {
        name: 'strings.splitN',
        args: [
            {
                name: 'v',
                desc: 'String value to split.',
                type: 'String'
            },
            {
                name: 't',
                desc: 'String value that acts as the separator.',
                type: 'String'
            },
            {
                name: 'i',
                desc: 'Maximum number of split substrings to return.',
                type: 'Integer'
            }
        ],
        package: 'strings',
        desc: 'Splits a string on a specified separator and returns an array of `i` substrings.',
        example: 'strings.splitN(v: "foo, bar, baz, quz", t: ", ", i: 3)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/strings/splitn/'
    },
    {
        name: 'strings.strlen',
        args: [
            {
                name: 'v',
                desc: 'String value to measure.',
                type: 'String'
            }
        ],
        package: 'strings',
        desc: 'Returns the length of a string. String length is determined by the number of UTF code points a string contains.',
        example: 'strings.strlen(v: r._value)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/strings/strlen/'
    },
    {
        name: 'strings.substring',
        args: [
            {
                name: 'v',
                desc: 'String value to search for.',
                type: 'String'
            },
            {
                name: 'start',
                desc: 'Starting inclusive index of the substring.',
                type: 'Integer'
            },
            {
                name: 'end',
                desc: 'Ending exclusive index of the substring.',
                type: 'Integer'
            }
        ],
        package: 'strings',
        desc: 'Returns a substring based on start and end parameters. These parameters are represent indices of UTF code points in the string.',
        example: 'strings.substring(v: r._value, start: 5, end: 9)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/strings/substring/'
    },
    {
        name: 'strings.title',
        args: [
            {
                name: 'v',
                desc: 'String value to convert.',
                type: 'String'
            }
        ],
        package: 'strings',
        desc: 'Converts a string to title case.',
        example: 'strings.title(v: r._value)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/strings/title/'
    },
    {
        name: 'strings.toLower',
        args: [
            {
                name: 'v',
                desc: 'String value to convert.',
                type: 'String'
            }
        ],
        package: 'strings',
        desc: 'Converts a string to lowercase.',
        example: 'strings.toLower(v: r._value)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/strings/tolower/'
    },
    {
        name: 'strings.toTitle',
        args: [
            {
                name: 'v',
                desc: 'String value to convert.',
                type: 'String'
            }
        ],
        package: 'strings',
        desc: 'Converts all characters in a string to title case.',
        example: 'strings.toTitle(v: r._value)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/strings/totitle/'
    },
    {
        name: 'strings.toUpper',
        args: [
            {
                name: 'v',
                desc: 'String value to convert.',
                type: 'String'
            }
        ],
        package: 'strings',
        desc: 'Converts a string to uppercase.',
        example: 'strings.toUpper(v: r._value)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/strings/toupper/'
    },
    {
        name: 'strings.trim',
        args: [
            {
                name: 'v',
                desc: 'String to remove characters from.',
                type: 'String'
            },
            {
                name: 'cutset',
                desc: 'Leading and trailing characters to remove from the string.',
                type: 'String'
            }
        ],
        package: 'strings',
        desc: 'Removes leading and trailing characters specified in the cutset from a string.',
        example: 'strings.trim(v: r._value, cutset: "smpl_")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/strings/trim/'
    },
    {
        name: 'strings.trimLeft',
        args: [
            {
                name: 'v',
                desc: 'String to to remove characters from.',
                type: 'String'
            },
            {
                name: 'cutset',
                desc: 'Leading characters to trim from the string.',
                type: 'String'
            }
        ],
        package: 'strings',
        desc: 'Removes specified leading characters from a string.',
        example: 'strings.trimLeft(v: r._value, cutset: ".")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/strings/trimleft/'
    },
    {
        name: 'strings.trimPrefix',
        args: [
            {
                name: 'v',
                desc: 'String to trim.',
                type: 'String'
            },
            {
                name: 'prefix',
                desc: 'Prefix to remove.',
                type: 'String'
            }
        ],
        package: 'strings',
        desc: 'Removes a prefix from a string. Strings that do not start with the prefix are returned unchanged.',
        example: 'strings.trimPrefix(v: r._value, prefix: "smpl_")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/strings/trimprefix/'
    },
    {
        name: 'strings.trimRight',
        args: [
            {
                name: 'v',
                desc: 'String to to remove characters from.',
                type: 'String'
            },
            {
                name: 'cutset',
                desc: 'Trailing characters to trim from the string.',
                type: 'String'
            }
        ],
        package: 'strings',
        desc: 'Removes trailing characters specified in the cutset from a string.',
        example: 'strings.trimRight(v: r._value, cutset: ".")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/strings/trimright/'
    },
    {
        name: 'strings.trimSpace',
        args: [
            {
                name: 'v',
                desc: 'String to remove spaces from.',
                type: 'String'
            }
        ],
        package: 'strings',
        desc: 'Removes leading and trailing spaces from a string.',
        example: 'strings.trimSpace(v: r._value)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/strings/trimspace/'
    },
    {
        name: 'strings.trimSuffix',
        args: [
            {
                name: 'v',
                desc: 'String to trim.',
                type: 'String'
            },
            {
                name: 'suffix',
                desc: 'Suffix to remove.',
                type: 'String'
            }
        ],
        package: 'strings',
        desc: 'Removes a suffix from a string.',
        example: 'strings.trimSuffix(v: r._value, suffix: "_ex1")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/strings/trimsuffix/'
    },
    {
        name: 'sum',
        args: [
            {
                name: 'column',
                desc: 'Column to operate on. Default is `_value`.',
                type: 'String'
            }
        ],
        package: '',
        desc: 'Returns the sum of non-null values in a specified column.',
        example: 'sum()',
        category: 'Aggregates',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/sum/'
    },
    {
        name: 'system.time',
        args: [],
        package: 'system',
        desc: 'Returns the current system time.',
        example: 'system.time()',
        category: 'Miscellaneous',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/system/time/'
    },
    {
        name: 'tableFind',
        args: [
            {
                name: 'fn',
                desc: 'Predicate function to evaluate input table group keys.',
                type: 'Function'
            }
        ],
        package: '',
        desc: 'Extracts the first table in a stream with group key values that match a specified predicate.',
        example: 'tableFind( fn: (key) => key.tag == "t2")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/tablefind/'
    },
    {
        name: 'tail',
        args: [
            {
                name: 'n',
                desc: 'Maximum number of rows to output.',
                type: 'Integer'
            },
            {
                name: 'offset',
                desc: 'Number of records to skip at the end of a table table before',
                type: 'Integer'
            }
        ],
        package: '',
        desc: 'Limits each output table to the last `n` rows.',
        example: 'tail(n: 3)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/tail/'
    },
    {
        name: 'testing.assertEmpty',
        args: [],
        package: 'testing',
        desc: 'Tests if an input stream is empty. If not empty, the function returns an error.',
        example: 'testing.assertEmpty()',
        category: 'Tests',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/testing/assertempty/'
    },
    {
        name: 'testing.assertEquals',
        args: [
            {
                name: 'name',
                desc: 'Unique assertion name.',
                type: 'String'
            },
            {
                name: 'got',
                desc: 'Data to test. Default is piped-forward data (`<-`).',
                type: 'Stream of tables'
            },
            {
                name: 'want',
                desc: 'Expected data to test against.',
                type: 'Stream of tables'
            }
        ],
        package: 'testing',
        desc: 'Tests whether two streams of tables are identical.',
        example: 'testing.assertEquals(name: "test_equality", got: got, want: want)',
        category: 'Tests',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/testing/assertequals/'
    },
    {
        name: 'testing.diff',
        args: [
            {
                name: 'got',
                desc: 'Stream containing data to test. Default is piped-forward data (`<-`).',
                type: 'Stream of tables'
            },
            {
                name: 'want',
                desc: 'Stream that contains data to test against.',
                type: 'Stream of tables'
            },
            {
                name: 'epsilon',
                desc: 'Specify how far apart two float values can be, but still considered equal. Defaults to 0.000000001.',
                type: 'Object'
            },
            {
                name: 'verbose',
                desc: 'Include detailed differences in output. Default is `false`.',
                type: 'Object'
            },
            {
                name: 'nansEqual',
                desc: 'Consider `NaN` float values equal. Default is `false`.',
                type: 'Object'
            }
        ],
        package: 'testing',
        desc: 'Produces a diff between two streams.',
        example: 'testing.diff(got: got, want: want)',
        category: 'Tests',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/testing/diff/'
    },
    {
        name: 'time',
        args: [
            {
                name: 'v',
                desc: 'Value to convert.',
                type: 'String, Integer, UInteger'
            }
        ],
        package: '',
        desc: 'Converts a value to a time type.',
        example: 'time(v: "2021-01-01T00:00:00Z")',
        category: 'Type Conversions',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/time/'
    },
    {
        name: 'timedMovingAverage',
        args: [
            {
                name: 'every',
                desc: 'Frequency of time window.',
                type: 'Duration'
            },
            {
                name: 'period',
                desc: 'Length of each averaged time window.',
                type: 'Duration'
            },
            {
                name: 'column',
                desc: 'Column to operate on. Default is `_value`.',
                type: 'String'
            }
        ],
        package: '',
        desc: 'Returns the mean of values in a defined time range at a specified frequency.',
        example: 'timedMovingAverage(every: 1y, period: 5y)',
        category: 'Aggregates',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/timedmovingaverage/'
    },
    {
        name: 'timeShift',
        args: [
            {
                name: 'duration',
                desc: 'Amount of time to add to each time value. May be a negative duration.',
                type: 'String'
            },
            {
                name: 'columns',
                desc: 'List of time columns to operate on. Default is `["_start", "_stop", "_time"]`.',
                type: 'Array of Strings'
            }
        ],
        package: '',
        desc: 'Adds a fixed duration to time columns.',
        example: 'timeShift(duration: 12h)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/timeshift/'
    },
    {
        name: 'to',
        args: [
            {
                name: 'bucket',
                desc: 'Name of the bucket to write to.',
                type: 'String'
            },
            {
                name: 'bucketID',
                desc: 'String-encoded bucket ID to to write to.',
                type: 'String'
            },
            {
                name: 'host',
                desc: 'URL of the InfluxDB instance to write to.',
                type: 'String'
            },
            {
                name: 'org',
                desc: 'Organization name.',
                type: 'String'
            },
            {
                name: 'orgID',
                desc: 'String-encoded organization ID to query.',
                type: 'String'
            },
            {
                name: 'token',
                desc: 'InfluxDB API token.',
                type: 'String'
            },
            {
                name: 'timeColumn',
                desc: 'Time column of the output. Default is `"_time"`.',
                type: 'String'
            },
            {
                name: 'measurementColumn',
                desc: 'Measurement column of the output. Default is `"_measurement"`.',
                type: 'String'
            },
            {
                name: 'tagColumns',
                desc: 'Tag columns in the output. Defaults to all columns with type',
                type: 'Array of Strings'
            },
            {
                name: 'fieldFn',
                desc: 'Function that maps a field key to a field value and returns a record.',
                type: 'Function'
            }
        ],
        package: '',
        desc: 'Writes data to an InfluxDB Cloud or 2.x bucket and returns the written data.',
        example: 'to( bucket: "example-bucket", org: "example-org", token: "mYSuP3rSecR37t0k3N", host: "http://localhost:8086")',
        category: 'Outputs',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/influxdata/influxdb/to/'
    },
    {
        name: 'toBool',
        args: [],
        package: '',
        desc: 'Converts all values in the `_value` column to boolean types.',
        example: 'toBool()',
        category: 'Type Conversions',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/tobool/'
    },
    {
        name: 'toFloat',
        args: [],
        package: '',
        desc: 'Converts all values in the `_value` column to float types.',
        example: 'toFloat()',
        category: 'Type Conversions',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/tofloat/'
    },
    {
        name: 'toInt',
        args: [],
        package: '',
        desc: 'Converts all values in the `_value` column to integer types.',
        example: 'toInt()',
        category: 'Type Conversions',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/toint/'
    },
    {
        name: 'toString',
        args: [],
        package: '',
        desc: 'Converts all values in the `_value` column to string types.',
        example: 'toString()',
        category: 'Type Conversions',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/tostring/'
    },
    {
        name: 'toTime',
        args: [],
        package: '',
        desc: 'Converts all values in the `_value` column to time types.',
        example: 'toTime()',
        category: 'Type Conversions',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/totime/'
    },
    {
        name: 'toUInt',
        args: [],
        package: '',
        desc: 'Converts all values in the `_value` column to unsigned integer types.',
        example: 'toUInt()',
        category: 'Type Conversions',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/touint/'
    },
    {
        name: 'top',
        args: [
            {
                name: 'n',
                desc: 'Number of rows to return from each input table.',
                type: 'Integer'
            },
            {
                name: 'columns',
                desc: 'List of columns to sort by. Default is `["_value"]`.',
                type: 'Array of Strings'
            }
        ],
        package: '',
        desc: 'Sorts each input table by specified columns and keeps the top `n` records in each table.',
        example: 'top(n: 3)',
        category: 'Selectors',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/top/'
    },
    {
        name: 'tripleEMA',
        args: [
            {
                name: 'n',
                desc: 'Number of points to use in the calculation.',
                type: 'Integer'
            }
        ],
        package: '',
        desc: 'Returns the triple exponential moving average (TEMA) of values in the `_value` column.',
        example: 'tripleEMA(n: 3)',
        category: 'Aggregates',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/tripleema/'
    },
    {
        name: 'tripleExponentialDerivative',
        args: [
            {
                name: 'n',
                desc: 'Number of points to use in the calculation.',
                type: 'Integer'
            }
        ],
        package: '',
        desc: 'Returns the triple exponential derivative (TRIX) values using `n` points.',
        example: 'tripleExponentialDerivative(n: 2)',
        category: 'Aggregates',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/tripleexponentialderivative/'
    },
    {
        name: 'truncateTimeColumn',
        args: [
            {
                name: 'unit',
                desc: 'Unit of time to truncate to.',
                type: 'Duration'
            },
            {
                name: 'timeColumn',
                desc: 'Time column to truncate. Default is `_time`.',
                type: 'Object'
            }
        ],
        package: '',
        desc: 'Truncates all input time values in the `_time` to a specified unit.',
        example: 'truncateTimeColumn(unit: 1m)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/truncatetimecolumn/'
    },
    {
        name: 'uint',
        args: [
            {
                name: 'v',
                desc: 'Value to convert.',
                type: 'String, Integer, Boolean'
            }
        ],
        package: '',
        desc: 'Converts a value to an unsigned integer type.',
        example: 'uint(v: "3")',
        category: 'Type Conversions',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/uint/'
    },
    {
        name: 'union',
        args: [
            {
                name: 'tables',
                desc: 'List of two or more streams of tables to union together.',
                type: 'Array of Strings'
            }
        ],
        package: '',
        desc: 'Merges two or more input streams into a single output stream.',
        example: 'union(tables: [t1, t2])',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/union/'
    },
    {
        name: 'unique',
        args: [
            {
                name: 'column',
                desc: 'Column to search for unique values. Default is `_value`.',
                type: 'String'
            }
        ],
        package: '',
        desc: 'Returns all records containing unique values in a specified column.',
        example: 'unique()',
        category: 'Selectors',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/unique/'
    },
    {
        name: 'v1.fieldsAsCols',
        args: [],
        package: 'influxdata/influxdb/v1',
        desc: 'Is a special application of `pivot()` that pivots input data on `_field` and `_time` columns to align fields within each input table that have the same timestamp.',
        example: 'v1.fieldsAsCols()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/influxdata/influxdb/v1/fieldsascols/'
    },
    {
        name: 'v1.measurementTagKeys',
        args: [
            {
                name: 'bucket',
                desc: 'Bucket to return tag keys from for a specific measurement.',
                type: 'String'
            },
            {
                name: 'measurement',
                desc: 'Measurement to return tag keys from.',
                type: 'String'
            },
            {
                name: 'start',
                desc: 'Oldest time to include in results. Default is `-30d`.',
                type: 'Object'
            },
            {
                name: 'stop',
                desc: 'Newest time include in results.',
                type: 'Object'
            }
        ],
        package: 'influxdata/influxdb/v1',
        desc: 'Returns the list of tag keys for a specific measurement.',
        example: 'v1.measurementTagKeys(bucket: "db/rp", measurement: "mem")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/influxdata/influxdb/v1/measurementtagkeys/'
    },
    {
        name: 'v1.measurementTagValues',
        args: [
            {
                name: 'bucket',
                desc: 'Bucket to return tag values from for a specific measurement.',
                type: 'String'
            },
            {
                name: 'measurement',
                desc: 'Measurement to return tag values from.',
                type: 'String'
            },
            {
                name: 'tag',
                desc: 'Tag to return all unique values from.',
                type: 'String'
            },
            {
                name: 'start',
                desc: 'Oldest time to include in results. Default is `-30d`.',
                type: 'Object'
            },
            {
                name: 'stop',
                desc: 'Newest time include in results.',
                type: 'Object'
            }
        ],
        package: 'influxdata/influxdb/v1',
        desc: 'Returns a list of tag values for a specific measurement.',
        example: 'v1.measurementTagValues(bucket: "db/rp", measurement: "mem", tag: "host")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/influxdata/influxdb/v1/measurementtagvalues/'
    },
    {
        name: 'v1.measurements',
        args: [
            {
                name: 'bucket',
                desc: 'Bucket to retrieve measurements from.',
                type: 'String'
            },
            {
                name: 'start',
                desc: 'Oldest time to include in results. Default is `-30d`.',
                type: 'Object'
            },
            {
                name: 'stop',
                desc: 'Newest time include in results.',
                type: 'Object'
            }
        ],
        package: 'influxdata/influxdb/v1',
        desc: 'Returns a list of measurements in a specific bucket.',
        example: 'v1.measurements(bucket: "db/rp")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/influxdata/influxdb/v1/measurements/'
    },
    {
        name: 'v1.tagKeys',
        args: [
            {
                name: 'bucket',
                desc: 'Bucket to return tag keys from.',
                type: 'String'
            },
            {
                name: 'predicate',
                desc: 'Predicate function that filters tag keys.',
                type: 'Function'
            },
            {
                name: 'start',
                desc: 'Oldest time to include in results. Default is `-30d`.',
                type: 'Duration | Time'
            },
            {
                name: 'stop',
                desc: 'Newest time include in results.',
                type: 'Object'
            }
        ],
        package: 'influxdata/influxdb/v1',
        desc: 'Returns a list of tag keys for all series that match the `predicate`.',
        example: 'v1.tagKeys(bucket: "example-bucket")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/influxdata/influxdb/v1/tagkeys/'
    },
    {
        name: 'v1.tagValues',
        args: [
            {
                name: 'bucket',
                desc: 'Bucket to return unique tag values from.',
                type: 'String'
            },
            {
                name: 'tag',
                desc: 'Tag to return unique values from.',
                type: 'String'
            },
            {
                name: 'predicate',
                desc: 'Predicate function that filters tag values.',
                type: 'Function'
            },
            {
                name: 'start',
                desc: 'Oldest time to include in results. Default is `-30d`.',
                type: 'Duration | Time'
            },
            {
                name: 'stop',
                desc: 'Newest time include in results.',
                type: 'Object'
            }
        ],
        package: 'influxdata/influxdb/v1',
        desc: 'Returns a list of unique values for a given tag.',
        example: 'v1.tagValues(bucket: "example-bucket", tag: "host")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/influxdata/influxdb/v1/tagvalues/'
    },
    {
        name: 'window',
        args: [
            {
                name: 'every',
                desc: 'Duration of time between windows.',
                type: 'Duration'
            },
            {
                name: 'period',
                desc: 'Duration of windows. Default is the `every` value.',
                type: 'Duration'
            },
            {
                name: 'offset',
                desc: 'Duration to shift the window boundaries by. Default is `0s`.',
                type: 'Duration'
            },
            {
                name: 'location',
                desc: 'Location used to determine timezone. Default is the `location` option.',
                type: 'Object'
            },
            {
                name: 'timeColumn',
                desc: 'Column that contains time values. Default is `_time`.',
                type: 'String'
            },
            {
                name: 'startColumn',
                desc: 'Column to store the window start time in. Default is `_start`.',
                type: 'String'
            },
            {
                name: 'stopColumn',
                desc: 'Column to store the window stop time in. Default is `_stop`.',
                type: 'String'
            },
            {
                name: 'createEmpty',
                desc: 'Create empty tables for empty window. Default is `false`.',
                type: 'Boolean'
            }
        ],
        package: '',
        desc: 'Groups records using regular time intervals.',
        example: 'window(every: 30s)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/window/'
    },
    {
        name: 'yield',
        args: [
            {
                name: 'name',
                desc: 'Unique name for the yielded results. Default is `_results`.',
                type: 'String'
            }
        ],
        package: '',
        desc: 'Delivers input data as a result of the query.',
        example: 'yield(name: "unmodified")',
        category: 'Outputs',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/yield/'
    },
    {
        name: 'alerta.alert',
        args: [
            {
                name: 'url',
                desc: '(Required) Alerta URL.',
                type: 'String'
            },
            {
                name: 'apiKey',
                desc: '(Required) Alerta API key.',
                type: 'String'
            },
            {
                name: 'resource',
                desc: '(Required) Resource associated with the alert.',
                type: 'Object'
            },
            {
                name: 'event',
                desc: '(Required) Event name.',
                type: 'Object'
            },
            {
                name: 'environment',
                desc: 'Alerta environment. Valid values: "Production", "Development" or empty string (default).',
                type: 'Object'
            },
            {
                name: 'severity',
                desc: '(Required) Event severity. See Alerta severities (https://docs.alerta.io/en/latest/api/alert.html#alert-severities).',
                type: 'Object'
            },
            {
                name: 'service',
                desc: 'List of affected services. Default is `[]`.',
                type: 'Object'
            },
            {
                name: 'group',
                desc: 'Alerta event group. Default is `""`.',
                type: 'Object'
            },
            {
                name: 'value',
                desc: 'Event value. Default is `""`.',
                type: 'Object'
            },
            {
                name: 'text',
                desc: 'Alerta text description. Default is `""`.',
                type: 'Object'
            },
            {
                name: 'tags',
                desc: 'List of event tags. Default is `[]`.',
                type: 'Object'
            },
            {
                name: 'attributes',
                desc: '(Required) Alert attributes.',
                type: 'Object'
            },
            {
                name: 'origin',
                desc: 'monitoring component.',
                type: 'Object'
            },
            {
                name: 'type',
                desc: 'Event type. Default is `""`.',
                type: 'Object'
            },
            {
                name: 'timestamp',
                desc: 'time alert was generated. Default is `now()`.',
                type: 'Object'
            }
        ],
        package: 'contrib/bonitoo-io/alerta',
        desc: 'Sends an alert to Alerta (https://alerta.io/).',
        example: 'alerta.alert( url: "https://alerta.io:8080/alert", apiKey: apiKey, resource: "example-resource", event: "Example event", environment: "Production", severity: severity, service: ["example-service"], group: "example-group", value: string(v: lastReported._value), text: "Service is ${severity}. The last reported value was ${string(v: lastReported._value)}.", tags: ["ex1", "ex2"], attributes: {}, origin: "InfluxDB", type: "exampleAlertType", timestamp: now())',
        category: 'Notification endpoints',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/bonitoo-io/alerta/alert/'
    },
    {
        name: 'alerta.endpoint',
        args: [
            {
                name: 'url',
                desc: '(Required) Alerta URL.',
                type: 'String'
            },
            {
                name: 'apiKey',
                desc: '(Required) Alerta API key.',
                type: 'String'
            },
            {
                name: 'environment',
                desc: 'Alert environment. Default is `""`.',
                type: 'Object'
            },
            {
                name: 'origin',
                desc: 'Alert origin. Default is `"InfluxDB"`.',
                type: 'Object'
            }
        ],
        package: 'contrib/bonitoo-io/alerta',
        desc: 'Sends alerts to Alerta using data from input rows.',
        example: 'alerta.endpoint( url: "https://alerta.io:8080/alert", apiKey: apiKey, environment: "Production", origin: "InfluxDB")',
        category: 'Notification endpoints',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/bonitoo-io/alerta/endpoint/'
    },
    {
        name: 'anomalydetection.mad',
        args: [
            {
                name: 'threshold',
                desc: 'Deviation threshold for anomalies.',
                type: 'Object'
            },
            {
                name: 'table',
                desc: 'Input data. Default is piped-forward data (`<-`).',
                type: 'Stream of tables'
            }
        ],
        package: 'contrib/anaisdg/anomalydetection',
        desc: 'Uses the median absolute deviation (MAD) algorithm to detect anomalies in a data set.',
        example: 'anomalydetection.mad(threshold: 1.0)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/anaisdg/anomalydetection/mad/'
    },
    {
        name: 'array.concat',
        args: [
            {
                name: 'arr',
                desc: 'First array. Default is the piped-forward array (`<-`).',
                type: 'Array'
            },
            {
                name: 'v',
                desc: 'Array to append to the first array.',
                type: 'Array'
            }
        ],
        package: 'array',
        desc: 'Appends two arrays and returns a new array.',
        example: 'array.concat(v: b)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/array/concat/'
    },
    {
        name: 'array.filter',
        args: [
            {
                name: 'arr',
                desc: 'Array to filter. Default is the piped-forward array (`<-`).',
                type: 'Array'
            },
            {
                name: 'fn',
                desc: 'Predicate function to evaluate on each element.',
                type: 'Function'
            }
        ],
        package: 'array',
        desc: 'Iterates over an array, evaluates each element with a predicate function, and then returns a new array with only elements that match the predicate.',
        example: 'array.filter(fn: (x) => x >= 3)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/array/filter/'
    },
    {
        name: 'array.from',
        args: [
            {
                name: 'rows',
                desc: 'Array of records to construct a table with. Default is the piped-forward array (`<-`).',
                type: 'Array'
            }
        ],
        package: 'array',
        desc: 'Constructs a table from an array of records.',
        example: 'array.from(rows: rows)',
        category: 'Inputs',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/array/from/'
    },
    {
        name: 'array.map',
        args: [
            {
                name: 'arr',
                desc: 'Array to operate on. Defaults is the piped-forward array (`<-`).',
                type: 'Array'
            },
            {
                name: 'fn',
                desc: 'Function to apply to elements. The element is represented by `x` in the function.',
                type: 'Function'
            }
        ],
        package: 'array',
        desc: 'Iterates over an array, applies a function to each element to produce a new element, and then returns a new array.',
        example: 'array.map(fn: (x) => ({_value: x}))',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/array/map/'
    },
    {
        name: 'array.toBool',
        args: [
            {
                name: 'arr',
                desc: 'Array of values to convert. Default is the piped-forward array (`<-`).',
                type: 'Array'
            }
        ],
        package: 'experimental/array',
        desc: 'Converts all values in an array to booleans.',
        example: 'array.toBool(arr: arr)',
        category: 'Type Conversions',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/array/tobool/'
    },
    {
        name: 'array.toDuration',
        args: [
            {
                name: 'arr',
                desc: 'Array of values to convert. Default is the piped-forward array (`<-`).',
                type: 'Array'
            }
        ],
        package: 'experimental/array',
        desc: 'Converts all values in an array to durations.',
        example: 'array.toDuration(arr: arr)',
        category: 'Type Conversions',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/array/toduration/'
    },
    {
        name: 'array.toFloat',
        args: [
            {
                name: 'arr',
                desc: 'Array of values to convert. Default is the piped-forward array (`<-`).',
                type: 'Array'
            }
        ],
        package: 'experimental/array',
        desc: 'Converts all values in an array to floats.',
        example: 'array.toFloat(arr: arr)',
        category: 'Type Conversions',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/array/tofloat/'
    },
    {
        name: 'array.toInt',
        args: [
            {
                name: 'arr',
                desc: 'Array of values to convert. Default is the piped-forward array (`<-`).',
                type: 'Array'
            }
        ],
        package: 'experimental/array',
        desc: 'Converts all values in an array to integers.',
        example: 'array.toInt(arr: arr)',
        category: 'Type Conversions',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/array/toint/'
    },
    {
        name: 'array.toString',
        args: [
            {
                name: 'arr',
                desc: 'Array of values to convert. Default is the piped-forward array (`<-`).',
                type: 'Array'
            }
        ],
        package: 'experimental/array',
        desc: 'Converts all values in an array to strings.',
        example: 'array.toString(arr: arr)',
        category: 'Type Conversions',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/array/tostring/'
    },
    {
        name: 'array.toTime',
        args: [
            {
                name: 'arr',
                desc: 'Array of values to convert. Default is the piped-forward array (`<-`).',
                type: 'Array'
            }
        ],
        package: 'experimental/array',
        desc: 'Converts all values in an array to times.',
        example: 'array.toTime(arr: arr)',
        category: 'Type Conversions',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/array/totime/'
    },
    {
        name: 'array.toUInt',
        args: [
            {
                name: 'arr',
                desc: 'Array of values to convert. Default is the piped-forward array (`<-`).',
                type: 'Array'
            }
        ],
        package: 'experimental/array',
        desc: 'Converts all values in an array to unsigned integers.',
        example: 'array.toUInt()',
        category: 'Type Conversions',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/array/touint/'
    },
    {
        name: 'bigpanda.endpoint',
        args: [
            {
                name: 'url',
                desc: 'BigPanda alerts API URL (https://docs.bigpanda.io/reference#alerts-how-it-works).',
                type: 'String'
            },
            {
                name: 'token',
                desc: 'BigPanda API Authorization token (API key) (https://docs.bigpanda.io/docs/api-key-management).',
                type: 'String'
            },
            {
                name: 'appKey',
                desc: 'BigPanda App Key (https://docs.bigpanda.io/reference#integrating-monitoring-systems).',
                type: 'Object'
            }
        ],
        package: 'contrib/rhajek/bigpanda',
        desc: 'Sends alerts to BigPanda using data from input rows.',
        example: 'bigpanda.endpoint(token: token, appKey: "example-app-key")',
        category: 'Notification endpoints',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/rhajek/bigpanda/endpoint/'
    },
    {
        name: 'bigpanda.sendAlert',
        args: [
            {
                name: 'url',
                desc: 'BigPanda alerts API URL (https://docs.bigpanda.io/reference#alerts-how-it-works).',
                type: 'String'
            },
            {
                name: 'token',
                desc: 'BigPanda API Authorization token (API key) (https://docs.bigpanda.io/docs/api-key-management).',
                type: 'String'
            },
            {
                name: 'appKey',
                desc: 'BigPanda App Key (https://docs.bigpanda.io/reference#integrating-monitoring-systems).',
                type: 'Object'
            },
            {
                name: 'status',
                desc: 'BigPanda alert status (https://docs.bigpanda.io/reference#alerts).',
                type: 'Object'
            },
            {
                name: 'rec',
                desc: 'Additional alert parameters (https://docs.bigpanda.io/reference#alert-object) to send to the BigPanda alert API.',
                type: 'Object'
            }
        ],
        package: 'contrib/rhajek/bigpanda',
        desc: 'Sends an alert to BigPanda (https://www.bigpanda.io/).',
        example: 'bigpanda.sendAlert( token: token, appKey: "example-app-key", status: bigpanda.statusFromLevel(level: "${lastReported.status}"), rec: { tags: json.encode(v: [{"name": "host", "value": "my-host"}]), check: "my-check", description: "${lastReported._field} is ${lastReported.status}: ${string( v: lastReported._value, )}", })',
        category: 'Notification endpoints',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/rhajek/bigpanda/sendalert/'
    },
    {
        name: 'bigpanda.statusFromLevel',
        args: [
            {
                name: 'level',
                desc: 'Alert level.',
                type: 'String'
            }
        ],
        package: 'contrib/rhajek/bigpanda',
        desc: 'Converts an alert level to a BigPanda status.',
        example: 'bigpanda.statusFromLevel(level: "crit")',
        category: 'Notification endpoints',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/rhajek/bigpanda/statusfromlevel/'
    },
    {
        name: 'bitwise.sand',
        args: [
            {
                name: 'a',
                desc: 'Left hand operand.',
                type: 'Integer'
            },
            {
                name: 'b',
                desc: 'Right hand operand.',
                type: 'Integer'
            }
        ],
        package: 'bitwise',
        desc: 'Performs the bitwise operation, `a AND b`, with integers.',
        example: 'bitwise.sand(a: 1234, b: 4567)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/bitwise/sand/'
    },
    {
        name: 'bitwise.sclear',
        args: [
            {
                name: 'a',
                desc: 'Left hand operand.',
                type: 'Integer'
            },
            {
                name: 'b',
                desc: 'Bits to clear.',
                type: 'Integer'
            }
        ],
        package: 'bitwise',
        desc: 'Performs the bitwise operation `a AND NOT b`. Both `a` and `b` are integers.',
        example: 'bitwise.sclear(a: 1234, b: 4567)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/bitwise/sclear/'
    },
    {
        name: 'bitwise.slshift',
        args: [
            {
                name: 'a',
                desc: 'Left hand operand.',
                type: 'Integer'
            },
            {
                name: 'b',
                desc: 'Number of bits to shift.',
                type: 'Integer'
            }
        ],
        package: 'bitwise',
        desc: 'Shifts the bits in `a` left by `b` bits. Both `a` and `b` are integers.',
        example: 'bitwise.slshift(a: 1234, b: 2)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/bitwise/slshift/'
    },
    {
        name: 'bitwise.snot',
        args: [
            {
                name: 'a',
                desc: 'Integer to invert.',
                type: 'Integer'
            }
        ],
        package: 'bitwise',
        desc: 'Inverts every bit in `a`, an integer.',
        example: 'bitwise.snot(a: 1234)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/bitwise/snot/'
    },
    {
        name: 'bitwise.sor',
        args: [
            {
                name: 'a',
                desc: 'Left hand operand.',
                type: 'Integer'
            },
            {
                name: 'b',
                desc: 'Right hand operand.',
                type: 'Integer'
            }
        ],
        package: 'bitwise',
        desc: 'Performs the bitwise operation, `a OR b`, with integers.',
        example: 'bitwise.sor(a: 1234, b: 4567)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/bitwise/sor/'
    },
    {
        name: 'bitwise.srshift',
        args: [
            {
                name: 'a',
                desc: 'Left hand operand.',
                type: 'Integer'
            },
            {
                name: 'b',
                desc: 'Number of bits to shift.',
                type: 'Integer'
            }
        ],
        package: 'bitwise',
        desc: 'Shifts the bits in `a` right by `b` bits. Both `a` and `b` are integers.',
        example: 'bitwise.srshift(a: 1234, b: 2)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/bitwise/srshift/'
    },
    {
        name: 'bitwise.sxor',
        args: [
            {
                name: 'a',
                desc: 'Left hand operand.',
                type: 'Integer'
            },
            {
                name: 'b',
                desc: 'Right hand operand.',
                type: 'Integer'
            }
        ],
        package: 'bitwise',
        desc: 'Performs the bitwise operation, `a XOR b`, with integers.',
        example: 'bitwise.sxor(a: 1234, b: 4567)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/bitwise/sxor/'
    },
    {
        name: 'bitwise.uand',
        args: [
            {
                name: 'a',
                desc: 'Left hand operand.',
                type: 'UInteger'
            },
            {
                name: 'b',
                desc: 'Right hand operand.',
                type: 'UInteger'
            }
        ],
        package: 'bitwise',
        desc: 'Performs the bitwise operation, `a AND b`, with unsigned integers.',
        example: 'bitwise.uand(a: uint(v: 1234), b: uint(v: 4567))',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/bitwise/uand/'
    },
    {
        name: 'bitwise.uclear',
        args: [
            {
                name: 'a',
                desc: 'Left hand operand.',
                type: 'UInteger'
            },
            {
                name: 'b',
                desc: 'Bits to clear.',
                type: 'UInteger'
            }
        ],
        package: 'bitwise',
        desc: 'Performs the bitwise operation `a AND NOT b`, with unsigned integers.',
        example: 'bitwise.uclear(a: uint(v: 1234), b: uint(v: 4567))',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/bitwise/uclear/'
    },
    {
        name: 'bitwise.ulshift',
        args: [
            {
                name: 'a',
                desc: 'Left hand operand.',
                type: 'UInteger'
            },
            {
                name: 'b',
                desc: 'Number of bits to shift.',
                type: 'UInteger'
            }
        ],
        package: 'bitwise',
        desc: 'Shifts the bits in `a` left by `b` bits. Both `a` and `b` are unsigned integers.',
        example: 'bitwise.ulshift(a: uint(v: 1234), b: uint(v: 2))',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/bitwise/ulshift/'
    },
    {
        name: 'bitwise.unot',
        args: [
            {
                name: 'a',
                desc: 'Unsigned integer to invert.',
                type: 'UInteger'
            }
        ],
        package: 'bitwise',
        desc: 'Inverts every bit in `a`, an unsigned integer.',
        example: 'bitwise.unot(a: uint(v: 1234))',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/bitwise/unot/'
    },
    {
        name: 'bitwise.uor',
        args: [
            {
                name: 'a',
                desc: 'Left hand operand.',
                type: 'UInteger'
            },
            {
                name: 'b',
                desc: 'Right hand operand.',
                type: 'UInteger'
            }
        ],
        package: 'bitwise',
        desc: 'Performs the bitwise operation, `a OR b`, with unsigned integers.',
        example: 'bitwise.uor(a: uint(v: 1234), b: uint(v: 4567))',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/bitwise/uor/'
    },
    {
        name: 'bitwise.urshift',
        args: [
            {
                name: 'a',
                desc: 'Left hand operand.',
                type: 'UInteger'
            },
            {
                name: 'b',
                desc: 'Number of bits to shift.',
                type: 'UInteger'
            }
        ],
        package: 'bitwise',
        desc: 'Shifts the bits in `a` right by `b` bits. Both `a` and `b` are unsigned integers.',
        example: 'bitwise.urshift(a: uint(v: 1234), b: uint(v: 2))',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/bitwise/urshift/'
    },
    {
        name: 'bitwise.uxor',
        args: [
            {
                name: 'a',
                desc: 'Left hand operand.',
                type: 'UInteger'
            },
            {
                name: 'b',
                desc: 'Right hand operand.',
                type: 'UInteger'
            }
        ],
        package: 'bitwise',
        desc: 'Performs the bitwise operation, `a XOR b`, with unsigned integers.',
        example: 'bitwise.uxor(a: uint(v: 1234), b: uint(v: 4567))',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/bitwise/uxor/'
    },
    {
        name: 'boundaries.friday',
        args: [],
        package: 'experimental/date/boundaries',
        desc: 'Returns a record with `start` and `stop` boundary timestamps for last Friday.',
        example: 'boundaries.friday()',
        category: 'Date/time',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/date/boundaries/friday/'
    },
    {
        name: 'boundaries.monday',
        args: [],
        package: 'experimental/date/boundaries',
        desc: 'Returns a record with `start` and `stop` boundary timestamps of last Monday. Last Monday is relative to `now()`. If today is Monday, the function returns boundaries for the previous Monday.',
        example: 'boundaries.monday()',
        category: 'Date/time',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/date/boundaries/monday/'
    },
    {
        name: 'boundaries.month',
        args: [
            {
                name: 'month_offset',
                desc: 'Number of months to offset from the current month. Default is `0`.',
                type: 'Integer'
            }
        ],
        package: 'experimental/date/boundaries',
        desc: 'Returns a record with `start` and `stop` boundary timestamps for the current month.',
        example: 'boundaries.month( )',
        category: 'Date/time',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/date/boundaries/month/'
    },
    {
        name: 'boundaries.saturday',
        args: [],
        package: 'experimental/date/boundaries',
        desc: 'Returns a record with `start` and `stop` boundary timestamps for last Saturday.',
        example: 'boundaries.saturday()',
        category: 'Date/time',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/date/boundaries/saturday/'
    },
    {
        name: 'boundaries.sunday',
        args: [],
        package: 'experimental/date/boundaries',
        desc: 'Returns a record with `start` and `stop` boundary timestamps for last Sunday.',
        example: 'boundaries.sunday()',
        category: 'Date/time',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/date/boundaries/sunday/'
    },
    {
        name: 'boundaries.thursday',
        args: [],
        package: 'experimental/date/boundaries',
        desc: 'Returns a record with `start` and `stop` boundary timestamps for last Thursday.',
        example: 'boundaries.thursday()',
        category: 'Date/time',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/date/boundaries/thursday/'
    },
    {
        name: 'boundaries.tuesday',
        args: [],
        package: 'experimental/date/boundaries',
        desc: 'Returns a record with `start` and `stop` boundary timestamps of last Tuesday.',
        example: 'boundaries.tuesday()',
        category: 'Date/time',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/date/boundaries/tuesday/'
    },
    {
        name: 'boundaries.wednesday',
        args: [],
        package: 'experimental/date/boundaries',
        desc: 'Returns a record with `start` and `stop` boundary timestamps for last Wednesday.',
        example: 'boundaries.wednesday()',
        category: 'Date/time',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/date/boundaries/wednesday/'
    },
    {
        name: 'boundaries.week',
        args: [
            {
                name: 'start_sunday',
                desc: 'Indicate if the week starts on Sunday. Default is `false`.',
                type: 'Boolean'
            },
            {
                name: 'week_offset',
                desc: 'Number of weeks to offset from the current week. Default is `0`.',
                type: 'Integer'
            }
        ],
        package: 'experimental/date/boundaries',
        desc: 'Returns a record with `start` and `stop` boundary timestamps of the current week. By default, weeks start on Monday.',
        example: 'boundaries.week( )',
        category: 'Date/time',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/date/boundaries/week/'
    },
    {
        name: 'boundaries.yesterday',
        args: [],
        package: 'experimental/date/boundaries',
        desc: 'Returns a record with `start` and `stop` boundary timestamps for yesterday.',
        example: 'boundaries.yesterday( )',
        category: 'Date/time',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/date/boundaries/yesterday/'
    },
    {
        name: 'buckets',
        args: [
            {
                name: 'org',
                desc: 'Organization name. Default is the current organization.',
                type: 'String'
            },
            {
                name: 'orgID',
                desc: 'Organization ID. Default is the ID of the current organization.',
                type: 'String'
            },
            {
                name: 'host',
                desc: 'URL of the InfluxDB instance.',
                type: 'String'
            },
            {
                name: 'token',
                desc: 'InfluxDB API token.',
                type: 'String'
            }
        ],
        package: 'influxdata/influxdb',
        desc: 'Returns a list of buckets in the specified organization.',
        example: 'buckets(org: "example-org", host: "http://localhost:8086", token: "mYSuP3rSecR37t0k3N")',
        category: 'Metadata',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/influxdata/influxdb/buckets/'
    },
    {
        name: 'clickhouse.query',
        args: [
            {
                name: 'url',
                desc: 'ClickHouse HTTP API URL. Default is `http://127.0.0.1:8123`.',
                type: 'String'
            },
            {
                name: 'query',
                desc: 'ClickHouse query to execute.',
                type: 'String'
            },
            {
                name: 'limit',
                desc: 'Query rows limit. Defaults is `100`.',
                type: 'Object'
            },
            {
                name: 'cors',
                desc: 'Request remote CORS headers. Defaults is `1`.',
                type: 'String'
            },
            {
                name: 'max_bytes',
                desc: 'Query bytes limit. Default is `10000000`.',
                type: 'Object'
            },
            {
                name: 'format',
                desc: 'Query format. Default is `CSVWithNames`.',
                type: 'String'
            }
        ],
        package: 'contrib/qxip/clickhouse',
        desc: 'Queries data from ClickHouse using specified parameters.',
        example: 'clickhouse.query(query: "SELECT version()")',
        category: 'Inputs',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/qxip/clickhouse/query/'
    },
    {
        name: 'date.add',
        args: [
            {
                name: 'd',
                desc: 'Duration to add.',
                type: 'Duration'
            },
            {
                name: 'to',
                desc: 'Time to add the duration to.',
                type: 'Object'
            },
            {
                name: 'location',
                desc: 'Location to use for the time value.',
                type: 'Object'
            }
        ],
        package: 'date',
        desc: 'Adds a duration to a time value and returns the resulting time value.',
        example: 'date.add(d: 6h, to: 2019-09-16T12:00:00Z)',
        category: 'Date/time',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/date/add/'
    },
    {
        name: 'date.scale',
        args: [
            {
                name: 'd',
                desc: 'Duration to scale.',
                type: 'Duration'
            },
            {
                name: 'n',
                desc: 'Amount to scale the duration by.',
                type: 'Integer'
            }
        ],
        package: 'date',
        desc: 'Will multiply the duration by the given value.',
        example: 'date.scale(d: 1h, n: n)',
        category: 'Date/time',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/date/scale/'
    },
    {
        name: 'date.sub',
        args: [
            {
                name: 'from',
                desc: 'Time to subtract the duration from.',
                type: 'Object'
            },
            {
                name: 'd',
                desc: 'Duration to subtract.',
                type: 'Duration'
            },
            {
                name: 'location',
                desc: 'Location to use for the time value.',
                type: 'Object'
            }
        ],
        package: 'date',
        desc: 'Subtracts a duration from a time value and returns the resulting time value.',
        example: 'date.sub(from: 2019-09-16T12:00:00Z, d: 6h)',
        category: 'Date/time',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/date/sub/'
    },
    {
        name: 'date.time',
        args: [
            {
                name: 't',
                desc: 'Duration or time value.',
                type: 'Object'
            },
            {
                name: 'location',
                desc: 'Location used to determine timezone.',
                type: 'Object'
            }
        ],
        package: 'date',
        desc: 'Returns the time value of a specified relative duration or time.',
        example: 'date.time(t: 2020-02-11T12:21:03.29353494Z)',
        category: 'Date/time',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/date/time/'
    },
    {
        name: 'debug.feature',
        args: [
            {
                name: 'key',
                desc: 'Feature flag name.',
                type: 'String'
            }
        ],
        package: 'internal/debug',
        desc: 'Returns the value associated with the given feature flag.',
        example: 'debug.feature()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/internal/debug/feature/'
    },
    {
        name: 'debug.getOption',
        args: [
            {
                name: 'pkg',
                desc: 'Full path of the package.',
                type: 'String'
            },
            {
                name: 'name',
                desc: 'Option name.',
                type: 'String'
            }
        ],
        package: 'internal/debug',
        desc: 'Gets the value of an option using a form of reflection.',
        example: 'debug.getOption()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/internal/debug/getoption/'
    },
    {
        name: 'debug.null',
        args: [
            {
                name: 'type',
                desc: 'Null type.',
                type: 'String'
            }
        ],
        package: 'internal/debug',
        desc: 'Returns the null value with a given type.',
        example: 'debug.null(type: "int")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/internal/debug/null/'
    },
    {
        name: 'debug.opaque',
        args: [],
        package: 'internal/debug',
        desc: 'Works like `pass` in that it passes any incoming tables directly to the following transformation, save for its type signature does not indicate that the input type has any correlation with the output type.',
        example: 'debug.opaque()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/internal/debug/opaque/'
    },
    {
        name: 'debug.pass',
        args: [],
        package: 'internal/debug',
        desc: 'Will pass any incoming tables directly next to the following transformation. It is best used to interrupt any planner rules that rely on a specific ordering.',
        example: 'debug.pass()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/internal/debug/pass/'
    },
    {
        name: 'debug.sink',
        args: [],
        package: 'internal/debug',
        desc: 'Will discard all data that comes into it.',
        example: 'debug.sink()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/internal/debug/sink/'
    },
    {
        name: 'debug.slurp',
        args: [],
        package: 'internal/debug',
        desc: 'Will read the incoming tables and concatenate buffers with the same group key into a single in memory table buffer. This is useful for testing the performance impact of multiple buffers versus a single buffer.',
        example: 'debug.slurp()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/internal/debug/slurp/'
    },
    {
        name: 'dict.fromList',
        args: [
            {
                name: 'pairs',
                desc: 'List of records with `key` and `value` properties.',
                type: 'Array'
            }
        ],
        package: 'dict',
        desc: 'Creates a dictionary from a list of records with `key` and `value` properties.',
        example: 'dict.fromList( pairs: [{key: 1, value: "foo"}, {key: 2, value: "bar"}])',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/dict/fromlist/'
    },
    {
        name: 'dict.get',
        args: [
            {
                name: 'dict',
                desc: 'Dictionary to return a value from.',
                type: 'Array'
            },
            {
                name: 'key',
                desc: 'Key to return from the dictionary.',
                type: 'Object'
            },
            {
                name: 'default',
                desc: 'Default value to return if the key does not exist in the',
                type: 'Object'
            }
        ],
        package: 'dict',
        desc: 'Returns the value of a specified key in a dictionary or a default value if the key does not exist.',
        example: 'dict.get(dict: d, key: 1, default: "")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/dict/get/'
    },
    {
        name: 'dict.insert',
        args: [
            {
                name: 'dict',
                desc: 'Dictionary to update.',
                type: 'Array'
            },
            {
                name: 'key',
                desc: 'Key to insert into the dictionary.',
                type: 'Object'
            },
            {
                name: 'value',
                desc: 'Value to insert into the dictionary.',
                type: 'Object'
            }
        ],
        package: 'dict',
        desc: 'Inserts a key-value pair into a dictionary and returns a new, updated dictionary.',
        example: 'dict.insert(dict: d, key: 3, value: "baz")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/dict/insert/'
    },
    {
        name: 'dict.remove',
        args: [
            {
                name: 'dict',
                desc: 'Dictionary to remove the key-value pair from.',
                type: 'Array'
            },
            {
                name: 'key',
                desc: 'Key to remove from the dictionary.',
                type: 'Object'
            }
        ],
        package: 'dict',
        desc: 'Removes a key value pair from a dictionary and returns an updated dictionary.',
        example: 'dict.remove(dict: d, key: 1)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/dict/remove/'
    },
    {
        name: 'die',
        args: [
            {
                name: 'msg',
                desc: 'Error message to return.',
                type: 'String'
            }
        ],
        package: '',
        desc: 'Stops the Flux script execution and returns an error message.',
        example: 'die(msg: "This is an error message")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/die/'
    },
    {
        name: 'discord.endpoint',
        args: [
            {
                name: 'webhookToken',
                desc: 'Discord webhook token (https://discord.com/developers/docs/resources/webhook).',
                type: 'String'
            },
            {
                name: 'webhookID',
                desc: 'Discord webhook ID (https://discord.com/developers/docs/resources/webhook).',
                type: 'String'
            },
            {
                name: 'username',
                desc: "Override the Discord webhook\u2019s default username.",
                type: 'Object'
            },
            {
                name: 'avatar_url',
                desc: "Override the Discord webhook\u2019s default avatar.",
                type: 'Object'
            }
        ],
        package: 'contrib/chobbs/discord',
        desc: 'Sends a single message to a Discord channel using a Discord webhook (https://support.discord.com/hc/en-us/articles/228383668-Intro-to-Webhooks&?page=3) and data from table rows.',
        example: 'discord.endpoint()',
        category: 'Notification endpoints',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/chobbs/discord/endpoint/'
    },
    {
        name: 'discord.send',
        args: [
            {
                name: 'webhookToken',
                desc: 'Discord webhook token (https://discord.com/developers/docs/resources/webhook).',
                type: 'String'
            },
            {
                name: 'webhookID',
                desc: 'Discord webhook ID (https://discord.com/developers/docs/resources/webhook).',
                type: 'String'
            },
            {
                name: 'username',
                desc: "Override the Discord webhook\u2019s default username.",
                type: 'Object'
            },
            {
                name: 'content',
                desc: 'Message to send to Discord (2000 character limit).',
                type: 'Object'
            },
            {
                name: 'avatar_url',
                desc: "Override the Discord webhook\u2019s default avatar.",
                type: 'Object'
            }
        ],
        package: 'contrib/chobbs/discord',
        desc: 'Sends a single message to a Discord channel using a Discord webhook.',
        example: 'discord.send( webhookToken: token, webhookID: "1234567890", username: "chobbs", content: "The current status is \\"${lastReported.status}\\".", avatar_url: "https://staff-photos.net/pic.jpg")',
        category: 'Notification endpoints',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/chobbs/discord/send/'
    },
    {
        name: 'display',
        args: [
            {
                name: 'v',
                desc: 'Value to convert for display.',
                type: 'Object'
            }
        ],
        package: '',
        desc: 'Returns the Flux literal representation of any value as a string.',
        example: 'display(v: ["a": 1, "b": 2])',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/display/'
    },
    {
        name: 'dynamic.asArray',
        args: [
            {
                name: 'v',
                desc: 'Dynamic value to convert. Default is the piped-forward value (`<-`).',
                type: 'Object'
            }
        ],
        package: 'experimental/dynamic',
        desc: 'Converts a dynamic value into an array of dynamic elements.',
        example: 'dynamic.asArray()',
        category: 'Type Conversions',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/dynamic/asarray/'
    },
    {
        name: 'dynamic.dynamic',
        args: [
            {
                name: 'v',
                desc: 'Value to wrap as dynamic.',
                type: 'Object'
            }
        ],
        package: 'experimental/dynamic',
        desc: 'Wraps a value so it can be used as a `dynamic` value.',
        example: 'dynamic.dynamic()',
        category: 'Type Conversions',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/dynamic/dynamic/'
    },
    {
        name: 'dynamic.isType',
        args: [
            {
                name: 'v',
                desc: 'Value to test.',
                type: 'Object'
            },
            {
                name: 'type',
                desc: 'String describing the type to check against.',
                type: 'String'
            }
        ],
        package: 'experimental/dynamic',
        desc: 'Tests if a dynamic type holds a value of a specified type.',
        example: 'dynamic.isType()',
        category: 'Tests',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/dynamic/istype/'
    },
    {
        name: 'dynamic.jsonEncode',
        args: [
            {
                name: 'v',
                desc: 'Value to encode into JSON.',
                type: 'Object'
            }
        ],
        package: 'experimental/dynamic',
        desc: 'Converts a dynamic value into JSON bytes.',
        example: 'dynamic.jsonEncode()',
        category: 'Type Conversions',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/dynamic/jsonencode/'
    },
    {
        name: 'dynamic.jsonParse',
        args: [
            {
                name: 'data',
                desc: 'JSON data (as bytes) to parse.',
                type: 'Bytes'
            }
        ],
        package: 'experimental/dynamic',
        desc: 'Takes JSON data as bytes and returns dynamic values.',
        example: 'dynamic.jsonParse()',
        category: 'Type Conversions',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/dynamic/jsonparse/'
    },
    {
        name: 'events.duration',
        args: [
            {
                name: 'unit',
                desc: 'Duration unit of the calculated state duration.',
                type: 'Duration'
            },
            {
                name: 'columnName',
                desc: 'Name of the result column.',
                type: 'String'
            },
            {
                name: 'timeColumn',
                desc: 'Name of the time column.',
                type: 'String'
            },
            {
                name: 'stopColumn',
                desc: 'Name of the stop column.',
                type: 'String'
            },
            {
                name: 'stop',
                desc: 'The latest time to use when calculating results.',
                type: 'Time'
            }
        ],
        package: 'contrib/tomhollingworth/events',
        desc: 'Calculates the duration of events.',
        example: 'events.duration(unit: 1m, stop: 2020-01-02T00:00:00Z)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/tomhollingworth/events/duration/'
    },
    {
        name: 'expect.planner',
        args: [
            {
                name: 'rules',
                desc: 'Mapping of rules names to expected counts.',
                type: 'Array'
            }
        ],
        package: 'testing/expect',
        desc: 'Will cause the present testcase to expect the given planner rules will be invoked exactly as many times as the number given.',
        example: 'expect.planner()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/testing/expect/planner/'
    },
    {
        name: 'experimental.alignTime',
        args: [
            {
                name: 'alignTo',
                desc: 'Time to align tables to. Default is `1970-01-01T00:00:00Z`.',
                type: 'Object'
            }
        ],
        package: 'experimental',
        desc: 'Shifts time values in input tables to all start at a common start time.',
        example: 'experimental.alignTime(alignTo: 2021-01-01T00:00:00Z)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/aligntime/'
    },
    {
        name: 'experimental.catch',
        args: [
            {
                name: 'fn',
                desc: 'Function to call.',
                type: 'Function'
            }
        ],
        package: 'experimental',
        desc: 'Calls a function and returns any error as a string value. If the function does not error the returned value is made into a string and returned.',
        example: 'experimental.catch(fn: () => die(msg: "error message"))',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/catch/'
    },
    {
        name: 'experimental.chain',
        args: [
            {
                name: 'first',
                desc: 'First query to execute.',
                type: 'Stream of tables'
            },
            {
                name: 'second',
                desc: 'Second query to execute.',
                type: 'Stream of tables'
            }
        ],
        package: 'experimental',
        desc: 'Runs two queries in a single Flux script sequentially and outputs the results of the second query.',
        example: 'experimental.chain(first: downsampled_max, second: average_max)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/chain/'
    },
    {
        name: 'experimental.count',
        args: [],
        package: 'experimental',
        desc: 'Returns the number of records in each input table.',
        example: 'experimental.count()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/count/'
    },
    {
        name: 'experimental.diff',
        args: [
            {
                name: 'want',
                desc: 'Input stream for the `-` side of the diff.',
                type: 'Stream of tables'
            },
            {
                name: 'got',
                desc: 'Input stream for the `+` side of the diff.',
                type: 'Stream of tables'
            }
        ],
        package: 'experimental',
        desc: 'Takes two table streams as input and produces a diff.',
        example: 'experimental.diff(got: got, want: want)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/diff/'
    },
    {
        name: 'experimental.distinct',
        args: [],
        package: 'experimental',
        desc: 'Returns unique values from the `_value` column.',
        example: 'experimental.distinct()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/distinct/'
    },
    {
        name: 'experimental.fill',
        args: [
            {
                name: 'value',
                desc: 'Value to replace null values with.',
                type: 'Object'
            },
            {
                name: 'usePrevious',
                desc: 'Replace null values with the value of the previous non-null row.',
                type: 'Boolean'
            }
        ],
        package: 'experimental',
        desc: 'Replaces all null values in the `_value` column with a non-null value.',
        example: 'experimental.fill(value: 0)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/fill/'
    },
    {
        name: 'experimental.first',
        args: [],
        package: 'experimental',
        desc: 'Returns the first record with a non-null value in the `_value` column for each input table.',
        example: 'experimental.first()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/first/'
    },
    {
        name: 'experimental.histogram',
        args: [
            {
                name: 'bins',
                desc: 'List of upper bounds to use when computing histogram frequencies,',
                type: 'Array'
            },
            {
                name: 'normalize',
                desc: 'Convert count values into frequency values between 0 and 1.',
                type: 'Boolean'
            }
        ],
        package: 'experimental',
        desc: 'Approximates the cumulative distribution of a dataset by counting data frequencies for a list of bins.',
        example: 'experimental.histogram( bins: [ 0.0, 5.0, 10.0, 15.0, 20.0, ])',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/histogram/'
    },
    {
        name: 'experimental.histogramQuantile',
        args: [
            {
                name: 'quantile',
                desc: 'Quantile to compute (`[0.0 - 1.0]`).',
                type: 'Float'
            },
            {
                name: 'minValue',
                desc: 'Assumed minimum value of the dataset. Default is `0.0`.',
                type: 'Float'
            }
        ],
        package: 'experimental',
        desc: 'Approximates a quantile given a histogram with the cumulative distribution of the dataset.',
        example: 'experimental.histogramQuantile(quantile: 0.9)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/histogramquantile/'
    },
    {
        name: 'experimental.integral',
        args: [
            {
                name: 'unit',
                desc: 'Time duration used to compute the integral.',
                type: 'Duration'
            },
            {
                name: 'interpolate',
                desc: 'Type of interpolation to use. Default is `""` (no interpolation).',
                type: 'String'
            }
        ],
        package: 'experimental',
        desc: 'Computes the area under the curve per unit of time of subsequent non-null records.',
        example: 'experimental.integral(unit: 20s)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/integral/'
    },
    {
        name: 'experimental.kaufmansAMA',
        args: [
            {
                name: 'n',
                desc: 'Period or number of points to use in the calculation.',
                type: 'Integer'
            }
        ],
        package: 'experimental',
        desc: "Calculates the Kaufman's Adaptive Moving Average (KAMA) of input tables using the `_value` column in each table.",
        example: 'experimental.kaufmansAMA(n: 3)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/kaufmansama/'
    },
    {
        name: 'experimental.last',
        args: [],
        package: 'experimental',
        desc: 'Returns the last record with a non-null value in the `_value` column for each input table.',
        example: 'experimental.last()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/last/'
    },
    {
        name: 'experimental.max',
        args: [],
        package: 'experimental',
        desc: 'Returns the record with the highest value in the `_value` column for each input table.',
        example: 'experimental.max()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/max/'
    },
    {
        name: 'experimental.mean',
        args: [],
        package: 'experimental',
        desc: 'Computes the mean or average of non-null values in the `_value` column of each input table.',
        example: 'experimental.mean()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/mean/'
    },
    {
        name: 'experimental.min',
        args: [],
        package: 'experimental',
        desc: 'Returns the record with the lowest value in the `_value` column for each input table.',
        example: 'experimental.min()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/min/'
    },
    {
        name: 'experimental.mode',
        args: [],
        package: 'experimental',
        desc: 'Computes the mode or value that occurs most often in the `_value` column in each input table.',
        example: 'experimental.mode()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/mode/'
    },
    {
        name: 'experimental.preview',
        args: [
            {
                name: 'nrows',
                desc: 'Maximum number of rows per table to return. Default is `5`.',
                type: 'Integer'
            },
            {
                name: 'ntables',
                desc: 'Maximum number of tables to return.',
                type: 'Integer'
            }
        ],
        package: 'experimental',
        desc: 'Limits the number of rows and tables in the stream.',
        example: 'experimental.preview()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/preview/'
    },
    {
        name: 'experimental.quantile',
        args: [
            {
                name: 'q',
                desc: 'Quantile to compute (`[0 - 1]`).',
                type: 'Float'
            },
            {
                name: 'method',
                desc: 'Computation method. Default is `estimate_tdigest`.',
                type: 'String'
            },
            {
                name: 'compression',
                desc: 'Number of centroids to use when compressing the dataset.',
                type: 'Float'
            }
        ],
        package: 'experimental',
        desc: 'Returns non-null records with values in the `_value` column that fall within the specified quantile or represent the specified quantile.',
        example: 'experimental.quantile(q: 0.5)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/quantile/'
    },
    {
        name: 'experimental.skew',
        args: [],
        package: 'experimental',
        desc: 'Returns the skew of non-null values in the `_value` column for each input table as a float.',
        example: 'experimental.skew()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/skew/'
    },
    {
        name: 'experimental.spread',
        args: [],
        package: 'experimental',
        desc: 'Returns the difference between the minimum and maximum values in the `_value` column for each input table.',
        example: 'experimental.spread()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/spread/'
    },
    {
        name: 'experimental.stddev',
        args: [
            {
                name: 'mode',
                desc: 'Standard deviation mode or type of standard deviation to calculate.',
                type: 'String'
            }
        ],
        package: 'experimental',
        desc: 'Returns the standard deviation of non-null values in the `_value` column for each input table.',
        example: 'experimental.stddev()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/stddev/'
    },
    {
        name: 'experimental.sum',
        args: [],
        package: 'experimental',
        desc: 'Returns the sum of non-null values in the `_value` column for each input table.',
        example: 'experimental.sum()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/sum/'
    },
    {
        name: 'experimental.unique',
        args: [],
        package: 'experimental',
        desc: 'Returns all records containing unique values in the `_value` column.',
        example: 'experimental.unique()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/unique/'
    },
    {
        name: 'experimental.unpivot',
        args: [
            {
                name: 'otherColumns',
                desc: 'List of column names that are not in the group key but are also not field columns. Default is `["_time"]`.',
                type: 'Array'
            }
        ],
        package: 'experimental',
        desc: 'Creates `_field` and `_value` columns pairs using all columns (other than `_time`) _not_ in the group key. The `_field` column contains the original column label and the `_value` column contains the original column value.',
        example: 'experimental.unpivot()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/unpivot/'
    },
    {
        name: 'experimental.window',
        args: [
            {
                name: 'every',
                desc: 'Duration of time between windows. Default is the `0s`.',
                type: 'Duration'
            },
            {
                name: 'period',
                desc: 'Duration of the window. Default is `0s`.',
                type: 'Duration'
            },
            {
                name: 'offset',
                desc: 'Duration to shift the window boundaries by. Default is 0s.',
                type: 'Duration'
            },
            {
                name: 'location',
                desc: 'Location used to determine timezone. Default is the `location` option.',
                type: 'Object'
            },
            {
                name: 'createEmpty',
                desc: 'Create empty tables for empty windows. Default is `false`.',
                type: 'Boolean'
            }
        ],
        package: 'experimental',
        desc: 'Groups records based on time.',
        example: 'experimental.window(every: 30s)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/window/'
    },
    {
        name: 'findColumn',
        args: [
            {
                name: 'column',
                desc: 'Column to extract.',
                type: 'String'
            },
            {
                name: 'fn',
                desc: 'Predicate function to evaluate input table group keys.',
                type: 'Function'
            }
        ],
        package: '',
        desc: 'Returns an array of values in a specified column from the first table in a stream of tables that matches the specified predicate function.',
        example: 'findColumn(fn: (key) => key.tag == "t1", column: "_value")',
        category: 'Dynamic queries',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/findcolumn/'
    },
    {
        name: 'findRecord',
        args: [
            {
                name: 'idx',
                desc: 'Index of the record to extract.',
                type: 'Integer'
            },
            {
                name: 'fn',
                desc: 'Predicate function to evaluate input table group keys.',
                type: 'Function'
            }
        ],
        package: '',
        desc: 'Returns a row at a specified index as a record from the first table in a stream of tables that matches the specified predicate function.',
        example: 'findRecord( fn: (key) => key.tag == "t1", idx: 0)',
        category: 'Dynamic queries',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/findrecord/'
    },
    {
        name: 'gen.tables',
        args: [
            {
                name: 'n',
                desc: 'Number of rows to generate.',
                type: 'Integer'
            },
            {
                name: 'nulls',
                desc: 'Percentage chance that a null value will be used in the input. Valid value range is `[0.0 - 1.0]`.',
                type: 'Float'
            },
            {
                name: 'tags',
                desc: 'Set of tags with their cardinality to generate.',
                type: 'Array'
            },
            {
                name: 'seed',
                desc: 'Pass seed to tables generator to get the very same sequence each time.',
                type: 'Integer'
            }
        ],
        package: 'internal/gen',
        desc: 'Generates a stream of table data.',
        example: 'gen.tables()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/internal/gen/tables/'
    },
    {
        name: 'generate.from',
        args: [
            {
                name: 'count',
                desc: 'Number of rows to generate.',
                type: 'Integer'
            },
            {
                name: 'fn',
                desc: 'Function used to generate values.',
                type: 'Function'
            },
            {
                name: 'start',
                desc: 'Beginning of the time range to generate values in.',
                type: 'Object'
            },
            {
                name: 'stop',
                desc: 'End of the time range to generate values in.',
                type: 'Object'
            }
        ],
        package: 'generate',
        desc: 'Generates data using the provided parameter values.',
        example: 'generate.from( count: 6, fn: (n) => (n + 1) * (n + 2), start: 2021-01-01T00:00:00Z, stop: 2021-01-02T00:00:00Z)',
        category: 'Inputs',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/generate/from/'
    },
    {
        name: 'geo.ST_Contains',
        args: [
            {
                name: 'region',
                desc: 'Region to test. Specify record properties for the shape.',
                type: 'Object'
            },
            {
                name: 'geometry',
                desc: 'GIS geometry to test. Can be either point or linestring geometry.',
                type: 'Object'
            },
            {
                name: 'units',
                desc: 'Record that defines the unit of measurement for distance.',
                type: 'Object'
            }
        ],
        package: 'experimental/geo',
        desc: 'Returns boolean indicating whether the defined region contains a specified GIS geometry.',
        example: 'geo.ST_Contains()',
        category: 'Geotemporal',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/geo/st_contains/'
    },
    {
        name: 'geo.ST_DWithin',
        args: [
            {
                name: 'region',
                desc: 'Region to test. Specify record properties for the shape.',
                type: 'Object'
            },
            {
                name: 'geometry',
                desc: 'GIS geometry to test. Can be either point or linestring geometry.',
                type: 'Object'
            },
            {
                name: 'distance',
                desc: 'Maximum distance allowed between the region and geometry.',
                type: 'Object'
            },
            {
                name: 'units',
                desc: 'Record that defines the unit of measurement for distance.',
                type: 'Object'
            }
        ],
        package: 'experimental/geo',
        desc: 'Tests if the specified region is within a defined distance from the specified GIS geometry and returns `true` or `false`.',
        example: 'geo.ST_DWithin()',
        category: 'Geotemporal',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/geo/st_dwithin/'
    },
    {
        name: 'geo.ST_Distance',
        args: [
            {
                name: 'region',
                desc: 'Region to test. Specify record properties for the shape.',
                type: 'Object'
            },
            {
                name: 'geometry',
                desc: 'GIS geometry to test. Can be either point or linestring geometry.',
                type: 'Object'
            },
            {
                name: 'units',
                desc: 'Record that defines the unit of measurement for distance.',
                type: 'Object'
            }
        ],
        package: 'experimental/geo',
        desc: 'Returns the distance from a given region to a specified GIS geometry.',
        example: 'geo.ST_Distance()',
        category: 'Geotemporal',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/geo/st_distance/'
    },
    {
        name: 'geo.ST_Intersects',
        args: [
            {
                name: 'region',
                desc: 'Region to test. Specify record properties for the shape.',
                type: 'Object'
            },
            {
                name: 'geometry',
                desc: 'GIS geometry to test. Can be either point or linestring geometry.',
                type: 'Object'
            },
            {
                name: 'units',
                desc: 'Record that defines the unit of measurement for distance.',
                type: 'Object'
            }
        ],
        package: 'experimental/geo',
        desc: 'Tests if the specified GIS geometry intersects with the specified region and returns `true` or `false`.',
        example: 'geo.ST_Intersects()',
        category: 'Geotemporal',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/geo/st_intersects/'
    },
    {
        name: 'geo.ST_Length',
        args: [
            {
                name: 'geometry',
                desc: 'GIS geometry to test. Can be either point or linestring geometry.',
                type: 'Object'
            },
            {
                name: 'units',
                desc: 'Record that defines the unit of measurement for distance.',
                type: 'Object'
            }
        ],
        package: 'experimental/geo',
        desc: 'Returns the spherical length or distance (https://mathworld.wolfram.com/SphericalDistance.html) of the specified GIS geometry.',
        example: 'geo.ST_Length()',
        category: 'Geotemporal',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/geo/st_length/'
    },
    {
        name: 'geo.ST_LineString',
        args: [],
        package: 'experimental/geo',
        desc: 'Converts a series of geographic points into linestring.',
        example: 'geo.ST_LineString()',
        category: 'Geotemporal',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/geo/st_linestring/'
    },
    {
        name: 'geo.getGrid',
        args: [
            {
                name: 'region',
                desc: 'Region used to return S2 cell ID tokens.',
                type: 'Object'
            },
            {
                name: 'minSize',
                desc: 'Minimum number of cells that cover the specified region.',
                type: 'Integer'
            },
            {
                name: 'maxSize',
                desc: 'Minimum number of cells that cover the specified region.',
                type: 'Integer'
            },
            {
                name: 'level',
                desc: 'S2 cell level of grid cells.',
                type: 'Integer'
            },
            {
                name: 'maxLevel',
                desc: 'Maximumn S2 cell level of grid cells.',
                type: 'Integer'
            },
            {
                name: 'units',
                desc: 'Record that defines the unit of measurement for distance.',
                type: 'Object'
            }
        ],
        package: 'experimental/geo',
        desc: 'Calculates a grid or set of cell ID tokens for a specified region.',
        example: 'geo.getGrid()',
        category: 'Geotemporal',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/geo/getgrid/'
    },
    {
        name: 'geo.getLevel',
        args: [
            {
                name: 'token',
                desc: 'S2 cell ID token.',
                type: 'String'
            }
        ],
        package: 'experimental/geo',
        desc: 'Returns the S2 cell level of specified cell ID token.',
        example: 'geo.getLevel(token: "166b59")',
        category: 'Geotemporal',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/geo/getlevel/'
    },
    {
        name: 'geo.s2CellLatLon',
        args: [
            {
                name: 'token',
                desc: 'S2 cell ID token.',
                type: 'String'
            }
        ],
        package: 'experimental/geo',
        desc: 'Returns the latitude and longitude of the center of an S2 cell.',
        example: 'geo.s2CellLatLon(token: "89c284")',
        category: 'Geotemporal',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/geo/s2celllatlon/'
    },
    {
        name: 'geo.stContains',
        args: [
            {
                name: 'region',
                desc: 'Region to test. Specify record properties for the shape.',
                type: 'Object'
            },
            {
                name: 'geometry',
                desc: 'GIS geometry to test. Can be either point or linestring geometry.',
                type: 'Object'
            },
            {
                name: 'units',
                desc: 'Record that defines the unit of measurement for distance.',
                type: 'Object'
            }
        ],
        package: 'experimental/geo',
        desc: 'Returns boolean indicating whether the defined region contains a specified GIS geometry.',
        example: 'geo.stContains()',
        category: 'Geotemporal',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/geo/stcontains/'
    },
    {
        name: 'geo.stDistance',
        args: [
            {
                name: 'region',
                desc: 'Region to test. Specify record properties for the shape.',
                type: 'Object'
            },
            {
                name: 'geometry',
                desc: 'GIS geometry to test. Can be either point or linestring geometry.',
                type: 'Object'
            },
            {
                name: 'units',
                desc: 'Record that defines the unit of measurement for distance.',
                type: 'Object'
            }
        ],
        package: 'experimental/geo',
        desc: 'Returns the distance from a given region to a specified GIS geometry.',
        example: 'geo.stDistance()',
        category: 'Geotemporal',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/geo/stdistance/'
    },
    {
        name: 'geo.stLength',
        args: [
            {
                name: 'geometry',
                desc: 'GIS geometry to test. Can be either point or linestring geometry.',
                type: 'Object'
            },
            {
                name: 'units',
                desc: 'Record that defines the unit of measurement for distance.',
                type: 'Object'
            }
        ],
        package: 'experimental/geo',
        desc: 'Returns the spherical length or distance (https://mathworld.wolfram.com/SphericalDistance.html) of the specified GIS geometry.',
        example: 'geo.stLength()',
        category: 'Geotemporal',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/geo/stlength/'
    },
    {
        name: 'geo.totalDistance',
        args: [
            {
                name: 'outputColumn',
                desc: 'Total distance output column. Default is `_value`.',
                type: 'Object'
            }
        ],
        package: 'experimental/geo',
        desc: 'Calculates the total distance covered by subsequent points in each input table.',
        example: 'geo.totalDistance()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/geo/totaldistance/'
    },
    {
        name: 'hash.b64',
        args: [
            {
                name: 'v',
                desc: 'String to hash.',
                type: 'Object'
            }
        ],
        package: 'contrib/qxip/hash',
        desc: 'Converts a string value to a Base64 string.',
        example: 'hash.b64(v: "Hello, world!")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/qxip/hash/b64/'
    },
    {
        name: 'hash.cityhash64',
        args: [
            {
                name: 'v',
                desc: 'String to hash.',
                type: 'Object'
            }
        ],
        package: 'contrib/qxip/hash',
        desc: 'Converts a string value to a 64-bit hexadecimal hash using the CityHash64 algorithm.',
        example: 'hash.cityhash64(v: "Hello, world!")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/qxip/hash/cityhash64/'
    },
    {
        name: 'hash.hmac',
        args: [
            {
                name: 'v',
                desc: 'String to hash.',
                type: 'Object'
            },
            {
                name: 'k',
                desc: 'Key to sign hash.',
                type: 'Object'
            }
        ],
        package: 'contrib/qxip/hash',
        desc: 'Converts a string value to an MD5-signed SHA-1 hash.',
        example: 'hash.hmac(v: "helloworld", k: "123456")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/qxip/hash/hmac/'
    },
    {
        name: 'hash.md5',
        args: [
            {
                name: 'v',
                desc: 'String to hash.',
                type: 'Object'
            }
        ],
        package: 'contrib/qxip/hash',
        desc: 'Converts a string value to an MD5 hash.',
        example: 'hash.md5(v: "Hello, world!")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/qxip/hash/md5/'
    },
    {
        name: 'hash.sha1',
        args: [
            {
                name: 'v',
                desc: 'String to hash.',
                type: 'Object'
            }
        ],
        package: 'contrib/qxip/hash',
        desc: 'Converts a string value to a hexadecimal hash using the SHA-1 hash algorithm.',
        example: 'hash.sha1( v: "Hello, world!")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/qxip/hash/sha1/'
    },
    {
        name: 'hash.sha256',
        args: [
            {
                name: 'v',
                desc: 'String to hash.',
                type: 'Object'
            }
        ],
        package: 'contrib/qxip/hash',
        desc: 'Converts a string value to a hexadecimal hash using the SHA 256 hash algorithm.',
        example: 'hash.sha256( v: "Hello, world!")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/qxip/hash/sha256/'
    },
    {
        name: 'hash.xxhash64',
        args: [
            {
                name: 'v',
                desc: 'String to hash.',
                type: 'Object'
            }
        ],
        package: 'contrib/qxip/hash',
        desc: 'Converts a string value to a 64-bit hexadecimal hash using the xxHash algorithm.',
        example: 'hash.xxhash64(v: "Hello, world!")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/qxip/hash/xxhash64/'
    },
    {
        name: 'hex.bytes',
        args: [
            {
                name: 'v',
                desc: 'String to convert.',
                type: 'String'
            }
        ],
        package: 'contrib/bonitoo-io/hex',
        desc: 'Converts a hexadecimal string to bytes.',
        example: 'hex.bytes(v: "FF5733")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/bonitoo-io/hex/bytes/'
    },
    {
        name: 'hex.int',
        args: [
            {
                name: 'v',
                desc: 'String to convert.',
                type: 'String'
            }
        ],
        package: 'contrib/bonitoo-io/hex',
        desc: 'Converts a hexadecimal string to an integer.',
        example: 'hex.int(v: "4d2")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/bonitoo-io/hex/int/'
    },
    {
        name: 'hex.string',
        args: [
            {
                name: 'v',
                desc: 'Value to convert.',
                type: 'Object'
            }
        ],
        package: 'contrib/bonitoo-io/hex',
        desc: 'Converts a Flux basic type to a hexadecimal string.',
        example: 'hex.string(v: 1234)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/bonitoo-io/hex/string/'
    },
    {
        name: 'hex.uint',
        args: [
            {
                name: 'v',
                desc: 'String to convert.',
                type: 'String'
            }
        ],
        package: 'contrib/bonitoo-io/hex',
        desc: 'Converts a hexadecimal string to an unsigned integer.',
        example: 'hex.uint(v: "4d2")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/bonitoo-io/hex/uint/'
    },
    {
        name: 'http.basicAuth',
        args: [
            {
                name: 'u',
                desc: 'Username to use in the basic authentication header.',
                type: 'String'
            },
            {
                name: 'p',
                desc: 'Password to use in the basic authentication header.',
                type: 'String'
            }
        ],
        package: 'http',
        desc: 'Returns a Base64-encoded basic authentication header using a specified username and password combination.',
        example: 'http.basicAuth(u: username, p: password)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/http/basicauth/'
    },
    {
        name: 'http.endpoint',
        args: [
            {
                name: 'url',
                desc: 'URL to send the POST request to.',
                type: 'String'
            }
        ],
        package: 'http',
        desc: 'Iterates over input data and sends a single POST request per input row to a specified URL.',
        example: 'http.endpoint(url: "http://example.com/")',
        category: 'Notification endpoints',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/http/endpoint/'
    },
    {
        name: 'http.pathEscape',
        args: [
            {
                name: 'inputString',
                desc: 'String to escape.',
                type: 'String'
            }
        ],
        package: 'http',
        desc: 'Escapes special characters in a string (including `/`) and replaces non-ASCII characters with hexadecimal representations (`%XX`).',
        example: 'http.pathEscape(inputString: "Hello world!")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/http/pathescape/'
    },
    {
        name: 'influxdb.api',
        args: [
            {
                name: 'method',
                desc: 'HTTP request method.',
                type: 'String'
            },
            {
                name: 'path',
                desc: 'InfluxDB API path.',
                type: 'String'
            },
            {
                name: 'host',
                desc: 'InfluxDB host URL _(Required when executed outside of InfluxDB)_.',
                type: 'String'
            },
            {
                name: 'token',
                desc: 'InfluxDB API token (/influxdb/cloud/admin/tokens/)',
                type: 'String'
            },
            {
                name: 'headers',
                desc: 'HTTP request headers.',
                type: 'Array'
            },
            {
                name: 'query',
                desc: 'URL query parameters.',
                type: 'Array'
            },
            {
                name: 'timeout',
                desc: 'HTTP request timeout. Default is `30s`.',
                type: 'Duration'
            },
            {
                name: 'body',
                desc: 'HTTP request body as bytes.',
                type: 'Bytes'
            }
        ],
        package: 'experimental/influxdb',
        desc: 'Submits an HTTP request to the specified InfluxDB API path and returns a record containing the HTTP status code, response headers, and the response body.',
        example: 'influxdb.api(method: "get", path: "/health", host: "http://localhost:8086", token: token)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/influxdb/api/'
    },
    {
        name: 'influxdb.cardinality',
        args: [
            {
                name: 'bucket',
                desc: 'Bucket to query cardinality from.',
                type: 'String'
            },
            {
                name: 'bucketID',
                desc: 'String-encoded bucket ID to query cardinality from.',
                type: 'String'
            },
            {
                name: 'org',
                desc: 'Organization name.',
                type: 'String'
            },
            {
                name: 'orgID',
                desc: 'String-encoded organization ID.',
                type: 'String'
            },
            {
                name: 'host',
                desc: 'URL of the InfluxDB instance to query.',
                type: 'String'
            },
            {
                name: 'token',
                desc: 'InfluxDB API token.',
                type: 'String'
            },
            {
                name: 'start',
                desc: 'Earliest time to include when calculating cardinality.',
                type: 'Object'
            },
            {
                name: 'stop',
                desc: 'Latest time to include when calculating cardinality.',
                type: 'Object'
            },
            {
                name: 'predicate',
                desc: 'Predicate function that filters records.',
                type: 'Function'
            }
        ],
        package: 'influxdata/influxdb',
        desc: 'Returns the series cardinality of data retrieved from InfluxDB.',
        example: 'influxdb.cardinality(bucket: "example-bucket", start: time(v: 1))',
        category: 'Metadata',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/influxdata/influxdb/cardinality/'
    },
    {
        name: 'influxdb.select',
        args: [
            {
                name: 'from',
                desc: 'Name of the bucket to query.',
                type: 'String'
            },
            {
                name: 'start',
                desc: 'Earliest time to include in results.',
                type: 'Object'
            },
            {
                name: 'stop',
                desc: 'Latest time to include in results. Default is `now()`.',
                type: 'Object'
            },
            {
                name: 'm',
                desc: 'Name of the measurement to query.',
                type: 'Object'
            },
            {
                name: 'fields',
                desc: 'List of fields to query. Default is`[]`.',
                type: 'Array'
            },
            {
                name: 'where',
                desc: 'Single argument predicate function that evaluates `true` or `false`',
                type: 'Function'
            },
            {
                name: 'host',
                desc: 'URL of the InfluxDB instance to query.',
                type: 'String'
            },
            {
                name: 'org',
                desc: 'Organization name.',
                type: 'String'
            },
            {
                name: 'token',
                desc: 'InfluxDB API token (/influxdb/v2/security/tokens/).',
                type: 'String'
            }
        ],
        package: 'contrib/jsternberg/influxdb',
        desc: 'Is an alternate implementation of `from()`, `range()`, `filter()` and `pivot()` that returns pivoted query results and masks the `_measurement`, `_start`, and `_stop` columns. Results are similar to those returned by InfluxQL `SELECT` statements.',
        example: 'influxdb.select(from: "example-bucket", start: -1d, m: "example-measurement", fields: ["field1"])',
        category: 'Inputs',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/jsternberg/influxdb/select/'
    },
    {
        name: 'influxdb.wideTo',
        args: [
            {
                name: 'bucket',
                desc: 'Name of the bucket to write to.',
                type: 'String'
            },
            {
                name: 'bucketID',
                desc: 'String-encoded bucket ID to to write to.',
                type: 'String'
            },
            {
                name: 'host',
                desc: 'URL of the InfluxDB instance to write to.',
                type: 'String'
            },
            {
                name: 'org',
                desc: 'Organization name.',
                type: 'String'
            },
            {
                name: 'orgID',
                desc: 'String-encoded organization ID to query.',
                type: 'String'
            },
            {
                name: 'token',
                desc: 'InfluxDB API token.',
                type: 'String'
            }
        ],
        package: 'influxdata/influxdb',
        desc: 'Writes wide data to an InfluxDB 2.x or InfluxDB Cloud bucket. Wide data is _pivoted_ in that its fields are represented as columns making the table wider.',
        example: 'influxdb.wideTo()',
        category: 'Outputs',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/influxdata/influxdb/wideto/'
    },
    {
        name: 'interpolate.linear',
        args: [
            {
                name: 'every',
                desc: 'Duration of time between interpolated points.',
                type: 'Duration'
            }
        ],
        package: 'interpolate',
        desc: 'Inserts rows at regular intervals using linear interpolation to determine values for inserted rows.',
        example: 'interpolate.linear(every: 1d)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/interpolate/linear/'
    },
    {
        name: 'iox.from',
        args: [
            {
                name: 'bucket',
                desc: 'IOx bucket to read data from.',
                type: 'String'
            },
            {
                name: 'measurement',
                desc: 'Measurement to read data from.',
                type: 'String'
            }
        ],
        package: 'experimental/iox',
        desc: 'Reads from the selected bucket and measurement in an IOx storage node.',
        example: 'iox.from(bucket: "example-bucket", measurement: "example-measurement")',
        category: 'Inputs',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/iox/from/'
    },
    {
        name: 'iox.sql',
        args: [
            {
                name: 'bucket',
                desc: 'IOx bucket to read data from.',
                type: 'String'
            },
            {
                name: 'query',
                desc: 'SQL query to execute.',
                type: 'String'
            }
        ],
        package: 'experimental/iox',
        desc: 'Executes an SQL query against a bucket in an IOx storage node.',
        example: 'iox.sql(bucket: "example-bucket", query: "SELECT * FROM measurement")',
        category: 'Inputs',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/iox/sql/'
    },
    {
        name: 'iox.sqlInterval',
        args: [
            {
                name: 'd',
                desc: 'Duration value to convert to SQL interval string.',
                type: 'Object'
            }
        ],
        package: 'experimental/iox',
        desc: 'Converts a duration value to a SQL interval string.',
        example: 'iox.sqlInterval( d: 1y2mo3w4d5h6m7s8ms)',
        category: 'Type Conversions',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/iox/sqlinterval/'
    },
    {
        name: 'join.full',
        args: [
            {
                name: 'left',
                desc: 'Left input stream. Default is piped-forward data (<-).',
                type: 'Stream of tables'
            },
            {
                name: 'right',
                desc: 'Right input stream.',
                type: 'Stream of tables'
            },
            {
                name: 'on',
                desc: 'Function that takes a left and right record (`l`, and `r` respectively), and returns a boolean.',
                type: 'Function'
            },
            {
                name: 'as',
                desc: 'Function that takes a left and a right record (`l` and `r` respectively), and returns a record.',
                type: 'Function'
            }
        ],
        package: 'join',
        desc: 'Performs a full outer join on two table streams.',
        example: 'join.full( left: left, right: right, on: (l, r) => l.label == r.id and l._time == r._time, as: (l, r) => { time = if exists l._time then l._time else r._time label = if exists l.label then l.label else r.id return {_time: time, label: label, v_left: l._value, v_right: r._value} })',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/join/full/'
    },
    {
        name: 'join.inner',
        args: [
            {
                name: 'left',
                desc: 'Left input stream. Default is piped-forward data (<-).',
                type: 'Stream of tables'
            },
            {
                name: 'right',
                desc: 'Right input stream.',
                type: 'Stream of tables'
            },
            {
                name: 'on',
                desc: 'Function that takes a left and right record (`l`, and `r` respectively), and returns a boolean.',
                type: 'Function'
            },
            {
                name: 'as',
                desc: 'Function that takes a left and a right record (`l` and `r` respectively), and returns a record.',
                type: 'Function'
            }
        ],
        package: 'join',
        desc: 'Performs an inner join on two table streams.',
        example: 'join.inner( left: ints, right: strings, on: (l, r) => l._time == r._time, as: (l, r) => ({l with label: r._value}))',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/join/inner/'
    },
    {
        name: 'join.left',
        args: [
            {
                name: 'left',
                desc: 'Left input stream. Default is piped-forward data (<-).',
                type: 'Stream of tables'
            },
            {
                name: 'right',
                desc: 'Right input stream.',
                type: 'Stream of tables'
            },
            {
                name: 'on',
                desc: 'Function that takes a left and right record (`l`, and `r` respectively), and returns a boolean.',
                type: 'Function'
            },
            {
                name: 'as',
                desc: 'Function that takes a left and a right record (`l` and `r` respectively), and returns a record.',
                type: 'Function'
            }
        ],
        package: 'join',
        desc: 'Performs a left outer join on two table streams.',
        example: 'join.left( left: left, right: right, on: (l, r) => l.label == r.id and l._time == r._time, as: (l, r) => ({_time: l._time, label: l.label, v_left: l._value, v_right: r._value}))',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/join/left/'
    },
    {
        name: 'join.right',
        args: [
            {
                name: 'left',
                desc: 'Left input stream. Default is piped-forward data (<-).',
                type: 'Stream of tables'
            },
            {
                name: 'right',
                desc: 'Right input stream.',
                type: 'Stream of tables'
            },
            {
                name: 'on',
                desc: 'Function that takes a left and right record (`l`, and `r` respectively), and returns a boolean.',
                type: 'Function'
            },
            {
                name: 'as',
                desc: 'Function that takes a left and a right record (`l` and `r` respectively), and returns a record.',
                type: 'Function'
            }
        ],
        package: 'join',
        desc: 'Performs a right outer join on two table streams.',
        example: 'join.right( left: left, right: right, on: (l, r) => l.label == r.id and l._time == r._time, as: (l, r) => ({_time: r._time, label: r.id, v_left: l._value, v_right: r._value}))',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/join/right/'
    },
    {
        name: 'join.tables',
        args: [
            {
                name: 'left',
                desc: 'Left input stream. Default is piped-forward data (`<-`).',
                type: 'Stream of tables'
            },
            {
                name: 'right',
                desc: 'Right input stream.',
                type: 'Stream of tables'
            },
            {
                name: 'on',
                desc: 'Function that takes a left and right record (`l`, and `r` respectively), and returns a boolean.',
                type: 'Function'
            },
            {
                name: 'as',
                desc: 'Function that takes a left and a right record (`l` and `r` respectively), and returns a record.',
                type: 'Function'
            },
            {
                name: 'method',
                desc: 'String that specifies the join method.',
                type: 'String'
            }
        ],
        package: 'join',
        desc: 'Joins two input streams together using a specified method, predicate, and a function to join two corresponding records, one from each input stream.',
        example: 'join.tables( method: "inner", left: ints, right: strings, on: (l, r) => l._time == r._time, as: (l, r) => ({l with label: r._value}))',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/join/tables/'
    },
    {
        name: 'join.time',
        args: [
            {
                name: 'left',
                desc: 'Left input stream. Default is piped-forward data (<-).',
                type: 'Stream of tables'
            },
            {
                name: 'right',
                desc: 'Right input stream.',
                type: 'Stream of tables'
            },
            {
                name: 'as',
                desc: 'Function that takes a left and a right record (`l` and `r` respectively), and returns a record.',
                type: 'Function'
            },
            {
                name: 'method',
                desc: 'String that specifies the join method. Default is `inner`.',
                type: 'String'
            }
        ],
        package: 'join',
        desc: 'Joins two table streams together exclusively on the `_time` column.',
        example: 'join.time(left: ints, right: strings, as: (l, r) => ({l with label: r._value}))',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/join/time/'
    },
    {
        name: 'json.parse',
        args: [
            {
                name: 'data',
                desc: 'JSON data (as bytes) to parse.',
                type: 'Bytes'
            }
        ],
        package: 'experimental/json',
        desc: 'Takes JSON data as bytes and returns a value.',
        example: 'json.parse(data: bytes(v: r._value))',
        category: 'Type Conversions',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/json/parse/'
    },
    {
        name: 'kafka.to',
        args: [
            {
                name: 'brokers',
                desc: 'List of Kafka brokers to send data to.',
                type: 'Array'
            },
            {
                name: 'topic',
                desc: 'Kafka topic to send data to.',
                type: 'String'
            },
            {
                name: 'balancer',
                desc: 'Kafka load balancing strategy. Default is `hash`.',
                type: 'String'
            },
            {
                name: 'name',
                desc: 'Kafka metric name. Default is the value of the `nameColumn`.',
                type: 'String'
            },
            {
                name: 'nameColumn',
                desc: 'Column to use as the Kafka metric name.',
                type: 'String'
            },
            {
                name: 'timeColumn',
                desc: 'Time column. Default is `_time`.',
                type: 'String'
            },
            {
                name: 'tagColumns',
                desc: 'List of tag columns in input data.',
                type: 'Array'
            },
            {
                name: 'valueColumns',
                desc: 'List of value columns in input data. Default is `["_value"]`.',
                type: 'Array'
            }
        ],
        package: 'kafka',
        desc: 'Sends data to Apache Kafka (https://kafka.apache.org/) brokers.',
        example: 'kafka.to( brokers: ["http://127.0.0.1:9092"], topic: "example-topic", name: "example-metric-name", tagColumns: ["tag"])',
        category: 'Outputs',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/kafka/to/'
    },
    {
        name: 'logql.query_range',
        args: [
            {
                name: 'url',
                desc: 'LogQL/qryn URL and port. Default is `http://qryn:3100`.',
                type: 'String'
            },
            {
                name: 'path',
                desc: 'LogQL query_range API path.',
                type: 'String'
            },
            {
                name: 'limit',
                desc: 'Query limit. Default is 100.',
                type: 'Object'
            },
            {
                name: 'query',
                desc: 'LogQL query to execute.',
                type: 'String'
            },
            {
                name: 'start',
                desc: 'Earliest time to include in results. Default is `-1h`.',
                type: 'Object'
            },
            {
                name: 'end',
                desc: 'Latest time to include in results. Default is `now()`.',
                type: 'Object'
            },
            {
                name: 'step',
                desc: 'Query resolution step width in seconds. Default is 10.',
                type: 'Object'
            },
            {
                name: 'orgid',
                desc: 'Optional Loki organization ID for partitioning. Default is `""`.',
                type: 'String'
            }
        ],
        package: 'contrib/qxip/logql',
        desc: 'Queries data from a specified LogQL query within given time bounds, filters data by query, timerange, and optional limit expressions. All values are returned as string values (using `raw` mode in `csv.from`)',
        example: 'logql.query_range(query: "{job=\\"dummy-server\\"}", start: -1h, end: now(), limit: 100)',
        category: 'Inputs',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/qxip/logql/query_range/'
    },
    {
        name: 'math.float64frombits',
        args: [
            {
                name: 'b',
                desc: 'Value to operate on.',
                type: 'UInteger'
            }
        ],
        package: 'math',
        desc: 'Returns the floating-point number corresponding to the IEE 754 binary representation `b`, with the sign bit of `b` and the result in the same bit position.',
        example: 'math.float64frombits(b: uint(v: 4))',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/float64frombits/'
    },
    {
        name: 'math.log10',
        args: [
            {
                name: 'x',
                desc: 'Value to operate on.',
                type: 'Float'
            }
        ],
        package: 'math',
        desc: 'Returns the decimal logarithm of x.',
        example: 'math.log10(x: 3.14)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/math/log10/'
    },
    {
        name: 'monitor.check',
        args: [
            {
                name: 'crit',
                desc: 'Predicate function that determines `crit` status. Default is `(r) => false`.',
                type: 'Function'
            },
            {
                name: 'warn',
                desc: 'Predicate function that determines `warn` status. Default is `(r) => false`.',
                type: 'Function'
            },
            {
                name: 'info',
                desc: 'Predicate function that determines `info` status. Default is `(r) => false`.',
                type: 'Function'
            },
            {
                name: 'ok',
                desc: 'Predicate function that determines `ok` status. `Default is (r) => true`.',
                type: 'Function'
            },
            {
                name: 'messageFn',
                desc: 'Predicate function that constructs a message to append to each row.',
                type: 'Function'
            },
            {
                name: 'data',
                desc: 'Check data to append to output used to identify this check.',
                type: 'Object'
            }
        ],
        package: 'influxdata/influxdb/monitor',
        desc: 'Checks input data and assigns a level (`ok`, `info`, `warn`, or `crit`) to each row based on predicate functions.',
        example: 'monitor.check( crit: (r) => r._value > 90.0, warn: (r) => r._value > 80.0, info: (r) => r._value > 70.0, ok: (r) => r._value <= 60.0, messageFn: (r) => if r._level == "crit" then "Critical alert!! Disk usage is at ${r._value}%!" else if r._level == "warn" then "Warning! Disk usage is at ${r._value}%." else if r._level == "info" then "Disk usage is at ${r._value}%." else "Things are looking good.", data: { _check_name: "Disk Utilization (Used Percentage)", _check_id: "disk_used_percent", _type: "threshold", tags: {}, })',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/influxdata/influxdb/monitor/check/'
    },
    {
        name: 'monitor.deadman',
        args: [
            {
                name: 't',
                desc: 'Time threshold for the deadman check.',
                type: 'Object'
            }
        ],
        package: 'influxdata/influxdb/monitor',
        desc: 'Detects when a group stops reporting data. It takes a stream of tables and reports if groups have been observed since time `t`.',
        example: 'monitor.deadman(t: 2021-01-01T00:05:00Z)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/influxdata/influxdb/monitor/deadman/'
    },
    {
        name: 'monitor.from',
        args: [
            {
                name: 'start',
                desc: 'Earliest time to include in results.',
                type: 'Object'
            },
            {
                name: 'stop',
                desc: 'Latest time to include in results. Default is `now()`.',
                type: 'Object'
            },
            {
                name: 'fn',
                desc: 'Predicate function that evaluates true or false.',
                type: 'Function'
            }
        ],
        package: 'influxdata/influxdb/monitor',
        desc: 'Retrieves check statuses stored in the `statuses` measurement in the `_monitoring` bucket.',
        example: 'monitor.from(start: -1h, fn: (r) => r._level == "crit")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/influxdata/influxdb/monitor/from/'
    },
    {
        name: 'monitor.log',
        args: [],
        package: 'influxdata/influxdb/monitor',
        desc: 'Persists notification events to an InfluxDB bucket.',
        example: 'monitor.log()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/influxdata/influxdb/monitor/log/'
    },
    {
        name: 'monitor.logs',
        args: [
            {
                name: 'start',
                desc: 'Earliest time to include in results.',
                type: 'Object'
            },
            {
                name: 'stop',
                desc: 'Latest time to include in results. Default is `now()`.',
                type: 'Object'
            },
            {
                name: 'fn',
                desc: 'Predicate function that evaluates true or false.',
                type: 'Function'
            }
        ],
        package: 'influxdata/influxdb/monitor',
        desc: 'Retrieves notification events stored in the `notifications` measurement in the `_monitoring` bucket.',
        example: 'monitor.logs(start: -2h, fn: (r) => true)',
        category: 'Inputs',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/influxdata/influxdb/monitor/logs/'
    },
    {
        name: 'monitor.notify',
        args: [
            {
                name: 'endpoint',
                desc: 'A function that constructs and sends the notification to an endpoint.',
                type: 'Function'
            },
            {
                name: 'data',
                desc: 'Notification data to append to the output.',
                type: 'Object'
            }
        ],
        package: 'influxdata/influxdb/monitor',
        desc: 'Sends a notification to an endpoint and logs it in the `notifications` measurement in the `_monitoring` bucket.',
        example: 'monitor.notify(endpoint: endpoint, data: notification_data)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/influxdata/influxdb/monitor/notify/'
    },
    {
        name: 'monitor.stateChanges',
        args: [
            {
                name: 'fromLevel',
                desc: 'Level to detect a change from. Default is `"any"`.',
                type: 'Object'
            },
            {
                name: 'toLevel',
                desc: 'Level to detect a change to. Default is `"any"`.',
                type: 'Object'
            }
        ],
        package: 'influxdata/influxdb/monitor',
        desc: 'Detects state changes in a stream of data with a `_level` column and outputs records that change from `fromLevel` to `toLevel`.',
        example: 'monitor.stateChanges(toLevel: "crit")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/influxdata/influxdb/monitor/statechanges/'
    },
    {
        name: 'monitor.stateChangesOnly',
        args: [],
        package: 'influxdata/influxdb/monitor',
        desc: 'Takes a stream of tables that contains a _level column and returns a stream of tables grouped by `_level` where each record represents a state change.',
        example: 'monitor.stateChangesOnly()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/influxdata/influxdb/monitor/statechangesonly/'
    },
    {
        name: 'monitor.write',
        args: [],
        package: 'influxdata/influxdb/monitor',
        desc: 'Persists check statuses to an InfluxDB bucket.',
        example: 'monitor.write()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/influxdata/influxdb/monitor/write/'
    },
    {
        name: 'mqtt.publish',
        args: [
            {
                name: 'broker',
                desc: 'MQTT broker connection string.',
                type: 'String'
            },
            {
                name: 'topic',
                desc: 'MQTT topic to send data to.',
                type: 'String'
            },
            {
                name: 'message',
                desc: 'Message to send to the MQTT broker.',
                type: 'String'
            },
            {
                name: 'qos',
                desc: 'MQTT Quality of Service (QoS) level. Values range from `[0-2]`.',
                type: 'Integer'
            },
            {
                name: 'retain',
                desc: 'MQTT retain flag. Default is `false`.',
                type: 'Boolean'
            },
            {
                name: 'clientid',
                desc: 'MQTT client ID.',
                type: 'String'
            },
            {
                name: 'username',
                desc: 'Username to send to the MQTT broker.',
                type: 'String'
            },
            {
                name: 'password',
                desc: 'Password to send to the MQTT broker.',
                type: 'String'
            },
            {
                name: 'timeout',
                desc: 'MQTT connection timeout. Default is `1s`.',
                type: 'Duration'
            }
        ],
        package: 'experimental/mqtt',
        desc: 'Sends data to an MQTT broker using MQTT protocol.',
        example: 'mqtt.publish( broker: "tcp://localhost:8883", topic: "alerts", message: "wake up", clientid: "alert-watcher", retain: true)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/mqtt/publish/'
    },
    {
        name: 'naiveBayesClassifier.naiveBayes',
        args: [
            {
                name: 'myMeasurement',
                desc: 'Measurement to use as training data.',
                type: 'Object'
            },
            {
                name: 'myField',
                desc: 'Field to use as training data.',
                type: 'Object'
            },
            {
                name: 'myClass',
                desc: 'Class to classify against.',
                type: 'String'
            }
        ],
        package: 'contrib/RohanSreerama5/naiveBayesClassifier',
        desc: 'Performs a naive Bayes classification.',
        example: 'naiveBayesClassifier.naiveBayes()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/RohanSreerama5/naiveBayesClassifier/naivebayes/'
    },
    {
        name: 'now',
        args: [],
        package: '',
        desc: 'Is a function option that, by default, returns the current system time.',
        example: 'now()',
        category: 'Date/time',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/now/'
    },
    {
        name: 'oee.APQ',
        args: [
            {
                name: 'runningState',
                desc: 'State value that represents a running state.',
                type: 'Object'
            },
            {
                name: 'plannedTime',
                desc: 'Total time that equipment is expected to produce parts.',
                type: 'Object'
            },
            {
                name: 'idealCycleTime',
                desc: 'Ideal minimum time to produce one part.',
                type: 'Object'
            }
        ],
        package: 'experimental/oee',
        desc: 'Computes availability, performance, quality (APQ) and overall equipment effectiveness (OEE) in producing parts.',
        example: 'oee.APQ()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/oee/apq/'
    },
    {
        name: 'oee.computeAPQ',
        args: [
            {
                name: 'productionEvents',
                desc: 'Production events stream that contains the production',
                type: 'Stream of tables'
            },
            {
                name: 'partEvents',
                desc: 'Part events that contains the running totals of parts produced and',
                type: 'Stream of tables'
            },
            {
                name: 'runningState',
                desc: 'State value that represents a running state.',
                type: 'Object'
            },
            {
                name: 'plannedTime',
                desc: 'Total time that equipment is expected to produce parts.',
                type: 'Object'
            },
            {
                name: 'idealCycleTime',
                desc: 'Ideal minimum time to produce one part.',
                type: 'Object'
            }
        ],
        package: 'experimental/oee',
        desc: 'Computes availability, performance, and quality (APQ) and overall equipment effectiveness (OEE) using two separate input streams: **production events** and **part events**.',
        example: 'oee.computeAPQ()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/oee/computeapq/'
    },
    {
        name: 'opsgenie.endpoint',
        args: [
            {
                name: 'url',
                desc: 'Opsgenie API URL. Defaults to `https://api.opsgenie.com/v2/alerts`.',
                type: 'String'
            },
            {
                name: 'apiKey',
                desc: '(Required) Opsgenie API authorization key.',
                type: 'String'
            },
            {
                name: 'entity',
                desc: 'Alert entity used to specify the alert domain.',
                type: 'String'
            }
        ],
        package: 'contrib/sranka/opsgenie',
        desc: 'Sends an alert message to Opsgenie using data from table rows.',
        example: 'opsgenie.endpoint(apiKey: apiKey)',
        category: 'Notification endpoints',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/sranka/opsgenie/endpoint/'
    },
    {
        name: 'opsgenie.respondersToJSON',
        args: [
            {
                name: 'v',
                desc: '(Required) Array of Opsgenie responder strings.',
                type: 'Array'
            }
        ],
        package: 'contrib/sranka/opsgenie',
        desc: 'Converts an array of Opsgenie responder strings to a string-encoded JSON array that can be embedded in an alert message.',
        example: 'opsgenie.respondersToJSON()',
        category: 'Notification endpoints',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/sranka/opsgenie/responderstojson/'
    },
    {
        name: 'opsgenie.sendAlert',
        args: [
            {
                name: 'url',
                desc: 'Opsgenie API URL. Defaults to `https://api.opsgenie.com/v2/alerts`.',
                type: 'String'
            },
            {
                name: 'apiKey',
                desc: '(Required) Opsgenie API authorization key.',
                type: 'String'
            },
            {
                name: 'message',
                desc: '(Required) Alert message text.',
                type: 'String'
            },
            {
                name: 'alias',
                desc: 'Opsgenie alias usee to de-deduplicate alerts.',
                type: 'String'
            },
            {
                name: 'description',
                desc: 'Alert description. 15000 characters or less.',
                type: 'String'
            },
            {
                name: 'priority',
                desc: 'Opsgenie alert priority.',
                type: 'String'
            },
            {
                name: 'responders',
                desc: 'List of responder teams or users.',
                type: 'Array'
            },
            {
                name: 'tags',
                desc: 'Alert tags.',
                type: 'Object'
            },
            {
                name: 'entity',
                desc: 'Alert entity used to specify the alert domain.',
                type: 'String'
            },
            {
                name: 'actions',
                desc: 'List of actions available for the alert.',
                type: 'Object'
            },
            {
                name: 'details',
                desc: 'Additional alert details. Must be a JSON-encoded map of key-value string pairs.',
                type: 'Object'
            },
            {
                name: 'visibleTo',
                desc: 'List of teams and users the alert will be visible to without sending notifications.',
                type: 'Array'
            }
        ],
        package: 'contrib/sranka/opsgenie',
        desc: 'Sends an alert message to Opsgenie.',
        example: 'opsgenie.sendAlert( apiKey: apiKey, message: "Disk usage is: ${lastReported.status}.", alias: "example-disk-usage", responders: ["user:john@example.com", "team:itcrowd"])',
        category: 'Notification endpoints',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/sranka/opsgenie/sendalert/'
    },
    {
        name: 'pagerduty.actionFromLevel',
        args: [
            {
                name: 'level',
                desc: 'Monitoring level to convert to a PagerDuty action.',
                type: 'String'
            }
        ],
        package: 'pagerduty',
        desc: 'Converts a monitoring level to a PagerDuty action.',
        example: 'pagerduty.actionFromLevel(level: "crit")',
        category: 'Notification endpoints',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/pagerduty/actionfromlevel/'
    },
    {
        name: 'pagerduty.actionFromSeverity',
        args: [
            {
                name: 'severity',
                desc: 'Severity to convert to a PagerDuty action.',
                type: 'String'
            }
        ],
        package: 'pagerduty',
        desc: 'Converts a severity to a PagerDuty action.',
        example: 'pagerduty.actionFromSeverity(severity: "crit")',
        category: 'Notification endpoints',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/pagerduty/actionfromseverity/'
    },
    {
        name: 'pagerduty.dedupKey',
        args: [
            {
                name: 'exclude',
                desc: 'Group key columns to exclude when generating the deduplication key.',
                type: 'Array'
            }
        ],
        package: 'pagerduty',
        desc: 'Uses the group key of an input table to generate and store a deduplication key in the `_pagerdutyDedupKey`column. The function sorts, newline-concatenates, SHA256-hashes, and hex-encodes the group key to create a unique deduplication key for each input table.',
        example: 'pagerduty.dedupKey()',
        category: 'Notification endpoints',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/pagerduty/dedupkey/'
    },
    {
        name: 'pagerduty.endpoint',
        args: [
            {
                name: 'url',
                desc: 'PagerDuty v2 Events API URL.',
                type: 'String'
            }
        ],
        package: 'pagerduty',
        desc: 'Returns a function that sends a message to PagerDuty that includes output data.',
        example: 'pagerduty.endpoint()',
        category: 'Notification endpoints',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/pagerduty/endpoint/'
    },
    {
        name: 'pagerduty.sendEvent',
        args: [
            {
                name: 'pagerdutyURL',
                desc: 'PagerDuty endpoint URL.',
                type: 'String'
            },
            {
                name: 'routingKey',
                desc: 'Routing key generated from your PagerDuty integration.',
                type: 'Object'
            },
            {
                name: 'client',
                desc: 'Name of the client sending the alert.',
                type: 'Object'
            },
            {
                name: 'clientURL',
                desc: 'URL of the client sending the alert.',
                type: 'Object'
            },
            {
                name: 'dedupKey',
                desc: 'Per-alert ID that acts as deduplication key and allows you to',
                type: 'Object'
            },
            {
                name: 'class',
                desc: 'Class or type of the event.',
                type: 'Object'
            },
            {
                name: 'group',
                desc: 'Logical grouping used by PagerDuty.',
                type: 'Object'
            },
            {
                name: 'severity',
                desc: 'Severity of the event.',
                type: 'Object'
            },
            {
                name: 'eventAction',
                desc: 'Event type to send to PagerDuty.',
                type: 'Object'
            },
            {
                name: 'source',
                desc: 'Unique location of the affected system.',
                type: 'Object'
            },
            {
                name: 'component',
                desc: 'Component responsible for the event.',
                type: 'Object'
            },
            {
                name: 'summary',
                desc: 'Brief text summary of the event used as the summaries or titles of associated alerts.',
                type: 'String'
            },
            {
                name: 'timestamp',
                desc: 'Time the detected event occurred in RFC3339nano format.',
                type: 'Object'
            },
            {
                name: 'customDetails',
                desc: 'Record with additional details about the event.',
                type: 'Object'
            }
        ],
        package: 'pagerduty',
        desc: 'Sends an event to PagerDuty and returns the HTTP response code of the request.',
        example: 'pagerduty.sendEvent( routingKey: "example-routing-key", client: "example-client", clientURL: "http://example-url.com", dedupKey: "example-dedup-key", class: "example-class", eventAction: "trigger", group: "example-group", severity: "crit", component: "example-component", source: "example-source", summary: "example-summary", timestamp: now(), customDetails: {"example-key": "example value"})',
        category: 'Notification endpoints',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/pagerduty/sendevent/'
    },
    {
        name: 'pagerduty.severityFromLevel',
        args: [
            {
                name: 'level',
                desc: 'InfluxDB status level to convert to a PagerDuty severity.',
                type: 'String'
            }
        ],
        package: 'pagerduty',
        desc: 'Converts an InfluxDB status level to a PagerDuty severity.',
        example: 'pagerduty.severityFromLevel(level: "crit")',
        category: 'Notification endpoints',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/pagerduty/severityfromlevel/'
    },
    {
        name: 'polyline.rdp',
        args: [
            {
                name: 'valColumn',
                desc: 'Column with Y axis values of the given curve. Default is `_value`.',
                type: 'String'
            },
            {
                name: 'timeColumn',
                desc: 'Column with X axis values of the given curve. Default is `_time`.',
                type: 'String'
            },
            {
                name: 'epsilon',
                desc: 'Maximum tolerance value that determines the amount of compression.',
                type: 'Float'
            },
            {
                name: 'retention',
                desc: 'Percentage of points to retain after downsampling.',
                type: 'Float'
            }
        ],
        package: 'experimental/polyline',
        desc: 'Applies the Ramer Douglas Peucker (RDP) algorithm to input data to downsample curves composed of line segments into visually indistinguishable curves with fewer points.',
        example: 'polyline.rdp()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/polyline/rdp/'
    },
    {
        name: 'promql.changes',
        args: [],
        package: 'internal/promql',
        desc: "Implements functionality equivalent to PromQL's `changes()` function (https://prometheus.io/docs/prometheus/latest/querying/functions/#changes).",
        example: 'promql.changes()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/internal/promql/changes/'
    },
    {
        name: 'promql.emptyTable',
        args: [],
        package: 'internal/promql',
        desc: "Returns an empty table, which is used as a helper function to implement PromQL's `time()` (https://prometheus.io/docs/prometheus/latest/querying/functions/#time) and `vector()` (https://prometheus.io/docs/prometheus/latest/querying/functions/#vector) functions.",
        example: 'promql.emptyTable()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/internal/promql/emptytable/'
    },
    {
        name: 'promql.extrapolatedRate',
        args: [
            {
                name: 'isCounter',
                desc: 'Data represents a counter.',
                type: 'Boolean'
            },
            {
                name: 'isRate',
                desc: 'Data represents a rate.',
                type: 'Boolean'
            }
        ],
        package: 'internal/promql',
        desc: "Is a helper function that calculates extrapolated rates over counters and is used to implement PromQL's `rate()` (https://prometheus.io/docs/prometheus/latest/querying/functions/#rate), `delta()` (https://prometheus.io/docs/prometheus/latest/querying/functions/#increase), and `increase()` (https://prometheus.io/docs/prometheus/latest/querying/functions/#delta) functions.",
        example: 'promql.extrapolatedRate()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/internal/promql/extrapolatedrate/'
    },
    {
        name: 'promql.holtWinters',
        args: [
            {
                name: 'smoothingFactor',
                desc: 'Exponential smoothing factor.',
                type: 'Float'
            },
            {
                name: 'trendFactor',
                desc: 'Trend factor.',
                type: 'Float'
            }
        ],
        package: 'internal/promql',
        desc: "Implements functionality equivalent to PromQL's `holt_winters()` function (https://prometheus.io/docs/prometheus/latest/querying/functions/#holt_winters).",
        example: 'promql.holtWinters()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/internal/promql/holtwinters/'
    },
    {
        name: 'promql.instantRate',
        args: [
            {
                name: 'isRate',
                desc: 'Data represents a rate.',
                type: 'Boolean'
            }
        ],
        package: 'internal/promql',
        desc: "Is a helper function that calculates instant rates over counters and is used to implement PromQL's `irate()` (https://prometheus.io/docs/prometheus/latest/querying/functions/#irate) and `idelta()` (https://prometheus.io/docs/prometheus/latest/querying/functions/#idelta) functions.",
        example: 'promql.instantRate()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/internal/promql/instantrate/'
    },
    {
        name: 'promql.join',
        args: [
            {
                name: 'left',
                desc: 'First of two streams of tables to join.',
                type: 'Stream of tables'
            },
            {
                name: 'right',
                desc: 'Second of two streams of tables to join.',
                type: 'Stream of tables'
            },
            {
                name: 'fn',
                desc: 'Function with left and right arguments that maps a new output record',
                type: 'Function'
            }
        ],
        package: 'internal/promql',
        desc: 'Joins two streams of tables on the **group key and `_time` column**. See `experimental.join` (/flux/v0/stdlib/experimental/join/).',
        example: 'promql.join()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/internal/promql/join/'
    },
    {
        name: 'promql.labelReplace',
        args: [
            {
                name: 'source',
                desc: 'Input label.',
                type: 'String'
            },
            {
                name: 'destination',
                desc: 'Output label.',
                type: 'String'
            },
            {
                name: 'regex',
                desc: 'Pattern as a regex string.',
                type: 'String'
            },
            {
                name: 'replacement',
                desc: 'Replacement value.',
                type: 'String'
            }
        ],
        package: 'internal/promql',
        desc: "Implements functionality equivalent to PromQL's `label_replace()` function (https://prometheus.io/docs/prometheus/latest/querying/functions/#label_replace).",
        example: 'promql.labelReplace()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/internal/promql/labelreplace/'
    },
    {
        name: 'promql.linearRegression',
        args: [
            {
                name: 'predict',
                desc: 'Output should contain a prediction.',
                type: 'Boolean'
            },
            {
                name: 'fromNow',
                desc: 'Time as a floating point value.',
                type: 'Float'
            }
        ],
        package: 'internal/promql',
        desc: "Implements linear regression functionality required to implement PromQL's `deriv()` (https://prometheus.io/docs/prometheus/latest/querying/functions/#deriv) and `predict_linear()` (https://prometheus.io/docs/prometheus/latest/querying/functions/#predict_linear) functions.",
        example: 'promql.linearRegression()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/internal/promql/linearregression/'
    },
    {
        name: 'promql.promHistogramQuantile',
        args: [
            {
                name: 'quantile',
                desc: 'Quantile to compute (`[0.0 - 1.0]`).',
                type: 'Float'
            },
            {
                name: 'countColumn',
                desc: 'Count column name.',
                type: 'String'
            },
            {
                name: 'upperBoundColumn',
                desc: 'Upper bound column name.',
                type: 'String'
            },
            {
                name: 'valueColumn',
                desc: 'Output value column name.',
                type: 'String'
            }
        ],
        package: 'internal/promql',
        desc: "Implements functionality equivalent to PromQL's `histogram_quantile()` function (https://prometheus.io/docs/prometheus/latest/querying/functions/#histogram_quantile).",
        example: 'promql.promHistogramQuantile()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/internal/promql/promhistogramquantile/'
    },
    {
        name: 'promql.promqlDayOfMonth',
        args: [
            {
                name: 'timestamp',
                desc: 'Time as a floating point value.',
                type: 'Float'
            }
        ],
        package: 'internal/promql',
        desc: "Implements functionality equivalent to PromQL's `day_of_month()` function (https://prometheus.io/docs/prometheus/latest/querying/functions/#day_of_month).",
        example: 'promql.promqlDayOfMonth()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/internal/promql/promqldayofmonth/'
    },
    {
        name: 'promql.promqlDayOfWeek',
        args: [
            {
                name: 'timestamp',
                desc: 'Time as a floating point value.',
                type: 'Float'
            }
        ],
        package: 'internal/promql',
        desc: "Implements functionality equivalent to PromQL's `day_of_week()` function (https://prometheus.io/docs/prometheus/latest/querying/functions/#day_of_week).",
        example: 'promql.promqlDayOfWeek()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/internal/promql/promqldayofweek/'
    },
    {
        name: 'promql.promqlDaysInMonth',
        args: [
            {
                name: 'timestamp',
                desc: 'Time as a floating point value.',
                type: 'Float'
            }
        ],
        package: 'internal/promql',
        desc: "Implements functionality equivalent to PromQL's `days_in_month()` function (https://prometheus.io/docs/prometheus/latest/querying/functions/#days_in_month).",
        example: 'promql.promqlDaysInMonth()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/internal/promql/promqldaysinmonth/'
    },
    {
        name: 'promql.promqlHour',
        args: [
            {
                name: 'timestamp',
                desc: 'Time as a floating point value.',
                type: 'Float'
            }
        ],
        package: 'internal/promql',
        desc: "Implements functionality equivalent to PromQL's `hour()` function (https://prometheus.io/docs/prometheus/latest/querying/functions/#hour).",
        example: 'promql.promqlHour()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/internal/promql/promqlhour/'
    },
    {
        name: 'promql.promqlMinute',
        args: [
            {
                name: 'timestamp',
                desc: 'Time as a floating point value.',
                type: 'Float'
            }
        ],
        package: 'internal/promql',
        desc: "Implements functionality equivalent to PromQL's `minute()` function ( https://prometheus.io/docs/prometheus/latest/querying/functions/#minute).",
        example: 'promql.promqlMinute()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/internal/promql/promqlminute/'
    },
    {
        name: 'promql.promqlMonth',
        args: [
            {
                name: 'timestamp',
                desc: 'Time as a floating point value.',
                type: 'Float'
            }
        ],
        package: 'internal/promql',
        desc: "Implements functionality equivalent to PromQL's `month()` function (https://prometheus.io/docs/prometheus/latest/querying/functions/#month).",
        example: 'promql.promqlMonth()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/internal/promql/promqlmonth/'
    },
    {
        name: 'promql.promqlYear',
        args: [
            {
                name: 'timestamp',
                desc: 'Time as a floating point value.',
                type: 'Float'
            }
        ],
        package: 'internal/promql',
        desc: "Implements functionality equivalent to PromQL's `year()` function (https://prometheus.io/docs/prometheus/latest/querying/functions/#year).",
        example: 'promql.promqlYear()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/internal/promql/promqlyear/'
    },
    {
        name: 'promql.quantile',
        args: [
            {
                name: 'q',
                desc: 'Quantile to compute (`[0.0 - 1.0]`).',
                type: 'Float'
            },
            {
                name: 'method',
                desc: 'Quantile method to use.',
                type: 'String'
            }
        ],
        package: 'internal/promql',
        desc: 'Accounts checks for quantile values that are out of range, above 1.0 or below 0.0, by either returning positive infinity or negative infinity in the `_value` column respectively. `q` must be a float.',
        example: 'promql.quantile()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/internal/promql/quantile/'
    },
    {
        name: 'promql.resets',
        args: [],
        package: 'internal/promql',
        desc: "Implements functionality equivalent to PromQL's `resets()` function (https://prometheus.io/docs/prometheus/latest/querying/functions/#resets).",
        example: 'promql.resets()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/internal/promql/resets/'
    },
    {
        name: 'promql.timestamp',
        args: [],
        package: 'internal/promql',
        desc: "Implements functionality equivalent to PromQL's `timestamp()` function (https://prometheus.io/docs/prometheus/latest/querying/functions/#timestamp).",
        example: 'promql.timestamp()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/internal/promql/timestamp/'
    },
    {
        name: 'pushbullet.endpoint',
        args: [
            {
                name: 'url',
                desc: 'PushBullet API endpoint URL. Default is `"https://api.pushbullet.com/v2/pushes"`.',
                type: 'String'
            },
            {
                name: 'token',
                desc: 'Pushbullet API token string. Default is `""`.',
                type: 'Object'
            }
        ],
        package: 'pushbullet',
        desc: 'Creates the endpoint for the Pushbullet API and sends a notification of type note.',
        example: 'pushbullet.endpoint(token: token)',
        category: 'Notification endpoints',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/pushbullet/endpoint/'
    },
    {
        name: 'pushbullet.pushData',
        args: [
            {
                name: 'url',
                desc: 'URL of the PushBullet endpoint. Default is `"https://api.pushbullet.com/v2/pushes"`.',
                type: 'String'
            },
            {
                name: 'token',
                desc: 'API token string. Default is `""`.',
                type: 'Object'
            },
            {
                name: 'data',
                desc: "Data to send to the endpoint. Data is JSON-encoded and sent to the Pushbullet's endpoint.",
                type: 'Object'
            }
        ],
        package: 'pushbullet',
        desc: 'Sends a push notification to the Pushbullet API.',
        example: 'pushbullet.pushData( token: "mY5up3Rs3Cre7T0k3n", data: { "type": "link", "title": "Example title", "body": "Example nofication body", "url": "http://example-url.com", })',
        category: 'Notification endpoints',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/pushbullet/pushdata/'
    },
    {
        name: 'pushbullet.pushNote',
        args: [
            {
                name: 'url',
                desc: 'URL of the PushBullet endpoint. Default is `"https://api.pushbullet.com/v2/pushes"`.',
                type: 'String'
            },
            {
                name: 'token',
                desc: 'API token string. Defaults to: `""`.',
                type: 'Object'
            },
            {
                name: 'title',
                desc: 'Title of the notification.',
                type: 'Object'
            },
            {
                name: 'text',
                desc: 'Text to display in the notification.',
                type: 'Object'
            }
        ],
        package: 'pushbullet',
        desc: 'Sends a push notification of type "note" to the Pushbullet API.',
        example: 'pushbullet.pushNote( token: "mY5up3Rs3Cre7T0k3n", data: {"type": "link", "title": "Example title", "text": "Example note text"})',
        category: 'Notification endpoints',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/pushbullet/pushnote/'
    },
    {
        name: 'record.get',
        args: [
            {
                name: 'r',
                desc: 'Record to retrieve the value from.',
                type: 'Object'
            },
            {
                name: 'key',
                desc: 'Property key to retrieve.',
                type: 'String'
            },
            {
                name: 'default',
                desc: 'Default value to return if the specified key does not exist in the record.',
                type: 'Object'
            }
        ],
        package: 'experimental/record',
        desc: "Returns a value from a record by key name or a default value if the key doesn\u2019t exist in the record.",
        example: 'record.get(r: exampleRecord, key: key, default: "")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/record/get/'
    },
    {
        name: 'requests.do',
        args: [
            {
                name: 'method',
                desc: 'method of the http request.',
                type: 'String'
            },
            {
                name: 'url',
                desc: 'URL to request. This should not include any query parameters.',
                type: 'String'
            },
            {
                name: 'params',
                desc: 'Set of key value pairs to add to the URL as query parameters.',
                type: 'Array'
            },
            {
                name: 'headers',
                desc: 'Set of key values pairs to include on the request.',
                type: 'Array'
            },
            {
                name: 'body',
                desc: 'Data to send with the request.',
                type: 'Bytes'
            },
            {
                name: 'config',
                desc: 'Set of options to control how the request should be performed.',
                type: 'Object'
            }
        ],
        package: 'http/requests',
        desc: 'Makes an http request.',
        example: 'requests.do(url: "http://example.com", method: "GET")',
        category: 'Inputs',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/http/requests/do/'
    },
    {
        name: 'requests.get',
        args: [
            {
                name: 'url',
                desc: 'URL to request. This should not include any query parameters.',
                type: 'String'
            },
            {
                name: 'params',
                desc: 'Set of key value pairs to add to the URL as query parameters.',
                type: 'Array'
            },
            {
                name: 'headers',
                desc: 'Set of key values pairs to include on the request.',
                type: 'Array'
            },
            {
                name: 'body',
                desc: 'Data to send with the request.',
                type: 'Bytes'
            },
            {
                name: 'config',
                desc: 'Set of options to control how the request should be performed.',
                type: 'Object'
            }
        ],
        package: 'http/requests',
        desc: 'Makes a http GET request. This identical to calling `request.do(method: "GET", ...)`.',
        example: 'requests.get(url: "http://example.com")',
        category: 'Inputs',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/http/requests/get/'
    },
    {
        name: 'requests.peek',
        args: [
            {
                name: 'response',
                desc: 'Response data from an HTTP request.',
                type: 'Object'
            }
        ],
        package: 'http/requests',
        desc: 'Converts an HTTP response into a table for easy inspection.',
        example: 'requests.peek(response: requests.get(url: "https://api.agify.io", params: ["name": ["natalie"]]))',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/http/requests/peek/'
    },
    {
        name: 'requests.post',
        args: [
            {
                name: 'url',
                desc: 'URL to request. This should not include any query parameters.',
                type: 'String'
            },
            {
                name: 'params',
                desc: 'Set of key value pairs to add to the URL as query parameters.',
                type: 'Array'
            },
            {
                name: 'headers',
                desc: 'Set of key values pairs to include on the request.',
                type: 'Array'
            },
            {
                name: 'body',
                desc: 'Data to send with the request.',
                type: 'Bytes'
            },
            {
                name: 'config',
                desc: 'Set of options to control how the request should be performed.',
                type: 'Object'
            }
        ],
        package: 'http/requests',
        desc: 'Makes a http POST request. This identical to calling `request.do(method: "POST", ...)`.',
        example: 'requests.post( url: "https://goolnk.com/api/v1/shorten", body: json.encode(v: {url: "http://www.influxdata.com"}), headers: ["Content-Type": "application/json"])',
        category: 'Inputs',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/http/requests/post/'
    },
    {
        name: 'sample.alignToNow',
        args: [],
        package: 'influxdata/influxdb/sample',
        desc: 'Shifts time values in input data to align the chronological last point to _now_.',
        example: 'sample.alignToNow()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/influxdata/influxdb/sample/aligntonow/'
    },
    {
        name: 'sample.data',
        args: [
            {
                name: 'set',
                desc: 'Sample data set to download and output.',
                type: 'String'
            }
        ],
        package: 'influxdata/influxdb/sample',
        desc: 'Downloads a specified InfluxDB sample dataset.',
        example: 'sample.data()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/influxdata/influxdb/sample/data/'
    },
    {
        name: 'sample.list',
        args: [],
        package: 'influxdata/influxdb/sample',
        desc: 'Outputs information about available InfluxDB sample datasets.',
        example: 'sample.list()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/influxdata/influxdb/sample/list/'
    },
    {
        name: 'sampledata.bool',
        args: [
            {
                name: 'includeNull',
                desc: 'Include null values in the returned dataset.',
                type: 'Boolean'
            }
        ],
        package: 'sampledata',
        desc: 'Returns a sample data set with boolean values.',
        example: 'sampledata.bool()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/sampledata/bool/'
    },
    {
        name: 'sampledata.float',
        args: [
            {
                name: 'includeNull',
                desc: 'Include null values in the returned dataset.',
                type: 'Boolean'
            }
        ],
        package: 'sampledata',
        desc: 'Returns a sample data set with float values.',
        example: 'sampledata.float()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/sampledata/float/'
    },
    {
        name: 'sampledata.int',
        args: [
            {
                name: 'includeNull',
                desc: 'Include null values in the returned dataset.',
                type: 'Boolean'
            }
        ],
        package: 'sampledata',
        desc: 'Returns a sample data set with integer values.',
        example: 'sampledata.int()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/sampledata/int/'
    },
    {
        name: 'sampledata.numericBool',
        args: [
            {
                name: 'includeNull',
                desc: 'Include null values in the returned dataset.',
                type: 'Boolean'
            }
        ],
        package: 'sampledata',
        desc: 'Returns a sample data set with numeric (integer) boolean values.',
        example: 'sampledata.numericBool()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/sampledata/numericbool/'
    },
    {
        name: 'sampledata.string',
        args: [
            {
                name: 'includeNull',
                desc: 'Include null values in the returned dataset.',
                type: 'Boolean'
            }
        ],
        package: 'sampledata',
        desc: 'Returns a sample data set with string values.',
        example: 'sampledata.string()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/sampledata/string/'
    },
    {
        name: 'sampledata.uint',
        args: [
            {
                name: 'includeNull',
                desc: 'Include null values in the returned dataset.',
                type: 'Boolean'
            }
        ],
        package: 'sampledata',
        desc: 'Returns a sample data set with unsigned integer values.',
        example: 'sampledata.uint()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/sampledata/uint/'
    },
    {
        name: 'schema.fieldKeys',
        args: [
            {
                name: 'bucket',
                desc: 'Bucket to list field keys from.',
                type: 'String'
            },
            {
                name: 'predicate',
                desc: 'Predicate function that filters field keys.',
                type: 'Function'
            },
            {
                name: 'start',
                desc: 'Oldest time to include in results. Default is `-30d`.',
                type: 'Object'
            },
            {
                name: 'stop',
                desc: 'Newest time include in results.',
                type: 'Object'
            }
        ],
        package: 'influxdata/influxdb/schema',
        desc: 'Returns field keys in a bucket.',
        example: 'schema.fieldKeys(bucket: "example-bucket")',
        category: 'Metadata',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/influxdata/influxdb/schema/fieldkeys/'
    },
    {
        name: 'schema.fieldsAsCols',
        args: [],
        package: 'influxdata/influxdb/schema',
        desc: 'Is a special application of `pivot()` that pivots input data on `_field` and `_time` columns to align fields within each input table that have the same timestamp.',
        example: 'schema.fieldsAsCols()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/influxdata/influxdb/schema/fieldsascols/'
    },
    {
        name: 'schema.measurementFieldKeys',
        args: [
            {
                name: 'bucket',
                desc: 'Bucket to retrieve field keys from.',
                type: 'String'
            },
            {
                name: 'measurement',
                desc: 'Measurement to list field keys from.',
                type: 'Object'
            },
            {
                name: 'start',
                desc: 'Oldest time to include in results. Default is `-30d`.',
                type: 'Object'
            },
            {
                name: 'stop',
                desc: 'Newest time include in results.',
                type: 'Object'
            }
        ],
        package: 'influxdata/influxdb/schema',
        desc: 'Returns a list of fields in a measurement.',
        example: 'schema.measurementFieldKeys(bucket: "example-bucket", measurement: "example-measurement")',
        category: 'Metadata',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/influxdata/influxdb/schema/measurementfieldkeys/'
    },
    {
        name: 'schema.measurementTagKeys',
        args: [
            {
                name: 'bucket',
                desc: 'Bucket to return tag keys from for a specific measurement.',
                type: 'String'
            },
            {
                name: 'measurement',
                desc: 'Measurement to return tag keys from.',
                type: 'Object'
            },
            {
                name: 'start',
                desc: 'Oldest time to include in results. Default is `-30d`.',
                type: 'Object'
            },
            {
                name: 'stop',
                desc: 'Newest time include in results.',
                type: 'Object'
            }
        ],
        package: 'influxdata/influxdb/schema',
        desc: 'Returns the list of tag keys for a specific measurement.',
        example: 'schema.measurementTagKeys(bucket: "example-bucket", measurement: "example-measurement")',
        category: 'Metadata',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/influxdata/influxdb/schema/measurementtagkeys/'
    },
    {
        name: 'schema.measurementTagValues',
        args: [
            {
                name: 'bucket',
                desc: 'Bucket to return tag values from for a specific measurement.',
                type: 'String'
            },
            {
                name: 'measurement',
                desc: 'Measurement to return tag values from.',
                type: 'Object'
            },
            {
                name: 'tag',
                desc: 'Tag to return all unique values from.',
                type: 'String'
            },
            {
                name: 'start',
                desc: 'Oldest time to include in results. Default is `-30d`.',
                type: 'Object'
            },
            {
                name: 'stop',
                desc: 'Newest time include in results.',
                type: 'Object'
            }
        ],
        package: 'influxdata/influxdb/schema',
        desc: 'Returns a list of tag values for a specific measurement.',
        example: 'schema.measurementTagValues( bucket: "example-bucket", measurement: "example-measurement", tag: "example-tag")',
        category: 'Metadata',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/influxdata/influxdb/schema/measurementtagvalues/'
    },
    {
        name: 'schema.measurements',
        args: [
            {
                name: 'bucket',
                desc: 'Bucket to retrieve measurements from.',
                type: 'String'
            },
            {
                name: 'start',
                desc: 'Oldest time to include in results. Default is `-30d`.',
                type: 'Object'
            },
            {
                name: 'stop',
                desc: 'Newest time include in results.',
                type: 'Object'
            }
        ],
        package: 'influxdata/influxdb/schema',
        desc: 'Returns a list of measurements in a specific bucket.',
        example: 'schema.measurements(bucket: "example-bucket")',
        category: 'Metadata',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/influxdata/influxdb/schema/measurements/'
    },
    {
        name: 'schema.tagKeys',
        args: [
            {
                name: 'bucket',
                desc: 'Bucket to return tag keys from.',
                type: 'String'
            },
            {
                name: 'predicate',
                desc: 'Predicate function that filters tag keys.',
                type: 'Function'
            },
            {
                name: 'start',
                desc: 'Oldest time to include in results. Default is `-30d`.',
                type: 'Object'
            },
            {
                name: 'stop',
                desc: 'Newest time include in results.',
                type: 'Object'
            }
        ],
        package: 'influxdata/influxdb/schema',
        desc: 'Returns a list of tag keys for all series that match the `predicate`.',
        example: 'schema.tagKeys(bucket: "example-bucket")',
        category: 'Metadata',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/influxdata/influxdb/schema/tagkeys/'
    },
    {
        name: 'schema.tagValues',
        args: [
            {
                name: 'bucket',
                desc: 'Bucket to return unique tag values from.',
                type: 'String'
            },
            {
                name: 'tag',
                desc: 'Tag to return unique values from.',
                type: 'String'
            },
            {
                name: 'predicate',
                desc: 'Predicate function that filters tag values.',
                type: 'Function'
            },
            {
                name: 'start',
                desc: 'Oldest time to include in results. Default is `-30d`.',
                type: 'Object'
            },
            {
                name: 'stop',
                desc: 'Newest time include in results.',
                type: 'Object'
            }
        ],
        package: 'influxdata/influxdb/schema',
        desc: 'Returns a list of unique values for a given tag.',
        example: 'schema.tagValues(bucket: "example-bucket", tag: "host")',
        category: 'Metadata',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/influxdata/influxdb/schema/tagvalues/'
    },
    {
        name: 'sensu.endpoint',
        args: [
            {
                name: 'url',
                desc: 'Base URL of Sensu API (https://docs.sensu.io/sensu-go/latest/migrate/#architecture)',
                type: 'String'
            },
            {
                name: 'apiKey',
                desc: 'Sensu API Key (https://docs.sensu.io/sensu-go/latest/operations/control-access/).',
                type: 'String'
            },
            {
                name: 'handlers',
                desc: 'Sensu handlers (https://docs.sensu.io/sensu-go/latest/reference/handlers/) to execute.',
                type: 'Object'
            },
            {
                name: 'namespace',
                desc: 'Sensu namespace (https://docs.sensu.io/sensu-go/latest/reference/rbac/).',
                type: 'String'
            },
            {
                name: 'entityName',
                desc: 'Event source.',
                type: 'String'
            }
        ],
        package: 'contrib/sranka/sensu',
        desc: 'Sends an event to the Sensu Events API (https://docs.sensu.io/sensu-go/latest/api/events/#create-a-new-event) using data from table rows.',
        example: 'sensu.endpoint(url: "http://localhost:8080", apiKey: apiKey)',
        category: 'Notification endpoints',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/sranka/sensu/endpoint/'
    },
    {
        name: 'sensu.event',
        args: [
            {
                name: 'url',
                desc: 'Base URL of Sensu API (https://docs.sensu.io/sensu-go/latest/migrate/#architecture)',
                type: 'String'
            },
            {
                name: 'apiKey',
                desc: 'Sensu API Key (https://docs.sensu.io/sensu-go/latest/operations/control-access/).',
                type: 'String'
            },
            {
                name: 'checkName',
                desc: 'Check name.',
                type: 'String'
            },
            {
                name: 'text',
                desc: 'Event text.',
                type: 'Object'
            },
            {
                name: 'handlers',
                desc: 'Sensu handlers to execute. Default is `[]`.',
                type: 'Object'
            },
            {
                name: 'status',
                desc: 'Event status code that indicates state (/flux/v0/stdlib/contrib/sranka/sensu/event/#state).',
                type: 'Object'
            },
            {
                name: 'state',
                desc: 'Event state.',
                type: 'String'
            },
            {
                name: 'namespace',
                desc: 'Sensu namespace (https://docs.sensu.io/sensu-go/latest/reference/rbac/).',
                type: 'String'
            },
            {
                name: 'entityName',
                desc: 'Event source.',
                type: 'String'
            }
        ],
        package: 'contrib/sranka/sensu',
        desc: 'Sends a single event to the Sensu Events API (https://docs.sensu.io/sensu-go/latest/api/events/#create-a-new-event).',
        example: 'sensu.event( url: "http://localhost:8080", apiKey: apiKey, checkName: "diskUsage", text: "Disk usage is **${lastReported.status}**.")',
        category: 'Notification endpoints',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/sranka/sensu/event/'
    },
    {
        name: 'sensu.toSensuName',
        args: [
            {
                name: 'v',
                desc: 'String to operate on.',
                type: 'String'
            }
        ],
        package: 'contrib/sranka/sensu',
        desc: 'Translates a string value to a Sensu name by replacing non-alphanumeric characters (`[a-zA-Z0-9_.-]`) with underscores (`_`).',
        example: 'sensu.toSensuName(v: "Example name conversion")',
        category: 'Notification endpoints',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/sranka/sensu/tosensuname/'
    },
    {
        name: 'servicenow.endpoint',
        args: [
            {
                name: 'url',
                desc: 'ServiceNow web service URL.',
                type: 'String'
            },
            {
                name: 'username',
                desc: 'ServiceNow username to use for HTTP BASIC authentication.',
                type: 'String'
            },
            {
                name: 'password',
                desc: 'ServiceNow password to use for HTTP BASIC authentication.',
                type: 'String'
            },
            {
                name: 'source',
                desc: 'Source name. Default is `"Flux"`.',
                type: 'Object'
            }
        ],
        package: 'contrib/bonitoo-io/servicenow',
        desc: 'Sends events to ServiceNow (https://servicenow.com/) using data from input rows.',
        example: 'servicenow.endpoint( url: "https://example-tenant.service-now.com/api/global/em/jsonv2", username: username, password: password)',
        category: 'Notification endpoints',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/bonitoo-io/servicenow/endpoint/'
    },
    {
        name: 'servicenow.event',
        args: [
            {
                name: 'url',
                desc: 'ServiceNow web service URL.',
                type: 'String'
            },
            {
                name: 'username',
                desc: 'ServiceNow username to use for HTTP BASIC authentication.',
                type: 'String'
            },
            {
                name: 'password',
                desc: 'ServiceNow password to use for HTTP BASIC authentication.',
                type: 'String'
            },
            {
                name: 'description',
                desc: 'Event description.',
                type: 'Object'
            },
            {
                name: 'severity',
                desc: 'Severity of the event.',
                type: 'Object'
            },
            {
                name: 'source',
                desc: 'Source name. Default is `"Flux"`.',
                type: 'Object'
            },
            {
                name: 'node',
                desc: 'Node name or IP address related to the event.',
                type: 'Object'
            },
            {
                name: 'metricType',
                desc: 'Metric type related to the event (for example, `CPU`).',
                type: 'Object'
            },
            {
                name: 'resource',
                desc: 'Resource related to the event (for example, `CPU-1`).',
                type: 'Object'
            },
            {
                name: 'metricName',
                desc: 'Metric name related to the event (for example, `usage_idle`).',
                type: 'Object'
            },
            {
                name: 'messageKey',
                desc: 'Unique identifier of the event (for example, the InfluxDB alert ID).',
                type: 'Object'
            },
            {
                name: 'additionalInfo',
                desc: 'Additional information to include with the event.',
                type: 'Object'
            }
        ],
        package: 'contrib/bonitoo-io/servicenow',
        desc: 'Sends an event to ServiceNow (https://servicenow.com/).',
        example: 'servicenow.event( url: "https://tenant.service-now.com/api/global/em/jsonv2", username: username, password: password, node: lastReported.host, metricType: lastReported._measurement, resource: lastReported.instance, metricName: lastReported._field, severity: if lastReported._value < 1.0 then "critical" else if lastReported._value < 5.0 then "warning" else "info", additionalInfo: {"devId": r.dev_id})',
        category: 'Notification endpoints',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/bonitoo-io/servicenow/event/'
    },
    {
        name: 'slack.endpoint',
        args: [
            {
                name: 'url',
                desc: 'Slack API URL. Default is `https://slack.com/api/chat.postMessage`.',
                type: 'String'
            },
            {
                name: 'token',
                desc: 'Slack API token. Default is `""`.',
                type: 'String'
            }
        ],
        package: 'slack',
        desc: 'Returns a function that can be used to send a message to Slack per input row.',
        example: 'slack.endpoint(token: "mY5uP3rSeCr37T0kEN")',
        category: 'Notification endpoints',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/slack/endpoint/'
    },
    {
        name: 'slack.message',
        args: [
            {
                name: 'url',
                desc: 'Slack API URL.',
                type: 'String'
            },
            {
                name: 'token',
                desc: 'Slack API token. Default is `""`.',
                type: 'String'
            },
            {
                name: 'channel',
                desc: 'Slack channel or user to send the message to.',
                type: 'Object'
            },
            {
                name: 'text',
                desc: 'Message text.',
                type: 'Object'
            },
            {
                name: 'color',
                desc: 'Slack message color.',
                type: 'String'
            }
        ],
        package: 'slack',
        desc: 'Sends a single message to a Slack channel and returns the HTTP response code of the request.',
        example: 'slack.message( url: "https://hooks.slack.com/services/EXAMPLE-WEBHOOK-URL", channel: "#example-channel", text: "Example slack message", color: "warning")',
        category: 'Notification endpoints',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/slack/message/'
    },
    {
        name: 'slack.validateColorString',
        args: [
            {
                name: 'color',
                desc: 'Hex color code.',
                type: 'String'
            }
        ],
        package: 'slack',
        desc: 'Ensures a string contains a valid hex color code.',
        example: 'slack.validateColorString(color: "#fff")',
        category: 'Notification endpoints',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/slack/validatecolorstring/'
    },
    {
        name: 'socket.from',
        args: [
            {
                name: 'url',
                desc: 'URL to return data from.',
                type: 'String'
            },
            {
                name: 'decoder',
                desc: 'Decoder to use to parse returned data into a stream of tables.',
                type: 'String'
            }
        ],
        package: 'socket',
        desc: 'Returns data from a socket connection and outputs a stream of tables given a specified decoder.',
        example: 'socket.from(url: "tcp://127.0.0.1:1234", decoder: "csv")',
        category: 'Inputs',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/socket/from/'
    },
    {
        name: 'stateTracking',
        args: [
            {
                name: 'fn',
                desc: 'Predicate function to determine state.',
                type: 'Function'
            },
            {
                name: 'countColumn',
                desc: 'Column to store state count in.',
                type: 'String'
            },
            {
                name: 'durationColumn',
                desc: 'Column to store state duration in.',
                type: 'String'
            },
            {
                name: 'durationUnit',
                desc: 'Unit of time to report state duration in. Default is `1s`.',
                type: 'Duration'
            },
            {
                name: 'timeColumn',
                desc: 'Column with time values used to calculate state duration.',
                type: 'String'
            }
        ],
        package: '',
        desc: 'Returns the cumulative count and duration of consecutive rows that match a predicate function that defines a state.',
        example: 'stateTracking(fn: (r) => r.state == "crit", countColumn: "count")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/statetracking/'
    },
    {
        name: 'statsmodels.linearRegression',
        args: [],
        package: 'contrib/anaisdg/statsmodels',
        desc: 'Performs a linear regression.',
        example: 'statsmodels.linearRegression()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/anaisdg/statsmodels/linearregression/'
    },
    {
        name: 'table.fill',
        args: [],
        package: 'experimental/table',
        desc: 'Adds a single row to empty tables in a stream of tables.',
        example: 'table.fill()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/table/fill/'
    },
    {
        name: 'tasks.lastSuccess',
        args: [
            {
                name: 'orTime',
                desc: 'Default time value returned if the task has never successfully run.',
                type: 'Object'
            }
        ],
        package: 'influxdata/influxdb/tasks',
        desc: 'Returns the time of the last successful run of the InfluxDB task or the value of the `orTime` parameter if the task has never successfully run.',
        example: 'tasks.lastSuccess(orTime: 2020-01-01T00:00:00Z)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/influxdata/influxdb/tasks/lastsuccess/'
    },
    {
        name: 'teams.endpoint',
        args: [
            {
                name: 'url',
                desc: 'Incoming webhook URL.',
                type: 'String'
            }
        ],
        package: 'contrib/sranka/teams',
        desc: 'Sends a message to a Microsoft Teams channel using data from table rows.',
        example: 'teams.endpoint(url: url)',
        category: 'Notification endpoints',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/sranka/teams/endpoint/'
    },
    {
        name: 'teams.message',
        args: [
            {
                name: 'url',
                desc: 'Incoming webhook URL.',
                type: 'String'
            },
            {
                name: 'title',
                desc: 'Message card title.',
                type: 'Object'
            },
            {
                name: 'text',
                desc: 'Message card text.',
                type: 'String'
            },
            {
                name: 'summary',
                desc: 'Message card summary.',
                type: 'String'
            }
        ],
        package: 'contrib/sranka/teams',
        desc: 'Sends a single message to a Microsoft Teams channel using an incoming webhook (https://docs.microsoft.com/microsoftteams/platform/webhooks-and-connectors/how-to/add-incoming-webhook).',
        example: 'teams.message( url: "https://outlook.office.com/webhook/example-webhook", title: "Disk Usage", text: "Disk usage is: *${lastReported.status}*.", summary: "Disk usage is ${lastReported.status}")',
        category: 'Notification endpoints',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/sranka/teams/message/'
    },
    {
        name: 'telegram.endpoint',
        args: [
            {
                name: 'url',
                desc: 'URL of the Telegram bot endpoint. Default is `https://api.telegram.org/bot`.',
                type: 'String'
            },
            {
                name: 'token',
                desc: 'Telegram bot token.',
                type: 'String'
            },
            {
                name: 'parseMode',
                desc: 'Parse mode (https://core.telegram.org/bots/api#formatting-options)',
                type: 'Object'
            },
            {
                name: 'disableWebPagePreview',
                desc: 'Disable preview of web links in the sent message.',
                type: 'Object'
            }
        ],
        package: 'contrib/sranka/telegram',
        desc: 'Sends a message to a Telegram channel using data from table rows.',
        example: 'telegram.endpoint(token: token)',
        category: 'Notification endpoints',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/sranka/telegram/endpoint/'
    },
    {
        name: 'telegram.message',
        args: [
            {
                name: 'url',
                desc: 'URL of the Telegram bot endpoint. Default is `https://api.telegram.org/bot`.',
                type: 'String'
            },
            {
                name: 'token',
                desc: 'Telegram bot token.',
                type: 'String'
            },
            {
                name: 'channel',
                desc: 'Telegram channel ID.',
                type: 'Object'
            },
            {
                name: 'text',
                desc: 'Message text.',
                type: 'Object'
            },
            {
                name: 'parseMode',
                desc: 'Parse mode (https://core.telegram.org/bots/api#formatting-options)',
                type: 'Object'
            },
            {
                name: 'disableWebPagePreview',
                desc: 'Disable preview of web links in the sent message.',
                type: 'Object'
            },
            {
                name: 'silent',
                desc: 'Send message silently (https://telegram.org/blog/channels-2-0#silent-messages).',
                type: 'Object'
            }
        ],
        package: 'contrib/sranka/telegram',
        desc: 'Sends a single message to a Telegram channel using the `sendMessage` (https://core.telegram.org/bots/api#sendmessage) method of the Telegram Bot API.',
        example: 'telegram.message(token: token, channel: "-12345", text: "Disk usage is **${lastReported.status}**.")',
        category: 'Notification endpoints',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/sranka/telegram/message/'
    },
    {
        name: 'testing.assertEqualValues',
        args: [
            {
                name: 'got',
                desc: 'Value to test.',
                type: 'Object'
            },
            {
                name: 'want',
                desc: 'Expected value to test against.',
                type: 'Object'
            }
        ],
        package: 'testing',
        desc: 'Tests whether two values are equal.',
        example: 'testing.assertEqualValues(got: 5, want: 12)',
        category: 'Tests',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/testing/assertequalvalues/'
    },
    {
        name: 'testing.assertMatches',
        args: [
            {
                name: 'got',
                desc: 'Value to test.',
                type: 'String'
            },
            {
                name: 'want',
                desc: 'Regex to test against.',
                type: 'Regexp'
            }
        ],
        package: 'internal/testing',
        desc: 'Tests whether a string matches a given regex.',
        example: 'testing.assertMatches(got: "123", want: /12/)',
        category: 'Tests',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/internal/testing/assertmatches/'
    },
    {
        name: 'testing.load',
        args: [],
        package: 'testing',
        desc: 'Loads test data from a stream of tables.',
        example: 'testing.load(tables: got)',
        category: 'Tests',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/testing/load/'
    },
    {
        name: 'testing.shouldError',
        args: [
            {
                name: 'fn',
                desc: 'Function to call.',
                type: 'Function'
            },
            {
                name: 'want',
                desc: 'Regular expression to match the expected error.',
                type: 'Regexp'
            }
        ],
        package: 'testing',
        desc: 'Calls a function that catches any error and checks that the error matches the expected value.',
        example: 'testing.shouldError(fn: () => die(msg: "error message"), want: /error message/)',
        category: 'Tests',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/testing/shoulderror/'
    },
    {
        name: 'testing.shouldErrorWithCode',
        args: [
            {
                name: 'fn',
                desc: 'Function to call.',
                type: 'Function'
            },
            {
                name: 'want',
                desc: 'Regular expression to match the expected error.',
                type: 'Regexp'
            },
            {
                name: 'code',
                desc: 'Which flux error code to expect',
                type: 'UInteger'
            }
        ],
        package: 'internal/testing',
        desc: 'Calls a function that catches any error and checks that the error matches the expected value.',
        example: 'testing.shouldErrorWithCode(fn: () => die(msg: "error message"), want: /error message/, code: 3)',
        category: 'Tests',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/internal/testing/shoulderrorwithcode/'
    },
    {
        name: 'testutil.fail',
        args: [],
        package: 'internal/testutil',
        desc: 'Causes the current script to fail.',
        example: 'testutil.fail()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/internal/testutil/fail/'
    },
    {
        name: 'testutil.makeAny',
        args: [
            {
                name: 'typ',
                desc: 'Description of the type to create.',
                type: 'String'
            }
        ],
        package: 'internal/testutil',
        desc: 'Constructs any value based on a type description as a string.',
        example: 'testutil.makeAny()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/internal/testutil/makeany/'
    },
    {
        name: 'testutil.makeRecord',
        args: [
            {
                name: 'o',
                desc: 'Record value.',
                type: 'Object'
            }
        ],
        package: 'internal/testutil',
        desc: 'Is the identity function, but breaks the type connection from input to output.',
        example: 'testutil.makeRecord()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/internal/testutil/makerecord/'
    },
    {
        name: 'testutil.yield',
        args: [
            {
                name: 'v',
                desc: 'Any value.',
                type: 'Object'
            }
        ],
        package: 'internal/testutil',
        desc: 'Is the identity function.',
        example: 'testutil.yield()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/internal/testutil/yield/'
    },
    {
        name: 'tickscript.alert',
        args: [
            {
                name: 'check',
                desc: 'InfluxDB check data.',
                type: 'Object'
            },
            {
                name: 'id',
                desc: 'Function that returns the InfluxDB check ID provided by the check record.',
                type: 'Function'
            },
            {
                name: 'details',
                desc: 'Function to return the InfluxDB check details using data from input rows.',
                type: 'Function'
            },
            {
                name: 'message',
                desc: 'Function to return the InfluxDB check message using data from input rows.',
                type: 'Function'
            },
            {
                name: 'crit',
                desc: 'Predicate function to determine `crit` status. Default is `(r) => false`.',
                type: 'Function'
            },
            {
                name: 'warn',
                desc: 'Predicate function to determine `warn` status. Default is `(r) => false`.',
                type: 'Function'
            },
            {
                name: 'info',
                desc: 'Predicate function to determine `info` status. Default is `(r) => false`.',
                type: 'Function'
            },
            {
                name: 'ok',
                desc: 'Predicate function to determine `ok` status. Default is `(r) => true`.',
                type: 'Function'
            },
            {
                name: 'topic',
                desc: 'Check topic. Default is `""`.',
                type: 'String'
            }
        ],
        package: 'contrib/bonitoo-io/tickscript',
        desc: 'Identifies events of varying severity levels and writes them to the `statuses` measurement in the InfluxDB `_monitoring` system bucket.',
        example: 'tickscript.alert( check: {check with _check_id: "task/${r.service}"}, message: "task/${r.service} is ${r._level} value: ${r._value}", crit: (r) => r._value > 30, warn: (r) => r._value > 20, info: (r) => r._value > 10)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/bonitoo-io/tickscript/alert/'
    },
    {
        name: 'tickscript.compute',
        args: [
            {
                name: 'as',
                desc: 'New column name.',
                type: 'String'
            },
            {
                name: 'column',
                desc: 'Column to operate on. Default is `_value`.',
                type: 'Object'
            },
            {
                name: 'fn',
                desc: 'Aggregate or selector function to apply.',
                type: 'Function'
            }
        ],
        package: 'contrib/bonitoo-io/tickscript',
        desc: "Is an alias for `tickscript.select()` that changes a column\u2019s name and optionally applies an aggregate or selector function.",
        example: 'tickscript.compute()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/bonitoo-io/tickscript/compute/'
    },
    {
        name: 'tickscript.deadman',
        args: [
            {
                name: 'check',
                desc: 'InfluxDB check data. See `tickscript.defineCheck()`.',
                type: 'Object'
            },
            {
                name: 'measurement',
                desc: 'Measurement name. Should match the queried measurement.',
                type: 'String'
            },
            {
                name: 'threshold',
                desc: 'Count threshold. Default is `0`.',
                type: 'Object'
            },
            {
                name: 'id',
                desc: 'Function that returns the InfluxDB check ID provided by the check record.',
                type: 'Function'
            },
            {
                name: 'message',
                desc: 'Function that returns the InfluxDB check message using data from input rows.',
                type: 'Function'
            },
            {
                name: 'topic',
                desc: 'Check topic. Default is `""`.',
                type: 'String'
            }
        ],
        package: 'contrib/bonitoo-io/tickscript',
        desc: 'Detects low data throughput and writes a point with a critical status to the InfluxDB `_monitoring` system bucket.',
        example: 'tickscript.deadman( check: tickscript.defineCheck(id: "000000000000", name: "task/${r.service}"), measurement: "pulse", threshold: 2)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/bonitoo-io/tickscript/deadman/'
    },
    {
        name: 'tickscript.defineCheck',
        args: [
            {
                name: 'id',
                desc: 'InfluxDB check ID.',
                type: 'Object'
            },
            {
                name: 'name',
                desc: 'InfluxDB check name.',
                type: 'Object'
            },
            {
                name: 'type',
                desc: 'InfluxDB check type. Default is `custom`.',
                type: 'Object'
            }
        ],
        package: 'contrib/bonitoo-io/tickscript',
        desc: 'Creates custom check data required by `alert()` and `deadman()`.',
        example: 'tickscript.defineCheck(id: "000000000000", name: "Example check name")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/bonitoo-io/tickscript/definecheck/'
    },
    {
        name: 'tickscript.groupBy',
        args: [
            {
                name: 'columns',
                desc: 'List of columns to group by.',
                type: 'Array'
            }
        ],
        package: 'contrib/bonitoo-io/tickscript',
        desc: 'Groups results by the `_measurement` column and other specified columns.',
        example: 'tickscript.groupBy(columns: ["host", "region"])',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/bonitoo-io/tickscript/groupby/'
    },
    {
        name: 'tickscript.join',
        args: [
            {
                name: 'tables',
                desc: 'Map of two streams to join.',
                type: 'Object'
            },
            {
                name: 'on',
                desc: 'List of columns to join on. Default is `["_time"]`.',
                type: 'Array'
            },
            {
                name: 'measurement',
                desc: 'Measurement name to use in results.',
                type: 'Object'
            }
        ],
        package: 'contrib/bonitoo-io/tickscript',
        desc: 'Merges two input streams into a single output stream based on specified columns with equal values and appends a new measurement name.',
        example: 'tickscript.join( tables: {metric: metrics, state: states}, on: ["_time", "host"], measurement: "example-m")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/bonitoo-io/tickscript/join/'
    },
    {
        name: 'tickscript.select',
        args: [
            {
                name: 'column',
                desc: 'Column to operate on. Default is `_value`.',
                type: 'Object'
            },
            {
                name: 'fn',
                desc: 'Aggregate or selector function to apply.',
                type: 'Function'
            },
            {
                name: 'as',
                desc: 'New column name.',
                type: 'String'
            }
        ],
        package: 'contrib/bonitoo-io/tickscript',
        desc: "Changes a column\u2019s name and optionally applies an aggregate or selector function to values in the column.",
        example: 'tickscript.select(as: "example-name")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/bonitoo-io/tickscript/select/'
    },
    {
        name: 'tickscript.selectWindow',
        args: [
            {
                name: 'column',
                desc: 'Column to operate on. Default is _value.',
                type: 'String'
            },
            {
                name: 'fn',
                desc: 'Aggregate or selector function to apply.',
                type: 'Function'
            },
            {
                name: 'as',
                desc: 'New column name.',
                type: 'String'
            },
            {
                name: 'every',
                desc: 'Duration of windows.',
                type: 'Duration'
            },
            {
                name: 'defaultValue',
                desc: 'Default fill value for null values in column.',
                type: 'Object'
            }
        ],
        package: 'contrib/bonitoo-io/tickscript',
        desc: "Changes a column\u2019s name, windows rows by time, and then applies an aggregate or selector function the specified column for each window of time.",
        example: 'tickscript.selectWindow(fn: sum, as: "example-name", every: 1h, defaultValue: 0)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/bonitoo-io/tickscript/selectwindow/'
    },
    {
        name: 'timeWeightedAvg',
        args: [
            {
                name: 'unit',
                desc: 'Unit of time to use to compute the time-weighted average.',
                type: 'Duration'
            }
        ],
        package: '',
        desc: 'Returns the time-weighted average of non-null values in `_value` column as a float for each input table.',
        example: 'timeWeightedAvg(unit: 1s)',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/timeweightedavg/'
    },
    {
        name: 'timezone.fixed',
        args: [
            {
                name: 'offset',
                desc: 'Fixed duration for the location offset.',
                type: 'Object'
            }
        ],
        package: 'timezone',
        desc: 'Returns a location record with a fixed offset.',
        example: 'timezone.fixed(offset: -8h)',
        category: 'Date/time',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/timezone/fixed/'
    },
    {
        name: 'timezone.location',
        args: [
            {
                name: 'name',
                desc: 'Location name (as defined by your operating system timezone database).',
                type: 'String'
            }
        ],
        package: 'timezone',
        desc: 'Returns a location record based on a location or timezone name.',
        example: 'timezone.location(name: "America/Los_Angeles")',
        category: 'Date/time',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/timezone/location/'
    },
    {
        name: 'today',
        args: [],
        package: '',
        desc: 'Returns the now() timestamp truncated to the day unit.',
        example: 'today()',
        category: 'Date/time',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/universe/today/'
    },
    {
        name: 'types.isNumeric',
        args: [
            {
                name: 'v',
                desc: 'Value to test.',
                type: 'Object'
            }
        ],
        package: 'types',
        desc: 'Tests if a value is a numeric type (int, uint, or float).',
        example: 'types.isNumeric(v: r._value)',
        category: 'Tests',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/types/isnumeric/'
    },
    {
        name: 'types.isType',
        args: [
            {
                name: 'v',
                desc: 'Value to test.',
                type: 'Object'
            },
            {
                name: 'type',
                desc: 'String describing the type to check against.',
                type: 'String'
            }
        ],
        package: 'types',
        desc: 'Tests if a value is a specified type.',
        example: 'types.isType(v: r._value, type: "string")',
        category: 'Tests',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/types/istype/'
    },
    {
        name: 'usage.from',
        args: [
            {
                name: 'start',
                desc: 'Earliest time to include in results.',
                type: 'Object'
            },
            {
                name: 'stop',
                desc: 'Latest time to include in results.',
                type: 'Object'
            },
            {
                name: 'host',
                desc: 'InfluxDB Cloud region URL (/influxdb/cloud/reference/regions/).',
                type: 'String'
            },
            {
                name: 'orgID',
                desc: 'InfluxDB Cloud organization ID. Default is `""`.',
                type: 'String'
            },
            {
                name: 'token',
                desc: 'InfluxDB Cloud API token (/influxdb/cloud/admin/tokens/).',
                type: 'String'
            },
            {
                name: 'raw',
                desc: 'Return raw, high resolution usage data instead of downsampled usage data.',
                type: 'Object'
            }
        ],
        package: 'experimental/usage',
        desc: 'Returns usage data from an **InfluxDB Cloud** organization.',
        example: 'usage.from(start: -30d, stop: now())',
        category: 'Inputs',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/usage/from/'
    },
    {
        name: 'usage.limits',
        args: [
            {
                name: 'host',
                desc: 'InfluxDB Cloud region URL (/influxdb/cloud/reference/regions/).',
                type: 'String'
            },
            {
                name: 'orgID',
                desc: 'InfluxDB Cloud organization ID. Default is `""`.',
                type: 'String'
            },
            {
                name: 'token',
                desc: 'InfluxDB Cloud API token (/influxdb/cloud/admin/tokens/).',
                type: 'String'
            }
        ],
        package: 'experimental/usage',
        desc: 'Returns a record containing usage limits for an **InfluxDB Cloud** organization.',
        example: 'usage.limits()',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/experimental/usage/limits/'
    },
    {
        name: 'v1.databases',
        args: [
            {
                name: 'org',
                desc: 'Organization name.',
                type: 'String'
            },
            {
                name: 'orgID',
                desc: 'Organization ID.',
                type: 'String'
            },
            {
                name: 'host',
                desc: 'InfluxDB URL. Default is `http://localhost:8086`.',
                type: 'String'
            },
            {
                name: 'token',
                desc: 'InfluxDB API token.',
                type: 'String'
            }
        ],
        package: 'influxdata/influxdb/v1',
        desc: 'Returns a list of databases in an InfluxDB 1.x (1.7+) instance.',
        example: 'v1.databases()',
        category: 'Metadata',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/influxdata/influxdb/v1/databases/'
    },
    {
        name: 'v1.fieldKeys',
        args: [
            {
                name: 'bucket',
                desc: 'Bucket to list field keys from.',
                type: 'String'
            },
            {
                name: 'predicate',
                desc: 'Predicate function that filters field keys.',
                type: 'Function'
            },
            {
                name: 'start',
                desc: 'Oldest time to include in results. Default is `-30d`.',
                type: 'Object'
            },
            {
                name: 'stop',
                desc: 'Newest time include in results.',
                type: 'Object'
            }
        ],
        package: 'influxdata/influxdb/v1',
        desc: 'Returns field keys in a bucket.',
        example: 'v1.fieldKeys()',
        category: 'Metadata',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/influxdata/influxdb/v1/fieldkeys/'
    },
    {
        name: 'v1.json (file)',
        args: [
            {
                name: 'file',
                desc: 'File path to file containing InfluxDB 1.x query results in JSON format.',
                type: 'String'
            }
        ],
        package: 'influxdata/influxdb/v1',
        desc: 'Parses an InfluxDB 1.x JSON result into a stream of tables.',
        example: 'v1.json(file: path)',
        category: 'Inputs',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/influxdata/influxdb/v1/json/'
    },
    {
        name: 'v1.json (jsonData)',
        args: [
            {
                name: 'json',
                desc: 'InfluxDB 1.x query results in JSON format.',
                type: 'String'
            }
        ],
        package: 'influxdata/influxdb/v1',
        desc: 'Parses an InfluxDB 1.x JSON result into a stream of tables.',
        example: 'v1.json(json: jsonData)',
        category: 'Inputs',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/influxdata/influxdb/v1/json/'
    },
    {
        name: 'v1.measurementFieldKeys',
        args: [
            {
                name: 'bucket',
                desc: 'Bucket to retrieve field keys from.',
                type: 'String'
            },
            {
                name: 'measurement',
                desc: 'Measurement to list field keys from.',
                type: 'Object'
            },
            {
                name: 'start',
                desc: 'Oldest time to include in results. Default is `-30d`.',
                type: 'Object'
            },
            {
                name: 'stop',
                desc: 'Newest time include in results.',
                type: 'Object'
            }
        ],
        package: 'influxdata/influxdb/v1',
        desc: 'Returns a list of fields in a measurement.',
        example: 'v1.measurementFieldKeys()',
        category: 'Metadata',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/influxdata/influxdb/v1/measurementfieldkeys/'
    },
    {
        name: 'victorops.alert',
        args: [
            {
                name: 'url',
                desc: 'VictorOps REST endpoint integration URL.',
                type: 'String'
            },
            {
                name: 'monitoringTool',
                desc: 'Monitoring agent name. Default is `""`.',
                type: 'Object'
            },
            {
                name: 'messageType',
                desc: 'VictorOps message type (alert behavior).',
                type: 'Object'
            },
            {
                name: 'entityID',
                desc: 'Incident ID. Default is `""`.',
                type: 'Object'
            },
            {
                name: 'entityDisplayName',
                desc: 'Incident display name or summary. Default is `""`.',
                type: 'Object'
            },
            {
                name: 'stateMessage',
                desc: 'Verbose incident message. Default is `""`.',
                type: 'Object'
            },
            {
                name: 'timestamp',
                desc: 'Incident start time. Default is `now()`.',
                type: 'Object'
            }
        ],
        package: 'contrib/bonitoo-io/victorops',
        desc: 'Sends an alert to VictorOps.',
        example: 'victorops.alert( url: "https://alert.victorops.com/integrations/generic/00000000/alert/${apiKey}/${routingKey}", messageType: if lastReported._value < 1.0 then "CRITICAL" else if lastReported._value < 5.0 then "WARNING" else "INFO", entityID: "example-alert-1", entityDisplayName: "Example Alert 1", stateMessage: "Last reported cpu_idle was ${string(v: r._value)}.")',
        category: 'Notification endpoints',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/bonitoo-io/victorops/alert/'
    },
    {
        name: 'victorops.endpoint',
        args: [
            {
                name: 'url',
                desc: 'VictorOps REST endpoint integration URL.',
                type: 'String'
            },
            {
                name: 'monitoringTool',
                desc: 'Tool to use for monitoring.',
                type: 'Object'
            }
        ],
        package: 'contrib/bonitoo-io/victorops',
        desc: 'Sends events to VictorOps using data from input rows.',
        example: 'victorops.endpoint(url: url)',
        category: 'Notification endpoints',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/bonitoo-io/victorops/endpoint/'
    },
    {
        name: 'webexteams.endpoint',
        args: [
            {
                name: 'url',
                desc: 'Base URL of Webex API endpoint (without a trailing slash).',
                type: 'String'
            },
            {
                name: 'token',
                desc: 'Webex API access token (https://developer.webex.com/docs/api/getting-started).',
                type: 'String'
            }
        ],
        package: 'contrib/sranka/webexteams',
        desc: 'Returns a function that sends a message that includes data from input rows to a Webex room.',
        example: 'webexteams.endpoint(token: token)',
        category: 'Notification endpoints',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/sranka/webexteams/endpoint/'
    },
    {
        name: 'webexteams.message',
        args: [
            {
                name: 'url',
                desc: 'Base URL of Webex API endpoint (without a trailing slash).',
                type: 'String'
            },
            {
                name: 'token',
                desc: 'Webex API access token (https://developer.webex.com/docs/api/getting-started).',
                type: 'String'
            },
            {
                name: 'roomId',
                desc: 'Room ID to send the message to.',
                type: 'Object'
            },
            {
                name: 'text',
                desc: 'Plain text message.',
                type: 'Object'
            },
            {
                name: 'markdown',
                desc: 'Markdown formatted message (https://developer.webex.com/docs/api/basics#formatting-messages).',
                type: 'Object'
            }
        ],
        package: 'contrib/sranka/webexteams',
        desc: 'Sends a single message to Webex using the Webex messages API (https://developer.webex.com/docs/api/v1/messages/create-a-message).',
        example: 'webexteams.message( token: apiToken, roomId: "Y2lzY29zcGFyazovL3VzL1JPT00vYmJjZWIxYWQtNDNmMS0zYjU4LTkxNDctZjE0YmIwYzRkMTU0", text: "Disk usage is ${lastReported.status}.", markdown: "Disk usage is **${lastReported.status}**.")',
        category: 'Notification endpoints',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/sranka/webexteams/message/'
    },
    {
        name: 'zenoss.endpoint',
        args: [
            {
                name: 'url',
                desc: 'Zenoss router endpoint URL (https://help.zenoss.com/zsd/RM/configuring-resource-manager/enabling-access-to-browser-interfaces/creating-and-changing-public-endpoints).',
                type: 'String'
            },
            {
                name: 'username',
                desc: 'Zenoss username to use for HTTP BASIC authentication.',
                type: 'String'
            },
            {
                name: 'password',
                desc: 'Zenoss password to use for HTTP BASIC authentication.',
                type: 'String'
            },
            {
                name: 'apiKey',
                desc: 'Zenoss cloud API key.',
                type: 'Object'
            },
            {
                name: 'action',
                desc: 'Zenoss router name.',
                type: 'Object'
            },
            {
                name: 'method',
                desc: 'EventsRouter method.',
                type: 'Object'
            },
            {
                name: 'type',
                desc: 'Event type. Default is `"rpc"`.',
                type: 'Object'
            },
            {
                name: 'tid',
                desc: 'Temporary request transaction ID.',
                type: 'Object'
            }
        ],
        package: 'contrib/bonitoo-io/zenoss',
        desc: 'Sends events to Zenoss using data from input rows.',
        example: 'zenoss.endpoint(url: url, username: username, password: password)',
        category: 'Notification endpoints',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/bonitoo-io/zenoss/endpoint/'
    },
    {
        name: 'zenoss.event',
        args: [
            {
                name: 'url',
                desc: 'Zenoss router endpoint URL (https://help.zenoss.com/zsd/RM/configuring-resource-manager/enabling-access-to-browser-interfaces/creating-and-changing-public-endpoints).',
                type: 'String'
            },
            {
                name: 'username',
                desc: 'Zenoss username to use for HTTP BASIC authentication.',
                type: 'String'
            },
            {
                name: 'password',
                desc: 'Zenoss password to use for HTTP BASIC authentication.',
                type: 'String'
            },
            {
                name: 'apiKey',
                desc: 'Zenoss cloud API key.',
                type: 'Object'
            },
            {
                name: 'action',
                desc: 'Zenoss router name.',
                type: 'Object'
            },
            {
                name: 'method',
                desc: 'EventsRouter method (https://help.zenoss.com/dev/collection-zone-and-resource-manager-apis/codebase/routers/router-reference/eventsrouter).',
                type: 'Object'
            },
            {
                name: 'type',
                desc: 'Event type.',
                type: 'Object'
            },
            {
                name: 'tid',
                desc: 'Temporary request transaction ID.',
                type: 'Object'
            },
            {
                name: 'summary',
                desc: 'Event summary.',
                type: 'Object'
            },
            {
                name: 'device',
                desc: 'Related device.',
                type: 'Object'
            },
            {
                name: 'component',
                desc: 'Related component.',
                type: 'Object'
            },
            {
                name: 'severity',
                desc: 'Event severity level (https://help.zenoss.com/zsd/RM/administering-resource-manager/event-management/event-severity-levels).',
                type: 'Object'
            },
            {
                name: 'eventClass',
                desc: 'Event class (https://help.zenoss.com/zsd/RM/administering-resource-manager/event-management/understanding-event-classes).',
                type: 'Object'
            },
            {
                name: 'eventClassKey',
                desc: 'Event class key (https://help.zenoss.com/zsd/RM/administering-resource-manager/event-management/event-fields).',
                type: 'Object'
            },
            {
                name: 'collector',
                desc: 'Zenoss collector (https://help.zenoss.com/zsd/RM/administering-resource-manager/event-management/event-fields).',
                type: 'Object'
            },
            {
                name: 'message',
                desc: 'Related message.',
                type: 'Object'
            }
        ],
        package: 'contrib/bonitoo-io/zenoss',
        desc: 'Sends an event to Zenoss (https://www.zenoss.com/).',
        example: 'zenoss.event( url: "https://tenant.zenoss.io:8080/zport/dmd/evconsole_router", username: username, username: password, device: lastReported.host, component: "CPU", eventClass: "/App", severity: if lastReported._value < 1.0 then "Critical" else if lastReported._value < 5.0 then "Warning" else if lastReported._value < 20.0 then "Info" else "Clear")',
        category: 'Transformations',
        link: 'https://docs.influxdata.com/flux/v0/stdlib/contrib/bonitoo-io/zenoss/event/'
    }
];




class $b940e5241ef2bddf$var$FluxFunctionsToolbar extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleClickFunction = (fluxFunction)=>{
            this.props.onInsertFluxFunction(fluxFunction);
        }, this.handleSearch = (searchTerm)=>{
            this.setState({
                searchTerm: searchTerm
            });
        };
        this.state = {
            searchTerm: ''
        };
    }
    render() {
        const { searchTerm: searchTerm } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-functions-toolbar"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $18a73859436fc264$export$2e2bcd8739ae039), {
            onSearch: this.handleSearch
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-functions-toolbar--list"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $28ed0021233d4002$export$2e2bcd8739ae039), {
            funcs: (0, $f3c6a3e5c6466088$export$599f8541cd7f6f57),
            searchTerm: searchTerm
        }, (sortedFunctions)=>{
            return Object.entries(sortedFunctions).map(([category, funcs])=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b80d0662c69b8fa7$export$2e2bcd8739ae039), {
                    key: category,
                    category: category,
                    funcs: funcs,
                    onClickFunction: this.handleClickFunction
                });
            });
        }))));
    }
}
const $b940e5241ef2bddf$var$FluxFunctionsToolbar2 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($b940e5241ef2bddf$var$FluxFunctionsToolbar);
const $b940e5241ef2bddf$var$ConnectedFluxFunctionsToolbar = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b029b3af5fc2e5d5$export$7d87f8b720f7653e), null, (container)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($b940e5241ef2bddf$var$FluxFunctionsToolbar2, {
            ...props,
            script: container.state.draftScript,
            onUpdateScript: container.handleUpdateDraftScript
        }));
var $b940e5241ef2bddf$export$2e2bcd8739ae039 = $b940e5241ef2bddf$var$ConnectedFluxFunctionsToolbar;








// Constants
const $92033682fbba1f2a$export$240a2ee49d1b21d = {
    type: 'File',
    start: 0,
    end: 22,
    loc: {
        start: {
            line: 1,
            column: 0
        },
        end: {
            line: 1,
            column: 22
        }
    },
    program: {
        type: 'Program',
        start: 0,
        end: 22,
        loc: {
            start: {
                line: 1,
                column: 0
            },
            end: {
                line: 1,
                column: 22
            }
        },
        sourceType: 'module',
        body: [
            {
                type: 'ExpressionStatement',
                start: 0,
                end: 22,
                loc: {
                    start: {
                        line: 1,
                        column: 0
                    },
                    end: {
                        line: 1,
                        column: 22
                    }
                },
                expression: {
                    type: 'CallExpression',
                    start: 0,
                    end: 22,
                    loc: {
                        start: {
                            line: 1,
                            column: 0
                        },
                        end: {
                            line: 1,
                            column: 22
                        }
                    },
                    callee: {
                        type: 'Identifier',
                        start: 0,
                        end: 4,
                        loc: {
                            start: {
                                line: 1,
                                column: 0
                            },
                            end: {
                                line: 1,
                                column: 4
                            },
                            identifierName: 'from'
                        },
                        name: 'from'
                    },
                    arguments: [
                        {
                            type: 'ObjectExpression',
                            start: 5,
                            end: 21,
                            loc: {
                                start: {
                                    line: 1,
                                    column: 5
                                },
                                end: {
                                    line: 1,
                                    column: 21
                                }
                            },
                            properties: [
                                {
                                    type: 'ObjectProperty',
                                    start: 6,
                                    end: 20,
                                    loc: {
                                        start: {
                                            line: 1,
                                            column: 6
                                        },
                                        end: {
                                            line: 1,
                                            column: 20
                                        }
                                    },
                                    method: false,
                                    shorthand: false,
                                    computed: false,
                                    key: {
                                        type: 'Identifier',
                                        start: 6,
                                        end: 8,
                                        loc: {
                                            start: {
                                                line: 1,
                                                column: 6
                                            },
                                            end: {
                                                line: 1,
                                                column: 8
                                            },
                                            identifierName: 'bucket'
                                        },
                                        name: 'bucket'
                                    },
                                    value: {
                                        type: 'StringLiteral',
                                        start: 10,
                                        end: 20,
                                        loc: {
                                            start: {
                                                line: 1,
                                                column: 10
                                            },
                                            end: {
                                                line: 1,
                                                column: 20
                                            }
                                        },
                                        extra: {
                                            rawValue: 'telegraf',
                                            raw: 'telegraf'
                                        },
                                        value: 'telegraf'
                                    }
                                }
                            ]
                        }
                    ]
                }
            }
        ],
        directives: []
    }
};


const $b250ee9ebc966ba1$export$9a105a556e65c2c0 = 'invalid';
const $b250ee9ebc966ba1$export$d5414a779ebfba6b = 'nil';
const $b250ee9ebc966ba1$export$a0e01ba2ebef17f2 = 'string';
const $b250ee9ebc966ba1$export$160e8bdd97bfce3a = 'int';
const $b250ee9ebc966ba1$export$54c0d11872b7e6d4 = 'uint';
const $b250ee9ebc966ba1$export$d2b086fd1e01e03a = 'float';
const $b250ee9ebc966ba1$export$c35dd5647862f990 = 'bool';
const $b250ee9ebc966ba1$export$a9905336c0111a3a = 'time';
const $b250ee9ebc966ba1$export$bacc88974c736870 = 'duration';
const $b250ee9ebc966ba1$export$cd2b220b1ea851b2 = 'regexp';
const $b250ee9ebc966ba1$export$b119f07080a207ba = 'array';
const $b250ee9ebc966ba1$export$8b8a958a7f6f130c = 'object';
const $b250ee9ebc966ba1$export$601fe16600f10158 = 'function';


const $91d8e76238bf6e87$export$1c7eeaee47a52d37 = 40;
const $91d8e76238bf6e87$export$ce0a6532dc465f8e = 30;
const $91d8e76238bf6e87$export$756996d575b7aab7 = 170;






const $9e4606691311afaa$export$cb01122796bc0228 = ()=>{
    return (0, $f3c6a3e5c6466088$export$599f8541cd7f6f57).map(({ args: args, name: name })=>{
        const params = args.reduce((acc, { name: argName, type: type })=>{
            acc[argName] = type;
            return acc;
        }, {});
        return {
            name: name,
            params: params
        };
    });
};



const $7208e8c4ebc3918f$var$rejoinScript = (scriptLines)=>{
    return scriptLines.join('\n');
};
const $7208e8c4ebc3918f$var$insertAtLine = (lineNumber, scriptLines, textToInsert, insertOnSameLine)=>{
    const front = scriptLines.slice(0, lineNumber);
    const backStartIndex = insertOnSameLine ? lineNumber + 1 : lineNumber;
    const back = scriptLines.slice(backStartIndex);
    const updated = [
        ...front,
        textToInsert,
        ...back
    ];
    return $7208e8c4ebc3918f$var$rejoinScript(updated);
};
const $7208e8c4ebc3918f$var$getInsertLineNumber = (currentLineNumber, scriptLines)=>{
    const currentLine = scriptLines[currentLineNumber];
    // Insert on the current line if its an empty line
    if (!currentLine.trim()) return currentLineNumber;
    return currentLineNumber + 1;
};
const $7208e8c4ebc3918f$var$functionRequiresNewLine = (funcName)=>{
    switch(funcName){
        case (0, $f3c6a3e5c6466088$export$18bbd41dfe510229).name:
        case (0, $f3c6a3e5c6466088$export$36eaf5aa2923fe81).name:
            return true;
        default:
            return false;
    }
};
const $7208e8c4ebc3918f$var$formatFunctionForInsert = (funcName, fluxFunction)=>{
    if ($7208e8c4ebc3918f$var$functionRequiresNewLine(funcName)) return `\n${fluxFunction}`;
    return `  |> ${fluxFunction}`;
};
const $7208e8c4ebc3918f$var$getCursorPosition = (insertLineNumber, formattedFunction, funcName)=>{
    const ch = formattedFunction.length - 1;
    const line = $7208e8c4ebc3918f$var$functionRequiresNewLine(funcName) ? insertLineNumber + 1 : insertLineNumber;
    return {
        line: line,
        ch: ch
    };
};
const $7208e8c4ebc3918f$var$genImport = (script, funcPackage)=>{
    const importStatement = `import "${funcPackage}"`;
    if (!funcPackage || script.includes(importStatement)) return '';
    return importStatement;
};
const $7208e8c4ebc3918f$export$85773d32ea4ff940 = (currentLineNumber, currentScript, func)=>{
    const { name: name, example: example } = func;
    const scriptLines = currentScript.split('\n');
    let insertLineNumber = $7208e8c4ebc3918f$var$getInsertLineNumber(currentLineNumber, scriptLines);
    const insertOnSameLine = currentLineNumber === insertLineNumber;
    const formattedFunction = $7208e8c4ebc3918f$var$formatFunctionForInsert(name, example);
    let nextScript = $7208e8c4ebc3918f$var$insertAtLine(insertLineNumber, scriptLines, formattedFunction, insertOnSameLine);
    const importStatement = $7208e8c4ebc3918f$var$genImport(nextScript, func.package);
    if (importStatement) {
        nextScript = `${importStatement}\n${nextScript}`;
        insertLineNumber += 1;
    }
    const nextCursorPos = $7208e8c4ebc3918f$var$getCursorPosition(insertLineNumber, formattedFunction, name);
    return {
        updatedScript: nextScript,
        cursorPosition: nextCursorPos
    };
};


// Libraries

var $NdCUR = parcelRequire("NdCUR");


var $8G5JO = parcelRequire("8G5JO");
// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");
// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");
const $d6997cc2b2093cb9$var$BuilderCardHeader = (props)=>{
    const { testID: testID, children: children, className: className, onDelete: onDelete, onDragStart: onDragStart, title: title } = props;
    const classname = (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('builder-card--header', {
        [`${className}`]: className
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: classname,
        "data-test": testID ?? 'builder-card--header'
    }, onDragStart ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "builder-card--draggable",
        onDragStart: onDragStart
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "builder-card--hamburger"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h2", {
        className: "builder-card--title"
    }, title)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h2", {
        className: "builder-card--title"
    }, title), children, onDelete ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "builder-card--delete",
        onClick: onDelete
    }) : undefined);
};
var $d6997cc2b2093cb9$export$2e2bcd8739ae039 = $d6997cc2b2093cb9$var$BuilderCardHeader;


// Libraries

var $NdCUR = parcelRequire("NdCUR");

class $898e3b234890bb6b$export$2e2bcd8739ae039 extends (0, $NdCUR.PureComponent) {
    static{
        this.defaultProps = {
            testID: 'builder-card--header'
        };
    }
    render() {
        const { children: children, options: options, onSelect: onSelect, selectedOption: selectedOption, testID: testID } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "builder-card--header",
            "data-test": testID
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ca4f14339173643c$export$931cbfb6bfb85fc), {
            items: options.map((x)=>({
                    text: x
                })),
            onChoose: ({ text: text })=>onSelect(text),
            selected: selectedOption,
            buttonSize: "btn-sm",
            className: "dropdown-stretch",
            "data-test": "select-option-dropdown"
        }), children, this.deleteButton);
    }
    get deleteButton() {
        const { onDelete: onDelete } = this.props;
        if (onDelete) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "builder-card--delete",
            onClick: onDelete
        });
    }
}


// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");
const $db82a95d84aca02b$var$BuilderCardMenu = (props)=>{
    const { testID: testID, children: children, className: className } = props;
    const classname = (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('builder-card--menu', {
        [`${className}`]: className
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: classname,
        "data-test": testID ?? 'builder-card--menu'
    }, children);
};
var $db82a95d84aca02b$export$2e2bcd8739ae039 = $db82a95d84aca02b$var$BuilderCardMenu;


// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");

class $5174515d98a1ff0f$export$2e2bcd8739ae039 extends (0, $NdCUR.PureComponent) {
    static{
        this.defaultProps = {
            scrollable: true,
            addPadding: true,
            testID: 'builder-card--body',
            autoHideScrollbars: false
        };
    }
    render() {
        const { scrollable: scrollable, testID: testID, autoHideScrollbars: autoHideScrollbars, style: style, className: className } = this.props;
        if (scrollable) {
            const scrollbarStyles = {
                maxWidth: '100%',
                maxHeight: '100%',
                ...style
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), {
                className: "builder-card--body",
                style: scrollbarStyles,
                "data-test": testID,
                autoHide: autoHideScrollbars
            }, this.children);
        }
        const classname = (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('builder-card--body', {
            [`${className}`]: className
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: classname,
            "data-test": testID,
            style: style
        }, this.children);
    }
    get children() {
        const { addPadding: addPadding, children: children } = this.props;
        if (addPadding) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "builder-card--contents"
        }, children);
        return children;
    }
}


// Libraries

var $NdCUR = parcelRequire("NdCUR");
const $535b9a5022807aa1$var$BuilderCardEmpty = (props)=>{
    const { testID: testID, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "builder-card--body builder-card--empty",
        "data-test": testID ?? 'builder-card--empty'
    }, children);
};
var $535b9a5022807aa1$export$2e2bcd8739ae039 = $535b9a5022807aa1$var$BuilderCardEmpty;


class $702c1c2288ff3dba$export$2e2bcd8739ae039 extends (0, $NdCUR.PureComponent) {
    static{
        this.Header = (0, $d6997cc2b2093cb9$export$2e2bcd8739ae039);
    }
    static{
        this.DropdownHeader = (0, $898e3b234890bb6b$export$2e2bcd8739ae039);
    }
    static{
        this.Menu = (0, $db82a95d84aca02b$export$2e2bcd8739ae039);
    }
    static{
        this.Body = (0, $5174515d98a1ff0f$export$2e2bcd8739ae039);
    }
    static{
        this.Empty = (0, $535b9a5022807aa1$export$2e2bcd8739ae039);
    }
    static{
        this.defaultProps = {
            testID: 'builder-card',
            widthPixels: 228
        };
    }
    render() {
        const { children: children, testID: testID, className: className, widthPixels: widthPixels } = this.props;
        const classname = (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('builder-card', {
            [`${className}`]: className
        });
        const style = {
            flex: `0 0 ${widthPixels}px`
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: classname,
            "data-test": testID,
            style: style
        }, children);
    }
}


// Libraries

var $NdCUR = parcelRequire("NdCUR");


var $1v7mg = parcelRequire("1v7mg");


/* eslint-disable @typescript-eslint/no-redundant-type-constituents */ 

// APIs

function $4901d8e53292d5c4$var$tagSelectionKey(tags) {
    return tags.map((x)=>({
            k: x.tagKey || '',
            v: x.tagValues || [],
            t: x.aggregateFunctionType
        }));
}
class $4901d8e53292d5c4$var$QueryBuilderFetcher {
    async findBuckets(source, options = {
        limit: Number.MAX_SAFE_INTEGER
    }) {
        this.cancelFindBuckets();
        const cacheKey = source.id;
        const cachedResult = this.findBucketsCache[cacheKey];
        if (cachedResult && options.limit <= cachedResult.limit) return Promise.resolve({
            result: cachedResult.result,
            truncated: cachedResult.truncated
        });
        const pendingResult = (0, $afe396ec0883bd0e$export$10fe5cbd6698f9ce)(source, options);
        this.findBucketsQuery = pendingResult;
        pendingResult.promise.then((t)=>{
            this.findBucketsCache[cacheKey] = {
                result: t.result,
                truncated: t.truncated,
                limit: options.limit
            };
        }).catch(()=>{});
        return pendingResult.promise;
    }
    cancelFindBuckets() {
        if (this.findBucketsQuery) {
            this.findBucketsQuery.cancel();
            this.findBucketsQuery = undefined;
        }
    }
    async findKeys(tagIndex, options) {
        this.cancelFindKeys(tagIndex);
        const { source: source, tagsSelections: tagsSelections, limit: limit, ...rest } = options;
        const cacheKey = JSON.stringify({
            id: source.id,
            tags: $4901d8e53292d5c4$var$tagSelectionKey(tagsSelections),
            ...rest
        });
        const cachedResult = this.findKeysCache[cacheKey];
        if (cachedResult && limit <= cachedResult.limit) return Promise.resolve({
            result: [
                ...cachedResult.result
            ],
            truncated: cachedResult.truncated
        });
        const pendingResult = (0, $afe396ec0883bd0e$export$8382f3d8ef168792)(options);
        this.findKeysQueries[tagIndex] = pendingResult;
        pendingResult.promise = pendingResult.promise.then((t)=>{
            this.findKeysCache[cacheKey] = {
                result: [
                    ...t.result
                ],
                truncated: t.truncated,
                limit: limit
            };
            return t;
        });
        return pendingResult.promise;
    }
    cancelFindKeys(tagIndex) {
        if (this.findKeysQueries[tagIndex]) {
            this.findKeysQueries[tagIndex].cancel();
            this.findKeysQueries[tagIndex] = undefined;
        }
    }
    async findValues(tagIndex, options) {
        this.cancelFindValues(tagIndex);
        if (!options.key) // return no values for no key
        return {
            result: [],
            truncated: false
        };
        const { source: source, tagsSelections: tagsSelections, limit: limit, ...rest } = options;
        const cacheKey = JSON.stringify({
            id: source.id,
            tags: $4901d8e53292d5c4$var$tagSelectionKey(tagsSelections),
            ...rest
        });
        const cachedResult = this.findValuesCache[cacheKey];
        if (cachedResult && limit <= cachedResult.limit) return Promise.resolve({
            result: [
                ...cachedResult.result
            ],
            truncated: cachedResult.truncated
        });
        const pendingResult = (0, $afe396ec0883bd0e$export$a8f1a400fa0f8036)(options);
        this.findValuesQueries[tagIndex] = pendingResult;
        pendingResult.promise = pendingResult.promise.then((t)=>{
            this.findValuesCache[cacheKey] = {
                result: [
                    ...t.result
                ],
                truncated: t.truncated,
                limit: limit
            };
            return t;
        });
        return pendingResult.promise;
    }
    cancelFindValues(tagIndex) {
        if (this.findValuesQueries[tagIndex]) {
            this.findValuesQueries[tagIndex].cancel();
            this.findValuesQueries[tagIndex] = undefined;
        }
    }
    cancelPendingQueries() {
        this.cancelFindBuckets();
        this.findKeysQueries.forEach((_, i)=>this.cancelFindKeys(i));
        this.findKeysQueries = [];
        this.findValuesQueries.forEach((_, i)=>this.cancelFindValues(i));
        this.findValuesQueries = [];
    }
    clearCache() {
        this.cancelPendingQueries();
        this.findBucketsCache = {};
        this.findKeysCache = {};
        this.findValuesCache = {};
    }
    constructor(){
        this.findKeysQueries = [];
        this.findValuesQueries = [];
        this.findKeysCache = {};
        this.findValuesCache = {};
        this.findBucketsCache = {};
    }
}
const $4901d8e53292d5c4$var$queryBuilderFetcher = new $4901d8e53292d5c4$var$QueryBuilderFetcher();
var $4901d8e53292d5c4$export$2e2bcd8739ae039 = $4901d8e53292d5c4$var$queryBuilderFetcher;


function $8708d281d7bbd5c0$export$6d4b83b6e666beb5() {
    return {
        type: 'FQB_TAG_ADD'
    };
}
function $8708d281d7bbd5c0$export$acf9ac22b41b4977(tagIndex) {
    return {
        type: 'FQB_TAG_REMOVE',
        payload: {
            tagIndex: tagIndex
        }
    };
}
function $8708d281d7bbd5c0$export$dbcdef796e8f314c(tagIndex, type) {
    return {
        type: 'FQB_TAG_CHANGE_TYPE',
        payload: {
            tagIndex: tagIndex,
            type: type
        }
    };
}
function $8708d281d7bbd5c0$export$aad8462122ac592b() {
    return {
        type: 'FQB_TAG_RESET'
    };
}
function $8708d281d7bbd5c0$export$5d0cfdc259377591(tagIndex, key) {
    return {
        type: 'FQB_TAG_SELECT_KEY',
        payload: {
            tagIndex: tagIndex,
            key: key
        }
    };
}
function $8708d281d7bbd5c0$export$af6b9fa63775877a(tagIndex, term) {
    return {
        type: 'FQB_TAG_CHANGE_KEY_SEARCHTERM',
        payload: {
            tagIndex: tagIndex,
            term: term
        }
    };
}
function $8708d281d7bbd5c0$export$6cc5734d6d8bd949(tagIndex) {
    return {
        type: 'FQB_TAG_INC_KEYS_LIMIT',
        payload: {
            tagIndex: tagIndex
        }
    };
}
function $8708d281d7bbd5c0$export$7b45cbfd4fd1e917(tagIndex) {
    return {
        type: 'FQB_TAG_SEARCH_KEY',
        payload: {
            tagIndex: tagIndex
        }
    };
}
function $8708d281d7bbd5c0$export$3f231e293fccc8de(tagIndex, values) {
    return {
        type: 'FQB_TAG_SELECT_VALUES',
        payload: {
            tagIndex: tagIndex,
            values: values
        }
    };
}
function $8708d281d7bbd5c0$export$29135ce0a7d788aa(tagIndex, term) {
    return {
        type: 'FQB_TAG_CHANGE_VALUES_SEARCHTERM',
        payload: {
            tagIndex: tagIndex,
            term: term
        }
    };
}
function $8708d281d7bbd5c0$export$447ca5b786ca7b12(tagIndex) {
    return {
        type: 'FQB_TAG_INC_VALUES_LIMIT',
        payload: {
            tagIndex: tagIndex
        }
    };
}
function $8708d281d7bbd5c0$export$9fd50a7417362ec1(tagIndex) {
    return {
        type: 'FQB_TAG_SEARCH_VALUES',
        payload: {
            tagIndex: tagIndex
        }
    };
}
function $8708d281d7bbd5c0$export$53eddf643269f78f(tagIndex, status) {
    return {
        type: 'FQB_TAG_KEY_STATUS',
        payload: {
            tagIndex: tagIndex,
            status: status
        }
    };
}
function $8708d281d7bbd5c0$export$8a0013bdc2a3c6b2(tagIndex, status) {
    return {
        type: 'FQB_TAG_VALUES_STATUS',
        payload: {
            tagIndex: tagIndex,
            status: status
        }
    };
}
function $8708d281d7bbd5c0$export$f66857f70258f506(tagIndex, keys, truncated) {
    return {
        type: 'FQB_TAG_KEYS',
        payload: {
            tagIndex: tagIndex,
            keys: keys,
            truncated: truncated
        }
    };
}
function $8708d281d7bbd5c0$export$b7771d60d308862f(tagIndex, values, truncated) {
    return {
        type: 'FQB_TAG_VALUES',
        payload: {
            tagIndex: tagIndex,
            values: values,
            truncated: truncated
        }
    };
}


function $499ffd7d99ff78f4$export$26e50de7604198fd(term) {
    return {
        type: 'FQB_BUCKETS_SEARCH_TERM',
        payload: {
            term: term
        }
    };
}
function $499ffd7d99ff78f4$export$a05788ede9342153(status) {
    return {
        type: 'FQB_BUCKETS_STATUS',
        payload: {
            status: status
        }
    };
}
function $499ffd7d99ff78f4$export$1ba836070c3ab52a(buckets) {
    return {
        type: 'FQB_BUCKETS_BUCKETS',
        payload: {
            buckets: buckets
        }
    };
}
function $499ffd7d99ff78f4$export$a32cef080dc5e6d2(bucket) {
    return {
        type: 'FQB_BUCKETS_SELECT',
        payload: {
            bucket: bucket
        }
    };
}
function $499ffd7d99ff78f4$export$409812c57221e3d8(term) {
    return {
        type: 'FQB_BUCKETS_FILTER',
        payload: {
            term: term
        }
    };
}


// We don't show these columns in results but they're able to be grouped on for most queries
const $5a9dce3ec2c239f0$var$ADDITIONAL_GROUP_BY_COLUMNS = [
    '_start',
    '_stop',
    '_time'
];
const $5a9dce3ec2c239f0$export$8bc32d5b7ddb7e19 = (source, timeRange, tagIndex)=>(dispatch)=>{
        (0, $4901d8e53292d5c4$export$2e2bcd8739ae039).cancelFindValues(tagIndex);
        (0, $4901d8e53292d5c4$export$2e2bcd8739ae039).cancelFindKeys(tagIndex);
        dispatch($8708d281d7bbd5c0$export$acf9ac22b41b4977(tagIndex));
        dispatch($5a9dce3ec2c239f0$export$5630c26e8d274fc8(source, timeRange, tagIndex));
    };
const $5a9dce3ec2c239f0$export$5630c26e8d274fc8 = (source, timeRange, tagIndex)=>async (dispatch, getState)=>{
        const { fluxQueryBuilder: { tags: tags, buckets: { selectedBucket: selectedBucket } } } = getState();
        if (tagIndex < 0 || !tags[tagIndex] || !selectedBucket) return;
        const tagState = tags[tagIndex];
        try {
            if (tagState.aggregateFunctionType === 'filter') {
                const searchTerm = tagState.keysSearchTerm;
                dispatch($8708d281d7bbd5c0$export$53eddf643269f78f(tagIndex, (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading));
                const { result: keys, truncated: truncated } = await (0, $4901d8e53292d5c4$export$2e2bcd8739ae039).findKeys(tagIndex, {
                    source: source,
                    bucket: selectedBucket,
                    searchTerm: searchTerm,
                    timeRange: timeRange,
                    tagsSelections: tags.slice(0, tagIndex).filter((x)=>x.aggregateFunctionType === 'filter'),
                    limit: tagState.keysLimit
                });
                const { tagKey: key } = tagState;
                if (!key) {
                    let defaultKey;
                    if (tagIndex === 0 && keys.includes('_measurement')) defaultKey = '_measurement';
                    else if (keys.includes('_field')) defaultKey = '_field';
                    else defaultKey = keys[0];
                    dispatch($8708d281d7bbd5c0$export$5d0cfdc259377591(tagIndex, defaultKey));
                } else if (!keys.includes(key)) // Even if the selected key didn't come back in the results, let it be
                // selected anyway
                keys.unshift(key);
                dispatch($8708d281d7bbd5c0$export$f66857f70258f506(tagIndex, keys, truncated));
            }
            dispatch($5a9dce3ec2c239f0$var$loadTagSelectorValuesThunk(source, timeRange, tagIndex));
        } catch (e) {
            if ((0, $d96f38380b9b4c62$export$2b3d06107d1323d4)(e)) return;
            console.error(e);
            dispatch($8708d281d7bbd5c0$export$53eddf643269f78f(tagIndex, (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error));
        }
    };
const $5a9dce3ec2c239f0$var$loadTagSelectorValuesThunk = (source, timeRange, tagIndex)=>async (dispatch, getState)=>{
        const { fluxQueryBuilder: { tags: tags, buckets: { selectedBucket: selectedBucket } } } = getState();
        if (tagIndex < 0 || !tags[tagIndex] || !selectedBucket) return;
        const tagState = tags[tagIndex];
        try {
            let values;
            let valuesTruncated = false;
            const originalSelected = tagState.tagValues || [];
            let selectedValues = originalSelected;
            if (tagState.aggregateFunctionType === 'filter') {
                dispatch($8708d281d7bbd5c0$export$8a0013bdc2a3c6b2(tagIndex, (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading));
                if (tagState.tagKey) {
                    const data = await (0, $4901d8e53292d5c4$export$2e2bcd8739ae039).findValues(tagIndex, {
                        source: source,
                        bucket: selectedBucket,
                        tagsSelections: tags.slice(0, tagIndex).filter((x)=>x.aggregateFunctionType === 'filter'),
                        key: tagState.tagKey,
                        searchTerm: tagState.valuesSearchTerm,
                        timeRange: timeRange,
                        limit: tagState.valuesLimit
                    });
                    values = data.result;
                    valuesTruncated = data.truncated;
                    for (const selectedValue of tagState.tagValues)// Even if the selected values didn't come back in the results, let them
                    // be selected anyway
                    if (!values.includes(selectedValue)) values.unshift(selectedValue);
                } else {
                    values = [];
                    selectedValues = originalSelected.length ? [] : originalSelected;
                }
            } else {
                values = tags.slice(0, tagIndex).reduce((acc, tag)=>{
                    if (tag.aggregateFunctionType === 'filter' && tag.tagKey) acc.push(tag.tagKey);
                    return acc;
                }, []);
                values = [
                    ...values,
                    ...$5a9dce3ec2c239f0$var$ADDITIONAL_GROUP_BY_COLUMNS
                ];
                const valuesSearchTerm = (tagState.valuesSearchTerm || '').toLowerCase();
                values = values.filter((x)=>x.includes(valuesSearchTerm));
                selectedValues = tagState.tagValues.filter((x)=>values.includes(x));
            }
            dispatch($8708d281d7bbd5c0$export$b7771d60d308862f(tagIndex, values, valuesTruncated));
            if (selectedValues !== originalSelected) dispatch($8708d281d7bbd5c0$export$3f231e293fccc8de(tagIndex, selectedValues));
            dispatch($5a9dce3ec2c239f0$export$5630c26e8d274fc8(source, timeRange, tagIndex + 1));
        } catch (e) {
            if ((0, $d96f38380b9b4c62$export$2b3d06107d1323d4)(e)) return;
            console.error(e);
            dispatch($8708d281d7bbd5c0$export$8a0013bdc2a3c6b2(tagIndex, (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error));
        }
    };
const $5a9dce3ec2c239f0$export$de9de675b33a1462 = (source, timeRange)=>async (dispatch, getState)=>{
        dispatch($499ffd7d99ff78f4$export$a05788ede9342153((0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading));
        try {
            const { result: allBuckets } = await (0, $4901d8e53292d5c4$export$2e2bcd8739ae039).findBuckets(source);
            const systemBuckets = allBuckets.filter((b)=>b.startsWith('_'));
            const userBuckets = allBuckets.filter((b)=>!b.startsWith('_'));
            const buckets = [
                ...userBuckets,
                ...systemBuckets
            ];
            dispatch($499ffd7d99ff78f4$export$1ba836070c3ab52a(buckets));
            dispatch($499ffd7d99ff78f4$export$a05788ede9342153((0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done));
            const { fluxQueryBuilder: { buckets: { selectedBucket: selectedBucket } } } = getState();
            if (selectedBucket && buckets.includes(selectedBucket)) dispatch($5a9dce3ec2c239f0$export$5a77dfa862942d6b(source, timeRange, selectedBucket));
            else dispatch($5a9dce3ec2c239f0$export$5a77dfa862942d6b(source, timeRange, buckets[0], true));
        } catch (e) {
            if (e.name === 'CancellationError') return;
            console.error(e);
            dispatch($499ffd7d99ff78f4$export$a05788ede9342153((0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error));
        }
    };
const $5a9dce3ec2c239f0$export$5a77dfa862942d6b = (source, timeRange, bucket, resetSelections = false)=>(dispatch)=>{
        dispatch($499ffd7d99ff78f4$export$a32cef080dc5e6d2(bucket));
        if (resetSelections) {
            (0, $4901d8e53292d5c4$export$2e2bcd8739ae039).cancelPendingQueries();
            dispatch($8708d281d7bbd5c0$export$aad8462122ac592b());
        }
        dispatch($5a9dce3ec2c239f0$export$5630c26e8d274fc8(source, timeRange, 0));
    };
const $5a9dce3ec2c239f0$export$1fae024c760db276 = (source, timeRange, tagIndex, key)=>(dispatch)=>{
        dispatch($8708d281d7bbd5c0$export$5d0cfdc259377591(tagIndex, key));
        dispatch($5a9dce3ec2c239f0$var$loadTagSelectorValuesThunk(source, timeRange, tagIndex));
    };
const $5a9dce3ec2c239f0$export$f1e58c4c62aeb4df = (source, timeRange, tagIndex, values)=>(dispatch, getState)=>{
        const { fluxQueryBuilder: { tags: tags } } = getState();
        const currentTag = tags[tagIndex];
        if (!currentTag) return;
        dispatch($8708d281d7bbd5c0$export$3f231e293fccc8de(tagIndex, values));
        // don't add a new tag filter if we're grouping
        if (currentTag.aggregateFunctionType === 'group') return;
        if (tagIndex === tags.length - 1 && values.length) dispatch($5a9dce3ec2c239f0$export$b24c3519ffe97b76(source, timeRange));
        else dispatch($5a9dce3ec2c239f0$export$5630c26e8d274fc8(source, timeRange, tagIndex + 1));
    };
const $5a9dce3ec2c239f0$export$b24c3519ffe97b76 = (source, timeRange)=>(dispatch, getState)=>{
        dispatch($8708d281d7bbd5c0$export$6d4b83b6e666beb5());
        const { fluxQueryBuilder: { tags: tags } } = getState();
        dispatch($5a9dce3ec2c239f0$export$5630c26e8d274fc8(source, timeRange, tags[tags.length - 1].tagIndex));
    };
const $5a9dce3ec2c239f0$export$dd2e52bf4495adbf = (source, timeRange, tagIndex)=>(dispatch)=>{
        dispatch($5a9dce3ec2c239f0$var$loadTagSelectorValuesThunk(source, timeRange, tagIndex));
    };
const $5a9dce3ec2c239f0$export$23c742dbcc1607c9 = (source, timeRange, tagIndex)=>(dispatch)=>{
        dispatch($5a9dce3ec2c239f0$export$5630c26e8d274fc8(source, timeRange, tagIndex));
    };
const $5a9dce3ec2c239f0$export$9e73223bd001c934 = (source, timeRange, tagIndex, type)=>(dispatch)=>{
        dispatch($8708d281d7bbd5c0$export$dbcdef796e8f314c(tagIndex, type));
        dispatch($5a9dce3ec2c239f0$export$5630c26e8d274fc8(source, timeRange, tagIndex));
    };



const $f9063f233abfc788$var$filterBuckets = (buckets, term)=>{
    const searchTerm = term.toLocaleLowerCase();
    let list = buckets.filter((bucket)=>bucket.toLocaleLowerCase().includes(searchTerm));
    if (list.length > 200) list = list.slice(0, 200);
    return list;
};
const $f9063f233abfc788$var$BucketsSelector = ({ source: source, timeRange: timeRange, selectedBucket: selectedBucket, buckets: passedBuckets, status: status, searchTerm: searchTerm, onSelectBucket: onSelectBucket, onFilterBuckets: onFilterBuckets })=>{
    if (status === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done) {
        if (!passedBuckets.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $702c1c2288ff3dba$export$2e2bcd8739ae039).Empty, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("i", null, "No buckets found"));
        const buckets = (0, $NdCUR.useMemo)(()=>{
            return $f9063f233abfc788$var$filterBuckets(passedBuckets, searchTerm);
        }, [
            passedBuckets,
            searchTerm
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $702c1c2288ff3dba$export$2e2bcd8739ae039).Menu, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control input-sm",
            placeholder: "Search for a bucket",
            type: "text",
            value: searchTerm,
            onChange: (e)=>onFilterBuckets(e.target.value),
            onKeyUp: (e)=>{
                if (e.key === 'Escape') {
                    e.stopPropagation();
                    onFilterBuckets('');
                }
            },
            spellCheck: false,
            autoComplete: "false"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $702c1c2288ff3dba$export$2e2bcd8739ae039).Body, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-query-builder--list"
        }, buckets.map((bucket)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('flux-query-builder--list-item', {
                    active: bucket === selectedBucket
                }),
                onClick: ()=>onSelectBucket(source, timeRange, bucket, true),
                key: bucket
            }, bucket)))));
    }
    if (status === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $702c1c2288ff3dba$export$2e2bcd8739ae039).Empty, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("i", null, "Failed to load buckets"));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $702c1c2288ff3dba$export$2e2bcd8739ae039).Empty, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("i", null, "Loading Buckets"));
};
const $f9063f233abfc788$var$InitializeBucketsSelector = (props)=>{
    (0, $NdCUR.useEffect)(()=>{
        props.onLoadBuckets(props.source, props.timeRange);
    }, [
        props.source,
        props.timeRange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($f9063f233abfc788$var$BucketsSelector, props);
};
const $f9063f233abfc788$var$mstp = (state)=>{
    return state?.fluxQueryBuilder?.buckets;
};
const $f9063f233abfc788$var$mdtp = {
    onLoadBuckets: (0, $5a9dce3ec2c239f0$export$de9de675b33a1462),
    onFilterBuckets: (0, $499ffd7d99ff78f4$export$26e50de7604198fd),
    onSelectBucket: (0, $5a9dce3ec2c239f0$export$5a77dfa862942d6b)
};
const $f9063f233abfc788$var$connector = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($f9063f233abfc788$var$mstp, $f9063f233abfc788$var$mdtp);
var $f9063f233abfc788$export$2e2bcd8739ae039 = $f9063f233abfc788$var$connector($f9063f233abfc788$var$InitializeBucketsSelector);





var $NdCUR = parcelRequire("NdCUR");






var $NdCUR = parcelRequire("NdCUR");






function $f8749795aab7496c$var$isDurationParseable(duration) {
    const durationRegExp = /^(?:[1-9][0-9]*(?:y|mo|w|d|h|ms|s|m|us|µs|ns))+$/g;
    return !!duration.match(durationRegExp);
}
const $f8749795aab7496c$var$WindowPeriod = ({ selected: selected, autoPeriod: autoPeriod, onChoose: onChoose })=>{
    const [customDuration, setCustomDuration] = (0, $NdCUR.useState)(undefined);
    let items = (0, $4d8b66f6adad74a3$export$74f6a832d246e098);
    const autoValue = `auto (${autoPeriod})`;
    if (selected === (0, $4d8b66f6adad74a3$export$3eff6d3d8f7c566)) selected = autoValue;
    if (!items.includes(selected) && selected !== autoValue) {
        const selectedText = `custom (${selected})`;
        items = [
            {
                text: selectedText,
                value: selected
            },
            ...items
        ];
        selected = selectedText;
    } else items = [
        `custom`,
        ...items
    ];
    items = [
        autoValue,
        ...items
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%'
        }
    }, customDuration !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($f8749795aab7496c$var$CustomDurationInput, {
        customDuration: customDuration,
        setCustomDuration: setCustomDuration,
        onChoose: onChoose
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ca4f14339173643c$export$2e2bcd8739ae039), {
        items: items,
        onChoose: ({ text: text, value: value })=>{
            if (text.startsWith('custom')) {
                setCustomDuration(value ?? '');
                return;
            }
            onChoose(text.startsWith((0, $4d8b66f6adad74a3$export$3eff6d3d8f7c566)) ? (0, $4d8b66f6adad74a3$export$3eff6d3d8f7c566) : text);
        },
        selected: selected,
        buttonSize: "btn-sm",
        className: "dropdown-stretch"
    }));
};
class $f8749795aab7496c$var$DurationInput extends (0, $NdCUR.PureComponent) {
    render() {
        const { customDuration: customDuration, setCustomDuration: setCustomDuration, onChoose: onChoose } = this.props;
        const valid = $f8749795aab7496c$var$isDurationParseable(customDuration);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1f11d3536bc98f8a$export$c16e4f034c84cb3f), {
            onClickOutside: this.handleClickOutside
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control input-sm",
            placeholder: "Enter custom duration",
            type: "text",
            style: valid ? undefined : {
                border: '2px solid #F95F53'
            },
            value: customDuration,
            onChange: (e)=>setCustomDuration(e.target.value),
            onKeyUp: (e)=>{
                if (e.key === 'Escape') {
                    e.stopPropagation();
                    setCustomDuration(undefined);
                }
                if (e.key === 'Enter') {
                    e.stopPropagation();
                    if (valid) {
                        setCustomDuration(undefined);
                        onChoose(customDuration);
                    } else this.props.notify((0, $ec1f42de4faacc37$export$c312505591a86529)(`Invalid flux duration: ${customDuration}`));
                }
            },
            onFocus: (e)=>e.target.select(),
            spellCheck: false,
            autoComplete: "false",
            autoFocus: true
        }));
    }
    constructor(...args){
        super(...args), this.handleClickOutside = ()=>{
            this.props.setCustomDuration(undefined);
        };
    }
}
const $f8749795aab7496c$var$CustomDurationInput = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)(null, {
    notify: (0, $205d139de2918454$export$5e14cdade93d6f7b)
})($f8749795aab7496c$var$DurationInput);
var $f8749795aab7496c$export$2e2bcd8739ae039 = $f8749795aab7496c$var$WindowPeriod;



function $39668681a3cda9db$export$4906c4c86003f5c(period) {
    return {
        type: 'FQB_AGG_PERIOD',
        payload: {
            period: period
        }
    };
}
function $39668681a3cda9db$export$626b001356fa4fc1(fillMissing) {
    return {
        type: 'FQB_AGG_FILL_MISSING',
        payload: {
            fillMissing: fillMissing
        }
    };
}
function $39668681a3cda9db$export$432b22c7198e4dcf(functions) {
    return {
        type: 'FQB_AGG_SELECTED_FNS',
        payload: {
            functions: functions
        }
    };
}
const $39668681a3cda9db$export$bcebe9548ee9dd37 = {
    setFillMissing: $39668681a3cda9db$export$626b001356fa4fc1,
    setPeriod: $39668681a3cda9db$export$4906c4c86003f5c,
    setSelectedFunctions: $39668681a3cda9db$export$432b22c7198e4dcf
};


const $fad4f9add39928d5$var$AggregationSelector = (props)=>{
    const { defaultPeriod: defaultPeriod, period: period, fillMissing: fillMissing, selectedFunctions: selectedFunctions, setPeriod: setPeriod, setFillMissing: setFillMissing, setSelectedFunctions: setSelectedFunctions } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $702c1c2288ff3dba$export$2e2bcd8739ae039), {
        className: "aggregation-selector",
        testID: "aggregation-selector"
    }, props.children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $702c1c2288ff3dba$export$2e2bcd8739ae039).Header, {
        title: "Window Period",
        className: "aggregation-selector-header"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $702c1c2288ff3dba$export$2e2bcd8739ae039).Body, {
        scrollable: false,
        addPadding: false,
        className: "aggregation-selector-body"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            width: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $f8749795aab7496c$export$2e2bcd8739ae039), {
        autoPeriod: defaultPeriod,
        selected: period,
        onChoose: setPeriod
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            marginTop: '3px',
            alignItems: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $4115c6d17e8dc56b$export$2e2bcd8739ae039), {
        size: (0, $918c9f03a35fe03f$export$fafce5c139da9687).ExtraSmall,
        active: fillMissing,
        onChange: ()=>setFillMissing(!fillMissing)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        style: {
            paddingLeft: '5px'
        }
    }, "Fill Missing Values"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        style: {
            paddingLeft: '5px',
            flexGrow: 1,
            display: 'flex',
            justifyContent: 'flex-end'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        "data-tip": "For windows without data, create an empty window and fill it with a null aggregate value"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        style: {
            borderRadius: '50%',
            backgroundColor: '#bec2cc',
            color: '#0f0e15',
            width: '17px',
            height: '17px',
            display: 'inline-block',
            textAlign: 'center',
            lineHeight: '18px',
            fontWeight: 900,
            cursor: 'default'
        }
    }, "?")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $82a18451bb6f6ba0$export$2e2bcd8739ae039), {
        effect: "solid",
        html: false,
        place: "left",
        class: "influx-tooltip"
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $702c1c2288ff3dba$export$2e2bcd8739ae039).Header, {
        title: "Aggregate Function",
        className: "aggregation-selector-header"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $702c1c2288ff3dba$export$2e2bcd8739ae039).Body, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "flux-query-builder--list"
    }, (0, $4d8b66f6adad74a3$export$42db895a6297a476).map((fn)=>{
        const active = selectedFunctions.includes(fn);
        const onChange = ()=>{
            const newSelected = active ? selectedFunctions.filter((x)=>x !== fn) : [
                fn,
                ...selectedFunctions
            ];
            setSelectedFunctions(newSelected);
        };
        const id = `flx-agrselect${fn}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-query-builder--list-item compact",
            onClick: onChange,
            key: id,
            id: id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            type: "checkbox",
            checked: active,
            onChange: onChange
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: id
        }, fn));
    }))));
};
const $fad4f9add39928d5$var$mstp = (state)=>{
    return state?.fluxQueryBuilder?.aggregation;
};
const $fad4f9add39928d5$var$mdtp = {
    notify: (0, $205d139de2918454$export$5e14cdade93d6f7b),
    setFillMissing: (0, $39668681a3cda9db$export$bcebe9548ee9dd37).setFillMissing,
    setPeriod: (0, $39668681a3cda9db$export$bcebe9548ee9dd37).setPeriod,
    setSelectedFunctions: (0, $39668681a3cda9db$export$bcebe9548ee9dd37).setSelectedFunctions
};
var $fad4f9add39928d5$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($fad4f9add39928d5$var$mstp, $fad4f9add39928d5$var$mdtp)($fad4f9add39928d5$var$AggregationSelector);



var $NdCUR = parcelRequire("NdCUR");





var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");





class $75d219277bc3d571$var$SearchableDropdown extends (0, $NdCUR.Component) {
    static{
        this.defaultProps = {
            actions: [],
            searchTerm: '',
            buttonSize: 'btn-sm',
            buttonColor: 'btn-default',
            menuWidth: '100%',
            disabled: false,
            tabIndex: 0
        };
    }
    constructor(props){
        super(props), this.handleClickOutside = ()=>{
            this.setState({
                isOpen: false
            });
        }, this.handleSelection = (item)=>()=>{
                this.toggleMenu();
                this.props.onChoose(item.text);
                this.dropdownRef.focus();
            }, this.handleHighlight = (itemIndex)=>()=>{
                this.setState({
                    highlightedItemIndex: itemIndex
                });
            }, this.toggleMenu = (e)=>{
            if (e) e.stopPropagation();
            if (!this.state.isOpen) this.setState({
                highlightedItemIndex: null
            });
            this.setState({
                isOpen: !this.state.isOpen
            });
        }, this.handleAction = (action, item)=>(e)=>{
                e.stopPropagation();
                action.handler(item);
            }, this.handleFilterKeyPress = (e)=>{
            const { items: items } = this.props;
            const { highlightedItemIndex: highlightedItemIndex } = this.state;
            if (e.key === 'Enter' && items.length) {
                this.setState({
                    isOpen: false
                });
                this.props.onChoose(items[highlightedItemIndex]);
            }
            if (e.key === 'Escape') this.setState({
                isOpen: false
            });
            if (e.key === 'ArrowUp' && highlightedItemIndex > 0) this.setState({
                highlightedItemIndex: highlightedItemIndex - 1
            });
            if (e.key === 'ArrowDown') {
                if (highlightedItemIndex < items.length - 1) this.setState({
                    highlightedItemIndex: highlightedItemIndex + 1
                });
                if (highlightedItemIndex === null && items.length) this.setState({
                    highlightedItemIndex: 0
                });
            }
        }, this.handleFilterChange = (e)=>{
            this.props.onChangeSearchTerm(e.target.value);
            this.setState({
                highlightedItemIndex: null
            });
        }, this.handleClick = (e)=>{
            const { disabled: disabled, onClick: onClick } = this.props;
            if (disabled) return;
            this.toggleMenu(e);
            if (onClick) onClick(e);
        };
        this.state = {
            isOpen: false,
            highlightedItemIndex: null
        };
    }
    render() {
        const { items: items, addNew: addNew, actions: actions, selected: selected, disabled: disabled, iconName: iconName, tabIndex: tabIndex, className: className, menuClass: menuClass, menuWidth: menuWidth, menuLabel: menuLabel, buttonSize: buttonSize, buttonColor: buttonColor, toggleStyle: toggleStyle, searchTerm: searchTerm } = this.props;
        const { isOpen: isOpen, highlightedItemIndex: highlightedItemIndex } = this.state;
        const menuItems = items;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            onClick: this.handleClick,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('dropdown', {
                open: isOpen,
                [className]: className
            }),
            tabIndex: tabIndex,
            ref: (r)=>this.dropdownRef = r,
            "data-test": "dropdown-toggle"
        }, isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1a3a3ccede5f85ba$export$2e2bcd8739ae039), {
            searchTerm: searchTerm,
            buttonSize: buttonSize,
            buttonColor: buttonColor,
            toggleStyle: toggleStyle,
            disabled: disabled,
            placeholder: "Search items...",
            onFilterChange: this.handleFilterChange,
            onFilterKeyPress: this.handleFilterKeyPress
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $8071b456283d6d39$export$2e2bcd8739ae039), {
            iconName: iconName,
            selected: selected,
            buttonSize: buttonSize,
            buttonColor: buttonColor,
            toggleStyle: toggleStyle,
            disabled: disabled
        }), isOpen && menuItems.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $53fa614fe011b7d9$export$2e2bcd8739ae039), {
            addNew: addNew,
            actions: actions,
            items: menuItems.map((x)=>({
                    text: x
                })),
            selected: selected,
            menuClass: menuClass,
            menuWidth: menuWidth,
            menuLabel: menuLabel,
            onAction: this.handleAction,
            useAutoComplete: true,
            onSelection: this.handleSelection,
            onHighlight: this.handleHighlight,
            highlightedItemIndex: highlightedItemIndex
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $53fa614fe011b7d9$export$da7287102a80edf6), {
            useAutoComplete: true,
            menuClass: menuClass
        }));
    }
}
var $75d219277bc3d571$export$2e2bcd8739ae039 = (0, $1636633b789d0ee3$export$2e2bcd8739ae039)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($75d219277bc3d571$var$SearchableDropdown));



var $NdCUR = parcelRequire("NdCUR");
const $2f92edf239a456bb$var$WaitingText = ({ text: text, className: className })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: `waiting-text ${className || ''}`
    }, text);
};
var $2f92edf239a456bb$export$2e2bcd8739ae039 = $2f92edf239a456bb$var$WaitingText;








const $46227f4c506c006a$var$SEARCH_DEBOUNCE_MS = 400;
function $46227f4c506c006a$var$renderType(type) {
    if (type === 'group') return 'Group';
    return 'Filter';
}
const $46227f4c506c006a$var$TagSelector = (props)=>{
    const { tagIndex: tagIndex, aggregateFunctionType: aggregateFunctionType, onRemoveTagSelector: onRemoveTagSelector, onChangeFunctionType: onChangeFunctionType } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $702c1c2288ff3dba$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $702c1c2288ff3dba$export$2e2bcd8739ae039).DropdownHeader, {
        options: [
            'Filter',
            'Group'
        ],
        selectedOption: $46227f4c506c006a$var$renderType(aggregateFunctionType),
        onDelete: tagIndex !== 0 ? ()=>onRemoveTagSelector() : undefined,
        onSelect: (val)=>onChangeFunctionType(val === 'Filter' ? 'filter' : 'group')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($46227f4c506c006a$var$TagSelectorBody, props));
};
function $46227f4c506c006a$var$tagSearchPlaceholder(key) {
    if (key === '_measurement') return 'Search measurements';
    if (key === '_field') return 'Search fields';
    return `Search ${key} tag values`;
}
const $46227f4c506c006a$var$TagSelectorBody = (props)=>{
    const { aggregateFunctionType: aggregateFunctionType, keys: keys, keysStatus: keysStatus, keysTruncated: keysTruncated, tagKey: key, onSelectKey: onSelectKey, valuesSearchTerm: valuesSearchTerm, onChangeValuesSearchTerm: onChangeValuesSearchTerm, onIncreaseValuesLimit: onIncreaseValuesLimit, onSearchValues: onSearchValues, keysSearchTerm: keysSearchTerm, onChangeKeysSearchTerm: onChangeKeysSearchTerm, onIncreaseKeysLimit: onIncreaseKeysLimit, onSearchKeys: onSearchKeys, tagValues: selectedValues, timeRangeText: timeRangeText } = props;
    if (aggregateFunctionType === 'filter') {
        if (keysStatus === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $702c1c2288ff3dba$export$2e2bcd8739ae039).Empty, null, "Failed to load tag keys");
        if (keysStatus === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done && !keys.length && !keysSearchTerm) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $702c1c2288ff3dba$export$2e2bcd8739ae039).Empty, {
            testID: "empty-tag-keys"
        }, "No tag keys found", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("small", null, "in the current", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("a", {
            href: "#",
            onClick: (0, $80cff9834e653b0a$export$71a9f17adbf66515),
            title: timeRangeText
        }, "time range")));
    }
    const debouncer = (0, $NdCUR.useMemo)(()=>new (0, $075f3b99bb3716e4$export$2e2bcd8739ae039)(), []);
    (0, $NdCUR.useEffect)(()=>()=>debouncer.cancelAll(), []);
    function onValueTermChange(e) {
        onChangeValuesSearchTerm(e.target.value);
        debouncer.call(()=>onSearchValues(), $46227f4c506c006a$var$SEARCH_DEBOUNCE_MS);
    }
    function onKeyTermChange(term) {
        onChangeKeysSearchTerm(term);
        debouncer.call(()=>onSearchKeys(), $46227f4c506c006a$var$SEARCH_DEBOUNCE_MS);
    }
    function onLoadMoreKeys() {
        onIncreaseKeysLimit();
        debouncer.call(()=>onSearchKeys(), $46227f4c506c006a$var$SEARCH_DEBOUNCE_MS);
    }
    function onLoadMoreValues() {
        onIncreaseValuesLimit();
        debouncer.call(()=>onSearchValues(), $46227f4c506c006a$var$SEARCH_DEBOUNCE_MS);
    }
    const placeholderText = aggregateFunctionType === 'group' ? 'Search group column values' : $46227f4c506c006a$var$tagSearchPlaceholder(key);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $702c1c2288ff3dba$export$2e2bcd8739ae039).Menu, {
        testID: `tag-selector--container`
    }, aggregateFunctionType !== 'group' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        style: {
            display: 'flex',
            width: '100%',
            alignItems: 'center',
            marginBottom: '4px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $75d219277bc3d571$export$2e2bcd8739ae039), {
        items: keys,
        onChoose: (k)=>onSelectKey(k),
        searchTerm: keysSearchTerm,
        onChangeSearchTerm: onKeyTermChange,
        selected: key,
        buttonSize: "btn-sm",
        className: "dropdown-stretch",
        status: keysStatus,
        addNew: aggregateFunctionType === 'filter' && keysTruncated ? {
            text: 'Load More',
            stopPropagation: true,
            handler: onLoadMoreKeys
        } : undefined
    }), selectedValues.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "flux-tag-selector--count",
        title: `${selectedValues.length} value${selectedValues.length === 1 ? '' : 's'} selected`
    }, selectedValues.length) : undefined), keysStatus === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
        className: "form-control input-sm",
        placeholder: placeholderText,
        type: "text",
        value: valuesSearchTerm,
        onChange: onValueTermChange,
        spellCheck: false,
        autoComplete: "false"
    }) : undefined), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($46227f4c506c006a$var$TagSelectorValues, {
        ...props,
        onLoadMoreValues: onLoadMoreValues
    }));
};
const $46227f4c506c006a$var$TagSelectorValues = (props)=>{
    const { aggregateFunctionType: aggregateFunctionType, keysStatus: keysStatus, tagKey: key, tagIndex: tagIndex, values: values, valuesStatus: valuesStatus, valuesTruncated: valuesTruncated, tagValues: selectedValues, onSelectValues: onSelectValues, onLoadMoreValues: onLoadMoreValues, timeRangeText: timeRangeText } = props;
    if (aggregateFunctionType === 'filter') {
        if (keysStatus === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).NotStarted) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $702c1c2288ff3dba$export$2e2bcd8739ae039).Empty, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $2f92edf239a456bb$export$2e2bcd8739ae039), {
            text: "Waiting for tag keys"
        }));
        if (keysStatus === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $702c1c2288ff3dba$export$2e2bcd8739ae039).Empty, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $2f92edf239a456bb$export$2e2bcd8739ae039), {
            text: "Loading tag keys"
        }));
    }
    const [loadFinished, setLoadFinished] = (0, $NdCUR.useState)(false);
    if (valuesStatus === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error) {
        if (loadFinished) setLoadFinished(false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $702c1c2288ff3dba$export$2e2bcd8739ae039).Empty, null, `Failed to load tag values for ${key}`);
    }
    if (valuesStatus === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).NotStarted) {
        if (loadFinished) setLoadFinished(false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $702c1c2288ff3dba$export$2e2bcd8739ae039).Empty, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $2f92edf239a456bb$export$2e2bcd8739ae039), {
            text: "Waiting for tag values"
        }));
    }
    if (!loadFinished && valuesStatus === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $702c1c2288ff3dba$export$2e2bcd8739ae039).Empty, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $2f92edf239a456bb$export$2e2bcd8739ae039), {
        text: "Loading tag values"
    }));
    if (valuesStatus === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done) {
        if (!loadFinished) setLoadFinished(true);
        if (!values.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $702c1c2288ff3dba$export$2e2bcd8739ae039).Empty, null, "No values found", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("small", null, "in the current", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("a", {
            href: "#",
            onClick: (0, $80cff9834e653b0a$export$71a9f17adbf66515),
            title: timeRangeText
        }, "time range")));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $702c1c2288ff3dba$export$2e2bcd8739ae039).Body, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "flux-query-builder--list"
    }, values.map((value)=>{
        const active = selectedValues.includes(value);
        const onChange = ()=>onSelectValues(active ? selectedValues.filter((x)=>x !== value) : [
                value,
                ...selectedValues
            ]);
        const divId = `flxts${tagIndex}_${value}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "flux-query-builder--list-item",
            onClick: onChange,
            key: divId,
            id: divId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            type: "checkbox",
            checked: active,
            onChange: onChange
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: divId
        }, value));
    }), valuesTruncated && aggregateFunctionType === 'filter' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "flux-query-builder--list-item",
        key: "__truncated"
    }, valuesStatus !== (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
        text: "Load More Values",
        onClick: (e)=>{
            e.stopPropagation();
            onLoadMoreValues();
        },
        size: (0, $918c9f03a35fe03f$export$fafce5c139da9687).ExtraSmall,
        shape: (0, $918c9f03a35fe03f$export$ce765fb8bb08a599).StretchToFit,
        icon: (0, $918c9f03a35fe03f$export$62c9c0cf752cde38).Plus
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7ba6e1db17640a51$export$2e2bcd8739ae039), null)) : undefined, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "flux-query-builder--list-item",
        key: "__infomsg",
        style: {
            cursor: 'default'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("small", {
        style: {
            textAlign: 'center',
            width: '100%'
        }
    }, "keys/values depend on", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("a", {
        href: "#",
        onClick: (0, $80cff9834e653b0a$export$71a9f17adbf66515),
        title: timeRangeText
    }, "time range")))));
};
const $46227f4c506c006a$var$mdtp = (dispatch, { source: source, timeRange: timeRange, tagIndex: tagIndex })=>{
    return {
        onRemoveTagSelector: ()=>{
            dispatch((0, $5a9dce3ec2c239f0$export$8bc32d5b7ddb7e19)(source, timeRange, tagIndex));
        },
        onChangeFunctionType: (type)=>{
            dispatch((0, $5a9dce3ec2c239f0$export$9e73223bd001c934)(source, timeRange, tagIndex, type));
        },
        onSelectKey: (key)=>{
            dispatch((0, $5a9dce3ec2c239f0$export$1fae024c760db276)(source, timeRange, tagIndex, key));
        },
        onChangeKeysSearchTerm: (term)=>{
            dispatch((0, $8708d281d7bbd5c0$export$af6b9fa63775877a)(tagIndex, term));
        },
        onIncreaseKeysLimit: ()=>{
            dispatch((0, $8708d281d7bbd5c0$export$6cc5734d6d8bd949)(tagIndex));
        },
        onSearchKeys: ()=>{
            dispatch((0, $5a9dce3ec2c239f0$export$23c742dbcc1607c9)(source, timeRange, tagIndex));
        },
        onChangeValuesSearchTerm: (term)=>{
            dispatch((0, $8708d281d7bbd5c0$export$29135ce0a7d788aa)(tagIndex, term));
        },
        onIncreaseValuesLimit: ()=>{
            dispatch((0, $8708d281d7bbd5c0$export$447ca5b786ca7b12)(tagIndex));
        },
        onSearchValues: ()=>{
            dispatch((0, $5a9dce3ec2c239f0$export$dd2e52bf4495adbf)(source, timeRange, tagIndex));
        },
        onSelectValues: (values)=>{
            dispatch((0, $5a9dce3ec2c239f0$export$f1e58c4c62aeb4df)(source, timeRange, tagIndex, values));
        }
    };
};
const $46227f4c506c006a$var$mstp = (state, { tagIndex: tagIndex })=>{
    const tags = state?.fluxQueryBuilder?.tags;
    return tags[tagIndex];
};
var $46227f4c506c006a$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($46227f4c506c006a$var$mstp, $46227f4c506c006a$var$mdtp)($46227f4c506c006a$var$TagSelector);






var $axd2S = parcelRequire("axd2S");

function $a2a0988fd706241b$var$timeRangeWindowPeriod(timeRange) {
    if (timeRange) {
        if (timeRange.seconds) return $a2a0988fd706241b$export$3f6a59346ffa0360(timeRange.seconds);
        // calculate from upper / lower
        const seconds = Math.round((0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(timeRange.upper).diff((0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(timeRange.lower)) / 1000);
        return $a2a0988fd706241b$export$3f6a59346ffa0360(seconds);
    }
}
function $a2a0988fd706241b$export$3f6a59346ffa0360(seconds) {
    seconds = Math.round(seconds / (0, $d9ab469c58284fd8$export$c43acf03b2e5f4d1));
    if (!(seconds > 1)) return '1s';
    let retVal = '';
    if (seconds >= 86400) {
        retVal += `${Math.trunc(seconds / 86400)}d`;
        seconds %= 86400;
    }
    if (seconds >= 3600) {
        retVal += `${Math.trunc(seconds / 3600)}h`;
        seconds %= 3600;
    }
    if (seconds >= 60) {
        retVal += `${Math.trunc(seconds / 60)}m`;
        seconds %= 60;
        return seconds === 0 ? retVal : `${retVal}${seconds}s`;
    }
    if (seconds > 0) retVal += `${seconds}s`;
    return retVal;
}
var $a2a0988fd706241b$export$2e2bcd8739ae039 = $a2a0988fd706241b$var$timeRangeWindowPeriod;





// Libraries

var $NdCUR = parcelRequire("NdCUR");




const $ab1ac1abee31f71d$var$EMPTY_FN = ()=>{};
const $ab1ac1abee31f71d$var$FluxQueryBuilderSubmit = ({ builderState: builderState, isRunnable: isRunnable, editorScript: editorScript, onSubmit: onSubmit, notify: notify })=>{
    if (!isRunnable) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
        size: (0, $918c9f03a35fe03f$export$fafce5c139da9687).ExtraSmall,
        color: (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Primary,
        onClick: $ab1ac1abee31f71d$var$EMPTY_FN,
        status: (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Disabled,
        text: "Submit",
        customClass: "fqb--submit"
    });
    const [showConfirm, setShowConfirm] = (0, $NdCUR.useState)(false);
    const buttonRef = (0, $NdCUR.useRef)();
    const lastConfirmedBuilderState = (0, $NdCUR.useMemo)(()=>{
        return builderState;
    }, [
        editorScript
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        ref: buttonRef
    }, !showConfirm ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
        size: (0, $918c9f03a35fe03f$export$fafce5c139da9687).ExtraSmall,
        color: (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Primary,
        onClick: ()=>{
            try {
                const script = (0, $d61eb6bd66956357$export$d7b58f10109feb02)(builderState);
                const lastScript = (0, $d61eb6bd66956357$export$d7b58f10109feb02)(lastConfirmedBuilderState);
                // submit directly if editor is empty, the generated query is the same as the editor query
                // or if the builder was used to generate the new script
                if (!editorScript || script === editorScript || editorScript === lastScript) onSubmit(script);
                else setShowConfirm(true);
            } catch (ex) {
                console.error(ex);
                notify((0, $ec1f42de4faacc37$export$c312505591a86529)('Unable to build flux script: ' + ex.message));
            }
        },
        status: (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Default,
        text: "Submit",
        customClass: "fqb--submit"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
        size: (0, $918c9f03a35fe03f$export$fafce5c139da9687).ExtraSmall,
        color: (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Primary,
        onClick: $ab1ac1abee31f71d$var$EMPTY_FN,
        status: isRunnable ? (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Default : (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Disabled,
        text: "Submit",
        customClass: "fqb--submit"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "fqb--confirm-popup",
        style: {
            left: `${buttonRef.current.getBoundingClientRect().right - 350}px`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        className: "fqb--confirm-label"
    }, "Submitting the Script Builder will overwrite the existing Flux script, any changes you have made using Flux will be discarded. This cannot be recovered."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1f11d3536bc98f8a$export$c16e4f034c84cb3f), {
        onClickOutside: ()=>setShowConfirm(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
        size: (0, $918c9f03a35fe03f$export$fafce5c139da9687).ExtraSmall,
        color: (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Danger,
        onClick: ()=>{
            try {
                const script = (0, $d61eb6bd66956357$export$d7b58f10109feb02)(builderState);
                setShowConfirm(false);
                onSubmit(script);
            } catch (ex) {
                console.error(ex);
                notify((0, $ec1f42de4faacc37$export$c312505591a86529)('Unable to build flux script: ' + ex.message));
            }
        },
        status: (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Default,
        text: "OK"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        className: "fqb--confirm-caret",
        style: {
            left: `${buttonRef.current.getBoundingClientRect().left + buttonRef.current.getBoundingClientRect().width / 2}px`,
            top: `${buttonRef.current.getBoundingClientRect().bottom}px`
        }
    })));
};
var $ab1ac1abee31f71d$export$2e2bcd8739ae039 = $ab1ac1abee31f71d$var$FluxQueryBuilderSubmit;


const $7afc5c063a23cc07$var$FluxQueryBuilder = ({ source: source, timeRange: timeRange, tags: tags, isRunnable: isRunnable, builderState: builderState, timeZone: timeZone, notify: notify, onSubmit: onSubmit, onShowEditor: onShowEditor, onAddTagSelector: onAddTagSelector, script: editorScript })=>{
    const [defaultPeriod, timeRangeText] = (0, $NdCUR.useMemo)(()=>[
            (0, $a2a0988fd706241b$export$2e2bcd8739ae039)(timeRange),
            (0, $557b602c140cbcc0$export$2168f5e111e02aa9)({
                timeRange: timeRange,
                timeZone: timeZone
            })
        ], [
        timeRange,
        timeZone
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "flux-query-builder",
        "data-test": "flux-query-builder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "flux-query-builder--cards"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "builder-card--list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $702c1c2288ff3dba$export$2e2bcd8739ae039), {
        testID: "bucket-selector"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $702c1c2288ff3dba$export$2e2bcd8739ae039).Header, {
        title: "From"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $f9063f233abfc788$export$2e2bcd8739ae039), {
        source: source,
        timeRange: timeRange
    })), tags.map((tag)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $46227f4c506c006a$export$2e2bcd8739ae039), {
            source: source,
            timeRange: timeRange,
            timeRangeText: timeRangeText,
            key: tag.tagIndex,
            tagIndex: tag.tagIndex
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
        size: (0, $918c9f03a35fe03f$export$fafce5c139da9687).Large,
        customClass: "flux-query-builder--add-card-button",
        icon: (0, $918c9f03a35fe03f$export$62c9c0cf752cde38).PlusSkinny,
        onClick: ()=>{
            onAddTagSelector(source, timeRange);
        },
        shape: (0, $918c9f03a35fe03f$export$ce765fb8bb08a599).Square
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fad4f9add39928d5$export$2e2bcd8739ae039), {
        defaultPeriod: defaultPeriod
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "flux-query-builder--actions"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
        size: (0, $918c9f03a35fe03f$export$fafce5c139da9687).ExtraSmall,
        onClick: onShowEditor,
        text: "Script Editor",
        titleText: "Switch to Flux Script Editor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
        shape: (0, $918c9f03a35fe03f$export$ce765fb8bb08a599).Square,
        size: (0, $918c9f03a35fe03f$export$fafce5c139da9687).ExtraSmall,
        titleText: "Copy builder script to clipboard",
        icon: (0, $918c9f03a35fe03f$export$62c9c0cf752cde38).Duplicate,
        status: isRunnable ? (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Default : (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Disabled,
        onClick: (e)=>{
            let success = false;
            try {
                const script = (0, $d61eb6bd66956357$export$d7b58f10109feb02)(builderState);
                success = !!script && (0, (/*@__PURE__*/$parcel$interopDefault($8G5JO)))(script);
            } catch (ex) {
                console.error('Build query failed', ex);
            }
            notify(success ? (0, $ec1f42de4faacc37$export$9744b69e3922044f)(null, 'Builder script has been copied to clipboard.', '') : (0, $ec1f42de4faacc37$export$6a59b8139549a56)(null, 'Builder script was not copied to clipboard.', ''));
            e.stopPropagation();
            e.preventDefault();
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ab1ac1abee31f71d$export$2e2bcd8739ae039), {
        isRunnable: isRunnable,
        builderState: builderState,
        editorScript: editorScript,
        notify: notify,
        onSubmit: onSubmit
    })))));
};
const $7afc5c063a23cc07$var$mstp = (state)=>{
    const fluxQueryBuilder = state?.fluxQueryBuilder;
    const timeZone = state?.app?.persisted?.timeZone;
    return {
        builderState: fluxQueryBuilder,
        tags: fluxQueryBuilder.tags,
        timeZone: timeZone,
        isRunnable: fluxQueryBuilder.buckets.status === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done && !!fluxQueryBuilder.buckets.selectedBucket
    };
};
const $7afc5c063a23cc07$var$mdtp = {
    onAddTagSelector: (0, $5a9dce3ec2c239f0$export$b24c3519ffe97b76),
    notify: (0, $205d139de2918454$export$5e14cdade93d6f7b)
};
var $7afc5c063a23cc07$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($7afc5c063a23cc07$var$mstp, $7afc5c063a23cc07$var$mdtp)($7afc5c063a23cc07$var$FluxQueryBuilder);


const $7a320275701d2a40$var$CHECK_SCRIPT_DELAY = 600;
const $7a320275701d2a40$var$VALID_SCRIPT_STATUS = {
    type: 'success',
    text: ''
};
class $7a320275701d2a40$var$FluxQueryMaker extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.debouncer = new (0, $075f3b99bb3716e4$export$2e2bcd8739ae039)(), this.getAST = (0, $fd27df6641fc3529$export$b54537f4467277c6)((0, $574ac1b431fc0723$export$1ab6d957e7a2fb4d)), this.cursorPosition = {
            line: 0,
            ch: 0
        }, this.handleCursorPosition = (position)=>{
            this.cursorPosition = position;
        }, this.handleInsertFluxFunction = async (fluxFunction)=>{
            const { draftScript: draftScript } = this.props;
            const { line: line } = this.cursorPosition;
            const { updatedScript: updatedScript, cursorPosition: cursorPosition } = (0, $7208e8c4ebc3918f$export$85773d32ea4ff940)(line, draftScript, fluxFunction);
            await this.handleChangeDraftScript(updatedScript);
            this.handleCursorPosition(cursorPosition);
        }, this.handleSubmitScript = ()=>{
            const { onChangeScript: onChangeScript, onUpdateStatus: onUpdateStatus, onManualRefresh: onManualRefresh, draftScript: draftScript } = this.props;
            const { draftScriptStatus: draftScriptStatus } = this.state;
            onChangeScript(draftScript);
            onManualRefresh();
            if (onUpdateStatus) onUpdateStatus(draftScriptStatus);
        }, this.handleSubmitBuilderScript = async (script)=>{
            await this.handleChangeDraftScript(script);
            this.props.onChangeScript(script);
            this.handleSubmitScript();
        }, this.handleShowWizard = ()=>{
            this.setState({
                isWizardActive: true
            });
        }, this.handleShowEditor = ()=>{
            this.setState({
                isWizardActive: false
            });
        }, this.handleChangeDraftScript = async (draftScript)=>{
            const { onChangeDraftScript: onChangeDraftScript } = this.props;
            await onChangeDraftScript(draftScript);
            this.debouncer.call(this.checkDraftScript, $7a320275701d2a40$var$CHECK_SCRIPT_DELAY);
        }, this.checkDraftScript = async ()=>{
            const { draftScript: draftScript } = this.props;
            if (draftScript.trim() === '') {
                // Don't attempt to validate an empty script
                this.setState({
                    draftScriptStatus: $7a320275701d2a40$var$VALID_SCRIPT_STATUS
                });
                return;
            }
            let draftScriptStatus;
            try {
                await this.getAST({
                    url: this.props.links.ast,
                    body: draftScript
                });
                draftScriptStatus = $7a320275701d2a40$var$VALID_SCRIPT_STATUS;
            } catch (error) {
                draftScriptStatus = (0, $6cc05668b9e9ec3f$export$e80a9284539c1797)(error);
            }
            this.setState({
                draftScriptStatus: draftScriptStatus
            });
        };
        this.state = {
            suggestions: (0, $9e4606691311afaa$export$cb01122796bc0228)(),
            draftScriptStatus: {
                type: 'none',
                text: ''
            },
            isWizardActive: false
        };
    }
    componentDidMount() {
        this.checkDraftScript();
    }
    render() {
        const { notify: notify, source: source, draftScript: draftScript, fluxProportions: fluxProportions, onSetFluxProportions: onSetFluxProportions, timeRange: timeRange } = this.props;
        if (!this.state.isWizardActive) {
            const { suggestions: suggestions, draftScriptStatus: draftScriptStatus } = this.state;
            const [leftSize, middleSize, rightSize] = fluxProportions;
            const divisions = [
                {
                    name: 'Schema',
                    size: leftSize,
                    headerButtons: [],
                    menuOptions: [],
                    render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $0b6b6176a30515ab$export$2e2bcd8739ae039), {
                            source: source,
                            timeRange: timeRange,
                            notify: notify
                        }),
                    headerOrientation: (0, $e10a8602f56394e3$export$13b6d0f939932bf6)
                },
                {
                    name: 'Script',
                    size: middleSize,
                    customClass: 'flux-query-maker--script',
                    headerOrientation: (0, $e10a8602f56394e3$export$13b6d0f939932bf6),
                    headerButtons: [
                        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
                            key: 0,
                            text: 'Script Builder',
                            onClick: this.handleShowWizard,
                            size: (0, $918c9f03a35fe03f$export$fafce5c139da9687).ExtraSmall
                        }),
                        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
                            key: 1,
                            text: 'Run Script',
                            onClick: this.handleSubmitScript,
                            size: (0, $918c9f03a35fe03f$export$fafce5c139da9687).ExtraSmall,
                            color: (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Primary
                        })
                    ],
                    menuOptions: [],
                    render: (visibility)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $06cdf5bcf6486c0a$export$2e2bcd8739ae039), {
                            status: draftScriptStatus,
                            script: draftScript,
                            visibility: visibility,
                            suggestions: suggestions,
                            onChangeScript: this.handleChangeDraftScript,
                            onSubmitScript: this.handleSubmitScript,
                            onShowWizard: this.handleShowWizard,
                            onCursorChange: this.handleCursorPosition
                        })
                },
                {
                    name: 'Flux Functions',
                    size: rightSize,
                    headerButtons: [],
                    menuOptions: [],
                    render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b940e5241ef2bddf$export$2e2bcd8739ae039), {
                            onInsertFluxFunction: this.handleInsertFluxFunction
                        }),
                    headerOrientation: (0, $e10a8602f56394e3$export$13b6d0f939932bf6)
                }
            ];
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                className: "flux-script-wizard"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                className: "flux-script-wizard--children"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $71205b63ef953f49$export$2e2bcd8739ae039), {
                orientation: (0, $e10a8602f56394e3$export$13b6d0f939932bf6),
                divisions: divisions,
                containerClass: "page-contents",
                onResize: onSetFluxProportions
            })));
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7afc5c063a23cc07$export$2e2bcd8739ae039), {
            script: draftScript,
            source: source,
            timeRange: timeRange,
            onSubmit: this.handleSubmitBuilderScript,
            onShowEditor: this.handleShowEditor
        });
    }
}
const $7a320275701d2a40$var$ConnectedFluxQueryMaker = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b029b3af5fc2e5d5$export$7d87f8b720f7653e), null, (container)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($7a320275701d2a40$var$FluxQueryMaker, {
            ...props,
            timeRange: container.state.timeRange,
            fluxProportions: container.state.fluxProportions,
            onSetFluxProportions: container.handleSetFluxProportions
        }));
var $7a320275701d2a40$export$2e2bcd8739ae039 = $7a320275701d2a40$var$ConnectedFluxQueryMaker;















class $dfadf026237d58c4$var$TimeMachine extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.renderVisualization = ()=>{
            const { templates: templates, isStaticLegend: isStaticLegend, manualRefresh: manualRefresh } = this.props;
            const { autoRefresher: autoRefresher, isViewingRawData: isViewingRawData } = this.state;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $6636068b2dc4465d$export$2e2bcd8739ae039), {
                source: this.source,
                templates: templates,
                queries: this.queriesForVis,
                autoRefresher: autoRefresher,
                staticLegend: isStaticLegend,
                manualRefresh: manualRefresh,
                editorLocation: this.stateToUpdate,
                showRawFluxData: isViewingRawData,
                onEditQueryStatus: this.handleEditQueryStatus
            });
        }, this.renderEditorBottom = ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ff707b0eec354c12$export$2e2bcd8739ae039), null, this.editorTab);
        }, this.handleUpdateEditorTimeRange = (timeRange)=>{
            const { onUpdateTimeRange: onUpdateTimeRange } = this.props;
            onUpdateTimeRange(timeRange);
        }, this.handleEditQueryStatus = (queryID, status)=>{
            const { editQueryStatus: editQueryStatus } = this.props;
            editQueryStatus(queryID, status, this.stateToUpdate);
        }, this.handleEditRawText = async (text, isAutoSubmitted)=>{
            const { templates: templates, onUpdateQueryDrafts: onUpdateQueryDrafts, queryDrafts: queryDrafts, queryStatuses: queryStatuses, notify: notify } = this.props;
            const activeID = this.activeQuery.id;
            const url = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(this.source, 'links.queries', '');
            const isExcluded = (0, $d6713fc94c521d4a$export$63fabf44ec222040)(text);
            let newQueryConfig;
            try {
                newQueryConfig = await (0, $0ece195804443aff$export$44487a86467333c3)(url, activeID, text, templates);
            } catch  {
                notify((0, $ec1f42de4faacc37$export$7e5c8f53d6c04d2c));
                return;
            }
            const updatedQueryDrafts = queryDrafts.map((query)=>{
                if (query.queryConfig.id !== activeID) return query;
                return {
                    ...query,
                    text: text,
                    query: text,
                    queryConfig: {
                        ...newQueryConfig,
                        rawText: text,
                        isExcluded: isExcluded
                    }
                };
            });
            this.handleEditQueryStatus(activeID, {
                ...queryStatuses[activeID],
                isManuallySubmitted: !isAutoSubmitted,
                submittedStatus: queryStatuses[activeID]?.submittedStatus,
                submittedQuery: queryStatuses[activeID]?.submittedQuery
            });
            onUpdateQueryDrafts(updatedQueryDrafts);
        }, this.handleChangeSource = (selectedSource, type)=>{
            const { updateSourceLink: updateSourceLink } = this.props;
            if (updateSourceLink) updateSourceLink((0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(selectedSource, 'links.self', ''));
            this.updateQueryDraftsSource(selectedSource, type);
            this.setState({
                selectedSource: selectedSource
            });
        }, this.handleSelectDynamicSource = ()=>{
            const type = this.isFluxSelected ? (0, $b4506126e09430df$export$7c8e26efb80b90e8).Flux : (0, $b4506126e09430df$export$7c8e26efb80b90e8).InfluxQL;
            this.updateQueryDraftsSource(null, type);
        }, this.handleAddQuery = ()=>{
            const { queryDrafts: queryDrafts, onAddQuery: onAddQuery } = this.props;
            const newIndex = queryDrafts.length;
            onAddQuery();
            this.handleSetActiveQueryIndex(newIndex);
        }, this.handleDeleteQuery = (index)=>{
            const { queryDrafts: queryDrafts, onDeleteQuery: onDeleteQuery } = this.props;
            const queryToDelete = queryDrafts.find((__, i)=>i === index);
            const activeQueryId = this.activeQuery.id;
            const activeQueryIndex = queryDrafts.findIndex((query)=>query.id === activeQueryId);
            let newIndex;
            if (index === activeQueryIndex) {
                if (index - 1 >= 0) newIndex = index - 1;
                else if (index - 1 < 0 && queryDrafts.length > 1) newIndex = index;
                else newIndex = null;
            } else if (activeQueryIndex < index) newIndex = activeQueryIndex;
            else newIndex = activeQueryIndex - 1;
            this.handleSetActiveQueryIndex(newIndex);
            onDeleteQuery(queryToDelete.id);
        }, this.handleChangeAutoRefreshDuration = (autoRefreshOption = (0, $7be8d2ddc7f80e0c$export$47c563f91f55e1eb))=>{
            const { milliseconds: milliseconds } = autoRefreshOption;
            this.setState({
                autoRefreshDuration: milliseconds
            });
        }, this.handleSetActiveQueryIndex = (activeQueryIndex)=>{
            this.setState({
                activeQueryIndex: activeQueryIndex
            });
            const { onActiveQueryIndexChange: onActiveQueryIndexChange } = this.props;
            if (onActiveQueryIndexChange) onActiveQueryIndexChange(activeQueryIndex);
        }, this.handleSetActiveEditorTab = (tabName)=>{
            this.setState({
                activeEditorTab: tabName
            });
        }, this.handleToggleIsViewingRawData = ()=>{
            this.setState({
                isViewingRawData: !this.state.isViewingRawData
            });
        }, this.toggleFlux = (type)=>{
            const { onUpdateQueryType: onUpdateQueryType } = this.props;
            const shouldUpdateType = type === (0, $b4506126e09430df$export$7c8e26efb80b90e8).InfluxQL && this.isFluxSelected || type === (0, $b4506126e09430df$export$7c8e26efb80b90e8).Flux && !this.isFluxSelected;
            if (shouldUpdateType) onUpdateQueryType(type);
        };
        this.state = {
            activeQueryIndex: 0,
            activeEditorTab: (0, $9a9ec629fdd38845$export$b11a09459547fdbb).Queries,
            selectedSource: null,
            autoRefresher: new (0, $a926ccb172fe03ce$export$260d1793ec17c683)(),
            autoRefreshDuration: props.refresh,
            isViewingRawData: false
        };
    }
    async componentDidMount() {
        const { autoRefresher: autoRefresher, autoRefreshDuration: autoRefreshDuration } = this.state;
        autoRefresher.poll(autoRefreshDuration);
    }
    componentWillUnmount() {
        const { autoRefresher: autoRefresher } = this.state;
        autoRefresher.stopPolling();
    }
    componentDidUpdate(__, prevState) {
        const { autoRefresher: autoRefresher, autoRefreshDuration: autoRefreshDuration } = this.state;
        if (autoRefreshDuration !== prevState.autoRefreshDuration) autoRefresher.poll(autoRefreshDuration);
    }
    render() {
        const { script: script, timeRange: timeRange, templates: templates, onManualRefresh: onManualRefresh, timeMachineProportions: timeMachineProportions, onSetTimeMachineProportions: onSetTimeMachineProportions } = this.props;
        const { autoRefreshDuration: autoRefreshDuration, isViewingRawData: isViewingRawData } = this.state;
        const [topSize, bottomSize] = timeMachineProportions;
        const horizontalDivisions = [
            {
                name: '',
                handleDisplay: 'none',
                headerButtons: [],
                menuOptions: [],
                render: this.renderVisualization,
                headerOrientation: (0, $e10a8602f56394e3$export$60faac65e31b0582),
                size: topSize
            },
            {
                name: '',
                handlePixels: 8,
                headerButtons: [],
                menuOptions: [],
                render: this.renderEditorBottom,
                headerOrientation: (0, $e10a8602f56394e3$export$60faac65e31b0582),
                size: bottomSize
            }
        ];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "deceo"
        }, this.pageHeader, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $3b680e0d9e258850$export$2e2bcd8739ae039), {
            script: script,
            source: this.source,
            templates: templates,
            timeRange: timeRange,
            sources: this.formattedSources,
            toggleFlux: this.toggleFlux,
            onManualRefresh: onManualRefresh,
            queries: this.queriesWorkingDraft,
            isViewingRawData: isViewingRawData,
            isFluxSelected: this.isFluxSelected,
            onChangeSource: this.handleChangeSource,
            autoRefreshDuration: autoRefreshDuration,
            sourceSupportsFlux: this.sourceSupportsFlux,
            isDynamicSourceSelected: this.useDynamicSource,
            onSelectDynamicSource: this.handleSelectDynamicSource,
            updateEditorTimeRange: this.handleUpdateEditorTimeRange,
            toggleIsViewingRawData: this.handleToggleIsViewingRawData,
            onChangeAutoRefreshDuration: this.handleChangeAutoRefreshDuration
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "deceo--container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $71205b63ef953f49$export$2e2bcd8739ae039), {
            orientation: (0, $e10a8602f56394e3$export$60faac65e31b0582),
            divisions: horizontalDivisions,
            onResize: onSetTimeMachineProportions
        })));
    }
    get editorTab() {
        const { onResetFocus: onResetFocus, isStaticLegend: isStaticLegend, onToggleStaticLegend: onToggleStaticLegend } = this.props;
        const { activeEditorTab: activeEditorTab } = this.state;
        if (activeEditorTab === (0, $9a9ec629fdd38845$export$b11a09459547fdbb).Queries) {
            if (this.isFluxSelected) return this.fluxBuilder;
            return this.influxQLBuilder;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $8c579bbea77c7b68$export$2e2bcd8739ae039), {
            queryConfigs: this.queriesWorkingDraft,
            onToggleStaticLegend: onToggleStaticLegend,
            staticLegend: isStaticLegend,
            onResetFocus: onResetFocus,
            stateToUpdate: this.stateToUpdate
        });
    }
    get pageHeader() {
        const { children: children } = this.props;
        const { activeEditorTab: activeEditorTab } = this.state;
        return children(activeEditorTab, this.handleSetActiveEditorTab);
    }
    get source() {
        const { source: source, sources: sources, queryDrafts: queryDrafts } = this.props;
        const { selectedSource: selectedSource } = this.state;
        // return current source
        if (this.useDynamicSource) return source;
        if (selectedSource) return selectedSource;
        const queryDraft = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(queryDrafts, 0);
        const querySource = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(queryDraft, 'source');
        if (!queryDraft || !querySource) return source;
        const foundSource = sources.find((s)=>s.links.self === querySource);
        if (foundSource) return foundSource;
        return source;
    }
    get queriesWorkingDraft() {
        const { queryDrafts: queryDrafts, queryStatuses: queryStatuses } = this.props;
        if (!queryDrafts || !queryDrafts.length) return [];
        return queryDrafts.map((q)=>({
                ...q.queryConfig,
                source: this.source,
                status: queryStatuses[String(q.id)]
            }));
    }
    get formattedSources() {
        const { sources: sources } = this.props;
        return sources.map((s)=>({
                ...s,
                text: `${s.name} @ ${s.url}`
            }));
    }
    get isFluxSelected() {
        const { queryType: queryType } = this.props;
        return queryType === (0, $b4506126e09430df$export$7c8e26efb80b90e8).Flux && this.sourceSupportsFlux;
    }
    get sourceSupportsFlux() {
        return !!(0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(this.source, 'links.flux', null);
    }
    get fluxBuilder() {
        const { script: script, notify: notify, fluxLinks: fluxLinks, draftScript: draftScript, onChangeScript: onChangeScript, onManualRefresh: onManualRefresh, onChangeDraftScript: onChangeDraftScript, onUpdateScriptStatus: onUpdateScriptStatus } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7a320275701d2a40$export$2e2bcd8739ae039), {
            notify: notify,
            script: script,
            links: fluxLinks,
            source: this.source,
            draftScript: draftScript,
            onChangeScript: onChangeScript,
            onManualRefresh: onManualRefresh,
            onChangeDraftScript: onChangeDraftScript,
            onUpdateStatus: onUpdateScriptStatus
        });
    }
    get influxQLBuilder() {
        const { templates: templates } = this.props;
        const { activeQueryIndex: activeQueryIndex } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $046d5031e62bfbb4$export$2e2bcd8739ae039), {
            source: this.source,
            templates: templates,
            queries: this.queriesWorkingDraft,
            onDeleteQuery: this.handleDeleteQuery,
            onAddQuery: this.handleAddQuery,
            activeQueryIndex: activeQueryIndex,
            activeQuery: this.activeQuery,
            setActiveQueryIndex: this.handleSetActiveQueryIndex,
            onEditRawText: this.handleEditRawText,
            onMetaQuerySelected: this.handleChangeAutoRefreshDuration
        });
    }
    get stateToUpdate() {
        const { isInCEO: isInCEO } = this.props;
        return isInCEO ? (0, $997a2bc484aadf39$export$f57f948de0498b05).CEO : (0, $997a2bc484aadf39$export$f57f948de0498b05).DE;
    }
    get queriesForVis() {
        const { script: script, timeRange: timeRange, queryDrafts: queryDrafts } = this.props;
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(queryDrafts, 'id', '');
        if (this.isFluxSelected) {
            // there will only be one flux query
            const fluxQuery = [
                {
                    text: script,
                    id: id,
                    queryConfig: null,
                    type: (0, $b4506126e09430df$export$7c8e26efb80b90e8).Flux
                }
            ];
            return fluxQuery;
        }
        return (0, $88fea4b168b314ad$export$2e2bcd8739ae039)(this.queriesWorkingDraft, timeRange);
    }
    get activeQuery() {
        const { activeQueryIndex: activeQueryIndex } = this.state;
        const queriesWorkingDraft = this.queriesWorkingDraft;
        const activeQuery = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(queriesWorkingDraft, activeQueryIndex, queriesWorkingDraft[0]);
        return activeQuery;
    }
    get useDynamicSource() {
        const { queryDrafts: queryDrafts } = this.props;
        return (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(queryDrafts, '0.source', '') === '';
    }
    updateQueryDraftsSource(selectedSource, type) {
        const { queryDrafts: queryDrafts, onUpdateQueryDrafts: onUpdateQueryDrafts } = this.props;
        const queries = queryDrafts.map((q)=>{
            const queryConfig = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(q, 'queryConfig');
            return {
                ...q,
                queryConfig: {
                    ...queryConfig,
                    source: selectedSource
                },
                source: (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(selectedSource, 'links.self', ''),
                type: type
            };
        });
        onUpdateQueryDrafts(queries);
    }
}
const $dfadf026237d58c4$var$ConnectedTimeMachine = (props)=>{
    (0, $NdCUR.useMemo)(()=>{
        // reset flux query builder cache, so that new timemachine start with a fresh cache
        (0, $4901d8e53292d5c4$export$2e2bcd8739ae039).clearCache();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b029b3af5fc2e5d5$export$7d87f8b720f7653e), null, (container)=>{
        const { state: state } = container;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($dfadf026237d58c4$var$TimeMachine, {
            ...props,
            script: state.script,
            queryType: state.queryType,
            draftScript: state.draftScript,
            queryDrafts: state.queryDrafts,
            timeRange: state.timeRange,
            refresh: props.refresh,
            timeMachineProportions: container.state.timeMachineProportions,
            onUpdateQueryType: container.handleUpdateQueryType,
            onUpdateTimeRange: container.handleUpdateTimeRange,
            onChangeScript: container.handleChangeScript,
            onChangeDraftScript: container.handleUpdateDraftScript,
            onUpdateQueryDrafts: container.handleUpdateQueryDrafts,
            onAddQuery: container.handleAddQuery,
            onDeleteQuery: container.handleDeleteQuery,
            onSetTimeMachineProportions: container.handleSetTimeMachineProportions
        });
    });
};
var $dfadf026237d58c4$export$2e2bcd8739ae039 = (0, $bfd6e1b2bb3e3a9d$export$2e2bcd8739ae039)($dfadf026237d58c4$var$ConnectedTimeMachine);


// Libraries

var $NdCUR = parcelRequire("NdCUR");






class $4937cd758057a690$var$DEHeader extends (0, $NdCUR.Component) {
    render() {
        const { timeZone: timeZone, onSetTimeZone: onSetTimeZone, onOpenWriteData: onOpenWriteData, activeEditorTab: activeEditorTab, onSetActiveEditorTab: onSetActiveEditorTab, toggleSendToDashboard: toggleSendToDashboard } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header, {
            fullWidth: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header.Left, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Title, {
            title: "Explore"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header.Center, {
            widthPixels: 220
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039), {
            shape: (0, $918c9f03a35fe03f$export$ce765fb8bb08a599).StretchToFit
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039).Button, {
            id: "deceo-tab-queries",
            titleText: "Queries",
            value: (0, $9a9ec629fdd38845$export$b11a09459547fdbb).Queries,
            active: activeEditorTab === (0, $9a9ec629fdd38845$export$b11a09459547fdbb).Queries,
            onClick: onSetActiveEditorTab
        }, "Queries"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039).Button, {
            id: "deceo-tab-vis",
            titleText: "Visualization",
            value: (0, $9a9ec629fdd38845$export$b11a09459547fdbb).Vis,
            active: activeEditorTab === (0, $9a9ec629fdd38845$export$b11a09459547fdbb).Vis,
            onClick: onSetActiveEditorTab
        }, "Visualization"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header.Right, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $3489e5a069c3594c$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ed11f2457ce5ca00$export$2e2bcd8739ae039), {
            timeZone: timeZone,
            onSetTimeZone: onSetTimeZone
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            onClick: onOpenWriteData,
            "data-test": "write-data-button",
            className: "button button-sm button-default"
        }, "Write Data"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $091cfcd49e339acd$export$2e2bcd8739ae039), {
            requiredRole: (0, $a7910b1002260d34$export$f715f7e27dea2abf)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            onClick: toggleSendToDashboard,
            className: "button button-sm button-success",
            "data-test": "send-to-dashboard-btn"
        }, "Send to Dashboard"))));
    }
}
var $4937cd758057a690$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($4937cd758057a690$var$DEHeader);







const $edc9e45d6bb52f43$export$ebd20d1eba07a613 = async (source, db, data, precision, v2)=>{
    const url = `${source.links.write}?db=${db}&precision=${precision ? precision : 'ns'}${v2 ? '&v=2' : ''}`;
    await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
        url: url,
        method: 'POST',
        data: data
    });
};




const $6ca895622edb68b7$export$43633ee54025c5cb = (source, db, data, precision, v2)=>async (dispatch)=>{
        try {
            await (0, $edc9e45d6bb52f43$export$ebd20d1eba07a613)(source, db, data, precision, v2);
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$9a22f1a20d817412)()));
        } catch (response) {
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$958c58ab5c08f102)(response.data?.error || response.data?.message)));
            throw response;
        }
    };







class $0a9cd0209b6d60fa$var$DataExplorer extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleCloseWriteData = ()=>{
            this.setState({
                isWriteFormVisible: false
            });
        }, this.handleOpenWriteData = ()=>{
            this.setState({
                isWriteFormVisible: true
            });
        }, this.toggleSendToDashboard = ()=>{
            this.setState({
                isSendToDashboardVisible: !this.state.isSendToDashboardVisible
            });
        }, this.handleToggleStaticLegend = (isStaticLegend)=>{
            this.setState({
                isStaticLegend: isStaticLegend
            });
        }, this.onActiveQueryIndexChange = (activeQueryIndex)=>{
            this.setState({
                activeQueryIndex: activeQueryIndex
            });
        }, this.handleResetFocus = ()=>{
            return;
        };
        this.state = {
            isWriteFormVisible: false,
            isSendToDashboardVisible: false,
            isStaticLegend: false,
            isComponentMounted: false,
            activeQueryIndex: 0
        };
        props.resetQueryStatuses();
        props.onResetTimeMachine();
    }
    async componentDidMount() {
        const { autoRefresh: autoRefresh } = this.props;
        (0, $a926ccb172fe03ce$export$a3ea0b2d0765f52e).poll(autoRefresh);
        this.setState({
            isComponentMounted: true
        });
    }
    componentDidUpdate(prevProps) {
        const { autoRefresh: autoRefresh } = this.props;
        if (autoRefresh !== prevProps.autoRefresh) (0, $a926ccb172fe03ce$export$a3ea0b2d0765f52e).poll(autoRefresh);
    }
    componentWillUnmount() {
        (0, $a926ccb172fe03ce$export$a3ea0b2d0765f52e).stopPolling();
    }
    render() {
        const { source: source, notify: notify, sources: sources, timeZone: timeZone, timeRange: timeRange, fluxLinks: fluxLinks, queryStatuses: queryStatuses, editQueryStatus: editQueryStatus, updateSourceLink: updateSourceLink, onSetTimeZone: onSetTimeZone, autoRefresh: autoRefresh } = this.props;
        const { isStaticLegend: isStaticLegend, isComponentMounted: isComponentMounted } = this.state;
        if (!isComponentMounted) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $810ad5a94daa03b8$export$2e2bcd8739ae039), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, this.writeDataForm, this.sendToDashboardOverlay, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "deceo--page"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dfadf026237d58c4$export$2e2bcd8739ae039), {
            notify: notify,
            source: source,
            isInCEO: false,
            sources: sources,
            fluxLinks: fluxLinks,
            templates: this.templates,
            queryStatuses: queryStatuses,
            isStaticLegend: isStaticLegend,
            editQueryStatus: editQueryStatus,
            updateSourceLink: updateSourceLink,
            onResetFocus: this.handleResetFocus,
            onToggleStaticLegend: this.handleToggleStaticLegend,
            onActiveQueryIndexChange: this.onActiveQueryIndexChange,
            refresh: autoRefresh
        }, (activeEditorTab, onSetActiveEditorTab)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $4937cd758057a690$export$2e2bcd8739ae039), {
                timeZone: timeZone,
                timeRange: timeRange,
                onSetTimeZone: onSetTimeZone,
                activeEditorTab: activeEditorTab,
                onOpenWriteData: this.handleOpenWriteData,
                onSetActiveEditorTab: onSetActiveEditorTab,
                toggleSendToDashboard: this.toggleSendToDashboard
            }))));
    }
    get writeDataForm() {
        const { source: source, errorThrownAction: errorThrownAction, writeLineProtocol: writeLineProtocol, queryType: queryType } = this.props;
        const { isWriteFormVisible: isWriteFormVisible } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $827fcd4cb090ac0e$export$2e2bcd8739ae039), {
            visible: isWriteFormVisible
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $59a17a34051de5aa$export$2e2bcd8739ae039), {
            source: source,
            errorThrown: errorThrownAction,
            selectedDatabase: this.selectedDatabase,
            onClose: this.handleCloseWriteData,
            writeLineProtocol: writeLineProtocol,
            useV2: queryType === 'flux'
        }));
    }
    get sendToDashboardOverlay() {
        const { source: source, dashboards: dashboards, sendDashboardCell: sendDashboardCell, handleGetDashboards: handleGetDashboards, notify: notify } = this.props;
        const { isSendToDashboardVisible: isSendToDashboardVisible, isStaticLegend: isStaticLegend, activeQueryIndex: activeQueryIndex } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $091cfcd49e339acd$export$2e2bcd8739ae039), {
            requiredRole: (0, $a7910b1002260d34$export$f715f7e27dea2abf)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $827fcd4cb090ac0e$export$2e2bcd8739ae039), {
            visible: isSendToDashboardVisible
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $39b3d9c631bf809f$export$2e2bcd8739ae039), {
            notify: notify,
            onCancel: this.toggleSendToDashboard,
            source: source,
            dashboards: dashboards,
            activeQueryIndex: activeQueryIndex,
            handleGetDashboards: handleGetDashboards,
            sendDashboardCell: sendDashboardCell,
            isStaticLegend: isStaticLegend
        })));
    }
    get templates() {
        const { timeRange: timeRange } = this.props;
        const low = timeRange.lower;
        const up = timeRange.upper;
        const lowerTemplateType = low && low.includes(':') ? (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).TimeStamp : (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Constant;
        const upperTemplateType = up && up.includes(':') ? (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).TimeStamp : (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Constant;
        const lowerTemplateValueType = low && low.includes(':') ? (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).TimeStamp : (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).Constant;
        const upperTemplateValueType = up && up.includes(':') ? (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).TimeStamp : (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).Constant;
        const dashboardTime = {
            id: 'dashtime',
            tempVar: (0, $e10a8602f56394e3$export$24969386fef72130),
            type: lowerTemplateType,
            label: 'minimum bound on dashboard time',
            values: [
                {
                    value: low,
                    type: lowerTemplateValueType,
                    selected: true,
                    localSelected: true
                }
            ]
        };
        const upperDashboardTime = {
            id: 'upperdashtime',
            tempVar: (0, $e10a8602f56394e3$export$cb0056005b9f8f1c),
            type: upperTemplateType,
            label: 'upper bound on dashboard time',
            values: [
                {
                    value: up || 'now()',
                    type: upperTemplateValueType,
                    selected: true,
                    localSelected: true
                }
            ]
        };
        return [
            ...(0, $e10a8602f56394e3$export$b8020e85ad90bfe5),
            dashboardTime,
            upperDashboardTime
        ];
    }
    get selectedDatabase() {
        return null;
    }
}
const $0a9cd0209b6d60fa$var$DataExplorer2 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($0a9cd0209b6d60fa$var$DataExplorer);
const $0a9cd0209b6d60fa$var$ConnectedDataExplorer = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b029b3af5fc2e5d5$export$7d87f8b720f7653e), null, (container)=>{
        const { state: state } = container;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($0a9cd0209b6d60fa$var$DataExplorer2, {
            ...props,
            queryDrafts: state.queryDrafts,
            queryType: state.queryType,
            draftScript: state.draftScript,
            timeRange: state.timeRange,
            script: state.script,
            onInitFluxScript: container.handleInitFluxScript,
            onUpdateQueryDrafts: container.handleUpdateQueryDrafts,
            onResetTimeMachine: container.reset
        });
    });
};
const $0a9cd0209b6d60fa$var$mstp = (state)=>{
    const { app: { persisted: { autoRefresh: autoRefresh, timeZone: timeZone } }, dataExplorer: { timeRange: timeRange, queryStatuses: queryStatuses, sourceLink: sourceLink }, dashboardUI: { dashboards: dashboards }, sources: sources, links: links } = state;
    return {
        timeZone: timeZone,
        fluxLinks: links.flux,
        autoRefresh: autoRefresh,
        timeRange: timeRange,
        dashboards: dashboards,
        sources: sources,
        queryStatuses: queryStatuses,
        sourceLink: sourceLink
    };
};
const $0a9cd0209b6d60fa$var$mdtp = {
    handleChooseAutoRefresh: (0, $cac020f89fc6c82e$export$5a78de5758caee29),
    errorThrownAction: (0, $eb59f3357c899aaf$export$1550334dc0519d45),
    writeLineProtocol: (0, $6ca895622edb68b7$export$43633ee54025c5cb),
    handleGetDashboards: (0, $9859d1d8ae3f2524$export$e5b1f1e10b3d70a7),
    sendDashboardCell: (0, $9859d1d8ae3f2524$export$bbb7779e826cf2eb),
    editQueryStatus: (0, $c38c93c59a242a56$export$8a793b1eac3a2),
    resetQueryStatuses: (0, $c38c93c59a242a56$export$ef2d6e8602fa6794),
    notify: (0, $205d139de2918454$export$5e14cdade93d6f7b),
    updateSourceLink: (0, $c38c93c59a242a56$export$a84df2ef2f50de53),
    onSetTimeZone: (0, $cac020f89fc6c82e$export$93c56f26d2728d8d)
};
var $0a9cd0209b6d60fa$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($0a9cd0209b6d60fa$var$mstp, $0a9cd0209b6d60fa$var$mdtp)($0a9cd0209b6d60fa$var$ConnectedDataExplorer);



class $f0d2bd67d46a316e$var$DataExplorerPage extends (0, $NdCUR.PureComponent) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "page"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $0a9cd0209b6d60fa$export$2e2bcd8739ae039), {
            source: this.props.source
        }));
    }
}
var $f0d2bd67d46a316e$export$2e2bcd8739ae039 = (0, $c8cd79e362cba2a4$export$a520fb22fccea800)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($f0d2bd67d46a316e$var$DataExplorerPage));


var $fec286da15954ea1$export$2e2bcd8739ae039 = (0, $f0d2bd67d46a316e$export$2e2bcd8739ae039);



var $NdCUR = parcelRequire("NdCUR");



// download.js v4.2, by dandavis; 2008-2016. [CCBY2] see http://danml.com/download.html for tests/usage
// v1 landed a FF+Chrome compat way of downloading strings to local un-named files, upgraded to use a hidden frame and optional mime
// v2 added named files via a[download], msSaveBlob, IE (10+) support, and window.URL support for larger+faster saves than dataURLs
// v3 added dataURL and Blob Input, bind-toggle arity, and legacy dataURL fallback was improved with force-download mime and base64 support. 3.1 improved safari handling.
// v4 adds AMD/UMD, commonJS, and plain browser support
// v4.1 adds url download capability via solo URL argument (same domain/CORS only)
// v4.2 adds semantic variable names, long (over 2MB) dataURL support, and hidden by default temp anchors
// https://github.com/rndme/download
const $4c41918c04bc80d6$var$dataUrlToBlob = (myBlob, strUrl)=>{
    const parts = strUrl.split(/[:;,]/), type = parts[1], decoder = parts[2] === 'base64' ? atob : decodeURIComponent, binData = decoder(parts.pop()), mx = binData.length, uiArr = new Uint8Array(mx);
    for(let i = 0; i < mx; ++i)uiArr[i] = binData.charCodeAt(i);
    return new myBlob([
        uiArr
    ], {
        type: type
    });
};
const $4c41918c04bc80d6$var$download = (data, strFileName, strMimeType)=>{
    const _window = window // this script is only for browsers anyway...
    ;
    const defaultMime = 'application/octet-stream' // this default mime also triggers iframe downloads
    ;
    let mimeType = strMimeType || defaultMime;
    let payload = data;
    let url = !strFileName && !strMimeType && payload;
    const anchor = document.createElement('a');
    const toString = (a)=>`${a}`;
    let myBlob = _window.Blob || _window.MozBlob || _window.WebKitBlob || toString;
    let fileName = strFileName || 'download';
    let reader;
    myBlob = myBlob.call ? myBlob.bind(_window) : Blob;
    if (url && url.length < 2048) {
        // if no filename and no mime, assume a url was passed as the only argument
        fileName = url.split('/').pop().split('?')[0];
        anchor.href = url // assign href prop to temp anchor
        ;
        if (anchor.href.indexOf(url) !== -1) {
            // if the browser determines that it's a potentially valid url path:
            const ajax = new XMLHttpRequest();
            ajax.open('GET', url, true);
            ajax.responseType = 'blob';
            ajax.onload = function(e) {
                $4c41918c04bc80d6$var$download(e.target.response, fileName, defaultMime);
            };
            setTimeout(function() {
                ajax.send();
            }, 0) // allows setting custom ajax headers using the return:
            ;
            return ajax;
        } // end if valid url?
    } // end if url?
    const saver = (saverUrl, winMode)=>{
        if ('download' in anchor) {
            // html5 A[download]
            anchor.href = saverUrl;
            anchor.setAttribute('download', fileName);
            anchor.className = 'download-js-link';
            anchor.innerHTML = 'downloading...';
            anchor.style.display = 'none';
            document.body.appendChild(anchor);
            setTimeout(function() {
                anchor.click();
                document.body.removeChild(anchor);
                if (winMode === true) setTimeout(function() {
                    _window.URL.revokeObjectURL(anchor.href);
                }, 250);
            }, 66);
            return true;
        }
        // do iframe dataURL download (old ch+FF):
        const f = document.createElement('iframe');
        document.body.appendChild(f);
        if (!winMode) // force a mime that will download:
        url = `data:${url.replace(/^data:([\w/\-+]+)/, defaultMime)}`;
        f.src = url;
        setTimeout(function() {
            document.body.removeChild(f);
        }, 333);
    } // end saver
    ;
    // go ahead and download dataURLs right away
    if (/^data:[\w+-]+\/[\w+-]+[,;]/.test(payload)) {
        if (payload.length > 2096103.424 && myBlob !== toString) {
            payload = $4c41918c04bc80d6$var$dataUrlToBlob(myBlob, payload);
            mimeType = payload.type || defaultMime;
        } else return navigator.msSaveBlob // IE10 can't do a[download], only Blobs:
         ? navigator.msSaveBlob($4c41918c04bc80d6$var$dataUrlToBlob(myBlob, payload), fileName) : saver(payload) // everyone else can save dataURLs un-processed
        ;
    } // end if dataURL passed?
    const blob = payload instanceof myBlob ? payload : new myBlob([
        payload
    ], {
        type: mimeType
    });
    if (navigator.msSaveBlob) // IE10+ : (has Blob, but not a[download] or URL)
    return navigator.msSaveBlob(blob, fileName);
    if (_window.URL) // simple fast and modern way using Blob and URL:
    saver(_window.URL.createObjectURL(blob), true);
    else {
        // handle non-Blob()+non-URL browsers:
        if (typeof blob === 'string' || blob.constructor === toString) try {
            return saver(`data:${mimeType};base64,${_window.btoa(blob)}`);
        } catch (y) {
            return saver(`data:${mimeType},${encodeURIComponent(blob)}`);
        }
        // Blob but not URL support:
        reader = new FileReader();
        reader.onload = function() {
            saver(this.result);
        };
        reader.readAsDataURL(blob);
    }
    return true;
} /* end download() */ ;
var $4c41918c04bc80d6$export$2e2bcd8739ae039 = $4c41918c04bc80d6$var$download;



var $hBdgJ = parcelRequire("hBdgJ");

var $NdCUR = parcelRequire("NdCUR");


var $NdCUR = parcelRequire("NdCUR");


var $hBdgJ = parcelRequire("hBdgJ");


var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");


class $8008717819fc7a5f$var$ConfirmButton extends (0, $NdCUR.PureComponent) {
    static{
        this.defaultProps = {
            confirmText: 'Confirm',
            type: 'btn-default',
            size: 'btn-sm',
            square: false
        };
    }
    constructor(props){
        super(props), this.handleButtonClick = ()=>{
            if (this.props.disabled) return;
            this.setState({
                expanded: !this.state.expanded
            });
        }, this.handleConfirmClick = ()=>{
            this.setState({
                expanded: false
            });
            this.props.confirmAction();
        }, this.handleClickOutside = ()=>{
            this.setState({
                expanded: false
            });
        };
        this.state = {
            expanded: false
        };
    }
    render() {
        const { text: text, confirmText: confirmText, icon: icon, style: style, testId: testId } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1f11d3536bc98f8a$export$c16e4f034c84cb3f), {
            onClickOutside: this.handleClickOutside
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.className,
            style: style,
            onClick: this.handleButtonClick,
            ref: (r)=>this.buttonDiv = r,
            title: confirmText,
            "data-test": testId
        }, icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: `icon ${icon}`
        }), text && text, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.tooltipClassName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "confirm-button--confirmation",
            onClick: this.handleConfirmClick,
            ref: (r)=>this.tooltipDiv = r,
            "data-test": "confirm-btn"
        }, confirmText))));
    }
    get className() {
        const { type: type, size: size, square: square, disabled: disabled, customClass: customClass } = this.props;
        const { expanded: expanded } = this.state;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))(`confirm-button btn ${type} ${size}`, {
            [customClass]: customClass,
            'btn-square': square,
            active: expanded,
            disabled: disabled
        });
    }
    get tooltipClassName() {
        const { position: position } = this.props;
        if (position) return `confirm-button--tooltip ${position}`;
        if (!this.buttonDiv || !this.tooltipDiv) return 'confirm-button--tooltip bottom';
        const windowWidth = window.innerWidth;
        const buttonRect = this.buttonDiv.getBoundingClientRect();
        const tooltipRect = this.tooltipDiv.getBoundingClientRect();
        const rightGap = windowWidth - buttonRect.right;
        if (tooltipRect.width / 2 > rightGap) return 'confirm-button--tooltip left';
        return 'confirm-button--tooltip bottom';
    }
}
var $8008717819fc7a5f$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($8008717819fc7a5f$var$ConfirmButton);




class $2e874bb29d38a8bc$var$DashboardsTable extends (0, $NdCUR.PureComponent) {
    render() {
        const { dashboards: dashboards, dashboardsStatus: dashboardsStatus, dashboardLink: dashboardLink, onCloneDashboard: onCloneDashboard, onDeleteDashboard: onDeleteDashboard, onExportDashboard: onExportDashboard } = this.props;
        if (dashboardsStatus === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading || dashboardsStatus === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).NotStarted) return this.renderLoadingState();
        if (dashboardsStatus === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error) return this.renderErrorState();
        if (!dashboards.length) return this.renderEmptyState();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("table", {
            className: "table v-center admin-table table-highlight"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", null, "Name"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", null, "Template Variables"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tbody", null, (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).sortBy(dashboards, (d)=>d.name.toLowerCase()).map((dashboard)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tr", {
                key: dashboard.id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ba1cc4424c00aefe$export$2e2bcd8739ae039), {
                to: `${dashboardLink}/dashboards/${dashboard.id}`,
                "data-test": `dashboard-link-${dashboard.id}`
            }, dashboard.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", null, this.getDashboardTemplates(dashboard)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
                className: "text-right"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $091cfcd49e339acd$export$2e2bcd8739ae039), {
                requiredRole: (0, $a7910b1002260d34$export$1d39a112fd67439d),
                replaceWithIfNotAuthorized: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
                className: "btn btn-xs btn-default table--show-on-row-hover",
                onClick: onExportDashboard(dashboard)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
                className: "icon export"
            }), "Export")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $091cfcd49e339acd$export$2e2bcd8739ae039), {
                requiredRole: (0, $a7910b1002260d34$export$f715f7e27dea2abf),
                replaceWithIfNotAuthorized: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
                className: "btn btn-xs btn-default table--show-on-row-hover",
                onClick: onCloneDashboard(dashboard)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
                className: "icon duplicate"
            }), "Clone"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $8008717819fc7a5f$export$2e2bcd8739ae039), {
                confirmAction: onDeleteDashboard(dashboard),
                size: "btn-xs",
                type: "btn-danger",
                text: "Delete",
                customClass: "table--show-on-row-hover"
            }))))))));
    }
    renderLoadingState() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "generic-empty-state"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", null, "Loading dashboards..."));
    }
    renderErrorState() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "generic-empty-state"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", null, "Unable to load dashboards"));
    }
    renderEmptyState() {
        const { onCreateDashboard: onCreateDashboard } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $091cfcd49e339acd$export$2e2bcd8739ae039), {
            requiredRole: (0, $a7910b1002260d34$export$f715f7e27dea2abf),
            replaceWithIfNotAuthorized: this.unauthorizedEmptyState
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "generic-empty-state"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", null, "Looks like you don\u2019t have any dashboards"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-sm btn-primary",
            onClick: onCreateDashboard,
            "data-test": "create-dashboard"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon plus"
        }), " Create Dashboard")));
    }
    get unauthorizedEmptyState() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "generic-empty-state"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", {
            style: {
                margin: '90px 0'
            }
        }, "Looks like you don\u2019t have any dashboards"));
    }
    constructor(...args){
        super(...args), this.getDashboardTemplates = (dashboard)=>{
            const templates = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(dashboard, 'templates', []);
            if (templates.length) return templates.map((tv)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("code", {
                    className: "table--temp-var",
                    key: tv.id
                }, tv.tempVar));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
                className: "empty-string"
            }, "None");
        };
    }
}
var $2e874bb29d38a8bc$export$2e2bcd8739ae039 = $2e874bb29d38a8bc$var$DashboardsTable;



var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");





var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");
let $c75c159839663ccc$var$dragCounter = 0;
class $c75c159839663ccc$var$DragAndDrop extends (0, $NdCUR.PureComponent) {
    static{
        this.defaultProps = {
            submitText: 'Write this File',
            submitOnDrop: false,
            submitOnUpload: false,
            compact: false
        };
    }
    constructor(props){
        super(props), this.handleWindowDragOver = (event)=>{
            event.preventDefault();
        }, this.handleSubmit = ()=>{
            const { handleSubmit: handleSubmit } = this.props;
            const { uploadContent: uploadContent, fileName: fileName } = this.state;
            handleSubmit(uploadContent, fileName);
        }, this.handleFileClick = (e)=>{
            const file = e.currentTarget.files[0];
            if (!file) return;
            e.preventDefault();
            e.stopPropagation();
            const reader = new FileReader();
            reader.readAsText(file);
            reader.onload = (loadEvent)=>{
                this.setState({
                    uploadContent: loadEvent.target.result,
                    fileName: file.name
                }, this.submitOnUpload);
            };
        }, this.handleFileDrop = (e)=>{
            const file = e.dataTransfer.files[0];
            this.setState({
                dragClass: 'drag-none'
            });
            if (!file) return;
            e.preventDefault();
            e.stopPropagation();
            const reader = new FileReader();
            reader.readAsText(file);
            reader.onload = (loadEvent)=>{
                this.setState({
                    uploadContent: loadEvent.target.result,
                    fileName: file.name
                }, this.submitOnDrop);
            };
        }, this.handleFileOpen = ()=>{
            const { uploadContent: uploadContent } = this.state;
            if (uploadContent === '') this.fileInput.click();
        }, this.handleCancelFile = ()=>{
            this.setState({
                uploadContent: ''
            });
            this.fileInput.value = '';
        }, this.handleDragEnter = (e)=>{
            $c75c159839663ccc$var$dragCounter += 1;
            e.preventDefault();
            this.setState({
                dragClass: 'drag-over'
            });
        }, this.handleDragLeave = (e)=>{
            $c75c159839663ccc$var$dragCounter -= 1;
            e.preventDefault();
            if ($c75c159839663ccc$var$dragCounter === 0) this.setState({
                dragClass: 'drag-none'
            });
        };
        this.state = {
            inputContent: null,
            uploadContent: '',
            fileName: '',
            dragClass: 'drag-none'
        };
    }
    componentDidMount() {
        window.addEventListener('dragover', this.handleWindowDragOver);
        window.addEventListener('drop', this.handleFileDrop);
        window.addEventListener('dragenter', this.handleDragEnter);
        window.addEventListener('dragleave', this.handleDragLeave);
    }
    componentWillUnmount() {
        window.removeEventListener('dragover', this.handleWindowDragOver);
        window.removeEventListener('drop', this.handleFileDrop);
        window.removeEventListener('dragenter', this.handleDragEnter);
        window.removeEventListener('dragleave', this.handleDragLeave);
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.containerClass
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.dragAreaClass,
            onClick: this.handleFileOpen
        }, this.dragAreaHeader, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.infoClass
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            type: "file",
            ref: (r)=>this.fileInput = r,
            className: "drag-and-drop--input",
            accept: this.fileTypesToAccept,
            onChange: this.handleFileClick
        }), this.buttons));
    }
    get fileTypesToAccept() {
        const { fileTypesToAccept: fileTypesToAccept } = this.props;
        if (!fileTypesToAccept) return '*';
        return fileTypesToAccept;
    }
    get containerClass() {
        const { dragClass: dragClass } = this.state;
        const { compact: compact } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('drag-and-drop', {
            compact: compact,
            [dragClass]: true
        });
    }
    get infoClass() {
        const { uploadContent: uploadContent } = this.state;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('drag-and-drop--graphic', {
            success: uploadContent
        });
    }
    get dragAreaClass() {
        const { uploadContent: uploadContent } = this.state;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('drag-and-drop--form', {
            active: !uploadContent
        });
    }
    get dragAreaHeader() {
        const { uploadContent: uploadContent, fileName: fileName } = this.state;
        if (uploadContent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "drag-and-drop--header selected"
        }, fileName);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "drag-and-drop--header empty"
        }, "Drop a file here or click to upload");
    }
    get buttons() {
        const { uploadContent: uploadContent } = this.state;
        const { submitText: submitText, submitOnDrop: submitOnDrop } = this.props;
        if (!uploadContent) return null;
        if (submitOnDrop) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "drag-and-drop--buttons"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-sm btn-default",
            onClick: this.handleCancelFile
        }, "Cancel"));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "drag-and-drop--buttons"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-sm btn-success",
            onClick: this.handleSubmit
        }, submitText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-sm btn-default",
            onClick: this.handleCancelFile
        }, "Cancel"));
    }
    submitOnDrop() {
        const { submitOnDrop: submitOnDrop } = this.props;
        if (submitOnDrop) this.handleSubmit();
    }
    submitOnUpload() {
        const { submitOnUpload: submitOnUpload } = this.props;
        if (submitOnUpload) this.handleSubmit();
    }
}
var $c75c159839663ccc$export$2e2bcd8739ae039 = $c75c159839663ccc$var$DragAndDrop;


// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");


// Libraries

var $hBdgJ = parcelRequire("hBdgJ");


const $f0b5f26d4a85a01a$var$REGEX_SOURCE_ID = /sources\/(\d+)/g;
const $f0b5f26d4a85a01a$export$9246c7cf90f60d71 = (source, cells, importedSources, variables = [])=>{
    let sourcesCells = {};
    const sourceMappings = {};
    const sourceInfo = $f0b5f26d4a85a01a$export$843f44d5becac992(source);
    const cellsWithNoSource = [];
    sourcesCells = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).reduce(cells, (acc, c)=>{
        const cellInfo = {
            id: c.i,
            name: c.name
        };
        const query = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(c, 'queries.0', null);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEmpty(query)) return acc;
        const sourceLink = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(query, 'source', '');
        if (!sourceLink) {
            cellsWithNoSource.push(cellInfo);
            return acc;
        }
        let importedSourceID = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).findKey(importedSources, (is)=>is.link === sourceLink);
        if (!importedSourceID) {
            const sourceLinkSID = $f0b5f26d4a85a01a$export$5879e92aa1828583(sourceLink);
            if (!sourceLinkSID) return acc;
            importedSourceID = sourceLinkSID;
        }
        if (acc[importedSourceID]) acc[importedSourceID].push(cellInfo);
        else acc[importedSourceID] = [
            cellInfo
        ];
        sourceMappings[importedSourceID] = sourceInfo;
        return acc;
    }, sourcesCells);
    // add sources also for variables
    variables.forEach((v)=>{
        if (v.sourceID && !sourceMappings[v.sourceID]) {
            sourceMappings[v.sourceID] = sourceInfo;
            sourcesCells[v.sourceID] = [];
        }
    });
    if (cellsWithNoSource.length) {
        sourcesCells[0, $9a9ec629fdd38845$export$1b9fd6004a8bc39d] = cellsWithNoSource;
        sourceMappings[0, $9a9ec629fdd38845$export$1b9fd6004a8bc39d] = (0, $9a9ec629fdd38845$export$e7bcaad447239ce9);
    }
    return {
        sourcesCells: sourcesCells,
        sourceMappings: sourceMappings
    };
};
const $f0b5f26d4a85a01a$export$a70c03abeaa7afa2 = (cells, sourceMappings, importedSources)=>{
    const mappedCells = cells.map((c)=>{
        const query = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(c, 'queries.0', null);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEmpty(query)) return c;
        const sourceLink = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(query, 'source', '');
        if (!sourceLink) return $f0b5f26d4a85a01a$export$a19748a878f62d88(sourceMappings, c, (0, $9a9ec629fdd38845$export$1b9fd6004a8bc39d));
        let importedSourceID = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).findKey(importedSources, (is)=>is.link === sourceLink);
        if (!importedSourceID) {
            const sourceLinkSID = $f0b5f26d4a85a01a$export$5879e92aa1828583(sourceLink);
            if (!sourceLinkSID) return c;
            importedSourceID = sourceLinkSID;
        }
        if (importedSourceID) return $f0b5f26d4a85a01a$export$a19748a878f62d88(sourceMappings, c, importedSourceID);
        return c;
    });
    return mappedCells;
};
const $f0b5f26d4a85a01a$export$a19748a878f62d88 = (sourceMappings, cell, sourceID)=>{
    const mappedSourceLink = sourceMappings[sourceID].link;
    let queries = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(cell, 'queries', []);
    if (queries.length) queries = queries.map((q)=>{
        return {
            ...q,
            source: mappedSourceLink
        };
    });
    return {
        ...cell,
        queries: queries
    };
};
const $f0b5f26d4a85a01a$export$843f44d5becac992 = (source)=>{
    return {
        name: source.name,
        id: source.id,
        link: source.links.self
    };
};
const $f0b5f26d4a85a01a$export$5879e92aa1828583 = (sourceLink)=>{
    // first capture group
    const matcher = new RegExp($f0b5f26d4a85a01a$var$REGEX_SOURCE_ID);
    const sourceLinkSID = matcher.exec(sourceLink)[1];
    return sourceLinkSID;
};



class $6ce98cb805601aef$var$ImportDashboardMappings extends (0, $NdCUR.Component) {
    constructor(props){
        super(props), this.handleChooseDropdown = (item)=>{
            const { sourceMappings: sourceMappings } = this.state;
            sourceMappings[item.importedSourceID] = item.sourceInfo;
            this.setState({
                sourceMappings: sourceMappings
            });
        }, this.handleSubmit = ()=>{
            const { cells: cells, onSubmit: onSubmit, importedSources: importedSources } = this.props;
            const { sourceMappings: sourceMappings } = this.state;
            const mappedCells = (0, $f0b5f26d4a85a01a$export$a70c03abeaa7afa2)(cells, sourceMappings, importedSources);
            onSubmit(mappedCells, sourceMappings);
        };
        this.state = {
            sourcesCells: {},
            sourceMappings: {}
        };
    }
    componentDidMount() {
        const { cells: cells, importedSources: importedSources, source: source, variables: variables } = this.props;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEmpty(cells)) return;
        const { sourcesCells: sourcesCells, sourceMappings: sourceMappings } = (0, $f0b5f26d4a85a01a$export$9246c7cf90f60d71)(source, cells, importedSources, variables);
        this.setState({
            sourcesCells: sourcesCells,
            sourceMappings: sourceMappings
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, this.description, this.table, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "dash-map--footer"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "dash-map--submit btn btn-sm btn-success",
            onClick: this.handleSubmit
        }, "Done")));
    }
    get noMappings() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            "data-test": "no-mapping",
            className: "generic-empty-state dash-map--empty"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h5", null, "No source mappings required"));
    }
    get arrow() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "fancytable--td provider--arrow"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", null));
    }
    get description() {
        const description = [
            'Match the sources from your imported dashboard with your available sources below. A ',
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("strong", {
                key: "emphasis"
            }, "Dynamic Source"),
            ' allows the cell source to change based on your currently selected source.'
        ];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "alert alert-grey"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon graphline-2"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "alert-message"
        }, description));
    }
    get table() {
        const { sourcesCells: sourcesCells } = this.state;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEmpty(sourcesCells)) return this.noMappings;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("table", {
            className: "table dash-map--table"
        }, this.header, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tbody", null, this.tableBody));
    }
    get tableBody() {
        const { importedSources: importedSources } = this.props;
        const { sourcesCells: sourcesCells } = this.state;
        const rows = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).reduce(sourcesCells, (acc, __, i)=>{
            if (i !== (0, $9a9ec629fdd38845$export$1b9fd6004a8bc39d) && sourcesCells[i]) {
                const sourceName = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(importedSources, `${i}.name`, 'Source');
                acc.push(this.getRow(sourceName, i));
            }
            return acc;
        }, []);
        if (sourcesCells[0, $9a9ec629fdd38845$export$1b9fd6004a8bc39d]) {
            const noSourceRow = this.getRow('Dynamic Source', (0, $9a9ec629fdd38845$export$1b9fd6004a8bc39d));
            rows.push(noSourceRow);
        }
        return rows;
    }
    getRow(sourceName, sourceID) {
        let sourceLabel = `${sourceName} (${sourceID})`;
        if (sourceID === (0, $9a9ec629fdd38845$export$1b9fd6004a8bc39d)) sourceLabel = sourceName;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tr", {
            key: sourceID
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            className: "dash-map--table-cell dash-map--table-half"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "dash-map--source",
            "data-test": "source-label"
        }, sourceLabel), this.getCellsForSource(sourceID), this.getVariablesForSource(sourceID)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            className: "dash-map--table-cell dash-map--table-center"
        }, this.arrow), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            className: "dash-map--table-cell dash-map--table-half"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ca4f14339173643c$export$2e2bcd8739ae039), {
            className: "dropdown-stretch",
            buttonColor: "btn-default",
            buttonSize: "btn-sm",
            items: this.getSourceItems(sourceID),
            onChoose: this.handleChooseDropdown,
            selected: this.getSelected(sourceID)
        })));
    }
    getSourceItems(importedSourceID) {
        const { sources: sources } = this.props;
        const sourceItems = sources.map((source)=>{
            const sourceInfo = (0, $f0b5f26d4a85a01a$export$843f44d5becac992)(source);
            const sourceMap = {
                sourceInfo: sourceInfo,
                importedSourceID: importedSourceID,
                text: source.name
            };
            return sourceMap;
        });
        sourceItems.push({
            ...(0, $9a9ec629fdd38845$export$46f395fdcdd36a73),
            importedSourceID: importedSourceID
        });
        return sourceItems;
    }
    get header() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
            className: "dash-map--table-half"
        }, "Sources in Dashboard"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
            className: "dash-map--table-center"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
            className: "dash-map--table-half"
        }, "Available Sources")));
    }
    getSelected(importedSourceID) {
        const { sources: sources } = this.props;
        const { sourceMappings: sourceMappings } = this.state;
        const sourceMapping = sourceMappings[importedSourceID];
        if (sourceMapping) return sourceMappings[importedSourceID].name;
        return sources[0].name;
    }
    getCellsForSource(sourceID) {
        const { sourcesCells: sourcesCells } = this.state;
        if (sourcesCells[sourceID].length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "dash-map--header"
        }, "Cells that use this Source:"), (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).map(sourcesCells[sourceID], (c)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                className: "dash-map--cell",
                key: c.id
            }, c.name);
        }));
    }
    getVariablesForSource(sourceID) {
        const { variables: variables } = this.props;
        const sourceVariables = variables.filter((x)=>x.sourceID === sourceID);
        if (sourceVariables.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "dash-map--header"
        }, "Variables that use this source:"), (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).map(sourceVariables, (v)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                className: "dash-map--cell",
                key: `var-${v.id}`
            }, v.tempVar);
        }));
    }
}
var $6ce98cb805601aef$export$2e2bcd8739ae039 = $6ce98cb805601aef$var$ImportDashboardMappings;



class $a4b66c4b9ab7f90b$var$ImportDashboardOverlay extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleContinueImport = (uploadContent, fileName)=>{
            const { notify: notify } = this.props;
            const fileExtensionRegex = new RegExp(`${this.validFileExtension}$`);
            if (!fileName.match(fileExtensionRegex)) {
                notify((0, $ec1f42de4faacc37$export$bdd074588a01033f)(fileName, 'Please import a JSON file'));
                return;
            }
            try {
                const { dashboard: dashboard, meta: meta } = JSON.parse(uploadContent);
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEmpty(dashboard)) {
                    const cells = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(dashboard, 'cells', []);
                    const importedSources = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(meta, 'sources', {});
                    const templates = dashboard.templates || [];
                    templates.forEach((t)=>{
                        if (t.sourceID && t.sourceID !== 'dynamic' && !importedSources[t.sourceID]) importedSources[t.sourceID] = {
                            name: `Variable source ${t.sourceID}`,
                            link: `/chronograf/v1/sources/${t.sourceID}`
                        };
                    });
                    this.setState({
                        cells: cells,
                        dashboard: dashboard,
                        importedSources: importedSources,
                        step: "mapping"
                    });
                } else notify((0, $ec1f42de4faacc37$export$bdd074588a01033f)(fileName, 'No dashboard found in file'));
            } catch (error) {
                notify((0, $ec1f42de4faacc37$export$bdd074588a01033f)(fileName, error));
            }
        }, this.handleUploadDashboard = (cells, mappings)=>{
            const { dashboard: dashboard } = this.state;
            const { onImportDashboard: onImportDashboard, onDismissOverlay: onDismissOverlay } = this.props;
            const templates = (dashboard.templates || []).map((x)=>{
                if (!x.sourceID) return x;
                const mapping = mappings[x.sourceID];
                return {
                    ...x,
                    sourceID: mapping ? mapping.id : undefined
                };
            });
            onImportDashboard({
                ...dashboard,
                cells: cells,
                templates: templates
            });
            onDismissOverlay();
        };
        this.state = {
            cells: [],
            dashboard: null,
            importedSources: {},
            isImportable: false,
            step: "import"
        };
    }
    render() {
        const { onDismissOverlay: onDismissOverlay } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1868bdace58643df$export$2e2bcd8739ae039), {
            maxWidth: 800
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1372e03f76900c5b$export$2e2bcd8739ae039), {
            title: this.title,
            onDismiss: onDismissOverlay
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1e8c886c7914a527$export$2e2bcd8739ae039), null, this.renderStep));
    }
    get renderStep() {
        const { step: step, importedSources: importedSources, cells: cells, dashboard: dashboard } = this.state;
        const { source: source, sources: sources } = this.props;
        switch(step){
            case "import":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c75c159839663ccc$export$2e2bcd8739ae039), {
                    submitText: "Continue",
                    fileTypesToAccept: this.validFileExtension,
                    handleSubmit: this.handleContinueImport
                });
            case "mapping":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $6ce98cb805601aef$export$2e2bcd8739ae039), {
                    cells: cells,
                    source: source,
                    sources: sources,
                    importedSources: importedSources,
                    variables: dashboard.templates || [],
                    onSubmit: this.handleUploadDashboard
                });
        }
    }
    get title() {
        const { step: step } = this.state;
        switch(step){
            case "import":
                return 'Import Dashboard';
            case "mapping":
                return 'Reconcile Sources';
        }
    }
    get validFileExtension() {
        return '.json';
    }
}
var $a4b66c4b9ab7f90b$export$2e2bcd8739ae039 = $a4b66c4b9ab7f90b$var$ImportDashboardOverlay;






class $d5045ee1678e086f$var$DashboardsPageContents extends (0, $NdCUR.Component) {
    constructor(props){
        super(props), this.filterDashboards = (searchTerm)=>{
            this.setState({
                searchTerm: searchTerm
            });
        }, this.handleToggleOverlay = ()=>{
            this.setState({
                isOverlayVisible: !this.state.isOverlayVisible
            });
        };
        this.state = {
            searchTerm: '',
            isOverlayVisible: false
        };
    }
    render() {
        const { onDeleteDashboard: onDeleteDashboard, onCreateDashboard: onCreateDashboard, onCloneDashboard: onCloneDashboard, onExportDashboard: onExportDashboard, dashboardLink: dashboardLink, dashboardsStatus: dashboardsStatus } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel dashboards-page-panel"
        }, this.renderPanelHeading, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel-body",
            "data-test": "dashboard-panel"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $2e874bb29d38a8bc$export$2e2bcd8739ae039), {
            dashboards: this.filteredDashboards,
            dashboardsStatus: dashboardsStatus,
            onDeleteDashboard: onDeleteDashboard,
            onCreateDashboard: onCreateDashboard,
            onCloneDashboard: onCloneDashboard,
            onExportDashboard: onExportDashboard,
            dashboardLink: dashboardLink
        })));
    }
    get renderPanelHeading() {
        const { onCreateDashboard: onCreateDashboard } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel-heading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h2", {
            className: "panel-title"
        }, this.panelTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel-controls"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $23c724436dc30b29$export$2e2bcd8739ae039), {
            placeholder: "Filter by Name...",
            onSearch: this.filterDashboards,
            testId: "dashboard-filter--input"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $091cfcd49e339acd$export$2e2bcd8739ae039), {
            requiredRole: (0, $a7910b1002260d34$export$f715f7e27dea2abf)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
            text: "Import Dashboard",
            icon: (0, $918c9f03a35fe03f$export$62c9c0cf752cde38).Import,
            onClick: this.handleToggleOverlay,
            testId: "import-dashboard--button"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
            text: "Create Dashboard",
            icon: (0, $918c9f03a35fe03f$export$62c9c0cf752cde38).Plus,
            onClick: onCreateDashboard,
            color: (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Primary,
            testId: "create-dashboard-button"
        }))))), this.renderImportOverlay);
    }
    get filteredDashboards() {
        const { dashboards: dashboards } = this.props;
        const { searchTerm: searchTerm } = this.state;
        return dashboards.filter((d)=>d.name.toLowerCase().includes(searchTerm.toLowerCase()));
    }
    get panelTitle() {
        const { dashboards: dashboards } = this.props;
        if (dashboards === null) return 'Loading Dashboards...';
        else if (dashboards.length === 1) return '1 Dashboard';
        return `${dashboards.length} Dashboards`;
    }
    get renderImportOverlay() {
        const { onImportDashboard: onImportDashboard, notify: notify, sources: sources, source: source } = this.props;
        const { isOverlayVisible: isOverlayVisible } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $827fcd4cb090ac0e$export$2e2bcd8739ae039), {
            visible: isOverlayVisible
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a4b66c4b9ab7f90b$export$2e2bcd8739ae039), {
            onDismissOverlay: this.handleToggleOverlay,
            onImportDashboard: onImportDashboard,
            notify: notify,
            source: source,
            sources: sources
        }));
    }
}
var $d5045ee1678e086f$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($d5045ee1678e086f$var$DashboardsPageContents);





var $hBdgJ = parcelRequire("hBdgJ");
const $747fabf129758fdd$export$2c47f7d55688d274 = (originalSources)=>(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).reduce(originalSources, (acc, source)=>{
        const { name: name, id: id, links: links } = source;
        const link = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(links, 'self', '');
        acc[id] = {
            name: name,
            link: link
        };
        return acc;
    }, {});
const $747fabf129758fdd$export$c6576c6980b15fc4 = (queries)=>{
    return queries.map((query)=>{
        return {
            ...query,
            source: query.source
        };
    });
};
const $747fabf129758fdd$export$7fefc223f238ece0 = (cells)=>{
    return cells.map((cell)=>{
        const { queries: queries } = cell;
        return {
            ...cell,
            queries: $747fabf129758fdd$export$c6576c6980b15fc4(queries)
        };
    });
};
const $747fabf129758fdd$export$1c205c024b2e12d0 = (originalSources, originalDashboard, chronografVersion)=>{
    const sources = $747fabf129758fdd$export$2c47f7d55688d274(originalSources);
    const meta = {
        chronografVersion: chronografVersion,
        sources: sources
    };
    const dashboard = {
        ...originalDashboard,
        cells: $747fabf129758fdd$export$7fefc223f238ece0(originalDashboard.cells)
    };
    return {
        meta: meta,
        dashboard: dashboard
    };
};











class $b611c9c333828d80$export$3a704d4ac2eeb2fe extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleCreateDashboard = async ()=>{
            const { source: { id: id }, router: { push: push } } = this.props;
            const { data: data } = await (0, $2adafb01fdaabc72$export$eadf0ac433611b3)((0, $9a9ec629fdd38845$export$d1428f2d92ff8e06));
            push(`/sources/${id}/dashboards/${data.id}`);
        }, this.handleCloneDashboard = (dashboard)=>async ()=>{
                const { source: { id: id }, router: { push: push } } = this.props;
                const { data: data } = await (0, $2adafb01fdaabc72$export$eadf0ac433611b3)({
                    ...dashboard,
                    name: `${dashboard.name} (clone)`
                });
                push(`/sources/${id}/dashboards/${data.id}`);
            }, this.handleDeleteDashboard = (dashboard)=>()=>{
                this.props.handleDeleteDashboard(dashboard);
            }, this.handleExportDashboard = (dashboard)=>async ()=>{
                const dashboardForDownload = await this.modifyDashboardForDownload(dashboard);
                try {
                    (0, $4c41918c04bc80d6$export$2e2bcd8739ae039)(JSON.stringify(dashboardForDownload, null, '\t'), `${dashboard.name}.json`, 'text/plain');
                    this.props.notify((0, $ec1f42de4faacc37$export$94dd573d58c195d3)(dashboard.name));
                } catch (error) {
                    this.props.notify((0, $ec1f42de4faacc37$export$7e798f539d06b4f7)(dashboard.name, error));
                }
            }, this.modifyDashboardForDownload = async (dashboard)=>{
            const { sources: sources, handleGetChronografVersion: handleGetChronografVersion } = this.props;
            const version = await handleGetChronografVersion();
            return (0, $747fabf129758fdd$export$1c205c024b2e12d0)(sources, dashboard, version);
        }, this.handleImportDashboard = async (dashboard)=>{
            const name = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(dashboard, 'name', (0, $9a9ec629fdd38845$export$de748f9c6ef6e33d));
            const cellsWithDefaultsApplied = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(dashboard, 'cells', []).map((c)=>({
                    ...(0, $9a9ec629fdd38845$export$5555fe053dab8f56),
                    ...c
                }));
            await this.props.handleImportDashboard({
                ...dashboard,
                name: name,
                cells: cellsWithDefaultsApplied
            });
        };
        this.state = {
            dashboardsStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).NotStarted
        };
    }
    async componentDidMount() {
        this.setState({
            dashboardsStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading
        });
        let dashboards;
        try {
            dashboards = await this.props.handleGetDashboards();
            const dashboardIDs = dashboards.map((d)=>d.id);
            this.props.retainRangesDashTimeV1(dashboardIDs);
            this.props.retainDashRefresh(dashboardIDs);
            this.setState({
                dashboardsStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done
            });
        } catch  {
            this.setState({
                dashboardsStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error
            });
        }
    }
    render() {
        const { dashboards: dashboards, notify: notify, sources: sources, source: source, isUsingAuth: isUsingAuth, me: me, logoutLink: logoutLink, links: links } = this.props;
        const { dashboardsStatus: dashboardsStatus } = this.state;
        const dashboardLink = `/sources/${this.props.source.id}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header.Left, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Title, {
            title: "Dashboards"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header.Right, {
            showSourceIndicator: true
        }, isUsingAuth && me.role === (0, $a7910b1002260d34$export$62bbf68aca1809f0) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21e072852e81bd41$export$2e2bcd8739ae039), {
            logoutLink: logoutLink,
            links: links,
            me: me,
            header: true
        }) : undefined)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Contents, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $d5045ee1678e086f$export$2e2bcd8739ae039), {
            notify: notify,
            source: source,
            sources: sources,
            dashboards: dashboards,
            dashboardsStatus: dashboardsStatus,
            dashboardLink: dashboardLink,
            onDeleteDashboard: this.handleDeleteDashboard,
            onCreateDashboard: this.handleCreateDashboard,
            onCloneDashboard: this.handleCloneDashboard,
            onExportDashboard: this.handleExportDashboard,
            onImportDashboard: this.handleImportDashboard
        })));
    }
}
const $b611c9c333828d80$var$mapStateToProps = ({ dashboardUI: { dashboards: dashboards, dashboard: dashboard }, sources: sources, auth: { isUsingAuth: isUsingAuth, logoutLink: logoutLink, me: me }, links: links })=>({
        dashboards: dashboards,
        dashboard: dashboard,
        sources: sources,
        isUsingAuth: isUsingAuth,
        logoutLink: logoutLink,
        me: me,
        links: links
    });
const $b611c9c333828d80$var$mapDispatchToProps = {
    handleGetDashboards: (0, $9859d1d8ae3f2524$export$e5b1f1e10b3d70a7),
    handleDeleteDashboard: (0, $9859d1d8ae3f2524$export$9cfbbfc4b857b8e5),
    handleGetChronografVersion: (0, $9859d1d8ae3f2524$export$af278a8f89c893bc),
    handleImportDashboard: (0, $9859d1d8ae3f2524$export$9bb49e3c808ea88c),
    notify: (0, $205d139de2918454$export$5e14cdade93d6f7b),
    retainRangesDashTimeV1: (0, $9859d1d8ae3f2524$export$3139c1361eed5496),
    retainDashRefresh: (0, $9859d1d8ae3f2524$export$d23cba85a907d123)
};
var $b611c9c333828d80$export$2e2bcd8739ae039 = (0, $c8cd79e362cba2a4$export$a520fb22fccea800)((0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($b611c9c333828d80$var$mapStateToProps, $b611c9c333828d80$var$mapDispatchToProps)((0, $dffbdf89c590a961$export$2e2bcd8739ae039)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($b611c9c333828d80$export$3a704d4ac2eeb2fe))));


// Libraries

var $NdCUR = parcelRequire("NdCUR");




var $hBdgJ = parcelRequire("hBdgJ");

// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");


// Libraries

var $NdCUR = parcelRequire("NdCUR");

// Libraries

var $NdCUR = parcelRequire("NdCUR");

class $bda9682652fde6bb$var$VisualizationName extends (0, $NdCUR.Component) {
    constructor(props){
        super(props), this.handleChange = (e)=>{
            this.setState({
                workingName: e.target.value
            });
        }, this.handleBlur = ()=>{
            const { handleRenameCell: handleRenameCell } = this.props;
            const { workingName: workingName } = this.state;
            this.setState({
                isEditing: false
            });
            handleRenameCell(workingName);
        }, this.handleKeyDown = (e)=>{
            const { handleRenameCell: handleRenameCell } = this.props;
            const { workingName: workingName } = this.state;
            if (e.key === 'Enter' || e.key === 'Escape') {
                handleRenameCell(workingName);
                this.setState({
                    isEditing: false
                });
            }
        }, this.handleFocus = (e)=>{
            e.target.select();
            this.setState({
                isEditing: true
            });
        }, this.handleClick = ()=>{
            this.setState({
                isEditing: true
            });
        };
        this.state = {
            workingName: props.name,
            isEditing: false
        };
    }
    render() {
        const { workingName: workingName, isEditing: isEditing } = this.state;
        if (isEditing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "rename-dashboard"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            type: "text",
            className: "rename-dashboard--input form-control input-sm",
            value: workingName,
            onChange: this.handleChange,
            autoFocus: true,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            onKeyDown: this.handleKeyDown,
            placeholder: "Name this Cell...",
            spellCheck: false
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "rename-dashboard",
            "data-test": "rename-graph"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "rename-dashboard--title",
            onClick: this.handleClick
        }, workingName, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon pencil"
        })));
    }
}
var $bda9682652fde6bb$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($bda9682652fde6bb$var$VisualizationName);



var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");


const $b4a526e8eda76ab1$export$469fa5fc28bc73d5 = ({ buttonSize: buttonSize, isDisabled: isDisabled, onConfirm: onConfirm, icon: icon, title: title })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
        "data-test": "confirm",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('confirm-or-cancel--confirm btn btn-success btn-square', {
            [buttonSize]: buttonSize
        }),
        disabled: isDisabled,
        title: isDisabled ? `Cannot ${title}` : title,
        onClick: onConfirm
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        className: icon
    }));
const $b4a526e8eda76ab1$export$848c9b7ead0df967 = ({ buttonSize: buttonSize, onCancel: onCancel, icon: icon, title: title })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
        "data-test": "cancel",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('confirm-or-cancel--cancel btn btn-info btn-square', {
            [buttonSize]: buttonSize
        }),
        onClick: onCancel,
        title: title
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        className: icon
    }));
class $b4a526e8eda76ab1$var$ConfirmOrCancel extends (0, $NdCUR.PureComponent) {
    static{
        this.defaultProps = {
            buttonSize: 'btn-sm',
            confirmTitle: 'Save',
            cancelTitle: 'Cancel',
            onClickOutside: ()=>{}
        };
    }
    constructor(props){
        super(props), this.handleConfirm = (item)=>()=>{
                this.props.onConfirm(item);
            }, this.handleCancel = (item)=>()=>{
                this.props.onCancel(item);
            }, this.handleClickOutside = ()=>{
            this.props.onClickOutside(this.props.item);
        };
    }
    render() {
        const { item: item, buttonSize: buttonSize, isDisabled: isDisabled, reversed: reversed, confirmTitle: confirmTitle, cancelTitle: cancelTitle } = this.props;
        const className = `confirm-or-cancel${reversed ? ' reversed' : ''}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: className
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($b4a526e8eda76ab1$export$848c9b7ead0df967, {
            buttonSize: buttonSize,
            onCancel: this.handleCancel(item),
            icon: "icon remove",
            title: cancelTitle
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($b4a526e8eda76ab1$export$469fa5fc28bc73d5, {
            buttonSize: buttonSize,
            isDisabled: isDisabled,
            onConfirm: this.handleConfirm(item),
            icon: "icon checkmark",
            title: confirmTitle
        }));
    }
}
var $b4a526e8eda76ab1$export$2e2bcd8739ae039 = (0, $1636633b789d0ee3$export$2e2bcd8739ae039)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($b4a526e8eda76ab1$var$ConfirmOrCancel));




class $c2c6e683aac379c7$var$CEOHeader extends (0, $NdCUR.Component) {
    render() {
        const { activeEditorTab: activeEditorTab, onSetActiveEditorTab: onSetActiveEditorTab, title: title, renameCell: renameCell, onCancel: onCancel, onSave: onSave, isSaveable: isSaveable } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "page-header full-width deceo--header"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "page-header--container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "page-header--left"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $bda9682652fde6bb$export$2e2bcd8739ae039), {
            name: title,
            handleRenameCell: renameCell
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "deceo--header-tabs"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039), {
            shape: (0, $918c9f03a35fe03f$export$ce765fb8bb08a599).StretchToFit
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039).Button, {
            id: "deceo-tab-queries",
            titleText: "Queries",
            value: (0, $9a9ec629fdd38845$export$b11a09459547fdbb).Queries,
            active: activeEditorTab === (0, $9a9ec629fdd38845$export$b11a09459547fdbb).Queries,
            onClick: onSetActiveEditorTab
        }, "Queries"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039).Button, {
            id: "deceo-tab-vis",
            titleText: "Visualization",
            value: (0, $9a9ec629fdd38845$export$b11a09459547fdbb).Vis,
            active: activeEditorTab === (0, $9a9ec629fdd38845$export$b11a09459547fdbb).Vis,
            onClick: onSetActiveEditorTab
        }, "Visualization"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "page-header--right"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b4a526e8eda76ab1$export$2e2bcd8739ae039), {
            onCancel: onCancel,
            onConfirm: onSave,
            isDisabled: !isSaveable
        }))));
    }
}
var $c2c6e683aac379c7$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($c2c6e683aac379c7$var$CEOHeader);










const $49025b9a9ba48763$export$6ddeec537125a398 = (timeRange, zoomedTimeRange = {
    lower: null
})=>{
    const { upper: zoomedUpper, lower: zoomedLower } = zoomedTimeRange;
    const { upper: upper, lower: lower } = timeRange;
    const low = zoomedLower || lower;
    const up = zoomedUpper || upper;
    const lowerTemplateType = low && low.includes(':') ? (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).TimeStamp : (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Constant;
    const upperTemplateType = up && up.includes(':') ? (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).TimeStamp : (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Constant;
    const lowerTemplateValueType = low && low.includes(':') ? (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).TimeStamp : (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).Constant;
    const upperTemplateValueType = up && up.includes(':') ? (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).TimeStamp : (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).Constant;
    const dashboardTime = {
        id: 'dashtime',
        tempVar: (0, $e10a8602f56394e3$export$24969386fef72130),
        type: lowerTemplateType,
        label: '',
        values: [
            {
                value: low,
                type: lowerTemplateValueType,
                selected: true,
                localSelected: true
            }
        ]
    };
    const upperDashboardTime = {
        id: 'upperdashtime',
        tempVar: (0, $e10a8602f56394e3$export$cb0056005b9f8f1c),
        type: upperTemplateType,
        label: '',
        values: [
            {
                value: up || 'now()',
                type: upperTemplateValueType,
                selected: true,
                localSelected: true
            }
        ]
    };
    return {
        dashboardTime: dashboardTime,
        upperDashboardTime: upperDashboardTime
    };
};


class $c5ea6fbc55d91fd3$var$CellEditorOverlay extends (0, $NdCUR.Component) {
    constructor(props){
        super(props), this.overlayRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createRef(), this.handleUpdateScriptStatus = (scriptStatus)=>{
            this.setState({
                scriptStatus: scriptStatus
            });
        }, this.handleRenameCell = (draftCellName)=>{
            this.setState({
                draftCellName: draftCellName
            });
        }, this.collectCell = ()=>{
            const { cell: cell, draftScript: draftScript, queryDrafts: queryDrafts, type: type, axes: axes, tableOptions: tableOptions, fieldOptions: fieldOptions, timeFormat: timeFormat, decimalPlaces: decimalPlaces, note: note, noteVisibility: noteVisibility, thresholdsListColors: thresholdsListColors, gaugeColors: gaugeColors, lineColors: lineColors } = this.props;
            const { isStaticLegend: isStaticLegend, draftCellName: draftCellName } = this.state;
            let queries = queryDrafts;
            if (this.isFluxQuery) queries = [
                {
                    query: draftScript,
                    queryConfig: null,
                    source: (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(queryDrafts, '0.source', ''),
                    type: (0, $b4506126e09430df$export$7c8e26efb80b90e8).Flux
                }
            ];
            const colors = (0, $727a6ab7dfc948a3$export$be1e3eb56b1b752d)({
                cellType: type,
                gaugeColors: gaugeColors,
                thresholdsListColors: thresholdsListColors,
                lineColors: lineColors
            });
            const newCell = {
                ...cell,
                name: draftCellName,
                queries: queries,
                colors: colors,
                axes: axes,
                tableOptions: tableOptions,
                fieldOptions: fieldOptions,
                timeFormat: timeFormat,
                decimalPlaces: decimalPlaces,
                note: note,
                noteVisibility: noteVisibility,
                type: type,
                legend: isStaticLegend ? (0, $727a6ab7dfc948a3$export$bce5511945345ed) : {}
            };
            return newCell;
        }, this.handleSaveCell = ()=>{
            const { onSave: onSave, onResetTimeMachine: onResetTimeMachine } = this.props;
            const cell = this.collectCell();
            onSave(cell);
            onResetTimeMachine();
        }, this.handleCancel = ()=>{
            const { onCancel: onCancel, onResetTimeMachine: onResetTimeMachine } = this.props;
            onCancel();
            onResetTimeMachine();
        }, this.handleKeyDown = (e)=>{
            switch(e.key){
                case 'Enter':
                    if (!e.metaKey) return;
                    else if (e.target === this.overlayRef) this.handleSaveCell();
                    else {
                        e.target.blur();
                        setTimeout(this.handleSaveCell, 50);
                    }
                    break;
                case 'Escape':
                    if (e.target === this.overlayRef) this.props.onCancel();
                    else {
                        const targetIsDropdown = e.target.classList[0] === 'dropdown';
                        const targetIsButton = e.target.tagName === 'BUTTON';
                        if (targetIsDropdown || targetIsButton) return this.props.onCancel();
                        e.target.blur();
                        this.handleResetFocus();
                    }
                    break;
            }
        }, this.handleToggleStaticLegend = (isStaticLegend)=>{
            this.setState({
                isStaticLegend: isStaticLegend
            });
        }, this.handleResetFocus = ()=>{
            if (this.overlayRef.current) this.overlayRef.current.focus();
        };
        const legend = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(props, 'cell.legend', null);
        this.state = {
            isStaticLegend: (0, $e10a8602f56394e3$export$1665041fd2ad0d88)(legend),
            scriptStatus: {
                type: 'none',
                text: ''
            },
            draftCellName: props.cell.name
        };
    }
    componentDidMount() {
        const { cell: cell, dashboardRefresh: dashboardRefresh, dashboardTimeRange: dashboardTimeRange, onResetTimeMachine: onResetTimeMachine } = this.props;
        const initialState = {
            ...(0, $975a79a7c96f3d95$export$c384300448dab5fa)(cell),
            timeRange: dashboardTimeRange,
            refresh: dashboardRefresh
        };
        onResetTimeMachine(initialState);
        this.handleResetFocus();
    }
    render() {
        const { cell: cell, editQueryStatus: editQueryStatus, fluxLinks: fluxLinks, notify: notify, source: source, sources: sources, queryStatuses: queryStatuses, dashboardRefresh: dashboardRefresh } = this.props;
        const { isStaticLegend: isStaticLegend } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "deceo--overlay",
            onKeyDown: this.handleKeyDown,
            tabIndex: 0,
            ref: this.overlayRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dfadf026237d58c4$export$2e2bcd8739ae039), {
            notify: notify,
            source: source,
            isInCEO: true,
            sources: sources,
            fluxLinks: fluxLinks,
            templates: this.ceoTemplates,
            editQueryStatus: editQueryStatus,
            onResetFocus: this.handleResetFocus,
            onToggleStaticLegend: this.handleToggleStaticLegend,
            isStaticLegend: isStaticLegend,
            queryStatuses: queryStatuses,
            onUpdateScriptStatus: this.handleUpdateScriptStatus,
            refresh: dashboardRefresh
        }, (activeEditorTab, onSetActiveEditorTab)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c2c6e683aac379c7$export$2e2bcd8739ae039), {
                title: (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(cell, 'name', ''),
                renameCell: this.handleRenameCell,
                onSave: this.handleSaveCell,
                onCancel: this.handleCancel,
                activeEditorTab: activeEditorTab,
                onSetActiveEditorTab: onSetActiveEditorTab,
                isSaveable: this.isSaveable
            })));
    }
    get ceoTemplates() {
        const { dashboardTemplates: dashboardTemplates, ceoTimeRange: ceoTimeRange } = this.props;
        const { dashboardTime: dashboardTime, upperDashboardTime: upperDashboardTime } = (0, $49025b9a9ba48763$export$6ddeec537125a398)(ceoTimeRange);
        return [
            ...dashboardTemplates,
            dashboardTime,
            upperDashboardTime
        ];
    }
    get isSaveable() {
        const { queryDrafts: queryDrafts, type: type } = this.props;
        if (type === 'note' || this.isFluxQuery) return true;
        return queryDrafts.every((queryDraft)=>{
            const queryConfig = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(queryDraft, 'queryConfig', null);
            return !!queryConfig.measurement && !!queryConfig.database && !!queryConfig.fields.length || !!queryConfig.rawText;
        });
    }
    get isFluxQuery() {
        const { queryType: queryType } = this.props;
        return queryType === (0, $b4506126e09430df$export$7c8e26efb80b90e8).Flux;
    }
}
const $c5ea6fbc55d91fd3$var$CellEditorOverlay2 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($c5ea6fbc55d91fd3$var$CellEditorOverlay);
const $c5ea6fbc55d91fd3$var$ConnectedCellEditorOverlay = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b029b3af5fc2e5d5$export$7d87f8b720f7653e), null, (container)=>{
        const { state: state } = container;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($c5ea6fbc55d91fd3$var$CellEditorOverlay2, {
            ...props,
            queryType: state.queryType,
            queryDrafts: state.queryDrafts,
            script: state.script,
            draftScript: state.draftScript,
            onChangeScript: container.handleChangeScript,
            type: state.type,
            axes: state.axes,
            tableOptions: state.tableOptions,
            fieldOptions: state.fieldOptions,
            timeFormat: state.timeFormat,
            decimalPlaces: state.decimalPlaces,
            note: state.note,
            noteVisibility: state.noteVisibility,
            thresholdsListColors: state.thresholdsListColors,
            thresholdsListType: state.thresholdsListType,
            gaugeColors: state.gaugeColors,
            lineColors: state.lineColors,
            onResetTimeMachine: container.reset,
            ceoTimeRange: state.timeRange
        });
    });
};
var $c5ea6fbc55d91fd3$export$2e2bcd8739ae039 = $c5ea6fbc55d91fd3$var$ConnectedCellEditorOverlay;




var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");

// Libraries

var $NdCUR = parcelRequire("NdCUR");







class $8b088af4a2b53839$var$DashboardEmpty extends (0, $NdCUR.Component) {
    constructor(props){
        super(props), this.handleAddCell = (type)=>()=>{
                const { dashboard: dashboard, addDashboardCell: addDashboardCell } = this.props;
                const emptyCell = (0, $0ece195804443aff$export$47308518c82e405)(dashboard);
                emptyCell.type = type;
                addDashboardCell(dashboard, emptyCell);
            };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "dashboard-empty"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, "This Dashboard doesn't have any ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("strong", null, "Cells"), ",", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("br", null), "why not add one?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $091cfcd49e339acd$export$2e2bcd8739ae039), {
            requiredRole: (0, $a7910b1002260d34$export$f715f7e27dea2abf)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "dashboard-empty--menu"
        }, (0, $68fa0144111754ce$export$68ca4bab3ef5b52c).map((graphType)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                key: graphType.type,
                className: "dashboard-empty--menu-option"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                onClick: this.handleAddCell(graphType.type)
            }, graphType.graphic, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, graphType.menuOption)))))));
    }
}
const $8b088af4a2b53839$var$mapDispatchToProps = (dispatch)=>({
        addDashboardCell: (0, $1f80bbeadc1a0021$export$2e2bcd8739ae039)((0, $9859d1d8ae3f2524$export$17ae542af88fbb65), dispatch)
    });
var $8b088af4a2b53839$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)(null, $8b088af4a2b53839$var$mapDispatchToProps)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($8b088af4a2b53839$var$DashboardEmpty));



const $e5911fcc26315b2c$var$Dashboard = ({ source: source, sources: sources, onZoom: onZoom, dashboard: dashboard, timeRange: timeRange, manualRefresh: manualRefresh, onDeleteCell: onDeleteCell, onCloneCell: onCloneCell, onPositionChange: onPositionChange, inPresentationMode: inPresentationMode, templatesIncludingDashTime: templatesIncludingDashTime, onSummonOverlayTechnologies: onSummonOverlayTechnologies, setScrollTop: setScrollTop, inView: inView })=>{
    const cells = dashboard.cells.map((cell)=>{
        const dashboardCell = {
            ...cell,
            inView: inView(cell)
        };
        dashboardCell.queries = dashboardCell.queries.map((q)=>({
                ...q,
                database: q.db,
                text: q.query,
                queryConfig: {
                    ...q.queryConfig,
                    rawText: q.query
                }
            }));
        return dashboardCell;
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Contents, {
        fullWidth: true,
        inPresentationMode: inPresentationMode,
        setScrollTop: setScrollTop
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "dashboard container-fluid full-width"
    }, cells.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $3abcc8f3edbea0d9$export$2e2bcd8739ae039), {
        cells: cells,
        onZoom: onZoom,
        source: source,
        sources: sources,
        isEditable: true,
        timeRange: timeRange,
        manualRefresh: manualRefresh,
        onDeleteCell: onDeleteCell,
        onCloneCell: onCloneCell,
        onPositionChange: onPositionChange,
        templates: templatesIncludingDashTime,
        onSummonOverlayTechnologies: onSummonOverlayTechnologies
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $8b088af4a2b53839$export$2e2bcd8739ae039), {
        dashboard: dashboard
    })));
};
const { arrayOf: $e5911fcc26315b2c$var$arrayOf, bool: $e5911fcc26315b2c$var$bool, func: $e5911fcc26315b2c$var$func, shape: $e5911fcc26315b2c$var$shape, string: $e5911fcc26315b2c$var$string, number: $e5911fcc26315b2c$var$number } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$e5911fcc26315b2c$var$Dashboard.propTypes = {
    dashboard: $e5911fcc26315b2c$var$shape({
        templates: $e5911fcc26315b2c$var$arrayOf($e5911fcc26315b2c$var$shape({
            type: $e5911fcc26315b2c$var$string.isRequired,
            tempVar: $e5911fcc26315b2c$var$string.isRequired,
            query: $e5911fcc26315b2c$var$shape({
                db: $e5911fcc26315b2c$var$string,
                rp: $e5911fcc26315b2c$var$string,
                influxql: $e5911fcc26315b2c$var$string
            }),
            values: $e5911fcc26315b2c$var$arrayOf($e5911fcc26315b2c$var$shape({
                type: $e5911fcc26315b2c$var$string.isRequired,
                value: $e5911fcc26315b2c$var$string.isRequired,
                selected: $e5911fcc26315b2c$var$bool
            })).isRequired
        })).isRequired
    }),
    templatesIncludingDashTime: $e5911fcc26315b2c$var$arrayOf($e5911fcc26315b2c$var$shape()).isRequired,
    inPresentationMode: $e5911fcc26315b2c$var$bool,
    onPositionChange: $e5911fcc26315b2c$var$func,
    onDeleteCell: $e5911fcc26315b2c$var$func,
    onCloneCell: $e5911fcc26315b2c$var$func,
    onSummonOverlayTechnologies: $e5911fcc26315b2c$var$func,
    source: $e5911fcc26315b2c$var$shape({
        links: $e5911fcc26315b2c$var$shape({
            proxy: $e5911fcc26315b2c$var$string
        }).isRequired
    }).isRequired,
    sources: $e5911fcc26315b2c$var$arrayOf($e5911fcc26315b2c$var$shape({})).isRequired,
    manualRefresh: $e5911fcc26315b2c$var$number,
    timeRange: $e5911fcc26315b2c$var$shape({}).isRequired,
    onZoom: $e5911fcc26315b2c$var$func,
    setScrollTop: $e5911fcc26315b2c$var$func,
    inView: $e5911fcc26315b2c$var$func
};
var $e5911fcc26315b2c$export$2e2bcd8739ae039 = $e5911fcc26315b2c$var$Dashboard;




var $NdCUR = parcelRequire("NdCUR");


var $NdCUR = parcelRequire("NdCUR");


var $NdCUR = parcelRequire("NdCUR");


const $4b353aa0c817068e$var$TemplateDropdown = (props)=>{
    const { template: template, onPickValue: onPickValue } = props;
    const dropdownItems = template.values.map((value)=>{
        if (value.type === (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).Map) return {
            ...value,
            text: value.key
        };
        return {
            ...value,
            text: value.value
        };
    });
    const localSelectedItem = dropdownItems.find((item)=>item.localSelected) || dropdownItems[0] || {
        text: '(No values)'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ca4f14339173643c$export$2e2bcd8739ae039), {
        items: dropdownItems,
        buttonSize: "btn-xs",
        menuClass: "dropdown-astronaut",
        useAutoComplete: true,
        selected: localSelectedItem.text,
        onChoose: onPickValue
    });
};
var $4b353aa0c817068e$export$2e2bcd8739ae039 = $4b353aa0c817068e$var$TemplateDropdown;



var $NdCUR = parcelRequire("NdCUR");


class $823c213757a0f70b$var$TextTemplateSelector extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleChange = (e)=>{
            this.setState({
                text: e.target.value
            });
        }, this.handleKeyUp = (e)=>{
            if (e.key === 'Enter') e.currentTarget.blur();
        }, this.handleFocus = (e)=>{
            const input = e.currentTarget;
            input.setSelectionRange(0, input.value.length);
        }, this.submit = ()=>{
            const { onPickValue: onPickValue } = this.props;
            const { text: text } = this.state;
            onPickValue({
                value: text,
                type: (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).Constant,
                selected: true,
                localSelected: true
            });
        };
        this.state = {
            text: (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(props, 'template.values.0.value', '')
        };
    }
    render() {
        const { text: text } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            type: "text",
            className: "text-template-selector",
            value: text,
            onChange: this.handleChange,
            onKeyUp: this.handleKeyUp,
            onFocus: this.handleFocus,
            onBlur: this.submit,
            spellCheck: false
        });
    }
}
var $823c213757a0f70b$export$2e2bcd8739ae039 = $823c213757a0f70b$var$TextTemplateSelector;


// Libraries

var $NdCUR = parcelRequire("NdCUR");



var $hBdgJ = parcelRequire("hBdgJ");











var $NdCUR = parcelRequire("NdCUR");




var $NdCUR = parcelRequire("NdCUR");


var $NdCUR = parcelRequire("NdCUR");



var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");


const { LI_HEIGHT: $cfd534820528ed59$var$LI_HEIGHT, LI_MARGIN_BOTTOM: $cfd534820528ed59$var$LI_MARGIN_BOTTOM } = (0, $a3b88d5d27f00a75$export$2441527122476343);
const $cfd534820528ed59$var$ITEM_STYLE = {
    height: `${$cfd534820528ed59$var$LI_HEIGHT}px`,
    marginBottom: `${$cfd534820528ed59$var$LI_MARGIN_BOTTOM}px`
};
class $cfd534820528ed59$var$TemplatePreviewListItem extends (0, $NdCUR.PureComponent) {
    render() {
        const { item: item } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("li", {
            onClick: this.handleClick,
            style: $cfd534820528ed59$var$ITEM_STYLE,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('temp-builder--results-item', {
                active: this.isDefault
            })
        }, this.mapTempVarKey, item.value, this.defaultIndicator());
    }
    get isDefault() {
        return this.props.item.selected;
    }
    get mapTempVarKey() {
        const { item: item } = this.props;
        if (item.type === (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).Map) return `${item.key} --> `;
    }
    defaultIndicator() {
        if (this.isDefault) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "temp-builder--default"
        }, "DEFAULT");
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "temp-builder--default"
        }, "SET AS DEFAULT");
    }
    constructor(...args){
        super(...args), this.handleClick = ()=>{
            if (this.isDefault) return;
            this.props.onClick(this.props.item);
        };
    }
}
var $cfd534820528ed59$export$2e2bcd8739ae039 = $cfd534820528ed59$var$TemplatePreviewListItem;



const { RESULTS_TO_DISPLAY: $c705b90ca073723c$var$RESULTS_TO_DISPLAY, LI_HEIGHT: $c705b90ca073723c$var$LI_HEIGHT, LI_MARGIN_BOTTOM: $c705b90ca073723c$var$LI_MARGIN_BOTTOM, OFFSET: $c705b90ca073723c$var$OFFSET } = (0, $a3b88d5d27f00a75$export$2441527122476343);
class $c705b90ca073723c$var$TemplatePreviewList extends (0, $NdCUR.PureComponent) {
    render() {
        const { items: items, onUpdateDefaultTemplateValue: onUpdateDefaultTemplateValue } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "temp-builder--results-list"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), {
            autoHide: false,
            autoHeight: true,
            maxHeight: this.resultsListHeight
        }, items.map((item, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $cfd534820528ed59$export$2e2bcd8739ae039), {
                key: i,
                onClick: onUpdateDefaultTemplateValue,
                item: item
            }))));
    }
    get resultsListHeight() {
        const { items: items } = this.props;
        const count = Math.min(items.length, $c705b90ca073723c$var$RESULTS_TO_DISPLAY);
        const scrollOffset = count > $c705b90ca073723c$var$RESULTS_TO_DISPLAY ? $c705b90ca073723c$var$OFFSET : 0;
        return count * ($c705b90ca073723c$var$LI_HEIGHT + $c705b90ca073723c$var$LI_MARGIN_BOTTOM) - scrollOffset;
    }
}
var $c705b90ca073723c$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($c705b90ca073723c$var$TemplatePreviewList);



class $21ab8bf486f284d7$var$TemplateMetaQueryPreview extends (0, $NdCUR.PureComponent) {
    render() {
        const { items: items, loadingStatus: loadingStatus, onUpdateDefaultTemplateValue: onUpdateDefaultTemplateValue } = this.props;
        if (loadingStatus === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).NotStarted) return null;
        if (loadingStatus === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12 temp-builder--results"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", {
            className: "temp-builder--validation loading"
        }, "Loading Meta Query preview..."));
        if (loadingStatus === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12 temp-builder--results"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", {
            className: "temp-builder--validation error"
        }, "Meta Query failed to execute"));
        if (items.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12 temp-builder--results"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", {
            className: "temp-builder--validation warning"
        }, "Meta Query is syntactically correct but returned no results"));
        const pluralizer = items.length === 1 ? '' : 's';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12 temp-builder--results"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", {
            className: "temp-builder--validation"
        }, "Meta Query returned ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("strong", null, items.length), " value", pluralizer), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c705b90ca073723c$export$2e2bcd8739ae039), {
            items: items,
            onUpdateDefaultTemplateValue: onUpdateDefaultTemplateValue
        }));
    }
}
var $21ab8bf486f284d7$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($21ab8bf486f284d7$var$TemplateMetaQueryPreview);



class $17195e0e27036d0d$var$DatabasesTemplateBuilder extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props);
        this.state = {
            databasesStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading
        };
    }
    async componentDidMount() {
        this.loadDatabases();
    }
    render() {
        const { template: template, onUpdateDefaultTemplateValue: onUpdateDefaultTemplateValue } = this.props;
        const { databasesStatus: databasesStatus } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", null, "Meta Query"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "temp-builder--mq-controls"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "temp-builder--mq-text"
        }, "SHOW DATABASES"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21ab8bf486f284d7$export$2e2bcd8739ae039), {
            items: template.values,
            loadingStatus: databasesStatus,
            onUpdateDefaultTemplateValue: onUpdateDefaultTemplateValue
        }));
    }
    async loadDatabases() {
        const { template: template, source: source, onUpdateTemplate: onUpdateTemplate } = this.props;
        this.setState({
            databasesStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading
        });
        try {
            const { data: data } = await (0, $8ba03c44d4b91783$export$46acc72e11cde242)(source.links.proxy);
            const { databases: databases } = (0, $b0c8a009bdea2e59$export$2e2bcd8739ae039)(data);
            this.setState({
                databasesStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done
            });
            const nextValues = databases.map((db)=>{
                return {
                    type: (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).Database,
                    value: db,
                    selected: false,
                    localSelected: false
                };
            });
            if (nextValues[0]) nextValues[0].selected = true;
            const nextTemplate = {
                ...template,
                values: nextValues
            };
            onUpdateTemplate(nextTemplate);
        } catch  {
            this.setState({
                databasesStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error
            });
        }
    }
}
var $17195e0e27036d0d$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($17195e0e27036d0d$var$DatabasesTemplateBuilder);



var $NdCUR = parcelRequire("NdCUR");



var $hBdgJ = parcelRequire("hBdgJ");






class $789d14294d4db619$var$CSVTemplateBuilder extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleUploadFile = (uploadContent, fileName)=>{
            const { template: template, onUpdateTemplate: onUpdateTemplate } = this.props;
            const fileExtensionRegex = new RegExp(`${this.validFileExtension}$`);
            if (!fileName.match(fileExtensionRegex)) {
                this.props.notify((0, $ec1f42de4faacc37$export$8c5a2fe0aa69e394)());
                return;
            }
            this.setState({
                templateValuesString: uploadContent
            });
            const nextValues = this.getValuesFromString(uploadContent);
            onUpdateTemplate({
                ...template,
                values: nextValues
            });
        }, this.handleBlur = ()=>{
            const { template: template, onUpdateTemplate: onUpdateTemplate } = this.props;
            const { templateValuesString: templateValuesString } = this.state;
            const nextValues = this.getValuesFromString(templateValuesString);
            onUpdateTemplate({
                ...template,
                values: nextValues
            });
        }, this.handleChange = (e)=>{
            this.setState({
                templateValuesString: e.target.value
            });
        };
        const templateValues = props.template.values.map((v)=>v.value);
        this.state = {
            templateValuesString: templateValues.join(', ')
        };
    }
    render() {
        const { onUpdateDefaultTemplateValue: onUpdateDefaultTemplateValue, template: template } = this.props;
        const { templateValuesString: templateValuesString } = this.state;
        const pluralizer = template.values.length === 1 ? '' : 's';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", null, "Upload a CSV File"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c75c159839663ccc$export$2e2bcd8739ae039), {
            submitText: "Preview",
            fileTypesToAccept: this.validFileExtension,
            handleSubmit: this.handleUploadFile,
            submitOnDrop: true,
            submitOnUpload: true,
            compact: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", null, "Comma Separated Values"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "temp-builder--mq-controls"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("textarea", {
            className: "form-control input-sm",
            value: templateValuesString,
            onChange: this.handleChange,
            onBlur: this.handleBlur
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12 temp-builder--results"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", {
            className: "temp-builder--validation"
        }, "CSV contains ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("strong", null, template.values.length), " value", pluralizer), template.values.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c705b90ca073723c$export$2e2bcd8739ae039), {
            items: template.values,
            onUpdateDefaultTemplateValue: onUpdateDefaultTemplateValue
        })));
    }
    get validFileExtension() {
        return '.csv';
    }
    getValuesFromString(templateValuesString) {
        const parsedTVS = (0, (/*@__PURE__*/$parcel$interopDefault($22ab81005d9b2ccc$exports))).parse(templateValuesString);
        const templateValuesData = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(parsedTVS, 'data', [
            []
        ]);
        const templateValues = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).filter((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).map((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).uniq((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).flatten(templateValuesData)), (elt)=>(0, $59c041f8acdb6976$export$30e493bbd186d503)(elt)), (elt)=>elt !== '');
        // check for too many errors in papa parse response
        const nextValues = templateValues.map((value)=>{
            return {
                type: (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).CSV,
                value: value,
                selected: false,
                localSelected: false
            };
        });
        return nextValues;
    }
}
var $789d14294d4db619$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($789d14294d4db619$var$CSVTemplateBuilder);



var $NdCUR = parcelRequire("NdCUR");





class $9b3422480befa774$var$MapTemplateBuilder extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleUploadFile = (uploadContent, fileName)=>{
            const { template: template, onUpdateTemplate: onUpdateTemplate } = this.props;
            const fileExtensionRegex = new RegExp(`${this.validFileExtension}$`);
            if (!fileName.match(fileExtensionRegex)) {
                this.props.notify((0, $ec1f42de4faacc37$export$8c5a2fe0aa69e394)());
                return;
            }
            this.setState({
                templateValuesString: uploadContent
            });
            const nextValues = this.constructValuesFromString(uploadContent);
            onUpdateTemplate({
                ...template,
                values: nextValues
            });
        }, this.handleBlur = ()=>{
            const { template: template, onUpdateTemplate: onUpdateTemplate } = this.props;
            const { templateValuesString: templateValuesString } = this.state;
            const values = this.constructValuesFromString(templateValuesString);
            onUpdateTemplate({
                ...template,
                values: values
            });
        }, this.handleChange = (e)=>{
            this.setState({
                templateValuesString: e.target.value
            });
        };
        const templateValuesString = (0, $59c041f8acdb6976$export$d0fb0a45e146209)(props.template.values);
        this.state = {
            templateValuesString: templateValuesString
        };
    }
    render() {
        const { onUpdateDefaultTemplateValue: onUpdateDefaultTemplateValue, template: template } = this.props;
        const { templateValuesString: templateValuesString } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", null, "Upload a CSV File"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c75c159839663ccc$export$2e2bcd8739ae039), {
            submitText: "Preview",
            fileTypesToAccept: this.validFileExtension,
            handleSubmit: this.handleUploadFile,
            submitOnDrop: true,
            submitOnUpload: true,
            compact: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", null, "Comma Separated Values"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "temp-builder--mq-controls"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("textarea", {
            className: "form-control input-sm",
            value: templateValuesString,
            onChange: this.handleChange,
            onBlur: this.handleBlur
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12 temp-builder--results"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", {
            className: "temp-builder--validation"
        }, "Mapping contains ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("strong", null, template.values.length), " key-value pair", this.pluralizer), template.values.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c705b90ca073723c$export$2e2bcd8739ae039), {
            items: template.values,
            onUpdateDefaultTemplateValue: onUpdateDefaultTemplateValue
        })));
    }
    get pluralizer() {
        return this.props.template.values.length === 1 ? '' : 's';
    }
    get validFileExtension() {
        return '.csv';
    }
    constructValuesFromString(templateValuesString) {
        const { notify: notify } = this.props;
        const { errors: errors, values: values } = (0, $59c041f8acdb6976$export$5e05677a1dcb2c28)(templateValuesString);
        if (errors.length > 0) notify((0, $ec1f42de4faacc37$export$12655bda97cfad49)());
        return values;
    }
}
var $9b3422480befa774$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($9b3422480befa774$var$MapTemplateBuilder);



var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");







var $NdCUR = parcelRequire("NdCUR");


const $75898e8cea80409d$var$DropdownLoadingPlaceholder = ({ children: children, rds: rds })=>{
    if (rds === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "dropdown-placeholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $3f24f31e899f9593$export$2e2bcd8739ae039), null));
    return children;
};
var $75898e8cea80409d$export$2e2bcd8739ae039 = $75898e8cea80409d$var$DropdownLoadingPlaceholder;



class $5fdfa5b802817c0b$var$MeasurementsTemplateBuilder extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleChooseDatabaseDropdown = ({ text: text })=>{
            this.handleChooseDatabase(text);
        }, this.handleChooseDatabase = (db)=>{
            this.setState({
                selectedDatabase: db
            }, ()=>this.loadMeasurements());
            const { template: template, onUpdateTemplate: onUpdateTemplate } = this.props;
            onUpdateTemplate({
                ...template,
                query: {
                    ...template.query,
                    db: db
                }
            });
        };
        const selectedDatabase = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(props, 'template.query.db', '');
        this.state = {
            databases: [],
            databasesStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading,
            selectedDatabase: selectedDatabase,
            measurementsStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading
        };
    }
    async componentDidMount() {
        await this.loadDatabases();
        await this.loadMeasurements();
    }
    render() {
        const { template: template, onUpdateDefaultTemplateValue: onUpdateDefaultTemplateValue } = this.props;
        const { databases: databases, databasesStatus: databasesStatus, selectedDatabase: selectedDatabase, measurementsStatus: measurementsStatus } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", null, "Meta Query"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "temp-builder--mq-controls"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "temp-builder--mq-text"
        }, "SHOW MEASUREMENTS ON"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $75898e8cea80409d$export$2e2bcd8739ae039), {
            rds: databasesStatus
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ca4f14339173643c$export$2e2bcd8739ae039), {
            items: databases.map((text)=>({
                    text: text
                })),
            onChoose: this.handleChooseDatabaseDropdown,
            selected: selectedDatabase,
            buttonSize: "btn-sm",
            className: "dropdown-stretch"
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21ab8bf486f284d7$export$2e2bcd8739ae039), {
            items: template.values,
            loadingStatus: measurementsStatus,
            onUpdateDefaultTemplateValue: onUpdateDefaultTemplateValue
        }));
    }
    async loadDatabases() {
        const { source: source } = this.props;
        this.setState({
            databasesStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading
        });
        try {
            const { data: data } = await (0, $8ba03c44d4b91783$export$46acc72e11cde242)(source.links.proxy);
            const { databases: databases } = (0, $b0c8a009bdea2e59$export$2e2bcd8739ae039)(data);
            const { selectedDatabase: selectedDatabase } = this.state;
            this.setState({
                databases: databases,
                databasesStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done
            });
            if (!selectedDatabase) this.handleChooseDatabase((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(databases, 0, ''));
        } catch (error) {
            this.setState({
                databasesStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error
            });
            console.error(error);
        }
    }
    async loadMeasurements() {
        const { template: template, source: source, onUpdateTemplate: onUpdateTemplate } = this.props;
        const { selectedDatabase: selectedDatabase } = this.state;
        this.setState({
            measurementsStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading
        });
        try {
            const { data: data } = await (0, $8ba03c44d4b91783$export$c71904f041e14568)(source.links.proxy, selectedDatabase);
            const { measurementSets: measurementSets } = (0, $4672176ee5bc174b$export$2e2bcd8739ae039)(data);
            const measurements = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(measurementSets, '0.measurements', []);
            this.setState({
                measurementsStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done
            });
            const nextValues = measurements.map((value)=>{
                return {
                    type: (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).Measurement,
                    value: value,
                    selected: false,
                    localSelected: false
                };
            });
            if (nextValues[0]) nextValues[0].selected = true;
            onUpdateTemplate({
                ...template,
                values: nextValues
            });
        } catch (error) {
            this.setState({
                measurementsStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error
            });
            console.error(error);
        }
    }
}
var $5fdfa5b802817c0b$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($5fdfa5b802817c0b$var$MeasurementsTemplateBuilder);



var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");


var $NdCUR = parcelRequire("NdCUR");









class $23840a6d14e3e73b$var$KeysTemplateBuilder extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleChooseDatabaseDropdown = ({ text: text })=>{
            this.handleChooseDatabase(text);
        }, this.handleChooseDatabase = (db)=>{
            this.setState({
                selectedDatabase: db,
                selectedMeasurement: ''
            }, ()=>this.loadMeasurements());
            const { template: template, onUpdateTemplate: onUpdateTemplate } = this.props;
            onUpdateTemplate({
                ...template,
                query: {
                    ...template.query,
                    db: db
                }
            });
        }, this.handleChooseMeasurementDropdown = ({ text: text })=>{
            this.handleChooseMeasurement(text);
        }, this.handleChooseMeasurement = (measurement)=>{
            this.setState({
                selectedMeasurement: measurement
            }, ()=>this.loadKeys());
            const { template: template, onUpdateTemplate: onUpdateTemplate } = this.props;
            onUpdateTemplate({
                ...template,
                query: {
                    ...template.query,
                    measurement: measurement
                }
            });
        };
        const selectedDatabase = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(props, 'template.query.db', '');
        const selectedMeasurement = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(props, 'template.query.measurement', '');
        this.state = {
            databases: [],
            databasesStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading,
            selectedDatabase: selectedDatabase,
            measurements: [],
            measurementsStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading,
            selectedMeasurement: selectedMeasurement,
            keysStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading
        };
    }
    async componentDidMount() {
        await this.loadDatabases();
        await this.loadMeasurements();
        await this.loadKeys();
    }
    render() {
        const { queryPrefix: queryPrefix, template: template, onUpdateDefaultTemplateValue: onUpdateDefaultTemplateValue } = this.props;
        const { databases: databases, databasesStatus: databasesStatus, selectedDatabase: selectedDatabase, measurements: measurements, measurementsStatus: measurementsStatus, selectedMeasurement: selectedMeasurement, keysStatus: keysStatus } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", null, "Meta Query"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "temp-builder--mq-controls"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "temp-builder--mq-text"
        }, queryPrefix), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $75898e8cea80409d$export$2e2bcd8739ae039), {
            rds: databasesStatus
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ca4f14339173643c$export$2e2bcd8739ae039), {
            items: databases.map((text)=>({
                    text: text
                })),
            onChoose: this.handleChooseDatabaseDropdown,
            selected: selectedDatabase,
            buttonSize: "btn-sm",
            className: "dropdown-stretch"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "temp-builder--mq-text"
        }, "FROM"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $75898e8cea80409d$export$2e2bcd8739ae039), {
            rds: measurementsStatus
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ca4f14339173643c$export$2e2bcd8739ae039), {
            items: measurements.map((text)=>({
                    text: text
                })),
            onChoose: this.handleChooseMeasurementDropdown,
            selected: selectedMeasurement,
            buttonSize: "btn-sm",
            className: "dropdown-stretch"
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21ab8bf486f284d7$export$2e2bcd8739ae039), {
            items: template.values,
            loadingStatus: keysStatus,
            onUpdateDefaultTemplateValue: onUpdateDefaultTemplateValue
        }));
    }
    async loadDatabases() {
        const { source: source } = this.props;
        this.setState({
            databasesStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading
        });
        try {
            const { data: data } = await (0, $8ba03c44d4b91783$export$46acc72e11cde242)(source.links.proxy);
            const { databases: databases } = (0, $b0c8a009bdea2e59$export$2e2bcd8739ae039)(data);
            const { selectedDatabase: selectedDatabase } = this.state;
            this.setState({
                databases: databases,
                databasesStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done
            });
            if (!selectedDatabase) this.handleChooseDatabase((0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(databases, 0, ''));
        } catch (error) {
            this.setState({
                databasesStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error
            });
            console.error(error);
        }
    }
    async loadMeasurements() {
        const { source: source } = this.props;
        const { selectedDatabase: selectedDatabase, selectedMeasurement: selectedMeasurement } = this.state;
        this.setState({
            measurementsStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading
        });
        try {
            const { data: data } = await (0, $8ba03c44d4b91783$export$c71904f041e14568)(source.links.proxy, selectedDatabase);
            const { measurementSets: measurementSets } = (0, $4672176ee5bc174b$export$2e2bcd8739ae039)(data);
            const measurements = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(measurementSets, '0.measurements', []);
            this.setState({
                measurements: measurements,
                measurementsStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done
            });
            if (!selectedMeasurement) this.handleChooseMeasurement((0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(measurements, 0, ''));
        } catch (error) {
            this.setState({
                measurementsStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error
            });
            console.error(error);
        }
    }
    async loadKeys() {
        const { template: template, onUpdateTemplate: onUpdateTemplate, templateValueType: templateValueType, fetchKeys: fetchKeys, source: source } = this.props;
        const { selectedDatabase: selectedDatabase, selectedMeasurement: selectedMeasurement } = this.state;
        this.setState({
            keysStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading
        });
        try {
            const keys = await fetchKeys(source, selectedDatabase, selectedMeasurement);
            this.setState({
                keysStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done
            });
            const nextValues = keys.map((value)=>{
                return {
                    type: templateValueType,
                    value: value,
                    selected: false,
                    localSelected: false
                };
            });
            if (nextValues[0]) nextValues[0].selected = true;
            onUpdateTemplate({
                ...template,
                query: {
                    ...template.query,
                    db: selectedDatabase,
                    measurement: selectedMeasurement
                },
                values: nextValues
            });
        } catch (error) {
            this.setState({
                keysStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error
            });
            console.error(error);
        }
    }
}
var $23840a6d14e3e73b$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($23840a6d14e3e73b$var$KeysTemplateBuilder);




const $de43a3c4e189a3ed$var$fetchKeys = async (source, db, measurement)=>{
    const { data: data } = await (0, $aea829e093f1eddb$export$923f96dd5afa9ce6)({
        source: source.links.proxy,
        db: db,
        query: `SHOW FIELD KEYS ON "${db}" FROM "${measurement}"`
    });
    const { fieldSets: fieldSets } = (0, $b90fabf231bb35b3$export$2e2bcd8739ae039)(data);
    const fieldKeys = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(Object.values(fieldSets), '0', []);
    return fieldKeys;
};
class $de43a3c4e189a3ed$var$FieldKeysTemplateBuilder extends (0, $NdCUR.PureComponent) {
    render() {
        const { template: template, templates: templates, source: source, onUpdateTemplate: onUpdateTemplate, onUpdateDefaultTemplateValue: onUpdateDefaultTemplateValue } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $23840a6d14e3e73b$export$2e2bcd8739ae039), {
            queryPrefix: 'SHOW FIELD KEYS ON',
            templateValueType: (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).FieldKey,
            fetchKeys: $de43a3c4e189a3ed$var$fetchKeys,
            template: template,
            templates: templates,
            source: source,
            onUpdateTemplate: onUpdateTemplate,
            onUpdateDefaultTemplateValue: onUpdateDefaultTemplateValue
        });
    }
}
var $de43a3c4e189a3ed$export$2e2bcd8739ae039 = $de43a3c4e189a3ed$var$FieldKeysTemplateBuilder;



var $NdCUR = parcelRequire("NdCUR");




const $3b1c219297b35d7d$export$8a3da65e62ec881c = async (source, db, measurement)=>{
    const { data: data } = await (0, $aea829e093f1eddb$export$923f96dd5afa9ce6)({
        source: source.links.proxy,
        db: db,
        query: `SHOW TAG KEYS ON "${db}" FROM "${measurement}"`
    });
    const { tagKeys: tagKeys } = (0, $6d45437803cb8b2c$export$2e2bcd8739ae039)(data);
    return tagKeys;
};
class $3b1c219297b35d7d$var$TagKeysTemplateBuilder extends (0, $NdCUR.PureComponent) {
    render() {
        const { template: template, templates: templates, source: source, onUpdateTemplate: onUpdateTemplate, onUpdateDefaultTemplateValue: onUpdateDefaultTemplateValue } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $23840a6d14e3e73b$export$2e2bcd8739ae039), {
            queryPrefix: 'SHOW TAG KEYS ON',
            templateValueType: (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).TagKey,
            fetchKeys: $3b1c219297b35d7d$export$8a3da65e62ec881c,
            template: template,
            templates: templates,
            source: source,
            onUpdateTemplate: onUpdateTemplate,
            onUpdateDefaultTemplateValue: onUpdateDefaultTemplateValue
        });
    }
}
var $3b1c219297b35d7d$export$2e2bcd8739ae039 = $3b1c219297b35d7d$var$TagKeysTemplateBuilder;



var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");











class $e3c12ef37ec04857$var$KeysTemplateBuilder extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.loadTagValues = async ()=>{
            const { source: source, template: template, onUpdateTemplate: onUpdateTemplate } = this.props;
            const { selectedDatabase: selectedDatabase, selectedMeasurement: selectedMeasurement, selectedTagKey: selectedTagKey } = this.state;
            this.setState({
                tagValuesStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading
            });
            try {
                const { data: data } = await (0, $aea829e093f1eddb$export$923f96dd5afa9ce6)({
                    source: source.links.proxy,
                    db: selectedDatabase,
                    query: `SHOW TAG VALUES ON "${selectedDatabase}" FROM "${selectedMeasurement}" WITH KEY = "${selectedTagKey}"`
                });
                const { tags: tags } = (0, $e693016ff8180917$export$2e2bcd8739ae039)(data);
                const tagValues = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(Object.values(tags), 0, []);
                this.setState({
                    tagValuesStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done
                });
                const nextValues = tagValues.map((value)=>{
                    return {
                        type: (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).TagValue,
                        value: value,
                        selected: false,
                        localSelected: false
                    };
                });
                if (nextValues[0]) nextValues[0].selected = true;
                onUpdateTemplate({
                    ...template,
                    values: nextValues,
                    query: {
                        ...template.query,
                        db: selectedDatabase,
                        measurement: selectedMeasurement,
                        tagKey: selectedTagKey
                    }
                });
            } catch (error) {
                this.setState({
                    tagValuesStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error
                });
                console.error(error);
            }
        }, this.handleChooseDatabaseDropdown = ({ text: text })=>{
            this.handleChooseDatabase(text);
        }, this.handleChooseDatabase = (db)=>{
            this.setState({
                selectedDatabase: db,
                selectedMeasurement: ''
            }, ()=>this.loadMeasurements());
            const { template: template, onUpdateTemplate: onUpdateTemplate } = this.props;
            onUpdateTemplate({
                ...template,
                query: {
                    ...template.query,
                    db: db,
                    tagKey: '',
                    measurement: ''
                }
            });
        }, this.handleChooseMeasurementDropdown = ({ text: text })=>{
            this.handleChooseMeasurement(text);
        }, this.handleChooseMeasurement = (measurement)=>{
            this.setState({
                selectedMeasurement: measurement,
                selectedTagKey: ''
            }, ()=>this.loadTagKeys());
            const { template: template, onUpdateTemplate: onUpdateTemplate } = this.props;
            onUpdateTemplate({
                ...template,
                query: {
                    ...template.query,
                    measurement: measurement,
                    tagKey: ''
                }
            });
        }, this.handleChooseTagKeyDropdown = ({ text: text })=>{
            this.handleChooseTagKey(text);
        }, this.handleChooseTagKey = (tagKey)=>{
            this.setState({
                selectedTagKey: tagKey
            }, ()=>this.loadTagValues());
            const { template: template, onUpdateTemplate: onUpdateTemplate } = this.props;
            onUpdateTemplate({
                ...template,
                query: {
                    ...template.query,
                    tagKey: tagKey
                }
            });
        };
        const selectedDatabase = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(props, 'template.query.db', '');
        const selectedMeasurement = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(props, 'template.query.measurement', '');
        const selectedTagKey = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(props, 'template.query.tagKey', '');
        this.state = {
            databases: [],
            databasesStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading,
            selectedDatabase: selectedDatabase,
            measurements: [],
            measurementsStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading,
            selectedMeasurement: selectedMeasurement,
            tagKeys: [],
            tagKeysStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading,
            selectedTagKey: selectedTagKey,
            tagValuesStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading
        };
    }
    async componentDidMount() {
        await this.loadDatabases();
        await this.loadMeasurements();
        await this.loadTagKeys();
        await this.loadTagValues();
    }
    render() {
        const { template: template, onUpdateDefaultTemplateValue: onUpdateDefaultTemplateValue } = this.props;
        const { databases: databases, databasesStatus: databasesStatus, selectedDatabase: selectedDatabase, measurements: measurements, measurementsStatus: measurementsStatus, selectedMeasurement: selectedMeasurement, tagKeys: tagKeys, tagKeysStatus: tagKeysStatus, selectedTagKey: selectedTagKey, tagValuesStatus: tagValuesStatus } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", null, "Meta Query"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "temp-builder--mq-controls"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "temp-builder--mq-text"
        }, "SHOW TAG VALUES ON"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $75898e8cea80409d$export$2e2bcd8739ae039), {
            rds: databasesStatus
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ca4f14339173643c$export$2e2bcd8739ae039), {
            items: databases.map((text)=>({
                    text: text
                })),
            onChoose: this.handleChooseDatabaseDropdown,
            selected: selectedDatabase,
            buttonSize: "btn-sm",
            className: "dropdown-stretch"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "temp-builder--mq-controls"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "temp-builder--mq-text"
        }, "FROM"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $75898e8cea80409d$export$2e2bcd8739ae039), {
            rds: measurementsStatus
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ca4f14339173643c$export$2e2bcd8739ae039), {
            items: measurements.map((text)=>({
                    text: text
                })),
            onChoose: this.handleChooseMeasurementDropdown,
            selected: selectedMeasurement,
            buttonSize: "btn-sm",
            className: "dropdown-stretch"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "temp-builder--mq-text"
        }, "WITH KEY"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $75898e8cea80409d$export$2e2bcd8739ae039), {
            rds: tagKeysStatus
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ca4f14339173643c$export$2e2bcd8739ae039), {
            items: tagKeys.map((text)=>({
                    text: text
                })),
            onChoose: this.handleChooseTagKeyDropdown,
            selected: selectedTagKey,
            buttonSize: "btn-sm",
            className: "dropdown-stretch"
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21ab8bf486f284d7$export$2e2bcd8739ae039), {
            items: template.values,
            loadingStatus: tagValuesStatus,
            onUpdateDefaultTemplateValue: onUpdateDefaultTemplateValue
        }));
    }
    async loadDatabases() {
        const { source: source } = this.props;
        this.setState({
            databasesStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading
        });
        try {
            const { data: data } = await (0, $8ba03c44d4b91783$export$46acc72e11cde242)(source.links.proxy);
            const { databases: databases } = (0, $b0c8a009bdea2e59$export$2e2bcd8739ae039)(data);
            const { selectedDatabase: selectedDatabase } = this.state;
            this.setState({
                databases: databases,
                databasesStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done
            });
            if (!selectedDatabase) this.handleChooseDatabase((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(databases, 0, ''));
        } catch (error) {
            this.setState({
                databasesStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error
            });
            console.error(error);
        }
    }
    async loadMeasurements() {
        const { source: source } = this.props;
        const { selectedDatabase: selectedDatabase, selectedMeasurement: selectedMeasurement } = this.state;
        this.setState({
            measurementsStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading
        });
        try {
            const { data: data } = await (0, $8ba03c44d4b91783$export$c71904f041e14568)(source.links.proxy, selectedDatabase);
            const { measurementSets: measurementSets } = (0, $4672176ee5bc174b$export$2e2bcd8739ae039)(data);
            const measurements = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(measurementSets, '0.measurements', []);
            this.setState({
                measurements: measurements,
                measurementsStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done
            });
            if (!selectedMeasurement) this.handleChooseMeasurement((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(measurements, 0, ''));
        } catch (error) {
            this.setState({
                measurementsStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error
            });
            console.error(error);
        }
    }
    async loadTagKeys() {
        const { source: source } = this.props;
        const { selectedTagKey: selectedTagKey } = this.state;
        const { selectedDatabase: selectedDatabase, selectedMeasurement: selectedMeasurement } = this.state;
        this.setState({
            tagKeysStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading
        });
        try {
            const tagKeys = await (0, $3b1c219297b35d7d$export$8a3da65e62ec881c)(source, selectedDatabase, selectedMeasurement);
            this.setState({
                tagKeys: tagKeys,
                tagKeysStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done
            });
            if (!selectedTagKey) this.handleChooseTagKey((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(tagKeys, 0, ''));
        } catch (error) {
            this.setState({
                tagKeysStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error
            });
            console.error(error);
        }
    }
}
var $e3c12ef37ec04857$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($e3c12ef37ec04857$var$KeysTemplateBuilder);



var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");






const $1a16ffc736177930$var$DEBOUNCE_DELAY = 750;
class $1a16ffc736177930$var$CustomMetaQueryTemplateBuilder extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleMetaQueryChange = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).debounce(()=>{
            const { metaQuery: metaQuery, metaQueryInput: metaQueryInput } = this.state;
            if (metaQuery === metaQueryInput) return;
            this.setState({
                metaQuery: metaQueryInput
            }, this.executeQuery);
        }, $1a16ffc736177930$var$DEBOUNCE_DELAY), this.handleMetaQueryInputChange = (e)=>{
            this.setState({
                metaQueryInput: e.target.value
            });
            this.handleMetaQueryChange();
        }, this.executeQuery = async ()=>{
            const { template: template, templates: templates, source: source, onUpdateTemplate: onUpdateTemplate } = this.props;
            const { metaQuery: metaQuery } = this.state;
            if (this.isInvalidMetaQuery) return;
            this.setState({
                metaQueryResultsStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading
            });
            try {
                const templateWithQuery = {
                    ...template,
                    query: {
                        influxql: metaQuery
                    }
                };
                const nextTemplate = await (0, $7b6b69e6512d0c7d$export$62eaf46cfd20a90c)(templateWithQuery, templates, {
                    source: source
                });
                this.setState({
                    metaQueryResultsStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done
                });
                if (nextTemplate.values[0]) nextTemplate.values[0].selected = true;
                onUpdateTemplate(nextTemplate);
            } catch  {
                this.setState({
                    metaQueryResultsStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error
                });
            }
        };
        const metaQuery = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(props.template, 'query.influxql', '');
        this.state = {
            metaQuery: metaQuery,
            metaQueryInput: metaQuery,
            metaQueryResultsStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).NotStarted
        };
    }
    componentDidMount() {
        this.executeQuery();
    }
    render() {
        const { metaQueryInput: metaQueryInput } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", null, "Meta Query"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "temp-builder--mq-controls"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("textarea", {
            className: "form-control input-sm",
            value: metaQueryInput,
            onChange: this.handleMetaQueryInputChange,
            onBlur: this.handleMetaQueryChange
        }))), this.renderResults());
    }
    renderResults() {
        const { template: template, onUpdateDefaultTemplateValue: onUpdateDefaultTemplateValue } = this.props;
        const { metaQueryResultsStatus: metaQueryResultsStatus } = this.state;
        if (this.showInvalidMetaQueryMessage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12 temp-builder--results"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", {
            className: "temp-builder--validation error"
        }, "Meta Query is not valid."));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21ab8bf486f284d7$export$2e2bcd8739ae039), {
            items: template.values,
            loadingStatus: metaQueryResultsStatus,
            onUpdateDefaultTemplateValue: onUpdateDefaultTemplateValue
        });
    }
    get showInvalidMetaQueryMessage() {
        const { metaQuery: metaQuery } = this.state;
        return this.isInvalidMetaQuery && metaQuery !== '';
    }
    get isInvalidMetaQuery() {
        const { metaQuery: metaQuery } = this.state;
        return (0, $82bb95c5c6d74105$export$bc278986e5723948)(metaQuery);
    }
}
var $1a16ffc736177930$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($1a16ffc736177930$var$CustomMetaQueryTemplateBuilder);



var $NdCUR = parcelRequire("NdCUR");


class $315a7e181cbf5625$var$TextTemplateBuilder extends (0, $NdCUR.PureComponent) {
    render() {
        const value = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(this.props, 'template.values.0.value', '');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-sm-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", null, "Text"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "temp-builder--mq-controls"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control input-sm",
            value: value,
            onChange: this.handleInputChange
        })));
    }
    constructor(...args){
        super(...args), this.handleInputChange = (e)=>{
            const { template: template, onUpdateTemplate: onUpdateTemplate } = this.props;
            const newValue = e.target.value;
            onUpdateTemplate({
                ...template,
                values: [
                    {
                        type: (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).Constant,
                        value: newValue,
                        selected: true,
                        localSelected: true
                    }
                ]
            });
        };
    }
}
var $315a7e181cbf5625$export$2e2bcd8739ae039 = $315a7e181cbf5625$var$TextTemplateBuilder;







var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");



var $NdCUR = parcelRequire("NdCUR");



class $c532436f1ac0a2d4$var$TemplateFluxQueryPreview extends (0, $NdCUR.PureComponent) {
    render() {
        const { items: items, loadingStatus: loadingStatus, onUpdateDefaultTemplateValue: onUpdateDefaultTemplateValue, fluxScriptWarning: fluxScriptWarning } = this.props;
        if (loadingStatus === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).NotStarted) return null;
        if (loadingStatus === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12 temp-builder--results"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", {
            className: "temp-builder--validation loading"
        }, "Loading Flux Query preview..."));
        if (loadingStatus === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12 temp-builder--results"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", {
            className: "temp-builder--validation error"
        }, "Flux Query failed to execute"));
        if (items.length === 0) {
            if (fluxScriptWarning) return this.fluxWarning(fluxScriptWarning);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                className: "form-group col-xs-12 temp-builder--results"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", {
                className: "temp-builder--validation warning"
            }, "Flux Query is syntactically correct but returned no results"));
        }
        const pluralizer = items.length === 1 ? '' : 's';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, this.fluxWarning(fluxScriptWarning), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12 temp-builder--results"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", {
            className: "temp-builder--validation"
        }, "Flux Query returned ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("strong", null, items.length), " value", pluralizer), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c705b90ca073723c$export$2e2bcd8739ae039), {
            items: items,
            onUpdateDefaultTemplateValue: onUpdateDefaultTemplateValue
        })));
    }
    fluxWarning(fluxScriptWarning) {
        if (!fluxScriptWarning) return;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12 temp-builder--results"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", {
            className: "temp-builder--validation warning"
        }, fluxScriptWarning));
    }
}
var $c532436f1ac0a2d4$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($c532436f1ac0a2d4$var$TemplateFluxQueryPreview);




const $e0917bdb3abf7281$var$DEBOUNCE_DELAY = 750;
class $e0917bdb3abf7281$var$FluxQueryTemplateBuilder extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleFluxScriptChange = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).debounce(()=>{
            const { fluxScript: fluxScript, fluxScriptInput: fluxScriptInput } = this.state;
            if (fluxScript === fluxScriptInput) return;
            this.setState({
                fluxScript: fluxScriptInput
            }, this.executeQuery);
        }, $e0917bdb3abf7281$var$DEBOUNCE_DELAY), this.handleFluxScriptInputChange = (e)=>{
            this.setState({
                fluxScriptInput: e.target.value
            });
            this.handleFluxScriptChange();
        }, this.executeQuery = async ()=>{
            const { template: template, templates: templates, source: source, onUpdateTemplate: onUpdateTemplate } = this.props;
            const { fluxScript: fluxScript } = this.state;
            if (fluxScript === '' || !source.links.flux) return;
            this.setState({
                fluxScriptResultsStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading
            });
            try {
                const templateWithQuery = {
                    ...template,
                    query: {
                        flux: fluxScript
                    }
                };
                let warning;
                const warnFn = (msg)=>{
                    if (!warning) warning = msg;
                };
                const nextTemplate = await (0, $7b6b69e6512d0c7d$export$62eaf46cfd20a90c)(templateWithQuery, templates, {
                    source: source,
                    warnFn: warnFn
                });
                this.setState({
                    fluxScriptResultsStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done,
                    fluxScriptWarning: warning
                });
                if (nextTemplate.values[0]) nextTemplate.values[0].selected = true;
                onUpdateTemplate(nextTemplate);
            } catch (e) {
                console.error(e);
                this.setState({
                    fluxScriptResultsStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error
                });
            }
        };
        const fluxScript = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(props.template, 'query.flux', '');
        this.state = {
            fluxScript: fluxScript,
            fluxScriptInput: fluxScript,
            fluxScriptResultsStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).NotStarted
        };
    }
    componentDidMount() {
        this.executeQuery();
    }
    render() {
        const { fluxScriptInput: fluxScriptInput } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", null, "Flux Script"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "temp-builder--mq-controls "
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("textarea", {
            className: "form-control input-sm temp-builder--flux",
            value: fluxScriptInput,
            onChange: this.handleFluxScriptInputChange,
            onBlur: this.handleFluxScriptChange
        }))), this.renderResults());
    }
    renderResults() {
        const { template: template, onUpdateDefaultTemplateValue: onUpdateDefaultTemplateValue, source: source } = this.props;
        const { fluxScriptResultsStatus: fluxScriptResultsStatus, fluxScriptWarning: fluxScriptWarning } = this.state;
        if (!source.links.flux) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12 temp-builder--results"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", {
            className: "temp-builder--validation error"
        }, "The current source does not support flux."));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c532436f1ac0a2d4$export$2e2bcd8739ae039), {
            items: template.values,
            loadingStatus: fluxScriptResultsStatus,
            fluxScriptWarning: fluxScriptWarning,
            onUpdateDefaultTemplateValue: onUpdateDefaultTemplateValue
        });
    }
}
var $e0917bdb3abf7281$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($e0917bdb3abf7281$var$FluxQueryTemplateBuilder);


const $66d546eda920c04b$var$TEMPLATE_BUILDERS = {
    [(0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Databases]: (0, $17195e0e27036d0d$export$2e2bcd8739ae039),
    [(0, $ae4c87db4f4621dc$export$fd0446c06165ed92).CSV]: (0, $789d14294d4db619$export$2e2bcd8739ae039),
    [(0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Map]: (0, $9b3422480befa774$export$2e2bcd8739ae039),
    [(0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Measurements]: (0, $5fdfa5b802817c0b$export$2e2bcd8739ae039),
    [(0, $ae4c87db4f4621dc$export$fd0446c06165ed92).FieldKeys]: (0, $de43a3c4e189a3ed$export$2e2bcd8739ae039),
    [(0, $ae4c87db4f4621dc$export$fd0446c06165ed92).TagKeys]: (0, $3b1c219297b35d7d$export$2e2bcd8739ae039),
    [(0, $ae4c87db4f4621dc$export$fd0446c06165ed92).TagValues]: (0, $e3c12ef37ec04857$export$2e2bcd8739ae039),
    [(0, $ae4c87db4f4621dc$export$fd0446c06165ed92).MetaQuery]: (0, $1a16ffc736177930$export$2e2bcd8739ae039),
    [(0, $ae4c87db4f4621dc$export$fd0446c06165ed92).FluxQuery]: (0, $e0917bdb3abf7281$export$2e2bcd8739ae039),
    [(0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Text]: (0, $315a7e181cbf5625$export$2e2bcd8739ae039)
};
const $66d546eda920c04b$var$DEFAULT_TEMPLATE = (0, $a3b88d5d27f00a75$export$d5b92d67f1b42228)[(0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Databases];
const $66d546eda920c04b$var$DYNAMIC_SOURCE_DATABASE_ID = 'dynamic';
class $66d546eda920c04b$var$TemplateVariableEditor extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), // See comment in source changing handler functions at the bottom of the file
        this.key = +new Date(), this.handleUpdateSelectedTemplateValue = (selected)=>{
            const { nextTemplate: nextTemplate, nextTemplate: { values: values } } = this.state;
            const nextValues = values.map((v)=>{
                if (v.value === selected.value) return {
                    ...v,
                    selected: true
                };
                return {
                    ...v,
                    selected: false
                };
            });
            this.setState({
                nextTemplate: {
                    ...nextTemplate,
                    values: nextValues
                }
            });
        }, this.handleUpdateTemplate = (nextNextTemplate)=>{
            const { nextTemplate: nextTemplate } = this.state;
            const templateWithSelectedAndLocalSelected = (0, $258ff394ebf672be$export$1b7f2606dceea62f)(nextTemplate, nextNextTemplate);
            this.setState({
                nextTemplate: templateWithSelectedAndLocalSelected
            });
        }, this.handleChooseType = ({ type: type })=>{
            const { nextTemplate: { id: id, tempVar: tempVar } } = this.state;
            const nextNextTemplate = {
                ...(0, $a3b88d5d27f00a75$export$d5b92d67f1b42228)[type](),
                id: id,
                tempVar: tempVar
            };
            this.setState({
                nextTemplate: nextNextTemplate
            });
        }, this.handleChangeName = (e)=>{
            const { value: value } = e.target;
            const { nextTemplate: nextTemplate } = this.state;
            this.setState({
                nextTemplate: {
                    ...nextTemplate,
                    tempVar: value
                }
            });
        }, this.formatName = ()=>{
            const { nextTemplate: nextTemplate } = this.state;
            let tempVar = (0, $59c041f8acdb6976$export$b9237471bf484894)(nextTemplate.tempVar);
            if (tempVar === '::') tempVar = '';
            this.setState({
                nextTemplate: {
                    ...nextTemplate,
                    tempVar: tempVar
                }
            });
        }, this.handleSave = async ()=>{
            if (!this.canSave) return;
            const { onUpdate: onUpdate, onCreate: onCreate, notify: notify } = this.props;
            const { nextTemplate: nextTemplate, isNew: isNew, isDynamicSourceSelected: isDynamicSourceSelected, selectedSource: selectedSource } = this.state;
            nextTemplate.sourceID = $66d546eda920c04b$var$DYNAMIC_SOURCE_DATABASE_ID;
            if (!isDynamicSourceSelected) nextTemplate.sourceID = selectedSource.id;
            nextTemplate.tempVar = (0, $59c041f8acdb6976$export$b9237471bf484894)(nextTemplate.tempVar);
            this.setState({
                savingStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading
            });
            try {
                if (isNew) {
                    const updatedTemplate = (0, $258ff394ebf672be$export$306a6429e9767166)(nextTemplate);
                    await onCreate(updatedTemplate);
                } else await onUpdate(nextTemplate);
            } catch (error) {
                notify({
                    message: `Error saving template: ${error}`,
                    type: 'error',
                    icon: 'alert-triangle',
                    duration: (0, $e10a8602f56394e3$export$c89f4746f89123d4)
                });
                console.error(error);
            }
        }, this.handleNameKeyPress = (e)=>{
            if (e.key === 'Enter') this.handleSave();
        }, this.handleSelectDynamicSource = ()=>{
            this.setState({
                isDynamicSourceSelected: true
            });
            // Changing this key to be the current timestamp then passing it to the current templateBuilder
            // forces a re-mount, which re-runs its query, which gets the proper data when we change the source.
            // A bit of a hack, sorry.
            this.key = +new Date();
        }, this.handleChangeSource = (source)=>{
            this.setState({
                isDynamicSourceSelected: false,
                selectedSource: source
            });
            // Changing this key to be the current timestamp then passing it to the current templateBuilder
            // forces a re-mount, which re-runs its query, which gets the proper data when we change the source.
            // A bit of a hack, sorry.
            this.key = +new Date();
        }, this.handleDelete = ()=>{
            const { onDelete: onDelete } = this.props;
            this.setState({
                deletingStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading
            }, onDelete);
        };
        let sourceID;
        let selectedSource;
        // If props.template exists, we're loading a source. If it doesn't, we're creating one
        if (props.template && props.template.sourceID) {
            sourceID = props.template.sourceID;
            selectedSource = props.sources.find((s)=>s.id === sourceID);
            if (!selectedSource && sourceID !== $66d546eda920c04b$var$DYNAMIC_SOURCE_DATABASE_ID) {
                const v = props.template.tempVar;
                console.error(`Variable '${v}' uses source '${sourceID}' that does not exist.`);
                sourceID = $66d546eda920c04b$var$DYNAMIC_SOURCE_DATABASE_ID;
            }
        } else sourceID = $66d546eda920c04b$var$DYNAMIC_SOURCE_DATABASE_ID;
        const isDynamicSourceSelected = sourceID === $66d546eda920c04b$var$DYNAMIC_SOURCE_DATABASE_ID;
        if (!selectedSource) // The source id of the current dynamic source is available as a url param
        selectedSource = props.sources.find((source)=>source.id === props.params.sourceID);
        const defaultState = {
            savingStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).NotStarted,
            deletingStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).NotStarted,
            isDynamicSourceSelected: isDynamicSourceSelected,
            selectedSource: selectedSource
        };
        const { template: template } = this.props;
        if (template) this.state = {
            ...defaultState,
            nextTemplate: {
                ...template
            },
            isNew: false
        };
        else this.state = {
            ...defaultState,
            nextTemplate: $66d546eda920c04b$var$DEFAULT_TEMPLATE(),
            isNew: true
        };
    }
    render() {
        const { sources: sources, onCancel: onCancel, notify: notify, templates: templates } = this.props;
        const { isDynamicSourceSelected: isDynamicSourceSelected, selectedSource: selectedSource, nextTemplate: nextTemplate, isNew: isNew } = this.state;
        const TemplateBuilder = this.templateBuilder;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1868bdace58643df$export$2e2bcd8739ae039), {
            maxWidth: 650
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1372e03f76900c5b$export$2e2bcd8739ae039), {
            title: this.title
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "btn-group--right"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-default btn-sm",
            type: "button",
            onClick: onCancel,
            "data-test": "btn-cancel"
        }, "Cancel"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-success btn-sm",
            type: "button",
            onClick: this.handleSave,
            disabled: !this.canSave,
            "data-test": "btn-accept"
        }, this.saveButtonText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1e8c886c7914a527$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "faux-form"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-sm-4"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", null, "Data Source"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $daaa6355868bebe1$export$2e2bcd8739ae039), {
            onSelectDynamicSource: this.handleSelectDynamicSource,
            sources: sources,
            source: selectedSource,
            isDynamicSourceSelected: isDynamicSourceSelected,
            onChangeSource: this.handleChangeSource,
            allowDynamicSource: true,
            type: (0, $b4506126e09430df$export$7c8e26efb80b90e8).InfluxQL,
            widthPixels: 0,
            zIndex: '9999'
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-sm-4"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", null, "Name"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            type: "text",
            className: "form-control input-sm form-astronaut",
            value: nextTemplate.tempVar,
            onChange: this.handleChangeName,
            onKeyPress: this.handleNameKeyPress,
            onBlur: this.formatName,
            spellCheck: false,
            "data-test": "variable-name-type"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-sm-4"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", null, "Type"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ca4f14339173643c$export$2e2bcd8739ae039), {
            items: (0, $a3b88d5d27f00a75$export$c4bb51af054593c4),
            onChoose: this.handleChooseType,
            selected: this.dropdownSelection,
            buttonSize: "btn-sm",
            className: "dropdown-stretch"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement(TemplateBuilder, {
            key: this.key,
            template: nextTemplate,
            templates: templates,
            source: selectedSource,
            onUpdateTemplate: this.handleUpdateTemplate,
            notify: notify,
            onUpdateDefaultTemplateValue: this.handleUpdateSelectedTemplateValue
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group text-center form-group-submit col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $8008717819fc7a5f$export$2e2bcd8739ae039), {
            text: this.confirmText,
            confirmAction: this.handleDelete,
            type: "btn-danger",
            size: "btn-sm",
            customClass: "delete",
            disabled: isNew || this.isDeleting
        })))));
    }
    get confirmText() {
        if (this.isDeleting) return 'Deleting...';
        return 'Delete';
    }
    get title() {
        const { isNew: isNew } = this.state;
        let prefix = 'Edit';
        if (isNew) prefix = 'Create';
        return `${prefix} Template Variable`;
    }
    get templateBuilder() {
        const { nextTemplate: { type: type } } = this.state;
        const component = $66d546eda920c04b$var$TEMPLATE_BUILDERS[type];
        if (!component) throw new Error(`Could not find template builder for type "${type}"`);
        return component;
    }
    get isSaving() {
        return this.state.savingStatus === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading;
    }
    get canSave() {
        const { nextTemplate: { tempVar: tempVar, type: type, values: values }, isNew: isNew } = this.state;
        const templates = this.props.templates || [];
        if (tempVar === '') return false;
        if (type === (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).CSV && (0, $hBdgJ.isEmpty)(values)) return false;
        const variable = (0, $59c041f8acdb6976$export$b9237471bf484894)(tempVar);
        if ((0, $a3b88d5d27f00a75$export$c13acb51e10a08e2).includes(variable)) return false;
        if (isNew && templates.some((t)=>t.tempVar === variable)) // duplicate variable on create
        return false;
        const template = this.props.template;
        if (!isNew && template && templates.reduce((acc, t)=>{
            if (t.tempVar === variable && template.id !== t.id) return acc + 1;
            return acc;
        }, 0) > 0) // duplicate variable on update
        return false;
        return !this.isSaving;
    }
    get dropdownSelection() {
        const { nextTemplate: { type: type } } = this.state;
        return (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)((0, $a3b88d5d27f00a75$export$c4bb51af054593c4).filter((t)=>t.type === type), '0.text', '');
    }
    get saveButtonText() {
        const { isNew: isNew } = this.state;
        if (this.isSaving && isNew) return 'Creating...';
        if (this.isSaving && !isNew) return 'Saving...';
        if (!this.isSaving && isNew) return 'Create';
        return 'Save';
    }
    get isDeleting() {
        return this.state.deletingStatus === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading;
    }
}
const $66d546eda920c04b$var$mdtp = {
    notify: (0, $205d139de2918454$export$5e14cdade93d6f7b)
};
const $66d546eda920c04b$var$mstp = (state)=>{
    const { sources: sources } = state;
    return {
        sources: sources
    };
};
var $66d546eda920c04b$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($66d546eda920c04b$var$mstp, $66d546eda920c04b$var$mdtp)((0, $dffbdf89c590a961$export$2e2bcd8739ae039)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($66d546eda920c04b$var$TemplateVariableEditor)));




var $hBdgJ = parcelRequire("hBdgJ");

const $558818baf18c178b$export$e2266d07d658e0d = 120;
const $558818baf18c178b$export$82e774cd8a35d58d = 330;
const $558818baf18c178b$export$d7161b0199bef7f0 = 30;
const $558818baf18c178b$var$valueLength = (a)=>(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).size(a.value);
const $558818baf18c178b$export$9fcdcb226d757a02 = (values)=>{
    if (!values || !values.length) return $558818baf18c178b$export$e2266d07d658e0d;
    const longest = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).maxBy(values, $558818baf18c178b$var$valueLength);
    const longestValuePixels = (0, (/*@__PURE__*/$parcel$interopDefault($9595af9b15fd4b76$exports)))(longest.value, {
        font: 'Monospace',
        fontSize: '12px'
    }).width + $558818baf18c178b$export$d7161b0199bef7f0;
    if (longestValuePixels < $558818baf18c178b$export$e2266d07d658e0d) return $558818baf18c178b$export$e2266d07d658e0d;
    if (longestValuePixels > $558818baf18c178b$export$82e774cd8a35d58d) return $558818baf18c178b$export$82e774cd8a35d58d;
    return longestValuePixels;
};



class $61c8017714fc4cd9$var$TemplateControl extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleShowSettings = ()=>{
            this.setState({
                isEditing: true
            });
        }, this.handleHideSettings = ()=>{
            this.setState({
                isEditing: false
            });
        }, this.handleUpdateTemplate = async (template)=>{
            const { onUpdateTemplate: onUpdateTemplate } = this.props;
            await onUpdateTemplate(template);
            this.setState({
                isEditing: false
            });
        }, this.handleDelete = ()=>{
            const { onDeleteTemplate: onDeleteTemplate, template: template } = this.props;
            return onDeleteTemplate(template);
        };
        this.state = {
            isEditing: false
        };
    }
    render() {
        const { template: template, templates: templates, source: source, onCreateTemplate: onCreateTemplate, onPickValue: onPickValue } = this.props;
        const { isEditing: isEditing } = this.state;
        const dropdownStyle = template.values.length ? {
            minWidth: (0, $558818baf18c178b$export$9fcdcb226d757a02)(template.values)
        } : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "template-control--dropdown",
            style: dropdownStyle
        }, template.type === (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Text ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $823c213757a0f70b$export$2e2bcd8739ae039), {
            template: template,
            onPickValue: onPickValue,
            key: template.id
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $4b353aa0c817068e$export$2e2bcd8739ae039), {
            template: template,
            onPickValue: onPickValue
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            className: "template-control--label"
        }, template.tempVar, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $091cfcd49e339acd$export$2e2bcd8739ae039), {
            requiredRole: (0, $a7910b1002260d34$export$f715f7e27dea2abf)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon cog-thick",
            onClick: this.handleShowSettings,
            "data-test": "edit"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $827fcd4cb090ac0e$export$2e2bcd8739ae039), {
            visible: isEditing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $66d546eda920c04b$export$2e2bcd8739ae039), {
            template: template,
            templates: templates,
            source: source,
            onCreate: onCreateTemplate,
            onUpdate: this.handleUpdateTemplate,
            onDelete: this.handleDelete,
            onCancel: this.handleHideSettings
        })));
    }
}
var $61c8017714fc4cd9$export$2e2bcd8739ae039 = $61c8017714fc4cd9$var$TemplateControl;






class $2194950b8f69e45b$var$TemplateControlBar extends (0, $NdCUR.Component) {
    constructor(props){
        super(props), this.handleAddVariable = ()=>{
            this.setState({
                isAdding: true
            });
        }, this.handleCancelAddVariable = ()=>{
            this.setState({
                isAdding: false
            });
        }, this.handleCreateTemplate = async (template)=>{
            const { templates: templates, onSaveTemplates: onSaveTemplates } = this.props;
            const newTemplates = [
                ...templates,
                template
            ];
            // Verify adding template yields a valid template graph (will throw if not)
            (0, $7b6b69e6512d0c7d$export$1a7bd1bb4818a731)(newTemplates);
            await onSaveTemplates(newTemplates);
            this.setState({
                isAdding: false
            });
        }, this.handleUpdateTemplate = async (template)=>{
            const { templates: templates, onSaveTemplates: onSaveTemplates } = this.props;
            const newTemplates = templates.reduce((acc, t)=>{
                if (t.id === template.id) return [
                    ...acc,
                    template
                ];
                return [
                    ...acc,
                    t
                ];
            }, []);
            // Verify update yields a valid template graph (will throw if not)
            (0, $7b6b69e6512d0c7d$export$1a7bd1bb4818a731)(newTemplates);
            await onSaveTemplates(newTemplates);
        }, this.handleDeleteTemplate = async (template)=>{
            const { templates: templates, onSaveTemplates: onSaveTemplates } = this.props;
            const newTemplates = templates.filter((t)=>t.id !== template.id);
            await onSaveTemplates(newTemplates);
        };
        this.state = {
            isAdding: false
        };
    }
    render() {
        const { templates: templates, source: source } = this.props;
        const { isAdding: isAdding } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "template-control-bar"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "template-control--container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "template-control--controls"
        }, this.renderTemplateControls(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $827fcd4cb090ac0e$export$2e2bcd8739ae039), {
            visible: isAdding
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $66d546eda920c04b$export$2e2bcd8739ae039), {
            templates: templates,
            source: source,
            onCreate: this.handleCreateTemplate,
            onCancel: this.handleCancelAddVariable
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $091cfcd49e339acd$export$2e2bcd8739ae039), {
            requiredRole: (0, $a7910b1002260d34$export$f715f7e27dea2abf)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-primary btn-sm template-control--manage",
            "data-test": "add-template-variable",
            onClick: this.handleAddVariable
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon plus"
        }), "Add Template Variable"))));
    }
    renderTemplateControls() {
        const { templates: templates, onPickTemplate: onPickTemplate, meRole: meRole, isUsingAuth: isUsingAuth, source: source } = this.props;
        if (!templates || !templates.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "template-control--empty",
            "data-test": "empty-state"
        }, "This dashboard does not have any ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("strong", null, "Template Variables"));
        return templates.map((template)=>{
            const onPickValue = (v)=>onPickTemplate(template, v);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $61c8017714fc4cd9$export$2e2bcd8739ae039), {
                key: template.id,
                meRole: meRole,
                isUsingAuth: isUsingAuth,
                template: template,
                templates: templates,
                source: source,
                onPickValue: onPickValue,
                onCreateTemplate: this.handleCreateTemplate,
                onUpdateTemplate: this.handleUpdateTemplate,
                onDeleteTemplate: this.handleDeleteTemplate
            });
        });
    }
}
var $2194950b8f69e45b$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($2194950b8f69e45b$var$TemplateControlBar);



var $NdCUR = parcelRequire("NdCUR");


var $NdCUR = parcelRequire("NdCUR");





const $72d929e461df84d4$var$AddAnnotationToggle = (props)=>{
    const { isAddingAnnotation: isAddingAnnotation, onAddingAnnotation: onAddingAnnotation, onDismissAddingAnnotation: onDismissAddingAnnotation, isUsingAuth: isUsingAuth, me: me } = props;
    if (isUsingAuth && !(0, $a7910b1002260d34$export$7d499847c5200082)(me.role, (0, $a7910b1002260d34$export$1d39a112fd67439d))) return null;
    let onToggle;
    let buttonContent = 'Annotate';
    let buttonColor = (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Primary;
    let buttonIcon = (0, $918c9f03a35fe03f$export$62c9c0cf752cde38).AnnotatePlus;
    let buttonDataTest = 'add-annotation--button';
    if (isAddingAnnotation) {
        onToggle = onDismissAddingAnnotation;
        buttonContent = 'Cancel Annotate';
        buttonColor = (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Default;
        buttonIcon = (0, $918c9f03a35fe03f$export$62c9c0cf752cde38).Remove;
        buttonDataTest = 'cancel-annotation--button';
    } else onToggle = onAddingAnnotation;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
        icon: buttonIcon,
        color: buttonColor,
        text: buttonContent,
        onClick: onToggle,
        testId: buttonDataTest
    });
};
const $72d929e461df84d4$var$mstp = ({ auth: { isUsingAuth: isUsingAuth, me: me }, annotations: { mode: mode } })=>({
        isAddingAnnotation: mode === (0, $53b1df725ed2947c$export$cd452f24a53287fb),
        isUsingAuth: isUsingAuth,
        me: me
    });
const $72d929e461df84d4$var$mdtp = {
    onAddingAnnotation: (0, $fa0d0f2e90b47171$export$3dbce9299df8a230),
    onDismissAddingAnnotation: (0, $fa0d0f2e90b47171$export$b6196d50b015cc18)
};
var $72d929e461df84d4$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($72d929e461df84d4$var$mstp, $72d929e461df84d4$var$mdtp)($72d929e461df84d4$var$AddAnnotationToggle);



var $NdCUR = parcelRequire("NdCUR");


var $NdCUR = parcelRequire("NdCUR");
const $e7984bb055ccbe2c$var$lexographicOrder = (a, b)=>{
    if (a) return a.localeCompare(b);
    return 0;
};
class $e7984bb055ccbe2c$var$AnnotationFilterControlInput extends (0, $NdCUR.PureComponent) {
    static getDerivedStateFromProps(props, state) {
        const { suggestions: suggestions, value: value } = props;
        const { shouldShowAllSuggestions: shouldShowAllSuggestions } = state;
        let filteredSuggestions = [
            ...suggestions.sort($e7984bb055ccbe2c$var$lexographicOrder)
        ];
        if (shouldShowAllSuggestions) return {
            filteredSuggestions: filteredSuggestions
        };
        filteredSuggestions = filteredSuggestions.filter((v)=>v && v.includes(value));
        return {
            filteredSuggestions: filteredSuggestions
        };
    }
    constructor(props){
        super(props), this.handleChange = (e)=>{
            this.setState({
                shouldShowAllSuggestions: false
            });
            this.props.onChange(e.target.value);
        }, this.handleFocus = ()=>{
            this.setState({
                areSuggestionsVisible: true,
                shouldShowAllSuggestions: true
            });
            this.props.onFocus();
        }, this.handleBlur = ()=>{
            // When a user clicks a suggestion in the suggestion list, the input blur
            // event fires first. By not hiding the suggestion list immediately, we
            // allow the click event to fire too and the suggestion to be properly
            // selected
            this.hideSuggestionsTimer = setTimeout(()=>{
                this.setState({
                    areSuggestionsVisible: false
                });
            }, 150);
        }, this.handleKeyUp = (e)=>{
            const { key: key, ctrlKey: ctrlKey } = e;
            if (key === 'Enter') {
                const { selectionIndex: selectionIndex, filteredSuggestions: filteredSuggestions } = this.state;
                const newValue = filteredSuggestions[selectionIndex] || this.input.current.value;
                this.handleSelect(newValue);
            } else if (key === 'ArrowDown' || ctrlKey && (key === 'j' || key === 'n') // emacs and vim bindings
            ) this.incrementSelectionIndex(1);
            else if (key === 'ArrowUp' || ctrlKey && (key === 'k' || key === 'p')) this.incrementSelectionIndex(-1);
        }, this.handleSelect = (value)=>{
            const { onSelect: onSelect } = this.props;
            this.input.current.value = value;
            this.input.current.blur();
            this.setState({
                areSuggestionsVisible: false
            });
            onSelect(value);
        }, this.incrementSelectionIndex = (di)=>{
            const { filteredSuggestions: filteredSuggestions } = this.state;
            let selectionIndex = this.state.selectionIndex + di;
            if (selectionIndex < 0) selectionIndex = 0;
            if (selectionIndex >= filteredSuggestions.length) selectionIndex = filteredSuggestions.length - 1;
            this.setState({
                selectionIndex: selectionIndex
            });
        };
        this.input = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createRef();
        this.state = {
            filteredSuggestions: props.suggestions,
            selectionIndex: 0,
            areSuggestionsVisible: false,
            shouldShowAllSuggestions: false
        };
    }
    render() {
        const { value: value } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "suggestion-input"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            ref: this.input,
            className: this.inputClass,
            defaultValue: value,
            onChange: this.handleChange,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            onKeyUp: this.handleKeyUp
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: `suggestion-input--suggestions dropdown-menu ${this.suggestionsClass}`
        }, this.suggestionDropdownItems));
    }
    componentWillUnmount() {
        clearTimeout(this.hideSuggestionsTimer);
    }
    get suggestionDropdownItems() {
        const { selectionIndex: selectionIndex, filteredSuggestions: filteredSuggestions } = this.state;
        return filteredSuggestions.map((v, i)=>{
            const selectedClass = i === selectionIndex ? 'selected' : '';
            const onClick = ()=>this.handleSelect(v);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                key: v,
                className: `suggestion-input-suggestion dropdown-item ${selectedClass}`,
                onClick: onClick
            }, v);
        });
    }
    get suggestionsClass() {
        return this.state.areSuggestionsVisible ? '' : 'hidden';
    }
    get inputClass() {
        const { inputClass: inputClass } = this.props;
        return `suggestion-input--input form-control ${inputClass ? inputClass : ''}`;
    }
}
var $e7984bb055ccbe2c$export$2e2bcd8739ae039 = $e7984bb055ccbe2c$var$AnnotationFilterControlInput;



const $d43d616fc11c71ca$var$nextItem = (xs, x)=>xs[(xs.indexOf(x) + 1) % xs.length];
class $d43d616fc11c71ca$var$AnnotationFilterControl extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleTagKeyFocus = async ()=>{
            this.setState({
                draftState: 'EDITING'
            });
            const keySuggestions = await this.props.onGetKeySuggestions();
            this.setState({
                keySuggestions: keySuggestions
            });
        }, this.handleTagValueFocus = async ()=>{
            this.setState({
                draftState: 'EDITING'
            });
            const valueSuggestions = await this.props.onGetValueSuggestions(this.state.tagKey);
            this.setState({
                valueSuggestions: valueSuggestions
            });
        }, this.handleDelete = ()=>{
            const { onDelete: onDelete, tagFilter: tagFilter } = this.props;
            this.setState({
                draftState: 'SAVING'
            });
            onDelete(tagFilter);
        }, this.toggleFilterType = ()=>{
            const { filterType: filterType } = this.state;
            this.setState({
                filterType: $d43d616fc11c71ca$var$nextItem((0, $53b1df725ed2947c$export$7e2445fa2039ccf1), filterType),
                draftState: 'EDITING'
            });
        }, this.save = async ()=>{
            const { onUpdate: onUpdate, onDelete: onDelete, tagFilter: tagFilter } = this.props;
            const { tagKey: tagKey, filterType: filterType, tagValue: tagValue } = this.state;
            if (!this.isValid) return;
            this.setState({
                draftState: 'SAVING'
            });
            if (tagKey === '') onDelete(tagFilter);
            else {
                await onUpdate({
                    id: tagFilter.id,
                    tagKey: tagKey,
                    filterType: filterType,
                    tagValue: tagValue
                });
                this.setState({
                    draftState: 'DEFAULT'
                });
            }
        }, this.handleSelectTagKey = (tagKey)=>{
            this.setState({
                tagKey: tagKey
            }, this.save);
        }, this.handleSelectTagValue = (tagValue)=>{
            this.setState({
                tagValue: tagValue
            }, this.save);
        }, this.handleTagKeyChange = (tagKey)=>{
            this.setState({
                tagKey: tagKey
            });
        }, this.handleTagValueChange = (tagValue)=>{
            this.setState({
                tagValue: tagValue
            });
        };
        const { tagKey: tagKey, tagValue: tagValue, filterType: filterType } = props.tagFilter;
        this.state = {
            tagKey: tagKey,
            tagValue: tagValue,
            filterType: filterType,
            keySuggestions: [],
            valueSuggestions: [],
            draftState: 'DEFAULT'
        };
    }
    render() {
        const { tagKey: tagKey, tagValue: tagValue, filterType: filterType, keySuggestions: keySuggestions, valueSuggestions: valueSuggestions } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "annotation-filter-control"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "annotation-filter-control--tag-key"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $e7984bb055ccbe2c$export$2e2bcd8739ae039), {
            value: tagKey,
            inputClass: "input-xs",
            onChange: this.handleTagKeyChange,
            onFocus: this.handleTagKeyFocus,
            onSelect: this.handleSelectTagKey,
            suggestions: keySuggestions
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
            text: filterType,
            color: (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Default,
            status: (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Default,
            size: (0, $918c9f03a35fe03f$export$fafce5c139da9687).ExtraSmall,
            onClick: this.toggleFilterType,
            tabIndex: -1
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "annotation-filter-control--tag-value"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $e7984bb055ccbe2c$export$2e2bcd8739ae039), {
            value: tagValue,
            inputClass: "input-xs",
            onChange: this.handleTagValueChange,
            onFocus: this.handleTagValueFocus,
            onSelect: this.handleSelectTagValue,
            suggestions: valueSuggestions
        })), this.button);
    }
    get button() {
        const { draftState: draftState } = this.state;
        let status = (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Default;
        let color = (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Default;
        let icon = (0, $918c9f03a35fe03f$export$62c9c0cf752cde38).Trash;
        let onClick = this.handleDelete;
        if (draftState === 'SAVING') {
            status = (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Loading;
            color = (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Success;
        } else if (draftState === 'EDITING') {
            icon = (0, $918c9f03a35fe03f$export$62c9c0cf752cde38).Checkmark;
            color = (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Success;
            onClick = this.save;
        }
        if (!this.isValid && draftState !== 'DEFAULT') status = (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Disabled;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
            text: "",
            size: (0, $918c9f03a35fe03f$export$fafce5c139da9687).ExtraSmall,
            shape: (0, $918c9f03a35fe03f$export$ce765fb8bb08a599).Square,
            status: status,
            icon: icon,
            color: color,
            onClick: onClick
        });
    }
    get isValid() {
        const { tagKey: tagKey, tagValue: tagValue } = this.state;
        return tagKey !== '' && tagValue !== '';
    }
}
var $d43d616fc11c71ca$export$2e2bcd8739ae039 = $d43d616fc11c71ca$var$AnnotationFilterControl;



var $NdCUR = parcelRequire("NdCUR");




const $be697b31234f60b5$var$DROPDOWN_WIDTH = 210;
const $be697b31234f60b5$var$AnnotationsDisplaySettingDropdown = ({ annotationsDisplaySetting: annotationsDisplaySetting, onSetDisplaySetting: onSetDisplaySetting })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $f040dbec7e8f99c8$export$2e2bcd8739ae039), {
        widthPixels: $be697b31234f60b5$var$DROPDOWN_WIDTH,
        onChange: onSetDisplaySetting,
        selectedID: annotationsDisplaySetting
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $f040dbec7e8f99c8$export$2e2bcd8739ae039).Item, {
        id: (0, $0714a56b2816a4c7$export$e62cccb760c33405).HideAnnotations,
        value: (0, $0714a56b2816a4c7$export$e62cccb760c33405).HideAnnotations
    }, "Hide Annotations"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $f040dbec7e8f99c8$export$2e2bcd8739ae039).Item, {
        id: (0, $0714a56b2816a4c7$export$e62cccb760c33405).FilterAnnotationsByTag,
        value: (0, $0714a56b2816a4c7$export$e62cccb760c33405).FilterAnnotationsByTag
    }, "Filter Annotations By Tags"));
};
const $be697b31234f60b5$var$mstp = (state)=>({
        annotationsDisplaySetting: state.app.persisted.annotationsDisplaySetting
    });
const $be697b31234f60b5$var$mdtp = {
    onSetDisplaySetting: (0, $fa0d0f2e90b47171$export$a1c2cacba2645386)
};
var $be697b31234f60b5$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($be697b31234f60b5$var$mstp, $be697b31234f60b5$var$mdtp)($be697b31234f60b5$var$AnnotationsDisplaySettingDropdown);







class $6f7b760e95990040$var$AnnotationControlBar extends (0, $NdCUR.PureComponent) {
    render() {
        const { tagFilters: tagFilters, annotationsDisplaySetting: annotationsDisplaySetting } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "annotation-control-bar"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "annotation-control-bar--lhs"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $be697b31234f60b5$export$2e2bcd8739ae039), null), annotationsDisplaySetting === (0, $0714a56b2816a4c7$export$e62cccb760c33405).FilterAnnotationsByTag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, tagFilters.map((tagFilter)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $d43d616fc11c71ca$export$2e2bcd8739ae039), {
                key: tagFilter.id,
                tagFilter: tagFilter,
                onUpdate: this.handleUpdateTagFilter,
                onDelete: this.handleDeleteTagFilter,
                onGetKeySuggestions: this.handleGetKeySuggestions,
                onGetValueSuggestions: this.handleGetValueSuggestions
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
            onClick: this.handleAddTagFilter,
            icon: (0, $918c9f03a35fe03f$export$62c9c0cf752cde38).Plus,
            color: (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Primary,
            text: 'Filter',
            titleText: 'Add New Annotation Tag Filter',
            testId: 'add-annotation-filter--button'
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "annotation-control-bar--rhs"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $72d929e461df84d4$export$2e2bcd8739ae039), null)));
    }
    constructor(...args){
        super(...args), this.handleAddTagFilter = async ()=>{
            const { dashboardID: dashboardID, onUpdateTagFilter: onUpdateTagFilter } = this.props;
            await onUpdateTagFilter(dashboardID, (0, $53b1df725ed2947c$export$4d61b4ac02d59f55)());
        }, this.handleUpdateTagFilter = async (t)=>{
            const { source: source, dashboardID: dashboardID, onUpdateTagFilterAsync: onUpdateTagFilterAsync } = this.props;
            await onUpdateTagFilterAsync(source.links.annotations, dashboardID, t);
        }, this.handleDeleteTagFilter = async (t)=>{
            const { source: source, dashboardID: dashboardID, onDeleteTagFilterAsync: onDeleteTagFilterAsync } = this.props;
            await onDeleteTagFilterAsync(source.links.annotations, dashboardID, t);
        }, this.handleGetKeySuggestions = async ()=>{
            const { tagKeys: tagKeys, onGetTagKeys: onGetTagKeys, source: source } = this.props;
            if (tagKeys) return tagKeys;
            await onGetTagKeys(source.links.proxy);
            return this.props.tagKeys;
        }, this.handleGetValueSuggestions = async (tagKey)=>{
            const { tagValues: tagValues, onGetTagValues: onGetTagValues, source: source } = this.props;
            if (tagValues[tagKey]) return tagValues[tagKey];
            await onGetTagValues(source.links.proxy, tagKey);
            return this.props.tagValues[tagKey];
        };
    }
}
const $6f7b760e95990040$var$mstp = (state, ownProps)=>{
    const { tagKeys: tagKeys, tagValues: tagValues } = state.annotations;
    const tagFilters = (0, $eeeaf526f24e9bde$export$16e65df6d1ee4126)(state, ownProps.dashboardID);
    return {
        tagFilters: tagFilters,
        tagKeys: tagKeys,
        tagValues: tagValues,
        annotationsDisplaySetting: state.app.persisted.annotationsDisplaySetting
    };
};
const $6f7b760e95990040$var$mdtp = {
    onUpdateTagFilter: (0, $fa0d0f2e90b47171$export$fc64c54f0e1d3b9e),
    onUpdateTagFilterAsync: (0, $fa0d0f2e90b47171$export$359b5cf394a2d642),
    onDeleteTagFilterAsync: (0, $fa0d0f2e90b47171$export$e0d940591f229d7f),
    onGetTagKeys: (0, $fa0d0f2e90b47171$export$3e0c61203e6f47fc),
    onGetTagValues: (0, $fa0d0f2e90b47171$export$bafb7deb947f563e)
};
var $6f7b760e95990040$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($6f7b760e95990040$var$mstp, $6f7b760e95990040$var$mdtp)($6f7b760e95990040$var$AnnotationControlBar);



var $NdCUR = parcelRequire("NdCUR");


var $NdCUR = parcelRequire("NdCUR");




var $NdCUR = parcelRequire("NdCUR");


var $axd2S = parcelRequire("axd2S");



var $NdCUR = parcelRequire("NdCUR");

class $6026f118057a51aa$var$AnnotationTagEditorLi extends (0, $NdCUR.PureComponent) {
    render() {
        const { tagKey: tagKey, tagValue: tagValue, onDelete: onDelete, shouldAutoFocus: shouldAutoFocus } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "tag-control"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control input-sm tag-control--key",
            value: tagKey,
            onChange: this.handleChangeTagKey,
            autoFocus: shouldAutoFocus
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "tag-control--arrow"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control input-sm tag-control--value",
            value: tagValue,
            onChange: this.handleChangeTagValue,
            onKeyDown: this.handleKeyDown
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
            onClick: onDelete,
            icon: (0, $918c9f03a35fe03f$export$62c9c0cf752cde38).Remove,
            shape: (0, $918c9f03a35fe03f$export$ce765fb8bb08a599).Square,
            size: (0, $918c9f03a35fe03f$export$fafce5c139da9687).Small,
            color: (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Default
        }));
    }
    constructor(...args){
        super(...args), this.handleKeyDown = (e)=>{
            const { onKeyDown: onKeyDown } = this.props;
            onKeyDown(e.key);
        }, this.handleChangeTagKey = (e)=>{
            const { onUpdate: onUpdate, tagValue: tagValue } = this.props;
            onUpdate(e.target.value, tagValue);
        }, this.handleChangeTagValue = (e)=>{
            const { onUpdate: onUpdate, tagKey: tagKey } = this.props;
            onUpdate(tagKey, e.target.value);
        };
    }
}
var $6026f118057a51aa$export$2e2bcd8739ae039 = $6026f118057a51aa$var$AnnotationTagEditorLi;






const $d0c67fa32852ab0b$var$INPUT_DEBOUNCE_TIME = 600;
const $d0c67fa32852ab0b$var$DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss.SS';
const $d0c67fa32852ab0b$var$BAD_DATETIME_ERROR = 'Not a valid date';
const $d0c67fa32852ab0b$var$END_BEFORE_START_ERROR = 'End date must be after start date';
const $d0c67fa32852ab0b$var$EMPTY_TEXT_ERROR = 'Name cannot be empty';
const $d0c67fa32852ab0b$var$DUPLICATE_KEY_ERROR = 'Tag keys must be unique';
const $d0c67fa32852ab0b$var$getTime = (d)=>new Date(d).getTime();
const $d0c67fa32852ab0b$var$isValidDate = (d)=>!isNaN($d0c67fa32852ab0b$var$getTime(d));
const $d0c67fa32852ab0b$var$formatDate = (d)=>(0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(d).format($d0c67fa32852ab0b$var$DATETIME_FORMAT);
class $d0c67fa32852ab0b$var$AnnotationEditorForm extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.onKeyDown = (e)=>{
            switch(e){
                case 'Enter':
                    this.handleAddTag();
                    return;
            }
        }, this.handleTextChange = ({ target: { value: text } })=>{
            let nextState = {
                text: text,
                textError: null
            };
            if (!text) nextState = {
                text: text,
                textError: $d0c67fa32852ab0b$var$EMPTY_TEXT_ERROR
            };
            this.setState(nextState, ()=>this.setDraftAnnotation());
        }, this.handleTypeChange = (type)=>{
            if (type === 'point') this.setState({
                type: type
            }, ()=>this.setDraftAnnotation());
            else if (type === 'window') {
                const endTime = $d0c67fa32852ab0b$var$getTime(this.props.annotation.endTime);
                this.setState({
                    type: type,
                    endTimeInput: $d0c67fa32852ab0b$var$formatDate(endTime),
                    endTimeError: null
                }, ()=>this.changeEndTime());
            }
        }, this.handleStartTimeInputChange = (e)=>{
            this.setState({
                startTimeInput: e.target.value,
                startTimeError: null
            }, ()=>{
                this.debouncer.call(this.changeStartTime, $d0c67fa32852ab0b$var$INPUT_DEBOUNCE_TIME);
            });
        }, this.handleStartTimeInputBlur = ()=>{
            const { startTimeInput: startTimeInput } = this.state;
            if ($d0c67fa32852ab0b$var$isValidDate(startTimeInput)) this.setState({
                startTimeInput: $d0c67fa32852ab0b$var$formatDate($d0c67fa32852ab0b$var$getTime(startTimeInput))
            });
        }, this.changeStartTime = ()=>{
            const { startTimeInput: startTimeInput } = this.state;
            let nextState = {
                startTime: $d0c67fa32852ab0b$var$getTime(startTimeInput),
                startTimeError: null
            };
            if (!$d0c67fa32852ab0b$var$isValidDate(startTimeInput)) nextState = {
                startTimeError: $d0c67fa32852ab0b$var$BAD_DATETIME_ERROR
            };
            this.setState(nextState, ()=>this.setDraftAnnotation());
        }, this.handleEndTimeInputChange = (e)=>{
            this.setState({
                endTimeInput: e.target.value,
                endTimeError: null
            }, ()=>{
                this.debouncer.call(this.changeEndTime, $d0c67fa32852ab0b$var$INPUT_DEBOUNCE_TIME);
            });
        }, this.handleEndTimeInputBlur = ()=>{
            const { endTimeInput: endTimeInput } = this.state;
            if ($d0c67fa32852ab0b$var$isValidDate(endTimeInput)) this.setState({
                endTimeInput: $d0c67fa32852ab0b$var$formatDate($d0c67fa32852ab0b$var$getTime(endTimeInput))
            });
        }, this.changeEndTime = ()=>{
            const { startTime: startTime, endTimeInput: endTimeInput } = this.state;
            let nextState = {
                endTime: $d0c67fa32852ab0b$var$getTime(endTimeInput),
                endTimeError: null
            };
            if (!$d0c67fa32852ab0b$var$isValidDate(endTimeInput)) nextState = {
                endTimeError: $d0c67fa32852ab0b$var$BAD_DATETIME_ERROR
            };
            else if ($d0c67fa32852ab0b$var$getTime(endTimeInput) < startTime) nextState = {
                endTimeError: $d0c67fa32852ab0b$var$END_BEFORE_START_ERROR
            };
            this.setState(nextState, ()=>this.setDraftAnnotation());
        }, this.handleChangeColor = (color)=>{
            this.setState({
                color: color
            }, this.setDraftAnnotation);
        }, this.handleAddTag = ()=>{
            const newTag = {
                id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
                tagKey: '',
                tagValue: '',
                shouldAutoFocus: true
            };
            const oldTags = this.state.tags.map((tag)=>{
                return {
                    ...tag,
                    shouldAutoFocus: false
                };
            });
            this.setState({
                tags: [
                    ...oldTags,
                    newTag
                ]
            }, this.setDraftAnnotation);
        }, this.handleUpdateTag = (id)=>(tagKey, tagValue)=>{
                const { tags: tags } = this.state;
                const newTag = {
                    id: id,
                    tagKey: tagKey,
                    tagValue: tagValue
                };
                const i = tags.findIndex((t)=>t.id === id);
                const newTags = [
                    ...tags.slice(0, i),
                    newTag,
                    ...tags.slice(i + 1)
                ];
                const uniqueKeys = new Set(newTags.map((t)=>t.tagKey));
                const nextState = {
                    tags: newTags
                };
                if ((0, $53b1df725ed2947c$export$f35938869845200f).includes(tagKey)) nextState.tagsError = `\u{201C}${tagKey}\u{201D} cannot be used as a tag key`;
                else if (uniqueKeys.size < tags.length) nextState.tagsError = $d0c67fa32852ab0b$var$DUPLICATE_KEY_ERROR;
                else nextState.tagsError = null;
                this.setState(nextState, this.setDraftAnnotation);
            }, this.handleDeleteTag = (id)=>()=>{
                const tags = this.state.tags.filter((t)=>t.id !== id);
                const uniqueKeys = new Set(tags.map((t)=>t.tagKey));
                const nextState = {
                    tags: tags
                };
                if (uniqueKeys.size < tags.length) nextState.tagsError = $d0c67fa32852ab0b$var$DUPLICATE_KEY_ERROR;
                else nextState.tagsError = null;
                this.setState(nextState, this.setDraftAnnotation);
            }, this.setDraftAnnotation = ()=>{
            const { annotation: annotation, onSetDraftAnnotation: onSetDraftAnnotation } = this.props;
            const { type: type, startTime: startTime, endTime: endTime, text: text, color: color, startTimeError: startTimeError, endTimeError: endTimeError, textError: textError, tagsError: tagsError, tags: tags } = this.state;
            if (!!startTimeError || !!endTimeError || !!textError || !!tagsError) {
                onSetDraftAnnotation(null);
                return;
            }
            const annotationTags = tags.reduce((acc, { tagKey: tagKey, tagValue: tagValue })=>({
                    ...acc,
                    [tagKey]: tagValue
                }), {});
            delete annotationTags[''];
            onSetDraftAnnotation({
                id: annotation.id,
                startTime: startTime,
                endTime: type === 'window' ? endTime : startTime,
                text: text,
                color: color.hex,
                tags: annotationTags,
                links: annotation.links
            });
        };
        this.debouncer = props.debouncer || new (0, $075f3b99bb3716e4$export$2e2bcd8739ae039)();
        const { text: text, startTime: startTime, endTime: endTime } = props.annotation;
        const type = startTime === endTime ? 'point' : 'window';
        const tags = Object.entries(props.annotation.tags || {}).map(([k, v])=>({
                id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
                tagKey: k,
                tagValue: v,
                shouldAutoFocus: false
            }));
        const initColor = props.annotation.color || (0, $687ef8d4c4e21a50$export$d2d74e32cf0de1d5).hex;
        let color = (0, $687ef8d4c4e21a50$export$5d93f993ca7fe88c).find((x)=>x.hex === initColor);
        let colors;
        if (color) colors = (0, $687ef8d4c4e21a50$export$5d93f993ca7fe88c);
        else {
            color = {
                name: 'custom',
                hex: initColor
            };
            colors = [
                color,
                ...(0, $687ef8d4c4e21a50$export$5d93f993ca7fe88c)
            ];
        }
        this.state = {
            text: text,
            startTime: $d0c67fa32852ab0b$var$getTime($d0c67fa32852ab0b$var$formatDate(startTime)),
            endTime: $d0c67fa32852ab0b$var$getTime($d0c67fa32852ab0b$var$formatDate(endTime)),
            tags: tags,
            type: type,
            color: color,
            colors: colors,
            startTimeInput: $d0c67fa32852ab0b$var$formatDate(startTime),
            startTimeError: null,
            endTimeInput: $d0c67fa32852ab0b$var$formatDate(endTime),
            endTimeError: null,
            textError: null,
            tagsError: null
        };
    }
    componentWillUnmount() {
        this.debouncer.cancelAll();
    }
    render() {
        const { onDelete: onDelete } = this.props;
        const { type: type, text: text, startTimeInput: startTimeInput, endTimeInput: endTimeInput, textError: textError, startTimeError: startTimeError, endTimeError: endTimeError, tagsError: tagsError, color: color, colors: colors } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "annotation-editor-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-6",
            "data-test": "name-group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", null, "Name", textError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "error"
        }, textError)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            type: "text",
            className: "form-control input-sm",
            value: text,
            onChange: this.handleTextChange
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-6",
            "data-test": "type-group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", null, "Type"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039), {
            shape: (0, $918c9f03a35fe03f$export$ce765fb8bb08a599).StretchToFit
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039).Button, {
            id: "annotation-editor-type--point",
            value: "point",
            active: type === 'point',
            titleText: "Assign a single timestamp to the Annotation",
            onClick: this.handleTypeChange
        }, "Point"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039).Button, {
            id: "annotation-editor-type--window",
            value: "window",
            active: type === 'window',
            titleText: "Assign a timestamp window to the Annotation",
            onClick: this.handleTypeChange
        }, "Window")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: `form-group col-xs-${type === 'point' ? 12 : 6}`,
            "data-test": "time-group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", null, type === 'point' ? 'Time' : 'Start', startTimeError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "error"
        }, startTimeError)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            type: "text",
            className: "form-control input-sm",
            value: startTimeInput,
            onChange: this.handleStartTimeInputChange,
            onBlur: this.handleStartTimeInputBlur
        })), type === 'window' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", null, "End", endTimeError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "error"
        }, endTimeError)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            type: "text",
            className: "form-control input-sm",
            value: endTimeInput,
            onChange: this.handleEndTimeInputChange,
            onBlur: this.handleEndTimeInputBlur
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12",
            "data-test": "tags-group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", null, "Color"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $5e39ab524a8799f2$export$2e2bcd8739ae039), {
            colors: colors,
            selected: color,
            onChoose: this.handleChangeColor,
            stretchToFit: true
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12",
            "data-test": "tags-group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", null, "Annotation Tags", ' ', tagsError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "error"
        }, tagsError)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "annotation-tag-editor"
        }, this.tagEditorListItems, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-sm btn-primary annotation-tag-editor--add",
            onClick: this.handleAddTag
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon plus"
        }), " Add Tag")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $8008717819fc7a5f$export$2e2bcd8739ae039), {
            text: 'Delete',
            confirmAction: onDelete,
            type: "btn-danger",
            customClass: 'annotation-editor-body--delete',
            size: "btn-xs"
        })));
    }
    get tagEditorListItems() {
        const { tags: tags } = this.state;
        return tags.map(({ id: id, tagKey: tagKey, tagValue: tagValue, shouldAutoFocus: shouldAutoFocus })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $6026f118057a51aa$export$2e2bcd8739ae039), {
                key: id,
                tagKey: tagKey,
                tagValue: tagValue,
                onUpdate: this.handleUpdateTag(id),
                onDelete: this.handleDeleteTag(id),
                onKeyDown: this.onKeyDown,
                shouldAutoFocus: shouldAutoFocus
            }));
    }
}
var $d0c67fa32852ab0b$export$2e2bcd8739ae039 = $d0c67fa32852ab0b$var$AnnotationEditorForm;



const $5c631df5c245897e$var$OVERLAY_WIDTH = 600;
class $5c631df5c245897e$var$AnnotationEditor extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleSetDraftAnnotation = (draftAnnotation)=>{
            this.setState({
                draftAnnotation: draftAnnotation
            });
        }, this.handleSave = async ()=>{
            if (!this.canSave) return;
            const { onSave: onSave } = this.props;
            const { draftAnnotation: draftAnnotation } = this.state;
            this.setState({
                savingStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading
            });
            await onSave(draftAnnotation);
        };
        this.state = {
            draftAnnotation: null,
            savingStatus: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).NotStarted
        };
    }
    render() {
        const { annotation: annotation, onDelete: onDelete, onCancel: onCancel } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "annotation-editor"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1868bdace58643df$export$2e2bcd8739ae039), {
            maxWidth: $5c631df5c245897e$var$OVERLAY_WIDTH
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1372e03f76900c5b$export$2e2bcd8739ae039), {
            title: 'Edit Annotation'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "annotation-editor--controls"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-sm btn-default",
            onClick: onCancel
        }, "Cancel"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-sm btn-success",
            disabled: !this.canSave || this.isSaving,
            onClick: this.handleSave,
            "data-test": "save-button"
        }, this.isSaving ? 'Saving...' : 'Save'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1e8c886c7914a527$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $d0c67fa32852ab0b$export$2e2bcd8739ae039), {
            key: annotation.id,
            annotation: annotation,
            onSetDraftAnnotation: this.handleSetDraftAnnotation,
            onDelete: onDelete
        }))));
    }
    get canSave() {
        return !!this.state.draftAnnotation;
    }
    get isSaving() {
        return this.state.savingStatus === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading;
    }
}
var $5c631df5c245897e$export$2e2bcd8739ae039 = $5c631df5c245897e$var$AnnotationEditor;





class $16412b5cdc40fee9$var$AnnotationEditorContainer extends (0, $NdCUR.PureComponent) {
    render() {
        const { editingAnnotation: editingAnnotation } = this.props;
        if (!editingAnnotation) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "overlay-tech show"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "overlay--dialog",
            "data-test": "overlay-children"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $5c631df5c245897e$export$2e2bcd8739ae039), {
            annotation: editingAnnotation,
            onCancel: this.handleCancelEdits,
            onSave: this.handleSave,
            onDelete: this.handleDelete
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "overlay--mask"
        }));
    }
    constructor(...args){
        super(...args), this.handleCancelEdits = ()=>{
            const { onSetEditingAnnotation: onSetEditingAnnotation } = this.props;
            onSetEditingAnnotation(null);
        }, this.handleDelete = async ()=>{
            const { editingAnnotation: editingAnnotation, onDeleteAnnotation: onDeleteAnnotation } = this.props;
            await onDeleteAnnotation(editingAnnotation);
        }, this.handleSave = async (a)=>{
            const { onSaveAnnotation: onSaveAnnotation, onSetEditingAnnotation: onSetEditingAnnotation, onNotify: onNotify, setTagKeys: setTagKeys } = this.props;
            try {
                await onSaveAnnotation(a);
                setTagKeys(null);
                onSetEditingAnnotation(null);
            } catch (e) {
                let errorMessage = 'unknown error';
                if (e.status && e.status === 404) errorMessage = 'annotation not found';
                else if (e.status && e.status === 422) errorMessage = 'could not process annotation';
                onNotify((0, $ec1f42de4faacc37$export$df80ffa52e9aac30)('error', `Could not save annotation: ${errorMessage}`));
            }
        };
    }
}
const $16412b5cdc40fee9$var$mstp = ({ annotations: { annotations: annotations, editingAnnotation: editingAnnotation } })=>{
    return {
        editingAnnotation: annotations[editingAnnotation]
    };
};
const $16412b5cdc40fee9$var$mdtp = {
    onSaveAnnotation: (0, $fa0d0f2e90b47171$export$c5f1221ab1e036d0),
    onSetEditingAnnotation: (0, $fa0d0f2e90b47171$export$25e35a3d0d8da4da),
    onDeleteAnnotation: (0, $fa0d0f2e90b47171$export$ea09476dbc4c7660),
    setTagKeys: (0, $fa0d0f2e90b47171$export$907079e2e957715f),
    onNotify: (0, $205d139de2918454$export$5e14cdade93d6f7b)
};
var $16412b5cdc40fee9$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($16412b5cdc40fee9$var$mstp, $16412b5cdc40fee9$var$mdtp)($16412b5cdc40fee9$var$AnnotationEditorContainer);
























class $2fd3a058811d2884$var$DashboardPage extends (0, $NdCUR.Component) {
    constructor(props){
        super(props), this.fetchAnnotations = async ()=>{
            const { source: source, dashboardID: dashboardID, onGetAnnotationsAsync: onGetAnnotationsAsync, notify: notify } = this.props;
            try {
                await onGetAnnotationsAsync(source.links.annotations, dashboardID);
            } catch  {
                notify((0, $ec1f42de4faacc37$export$1fd9c65b41098040)('Error fetching annotations'));
            }
        }, this.handleWindowResize = ()=>{
            this.setState({
                windowHeight: window.innerHeight
            });
        }, this.getDashboard = ()=>{
            const { dashboardID: dashboardID, source: source, sources: sources, getDashboardWithTemplatesAsync: getDashboardWithTemplatesAsync } = this.props;
            getDashboardWithTemplatesAsync(dashboardID, source, sources);
            this.updateActiveDashboard();
        }, this.inView = (cell)=>{
            const { scrollTop: scrollTop, windowHeight: windowHeight } = this.state;
            const bufferValue = 600;
            const cellTop = cell.y * (0, $e10a8602f56394e3$export$13d5843c9841853c);
            const cellBottom = (cell.y + cell.h) * (0, $e10a8602f56394e3$export$13d5843c9841853c);
            const bufferedWindowBottom = windowHeight + scrollTop + bufferValue;
            const bufferedWindowTop = scrollTop - bufferValue;
            const topInView = cellTop < bufferedWindowBottom;
            const bottomInView = cellBottom > bufferedWindowTop;
            return topInView && bottomInView;
        }, this.handleSaveEditedCell = async (newCell)=>{
            const { dashboard: dashboard } = this.props;
            if (this.isExistingCell(newCell)) await this.props.updateDashboardCell(dashboard, newCell);
            else this.props.addDashboardCellAsync(dashboard, newCell);
            this.handleHideCellEditorOverlay();
        }, this.handleShowCellEditorOverlay = (cell)=>{
            this.setState({
                selectedCell: cell,
                showCellEditorOverlay: true
            });
        }, this.handleHideCellEditorOverlay = ()=>{
            const { handleClearCEO: handleClearCEO } = this.props;
            const WAIT_FOR_ANIMATION = 400;
            this.setState({
                showCellEditorOverlay: false
            });
            window.setTimeout(()=>{
                handleClearCEO();
            }, WAIT_FOR_ANIMATION);
        }, this.handleChooseAutoRefresh = (autoRefreshOption)=>{
            const { dashboardID: dashboardID, setDashRefresh: setDashRefresh, updateQueryParams: updateQueryParams } = this.props;
            const { label: label, milliseconds: milliseconds } = autoRefreshOption;
            updateQueryParams({
                refresh: label
            });
            setDashRefresh(dashboardID, milliseconds);
        }, this.handleChooseTimeRange = (timeRange)=>{
            const { dashboardID: dashboardID, setDashTimeV1: setDashTimeV1, updateTimeRangeQueryParams: updateTimeRangeQueryParams } = this.props;
            updateTimeRangeQueryParams({
                lower: timeRange.lower,
                upper: timeRange.upper
            });
            setDashTimeV1(dashboardID, {
                ...timeRange,
                format: (0, $6a7b0ae94f8ec28f$export$ecd1ea28cd2a4eac)
            });
            this.fetchAnnotations();
        }, this.handleUpdatePosition = (cells)=>{
            const { dashboard: dashboard } = this.props;
            const newDashboard = {
                ...dashboard,
                cells: cells
            };
            this.props.updateDashboard(newDashboard);
            this.props.putDashboard(newDashboard);
        }, this.handleAddCell = ()=>{
            const { dashboard: dashboard } = this.props;
            const emptyCell = (0, $0ece195804443aff$export$47308518c82e405)(dashboard);
            this.setState({
                selectedCell: emptyCell,
                showCellEditorOverlay: true
            });
        }, this.handleCloneCell = (cell)=>{
            const { dashboard: dashboard } = this.props;
            this.props.cloneDashboardCellAsync(dashboard, cell);
        }, this.handleRenameDashboard = async (name)=>{
            const { dashboard: dashboard } = this.props;
            const renamedDashboard = {
                ...dashboard,
                name: name
            };
            this.props.updateDashboard(renamedDashboard);
            await this.props.putDashboard(renamedDashboard);
            this.updateActiveDashboard();
        }, this.handleDeleteDashboardCell = (cell)=>{
            const { dashboard: dashboard } = this.props;
            this.props.deleteDashboardCellAsync(dashboard, cell);
        }, this.handlePickTemplate = (template, value)=>{
            const { dashboard: dashboard, source: source, sources: sources, templateVariableLocalSelected: templateVariableLocalSelected, rehydrateTemplatesAsync: rehydrateTemplatesAsync } = this.props;
            templateVariableLocalSelected(dashboard.id, template.id, value);
            rehydrateTemplatesAsync(dashboard.id, source, sources);
        }, this.handleSaveTemplateVariables = async (templates)=>{
            const { dashboard: dashboard, updateTemplateQueryParams: updateTemplateQueryParams } = this.props;
            try {
                await this.props.putDashboard({
                    ...dashboard,
                    templates: templates
                });
                updateTemplateQueryParams(dashboard.id);
            } catch (error) {
                console.error(error);
            }
        }, this.handleZoomedTimeRange = (zoomedTimeRange)=>{
            const { setZoomedTimeRange: setZoomedTimeRange, updateQueryParams: updateQueryParams } = this.props;
            setZoomedTimeRange(zoomedTimeRange);
            updateQueryParams({
                zoomedLower: zoomedTimeRange.lower,
                zoomedUpper: zoomedTimeRange.upper
            });
        }, this.setScrollTop = (e)=>{
            const target = e.target;
            this.setState({
                scrollTop: target.scrollTop
            });
        }, this.getDashboardLinks = async ()=>{
            const { source: source, dashboard: activeDashboard } = this.props;
            try {
                const dashboardLinks = await (0, $2adafb01fdaabc72$export$646488bd511db359)(source, {
                    activeDashboard: activeDashboard
                });
                this.setState({
                    dashboardLinks: dashboardLinks
                });
            } catch (error) {
                console.error(error);
            }
        };
        this.state = {
            scrollTop: 0,
            selectedCell: null,
            windowHeight: window.innerHeight,
            dashboardLinks: (0, $366e79a20fc561c5$export$b430c2bd97f9d15b),
            showCellEditorOverlay: false
        };
    }
    componentDidMount() {
        const { refreshRate: refreshRate, updateQueryParams: updateQueryParams } = this.props;
        const compareOptionToRefreshRate = (r)=>r.milliseconds === refreshRate;
        const { location: { search: search = '' } = {} } = window;
        const urlSelectedRefresh = search.match(/refresh=([^&#]*)/i);
        let pollRefreshRate = refreshRate;
        let localStorageRefresh;
        const autoRefreshOptions = (0, $7be8d2ddc7f80e0c$export$f646e68351a87786)();
        if (urlSelectedRefresh) {
            const option = autoRefreshOptions.find((r)=>r.label.toLowerCase() === urlSelectedRefresh[1].toLowerCase());
            if (option) {
                this.handleChooseAutoRefresh(option);
                pollRefreshRate = option.milliseconds;
            } else localStorageRefresh = autoRefreshOptions.find(compareOptionToRefreshRate);
        } else localStorageRefresh = autoRefreshOptions.find(compareOptionToRefreshRate);
        if (localStorageRefresh) updateQueryParams({
            refresh: localStorageRefresh.label
        });
        (0, $a926ccb172fe03ce$export$a3ea0b2d0765f52e).poll(pollRefreshRate);
        (0, $a926ccb172fe03ce$export$a3ea0b2d0765f52e).subscribe(this.fetchAnnotations);
        window.addEventListener('resize', this.handleWindowResize, true);
        this.getDashboard();
        this.fetchAnnotations();
        this.getDashboardLinks();
    }
    componentDidUpdate(prevProps) {
        const { dashboard: dashboard, refreshRate: refreshRate, updateQueryParams: updateQueryParams, annotationsDisplaySetting: annotationsDisplaySetting, timeRange: timeRange } = this.props;
        const prevPath = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(prevProps.location, 'pathname', null);
        const thisPath = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(this.props.location, 'pathname', null);
        const localStorageRefresh = (0, $7be8d2ddc7f80e0c$export$f646e68351a87786)().find((r)=>r.milliseconds === refreshRate);
        const templates = this.parseTempVar(dashboard);
        const prevTemplates = this.parseTempVar(prevProps.dashboard);
        const intersection = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).intersection(templates, prevTemplates);
        const isTemplateDeleted = intersection.length !== prevTemplates.length;
        if (prevPath && thisPath && prevPath !== thisPath || isTemplateDeleted) {
            this.getDashboard();
            if (localStorageRefresh) updateQueryParams({
                refresh: localStorageRefresh.label
            });
        }
        if (refreshRate !== prevProps.refreshRate) (0, $a926ccb172fe03ce$export$a3ea0b2d0765f52e).poll(refreshRate);
        if (annotationsDisplaySetting !== (0, $0714a56b2816a4c7$export$e62cccb760c33405).HideAnnotations && (annotationsDisplaySetting !== prevProps.annotationsDisplaySetting || !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEqual(timeRange, prevProps.timeRange))) this.fetchAnnotations();
    }
    componentWillUnmount() {
        (0, $a926ccb172fe03ce$export$a3ea0b2d0765f52e).stopPolling();
        (0, $a926ccb172fe03ce$export$a3ea0b2d0765f52e).unsubscribe(this.fetchAnnotations);
        window.removeEventListener('resize', this.handleWindowResize, true);
        this.props.handleDismissEditingAnnotation();
    }
    render() {
        const { notify: notify, fluxLinks: fluxLinks, isUsingAuth: isUsingAuth, meRole: meRole, source: source, sources: sources, timeRange: timeRange, timeZone: timeZone, setTimeZone: setTimeZone, zoomedTimeRange: zoomedTimeRange, dashboard: dashboard, dashboardID: dashboardID, refreshRate: refreshRate, manualRefresh: manualRefresh, onManualRefresh: onManualRefresh, cellQueryStatuses: cellQueryStatuses, inPresentationMode: inPresentationMode, showTemplateVariableControlBar: showTemplateVariableControlBar, showAnnotationControls: showAnnotationControls, handleClickPresentationButton: handleClickPresentationButton, toggleTemplateVariableControlBar: toggleTemplateVariableControlBar, toggleShowAnnotationControls: toggleShowAnnotationControls, me: me, logoutLink: logoutLink, links: links } = this.props;
        const { dashboardTime: dashboardTime, upperDashboardTime: upperDashboardTime } = (0, $49025b9a9ba48763$export$6ddeec537125a398)(timeRange, zoomedTimeRange);
        let templatesIncludingDashTime;
        if (dashboard) templatesIncludingDashTime = [
            ...dashboard.templates,
            dashboardTime,
            upperDashboardTime,
            (0, $e10a8602f56394e3$export$3174cdbf0a0cbc84)
        ];
        else templatesIncludingDashTime = [];
        const { dashboardLinks: dashboardLinks, selectedCell: selectedCell, showCellEditorOverlay: showCellEditorOverlay } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $827fcd4cb090ac0e$export$2e2bcd8739ae039), {
            visible: showCellEditorOverlay
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c5ea6fbc55d91fd3$export$2e2bcd8739ae039), {
            source: source,
            sources: sources,
            notify: notify,
            fluxLinks: fluxLinks,
            cell: selectedCell,
            dashboardID: dashboardID,
            queryStatuses: cellQueryStatuses,
            onSave: this.handleSaveEditedCell,
            onCancel: this.handleHideCellEditorOverlay,
            dashboardTemplates: (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(dashboard, 'templates', []),
            editQueryStatus: this.props.editCellQueryStatus,
            dashboardTimeRange: timeRange,
            dashboardRefresh: refreshRate
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $2af4af39d360d566$export$2e2bcd8739ae039), {
            dashboard: dashboard,
            timeRange: timeRange,
            timeZone: timeZone,
            onSetTimeZone: setTimeZone,
            autoRefresh: refreshRate,
            isHidden: inPresentationMode,
            onAddCell: this.handleAddCell,
            onManualRefresh: onManualRefresh,
            zoomedTimeRange: zoomedTimeRange,
            onRenameDashboard: this.handleRenameDashboard,
            dashboardLinks: dashboardLinks,
            activeDashboard: dashboard ? dashboard.name : '',
            showAnnotationControls: showAnnotationControls,
            showTempVarControls: showTemplateVariableControlBar,
            handleChooseAutoRefresh: this.handleChooseAutoRefresh,
            handleChooseTimeRange: this.handleChooseTimeRange,
            onToggleShowTempVarControls: toggleTemplateVariableControlBar,
            onToggleShowAnnotationControls: toggleShowAnnotationControls,
            handleClickPresentationButton: handleClickPresentationButton
        }, isUsingAuth && me.role === (0, $a7910b1002260d34$export$62bbf68aca1809f0) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21e072852e81bd41$export$2e2bcd8739ae039), {
            logoutLink: logoutLink,
            links: links,
            me: me,
            header: true
        }) : undefined), !inPresentationMode && showTemplateVariableControlBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $2194950b8f69e45b$export$2e2bcd8739ae039), {
            templates: dashboard && dashboard.templates,
            meRole: meRole,
            isUsingAuth: isUsingAuth,
            onSaveTemplates: this.handleSaveTemplateVariables,
            onPickTemplate: this.handlePickTemplate,
            source: source
        }), !inPresentationMode && showAnnotationControls && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $6f7b760e95990040$export$2e2bcd8739ae039), {
            dashboardID: dashboardID,
            source: source
        }), this.showDashboard ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $e5911fcc26315b2c$export$2e2bcd8739ae039), {
            source: source,
            sources: sources,
            setScrollTop: this.setScrollTop,
            inView: this.inView,
            dashboard: dashboard,
            timeRange: timeRange,
            manualRefresh: manualRefresh,
            onZoom: this.handleZoomedTimeRange,
            inPresentationMode: inPresentationMode,
            onPositionChange: this.handleUpdatePosition,
            onDeleteCell: this.handleDeleteDashboardCell,
            onCloneCell: this.handleCloneCell,
            templatesIncludingDashTime: templatesIncludingDashTime,
            onSummonOverlayTechnologies: this.handleShowCellEditorOverlay
        }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $16412b5cdc40fee9$export$2e2bcd8739ae039), null));
    }
    parseTempVar(dashboard) {
        return (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(dashboard, 'templates', []).map((t)=>t.tempVar);
    }
    get showDashboard() {
        const { dashboard: dashboard } = this.props;
        return !!dashboard;
    }
    updateActiveDashboard() {
        this.setState((prevState, props)=>({
                dashboardLinks: (0, $a7c7af802fab926a$export$9d5bee8a7028c508)(prevState.dashboardLinks, props.dashboard)
            }));
    }
    isExistingCell(cell) {
        return cell.i !== undefined;
    }
}
const $2fd3a058811d2884$var$mstp = (state, { params: { dashboardID: dashboardID } })=>{
    const { app: { ephemeral: { inPresentationMode: inPresentationMode }, persisted: { autoRefresh: autoRefresh, showTemplateVariableControlBar: showTemplateVariableControlBar, showAnnotationControls: showAnnotationControls, annotationsDisplaySetting: annotationsDisplaySetting, timeZone: timeZone } }, links: links, dashboardUI: { dashboards: dashboards, cellQueryStatuses: cellQueryStatuses, zoomedTimeRange: zoomedTimeRange }, sources: sources, auth: { me: me, isUsingAuth: isUsingAuth, logoutLink: logoutLink }, cellEditorOverlay: { timeRange: editorTimeRange } } = state;
    const meRole = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(me, 'role', null);
    const timeRange = (0, $d86454733477636e$export$fe73f2cc6771a40f)(state, dashboardID);
    const refreshRate = (0, $d86454733477636e$export$db55aefb333a1ced)(state, dashboardID);
    const dashboard = dashboards.find((d)=>d.id === dashboardID);
    return {
        sources: sources,
        meRole: meRole,
        timeZone: timeZone,
        dashboard: dashboard,
        fluxLinks: links.flux,
        dashboardID: dashboardID,
        timeRange: timeRange,
        refreshRate: refreshRate,
        zoomedTimeRange: zoomedTimeRange,
        autoRefresh: autoRefresh,
        isUsingAuth: isUsingAuth,
        cellQueryStatuses: cellQueryStatuses,
        inPresentationMode: inPresentationMode,
        editorTimeRange: editorTimeRange,
        showTemplateVariableControlBar: showTemplateVariableControlBar,
        showAnnotationControls: showAnnotationControls,
        annotationsDisplaySetting: annotationsDisplaySetting,
        logoutLink: logoutLink,
        me: me,
        links: links
    };
};
const $2fd3a058811d2884$var$mdtp = {
    setDashTimeV1: $9859d1d8ae3f2524$export$25a740f44c90929f,
    setDashRefresh: $9859d1d8ae3f2524$export$6ad1ca08b6b7b636,
    setZoomedTimeRange: $9859d1d8ae3f2524$export$4c0bf62335ec7f62,
    updateDashboard: $9859d1d8ae3f2524$export$8a2c60458ca4e242,
    putDashboard: $9859d1d8ae3f2524$export$29b6f6999ebdbd60,
    putDashboardByID: $9859d1d8ae3f2524$export$59693e3bcff1cf23,
    getDashboardsAsync: $9859d1d8ae3f2524$export$e5b1f1e10b3d70a7,
    addDashboardCellAsync: $9859d1d8ae3f2524$export$17ae542af88fbb65,
    editCellQueryStatus: $9859d1d8ae3f2524$export$40f5f2075e1b32d4,
    updateDashboardCell: $9859d1d8ae3f2524$export$18f05ab8a5b491fd,
    cloneDashboardCellAsync: $9859d1d8ae3f2524$export$296fabffdb579a4f,
    deleteDashboardCellAsync: $9859d1d8ae3f2524$export$1874906bbeb2f659,
    templateVariableLocalSelected: $9859d1d8ae3f2524$export$c637c70fae500106,
    toggleTemplateVariableControlBar: $cac020f89fc6c82e$export$9b87e5c5d16de9de,
    toggleShowAnnotationControls: $cac020f89fc6c82e$export$538f3bcfcce55171,
    getDashboardWithTemplatesAsync: $9859d1d8ae3f2524$export$ec042ffaea15d906,
    rehydrateTemplatesAsync: $9859d1d8ae3f2524$export$bb40b898163aec67,
    updateTemplateQueryParams: $9859d1d8ae3f2524$export$61a23c00684e4186,
    updateQueryParams: $9859d1d8ae3f2524$export$92377f461a797888,
    updateTimeRangeQueryParams: $9859d1d8ae3f2524$export$8912edd43a848d84,
    handleClickPresentationButton: $cac020f89fc6c82e$export$84ea1cdd7d049965,
    errorThrown: $eb59f3357c899aaf$export$1550334dc0519d45,
    notify: $205d139de2918454$export$5e14cdade93d6f7b,
    handleClearCEO: $0a1fef76cb2a2e9d$export$daf9b15f740d8268,
    onGetAnnotationsAsync: (0, $fa0d0f2e90b47171$export$fafa59bd2ee01f48),
    handleDismissEditingAnnotation: (0, $fa0d0f2e90b47171$export$29606ee39da5bcdf),
    setTimeZone: $cac020f89fc6c82e$export$93c56f26d2728d8d
};
var $2fd3a058811d2884$export$2e2bcd8739ae039 = (0, $c8cd79e362cba2a4$export$a520fb22fccea800)((0, $dffbdf89c590a961$export$2e2bcd8739ae039)((0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($2fd3a058811d2884$var$mstp, $2fd3a058811d2884$var$mdtp)((0, $bfd6e1b2bb3e3a9d$export$2e2bcd8739ae039)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($2fd3a058811d2884$var$DashboardPage)))));




// Libraries

var $NdCUR = parcelRequire("NdCUR");


var $hBdgJ = parcelRequire("hBdgJ");




var $hBdgJ = parcelRequire("hBdgJ");

var $NdCUR = parcelRequire("NdCUR");




var $NdCUR = parcelRequire("NdCUR");

class $686e4da7a12de4e8$export$2e2bcd8739ae039 extends (0, $NdCUR.PureComponent) {
    render() {
        const { onChangeLiveUpdatingStatus: onChangeLiveUpdatingStatus } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
            customClass: "logs-viewer--mode-toggle",
            shape: (0, $918c9f03a35fe03f$export$ce765fb8bb08a599).Square,
            color: this.color,
            icon: this.icon,
            onClick: onChangeLiveUpdatingStatus
        });
    }
    get icon() {
        const { liveUpdating: liveUpdating } = this.props;
        if (liveUpdating) return (0, $918c9f03a35fe03f$export$62c9c0cf752cde38).Play;
        return (0, $918c9f03a35fe03f$export$62c9c0cf752cde38).Pause;
    }
    get color() {
        const { liveUpdating: liveUpdating } = this.props;
        if (liveUpdating) return (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Primary;
        return (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Default;
    }
}


class $1c58573b02c4cba3$var$LogsHeader extends (0, $NdCUR.PureComponent) {
    render() {
        const { liveUpdating: liveUpdating, onChangeLiveUpdatingStatus: onChangeLiveUpdatingStatus, onShowOptionsOverlay: onShowOptionsOverlay } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header, {
            fullWidth: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header.Left, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $686e4da7a12de4e8$export$2e2bcd8739ae039), {
            onChangeLiveUpdatingStatus: onChangeLiveUpdatingStatus,
            liveUpdating: liveUpdating
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Title, {
            title: "Log Viewer"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header.Right, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ca4f14339173643c$export$2e2bcd8739ae039), {
            className: "dropdown-300",
            items: this.sourceDropDownItems,
            selected: this.selectedSource,
            onChoose: this.handleChooseSource
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ca4f14339173643c$export$2e2bcd8739ae039), {
            className: "dropdown-180",
            iconName: "disks",
            items: this.namespaceDropDownItems,
            selected: this.selectedNamespace,
            onChoose: this.handleChooseNamespace
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $091cfcd49e339acd$export$2e2bcd8739ae039), {
            requiredRole: (0, $a7910b1002260d34$export$f715f7e27dea2abf)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-sm btn-square btn-default",
            onClick: onShowOptionsOverlay
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon cog-thick"
        })))));
    }
    get selectedSource() {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEmpty(this.sourceDropDownItems)) return '';
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(this.props, 'currentSource.id', '');
        const currentItem = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).find(this.sourceDropDownItems, (item)=>{
            return item.id === id;
        });
        if (currentItem) return currentItem.text;
        return '';
    }
    get selectedNamespace() {
        const { currentNamespace: currentNamespace } = this.props;
        if (!currentNamespace) return '';
        return `${currentNamespace.database}.${currentNamespace.retentionPolicy}`;
    }
    get namespaceDropDownItems() {
        const { currentNamespaces: currentNamespaces } = this.props;
        return currentNamespaces.map((namespace)=>{
            return {
                text: `${namespace.database}.${namespace.retentionPolicy}`,
                ...namespace
            };
        });
    }
    get sourceDropDownItems() {
        const { availableSources: availableSources } = this.props;
        return availableSources.map((source)=>{
            return {
                text: `${source.name} @ ${source.url}`,
                id: source.id
            };
        });
    }
    constructor(...args){
        super(...args), this.handleChooseSource = (item)=>{
            this.props.onChooseSource(item.id);
        }, this.handleChooseNamespace = (namespace)=>{
            this.props.onChooseNamespace(namespace);
        };
    }
}
var $1c58573b02c4cba3$export$2e2bcd8739ae039 = $1c58573b02c4cba3$var$LogsHeader;



var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");
const $7a8da38967538e73$var$e10 = Math.sqrt(50), $7a8da38967538e73$var$e5 = Math.sqrt(10), $7a8da38967538e73$var$e2 = Math.sqrt(2);
function $7a8da38967538e73$var$tickSpec(start, stop, count) {
    const step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log10(step)), error = step / Math.pow(10, power), factor = error >= $7a8da38967538e73$var$e10 ? 10 : error >= $7a8da38967538e73$var$e5 ? 5 : error >= $7a8da38967538e73$var$e2 ? 2 : 1;
    let i1, i2, inc;
    if (power < 0) {
        inc = Math.pow(10, -power) / factor;
        i1 = Math.round(start * inc);
        i2 = Math.round(stop * inc);
        if (i1 / inc < start) ++i1;
        if (i2 / inc > stop) --i2;
        inc = -inc;
    } else {
        inc = Math.pow(10, power) * factor;
        i1 = Math.round(start / inc);
        i2 = Math.round(stop / inc);
        if (i1 * inc < start) ++i1;
        if (i2 * inc > stop) --i2;
    }
    if (i2 < i1 && 0.5 <= count && count < 2) return $7a8da38967538e73$var$tickSpec(start, stop, count * 2);
    return [
        i1,
        i2,
        inc
    ];
}
function $7a8da38967538e73$export$2e2bcd8739ae039(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    if (!(count > 0)) return [];
    if (start === stop) return [
        start
    ];
    const reverse = stop < start, [i1, i2, inc] = reverse ? $7a8da38967538e73$var$tickSpec(stop, start, count) : $7a8da38967538e73$var$tickSpec(start, stop, count);
    if (!(i2 >= i1)) return [];
    const n = i2 - i1 + 1, ticks = new Array(n);
    if (reverse) {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) * inc;
    } else {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) * inc;
    }
    return ticks;
}
function $7a8da38967538e73$export$bc64d00cc98e7e95(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    return $7a8da38967538e73$var$tickSpec(start, stop, count)[2];
}
function $7a8da38967538e73$export$81087d9b915d4ede(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    const reverse = stop < start, inc = reverse ? $7a8da38967538e73$export$bc64d00cc98e7e95(stop, start, count) : $7a8da38967538e73$export$bc64d00cc98e7e95(start, stop, count);
    return (reverse ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
}


function $124ee9e94239f94d$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}



function $7d326c509d660025$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}


function $c4ba7f6ca40ba921$export$2e2bcd8739ae039(f) {
    let compare1, compare2, delta;
    // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = (0, $124ee9e94239f94d$export$2e2bcd8739ae039);
        compare2 = (d, x)=>(0, $124ee9e94239f94d$export$2e2bcd8739ae039)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === (0, $124ee9e94239f94d$export$2e2bcd8739ae039) || f === (0, $7d326c509d660025$export$2e2bcd8739ae039) ? f : $c4ba7f6ca40ba921$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $c4ba7f6ca40ba921$var$zero() {
    return 0;
}


function $b80514881a3bfb3b$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}
function* $b80514881a3bfb3b$export$1f6c9cc012ebacae(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}


const $79d8d5aac932c361$var$ascendingBisect = (0, $c4ba7f6ca40ba921$export$2e2bcd8739ae039)((0, $124ee9e94239f94d$export$2e2bcd8739ae039));
const $79d8d5aac932c361$export$4d945ad3ad5751b0 = $79d8d5aac932c361$var$ascendingBisect.right;
const $79d8d5aac932c361$export$df7d25c84ebd12a5 = $79d8d5aac932c361$var$ascendingBisect.left;
const $79d8d5aac932c361$export$c1cb828b1117c77b = (0, $c4ba7f6ca40ba921$export$2e2bcd8739ae039)((0, $b80514881a3bfb3b$export$2e2bcd8739ae039)).center;
var $79d8d5aac932c361$export$2e2bcd8739ae039 = $79d8d5aac932c361$export$4d945ad3ad5751b0;



var $dPK2y = parcelRequire("dPK2y");

var $dPK2y = parcelRequire("dPK2y");
function $6b17a98b8fdbb34d$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $6b17a98b8fdbb34d$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $6b17a98b8fdbb34d$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}



function $c16465d3b96fd3df$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $6b17a98b8fdbb34d$export$4e41033bfeec1a4c)((t - i / n) * n, v0, v1, v2, v3);
    };
}


var $ab61e0fb7ce399f8$export$2e2bcd8739ae039 = (x)=>()=>x;


function $97be1df995e5a117$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $97be1df995e5a117$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $97be1df995e5a117$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $97be1df995e5a117$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $ab61e0fb7ce399f8$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}
function $97be1df995e5a117$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $97be1df995e5a117$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $97be1df995e5a117$var$exponential(a, b, y) : (0, $ab61e0fb7ce399f8$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
    };
}
function $97be1df995e5a117$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $97be1df995e5a117$var$linear(a, d) : (0, $ab61e0fb7ce399f8$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}


var $a5cbfaabd524af5c$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $97be1df995e5a117$export$a7ebe8cc6aaf8d37)(y);
    function rgb(start, end) {
        var r = color((start = (0, $dPK2y.rgb)(start)).r, (end = (0, $dPK2y.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $97be1df995e5a117$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $a5cbfaabd524af5c$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $dPK2y.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $a5cbfaabd524af5c$export$2c0e28f2e2852d3f = $a5cbfaabd524af5c$var$rgbSpline((0, $6b17a98b8fdbb34d$export$2e2bcd8739ae039));
var $a5cbfaabd524af5c$export$53d5214f625ccd4c = $a5cbfaabd524af5c$var$rgbSpline((0, $c16465d3b96fd3df$export$2e2bcd8739ae039));



function $a0f07588f813c5d7$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $a0f07588f813c5d7$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}


function $59e240aa80a63b3e$export$2e2bcd8739ae039(a, b) {
    return ((0, $a0f07588f813c5d7$export$5cd576d1827d40c8)(b) ? (0, $a0f07588f813c5d7$export$2e2bcd8739ae039) : $59e240aa80a63b3e$export$15d09067c6a5ee49)(a, b);
}
function $59e240aa80a63b3e$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $1f216e2faccc8163$export$2e2bcd8739ae039)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}


function $d8389bdf6615fbb6$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}


function $eb2bb06aba5a5f63$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}



function $7df4a72af7d44e92$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $1f216e2faccc8163$export$2e2bcd8739ae039)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}



var $bf7e2b54f0a06c8e$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $bf7e2b54f0a06c8e$var$reB = new RegExp($bf7e2b54f0a06c8e$var$reA.source, "g");
function $bf7e2b54f0a06c8e$var$zero(b) {
    return function() {
        return b;
    };
}
function $bf7e2b54f0a06c8e$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $bf7e2b54f0a06c8e$export$2e2bcd8739ae039(a, b) {
    var bi = $bf7e2b54f0a06c8e$var$reA.lastIndex = $bf7e2b54f0a06c8e$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $bf7e2b54f0a06c8e$var$reA.exec(a)) && (bm = $bf7e2b54f0a06c8e$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $eb2bb06aba5a5f63$export$2e2bcd8739ae039)(am, bm)
            });
        }
        bi = $bf7e2b54f0a06c8e$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $bf7e2b54f0a06c8e$var$one(q[0].x) : $bf7e2b54f0a06c8e$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}




function $1f216e2faccc8163$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $ab61e0fb7ce399f8$export$2e2bcd8739ae039)(b) : (t === "number" ? (0, $eb2bb06aba5a5f63$export$2e2bcd8739ae039) : t === "string" ? (c = (0, $dPK2y.default)(b)) ? (b = c, $a5cbfaabd524af5c$export$2e2bcd8739ae039) : (0, $bf7e2b54f0a06c8e$export$2e2bcd8739ae039) : b instanceof (0, $dPK2y.default) ? (0, $a5cbfaabd524af5c$export$2e2bcd8739ae039) : b instanceof Date ? (0, $d8389bdf6615fbb6$export$2e2bcd8739ae039) : (0, $a0f07588f813c5d7$export$5cd576d1827d40c8)(b) ? (0, $a0f07588f813c5d7$export$2e2bcd8739ae039) : Array.isArray(b) ? (0, $59e240aa80a63b3e$export$15d09067c6a5ee49) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $7df4a72af7d44e92$export$2e2bcd8739ae039) : (0, $eb2bb06aba5a5f63$export$2e2bcd8739ae039))(a, b);
}

function $02fbdbbe756386c9$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}


function $841d06f7b1036070$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $4d38a77ee181cec7$export$2e2bcd8739ae039(x) {
    return +x;
}


var $2fa8e6a54effbce4$var$unit = [
    0,
    1
];
function $2fa8e6a54effbce4$export$f0954fd7d5368655(x) {
    return x;
}
function $2fa8e6a54effbce4$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $841d06f7b1036070$export$2e2bcd8739ae039)(isNaN(b) ? NaN : 0.5);
}
function $2fa8e6a54effbce4$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $2fa8e6a54effbce4$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $2fa8e6a54effbce4$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $2fa8e6a54effbce4$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $2fa8e6a54effbce4$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $2fa8e6a54effbce4$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $79d8d5aac932c361$export$2e2bcd8739ae039)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $2fa8e6a54effbce4$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $2fa8e6a54effbce4$export$6b468dcfb64c653c() {
    var domain = $2fa8e6a54effbce4$var$unit, range = $2fa8e6a54effbce4$var$unit, interpolate = (0, $1f216e2faccc8163$export$2e2bcd8739ae039), transform, untransform, unknown, clamp = $2fa8e6a54effbce4$export$f0954fd7d5368655, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $2fa8e6a54effbce4$export$f0954fd7d5368655) clamp = $2fa8e6a54effbce4$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $2fa8e6a54effbce4$var$polymap : $2fa8e6a54effbce4$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, $eb2bb06aba5a5f63$export$2e2bcd8739ae039))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, $4d38a77ee181cec7$export$2e2bcd8739ae039)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = (0, $02fbdbbe756386c9$export$2e2bcd8739ae039), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $2fa8e6a54effbce4$export$f0954fd7d5368655, rescale()) : clamp !== $2fa8e6a54effbce4$export$f0954fd7d5368655;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $2fa8e6a54effbce4$export$2e2bcd8739ae039() {
    return $2fa8e6a54effbce4$export$6b468dcfb64c653c()($2fa8e6a54effbce4$export$f0954fd7d5368655, $2fa8e6a54effbce4$export$f0954fd7d5368655);
}


function $8dace37c8abe7fc9$export$23c7bb9e6558da2a(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $8dace37c8abe7fc9$export$7d6b419e59e83f3d(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}



function $57a870d3837a04f2$export$2e2bcd8739ae039(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function $57a870d3837a04f2$export$8f8e23dd27dc19f5(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}


function $23954a882cab715e$export$2e2bcd8739ae039(x) {
    return x = (0, $57a870d3837a04f2$export$8f8e23dd27dc19f5)(Math.abs(x)), x ? x[1] : NaN;
}


function $2fe6f9456bf6ad41$export$2e2bcd8739ae039(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}


function $65db753186dd66bb$export$2e2bcd8739ae039(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}


// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $823a04eab69a0296$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $823a04eab69a0296$export$2e2bcd8739ae039(specifier) {
    if (!(match = $823a04eab69a0296$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $823a04eab69a0296$export$963aac351db36ed4({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$823a04eab69a0296$export$2e2bcd8739ae039.prototype = $823a04eab69a0296$export$963aac351db36ed4.prototype; // instanceof
function $823a04eab69a0296$export$963aac351db36ed4(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$823a04eab69a0296$export$963aac351db36ed4.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};


// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $bd0922c67f15f04a$export$2e2bcd8739ae039(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}




var $8bb68ae8e3b1e6f4$export$6863724d9a42263;
function $8bb68ae8e3b1e6f4$export$2e2bcd8739ae039(x, p) {
    var d = (0, $57a870d3837a04f2$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - ($8bb68ae8e3b1e6f4$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $57a870d3837a04f2$export$8f8e23dd27dc19f5)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}



function $b45958fdec4f4188$export$2e2bcd8739ae039(x, p) {
    var d = (0, $57a870d3837a04f2$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}


var $4ae1df6f2c0b1d2c$export$2e2bcd8739ae039 = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": (0, $57a870d3837a04f2$export$2e2bcd8739ae039),
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $b45958fdec4f4188$export$2e2bcd8739ae039)(x * 100, p),
    "r": (0, $b45958fdec4f4188$export$2e2bcd8739ae039),
    "s": (0, $8bb68ae8e3b1e6f4$export$2e2bcd8739ae039),
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};



function $a8f99d5606ba64c9$export$2e2bcd8739ae039(x) {
    return x;
}


var $afcb6410b496fb6c$var$map = Array.prototype.map, $afcb6410b496fb6c$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $afcb6410b496fb6c$export$2e2bcd8739ae039(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? (0, $a8f99d5606ba64c9$export$2e2bcd8739ae039) : (0, $2fe6f9456bf6ad41$export$2e2bcd8739ae039)($afcb6410b496fb6c$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, $a8f99d5606ba64c9$export$2e2bcd8739ae039) : (0, $65db753186dd66bb$export$2e2bcd8739ae039)($afcb6410b496fb6c$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $823a04eab69a0296$export$2e2bcd8739ae039)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!(0, $4ae1df6f2c0b1d2c$export$2e2bcd8739ae039)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = (0, $4ae1df6f2c0b1d2c$export$2e2bcd8739ae039)[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $bd0922c67f15f04a$export$2e2bcd8739ae039)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $afcb6410b496fb6c$var$prefixes[8 + (0, $8bb68ae8e3b1e6f4$export$6863724d9a42263) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $823a04eab69a0296$export$2e2bcd8739ae039)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $23954a882cab715e$export$2e2bcd8739ae039)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $afcb6410b496fb6c$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}


var $8df3ddebf3298fa7$var$locale;
var $8df3ddebf3298fa7$export$d9468344d3651243;
var $8df3ddebf3298fa7$export$8d85692a469dde6f;
$8df3ddebf3298fa7$export$2e2bcd8739ae039({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $8df3ddebf3298fa7$export$2e2bcd8739ae039(definition) {
    $8df3ddebf3298fa7$var$locale = (0, $afcb6410b496fb6c$export$2e2bcd8739ae039)(definition);
    $8df3ddebf3298fa7$export$d9468344d3651243 = $8df3ddebf3298fa7$var$locale.format;
    $8df3ddebf3298fa7$export$8d85692a469dde6f = $8df3ddebf3298fa7$var$locale.formatPrefix;
    return $8df3ddebf3298fa7$var$locale;
}


function $be915e8f4b092266$export$2e2bcd8739ae039(step) {
    return Math.max(0, -(0, $23954a882cab715e$export$2e2bcd8739ae039)(Math.abs(step)));
}


function $120662a3f75080a2$export$2e2bcd8739ae039(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $23954a882cab715e$export$2e2bcd8739ae039)(value) / 3))) * 3 - (0, $23954a882cab715e$export$2e2bcd8739ae039)(Math.abs(step)));
}


function $9736a50529c6c043$export$2e2bcd8739ae039(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $23954a882cab715e$export$2e2bcd8739ae039)(max) - (0, $23954a882cab715e$export$2e2bcd8739ae039)(step)) + 1;
}


function $1e6ce0e7f165aca3$export$2e2bcd8739ae039(start, stop, count, specifier) {
    var step = (0, $7a8da38967538e73$export$81087d9b915d4ede)(start, stop, count), precision;
    specifier = (0, $823a04eab69a0296$export$2e2bcd8739ae039)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $120662a3f75080a2$export$2e2bcd8739ae039)(step, value))) specifier.precision = precision;
            return (0, $8df3ddebf3298fa7$export$8d85692a469dde6f)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $9736a50529c6c043$export$2e2bcd8739ae039)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $be915e8f4b092266$export$2e2bcd8739ae039)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $8df3ddebf3298fa7$export$d9468344d3651243)(specifier);
}


function $ccf8ada068c66f81$export$16a5d4b4a61a274d(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $7a8da38967538e73$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $1e6ce0e7f165aca3$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $7a8da38967538e73$export$bc64d00cc98e7e95)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $ccf8ada068c66f81$export$2e2bcd8739ae039() {
    var scale = (0, $2fa8e6a54effbce4$export$2e2bcd8739ae039)();
    scale.copy = function() {
        return (0, $2fa8e6a54effbce4$export$784d13d8ee351f07)(scale, $ccf8ada068c66f81$export$2e2bcd8739ae039());
    };
    (0, $8dace37c8abe7fc9$export$23c7bb9e6558da2a).apply(scale, arguments);
    return $ccf8ada068c66f81$export$16a5d4b4a61a274d(scale);
}

const $605a00b39e409b25$var$t0 = new Date, $605a00b39e409b25$var$t1 = new Date;
function $605a00b39e409b25$export$1a539c8b2950ab40(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = (date)=>{
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = (date)=>{
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = (date)=>{
        const d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = (date, step)=>{
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = (start, stop, step)=>{
        const range = [];
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        let previous;
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = (test)=>{
        return $605a00b39e409b25$export$1a539c8b2950ab40((date)=>{
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, (date, step)=>{
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = (start, end)=>{
            $605a00b39e409b25$var$t0.setTime(+start), $605a00b39e409b25$var$t1.setTime(+end);
            floori($605a00b39e409b25$var$t0), floori($605a00b39e409b25$var$t1);
            return Math.floor(count($605a00b39e409b25$var$t0, $605a00b39e409b25$var$t1));
        };
        interval.every = (step)=>{
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? (d)=>field(d) % step === 0 : (d)=>interval.count(0, d) % step === 0);
        };
    }
    return interval;
}


const $e19d601c781b1aa0$export$79ef0e34099623dc = 1000;
const $e19d601c781b1aa0$export$683905d551c33fa9 = $e19d601c781b1aa0$export$79ef0e34099623dc * 60;
const $e19d601c781b1aa0$export$4157bf0c8e241659 = $e19d601c781b1aa0$export$683905d551c33fa9 * 60;
const $e19d601c781b1aa0$export$353686095f4fbf45 = $e19d601c781b1aa0$export$4157bf0c8e241659 * 24;
const $e19d601c781b1aa0$export$c241eb88520d5016 = $e19d601c781b1aa0$export$353686095f4fbf45 * 7;
const $e19d601c781b1aa0$export$ab95684df7020b26 = $e19d601c781b1aa0$export$353686095f4fbf45 * 30;
const $e19d601c781b1aa0$export$61f8ee2d834c6959 = $e19d601c781b1aa0$export$353686095f4fbf45 * 365;


const $08b46852e9813716$export$8888529b966033e5 = (0, $605a00b39e409b25$export$1a539c8b2950ab40)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $e19d601c781b1aa0$export$683905d551c33fa9)) / (0, $e19d601c781b1aa0$export$353686095f4fbf45), (date)=>date.getDate() - 1);
const $08b46852e9813716$export$6657a54f3034cf45 = $08b46852e9813716$export$8888529b966033e5.range;
const $08b46852e9813716$export$c8cbc42cefd47140 = (0, $605a00b39e409b25$export$1a539c8b2950ab40)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, $e19d601c781b1aa0$export$353686095f4fbf45);
}, (date)=>{
    return date.getUTCDate() - 1;
});
const $08b46852e9813716$export$d277e198508549a1 = $08b46852e9813716$export$c8cbc42cefd47140.range;
const $08b46852e9813716$export$fb065be2d7ea4a71 = (0, $605a00b39e409b25$export$1a539c8b2950ab40)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, $e19d601c781b1aa0$export$353686095f4fbf45);
}, (date)=>{
    return Math.floor(date / (0, $e19d601c781b1aa0$export$353686095f4fbf45));
});
const $08b46852e9813716$export$a491caaf5e9481aa = $08b46852e9813716$export$fb065be2d7ea4a71.range;



const $d45bd4705559ea98$export$46c68a5833bc315b = (0, $605a00b39e409b25$export$1a539c8b2950ab40)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $e19d601c781b1aa0$export$79ef0e34099623dc) - date.getMinutes() * (0, $e19d601c781b1aa0$export$683905d551c33fa9));
}, (date, step)=>{
    date.setTime(+date + step * (0, $e19d601c781b1aa0$export$4157bf0c8e241659));
}, (start, end)=>{
    return (end - start) / (0, $e19d601c781b1aa0$export$4157bf0c8e241659);
}, (date)=>{
    return date.getHours();
});
const $d45bd4705559ea98$export$fb843f9087cd5235 = $d45bd4705559ea98$export$46c68a5833bc315b.range;
const $d45bd4705559ea98$export$31f6f2b3c63ac75e = (0, $605a00b39e409b25$export$1a539c8b2950ab40)((date)=>{
    date.setUTCMinutes(0, 0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, $e19d601c781b1aa0$export$4157bf0c8e241659));
}, (start, end)=>{
    return (end - start) / (0, $e19d601c781b1aa0$export$4157bf0c8e241659);
}, (date)=>{
    return date.getUTCHours();
});
const $d45bd4705559ea98$export$6e7a76cd5f50b719 = $d45bd4705559ea98$export$31f6f2b3c63ac75e.range;



const $7639fd829c434ccc$export$a7e4c34a52f0576 = (0, $605a00b39e409b25$export$1a539c8b2950ab40)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $e19d601c781b1aa0$export$79ef0e34099623dc));
}, (date, step)=>{
    date.setTime(+date + step * (0, $e19d601c781b1aa0$export$683905d551c33fa9));
}, (start, end)=>{
    return (end - start) / (0, $e19d601c781b1aa0$export$683905d551c33fa9);
}, (date)=>{
    return date.getMinutes();
});
const $7639fd829c434ccc$export$186d65358374c0a2 = $7639fd829c434ccc$export$a7e4c34a52f0576.range;
const $7639fd829c434ccc$export$efe6712d6003761b = (0, $605a00b39e409b25$export$1a539c8b2950ab40)((date)=>{
    date.setUTCSeconds(0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, $e19d601c781b1aa0$export$683905d551c33fa9));
}, (start, end)=>{
    return (end - start) / (0, $e19d601c781b1aa0$export$683905d551c33fa9);
}, (date)=>{
    return date.getUTCMinutes();
});
const $7639fd829c434ccc$export$cedd563624e8ee50 = $7639fd829c434ccc$export$efe6712d6003761b.range;


const $244893c5c4313cb8$export$7e1084fb688591c1 = (0, $605a00b39e409b25$export$1a539c8b2950ab40)((date)=>{
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setMonth(date.getMonth() + step);
}, (start, end)=>{
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, (date)=>{
    return date.getMonth();
});
const $244893c5c4313cb8$export$3e24aa839cd0f1c4 = $244893c5c4313cb8$export$7e1084fb688591c1.range;
const $244893c5c4313cb8$export$cd49b3d2bcfe50d5 = (0, $605a00b39e409b25$export$1a539c8b2950ab40)((date)=>{
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCMonth(date.getUTCMonth() + step);
}, (start, end)=>{
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, (date)=>{
    return date.getUTCMonth();
});
const $244893c5c4313cb8$export$49159f585997498 = $244893c5c4313cb8$export$cd49b3d2bcfe50d5.range;



const $343cd944c59b5b21$export$3d3c77ce7df7d30d = (0, $605a00b39e409b25$export$1a539c8b2950ab40)((date)=>{
    date.setTime(date - date.getMilliseconds());
}, (date, step)=>{
    date.setTime(+date + step * (0, $e19d601c781b1aa0$export$79ef0e34099623dc));
}, (start, end)=>{
    return (end - start) / (0, $e19d601c781b1aa0$export$79ef0e34099623dc);
}, (date)=>{
    return date.getUTCSeconds();
});
const $343cd944c59b5b21$export$4792e48abc550fa1 = $343cd944c59b5b21$export$3d3c77ce7df7d30d.range;




const $db77b1a4d11db8e6$export$edc5e5cb87280477 = (0, $605a00b39e409b25$export$1a539c8b2950ab40)(()=>{
// noop
}, (date, step)=>{
    date.setTime(+date + step);
}, (start, end)=>{
    return end - start;
});
// An optimized implementation for this simple case.
$db77b1a4d11db8e6$export$edc5e5cb87280477.every = (k)=>{
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $db77b1a4d11db8e6$export$edc5e5cb87280477;
    return (0, $605a00b39e409b25$export$1a539c8b2950ab40)((date)=>{
        date.setTime(Math.floor(date / k) * k);
    }, (date, step)=>{
        date.setTime(+date + step * k);
    }, (start, end)=>{
        return (end - start) / k;
    });
};
const $db77b1a4d11db8e6$export$9a27fac83d67afd3 = $db77b1a4d11db8e6$export$edc5e5cb87280477.range;








function $75af0657878c8c51$var$timeWeekday(i) {
    return (0, $605a00b39e409b25$export$1a539c8b2950ab40)((date)=>{
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setDate(date.getDate() + step * 7);
    }, (start, end)=>{
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $e19d601c781b1aa0$export$683905d551c33fa9)) / (0, $e19d601c781b1aa0$export$c241eb88520d5016);
    });
}
const $75af0657878c8c51$export$22ee6205b762968c = $75af0657878c8c51$var$timeWeekday(0);
const $75af0657878c8c51$export$e79bbe0177cf1b01 = $75af0657878c8c51$var$timeWeekday(1);
const $75af0657878c8c51$export$57c0658c29f77708 = $75af0657878c8c51$var$timeWeekday(2);
const $75af0657878c8c51$export$3fbeef226c256e43 = $75af0657878c8c51$var$timeWeekday(3);
const $75af0657878c8c51$export$608689422d5cf9f4 = $75af0657878c8c51$var$timeWeekday(4);
const $75af0657878c8c51$export$548e5227aa183dca = $75af0657878c8c51$var$timeWeekday(5);
const $75af0657878c8c51$export$c56a3ad248908e19 = $75af0657878c8c51$var$timeWeekday(6);
const $75af0657878c8c51$export$eac514c8a8674eba = $75af0657878c8c51$export$22ee6205b762968c.range;
const $75af0657878c8c51$export$f7219b1481948356 = $75af0657878c8c51$export$e79bbe0177cf1b01.range;
const $75af0657878c8c51$export$77e22b12c5bed05b = $75af0657878c8c51$export$57c0658c29f77708.range;
const $75af0657878c8c51$export$b85d407a471809e8 = $75af0657878c8c51$export$3fbeef226c256e43.range;
const $75af0657878c8c51$export$c1bc1c49254c8855 = $75af0657878c8c51$export$608689422d5cf9f4.range;
const $75af0657878c8c51$export$3691a1557fff46f1 = $75af0657878c8c51$export$548e5227aa183dca.range;
const $75af0657878c8c51$export$b755452d02cba8d2 = $75af0657878c8c51$export$c56a3ad248908e19.range;
function $75af0657878c8c51$var$utcWeekday(i) {
    return (0, $605a00b39e409b25$export$1a539c8b2950ab40)((date)=>{
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, (start, end)=>{
        return (end - start) / (0, $e19d601c781b1aa0$export$c241eb88520d5016);
    });
}
const $75af0657878c8c51$export$4898b06303a92011 = $75af0657878c8c51$var$utcWeekday(0);
const $75af0657878c8c51$export$9cfc53b9cfafd080 = $75af0657878c8c51$var$utcWeekday(1);
const $75af0657878c8c51$export$2a6d545f77eceb15 = $75af0657878c8c51$var$utcWeekday(2);
const $75af0657878c8c51$export$a5c25d8ed64433c4 = $75af0657878c8c51$var$utcWeekday(3);
const $75af0657878c8c51$export$1db08111baec2f53 = $75af0657878c8c51$var$utcWeekday(4);
const $75af0657878c8c51$export$29265e34dd5921f7 = $75af0657878c8c51$var$utcWeekday(5);
const $75af0657878c8c51$export$85b74dad05049604 = $75af0657878c8c51$var$utcWeekday(6);
const $75af0657878c8c51$export$6f3e1c2b0f7d7880 = $75af0657878c8c51$export$4898b06303a92011.range;
const $75af0657878c8c51$export$1d2d8b858bb366f9 = $75af0657878c8c51$export$9cfc53b9cfafd080.range;
const $75af0657878c8c51$export$1d5f6785fc7f30f8 = $75af0657878c8c51$export$2a6d545f77eceb15.range;
const $75af0657878c8c51$export$7a75faf0e37ef4af = $75af0657878c8c51$export$a5c25d8ed64433c4.range;
const $75af0657878c8c51$export$417eb959611b2f2f = $75af0657878c8c51$export$1db08111baec2f53.range;
const $75af0657878c8c51$export$59d308db7af08c64 = $75af0657878c8c51$export$29265e34dd5921f7.range;
const $75af0657878c8c51$export$a124108a0a7f34c8 = $75af0657878c8c51$export$85b74dad05049604.range;




const $64318b8308284f2f$export$cd17cfe45df0c046 = (0, $605a00b39e409b25$export$1a539c8b2950ab40)((date)=>{
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setFullYear(date.getFullYear() + step);
}, (start, end)=>{
    return end.getFullYear() - start.getFullYear();
}, (date)=>{
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$64318b8308284f2f$export$cd17cfe45df0c046.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $605a00b39e409b25$export$1a539c8b2950ab40)((date)=>{
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setFullYear(date.getFullYear() + step * k);
    });
};
const $64318b8308284f2f$export$69a4e90dd2cc3bd1 = $64318b8308284f2f$export$cd17cfe45df0c046.range;
const $64318b8308284f2f$export$d5c3802e389714c4 = (0, $605a00b39e409b25$export$1a539c8b2950ab40)((date)=>{
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, (start, end)=>{
    return end.getUTCFullYear() - start.getUTCFullYear();
}, (date)=>{
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$64318b8308284f2f$export$d5c3802e389714c4.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $605a00b39e409b25$export$1a539c8b2950ab40)((date)=>{
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
const $64318b8308284f2f$export$3e24d311e17f5802 = $64318b8308284f2f$export$d5c3802e389714c4.range;


function $07b37cbb2fcf6d18$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            (0, $343cd944c59b5b21$export$3d3c77ce7df7d30d),
            1,
            (0, $e19d601c781b1aa0$export$79ef0e34099623dc)
        ],
        [
            (0, $343cd944c59b5b21$export$3d3c77ce7df7d30d),
            5,
            5 * (0, $e19d601c781b1aa0$export$79ef0e34099623dc)
        ],
        [
            (0, $343cd944c59b5b21$export$3d3c77ce7df7d30d),
            15,
            15 * (0, $e19d601c781b1aa0$export$79ef0e34099623dc)
        ],
        [
            (0, $343cd944c59b5b21$export$3d3c77ce7df7d30d),
            30,
            30 * (0, $e19d601c781b1aa0$export$79ef0e34099623dc)
        ],
        [
            minute,
            1,
            (0, $e19d601c781b1aa0$export$683905d551c33fa9)
        ],
        [
            minute,
            5,
            5 * (0, $e19d601c781b1aa0$export$683905d551c33fa9)
        ],
        [
            minute,
            15,
            15 * (0, $e19d601c781b1aa0$export$683905d551c33fa9)
        ],
        [
            minute,
            30,
            30 * (0, $e19d601c781b1aa0$export$683905d551c33fa9)
        ],
        [
            hour,
            1,
            (0, $e19d601c781b1aa0$export$4157bf0c8e241659)
        ],
        [
            hour,
            3,
            3 * (0, $e19d601c781b1aa0$export$4157bf0c8e241659)
        ],
        [
            hour,
            6,
            6 * (0, $e19d601c781b1aa0$export$4157bf0c8e241659)
        ],
        [
            hour,
            12,
            12 * (0, $e19d601c781b1aa0$export$4157bf0c8e241659)
        ],
        [
            day,
            1,
            (0, $e19d601c781b1aa0$export$353686095f4fbf45)
        ],
        [
            day,
            2,
            2 * (0, $e19d601c781b1aa0$export$353686095f4fbf45)
        ],
        [
            week,
            1,
            (0, $e19d601c781b1aa0$export$c241eb88520d5016)
        ],
        [
            month,
            1,
            (0, $e19d601c781b1aa0$export$ab95684df7020b26)
        ],
        [
            month,
            3,
            3 * (0, $e19d601c781b1aa0$export$ab95684df7020b26)
        ],
        [
            year,
            1,
            (0, $e19d601c781b1aa0$export$61f8ee2d834c6959)
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $c4ba7f6ca40ba921$export$2e2bcd8739ae039)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $7a8da38967538e73$export$81087d9b915d4ede)(start / (0, $e19d601c781b1aa0$export$61f8ee2d834c6959), stop / (0, $e19d601c781b1aa0$export$61f8ee2d834c6959), count));
        if (i === 0) return (0, $db77b1a4d11db8e6$export$edc5e5cb87280477).every(Math.max((0, $7a8da38967538e73$export$81087d9b915d4ede)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$07b37cbb2fcf6d18$export$826ba5ae907e9767, $07b37cbb2fcf6d18$export$6262d8d056ea44c4] = $07b37cbb2fcf6d18$var$ticker((0, $64318b8308284f2f$export$d5c3802e389714c4), (0, $244893c5c4313cb8$export$cd49b3d2bcfe50d5), (0, $75af0657878c8c51$export$4898b06303a92011), (0, $08b46852e9813716$export$fb065be2d7ea4a71), (0, $d45bd4705559ea98$export$31f6f2b3c63ac75e), (0, $7639fd829c434ccc$export$efe6712d6003761b));
const [$07b37cbb2fcf6d18$export$60c76498552d28a6, $07b37cbb2fcf6d18$export$69511150134dd174] = $07b37cbb2fcf6d18$var$ticker((0, $64318b8308284f2f$export$cd17cfe45df0c046), (0, $244893c5c4313cb8$export$7e1084fb688591c1), (0, $75af0657878c8c51$export$22ee6205b762968c), (0, $08b46852e9813716$export$8888529b966033e5), (0, $d45bd4705559ea98$export$46c68a5833bc315b), (0, $7639fd829c434ccc$export$a7e4c34a52f0576));



function $655110f65d95a265$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $655110f65d95a265$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $655110f65d95a265$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $655110f65d95a265$export$2e2bcd8739ae039(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $655110f65d95a265$var$formatRe(locale_periods), periodLookup = $655110f65d95a265$var$formatLookup(locale_periods), weekdayRe = $655110f65d95a265$var$formatRe(locale_weekdays), weekdayLookup = $655110f65d95a265$var$formatLookup(locale_weekdays), shortWeekdayRe = $655110f65d95a265$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $655110f65d95a265$var$formatLookup(locale_shortWeekdays), monthRe = $655110f65d95a265$var$formatRe(locale_months), monthLookup = $655110f65d95a265$var$formatLookup(locale_months), shortMonthRe = $655110f65d95a265$var$formatRe(locale_shortMonths), shortMonthLookup = $655110f65d95a265$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $655110f65d95a265$var$formatDayOfMonth,
        "e": $655110f65d95a265$var$formatDayOfMonth,
        "f": $655110f65d95a265$var$formatMicroseconds,
        "g": $655110f65d95a265$var$formatYearISO,
        "G": $655110f65d95a265$var$formatFullYearISO,
        "H": $655110f65d95a265$var$formatHour24,
        "I": $655110f65d95a265$var$formatHour12,
        "j": $655110f65d95a265$var$formatDayOfYear,
        "L": $655110f65d95a265$var$formatMilliseconds,
        "m": $655110f65d95a265$var$formatMonthNumber,
        "M": $655110f65d95a265$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $655110f65d95a265$var$formatUnixTimestamp,
        "s": $655110f65d95a265$var$formatUnixTimestampSeconds,
        "S": $655110f65d95a265$var$formatSeconds,
        "u": $655110f65d95a265$var$formatWeekdayNumberMonday,
        "U": $655110f65d95a265$var$formatWeekNumberSunday,
        "V": $655110f65d95a265$var$formatWeekNumberISO,
        "w": $655110f65d95a265$var$formatWeekdayNumberSunday,
        "W": $655110f65d95a265$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $655110f65d95a265$var$formatYear,
        "Y": $655110f65d95a265$var$formatFullYear,
        "Z": $655110f65d95a265$var$formatZone,
        "%": $655110f65d95a265$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $655110f65d95a265$var$formatUTCDayOfMonth,
        "e": $655110f65d95a265$var$formatUTCDayOfMonth,
        "f": $655110f65d95a265$var$formatUTCMicroseconds,
        "g": $655110f65d95a265$var$formatUTCYearISO,
        "G": $655110f65d95a265$var$formatUTCFullYearISO,
        "H": $655110f65d95a265$var$formatUTCHour24,
        "I": $655110f65d95a265$var$formatUTCHour12,
        "j": $655110f65d95a265$var$formatUTCDayOfYear,
        "L": $655110f65d95a265$var$formatUTCMilliseconds,
        "m": $655110f65d95a265$var$formatUTCMonthNumber,
        "M": $655110f65d95a265$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $655110f65d95a265$var$formatUnixTimestamp,
        "s": $655110f65d95a265$var$formatUnixTimestampSeconds,
        "S": $655110f65d95a265$var$formatUTCSeconds,
        "u": $655110f65d95a265$var$formatUTCWeekdayNumberMonday,
        "U": $655110f65d95a265$var$formatUTCWeekNumberSunday,
        "V": $655110f65d95a265$var$formatUTCWeekNumberISO,
        "w": $655110f65d95a265$var$formatUTCWeekdayNumberSunday,
        "W": $655110f65d95a265$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $655110f65d95a265$var$formatUTCYear,
        "Y": $655110f65d95a265$var$formatUTCFullYear,
        "Z": $655110f65d95a265$var$formatUTCZone,
        "%": $655110f65d95a265$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $655110f65d95a265$var$parseDayOfMonth,
        "e": $655110f65d95a265$var$parseDayOfMonth,
        "f": $655110f65d95a265$var$parseMicroseconds,
        "g": $655110f65d95a265$var$parseYear,
        "G": $655110f65d95a265$var$parseFullYear,
        "H": $655110f65d95a265$var$parseHour24,
        "I": $655110f65d95a265$var$parseHour24,
        "j": $655110f65d95a265$var$parseDayOfYear,
        "L": $655110f65d95a265$var$parseMilliseconds,
        "m": $655110f65d95a265$var$parseMonthNumber,
        "M": $655110f65d95a265$var$parseMinutes,
        "p": parsePeriod,
        "q": $655110f65d95a265$var$parseQuarter,
        "Q": $655110f65d95a265$var$parseUnixTimestamp,
        "s": $655110f65d95a265$var$parseUnixTimestampSeconds,
        "S": $655110f65d95a265$var$parseSeconds,
        "u": $655110f65d95a265$var$parseWeekdayNumberMonday,
        "U": $655110f65d95a265$var$parseWeekNumberSunday,
        "V": $655110f65d95a265$var$parseWeekNumberISO,
        "w": $655110f65d95a265$var$parseWeekdayNumberSunday,
        "W": $655110f65d95a265$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $655110f65d95a265$var$parseYear,
        "Y": $655110f65d95a265$var$parseFullYear,
        "Z": $655110f65d95a265$var$parseZone,
        "%": $655110f65d95a265$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $655110f65d95a265$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $655110f65d95a265$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $655110f65d95a265$var$utcDate($655110f65d95a265$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, $75af0657878c8c51$export$9cfc53b9cfafd080).ceil(week) : (0, $75af0657878c8c51$export$9cfc53b9cfafd080)(week);
                    week = (0, $08b46852e9813716$export$c8cbc42cefd47140).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $655110f65d95a265$var$localDate($655110f65d95a265$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, $75af0657878c8c51$export$e79bbe0177cf1b01).ceil(week) : (0, $75af0657878c8c51$export$e79bbe0177cf1b01)(week);
                    week = (0, $08b46852e9813716$export$8888529b966033e5).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $655110f65d95a265$var$utcDate($655110f65d95a265$var$newDate(d.y, 0, 1)).getUTCDay() : $655110f65d95a265$var$localDate($655110f65d95a265$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $655110f65d95a265$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return $655110f65d95a265$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $655110f65d95a265$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $655110f65d95a265$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $655110f65d95a265$var$numberRe = /^\s*\d+/, $655110f65d95a265$var$percentRe = /^%/, $655110f65d95a265$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $655110f65d95a265$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $655110f65d95a265$var$requote(s) {
    return s.replace($655110f65d95a265$var$requoteRe, "\\$&");
}
function $655110f65d95a265$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($655110f65d95a265$var$requote).join("|") + ")", "i");
}
function $655110f65d95a265$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $655110f65d95a265$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $655110f65d95a265$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $655110f65d95a265$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $655110f65d95a265$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $655110f65d95a265$var$parseWeekNumberSunday(d, string, i) {
    var n = $655110f65d95a265$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $655110f65d95a265$var$parseWeekNumberISO(d, string, i) {
    var n = $655110f65d95a265$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $655110f65d95a265$var$parseWeekNumberMonday(d, string, i) {
    var n = $655110f65d95a265$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $655110f65d95a265$var$parseFullYear(d, string, i) {
    var n = $655110f65d95a265$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $655110f65d95a265$var$parseYear(d, string, i) {
    var n = $655110f65d95a265$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $655110f65d95a265$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $655110f65d95a265$var$parseQuarter(d, string, i) {
    var n = $655110f65d95a265$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $655110f65d95a265$var$parseMonthNumber(d, string, i) {
    var n = $655110f65d95a265$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $655110f65d95a265$var$parseDayOfMonth(d, string, i) {
    var n = $655110f65d95a265$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $655110f65d95a265$var$parseDayOfYear(d, string, i) {
    var n = $655110f65d95a265$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $655110f65d95a265$var$parseHour24(d, string, i) {
    var n = $655110f65d95a265$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $655110f65d95a265$var$parseMinutes(d, string, i) {
    var n = $655110f65d95a265$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $655110f65d95a265$var$parseSeconds(d, string, i) {
    var n = $655110f65d95a265$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $655110f65d95a265$var$parseMilliseconds(d, string, i) {
    var n = $655110f65d95a265$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $655110f65d95a265$var$parseMicroseconds(d, string, i) {
    var n = $655110f65d95a265$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $655110f65d95a265$var$parseLiteralPercent(d, string, i) {
    var n = $655110f65d95a265$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $655110f65d95a265$var$parseUnixTimestamp(d, string, i) {
    var n = $655110f65d95a265$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $655110f65d95a265$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $655110f65d95a265$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $655110f65d95a265$var$formatDayOfMonth(d, p) {
    return $655110f65d95a265$var$pad(d.getDate(), p, 2);
}
function $655110f65d95a265$var$formatHour24(d, p) {
    return $655110f65d95a265$var$pad(d.getHours(), p, 2);
}
function $655110f65d95a265$var$formatHour12(d, p) {
    return $655110f65d95a265$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $655110f65d95a265$var$formatDayOfYear(d, p) {
    return $655110f65d95a265$var$pad(1 + (0, $08b46852e9813716$export$8888529b966033e5).count((0, $64318b8308284f2f$export$cd17cfe45df0c046)(d), d), p, 3);
}
function $655110f65d95a265$var$formatMilliseconds(d, p) {
    return $655110f65d95a265$var$pad(d.getMilliseconds(), p, 3);
}
function $655110f65d95a265$var$formatMicroseconds(d, p) {
    return $655110f65d95a265$var$formatMilliseconds(d, p) + "000";
}
function $655110f65d95a265$var$formatMonthNumber(d, p) {
    return $655110f65d95a265$var$pad(d.getMonth() + 1, p, 2);
}
function $655110f65d95a265$var$formatMinutes(d, p) {
    return $655110f65d95a265$var$pad(d.getMinutes(), p, 2);
}
function $655110f65d95a265$var$formatSeconds(d, p) {
    return $655110f65d95a265$var$pad(d.getSeconds(), p, 2);
}
function $655110f65d95a265$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $655110f65d95a265$var$formatWeekNumberSunday(d, p) {
    return $655110f65d95a265$var$pad((0, $75af0657878c8c51$export$22ee6205b762968c).count((0, $64318b8308284f2f$export$cd17cfe45df0c046)(d) - 1, d), p, 2);
}
function $655110f65d95a265$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $75af0657878c8c51$export$608689422d5cf9f4)(d) : (0, $75af0657878c8c51$export$608689422d5cf9f4).ceil(d);
}
function $655110f65d95a265$var$formatWeekNumberISO(d, p) {
    d = $655110f65d95a265$var$dISO(d);
    return $655110f65d95a265$var$pad((0, $75af0657878c8c51$export$608689422d5cf9f4).count((0, $64318b8308284f2f$export$cd17cfe45df0c046)(d), d) + ((0, $64318b8308284f2f$export$cd17cfe45df0c046)(d).getDay() === 4), p, 2);
}
function $655110f65d95a265$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $655110f65d95a265$var$formatWeekNumberMonday(d, p) {
    return $655110f65d95a265$var$pad((0, $75af0657878c8c51$export$e79bbe0177cf1b01).count((0, $64318b8308284f2f$export$cd17cfe45df0c046)(d) - 1, d), p, 2);
}
function $655110f65d95a265$var$formatYear(d, p) {
    return $655110f65d95a265$var$pad(d.getFullYear() % 100, p, 2);
}
function $655110f65d95a265$var$formatYearISO(d, p) {
    d = $655110f65d95a265$var$dISO(d);
    return $655110f65d95a265$var$pad(d.getFullYear() % 100, p, 2);
}
function $655110f65d95a265$var$formatFullYear(d, p) {
    return $655110f65d95a265$var$pad(d.getFullYear() % 10000, p, 4);
}
function $655110f65d95a265$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $75af0657878c8c51$export$608689422d5cf9f4)(d) : (0, $75af0657878c8c51$export$608689422d5cf9f4).ceil(d);
    return $655110f65d95a265$var$pad(d.getFullYear() % 10000, p, 4);
}
function $655110f65d95a265$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $655110f65d95a265$var$pad(z / 60 | 0, "0", 2) + $655110f65d95a265$var$pad(z % 60, "0", 2);
}
function $655110f65d95a265$var$formatUTCDayOfMonth(d, p) {
    return $655110f65d95a265$var$pad(d.getUTCDate(), p, 2);
}
function $655110f65d95a265$var$formatUTCHour24(d, p) {
    return $655110f65d95a265$var$pad(d.getUTCHours(), p, 2);
}
function $655110f65d95a265$var$formatUTCHour12(d, p) {
    return $655110f65d95a265$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $655110f65d95a265$var$formatUTCDayOfYear(d, p) {
    return $655110f65d95a265$var$pad(1 + (0, $08b46852e9813716$export$c8cbc42cefd47140).count((0, $64318b8308284f2f$export$d5c3802e389714c4)(d), d), p, 3);
}
function $655110f65d95a265$var$formatUTCMilliseconds(d, p) {
    return $655110f65d95a265$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $655110f65d95a265$var$formatUTCMicroseconds(d, p) {
    return $655110f65d95a265$var$formatUTCMilliseconds(d, p) + "000";
}
function $655110f65d95a265$var$formatUTCMonthNumber(d, p) {
    return $655110f65d95a265$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $655110f65d95a265$var$formatUTCMinutes(d, p) {
    return $655110f65d95a265$var$pad(d.getUTCMinutes(), p, 2);
}
function $655110f65d95a265$var$formatUTCSeconds(d, p) {
    return $655110f65d95a265$var$pad(d.getUTCSeconds(), p, 2);
}
function $655110f65d95a265$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $655110f65d95a265$var$formatUTCWeekNumberSunday(d, p) {
    return $655110f65d95a265$var$pad((0, $75af0657878c8c51$export$4898b06303a92011).count((0, $64318b8308284f2f$export$d5c3802e389714c4)(d) - 1, d), p, 2);
}
function $655110f65d95a265$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $75af0657878c8c51$export$1db08111baec2f53)(d) : (0, $75af0657878c8c51$export$1db08111baec2f53).ceil(d);
}
function $655110f65d95a265$var$formatUTCWeekNumberISO(d, p) {
    d = $655110f65d95a265$var$UTCdISO(d);
    return $655110f65d95a265$var$pad((0, $75af0657878c8c51$export$1db08111baec2f53).count((0, $64318b8308284f2f$export$d5c3802e389714c4)(d), d) + ((0, $64318b8308284f2f$export$d5c3802e389714c4)(d).getUTCDay() === 4), p, 2);
}
function $655110f65d95a265$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $655110f65d95a265$var$formatUTCWeekNumberMonday(d, p) {
    return $655110f65d95a265$var$pad((0, $75af0657878c8c51$export$9cfc53b9cfafd080).count((0, $64318b8308284f2f$export$d5c3802e389714c4)(d) - 1, d), p, 2);
}
function $655110f65d95a265$var$formatUTCYear(d, p) {
    return $655110f65d95a265$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $655110f65d95a265$var$formatUTCYearISO(d, p) {
    d = $655110f65d95a265$var$UTCdISO(d);
    return $655110f65d95a265$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $655110f65d95a265$var$formatUTCFullYear(d, p) {
    return $655110f65d95a265$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $655110f65d95a265$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $75af0657878c8c51$export$1db08111baec2f53)(d) : (0, $75af0657878c8c51$export$1db08111baec2f53).ceil(d);
    return $655110f65d95a265$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $655110f65d95a265$var$formatUTCZone() {
    return "+0000";
}
function $655110f65d95a265$var$formatLiteralPercent() {
    return "%";
}
function $655110f65d95a265$var$formatUnixTimestamp(d) {
    return +d;
}
function $655110f65d95a265$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}


var $83cbfbc189509f85$var$locale;
var $83cbfbc189509f85$export$94f4d87fad5dcf9a;
var $83cbfbc189509f85$export$32b9cd16e1b8c8d2;
var $83cbfbc189509f85$export$1a08fe38f63ebbbb;
var $83cbfbc189509f85$export$3edae9cf8e233729;
$83cbfbc189509f85$export$2e2bcd8739ae039({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $83cbfbc189509f85$export$2e2bcd8739ae039(definition) {
    $83cbfbc189509f85$var$locale = (0, $655110f65d95a265$export$2e2bcd8739ae039)(definition);
    $83cbfbc189509f85$export$94f4d87fad5dcf9a = $83cbfbc189509f85$var$locale.format;
    $83cbfbc189509f85$export$32b9cd16e1b8c8d2 = $83cbfbc189509f85$var$locale.parse;
    $83cbfbc189509f85$export$1a08fe38f63ebbbb = $83cbfbc189509f85$var$locale.utcFormat;
    $83cbfbc189509f85$export$3edae9cf8e233729 = $83cbfbc189509f85$var$locale.utcParse;
    return $83cbfbc189509f85$var$locale;
}




function $c540657d40b1fc25$export$2e2bcd8739ae039(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}


function $765c04f742ece3b5$var$date(t) {
    return new Date(t);
}
function $765c04f742ece3b5$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $765c04f742ece3b5$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $2fa8e6a54effbce4$export$2e2bcd8739ae039)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $765c04f742ece3b5$var$number)) : domain().map($765c04f742ece3b5$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $c540657d40b1fc25$export$2e2bcd8739ae039)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $2fa8e6a54effbce4$export$784d13d8ee351f07)(scale, $765c04f742ece3b5$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $765c04f742ece3b5$export$2e2bcd8739ae039() {
    return (0, $8dace37c8abe7fc9$export$23c7bb9e6558da2a).apply($765c04f742ece3b5$export$56bbcdb8aca31149((0, $07b37cbb2fcf6d18$export$60c76498552d28a6), (0, $07b37cbb2fcf6d18$export$69511150134dd174), (0, $64318b8308284f2f$export$cd17cfe45df0c046), (0, $244893c5c4313cb8$export$7e1084fb688591c1), (0, $75af0657878c8c51$export$22ee6205b762968c), (0, $08b46852e9813716$export$8888529b966033e5), (0, $d45bd4705559ea98$export$46c68a5833bc315b), (0, $7639fd829c434ccc$export$a7e4c34a52f0576), (0, $343cd944c59b5b21$export$3d3c77ce7df7d30d), (0, $83cbfbc189509f85$export$94f4d87fad5dcf9a)).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}



var $NdCUR = parcelRequire("NdCUR");
const $2ba0ca0b374e98f9$var$Y_TICK_COUNT = 5;
const $2ba0ca0b374e98f9$var$Y_TICK_PADDING_RIGHT = 7;
const $2ba0ca0b374e98f9$var$X_TICK_COUNT = 10;
const $2ba0ca0b374e98f9$var$X_TICK_PADDING_TOP = 8;
class $2ba0ca0b374e98f9$var$HistogramChartAxes extends (0, $NdCUR.PureComponent) {
    render() {
        const { xTickData: xTickData, yTickData: yTickData } = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, this.renderYTicks(yTickData), this.renderYLabels(yTickData), this.renderXLabels(xTickData));
    }
    renderYTicks(yTickData) {
        return yTickData.map(({ x1: x1, x2: x2, y: y, key: key })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("line", {
                className: "y-tick",
                key: key,
                x1: x1,
                x2: x2,
                y1: y,
                y2: y
            }));
    }
    renderYLabels(yTickData) {
        return yTickData.map(({ x1: x1, y: y, label: label, key: key })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("text", {
                className: "y-label",
                key: key,
                x: x1 - $2ba0ca0b374e98f9$var$Y_TICK_PADDING_RIGHT,
                y: y
            }, label));
    }
    renderXLabels(xTickData) {
        return xTickData.map(({ x: x, y: y, label: label, key: key })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("text", {
                className: "x-label",
                key: key,
                y: y,
                x: x
            }, label));
    }
    get xTickData() {
        const { margins: margins, xScale: xScale, width: width, height: height } = this.props;
        const formatTime = xScale.tickFormat();
        const y = height - margins.bottom + $2ba0ca0b374e98f9$var$X_TICK_PADDING_TOP;
        return xScale.ticks($2ba0ca0b374e98f9$var$X_TICK_COUNT).filter((val)=>{
            const x = xScale(val);
            // Don't render labels that will be cut off
            return x > margins.left && x < width - margins.right;
        }).map((val)=>{
            const x = xScale(val);
            const label = formatTime(val);
            const key = `${label}-${x}-${y}`;
            return {
                label: label,
                x: x,
                y: y,
                key: key
            };
        });
    }
    get yTickData() {
        const { width: width, margins: margins, yScale: yScale } = this.props;
        return yScale.ticks($2ba0ca0b374e98f9$var$Y_TICK_COUNT).map((val)=>{
            const label = val;
            const x1 = margins.left;
            const x2 = margins.left + width;
            const y = margins.top + yScale(val);
            const key = `${label}-${x1}-${x2}-${y}`;
            return {
                label: label,
                x1: x1,
                x2: x2,
                y: y,
                key: key
            };
        });
    }
}
var $2ba0ca0b374e98f9$export$2e2bcd8739ae039 = $2ba0ca0b374e98f9$var$HistogramChartAxes;



var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");

const $42673dc8054eca79$export$94fddb23dc92d9f8 = (elementId)=>{
    // Other SVG elements are often referenced in SVG attributes like `clip-path`
    // and `mask` using a url, e.g.
    //
    //     <rect clip-path="url(#some-svg-element-id") ... />
    //
    // Chronograf supports a [`--basepath`][0] option that rewrites all instances
    // of `url(` occuring in asset files as they are served, which breaks usages
    // of `url(#...)` strings in SVG elements. This issue has been fixed for
    // standalone SVG files by [#3402][1], but not for inline SVG elements (i.e.
    // those rendered by components). This workaround renders `url(#...)` strings
    // dynamically on the client to evade the server asset rewriting.
    //
    // [0]: https://docs.influxdata.com/chronograf/v1.6/administration/config-options/#chronograf-service-options
    // [1]: https://github.com/influxdata/chronograf/pull/3402
    const leftParen = String.fromCharCode(40);
    return `url${leftParen}#${elementId})`;
};



var $dPK2y = parcelRequire("dPK2y");

const $fb9227b661b4dffd$var$DEFAULT_COLOR_VALUE = (0, $17fe399301a568db$export$6cbcd37aa6bd16b6).star;
const $fb9227b661b4dffd$export$cbbaf6b8cc77795b = (colorName, severityLevel)=>{
    return (0, $17fe399301a568db$export$6cbcd37aa6bd16b6)[colorName] || (0, $17fe399301a568db$export$6cbcd37aa6bd16b6)[(0, $17fe399301a568db$export$55a84d26829aa31)[severityLevel]] || $fb9227b661b4dffd$var$DEFAULT_COLOR_VALUE;
};
const $fb9227b661b4dffd$export$f87c7144914326df = (factor, value)=>{
    const colorValue = (0, $dPK2y.default)(value);
    if (colorValue) return colorValue.brighter(factor).hex();
    return $fb9227b661b4dffd$var$DEFAULT_COLOR_VALUE;
};


const $250557b33b10eb9e$var$BAR_BORDER_RADIUS = 3;
const $250557b33b10eb9e$var$BAR_PADDING_SIDES = 4;
const $250557b33b10eb9e$var$HOVER_BRIGTHEN_FACTOR = 0.4;
const $250557b33b10eb9e$var$TOOLTIP_HORIZONTAL_MARGIN = 5;
const $250557b33b10eb9e$var$TOOLTIP_REFLECT_DIST = 100;
const $250557b33b10eb9e$var$getBarWidth = ({ data: data, xScale: xScale, width: width })=>{
    const dataInView = data.filter((d)=>xScale(d.time) >= 0 && xScale(d.time) <= width);
    const barCount = Object.values((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).groupBy(dataInView, 'time')).length;
    return Math.round(width / barCount - $250557b33b10eb9e$var$BAR_PADDING_SIDES);
};
const $250557b33b10eb9e$var$getBarGroups = ({ data: data, width: width, xScale: xScale, yScale: yScale, colorScale: colorScale, hoverData: hoverData, colors: colors, sortBarGroups: sortBarGroups })=>{
    const barWidth = $250557b33b10eb9e$var$getBarWidth({
        data: data,
        xScale: xScale,
        width: width
    });
    const visibleData = data.filter((d)=>d.value !== 0);
    const timeGroups = Object.values((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).groupBy(visibleData, 'time'));
    for (const timeGroup of timeGroups)timeGroup.sort(sortBarGroups);
    let hoverDataKeys = [];
    if (hoverData) hoverDataKeys = hoverData.data.map((h)=>h.key);
    return timeGroups.map((timeGroup)=>{
        const time = timeGroup[0].time;
        const x = xScale(time) - barWidth / 2;
        const total = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).sumBy(timeGroup, 'value');
        const barGroup = {
            key: `${time}-${total}-${x}`,
            clip: {
                x: x,
                y: yScale(total),
                width: barWidth,
                height: yScale(0) - yScale(total) + $250557b33b10eb9e$var$BAR_BORDER_RADIUS
            },
            bars: [],
            data: timeGroup
        };
        let offset = 0;
        timeGroup.forEach((d)=>{
            const height = yScale(0) - yScale(d.value);
            const k = hoverDataKeys.includes(d.key) ? $250557b33b10eb9e$var$HOVER_BRIGTHEN_FACTOR : 0;
            const groupColor = colors.find((c)=>c.group === d.group);
            const scaledColor = colorScale((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(groupColor, 'color', ''), d.group);
            const fill = (0, $fb9227b661b4dffd$export$f87c7144914326df)(k, scaledColor);
            barGroup.bars.push({
                key: d.key,
                group: d.group,
                x: x,
                y: yScale(d.value) - offset,
                width: barWidth,
                height: height,
                fill: fill
            });
            offset += height;
        });
        return barGroup;
    });
};
class $250557b33b10eb9e$var$HistogramChartBars extends (0, $NdCUR.PureComponent) {
    static getDerivedStateFromProps(props) {
        return {
            barGroups: $250557b33b10eb9e$var$getBarGroups(props)
        };
    }
    constructor(props){
        super(props), this.handleBarClick = (data)=>()=>{
                const { onBarClick: onBarClick } = this.props;
                if (onBarClick) {
                    const time = data[0].time;
                    onBarClick(time);
                }
            }, this.handleMouseOver = (e)=>{
            const groupKey = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(e, 'currentTarget.dataset.key', '');
            if (!groupKey) return;
            const { barGroups: barGroups } = this.state;
            const hoverGroup = barGroups.find((d)=>d.key === groupKey);
            if (!hoverGroup) return;
            const data = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(hoverGroup, 'data').reverse();
            const barGroup = e.currentTarget;
            const boundingRect = barGroup.getBoundingClientRect();
            const boundingRectHeight = boundingRect.bottom - boundingRect.top;
            const y = boundingRect.top + boundingRectHeight / 2;
            let x = boundingRect.right + $250557b33b10eb9e$var$TOOLTIP_HORIZONTAL_MARGIN;
            let anchor = 'left';
            // This makes an assumption that the component is within the viewport
            if (x >= window.innerWidth - $250557b33b10eb9e$var$TOOLTIP_REFLECT_DIST) {
                x = window.innerWidth - boundingRect.left + $250557b33b10eb9e$var$TOOLTIP_HORIZONTAL_MARGIN;
                anchor = 'right';
            }
            this.props.onHover({
                data: data,
                x: x,
                y: y,
                anchor: anchor
            });
        }, this.handleMouseOut = ()=>{
            this.props.onHover(null);
        };
        this.state = {
            barGroups: []
        };
    }
    render() {
        const { barGroups: barGroups } = this.state;
        return barGroups.map((group)=>{
            const { key: key, clip: clip, bars: bars } = group;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("g", {
                key: key,
                className: "histogram-chart-bars--bars",
                "data-key": key,
                onMouseOver: this.handleMouseOver,
                onMouseOut: this.handleMouseOut,
                onClick: this.handleBarClick(group.data)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("clipPath", {
                id: `histogram-chart-bars--clip-${key}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("rect", {
                x: clip.x,
                y: clip.y,
                width: clip.width,
                height: clip.height,
                rx: $250557b33b10eb9e$var$BAR_BORDER_RADIUS,
                ry: $250557b33b10eb9e$var$BAR_BORDER_RADIUS
            }))), bars.map((d)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("rect", {
                    key: d.key,
                    className: "histogram-chart-bars--bar",
                    x: d.x,
                    y: d.y,
                    width: d.width,
                    height: d.height,
                    fill: d.fill,
                    clipPath: (0, $42673dc8054eca79$export$94fddb23dc92d9f8)(`histogram-chart-bars--clip-${key}`),
                    "data-group": d.group,
                    "data-key": d.key
                })));
        });
    }
}
var $250557b33b10eb9e$export$2e2bcd8739ae039 = $250557b33b10eb9e$var$HistogramChartBars;



var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");
const $23bc867440203030$var$HistogramChartTooltip = (props)=>{
    const { colorScale: colorScale, colors: colors } = props;
    const { data: data, x: x, y: y, anchor: anchor = 'left' } = props.data;
    const tooltipStyle = {
        position: 'fixed',
        top: y
    };
    if (anchor === 'left') tooltipStyle.left = x;
    else tooltipStyle.right = x;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "histogram-chart-tooltip",
        style: tooltipStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "histogram-chart-tooltip--column"
    }, data.map((d)=>{
        const groupColor = colors.find((c)=>c.group === d.group);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            key: d.key,
            style: {
                color: colorScale((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(groupColor, 'color', ''), d.group)
            }
        }, d.value);
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "histogram-chart-tooltip--column"
    }, data.map((d)=>{
        const groupColor = colors.find((c)=>c.group === d.group);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            key: d.key,
            style: {
                color: colorScale((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(groupColor, 'color', ''), d.group)
            }
        }, d.group);
    })));
};
var $23bc867440203030$export$2e2bcd8739ae039 = $23bc867440203030$var$HistogramChartTooltip;



var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");
const $dc1dfe704fc82a6b$var$NUM_TICKS = 5;
const $dc1dfe704fc82a6b$var$HistogramChartSkeleton = (props)=>{
    const { margins: margins, width: width, height: height } = props;
    const spacing = (height - margins.top - margins.bottom) / $dc1dfe704fc82a6b$var$NUM_TICKS;
    const y1 = height - margins.bottom;
    const tickYs = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).range(0, $dc1dfe704fc82a6b$var$NUM_TICKS).map((i)=>y1 - i * spacing);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("svg", {
        className: "histogram-chart-skeleton",
        width: width,
        height: height
    }, tickYs.map((y, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("line", {
            key: i,
            className: "y-tick",
            x1: margins.left,
            x2: width - margins.right,
            y1: y,
            y2: y
        })));
};
var $dc1dfe704fc82a6b$export$2e2bcd8739ae039 = $dc1dfe704fc82a6b$var$HistogramChartSkeleton;


function $88b90c62acd29beb$export$2e2bcd8739ae039(collection, keyFn) {
    let min = Infinity;
    let max = -Infinity;
    let minItem;
    let maxItem;
    if (collection.length === 0) return collection;
    for (const item of collection){
        const val = keyFn(item);
        if (val <= min) {
            min = val;
            minItem = item;
        }
        if (val >= max) {
            max = val;
            maxItem = item;
        }
    }
    return [
        minItem,
        maxItem
    ];
}



const $500e4bf25e7bc866$var$PADDING_TOP = 0.2;
// Rather than use these magical constants, we could also render a digit and
// capture its measured width with as state before rendering anything else.
// Doing so would be robust but overkill.
const $500e4bf25e7bc866$var$DIGIT_WIDTH = 7;
const $500e4bf25e7bc866$var$PERIOD_DIGIT_WIDTH = 4;
class $500e4bf25e7bc866$var$HistogramChart extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleHover = (hoverData)=>{
            this.setState({
                hoverData: hoverData
            });
        };
        this.state = {};
    }
    render() {
        const { width: width, height: height, data: data, colorScale: colorScale, colors: colors, onBarClick: onBarClick, sortBarGroups: sortBarGroups, children: children } = this.props;
        const { margins: margins } = this;
        if (width === 0 || height === 0) return null;
        if (!data.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dc1dfe704fc82a6b$export$2e2bcd8739ae039), {
            width: width,
            height: height,
            margins: margins
        });
        const { hoverData: hoverData } = this.state;
        const { xScale: xScale, yScale: yScale, adjustedWidth: adjustedWidth, adjustedHeight: adjustedHeight, bodyTransform: bodyTransform } = this;
        const renderPropArgs = {
            xScale: xScale,
            yScale: yScale,
            adjustedWidth: adjustedWidth,
            adjustedHeight: adjustedHeight,
            margins: margins
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "histogram-chart"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("svg", {
            width: width,
            height: height,
            className: "histogram-chart"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("clipPath", {
            id: "histogram-chart--bars-clip"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("rect", {
            x: "0",
            y: "0",
            width: adjustedWidth,
            height: adjustedHeight
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("g", {
            className: "histogram-chart--axes"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $2ba0ca0b374e98f9$export$2e2bcd8739ae039), {
            width: width,
            height: height,
            margins: margins,
            xScale: xScale,
            yScale: yScale
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("g", {
            transform: bodyTransform,
            className: "histogram-chart--bars",
            clipPath: (0, $42673dc8054eca79$export$94fddb23dc92d9f8)('histogram-chart--bars-clip')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $250557b33b10eb9e$export$2e2bcd8739ae039), {
            width: adjustedWidth,
            height: adjustedHeight,
            data: data,
            xScale: xScale,
            yScale: yScale,
            colorScale: colorScale,
            hoverData: hoverData,
            onHover: this.handleHover,
            colors: colors,
            onBarClick: onBarClick,
            sortBarGroups: sortBarGroups
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "histogram-chart--overlays"
        }, !!children && children(renderPropArgs), hoverData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $23bc867440203030$export$2e2bcd8739ae039), {
            data: hoverData,
            colorScale: colorScale,
            colors: colors
        })));
    }
    get xScale() {
        const { adjustedWidth: adjustedWidth } = this;
        const { data: data } = this.props;
        const [t0, t1] = (0, $88b90c62acd29beb$export$2e2bcd8739ae039)(data, (d)=>d.time);
        return (0, $765c04f742ece3b5$export$2e2bcd8739ae039)().domain([
            new Date(t0.time),
            new Date(t1.time)
        ]).range([
            0,
            adjustedWidth
        ]);
    }
    get yScale() {
        const { adjustedHeight: adjustedHeight, maxAggregateCount: maxAggregateCount } = this;
        return (0, $ccf8ada068c66f81$export$2e2bcd8739ae039)().domain([
            0,
            maxAggregateCount + $500e4bf25e7bc866$var$PADDING_TOP * maxAggregateCount
        ]).range([
            adjustedHeight,
            0
        ]);
    }
    get adjustedWidth() {
        const { margins: margins } = this;
        return this.props.width - margins.left - margins.right;
    }
    get adjustedHeight() {
        const { margins: margins } = this;
        return this.props.height - margins.top - margins.bottom;
    }
    get bodyTransform() {
        const { margins: margins } = this;
        return `translate(${margins.left}, ${margins.top})`;
    }
    get margins() {
        const { maxAggregateCount: maxAggregateCount } = this;
        const domainTop = maxAggregateCount + $500e4bf25e7bc866$var$PADDING_TOP * maxAggregateCount;
        const left = domainTop.toString().length * $500e4bf25e7bc866$var$DIGIT_WIDTH + $500e4bf25e7bc866$var$PERIOD_DIGIT_WIDTH;
        return {
            top: 5,
            right: 0,
            bottom: 20,
            left: left
        };
    }
    get maxAggregateCount() {
        const { data: data } = this.props;
        if (!data.length) return 0;
        const groups = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).groupBy(data, 'time');
        const counts = Object.values(groups).map((group)=>group.reduce((sum, current)=>sum + current.value, 0));
        return Math.max(...counts);
    }
}
var $500e4bf25e7bc866$export$2e2bcd8739ae039 = $500e4bf25e7bc866$var$HistogramChart;



var $NdCUR = parcelRequire("NdCUR");
class $32f60005892e8c21$var$LogsGraphContainer extends (0, $NdCUR.PureComponent) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "logs-viewer--graph-container"
        }, this.props.children);
    }
}
var $32f60005892e8c21$export$2e2bcd8739ae039 = $32f60005892e8c21$var$LogsGraphContainer;



var $NdCUR = parcelRequire("NdCUR");


class $173793fa9d366c6c$var$TimeWindowDropdown extends (0, $NdCUR.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ca4f14339173643c$export$2e2bcd8739ae039), {
            className: "dropdown-120",
            selected: this.selected,
            onChoose: this.handleChoose,
            buttonSize: "btn-sm",
            buttonColor: "btn-default",
            items: (0, $17fe399301a568db$export$d06a86d34e567220)
        });
    }
    get selected() {
        const { selectedTimeWindow: { timeOption: timeOption, windowOption: windowOption } } = this.props;
        if (timeOption === 'now') return `Past ${windowOption}`;
        return `${windowOption} Window`;
    }
    constructor(...args){
        super(...args), this.handleChoose = (dropdownItem)=>{
            const { onSetTimeWindow: onSetTimeWindow } = this.props;
            const { text: text, seconds: seconds } = dropdownItem;
            onSetTimeWindow({
                seconds: seconds,
                windowOption: text
            });
        };
    }
}
var $173793fa9d366c6c$export$2e2bcd8739ae039 = $173793fa9d366c6c$var$TimeWindowDropdown;



var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");




var $NdCUR = parcelRequire("NdCUR");

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");





class $b90f7e07ce65f30f$var$ColorDropdown extends (0, $NdCUR.Component) {
    static{
        this.defaultProps = {
            stretchToFit: false,
            disabled: false
        };
    }
    constructor(props){
        super(props), this.handleToggleMenu = ()=>{
            const { disabled: disabled } = this.props;
            if (disabled) return;
            this.setState({
                expanded: !this.state.expanded
            });
        }, this.handleClickOutside = ()=>{
            this.setState({
                expanded: false
            });
        }, this.handleColorClick = (e)=>{
            const target = e.target;
            const hex = target.dataset.tagValue || target.parentElement.dataset.tagValue;
            const nameString = target.dataset.tagKey || target.parentElement.dataset.tagKey;
            const name = (0, $17fe399301a568db$export$4882b5974b950793)[nameString];
            const color = {
                name: name,
                hex: hex
            };
            this.props.onChoose(this.props.severityLevel, color);
            this.setState({
                expanded: false
            });
        };
        this.state = {
            expanded: false
        };
    }
    render() {
        const { expanded: expanded } = this.state;
        const { selected: selected } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1f11d3536bc98f8a$export$c16e4f034c84cb3f), {
            onClickOutside: this.handleClickOutside
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.dropdownClassNames
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.buttonClassNames,
            onClick: this.handleToggleMenu
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "color-dropdown--swatch",
            style: {
                backgroundColor: selected.hex
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "color-dropdown--name"
        }, selected.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "caret"
        })), expanded && this.renderMenu));
    }
    get dropdownClassNames() {
        const { stretchToFit: stretchToFit } = this.props;
        const { expanded: expanded } = this.state;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('color-dropdown', {
            open: expanded,
            'color-dropdown--stretch': stretchToFit
        });
    }
    get buttonClassNames() {
        const { disabled: disabled } = this.props;
        const { expanded: expanded } = this.state;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('btn btn-sm btn-default color-dropdown--toggle', {
            active: expanded,
            'color-dropdown__disabled': disabled
        });
    }
    get renderMenu() {
        const { selected: selected } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "color-dropdown--menu"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), {
            autoHide: false,
            autoHeight: true,
            maxHeight: (0, $e10a8602f56394e3$export$bd1588cc2d72fbf)
        }, (0, $17fe399301a568db$export$64b7befa177cf511).map((color, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('color-dropdown--item', {
                    active: color.name === selected.name
                }),
                "data-tag-key": color.name,
                "data-tag-value": color.hex,
                key: i,
                onClick: this.handleColorClick,
                title: color.name
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
                className: "color-dropdown--swatch",
                style: {
                    backgroundColor: color.hex
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
                className: "color-dropdown--name"
            }, color.name)))));
    }
}
var $b90f7e07ce65f30f$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($b90f7e07ce65f30f$var$ColorDropdown);


// Libraries

var $NdCUR = parcelRequire("NdCUR");



class $336cd2a7f2bb9ca2$var$SeverityColumnFormat extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props);
    }
    render() {
        const { format: format, onChangeFormat: onChangeFormat } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "graph-options-group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            className: "form-label"
        }, "Severity Format"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039), {
            shape: (0, $918c9f03a35fe03f$export$ce765fb8bb08a599).StretchToFit
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039).Button, {
            active: format === (0, $17fe399301a568db$export$85ce1201a2cc2824).dot,
            id: "severity-format-option--dot",
            value: (0, $17fe399301a568db$export$85ce1201a2cc2824).dot,
            onClick: onChangeFormat,
            titleText: "Show only a dot in the severity column"
        }, "Dot"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039).Button, {
            active: format === (0, $17fe399301a568db$export$85ce1201a2cc2824).dotText,
            id: "severity-format-option--dot-text",
            value: (0, $17fe399301a568db$export$85ce1201a2cc2824).dotText,
            onClick: onChangeFormat,
            titleText: "Show both a dot and the severity name in the severity column"
        }, "Dot + Text"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039).Button, {
            active: format === (0, $17fe399301a568db$export$85ce1201a2cc2824).text,
            id: "severity-format-option--text",
            value: (0, $17fe399301a568db$export$85ce1201a2cc2824).text,
            onClick: onChangeFormat,
            titleText: "Show only the severity name in the severity column"
        }, "Text")));
    }
}
var $336cd2a7f2bb9ca2$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($336cd2a7f2bb9ca2$var$SeverityColumnFormat);



const $44a14e1fd111d2f9$var$SeverityConfig = ({ severityLevelColors: severityLevelColors, onReset: onReset, onChangeSeverityLevel: onChangeSeverityLevel, severityFormat: severityFormat, onChangeSeverityFormat: onChangeSeverityFormat })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
        className: "form-label"
    }, "Severity Colors"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-options--color-list"
    }, severityLevelColors.map((lc, i)=>{
        const color = {
            name: lc.color,
            hex: (0, $17fe399301a568db$export$6cbcd37aa6bd16b6)[lc.color]
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            key: i,
            className: "logs-options--color-row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "logs-options--color-column"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "logs-options--color-label"
        }, lc.level)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "logs-options--color-column"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b90f7e07ce65f30f$export$2e2bcd8739ae039), {
            selected: color,
            onChoose: onChangeSeverityLevel,
            stretchToFit: true,
            severityLevel: lc.level
        })));
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
        className: "btn btn-sm btn-default btn-block",
        onClick: onReset
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        className: "icon refresh"
    }), "Reset to Defaults"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $336cd2a7f2bb9ca2$export$2e2bcd8739ae039), {
        format: severityFormat,
        onChangeFormat: onChangeSeverityFormat
    }));
var $44a14e1fd111d2f9$export$2e2bcd8739ae039 = $44a14e1fd111d2f9$var$SeverityConfig;



var $NdCUR = parcelRequire("NdCUR");



var $NdCUR = parcelRequire("NdCUR");

var $g2wso = parcelRequire("g2wso");


const $f0f0d0132656c81e$var$columnType = 'column';
const $f0f0d0132656c81e$var$columnSource = {
    beginDrag (props) {
        return {
            id: props.id,
            index: props.index
        };
    }
};
const $f0f0d0132656c81e$var$columnTarget = {
    hover (props, monitor, component) {
        const dragIndex = monitor.getItem().index;
        const hoverIndex = props.index;
        // Don't replace items with themselves
        if (dragIndex === hoverIndex) return;
        // Determine rectangle on screen
        const domNode = (0, $g2wso.findDOMNode)(component);
        const hoverBoundingRect = domNode.getBoundingClientRect();
        // Get vertical middle
        const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
        // Determine mouse position
        const clientOffset = monitor.getClientOffset();
        // Get pixels to the top
        const hoverClientY = clientOffset.y - hoverBoundingRect.top;
        // Only perform the move when the mouse has crossed half of the items height
        // When dragging downwards, only move when the cursor is below 50%
        // When dragging upwards, only move when the cursor is above 50%
        // Dragging downwards
        if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) return;
        // Dragging upwards
        if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) return;
        // Time to actually perform the action
        props.onMoveColumn(dragIndex, hoverIndex);
        // Note: we're mutating the monitor item here!
        // Generally it's better to avoid mutations,
        // but it's good here for the sake of performance
        // to avoid expensive index searches.
        monitor.getItem().index = hoverIndex;
    }
};
function $f0f0d0132656c81e$var$ColumnDropTarget(dropColumnType, dropColumnTarget, dropHandler) {
    return (target)=>(0, $db9eac57989e0572$exports.DropTarget)(dropColumnType, dropColumnTarget, dropHandler)(target);
}
function $f0f0d0132656c81e$var$ColumnDragSource(dragColumnType, dragColumnSource, dragHandler) {
    return (target)=>(0, $db9eac57989e0572$exports.DragSource)(dragColumnType, dragColumnSource, dragHandler)(target);
}
class $f0f0d0132656c81e$var$DraggableColumn extends (0, $NdCUR.Component) {
    constructor(props){
        super(props), this.handleColumnRename = (e)=>{
            const { onUpdateColumn: onUpdateColumn, internalName: internalName, visible: visible } = this.props;
            onUpdateColumn({
                internalName: internalName,
                displayName: e.target.value,
                visible: visible
            });
        }, this.handleToggleVisible = ()=>{
            const { onUpdateColumn: onUpdateColumn, internalName: internalName, displayName: displayName, visible: visible } = this.props;
            onUpdateColumn({
                internalName: internalName,
                displayName: displayName,
                visible: !visible
            });
        };
        this.handleColumnRename = this.handleColumnRename.bind(this);
        this.handleToggleVisible = this.handleToggleVisible.bind(this);
    }
    render() {
        const { internalName: internalName, displayName: displayName, connectDragPreview: connectDragPreview, connectDropTarget: connectDropTarget, visible: visible } = this.props;
        return connectDragPreview(connectDropTarget(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.columnClassName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.labelClassName
        }, this.dragHandle, this.visibilityToggle, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "customizable-field--name"
        }, internalName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control input-sm customizable-field--input",
            type: "text",
            spellCheck: false,
            id: "internalName",
            value: displayName,
            onChange: this.handleColumnRename,
            placeholder: `Rename ${internalName}`,
            disabled: !visible
        }))));
    }
    get dragHandle() {
        const { connectDragSource: connectDragSource } = this.props;
        return connectDragSource(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "customizable-field--drag"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "hamburger"
        })));
    }
    get visibilityToggle() {
        const { visible: visible, internalName: internalName } = this.props;
        if (visible) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "customizable-field--visibility",
            onClick: this.handleToggleVisible,
            title: `Click to HIDE ${internalName}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon eye-open"
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "customizable-field--visibility",
            onClick: this.handleToggleVisible,
            title: `Click to SHOW ${internalName}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon eye-closed"
        }));
    }
    get labelClassName() {
        const { visible: visible } = this.props;
        if (visible) return 'customizable-field--label';
        return 'customizable-field--label__hidden';
    }
    get columnClassName() {
        const { isDragging: isDragging } = this.props;
        if (isDragging) return 'customizable-field dragging';
        return 'customizable-field';
    }
}
var $f0f0d0132656c81e$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($f0f0d0132656c81e$var$ColumnDropTarget($f0f0d0132656c81e$var$columnType, $f0f0d0132656c81e$var$columnTarget, (connect)=>({
        connectDropTarget: connect.dropTarget()
    }))($f0f0d0132656c81e$var$ColumnDragSource($f0f0d0132656c81e$var$columnType, $f0f0d0132656c81e$var$columnSource, (connect, monitor)=>({
        connectDragSource: connect.dragSource(),
        connectDragPreview: connect.dragPreview(),
        isDragging: monitor.isDragging()
    }))($f0f0d0132656c81e$var$DraggableColumn)));


class $04935137648e6405$var$ColumnsOptions extends (0, $NdCUR.Component) {
    render() {
        const { columns: columns } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            className: "form-label"
        }, "Table Columns"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "logs-options--columns"
        }, columns.map((c, i)=>this.getDraggableColumn(c, i))));
    }
    getDraggableColumn(column, i) {
        const { onMoveColumn: onMoveColumn, onUpdateColumn: onUpdateColumn } = this.props;
        if (column.internalName !== 'time') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $f0f0d0132656c81e$export$2e2bcd8739ae039), {
            key: column.internalName,
            index: i,
            id: column.internalName,
            internalName: column.internalName,
            displayName: column.displayName,
            visible: column.visible,
            onUpdateColumn: onUpdateColumn,
            onMoveColumn: onMoveColumn
        });
    }
}
var $04935137648e6405$export$2e2bcd8739ae039 = (0, $db9eac57989e0572$exports.DragDropContext)((0, (/*@__PURE__*/$parcel$interopDefault($3d979c1ec0f4ae95$exports))))($04935137648e6405$var$ColumnsOptions);




class $ce5ad5c9f942faa7$var$OptionsOverlay extends (0, $NdCUR.Component) {
    constructor(props){
        super(props), this.handleSave = async ()=>{
            const { onUpdate: onUpdate, onDismissOverlay: onDismissOverlay } = this.props;
            const { workingLevelColumns: workingLevelColumns, workingFormat: workingFormat, workingColumns: workingColumns } = this.state;
            await onUpdate(workingLevelColumns, workingFormat, workingColumns);
            onDismissOverlay();
        }, this.handleResetSeverityLevels = ()=>{
            const defaults = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).map((0, $17fe399301a568db$export$55a84d26829aa31), (color, level)=>{
                return {
                    level: (0, $17fe399301a568db$export$4f069e5a50708cd4)[level],
                    color: color
                };
            });
            this.setState({
                workingLevelColumns: defaults
            });
        }, this.handleChangeSeverityLevel = (severityLevel, override)=>{
            const workingLevelColumns = this.state.workingLevelColumns.map((config)=>{
                if (config.level === severityLevel) return {
                    ...config,
                    color: override.name
                };
                return config;
            });
            this.setState({
                workingLevelColumns: workingLevelColumns
            });
        }, this.handleChangeSeverityFormat = (format)=>{
            this.setState({
                workingFormat: format
            });
        }, this.handleMoveColumn = (dragIndex, hoverIndex)=>{
            const { workingColumns: workingColumns } = this.state;
            const draggedField = workingColumns[dragIndex];
            const columnsRemoved = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).concat((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).slice(workingColumns, 0, dragIndex), (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).slice(workingColumns, dragIndex + 1));
            const columnsAdded = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).concat((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).slice(columnsRemoved, 0, hoverIndex), [
                draggedField
            ], (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).slice(columnsRemoved, hoverIndex));
            this.setState({
                workingColumns: columnsAdded
            });
        }, this.handleUpdateColumn = (column)=>{
            const workingColumns = this.state.workingColumns.map((wc)=>{
                if (wc.internalName === column.internalName) return column;
                return wc;
            });
            this.setState({
                workingColumns: workingColumns
            });
        };
        this.state = {
            workingLevelColumns: this.props.severityLevelColors,
            workingColumns: this.props.columns,
            workingFormat: this.props.severityFormat
        };
    }
    shouldComponentUpdate(__, nextState) {
        const isColorsDifferent = !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEqual(nextState.workingLevelColumns, this.state.workingLevelColumns);
        const isFormatDifferent = !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEqual(nextState.workingFormat, this.state.workingFormat);
        const isColumnsDifferent = !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEqual(nextState.workingColumns, this.state.workingColumns);
        if (isColorsDifferent || isFormatDifferent || isColumnsDifferent) return true;
        return false;
    }
    render() {
        const { workingLevelColumns: workingLevelColumns, workingColumns: workingColumns, workingFormat: workingFormat } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1868bdace58643df$export$2e2bcd8739ae039), {
            maxWidth: 800
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1372e03f76900c5b$export$2e2bcd8739ae039), {
            title: "Configure Log Viewer"
        }, this.overlayActionButtons), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1e8c886c7914a527$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "col-sm-5"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $44a14e1fd111d2f9$export$2e2bcd8739ae039), {
            severityLevelColors: workingLevelColumns,
            onReset: this.handleResetSeverityLevels,
            onChangeSeverityLevel: this.handleChangeSeverityLevel,
            severityFormat: workingFormat,
            onChangeSeverityFormat: this.handleChangeSeverityFormat
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "col-sm-7"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $04935137648e6405$export$2e2bcd8739ae039), {
            columns: workingColumns,
            onMoveColumn: this.handleMoveColumn,
            onUpdateColumn: this.handleUpdateColumn
        })))));
    }
    get overlayActionButtons() {
        const { onDismissOverlay: onDismissOverlay } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "btn-group--right"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-sm btn-default",
            onClick: onDismissOverlay
        }, "Cancel"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-sm btn-success",
            onClick: this.handleSave,
            disabled: this.isSaveDisabled
        }, "Save"));
    }
    get isSaveDisabled() {
        const { workingLevelColumns: workingLevelColumns, workingColumns: workingColumns, workingFormat: workingFormat } = this.state;
        const { severityLevelColors: severityLevelColors, columns: columns, severityFormat: severityFormat } = this.props;
        const severityChanged = !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEqual(workingLevelColumns, severityLevelColors);
        const columnsChanged = !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEqual(workingColumns, columns);
        const formatChanged = !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEqual(workingFormat, severityFormat);
        if (severityChanged || columnsChanged || formatChanged) return false;
        return true;
    }
}
var $ce5ad5c9f942faa7$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($ce5ad5c9f942faa7$var$OptionsOverlay);



var $NdCUR = parcelRequire("NdCUR");


var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");

var $axd2S = parcelRequire("axd2S");

var $f625ea6286d97954$export$2e2bcd8739ae039 = [
    {
        text: 'now',
        value: 0
    },
    {
        text: '1m ago',
        value: 60
    },
    {
        text: '5m ago',
        value: 300
    },
    {
        text: '10m ago',
        value: 600
    },
    {
        text: '30m ago',
        value: 1800
    },
    {
        text: '1h ago',
        value: 3600
    },
    {
        text: '3h ago',
        value: 10800
    }
];






var $NdCUR = parcelRequire("NdCUR");



class $6dd0f1b520efd90f$var$CustomSingularTime extends (0, $NdCUR.Component) {
    constructor(props){
        super(props), this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createRef(), this.inputRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createRef(), this.handleRefreshCalendar = ()=>{
            if (this.calendar) this.calendar.refresh();
        }, this.handleClick = ()=>{
            const date = this.calendar.getDate();
            if (date) {
                const time = date.toISOString();
                this.props.onSelected(time);
            }
            if (this.props.onClose) this.props.onClose();
        };
        this.state = {
            time: props.time
        };
    }
    componentDidMount() {
        const { time: time, timeInterval: timeInterval } = this.props;
        this.calendar = (0, (/*@__PURE__*/$parcel$interopDefault($e3fe4930b4cc098f$exports)))(this.inputRef.current, {
            appendTo: this.containerRef.current,
            initialValue: (0, $1e96af9f52ee26c2$export$b40fc491ceb69c4e)(time),
            autoClose: false,
            autoHideOnBlur: false,
            autoHideOnClick: false,
            timeInterval: timeInterval
        });
        this.calendar.show();
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "custom-time-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "custom-time--wrap"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "custom-time--dates"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "custom-time--lower-container",
            ref: this.containerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            ref: this.inputRef,
            className: "custom-time--lower form-control input-sm",
            onKeyUp: this.handleRefreshCalendar
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            style: {
                marginTop: '10px'
            },
            className: "custom-time--apply btn btn-sm btn-primary",
            onClick: this.handleClick
        }, "Apply")));
    }
}
var $6dd0f1b520efd90f$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($6dd0f1b520efd90f$var$CustomSingularTime);


const $229d354ab66b20db$var$dateFormat = 'YYYY-MM-DD HH:mm';
const $229d354ab66b20db$var$format = (t)=>(0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(t.replace(/\'/g, '')).format($229d354ab66b20db$var$dateFormat);
class $229d354ab66b20db$var$TimeRangeDropdown extends (0, $NdCUR.Component) {
    constructor(props){
        super(props), this.handleCustomSelection = (time)=>{
            this.handleCloseCustomTime();
            this.props.onChooseCustomTime(time);
            this.setState({
                isOpen: false
            });
        }, this.handleSelection = (e)=>{
            e.preventDefault();
            const { dataset: dataset } = e.target;
            this.props.onChooseRelativeTime(+dataset.value);
            this.setState({
                isOpen: false
            });
        }, this.handleClickOutside = ()=>{
            this.setState({
                isOpen: false
            });
        }, this.toggleMenu = ()=>{
            this.setState({
                isOpen: !this.state.isOpen
            });
        }, this.handleCloseCustomTime = ()=>{
            this.setState({
                isTimeSelectorOpen: false
            });
        }, this.handleOpenCustomTime = ()=>{
            this.setState({
                isTimeSelectorOpen: true
            });
        };
        this.state = {
            isOpen: false,
            isTimeSelectorOpen: false
        };
    }
    render() {
        const { isTimeSelectorOpen: isTimeSelectorOpen } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1f11d3536bc98f8a$export$c16e4f034c84cb3f), {
            onClickOutside: this.handleClickOutside
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "time-range-dropdown logs-viewer--search-dropdown",
            style: {
                display: 'inline'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.dropdownClassName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "btn btn-sm btn-default dropdown-toggle",
            onClick: this.toggleMenu
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon clock"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "dropdown-selected"
        }, this.timeInputValue), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "caret"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("ul", {
            className: "dropdown-menu"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), {
            autoHide: false,
            autoHeight: true,
            maxHeight: (0, $e10a8602f56394e3$export$bd1588cc2d72fbf)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("li", {
            className: "dropdown-header"
        }, "Absolute Time"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("li", {
            className: isTimeSelectorOpen ? 'active dropdown-item custom-timerange' : 'dropdown-item custom-timerange'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("a", {
            href: "#",
            onClick: this.handleOpenCustomTime
        }, "Date Picker"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("li", {
            className: "dropdown-header"
        }, "Relative Time"), (0, $f625ea6286d97954$export$2e2bcd8739ae039).map((point)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("li", {
                className: "dropdown-item",
                key: `pot-${point.value}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("a", {
                href: "#",
                onClick: this.handleSelection,
                "data-value": point.value
            }, point.text));
        })))), isTimeSelectorOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1f11d3536bc98f8a$export$c16e4f034c84cb3f), {
            onClickOutside: this.handleCloseCustomTime
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "custom-time--overlay"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $6dd0f1b520efd90f$export$2e2bcd8739ae039), {
            onSelected: this.handleCustomSelection,
            time: this.props.customTime
        }))) : null));
    }
    get dropdownClassName() {
        const { isOpen: isOpen } = this.state;
        const absoluteTimeRange = !!this.props.customTime;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('dropdown', {
            'dropdown-180': absoluteTimeRange,
            'dropdown-110': !absoluteTimeRange,
            open: isOpen
        });
    }
    get timeInputValue() {
        if (!this.props.customTime) {
            const point = (0, $f625ea6286d97954$export$2e2bcd8739ae039).find((p)=>p.value === this.props.relativeTime);
            if (point) return point.text;
            return 'now';
        }
        return $229d354ab66b20db$var$format(this.props.customTime);
    }
}
var $229d354ab66b20db$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($229d354ab66b20db$var$TimeRangeDropdown);


class $91a0846051d28fe9$var$LogsSearchBar extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleSearch = ()=>{
            this.props.onSearch(this.state.searchTerm);
            this.setState({
                searchTerm: ''
            });
        }, this.handleInputKeyDown = (e)=>{
            if (e.key === 'Enter') return this.handleSearch();
        }, this.handleChange = (e)=>{
            this.setState({
                searchTerm: e.target.value
            });
        };
        this.state = {
            searchTerm: ''
        };
    }
    render() {
        const { searchTerm: searchTerm } = this.state;
        const { customTime: customTime, relativeTime: relativeTime, onChooseCustomTime: onChooseCustomTime, onChooseRelativeTime: onChooseRelativeTime } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "logs-viewer--search-bar"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "logs-viewer--search-input"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $86817c9e53a28f66$export$2e2bcd8739ae039), {
            icon: (0, $918c9f03a35fe03f$export$62c9c0cf752cde38).Search,
            placeholder: "Search logs using keywords or regular expressions...",
            onChange: this.handleChange,
            onKeyDown: this.handleInputKeyDown,
            value: searchTerm
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $229d354ab66b20db$export$2e2bcd8739ae039), {
            customTime: customTime,
            relativeTime: relativeTime,
            onChooseCustomTime: onChooseCustomTime,
            onChooseRelativeTime: onChooseRelativeTime
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
            text: "Search",
            color: (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Primary,
            onClick: this.handleSearch
        }));
    }
}
var $91a0846051d28fe9$export$2e2bcd8739ae039 = $91a0846051d28fe9$var$LogsSearchBar;



var $NdCUR = parcelRequire("NdCUR");

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");


class $57234ccc59040c9f$var$LogsFilter extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleClickOutside = ()=>{
            this.stopEditing();
        }, this.handleStartEdit = ()=>{
            this.setState({
                editing: true
            });
        }, this.handleDelete = ()=>{
            const id = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(this.props, 'filter.id', '');
            this.props.onDelete(id);
        }, this.handleOperatorInput = (e)=>{
            const operator = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(e, 'target.value', '').trim();
            this.setState({
                operator: operator
            });
        }, this.handleValueInput = (e)=>{
            const value = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(e, 'target.value', '').trim();
            this.setState({
                value: value
            });
        }, this.handleKeyDown = (e)=>{
            if (e.key === 'Enter') {
                e.preventDefault();
                this.stopEditing();
            }
        };
        this.state = {
            editing: false,
            value: this.props.filter.value,
            operator: this.props.filter.operator
        };
    }
    render() {
        const { editing: editing } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1f11d3536bc98f8a$export$c16e4f034c84cb3f), {
            onClickOutside: this.handleClickOutside
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: this.className,
            onClick: this.handleStartEdit
        }, editing ? this.renderEditor : this.label, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "logs-viewer--filter-remove",
            onClick: this.handleDelete
        })));
    }
    get className() {
        const { editing: editing } = this.state;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('logs-viewer--filter', {
            active: editing
        });
    }
    get label() {
        const { filter: { key: key, operator: operator, value: value } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", null, `${key} ${operator} ${value}`);
    }
    get renderEditor() {
        const { operator: operator, value: value } = this.state;
        const { filter: { key: key } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null, key), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            type: "text",
            maxLength: 2,
            value: operator,
            className: "form-control monotype input-xs logs-viewer--operator",
            spellCheck: false,
            onChange: this.handleOperatorInput,
            onKeyDown: this.handleKeyDown
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            type: "text",
            value: value,
            className: "form-control monotype input-xs logs-viewer--value",
            spellCheck: false,
            autoFocus: true,
            onChange: this.handleValueInput,
            onKeyDown: this.handleKeyDown
        }));
    }
    stopEditing() {
        const id = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(this.props, 'filter.id', '');
        const { operator: operator, value: value, editing: editing } = this.state;
        const { filter: filter } = this.props;
        if (!editing) return;
        if (filter.operator === operator && filter.value === value) return this.setState({
            editing: false
        });
        let state = {};
        if ([
            '!=',
            '==',
            '=~',
            '!~'
        ].includes(operator) && value !== '') this.props.onChangeFilter(id, operator, value);
        else state = {
            operator: filter.operator,
            value: filter.value
        };
        this.setState({
            ...state,
            editing: false
        });
    }
}
var $57234ccc59040c9f$export$2e2bcd8739ae039 = $57234ccc59040c9f$var$LogsFilter;



class $950dfe92aacd1856$var$LogsFilters extends (0, $NdCUR.PureComponent) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "logs-viewer--filter-bar"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "logs-viewer--filters"
        }, this.renderFilters), this.clearFiltersButton, this.truncationToggle);
    }
    get clearFiltersButton() {
        const { filters: filters, onClearFilters: onClearFilters } = this.props;
        if (filters.length >= 3) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "logs-viewer--clear-filters"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
            size: (0, $918c9f03a35fe03f$export$fafce5c139da9687).Small,
            text: "Clear Filters",
            onClick: onClearFilters
        }));
    }
    get truncationToggle() {
        const { isTruncated: isTruncated, onUpdateTruncation: onUpdateTruncation, isHistogramHidden: isHistogramHidden, onShowHistogram: onShowHistogram } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "page-header--right"
        }, isHistogramHidden ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-sm btn-square btn-default",
            onClick: onShowHistogram,
            title: "Show Histogram"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon bar-chart"
        })) : undefined, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039).Button, {
            id: "logs-truncation--truncate",
            active: isTruncated === true,
            value: true,
            titleText: "Truncate log messages when they exceed 1 line",
            onClick: onUpdateTruncation
        }, "Truncate"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039).Button, {
            id: "logs-truncation--multi",
            active: isTruncated === false,
            value: false,
            titleText: "Allow log messages to wrap text",
            onClick: onUpdateTruncation
        }, "Wrap")));
    }
    get renderFilters() {
        const { filters: filters } = this.props;
        return filters.map((filter)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $57234ccc59040c9f$export$2e2bcd8739ae039), {
                key: filter.id,
                filter: filter,
                onDelete: this.props.onDelete,
                onChangeFilter: this.props.onFilterChange
            }));
    }
}
var $950dfe92aacd1856$export$2e2bcd8739ae039 = $950dfe92aacd1856$var$LogsFilters;



var $hBdgJ = parcelRequire("hBdgJ");

var $axd2S = parcelRequire("axd2S");

var $1v7mg = parcelRequire("1v7mg");

var $NdCUR = parcelRequire("NdCUR");


// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $g2wso = parcelRequire("g2wso");

var $NdCUR = parcelRequire("NdCUR");
var $167b65a9268a02a9$exports = {};
"use strict";
var $e67b2ae93bced11c$exports = {};
"use strict";
Object.defineProperty($e67b2ae93bced11c$exports, "__esModule", {
    value: true
});
$e67b2ae93bced11c$exports.CopyToClipboard = void 0;

var $e67b2ae93bced11c$var$_react = $e67b2ae93bced11c$var$_interopRequireDefault((parcelRequire("NdCUR")));

var $e67b2ae93bced11c$var$_copyToClipboard = $e67b2ae93bced11c$var$_interopRequireDefault((parcelRequire("8G5JO")));
function $e67b2ae93bced11c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $e67b2ae93bced11c$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $e67b2ae93bced11c$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $e67b2ae93bced11c$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $e67b2ae93bced11c$var$_typeof(obj);
}
function $e67b2ae93bced11c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e67b2ae93bced11c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $e67b2ae93bced11c$var$ownKeys(source, true).forEach(function(key) {
            $e67b2ae93bced11c$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $e67b2ae93bced11c$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e67b2ae93bced11c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e67b2ae93bced11c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e67b2ae93bced11c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $e67b2ae93bced11c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e67b2ae93bced11c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $e67b2ae93bced11c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e67b2ae93bced11c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e67b2ae93bced11c$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $e67b2ae93bced11c$var$_possibleConstructorReturn(self, call) {
    if (call && ($e67b2ae93bced11c$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $e67b2ae93bced11c$var$_assertThisInitialized(self);
}
function $e67b2ae93bced11c$var$_getPrototypeOf(o) {
    $e67b2ae93bced11c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e67b2ae93bced11c$var$_getPrototypeOf(o);
}
function $e67b2ae93bced11c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $e67b2ae93bced11c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $e67b2ae93bced11c$var$_setPrototypeOf(subClass, superClass);
}
function $e67b2ae93bced11c$var$_setPrototypeOf(o, p) {
    $e67b2ae93bced11c$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e67b2ae93bced11c$var$_setPrototypeOf(o, p);
}
function $e67b2ae93bced11c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $e67b2ae93bced11c$var$CopyToClipboard = /*#__PURE__*/ function(_React$PureComponent) {
    $e67b2ae93bced11c$var$_inherits(CopyToClipboard, _React$PureComponent);
    function CopyToClipboard() {
        var _getPrototypeOf2;
        var _this;
        $e67b2ae93bced11c$var$_classCallCheck(this, CopyToClipboard);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $e67b2ae93bced11c$var$_possibleConstructorReturn(this, (_getPrototypeOf2 = $e67b2ae93bced11c$var$_getPrototypeOf(CopyToClipboard)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        $e67b2ae93bced11c$var$_defineProperty($e67b2ae93bced11c$var$_assertThisInitialized(_this), "onClick", function(event) {
            var _this$props = _this.props, text = _this$props.text, onCopy = _this$props.onCopy, children = _this$props.children, options = _this$props.options;
            var elem = $e67b2ae93bced11c$var$_react["default"].Children.only(children);
            var result = (0, $e67b2ae93bced11c$var$_copyToClipboard["default"])(text, options);
            if (onCopy) onCopy(text, result);
             // Bypass onClick if it was present
            if (elem && elem.props && typeof elem.props.onClick === 'function') elem.props.onClick(event);
        });
        return _this;
    }
    $e67b2ae93bced11c$var$_createClass(CopyToClipboard, [
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, _text = _this$props2.text, _onCopy = _this$props2.onCopy, _options = _this$props2.options, children = _this$props2.children, props = $e67b2ae93bced11c$var$_objectWithoutProperties(_this$props2, [
                    "text",
                    "onCopy",
                    "options",
                    "children"
                ]);
                var elem = $e67b2ae93bced11c$var$_react["default"].Children.only(children);
                return $e67b2ae93bced11c$var$_react["default"].cloneElement(elem, $e67b2ae93bced11c$var$_objectSpread({}, props, {
                    onClick: this.onClick
                }));
            }
        }
    ]);
    return CopyToClipboard;
}($e67b2ae93bced11c$var$_react["default"].PureComponent);
$e67b2ae93bced11c$exports.CopyToClipboard = $e67b2ae93bced11c$var$CopyToClipboard;
$e67b2ae93bced11c$var$_defineProperty($e67b2ae93bced11c$var$CopyToClipboard, "defaultProps", {
    onCopy: undefined,
    options: undefined
});


var $167b65a9268a02a9$var$CopyToClipboard = $e67b2ae93bced11c$exports.CopyToClipboard;
$167b65a9268a02a9$var$CopyToClipboard.CopyToClipboard = $167b65a9268a02a9$var$CopyToClipboard;
$167b65a9268a02a9$exports = $167b65a9268a02a9$var$CopyToClipboard;





const $23c74a7180d16f67$export$52dfc803f7616eea = (pattern, text)=>{
    if (!pattern) return [
        $23c74a7180d16f67$var$createSection((0, $d241d8e181bfcafe$export$44087f2a0e4739a3).NONE, text)
    ];
    const regexp = new RegExp(pattern);
    return $23c74a7180d16f67$var$matchSections(regexp, text);
};
const $23c74a7180d16f67$var$matchSections = (re, text)=>{
    const sections = [];
    let remaining = text;
    for(let match = remaining.match(re); match !== null; match = remaining.match(re)){
        remaining = match[match.length - 1];
        sections.push($23c74a7180d16f67$var$createSection((0, $d241d8e181bfcafe$export$44087f2a0e4739a3).NONE, match[1]), $23c74a7180d16f67$var$createSection((0, $d241d8e181bfcafe$export$44087f2a0e4739a3).MATCH, match[2]));
    }
    sections.push($23c74a7180d16f67$var$createSection((0, $d241d8e181bfcafe$export$44087f2a0e4739a3).NONE, remaining));
    return sections;
};
const $23c74a7180d16f67$var$createSection = (type, text)=>({
        id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
        type: type,
        text: text
    });
const $23c74a7180d16f67$export$5f0a5c263a2834aa = (filters)=>{
    if (filters.length === 0) return null;
    const values = filters.map((f)=>f.value).join('|');
    return `^(.*?)(${values})(.*)`;
};
const $23c74a7180d16f67$export$ac1ed0a530ed60db = (filters)=>filters.filter($23c74a7180d16f67$var$isValidMessageFilter);
const $23c74a7180d16f67$var$isValidMessageFilter = (f)=>$23c74a7180d16f67$var$isMessage(f.key) && $23c74a7180d16f67$var$isLikeOp(f.operator) && $23c74a7180d16f67$var$isValidRegExp(f.value);
const $23c74a7180d16f67$var$isMessage = (key)=>key === 'message';
const $23c74a7180d16f67$var$isLikeOp = (op)=>op === (0, $d241d8e181bfcafe$export$fa5f90bfb4dbdbcd).LIKE;
const $23c74a7180d16f67$var$isValidRegExp = (value)=>{
    try {
        RegExp(value);
        return true;
    } catch (error) {
        return false;
    }
};



class $0084d3e976473c6e$var$LogsMessage extends (0, $NdCUR.PureComponent) {
    render() {
        const { formattedValue: formattedValue } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "logs-message"
        }, this.messageSections, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($167b65a9268a02a9$exports))), {
            text: formattedValue,
            onCopy: this.handleCopyAttempt
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
            size: (0, $918c9f03a35fe03f$export$fafce5c139da9687).ExtraSmall,
            color: (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Primary,
            customClass: "logs-message--copy",
            titleText: "copy to clipboard",
            icon: (0, $918c9f03a35fe03f$export$62c9c0cf752cde38).Duplicate,
            text: "Copy",
            onClick: this.handleClickCopy
        })));
    }
    get messageSections() {
        const { searchPattern: searchPattern, formattedValue: formattedValue } = this.props;
        if (!searchPattern) return formattedValue;
        const sections = (0, $23c74a7180d16f67$export$52dfc803f7616eea)(searchPattern, formattedValue);
        return sections.map((s)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
                key: s.id,
                className: `logs-message--${s.type}`
            }, s.text));
    }
    handleClickCopy(e) {
        e.stopPropagation();
        e.preventDefault();
    }
    constructor(...args){
        super(...args), this.handleCopyAttempt = (copiedText, isSuccessful)=>{
            const { notify: notify } = this.props;
            const text = copiedText.slice(0, 20).trimRight();
            const truncatedText = `${text}...`;
            const title = 'Log message ';
            if (isSuccessful) notify((0, $ec1f42de4faacc37$export$9744b69e3922044f)(truncatedText, title));
            else notify((0, $ec1f42de4faacc37$export$6a59b8139549a56)(truncatedText, title));
        };
    }
}
var $0084d3e976473c6e$export$2e2bcd8739ae039 = $0084d3e976473c6e$var$LogsMessage;


// Libraries

var $NdCUR = parcelRequire("NdCUR");



var $d947215d17ea0ed9$var$PinnedState = /*#__PURE__*/ function(PinnedState) {
    PinnedState["Left"] = "PinnedLeft";
    PinnedState["Right"] = "PinnedRight";
    PinnedState["Center"] = "PinnedCenter";
    PinnedState["OnMessage"] = "PinnedOnMessage";
    return PinnedState;
}($d947215d17ea0ed9$var$PinnedState || {});
class $d947215d17ea0ed9$var$ExpandedContainer extends (0, $NdCUR.Component) {
    constructor(props){
        super(props), this.handleClickDismiss = (e)=>{
            e.stopPropagation();
            this.props.onClose();
        }, this.handleScrollbarScroll = (e)=>{
            e.stopPropagation();
            e.preventDefault();
            const { scrollTop: scrollTop } = e.currentTarget;
            this.setState({
                scrollTop: scrollTop
            });
        }, this.handleClickOutside = ()=>{
            this.props.onClose();
        };
        this.state = {
            scrollTop: 0
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1f11d3536bc98f8a$export$c16e4f034c84cb3f), {
            onClickOutside: this.handleClickOutside
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "expanded--message message-wrap",
            style: this.style
        }, this.closeExpansionButton, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), {
            setScrollTop: this.handleScrollbarScroll,
            scrollTop: this.state.scrollTop,
            autoHeight: true,
            maxHeight: this.maxHeight
        }, this.props.children)));
    }
    get maxHeight() {
        return this.props.maxHeight - this.verticalPadding;
    }
    get verticalPadding() {
        return this.props.padding * 2;
    }
    get style() {
        return {
            ...this.position,
            top: this.props.top,
            width: this.width,
            padding: this.props.padding,
            maxHeight: this.props.maxHeight
        };
    }
    get position() {
        switch(this.pinnedState){
            case "PinnedLeft":
                return {
                    left: this.props.minLeft
                };
            case "PinnedRight":
                return {
                    left: this.props.minLeft + this.props.scrollMargin
                };
            case "PinnedCenter":
                return {
                    left: this.props.minLeft
                };
            case "PinnedOnMessage":
                return {
                    left: this.props.left
                };
        }
    }
    get width() {
        switch(this.pinnedState){
            case "PinnedLeft":
            case "PinnedRight":
                return this.props.maxWidth - this.props.scrollMargin - this.props.padding;
            case "PinnedCenter":
                return this.props.maxWidth - this.props.padding;
            case "PinnedOnMessage":
                return this.props.width;
        }
    }
    get pinnedState() {
        const isLeftOutOfView = this.props.left < this.props.minLeft;
        const isRightOfView = this.props.width + this.props.left - this.props.minLeft > this.props.maxWidth;
        if (isLeftOutOfView && isRightOfView) return "PinnedCenter";
        else if (!isLeftOutOfView && !isRightOfView) return "PinnedOnMessage";
        else if (!isRightOfView) return "PinnedLeft";
        else if (!isLeftOutOfView) return "PinnedRight";
    }
    get closeExpansionButton() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "expanded--dismiss",
            onClick: this.handleClickDismiss
        });
    }
}
var $d947215d17ea0ed9$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($d947215d17ea0ed9$var$ExpandedContainer);



const $bdfd57a2de2f635d$var$PADDING = 8;
const $bdfd57a2de2f635d$var$MIN_LEFT = 120;
const $bdfd57a2de2f635d$var$MIN_MESSAGE_WIDTH = 200;
const $bdfd57a2de2f635d$var$MAX_MESSAGE_HEIGHT = 200;
const $bdfd57a2de2f635d$var$SCROLL_MARGIN = 80;
class $bdfd57a2de2f635d$var$ExpandableMessage extends (0, $NdCUR.Component) {
    constructor(props){
        super(props), this.handleClick = ()=>{
            const { expanded: expanded } = this.state;
            const { onExpand: onExpand } = this.props;
            if (!expanded && onExpand) onExpand();
            this.setState({
                expanded: true
            });
        }, this.handleClose = ()=>{
            this.setState({
                expanded: false
            });
        };
        this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createRef();
        this.state = {
            expanded: false
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            onClick: this.handleClick,
            className: "expandable--message",
            ref: this.containerRef
        }, this.message, this.expandedMessage);
    }
    /* eslint-disable @typescript-eslint/no-base-to-string */ get message() {
        const { notify: notify, searchPattern: searchPattern, formattedValue: formattedValue } = this.props;
        const valueString = `${formattedValue}`;
        const trimmedValue = valueString.trimLeft();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $0084d3e976473c6e$export$2e2bcd8739ae039), {
            formattedValue: trimmedValue,
            notify: notify,
            searchPattern: searchPattern
        });
    }
    get expandedMessage() {
        const { expanded: expanded } = this.state;
        if (!expanded || !this.containerRef.current) return null;
        const portalElement = document.getElementById('expanded-message-container');
        const containerRect = this.containerRef.current.getBoundingClientRect();
        const { top: top, left: left, width: width } = containerRect;
        const message = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $d947215d17ea0ed9$export$2e2bcd8739ae039), {
            notify: this.props.notify,
            onClose: this.handleClose,
            scrollMargin: $bdfd57a2de2f635d$var$SCROLL_MARGIN,
            maxWidth: this.props.maxWidth,
            minWidth: $bdfd57a2de2f635d$var$MIN_MESSAGE_WIDTH,
            maxHeight: $bdfd57a2de2f635d$var$MAX_MESSAGE_HEIGHT,
            padding: $bdfd57a2de2f635d$var$PADDING,
            top: top,
            left: left,
            minLeft: $bdfd57a2de2f635d$var$MIN_LEFT,
            width: width
        }, this.message);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g2wso))).createPortal(message, portalElement);
    }
}
var $bdfd57a2de2f635d$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($bdfd57a2de2f635d$var$ExpandableMessage);




var $NdCUR = parcelRequire("NdCUR");


class $199d8bba9c804ca3$var$LoadingStatus extends (0, $NdCUR.PureComponent) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "logs-viewer--table-container generic-empty-state"
        }, this.loadingSpinner, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", null, this.loadingMessage, " ", this.description));
    }
    get description() {
        switch(this.props.status){
            case (0, $d241d8e181bfcafe$export$ca480a6cbcd8239).NoResults:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, "Try changing the ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("strong", null, "Time Range"), " or", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("strong", null, "Removing Filters"));
            case (0, $d241d8e181bfcafe$export$ca480a6cbcd8239).MeasurementMissing:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, "Try changing the selected ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("strong", null, "Database"), " or", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("strong", null, "Source"));
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, this.timeBounds);
        }
    }
    get loadingSpinner() {
        switch(this.props.status){
            case (0, $d241d8e181bfcafe$export$ca480a6cbcd8239).NoResults:
            case (0, $d241d8e181bfcafe$export$ca480a6cbcd8239).MeasurementMissing:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                    className: "logs-viewer--search-graphic"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                    className: "logs-viewer--graphic-empty"
                }));
            case (0, $d241d8e181bfcafe$export$ca480a6cbcd8239).UpdatingFilters:
            case (0, $d241d8e181bfcafe$export$ca480a6cbcd8239).UpdatingTimeBounds:
            case (0, $d241d8e181bfcafe$export$ca480a6cbcd8239).UpdatingSource:
            case (0, $d241d8e181bfcafe$export$ca480a6cbcd8239).UpdatingNamespace:
            case (0, $d241d8e181bfcafe$export$ca480a6cbcd8239).Loading:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                    className: "logs-viewer--search-graphic"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                    className: "logs-viewer--graphic-log"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                    className: "logs-viewer--graphic-magnifier-a"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                    className: "logs-viewer--graphic-magnifier-b"
                })));
            default:
                return null;
        }
    }
    get timeBounds() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "logs-viewer--searching-time"
        }, "from ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("strong", null, (0, $39ae7dd6f6a41115$export$3203edd9e5edd663)(this.props.upper)), " to", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("strong", null, (0, $39ae7dd6f6a41115$export$3203edd9e5edd663)(this.props.lower)));
    }
    get loadingMessage() {
        switch(this.props.status){
            case (0, $d241d8e181bfcafe$export$ca480a6cbcd8239).UpdatingFilters:
                return 'Updating search filters...';
            case (0, $d241d8e181bfcafe$export$ca480a6cbcd8239).NoResults:
                return 'No logs found';
            case (0, $d241d8e181bfcafe$export$ca480a6cbcd8239).UpdatingTimeBounds:
                return 'Searching time bounds...';
            case (0, $d241d8e181bfcafe$export$ca480a6cbcd8239).UpdatingSource:
                return 'Searching updated source...';
            case (0, $d241d8e181bfcafe$export$ca480a6cbcd8239).UpdatingNamespace:
                return 'Searching updated namespace...';
            case (0, $d241d8e181bfcafe$export$ca480a6cbcd8239).MeasurementMissing:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, "The selected database does not have a ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("strong", null, "syslog"), ' ', "measurement...", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("br", null));
            case (0, $d241d8e181bfcafe$export$ca480a6cbcd8239).Loading:
            default:
                return 'Searching...';
        }
    }
}
var $199d8bba9c804ca3$export$2e2bcd8739ae039 = $199d8bba9c804ca3$var$LoadingStatus;





var $hBdgJ = parcelRequire("hBdgJ");

var $axd2S = parcelRequire("axd2S");



const $609fe1a5ad4907b6$export$88e6c5bab2ff80e8 = 18;
const $609fe1a5ad4907b6$var$CHAR_WIDTH = 9;
const $609fe1a5ad4907b6$var$DEFAULT_COLUMN_WIDTH = 200;
const $609fe1a5ad4907b6$export$7343029b984a5542 = (data)=>(0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(data, 'values', []);
const $609fe1a5ad4907b6$export$6894ebd31c9dfe01 = (data, row, column)=>(0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(data, `values.${row}.${column}`, '');
const $609fe1a5ad4907b6$export$3f19ad07848df794 = (data)=>(0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(data, 'columns', []);
const $609fe1a5ad4907b6$export$fc0dadda4135d084 = (data, index)=>(0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(data, `columns.${index}`, '');
const $609fe1a5ad4907b6$export$8eed54c26009b0a9 = (column)=>(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).includes([
        'appname',
        'facility',
        'host',
        'hostname',
        'severity',
        'procid'
    ], column);
const $609fe1a5ad4907b6$export$e3f4b4be9cb9e73b = (column, value, charLimit)=>{
    switch(column){
        case 'timestamp':
            return (0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(+value / 1000000).format((0, $17fe399301a568db$export$c4d2eaadfa3c28df));
        case 'procid':
        case 'host':
        case 'hostname':
        case 'appname':
            return $609fe1a5ad4907b6$var$truncateText(value, column);
        case 'message':
            value = (value || 'No Message Provided').replace('\\n', '');
            if (value.indexOf(' ') > charLimit - 5) value = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).truncate(value, {
                length: charLimit - 5
            });
            return value;
    }
    return value;
};
const $609fe1a5ad4907b6$export$38e42c68cf43b5d4 = (key, headerOptions)=>{
    if (key === (0, $17fe399301a568db$export$85ce1201a2cc2824).dot) return '';
    const headerOption = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).find(headerOptions, (h)=>h.internalName === key);
    return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(headerOption, 'displayName') || (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).capitalize(key);
};
const $609fe1a5ad4907b6$var$truncateText = (value, column)=>{
    const columnWidth = $609fe1a5ad4907b6$export$dfa11a34ceba822(column);
    const length = Math.floor(columnWidth / $609fe1a5ad4907b6$var$CHAR_WIDTH) - 2;
    return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).truncate(value || '', {
        length: length
    });
};
const $609fe1a5ad4907b6$export$dfa11a34ceba822 = (column)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get({
        timestamp: 160,
        procid: 80,
        facility: 120,
        severity_dot: 25,
        severity_text: 120,
        severity_dotText: 120,
        host: 300
    }, column, $609fe1a5ad4907b6$var$DEFAULT_COLUMN_WIDTH);
};
const $609fe1a5ad4907b6$export$d161360cbd6bb40f = (currentMessageWidth)=>Math.floor(currentMessageWidth / $609fe1a5ad4907b6$var$CHAR_WIDTH);
const $609fe1a5ad4907b6$export$98f0266d87b6c279 = (index, data, rowCharLimit)=>{
    const columns = $609fe1a5ad4907b6$export$3f19ad07848df794(data);
    const columnIndex = columns.indexOf('message');
    const value = $609fe1a5ad4907b6$export$6894ebd31c9dfe01(data, index, columnIndex);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEmpty(value)) return $609fe1a5ad4907b6$export$88e6c5bab2ff80e8;
    const lines = Math.ceil(value.length / (rowCharLimit * 1.25));
    return Math.max(lines, 1) * $609fe1a5ad4907b6$export$88e6c5bab2ff80e8 + 2;
};
const $609fe1a5ad4907b6$export$bafec8c2bd6c7cb7 = (data, tableColumns, severityFormat)=>{
    const columns = $609fe1a5ad4907b6$export$3f19ad07848df794(data);
    return columns.reduce((acc, col)=>{
        const colConfig = tableColumns.find((c)=>c.internalName === col);
        const isColVisible = colConfig && colConfig.visible;
        if (col === 'message' || col === 'time' || !isColVisible) return acc;
        let columnName = col;
        if (col === 'severity') columnName = `${col}_${severityFormat}`;
        return acc + $609fe1a5ad4907b6$export$dfa11a34ceba822(columnName);
    }, 0);
};
const $609fe1a5ad4907b6$export$942718ef0650e004 = (data, tableColumns, severityFormat)=>{
    const otherColumnsWidth = $609fe1a5ad4907b6$export$bafec8c2bd6c7cb7(data, tableColumns, severityFormat);
    const calculatedWidth = Math.max(window.innerWidth - (otherColumnsWidth + 180), 100 * $609fe1a5ad4907b6$var$CHAR_WIDTH);
    return calculatedWidth - $609fe1a5ad4907b6$var$CHAR_WIDTH;
};
const $609fe1a5ad4907b6$var$MIN_MESSAGE_WIDTH = 99 * $609fe1a5ad4907b6$var$CHAR_WIDTH;
const $609fe1a5ad4907b6$export$3f8d01bbdb29360b = (data, tableColumns, severityFormat)=>{
    const otherColumnsWidth = $609fe1a5ad4907b6$export$bafec8c2bd6c7cb7(data, tableColumns, severityFormat);
    return $609fe1a5ad4907b6$var$MIN_MESSAGE_WIDTH + otherColumnsWidth;
};
const $609fe1a5ad4907b6$export$654b7c76080cc175 = (tableData, tableColumns)=>{
    const columns = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(tableData, 'columns', []);
    const values = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(tableData, 'values', []);
    // #5472 fallback to timestamp when time is not defined
    const timeColumnIndex = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).indexOf(columns, 'time');
    const timestampColumnIndex = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).indexOf(columns, 'timestamp');
    const timestampNsInMsColumnIndex = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).indexOf(columns, (0, $17fe399301a568db$export$5a9d40b22b614c94));
    if (timeColumnIndex >= 0 && timestampColumnIndex >= 0) // modify existing data to save memory
    values.forEach((row)=>{
        if (row[timestampColumnIndex] === null) row[timestampColumnIndex] = row[timeColumnIndex] * 1000000;
        else if (timestampNsInMsColumnIndex >= 0) {
            const ms = Math.floor(row[timestampColumnIndex] / 1000000);
            const ns = String(row[timestampNsInMsColumnIndex]).padStart(6, '0');
            row[timestampColumnIndex] = `${ms}${ns}`;
        }
    });
    const data = [
        columns,
        ...values
    ];
    const filteredData = (0, $182b28bda5c9878f$export$554cd5520b0fdd6b)(data, tableColumns);
    const orderedData = (0, $182b28bda5c9878f$export$1a306919e5294bf2)(filteredData, tableColumns);
    const updatedColumns = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(orderedData, '0', []);
    const updatedValues = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).slice(orderedData, 1);
    return {
        columns: updatedColumns,
        values: updatedValues
    };
};
const $609fe1a5ad4907b6$export$9f9983dcfce9558 = (data)=>{
    return $609fe1a5ad4907b6$var$isEmptyTableData(data.forward) && $609fe1a5ad4907b6$var$isEmptyTableData(data.backward);
};
const $609fe1a5ad4907b6$var$isEmptyTableData = (data)=>{
    return (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(data, 'values.length', 0) === 0;
};
const $609fe1a5ad4907b6$export$3ba2ae9260aa3226 = (timeOption, data, defaultIndex = 0)=>{
    const { forward: forward, backward: backward } = data;
    const selectedTime = new Date(timeOption).valueOf();
    const timeColumn = forward.columns.indexOf('time');
    const tableData = [
        ...forward.values,
        ...backward.values
    ];
    const rowIndex = tableData.findIndex((row)=>row[timeColumn] <= selectedTime);
    if (rowIndex < 0) return defaultIndex;
    return rowIndex;
};






const $e8de79f4abf4f89f$var$calculateScrollTop = (scrollToRow)=>{
    return scrollToRow * (0, $609fe1a5ad4907b6$export$88e6c5bab2ff80e8);
};
class $e8de79f4abf4f89f$var$LogsTable extends (0, $NdCUR.Component) {
    static getDerivedStateFromProps(props, state) {
        const { scrollToRow: scrollToRow, data: data, tableColumns: tableColumns, severityFormat: severityFormat, filters: filters, searchStatus: searchStatus } = props;
        const currentMessageWidth = (0, $609fe1a5ad4907b6$export$942718ef0650e004)(data, tableColumns, severityFormat);
        let scrollTop = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(state, 'scrollTop', 0);
        let scrollLeft = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(state, 'scrollLeft', 0);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isNumber(scrollToRow)) scrollTop = $e8de79f4abf4f89f$var$calculateScrollTop(scrollToRow);
        if (searchStatus === (0, $d241d8e181bfcafe$export$ca480a6cbcd8239).Clearing) scrollLeft = 0;
        let isMessageVisible = false;
        const visibleColumnsCount = props.tableColumns.filter((c)=>{
            if (c.internalName === 'message') isMessageVisible = c.visible;
            return c.visible;
        }).length;
        const validFilters = (0, $23c74a7180d16f67$export$ac1ed0a530ed60db)(filters);
        const searchPattern = (0, $23c74a7180d16f67$export$5f0a5c263a2834aa)(validFilters);
        return {
            ...state,
            searchPattern: searchPattern,
            isQuerying: false,
            scrollTop: scrollTop,
            scrollLeft: scrollLeft,
            currentMessageWidth: currentMessageWidth,
            isMessageVisible: isMessageVisible,
            visibleColumnsCount: visibleColumnsCount,
            scrollToRow: scrollToRow
        };
    }
    constructor(props){
        super(props), this.gridProperties = (width, height, onRowsRendered, columnCount, registerChild)=>{
            this.currentWidth = width;
            const { scrollToRow: scrollToRow } = this.props;
            const { scrollTop: scrollTop, scrollLeft: scrollLeft } = this.state;
            let rowHeight = (0, $609fe1a5ad4907b6$export$88e6c5bab2ff80e8);
            if (!this.props.isTruncated) rowHeight = this.calculateRowHeight;
            const result = {
                width: width,
                height: height,
                rowHeight: rowHeight,
                rowCount: this.rowCount(),
                scrollLeft: scrollLeft,
                scrollTop: scrollTop,
                cellRenderer: this.cellRenderer,
                onSectionRendered: this.handleRowRender(onRowsRendered),
                columnCount: columnCount,
                columnWidth: this.getColumnWidth,
                overscanRowCount: 50,
                ref: (ref)=>{
                    registerChild(ref);
                    this.grid = ref;
                }
            };
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isNumber(scrollToRow)) result.scrollToRow = scrollToRow;
            return result;
        }, this.handleScrollbarScroll = (e)=>{
            e.stopPropagation();
            e.preventDefault();
            const { scrollTop: scrollTop, scrollLeft: scrollLeft } = e.currentTarget;
            this.handleScroll({
                scrollTop: scrollTop,
                scrollLeft: scrollLeft
            });
        }, this.handleScroll = (scrollInfo)=>{
            const { scrollTop: scrollTop, scrollLeft: scrollLeft } = scrollInfo;
            const previousTop = this.state.scrollTop;
            const previousLeft = this.state.scrollLeft;
            if (scrollTop < 200 && scrollTop <= previousTop) this.loadMoreAboveRows();
            if (scrollTop === 0 && previousTop !== 0) this.props.onScrolledToTop();
            else if (scrollTop !== previousTop) this.props.onScrollVertical();
            if (scrollLeft !== previousLeft || scrollTop !== previousTop) this.setState({
                scrollLeft: scrollLeft,
                scrollTop: scrollTop
            });
        }, this.handleRowRender = (onRowsRendered)=>{
            return ({ rowStartIndex: rowStartIndex, rowStopIndex: rowStopIndex })=>{
                onRowsRendered({
                    startIndex: rowStartIndex,
                    stopIndex: rowStopIndex
                });
            };
        }, this.loadMoreAboveRows = async ()=>{
            await this.props.fetchNewer();
        }, this.loadMoreBelowRows = async ()=>{
            await this.props.fetchMore();
        }, this.rowCount = ()=>{
            const data = this.props.tableInfiniteData;
            return (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(data, 'forward.values.length', 0) + (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(data, 'backward.values.length', 0);
        }, this.isRowLoaded = ({ index: index })=>{
            return index < this.rowCount() - 1;
        }, this.handleWindowResize = ()=>{
            this.setState({
                currentMessageWidth: (0, $609fe1a5ad4907b6$export$942718ef0650e004)(this.props.data, this.props.tableColumns, this.props.severityFormat)
            });
        }, this.getColumnWidth = ({ index: index })=>{
            const { severityFormat: severityFormat } = this.props;
            const column = (0, $609fe1a5ad4907b6$export$fc0dadda4135d084)(this.props.data, index);
            const { currentMessageWidth: currentMessageWidth, isMessageVisible: isMessageVisible, visibleColumnsCount: visibleColumnsCount } = this.state;
            switch(column){
                case 'message':
                    return currentMessageWidth;
                default:
                    {
                        let columnKey = column;
                        if (column === 'severity') columnKey = `${column}_${severityFormat}`;
                        const width = (0, $609fe1a5ad4907b6$export$dfa11a34ceba822)(columnKey);
                        if (!isMessageVisible) {
                            const inc = currentMessageWidth / visibleColumnsCount;
                            return width + inc;
                        }
                        return width;
                    }
            }
        }, this.calculateTotalHeight = ()=>{
            const data = (0, $609fe1a5ad4907b6$export$7343029b984a5542)(this.props.data);
            if (this.props.isTruncated) return data.length * (0, $609fe1a5ad4907b6$export$88e6c5bab2ff80e8);
            return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).reduce(data, (acc, __, index)=>{
                return acc + (0, $609fe1a5ad4907b6$export$98f0266d87b6c279)(index, this.props.data, this.rowCharLimit);
            }, 0);
        }, this.calculateRowHeight = ({ index: index })=>{
            return (0, $609fe1a5ad4907b6$export$98f0266d87b6c279)(index, this.props.data, this.rowCharLimit);
        }, this.headerRenderer = ({ key: key, style: style, columnIndex: columnIndex })=>{
            const column = (0, $609fe1a5ad4907b6$export$fc0dadda4135d084)(this.props.data, columnIndex);
            const classes = 'logs-viewer--cell logs-viewer--cell-header';
            let columnKey = column;
            if (column === 'severity') columnKey = this.getSeverityColumn(column);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                className: classes,
                style: style,
                key: key
            }, (0, $609fe1a5ad4907b6$export$38e42c68cf43b5d4)(columnKey, this.props.tableColumns));
        }, /* eslint-disable @typescript-eslint/no-base-to-string */ this.cellRenderer = ({ key: key, style: style, rowIndex: rowIndex, columnIndex: columnIndex })=>{
            const { severityFormat: severityFormat, severityLevelColors: severityLevelColors } = this.props;
            const column = (0, $609fe1a5ad4907b6$export$fc0dadda4135d084)(this.props.data, columnIndex);
            const value = (0, $609fe1a5ad4907b6$export$6894ebd31c9dfe01)(this.props.data, rowIndex, columnIndex);
            let formattedValue;
            const isDotNeeded = severityFormat === (0, $17fe399301a568db$export$85ce1201a2cc2824).dot || severityFormat === (0, $17fe399301a568db$export$85ce1201a2cc2824).dotText;
            let title;
            if (column === 'severity' && isDotNeeded) {
                title = value;
                const colorLevel = severityLevelColors.find((lc)=>lc.level === value) || severityLevelColors[0];
                formattedValue = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                    className: `logs-viewer--dot ${value}-severity`,
                    title: value,
                    "data-index": rowIndex,
                    style: this.severityDotStyle(colorLevel.color, colorLevel.level)
                }), this.getSeverityDotText(value));
            } else {
                formattedValue = (0, $609fe1a5ad4907b6$export$e3f4b4be9cb9e73b)(column, value, this.rowCharLimit);
                title = formattedValue;
            }
            if (column === 'message') formattedValue = this.renderMessage(formattedValue);
            if (column === 'timestamp') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                className: "logs-viewer--cell",
                title: typeof value === 'string' && value.length > 9 ? `Jump to '${formattedValue}.${value.substring(value.length - 9)}' (${value})` : `Jump to '${value}'`,
                key: key,
                style: style,
                "data-index": rowIndex
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                "data-tag-key": column,
                "data-tag-value": value,
                onClick: this.handleTimestampClick(`${formattedValue}`),
                "data-index": rowIndex,
                className: "logs-viewer--clickable"
            }, formattedValue));
            if ((0, $609fe1a5ad4907b6$export$8eed54c26009b0a9)(column)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                className: "logs-viewer--cell",
                title: `Filter by '${title}'`,
                key: key,
                style: style,
                "data-index": rowIndex
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                "data-tag-key": column,
                "data-tag-value": value,
                onClick: this.handleTagClick,
                "data-index": rowIndex,
                className: "logs-viewer--clickable"
            }, formattedValue));
            const wrapMessage = column === 'message' && !this.props.isTruncated;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))(`logs-viewer--cell  ${column}--cell`, {
                    'message-wrap': wrapMessage
                }),
                key: key,
                style: style,
                "data-index": rowIndex
            }, formattedValue);
        }, this.renderMessage = (formattedValue)=>{
            const { notify: notify } = this.props;
            const { searchPattern: searchPattern } = this.state;
            if (this.props.isTruncated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $bdfd57a2de2f635d$export$2e2bcd8739ae039), {
                notify: notify,
                formattedValue: formattedValue,
                onExpand: this.props.onExpandMessage,
                searchPattern: searchPattern,
                maxWidth: this.currentWidth
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $0084d3e976473c6e$export$2e2bcd8739ae039), {
                notify: notify,
                formattedValue: formattedValue,
                searchPattern: searchPattern
            });
        }, this.severityDotStyle = (colorName, level)=>{
            const severityColor = (0, $fb9227b661b4dffd$export$cbbaf6b8cc77795b)(colorName, level);
            const brightSeverityColor = (0, $fb9227b661b4dffd$export$f87c7144914326df)(0.5, severityColor);
            return {
                background: `linear-gradient(45deg, ${severityColor}, ${brightSeverityColor}`
            };
        }, this.handleTimestampClick = (time)=>()=>{
                const { onChooseCustomTime: onChooseCustomTime } = this.props;
                const formattedTime = (0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(time, (0, $17fe399301a568db$export$c4d2eaadfa3c28df)).toISOString();
                onChooseCustomTime(formattedTime);
            }, this.handleTagClick = (e)=>{
            const { onTagSelection: onTagSelection } = this.props;
            const target = e.target;
            const selection = {
                tag: target.dataset.tagValue || target.parentElement.dataset.tagValue,
                key: target.dataset.tagKey || target.parentElement.dataset.tagKey
            };
            onTagSelection(selection);
        };
        this.grid = null;
        this.headerGrid = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createRef();
        let isMessageVisible = false;
        const visibleColumnsCount = props.tableColumns.filter((c)=>{
            if (c.internalName === 'message') isMessageVisible = c.visible;
            return c.visible;
        }).length;
        this.currentWidth = null;
        this.state = {
            searchPattern: null,
            scrollTop: 0,
            scrollLeft: 0,
            currentMessageWidth: 0,
            isMessageVisible: isMessageVisible,
            visibleColumnsCount: visibleColumnsCount
        };
    }
    componentDidUpdate() {
        const { searchStatus: searchStatus } = this.props;
        if (searchStatus === (0, $d241d8e181bfcafe$export$ca480a6cbcd8239).NoResults) return;
        if (this.grid) this.grid.recomputeGridSize();
        if (this.headerGrid.current) this.headerGrid.current.recomputeGridSize();
    }
    componentDidMount() {
        window.addEventListener('resize', this.handleWindowResize);
        if (this.grid) this.grid.recomputeGridSize();
        if (this.headerGrid.current) this.headerGrid.current.recomputeGridSize();
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowResize);
    }
    render() {
        const columnCount = Math.max((0, $609fe1a5ad4907b6$export$3f19ad07848df794)(this.props.data).length, 0);
        if (this.isLoadingTableData) return this.loadingStatus;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "logs-viewer--table-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $9cf5f10972873d72$export$2e2bcd8739ae039), null, ({ width: width })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $df00be2467032761$export$2e2bcd8739ae039), {
                ref: this.headerGrid,
                height: (0, $609fe1a5ad4907b6$export$88e6c5bab2ff80e8),
                rowHeight: (0, $609fe1a5ad4907b6$export$88e6c5bab2ff80e8),
                rowCount: 1,
                width: width,
                scrollLeft: this.state.scrollLeft,
                cellRenderer: this.headerRenderer,
                columnCount: columnCount,
                columnWidth: this.getColumnWidth,
                style: {
                    overflow: 'hidden'
                }
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $9324e56cd5b2aaa8$export$2e2bcd8739ae039), {
            isRowLoaded: this.isRowLoaded,
            loadMoreRows: this.loadMoreBelowRows,
            rowCount: this.rowCount() + (0, $353d602c97200dee$export$ec97e03929c39fe4)
        }, ({ registerChild: registerChild, onRowsRendered: onRowsRendered })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $9cf5f10972873d72$export$2e2bcd8739ae039), null, ({ width: width, height: height })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), {
                    style: {
                        width: width,
                        height: height - (0, $609fe1a5ad4907b6$export$88e6c5bab2ff80e8),
                        marginTop: `${(0, $609fe1a5ad4907b6$export$88e6c5bab2ff80e8)}px`
                    },
                    setScrollTop: this.handleScrollbarScroll,
                    scrollTop: this.state.scrollTop,
                    scrollLeft: this.state.scrollLeft,
                    autoHide: false
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $df00be2467032761$export$2e2bcd8739ae039), {
                    ...this.gridProperties(width, height, onRowsRendered, columnCount, registerChild),
                    style: {
                        height: this.calculateTotalHeight(),
                        width: Math.max(this.minTableWidth, width),
                        overflow: 'hidden'
                    }
                })))), this.scrollLoadingIndicator);
    }
    get rowCharLimit() {
        return (0, $609fe1a5ad4907b6$export$d161360cbd6bb40f)(this.state.currentMessageWidth);
    }
    getSeverityColumn(column) {
        const { severityFormat: severityFormat } = this.props;
        if (severityFormat === (0, $17fe399301a568db$export$85ce1201a2cc2824).dot) return (0, $17fe399301a568db$export$85ce1201a2cc2824).dot;
        return column;
    }
    getSeverityDotText(text) {
        const { severityFormat: severityFormat } = this.props;
        if (severityFormat === (0, $17fe399301a568db$export$85ce1201a2cc2824).dotText) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "logs-viewer--severity-text"
        }, text);
    }
    get loadingStatus() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $199d8bba9c804ca3$export$2e2bcd8739ae039), {
            status: this.props.searchStatus,
            lower: this.props.lower,
            upper: this.props.upper
        });
    }
    get isLoadingTableData() {
        const { searchStatus: searchStatus } = this.props;
        switch(searchStatus){
            case (0, $d241d8e181bfcafe$export$ca480a6cbcd8239).Loaded:
                return false;
            default:
                return true;
        }
    }
    get isLoadingMore() {
        return this.props.queryCount > 0;
    }
    get scrollLoadingIndicator() {
        const className = (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('logs-viewer--scroll-loader', {
            loading: this.isLoadingMore
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: className
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h6", null, "Loading more logs..."));
    }
    get minTableWidth() {
        return (0, $609fe1a5ad4907b6$export$3f8d01bbdb29360b)(this.props.data, this.props.tableColumns, this.props.severityFormat);
    }
}
var $e8de79f4abf4f89f$export$2e2bcd8739ae039 = $e8de79f4abf4f89f$var$LogsTable;




var $NdCUR = parcelRequire("NdCUR");

class $577dac35075877a3$var$HistogramResults extends (0, $NdCUR.PureComponent) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            className: "logs-viewer--results-text"
        }, this.contents);
    }
    get contents() {
        switch(this.props.searchStatus){
            case (0, $d241d8e181bfcafe$export$ca480a6cbcd8239).NoResults:
                return this.noResultsContent;
            case (0, $d241d8e181bfcafe$export$ca480a6cbcd8239).Loaded:
                return this.completedContents;
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, "Updating histogram...");
        }
    }
    get completedContents() {
        const { count: count } = this.props;
        if (count === 0) return this.noResultsContent;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, "Displaying ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("strong", null, " ", count, " events"), " in histogram");
    }
    get noResultsContent() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, "No results in ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("strong", null, this.window));
    }
    get window() {
        const { timeOption: timeOption, windowOption: windowOption } = this.props.selectedTimeWindow;
        if (timeOption === 'now') return `Past ${windowOption}`;
        return `${windowOption} Window`;
    }
}
var $577dac35075877a3$export$2e2bcd8739ae039 = $577dac35075877a3$var$HistogramResults;






var $hBdgJ = parcelRequire("hBdgJ");

const $c79d422e3e25b9be$var$MESSAGE_KEY = 'message';
const $c79d422e3e25b9be$var$APP_NAME = 'appname';
const $c79d422e3e25b9be$export$56e87122f905fac0 = (part, type = (0, $d241d8e181bfcafe$export$1d002fc419589aea).INCLUDE)=>({
        type: type,
        pattern: $c79d422e3e25b9be$var$getPattern(type, part)
    });
const $c79d422e3e25b9be$var$getPattern = (type, phrase)=>{
    const { ATTRIBUTE: ATTRIBUTE, COLON: COLON, EXCLUSION: EXCLUSION } = (0, $d241d8e181bfcafe$export$5ac3d064d508813a);
    const PHRASE = `(${ATTRIBUTE}${COLON})?${phrase}`;
    switch(type){
        case (0, $d241d8e181bfcafe$export$1d002fc419589aea).EXCLUDE:
            return new RegExp(`^${EXCLUSION}${PHRASE}`);
        default:
            return new RegExp(`^${PHRASE}`);
    }
};
const $c79d422e3e25b9be$export$f8407203a7d135fd = [
    $c79d422e3e25b9be$export$56e87122f905fac0((0, $d241d8e181bfcafe$export$5ac3d064d508813a).SINGLE_QUOTED, (0, $d241d8e181bfcafe$export$1d002fc419589aea).EXCLUDE),
    $c79d422e3e25b9be$export$56e87122f905fac0((0, $d241d8e181bfcafe$export$5ac3d064d508813a).DOUBLE_QUOTED, (0, $d241d8e181bfcafe$export$1d002fc419589aea).EXCLUDE),
    $c79d422e3e25b9be$export$56e87122f905fac0((0, $d241d8e181bfcafe$export$5ac3d064d508813a).SINGLE_QUOTED),
    $c79d422e3e25b9be$export$56e87122f905fac0((0, $d241d8e181bfcafe$export$5ac3d064d508813a).DOUBLE_QUOTED),
    $c79d422e3e25b9be$export$56e87122f905fac0((0, $d241d8e181bfcafe$export$5ac3d064d508813a).UNQUOTED_WORD, (0, $d241d8e181bfcafe$export$1d002fc419589aea).EXCLUDE),
    $c79d422e3e25b9be$export$56e87122f905fac0((0, $d241d8e181bfcafe$export$5ac3d064d508813a).UNQUOTED_WORD)
];
const $c79d422e3e25b9be$export$9cf1c2be119e1d9f = (searchTerm)=>{
    const allTerms = $c79d422e3e25b9be$var$extractTerms(searchTerm, $c79d422e3e25b9be$export$f8407203a7d135fd);
    return $c79d422e3e25b9be$var$termsToFilters(allTerms);
};
const $c79d422e3e25b9be$var$termsToFilters = (terms)=>{
    return terms.map((t)=>$c79d422e3e25b9be$var$createAttributeFilter(t.attribute, t.term, $c79d422e3e25b9be$var$termToOp(t)));
};
const $c79d422e3e25b9be$var$extractTerms = (searchTerms, rules)=>{
    let tokens = [];
    let text = searchTerms.trim();
    while(!(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEmpty(text)){
        const { nextTerm: nextTerm, nextText: nextText } = $c79d422e3e25b9be$var$extractNextTerm(text, rules);
        tokens = [
            ...tokens,
            nextTerm
        ];
        text = nextText;
    }
    return tokens;
};
const $c79d422e3e25b9be$var$extractNextTerm = (text, rules)=>{
    const { literal: literal, rule: rule, nextText: nextText, attribute: attribute } = $c79d422e3e25b9be$var$readToken($c79d422e3e25b9be$var$eatSpaces(text), rules);
    const nextTerm = $c79d422e3e25b9be$var$createTerm(rule.type, literal, attribute);
    return {
        nextText: nextText,
        nextTerm: nextTerm
    };
};
const $c79d422e3e25b9be$var$eatSpaces = (text)=>{
    return text.trim();
};
const $c79d422e3e25b9be$var$readToken = (text, rules)=>{
    const rule = rules.find((r)=>text.match(new RegExp(r.pattern)) !== null);
    const term = new RegExp(rule.pattern).exec(text);
    const literal = term[3];
    const attribute = term[2];
    // differs from literal length because of quote and exclusion removal
    const termLength = term[0].length;
    const nextText = text.slice(termLength);
    return {
        literal: literal,
        nextText: nextText,
        rule: rule,
        attribute: attribute
    };
};
const $c79d422e3e25b9be$var$createTerm = (type, term, attribute = $c79d422e3e25b9be$var$MESSAGE_KEY)=>({
        type: type,
        term: term,
        attribute: $c79d422e3e25b9be$export$38a6c237befa10e8(attribute)
    });
const $c79d422e3e25b9be$var$createAttributeFilter = (key, value, operator)=>({
        id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
        key: key,
        value: value,
        operator: operator
    });
const $c79d422e3e25b9be$var$termToOp = (term)=>{
    switch(term.attribute){
        case $c79d422e3e25b9be$var$MESSAGE_KEY:
        case $c79d422e3e25b9be$var$APP_NAME:
            return $c79d422e3e25b9be$var$handleOpExclusion(term, (0, $d241d8e181bfcafe$export$fa5f90bfb4dbdbcd).LIKE, (0, $d241d8e181bfcafe$export$fa5f90bfb4dbdbcd).NOT_LIKE);
        default:
            return $c79d422e3e25b9be$var$handleOpExclusion(term, (0, $d241d8e181bfcafe$export$fa5f90bfb4dbdbcd).EQUAL, (0, $d241d8e181bfcafe$export$fa5f90bfb4dbdbcd).NOT_EQUAL);
    }
};
const $c79d422e3e25b9be$var$handleOpExclusion = (term, inclusion, exclusion)=>{
    switch(term.type){
        case (0, $d241d8e181bfcafe$export$1d002fc419589aea).EXCLUDE:
            return exclusion;
        case (0, $d241d8e181bfcafe$export$1d002fc419589aea).INCLUDE:
            return inclusion;
    }
};
const $c79d422e3e25b9be$export$38a6c237befa10e8 = (name)=>{
    const lowerName = name.toLowerCase();
    switch(lowerName){
        case 'ap':
        case 'app':
        case 'apps':
        case 'application':
        case 'program':
            return $c79d422e3e25b9be$var$APP_NAME;
        default:
            return name;
    }
};


function $255245f673ddf3c1$export$e524544f3a74a6a9(predicate, request) {
    let isCanceled = false;
    const requests = $255245f673ddf3c1$var$fetchUnless(()=>isCanceled || predicate(), request);
    const promise = $255245f673ddf3c1$var$fetchEachAsync(requests);
    const cancel = ()=>{
        isCanceled = true;
    };
    return {
        promise: promise,
        cancel: cancel,
        isCanceled: isCanceled
    };
}
const $255245f673ddf3c1$var$fetchEachAsync = async (requestsIterator)=>{
    for (const response of requestsIterator)await response;
};
function* $255245f673ddf3c1$var$fetchUnless(predicate, request) {
    while(!predicate())yield request();
}


const $b737749ec5f30674$export$b618ddbc18cd41f3 = (request, chunkParams)=>{
    const { getCurrentSize: getCurrentSize, maxFetchCount: maxFetchCount, maxNoChangeFetchCount: maxNoChangeFetchCount, chunkSize: chunkSize } = chunkParams;
    const initialSize = getCurrentSize();
    const fetchCount = $b737749ec5f30674$var$fetchCounter();
    let lastSize = initialSize;
    const isDone = ()=>{
        const size = getCurrentSize();
        const cycle = fetchCount.next().value;
        const isChunkLoaded = size - initialSize >= chunkSize;
        const isCountMaxed = cycle > maxFetchCount;
        if ((cycle + 1) % maxNoChangeFetchCount === 0) {
            if (lastSize - size > 0) lastSize = size;
            return true;
        }
        return isChunkLoaded || isCountMaxed;
    };
    return (0, $255245f673ddf3c1$export$e524544f3a74a6a9)(isDone, request);
};
function* $b737749ec5f30674$var$fetchCounter() {
    let count = 0;
    while(true)yield count++;
}






var $axd2S = parcelRequire("axd2S");

const $12a27e58f249a026$export$cfe8c04a9bb43d0e = (extentTimes, timeOption, seconds)=>{
    const numberTimeOption = new Date(timeOption).valueOf();
    const period = seconds * (0, $17fe399301a568db$export$ac31e7baba4e5d05);
    const [lowerExtent] = extentTimes;
    if (!$12a27e58f249a026$export$784fd2bb162bbbe9(numberTimeOption, extentTimes, period)) return $12a27e58f249a026$var$centerTimeBounds(numberTimeOption, period);
    return $12a27e58f249a026$var$offsetTimeBounds(lowerExtent, numberTimeOption, period);
};
const $12a27e58f249a026$export$784fd2bb162bbbe9 = (numberTimeOption, [t0, t1], period)=>{
    return t1 - t0 < period && t0 <= numberTimeOption && t1 >= numberTimeOption;
};
const $12a27e58f249a026$var$centerTimeBounds = (center, period)=>{
    const halfPeriod = Math.floor(period / 2);
    const lower = (0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(center - halfPeriod).toISOString();
    const upper = (0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(center + halfPeriod).toISOString();
    return {
        lower: lower,
        upper: upper
    };
};
const $12a27e58f249a026$var$offsetTimeBounds = (lowerExtent, numberTimeOption, period)=>{
    const offset = $12a27e58f249a026$var$doubleStepOffset({
        maxOffset: period * (0, $17fe399301a568db$export$d45b825de1ee1bc4),
        center: lowerExtent + period / 2,
        numberTimeOption: numberTimeOption,
        period: period
    });
    const lower = (0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(lowerExtent + offset).toISOString();
    const upper = (0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))(lowerExtent + period + offset).toISOString();
    return {
        lower: lower,
        upper: upper
    };
};
const $12a27e58f249a026$var$doubleStepOffset = ({ numberTimeOption: numberTimeOption, period: period, maxOffset: maxOffset, center: center })=>{
    const x = (numberTimeOption - center) / period;
    if (Math.abs(x) < (0, $17fe399301a568db$export$86e73ff840e5234) / 2) return 0;
    return maxOffset * Math.sign(x);
};










const $05168acb2d31b9e6$var$mapDispatchToProps = {
    getSourceAndPopulateNamespaces: (0, $353d602c97200dee$export$c37c3cb83f304b49),
    getSources: (0, $b73fb830e0a94a1d$export$5f6ba1bbbf575a21),
    setTimeRangeAsync: $353d602c97200dee$export$b36acc1d2d750740,
    setTimeBounds: $353d602c97200dee$export$59f3db1d7df09881,
    setTimeWindow: $353d602c97200dee$export$dc7aee2bcc03083a,
    setTimeMarker: $353d602c97200dee$export$a40b898b9d72fbba,
    setNamespaceAsync: $353d602c97200dee$export$bfb25655fb3b81b,
    executeHistogramQueryAsync: $353d602c97200dee$export$aeb6a841efeb4bd3,
    clearSearchData: $353d602c97200dee$export$8bb077ed816673f7,
    setSearchStatus: $353d602c97200dee$export$f3503bb636498ae7,
    addFilter: $353d602c97200dee$export$ae939118842f3d6d,
    removeFilter: $353d602c97200dee$export$3be5fe9f09d6965,
    changeFilter: $353d602c97200dee$export$347972a19297a2b7,
    clearFilters: $353d602c97200dee$export$d0e6b6bfede2a57,
    fetchOlderChunkAsync: $353d602c97200dee$export$6b2592cc9359df84,
    fetchNewerChunkAsync: $353d602c97200dee$export$9867c3abea3f9c6f,
    fetchTailAsync: $353d602c97200dee$export$d115d6c69a81f80c,
    fetchNamespaceSyslogStatusAsync: $353d602c97200dee$export$a2f59495f078ad22,
    flushTailBuffer: $353d602c97200dee$export$b300bd48a52702ed,
    clearAllTimeBounds: $353d602c97200dee$export$670c18d1c7d2069c,
    setNextTailLowerBound: $353d602c97200dee$export$62b3184be770961e,
    setNextNewerLowerBound: $353d602c97200dee$export$ccab220fcb0bc359,
    setTableCustomTime: (0, $353d602c97200dee$export$e41c4a5ba57a2eda),
    setTableRelativeTime: (0, $353d602c97200dee$export$9597a83095c7014e),
    getConfig: (0, $353d602c97200dee$export$76f9dfcf614176c4),
    updateConfig: (0, $353d602c97200dee$export$a9ca9aca226bcfdb),
    notify: (0, $205d139de2918454$export$5e14cdade93d6f7b),
    populateNamespacesAsync: $353d602c97200dee$export$87caf57dc085f3cb
};
class $05168acb2d31b9e6$var$LogsPage extends (0, $NdCUR.Component) {
    static getDerivedStateFromProps(props) {
        const severityLevelColors = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(props.logConfig, 'severityLevelColors', []);
        const histogramColors = severityLevelColors.map((lc)=>({
                group: lc.level,
                color: lc.color
            }));
        return {
            histogramColors: histogramColors
        };
    }
    constructor(props){
        super(props), this.currentOlderChunksGenerator = null, this.currentNewerChunksGenerator = null, this.loadingSourcesStatus = (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).NotStarted, this.isComponentMounted = true, this.setCurrentSource = async ()=>{
            if (!this.props.currentSource && this.props.sources.length > 0) {
                const source = this.props.sources.find((src)=>{
                    return src.default;
                }) || this.props.sources[0];
                return this.props.getSourceAndPopulateNamespaces(source.id);
            } else if (this.props.currentNamespace) return this.props.populateNamespacesAsync(this.props.currentSource, this.props.currentNamespace);
        }, this.handleExpandMessage = ()=>{
            this.handleVerticalScroll();
        }, this.startLogsTailFetchingInterval = ()=>{
            this.flushTailBuffer();
            this.clearTailInterval();
            if (!this.isComponentMounted) return false;
            this.props.setNextTailLowerBound(Date.now());
            this.interval = window.setInterval(this.handleTailFetchingInterval, (0, $17fe399301a568db$export$6f8f9ddc0aeaa6ed));
            this.setState({
                liveUpdating: true
            });
        }, this.handleTailFetchingInterval = async ()=>{
            if (this.isClearing || !this.isComponentMounted) return;
            this.props.executeHistogramQueryAsync();
            await this.fetchTail();
        }, this.fetchTail = async ()=>{
            if (!this.isComponentMounted) return;
            await this.props.fetchTailAsync();
        }, this.fetchNewerChunk = async ()=>{
            if (!this.isComponentMounted) return;
            const maxNewerFetchForward = Date.now() + (0, $17fe399301a568db$export$dccafea29eb05d53);
            if (this.props.nextNewerLowerBound > maxNewerFetchForward) {
                this.props.setNextNewerLowerBound(Date.now());
                this.currentNewerChunksGenerator.cancel();
            }
            if (!this.isComponentMounted) return;
            await this.props.fetchNewerChunkAsync();
        }, this.totalForwardValues = ()=>{
            return (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(this.props, 'tableInfiniteData.forward.values.length', null);
        }, this.totalBackwardValues = ()=>{
            return (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(this.props, 'tableInfiniteData.backward.values.length', null);
        }, this.fetchOlderChunk = async ()=>{
            if (!this.isComponentMounted) return;
            await this.props.fetchOlderChunkAsync();
        }, this.handleFetchOlderChunk = async ()=>{
            if (!this.isComponentMounted) return;
            if (this.currentOlderChunksGenerator) return;
            await this.startFetchingOlder();
        }, this.handleFetchNewerChunk = async ()=>{
            if (!this.isComponentMounted) return;
            if (this.isLiveUpdating || this.shouldLiveUpdate) return;
            this.setState({
                isLoadingNewer: true
            });
            await this.startFetchingNewer();
        }, this.startFetchingNewer = async ()=>{
            if (!this.isComponentMounted) return;
            if (this.currentNewerChunksGenerator) return;
            const chunkOptions = {
                ...(0, $17fe399301a568db$export$8c3b0a2072972ae8),
                getCurrentSize: this.totalForwardValues
            };
            this.currentNewerChunksGenerator = (0, $b737749ec5f30674$export$b618ddbc18cd41f3)(this.fetchNewerChunk, chunkOptions);
            this.updateQueryCount();
            try {
                await this.currentNewerChunksGenerator.promise;
            } catch (error) {
                console.error(error);
            }
            if (!this.isComponentMounted) return;
            this.setState({
                isLoadingNewer: false
            });
            this.currentNewerChunksGenerator = null;
            this.updateQueryCount();
        }, this.startFetchingOlder = async ()=>{
            const chunkOptions = {
                ...(0, $17fe399301a568db$export$355b6eb3ee30bab9),
                getCurrentSize: this.totalBackwardValues
            };
            if (!this.isComponentMounted) return;
            this.currentOlderChunksGenerator = (0, $b737749ec5f30674$export$b618ddbc18cd41f3)(this.fetchOlderChunk, chunkOptions);
            if (!this.isComponentMounted) return;
            this.updateQueryCount();
            try {
                await this.currentOlderChunksGenerator.promise;
            } catch (error) {
                console.error(error);
            }
            this.currentOlderChunksGenerator = null;
            if (!this.isComponentMounted) return;
            this.updateQueryCount();
        }, this.clearTailInterval = ()=>{
            if (this.interval) {
                clearInterval(this.interval);
                this.interval = null;
            }
        }, this.cancelChunks = async ()=>{
            const cancelPendingChunks = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).compact([
                this.currentNewerChunksGenerator,
                this.currentOlderChunksGenerator
            ]).map((req)=>{
                req.cancel();
                return req.promise;
            });
            await Promise.all(cancelPendingChunks);
            this.currentNewerChunksGenerator = null;
            this.currentOlderChunksGenerator = null;
            if (!this.isComponentMounted) return;
            this.setState({
                queryCount: 0
            });
        }, this.handleChooseCustomTime = async (time)=>{
            this.clearAllTimeBounds();
            this.props.setTableCustomTime(time);
            const liveUpdating = false;
            const customLowerBound = Date.parse(time);
            this.props.setNextNewerLowerBound(customLowerBound);
            if (!this.isComponentMounted) return;
            this.setState({
                hasScrolled: false,
                liveUpdating: liveUpdating
            });
            if (!this.isComponentMounted) return;
            await this.props.setTimeMarker({
                timeOption: time
            });
            this.handleSetTimeBounds();
        }, this.handleChooseRelativeTime = async (time)=>{
            this.clearAllTimeBounds();
            this.props.setTableRelativeTime(time);
            const relativeLowerBound = Date.now() - time * 1000;
            this.props.setNextNewerLowerBound(relativeLowerBound);
            if (!this.isComponentMounted) return;
            this.setState({
                hasScrolled: false
            });
            const timeOptionUTC = new Date(Date.now() - time * 1000).toISOString();
            let timeOption = {
                timeOption: timeOptionUTC
            };
            let liveUpdating = false;
            if (time === (0, $17fe399301a568db$export$ecb408e1f47ed474)) {
                timeOption = {
                    timeOption: 'now'
                };
                liveUpdating = true;
            }
            this.setState({
                liveUpdating: liveUpdating
            });
            await this.props.setTimeMarker(timeOption);
            this.handleSetTimeBounds();
        }, this.handleScrollToTop = ()=>{
            if (!this.isLiveUpdating && this.shouldLiveUpdate) this.startLogsTailFetchingInterval();
        }, this.handleVerticalScroll = ()=>{
            if (!this.isLiveUpdating && this.state.hasScrolled) return;
            if (this.isLiveUpdating) this.clearTailInterval();
            this.setState({
                liveUpdating: false,
                hasScrolled: true
            });
        }, this.handleTagSelection = (selection)=>{
            this.props.addFilter({
                id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
                key: selection.key,
                value: selection.tag,
                operator: '=='
            });
            this.updateTableData((0, $d241d8e181bfcafe$export$ca480a6cbcd8239).UpdatingFilters);
        }, this.handleSortHistogramBarGroups = (a, b)=>{
            return (0, $17fe399301a568db$export$44d8d03845f535a9)[b.group] - (0, $17fe399301a568db$export$44d8d03845f535a9)[a.group];
        }, this.handleChangeLiveUpdatingStatus = async ()=>{
            const { liveUpdating: liveUpdating } = this.state;
            if (liveUpdating === true) {
                this.setState({
                    liveUpdating: false
                });
                this.clearTailInterval();
            } else this.handleChooseRelativeTime((0, $17fe399301a568db$export$ecb408e1f47ed474));
        }, this.handleSubmitSearch = async (value)=>{
            (0, $c79d422e3e25b9be$export$9cf1c2be119e1d9f)(value).reverse().forEach((filter)=>{
                this.props.addFilter(filter);
            });
            this.updateTableData((0, $d241d8e181bfcafe$export$ca480a6cbcd8239).Loading);
        }, this.handleFilterDelete = (id)=>{
            this.props.removeFilter(id);
            this.updateTableData((0, $d241d8e181bfcafe$export$ca480a6cbcd8239).UpdatingFilters);
        }, this.handleFilterChange = async (id, operator, value)=>{
            this.props.changeFilter(id, operator, value);
            this.updateTableData((0, $d241d8e181bfcafe$export$ca480a6cbcd8239).UpdatingFilters);
        }, this.handleClearFilters = async ()=>{
            this.props.clearFilters();
            this.updateTableData((0, $d241d8e181bfcafe$export$ca480a6cbcd8239).UpdatingFilters);
        }, this.handleBarClick = (time)=>{
            const formattedTime = new Date(time).toISOString();
            this.handleChooseCustomTime(formattedTime);
        }, this.handleSetTimeBounds = async ()=>{
            const { seconds: seconds, windowOption: windowOption, timeOption: timeOption } = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(this.props, 'timeRange', {
                seconds: null,
                windowOption: null,
                timeOption: null
            });
            let timeBounds = {
                lower: `now() - ${windowOption}`,
                upper: null
            };
            if (timeOption !== 'now') {
                const extentTimes = (0, $88b90c62acd29beb$export$2e2bcd8739ae039)(this.props.histogramData, (d)=>d.time).map((d)=>d.time);
                timeBounds = (0, $12a27e58f249a026$export$cfe8c04a9bb43d0e)(extentTimes, timeOption, seconds);
            }
            await this.props.setTimeBounds(timeBounds);
            this.props.setTimeRangeAsync();
            this.updateTableData((0, $d241d8e181bfcafe$export$ca480a6cbcd8239).UpdatingTimeBounds);
        }, this.handleSetTimeWindow = async (timeWindow)=>{
            await this.props.setTimeWindow(timeWindow);
            this.handleSetTimeBounds();
        }, this.handleChooseSource = async (sourceID)=>{
            this.updateTableData((0, $d241d8e181bfcafe$export$ca480a6cbcd8239).Cleared);
            await this.props.getSourceAndPopulateNamespaces(sourceID);
            if (this.isMeasurementInNamespace) this.updateTableData((0, $d241d8e181bfcafe$export$ca480a6cbcd8239).UpdatingSource);
        }, this.handleChooseNamespace = async (namespace)=>{
            this.updateTableData((0, $d241d8e181bfcafe$export$ca480a6cbcd8239).Cleared);
            await Promise.all([
                this.props.setNamespaceAsync(namespace),
                this.props.fetchNamespaceSyslogStatusAsync(namespace)
            ]);
            if (this.isMeasurementInNamespace) this.updateTableData((0, $d241d8e181bfcafe$export$ca480a6cbcd8239).UpdatingNamespace);
        }, this.updateTableData = async (searchStatus)=>{
            this.clearTailInterval();
            await this.cancelChunks();
            this.setState({
                hasScrolled: false,
                liveUpdating: this.shouldLiveUpdate
            });
            this.props.clearSearchData(searchStatus);
        }, this.fetchNewDataset = async ()=>{
            if (this.isLiveUpdating && this.shouldLiveUpdate) this.startLogsTailFetchingInterval();
            else if (!this.shouldLiveUpdate) {
                this.props.executeHistogramQueryAsync();
                this.handleFetchNewerChunk();
            }
            await this.handleFetchOlderChunk();
        }, this.handleToggleOverlay = ()=>{
            this.setState({
                isOverlayVisible: !this.state.isOverlayVisible
            });
        }, this.handleShowHistogram = ()=>{
            this.setState({
                isHistogramHidden: false,
                isOverlayVisible: false
            });
        }, this.handleHideHistogram = ()=>{
            this.setState({
                isHistogramHidden: true
            });
        }, this.renderImportOverlay = ()=>{
            const { isOverlayVisible: isOverlayVisible } = this.state;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $827fcd4cb090ac0e$export$2e2bcd8739ae039), {
                visible: isOverlayVisible
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ce5ad5c9f942faa7$export$2e2bcd8739ae039), {
                severityLevelColors: this.severityLevelColors,
                onUpdate: this.handleUpdateOptions,
                onDismissOverlay: this.handleToggleOverlay,
                columns: this.tableColumns,
                severityFormat: this.severityFormat
            }));
        }, this.handleUpdateOptions = async (severityLevelColors, severityFormat, tableColumns)=>{
            const { logConfig: logConfig } = this.props;
            await this.props.updateConfig(this.logConfigLink, {
                ...logConfig,
                severityLevelColors: severityLevelColors,
                severityFormat: severityFormat,
                tableColumns: tableColumns
            });
        }, this.handleUpdateTruncation = async (isTruncated)=>{
            const { logConfig: logConfig } = this.props;
            await this.props.updateConfig(this.logConfigLink, {
                ...logConfig,
                isTruncated: isTruncated
            });
        }, this.getSources = async ()=>{
            try {
                this.loadingSourcesStatus = (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading;
                await this.props.getSources();
                this.loadingSourcesStatus = (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done;
            } catch (err) {
                this.loadingSourcesStatus = (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error;
            }
        };
        const { location: { query: { table: table } } } = props;
        this.state = {
            isLoadingNewer: false,
            searchString: '',
            liveUpdating: false,
            isOverlayVisible: false,
            histogramColors: [],
            hasScrolled: false,
            queryCount: 0,
            isHistogramHidden: table !== undefined
        };
    }
    async componentDidUpdate(prevProps) {
        const { router: router } = this.props;
        if (this.isSourcesEmpty) return router.push(`/sources/new?redirectPath=${location.pathname}`);
        this.handleLoadingStatus();
        const isSearchStatusUpdated = prevProps.searchStatus !== this.props.searchStatus;
        const isPrevSearchCleared = prevProps.searchStatus === (0, $d241d8e181bfcafe$export$ca480a6cbcd8239).Cleared;
        if (isSearchStatusUpdated && isPrevSearchCleared && this.isMeasurementInNamespace) this.fetchNewDataset();
    }
    async componentDidMount() {
        this.isComponentMounted = true;
        await this.getSources();
        await this.setCurrentSource();
        await this.props.getConfig(this.logConfigLink);
        if (this.isComponentMounted && this.isMeasurementInNamespace) this.updateTableData((0, $d241d8e181bfcafe$export$ca480a6cbcd8239).Loading);
        if ((0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(this.props, 'timeRange.timeOption', '') === 'now') this.startLogsTailFetchingInterval();
        if (this.isComponentMounted) await this.props.executeHistogramQueryAsync();
    }
    componentWillUnmount() {
        this.isComponentMounted = false;
        this.clearTailInterval();
        this.cancelChunks();
    }
    render() {
        const { filters: filters, timeRange: timeRange, notify: notify, nextOlderUpperBound: nextOlderUpperBound, nextNewerLowerBound: nextNewerLowerBound, nextTailLowerBound: nextTailLowerBound, currentTailUpperBound: currentTailUpperBound, searchStatus: searchStatus, tableTime: tableTime } = this.props;
        const { isHistogramHidden: isHistogramHidden } = this.state;
        if (this.isLoadingSourcesStatus) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $810ad5a94daa03b8$export$2e2bcd8739ae039), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "page"
        }, this.header, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: `page-contents logs-viewer ${isHistogramHidden ? 'logs-viewer--table-only' : ''}`
        }, isHistogramHidden ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $32f60005892e8c21$export$2e2bcd8739ae039), null, this.chartControlBar, this.chart), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $91a0846051d28fe9$export$2e2bcd8739ae039), {
            onSearch: this.handleSubmitSearch,
            customTime: tableTime.custom,
            relativeTime: tableTime.relative,
            onChooseCustomTime: this.handleChooseCustomTime,
            onChooseRelativeTime: this.handleChooseRelativeTime
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $950dfe92aacd1856$export$2e2bcd8739ae039), {
            filters: filters || [],
            onDelete: this.handleFilterDelete,
            onFilterChange: this.handleFilterChange,
            onClearFilters: this.handleClearFilters,
            onUpdateTruncation: this.handleUpdateTruncation,
            isTruncated: this.isTruncated,
            isHistogramHidden: isHistogramHidden,
            onShowHistogram: this.handleShowHistogram
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $e8de79f4abf4f89f$export$2e2bcd8739ae039), {
            queryCount: this.state.queryCount,
            count: this.histogramTotal,
            data: this.tableData,
            onScrollVertical: this.handleVerticalScroll,
            onScrolledToTop: this.handleScrollToTop,
            isTruncated: this.isTruncated,
            onTagSelection: this.handleTagSelection,
            fetchMore: this.handleFetchOlderChunk,
            fetchNewer: this.handleFetchNewerChunk,
            timeRange: timeRange,
            scrollToRow: this.tableScrollToRow,
            tableColumns: this.tableColumns,
            severityFormat: this.severityFormat,
            severityLevelColors: this.severityLevelColors,
            hasScrolled: this.state.hasScrolled,
            tableInfiniteData: this.props.tableInfiniteData,
            onChooseCustomTime: this.handleChooseCustomTime,
            onExpandMessage: this.handleExpandMessage,
            notify: notify,
            searchStatus: searchStatus,
            filters: filters,
            upper: currentTailUpperBound || nextNewerLowerBound || nextTailLowerBound,
            lower: nextOlderUpperBound
        }))), this.renderImportOverlay(), this.expandedMessageContainer);
    }
    handleLoadingStatus() {
        if (this.isMeasurementInNamespace && !this.isClearing && !(0, $609fe1a5ad4907b6$export$9f9983dcfce9558)(this.props.tableInfiniteData)) this.props.setSearchStatus((0, $d241d8e181bfcafe$export$ca480a6cbcd8239).Loaded);
    }
    get isClearing() {
        switch(this.props.searchStatus){
            case (0, $d241d8e181bfcafe$export$ca480a6cbcd8239).Clearing:
            case (0, $d241d8e181bfcafe$export$ca480a6cbcd8239).None:
                return true;
        }
        return false;
    }
    get tableScrollToRow() {
        const { timeRange: { timeOption: timeOption } } = this.props;
        if (this.isLiveUpdating === true && !this.state.hasScrolled) return 0;
        if (!this.isLiveUpdating && timeOption && !this.state.hasScrolled) return (0, $609fe1a5ad4907b6$export$3ba2ae9260aa3226)(timeOption, this.props.tableInfiniteData, 0);
        else if (this.state.isLoadingNewer && this.props.newRowsAdded) return this.props.newRowsAdded || 0;
        if (this.state.hasScrolled) return;
        if (this.totalForwardValues() > 0) return Math.max(this.totalForwardValues() - 3, 0);
        return Math.round(this.totalBackwardValues() / 2);
    }
    clearAllTimeBounds() {
        this.props.clearAllTimeBounds();
    }
    flushTailBuffer() {
        this.props.flushTailBuffer();
    }
    get tableData() {
        const forwardData = (0, $609fe1a5ad4907b6$export$654b7c76080cc175)(this.props.tableInfiniteData.forward, this.tableColumns);
        const backwardData = (0, $609fe1a5ad4907b6$export$654b7c76080cc175)(this.props.tableInfiniteData.backward, this.tableColumns);
        const data = {
            columns: forwardData.columns,
            values: [
                ...forwardData.values,
                ...backwardData.values
            ]
        };
        return data;
    }
    get logConfigLink() {
        return this.props.logConfigLink;
    }
    get tableColumns() {
        const { logConfig: logConfig } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(logConfig, 'tableColumns', []);
    }
    get histogramTotal() {
        const { histogramData: histogramData } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).sumBy(histogramData, 'value');
    }
    get chart() {
        const { histogramData: histogramData, timeRange: { timeOption: timeOption } } = this.props;
        const { histogramColors: histogramColors } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "logs-viewer--graph"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $9cf5f10972873d72$export$2e2bcd8739ae039), null, ({ width: width, height: height })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $500e4bf25e7bc866$export$2e2bcd8739ae039), {
                data: histogramData,
                width: width,
                height: height,
                colorScale: (0, $fb9227b661b4dffd$export$cbbaf6b8cc77795b),
                colors: histogramColors,
                onBarClick: this.handleBarClick,
                sortBarGroups: this.handleSortHistogramBarGroups
            }, ({ xScale: xScale, adjustedHeight: adjustedHeight, margins: margins })=>{
                const timeOptionValue = new Date(timeOption).valueOf();
                const x = xScale(timeOptionValue);
                const y1 = margins.top;
                const y2 = margins.top + adjustedHeight;
                const textSize = 11;
                const markerSize = 5;
                const labelSize = 100;
                if (timeOption === 'now') return null;
                const lineContainerWidth = 3;
                const lineWidth = 1;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("svg", {
                    width: lineContainerWidth,
                    height: height,
                    style: {
                        position: 'absolute',
                        left: `${x}px`,
                        top: '0px',
                        transform: 'translateX(-50%)'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("line", {
                    x1: (lineContainerWidth - lineWidth) / 2,
                    x2: (lineContainerWidth - lineWidth) / 2,
                    y1: y1 + markerSize / 2,
                    y2: y2,
                    stroke: (0, $918c9f03a35fe03f$export$5fbd7a106ab5f092).White,
                    strokeWidth: `${lineWidth}`
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("svg", {
                    width: x,
                    height: textSize + textSize / 2,
                    style: {
                        position: 'absolute',
                        left: `${x - markerSize - labelSize}px`
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("text", {
                    style: {
                        fontSize: textSize,
                        fontWeight: 600
                    },
                    x: 0,
                    y: textSize,
                    height: textSize,
                    fill: (0, $918c9f03a35fe03f$export$5fbd7a106ab5f092).Sidewalk
                }, "Current Timestamp"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("ellipse", {
                    cx: labelSize + markerSize - 0.5,
                    cy: textSize / 2 + markerSize / 2,
                    rx: markerSize / 2,
                    ry: markerSize / 2,
                    fill: (0, $918c9f03a35fe03f$export$5fbd7a106ab5f092).White
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("text", {
                    style: {
                        fontSize: textSize,
                        fontWeight: 600
                    },
                    x: labelSize + markerSize / 2 + textSize,
                    y: textSize,
                    height: textSize,
                    fill: (0, $918c9f03a35fe03f$export$5fbd7a106ab5f092).Sidewalk
                }, (0, $39ae7dd6f6a41115$export$3203edd9e5edd663)(timeOptionValue))));
            })));
    }
    get header() {
        const { sources: sources, currentSource: currentSource, currentNamespaces: currentNamespaces, currentNamespace: currentNamespace } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1c58573b02c4cba3$export$2e2bcd8739ae039), {
            liveUpdating: this.isLiveUpdating,
            availableSources: sources,
            onChooseSource: this.handleChooseSource,
            onChooseNamespace: this.handleChooseNamespace,
            currentSource: currentSource,
            currentNamespaces: currentNamespaces,
            currentNamespace: currentNamespace,
            onChangeLiveUpdatingStatus: this.handleChangeLiveUpdatingStatus,
            onShowOptionsOverlay: this.handleToggleOverlay
        });
    }
    get chartControlBar() {
        const { queryCount: queryCount, searchStatus: searchStatus } = this.props;
        const timeRange = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(this.props, 'timeRange', {
            upper: null,
            lower: 'now() - 1m',
            seconds: 60,
            windowOption: '1m',
            timeOption: 'now'
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "logs-viewer--graph-controls"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $577dac35075877a3$export$2e2bcd8739ae039), {
            count: this.histogramTotal,
            queryCount: queryCount,
            searchStatus: searchStatus,
            selectedTimeWindow: timeRange
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "page-header--right"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-sm btn-square btn-default",
            onClick: this.handleHideHistogram,
            title: "Hide Histogram"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon eye-closed"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $173793fa9d366c6c$export$2e2bcd8739ae039), {
            selectedTimeWindow: timeRange,
            onSetTimeWindow: this.handleSetTimeWindow
        })));
    }
    get severityLevelColors() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(this.props.logConfig, 'severityLevelColors', []);
    }
    get severityFormat() {
        const { logConfig: logConfig } = this.props;
        const severityFormat = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(logConfig, 'severityFormat', (0, $17fe399301a568db$export$85ce1201a2cc2824).dotText);
        return severityFormat;
    }
    get isTruncated() {
        return this.props.logConfig.isTruncated;
    }
    get expandedMessageContainer() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "logs-viewer--expanded-message-container",
            id: "expanded-message-container"
        });
    }
    get isLiveUpdating() {
        return !!this.state.liveUpdating;
    }
    get shouldLiveUpdate() {
        return this.props.tableTime.relative === 0;
    }
    get isLoadingSourcesStatus() {
        switch(this.loadingSourcesStatus){
            case (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading:
            case (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).NotStarted:
                return true;
            default:
                return false;
        }
    }
    get isSourcesEmpty() {
        if (this.isLoadingSourcesStatus) return false;
        return !this.props.sources || this.props.sources.length === 0;
    }
    get isMeasurementInNamespace() {
        return this.props.searchStatus !== (0, $d241d8e181bfcafe$export$ca480a6cbcd8239).MeasurementMissing;
    }
    updateQueryCount() {
        this.setState({
            queryCount: this.countCurrentQueries()
        });
    }
    countCurrentQueries() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).compact([
            this.currentNewerChunksGenerator,
            this.currentOlderChunksGenerator
        ]).length;
    }
}
const $05168acb2d31b9e6$var$mapStateToProps = ({ sources: sources, links: { orgConfig: { logViewer: logViewer } }, logs: { newRowsAdded: newRowsAdded, currentSource: currentSource, currentNamespaces: currentNamespaces, timeRange: timeRange, currentNamespace: currentNamespace, histogramData: histogramData, tableData: tableData, filters: filters, queryCount: queryCount, logConfig: logConfig, tableTime: tableTime, tableInfiniteData: tableInfiniteData, nextOlderUpperBound: nextOlderUpperBound, nextNewerLowerBound: nextNewerLowerBound, currentTailUpperBound: currentTailUpperBound, nextTailLowerBound: nextTailLowerBound, searchStatus: searchStatus } })=>({
        sources: sources,
        currentSource: currentSource,
        currentNamespaces: currentNamespaces,
        timeRange: timeRange,
        currentNamespace: currentNamespace,
        histogramData: histogramData,
        tableData: tableData,
        filters: filters,
        queryCount: queryCount,
        logConfig: logConfig,
        tableTime: tableTime,
        logConfigLink: logViewer,
        tableInfiniteData: tableInfiniteData,
        newRowsAdded: newRowsAdded,
        nextOlderUpperBound: nextOlderUpperBound,
        nextNewerLowerBound: nextNewerLowerBound,
        currentTailUpperBound: currentTailUpperBound,
        nextTailLowerBound: nextTailLowerBound,
        searchStatus: searchStatus
    });
var $05168acb2d31b9e6$export$2e2bcd8739ae039 = (0, $dffbdf89c590a961$export$2e2bcd8739ae039)((0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($05168acb2d31b9e6$var$mapStateToProps, $05168acb2d31b9e6$var$mapDispatchToProps)($05168acb2d31b9e6$var$LogsPage));





var $3ced1640a46259ef$export$2e2bcd8739ae039 = (0, $f03dc95120ce491d$export$2e2bcd8739ae039);



var $NdCUR = parcelRequire("NdCUR");







var $NdCUR = parcelRequire("NdCUR");

var $NdCUR = parcelRequire("NdCUR");

var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");


var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");
const $d73d905aed2f329a$export$3e41faf802a29e71 = ({ children: children, onClick: onClick, isDisabled: isDisabled, isActive: isActive, isConfigured: isConfigured })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('btn tab', {
            active: isActive,
            configured: isConfigured
        }),
        onClick: isDisabled ? null : onClick
    }, children);
const $d73d905aed2f329a$export$e51a686c67fdaa2d = ({ children: children, activeIndex: activeIndex, onActivate: onActivate, customClass: customClass })=>{
    const kids = (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Children.map(children, (child, index)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).cloneElement(child, {
            isActive: index === activeIndex,
            onClick: ()=>onActivate(index)
        });
    });
    if (customClass) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: customClass
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "btn-group btn-group-lg tab-group"
    }, kids));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "btn-group btn-group-lg tab-group"
    }, kids);
};
const $d73d905aed2f329a$export$5dae8d435677f210 = ({ children: children, activeIndex: activeIndex, customClass: customClass })=>// if only 1 child, children array index lookup will fail
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: customClass
    }, children[activeIndex]);
const $d73d905aed2f329a$export$3d96ec278d3efce4 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null, children);
class $d73d905aed2f329a$export$b2539bed5023c21c extends (0, $NdCUR.PureComponent) {
    static{
        this.defaultProps = {
            onSelect: ()=>{},
            tabContentsClass: ''
        };
    }
    constructor(props){
        super(props), this.handleActivateTab = (activeIndex)=>{
            this.setState({
                activeIndex: activeIndex
            });
            this.props.onSelect(activeIndex);
        };
        // initialIndex allows the user to enable a Tab and TabPanel
        // other than 0 on initial render.
        this.state = {
            activeIndex: this.props.initialIndex || 0
        };
    }
    render() {
        const { children: children, tabContentsClass: tabContentsClass } = this.props;
        const kids = (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Children.map(children, (child)=>{
            if (child && child.type === $d73d905aed2f329a$export$5dae8d435677f210) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).cloneElement(child, {
                activeIndex: this.state.activeIndex
            });
            if (child && child.type === $d73d905aed2f329a$export$e51a686c67fdaa2d) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).cloneElement(child, {
                activeIndex: this.state.activeIndex,
                onActivate: this.handleActivateTab
            });
            return child;
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: tabContentsClass
        }, kids);
    }
}




var $hBdgJ = parcelRequire("hBdgJ");

var $NdCUR = parcelRequire("NdCUR");

var $NdCUR = parcelRequire("NdCUR");

class $5b6de86dd5c73541$var$RedactedInput extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleClick = ()=>{
            this.setState({
                editing: true
            });
        };
        this.state = {
            editing: false
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!nextProps.isFormEditing) this.setState({
            editing: false
        });
    }
    render() {
        const { defaultValue: defaultValue, id: id, refFunc: refFunc, disableTest: disableTest } = this.props;
        const { editing: editing } = this.state;
        if (defaultValue === true && !editing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-control-static redacted-input"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "alert-value-set"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon checkmark"
        }), " Value set"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "btn btn-xs btn-link",
            onClick: this.handleClick
        }, "Change"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: id,
            type: "hidden",
            ref: refFunc,
            defaultValue: defaultValue.toString()
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: id,
            type: "text",
            ref: refFunc,
            defaultValue: '',
            onChange: disableTest
        });
    }
}
var $5b6de86dd5c73541$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($5b6de86dd5c73541$var$RedactedInput);



class $aa1b638ec5727b5b$var$AlertaConfig extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleEnabledChange = (e)=>{
            this.setState({
                enabled: e.target.checked
            });
            this.disableTest();
        }, this.handleSubmit = async (e)=>{
            e.preventDefault();
            const properties = {
                environment: this.environment.value,
                origin: this.origin.value,
                token: this.token.value,
                'token-prefix': this.tokenPrefix.value,
                url: this.url.value,
                enabled: this.state.enabled
            };
            const success = await this.props.onSave(properties);
            if (success) this.setState({
                testEnabled: true
            });
        }, this.disableTest = ()=>{
            this.setState({
                testEnabled: false
            });
        }, this.handleTokenRef = (r)=>this.token = r;
        this.state = {
            testEnabled: this.props.enabled,
            enabled: (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(this.props, 'config.options.enabled', false)
        };
    }
    render() {
        const { environment: environment, origin: origin, token: token, url: url, 'token-prefix': tokenPrefix } = this.props.config.options;
        const { testEnabled: testEnabled, enabled: enabled } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("form", {
            onSubmit: this.handleSubmit
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "environment"
        }, "Environment"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: "environment",
            type: "text",
            ref: (r)=>this.environment = r,
            defaultValue: environment || '',
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "origin"
        }, "Origin"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: "origin",
            type: "text",
            ref: (r)=>this.origin = r,
            defaultValue: origin || '',
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "token"
        }, "Token"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $5b6de86dd5c73541$export$2e2bcd8739ae039), {
            defaultValue: token,
            id: "token",
            refFunc: this.handleTokenRef,
            disableTest: this.disableTest,
            isFormEditing: !testEnabled
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "token-prefix"
        }, "Token Prefix"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: "token-prefix",
            type: "text",
            ref: (r)=>this.tokenPrefix = r,
            defaultValue: tokenPrefix || '',
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "url"
        }, "User"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: "url",
            type: "text",
            ref: (r)=>this.url = r,
            defaultValue: url || '',
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-control-static"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            type: "checkbox",
            id: "disabled",
            checked: enabled,
            onChange: this.handleEnabledChange
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "disabled"
        }, "Configuration Enabled"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group form-group-submit col-xs-12 text-center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-primary",
            type: "submit",
            disabled: this.state.testEnabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon checkmark"
        }), "Save Changes"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-primary",
            disabled: !this.state.testEnabled || !enabled,
            onClick: this.props.onTest
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon pulse-c"
        }), "Send Test Alert")));
    }
}
var $aa1b638ec5727b5b$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($aa1b638ec5727b5b$var$AlertaConfig);



var $NdCUR = parcelRequire("NdCUR");

var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");

var $NdCUR = parcelRequire("NdCUR");

var $NdCUR = parcelRequire("NdCUR");


class $8ea1c6fecd25d5ca$var$TagsAddButton extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleButtonClick = ()=>{
            this.setState({
                open: !this.state.open
            });
        }, this.handleMenuClick = (item)=>()=>{
                this.setState({
                    open: false
                });
                this.props.onChoose(item);
            }, this.handleClickOutside = ()=>{
            this.setState({
                open: false
            });
        };
        this.state = {
            open: false
        };
    }
    render() {
        const { open: open } = this.state;
        const { items: items } = this.props;
        const classname = `tags-add${open ? ' open' : ''}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1f11d3536bc98f8a$export$c16e4f034c84cb3f), {
            onClickOutside: this.handleClickOutside
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: classname,
            onClick: this.handleButtonClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon plus"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "tags-add--menu"
        }, items.map((item, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                key: i,
                className: "tags-add--menu-item",
                onClick: this.handleMenuClick(item)
            }, item.text)))));
    }
}
var $8ea1c6fecd25d5ca$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($8ea1c6fecd25d5ca$var$TagsAddButton);




const $099d0b83ed311b1f$var$Tags = ({ tags: tags, onDeleteTag: onDeleteTag, addMenuItems: addMenuItems, addMenuChoose: addMenuChoose, confirmText: confirmText })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "input-tag-list"
    }, tags.map((item, i)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($099d0b83ed311b1f$var$Tag2, {
            key: i,
            item: item,
            onDelete: onDeleteTag,
            confirmText: confirmText,
            testId: `${item.name}-org--tag`
        });
    }), addMenuItems && addMenuItems.length && addMenuChoose ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $8ea1c6fecd25d5ca$export$2e2bcd8739ae039), {
        items: addMenuItems,
        onChoose: addMenuChoose
    }) : null);
};
class $099d0b83ed311b1f$var$Tag extends (0, $NdCUR.PureComponent) {
    static{
        this.defaultProps = {
            confirmText: 'Delete'
        };
    }
    render() {
        const { item: item, confirmText: confirmText, testId: testId } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "input-tag--item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            "data-test": testId
        }, item.text || item.name || item), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $8008717819fc7a5f$export$2e2bcd8739ae039), {
            icon: "remove",
            size: "btn-xs",
            square: true,
            confirmText: confirmText,
            customClass: "input-tag--remove",
            confirmAction: this.handleClickDelete(item),
            testId: "delete-tag--button"
        }));
    }
    constructor(...args){
        super(...args), this.handleClickDelete = (item)=>()=>{
                this.props.onDelete(item);
            };
    }
}
const $099d0b83ed311b1f$var$Tag2 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($099d0b83ed311b1f$var$Tag);
var $099d0b83ed311b1f$export$2e2bcd8739ae039 = $099d0b83ed311b1f$var$Tags;



class $c968296c3ed7ff6f$var$TagInput extends (0, $NdCUR.PureComponent) {
    render() {
        const { title: title, tags: tags, inputID: inputID } = this.props;
        const id = inputID || title;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: id
        }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            placeholder: `Type and hit 'Enter' to add to list of ${title}`,
            autoComplete: "off",
            className: "form-control tag-input",
            id: id,
            type: "text",
            ref: (r)=>this.input = r,
            onKeyDown: this.handleAddTag
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $099d0b83ed311b1f$export$2e2bcd8739ae039), {
            tags: tags,
            onDeleteTag: this.handleDeleteTag
        }));
    }
    shouldAddToList(item, tags) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEmpty(item) && !tags.find((l)=>l === item);
    }
    constructor(...args){
        super(...args), this.handleAddTag = (e)=>{
            if (e.key === 'Enter') {
                e.preventDefault();
                const newItem = e.target.value.trim();
                const { tags: tags, onAddTag: onAddTag } = this.props;
                if (!this.shouldAddToList(newItem, tags)) return;
                this.input.value = '';
                onAddTag(newItem);
                this.props.disableTest();
            }
        }, this.handleDeleteTag = (item)=>{
            this.props.onDeleteTag(item);
        };
    }
}
var $c968296c3ed7ff6f$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($c968296c3ed7ff6f$var$TagInput);





class $565861ae3c11c98a$var$KafkaConfig extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleSubmit = async (e)=>{
            e.preventDefault();
            const batchSize = parseInt(this.batchSize.value, 10);
            if (isNaN(batchSize)) {
                this.props.notify((0, $ec1f42de4faacc37$export$e838d276f1588a38)());
                return;
            }
            const properties = {
                brokers: this.state.currentBrokers,
                timeout: this.timeout.value,
                'batch-size': batchSize,
                'batch-timeout': this.batchTimeout.value,
                'use-ssl': this.useSSL.checked,
                'ssl-ca': this.sslCA.value,
                'ssl-cert': this.sslCert.value,
                'ssl-key': this.sslKey.value,
                'insecure-skip-verify': this.insecureSkipVerify.checked,
                enabled: this.state.enabled
            };
            if (this.isNewConfig) properties.id = this.id.value;
            const success = await this.props.onSave(properties, this.isNewConfig, this.configID);
            if (success) this.setState({
                testEnabled: true
            });
        }, this.handleConfigEnabledChange = (e)=>{
            this.setState({
                enabled: e.target.checked
            });
            this.disableTest();
        }, this.handleTest = (e)=>{
            this.props.onTest(e, {
                id: this.configID
            });
        }, this.handleDelete = (e)=>{
            e.preventDefault();
            this.props.onDelete(this.configID);
        }, this.disableTest = ()=>{
            this.setState({
                testEnabled: false
            });
        }, this.handleAddBroker = (broker)=>{
            this.setState({
                currentBrokers: this.state.currentBrokers.concat(broker)
            });
        }, this.handleDeleteBroker = (broker)=>{
            this.setState({
                currentBrokers: this.state.currentBrokers.filter((t)=>t !== broker.name),
                testEnabled: false
            });
        };
        const { brokers: brokers } = props.config.options;
        this.state = {
            currentBrokers: brokers || [],
            testEnabled: this.props.enabled,
            enabled: (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(this.props, 'config.options.enabled', false)
        };
    }
    render() {
        const { options: options } = this.props.config;
        const { id: keyID } = this.props;
        const id = options.id;
        const timeout = options.timeout;
        const batchSize = options['batch-size'];
        const batchTimeout = options['batch-timeout'];
        const useSSL = options['use-ssl'];
        const sslCA = options['ssl-ca'];
        const sslCert = options['ssl-cert'];
        const sslKey = options['ssl-key'];
        const insecureSkipVerify = options['insecure-skip-verify'];
        const { enabled: enabled } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("form", {
            onSubmit: this.handleSubmit
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: `${keyID}-id`
        }, "ID"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: `${keyID}-id`,
            type: "text",
            ref: (r)=>this.id = r,
            defaultValue: id || '',
            onChange: this.disableTest,
            readOnly: !this.isNewConfig
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c968296c3ed7ff6f$export$2e2bcd8739ae039), {
            title: "Brokers",
            inputID: `${keyID}-brokers`,
            onAddTag: this.handleAddBroker,
            onDeleteTag: this.handleDeleteBroker,
            tags: this.currentBrokersForTags,
            disableTest: this.disableTest
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: `${keyID}-timeout`
        }, "Timeout"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: `${keyID}-timeout`,
            type: "text",
            ref: (r)=>this.timeout = r,
            defaultValue: timeout || '',
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: `${keyID}-batchsize`
        }, "Batch Size"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: `${keyID}-batchsize`,
            type: "number",
            ref: (r)=>this.batchSize = r,
            defaultValue: batchSize.toString() || '0',
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: `${keyID}-batch-timeout`
        }, "Batch Timeout"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: `${keyID}-batch-timeout`,
            type: "text",
            ref: (r)=>this.batchTimeout = r,
            defaultValue: batchTimeout || '',
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-control-static"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            id: `${keyID}-useSSL`,
            type: "checkbox",
            defaultChecked: useSSL,
            ref: (r)=>this.useSSL = r,
            onChange: this.disableTest
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: `${keyID}-useSSL`
        }, "Use SSL"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: `${keyID}-sslCA`
        }, "SSL CA"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: `${keyID}-sslCA`,
            type: "text",
            ref: (r)=>this.sslCA = r,
            defaultValue: sslCA || '',
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: `${keyID}-sslCert`
        }, "SSL Cert"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: `${keyID}-sslCert`,
            type: "text",
            ref: (r)=>this.sslCert = r,
            defaultValue: sslCert || '',
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: `${keyID}-sslKey`
        }, "SSL Key"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: `${keyID}-sslKey`,
            type: "text",
            ref: (r)=>this.sslKey = r,
            defaultValue: sslKey || '',
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-control-static"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            id: `${keyID}-insecureSkipVerify`,
            type: "checkbox",
            defaultChecked: insecureSkipVerify,
            ref: (r)=>this.insecureSkipVerify = r,
            onChange: this.disableTest
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: `${keyID}-insecureSkipVerify`
        }, "Insecure Skip Verify"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-control-static"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            type: "checkbox",
            id: `${keyID}-enabled`,
            checked: enabled,
            onChange: this.handleConfigEnabledChange
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: `${keyID}-enabled`
        }, "Configuration Enabled"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group form-group-submit col-xs-12 text-center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-primary",
            type: "submit",
            disabled: this.state.testEnabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon checkmark"
        }), "Save Changes"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-primary",
            disabled: !this.state.testEnabled,
            onClick: this.handleTest
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon pulse-c"
        }), "Send Test Alert"), this.deleteButton, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("hr", null)));
    }
    get currentBrokersForTags() {
        const { currentBrokers: currentBrokers } = this.state;
        return currentBrokers.map((broker)=>({
                name: broker
            }));
    }
    get configID() {
        const { config: { options: { id: id } } } = this.props;
        return id;
    }
    get isNewConfig() {
        return (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(this.props, 'config.isNewConfig', false);
    }
    get isDefaultConfig() {
        return this.configID === 'default';
    }
    get deleteButton() {
        if (this.isDefaultConfig) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-danger",
            onClick: this.handleDelete
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon trash"
        }), "Delete");
    }
}
var $565861ae3c11c98a$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($565861ae3c11c98a$var$KafkaConfig);



var $hBdgJ = parcelRequire("hBdgJ");

var $NdCUR = parcelRequire("NdCUR");



class $514756b62eb57658$var$OpsGenieConfig extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleEnabledChange = (e)=>{
            this.setState({
                enabled: e.target.checked
            });
            this.disableTest();
        }, this.handleSubmit = async (e)=>{
            e.preventDefault();
            const properties = {
                'api-key': this.apiKey.value,
                teams: this.state.currentTeams,
                recipients: this.state.currentRecipients,
                enabled: this.state.enabled
            };
            if (this.props.v2) {
                if (this.recoveryActionNotes.checked) properties.recovery_action = 'notes';
                else if (this.recoveryActionClose.checked) properties.recovery_action = 'close';
            }
            const success = await this.props.onSave(properties);
            if (success) this.setState({
                testEnabled: true
            });
        }, this.disableTest = ()=>{
            this.setState({
                testEnabled: false
            });
        }, this.handleAddTeam = (team)=>{
            this.setState({
                currentTeams: this.state.currentTeams.concat(team)
            });
        }, this.handleAddRecipient = (recipient)=>{
            this.setState({
                currentRecipients: this.state.currentRecipients.concat(recipient)
            });
        }, this.handleDeleteTeam = (team)=>{
            this.setState({
                currentTeams: this.state.currentTeams.filter((t)=>t !== team.name),
                testEnabled: false
            });
        }, this.handleDeleteRecipient = (recipient)=>{
            this.setState({
                currentRecipients: this.state.currentRecipients.filter((r)=>r !== recipient.name),
                testEnabled: false
            });
        }, this.handleApiKeyRef = (r)=>this.apiKey = r;
        const { teams: teams, recipients: recipients } = props.config.options;
        this.state = {
            currentTeams: teams || [],
            currentRecipients: recipients || [],
            testEnabled: this.props.enabled,
            enabled: (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(this.props, 'config.options.enabled', false)
        };
    }
    render() {
        const { options: options } = this.props.config;
        const apiKey = options['api-key'];
        const recoveryAction = options.recovery_action;
        const { testEnabled: testEnabled, enabled: enabled } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("form", {
            onSubmit: this.handleSubmit
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "api-key"
        }, "API Key"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $5b6de86dd5c73541$export$2e2bcd8739ae039), {
            defaultValue: apiKey,
            id: "api-key",
            refFunc: this.handleApiKeyRef,
            disableTest: this.disableTest,
            isFormEditing: !testEnabled
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c968296c3ed7ff6f$export$2e2bcd8739ae039), {
            title: "Teams",
            onAddTag: this.handleAddTeam,
            onDeleteTag: this.handleDeleteTeam,
            tags: this.currentTeamsForTags,
            disableTest: this.disableTest
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c968296c3ed7ff6f$export$2e2bcd8739ae039), {
            title: "Recipients",
            onAddTag: this.handleAddRecipient,
            onDeleteTag: this.handleDeleteRecipient,
            tags: this.currentRecipientsForTags,
            disableTest: this.disableTest
        }), this.props.v2 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "parseMode"
        }, "Select recovery action"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-control-static"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "radio-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            id: "recoveryAction_notes",
            type: "radio",
            name: "recoveryAction",
            value: "notes",
            defaultChecked: recoveryAction !== 'close',
            ref: (r)=>this.recoveryActionNotes = r,
            onChange: this.disableTest
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "recoveryAction_notes"
        }, "Add a note to the alert")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "radio-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            id: "recoveryAction_close",
            type: "radio",
            name: "recoveryAction",
            value: "close",
            defaultChecked: recoveryAction === 'close',
            ref: (r)=>this.recoveryActionClose = r,
            onChange: this.disableTest
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "recoveryAction_close"
        }, "Close the alert")))) : undefined, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-control-static"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            type: "checkbox",
            id: "disabled",
            checked: enabled,
            onChange: this.handleEnabledChange
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "disabled"
        }, "Configuration Enabled"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group form-group-submit col-xs-12 text-center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-primary",
            type: "submit",
            disabled: this.state.testEnabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon checkmark"
        }), "Save Changes"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-primary",
            disabled: !this.state.testEnabled || !enabled,
            onClick: this.props.onTest
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon pulse-c"
        }), "Send Test Alert")));
    }
    get currentTeamsForTags() {
        const { currentTeams: currentTeams } = this.state;
        return currentTeams.map((team)=>({
                name: team
            }));
    }
    get currentRecipientsForTags() {
        const { currentRecipients: currentRecipients } = this.state;
        return currentRecipients.map((recipient)=>({
                name: recipient
            }));
    }
}
var $514756b62eb57658$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($514756b62eb57658$var$OpsGenieConfig);



var $hBdgJ = parcelRequire("hBdgJ");

var $NdCUR = parcelRequire("NdCUR");


class $e678ff2e0c35158a$var$PagerDutyConfig extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleServiceKeyRef = (r)=>this.serviceKey = r, this.handleEnabledChange = (e)=>{
            this.setState({
                enabled: e.target.checked
            });
            this.disableTest();
        }, this.handleSubmit = async (e)=>{
            e.preventDefault();
            const properties = {
                'service-key': this.serviceKey.value,
                url: this.url.value,
                enabled: this.state.enabled
            };
            const success = await this.props.onSave(properties);
            if (success) this.setState({
                testEnabled: true
            });
        }, this.disableTest = ()=>{
            this.setState({
                testEnabled: false
            });
        };
        this.state = {
            testEnabled: this.props.enabled,
            enabled: (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(this.props, 'config.options.enabled', false)
        };
    }
    render() {
        const { options: options } = this.props.config;
        const { url: url } = options;
        const serviceKey = options['service-key'];
        const { testEnabled: testEnabled, enabled: enabled } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("form", {
            onSubmit: this.handleSubmit
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "service-key"
        }, "Service Key"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $5b6de86dd5c73541$export$2e2bcd8739ae039), {
            defaultValue: serviceKey,
            id: "service-key",
            refFunc: this.handleServiceKeyRef,
            disableTest: this.disableTest,
            isFormEditing: !testEnabled
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "url"
        }, "PagerDuty URL"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: "url",
            type: "text",
            ref: (r)=>this.url = r,
            defaultValue: url || '',
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-control-static"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            type: "checkbox",
            id: "disabled",
            checked: enabled,
            onChange: this.handleEnabledChange
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "disabled"
        }, "Configuration Enabled"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group form-group-submit col-xs-12 text-center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-primary",
            type: "submit",
            disabled: this.state.testEnabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon checkmark"
        }), "Save Changes"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-primary",
            disabled: !this.state.testEnabled || !enabled,
            onClick: this.props.onTest
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon pulse-c"
        }), "Send Test Alert")));
    }
}
var $e678ff2e0c35158a$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($e678ff2e0c35158a$var$PagerDutyConfig);



var $hBdgJ = parcelRequire("hBdgJ");

var $NdCUR = parcelRequire("NdCUR");


class $1fe8c3cabe211880$var$PagerDuty2Config extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleRoutingKeyRef = (r)=>this.routingKey = r, this.handleEnabledChange = (e)=>{
            this.setState({
                enabled: e.target.checked
            });
            this.disableTest();
        }, this.handleSubmit = async (e)=>{
            e.preventDefault();
            const properties = {
                'routing-key': this.routingKey.value,
                url: this.url.value,
                enabled: this.state.enabled
            };
            const success = await this.props.onSave(properties);
            if (success) this.setState({
                testEnabled: true
            });
        }, this.disableTest = ()=>{
            this.setState({
                testEnabled: false
            });
        };
        this.state = {
            testEnabled: this.props.enabled,
            enabled: (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(this.props, 'config.options.enabled', false)
        };
    }
    render() {
        const { options: options } = this.props.config;
        const { url: url } = options;
        const routingKey = options['routing-key'];
        const { testEnabled: testEnabled, enabled: enabled } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("form", {
            onSubmit: this.handleSubmit
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "routing-key"
        }, "Routing Key"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $5b6de86dd5c73541$export$2e2bcd8739ae039), {
            defaultValue: routingKey,
            id: "routing-key",
            refFunc: this.handleRoutingKeyRef,
            disableTest: this.disableTest,
            isFormEditing: !testEnabled
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "url"
        }, "PagerDuty URL"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: "url",
            type: "text",
            ref: (r)=>this.url = r,
            defaultValue: url || '',
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-control-static"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            type: "checkbox",
            id: "disabled",
            checked: enabled,
            onChange: this.handleEnabledChange
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "disabled"
        }, "Configuration Enabled"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group form-group-submit col-xs-12 text-center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-primary",
            type: "submit",
            disabled: this.state.testEnabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon checkmark"
        }), "Save Changes"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-primary",
            disabled: !this.state.testEnabled || !enabled,
            onClick: this.props.onTest
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon pulse-c"
        }), "Send Test Alert")));
    }
}
var $1fe8c3cabe211880$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($1fe8c3cabe211880$var$PagerDuty2Config);



var $hBdgJ = parcelRequire("hBdgJ");

var $NdCUR = parcelRequire("NdCUR");



// Pushover
const $e699c1a854308eca$var$pushoverDocsLink = 'https://docs.influxdata.com/kapacitor/latest/nodes/alert_node/#pushover';
const $e699c1a854308eca$export$7a4f797b4f044d28 = `<p>Need help setting up Pushover?<br/>Check out <a href='${$e699c1a854308eca$var$pushoverDocsLink}' target='_blank'>the docs here</a>.</p>`;
// Telegram
const $e699c1a854308eca$var$telegramChatIDLink = 'https://docs.influxdata.com/kapacitor/latest/guides/event-handler-setup/#telegram-chat-id';
const $e699c1a854308eca$export$294358b442f7130d = `<p>Need help finding your chat id?<br/>Check out <a target='_blank' href='${$e699c1a854308eca$var$telegramChatIDLink}'>these steps</a>.</p>`;
const $e699c1a854308eca$var$telegramTokenLink = 'https://docs.influxdata.com/kapacitor/latest/guides/event-handler-setup/#telegram-api-access-token';
const $e699c1a854308eca$export$637c646e27d6ef34 = `<p>Need help finding your token?<br/>Check out <a target='_blank' href='${$e699c1a854308eca$var$telegramTokenLink}'>these steps</a>.</p>`;


class $631e2b39c382d86e$var$PushoverConfig extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleEnabledChange = (e)=>{
            this.setState({
                enabled: e.target.checked
            });
            this.disableTest();
        }, this.handleSubmit = async (e)=>{
            e.preventDefault();
            const properties = {
                token: this.token.value,
                url: this.url.value,
                'user-key': this.userKey.value,
                enabled: this.state.enabled
            };
            const success = await this.props.onSave(properties);
            if (success) this.setState({
                testEnabled: true
            });
        }, this.disableTest = ()=>{
            this.setState({
                testEnabled: false
            });
        }, this.handleUserKeyRef = (r)=>this.userKey = r, this.handleTokenRef = (r)=>this.token = r;
        this.state = {
            testEnabled: this.props.enabled,
            enabled: (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(this.props, 'config.options.enabled', false)
        };
    }
    render() {
        const { options: options } = this.props.config;
        const { token: token, url: url } = options;
        const userKey = options['user-key'];
        const { testEnabled: testEnabled, enabled: enabled } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("form", {
            onSubmit: this.handleSubmit
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "user-key"
        }, "User Key", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1ca55233f3c1ef57$export$2e2bcd8739ae039), {
            tipID: "token",
            tipContent: (0, $e699c1a854308eca$export$7a4f797b4f044d28)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $5b6de86dd5c73541$export$2e2bcd8739ae039), {
            defaultValue: userKey,
            id: "user-key",
            refFunc: this.handleUserKeyRef,
            disableTest: this.disableTest,
            isFormEditing: !testEnabled
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "token"
        }, "Token", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1ca55233f3c1ef57$export$2e2bcd8739ae039), {
            tipID: "token",
            tipContent: (0, $e699c1a854308eca$export$7a4f797b4f044d28)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $5b6de86dd5c73541$export$2e2bcd8739ae039), {
            defaultValue: token,
            id: "token",
            refFunc: this.handleTokenRef,
            disableTest: this.disableTest,
            isFormEditing: !testEnabled
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "url"
        }, "Pushover URL"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: "url",
            type: "text",
            ref: (r)=>this.url = r,
            defaultValue: url || '',
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-control-static"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            type: "checkbox",
            id: "disabled",
            checked: enabled,
            onChange: this.handleEnabledChange
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "disabled"
        }, "Configuration Enabled"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group form-group-submit col-xs-12 text-center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-primary",
            type: "submit",
            disabled: this.state.testEnabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon checkmark"
        }), "Save Changes"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-primary",
            disabled: !this.state.testEnabled || !enabled,
            onClick: this.props.onTest
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon pulse-c"
        }), "Send Test Alert")));
    }
}
var $631e2b39c382d86e$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($631e2b39c382d86e$var$PushoverConfig);



var $hBdgJ = parcelRequire("hBdgJ");

var $NdCUR = parcelRequire("NdCUR");

class $7ba59b39fdd6afda$var$SensuConfig extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleEnabledChange = (e)=>{
            this.setState({
                enabled: e.target.checked
            });
            this.disableTest();
        }, this.handleSubmit = async (e)=>{
            e.preventDefault();
            const properties = {
                source: this.source.value,
                addr: this.addr.value,
                enabled: this.state.enabled
            };
            const success = await this.props.onSave(properties);
            if (success) this.setState({
                testEnabled: true
            });
        }, this.disableTest = ()=>{
            this.setState({
                testEnabled: false
            });
        };
        this.state = {
            testEnabled: this.props.enabled,
            enabled: (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(this.props, 'config.options.enabled', false)
        };
    }
    render() {
        const { source: source, addr: addr } = this.props.config.options;
        const { enabled: enabled } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("form", {
            onSubmit: this.handleSubmit
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12 col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "source"
        }, "Source"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: "source",
            type: "text",
            ref: (r)=>this.source = r,
            defaultValue: source || '',
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12 col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "address"
        }, "Address"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: "address",
            type: "text",
            ref: (r)=>this.addr = r,
            defaultValue: addr || '',
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-control-static"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            type: "checkbox",
            id: "disabled",
            checked: enabled,
            onChange: this.handleEnabledChange
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "disabled"
        }, "Configuration Enabled"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group form-group-submit col-xs-12 text-center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-primary",
            type: "submit",
            disabled: this.state.testEnabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon checkmark"
        }), "Save Changes"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-primary",
            disabled: !this.state.testEnabled || !enabled,
            onClick: this.props.onTest
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon pulse-c"
        }), "Send Test Alert")));
    }
}
var $7ba59b39fdd6afda$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($7ba59b39fdd6afda$var$SensuConfig);



var $hBdgJ = parcelRequire("hBdgJ");

var $NdCUR = parcelRequire("NdCUR");


class $bbf99afa31d06bb1$var$SlackConfig extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleWorkspaceChange = (e)=>{
            this.setState({
                workspace: e.target.value
            });
        }, this.handleTest = (e)=>{
            const { onTest: onTest, config: { options: { workspace: workspace, channel: channel } } } = this.props;
            onTest(e, {
                workspace: workspace,
                channel: channel
            });
        }, this.handleEnabledChange = (e)=>{
            this.setState({
                enabled: e.target.checked
            });
            this.disableTest();
        }, this.handleSubmit = async (e)=>{
            e.preventDefault();
            const { workspace: workspace } = this.state;
            const { isNewConfig: isNewConfig } = this.props;
            const properties = {
                url: this.url.value,
                channel: this.channel.value,
                enabled: this.state.enabled
            };
            if (isNewConfig) properties.workspace = workspace;
            const success = await this.props.onSave(properties, isNewConfig, workspace);
            if (success) this.setState({
                testEnabled: true
            });
        }, this.handleDelete = async (e)=>{
            e.preventDefault();
            const { workspace: workspace } = this.state;
            await this.props.onDelete(workspace, this.workspaceID);
        }, this.disableTest = ()=>{
            this.setState({
                testEnabled: false
            });
        }, this.handleUrlRef = (r)=>this.url = r;
        this.state = {
            testEnabled: this.props.enabled,
            enabled: (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(this.props, 'config.options.enabled', false),
            workspace: (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(this.props, 'config.options.workspace') || ''
        };
    }
    render() {
        const { url: url, channel: channel } = this.options;
        const { testEnabled: testEnabled, enabled: enabled, workspace: workspace } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("form", {
            onSubmit: this.handleSubmit
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: `${this.workspaceID}-nickname`
        }, "Nickname this Configuration"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: `${this.workspaceID}-nickname`,
            type: "text",
            placeholder: this.nicknamePlaceholder,
            value: workspace,
            onChange: this.handleWorkspaceChange,
            disabled: this.isNicknameDisabled
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: `${this.workspaceID}-url`
        }, "Slack Webhook URL (", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("a", {
            href: "https://api.slack.com/incoming-webhooks",
            target: "_"
        }, "see more on Slack webhooks"), ")"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $5b6de86dd5c73541$export$2e2bcd8739ae039), {
            defaultValue: url,
            id: `${this.workspaceID}-url`,
            refFunc: this.handleUrlRef,
            disableTest: this.disableTest,
            isFormEditing: !testEnabled
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: `${this.workspaceID}-slack-channel`
        }, "Slack Channel (optional)"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: `${this.workspaceID}-slack-channel`,
            type: "text",
            placeholder: "#alerts",
            ref: (r)=>this.channel = r,
            defaultValue: channel || '',
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-control-static"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            type: "checkbox",
            id: `${this.workspaceID}-disabled`,
            checked: enabled,
            onChange: this.handleEnabledChange
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: `${this.workspaceID}-disabled`
        }, "Configuration Enabled"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group form-group-submit col-xs-12 text-center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-primary",
            type: "submit",
            disabled: testEnabled || this.isWorkspaceEmpty
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon checkmark"
        }), "Save Changes"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-primary",
            disabled: this.isTestDisabled,
            onClick: this.handleTest
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon pulse-c"
        }), "Send Test Alert"), this.deleteButton, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("hr", null)));
    }
    get isNewConfig() {
        const { isNewConfig: isNewConfig } = this.props;
        return isNewConfig;
    }
    get options() {
        const { config: { options: options } } = this.props;
        return options;
    }
    get deleteButton() {
        if (this.isDefaultConfig) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-danger",
            onClick: this.handleDelete
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon trash"
        }), "Delete");
    }
    get nicknamePlaceholder() {
        if (this.isDefaultConfig) return 'Only for additional Configurations';
        return 'Must be different from previous Configurations';
    }
    get isDefaultConfig() {
        return this.props.isDefaultConfig;
    }
    get workspaceID() {
        return this.props.workspaceID;
    }
    get isWorkspaceEmpty() {
        const { workspace: workspace } = this.state;
        return workspace === '' && !this.isDefaultConfig;
    }
    get isTestDisabled() {
        const { testEnabled: testEnabled, enabled: enabled } = this.state;
        return !testEnabled || !enabled || this.isWorkspaceEmpty;
    }
    get isNicknameDisabled() {
        return !this.isNewConfig || this.isDefaultConfig;
    }
}
var $bbf99afa31d06bb1$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($bbf99afa31d06bb1$var$SlackConfig);



var $hBdgJ = parcelRequire("hBdgJ");

var $NdCUR = parcelRequire("NdCUR");

class $2e29b24ba0d423e1$var$SMTPConfig extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleEnabledChange = (e)=>{
            this.setState({
                enabled: e.target.checked
            });
            this.disableTest();
        }, this.handleSubmit = async (e)=>{
            e.preventDefault();
            const properties = {
                host: this.host.value,
                port: this.port.value,
                from: this.from.value,
                to: this.to.value ? [
                    this.to.value
                ] : [],
                username: this.username.value,
                password: this.password.value,
                enabled: this.state.enabled
            };
            const success = await this.props.onSave(properties);
            if (success) this.setState({
                testEnabled: true
            });
        }, this.disableTest = ()=>{
            this.setState({
                testEnabled: false
            });
        };
        this.state = {
            testEnabled: this.props.enabled,
            enabled: (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(this.props, 'config.options.enabled', false)
        };
    }
    render() {
        const { host: host, port: port, from: from, username: username, password: password, to: to } = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(this.props, 'config.options', {});
        const { enabled: enabled } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("form", {
            onSubmit: this.handleSubmit
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12 col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "smtp-host"
        }, "SMTP Host"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: "smtp-host",
            type: "text",
            ref: (r)=>this.host = r,
            defaultValue: host || '',
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12 col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "smtp-port"
        }, "SMTP Port"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: "smtp-port",
            type: "text",
            ref: (r)=>this.port = r,
            defaultValue: port.toString() || '',
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "smtp-from"
        }, "From Email"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: "smtp-from",
            placeholder: "email@domain.com",
            type: "text",
            ref: (r)=>this.from = r,
            defaultValue: from || '',
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12 col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "smtp-to"
        }, "To Email"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: "smtp-to",
            placeholder: "email@domain.com",
            type: "text",
            ref: (r)=>this.to = r,
            defaultValue: to || '',
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12 col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "smtp-user"
        }, "User"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: "smtp-user",
            type: "text",
            ref: (r)=>this.username = r,
            defaultValue: username || '',
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12 col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "smtp-password"
        }, "Password"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: "smtp-password",
            type: "password",
            ref: (r)=>this.password = r,
            defaultValue: `${password}`,
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-control-static"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            type: "checkbox",
            id: "disabled",
            checked: enabled,
            onChange: this.handleEnabledChange
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "disabled"
        }, "Configuration Enabled"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group form-group-submit col-xs-12 text-center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-primary",
            type: "submit",
            disabled: this.state.testEnabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon checkmark"
        }), "Save Changes"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-primary",
            disabled: !this.state.testEnabled || !enabled,
            onClick: this.props.onTest
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon pulse-c"
        }), "Send Test Alert")));
    }
}
var $2e29b24ba0d423e1$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($2e29b24ba0d423e1$var$SMTPConfig);



var $hBdgJ = parcelRequire("hBdgJ");

var $NdCUR = parcelRequire("NdCUR");


class $7ebb0dfea5f41a2b$var$TalkConfig extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleEnabledChange = (e)=>{
            this.setState({
                enabled: e.target.checked
            });
            this.disableTest();
        }, this.handleSubmit = async (e)=>{
            e.preventDefault();
            const properties = {
                url: this.url.value,
                author_name: this.author.value,
                enabled: this.state.enabled
            };
            const success = await this.props.onSave(properties);
            if (success) this.setState({
                testEnabled: true
            });
        }, this.disableTest = ()=>{
            this.setState({
                testEnabled: false
            });
        }, this.handleUrlRef = (r)=>this.url = r;
        this.state = {
            testEnabled: this.props.enabled,
            enabled: (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(this.props, 'config.options.enabled', false)
        };
    }
    render() {
        const { url: url, author_name: author } = this.props.config.options;
        const { testEnabled: testEnabled, enabled: enabled } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("form", {
            onSubmit: this.handleSubmit
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "url"
        }, "URL"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $5b6de86dd5c73541$export$2e2bcd8739ae039), {
            defaultValue: url,
            id: "url",
            refFunc: this.handleUrlRef,
            disableTest: this.disableTest,
            isFormEditing: !testEnabled
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "author"
        }, "Author Name"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: "author",
            type: "text",
            ref: (r)=>this.author = r,
            defaultValue: author || '',
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-control-static"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            type: "checkbox",
            id: "disabled",
            checked: enabled,
            onChange: this.handleEnabledChange
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "disabled"
        }, "Configuration Enabled"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group form-group-submit col-xs-12 text-center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-primary",
            type: "submit",
            disabled: this.state.testEnabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon checkmark"
        }), "Save Changes"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-primary",
            disabled: !this.state.testEnabled || !enabled,
            onClick: this.props.onTest
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon pulse-c"
        }), "Send Test Alert")));
    }
}
var $7ebb0dfea5f41a2b$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($7ebb0dfea5f41a2b$var$TalkConfig);



var $hBdgJ = parcelRequire("hBdgJ");

var $NdCUR = parcelRequire("NdCUR");




class $1939bb8bd1968e75$var$TelegramConfig extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleEnabledChange = (e)=>{
            this.setState({
                enabled: e.target.checked
            });
            this.disableTest();
        }, this.handleSubmit = async (e)=>{
            e.preventDefault();
            let parseMode;
            if (this.parseModeHTML.checked) parseMode = 'HTML';
            if (this.parseModeMarkdown.checked) parseMode = 'Markdown';
            const properties = {
                'chat-id': this.chatID.value,
                'disable-notification': this.disableNotification.checked,
                'disable-web-page-preview': this.disableWebPagePreview.checked,
                'parse-mode': parseMode,
                token: this.token.value,
                enabled: this.state.enabled
            };
            const success = await this.props.onSave(properties);
            if (success) this.setState({
                testEnabled: true
            });
        }, this.disableTest = ()=>{
            this.setState({
                testEnabled: false
            });
        }, this.handleTokenRef = (r)=>this.token = r;
        this.state = {
            testEnabled: this.props.enabled,
            enabled: (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(this.props, 'config.options.enabled', false)
        };
    }
    render() {
        const { options: options } = this.props.config;
        const { token: token } = options;
        const chatID = options['chat-id'];
        const disableNotification = options['disable-notification'];
        const disableWebPagePreview = options['disable-web-page-preview'];
        const parseMode = options['parse-mode'];
        const { testEnabled: testEnabled, enabled: enabled } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("form", {
            onSubmit: this.handleSubmit
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "alert alert-warning"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon triangle"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "alert-message"
        }, "You need a", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("a", {
            href: "https://docs.influxdata.com/kapacitor/latest/guides/event-handler-setup/#telegram-setup",
            target: "_blank"
        }, "Telegram Bot"), ' ', "to use this endpoint"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "token"
        }, "Token", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1ca55233f3c1ef57$export$2e2bcd8739ae039), {
            tipID: "token",
            tipContent: (0, $e699c1a854308eca$export$637c646e27d6ef34)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $5b6de86dd5c73541$export$2e2bcd8739ae039), {
            defaultValue: token,
            id: "token",
            refFunc: this.handleTokenRef,
            disableTest: this.disableTest,
            isFormEditing: !testEnabled
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "chat-id"
        }, "Chat ID", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1ca55233f3c1ef57$export$2e2bcd8739ae039), {
            tipID: "chat-id",
            tipContent: (0, $e699c1a854308eca$export$294358b442f7130d)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: "chat-id",
            type: "text",
            placeholder: "your-telegram-chat-id",
            ref: (r)=>this.chatID = r,
            defaultValue: chatID || '',
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "parseMode"
        }, "Select the alert message format"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-control-static"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "radio-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            id: "parseModeMarkdown",
            type: "radio",
            name: "parseMode",
            value: "markdown",
            defaultChecked: parseMode !== 'HTML',
            ref: (r)=>this.parseModeMarkdown = r,
            onChange: this.disableTest
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "parseModeMarkdown"
        }, "Markdown")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "radio-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            id: "parseModeHTML",
            type: "radio",
            name: "parseMode",
            value: "html",
            defaultChecked: parseMode === 'HTML',
            ref: (r)=>this.parseModeHTML = r,
            onChange: this.disableTest
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "parseModeHTML"
        }, "HTML")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-control-static"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            id: "disableWebPagePreview",
            type: "checkbox",
            defaultChecked: disableWebPagePreview,
            ref: (r)=>this.disableWebPagePreview = r,
            onChange: this.disableTest
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "disableWebPagePreview"
        }, "Disable", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("a", {
            href: "https://telegram.org/blog/link-preview",
            target: "_blank"
        }, "link previews"), ' ', "in alert messages."))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-control-static"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            id: "disableNotification",
            type: "checkbox",
            defaultChecked: disableNotification,
            ref: (r)=>this.disableNotification = r,
            onChange: this.disableTest
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "disableNotification"
        }, "Disable notifications on iOS devices and disable sounds on Android devices. Android users continue to receive notifications."))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-control-static"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            type: "checkbox",
            id: "disabled",
            checked: enabled,
            onChange: this.handleEnabledChange
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "disabled"
        }, "Configuration Enabled"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group form-group-submit col-xs-12 text-center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-primary",
            type: "submit",
            disabled: this.state.testEnabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon checkmark"
        }), "Save Changes"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-primary",
            disabled: !this.state.testEnabled || !enabled,
            onClick: this.props.onTest
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon pulse-c"
        }), "Send Test Alert")));
    }
}
var $1939bb8bd1968e75$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($1939bb8bd1968e75$var$TelegramConfig);



var $hBdgJ = parcelRequire("hBdgJ");

var $NdCUR = parcelRequire("NdCUR");


class $61ec3dfda10a67cf$var$VictorOpsConfig extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleEnabledChange = (e)=>{
            this.setState({
                enabled: e.target.checked
            });
            this.disableTest();
        }, this.handleSubmit = async (e)=>{
            e.preventDefault();
            const properties = {
                'api-key': this.apiKey.value,
                'routing-key': this.routingKey.value,
                url: this.url.value,
                enabled: this.state.enabled
            };
            const success = await this.props.onSave(properties);
            if (success) this.setState({
                testEnabled: true
            });
        }, this.disableTest = ()=>{
            this.setState({
                testEnabled: false
            });
        }, this.handleApiRef = (r)=>this.apiKey = r;
        this.state = {
            testEnabled: this.props.enabled,
            enabled: (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(this.props, 'config.options.enabled', false)
        };
    }
    render() {
        const { options: options } = this.props.config;
        const apiKey = options['api-key'];
        const routingKey = options['routing-key'];
        const { url: url } = options;
        const { testEnabled: testEnabled, enabled: enabled } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("form", {
            onSubmit: this.handleSubmit
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "api-key"
        }, "API Key"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $5b6de86dd5c73541$export$2e2bcd8739ae039), {
            defaultValue: apiKey,
            id: "api-key",
            refFunc: this.handleApiRef,
            disableTest: this.disableTest,
            isFormEditing: !testEnabled
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "routing-key"
        }, "Routing Key"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: "routing-key",
            type: "text",
            ref: (r)=>this.routingKey = r,
            defaultValue: routingKey || '',
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "url"
        }, "VictorOps URL"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: "url",
            type: "text",
            ref: (r)=>this.url = r,
            defaultValue: url || '',
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-control-static"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            type: "checkbox",
            id: "disabled",
            checked: enabled,
            onChange: this.handleEnabledChange
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "disabled"
        }, "Configuration Enabled"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group form-group-submit col-xs-12 text-center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-primary",
            type: "submit",
            disabled: this.state.testEnabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon checkmark"
        }), "Save Changes"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-primary",
            disabled: !this.state.testEnabled || !enabled,
            onClick: this.props.onTest
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon pulse-c"
        }), "Send Test Alert")));
    }
}
var $61ec3dfda10a67cf$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($61ec3dfda10a67cf$var$VictorOpsConfig);



var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");



class $cf03582cd2cbd45b$var$SlackConfigs extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.isNewConfig = (config)=>{
            return (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(config, 'isNewConfig', false);
        }, this.isDefaultConfig = (config)=>{
            return this.getWorkspace(config) === '' && !this.isNewConfig(config);
        }, this.getWorkspace = (config)=>{
            const { isMultipleConfigsSupported: isMultipleConfigsSupported } = this.props;
            if (isMultipleConfigsSupported) {
                const workspace = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(config, 'options', {
                    workspace: null
                }).workspace;
                if (workspace !== null) return workspace;
                return 'new';
            }
            return '';
        }, this.getWorkspaceID = (config)=>{
            if (this.isDefaultConfig(config)) return 'default';
            if (this.isNewConfig(config)) return 'new';
            return this.getWorkspace(config);
        }, this.addConfig = ()=>{
            const configs = this.configs;
            const newConfig = {
                options: {
                    url: false,
                    channel: '',
                    workspace: null
                },
                isNewConfig: true
            };
            this.setState({
                configs: [
                    ...configs,
                    newConfig
                ]
            });
        }, this.deleteConfig = (specificConfig, workspaceID)=>{
            if (workspaceID === 'new') {
                const configs = this.configs.filter((c)=>this.getWorkspaceID(c) !== workspaceID);
                this.setState({
                    configs: configs
                });
            } else this.props.onDelete(specificConfig);
        };
        this.state = {
            configs: this.props.configs
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            configs: nextProps.configs
        });
    }
    render() {
        const { configs: configs } = this.state;
        const { onSave: onSave, onTest: onTest, onEnabled: onEnabled } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null, configs.map((config)=>{
            const workspace = this.getWorkspace(config);
            const isNewConfig = this.isNewConfig(config);
            const enabled = onEnabled(workspace);
            const isDefaultConfig = this.isDefaultConfig(config);
            const workspaceID = this.getWorkspaceID(config);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $bbf99afa31d06bb1$export$2e2bcd8739ae039), {
                key: workspace,
                onSave: onSave,
                config: config,
                onTest: onTest,
                onDelete: this.deleteConfig,
                enabled: enabled,
                isNewConfig: isNewConfig,
                isDefaultConfig: isDefaultConfig,
                workspaceID: workspaceID
            });
        }), this.isAddingConfigsAllowed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12 text-center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-md btn-default",
            onClick: this.addConfig
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon plus"
        }), " Add Another Config")));
    }
    get configs() {
        return this.state.configs;
    }
    get isAddingConfigsAllowed() {
        const { isMultipleConfigsSupported: isMultipleConfigsSupported } = this.props;
        const { configs: configs } = this.state;
        const isAllConfigsPersisted = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).every(configs, (c)=>!this.isNewConfig(c));
        return isMultipleConfigsSupported && isAllConfigsPersisted;
    }
}
var $cf03582cd2cbd45b$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($cf03582cd2cbd45b$var$SlackConfigs);



var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");



const $97129d945190ae65$var$DEFAULT_CONFIG = {
    options: {
        id: '',
        brokers: [],
        timeout: '',
        'batch-size': 0,
        'batch-timeout': '',
        'use-ssl': false,
        'ssl-ca': '',
        'ssl-cert': '',
        'ssl-key': '',
        'insecure-skip-verify': false,
        enabled: false
    },
    isNewConfig: true
};
class $97129d945190ae65$var$KafkaConfigs extends (0, $NdCUR.Component) {
    static getDerivedStateFromProps(nextProps, prevState) {
        return {
            ...prevState,
            configs: nextProps.configs
        };
    }
    render() {
        const { onSave: onSave, onDelete: onDelete, onTest: onTest, notify: notify } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null, this.configs.map((c)=>{
            const enabled = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(c, 'options.enabled', false);
            const id = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(c, 'options.id', '');
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $565861ae3c11c98a$export$2e2bcd8739ae039), {
                config: c,
                onSave: onSave,
                onTest: onTest,
                onDelete: onDelete,
                enabled: enabled,
                notify: notify,
                key: id,
                id: id
            });
        }), this.isAddingConfigsAllowed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12 text-center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-md btn-default",
            onClick: this.handleAddConfig
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon plus"
        }), " Add Another Config")));
    }
    get configs() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).sortBy(this.state.configs, (c)=>{
            const id = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(c, 'options.id', '');
            const { isNewConfig: isNewConfig } = c;
            if (id === 'default') return '';
            if (isNewConfig) return Infinity;
            return id;
        });
    }
    get isAddingConfigsAllowed() {
        const { isMultipleConfigsSupported: isMultipleConfigsSupported } = this.props;
        const isAllConfigsPersisted = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).every(this.configs, (c)=>!c.isNewConfig);
        return isMultipleConfigsSupported && isAllConfigsPersisted;
    }
    constructor(...args){
        super(...args), this.state = {
            configs: []
        }, this.handleAddConfig = ()=>{
            const { configs: configs } = this.state;
            const newConfig = $97129d945190ae65$var$DEFAULT_CONFIG;
            const updatedConfigs = [
                ...configs,
                newConfig
            ];
            this.setState({
                configs: updatedConfigs
            });
        };
    }
}
var $97129d945190ae65$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($97129d945190ae65$var$KafkaConfigs);



var $hBdgJ = parcelRequire("hBdgJ");

var $NdCUR = parcelRequire("NdCUR");


class $d85d52da74866f4e$var$ServiceNowConfig extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handlePasswordRef = (r)=>this.password = r, this.handleEnabledChange = (e)=>{
            this.setState({
                enabled: e.target.checked
            });
            this.disableTest();
        }, this.handleSubmit = async (e)=>{
            e.preventDefault();
            const properties = {
                url: this.url.value,
                source: this.source.value,
                username: this.username.value,
                password: this.password.value,
                enabled: this.state.enabled
            };
            const success = await this.props.onSave(properties);
            if (success) this.setState({
                testEnabled: true
            });
        }, this.disableTest = ()=>{
            this.setState({
                testEnabled: false
            });
        };
        this.state = {
            testEnabled: this.props.enabled,
            enabled: (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(this.props, 'config.options.enabled', false)
        };
    }
    render() {
        const { source: source, url: url, username: username, password: password } = this.props.config.options;
        const { testEnabled: testEnabled, enabled: enabled } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("form", {
            onSubmit: this.handleSubmit
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "source"
        }, "URL"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: "url",
            type: "text",
            ref: (r)=>this.url = r,
            defaultValue: url || '',
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "source"
        }, "Source"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: "source",
            type: "text",
            ref: (r)=>this.source = r,
            defaultValue: source || '',
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12 col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "address"
        }, "Username"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: "username",
            type: "text",
            ref: (r)=>this.username = r,
            defaultValue: username || '',
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12 col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "address"
        }, "Password"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $5b6de86dd5c73541$export$2e2bcd8739ae039), {
            defaultValue: password,
            id: "password",
            refFunc: this.handlePasswordRef,
            disableTest: this.disableTest,
            isFormEditing: !testEnabled
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-control-static"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            type: "checkbox",
            id: "disabled",
            checked: enabled,
            onChange: this.handleEnabledChange
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "disabled"
        }, "Configuration Enabled"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group form-group-submit col-xs-12 text-center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-primary",
            type: "submit",
            disabled: this.state.testEnabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon checkmark"
        }), "Save Changes"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-primary",
            disabled: !this.state.testEnabled || !enabled,
            onClick: this.props.onTest
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon pulse-c"
        }), "Send Test Event")));
    }
}
var $d85d52da74866f4e$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($d85d52da74866f4e$var$ServiceNowConfig);



var $hBdgJ = parcelRequire("hBdgJ");

var $NdCUR = parcelRequire("NdCUR");


class $4e6d76cb8059b888$var$BigPandaConfig extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleTokenRef = (r)=>this.token = r, this.handleEnabledChange = (e)=>{
            this.setState({
                enabled: e.target.checked
            });
            this.disableTest();
        }, this.handleSubmit = async (e)=>{
            e.preventDefault();
            const properties = {
                url: this.url.value,
                token: this.token.value,
                'app-key': this.appKey.value,
                'insecure-skip-verify': this.insecureSkipVerify.checked,
                enabled: this.state.enabled
            };
            const success = await this.props.onSave(properties);
            if (success) this.setState({
                testEnabled: true
            });
        }, this.disableTest = ()=>{
            this.setState({
                testEnabled: false
            });
        };
        this.state = {
            testEnabled: this.props.enabled,
            enabled: (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(this.props, 'config.options.enabled', false)
        };
    }
    render() {
        const { url: url, token: token, 'app-key': appKey, 'insecure-skip-verify': insecureSkipVerify } = this.props.config.options;
        const { testEnabled: testEnabled, enabled: enabled } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("form", {
            onSubmit: this.handleSubmit
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "source"
        }, "URL"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: "url",
            type: "text",
            ref: (r)=>this.url = r,
            defaultValue: url || 'https://api.bigpanda.io/data/v2/alerts',
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "address"
        }, "Token"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $5b6de86dd5c73541$export$2e2bcd8739ae039), {
            defaultValue: token,
            id: "token",
            refFunc: this.handleTokenRef,
            disableTest: this.disableTest,
            isFormEditing: !testEnabled
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "source"
        }, "Application Key"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: "app-key",
            type: "text",
            ref: (r)=>this.appKey = r,
            placeholder: "ex: My_Application_Key",
            defaultValue: appKey || '',
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-control-static"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            id: "insecureSkipVerify",
            type: "checkbox",
            defaultChecked: insecureSkipVerify,
            ref: (r)=>this.insecureSkipVerify = r,
            onChange: this.disableTest
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "insecureSkipVerify"
        }, "Insecure Skip Verify"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-control-static"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            type: "checkbox",
            id: "disabled",
            checked: enabled,
            onChange: this.handleEnabledChange
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "disabled"
        }, "Configuration Enabled"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group form-group-submit col-xs-12 text-center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-primary",
            type: "submit",
            disabled: this.state.testEnabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon checkmark"
        }), "Save Changes"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-primary",
            disabled: !this.state.testEnabled || !enabled,
            onClick: this.props.onTest
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon pulse-c"
        }), "Send Test Event")));
    }
}
var $4e6d76cb8059b888$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($4e6d76cb8059b888$var$BigPandaConfig);



var $hBdgJ = parcelRequire("hBdgJ");

var $NdCUR = parcelRequire("NdCUR");

class $cd4418cefdc9b4cb$var$TeamsConfig extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleEnabledChange = (e)=>{
            this.setState({
                enabled: e.target.checked
            });
            this.disableTest();
        }, this.handleSubmit = async (e)=>{
            e.preventDefault();
            const properties = {
                'channel-url': this.channelURL.value,
                enabled: this.state.enabled
            };
            const success = await this.props.onSave(properties);
            if (success) this.setState({
                testEnabled: true
            });
        }, this.disableTest = ()=>{
            this.setState({
                testEnabled: false
            });
        };
        this.state = {
            testEnabled: this.props.enabled,
            enabled: (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(this.props, 'config.options.enabled', false)
        };
    }
    render() {
        const { 'channel-url': channelURL } = this.props.config.options;
        const { enabled: enabled } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("form", {
            onSubmit: this.handleSubmit
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "source"
        }, "Channel URL"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: "url",
            type: "text",
            ref: (r)=>this.channelURL = r,
            defaultValue: channelURL || '',
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-control-static"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            type: "checkbox",
            id: "disabled",
            checked: enabled,
            onChange: this.handleEnabledChange
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "disabled"
        }, "Configuration Enabled"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group form-group-submit col-xs-12 text-center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-primary",
            type: "submit",
            disabled: this.state.testEnabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon checkmark"
        }), "Save Changes"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-primary",
            disabled: !this.state.testEnabled || !enabled,
            onClick: this.props.onTest
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon pulse-c"
        }), "Send Test Event")));
    }
}
var $cd4418cefdc9b4cb$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($cd4418cefdc9b4cb$var$TeamsConfig);



var $hBdgJ = parcelRequire("hBdgJ");

var $NdCUR = parcelRequire("NdCUR");


class $ea7dff38fce2d4a4$var$ZenossConfig extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handlePasswordRef = (r)=>this.password = r, this.handleEnabledChange = (e)=>{
            this.setState({
                enabled: e.target.checked
            });
            this.disableTest();
        }, this.handleSubmit = async (e)=>{
            e.preventDefault();
            let tid;
            try {
                tid = parseInt(this.tid.value, 10);
            } catch (nfe) {
                console.error(nfe);
                tid = 1;
            }
            const properties = {
                url: this.url.value,
                username: this.username.value,
                password: this.password.value,
                action: this.action.value,
                method: this.method.value,
                type: this.type.value,
                tid: tid,
                collector: this.collector.value,
                'severity-map': {
                    ok: this.ok.value,
                    info: this.info.value,
                    warning: this.warning.value,
                    critical: this.critical.value
                },
                enabled: this.state.enabled
            };
            const success = await this.props.onSave(properties);
            if (success) this.setState({
                testEnabled: true
            });
        }, this.disableTest = ()=>{
            this.setState({
                testEnabled: false
            });
        };
        this.state = {
            testEnabled: this.props.enabled,
            enabled: (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(this.props, 'config.options.enabled', false)
        };
    }
    render() {
        const { url: url, username: username, password: password, action: action, method: method, type: type, tid: tid, collector: collector, 'severity-map': { ok: ok, info: info, warning: warning, critical: critical } } = this.props.config.options;
        const { testEnabled: testEnabled, enabled: enabled } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("form", {
            onSubmit: this.handleSubmit
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "source"
        }, "URL"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: "url",
            type: "text",
            ref: (r)=>this.url = r,
            defaultValue: url || '',
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12 col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "address"
        }, "Username"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: "username",
            type: "text",
            ref: (r)=>this.username = r,
            defaultValue: username || '',
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12 col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "address"
        }, "Password"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $5b6de86dd5c73541$export$2e2bcd8739ae039), {
            defaultValue: password,
            id: "password",
            refFunc: this.handlePasswordRef,
            disableTest: this.disableTest,
            isFormEditing: !testEnabled
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "source"
        }, "Action (Router Name)"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: "action",
            type: "text",
            ref: (r)=>this.action = r,
            defaultValue: action || '',
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "source"
        }, "Router Method"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: "method",
            type: "text",
            ref: (r)=>this.method = r,
            defaultValue: method || '',
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "source"
        }, "Event Type"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: "method",
            type: "text",
            ref: (r)=>this.type = r,
            defaultValue: type || '',
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "source"
        }, "Event TID"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: "tid",
            type: "number",
            ref: (r)=>this.tid = r,
            defaultValue: tid || '',
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "source"
        }, "Collector Name"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: "collector",
            type: "string",
            ref: (r)=>this.collector = r,
            defaultValue: collector || '',
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", null, "Kapacitor to Zenoss Severity Mapping"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-control-static"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12 col-md-6 col-lg-3"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "source"
        }, "OK"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: "okSeverity",
            type: "text",
            ref: (r)=>this.ok = r,
            defaultValue: ok || '',
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12 col-md-6 col-lg-3"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "source"
        }, "Info"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: "infoSeverity",
            type: "text",
            ref: (r)=>this.info = r,
            defaultValue: info || '',
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12 col-md-6 col-lg-3"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "source"
        }, "Warning"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: "warningSeverity",
            type: "text",
            ref: (r)=>this.warning = r,
            defaultValue: warning || '',
            onChange: this.disableTest
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12 col-md-6 col-lg-3"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "source"
        }, "Critical"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control",
            id: "criticalSeverity",
            type: "text",
            ref: (r)=>this.critical = r,
            defaultValue: critical || '',
            onChange: this.disableTest
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-control-static"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            type: "checkbox",
            id: "disabled",
            checked: enabled,
            onChange: this.handleEnabledChange
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "disabled"
        }, "Configuration Enabled"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group form-group-submit col-xs-12 text-center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-primary",
            type: "submit",
            disabled: this.state.testEnabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon checkmark"
        }), "Save Changes"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-primary",
            disabled: !this.state.testEnabled || !enabled,
            onClick: this.props.onTest
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon pulse-c"
        }), "Send Test Event")));
    }
}
var $ea7dff38fce2d4a4$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($ea7dff38fce2d4a4$var$ZenossConfig);






var $NdCUR = parcelRequire("NdCUR");
const $ddcee8a56d69bd31$var$DeprecationWarning = ({ message: message })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "alert alert-primary"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        className: "icon octagon"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "alert-message"
    }, message));
var $ddcee8a56d69bd31$export$2e2bcd8739ae039 = $ddcee8a56d69bd31$var$DeprecationWarning;




class $47b2c69d2176c604$var$AlertTabs extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.refreshKapacitorConfig = async (kapacitor)=>{
            try {
                const { data: { sections: sections } } = await (0, $3bff70d0456af5c0$export$1bad164085925c74)(kapacitor);
                this.setState({
                    configSections: sections
                });
            } catch (error) {
                this.setState({
                    configSections: null
                });
                this.props.notify((0, $ec1f42de4faacc37$export$6ef25cd61bd3e07b)());
            }
        }, this.getSectionElement = (sections, section)=>{
            return (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(sections, `${section}.elements.0`, null);
        }, this.getSectionElements = (sections, section)=>{
            return (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(sections, `${section}.elements`, null);
        }, this.getConfigEnabled = (sections, section)=>{
            if (section === (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).slack || section === (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).kafka) {
                const configElements = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(sections, `${section}.elements`, []);
                const enabledConfigElements = configElements.filter((e)=>{
                    const enabled = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(e, 'options.enabled', false);
                    return enabled;
                });
                return enabledConfigElements.length > 0;
            }
            return (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(sections, `${section}.elements.0.options.enabled`, false);
        }, this.getProperty = (sections, section, property)=>{
            return (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(sections, `${section}.elements.0.options.${property}`, null);
        }, this.getSpecificConfigEnabled = (sections, section)=>(specificConfig)=>{
                const elements = this.getSectionElements(sections, section);
                const elementIndex = elements.findIndex((element)=>(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(element, [
                        'options',
                        'workspace'
                    ]) === specificConfig);
                return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(sections, [
                    section,
                    'elements',
                    elementIndex.toString(),
                    'options',
                    'enabled'
                ], false);
            }, this.handleSaveConfig = (section)=>async (properties, isNewConfigInSection, specificConfig)=>{
                if (section !== '') {
                    const propsToSend = this.sanitizeProperties(section, properties);
                    try {
                        if (isNewConfigInSection) await (0, $3bff70d0456af5c0$export$93f16abed62a18d7)(this.props.kapacitor, section, propsToSend);
                        else await (0, $3bff70d0456af5c0$export$95c4bfedf542511b)(this.props.kapacitor, section, propsToSend, specificConfig);
                        this.refreshKapacitorConfig(this.props.kapacitor);
                        this.props.notify((0, $ec1f42de4faacc37$export$712befa86969b20d)(section));
                        return true;
                    } catch (err) {
                        const { data: data } = err;
                        const { error: error } = data;
                        if (!error) {
                            this.props.notify((0, $ec1f42de4faacc37$export$eabfbe16422aaee2)(section, 'Cannot save configuration'));
                            return false;
                        }
                        const errorMsg = error.split(': ').pop();
                        this.props.notify((0, $ec1f42de4faacc37$export$eabfbe16422aaee2)(section, errorMsg));
                        return false;
                    }
                }
            }, this.handleTestConfig = (section, options)=>async (e, specificConfigOptions)=>{
                e.preventDefault();
                try {
                    const { data: data } = await (0, $3bff70d0456af5c0$export$ed3a4ae2fb209f22)(this.props.kapacitor, section, options, specificConfigOptions);
                    if (data.success) this.props.notify((0, $ec1f42de4faacc37$export$b68e24ec4022574)(section));
                    else this.props.notify((0, $ec1f42de4faacc37$export$b5e165c93210c11b)(section, data.message));
                } catch (error) {
                    this.props.notify((0, $ec1f42de4faacc37$export$b5e165c93210c11b)(section));
                }
            }, this.handleDeleteConfig = (section)=>async (specificConfig)=>{
                try {
                    await (0, $3bff70d0456af5c0$export$4ef4a9eab7a466d3)(this.props.kapacitor, section, specificConfig);
                    await this.refreshKapacitorConfig(this.props.kapacitor);
                    this.props.notify((0, $ec1f42de4faacc37$export$31a167bb98c72316)(section, specificConfig));
                } catch (error) {
                    const errorMsg = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).join((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).drop((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).split(error, ': '), 2), ': ');
                    this.props.notify((0, $ec1f42de4faacc37$export$b2ced4ca8b27dade)(section, specificConfig, errorMsg));
                }
            }, this.sanitizeProperties = (section, properties)=>{
            const cleanProps = {
                enabled: true,
                ...properties
            };
            const { redacted: redacted } = this.getSectionElement(this.state.configSections, section);
            if (redacted && redacted.length) redacted.forEach((badProp)=>{
                if (properties[badProp] === 'true') delete cleanProps[badProp];
            });
            return cleanProps;
        }, this.getInitialIndex = (hash)=>{
            const index = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).indexOf((0, $2aff9a9dae44a870$export$dd6f23c26abf90c7), (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).replace(hash, '#', ''));
            return index >= 0 ? index : 0;
        }, this.isSupportedService = (serviceType)=>{
            const { services: services, configSections: configSections } = this.state;
            const foundKapacitorService = services.find((service)=>{
                return service.name === serviceType;
            });
            const foundSupportedService = (0, $2aff9a9dae44a870$export$dd6f23c26abf90c7).find((service)=>service === serviceType);
            const foundSection = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(configSections, serviceType, null);
            const isSupported = !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isUndefined(foundKapacitorService) && !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isUndefined(foundSupportedService) && !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isUndefined(foundSection);
            return isSupported;
        };
        this.state = {
            configSections: null,
            services: []
        };
    }
    async componentDidMount() {
        const { kapacitor: kapacitor } = this.props;
        try {
            this.refreshKapacitorConfig(kapacitor);
            const services = await (0, $3bff70d0456af5c0$export$82b5b7cb78251807)(kapacitor);
            this.setState({
                services: services
            });
        } catch (error) {
            this.setState({
                services: null
            });
            this.props.notify((0, $ec1f42de4faacc37$export$cf44035ccf0482b3)(kapacitor.name));
        }
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.kapacitor.url !== nextProps.kapacitor.url) this.refreshKapacitorConfig(nextProps.kapacitor);
    }
    render() {
        const { configSections: configSections } = this.state;
        const { hash: hash } = this.props;
        if (!configSections) return null;
        const pagerDutyV1Enabled = this.getConfigEnabled(configSections, (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).pagerduty);
        const opsGenieV1Enabled = this.getConfigEnabled(configSections, (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).opsgenie);
        const pagerDutyDeprecationMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null, "InfluxData will be deprecating the use of PagerDuty v1. Please update your Kapacitor and configure PagerDuty v2.");
        const opsGenieDeprecationMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null, "OpsGenie v1 is being deprecated. Please update your Kapacitor and configure OpsGenie v2.");
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel-heading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h2", {
            className: "panel-title"
        }, "Configure Alert Endpoints")), pagerDutyV1Enabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ddcee8a56d69bd31$export$2e2bcd8739ae039), {
            message: pagerDutyDeprecationMessage
        }), opsGenieV1Enabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ddcee8a56d69bd31$export$2e2bcd8739ae039), {
            message: opsGenieDeprecationMessage
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $d73d905aed2f329a$export$b2539bed5023c21c), {
            tabContentsClass: "config-endpoint",
            initialIndex: this.getInitialIndex(hash)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $d73d905aed2f329a$export$e51a686c67fdaa2d), {
            customClass: "config-endpoint--tabs"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).reduce(configSections, (acc, __, k)=>{
            if (this.isSupportedService(k)) return acc.concat(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $d73d905aed2f329a$export$3e41faf802a29e71), {
                key: k,
                isConfigured: this.getConfigEnabled(configSections, k)
            }, (0, $2aff9a9dae44a870$export$e830ee944b1c1767)[k]));
            return acc;
        }, [])), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $d73d905aed2f329a$export$5dae8d435677f210), {
            customClass: "config-endpoint--tab-contents"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).reduce(configSections, (acc, __, k)=>{
            if (this.isSupportedService(k)) return acc.concat(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $d73d905aed2f329a$export$3d96ec278d3efce4), {
                key: k
            }, this.getConfig(k)));
            return acc;
        }, []))));
    }
    getConfig(config) {
        const { configSections: configSections } = this.state;
        switch(config){
            case (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).alerta:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $aa1b638ec5727b5b$export$2e2bcd8739ae039), {
                    onSave: this.handleSaveConfig((0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).alerta),
                    config: this.getSectionElement(configSections, (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).alerta),
                    onTest: this.handleTestConfig((0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).alerta),
                    enabled: this.getConfigEnabled(configSections, (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).alerta)
                });
            case (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).kafka:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $97129d945190ae65$export$2e2bcd8739ae039), {
                    onSave: this.handleSaveConfig((0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).kafka),
                    configs: this.getSectionElements(configSections, (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).kafka),
                    onTest: this.handleTestConfig((0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).kafka, {
                        cluster: this.getProperty(configSections, (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).kafka, 'id')
                    }),
                    onEnabled: this.getSpecificConfigEnabled(configSections, (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).kafka),
                    notify: this.props.notify,
                    isMultipleConfigsSupported: this.isMultipleConfigsSupported,
                    onDelete: this.handleDeleteConfig((0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).kafka)
                });
            case (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).opsgenie:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $514756b62eb57658$export$2e2bcd8739ae039), {
                    onSave: this.handleSaveConfig((0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).opsgenie),
                    config: this.getSectionElement(configSections, (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).opsgenie),
                    onTest: this.handleTestConfig((0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).opsgenie),
                    enabled: this.getConfigEnabled(configSections, (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).opsgenie)
                });
            case (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).opsgenie2:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $514756b62eb57658$export$2e2bcd8739ae039), {
                    onSave: this.handleSaveConfig((0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).opsgenie2),
                    config: this.getSectionElement(configSections, (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).opsgenie2),
                    onTest: this.handleTestConfig((0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).opsgenie2),
                    enabled: this.getConfigEnabled(configSections, (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).opsgenie2),
                    v2: true
                });
            case (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).pagerduty:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $e678ff2e0c35158a$export$2e2bcd8739ae039), {
                    onSave: this.handleSaveConfig((0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).pagerduty),
                    config: this.getSectionElement(configSections, (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).pagerduty),
                    onTest: this.handleTestConfig((0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).pagerduty),
                    enabled: this.getConfigEnabled(configSections, (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).pagerduty)
                });
            case (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).pagerduty2:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1fe8c3cabe211880$export$2e2bcd8739ae039), {
                    onSave: this.handleSaveConfig((0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).pagerduty2),
                    config: this.getSectionElement(configSections, (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).pagerduty2),
                    onTest: this.handleTestConfig((0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).pagerduty2),
                    enabled: this.getConfigEnabled(configSections, (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).pagerduty2)
                });
            case (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).pushover:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $631e2b39c382d86e$export$2e2bcd8739ae039), {
                    onSave: this.handleSaveConfig((0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).pushover),
                    config: this.getSectionElement(configSections, (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).pushover),
                    onTest: this.handleTestConfig((0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).pushover),
                    enabled: this.getConfigEnabled(configSections, (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).pushover)
                });
            case (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).sensu:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7ba59b39fdd6afda$export$2e2bcd8739ae039), {
                    onSave: this.handleSaveConfig((0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).sensu),
                    config: this.getSectionElement(configSections, (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).sensu),
                    onTest: this.handleTestConfig((0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).sensu),
                    enabled: this.getConfigEnabled(configSections, (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).sensu)
                });
            case (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).slack:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $cf03582cd2cbd45b$export$2e2bcd8739ae039), {
                    configs: this.getSectionElements(configSections, (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).slack),
                    onSave: this.handleSaveConfig((0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).slack),
                    onTest: this.handleTestConfig((0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).slack),
                    onDelete: this.handleDeleteConfig((0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).slack),
                    onEnabled: this.getSpecificConfigEnabled(configSections, (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).slack),
                    isMultipleConfigsSupported: this.isMultipleConfigsSupported
                });
            case (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).smtp:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $2e29b24ba0d423e1$export$2e2bcd8739ae039), {
                    onSave: this.handleSaveConfig((0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).smtp),
                    config: this.getSectionElement(configSections, (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).smtp),
                    onTest: this.handleTestConfig((0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).smtp),
                    enabled: this.getConfigEnabled(configSections, (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).smtp)
                });
            case (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).talk:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7ebb0dfea5f41a2b$export$2e2bcd8739ae039), {
                    onSave: this.handleSaveConfig((0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).talk),
                    config: this.getSectionElement(configSections, (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).talk),
                    onTest: this.handleTestConfig((0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).talk),
                    enabled: this.getConfigEnabled(configSections, (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).talk)
                });
            case (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).telegram:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1939bb8bd1968e75$export$2e2bcd8739ae039), {
                    onSave: this.handleSaveConfig((0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).telegram),
                    config: this.getSectionElement(configSections, (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).telegram),
                    onTest: this.handleTestConfig((0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).telegram),
                    enabled: this.getConfigEnabled(configSections, (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).telegram)
                });
            case (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).victorops:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $61ec3dfda10a67cf$export$2e2bcd8739ae039), {
                    onSave: this.handleSaveConfig((0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).victorops),
                    config: this.getSectionElement(configSections, (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).victorops),
                    onTest: this.handleTestConfig((0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).victorops),
                    enabled: this.getConfigEnabled(configSections, (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).victorops)
                });
            case (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).servicenow:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $d85d52da74866f4e$export$2e2bcd8739ae039), {
                    onSave: this.handleSaveConfig((0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).servicenow),
                    config: this.getSectionElement(configSections, (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).servicenow),
                    onTest: this.handleTestConfig((0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).servicenow),
                    enabled: this.getConfigEnabled(configSections, (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).servicenow)
                });
            case (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).bigpanda:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $4e6d76cb8059b888$export$2e2bcd8739ae039), {
                    onSave: this.handleSaveConfig((0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).bigpanda),
                    config: this.getSectionElement(configSections, (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).bigpanda),
                    onTest: this.handleTestConfig((0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).bigpanda),
                    enabled: this.getConfigEnabled(configSections, (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).bigpanda)
                });
            case (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).teams:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $cd4418cefdc9b4cb$export$2e2bcd8739ae039), {
                    onSave: this.handleSaveConfig((0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).teams),
                    config: this.getSectionElement(configSections, (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).teams),
                    onTest: this.handleTestConfig((0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).teams),
                    enabled: this.getConfigEnabled(configSections, (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).teams)
                });
            case (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).zenoss:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ea7dff38fce2d4a4$export$2e2bcd8739ae039), {
                    onSave: this.handleSaveConfig((0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).zenoss),
                    config: this.getSectionElement(configSections, (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).zenoss),
                    onTest: this.handleTestConfig((0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).zenoss),
                    enabled: this.getConfigEnabled(configSections, (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).zenoss)
                });
        }
    }
    get isMultipleConfigsSupported() {
        const { configSections: configSections } = this.state;
        const hasPagerDuty2 = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(configSections, (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).pagerduty2, undefined);
        const hasOpsGenie2 = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(configSections, (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).opsgenie2, undefined);
        // if kapacitor supports pagerduty2 and opsgenie2, its at least v1.5
        return !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isUndefined(hasPagerDuty2) && !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isUndefined(hasOpsGenie2);
    }
}
var $47b2c69d2176c604$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($47b2c69d2176c604$var$AlertTabs);


const $0253e50655551aa6$var$AlertOutputs = ({ hash: hash, exists: exists, source: source, kapacitor: kapacitor, notify: notify })=>{
    if (exists) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $47b2c69d2176c604$export$2e2bcd8739ae039), {
        hash: hash,
        source: source,
        kapacitor: kapacitor,
        notify: notify
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel-heading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h2", {
        className: "panel-title"
    }, "Configure Alert Endpoints")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel-body"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "generic-empty-state"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", {
        className: "no-user-select"
    }, "Connect to an active Kapacitor instance to configure alerting endpoints"))));
};
var $0253e50655551aa6$export$2e2bcd8739ae039 = $0253e50655551aa6$var$AlertOutputs;



var $NdCUR = parcelRequire("NdCUR");
const $bb3547efb6ed3ea6$var$KapacitorFormInput = ({ name: name, label: label, value: value, placeholder: placeholder, onChange: onChange, maxLength: maxLength, inputType: inputType, customClass: customClass })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: `form-group ${customClass}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
        htmlFor: name
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
        className: "form-control",
        id: name,
        name: name,
        value: value,
        spellCheck: false,
        onChange: onChange,
        placeholder: placeholder,
        maxLength: maxLength,
        type: inputType
    }));
$bb3547efb6ed3ea6$var$KapacitorFormInput.defaultProps = {
    inputType: ''
};
var $bb3547efb6ed3ea6$export$2e2bcd8739ae039 = $bb3547efb6ed3ea6$var$KapacitorFormInput;




var $NdCUR = parcelRequire("NdCUR");
const $cb8c629075840449$export$97c9a2743dff7753 = `Unsafe SSL controls whether a client verifies the server's certificate chain and host name. \n
If checked, TLS accepts any certificate presented by the server and any host name in that certificate.`;


const $3187d16017557b6b$var$KapacitorFormSkipVerify = ({ kapacitor: { insecureSkipVerify: insecureSkipVerify }, onCheckboxChange: onCheckboxChange })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "form-group col-xs-12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "form-control-static"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
        type: "checkbox",
        id: "insecureSkipVerifyCheckbox",
        name: "insecureSkipVerify",
        checked: insecureSkipVerify,
        onChange: onCheckboxChange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
        htmlFor: "insecureSkipVerifyCheckbox"
    }, "Unsafe SSL")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
        className: "form-helper"
    }, (0, $cb8c629075840449$export$97c9a2743dff7753)));
};
var $3187d16017557b6b$export$2e2bcd8739ae039 = $3187d16017557b6b$var$KapacitorFormSkipVerify;


class $9891700b982d7645$var$KapacitorForm extends (0, $NdCUR.PureComponent) {
    render() {
        const { onChangeUrl: onChangeUrl, onReset: onReset, kapacitor: kapacitor, kapacitor: { name: name, username: username, password: password }, onSubmit: onSubmit, exists: exists, onInputChange: onInputChange, onCheckboxChange: onCheckboxChange, source: source, hash: hash, notify: notify } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header.Left, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Title, {
            title: this.headerText
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header.Right, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Contents, {
            fullWidth: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "container-fluid"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "col-md-3"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel-heading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h2", {
            className: "panel-title"
        }, "Connection Details")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("form", {
            onSubmit: onSubmit
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $bb3547efb6ed3ea6$export$2e2bcd8739ae039), {
            name: "kapaUrl",
            label: "Kapacitor URL",
            value: this.url,
            placeholder: this.url,
            onChange: onChangeUrl
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $bb3547efb6ed3ea6$export$2e2bcd8739ae039), {
            name: "name",
            label: "Name",
            value: name,
            placeholder: name,
            onChange: onInputChange,
            maxLength: 33
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $bb3547efb6ed3ea6$export$2e2bcd8739ae039), {
            name: "username",
            label: "Username",
            value: username || '',
            placeholder: username,
            onChange: onInputChange
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $bb3547efb6ed3ea6$export$2e2bcd8739ae039), {
            name: "password",
            label: "password",
            placeholder: "password",
            value: password || '',
            onChange: onInputChange,
            inputType: "password"
        })), this.isSecure && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $3187d16017557b6b$export$2e2bcd8739ae039), {
            kapacitor: kapacitor,
            onCheckboxChange: onCheckboxChange
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group form-group-submit col-xs-12 text-center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-default",
            type: "button",
            onClick: onReset,
            "data-test": "reset-button"
        }, "Reset"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-success",
            type: "submit",
            "data-test": "submit-button"
        }, this.buttonText)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "col-md-9"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $0253e50655551aa6$export$2e2bcd8739ae039), {
            hash: hash,
            exists: exists,
            source: source,
            kapacitor: kapacitor,
            notify: notify
        }))))));
    }
    get buttonText() {
        const { exists: exists } = this.props;
        if (exists) return 'Update';
        return 'Connect';
    }
    get headerText() {
        const { exists: exists } = this.props;
        let prefix = 'Add a New';
        if (exists) prefix = 'Configure';
        return `${prefix} Kapacitor Connection`;
    }
    get url() {
        const { kapacitor: { url: url } } = this.props;
        if (url) return url;
        return '';
    }
    get isSecure() {
        return this.url.startsWith('https');
    }
}
var $9891700b982d7645$export$2e2bcd8739ae039 = $9891700b982d7645$var$KapacitorForm;




const $42c0286812dea1ee$export$676e28d0be6385fa = 'My Kapacitor';
const $42c0286812dea1ee$export$b8ec28ea5f808021 = '9092';
class $42c0286812dea1ee$export$600d10585641722c extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleCheckboxChange = (e)=>{
            const { checked: checked } = e.target;
            this.setState({
                kapacitor: {
                    ...this.state.kapacitor,
                    insecureSkipVerify: checked
                }
            });
        }, this.handleInputChange = (e)=>{
            const { value: value, name: name } = e.target;
            this.setState((prevState)=>{
                const update = {
                    [name]: value
                };
                return {
                    kapacitor: {
                        ...prevState.kapacitor,
                        ...update
                    }
                };
            });
        }, this.handleChangeUrl = (e)=>{
            this.setState({
                kapacitor: {
                    ...this.state.kapacitor,
                    url: e.target.value
                }
            });
        }, this.handleSubmit = async (e)=>{
            e.preventDefault();
            const { notify: notify, source: source, source: { kapacitors: kapacitors = [] }, params: params, router: router } = this.props;
            const { kapacitor: kapacitor } = this.state;
            kapacitor.name = kapacitor.name.trim();
            const isNameTaken = kapacitors.some((k)=>k.name === kapacitor.name);
            const isNew = !params.id;
            if (isNew && isNameTaken) {
                notify((0, $ec1f42de4faacc37$export$9984e2e3836bf7bd)(kapacitor.name));
                return;
            }
            if (params.id) try {
                const { data: data } = await (0, $3bff70d0456af5c0$export$aed6d6f44d1e4150)(kapacitor);
                this.setState({
                    kapacitor: data
                });
                this.checkKapacitorConnection(data);
                notify((0, $ec1f42de4faacc37$export$6b6bc939c8a37bfd)());
            } catch (error) {
                console.error(error);
                notify((0, $ec1f42de4faacc37$export$925b076dd6957393)());
            }
            else try {
                const { data: data } = await (0, $3bff70d0456af5c0$export$3223cd8da62dca03)(source, kapacitor);
                // need up update kapacitor with info from server to AlertOutputs
                this.setState({
                    kapacitor: data
                });
                this.checkKapacitorConnection(data);
                router.push(`/sources/${source.id}/kapacitors/${data.id}/edit`);
                notify((0, $ec1f42de4faacc37$export$9bc16ccd017b167b)());
            } catch (error) {
                console.error(error);
                notify((0, $ec1f42de4faacc37$export$3a02db82a483db3a)());
            }
        }, this.handleResetToDefaults = (e)=>{
            e.preventDefault();
            this.setState({
                kapacitor: {
                    ...this.defaultKapacitor
                }
            });
        }, this.checkKapacitorConnection = async (kapacitor)=>{
            try {
                await (0, $3bff70d0456af5c0$export$41af5c3435cc7908)(kapacitor);
                this.setState({
                    exists: true
                });
            } catch (error) {
                console.error(error);
                this.setState({
                    exists: false
                });
                this.props.notify((0, $ec1f42de4faacc37$export$3d61248777676e06)());
            }
        }, this.parseKapacitorURL = ()=>{
            const parser = document.createElement('a');
            parser.href = this.props.source.url;
            return `${parser.protocol}//${parser.hostname}:${$42c0286812dea1ee$export$b8ec28ea5f808021}`;
        };
        this.state = {
            exists: false,
            kapacitor: this.defaultKapacitor
        };
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    async componentDidMount() {
        const { source: source, params: { id: id }, notify: notify } = this.props;
        if (!id) return;
        try {
            const kapacitor = await (0, $3bff70d0456af5c0$export$c751af5d7f198354)(source, id);
            this.setState({
                kapacitor: kapacitor
            });
            await this.checkKapacitorConnection(kapacitor);
        } catch (error) {
            console.error('Could not get kapacitor: ', error);
            notify((0, $ec1f42de4faacc37$export$3d61248777676e06)());
        }
    }
    render() {
        const { source: source, location: location, params: params, notify: notify } = this.props;
        const hash = location && location.hash || params && params.hash || '';
        const { exists: exists, kapacitor: kapacitor } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $9891700b982d7645$export$2e2bcd8739ae039), {
            hash: hash,
            notify: notify,
            source: source,
            exists: exists,
            kapacitor: kapacitor,
            onSubmit: this.handleSubmit,
            onChangeUrl: this.handleChangeUrl,
            onReset: this.handleResetToDefaults,
            onInputChange: this.handleInputChange,
            onCheckboxChange: this.handleCheckboxChange
        });
    }
    get defaultKapacitor() {
        return {
            active: false,
            insecureSkipVerify: false,
            links: {
                self: ''
            },
            name: $42c0286812dea1ee$export$676e28d0be6385fa,
            password: '',
            url: this.parseKapacitorURL(),
            username: ''
        };
    }
}
const $42c0286812dea1ee$var$mapDispatchToProps = (dispatch)=>({
        notify: (0, $1f80bbeadc1a0021$export$2e2bcd8739ae039)((0, $205d139de2918454$export$5e14cdade93d6f7b), dispatch)
    });
var $42c0286812dea1ee$export$2e2bcd8739ae039 = (0, $c8cd79e362cba2a4$export$a520fb22fccea800)((0, $ad1c01f2a894092c$export$2e2bcd8739ae039)(null, $42c0286812dea1ee$var$mapDispatchToProps)((0, $dffbdf89c590a961$export$2e2bcd8739ae039)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($42c0286812dea1ee$export$600d10585641722c))));



var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");




var $413b7ff06f318700$exports = {};

$parcel$export($413b7ff06f318700$exports, "fetchRule", function () { return $413b7ff06f318700$export$4248d1a6a8258b34; });
$parcel$export($413b7ff06f318700$exports, "getRule", function () { return $413b7ff06f318700$export$8a73d6c1af11382a; });
$parcel$export($413b7ff06f318700$exports, "loadDefaultRule", function () { return $413b7ff06f318700$export$9ad2097697580d5b; });
$parcel$export($413b7ff06f318700$exports, "fetchRules", function () { return $413b7ff06f318700$export$2b27f4974f0fa742; });
$parcel$export($413b7ff06f318700$exports, "chooseTrigger", function () { return $413b7ff06f318700$export$bd649937224d3465; });
$parcel$export($413b7ff06f318700$exports, "addEvery", function () { return $413b7ff06f318700$export$7d1b9bea9f720899; });
$parcel$export($413b7ff06f318700$exports, "removeEvery", function () { return $413b7ff06f318700$export$39d5a21094e0a2aa; });
$parcel$export($413b7ff06f318700$exports, "updateRuleValues", function () { return $413b7ff06f318700$export$76b35290c9b3f60d; });
$parcel$export($413b7ff06f318700$exports, "updateNoRecoveries", function () { return $413b7ff06f318700$export$c3a297e6b6cebb27; });
$parcel$export($413b7ff06f318700$exports, "updateStateChangesOnly", function () { return $413b7ff06f318700$export$ec4556127f23a870; });
$parcel$export($413b7ff06f318700$exports, "updateMessage", function () { return $413b7ff06f318700$export$829153c748a07de7; });
$parcel$export($413b7ff06f318700$exports, "updateDetails", function () { return $413b7ff06f318700$export$45bd8318dd851e4c; });
$parcel$export($413b7ff06f318700$exports, "updateAlertNodes", function () { return $413b7ff06f318700$export$78492587e639b552; });
$parcel$export($413b7ff06f318700$exports, "updateRuleName", function () { return $413b7ff06f318700$export$28d2c763842af1f5; });
$parcel$export($413b7ff06f318700$exports, "deleteRuleSuccess", function () { return $413b7ff06f318700$export$eabc55ac71b1475e; });
$parcel$export($413b7ff06f318700$exports, "deleteFluxTaskSuccess", function () { return $413b7ff06f318700$export$d968a446478351c1; });
$parcel$export($413b7ff06f318700$exports, "updateRuleStatusSuccess", function () { return $413b7ff06f318700$export$28708bbb7c03de51; });
$parcel$export($413b7ff06f318700$exports, "updateFluxTaskStatusSuccess", function () { return $413b7ff06f318700$export$c9b7a4d2a8b6f134; });
$parcel$export($413b7ff06f318700$exports, "deleteRule", function () { return $413b7ff06f318700$export$988cba38e738f27d; });
$parcel$export($413b7ff06f318700$exports, "deleteFluxTask", function () { return $413b7ff06f318700$export$6d05c72bb9cfb10; });
$parcel$export($413b7ff06f318700$exports, "updateRuleStatus", function () { return $413b7ff06f318700$export$fd0bd303c88e021a; });
$parcel$export($413b7ff06f318700$exports, "updateFluxTaskStatus", function () { return $413b7ff06f318700$export$eb74524fc20af70a; });
$parcel$export($413b7ff06f318700$exports, "createTask", function () { return $413b7ff06f318700$export$f7292ab7796be73c; });
$parcel$export($413b7ff06f318700$exports, "updateTask", function () { return $413b7ff06f318700$export$e8e0154b7bb02be4; });






var $hBdgJ = parcelRequire("hBdgJ");
function $c836572692edfbec$var$outRule(rule) {
    // fit into range
    const { value: value, rangeValue: rangeValue, operator: operator } = rule.values;
    if (operator === 'inside range' || operator === 'outside range') {
        rule.values.value = Math.min(Number(value), Number(rangeValue)).toString();
        rule.values.rangeValue = Math.max(Number(value), Number(rangeValue)).toString();
    }
    // remap serviceNow from '_type' back to 'type', see getRule/getRules
    if (Array.isArray((0, $hBdgJ.get)(rule, [
        'alertNodes',
        'serviceNow'
    ]))) {
        rule = (0, $hBdgJ.cloneDeep)(rule);
        rule.alertNodes.serviceNow = rule.alertNodes.serviceNow.map((val)=>({
                ...val,
                type: val._type,
                _type: undefined
            }));
    }
    // remap zenoss from '_type' back to 'type', see getRule/getRules
    if (Array.isArray((0, $hBdgJ.get)(rule, [
        'alertNodes',
        'zenoss'
    ]))) {
        rule = (0, $hBdgJ.cloneDeep)(rule);
        rule.alertNodes.zenoss = rule.alertNodes.zenoss.map((val)=>({
                ...val,
                type: val._type,
                _type: undefined
            }));
    }
    return rule;
}
async function $c836572692edfbec$export$56e87122f905fac0(kapacitor, rule) {
    await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
        method: 'POST',
        url: kapacitor.links.rules,
        data: $c836572692edfbec$var$outRule(rule)
    });
}
function $c836572692edfbec$var$addUnderscoreType(alertArray) {
    // rename 'type' to '_type' property, because `type` conflicts with existing UI property
    if (Array.isArray(alertArray)) alertArray.forEach((x)=>{
        if (x.type !== undefined) x._type = x.type;
    });
}
function $c836572692edfbec$var$convertTeamsChannelUrl(teamsArray) {
    // convert 'channel_url' (from backend) to 'channel-url' (used by UI)
    // see defect #5768 - the backend uses channel_url, but UI uses channel-url
    if (Array.isArray(teamsArray)) teamsArray.forEach((x)=>{
        if (x.channel_url !== undefined) x['channel-url'] = x.channel_url;
    });
}
async function $c836572692edfbec$export$f65e0b130162f295(kapacitor, opts) {
    const response = await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
        method: 'GET',
        url: kapacitor.links.rules,
        ...opts
    });
    const rules = (0, $hBdgJ.get)(response, [
        'data',
        'rules'
    ]);
    if (Array.isArray(rules)) rules.forEach((rule)=>{
        $c836572692edfbec$var$addUnderscoreType(rule.alertNodes.serviceNow);
        $c836572692edfbec$var$addUnderscoreType(rule.alertNodes.zenoss);
        $c836572692edfbec$var$convertTeamsChannelUrl(rule.alertNodes.teams);
    });
    return response;
}
async function $c836572692edfbec$export$8a73d6c1af11382a(kapacitor, ruleID) {
    try {
        const response = await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'GET',
            url: `${kapacitor.links.rules}/${ruleID}`
        });
        const alertNodes = (0, $hBdgJ.get)(response, [
            'data',
            'alertNodes'
        ]);
        if (alertNodes) {
            $c836572692edfbec$var$addUnderscoreType(alertNodes.serviceNow);
            $c836572692edfbec$var$addUnderscoreType(alertNodes.zenoss);
            $c836572692edfbec$var$convertTeamsChannelUrl(alertNodes.teams);
        }
        return response;
    } catch (error) {
        console.error(error);
        throw error;
    }
}
async function $c836572692edfbec$export$41f8c4ddfb0d5041(rule) {
    await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
        method: 'PUT',
        url: rule.links.self,
        data: $c836572692edfbec$var$outRule(rule)
    });
}
async function $c836572692edfbec$export$988cba38e738f27d(rule) {
    await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
        method: 'DELETE',
        url: rule.links.self
    });
}
async function $c836572692edfbec$export$fd0bd303c88e021a(rule, status) {
    await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
        method: 'PATCH',
        url: rule.links.self,
        data: {
            status: status
        }
    });
}
const $c836572692edfbec$var$kapacitorLogHeaders = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
};
const $c836572692edfbec$export$7827719c6ae7f112 = (kapacitor, ruleID, signal)=>{
    const url = `${kapacitor.links.proxy}?path=/kapacitor/v1preview/logs?task=${ruleID}`;
    const basepath = window.basepath || '';
    return fetch(`${basepath}${url}`, {
        method: 'GET',
        headers: $c836572692edfbec$var$kapacitorLogHeaders,
        credentials: 'include',
        signal: signal
    });
};
async function $c836572692edfbec$export$ff4fb5ac77366d84(kapacitor) {
    try {
        const result = await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'GET',
            url: `${kapacitor.links.proxy}?path=/kapacitor/v1preview/ping`,
            headers: $c836572692edfbec$var$kapacitorLogHeaders
        });
        const kapVersion = result.headers['x-kapacitor-version'];
        return kapVersion === '' ? null : kapVersion;
    } catch (error) {
        console.error(error);
        throw error;
    }
}


const $439ca78571292fda$export$f7292ab7796be73c = async (kapacitor, { id: id, dbrps: dbrps, tickscript: tickscript, type: type })=>{
    try {
        return await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'POST',
            url: kapacitor.links.rules,
            data: {
                id: id,
                type: type,
                dbrps: dbrps,
                tickscript: tickscript
            }
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $439ca78571292fda$export$e8e0154b7bb02be4 = async (kapacitor, { id: id, dbrps: dbrps, tickscript: tickscript, type: type }, ruleID)=>{
    try {
        return await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'PUT',
            url: `${kapacitor.links.rules}/${ruleID}`,
            data: {
                id: id,
                type: type,
                dbrps: dbrps,
                tickscript: tickscript
            }
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
};




var $hBdgJ = parcelRequire("hBdgJ");
const $1c87b80fc86b574d$var$tasksBatchLimit = 500;
const $1c87b80fc86b574d$export$2afa9e760b71914e = async (kapacitor, signal)=>{
    const taskIds = {};
    let lastID = '';
    for(;;){
        const { data: { tasks: tasks } } = await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'GET',
            url: kapacitor.links.proxy + '?path=' + encodeURIComponent(`/kapacitor/v1/api/v2/tasks?limit=${$1c87b80fc86b574d$var$tasksBatchLimit}&after=${lastID}`),
            signal: signal
        });
        if (!tasks || !tasks.length) break;
        lastID = tasks[tasks.length - 1].id;
        let noNewData = true;
        tasks.forEach((x)=>{
            if (taskIds[x.id]) return;
            noNewData = false;
            taskIds[x.id] = x;
        });
        if (noNewData) break;
        if (tasks.length < $1c87b80fc86b574d$var$tasksBatchLimit) break;
    }
    return (0, $hBdgJ.values)(taskIds).sort((a, b)=>a.name.localeCompare(b.name));
};
const $1c87b80fc86b574d$export$6a97019aaa996411 = async (kapacitor, taskID)=>{
    const { data: data } = await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
        method: 'GET',
        url: kapacitor.links.proxy + `?path=/kapacitor/v1/api/v2/tasks/${taskID}`
    });
    return data;
};
function $1c87b80fc86b574d$var$friendlyID(id) {
    if (id > 25) return $1c87b80fc86b574d$var$friendlyID(Math.trunc(id / 25)) + String.fromCharCode(id % 25);
    return String.fromCharCode(65 + id);
}
const $1c87b80fc86b574d$export$bc33a3e3875d93ec = async (kapacitor, taskID, maxItems)=>{
    const { data: data } = await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
        method: 'GET',
        url: kapacitor.links.proxy + `?path=/kapacitor/v1/api/v2/tasks/${taskID}/runs`
    });
    const logs = [];
    let nextClusterId = 0;
    const runsById = {};
    (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).each((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(data, [
        'runs'
    ], []), (run)=>{
        runsById[run.id] = {
            name: $1c87b80fc86b574d$var$friendlyID(nextClusterId++),
            lvl: run.status === 'failed' ? 'error' : 'info'
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).each(run.log, (l)=>logs.push(l));
    });
    logs.sort((a, b)=>b.time.localeCompare(a.time));
    return logs.slice(0, maxItems).map((x)=>{
        const runDetail = runsById[x.runID];
        return {
            id: `${x.runID}-${x.time}`,
            key: `${x.runID}-${x.time}`,
            service: 'flux_task',
            lvl: runDetail.lvl,
            ts: x.time,
            msg: x.message,
            tags: x.runID,
            cluster: runDetail.name
        };
    });
};
const $1c87b80fc86b574d$export$eb74524fc20af70a = (kapacitor, task, status)=>{
    return (0, $a537743573e5e486$export$2e2bcd8739ae039)({
        method: 'PATCH',
        url: kapacitor.links.proxy + '?path=' + task.links.self,
        data: {
            status: status
        }
    });
};
const $1c87b80fc86b574d$export$6d05c72bb9cfb10 = (kapacitor, task)=>{
    return (0, $a537743573e5e486$export$2e2bcd8739ae039)({
        method: 'DELETE',
        url: kapacitor.links.proxy + '?path=' + task.links.self
    });
};




const $413b7ff06f318700$var$loadQuery = (query)=>({
        type: 'KAPA_LOAD_QUERY',
        payload: {
            query: query
        }
    });
function $413b7ff06f318700$export$4248d1a6a8258b34(source, ruleID) {
    return (dispatch)=>{
        (0, $3bff70d0456af5c0$export$82a2e3b7e5164c8a)(source).then((kapacitor)=>{
            (0, $c836572692edfbec$export$8a73d6c1af11382a)(kapacitor, ruleID).then(({ data: rule })=>{
                if (rule.query) rule = Object.assign(rule, {
                    queryID: rule.query.id
                });
                dispatch({
                    type: 'LOAD_RULE',
                    payload: {
                        rule: rule
                    }
                });
                if (rule.query) dispatch($413b7ff06f318700$var$loadQuery(rule.query));
            });
        });
    };
}
const $413b7ff06f318700$var$addQuery = (queryID)=>({
        type: 'KAPA_ADD_QUERY',
        payload: {
            queryID: queryID
        }
    });
const $413b7ff06f318700$export$8a73d6c1af11382a = (kapacitor, ruleID)=>async (dispatch)=>{
        try {
            const { data: rule } = await (0, $c836572692edfbec$export$8a73d6c1af11382a)(kapacitor, ruleID);
            dispatch({
                type: 'LOAD_RULE',
                payload: {
                    rule: {
                        ...rule,
                        queryID: rule.query && rule.query.id
                    }
                }
            });
            if (rule.query) dispatch({
                type: 'LOAD_KAPACITOR_QUERY',
                payload: {
                    query: rule.query
                }
            });
        } catch (error) {
            console.error(error);
            throw error;
        }
    };
const $413b7ff06f318700$export$9ad2097697580d5b = ()=>{
    return (dispatch)=>{
        const queryID = (0, $dbdc5944552afab7$export$2e2bcd8739ae039)();
        dispatch({
            type: 'LOAD_DEFAULT_RULE',
            payload: {
                queryID: queryID
            }
        });
        dispatch($413b7ff06f318700$var$addQuery(queryID));
    };
};
const $413b7ff06f318700$export$2b27f4974f0fa742 = (kapacitor)=>async (dispatch)=>{
        try {
            const { data: { rules: rules } } = await (0, $c836572692edfbec$export$f65e0b130162f295)(kapacitor);
            dispatch({
                type: 'LOAD_RULES',
                payload: {
                    rules: rules
                }
            });
        } catch (error) {
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error));
        }
    };
const $413b7ff06f318700$export$bd649937224d3465 = (ruleID, trigger)=>({
        type: 'CHOOSE_TRIGGER',
        payload: {
            ruleID: ruleID,
            trigger: trigger
        }
    });
const $413b7ff06f318700$export$7d1b9bea9f720899 = (ruleID, frequency)=>({
        type: 'ADD_EVERY',
        payload: {
            ruleID: ruleID,
            frequency: frequency
        }
    });
const $413b7ff06f318700$export$39d5a21094e0a2aa = (ruleID)=>({
        type: 'REMOVE_EVERY',
        payload: {
            ruleID: ruleID
        }
    });
const $413b7ff06f318700$export$76b35290c9b3f60d = (ruleID, trigger, values)=>({
        type: 'UPDATE_RULE_VALUES',
        payload: {
            ruleID: ruleID,
            trigger: trigger,
            values: values
        }
    });
const $413b7ff06f318700$export$c3a297e6b6cebb27 = (ruleID, noRecoveries)=>({
        type: 'UPDATE_RULE_NORECOVERIES',
        payload: {
            ruleID: ruleID,
            noRecoveries: noRecoveries
        }
    });
const $413b7ff06f318700$export$ec4556127f23a870 = (ruleID, stateChangesOnly)=>({
        type: 'UPDATE_RULE_STATECHANGESONLY',
        payload: {
            ruleID: ruleID,
            stateChangesOnly: stateChangesOnly
        }
    });
const $413b7ff06f318700$export$829153c748a07de7 = (ruleID, message)=>({
        type: 'UPDATE_RULE_MESSAGE',
        payload: {
            ruleID: ruleID,
            message: message
        }
    });
const $413b7ff06f318700$export$45bd8318dd851e4c = (ruleID, details)=>({
        type: 'UPDATE_RULE_DETAILS',
        payload: {
            ruleID: ruleID,
            details: details
        }
    });
function $413b7ff06f318700$export$78492587e639b552(ruleID, alerts) {
    return {
        type: 'UPDATE_RULE_ALERT_NODES',
        payload: {
            ruleID: ruleID,
            alerts: alerts
        }
    };
}
const $413b7ff06f318700$export$28d2c763842af1f5 = (ruleID, name)=>({
        type: 'UPDATE_RULE_NAME',
        payload: {
            ruleID: ruleID,
            name: name
        }
    });
const $413b7ff06f318700$export$eabc55ac71b1475e = (ruleID)=>({
        type: 'DELETE_RULE_SUCCESS',
        payload: {
            ruleID: ruleID
        }
    });
const $413b7ff06f318700$export$d968a446478351c1 = (taskId)=>({
        type: 'DELETE_FLUX_TASK_SUCCESS',
        payload: {
            taskId: taskId
        }
    });
const $413b7ff06f318700$export$28708bbb7c03de51 = (ruleID, status)=>({
        type: 'UPDATE_RULE_STATUS_SUCCESS',
        payload: {
            ruleID: ruleID,
            status: status
        }
    });
const $413b7ff06f318700$export$c9b7a4d2a8b6f134 = (task, status)=>({
        type: 'UPDATE_FLUX_TASK_STATUS_SUCCESS',
        payload: {
            task: task,
            status: status
        }
    });
const $413b7ff06f318700$export$988cba38e738f27d = (rule)=>(dispatch)=>{
        (0, $c836572692edfbec$export$988cba38e738f27d)(rule).then(()=>{
            dispatch($413b7ff06f318700$export$eabc55ac71b1475e(rule.id));
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$b9fb5ac3b1648cf)(rule.name)));
        }).catch(()=>{
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$a023f39c3f194683)(rule.name)));
        });
    };
const $413b7ff06f318700$export$6d05c72bb9cfb10 = (kapacitor, task)=>(dispatch)=>{
        (0, $1c87b80fc86b574d$export$6d05c72bb9cfb10)(kapacitor, task).then(()=>{
            dispatch($413b7ff06f318700$export$d968a446478351c1(task.id));
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$b9fb5ac3b1648cf)(task.name)));
        }).catch(()=>{
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$a023f39c3f194683)(task.name)));
        });
    };
const $413b7ff06f318700$export$fd0bd303c88e021a = (rule, status)=>(dispatch)=>{
        (0, $c836572692edfbec$export$fd0bd303c88e021a)(rule, status).then(()=>{
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$41af055b5b12f786)(rule.name, status)));
        }).catch(()=>{
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$163d6d23beef07ab)(rule.name, status)));
        });
    };
const $413b7ff06f318700$export$eb74524fc20af70a = (kapacitor, task, status, notifySuccess = true)=>(dispatch)=>{
        return (0, $1c87b80fc86b574d$export$eb74524fc20af70a)(kapacitor, task, status).then(()=>{
            dispatch($413b7ff06f318700$export$c9b7a4d2a8b6f134(task, status));
            if (notifySuccess) dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$63f2ebe081830a1e)(task.name, status)));
            return true;
        }).catch(()=>{
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$e9e86592d2c92c39)(task.name, status)));
            return false;
        });
    };
const $413b7ff06f318700$export$f7292ab7796be73c = (kapacitor, task)=>async (dispatch)=>{
        try {
            const { data: data } = await (0, $439ca78571292fda$export$f7292ab7796be73c)(kapacitor, task);
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$6d828cef0570d712)()));
            return data;
        } catch (error) {
            if (!error) {
                dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)((0, $ec1f42de4faacc37$export$4b3289079e9741b6)()));
                return;
            }
            return error.data;
        }
    };
const $413b7ff06f318700$export$e8e0154b7bb02be4 = (kapacitor, task, ruleID, sourceID)=>async (dispatch)=>{
        try {
            const { data: data } = await (0, $439ca78571292fda$export$e8e0154b7bb02be4)(kapacitor, task, ruleID, sourceID);
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$74962bbe08d29d34)()));
            return data;
        } catch (error) {
            if (!error) {
                dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)((0, $ec1f42de4faacc37$export$46ee31e0b5169ec0)()));
                return;
            }
            return error.data;
        }
    };


var $4f7db08908a3084d$exports = {};

$parcel$export($4f7db08908a3084d$exports, "chooseNamespace", function () { return $4f7db08908a3084d$export$701baf921074a53d; });
$parcel$export($4f7db08908a3084d$exports, "chooseMeasurement", function () { return $4f7db08908a3084d$export$3d55885fc623730f; });
$parcel$export($4f7db08908a3084d$exports, "chooseTag", function () { return $4f7db08908a3084d$export$4480d0807bd82ec1; });
$parcel$export($4f7db08908a3084d$exports, "groupByTag", function () { return $4f7db08908a3084d$export$ca2e14d4de2d2b70; });
$parcel$export($4f7db08908a3084d$exports, "toggleTagAcceptance", function () { return $4f7db08908a3084d$export$ba46ef16c986791; });
$parcel$export($4f7db08908a3084d$exports, "toggleField", function () { return $4f7db08908a3084d$export$7c7a7daa922e15cc; });
$parcel$export($4f7db08908a3084d$exports, "applyFuncsToField", function () { return $4f7db08908a3084d$export$62c64e38b267511f; });
$parcel$export($4f7db08908a3084d$exports, "groupByTime", function () { return $4f7db08908a3084d$export$17dbdfc260d411c0; });
$parcel$export($4f7db08908a3084d$exports, "removeFuncs", function () { return $4f7db08908a3084d$export$6c7ecc4b49686af; });
$parcel$export($4f7db08908a3084d$exports, "timeShift", function () { return $4f7db08908a3084d$export$2cfa160b16d04366; });
const $4f7db08908a3084d$export$701baf921074a53d = (queryID, { database: database, retentionPolicy: retentionPolicy })=>({
        type: 'KAPA_CHOOSE_NAMESPACE',
        payload: {
            queryID: queryID,
            database: database,
            retentionPolicy: retentionPolicy
        }
    });
const $4f7db08908a3084d$export$3d55885fc623730f = (queryID, measurement)=>({
        type: 'KAPA_CHOOSE_MEASUREMENT',
        payload: {
            queryID: queryID,
            measurement: measurement
        }
    });
const $4f7db08908a3084d$export$4480d0807bd82ec1 = (queryID, tag)=>({
        type: 'KAPA_CHOOSE_TAG',
        payload: {
            queryID: queryID,
            tag: tag
        }
    });
const $4f7db08908a3084d$export$ca2e14d4de2d2b70 = (queryID, tagKey)=>({
        type: 'KAPA_GROUP_BY_TAG',
        payload: {
            queryID: queryID,
            tagKey: tagKey
        }
    });
const $4f7db08908a3084d$export$ba46ef16c986791 = (queryID)=>({
        type: 'KAPA_TOGGLE_TAG_ACCEPTANCE',
        payload: {
            queryID: queryID
        }
    });
const $4f7db08908a3084d$export$7c7a7daa922e15cc = (queryID, fieldFunc)=>({
        type: 'KAPA_TOGGLE_FIELD',
        payload: {
            queryID: queryID,
            fieldFunc: fieldFunc
        }
    });
const $4f7db08908a3084d$export$62c64e38b267511f = (queryID, fieldFunc)=>({
        type: 'KAPA_APPLY_FUNCS_TO_FIELD',
        payload: {
            queryID: queryID,
            fieldFunc: fieldFunc
        }
    });
const $4f7db08908a3084d$export$17dbdfc260d411c0 = (queryID, time)=>({
        type: 'KAPA_GROUP_BY_TIME',
        payload: {
            queryID: queryID,
            time: time
        }
    });
const $4f7db08908a3084d$export$6c7ecc4b49686af = (queryID, fields)=>({
        type: 'KAPA_REMOVE_FUNCS',
        payload: {
            queryID: queryID,
            fields: fields
        }
    });
const $4f7db08908a3084d$export$2cfa160b16d04366 = (queryID, shift)=>({
        type: 'KAPA_TIME_SHIFT',
        payload: {
            queryID: queryID,
            shift: shift
        }
    });






var $NdCUR = parcelRequire("NdCUR");




var $NdCUR = parcelRequire("NdCUR");


class $f86470b8a1d0e0dc$var$NameSection extends (0, $NdCUR.Component) {
    constructor(props){
        super(props), this.handleInputBlur = (reset)=>(e)=>{
                const { defaultName: defaultName, onRuleRename: onRuleRename, rule: rule } = this.props;
                let ruleName;
                if (reset) ruleName = defaultName;
                else ruleName = e.target.value;
                onRuleRename(rule.id, ruleName);
                this.setState({
                    reset: false
                });
            }, this.handleKeyDown = (e)=>{
            if (e.key === 'Enter') this.inputRef.blur();
            if (e.key === 'Escape') {
                this.inputRef.value = this.props.defaultName;
                this.setState({
                    reset: true
                }, ()=>this.inputRef.blur());
            }
        };
        this.state = {
            reset: false
        };
    }
    render() {
        const { defaultName: defaultName } = this.props;
        const { reset: reset } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "rule-section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h3", {
            className: "rule-section--heading"
        }, this.header), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "rule-section--body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "rule-section--row rule-section--row-first rule-section--row-last"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            type: "text",
            className: "form-control input-md form-malachite",
            defaultValue: defaultName,
            onBlur: this.handleInputBlur(reset),
            onKeyDown: this.handleKeyDown,
            placeholder: "ex: Ruley McRuleface",
            ref: (r)=>this.inputRef = r
        }))));
    }
    get header() {
        const { rule: { id: id } } = this.props;
        if (id === (0, $2aff9a9dae44a870$export$f20cff0eb3a8b896)) return 'Name this Alert Rule';
        return 'Name';
    }
}
var $f86470b8a1d0e0dc$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($f86470b8a1d0e0dc$var$NameSection);



var $NdCUR = parcelRequire("NdCUR");


var $NdCUR = parcelRequire("NdCUR");


const $acb56a36e7eeed30$var$periods = (0, $2aff9a9dae44a870$export$250100a662402f55).map((text)=>{
    return {
        text: text
    };
});
const $acb56a36e7eeed30$var$Deadman = ({ rule: rule, onChange: onChange })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "rule-section--row rule-section--row-first rule-section--row-last"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, "Send Alert if Data is missing for"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ca4f14339173643c$export$2e2bcd8739ae039), {
        className: "dropdown-80",
        menuClass: "dropdown-malachite",
        items: $acb56a36e7eeed30$var$periods,
        selected: rule.values.period,
        onChoose: onChange
    }));
var $acb56a36e7eeed30$export$2e2bcd8739ae039 = $acb56a36e7eeed30$var$Deadman;



var $NdCUR = parcelRequire("NdCUR");




class $c07b238a09f5576f$var$Threshold extends (0, $NdCUR.Component) {
    render() {
        const { rule: { values: { operator: operator, value: value } }, query: query, onDropdownChange: onDropdownChange, onRuleTypeInputChange: onRuleTypeInputChange } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "rule-section--row rule-section--row-first rule-section--border-bottom"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, "Send Alert where"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "rule-builder--metric"
        }, this.getField(query)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, "is"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ca4f14339173643c$export$2e2bcd8739ae039), {
            className: "dropdown-180",
            menuClass: "dropdown-malachite",
            items: this.operators,
            selected: operator,
            onChoose: onDropdownChange
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("form", {
            style: {
                display: 'flex'
            },
            onSubmit: this.noopSubmit
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control input-sm form-malachite monotype",
            style: {
                width: '160px',
                marginLeft: '6px'
            },
            type: "text",
            name: "lower",
            spellCheck: false,
            value: value,
            onChange: onRuleTypeInputChange,
            placeholder: this.firstInputPlaceholder
        }), this.secondInput));
    }
    get operators() {
        const type = 'operator';
        return (0, $2aff9a9dae44a870$export$e41da9f403454a3d).map((text)=>{
            return {
                text: text,
                type: type
            };
        });
    }
    get isSecondInputRequired() {
        const { rule: rule } = this.props;
        const operator = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(rule, 'values.operator', '');
        if (operator === 'inside range' || operator === 'outside range') return true;
        return false;
    }
    get firstInputPlaceholder() {
        if (this.isSecondInputRequired) return 'lower';
        return null;
    }
    get secondInput() {
        const { rule: rule, onRuleTypeInputChange: onRuleTypeInputChange } = this.props;
        const rangeValue = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(rule, 'values.rangeValue', '');
        if (this.isSecondInputRequired) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control input-sm form-malachite monotype",
            name: "upper",
            style: {
                width: '160px'
            },
            placeholder: "Upper",
            type: "text",
            spellCheck: false,
            value: rangeValue,
            onChange: onRuleTypeInputChange
        });
    }
    constructor(...args){
        super(...args), this.noopSubmit = (e)=>e.preventDefault(), this.getField = ({ fields: fields })=>{
            const alias = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(fields, '0.alias', '');
            if (!alias) return (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(fields, '0.value', 'Select a Time-Series');
            return alias;
        };
    }
}
var $c07b238a09f5576f$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($c07b238a09f5576f$var$Threshold);



var $NdCUR = parcelRequire("NdCUR");


const $48693af6e3a53519$var$mapToItems = (arr, type)=>arr.map((text)=>({
            text: text,
            type: type
        }));
const $48693af6e3a53519$var$changes = $48693af6e3a53519$var$mapToItems((0, $2aff9a9dae44a870$export$8598196f74460271), 'change');
const $48693af6e3a53519$var$shifts = $48693af6e3a53519$var$mapToItems((0, $2aff9a9dae44a870$export$41955167b1d28fc5), 'shift');
const $48693af6e3a53519$var$operators = $48693af6e3a53519$var$mapToItems((0, $2aff9a9dae44a870$export$7078aff415f59dec), 'operator');
const $48693af6e3a53519$var$Relative = ({ onRuleTypeInputChange: onRuleTypeInputChange, onDropdownChange: onDropdownChange, rule: { values: { change: change, shift: shift, operator: operator, value: value } } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "rule-section--row rule-section--row-first rule-section--border-bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, "Send Alert when"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ca4f14339173643c$export$2e2bcd8739ae039), {
        className: "dropdown-110",
        menuClass: "dropdown-malachite",
        items: $48693af6e3a53519$var$changes,
        selected: change,
        onChoose: onDropdownChange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, "compared to previous"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ca4f14339173643c$export$2e2bcd8739ae039), {
        className: "dropdown-80",
        menuClass: "dropdown-malachite",
        items: $48693af6e3a53519$var$shifts,
        selected: shift,
        onChoose: onDropdownChange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, "is"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ca4f14339173643c$export$2e2bcd8739ae039), {
        className: "dropdown-160",
        menuClass: "dropdown-malachite",
        items: $48693af6e3a53519$var$operators,
        selected: operator,
        onChoose: onDropdownChange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("form", {
        style: {
            display: 'flex'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
        className: "form-control input-sm form-malachite monotype",
        style: {
            width: '160px',
            marginLeft: '6px'
        },
        type: "text",
        name: "lower",
        spellCheck: false,
        value: value,
        onChange: onRuleTypeInputChange,
        required: true
    })), change === (0, $2aff9a9dae44a870$export$8598196f74460271)[1] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, "%") : null);
var $48693af6e3a53519$export$2e2bcd8739ae039 = $48693af6e3a53519$var$Relative;



var $NdCUR = parcelRequire("NdCUR");





class $df3f9314d998f7d5$var$DataSection extends (0, $NdCUR.PureComponent) {
    render() {
        const { query: query, isDeadman: isDeadman, isKapacitorRule: isKapacitorRule, onAddEvery: onAddEvery } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c8cd79e362cba2a4$export$5416f05742cfa18a).Consumer, null, (source)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                className: "rule-section"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                className: "query-builder"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $bc7a39c4dbc338a6$export$2e2bcd8739ae039), {
                query: query,
                onChooseNamespace: this.handleChooseNamespace
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b7417221f063c35e$export$2e2bcd8739ae039), {
                query: query,
                onChooseMeasurement: this.handleChooseMeasurement,
                onChooseTag: this.handleChooseTag,
                onGroupByTag: this.handleGroupByTag,
                onToggleTagAcceptance: this.handleToggleTagAcceptance,
                isKapacitorRule: isKapacitorRule
            }), isDeadman ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b1ff4c63c24666bb$export$2e2bcd8739ae039), {
                query: query,
                applyFuncsToField: this.handleApplyFuncsToField(onAddEvery),
                onGroupByTime: this.handleGroupByTime,
                onToggleField: this.handleToggleField,
                removeFuncs: this.handleRemoveFuncs,
                isKapacitorRule: isKapacitorRule,
                source: source
            }))));
    }
    constructor(...args){
        super(...args), this.handleChooseNamespace = (namespace)=>{
            const { actions: actions, query: query } = this.props;
            actions.chooseNamespace(query.id, namespace);
        }, this.handleChooseMeasurement = (measurement)=>{
            const { actions: actions, query: query } = this.props;
            actions.chooseMeasurement(query.id, measurement);
        }, this.handleToggleField = (field)=>{
            const { actions: actions, query: query } = this.props;
            actions.toggleField(query.id, field);
        }, this.handleGroupByTime = (time)=>{
            const { actions: actions, query: query } = this.props;
            actions.groupByTime(query.id, time);
        }, this.handleApplyFuncsToField = (onAddEvery)=>(fieldFunc)=>{
                const { actions: actions, query: query } = this.props;
                actions.applyFuncsToField(query.id, fieldFunc);
                onAddEvery((0, $2aff9a9dae44a870$export$a8b42427a6648e97));
            }, this.handleChooseTag = (tag)=>{
            const { actions: actions, query: query } = this.props;
            actions.chooseTag(query.id, tag);
        }, this.handleToggleTagAcceptance = ()=>{
            const { actions: actions, query: query } = this.props;
            actions.toggleTagAcceptance(query.id);
        }, this.handleGroupByTag = (tagKey)=>{
            const { actions: actions, query: query } = this.props;
            actions.groupByTag(query.id, tagKey);
        }, this.handleRemoveFuncs = (fields)=>{
            const { actions: actions, query: query } = this.props;
            actions.removeFuncs(query.id, fields);
        };
    }
}
var $df3f9314d998f7d5$export$2e2bcd8739ae039 = $df3f9314d998f7d5$var$DataSection;


// Libraries

var $NdCUR = parcelRequire("NdCUR");





var $NdCUR = parcelRequire("NdCUR");



/* eslint-disable no-undef */ 
const $c81cfe541c07e481$var$HIGHLIGHT = 'rgba(78, 216, 160, 0.3)';
const $c81cfe541c07e481$var$BACKGROUND = 'rgba(41, 41, 51, 1)';
const $c81cfe541c07e481$var$getFillColor = (operator)=>{
    const backgroundColor = $c81cfe541c07e481$var$BACKGROUND;
    const highlightColor = $c81cfe541c07e481$var$HIGHLIGHT;
    if (operator === (0, $2aff9a9dae44a870$export$2d7890f74d4e6421).OutsideRange) return backgroundColor;
    if (operator === (0, $2aff9a9dae44a870$export$2d7890f74d4e6421).NotEqualTo) return backgroundColor;
    return highlightColor;
};
const $c81cfe541c07e481$var$underlayCallback = (rule)=>(canvas, area, dygraph)=>{
        const { values: values } = rule;
        const { operator: operator, value: value } = values;
        if (rule.trigger !== 'threshold' || value === '' || !isFinite(value)) return;
        const theOnePercent = 0.01;
        let highlightStart = 0;
        let highlightEnd = 0;
        switch(operator){
            case (0, $2aff9a9dae44a870$export$2d7890f74d4e6421).EqualToOrGreaterThan:
            case (0, $2aff9a9dae44a870$export$2d7890f74d4e6421).GreaterThan:
                highlightStart = value;
                highlightEnd = dygraph.yAxisRange()[1];
                break;
            case (0, $2aff9a9dae44a870$export$2d7890f74d4e6421).EqualToOrLessThan:
            case (0, $2aff9a9dae44a870$export$2d7890f74d4e6421).LessThan:
                highlightStart = dygraph.yAxisRange()[0];
                highlightEnd = value;
                break;
            // case ThresholdOperators.LessThan: {
            //   const width =
            //     theOnePercent * (dygraph.yAxisRange()[1] - dygraph.yAxisRange()[0])
            //   highlightStart = +value - width
            //   highlightEnd = +value + width
            //   break
            // }
            case (0, $2aff9a9dae44a870$export$2d7890f74d4e6421).NotEqualTo:
                {
                    const width = theOnePercent * (dygraph.yAxisRange()[1] - dygraph.yAxisRange()[0]);
                    highlightStart = +value - width;
                    highlightEnd = +value + width;
                    canvas.fillStyle = $c81cfe541c07e481$var$HIGHLIGHT;
                    canvas.fillRect(area.x, area.y, area.w, area.h);
                    break;
                }
            case (0, $2aff9a9dae44a870$export$2d7890f74d4e6421).OutsideRange:
                highlightStart = Math.min(+value, +values.rangeValue);
                highlightEnd = Math.max(+value, +values.rangeValue);
                canvas.fillStyle = $c81cfe541c07e481$var$HIGHLIGHT;
                canvas.fillRect(area.x, area.y, area.w, area.h);
                break;
            case (0, $2aff9a9dae44a870$export$2d7890f74d4e6421).InsideRange:
                highlightStart = Math.min(+value, +values.rangeValue);
                highlightEnd = Math.max(+value, +values.rangeValue);
                break;
        }
        const bottom = dygraph.toDomYCoord(highlightStart);
        const top = dygraph.toDomYCoord(highlightEnd);
        const fillColor = $c81cfe541c07e481$var$getFillColor(operator);
        canvas.fillStyle = fillColor;
        canvas.fillRect(area.x, top, area.w, bottom - top);
    };
var $c81cfe541c07e481$export$2e2bcd8739ae039 = $c81cfe541c07e481$var$underlayCallback;




class $0228c0385a3d47a1$var$RuleGraphDygraph extends (0, $NdCUR.Component) {
    constructor(props){
        super(props), this.loadDygraphData = async ()=>{
            const { timeSeries: timeSeries } = this.props;
            const result = await (0, $4420ff9299c1c25c$export$6f8771e84995407d)(timeSeries, 'rule-builder');
            this.setState({
                timeSeriesToDygraphResult: result
            });
        };
        this.state = {
            timeSeriesToDygraphResult: null
        };
    }
    componentDidMount() {
        if (this.props.timeSeries) this.loadDygraphData();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.timeSeries !== this.props.timeSeries) this.loadDygraphData();
    }
    render() {
        const { timeRange: timeRange, rule: rule } = this.props;
        const { timeSeriesToDygraphResult: timeSeriesToDygraphResult } = this.state;
        if (!timeSeriesToDygraphResult) return null;
        if (timeSeriesToDygraphResult.unsupportedValue !== undefined) {
            console.error('Unsupported y-axis value, cannot display data', timeSeriesToDygraphResult);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", {
                className: "unexpected-error"
            }, "Unsupported y-axis value, only numbers are supported.");
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c99ab73e7002f8ba$export$2e2bcd8739ae039), {
            labels: timeSeriesToDygraphResult.labels,
            staticLegend: false,
            isGraphFilled: false,
            ruleValues: rule.values,
            options: this.options,
            timeRange: timeRange,
            queries: this.queries,
            timeSeries: timeSeriesToDygraphResult.timeSeries,
            dygraphSeries: timeSeriesToDygraphResult.dygraphSeries,
            colors: (0, $b00e3cd70e675d45$export$68073cd983ce53ee),
            containerStyle: this.containerStyle,
            underlayCallback: (0, $c81cfe541c07e481$export$2e2bcd8739ae039)(rule),
            handleSetHoverTime: this.props.setHoverTime
        });
    }
    get containerStyle() {
        return {
            width: 'calc(100% - 32px)',
            height: 'calc(100% - 16px)',
            position: 'absolute',
            top: '8px'
        };
    }
    get options() {
        return {
            rightGap: 0,
            yRangePad: 10,
            labelsKMB: true,
            fillGraph: true,
            axisLabelWidth: 60,
            animatedZooms: true,
            drawAxesAtZero: true,
            axisLineColor: '#383846',
            gridLineColor: '#383846',
            connectSeparatedPoints: true
        };
    }
    get queries() {
        const { query: query, timeRange: timeRange } = this.props;
        return (0, $88fea4b168b314ad$export$2e2bcd8739ae039)([
            query
        ], timeRange);
    }
}
var $0228c0385a3d47a1$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($0228c0385a3d47a1$var$RuleGraphDygraph);








class $e6aecc7fde6ae810$var$RuleGraph extends (0, $NdCUR.PureComponent) {
    render() {
        const { source: source, onChooseTimeRange: onChooseTimeRange, timeRange: timeRange, rule: rule } = this.props;
        if (!this.queryText) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "rule-builder--graph-empty"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, "Select a ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("strong", null, "Time-Series"), " to preview on a graph"));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "rule-builder--graph"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "rule-builder--graph-options"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, "Preview Data from"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $80cff9834e653b0a$export$2e2bcd8739ae039), {
            onChooseTimeRange: onChooseTimeRange,
            selected: timeRange,
            preventCustomTimeRange: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "dygraph graph--hasYLabel",
            style: this.style
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $11dac49c5bd352c2$export$2e2bcd8739ae039), {
            timeRange: timeRange,
            source: source,
            queries: this.queries,
            templates: this.templates,
            uuid: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)()
        }, (data)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $0228c0385a3d47a1$export$2e2bcd8739ae039), {
                loading: data.loading,
                query: this.props.query,
                rule: rule,
                timeRange: timeRange,
                timeSeries: data.timeSeriesInfluxQL,
                setHoverTime: this.props.setHoverTime
            });
        })));
    }
    get style() {
        return {
            height: '100%'
        };
    }
    get queryText() {
        const { timeRange: timeRange, query: query } = this.props;
        const lower = timeRange.lower;
        return (0, $7b2c5b24a44a7fa2$export$2e2bcd8739ae039)({
            lower: lower
        }, query);
    }
    get templates() {
        const { timeRange: timeRange } = this.props;
        const dashboardTime = {
            id: (0, $e10a8602f56394e3$export$24969386fef72130),
            tempVar: (0, $e10a8602f56394e3$export$24969386fef72130),
            type: (0, $ae4c87db4f4621dc$export$fd0446c06165ed92).Constant,
            label: '',
            values: [
                {
                    value: timeRange.lower,
                    type: (0, $ae4c87db4f4621dc$export$fdb0c74e1d4dd76b).Constant,
                    selected: true,
                    localSelected: true
                }
            ]
        };
        return [
            dashboardTime
        ];
    }
    get queries() {
        const { query: query, timeRange: timeRange } = this.props;
        return (0, $88fea4b168b314ad$export$2e2bcd8739ae039)([
            query
        ], timeRange);
    }
}
const $e6aecc7fde6ae810$var$mdtp = {
    setHoverTime: (0, $9859d1d8ae3f2524$export$fe6c3dd773ddd054)
};
var $e6aecc7fde6ae810$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)(null, $e6aecc7fde6ae810$var$mdtp)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($e6aecc7fde6ae810$var$RuleGraph));



class $fb69a5debf0306ef$var$ValuesSection extends (0, $NdCUR.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "rule-section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h3", {
            className: "rule-section--heading"
        }, "Alert Type"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "rule-section--body"
        }, this.triggerSelector, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h3", {
            className: "rule-section--sub-heading"
        }, "Time Series"), this.dataSection, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h3", {
            className: "rule-section--sub-heading"
        }, "Conditions"), this.thresholdRule, this.relativeRule, this.deadmanRule, this.ruleGraph));
    }
    get triggerSelector() {
        const { rule: rule } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "rule-section--row rule-section--row-first rule-section--row-last"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, "Choose One:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039), {
            color: (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Success
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039).Button, {
            id: "rule-builder-trigger--threshold",
            value: (0, $61056af5b9250c91$export$be0001227188532f).Threshold,
            titleText: "Use Threshold rule type",
            active: rule.trigger === (0, $61056af5b9250c91$export$be0001227188532f).Threshold,
            onClick: this.handleTriggerTabClick
        }, "Threshold"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039).Button, {
            id: "rule-builder-trigger--relative",
            value: (0, $61056af5b9250c91$export$be0001227188532f).Relative,
            titleText: "Use Relative rule type",
            active: rule.trigger === (0, $61056af5b9250c91$export$be0001227188532f).Relative,
            onClick: this.handleTriggerTabClick
        }, "Relative"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039).Button, {
            id: "rule-builder-trigger--deadman",
            value: (0, $61056af5b9250c91$export$be0001227188532f).Deadman,
            titleText: "Use Deadman rule type",
            active: rule.trigger === (0, $61056af5b9250c91$export$be0001227188532f).Deadman,
            onClick: this.handleTriggerTabClick
        }, "Deadman")));
    }
    get dataSection() {
        const { rule: rule, query: query, timeRange: timeRange, onAddEvery: onAddEvery, queryConfigActions: queryConfigActions } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $df3f9314d998f7d5$export$2e2bcd8739ae039), {
            query: query,
            timeRange: timeRange,
            isKapacitorRule: true,
            actions: queryConfigActions,
            onAddEvery: onAddEvery,
            isDeadman: this.isDeadman(rule)
        });
    }
    get thresholdRule() {
        const { rule: rule, query: query, onRuleTypeInputChange: onRuleTypeInputChange, onRuleTypeDropdownChange: onRuleTypeDropdownChange } = this.props;
        if (rule.trigger === (0, $61056af5b9250c91$export$be0001227188532f).Threshold) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c07b238a09f5576f$export$2e2bcd8739ae039), {
            rule: rule,
            query: query,
            onDropdownChange: onRuleTypeDropdownChange,
            onRuleTypeInputChange: onRuleTypeInputChange
        });
    }
    get relativeRule() {
        const { rule: rule, onRuleTypeInputChange: onRuleTypeInputChange, onRuleTypeDropdownChange: onRuleTypeDropdownChange } = this.props;
        if (rule.trigger === (0, $61056af5b9250c91$export$be0001227188532f).Relative) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $48693af6e3a53519$export$2e2bcd8739ae039), {
            rule: rule,
            onDropdownChange: onRuleTypeDropdownChange,
            onRuleTypeInputChange: onRuleTypeInputChange
        });
    }
    get deadmanRule() {
        const { rule: rule, onDeadmanChange: onDeadmanChange } = this.props;
        if (rule.trigger === (0, $61056af5b9250c91$export$be0001227188532f).Deadman) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $acb56a36e7eeed30$export$2e2bcd8739ae039), {
            rule: rule,
            onChange: onDeadmanChange
        });
    }
    get ruleGraph() {
        const { rule: rule, query: query, source: source, timeRange: timeRange, onChooseTimeRange: onChooseTimeRange } = this.props;
        if (rule.trigger === (0, $61056af5b9250c91$export$be0001227188532f).Threshold || rule.trigger === (0, $61056af5b9250c91$export$be0001227188532f).Relative) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $e6aecc7fde6ae810$export$2e2bcd8739ae039), {
            rule: rule,
            query: query,
            source: source,
            timeRange: timeRange,
            onChooseTimeRange: onChooseTimeRange
        });
    }
    constructor(...args){
        super(...args), this.handleTriggerTabClick = (trigger)=>{
            const { rule: rule, onChooseTrigger: onChooseTrigger } = this.props;
            onChooseTrigger(rule.id, trigger);
        }, this.isDeadman = (rule)=>{
            return rule.trigger === (0, $61056af5b9250c91$export$be0001227188532f).Deadman;
        };
    }
}
var $fb69a5debf0306ef$export$2e2bcd8739ae039 = $fb69a5debf0306ef$var$ValuesSection;



var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");

var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");

var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");

var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");

var $hBdgJ = parcelRequire("hBdgJ");
const $14c19c656a2c7fbe$var$HandlerInput = ({ fieldName: fieldName, fieldDisplay: fieldDisplay, placeholder: placeholder, selectedHandler: selectedHandler, handleModifyHandler: handleModifyHandler, redacted: redacted = false, disabled: disabled = false, fieldColumns: fieldColumns = 'col-md-6', parseToArray: parseToArray = false, headerIndex: headerIndex = 0, type: type = 'text' })=>{
    const formGroupClass = `form-group ${fieldColumns}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: formGroupClass
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
        htmlFor: fieldName
    }, fieldDisplay), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: redacted ? 'form-control-static redacted-handler' : null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
        name: fieldName,
        id: selectedHandler.alias + fieldName,
        className: "form-control input-sm form-malachite",
        type: redacted ? 'hidden' : type,
        placeholder: placeholder,
        onChange: handleModifyHandler(selectedHandler, fieldName, parseToArray, headerIndex),
        value: parseToArray ? (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).join(selectedHandler[fieldName], ' ') : selectedHandler[fieldName] || '',
        autoComplete: "off",
        spellCheck: "false",
        disabled: disabled
    }), redacted ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        className: "alert-value-set"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        className: "icon checkmark"
    }), " Value set in Config") : null));
};
const { func: $14c19c656a2c7fbe$var$func, shape: $14c19c656a2c7fbe$var$shape, string: $14c19c656a2c7fbe$var$string, bool: $14c19c656a2c7fbe$var$bool, number: $14c19c656a2c7fbe$var$number } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$14c19c656a2c7fbe$var$HandlerInput.propTypes = {
    fieldName: $14c19c656a2c7fbe$var$string.isRequired,
    fieldDisplay: $14c19c656a2c7fbe$var$string,
    placeholder: $14c19c656a2c7fbe$var$string,
    disabled: $14c19c656a2c7fbe$var$bool,
    redacted: $14c19c656a2c7fbe$var$bool,
    selectedHandler: $14c19c656a2c7fbe$var$shape({}).isRequired,
    handleModifyHandler: $14c19c656a2c7fbe$var$func.isRequired,
    fieldColumns: $14c19c656a2c7fbe$var$string,
    parseToArray: $14c19c656a2c7fbe$var$bool,
    headerIndex: $14c19c656a2c7fbe$var$number
};
var $14c19c656a2c7fbe$export$2e2bcd8739ae039 = $14c19c656a2c7fbe$var$HandlerInput;


const $f358605b287be4cc$var$PostHandler = ({ selectedHandler: selectedHandler, handleModifyHandler: handleModifyHandler })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab-contents"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab--parameters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", null, "Parameters for this Alert Handler"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "faux-form"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "url",
        fieldDisplay: "HTTP endpoint for POST request",
        placeholder: "ex: http://example.com/api/alert",
        fieldColumns: "col-md-12"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "headerKey",
        fieldDisplay: "Header Key",
        placeholder: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "headerValue",
        fieldDisplay: "Header Value",
        placeholder: ""
    }))));
const { func: $f358605b287be4cc$var$func, shape: $f358605b287be4cc$var$shape } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$f358605b287be4cc$var$PostHandler.propTypes = {
    selectedHandler: $f358605b287be4cc$var$shape({}).isRequired,
    handleModifyHandler: $f358605b287be4cc$var$func.isRequired
};
var $f358605b287be4cc$export$2e2bcd8739ae039 = $f358605b287be4cc$var$PostHandler;



var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");

const $e1d0b0f278c8d5b2$var$TcpHandler = ({ selectedHandler: selectedHandler, handleModifyHandler: handleModifyHandler })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab-contents"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab--parameters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", null, "Parameters for this Alert Handler"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "faux-form"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "address",
        fieldDisplay: "Address",
        placeholder: "ex: exampleendpoint.com:5678",
        fieldColumns: "col-md-12"
    }))));
const { func: $e1d0b0f278c8d5b2$var$func, shape: $e1d0b0f278c8d5b2$var$shape } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$e1d0b0f278c8d5b2$var$TcpHandler.propTypes = {
    selectedHandler: $e1d0b0f278c8d5b2$var$shape({}).isRequired,
    handleModifyHandler: $e1d0b0f278c8d5b2$var$func.isRequired
};
var $e1d0b0f278c8d5b2$export$2e2bcd8739ae039 = $e1d0b0f278c8d5b2$var$TcpHandler;



var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");

const $e1f9a16e38d20ad7$var$ExecHandler = ({ selectedHandler: selectedHandler, handleModifyHandler: handleModifyHandler })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab-contents"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab--parameters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", null, "Parameters for this Alert Handler"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "faux-form"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "command",
        fieldDisplay: "Command (arguments separated by spaces):",
        placeholder: "ex: command argument",
        fieldColumns: "col-md-12",
        parseToArray: true
    }))));
const { func: $e1f9a16e38d20ad7$var$func, shape: $e1f9a16e38d20ad7$var$shape } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$e1f9a16e38d20ad7$var$ExecHandler.propTypes = {
    selectedHandler: $e1f9a16e38d20ad7$var$shape({}).isRequired,
    handleModifyHandler: $e1f9a16e38d20ad7$var$func.isRequired
};
var $e1f9a16e38d20ad7$export$2e2bcd8739ae039 = $e1f9a16e38d20ad7$var$ExecHandler;



var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");

const $f0ae0f5a48840015$var$LogHandler = ({ selectedHandler: selectedHandler, handleModifyHandler: handleModifyHandler })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab-contents"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab--parameters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", null, "Parameters for this Alert Handler"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "faux-form"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "filePath",
        fieldDisplay: "File Path for Log File:",
        placeholder: "ex: /tmp/alerts.log",
        fieldColumns: "col-md-12"
    }))));
const { func: $f0ae0f5a48840015$var$func, shape: $f0ae0f5a48840015$var$shape } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$f0ae0f5a48840015$var$LogHandler.propTypes = {
    selectedHandler: $f0ae0f5a48840015$var$shape({}).isRequired,
    handleModifyHandler: $f0ae0f5a48840015$var$func.isRequired
};
var $f0ae0f5a48840015$export$2e2bcd8739ae039 = $f0ae0f5a48840015$var$LogHandler;



var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");


var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");
const $761bee22b134f64f$var$HandlerEmpty = ({ onGoToConfig: onGoToConfig, validationError: validationError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab-contents"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab--parameters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab--parameters--empty"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, "This handler is not enabled"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "form-group form-group-submit col-xs-12 text-center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
        className: "btn btn-primary",
        type: "submit",
        onClick: onGoToConfig
    }, validationError ? 'Exit Rule and Configure this Alert Handler' : 'Save Rule and Configure this Alert Handler')))));
const { string: $761bee22b134f64f$var$string, func: $761bee22b134f64f$var$func } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$761bee22b134f64f$var$HandlerEmpty.propTypes = {
    onGoToConfig: $761bee22b134f64f$var$func.isRequired,
    validationError: $761bee22b134f64f$var$string.isRequired
};
var $761bee22b134f64f$export$2e2bcd8739ae039 = $761bee22b134f64f$var$HandlerEmpty;



var $NdCUR = parcelRequire("NdCUR");
const $a06510f92c3575a8$var$HandlerActions = ({ onGoToConfig: onGoToConfig, onTest: onTest, validationError: validationError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        style: {
            display: 'flex'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "btn btn-primary btn-sm",
        onClick: (e)=>{
            e.preventDefault();
            onTest();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        className: "icon pulse-c"
    }), "Send Test Alert"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "btn btn-default btn-sm",
        onClick: onGoToConfig
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        className: "icon cog-thick"
    }), validationError ? 'Exit this Rule and Edit Configuration' : 'Save this Rule and Edit Configuration'));
var $a06510f92c3575a8$export$2e2bcd8739ae039 = $a06510f92c3575a8$var$HandlerActions;


const $a5307be676c55005$var$AlertaHandler = ({ selectedHandler: selectedHandler, handleModifyHandler: handleModifyHandler, onGoToConfig: onGoToConfig, onTest: onTest, validationError: validationError })=>selectedHandler.enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab-contents"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab--parameters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", {
        className: "u-flex u-jc-space-between"
    }, "Parameters from Kapacitor Configuration", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a06510f92c3575a8$export$2e2bcd8739ae039), {
        onGoToConfig: onGoToConfig,
        onTest: ()=>onTest(selectedHandler),
        validationError: validationError
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "faux-form"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "token",
        fieldDisplay: "Token",
        placeholder: "ex: my_token",
        redacted: true,
        fieldColumns: "col-md-12"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "environment",
        fieldDisplay: "Environment",
        placeholder: "ex: environment"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "origin",
        fieldDisplay: "Origin",
        placeholder: "ex: origin"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab--parameters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", null, "Parameters for this Alert Handler"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "faux-form"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "resource",
        fieldDisplay: "Resource",
        placeholder: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "event",
        fieldDisplay: "Event",
        placeholder: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "group",
        fieldDisplay: "Group",
        placeholder: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "value",
        fieldDisplay: "Value",
        placeholder: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "service",
        fieldDisplay: "Service",
        placeholder: "",
        parseToArray: true
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $761bee22b134f64f$export$2e2bcd8739ae039), {
        onGoToConfig: onGoToConfig,
        validationError: validationError
    });
const { func: $a5307be676c55005$var$func, shape: $a5307be676c55005$var$shape, string: $a5307be676c55005$var$string } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$a5307be676c55005$var$AlertaHandler.propTypes = {
    selectedHandler: $a5307be676c55005$var$shape({}).isRequired,
    handleModifyHandler: $a5307be676c55005$var$func.isRequired,
    onGoToConfig: $a5307be676c55005$var$func.isRequired,
    validationError: $a5307be676c55005$var$string.isRequired
};
var $a5307be676c55005$export$2e2bcd8739ae039 = $a5307be676c55005$var$AlertaHandler;



var $NdCUR = parcelRequire("NdCUR");



const $4c273c5b7dbef822$var$KafkaHandler = ({ selectedHandler: selectedHandler, handleModifyHandler: handleModifyHandler, onGoToConfig: onGoToConfig, onTest: onTest, validationError: validationError })=>{
    const handler = {
        ...selectedHandler,
        cluster: selectedHandler.id
    };
    handleModifyHandler(handler, 'cluster', false, 0);
    if (selectedHandler.enabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab-contents"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab--parameters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", {
        className: "u-flex u-jc-space-between"
    }, "Parameters for this Alert Handler", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a06510f92c3575a8$export$2e2bcd8739ae039), {
        onGoToConfig: onGoToConfig,
        onTest: ()=>onTest(handler),
        validationError: validationError
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "faux-form"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: handler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "kafka-topic",
        fieldDisplay: "Topic",
        placeholder: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: handler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "template",
        fieldDisplay: "Template",
        placeholder: ""
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $761bee22b134f64f$export$2e2bcd8739ae039), {
        onGoToConfig: onGoToConfig,
        validationError: validationError
    });
};
var $4c273c5b7dbef822$export$2e2bcd8739ae039 = $4c273c5b7dbef822$var$KafkaHandler;



var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");



const $1c53f5af00481e79$var$OpsgenieHandler = ({ selectedHandler: selectedHandler, handleModifyHandler: handleModifyHandler, onGoToConfig: onGoToConfig, onTest: onTest, validationError: validationError })=>selectedHandler.enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab-contents"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab--parameters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", {
        className: "u-flex u-jc-space-between"
    }, "Parameters from Kapacitor Configuration", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a06510f92c3575a8$export$2e2bcd8739ae039), {
        onGoToConfig: onGoToConfig,
        onTest: ()=>onTest(selectedHandler),
        validationError: validationError
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "faux-form"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "api-key",
        fieldDisplay: "API-key",
        placeholder: "",
        redacted: true,
        disabled: true,
        fieldColumns: "col-md-12"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab--parameters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", null, "Parameters for this Alert Handler:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "faux-form"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "teams",
        fieldDisplay: "Teams",
        placeholder: "ex: teams_name",
        parseToArray: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "recipients",
        fieldDisplay: "Recipients",
        placeholder: "ex: recipients_name",
        parseToArray: true
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $761bee22b134f64f$export$2e2bcd8739ae039), {
        onGoToConfig: onGoToConfig,
        validationError: validationError
    });
const { func: $1c53f5af00481e79$var$func, shape: $1c53f5af00481e79$var$shape, string: $1c53f5af00481e79$var$string } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$1c53f5af00481e79$var$OpsgenieHandler.propTypes = {
    selectedHandler: $1c53f5af00481e79$var$shape({}).isRequired,
    handleModifyHandler: $1c53f5af00481e79$var$func.isRequired,
    onGoToConfig: $1c53f5af00481e79$var$func.isRequired,
    validationError: $1c53f5af00481e79$var$string.isRequired
};
var $1c53f5af00481e79$export$2e2bcd8739ae039 = $1c53f5af00481e79$var$OpsgenieHandler;



var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");



const $fa1a1609e610d9d4$var$PagerdutyHandler = ({ selectedHandler: selectedHandler, handleModifyHandler: handleModifyHandler, onGoToConfig: onGoToConfig, onTest: onTest, validationError: validationError })=>selectedHandler.enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab-contents"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab--parameters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", {
        className: "u-flex u-jc-space-between"
    }, "Parameters from Kapacitor Configuration", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a06510f92c3575a8$export$2e2bcd8739ae039), {
        onGoToConfig: onGoToConfig,
        onTest: ()=>onTest(selectedHandler),
        validationError: validationError
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "serviceKey",
        fieldDisplay: "Service Key:",
        placeholder: "ex: service_key",
        redacted: true,
        fieldColumns: "col-md-12"
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $761bee22b134f64f$export$2e2bcd8739ae039), {
        onGoToConfig: onGoToConfig,
        validationError: validationError
    });
const { func: $fa1a1609e610d9d4$var$func, shape: $fa1a1609e610d9d4$var$shape, string: $fa1a1609e610d9d4$var$string } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$fa1a1609e610d9d4$var$PagerdutyHandler.propTypes = {
    selectedHandler: $fa1a1609e610d9d4$var$shape({}).isRequired,
    handleModifyHandler: $fa1a1609e610d9d4$var$func.isRequired,
    onGoToConfig: $fa1a1609e610d9d4$var$func.isRequired,
    validationError: $fa1a1609e610d9d4$var$string.isRequired
};
var $fa1a1609e610d9d4$export$2e2bcd8739ae039 = $fa1a1609e610d9d4$var$PagerdutyHandler;



var $NdCUR = parcelRequire("NdCUR");



const $3c5810269f3d4d60$var$Pagerduty2Handler = ({ selectedHandler: selectedHandler, handleModifyHandler: handleModifyHandler, onGoToConfig: onGoToConfig, onTest: onTest, validationError: validationError })=>{
    if (selectedHandler.enabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab-contents"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab--parameters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", {
        className: "u-flex u-jc-space-between"
    }, "Parameters from Kapacitor Configuration", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a06510f92c3575a8$export$2e2bcd8739ae039), {
        onGoToConfig: onGoToConfig,
        onTest: ()=>onTest(selectedHandler),
        validationError: validationError
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "routingKey",
        fieldDisplay: "Routing Key:",
        placeholder: "ex: routing_key",
        redacted: true,
        fieldColumns: "col-md-12"
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $761bee22b134f64f$export$2e2bcd8739ae039), {
        onGoToConfig: onGoToConfig,
        validationError: validationError
    });
};
var $3c5810269f3d4d60$export$2e2bcd8739ae039 = $3c5810269f3d4d60$var$Pagerduty2Handler;



var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");



const $318fed17a24745a4$var$PushoverHandler = ({ selectedHandler: selectedHandler, handleModifyHandler: handleModifyHandler, onGoToConfig: onGoToConfig, onTest: onTest, validationError: validationError })=>selectedHandler.enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab-contents"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab--parameters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", {
        className: "u-flex u-jc-space-between"
    }, "Parameters from Kapacitor Configuration", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a06510f92c3575a8$export$2e2bcd8739ae039), {
        onGoToConfig: onGoToConfig,
        onTest: ()=>onTest(selectedHandler),
        validationError: validationError
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "faux-form"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "token",
        fieldDisplay: "Token",
        placeholder: "",
        disabled: true,
        redacted: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "userKey",
        fieldDisplay: "User Key",
        placeholder: "",
        redacted: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab--parameters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", null, "Parameters for this Alert Handler"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "faux-form"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "title",
        fieldDisplay: "Alert Title:",
        placeholder: "ex: Important Alert",
        fieldColumns: "col-md-12"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "url",
        fieldDisplay: "URL:",
        placeholder: "ex: https://influxdata.com"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "urlTitle",
        fieldDisplay: "URL Title:",
        placeholder: "ex: InfluxData"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "device",
        fieldDisplay: "Devices: (comma separated)",
        placeholder: "ex: dv1, dv2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "sound",
        fieldDisplay: "Alert Sound:",
        placeholder: "ex: alien"
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $761bee22b134f64f$export$2e2bcd8739ae039), {
        onGoToConfig: onGoToConfig,
        validationError: validationError
    });
const { func: $318fed17a24745a4$var$func, shape: $318fed17a24745a4$var$shape, string: $318fed17a24745a4$var$string } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$318fed17a24745a4$var$PushoverHandler.propTypes = {
    selectedHandler: $318fed17a24745a4$var$shape({}).isRequired,
    handleModifyHandler: $318fed17a24745a4$var$func.isRequired,
    onGoToConfig: $318fed17a24745a4$var$func.isRequired,
    validationError: $318fed17a24745a4$var$string.isRequired
};
var $318fed17a24745a4$export$2e2bcd8739ae039 = $318fed17a24745a4$var$PushoverHandler;



var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");



const $a843a832d3de37c1$var$SensuHandler = ({ selectedHandler: selectedHandler, handleModifyHandler: handleModifyHandler, onGoToConfig: onGoToConfig, onTest: onTest, validationError: validationError })=>selectedHandler.enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab-contents"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab--parameters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", {
        className: "u-flex u-jc-space-between"
    }, "Parameters from Kapacitor Configuration", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a06510f92c3575a8$export$2e2bcd8739ae039), {
        onGoToConfig: onGoToConfig,
        onTest: ()=>onTest(selectedHandler),
        validationError: validationError
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "faux-form"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "addr",
        fieldDisplay: "Address",
        placeholder: "",
        disabled: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "source",
        fieldDisplay: "Source",
        placeholder: "ex: my_source"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab--parameters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", null, "Parameters for this Alert Handler"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "faux-form"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "handlers",
        fieldDisplay: "Handlers",
        placeholder: "ex: my_handlers",
        fieldColumns: "col-md-12",
        parseToArray: true
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $761bee22b134f64f$export$2e2bcd8739ae039), {
        onGoToConfig: onGoToConfig,
        validationError: validationError
    });
const { func: $a843a832d3de37c1$var$func, shape: $a843a832d3de37c1$var$shape, string: $a843a832d3de37c1$var$string } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$a843a832d3de37c1$var$SensuHandler.propTypes = {
    selectedHandler: $a843a832d3de37c1$var$shape({}).isRequired,
    handleModifyHandler: $a843a832d3de37c1$var$func.isRequired,
    onGoToConfig: $a843a832d3de37c1$var$func.isRequired,
    validationError: $a843a832d3de37c1$var$string.isRequired
};
var $a843a832d3de37c1$export$2e2bcd8739ae039 = $a843a832d3de37c1$var$SensuHandler;



var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");



const $119205539ea517da$var$SlackHandler = ({ selectedHandler: selectedHandler, handleModifyHandler: handleModifyHandler, onGoToConfig: onGoToConfig, onTest: onTest, validationError: validationError })=>selectedHandler.enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab-contents"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab--parameters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", {
        className: "u-flex u-jc-space-between"
    }, "Parameters from Kapacitor Configuration", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a06510f92c3575a8$export$2e2bcd8739ae039), {
        onGoToConfig: onGoToConfig,
        onTest: ()=>onTest(selectedHandler),
        validationError: validationError
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "faux-form"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "url",
        fieldDisplay: "Webhook URL:",
        placeholder: "",
        disabled: true,
        redacted: true,
        fieldColumns: "col-md-12"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab--parameters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", null, "Parameters for this Alert Handler"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "faux-form"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "channel",
        fieldDisplay: "Channel:",
        placeholder: "ex: #my_favorite_channel",
        fieldColumns: "col-md-4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "username",
        fieldDisplay: "Username:",
        placeholder: "ex: my_favorite_username",
        fieldColumns: "col-md-4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "iconEmoji",
        fieldDisplay: "Emoji:",
        placeholder: "ex: :thumbsup:",
        fieldColumns: "col-md-4"
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $761bee22b134f64f$export$2e2bcd8739ae039), {
        onGoToConfig: onGoToConfig,
        validationError: validationError
    });
const { func: $119205539ea517da$var$func, shape: $119205539ea517da$var$shape, string: $119205539ea517da$var$string } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$119205539ea517da$var$SlackHandler.propTypes = {
    selectedHandler: $119205539ea517da$var$shape({}).isRequired,
    handleModifyHandler: $119205539ea517da$var$func.isRequired,
    onGoToConfig: $119205539ea517da$var$func.isRequired,
    validationError: $119205539ea517da$var$string.isRequired
};
var $119205539ea517da$export$2e2bcd8739ae039 = $119205539ea517da$var$SlackHandler;



var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");



var $NdCUR = parcelRequire("NdCUR");

class $763124073b0e22cd$var$RuleDetailsText extends (0, $NdCUR.PureComponent) {
    render() {
        const { rule: rule } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "rule-builder--details"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("textarea", {
            className: "form-control form-malachite monotype",
            onChange: this.handleUpdateDetails,
            placeholder: "Enter the body for your email here. Can contain html",
            value: rule.details,
            spellCheck: false
        }));
    }
    constructor(...args){
        super(...args), this.handleUpdateDetails = (e)=>{
            const { rule: rule, updateDetails: updateDetails } = this.props;
            updateDetails(rule.id, e.target.value);
        };
    }
}
var $763124073b0e22cd$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($763124073b0e22cd$var$RuleDetailsText);



const $e09500d423a5c0c3$var$EmailHandler = ({ rule: rule, updateDetails: updateDetails, selectedHandler: selectedHandler, handleModifyHandler: handleModifyHandler, onGoToConfig: onGoToConfig, onTest: onTest, validationError: validationError })=>selectedHandler.enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab-contents"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab--parameters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", {
        className: "u-flex u-jc-space-between"
    }, "Parameters from Kapacitor Configuration", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a06510f92c3575a8$export$2e2bcd8739ae039), {
        onGoToConfig: onGoToConfig,
        onTest: ()=>onTest(selectedHandler),
        validationError: validationError
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "faux-form"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "from",
        fieldDisplay: "From E-mail",
        placeholder: "",
        disabled: true,
        fieldColumns: "col-md-4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "host",
        fieldDisplay: "SMTP Host",
        placeholder: "",
        disabled: true,
        fieldColumns: "col-md-4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "port",
        fieldDisplay: "SMTP Port",
        placeholder: "",
        disabled: true,
        fieldColumns: "col-md-4"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab--parameters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", null, "Parameters for this Alert Handler"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "faux-form"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "to",
        fieldDisplay: "Recipient E-mail Addresses: (separated by spaces)",
        placeholder: "ex: bob@domain.com susan@domain.com",
        parseToArray: true,
        fieldColumns: "col-md-12"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $763124073b0e22cd$export$2e2bcd8739ae039), {
        rule: rule,
        updateDetails: updateDetails
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $761bee22b134f64f$export$2e2bcd8739ae039), {
        onGoToConfig: onGoToConfig,
        validationError: validationError
    });
const { func: $e09500d423a5c0c3$var$func, shape: $e09500d423a5c0c3$var$shape, string: $e09500d423a5c0c3$var$string } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$e09500d423a5c0c3$var$EmailHandler.propTypes = {
    selectedHandler: $e09500d423a5c0c3$var$shape({}).isRequired,
    handleModifyHandler: $e09500d423a5c0c3$var$func.isRequired,
    updateDetails: $e09500d423a5c0c3$var$func,
    rule: $e09500d423a5c0c3$var$shape({}),
    onGoToConfig: $e09500d423a5c0c3$var$func.isRequired,
    validationError: $e09500d423a5c0c3$var$string.isRequired
};
var $e09500d423a5c0c3$export$2e2bcd8739ae039 = $e09500d423a5c0c3$var$EmailHandler;



var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");



const $4aa57d9f8d9b46b1$var$TalkHandler = ({ selectedHandler: selectedHandler, handleModifyHandler: handleModifyHandler, onGoToConfig: onGoToConfig, onTest: onTest, validationError: validationError })=>selectedHandler.enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab-contents"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab--parameters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", {
        className: "u-flex u-jc-space-between"
    }, "Parameters from Kapacitor Configuration", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a06510f92c3575a8$export$2e2bcd8739ae039), {
        onGoToConfig: onGoToConfig,
        onTest: ()=>onTest(selectedHandler),
        validationError: validationError
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "faux-form"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "url",
        fieldDisplay: "URL",
        placeholder: "",
        disabled: true,
        redacted: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "author_name",
        fieldDisplay: "Author Name",
        placeholder: "",
        disabled: true
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $761bee22b134f64f$export$2e2bcd8739ae039), {
        onGoToConfig: onGoToConfig,
        validationError: validationError
    });
const { func: $4aa57d9f8d9b46b1$var$func, shape: $4aa57d9f8d9b46b1$var$shape, string: $4aa57d9f8d9b46b1$var$string } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$4aa57d9f8d9b46b1$var$TalkHandler.propTypes = {
    selectedHandler: $4aa57d9f8d9b46b1$var$shape({}).isRequired,
    handleModifyHandler: $4aa57d9f8d9b46b1$var$func.isRequired,
    onGoToConfig: $4aa57d9f8d9b46b1$var$func.isRequired,
    validationError: $4aa57d9f8d9b46b1$var$string.isRequired
};
var $4aa57d9f8d9b46b1$export$2e2bcd8739ae039 = $4aa57d9f8d9b46b1$var$TalkHandler;



var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");


var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");
const $54e67fc523870005$var$HandlerCheckbox = ({ fieldName: fieldName, fieldDisplay: fieldDisplay, selectedHandler: selectedHandler, handleModifyHandler: handleModifyHandler })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "form-group "
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "form-control-static handler-checkbox"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
        name: fieldName,
        id: fieldName,
        type: "checkbox",
        defaultChecked: selectedHandler[fieldName],
        onClick: handleModifyHandler(selectedHandler, fieldName)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
        htmlFor: fieldName
    }, fieldDisplay)));
const { func: $54e67fc523870005$var$func, shape: $54e67fc523870005$var$shape, string: $54e67fc523870005$var$string, bool: $54e67fc523870005$var$bool } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$54e67fc523870005$var$HandlerCheckbox.propTypes = {
    fieldName: $54e67fc523870005$var$string,
    fieldDisplay: $54e67fc523870005$var$string,
    defaultChecked: $54e67fc523870005$var$bool,
    selectedHandler: $54e67fc523870005$var$shape({}).isRequired,
    handleModifyHandler: $54e67fc523870005$var$func.isRequired
};
var $54e67fc523870005$export$2e2bcd8739ae039 = $54e67fc523870005$var$HandlerCheckbox;




const $0ea5ab7f3f2668da$var$TelegramHandler = ({ selectedHandler: selectedHandler, handleModifyHandler: handleModifyHandler, onGoToConfig: onGoToConfig, onTest: onTest, validationError: validationError })=>selectedHandler.enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab-contents"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab--parameters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", {
        className: "u-flex u-jc-space-between"
    }, "Parameters from Kapacitor Configuration", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a06510f92c3575a8$export$2e2bcd8739ae039), {
        onGoToConfig: onGoToConfig,
        onTest: ()=>onTest(selectedHandler),
        validationError: validationError
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "faux-form"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "token",
        fieldDisplay: "Token",
        placeholder: "",
        disabled: true,
        redacted: true,
        fieldColumns: "col-md-12"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab--parameters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", null, "Parameters for this Alert Handler"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "faux-form"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "chatId",
        fieldDisplay: "Chat ID:",
        placeholder: "ex: chat_id"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "parseMode",
        fieldDisplay: "Parse Mode:",
        placeholder: "ex: Markdown or HTML"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $54e67fc523870005$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "disableWebPagePreview",
        fieldDisplay: "Disable web page preview"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $54e67fc523870005$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "disableNotification",
        fieldDisplay: "Disable notification"
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $761bee22b134f64f$export$2e2bcd8739ae039), {
        onGoToConfig: onGoToConfig,
        validationError: validationError
    });
const { func: $0ea5ab7f3f2668da$var$func, shape: $0ea5ab7f3f2668da$var$shape, string: $0ea5ab7f3f2668da$var$string } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$0ea5ab7f3f2668da$var$TelegramHandler.propTypes = {
    selectedHandler: $0ea5ab7f3f2668da$var$shape({}).isRequired,
    handleModifyHandler: $0ea5ab7f3f2668da$var$func.isRequired,
    onGoToConfig: $0ea5ab7f3f2668da$var$func.isRequired,
    validationError: $0ea5ab7f3f2668da$var$string.isRequired
};
var $0ea5ab7f3f2668da$export$2e2bcd8739ae039 = $0ea5ab7f3f2668da$var$TelegramHandler;



var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");



const $6de347be035ecf55$var$VictoropsHandler = ({ selectedHandler: selectedHandler, handleModifyHandler: handleModifyHandler, onGoToConfig: onGoToConfig, onTest: onTest, validationError: validationError })=>selectedHandler.enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab-contents"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab--parameters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", {
        className: "u-flex u-jc-space-between"
    }, "Parameters from Kapacitor Configuration", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a06510f92c3575a8$export$2e2bcd8739ae039), {
        onGoToConfig: onGoToConfig,
        validationError: validationError,
        onTest: ()=>onTest(selectedHandler)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "faux-form"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "api-key",
        fieldDisplay: "API key",
        placeholder: "ex: api_key",
        disabled: true,
        redacted: true,
        fieldColumns: "col-md-12"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab--parameters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", null, "Parameters for this Alert Handler"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "faux-form"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "routingKey",
        fieldDisplay: "Routing Key:",
        placeholder: "ex: routing_key",
        fieldColumns: "col-md-12"
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $761bee22b134f64f$export$2e2bcd8739ae039), {
        onGoToConfig: onGoToConfig,
        validationError: validationError
    });
const { func: $6de347be035ecf55$var$func, shape: $6de347be035ecf55$var$shape, string: $6de347be035ecf55$var$string } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$6de347be035ecf55$var$VictoropsHandler.propTypes = {
    selectedHandler: $6de347be035ecf55$var$shape({}).isRequired,
    handleModifyHandler: $6de347be035ecf55$var$func.isRequired,
    onGoToConfig: $6de347be035ecf55$var$func.isRequired,
    validationError: $6de347be035ecf55$var$string.isRequired
};
var $6de347be035ecf55$export$2e2bcd8739ae039 = $6de347be035ecf55$var$VictoropsHandler;



var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");



const $e61dfda7955f80ab$var$ServiceNowHandler = ({ selectedHandler: selectedHandler, handleModifyHandler: handleModifyHandler, onGoToConfig: onGoToConfig, onTest: onTest, validationError: validationError })=>selectedHandler.enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab-contents"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab--parameters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", {
        className: "u-flex u-jc-space-between"
    }, "Parameters from Kapacitor Configuration", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a06510f92c3575a8$export$2e2bcd8739ae039), {
        onGoToConfig: onGoToConfig,
        onTest: ()=>onTest(selectedHandler),
        validationError: validationError
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "faux-form"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "source",
        fieldDisplay: "Source:",
        placeholder: "ex: Kapacitor",
        fieldColumns: "col-md-12"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab--parameters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", null, "Parameters for this Alert Handler"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "faux-form"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "_type" // type is used by js internally
        ,
        fieldDisplay: "Type:",
        placeholder: "ex: CPU",
        fieldColumns: "col-md-12"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "resource",
        fieldDisplay: "Resource:",
        placeholder: "ex: CPU-Total",
        fieldColumns: "col-md-12"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "metric_name",
        fieldDisplay: "Metric Name:",
        placeholder: "ex: usage_user",
        fieldColumns: "col-md-12"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "message_key",
        fieldDisplay: "Message Key:",
        placeholder: "",
        fieldColumns: "col-md-12"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "node",
        fieldDisplay: "Node:",
        placeholder: "",
        fieldColumns: "col-md-12"
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $761bee22b134f64f$export$2e2bcd8739ae039), {
        onGoToConfig: onGoToConfig,
        validationError: validationError
    });
const { func: $e61dfda7955f80ab$var$func, shape: $e61dfda7955f80ab$var$shape, string: $e61dfda7955f80ab$var$string } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$e61dfda7955f80ab$var$ServiceNowHandler.propTypes = {
    selectedHandler: $e61dfda7955f80ab$var$shape({}).isRequired,
    handleModifyHandler: $e61dfda7955f80ab$var$func.isRequired,
    onGoToConfig: $e61dfda7955f80ab$var$func.isRequired,
    validationError: $e61dfda7955f80ab$var$string.isRequired
};
var $e61dfda7955f80ab$export$2e2bcd8739ae039 = $e61dfda7955f80ab$var$ServiceNowHandler;



var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");



const $5f745664503743b4$var$BigPandaHandler = ({ selectedHandler: selectedHandler, handleModifyHandler: handleModifyHandler, onGoToConfig: onGoToConfig, onTest: onTest, validationError: validationError })=>selectedHandler.enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab-contents"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab--parameters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", {
        className: "u-flex u-jc-space-between"
    }, "Parameters from Kapacitor Configuration", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a06510f92c3575a8$export$2e2bcd8739ae039), {
        onGoToConfig: onGoToConfig,
        onTest: ()=>onTest(selectedHandler),
        validationError: validationError
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "faux-form"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "app-key",
        fieldDisplay: "Application Key:",
        placeholder: "ex: my_app",
        fieldColumns: "col-md-12"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab--parameters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", null, "Parameters for this Alert Handler"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "faux-form"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "primary-property",
        fieldDisplay: "Primary Property",
        placeholder: "",
        fieldColumns: "col-md-12"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "secondary-property",
        fieldDisplay: "Secondary Property",
        placeholder: "",
        fieldColumns: "col-md-12"
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $761bee22b134f64f$export$2e2bcd8739ae039), {
        onGoToConfig: onGoToConfig,
        validationError: validationError
    });
const { func: $5f745664503743b4$var$func, shape: $5f745664503743b4$var$shape, string: $5f745664503743b4$var$string } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$5f745664503743b4$var$BigPandaHandler.propTypes = {
    selectedHandler: $5f745664503743b4$var$shape({}).isRequired,
    handleModifyHandler: $5f745664503743b4$var$func.isRequired,
    onGoToConfig: $5f745664503743b4$var$func.isRequired,
    validationError: $5f745664503743b4$var$string.isRequired
};
var $5f745664503743b4$export$2e2bcd8739ae039 = $5f745664503743b4$var$BigPandaHandler;



var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");



const $1e77658f5f83f6f2$var$TeamsHandler = ({ selectedHandler: selectedHandler, handleModifyHandler: handleModifyHandler, onGoToConfig: onGoToConfig, onTest: onTest, validationError: validationError })=>selectedHandler.enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab-contents"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab--parameters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", {
        className: "u-flex u-jc-space-between"
    }, "Parameter Overriding Kapacitor Configuration", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a06510f92c3575a8$export$2e2bcd8739ae039), {
        onGoToConfig: onGoToConfig,
        onTest: ()=>onTest(selectedHandler),
        validationError: validationError
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "faux-form"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "channel-url",
        fieldDisplay: "Channel URL:",
        placeholder: "ex: https://outlook.office.com/webhook/...",
        fieldColumns: "col-md-12"
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $761bee22b134f64f$export$2e2bcd8739ae039), {
        onGoToConfig: onGoToConfig,
        validationError: validationError
    });
const { func: $1e77658f5f83f6f2$var$func, shape: $1e77658f5f83f6f2$var$shape, string: $1e77658f5f83f6f2$var$string } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$1e77658f5f83f6f2$var$TeamsHandler.propTypes = {
    selectedHandler: $1e77658f5f83f6f2$var$shape({}).isRequired,
    handleModifyHandler: $1e77658f5f83f6f2$var$func.isRequired,
    onGoToConfig: $1e77658f5f83f6f2$var$func.isRequired,
    validationError: $1e77658f5f83f6f2$var$string.isRequired
};
var $1e77658f5f83f6f2$export$2e2bcd8739ae039 = $1e77658f5f83f6f2$var$TeamsHandler;



var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");



const $98fa5a0281ba4abf$var$ZenossHandler = ({ selectedHandler: selectedHandler, handleModifyHandler: handleModifyHandler, onGoToConfig: onGoToConfig, onTest: onTest, validationError: validationError })=>selectedHandler.enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab-contents"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab--parameters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", {
        className: "u-flex u-jc-space-between"
    }, "Parameters from Kapacitor Configuration", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a06510f92c3575a8$export$2e2bcd8739ae039), {
        onGoToConfig: onGoToConfig,
        onTest: ()=>onTest(selectedHandler, {
                evclass: 'eventclass',
                evclasskey: 'eventclasskey'
            }),
        validationError: validationError
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "faux-form"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "action",
        fieldDisplay: "Action:",
        placeholder: "ex: MyRouter",
        fieldColumns: "col-md-12"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "method",
        fieldDisplay: "Method:",
        placeholder: "ex: RouterMethod",
        fieldColumns: "col-md-12"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "_type" // type is used by js internally
        ,
        fieldDisplay: "Event Type:",
        fieldColumns: "col-md-12"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "tid" // type is used by js internally
        ,
        type: "number",
        fieldDisplay: "Event TID:",
        fieldColumns: "col-md-12"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "endpoint-tab--parameters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", null, "Parameters for this Alert Handler"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "faux-form"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "device" // type is used by js internally
        ,
        fieldDisplay: "Device:",
        fieldColumns: "col-md-12"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "component",
        fieldDisplay: "Component:",
        fieldColumns: "col-md-12"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "evclasskey",
        fieldDisplay: "Event Class Key:",
        fieldColumns: "col-md-12"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $14c19c656a2c7fbe$export$2e2bcd8739ae039), {
        selectedHandler: selectedHandler,
        handleModifyHandler: handleModifyHandler,
        fieldName: "evclass",
        fieldDisplay: "Event Class:",
        fieldColumns: "col-md-12"
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $761bee22b134f64f$export$2e2bcd8739ae039), {
        onGoToConfig: onGoToConfig,
        validationError: validationError
    });
const { func: $98fa5a0281ba4abf$var$func, shape: $98fa5a0281ba4abf$var$shape, string: $98fa5a0281ba4abf$var$string } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$98fa5a0281ba4abf$var$ZenossHandler.propTypes = {
    selectedHandler: $98fa5a0281ba4abf$var$shape({}).isRequired,
    handleModifyHandler: $98fa5a0281ba4abf$var$func.isRequired,
    onGoToConfig: $98fa5a0281ba4abf$var$func.isRequired,
    validationError: $98fa5a0281ba4abf$var$string.isRequired
};
var $98fa5a0281ba4abf$export$2e2bcd8739ae039 = $98fa5a0281ba4abf$var$ZenossHandler;





class $cde85255963691fc$var$HandlerOptions extends (0, $NdCUR.Component) {
    constructor(props){
        super(props);
    }
    render() {
        const { selectedHandler: selectedHandler, handleModifyHandler: handleModifyHandler, rule: rule, updateDetails: updateDetails, onGoToConfig: onGoToConfig, onTestHandler: onTestHandler, validationError: validationError } = this.props;
        switch(selectedHandler && selectedHandler.type){
            case 'post':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $f358605b287be4cc$export$2e2bcd8739ae039), {
                    selectedHandler: selectedHandler,
                    handleModifyHandler: handleModifyHandler
                });
            case 'tcp':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $e1d0b0f278c8d5b2$export$2e2bcd8739ae039), {
                    selectedHandler: selectedHandler,
                    handleModifyHandler: handleModifyHandler
                });
            case 'exec':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $e1f9a16e38d20ad7$export$2e2bcd8739ae039), {
                    selectedHandler: selectedHandler,
                    handleModifyHandler: handleModifyHandler
                });
            case 'log':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $f0ae0f5a48840015$export$2e2bcd8739ae039), {
                    selectedHandler: selectedHandler,
                    handleModifyHandler: handleModifyHandler
                });
            case 'email':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $e09500d423a5c0c3$export$2e2bcd8739ae039), {
                    selectedHandler: selectedHandler,
                    handleModifyHandler: handleModifyHandler,
                    onGoToConfig: onGoToConfig('smtp'),
                    onTest: onTestHandler('smtp'),
                    validationError: validationError,
                    updateDetails: updateDetails,
                    rule: rule
                });
            case 'alerta':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a5307be676c55005$export$2e2bcd8739ae039), {
                    selectedHandler: selectedHandler,
                    handleModifyHandler: handleModifyHandler,
                    onGoToConfig: onGoToConfig('alerta'),
                    onTest: onTestHandler('alerta'),
                    validationError: validationError
                });
            case 'kafka':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $4c273c5b7dbef822$export$2e2bcd8739ae039), {
                    selectedHandler: selectedHandler,
                    handleModifyHandler: handleModifyHandler,
                    onGoToConfig: onGoToConfig('kafka'),
                    onTest: onTestHandler('kafka'),
                    validationError: validationError
                });
            case 'opsGenie':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1c53f5af00481e79$export$2e2bcd8739ae039), {
                    selectedHandler: selectedHandler,
                    handleModifyHandler: handleModifyHandler,
                    onGoToConfig: onGoToConfig('opsgenie'),
                    onTest: onTestHandler('opsgenie'),
                    validationError: validationError
                });
            case 'opsGenie2':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1c53f5af00481e79$export$2e2bcd8739ae039), {
                    selectedHandler: selectedHandler,
                    handleModifyHandler: handleModifyHandler,
                    onGoToConfig: onGoToConfig('opsgenie2'),
                    onTest: onTestHandler('opsgenie2'),
                    validationError: validationError
                });
            case 'pagerDuty':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fa1a1609e610d9d4$export$2e2bcd8739ae039), {
                    selectedHandler: selectedHandler,
                    handleModifyHandler: handleModifyHandler,
                    onGoToConfig: onGoToConfig('pagerduty'),
                    onTest: onTestHandler('pagerduty'),
                    validationError: validationError
                });
            case 'pagerDuty2':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $3c5810269f3d4d60$export$2e2bcd8739ae039), {
                    selectedHandler: selectedHandler,
                    handleModifyHandler: handleModifyHandler,
                    onGoToConfig: onGoToConfig('pagerduty2'),
                    onTest: onTestHandler('pagerduty2'),
                    validationError: validationError
                });
            case 'pushover':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $318fed17a24745a4$export$2e2bcd8739ae039), {
                    selectedHandler: selectedHandler,
                    handleModifyHandler: handleModifyHandler,
                    onGoToConfig: onGoToConfig('pushover'),
                    onTest: onTestHandler('pushover'),
                    validationError: validationError
                });
            case 'sensu':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a843a832d3de37c1$export$2e2bcd8739ae039), {
                    selectedHandler: selectedHandler,
                    handleModifyHandler: handleModifyHandler,
                    onGoToConfig: onGoToConfig('sensu'),
                    onTest: onTestHandler('sensu'),
                    validationError: validationError
                });
            case 'slack':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $119205539ea517da$export$2e2bcd8739ae039), {
                    selectedHandler: selectedHandler,
                    handleModifyHandler: handleModifyHandler,
                    onGoToConfig: onGoToConfig('slack'),
                    onTest: onTestHandler('slack'),
                    validationError: validationError
                });
            case 'talk':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $4aa57d9f8d9b46b1$export$2e2bcd8739ae039), {
                    selectedHandler: selectedHandler,
                    handleModifyHandler: handleModifyHandler,
                    onGoToConfig: onGoToConfig('talk'),
                    onTest: onTestHandler('talk'),
                    validationError: validationError
                });
            case 'telegram':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $0ea5ab7f3f2668da$export$2e2bcd8739ae039), {
                    selectedHandler: selectedHandler,
                    handleModifyHandler: handleModifyHandler,
                    onGoToConfig: onGoToConfig('telegram'),
                    onTest: onTestHandler('telegram'),
                    validationError: validationError
                });
            case 'victorOps':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $6de347be035ecf55$export$2e2bcd8739ae039), {
                    selectedHandler: selectedHandler,
                    handleModifyHandler: handleModifyHandler,
                    onGoToConfig: onGoToConfig('victorops'),
                    onTest: onTestHandler('victorops'),
                    validationError: validationError
                });
            case 'serviceNow':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $e61dfda7955f80ab$export$2e2bcd8739ae039), {
                    selectedHandler: selectedHandler,
                    handleModifyHandler: handleModifyHandler,
                    onGoToConfig: onGoToConfig('servicenow'),
                    onTest: onTestHandler('servicenow'),
                    validationError: validationError
                });
            case 'bigPanda':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $5f745664503743b4$export$2e2bcd8739ae039), {
                    selectedHandler: selectedHandler,
                    handleModifyHandler: handleModifyHandler,
                    onGoToConfig: onGoToConfig('bigpanda'),
                    onTest: onTestHandler('bigpanda'),
                    validationError: validationError
                });
            case 'teams':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1e77658f5f83f6f2$export$2e2bcd8739ae039), {
                    selectedHandler: selectedHandler,
                    handleModifyHandler: handleModifyHandler,
                    onGoToConfig: onGoToConfig('teams'),
                    onTest: onTestHandler('teams'),
                    validationError: validationError
                });
            case 'zenoss':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $98fa5a0281ba4abf$export$2e2bcd8739ae039), {
                    selectedHandler: selectedHandler,
                    handleModifyHandler: handleModifyHandler,
                    onGoToConfig: onGoToConfig('zenoss'),
                    onTest: onTestHandler('zenoss'),
                    validationError: validationError
                });
            default:
                return null;
        }
    }
}
const { func: $cde85255963691fc$var$func, shape: $cde85255963691fc$var$shape, string: $cde85255963691fc$var$string } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$cde85255963691fc$var$HandlerOptions.propTypes = {
    selectedHandler: $cde85255963691fc$var$shape({}).isRequired,
    handleModifyHandler: $cde85255963691fc$var$func.isRequired,
    updateDetails: $cde85255963691fc$var$func,
    rule: $cde85255963691fc$var$shape({}),
    onGoToConfig: $cde85255963691fc$var$func.isRequired,
    onTestHandler: $cde85255963691fc$var$func.isRequired,
    validationError: $cde85255963691fc$var$string.isRequired
};
var $cde85255963691fc$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($cde85255963691fc$var$HandlerOptions);



var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");
const $bda6945ff06af317$var$HandlerTabs = ({ handlersOnThisAlert: handlersOnThisAlert, selectedHandler: selectedHandler, handleChooseHandler: handleChooseHandler, handleRemoveHandler: handleRemoveHandler })=>handlersOnThisAlert.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("ul", {
        className: "endpoint-tabs"
    }, handlersOnThisAlert.map((endpoint, i)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("li", {
            key: i,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('endpoint-tab', {
                active: endpoint.alias === (selectedHandler && selectedHandler.alias)
            }),
            onClick: handleChooseHandler(endpoint)
        }, endpoint.text, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "endpoint-tab--delete",
            onClick: handleRemoveHandler(endpoint)
        }));
    })) : null;
var $bda6945ff06af317$export$2e2bcd8739ae039 = $bda6945ff06af317$var$HandlerTabs;




var $hBdgJ = parcelRequire("hBdgJ");

const $2a661c3679d1aa5a$export$9f702f399604ac6d = (rule, handlersFromConfig)=>{
    const handlersOfKind = {};
    const handlersOnThisAlert = [];
    const handlersFromRule = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).pickBy(rule.alertNodes, (v, k)=>{
        return k in (0, $2aff9a9dae44a870$export$2def0f8fba1bcd69);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).forEach(handlersFromRule, (v, alertKind)=>{
        const thisAlertFromConfig = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).find(handlersFromConfig, (h)=>h.type === alertKind);
        (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).forEach(v, (alertOptions)=>{
            const count = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(handlersOfKind, alertKind, 0) + 1;
            handlersOfKind[alertKind] = count;
            if (alertKind === 'post') {
                const headers = alertOptions.headers;
                alertOptions.headerKey = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).keys(headers)[0];
                alertOptions.headerValue = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).values(headers)[0];
                alertOptions = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).omit(alertOptions, 'headers');
            }
            const ep = {
                enabled: true,
                ...thisAlertFromConfig,
                ...alertOptions,
                alias: `${alertKind}-${count}`,
                type: alertKind
            };
            handlersOnThisAlert.push(ep);
        });
    });
    const selectedHandler = handlersOnThisAlert.length ? handlersOnThisAlert[0] : null;
    return {
        handlersOnThisAlert: handlersOnThisAlert,
        selectedHandler: selectedHandler,
        handlersOfKind: handlersOfKind
    };
};
const $2a661c3679d1aa5a$export$c13dcb14e7ee62 = (rule)=>{
    const nodeList = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).transform(rule.alertNodes, (acc, v, k)=>{
        if (k in (0, $2aff9a9dae44a870$export$2def0f8fba1bcd69) && v && v.length > 0) {
            let alerts;
            switch(k){
                case (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).slack:
                    alerts = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).uniqBy(v, (alert)=>(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(alert, 'workspace') || 'default');
                    acc.push(...(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).map(alerts, (alert)=>{
                        const nickname = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(alert, 'workspace') || 'default';
                        return `${k} (${nickname})`;
                    }));
                    break;
                case (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).kafka:
                    alerts = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).uniqBy(v, (alert)=>(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(alert, 'cluster'));
                    acc.push(...(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).map(alerts, (alert)=>{
                        const nickname = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(alert, 'cluster');
                        return `${k} (${nickname})`;
                    }));
                    break;
                default:
                    acc.push(k);
            }
        }
    }, []);
    const uniqNodeList = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).uniq(nodeList);
    return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).join(uniqNodeList, ', ');
};




class $a5698c2a12d9e2f4$var$RuleHandlers extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleNoRecoveries = (e)=>{
            const { ruleActions: ruleActions, rule: rule } = this.props;
            ruleActions.updateNoRecoveries(rule.id, e.target.checked);
        }, this.handleStateChangesOnly = (e)=>{
            const { ruleActions: ruleActions, rule: rule } = this.props;
            ruleActions.updateStateChangesOnly(rule.id, e.target.checked);
        }, this.handleChooseHandler = (ep)=>()=>{
                this.setState({
                    selectedHandler: ep
                });
            }, this.handleAddHandler = (selectedItem)=>{
            const { handlersOnThisAlert: handlersOnThisAlert, handlersOfKind: handlersOfKind } = this.state;
            const newItemNumbering = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(handlersOfKind, selectedItem.type, 0) + 1;
            const newItemName = `${selectedItem.type}-${newItemNumbering}`;
            const newEndpoint = {
                ...selectedItem,
                alias: newItemName
            };
            // Handle kapacitor requiring a cluster to be provided that matches the id
            if (newEndpoint.type === (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).kafka) newEndpoint.cluster = newEndpoint.id;
            this.setState({
                handlersOnThisAlert: [
                    ...handlersOnThisAlert,
                    newEndpoint
                ],
                handlersOfKind: {
                    ...handlersOfKind,
                    [selectedItem.type]: newItemNumbering
                },
                selectedHandler: newEndpoint
            }, this.handleUpdateAllAlerts);
        }, this.handleRemoveHandler = (removedHandler)=>(e)=>{
                e.stopPropagation();
                const { handlersOnThisAlert: handlersOnThisAlert, selectedHandler: selectedHandler } = this.state;
                const removedIndex = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).findIndex(handlersOnThisAlert, [
                    'alias',
                    removedHandler.alias
                ]);
                const remainingHandlers = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).reject(handlersOnThisAlert, [
                    'alias',
                    removedHandler.alias
                ]);
                if (selectedHandler.alias === removedHandler.alias) {
                    const selectedIndex = removedIndex > 0 ? removedIndex - 1 : 0;
                    const newSelected = remainingHandlers.length ? remainingHandlers[selectedIndex] : null;
                    this.setState({
                        selectedHandler: newSelected
                    });
                }
                this.setState({
                    handlersOnThisAlert: remainingHandlers
                }, this.handleUpdateAllAlerts);
            }, this.handleUpdateAllAlerts = ()=>{
            const { rule: rule, ruleActions: ruleActions } = this.props;
            const { handlersOnThisAlert: handlersOnThisAlert } = this.state;
            ruleActions.updateAlertNodes(rule.id, handlersOnThisAlert);
        }, this.handleModifyHandler = (selectedHandler, fieldName, parseToArray)=>(e)=>{
                const { handlersOnThisAlert: handlersOnThisAlert } = this.state;
                let modifiedHandler;
                if (e.target.type === 'checkbox') modifiedHandler = {
                    ...selectedHandler,
                    [fieldName]: !selectedHandler[fieldName]
                };
                else if (parseToArray) modifiedHandler = {
                    ...selectedHandler,
                    [fieldName]: (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).split(e.target.value, ' ')
                };
                else {
                    let value = e.target.value;
                    if (e.target.type === 'number') {
                        if (value === '') value = undefined;
                        else try {
                            value = parseInt(value, 10);
                        } catch (nfe) {
                            console.error(nfe);
                        }
                    }
                    modifiedHandler = {
                        ...selectedHandler,
                        [fieldName]: value
                    };
                }
                const modifiedIndex = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).findIndex(handlersOnThisAlert, [
                    'alias',
                    modifiedHandler.alias
                ]);
                handlersOnThisAlert[modifiedIndex] = modifiedHandler;
                this.setState({
                    selectedHandler: modifiedHandler,
                    handlersOnThisAlert: [
                        ...handlersOnThisAlert
                    ]
                }, this.handleUpdateAllAlerts);
            }, this.getNickname = (handler)=>{
            const configType = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(handler, 'type');
            switch(configType){
                case (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).slack:
                    return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(handler, 'workspace') || 'default';
                case (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).kafka:
                    return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(handler, 'id') || (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(handler, 'cluster');
                default:
                    return null;
            }
        }, this.addNicknameText = (handler)=>{
            if (handler) {
                const nickname = this.getNickname(handler);
                if (nickname) return {
                    ...handler,
                    text: `${handler.type} (${nickname})`
                };
                return {
                    ...handler,
                    text: handler.type
                };
            }
            return null;
        }, this.mapWithNicknames = (handlers)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).map(handlers, (h)=>{
                return this.addNicknameText(h);
            });
        };
        const { handlersFromConfig: handlersFromConfig } = this.props;
        const { handlersOnThisAlert: handlersOnThisAlert, selectedHandler: selectedHandler, handlersOfKind: handlersOfKind } = (0, $2a661c3679d1aa5a$export$9f702f399604ac6d)(this.props.rule, handlersFromConfig);
        this.state = {
            selectedHandler: selectedHandler,
            handlersOnThisAlert: handlersOnThisAlert,
            handlersOfKind: handlersOfKind
        };
    }
    render() {
        const { rule: rule, ruleActions: ruleActions, onGoToConfig: onGoToConfig, onTestHandler: onTestHandler, validationError: validationError, handlersFromConfig: handlersFromConfig } = this.props;
        const { handlersOnThisAlert: handlersOnThisAlert, selectedHandler: selectedHandler } = this.state;
        const allHandlers = [
            ...(0, $2aff9a9dae44a870$export$919ec570f8ddd5f3),
            ...handlersFromConfig
        ];
        const mappedHandlers = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).sortBy(this.mapWithNicknames(allHandlers), 'text');
        const mappedHandlersOnThisAlert = this.mapWithNicknames(handlersOnThisAlert);
        const separator = {
            type: (0, $2aff9a9dae44a870$export$deac0a0b3bd8dbae).seperator,
            enabled: true,
            text: 'SEPARATOR'
        };
        const handlers = [
            ...(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).filter(mappedHandlers, (e)=>e.enabled),
            separator,
            ...(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).filter(mappedHandlers, [
                'enabled',
                false
            ])
        ];
        const dropdownLabel = handlersOnThisAlert.length ? 'Add another Handler' : 'Add a Handler';
        const ruleSectionClassName = handlersOnThisAlert.length ? 'rule-section--row rule-section--row-first rule-section--border-bottom' : 'rule-section--row rule-section--row-first rule-section--row-last';
        const selectedHandlerWithText = this.addNicknameText(selectedHandler);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "rule-section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h3", {
            className: "rule-section--heading"
        }, "Alert Handlers"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "rule-section--body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: ruleSectionClassName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, "Send this Alert to:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ca4f14339173643c$export$2e2bcd8739ae039), {
            items: handlers,
            menuClass: "dropdown-malachite",
            selected: dropdownLabel,
            onChoose: this.handleAddHandler,
            className: "dropdown-170 rule-message--add-endpoint"
        })), mappedHandlersOnThisAlert.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "rule-message--endpoints"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $bda6945ff06af317$export$2e2bcd8739ae039), {
            handlersOnThisAlert: mappedHandlersOnThisAlert,
            selectedHandler: selectedHandlerWithText,
            handleChooseHandler: this.handleChooseHandler,
            handleRemoveHandler: this.handleRemoveHandler
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $cde85255963691fc$export$2e2bcd8739ae039), {
            selectedHandler: selectedHandler,
            handleModifyHandler: this.handleModifyHandler,
            updateDetails: ruleActions.updateDetails,
            rule: rule,
            onGoToConfig: onGoToConfig,
            onTestHandler: onTestHandler,
            validationError: validationError
        })) : null, mappedHandlersOnThisAlert.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "rule-section--row rule-section--border-top rule-section--row-last rule-alert-options"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, "Alert Options:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-control-static"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            name: "noRecoveries",
            id: "noRecoveries",
            type: "checkbox",
            defaultChecked: rule.alertNodes.noRecoveries,
            onClick: this.handleNoRecoveries
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "noRecoveries"
        }, "Don't send alert on condition recovery")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-control-static"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            name: "stateChangesOnly",
            id: "stateChangesOnly",
            type: "checkbox",
            defaultChecked: rule.alertNodes.stateChangesOnly,
            onClick: this.handleStateChangesOnly
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: "stateChangesOnly"
        }, "Send alert only when condition state changes"))) : null));
    }
}
var $a5698c2a12d9e2f4$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($a5698c2a12d9e2f4$var$RuleHandlers);



var $NdCUR = parcelRequire("NdCUR");

const $7367d9cd38744e61$var$RuleHeaderSave = ({ onSave: onSave, validationError: validationError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, validationError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
        className: "btn btn-success btn-sm disabled",
        "data-for": "save-kapacitor-tooltip",
        "data-tip": validationError
    }, "Save Rule") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
        className: "btn btn-success btn-sm",
        onClick: onSave
    }, "Save Rule"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $82a18451bb6f6ba0$export$2e2bcd8739ae039), {
        id: "save-kapacitor-tooltip",
        effect: "solid",
        html: true,
        place: "bottom",
        class: "influx-tooltip kapacitor-tooltip"
    }));
var $7367d9cd38744e61$export$2e2bcd8739ae039 = $7367d9cd38744e61$var$RuleHeaderSave;



var $NdCUR = parcelRequire("NdCUR");
// Libraries

var $NdCUR = parcelRequire("NdCUR");
// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");
// Libraries

var $NdCUR = parcelRequire("NdCUR");


const $fe3f928519e86703$var$RuleMessageIcon = ({ validationState: validationState })=>{
    if (validationState === (0, $61056af5b9250c91$export$2a27dae48bac82b3).Validating) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7ba6e1db17640a51$export$2e2bcd8739ae039), {
        diameter: 15
    });
    if (validationState === (0, $61056af5b9250c91$export$2a27dae48bac82b3).Error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        className: "icon stop"
    });
    if (validationState === (0, $61056af5b9250c91$export$2a27dae48bac82b3).Success) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        className: "icon checkmark"
    });
    return null;
};
var $fe3f928519e86703$export$2e2bcd8739ae039 = $fe3f928519e86703$var$RuleMessageIcon;



const $7593da69953af9a1$var$RuleMessageStatus = ({ validationText: validationText, validationState: validationState })=>{
    const className = (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('query-status-output', {
        'query-status-output--success': validationState === (0, $61056af5b9250c91$export$2a27dae48bac82b3).Success,
        'query-status-output--error': validationState === (0, $61056af5b9250c91$export$2a27dae48bac82b3).Error
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "query-editor--status"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        className: className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fe3f928519e86703$export$2e2bcd8739ae039), {
        validationState: validationState
    }), validationText));
};
var $7593da69953af9a1$export$2e2bcd8739ae039 = $7593da69953af9a1$var$RuleMessageStatus;


// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");

const $befd29c02eec2dc3$var$RuleMessageTextArea = ({ message: message, onChange: onChange, onKeyUp: onKeyUp, validationState: validationState })=>{
    const className = (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('form-control input-sm monotype', {
        'form-volcano': validationState === (0, $61056af5b9250c91$export$2a27dae48bac82b3).Error,
        'form-malachite': validationState === (0, $61056af5b9250c91$export$2a27dae48bac82b3).Success
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("textarea", {
        value: message,
        onKeyUp: onKeyUp,
        spellCheck: false,
        onChange: onChange,
        className: className,
        placeholder: 'Example: {{ .ID }} is {{ .Level }} value: {{ index .Fields "value" }}'
    });
};
var $befd29c02eec2dc3$export$2e2bcd8739ae039 = $befd29c02eec2dc3$var$RuleMessageTextArea;


// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");


var $hBdgJ = parcelRequire("hBdgJ");

// the following template variables must also pass validation
// they are not that much common to be part of RULE_MESSAGE_TEMPLATE_TEXTS
const $3c50503eb8ee9a33$var$EXTRA_MESSAGE_VARIABLES = [
    '.Time.Unix',
    '.Time.UnixNano',
    '.'
];
// templates with global functions are valid as well - https://golang.org/pkg/text/template/#hdr-Functions
const $3c50503eb8ee9a33$var$GLOBAL_FUNCTIONS = [
    'and',
    'call',
    'html',
    'index',
    'slice',
    'js',
    'len',
    'not',
    'print',
    'printf',
    'println',
    'urlquery'
];
const $3c50503eb8ee9a33$export$77a51aa56fe80a89 = (template)=>{
    if (!!(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).find((0, $2aff9a9dae44a870$export$fe077c000bf9de77), (t)=>t === template) || !!(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).find($3c50503eb8ee9a33$var$EXTRA_MESSAGE_VARIABLES, (t)=>t === template)) return true;
    const fieldsRegex = /(index .Fields ".+")/;
    const tagsRegex = /(index .Tags ".+")/;
    const ifRegex = /(if .+)/;
    const rangeRegex = /(range .+)/;
    const blockRegex = /(block .+)/;
    const withRegex = /(with .+)/;
    const regexpTests = fieldsRegex.test(template) || tagsRegex.test(template) || ifRegex.test(template) || rangeRegex.test(template) || blockRegex.test(template) || withRegex.test(template);
    if (regexpTests) return true;
    // check if we have a prefix that we can remove
    const validPrefix = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).find($3c50503eb8ee9a33$var$GLOBAL_FUNCTIONS, (t)=>template.startsWith(t) && template.length > t.length && /\s/.test(template[t.length]));
    if (validPrefix) return $3c50503eb8ee9a33$export$77a51aa56fe80a89(template.substring(validPrefix.length + 1).trim());
    return false;
};
const $3c50503eb8ee9a33$export$f648e44869ab6afd = (message)=>{
    const templateRegexp = /((?:{{)([^{}]*)(?:}}))/g // matches {{*}} where star does not contain '{' or '}'
    ;
    const matches = [];
    let match = templateRegexp.exec(message);
    while(match){
        let insideBraces = match[2];
        // ignore template's text trimming when '{{- ' prefix or ' -}}' suffix
        if (insideBraces.startsWith('- ')) insideBraces = insideBraces.substring(2);
        if (insideBraces.endsWith(' -')) insideBraces = insideBraces.substring(0, insideBraces.length - 2);
        matches[matches.length] = insideBraces.trim();
        match = templateRegexp.exec(message);
    }
    const isValid = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).every(matches, (m)=>$3c50503eb8ee9a33$export$77a51aa56fe80a89(m));
    return isValid;
};
var $3c50503eb8ee9a33$export$2e2bcd8739ae039 = $3c50503eb8ee9a33$export$f648e44869ab6afd;



const $bcc42828a32d2568$export$ee58eb577a1f7d7a = async (url, template)=>{
    const { data: validation } = await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
        url: url,
        method: 'POST',
        data: {
            template: template
        }
    });
    return validation;
};


// Copy
const $6093e7c676877d79$var$messageValid = 'Alert message is syntactically correct.';
const $6093e7c676877d79$var$messageInvalid = 'Please correct templates in alert message.';
const $6093e7c676877d79$var$messageValidating = 'Validating template';
const $6093e7c676877d79$export$658840cbfe7e7293 = (typingStatus, ruleMessage)=>{
    // text is the validation text to display to the user
    const [text, setValidationText] = (0, $NdCUR.useState)('');
    // state is the current state of go template parsing
    const [state, setValidationState] = (0, $NdCUR.useState)((0, $61056af5b9250c91$export$2a27dae48bac82b3).NotStarted);
    (0, $NdCUR.useEffect)(()=>{
        const validate = async ()=>{
            if (typingStatus === (0, $61056af5b9250c91$export$89d04bf4bca317e9).Started) {
                setValidationState((0, $61056af5b9250c91$export$2a27dae48bac82b3).Validating);
                setValidationText($6093e7c676877d79$var$messageValidating);
            }
            if (typingStatus === (0, $61056af5b9250c91$export$89d04bf4bca317e9).Done) try {
                await (0, $bcc42828a32d2568$export$ee58eb577a1f7d7a)('/chronograf/v1/validate_text_templates', ruleMessage);
                const matchesVars = (0, $3c50503eb8ee9a33$export$2e2bcd8739ae039)(ruleMessage);
                if (matchesVars) {
                    setValidationText($6093e7c676877d79$var$messageValid);
                    setValidationState((0, $61056af5b9250c91$export$2a27dae48bac82b3).Success);
                } else {
                    setValidationText($6093e7c676877d79$var$messageInvalid);
                    setValidationState((0, $61056af5b9250c91$export$2a27dae48bac82b3).Error);
                }
            } catch (error) {
                const errorMessage = (0, $hBdgJ.get)(error, 'data.message', $6093e7c676877d79$var$messageInvalid);
                setValidationText(errorMessage);
                setValidationState((0, $61056af5b9250c91$export$2a27dae48bac82b3).Error);
            }
        };
        validate();
    }, [
        typingStatus
    ]);
    return {
        text: text,
        state: state
    };
};




const $dc3cb122bf189e09$var$debouncer = new (0, $075f3b99bb3716e4$export$2e2bcd8739ae039)();
const $dc3cb122bf189e09$var$RuleMessageText = ({ message: message, updateMessage: updateMessage })=>{
    const [typingStatus, setTypingStatus] = (0, $NdCUR.useState)((0, $61056af5b9250c91$export$89d04bf4bca317e9).NotStarted);
    const validation = (0, $6093e7c676877d79$export$658840cbfe7e7293)(typingStatus, message);
    const typingDone = (0, $NdCUR.useCallback)(()=>{
        setTypingStatus((0, $61056af5b9250c91$export$89d04bf4bca317e9).Done);
    }, [
        setTypingStatus
    ]);
    const onKeyUp = ()=>{
        const waitForEndTypingMs = 500;
        $dc3cb122bf189e09$var$debouncer.call(typingDone, waitForEndTypingMs);
    };
    const onChange = (e)=>{
        if (typingStatus !== (0, $61056af5b9250c91$export$89d04bf4bca317e9).Started) setTypingStatus((0, $61056af5b9250c91$export$89d04bf4bca317e9).Started);
        updateMessage(e);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "rule-builder--message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $befd29c02eec2dc3$export$2e2bcd8739ae039), {
        message: message,
        onKeyUp: onKeyUp,
        onChange: onChange,
        validationState: validation.state
    }), message && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7593da69953af9a1$export$2e2bcd8739ae039), {
        validationState: validation.state,
        validationText: validation.text
    }));
};
var $dc3cb122bf189e09$export$2e2bcd8739ae039 = $dc3cb122bf189e09$var$RuleMessageText;



var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");


var $NdCUR = parcelRequire("NdCUR");
const $f16980c61d8bd47d$var$CodeData = ({ onClickTemplate: onClickTemplate, template: template })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("code", {
        className: "rule-builder--message-template",
        "data-tip": template.text,
        onClick: onClickTemplate
    }, template.label);
var $f16980c61d8bd47d$export$2e2bcd8739ae039 = $f16980c61d8bd47d$var$CodeData;




// needs to be React Component for CodeData click handler to work
class $ca949f5b6d2178d7$var$RuleMessageTemplates extends (0, $NdCUR.Component) {
    constructor(props){
        super(props), this.handleClickTemplate = (template)=>()=>{
                const { updateMessage: updateMessage, rule: rule } = this.props;
                updateMessage(rule.id, `${rule.message} ${template.label}`);
            };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "rule-section--row rule-section--row-last"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, "Templates:"), (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).map((0, $2aff9a9dae44a870$export$60a7204fde4e6dc7), (template, key)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $f16980c61d8bd47d$export$2e2bcd8739ae039), {
                key: key,
                template: template,
                onClickTemplate: this.handleClickTemplate(template)
            });
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $82a18451bb6f6ba0$export$2e2bcd8739ae039), {
            effect: "solid",
            html: true,
            class: "influx-tooltip kapacitor-tooltip"
        }));
    }
}
var $ca949f5b6d2178d7$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($ca949f5b6d2178d7$var$RuleMessageTemplates);



class $08cd7e685ad4ea7c$var$RuleMessage extends (0, $NdCUR.Component) {
    constructor(props){
        super(props), this.handleChangeMessage = (e)=>{
            const { ruleActions: ruleActions, rule: rule } = this.props;
            ruleActions.updateMessage(rule.id, e.target.value);
        };
    }
    render() {
        const { rule: rule, ruleActions: ruleActions } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "rule-section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h3", {
            className: "rule-section--heading"
        }, "Message"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "rule-section--body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dc3cb122bf189e09$export$2e2bcd8739ae039), {
            message: rule.message,
            updateMessage: this.handleChangeMessage
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ca949f5b6d2178d7$export$2e2bcd8739ae039), {
            rule: rule,
            updateMessage: ruleActions.updateMessage
        })));
    }
}
var $08cd7e685ad4ea7c$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($08cd7e685ad4ea7c$var$RuleMessage);











class $75eec0b449024477$var$KapacitorRule extends (0, $NdCUR.Component) {
    constructor(props){
        super(props), this.handleChooseTimeRange = ({ lower: lower })=>{
            const timeRange = (0, $6a7b0ae94f8ec28f$export$9b55ef3c660cd071).find((range)=>range.lower === lower);
            this.setState({
                timeRange: timeRange
            });
        }, this.handleCreate = (pathname)=>{
            const { notify: notify, queryConfigs: queryConfigs, rule: rule, kapacitor: kapacitor } = this.props;
            const newRule = Object.assign({}, rule, {
                query: queryConfigs[rule.queryID]
            });
            delete newRule.queryID;
            this.applyRuleWorkarounds(newRule);
            (0, $c836572692edfbec$export$56e87122f905fac0)(kapacitor, newRule).then(()=>{
                this.exitPage(pathname);
                notify((0, $ec1f42de4faacc37$export$5df45d19808f1d9d)(newRule.name));
            }).catch((e)=>{
                notify((0, $ec1f42de4faacc37$export$ed834968f44fc6b8)(newRule.name, e.data.message));
            });
        }, this.handleEdit = (pathname)=>{
            const { notify: notify, queryConfigs: queryConfigs, rule: rule } = this.props;
            const updatedRule = Object.assign({}, rule, {
                query: queryConfigs[rule.queryID]
            });
            this.applyRuleWorkarounds(updatedRule);
            (0, $c836572692edfbec$export$41f8c4ddfb0d5041)(updatedRule).then(()=>{
                this.exitPage(pathname);
                notify((0, $ec1f42de4faacc37$export$7ebcc4382eca02d)(rule.name));
            }).catch((e)=>{
                notify((0, $ec1f42de4faacc37$export$47898d2d85291ebb)(rule.name, e?.data?.message || String(e)));
            });
        }, this.handleSave = ()=>{
            const { rule: rule } = this.props;
            if (rule.id === (0, $2aff9a9dae44a870$export$f20cff0eb3a8b896)) this.handleCreate();
            else this.handleEdit();
        }, this.handleSaveToConfig = (configName)=>()=>{
                const { rule: rule, configLink: configLink, router: router } = this.props;
                const pathname = `${configLink}#${configName}`;
                if (this.validationError) {
                    router.push({
                        pathname: pathname
                    });
                    return;
                }
                if (rule.id === (0, $2aff9a9dae44a870$export$f20cff0eb3a8b896)) this.handleCreate(pathname);
                else this.handleEdit(pathname);
            }, this.handleTestHandler = (configName)=>async (handler, toTestProperty = {})=>{
                const testData = Object.keys(handler).reduce((acc, key)=>{
                    // ignore: 'type' is created by UI, 'enabled' is not used by testing
                    if (key === 'enabled' || key === 'type') return acc;
                    if (key === '_type') {
                        acc.type = handler._type;
                        return acc;
                    }
                    if (toTestProperty[key]) {
                        acc[toTestProperty[key]] = handler[key];
                        return acc;
                    }
                    // common property
                    acc[key] = handler[key];
                    // there are naming problems in kapacitor, - and _ are used inconsistently in tickscript and testing options
                    acc[key.replace('-', '_')] = acc[key];
                    acc[key.replace('_', '-')] = acc[key];
                    return acc;
                }, {});
                try {
                    const { data: data } = await (0, $3bff70d0456af5c0$export$ed3a4ae2fb209f22)(this.props.kapacitor, configName, testData, testData);
                    if (data.success) this.props.notify((0, $ec1f42de4faacc37$export$b68e24ec4022574)(configName));
                    else this.props.notify((0, $ec1f42de4faacc37$export$b5e165c93210c11b)(configName, data.message));
                } catch (error) {
                    this.props.notify((0, $ec1f42de4faacc37$export$b5e165c93210c11b)(configName));
                }
            }, this.handleAddEvery = (frequency)=>{
            const { rule: { id: ruleID }, ruleActions: { addEvery: addEvery } } = this.props;
            addEvery(ruleID, frequency);
        }, this.handleRemoveEvery = ()=>{
            const { rule: { id: ruleID }, ruleActions: { removeEvery: removeEvery } } = this.props;
            removeEvery(ruleID);
        }, this.deadmanValidation = ()=>{
            const { query: query } = this.props;
            if (query && (!query.database || !query.measurement)) return (0, $ec1f42de4faacc37$export$ec77ce4d517f2f5e)();
            return '';
        }, this.handleRuleTypeDropdownChange = ({ type: type, text: text })=>{
            const { ruleActions: ruleActions, rule: rule } = this.props;
            ruleActions.updateRuleValues(rule.id, rule.trigger, {
                ...this.props.rule.values,
                [type]: text
            });
        }, this.handleRuleTypeInputChange = (e)=>{
            const { ruleActions: ruleActions, rule: rule } = this.props;
            const { lower: lower, upper: upper } = e.target.form;
            ruleActions.updateRuleValues(rule.id, rule.trigger, {
                ...this.props.rule.values,
                value: lower.value,
                rangeValue: upper ? upper.value : ''
            });
        }, this.handleDeadmanChange = ({ text: text })=>{
            const { ruleActions: ruleActions, rule: rule } = this.props;
            ruleActions.updateRuleValues(rule.id, rule.trigger, {
                period: text
            });
        };
        this.state = {
            timeRange: (0, $6a7b0ae94f8ec28f$export$9b55ef3c660cd071).find((tr)=>tr.lower === 'now() - 15m')
        };
    }
    render() {
        const { rule: rule, source: source, ruleActions: ruleActions, queryConfigs: queryConfigs, handlersFromConfig: handlersFromConfig, queryConfigActions: queryConfigActions } = this.props;
        const { chooseTrigger: chooseTrigger, updateRuleValues: updateRuleValues } = ruleActions;
        const { timeRange: timeRange } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header.Left, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Title, {
            title: "Alert Rule Builder"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header.Right, {
            showSourceIndicator: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7367d9cd38744e61$export$2e2bcd8739ae039), {
            onSave: this.handleSave,
            validationError: this.validationError
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Contents, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "rule-builder"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $f86470b8a1d0e0dc$export$2e2bcd8739ae039), {
            rule: rule,
            defaultName: rule.name,
            onRuleRename: ruleActions.updateRuleName
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fb69a5debf0306ef$export$2e2bcd8739ae039), {
            rule: rule,
            source: source,
            timeRange: timeRange,
            onChooseTrigger: chooseTrigger,
            onAddEvery: this.handleAddEvery,
            onUpdateValues: updateRuleValues,
            query: queryConfigs[rule.queryID],
            onRemoveEvery: this.handleRemoveEvery,
            queryConfigActions: queryConfigActions,
            onDeadmanChange: this.handleDeadmanChange,
            onRuleTypeInputChange: this.handleRuleTypeInputChange,
            onRuleTypeDropdownChange: this.handleRuleTypeDropdownChange,
            onChooseTimeRange: this.handleChooseTimeRange
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a5698c2a12d9e2f4$export$2e2bcd8739ae039), {
            rule: rule,
            ruleActions: ruleActions,
            handlersFromConfig: handlersFromConfig,
            onGoToConfig: this.handleSaveToConfig,
            onTestHandler: this.handleTestHandler,
            validationError: this.validationError
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $08cd7e685ad4ea7c$export$2e2bcd8739ae039), {
            rule: rule,
            ruleActions: ruleActions
        }))));
    }
    applyRuleWorkarounds(updatedRule) {
        // defect #5768 - naming issue
        if (updatedRule.alertNodes?.teams?.length) {
            const teams = updatedRule.alertNodes.teams[0];
            if (teams['channel-url']) teams.channel_url = teams['channel-url'];
        }
    }
    exitPage(pathname) {
        const { source: source, router: router } = this.props;
        if (pathname) return router.push(pathname);
        const location = router.location;
        if (location?.query?.l === 't') return router.push(`/sources/${source.id}/tickscripts${location?.search || ''}`);
        router.push(`/sources/${source.id}/alert-rules`);
    }
    get validationError() {
        const { rule: rule, query: query } = this.props;
        if (rule.trigger === 'deadman') return this.deadmanValidation();
        if (!(0, $7b2c5b24a44a7fa2$export$2e2bcd8739ae039)({
            lower: ''
        }, query)) return (0, $ec1f42de4faacc37$export$b5dc5f7a41f67809)();
        if (!rule.values.value) return (0, $ec1f42de4faacc37$export$63c9b60b7014c624)();
        if (rule.message && !(0, $3c50503eb8ee9a33$export$2e2bcd8739ae039)(rule.message)) return 'Please correct template values in the alert message.';
        return '';
    }
}
const $75eec0b449024477$var$mapDispatchToProps = (dispatch)=>({
        notify: (0, $1f80bbeadc1a0021$export$2e2bcd8739ae039)((0, $205d139de2918454$export$5e14cdade93d6f7b), dispatch)
    });
var $75eec0b449024477$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)(null, $75eec0b449024477$var$mapDispatchToProps)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($75eec0b449024477$var$KapacitorRule));



var $hBdgJ = parcelRequire("hBdgJ");

const $0dc236c178cf0ed9$var$getElementOptions = (section)=>{
    const elements = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(section, 'elements', []);
    if (elements.length === 0) return {};
    return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).map(elements, (element)=>(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(element, 'options', {}));
};
const $0dc236c178cf0ed9$var$parseHandlersFromConfig = (config)=>{
    const { data: { sections: sections } } = config;
    const allHandlers = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).reduce(sections, (acc, v, k)=>{
        const options = $0dc236c178cf0ed9$var$getElementOptions(v);
        const type = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get((0, $2aff9a9dae44a870$export$86f0d6fad2354a02), k, k);
        (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).forEach(options, (option)=>{
            const toAdd = {
                // fill type with handler names in rule
                ...option,
                type: type
            };
            if (option.type) // zenoss uses type property that is reserved internally
            // it is mapped to _type
            toAdd._type = option.type;
            acc.push(toAdd);
        });
        return acc;
    }, []);
    // map handler names from config to handler names in rule
    const mappedHandlers = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).mapKeys(allHandlers, (v, k)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get((0, $2aff9a9dae44a870$export$86f0d6fad2354a02), k, k);
    });
    // filter out any handlers from config that are not allowed
    const allowedHandlers = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).filter(mappedHandlers, (h)=>h.type in (0, $2aff9a9dae44a870$export$6f8a1490aabaf436));
    // filter out any fields of handlers that are not allowed
    const pickedHandlers = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).map(allowedHandlers, (h)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).pick(h, [
            'type',
            'enabled',
            ...(0, $2aff9a9dae44a870$export$6f8a1490aabaf436)[h.type]
        ]);
    });
    // map field names from config to field names in rule
    const fieldKeyMappedHandlers = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).map(pickedHandlers, (h)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).mapKeys(h, (v, k)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get((0, $2aff9a9dae44a870$export$e5e1e7e16f25f098)[h.type], k, k);
        });
    });
    return fieldKeyMappedHandlers;
};
var $0dc236c178cf0ed9$export$2e2bcd8739ae039 = $0dc236c178cf0ed9$var$parseHandlersFromConfig;






class $c6f08f0d7d8c82a1$var$KapacitorRulePage extends (0, $NdCUR.Component) {
    constructor(props){
        super(props);
        this.state = {
            handlersFromConfig: [],
            kapacitor: {}
        };
    }
    async componentDidMount() {
        const { params: params, source: source, ruleActions: ruleActions, notify: notify } = this.props;
        if (params.ruleID === 'new') ruleActions.loadDefaultRule();
        else ruleActions.fetchRule(source, params.ruleID);
        let kapacitor;
        if (params.kid) kapacitor = await (0, $3bff70d0456af5c0$export$c751af5d7f198354)(this.props.source, params.kid);
        else kapacitor = await (0, $3bff70d0456af5c0$export$82a2e3b7e5164c8a)(source);
        if (!kapacitor) return notify((0, $ec1f42de4faacc37$export$d9701f6e26d94d71)());
        try {
            const kapacitorConfig = await (0, $3bff70d0456af5c0$export$1bad164085925c74)(kapacitor);
            const handlersFromConfig = (0, $0dc236c178cf0ed9$export$2e2bcd8739ae039)(kapacitorConfig);
            this.setState({
                kapacitor: kapacitor,
                handlersFromConfig: handlersFromConfig
            });
        } catch (error) {
            notify((0, $ec1f42de4faacc37$export$3a02db82a483db3a)());
            console.error(error);
            throw error;
        }
    }
    render() {
        const { params: params, source: source, router: router, ruleActions: ruleActions, queryConfigs: queryConfigs, queryConfigActions: queryConfigActions } = this.props;
        const { handlersFromConfig: handlersFromConfig, kapacitor: kapacitor } = this.state;
        const rule = this.rule;
        const query = rule && queryConfigs[rule.queryID];
        if (rule && rule['template-id'] && kapacitor) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Contents, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null, "This rule was created from a template. It cannot be edited in chronograf, see its", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ba1cc4424c00aefe$export$2e2bcd8739ae039), {
            to: `sources/${source.id}/kapacitors/${kapacitor.id}/tickscripts/${rule.id}`
        }, "TICKScript"), ".")));
        if (!query) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $810ad5a94daa03b8$export$2e2bcd8739ae039), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $75eec0b449024477$export$2e2bcd8739ae039), {
            source: source,
            rule: rule,
            query: query,
            queryConfigs: queryConfigs,
            queryConfigActions: queryConfigActions,
            ruleActions: ruleActions,
            handlersFromConfig: handlersFromConfig,
            ruleID: params.ruleID,
            router: router,
            kapacitor: kapacitor,
            configLink: `/sources/${source.id}/kapacitors/${this.kapacitorID}/edit`
        });
    }
    get kapacitorID() {
        const { kapacitor: kapacitor } = this.state;
        return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(kapacitor, 'id');
    }
    get rule() {
        const { params: params, rules: rules } = this.props;
        const ruleID = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(params, 'ruleID');
        if (ruleID === 'new') return rules[0, $2aff9a9dae44a870$export$f20cff0eb3a8b896];
        return rules[params.ruleID];
    }
}
const $c6f08f0d7d8c82a1$var$mapStateToProps = ({ rules: rules, kapacitorQueryConfigs: queryConfigs })=>({
        rules: rules,
        queryConfigs: queryConfigs
    });
const $c6f08f0d7d8c82a1$var$mapDispatchToProps = (dispatch)=>({
        ruleActions: (0, $1f80bbeadc1a0021$export$2e2bcd8739ae039)($413b7ff06f318700$exports, dispatch),
        notify: (0, $1f80bbeadc1a0021$export$2e2bcd8739ae039)((0, $205d139de2918454$export$5e14cdade93d6f7b), dispatch),
        queryConfigActions: (0, $1f80bbeadc1a0021$export$2e2bcd8739ae039)($4f7db08908a3084d$exports, dispatch)
    });
var $c6f08f0d7d8c82a1$export$2e2bcd8739ae039 = (0, $c8cd79e362cba2a4$export$a520fb22fccea800)((0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($c6f08f0d7d8c82a1$var$mapStateToProps, $c6f08f0d7d8c82a1$var$mapDispatchToProps)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($c6f08f0d7d8c82a1$var$KapacitorRulePage)));


// Libraries

var $NdCUR = parcelRequire("NdCUR");



const $9541f29439ffa68c$var$activeKapacitorFromSources = (source, sources)=>{
    if (!source || !sources) return null;
    const ActiveSource = sources.find((s)=>s.id === source.id);
    if (!ActiveSource || !ActiveSource.kapacitors) return null;
    const { kapacitors: kapacitors } = ActiveSource;
    return kapacitors.find((k)=>k.active) || kapacitors[0];
};
var $9541f29439ffa68c$export$2e2bcd8739ae039 = $9541f29439ffa68c$var$activeKapacitorFromSources;







var $NdCUR = parcelRequire("NdCUR");


var $NdCUR = parcelRequire("NdCUR");


var $hBdgJ = parcelRequire("hBdgJ");



const $063b710ad7fb02e4$export$cddaf6cea22db06c = {
    colName: '200px',
    colTrigger: '90px',
    colMessage: '200px',
    colAlerts: '120px',
    colEnabled: '95px',
    colActions: '68px',
    colType: '90px',
    colEvery: '90px',
    colCron: '90px'
};


const { colName: $11f5b907eec19cc1$var$colName, colTrigger: $11f5b907eec19cc1$var$colTrigger, colMessage: $11f5b907eec19cc1$var$colMessage, colAlerts: $11f5b907eec19cc1$var$colAlerts, colEnabled: $11f5b907eec19cc1$var$colEnabled, colActions: $11f5b907eec19cc1$var$colActions } = (0, $063b710ad7fb02e4$export$cddaf6cea22db06c);
const $11f5b907eec19cc1$var$KapacitorRulesTable = ({ rules: rules, kapacitorLink: kapacitorLink, onChangeRuleStatus: onChangeRuleStatus, onDelete: onDelete })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("table", {
        className: "table v-center table-highlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
        style: {
            minWidth: $11f5b907eec19cc1$var$colName
        }
    }, "Name"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
        style: {
            width: $11f5b907eec19cc1$var$colTrigger
        }
    }, "Rule Type"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
        style: {
            width: $11f5b907eec19cc1$var$colMessage
        }
    }, "Message"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
        style: {
            width: $11f5b907eec19cc1$var$colAlerts
        }
    }, "Alert Handlers"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
        style: {
            width: $11f5b907eec19cc1$var$colEnabled
        },
        className: "text-center"
    }, "Task Enabled"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
        style: {
            width: $11f5b907eec19cc1$var$colActions
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tbody", null, (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).sortBy(rules, (r)=>r.name.toLowerCase()).map((rule)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($11f5b907eec19cc1$export$38830e5a44acf89f, {
            key: rule.id,
            rule: rule,
            editLink: `${kapacitorLink}/alert-rules/${rule.id}`,
            onDelete: onDelete,
            onChangeRuleStatus: onChangeRuleStatus
        });
    })));
class $11f5b907eec19cc1$var$RuleRow extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props);
        this.handleClickRuleStatusEnabled = this.handleClickRuleStatusEnabled.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
    }
    handleClickRuleStatusEnabled(rule) {
        return ()=>{
            this.props.onChangeRuleStatus(rule);
        };
    }
    handleDelete(rule) {
        return ()=>{
            this.props.onDelete(rule);
        };
    }
    render() {
        const { rule: rule, editLink: editLink } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tr", {
            key: rule.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            style: {
                minWidth: $11f5b907eec19cc1$var$colName
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ba1cc4424c00aefe$export$2e2bcd8739ae039), {
            to: editLink
        }, rule.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            style: {
                width: $11f5b907eec19cc1$var$colTrigger,
                textTransform: 'capitalize'
            }
        }, rule.trigger), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            style: {
                width: $11f5b907eec19cc1$var$colMessage
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "text-ellipsis",
            style: {
                maxWidth: $11f5b907eec19cc1$var$colMessage
            }
        }, rule.message)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            style: {
                width: $11f5b907eec19cc1$var$colAlerts
            }
        }, (0, $2a661c3679d1aa5a$export$c13dcb14e7ee62)(rule)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            style: {
                width: $11f5b907eec19cc1$var$colEnabled
            },
            className: "text-center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "dark-checkbox"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            id: `kapacitor-rule-row-task-enabled ${rule.id}`,
            className: "form-control-static",
            type: "checkbox",
            checked: rule.status === 'enabled',
            onChange: this.handleClickRuleStatusEnabled(rule)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: `kapacitor-rule-row-task-enabled ${rule.id}`
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            style: {
                width: $11f5b907eec19cc1$var$colActions
            },
            className: "text-right"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $8008717819fc7a5f$export$2e2bcd8739ae039), {
            text: "Delete",
            type: "btn-danger",
            size: "btn-xs",
            customClass: "table--show-on-row-hover",
            confirmAction: this.handleDelete(rule)
        })));
    }
}
const $11f5b907eec19cc1$export$38830e5a44acf89f = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($11f5b907eec19cc1$var$RuleRow);
var $11f5b907eec19cc1$export$2e2bcd8739ae039 = $11f5b907eec19cc1$var$KapacitorRulesTable;


const $4aea98d0f9cb3616$var$KapacitorRules = ({ source: source, kapacitor: kapacitor, rules: rules, onDelete: onDelete, onChangeRuleStatus: onChangeRuleStatus })=>{
    const builderRules = rules.filter((r)=>r.query);
    const builderHeader = `${builderRules.length} Alert Rule${builderRules.length === 1 ? '' : 's'}`;
    const kapacitorLink = `/sources/${source.id}/kapacitors/${kapacitor.id}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel-heading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h2", {
        className: "panel-title"
    }, builderHeader), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ba1cc4424c00aefe$export$2e2bcd8739ae039), {
        to: `${kapacitorLink}/alert-rules/new`,
        className: "btn btn-sm btn-primary",
        style: {
            marginRight: '4px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        className: "icon plus"
    }), " Build Alert Rule")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel-body"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $11f5b907eec19cc1$export$2e2bcd8739ae039), {
        kapacitorLink: kapacitorLink,
        rules: builderRules,
        onDelete: onDelete,
        onChangeRuleStatus: onChangeRuleStatus
    }))));
};
var $4aea98d0f9cb3616$export$2e2bcd8739ae039 = $4aea98d0f9cb3616$var$KapacitorRules;









class $41a1e40c30112c9e$var$KapacitorRulesPage extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleSetActiveKapacitor = async (kapacitorID)=>{
            const { setActiveKapacitor: setActiveKapacitor } = this.props;
            const kapacitors = this.kapacitors;
            const toKapacitor = kapacitors.find((k)=>k.id === kapacitorID);
            await setActiveKapacitor(toKapacitor);
            await this.pingAndFetchRules(toKapacitor);
        }, this.pingAndFetchRules = async (kapacitor)=>{
            try {
                await this.props.fetchRules(kapacitor);
                await (0, $3bff70d0456af5c0$export$41af5c3435cc7908)(kapacitor);
            } catch (error) {
                this.props.notify((0, $ec1f42de4faacc37$export$3d61248777676e06)());
            }
        }, this.handleDeleteRule = (rule)=>{
            const { deleteRule: deleteRule } = this.props;
            deleteRule(rule);
        }, this.handleRuleStatus = (rule)=>{
            const { updateRuleStatus: updateRuleStatus, updateRuleStatusSuccess: updateRuleStatusSuccess } = this.props;
            const status = rule.status === 'enabled' ? 'disabled' : 'enabled';
            updateRuleStatus(rule, status);
            updateRuleStatusSuccess(rule.id, status);
        };
        this.state = {
            loading: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).NotStarted
        };
    }
    async componentDidMount() {
        const { source: source, fetchKapacitors: fetchKapacitors } = this.props;
        this.setState({
            loading: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading
        });
        await fetchKapacitors(source);
        const kapacitor = this.kapacitor;
        if (kapacitor) await this.pingAndFetchRules(kapacitor);
        this.setState({
            loading: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039), {
            className: this.className
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header.Left, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Title, {
            title: this.headerTitle
        }), this.kapacitorsDropdown), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header.Right, {
            showSourceIndicator: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1ca55233f3c1ef57$export$2e2bcd8739ae039), {
            tipID: "manage-tasks--tooltip",
            tipContent: "<b>Alert Rules</b> generate a TICKscript for<br/>you using our Builder UI.<br/><br/>Not all TICKscripts can be edited<br/>using the Builder."
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Contents, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $4ee59a55fab29874$export$2e2bcd8739ae039), {
            loading: this.state.loading
        }, this.rules)));
    }
    get rules() {
        const kapacitor = this.kapacitor;
        const { source: source, rules: rules } = this.props;
        if (!kapacitor) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $16af25b437b7972f$export$2e2bcd8739ae039), {
            source: source
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $4aea98d0f9cb3616$export$2e2bcd8739ae039), {
            rules: rules,
            source: source,
            kapacitor: kapacitor,
            onDelete: this.handleDeleteRule,
            onChangeRuleStatus: this.handleRuleStatus
        });
    }
    get kapacitorsDropdown() {
        const kapacitor = this.kapacitor;
        const kapacitors = this.kapacitors;
        if (!kapacitor) return null;
        const dropDownItems = kapacitors.map((k)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $f040dbec7e8f99c8$export$2e2bcd8739ae039).Item, {
                key: k.id,
                id: k.id,
                value: k.id
            }, `${k.name} @ ${k.url}`));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $f040dbec7e8f99c8$export$2e2bcd8739ae039), {
            customClass: "kapacitor-switcher",
            onChange: this.handleSetActiveKapacitor,
            widthPixels: 330,
            selectedID: kapacitor.id
        }, dropDownItems);
    }
    get kapacitors() {
        const { sources: sources, source: source } = this.props;
        const activeSource = sources.find((s)=>s.id === source.id);
        return (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(activeSource, 'kapacitors', []);
    }
    get kapacitor() {
        const { sources: sources, source: source } = this.props;
        return (0, $9541f29439ffa68c$export$2e2bcd8739ae039)(source, sources);
    }
    get headerTitle() {
        const kapacitor = this.kapacitor;
        if (!kapacitor) return 'Manage Alert Rules';
        return `Manage Alert Rules on`;
    }
    get className() {
        const kapacitor = this.kapacitor;
        if (!kapacitor) return 'empty-tasks-page';
        return '';
    }
}
const $41a1e40c30112c9e$var$mstp = ({ rules: rules, sources: sources, fluxTasks: fluxTasks })=>({
        rules: Object.values(rules),
        sources: sources,
        fluxTasks: fluxTasks
    });
const $41a1e40c30112c9e$var$mdtp = {
    fetchRules: $413b7ff06f318700$export$2b27f4974f0fa742,
    deleteRule: $413b7ff06f318700$export$988cba38e738f27d,
    updateRuleStatus: $413b7ff06f318700$export$fd0bd303c88e021a,
    updateRuleStatusSuccess: $413b7ff06f318700$export$28708bbb7c03de51,
    fetchKapacitors: $b73fb830e0a94a1d$export$c18bacb24d8f6935,
    setActiveKapacitor: $b73fb830e0a94a1d$export$7bafe015e336e80b,
    notify: (0, $205d139de2918454$export$5e14cdade93d6f7b)
};
var $41a1e40c30112c9e$export$2e2bcd8739ae039 = (0, $c8cd79e362cba2a4$export$a520fb22fccea800)((0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($41a1e40c30112c9e$var$mstp, $41a1e40c30112c9e$var$mdtp)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($41a1e40c30112c9e$var$KapacitorRulesPage)));



var $NdCUR = parcelRequire("NdCUR");





var $NdCUR = parcelRequire("NdCUR");

var $NdCUR = parcelRequire("NdCUR");

// Libraries

var $NdCUR = parcelRequire("NdCUR");


class $74f53be259d1daa3$var$LogsToggle extends (0, $NdCUR.PureComponent) {
    render() {
        const { areLogsVisible: areLogsVisible, areLogsEnabled: areLogsEnabled, onToggleLogsVisibility: onToggleLogsVisibility } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039), {
            color: (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Success
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039).Button, {
            id: "tickscript-logs--hidden",
            active: !areLogsVisible,
            value: false,
            onClick: onToggleLogsVisibility,
            titleText: "Show just the TICKscript Editor",
            disabledTitleText: "Log viewing is currently disabled",
            disabled: !areLogsEnabled
        }, "Editor"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039).Button, {
            id: "tickscript-logs--visible",
            active: areLogsVisible,
            value: true,
            onClick: onToggleLogsVisibility,
            titleText: "Show the TICKscript Editor & Logs Viewer",
            disabledTitleText: "Log viewing is currently disabled",
            disabled: !areLogsEnabled
        }, "Editor + Logs"));
    }
}
var $74f53be259d1daa3$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($74f53be259d1daa3$var$LogsToggle);




var $NdCUR = parcelRequire("NdCUR");

class $ff03f274b12bf462$var$TickscriptSave extends (0, $NdCUR.PureComponent) {
    render() {
        const { onSave: onSave } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-success btn-sm",
            title: this.title,
            onClick: onSave,
            disabled: this.isDisabled
        }, this.textContent);
    }
    get title() {
        const { task: task } = this.props;
        if (!task.id) return 'Name your TICKscript to save';
        if (!task.dbrps.length) return 'Select databases to save';
    }
    get textContent() {
        if (this.props.isNewTickscript) return 'Save New TICKscript';
        return 'Save Changes';
    }
    get isDisabled() {
        const { isNewTickscript: isNewTickscript, unsavedChanges: unsavedChanges, task: task } = this.props;
        const { id: id, dbrps: dbrps } = task;
        if (isNewTickscript) return !id || !dbrps.length;
        return !unsavedChanges || !dbrps.length;
    }
}
var $ff03f274b12bf462$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($ff03f274b12bf462$var$TickscriptSave);


class $85066abc7f07bcc7$var$TickscriptHeader extends (0, $NdCUR.Component) {
    render() {
        const { task: task, onSave: onSave, unsavedChanges: unsavedChanges, isNewTickscript: isNewTickscript, areLogsEnabled: areLogsEnabled, areLogsVisible: areLogsVisible, onToggleLogsVisibility: onToggleLogsVisibility, onOpenBuilderUI: onOpenBuilderUI } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header, {
            fullWidth: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header.Left, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Title, {
            title: "TICKscript Editor"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header.Right, {
            showSourceIndicator: true
        }, !!task.query && !task.templateID ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-sm btn-primary",
            title: "Open TICKscript in Alert Rule Builder",
            onClick: onOpenBuilderUI
        }, "Alert Rule Builder") : undefined, isNewTickscript ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-sm btn-default",
            title: "Use Alert Rule Builder to create a new TICKscript",
            onClick: onOpenBuilderUI
        }, "Alert Rule Builder") : undefined, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $74f53be259d1daa3$export$2e2bcd8739ae039), {
            areLogsEnabled: areLogsEnabled,
            areLogsVisible: areLogsVisible,
            onToggleLogsVisibility: onToggleLogsVisibility
        }), task.templateID ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ff03f274b12bf462$export$2e2bcd8739ae039), {
            task: task,
            onSave: onSave,
            unsavedChanges: unsavedChanges,
            isNewTickscript: isNewTickscript
        }), this.saveButton));
    }
    get saveButton() {
        const { unsavedChanges: unsavedChanges, onExit: onExit } = this.props;
        if (unsavedChanges) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $8008717819fc7a5f$export$2e2bcd8739ae039), {
            text: "Exit",
            confirmText: "Discard unsaved changes?",
            confirmAction: onExit
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-default btn-sm",
            title: "Return to Alert Rules",
            onClick: onExit
        }, "Exit");
    }
}
var $85066abc7f07bcc7$export$2e2bcd8739ae039 = $85066abc7f07bcc7$var$TickscriptHeader;



var $NdCUR = parcelRequire("NdCUR");



const $e9518cd09d459fdb$var$NOOP = ()=>{};
class $e9518cd09d459fdb$var$TickscriptEditor extends (0, $NdCUR.Component) {
    constructor(props){
        super(props), this.updateCode = (_, __, script)=>{
            this.props.onChangeScript(script);
        };
    }
    render() {
        const { script: script, readOnly: readOnly } = this.props;
        const options = {
            lineNumbers: true,
            theme: 'tickscript',
            tabIndex: 1,
            readOnly: !!readOnly,
            mode: 'tickscript'
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "tickscript-editor"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b1cb9a1ab496dfeb$exports.Controlled), {
            value: script,
            onBeforeChange: this.updateCode,
            options: options,
            onTouchStart: $e9518cd09d459fdb$var$NOOP
        }));
    }
}
var $e9518cd09d459fdb$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($e9518cd09d459fdb$var$TickscriptEditor);



var $NdCUR = parcelRequire("NdCUR");
// Libaries

var $NdCUR = parcelRequire("NdCUR");


const $0825c3b5a483fa80$var$STREAM = 'stream';
const $0825c3b5a483fa80$var$BATCH = 'batch';
class $0825c3b5a483fa80$var$TickscriptType extends (0, $NdCUR.PureComponent) {
    render() {
        const { onChangeType: onChangeType, type: type } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039).Button, {
            id: "tickscript-type--stream",
            value: $0825c3b5a483fa80$var$STREAM,
            titleText: "Change TICKscript to 'Stream' type",
            active: type === $0825c3b5a483fa80$var$STREAM,
            onClick: onChangeType
        }, "Stream"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039).Button, {
            id: "tickscript-type--batch",
            value: $0825c3b5a483fa80$var$BATCH,
            titleText: "Change TICKscript to 'Batch' type",
            active: type === $0825c3b5a483fa80$var$BATCH,
            onClick: onChangeType
        }, "Batch"));
    }
}
var $0825c3b5a483fa80$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($0825c3b5a483fa80$var$TickscriptType);



var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");




var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");

var $1v7mg = parcelRequire("1v7mg");

var $hBdgJ = parcelRequire("hBdgJ");




const $4e7d5dbf71005afd$var$labelText = ({ localSelectedItems: localSelectedItems, isOpen: isOpen, label: label })=>{
    if (localSelectedItems.length) return localSelectedItems.map((s)=>s.name).join(', ');
    if (label) return label;
    // TODO: be smarter about the text displayed here
    if (isOpen) return '0 Selected';
    return 'None';
};
class $4e7d5dbf71005afd$var$MultiSelectDropdown extends (0, $NdCUR.Component) {
    constructor(props){
        super(props);
        this.state = {
            isOpen: false,
            localSelectedItems: props.selectedItems
        };
    }
    handleClickOutside() {
        this.setState({
            isOpen: false
        });
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!this.props.resetStateOnReceiveProps || !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEqual(this.props.selectedItems, nextProps.selectedItems)) return;
        this.setState({
            localSelectedItems: nextProps.selectedItems
        });
    }
    toggleMenu = (e)=>{
        e.stopPropagation();
        this.setState({
            isOpen: !this.state.isOpen
        });
    };
    onSelect = (item, e)=>{
        e.stopPropagation();
        const { onApply: onApply, isApplyShown: isApplyShown } = this.props;
        const { localSelectedItems: localSelectedItems } = this.state;
        let nextItems;
        if (this.isSelected(item)) nextItems = localSelectedItems.filter((i)=>i.name !== item.name);
        else nextItems = [
            ...localSelectedItems,
            item
        ];
        if (!isApplyShown) onApply(nextItems);
        this.setState({
            localSelectedItems: nextItems
        });
    };
    isSelected(item) {
        return !!this.state.localSelectedItems.find(({ name: name })=>name === item.name);
    }
    handleApply = (e)=>{
        e.stopPropagation();
        this.setState({
            isOpen: false
        });
        this.props.onApply(this.state.localSelectedItems);
    };
    render() {
        const { localSelectedItems: localSelectedItems, isOpen: isOpen } = this.state;
        const { label: label, buttonSize: buttonSize, buttonColor: buttonColor, customClass: customClass, iconName: iconName } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))(`dropdown ${customClass}`, {
                open: isOpen
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            onClick: this.toggleMenu,
            className: `dropdown-toggle btn ${buttonSize} ${buttonColor}`
        }, iconName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: `icon ${iconName}`
        }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "dropdown-selected"
        }, $4e7d5dbf71005afd$var$labelText({
            localSelectedItems: localSelectedItems,
            isOpen: isOpen,
            label: label
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "caret"
        })), this.renderMenu());
    }
    renderMenu() {
        const { items: items, isApplyShown: isApplyShown, rightAligned: rightAligned } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("ul", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('dropdown-menu', {
                'dropdown--right': rightAligned
            })
        }, isApplyShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("li", {
            className: "multi-select--apply"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-xs btn-info",
            onClick: this.handleApply
        }, "Apply")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), {
            autoHide: false,
            autoHeight: true,
            maxHeight: (0, $e10a8602f56394e3$export$bd1588cc2d72fbf)
        }, items.map((listItem, i)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("li", {
                key: i,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('multi-select--item', {
                    checked: this.isSelected(listItem)
                }),
                onClick: (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).wrap(listItem, this.onSelect)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                className: "multi-select--checkbox"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", null, listItem.name));
        })));
    }
}
const { arrayOf: $4e7d5dbf71005afd$var$arrayOf, bool: $4e7d5dbf71005afd$var$bool, func: $4e7d5dbf71005afd$var$func, shape: $4e7d5dbf71005afd$var$shape, string: $4e7d5dbf71005afd$var$string } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$4e7d5dbf71005afd$var$MultiSelectDropdown.propTypes = {
    onApply: $4e7d5dbf71005afd$var$func.isRequired,
    items: $4e7d5dbf71005afd$var$arrayOf($4e7d5dbf71005afd$var$shape({
        name: $4e7d5dbf71005afd$var$string.isRequired
    })).isRequired,
    selectedItems: $4e7d5dbf71005afd$var$arrayOf($4e7d5dbf71005afd$var$shape({
        name: $4e7d5dbf71005afd$var$string.isRequired
    })),
    label: $4e7d5dbf71005afd$var$string,
    buttonSize: $4e7d5dbf71005afd$var$string,
    buttonColor: $4e7d5dbf71005afd$var$string,
    customClass: $4e7d5dbf71005afd$var$string,
    iconName: $4e7d5dbf71005afd$var$string,
    isApplyShown: $4e7d5dbf71005afd$var$bool,
    resetStateOnReceiveProps: $4e7d5dbf71005afd$var$bool
};
$4e7d5dbf71005afd$var$MultiSelectDropdown.defaultProps = {
    buttonSize: 'btn-sm',
    buttonColor: 'btn-default',
    customClass: 'dropdown-160',
    selectedItems: [],
    isApplyShown: true,
    resetStateOnReceiveProps: true
};
var $4e7d5dbf71005afd$export$2e2bcd8739ae039 = (0, $1636633b789d0ee3$export$2e2bcd8739ae039)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($4e7d5dbf71005afd$var$MultiSelectDropdown));



class $8fc585a86514c5e6$var$MultiSelectDBDropdown extends (0, $NdCUR.Component) {
    constructor(props){
        super(props);
        this.state = {
            dbrps: []
        };
    }
    componentDidMount() {
        this._getDbRps();
    }
    render() {
        const { dbrps: dbrps } = this.state;
        const { onApply: onApply, selectedItems: selectedItems, rightAligned: rightAligned } = this.props;
        const label = 'Select databases';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $4e7d5dbf71005afd$export$2e2bcd8739ae039), {
            label: label,
            items: dbrps,
            onApply: onApply,
            isApplyShown: false,
            selectedItems: selectedItems,
            rightAligned: rightAligned
        });
    }
    _getDbRps = async ()=>{
        const { source: { links: { proxy: proxy } } } = this.context;
        const { onErrorThrown: onErrorThrown } = this.props;
        try {
            const { data: data } = await (0, $8ba03c44d4b91783$export$46acc72e11cde242)(proxy);
            const { databases: databases, errors: errors } = (0, $b0c8a009bdea2e59$export$2e2bcd8739ae039)(data);
            if (errors.length > 0) throw errors[0] // only one error can come back from this, but it's returned as an array
            ;
            const response = await (0, $8ba03c44d4b91783$export$e62df8db5c873ebc)(proxy, databases);
            const dbrps = response.data.results.reduce((acc, result, i)=>{
                const { retentionPolicies: retentionPolicies } = (0, $818475225a3c3c78$export$2e2bcd8739ae039)(result);
                const db = databases[i];
                const rps = retentionPolicies.map(({ name: rp })=>({
                        db: db,
                        rp: rp,
                        name: `${db}.${rp}`
                    }));
                return [
                    ...acc,
                    ...rps
                ];
            }, []);
            this.setState({
                dbrps: dbrps
            });
        } catch (error) {
            console.error(error);
            onErrorThrown(error);
        }
    };
}
const { arrayOf: $8fc585a86514c5e6$var$arrayOf, func: $8fc585a86514c5e6$var$func, shape: $8fc585a86514c5e6$var$shape, string: $8fc585a86514c5e6$var$string } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$8fc585a86514c5e6$var$MultiSelectDBDropdown.contextTypes = {
    source: $8fc585a86514c5e6$var$shape({
        links: $8fc585a86514c5e6$var$shape({
            proxy: $8fc585a86514c5e6$var$string.isRequired
        }).isRequired
    }).isRequired
};
$8fc585a86514c5e6$var$MultiSelectDBDropdown.propTypes = {
    onErrorThrown: $8fc585a86514c5e6$var$func,
    onApply: $8fc585a86514c5e6$var$func.isRequired,
    selectedItems: $8fc585a86514c5e6$var$arrayOf($8fc585a86514c5e6$var$shape())
};
var $8fc585a86514c5e6$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($8fc585a86514c5e6$var$MultiSelectDBDropdown);



var $NdCUR = parcelRequire("NdCUR");

class $53b2bd5fd30f6dde$var$TickscriptID extends (0, $NdCUR.Component) {
    constructor(props){
        super(props);
    }
    render() {
        const { onChangeID: onChangeID, id: id } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control input-sm form-malachite",
            autoFocus: true,
            value: id,
            onChange: onChangeID,
            placeholder: "ID your TICKscript",
            spellCheck: false,
            autoComplete: "off"
        });
    }
}
var $53b2bd5fd30f6dde$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($53b2bd5fd30f6dde$var$TickscriptID);


// Libraries

var $NdCUR = parcelRequire("NdCUR");
const $fb6ce0f5011ee452$var$TickscriptNameEditor = (props)=>{
    const [isEditing, setEditing] = (0, $NdCUR.useState)(false);
    const inputRef = (0, $NdCUR.useRef)(null);
    const { name: name } = props;
    if (isEditing) {
        const handleInputBlur = (e)=>{
            const { onRename: onRename } = props;
            const newName = e.target.value;
            if (newName !== name) onRename(newName);
            setEditing(false);
        };
        const handleKeyDown = (e)=>{
            if (e.key === 'Enter') inputRef.current.blur();
            if (e.key === 'Escape') {
                inputRef.current.value = name;
                inputRef.current.blur();
            }
        };
        const handleFocus = (e)=>e.target.select();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "rename-dashboard"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            type: "text",
            className: "rename-dashboard--input form-control input-sm",
            defaultValue: name,
            autoComplete: "off",
            autoFocus: true,
            spellCheck: false,
            onBlur: handleInputBlur,
            onKeyDown: handleKeyDown,
            onFocus: handleFocus,
            placeholder: "Name this TICKscript",
            ref: inputRef
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h1", {
        className: "tickscript-controls--name",
        onClick: ()=>setEditing(true)
    }, name, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        className: "icon pencil"
    }));
};
var $fb6ce0f5011ee452$export$2e2bcd8739ae039 = $fb6ce0f5011ee452$var$TickscriptNameEditor;


class $06cb45cd9f1b5def$var$TickscriptEditorControls extends (0, $NdCUR.Component) {
    render() {
        const { onSelectDbrps: onSelectDbrps, onChangeType: onChangeType, task: task } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "tickscript-controls"
        }, this.tickscriptID, !task.id || task.templateID ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "tickscript-controls--right"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $0825c3b5a483fa80$export$2e2bcd8739ae039), {
            type: task.type,
            onChangeType: onChangeType
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $8fc585a86514c5e6$export$2e2bcd8739ae039), {
            selectedItems: this.addName(task.dbrps),
            onApply: onSelectDbrps,
            rightAligned: true
        })));
    }
    get tickscriptID() {
        const { isNewTickscript: isNewTickscript, onChangeID: onChangeID, onChangeName: onChangeName, task: task } = this.props;
        if (isNewTickscript) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $53b2bd5fd30f6dde$export$2e2bcd8739ae039), {
            onChangeID: onChangeID,
            id: task.id
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fb6ce0f5011ee452$export$2e2bcd8739ae039), {
            name: this.taskID,
            onRename: onChangeName
        });
    }
    get taskID() {
        const { task: { name: name, id: id } } = this.props;
        if (name) return name;
        return id;
    }
    constructor(...args){
        super(...args), this.addName = (list)=>{
            const listWithName = list.map((l)=>({
                    ...l,
                    name: `${l.db}.${l.rp}`
                }));
            return listWithName;
        };
    }
}
var $06cb45cd9f1b5def$export$2e2bcd8739ae039 = $06cb45cd9f1b5def$var$TickscriptEditorControls;



var $NdCUR = parcelRequire("NdCUR");
const $0e061b6557455d6f$var$TickscriptEditorConsole = ({ consoleMessage: consoleMessage, unsavedChanges: unsavedChanges, task: task })=>{
    let consoleOutput = 'TICKscript is valid';
    let consoleClass = 'tickscript-console--valid';
    if (consoleMessage) {
        consoleOutput = consoleMessage;
        consoleClass = 'tickscript-console--error';
    } else if (unsavedChanges) {
        consoleOutput = 'You have unsaved changes, save to validate TICKscript';
        consoleClass = 'tickscript-console--default';
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "tickscript-console"
    }, task.templateID ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", {
        className: consoleClass
    }, "TickScript is READ-ONLY, it was created from template", ' ', task.templateID, ".") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", {
        className: consoleClass
    }, consoleOutput), task.vars && Object.keys(task.vars).length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, "Variables:", ' ', Object.keys(task.vars).map((name)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            key: name
        }, name, ":", task.vars[name].type, "=", String(task.vars[name].value), ' '))) : undefined);
};
var $0e061b6557455d6f$export$2e2bcd8739ae039 = $0e061b6557455d6f$var$TickscriptEditorConsole;



var $NdCUR = parcelRequire("NdCUR");

var $NdCUR = parcelRequire("NdCUR");

var $NdCUR = parcelRequire("NdCUR");
const $c286482cf693220b$var$LogItemSession = ({ logItem: logItem })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--divider"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: `logs-table--level ${logItem.lvl}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--timestamp"
    }, logItem.ts)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--details"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--session"
    }, logItem.msg)));
var $c286482cf693220b$export$2e2bcd8739ae039 = $c286482cf693220b$var$LogItemSession;



var $NdCUR = parcelRequire("NdCUR");
const $82ff34a475367a13$var$LogItemHTTP = ({ logItem: logItem })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--divider"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: `logs-table--level ${logItem.lvl}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--timestamp"
    }, logItem.ts)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--details"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--service"
    }, "HTTP Request"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--http"
    }, logItem.method, " ", logItem.username, "@", logItem.host, " (", logItem.duration, ")")));
var $82ff34a475367a13$export$2e2bcd8739ae039 = $82ff34a475367a13$var$LogItemHTTP;



var $NdCUR = parcelRequire("NdCUR");
const $74322e421f0749cd$var$LogItemHTTPError = ({ logItem: logItem })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--row",
        key: logItem.key
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--divider"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: `logs-table--level ${logItem.lvl}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--timestamp"
    }, logItem.ts)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--details"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--service error"
    }, "HTTP Server"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--columns"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--key-values error"
    }, "ERROR: ", logItem.msg))));
var $74322e421f0749cd$export$2e2bcd8739ae039 = $74322e421f0749cd$var$LogItemHTTPError;



var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");

class $08031fad5e71408d$var$LogItemKapacitorPoint extends (0, $NdCUR.PureComponent) {
    render() {
        const { logItem: logItem } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "logs-table--row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "logs-table--divider"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: `logs-table--level ${logItem.lvl}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "logs-table--timestamp"
        }, logItem.ts)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "logs-table--details"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "logs-table--service"
        }, "Kapacitor Point"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "logs-table--columns"
        }, this.renderKeysAndValues(logItem.tag, 'Tags'), this.renderKeysAndValues(logItem.field, 'Fields'))));
    }
    constructor(...args){
        super(...args), this.renderKeysAndValues = (object, name)=>{
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEmpty(object)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
                className: "logs-table--empty-cell"
            }, "--");
            const sortedObjKeys = Object.keys(object).sort();
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                className: "logs-table--column"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h1", null, `${sortedObjKeys.length} ${name}`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                className: "logs-table--scrollbox"
            }, sortedObjKeys.map((objKey)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                    key: objKey,
                    className: "logs-table--key-value"
                }, objKey, ": ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", null, String(object[objKey]))))));
        };
    }
}
var $08031fad5e71408d$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($08031fad5e71408d$var$LogItemKapacitorPoint);



var $NdCUR = parcelRequire("NdCUR");
const $4f3c96686ba2631c$var$LogItemKapacitorError = ({ logItem: logItem })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--divider"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: `logs-table--level ${logItem.lvl}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--timestamp"
    }, logItem.ts)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--details"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--service error"
    }, "Kapacitor"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--columns"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--key-values error"
    }, "ERROR: ", logItem.msg))));
var $4f3c96686ba2631c$export$2e2bcd8739ae039 = $4f3c96686ba2631c$var$LogItemKapacitorError;



var $NdCUR = parcelRequire("NdCUR");
const $33af7ae78ef1e78f$var$LogItemKapacitorDebug = ({ logItem: logItem })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--divider"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: `logs-table--level ${logItem.lvl}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--timestamp"
    }, logItem.ts)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--details"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--service debug"
    }, "Kapacitor"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--columns"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--key-values debug"
    }, "DEBUG: ", logItem.msg))));
var $33af7ae78ef1e78f$export$2e2bcd8739ae039 = $33af7ae78ef1e78f$var$LogItemKapacitorDebug;



var $NdCUR = parcelRequire("NdCUR");
const $6c3f1fed5a56d6c3$var$LogItemInfluxDBDebug = ({ logItem: logItem })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--divider"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: `logs-table--level ${logItem.lvl}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--timestamp"
    }, logItem.ts)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--details"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--service debug"
    }, "InfluxDB"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--columns"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--key-values debug"
    }, "DEBUG: ", logItem.msg, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("br", null), "Cluster: ", logItem.cluster))));
var $6c3f1fed5a56d6c3$export$2e2bcd8739ae039 = $6c3f1fed5a56d6c3$var$LogItemInfluxDBDebug;



var $NdCUR = parcelRequire("NdCUR");
const $084235a8b8e66738$var$LogItemSession = ({ logItem: logItem })=>{
    let taskRun = '';
    if (logItem.cluster) taskRun = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, ' / ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("i", {
        title: `friendly task run name, runID: ${logItem.tags}`
    }, logItem.cluster || logItem.tags));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--divider"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: `logs-table--level ${logItem.lvl}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--timestamp"
    }, logItem.ts, " ", taskRun)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--details"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--session"
    }, logItem.msg)));
};
var $084235a8b8e66738$export$2e2bcd8739ae039 = $084235a8b8e66738$var$LogItemSession;


const $c355ae0c09c80324$var$LogsTableRow = ({ logItem: logItem })=>{
    if (logItem.service === 'sessions') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c286482cf693220b$export$2e2bcd8739ae039), {
        logItem: logItem
    });
    if (logItem.service === 'http' && logItem.msg === 'http request') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $82ff34a475367a13$export$2e2bcd8739ae039), {
        logItem: logItem
    });
    if (logItem.service === 'kapacitor' && logItem.msg === 'point') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $08031fad5e71408d$export$2e2bcd8739ae039), {
        logItem: logItem
    });
    if (logItem.service === 'kapacitor' && logItem.msg === 'batch point') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $08031fad5e71408d$export$2e2bcd8739ae039), {
        logItem: logItem
    });
    if (logItem.service === 'httpd_server_errors' && logItem.lvl === 'error') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $74322e421f0749cd$export$2e2bcd8739ae039), {
        logItem: logItem
    });
    if (logItem.service === 'kapacitor' && logItem.lvl === 'error') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $4f3c96686ba2631c$export$2e2bcd8739ae039), {
        logItem: logItem
    });
    if (logItem.service === 'kapacitor' && logItem.lvl === 'debug') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $33af7ae78ef1e78f$export$2e2bcd8739ae039), {
        logItem: logItem
    });
    if (logItem.service === 'influxdb' && logItem.lvl === 'debug') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $6c3f1fed5a56d6c3$export$2e2bcd8739ae039), {
        logItem: logItem
    });
    if (logItem.service === 'flux_task') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $084235a8b8e66738$export$2e2bcd8739ae039), {
        logItem: logItem
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--divider"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: `logs-table--level ${logItem.lvl}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--timestamp"
    }, logItem.ts)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--details"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--service"
    }, logItem.service || '--'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--columns"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--key-values"
    }, logItem.msg || '--'))));
};
var $c355ae0c09c80324$export$2e2bcd8739ae039 = $c355ae0c09c80324$var$LogsTableRow;



const $3b75eab68a2e1ff1$var$numLogsToRender = 200;
const $3b75eab68a2e1ff1$var$LogsTable = ({ logs: logs })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--header"
    }, `${$3b75eab68a2e1ff1$var$numLogsToRender} Most Recent Logs`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), {
        autoHide: false,
        className: "logs-table--container fancy-scroll--kapacitor"
    }, logs.slice(0, $3b75eab68a2e1ff1$var$numLogsToRender).map((log)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c355ae0c09c80324$export$2e2bcd8739ae039), {
            key: log.key,
            logItem: log
        }))));
var $3b75eab68a2e1ff1$export$2e2bcd8739ae039 = $3b75eab68a2e1ff1$var$LogsTable;




class $6b07d8c3eded7754$var$Tickscript extends (0, $NdCUR.PureComponent) {
    render() {
        const { onSave: onSave, onExit: onExit, task: task, consoleMessage: consoleMessage, onSelectDbrps: onSelectDbrps, onChangeScript: onChangeScript, onChangeType: onChangeType, onChangeID: onChangeID, onChangeName: onChangeName, unsavedChanges: unsavedChanges, isNewTickscript: isNewTickscript, areLogsVisible: areLogsVisible, areLogsEnabled: areLogsEnabled, onToggleLogsVisibility: onToggleLogsVisibility, onOpenBuilderUI: onOpenBuilderUI } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039), {
            className: "tickscript-editor-page"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $85066abc7f07bcc7$export$2e2bcd8739ae039), {
            task: task,
            onSave: onSave,
            onExit: onExit,
            onOpenBuilderUI: onOpenBuilderUI,
            unsavedChanges: unsavedChanges,
            areLogsVisible: areLogsVisible,
            areLogsEnabled: areLogsEnabled,
            onToggleLogsVisibility: onToggleLogsVisibility,
            isNewTickscript: isNewTickscript
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "page-contents--split"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "tickscript",
            style: this.style
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $06cb45cd9f1b5def$export$2e2bcd8739ae039), {
            isNewTickscript: isNewTickscript,
            onSelectDbrps: onSelectDbrps,
            onChangeType: onChangeType,
            onChangeID: onChangeID,
            onChangeName: onChangeName,
            task: task
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $e9518cd09d459fdb$export$2e2bcd8739ae039), {
            script: task.tickscript,
            readOnly: !!task.templateID,
            onChangeScript: onChangeScript
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $0e061b6557455d6f$export$2e2bcd8739ae039), {
            consoleMessage: consoleMessage,
            unsavedChanges: unsavedChanges,
            task: task
        })), this.logsTable));
    }
    get style() {
        const { areLogsVisible: areLogsVisible } = this.props;
        if (areLogsVisible) return {
            maxWidth: '50%'
        };
    }
    get logsTable() {
        const { areLogsVisible: areLogsVisible, logs: logs } = this.props;
        if (areLogsVisible) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $3b75eab68a2e1ff1$export$2e2bcd8739ae039), {
            logs: logs
        });
    }
}
var $6b07d8c3eded7754$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($6b07d8c3eded7754$var$Tickscript);









const $6c10491afedef5fd$var$reNameDeclaration = new RegExp(// eslint-disable-next-line no-control-regex
"(?:^|\n)var[ \t]+name[ \t]*=[ \t]*'[^\n]*'[ \r\t]*\n");
function $6c10491afedef5fd$var$escapeName(s) {
    return s.replace(/['\\]/gi, (str)=>'\\' + str);
}
function $6c10491afedef5fd$export$2e2bcd8739ae039(tickscript, newName) {
    const match = tickscript.match($6c10491afedef5fd$var$reNameDeclaration);
    if (!match) return `var name = '${$6c10491afedef5fd$var$escapeName(newName)}'\n${tickscript}`;
    let retVal = match.index ? `${tickscript.substring(0, match.index)}\n` : '';
    retVal += `var name = '${$6c10491afedef5fd$var$escapeName(newName)}'\n${tickscript.substring(match.index + match[0].length)}`;
    return retVal;
}


class $b1697bd15f20ec31$export$11550477602b0544 extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleSave = async ()=>{
            const { source: { id: sourceID }, router: router } = this.props;
            const { kapacitor: kapacitor } = this.state;
            try {
                const response = await this.persist();
                if (response.code === 422) {
                    this.setState({
                        unsavedChanges: true,
                        consoleMessage: response.message
                    });
                    return;
                }
                if (response.code) this.setState({
                    unsavedChanges: true,
                    consoleMessage: response.message
                });
                else this.setState({
                    unsavedChanges: false,
                    consoleMessage: ''
                });
                router.push(// prettier-ignore
                `/sources/${sourceID}/kapacitors/${kapacitor.id}/tickscripts/${response.id}${router.location.search}`);
            } catch (error) {
                console.error(error);
                throw error;
            }
        }, this.handleOpenBuilderUI = ()=>{
            const { params: { ruleID: ruleID }, source: { id: sourceID }, router: router } = this.props;
            const { kapacitor: kapacitor } = this.state;
            router.push(// prettier-ignore
            `/sources/${sourceID}/kapacitors/${kapacitor.id}/alert-rules/${ruleID}${router.location.search}`);
        }, this.handleExit = ()=>{
            const { source: { id: sourceID }, router: router } = this.props;
            return router.push(`/sources/${sourceID}/tickscripts${router.location.search}`);
        }, this.handleChangeScript = (tickscript)=>{
            this.setState({
                task: {
                    ...this.state.task,
                    tickscript: tickscript
                },
                unsavedChanges: true
            });
        }, this.handleSelectDbrps = (dbrps)=>{
            this.setState({
                task: {
                    ...this.state.task,
                    dbrps: dbrps
                },
                unsavedChanges: true
            });
        }, this.handleChangeType = (type)=>{
            this.setState({
                task: {
                    ...this.state.task,
                    type: type
                },
                unsavedChanges: true
            });
        }, this.handleChangeID = (e)=>{
            this.setState({
                task: {
                    ...this.state.task,
                    id: e.target.value
                },
                unsavedChanges: true
            });
        }, this.handleChangeName = (name)=>{
            this.setState((state)=>({
                    task: {
                        ...state.task,
                        tickscript: (0, $6c10491afedef5fd$export$2e2bcd8739ae039)(state.task.tickscript, name),
                        name: name
                    },
                    unsavedChanges: true
                }));
        }, this.handleToggleLogsVisibility = (areLogsVisible)=>{
            this.setState({
                areLogsVisible: areLogsVisible
            });
        }, this.fetchChunkedLogs = async (kapacitor, ruleID)=>{
            const { notify: notify } = this.props;
            try {
                const version = await (0, $c836572692edfbec$export$ff4fb5ac77366d84)(kapacitor);
                if (version && parseInt(version.split('.')[1], 10) < 4) {
                    this.setState({
                        areLogsEnabled: false
                    });
                    notify((0, $ec1f42de4faacc37$export$832db2e7f377c899)());
                    return;
                }
                if (this.state.logs.length === 0) this.setState({
                    areLogsEnabled: true,
                    logs: [
                        {
                            id: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
                            key: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)(),
                            lvl: 'info',
                            msg: 'created log session',
                            service: 'sessions',
                            tags: 'nil',
                            ts: new Date().toISOString()
                        }
                    ]
                });
                const abortController = new AbortController();
                this.abortController = abortController;
                const response = await (0, $c836572692edfbec$export$7827719c6ae7f112)(kapacitor, ruleID, abortController.signal);
                if (!this.state.areLogsEnabled) {
                    // applies when component destroyment happens sooner than response
                    abortController.abort();
                    return;
                }
                const reader = await response.body.getReader();
                const decoder = new TextDecoder();
                let result;
                while(this.state.areLogsEnabled === true && !(result && result.done)){
                    result = await reader.read();
                    const chunk = decoder.decode(result.value || new Uint8Array(), {
                        stream: !result.done
                    });
                    const json = chunk.split('\n');
                    let logs = [];
                    let failStr = this.state.failStr;
                    try {
                        for (let objStr of json){
                            objStr = failStr + objStr;
                            failStr = objStr;
                            const jsonStr = `[${objStr.split('}{').join('},{')}]`;
                            logs = [
                                ...logs,
                                ...JSON.parse(jsonStr).map((log)=>({
                                        ...log,
                                        key: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)()
                                    }))
                            ];
                            failStr = '';
                        }
                        this.setState({
                            logs: [
                                ...logs,
                                ...this.state.logs
                            ],
                            failStr: failStr
                        });
                    } catch (err) {
                        this.setState({
                            logs: [
                                ...logs,
                                ...this.state.logs
                            ],
                            failStr: failStr
                        });
                    }
                }
            } catch (error) {
                // do not log error if it was programatically aborted
                if (!error.name || error.name !== 'AbortError') {
                    console.error(error);
                    notify((0, $ec1f42de4faacc37$export$78d3dfe36c7b2e43)());
                    throw error;
                }
            }
        };
        this.state = {
            kapacitor: {
                id: '',
                url: '',
                name: '',
                active: false,
                insecureSkipVerify: false,
                links: {
                    self: ''
                }
            },
            task: {
                id: '',
                name: '',
                status: 'enabled',
                tickscript: '',
                dbrps: [],
                type: 'stream'
            },
            consoleMessage: '',
            isEditingID: true,
            logs: [],
            failStr: '',
            areLogsVisible: false,
            areLogsEnabled: false,
            unsavedChanges: false
        };
    }
    async componentDidMount() {
        const { source: source, errorActions: errorActions, kapacitorActions: kapacitorActions, params: { ruleID: ruleID, kid: kid } } = this.props;
        let kapacitor;
        if (!kid) kapacitor = await (0, $3bff70d0456af5c0$export$82a2e3b7e5164c8a)(source);
        else kapacitor = await (0, $3bff70d0456af5c0$export$c751af5d7f198354)(source, kid);
        if (!kapacitor) errorActions.errorThrown((0, $ec1f42de4faacc37$export$e110245f059bd84a)());
        if (this.isEditing) {
            await kapacitorActions.getRule(kapacitor, ruleID);
            const { id: id, name: name, tickscript: tickscript, status: status, dbrps: dbrps, type: type, 'template-id': templateID, vars: vars, query: query } = this.props.rules.find((r)=>r.id === ruleID);
            this.setState({
                task: {
                    tickscript: tickscript,
                    dbrps: dbrps,
                    type: type,
                    status: status,
                    name: name,
                    id: id,
                    templateID: templateID,
                    vars: vars,
                    query: query
                }
            });
        }
        this.fetchChunkedLogs(kapacitor, ruleID);
        this.setState({
            kapacitor: kapacitor
        });
    }
    componentWillUnmount() {
        this.setState({
            areLogsEnabled: false
        });
        if (this.abortController) this.abortController.abort();
    }
    render() {
        const { task: task, logs: logs, areLogsVisible: areLogsVisible, areLogsEnabled: areLogsEnabled, unsavedChanges: unsavedChanges, consoleMessage: consoleMessage } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $6b07d8c3eded7754$export$2e2bcd8739ae039), {
            task: task,
            logs: logs,
            onSave: this.handleSave,
            onExit: this.handleExit,
            onOpenBuilderUI: this.handleOpenBuilderUI,
            unsavedChanges: unsavedChanges,
            areLogsVisible: areLogsVisible,
            areLogsEnabled: areLogsEnabled,
            consoleMessage: consoleMessage,
            onChangeID: this.handleChangeID,
            onChangeName: this.handleChangeName,
            onChangeType: this.handleChangeType,
            isNewTickscript: !this.isEditing,
            onSelectDbrps: this.handleSelectDbrps,
            onChangeScript: this.handleChangeScript,
            onToggleLogsVisibility: this.handleToggleLogsVisibility
        });
    }
    async updateTask() {
        const { kapacitor: kapacitor, task: task } = this.state;
        const { source: { id: sourceID }, router: router, kapacitorActions: { updateTask: updateTask }, params: { ruleID: ruleID } } = this.props;
        return await updateTask(kapacitor, task, ruleID, router, sourceID);
    }
    async createTask() {
        const { kapacitor: kapacitor, task: task } = this.state;
        const { source: { id: sourceID }, router: router, kapacitorActions: { createTask: createTask } } = this.props;
        return await createTask(kapacitor, task, router, sourceID);
    }
    async persist() {
        if (this.isEditing) return await this.updateTask();
        return await this.createTask();
    }
    get isEditing() {
        const { params: params } = this.props;
        return params.ruleID && params.ruleID !== 'new';
    }
}
const $b1697bd15f20ec31$var$mapStateToProps = (state)=>{
    return {
        rules: Object.values(state.rules)
    };
};
const $b1697bd15f20ec31$var$mapDispatchToProps = (dispatch)=>({
        kapacitorActions: (0, $1f80bbeadc1a0021$export$2e2bcd8739ae039)($413b7ff06f318700$exports, dispatch),
        errorActions: (0, $1f80bbeadc1a0021$export$2e2bcd8739ae039)($eb59f3357c899aaf$exports, dispatch),
        notify: (0, $1f80bbeadc1a0021$export$2e2bcd8739ae039)((0, $205d139de2918454$export$5e14cdade93d6f7b), dispatch)
    });
var $b1697bd15f20ec31$export$2e2bcd8739ae039 = (0, $c8cd79e362cba2a4$export$a520fb22fccea800)((0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($b1697bd15f20ec31$var$mapStateToProps, $b1697bd15f20ec31$var$mapDispatchToProps)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($b1697bd15f20ec31$export$11550477602b0544)));



var $NdCUR = parcelRequire("NdCUR");

// Libraries

var $NdCUR = parcelRequire("NdCUR");











class $442c44a73c838577$var$KapacitorScopedPage extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleSetActiveKapacitor = async (kapacitorID)=>{
            const { setActiveKapacitor: setActiveKapacitor } = this.props;
            const { kapacitors: kapacitors } = this.state;
            const toKapacitor = kapacitors.find((k)=>k.id === kapacitorID);
            setActiveKapacitor(toKapacitor);
            (0, $3bff70d0456af5c0$export$41af5c3435cc7908)(toKapacitor).catch(()=>{
                this.props.notify((0, $ec1f42de4faacc37$export$3d61248777676e06)());
            });
        }, this.handleScrollbarScroll = (e)=>{
            e.stopPropagation();
            e.preventDefault();
            const target = e.currentTarget;
            this.setState({
                scrollTop: target.scrollTop
            });
        }, this.scrollToTop = (scrollTop)=>{
            this.setState({
                scrollTop: scrollTop
            });
        };
        this.state = {
            loading: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).NotStarted,
            scrollTop: 0
        };
    }
    componentDidMount() {
        const { source: source } = this.props;
        this.setState({
            loading: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading
        });
        (0, $3bff70d0456af5c0$export$c006b25b4b2674db)(source).then((kapacitors)=>{
            const kapacitor = kapacitors && kapacitors.length ? kapacitors.find((x)=>x.active) || kapacitors[0] : undefined;
            if (kapacitor) (0, $3bff70d0456af5c0$export$41af5c3435cc7908)(kapacitor).catch(()=>{
                this.props.notify((0, $ec1f42de4faacc37$export$3d61248777676e06)());
            });
            this.setState({
                kapacitors: kapacitors,
                kapacitor: kapacitor,
                loading: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done
            });
        });
    }
    render() {
        const { tooltip: tooltip, title: title, source: source, children: children } = this.props;
        const { loading: loading, kapacitor: kapacitor, kapacitors: kapacitors, scrollTop: scrollTop } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039), {
            className: kapacitor ? '' : 'empty-tasks-page'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header.Left, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Title, {
            title: kapacitor ? `${title} on` : title
        }), kapacitor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $f040dbec7e8f99c8$export$2e2bcd8739ae039), {
            customClass: "kapacitor-switcher",
            onChange: this.handleSetActiveKapacitor,
            widthPixels: 330,
            selectedID: kapacitor.id
        }, kapacitors.map((k)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $f040dbec7e8f99c8$export$2e2bcd8739ae039).Item, {
                key: k.id,
                id: k.id,
                value: k.id
            }, `${k.name} @ ${k.url}`))) : undefined), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header.Right, {
            showSourceIndicator: true
        }, tooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1ca55233f3c1ef57$export$2e2bcd8739ae039), {
            tipID: "manage-tasks--tooltip",
            tipContent: tooltip
        }) : undefined)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Contents, {
            setScrollTop: this.handleScrollbarScroll,
            scrollTop: scrollTop
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $4ee59a55fab29874$export$2e2bcd8739ae039), {
            loading: loading
        }, kapacitor ? children(kapacitor, source, this.scrollToTop) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $16af25b437b7972f$export$2e2bcd8739ae039), {
            source: source
        }))));
    }
}
const $442c44a73c838577$var$mdtp = {
    notify: (0, $205d139de2918454$export$5e14cdade93d6f7b),
    setActiveKapacitor: (0, $b73fb830e0a94a1d$export$7bafe015e336e80b)
};
var $442c44a73c838577$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)(null, $442c44a73c838577$var$mdtp)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($442c44a73c838577$var$KapacitorScopedPage));




function $0ba8b809bdda5b53$export$2e2bcd8739ae039(e) {
    if (!e) return e;
    if (e.message) return e.message;
    if (e.statusText) return e.statusText;
    return e;
}






var $NdCUR = parcelRequire("NdCUR");
const $9f13d970a740e49f$var$DEFAULT_DELAY = 500;
function $9f13d970a740e49f$var$useDebounce(value, delay = $9f13d970a740e49f$var$DEFAULT_DELAY) {
    const [debounced, setDebounced] = (0, $NdCUR.useState)(value);
    const first = (0, $NdCUR.useRef)(true);
    (0, $NdCUR.useEffect)(()=>{
        if (first.current) {
            setDebounced(value);
            first.current = false;
            return;
        }
        const handler = setTimeout(()=>{
            setDebounced(value);
        }, delay);
        return ()=>clearTimeout(handler);
    }, [
        value,
        delay
    ]);
    return debounced;
}
var $9f13d970a740e49f$export$2e2bcd8739ae039 = $9f13d970a740e49f$var$useDebounce;





var $NdCUR = parcelRequire("NdCUR");


var $hBdgJ = parcelRequire("hBdgJ");


const { colName: $9e4824894266fe27$var$colName, colType: $9e4824894266fe27$var$colType, colEnabled: $9e4824894266fe27$var$colEnabled, colActions: $9e4824894266fe27$var$colActions } = (0, $063b710ad7fb02e4$export$cddaf6cea22db06c);
const $9e4824894266fe27$var$TasksTable = ({ tasks: tasks, kapacitorLink: kapacitorLink, onDelete: onDelete, onChangeRuleStatus: onChangeRuleStatus, onViewRule: onViewRule, children: children, sorted: sorted })=>{
    const tableData = (0, $NdCUR.useMemo)(()=>sorted ? tasks : (0, $hBdgJ.sortBy)(tasks, (t)=>t.name.toLowerCase()), [
        tasks,
        sorted
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("table", {
        className: "table v-center table-highlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
        style: {
            minWidth: $9e4824894266fe27$var$colName
        }
    }, "Name"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
        style: {
            width: $9e4824894266fe27$var$colType
        }
    }, "Type"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
        style: {
            width: $9e4824894266fe27$var$colEnabled
        },
        className: "text-center"
    }, "Task Enabled"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
        style: {
            width: $9e4824894266fe27$var$colActions
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tbody", null, tableData.map((task)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($9e4824894266fe27$export$44f59c2c5b5f114c, {
            key: task.id,
            task: task,
            editLink: `${kapacitorLink}/tickscripts/${task.id}`,
            onViewRule: onViewRule,
            onDelete: onDelete,
            onChangeRuleStatus: onChangeRuleStatus
        });
    }), children ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
        colSpan: 4
    }, children)) : undefined));
};
class $9e4824894266fe27$export$44f59c2c5b5f114c extends (0, $NdCUR.PureComponent) {
    render() {
        const { task: task, editLink: editLink } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tr", {
            key: task.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            style: {
                minWidth: $9e4824894266fe27$var$colName
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ba1cc4424c00aefe$export$2e2bcd8739ae039), {
            style: {
                color: task['template-id'] ? 'gray' : undefined
            },
            className: "link-success",
            to: editLink,
            "data-task-id": task.id,
            onClick: this.handleViewRule
        }, task.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            style: {
                width: $9e4824894266fe27$var$colType,
                textTransform: 'capitalize'
            }
        }, task.type), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            style: {
                width: $9e4824894266fe27$var$colEnabled
            },
            className: "text-center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "dark-checkbox"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            id: `kapacitor-task-row-task-enabled ${task.id}`,
            className: "form-control-static",
            type: "checkbox",
            checked: task.status === 'enabled',
            onChange: this.handleClickRuleStatusEnabled
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: `kapacitor-task-row-task-enabled ${task.id}`
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            style: {
                width: $9e4824894266fe27$var$colActions
            },
            className: "text-right"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $8008717819fc7a5f$export$2e2bcd8739ae039), {
            text: "Delete",
            type: "btn-danger",
            size: "btn-xs",
            customClass: "table--show-on-row-hover",
            confirmAction: this.handleDelete
        })));
    }
    constructor(...args){
        super(...args), this.handleDelete = ()=>{
            const { onDelete: onDelete, task: task } = this.props;
            onDelete(task);
        }, this.handleClickRuleStatusEnabled = ()=>{
            const { onChangeRuleStatus: onChangeRuleStatus, task: task } = this.props;
            onChangeRuleStatus(task);
        }, this.handleViewRule = (e)=>{
            const { onViewRule: onViewRule } = this.props;
            if (onViewRule) {
                e.preventDefault();
                // casting to unknown is a workaround to wrong global typings
                onViewRule(e.target.attributes.getNamedItem('data-task-id').value);
            }
        };
    }
}
var $9e4824894266fe27$export$2e2bcd8739ae039 = $9e4824894266fe27$var$TasksTable;




var $hBdgJ = parcelRequire("hBdgJ");

// max size of a limited fetch
const $1eda08f448cda2ea$var$LIMITED_FETCH_SIZE = 100;
const $1eda08f448cda2ea$var$PAGE_SIZE = $1eda08f448cda2ea$var$LIMITED_FETCH_SIZE;
const $1eda08f448cda2ea$var$Contents = ({ kapacitor: kapacitor, source: source, filter: filterInit = '', router: router, setScrollTop: setScrollTop })=>{
    const { width: width, ref: ref } = (0, $8d02d0065a7826a6$export$453c3d1cba18d800)();
    const [loading, setLoading] = (0, $NdCUR.useState)(true);
    const [reloadRequired, setReloadRequired] = (0, $NdCUR.useState)(0);
    const [error, setError] = (0, $NdCUR.useState)(undefined);
    const [allList, setAllList] = (0, $NdCUR.useState)([]);
    const dispatch = (0, $cc214f6ed98ca6a9$export$8ad76b76a4c905f8)();
    const [nameFilter, setNameFilter] = (0, $NdCUR.useState)(filterInit);
    const filter = (0, $9f13d970a740e49f$export$2e2bcd8739ae039)(nameFilter);
    const list = (0, $NdCUR.useMemo)(()=>{
        if (allList && allList.length && filter) return allList.filter((x)=>x.name.includes(filter));
        return allList;
    }, [
        allList,
        filter
    ]);
    // optimization: limit fetch if no filter is specified
    const loadAllData = (0, $NdCUR.useRef)(false);
    const limitedFetch = (0, $NdCUR.useMemo)(()=>{
        if (loadAllData.current) return false;
        if (filter) {
            loadAllData.current = true;
            return false;
        }
        return true;
    }, [
        filter,
        reloadRequired
    ]);
    const [page, setPage] = (0, $NdCUR.useState)(0);
    const listPage = (0, $NdCUR.useMemo)(()=>{
        if (list.length <= $1eda08f448cda2ea$var$PAGE_SIZE) return list;
        const start = Math.max(page * $1eda08f448cda2ea$var$PAGE_SIZE, 0);
        return list.slice(start, Math.min(start + $1eda08f448cda2ea$var$PAGE_SIZE, list.length));
    }, [
        page,
        list
    ]);
    (0, $NdCUR.useEffect)(()=>{
        setLoading(true);
        const ac = new AbortController();
        const fetchData = async ()=>{
            const params = {
                parse: '0',
                ...limitedFetch ? {
                    limit: String($1eda08f448cda2ea$var$LIMITED_FETCH_SIZE)
                } : undefined
            };
            try {
                const { data: { rules: rules } } = await (0, $c836572692edfbec$export$f65e0b130162f295)(kapacitor, {
                    signal: ac.signal,
                    params: params
                });
                const sorted = (0, $hBdgJ.sortBy)(rules, (t)=>t.name.toLowerCase());
                setAllList(sorted);
            } catch (e) {
                if (!(0, $d96f38380b9b4c62$export$2b3d06107d1323d4)(e)) {
                    console.error(e);
                    setError(new Error(e?.data?.message ? e.data.message : `Cannot load alert rules: ${(0, $0ba8b809bdda5b53$export$2e2bcd8739ae039)(e)}`));
                }
            } finally{
                setLoading(false);
            }
        };
        fetchData();
        return ()=>ac.abort();
    }, [
        kapacitor,
        reloadRequired,
        limitedFetch
    ]);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel panel-solid"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel-body"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", {
        className: "unexpected_error"
    }, error.toString())));
    const kapacitorLink = `/sources/${source.id}/kapacitors/${kapacitor.id}`;
    // memoize table handlers in order to avoid re-rendering of table rows
    const onDelete = (0, $NdCUR.useCallback)((rule)=>{
        (0, $c836572692edfbec$export$988cba38e738f27d)(rule).then(()=>{
            setAllList(allList.filter((x)=>x.id !== rule.id));
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$b9fb5ac3b1648cf)(rule.name)));
        }).catch(()=>{
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$a023f39c3f194683)(rule.name)));
        });
    }, [
        allList,
        dispatch
    ]);
    const onChangeRuleStatus = (0, $NdCUR.useCallback)((rule)=>{
        const status = rule.status === 'enabled' ? 'disabled' : 'enabled';
        (0, $c836572692edfbec$export$fd0bd303c88e021a)(rule, status).then(()=>{
            setAllList(allList.map((x)=>x.id === rule.id ? {
                    ...rule,
                    status: status
                } : x));
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$41af055b5b12f786)(rule.name, status)));
        }).catch(()=>{
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$163d6d23beef07ab)(rule.name, status)));
            return false;
        });
    }, [
        allList,
        dispatch
    ]);
    const filterRef = (0, $NdCUR.useRef)();
    const onViewRule = (0, $NdCUR.useCallback)((id)=>{
        const params = new URLSearchParams({
            l: 't',
            filter: filterRef.current.value
        });
        router.push(`${kapacitorLink}/tickscripts/${id}?${params}`);
    }, [
        dispatch,
        kapacitorLink
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel-heading",
        style: {
            gap: '5px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "search-widget",
        style: {
            flexGrow: 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
        ref: filterRef,
        type: "text",
        className: "form-control input-sm",
        placeholder: "Filter by name",
        value: nameFilter,
        disabled: loading,
        onChange: (e)=>{
            setNameFilter(e.target.value);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        className: "icon search"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
        titleText: "Reload Flux Tasks",
        shape: (0, $918c9f03a35fe03f$export$ce765fb8bb08a599).Square,
        icon: (0, $918c9f03a35fe03f$export$62c9c0cf752cde38).Refresh,
        onClick: ()=>setReloadRequired(reloadRequired + 1)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ba1cc4424c00aefe$export$2e2bcd8739ae039), {
        to: `${kapacitorLink}/tickscripts/new?l=t&filter=${encodeURIComponent(filter)}`,
        className: "btn btn-sm btn-success",
        style: {
            marginLeft: '4px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        className: "icon plus"
    }), " Write TICKscript")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel-body",
        ref: ref
    }, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $810ad5a94daa03b8$export$2e2bcd8739ae039), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, limitedFetch && list.length === $1eda08f448cda2ea$var$LIMITED_FETCH_SIZE ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        style: {
            display: 'inline-flex',
            justifyContent: 'center',
            color: '#FFB94A',
            width: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", null, `${$1eda08f448cda2ea$var$LIMITED_FETCH_SIZE} kapacitor tasks are shown. Input a filter or `, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("a", {
        href: "#",
        onClick: ()=>{
            loadAllData.current = true;
            setReloadRequired(reloadRequired + 1);
        }
    }, "Load All"), ' to show the first 100 tasks sorted by name.')) : undefined, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $9e4824894266fe27$export$2e2bcd8739ae039), {
        kapacitorLink: kapacitorLink,
        tasks: listPage,
        sorted: true,
        onViewRule: onViewRule,
        onDelete: onDelete,
        onChangeRuleStatus: onChangeRuleStatus
    }, listPage !== list ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ab2e782baa03cd84$export$2e2bcd8739ae039), {
        page: page,
        total: list.length,
        pageSize: $1eda08f448cda2ea$var$PAGE_SIZE,
        onChange: (p)=>{
            setScrollTop(0);
            setPage(p);
        },
        width: width
    }) : undefined))));
};
const $1eda08f448cda2ea$var$TickscriptsPage = ({ source: src, router: router })=>{
    const filter = router.location.query?.filter;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $442c44a73c838577$export$2e2bcd8739ae039), {
        source: src,
        title: "Manage TICKscripts"
    }, (kapacitor, source, setScrollTop)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($1eda08f448cda2ea$var$Contents, {
            kapacitor: kapacitor,
            source: source,
            filter: filter,
            router: router,
            setScrollTop: setScrollTop
        }));
};
var $1eda08f448cda2ea$export$2e2bcd8739ae039 = (0, $c8cd79e362cba2a4$export$a520fb22fccea800)($1eda08f448cda2ea$var$TickscriptsPage);



var $NdCUR = parcelRequire("NdCUR");














const $43e4a68a43bdcbc0$var$noop = ()=>undefined;
const $43e4a68a43bdcbc0$var$numLogsToRender = 200;
const $43e4a68a43bdcbc0$var$LogsTable = ({ task: task, kapacitor: kapacitor })=>{
    const [loading, setLoading] = (0, $NdCUR.useState)(true);
    const [logs, setLogs] = (0, $NdCUR.useState)(undefined);
    (0, $NdCUR.useEffect)(()=>{
        setLoading(true);
        const fetchData = async ()=>{
            try {
                let lastLogs = await (0, $1c87b80fc86b574d$export$bc33a3e3875d93ec)(kapacitor, task.id, $43e4a68a43bdcbc0$var$numLogsToRender);
                if (!lastLogs || !lastLogs.length) lastLogs = [
                    {
                        id: 'nologs',
                        key: 'nologs',
                        service: 'flux_task',
                        lvl: 'info',
                        ts: new Date().toISOString(),
                        msg: 'No Logs available',
                        tags: '',
                        cluster: ''
                    }
                ];
                setLogs(lastLogs);
            } catch (e) {
                console.error(e);
                setLogs([
                    {
                        id: 'nologs',
                        key: 'nologs',
                        service: 'flux_task',
                        lvl: 'error',
                        ts: new Date().toISOString(),
                        msg: e?.data?.message ? e.data.message : `Cannot load flux task logs: ${(0, $0ba8b809bdda5b53$export$2e2bcd8739ae039)(e)}`,
                        tags: ''
                    }
                ]);
            } finally{
                setLoading(false);
            }
        };
        fetchData();
    }, [
        task,
        kapacitor
    ]);
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel panel-solid"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel-body"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $810ad5a94daa03b8$export$2e2bcd8739ae039), null)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "logs-table--header"
    }, `${$43e4a68a43bdcbc0$var$numLogsToRender} Most Recent Logs`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), {
        autoHide: false,
        className: "logs-table--container fancy-scroll--kapacitor"
    }, logs.map((log)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c355ae0c09c80324$export$2e2bcd8739ae039), {
            key: log.key,
            logItem: log
        }))));
};
const $43e4a68a43bdcbc0$var$FluxTaskPage = ({ source: source, params: { taskID: taskID, kid: kid }, router: router })=>{
    const [loading, setLoading] = (0, $NdCUR.useState)(true);
    const [error, setError] = (0, $NdCUR.useState)(undefined);
    const [[kapacitor, task], setData] = (0, $NdCUR.useState)([
        undefined,
        undefined
    ]);
    const [areLogsVisible, setLogsVisible] = (0, $NdCUR.useState)(false);
    const dispatch = (0, $cc214f6ed98ca6a9$export$8ad76b76a4c905f8)();
    const [changeStatus, setChangeStatus] = (0, $NdCUR.useState)((0, $918c9f03a35fe03f$export$f58bd244391b65a5).Default);
    (0, $NdCUR.useEffect)(()=>{
        setLoading(true);
        const fetchData = async ()=>{
            try {
                let kapa;
                if (kid) kapa = await (0, $3bff70d0456af5c0$export$82a2e3b7e5164c8a)(source);
                else kapa = await (0, $3bff70d0456af5c0$export$c751af5d7f198354)(source, kid);
                if (!kapa) {
                    setError(new Error('Kapacitor not found!'));
                    return;
                }
                const taskVal = await (0, $1c87b80fc86b574d$export$6a97019aaa996411)(kapa, taskID);
                if (!taskVal) {
                    setError(new Error(`Task identified by ${taskID} not found!`));
                    return;
                }
                setData([
                    kapa,
                    taskVal
                ]);
            } catch (e) {
                console.error(e);
                setError(new Error(e?.data?.message ? e.data.message : `Cannot load flux task: ${(0, $0ba8b809bdda5b53$export$2e2bcd8739ae039)(e)}`));
            } finally{
                setLoading(false);
            }
        };
        fetchData();
    }, [
        kid,
        taskID
    ]);
    let contents = null;
    if (error) contents = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel panel-solid"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel-body"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", {
        className: "unexpected_error"
    }, error.toString())));
    else if (loading) contents = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel panel-solid"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel-body"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $810ad5a94daa03b8$export$2e2bcd8739ae039), null)));
    else if (task) {
        const active = task.status === 'active';
        contents = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "fluxtask-controls"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h1", {
            className: "tickscript-controls--name"
        }, task.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "tickscript-controls--right"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($167b65a9268a02a9$exports))), {
            text: task.flux,
            onCopy: (_copiedText, isSuccessful)=>{
                if (isSuccessful) dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$9744b69e3922044f)(null, 'Flux Script')));
                else dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$6a59b8139549a56)(null, 'Flux Script')));
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
            size: (0, $918c9f03a35fe03f$export$fafce5c139da9687).ExtraSmall,
            color: (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Default,
            titleText: "Copy to clipboard",
            icon: (0, $918c9f03a35fe03f$export$62c9c0cf752cde38).Duplicate,
            text: "Copy",
            onClick: (e)=>{
                e.stopPropagation();
                e.preventDefault();
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
            size: (0, $918c9f03a35fe03f$export$fafce5c139da9687).ExtraSmall,
            color: active ? (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Default : (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Success,
            titleText: "Change task status",
            text: active ? 'Deactivate' : 'Activate',
            status: changeStatus,
            onClick: ()=>{
                setChangeStatus((0, $918c9f03a35fe03f$export$f58bd244391b65a5).Loading);
                (0, $413b7ff06f318700$export$eb74524fc20af70a)(kapacitor, task, active ? 'inactive' : 'active', false)(dispatch).then((success)=>{
                    setChangeStatus((0, $918c9f03a35fe03f$export$f58bd244391b65a5).Default);
                    if (success) setData([
                        kapacitor,
                        {
                            ...task,
                            status: active ? 'inactive' : 'active'
                        }
                    ]);
                });
            }
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "fluxtask-editor"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a58c20547c7c0b21$export$2e2bcd8739ae039), {
            onChangeScript: $43e4a68a43bdcbc0$var$noop,
            onSubmitScript: $43e4a68a43bdcbc0$var$noop,
            onCursorChange: $43e4a68a43bdcbc0$var$noop,
            suggestions: [],
            status: {
                text: '',
                type: 'success'
            },
            script: task.flux,
            visibility: "visible",
            readOnly: true
        })));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039), {
        className: "tickscript-editor-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header, {
        fullWidth: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header.Left, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Title, {
        title: "Flux Task"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header.Right, {
        showSourceIndicator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039), {
        color: (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Success
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039).Button, {
        id: "tickscript-logs--hidden",
        active: !areLogsVisible,
        value: false,
        onClick: setLogsVisible,
        titleText: "Show just the Flux Task Script"
    }, "Script"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21a9fdccc7481b10$export$2e2bcd8739ae039).Button, {
        id: "tickscript-logs--visible",
        active: areLogsVisible,
        value: true,
        onClick: setLogsVisible,
        titleText: "Show the Flux Task Script & Logs"
    }, "Script + Logs")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
        className: "btn btn-default btn-sm",
        title: "Return to Flux Tasks",
        onClick: ()=>{
            router.push(`/sources/${source.id}/flux-tasks${router.location.search}`);
        }
    }, "Exit"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "page-contents--split"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: `fluxtask ${areLogsVisible ? 'fluxtask--withLogs' : ''}`
    }, contents), areLogsVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($43e4a68a43bdcbc0$var$LogsTable, {
        task: task,
        kapacitor: kapacitor
    }) : null));
};
var $43e4a68a43bdcbc0$export$2e2bcd8739ae039 = (0, $c8cd79e362cba2a4$export$a520fb22fccea800)($43e4a68a43bdcbc0$var$FluxTaskPage);



var $NdCUR = parcelRequire("NdCUR");







var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");



const { colName: $e15536945cdc44fb$var$colName, colEnabled: $e15536945cdc44fb$var$colEnabled, colActions: $e15536945cdc44fb$var$colActions, colEvery: $e15536945cdc44fb$var$colEvery, colCron: $e15536945cdc44fb$var$colCron } = (0, $063b710ad7fb02e4$export$cddaf6cea22db06c);
const $e15536945cdc44fb$var$FluxTaskRow = ({ task: task, viewLink: viewLink, onChangeTaskStatus: onChangeTaskStatus, onDelete: onDelete })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tr", {
        key: task.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
        style: {
            minWidth: $e15536945cdc44fb$var$colName
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ba1cc4424c00aefe$export$2e2bcd8739ae039), {
        to: viewLink
    }, task.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
        style: {
            width: $e15536945cdc44fb$var$colEvery
        }
    }, task.every || ''), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
        style: {
            width: $e15536945cdc44fb$var$colCron
        }
    }, task.cron || ''), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
        style: {
            width: $e15536945cdc44fb$var$colEnabled
        },
        className: "text-center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "dark-checkbox"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
        id: `kapacitor-task-row-task-enabled ${task.id}`,
        className: "form-control-static",
        type: "checkbox",
        checked: task.status === 'active',
        onChange: ()=>onChangeTaskStatus(task)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
        htmlFor: `kapacitor-task-row-task-enabled ${task.id}`
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
        style: {
            width: $e15536945cdc44fb$var$colActions
        },
        className: "text-right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $8008717819fc7a5f$export$2e2bcd8739ae039), {
        text: "Delete",
        type: "btn-danger",
        size: "btn-xs",
        customClass: "table--show-on-row-hover",
        confirmAction: ()=>onDelete(task)
    })));
const $e15536945cdc44fb$var$FluxTasksTable = ({ tasks: tasks, kapacitorLink: kapacitorLink, onDelete: onDelete, onChangeTaskStatus: onChangeTaskStatus, editLinkSuffix: editLinkSuffix = '' })=>{
    if (!tasks) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("table", {
        className: "table v-center table-highlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
        style: {
            minWidth: $e15536945cdc44fb$var$colName
        }
    }, "Name"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
        style: {
            minWidth: $e15536945cdc44fb$var$colEvery
        }
    }, "Every"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
        style: {
            minWidth: $e15536945cdc44fb$var$colCron
        }
    }, "Cron"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
        style: {
            width: $e15536945cdc44fb$var$colEnabled
        },
        className: "text-center"
    }, "Task Active"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
        style: {
            width: $e15536945cdc44fb$var$colActions
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tbody", null, (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).sortBy(tasks, (t)=>t.name.toLowerCase()).map((task)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($e15536945cdc44fb$var$FluxTaskRow, {
            key: task.id,
            viewLink: `${kapacitorLink}/fluxtasks/${task.id}${editLinkSuffix}`,
            task: task,
            onDelete: onDelete,
            onChangeTaskStatus: onChangeTaskStatus
        });
    })));
};
var $e15536945cdc44fb$export$2e2bcd8739ae039 = $e15536945cdc44fb$var$FluxTasksTable;







const $f3641bbcba4f52a8$var$Contents = ({ kapacitor: kapacitor, source: source, filter: filterInit = '' })=>{
    const [loading, setLoading] = (0, $NdCUR.useState)(true);
    const [reloadRequired, setReloadRequired] = (0, $NdCUR.useState)(0);
    const [error, setError] = (0, $NdCUR.useState)(undefined);
    const [allList, setAllList] = (0, $NdCUR.useState)(null);
    const dispatch = (0, $cc214f6ed98ca6a9$export$8ad76b76a4c905f8)();
    (0, $NdCUR.useEffect)(()=>{
        setLoading(true);
        const ac = new AbortController();
        const fetchData = async ()=>{
            try {
                const data = await (0, $1c87b80fc86b574d$export$2afa9e760b71914e)(kapacitor, ac.signal);
                setAllList(data);
            } catch (e) {
                if (!(0, $d96f38380b9b4c62$export$2b3d06107d1323d4)(e)) {
                    if (e.status === 404) setAllList(null);
                    else {
                        console.error(e);
                        setError(new Error(e?.data?.message ? e.data.message : `Cannot load flux tasks: ${(0, $0ba8b809bdda5b53$export$2e2bcd8739ae039)(e)}`));
                    }
                }
            } finally{
                setLoading(false);
            }
        };
        fetchData();
        return ()=>ac.abort();
    }, [
        kapacitor,
        reloadRequired
    ]);
    const [nameFilter, setNameFilter] = (0, $NdCUR.useState)(filterInit);
    const filter = (0, $9f13d970a740e49f$export$2e2bcd8739ae039)(nameFilter);
    const list = (0, $NdCUR.useMemo)(()=>{
        if (allList && allList.length && filter) return allList.filter((x)=>x.name.includes(filter));
        return allList;
    }, [
        allList,
        filter
    ]);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel panel-solid"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel-body"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", {
        className: "unexpected_error"
    }, error.toString())));
    if (list === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel panel-solid"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel-body"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", {
        className: "unexpected_error"
    }, "No flux tasks are available. Kapacitor 1.6+ is required with Flux tasks enabled.")));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel-heading",
        style: {
            gap: '5px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "search-widget",
        style: {
            flexGrow: 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
        type: "text",
        className: "form-control input-sm",
        placeholder: "Filter by name",
        value: nameFilter,
        disabled: loading,
        onChange: (e)=>{
            setNameFilter(e.target.value);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        className: "icon search"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
        titleText: "Reload Flux Tasks",
        shape: (0, $918c9f03a35fe03f$export$ce765fb8bb08a599).Square,
        icon: (0, $918c9f03a35fe03f$export$62c9c0cf752cde38).Refresh,
        onClick: ()=>setReloadRequired(reloadRequired + 1)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel-body"
    }, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $810ad5a94daa03b8$export$2e2bcd8739ae039), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $e15536945cdc44fb$export$2e2bcd8739ae039), {
        kapacitorLink: `/sources/${source.id}/kapacitors/${kapacitor.id}`,
        tasks: list,
        onDelete: (task)=>{
            (0, $1c87b80fc86b574d$export$6d05c72bb9cfb10)(kapacitor, task).then(()=>{
                setAllList(allList.filter((x)=>x.id !== task.id));
                dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$b9fb5ac3b1648cf)(task.name)));
            }).catch(()=>{
                dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$a023f39c3f194683)(task.name)));
            });
        },
        onChangeTaskStatus: (task)=>{
            const status = task.status === 'active' ? 'inactive' : 'active';
            (0, $1c87b80fc86b574d$export$eb74524fc20af70a)(kapacitor, task, status).then(()=>{
                setAllList(allList.map((x)=>x.id === task.id ? {
                        ...task,
                        status: status
                    } : x));
                dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$63f2ebe081830a1e)(task.name, status)));
            }).catch(()=>{
                dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$e9e86592d2c92c39)(task.name, status)));
                return false;
            });
        }
    })));
};
const $f3641bbcba4f52a8$var$FluxTasksPage = ({ source: src, router: { location: { query: { filter: filter } } } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $442c44a73c838577$export$2e2bcd8739ae039), {
        source: src,
        title: "Manage Flux Tasks"
    }, (kapacitor, source)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($f3641bbcba4f52a8$var$Contents, {
            kapacitor: kapacitor,
            source: source,
            filter: filter
        }));
};
var $f3641bbcba4f52a8$export$2e2bcd8739ae039 = (0, $c8cd79e362cba2a4$export$a520fb22fccea800)($f3641bbcba4f52a8$var$FluxTasksPage);





var $NdCUR = parcelRequire("NdCUR");







var $NdCUR = parcelRequire("NdCUR");


var $NdCUR = parcelRequire("NdCUR");


const $6bea39f1e18f5494$var$InfluxTableHead = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
        className: "source-table--connect-col"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", null, "InfluxDB Connection"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
        className: "text-right"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", null, "Kapacitor Connection", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1ca55233f3c1ef57$export$2e2bcd8739ae039), {
        tipID: "kapacitor-node-helper",
        tipContent: (0, $682f08314e650e04$export$c21a3cc87aee594d)
    }))));
};
var $6bea39f1e18f5494$export$2e2bcd8739ae039 = $6bea39f1e18f5494$var$InfluxTableHead;



var $NdCUR = parcelRequire("NdCUR");

class $c6ea104c905af268$var$InfluxTableHeader extends (0, $NdCUR.PureComponent) {
    render() {
        const { toggleWizard: toggleWizard } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel-heading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h2", {
            className: "panel-title"
        }, this.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $091cfcd49e339acd$export$2e2bcd8739ae039), {
            requiredRole: (0, $a7910b1002260d34$export$f715f7e27dea2abf)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            onClick: toggleWizard(true),
            className: "btn btn-sm btn-primary",
            "data-test": "add-connection--button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon plus"
        }), " Add Connection")));
    }
    get title() {
        const { isUsingAuth: isUsingAuth, me: me } = this.props;
        if (isUsingAuth) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", null, "Connections for ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("em", null, me.currentOrganization.name));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", null, "Connections");
    }
}
var $c6ea104c905af268$export$2e2bcd8739ae039 = $c6ea104c905af268$var$InfluxTableHeader;



var $NdCUR = parcelRequire("NdCUR");




var $NdCUR = parcelRequire("NdCUR");





var $1v7mg = parcelRequire("1v7mg");

class $35aab7e74efc8a1d$var$KapacitorDropdown extends (0, $NdCUR.PureComponent) {
    static{
        this.defaultProps = {
            buttonSize: 'btn-xs'
        };
    }
    render() {
        const { buttonSize: buttonSize, onAddNew: onAddNew } = this.props;
        if (this.isKapacitorsEmpty) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $091cfcd49e339acd$export$2e2bcd8739ae039), {
            requiredRole: (0, $a7910b1002260d34$export$f715f7e27dea2abf)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
            text: 'Add Kapacitor Connection',
            onClick: this.launchWizard,
            color: (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Default,
            size: (0, $918c9f03a35fe03f$export$fafce5c139da9687).ExtraSmall,
            shape: (0, $918c9f03a35fe03f$export$ce765fb8bb08a599).StretchToFit,
            icon: (0, $918c9f03a35fe03f$export$62c9c0cf752cde38).Plus
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $091cfcd49e339acd$export$2e2bcd8739ae039), {
            requiredRole: (0, $a7910b1002260d34$export$f715f7e27dea2abf),
            replaceWithIfNotAuthorized: this.UnauthorizedDropdown
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ca4f14339173643c$export$2e2bcd8739ae039), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))({
                'kapacitor-dropdown': onAddNew,
                'dropdown-260': !onAddNew
            }),
            buttonColor: "btn-primary",
            buttonSize: buttonSize,
            items: this.kapacitorItems,
            onChoose: this.handleSetActiveKapacitor,
            addNew: {
                text: 'Add Kapacitor Connection',
                handler: this.handleAddNew
            },
            actions: this.dropdownActions,
            selected: this.selected
        }));
    }
    get UnauthorizedDropdown() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "source-table--kapacitor__view-only"
        }, this.selected);
    }
    get dropdownActions() {
        const { deleteKapacitor: deleteKapacitor, router: router, suppressEdit: suppressEdit } = this.props;
        const deleteAction = [
            {
                icon: 'trash',
                text: 'delete',
                handler: (item)=>{
                    deleteKapacitor(item.kapacitor);
                },
                confirmable: true
            }
        ];
        const editAction = [
            {
                icon: 'pencil',
                text: 'edit',
                handler: (item)=>{
                    router.push(`${item.resource}/edit`);
                }
            }
        ];
        if (suppressEdit) return deleteAction;
        return [
            ...editAction,
            ...deleteAction
        ];
    }
    get isKapacitorsEmpty() {
        const { kapacitors: kapacitors } = this.props;
        return !kapacitors || kapacitors.length === 0;
    }
    get kapacitorItems() {
        const { kapacitors: kapacitors, source: source } = this.props;
        return kapacitors.map((k)=>{
            return {
                text: k.name,
                resource: `/sources/${source.id}/kapacitors/${k.id}`,
                kapacitor: k
            };
        });
    }
    get activeKapacitor() {
        const { kapacitors: kapacitors } = this.props;
        return kapacitors.find((k)=>k.active) || kapacitors[0];
    }
    get selected() {
        const { displayValue: displayValue } = this.props;
        let selected = '';
        if (displayValue) return displayValue;
        if (this.activeKapacitor) selected = this.activeKapacitor.name;
        else selected = this.kapacitorItems[0].text;
        return selected;
    }
    constructor(...args){
        super(...args), this.handleSetActiveKapacitor = (item)=>{
            const { setActiveKapacitor: setActiveKapacitor } = this.props;
            setActiveKapacitor(item.kapacitor);
        }, this.handleAddNew = ()=>{
            const { onAddNew: onAddNew } = this.props;
            if (onAddNew) onAddNew();
            else this.launchWizard();
        }, this.launchWizard = ()=>{
            const { toggleWizard: toggleWizard, source: source } = this.props;
            if (toggleWizard) toggleWizard(true, source, 2, true)();
        };
    }
}
var $35aab7e74efc8a1d$export$2e2bcd8739ae039 = (0, $dffbdf89c590a961$export$2e2bcd8739ae039)($35aab7e74efc8a1d$var$KapacitorDropdown);



var $NdCUR = parcelRequire("NdCUR");

class $fe9b65e4ec33dadb$var$ConnectionLink extends (0, $NdCUR.PureComponent) {
    render() {
        const { source: source, toggleWizard: toggleWizard } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h5", {
            className: "margin-zero"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $091cfcd49e339acd$export$2e2bcd8739ae039), {
            requiredRole: (0, $a7910b1002260d34$export$f715f7e27dea2abf),
            replaceWithIfNotAuthorized: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("strong", null, source.name)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            onClick: toggleWizard(true, source, 0),
            className: `connection-title ${this.className}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("strong", null, source.name), this.default)));
    }
    get className() {
        if (this.isCurrentSource) return 'link-success';
        return '';
    }
    get default() {
        const { source: source } = this.props;
        if (source.default) return ' (Default)';
        return '';
    }
    get isCurrentSource() {
        const { source: source, currentSource: currentSource } = this.props;
        return source.id === currentSource.id;
    }
}
var $fe9b65e4ec33dadb$export$2e2bcd8739ae039 = $fe9b65e4ec33dadb$var$ConnectionLink;




class $31ade998bd02e5de$var$InfluxTableRow extends (0, $NdCUR.PureComponent) {
    componentDidUpdate() {
        if (this.connectionLink.current) this.connectionLink.current.forceUpdate();
    }
    render() {
        const { source: source, currentSource: currentSource, setActiveKapacitor: setActiveKapacitor, deleteKapacitor: deleteKapacitor, toggleWizard: toggleWizard } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tr", {
            className: this.className,
            "data-test": "connection-row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", null, this.connectButton), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fe9b65e4ec33dadb$export$2e2bcd8739ae039), {
            ref: this.connectionLink,
            source: source,
            currentSource: currentSource,
            toggleWizard: toggleWizard
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", null, source.url)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            className: "text-right"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $091cfcd49e339acd$export$2e2bcd8739ae039), {
            requiredRole: (0, $a7910b1002260d34$export$f715f7e27dea2abf)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $8008717819fc7a5f$export$2e2bcd8739ae039), {
            type: "btn-danger",
            size: "btn-xs",
            text: "Delete Connection",
            confirmAction: this.handleDeleteSource,
            customClass: "delete-source table--show-on-row-hover",
            testId: "delete-connection--button"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            className: "source-table--kapacitor"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $35aab7e74efc8a1d$export$2e2bcd8739ae039), {
            source: source,
            kapacitors: source.kapacitors,
            deleteKapacitor: deleteKapacitor,
            setActiveKapacitor: setActiveKapacitor,
            toggleWizard: toggleWizard
        })));
    }
    get connectButton() {
        if (this.isCurrentSource) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
            text: 'Connected',
            color: (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Success,
            size: (0, $918c9f03a35fe03f$export$fafce5c139da9687).ExtraSmall,
            shape: (0, $918c9f03a35fe03f$export$ce765fb8bb08a599).StretchToFit
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
            text: 'Connect',
            onClick: this.routeToSource,
            color: (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Default,
            size: (0, $918c9f03a35fe03f$export$fafce5c139da9687).ExtraSmall,
            shape: (0, $918c9f03a35fe03f$export$ce765fb8bb08a599).StretchToFit
        });
    }
    get className() {
        if (this.isCurrentSource) return 'hightlight';
        return '';
    }
    get isCurrentSource() {
        const { source: source, currentSource: currentSource } = this.props;
        return source.id === currentSource.id;
    }
    constructor(...args){
        super(...args), this.connectionLink = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createRef(), this.handleDeleteSource = ()=>{
            this.props.onDeleteSource(this.props.source);
        }, this.routeToSource = ()=>{
            const { source: source, router: router } = this.props;
            router.push(`/sources/${source.id}/manage-sources`);
        };
    }
}
var $31ade998bd02e5de$export$2e2bcd8739ae039 = (0, $dffbdf89c590a961$export$2e2bcd8739ae039)($31ade998bd02e5de$var$InfluxTableRow);


class $eccbf29120012148$var$InfluxTable extends (0, $NdCUR.PureComponent) {
    render() {
        const { source: source, sources: sources, setActiveKapacitor: setActiveKapacitor, onDeleteSource: onDeleteSource, deleteKapacitor: deleteKapacitor, isUsingAuth: isUsingAuth, me: me, toggleWizard: toggleWizard } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c6ea104c905af268$export$2e2bcd8739ae039), {
            me: me,
            source: source,
            isUsingAuth: isUsingAuth,
            toggleWizard: toggleWizard
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel-body",
            "data-test": "set-conection-panel-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("table", {
            className: "table v-center margin-bottom-zero table-highlight"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $6bea39f1e18f5494$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tbody", null, sources.map((s)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $31ade998bd02e5de$export$2e2bcd8739ae039), {
                key: s.id,
                source: s,
                currentSource: source,
                onDeleteSource: onDeleteSource,
                deleteKapacitor: deleteKapacitor,
                setActiveKapacitor: setActiveKapacitor,
                toggleWizard: toggleWizard
            });
        })))));
    }
}
const $eccbf29120012148$var$mapStateToProps = ({ auth: { isUsingAuth: isUsingAuth, me: me } })=>({
        isUsingAuth: isUsingAuth,
        me: me
    });
var $eccbf29120012148$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($eccbf29120012148$var$mapStateToProps)($eccbf29120012148$var$InfluxTable);


// Libraries

var $NdCUR = parcelRequire("NdCUR");


var $hBdgJ = parcelRequire("hBdgJ");

// Libraries

var $NdCUR = parcelRequire("NdCUR");



// Libraries

var $NdCUR = parcelRequire("NdCUR");
// Libraries

var $NdCUR = parcelRequire("NdCUR");
// Libraries

var $NdCUR = parcelRequire("NdCUR");
var $3169684d4687dfc0$export$d0aa683445069f84 = /*#__PURE__*/ function(ConnectorState) {
    ConnectorState["None"] = "none";
    ConnectorState["Some"] = "some";
    ConnectorState["Full"] = "full";
    return ConnectorState;
}({});
var $3169684d4687dfc0$export$d57f9812c5f15784 = /*#__PURE__*/ function(StepStatus) {
    StepStatus["Incomplete"] = "circle-thick";
    StepStatus["Complete"] = "checkmark";
    StepStatus["Error"] = "remove";
    return StepStatus;
}({});



class $f90f5f6852f611d2$var$ProgressConnector extends (0, $NdCUR.PureComponent) {
    render() {
        const { status: status } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: `wizard-progress-connector wizard-progress-connector--${status || (0, $3169684d4687dfc0$export$d0aa683445069f84).None}`
        });
    }
}
var $f90f5f6852f611d2$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($f90f5f6852f611d2$var$ProgressConnector);




class $d0a0e6f1897a87e8$var$WizardProgressBar extends (0, $NdCUR.PureComponent) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "wizard-progress-bar"
        }, this.WizardProgress);
    }
    get WizardProgress() {
        const { steps: steps, currentStepIndex: currentStepIndex, handleJump: handleJump } = this.props;
        const progressBar = steps.reduce((acc, step, index)=>{
            const { stepStatus: stepStatus } = step;
            let currentStep = '';
            const isCurrentStep = index === currentStepIndex;
            const isNotErrored = stepStatus !== (0, $3169684d4687dfc0$export$d57f9812c5f15784).Error;
            const isAtEndOfWizard = currentStepIndex === steps.length - 1;
            const isCompleted = stepStatus === (0, $3169684d4687dfc0$export$d57f9812c5f15784).Complete;
            const isLastStep = index === steps.length - 1;
            const previousIsComplete = steps[index - 1] && steps[index - 1].stepStatus === (0, $3169684d4687dfc0$export$d57f9812c5f15784).Complete;
            // STEP STATUS
            if (isCurrentStep && isNotErrored) currentStep = 'circle-thick current';
            if (isLastStep && previousIsComplete) currentStep = 'checkmark';
            const stepEle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                key: `stepEle${index}`,
                className: "wizard-progress-button",
                onClick: handleJump(index)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                className: "wizard-progress-title"
            }, step.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
                className: `icon ${currentStep || stepStatus}`
            }));
            // PROGRESS BAR CONNECTOR
            let connectorStatus = (0, $3169684d4687dfc0$export$d0aa683445069f84).None;
            if (isCurrentStep && isNotErrored) connectorStatus = (0, $3169684d4687dfc0$export$d0aa683445069f84).Some;
            if (isAtEndOfWizard || isLastStep || isCompleted) connectorStatus = (0, $3169684d4687dfc0$export$d0aa683445069f84).Full;
            const connectorEle = isLastStep ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $f90f5f6852f611d2$export$2e2bcd8739ae039), {
                key: `connectorEle${index}`,
                status: connectorStatus
            });
            return [
                ...acc,
                stepEle,
                connectorEle
            ];
        }, []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, progressBar);
    }
}
var $d0a0e6f1897a87e8$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($d0a0e6f1897a87e8$var$WizardProgressBar);






var $hBdgJ = parcelRequire("hBdgJ");
class $575882ef096e7857$var$WizardController extends (0, $NdCUR.PureComponent) {
    static{
        this.defaultProps = {
            skipLinkText: 'Skip',
            jumpStep: -1
        };
    }
    static getDerivedStateFromProps(props, state) {
        let { currentStepIndex: currentStepIndex } = state;
        const { children: children } = props;
        const childSteps = (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Children.map(children, (child, i)=>{
            const isComplete = child.props.isComplete();
            let isErrored;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isBoolean(child.props.isErrored)) isErrored = child.props.isErrored;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isFunction(child.props.isErrored)) isErrored = child.props.isErrored();
            let stepStatus = (0, $3169684d4687dfc0$export$d57f9812c5f15784).Incomplete;
            if (isComplete) stepStatus = (0, $3169684d4687dfc0$export$d57f9812c5f15784).Complete;
            if (isErrored) stepStatus = (0, $3169684d4687dfc0$export$d57f9812c5f15784).Error;
            if (currentStepIndex === -1 && !isComplete) currentStepIndex = i;
            return {
                title: child.props.title,
                stepStatus: stepStatus
            };
        });
        if (currentStepIndex === -1) currentStepIndex = childSteps.length - 1;
        return {
            steps: childSteps,
            currentStepIndex: currentStepIndex
        };
    }
    constructor(props){
        super(props), this.incrementStep = ()=>{
            this.setState((prevState)=>{
                return {
                    currentStepIndex: prevState.currentStepIndex + 1
                };
            });
        }, this.decrementStep = ()=>{
            this.setState((prevState)=>{
                return {
                    currentStepIndex: prevState.currentStepIndex - 1
                };
            });
        }, this.jumpToStep = (jumpIndex)=>()=>{
                const { isJumpingAllowed: isJumpingAllowed } = this.props;
                if (isJumpingAllowed) this.setState({
                    currentStepIndex: jumpIndex
                });
            };
        const { jumpStep: jumpStep } = this.props;
        this.state = {
            steps: [],
            currentStepIndex: (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isNull(jumpStep) ? -1 : jumpStep
        };
    }
    render() {
        const { steps: steps, currentStepIndex: currentStepIndex } = this.state;
        const { isUsingAuth: isUsingAuth } = this.props;
        const currentChild = this.CurrentChild;
        const { isSkippableStep: isSkippableStep } = currentChild.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "wizard-controller"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "progress-header"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h3", {
            className: "wizard-step-title"
        }, currentChild.props.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $d0a0e6f1897a87e8$export$2e2bcd8739ae039), {
            handleJump: this.jumpToStep,
            steps: steps,
            currentStepIndex: currentStepIndex
        }), this.tipText), currentChild, isUsingAuth ? this.switchLink : null, isSkippableStep ? this.skipLink : null);
    }
    get CurrentChild() {
        const { children: children, handleFinish: handleFinish } = this.props;
        const { currentStepIndex: currentStepIndex, steps: steps } = this.state;
        const lastStep = currentStepIndex === steps.length - 1;
        const advance = lastStep ? handleFinish : this.incrementStep;
        const retreat = currentStepIndex === 0 ? null : this.decrementStep;
        let currentChild;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Children.count(children) === 1) currentChild = children;
        else currentChild = children[currentStepIndex];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).cloneElement(currentChild, {
            increment: advance,
            decrement: retreat,
            lastStep: lastStep
        });
    }
    get tipText() {
        const { currentStepIndex: currentStepIndex } = this.state;
        const { children: children } = this.props;
        let currentChild;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Children.count(children) === 1) currentChild = children;
        else currentChild = children[currentStepIndex];
        const tipText = (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(currentChild, 'props.tipText', '');
        if (tipText) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "wizard-tip-text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, tipText));
        return null;
    }
    get skipLink() {
        const { skipLinkText: skipLinkText } = this.props;
        const { currentStepIndex: currentStepIndex } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-xs btn-primary btn-link wizard-skip-link",
            onClick: this.jumpToStep(currentStepIndex + 1),
            "data-test": 'skip-button'
        }, skipLinkText);
    }
    get switchLink() {
        const { handleSwitch: handleSwitch, switchLinkText: switchLinkText } = this.props;
        if (handleSwitch) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-xs btn-primary btn-link wizard-skip-link",
            onClick: handleSwitch,
            "data-test": 'switch-button'
        }, switchLinkText);
        return null;
    }
}
var $575882ef096e7857$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($575882ef096e7857$var$WizardController);




class $606a8ffac69c39b8$var$WizardOverlay extends (0, $NdCUR.PureComponent) {
    static{
        this.defaultProps = {
            maxWidth: 800
        };
    }
    render() {
        const { visible: visible, title: title, maxWidth: maxWidth } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "wizard-overlay"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $827fcd4cb090ac0e$export$2e2bcd8739ae039), {
            visible: visible
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1868bdace58643df$export$2e2bcd8739ae039), {
            maxWidth: maxWidth
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1372e03f76900c5b$export$2e2bcd8739ae039), {
            title: title,
            onDismiss: this.handleFinish
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1e8c886c7914a527$export$2e2bcd8739ae039), null, this.WizardController))));
    }
    get WizardController() {
        const { children: children, skipLinkText: skipLinkText, jumpStep: jumpStep, isJumpingAllowed: isJumpingAllowed } = this.props;
        if (children) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $575882ef096e7857$export$2e2bcd8739ae039), {
            skipLinkText: skipLinkText,
            handleFinish: this.handleFinish,
            jumpStep: jumpStep,
            isJumpingAllowed: isJumpingAllowed
        }, children);
        return null;
    }
    constructor(...args){
        super(...args), this.handleFinish = ()=>{
            const { toggleVisibility: toggleVisibility, resetWizardState: resetWizardState } = this.props;
            toggleVisibility(false)();
            resetWizardState();
        };
    }
}
var $606a8ffac69c39b8$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($606a8ffac69c39b8$var$WizardOverlay);


// Libraries

var $NdCUR = parcelRequire("NdCUR");
// Libraries

var $NdCUR = parcelRequire("NdCUR");

class $9482669acf946304$var$WizardButtonBar extends (0, $NdCUR.PureComponent) {
    static{
        this.defaultProps = {
            nextLabel: 'Next',
            previousLabel: 'Previous'
        };
    }
    render() {
        const { decrement: decrement, previousLabel: previousLabel, nextLabel: nextLabel, onClickPrevious: onClickPrevious, onClickNext: onClickNext } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "wizard-button-bar"
        }, decrement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-md btn-default",
            onClick: onClickPrevious
        }, previousLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: `btn btn-md ${this.buttonColor}`,
            onClick: onClickNext
        }, nextLabel));
    }
    get buttonColor() {
        const { lastStep: lastStep } = this.props;
        if (lastStep) return 'btn-success';
        return 'btn-primary';
    }
}
var $9482669acf946304$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($9482669acf946304$var$WizardButtonBar);




class $897f9eefb239aa01$var$WizardStep extends (0, $NdCUR.PureComponent) {
    static{
        this.defaultProps = {
            isSkippableStep: true,
            isErrored: false
        };
    }
    render() {
        const { children: children, decrement: decrement, nextLabel: nextLabel, previousLabel: previousLabel, lastStep: lastStep } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "wizard-step--container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "wizard-step--shadow"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), {
            autoHide: false,
            autoHeight: true,
            maxHeight: this.scrollMaxHeight
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "wizard-step--child"
        }, children))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $9482669acf946304$export$2e2bcd8739ae039), {
            decrement: decrement,
            nextLabel: nextLabel,
            previousLabel: previousLabel,
            onClickPrevious: this.handleClickPrevious,
            onClickNext: this.handleClickNext,
            lastStep: lastStep
        }));
    }
    constructor(...args){
        super(...args), this.scrollMaxHeight = window.innerHeight * 0.45, this.handleClickPrevious = async ()=>{
            const { onPrevious: onPrevious, decrement: decrement } = this.props;
            let returnedValue;
            if (onPrevious) returnedValue = await onPrevious();
            if (decrement) decrement();
            return returnedValue;
        }, this.handleClickNext = async ()=>{
            const { onNext: onNext, increment: increment, isSkippableStep: isSkippableStep } = this.props;
            let payload;
            let error = false;
            if (onNext) {
                const response = await onNext();
                error = response.error;
                payload = response.payload;
            }
            if (increment) {
                if (isSkippableStep || !isSkippableStep && error === false) increment();
            }
            return payload;
        };
    }
}
var $897f9eefb239aa01$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($897f9eefb239aa01$var$WizardStep);


/* eslint-disable no-empty */ // Libraries

var $NdCUR = parcelRequire("NdCUR");


var $hBdgJ = parcelRequire("hBdgJ");


var $NdCUR = parcelRequire("NdCUR");

class $b3da5d11e9cd3818$var$WizardTextInput extends (0, $NdCUR.PureComponent) {
    static{
        this.defaultProps = {
            value: '',
            isDisabled: false,
            isValid: ()=>({
                    status: true,
                    reason: ''
                }),
            valueModifier: (x)=>x,
            autoFocus: false,
            type: 'text',
            onSubmit: ()=>null
        };
    }
    constructor(props){
        super(props), this.handleBlur = (e)=>{
            this.submit(e.target.value);
        }, this.handleKeyDown = (e)=>{
            if (e.key === 'Enter') this.submit(e.currentTarget.value);
            if (e.key === 'Escape') this.handleEscape();
        }, this.handleEscape = ()=>{
            const { onChange: onChange } = this.props;
            const { initialValue: initialValue } = this.state;
            onChange(initialValue);
        }, this.submit = (incomingValue)=>{
            const { onChange: onChange, value: value, valueModifier: valueModifier, onSubmit: onSubmit } = this.props;
            const newValue = valueModifier(incomingValue);
            onSubmit(newValue);
            if (value !== newValue) onChange(newValue);
            this.setState({
                initialValue: newValue
            });
        }, this.handleChange = (e)=>{
            const { onChange: onChange } = this.props;
            if (onChange) onChange(e.target.value);
        };
        this.state = {
            initialValue: this.props.value
        };
    }
    render() {
        const { isDisabled: isDisabled, placeholder: placeholder, isValid: isValid, value: value, autoFocus: autoFocus, label: label, type: type, testId: testId } = this.props;
        let inputClass = '';
        let errorText = '';
        const validation = isValid(value);
        if (validation.status === false) {
            inputClass = 'form-volcano';
            errorText = validation.reason;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group col-xs-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            htmlFor: label
        }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            type: type,
            id: label,
            className: `form-control input-sm ${inputClass}`,
            value: value,
            placeholder: placeholder,
            onBlur: this.handleBlur,
            onKeyDown: this.handleKeyDown,
            onChange: this.handleChange,
            disabled: isDisabled,
            autoFocus: autoFocus,
            spellCheck: false,
            autoComplete: 'off',
            "data-test": testId
        }), errorText);
    }
}
var $b3da5d11e9cd3818$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($b3da5d11e9cd3818$var$WizardTextInput);



var $NdCUR = parcelRequire("NdCUR");



class $81ae7b856a4d886e$var$WizardCheckbox extends (0, $NdCUR.PureComponent) {
    render() {
        const { text: text, isChecked: isChecked, subtext: subtext, halfWidth: halfWidth, testId: testId } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: 'form-group ' + (halfWidth ? 'col-xs-6' : 'col-xs-12')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-control-static wizard-checkbox--group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $4115c6d17e8dc56b$export$2e2bcd8739ae039), {
            color: (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Success,
            size: (0, $918c9f03a35fe03f$export$fafce5c139da9687).ExtraSmall,
            active: isChecked,
            onChange: this.onChangeSlideToggle,
            tooltipText: text,
            testId: testId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "wizard-checkbox--label",
            onClick: this.onChangeSlideToggle
        }, text), subtext && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "wizard-checkbox--subtext"
        }, subtext)));
    }
    constructor(...args){
        super(...args), this.onChangeSlideToggle = ()=>{
            const { onChange: onChange, isChecked: isChecked } = this.props;
            onChange(!isChecked);
        };
    }
}
var $81ae7b856a4d886e$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($81ae7b856a4d886e$var$WizardCheckbox);



var $NdCUR = parcelRequire("NdCUR");

const $3ebee1ed3065f342$var$WizardDropdown = ({ value: value, options: options, placeholder: placeholder = 'Select option...', label: label, subtext: subtext, onChange: onChange, halfWidth: halfWidth, testId: testId })=>{
    const dropdownItems = (0, $NdCUR.useMemo)(()=>options.map((option)=>({
                text: option.label
            })), [
        options
    ]);
    const selectedText = (0, $NdCUR.useMemo)(()=>{
        const selectedOption = options.find((opt)=>opt.value === value);
        return selectedOption ? selectedOption.label : placeholder;
    }, [
        value,
        options,
        placeholder
    ]);
    const handleChoose = (0, $NdCUR.useCallback)((item)=>{
        const selectedOption = options.find((opt)=>opt.label === item.text);
        if (selectedOption) onChange(selectedOption.value);
    }, [
        options,
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: 'form-group ' + (halfWidth ? 'col-xs-6' : 'col-xs-12')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
        htmlFor: `wizard-dropdown-${testId}`
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ca4f14339173643c$export$2e2bcd8739ae039), {
        items: dropdownItems,
        selected: selectedText,
        onChoose: handleChoose,
        className: "dropdown-stretch",
        "data-testid": testId
    }), subtext && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        className: "wizard-dropdown--subtext"
    }, subtext));
};
var $3ebee1ed3065f342$export$2e2bcd8739ae039 = $3ebee1ed3065f342$var$WizardDropdown;










const $4385a65f5fcbb29e$var$isNewSource = (source)=>!source.id;
class $4385a65f5fcbb29e$var$SourceStep extends (0, $NdCUR.PureComponent) {
    static{
        this.defaultProps = {
            onBoarding: false
        };
    }
    constructor(props){
        super(props), this.next = async ()=>{
            const { source: source } = this.state;
            const { notify: notify } = this.props;
            if ($4385a65f5fcbb29e$var$isNewSource(source)) try {
                const sourceFromServer = await (0, $3bff70d0456af5c0$export$1921362e86c73c88)(source);
                this.props.addSource(sourceFromServer);
                notify((0, $ec1f42de4faacc37$export$8d90d31f62c24f5f)(source.name));
                return {
                    error: false,
                    payload: sourceFromServer
                };
            } catch (err) {
                notify((0, $ec1f42de4faacc37$export$cecd8ab06970b3ec)(source.name, this.parseError(err)));
                return {
                    error: true,
                    payload: null
                };
            }
            else {
                if (this.sourceIsEdited) try {
                    const sourceFromServer = await (0, $3bff70d0456af5c0$export$328b0edc9fda3a36)(source);
                    this.props.updateSource(sourceFromServer);
                    // if the url field is blurred on a new source, the source is already created with no alert best to give a neutral success message
                    notify((0, $ec1f42de4faacc37$export$8d90d31f62c24f5f)(source.name));
                    return {
                        error: false,
                        payload: sourceFromServer
                    };
                } catch (err) {
                    notify((0, $ec1f42de4faacc37$export$1755739170576210)(source.name, this.parseError(err)));
                    return {
                        error: true,
                        payload: null
                    };
                }
                return {
                    error: false,
                    payload: source
                };
            }
        }, this.URLModifier = (value)=>{
            const url = value.trim();
            if (url.startsWith('http')) return url;
            return `http://${url}`;
        }, this.parseError = (error)=>{
            return (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(error, 'data.message', error);
        }, this.onChangeInput = (key)=>(value)=>{
                const { source: source } = this.state;
                const { setError: setError } = this.props;
                this.setState({
                    source: {
                        ...source,
                        [key]: value
                    }
                });
                setError(false);
            }, this.changeAuth = (v2)=>{
            this.changeSourceType(v2 ? (0, $e10a8602f56394e3$export$f19a85207251c5b9) : (0, $e10a8602f56394e3$export$2b517738cc766db5), v2 ? '2.x' : '1.x');
        }, this.changeSourceType = (type, version)=>{
            const { source: source } = this.state;
            this.setState({
                serverType: type,
                source: {
                    ...source,
                    username: '',
                    password: '',
                    clusterId: '',
                    accountId: '',
                    managementToken: '',
                    databaseToken: '',
                    type: type,
                    version: version
                }
            });
        }, this.handleSubmitUrl = (url)=>this.detectServerType({
                url: url
            }), this.handleSubmitUsername = (username)=>this.detectServerType({
                username: username
            }), this.handleSubmitPassword = (password)=>this.detectServerType({
                password: password
            }), this.detectServerType = async (changedField)=>{
            const source = {
                ...this.state.source,
                ...changedField,
                insecureSkipVerify: true
            };
            const metaserviceURL = new URL(source.metaUrl || (0, $e10a8602f56394e3$export$b055de0e665cb20c).metaUrl);
            const sourceURL = new URL(source.url || (0, $e10a8602f56394e3$export$b055de0e665cb20c).url);
            if ($4385a65f5fcbb29e$var$isNewSource(source)) try {
                metaserviceURL.hostname = sourceURL.hostname;
                const { type: type } = await (0, $3bff70d0456af5c0$export$1921362e86c73c88)(source, {
                    dryRun: ''
                });
                this.setState({
                    source: {
                        ...this.state.source,
                        type: type,
                        metaUrl: metaserviceURL.href
                    }
                });
            } catch (err) {}
            else try {
                const { type: type } = await (0, $3bff70d0456af5c0$export$328b0edc9fda3a36)(source, {
                    dryRun: ''
                });
                this.setState({
                    source: {
                        ...this.state.source,
                        type: type
                    }
                });
            } catch (err) {}
        }, this.getServerTypeFromSource = (source)=>{
            if (source.type === (0, $e10a8602f56394e3$export$2b517738cc766db5) || source.type === (0, $e10a8602f56394e3$export$f19a85207251c5b9) || source.type === (0, $e10a8602f56394e3$export$a76eedc208d7b9c8) || source.type === (0, $e10a8602f56394e3$export$28e7e8206aa55fc2) || source.type === (0, $e10a8602f56394e3$export$8c103d68b966820a) || source.type === (0, $e10a8602f56394e3$export$211019da7a6116e6) || source.type === (0, $e10a8602f56394e3$export$bf23c8863b1b2fd1)) return source.type;
            if (source.type === (0, $e10a8602f56394e3$export$610a9003e7f2f0cb) || source.type === (0, $e10a8602f56394e3$export$56760039c086e0f7)) // Special v1 subtypes are displayed as v1
            return 0, $e10a8602f56394e3$export$2b517738cc766db5;
            return 0, $e10a8602f56394e3$export$2b517738cc766db5;
        }, this.handleServerTypeChange = (value)=>{
            switch(value){
                case 0, $e10a8602f56394e3$export$f19a85207251c5b9:
                    this.changeSourceType(value, '2.x');
                    break;
                case 0, $e10a8602f56394e3$export$a76eedc208d7b9c8:
                    this.changeSourceType(value, '3.x');
                    break;
                case 0, $e10a8602f56394e3$export$28e7e8206aa55fc2:
                    this.changeSourceType(value, '3.x');
                    break;
                case 0, $e10a8602f56394e3$export$8c103d68b966820a:
                    this.changeSourceType(value, '3.x');
                    break;
                case 0, $e10a8602f56394e3$export$211019da7a6116e6:
                    this.changeSourceType(value, 'cloud');
                    break;
                case 0, $e10a8602f56394e3$export$bf23c8863b1b2fd1:
                    this.changeSourceType(value, 'cloud');
                    break;
                case 0, $e10a8602f56394e3$export$2b517738cc766db5:
                default:
                    this.changeSourceType((0, $e10a8602f56394e3$export$2b517738cc766db5), '1.x');
            }
        };
        const source = this.props.source || (0, $e10a8602f56394e3$export$b055de0e665cb20c);
        this.state = {
            source: source,
            serverType: this.getServerTypeFromSource(source)
        };
    }
    render() {
        const { source: source, serverType: serverType } = this.state;
        const { isUsingAuth: isUsingAuth, onBoarding: onBoarding, env: env } = this.props;
        const isV3 = (0, $e10a8602f56394e3$export$8668fc04891bde79)(source);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, isUsingAuth && onBoarding && this.authIndicator, env.v3SupportEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $3ebee1ed3065f342$export$2e2bcd8739ae039), {
            label: "Server Type",
            placeholder: "Select Server Type",
            value: serverType,
            options: [
                {
                    value: (0, $e10a8602f56394e3$export$2b517738cc766db5),
                    label: 'InfluxDB v1'
                },
                {
                    value: (0, $e10a8602f56394e3$export$f19a85207251c5b9),
                    label: 'InfluxDB v2'
                },
                {
                    value: (0, $e10a8602f56394e3$export$a76eedc208d7b9c8),
                    label: 'InfluxDB 3 Core'
                },
                {
                    value: (0, $e10a8602f56394e3$export$28e7e8206aa55fc2),
                    label: 'InfluxDB 3 Enterprise'
                },
                {
                    value: (0, $e10a8602f56394e3$export$8c103d68b966820a),
                    label: 'InfluxDB Clustered'
                },
                {
                    value: (0, $e10a8602f56394e3$export$211019da7a6116e6),
                    label: 'InfluxDB Cloud Dedicated'
                },
                {
                    value: (0, $e10a8602f56394e3$export$bf23c8863b1b2fd1),
                    label: 'InfluxDB Cloud Serverless'
                }
            ],
            onChange: this.handleServerTypeChange,
            testId: "server-type-selector--dropdown"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b3da5d11e9cd3818$export$2e2bcd8739ae039), {
            value: source.url,
            label: "Connection URL",
            onChange: this.onChangeInput('url'),
            valueModifier: this.URLModifier,
            onSubmit: this.handleSubmitUrl,
            testId: "connection-url--input"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b3da5d11e9cd3818$export$2e2bcd8739ae039), {
            value: source.name,
            label: "Connection Name",
            onChange: this.onChangeInput('name'),
            testId: "connection-name--input"
        }), (serverType === (0, $e10a8602f56394e3$export$2b517738cc766db5) || serverType === (0, $e10a8602f56394e3$export$f19a85207251c5b9)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b3da5d11e9cd3818$export$2e2bcd8739ae039), {
            value: source.username,
            label: serverType === (0, $e10a8602f56394e3$export$f19a85207251c5b9) ? 'Organization' : 'Username',
            onChange: this.onChangeInput('username'),
            onSubmit: this.handleSubmitUsername,
            testId: "connection-username--input"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b3da5d11e9cd3818$export$2e2bcd8739ae039), {
            value: source.password,
            label: serverType === (0, $e10a8602f56394e3$export$f19a85207251c5b9) ? 'Token' : 'Password',
            placeholder: this.passwordPlaceholder,
            type: "password",
            onChange: this.onChangeInput('password'),
            onSubmit: this.handleSubmitPassword,
            testId: "connection-password--input"
        })), (serverType === (0, $e10a8602f56394e3$export$a76eedc208d7b9c8) || serverType === (0, $e10a8602f56394e3$export$28e7e8206aa55fc2) || serverType === (0, $e10a8602f56394e3$export$bf23c8863b1b2fd1)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b3da5d11e9cd3818$export$2e2bcd8739ae039), {
            value: source.databaseToken,
            label: 'Database Token',
            type: "password",
            onChange: this.onChangeInput('databaseToken')
        })), serverType === (0, $e10a8602f56394e3$export$8c103d68b966820a) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b3da5d11e9cd3818$export$2e2bcd8739ae039), {
            value: source.managementToken,
            label: 'Management Token',
            type: "password",
            onChange: this.onChangeInput('managementToken')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b3da5d11e9cd3818$export$2e2bcd8739ae039), {
            value: source.databaseToken,
            label: 'Database Token',
            type: "password",
            onChange: this.onChangeInput('databaseToken')
        })), serverType === (0, $e10a8602f56394e3$export$211019da7a6116e6) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b3da5d11e9cd3818$export$2e2bcd8739ae039), {
            value: source.clusterId,
            label: 'Cluster ID',
            onChange: this.onChangeInput('clusterId')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b3da5d11e9cd3818$export$2e2bcd8739ae039), {
            value: source.accountId,
            label: 'Account ID',
            onChange: this.onChangeInput('accountId')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b3da5d11e9cd3818$export$2e2bcd8739ae039), {
            value: source.managementToken,
            label: 'Management Token',
            type: "password",
            onChange: this.onChangeInput('managementToken')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b3da5d11e9cd3818$export$2e2bcd8739ae039), {
            value: source.databaseToken,
            label: 'Database Token',
            type: "password",
            onChange: this.onChangeInput('databaseToken')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b3da5d11e9cd3818$export$2e2bcd8739ae039), {
            value: source.tagsCSVPath,
            label: 'Tags CSV Directory Path',
            onChange: this.onChangeInput('tagsCSVPath')
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b3da5d11e9cd3818$export$2e2bcd8739ae039), {
            value: source.telegraf,
            label: "Telegraf Database Name",
            onChange: this.onChangeInput('telegraf')
        }), !isV3 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b3da5d11e9cd3818$export$2e2bcd8739ae039), {
            value: source.defaultRP,
            label: "Default Retention Policy",
            onChange: this.onChangeInput('defaultRP')
        }), (serverType === (0, $e10a8602f56394e3$export$211019da7a6116e6) || serverType === (0, $e10a8602f56394e3$export$8c103d68b966820a)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b3da5d11e9cd3818$export$2e2bcd8739ae039), {
            value: source.defaultDB,
            label: "Default Database",
            onChange: this.onChangeInput('defaultDB')
        }), this.isEnterprise && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b3da5d11e9cd3818$export$2e2bcd8739ae039), {
            value: source.metaUrl,
            label: "Meta Service Connection URL",
            onChange: this.onChangeInput('metaUrl'),
            testId: "meta-service-connection-url--input"
        }), !onBoarding && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $81ae7b856a4d886e$export$2e2bcd8739ae039), {
            halfWidth: true,
            isChecked: source.default,
            text: 'Default connection',
            onChange: this.onChangeInput('default'),
            testId: "default-connection--checkbox"
        }), !env.v3SupportEnabled && !isV3 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $81ae7b856a4d886e$export$2e2bcd8739ae039), {
            halfWidth: !onBoarding,
            isChecked: serverType === (0, $e10a8602f56394e3$export$f19a85207251c5b9),
            text: 'InfluxDB v2 Auth',
            onChange: this.changeAuth
        }), this.isHTTPS && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $81ae7b856a4d886e$export$2e2bcd8739ae039), {
            isChecked: source.insecureSkipVerify,
            text: `Unsafe SSL`,
            onChange: this.onChangeInput('insecureSkipVerify'),
            subtext: (0, $cb8c629075840449$export$97c9a2743dff7753),
            testId: "unsafe-ssl--checkbox"
        }));
    }
    get passwordPlaceholder() {
        const { source: source } = this.props;
        if (source && source.authentication === 'basic') return 'Value saved in server';
    }
    get authIndicator() {
        const { me: me } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "text-center"
        }, me.role === (0, $a7910b1002260d34$export$ccd9fcc6ec6e7386) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", null, "The organization", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("strong", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("i", null, me.currentOrganization.name)), ' ', "currently has no connections") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h3", null, "The organization", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("strong", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("i", null, me.currentOrganization.name)), ' ', "has no connections available to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("em", null, me.role, "s")));
    }
    get sourceIsEdited() {
        const sourceInProps = this.props.source;
        const sourceInState = this.state.source;
        return !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEqual(sourceInProps, sourceInState);
    }
    get isHTTPS() {
        const { source: source } = this.state;
        return (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(source, 'url', '').startsWith('https');
    }
    get isEnterprise() {
        const { source: source } = this.state;
        return source.type === (0, $e10a8602f56394e3$export$610a9003e7f2f0cb);
    }
}
const $4385a65f5fcbb29e$var$mstp = ({ env: env })=>({
        env: env
    });
const $4385a65f5fcbb29e$var$mdtp = {
    notify: (0, $205d139de2918454$export$5e14cdade93d6f7b),
    addSource: (0, $b73fb830e0a94a1d$export$bc333c64f07a75c4),
    updateSource: (0, $b73fb830e0a94a1d$export$328b0edc9fda3a36)
};
var $4385a65f5fcbb29e$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($4385a65f5fcbb29e$var$mstp, $4385a65f5fcbb29e$var$mdtp, null, {
    forwardRef: true
})((0, $855a64e5014f72b2$export$b648208ff1c161a7)($4385a65f5fcbb29e$var$SourceStep));


/* eslint-disable no-empty */ // Libraries

var $NdCUR = parcelRequire("NdCUR");


var $hBdgJ = parcelRequire("hBdgJ");


// Libraries

var $NdCUR = parcelRequire("NdCUR");





class $db2f29edea55b3c5$var$KapacitorForm extends (0, $NdCUR.PureComponent) {
    render() {
        const { kapacitor: kapacitor, onChangeInput: onChangeInput } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b3da5d11e9cd3818$export$2e2bcd8739ae039), {
            value: kapacitor.url,
            label: "Kapacitor URL",
            onChange: onChangeInput('url'),
            valueModifier: this.URLModifier
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b3da5d11e9cd3818$export$2e2bcd8739ae039), {
            value: kapacitor.name,
            label: "Name",
            onChange: onChangeInput('name')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b3da5d11e9cd3818$export$2e2bcd8739ae039), {
            value: kapacitor.username,
            label: "Username",
            onChange: onChangeInput('username')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b3da5d11e9cd3818$export$2e2bcd8739ae039), {
            value: kapacitor.password,
            label: "Password",
            type: "password",
            onChange: onChangeInput('password')
        }), this.isHTTPS && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $81ae7b856a4d886e$export$2e2bcd8739ae039), {
            isChecked: kapacitor.insecureSkipVerify,
            text: `Unsafe SSL`,
            onChange: onChangeInput('insecureSkipVerify'),
            subtext: (0, $cb8c629075840449$export$97c9a2743dff7753)
        }));
    }
    get isHTTPS() {
        const { kapacitor: kapacitor } = this.props;
        return (0, $38eb15bdc4f4caa2$export$cc083bb740ac7702)(kapacitor, 'url', '').startsWith('https');
    }
    constructor(...args){
        super(...args), this.URLModifier = (value)=>{
            const url = value.trim();
            if (url.startsWith('http')) return url;
            return `http://${url}`;
        };
    }
}
var $db2f29edea55b3c5$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($db2f29edea55b3c5$var$KapacitorForm);








const $ddae834a34df3aad$var$syncHostnames = (source, kapacitor)=>{
    try {
        // new URL(input) throws error if input is not a valid url.
        if (source && source.url) {
            const sourceURL = new URL(source.url);
            const kapacitorURL = new URL(kapacitor.url);
            if (sourceURL.hostname) {
                kapacitorURL.hostname = sourceURL.hostname;
                return {
                    ...kapacitor,
                    url: kapacitorURL.href
                };
            }
        }
    } catch (e) {}
    return kapacitor;
};
class $ddae834a34df3aad$var$KapacitorStep extends (0, $NdCUR.Component) {
    static{
        this.defaultProps = {
            onBoarding: false
        };
    }
    constructor(props){
        super(props), this.next = async ()=>{
            const { kapacitor: kapacitor } = this.state;
            const { notify: notify, source: source } = this.props;
            const kapacitorExists = kapacitor.id;
            if (kapacitorExists) {
                if (this.existingKapacitorHasChanged) try {
                    const { data: updatedKapacitor } = await (0, $3bff70d0456af5c0$export$aed6d6f44d1e4150)(kapacitor);
                    await this.fetchNewKapacitors();
                    await (0, $3bff70d0456af5c0$export$41af5c3435cc7908)(updatedKapacitor);
                    notify((0, $ec1f42de4faacc37$export$6b6bc939c8a37bfd)());
                    this.setState({
                        kapacitor: updatedKapacitor
                    });
                    return {
                        error: false,
                        payload: updatedKapacitor
                    };
                } catch (error) {
                    console.error(error);
                    notify((0, $ec1f42de4faacc37$export$d1d4e05f77d7d304)(kapacitor.name));
                    return {
                        error: true,
                        payload: null
                    };
                }
                return {
                    error: false,
                    payload: kapacitor
                };
            }
            try {
                const { data: newKapacitor } = await (0, $3bff70d0456af5c0$export$3223cd8da62dca03)(source, kapacitor);
                await this.fetchNewKapacitors();
                await (0, $3bff70d0456af5c0$export$41af5c3435cc7908)(newKapacitor);
                this.setState({
                    kapacitor: newKapacitor
                });
                notify((0, $ec1f42de4faacc37$export$76f6258963c60ebd)());
                return {
                    error: false,
                    payload: newKapacitor
                };
            } catch (error) {
                console.error(error);
                notify((0, $ec1f42de4faacc37$export$487f49b354cc796d)(kapacitor.name));
                return {
                    error: true,
                    payload: null
                };
            }
        }, this.onChangeInput = (key)=>(value)=>{
                const { setError: setError, setKapacitorDraft: setKapacitorDraft } = this.props;
                const { kapacitor: kapacitor } = this.state;
                this.setState({
                    kapacitor: {
                        ...kapacitor,
                        [key]: value
                    }
                }, ()=>{
                    if (setKapacitorDraft) setKapacitorDraft(this.state.kapacitor);
                });
                setError(false);
            }, this.handleSetActiveKapacitor = (kapacitor)=>{
            this.props.setActiveKapacitor(kapacitor);
            this.setState({
                kapacitor: kapacitor
            });
        }, this.resetDefault = ()=>{
            this.setState({
                kapacitor: (0, $e10a8602f56394e3$export$7b9591098a50d1e2)
            });
        }, this.fetchNewKapacitors = ()=>{
            const { source: source, sources: sources, fetchKapacitors: fetchKapacitors } = this.props;
            const storeSource = sources.find((s)=>s.id === source.id);
            fetchKapacitors(storeSource);
        };
        const activeKapacitor = (0, $9541f29439ffa68c$export$2e2bcd8739ae039)(props.source, props.sources) || props.kapacitor;
        let kapacitor = $ddae834a34df3aad$var$syncHostnames(props.source, (0, $e10a8602f56394e3$export$7b9591098a50d1e2));
        if (!props.showNewKapacitor && activeKapacitor) kapacitor = activeKapacitor;
        this.state = {
            kapacitor: kapacitor
        };
    }
    render() {
        const { onBoarding: onBoarding } = this.props;
        const { kapacitor: kapacitor } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, !onBoarding && this.kapacitorDropdown, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $db2f29edea55b3c5$export$2e2bcd8739ae039), {
            kapacitor: kapacitor,
            onChangeInput: this.onChangeInput
        }));
    }
    get existingKapacitorHasChanged() {
        const { source: source, sources: sources } = this.props;
        const { kapacitor: kapacitor } = this.state;
        const activeKapacitor = (0, $9541f29439ffa68c$export$2e2bcd8739ae039)(source, sources);
        return !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEqual(activeKapacitor, kapacitor);
    }
    get kapacitorDropdown() {
        const { kapacitor: kapacitor } = this.state;
        const { source: source, sources: sources, deleteKapacitor: deleteKapacitor } = this.props;
        if (source && sources) {
            const storeSource = sources.find((s)=>s.id === source.id);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                className: "kapacitor-step--dropdown col-xs-12"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                className: "form-group col-xs-6"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $35aab7e74efc8a1d$export$2e2bcd8739ae039), {
                suppressEdit: true,
                source: storeSource,
                kapacitors: storeSource.kapacitors,
                deleteKapacitor: deleteKapacitor,
                setActiveKapacitor: this.handleSetActiveKapacitor,
                buttonSize: "btn-sm",
                onAddNew: this.resetDefault,
                displayValue: !kapacitor.id && kapacitor.name
            })));
        }
        return;
    }
}
const $ddae834a34df3aad$var$mstp = ({ sources: sources })=>({
        sources: sources
    });
const $ddae834a34df3aad$var$mdtp = {
    notify: (0, $205d139de2918454$export$5e14cdade93d6f7b),
    setActiveKapacitor: $b73fb830e0a94a1d$export$7bafe015e336e80b,
    deleteKapacitor: $b73fb830e0a94a1d$export$4a7c8a5c76d44143,
    fetchKapacitors: $b73fb830e0a94a1d$export$ac5e5ccaf8abc797
};
var $ddae834a34df3aad$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($ddae834a34df3aad$var$mstp, $ddae834a34df3aad$var$mdtp, null, {
    forwardRef: true
})((0, $855a64e5014f72b2$export$b648208ff1c161a7)($ddae834a34df3aad$var$KapacitorStep));


// Libraries

var $NdCUR = parcelRequire("NdCUR");


var $hBdgJ = parcelRequire("hBdgJ");



const $8c3f3417ae7df4a0$export$fa9f4832fa5ceb4 = (input, searchTerm)=>input.toLowerCase().includes(searchTerm.toLowerCase());


// Libraries

var $hBdgJ = parcelRequire("hBdgJ");




async function $25aba5a54fc69e9c$var$getTelegrafBucketID(source) {
    // try to get bucket of the same name
    const v2BucketsPath = `/api/v2/buckets?org=${encodeURIComponent(source.username)}&name=${encodeURIComponent(source.telegraf)}`;
    try {
        const response = await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'GET',
            url: `${source.links.flux}?version=${encodeURIComponent(source.version)}&path=${encodeURIComponent(v2BucketsPath)}`,
            data: ''
        });
        if (response.status !== 200) return undefined;
        return response.data?.buckets?.[0]?.id;
    // eslint-disable-next-line no-empty
    } catch (e) {}
}
async function $25aba5a54fc69e9c$var$createDBRPMapping(source, bucketID) {
    // try to get bucket of the same name
    const body = {
        bucketID: bucketID,
        database: source.telegraf,
        retention_policy: source.defaultRP || 'autogen',
        default: true,
        org: source.username
    };
    try {
        const response = await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'POST',
            url: `${source.links.flux}?version=${encodeURIComponent(source.version)}&path=/api/v2/dbrps`,
            data: body,
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (response.status === 201 && response.data.id) return response.data;
        console.warn('Cannot create v1 DBRP mapping', response.data);
    } catch (e) {
        console.warn('Cannot create v1 DBRP mapping', e);
    }
}
async function $25aba5a54fc69e9c$export$a4bcc245608cae40(source) {
    if (!source.links?.flux || source.type !== (0, $e10a8602f56394e3$export$f19a85207251c5b9) || !source.telegraf) return;
    const bucketID = await $25aba5a54fc69e9c$var$getTelegrafBucketID(source);
    if (!bucketID) {
        console.warn(`Cannot verify existence of ${source.telegraf} bucket, v1 DBRP mapping cannot be created`);
        return;
    }
    // create DBRP mappings for bucket id
    return await $25aba5a54fc69e9c$var$createDBRPMapping(source, bucketID);
}


const $43eeeb95e86367e3$export$e8ca0f9d0e3135db = async (source, protoboards, afterCreatedDBRP = ()=>undefined)=>{
    const hosts = await $43eeeb95e86367e3$var$getHosts(source, afterCreatedDBRP);
    if (!hosts) return [];
    const newHosts = await $43eeeb95e86367e3$export$1bdcbedb0334af9f(source, hosts, protoboards);
    const suggestedProtoboards = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).reduce(newHosts, (acc, host)=>{
        if (host.apps && host.apps.length) return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).union(acc, host.apps);
        return acc;
    }, []);
    return suggestedProtoboards;
};
const $43eeeb95e86367e3$export$1bdcbedb0334af9f = async (source, hosts, protoboards)=>{
    const measurementsList = [];
    const measurementsToProtoboards = {};
    (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).forEach(protoboards, (pb)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).forEach(pb.meta.measurements, (m)=>{
            measurementsToProtoboards[m] = pb.meta.name;
            measurementsList.push(m);
        });
    });
    const joinedMeasurements = measurementsList.join('|');
    const newHosts = {
        ...hosts
    };
    const allSeries = await $43eeeb95e86367e3$var$getAllSeries(source, joinedMeasurements);
    allSeries.forEach((series)=>{
        const { measurement: measurement, host: host } = $43eeeb95e86367e3$var$parseSeries(series);
        if (!newHosts[host]) return;
        const existingApps = newHosts[host].apps || [];
        newHosts[host].apps = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).uniq([
            ...existingApps,
            measurementsToProtoboards[measurement]
        ]);
    });
    return newHosts;
};
const $43eeeb95e86367e3$var$getHosts = async (source, afterCreatedDBRP)=>{
    const hosts = {};
    const query = `SHOW TAG VALUES WITH KEY = "host" WHERE TIME > now() - 10m;`;
    let resp = await (0, $aea829e093f1eddb$export$923f96dd5afa9ce6)({
        source: source.links.proxy,
        query: query,
        db: source.telegraf
    });
    const loadError = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(resp, [
        'data',
        'results',
        '0',
        'error'
    ]);
    if (loadError) {
        console.warn('Cannot suggest protoboards:', loadError);
        if (source.type === (0, $e10a8602f56394e3$export$f19a85207251c5b9)) {
            // try to create DBRP mapping for ${source.telegraf} bucket
            const dbrp = await (0, $25aba5a54fc69e9c$export$a4bcc245608cae40)(source);
            if (dbrp) {
                if (afterCreatedDBRP) afterCreatedDBRP(dbrp);
                // reload query
                resp = await (0, $aea829e093f1eddb$export$923f96dd5afa9ce6)({
                    source: source.links.proxy,
                    query: query,
                    db: source.telegraf
                });
            }
        }
    }
    const allHostsSeries = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(resp, [
        'data',
        'results',
        '0',
        'series'
    ], []);
    allHostsSeries.forEach((s)=>{
        const hostnameIndex = s.columns.findIndex((col)=>col === 'value');
        s.values.forEach((v)=>{
            const hostname = v[hostnameIndex];
            hosts[hostname] = {};
        });
    });
    return hosts;
};
const $43eeeb95e86367e3$var$getAllSeries = async (source, joinedMeasurements)=>{
    const resp = await (0, $aea829e093f1eddb$export$923f96dd5afa9ce6)({
        source: source.links.proxy,
        query: `show series from /${joinedMeasurements}/ where time > now() - 10m`,
        db: source.telegraf
    });
    const allSeries = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).flatten((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(resp, [
        'data',
        'results',
        '0',
        'series',
        '0',
        'values'
    ], []));
    return allSeries;
};
const $43eeeb95e86367e3$var$parseSeries = (series)=>{
    let workingString = series.slice();
    const parseMeasurementResult = $43eeeb95e86367e3$var$parseMeasurement(workingString);
    workingString = parseMeasurementResult.workingString;
    const measurement = parseMeasurementResult.measurement;
    let host = '';
    while(workingString.length){
        const parseHostResult = $43eeeb95e86367e3$var$parseHost(workingString);
        workingString = parseHostResult.workingString;
        if (parseHostResult.host) host = parseHostResult.host;
    }
    return {
        measurement: measurement,
        host: host
    };
};
const $43eeeb95e86367e3$var$parseMeasurement = (s)=>{
    const word = /\w+/;
    const match = word.exec(s);
    const measurement = match[0];
    const workingString = s.slice(match.index + measurement.length);
    return {
        workingString: workingString,
        measurement: measurement
    };
};
const $43eeeb95e86367e3$var$parseHost = (s)=>{
    const tag = /,?([^=]+)=([^,]+)/;
    const match = tag.exec(s);
    let host = '';
    let workingString = '';
    if (match) {
        const kv = match[0];
        const key = match[1];
        const value = match[2];
        if (key === 'host') host = value;
        workingString = s.slice(match.index + kv.length);
    }
    return {
        workingString: workingString,
        host: host
    };
};


// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");

class $42196ee68bb1dbef$var$GridSizer extends (0, $NdCUR.PureComponent) {
    static{
        this.defaultProps = {
            cellWidth: 150,
            width: null
        };
    }
    constructor(props){
        super(props), this.listener = ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).debounce(()=>this.setColumns(this.getWidth()), 250);
        }, this.getWidth = ()=>{
            const ele = document.getElementById('grid_sizer');
            const computedWidth = window.getComputedStyle(ele, null).getPropertyValue('width');
            const widthValue = Number(computedWidth.substring(0, computedWidth.length - 2));
            return widthValue;
        }, this.setColumns = (width)=>{
            const { cellWidth: cellWidth } = this.props;
            const columns = Math.round(width / cellWidth);
            this.setState({
                columns: columns
            });
        };
        this.state = {
            columns: null
        };
    }
    componentDidMount() {
        const { width: width } = this.props;
        const widthValue = width || this.getWidth();
        this.setColumns(widthValue);
        if (!width) window.addEventListener('resize', this.listener, false);
    }
    componentDidUpdate() {
        const { width: width } = this.props;
        if (width) this.setColumns(width);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.listener, false);
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            id: "grid_sizer",
            className: "grid-sizer"
        }, this.sizeChildren);
    }
    get sizeChildren() {
        const { columns: columns } = this.state;
        const { children: children } = this.props;
        if (columns) {
            const wrappedChildren = children.map((child, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                    key: `grid_cell_${i}`,
                    className: `grid-sizer--cell grid-sizer--col-${columns}`
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                    className: "grid-sizer--content"
                }, child)));
            return wrappedChildren;
        }
        return children;
    }
}
var $42196ee68bb1dbef$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($42196ee68bb1dbef$var$GridSizer);


// Libraries

var $NdCUR = parcelRequire("NdCUR");

var $1v7mg = parcelRequire("1v7mg");

// Libraries

var $NdCUR = parcelRequire("NdCUR");
class $68a6a3aeced83146$var$ProtoboardIcon extends (0, $NdCUR.PureComponent) {
    static{
        this.defaultProps = {
            displayText: ''
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "protoboard-icon"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("svg", {
            version: "1.1",
            id: "protoboard_icon",
            x: "0px",
            y: "0px",
            viewBox: "0 0 80 65",
            width: "80px",
            height: "65px"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("rect", {
            className: "protoboard-icon--shape",
            x: "2",
            y: "6",
            width: "32",
            height: "28",
            rx: "2",
            ry: "2"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("rect", {
            className: "protoboard-icon--shape",
            x: "40",
            y: "6",
            width: "38",
            height: "9",
            rx: "2",
            ry: "2"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("rect", {
            className: "protoboard-icon--shape",
            x: "2",
            y: "41",
            width: "32",
            height: "21",
            rx: "2",
            ry: "2"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("rect", {
            className: "protoboard-icon--text-shape",
            x: "40",
            y: "22",
            width: "38",
            height: "40",
            rx: "2",
            ry: "2"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("text", {
            transform: "matrix(1 0 0 1 59 57)",
            textAnchor: "middle",
            className: "protoboard-icon--text"
        }, this.displayInitial)));
    }
    get displayInitial() {
        const { displayText: displayText } = this.props;
        return displayText.substring(0, 1).toUpperCase();
    }
}
var $68a6a3aeced83146$export$2e2bcd8739ae039 = $68a6a3aeced83146$var$ProtoboardIcon;


class $1c723ee051d0fa57$var$CardSelectCard extends (0, $NdCUR.PureComponent) {
    static{
        this.defaultProps = {
            checked: false,
            disabled: false
        };
    }
    render() {
        const { id: id, label: label, checked: checked, name: name, disabled: disabled } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            "data-toggle": "card_toggle",
            onClick: this.handleClick,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('card-select--card', {
                'card-select--checked': checked,
                'card-select--disabled': disabled,
                'card-select--active': !disabled
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("label", {
            className: "card-select--container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            id: `card_select_${id}`,
            name: name,
            type: "checkbox",
            value: id,
            defaultChecked: checked,
            disabled: disabled
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('card-select--checkmark', 'icon', 'checkmark', {
                'card-select--checked': checked
            })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "card-select--image"
        }, this.cardImage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "card-select--label"
        }, label)));
    }
    get cardImage() {
        const { image: image, label: label } = this.props;
        if (image) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("img", {
            src: image,
            alt: `${label} icon`
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $68a6a3aeced83146$export$2e2bcd8739ae039), {
            displayText: label
        });
    }
    constructor(...args){
        super(...args), this.handleClick = (e)=>{
            const { onClick: onClick, disabled: disabled } = this.props;
            e.preventDefault();
            if (!disabled) onClick();
        };
    }
}
var $1c723ee051d0fa57$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($1c723ee051d0fa57$var$CardSelectCard);







class $abdb0dd586b260a3$var$DashboardStep extends (0, $NdCUR.Component) {
    constructor(props){
        super(props), this.next = async ()=>{
            const { selected: selected, protoboards: protoboards } = this.state;
            const { dashboardsCreated: dashboardsCreated, notify: notify, source: source } = this.props;
            const selectedProtoboards = protoboards.filter((p)=>selected[p.id]);
            const newSelectedProtoboards = protoboards.filter((p)=>selected[p.id] && !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).find(dashboardsCreated, (d)=>{
                    return d.id === p.id;
                }));
            const countNew = newSelectedProtoboards.length;
            try {
                newSelectedProtoboards.forEach((p)=>{
                    (0, $2adafb01fdaabc72$export$3d4a4db1f9a4ff4c)(p, source);
                });
                if (countNew > 0) notify((0, $ec1f42de4faacc37$export$d09415c64d64264a)(countNew));
                return {
                    error: false,
                    payload: selectedProtoboards
                };
            } catch (err) {
                notify((0, $ec1f42de4faacc37$export$eeb98aa1ba59dfcc)(countNew));
                return {
                    error: true,
                    payload: dashboardsCreated
                };
            }
        }, this.setSearchTerm = (searchTerm)=>{
            this.setState({
                searchTerm: searchTerm
            });
        }, this.handleSuggest = async ()=>{
            const { protoboards: protoboards } = this.state;
            const { source: source, notify: notify } = this.props;
            if (source) {
                if (this.isComponentMounted) this.setState({
                    fetchingSuggested: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading
                });
                try {
                    const suggestedProtoboardsList = await (0, $43eeeb95e86367e3$export$e8ca0f9d0e3135db)(source, protoboards, (dbrp)=>{
                        notify((0, $ec1f42de4faacc37$export$12b4d85bb93671c5)(source.telegraf, dbrp.database, dbrp.retention_policy));
                    });
                    if (suggestedProtoboardsList.length === 0) {
                        if (this.isComponentMounted) this.setState({
                            fetchingSuggested: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done
                        });
                        return;
                    }
                    const suggestedProtoboards = protoboards.filter((p)=>suggestedProtoboardsList.includes(p.meta.name));
                    if (this.isComponentMounted) this.setState({
                        suggestedProtoboards: suggestedProtoboards,
                        fetchingSuggested: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done
                    });
                } catch (err) {
                    this.setState({
                        fetchingSuggested: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error
                    });
                }
            }
        }, this.toggleChecked = (id)=>()=>{
                const { selected: selected } = this.state;
                const { dashboardsCreated: dashboardsCreated } = this.props;
                const newSelected = selected;
                const dashboardAlreadyCreated = dashboardsCreated.find((d)=>d.id === id);
                if (!dashboardAlreadyCreated) {
                    if (selected[id]) newSelected[id] = false;
                    else newSelected[id] = true;
                    this.setState({
                        selected: newSelected
                    }, this.countSelectedDashboards);
                }
            }, this.countSelectedDashboards = ()=>{
            const { countSelected: countSelected } = this.props;
            const { selected: selected } = this.state;
            const selectedDashboards = (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).filter(selected, (v)=>v === true).length;
            countSelected(selectedDashboards);
        };
        this.state = {
            selected: this.selected,
            protoboards: [],
            searchTerm: '',
            suggestedProtoboards: [],
            fetchingProtoboards: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).NotStarted,
            fetchingSuggested: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).NotStarted
        };
    }
    async componentDidMount() {
        this.isComponentMounted = true;
        this.setState({
            fetchingProtoboards: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading
        });
        try {
            const protoboards = await (0, $bb4988507d545d48$export$b12ddf621b40b921)();
            if (this.isComponentMounted) {
                this.setState({
                    protoboards: protoboards,
                    fetchingProtoboards: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done
                });
                this.handleSuggest();
            }
        } catch (err) {
            if (this.isComponentMounted) this.setState({
                fetchingProtoboards: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error
            });
        }
    }
    componentWillUnmount() {
        this.isComponentMounted = false;
    }
    render() {
        const { protoboards: protoboards, fetchingProtoboards: fetchingProtoboards } = this.state;
        if (fetchingProtoboards === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $810ad5a94daa03b8$export$2e2bcd8739ae039), null);
        if (protoboards && protoboards.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "dashboard-step"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "dashboard-step--filter-controls"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $23c724436dc30b29$export$2e2bcd8739ae039), {
            placeholder: "Filter by name...",
            onSearch: this.setSearchTerm,
            testId: "filter-dashboards--input"
        })), this.suggestedDashboardCards, this.dashboardCards);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null);
    }
    get selected() {
        return this.props.dashboardsCreated.reduce((acc, d)=>({
                ...acc,
                [d.id]: true
            }), {});
    }
    get dashboardCards() {
        const { selected: selected, protoboards: protoboards, suggestedProtoboards: suggestedProtoboards, searchTerm: searchTerm } = this.state;
        const filteredProtoboards = protoboards.filter((pb)=>(0, $8c3f3417ae7df4a0$export$fa9f4832fa5ceb4)(pb.meta.name, searchTerm) && !suggestedProtoboards.find((spb)=>spb.id === pb.id));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $42196ee68bb1dbef$export$2e2bcd8739ae039), null, filteredProtoboards.map((protoboard, i)=>{
            const { meta: meta, id: id } = protoboard;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1c723ee051d0fa57$export$2e2bcd8739ae039), {
                key: `${id}_${i}`,
                id: id,
                name: meta.name,
                label: meta.name,
                checked: selected[id],
                onClick: this.toggleChecked(id)
            });
        })));
    }
    get suggestedDashboardCards() {
        const { selected: selected, suggestedProtoboards: suggestedProtoboards, searchTerm: searchTerm, fetchingSuggested: fetchingSuggested } = this.state;
        if (fetchingSuggested === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "dashboard-step--loading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $810ad5a94daa03b8$export$2e2bcd8739ae039), null));
        const filteredProtoboards = suggestedProtoboards.filter((pb)=>(0, $8c3f3417ae7df4a0$export$fa9f4832fa5ceb4)(pb.meta.name, searchTerm));
        if (filteredProtoboards.length === 0) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "suggestion-text"
        }, "Suggested Dashboards for your Source:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $42196ee68bb1dbef$export$2e2bcd8739ae039), null, filteredProtoboards.map((protoboard, i)=>{
            const { meta: meta, id: id } = protoboard;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1c723ee051d0fa57$export$2e2bcd8739ae039), {
                key: `${id}_${i}`,
                id: id,
                name: meta.name,
                label: meta.name,
                checked: selected[id],
                onClick: this.toggleChecked(id)
            });
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "suggestion-text"
        }, "Other Dashboards:"));
    }
}
const $abdb0dd586b260a3$var$mdtp = {
    notify: (0, $205d139de2918454$export$5e14cdade93d6f7b)
};
var $abdb0dd586b260a3$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)(null, $abdb0dd586b260a3$var$mdtp, null, {
    forwardRef: true
})((0, $855a64e5014f72b2$export$b648208ff1c161a7)($abdb0dd586b260a3$var$DashboardStep));


// Libraries

var $NdCUR = parcelRequire("NdCUR");



class $96c115fa992ddc92$var$CompletionStep extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.next = async ()=>{
        // navigate to newly created source?
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "wizard-step--bookend"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "auth-logo"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, "You have successfully configured your connection"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, "Continue to view your connections"));
    }
}
const $96c115fa992ddc92$var$mdtp = {
    notify: (0, $205d139de2918454$export$5e14cdade93d6f7b)
};
var $96c115fa992ddc92$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)(null, $96c115fa992ddc92$var$mdtp, null, {
    forwardRef: true
})((0, $855a64e5014f72b2$export$b648208ff1c161a7)($96c115fa992ddc92$var$CompletionStep));


class $381b355aed80361b$var$ConnectionWizard extends (0, $NdCUR.PureComponent) {
    static getDerivedStateFromProps(props, state) {
        const sourceInState = state.source;
        const sourceInProps = props.source;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isNull(sourceInState) && !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isNull(sourceInProps)) return {
            source: sourceInProps
        };
        return null;
    }
    constructor(props){
        super(props), // SourceStep
        this.isSourceComplete = ()=>{
            const { source: source } = this.state;
            return !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isNull(source);
        }, this.handleSourceNext = async ()=>{
            const response = await this.sourceStepRef.next();
            this.setState({
                source: response.payload,
                sourceError: response.error
            });
            return response;
        }, this.handleSetSourceError = (b)=>{
            if (this.state.sourceError !== b) this.setState({
                sourceError: b
            });
        }, // DashboardStep
        this.isDashboardComplete = ()=>{
            const { hasNextOnDashboard: hasNextOnDashboard } = this.state;
            return hasNextOnDashboard;
        }, this.handleDashboardNext = async ()=>{
            const response = await this.dashboardStepRef.next();
            this.setState({
                dashboardError: response.error,
                dashboardsCreated: response.payload,
                hasNextOnDashboard: true
            });
            return response;
        }, this.countSelected = (selectedDashboards)=>{
            this.setState({
                selectedDashboards: selectedDashboards
            });
        }, // KapacitorStep
        this.isKapacitorComplete = ()=>{
            const { kapacitor: kapacitor } = this.state;
            return !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isNull(kapacitor);
        }, this.handleKapacitorNext = async ()=>{
            const response = await this.kapacitorStepRef.next();
            this.setState({
                kapacitor: response.payload,
                kapacitorError: response.error
            });
            return response;
        }, this.setKapacitorDraft = (kapacitor)=>{
            this.setState({
                kapacitor: kapacitor
            });
        }, this.handleKapacitorPrev = ()=>{}, this.handleSetKapacitorError = (b)=>{
            if (this.state.kapacitorError !== b) this.setState({
                kapacitorError: b
            });
        }, // CompletionStep
        this.isCompletionComplete = ()=>{
            return false;
        }, this.handleCompletionNext = ()=>{
            const { router: router } = this.props;
            const { source: source } = this.state;
            this.resetWizardState();
            if (this.isSourceEdited) router.push(`/sources/${source.id}/manage-sources`);
            return {
                error: false,
                payload: null
            };
        }, this.handleCompletionPrev = ()=>{}, this.resetWizardState = ()=>{
            this.setState({
                source: null,
                kapacitor: null,
                sourceError: false,
                kapacitorError: false,
                dashboardError: false,
                dashboardsCreated: [],
                hasNextOnDashboard: false
            });
        };
        this.state = {
            source: null,
            kapacitor: null,
            sourceError: false,
            kapacitorError: false,
            dashboardError: false,
            dashboardsCreated: [],
            hasNextOnDashboard: false,
            selectedDashboards: 0
        };
    }
    render() {
        const { isVisible: isVisible, toggleVisibility: toggleVisibility, jumpStep: jumpStep, showNewKapacitor: showNewKapacitor } = this.props;
        const { source: source, sourceError: sourceError, kapacitor: kapacitor, kapacitorError: kapacitorError, dashboardError: dashboardError, dashboardsCreated: dashboardsCreated } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $606a8ffac69c39b8$export$2e2bcd8739ae039), {
            visible: isVisible,
            toggleVisibility: toggleVisibility,
            resetWizardState: this.resetWizardState,
            title: "Connection Configuration",
            maxWidth: 800,
            jumpStep: jumpStep,
            isJumpingAllowed: this.isSourceComplete()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $897f9eefb239aa01$export$2e2bcd8739ae039), {
            title: "InfluxDB Connection",
            tipText: "",
            isComplete: this.isSourceComplete,
            isErrored: sourceError,
            isSkippableStep: false,
            onNext: this.handleSourceNext,
            nextLabel: source ? 'Update Connection' : 'Add Connection',
            previousLabel: "Cancel"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $4385a65f5fcbb29e$export$2e2bcd8739ae039), {
            ref: (c)=>this.sourceStepRef = c,
            setError: this.handleSetSourceError,
            source: source
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $897f9eefb239aa01$export$2e2bcd8739ae039), {
            title: "Dashboards",
            tipText: "Select Dashboards you would like to create:",
            isComplete: this.isDashboardComplete,
            isSkippableStep: false,
            isErrored: dashboardError,
            nextLabel: this.dashboardNextLabel,
            onNext: this.handleDashboardNext,
            previousLabel: "Go Back"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $abdb0dd586b260a3$export$2e2bcd8739ae039), {
            ref: (c)=>this.dashboardStepRef = c,
            source: source,
            dashboardsCreated: dashboardsCreated,
            countSelected: this.countSelected
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $897f9eefb239aa01$export$2e2bcd8739ae039), {
            title: "Kapacitor Connection",
            tipText: "",
            isComplete: this.isKapacitorComplete,
            isSkippableStep: true,
            isErrored: kapacitorError,
            onNext: this.handleKapacitorNext,
            onPrevious: this.handleKapacitorPrev,
            nextLabel: "Continue",
            previousLabel: "Go Back"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ddae834a34df3aad$export$2e2bcd8739ae039), {
            ref: (c)=>this.kapacitorStepRef = c,
            source: source,
            setError: this.handleSetKapacitorError,
            kapacitor: kapacitor,
            showNewKapacitor: showNewKapacitor,
            setKapacitorDraft: this.setKapacitorDraft
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $897f9eefb239aa01$export$2e2bcd8739ae039), {
            title: "Setup Complete",
            tipText: "",
            isComplete: this.isCompletionComplete,
            isSkippableStep: false,
            isErrored: false,
            onNext: this.handleCompletionNext,
            onPrevious: this.handleCompletionPrev,
            nextLabel: "Finish",
            previousLabel: "Go Back"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $96c115fa992ddc92$export$2e2bcd8739ae039), {
            ref: (c)=>this.completionStepRef = c
        })));
    }
    get isSourceEdited() {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEqual(this.state.source, this.props.source);
    }
    get dashboardNextLabel() {
        const { selectedDashboards: selectedDashboards } = this.state;
        if (selectedDashboards) return `Create ${selectedDashboards} Dashboard${selectedDashboards > 1 ? 's' : ''}`;
        return 'Next';
    }
}
var $381b355aed80361b$export$2e2bcd8739ae039 = (0, $dffbdf89c590a961$export$2e2bcd8739ae039)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($381b355aed80361b$var$ConnectionWizard));




class $7d93b65e95a1bc86$var$ManageSources extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleDeleteSource = (source)=>{
            const { notify: notify } = this.props;
            try {
                this.props.removeAndLoadSources(source);
                notify((0, $ec1f42de4faacc37$export$bb23f64e781656ef)(source.name));
            } catch (e) {
                notify((0, $ec1f42de4faacc37$export$5b2aebe776f68ed)(source.name));
            }
        }, this.fetchKapacitors = ()=>{
            this.props.sources.forEach((source)=>{
                this.props.fetchKapacitors(source);
            });
        }, this.toggleWizard = (isVisible, source = null, jumpStep = null, showNewKapacitor = null)=>()=>{
                if (!isVisible) this.fetchKapacitors();
                this.setState({
                    wizardVisibility: isVisible,
                    sourceInWizard: source,
                    jumpStep: jumpStep,
                    showNewKapacitor: showNewKapacitor
                });
            }, this.handleSetActiveKapacitor = (kapacitor)=>{
            this.props.setActiveKapacitor(kapacitor);
        };
        this.state = {
            wizardVisibility: false,
            sourceInWizard: null,
            jumpStep: null,
            showNewKapacitor: null
        };
    }
    componentDidMount() {
        this.fetchKapacitors();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.sources.length !== this.props.sources.length) this.props.sources.forEach((source)=>{
            this.props.fetchKapacitors(source);
        });
    }
    render() {
        const { sources: sources, source: source, deleteKapacitor: deleteKapacitor } = this.props;
        const { wizardVisibility: wizardVisibility, sourceInWizard: sourceInWizard, jumpStep: jumpStep, showNewKapacitor: showNewKapacitor } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header.Left, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Title, {
            title: "Configuration"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header.Right, {
            showSourceIndicator: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Contents, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $eccbf29120012148$export$2e2bcd8739ae039), {
            source: source,
            sources: sources,
            deleteKapacitor: deleteKapacitor,
            onDeleteSource: this.handleDeleteSource,
            setActiveKapacitor: this.handleSetActiveKapacitor,
            toggleWizard: this.toggleWizard
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", {
            className: "version-number"
        }, "Chronograf Version: ", (0, $e10a8602f56394e3$export$a4ad2735b021c132))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $381b355aed80361b$export$2e2bcd8739ae039), {
            isVisible: wizardVisibility,
            toggleVisibility: this.toggleWizard,
            source: sourceInWizard,
            jumpStep: jumpStep,
            showNewKapacitor: showNewKapacitor
        }));
    }
}
const $7d93b65e95a1bc86$var$mstp = ({ sources: sources })=>({
        sources: sources
    });
const $7d93b65e95a1bc86$var$mdtp = {
    notify: (0, $205d139de2918454$export$5e14cdade93d6f7b),
    removeAndLoadSources: $b73fb830e0a94a1d$export$2bb09a8b12c55257,
    fetchKapacitors: $b73fb830e0a94a1d$export$c18bacb24d8f6935,
    setActiveKapacitor: $b73fb830e0a94a1d$export$7bafe015e336e80b,
    deleteKapacitor: $b73fb830e0a94a1d$export$4a7c8a5c76d44143
};
var $7d93b65e95a1bc86$export$2e2bcd8739ae039 = (0, $c8cd79e362cba2a4$export$a520fb22fccea800)((0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($7d93b65e95a1bc86$var$mstp, $7d93b65e95a1bc86$var$mdtp)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($7d93b65e95a1bc86$var$ManageSources)));



var $NdCUR = parcelRequire("NdCUR");



var $hBdgJ = parcelRequire("hBdgJ");
// Libraries

var $NdCUR = parcelRequire("NdCUR");


class $0d7d37398b07c4bd$var$WizardFullScreen extends (0, $NdCUR.PureComponent) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "wizard-splash auth-image"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "wizard-container"
        }, this.WizardController), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", {
            className: "auth-credits"
        }, "Powered by ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon cubo-uniform"
        }), " InfluxData"));
    }
    get WizardController() {
        const { children: children, skipLinkText: skipLinkText, handleSwitch: handleSwitch, switchLinkText: switchLinkText, isUsingAuth: isUsingAuth, isJumpingAllowed: isJumpingAllowed } = this.props;
        if (children) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $575882ef096e7857$export$2e2bcd8739ae039), {
            skipLinkText: skipLinkText,
            handleSwitch: handleSwitch,
            switchLinkText: switchLinkText,
            isUsingAuth: isUsingAuth,
            jumpStep: 0,
            isJumpingAllowed: isJumpingAllowed
        }, children);
        return null;
    }
}
var $0d7d37398b07c4bd$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($0d7d37398b07c4bd$var$WizardFullScreen);






// Libraries

var $NdCUR = parcelRequire("NdCUR");



class $998a461b1471c814$var$SourceStep extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.next = async ()=>{
        // navigate to newly created source?
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "wizard-step--bookend"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "auth-logo"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h1", null, "Welcome to Chronograf"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, "Start using Chronograf in a few easy steps"));
    }
}
const $998a461b1471c814$var$mdtp = {
    notify: (0, $205d139de2918454$export$5e14cdade93d6f7b)
};
var $998a461b1471c814$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)(null, $998a461b1471c814$var$mdtp, null, {
    forwardRef: true
})((0, $855a64e5014f72b2$export$b648208ff1c161a7)($998a461b1471c814$var$SourceStep));





class $b0c12c1b94dfc089$var$OnboardingWizard extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), // WelcomeStep
        this.isWelcomeComplete = ()=>{
            return true;
        }, // SourceStep
        this.isSourceComplete = ()=>{
            const { source: source } = this.state;
            return !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isNull(source);
        }, this.handleSourceNext = async ()=>{
            const response = await this.sourceStepRef.next();
            this.setState({
                source: response.payload,
                sourceError: response.error
            });
            return response;
        }, this.handleSetSourceError = (b)=>{
            if (this.state.sourceError !== b) this.setState({
                sourceError: b
            });
        }, // DashboardStep
        this.isDashboardComplete = ()=>{
            const { hasNextOnDashboard: hasNextOnDashboard } = this.state;
            return hasNextOnDashboard;
        }, this.handleDashboardNext = async ()=>{
            const response = await this.dashboardStepRef.next();
            this.setState({
                dashboardError: response.error,
                dashboardsCreated: response.payload,
                hasNextOnDashboard: true
            });
            return response;
        }, this.countSelected = (selectedDashboards)=>{
            this.setState({
                selectedDashboards: selectedDashboards
            });
        }, // KapacitorStep
        this.isKapacitorComplete = ()=>{
            const { kapacitor: kapacitor } = this.state;
            return !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isNull(kapacitor);
        }, this.handleKapacitorNext = async ()=>{
            const response = await this.kapacitorStepRef.next();
            this.setState({
                kapacitor: response.payload
            });
            return response;
        }, this.handleKapacitorPrev = ()=>{}, this.handleSetKapacitorError = (b)=>{
            if (this.state.kapacitorError !== b) this.setState({
                kapacitorError: b
            });
        }, // CompletionStep
        this.isCompletionComplete = ()=>{
            return false;
        }, this.handleCompletionNext = ()=>{
            const { router: router } = this.props;
            const { source: source } = this.state;
            this.resetWizardState();
            if (source) router.push(`/sources/${source.id}/manage-sources`);
            else router.push(`/`);
            return {
                error: false,
                payload: null
            };
        }, this.handleCompletionPrev = ()=>{}, this.resetWizardState = ()=>{
            this.setState({
                source: null,
                kapacitor: null,
                sourceError: false,
                kapacitorError: false,
                dashboardError: false,
                dashboardsCreated: [],
                hasNextOnDashboard: false
            });
        }, this.resetAndGotoPurgatory = ()=>{
            const { router: router } = this.props;
            this.resetWizardState();
            router.push('/purgatory');
        };
        this.state = {
            source: null,
            sourceError: false,
            kapacitor: null,
            kapacitorError: false,
            dashboardError: false,
            dashboardsCreated: [],
            hasNextOnDashboard: false,
            selectedDashboards: 0
        };
    }
    render() {
        const { source: source, sourceError: sourceError, kapacitorError: kapacitorError, dashboardError: dashboardError, dashboardsCreated: dashboardsCreated } = this.state;
        const { me: me, isUsingAuth: isUsingAuth } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $6c7f63564a51019c$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $0d7d37398b07c4bd$export$2e2bcd8739ae039), {
            skipLinkText: "Skip",
            switchLinkText: "Switch Organizations",
            handleSwitch: this.resetAndGotoPurgatory,
            isUsingAuth: isUsingAuth,
            isJumpingAllowed: this.isSourceComplete()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $897f9eefb239aa01$export$2e2bcd8739ae039), {
            title: "Welcome",
            isComplete: this.isWelcomeComplete,
            isErrored: false,
            nextLabel: "Get Started",
            isSkippableStep: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $998a461b1471c814$export$2e2bcd8739ae039), {
            ref: (c)=>this.welcomeStepRef = c
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $897f9eefb239aa01$export$2e2bcd8739ae039), {
            title: "InfluxDB Connection",
            tipText: "",
            isComplete: this.isSourceComplete,
            isErrored: sourceError,
            isSkippableStep: false,
            onNext: this.handleSourceNext,
            nextLabel: source ? 'Update Connection' : 'Add Connection',
            previousLabel: "Go Back",
            onPrevious: this.handleKapacitorPrev
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $4385a65f5fcbb29e$export$2e2bcd8739ae039), {
            ref: (c)=>this.sourceStepRef = c,
            setError: this.handleSetSourceError,
            source: source,
            onBoarding: true,
            me: me,
            isUsingAuth: isUsingAuth
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $897f9eefb239aa01$export$2e2bcd8739ae039), {
            title: "Dashboards",
            tipText: "Select dashboards you would like to create:",
            isComplete: this.isDashboardComplete,
            isErrored: dashboardError,
            nextLabel: this.dashboardNextLabel,
            onNext: this.handleDashboardNext,
            previousLabel: "Go Back"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $abdb0dd586b260a3$export$2e2bcd8739ae039), {
            source: source,
            countSelected: this.countSelected,
            dashboardsCreated: dashboardsCreated,
            ref: (c)=>this.dashboardStepRef = c
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $897f9eefb239aa01$export$2e2bcd8739ae039), {
            title: "Kapacitor Connection",
            tipText: "",
            isComplete: this.isKapacitorComplete,
            isErrored: kapacitorError,
            onNext: this.handleKapacitorNext,
            onPrevious: this.handleKapacitorPrev,
            nextLabel: "Continue",
            previousLabel: "Go Back"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ddae834a34df3aad$export$2e2bcd8739ae039), {
            ref: (c)=>this.kapacitorStepRef = c,
            setError: this.handleSetKapacitorError,
            source: source,
            onBoarding: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $897f9eefb239aa01$export$2e2bcd8739ae039), {
            title: "Setup Complete",
            tipText: "",
            isComplete: this.isCompletionComplete,
            isErrored: false,
            isSkippableStep: false,
            onNext: this.handleCompletionNext,
            onPrevious: this.handleCompletionPrev,
            nextLabel: "View All Connections",
            previousLabel: "Go Back"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $96c115fa992ddc92$export$2e2bcd8739ae039), {
            ref: (c)=>this.completionStepRef = c
        }))));
    }
    get dashboardNextLabel() {
        const { selectedDashboards: selectedDashboards } = this.state;
        if (selectedDashboards) return `Create ${selectedDashboards} Dashboard${selectedDashboards > 1 ? 's' : ''}`;
        return 'Next';
    }
}
const $b0c12c1b94dfc089$var$mstp = ({ auth: { isUsingAuth: isUsingAuth, me: me } })=>({
        isUsingAuth: isUsingAuth,
        me: me
    });
var $b0c12c1b94dfc089$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($b0c12c1b94dfc089$var$mstp, null)((0, $dffbdf89c590a961$export$2e2bcd8739ae039)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($b0c12c1b94dfc089$var$OnboardingWizard)));





var $NdCUR = parcelRequire("NdCUR");

// landing page is used after successful OAuth2 authentication
const $f7df8000f5455a87$var$LandingPage = ({ router: router })=>{
    (0, $NdCUR.useEffect)(()=>router.push((0, $985a502d70a1bfe1$export$d164ee800969599c)()), []);
    return null;
};
var $f7df8000f5455a87$export$2e2bcd8739ae039 = $f7df8000f5455a87$var$LandingPage;



var $NdCUR = parcelRequire("NdCUR");
const $080fd076463801b6$var$NotFound = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "container-fluid"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel-heading text-center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h1", {
        className: "deluxe"
    }, "404"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", null, "Bummer! We couldn't find the page you were looking for"))));
var $080fd076463801b6$export$2e2bcd8739ae039 = $080fd076463801b6$var$NotFound;









const $a965c6d8ca2338eb$export$9f9c5ceabb12cbb3 = (telegrafSystemInterval)=>({
        type: (0, $67853175702c8b4d$export$1385d81a6c6bbcd4).SetTelegrafSystemInterval,
        payload: {
            telegrafSystemInterval: telegrafSystemInterval
        }
    });
const $a965c6d8ca2338eb$export$58a7d2eb42160389 = (hostPageDisabled)=>({
        type: (0, $67853175702c8b4d$export$1385d81a6c6bbcd4).SetHostPageDisplayStatus,
        payload: {
            hostPageDisabled: hostPageDisabled
        }
    });
const $a965c6d8ca2338eb$export$2b808e8bc22434d0 = (v3SupportEnabled)=>({
        type: (0, $67853175702c8b4d$export$1385d81a6c6bbcd4).SetV3SupportEnabled,
        payload: {
            v3SupportEnabled: v3SupportEnabled
        }
    });






var $85bc4a9940703419$export$5b4a8869eb24d061 = /*#__PURE__*/ function(AlertType) {
    AlertType["Info"] = "info";
    AlertType["Warning"] = "warning";
    return AlertType;
}({});




var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");




var $NdCUR = parcelRequire("NdCUR");


var $NdCUR = parcelRequire("NdCUR");
const $c46ed9551537a181$var$SubSectionsTab = ({ handleClick: handleClick, section: section, activeSection: activeSection })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: `subsection--tab ${section.url === activeSection ? 'active' : ''}`,
        onClick: handleClick
    }, section.name);
var $c46ed9551537a181$export$2e2bcd8739ae039 = $c46ed9551537a181$var$SubSectionsTab;




const $16731a995ab23942$var$TOP = {
    top: 'subsection',
    nav: 'subsection--nav',
    tabs: 'subsection__tabs subsection__tabs--row',
    content: 'subsection--content'
};
const $16731a995ab23942$var$LEFT = {
    top: 'row subsection',
    nav: 'col-md-2 subsection--nav',
    tabs: 'subsection__tabs',
    content: 'col-md-10 subsection--content'
};
class $16731a995ab23942$var$SubSections extends (0, $NdCUR.Component) {
    constructor(props){
        super(props), this.handleTabClick = (section)=>()=>{
                const { router: router, sourceID: sourceID, parentUrl: parentUrl, onTabChange: onTabChange } = this.props;
                const url = `/sources/${sourceID}/${parentUrl}/${section.url}`;
                if (onTabChange) {
                    onTabChange(section, url);
                    return;
                }
                router.push(url);
            };
    }
    render() {
        const { sections: sections, activeSection: activeSection, position: position } = this.props;
        const classes = position === 'top' ? $16731a995ab23942$var$TOP : $16731a995ab23942$var$LEFT;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: classes.top
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: classes.nav,
            "data-test": "subsectionNav"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: classes.tabs
        }, sections.map((section, i)=>section.enabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c46ed9551537a181$export$2e2bcd8739ae039), {
                key: i,
                section: section,
                handleClick: this.handleTabClick(section),
                activeSection: activeSection
            })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: classes.content,
            "data-test": "subsectionContent"
        }, this.activeSectionComponent));
    }
    get activeSectionComponent() {
        const { sections: sections, activeSection: activeSection, children: children } = this.props;
        const found = sections.find((section)=>section.url === activeSection);
        return found?.component || children || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $080fd076463801b6$export$2e2bcd8739ae039), null);
    }
}
var $16731a995ab23942$export$2e2bcd8739ae039 = (0, $dffbdf89c590a961$export$2e2bcd8739ae039)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($16731a995ab23942$var$SubSections));



var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");


var $eb9e4c802dd9bc17$exports = {};

$parcel$export($eb9e4c802dd9bc17$exports, "loadUsers", function () { return $eb9e4c802dd9bc17$export$2c3a8e05396a78be; });
$parcel$export($eb9e4c802dd9bc17$exports, "loadOrganizations", function () { return $eb9e4c802dd9bc17$export$2cbef5c753b63a7b; });
$parcel$export($eb9e4c802dd9bc17$exports, "addUser", function () { return $eb9e4c802dd9bc17$export$7ee7664ce5ce7d6; });
$parcel$export($eb9e4c802dd9bc17$exports, "updateUser", function () { return $eb9e4c802dd9bc17$export$e3ac7a5d19605772; });
$parcel$export($eb9e4c802dd9bc17$exports, "syncUser", function () { return $eb9e4c802dd9bc17$export$bf59184358edf23a; });
$parcel$export($eb9e4c802dd9bc17$exports, "removeUser", function () { return $eb9e4c802dd9bc17$export$d006f7a482b957ad; });
$parcel$export($eb9e4c802dd9bc17$exports, "addOrganization", function () { return $eb9e4c802dd9bc17$export$8bf248e9cc406dd4; });
$parcel$export($eb9e4c802dd9bc17$exports, "renameOrganization", function () { return $eb9e4c802dd9bc17$export$21f61772044477cf; });
$parcel$export($eb9e4c802dd9bc17$exports, "syncOrganization", function () { return $eb9e4c802dd9bc17$export$effdbe387ec005d3; });
$parcel$export($eb9e4c802dd9bc17$exports, "removeOrganization", function () { return $eb9e4c802dd9bc17$export$3f42ef619dd0fbcc; });
$parcel$export($eb9e4c802dd9bc17$exports, "loadMappings", function () { return $eb9e4c802dd9bc17$export$f9c3c933e37b50f5; });
$parcel$export($eb9e4c802dd9bc17$exports, "updateMapping", function () { return $eb9e4c802dd9bc17$export$dd15abf137d320e4; });
$parcel$export($eb9e4c802dd9bc17$exports, "addMapping", function () { return $eb9e4c802dd9bc17$export$2d9a54e47969bead; });
$parcel$export($eb9e4c802dd9bc17$exports, "removeMapping", function () { return $eb9e4c802dd9bc17$export$c37b10abcd57d19c; });
$parcel$export($eb9e4c802dd9bc17$exports, "loadUsersAsync", function () { return $eb9e4c802dd9bc17$export$7d3fcf540e9f03ed; });
$parcel$export($eb9e4c802dd9bc17$exports, "loadOrganizationsAsync", function () { return $eb9e4c802dd9bc17$export$4c02ea6a2c3b00fd; });
$parcel$export($eb9e4c802dd9bc17$exports, "loadMappingsAsync", function () { return $eb9e4c802dd9bc17$export$478994c4c1eccb21; });
$parcel$export($eb9e4c802dd9bc17$exports, "createMappingAsync", function () { return $eb9e4c802dd9bc17$export$2bbd0a6a55fe6f10; });
$parcel$export($eb9e4c802dd9bc17$exports, "deleteMappingAsync", function () { return $eb9e4c802dd9bc17$export$f55c3c09d2aab1c6; });
$parcel$export($eb9e4c802dd9bc17$exports, "updateMappingAsync", function () { return $eb9e4c802dd9bc17$export$f8e30957dcbe4b5d; });
$parcel$export($eb9e4c802dd9bc17$exports, "createUserAsync", function () { return $eb9e4c802dd9bc17$export$88a546ec116dc5dc; });
$parcel$export($eb9e4c802dd9bc17$exports, "updateUserAsync", function () { return $eb9e4c802dd9bc17$export$fb56416579e053f5; });
$parcel$export($eb9e4c802dd9bc17$exports, "deleteUserAsync", function () { return $eb9e4c802dd9bc17$export$768a6f192dfb6e00; });
$parcel$export($eb9e4c802dd9bc17$exports, "createOrganizationAsync", function () { return $eb9e4c802dd9bc17$export$f2f249bffa261061; });
$parcel$export($eb9e4c802dd9bc17$exports, "updateOrganizationAsync", function () { return $eb9e4c802dd9bc17$export$588ea2291c805037; });
$parcel$export($eb9e4c802dd9bc17$exports, "deleteOrganizationAsync", function () { return $eb9e4c802dd9bc17$export$91426d3eed7f56d2; });

var $hBdgJ = parcelRequire("hBdgJ");


const $91a09b708dc2a495$export$925a4945a6cd0f3e = async (url)=>{
    try {
        return await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'GET',
            url: url
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $91a09b708dc2a495$export$935536f6e4c62d5e = async (url)=>{
    try {
        return await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'GET',
            url: url
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $91a09b708dc2a495$export$3493b8991d49f558 = async (url, user)=>{
    try {
        return await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'POST',
            url: url,
            data: user
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $91a09b708dc2a495$export$e3ac7a5d19605772 = async (updatedUserWithRolesOnly)=>{
    try {
        return await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'PATCH',
            url: updatedUserWithRolesOnly.links.self,
            data: updatedUserWithRolesOnly
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $91a09b708dc2a495$export$7d0f10f273c0438a = async (user)=>{
    try {
        return await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'DELETE',
            url: user.links.self
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $91a09b708dc2a495$export$34c6178bfd248df3 = async (url, organization)=>{
    try {
        return await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'POST',
            url: url,
            data: organization
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $91a09b708dc2a495$export$3f4430ea1068bd7f = async (organization)=>{
    try {
        return await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'PATCH',
            url: organization.links.self,
            data: organization
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $91a09b708dc2a495$export$671500b18c6f825a = async (organization)=>{
    try {
        return await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'DELETE',
            url: organization.links.self
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $91a09b708dc2a495$export$3b8fbc34b0c167c = async (url, mapping)=>{
    try {
        return await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'POST',
            resource: 'mappings',
            data: mapping
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $91a09b708dc2a495$export$8329fa88651e3196 = async ()=>{
    try {
        return await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'GET',
            resource: 'mappings'
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $91a09b708dc2a495$export$dd15abf137d320e4 = async (mapping)=>{
    try {
        return await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'PUT',
            url: mapping.links.self,
            data: mapping
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $91a09b708dc2a495$export$3b38f18d52622fa8 = async (mapping)=>{
    try {
        return await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'DELETE',
            url: mapping.links.self
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
};






const $eb9e4c802dd9bc17$export$2c3a8e05396a78be = ({ users: users })=>({
        type: 'CHRONOGRAF_LOAD_USERS',
        payload: {
            users: users
        }
    });
const $eb9e4c802dd9bc17$export$2cbef5c753b63a7b = ({ organizations: organizations })=>({
        type: 'CHRONOGRAF_LOAD_ORGANIZATIONS',
        payload: {
            organizations: organizations
        }
    });
const $eb9e4c802dd9bc17$export$7ee7664ce5ce7d6 = (user)=>({
        type: 'CHRONOGRAF_ADD_USER',
        payload: {
            user: user
        }
    });
const $eb9e4c802dd9bc17$export$e3ac7a5d19605772 = (user, updatedUser)=>({
        type: 'CHRONOGRAF_UPDATE_USER',
        payload: {
            user: user,
            updatedUser: updatedUser
        }
    });
const $eb9e4c802dd9bc17$export$bf59184358edf23a = (staleUser, syncedUser)=>({
        type: 'CHRONOGRAF_SYNC_USER',
        payload: {
            staleUser: staleUser,
            syncedUser: syncedUser
        }
    });
const $eb9e4c802dd9bc17$export$d006f7a482b957ad = (user)=>({
        type: 'CHRONOGRAF_REMOVE_USER',
        payload: {
            user: user
        }
    });
const $eb9e4c802dd9bc17$export$8bf248e9cc406dd4 = (organization)=>({
        type: 'CHRONOGRAF_ADD_ORGANIZATION',
        payload: {
            organization: organization
        }
    });
const $eb9e4c802dd9bc17$export$21f61772044477cf = (organization, newName)=>({
        type: 'CHRONOGRAF_RENAME_ORGANIZATION',
        payload: {
            organization: organization,
            newName: newName
        }
    });
const $eb9e4c802dd9bc17$export$effdbe387ec005d3 = (staleOrganization, syncedOrganization)=>({
        type: 'CHRONOGRAF_SYNC_ORGANIZATION',
        payload: {
            staleOrganization: staleOrganization,
            syncedOrganization: syncedOrganization
        }
    });
const $eb9e4c802dd9bc17$export$3f42ef619dd0fbcc = (organization)=>({
        type: 'CHRONOGRAF_REMOVE_ORGANIZATION',
        payload: {
            organization: organization
        }
    });
const $eb9e4c802dd9bc17$export$f9c3c933e37b50f5 = ({ mappings: mappings })=>({
        type: 'CHRONOGRAF_LOAD_MAPPINGS',
        payload: {
            mappings: mappings
        }
    });
const $eb9e4c802dd9bc17$export$dd15abf137d320e4 = (staleMapping, updatedMapping)=>({
        type: 'CHRONOGRAF_UPDATE_MAPPING',
        payload: {
            staleMapping: staleMapping,
            updatedMapping: updatedMapping
        }
    });
const $eb9e4c802dd9bc17$export$2d9a54e47969bead = (mapping)=>({
        type: 'CHRONOGRAF_ADD_MAPPING',
        payload: {
            mapping: mapping
        }
    });
const $eb9e4c802dd9bc17$export$c37b10abcd57d19c = (mapping)=>({
        type: 'CHRONOGRAF_REMOVE_MAPPING',
        payload: {
            mapping: mapping
        }
    });
const $eb9e4c802dd9bc17$export$7d3fcf540e9f03ed = (url)=>async (dispatch)=>{
        try {
            const { data: data } = await (0, $91a09b708dc2a495$export$925a4945a6cd0f3e)(url);
            dispatch($eb9e4c802dd9bc17$export$2c3a8e05396a78be(data));
        } catch (error) {
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error));
        }
    };
const $eb9e4c802dd9bc17$export$4c02ea6a2c3b00fd = (url)=>async (dispatch)=>{
        try {
            const { data: data } = await (0, $91a09b708dc2a495$export$935536f6e4c62d5e)(url);
            dispatch($eb9e4c802dd9bc17$export$2cbef5c753b63a7b(data));
        } catch (error) {
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error));
        }
    };
const $eb9e4c802dd9bc17$export$478994c4c1eccb21 = ()=>async (dispatch)=>{
        try {
            const { data: data } = await (0, $91a09b708dc2a495$export$8329fa88651e3196)();
            dispatch($eb9e4c802dd9bc17$export$f9c3c933e37b50f5(data));
        } catch (error) {
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error));
        }
    };
const $eb9e4c802dd9bc17$export$2bbd0a6a55fe6f10 = (url, mapping)=>async (dispatch)=>{
        const mappingWithTempId = {
            ...mapping,
            _tempID: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)()
        };
        dispatch($eb9e4c802dd9bc17$export$2d9a54e47969bead(mappingWithTempId));
        try {
            const { data: data } = await (0, $91a09b708dc2a495$export$3b8fbc34b0c167c)(url, mapping);
            dispatch($eb9e4c802dd9bc17$export$dd15abf137d320e4(mappingWithTempId, data));
        } catch (error) {
            const message = `${(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).upperFirst((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).toLower(error.data.message))}: Scheme: ${mapping.scheme} Provider: ${mapping.provider}`;
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error, message));
            setTimeout(()=>dispatch($eb9e4c802dd9bc17$export$c37b10abcd57d19c(mappingWithTempId)), (0, $e10a8602f56394e3$export$7cead1aa1be9a72f));
        }
    };
const $eb9e4c802dd9bc17$export$f55c3c09d2aab1c6 = (mapping)=>async (dispatch)=>{
        dispatch($eb9e4c802dd9bc17$export$c37b10abcd57d19c(mapping));
        try {
            await (0, $91a09b708dc2a495$export$3b38f18d52622fa8)(mapping);
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$c6e980ccf24e588b)(mapping.id, mapping.scheme)));
        } catch (error) {
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error));
            dispatch($eb9e4c802dd9bc17$export$2d9a54e47969bead(mapping));
        }
    };
const $eb9e4c802dd9bc17$export$f8e30957dcbe4b5d = (staleMapping, updatedMapping)=>async (dispatch)=>{
        dispatch($eb9e4c802dd9bc17$export$dd15abf137d320e4(staleMapping, updatedMapping));
        try {
            await (0, $91a09b708dc2a495$export$dd15abf137d320e4)(updatedMapping);
        } catch (error) {
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error));
            dispatch($eb9e4c802dd9bc17$export$dd15abf137d320e4(updatedMapping, staleMapping));
        }
    };
const $eb9e4c802dd9bc17$export$88a546ec116dc5dc = (url, user)=>async (dispatch)=>{
        // temp uuid is added to be able to disambiguate a created user that has the
        // same scheme, provider, and name as an existing user
        const userWithTempID = {
            ...user,
            _tempID: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)()
        };
        dispatch($eb9e4c802dd9bc17$export$7ee7664ce5ce7d6(userWithTempID));
        try {
            const { data: data } = await (0, $91a09b708dc2a495$export$3493b8991d49f558)(url, user);
            dispatch($eb9e4c802dd9bc17$export$bf59184358edf23a(userWithTempID, data));
        } catch (error) {
            const message = `${(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).upperFirst((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).toLower(error.data.message))}: ${user.scheme}::${user.provider}::${user.name}`;
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error, message));
            // undo optimistic update
            setTimeout(()=>dispatch($eb9e4c802dd9bc17$export$d006f7a482b957ad(userWithTempID)), (0, $e10a8602f56394e3$export$7cead1aa1be9a72f));
        }
    };
const $eb9e4c802dd9bc17$export$fb56416579e053f5 = (user, updatedUser, successMessage)=>async (dispatch)=>{
        dispatch($eb9e4c802dd9bc17$export$e3ac7a5d19605772(user, updatedUser));
        try {
            // currently the request will be rejected if name, provider, or scheme, or
            // no roles are sent with the request.
            // TODO: remove the null assignments below so that the user request can have
            // the original name, provider, and scheme once the change to allow this is
            // implemented server-side
            const { data: data } = await (0, $91a09b708dc2a495$export$e3ac7a5d19605772)({
                ...updatedUser,
                name: null,
                provider: null,
                scheme: null
            });
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$87d9851da6351cab)(successMessage)));
            // it's not necessary to syncUser again but it's useful for good
            // measure and for the clarity of insight in the redux story
            dispatch($eb9e4c802dd9bc17$export$bf59184358edf23a(user, data));
        } catch (error) {
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error));
            dispatch($eb9e4c802dd9bc17$export$bf59184358edf23a(user, user));
        }
    };
const $eb9e4c802dd9bc17$export$768a6f192dfb6e00 = (user, { isAbsoluteDelete: isAbsoluteDelete } = {})=>async (dispatch)=>{
        dispatch($eb9e4c802dd9bc17$export$d006f7a482b957ad(user));
        try {
            await (0, $91a09b708dc2a495$export$7d0f10f273c0438a)(user);
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$e8553dca2b78ebe6)(user.name, isAbsoluteDelete)));
        } catch (error) {
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error));
            dispatch($eb9e4c802dd9bc17$export$7ee7664ce5ce7d6(user));
        }
    };
const $eb9e4c802dd9bc17$export$f2f249bffa261061 = (url, organization)=>async (dispatch)=>{
        // temp uuid is added to be able to disambiguate a created organization with
        // the same name as an existing organization
        const organizationWithTempID = {
            ...organization,
            _tempID: (0, $dbdc5944552afab7$export$2e2bcd8739ae039)()
        };
        dispatch($eb9e4c802dd9bc17$export$8bf248e9cc406dd4(organizationWithTempID));
        try {
            const { data: data } = await (0, $91a09b708dc2a495$export$34c6178bfd248df3)(url, organization);
            dispatch($eb9e4c802dd9bc17$export$effdbe387ec005d3(organization, data));
        } catch (error) {
            const message = `${(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).upperFirst((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).toLower(error.data.message))}: ${organization.name}`;
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error, message));
            // undo optimistic update
            setTimeout(()=>dispatch($eb9e4c802dd9bc17$export$3f42ef619dd0fbcc(organizationWithTempID)), (0, $e10a8602f56394e3$export$7cead1aa1be9a72f));
        }
    };
const $eb9e4c802dd9bc17$export$588ea2291c805037 = (organization, updatedOrganization)=>async (dispatch)=>{
        dispatch($eb9e4c802dd9bc17$export$21f61772044477cf(organization, updatedOrganization.name));
        try {
            const { data: data } = await (0, $91a09b708dc2a495$export$3f4430ea1068bd7f)(updatedOrganization);
            // it's not necessary to syncOrganization again but it's useful for good
            // measure and for the clarity of insight in the redux story
            dispatch($eb9e4c802dd9bc17$export$effdbe387ec005d3(updatedOrganization, data));
        } catch (error) {
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error));
            dispatch($eb9e4c802dd9bc17$export$effdbe387ec005d3(organization, organization)) // restore if fail
            ;
        }
    };
const $eb9e4c802dd9bc17$export$91426d3eed7f56d2 = (organization)=>async (dispatch)=>{
        dispatch($eb9e4c802dd9bc17$export$3f42ef619dd0fbcc(organization));
        try {
            await (0, $91a09b708dc2a495$export$671500b18c6f825a)(organization);
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$a0f2d8fba649a6a5)(organization.name)));
        } catch (error) {
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error));
            dispatch($eb9e4c802dd9bc17$export$8bf248e9cc406dd4(organization));
        }
    };





var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");

var $hBdgJ = parcelRequire("hBdgJ");

var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");

class $d9ecbdd7ef224449$var$UsersTableHeader extends (0, $NdCUR.Component) {
    constructor(props){
        super(props);
    }
    render() {
        const { onClickCreateUser: onClickCreateUser, numUsers: numUsers, isCreatingUser: isCreatingUser, organization: organization } = this.props;
        const panelTitle = numUsers === 1 ? `${numUsers} User` : `${numUsers} Users`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel-heading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h2", {
            className: "panel-title"
        }, panelTitle, " in ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("em", null, organization.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-primary btn-sm",
            onClick: onClickCreateUser,
            disabled: isCreatingUser || !onClickCreateUser,
            "data-test": "add-user--button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon plus"
        }), "Add User"));
    }
}
const { bool: $d9ecbdd7ef224449$var$bool, func: $d9ecbdd7ef224449$var$func, shape: $d9ecbdd7ef224449$var$shape, string: $d9ecbdd7ef224449$var$string, number: $d9ecbdd7ef224449$var$number } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$d9ecbdd7ef224449$var$UsersTableHeader.defaultProps = {
    numUsers: 0,
    organization: {
        name: ''
    },
    isCreatingUser: false
};
$d9ecbdd7ef224449$var$UsersTableHeader.propTypes = {
    numUsers: $d9ecbdd7ef224449$var$number.isRequired,
    onClickCreateUser: $d9ecbdd7ef224449$var$func,
    isCreatingUser: $d9ecbdd7ef224449$var$bool.isRequired,
    organization: $d9ecbdd7ef224449$var$shape({
        name: $d9ecbdd7ef224449$var$string.isRequired
    })
};
var $d9ecbdd7ef224449$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($d9ecbdd7ef224449$var$UsersTableHeader);



var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");






const $7ba9f168b2e3ae7f$export$c367ad1972a0fb01 = {
    colRole: 120,
    colOrganizations: 200,
    colSuperAdmin: 90,
    colProvider: 170,
    colScheme: 90,
    colActions: 80
};
const $7ba9f168b2e3ae7f$export$52ce62778f54cb60 = {
    colOrganizations: 320,
    colSuperAdmin: 90,
    colProvider: 100,
    colScheme: 90,
    colActions: 50
};



const $603926c3b7bd4a9b$export$7c6317deeec7a6c1 = [
    {
        name: (0, $a7910b1002260d34$export$2959f045e897f38b)
    },
    {
        name: (0, $a7910b1002260d34$export$62bbf68aca1809f0)
    },
    {
        name: (0, $a7910b1002260d34$export$1d39a112fd67439d)
    },
    {
        name: (0, $a7910b1002260d34$export$f715f7e27dea2abf)
    },
    {
        name: (0, $a7910b1002260d34$export$856b7354d850707e)
    }
];
const $603926c3b7bd4a9b$export$a471ccbb4f8b12ef = 'default';
const $603926c3b7bd4a9b$export$30f2e46c50bfc896 = 'default';


class $c75959caa796913e$var$UsersTableRowNew extends (0, $NdCUR.Component) {
    constructor(props){
        super(props);
        this.state = {
            name: '',
            provider: '',
            scheme: 'oauth2',
            role: this.props.organization.defaultRole
        };
    }
    handleInputChange = (fieldName)=>(e)=>{
            this.setState({
                [fieldName]: e.target.value.trim()
            });
        };
    handleConfirmCreateUser = ()=>{
        const { onBlur: onBlur, onCreateUser: onCreateUser, organization: organization } = this.props;
        const { name: name, provider: provider, scheme: scheme, role: role } = this.state;
        const newUser = {
            name: name,
            provider: provider,
            scheme: scheme,
            roles: [
                {
                    name: role,
                    organization: organization.id
                }
            ]
        };
        onCreateUser(newUser);
        onBlur();
    };
    handleInputFocus = (e)=>{
        e.target.select();
    };
    handleSelectRole = (newRole)=>{
        this.setState({
            role: newRole.text
        });
    };
    handleKeyDown = (e)=>{
        const { name: name, provider: provider } = this.state;
        const preventCreate = !name || !provider;
        if (e.key === 'Escape') this.props.onBlur();
        if (e.key === 'Enter') {
            if (preventCreate) return this.props.notify((0, $ec1f42de4faacc37$export$ff016350b0e7cf48)());
            this.handleConfirmCreateUser();
        }
    };
    render() {
        const { colRole: colRole, colProvider: colProvider, colScheme: colScheme, colActions: colActions } = (0, $7ba9f168b2e3ae7f$export$c367ad1972a0fb01);
        const { onBlur: onBlur } = this.props;
        const { name: name, provider: provider, scheme: scheme, role: role } = this.state;
        const dropdownRolesItems = (0, $603926c3b7bd4a9b$export$7c6317deeec7a6c1).map((r)=>({
                ...r,
                text: r.name
            }));
        const preventCreate = !name || !provider;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tr", {
            className: "chronograf-admin-table--new-user",
            "data-test": "new-user--table-row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control input-xs",
            type: "text",
            placeholder: "OAuth Username...",
            autoFocus: true,
            value: name,
            onChange: this.handleInputChange('name'),
            onKeyDown: this.handleKeyDown,
            "data-test": "username--input"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            style: {
                width: colRole
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ca4f14339173643c$export$2e2bcd8739ae039), {
            items: dropdownRolesItems,
            selected: role,
            onChoose: this.handleSelectRole,
            buttonColor: "btn-primary",
            buttonSize: "btn-xs",
            className: "dropdown-stretch"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            style: {
                width: colProvider
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control input-xs",
            type: "text",
            placeholder: "OAuth Provider...",
            value: provider,
            onChange: this.handleInputChange('provider'),
            onKeyDown: this.handleKeyDown,
            "data-test": "oauth-provider--input"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            style: {
                width: colScheme
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control input-xs disabled",
            type: "text",
            disabled: true,
            placeholder: "OAuth Scheme...",
            value: scheme,
            "data-test": "oauth-schema--input"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            className: "text-right",
            style: {
                width: colActions
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-xs btn-square btn-info",
            onClick: onBlur,
            "data-test": "cancel-new-user--button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon remove"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-xs btn-square btn-success",
            disabled: preventCreate,
            onClick: this.handleConfirmCreateUser,
            "data-test": "confirm-new-user--button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon checkmark"
        }))));
    }
}
const { func: $c75959caa796913e$var$func, shape: $c75959caa796913e$var$shape, string: $c75959caa796913e$var$string } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$c75959caa796913e$var$UsersTableRowNew.propTypes = {
    organization: $c75959caa796913e$var$shape({
        id: $c75959caa796913e$var$string.isRequired,
        name: $c75959caa796913e$var$string.isRequired
    }),
    onBlur: $c75959caa796913e$var$func.isRequired,
    onCreateUser: $c75959caa796913e$var$func.isRequired,
    notify: $c75959caa796913e$var$func.isRequired
};
const $c75959caa796913e$var$mapDispatchToProps = (dispatch)=>({
        notify: (0, $1f80bbeadc1a0021$export$2e2bcd8739ae039)((0, $205d139de2918454$export$5e14cdade93d6f7b), dispatch)
    });
var $c75959caa796913e$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)(null, $c75959caa796913e$var$mapDispatchToProps)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($c75959caa796913e$var$UsersTableRowNew));



var $NdCUR = parcelRequire("NdCUR");





class $9e623e6e64594938$var$UsersTableRow extends (0, $NdCUR.PureComponent) {
    render() {
        const { user: user, onChangeUserRole: onChangeUserRole } = this.props;
        const { colRole: colRole, colProvider: colProvider, colScheme: colScheme } = (0, $7ba9f168b2e3ae7f$export$c367ad1972a0fb01);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tr", {
            className: 'chronograf-admin-table--user',
            "data-test": `${user.name}--table-row`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", null, this.isMe ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("strong", {
            className: "chronograf-user--me"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon user"
        }), user.name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("strong", null, user.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            style: {
                width: colRole
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "chronograf-user--role"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ca4f14339173643c$export$2e2bcd8739ae039), {
            items: this.rolesDropdownItems,
            selected: this.currentRole?.name,
            onChoose: onChangeUserRole(user, this.currentRole),
            buttonColor: "btn-primary",
            buttonSize: "btn-xs",
            className: "dropdown-stretch"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            style: {
                width: colProvider
            }
        }, user.provider), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            style: {
                width: colScheme
            }
        }, user.scheme), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            className: "text-right"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $8008717819fc7a5f$export$2e2bcd8739ae039), {
            confirmText: this.confirmationText,
            confirmAction: this.handleDelete,
            size: "btn-xs",
            type: "btn-danger",
            text: "Remove",
            customClass: "table--show-on-row-hover",
            testId: "remove-user--button"
        })));
    }
    get rolesDropdownItems() {
        return (0, $603926c3b7bd4a9b$export$7c6317deeec7a6c1).map((r)=>({
                ...r,
                text: r.name
            }));
    }
    get currentRole() {
        const { user: user, organization: organization } = this.props;
        return user.roles.find((role)=>role.organization === organization.id);
    }
    get isMe() {
        const { user: user, meID: meID } = this.props;
        return user.id === meID;
    }
    get confirmationText() {
        return 'Remove this user\nfrom Current Org?';
    }
    constructor(...args){
        super(...args), this.handleDelete = ()=>{
            const { user: user, onDelete: onDelete } = this.props;
            onDelete(user);
        };
    }
}
var $9e623e6e64594938$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($9e623e6e64594938$var$UsersTableRow);





class $dc09d2caa4fe835e$var$UsersTable extends (0, $NdCUR.Component) {
    constructor(props){
        super(props);
        this.state = {
            isCreatingUser: false
        };
    }
    shouldComponentUpdate(nextProps, nextState) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEqual(this.props, nextProps) || !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEqual(this.state, nextState);
    }
    handleChangeUserRole = (user, currentRole)=>(newRole)=>{
            this.props.onUpdateUserRole(user, currentRole, newRole);
        };
    handleDeleteUser = (user)=>{
        this.props.onDeleteUser(user);
    };
    handleClickCreateUser = ()=>{
        this.setState({
            isCreatingUser: true
        });
    };
    handleBlurCreateUserRow = ()=>{
        this.setState({
            isCreatingUser: false
        });
    };
    render() {
        const { organization: organization, users: users, onCreateUser: onCreateUser, meID: meID, isLoading: isLoading } = this.props;
        const { isCreatingUser: isCreatingUser } = this.state;
        const { colRole: colRole, colProvider: colProvider, colScheme: colScheme, colActions: colActions } = (0, $7ba9f168b2e3ae7f$export$c367ad1972a0fb01);
        if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel panel-solid"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $810ad5a94daa03b8$export$2e2bcd8739ae039), null)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel panel-solid"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $d9ecbdd7ef224449$export$2e2bcd8739ae039), {
            numUsers: users.length,
            onClickCreateUser: this.handleClickCreateUser,
            isCreatingUser: isCreatingUser,
            organization: organization
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("table", {
            className: "table table-highlight v-center chronograf-admin-table"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", null, "Username"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
            style: {
                width: colRole
            },
            className: "align-with-col-text"
        }, "Role"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
            style: {
                width: colProvider
            }
        }, "Provider"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
            style: {
                width: colScheme
            }
        }, "Scheme"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
            className: "text-right",
            style: {
                width: colActions
            }
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tbody", null, isCreatingUser ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c75959caa796913e$export$2e2bcd8739ae039), {
            organization: organization,
            onBlur: this.handleBlurCreateUserRow,
            onCreateUser: onCreateUser
        }) : null, users.length ? users.map((user)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $9e623e6e64594938$export$2e2bcd8739ae039), {
                user: user,
                key: user.id,
                organization: organization,
                onChangeUserRole: this.handleChangeUserRole,
                onDelete: this.handleDeleteUser,
                meID: meID
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tr", {
            className: "table-empty-state"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
            colSpan: "5"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, "No Users to display")))))));
    }
}
const { arrayOf: $dc09d2caa4fe835e$var$arrayOf, bool: $dc09d2caa4fe835e$var$bool, func: $dc09d2caa4fe835e$var$func, shape: $dc09d2caa4fe835e$var$shape, string: $dc09d2caa4fe835e$var$string } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$dc09d2caa4fe835e$var$UsersTable.propTypes = {
    users: $dc09d2caa4fe835e$var$arrayOf($dc09d2caa4fe835e$var$shape({
        id: $dc09d2caa4fe835e$var$string,
        links: $dc09d2caa4fe835e$var$shape({
            self: $dc09d2caa4fe835e$var$string.isRequired
        }),
        name: $dc09d2caa4fe835e$var$string.isRequired,
        provider: $dc09d2caa4fe835e$var$string.isRequired,
        roles: $dc09d2caa4fe835e$var$arrayOf($dc09d2caa4fe835e$var$shape({
            name: $dc09d2caa4fe835e$var$string.isRequired,
            organization: $dc09d2caa4fe835e$var$string.isRequired
        })),
        scheme: $dc09d2caa4fe835e$var$string.isRequired
    })).isRequired,
    organization: $dc09d2caa4fe835e$var$shape({
        name: $dc09d2caa4fe835e$var$string.isRequired,
        id: $dc09d2caa4fe835e$var$string.isRequired
    }),
    onCreateUser: $dc09d2caa4fe835e$var$func.isRequired,
    onUpdateUserRole: $dc09d2caa4fe835e$var$func.isRequired,
    onDeleteUser: $dc09d2caa4fe835e$var$func.isRequired,
    meID: $dc09d2caa4fe835e$var$string.isRequired,
    isLoading: $dc09d2caa4fe835e$var$bool.isRequired
};
var $dc09d2caa4fe835e$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($dc09d2caa4fe835e$var$UsersTable);


class $5ff6af365959a730$var$UsersPage extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props);
        this.state = {
            isLoading: true
        };
    }
    handleCreateUser = (user)=>{
        const { links: links, actions: { createUserAsync: createUserAsync } } = this.props;
        createUserAsync(links.users, user);
    };
    handleUpdateUserRole = (user, currentRole, { name: name })=>{
        const { actions: { updateUserAsync: updateUserAsync } } = this.props;
        const updatedRole = {
            ...currentRole,
            name: name
        };
        const newRoles = user.roles.map((r)=>r.organization === currentRole.organization ? updatedRole : r);
        updateUserAsync(user, {
            ...user,
            roles: newRoles
        }, `${user.name} is now a ${name}`);
    };
    handleDeleteUser = (user)=>{
        const { actions: { deleteUserAsync: deleteUserAsync } } = this.props;
        deleteUserAsync(user, {
            isAbsoluteDelete: false
        });
    };
    async UNSAFE_componentWillMount() {
        const { links: links, actions: { loadOrganizationsAsync: loadOrganizationsAsync, loadUsersAsync: loadUsersAsync } } = this.props;
        this.setState({
            isLoading: true
        });
        await Promise.all([
            loadOrganizationsAsync(links.organizations),
            loadUsersAsync(links.users)
        ]);
        this.setState({
            isLoading: false
        });
    }
    render() {
        const { meCurrentOrganization: meCurrentOrganization, organizations: organizations, meID: meID, users: users, notify: notify } = this.props;
        const { isLoading: isLoading } = this.state;
        const organization = organizations.find((o)=>o.id === meCurrentOrganization.id);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dc09d2caa4fe835e$export$2e2bcd8739ae039), {
            meID: meID,
            users: users,
            organization: organization,
            onCreateUser: this.handleCreateUser,
            onUpdateUserRole: this.handleUpdateUserRole,
            onDeleteUser: this.handleDeleteUser,
            notify: notify,
            isLoading: isLoading
        });
    }
}
const { arrayOf: $5ff6af365959a730$var$arrayOf, func: $5ff6af365959a730$var$func, shape: $5ff6af365959a730$var$shape, string: $5ff6af365959a730$var$string } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$5ff6af365959a730$var$UsersPage.propTypes = {
    links: $5ff6af365959a730$var$shape({
        users: $5ff6af365959a730$var$string.isRequired
    }),
    meID: $5ff6af365959a730$var$string.isRequired,
    meCurrentOrganization: $5ff6af365959a730$var$shape({
        id: $5ff6af365959a730$var$string.isRequired,
        name: $5ff6af365959a730$var$string.isRequired
    }).isRequired,
    users: $5ff6af365959a730$var$arrayOf($5ff6af365959a730$var$shape),
    organizations: $5ff6af365959a730$var$arrayOf($5ff6af365959a730$var$shape),
    actions: $5ff6af365959a730$var$shape({
        loadUsersAsync: $5ff6af365959a730$var$func.isRequired,
        loadOrganizationsAsync: $5ff6af365959a730$var$func.isRequired,
        createUserAsync: $5ff6af365959a730$var$func.isRequired,
        updateUserAsync: $5ff6af365959a730$var$func.isRequired,
        deleteUserAsync: $5ff6af365959a730$var$func.isRequired
    }),
    notify: $5ff6af365959a730$var$func.isRequired
};
const $5ff6af365959a730$var$mapStateToProps = ({ links: links, adminChronograf: { organizations: organizations, users: users } })=>({
        links: links,
        organizations: organizations,
        users: users
    });
const $5ff6af365959a730$var$mapDispatchToProps = (dispatch)=>({
        actions: (0, $1f80bbeadc1a0021$export$2e2bcd8739ae039)($eb9e4c802dd9bc17$exports, dispatch),
        notify: (0, $1f80bbeadc1a0021$export$2e2bcd8739ae039)((0, $205d139de2918454$export$5e14cdade93d6f7b), dispatch)
    });
var $5ff6af365959a730$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($5ff6af365959a730$var$mapStateToProps, $5ff6af365959a730$var$mapDispatchToProps)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($5ff6af365959a730$var$UsersPage));



var $NdCUR = parcelRequire("NdCUR");



var $b4067703fdb5f3e7$exports = {};

$parcel$export($b4067703fdb5f3e7$exports, "getAuthConfigRequested", function () { return $b4067703fdb5f3e7$export$3a4496abab1ccda0; });
$parcel$export($b4067703fdb5f3e7$exports, "getAuthConfigCompleted", function () { return $b4067703fdb5f3e7$export$99215ea9f98b91bc; });
$parcel$export($b4067703fdb5f3e7$exports, "getAuthConfigFailed", function () { return $b4067703fdb5f3e7$export$1317971a8ed21c9e; });
$parcel$export($b4067703fdb5f3e7$exports, "updateAuthConfigRequested", function () { return $b4067703fdb5f3e7$export$153c55e53a8ffb78; });
$parcel$export($b4067703fdb5f3e7$exports, "updateAuthConfigCompleted", function () { return $b4067703fdb5f3e7$export$a5da4aaee2cd3b1; });
$parcel$export($b4067703fdb5f3e7$exports, "updateAuthConfigFailed", function () { return $b4067703fdb5f3e7$export$a45fdff9a5736ef5; });
$parcel$export($b4067703fdb5f3e7$exports, "getAuthConfigAsync", function () { return $b4067703fdb5f3e7$export$aa50083caea9750d; });
$parcel$export($b4067703fdb5f3e7$exports, "updateAuthConfigAsync", function () { return $b4067703fdb5f3e7$export$f5cc8c3658a00a5f; });

const $afff6eee950efdab$export$43a1ed41a93b382a = async (url)=>{
    try {
        return await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'GET',
            url: url
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $afff6eee950efdab$export$5d6737d3a3a1f0ae = async (url, authConfig)=>{
    try {
        return await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'PUT',
            url: url,
            data: authConfig
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
};



const $b4067703fdb5f3e7$export$3a4496abab1ccda0 = ()=>({
        type: 'CHRONOGRAF_GET_AUTH_CONFIG_REQUESTED'
    });
const $b4067703fdb5f3e7$export$99215ea9f98b91bc = (authConfig)=>({
        type: 'CHRONOGRAF_GET_AUTH_CONFIG_COMPLETED',
        payload: {
            authConfig: authConfig
        }
    });
const $b4067703fdb5f3e7$export$1317971a8ed21c9e = ()=>({
        type: 'CHRONOGRAF_GET_AUTH_CONFIG_FAILED'
    });
const $b4067703fdb5f3e7$export$153c55e53a8ffb78 = (authConfig)=>({
        type: 'CHRONOGRAF_UPDATE_AUTH_CONFIG_REQUESTED',
        payload: {
            authConfig: authConfig
        }
    });
const $b4067703fdb5f3e7$export$a5da4aaee2cd3b1 = ()=>({
        type: 'CHRONOGRAF_UPDATE_AUTH_CONFIG_COMPLETED'
    });
const $b4067703fdb5f3e7$export$a45fdff9a5736ef5 = (authConfig)=>({
        type: 'CHRONOGRAF_UPDATE_AUTH_CONFIG_FAILED',
        payload: {
            authConfig: authConfig
        }
    });
const $b4067703fdb5f3e7$export$aa50083caea9750d = (url)=>async (dispatch)=>{
        dispatch($b4067703fdb5f3e7$export$3a4496abab1ccda0());
        try {
            const { data: data } = await (0, $afff6eee950efdab$export$43a1ed41a93b382a)(url);
            dispatch($b4067703fdb5f3e7$export$99215ea9f98b91bc(data)) // TODO: change authConfig in actions & reducers to reflect final shape
            ;
        } catch (error) {
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error));
            dispatch($b4067703fdb5f3e7$export$1317971a8ed21c9e());
        }
    };
const $b4067703fdb5f3e7$export$f5cc8c3658a00a5f = (url, oldAuthConfig, updatedAuthConfig)=>async (dispatch)=>{
        const newAuthConfig = {
            ...oldAuthConfig,
            ...updatedAuthConfig
        };
        dispatch($b4067703fdb5f3e7$export$153c55e53a8ffb78(newAuthConfig));
        try {
            await (0, $afff6eee950efdab$export$5d6737d3a3a1f0ae)(url, newAuthConfig);
            dispatch($b4067703fdb5f3e7$export$a5da4aaee2cd3b1());
        } catch (error) {
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error));
            dispatch($b4067703fdb5f3e7$export$a45fdff9a5736ef5(oldAuthConfig));
        }
    };





var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");

var $NdCUR = parcelRequire("NdCUR");


class $9a8056ab4d9ff569$var$AllUsersTableHeader extends (0, $NdCUR.Component) {
    static{
        this.defaultProps = {
            numUsers: 0,
            numOrganizations: 0,
            isCreatingUser: false
        };
    }
    render() {
        const { numUsers: numUsers, numOrganizations: numOrganizations, onClickCreateUser: onClickCreateUser, isCreatingUser: isCreatingUser, authConfig: { superAdminNewUsers: superAdminNewUsers } } = this.props;
        const numUsersString = `${numUsers} User${numUsers === 1 ? '' : 's'}`;
        const numOrganizationsString = `${numOrganizations} Org${numOrganizations === 1 ? '' : 's'}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel-heading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h2", {
            className: "panel-title"
        }, numUsersString, " across ", numOrganizationsString), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "all-users-admin-toggle"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $4115c6d17e8dc56b$export$2e2bcd8739ae039), {
            color: (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Success,
            size: (0, $918c9f03a35fe03f$export$fafce5c139da9687).Small,
            active: superAdminNewUsers,
            onChange: this.handleToggleClick,
            testId: "new-user-admins--toggle"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", null, "All new users are SuperAdmins")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-primary btn-sm",
            onClick: onClickCreateUser,
            disabled: isCreatingUser || !onClickCreateUser,
            "data-test": "add-user--button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon plus"
        }), "Add User")));
    }
    constructor(...args){
        super(...args), this.handleToggleClick = ()=>{
            const { onChangeAuthConfig: onChangeAuthConfig, authConfig: { superAdminNewUsers: superAdminNewUsers } } = this.props;
            const fieldName = 'superAdminNewUsers';
            const newConfig = !superAdminNewUsers;
            onChangeAuthConfig(fieldName)(newConfig);
        };
    }
}
var $9a8056ab4d9ff569$export$2e2bcd8739ae039 = $9a8056ab4d9ff569$var$AllUsersTableHeader;



var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");







const { colOrganizations: $ef42b88559190b9a$var$colOrganizations, colProvider: $ef42b88559190b9a$var$colProvider, colScheme: $ef42b88559190b9a$var$colScheme, colSuperAdmin: $ef42b88559190b9a$var$colSuperAdmin, colActions: $ef42b88559190b9a$var$colActions } = (0, $7ba9f168b2e3ae7f$export$52ce62778f54cb60);
const $ef42b88559190b9a$var$nullOrganization = {
    id: undefined,
    name: 'None'
};
const $ef42b88559190b9a$var$nullRole = {
    name: '*',
    organization: undefined
};
class $ef42b88559190b9a$var$AllUsersTableRowNew extends (0, $NdCUR.Component) {
    constructor(props){
        super(props);
        this.state = {
            name: '',
            provider: '',
            scheme: 'oauth2',
            role: {
                ...$ef42b88559190b9a$var$nullRole
            }
        };
    }
    handleInputChange = (fieldName)=>(e)=>{
            this.setState({
                [fieldName]: e.target.value.trim()
            });
        };
    handleConfirmCreateUser = ()=>{
        const { onBlur: onBlur, onCreateUser: onCreateUser } = this.props;
        const { name: name, provider: provider, scheme: scheme, role: role, superAdmin: superAdmin } = this.state;
        const newUser = {
            name: name,
            provider: provider,
            scheme: scheme,
            superAdmin: superAdmin,
            // since you can only choose one organization, there is only one role in a new row
            // if no organization is selected ie the "None" organization,
            // then set roles to an empty array
            roles: role.organization === undefined ? [] : [
                role
            ]
        };
        onCreateUser(newUser);
        onBlur();
    };
    handleInputFocus = (e)=>{
        e.target.select();
    };
    handleSelectOrganization = (newOrganization)=>{
        // if "None" was selected for organization, create a "null role" from the predefined null role
        // else create a new role with the organization as the newOrganization's id
        const newRole = newOrganization.id === undefined ? {
            ...$ef42b88559190b9a$var$nullRole
        } : {
            organization: newOrganization.id,
            name: '*'
        };
        this.setState({
            role: newRole
        });
    };
    handleKeyDown = (e)=>{
        const { name: name, provider: provider } = this.state;
        const preventCreate = !name || !provider;
        if (e.key === 'Escape') this.props.onBlur();
        if (e.key === 'Enter') {
            if (preventCreate) return this.props.notify((0, $ec1f42de4faacc37$export$ff016350b0e7cf48)());
            this.handleConfirmCreateUser();
        }
    };
    render() {
        const { organizations: organizations, onBlur: onBlur } = this.props;
        const { name: name, provider: provider, scheme: scheme, role: role } = this.state;
        const dropdownOrganizationsItems = [
            {
                ...$ef42b88559190b9a$var$nullOrganization
            },
            ...organizations
        ].map((o)=>({
                ...o,
                text: o.name
            }));
        const selectedRole = dropdownOrganizationsItems.find((o)=>role.organization === o.id);
        const preventCreate = !name || !provider;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tr", {
            className: "chronograf-admin-table--new-user",
            "data-test": "new-user--table-row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control input-xs",
            type: "text",
            placeholder: "OAuth Username...",
            autoFocus: true,
            value: name,
            onChange: this.handleInputChange('name'),
            onKeyDown: this.handleKeyDown,
            "data-test": "username--input"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            style: {
                width: $ef42b88559190b9a$var$colOrganizations
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ca4f14339173643c$export$2e2bcd8739ae039), {
            items: dropdownOrganizationsItems,
            selected: selectedRole.text,
            onChoose: this.handleSelectOrganization,
            buttonColor: "btn-primary",
            buttonSize: "btn-xs",
            className: "dropdown-stretch"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            style: {
                width: $ef42b88559190b9a$var$colProvider
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control input-xs",
            type: "text",
            placeholder: "OAuth Provider...",
            value: provider,
            onChange: this.handleInputChange('provider'),
            onKeyDown: this.handleKeyDown,
            "data-test": "oauth-provider--input"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            style: {
                width: $ef42b88559190b9a$var$colScheme
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control input-xs disabled",
            type: "text",
            disabled: true,
            placeholder: "OAuth Scheme...",
            value: scheme,
            "data-test": "oauth-schema--input"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            style: {
                width: $ef42b88559190b9a$var$colSuperAdmin
            },
            className: "text-center"
        }, "\u2014"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            className: "text-right",
            style: {
                width: $ef42b88559190b9a$var$colActions
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-xs btn-square btn-info",
            onClick: onBlur,
            "data-test": "cancel-new-user--button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon remove"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-xs btn-square btn-success",
            disabled: preventCreate,
            onClick: this.handleConfirmCreateUser,
            "data-test": "confirm-new-user--button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon checkmark"
        }))));
    }
}
const { arrayOf: $ef42b88559190b9a$var$arrayOf, func: $ef42b88559190b9a$var$func, shape: $ef42b88559190b9a$var$shape, string: $ef42b88559190b9a$var$string } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$ef42b88559190b9a$var$AllUsersTableRowNew.propTypes = {
    organizations: $ef42b88559190b9a$var$arrayOf($ef42b88559190b9a$var$shape({
        id: $ef42b88559190b9a$var$string.isRequired,
        name: $ef42b88559190b9a$var$string.isRequired
    })),
    onBlur: $ef42b88559190b9a$var$func.isRequired,
    onCreateUser: $ef42b88559190b9a$var$func.isRequired,
    notify: $ef42b88559190b9a$var$func.isRequired
};
const $ef42b88559190b9a$var$mapDispatchToProps = (dispatch)=>({
        notify: (0, $1f80bbeadc1a0021$export$2e2bcd8739ae039)((0, $205d139de2918454$export$5e14cdade93d6f7b), dispatch)
    });
var $ef42b88559190b9a$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)(null, $ef42b88559190b9a$var$mapDispatchToProps)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($ef42b88559190b9a$var$AllUsersTableRowNew));



var $NdCUR = parcelRequire("NdCUR");

var $hBdgJ = parcelRequire("hBdgJ");






const { colOrganizations: $69c90448ef483021$var$colOrganizations, colProvider: $69c90448ef483021$var$colProvider, colScheme: $69c90448ef483021$var$colScheme, colSuperAdmin: $69c90448ef483021$var$colSuperAdmin, colActions: $69c90448ef483021$var$colActions } = (0, $7ba9f168b2e3ae7f$export$52ce62778f54cb60);
class $69c90448ef483021$var$AllUsersTableRow extends (0, $NdCUR.Component) {
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEqual(nextProps.user, this.props.user);
    }
    render() {
        const { user: user, onRemoveFromOrganization: onRemoveFromOrganization, onAddToOrganization: onAddToOrganization } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tr", {
            className: 'chronograf-admin-table--user',
            "data-test": `${user.name}--table-row`
        }, this.userNameTableCell, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            style: {
                width: $69c90448ef483021$var$colOrganizations
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $099d0b83ed311b1f$export$2e2bcd8739ae039), {
            tags: this.userOrganizationTags,
            confirmText: "Remove user from organization?",
            onDeleteTag: onRemoveFromOrganization(user),
            addMenuItems: this.dropdownOrganizationsItems,
            addMenuChoose: onAddToOrganization(user)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            style: {
                width: $69c90448ef483021$var$colProvider
            }
        }, user.provider), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            style: {
                width: $69c90448ef483021$var$colScheme
            }
        }, user.scheme), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            style: {
                width: $69c90448ef483021$var$colSuperAdmin
            },
            className: "text-center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $4115c6d17e8dc56b$export$2e2bcd8739ae039), {
            active: user.superAdmin,
            onChange: this.handleToggleClick,
            size: (0, $918c9f03a35fe03f$export$fafce5c139da9687).ExtraSmall,
            color: (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Success,
            disabled: this.userIsMe,
            tooltipText: this.toggleTooltipText,
            testId: "superAdmin--toggle"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            style: {
                textAlign: 'right',
                width: $69c90448ef483021$var$colActions
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $8008717819fc7a5f$export$2e2bcd8739ae039), {
            confirmText: this.removeWarning,
            confirmAction: this.handleDelete,
            size: "btn-xs",
            type: "btn-danger",
            text: "Delete",
            customClass: "table--show-on-row-hover",
            testId: "delete-user--button"
        })));
    }
    get toggleTooltipText() {
        if (this.userIsMe) return 'You cannot demote yourself';
    }
    get userNameTableCell() {
        const { user: user } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", null, this.userIsMe ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("strong", {
            className: "chronograf-user--me"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon user"
        }), user.name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("strong", null, user.name));
    }
    get userOrganizationTags() {
        return this.userRoles.map((role)=>({
                ...role,
                name: this.findOrganizationByRole(role)?.name
            })).filter((x)=>x.name !== undefined);
    }
    findOrganizationByRole(role) {
        const { organizations: organizations } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).find(organizations, (org)=>role.organization === org.id);
    }
    get removeWarning() {
        if (this.userIsMe) return 'Delete your user record\nand log yourself out?';
        return 'Delete this user?';
    }
    get userIsMe() {
        const { user: user, meID: meID } = this.props;
        return user.id === meID;
    }
    get dropdownOrganizationsItems() {
        return this.userOrganizations.map((o)=>({
                ...o,
                text: o.name
            }));
    }
    get userOrganizations() {
        const { organizations: organizations } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).filter(organizations, (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).negate(this.isUserOrganization));
    }
    get userRoles() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).get(this.props.user, 'roles', []);
    }
    constructor(...args){
        super(...args), this.handleToggleClick = ()=>{
            const { user: user, onChangeSuperAdmin: onChangeSuperAdmin } = this.props;
            onChangeSuperAdmin(user);
        }, this.isUserOrganization = (organization)=>{
            return !!(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).find(this.userRoles, (role)=>role.organization === organization.id);
        }, this.handleDelete = ()=>{
            const { onDelete: onDelete, user: user } = this.props;
            onDelete(user);
        };
    }
}
var $69c90448ef483021$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($69c90448ef483021$var$AllUsersTableRow);






const { colOrganizations: $cf2dc5801713f71e$var$colOrganizations, colProvider: $cf2dc5801713f71e$var$colProvider, colScheme: $cf2dc5801713f71e$var$colScheme, colSuperAdmin: $cf2dc5801713f71e$var$colSuperAdmin, colActions: $cf2dc5801713f71e$var$colActions } = (0, $7ba9f168b2e3ae7f$export$52ce62778f54cb60);
class $cf2dc5801713f71e$var$AllUsersTable extends (0, $NdCUR.Component) {
    constructor(props){
        super(props);
        this.state = {
            isCreatingUser: false
        };
    }
    handleUpdateAuthConfig = (fieldName)=>(updatedValue)=>{
            const { actionsConfig: { updateAuthConfigAsync: updateAuthConfigAsync }, authConfig: authConfig, links: links } = this.props;
            const updatedAuthConfig = {
                ...authConfig,
                [fieldName]: updatedValue
            };
            updateAuthConfigAsync(links.config.auth, authConfig, updatedAuthConfig);
        };
    handleAddToOrganization = (user)=>(organization)=>{
            // '*' tells the server to fill in the current defaultRole of that org
            const newRoles = user.roles.concat({
                organization: organization.id,
                name: '*'
            });
            this.props.onUpdateUserRoles(user, newRoles, (0, $ec1f42de4faacc37$export$c0bafb2e341faca8)(user.name, organization.name));
        };
    handleRemoveFromOrganization = (user)=>(role)=>{
            const newRoles = user.roles.filter((r)=>r.organization !== role.organization);
            const { name: name } = this.props.organizations.find((o)=>o.id === role.organization);
            this.props.onUpdateUserRoles(user, newRoles, (0, $ec1f42de4faacc37$export$bd9d907d4a68e0aa)(user.name, name));
        };
    handleChangeSuperAdmin = (user)=>{
        const newStatus = !user.superAdmin;
        this.props.onUpdateUserSuperAdmin(user, newStatus);
    };
    handleClickCreateUser = ()=>{
        this.setState({
            isCreatingUser: true
        });
    };
    handleBlurCreateUserRow = ()=>{
        this.setState({
            isCreatingUser: false
        });
    };
    render() {
        const { users: users, organizations: organizations, onCreateUser: onCreateUser, authConfig: authConfig, meID: meID, onDeleteUser: onDeleteUser, isLoading: isLoading } = this.props;
        const { isCreatingUser: isCreatingUser } = this.state;
        if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel panel-solid"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $810ad5a94daa03b8$export$2e2bcd8739ae039), null)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel panel-solid"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $9a8056ab4d9ff569$export$2e2bcd8739ae039), {
            numUsers: users.length,
            numOrganizations: organizations.length,
            onClickCreateUser: this.handleClickCreateUser,
            isCreatingUser: isCreatingUser,
            authConfig: authConfig,
            onChangeAuthConfig: this.handleUpdateAuthConfig
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("table", {
            className: "table table-highlight v-center chronograf-admin-table"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", null, "Username"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
            style: {
                width: $cf2dc5801713f71e$var$colOrganizations
            },
            className: "align-with-col-text"
        }, "Organizations"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
            style: {
                width: $cf2dc5801713f71e$var$colProvider
            }
        }, "Provider"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
            style: {
                width: $cf2dc5801713f71e$var$colScheme
            }
        }, "Scheme"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
            style: {
                width: $cf2dc5801713f71e$var$colSuperAdmin
            },
            className: "text-center"
        }, "SuperAdmin"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
            className: "text-right",
            style: {
                width: $cf2dc5801713f71e$var$colActions
            }
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tbody", null, users.length ? users.map((user)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $69c90448ef483021$export$2e2bcd8739ae039), {
                user: user,
                key: user.id,
                organizations: organizations,
                onAddToOrganization: this.handleAddToOrganization,
                onRemoveFromOrganization: this.handleRemoveFromOrganization,
                onChangeSuperAdmin: this.handleChangeSuperAdmin,
                onDelete: onDeleteUser,
                meID: meID
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tr", {
            className: "table-empty-state"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
            colSpan: "6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, "No Users to display"))), isCreatingUser ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ef42b88559190b9a$export$2e2bcd8739ae039), {
            organizations: organizations,
            onBlur: this.handleBlurCreateUserRow,
            onCreateUser: onCreateUser
        }) : null))));
    }
}
const { arrayOf: $cf2dc5801713f71e$var$arrayOf, bool: $cf2dc5801713f71e$var$bool, func: $cf2dc5801713f71e$var$func, shape: $cf2dc5801713f71e$var$shape, string: $cf2dc5801713f71e$var$string } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$cf2dc5801713f71e$var$AllUsersTable.propTypes = {
    links: $cf2dc5801713f71e$var$shape({
        config: $cf2dc5801713f71e$var$shape({
            auth: $cf2dc5801713f71e$var$string.isRequired
        }).isRequired
    }).isRequired,
    users: $cf2dc5801713f71e$var$arrayOf($cf2dc5801713f71e$var$shape({
        id: $cf2dc5801713f71e$var$string,
        links: $cf2dc5801713f71e$var$shape({
            self: $cf2dc5801713f71e$var$string.isRequired
        }),
        name: $cf2dc5801713f71e$var$string.isRequired,
        provider: $cf2dc5801713f71e$var$string.isRequired,
        roles: $cf2dc5801713f71e$var$arrayOf($cf2dc5801713f71e$var$shape({
            name: $cf2dc5801713f71e$var$string.isRequired,
            organization: $cf2dc5801713f71e$var$string.isRequired
        })),
        scheme: $cf2dc5801713f71e$var$string.isRequired,
        superAdmin: $cf2dc5801713f71e$var$bool
    })).isRequired,
    organizations: $cf2dc5801713f71e$var$arrayOf($cf2dc5801713f71e$var$shape({
        name: $cf2dc5801713f71e$var$string.isRequired,
        id: $cf2dc5801713f71e$var$string.isRequired
    })),
    onCreateUser: $cf2dc5801713f71e$var$func.isRequired,
    onUpdateUserRoles: $cf2dc5801713f71e$var$func.isRequired,
    onUpdateUserSuperAdmin: $cf2dc5801713f71e$var$func.isRequired,
    onDeleteUser: $cf2dc5801713f71e$var$func.isRequired,
    actionsConfig: $cf2dc5801713f71e$var$shape({
        getAuthConfigAsync: $cf2dc5801713f71e$var$func.isRequired,
        updateAuthConfigAsync: $cf2dc5801713f71e$var$func.isRequired
    }),
    authConfig: $cf2dc5801713f71e$var$shape({
        superAdminNewUsers: $cf2dc5801713f71e$var$bool
    }),
    meID: $cf2dc5801713f71e$var$string.isRequired,
    isLoading: $cf2dc5801713f71e$var$bool.isRequired
};
var $cf2dc5801713f71e$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($cf2dc5801713f71e$var$AllUsersTable);


class $0595b51b6eb43d5f$export$f8cfc90f08bda420 extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.handleCreateUser = (user)=>{
            const { links: links, actionsAdmin: { createUserAsync: createUserAsync } } = this.props;
            createUserAsync(links.allUsers, user);
        }, this.handleUpdateUserRoles = (user, roles, successMessage)=>{
            const { actionsAdmin: { updateUserAsync: updateUserAsync } } = this.props;
            const updatedUser = {
                ...user,
                roles: roles
            };
            updateUserAsync(user, updatedUser, successMessage);
        }, this.handleUpdateUserSuperAdmin = (user, superAdmin)=>{
            const { actionsAdmin: { updateUserAsync: updateUserAsync } } = this.props;
            const updatedUser = {
                ...user,
                superAdmin: superAdmin
            };
            updateUserAsync(user, updatedUser, `${user.name}'s SuperAdmin status has been updated`);
        }, this.handleDeleteUser = (user)=>{
            const { actionsAdmin: { deleteUserAsync: deleteUserAsync } } = this.props;
            deleteUserAsync(user, {
                isAbsoluteDelete: true
            });
        };
        this.state = {
            isLoading: true
        };
    }
    componentDidMount() {
        const { links: links, actionsConfig: { getAuthConfigAsync: getAuthConfigAsync } } = this.props;
        getAuthConfigAsync(links.config.auth);
    }
    async UNSAFE_componentWillMount() {
        const { links: links, actionsAdmin: { loadOrganizationsAsync: loadOrganizationsAsync, loadUsersAsync: loadUsersAsync } } = this.props;
        this.setState({
            isLoading: true
        });
        await Promise.all([
            loadOrganizationsAsync(links.organizations),
            loadUsersAsync(links.allUsers)
        ]);
        this.setState({
            isLoading: false
        });
    }
    render() {
        const { meID: meID, users: users, links: links, notify: notify, authConfig: authConfig, actionsConfig: actionsConfig, organizations: organizations } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $cf2dc5801713f71e$export$2e2bcd8739ae039), {
            meID: meID,
            users: users,
            links: links,
            notify: notify,
            authConfig: authConfig,
            actionsConfig: actionsConfig,
            organizations: organizations,
            isLoading: this.state.isLoading,
            onDeleteUser: this.handleDeleteUser,
            onCreateUser: this.handleCreateUser,
            onUpdateUserRoles: this.handleUpdateUserRoles,
            onUpdateUserSuperAdmin: this.handleUpdateUserSuperAdmin
        });
    }
}
const $0595b51b6eb43d5f$var$mapStateToProps = ({ links: links, adminChronograf: { organizations: organizations, users: users }, config: { auth: authConfig } })=>({
        authConfig: authConfig,
        links: links,
        organizations: organizations,
        users: users
    });
const $0595b51b6eb43d5f$var$mapDispatchToProps = (dispatch)=>({
        actionsAdmin: (0, $1f80bbeadc1a0021$export$2e2bcd8739ae039)($eb9e4c802dd9bc17$exports, dispatch),
        actionsConfig: (0, $1f80bbeadc1a0021$export$2e2bcd8739ae039)($b4067703fdb5f3e7$exports, dispatch),
        notify: (0, $1f80bbeadc1a0021$export$2e2bcd8739ae039)((0, $205d139de2918454$export$5e14cdade93d6f7b), dispatch)
    });
var $0595b51b6eb43d5f$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($0595b51b6eb43d5f$var$mapStateToProps, $0595b51b6eb43d5f$var$mapDispatchToProps)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($0595b51b6eb43d5f$export$f8cfc90f08bda420));



var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");






var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");

var $hBdgJ = parcelRequire("hBdgJ");

var $NdCUR = parcelRequire("NdCUR");




var $hBdgJ = parcelRequire("hBdgJ");



var $NdCUR = parcelRequire("NdCUR");

class $9823a99966f955b2$var$InputClickToEdit extends (0, $NdCUR.PureComponent) {
    static{
        this.defaultProps = {
            tabIndex: 0
        };
    }
    constructor(props){
        super(props);
        this.state = {
            initialValue: this.props.value,
            isEditing: false
        };
        this.handleCancel = this.handleCancel.bind(this);
        this.handleInputClick = this.handleInputClick.bind(this);
        this.handleInputBlur = this.handleInputBlur.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
    }
    handleCancel() {
        const { onChange: onChange } = this.props;
        const { initialValue: initialValue } = this.state;
        this.setState({
            isEditing: false
        });
        if (onChange) onChange(initialValue);
    }
    handleInputClick() {
        this.setState({
            isEditing: true
        });
    }
    handleInputBlur(e) {
        const { onBlur: onBlur, value: value } = this.props;
        if (value !== e.target.value) onBlur(e.target.value);
        this.setState({
            initialValue: e.target.value,
            isEditing: false
        });
    }
    handleKeyDown(e) {
        const { onBlur: onBlur, value: value } = this.props;
        if (e.key === 'Enter') {
            if (value !== e.currentTarget.value) onBlur(e.currentTarget.value);
            this.setState({
                initialValue: e.currentTarget.value,
                isEditing: false
            });
        }
        if (e.key === 'Escape') this.handleCancel();
    }
    handleChange(e) {
        const { onChange: onChange } = this.props;
        if (onChange) onChange(e.target.value);
    }
    handleFocus(e) {
        e.target.select();
    }
    render() {
        const { isEditing: isEditing } = this.state;
        const { wrapperClass: wrapper, disabled: disabled, tabIndex: tabIndex, placeholder: placeholder, value: value, appearAsNormalInput: appearAsNormalInput, testId: testId = 'icte' } = this.props;
        const wrapperClass = `${wrapper}${appearAsNormalInput ? ' input-cte__normal' : ''}`;
        const defaultStyle = value ? 'input-cte' : 'input-cte__empty';
        return disabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: wrapperClass
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            "data-test": "disabled",
            className: "input-cte__disabled"
        }, value)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: wrapperClass
        }, isEditing ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            type: "text",
            className: "form-control input-sm provider--input",
            defaultValue: value,
            onBlur: this.handleInputBlur,
            onKeyDown: this.handleKeyDown,
            onChange: this.handleChange,
            autoFocus: true,
            onFocus: this.handleFocus,
            tabIndex: tabIndex,
            spellCheck: false,
            "data-test": `${testId}--input`
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: defaultStyle,
            onClick: this.handleInputClick,
            onFocus: this.handleInputClick,
            tabIndex: tabIndex,
            "data-test": `${testId}-name`
        }, value || placeholder, appearAsNormalInput || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            "data-test": "icon",
            className: "icon pencil"
        })));
    }
}
var $9823a99966f955b2$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($9823a99966f955b2$var$InputClickToEdit);





class $34091c793c03bab8$var$OrganizationsTableRow extends (0, $NdCUR.Component) {
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEqual(this.props, nextProps);
    }
    render() {
        const { organization: organization, currentOrganization: currentOrganization } = this.props;
        const dropdownRolesItems = (0, $603926c3b7bd4a9b$export$7c6317deeec7a6c1).map((role)=>({
                ...role,
                text: role.name
            }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "fancytable--row",
            "data-test": `${organization.name}-org--row`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "fancytable--td orgs-table--active"
        }, organization.id === currentOrganization.id ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-sm btn-success",
            "data-test": "current-org--button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon checkmark"
        }), " Current") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-sm btn-default",
            onClick: this.handleChangeCurrentOrganization,
            "data-test": "switch-current-org--button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon shuffle"
        }), " Switch to")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $9823a99966f955b2$export$2e2bcd8739ae039), {
            value: organization.name,
            wrapperClass: "fancytable--td orgs-table--name",
            onBlur: this.handleUpdateOrgName,
            testId: `${organization.name}-org`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "fancytable--td orgs-table--default-role"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ca4f14339173643c$export$2e2bcd8739ae039), {
            items: dropdownRolesItems,
            onChoose: this.handleChooseDefaultRole,
            selected: organization.defaultRole,
            className: "dropdown-stretch"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $8008717819fc7a5f$export$2e2bcd8739ae039), {
            confirmAction: this.handleDeleteOrg,
            confirmText: "Delete Organization?",
            size: "btn-sm",
            square: true,
            icon: "trash",
            disabled: organization.id === (0, $603926c3b7bd4a9b$export$a471ccbb4f8b12ef),
            testId: "delete-org--button"
        }));
    }
    constructor(...args){
        super(...args), this.handleChangeCurrentOrganization = async ()=>{
            const { router: router, links: links, meChangeOrganization: meChangeOrganization, organization: organization } = this.props;
            // eslint-disable-next-line @typescript-eslint/await-thenable
            await meChangeOrganization(links.me, {
                organization: organization.id
            });
            router.push('');
        }, this.handleUpdateOrgName = (newName)=>{
            const { organization: organization, onRename: onRename } = this.props;
            onRename(organization, newName);
        }, this.handleDeleteOrg = ()=>{
            const { onDelete: onDelete, organization: organization } = this.props;
            onDelete(organization);
        }, this.handleChooseDefaultRole = (role)=>{
            const { organization: organization, onChooseDefaultRole: onChooseDefaultRole } = this.props;
            onChooseDefaultRole(organization, role.name);
        };
    }
}
const $34091c793c03bab8$var$mapDispatchToProps = (dispatch)=>({
        meChangeOrganization: (0, $1f80bbeadc1a0021$export$2e2bcd8739ae039)((0, $7af565d99d629ce9$export$5327fe44904ab84d), dispatch)
    });
const $34091c793c03bab8$var$mapStateToProps = ({ links: links })=>({
        links: links
    });
var $34091c793c03bab8$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($34091c793c03bab8$var$mapStateToProps, $34091c793c03bab8$var$mapDispatchToProps)((0, $dffbdf89c590a961$export$2e2bcd8739ae039)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($34091c793c03bab8$var$OrganizationsTableRow)));



var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");





class $21818e37c5ebb255$var$OrganizationsTableRowNew extends (0, $NdCUR.Component) {
    constructor(props){
        super(props);
        this.state = {
            name: 'Untitled Organization',
            defaultRole: (0, $a7910b1002260d34$export$2959f045e897f38b)
        };
    }
    handleKeyDown = (e)=>{
        const { onCancelCreateOrganization: onCancelCreateOrganization } = this.props;
        if (e.key === 'Escape') onCancelCreateOrganization();
        if (e.key === 'Enter') this.handleClickSave();
    };
    handleInputChange = (e)=>{
        this.setState({
            name: e.target.value
        });
    };
    handleInputFocus = (e)=>{
        e.target.select();
    };
    handleClickSave = ()=>{
        const { onCreateOrganization: onCreateOrganization } = this.props;
        const { name: name, defaultRole: defaultRole } = this.state;
        onCreateOrganization({
            name: name.trim(),
            defaultRole: defaultRole
        });
    };
    handleChooseDefaultRole = (role)=>{
        this.setState({
            defaultRole: role.name
        });
    };
    render() {
        const { name: name, defaultRole: defaultRole } = this.state;
        const { onCancelCreateOrganization: onCancelCreateOrganization } = this.props;
        const isSaveDisabled = name === null || name === '';
        const dropdownRolesItems = (0, $603926c3b7bd4a9b$export$7c6317deeec7a6c1).map((role)=>({
                ...role,
                text: role.name
            }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "fancytable--row",
            "data-test": "new-org--row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "fancytable--td orgs-table--active"
        }, "\u2014"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "fancytable--td orgs-table--name"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            type: "text",
            className: "form-control input-sm",
            value: name,
            onKeyDown: this.handleKeyDown,
            onChange: this.handleInputChange,
            onFocus: this.handleInputFocus,
            placeholder: "Name this Organization...",
            autoFocus: true,
            ref: (r)=>this.inputRef = r,
            "data-test": "new-org-name--input"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "fancytable--td orgs-table--default-role creating"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ca4f14339173643c$export$2e2bcd8739ae039), {
            items: dropdownRolesItems,
            onChoose: this.handleChooseDefaultRole,
            selected: defaultRole,
            className: "dropdown-stretch"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b4a526e8eda76ab1$export$2e2bcd8739ae039), {
            disabled: isSaveDisabled,
            onCancel: onCancelCreateOrganization,
            onConfirm: this.handleClickSave,
            confirmLeft: true
        }));
    }
}
const { func: $21818e37c5ebb255$var$func } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$21818e37c5ebb255$var$OrganizationsTableRowNew.propTypes = {
    onCreateOrganization: $21818e37c5ebb255$var$func.isRequired,
    onCancelCreateOrganization: $21818e37c5ebb255$var$func.isRequired
};
var $21818e37c5ebb255$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($21818e37c5ebb255$var$OrganizationsTableRowNew);




class $b7278ac1326e8955$var$OrganizationsTable extends (0, $NdCUR.Component) {
    constructor(props){
        super(props);
        this.state = {
            isCreatingOrganization: false
        };
    }
    shouldComponentUpdate(nextProps, nextState) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEqual(this.props, nextProps) || !(0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).isEqual(this.state, nextState);
    }
    handleClickCreateOrganization = ()=>{
        this.setState({
            isCreatingOrganization: true
        });
    };
    handleCancelCreateOrganization = ()=>{
        this.setState({
            isCreatingOrganization: false
        });
    };
    handleCreateOrganization = (organization)=>{
        const { onCreateOrg: onCreateOrg } = this.props;
        onCreateOrg(organization);
        this.setState({
            isCreatingOrganization: false
        });
    };
    render() {
        const { organizations: organizations, onDeleteOrg: onDeleteOrg, onRenameOrg: onRenameOrg, onChooseDefaultRole: onChooseDefaultRole, currentOrganization: currentOrganization } = this.props;
        const { isCreatingOrganization: isCreatingOrganization } = this.state;
        const tableTitle = `${organizations.length} Organization${organizations.length === 1 ? '' : 's'}`;
        if (!organizations.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel panel-solid"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $810ad5a94daa03b8$export$2e2bcd8739ae039), null)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel panel-solid"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel-heading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h2", {
            className: "panel-title"
        }, tableTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-sm btn-primary",
            onClick: this.handleClickCreateOrganization,
            disabled: isCreatingOrganization,
            "data-test": "create-new-org--button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon plus"
        }), " Create Organization")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "fancytable--labels"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "fancytable--th orgs-table--active"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "fancytable--th orgs-table--name"
        }, "Name"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "fancytable--th orgs-table--default-role"
        }, "Default Role"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "fancytable--th orgs-table--delete"
        })), isCreatingOrganization ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $21818e37c5ebb255$export$2e2bcd8739ae039), {
            onCreateOrganization: this.handleCreateOrganization,
            onCancelCreateOrganization: this.handleCancelCreateOrganization
        }) : null, organizations.map((org)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $34091c793c03bab8$export$2e2bcd8739ae039), {
                key: org.id,
                organization: org,
                onDelete: onDeleteOrg,
                onRename: onRenameOrg,
                onChooseDefaultRole: onChooseDefaultRole,
                currentOrganization: currentOrganization
            }))));
    }
}
const { arrayOf: $b7278ac1326e8955$var$arrayOf, func: $b7278ac1326e8955$var$func, shape: $b7278ac1326e8955$var$shape, string: $b7278ac1326e8955$var$string } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$b7278ac1326e8955$var$OrganizationsTable.propTypes = {
    organizations: $b7278ac1326e8955$var$arrayOf($b7278ac1326e8955$var$shape({
        id: $b7278ac1326e8955$var$string,
        name: $b7278ac1326e8955$var$string.isRequired
    })).isRequired,
    currentOrganization: $b7278ac1326e8955$var$shape({
        name: $b7278ac1326e8955$var$string.isRequired,
        id: $b7278ac1326e8955$var$string.isRequired
    }),
    onCreateOrg: $b7278ac1326e8955$var$func.isRequired,
    onDeleteOrg: $b7278ac1326e8955$var$func.isRequired,
    onRenameOrg: $b7278ac1326e8955$var$func.isRequired,
    onChooseDefaultRole: $b7278ac1326e8955$var$func.isRequired
};
var $b7278ac1326e8955$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($b7278ac1326e8955$var$OrganizationsTable);


class $7d58e29f36e61dc3$var$OrganizationsPage extends (0, $NdCUR.Component) {
    componentDidMount() {
        const { links: links, actionsAdmin: { loadOrganizationsAsync: loadOrganizationsAsync } } = this.props;
        loadOrganizationsAsync(links.organizations);
    }
    handleCreateOrganization = async (organization)=>{
        const { links: links, actionsAdmin: { createOrganizationAsync: createOrganizationAsync } } = this.props;
        await createOrganizationAsync(links.organizations, organization);
        this.refreshMe();
    };
    handleRenameOrganization = async (organization, name)=>{
        const { actionsAdmin: { updateOrganizationAsync: updateOrganizationAsync } } = this.props;
        await updateOrganizationAsync(organization, {
            ...organization,
            name: name
        });
        this.refreshMe();
    };
    handleDeleteOrganization = (organization)=>{
        const { actionsAdmin: { deleteOrganizationAsync: deleteOrganizationAsync } } = this.props;
        deleteOrganizationAsync(organization);
        this.refreshMe();
    };
    refreshMe = ()=>{
        const { getMe: getMe } = this.props;
        getMe({
            shouldResetMe: false
        });
    };
    handleChooseDefaultRole = (organization, defaultRole)=>{
        const { actionsAdmin: { updateOrganizationAsync: updateOrganizationAsync } } = this.props;
        updateOrganizationAsync(organization, {
            ...organization,
            defaultRole: defaultRole
        });
        // refreshMe is here to update the org's defaultRole in `me.organizations`
        this.refreshMe();
    };
    render() {
        const { meCurrentOrganization: meCurrentOrganization, organizations: organizations, me: me } = this.props;
        const organization = organizations.find((o)=>o.id === meCurrentOrganization.id);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b7278ac1326e8955$export$2e2bcd8739ae039), {
            organizations: organizations,
            currentOrganization: organization,
            onCreateOrg: this.handleCreateOrganization,
            onDeleteOrg: this.handleDeleteOrganization,
            onRenameOrg: this.handleRenameOrganization,
            onChooseDefaultRole: this.handleChooseDefaultRole,
            me: me
        });
    }
}
const { arrayOf: $7d58e29f36e61dc3$var$arrayOf, func: $7d58e29f36e61dc3$var$func, shape: $7d58e29f36e61dc3$var$shape, string: $7d58e29f36e61dc3$var$string } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$7d58e29f36e61dc3$var$OrganizationsPage.propTypes = {
    links: $7d58e29f36e61dc3$var$shape({
        organizations: $7d58e29f36e61dc3$var$string.isRequired,
        config: $7d58e29f36e61dc3$var$shape({
            auth: $7d58e29f36e61dc3$var$string.isRequired
        }).isRequired
    }),
    organizations: $7d58e29f36e61dc3$var$arrayOf($7d58e29f36e61dc3$var$shape({
        id: $7d58e29f36e61dc3$var$string,
        name: $7d58e29f36e61dc3$var$string.isRequired,
        link: $7d58e29f36e61dc3$var$string
    })),
    actionsAdmin: $7d58e29f36e61dc3$var$shape({
        loadOrganizationsAsync: $7d58e29f36e61dc3$var$func.isRequired,
        createOrganizationAsync: $7d58e29f36e61dc3$var$func.isRequired,
        updateOrganizationAsync: $7d58e29f36e61dc3$var$func.isRequired,
        deleteOrganizationAsync: $7d58e29f36e61dc3$var$func.isRequired
    }),
    getMe: $7d58e29f36e61dc3$var$func.isRequired,
    meCurrentOrganization: $7d58e29f36e61dc3$var$shape({
        name: $7d58e29f36e61dc3$var$string.isRequired,
        id: $7d58e29f36e61dc3$var$string.isRequired
    }),
    me: $7d58e29f36e61dc3$var$shape({
        organizations: $7d58e29f36e61dc3$var$arrayOf($7d58e29f36e61dc3$var$shape({
            id: $7d58e29f36e61dc3$var$string.isRequired,
            name: $7d58e29f36e61dc3$var$string.isRequired,
            defaultRole: $7d58e29f36e61dc3$var$string.isRequired
        }))
    })
};
const $7d58e29f36e61dc3$var$mapStateToProps = ({ links: links, adminChronograf: { organizations: organizations }, auth: { me: me } })=>({
        links: links,
        organizations: organizations,
        me: me
    });
const $7d58e29f36e61dc3$var$mapDispatchToProps = (dispatch)=>({
        actionsAdmin: (0, $1f80bbeadc1a0021$export$2e2bcd8739ae039)($eb9e4c802dd9bc17$exports, dispatch),
        getMe: (0, $1f80bbeadc1a0021$export$2e2bcd8739ae039)((0, $7af565d99d629ce9$export$2c21f559fb9e5c02), dispatch)
    });
var $7d58e29f36e61dc3$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($7d58e29f36e61dc3$var$mapStateToProps, $7d58e29f36e61dc3$var$mapDispatchToProps)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($7d58e29f36e61dc3$var$OrganizationsPage));



var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");





var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");

var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");





class $144cee226fa72f22$var$ProvidersTableRow extends (0, $NdCUR.Component) {
    constructor(props){
        super(props);
        this.state = {
            ...this.props.mapping
        };
    }
    handleDeleteMap = ()=>{
        const { onDelete: onDelete, mapping: mapping } = this.props;
        onDelete(mapping);
    };
    handleUpdateMapping = (changes)=>{
        const { onUpdate: onUpdate, mapping: mapping } = this.props;
        const newState = {
            ...mapping,
            ...changes
        };
        this.setState(newState);
        onUpdate(mapping, newState);
    };
    handleChangeProvider = (provider)=>this.handleUpdateMapping({
            provider: provider
        });
    handleChangeProviderOrg = (providerOrganization)=>this.handleUpdateMapping({
            providerOrganization: providerOrganization
        });
    handleChooseOrganization = ({ id: organizationId })=>this.handleUpdateMapping({
            organizationId: organizationId
        });
    handleChooseScheme = ({ text: scheme })=>this.handleUpdateMapping({
            scheme: scheme
        });
    render() {
        const { scheme: scheme, provider: provider, providerOrganization: providerOrganization, organizationId: organizationId, isDeleting: isDeleting } = this.state;
        const { organizations: organizations, mapping: mapping, schemes: schemes, rowIndex: rowIndex } = this.props;
        const selectedOrg = organizations.find((o)=>o.id === organizationId);
        const orgDropdownItems = organizations.map((role)=>({
                ...role,
                text: role.name
            }));
        const organizationIdClassName = isDeleting ? 'fancytable--td provider--redirect deleting' : 'fancytable--td provider--redirect';
        const isDefaultMapping = (0, $603926c3b7bd4a9b$export$30f2e46c50bfc896) === mapping.id;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "fancytable--row",
            "data-test": "providers--row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "fancytable--td provider--scheme"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ca4f14339173643c$export$2e2bcd8739ae039), {
            items: schemes,
            onChoose: this.handleChooseScheme,
            selected: scheme,
            className: "dropdown-stretch",
            disabled: isDefaultMapping
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $9823a99966f955b2$export$2e2bcd8739ae039), {
            value: provider,
            wrapperClass: "fancytable--td provider--provider",
            onBlur: this.handleChangeProvider,
            disabled: isDefaultMapping,
            tabIndex: rowIndex,
            testId: "provider"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $9823a99966f955b2$export$2e2bcd8739ae039), {
            value: providerOrganization,
            wrapperClass: "fancytable--td provider--providerorg",
            onBlur: this.handleChangeProviderOrg,
            disabled: isDefaultMapping,
            tabIndex: rowIndex,
            testId: "provider-org"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "fancytable--td provider--arrow"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: organizationIdClassName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ca4f14339173643c$export$2e2bcd8739ae039), {
            items: orgDropdownItems,
            onChoose: this.handleChooseOrganization,
            selected: selectedOrg.name,
            className: "dropdown-stretch",
            disabled: isDefaultMapping
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $8008717819fc7a5f$export$2e2bcd8739ae039), {
            square: true,
            icon: "trash",
            confirmAction: this.handleDeleteMap,
            confirmText: "Delete this Mapping?",
            disabled: isDefaultMapping,
            testId: "delete-mapping--confirm-button"
        }));
    }
}
const { arrayOf: $144cee226fa72f22$var$arrayOf, func: $144cee226fa72f22$var$func, number: $144cee226fa72f22$var$number, shape: $144cee226fa72f22$var$shape, string: $144cee226fa72f22$var$string } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$144cee226fa72f22$var$ProvidersTableRow.propTypes = {
    mapping: $144cee226fa72f22$var$shape({
        id: $144cee226fa72f22$var$string,
        scheme: $144cee226fa72f22$var$string,
        provider: $144cee226fa72f22$var$string,
        providerOrganization: $144cee226fa72f22$var$string,
        organizationId: $144cee226fa72f22$var$string
    }),
    organizations: $144cee226fa72f22$var$arrayOf($144cee226fa72f22$var$shape({
        id: $144cee226fa72f22$var$string.isRequired,
        name: $144cee226fa72f22$var$string.isRequired
    })),
    schemes: $144cee226fa72f22$var$arrayOf($144cee226fa72f22$var$shape({
        text: $144cee226fa72f22$var$string.isRequired
    })),
    rowIndex: $144cee226fa72f22$var$number,
    onDelete: $144cee226fa72f22$var$func.isRequired,
    onUpdate: $144cee226fa72f22$var$func.isRequired
};
var $144cee226fa72f22$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($144cee226fa72f22$var$ProvidersTableRow);



var $NdCUR = parcelRequire("NdCUR");




class $aec65cb334074a34$var$ProvidersTableRowNew extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props);
        this.state = {
            organizationId: 'default',
            provider: null,
            providerOrganization: null,
            scheme: '*'
        };
        this.handleChooseScheme = this.handleChooseScheme.bind(this);
        this.handleChangeProvider = this.handleChangeProvider.bind(this);
        this.handleChangeProviderOrg = this.handleChangeProviderOrg.bind(this);
        this.handleChooseOrganization = this.handleChooseOrganization.bind(this);
        this.handleSaveNewMapping = this.handleSaveNewMapping.bind(this);
    }
    render() {
        const { scheme: scheme, provider: provider, providerOrganization: providerOrganization, organizationId: organizationId } = this.state;
        const { organizations: organizations, onCancel: onCancel, schemes: schemes, rowIndex: rowIndex } = this.props;
        const selectedOrg = organizations.find((o)=>o.id === organizationId);
        const dropdownItems = organizations.map((role)=>({
                ...role,
                text: role.name
            }));
        const preventCreate = !provider || !providerOrganization;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "fancytable--row",
            "data-test": "providers--new-row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "fancytable--td provider--scheme"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ca4f14339173643c$export$2e2bcd8739ae039), {
            items: schemes,
            onChoose: this.handleChooseScheme,
            selected: scheme,
            className: "dropdown-stretch"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $9823a99966f955b2$export$2e2bcd8739ae039), {
            value: provider,
            wrapperClass: "fancytable--td provider--provider",
            onChange: this.handleChangeProvider,
            onBlur: this.handleChangeProvider,
            tabIndex: rowIndex,
            placeholder: "google",
            testId: "new-provider"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $9823a99966f955b2$export$2e2bcd8739ae039), {
            value: providerOrganization,
            wrapperClass: "fancytable--td provider--providerorg",
            onChange: this.handleChangeProviderOrg,
            onBlur: this.handleChangeProviderOrg,
            tabIndex: rowIndex,
            placeholder: "*",
            testId: "new-provider-org"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "fancytable--td provider--arrow"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "fancytable--td provider--redirect creating"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ca4f14339173643c$export$2e2bcd8739ae039), {
            items: dropdownItems,
            onChoose: this.handleChooseOrganization,
            selected: selectedOrg.name,
            className: "dropdown-stretch"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b4a526e8eda76ab1$export$2e2bcd8739ae039), {
            onCancel: onCancel,
            onConfirm: this.handleSaveNewMapping,
            isDisabled: preventCreate
        }));
    }
    handleChooseScheme(scheme) {
        this.setState({
            scheme: scheme.text
        });
    }
    handleChangeProvider(provider) {
        this.setState({
            provider: provider
        });
    }
    handleChangeProviderOrg(providerOrganization) {
        this.setState({
            providerOrganization: providerOrganization
        });
    }
    handleChooseOrganization(org) {
        this.setState({
            organizationId: org.id
        });
    }
    handleSaveNewMapping() {
        const { onCreate: onCreate } = this.props;
        onCreate(this.state);
    }
}
var $aec65cb334074a34$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($aec65cb334074a34$var$ProvidersTableRowNew);




class $8fcfb00c033934a9$var$ProvidersTable extends (0, $NdCUR.Component) {
    constructor(props){
        super(props);
        this.state = {
            isCreatingMap: false
        };
    }
    handleClickCreateMap = ()=>{
        this.setState({
            isCreatingMap: true
        });
    };
    handleCancelCreateMap = ()=>{
        this.setState({
            isCreatingMap: false
        });
    };
    handleCreateMap = (newMap)=>{
        this.props.onCreateMap(newMap);
        this.setState({
            isCreatingMap: false
        });
    };
    render() {
        const { mappings: mappings = [], organizations: organizations, onUpdateMap: onUpdateMap, onDeleteMap: onDeleteMap, isLoading: isLoading } = this.props;
        const { isCreatingMap: isCreatingMap } = this.state;
        const tableTitle = mappings.length === 1 ? '1 Map' : `${mappings.length} Maps`;
        // define scheme options
        const SCHEMES = [
            {
                text: '*'
            },
            {
                text: 'oauth2'
            }
        ];
        if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel panel-solid"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $810ad5a94daa03b8$export$2e2bcd8739ae039), null)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel panel-solid"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel-heading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h2", {
            className: "panel-title"
        }, tableTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-sm btn-primary",
            onClick: this.handleClickCreateMap,
            disabled: isCreatingMap,
            "data-test": "create-mapping--button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon plus"
        }), " Create Mapping")), mappings.length || isCreatingMap ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "fancytable--labels"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "fancytable--th provider--scheme"
        }, "Scheme"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "fancytable--th provider--provider"
        }, "Provider"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "fancytable--th provider--providerorg"
        }, "Provider Org"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "fancytable--th provider--arrow"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "fancytable--th provider--redirect"
        }, "Organization"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "fancytable--th provider--delete"
        })), mappings.map((mapping, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $144cee226fa72f22$export$2e2bcd8739ae039), {
                key: mapping.id,
                mapping: mapping,
                organizations: organizations,
                schemes: SCHEMES,
                onDelete: onDeleteMap,
                onUpdate: onUpdateMap,
                rowIndex: i + 1
            })), isCreatingMap ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $aec65cb334074a34$export$2e2bcd8739ae039), {
            organizations: organizations,
            schemes: SCHEMES,
            onCreate: this.handleCreateMap,
            onCancel: this.handleCancelCreateMap,
            rowIndex: mappings.length + 1
        }) : null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "generic-empty-state"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", {
            style: {
                margin: '50px 0'
            }
        }, "Looks like you have no mappings", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("br", null), "New users will not be able to sign up automatically"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-sm btn-primary",
            onClick: this.handleClickCreateMap,
            disabled: isCreatingMap,
            "data-test": "create-mapping--button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon plus"
        }), " Create Mapping"))));
    }
}
const { arrayOf: $8fcfb00c033934a9$var$arrayOf, bool: $8fcfb00c033934a9$var$bool, func: $8fcfb00c033934a9$var$func, shape: $8fcfb00c033934a9$var$shape, string: $8fcfb00c033934a9$var$string } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$8fcfb00c033934a9$var$ProvidersTable.propTypes = {
    mappings: $8fcfb00c033934a9$var$arrayOf($8fcfb00c033934a9$var$shape({
        id: $8fcfb00c033934a9$var$string,
        scheme: $8fcfb00c033934a9$var$string,
        provider: $8fcfb00c033934a9$var$string,
        providerOrganization: $8fcfb00c033934a9$var$string,
        organizationId: $8fcfb00c033934a9$var$string
    })).isRequired,
    organizations: $8fcfb00c033934a9$var$arrayOf($8fcfb00c033934a9$var$shape({
        id: $8fcfb00c033934a9$var$string,
        name: $8fcfb00c033934a9$var$string.isRequired
    })).isRequired,
    onCreateMap: $8fcfb00c033934a9$var$func.isRequired,
    onUpdateMap: $8fcfb00c033934a9$var$func.isRequired,
    onDeleteMap: $8fcfb00c033934a9$var$func.isRequired,
    isLoading: $8fcfb00c033934a9$var$bool.isRequired
};
var $8fcfb00c033934a9$export$2e2bcd8739ae039 = (0, $855a64e5014f72b2$export$b648208ff1c161a7)($8fcfb00c033934a9$var$ProvidersTable);



class $23c02ae72b96acf8$var$ProvidersPage extends (0, $NdCUR.Component) {
    constructor(props){
        super(props);
        this.state = {
            isLoading: true
        };
    }
    async componentDidMount() {
        const { links: links, actions: { loadOrganizationsAsync: loadOrganizationsAsync, loadMappingsAsync: loadMappingsAsync } } = this.props;
        await Promise.all([
            loadOrganizationsAsync(links.organizations),
            loadMappingsAsync(links.mappings)
        ]);
        this.setState({
            isLoading: false
        });
    }
    handleCreateMap = (mapping)=>{
        this.props.actions.createMappingAsync(this.props.links.mappings, mapping);
    };
    handleUpdateMap = (staleMap, updatedMap)=>{
        this.props.actions.updateMappingAsync(staleMap, updatedMap);
    };
    handleDeleteMap = (mapping)=>{
        this.props.actions.deleteMappingAsync(mapping);
    };
    render() {
        const { organizations: organizations, mappings: mappings = [] } = this.props;
        const { isLoading: isLoading } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $8fcfb00c033934a9$export$2e2bcd8739ae039), {
            mappings: mappings,
            organizations: organizations,
            onCreateMap: this.handleCreateMap,
            onUpdateMap: this.handleUpdateMap,
            onDeleteMap: this.handleDeleteMap,
            isLoading: isLoading
        });
    }
}
const { arrayOf: $23c02ae72b96acf8$var$arrayOf, func: $23c02ae72b96acf8$var$func, shape: $23c02ae72b96acf8$var$shape, string: $23c02ae72b96acf8$var$string } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$23c02ae72b96acf8$var$ProvidersPage.propTypes = {
    links: $23c02ae72b96acf8$var$shape({
        organizations: $23c02ae72b96acf8$var$string.isRequired
    }),
    organizations: $23c02ae72b96acf8$var$arrayOf($23c02ae72b96acf8$var$shape({
        id: $23c02ae72b96acf8$var$string.isRequired,
        name: $23c02ae72b96acf8$var$string.isRequired
    })),
    mappings: $23c02ae72b96acf8$var$arrayOf($23c02ae72b96acf8$var$shape({
        id: $23c02ae72b96acf8$var$string,
        scheme: $23c02ae72b96acf8$var$string,
        provider: $23c02ae72b96acf8$var$string,
        providerOrganization: $23c02ae72b96acf8$var$string,
        organizationId: $23c02ae72b96acf8$var$string
    })),
    actions: $23c02ae72b96acf8$var$shape({
        loadOrganizationsAsync: $23c02ae72b96acf8$var$func.isRequired
    }),
    notify: $23c02ae72b96acf8$var$func.isRequired
};
const $23c02ae72b96acf8$var$mapStateToProps = ({ links: links, adminChronograf: { organizations: organizations, mappings: mappings } })=>({
        links: links,
        organizations: organizations,
        mappings: mappings
    });
const $23c02ae72b96acf8$var$mapDispatchToProps = (dispatch)=>({
        actions: (0, $1f80bbeadc1a0021$export$2e2bcd8739ae039)($eb9e4c802dd9bc17$exports, dispatch),
        notify: (0, $1f80bbeadc1a0021$export$2e2bcd8739ae039)((0, $205d139de2918454$export$5e14cdade93d6f7b), dispatch)
    });
var $23c02ae72b96acf8$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($23c02ae72b96acf8$var$mapStateToProps, $23c02ae72b96acf8$var$mapDispatchToProps)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($23c02ae72b96acf8$var$ProvidersPage));



const $dec327df71eea054$var$sections = (me)=>[
        {
            url: 'current-organization',
            name: 'Current Org',
            enabled: (0, $a7910b1002260d34$export$7d499847c5200082)(me.role, (0, $a7910b1002260d34$export$856b7354d850707e)),
            component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $5ff6af365959a730$export$2e2bcd8739ae039), {
                meID: me.id,
                meCurrentOrganization: me.currentOrganization
            })
        },
        {
            url: 'all-users',
            name: 'All Users',
            enabled: (0, $a7910b1002260d34$export$7d499847c5200082)(me.role, (0, $a7910b1002260d34$export$ccd9fcc6ec6e7386)),
            component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $0595b51b6eb43d5f$export$2e2bcd8739ae039), {
                meID: me.id
            })
        },
        {
            url: 'all-organizations',
            name: 'All Orgs',
            enabled: (0, $a7910b1002260d34$export$7d499847c5200082)(me.role, (0, $a7910b1002260d34$export$ccd9fcc6ec6e7386)),
            component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7d58e29f36e61dc3$export$2e2bcd8739ae039), {
                meCurrentOrganization: me.currentOrganization
            })
        },
        {
            url: 'organization-mappings',
            name: 'Org Mappings',
            enabled: (0, $a7910b1002260d34$export$7d499847c5200082)(me.role, (0, $a7910b1002260d34$export$ccd9fcc6ec6e7386)),
            component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $23c02ae72b96acf8$export$2e2bcd8739ae039), null)
        }
    ];
const $dec327df71eea054$var$AdminChronografPage = ({ me: me, source: source, params: { tab: tab } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header.Left, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Title, {
        title: "Chronograf Admin"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header.Right, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Contents, {
        fullWidth: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "container-fluid"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $16731a995ab23942$export$2e2bcd8739ae039), {
        sections: $dec327df71eea054$var$sections(me),
        activeSection: tab,
        parentUrl: "admin-chronograf",
        sourceID: source.id
    }))));
const { shape: $dec327df71eea054$var$shape, string: $dec327df71eea054$var$string } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$dec327df71eea054$var$AdminChronografPage.propTypes = {
    me: $dec327df71eea054$var$shape({
        id: $dec327df71eea054$var$string.isRequired,
        role: $dec327df71eea054$var$string.isRequired,
        currentOrganization: $dec327df71eea054$var$shape({
            name: $dec327df71eea054$var$string.isRequired,
            id: $dec327df71eea054$var$string.isRequired
        })
    }).isRequired,
    params: $dec327df71eea054$var$shape({
        tab: $dec327df71eea054$var$string
    }).isRequired,
    source: $dec327df71eea054$var$shape({
        id: $dec327df71eea054$var$string.isRequired,
        links: $dec327df71eea054$var$shape({
            users: $dec327df71eea054$var$string.isRequired
        })
    }).isRequired
};
const $dec327df71eea054$var$mapStateToProps = ({ auth: { me: me } })=>({
        me: me
    });
var $dec327df71eea054$export$2e2bcd8739ae039 = (0, $c8cd79e362cba2a4$export$a520fb22fccea800)((0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($dec327df71eea054$var$mapStateToProps, null)($dec327df71eea054$var$AdminChronografPage));



var $NdCUR = parcelRequire("NdCUR");


var $e271547bf032bb19$exports = {};

$parcel$export($e271547bf032bb19$exports, "loadUsers", function () { return $e271547bf032bb19$export$2c3a8e05396a78be; });
$parcel$export($e271547bf032bb19$exports, "loadRoles", function () { return $e271547bf032bb19$export$c0334f52bda8729d; });
$parcel$export($e271547bf032bb19$exports, "loadPermissions", function () { return $e271547bf032bb19$export$52601d1a993d3c1; });
$parcel$export($e271547bf032bb19$exports, "loadDatabases", function () { return $e271547bf032bb19$export$2b27e77a45554fc9; });
$parcel$export($e271547bf032bb19$exports, "addDatabase", function () { return $e271547bf032bb19$export$dce7905b31cf8f49; });
$parcel$export($e271547bf032bb19$exports, "addRetentionPolicy", function () { return $e271547bf032bb19$export$600c930b0cfe9074; });
$parcel$export($e271547bf032bb19$exports, "syncUser", function () { return $e271547bf032bb19$export$bf59184358edf23a; });
$parcel$export($e271547bf032bb19$exports, "syncRole", function () { return $e271547bf032bb19$export$d961c7e12bae55f6; });
$parcel$export($e271547bf032bb19$exports, "syncDatabase", function () { return $e271547bf032bb19$export$bf79df873a53291e; });
$parcel$export($e271547bf032bb19$exports, "syncRetentionPolicy", function () { return $e271547bf032bb19$export$cd37101c2cba0cf2; });
$parcel$export($e271547bf032bb19$exports, "editDatabase", function () { return $e271547bf032bb19$export$83137eae9e5a41dd; });
$parcel$export($e271547bf032bb19$exports, "killQuery", function () { return $e271547bf032bb19$export$fff165c7af0be505; });
$parcel$export($e271547bf032bb19$exports, "setQueryToKill", function () { return $e271547bf032bb19$export$1f1694874eb7e9fc; });
$parcel$export($e271547bf032bb19$exports, "loadQueries", function () { return $e271547bf032bb19$export$a4a6ceb246289b4c; });
$parcel$export($e271547bf032bb19$exports, "setQueriesSort", function () { return $e271547bf032bb19$export$bd8636d030837505; });
$parcel$export($e271547bf032bb19$exports, "deleteUser", function () { return $e271547bf032bb19$export$7d0f10f273c0438a; });
$parcel$export($e271547bf032bb19$exports, "deleteRole", function () { return $e271547bf032bb19$export$a7396bae498de6f1; });
$parcel$export($e271547bf032bb19$exports, "removeDatabase", function () { return $e271547bf032bb19$export$57be51b29b1d08d3; });
$parcel$export($e271547bf032bb19$exports, "removeRetentionPolicy", function () { return $e271547bf032bb19$export$aa03b6b245a3c7f5; });
$parcel$export($e271547bf032bb19$exports, "filterUsers", function () { return $e271547bf032bb19$export$3e8d7a10dddfc47e; });
$parcel$export($e271547bf032bb19$exports, "filterRoles", function () { return $e271547bf032bb19$export$b684fd0e6ec2497d; });
$parcel$export($e271547bf032bb19$exports, "addDatabaseDeleteCode", function () { return $e271547bf032bb19$export$8461eeea21c8d91f; });
$parcel$export($e271547bf032bb19$exports, "removeDatabaseDeleteCode", function () { return $e271547bf032bb19$export$f0570031c28e88a; });
$parcel$export($e271547bf032bb19$exports, "editRetentionPolicyRequested", function () { return $e271547bf032bb19$export$f8706df75eaed6ba; });
$parcel$export($e271547bf032bb19$exports, "editRetentionPolicyCompleted", function () { return $e271547bf032bb19$export$e7babb2c2a5af92a; });
$parcel$export($e271547bf032bb19$exports, "editRetentionPolicyFailed", function () { return $e271547bf032bb19$export$ecfee753b6709ccf; });
$parcel$export($e271547bf032bb19$exports, "loadUsersAsync", function () { return $e271547bf032bb19$export$7d3fcf540e9f03ed; });
$parcel$export($e271547bf032bb19$exports, "loadRolesAsync", function () { return $e271547bf032bb19$export$15156f305e96def7; });
$parcel$export($e271547bf032bb19$exports, "loadPermissionsAsync", function () { return $e271547bf032bb19$export$a9039877195ed664; });
$parcel$export($e271547bf032bb19$exports, "loadDBsAndRPsAsync", function () { return $e271547bf032bb19$export$1fe749888cc2823a; });
$parcel$export($e271547bf032bb19$exports, "createUserAsync", function () { return $e271547bf032bb19$export$88a546ec116dc5dc; });
$parcel$export($e271547bf032bb19$exports, "createRoleAsync", function () { return $e271547bf032bb19$export$df7e75ea7d72da62; });
$parcel$export($e271547bf032bb19$exports, "createDatabaseAsync", function () { return $e271547bf032bb19$export$a8f0afecffb25153; });
$parcel$export($e271547bf032bb19$exports, "createRetentionPolicyAsync", function () { return $e271547bf032bb19$export$2d98a4d07be84134; });
$parcel$export($e271547bf032bb19$exports, "updateRetentionPolicyAsync", function () { return $e271547bf032bb19$export$49da301f3da455f7; });
$parcel$export($e271547bf032bb19$exports, "killQueryAsync", function () { return $e271547bf032bb19$export$3f02b0244acbfec9; });
$parcel$export($e271547bf032bb19$exports, "deleteRoleAsync", function () { return $e271547bf032bb19$export$7f34cacd73affbe8; });
$parcel$export($e271547bf032bb19$exports, "deleteUserAsync", function () { return $e271547bf032bb19$export$768a6f192dfb6e00; });
$parcel$export($e271547bf032bb19$exports, "deleteDatabaseAsync", function () { return $e271547bf032bb19$export$bdca2347a16f5cd0; });
$parcel$export($e271547bf032bb19$exports, "deleteRetentionPolicyAsync", function () { return $e271547bf032bb19$export$28d9b207758e6f6; });
$parcel$export($e271547bf032bb19$exports, "updateRoleUsersAsync", function () { return $e271547bf032bb19$export$1f3f547df2292a42; });
$parcel$export($e271547bf032bb19$exports, "updateRolePermissionsAsync", function () { return $e271547bf032bb19$export$e7a56bd828bee49; });
$parcel$export($e271547bf032bb19$exports, "updateUserPermissionsAsync", function () { return $e271547bf032bb19$export$94268ff2217d9ade; });
$parcel$export($e271547bf032bb19$exports, "updateUserRolesAsync", function () { return $e271547bf032bb19$export$104ba8708c1acdb9; });
$parcel$export($e271547bf032bb19$exports, "updateUserPasswordAsync", function () { return $e271547bf032bb19$export$3ac57f160b73278f; });
$parcel$export($e271547bf032bb19$exports, "changeSelectedDBs", function () { return $e271547bf032bb19$export$de10f08c6868453e; });
$parcel$export($e271547bf032bb19$exports, "changeShowUsers", function () { return $e271547bf032bb19$export$77998114e017bba9; });
$parcel$export($e271547bf032bb19$exports, "changeShowRoles", function () { return $e271547bf032bb19$export$97a83c13efe928eb; });

const $4ad64dddcd175d62$export$925a4945a6cd0f3e = async (url)=>{
    try {
        return await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'GET',
            url: url
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $4ad64dddcd175d62$export$57690667ea6b189b = async (url)=>{
    try {
        return await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'GET',
            url: url
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $4ad64dddcd175d62$export$e10fd44ca431fa8e = async (url)=>{
    try {
        return await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'GET',
            url: url
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $4ad64dddcd175d62$export$10a94fd43aa20598 = async (url)=>{
    try {
        return await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'GET',
            url: url
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $4ad64dddcd175d62$export$3493b8991d49f558 = async (url, user)=>{
    return await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
        method: 'POST',
        url: url,
        data: user
    });
};
const $4ad64dddcd175d62$export$9678a115f63a3512 = async (url, role)=>{
    return await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
        method: 'POST',
        url: url,
        data: role
    });
};
const $4ad64dddcd175d62$export$44470c96608c2d07 = async (url, database)=>{
    return await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
        method: 'POST',
        url: url,
        data: database
    });
};
const $4ad64dddcd175d62$export$7154fbff737ffcac = async (url, retentionPolicy)=>{
    return await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
        method: 'POST',
        url: url,
        data: retentionPolicy
    });
};
const $4ad64dddcd175d62$export$76c8cecf3eff3811 = async (url)=>{
    return await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
        method: 'DELETE',
        url: url
    });
};
const $4ad64dddcd175d62$export$a7396bae498de6f1 = async (url)=>{
    try {
        return await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'DELETE',
            url: url
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $4ad64dddcd175d62$export$7d0f10f273c0438a = async (url)=>{
    try {
        return await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'DELETE',
            url: url
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $4ad64dddcd175d62$export$24b6df48b2529372 = async (url)=>{
    try {
        return await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'DELETE',
            url: url
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $4ad64dddcd175d62$export$c37c5570c259cd71 = async (url, updates)=>{
    try {
        return await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'PATCH',
            url: url,
            data: updates
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $4ad64dddcd175d62$export$e3ac7a5d19605772 = async (url, updates)=>{
    try {
        return await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'PATCH',
            url: url,
            data: updates
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $4ad64dddcd175d62$export$d6bd77208c178fab = async (url, retentionPolicy)=>{
    try {
        return await (0, $a537743573e5e486$export$2e2bcd8739ae039)({
            method: 'PUT',
            url: url,
            data: {
                ...retentionPolicy
            }
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
};








var $hBdgJ = parcelRequire("hBdgJ");
const $e271547bf032bb19$export$2c3a8e05396a78be = ({ users: users })=>({
        type: 'INFLUXDB_LOAD_USERS',
        payload: {
            users: users
        }
    });
const $e271547bf032bb19$export$c0334f52bda8729d = ({ roles: roles })=>({
        type: 'INFLUXDB_LOAD_ROLES',
        payload: {
            roles: roles
        }
    });
const $e271547bf032bb19$export$52601d1a993d3c1 = ({ permissions: permissions })=>({
        type: 'INFLUXDB_LOAD_PERMISSIONS',
        payload: {
            permissions: permissions
        }
    });
const $e271547bf032bb19$export$2b27e77a45554fc9 = (databases)=>({
        type: 'INFLUXDB_LOAD_DATABASES',
        payload: {
            databases: databases
        }
    });
const $e271547bf032bb19$export$dce7905b31cf8f49 = ()=>({
        type: 'INFLUXDB_ADD_DATABASE'
    });
const $e271547bf032bb19$export$600c930b0cfe9074 = (database)=>({
        type: 'INFLUXDB_ADD_RETENTION_POLICY',
        payload: {
            database: database
        }
    });
const $e271547bf032bb19$export$bf59184358edf23a = (staleUser, syncedUser)=>({
        type: 'INFLUXDB_SYNC_USER',
        payload: {
            staleUser: staleUser,
            syncedUser: syncedUser
        }
    });
const $e271547bf032bb19$export$d961c7e12bae55f6 = (staleRole, syncedRole)=>({
        type: 'INFLUXDB_SYNC_ROLE',
        payload: {
            staleRole: staleRole,
            syncedRole: syncedRole
        }
    });
const $e271547bf032bb19$export$bf79df873a53291e = (stale, synced)=>({
        type: 'INFLUXDB_SYNC_DATABASE',
        payload: {
            stale: stale,
            synced: synced
        }
    });
const $e271547bf032bb19$export$cd37101c2cba0cf2 = (database, stale, synced)=>({
        type: 'INFLUXDB_SYNC_RETENTION_POLICY',
        payload: {
            database: database,
            stale: stale,
            synced: synced
        }
    });
const $e271547bf032bb19$export$83137eae9e5a41dd = (database, updates)=>({
        type: 'INFLUXDB_EDIT_DATABASE',
        payload: {
            database: database,
            updates: updates
        }
    });
const $e271547bf032bb19$export$fff165c7af0be505 = (queryID)=>({
        type: 'INFLUXDB_KILL_QUERY',
        payload: {
            queryID: queryID
        }
    });
const $e271547bf032bb19$export$1f1694874eb7e9fc = (queryIDToKill)=>({
        type: 'INFLUXDB_SET_QUERY_TO_KILL',
        payload: {
            queryIDToKill: queryIDToKill
        }
    });
const $e271547bf032bb19$export$a4a6ceb246289b4c = (queries)=>({
        type: 'INFLUXDB_LOAD_QUERIES',
        payload: {
            queries: [
                ...queries
            ]
        }
    });
const $e271547bf032bb19$export$bd8636d030837505 = (queriesSort)=>({
        type: 'INFLUXDB_SET_QUERIES_SORT',
        payload: {
            queriesSort: queriesSort
        }
    });
const $e271547bf032bb19$export$7d0f10f273c0438a = (user)=>({
        type: 'INFLUXDB_DELETE_USER',
        payload: {
            user: user
        }
    });
const $e271547bf032bb19$export$a7396bae498de6f1 = (role)=>({
        type: 'INFLUXDB_DELETE_ROLE',
        payload: {
            role: role
        }
    });
const $e271547bf032bb19$export$57be51b29b1d08d3 = (database)=>({
        type: 'INFLUXDB_REMOVE_DATABASE',
        payload: {
            database: database
        }
    });
const $e271547bf032bb19$export$aa03b6b245a3c7f5 = (database, retentionPolicy)=>({
        type: 'INFLUXDB_REMOVE_RETENTION_POLICY',
        payload: {
            database: database,
            retentionPolicy: retentionPolicy
        }
    });
const $e271547bf032bb19$export$3e8d7a10dddfc47e = (text)=>({
        type: 'INFLUXDB_FILTER_USERS',
        payload: {
            text: text
        }
    });
const $e271547bf032bb19$export$b684fd0e6ec2497d = (text)=>({
        type: 'INFLUXDB_FILTER_ROLES',
        payload: {
            text: text
        }
    });
const $e271547bf032bb19$export$8461eeea21c8d91f = (database)=>({
        type: 'INFLUXDB_ADD_DATABASE_DELETE_CODE',
        payload: {
            database: database
        }
    });
const $e271547bf032bb19$export$f0570031c28e88a = (database)=>({
        type: 'INFLUXDB_REMOVE_DATABASE_DELETE_CODE',
        payload: {
            database: database
        }
    });
const $e271547bf032bb19$export$f8706df75eaed6ba = (database, retentionPolicy, updates)=>({
        type: 'INFLUXDB_EDIT_RETENTION_POLICY_REQUESTED',
        payload: {
            database: database,
            retentionPolicy: retentionPolicy,
            updates: updates
        }
    });
const $e271547bf032bb19$export$e7babb2c2a5af92a = $e271547bf032bb19$export$cd37101c2cba0cf2;
const $e271547bf032bb19$export$ecfee753b6709ccf = (database, retentionPolicy, updates)=>({
        type: 'INFLUXDB_EDIT_RETENTION_POLICY_FAILED',
        payload: {
            database: database,
            retentionPolicy: retentionPolicy,
            updates: updates
        }
    });
const $e271547bf032bb19$export$7d3fcf540e9f03ed = (url)=>async (dispatch)=>{
        const { data: data } = await (0, $4ad64dddcd175d62$export$925a4945a6cd0f3e)(url);
        dispatch($e271547bf032bb19$export$2c3a8e05396a78be(data));
    };
const $e271547bf032bb19$export$15156f305e96def7 = (url)=>async (dispatch)=>{
        const { data: data } = await (0, $4ad64dddcd175d62$export$57690667ea6b189b)(url);
        dispatch($e271547bf032bb19$export$c0334f52bda8729d(data));
    };
const $e271547bf032bb19$export$a9039877195ed664 = (url)=>async (dispatch)=>{
        const { data: data } = await (0, $4ad64dddcd175d62$export$e10fd44ca431fa8e)(url);
        dispatch($e271547bf032bb19$export$52601d1a993d3c1(data));
    };
const $e271547bf032bb19$export$1fe749888cc2823a = (url)=>async (dispatch)=>{
        const { data: { databases: databases } } = await (0, $4ad64dddcd175d62$export$10a94fd43aa20598)(url);
        dispatch($e271547bf032bb19$export$2b27e77a45554fc9((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).sortBy(databases, ({ name: name })=>name.toLowerCase())));
    };
const $e271547bf032bb19$export$88a546ec116dc5dc = (url, user)=>async (dispatch)=>{
        try {
            const { data: data } = await (0, $4ad64dddcd175d62$export$3493b8991d49f558)(url, user);
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$4c6c008a07c69695)()));
            dispatch($e271547bf032bb19$export$bf59184358edf23a(user, data));
        } catch (error) {
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error, (0, $ec1f42de4faacc37$export$2e63cce792446e71)(error.data.message)));
        }
    };
const $e271547bf032bb19$export$df7e75ea7d72da62 = (url, role)=>async (dispatch)=>{
        try {
            const { data: data } = await (0, $4ad64dddcd175d62$export$9678a115f63a3512)(url, role);
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$5756acff3e9ae6fd)()));
            dispatch($e271547bf032bb19$export$d961c7e12bae55f6(role, data));
        } catch (error) {
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error, (0, $ec1f42de4faacc37$export$8b003f331ce4581b)(error.data.message)));
        }
    };
const $e271547bf032bb19$export$a8f0afecffb25153 = (url, database)=>async (dispatch)=>{
        try {
            const { data: data } = await (0, $4ad64dddcd175d62$export$44470c96608c2d07)(url, database);
            dispatch($e271547bf032bb19$export$bf79df873a53291e(database, data));
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$3c6fbfed387c4eac)()));
        } catch (error) {
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error, (0, $ec1f42de4faacc37$export$2057d63776a988da)(error.data.message)));
            // undo optimistic update
            setTimeout(()=>dispatch($e271547bf032bb19$export$57be51b29b1d08d3(database)), (0, $e10a8602f56394e3$export$7cead1aa1be9a72f));
        }
    };
const $e271547bf032bb19$export$2d98a4d07be84134 = (database, retentionPolicy)=>async (dispatch)=>{
        try {
            const { data: data } = await (0, $4ad64dddcd175d62$export$7154fbff737ffcac)(database.links.retentionPolicies, retentionPolicy);
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$77da94ed464c9b49)()));
            dispatch($e271547bf032bb19$export$cd37101c2cba0cf2(database, retentionPolicy, data));
        } catch (error) {
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$c5a6efc773cc12a6)()));
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)((0, $ec1f42de4faacc37$export$4fee75cd22cf084c)(error.data.message)));
            // undo optimistic update
            setTimeout(()=>dispatch($e271547bf032bb19$export$aa03b6b245a3c7f5(database, retentionPolicy)), (0, $e10a8602f56394e3$export$7cead1aa1be9a72f));
        }
    };
const $e271547bf032bb19$export$49da301f3da455f7 = (database, oldRP, newRP)=>async (dispatch)=>{
        try {
            dispatch($e271547bf032bb19$export$f8706df75eaed6ba(database, oldRP, newRP));
            const { data: data } = await (0, $4ad64dddcd175d62$export$d6bd77208c178fab)(oldRP.links.self, newRP);
            dispatch($e271547bf032bb19$export$e7babb2c2a5af92a(database, oldRP, data));
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$f06db47b4fa62877)()));
        } catch (error) {
            dispatch($e271547bf032bb19$export$ecfee753b6709ccf(database, oldRP));
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error, (0, $ec1f42de4faacc37$export$be7fbf4b943ce41c)(error.data.message)));
        }
    };
const $e271547bf032bb19$export$3f02b0244acbfec9 = (source, query)=>async (dispatch)=>{
        // optimistic update
        dispatch($e271547bf032bb19$export$fff165c7af0be505(query.id));
        dispatch($e271547bf032bb19$export$1f1694874eb7e9fc(null));
        try {
            // kill query on server
            await (0, $8ba03c44d4b91783$export$fff165c7af0be505)(source, query.id, query.tcpHost);
        } catch (error) {
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error));
        // TODO: handle failed killQuery
        }
    };
const $e271547bf032bb19$export$7f34cacd73affbe8 = (role)=>async (dispatch)=>{
        dispatch($e271547bf032bb19$export$a7396bae498de6f1(role));
        try {
            await (0, $4ad64dddcd175d62$export$a7396bae498de6f1)(role.links.self);
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$81c0d3902693e46b)(role.name)));
        } catch (error) {
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error, (0, $ec1f42de4faacc37$export$e907074790b70611)(error.data.message)));
        }
    };
const $e271547bf032bb19$export$768a6f192dfb6e00 = (user)=>async (dispatch)=>{
        dispatch($e271547bf032bb19$export$7d0f10f273c0438a(user));
        try {
            await (0, $4ad64dddcd175d62$export$7d0f10f273c0438a)(user.links.self);
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$51f46d16f7deabc9)(user.name)));
        } catch (error) {
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error, (0, $ec1f42de4faacc37$export$5419445d0df6af71)(error.data.message)));
        }
    };
const $e271547bf032bb19$export$bdca2347a16f5cd0 = (database)=>async (dispatch)=>{
        dispatch($e271547bf032bb19$export$57be51b29b1d08d3(database));
        try {
            await (0, $4ad64dddcd175d62$export$24b6df48b2529372)(database.links.self);
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$ac5d1ff53db4fcb2)(database.name)));
        } catch (error) {
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error, (0, $ec1f42de4faacc37$export$2a521f5871c9b754)(error.data.message)));
        }
    };
const $e271547bf032bb19$export$28d9b207758e6f6 = (database, retentionPolicy)=>async (dispatch)=>{
        dispatch($e271547bf032bb19$export$aa03b6b245a3c7f5(database, retentionPolicy));
        try {
            await (0, $4ad64dddcd175d62$export$76c8cecf3eff3811)(retentionPolicy.links.self);
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$6bde8172d5cb97e1)(retentionPolicy.name)));
        } catch (error) {
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error, (0, $ec1f42de4faacc37$export$f6ff5581ab8c95df)(error.data.message)));
        }
    };
const $e271547bf032bb19$export$1f3f547df2292a42 = (role, users)=>async (dispatch)=>{
        try {
            const { data: data } = await (0, $4ad64dddcd175d62$export$c37c5570c259cd71)(role.links.self, {
                users: users
            });
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$2e024db71a7563fb)()));
            dispatch($e271547bf032bb19$export$d961c7e12bae55f6(role, data));
            return true;
        } catch (error) {
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error, (0, $ec1f42de4faacc37$export$d67cdd4a9aa1509f)(error.data.message)));
        }
        return false;
    };
const $e271547bf032bb19$export$e7a56bd828bee49 = (role, permissions)=>async (dispatch)=>{
        try {
            const { data: data } = await (0, $4ad64dddcd175d62$export$c37c5570c259cd71)(role.links.self, {
                permissions: permissions
            });
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$867c0323ff47e90c)()));
            dispatch($e271547bf032bb19$export$d961c7e12bae55f6(role, data));
            return true;
        } catch (error) {
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error, (0, $ec1f42de4faacc37$export$e1df1d69e5b00ef)(error.data.message)));
        }
        return false;
    };
const $e271547bf032bb19$export$94268ff2217d9ade = (user, permissions)=>async (dispatch)=>{
        try {
            const { data: data } = await (0, $4ad64dddcd175d62$export$e3ac7a5d19605772)(user.links.self, {
                permissions: permissions
            });
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$22867ede2453945c)()));
            dispatch($e271547bf032bb19$export$bf59184358edf23a(user, data));
            return true;
        } catch (error) {
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error, (0, $ec1f42de4faacc37$export$d16f2d60afbbaa40)(error.data.message)));
        }
    };
const $e271547bf032bb19$export$104ba8708c1acdb9 = (user, roles)=>async (dispatch)=>{
        try {
            const { data: data } = await (0, $4ad64dddcd175d62$export$e3ac7a5d19605772)(user.links.self, {
                roles: roles
            });
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$ce928715b18e4b9f)()));
            dispatch($e271547bf032bb19$export$bf59184358edf23a(user, data));
            return true;
        } catch (error) {
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error, (0, $ec1f42de4faacc37$export$b348072ac3f9c1b9)(error.data.message)));
        }
        return false;
    };
const $e271547bf032bb19$export$3ac57f160b73278f = (user, password)=>async (dispatch)=>{
        try {
            const { data: data } = await (0, $4ad64dddcd175d62$export$e3ac7a5d19605772)(user.links.self, {
                password: password
            });
            dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)((0, $ec1f42de4faacc37$export$8a8ab4d4ce2f5a6d)()));
            dispatch($e271547bf032bb19$export$bf59184358edf23a(user, data));
        } catch (error) {
            dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error, (0, $ec1f42de4faacc37$export$310cbc8347ac0406)(error.data.message)));
        }
    };
const $e271547bf032bb19$export$de10f08c6868453e = (selectedDBs /* : string[] */ )=>({
        type: 'INFLUXDB_CHANGE_SELECTED_DBS',
        payload: {
            selectedDBs: selectedDBs
        }
    });
const $e271547bf032bb19$export$77998114e017bba9 = ()=>({
        type: 'INFLUXDB_CHANGE_SHOW_USERS'
    });
const $e271547bf032bb19$export$97a83c13efe928eb = ()=>({
        type: 'INFLUXDB_CHANGE_SHOW_ROLES'
    });








var $NdCUR = parcelRequire("NdCUR");




function $eaa83b4bf15172b4$export$a51709d05d806ee2(source) {
    return !!source?.links?.roles;
}
function $eaa83b4bf15172b4$export$3295c333c7855cf3(source) {
    return source.authentication === (0, $507599f0e7251de2$export$7d18f7c49c9d7266).LDAP;
}
const $eaa83b4bf15172b4$export$f4b79619cc47424a = ({ source: source, activeTab: activeTab, children: children, onTabChange: onTabChange })=>{
    const sections = (0, $NdCUR.useMemo)(()=>{
        const hasRoles = $eaa83b4bf15172b4$export$a51709d05d806ee2(source);
        const isLDAP = $eaa83b4bf15172b4$export$3295c333c7855cf3(source);
        const isV3 = (0, $e10a8602f56394e3$export$8668fc04891bde79)(source);
        return [
            {
                url: 'databases',
                name: 'Databases',
                enabled: true
            },
            {
                url: 'users',
                name: 'Users',
                enabled: !isLDAP && !isV3
            },
            {
                url: 'roles',
                name: 'Roles',
                enabled: hasRoles && !isLDAP && !isV3
            },
            {
                url: 'queries',
                name: 'Queries',
                enabled: !isV3
            }
        ];
    }, [
        source
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $16731a995ab23942$export$2e2bcd8739ae039), {
        parentUrl: "admin-influxdb",
        sourceID: source.id,
        activeSection: activeTab,
        sections: sections,
        position: "top",
        onTabChange: onTabChange
    }, children);
};
const $eaa83b4bf15172b4$var$AdminInfluxDBTabbedPage = ({ source: source, activeTab: activeTab, children: children, onTabChange: onTabChange })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $4b3f9e245d0fb322$export$f5cf18beec21806), {
        hideRefresh: activeTab === 'queries'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($eaa83b4bf15172b4$export$f4b79619cc47424a, {
        source: source,
        activeTab: activeTab,
        onTabChange: onTabChange
    }, children));
};
var $eaa83b4bf15172b4$export$2e2bcd8739ae039 = $eaa83b4bf15172b4$var$AdminInfluxDBTabbedPage;



const $4b3f9e245d0fb322$var$mapDispatchToProps = {
    loadUsers: (0, $e271547bf032bb19$export$7d3fcf540e9f03ed),
    loadRoles: (0, $e271547bf032bb19$export$15156f305e96def7),
    loadPermissions: (0, $e271547bf032bb19$export$a9039877195ed664),
    loadDBsAndRPs: (0, $e271547bf032bb19$export$1fe749888cc2823a),
    notify: (0, $205d139de2918454$export$5e14cdade93d6f7b)
};
const $4b3f9e245d0fb322$export$423832cdec2d5822 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createContext(undefined);
const $4b3f9e245d0fb322$export$f5cf18beec21806 = ({ children: children, hideRefresh: hideRefresh })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039), {
        className: "influxdb-admin"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header, {
        fullWidth: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header.Left, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Title, {
        title: "InfluxDB Admin"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header.Right, {
        showSourceIndicator: true
    }, hideRefresh ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($4b3f9e245d0fb322$export$423832cdec2d5822.Consumer, null, (refresh)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "icon refresh",
            title: "Refresh",
            onClick: refresh
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        style: {
            height: 'calc(100% - 60px)'
        }
    }, children));
class $4b3f9e245d0fb322$var$AdminInfluxDBScopedPage extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.refresh = async ()=>{
            const { source: source, loadUsers: loadUsers, loadRoles: loadRoles, loadPermissions: loadPermissions, loadDBsAndRPs: loadDBsAndRPs } = this.props;
            if (!source.version || source.version.startsWith('2')) // administration is not possible for v2 type
            return;
            this.setState({
                loading: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading
            });
            let errorMessage;
            try {
                errorMessage = 'Failed to load databases.';
                await loadDBsAndRPs(source.links.databases);
                if (!(0, $eaa83b4bf15172b4$export$3295c333c7855cf3)(source) && !(0, $e10a8602f56394e3$export$8668fc04891bde79)(source)) {
                    // Load users and permissions
                    errorMessage = 'Failed to load users.';
                    await loadUsers(source.links.users);
                    errorMessage = 'Failed to load permissions.';
                    await loadPermissions(source.links.permissions);
                    if (source.links.roles) {
                        errorMessage = 'Failed to load roles.';
                        await loadRoles(source.links.roles);
                    }
                }
                this.setState({
                    loading: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Done
                });
            } catch (e) {
                console.error(e);
                // extract error message for the UI
                let error = e;
                if (error.message) error = error.message;
                else if (error.data?.message) error = error.data?.message;
                else if (error.statusText) error = error.statusText;
                this.setState({
                    loading: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error,
                    error: error,
                    errorMessage: `Unable to administer InfluxDB. ${errorMessage}`
                });
            }
        };
        this.state = {
            loading: (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).NotStarted
        };
    }
    async componentDidMount() {
        await this.refresh();
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($4b3f9e245d0fb322$export$423832cdec2d5822.Provider, {
            value: this.refresh
        }, this.content());
    }
    content() {
        const { source: source, children: children } = this.props;
        if (!source.version || source.version.startsWith('2')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($4b3f9e245d0fb322$export$f5cf18beec21806, {
            hideRefresh: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "container-fluid"
        }, "These functions are not available for the currently selected InfluxDB ", source.version?.startsWith('2') ? 'v2 ' : '', "connection.", source.version?.startsWith('2') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("br", null), ' Use InfluxDB v2 UI directly at ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("a", {
            href: source.url
        }, source.url)) : ''));
        const { loading: loading, error: error, errorMessage: errorMessage } = this.state;
        if (loading === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Loading || loading === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).NotStarted) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($4b3f9e245d0fb322$export$f5cf18beec21806, {
            hideRefresh: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $810ad5a94daa03b8$export$2e2bcd8739ae039), null));
        if (loading === (0, $bf3dd750ec7dcb0a$export$84f725a50b2d16f7).Error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($4b3f9e245d0fb322$export$f5cf18beec21806, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "container-fluid"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", {
            className: "unexpected-error"
        }, errorMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", {
            className: "unexpected-error"
        }, (error || '').toString()))));
        return children;
    }
}
var $4b3f9e245d0fb322$export$2e2bcd8739ae039 = (0, $c8cd79e362cba2a4$export$a520fb22fccea800)((0, $ad1c01f2a894092c$export$2e2bcd8739ae039)(null, $4b3f9e245d0fb322$var$mapDispatchToProps)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($4b3f9e245d0fb322$var$AdminInfluxDBScopedPage)));



var $NdCUR = parcelRequire("NdCUR");




var $hBdgJ = parcelRequire("hBdgJ");

var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");

var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");

var $hBdgJ = parcelRequire("hBdgJ");

var $1v7mg = parcelRequire("1v7mg");

var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");






const $6bd39f00410cdd05$export$c367ad1972a0fb01 = {
    colUsername: 240,
    colAdministrator: 70
};
const $6bd39f00410cdd05$export$867baa1e36de1973 = {
    colName: 240
};
const $6bd39f00410cdd05$export$2db02977e6744a80 = {
    colDatabase: 160,
    colDuration: 80,
    colKillQuery: 70
};
const $6bd39f00410cdd05$export$4e93eb5f664a9e78 = {
    colDelete: 70
};
const $6bd39f00410cdd05$export$adcb110a3713eacd = {
    colRetentionPolicy: 140,
    colDuration: 80,
    colReplication: 122,
    colDelete: 160
};




class $528a03d133a630bc$var$DatabaseRow extends (0, $NdCUR.Component) {
    constructor(props){
        super(props);
        this.state = {
            isEditing: false
        };
    }
    UNSAFE_componentWillMount() {
        if (this.props.retentionPolicy.isNew) this.setState({
            isEditing: true
        });
    }
    handleRemove = ()=>{
        const { database: database, retentionPolicy: retentionPolicy, onRemove: onRemove } = this.props;
        onRemove(database, retentionPolicy);
    };
    handleClickOutside = ()=>{
        const { database: database, retentionPolicy: retentionPolicy, onRemove: onRemove } = this.props;
        if (retentionPolicy.isNew) onRemove(database, retentionPolicy);
        this.handleEndEdit();
    };
    handleStartEdit = ()=>{
        this.setState({
            isEditing: true
        });
    };
    handleEndEdit = ()=>{
        this.setState({
            isEditing: false
        });
    };
    handleCreate = ()=>{
        const { database: database, retentionPolicy: retentionPolicy, onCreate: onCreate } = this.props;
        const validInputs = this.getInputValues();
        if (!validInputs) return;
        onCreate(database, {
            ...retentionPolicy,
            ...validInputs
        });
        this.handleEndEdit();
    };
    handleUpdate = ()=>{
        const { database: database, retentionPolicy: retentionPolicy, onUpdate: onUpdate } = this.props;
        const validInputs = this.getInputValues();
        if (!validInputs) return;
        onUpdate(database, retentionPolicy, validInputs);
        this.handleEndEdit();
    };
    handleKeyDown = (e)=>{
        const { key: key } = e;
        const { retentionPolicy: retentionPolicy, database: database, onRemove: onRemove } = this.props;
        if (key === 'Escape') {
            if (retentionPolicy.isNew) {
                onRemove(database, retentionPolicy);
                return;
            }
            this.handleEndEdit();
        }
        if (key === 'Enter') {
            if (retentionPolicy.isNew) {
                this.handleCreate();
                return;
            }
            this.handleUpdate();
        }
    };
    getInputValues = ()=>{
        const { notify: notify, retentionPolicy: { name: currentName }, isRFDisplayed: isRFDisplayed } = this.props;
        const name = this.name && this.name.value.trim() || currentName;
        let duration = this.duration.value.trim();
        // Replication > 1 is only valid for Influx Enterprise
        const replication = isRFDisplayed ? +this.replication.value.trim() : 1;
        if (!duration || isRFDisplayed && !replication) {
            notify((0, $ec1f42de4faacc37$export$6b14ed50c565020f)());
            return;
        }
        if (duration === "\u221E") duration = 'INF';
        return {
            name: name,
            duration: duration,
            replication: replication
        };
    };
    render() {
        const { retentionPolicy: { name: name, duration: duration, replication: replication, isDefault: isDefault, isNew: isNew }, retentionPolicy: retentionPolicy, database: database, onDelete: onDelete, isDeletable: isDeletable, isEditable: isEditable, isRFDisplayed: isRFDisplayed } = this.props;
        const { isEditing: isEditing } = this.state;
        const formattedDuration = (0, $d1eae937b60051ec$export$e2ad482cc86adb89)(duration);
        if (isEditing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            style: {
                width: `${(0, $6bd39f00410cdd05$export$adcb110a3713eacd).colRetentionPolicy}px`
            }
        }, isNew ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control input-xs",
            type: "text",
            defaultValue: name,
            placeholder: "Name this RP",
            onKeyDown: this.handleKeyDown,
            ref: (r)=>this.name = r,
            autoFocus: true,
            spellCheck: false,
            autoComplete: "false",
            "data-test": "rp-name--input"
        }) : name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            style: {
                width: `${(0, $6bd39f00410cdd05$export$adcb110a3713eacd).colDuration}px`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control input-xs",
            name: "name",
            type: "text",
            defaultValue: formattedDuration,
            placeholder: "INF, 1h30m, 1d, etc",
            onKeyDown: this.handleKeyDown,
            ref: (r)=>this.duration = r,
            autoFocus: !isNew,
            spellCheck: false,
            autoComplete: "false",
            "data-test": "rp-duration--input"
        })), isRFDisplayed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            style: {
                width: `${(0, $6bd39f00410cdd05$export$adcb110a3713eacd).colReplication}px`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
            className: "form-control input-xs",
            name: "name",
            type: "number",
            min: "1",
            defaultValue: replication || 1,
            placeholder: "# of Nodes",
            onKeyDown: this.handleKeyDown,
            ref: (r)=>this.replication = r,
            spellCheck: false,
            autoComplete: "false"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            className: "text-right",
            style: {
                width: `${(0, $6bd39f00410cdd05$export$adcb110a3713eacd).colDelete}px`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-xs btn-info",
            onClick: isNew ? this.handleRemove : this.handleEndEdit,
            "data-test": "cancel-rp--button"
        }, "Cancel"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-xs btn-success",
            onClick: isNew ? this.handleCreate : this.handleUpdate,
            "data-test": "save-rp--button"
        }, "Save")));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tr", {
            "data-test": 'retention-policy--' + name
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", null, `${name} `, isDefault ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: "default-source-label"
        }, "default") : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            style: {
                width: `${(0, $6bd39f00410cdd05$export$adcb110a3713eacd).colDuration}px`
            }
        }, formattedDuration), isRFDisplayed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            style: {
                width: `${(0, $6bd39f00410cdd05$export$adcb110a3713eacd).colReplication}px`
            }
        }, replication) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            className: "text-right",
            style: {
                width: `${(0, $6bd39f00410cdd05$export$adcb110a3713eacd).colDelete}px`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-xs btn-info table--show-on-row-hover",
            onClick: this.handleStartEdit,
            disabled: !isEditable,
            "data-test": "edit-rp--button"
        }, "Edit"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $8008717819fc7a5f$export$2e2bcd8739ae039), {
            text: `Delete ${name}`,
            confirmAction: onDelete(database, retentionPolicy),
            size: "btn-xs",
            type: "btn-danger",
            customClass: "table--show-on-row-hover",
            disabled: !isDeletable,
            testId: "delete-rp--confirm-button"
        })));
    }
}
const { bool: $528a03d133a630bc$var$bool, func: $528a03d133a630bc$var$func, number: $528a03d133a630bc$var$number, shape: $528a03d133a630bc$var$shape, string: $528a03d133a630bc$var$string } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$528a03d133a630bc$var$DatabaseRow.propTypes = {
    retentionPolicy: $528a03d133a630bc$var$shape({
        name: $528a03d133a630bc$var$string,
        duration: $528a03d133a630bc$var$string,
        replication: $528a03d133a630bc$var$number,
        isDefault: $528a03d133a630bc$var$bool,
        isEditing: $528a03d133a630bc$var$bool
    }),
    isDeletable: $528a03d133a630bc$var$bool,
    isEditable: $528a03d133a630bc$var$bool,
    database: $528a03d133a630bc$var$shape(),
    onRemove: $528a03d133a630bc$var$func,
    onCreate: $528a03d133a630bc$var$func,
    onUpdate: $528a03d133a630bc$var$func,
    onDelete: $528a03d133a630bc$var$func,
    notify: $528a03d133a630bc$var$func.isRequired,
    isRFDisplayed: $528a03d133a630bc$var$bool
};
const $528a03d133a630bc$var$mapDispatchToProps = (dispatch)=>({
        notify: (0, $1f80bbeadc1a0021$export$2e2bcd8739ae039)((0, $205d139de2918454$export$5e14cdade93d6f7b), dispatch)
    });
var $528a03d133a630bc$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)(null, $528a03d133a630bc$var$mapDispatchToProps)((0, $23ae721fc6e771d0$export$2e2bcd8739ae039)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($528a03d133a630bc$var$DatabaseRow)));



var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");





const $f97216b2b91bc3fa$var$DatabaseTableHeader = ({ database: database, onEdit: onEdit, notify: notify, onKeyDown: onKeyDown, onConfirm: onConfirm, onCancel: onCancel, onDelete: onDelete, onStartDelete: onStartDelete, onRemoveDeleteCode: onRemoveDeleteCode, onDatabaseDeleteConfirm: onDatabaseDeleteConfirm, onAddRetentionPolicy: onAddRetentionPolicy, isAddRPDisabled: isAddRPDisabled, isDBDeleteDisabled: isDBDeleteDisabled })=>{
    if (database.isEditing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($f97216b2b91bc3fa$var$EditHeader, {
        database: database,
        onEdit: onEdit,
        onKeyDown: onKeyDown,
        onConfirm: onConfirm,
        onCancel: onCancel
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($f97216b2b91bc3fa$var$Header, {
        notify: notify,
        database: database,
        onCancel: onRemoveDeleteCode,
        onConfirm: onConfirm,
        onDelete: onDelete,
        onStartDelete: onStartDelete,
        isAddRPDisabled: isAddRPDisabled,
        isDBDeleteDisabled: isDBDeleteDisabled,
        onAddRetentionPolicy: onAddRetentionPolicy,
        onDatabaseDeleteConfirm: onDatabaseDeleteConfirm
    });
};
const $f97216b2b91bc3fa$var$Header = ({ notify: notify, database: database, onCancel: onCancel, onDelete: onDelete, onStartDelete: onStartDelete, isAddRPDisabled: isAddRPDisabled, isDBDeleteDisabled: isDBDeleteDisabled, onAddRetentionPolicy: onAddRetentionPolicy, onDatabaseDeleteConfirm: onDatabaseDeleteConfirm })=>{
    const buttons = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "db-manager-header--actions text-right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
        className: "btn btn-xs btn-primary",
        disabled: isAddRPDisabled,
        onClick: onAddRetentionPolicy(database),
        "data-test": "add-retention-policy--button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        className: "icon plus"
    }), " Add Retention Policy"), database.name === '_internal' ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
        className: "btn btn-xs btn-danger",
        disabled: isDBDeleteDisabled,
        onClick: onStartDelete(database),
        "data-test": "delete-db--button"
    }, "Delete"));
    function onConfirm(db) {
        if (database.deleteCode !== `DELETE ${database.name}`) return notify((0, $ec1f42de4faacc37$export$2fb9043fa7492e92)(database.name));
        onDelete(db);
    }
    const deleteConfirmation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "admin-table--delete-db",
        "data-test": "delete-db--confirmation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
        className: "form-control input-xs",
        name: "name",
        type: "text",
        value: database.deleteCode || '',
        placeholder: `DELETE ${database.name}`,
        onChange: onDatabaseDeleteConfirm(database),
        onKeyDown: onDatabaseDeleteConfirm(database),
        autoFocus: true,
        autoComplete: "false",
        spellCheck: false,
        "data-test": "delete-db--confirm-input"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b4a526e8eda76ab1$export$2e2bcd8739ae039), {
        item: database,
        onConfirm: onConfirm,
        onCancel: onCancel,
        buttonSize: "btn-xs"
    }));
    // eslint-disable-next-line no-prototype-builtins
    const hasDeleteCode = database.hasOwnProperty('deleteCode');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "db-manager-header",
        "data-test": "db-manager--header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", null, database.name), hasDeleteCode ? deleteConfirmation : buttons);
};
const $f97216b2b91bc3fa$var$EditHeader = ({ database: database, onEdit: onEdit, onKeyDown: onKeyDown, onConfirm: onConfirm, onCancel: onCancel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "db-manager-header db-manager-header--edit"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
        className: "form-control input-sm",
        name: "name",
        type: "text",
        value: database.name,
        placeholder: "Name this Database",
        onChange: onEdit(database),
        onKeyDown: onKeyDown(database),
        autoFocus: true,
        spellCheck: false,
        autoComplete: "false",
        "data-test": "db-name--input"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b4a526e8eda76ab1$export$2e2bcd8739ae039), {
        item: database,
        onConfirm: onConfirm,
        onCancel: onCancel
    }));
const { func: $f97216b2b91bc3fa$var$func, shape: $f97216b2b91bc3fa$var$shape, bool: $f97216b2b91bc3fa$var$bool } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$f97216b2b91bc3fa$var$DatabaseTableHeader.propTypes = {
    onEdit: $f97216b2b91bc3fa$var$func,
    notify: $f97216b2b91bc3fa$var$func.isRequired,
    database: $f97216b2b91bc3fa$var$shape(),
    onKeyDown: $f97216b2b91bc3fa$var$func,
    onCancel: $f97216b2b91bc3fa$var$func,
    onConfirm: $f97216b2b91bc3fa$var$func,
    onDelete: $f97216b2b91bc3fa$var$func,
    onStartDelete: $f97216b2b91bc3fa$var$func,
    onDatabaseDeleteConfirm: $f97216b2b91bc3fa$var$func,
    onRemoveDeleteCode: $f97216b2b91bc3fa$var$func,
    onAddRetentionPolicy: $f97216b2b91bc3fa$var$func,
    isAddRPDisabled: $f97216b2b91bc3fa$var$bool,
    isDBDeleteDisabled: $f97216b2b91bc3fa$var$bool
};
$f97216b2b91bc3fa$var$Header.propTypes = {
    notify: $f97216b2b91bc3fa$var$func.isRequired,
    onConfirm: $f97216b2b91bc3fa$var$func,
    onCancel: $f97216b2b91bc3fa$var$func,
    onDelete: $f97216b2b91bc3fa$var$func,
    database: $f97216b2b91bc3fa$var$shape(),
    onStartDelete: $f97216b2b91bc3fa$var$func,
    isAddRPDisabled: $f97216b2b91bc3fa$var$bool,
    isDBDeleteDisabled: $f97216b2b91bc3fa$var$bool,
    onAddRetentionPolicy: $f97216b2b91bc3fa$var$func,
    onDatabaseDeleteConfirm: $f97216b2b91bc3fa$var$func
};
$f97216b2b91bc3fa$var$EditHeader.propTypes = {
    database: $f97216b2b91bc3fa$var$shape(),
    onEdit: $f97216b2b91bc3fa$var$func,
    onKeyDown: $f97216b2b91bc3fa$var$func,
    onCancel: $f97216b2b91bc3fa$var$func,
    onConfirm: $f97216b2b91bc3fa$var$func,
    isRFDisplayed: $f97216b2b91bc3fa$var$bool
};
const $f97216b2b91bc3fa$var$mapDispatchToProps = (dispatch)=>({
        notify: (0, $1f80bbeadc1a0021$export$2e2bcd8739ae039)((0, $205d139de2918454$export$5e14cdade93d6f7b), dispatch)
    });
var $f97216b2b91bc3fa$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)(null, $f97216b2b91bc3fa$var$mapDispatchToProps)($f97216b2b91bc3fa$var$DatabaseTableHeader);



const { func: $7e3cfff8633971f7$var$func, shape: $7e3cfff8633971f7$var$shape, bool: $7e3cfff8633971f7$var$bool } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
const $7e3cfff8633971f7$var$DatabaseTable = ({ database: database, isRFDisplayed: isRFDisplayed, isDBReadOnly: isDBReadOnly, onEditDatabase: onEditDatabase, onKeyDownDatabase: onKeyDownDatabase, onCancelDatabase: onCancelDatabase, onConfirmDatabase: onConfirmDatabase, onDeleteDatabase: onDeleteDatabase, onRemoveDeleteCode: onRemoveDeleteCode, onStartDeleteDatabase: onStartDeleteDatabase, onDatabaseDeleteConfirm: onDatabaseDeleteConfirm, onAddRetentionPolicy: onAddRetentionPolicy, onCreateRetentionPolicy: onCreateRetentionPolicy, onUpdateRetentionPolicy: onUpdateRetentionPolicy, onRemoveRetentionPolicy: onRemoveRetentionPolicy, onDeleteRetentionPolicy: onDeleteRetentionPolicy })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1v7mg)))('db-manager', {
            'db-manager--edit': database.isEditing
        }),
        "data-test": 'db-manager--' + database.name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $f97216b2b91bc3fa$export$2e2bcd8739ae039), {
        database: database,
        onEdit: onEditDatabase,
        onCancel: onCancelDatabase,
        onDelete: onDeleteDatabase,
        onConfirm: onConfirmDatabase,
        onKeyDown: onKeyDownDatabase,
        onStartDelete: onStartDeleteDatabase,
        onRemoveDeleteCode: onRemoveDeleteCode,
        onAddRetentionPolicy: onAddRetentionPolicy,
        onDeleteRetentionPolicy: onDeleteRetentionPolicy,
        onDatabaseDeleteConfirm: onDatabaseDeleteConfirm,
        isAddRPDisabled: !!database.retentionPolicies.some((rp)=>rp.isNew) || isDBReadOnly,
        isDBDeleteDisabled: isDBReadOnly
    }), !database.isNew && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "db-manager-table",
        "data-test": 'db-manager-table--' + database.name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("table", {
        className: "table v-center table-highlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
        style: {
            width: `${(0, $6bd39f00410cdd05$export$adcb110a3713eacd).colRetentionPolicy}px`
        }
    }, "Retention Policy"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
        style: {
            width: `${(0, $6bd39f00410cdd05$export$adcb110a3713eacd).colDuration}px`
        }
    }, "Duration"), isRFDisplayed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
        style: {
            width: `${(0, $6bd39f00410cdd05$export$adcb110a3713eacd).colReplication}px`
        }
    }, "Replication Factor") : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
        style: {
            width: `${(0, $6bd39f00410cdd05$export$adcb110a3713eacd).colDelete}px`
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tbody", null, (0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).sortBy(database.retentionPolicies, ({ name: name })=>name.toLowerCase()).map((rp)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $528a03d133a630bc$export$2e2bcd8739ae039), {
            key: rp.links.self,
            database: database,
            retentionPolicy: rp,
            onCreate: onCreateRetentionPolicy,
            onUpdate: onUpdateRetentionPolicy,
            onRemove: onRemoveRetentionPolicy,
            onDelete: onDeleteRetentionPolicy,
            isRFDisplayed: isRFDisplayed,
            isEditable: !isDBReadOnly,
            isDeletable: !isDBReadOnly && database.retentionPolicies.length > 1
        });
    })))));
};
$7e3cfff8633971f7$var$DatabaseTable.propTypes = {
    onEditDatabase: $7e3cfff8633971f7$var$func,
    database: $7e3cfff8633971f7$var$shape(),
    isRFDisplayed: $7e3cfff8633971f7$var$bool,
    isDBReadOnly: $7e3cfff8633971f7$var$bool,
    isAddRPDisabled: $7e3cfff8633971f7$var$bool,
    onKeyDownDatabase: $7e3cfff8633971f7$var$func,
    onDeleteDatabase: $7e3cfff8633971f7$var$func,
    onCancelDatabase: $7e3cfff8633971f7$var$func,
    onConfirmDatabase: $7e3cfff8633971f7$var$func,
    onRemoveDeleteCode: $7e3cfff8633971f7$var$func,
    onStartDeleteDatabase: $7e3cfff8633971f7$var$func,
    onDatabaseDeleteConfirm: $7e3cfff8633971f7$var$func,
    onAddRetentionPolicy: $7e3cfff8633971f7$var$func,
    onCancelRetentionPolicy: $7e3cfff8633971f7$var$func,
    onCreateRetentionPolicy: $7e3cfff8633971f7$var$func,
    onUpdateRetentionPolicy: $7e3cfff8633971f7$var$func,
    onRemoveRetentionPolicy: $7e3cfff8633971f7$var$func,
    onDeleteRetentionPolicy: $7e3cfff8633971f7$var$func
};
var $7e3cfff8633971f7$export$2e2bcd8739ae039 = $7e3cfff8633971f7$var$DatabaseTable;



const $8445f462b7313dc1$var$DatabaseManager = ({ databases: databases, isRFDisplayed: isRFDisplayed, isDBReadOnly: isDBReadOnly, isAddDBDisabled: isAddDBDisabled, addDatabase: addDatabase, onEditDatabase: onEditDatabase, onKeyDownDatabase: onKeyDownDatabase, onCancelDatabase: onCancelDatabase, onConfirmDatabase: onConfirmDatabase, onDeleteDatabase: onDeleteDatabase, onStartDeleteDatabase: onStartDeleteDatabase, onDatabaseDeleteConfirm: onDatabaseDeleteConfirm, onRemoveDeleteCode: onRemoveDeleteCode, onAddRetentionPolicy: onAddRetentionPolicy, onStopEditRetentionPolicy: onStopEditRetentionPolicy, onCancelRetentionPolicy: onCancelRetentionPolicy, onCreateRetentionPolicy: onCreateRetentionPolicy, onUpdateRetentionPolicy: onUpdateRetentionPolicy, onRemoveRetentionPolicy: onRemoveRetentionPolicy, onDeleteRetentionPolicy: onDeleteRetentionPolicy })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel panel-solid influxdb-admin"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel-heading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h2", {
        className: "panel-title"
    }, databases.length === 1 ? '1 Database' : `${databases.length} Databases`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel-heading--right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
        className: "btn btn-sm btn-primary",
        disabled: isAddDBDisabled,
        onClick: addDatabase,
        "data-test": "create-db--button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        className: "icon plus"
    }), " Create Database"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel-body",
        style: {
            paddingRight: 20
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        style: {
            paddingRight: 10
        }
    }, databases.map((db)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7e3cfff8633971f7$export$2e2bcd8739ae039), {
            key: db.links.self,
            database: db,
            isRFDisplayed: isRFDisplayed,
            isDBReadOnly: isDBReadOnly,
            onEditDatabase: onEditDatabase,
            onKeyDownDatabase: onKeyDownDatabase,
            onCancelDatabase: onCancelDatabase,
            onConfirmDatabase: onConfirmDatabase,
            onRemoveDeleteCode: onRemoveDeleteCode,
            onDeleteDatabase: onDeleteDatabase,
            onStartDeleteDatabase: onStartDeleteDatabase,
            onDatabaseDeleteConfirm: onDatabaseDeleteConfirm,
            onAddRetentionPolicy: onAddRetentionPolicy,
            onStopEditRetentionPolicy: onStopEditRetentionPolicy,
            onCancelRetentionPolicy: onCancelRetentionPolicy,
            onCreateRetentionPolicy: onCreateRetentionPolicy,
            onUpdateRetentionPolicy: onUpdateRetentionPolicy,
            onRemoveRetentionPolicy: onRemoveRetentionPolicy,
            onDeleteRetentionPolicy: onDeleteRetentionPolicy
        }))))));
};
const { arrayOf: $8445f462b7313dc1$var$arrayOf, bool: $8445f462b7313dc1$var$bool, func: $8445f462b7313dc1$var$func, shape: $8445f462b7313dc1$var$shape } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$8445f462b7313dc1$var$DatabaseManager.propTypes = {
    databases: $8445f462b7313dc1$var$arrayOf($8445f462b7313dc1$var$shape()),
    addDatabase: $8445f462b7313dc1$var$func,
    isRFDisplayed: $8445f462b7313dc1$var$bool,
    isDBReadOnly: $8445f462b7313dc1$var$bool,
    isAddDBDisabled: $8445f462b7313dc1$var$bool,
    onEditDatabase: $8445f462b7313dc1$var$func,
    onKeyDownDatabase: $8445f462b7313dc1$var$func,
    onCancelDatabase: $8445f462b7313dc1$var$func,
    onConfirmDatabase: $8445f462b7313dc1$var$func,
    onDeleteDatabase: $8445f462b7313dc1$var$func,
    onRemoveDeleteCode: $8445f462b7313dc1$var$func,
    onStartDeleteDatabase: $8445f462b7313dc1$var$func,
    onDatabaseDeleteConfirm: $8445f462b7313dc1$var$func,
    onAddRetentionPolicy: $8445f462b7313dc1$var$func,
    onEditRetentionPolicy: $8445f462b7313dc1$var$func,
    onStopEditRetentionPolicy: $8445f462b7313dc1$var$func,
    onCancelRetentionPolicy: $8445f462b7313dc1$var$func,
    onCreateRetentionPolicy: $8445f462b7313dc1$var$func,
    onUpdateRetentionPolicy: $8445f462b7313dc1$var$func,
    onRemoveRetentionPolicy: $8445f462b7313dc1$var$func,
    onDeleteRetentionPolicy: $8445f462b7313dc1$var$func
};
var $8445f462b7313dc1$export$2e2bcd8739ae039 = $8445f462b7313dc1$var$DatabaseManager;








class $ae004e1621a95da4$var$DatabaseManagerPage extends (0, $NdCUR.Component) {
    constructor(props){
        super(props), this.handleDeleteRetentionPolicy = (db, rp)=>()=>{
                this.props.actions.deleteRetentionPolicyAsync(db, rp);
            }, this.handleStartDeleteDatabase = (database)=>()=>{
                this.props.actions.addDatabaseDeleteCode(database);
            }, this.handleEditDatabase = (database)=>(e)=>{
                this.props.actions.editDatabase(database, {
                    name: e.target.value
                });
            }, this.handleCreateDatabase = (database)=>{
            const { actions: actions, notify: notify, source: source, databases: databases } = this.props;
            if (!database.name) return notify((0, $ec1f42de4faacc37$export$5eec90a2b9dd4cc1)());
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).findIndex(databases, {
                name: database.name
            }, 1) !== -1) return notify((0, $ec1f42de4faacc37$export$7ed201556d6460db)());
            actions.createDatabaseAsync(source.links.databases, database);
        }, this.handleAddRetentionPolicy = (database)=>()=>{
                const { addRetentionPolicy: addRetentionPolicy } = this.props.actions;
                addRetentionPolicy(database);
            }, this.handleKeyDownDatabase = (database)=>(e)=>{
                const { key: key } = e;
                const { actions: actions, notify: notify, source: source, databases: databases } = this.props;
                if (key === 'Escape') {
                    actions.removeDatabase(database);
                    return;
                }
                if (key === 'Enter') {
                    if (!database.name) return notify((0, $ec1f42de4faacc37$export$5eec90a2b9dd4cc1)());
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($hBdgJ))).findIndex(databases, {
                        name: database.name
                    }, 1) !== -1) return notify((0, $ec1f42de4faacc37$export$7ed201556d6460db)());
                    actions.createDatabaseAsync(source.links.databases, database);
                }
            }, this.handleDatabaseDeleteConfirm = (database)=>(e)=>{
                const { key: key, target: { value: value } } = e;
                const { actions: actions, notify: notify } = this.props;
                if (key === 'Escape') {
                    actions.removeDatabaseDeleteCode(database);
                    return;
                }
                if (key === 'Enter') {
                    if (database.deleteCode !== `DELETE ${database.name}`) return notify((0, $ec1f42de4faacc37$export$2fb9043fa7492e92)(database.name));
                    return actions.deleteDatabaseAsync(database);
                }
                actions.editDatabase(database, {
                    deleteCode: value
                });
            };
    }
    render() {
        const { source: source, databases: databases, actions: actions } = this.props;
        const isDBReadOnly = (0, $e10a8602f56394e3$export$8668fc04891bde79)(source);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $eaa83b4bf15172b4$export$2e2bcd8739ae039), {
            activeTab: "databases",
            source: source
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $8445f462b7313dc1$export$2e2bcd8739ae039), {
            databases: databases,
            isRFDisplayed: !!source.metaUrl,
            isDBReadOnly: isDBReadOnly,
            isAddDBDisabled: isDBReadOnly || !!databases.some((db)=>db.isEditing),
            addDatabase: actions.addDatabase,
            onEditDatabase: this.handleEditDatabase,
            onCancelDatabase: actions.removeDatabase,
            onConfirmDatabase: this.handleCreateDatabase,
            onDeleteDatabase: actions.deleteDatabaseAsync,
            onKeyDownDatabase: this.handleKeyDownDatabase,
            onAddRetentionPolicy: this.handleAddRetentionPolicy,
            onRemoveDeleteCode: actions.removeDatabaseDeleteCode,
            onStartDeleteDatabase: this.handleStartDeleteDatabase,
            onRemoveRetentionPolicy: actions.removeRetentionPolicy,
            onDeleteRetentionPolicy: this.handleDeleteRetentionPolicy,
            onDatabaseDeleteConfirm: this.handleDatabaseDeleteConfirm,
            onCreateRetentionPolicy: actions.createRetentionPolicyAsync,
            onUpdateRetentionPolicy: actions.updateRetentionPolicyAsync
        }));
    }
}
const $ae004e1621a95da4$var$mapStateToProps = ({ adminInfluxDB: { databases: databases, retentionPolicies: retentionPolicies } })=>({
        databases: databases,
        retentionPolicies: retentionPolicies
    });
const $ae004e1621a95da4$var$mapDispatchToProps = (dispatch)=>({
        actions: (0, $1f80bbeadc1a0021$export$2e2bcd8739ae039)($e271547bf032bb19$exports, dispatch),
        notify: (0, $1f80bbeadc1a0021$export$2e2bcd8739ae039)((0, $205d139de2918454$export$5e14cdade93d6f7b), dispatch)
    });
var $ae004e1621a95da4$export$2e2bcd8739ae039 = (0, $c8cd79e362cba2a4$export$a520fb22fccea800)((0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($ae004e1621a95da4$var$mapStateToProps, $ae004e1621a95da4$var$mapDispatchToProps)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($ae004e1621a95da4$var$DatabaseManagerPage)));



var $NdCUR = parcelRequire("NdCUR");








var $NdCUR = parcelRequire("NdCUR");
const $ef4ff94a119b8367$var$NoEntities = ({ entities: entities, filtered: filtered })=>filtered ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", {
        className: "empty"
    }, "No Matching ", entities, " Found") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", {
        className: "empty"
    }, "You don't have any ", entities, ",", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("br", null), "why not create one?");
var $ef4ff94a119b8367$export$2e2bcd8739ae039 = $ef4ff94a119b8367$var$NoEntities;



var $NdCUR = parcelRequire("NdCUR");



const $490688b9a0d2bba9$var$ADMIN_STYLES = [
    {
        style: 'admin--not-admin',
        text: 'No'
    },
    {
        style: 'admin--is-admin',
        text: 'Yes'
    }
];
const $490688b9a0d2bba9$var$UserRow = ({ user: user, allRoles: allRoles, hasRoles: hasRoles, page: page, userDBPermissions: userDBPermissions, showRoles: showRoles })=>{
    const adminStyle = $490688b9a0d2bba9$var$ADMIN_STYLES[+!!user.permissions.find((x)=>x.scope === 'all' && (x.allowed || []).includes('ALL'))];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tr", {
        "data-test": 'user-row--' + user.name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
        style: {
            width: `${(0, $6bd39f00410cdd05$export$c367ad1972a0fb01).colUsername}px`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ba1cc4424c00aefe$export$2e2bcd8739ae039), {
        to: page
    }, user.name)), hasRoles && showRoles && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
        className: "admin-table--left-offset",
        title: !allRoles.length ? 'No roles are defined' : '',
        "data-test": "roles-granted"
    }, user.roles.map((role, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            key: i,
            className: "role-value granted"
        }, role.name))), !hasRoles && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
        style: {
            width: `${(0, $6bd39f00410cdd05$export$c367ad1972a0fb01).colAdministrator}px`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        className: adminStyle.style
    }, adminStyle.text)), userDBPermissions.map((perms, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            className: "admin-table__dbperm",
            key: i,
            "data-test": "permissions--values"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: `permission-value ${perms.READ || perms.ReadData ? 'granted' : 'denied'}`,
            title: (0, $e10a8602f56394e3$export$d6eefc103e184eaa).ReadData.description,
            "data-test": "read-permission"
        }, (0, $e10a8602f56394e3$export$d6eefc103e184eaa).ReadData.displayName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: `permission-value ${perms.WRITE || perms.WriteData ? 'granted' : 'denied'}`,
            title: (0, $e10a8602f56394e3$export$d6eefc103e184eaa).WriteData.description,
            "data-test": "write-permission"
        }, (0, $e10a8602f56394e3$export$d6eefc103e184eaa).WriteData.displayName))));
};
var $490688b9a0d2bba9$export$2e2bcd8739ae039 = $490688b9a0d2bba9$var$UserRow;




var $NdCUR = parcelRequire("NdCUR");
/**
 * Acts like React.useEffect, but it does not call the effect
 * for the first time, but only opon any change after initialization.
 */ function $6780c1ec7807c02d$var$useChangeEffect(effect, deps) {
    const first = (0, $NdCUR.useRef)(true);
    (0, $NdCUR.useEffect)(()=>{
        if (first.current) {
            first.current = false;
            return;
        }
        return effect();
    }, deps);
}
var $6780c1ec7807c02d$export$2e2bcd8739ae039 = $6780c1ec7807c02d$var$useChangeEffect;



const $3fae487d95c6547a$var$getEmptyDBPermRecords = ()=>({});
function $3fae487d95c6547a$export$a505508ba136d1de(e, dbNames, initialDBPermRecords = {}) {
    return e.permissions.reduce((acc, perm)=>{
        if (perm.scope === 'all') {
            const allowed = perm.allowed.includes('ALL') ? {
                READ: true,
                WRITE: true
            } : perm.allowed.reduce((obj, x)=>{
                obj[x] = true;
                return obj;
            }, {});
            dbNames.forEach((name)=>acc[name] = {
                    ...allowed,
                    ...acc[name]
                });
        } else if (perm.scope === 'database') acc[perm.name] = perm.allowed.reduce((obj, permValue)=>{
            obj[permValue] = true;
            return obj;
        }, acc[perm.name] || {});
        return acc;
    }, initialDBPermRecords);
}
function $3fae487d95c6547a$export$bb6cf50db31e6d90(...records) {
    return records.reduce((acc, record)=>{
        Object.entries(record).forEach(([db, perms])=>{
            const dbPerms = acc[db] || (acc[db] = {});
            Object.entries(perms).forEach(([perm, val])=>dbPerms[perm] = val);
        });
        return acc;
    }, {});
}
function $3fae487d95c6547a$export$96f7157278bed44a(entities, dbNames, getInitialDBRecords = $3fae487d95c6547a$var$getEmptyDBPermRecords) {
    return entities.map((e)=>{
        const dbPermRecords = $3fae487d95c6547a$export$a505508ba136d1de(e, dbNames, getInitialDBRecords(e));
        return dbNames.map((dbName)=>dbPermRecords[dbName] || {});
    });
}
function $3fae487d95c6547a$export$b1d194fc8dba29f4(users, roles, dbNames) {
    const rolesDBPermRecords = roles.reduce((acc, role)=>{
        acc[role.name] = [
            role,
            undefined
        ];
        return acc;
    }, {});
    const getInitialPermRecord = (u)=>{
        if (u.roles?.length) return u.roles.reduce((acc, { name: roleName })=>{
            const pair = rolesDBPermRecords[roleName];
            let rolePerms = pair[1];
            if (!rolePerms) {
                rolePerms = $3fae487d95c6547a$export$a505508ba136d1de(pair[0], dbNames);
                pair[1] = rolePerms;
            }
            return $3fae487d95c6547a$export$bb6cf50db31e6d90(acc, rolePerms);
        }, {});
        return {};
    };
    return $3fae487d95c6547a$export$96f7157278bed44a(users, dbNames, getInitialPermRecord);
}



var $NdCUR = parcelRequire("NdCUR");

const $ea09e1ff1c9f40ff$var$minLen = 3;
function $ea09e1ff1c9f40ff$export$b4155683fe8153a9(name) {
    return name?.length >= $ea09e1ff1c9f40ff$var$minLen;
}
const $ea09e1ff1c9f40ff$export$4d2a7159fda5dc93 = $ea09e1ff1c9f40ff$export$b4155683fe8153a9;
const $ea09e1ff1c9f40ff$var$CreateUserDialog = ({ visible: visible, setVisible: setVisible, create: create })=>{
    const [name, setName] = (0, $NdCUR.useState)('');
    const [password, setPassword] = (0, $NdCUR.useState)('');
    const cancel = (0, $NdCUR.useCallback)(()=>{
        setName('');
        setPassword('');
        setVisible(false);
    }, []);
    const onEnterPressed = (0, $NdCUR.useCallback)((e)=>{
        if (e.key === 'Enter' && name && password) {
            e.stopPropagation();
            create({
                name: name,
                password: password
            });
        }
    }, [
        name,
        password,
        create
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $827fcd4cb090ac0e$export$2e2bcd8739ae039), {
        visible: visible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1868bdace58643df$export$2e2bcd8739ae039), {
        maxWidth: 650
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1372e03f76900c5b$export$2e2bcd8739ae039), {
        title: "Create User",
        onDismiss: cancel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1e8c886c7914a527$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("form", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c5881206d41e0616$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c5881206d41e0616$export$2e2bcd8739ae039).Element, {
        label: "User Name"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $86817c9e53a28f66$export$2e2bcd8739ae039), {
        value: name,
        onChange: (e)=>setName(e.target.value),
        autoFocus: true,
        autoComplete: "off",
        onKeyPress: onEnterPressed,
        status: $ea09e1ff1c9f40ff$export$b4155683fe8153a9(name) ? (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Valid : (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Default,
        testId: "username--input"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c5881206d41e0616$export$2e2bcd8739ae039).Element, {
        label: "Password"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $86817c9e53a28f66$export$2e2bcd8739ae039), {
        value: password,
        type: (0, $86817c9e53a28f66$export$476dfc2401bc286b).Password,
        status: $ea09e1ff1c9f40ff$export$4d2a7159fda5dc93(password) ? (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Valid : (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Default,
        onChange: (e)=>setPassword(e.target.value),
        onKeyPress: onEnterPressed,
        autoComplete: "off",
        testId: "password--input"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c5881206d41e0616$export$2e2bcd8739ae039).Footer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "form-group text-center form-group-submit col-xs-12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
        className: "btn btn-sm btn-default",
        onClick: cancel,
        type: "button"
    }, "Cancel"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
        className: "btn btn-sm btn-success",
        disabled: !(name && password),
        type: "button",
        onClick: ()=>create({
                name: name,
                password: password
            })
    }, "Create"))))))));
};
var $ea09e1ff1c9f40ff$export$2e2bcd8739ae039 = $ea09e1ff1c9f40ff$var$CreateUserDialog;




var $NdCUR = parcelRequire("NdCUR");



const $3a6d3dcc7cd9a582$var$mapStateToProps = ({ adminInfluxDB: { databases: databases, selectedDBs: selectedDBs } })=>({
        databases: databases,
        selectedDBs: selectedDBs
    });
const $3a6d3dcc7cd9a582$var$mapDispatchToProps = {
    setSelectedDBs: (0, $e271547bf032bb19$export$de10f08c6868453e)
};
const $3a6d3dcc7cd9a582$var$MultiDBSelector = ({ databases: databases, selectedDBs: selectedDBs, setSelectedDBs: setSelectedDBs })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "db-selector"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fba4704c463778f3$export$2e2bcd8739ae039), {
        onChange: setSelectedDBs,
        selectedIDs: selectedDBs,
        emptyText: "<no database>"
    }, databases.reduce((acc, db)=>{
        acc.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fba4704c463778f3$export$2e2bcd8739ae039).Item, {
            key: db.name,
            id: db.name,
            value: {
                id: db.name
            }
        }, db.name));
        return acc;
    }, [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fba4704c463778f3$export$2e2bcd8739ae039).Item, {
            id: "*",
            key: "*",
            value: {
                id: '*'
            }
        }, "All Databases"),
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fba4704c463778f3$export$2e2bcd8739ae039).Divider, {
            id: "",
            key: ""
        })
    ])));
};
var $3a6d3dcc7cd9a582$export$2e2bcd8739ae039 = (0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($3a6d3dcc7cd9a582$var$mapStateToProps, $3a6d3dcc7cd9a582$var$mapDispatchToProps)($3a6d3dcc7cd9a582$var$MultiDBSelector);


const $88edc969ddbabdb9$var$validateUser = (user, notify)=>{
    if (!(0, $ea09e1ff1c9f40ff$export$b4155683fe8153a9)(user.name)) {
        notify((0, $ec1f42de4faacc37$export$ea1c3821542ff55e)());
        return false;
    }
    if (!(0, $ea09e1ff1c9f40ff$export$4d2a7159fda5dc93)(user.password)) {
        notify((0, $ec1f42de4faacc37$export$64b28869dcd192f)());
        return false;
    }
    return true;
};
const $88edc969ddbabdb9$var$mapStateToProps = ({ adminInfluxDB: { databases: databases, users: users, roles: roles, selectedDBs: selectedDBs, showRoles: showRoles, usersFilter: usersFilter } })=>({
        databases: databases,
        users: users,
        roles: roles,
        selectedDBs: selectedDBs,
        showRoles: showRoles,
        usersFilter: usersFilter
    });
const $88edc969ddbabdb9$var$mapDispatchToProps = {
    filterUsers: (0, $e271547bf032bb19$export$3e8d7a10dddfc47e),
    createUser: (0, $e271547bf032bb19$export$88a546ec116dc5dc),
    toggleShowRoles: (0, $e271547bf032bb19$export$97a83c13efe928eb),
    notify: (0, $205d139de2918454$export$5e14cdade93d6f7b)
};
const $88edc969ddbabdb9$var$UsersPage = ({ router: router, source: source, databases: databases, users: users, roles: roles, selectedDBs: selectedDBs, showRoles: showRoles, usersFilter: usersFilter, notify: notify, createUser: createUser, filterUsers: filterUsers, toggleShowRoles: toggleShowRoles })=>{
    const [isEnterprise, usersPage] = (0, $NdCUR.useMemo)(()=>[
            (0, $eaa83b4bf15172b4$export$a51709d05d806ee2)(source),
            `/sources/${source.id}/admin-influxdb/users`
        ], [
        source
    ]);
    // database columns
    const visibleDBNames = (0, $NdCUR.useMemo)(()=>{
        if (selectedDBs.includes('*')) return databases.map((db)=>db.name);
        return selectedDBs;
    }, [
        databases,
        selectedDBs
    ]);
    // effective permissions
    const visibleUsers = (0, $NdCUR.useMemo)(()=>users.filter((x)=>!x.hidden), [
        users
    ]);
    const userDBPermissions = (0, $NdCUR.useMemo)(()=>(0, $3fae487d95c6547a$export$b1d194fc8dba29f4)(visibleUsers, roles, visibleDBNames), [
        visibleDBNames,
        visibleUsers,
        roles
    ]);
    // filter users
    const [filterText, setFilterText] = (0, $NdCUR.useState)(usersFilter);
    const changeFilterText = (0, $NdCUR.useCallback)((e)=>setFilterText(e.target.value), []);
    const debouncedFilterText = (0, $9f13d970a740e49f$export$2e2bcd8739ae039)(filterText, 200);
    (0, $6780c1ec7807c02d$export$2e2bcd8739ae039)(()=>{
        filterUsers(debouncedFilterText);
    }, [
        debouncedFilterText
    ]);
    const [createVisible, setCreateVisible] = (0, $NdCUR.useState)(false);
    const createNew = (0, $NdCUR.useCallback)(async (user)=>{
        if (users.some((x)=>x.name === user.name)) {
            notify((0, $ec1f42de4faacc37$export$cc3632ec43d85246)());
            return;
        }
        if (!$88edc969ddbabdb9$var$validateUser(user, notify)) return;
        await createUser(source.links.users, user);
        router.push(`/sources/${source.id}/admin-influxdb/users/${encodeURIComponent(user.name)}`);
    }, [
        users,
        router,
        source,
        notify
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $eaa83b4bf15172b4$export$2e2bcd8739ae039), {
        activeTab: "users",
        source: source
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ea09e1ff1c9f40ff$export$2e2bcd8739ae039), {
        visible: createVisible,
        setVisible: setCreateVisible,
        create: createNew
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel panel-solid influxdb-admin"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel-heading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "search-widget"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
        type: "text",
        className: "form-control input-sm",
        placeholder: `Filter Users...`,
        value: filterText,
        onChange: changeFilterText,
        "data-test": "user-filter--input"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        className: "icon search"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $3a6d3dcc7cd9a582$export$2e2bcd8739ae039), null), isEnterprise && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "hide-roles-toggle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $4115c6d17e8dc56b$export$2e2bcd8739ae039), {
        active: showRoles,
        onChange: toggleShowRoles,
        size: (0, $918c9f03a35fe03f$export$fafce5c139da9687).ExtraSmall
    }), "Show Roles"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel-heading--right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
        className: "btn btn-sm btn-primary",
        onClick: ()=>setCreateVisible(true),
        "data-test": "create-user--button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        className: "icon plus"
    }), " Create User"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel-body"
    }, visibleUsers.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("table", {
        className: "table v-center admin-table table-highlight admin-table--compact"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", null, "User"), showRoles && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
        className: "admin-table--left-offset"
    }, isEnterprise ? 'Roles' : 'Admin'), visibleDBNames.length ? visibleDBNames.map((name)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
            className: "admin-table__dbheader",
            title: `effective permissions for db: ${name}`,
            key: name
        }, name)) : null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tbody", null, visibleUsers.map((user, userIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $490688b9a0d2bba9$export$2e2bcd8739ae039), {
            key: user.name,
            user: user,
            page: `${usersPage}/${encodeURIComponent(user.name || '')}`,
            userDBPermissions: userDBPermissions[userIndex],
            allRoles: roles,
            showRoles: showRoles,
            hasRoles: isEnterprise
        }))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ef4ff94a119b8367$export$2e2bcd8739ae039), {
        entities: "Users",
        filtered: !!debouncedFilterText
    }))));
};
const $88edc969ddbabdb9$var$UsersPageAvailable = (props)=>{
    if ((0, $eaa83b4bf15172b4$export$3295c333c7855cf3)(props.source)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $eaa83b4bf15172b4$export$2e2bcd8739ae039), {
        activeTab: "users",
        source: props.source
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "container-fluid"
    }, "Users are managed in LDAP directory."));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($88edc969ddbabdb9$var$UsersPage, props);
};
var $88edc969ddbabdb9$export$2e2bcd8739ae039 = (0, $c8cd79e362cba2a4$export$a520fb22fccea800)((0, $dffbdf89c590a961$export$2e2bcd8739ae039)((0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($88edc969ddbabdb9$var$mapStateToProps, $88edc969ddbabdb9$var$mapDispatchToProps)($88edc969ddbabdb9$var$UsersPageAvailable)));



var $NdCUR = parcelRequire("NdCUR");










var $NdCUR = parcelRequire("NdCUR");



const $fafaaa244b14448c$var$RoleRow = ({ role: role, allUsers: allUsers, page: page, perDBPermissions: perDBPermissions, showUsers: showUsers })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tr", {
        "data-test": `role-${role.name}--row`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
        style: {
            width: `${(0, $6bd39f00410cdd05$export$867baa1e36de1973).colName}px`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ba1cc4424c00aefe$export$2e2bcd8739ae039), {
        to: page
    }, role.name)), showUsers && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
        className: "admin-table--left-offset",
        title: !allUsers.length ? 'No users are defined' : ''
    }, role.users.map((user, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            key: i,
            className: "user-value granted"
        }, user.name))), perDBPermissions.map((perms, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
            className: "admin-table__dbperm",
            key: i
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: `permission-value ${perms.ReadData ? 'granted' : 'denied'}`,
            title: (0, $e10a8602f56394e3$export$d6eefc103e184eaa).ReadData.description,
            "data-test": "read-permission"
        }, (0, $e10a8602f56394e3$export$d6eefc103e184eaa).ReadData.displayName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
            className: `permission-value ${perms.WriteData ? 'granted' : 'denied'}`,
            title: (0, $e10a8602f56394e3$export$d6eefc103e184eaa).WriteData.description,
            "data-test": "write-permission"
        }, (0, $e10a8602f56394e3$export$d6eefc103e184eaa).WriteData.displayName))));
};
var $fafaaa244b14448c$export$2e2bcd8739ae039 = $fafaaa244b14448c$var$RoleRow;







var $NdCUR = parcelRequire("NdCUR");

const $465907fa0adf8436$var$minLen = 3;
function $465907fa0adf8436$export$fc1d741cf554eabd(name) {
    return name?.length >= $465907fa0adf8436$var$minLen;
}
const $465907fa0adf8436$var$CreateRoleDialog = ({ visible: visible, setVisible: setVisible, create: create })=>{
    const [name, setName] = (0, $NdCUR.useState)('');
    const cancel = (0, $NdCUR.useCallback)(()=>{
        setName('');
        setVisible(false);
    }, []);
    const onEnterPressed = (0, $NdCUR.useCallback)((e)=>{
        if (e.key === 'Enter' && name) {
            e.stopPropagation();
            create({
                name: name
            });
        }
    }, [
        name,
        create
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $827fcd4cb090ac0e$export$2e2bcd8739ae039), {
        visible: visible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1868bdace58643df$export$2e2bcd8739ae039), {
        maxWidth: 650
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1372e03f76900c5b$export$2e2bcd8739ae039), {
        title: "Create Role",
        onDismiss: cancel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1e8c886c7914a527$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("form", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c5881206d41e0616$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c5881206d41e0616$export$2e2bcd8739ae039).Element, {
        label: "Role Name"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $86817c9e53a28f66$export$2e2bcd8739ae039), {
        value: name,
        autoFocus: true,
        autoComplete: "off",
        onChange: (e)=>setName(e.target.value),
        onKeyPress: onEnterPressed,
        status: $465907fa0adf8436$export$fc1d741cf554eabd(name) ? (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Valid : (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Default,
        testId: "role-name--input"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c5881206d41e0616$export$2e2bcd8739ae039).Footer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "form-group text-center form-group-submit col-xs-12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
        className: "btn btn-sm btn-default",
        onClick: cancel,
        type: "button",
        "data-test": "form--cancel-role--button"
    }, "Cancel"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
        className: "btn btn-sm btn-success",
        disabled: !name,
        type: "button",
        onClick: ()=>create({
                name: name
            }),
        "data-test": "form--create-role--button"
    }, "Create"))))))));
};
var $465907fa0adf8436$export$2e2bcd8739ae039 = $465907fa0adf8436$var$CreateRoleDialog;



const $1bde67fac5504550$var$validateRole = (role, notify)=>{
    if (!(0, $465907fa0adf8436$export$fc1d741cf554eabd)(role.name)) {
        notify((0, $ec1f42de4faacc37$export$f6a944aaea43bf79)());
        return false;
    }
    return true;
};
const $1bde67fac5504550$var$mapStateToProps = ({ adminInfluxDB: { databases: databases, users: users, roles: roles, selectedDBs: selectedDBs, showUsers: showUsers, rolesFilter: rolesFilter } })=>({
        databases: databases,
        users: users,
        roles: roles,
        selectedDBs: selectedDBs,
        showUsers: showUsers,
        rolesFilter: rolesFilter
    });
const $1bde67fac5504550$var$mapDispatchToProps = {
    filterRoles: (0, $e271547bf032bb19$export$b684fd0e6ec2497d),
    createRole: (0, $e271547bf032bb19$export$df7e75ea7d72da62),
    notify: (0, $205d139de2918454$export$5e14cdade93d6f7b),
    toggleShowUsers: (0, $e271547bf032bb19$export$77998114e017bba9)
};
const $1bde67fac5504550$var$RolesPage = ({ source: source, users: users, roles: roles, databases: databases, selectedDBs: selectedDBs, showUsers: showUsers, rolesFilter: rolesFilter, router: router, filterRoles: filterRoles, createRole: createRole, toggleShowUsers: toggleShowUsers, notify: notify })=>{
    const rolesPage = (0, $NdCUR.useMemo)(()=>`/sources/${source.id}/admin-influxdb/roles`, [
        source
    ]);
    // database columns
    const visibleDBNames = (0, $NdCUR.useMemo)(()=>{
        if (selectedDBs.includes('*')) return databases.map((db)=>db.name);
        return selectedDBs;
    }, [
        databases,
        selectedDBs
    ]);
    // effective permissions
    const visibleRoles = (0, $NdCUR.useMemo)(()=>roles.filter((x)=>!x.hidden), [
        roles
    ]);
    const perDBPermissions = (0, $NdCUR.useMemo)(()=>(0, $3fae487d95c6547a$export$96f7157278bed44a)(visibleRoles, visibleDBNames), [
        visibleDBNames,
        visibleRoles
    ]);
    // filter roles
    const [filterText, setFilterText] = (0, $NdCUR.useState)(rolesFilter);
    const changeFilterText = (0, $NdCUR.useCallback)((e)=>setFilterText(e.target.value), []);
    const debouncedFilterText = (0, $9f13d970a740e49f$export$2e2bcd8739ae039)(filterText, 200);
    (0, $6780c1ec7807c02d$export$2e2bcd8739ae039)(()=>{
        filterRoles(debouncedFilterText);
    }, [
        debouncedFilterText
    ]);
    const [createVisible, setCreateVisible] = (0, $NdCUR.useState)(false);
    const createNew = (0, $NdCUR.useCallback)(async (role)=>{
        if (roles.some((x)=>x.name === role.name)) {
            notify((0, $ec1f42de4faacc37$export$a66177f85945ac02)());
            return;
        }
        if (!$1bde67fac5504550$var$validateRole(role, notify)) return;
        await createRole(source.links.roles, role);
        router.push(`/sources/${source.id}/admin-influxdb/roles/${encodeURIComponent(role.name)}`);
    }, [
        roles,
        router,
        source,
        notify
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $eaa83b4bf15172b4$export$2e2bcd8739ae039), {
        activeTab: "roles",
        source: source
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $465907fa0adf8436$export$2e2bcd8739ae039), {
        visible: createVisible,
        setVisible: setCreateVisible,
        create: createNew
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel panel-solid influxdb-admin"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel-heading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "search-widget"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
        type: "text",
        className: "form-control input-sm",
        placeholder: `Filter Roles...`,
        value: filterText,
        onChange: changeFilterText
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        className: "icon search"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $3a6d3dcc7cd9a582$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "hide-roles-toggle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $4115c6d17e8dc56b$export$2e2bcd8739ae039), {
        active: showUsers,
        onChange: toggleShowUsers,
        size: (0, $918c9f03a35fe03f$export$fafce5c139da9687).ExtraSmall,
        testId: "show-users--toggle"
    }), "Show Users"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel-heading--right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
        className: "btn btn-sm btn-primary",
        onClick: ()=>setCreateVisible(true),
        "data-test": "create-role--button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        className: "icon plus"
    }), " Create Role"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel-body"
    }, visibleRoles.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("table", {
        className: "table v-center admin-table table-highlight admin-table--compact"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("thead", {
        "data-test": "admin-table--head"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", null, "Role"), showUsers && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
        className: "admin-table--left-offset"
    }, "Users"), visibleDBNames.length ? visibleDBNames.map((name)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
            className: "admin-table__dbheader",
            title: `effective permissions for db: ${name}`,
            key: name
        }, name)) : null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tbody", {
        "data-test": "admin-table--body"
    }, visibleRoles.map((role, roleIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fafaaa244b14448c$export$2e2bcd8739ae039), {
            key: role.name,
            role: role,
            page: `${rolesPage}/${encodeURIComponent(role.name || '')}`,
            perDBPermissions: perDBPermissions[roleIndex],
            allUsers: users,
            showUsers: showUsers
        }))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $ef4ff94a119b8367$export$2e2bcd8739ae039), {
        entities: "Roles",
        filtered: !!debouncedFilterText
    }))));
};
const $1bde67fac5504550$var$RolesPageAvailable = (props)=>{
    if (!(0, $eaa83b4bf15172b4$export$a51709d05d806ee2)(props.source)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $eaa83b4bf15172b4$export$2e2bcd8739ae039), {
        activeTab: "roles",
        source: props.source
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "container-fluid"
    }, "Roles management is not available for the currently selected InfluxDB Connection."));
    if ((0, $eaa83b4bf15172b4$export$3295c333c7855cf3)(props.source)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $eaa83b4bf15172b4$export$2e2bcd8739ae039), {
        activeTab: "roles",
        source: props.source
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "container-fluid"
    }, "Users are managed via LDAP, roles management is not available."));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($1bde67fac5504550$var$RolesPage, props);
};
var $1bde67fac5504550$export$2e2bcd8739ae039 = (0, $c8cd79e362cba2a4$export$a520fb22fccea800)((0, $dffbdf89c590a961$export$2e2bcd8739ae039)((0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($1bde67fac5504550$var$mapStateToProps, $1bde67fac5504550$var$mapDispatchToProps)($1bde67fac5504550$var$RolesPageAvailable)));



var $NdCUR = parcelRequire("NdCUR");


var $eec31621a43bbafa$exports = {};

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $eec31621a43bbafa$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $6bc15f8cc5a05c72$exports(array, 1) : [];
}
$eec31621a43bbafa$exports = $eec31621a43bbafa$var$flatten;


var $93122c04566c7a2f$exports = {};


/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $93122c04566c7a2f$var$uniqBy(array, iteratee) {
    return array && array.length ? $a1f8839e2550ec0f$exports(array, $76648cdc70b67884$exports(iteratee, 2)) : [];
}
$93122c04566c7a2f$exports = $93122c04566c7a2f$var$uniqBy;




var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");

var $NdCUR = parcelRequire("NdCUR");

var $fGw9V = parcelRequire("fGw9V");


const $a131ba31b497c2dd$var$QueryRow = ({ query: query, onKill: onKill })=>{
    const { database: database, duration: duration, status: status } = query;
    const wrappedKill = ()=>{
        onKill(query);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
        style: {
            width: `${(0, $6bd39f00410cdd05$export$2db02977e6744a80).colDatabase}px`
        },
        className: "monotype"
    }, database), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("code", null, query.query)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
        style: {
            width: `${(0, $6bd39f00410cdd05$export$2db02977e6744a80).colDuration}px`
        },
        className: "monotype"
    }, duration), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", {
        style: {
            width: `${(0, $6bd39f00410cdd05$export$2db02977e6744a80).colKillQuery}px`
        },
        className: "text-left"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        style: {
            width: '100%',
            position: 'relative'
        }
    }, status === 'running' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        style: {
            width: '100%',
            position: 'absolute',
            top: '-4px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $8008717819fc7a5f$export$2e2bcd8739ae039), {
        text: "Kill",
        confirmAction: wrappedKill,
        size: "btn-xs",
        type: "btn-danger",
        customClass: "table--show-on-row-hover",
        style: {
            width: '100%'
        }
    })) : undefined, status)));
};
const { func: $a131ba31b497c2dd$var$func, shape: $a131ba31b497c2dd$var$shape } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$a131ba31b497c2dd$var$QueryRow.propTypes = {
    query: $a131ba31b497c2dd$var$shape().isRequired,
    onKill: $a131ba31b497c2dd$var$func.isRequired
};
var $a131ba31b497c2dd$export$2e2bcd8739ae039 = $a131ba31b497c2dd$var$QueryRow;



const $1608832d9a585c41$var$QueriesTable = ({ queries: queries, queriesSort: queriesSort, changeSort: changeSort, onKillQuery: onKillQuery })=>{
    let timeSortClass = 'col--sort-next-desc';
    let dbSortClass = 'col--sort-next-asc';
    let newTimeSort = '-time';
    let newDBSort = '+database';
    switch(queriesSort){
        case '-time':
            timeSortClass = 'col--sort-desc';
            newTimeSort = '+time';
            break;
        case '+time':
            timeSortClass = 'col--sort-asc';
            newTimeSort = '-time';
            break;
        case '-database':
            dbSortClass = 'col--sort-desc';
            newDBSort = '+database';
            break;
        case '+database':
            dbSortClass = 'col--sort-asc';
            newDBSort = '-database';
            break;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("table", {
        className: "table v-center admin-table table-highlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
        style: {
            width: `${(0, $6bd39f00410cdd05$export$2db02977e6744a80).colDatabase}px`
        },
        className: `col--sortable ${dbSortClass}`,
        onClick: ()=>changeSort(newDBSort)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null, "Database")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", null, "Query"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
        style: {
            width: `${(0, $6bd39f00410cdd05$export$2db02977e6744a80).colDuration}px`
        },
        className: `col--sortable ${timeSortClass}`,
        onClick: ()=>changeSort(newTimeSort)
    }, "Duration"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
        style: {
            width: `${(0, $6bd39f00410cdd05$export$2db02977e6744a80).colKillQuery}px`
        }
    }, "Status"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tbody", null, queries.map((q)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a131ba31b497c2dd$export$2e2bcd8739ae039), {
            key: q.id,
            query: q,
            onKill: onKillQuery
        }))));
};
const { arrayOf: $1608832d9a585c41$var$arrayOf, func: $1608832d9a585c41$var$func, shape: $1608832d9a585c41$var$shape } = (0, (/*@__PURE__*/$parcel$interopDefault($fGw9V)));
$1608832d9a585c41$var$QueriesTable.propTypes = {
    queries: $1608832d9a585c41$var$arrayOf($1608832d9a585c41$var$shape()),
    queriesSort: (0, $fGw9V.string),
    changeSort: $1608832d9a585c41$var$func,
    onConfirm: $1608832d9a585c41$var$func,
    onKillQuery: $1608832d9a585c41$var$func
};
var $1608832d9a585c41$export$2e2bcd8739ae039 = $1608832d9a585c41$var$QueriesTable;



function $2ae138e38cbc1d52$export$2e2bcd8739ae039(response) {
    const results = response.results[0];
    if (results.error) return {
        errors: [
            results.error
        ],
        queries: []
    };
    const series = results.series[0];
    if (!series.values) return {
        errors: [],
        queries: []
    };
    const queries = series.values.map((value)=>{
        return {
            id: value[series.columns.indexOf('qid')],
            database: value[series.columns.indexOf('database')],
            query: value[series.columns.indexOf('query')],
            status: value[series.columns.indexOf('status')],
            duration: value[series.columns.indexOf('duration')]
        };
    });
    return {
        errors: [],
        queries: queries
    };
}









var $axd2S = parcelRequire("axd2S");



class $3c9a79623b836c2f$var$QueriesPage extends (0, $NdCUR.Component) {
    constructor(props){
        super(props), this.updateQueries = ()=>{
            const { source: source, notify: notify, loadQueries: loadQueries } = this.props;
            const dbErrors = [];
            (0, $8ba03c44d4b91783$export$46acc72e11cde242)(source.links.proxy).then((resp)=>{
                const { databases: databases, errors: errors } = (0, $b0c8a009bdea2e59$export$2e2bcd8739ae039)(resp.data);
                if (errors.length) {
                    this.setState((state)=>({
                            ...state,
                            title: ''
                        }));
                    errors.forEach((message)=>notify((0, $ec1f42de4faacc37$export$43064f5e630893ac)(message)));
                    return;
                }
                this.setState((state)=>({
                        ...state,
                        title: databases.length === 1 ? '1 Database' : `${databases.length} Databases`
                    }));
                const fetches = databases.map((db)=>(0, $8ba03c44d4b91783$export$b87c83d7687fd7ef)(source.links.proxy, db));
                return Promise.allSettled(fetches).then((results)=>{
                    const allQueries = [];
                    results.forEach((settledResponse, i)=>{
                        if (settledResponse.status !== 'fulfilled') {
                            const msg = `Unable to show queries on '${databases[i]}': ${settledResponse.reason}`;
                            dbErrors.push(msg);
                            console.error('Unable to show queries', databases[i], settledResponse.reason);
                            return;
                        }
                        const result = (0, $2ae138e38cbc1d52$export$2e2bcd8739ae039)(settledResponse.value.data);
                        if (result.errors.length) result.errors.forEach((message)=>notify((0, $ec1f42de4faacc37$export$43064f5e630893ac)(message)));
                        allQueries.push(...result.queries);
                    });
                    const queries = (0, (/*@__PURE__*/$parcel$interopDefault($93122c04566c7a2f$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($eec31621a43bbafa$exports)))(allQueries), (q)=>q.id);
                    loadQueries(queries);
                });
            }).catch((e)=>{
                dbErrors.push(`Unable to show databases: ${e}`);
                console.error('Unable to show databases', e);
            }).then(()=>this.setState({
                    errors: dbErrors
                }));
        }, this.changeRefreshInterval = ({ milliseconds: updateInterval })=>{
            this.setState((state)=>({
                    ...state,
                    updateInterval: updateInterval
                }));
            if (this.intervalID) {
                clearInterval(this.intervalID);
                this.intervalID = undefined;
            }
            if (updateInterval > 0) {
                this.updateQueries();
                this.intervalID = setInterval(this.updateQueries, updateInterval);
            }
        }, this.handleKillQuery = (query)=>{
            const { source: source, killQuery: killQuery } = this.props;
            killQuery(source.links.proxy, query);
        }, this.downloadCSV = ()=>{
            const queries = this.props.queries || [];
            const csv = queries.reduce((acc, val)=>{
                const db = val.database.replace(/"/g, '""');
                const query = val.query.replace(/"/g, '""');
                return `${acc}"${db}","${query}",${val.duration},${val.status}${'\n'}`;
            }, 'database,query,duration,status\n');
            const blob = new Blob([
                csv
            ], {
                type: 'text/csv'
            });
            const a = document.createElement('a');
            a.href = window.URL.createObjectURL(blob);
            a.target = '_blank';
            a.download = `${(0, (/*@__PURE__*/$parcel$interopDefault($axd2S)))().format('YYYY-MM-DD-HH-mm-ss')} Chronograf Queries.csv`;
            document.body.appendChild(a);
            a.click();
            a.parentNode.removeChild(a);
        };
        this.state = {
            updateInterval: 5000,
            errors: [],
            title: ''
        };
    }
    componentDidMount() {
        this.updateQueries();
        if (this.state.updateInterval > 0) this.intervalID = setInterval(this.updateQueries, this.state.updateInterval);
    }
    componentWillUnmount() {
        if (this.intervalID) clearInterval(this.intervalID);
    }
    render() {
        const { queries: queries, queriesSort: queriesSort, changeSort: changeSort, source: source } = this.props;
        const { updateInterval: updateInterval, title: title, errors: errors } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $eaa83b4bf15172b4$export$2e2bcd8739ae039), {
            activeTab: "queries",
            source: source
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel panel-solid influxdb-admin"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel-heading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h2", {
            className: "panel-title"
        }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel-heading--right"
        }, queries && queries.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            style: {
                marginRight: '5px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
            customClass: "csv-export",
            text: "CSV",
            icon: (0, $918c9f03a35fe03f$export$62c9c0cf752cde38).Download,
            status: (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Default,
            onClick: this.downloadCSV
        })) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $e6a8d4614c25ddf0$export$2e2bcd8739ae039), {
            selected: updateInterval,
            onChoose: this.changeRefreshInterval,
            onManualRefresh: this.updateQueries,
            showManualRefresh: true
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "panel-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), null, queries && queries.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1608832d9a585c41$export$2e2bcd8739ae039), {
            queries: queries,
            queriesSort: queriesSort,
            changeSort: changeSort,
            onKillQuery: this.handleKillQuery
        }) : null, errors.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            style: {
                marginTop: '5px'
            }
        }, errors.map((e, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                key: `error${i}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $d4af08b6d61e805a$export$2e2bcd8739ae039), {
                message: e
            })))) : null))));
    }
}
const $3c9a79623b836c2f$var$mapStateToProps = ({ adminInfluxDB: { queries: queries, queriesSort: queriesSort, queryIDToKill: queryIDToKill } })=>({
        queries: queries,
        queriesSort: queriesSort,
        queryIDToKill: queryIDToKill
    });
const $3c9a79623b836c2f$var$mapDispatchToProps = {
    loadQueries: (0, $e271547bf032bb19$export$a4a6ceb246289b4c),
    setQueryToKill: (0, $e271547bf032bb19$export$1f1694874eb7e9fc),
    changeSort: (0, $e271547bf032bb19$export$bd8636d030837505),
    killQuery: (0, $e271547bf032bb19$export$3f02b0244acbfec9),
    notify: (0, $205d139de2918454$export$5e14cdade93d6f7b)
};
var $3c9a79623b836c2f$export$2e2bcd8739ae039 = (0, $c8cd79e362cba2a4$export$a520fb22fccea800)((0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($3c9a79623b836c2f$var$mapStateToProps, $3c9a79623b836c2f$var$mapDispatchToProps)((0, $855a64e5014f72b2$export$b648208ff1c161a7)($3c9a79623b836c2f$var$QueriesPage)));



var $NdCUR = parcelRequire("NdCUR");










function $0f8bd252fcb08c00$export$fcaf6b1a07b1ce20(user, isEnterprise) {
    return user.permissions.reduce((acc, perm)=>{
        if (!isEnterprise && perm.scope !== 'database') return acc // do not include all permissions in OSS, they have separate administration
        ;
        const dbName = perm.name || '';
        const dbPerms = acc[dbName] || (acc[dbName] = {});
        perm.allowed.forEach((x)=>dbPerms[x] = true);
        return acc;
    }, {});
}
function $0f8bd252fcb08c00$export$c7009bd8c437c03c(db, perm, userPermissions, changedPermissions) {
    const origState = userPermissions[db]?.[perm];
    const { [db]: changedDB, ...otherDBs } = changedPermissions;
    if (changedDB === undefined) // no change for the database yet
    return {
        [db]: {
            [perm]: !origState
        },
        ...otherDBs
    };
    const { [perm]: changedPerm, ...otherPerms } = changedDB;
    if (changedPerm === undefined) // no change for the permission yet
    return {
        [db]: {
            [perm]: !origState,
            ...otherPerms
        },
        ...otherDBs
    };
    if (Object.keys(otherPerms).length) // we are reverting what has been already changed,
    // return other changed permissions for this database
    return {
        [db]: otherPerms,
        ...otherDBs
    };
    // the current database is not changed as a result
    return otherDBs;
}
function $0f8bd252fcb08c00$export$9c67dcab50d05583(userPermissions, changedPermissions, appendAfter = []) {
    const newUserPermisssions = {
        ...userPermissions
    };
    Object.entries(changedPermissions).forEach(([db, perms])=>{
        if (newUserPermisssions[db]) newUserPermisssions[db] = {
            ...newUserPermisssions[db],
            ...perms
        };
        else newUserPermisssions[db] = {
            ...perms
        };
    });
    return Object.entries(newUserPermisssions).reduce((acc, [db, permRecord])=>{
        const allowed = Object.entries(permRecord).reduce((allowedAcc, [perm, use])=>{
            if (use) allowedAcc.push(perm);
            return allowedAcc;
        }, []);
        if (allowed.length) acc.push({
            scope: db ? 'database' : 'all',
            name: db || undefined,
            allowed: allowed
        });
        return acc;
    }, appendAfter);
}



var $NdCUR = parcelRequire("NdCUR");

const $cca1eaeac66a1201$var$minLen = 3;
function $cca1eaeac66a1201$export$fc1d741cf554eabd(name) {
    return name?.length >= $cca1eaeac66a1201$var$minLen;
}
const $cca1eaeac66a1201$var$ConfirmDiscardDialog = ({ visible: visible, onOK: onOK, onCancel: onCancel })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $827fcd4cb090ac0e$export$2e2bcd8739ae039), {
        visible: visible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1868bdace58643df$export$2e2bcd8739ae039), {
        maxWidth: 400
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $1372e03f76900c5b$export$2e2bcd8739ae039), {
        title: "Discard unsaved changes?"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "overlay--body",
        style: {
            minHeight: '100px',
            padding: '0px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("form", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c5881206d41e0616$export$2e2bcd8739ae039), null, [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c5881206d41e0616$export$2e2bcd8739ae039).Footer, {
            key: 1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            className: "form-group text-center col-xs-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-sm btn-warning",
            type: "button",
            onClick: onOK,
            "data-test": "confirm--ok--button"
        }, "OK"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("button", {
            className: "btn btn-sm btn-default",
            onClick: onCancel,
            type: "button",
            "data-test": "confirm--cancel--button"
        }, "Cancel")))
    ])))));
};
var $cca1eaeac66a1201$export$2e2bcd8739ae039 = $cca1eaeac66a1201$var$ConfirmDiscardDialog;


const $ca24f4b144650cd3$var$FAKE_USER = {
    name: '',
    permissions: [],
    roles: [],
    links: {
        self: ''
    }
};
const $ca24f4b144650cd3$var$mapStateToProps = ({ adminInfluxDB: { databases: databases, users: users, roles: roles, permissions: permissions } })=>({
        databases: databases,
        users: users,
        roles: roles,
        permissions: permissions
    });
const $ca24f4b144650cd3$var$mapDispatchToProps = {
    deleteUserAsync: $e271547bf032bb19$export$768a6f192dfb6e00,
    updateUserPasswordAsync: $e271547bf032bb19$export$3ac57f160b73278f,
    updateUserPermissionsAsync: $e271547bf032bb19$export$94268ff2217d9ade,
    updateUserRolesAsync: $e271547bf032bb19$export$104ba8708c1acdb9
};
const $ca24f4b144650cd3$var$UserPage = ({ users: users, databases: databases, permissions: serverPermissions, roles: roles, source: source, router: router, params: { userName: userName, sourceID: sourceID }, deleteUserAsync: deleteUserDispatchAsync, updateUserPasswordAsync: updatePasswordAsync, updateUserPermissionsAsync: updatePermissionsAsync, updateUserRolesAsync: updateRolesAsync })=>{
    if ((0, $eaa83b4bf15172b4$export$3295c333c7855cf3)(source)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "container-fluid"
    }, "Users are managed via LDAP.");
    const [running, setRunning] = (0, $NdCUR.useState)(false);
    const [password, setPassword] = (0, $NdCUR.useState)(undefined);
    const [user, deleteUser] = (0, $NdCUR.useMemo)(()=>{
        const u = users.find((x)=>x.name === userName) || $ca24f4b144650cd3$var$FAKE_USER;
        return [
            u,
            async ()=>{
                setRunning(true);
                try {
                    await deleteUserDispatchAsync(u);
                } finally{
                    setRunning(false);
                }
                router.push(`/sources/${sourceID}/admin-influxdb/users`);
            }
        ];
    }, [
        source,
        users,
        userName
    ]);
    const updatePassword = (0, $NdCUR.useMemo)(()=>async ()=>{
            setRunning(true);
            try {
                await updatePasswordAsync(user, password);
                setPassword(undefined);
            } finally{
                setRunning(false);
            }
        }, [
        user,
        password
    ]);
    const isEnterprise = (0, $eaa83b4bf15172b4$export$a51709d05d806ee2)(source);
    // admin
    const isAdmin = !isEnterprise && !!user.permissions.find((x)=>x.scope === 'all' && (x.allowed || []).includes('ALL'));
    const changeAdmin = (0, $NdCUR.useMemo)(()=>async ()=>{
            setRunning(true);
            try {
                let permissions = (user.permissions || []).filter((x)=>x.scope !== 'all');
                if (!isAdmin) permissions = [
                    {
                        scope: 'all',
                        allowed: [
                            'ALL'
                        ]
                    },
                    ...permissions
                ];
                await updatePermissionsAsync(user, permissions);
                setPassword(undefined);
            } finally{
                setRunning(false);
            }
        }, [
        user,
        isAdmin
    ]);
    // permissions
    const [dbPermisssions, clusterPermissions, userDBPermissions] = (0, $NdCUR.useMemo)(()=>[
            serverPermissions.find((x)=>x.scope === 'database')?.allowed || [],
            serverPermissions.find((x)=>x.scope === 'all')?.allowed || [],
            (0, $0f8bd252fcb08c00$export$fcaf6b1a07b1ce20)(user, isEnterprise)
        ], [
        serverPermissions,
        user,
        isEnterprise
    ]);
    const [changedPermissions, setChangedPermissions] = (0, $NdCUR.useState)({});
    (0, $NdCUR.useEffect)(()=>{
        setChangedPermissions({});
    }, [
        user
    ]);
    const onPermissionChange = (0, $NdCUR.useMemo)(()=>(e)=>{
            const db = e.target.dataset.db;
            const perm = e.target.dataset.perm;
            setChangedPermissions((0, $0f8bd252fcb08c00$export$c7009bd8c437c03c)(db, perm, userDBPermissions, changedPermissions));
        }, [
        userDBPermissions,
        changedPermissions
    ]);
    const permissionsChanged = !!Object.keys(changedPermissions).length;
    const changePermissions = (0, $NdCUR.useMemo)(()=>async ()=>{
            if (Object.entries(changedPermissions).length === 0) return true;
            setRunning(true);
            try {
                // append to existing all-scoped permissions in OSS, they manage administrator status
                const permissions = (0, $0f8bd252fcb08c00$export$9c67dcab50d05583)(userDBPermissions, changedPermissions, isEnterprise ? [] : user.permissions.filter((x)=>x.scope === 'all'));
                return await updatePermissionsAsync(user, permissions);
            } finally{
                setRunning(false);
            }
        }, [
        user,
        changedPermissions,
        userDBPermissions,
        isEnterprise
    ]);
    // roles
    const [allRoleNames, rolesRecord] = (0, $NdCUR.useMemo)(()=>{
        if (!isEnterprise) return [
            [],
            {}
        ];
        const rNames = (isEnterprise ? roles : []).map((r)=>r.name).sort();
        const urRecord = user.roles.reduce((acc, r)=>{
            acc[r.name] = true;
            return acc;
        }, {});
        return [
            rNames,
            urRecord
        ];
    }, [
        user,
        roles,
        isEnterprise
    ]);
    const [changedRolesRecord, setChangedRolesRecord] = (0, $NdCUR.useState)({});
    (0, $NdCUR.useEffect)(()=>setChangedRolesRecord({}), [
        user
    ]);
    const rolesChanged = (0, $NdCUR.useMemo)(()=>!!Object.keys(changedRolesRecord).length, [
        changedRolesRecord
    ]);
    const onRoleChange = (0, $NdCUR.useMemo)(()=>(e)=>{
            const role = e.target.dataset.role;
            const { [role]: roleChanged, ...restChanged } = changedRolesRecord;
            if (roleChanged === undefined) setChangedRolesRecord({
                ...changedRolesRecord,
                [role]: !rolesRecord[role]
            });
            else // returning back to original state
            setChangedRolesRecord(restChanged);
            return;
        }, [
        rolesRecord,
        changedRolesRecord
    ]);
    const changeRoles = (0, $NdCUR.useMemo)(()=>async ()=>{
            if (Object.entries(changedRolesRecord).length === 0) return true;
            setRunning(true);
            try {
                const newRoles = roles.reduce((acc, role)=>{
                    const roleName = role.name;
                    if (changedRolesRecord[roleName] === true || changedRolesRecord[roleName] === undefined && rolesRecord[roleName]) acc.push(role);
                    return acc;
                }, []);
                return await updateRolesAsync(user, newRoles);
            } finally{
                setRunning(false);
            }
        }, [
        user,
        rolesRecord,
        changedRolesRecord,
        roles
    ]);
    const dataChanged = (0, $NdCUR.useMemo)(()=>permissionsChanged || rolesChanged, [
        permissionsChanged,
        rolesChanged
    ]);
    const exitHandler = (0, $NdCUR.useCallback)(()=>{
        router.push(`/sources/${sourceID}/admin-influxdb/users`);
    }, [
        router,
        source
    ]);
    const changeData = (0, $NdCUR.useCallback)(async ()=>{
        if (await changeRoles() && await changePermissions()) exitHandler();
    }, [
        changePermissions,
        changeRoles,
        exitHandler
    ]);
    const databaseNames = (0, $NdCUR.useMemo)(()=>databases.reduce((acc, db)=>{
            acc.push(db.name);
            return acc;
        }, isEnterprise ? [
            ''
        ] : []), [
        isEnterprise,
        databases
    ]);
    const [exitUrl, setExitUrl] = (0, $NdCUR.useState)('');
    const onTabChange = (0, $NdCUR.useCallback)((_section, url)=>{
        if (dataChanged) {
            setExitUrl(url);
            return;
        }
        router.push(url);
    }, [
        router,
        dataChanged
    ]);
    const onExitCancel = (0, $NdCUR.useCallback)(()=>{
        setExitUrl('');
    }, []);
    const onExitConfirm = (0, $NdCUR.useCallback)(()=>{
        router.push(exitUrl);
    }, [
        router,
        exitUrl
    ]);
    const body = user === $ca24f4b144650cd3$var$FAKE_USER ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "container-fluid"
    }, "User ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        className: "error-warning"
    }, userName), " not found!") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel panel-solid influxdb-admin"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel-heading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h2", {
        className: "panel-title"
    }, password === undefined ? '' : 'Set password for user: ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        title: `User: ${userName}`
    }, userName)), password === undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel-heading--right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
        text: "Change password",
        onClick: ()=>setPassword(''),
        status: running ? (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Disabled : (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Default,
        testId: "change-password--button"
    }), !isEnterprise && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $8008717819fc7a5f$export$2e2bcd8739ae039), {
        type: "btn-default",
        text: isAdmin ? 'Revoke Admin' : 'Grant Admin',
        confirmText: isAdmin ? 'Revoke ALL Privileges' : 'Grant ALL Privileges',
        confirmAction: changeAdmin,
        disabled: running,
        position: "bottom",
        testId: `${isAdmin ? 'revoke' : 'grant'}-admin--button`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $8008717819fc7a5f$export$2e2bcd8739ae039), {
        type: "btn-danger",
        text: "Delete User",
        confirmAction: deleteUser,
        disabled: running,
        position: "bottom",
        testId: "delete-user--button"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel-body influxdb-admin--detail"
    }, password !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "influxdb-admin--pwdchange"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("input", {
        className: "form-control input-sm",
        name: "password",
        type: "password",
        value: password,
        placeholder: "New Password",
        disabled: running,
        onChange: (e)=>setPassword(e.target.value),
        onKeyPress: (e)=>{
            if (e.key === 'Enter') updatePassword();
        },
        style: {
            flex: '0 0 auto',
            width: '200px'
        },
        spellCheck: false,
        autoComplete: "false",
        "data-test": "new-password--input"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b4a526e8eda76ab1$export$2e2bcd8739ae039), {
        item: user,
        onConfirm: updatePassword,
        isDisabled: running,
        onCancel: ()=>setPassword(undefined),
        buttonSize: "btn-sm"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), null, isEnterprise && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "infludb-admin-section__header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", null, "Roles", rolesChanged ? ' (unsaved)' : '')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "infludb-admin-section__body"
    }, !allRoleNames.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, "No roles are defined.") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "collection-selector"
    }, allRoleNames.map((roleName, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            key: i,
            title: "Click to change, click Apply Changes to save all changes",
            "data-role": roleName,
            className: `role-value ${rolesRecord[roleName] ? 'granted' : 'denied'} ${changedRolesRecord[roleName] !== undefined ? 'value-changed' : ''}`,
            onClick: onRoleChange,
            "data-test": `role-${roleName}--button`
        }, roleName))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "infludb-admin-section__header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", null, isEnterprise ? 'Permissions' : 'Database Permissions', permissionsChanged ? ' (unsaved)' : '')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "infludb-admin-section__body"
    }, isAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", {
        "data-test": "user-is-admin--text"
    }, "The user is an ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("b", null, "admin"), ", ALL PRIVILEGES are granted irrespectively of database permissions."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("table", {
        className: "table v-center table-highlight permission-table",
        "data-test": "permission-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
        style: {
            minWidth: '100px',
            whiteSpace: 'nowrap'
        }
    }, "Database"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
        style: {
            width: '99%',
            whiteSpace: 'nowrap'
        }
    }, "Permissions"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tbody", null, (databaseNames || []).map((db)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tr", {
            key: db,
            className: db ? '' : 'all-databases',
            title: db ? db : 'Cluster-Wide Permissions applies to all databases',
            "data-test": `${db ? db : 'all-databases'}-permissions--row`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", null, db || '*'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", null, (db ? dbPermisssions : clusterPermissions).map((perm, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                key: i,
                title: (0, $e10a8602f56394e3$export$d6eefc103e184eaa)[perm]?.description || 'Click to change, click Apply Changes to save all changes',
                "data-db": db,
                "data-perm": perm,
                className: `permission-value ${userDBPermissions[db]?.[perm] ? 'granted' : 'denied'} ${changedPermissions[db]?.[perm] !== undefined ? 'value-changed' : ''}`,
                onClick: onPermissionChange,
                "data-test": `${db}-${perm}-permission--button`
            }, perm))))))))))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039), {
        className: "influxdb-admin"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header, {
        fullWidth: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header.Left, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Title, {
        title: "InfluxDB User"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header.Right, {
        showSourceIndicator: true
    }, dataChanged ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $8008717819fc7a5f$export$2e2bcd8739ae039), {
        text: "Exit",
        confirmText: "Discard unsaved changes?",
        confirmAction: exitHandler,
        position: "left",
        testId: "discard-changes--exit--button"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
        text: "Exit",
        onClick: exitHandler,
        testId: "exit--button"
    }), dataChanged && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
        text: "Apply Changes",
        onClick: changeData,
        color: (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Primary,
        status: running ? (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Disabled : (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Default,
        testId: "apply-changes--button"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "influxdb-admin--contents"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $eaa83b4bf15172b4$export$f4b79619cc47424a), {
        activeTab: "users",
        source: source,
        onTabChange: onTabChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $cca1eaeac66a1201$export$2e2bcd8739ae039), {
        onOK: onExitConfirm,
        onCancel: onExitCancel,
        visible: !!exitUrl
    }), body)));
};
var $ca24f4b144650cd3$export$2e2bcd8739ae039 = (0, $c8cd79e362cba2a4$export$a520fb22fccea800)((0, $dffbdf89c590a961$export$2e2bcd8739ae039)((0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($ca24f4b144650cd3$var$mapStateToProps, $ca24f4b144650cd3$var$mapDispatchToProps)($ca24f4b144650cd3$var$UserPage)));



var $NdCUR = parcelRequire("NdCUR");











const $babc8dc89fd5baaa$var$FAKE_ROLE = {
    name: '',
    permissions: [],
    users: [],
    links: {
        self: ''
    }
};
const $babc8dc89fd5baaa$var$mapStateToProps = ({ adminInfluxDB: { databases: databases, users: users, roles: roles, permissions: permissions } })=>({
        databases: databases,
        users: users,
        roles: roles,
        permissions: permissions
    });
const $babc8dc89fd5baaa$var$mapDispatchToProps = {
    deleteRoleAsync: $e271547bf032bb19$export$7f34cacd73affbe8,
    updateRolePermissionsAsync: $e271547bf032bb19$export$e7a56bd828bee49,
    updateRoleUsersAsync: $e271547bf032bb19$export$1f3f547df2292a42
};
const $babc8dc89fd5baaa$var$RolePage = ({ users: users, databases: databases, permissions: serverPermissions, roles: roles, source: source, router: router, params: { roleName: roleName, sourceID: sourceID }, deleteRoleAsync: deleteAsync, updateRolePermissionsAsync: updatePermissionsAsync, updateRoleUsersAsync: updateUsersAsync })=>{
    if (!(0, $eaa83b4bf15172b4$export$a51709d05d806ee2)(source)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "container-fluid"
    }, "Role management is not available for the currently selected InfluxDB Connection.");
    if ((0, $eaa83b4bf15172b4$export$3295c333c7855cf3)(source)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "container-fluid"
    }, "Users are managed via LDAP, roles management is not available.");
    const [running, setRunning] = (0, $NdCUR.useState)(false);
    const [role, deleteRole] = (0, $NdCUR.useMemo)(()=>{
        const r = roles.find((x)=>x.name === roleName) || $babc8dc89fd5baaa$var$FAKE_ROLE;
        return [
            r,
            async ()=>{
                setRunning(true);
                try {
                    await deleteAsync(r);
                } finally{
                    setRunning(false);
                }
                router.push(`/sources/${sourceID}/admin-influxdb/roles`);
            }
        ];
    }, [
        source,
        roles,
        roleName
    ]);
    // permissions
    const [dbPermisssions, clusterPermissions, roleDBPermissions] = (0, $NdCUR.useMemo)(()=>[
            serverPermissions.find((x)=>x.scope === 'database')?.allowed || [],
            serverPermissions.find((x)=>x.scope === 'all')?.allowed || [],
            (0, $0f8bd252fcb08c00$export$fcaf6b1a07b1ce20)(role, true)
        ], [
        serverPermissions,
        role
    ]);
    const [changedPermissions, setChangedPermissions] = (0, $NdCUR.useState)({});
    (0, $NdCUR.useEffect)(()=>{
        setChangedPermissions({});
    }, [
        role
    ]);
    const onPermissionChange = (0, $NdCUR.useMemo)(()=>(e)=>{
            const db = e.target.dataset.db;
            const perm = e.target.dataset.perm;
            setChangedPermissions((0, $0f8bd252fcb08c00$export$c7009bd8c437c03c)(db, perm, roleDBPermissions, changedPermissions));
        }, [
        roleDBPermissions,
        changedPermissions
    ]);
    const permissionsChanged = !!Object.keys(changedPermissions).length;
    const changePermissions = (0, $NdCUR.useMemo)(()=>async ()=>{
            if (Object.entries(changedPermissions).length === 0) return true;
            setRunning(true);
            try {
                // append to existing all-scoped permissions in OSS, they manage administrator status
                const permissions = (0, $0f8bd252fcb08c00$export$9c67dcab50d05583)(roleDBPermissions, changedPermissions);
                return await updatePermissionsAsync(role, permissions);
            } finally{
                setRunning(false);
            }
        }, [
        role,
        changedPermissions,
        roleDBPermissions
    ]);
    // users
    const [allUserNames, usersRecord] = (0, $NdCUR.useMemo)(()=>{
        const uNames = users.map((r)=>r.name).sort();
        const ruRecord = role.users.reduce((acc, r)=>{
            acc[r.name] = true;
            return acc;
        }, {});
        return [
            uNames,
            ruRecord
        ];
    }, [
        role,
        users
    ]);
    const [changedUsersRecord, setChangedUsersRecord] = (0, $NdCUR.useState)({});
    (0, $NdCUR.useEffect)(()=>setChangedUsersRecord({}), [
        role
    ]);
    const usersChanged = (0, $NdCUR.useMemo)(()=>!!Object.keys(changedUsersRecord).length, [
        changedUsersRecord
    ]);
    const onUserChange = (0, $NdCUR.useMemo)(()=>(e)=>{
            const user = e.target.dataset.user;
            const { [user]: roleChanged, ...restChanged } = changedUsersRecord;
            if (roleChanged === undefined) setChangedUsersRecord({
                ...changedUsersRecord,
                [user]: !usersRecord[user]
            });
            else // returning back to original state
            setChangedUsersRecord(restChanged);
            return;
        }, [
        usersRecord,
        changedUsersRecord
    ]);
    const changeUsers = (0, $NdCUR.useMemo)(()=>async ()=>{
            if (Object.entries(changedUsersRecord).length === 0) return true;
            setRunning(true);
            try {
                const newUsers = users.reduce((acc, user)=>{
                    const userName = user.name;
                    if (changedUsersRecord[userName] === true || changedUsersRecord[userName] === undefined && usersRecord[userName]) acc.push(user);
                    return acc;
                }, []);
                return await updateUsersAsync(role, newUsers);
            } finally{
                setRunning(false);
            }
        }, [
        role,
        usersRecord,
        changedUsersRecord,
        users
    ]);
    const dataChanged = (0, $NdCUR.useMemo)(()=>permissionsChanged || usersChanged, [
        permissionsChanged,
        usersChanged
    ]);
    const exitHandler = (0, $NdCUR.useCallback)(()=>{
        router.push(`/sources/${sourceID}/admin-influxdb/roles`);
    }, [
        router,
        source
    ]);
    const changeData = (0, $NdCUR.useCallback)(async ()=>{
        if (await changeUsers() && await changePermissions()) exitHandler();
    }, [
        changePermissions,
        changeUsers,
        exitHandler
    ]);
    const databaseNames = (0, $NdCUR.useMemo)(()=>databases.reduce((acc, db)=>{
            acc.push(db.name);
            return acc;
        }, [
            ''
        ]), [
        databases
    ]);
    const [exitUrl, setExitUrl] = (0, $NdCUR.useState)('');
    const onTabChange = (0, $NdCUR.useCallback)((_section, url)=>{
        if (dataChanged) {
            setExitUrl(url);
            return;
        }
        router.push(url);
    }, [
        router,
        dataChanged
    ]);
    const onExitCancel = (0, $NdCUR.useCallback)(()=>{
        setExitUrl('');
    }, []);
    const onExitConfirm = (0, $NdCUR.useCallback)(()=>{
        router.push(exitUrl);
    }, [
        router,
        exitUrl
    ]);
    const body = role === $babc8dc89fd5baaa$var$FAKE_ROLE ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "container-fluid"
    }, "Role ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        className: "error-warning"
    }, roleName), " not found!") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel panel-solid influxdb-admin"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel-heading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h2", {
        className: "panel-title"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("span", {
        title: `Role: ${roleName}`
    }, roleName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel-heading--right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $8008717819fc7a5f$export$2e2bcd8739ae039), {
        type: "btn-danger",
        text: "Delete Role",
        confirmAction: deleteRole,
        disabled: running,
        position: "bottom"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "panel-body influxdb-admin--detail"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $fd3a484677319113$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "infludb-admin-section__header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", null, "Users", usersChanged ? ' (unsaved)' : '')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "infludb-admin-section__body"
    }, !allUserNames.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("p", null, "No users are defined.") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "collection-selector"
    }, allUserNames.map((userName, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
            key: i,
            title: "Click to change, click Apply Changes to save all changes",
            "data-user": userName,
            className: `user-value ${usersRecord[userName] ? 'granted' : 'denied'} ${changedUsersRecord[userName] !== undefined ? 'value-changed' : ''}`,
            onClick: onUserChange,
            "data-test": `user-${userName}--selector`
        }, userName)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "infludb-admin-section__header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("h4", null, "Permissions", permissionsChanged ? ' (unsaved)' : '')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "infludb-admin-section__body"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("table", {
        className: "table v-center table-highlight permission-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
        style: {
            minWidth: '100px',
            whiteSpace: 'nowrap'
        }
    }, "Database"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("th", {
        style: {
            width: '99%',
            whiteSpace: 'nowrap'
        }
    }, "Permissions"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tbody", null, (databaseNames || []).map((db)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("tr", {
            key: db,
            className: db ? '' : 'all-databases',
            title: db ? db : 'Cluster-Wide Permissions applies to all databases',
            "data-test": `${db || 'all'}-db-perm--row`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", null, db || '*'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("td", null, (db ? dbPermisssions : clusterPermissions).map((perm, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
                key: i,
                title: (0, $e10a8602f56394e3$export$d6eefc103e184eaa)[perm]?.description || 'Click to change, click Apply Changes to save all changes',
                "data-db": db,
                "data-perm": perm,
                className: `permission-value ${roleDBPermissions[db]?.[perm] ? 'granted' : 'denied'} ${changedPermissions[db]?.[perm] !== undefined ? 'value-changed' : ''}`,
                onClick: onPermissionChange,
                "data-test": `${perm}--value`
            }, perm))))))))))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039), {
        className: "influxdb-admin"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header, {
        fullWidth: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header.Left, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Title, {
        title: "InfluxDB Role"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $dad0aa542284157e$export$2e2bcd8739ae039).Header.Right, {
        showSourceIndicator: true
    }, dataChanged ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $8008717819fc7a5f$export$2e2bcd8739ae039), {
        text: "Exit",
        confirmText: "Discard unsaved changes?",
        confirmAction: exitHandler,
        position: "left",
        testId: "discard-changes--exit--button"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
        text: "Exit",
        onClick: exitHandler,
        testId: "exit--button"
    }), dataChanged && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $7c1c09dc355c9bd4$export$2e2bcd8739ae039), {
        text: "Apply Changes",
        onClick: changeData,
        color: (0, $918c9f03a35fe03f$export$c1cedbc1c46e937d).Primary,
        status: running ? (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Disabled : (0, $918c9f03a35fe03f$export$f58bd244391b65a5).Default,
        testId: "apply-changes--button"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement("div", {
        className: "influxdb-admin--contents"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $eaa83b4bf15172b4$export$f4b79619cc47424a), {
        activeTab: "roles",
        source: source,
        onTabChange: onTabChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $cca1eaeac66a1201$export$2e2bcd8739ae039), {
        onOK: onExitConfirm,
        onCancel: onExitCancel,
        visible: !!exitUrl
    }), body)));
};
var $babc8dc89fd5baaa$export$2e2bcd8739ae039 = (0, $c8cd79e362cba2a4$export$a520fb22fccea800)((0, $dffbdf89c590a961$export$2e2bcd8739ae039)((0, $ad1c01f2a894092c$export$2e2bcd8739ae039)($babc8dc89fd5baaa$var$mapStateToProps, $babc8dc89fd5baaa$var$mapDispatchToProps)($babc8dc89fd5baaa$var$RolePage)));


const $d5e6efda690e8870$var$errorsQueue = [];
const $d5e6efda690e8870$var$rootNode = (0, $c07cd4c29e466bdb$export$9bfe85d84666e58)();
const $d5e6efda690e8870$var$basepath = (0, $d54b25c31b40a794$export$aee2638d36416d07)();
// Older method used for pre-IE 11 compatibility
window.basepath = $d5e6efda690e8870$var$basepath;
const $d5e6efda690e8870$var$browserHistory = (0, $6b4c7860a1964595$export$2e2bcd8739ae039)((0, $5c2c7cce1dcca23a$exports.createHistory))({
    basename: $d5e6efda690e8870$var$basepath
});
const $d5e6efda690e8870$var$store = (0, $2da2fd17d668b688$export$2e2bcd8739ae039)((0, $92ae4c2e27237e7e$export$d3dfa491819f2d3c)($d5e6efda690e8870$var$errorsQueue), $d5e6efda690e8870$var$browserHistory);
const { dispatch: $d5e6efda690e8870$var$dispatch } = $d5e6efda690e8870$var$store;
// pathname of last location change
let $d5e6efda690e8870$var$lastPathname;
$d5e6efda690e8870$var$browserHistory.listen((location)=>{
    // disable presentation mode only if pathname changes, #5382
    if ($d5e6efda690e8870$var$lastPathname !== location.pathname) {
        $d5e6efda690e8870$var$dispatch((0, $cac020f89fc6c82e$export$35e76ce34554c16c)());
        $d5e6efda690e8870$var$lastPathname = location.pathname;
    }
});
window.addEventListener('keyup', (event)=>{
    const escapeKeyCode = 27;
    // fallback for browsers that don't support event.key
    if (event.key === 'Escape' || event.keyCode === escapeKeyCode) $d5e6efda690e8870$var$dispatch((0, $cac020f89fc6c82e$export$35e76ce34554c16c)());
});
const $d5e6efda690e8870$var$history = (0, $14b9f70b6017fdee$exports.syncHistoryWithStore)($d5e6efda690e8870$var$browserHistory, $d5e6efda690e8870$var$store);
const $d5e6efda690e8870$var$populateEnv = async (url)=>{
    try {
        const envVars = await (0, $8724956c7a46b140$export$4bd44a2aa29d3d6e)(url);
        $d5e6efda690e8870$var$dispatch((0, $a965c6d8ca2338eb$export$58a7d2eb42160389)(envVars.hostPageDisabled));
        $d5e6efda690e8870$var$dispatch((0, $a965c6d8ca2338eb$export$2b808e8bc22434d0)(envVars.v3SupportEnabled));
        (0, $7be8d2ddc7f80e0c$export$6b3dc096e22ed40)(envVars.customAutoRefresh);
    } catch (error) {
        console.error('Error fetching envVars', error);
    }
};
class $d5e6efda690e8870$var$RedirectToRoot extends (0, $NdCUR.PureComponent) {
    componentDidMount() {
        $d5e6efda690e8870$var$browserHistory.replace('/');
    }
    render() {
        return null;
    }
}
const $d5e6efda690e8870$var$LogsPageRoute = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $091cfcd49e339acd$export$2e2bcd8739ae039), {
        requiredRole: (0, $a7910b1002260d34$export$1d39a112fd67439d),
        replaceWithIfNotAuthorized: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($d5e6efda690e8870$var$RedirectToRoot, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $05168acb2d31b9e6$export$2e2bcd8739ae039), null));
const $d5e6efda690e8870$var$OnboardingWizardRoute = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $091cfcd49e339acd$export$2e2bcd8739ae039), {
        requiredRole: (0, $a7910b1002260d34$export$f715f7e27dea2abf),
        replaceWithIfNotAuthorized: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($d5e6efda690e8870$var$RedirectToRoot, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b0c12c1b94dfc089$export$2e2bcd8739ae039), null));
class $d5e6efda690e8870$var$Root extends (0, $NdCUR.PureComponent) {
    constructor(props){
        super(props), this.getLinks = (0, $1f80bbeadc1a0021$export$2e2bcd8739ae039)((0, $e443bd9645650029$export$3318957a1a5ea6cf), $d5e6efda690e8870$var$dispatch), this.getMe = (0, $1f80bbeadc1a0021$export$2e2bcd8739ae039)((0, $7af565d99d629ce9$export$2c21f559fb9e5c02), $d5e6efda690e8870$var$dispatch);
        this.state = {
            ready: false
        };
    }
    async UNSAFE_componentWillMount() {
        this.flushErrorsQueue();
        try {
            await this.getLinks();
            await this.checkAuth();
            await $d5e6efda690e8870$var$populateEnv($d5e6efda690e8870$var$store.getState().links.environment);
            this.setState({
                ready: true
            });
        } catch (error) {
            $d5e6efda690e8870$var$dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error));
        }
    }
    componentWillUnmount() {
        clearTimeout(this.heartbeatTimer);
    }
    render() {
        // renaming this to make it easier to reason about
        const hostPageIsEnabled = !$d5e6efda690e8870$var$store.getState().env.hostPageDisabled;
        return this.state.ready ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $2ac88c716bc0c424$export$2e2bcd8739ae039), {
            store: $d5e6efda690e8870$var$store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $b029b3af5fc2e5d5$export$f622d6318304b0fa), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $c73532fc4d2afd05$export$2e2bcd8739ae039), {
            history: $d5e6efda690e8870$var$history
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a8b446a49e6c7459$export$2e2bcd8739ae039), {
            path: "/",
            component: (0, $787b801d874c919a$export$6e030bb0a4caa92a)((0, $c8cd79e362cba2a4$export$2e2bcd8739ae039))
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a8b446a49e6c7459$export$2e2bcd8739ae039), {
            path: "/landing",
            component: (0, $787b801d874c919a$export$6e030bb0a4caa92a)((0, $f7df8000f5455a87$export$2e2bcd8739ae039))
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a8b446a49e6c7459$export$2e2bcd8739ae039), {
            path: "/login",
            component: (0, $787b801d874c919a$export$ae0753c39619b4bc)((0, $985a502d70a1bfe1$export$2e2bcd8739ae039))
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a8b446a49e6c7459$export$2e2bcd8739ae039), {
            path: "/purgatory",
            component: (0, $787b801d874c919a$export$6e030bb0a4caa92a)((0, $9de6e52768b61007$export$2e2bcd8739ae039))
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a8b446a49e6c7459$export$2e2bcd8739ae039), {
            component: (0, $787b801d874c919a$export$6e030bb0a4caa92a)((0, $8678b5e670940e88$export$2e2bcd8739ae039))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a8b446a49e6c7459$export$2e2bcd8739ae039), {
            path: "/logs",
            component: $d5e6efda690e8870$var$LogsPageRoute
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a8b446a49e6c7459$export$2e2bcd8739ae039), {
            path: "/sources/new",
            component: (0, $787b801d874c919a$export$6e030bb0a4caa92a)($d5e6efda690e8870$var$OnboardingWizardRoute)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a8b446a49e6c7459$export$2e2bcd8739ae039), {
            path: "/sources/:sourceID",
            component: (0, $787b801d874c919a$export$6e030bb0a4caa92a)((0, $8678b5e670940e88$export$2e2bcd8739ae039))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a8b446a49e6c7459$export$2e2bcd8739ae039), {
            component: (0, $c8cd79e362cba2a4$export$2e2bcd8739ae039)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a8b446a49e6c7459$export$2e2bcd8739ae039), {
            path: "status",
            component: (0, $cb74a3ac1e224099$export$2e2bcd8739ae039)
        }), hostPageIsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a8b446a49e6c7459$export$2e2bcd8739ae039), {
            path: "hosts",
            component: (0, $e332d644fe278728$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a8b446a49e6c7459$export$2e2bcd8739ae039), {
            path: "hosts/:hostID",
            component: (0, $d7371a9c353b1d15$export$2e2bcd8739ae039)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a8b446a49e6c7459$export$2e2bcd8739ae039), {
            path: "chronograf/data-explorer",
            component: (0, $fec286da15954ea1$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a8b446a49e6c7459$export$2e2bcd8739ae039), {
            path: "dashboards",
            component: (0, $b611c9c333828d80$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a8b446a49e6c7459$export$2e2bcd8739ae039), {
            path: "dashboards/:dashboardID",
            component: (0, $2fd3a058811d2884$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a8b446a49e6c7459$export$2e2bcd8739ae039), {
            path: "alerts",
            component: (0, $3ced1640a46259ef$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a8b446a49e6c7459$export$2e2bcd8739ae039), {
            path: "alert-rules",
            component: (0, $41a1e40c30112c9e$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a8b446a49e6c7459$export$2e2bcd8739ae039), {
            path: "flux-tasks",
            component: (0, $f3641bbcba4f52a8$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a8b446a49e6c7459$export$2e2bcd8739ae039), {
            path: "tickscripts",
            component: (0, $1eda08f448cda2ea$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a8b446a49e6c7459$export$2e2bcd8739ae039), {
            path: "kapacitors/:kid/alert-rules/:ruleID" // ruleID can be "new"
            ,
            component: (0, $c6f08f0d7d8c82a1$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a8b446a49e6c7459$export$2e2bcd8739ae039), {
            path: "alert-rules/:ruleID",
            component: (0, $c6f08f0d7d8c82a1$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a8b446a49e6c7459$export$2e2bcd8739ae039), {
            path: "kapacitors/:kid/tickscripts/:ruleID" // ruleID can be "new"
            ,
            component: (0, $b1697bd15f20ec31$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a8b446a49e6c7459$export$2e2bcd8739ae039), {
            path: "kapacitors/:kid/fluxtasks/:taskID",
            component: (0, $43e4a68a43bdcbc0$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a8b446a49e6c7459$export$2e2bcd8739ae039), {
            path: "kapacitors/new",
            component: (0, $42c0286812dea1ee$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a8b446a49e6c7459$export$2e2bcd8739ae039), {
            path: "kapacitors/:id/edit",
            component: (0, $42c0286812dea1ee$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a8b446a49e6c7459$export$2e2bcd8739ae039), {
            path: "kapacitors/:id/edit:hash",
            component: (0, $42c0286812dea1ee$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a8b446a49e6c7459$export$2e2bcd8739ae039), {
            path: "admin-chronograf/:tab",
            component: (0, $dec327df71eea054$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a8b446a49e6c7459$export$2e2bcd8739ae039), {
            path: "admin-influxdb",
            component: (0, $4b3f9e245d0fb322$export$2e2bcd8739ae039)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a8b446a49e6c7459$export$2e2bcd8739ae039), {
            path: "databases",
            component: (0, $ae004e1621a95da4$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a8b446a49e6c7459$export$2e2bcd8739ae039), {
            path: "users",
            component: (0, $88edc969ddbabdb9$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a8b446a49e6c7459$export$2e2bcd8739ae039), {
            path: "roles",
            component: (0, $1bde67fac5504550$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a8b446a49e6c7459$export$2e2bcd8739ae039), {
            path: "queries",
            component: (0, $3c9a79623b836c2f$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a8b446a49e6c7459$export$2e2bcd8739ae039), {
            path: "users/:userName",
            component: (0, $ca24f4b144650cd3$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a8b446a49e6c7459$export$2e2bcd8739ae039), {
            path: "roles/:roleName",
            component: (0, $babc8dc89fd5baaa$export$2e2bcd8739ae039)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a8b446a49e6c7459$export$2e2bcd8739ae039), {
            path: "manage-sources",
            component: (0, $7d93b65e95a1bc86$export$2e2bcd8739ae039)
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $a8b446a49e6c7459$export$2e2bcd8739ae039), {
            path: "*",
            component: (0, $080fd076463801b6$export$2e2bcd8739ae039)
        })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement((0, $810ad5a94daa03b8$export$2e2bcd8739ae039), null);
    }
    async performHeartbeat({ shouldResetMe: shouldResetMe = false } = {}) {
        await this.getMe({
            shouldResetMe: shouldResetMe
        });
        this.heartbeatTimer = window.setTimeout(()=>{
            if ($d5e6efda690e8870$var$store.getState().auth.me !== null) this.performHeartbeat();
        }, (0, $e10a8602f56394e3$export$31c453b5fe09788d));
    }
    flushErrorsQueue() {
        if ($d5e6efda690e8870$var$errorsQueue.length) $d5e6efda690e8870$var$errorsQueue.forEach((error)=>{
            if (typeof error === 'object') $d5e6efda690e8870$var$dispatch((0, $205d139de2918454$export$5e14cdade93d6f7b)(error));
            else $d5e6efda690e8870$var$dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)({
                status: 0,
                auth: null
            }, error, $85bc4a9940703419$export$5b4a8869eb24d061.Warning));
        });
    }
    async checkAuth() {
        try {
            await this.performHeartbeat({
                shouldResetMe: true
            });
        } catch (error) {
            $d5e6efda690e8870$var$dispatch((0, $eb59f3357c899aaf$export$1550334dc0519d45)(error));
        }
    }
}
if ($d5e6efda690e8870$var$rootNode) (0, $g2wso.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($NdCUR))).createElement($d5e6efda690e8870$var$Root, null), $d5e6efda690e8870$var$rootNode);


//# sourceMappingURL=ui.9c8ec060.js.map
